/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 5149:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'spinner-third';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f3f4';
var svgPathData = ['M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z', 'M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z'];

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.sq = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6150:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fal';
var iconName = 'arrow-right';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f061';
var svgPathData = 'M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.dm = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 9720:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
module.exports = exports.default;

/***/ }),

/***/ 9784:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toInteger;
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = exports.default;

/***/ }),

/***/ 212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

(function (global, factory) {
   true ? factory(__webpack_require__(189)) :
  0;
}(this, (function (FE) { 'use strict';

  FE = FE && FE.hasOwnProperty('default') ? FE['default'] : FE;

  /**
   * French
   */
  FE.LANGUAGE['fr'] = {
    translation: {
      // Place holder
      'Type something': 'Tapez quelque chose',
      // Basic formatting
      'Bold': 'Gras',
      'Italic': 'Italique',
      'Underline': "Soulign\xE9",
      'Strikethrough': "Barr\xE9",
      // Main buttons
      'Insert': "Ins\xE9rer",
      'Delete': 'Supprimer',
      'Cancel': 'Annuler',
      'OK': 'Ok',
      'Back': 'Retour',
      'Remove': 'Supprimer',
      'More': 'Plus',
      'Update': 'Actualiser',
      'Style': 'Style',
      // Font
      'Font Family': "Polices de caract\xE8res",
      'Font Size': 'Taille de police',
      'Text Color': 'Couleur du texte',
      'Background Color': 'Couleur d\'arri\xE8re plan',
      'Line Height': 'Hauteur de la ligne',
      // Colors
      'Colors': 'Couleurs',
      'Background': "Arri\xE8re-plan",
      'Text': 'Texte',
      'HEX Color': "Couleur hexad\xE9cimale",
      // Paragraphs
      'Paragraph Format': 'Format de paragraphe',
      'Normal': 'Normal',
      'Code': 'Code',
      'Heading 1': 'Titre 1',
      'Heading 2': 'Titre 2',
      'Heading 3': 'Titre 3',
      'Heading 4': 'Titre 4',
      'Single': 'Célibataire',
      // Style
      'Paragraph Style': 'Style de paragraphe',
      'Inline Style': 'Style en ligne',
      'Gray': 'Grise',
      'Bordered': 'Bordé',
      'Spaced': 'Espacé',
      'Uppercase': 'Majuscule',
      // Alignment
      'Align': 'Aligner',
      'Align Left': "Aligner \xE0 gauche",
      'Align Center': 'Aligner au centre',
      'Align Right': "Aligner \xE0 droite",
      'Align Justify': 'Justifier',
      'None': 'Aucun',
      // Download PDF
      'Download PDF': 'Télécharger le PDF',
      // Inline Class
      'Inline Class': 'Classe en ligne',
      // Lists
      'Ordered List': "Liste ordonn\xE9e",
      'Unordered List': "Liste non ordonn\xE9e",
      'Default': 'D\xE9faut',
      'Circle': 'Cercle',
      'Disc': 'Rond',
      'Square': 'Carr\xE9',
      'Lower Alpha': 'Alpha inf\xE9rieur',
      'Lower Greek': 'Grec inf\xE9rieur',
      'Lower Roman': 'Romain inf\xE9rieur',
      'Upper Alpha': 'Alpha sup\xE9rieur',
      'Upper Roman': 'Romain sup\xE9rieur',
      // Indent
      'Decrease Indent': 'Diminuer le retrait',
      'Increase Indent': 'Augmenter le retrait',
      // Links
      'Insert Link': "Ins\xE9rer un lien",
      'Open in new tab': 'Ouvrir dans un nouvel onglet',
      'Open Link': 'Ouvrir le lien',
      'Edit Link': 'Modifier le lien',
      'Unlink': 'Enlever le lien',
      'Choose Link': 'Choisir le lien',
      // Images
      'Insert Image': "Ins\xE9rer une image",
      'Upload Image': "T\xE9l\xE9verser une image",
      'By URL': 'Par URL',
      'Browse': 'Parcourir',
      'Drop image': 'Cliquer pour parcourir',
      'or click': 'ou glisser/d\xE9poser en plein \xE9cran',
      'Manage Images': "G\xE9rer les images",
      'Loading': 'Chargement',
      'Deleting': 'Suppression',
      'Tags': "\xC9tiquettes",
      'Are you sure? Image will be deleted.': "Etes-vous certain? L'image sera supprim\xE9e.",
      'Replace': 'Remplacer',
      'Uploading': 'Envoi en cours',
      'Loading image': 'Chargement d\'image en cours',
      'Display': 'Afficher',
      'Inline': 'En ligne',
      'Break Text': 'Rompre le texte',
      'Alternative Text': 'Texte alternatif',
      'Change Size': 'Changer la dimension',
      'Width': 'Largeur',
      'Height': 'Hauteur',
      'Something went wrong. Please try again.': "Quelque chose a mal tourn\xE9. Veuillez r\xE9essayer.",
      'Image Caption': "L\xE9gende de l'image",
      'Advanced Edit': "\xC9dition avanc\xE9e",
      // Video
      'Insert Video': "Ins\xE9rer une vid\xE9o",
      'Embedded Code': "Code int\xE9gr\xE9",
      'Paste in a video URL': "Coller l'URL d'une vid\xE9o",
      'Drop video': 'Cliquer pour parcourir',
      'Your browser does not support HTML5 video.': "Votre navigateur ne supporte pas les vid\xE9os au format HTML5.",
      'Upload Video': "T\xE9l\xE9verser une vid\xE9o",
      // Tables
      'Insert Table': "Ins\xE9rer un tableau",
      'Table Header': "Ent\xEAte de tableau",
      'Remove Table': 'Supprimer le tableau',
      'Table Style': 'Style de tableau',
      'Horizontal Align': 'Alignement horizontal',
      'Row': 'Ligne',
      'Insert row above': "Ins\xE9rer une ligne au-dessus",
      'Insert row below': "Ins\xE9rer une ligne en-dessous",
      'Delete row': 'Supprimer la ligne',
      'Column': 'Colonne',
      'Insert column before': "Ins\xE9rer une colonne avant",
      'Insert column after': "Ins\xE9rer une colonne apr\xE8s",
      'Delete column': 'Supprimer la colonne',
      'Cell': 'Cellule',
      'Merge cells': 'Fusionner les cellules',
      'Horizontal split': 'Diviser horizontalement',
      'Vertical split': 'Diviser verticalement',
      'Cell Background': "Arri\xE8re-plan de la cellule",
      'Vertical Align': 'Alignement vertical',
      'Top': 'En haut',
      'Middle': 'Au centre',
      'Bottom': 'En bas',
      'Align Top': 'Aligner en haut',
      'Align Middle': 'Aligner au centre',
      'Align Bottom': 'Aligner en bas',
      'Cell Style': 'Style de cellule',
      'Dashed Borders': 'Bordures pointillées',
      'Alternate Rows': 'Lignes alternatives',
      'Highlighted': 'Souligné',
      'Thick': 'Épais',
      // Files
      'Upload File': "T\xE9l\xE9verser un fichier",
      'Drop file': 'Cliquer pour parcourir',
      // Emoticons
      'Emoticons': "\xC9motic\xF4nes",
      'Grinning face': 'Souriant visage',
      'Grinning face with smiling eyes': 'Souriant visage aux yeux souriants',
      'Face with tears of joy': "Visage \xE0 des larmes de joie",
      'Smiling face with open mouth': 'Visage souriant avec la bouche ouverte',
      'Smiling face with open mouth and smiling eyes': 'Visage souriant avec la bouche ouverte et les yeux en souriant',
      'Smiling face with open mouth and cold sweat': 'Visage souriant avec la bouche ouverte et la sueur froide',
      'Smiling face with open mouth and tightly-closed eyes': "Visage souriant avec la bouche ouverte et les yeux herm\xE9tiquement clos",
      'Smiling face with halo': 'Sourire visage avec halo',
      'Smiling face with horns': 'Visage souriant avec des cornes',
      'Winking face': 'Clin d\'oeil visage',
      'Smiling face with smiling eyes': 'Sourire visage aux yeux souriants',
      'Face savoring delicious food': "Visage savourant de d\xE9licieux plats",
      'Relieved face': "Soulag\xE9 visage",
      'Smiling face with heart-shaped eyes': 'Visage souriant avec des yeux en forme de coeur',
      'Smiling face with sunglasses': 'Sourire visage avec des lunettes de soleil',
      'Smirking face': 'Souriant visage',
      'Neutral face': 'Visage neutre',
      'Expressionless face': 'Visage sans expression',
      'Unamused face': "Visage pas amus\xE9",
      'Face with cold sweat': "Face \xE0 la sueur froide",
      'Pensive face': 'pensif visage',
      'Confused face': 'Visage confus',
      'Confounded face': 'visage maudit',
      'Kissing face': 'Embrasser le visage',
      'Face throwing a kiss': 'Visage jetant un baiser',
      'Kissing face with smiling eyes': 'Embrasser le visage avec les yeux souriants',
      'Kissing face with closed eyes': "Embrasser le visage avec les yeux ferm\xE9s",
      'Face with stuck out tongue': 'Visage avec sortait de la langue',
      'Face with stuck out tongue and winking eye': 'Visage avec sortait de la langue et des yeux clignotante',
      'Face with stuck out tongue and tightly-closed eyes': "Visage avec sortait de la langue et les yeux ferm\xE9s herm\xE9tiquement",
      'Disappointed face': "Visage d\xE9\xE7u",
      'Worried face': 'Visage inquiet',
      'Angry face': "Visage en col\xE9re",
      'Pouting face': 'Faire la moue face',
      'Crying face': 'Pleurer visage',
      'Persevering face': "Pers\xE9v\xE9rer face",
      'Face with look of triumph': 'Visage avec le regard de triomphe',
      'Disappointed but relieved face': "D\xE9\xE7u, mais le visage soulag\xE9",
      'Frowning face with open mouth': "Les sourcils fronc\xE9s visage avec la bouche ouverte",
      'Anguished face': "Visage angoiss\xE9",
      'Fearful face': 'Craignant visage',
      'Weary face': 'Visage las',
      'Sleepy face': 'Visage endormi',
      'Tired face': "Visage fatigu\xE9",
      'Grimacing face': "Visage grima\xE7ante",
      'Loudly crying face': 'Pleurer bruyamment visage',
      'Face with open mouth': "Visage \xE0 la bouche ouverte",
      'Hushed face': "Visage feutr\xE9e",
      'Face with open mouth and cold sweat': "Visage \xE0 la bouche ouverte et la sueur froide",
      'Face screaming in fear': 'Visage hurlant de peur',
      'Astonished face': "Visage \xE9tonn\xE9",
      'Flushed face': "Visage congestionn\xE9",
      'Sleeping face': 'Visage au bois dormant',
      'Dizzy face': 'Visage vertige',
      'Face without mouth': 'Visage sans bouche',
      'Face with medical mask': "Visage avec un masque m\xE9dical",
      // Line breaker
      'Break': 'Rompre',
      // Math
      'Subscript': 'Indice',
      'Superscript': 'Exposant',
      // Full screen
      'Fullscreen': "Plein \xE9cran",
      // Horizontal line
      'Insert Horizontal Line': "Ins\xE9rer une ligne horizontale",
      // Clear formatting
      'Clear Formatting': 'Effacer le formatage',
      // Save
      'Save': 'Sauvegarder',
      // Undo, redo
      'Undo': 'Annuler',
      'Redo': "R\xE9tablir",
      // Select all
      'Select All': "Tout s\xE9lectionner",
      // Code view
      'Code View': 'Mode HTML',
      // Quote
      'Quote': 'Citation',
      'Increase': 'Augmenter',
      'Decrease': 'Diminuer',
      // Quick Insert
      'Quick Insert': 'Insertion rapide',
      // Spcial Characters
      'Special Characters': "Caract\xE8res sp\xE9ciaux",
      'Latin': 'Latin',
      'Greek': 'Grec',
      'Cyrillic': 'Cyrillique',
      'Punctuation': 'Ponctuation',
      'Currency': 'Devise',
      'Arrows': "Fl\xE8ches",
      'Math': 'Math',
      'Misc': 'Divers',
      // Print.
      'Print': 'Imprimer',
      // Spell Checker.
      'Spell Checker': 'Correcteur orthographique',
      // Help
      'Help': 'Aide',
      'Shortcuts': 'Raccourcis',
      'Inline Editor': "\xC9diteur en ligne",
      'Show the editor': "Montrer l'\xE9diteur",
      'Common actions': 'Actions communes',
      'Copy': 'Copier',
      'Cut': 'Couper',
      'Paste': 'Coller',
      'Basic Formatting': 'Formatage de base',
      'Increase quote level': 'Augmenter le niveau de citation',
      'Decrease quote level': 'Diminuer le niveau de citation',
      'Image / Video': "Image / vid\xE9o",
      'Resize larger': 'Redimensionner plus grand',
      'Resize smaller': 'Redimensionner plus petit',
      'Table': 'Table',
      'Select table cell': "S\xE9lectionner la cellule du tableau",
      'Extend selection one cell': "\xC9tendre la s\xE9lection d'une cellule",
      'Extend selection one row': "\xC9tendre la s\xE9lection d'une ligne",
      'Navigation': 'Navigation',
      'Focus popup / toolbar': 'Focus popup / toolbar',
      'Return focus to previous position': "Retourner l'accent sur le poste pr\xE9c\xE9dent",
      // Embed.ly
      'Embed URL': "URL int\xE9gr\xE9e",
      'Paste in a URL to embed': "Coller une URL int\xE9gr\xE9e",
      // Word Paste.
      'The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?': "Le contenu coll\xE9 provient d'un document Microsoft Word. Voulez-vous conserver le format ou le nettoyer?",
      'Keep': 'Conserver',
      'Clean': 'Nettoyer',
      'Word Paste Detected': "Copiage de mots d\xE9tect\xE9",
      // Character Counter 
      'Characters': 'Caract\xE8res',
      // More Buttons
      'More Text': 'Autres options de texte',
      'More Paragraph': 'Autres options de paragraphe',
      'More Rich': 'Autres options d\'enrichissement',
      'More Misc': 'Autres fonctionnalit\xE9s diverses'
    },
    direction: 'ltr'
  };

})));
//# sourceMappingURL=fr.js.map


/***/ }),

/***/ 4458:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(e,t){ true?t(__webpack_require__(189)):0}(this,function(St){"use strict";function r(e,t){(null==t||t>e.length)&&(t=e.length);for(var a=0,n=Array(t);a<t;a++)n[a]=e[a];return n}function He(e,t){var a="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!a){if(Array.isArray(e)||(a=l(e))||t&&e&&"number"==typeof e.length){a&&(e=a);var n=0,r=function(){};return{s:r,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:r}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,o=!0,s=!1;return{s:function(){a=a.call(e)},n:function(){var e=a.next();return o=e.done,e},e:function(e){s=!0,i=e},f:function(){try{o||null==a["return"]||a["return"]()}finally{if(s)throw i}}}}function ye(e){return function t(e){if(Array.isArray(e))return r(e)}(e)||function a(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||l(e)||function n(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Rt(e){return(Rt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function l(e,t){if(e){if("string"==typeof e)return r(e,t);var a={}.toString.call(e).slice(8,-1);return"Object"===a&&e.constructor&&(a=e.constructor.name),"Map"===a||"Set"===a?Array.from(e):"Arguments"===a||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)?r(e,t):void 0}}if((St=St&&St.hasOwnProperty("default")?St["default"]:St).PLUGINS.align=function(r){var i=r.$;return{apply:function o(e){var t=r.selection.element();if(i(t).parents(".fr-img-caption").length)i(t).css("text-align",e);else{r.selection.save(),r.html.wrap(!0,!0,!0,!0),r.selection.restore();for(var a=r.selection.blocks(),n=0;n<a.length;n++)i(a[n]).css("text-align",e).removeClass("fr-temp-div"),""===i(a[n]).attr("class")&&i(a[n]).removeAttr("class"),""===i(a[n]).attr("style")&&i(a[n]).removeAttr("style");r.selection.save(),r.html.unwrap(),r.selection.restore()}},refresh:function n(e){var t=r.selection.blocks();if(t.length){var a=r.helpers.getAlignment(i(t[0]));e.find("> *").first().replaceWith(r.icon.create("align-".concat(a)))}},refreshOnShow:function s(e,t){var a=r.selection.blocks();if(a.length){var n=r.helpers.getAlignment(i(a[0]));t.find('a.fr-command[data-param1="'.concat(n,'"]')).addClass("fr-active").attr("aria-selected",!0)}},refreshForToolbar:function l(e){var t=r.selection.blocks();if(t.length){var a=r.helpers.getAlignment(i(t[0]));a=a.charAt(0).toUpperCase()+a.slice(1),"align".concat(a)===e.attr("data-cmd")&&e.addClass("fr-active")}}}},St.DefineIcon("align",{NAME:"align-left",SVG_KEY:"alignLeft"}),St.DefineIcon("align-left",{NAME:"align-left",SVG_KEY:"alignLeft"}),St.DefineIcon("align-right",{NAME:"align-right",SVG_KEY:"alignRight"}),St.DefineIcon("align-center",{NAME:"align-center",SVG_KEY:"alignCenter"}),St.DefineIcon("align-justify",{NAME:"align-justify",SVG_KEY:"alignJustify"}),St.RegisterCommand("align",{type:"dropdown",title:"Align",options:{left:"Align Left",center:"Align Center",right:"Align Right",justify:"Align Justify"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=St.COMMANDS.align.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="align"data-param1="\n        '.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.icon.create("align-".concat(a)),'<span class="fr-sr-only">\n        ').concat(this.language.translate(t[a]),"</span></a></li>"));return e+="</ul>"},callback:function(e,t){this.align.apply(t)},refresh:function(e){this.align.refresh(e)},refreshOnShow:function(e,t){this.align.refreshOnShow(e,t)},plugin:"align"}),St.RegisterCommand("alignLeft",{type:"button",icon:"align-left",title:"Align Left",callback:function(){this.align.apply("left")},refresh:function(e){this.align.refreshForToolbar(e)},plugin:"align"}),St.RegisterCommand("alignRight",{type:"button",icon:"align-right",title:"Align Right",callback:function(){this.align.apply("right")},refresh:function(e){this.align.refreshForToolbar(e)},plugin:"align"}),St.RegisterCommand("alignCenter",{type:"button",icon:"align-center",title:"Align Center",callback:function(){this.align.apply("center")},refresh:function(e){this.align.refreshForToolbar(e)},plugin:"align"}),St.RegisterCommand("alignJustify",{type:"button",icon:"align-justify",title:"Align Justify",callback:function(){this.align.apply("justify")},refresh:function(e){this.align.refreshForToolbar(e)},plugin:"align"}),Object.assign(St.DEFAULTS,{charCounterMax:-1,charCounterCount:!0}),St.PLUGINS.charCounter=function(n){var a,r=n.$,i=function i(){return(n.opts.iframe&&n.markdown&&n.markdown.isEnabled()?n.$el.text()||"":n.el.textContent||"").replace(/\u200B/g,"").length};function e(e){if(n.opts.charCounterMax<0)return!0;if(i()<n.opts.charCounterMax)return!0;var t=e.which;return!(!n.keys.ctrlKey(e)&&n.keys.isCharacter(t)||t===St.KEYCODE.IME)||(e.preventDefault(),e.stopPropagation(),n.events.trigger("charCounter.exceeded"),!1)}function t(e){return n.opts.charCounterMax<0?e:r("<div>").html(e).text().length+i()<=n.opts.charCounterMax?e:(n.events.trigger("charCounter.exceeded"),"")}function o(e,t,a){return n.opts.charCounterMax<0||(e.includes('<span class="fr-emoticon')||e.includes('<i class="fa ')?!(i()>=n.opts.charCounterMax)||(n.events.trigger("charCounter.exceeded"),!1):r("<div>").html(e).text().length+i()<=n.opts.charCounterMax||(n.events.trigger("charCounter.exceeded"),!1))}function s(){if(n.opts.charCounterCount){var e=i()+(0<n.opts.charCounterMax?"/"+n.opts.charCounterMax:"");a.text("".concat(n.language.translate("Characters")," : ").concat(e)),n.opts.toolbarBottom&&a.css("margin-bottom",n.$tb.outerHeight(!0));var t=n.$wp.get(0).offsetWidth-n.$wp.get(0).clientWidth;0<=t&&("rtl"==n.opts.direction?a.css("margin-left",t):a.css("margin-right",t))}}return{_init:function l(){return!!n.$wp&&!!n.opts.charCounterCount&&((a=r(document.createElement("span")).attr("class","fr-counter")).css("bottom",n.$wp.css("border-bottom-width")),n.$second_tb?n.$second_tb.append(a):n.$wp.append(a),n.events.on("keydown",e,!0),n.events.on("paste.afterCleanup",t),n.events.on("keyup contentChanged input",function(){n.events.trigger("charCounter.update")}),n.events.on("html.beforeInsert",o),n.events.on("charCounter.update",s),n.events.trigger("charCounter.update"),void n.events.on("destroy",function(){r(n.o_win).off("resize.char".concat(n.id)),a.removeData().remove(),a=null}))},count:i}},St.PLUGINS.codeBeautifier=function(){var e,t,a,n,j={};function L(n,e){var t={"@page":!0,"@font-face":!0,"@keyframes":!0,"@media":!0,"@supports":!0,"@document":!0},a={"@media":!0,"@supports":!0,"@document":!0};e=e||{},n=(n=n||"").replace(/\r\n|[\r\u2028\u2029]/g,"\n");var r=e.indent_size||4,i=e.indent_char||" ",o=e.selector_separator_newline===undefined||e.selector_separator_newline,s=e.end_with_newline!==undefined&&e.end_with_newline,l=e.newline_between_rules===undefined||e.newline_between_rules,c=e.eol?e.eol:"\n";"string"==typeof r&&(r=parseInt(r,10)),e.indent_with_tabs&&(i="\t",r=1),c=c.replace(/\\r/,"\r").replace(/\\n/,"\n");var d,f=/^\s+$/,p=-1,u=0;function g(){return(d=n.charAt(++p))||""}function h(e){var t,a=p;return e&&v(),t=n.charAt(p+1)||"",p=a-1,g(),t}function m(e){for(var t=p;g();)if("\\"===d)g();else{if(-1!==e.indexOf(d))break;if("\n"===d)break}return n.substring(t,p+1)}function v(){for(var e="";f.test(h());)g(),e+=d;return e}function b(){var e="";for(d&&f.test(d)&&(e=d);f.test(g());)e+=d;return e}function E(e){var t=p;for(e="/"===h(),g();g();){if(!e&&"*"===d&&"/"===h()){g();break}if(e&&"\n"===d)return n.substring(t,p)}return n.substring(t,p)+d}function _(e){return n.substring(p-e.length,p).toLowerCase()===e}function w(){for(var e=0,t=p+1;t<n.length;t++){var a=n.charAt(t);if("{"===a)return!0;if("("===a)e+=1;else if(")"===a){if(0===e)return!1;e-=1}else if(" "===a||"}"===a)return!1}return!1}var y=n.match(/^[\t ]*/)[0],A=new Array(r+1).join(i),C=0,T=0;for(var k,S,R,L={"{":function(e){L.singleSpace(),x.push(e),L.newLine()},"}":function(e){L.newLine(),x.push(e),L.newLine()},_lastCharWhitespace:function(){return f.test(x[x.length-1])},newLine:function(e){x.length&&(e||"\n"===x[x.length-1]||L.trim(),x.push("\n"),y&&x.push(y))},singleSpace:function(){x.length&&!L._lastCharWhitespace()&&x.push(" ")},preserveSingleSpace:function(){k&&L.singleSpace()},trim:function(){for(;L._lastCharWhitespace();)x.pop()}},x=[],I=!1,O=!1,F=!1,M="",N="";;){var D=b();k=""!==D;var P=-1!==D.indexOf("\n");if(N=M,!(M=d))break;if("/"===d&&"*"===h()){var B=0===C;(P||B)&&L.newLine(),x.push(E()),L.newLine(),B&&L.newLine(!0)}else if("/"===d&&"/"===h())P||"{"===N||L.trim(),L.singleSpace(),x.push(E()),L.newLine();else if("@"===d){L.preserveSingleSpace(),x.push(d);var U=(void 0,S=p,R=m(": , {}()[]/='\""),p=S-1,g(),R);U.match(/[ :]$/)&&(g(),U=m(": ").replace(/\s$/,""),x.push(U),L.singleSpace()),(U=U.replace(/\s$/,""))in t&&(T+=1,U in a&&(F=!0))}else"#"===d&&"{"===h()?(L.preserveSingleSpace(),x.push(m("}"))):"{"===d?"}"===h(!0)?(v(),g(),L.singleSpace(),x.push("{}"),L.newLine(),l&&0===C&&L.newLine(!0)):(C++,y+=A,L["{"](d),I=F?(F=!1,T<C):T<=C):"}"===d?(C--,y=y.slice(0,-r),L["}"](d),O=I=!1,T&&T--,l&&0===C&&L.newLine(!0)):":"===d?(v(),!I&&!F||_("&")||w()?":"===h()?(g(),x.push("::")):x.push(":"):(O=!0,x.push(":"),L.singleSpace())):'"'===d||"'"===d?(L.preserveSingleSpace(),x.push(m(d))):" "===d?(O=!1,x.push(d),L.newLine()):"("===d?_("url")?(x.push(d),v(),g()&&(")"!==d&&'"'!==d&&"'"!==d?x.push(m(")")):p--)):(u++,L.preserveSingleSpace(),x.push(d),v()):")"===d?(x.push(d),u--):","===d?(x.push(d),v(),o&&!O&&u<1?L.newLine():L.singleSpace()):("]"===d||("["===d?L.preserveSingleSpace():"="===d?(v(),d="="):L.preserveSingleSpace()),x.push(d))}var H="";return y&&(H+=y),H+=x.join("").replace(/[\r\n\t ]+$/,""),s&&(H+="\n"),"\n"!=c&&(H=H.replace(/[\n]/g,c)),H}function q(e,t){for(var a=0;a<t.length;a+=1)if(t[a]===e)return!0;return!1}function X(e){return e.replace(/^\s+|\s+$/g,"")}function x(e,t){return new r(e,t).beautify()}e=j,t="\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc",a=new RegExp("[".concat(t,"]")),n=new RegExp("[".concat(t," ").concat("\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u0620-\u0649\u0672-\u06d3\u06e7-\u06e8\u06fb-\u06fc\u0730-\u074a\u0800-\u0814\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0840-\u0857\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962-\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09d7\u09df-\u09e0\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2-\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5f-\u0b60\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62-\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2-\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d46-\u0d48\u0d57\u0d62-\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e34-\u0e3a\u0e40-\u0e45\u0e50-\u0e59\u0eb4-\u0eb9\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f41-\u0f47\u0f71-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1029\u1040-\u1049\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u170e-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17b2\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1920-\u192b\u1930-\u193b\u1951-\u196d\u19b0-\u19c0\u19c8-\u19c9\u19d0-\u19d9\u1a00-\u1a15\u1a20-\u1a53\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b46-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1bb0-\u1bb9\u1be6-\u1bf3\u1c00-\u1c22\u1c40-\u1c49\u1c5b-\u1c7d\u1cd0-\u1cd2\u1d00-\u1dbe\u1e01-\u1f15\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2d81-\u2d96\u2de0-\u2dff\u3021-\u3028\u3099\u309a\ua640-\ua66d\ua674-\ua67d\ua69f\ua6f0-\ua6f1\ua7f8-\ua800\ua806\ua80b\ua823-\ua827\ua880-\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8f3-\ua8f7\ua900-\ua909\ua926-\ua92d\ua930-\ua945\ua980-\ua983\ua9b3-\ua9c0\uaa00-\uaa27\uaa40-\uaa41\uaa4c-\uaa4d\uaa50-\uaa59\uaa7b\uaae0-\uaae9\uaaf2-\uaaf3\uabc0-\uabe1\uabec\uabed\uabf0-\uabf9\ufb20-\ufb28\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f","]")),e.newline=/[\n\r\u2028\u2029]/,e.lineBreak=new RegExp("\r\n|".concat(e.newline.source)),e.allLineBreaks=new RegExp(e.lineBreak.source,"g"),e.isIdentifierStart=function(e){return e<65?36===e||64===e:e<91||(e<97?95===e:e<123||170<=e&&a.test(String.fromCharCode(e)))},e.isIdentifierChar=function(e){return e<48?36===e:e<58||!(e<65)&&(e<91||(e<97?95===e:e<123||170<=e&&n.test(String.fromCharCode(e))))};var Z={BlockStatement:"BlockStatement",Statement:"Statement",ObjectLiteral:"ObjectLiteral",ArrayLiteral:"ArrayLiteral",ForInitializer:"ForInitializer",Conditional:"Conditional",Expression:"Expression"};function r(n,e){var c,r,i,d,o,s,l,f,p,t,a,u,g,h=[],m="";function v(e,t){var a=0;return e&&(a=e.indentation_level,!c.just_added_newline()&&e.line_indent_level>a&&(a=e.line_indent_level)),{mode:t,parent:e,last_text:e?e.last_text:"",last_word:e?e.last_word:"",declaration_statement:!1,declaration_assignment:!1,multiline_frame:!1,if_block:!1,else_block:!1,do_block:!1,do_while:!1,in_case_statement:!1,in_case:!1,case_body:!1,indentation_level:a,line_indent_level:e?e.line_indent_level:a,start_line_index:c.get_line_number(),ternary_depth:0}}for(u={TK_START_EXPR:function M(){x();var e=Z.Expression;if("["===d.text){if("TK_WORD"===o||")"===f.last_text)return"TK_RESERVED"===o&&q(f.last_text,i.line_starters)&&(c.space_before_token=!0),T(e),A(),C(),void(g.space_in_paren&&(c.space_before_token=!0));e=Z.ArrayLiteral,k(f.mode)&&("["!==f.last_text&&(","!==f.last_text||"]"!==s&&"}"!==s)||g.keep_array_indentation||w())}else"TK_RESERVED"===o&&"for"===f.last_text?e=Z.ForInitializer:"TK_RESERVED"===o&&q(f.last_text,["if","while"])&&(e=Z.Conditional);" "===f.last_text||"TK_START_BLOCK"===o?w():"TK_END_EXPR"===o||"TK_START_EXPR"===o||"TK_END_BLOCK"===o||"."===f.last_text?_(d.wanted_newline):"TK_RESERVED"===o&&"("===d.text||"TK_WORD"===o||"TK_OPERATOR"===o?"TK_RESERVED"===o&&("function"===f.last_word||"typeof"===f.last_word)||"*"===f.last_text&&"function"===s?g.space_after_anon_function&&(c.space_before_token=!0):"TK_RESERVED"!==o||!q(f.last_text,i.line_starters)&&"catch"!==f.last_text||g.space_before_conditional&&(c.space_before_token=!0):c.space_before_token=!0;"("===d.text&&"TK_RESERVED"===o&&"await"===f.last_word&&(c.space_before_token=!0);"("===d.text&&("TK_EQUALS"!==o&&"TK_OPERATOR"!==o||L()||_());T(e),A(),g.space_in_paren&&(c.space_before_token=!0);C()},TK_END_EXPR:function N(){for(;f.mode===Z.Statement;)R();f.multiline_frame&&_("]"===d.text&&k(f.mode)&&!g.keep_array_indentation);g.space_in_paren&&("TK_START_EXPR"!==o||g.space_in_empty_paren?c.space_before_token=!0:(c.trim(),c.space_before_token=!1));"]"===d.text&&g.keep_array_indentation?(A(),R()):(R(),A());c.remove_redundant_indentation(p),f.do_while&&p.mode===Z.Conditional&&(p.mode=Z.Expression,f.do_block=!1,f.do_while=!1)},TK_START_BLOCK:function D(){var e=O(1),t=O(2);t&&(":"===t.text&&q(e.type,["TK_STRING","TK_WORD","TK_RESERVED"])||q(e.text,["get","set"])&&q(t.type,["TK_WORD","TK_RESERVED"]))?q(s,["class","interface"])?T(Z.BlockStatement):T(Z.ObjectLiteral):T(Z.BlockStatement);var a=!e.comments_before.length&&"}"===e.text&&"function"===f.last_word&&"TK_END_EXPR"===o;"expand"===g.brace_style||"none"===g.brace_style&&d.wanted_newline?"TK_OPERATOR"!==o&&(a||"TK_EQUALS"===o||"TK_RESERVED"===o&&I(f.last_text)&&"else"!==f.last_text)?c.space_before_token=!0:w(!1,!0):"TK_OPERATOR"!==o&&"TK_START_EXPR"!==o?"TK_START_BLOCK"===o?w():c.space_before_token=!0:k(p.mode)&&","===f.last_text&&("}"===s?c.space_before_token=!0:w());A(),C()},TK_END_BLOCK:function P(){for(;f.mode===Z.Statement;)R();var e="TK_START_BLOCK"===o;"expand"===g.brace_style?e||w():e||(k(f.mode)&&g.keep_array_indentation?(g.keep_array_indentation=!1,w(),g.keep_array_indentation=!0):w());R(),A()},TK_WORD:F,TK_RESERVED:F,TK_SEMICOLON:function B(){x()&&(c.space_before_token=!1);for(;f.mode===Z.Statement&&!f.if_block&&!f.do_block;)R();A()},TK_STRING:function U(){x()?c.space_before_token=!0:"TK_RESERVED"===o||"TK_WORD"===o?c.space_before_token=!0:"TK_COMMA"===o||"TK_START_EXPR"===o||"TK_EQUALS"===o||"TK_OPERATOR"===o?L()||_():w();A()},TK_EQUALS:function H(){x();f.declaration_statement&&(f.declaration_assignment=!0);c.space_before_token=!0,A(),c.space_before_token=!0},TK_OPERATOR:function $(){x();if("TK_RESERVED"===o&&I(f.last_text))return c.space_before_token=!0,void A();if("*"===d.text&&"TK_DOT"===o)return void A();if(":"===d.text&&f.in_case)return f.case_body=!0,C(),A(),w(),void(f.in_case=!1);if("::"===d.text)return void A();"TK_OPERATOR"===o&&_();var e=!0,t=!0;q(d.text,["--","++","!","~"])||q(d.text,["-","+"])&&(q(o,["TK_START_BLOCK","TK_START_EXPR","TK_EQUALS","TK_OPERATOR"])||q(f.last_text,i.line_starters)||","===f.last_text)?(t=e=!1,!d.wanted_newline||"--"!==d.text&&"++"!==d.text||w(!1,!0)," "===f.last_text&&S(f.mode)&&(e=!0),"TK_RESERVED"===o?e=!0:"TK_END_EXPR"===o?e=!("]"===f.last_text&&("--"===d.text||"++"===d.text)):"TK_OPERATOR"===o&&(e=q(d.text,["--","-","++","+"])&&q(f.last_text,["--","-","++","+"]),q(d.text,["+","-"])&&q(f.last_text,["--","++"])&&(t=!0)),f.mode!==Z.BlockStatement&&f.mode!==Z.Statement||"{"!==f.last_text&&" "!==f.last_text||w()):":"===d.text?0===f.ternary_depth?e=!1:f.ternary_depth-=1:"?"===d.text?f.ternary_depth+=1:"*"===d.text&&"TK_RESERVED"===o&&"function"===f.last_text&&(t=e=!1);c.space_before_token=c.space_before_token||e,A(),c.space_before_token=t},TK_COMMA:function z(){if(f.declaration_statement)return S(f.parent.mode)&&(f.declaration_assignment=!1),A(),void(f.declaration_assignment?w(f.declaration_assignment=!1,!0):(c.space_before_token=!0,g.comma_first&&_()));A(),f.mode===Z.ObjectLiteral||f.mode===Z.Statement&&f.parent.mode===Z.ObjectLiteral?(f.mode===Z.Statement&&R(),w()):(c.space_before_token=!0,g.comma_first&&_())},TK_BLOCK_COMMENT:function W(){if(c.raw)return c.add_raw_token(d),void(d.directives&&"end"===d.directives.preserve&&(g.test_output_raw||(c.raw=!1)));if(d.directives)return w(!1,!0),A(),"start"===d.directives.preserve&&(c.raw=!0),void w(!1,!0);if(!j.newline.test(d.text)&&!d.wanted_newline)return c.space_before_token=!0,A(),void(c.space_before_token=!0);var e,t=function o(e){var t;e=e.replace(/\x0d/g,"");var a=[];t=e.indexOf("\n");for(;-1!==t;)a.push(e.substring(0,t)),e=e.substring(t+1),t=e.indexOf("\n");e.length&&a.push(e);return a}(d.text),a=!1,n=!1,r=d.whitespace_before,i=r.length;w(!1,!0),1<t.length&&(!function s(e,t){for(var a=0;a<e.length;a++){var n=X(e[a]);if(n.charAt(0)!==t)return!1}return!0}(t.slice(1),"*")?function l(e,t){for(var a,n=0,r=e.length;n<r;n++)if((a=e[n])&&0!==a.indexOf(t))return!1;return!0}(t.slice(1),r)&&(n=!0):a=!0);for(A(t[0]),e=1;e<t.length;e++)w(!1,!0),a?A(" ".concat(t[e].replace(/^\s+/g,""))):n&&t[e].length>i?A(t[e].substring(i)):c.add_token(t[e]);w(!1,!0)},TK_COMMENT:function K(){d.wanted_newline?w(!1,!0):c.trim(!0);c.space_before_token=!0,A(),w(!1,!0)},TK_DOT:function G(){x();"TK_RESERVED"===o&&I(f.last_text)?c.space_before_token=!0:_(")"===f.last_text&&g.break_chained_methods);A()},TK_UNKNOWN:function V(){A(),"\n"===d.text[d.text.length-1]&&w()},TK_EOF:function Y(){for(;f.mode===Z.Statement;)R()}},g={},(e=e||{}).braces_on_own_line!==undefined&&(g.brace_style=e.braces_on_own_line?"expand":"collapse"),g.brace_style=e.brace_style?e.brace_style:g.brace_style?g.brace_style:"collapse","expand-strict"===g.brace_style&&(g.brace_style="expand"),g.indent_size=e.indent_size?parseInt(e.indent_size,10):4,g.indent_char=e.indent_char?e.indent_char:" ",g.eol=e.eol?e.eol:"\n",g.preserve_newlines=e.preserve_newlines===undefined||e.preserve_newlines,g.break_chained_methods=e.break_chained_methods!==undefined&&e.break_chained_methods,g.max_preserve_newlines=e.max_preserve_newlines===undefined?0:parseInt(e.max_preserve_newlines,10),g.space_in_paren=e.space_in_paren!==undefined&&e.space_in_paren,g.space_in_empty_paren=e.space_in_empty_paren!==undefined&&e.space_in_empty_paren,g.jslint_happy=e.jslint_happy!==undefined&&e.jslint_happy,g.space_after_anon_function=e.space_after_anon_function!==undefined&&e.space_after_anon_function,g.keep_array_indentation=e.keep_array_indentation!==undefined&&e.keep_array_indentation,g.space_before_conditional=e.space_before_conditional===undefined||e.space_before_conditional,g.unescape_strings=e.unescape_strings!==undefined&&e.unescape_strings,g.wrap_line_length=e.wrap_line_length===undefined?0:parseInt(e.wrap_line_length,10),g.e4x=e.e4x!==undefined&&e.e4x,g.end_with_newline=e.end_with_newline!==undefined&&e.end_with_newline,g.comma_first=e.comma_first!==undefined&&e.comma_first,g.test_output_raw=e.test_output_raw!==undefined&&e.test_output_raw,g.jslint_happy&&(g.space_after_anon_function=!0),e.indent_with_tabs&&(g.indent_char="\t",g.indent_size=1),g.eol=g.eol.replace(/\\r/,"\r").replace(/\\n/,"\n"),l="";0<g.indent_size;)l+=g.indent_char,g.indent_size-=1;var b=0;if(n&&n.length){for(;" "===n.charAt(b)||"\t"===n.charAt(b);)m+=n.charAt(b),b+=1;n=n.substring(b)}function E(e){var t=e.newlines;if(g.keep_array_indentation&&k(f.mode))for(var a=0;a<t;a+=1)w(0<a);else if(g.max_preserve_newlines&&t>g.max_preserve_newlines&&(t=g.max_preserve_newlines),g.preserve_newlines&&1<e.newlines){w();for(var n=1;n<t;n+=1)w(!0)}u[(d=e).type]()}function _(e){if(e=e!==undefined&&e,!c.just_added_newline())if(g.preserve_newlines&&d.wanted_newline||e)w(!1,!0);else if(g.wrap_line_length){c.current_line.get_character_count()+d.text.length+(c.space_before_token?1:0)>=g.wrap_line_length&&w(!1,!0)}}function w(e,t){if(!t&&" "!==f.last_text&&","!==f.last_text&&"="!==f.last_text&&"TK_OPERATOR"!==o)for(;f.mode===Z.Statement&&!f.if_block&&!f.do_block;)R();c.add_new_line(e)&&(f.multiline_frame=!0)}function y(){c.just_added_newline()&&(g.keep_array_indentation&&k(f.mode)&&d.wanted_newline?(c.current_line.push(d.whitespace_before),c.space_before_token=!1):c.set_indent(f.indentation_level)&&(f.line_indent_level=f.indentation_level))}function A(e){c.raw?c.add_raw_token(d):(g.comma_first&&"TK_COMMA"===o&&c.just_added_newline()&&","===c.previous_line.last()&&(c.previous_line.pop(),y(),c.add_token(","),c.space_before_token=!0),e=e||d.text,y(),c.add_token(e))}function C(){f.indentation_level+=1}function T(e){p=f?(t.push(f),f):v(null,e),f=v(p,e)}function k(e){return e===Z.ArrayLiteral}function S(e){return q(e,[Z.Expression,Z.ForInitializer,Z.Conditional])}function R(){0<t.length&&(p=f,f=t.pop(),p.mode===Z.Statement&&c.remove_redundant_indentation(p))}function L(){return f.parent.mode===Z.ObjectLiteral&&f.mode===Z.Statement&&(":"===f.last_text&&0===f.ternary_depth||"TK_RESERVED"===o&&q(f.last_text,["get","set"]))}function x(){return!!("TK_RESERVED"===o&&q(f.last_text,["const","let","const"])&&"TK_WORD"===d.type||"TK_RESERVED"===o&&"do"===f.last_text||"TK_RESERVED"===o&&"return"===f.last_text&&!d.wanted_newline||"TK_RESERVED"===o&&"else"===f.last_text&&("TK_RESERVED"!==d.type||"if"!==d.text)||"TK_END_EXPR"===o&&(p.mode===Z.ForInitializer||p.mode===Z.Conditional)||"TK_WORD"===o&&f.mode===Z.BlockStatement&&!f.in_case&&"--"!==d.text&&"++"!==d.text&&"function"!==s&&"TK_WORD"!==d.type&&"TK_RESERVED"!==d.type||f.mode===Z.ObjectLiteral&&(":"===f.last_text&&0===f.ternary_depth||"TK_RESERVED"===o&&q(f.last_text,["get","set"])))&&(T(Z.Statement),C(),"TK_RESERVED"===o&&q(f.last_text,["const","let","const"])&&"TK_WORD"===d.type&&(f.declaration_statement=!0),L()||_("TK_RESERVED"===d.type&&q(d.text,["do","for","if","while"])),!0)}function I(e){return q(e,["case","return","do","if","throw","else"])}function O(e){var t=r+(e||0);return t<0||t>=h.length?null:h[t]}function F(){("TK_RESERVED"===d.type&&f.mode!==Z.ObjectLiteral&&q(d.text,["set","get"])&&(d.type="TK_WORD"),"TK_RESERVED"===d.type&&f.mode===Z.ObjectLiteral)&&(":"===O(1).text&&(d.type="TK_WORD"));if(x()||!d.wanted_newline||S(f.mode)||"TK_OPERATOR"===o&&"--"!==f.last_text&&"++"!==f.last_text||"TK_EQUALS"===o||!g.preserve_newlines&&"TK_RESERVED"===o&&q(f.last_text,["const","let","const","set","get"])||w(),f.do_block&&!f.do_while){if("TK_RESERVED"===d.type&&"while"===d.text)return c.space_before_token=!0,A(),c.space_before_token=!0,void(f.do_while=!0);w(),f.do_block=!1}if(f.if_block)if(f.else_block||"TK_RESERVED"!==d.type||"else"!==d.text){for(;f.mode===Z.Statement;)R();f.if_block=!1,f.else_block=!1}else f.else_block=!0;if("TK_RESERVED"===d.type&&("case"===d.text||"default"===d.text&&f.in_case_statement))return w(),(f.case_body||g.jslint_happy)&&(!function e(){0<f.indentation_level&&(!f.parent||f.indentation_level>f.parent.indentation_level)&&(f.indentation_level-=1)}(),f.case_body=!1),A(),f.in_case=!0,void(f.in_case_statement=!0);if("TK_RESERVED"===d.type&&"function"===d.text&&((q(f.last_text,["}"," "])||c.just_added_newline()&&!q(f.last_text,["[","{",":","=",","]))&&(c.just_added_blankline()||d.comments_before.length||(w(),w(!0))),"TK_RESERVED"===o||"TK_WORD"===o?"TK_RESERVED"===o&&q(f.last_text,["get","set","new","return","export","async"])?c.space_before_token=!0:"TK_RESERVED"===o&&"default"===f.last_text&&"export"===s?c.space_before_token=!0:w():"TK_OPERATOR"===o||"="===f.last_text?c.space_before_token=!0:(f.multiline_frame||!S(f.mode)&&!k(f.mode))&&w()),"TK_COMMA"!==o&&"TK_START_EXPR"!==o&&"TK_EQUALS"!==o&&"TK_OPERATOR"!==o||L()||_(),"TK_RESERVED"===d.type&&q(d.text,["function","get","set"]))return A(),void(f.last_word=d.text);(a="NONE","TK_END_BLOCK"===o?"TK_RESERVED"===d.type&&q(d.text,["else","catch","finally"])?"expand"===g.brace_style||"end-expand"===g.brace_style||"none"===g.brace_style&&d.wanted_newline?a="NEWLINE":(a="SPACE",c.space_before_token=!0):a="NEWLINE":"TK_SEMICOLON"===o&&f.mode===Z.BlockStatement?a="NEWLINE":"TK_SEMICOLON"===o&&S(f.mode)?a="SPACE":"TK_STRING"===o?a="NEWLINE":"TK_RESERVED"===o||"TK_WORD"===o||"*"===f.last_text&&"function"===s?a="SPACE":"TK_START_BLOCK"===o?a="NEWLINE":"TK_END_EXPR"===o&&(c.space_before_token=!0,a="NEWLINE"),"TK_RESERVED"===d.type&&q(d.text,i.line_starters)&&")"!==f.last_text&&(a="else"===f.last_text||"export"===f.last_text?"SPACE":"NEWLINE"),"TK_RESERVED"===d.type&&q(d.text,["else","catch","finally"]))?"TK_END_BLOCK"!==o||"expand"===g.brace_style||"end-expand"===g.brace_style||"none"===g.brace_style&&d.wanted_newline?w():(c.trim(!0),"}"!==c.current_line.last()&&w(),c.space_before_token=!0):"NEWLINE"===a?"TK_RESERVED"===o&&I(f.last_text)?c.space_before_token=!0:"TK_END_EXPR"!==o?"TK_START_EXPR"===o&&"TK_RESERVED"===d.type&&q(d.text,["const","let","const"])||":"===f.last_text||("TK_RESERVED"===d.type&&"if"===d.text&&"else"===f.last_text?c.space_before_token=!0:w()):"TK_RESERVED"===d.type&&q(d.text,i.line_starters)&&")"!==f.last_text&&w():f.multiline_frame&&k(f.mode)&&","===f.last_text&&"}"===s?w():"SPACE"===a&&(c.space_before_token=!0);A(),f.last_word=d.text,"TK_RESERVED"===d.type&&"do"===d.text&&(f.do_block=!0),"TK_RESERVED"===d.type&&"if"===d.text&&(f.if_block=!0)}o="TK_START_BLOCK",s="",(c=new Q(l,m)).raw=g.test_output_raw,t=[],T(Z.BlockStatement),this.beautify=function(){var e,t;for(i=new ee(n,g,l),h=i.tokenize(),r=0;e=O();){for(var a=0;a<e.comments_before.length;a++)E(e.comments_before[a]);E(e),s=f.last_text,o=e.type,f.last_text=e.text,r+=1}return t=c.get_code(),g.end_with_newline&&(t+="\n"),"\n"!=g.eol&&(t=t.replace(/[\n]/g,g.eol)),t}}function i(t){var a=0,n=-1,r=[],i=!0;this.set_indent=function(e){a=t.baseIndentLength+e*t.indent_length,n=e},this.get_character_count=function(){return a},this.is_empty=function(){return i},this.last=function(){return this._empty?null:r[r.length-1]},this.push=function(e){r.push(e),a+=e.length,i=!1},this.pop=function(){var e=null;return i||(e=r.pop(),a-=e.length,i=0===r.length),e},this.remove_indent=function(){0<n&&(n-=1,a-=t.indent_length)},this.trim=function(){for(;" "===this.last();)r.pop(),a-=1;i=0===r.length},this.toString=function(){var e="";return this._empty||(0<=n&&(e=t.indent_cache[n]),e+=r.join("")),e}}function Q(t,a){a=a||"",this.indent_cache=[a],this.baseIndentLength=a.length,this.indent_length=t.length,this.raw=!1;var n=[];this.baseIndentString=a,this.indent_string=t,this.previous_line=null,this.current_line=null,this.space_before_token=!1,this.add_outputline=function(){this.previous_line=this.current_line,this.current_line=new i(this),n.push(this.current_line)},this.add_outputline(),this.get_line_number=function(){return n.length},this.add_new_line=function(e){return(1!==this.get_line_number()||!this.just_added_newline())&&(!(!e&&this.just_added_newline())&&(this.raw||this.add_outputline(),!0))},this.get_code=function(){return n.join("\n").replace(/[\r\n\t ]+$/,"")},this.set_indent=function(e){if(1<n.length){for(;e>=this.indent_cache.length;)this.indent_cache.push(this.indent_cache[this.indent_cache.length-1]+this.indent_string);return this.current_line.set_indent(e),!0}return this.current_line.set_indent(0),!1},this.add_raw_token=function(e){for(var t=0;t<e.newlines;t++)this.add_outputline();this.current_line.push(e.whitespace_before),this.current_line.push(e.text),this.space_before_token=!1},this.add_token=function(e){this.add_space_before_token(),this.current_line.push(e)},this.add_space_before_token=function(){this.space_before_token&&!this.just_added_newline()&&this.current_line.push(" "),this.space_before_token=!1},this.remove_redundant_indentation=function(e){if(!e.multiline_frame&&e.mode!==Z.ForInitializer&&e.mode!==Z.Conditional)for(var t=e.start_line_index,a=n.length;t<a;)n[t].remove_indent(),t++},this.trim=function(e){for(e=e!==undefined&&e,this.current_line.trim(t,a);e&&1<n.length&&this.current_line.is_empty();)n.pop(),this.current_line=n[n.length-1],this.current_line.trim();this.previous_line=1<n.length?n[n.length-2]:null},this.just_added_newline=function(){return this.current_line.is_empty()},this.just_added_blankline=function(){return!!this.just_added_newline()&&(1===n.length||n[n.length-2].is_empty())}}var J=function J(e,t,a,n,r,i){this.type=e,this.text=t,this.comments_before=[],this.newlines=a||0,this.wanted_newline=0<a,this.whitespace_before=n||"",this.parent=null,this.directives=null};function ee(R,L,e){var x="\n\r\t ".split(""),I=/[0-9]/,O=/[01234567]/,F=/[0123456789abcdefABCDEF]/,M="+ - * / % & ++ -- = += -= *= /= %= == === != !== > < >= <= >> << >>> >>>= >>= <<= && &= | || ! ~ , : ? ^ ^= |= :: =>".split(" ");this.line_starters="continue,try,throw,return,const,let,const,if,switch,case,default,for,while,break,function,import,export".split(",");var N,D,P,B,U,H,$=this.line_starters.concat(["do","in","else","get","set","new","catch","finally","typeof","yield","async","await"]),z=/([\s\S]*?)((?:\*\/)|$)/g,W=/([^\n\r\u2028\u2029]*)/g,K=/\/\* beautify( \w+[:]\w+)+ \*\//g,G=/ (\w+)[:](\w+)/g,V=/([\s\S]*?)((?:\/\*\sbeautify\signore:end\s\*\/)|$)/g,Y=/((<\?php|<\?=)[\s\S]*?\?>)|(<%[\s\S]*?%>)/g;function o(){var e,t,a=[];if(N=0,D="",H<=U)return["","TK_EOF"];t=B.length?B[B.length-1]:new J("TK_START_BLOCK","{");var n=R.charAt(U);for(U+=1;q(n,x);){if(j.newline.test(n)?"\n"===n&&"\r"===R.charAt(U-2)||(N+=1,a=[]):a.push(n),H<=U)return["","TK_EOF"];n=R.charAt(U),U+=1}if(a.length&&(D=a.join("")),I.test(n)){var r=!0,i=!0,o=I;for("0"===n&&U<H&&/[Xxo]/.test(R.charAt(U))?(i=r=!1,n+=R.charAt(U),U+=1,o=/[o]/.test(R.charAt(U))?O:F):(n="",U-=1);U<H&&o.test(R.charAt(U));)n+=R.charAt(U),U+=1,r&&U<H&&"."===R.charAt(U)&&(n+=R.charAt(U),U+=1,r=!1),i&&U<H&&/[Ee]/.test(R.charAt(U))&&(n+=R.charAt(U),(U+=1)<H&&/[+-]/.test(R.charAt(U))&&(n+=R.charAt(U),U+=1),r=i=!1);return[n,"TK_WORD"]}if(j.isIdentifierStart(R.charCodeAt(U-1))){if(U<H)for(;j.isIdentifierChar(R.charCodeAt(U))&&(n+=R.charAt(U),(U+=1)!==H););return"TK_DOT"===t.type||"TK_RESERVED"===t.type&&q(t.text,["set","get"])||!q(n,$)?[n,"TK_WORD"]:"in"===n?[n,"TK_OPERATOR"]:[n,"TK_RESERVED"]}if("("===n||"["===n)return[n,"TK_START_EXPR"];if(")"===n||"]"===n)return[n,"TK_END_EXPR"];if("{"===n)return[n,"TK_START_BLOCK"];if("}"===n)return[n,"TK_END_BLOCK"];if(" "===n)return[n,"TK_SEMICOLON"];if("/"===n){var s="";if("*"===R.charAt(U)){U+=1,z.lastIndex=U;var l=z.exec(R);s="/*".concat(l[0]),U+=l[0].length;var c=function k(e){if(!e.match(K))return null;var t={};G.lastIndex=0;for(var a=G.exec(e);a;)t[a[1]]=a[2],a=G.exec(e);return t}(s);return c&&"start"===c.ignore&&(V.lastIndex=U,s+=(l=V.exec(R))[0],U+=l[0].length),[s=s.replace(j.lineBreak,"\n"),"TK_BLOCK_COMMENT",c]}if("/"===R.charAt(U)){U+=1,W.lastIndex=U;var d=W.exec(R);return s="//".concat(d[0]),U+=d[0].length,[s,"TK_COMMENT"]}}if("`"===n||"'"===n||'"'===n||("/"===n||L.e4x&&"<"===n&&R.slice(U-1).match(/^<([-a-zA-Z:0-9_.]+|{[^{}]*}|!\[CDATA\[[\s\S]*?\]\])(\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{.*?}))*\s*(\/?)\s*>/))&&("TK_RESERVED"===t.type&&q(t.text,["return","case","throw","else","do","typeof","yield"])||"TK_END_EXPR"===t.type&&")"===t.text&&t.parent&&"TK_RESERVED"===t.parent.type&&q(t.parent.text,["if","while","for"])||q(t.type,["TK_COMMENT","TK_START_EXPR","TK_START_BLOCK","TK_END_BLOCK","TK_OPERATOR","TK_EQUALS","TK_EOF","TK_SEMICOLON","TK_COMMA"]))){var f=n,p=!1,u=!1;if(e=n,"/"===f)for(var g=!1;U<H&&(p||g||R.charAt(U)!==f)&&!j.newline.test(R.charAt(U));)e+=R.charAt(U),p?p=!1:(p="\\"===R.charAt(U),"["===R.charAt(U)?g=!0:"]"===R.charAt(U)&&(g=!1)),U+=1;else if(L.e4x&&"<"===f){var h=/<(\/?)([-a-zA-Z:0-9_.]+|{[^{}]*}|!\[CDATA\[[\s\S]*?\]\])(\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{.*?}))*\s*(\/?)\s*>/g,m=R.slice(U-1),v=h.exec(m);if(v&&0===v.index){for(var b=v[2],E=0;v;){var _=!!v[1],w=v[2],y=!!v[v.length-1]||"![CDATA["===w.slice(0,8);if(w!==b||y||(_?--E:++E),E<=0)break;v=h.exec(m)}var A=v?v.index+v[0].length:m.length;return m=m.slice(0,A),U+=A-1,[m=m.replace(j.lineBreak,"\n"),"TK_STRING"]}}else for(;U<H&&(p||R.charAt(U)!==f&&("`"===f||!j.newline.test(R.charAt(U))));)(p||"`"===f)&&j.newline.test(R.charAt(U))?("\r"===R.charAt(U)&&"\n"===R.charAt(U+1)&&(U+=1),e+="\n"):e+=R.charAt(U),p=p?("x"!==R.charAt(U)&&"u"!==R.charAt(U)||(u=!0),!1):"\\"===R.charAt(U),U+=1;if(u&&L.unescape_strings&&(e=function S(e){var t,a=!1,n="",r=0,i="",o=0;for(;a||r<e.length;)if(t=e.charAt(r),r++,a){if(a=!1,"x"===t)i=e.substr(r,2),r+=2;else{if("u"!==t){n+="\\".concat(t);continue}i=e.substr(r,4),r+=4}if(!i.match(/^[0123456789abcdefABCDEF]+$/))return e;if(0<=(o=parseInt(i,16))&&o<32){n+="x"===t?"\\x".concat(i):"\\u".concat(i);continue}if(34===o||39===o||92===o)n+="\\".concat(String.fromCharCode(o));else{if("x"===t&&126<o&&o<=255)return e;n+=String.fromCharCode(o)}}else"\\"===t?a=!0:n+=t;return n}(e)),U<H&&R.charAt(U)===f&&(e+=f,U+=1,"/"===f))for(;U<H&&j.isIdentifierStart(R.charCodeAt(U));)e+=R.charAt(U),U+=1;return[e,"TK_STRING"]}if("#"===n){if(0===B.length&&"!"===R.charAt(U)){for(e=n;U<H&&"\n"!==n;)e+=n=R.charAt(U),U+=1;return["".concat(X(e),"\n"),"TK_UNKNOWN"]}var C="#";if(U<H&&I.test(R.charAt(U))){for(;C+=n=R.charAt(U),(U+=1)<H&&"#"!==n&&"="!==n;);return"#"===n||("["===R.charAt(U)&&"]"===R.charAt(U+1)?(C+="[]",U+=2):"{"===R.charAt(U)&&"}"===R.charAt(U+1)&&(C+="{}",U+=2)),[C,"TK_WORD"]}}if("<"===n&&("?"===R.charAt(U)||"%"===R.charAt(U))){Y.lastIndex=U-1;var T=Y.exec(R);if(T)return n=T[0],U+=n.length-1,[n=n.replace(j.lineBreak,"\n"),"TK_STRING"]}if("<"===n&&"\x3c!--"===R.substring(U-1,U+3)){for(U+=3,n="\x3c!--";!j.newline.test(R.charAt(U))&&U<H;)n+=R.charAt(U),U++;return P=!0,[n,"TK_COMMENT"]}if("-"===n&&P&&"--\x3e"===R.substring(U-1,U+2))return P=!1,U+=2,["--\x3e","TK_COMMENT"];if("."===n)return[n,"TK_DOT"];if(q(n,M)){for(;U<H&&q(n+R.charAt(U),M)&&(n+=R.charAt(U),!(H<=(U+=1))););return","===n?[n,"TK_COMMA"]:"="===n?[n,"TK_EQUALS"]:[n,"TK_OPERATOR"]}return[n,"TK_UNKNOWN"]}this.tokenize=function(){var e,t,a;H=R.length,U=0,P=!1,B=[];for(var n=null,r=[],i=[];!t||"TK_EOF"!==t.type;){for(a=o(),e=new J(a[1],a[0],N,D);"TK_COMMENT"===e.type||"TK_BLOCK_COMMENT"===e.type||"TK_UNKNOWN"===e.type;)"TK_BLOCK_COMMENT"===e.type&&(e.directives=a[2]),i.push(e),a=o(),e=new J(a[1],a[0],N,D);i.length&&(e.comments_before=i,i=[]),"TK_START_BLOCK"===e.type||"TK_START_EXPR"===e.type?(e.parent=t,r.push(n),n=e):("TK_END_BLOCK"===e.type||"TK_END_EXPR"===e.type)&&n&&("]"===e.text&&"["===n.text||")"===e.text&&"("===n.text||"}"===e.text&&"{"===n.text)&&(e.parent=n.parent,n=r.pop()),B.push(e),t=e}return B}}return{run:function I(e,t){function o(e){return e.replace(/\s+$/g,"")}var a,n,r,m,i,s,v,l,c,b,E,_,d,f;for((t=t||{}).wrap_line_length!==undefined&&0!==parseInt(t.wrap_line_length,10)||t.max_char===undefined||0===parseInt(t.max_char,10)||(t.wrap_line_length=t.max_char),n=t.indent_inner_html!==undefined&&t.indent_inner_html,r=t.indent_size===undefined?4:parseInt(t.indent_size,10),m=t.indent_char===undefined?" ":t.indent_char,s=t.brace_style===undefined?"collapse":t.brace_style,i=0===parseInt(t.wrap_line_length,10)?32786:parseInt(t.wrap_line_length||250,10),v=t.unformatted||["a","span","img","bdo","em","strong","dfn","code","samp","kbd","const","cite","abbr","acronym","q","sub","sup","tt","i","b","big","small","u","s","strike","font","ins","del","address","pre"],l=t.preserve_newlines===undefined||t.preserve_newlines,c=l?isNaN(parseInt(t.max_preserve_newlines,10))?32786:parseInt(t.max_preserve_newlines,10):0,b=t.indent_handlebars!==undefined&&t.indent_handlebars,E=t.wrap_attributes===undefined?"auto":t.wrap_attributes,_=t.wrap_attributes_indent_size===undefined?r:parseInt(t.wrap_attributes_indent_size,10)||r,d=t.end_with_newline!==undefined&&t.end_with_newline,f=Array.isArray(t.extra_liners)?t.extra_liners.concat():"string"==typeof t.extra_liners?t.extra_liners.split(","):"head,body,/html".split(","),t.indent_with_tabs&&(m="\t",r=1),(a=new function R(){return this.pos=0,this.token="",this.current_mode="CONTENT",this.tags={parent:"parent1",parentcount:1,parent1:""},this.tag_type="",this.token_text=this.last_token=this.last_text=this.token_type="",this.newlines=0,this.indent_content=n,this.Utils={whitespace:"\n\r\t ".split(""),single_token:"br,input,link,meta,source,!doctype,basefont,base,area,hr,wbr,param,img,isindex,embed".split(","),extra_liners:f,in_array:function(e,t){for(var a=0;a<t.length;a++)if(e===t[a])return!0;return!1}},this.is_whitespace=function(e){for(;0<e.length;e++)if(!this.Utils.in_array(e.charAt(0),this.Utils.whitespace))return!1;return!0},this.traverse_whitespace=function(){var e="";if(e=this.input.charAt(this.pos),this.Utils.in_array(e,this.Utils.whitespace)){for(this.newlines=0;this.Utils.in_array(e,this.Utils.whitespace);)l&&"\n"===e&&this.newlines<=c&&(this.newlines+=1),this.pos++,e=this.input.charAt(this.pos);return!0}return!1},this.space_or_wrap=function(e){this.line_char_count>=this.wrap_line_length?(this.print_newline(!1,e),this.print_indentation(e)):(this.line_char_count++,e.push(" "))},this.get_content=function(){for(var e="",t=[];"<"!=this.input.charAt(this.pos);){if(this.pos>=this.input.length)return t.length?t.join(""):["","TK_EOF"];if(this.traverse_whitespace())this.space_or_wrap(t);else{if(b){var a=this.input.substr(this.pos,3);if("{{#"===a||"{{/"===a)break;if("{{!"===a)return[this.get_tag(),"TK_TAG_HANDLEBARS_COMMENT"];if("{{"===this.input.substr(this.pos,2)&&"{{else}}"===this.get_tag(!0))break}e=this.input.charAt(this.pos),this.pos++,this.line_char_count++,t.push(e)}}return t.length?t.join(""):""},this.get_contents_to=function(e){if(this.pos===this.input.length)return["","TK_EOF"];var t="",a=new RegExp("</".concat(e,"\\s*>"),"igm");a.lastIndex=this.pos;var n=a.exec(this.input),r=n?n.index:this.input.length;return this.pos<r&&(t=this.input.substring(this.pos,r),this.pos=r),t},this.record_tag=function(e){this.tags["".concat(e,"count")]?this.tags["".concat(e,"count")]++:this.tags["".concat(e,"count")]=1,this.tags[e+this.tags["".concat(e,"count")]]=this.indent_level,this.tags[e+this.tags["".concat(e,"count")]+"parent"]=this.tags.parent,this.tags.parent=e+this.tags["".concat(e,"count")]},this.retrieve_tag=function(e){if(this.tags["".concat(e,"count")]){for(var t=this.tags.parent;t&&e+this.tags["".concat(e,"count")]!==t;)t=this.tags["".concat(t,"parent")];t&&(this.indent_level=this.tags[e+this.tags["".concat(e,"count")]],this.tags.parent=this.tags[t+"parent"]),delete this.tags[e+this.tags["".concat(e,"count")]+"parent"],delete this.tags[e+this.tags["".concat(e,"count")]],1===this.tags["".concat(e,"count")]?delete this.tags["".concat(e,"count")]:this.tags["".concat(e,"count")]--}},this.indent_to_tag=function(e){if(this.tags["".concat(e,"count")]){for(var t=this.tags.parent;t&&e+this.tags["".concat(e,"count")]!==t;)t=this.tags["".concat(t,"parent")];t&&(this.indent_level=this.tags[e+this.tags["".concat(e,"count")]])}},this.get_tag=function(e){var t,a,n="",r=[],i="",o=!1,s=!0,l=this.pos,c=this.line_char_count;e=e!==undefined&&e;do{if(this.pos>=this.input.length)return e&&(this.pos=l,this.line_char_count=c),r.length?r.join(""):["","TK_EOF"];if(n=this.input.charAt(this.pos),this.pos++,this.Utils.in_array(n,this.Utils.whitespace))o=!0;else{if("'"!==n&&'"'!==n||(n+=this.get_unformatted(n),o=!0),"="===n&&(o=!1),r.length&&"="!=r[r.length-1]&&">"!=n&&o){if(this.space_or_wrap(r),o=!1,!s&&"force"===E&&"/"!=n){this.print_newline(!0,r),this.print_indentation(r);for(var d=0;d<_;d++)r.push(m)}for(var f=0;f<r.length;f++)if(" "===r[f]){s=!1;break}}if(b&&"<"===a&&n+this.input.charAt(this.pos)==="{{"&&(n+=this.get_unformatted("}}"),r.length&&" "!=r[r.length-1]&&"<"!=r[r.length-1]&&(n=" ".concat(n)),o=!0),"<"!==n||a||(t=this.pos-1,a="<"),b&&!a&&2<=r.length&&"{"===r[r.length-1]&&"{"===r[r.length-2]&&(t="#"===n||"/"===n||"!"===n?this.pos-3:this.pos-2,a="{"),this.line_char_count++,r.push(n),r[1]&&("!"===r[1]||"?"===r[1]||"%"===r[1])){r=[this.get_comment(t)];break}if(b&&r[1]&&"{"===r[1]&&r[2]&&"!"===r[2]){r=[this.get_comment(t)];break}if(b&&"{"===a&&2<r.length&&"}"===r[r.length-2]&&"}"===r[r.length-1])break}}while(">"!=n);var p,u,g=r.join("");p=-1!=g.indexOf(" ")?g.indexOf(" "):"{"===g[0]?g.indexOf("}"):g.indexOf(">"),u="<"!==g[0]&&b?"#"===g[2]?3:2:1;var h=g.substring(u,p).toLowerCase();return"/"===g.charAt(g.length-2)||this.Utils.in_array(h,this.Utils.single_token)?e||(this.tag_type="SINGLE"):b&&"{"===g[0]&&"else"===h?e||(this.indent_to_tag("if"),this.tag_type="HANDLEBARS_ELSE",this.indent_content=!0,this.traverse_whitespace()):this.is_unformatted(h,v)?(i=this.get_unformatted("</".concat(h,">"),g),r.push(i),this.pos,this.tag_type="SINGLE"):"script"===h&&(-1===g.search("type")||-1<g.search("type")&&-1<g.search(/\b(text|application)\/(x-)?(javascript|ecmascript|jscript|livescript)/))?e||(this.record_tag(h),this.tag_type="SCRIPT"):"style"===h&&(-1===g.search("type")||-1<g.search("type")&&-1<g.search("text/css"))?e||(this.record_tag(h),this.tag_type="STYLE"):"!"===h.charAt(0)?e||(this.tag_type="SINGLE",this.traverse_whitespace()):e||("/"===h.charAt(0)?(this.retrieve_tag(h.substring(1)),this.tag_type="END"):(this.record_tag(h),"html"!=h.toLowerCase()&&(this.indent_content=!0),this.tag_type="START"),this.traverse_whitespace()&&this.space_or_wrap(r),this.Utils.in_array(h,this.Utils.extra_liners)&&(this.print_newline(!1,this.output),this.output.length&&"\n"!=this.output[this.output.length-2]&&this.print_newline(!0,this.output))),e&&(this.pos=l,this.line_char_count=c),r.join("")},this.get_comment=function(e){var t="",a=">",n=!1;this.pos=e;var r=this.input.charAt(this.pos);for(this.pos++;this.pos<=this.input.length&&((t+=r)[t.length-1]!==a[a.length-1]||-1==t.indexOf(a));)!n&&t.length<10&&(0===t.indexOf("<![if")?(a="<![endif]>",n=!0):0===t.indexOf("<![cdata[")?(a="]]>",n=!0):0===t.indexOf("<![")?(a="]>",n=!0):0===t.indexOf("\x3c!--")?(a="--\x3e",n=!0):0===t.indexOf("{{!")?(a="}}",n=!0):0===t.indexOf("<?")?(a="?>",n=!0):0===t.indexOf("<%")&&(a="%>",n=!0)),r=this.input.charAt(this.pos),this.pos++;return t},this.get_unformatted=function(e,t){if(t&&-1!=t.toLowerCase().indexOf(e))return"";var a="",n="",r=0,i=!0;do{if(this.pos>=this.input.length)return n;if(a=this.input.charAt(this.pos),this.pos++,this.Utils.in_array(a,this.Utils.whitespace)){if(!i){this.line_char_count--;continue}if("\n"===a||"\r"===a){n+="\n",this.line_char_count=0;continue}}n+=a,this.line_char_count++,i=!0,b&&"{"===a&&n.length&&"{"===n[n.length-2]&&(r=(n+=this.get_unformatted("}}")).length)}while(-1===n.toLowerCase().indexOf(e,r));return n},this.get_token=function(){var e;if("TK_TAG_SCRIPT"!==this.last_token&&"TK_TAG_STYLE"!==this.last_token)return"CONTENT"===this.current_mode?"string"!=typeof(e=this.get_content())?e:[e,"TK_CONTENT"]:"TAG"===this.current_mode?"string"!=typeof(e=this.get_tag())?e:[e,"TK_TAG_".concat(this.tag_type)]:void 0;var t=this.last_token.substr(7);return"string"!=typeof(e=this.get_contents_to(t))?e:[e,"TK_".concat(t)]},this.get_full_indent=function(e){return(e=this.indent_level+e||0)<1?"":new Array(e+1).join(this.indent_string)},this.is_unformatted=function(e,t){if(!this.Utils.in_array(e,t))return!1;if("a"!=e.toLowerCase()||!this.Utils.in_array("a",t))return!0;var a=(this.get_tag(!0)||"").match(/^\s*<\s*\/?([a-z]*)\s*[^>]*>\s*$/);return!(a&&!this.Utils.in_array(a,t))},this.printer=function(e,t,a,n,r){this.input=e||"",this.output=[],this.indent_character=t,this.indent_string="",this.indent_size=a,this.brace_style=r,this.indent_level=0,this.wrap_line_length=n;for(var i=this.line_char_count=0;i<this.indent_size;i++)this.indent_string+=this.indent_character;this.print_newline=function(e,t){this.line_char_count=0,t&&t.length&&(e||"\n"!=t[t.length-1])&&("\n"!=t[t.length-1]&&(t[t.length-1]=o(t[t.length-1])),t.push("\n"))},this.print_indentation=function(e){for(var t=0;t<this.indent_level;t++)e.push(this.indent_string),this.line_char_count+=this.indent_string.length},this.print_token=function(e){this.is_whitespace(e)&&!this.output.length||((e||""!==e)&&this.output.length&&"\n"===this.output[this.output.length-1]&&(this.print_indentation(this.output),e=function t(e){return e.replace(/^\s+/g,"")}(e)),this.print_token_raw(e))},this.print_token_raw=function(e){0<this.newlines&&(e=o(e)),e&&""!==e&&(1<e.length&&"\n"===e[e.length-1]?(this.output.push(e.slice(0,-1)),this.print_newline(!1,this.output)):this.output.push(e));for(var t=0;t<this.newlines;t++)this.print_newline(0<t,this.output);this.newlines=0},this.indent=function(){this.indent_level++},this.unindent=function(){0<this.indent_level&&this.indent_level--}},this}).printer(e,m,r,i,s);;){var p=a.get_token();if(a.token_text=p[0],a.token_type=p[1],"TK_EOF"===a.token_type)break;switch(a.token_type){case"TK_TAG_START":a.print_newline(!1,a.output),a.print_token(a.token_text),a.indent_content&&(a.indent(),a.indent_content=!1),a.current_mode="CONTENT";break;case"TK_TAG_STYLE":case"TK_TAG_SCRIPT":a.print_newline(!1,a.output),a.print_token(a.token_text),a.current_mode="CONTENT";break;case"TK_TAG_END":if("TK_CONTENT"===a.last_token&&""===a.last_text){var u=a.token_text.match(/\w+/)[0],g=null;a.output.length&&(g=a.output[a.output.length-1].match(/(?:<|{{#)\/?\s*(\w+)/)),(null===g||g[1]!=u&&!a.Utils.in_array(g[1],v))&&a.print_newline(!1,a.output)}a.print_token(a.token_text),a.current_mode="CONTENT";break;case"TK_TAG_SINGLE":var h=a.token_text.match(/^\s*<([a-z-]+)/i);h&&a.Utils.in_array(h[1],v)||a.print_newline(!1,a.output),a.print_token(a.token_text),a.current_mode="CONTENT";break;case"TK_TAG_HANDLEBARS_ELSE":a.print_token(a.token_text),a.indent_content&&(a.indent(),a.indent_content=!1),a.current_mode="CONTENT";break;case"TK_TAG_HANDLEBARS_COMMENT":case"TK_CONTENT":a.print_token(a.token_text),a.current_mode="TAG";break;case"TK_STYLE":case"TK_SCRIPT":if(""!==a.token_text){a.print_newline(!1,a.output);var w=a.token_text,y=void 0,A=1;"TK_SCRIPT"===a.token_type?y=x:"TK_STYLE"===a.token_type&&(y=L),"keep"===t.indent_scripts?A=0:"separate"===t.indent_scripts&&(A=-a.indent_level);var C=a.get_full_indent(A);if(y)w=y(w.replace(/^\s*/,C),t);else{var T=w.match(/^\s*/)[0].match(/[^\n\r]*$/)[0].split(a.indent_string).length-1,k=a.get_full_indent(A-T);w=w.replace(/^\s*/,C).replace(/\r\n|\r|\n/g,"\n"+k).replace(/\s+$/,"")}w&&(a.print_token_raw(w),a.print_newline(!0,a.output))}a.current_mode="TAG";break;default:""!==a.token_text&&a.print_token(a.token_text)}a.last_token=a.token_type,a.last_text=a.token_text}var S=a.output.join("").replace(/[\r\n\t ]+$/,"");return d&&(S+="\n"),S}}},Object.assign(St.DEFAULTS,{codeMirror:window.CodeMirror,codeMirrorOptions:{lineNumbers:!0,tabMode:"indent",indentWithTabs:!0,lineWrapping:!0,mode:"text/html",tabSize:2},codeBeautifierOptions:{end_with_newline:!0,indent_inner_html:!0,extra_liners:["p","h1","h2","h3","h4","h5","h6","blockquote","pre","ul","ol","table","dl"],brace_style:"expand",indent_char:"\t",indent_size:1,wrap_line_length:0},codeViewKeepActiveButtons:["fullscreen"]}),St.PLUGINS.codeView=function(c){var d,f,p=c.$,u=function u(){return c.$box.hasClass("fr-code-view")};function g(){return f?f.getValue():d.val()}function h(){u()&&(f&&f.setSize(null,c.opts.height?c.opts.height:"auto"),c.opts.heightMin||c.opts.height?(c.$box.find(".CodeMirror-scroll, .CodeMirror-gutters").css("min-height",c.opts.heightMin||c.opts.height),d.css("height",c.opts.height)):c.$box.find(".CodeMirror-scroll, .CodeMirror-gutters").css("min-height",""))}var m,v=!1;function b(){u()&&c.events.trigger("blur")}function E(){u()&&v&&c.events.trigger("focus")}function n(e){d||(!function l(){d=p('<textarea class="fr-code" tabIndex="-1">'),c.$wp.append(d),d.attr("dir",c.opts.direction),c.$box.hasClass("fr-basic")||(m=p('<a data-cmd="html" title="Code View" class="fr-command fr-btn html-switch'.concat(c.helpers.isMobile()?"":" fr-desktop",'" role="button" tabIndex="-1"><i class="fa fa-code"></i></button>')),c.$box.append(m),c.events.bindClick(c.$box,"a.html-switch",function(){c.events.trigger("commands.before",["html"]),_(!1),c.events.trigger("commands.after",["html"])}));var e=function e(){return!u()};c.events.on("buttons.refresh",e),c.events.on("copy",e,!0),c.events.on("cut",e,!0),c.events.on("paste",e,!0),c.events.on("destroy",w,!0),c.events.on("html.set",function(){u()&&_(!0)}),c.events.on("codeView.update",h),c.events.on("codeView.toggle",function(){c.$box.hasClass("fr-code-view")&&_()}),c.events.on("form.submit",function(){u()&&(c.html.set(g()),c.events.trigger("contentChanged",[],!0))},!0)}(),!f&&c.opts.codeMirror?((f=c.opts.codeMirror.fromTextArea(d.get(0),c.opts.codeMirrorOptions)).on("blur",b),f.on("focus",E)):(c.events.$on(d,"keydown keyup change input",function(){c.opts.height?this.removeAttribute("rows"):(this.rows=1,0===this.value.length?this.style.height="auto":this.style.height="".concat(this.scrollHeight,"px"))}),c.events.$on(d,"blur",b),c.events.$on(d,"focus",E))),c.undo.saveStep(),c.html.cleanEmptyTags(),c.html.cleanWhiteTags(!0),c.core.hasFocus()&&(c.core.isEmpty()||(c.selection.save(),c.$el.find('.fr-marker[data-type="true"]').first().replaceWith('<span class="fr-tmp fr-sm">F</span>'),c.$el.find('.fr-marker[data-type="false"]').last().replaceWith('<span class="fr-tmp fr-em">F</span>')));var t=c.html.get(!1,!0);c.$el.find("span.fr-tmp").remove(),c.$box.toggleClass("fr-code-view",!0);var a,n,r=!1;if(c.core.hasFocus()&&(r=!0,c.events.disableBlur(),c.$el.blur()),t=(t=t.replace(/<span class="fr-tmp fr-sm">F<\/span>/,"FROALA-SM")).replace(/<span class="fr-tmp fr-em">F<\/span>/,"FROALA-EM"),c.codeBeautifier&&!t.includes("fr-embedly")&&(t=c.codeBeautifier.run(t,c.opts.codeBeautifierOptions)),f){a=t.indexOf("FROALA-SM"),(n=t.indexOf("FROALA-EM"))<a?a=n:n-=9;var i=(t=t.replace(/FROALA-SM/g,"").replace(/FROALA-EM/g,"")).substring(0,a).length-t.substring(0,a).replace(/\n/g,"").length,o=t.substring(0,n).length-t.substring(0,n).replace(/\n/g,"").length;a=t.substring(0,a).length-t.substring(0,t.substring(0,a).lastIndexOf("\n")+1).length,n=t.substring(0,n).length-t.substring(0,t.substring(0,n).lastIndexOf("\n")+1).length,f.setSize(null,c.opts.height?c.opts.height:"auto"),c.opts.heightMin&&c.$box.find(".CodeMirror-scroll").css("min-height",c.opts.heightMin),f.setValue(t),v=!r,f.focus(),v=!0,f.setSelection({line:i,ch:a},{line:o,ch:n}),f.refresh(),f.clearHistory()}else{a=t.indexOf("FROALA-SM"),n=t.indexOf("FROALA-EM")-9,c.opts.heightMin&&d.css("min-height",c.opts.heightMin),c.opts.height&&d.css("height",c.opts.height),c.opts.heightMax&&d.css("max-height",c.opts.height||c.opts.heightMax),d.val(t.replace(/FROALA-SM/g,"").replace(/FROALA-EM/g,"")).trigger("change");var s=p(c.o_doc).scrollTop();v=!r,d.focus(),v=!0,d.get(0).setSelectionRange(a,n),p(c.o_doc).scrollTop(s)}c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").not(e).filter(function(){return c.opts.codeViewKeepActiveButtons.indexOf(p(this).data("cmd"))<0}).addClass("fr-disabled").attr("aria-disabled",!0),e.addClass("fr-active").attr("aria-pressed",!0),!c.helpers.isMobile()&&c.opts.toolbarInline&&c.toolbar.hide()}function _(e){void 0===e&&(e=!u());var t=c.$tb.find('.fr-command[data-cmd="html"]');e?(c.popups.hideAll(),n(t)):(c.$box.toggleClass("fr-code-view",!1),function a(e){var t=g();c.html.set(t),c.$el.blur(),c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").not(e).removeClass("fr-disabled").attr("aria-disabled",!1),e.removeClass("fr-active").attr("aria-pressed",!1),c.selection.setAtStart(c.el),c.selection.restore(),c.placeholder.refresh(),c.undo.saveStep()}(t),c.events.trigger("codeView.update"))}function w(){u()&&_(!1),f&&f.toTextArea(),d.val("").removeData().remove(),d=null,m&&(m.remove(),m=null)}return{_init:function e(){if(c.events.on("focus",function(){c.opts.toolbarContainer&&function t(){var e=c.$tb.find('.fr-command[data-cmd="html"]');u()?(c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").not(e).filter(function(){return c.opts.codeViewKeepActiveButtons.indexOf(p(this).data("cmd"))<0}).addClass("fr-disabled").attr("aria-disabled",!1),e.addClass("fr-active").attr("aria-pressed",!1)):(c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").not(e).removeClass("fr-disabled").attr("aria-disabled",!1),e.removeClass("fr-active").attr("aria-pressed",!1))}()}),!c.$wp)return!1},toggle:_,isActive:u,get:g}},St.RegisterCommand("html",{title:"Code View",undo:!1,focus:!1,forcedRefresh:!0,toggle:!0,callback:function(){this.codeView.toggle()},plugin:"codeView"}),St.DefineIcon("html",{NAME:"code",SVG_KEY:"codeView"}),Object.assign(St.POPUP_TEMPLATES,{"textColor.picker":"[_BUTTONS_][_TEXT_COLORS_][_CUSTOM_COLOR_]","backgroundColor.picker":"[_BUTTONS_][_BACKGROUND_COLORS_][_CUSTOM_COLOR_]"}),Object.assign(St.DEFAULTS,{colorsText:["#61BD6D","#1ABC9C","#54ACD2","#2C82C9","#9365B8","#475577","#CCCCCC","#41A85F","#00A885","#3D8EB9","#2969B0","#553982","#28324E","#000000","#F7DA64","#FBA026","#EB6B56","#E25041","#A38F84","#EFEFEF","#FFFFFF","#FAC51C","#F37934","#D14841","#B8312F","#7C706B","#D1D5D8","REMOVE"],colorsBackground:["#61BD6D","#1ABC9C","#54ACD2","#2C82C9","#9365B8","#475577","#CCCCCC","#41A85F","#00A885","#3D8EB9","#2969B0","#553982","#28324E","#000000","#F7DA64","#FBA026","#EB6B56","#E25041","#A38F84","#EFEFEF","#FFFFFF","#FAC51C","#F37934","#D14841","#B8312F","#7C706B","#D1D5D8","REMOVE"],colorsStep:7,colorsHEXInput:!0,colorsButtons:["colorsBack","|","-"]}),St.PLUGINS.colors=function(m){var v=m.$,s='<div class="fr-color-hex-layer fr-active fr-layer" id="fr-color-hex-layer- \n  '.concat(m.id,'"><div class="fr-input-line"><input maxlength="7" id="[ID]"\n  type="text" placeholder="').concat(m.language.translate("HEX Color"),'" \n  tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button \n  type="button" class="fr-command fr-submit" data-cmd="[COMMAND]" tabIndex="2" role="button">\n  ').concat(m.language.translate("OK"),"</button></div></div>");function l(e){for(var t="text"===e?m.opts.colorsText:m.opts.colorsBackground,a='<div class="fr-color-set fr-'.concat(e,'-color fr-selected-set">'),n=0;n<t.length;n++)0!==n&&n%m.opts.colorsStep==0&&(a+="<br>"),"REMOVE"!==t[n]?a+='<span class="fr-command fr-select-color" style="background:'.concat(t[n],';" \n        tabIndex="-1" aria-selected="false" role="button" data-cmd="apply').concat(e,'Color" \n        data-param1="').concat(t[n],'"><span class="fr-sr-only"> ').concat(m.language.translate("Color")).concat(t[n]," \n        &nbsp;&nbsp;&nbsp;</span></span>"):a+='<span class="fr-command fr-select-color" data-cmd="apply'.concat(e,'Color"\n         tabIndex="-1" role="button" data-param1="REMOVE" \n         title="').concat(m.language.translate("Clear Formatting"),'">').concat(m.icon.create("remove"),' \n        <span class="fr-sr-only"> ').concat(m.language.translate("Clear Formatting")," </span></span>");return"".concat(a,"</div>")}function c(e){var t,a=m.popups.get("".concat(e,"Color.picker")),n=v(m.selection.element());t="background"===e?"background-color":"color";var r=a.find(".fr-".concat(e,"-color .fr-select-color"));for(r.find(".fr-selected-color").remove(),r.removeClass("fr-active-item"),r.not('[data-param1="REMOVE"]').attr("aria-selected",!1);n.get(0)!==m.el;){if("transparent"!==n.css(t)&&"rgba(0, 0, 0, 0)"!==n.css(t)){var i=a.find(".fr-".concat(e,'-color .fr-select-color[data-param1="').concat(m.helpers.RGBToHex(n.css(t)),'"]'));i.append('<span class="fr-selected-color" aria-hidden="true">\uf00c</span>'),i.addClass("fr-active-item").attr("aria-selected",!0);break}n=n.parent()}!function o(e){var t=m.popups.get("".concat(e,"Color.picker")),a=t.find(".fr-".concat(e,"-color .fr-active-item")).attr("data-param1"),n=t.find(".fr-color-hex-layer input");a||(a="");n.length&&v(n.val(a).input).trigger("change")}(e)}function n(e){"REMOVE"!==e?m.format.applyStyle("background-color",m.helpers.HEXtoRGB(e)):m.format.removeStyle("background-color"),m.popups.hide("backgroundColor.picker")}function r(e){"REMOVE"!==e?m.format.applyStyle("color",m.helpers.HEXtoRGB(e)):m.format.removeStyle("color"),m.popups.hide("textColor.picker")}return{showColorsPopup:function d(e){var t=m.$tb.find('.fr-command[data-cmd="'.concat(e,'"]')),a=m.popups.get("".concat(e,".picker"));if(a||(a=function o(e){var t="";m.opts.toolbarInline&&0<m.opts.colorsButtons.length&&(t+='<div class="fr-buttons fr-colors-buttons fr-tabs">\n        '.concat(m.button.buildList(m.opts.colorsButtons),"\n        </div>"));var a,n="";a="textColor"===e?(m.opts.colorsHEXInput&&(n=s.replace(/\[ID\]/g,"fr-color-hex-layer-text-".concat(m.id)).replace(/\[COMMAND\]/g,"customTextColor")),{buttons:t,text_colors:l("text"),custom_color:n}):(m.opts.colorsHEXInput&&(n=s.replace(/\[ID\]/g,"fr-color-hex-layer-background-".concat(m.id)).replace(/\[COMMAND\]/g,"customBackgroundColor")),{buttons:t,background_colors:l("background"),custom_color:n});var r=m.popups.create("".concat(e,".picker"),a);return function i(g,h){m.events.on("popup.tab",function(e){var t=v(e.currentTarget);if(!m.popups.isVisible(h)||!t.is("span"))return!0;var a=e.which,n=!0;if(St.KEYCODE.TAB===a){var r=g.find(".fr-buttons");n=!m.accessibility.focusToolbar(r,!!e.shiftKey)}else if(St.KEYCODE.ARROW_UP===a||St.KEYCODE.ARROW_DOWN===a||St.KEYCODE.ARROW_LEFT===a||St.KEYCODE.ARROW_RIGHT===a){if(t.is("span.fr-select-color")){var i=t.parent().find("span.fr-select-color"),o=i.index(t),s=m.opts.colorsStep,l=Math.floor(i.length/s),c=o%s,d=Math.floor(o/s),f=d*s+c,p=l*s;St.KEYCODE.ARROW_UP===a?f=((f-s)%p+p)%p:St.KEYCODE.ARROW_DOWN===a?f=(f+s)%p:St.KEYCODE.ARROW_LEFT===a?f=((f-1)%p+p)%p:St.KEYCODE.ARROW_RIGHT===a&&(f=(f+1)%p);var u=v(i.get(f));m.events.disableBlur(),u.focus(),n=!1}}else St.KEYCODE.ENTER===a&&(m.button.exec(t),n=!1);return!1===n&&(e.preventDefault(),e.stopPropagation()),n},!0)}(r,"".concat(e,".picker")),r}(e)),!a.hasClass("fr-active"))if(m.popups.setContainer("".concat(e,".picker"),m.$tb),c("textColor"===e?"text":"background"),t.isVisible()){var n=m.button.getPosition(t),r=n.left,i=n.top;m.popups.show("".concat(e,".picker"),r,i,t.outerHeight())}else m.position.forSelection(a),m.popups.show("".concat(e,".picker"))},background:n,customColor:function i(e){var t=m.popups.get("".concat(e,"Color.picker")).find(".fr-color-hex-layer input");if(t.length){var a=t.val();"background"===e?n(a):r(a)}},text:r,back:function e(){m.popups.hide("textColor.picker"),m.popups.hide("backgroundColor.picker"),m.toolbar.showInline()}}},St.DefineIcon("textColor",{NAME:"tint",SVG_KEY:"textColor"}),St.RegisterCommand("textColor",{title:"Text Color",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible("textColor.picker")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("textColor.picker")):this.colors.showColorsPopup("textColor")}}),St.RegisterCommand("applytextColor",{undo:!0,callback:function(e,t){this.colors.text(t)}}),St.RegisterCommand("customTextColor",{title:"OK",undo:!0,callback:function(){this.colors.customColor("text")}}),St.DefineIcon("backgroundColor",{NAME:"paint-brush",SVG_KEY:"backgroundColor"}),St.RegisterCommand("backgroundColor",{title:"Background Color",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible("backgroundColor.picker")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("backgroundColor.picker")):this.colors.showColorsPopup("backgroundColor")}}),St.RegisterCommand("applybackgroundColor",{undo:!0,callback:function(e,t){this.colors.background(t)}}),St.RegisterCommand("customBackgroundColor",{title:"OK",undo:!0,callback:function(){this.colors.customColor("background")}}),St.DefineIcon("colorsBack",{NAME:"arrow-left",SVG_KEY:"back"}),St.RegisterCommand("colorsBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.colors.back()}}),St.DefineIcon("remove",{NAME:"eraser",SVG_KEY:"remove"}),Object.assign(St.DEFAULTS,{dragInline:!0}),St.PLUGINS.draggable=function(d){var f=d.$;function e(e){return!(!e.originalEvent||!e.originalEvent.target||e.originalEvent.target.nodeType!==Node.TEXT_NODE)||(e.target&&"A"===e.target.tagName&&1===e.target.childNodes.length&&"IMG"===e.target.childNodes[0].tagName&&(e.target=e.target.childNodes[0]),f(e.target).hasClass("fr-draggable")?(d.undo.canDo()||d.undo.saveStep(),d.opts.dragInline?d.$el.attr("contenteditable",!0):d.$el.attr("contenteditable",!1),d.opts.toolbarInline&&d.toolbar.hide(),f(e.target).addClass("fr-dragging"),d.browser.msie||d.browser.edge||d.selection.clear(),void e.originalEvent.dataTransfer.setData("text","Froala")):(e.preventDefault(),!1))}var p,u=function u(e){return!(e&&("HTML"===e.tagName||"BODY"===e.tagName||d.node.isElement(e)))};function g(e,t,a){if(d.opts.iframe){var n=d.helpers.getPX(d.$wp.find(".fr-iframe").css("padding-top")),r=d.helpers.getPX(d.$wp.find(".fr-iframe").css("padding-left"));e+=d.$iframe.offset().top+n,t+=d.$iframe.offset().left+r}p.offset().top!==e&&p.css("top",e),p.offset().left!==t&&p.css("left",t),p.width()!==a&&p.css("width",a)}function t(e){e.originalEvent.dataTransfer.dropEffect="move",d.opts.dragInline?(!function a(){for(var e=null,t=0;t<St.INSTANCES.length;t++)if((e=St.INSTANCES[t].$el.find(".fr-dragging")).length)return e.get(0)}()||d.browser.msie||d.browser.edge)&&e.preventDefault():(e.preventDefault(),function c(e){var t=d.doc.elementFromPoint(e.originalEvent.pageX-d.win.pageXOffset,e.originalEvent.pageY-d.win.pageYOffset);if(!u(t)){for(var a=0,n=t;!u(n)&&n===t&&0<e.originalEvent.pageY-d.win.pageYOffset-a;)a++,n=d.doc.elementFromPoint(e.originalEvent.pageX-d.win.pageXOffset,e.originalEvent.pageY-d.win.pageYOffset-a);(!u(n)||p&&0===d.$el.find(n).length&&n!==p.get(0))&&(n=null);for(var r=0,i=t;!u(i)&&i===t&&e.originalEvent.pageY-d.win.pageYOffset+r<f(d.doc).height();)r++,i=d.doc.elementFromPoint(e.originalEvent.pageX-d.win.pageXOffset,e.originalEvent.pageY-d.win.pageYOffset+r);(!u(i)||p&&0===d.$el.find(i).length&&i!==p.get(0))&&(i=null),t=null===i&&n?n:i&&null===n?i:i&&n?a<r?n:i:null}if(f(t).hasClass("fr-drag-helper"))return!1;if(t&&!d.node.isBlock(t)&&(t=d.node.blockParent(t)),t&&0<=["TD","TH","TR","THEAD","TBODY"].indexOf(t.tagName)&&(t=f(t).parents("table").get(0)),t&&0<=["LI"].indexOf(t.tagName)&&(t=f(t).parents("UL, OL").get(0)),t&&!f(t).hasClass("fr-drag-helper")){var o;p||(St.$draggable_helper||(St.$draggable_helper=f(document.createElement("div")).attr("class","fr-drag-helper")),p=St.$draggable_helper,d.events.on("shared.destroy",function(){p.html("").removeData().remove(),p=null},!0)),o=e.originalEvent.pageY<f(t).offset().top+f(t).outerHeight()/2;var s=f(t),l=0;o||0!==s.next().length?(o||(s=s.next()),"before"===p.data("fr-position")&&s.is(p.data("fr-tag"))||(0<s.prev().length&&(l=parseFloat(s.prev().css("margin-bottom"))||0),l=Math.max(l,parseFloat(s.css("margin-top"))||0),g(s.offset().top-l/2-d.$box.offset().top,s.offset().left-d.win.pageXOffset-d.$box.offset().left,s.width()),p.data("fr-position","before"))):"after"===p.data("fr-position")&&s.is(p.data("fr-tag"))||(l=parseFloat(s.css("margin-bottom"))||0,g(s.offset().top+f(t).height()+l/2-d.$box.offset().top,s.offset().left-d.win.pageXOffset-d.$box.offset().left,s.width()),p.data("fr-position","after")),p.data("fr-tag",s),p.addClass("fr-visible"),d.$box.append(p)}else p&&0<d.$box.find(p).length&&p.removeClass("fr-visible")}(e))}function a(e){e.originalEvent.dataTransfer.dropEffect="move",d.opts.dragInline||e.preventDefault()}function n(e){d.$el.attr("contenteditable",!0);var t=d.$el.find(".fr-dragging");p&&p.hasClass("fr-visible")&&d.$box.find(p).length?r(e):t.length&&(e.preventDefault(),e.stopPropagation()),p&&d.$box.find(p).length&&p.removeClass("fr-visible"),t.removeClass("fr-dragging")}function r(e){var t,a;d.$el.attr("contenteditable",!0);for(var n=0;n<St.INSTANCES.length;n++)if((t=St.INSTANCES[n].$el.find(".fr-dragging")).length){a=St.INSTANCES[n];break}if(t.length){if(e.preventDefault(),e.stopPropagation(),p&&p.hasClass("fr-visible")&&d.$box.find(p).length)p.data("fr-tag")[p.data("fr-position")]('<span class="fr-marker"></span>'),p.removeClass("fr-visible");else if(!1===d.markers.insertAtPoint(e.originalEvent))return!1;if(t.removeClass("fr-dragging"),!1===(t=d.events.chainTrigger("element.beforeDrop",t)))return!1;var r=t;if(t.parent().is("A")&&1===t.parent().get(0).childNodes.length&&(r=t.parent()),d.core.isEmpty())d.events.focus();else d.$el.find(".fr-marker").replaceWith(St.MARKERS),d.selection.restore();if(a===d||d.undo.canDo()||d.undo.saveStep(),d.core.isEmpty())d.$el.html(r);else{var i=d.markers.insert();(d||"").selection&&r.contains(i)&&r.before(i),0===r.find(i).length?f(i).replaceWith(r):0===t.find(i).length&&f(i).replaceWith(t),t.after(St.MARKERS),d.selection.restore()}return d.popups.hideAll(),d.selection.save(),d.$el.find(d.html.emptyBlockTagsQuery()).not("TD, TH, LI, .fr-inner").not(d.opts.htmlAllowedEmptyTags.join(",")).remove(),d.html.wrap(),d.html.fillEmptyBlocks(),d.selection.restore(),d.undo.saveStep(),d.opts.iframe&&d.size.syncIframe(),a!==d&&(a.popups.hideAll(),a.$el.find(a.html.emptyBlockTagsQuery()).not("TD, TH, LI, .fr-inner").remove(),a.html.wrap(),a.html.fillEmptyBlocks(),a.undo.saveStep(),a.events.trigger("element.dropped"),a.opts.iframe&&a.size.syncIframe()),d.events.trigger("element.dropped",[r]),!1}p&&p.removeClass("fr-visible"),d.undo.canDo()||d.undo.saveStep(),setTimeout(function(){d.undo.saveStep()},0)}function i(e){if(e&&"DIV"===e.tagName&&d.node.hasClass(e,"fr-drag-helper"))e.parentNode.removeChild(e);else if(e&&e.nodeType===Node.ELEMENT_NODE)for(var t=e.querySelectorAll("div.fr-drag-helper"),a=0;a<t.length;a++)t[a].parentNode.removeChild(t[a])}return{_init:function o(){d.opts.enter===St.ENTER_BR&&(d.opts.dragInline=!0),d.events.on("dragstart",e,!0),d.events.on("dragover",t,!0),d.events.on("dragenter",a,!0),d.events.on("document.dragend",n,!0),d.events.on("document.drop",n,!0),d.events.on("drop",r,!0),d.events.on("html.processGet",i)}}},Object.assign(St.DEFAULTS,{editInPopup:!1}),St.MODULES.editInPopup=function(n){function e(){n.events.$on(n.$el,n._mouseup,function(){setTimeout(function(){!function a(){var e,t=n.popups.get("text.edit");e="INPUT"===n.el.tagName?n.$el.attr("placeholder"):n.$el.text(),t.find("input").val(e).trigger("change"),n.popups.setContainer("text.edit",n.$sc),n.popups.show("text.edit",n.$el.offset().left+n.$el.outerWidth()/2,n.$el.offset().top+n.$el.outerHeight(),n.$el.outerHeight())}()},10)})}return{_init:function a(){n.opts.editInPopup&&(!function t(){var e={edit:'<div id="fr-text-edit-'.concat(n.id,'" class="fr-layer fr-text-edit-layer"><div class="fr-input-line"><input type="text" placeholder="').concat(n.language.translate("Text"),'" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="updateText" tabIndex="2">').concat(n.language.translate("Update"),"</button></div></div>")};n.popups.create("text.edit",e)}(),e())},update:function t(){var e=n.popups.get("text.edit").find("input").val();0===e.length&&(e=n.opts.placeholderText),"INPUT"===n.el.tagName?n.$el.attr("placeholder",e):n.$el.text(e),n.events.trigger("contentChanged"),n.popups.hide("text.edit")}}},St.RegisterCommand("updateText",{focus:!1,undo:!1,callback:function(){this.editInPopup.update()}}),Object.assign(St.POPUP_TEMPLATES,{emoticons:"[_BUTTONS_][_CUSTOM_LAYER_]"}),Object.assign(St.DEFAULTS,{emoticonsSet:[{id:"people",name:"Smileys & People",code:"1f600",emoticons:[{code:"1f600",desc:"Grinning face"},{code:"1f601",desc:"Grinning Face with Smiling Eyes"},{code:"1f602",desc:"Face with Tears of Joy"},{code:"1f603",desc:"Smiling Face with Open Mouth"},{code:"1f604",desc:"Smiling Face with Open Mouth and Smiling Eyes"},{code:"1f605",desc:"Smiling Face with Open Mouth and Cold Sweat"},{code:"1f606",desc:"Smiling Face with Open Mouth and Tightly-Closed Eyes"},{code:"1f609",desc:"Winking Face"},{code:"1f60a",desc:"Smiling Face with Smiling Eyes"},{code:"1f608",desc:"Face Savouring Delicious Food"},{code:"1f60e",desc:"Smiling Face with Sunglasses"},{code:"1f60d",desc:"Smiling Face with Heart-Shaped Eyes"},{code:"1f618",desc:"Face Throwing a Kiss"},{code:"1f617",desc:"Kissing Face"},{code:"1f619",desc:"Kissing Face with Smiling Eyes"},{code:"1f61a",desc:"Kissing Face with Closed Eyes"},{code:"263a",desc:"White Smiling Face"},{code:"1f642",desc:"Slightly Smiling Face"},{code:"1f610",desc:"Neutral Face"},{code:"1f611",desc:"Expressionless Face"},{code:"1f636",desc:"Face Without Mouth"},{code:"1f60f",desc:"Smirking Face"},{code:"1f623",desc:"Persevering Face"},{code:"1f625",desc:"Disappointed but Relieved Face"},{code:"1f62e",desc:"Face with Open Mouth"},{code:"1f62f",desc:"Hushed Face"},{code:"1f62a",desc:"Sleepy Face"},{code:"1f62b",desc:"Tired Face"},{code:"1f634",desc:"Sleeping Face"},{code:"1f60c",desc:"Relieved Face"},{code:"1f61b",desc:"Face with Stuck-out Tongue"},{code:"1f61c",desc:"Face with Stuck-out Tongue and Winking Eye"},{code:"1f61d",desc:"Face with Stuck-out Tongue and Tightly-Closed Eyes"},{code:"1f612",desc:"Unamused Face"},{code:"1f613",desc:"Face with Cold Sweat"},{code:"1f613",desc:"Face with Cold Sweat"},{code:"1f614",desc:"Pensive Face"},{code:"1f615",desc:"Confused Face"},{code:"1f632",desc:"Astonished  Face"},{code:"1f616",desc:"Confounded Face"},{code:"1f61e",desc:"Disappointed Face"},{code:"1f61f",desc:"Worried Face"},{code:"1f624",desc:"Face with Look of Triumph"},{code:"1f622",desc:"Crying Face"},{code:"1f62d",desc:"Loudly Crying Face"},{code:"1f626",desc:"Frowning Face with Open Mouth"},{code:"1f627",desc:"Anguished Face"},{code:"1f628",desc:"Fearful Face"},{code:"1f629",desc:"Weary Face"},{code:"1f62c",desc:"Grimacing Face"},{code:"1f630",desc:"Face with Open Mouth and Cold Sweat"},{code:"1f631",desc:"Face Screaming in Fear"},{code:"1f633",desc:"Flushed Face"},{code:"1f635",desc:"Dizzy Face"},{code:"1f621",desc:"Pouting Face"},{code:"1f620",desc:"Angry Face"},{code:"1f637",desc:"Face with Medical Mask"},{code:"1f607",desc:"Smiling Face with Halo"},{code:"1f608",desc:"Smiling Face with Horns"},{code:"1f47f",desc:"Imp"},{code:"1f479",desc:"Japanese Ogre"},{code:"1f47a",desc:"Japanese Goblin"},{code:"1f480",desc:"Skull"},{code:"1f47b",desc:"Ghost"},{code:"1f47d",desc:"Extraterrestrial Alien"},{code:"1f47e",desc:"Alien Monster"},{code:"1f4a9",desc:"Pile of Poo"},{code:"1f63a",desc:"Smiling Cat Face with Open Mouth"},{code:"1f638",desc:"Grinning Cat Face with Smiling Eyes"},{code:"1f639",desc:"Cat Face with Tears of Joy"},{code:"1f63b",desc:"Smiling Cat Face with Heart-Shaped Eyes"},{code:"1f63c",desc:"Cat Face with Wry Smile"},{code:"1f63d",desc:"Kissing Cat Face with Closed Eyes"},{code:"1f640",desc:"Weary Cat Face"},{code:"1f63f",desc:"Crying Cat Face"},{code:"1f63e",desc:"Pouting Cat Face"},{code:"1f648",desc:"See-No-Evil Monkey"},{code:"1f649",desc:"Hear-No-Evil Monkey"},{code:"1f64a",desc:"Speak-No-Evil Monkey"},{code:"1f476",desc:"Baby"},{code:"1f466",desc:"Boy"},{code:"1f467",desc:"Girl"},{code:"1f468",desc:"Man"},{code:"1f469",desc:"Woman"},{code:"1f474",desc:"Older Man"},{code:"1f475",desc:"Older Woman"},{code:"1f46e",desc:"Police Officer"},{code:"1f482",desc:" Guardsman"},{code:"1f477",desc:" Construction Worker"},{code:"1f478",desc:"Princess"},{code:"1f473",desc:"Man with Turban"},{code:"1f472",desc:"Man with Gua Pi Mao"},{code:"1f471",desc:"Person with Blond Hair"},{code:"1f470",desc:"Bride with Veil"},{code:"1f47c",desc:"Baby Angel"},{code:"1f385",desc:"Father Christmas"},{code:"1f64e",desc:"Person with Pouting Face"},{code:"1f645",desc:"Face with No Good Gesture"},{code:"1f646",desc:"Face with Ok Gesture"},{code:"1f481",desc:"Information Desk Person"},{code:"1f64b",desc:"Happy Person Raising One Hand"},{code:"1f647",desc:"Person Bowing Deeply"},{code:"1f486",desc:"Face Massage"},{code:"1f487",desc:"Haircut"},{code:"1f6b6",desc:"Pedestrian"},{code:"1f3c3",desc:"Runner"},{code:"1f483",desc:"Dancer"},{code:"1f46f",desc:"Woman with Bunny Ears"},{code:"1f6c0",desc:"Bath"},{code:"1f464",desc:"Bust in Silhouette"},{code:"1f465",desc:"Busts in Silhouette"},{code:"1f3c7",desc:"Horse Racing"},{code:"1f3c2",desc:" Snowboarder"},{code:"1f3c4",desc:" Surfer"},{code:"1f6a3",desc:" Rowboat"},{code:"1f3ca",desc:" Swimmer"},{code:"1f6b4",desc:" Bicyclist"},{code:"1f6b5",desc:"Mountain Bicyclist"},{code:"1f46b",desc:" Man and Woman Holding Hands"},{code:"1f46c",desc:"Two Men Holding Hands"},{code:"1f46d",desc:"Two Women Holding Hands"},{code:"1f48f",desc:"Kiss"},{code:"1f468-2764-1f48b-1f468",uCode:"\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68",desc:"Man Kiss Man"},{code:"1f469-2764-1f48b-1f469",uCode:"\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc69",desc:"Woman Kiss Woman"},{code:"1f491",desc:"Couple with Heart"},{code:"1f468-2764-1f468",uCode:"\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68",desc:"Man Heart Man"},{code:"1f469-2764-1f469",uCode:"\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc69",desc:"Woman Heart Woman"},{code:"1f46a",desc:"Family"},{code:"1f468",desc:"Man Woman Boy"},{code:"1f468-1f469-1f467",desc:"Man Woman Girl"},{code:"1f468-1f469-1f467-1f466",desc:"Man Woman Girl Boy"},{code:"1f468-1f469-1f466-1f466",desc:"Man Woman Boy Boy"},{code:"1f468-1f469-1f467-1f467",desc:"Man Woman Girl Girl"},{code:"1f468-1f468-1f466",desc:"Man Man Boy"},{code:"1f468-1f468-1f467",desc:"Man Man Girl"},{code:"1f468-1f468-1f467-1f466",desc:"Man Man Girl Boy"},{code:"1f468-1f468-1f466-1f466",desc:"Man Man Boy Boy"},{code:"1f469-1f469-1f466",desc:"Woman Woman Boy"},{code:"1f469-1f469-1f467",desc:"Woman Woman Girl"},{code:"1f469-1f469-1f467-1f466",desc:"Woman Woman Girl Boy"},{code:"1f469-1f469-1f467-1f467",desc:"Woman Woman Girl Girl"},{code:"1f4aa",desc:"Flexed Biceps"},{code:"1f448",desc:"White Left Pointing Backhand Index"},{code:"1f449",desc:"White Right Pointing Backhand Index"},{code:"1f446",desc:"White Up Pointing Backhand Index"},{code:"1f447",desc:"White Down Pointing Backhand Index"},{code:"270c",desc:"Victory Hand"},{code:"270b",desc:"Raised Hand"},{code:"1f44c",desc:"Ok Hand Sign"},{code:"1f44d",desc:"Thumbs Up Sign"},{code:"1f44e",desc:"Thumbs Down Sign"},{code:"270a",desc:"Raised Fist"},{code:"1f44a",desc:"Fisted Hand Sign"},{code:"1f44b",desc:"Waving Hand Sign"},{code:"1f44f",desc:"Clapping Hands Sign"},{code:"1f450",desc:"Open  Hands Sign"},{code:"1f64c",desc:"Person Raising Both Hands in Celebration"},{code:"1f64f",desc:"Person with Folded Hands"},{code:"1f485",desc:"Nail Polish"},{code:"1f442",desc:"Ear"},{code:"1f443",desc:"Nose"},{code:"1f463",desc:"Footprints"},{code:"1f440",desc:"Eyes"},{code:"1f445",desc:"Tongue"},{code:"1f444",desc:"Mouth"},{code:"1f48b",desc:"Kiss Mark"},{code:"1f498",desc:"Heart with Arrow"},{code:"2764",desc:"Heavy Black Heart"},{code:"1f493",desc:"Heavy Black Heart"},{code:"1f494",desc:"Broken Heart"},{code:"1f495",desc:"Two Hearts"},{code:"1f496",desc:"Sparkling Hearts"},{code:"1f497",desc:"Growing Hearts"},{code:"1f499",desc:"Blue Heart"},{code:"1f49a",desc:"Green Heart"},{code:"1f49b",desc:"Yellow Heart"},{code:"1f49c",desc:"Purple Heart"},{code:"1f49d",desc:"Heart with Ribbon"},{code:"1f49e",desc:"Revolving Hearts"},{code:"1f49f",desc:"Heart Decoration"},{code:"1f48c",desc:"Love Letter"},{code:"1f4a4",desc:"Sleeping Symbol"},{code:"1f4a2",desc:"Anger Symbol"},{code:"1f4a3",desc:"Bomb"},{code:"1f4a5",desc:"Collision Symbol"},{code:"1f4a6",desc:"Splashing Sweat Symbol"},{code:"1f4a8",desc:"Dash Symbol"},{code:"1f4ab",desc:"Dizzy Symbol"},{code:"1f4ab",desc:"Dizzy Symbol"},{code:"1f4ac",desc:"Speech Balloon"},{code:"1f4ad",desc:"Thought Balloon"},{code:"1f453",desc:"Eyeglasses"},{code:"1f454",desc:"Necktie"},{code:"1f455",desc:"T-Shirt"},{code:"1f456",desc:"Jeans"},{code:"1f457",desc:"Dress"},{code:"1f458",desc:"Kimono"},{code:"1f459",desc:"Bikini"},{code:"1f45a",desc:"Womans Clothes"},{code:"1f45b",desc:"Purse"},{code:"1f45c",desc:"Handbag"},{code:"1f45d",desc:"Pouch"},{code:"1f392",desc:"School Satchel"},{code:"1f45e",desc:"Mans Shoe"},{code:"1f45f",desc:"Athletic Shoe"},{code:"1f460",desc:"High-Heeled Shoe"},{code:"1f461",desc:"Womans Sandal"},{code:"1f462",desc:"Womans Boots"},{code:"1f451",desc:"Crown"},{code:"1f452",desc:"Womans Hat"},{code:"1f462",desc:"Top Hat"},{code:"1f393",desc:"Graduation Cap"},{code:"1f484",desc:"Lipstick"},{code:"1f48d",desc:"Ring"},{code:"1f48e",desc:"Gem Stone"}]},{id:"nature",name:"Animals & Nature",code:"1F435",emoticons:[{code:"1F435",desc:"Monkey Face"},{code:"1F412",desc:"Monkey"},{code:"1F436",desc:"Dog Face"},{code:"1F415",desc:"Dog"},{code:"1F429",desc:"Poodle"},{code:"1F43A",desc:"Wolf Face"},{code:"1F431",desc:"Cat Face"},{code:"1F408",desc:"Cat"},{code:"1F42F",desc:"Tiger Face"},{code:"1F405",desc:"Tiger"},{code:"1F406",desc:"Leopard"},{code:"1F434",desc:"Horse Face"},{code:"1F40E",desc:"Horse"},{code:"1F42E",desc:"Cow Face"},{code:"1F402",desc:"Ox"},{code:"1F403",desc:"Water Buffalo"},{code:"1F404",desc:"Cow"},{code:"1F437",desc:"Pig Face"},{code:"1F416",desc:"Pig"},{code:"1F417",desc:"Boar"},{code:"1F43D",desc:"Pig Nose"},{code:"1F40F",desc:"Ram"},{code:"1F411",desc:"Sheep"},{code:"1F410",desc:"Goat"},{code:"1F42A",desc:"Dromedary Camel"},{code:"1F42B",desc:"Bactrian Camel"},{code:"1F418",desc:"Elephant"},{code:"1F42D",desc:"Mouse Face"},{code:"1F401",desc:"Mouse"},{code:"1F400",desc:"Rat"},{code:"1F439",desc:"Hamster Face"},{code:"1F430",desc:"Rabbit Face"},{code:"1F407",desc:"Rabbit"},{code:"1F43B",desc:"Bear Face"},{code:"1F428",desc:"Koala"},{code:"1F43C",desc:"Panda Face"},{code:"1F43E",desc:"Paw Prints"},{code:"1F414",desc:"Chicken"},{code:"1F413",desc:"Rooster"},{code:"1F423",desc:"Hatching Chick"},{code:"1F424",desc:"Baby Chick"},{code:"1F425",desc:"Front-Facing Baby Chick"},{code:"1F426",desc:"Bird"},{code:"1F427",desc:"Penguin"},{code:"1F438",desc:"Frog Face"},{code:"1F40A",desc:"Crocodile"},{code:"1F422",desc:"Turtle"},{code:"1F40D",desc:"Snake"},{code:"1F432",desc:"Dragon Face"},{code:"1F409",desc:"Dragon"},{code:"1F433",desc:"Spouting Whale"},{code:"1F40B",desc:"Whale"},{code:"1F42C",desc:"Dolphin"},{code:"1F41F",desc:"Fish"},{code:"1F420",desc:"Tropical Fish"},{code:"1F421",desc:"Blowfish"},{code:"1F419",desc:"Octopus"},{code:"1F41A",desc:"Spiral Shell"},{code:"1F40C",desc:"Snail"},{code:"1F41B",desc:"Bug"},{code:"1F41C",desc:"Ant"},{code:"1F41D",desc:"Honeybee"},{code:"1F41E",desc:"Lady Beetle"},{code:"1F490",desc:"Bouquet"},{code:"1F338",desc:"Cherry Blossom"},{code:"1F4AE",desc:"White Flower"},{code:"1F339",desc:"Rose"},{code:"1F33A",desc:"Hibiscus"},{code:"1F33B",desc:"Sunflower"},{code:"1F33C",desc:"Blossom"},{code:"1F337",desc:"Tulip"},{code:"1F331",desc:"Seedling"},{code:"1F332",desc:"Evergreen Tree"},{code:"1F333",desc:"Deciduous Tree"},{code:"1F334",desc:"Palm Tree"},{code:"1F335",desc:"Cactus"},{code:"1F33E",desc:"Ear of Rice"},{code:"1F33F",desc:"Herb"},{code:"2618",desc:"Four Leaf Clover"},{code:"1F341",desc:"Maple Leaf"},{code:"1F342",desc:"Fallen Leaf"},{code:"1F343",desc:"Leaf Fluttering in Wind"}]},{id:"foods",name:"Food & Drink",code:"1F347",emoticons:[{code:"1F347",desc:"Grapes"},{code:"1F348",desc:"Melon"},{code:"1F349",desc:"Watermelon"},{code:"1F34A",desc:"Tangerine"},{code:"1F34B",desc:"Lemon"},{code:"1F34C",desc:"Banana"},{code:"1F34D",desc:"Pineapple"},{code:"1F34E",desc:"Red Apple"},{code:"1F34F",desc:"Green Apple"},{code:"1F350",desc:"Pear"},{code:"1F351",desc:"Peach"},{code:"1F352",desc:"Cherries"},{code:"1F353",desc:"Strawberry"},{code:"1F345",desc:"Tomato"},{code:"1F346",desc:"Aubergine"},{code:"1F33D",desc:"Ear of Maize"},{code:"1F344",desc:"Mushroom"},{code:"1F330",desc:"Chestnut"},{code:"1F35E",desc:"Bread"},{code:"1F356",desc:"Meat on Bone"},{code:"1F357",desc:"Poultry Leg"},{code:"1F354",desc:"Hamburger"},{code:"1F35F",desc:"French Fries"},{code:"1F355",desc:"Slice of Pizza"},{code:"1F373",desc:"Cooking"},{code:"1F372",desc:"Pot of Food"},{code:"1F371",desc:"Bento Box"},{code:"1F358",desc:"Rice Cracker"},{code:"1F359",desc:"Rice Ball"},{code:"1F35A",desc:"Cooked Rice"},{code:"1F35B",desc:"Curry and Rice"},{code:"1F35C",desc:"Steaming Bowl"},{code:"1F35D",desc:"Spaghetti"},{code:"1F360",desc:"Roasted Sweet Potato"},{code:"1F362",desc:"Oden"},{code:"1F363",desc:"Sushi"},{code:"1F364",desc:"Fried Shrimp"},{code:"1F365",desc:"Fish Cake with Swirl Design"},{code:"1F361",desc:"Dango"},{code:"1F366",desc:"Soft Ice Cream"},{code:"1F367",desc:"Shaved Ice"},{code:"1F368",desc:"Ice Cream"},{code:"1F369",desc:"Doughnut"},{code:"1F36A",desc:"Cookie"},{code:"1F382",desc:"Birthday Cake"},{code:"1F370",desc:"Shortcake"},{code:"1F36B",desc:"Chocolate Bar"},{code:"1F36C",desc:"Candy"},{code:"1F36D",desc:"Lollipop"},{code:"1F36E",desc:"Custard"},{code:"1F36F",desc:"Honey Pot"},{code:"1F37C",desc:"Baby Bottle"},{code:"2615",desc:"Hot Beverage"},{code:"1F375",desc:"Teacup Without Handle"},{code:"1F376",desc:"Sake Bottle and Cup"},{code:"1F377",desc:"Wine Glass"},{code:"1F378",desc:"Cocktail Glass"},{code:"1F379",desc:"Tropical Drink"},{code:"1F37A",desc:"Beer Mug"},{code:"1F37B",desc:"Clinking Beer Mugs"},{code:"1F374",desc:"Fork and Knife"},{code:"1F52A",desc:"Hocho"}]},{id:"activity",name:"Activities",code:"1f383",emoticons:[{code:"1f383",desc:" Jack-O-Lantern"},{code:"1f384",desc:"Christmas Tree"},{code:"1f386",desc:" Fireworks"},{code:"1f387",desc:"Firework Sparkler"},{code:"2728",desc:" Sparkles"},{code:"1f388",desc:"Balloon"},{code:"1f389",desc:"Party Popper"},{code:"1f38a",desc:"Confetti Ball"},{code:"1f38b",desc:"Tanabata Tree"},{code:"1f38d",desc:"Pine Decoration"},{code:"1f38e",desc:"Japanese Dolls"},{code:"1f38f",desc:"Carp Streamer"},{code:"1f390",desc:"Wind Chime"},{code:"1f391",desc:"Moon Viewing Ceremony"},{code:"1f380",desc:"Ribbon"},{code:"1f381",desc:"Wrapped Present"},{code:"1f3ab",desc:"Ticket"},{code:"1f3c6",desc:"Trophy"},{code:"1f388",desc:"Balloon"},{code:"26bd",desc:"Soccer Ball"},{code:"26be",desc:"Baseball"},{code:"1f3c0",desc:"Basketball and Hoop"},{code:"1f3c8",desc:"American Football"},{code:"1f3c9",desc:"Rugby Football"},{code:"1f3be",desc:"Tennis Racquet and Ball"},{code:"1f3b1",desc:"Billiards"},{code:"1f3b3",desc:"Bowling"},{code:"1f3af",desc:"Direct Hit"},{code:"26f3",desc:"Flag in Hole"},{code:"1f3a3",desc:"Fishing Pole and Fish"},{code:"1f3bd",desc:"Running Shirt with Sash"},{code:"1f3bf",desc:"Ski and Ski Boot"},{code:"1f3ae",desc:"Video Game"},{code:"1f3b2",desc:"Game Die"},{code:"2660",desc:"Black Spade Suit"},{code:"2665",desc:"Black Heart SuiT"},{code:"2666",desc:"Black Diamond Suit"},{code:"2663",desc:"Black Club Suit"},{code:"1f0cf",desc:"Playing Card Black Joker"},{code:"1f004",desc:"Mahjong Tile Red Dragon"},{code:"1f3b4",desc:"Flower Playing Cards"}]},{id:"places",name:"Travel & Places",code:"1f30d",emoticons:[{code:"1f30d",desc:"Earth Globe Europe-Africa"},{code:"1f30e",desc:"Earth Globe Americas"},{code:"1f30f",desc:"Earth Globe Asia-Australia"},{code:"1f310",desc:"Globe with Meridians"},{code:"1f5fe",desc:"Silhouette of Japan"},{code:"1f30b",desc:"Volcano"},{code:"1f5fb",desc:"Mount Fuji"},{code:"1f3e0",desc:"House Building"},{code:"1f3e1",desc:"House with Garden"},{code:"1f3e2",desc:"Office Building"},{code:"1f3e3",desc:"Japanese Post Office"},{code:"1f3e4",desc:"European Post Office"},{code:"1f3e5",desc:"Hospital"},{code:"1f3e6",desc:"Bank"},{code:"1f3e8",desc:"Hotel"},{code:"1f3e9",desc:"Love Hotel"},{code:"1f3ea",desc:"Convenience Store"},{code:"1f3eb",desc:"School"},{code:"1f3ec",desc:"Department Store"},{code:"1f3ed",desc:"Factory"},{code:"1f3ef",desc:"Japanese Castle"},{code:"1f3f0",desc:"European Castle"},{code:"1f492",desc:"Wedding"},{code:"1f5fc",desc:"Tokyo Tower"},{code:"1f5fd",desc:"Statue of Liberty"},{code:"26ea",desc:"Church"},{code:"26f2",desc:"Fountain"},{code:"26fa",desc:"Tent"},{code:"1f301",desc:"Foggy"},{code:"1f303",desc:"Night with Stars"},{code:"1f304",desc:"Sunrise over Mountains"},{code:"1f305",desc:"Sunrise"},{code:"1f306",desc:"Cityscape at Dusk"},{code:"1f307",desc:"Sunset over Buildings"},{code:"1f309",desc:"Bridge at Night"},{code:"2668",desc:"Hot Springs"},{code:"1f30c",desc:"Milky Way"},{code:"1f3a0",desc:"Carousel Horse"},{code:"1f3a1",desc:"Ferris Wheel"},{code:"1f3a2",desc:"Roller Coaster"},{code:"1f488",desc:"Barber Pole"},{code:"1f3aa",desc:"Circus Tent"},{code:"1f3ad",desc:"Performing Arts"},{code:"1f3a8",desc:"Artist Palette"},{code:"1f3b0",desc:"Slot Machine"},{code:"1f682",desc:"Steam Locomotive"},{code:"1f683",desc:"Railway Car"},{code:"1f684",desc:"High-Speed Train"},{code:"1f685",desc:"High-Speed Train with Bullet Nose"},{code:"1f686",desc:"Train"},{code:"1f687",desc:"Metro"},{code:"1f688",desc:"Light Rail"},{code:"1f689",desc:"Station"},{code:"1f68a",desc:"Tram"},{code:"1f69d",desc:"Monorail"},{code:"1f69e",desc:"Mountain Railway"},{code:"1f68b",desc:"Tram Car"},{code:"1f68c",desc:"Bus"},{code:"1f68d",desc:"Oncoming Bus"},{code:"1f68e",desc:"Trolleybus"},{code:"1f690",desc:"Minibus"},{code:"1f691",desc:"Ambulance"},{code:"1f692",desc:"Fire Engine"},{code:"1f693",desc:"Police Car"},{code:"1f694",desc:"Oncoming Police Car"},{code:"1f695",desc:"Taxi"},{code:"1f695",desc:"Oncoming Taxi"},{code:"1f697",desc:"Automobile"},{code:"1f698",desc:"Oncoming Automobile"},{code:"1f699",desc:"Recreational Vehicle"},{code:"1f69a",desc:"Delivery Truck"},{code:"1f69b",desc:"Articulated Lorry"},{code:"1f69c",desc:"Tractor"},{code:"1f6b2",desc:"Bicycle"},{code:"1f68f",desc:"Bus Stop"},{code:"26fd",desc:"Fuel Pump"},{code:"1f6a8",desc:"Police Cars Revolving Light"},{code:"1f6a5",desc:"Horizontal Traffic Light"},{code:"1f6a6",desc:"Vertical Traffic Light"},{code:"1f6a7",desc:"Construction Sign"},{code:"2693",desc:"Anchor"},{code:"26f5",desc:"Sailboat"},{code:"1f6a4",desc:"Speedboat"},{code:"1f6a2",desc:"Ship"},{code:"2708",desc:"Airplane"},{code:"1f4ba",desc:"Seat"},{code:"1f681",desc:"Helicopter"},{code:"1f69f",desc:"Suspension Railway"},{code:"1f6a0",desc:"Mountain Cableway"},{code:"1f6a1",desc:"Aerial Tramway"},{code:"1f680",desc:"Rocket"},{code:"1f6aa",desc:"Door"},{code:"1f6bd",desc:"Toilet"},{code:"1f6bf",desc:"Shower"},{code:"1f6c1",desc:"Bathtub"},{code:"231b",desc:"Hourglass"},{code:"23f3",desc:"Hourglass with Flowing Sand"},{code:"231a",desc:"Watch"},{code:"23f0",desc:"Alarm Clock"},{code:"1f55b",desc:"Clock Face Twelve Oclock"},{code:"1f567",desc:"Clock Face Twelve-Thirty"},{code:"1f550",desc:"Clock Face One Oclock"},{code:"1f55c",desc:"Clock Face One-thirty"},{code:"1f551",desc:"Clock Face Two Oclock"},{code:"1f55d",desc:"Clock Face Two-thirty"},{code:"1f552",desc:"Clock Face Three Oclock"},{code:"1f55e",desc:"Clock Face Three-thirty"},{code:"1f553",desc:"Clock Face Four Oclock"},{code:"1f55f",desc:"Clock Face Four-thirty"},{code:"1f554",desc:"Clock Face Five Oclock"},{code:"1f560",desc:"Clock Face Five-thirty"},{code:"1f555",desc:"Clock Face Six Oclock"},{code:"1f561",desc:"Clock Face Six-thirty"},{code:"1f556",desc:"Clock Face Seven Oclock"},{code:"1f562",desc:"Clock Face Seven-thirty"},{code:"1f557",desc:"Clock Face Eight Oclock"},{code:"1f563",desc:"Clock Face Eight-thirty"},{code:"1f558",desc:"Clock Face Nine Oclock"},{code:"1f564",desc:"Clock Face Nine-thirty"},{code:"1f559",desc:"Clock Face Ten Oclock"},{code:"1f565",desc:"Clock Face Ten-thirty"},{code:"1f55a",desc:"Clock Face Eleven Oclock"},{code:"1f566",desc:"Clock Face Eleven-thirty"},{code:"1f311",desc:"New Moon Symbol"},{code:"1f312",desc:"Waxing Crescent Moon Symbol"},{code:"1f313",desc:"First Quarter Moon Symbol"},{code:"1f314",desc:"Waxing Gibbous Moon Symbol"},{code:"1f315",desc:"Full Moon Symbol"},{code:"1f316",desc:"Waning Gibbous Moon Symbol"},{code:"1f317",desc:"Last Quarter Moon Symbol"},{code:"1f318",desc:"Waning Crescent Moon Symbol"},{code:"1f319",desc:"Crescent Moon"},{code:"1f31a",desc:"New Moon with Face"},{code:"1f31b",desc:"First Quarter Moon with Face"},{code:"1f31c",desc:"Last Quarter Moon with Face"},{code:"2600",desc:"Black Sun with Rays"},{code:"1f31d",desc:"Full Moon with Face"},{code:"1f31e",desc:"Sun with Face"},{code:"2b50",desc:"White Medium Star"},{code:"1f31f",desc:"Glowing Star"},{code:"1f320",desc:"Shooting Star"},{code:"2601",desc:"Cloud"},{code:"26c5",desc:"Sun Behind Cloud"},{code:"1f300",desc:"Cyclone"},{code:"1f308",desc:"Rainbow"},{code:"1f302",desc:"Closed Umbrella"},{code:"2614",desc:"Umbrella with Rain Drops"},{code:"26a1",desc:"High Voltage Sign"},{code:"2744",desc:"Snowflake"},{code:"2603",desc:"Snowman Without Snow"},{code:"1f525",desc:"Fire"},{code:"1f4a7",desc:"Droplet"},{code:"1F30A",desc:"Water Wave"}]},{id:"objects",name:"Objects",code:"1F507",emoticons:[{code:"1F507",desc:"Speaker with Cancellation Stroke"},{code:"1F508",desc:"Speaker"},{code:"1F509",desc:"Speaker with One Sound Wave"},{code:"1F50A",desc:"Speaker with Three Sound Wave"},{code:"1F4E2",desc:"Public Address Loudspeaker"},{code:"1F4E3",desc:"Cheering Megaphone"},{code:"1F4EF",desc:"Postal Horn"},{code:"1F514",desc:"Bell"},{code:"1F515",desc:"Bell with Cancellation Stroke"},{code:"1F3BC",desc:"Musical Score"},{code:"1F3B5",desc:"Musical Note"},{code:"1F3B6",desc:"Multiple Musical Notes"},{code:"1F3A4",desc:"Microphone"},{code:"1F3A7",desc:"Headphone"},{code:"1F4FB",desc:"Radio"},{code:"1F3B7",desc:"Saxophone"},{code:"1F3B8",desc:"Guitar"},{code:"1F3B9",desc:"Musical Keyboard"},{code:"1F3BA",desc:"Trumpet"},{code:"1F3BB",desc:"Violin"},{code:"1F4F1",desc:"Mobile Phone"},{code:"1F4F2",desc:"Mobile Phone with Rightwards Arrow at Left"},{code:"260E",desc:"Black Telephone"},{code:"1F4DE",desc:"Telephone Receiver"},{code:"1F4DF",desc:"Pager"},{code:"1F4E0",desc:"Fax Machine"},{code:"1F50B",desc:"Battery"},{code:"1F50C",desc:"Electric Plug"},{code:"1F4BB",desc:"Personal Computer"},{code:"1F4BD",desc:"Minidisc"},{code:"1F4BE",desc:"Floppy Disk"},{code:"1F4BF",desc:"Optical Disk"},{code:"1F4C0",desc:"Dvd"},{code:"1F3A5",desc:"Movie Camera"},{code:"1F3AC",desc:"Clapper Board"},{code:"1F4FA",desc:"Television"},{code:"1F4F7",desc:"Camera"},{code:"1F4F9",desc:"Video Camera"},{code:"1F4FC",desc:"Videocassette"},{code:"1F50D",desc:"Left-Pointing Magnifying Glass"},{code:"1F50E",desc:"Right-Pointing Magnifying Glass"},{code:"1F52C",desc:"Microscope"},{code:"1F52D",desc:"Telelscope"},{code:"1F4E1",desc:"Satellite Antenna"},{code:"1F4A1",desc:"Electric Light Bulb"},{code:"1F526",desc:"Electric Torch"},{code:"1F3EE",desc:"Izakaya Lantern"},{code:"1F4D4",desc:"Notebook with Decorative Cover"},{code:"1F4D5",desc:"Closed Book"},{code:"1F4D6",desc:"Open Book"},{code:"1F4D7",desc:"Green Book"},{code:"1F4D8",desc:"Blue Book"},{code:"1F4D9",desc:"Orange Book"},{code:"1F4DA",desc:"Books"},{code:"1F4D3",desc:"Notebook"},{code:"1F4D2",desc:"Ledger"},{code:"1F4C3",desc:"Curl"},{code:"1F4DC",desc:"Scroll"},{code:"1F4C4",desc:"Page Facing Up"},{code:"1F4F0",desc:"Newspaper"},{code:"1F4D1",desc:"Bookmark Tabs"},{code:"1F516",desc:"Bookmark"},{code:"1F4B0",desc:"Money Bag"},{code:"1F4B4",desc:"Banknote with Yen Sign"},{code:"1F4B5",desc:"Banknote with Dollar Sign"},{code:"1F4B6",desc:"Banknote with Euro Sign"},{code:"1F4B7",desc:"Banknote with Pound Sign"},{code:"1F4B8",desc:"Money with Wings"},{code:"1F4B3",desc:"Credit Card"},{code:"1F4B9",desc:"Chart with Upwards Trend and Yen Sign"},{code:"1F4B1",desc:"Currency Exchange"},{code:"1F4B2",desc:"Heavy Dollar Sign"},{code:"2709",desc:"Envelope"},{code:"1F4E7",desc:"E-Mail Symbol"},{code:"1F4E8",desc:"Incoming Envelope"},{code:"1F4E9",desc:"Envelope with Downwards Arrow Above"},{code:"1F4E4",desc:"Outbox Tray"},{code:"1F4E5",desc:"Inbox Tray"},{code:"1F4E6",desc:"Package"},{code:"1F4BE",desc:"Closed Mailbox with Raised Flag"},{code:"1F4EA",desc:"Closed Mailbox with Lowered Flag"},{code:"1F4EC",desc:"Open Mailbox with Raised Flag"},{code:"1F4ED",desc:"Open Mailbox with Lowered Flag"},{code:"1F5F3",desc:"Postbox"},{code:"270F",desc:"Pencil"},{code:"2712",desc:"Black Nib"},{code:"1F4DD",desc:"Memo"},{code:"1F4BC",desc:"Briefcase"},{code:"1F4C1",desc:"File Folder"},{code:"1F4C2",desc:"Open File Folder"},{code:"1F4C5",desc:"Calender"},{code:"1F4C6",desc:"Tear-off Calender"},{code:"1F4C7",desc:"Card Index"},{code:"1F4C8",desc:"Chart with Upwards Trend"},{code:"1F4C9",desc:"Chart with Downwards Trend"},{code:"1F4CA",desc:"Bar Chart"},{code:"1F4CB",desc:"Clipboard"},{code:"1F4CC",desc:"Pushpin"},{code:"1F4CD",desc:"Round Pushpin"},{code:"1F4CE",desc:"Paperclip"},{code:"1F4CF",desc:"Straight Ruler"},{code:"1F4D0",desc:"Triangular Ruler"},{code:"2702",desc:"Black Scissors"},{code:"1F512",desc:"Lock"},{code:"1F513",desc:"Open Lock"},{code:"1F50F",desc:"Lock with Ink Pen"},{code:"1F510",desc:"Closed Lock with Key"},{code:"1F511",desc:"Key"},{code:"1F528",desc:"Hammer"},{code:"1F52B",desc:"Pistol"},{code:"1F527",desc:"Wrench"},{code:"1F529",desc:"Nut and Bolt"},{code:"1F517",desc:"Link Symbol"},{code:"1F489",desc:"Syringe"},{code:"1F48A",desc:"Pill"},{code:"1F6AC",desc:"Smoking Symbol"},{code:"1F5FF",desc:"Moyai"},{code:"1F52E",desc:"Crystal Ball"}]},{id:"symbols",name:"Symbols",code:"1F3E7",emoticons:[{code:"1F3E7",desc:"Automated Teller Machine"},{code:"1F6AE",desc:"Put Litter in Its Place Symbol"},{code:"1F6B0",desc:"Potable Water Symbol"},{code:"267F",desc:"Wheelchair Symbol"},{code:"1F6B9",desc:"Mens Symbol"},{code:"1F6BA",desc:"Womens Symbol"},{code:"1F6BB",desc:"Restroom"},{code:"1F6BC",desc:"Baby Symbol"},{code:"1F6BE",desc:"Water Closet"},{code:"1F6C2",desc:"Passport Control"},{code:"1F6C3",desc:"Customs"},{code:"1F6C4",desc:"Baggage Claim"},{code:"1F6C5",desc:"Left Luggage"},{code:"26A0",desc:"Warning Sign"},{code:"1F6B8",desc:"Children Crossing"},{code:"26D4",desc:"No Entry"},{code:"1F6AB",desc:"No Entry Sign"},{code:"1F6B3",desc:"No Bicycles"},{code:"1F6AD",desc:"No Smoking Symbol"},{code:"1F6AF",desc:"Do Not Litter Symbol"},{code:"1F6B1",desc:"Non-Potable Water Symbol"},{code:"1F6B7",desc:"No Pedestrians"},{code:"1F4F5",desc:"No Mobile Phones"},{code:"1F51E",desc:"No One Under Eighteen Symbol"},{code:"2B06",desc:"Upwards Black Arrow"},{code:"2197",desc:"North East Arrow"},{code:"27A1",desc:"Black Rightwards Arrow"},{code:"2198",desc:"South East Arrow"},{code:"2B07",desc:"Downwards Black Arrow"},{code:"2199",desc:"South West Arrow"},{code:"2B05",desc:"Leftwards Black Arrow"},{code:"2196",desc:"North West Arrow"},{code:"2195",desc:"Up Down Arrow"},{code:"2194",desc:"Left Right Arrow"},{code:"21A9",desc:"Leftwards Arrow with Hook"},{code:"21AA",desc:"Rightwards Arrow with Hook"},{code:"2934",desc:"Arrow Pointing Rightwards Then Curving Upwards"},{code:"2935",desc:"Arrow Pointing Rightwards Then Curving Downwards"},{code:"1F503",desc:"Clockwise Downwards and Upwards Open Circle Arrows"},{code:"1F504",desc:"Anticlockwise Downwards and Upwards Open Circle Arrows"},{code:"1F519",desc:"Back with Leftwards Arrow Above"},{code:"1F51A",desc:"End with Leftwards Arrow Above"},{code:"1F51B",desc:"On with Exclamation Mark with Left Right Arrow Above"},{code:"1F51C",desc:"Soon with Rightwards Arrow Above"},{code:"1F51D",desc:"Top with Upwards Arrow Above"},{code:"1F52F",desc:"Six Pointed Star with Middle Dot"},{code:"2648",desc:"Aries"},{code:"2649",desc:"Taurus"},{code:"264A",desc:"Gemini"},{code:"264B",desc:"Cancer"},{code:"264C",desc:"Leo"},{code:"264D",desc:"Virgo"},{code:"264E",desc:"Libra"},{code:"264F",desc:"Scorpius"},{code:"2650",desc:"Sagittarius"},{code:"2651",desc:"Capricorn"},{code:"2652",desc:"Aquarius"},{code:"2653",desc:"Pisces"},{code:"26CE",desc:"Ophiuchus"},{code:"1F500",desc:"Twisted Rightwards Arrows"},{code:"1F501",desc:"Clockwise Rightwards and Leftwards Open Circle Arrows"},{code:"1F502",desc:"Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay"},{code:"25B6",desc:"Black Right-Pointing Triangle"},{code:"23E9",desc:"Black Right-Pointing Double Triangle"},{code:"25C0",desc:"Black Left-Pointing Triangle"},{code:"23EA",desc:"Black Left-Pointing Double Triangle"},{code:"1F53C",desc:"Up-Pointing Small Red Triangle"},{code:"23EB",desc:"Black Up-Pointing Double Triangle"},{code:"1F53D",desc:"Down-Pointing Small Red Triangle"},{code:"23EC",desc:"Black Down-Pointing Double Triangle"},{code:"1F3A6",desc:"Cinema"},{code:"1F505",desc:"Low Brightness Symbol"},{code:"1F506",desc:"High Brightness Symbol"},{code:"1F4F6",desc:"Antenna with Bars"},{code:"1F4F3",desc:"Vibration Mode"},{code:"1F4F4",desc:"Mobile Phone off"},{code:"267B",desc:"Black Universal Recycling Symbol"},{code:"1F531",desc:"Trident Emblem"},{code:"1F4DB",desc:"Name Badge"},{code:"1F530",desc:"Japanese Symbol for Beginner"},{code:"2B55",desc:"Heavy Large Circle"},{code:"2705",desc:"White Heavy Check Mark"},{code:"2611",desc:"Ballot Box with Check"},{code:"2714",desc:"Heavy Check Mark"},{code:"2716",desc:"Heavy Multiplication X"},{code:"274C",desc:"Cross Mark"},{code:"274E",desc:"Negative Squared Cross Mark"},{code:"2795",desc:"Heavy Plus Sign"},{code:"2796",desc:"Heavy Minus Sign"},{code:"2797",desc:"Heavy Division Sign"},{code:"27B0",desc:"Curly Loop"},{code:"27BF",desc:"Double Curly Loop"},{code:"303D",desc:"Part Alternation Mark"},{code:"2733",desc:"Eight Spoked Asterisk"},{code:"2734",desc:"Eight Pointed Black Star"},{code:"2747",desc:"Sparkle"},{code:"203C",desc:"Double Exclamation Mark"},{code:"2049",desc:"Exclamation Question Mark"},{code:"2753",desc:"Black Question Mark Ornament"},{code:"2754",desc:"White Question Mark Ornament"},{code:"2755",desc:"White Exclamation Mark Ornament"},{code:"2757",desc:"Heavy Exclamation Mark Symbol"},{code:"3030",desc:"Wavy Dash"},{code:"2122",desc:"Trade Mark Sign"},{code:"1F51F",desc:"Keycap Ten"},{code:"1F4AF",desc:"Hundred Points Symbol"},{code:"1F520",desc:"Input Symbol for Latin Capital Letters"},{code:"1F521",desc:"Input Symbol for Latin Small Letters"},{code:"1F522",desc:"Input Symbol for Numbers"},{code:"1F523",desc:"Input Symbol for Symbols"},{code:"1F524",desc:"Input Symbol for Latin Letters"},{code:"1F170",desc:"Negative Squared Latin Capital Letter a"},{code:"1F18E",desc:"Negative Squared Ab"},{code:"1F171",desc:"Negative Squared Latin Capital Letter B"},{code:"1F191",desc:"Squared Cl"},{code:"1F192",desc:"Squared Cool"},{code:"1F193",desc:"Squared Free"},{code:"2139",desc:"Information Source"},{code:"1F194",desc:"Squared Id"},{code:"24C2",desc:"Circled Latin Capital Letter M"},{code:"1F195",desc:"Squared New"},{code:"1F196",desc:"Squared Ng"},{code:"1F17E",desc:"Negative Squared Latin Capital Letter O"},{code:"1F197",desc:"Squared Ok"},{code:"1F17F",desc:"Negative Squared Latin Capital Letter P"},{code:"1F198",desc:"Squared Sos"},{code:"1F199",desc:"Squared Up with Exclamation Mark"},{code:"1F19A",desc:"Squared Vs"},{code:"1F201",desc:"Squared Katakana Koko"},{code:"1F202",desc:"Squared Katakana Sa"},{code:"1F237",desc:"Squared Cjk Unified Ideograph-6708"},{code:"1F236",desc:"Squared Cjk Unified Ideograph-6709"},{code:"1F22F",desc:"Squared Cjk Unified Ideograph-6307"},{code:"1F250",desc:"Circled Ideograph Advantage"},{code:"1F239",desc:"Squared Cjk Unified Ideograph-5272"},{code:"1F21A",desc:"Squared Cjk Unified Ideograph-7121"},{code:"1F232",desc:"Squared Cjk Unified Ideograph-7981"},{code:"1F251",desc:"Circled Ideograph Accept"},{code:"1F238",desc:"Squared Cjk Unified Ideograph-7533"},{code:"1F234",desc:"Squared Cjk Unified Ideograph-5408"},{code:"1F233",desc:"Squared Cjk Unified Ideograph-7a7a"},{code:"3297",desc:"Circled Ideograph Congratulation"},{code:"3299",desc:"Circled Ideograph Secret"},{code:"1F23A",desc:"Squared Cjk Unified Ideograph-55b6"},{code:"1F235",desc:"Squared Cjk Unified Ideograph-6e80"},{code:"25AA",desc:"Black Small Square"},{code:"25AB",desc:"White Small Square"},{code:"25FB",desc:"White Medium Square"},{code:"25FC",desc:"Black Medium Square"},{code:"25FD",desc:"White Medium Small Square"},{code:"25FE",desc:"Black Medium Small Square"},{code:"2B1B",desc:"Black Large Square"},{code:"2B1C",desc:"White Large Square"},{code:"1F536",desc:"Large Orange Diamond"},{code:"1F537",desc:"Large Blue Diamond"},{code:"1F538",desc:"Small Orange Diamond"},{code:"1F539",desc:"Small Blue Diamond"},{code:"1F53A",desc:"Up-Pointing Red Triangle"},{code:"1F53B",desc:"Down-Pointing Red Triangle"},{code:"1F4A0",desc:"Diamond Shape with a Dot Inside"},{code:"1F518",desc:"Radio Button"},{code:"1F532",desc:"Black Square Button"},{code:"1F533",desc:"White Square Button"},{code:"26AA",desc:"Medium White Circle"},{code:"26AB",desc:"Medium Black Circle"},{code:"1F534",desc:"Large Red Circle"},{code:"1F535",desc:"Large Blue Circle"}]},{id:"flags",name:"Flags",code:"1F3C1",emoticons:[{code:"1f3c1",desc:"Chequered Flag"},{code:"1f1e8-1f1f3",desc:"China Flag"},{code:"1f38c",desc:"Crossed Flags"},{code:"1f1e9-1f1ea",desc:"Germany Flag"},{code:"1f1ea-1f1f8",desc:"Spain Flag"},{code:"1f1e6-1f1e8",desc:"Ascension Island Flag"},{code:"1f1e6-1f1e9",desc:"Andorra Flag"},{code:"1f1e6-1f1ea",desc:"United Arab Emirates Flag"},{code:"1f1e6-1f1eb",desc:"Afghanistan Flag"},{code:"1f1e6-1f1ec",desc:"Antigua & Barbuda Flag"},{code:"1f1e6-1f1ee",desc:"Anguilla Flag"},{code:"1f1e6-1f1f1",desc:"Albania Flag"},{code:"1f1e6-1f1f2",desc:"Armenia Flag"},{code:"1f1e6-1f1f4",desc:"Angola Flag"},{code:"1f1e6-1f1f6",desc:"Antarctica Flag"},{code:"1f1e6-1f1f7",desc:"Argentina Flag"},{code:"1f1e6-1f1f8",desc:"American Samoa Flag"},{code:"1f1e6-1f1f9",desc:"Austria Flag"},{code:"1f1e6-1f1fa",desc:"Australia Flag"},{code:"1f1e6-1f1fc",desc:"Aruba Flag"},{code:"1f1e6-1f1fd",desc:"\xc5land Islands Flag"},{code:"1f1e6-1f1ff",desc:"Azerbaijan Flag"},{code:"1f1e7-1f1e7",desc:"Barbados Flag"},{code:"1f1e7-1f1e9",desc:"Bangladesh Flag"},{code:"1f1e7-1f1ea",desc:"Belgium Flag"},{code:"1f1e7-1f1eb",desc:"Burkina Faso Flag"},{code:"1f1e7-1f1ec",desc:"Bulgaria Flag"},{code:"1f1e7-1f1ed",desc:"Bahrain Flag"},{code:"1f1e7-1f1ee",desc:"Burundi Flag"},{code:"1f1e7-1f1ef",desc:"Benin Flag"},{code:"1f1e7-1f1f1",desc:"St. Barth\xe9lemy Flag"},{code:"1f1e7-1f1f2",desc:"Bermuda Flag"},{code:"1f1e7-1f1f4",desc:"Bolivia Flag"},{code:"1f1e7-1f1f6",desc:"Caribbean Netherlands Flag"},{code:"1f1e7-1f1f7",desc:"Brazil Flag"},{code:"1f1e7-1f1f8",desc:"Bahamas Flag"},{code:"1f1e7-1f1f9",desc:"Bhutan Flag"},{code:"1f1e7-1f1fb",desc:"Bouvet Island Flag"},{code:"1f1e7-1f1fc",desc:"Botswana Flag"},{code:"1f1e7-1f1fe",desc:"Belarus Flag"},{code:"1f1e7-1f1ff",desc:"Belize Flag"},{code:"1f1e8-1f1e6",desc:"Canada Flag"},{code:"1f1e8-1f1e8",desc:"Cocos (keeling) Islands Flag"},{code:"1f1e8-1f1e9",desc:"Congo - Kinshasa Flag"},{code:"1f1e8-1f1eb",desc:"Central African Republic Flag"},{code:"1f1e8-1f1ec",desc:"Congo - Brazzaville Flag"},{code:"1f1e8-1f1ed",desc:"Switzerland Flag"},{code:"1f1e8-1f1ee",desc:"C\xf4te D\u2019ivoire Flag"},{code:"1f1e8-1f1f0",desc:"Cook Islands Flag"},{code:"1f1e8-1f1f1",desc:"Chile Flag"},{code:"1f1e8-1f1f2",desc:"Cameroon Flag"},{code:"1f1e8-1f1f4",desc:"Colombia Flag"},{code:"1f1e8-1f1f7",desc:"Costa Rica Flag"},{code:"1f1e8-1f1fa",desc:"Cuba Flag"},{code:"1f1e8-1f1fb",desc:"Cape Verde Flag"},{code:"1f1e8-1f1fc",desc:"Cura\xe7ao Flag"},{code:"1f1e8-1f1fd",desc:"Christmas Island Flag"},{code:"1f1e8-1f1fe",desc:"Cyprus Flag"},{code:"1f1e8-1f1ff",desc:'Czechia Flag"'},{code:"1f1e9-1f1ec",desc:"Diego Garcia Flag"},{code:"1f1e9-1f1ef",desc:"Djibouti Flag"},{code:"1f1e9-1f1f0",desc:"Denmark Flag"},{code:"1f1e9-1f1f2",desc:"Dominica Flag"},{code:"1f1e9-1f1f4",desc:"Dominican Republic Flag"},{code:"1f1e9-1f1ff",desc:"Algeria Flag"},{code:"1f1ea-1f1e6",desc:"Ceuta & Melilla Flag"},{code:"1f1ea-1f1e8",desc:"Ecuador Flag"},{code:"1f1ea-1f1ea",desc:"Estonia Flag"},{code:"1f1ea-1f1ec",desc:"Egypt Flag"},{code:"1f1ea-1f1ed",desc:"Western Sahara Flag"},{code:"1f1ea-1f1f7",desc:"Eritrea Flag"},{code:"1f1ea-1f1f9",desc:"Ethiopia Flag"},{code:"1f1ea-1f1fa",desc:"European Union Flag"},{code:"1f1eb-1f1ee",desc:"Finland Flag"},{code:"1f1eb-1f1ef",desc:"Fiji Flag"},{code:"1f1eb-1f1f0",desc:"Falkland Islands Flag"},{code:"1f1eb-1f1f2",desc:"Micronesia Flag"},{code:"1f1eb-1f1f4",desc:"Faroe Islands Flag"},{code:"1f1ec-1f1e6",desc:"Gabon Flag"},{code:"1f1ec-1f1e9",desc:"Grenada Flag"},{code:"1f1ec-1f1ea",desc:"Georgia Flag"},{code:"1f1ec-1f1eb",desc:"French Guiana Flag"},{code:"1f1ec-1f1ec",desc:"Guernsey Flag"},{code:"1f1ec-1f1ed",desc:"Ghana Flag"},{code:"1f1ec-1f1ee",desc:"Gibraltar Flag"},{code:"1f1ec-1f1f1",desc:"Greenland Flag"},{code:"1f1ec-1f1f2",desc:"Gambia Flag"},{code:"1f1ec-1f1f3",desc:"Guinea Flag"},{code:"1f1ec-1f1f5",desc:"Guadeloupe Flag"},{code:"1f1ec-1f1f6",desc:"Equatorial Guinea Flag"},{code:"1f1ec-1f1f7",desc:"Greece Flag"},{code:"1f1ec-1f1f8",desc:"South Georgia & South Sandwich Islands Flag"},{code:"1f1ec-1f1f9",desc:"Guatemala Flag"},{code:"1f1ec-1f1fa",desc:"Guam Flag"},{code:"1f1ec-1f1fc",desc:"Guinea-Bissau Flag"},{code:"1f1ec-1f1fe",desc:"Guyana Flag"},{code:"1f1ed-1f1f0",desc:"Hong Kong Sar China Flag"},{code:"1f1ed-1f1f2",desc:"Heard & Mcdonald Islands Flag"},{code:"1f1ed-1f1f3",desc:"Honduras Flag"},{code:"1f1ed-1f1f7",desc:"Croatia Flag"},{code:"1f1ed-1f1f9",desc:"Haiti Flag"},{code:"1f1ed-1f1fa",desc:"Hungary Flag"},{code:"1f1ee-1f1e8",desc:"Canary Islands Flag"},{code:"1f1ee-1f1e9",desc:"Indonesia Flag"},{code:"1f1ee-1f1ea",desc:"Ireland Flag"},{code:"1f1ee-1f1f1",desc:"Israel Flag"},{code:"1f1ee-1f1f2",desc:"Isle of Man Flag"},{code:"1f1ee-1f1f3",desc:"India Flag"},{code:"1f1ee-1f1f4",desc:"British Indian Ocean Territory Flag"},{code:"1f1ee-1f1f6",desc:"Iraq Flag"},{code:"1f1ee-1f1f7",desc:"Iran Flag"},{code:"1f1ee-1f1f8",desc:"Iceland Flag"},{code:"1f1ef-1f1ea",desc:"Jersey Flag"},{code:"1f1ef-1f1f2",desc:"Jamaica Flag"},{code:"1f1ef-1f1f4",desc:"Jordan Flag"},{code:"1f1f0-1f1ea",desc:"Kenya Flag"},{code:"1f1f0-1f1ec",desc:"Kyrgyzstan Flag"},{code:"1f1f0-1f1ed",desc:"Cambodia Flag"},{code:"1f1f0-1f1ee",desc:"Kiribati Flag"},{code:"1f1f0-1f1f2",desc:"Comoros Flag"},{code:"1f1f0-1f1f3",desc:"St. Kitts & Nevis Flag"},{code:"1f1f0-1f1f5",desc:"North Korea Flag"},{code:"1f1f0-1f1fc",desc:"Kuwait Flag"},{code:"1f1f0-1f1fe",desc:"Cayman Islands Flag"},{code:"1f1f0-1f1ff",desc:"Kazakhstan Flag"},{code:"1f1f1-1f1e6",desc:"Laos Flag"},{code:"1f1f1-1f1e7",desc:"Lebanon Flag"},{code:"1f1f1-1f1e8",desc:"St. Lucia Flag"},{code:"1f1f1-1f1ee",desc:"Liechtenstein Flag"},{code:"1f1f1-1f1f0",desc:"Sri Lanka Flag"},{code:"1f1f1-1f1f7",desc:"Liberia Flag"},{code:"1f1f1-1f1f8",desc:"Lesotho Flag"},{code:"1f1f1-1f1f9",desc:"Lithuania Flag"},{code:"1f1f1-1f1fa",desc:"Luxembourg Flag"},{code:"1f1f1-1f1fb",desc:"Latvia Flag"},{code:"1f1f1-1f1fe",desc:"Libya Flag"},{code:"1f1f2-1f1e6",desc:"Morocco Flag"},{code:"1f1f2-1f1e8",desc:"Monaco Flag"},{code:"1f1f2-1f1e9",desc:"Moldova Flag"},{code:"1f1f2-1f1ea",desc:"Montenegro Flag"},{code:"1f1f2-1f1eb",desc:"St. Martin Flag"},{code:"1f1f2-1f1ec",desc:"Madagascar Flag"},{code:"1f1f2-1f1ed",desc:"Marshall Islands Flag"},{code:"1f1f2-1f1f0",desc:"Macedonia Flag"},{code:"1f1f2-1f1f1",desc:"Mali Flag"},{code:"1f1f2-1f1f2",desc:"Myanmar (burma) Flag"},{code:"1f1f2-1f1f3",desc:"Mongolia Flag"},{code:"1f1f2-1f1f4",desc:"Macau Sar China Flag"},{code:"1f1f2-1f1f5",desc:"Northern Mariana Islands Flag"},{code:"1f1f2-1f1f6",desc:"Martinique Flag"},{code:"1f1f2-1f1f7",desc:"Mauritania Flag"},{code:"1f1f2-1f1f8",desc:"Montserrat Flag"},{code:"1f1f2-1f1f9",desc:"Malta Flag"},{code:"1f1f2-1f1fa",desc:"Mauritius Flag"},{code:"1f1f2-1f1fb",desc:"Maldives Flag"},{code:"1f1f2-1f1fc",desc:"Malawi Flag"},{code:"1f1f2-1f1fd",desc:"Mexico Flag"},{code:"1f1f2-1f1fe",desc:"Malaysia Flag"},{code:"1f1f2-1f1ff",desc:"Mozambique Flag"},{code:"1f1f3-1f1e6",desc:"Namibia Flag"},{code:"1f1f3-1f1e8",desc:"New Caledonia Flag"},{code:"1f1f3-1f1ea",desc:"Niger Flag"},{code:"1f1f3-1f1eb",desc:"Norfolk Island Flag"},{code:"1f1f3-1f1ec",desc:"Nigeria Flag"},{code:"1f1f3-1f1ee",desc:"Nicaragua Flag"},{code:"1f1f3-1f1f1",desc:"Netherlands Flag"},{code:"1f1f3-1f1f4",desc:"Norway Flag"},{code:"1f1f3-1f1f5",desc:"Nepal Flag"},{code:"1f1f3-1f1f7",desc:"Nauru Flag"},{code:"1f1f3-1f1fa",desc:"Niue Flag"},{code:"1f1f3-1f1ff",desc:"New Zealand Flag"},{code:"1f1f4-1f1f2",desc:"Oman Flag"},{code:"1f1f8-1f1ff",desc:"Swaziland Flag"},{code:"1f1f5-1f1e6",desc:"Panama Flag"},{code:"1f1f5-1f1ea",desc:"Peru Flag"},{code:"1f1f5-1f1eb",desc:"French Polynesia Flag"},{code:"1f1f5-1f1ec",desc:"Papua New Guinea Flag"},{code:"1f1f5-1f1ed",desc:"Philippines Flag"},{code:"1f1f5-1f1f0",desc:"Pakistan Flag"},{code:"1f1f5-1f1f1",desc:"Poland Flag"},{code:"1f1f5-1f1f2",desc:"St. Pierre & Miquelon  Flag"},{code:"1f1f5-1f1f3",desc:"Pitcairn Islands Flag"},{code:"1f1f5-1f1f7",desc:"Puerto Rico Flag"},{code:"1f1f5-1f1f8",desc:"Palestinian Territories Flag"},{code:"1f1f5-1f1f9",desc:"Portugal Flag"},{code:"1f1f5-1f1fc",desc:"Palau Flag"},{code:"1f1f5-1f1fe",desc:"Paraguay Flag"},{code:"1f1f6-1f1e6",desc:"Qatar Flag"},{code:"1f1f7-1f1ea",desc:"R\xe9union Flag"},{code:"1f1f7-1f1f4",desc:"Romania Flag"},{code:"1f1f7-1f1f8",desc:"Serbia Flag"},{code:"1f1f7-1f1fc",desc:"Rwanda Flag"},{code:"1f1f8-1f1e6",desc:"Saudi Arabia Flag"},{code:"1f1f8-1f1e7",desc:"Solomon Islands Flag"},{code:"1f1f8-1f1e8",desc:"Seychelles Flag"},{code:"1f1f8-1f1e9",desc:"Sudan Flag"},{code:"1f1f8-1f1ea",desc:"Sweden Flag"},{code:"1f1f8-1f1ec",desc:"Singapore Flag"},{code:"1f1f8-1f1ee",desc:"Slovenia Flag"},{code:"1f1f8-1f1ed",desc:"St. Helena  Flag"},{code:"1f1f8-1f1ef",desc:"Svalbard & Jan Mayen  Flag"},{code:"1f1f8-1f1f1",desc:"Sierra Leone Flag"},{code:"1f1f8-1f1f2",desc:"San Marino Flag"},{code:"1f1f8-1f1f3",desc:"Senegal Flag"},{code:"1f1f8-1f1f4",desc:"Somalia Flag"},{code:"1f1f8-1f1f7",desc:"Suriname Flag"},{code:"1f1f8-1f1f8",desc:"South Sudan  Flag"},{code:"1f1f8-1f1f9",desc:"S\xe3o Tom\xe9 & Pr\xedncipe Flag"},{code:"1f1f8-1f1fb",desc:"El Salvador Flag"},{code:"1f1f8-1f1fd",desc:"Sint Maarten Flag"},{code:"1f1f8-1f1fe",desc:"Syria Flag"},{code:"1f1f9-1f1e6",desc:"Tristan Da Cunha Flag"},{code:"1f1f9-1f1e8",desc:"Turks & Caicos Islands  Flag"},{code:"1f1f9-1f1eb",desc:"French Southern Territories Flag"},{code:"1f1f9-1f1ec",desc:"Togo Flag"},{code:"1f1f9-1f1ed",desc:"Thailand Flag"},{code:"1f1f9-1f1ef",desc:"Tajikistan Flag"},{code:"1f1f9-1f1f0",desc:"Tokelau Flag"},{code:"1f1f9-1f1f1",desc:"Timor-Leste Flag"},{code:"1f1f9-1f1f2",desc:"Turkmenistan Flag"},{code:"1f1f9-1f1f3",desc:"Tunisia Flag"},{code:"1f1f9-1f1f4",desc:"Tonga Flag"},{code:"1f1f9-1f1f7",desc:"Turkey Flag"},{code:"1f1f9-1f1f9",desc:"Trinidad & Tobago Flag"},{code:"1f1f9-1f1fb",desc:"Tuvalu Flag"},{code:"1f1f9-1f1fc",desc:"Taiwan Flag"},{code:"1f1f9-1f1ff",desc:"Tanzania Flag"},{code:"1f1fa-1f1e6",desc:"Ukraine City  Flag"},{code:"1f1fa-1f1ec",desc:"Uganda Flag"},{code:"1f1fa-1f1f2",desc:"U.s. Outlying Islands  Flag"},{code:"1f1fa-1f1fe",desc:"Uruguay  Flag"},{code:"1f1fa-1f1ff",desc:"Uzbekistan Flag"},{code:"1f1fb-1f1e6",desc:"Vatican City  Flag"},{code:"1f1fb-1f1e8",desc:"St. Vincent & Grenadines Flag"},{code:"1f1fb-1f1ea",desc:"Venezuela Flag"},{code:"1f1fb-1f1ec",desc:"British Virgin Islands Flag"},{code:"1f1fb-1f1ee",desc:"U.s. Virgin Islands Flag"},{code:"1f1fb-1f1f3",desc:"Vietnam Flag"},{code:"1f1fc-1f1f8",desc:"Samoa Flag"},{code:"1f1fb-1f1fa",desc:"Vanuatu Flag"},{code:"1f1fc-1f1eb",desc:'"Wallis & Futuna Flag'},{code:"1f1fd-1f1f0",desc:"Kosovo Flag"},{code:"1f1fe-1f1ea",desc:"Yemen Flag"},{code:"1f1fe-1f1f9",desc:"Mayotte Flag"},{code:"1f1ff-1f1e6",desc:"South Africa Flag"},{code:"1f1ff-1f1f2",desc:"Zambia Flag"},{code:"1f1ff-1f1fc",desc:"Zimbabwe Flag"},{code:"1f1eb-1f1f7",desc:"France Flag"},{code:"1f1ec-1f1e7",desc:"United Kingdom  Flag"},{code:"1f1ee-1f1f9",desc:"Italy Flag"},{code:"1f1ef-1f1f5",desc:"Japan Flag"},{code:"1f1f0-1f1f7",desc:"South Korea Flag"},{code:"1f1f7-1f1fa",desc:"Russia Flag"},{code:"1F6A9",desc:"Triangular Flag on Post"},{code:"1f1fa-1f1f8",desc:"United States Flag"}]}],emoticonsButtons:["emoticonsBack","|"],emoticonsUseImage:!0}),St.PLUGINS.emoticons=function(E){var _=E.$,r=E.opts.emoticonsSet,i=r&&r[0],o="";function s(){if(!E.selection.isCollapsed())return!1;var e=E.selection.element(),t=E.selection.endElement();if(e&&E.node.hasClass(e,"fr-emoticon"))return e;if(t&&E.node.hasClass(t,"fr-emoticon"))return t;var a=E.selection.ranges(0),n=a.startContainer;if(n.nodeType==Node.ELEMENT_NODE&&0<n.childNodes.length&&0<a.startOffset){var r=n.childNodes[a.startOffset-1];if(E.node.hasClass(r,"fr-emoticon"))return r}return!1}function l(){return"".concat(function n(e,t){return'<div class="fr-buttons fr-tabs fr-tabs-scroll">\n                        '.concat(function a(e,n){var r="";return e.forEach(function(e){var t={image:e.code.toLowerCase()},a={elementClass:e.id===n.id?"fr-active fr-active-tab":"",emoticonsUnicodeClass:E.opts.emoticonsUseImage?"":"fr-tabs-unicode",title:E.language.translate(e.name),dataCmd:"setEmoticonCategory",dataParam1:e.id,image:E.opts.emoticonsUseImage?'<img src="https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/'.concat(t.image,'.svg"/>'):"&#x".concat(t.image,";")};r+='<button class="fr-command fr-btn '.concat(a.elementClass," ").concat(a.emoticonsUnicodeClass,'" \n      title="').concat(a.title,'" data-cmd="').concat(a.dataCmd,'" data-param1="').concat(a.dataParam1,'">\n       ').concat(a.image," </button>")}),r}(e,t),"\n                        </div>")}(r,i),"\n                      ").concat(function a(e){return'\n        <div class="fr-icon-container fr-emoticon-container">\n            '.concat(function t(e){var r="";return e.emoticons.forEach(function(e){var t=e.code.split("-").reduce(function(e,t){return e?"".concat(e,"&zwj;&#x").concat(t.toLowerCase(),";"):"&#x".concat(t.toLowerCase(),";")},""),a={image:e.code.toLowerCase(),compiledCode:e.uCode?e.uCode:t},n={dataParam1:e.code.toLowerCase(),dataParam2:a.compiledCode,title:E.language.translate(e.desc),image:E.opts.emoticonsUseImage?'<img src="https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/'.concat(a.image,'.svg"/>'):"".concat(a.compiledCode),desc:E.language.translate(e.desc)};r+='<span class="fr-command fr-emoticon fr-icon" role="button" \n      data-cmd="insertEmoticon" data-param1="'.concat(n.dataParam1,'" tabindex="0"\n      data-param2="').concat(n.dataParam2,'"  title="').concat(n.title,'" >\n      ').concat(n.image,'<span class="fr-sr-only">').concat(n.desc,"&nbsp;&nbsp;&nbsp;</span></span>")}),r}(e),"\n        </div>\n        ")}(i),"\n                      ").concat(function e(){return E.opts.emoticonsUseImage?'<p style="font-size: 12px; text-align: center; padding: 0 5px;">Emoji free by <a class="fr-link" tabIndex="-1" href="http://emojione.com/" target="_blank" rel="nofollow noopener noreferrer" role="link" aria-label="Open Emoji One website.">Emoji One</a></p>':""}())}return{_init:function e(){var a=function a(){for(var e=E.el.querySelectorAll(".fr-emoticon:not(.fr-deletable)"),t=0;t<e.length;t++)e[t].className+=" fr-deletable"};a(),E.events.on("html.set",a),E.events.on("keydown",function(e){if(E.keys.isCharacter(e.which)&&E.selection.inEditor()){var t=E.selection.ranges(0),a=s();E.node.hasClass(a,"fr-emoticon-img")&&a&&(0===t.startOffset&&E.selection.element()===a?_(a).before(St.MARKERS+St.INVISIBLE_SPACE):_(a).after(St.INVISIBLE_SPACE+St.MARKERS),E.selection.restore())}}),E.events.on("keyup",function(e){for(var t=E.el.querySelectorAll(".fr-emoticon"),a=0;a<t.length;a++)"undefined"!=typeof t[a].textContent&&0===t[a].textContent.replace(/\u200B/gi,"").length&&_(t[a]).remove();if(!(e.which>=St.KEYCODE.ARROW_LEFT&&e.which<=St.KEYCODE.ARROW_DOWN)){var n=s();E.node.hasClass(n,"fr-emoticon-img")&&(_(n).append(St.MARKERS),E.selection.restore())}})},insert:function c(e,t){var a=s(),n=E.selection.ranges(0);a?(0===n.startOffset&&E.selection.element()===a?_(a).before(St.MARKERS+St.INVISIBLE_SPACE):0<n.startOffset&&E.selection.element()===a&&n.commonAncestorContainer.parentNode.classList.contains("fr-emoticon")&&_(a).after(St.INVISIBLE_SPACE+St.MARKERS),E.selection.restore(),E.html.insert('<span class="fr-emoticon fr-deletable'.concat(t?" fr-emoticon-img":"",'"').concat(t?' style="background: url('.concat(t,');"'):"",">").concat(t?"&nbsp;":e,"</span>&nbsp;").concat(St.MARKERS),!0)):E.html.insert('<span class="fr-emoticon fr-deletable'.concat(t?" fr-emoticon-img":"",'"').concat(t?' style="background: url('.concat(t,');"'):"",">").concat(t?"&nbsp;":e,"</span>").concat(St.INVISIBLE_SPACE),!0)},setEmoticonCategory:function n(t){i=r.filter(function(e){return e.id===t})[0],function a(){E.popups.get("emoticons").html(o+l());var e=E.popups.get("emoticons").children().not(".fr-buttons");E.accessibility.registerPopup("emoticons"),E.accessibility.focusContent(e)}()},showEmoticonsPopup:function d(){var e=E.popups.get("emoticons");if(e||(e=function i(){E.opts.toolbarInline&&0<E.opts.emoticonsButtons.length&&(o='<div class="fr-buttons fr-emoticons-buttons fr-tabs">'.concat(E.button.buildList(E.opts.emoticonsButtons),"</div>"));var e={buttons:o,custom_layer:l()},t=E.popups.create("emoticons",e);return function a(b){E.events.on("popup.tab",function(e){var t=_(e.currentTarget);if(!E.popups.isVisible("emoticons")||!t.is("span, a"))return!0;var a,n,r,i=e.which,o=window.getComputedStyle(b.find(".fr-icon-container")[0]),s=o.getPropertyValue("grid-template-columns").split(" ").length;if(St.KEYCODE.TAB==i){var l=b.find("span.fr-emoticon");if(t.is(l.first())&&e.shiftKey||t.is("a")&&!e.shiftKey){var c=b.find(".fr-buttons");a=!E.accessibility.focusToolbar(c,!!e.shiftKey)}if(!1!==a){var d=b.find("span.fr-emoticon");d.add(b.find("a.fr-link")),d.add(b.find("button.fr-btn")),n=d.index(t),n=e.shiftKey?((n-1)%d.length+d.length)%d.length:(n+1)%d.length,r=d.get(n),E.events.disableBlur(),r.focus(),a=!1}}else if(St.KEYCODE.ARROW_UP==i||St.KEYCODE.ARROW_DOWN==i||St.KEYCODE.ARROW_LEFT==i||St.KEYCODE.ARROW_RIGHT==i){if(t.is("span.fr-emoticon")){var f=t.parent().find("span.fr-emoticon");n=f.index(t);var p=s,u=Math.ceil(f.length/p),g=n%p,h=Math.floor(n/p),m=h*p+g,v=u*p;St.KEYCODE.ARROW_UP==i?m=((m-p)%v+v)%v:St.KEYCODE.ARROW_DOWN==i?m=(m+p)%v:St.KEYCODE.ARROW_LEFT==i?m=((m-1)%v+v)%v:St.KEYCODE.ARROW_RIGHT==i&&(m=(m+1)%v),r=_(f.get(m)),E.events.disableBlur(),r.focus(),a=!1}}else St.KEYCODE.ENTER==i&&(t.is("a")?t[0].click():E.button.exec(t),a=!1);return!1===a&&(e.preventDefault(),e.stopPropagation()),a},!0)}(t),t}()),!e.hasClass("fr-active")){E.popups.refresh("emoticons"),E.popups.setContainer("emoticons",E.$tb);var t=E.$tb.find('.fr-command[data-cmd="emoticons"]'),a=E.button.getPosition(t),n=a.left,r=a.top;E.popups.show("emoticons",n,r,t.outerHeight()),E.popups.get("emoticons").css("overflow","hidden")}},back:function t(){E.popups.hide("emoticons"),E.toolbar.showInline()}}},St.DefineIcon("emoticons",{NAME:"smile-o",FA5NAME:"smile",SVG_KEY:"smile"}),St.RegisterCommand("emoticons",{title:"Emoticons",undo:!1,focus:!0,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible("emoticons")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("emoticons")):this.emoticons.showEmoticonsPopup()},plugin:"emoticons"}),St.RegisterCommand("insertEmoticon",{callback:function(e,t,a){this.emoticons.insert(a,this.opts.emoticonsUseImage?"https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/".concat(t,".svg"):null),this.popups.hide("emoticons")}}),St.RegisterCommand("setEmoticonCategory",{undo:!1,focus:!1,callback:function(e,t){this.emoticons.setEmoticonCategory(t)}}),St.DefineIcon("emoticonsBack",{NAME:"arrow-left",SVG_KEY:"back"}),St.RegisterCommand("emoticonsBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.emoticons.back()}}),Object.assign(St.DEFAULTS,{entities:"&quot;&#39;&iexcl;&cent;&pound;&curren;&yen;&brvbar;&sect;&uml;&copy;&ordf;&laquo;&not;&shy;&reg;&macr;&deg;&plusmn;&sup2;&sup3;&acute;&micro;&para;&middot;&cedil;&sup1;&ordm;&raquo;&frac14;&frac12;&frac34;&iquest;&Agrave;&Aacute;&Acirc;&Atilde;&Auml;&Aring;&AElig;&Ccedil;&Egrave;&Eacute;&Ecirc;&Euml;&Igrave;&Iacute;&Icirc;&Iuml;&ETH;&Ntilde;&Ograve;&Oacute;&Ocirc;&Otilde;&Ouml;&times;&Oslash;&Ugrave;&Uacute;&Ucirc;&Uuml;&Yacute;&THORN;&szlig;&agrave;&aacute;&acirc;&atilde;&auml;&aring;&aelig;&ccedil;&egrave;&eacute;&ecirc;&euml;&igrave;&iacute;&icirc;&iuml;&eth;&ntilde;&ograve;&oacute;&ocirc;&otilde;&ouml;&divide;&oslash;&ugrave;&uacute;&ucirc;&uuml;&yacute;&thorn;&yuml;&OElig;&oelig;&Scaron;&scaron;&Yuml;&fnof;&circ;&tilde;&Alpha;&Beta;&Gamma;&Delta;&Epsilon;&Zeta;&Eta;&Theta;&Iota;&Kappa;&Lambda;&Mu;&Nu;&Xi;&Omicron;&Pi;&Rho;&Sigma;&Tau;&Upsilon;&Phi;&Chi;&Psi;&Omega;&alpha;&beta;&gamma;&delta;&epsilon;&zeta;&eta;&theta;&iota;&kappa;&lambda;&mu;&nu;&xi;&omicron;&pi;&rho;&sigmaf;&sigma;&tau;&upsilon;&phi;&chi;&psi;&omega;&thetasym;&upsih;&piv;&ensp;&emsp;&thinsp;&zwnj;&zwj;&lrm;&rlm;&ndash;&mdash;&lsquo;&rsquo;&sbquo;&ldquo;&rdquo;&bdquo;&dagger;&Dagger;&bull;&hellip;&permil;&prime;&Prime;&lsaquo;&rsaquo;&oline;&frasl;&euro;&image;&weierp;&real;&trade;&alefsym;&larr;&uarr;&rarr;&darr;&harr;&crarr;&lArr;&uArr;&rArr;&dArr;&hArr;&forall;&part;&exist;&empty;&nabla;&isin;&notin;&ni;&prod;&sum;&minus;&lowast;&radic;&prop;&infin;&ang;&and;&or;&cap;&cup;&int;&there4;&sim;&cong;&asymp;&ne;&equiv;&le;&ge;&sub;&sup;&nsub;&sube;&supe;&oplus;&otimes;&perp;&sdot;&lceil;&rceil;&lfloor;&rfloor;&lang;&rang;&loz;&spades;&clubs;&hearts;&diams;"}),St.PLUGINS.entities=function(r){var i,o,s=r.$;function n(e){var t=e.textContent;if(t.match(i)){for(var a="",n=0;n<t.length;n++)o[t[n]]?a+=o[t[n]]:a+=t[n];e.textContent=a}}function l(e){if(e&&0<=["STYLE","SCRIPT","svg","IFRAME"].indexOf(e.tagName))return!0;for(var t=r.node.contents(e),a=0;a<t.length;a++)t[a].nodeType===Node.TEXT_NODE?n(t[a]):l(t[a]);return e.nodeType===Node.TEXT_NODE&&n(e),!1}var c=function c(e){return 0===e.length?"":r.clean.exec(e,l).replace(/\&amp;/g,"&")};return{_init:function d(){r.opts.htmlSimpleAmpersand||(r.opts.entities="".concat(r.opts.entities,"&amp;"));var e=s(document.createElement("div")).html(r.opts.entities).text(),t=r.opts.entities.split(";");o={},i="";for(var a=0;a<e.length;a++){var n=e.charAt(a);o[n]="".concat(t[a],";"),i+="\\".concat(n+(a<e.length-1?"|":""))}i=new RegExp("(".concat(i,")"),"g"),r.events.on("html.get",c,!0)}}},Object.assign(St.POPUP_TEMPLATES,{"file.insert":"[_BUTTONS_][_UPLOAD_LAYER_][_PROGRESS_BAR_]"}),Object.assign(St.DEFAULTS,{fileUpload:!0,fileUploadURL:null,fileUploadParam:"file",fileUploadParams:{},fileUploadToS3:!1,fileUploadToAzure:!1,fileUploadMethod:"POST",fileMaxSize:10485760,fileAllowedTypes:["*"],fileInsertButtons:["fileBack","|"],fileUseSelectedText:!1}),St.PLUGINS.file=function(w){var n,p=w.$,y="https://i.froala.com/upload",u=2,g=3,h=4,A=5,C=6,a={};function T(){var e=w.popups.get("file.insert");e||(e=l()),e.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"),e.find(".fr-file-progress-bar-layer").addClass("fr-active"),e.find(".fr-buttons").hide(),r(w.language.translate("Uploading"),0)}function i(e){var t=w.popups.get("file.insert");t&&(t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"),t.find(".fr-file-progress-bar-layer").removeClass("fr-active"),t.find(".fr-buttons").show(),e&&(w.events.focus(),w.popups.hide("file.insert")))}function r(e,t){var a=w.popups.get("file.insert");if(a){var n=a.find(".fr-file-progress-bar-layer");n.find("h3").text(e+(t?" ".concat(t,"%"):"")),n.removeClass("fr-error"),t?(n.find("div").removeClass("fr-indeterminate"),n.find("div > span").css("width","".concat(t,"%"))):n.find("div").addClass("fr-indeterminate")}}function m(e,t,a,n){var r;w.edit.on(),w.events.focus(!0),w.selection.restore(),w.opts.fileUseSelectedText&&w.selection.text().length&&(t=w.selection.text());var i='<a href="'.concat(e,'" id="fr-inserted-file" ');if(void 0!==n)for(r in n)n.hasOwnProperty(r)&&"link"!=r&&(i+="".concat(r,'="').concat(n[r],'" '));-1==i.indexOf(' class="')&&(i+='class="fr-file" '),i+=">".concat(t,"</a>"),w.html.insert(i);var o=w.$el.find("#fr-inserted-file");o.removeAttr("id"),w.popups.hide("file.insert"),w.undo.saveStep(),d(),w.events.trigger("file.inserted",[o,a])}function k(e,t,a){var n=this.status,r=this.response,i=this.responseXML,o=this.responseText;try{if(w.opts.fileUploadToS3||w.opts.fileUploadToAzure)if(201===n){var s;if(w.opts.fileUploadToAzure){if(!1===w.events.trigger("file.uploadedToAzure",[this.responseURL,a,r],!0))return w.edit.on(),!1;s=t}else s=function c(e){try{var t=p(e).find("Location").text(),a=p(e).find("Key").text();return!1===w.events.trigger("file.uploadedToS3",[t,a,e],!0)?(w.edit.on(),!1):t}catch(n){return L(h,e),!1}}(i);s&&m(s,e,r||i)}else L(h,r||i);else if(200<=n&&n<300){var l=function d(e){try{if(!1===w.events.trigger("file.uploaded",[e],!0))return w.edit.on(),!1;var t=JSON.parse(e);return t.link?t:(L(u,e),!1)}catch(a){return L(h,e),!1}}(o);l&&m(l.link,e,r||o,l)}else L(g,r||o)}catch(f){L(h,r||o)}}function S(){L(h,this.response||this.responseText||this.responseXML)}function R(e){if(e.lengthComputable){var t=e.loaded/e.total*100|0;r(w.language.translate("Uploading"),t)}}function L(e,t){w.edit.on(),function n(e){T();var t=w.popups.get("file.insert").find(".fr-file-progress-bar-layer");t.addClass("fr-error");var a=t.find("h3");a.text(e),w.events.disableBlur(),a.focus()}(w.language.translate("Something went wrong. Please try again.")),w.events.trigger("file.error",[{code:e,message:a[e]},t])}function x(){w.edit.on(),i(!0)}function o(e){if(void 0!==e&&0<e.length){var t=e[0].type;if(e[0].name&&e[0].name.endsWith(".msg")&&(t="application/vnd.ms-outlook"),!1===w.events.trigger("file.beforeUpload",[e]))return!1;var a,n=e[0];if(!(null!==w.opts.fileUploadURL&&w.opts.fileUploadURL!==y||w.opts.fileUploadToS3||w.opts.fileUploadToAzure))return function _(i){var o=new FileReader;o.onload=function(){for(var e=o.result,t=atob(o.result.split(",")[1]),a=[],n=0;n<t.length;n++)a.push(t.charCodeAt(n));var r=i.type;i.name&&i.name.endsWith(".msg")&&(r="application/vnd.ms-outlook"),e=window.URL.createObjectURL(new Blob([new Uint8Array(a)],{type:r})),w.file.insert(e,i.name,null)},T(),o.readAsDataURL(i)}(n),!1;if(n.size>w.opts.fileMaxSize)return L(A),!1;if(w.opts.fileAllowedTypes.indexOf("*")<0&&w.opts.fileAllowedTypes.indexOf(t.replace(/file\//g,""))<0)return L(C),!1;if(w.drag_support.formdata&&(a=w.drag_support.formdata?new FormData:null),a){var r;if(!1!==w.opts.fileUploadToS3)for(r in a.append("key",w.opts.fileUploadToS3.keyStart+(new Date).getTime()+"-"+(n.name||"untitled")),a.append("success_action_status","201"),a.append("X-Requested-With","xhr"),a.append("Content-Type",t),w.opts.fileUploadToS3.params)w.opts.fileUploadToS3.params.hasOwnProperty(r)&&a.append(r,w.opts.fileUploadToS3.params[r]);for(r in w.opts.fileUploadParams)w.opts.fileUploadParams.hasOwnProperty(r)&&a.append(r,w.opts.fileUploadParams[r]);a.append(w.opts.fileUploadParam,n);var i,o,s=w.opts.fileUploadURL;w.opts.fileUploadToS3&&(s=w.opts.fileUploadToS3.uploadURL?w.opts.fileUploadToS3.uploadURL:"https://".concat(w.opts.fileUploadToS3.region,".amazonaws.com/").concat(w.opts.fileUploadToS3.bucket));var l=w.opts.fileUploadMethod;w.opts.fileUploadToAzure&&(s=w.opts.fileUploadToAzure.uploadURL?"".concat(w.opts.fileUploadToAzure.uploadURL,"/").concat(n.name):encodeURI("https://".concat(w.opts.fileUploadToAzure.account,".blob.core.windows.net/").concat(w.opts.fileUploadToAzure.container,"/").concat(n.name)),i=s,w.opts.fileUploadToAzure.SASToken&&(s+=w.opts.fileUploadToAzure.SASToken),l="PUT");var c=w.core.getXHR(s,l);if(w.opts.fileUploadToAzure){var d=(new Date).toUTCString();if(!w.opts.fileUploadToAzure.SASToken&&w.opts.fileUploadToAzure.accessKey){var f=w.opts.fileUploadToAzure.account,p=w.opts.fileUploadToAzure.container;if(w.opts.fileUploadToAzure.uploadURL){var u=w.opts.fileUploadToAzure.uploadURL.split("/");p=u.pop(),f=u.pop().split(".")[0]}var g="x-ms-blob-type:BlockBlob\nx-ms-date:".concat(d,"\nx-ms-version:2019-07-07"),h=encodeURI("/"+f+"/"+p+"/"+n.name),m=l+"\n\n\n"+n.size+"\n\n"+t+"\n\n\n\n\n\n\n"+g+"\n"+h,v=w.cryptoJSPlugin.cryptoJS.HmacSHA256(m,w.cryptoJSPlugin.cryptoJS.enc.Base64.parse(w.opts.fileUploadToAzure.accessKey)).toString(w.cryptoJSPlugin.cryptoJS.enc.Base64),b="SharedKey "+f+":"+v;o=v,c.setRequestHeader("Authorization",b)}for(r in c.setRequestHeader("x-ms-version","2019-07-07"),c.setRequestHeader("x-ms-date",d),c.setRequestHeader("Content-Type",t),c.setRequestHeader("x-ms-blob-type","BlockBlob"),w.opts.fileUploadParams)w.opts.fileUploadParams.hasOwnProperty(r)&&c.setRequestHeader(r,w.opts.fileUploadParams[r]);for(r in w.opts.fileUploadToAzure.params)w.opts.fileUploadToAzure.params.hasOwnProperty(r)&&c.setRequestHeader(r,w.opts.fileUploadToAzure.params[r])}c.onload=function(){k.call(c,n.name,i,o)},c.onerror=S,c.upload.onprogress=R,c.onabort=x,T();var E=w.popups.get("file.insert");E&&(E.off("abortUpload"),E.on("abortUpload",function(){4!==c.readyState&&c.abort()})),c.send(w.opts.fileUploadToAzure?n:a)}}}function s(){i()}function l(e){if(e)return w.popups.onHide("file.insert",s),!0;var t;w.opts.fileUpload||w.opts.fileInsertButtons.splice(w.opts.fileInsertButtons.indexOf("fileUpload"),1),t='<div class="fr-buttons fr-tabs">'.concat(w.button.buildList(w.opts.fileInsertButtons),"</div>");var a="";w.opts.fileUpload&&(a='<div class="fr-file-upload-layer fr-layer fr-active" id="fr-file-upload-layer-'.concat(w.id,'"><strong>').concat(w.language.translate("Drop file"),"</strong><br>(").concat(w.language.translate("or click"),')<div class="fr-form"><input type="file" name="').concat(w.opts.fileUploadParam,'" accept="').concat(0<=w.opts.fileAllowedTypes.indexOf("*")?"/":"").concat(w.opts.fileAllowedTypes.join(", ").toLowerCase(),'" tabIndex="-1" aria-labelledby="fr-file-upload-layer-').concat(w.id,'" role="button"></div></div>'));var n={buttons:t,upload_layer:a,progress_bar:'<div class="fr-file-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="fileDismissError" tabIndex="2" role="button">OK</button></div></div>'},r=w.popups.create("file.insert",n);return function i(a){w.events.$on(a,"dragover dragenter",".fr-file-upload-layer",function(){return p(this).addClass("fr-drop"),!1},!0),w.events.$on(a,"dragleave dragend",".fr-file-upload-layer",function(){return p(this).removeClass("fr-drop"),!1},!0),w.events.$on(a,"drop",".fr-file-upload-layer",function(e){e.preventDefault(),e.stopPropagation(),p(this).removeClass("fr-drop");var t=e.originalEvent.dataTransfer;t&&t.files&&(a.data("instance")||w).file.upload(t.files)},!0),w.helpers.isIOS()&&w.events.$on(a,"touchstart",'.fr-file-upload-layer input[type="file"]',function(){p(this).trigger("click")}),w.events.$on(a,"change",'.fr-file-upload-layer input[type="file"]',function(){if(this.files){var e=a.data("instance")||w;e.events.disableBlur(),a.find("input:focus").blur(),e.events.enableBlur(),e.file.upload(this.files)}p(this).val("")},!0)}(r),r}function t(e){w.node.hasClass(e,"fr-file")}function c(e){var t=e.originalEvent.dataTransfer;if(t&&t.files&&t.files.length){var a=t.files[0];if(a&&"undefined"!=typeof a.type){if(a.type.indexOf("image")<0){if(!w.opts.fileUpload)return e.preventDefault(),e.stopPropagation(),!1;w.markers.remove(),w.markers.insertAtPoint(e.originalEvent),w.$el.find(".fr-marker").replaceWith(St.MARKERS),w.popups.hideAll();var n=w.popups.get("file.insert");return n||(n=l()),w.popups.setContainer("file.insert",w.$sc),w.popups.show("file.insert",e.originalEvent.pageX,e.originalEvent.pageY),T(),o(t.files),e.preventDefault(),e.stopPropagation(),!1}}else a.type.indexOf("image")<0&&(e.preventDefault(),e.stopPropagation())}}function d(){var e,t=Array.prototype.slice.call(w.el.querySelectorAll("a.fr-file")),a=[];for(e=0;e<t.length;e++)a.push(t[e].getAttribute("href"));if(n)for(e=0;e<n.length;e++)a.indexOf(n[e].getAttribute("href"))<0&&w.events.trigger("file.unlink",[n[e]]);n=t}return a[1]="File cannot be loaded from the passed link.",a[u]="No link in upload response.",a[g]="Error during file upload.",a[h]="Parsing response failed.",a[A]="File is too large.",a[C]="File file type is invalid.",a[7]="Files can be uploaded only to same domain in IE 8 and IE 9.",{_init:function f(){!function e(){w.events.on("drop",c),w.events.$on(w.$win,"keydown",function(e){var t=e.which,a=w.popups.get("file.insert");a&&t===St.KEYCODE.ESC&&a.trigger("abortUpload")}),w.events.on("destroy",function(){var e=w.popups.get("file.insert");e&&e.trigger("abortUpload")})}(),w.events.on("link.beforeRemove",t),w.$wp&&(d(),w.events.on("contentChanged",d)),l(!0)},showInsertPopup:function v(){var e=w.$tb.find('.fr-command[data-cmd="insertFile"]'),t=w.popups.get("file.insert");if(t||(t=l()),i(),!t.hasClass("fr-active"))if(w.popups.refresh("file.insert"),w.popups.setContainer("file.insert",w.$tb),e.isVisible){var a=w.button.getPosition(e),n=a.left,r=a.top;w.popups.show("file.insert",n,r,e.outerHeight())}else w.position.forSelection(t),w.popups.show("file.insert")},upload:o,insert:m,back:function e(){w.events.disableBlur(),w.selection.restore(),w.events.enableBlur(),w.popups.hide("file.insert"),w.toolbar.showInline()},hideProgressBar:i}},St.DefineIcon("insertFile",{NAME:"file-o",FA5NAME:"file",SVG_KEY:"insertFile"}),St.RegisterCommand("insertFile",{title:"Upload File",undo:!1,focus:!0,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible("file.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("file.insert")):this.file.showInsertPopup()},plugin:"file"}),St.DefineIcon("fileBack",{NAME:"arrow-left",SVG_KEY:"back"}),St.RegisterCommand("fileBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.file.back()},refresh:function(e){this.opts.toolbarInline?(e.removeClass("fr-hidden"),e.next(".fr-separator").removeClass("fr-hidden")):(e.addClass("fr-hidden"),e.next(".fr-separator").addClass("fr-hidden"))}}),St.RegisterCommand("fileDismissError",{title:"OK",callback:function(){this.file.hideProgressBar(!0)}}),Object.assign(St.POPUP_TEMPLATES,{"filesManager.insert":"[_BUTTONS_][_UPLOAD_LAYER_][_BY_URL_LAYER_][_EMBED_LAYER_][_UPLOAD_PROGRESS_LAYER_][_PROGRESS_BAR_]","image.edit":"[_BUTTONS_]","image.alt":"[_BUTTONS_][_ALT_LAYER_]","image.size":"[_BUTTONS_][_SIZE_LAYER_]"}),Object.assign(St.DEFAULTS,{filesInsertButtons:["imageBack","|","filesUpload","filesByURL","filesEmbed"],filesInsertButtons2:["deleteAll","insertAll","cancel","minimize"],imageEditButtons:["imageReplace","imageAlign","imageCaption","imageRemove","imageLink","linkOpen","linkEdit","linkRemove","-","imageDisplay","imageStyle","imageAlt","imageSize"],imageAltButtons:["imageBack","|"],imageSizeButtons:["imageBack","|"],imageUpload:!0,filesManagerUploadURL:null,imageCORSProxy:"https://cors-anywhere.froala.com",imageUploadRemoteUrls:!0,filesManagerUploadParam:"file",filesManagerUploadParams:{},googleOptions:{},filesManagerUploadToS3:!1,filesManagerUploadToAzure:!1,filesManagerUploadMethod:"POST",filesManagerMaxSize:10485760,filesManagerAllowedTypes:["*"],imageResize:!0,imageResizeWithPercent:!1,imageRoundPercent:!1,imageDefaultWidth:300,imageDefaultAlign:"center",imageDefaultDisplay:"block",imageSplitHTML:!1,imageStyles:{"fr-rounded":"Rounded","fr-bordered":"Bordered","fr-shadow":"Shadow"},imageMove:!0,imageMultipleStyles:!0,imageTextNear:!0,imagePaste:!0,imagePasteProcess:!1,imageMinWidth:16,imageOutputSize:!1,imageDefaultMargin:5,imageAddNewLine:!1}),St.VIDEO_PROVIDERS=[{test_regex:/^.*((youtu.be)|(youtube.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))?\??v?=?([^#\&\?]*).*/,url_regex:/(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/)?([0-9a-zA-Z_\-]+)(.+)?/g,url_text:"https://www.youtube.com/embed/$1?$2",html:'<iframe width="640" height="360" src="{url}&wmode=opaque" frameborder="0" allowfullscreen></iframe>',provider:"youtube"},{test_regex:/^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/\u200b\d+\/|video\/|)(\d+)(?:$|\/|\?)/,url_regex:/(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?(\/[a-zA-Z0-9_\-]+)?/i,url_text:"https://player.vimeo.com/video/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',provider:"vimeo"},{test_regex:/^.+(dailymotion.com|dai.ly)\/(video|hub)?\/?([^_]+)[^#]*(#video=([^_&]+))?/,url_regex:/(?:https?:\/\/)?(?:www\.)?(?:dailymotion\.com|dai\.ly)\/(?:video|hub)?\/?(.+)/g,url_text:"https://www.dailymotion.com/embed/video/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',provider:"dailymotion"},{test_regex:/^.+(screen.yahoo.com)\/[^_&]+/,url_regex:"",url_text:"",html:'<iframe width="640" height="360" src="{url}?format=embed" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',provider:"yahoo"},{test_regex:/^.+(rutube.ru)\/[^_&]+/,url_regex:/(?:https?:\/\/)?(?:www\.)?(?:rutube\.ru)\/(?:video)?\/?(.+)/g,url_text:"https://rutube.ru/play/embed/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',provider:"rutube"},{test_regex:/^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/,url_regex:/^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/g,url_text:"https://play.vidyard.com/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',provider:"vidyard"}],St.VIDEO_EMBED_REGEX=/^\W*((<iframe(.|\n)*>(\s|\n)*<\/iframe>)|(<embed(.|\n)*>))\W*$/i,St.IMAGE_EMBED_REGEX=/^\W*((<img(.|\n)*>(\s|\n)*))\W*$/i,St.IMAGE_TYPE="image/png",St.IMAGE_ALLOW_REGEX=/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i,St.PLUGINS.filesManager=function(R){var w,o,L,l,c,d,s,f,x=R.$,y="https://i.froala.com/upload",p=!1,t=!1,I=new Map,O=new Map,A=new Map,C=new Map,F=new Map,T=new Map,i=0,r=[],u=-1,M=[],g=0,h=["file","image","imageTUI","video"],N=1,m=2,k=3,S=4,D=5,P=6,B=10,U=["video/avi","video/mpeg","video/x-ms-wmv"],v={};function b(){var e=R.popups.get("filesManager.insert"),t=e.find(".fr-files-by-url-layer input");t.val(""),e.find(".fr-files-embed-layer textarea").val("").trigger("change"),t.trigger("change")}function E(e){var t;R.hasOwnProperty("imageTUI")||(s="fr-disabled"),T.forEach(function(e,t){X(t)}),_()?(t=R.popups.get("filesManager.insert"))||(t=He()):(t=R.popups.get("filesManager.insert"))||(t=function o(){var e="<div style= 'padding:10px'>\n    <div class = 'fr-message'><h3 style ='font-size: 16px; margin: 10px 10px;font-weight: normal;'>".concat(R.language.translate(function n(){var e="",t=function a(){var t=[];return h.forEach(function(e){R.opts.pluginsEnabled.indexOf(e)<0&&t.push(e.charAt(0).toUpperCase()+e.slice(1))}),t}();e=t.join(", "),1<t.length?e+=" plugin are":e+=" plugin is";return e}()+" not enabled. Do you want to enable?"),"</h3></div>\n    <div style='text-align:right;'>\n      <button class='fr-trim-button fr-plugins-enable'>").concat(R.language.translate("Enable"),"</button>               \n      <button class='fr-trim-button fr-plugins-cancel'>").concat(R.language.translate("Cancel"),"</button>\n    </div>"),t={buttons:'<div class="fr-buttons fr-tabs"></div>',upload_layer:e,by_url_layer:"",embed_layer:"",upload_progress_layer:"",progress_bar:""},a=R.popups.create("filesManager.insert",t);return Fe(a),a}());var a=R.$tb.find('.fr-command[data-cmd="insertFiles"]');if(J(),e||!t.hasClass("fr-active"))if(e||Z(),R.popups.refresh("filesManager.insert"),R.popups.setContainer("filesManager.insert",R.$tb),a.isVisible()){var n=R.button.getPosition(a,I.size),r=n.left,i=n.top;R.popups.show("filesManager.insert",r,i,a.outerHeight())}else R.position.forSelection(t),R.popups.show("filesManager.insert");R.popups.setPopupDimensions(t),_()&&R.popups.setFileListHeight(t),t.find(".fr-upload-progress")&&0==I.size&&t.find(".fr-upload-progress").addClass("fr-none")}function _(){var t=!0;return h.forEach(function(e){R.opts.pluginsEnabled.indexOf(e)<0&&(t=!1)}),t}function H(){J()}function $(){if(l||function o(){var e;R.shared.$image_resizer?(l=R.shared.$image_resizer,d=R.shared.$img_overlay,R.events.on("destroy",function(){x("body").first().append(l.removeClass("fr-active"))},!0)):(R.shared.$image_resizer=x(document.createElement("div")).attr("class","fr-image-resizer"),l=R.shared.$image_resizer,R.events.$on(l,"mousedown",function(e){e.stopPropagation()},!0),R.opts.imageResize&&(l.append(z("nw")+z("ne")+z("sw")+z("se")),R.shared.$img_overlay=x(document.createElement("div")).attr("class","fr-image-overlay"),d=R.shared.$img_overlay,e=l.get(0).ownerDocument,x(e).find("body").first().append(d)));R.events.on("shared.destroy",function(){l.html("").removeData().remove(),l=null,R.opts.imageResize&&(d.remove(),d=null)},!0),R.helpers.isMobile()||R.events.$on(x(R.o_win),"resize",function(){w&&!w.hasClass("fr-uploading")?at(!0):w&&($(),replace(),Q(!1))});if(R.opts.imageResize){e=l.get(0).ownerDocument,R.events.$on(l,R._mousedown,".fr-handler",K),R.events.$on(x(e),R._mousemove,G),R.events.$on(x(e.defaultView||e.parentWindow),R._mouseup,V),R.events.$on(d,"mouseleave",V);var n=1,r=null,i=0;R.events.on("keydown",function(e){if(w){var t=-1!=navigator.userAgent.indexOf("Mac OS X")?e.metaKey:e.ctrlKey,a=e.which;(a!==r||200<e.timeStamp-i)&&(n=1),(a==St.KEYCODE.EQUALS||R.browser.mozilla&&a==St.KEYCODE.FF_EQUALS)&&t&&!e.altKey?n=je.call(this,e,1,1,n):(a==St.KEYCODE.HYPHEN||R.browser.mozilla&&a==St.KEYCODE.FF_HYPHEN)&&t&&!e.altKey?n=je.call(this,e,2,-1,n):R.keys.ctrlKey(e)||a!=St.KEYCODE.ENTER||(w.before("<br>"),Ae(w)),r=a,i=e.timeStamp}},!0),R.events.on("keyup",function(){n=1})}}(),!w)return!1;var e=R.$wp||R.$sc;e.append(l),l.data("instance",R);var t=e.scrollTop()-("static"!=e.css("position")?e.offset().top:0),a=e.scrollLeft()-("static"!=e.css("position")?e.offset().left:0);a-=R.helpers.getPX(e.css("border-left-width")),t-=R.helpers.getPX(e.css("border-top-width")),R.$el.is("img")&&R.$sc.is("body")&&(a=t=0);var n=lt();ct()&&(n=n.find(".fr-img-wrap"));var r=0,i=0;R.opts.iframe&&(r=R.helpers.getPX(R.$wp.find(".fr-iframe").css("padding-top")),i=R.helpers.getPX(R.$wp.find(".fr-iframe").css("padding-left"))),l.css("top",(R.opts.iframe?n.offset().top+r:n.offset().top+t)-1).css("left",(R.opts.iframe?n.offset().left+i:n.offset().left+a)-1).css("width",n.get(0).getBoundingClientRect().width).css("height",n.get(0).getBoundingClientRect().height).addClass("fr-active")}function z(e){return'<div class="fr-handler fr-h'.concat(e,'"></div>')}function W(e){ct()?w.parents(".fr-img-caption").css("width",e):w.css("width",e)}function K(e){if(!R.core.sameInstance(l))return!0;if(e.preventDefault(),e.stopPropagation(),R.$el.find("img.fr-error").left)return!1;R.undo.canDo()||R.undo.saveStep();var t=e.pageX||e.originalEvent.touches[0].pageX;if("mousedown"==e.type){var a=R.$oel.get(0).ownerDocument,n=a.defaultView||a.parentWindow,r=!1;try{r=n.location!=n.parent.location&&!(n.$&&n.$.FE)}catch(s){}r&&n.frameElement&&(t+=R.helpers.getPX(x(n.frameElement).offset().left)+n.frameElement.clientLeft)}(c=x(this)).data("start-x",t),c.data("start-width",w.width()),c.data("start-height",w.height());var i=w.width();if(R.opts.imageResizeWithPercent){var o=w.parentsUntil(R.$el,R.html.blockTagsQuery()).get(0)||R.el;i=(i/x(o).outerWidth()*100).toFixed(2)+"%"}W(i),d.show(),R.popups.hideAll(),it()}function G(e){if(!R.core.sameInstance(l))return!0;var t;if(c&&w){if(e.preventDefault(),R.$el.find("img.fr-error").left)return!1;var a=e.pageX||(e.originalEvent.touches?e.originalEvent.touches[0].pageX:null);if(!a)return!1;var n=a-c.data("start-x"),r=c.data("start-width");if((c.hasClass("fr-hnw")||c.hasClass("fr-hsw"))&&(n=0-n),R.opts.imageResizeWithPercent){var i=w.parentsUntil(R.$el,R.html.blockTagsQuery()).get(0)||R.el;r=((r+n)/x(i).outerWidth()*100).toFixed(2),R.opts.imageRoundPercent&&(r=Math.round(r)),W("".concat(r,"%")),(t=ct()?(R.helpers.getPX(w.parents(".fr-img-caption").css("width"))/x(i).outerWidth()*100).toFixed(2):(R.helpers.getPX(w.css("width"))/x(i).outerWidth()*100).toFixed(2))===r||R.opts.imageRoundPercent||W("".concat(t,"%")),w.css("height","").removeAttr("height")}else r+n>=R.opts.imageMinWidth&&(W(r+n),t=ct()?R.helpers.getPX(w.parents(".fr-img-caption").css("width")):R.helpers.getPX(w.css("width"))),t!==r+n&&W(t),((w.attr("style")||"").match(/(^height:)|(; *height:)/)||w.attr("height"))&&(w.css("height",c.data("start-height")*w.width()/c.data("start-width")),w.removeAttr("height"));$(),R.events.trigger("image.resize",[st()])}}function V(e){if(!R.core.sameInstance(l))return!0;if(c&&w){if(e&&e.stopPropagation(),R.$el.find("img.fr-error").left)return!1;c=null,d.hide(),$(),R.undo.saveStep(),R.events.trigger("image.resizeEnd",[st()])}else l.removeClass("fr-active")}function Y(){T.forEach(function(e,t){var a=R.popups.get("filesManager.insert");a.find(".fr-checkbox-file-"+t).get(0).disabled=!0,document.getElementById("fr-file-autoplay-button-"+t)&&(document.getElementById("fr-file-autoplay-button-"+t).disabled=!0,document.getElementById("fr-file-autoplay-button-"+t).parentElement.classList.add("fr-checkbox-disabled"),document.getElementById("fr-file-autoplay-button-"+t).parentElement.classList.remove("fr-files-checkbox")),a.find(".fr-checkbox-"+t).get(0).classList.remove("fr-files-checkbox"),a.find(".fr-checkbox-"+t).get(0).classList.add("fr-checkbox-disabled")})}function j(e,t,a,n){R.edit.on(),w&&w.addClass("fr-error"),v[e]?(e!=k&&e!=m&&e!=S||_e(100,n,!0),T.set(n,v[e]),Y(),function r(){T.forEach(function(e,t){R.popups.get("filesManager.insert"),document.getElementById("fr-file-edit-button-".concat(t))&&(document.getElementById("fr-file-edit-button-".concat(t)).classList.add("fr-disabled"),document.getElementById("fr-file-view-button-".concat(t)).classList.add("fr-disabled"),document.getElementById("fr-file-insert-button-".concat(t)).classList.add("fr-disabled"))})}(),ae(R.language.translate(v[e]),n)):ae(R.language.translate("Something went wrong. Please try again."),n),!w&&a&&qe(a),R.events.trigger("filesManager.error",[{code:e,message:v[e]},t,a])}function q(){var e=R.popups.get("filesManager.insert"),t=e.find('.fr-command[data-cmd="insertAll"]'),a=e.find('.fr-command[data-cmd="deleteAll"]'),n=!0;F.forEach(function r(e,t,a){F.get(t)&&(n=!1)}),n?t.addClass("fr-disabled"):t.removeClass("fr-disabled"),n?a.addClass("fr-disabled"):a.removeClass("fr-disabled")}function X(e){O.get(e)&&O.get(e).link&&R.events.trigger("filesManager.removed",[O.get(e).link]);var t=R.popups.get("filesManager.insert");t.find(".fr-file-"+e).get(0)!==undefined&&(t.find(".fr-file-"+e).get(0).outerHTML=""),O["delete"](e),I["delete"](e),F["delete"](e),q(),0==I.size&&(g=0),T["delete"](e),R.popups.setPopupDimensions(t,!0),R.opts.toolbarBottom?E(!0):R.popups.setPopupDimensions(t),t.find(".fr-upload-progress")&&0==I.size&&t.find(".fr-upload-progress").addClass("fr-none")}function Z(){for(var e=R.popups.get("filesManager.insert"),t=e.find(".fr-insert-checkbox"),a=0;a<t.length;a++)t.get(a).children.target.checked=!1,e.find(".fr-file-"+t.get(a).id.split("-").pop()).get(0).classList.add("fr-unchecked");if(L)document.getElementById("fr-file-autoplay-button-".concat(L))&&(document.getElementById("fr-file-autoplay-button-".concat(L)).checked=!1),M=M.filter(function(e){return e!=L});else{for(var n=e.find(".fr-file-autoplay-button"),r=0;r<n.length;r++)n.get(r).checked=!1;M=[]}F=new Map,q()}function Q(e){var t=R.popups.get("filesManager.insert");if(t||(t=He()),t.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"),t.find(".fr-files-progress-bar-layer").addClass("fr-active"),t.find(".fr-buttons").hide(),w){var a=lt();R.popups.setContainer("filesManager.insert",R.$sc);var n=a.offset().left,r=a.offset().top+a.height();R.popups.show("filesManager.insert",n,r,a.outerHeight())}void 0===e&&ee(R.language.translate("Uploading"),0)}function J(e){var t=R.popups.get("filesManager.insert");if(t&&(t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"),t.find(".fr-files-progress-bar-layer").removeClass("fr-active"),t.find(".fr-buttons").show(),e||R.$el.find("img.fr-error").length)){if(R.events.focus(),R.$el.find("img.fr-error").length&&(R.$el.find("img.fr-error").remove(),R.undo.saveStep(),R.undo.run(),R.undo.dropRedo()),!R.$wp&&w){var a=w;at(!0),R.selection.setAfter(a.get(0)),R.selection.restore()}R.popups.hide("filesManager.insert")}}function ee(e,t){var a=R.popups.get("filesManager.insert");if(a){var n=a.find(".fr-files-progress-bar-layer");n.find("h3").text(e+(t?" ".concat(t,"%"):"")),n.removeClass("fr-error"),t?(n.find("div").removeClass("fr-indeterminate"),n.find("div > span").css("width","".concat(t,"%"))):n.find("div").addClass("fr-indeterminate")}}function te(e){Q();var t=R.popups.get("filesManager.insert").find(".fr-files-progress-bar-layer");t.addClass("fr-error");var a=t.find("h3");a.text(e),R.events.disableBlur(),a.focus()}function ae(e,t){var a=R.popups.get("filesManager.insert"),n=a.find(".fr-upload-progress-layer"),r=a.find(".fr-file-".concat(t));n.addClass("fr-error"),r.find("h5").text(e)}v[N]="File cannot be loaded from the passed link.",v[m]="No link in upload response.",v[k]="Error during file upload.",v[S]="Parsing response failed.",v[D]="File is too large.",v[P]="File type is invalid.",v[7]="Files can be uploaded only to same domain in IE 8 and IE 9.",v[8]="File is corrupted.",v[9]="Error during file loading.",v[B]="File upload cancelled";var a,ne,re,ie,oe,se,n,le,ce,de,fe="";function pe(e){fe=e,a=document.getElementsByClassName(e),Array.prototype.map.call(a,function(e){!function n(e){if(e.addEventListener("dragover",function(e){e.preventDefault(),e.stopPropagation(),ne=e.pageX,re=e.pageY;var t=document.getElementById("filesList");re+20>t.getBoundingClientRect().bottom&&ue(t,0,10),re-20<t.getBoundingClientRect().top&&ue(t,0,-10)},!1),R.helpers.isMobile()){var t=e.getElementsByClassName("dot");t[0].addEventListener("touchmove",function(e){e.preventDefault(),e.stopPropagation();for(var t=e.target;t&&!t.classList.contains(fe);)t=t.parentElement;for(var a=document.elementFromPoint(e.targetTouches[0].clientX,e.targetTouches[0].clientY);a&&!a.classList.contains(fe);)a=a.parentElement;var n=document.getElementsByClassName("fr-hovered-over-file");Array.prototype.forEach.call(n,function(e){e.classList.remove("fr-hovered-over-file")}),a&&!t.classList.contains("fr-unchecked")&&a.classList.add("fr-hovered-over-file");var r=document.getElementById("filesList");e.targetTouches[0].clientY+5>r.getBoundingClientRect().bottom&&ue(r,0,5),e.targetTouches[0].clientY-5<r.getBoundingClientRect().top&&ue(r,0,-5)},!1)}if(e.ondrag=ge,e.ondragend=he,R.helpers.isMobile()){var a=e.getElementsByClassName("dot");a[0].addEventListener("touchmove",ge,!1),a[0].addEventListener("touchend",he,!1)}}(e)})}function ue(e,t,a){e.scrollLeft+=t,e.scrollTop+=a}function ge(e){for(R.helpers.isMobile()&&(oe=event.touches[0].clientX,se=event.touches[0].clientY),ie=e.target;!ie.classList.contains(fe);)ie=ie.parentElement;ie.classList.contains(fe)&&!ie.classList.contains("fr-unchecked")?R.helpers.isMobile()&&ie.classList.add("drag-sort-active"):ie=undefined}function he(e){var t;if(ie!==undefined){var a,n;if(R.helpers.isMobile())for(a=oe,n=se,t=event.target;!t.classList.contains(fe);)t=t.parentElement;else a=event.clientX,n=event.clientY;R.helpers.isMobile()||!R.browser.safari&&!R.browser.mozilla||(a=ne,n=re);for(var r=document.elementFromPoint(a,n);r&&!r.classList.contains(fe);)r=r.parentElement;r&&!r.classList.contains(fe)?r=undefined:r&&ie!==r&&function s(e,t){var a,n,r=e.parentNode,i=t.parentNode;if(!r||!i||r.isEqualNode(t)||i.isEqualNode(e))return;for(var o=0;o<r.children.length;o++)r.children[o].isEqualNode(e)&&(a=o);for(var o=0;o<i.children.length;o++)i.children[o].isEqualNode(t)&&(n=o);r.isEqualNode(i)&&a<n&&n++;r.insertBefore(t,r.children[a]),i.insertBefore(e,i.children[n])}(ie,r),R.helpers.isMobile()&&(t.classList.remove("fr-hovered-over-file"),r.classList.remove("fr-hovered-over-file"))}}function me(e){var n=R.popups.get("filesManager.insert");n.find(".fr-upload-progress-layer").hasClass("fr-active")||n.find(".fr-upload-progress-layer").addClass("fr-active"),n.find(".fr-upload-progress").removeClass("fr-none");var t=I.get(e),a=function o(e){var t,a={weekday:"long",year:"numeric",month:"long",day:"numeric"};try{t=e.toLocaleDateString(R.opts.language?R.opts.language:undefined,a)}catch(n){t=e.toLocaleDateString(undefined,a)}return t+""}(new Date),r=F.get(e)?"":"fr-unchecked ",i="\n        <div id='fr-file-".concat(e,"' class='fr-file-list-item fr-file-").concat(e," ").concat(r,"' draggable = \"").concat(!r,'" >\n        <div class=\'fr-file-item-left\' >\n\n    \n            <div class="fr-file-item-insert-checkbox fr-files-checkbox-line">\n            ').concat(R.helpers.isMobile()?"<div id='fr-pick-".concat(e,"}' class='dot'>\n            </div>"):"",'\n            <div id="checkbox-key-').concat(e,'" class="fr-files-checkbox fr-insert-checkbox  fr-checkbox-').concat(e,'">\n            <input name="target" class="fr-insert-attr fr-checkbox-file-').concat(e,' fr-file-insert-check" data-cmd="fileInsertCheckbox"\n             data-checked="_blank" type="checkbox" id="fr-link-target-').concat(R.id,'" tabIndex="0" />\n            <span>').concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>','\n            </span>\n        </div>\n                <label id="fr-label-target-').concat(R.id,"\"></label>\n            </div>\n    \n            <div class='fr-file-item-icon fr-file-item-icon-").concat(e,"' >\n                <img src='https://secure.webtoolhub.com/static/resources/icons/set112/f2afb6f7.png' alt='Image preview' class='fr-thumbnail-padding' height='36px' width='36px' />\n            </div>\n\n            <div class='fr-file-item-description' >\n                <div class='fr-file-name fr-files-manager-tooltip'>\n                   ").concat(function s(e,t,a){null==t&&(t=100);null==a&&(a="...");return e.length>t?e.substring(0,t-a.length)+a:e}(t.name,20),'\n                      <span class="').concat(20<t.name.length?"tooltiptext":"fr-none",'">').concat(t.name,"\n                      </span>\n                 </div>\n                 <div class='fr-file-details'>\n                 <div class='fr-file-date'>").concat(a,"\n                 </div>\n \n                 <div class='fr-file-size'>\n                     ").concat(function l(e){if(0==e)return"0 Bytes";var t=Math.floor(Math.log(e)/Math.log(1024));return" | "+1*(e/Math.pow(1024,t)).toFixed(2)+" "+["Bytes","KB","MB","GB","TB"][t]}(t.size),"\n                 </div>\n                 </div>\n\n                  <div class='fr-file-error'>\n                    <h5 class='fr-file-error-h5'></h5>\n                 </div>\n             </div>\n    \n        </div>\n\n        <div class='fr-file-item-right fr-file-item-right-").concat(e,"'>")+Ee(e)+"</div>\n    </div>";n.find(".fr-upload-progress-layer")[0].innerHTML=i+n.find(".fr-upload-progress-layer")[0].innerHTML,I.forEach(function c(e,t,a){F.get(t)&&n.find("input.fr-insert-attr.fr-checkbox-file-".concat(t))[0].setAttribute("checked",null)}),M.forEach(function(e){document.getElementById("fr-file-autoplay-button-"+e).checked=!0}),be(e,t),J(),R.opts.toolbarBottom?E(!0):R.popups.setPopupDimensions(n),pe("fr-file-list-item")}function ve(e){switch(e){case"application/msword":return R.icon.getFileIcon("docIcon");case"application/vnd.openxmlformats-officedocument.wordprocessingml.document":return R.icon.getFileIcon("docxIcon");case"image/gif":return R.icon.getFileIcon("gifIcon");case"image/jpeg":return R.icon.getFileIcon("jpegIcon");case"image/jpeg":return R.icon.getFileIcon("jpgIcon");case"type/text":return R.icon.getFileIcon("logIcon");case"video/quicktime":return R.icon.getFileIcon("movIcon");case"audio/mp3":case"audio/mpeg":return R.icon.getFileIcon("mp3Icon");case"video/mp4":return R.icon.getFileIcon("mp4Icon");case"audio/ogg":return R.icon.getFileIcon("oggIcon");case"video/ogg":return R.icon.getFileIcon("ogvIcon");case"application/pdf":return R.icon.getFileIcon("pdfIcon");case"image/png":return R.icon.getFileIcon("pngIcon");case"text/plain":return R.icon.getFileIcon("txtIcon");case"video/webm":return R.icon.getFileIcon("webmIcon");case"image/webp":return R.icon.getFileIcon("webpIcon");case"video/x-ms-wmv":return R.icon.getFileIcon("wmvIcon");case"application/vnd.ms-excel":return R.icon.getFileIcon("xlsIcon");case"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":return R.icon.getFileIcon("xlsxIcon");case"application/x-zip-compressed":case"application/zip":return R.icon.getFileIcon("zipIcon");default:return R.icon.getFileIcon("defaultIcon")}}function be(n,r,e){var i=R.popups.get("filesManager.insert"),t=i.find(".fr-file-item-icon-"+n).get(0);if(Ne(Re(r))&&"image/gif"!=Re(r)&&"image/webp"!=Re(r)){"a"!=t.children[0].localName&&(t.innerHTML="<a target='_blank' href=''>"+t.innerHTML+"</a>");i.find(".fr-file-item-icon-"+n).get(0).children[0].children[0];var o=new FileReader;if(null!=e&&e){var a=I.get(n);r.name=a.name,I.set(n,r)}if(o.onloadend=function(){i.find(".fr-file-item-icon-"+n).get(0).children[0].children[0].src=o.result;for(var e=atob(o.result.split(",")[1]),t=[],a=0;a<e.length;a++)t.push(e.charCodeAt(a));i.find(".fr-file-item-icon-"+n).get(0).children[0].href=window.URL.createObjectURL(new Blob([new Uint8Array(t)],{type:Re(r)})),i.find(".fr-file-item-icon-"+n).get(0).classList.add("fr-file-item-thumbnail-hover")},r)o.readAsDataURL(r);else{var s=ve(Re(r));t.innerHTML='<svg height="40px" width="40px" viewBox="0 0 55 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n        '.concat(s.path,"\n        </svg>")}}else{var l=ve(Re(r));t.innerHTML='<svg height="40px" width="40px" viewBox="0 0 55 55" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n      '.concat(l.path,"\n      </svg>")}}function Ee(e){var t="";if(Pe(Re(I.get(e)))){var a="fr-files-checkbox",n="";Ue(Re(I.get(e)))||(a="fr-checkbox-disabled",n="disabled");t='\n      <div class="fr-files-checkbox-line align-autoplay">\n      <div id="checkbox-key-'.concat(e,'" class="').concat(a," fr-autoplay-checkbox  fr-checkbox-").concat(e,'">  \n                   \n      <input type="checkbox" id="fr-file-autoplay-button-').concat(e,'" class="fr-file-button-').concat(e,' fr-file-autoplay-button" data-title="Edit" data-param1="').concat(e,'" role="button" ').concat(n,"/>\n\n      <span>").concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>'," </span>\n      </div>      \n      <label  class='fr-autoplay-checkbox-label'>Autoplay </label>\n      </div>")}var r="application/msword",i="application/vnd.openxmlformats-officedocument.wordprocessingml.document",o="";return!Be(Re(I.get(e)))&&Ue(Re(I.get(e)))||(s="fr-disabled"),Pe(Re(I.get(e)))&&(s="fr-disabled"),De(Re(I.get(e)))&&(s="fr-disabled",Re(I.get(e))!=r&&Re(I.get(e))!=i||R.opts.googleOptions&&!R.helpers.isMobile()&&R.opts.googleOptions.API_KEY&&R.opts.googleOptions.CLIENT_ID&&(s=""),"text/plain"!=Re(I.get(e))&&Re(I.get(e))!=r&&"application/pdf"!=Re(I.get(e))&&Re(I.get(e))!=i&&"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"!=Re(I.get(e))&&"application/vnd.ms-excel"!=Re(I.get(e))&&"type/text"!=Re(I.get(e))||(o="")),"video/url"===Re(I.get(e))&&(s="fr-disabled"),t+='<div class=\'fr-file-item-action-buttons\' >\n                <button type="button" id="fr-file-insert-button-'.concat(e,'" class=" fr-doc-edit-').concat(e," fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons \n                fr-file-button-").concat(e," fr-file-insert-button-").concat(e,' fr-file-insert-button" data-cmd="imageInsertByUpload" data-title="Insert" data-param1="').concat(e,'" tabIndex="2" role="button">\n                <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "-5 0 28 28" xlmns = "http://w3.org/200/svg"><path d = \'M 9.25 12 L 6.75 12 C 6.335938 12 6 11.664062 6 11.25 L 6 6 L 3.257812 6 C 2.703125 6 2.425781 5.328125 2.820312 4.933594 L 7.570312 0.179688 C 7.804688 -0.0546875 8.191406 -0.0546875 8.425781 0.179688 L 13.179688 4.933594 C 13.574219 5.328125 13.296875 6 12.742188 6 L 10 6 L 10 11.25 C 10 11.664062 9.664062 12 9.25 12 Z M 16 11.75 L 16 15.25 C 16 15.664062 15.664062 16 15.25 16 L 0.75 16 C 0.335938 16 0 15.664062 0 15.25 L 0 11.75 C 0 11.335938 0.335938 11 0.75 11 L 5 11 L 5 11.25 C 5 12.214844 5.785156 13 6.75 13 L 9.25 13 C 10.214844 13 11 12.214844 11 11.25 L 11 11 L 15.25 11 C 15.664062 11 16 11.335938 16 11.75 Z M 12.125 14.5 C 12.125 14.15625 11.84375 13.875 11.5 13.875 C 11.15625 13.875 10.875 14.15625 10.875 14.5 C 10.875 14.84375 11.15625 15.125 11.5 15.125 C 11.84375 15.125 12.125 14.84375 12.125 14.5 Z M 14.125 14.5 C 14.125 14.15625 13.84375 13.875 13.5 13.875 C 13.15625 13.875 12.875 14.15625 12.875 14.5 C 12.875 14.84375 13.15625 15.125 13.5 15.125 C 13.84375 15.125 14.125 14.84375 14.125 14.5 Z M 14.125 14.5 \'></path></svg>\n                </button>\n\n                <button type="button" id="fr-file-edit-button-').concat(e,'" class=" fr-doc-edit-').concat(e," ").concat(s," fr-img-icon fr-btn fr-command fr-submit \n                fr-file-action-icons fr-file-edit-button-").concat(e," fr-file-button-").concat(e,' fr-file-edit-button" data-cmd="editImage" data-title="Edit" data-param1="').concat(e,'" role="button">\n                <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "0 4 25 25" xlmns = "http://w3.org/200/svg"><path d = \'M17,11.2L12.8,7L5,14.8V19h4.2L17,11.2z M7,16.8v-1.5l5.6-5.6l1.4,1.5l-5.6,5.6H7z M13.5,6.3l0.7-0.7c0.8-0.8,2.1-0.8,2.8,0  c0,0,0,0,0,0L18.4,7c0.8,0.8,0.8,2,0,2.8l-0.7,0.7L13.5,6.3z\'></path></svg>\n                </button>\n                \n                <span class="fr-file-view-').concat(e,'"><button type="button" id="fr-file-view-button-').concat(e,'" class=" fr-doc-edit-').concat(e," ").concat(o," fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons \n                fr-file-view-button-").concat(e,' fr-file-view-button" data-cmd="viewImage" data-title="View" data-param1="').concat(e,'" tabIndex="2" role="button">\n                <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "15 19 21 21" xlmns = "http://w3.org/200/svg"> <path style="fill:none;stroke-width:0.9077;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(0%,0%,0%);stroke-opacity:1;stroke-miterlimit:10;" d="M 19.086094 16.541466 C 16.185625 16.541466 14.318281 19.447115 14.318281 19.447115 L 14.318281 19.555288 C 14.318281 19.555288 16.176719 22.475962 19.077187 22.475962 C 21.977656 22.475962 23.847969 19.576322 23.847969 19.576322 L 23.847969 19.465144 C 23.847969 19.465144 21.989531 16.541466 19.086094 16.541466 Z M 19.07125 21.024639 C 18.248906 21.024639 17.583906 20.357572 17.583906 19.53726 C 17.583906 18.716947 18.248906 18.04988 19.07125 18.04988 C 19.890625 18.04988 20.555625 18.716947 20.555625 19.53726 C 20.555625 20.357572 19.890625 21.024639 19.07125 21.024639 Z M 19.07125 21.024639 " transform="matrix(1.315789,0,0,1.3,0,0)"/></svg></button></span>\n\n                <button type="button" id="fr-file-delete-button-').concat(e,'" class=" fr-doc-edit-').concat(e," fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons\n                fr-file-button-").concat(e,' fr-file-delete-button" data-cmd="deleteImage" data-title="Delete" data-param1="').concat(e,'" role="button">\n                <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "-2 3 30 30" xlmns = "http://w3.org/200/svg"><path d = \'M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z\'></path></svg>\n                </button>\n                 \n            </div>\n            <div id="user_area-').concat(e,"\" style=\"display: none;\">\n            \n              <div id=\"file_container\"></div>\n\n              <div style='display:block;text-align: center; margin-left:50%; id='edit-file-loader' class='fr-file-loader'></div>\n\n          </div> \n            ")}function _e(e,t,a){var n=R.popups.get("filesManager.insert");if(!a&&e<=100){n.find(".fr-checkbox-file-"+t).get(0).disabled=!0,n.find(".fr-checkbox-"+t).get(0).classList.remove("fr-files-checkbox"),n.find(".fr-checkbox-"+t).get(0).classList.add("fr-checkbox-disabled");var r=n.find(".fr-file-progress-circle-"+t),i=n.find(".fr-file-upload-percent-"+t);return 50<e?r.get(0).setAttribute("class","fr-file-progress-circle-"+t+" progress-circle p"+Math.floor(e)+" over50"):r.get(0).setAttribute("class","fr-file-progress-circle-"+t+" progress-circle p"+Math.floor(e)),i.get(0).innerHTML=Math.floor(e)+"%",void we(t,e,a)}a&&(n.find(".fr-checkbox-file-"+t).get(0).disabled=!1,n.find(".fr-checkbox-"+t).get(0).classList.remove("fr-checkbox-disabled"),n.find(".fr-checkbox-"+t).get(0).classList.add("fr-files-checkbox"),n.find(".fr-file-item-right-"+t).get(0).innerHTML=Ee(t),we(t,100,a))}function we(e,t,a){var n=R.popups.get("filesManager.insert");n.find(".fr-progress-bar").removeClass("fr-none").addClass("fr-display-block"),n.find(".fr-upload-progress").hasClass("fr-height-set")&&R.popups.setFileListHeight(n);var r=0;C.set(e,t),C.forEach(function(e,t){r+=e}),r/=C.size,100==t&&a&&i++,n.find('.fr-command[data-cmd="filesUpload"]').addClass("fr-disabled"),n.find('.fr-command[data-cmd="filesByURL"]').addClass("fr-disabled"),n.find('.fr-command[data-cmd="filesEmbed"]').addClass("fr-disabled"),n.find(".fr-progress-bar").get(0).style.width=r+"%",i==C.size&&(n.find(".fr-progress-bar").removeClass("fr-display-block").addClass("fr-none"),C=new Map,i=0,n.find('.fr-command[data-cmd="filesUpload"]').removeClass("fr-disabled"),n.find('.fr-command[data-cmd="filesByURL"]').removeClass("fr-disabled"),n.find('.fr-command[data-cmd="filesEmbed"]').removeClass("fr-disabled"))}function ye(a,n){J(),R.popups.get("filesManager.insert").find(".fr-upload-progress-layer").addClass("fr-active"),a.forEach(function(e,t){Ne(Re(e))&&R.opts.imageUploadRemoteUrls&&R.opts.imageCORSProxy&&R.opts.imageUpload?Oe(e,a,w,n[t]):O.set(n[t],e)})}function Ae(e){e&&e.get&&function a(e){if("false"==x(this).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable"))return!0;if(e&&"touchend"==e.type&&de)return!0;if(e&&R.edit.isDisabled())return e.stopPropagation(),e.preventDefault(),!1;for(var t=0;t<St.INSTANCES.length;t++)St.INSTANCES[t]!=R&&St.INSTANCES[t].events.trigger("image.hideResizer");R.toolbar.disable(),e&&(e.stopPropagation(),e.preventDefault());R.helpers.isMobile()&&(R.events.disableBlur(),R.$el.blur(),R.events.enableBlur());R.opts.iframe&&R.size.syncIframe();w=x(this),$(),R.browser.msie?(R.popups.areVisible()&&R.events.disableBlur(),R.win.getSelection&&(R.win.getSelection().removeAllRanges(),R.win.getSelection().addRange(R.doc.createRange()))):R.selection.clear();R.helpers.isIOS()&&(R.events.disableBlur(),R.$el.blur());R.button.bulkRefresh(),R.events.trigger("video.hideResizer")}.call(e.get(0))}function Ce(){var e=x(this);e.removeClass("fr-uploading"),e.next().is("br")&&e.next().remove(),(0==r.length||0<r.length&&r.length==u)&&(f=e),"VIDEO"==e.get(0).tagName||"AUDIO"==e.get(0).tagName?R.selection.setAfter(e.parent()):R.selection.setAfter(e),R.undo.saveStep(),R.events.trigger("filesManager.loaded",[e]),ke(r)}function Te(){var e,t=Array.prototype.slice.call(R.el.querySelectorAll("video, .fr-video > *")),a=[];for(e=0;e<t.length;e++)a.push(t[e].getAttribute("src")),x(t[e]).toggleClass("fr-draggable",R.opts.videoMove),""===t[e].getAttribute("class")&&t[e].removeAttribute("class"),""===t[e].getAttribute("style")&&t[e].removeAttribute("style");if(n)for(e=0;e<n.length;e++)a.indexOf(n[e].getAttribute("src"))<0&&R.events.trigger("video.removed",[x(n[e])]);n=t}function ke(e){if(null!=e){if(0==e.length)return void(null!=f&&("VIDEO"==f.get(0).tagName?R.video._editVideo(f.parent()):"IMG"==f.get(0).tagName?R.image.edit(f):f.trigger("click"),R.toolbar.disable()));Le(e.shift(),e)}}function Se(e){var t=!1;if(Pe(Re(O.get(e))))R.trimVideoPlugin.trimVideo(I.get(e),e,I),t=!0;else if(Ne(Re(O.get(e)))){var a=O.get(e).link,n=R.o_doc.createElement("img");n.src=a,w=n,o=e,R.imageTUI.launch(R,!1,e),t=!0}else if(De(Re(O.get(e)))){var r={apiKey:R.opts.googleOptions.API_KEY,clientId:R.opts.googleOptions.CLIENT_ID,authorizeButton:"authorize_button-".concat(e),signoutButton:"signout_button",userArea:"user_area-".concat(e),fileInput:"file_input",fileIndex:e,file:I.get(e),fileContainer:"file_container",loadingText:"File is being uploaded...",events:{onInvalidFile:function(e){},onError:function(e){}}};ce=function d(p){var i,e=["https://www.googleapis.com/discovery/v1/apis/drive/v2/rest"],u="id,title,mimeType,userPermission,editable,copyable,shared,fileSize",g="-------314159265358979323846",h="\r\n--"+g+"\r\n",m="\r\n--"+g+"--",t=(document.getElementById(p.authorizeButton),document.getElementById(p.userArea));p.events||(p.events={});function a(){gapi.client.init({apiKey:p.apiKey,clientId:p.clientId,discoveryDocs:e,scope:"https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.appdata"}).then(function(){gapi.auth2.getAuthInstance().isSignedIn.listen(n),n(gapi.auth2.getAuthInstance().isSignedIn.get()),function t(e){!gapi.auth2.getAuthInstance().isSignedIn.get()||gapi.auth.getToken()!==undefined&&gapi.auth.getToken().access_token===undefined?Promise.resolve(gapi.auth2.getAuthInstance().signIn()).then(function(){o()}):o()}()},function(e){p.events.onError(e)})}function n(e){e&&(t.style.display="block")}function r(e){var t=gapi.auth.getToken().access_token,a=i,n="https://docs.google.com/feeds/download/documents/export/Export?id="+a+"&format=docx&access_token="+t,r=new XMLHttpRequest;r.open("get",n),r.responseType="arraybuffer",r.onload=function(){var e=new Blob([new Uint8Array(this.response)],{type:"application/vnd.openxmlformats-officedocument.wordprocessingml.document"}),t=I.get(p.fileIndex);e.name=t.name,e.lastModified=t.lastModified,e.lastModifiedDate=t.lastModifiedDate,I.set(p.fileIndex,e),R.filesManager.upload(e,O,w,p.fileIndex),l()},r.send()}function o(e){!function n(e){for(var t=document.getElementsByClassName("fr-doc-edit-".concat(e)),a=0;a<t.length;a++)t[a].setAttribute("disabled",!0),t[a].classList.add("fr-disabled")}(p.fileIndex);var t=p.file;t?function a(c,d){var f=new FileReader;f.readAsArrayBuffer(c),f.onload=function(e){for(var t={title:c.name,mimeType:"application/vnd.google-apps.document"},a="",n=new Uint8Array(f.result),r=n.byteLength,i=0;i<r;i++)a+=String.fromCharCode(n[i]);var o=btoa(a),s=h+"Content-Type: application/json; charset=UTF-8\r\n\r\n"+JSON.stringify(t)+h+"Content-Type: application/octet-stream\r\nContent-Transfer-Encoding: base64\r\n\r\n"+o+m,l=gapi.client.request({path:"/upload/drive/v2/files",method:"POST",params:{uploadType:"multipart",fields:u},headers:{"Content-Type":'multipart/related; boundary="'+g+'"',"Content-Length":s.Length},body:s});d||(d=function(e){}),l.execute(function(e,t){e.error?p.events.onError(e.error):d(e)})}}(t,s):p.events.onInvalidFile("File is not selected")}function s(e){i=e.id;var t="https://docs.google.com/document/d/"+e.id+"/edit",a=R.o_doc.body,n=R.o_doc.createElement("div");n.setAttribute("id","editDocContainer"),n.style.cssText="position: fixed; top: 0;left: 0;padding: 0;width: 100%;height: 100%;background: rgba(255,255,255,1);z-index: 9998;display:block",n.innerHTML='<div style="margin-top:25px; text-align:center"><label>Sign Out : </label><input type="checkbox" id ="markSignOut" role="button"/>  <button id="signout_button"  class="fr-trim-button" >Save </button> <button id="cancel_file_edit" class="fr-trim-button">Cancel</button></div>  <iframe title="Edit your file" frameBorder="0" width="100%" height="700px" src="'+t+'"></iframe>',a.appendChild(n),document.getElementById("signout_button").onclick=r,document.getElementById("cancel_file_edit").onclick=l}function l(){document.getElementById("markSignOut").checked&&gapi.auth2.getAuthInstance().signOut().then(function(){gapi.auth.getToken()&&(gapi.auth.getToken().access_token=undefined)});var e=document.getElementById("editDocContainer");e.parentNode.removeChild(e),document.getElementById("user_area-".concat(p.fileIndex))&&(document.getElementById("user_area-".concat(p.fileIndex)).style.display="none"),function n(e){for(var t=document.getElementsByClassName("fr-doc-edit-".concat(e)),a=0;a<t.length;a++)t[a].removeAttribute("disabled"),t[a].classList.remove("fr-disabled")}(p.fileIndex)}p.events.onInvalidFile=p.events.onInvalidFile||function(e){},p.events.onError=p.events.onError||function(e){};var c={};return c.handleClientLoad=function(){gapi.load("client:auth2",a)},c}(r),function i(e,t){var n=function n(e,t){var a=document.createElement("script");a.src=e,a.onload=function(){this.onload=function(){},ce.handleClientLoad()},a.onreadystatechange=function(){"complete"===this.readyState&&this.onload()},(document.getElementsByTagName("head")[0]||document.body).appendChild(a)};!function a(){0!=e.length?n(e.shift(),a):t&&t()}()}(["https://apis.google.com/js/api.js"],function(){})}t&&(p=!0)}function Re(e){var a;if(""!=e.type)return e.type;if(e.name&&e.name.endsWith(".msg"))return a="application/vnd.ms-outlook";var n=/(?:\.([^.]+))?$/.exec(e.name)[1];return[[".doc","application/msword"],[".docx","application/vnd.openxmlformats-officedocument.wordprocessingml.document"],[".gif","image/gif"],[".jpeg","image/jpeg"],[".jpg","image/jpeg"],[".txt","text/plain"],[".log","type/text"],[".mov","video/quicktime"],[".mp3","audio/mpeg"],[".mp4","video/mp4"],[".ogg","audio/ogg"],[".ogv","video/ogg"],[".pdf","application/pdf"],[".png","image/png"],[".webm","video/webm"],[".webp","image/webp"],[".wmv","video/x-ms-wmv"],[".xls","application/vnd.ms-excel"],[".xlsx","application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],[".zip","application/x-zip-compressed"]].forEach(function(e,t){e[0]==".".concat(n)&&(a=e[1])}),a}function Le(s,e){if(De(Re(O.get(s)))||!Ue(Re(O.get(s)))){var t,a=O.get(s).link,n=O.get(s).text,r=O.get(s).data;!n&&I.get(s)&&I.get(s).name&&(n=I.get(s).name);var i=O.get(s).response;R.edit.on(),R.events.focus(!0),R.selection.restore(),R.opts.fileUseSelectedText&&R.selection.text().length&&(n=R.selection.text());var o='<a href="'.concat(a,'" target="_blank" id="fr-inserted-file" ');if(void 0!==r)for(t in r)r.hasOwnProperty(t)&&"link"!=t&&(o+="".concat(t,'="').concat(r[t],'" '));-1==o.indexOf(' class="')&&(o+='class="fr-file" '),o+=">".concat(n,"</a>"),R.html.insert(o);var l=R.$el.find("#fr-inserted-file");l.removeAttr("id"),R.undo.saveStep(),function T(){var e,t=Array.prototype.slice.call(R.el.querySelectorAll("a.fr-file")),a=[];for(e=0;e<t.length;e++)a.push(t[e].getAttribute("href"));if(le)for(e=0;e<le.length;e++)a.indexOf(le[e].getAttribute("href"))<0&&R.events.trigger("file.unlink",[le[e]]);le=t}(),R.selection.clear(),R.selection.setAfter(l),R.events.trigger("file.inserted",[l,i]),ke(e)}if(Ne(Re(O.get(s)))&&Ue(Re(O.get(s)))){var c=O.get(s).link,d=O.get(s).sanitize,f=O.get(s).data,p=O.get(s).$existing_img,u=O.get(s).response;p&&"string"==typeof p&&(p=R.$(p)),R.edit.off(),ee(R.language.translate("Loading image")),d&&(c=R.helpers.sanitizeURL(c));var g=new Image;g.onload=function(){var e,t;if(p){R.undo.canDo()||p.hasClass("fr-uploading")||R.undo.saveStep();var a=p.data("fr-old-src");p.data("fr-image-pasted")&&(a=null),R.$wp?((e=p.clone().removeData("fr-old-src").removeClass("fr-uploading").removeAttr("data-fr-image-pasted")).off("load"),a&&p.attr("src",a),p.replaceWith(e)):e=p;for(var n=e.get(0).attributes,r=0;r<n.length;r++){var i=n[r];0===i.nodeName.indexOf("data-")&&e.removeAttr(i.nodeName)}if(void 0!==f)for(t in f)f.hasOwnProperty(t)&&"link"!=t&&e.attr("data-".concat(t),f[t]);e.on("load",Ce),e.attr("src",c),R.edit.on(),R.undo.saveStep(),R.events.disableBlur(),R.$el.blur(),R.events.trigger(a?"image.replaced":"image.inserted",[e,u])}else e=function s(e,t,a){var n,r=x(document.createElement("img")).attr("src",e);if(t&&void 0!==t)for(n in t)t.hasOwnProperty(n)&&"link"!=n&&(" data-".concat(n,'="').concat(t[n],'"'),r.attr("data-".concat(n),t[n]));var i=R.opts.imageDefaultWidth;i&&"auto"!=i&&(i=R.opts.imageResizeWithPercent?"100%":"".concat(i,"px"));r.attr("style",i?"width: ".concat(i,";"):""),ot(r,R.opts.imageDefaultDisplay,R.opts.imageDefaultAlign),r.on("load",a),r.on("error",a),R.edit.on(),R.events.focus(!0),R.selection.restore(),R.undo.saveStep(),R.opts.imageSplitHTML?R.markers.split():R.markers.insert();R.html.wrap();var o=R.$el.find(".fr-marker");o.length?(o.parent().is("hr")&&o.parent().after(o),R.node.isLastSibling(o)&&o.parent().hasClass("fr-deletable")&&o.insertAfter(o.parent()),o.replaceWith(r)):R.$el.append(r);return r}(c,f,Ce),R.undo.saveStep(),R.events.disableBlur(),R.$el.blur(),R.events.trigger("image.inserted",[e,u])},g.onerror=function(){j(N,null,null,s),ke(e)},g.src=c}if((Pe(Re(O.get(s)))||Be(Re(O.get(s))))&&Ue(Re(O.get(s))))if(L=s,"video/url"==Re(O.get(s))){var h=!1;if(document.getElementById("fr-file-autoplay-button-"+s)!==undefined&&(h=document.getElementById("fr-file-autoplay-button-"+s).checked),h&&O.get(s)!==undefined&&-1<O.get(s).video.indexOf("iframe")&&O.get(s).video.indexOf("autoplay=1")<0){var m=O.get(s).video.substring(O.get(s).video.indexOf("src")+3),v="&";(m=(m=m.substring(m.indexOf('"')+1)).substring(0,m.indexOf('"'))).indexOf("?")<0&&(v="?"),O.get(s).video=O.get(s).video.replace(m,m+=v+"autoplay=1&mute=1")}else!h&&O.get(s).video.indexOf(!1)&&(-1<O.get(s).video.indexOf("&autoplay=1")&&(O.get(s).video=O.get(s).video.replace("&autoplay=1","")),-1<O.get(s).video.indexOf("?autoplay=1")&&(O.get(s).video=O.get(s).video.replace("?autoplay=1","")));R.events.focus(!0),R.selection.restore(),R.html.insert('<span contenteditable="false" draggable="true" class="fr-jiv fr-video fr-deletable">'.concat(O.get(s).video,"</span>"),!1,R.opts.videoSplitHTML),R.popups.hide("filesManager.insert");var b=R.$el.find(".fr-jiv");b.removeClass("fr-jiv"),b.toggleClass("fr-rv",R.opts.videoResponsive),function k(e,t,a){!R.opts.htmlUntouched&&R.opts.useClasses?(e.removeClass("fr-fvl fr-fvr fr-dvb fr-dvi"),e.addClass("fr-fv".concat(a[0]," fr-dv").concat(t[0]))):"inline"==t?(e.css({display:"inline-block"}),"center"==a?e.css({"float":"none"}):"left"==a?e.css({"float":"left"}):e.css({"float":"right"})):(e.css({display:"block",clear:"both"}),"left"==a?e.css({textAlign:"left"}):"right"==a?e.css({textAlign:"right"}):e.css({textAlign:"center"}))}(b,R.opts.videoDefaultDisplay,R.opts.videoDefaultAlign),b.toggleClass("fr-draggable",R.opts.videoMove),R.events.trigger("video.inserted",[b]),Ce.call(b)}else{var E=O.get(s).link,_=O.get(s).sanitize,w=O.get(s).data,y=O.get(s).$existing_img,A=O.get(s).response;R.edit.off(),_&&(E=R.helpers.sanitizeURL(E)),function S(){var e,t;if(y){R.undo.canDo()||y.find("video").hasClass("fr-uploading")||R.undo.saveStep();var a=y.find("video").data("fr-old-src"),n=y.data("fr-replaced");y.data("fr-replaced",!1),R.$wp?((e=y.clone(!0)).find("video").removeData("fr-old-src").removeClass("fr-uploading"),e.find("video").off("canplay"),a&&y.find("video").attr("src",a),y.replaceWith(e)):e=y;for(var r=e.find("video").get(0).attributes,i=0;i<r.length;i++){var o=r[i];0===o.nodeName.indexOf("data-")&&e.find("video").removeAttr(o.nodeName)}if(void 0!==w)for(t in w)w.hasOwnProperty(t)&&"link"!=t&&e.find("video").attr("data-".concat(t),w[t]);e.find("video").on("canplay",Ce),e.find("video").attr("src",E),R.edit.on(),Te(),R.undo.saveStep(),R.$el.blur(),R.events.trigger(n?"video.replaced":"video.inserted",[e,A])}else e=function u(e,t,a,n,r){var i,o="";if(t&&void 0!==t)for(i in t)t.hasOwnProperty(i)&&"link"!=i&&(o+=" data-".concat(i,'="').concat(t[i],'"'));var s,l=R.opts.videoDefaultWidth;l&&"auto"!=l&&(l="".concat(l,"px"));if(Be(n))s=x(document.createElement("span")).attr("contenteditable","false").attr("draggable","true").attr("class","fr-video fr-dv"+R.opts.videoDefaultDisplay[0]+("center"!=R.opts.videoDefaultAlign?" fr-fv"+R.opts.videoDefaultAlign[0]:"")).html('<audio src="'+e+'" '+o+" controls>"+R.language.translate("Your browser does not support HTML5 video.")+"</audio>");else{var c="",d=document.getElementById("fr-file-autoplay-button-"+r).checked;d&&(c="autoplay"),s=x(document.createElement("span")).attr("contenteditable","false").attr("draggable","true").attr("class","fr-video fr-dv"+R.opts.videoDefaultDisplay[0]+("center"!=R.opts.videoDefaultAlign?" fr-fv"+R.opts.videoDefaultAlign[0]:"")).html('<video src="'+e+'" '+o+(l?' style="width: '+l+';" ':"")+c+"  controls>"+R.language.translate("Your browser does not support HTML5 video.")+"</video>")}s.toggleClass("fr-draggable",R.opts.videoMove),R.edit.on(),R.events.focus(!0),R.selection.restore(),R.undo.saveStep(),R.opts.videoSplitHTML?R.markers.split():R.markers.insert();R.html.wrap();var f=R.$el.find(".fr-marker");R.node.isLastSibling(f)&&f.parent().hasClass("fr-deletable")&&f.insertAfter(f.parent());f.replaceWith(s);var p="";p=Be(n)?"audio":"video",s.find(p).get(0).readyState>s.find(p).get(0).HAVE_FUTURE_DATA||R.helpers.isIOS()?a.call(s.find(p).get(0)):(s.find(p).on("canplaythrough load",a),s.find(p).on("error",a));return s}(E,w,Ce,Re(O.get(s)),s),Te(),R.undo.saveStep(),R.events.trigger("video.inserted",[e,A])}()}R.popups.hide("filesManager.insert"),F["delete"](s);var C=R.popups.get("filesManager.insert");C.find("input.fr-insert-attr.fr-checkbox-file-".concat(s))[0].checked=!1,C.find(".fr-file-"+s).get(0).classList.add("fr-unchecked"),q(),document.getElementById("fr-file-autoplay-button-"+s)&&(document.getElementById("fr-file-autoplay-button-"+s).checked=!1),M=M.filter(function(e){return e!=s})}function xe(e,t){try{if(!1===R.events.trigger("filesManager.uploaded",[e],!0))return R.edit.on(),!1;var a=JSON.parse(e);return a.link?a:(j(m,e,null,t),!1)}catch(n){return j(S,e,null,t),!1}}function Ie(e,t){try{var a=x(e).find("Location").text(),n=x(e).find("Key").text();return!1===R.events.trigger("filesManager.uploadedToS3",[a,n,e],!0)?(R.edit.on(),!1):a}catch(r){return j(S,e,null,t),!1}}function Oe(e,t,a,n){if(-1<U.indexOf(Re(e))||!Re(e))return j(P,null,null,n),!1;if(!1===R.events.trigger("filesManager.beforeUpload",[t]))return!1;if(!(null!==R.opts.filesManagerUploadURL&&R.opts.filesManagerUploadURL!=y||R.opts.filesManagerUploadToS3||R.opts.filesManagerUploadToAzure))return function E(s,l,c){var d=new FileReader;d.onload=function(){var e=d.result;if(d.result.indexOf("svg+xml")<0){for(var t=atob(d.result.split(",")[1]),a=[],n=0;n<t.length;n++)a.push(t.charCodeAt(n));if(e=window.URL.createObjectURL(new Blob([new Uint8Array(a)],{type:Re(l)})),Ne(Re(l))){var r={link:e,sanitize:!1,data:null,$existing_img:c,response:null,type:Re(l)};O.set(s,r)}if(De(Re(l))){var i={link:e,text:l.name,response:null,type:Re(l)};O.set(s,i)}if(Pe(Re(l))||Be(Re(l))){var o={link:e,sanitize:!1,data:null,$existing_img:c,type:Re(l)};O.set(s,o)}}},d.readAsDataURL(l)}(n,e),!1;if(Ne(Re(e))&&(e.name||(e.name=(new Date).getTime()+"."+(Re(e)||"image/jpeg").replace(/image\//g,""))),e.size>R.opts.filesManagerMaxSize)return j(D,null,null,n),!1;if(R.opts.filesManagerAllowedTypes.indexOf("*")<0&&R.opts.filesManagerAllowedTypes.indexOf(Re(e))<0)return j(P,null,null,n),!1;var r;if(function _(e){isNaN(e)||(R.popups.get("filesManager.insert").find(".fr-file-item-right-"+e).get(0).innerHTML='<div class=\'fr-file-item-action-buttons\' >\n    <button type="button" id="fr-file-cancel-upload-button-'.concat(e,'" class="fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons \n    fr-file-button-').concat(e,' fr-file-cancel-upload-button" data-cmd="cancelUpload" data-title="Cancel" data-param1="').concat(e,'" role="button">\n    <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "-2 3 30 30" xlmns = "http://w3.org/200/svg"><path d = \'M13.4,12l5.6,5.6L17.6,19L12,13.4L6.4,19L5,17.6l5.6-5.6L5,6.4L6.4,5l5.6,5.6L17.6,5L19,6.4L13.4,12z\'></path></svg>\n    </button>\n\n    <button type="button" id="fr-upload-delete-button-').concat(e,'" class="fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons \n    fr-file-button-').concat(e,' fr-upload-delete-button" data-cmd="deleteUpload" data-title="Delete" data-param1="').concat(e,'" role="button">\n    <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "-2 3 30 30" xlmns = "http://w3.org/200/svg"><path d = \'M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z\'></path></svg>\n    </button>\n\n    <div class=\'progress-circle p0 fr-file-progress-circle-').concat(e,"'>\n                  <span class='fr-file-upload-percent-").concat(e," fr-file-upload-percent'>0%</span>\n                  <div class='left-half-clipper'>\n                    <div class='first50-bar'></div>\n                    <div class='value-bar'></div>\n                  </div>\n                </div>\n            </div>"),C.set(e,0))}(n),R.drag_support.formdata&&(r=R.drag_support.formdata?new FormData:null),r){var i;if(!1!==R.opts.filesManagerUploadToS3)for(i in r.append("key",R.opts.filesManagerUploadToS3.keyStart+(new Date).getTime()+"-"+(e.name||"untitled")),r.append("success_action_status","201"),r.append("X-Requested-With","xhr"),r.append("Content-Type",Re(e)),R.opts.filesManagerUploadToS3.params)R.opts.filesManagerUploadToS3.params.hasOwnProperty(i)&&r.append(i,R.opts.filesManagerUploadToS3.params[i]);for(i in R.opts.filesManagerUploadParams)R.opts.filesManagerUploadParams.hasOwnProperty(i)&&r.append(i,R.opts.filesManagerUploadParams[i]);r.append(R.opts.filesManagerUploadParam,e,e.name);var o,s,l=R.opts.filesManagerUploadURL;R.opts.filesManagerUploadToS3&&(l=R.opts.filesManagerUploadToS3.uploadURL?R.opts.filesManagerUploadToS3.uploadURL:"https://".concat(R.opts.filesManagerUploadToS3.region,".amazonaws.com/").concat(R.opts.filesManagerUploadToS3.bucket)),R.opts.filesManagerUploadToAzure&&(l=R.opts.filesManagerUploadToAzure.uploadURL?"".concat(R.opts.filesManagerUploadToAzure.uploadURL,"/").concat(e.name):encodeURI("https://".concat(R.opts.filesManagerUploadToAzure.account,".blob.core.windows.net/").concat(R.opts.filesManagerUploadToAzure.container,"/").concat(e.name)),o=l,R.opts.filesManagerUploadToAzure.SASToken&&(l+=R.opts.filesManagerUploadToAzure.SASToken),R.opts.filesManagerUploadMethod="PUT");var c=R.core.getXHR(l,R.opts.filesManagerUploadMethod);if(R.opts.filesManagerUploadToAzure){var d=(new Date).toUTCString();if(!R.opts.filesManagerUploadToAzure.SASToken&&R.opts.filesManagerUploadToAzure.accessKey){var f=R.opts.filesManagerUploadToAzure.account,p=R.opts.filesManagerUploadToAzure.container;if(R.opts.filesManagerUploadToAzure.uploadURL){var u=R.opts.filesManagerUploadToAzure.uploadURL.split("/");p=u.pop(),f=u.pop().split(".")[0]}var g="x-ms-blob-type:BlockBlob\nx-ms-date:".concat(d,"\nx-ms-version:2019-07-07"),h=encodeURI("/"+f+"/"+p+"/"+e.name),m=R.opts.filesManagerUploadMethod+"\n\n\n"+e.size+"\n\n"+Re(e)+"\n\n\n\n\n\n\n"+g+"\n"+h,v=R.cryptoJSPlugin.cryptoJS.HmacSHA256(m,R.cryptoJSPlugin.cryptoJS.enc.Base64.parse(R.opts.filesManagerUploadToAzure.accessKey)).toString(R.cryptoJSPlugin.cryptoJS.enc.Base64),b="SharedKey "+f+":"+v;s=v,c.setRequestHeader("Authorization",b)}for(i in c.setRequestHeader("x-ms-version","2019-07-07"),c.setRequestHeader("x-ms-date",d),c.setRequestHeader("Content-Type",Re(e)),c.setRequestHeader("x-ms-blob-type","BlockBlob"),R.opts.filesManagerUploadParams)R.opts.filesManagerUploadParams.hasOwnProperty(i)&&c.setRequestHeader(i,R.opts.filesManagerUploadParams[i]);for(i in R.opts.filesManagerUploadToAzure.params)R.opts.filesManagerUploadToAzure.params.hasOwnProperty(i)&&c.setRequestHeader(i,R.opts.filesManagerUploadToAzure.params[i])}c.onload=function(){De(Re(e))?function g(e,t,a,n,r){var i=this.status,o=this.response,s=this.responseXML,l=this.responseText;try{if(R.opts.filesManagerUploadToS3||R.opts.filesManagerUploadToAzure)if(201===i){var c;if(R.opts.filesManagerUploadToAzure){if(!1===R.events.trigger("filesManager.uploadedToAzure",[this.responseURL,r,o],!0))return R.edit.on(),!1;c=n}else c=Ie(s,t);if(c){var d={link:c,text:e,response:o,type:a};O.set(t,d)}}else j(S,o||s,null,t);else if(200<=i&&i<300){var f=xe(l,t);if(f){var p={link:f.link,text:e,response:o,type:a,data:f};O.set(t,p)}}else j(k,o||l,null,t)}catch(u){j(S,o||l,null,t)}}.call(c,e.name,n,Re(e),o,s):function h(e,t,a,n,r){var i=this.status,o=this.response,s=this.responseXML,l=this.responseText;try{if(R.opts.filesManagerUploadToS3||R.opts.filesManagerUploadToAzure)if(201==i){var c;if(R.opts.filesManagerUploadToAzure){if(!1===R.events.trigger("filesManager.uploadedToAzure",[this.responseURL,r,o],!0))return R.edit.on(),!1;c=n}else c=Ie(s,t);if(c){var d={link:c,sanitize:!1,data:[],$existing_img:e,response:o||s,type:a};O.set(t,d)}}else j(S,o||s,e,t);else if(200<=i&&i<300){var f=xe(l,t);if(f){var p={link:f.link,sanitize:!1,data:f,$existing_img:e,response:o||s,type:a};O.set(t,p)}}else j(k,o||l,e,t)}catch(u){j(S,o||l,e,t)}}.call(c,w,n,Re(e),o,s),T.has(n)||_e(100,n,!0)},c.onerror=function(){j(S,this.response||this.responseText||this.responseXML,null,n)},c.upload.onprogress=function(e){!function a(e,t){e.lengthComputable&&_e(e.loaded/e.total*100|0,t,!1)}(e,n)},c.onabort=function(e){!function a(e,t){j(B,t,w,e)}(n,e)},c.send(R.opts.filesManagerUploadToAzure?e:r),A.set(n,c)}}function Fe(l){R.events.$on(l,"click",".fr-upload-progress-layer",function(e){if(R.helpers.isMobile())return e.stopPropagation(),!1},!0),R.events.$on(l,"dragover dragenter",".fr-upload-progress-layer",function(e){e.preventDefault();for(var t=0;t<e.originalEvent.dataTransfer.types.length;t++)"Files"==e.originalEvent.dataTransfer.types[t]&&(e.originalEvent.dataTransfer.dropEffect="none");return!1},!0),R.events.$on(l,"dragleave dragend",".fr-upload-progress-layer",function(e){return e.preventDefault(),!1},!0),R.events.$on(l,"dragover dragenter",".fr-files-upload-layer",function(e){return x(this).addClass("fr-drop"),(R.browser.msie||R.browser.edge)&&e.preventDefault(),!1},!0),R.events.$on(l,"dragleave dragend",".fr-files-upload-layer",function(e){return x(this).removeClass("fr-drop"),(R.browser.msie||R.browser.edge)&&e.preventDefault(),!1},!0),R.events.$on(l,"click",".fr-insert-checkbox",function(e){if(this.classList.contains("fr-checkbox-disabled"))return this.children.target.disabled=!0,void(this.children.target.checked=!1);var t=parseInt(this.id.split("-").pop());F.set(t,this.children.target.checked);for(var a=l.find('.fr-command[data-cmd="insertAll"]'),n=l.find('.fr-command[data-cmd="deleteAll"]'),r=l.find('input.fr-file-insert-check[type="checkbox"]'),i=r.length,o=!0,s=0;s<i;s++)1==r[s].checked&&(o=!1);if(o?a.addClass("fr-disabled"):a.removeClass("fr-disabled"),o?n.addClass("fr-disabled"):n.removeClass("fr-disabled"),this.children.target.checked)l.find(".fr-file-"+this.id.split("-").pop()).get(0).setAttribute("draggable","true"),l.find(".fr-file-"+this.id.split("-").pop()).get(0).classList.remove("fr-unchecked");else{this.id.split("-").pop();l.find(".fr-file-"+this.id.split("-").pop()).get(0).setAttribute("draggable","false"),l.find(".fr-file-"+this.id.split("-").pop()).get(0).classList.add("fr-unchecked")}}),R.events.$on(l,"click",".fr-file-insert-button",function(e){this.classList.contains("fr-disabled")||Le(parseInt(this.id.split("-").pop()))}),R.events.$on(l,"click",".fr-file-autoplay-button",function(e){if(this.parentNode.classList.contains("fr-checkbox-disabled"))return this.disabled=!0,void(this.checked=!1);Me(parseInt(this.id.split("-").pop()))}),R.events.$on(l,"click",".fr-file-edit-button",function(e){var t=parseInt(this.id.split("-").pop());l.find(".fr-file-edit-button-".concat(t)).hasClass("fr-disabled")||Se(t)}),R.events.$on(l,"click",".fr-file-view-button",function(e){var t=parseInt(this.id.split("-").pop());l.find(".fr-file-view-button-".concat(t)).hasClass("fr-disabled")||function v(e){if(!Ue(Re(O.get(e)))){var t=O.get(e).link,a=O.get(e).link;if(I.get(e)&&I.get(e).name?a=I.get(e).name:O.get(e).text&&(a=O.get(e).text),0===t.indexOf("blob:")&&R.browser.msie&&window.navigator&&window.navigator.msSaveBlob)window.navigator.msSaveBlob(I.get(e),a);else{var n=document.createElement("a");n.href=t,n.download=a,n.click()}return!1}var r=R.popups.get("filesManager.insert");if(0<r.find(".fr-file-view-image-"+e).length)r.find(".fr-file-view-image-"+e)[0].remove();else{for(var i=r.find(".fr-file-view"),o=0;o<i.length;o++)i.get(o).remove();var s=r.find(".fr-file-view-"+e);if(Ne(Re(O.get(e)))){var l='<div class="fr-file-view-modal">\n              <div class="fr-file-view-modal-content">\n              <div class="fr-file-view-close">&times;</div> \n                <img src="'+O.get(e).link+"\" class ='fr-file-view-image'/>\n                </div>\n              </div>";s[0].innerHTML=l+s[0].innerHTML}else if(Pe(Re(O.get(e)))){var c;if(O.get(e).hasOwnProperty("video")){var d=O.get(e).video.substring(O.get(e).video.indexOf("src")+3),f=d.substring(d.indexOf('"')+1);f=f.substring(0,f.indexOf('"')),c='<div class="fr-file-view-modal">\n        <div class="fr-file-view-modal-content ">\n          <div class="fr-file-view-close">&times;</div> \n          <iframe width="640" height="360" src="'.concat(f+"&autoplay=1&mute=1",'" allow="autoplay" frameborder="0" class = "fr-file-view-image"></iframe>\n        </div>\n      </div>')}else c='<div class="fr-file-view-modal">\n          <div class="fr-file-view-modal-content ">\n            <div class="fr-file-view-close">&times;</div> \n            <video controls src="'+O.get(e).link+"\"  class ='fr-file-view-image' autoplay></video>\n          </div>\n        </div>";s[0].innerHTML=c+s[0].innerHTML}else if(Be(Re(O.get(e)))){var p='<div class="fr-file-view-modal">\n        <div class="fr-file-view-modal-content ">\n          <div  class="fr-file-view-close">&times;</div> \n          <audio controls="controls"  class =\'fr-file-view-image\' autoplay>\n\n          <source src="'.concat(O.get(e).link,'" type="').concat(Re(O.get(e)),'" />\n\n            Your browser does not support the audio element.\n          </audio>\n        </div>\n      </div>');s[0].innerHTML=p+s[0].innerHTML}else if(De(Re(O.get(e)))){var u=O.get(e).link,g=O.get(e).text;if(u.endsWith(".pdf")||u.endsWith(".txt")){var h='<div class="fr-file-view-modal">\t\n              <div class="fr-file-view-modal-content " >\t\n              <div class="fr-file-view-close">&times;</div> \t\n              <iframe src="'.concat(u,"\" style='background-color: white;' height='50%' width='50%' title=\"").concat(g,'" class="fr-file fr-file-view-image"></iframe>\t\n            </div>\t\n            </div>');s[0].innerHTML=h+s[0].innerHTML}else if(0===u.indexOf("blob:")&&R.browser.msie&&window.navigator&&window.navigator.msSaveBlob)window.navigator.msSaveBlob(I.get(e),g);else{var m=document.createElement("a");m.href=u,m.download=g,m.click()}}}}(t)}),R.events.$on(l,"click",".fr-file-delete-button",function(e){X(parseInt(this.id.split("-").pop()))}),R.events.$on(l,"click",".fr-file-cancel-upload-button",function(e){!function a(e){var t=R.popups.get("filesManager.insert");t.find(".fr-file-item-right-"+e).get(0).innerHTML=Ee(e),A.get(e).abort(),we(e,100,!0),t.find(".fr-checkbox-file-"+e).get(0).disabled=!0}(parseInt(this.id.split("-").pop()))}),R.events.$on(l,"click",".fr-upload-delete-button",function(e){!function t(e){0!=A.get(e).readyState&&(A.get(e).abort(),we(e,100,!0),A["delete"](e)),X(e)}(parseInt(this.id.split("-").pop()))}),R.events.$on(l,"click",".fr-file-view-close",function(e){l.find(".fr-file-view-modal").get(0).outerHTML=""}),R.events.$on(l,"click",".fr-plugins-enable",function(e){!function t(){h.forEach(function(e){R.opts.pluginsEnabled.indexOf(e)<0&&R.opts.pluginsEnabled.push(e)})}(),function a(e){for(var t in e)if(!R[t]){if(St.PLUGINS[t]&&R.opts.pluginsEnabled.indexOf(t)<0)continue;R[t]=new e[t](R),R[t]._init&&R[t]._init()}}(St.PLUGINS),R.popups.get("filesManager.insert").get(0).outerHTML="",He(),E(!0)}),R.events.$on(l,"click",".fr-plugins-cancel",function(e){R.popups.hide("filesManager.insert")}),R.events.$on(l,"drop",".fr-upload-progress",function(e){e.preventDefault(),e.stopPropagation()}),R.events.$on(l,"drop",".fr-files-upload-layer",function(e){e.preventDefault(),e.stopPropagation(),x(this).removeClass("fr-drop");var t=e.originalEvent.dataTransfer;if(t&&t.files){var a=l.data("instance")||R;a.events.disableBlur();for(var n=[],r=0;r<t.files.length;r++){var i=g;I.set(i,t.files[r]),me(i),F.set(i,!1),n.push(i),g++}for(var o=0;o<n.length;o++)a.filesManager.upload(I.get(n[o]),t.files,w,n[o]);a.events.enableBlur()}},!0),R.helpers.isIOS()&&R.events.$on(l,"touchstart",'.fr-files-upload-layer input[type="file"]',function(){x(this).trigger("click")},!0),R.events.$on(l,"change",'.fr-files-upload-layer input[type="file"]',function(){if(this.files){var e=l.data("instance")||R;e.events.disableBlur(),l.find("input:focus").blur(),e.events.enableBlur();var t=[];if("undefined"!=typeof this.files&&0<this.files.length){for(var a=0;a<this.files.length;a++){var n=g;I.set(n,this.files[a]),me(n),F.set(n,!1),++g,t.push(n)}for(var r=0;r<t.length;r++)e.filesManager.upload(I.get(t[r]),this.files,w,t[r])}}x(this).val("")},!0)}function Me(t){document.getElementById("fr-file-autoplay-button-"+t).checked?M.push(t):M=M.filter(function(e){return e!=t})}function Ne(e){return e&&"image"===e.split("/")[0]}function De(e){return e&&"image"!=e.split("/")[0]&&e&&"video"!=e.split("/")[0]&&e&&"audio"!=e.split("/")[0]}function Pe(e){return e&&"video"===e.split("/")[0]}function Be(e){return e&&"audio"===e.split("/")[0]}function Ue(e){var t="audio/ogg",a="video/ogg";if(e==t||e==a||"image/webp"==e||"video/webm"==e){if(R.browser.msie||R.browser.edge||R.browser.safari)return!1;if(R.helpers.isMobile()){if(e==t||e==a)return!1;if(!R.helpers.isAndroid()&&!R.browser.chrome)return!1}}return!0}function He(e){if(e)return R.popups.onRefresh("filesManager.insert",b),R.popups.onHide("filesManager.insert",H),!0;var t,a,n="";R.opts.imageUpload||-1===R.opts.filesInsertButtons.indexOf("filesUpload")||R.opts.imageInsertButtons.splice(R.opts.filesInsertButtons.indexOf("filesUpload"),1);var r=R.button.buildList(R.opts.filesInsertButtons),i=R.button.buildList(R.opts.filesInsertButtons2);""!==r&&(n='<div class="fr-buttons fr-tabs">'.concat(r,'<span class="fr-align-right">').concat(i,"</span></div>"));var o=R.opts.filesInsertButtons.indexOf("filesUpload"),s=R.opts.filesInsertButtons.indexOf("filesByURL"),l=R.opts.filesInsertButtons.indexOf("filesEmbed"),c="";0<=o&&(t=" fr-active",0<=s&&s<o&&(t=""),c='<div class="fr-files-upload-layer'.concat(t,' fr-layer " id="fr-files-upload-layer-').concat(R.id,'"><div style="display:flex"><div class="fr-upload-section"><div class = \'fr-blue-decorator\'><div class = \'fr-cloud-icon\'><svg class = "fr-svg" focusable="false" width="26px" height="26px" viewBox = "0 0 24 24" xlmns = "http://w3.org/200/svg"><path d = \'M12 6.66667a4.87654 4.87654 0 0 1 4.77525 3.92342l0.29618 1.50268 1.52794 0.10578a2.57021 2.57021 0 0 1 -0.1827 5.13478H6.5a3.49774 3.49774 0 0 1 -0.3844 -6.97454l1.06682 -0.11341L7.678 9.29387A4.86024 4.86024 0 0 1 12 6.66667m0 -2A6.871 6.871 0 0 0 5.90417 8.37 5.49773 5.49773 0 0 0 6.5 19.33333H18.41667a4.57019 4.57019 0 0 0 0.32083 -9.13A6.86567 6.86567 0 0 0 12 4.66667Zm0.99976 7.2469h1.91406L11.99976 9 9.08618 11.91357h1.91358v3H11V16h2V14h-0.00024Z\'></path></svg></div>Drag & Drop One or More Files<br><div class="fr-decorated"><span> OR </span></div> Click Browse Files </div> </div><div class="fr-form"><input type="file" accept="').concat(R.opts.filesManagerAllowedTypes.join(",").toLowerCase(),'" tabIndex="-1" aria - labelledby="fr-files-upload-layer-').concat(R.id,'"role="button" multiple></div> </div></div>'));var d="";0<=l&&(t=" fr-active",(o<l&&0<=o||s<l&&0<=s)&&(t=""),d='<div class="fr-files-embed-layer fr-layer'.concat(t,'" id="fr-files-embed-layer-').concat(R.id,'"><div class="fr-input-line padding-top-15"><textarea data-gramm_editor="false" style=\'height:60px\' id="fr-files-embed-layer-text').concat(R.id,'" type="text" placeholder="').concat(R.language.translate("Embedded Code"),'" tabIndex="1" aria-required="true" rows="5"></textarea></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="insertEmbed" tabIndex="2" role="button">').concat(R.language.translate("Insert"),"</button></div></div>"));var f="";0<=s&&(t=" fr-active",0<=o&&o<s&&(t=""),f='<div class="fr-files-by-url-layer'.concat(t,' fr-layer" id="fr-files-by-url-layer-').concat(R.id,'"><div class="fr-input-line fr-by-url-padding"><input id="fr-files-by-url-layer-text-').concat(R.id,'" type="text" placeholder="http://" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="filesInsertByURL" tabIndex="2" role="button">').concat(R.language.translate("Add"),"</button></div></div>"));var p={buttons:n,upload_layer:c,by_url_layer:f,embed_layer:d,upload_progress_layer:"<div class = ' fr-margin-16 fr-upload-progress' id=\"fr-upload-progress-layer-".concat(R.id,"\" ><div  class='fr-progress-bar-style'><div class='fr-progress-bar fr-none'></div></div><div id='filesList' class = 'fr-upload-progress-layer fr-layer'></div></div>"),progress_bar:'<div class="fr-files-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="filesDismissError" tabIndex="2" role="button">OK</button></div></div>'};return 1<=R.opts.imageInsertButtons.length&&(a=R.popups.create("filesManager.insert",p)),R.$wp&&R.events.$on(R.$wp,"scroll",function(){w&&R.popups.isVisible("filesManager.insert")&&replace()}),Fe(a),R.popups.setPopupDimensions(a),a}function $e(e){var t=e.split("/").pop();if(t.split(".").length<2){var a=new Date;return t+"-"+a.getDate()+"/"+(a.getMonth()+1)+"/"+a.getFullYear()}return t}function ze(){w&&R.popups.get("image.alt").find("input").val(w.attr("alt")||"").trigger("change")}function We(){var e=R.popups.get("image.alt");e||(e=Ke()),J(),R.popups.refresh("image.alt"),R.popups.setContainer("image.alt",R.$sc);var t=lt();ct()&&(t=t.find(".fr-img-wrap"));var a=t.offset().left+t.outerWidth()/2,n=t.offset().top+t.outerHeight();R.popups.show("image.alt",a,n,t.outerHeight(),!0)}function Ke(e){if(e)return R.popups.onRefresh("image.alt",ze),!0;var t={buttons:'<div class="fr-buttons fr-tabs">'.concat(R.button.buildList(R.opts.imageAltButtons),"</div>"),alt_layer:'<div class="fr-image-alt-layer fr-layer fr-active" id="fr-image-alt-layer-'.concat(R.id,'"><div class="fr-input-line"><input id="fr-image-alt-layer-text-').concat(R.id,'" type="text" placeholder="').concat(R.language.translate("Alternative Text"),'" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetAlt" tabIndex="2" role="button">').concat(R.language.translate("Update"),"</button></div></div>")},a=R.popups.create("image.alt",t);return R.$wp&&R.events.$on(R.$wp,"scroll.image-alt",function(){w&&R.popups.isVisible("image.alt")&&We()}),a}function Ge(){var e=R.popups.get("image.size");if(w)if(ct()){var t=w.parent();t.get(0).style.width||(t=w.parent().parent()),e.find('input[name="width"]').val(t.get(0).style.width).trigger("change"),e.find('input[name="height"]').val(t.get(0).style.height).trigger("change")}else e.find('input[name="width"]').val(w.get(0).style.width).trigger("change"),e.find('input[name="height"]').val(w.get(0).style.height).trigger("change")}function Ve(){var e=R.popups.get("image.size");e||(e=Ye()),J(),R.popups.refresh("image.size"),R.popups.setContainer("image.size",R.$sc);var t=lt();ct()&&(t=t.find(".fr-img-wrap"));var a=t.offset().left+t.outerWidth()/2,n=t.offset().top+t.outerHeight();R.popups.show("image.size",a,n,t.outerHeight(),!0)}function Ye(e){if(e)return R.popups.onRefresh("image.size",Ge),!0;var t={buttons:'<div class="fr-buttons fr-tabs">'.concat(R.button.buildList(R.opts.imageSizeButtons),"</div>"),size_layer:'<div class="fr-image-size-layer fr-layer fr-active" id="fr-image-size-layer-'.concat(R.id,'"><div class="fr-image-group"><div class="fr-input-line"><input id="fr-image-size-layer-width-\'').concat(R.id,'" type="text" name="width" placeholder="').concat(R.language.translate("Width"),'" tabIndex="1"></div><div class="fr-input-line"><input id="fr-image-size-layer-height').concat(R.id,'" type="text" name="height" placeholder="').concat(R.language.translate("Height"),'" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetSize" tabIndex="2" role="button">').concat(R.language.translate("Update"),"</button></div></div>")},a=R.popups.create("image.size",t);return R.$wp&&R.events.$on(R.$wp,"scroll.image-size",function(){w&&R.popups.isVisible("image.size")&&Ve()}),a}function je(e,t,a,n){return e.pageX=t,K.call(this,e),e.pageX=e.pageX+a*Math.floor(Math.pow(1.1,n)),G.call(this,e),V.call(this,e),++n}function qe(e){(e=e||lt())&&!1!==R.events.trigger("image.beforeRemove",[e])&&(R.popups.hideAll(),at(!0),R.undo.canDo()||R.undo.saveStep(),e.get(0)==R.el?e.removeAttr("src"):(e.get(0).parentNode&&"A"==e.get(0).parentNode.tagName?(R.selection.setBefore(e.get(0).parentNode)||R.selection.setAfter(e.get(0).parentNode)||e.parent().after(St.MARKERS),x(e.get(0).parentNode).remove()):(R.selection.setBefore(e.get(0))||R.selection.setAfter(e.get(0))||e.after(St.MARKERS),e.remove()),R.html.fillEmptyBlocks(),R.selection.restore()),R.undo.saveStep())}function Xe(e){var t=e.which;if(w&&(t==St.KEYCODE.BACKSPACE||t==St.KEYCODE.DELETE))return e.preventDefault(),e.stopPropagation(),qe(),!1;if(w&&t==St.KEYCODE.ESC){var a=w;return at(!0),R.selection.setAfter(a.get(0)),R.selection.restore(),e.preventDefault(),!1}if(!w||t!=St.KEYCODE.ARROW_LEFT&&t!=St.KEYCODE.ARROW_RIGHT)return w&&t===St.KEYCODE.TAB?(e.preventDefault(),e.stopPropagation(),at(!0),!1):w&&t!=St.KEYCODE.F10&&!R.keys.isBrowserAction(e)?(e.preventDefault(),e.stopPropagation(),!1):void 0;var n=w.get(0);return at(!0),t==St.KEYCODE.ARROW_LEFT?R.selection.setBefore(n):R.selection.setAfter(n),R.selection.restore(),e.preventDefault(),!1}function Ze(e){if(e&&"IMG"==e.tagName){var t;if(R.node.hasClass(e,"fr-uploading")||R.node.hasClass(e,"fr-error"))null===(t=e.parentNode)||void 0===t||t.removeChild(e);else R.node.hasClass(e,"fr-draggable")&&e.classList.remove("fr-draggable");if(e.parentNode&&e.parentNode.parentNode&&R.node.hasClass(e.parentNode.parentNode,"fr-img-caption")){var a=e.parentNode.parentNode;a.removeAttribute("contenteditable"),a.removeAttribute("draggable"),a.classList.remove("fr-draggable");var n=e.nextSibling;n&&n.removeAttribute("contenteditable")}}else if(e&&e.nodeType==Node.ELEMENT_NODE)for(var r=e.querySelectorAll("img.fr-uploading, img.fr-error, img.fr-draggable"),i=0;i<r.length;i++)Ze(r[i])}function Qe(e){var t=e.target.result,a=R.opts.imageDefaultWidth;a&&"auto"!=a&&(a+=R.opts.imageResizeWithPercent?"%":"px"),R.undo.saveStep(),R.html.insert('<img data-fr-image-pasted="true" src="'.concat(t,'"').concat(a?' style="width: '.concat(a,';"'):"",">"));var n=R.$el.find('img[data-fr-image-pasted="true"]');n&&ot(n,R.opts.imageDefaultDisplay,R.opts.imageDefaultAlign),R.events.trigger("paste.after")}function Je(e,t){var a=new FileReader;a.onload=function n(e){var t=R.opts.imageDefaultWidth;t&&"auto"!=t&&(t+=R.opts.imageResizeWithPercent?"%":"px"),R.html.insert('<img data-fr-image-pasted="true" src="'.concat(e,'"').concat(t?' style="width: '.concat(t,';"'):"",">"));var a=R.$el.find('img[data-fr-image-pasted="true"]');a&&ot(a,R.opts.imageDefaultDisplay,R.opts.imageDefaultAlign),R.events.trigger("paste.after")}(t),a.readAsDataURL(e,t)}function et(e,t){var a=t||e&&e.clipboardData;if(a&&a.items){var n=(a||window.clipboardData).getData("text/html")||"",r=(new DOMParser).parseFromString(n,"text/html").querySelector("img");if(r&&!R.opts.imageUploadURL){if(!r)return!1;var i=r.src,o=null;if(a.types&&-1!=[].indexOf.call(a.types,"text/rtf")||a.getData("text/rtf"))o=a.items[0].getAsFile();else for(var s=0;s<a.items.length;s++)if(o=a.items[s].getAsFile()){St.IMAGE_TYPE=o.type;break}if(o)return Je(o,i),!1}else{var l=null;if(a.types&&-1!=[].indexOf.call(a.types,"text/rtf")||a.getData("text/rtf"))l=a.items[0].getAsFile();else for(var c=0;c<a.items.length&&!(l=a.items[c].getAsFile());c++);if(l)return function d(e){var t=new FileReader;t.onload=Qe,t.readAsDataURL(e)}(l),!1}}}function tt(e){return e=e.replace(/<img /gi,'<img data-fr-image-pasted="true" ')}function at(e){w&&(function t(){return nt}()||!0===e)&&(R.toolbar.enable(),l&&l.removeClass("fr-active"),R.popups.hide("image.edit"),w=null,it(),c=null,d&&d.hide())}var nt=!1;function rt(){nt=!0}function it(){nt=!1}function ot(e,t,a){!R.opts.htmlUntouched&&R.opts.useClasses?(x(e).removeClass("fr-fil fr-fir fr-dib fr-dii"),a&&x(e).addClass("fr-fi".concat(a[0])),t&&x(e).addClass("fr-di".concat(t[0]))):"inline"==t?(e.css({display:"inline-block",verticalAlign:"bottom",margin:R.opts.imageDefaultMargin}),"center"==a?e.css({"float":"none",marginBottom:"",marginTop:"",maxWidth:"calc(100% - ".concat(2*R.opts.imageDefaultMargin,"px)"),textAlign:"center"}):"left"==a?e.css({"float":"left",marginLeft:0,maxWidth:"calc(100% - ".concat(R.opts.imageDefaultMargin,"px)"),textAlign:"left"}):e.css({"float":"right",marginRight:0,maxWidth:"calc(100% - ".concat(R.opts.imageDefaultMargin,"px)"),textAlign:"right"})):"block"==t&&(e.css({display:"block","float":"none",verticalAlign:"top",margin:"".concat(R.opts.imageDefaultMargin,"px auto"),textAlign:"center"}),"left"==a?e.css({marginLeft:0,textAlign:"left"}):"right"==a&&e.css({marginRight:0,textAlign:"right"}))}function st(){return w}function lt(){return ct()?w.parents(".fr-img-caption").first():w}function ct(){return!!w&&0<w.parents(".fr-img-caption").length}return{_init:function dt(){var i;(function e(){R.events.$on(R.$el,R._mousedown,"IMG"==R.el.tagName?null:'img:not([contenteditable="false"])',function(e){if("false"==x(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable"))return!0;R.helpers.isMobile()||R.selection.clear(),t=!0,R.popups.areVisible()&&R.events.disableBlur(),R.browser.msie&&(R.events.disableBlur(),R.$el.attr("contenteditable",!1)),R.draggable||"touchstart"==e.type||e.preventDefault(),e.stopPropagation()}),R.events.$on(R.$el,R._mousedown,".fr-img-caption .fr-inner",function(e){R.core.hasFocus()||R.events.focus(),e.stopPropagation()}),R.events.$on(R.$el,"paste",".fr-img-caption .fr-inner",function(e){!0===R.opts.toolbarInline&&(R.toolbar.hide(),e.stopPropagation())}),R.events.$on(R.$el,R._mouseup,"IMG"==R.el.tagName?null:'img:not([contenteditable="false"])',function(e){if("false"==x(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable"))return!0;t&&(t=!1,e.stopPropagation(),R.browser.msie&&(R.$el.attr("contenteditable",!0),R.events.enableBlur()))}),R.events.on("keyup",function(e){if(e.shiftKey&&""===R.selection.text().replace(/\n/g,"")&&R.keys.isArrow(e.which)){var t=R.selection.element(),a=R.selection.endElement();t&&"IMG"==t.tagName?Ae(x(t)):a&&"IMG"==a.tagName&&Ae(x(a))}},!0),R.events.on("window.mousedown",rt),R.events.on("window.touchmove",it),R.events.on("mouseup window.mouseup",function(){if(w)return at(),!1;it()}),R.events.on("commands.mousedown",function(e){0<e.parents(".fr-toolbar").length&&at()}),R.events.on("image.resizeEnd",function(){R.opts.iframe&&R.size.syncIframe()}),R.events.on("blur image.hideResizer commands.undo commands.redo element.dropped",function(){at(!(t=!1))}),R.events.on("modals.hide",function(){w&&R.selection.clear()}),R.events.on("image.resizeEnd",function(){R.win.getSelection&&Ae(w)}),R.opts.imageAddNewLine&&R.events.on("image.inserted",function(e){var t=e.get(0);for(t.nextSibling&&"BR"===t.nextSibling.tagName&&(t=t.nextSibling);t&&!R.node.isElement(t);)t=R.node.isLastSibling(t)?t.parentNode:null;R.node.isElement(t)&&(R.opts.enter===St.ENTER_BR?e.after("<br>"):x(R.node.blockParent(e.get(0))).after("<".concat(R.html.defaultTag(),"><br></").concat(R.html.defaultTag(),">")))})})(),"IMG"==R.el.tagName&&R.$el.addClass("fr-view"),R.helpers.isMobile()&&(R.events.$on(R.$el,"touchstart","IMG"==R.el.tagName?null:'img:not([contenteditable="false"])',function(){de=!1}),R.events.$on(R.$el,"touchmove",function(){de=!0})),R.opts.pluginsEnabled.includes("filestack")&&R.events.on("filestack.pluginsEnabled",function(){He()}),R.$wp?(R.events.on("window.keydown keydown",Xe,!0),R.events.on("keyup",function(e){if(w&&e.which==St.KEYCODE.ENTER)return!1},!0),R.events.$on(R.$el,"keydown",function(){var e=R.selection.element();(e.nodeType===Node.TEXT_NODE||"BR"==e.tagName&&R.node.isLastSibling(e))&&(e=e.parentNode),R.node.hasClass(e,"fr-inner")||(R.node.hasClass(e,"fr-img-caption")||(e=x(e).parents(".fr-img-caption").get(0)),R.node.hasClass(e,"fr-img-caption")&&(R.opts.trackChangesEnabled||x(e).after(St.INVISIBLE_SPACE+St.MARKERS),R.selection.restore()))})):R.events.$on(R.$win,"keydown",Xe),R.events.on("toolbar.esc",function(){if(w){if(R.$wp)R.events.disableBlur(),R.events.focus();else{var e=w;at(!0),R.selection.setAfter(e.get(0)),R.selection.restore()}return!1}},!0),R.events.on("toolbar.focusEditor",function(){if(w)return!1},!0),R.events.on("window.cut window.copy",function(e){if(w&&R.popups.isVisible("image.edit")&&!R.popups.get("image.edit").find(":focus").length){var t=lt();ct()?(t.before(St.START_MARKER),t.after(St.END_MARKER),R.selection.restore(),R.paste.saveCopiedText(t.get(0).outerHTML,t.text())):R.paste.saveCopiedText(w.get(0).outerHTML,w.attr("alt")),"copy"==e.type?setTimeout(function(){Ae(w)}):(at(!0),R.undo.saveStep(),setTimeout(function(){R.undo.saveStep()},0))}},!0),R.browser.msie&&R.events.on("keydown",function(e){if(!R.selection.isCollapsed()||!w)return!0;var t=e.which;t==St.KEYCODE.C&&R.keys.ctrlKey(e)?R.events.trigger("window.copy"):t==St.KEYCODE.X&&R.keys.ctrlKey(e)&&R.events.trigger("window.cut")}),R.events.$on(x(R.o_win),"keydown",function(e){var t=e.which;if(w&&t==St.KEYCODE.BACKSPACE)return e.preventDefault(),!1}),R.events.$on(R.$win,"keydown",function(e){var t=e.which;w&&w.hasClass("fr-uploading")&&t==St.KEYCODE.ESC&&w.trigger("abortUpload")}),R.events.on("destroy",function(){w&&w.hasClass("fr-uploading")&&w.trigger("abortUpload")}),R.events.on("paste.before",et),R.events.on("paste.beforeCleanup",tt),R.events.on("html.processGet",Ze),R.opts.imageOutputSize&&R.events.on("html.beforeGet",function(){i=R.el.querySelectorAll("img");for(var e=0;e<i.length;e++){var t=parseFloat(x(i[e]).css("padding-left"))+parseFloat(x(i[e]).css("padding-right")),a=x(i[e]).width()-t,n=i[e].style.width||a,r=i[e].style.height||x(i[e]).height();n&&i[e].setAttribute("width","".concat(n).replace(/px/,"")),r&&i[e].setAttribute("height","".concat(r).replace(/px/,""))}}),R.opts.iframe&&R.events.on("image.loaded",R.size.syncIframe),R.events.$on(x(R.o_win),"orientationchange.image",function(){setTimeout(function(){w&&Ae(w)},100)}),function n(e){if(e)return R.$wp&&R.events.$on(R.$wp,"scroll.image-edit",function(){w&&R.popups.isVisible("image.edit")&&R.events.disableBlur()}),!0;var t="";if(0<R.opts.imageEditButtons.length){var a={buttons:t+='<div class="fr-buttons"> \n        '.concat(R.button.buildList(R.opts.imageEditButtons),"\n        </div>")};return R.popups.create("image.edit",a)}return!1}(!0),He(!0),Ye(!0),Ke(!0),R.events.on("node.remove",function(e){if("IMG"==e.get(0).tagName)return qe(e),!1}),R.events.on("popups.hide.filesManager.insert",function(e){R.filesManager.minimizePopup(L)})},showInsertPopup:E,showLayer:function ft(e){var t,a,n=R.popups.get("filesManager.insert");if(w||R.opts.toolbarInline){if(w){var r=lt();ct()&&(r=r.find(".fr-img-wrap")),a=r.offset().top+r.outerHeight(),t=r.offset().left}}else{var i=R.$tb.find('.fr-command[data-cmd="insertFiles"]');t=i.offset().left,a=i.offset().top+(R.opts.toolbarBottom?10:i.outerHeight()-10)}!w&&R.opts.toolbarInline&&(a=n.offset().top-R.helpers.getPX(n.css("margin-top")),n.hasClass("fr-above")&&(a+=n.outerHeight())),n.find(".fr-layer").removeClass("fr-active"),n.find(".fr-".concat(e,"-layer")).addClass("fr-active"),n.find(".fr-upload-progress-layer").addClass("fr-active"),R.popups.show("filesManager.insert",t,a,w?w.outerHeight():0),R.accessibility.focusPopup(n)},refreshUploadButton:function pt(e){var t=R.popups.get("filesManager.insert");t&&t.find(".fr-files-upload-layer").hasClass("fr-active")&&e.addClass("fr-active").attr("aria-pressed",!0)},refreshByURLButton:function ut(e){var t=R.popups.get("filesManager.insert");t&&t.find(".fr-files-by-url-layer").hasClass("fr-active")&&e.addClass("fr-active").attr("aria-pressed",!0)},upload:Oe,insertByURL:function gt(){for(var e,t=R.popups.get("filesManager.insert").find(".fr-files-by-url-layer input"),a=t.val().trim().split(/[ ,]+/),n=[],r=0,i=0;i<a.length;i++)e=a[i],new RegExp("^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$","i").test(e)&&(n[r]=a[i],r++);if(0!=n.length){if(0<t.val().trim().length&&0<n.length){var s=[],l=[],c=g,d=n.length;n.forEach(function(e,a){if(0==e.trim().length)g==c+--d&&ye(s,l);else{J(),Q(),ee(R.language.translate("Loading file(s)"));var n=e.trim(),t=function o(e){if(void 0===e)return e;var t=null;if(/^http/.test(e)||(e="https://".concat(e)),R.helpers.isURL(e))for(var a=0;a<St.VIDEO_PROVIDERS.length;a++){var n=St.VIDEO_PROVIDERS[a];if(n.test_regex.test(e)&&new RegExp(R.opts.videoAllowedProviders.join("|")).test(n.provider)){t=e.replace(n.url_regex,n.url_text),t=n.html.replace(/\{url\}/,t);break}}return t}(n);if(t){var r={link:n,name:n,type:"video/url",size:2,video:t};I.set(c+a,r),me(c+a),J(),Q(),ee(R.language.translate("Loading file(s)")),O.set(c+a,r),++g==c+d&&ye(s,l)}else{var i=new XMLHttpRequest;i.onload=function(){if(200==this.status){var e=new Blob([this.response],{type:this.response.type||""});e.name=$e(n),e.link=n,Ne(this.response.type)?(e.sanitize=!0,e.existing_image=w):De(this.response.type)&&(e.text=$e(n)),s.push(e),l.push(c+a),I.set(c+a,e),me(c+a),(-1<U.indexOf(Re(e))||!Re(e))&&j(P,null,null,c+a)}else{var t=new Blob([this.response],{type:this.response.type||" "});t.name=$e(n),t.link=n,I.set(c+a,t),me(c+a),j(N,this.response,w,c+a)}J(),Q(),ee(R.language.translate("Loading file(s)")),++g==c+d&&ye(s,l)},i.onerror=function(){var e={link:n,name:$e(n),size:0,type:""};j(9,this.response,w,c+a);var t=g;I.set(t,e),me(t),J(),Q(),ee(R.language.translate("Loading file(s)")),++g==c+d&&ye(s,l)},i.open("GET","".concat(R.opts.imageCORSProxy,"/").concat(n),!0),i.responseType="blob",i.send()}}}),t.val(""),t.blur()}}else te(R.language.translate("Url entered is invalid. Please try again."))},insertAllFiles:function ht(){r=[];var e=R.popups.get("filesManager.insert");u=-1,f=null,e.find(".fr-insert-checkbox").toArray().forEach(function n(e,t,a){e.children.target.checked&&(r.push(parseInt(e.id.split("-").pop())),Ne(O.get(parseInt(e.id.split("-").pop())).type)&&-1==u&&(u=t))}),ke(r),q()},deleteAllFiles:function e(){R.popups.get("filesManager.insert").find(".fr-insert-checkbox").toArray().forEach(function r(e,t,a){if(e.children.target.checked){var n=parseInt(e.id.split("-").pop());A.has(n)&&A["delete"](n),X(n)}}),q()},get:st,getEl:lt,insert:Le,showProgressBar:Q,remove:qe,hideProgressBar:J,applyStyle:function mt(e,t,a){if(void 0===t&&(t=R.opts.imageStyles),void 0===a&&(a=R.opts.imageMultipleStyles),!w)return!1;var n=lt();if(!a){var r=Object.keys(t);r.splice(r.indexOf(e),1),n.removeClass(r.join(" "))}"object"==Rt(t[e])?(n.removeAttr("style"),n.css(t[e].style)):n.toggleClass(e),Ae(w)},showAltPopup:We,showSizePopup:Ve,setAlt:function vt(e){if(w){var t=R.popups.get("image.alt");w.attr("alt",e||t.find("input").val()||""),t.find("input:focus").blur(),Ae(w)}},setSize:function bt(e,t){if(w){var a=R.popups.get("image.size");e=e||a.find('input[name="width"]').val()||"",t=t||a.find('input[name="height"]').val()||"";var n=/^[\d]+((px)|%)*$/g;w.removeAttr("width").removeAttr("height"),e.match(n)?w.css("width",e):w.css("width",""),t.match(n)?w.css("height",t):w.css("height",""),ct()&&(w.parents(".fr-img-caption").removeAttr("width").removeAttr("height"),e.match(n)?w.parents(".fr-img-caption").css("width",e):w.parents(".fr-img-caption").css("width",""),t.match(n)?w.parents(".fr-img-caption").css("height",t):w.parents(".fr-img-caption").css("height","")),a&&a.find("input:focus").blur(),Ae(w)}},toggleCaption:function Et(){var e;if(w&&!ct()){(e=w).parent().is("a")&&(e=w.parent());var t,a,n=w.parents("ul")&&0<w.parents("ul").length?w.parents("ul"):w.parents("ol")&&0<w.parents("ol").length?w.parents("ol"):[];if(0<n.length){var r=n.find("li").length,i=w.parents("li"),o=document.createElement("li");r-1===i.index()&&(n.append(o),o.innerHTML="&nbsp;")}e.attr("style")&&(a=-1<(t=e.attr("style").split(":")).indexOf("width")?t[t.indexOf("width")+1].replace(";",""):"");var s=R.opts.imageResizeWithPercent?(-1<a.indexOf("px")?null:a)||"100%":w.width()+"px";e.wrap('<div class="fr-img-space-wrap"><span '+(R.browser.mozilla?"":'contenteditable="false"')+'class="fr-img-caption '+w.attr("class")+'" style="'+(R.opts.useClasses?"":e.attr("style"))+'" draggable="false"></span><p class="fr-img-space-wrap2">&nbsp;</p></div>'),e.wrap('<span class="fr-img-wrap"></span>'),w.after('<span class="fr-inner"'.concat(R.browser.mozilla?"":' contenteditable="true"',">").concat(St.START_MARKER).concat(R.language.translate("Image Caption")).concat(St.END_MARKER,"</span>")),w.removeAttr("class").removeAttr("style").removeAttr("width"),w.parents(".fr-img-caption").css("width",s),at(!0),R.selection.restore()}else e=lt(),w.insertAfter(e),w.attr("class",e.attr("class").replace("fr-img-caption","")).attr("style",e.attr("style")),e.remove(),Ae(w)},refreshEmbedButton:function _t(e){var t=R.popups.get("filesManager.insert");t&&t.find(".fr-files-embed-layer").hasClass("fr-active")&&e.addClass("fr-active").attr("aria-pressed",!0)},insertEmbed:function wt(e){void 0===e&&(e=R.popups.get("filesManager.insert").find(".fr-files-embed-layer textarea").val()||""),0===e.length||!St.VIDEO_EMBED_REGEX.test(e)&&!St.IMAGE_EMBED_REGEX.test(e)?(te(R.language.translate("Something went wrong. Please try again.")),St.VIDEO_EMBED_REGEX.test(e)&&R.events.trigger("video.codeError",[e])):function s(e,t){var a,n;St.VIDEO_EMBED_REGEX.test(e)?(a="video",n=R.opts.videoSplitHTML):St.IMAGE_EMBED_REGEX.test(e)&&(a="image",n=R.opts.imageSplitHTML),R.events.focus(!0),R.selection.restore();var r=!1;w&&(qe(),r=!0),R.html.insert('<span id="fr-inserted-file" contenteditable="true" draggable="true" class="fr-'.concat(a,' fr-jiv fr-deletable">').concat(e,"</span>"),!1,n),R.popups.hide("filesManager.insert");var i=R.$el.find(".fr-jiv");i.removeClass("fr-jiv"),"video"==a&&(i.toggleClass("fr-rv",R.opts.videoResponsive),function o(e,t,a){!R.opts.htmlUntouched&&R.opts.useClasses?(e.removeClass("fr-fvl fr-fvr fr-dvb fr-dvi"),e.addClass("fr-fv".concat(a[0]," fr-dv").concat(t[0]))):"inline"==t?(e.css({display:"inline-block"}),"center"==a?e.css({"float":"none"}):"left"==a?e.css({"float":"left"}):e.css({"float":"right"})):(e.css({display:"block",clear:"both"}),"left"==a?e.css({textAlign:"left"}):"right"==a?e.css({textAlign:"right"}):e.css({textAlign:"center"}))}(i,R.opts.videoDefaultDisplay,R.opts.videoDefaultAlign),i.toggleClass("fr-draggable",R.opts.videoMove),R.events.trigger(r?"video.replaced":"video.inserted",[i])),"image"==a&&(ot(i,R.opts.imageDefaultDisplay,R.opts.imageDefaultAlign),i.find("img").removeClass("fr-dii"),i.find("img").addClass("fr-dib"),i.toggleClass("fr-draggable",R.opts.imageMove),R.events.trigger(r?"image.replaced":"image.inserted",[i])),t&&(f=i,R.selection.clear(),R.toolbar.disable(),R.video._editVideo(f))}(e)},hasCaption:ct,exitEdit:at,edit:Ae,cancelFileInsert:function yt(){this.file_manager_dialog_open=!1,A.forEach(function(e,t){4!=e.readyState&&(e.abort(),X(t))});var e=R.popups.get("filesManager.insert");e.find(".fr-progress-bar").removeClass("fr-display-block").addClass("fr-none"),e.find('.fr-command[data-cmd="filesUpload"]').removeClass("fr-disabled"),e.find('.fr-command[data-cmd="filesByURL"]').removeClass("fr-disabled"),e.find('.fr-command[data-cmd="filesEmbed"]').removeClass("fr-disabled"),i=0,A=new Map,C=new Map,Z(),R.popups.hide("filesManager.insert")},minimizePopup:function At(e){this.file_manager_dialog_open=!1,R.popups.hide("filesManager.insert"),Z()},editImage:Se,saveImage:function Ct(e){var t=O.get(o);t.link=window.URL.createObjectURL(new Blob(e,{type:"image/png"})),O.set(o,t)},_showErrorMessage:te,_showFileErrorMessage:ae,getFileThumbnail:be,deleteFile:X,checkAutoplay:Me,checkInsertAllState:q,_disableInsertCheckbox:Y,_getFileType:Re,isChildWindowOpen:function Tt(){return p},setChildWindowState:function kt(e){e!==undefined&&(p=e)},resetAllFilesCheckbox:Z}},St.DefineIcon("insertFiles",{NAME:"image",SVG_KEY:"fileManager"}),St.RegisterShortcut(St.KEYCODE.P,"insertFiles",null,"P"),St.RegisterCommand("insertFiles",{title:"Insert Files",undo:!1,focus:!0,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible("filesManager.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("filesManager.insert")):this.filesManager.showInsertPopup()},plugin:"filesManager"}),St.DefineIcon("cloudIcon",{NAME:"cloudIcon",SVG_KEY:"uploadFiles"}),St.DefineIcon("filesUpload",{NAME:"uploadFiles",SVG_KEY:"uploadFiles"}),St.RegisterCommand("filesUpload",{title:"Upload Files",undo:!1,focus:!1,toggle:!0,callback:function(){this.filesManager.showLayer("files-upload")},refresh:function(e){this.filesManager.refreshUploadButton(e)}}),St.DefineIcon("filesByURL",{NAME:"link",SVG_KEY:"insertLink"}),St.RegisterCommand("filesByURL",{title:"By URL",undo:!1,focus:!1,toggle:!0,callback:function(){this.filesManager.showLayer("files-by-url")},refresh:function(e){this.filesManager.refreshByURLButton(e)}}),St.DefineIcon("filesEmbed",{NAME:"code",SVG_KEY:"codeView"}),St.RegisterCommand("filesEmbed",{title:"Embedded Code",undo:!1,focus:!1,toggle:!0,callback:function(){this.filesManager.showLayer("files-embed")},refresh:function(e){this.filesManager.refreshEmbedButton(e)}}),St.DefineIcon("insertAll",{NAME:"insertAll",SVG_KEY:"fileInsert"}),St.RegisterCommand("insertAll",{title:"Insert",undo:!1,focus:!1,toggle:!0,disabled:!0,callback:function(){this.filesManager.insertAllFiles()}}),St.DefineIcon("deleteAll",{NAME:"remove",SVG_KEY:"remove"}),St.RegisterCommand("deleteAll",{title:"Delete",undo:!1,focus:!1,toggle:!0,disabled:!0,callback:function(){this.filesManager.deleteAllFiles()}}),St.DefineIcon("cancel",{NAME:"cancel",SVG_KEY:"cancel"}),St.RegisterCommand("cancel",{title:"Cancel",undo:!1,focus:!1,toggle:!0,callback:function(){this.filesManager.cancelFileInsert()},refresh:function(e){}}),St.DefineIcon("minimize",{NAME:"minimize",SVG_KEY:"minimize"}),St.RegisterCommand("minimize",{title:"Minimize",undo:!1,focus:!1,toggle:!0,callback:function(){this.filesManager.minimizePopup("image.insert",!0)},refresh:function(e){this.filesManager.refreshEmbedButton(e)}}),St.RegisterCommand("filesInsertByURL",{title:"Insert Image",undo:!0,refreshAfterCallback:!1,callback:function(){this.filesManager.insertByURL()},refresh:function(e){e.text(this.language.translate("Add"))}}),St.RegisterCommand("imageInsertByUpload",{title:"Insert",undo:!0,refreshAfterCallback:!1,callback:function(e,t){},refresh:function(e){}}),St.RegisterCommand("viewImage",{title:"View Image",undo:!0,refreshAfterCallback:!1,callback:function(e,t){},refresh:function(e){}}),St.RegisterCommand("insertEmbed",{undo:!0,focus:!0,callback:function(){this.filesManager.insertEmbed(),this.popups.get("filesManager.insert").find("textarea")[0].value="",this.popups.get("filesManager.insert").find("textarea").removeClass("fr-not-empty")}}),St.RegisterCommand("filesDismissError",{title:"OK",undo:!1,callback:function(){this.filesManager.hideProgressBar(!0)}}),St.PLUGINS.cryptoJSPlugin=function(e){var t,d,a,n,r,i,o,f,s,l,c,p,u,g,h,v,m,b,E,_,w,y,A,C,T,k,S,R,L,x,I,O,F,M,N,D,P,B,U,H,$,z,W,K,G,V,Y,j,q,X,Z,Q,J,ee,te,ae,ne,re,ie,oe,se,le,ce,de,fe,pe,ue,ge,he,me,ve=ve||function(d,e){var t;if("undefined"!=typeof window&&window.crypto&&(t=window.crypto),!t&&"undefined"!=typeof window&&window.msCrypto&&(t=window.msCrypto),!t&&"undefined"!=typeof __webpack_require__.g&&__webpack_require__.g.crypto&&(t=__webpack_require__.g.crypto),!t&&"function"=="function")try{t=__webpack_require__(9271)}catch(h){}var n=function n(){if(t){if("function"==typeof t.getRandomValues)try{return t.getRandomValues(new Uint32Array(1))[0]}catch(h){}if("function"==typeof t.randomBytes)try{return t.randomBytes(4).readInt32LE()}catch(h){}}throw new Error("Native crypto module could not be used to get secure random number.")},a=Object.create||function(){function a(){}return function(e){var t;return a.prototype=e,t=new a,a.prototype=null,t}}(),r={},i=r.lib={},o=i.Base={extend:function(e){var t=a(this);return e&&t.mixIn(e),t.hasOwnProperty("init")&&this.init!==t.init||(t.init=function(){t.$super.init.apply(this,arguments)}),(t.init.prototype=t).$super=this,t},create:function(){var e=this.extend();return e.init.apply(e,arguments),e},init:function(){},mixIn:function(e){for(var t in e)e.hasOwnProperty(t)&&(this[t]=e[t]);e.hasOwnProperty("toString")&&(this.toString=e.toString)},clone:function(){return this.init.prototype.extend(this)}},f=i.WordArray=o.extend({init:function(e,t){e=this.words=e||[],this.sigBytes=null!=t?t:4*e.length},toString:function(e){return(e||l).stringify(this)},concat:function(e){var t=this.words,a=e.words,n=this.sigBytes,r=e.sigBytes;if(this.clamp(),n%4)for(var i=0;i<r;i++){var o=a[i>>>2]>>>24-i%4*8&255;t[n+i>>>2]|=o<<24-(n+i)%4*8}else for(i=0;i<r;i+=4)t[n+i>>>2]=a[i>>>2];return this.sigBytes+=r,this},clamp:function(){var e=this.words,t=this.sigBytes;e[t>>>2]&=4294967295<<32-t%4*8,e.length=d.ceil(t/4)},clone:function e(){var e=o.clone.call(this);return e.words=this.words.slice(0),e},random:function(e){for(var t=[],a=0;a<e;a+=4)t.push(n());return new f.init(t,e)}}),s=r.enc={},l=s.Hex={stringify:function(e){for(var t=e.words,a=e.sigBytes,n=[],r=0;r<a;r++){var i=t[r>>>2]>>>24-r%4*8&255;n.push((i>>>4).toString(16)),n.push((15&i).toString(16))}return n.join("")},parse:function(e){for(var t=e.length,a=[],n=0;n<t;n+=2)a[n>>>3]|=parseInt(e.substr(n,2),16)<<24-n%8*4;return new f.init(a,t/2)}},c=s.Latin1={stringify:function(e){for(var t=e.words,a=e.sigBytes,n=[],r=0;r<a;r++){var i=t[r>>>2]>>>24-r%4*8&255;n.push(String.fromCharCode(i))}return n.join("")},parse:function(e){for(var t=e.length,a=[],n=0;n<t;n++)a[n>>>2]|=(255&e.charCodeAt(n))<<24-n%4*8;return new f.init(a,t)}},p=s.Utf8={stringify:function(e){try{return decodeURIComponent(escape(c.stringify(e)))}catch(t){throw new Error("Malformed UTF-8 data")}},parse:function(e){return c.parse(unescape(encodeURIComponent(e)))}},u=i.BufferedBlockAlgorithm=o.extend({reset:function(){this._data=new f.init,this._nDataBytes=0},_append:function(e){"string"==typeof e&&(e=p.parse(e)),this._data.concat(e),this._nDataBytes+=e.sigBytes},_process:function(e){var t,a=this._data,n=a.words,r=a.sigBytes,i=this.blockSize,o=r/(4*i),s=(o=e?d.ceil(o):d.max((0|o)-this._minBufferSize,0))*i,l=d.min(4*s,r);if(s){for(var c=0;c<s;c+=i)this._doProcessBlock(n,c);t=n.splice(0,s),a.sigBytes-=l}return new f.init(t,l)},clone:function e(){var e=o.clone.call(this);return e._data=this._data.clone(),e},_minBufferSize:0}),g=(i.Hasher=u.extend({cfg:o.extend(),init:function(e){this.cfg=this.cfg.extend(e),this.reset()},reset:function(){u.reset.call(this),this._doReset()},update:function(e){return this._append(e),this._process(),this},finalize:function(e){return e&&this._append(e),this._doFinalize()},blockSize:16,_createHelper:function(a){return function(e,t){return new a.init(t).finalize(e)}},_createHmacHelper:function(a){return function(e,t){return new g.HMAC.init(a,t).finalize(e)}}}),r.algo={});return r}(Math);return d=(t=ve).lib.WordArray,t.enc.Base64={stringify:function(e){var t=e.words,a=e.sigBytes,n=this._map;e.clamp();for(var r=[],i=0;i<a;i+=3)for(var o=(t[i>>>2]>>>24-i%4*8&255)<<16|(t[i+1>>>2]>>>24-(i+1)%4*8&255)<<8|t[i+2>>>2]>>>24-(i+2)%4*8&255,s=0;s<4&&i+.75*s<a;s++)r.push(n.charAt(o>>>6*(3-s)&63));var l=n.charAt(64);if(l)for(;r.length%4;)r.push(l);return r.join("")},parse:function(e){var t=e.length,a=this._map,n=this._reverseMap;if(!n){n=this._reverseMap=[];for(var r=0;r<a.length;r++)n[a.charCodeAt(r)]=r}var i=a.charAt(64);if(i){var o=e.indexOf(i);-1!==o&&(t=o)}return function c(e,t,a){for(var n=[],r=0,i=0;i<t;i++)if(i%4){var o=a[e.charCodeAt(i-1)]<<i%4*2,s=a[e.charCodeAt(i)]>>>6-i%4*2,l=o|s;n[r>>>2]|=l<<24-r%4*8,r++}return d.create(n,r)}(e,t,n)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="},function(d){var e=ve,t=e.lib,a=t.WordArray,n=t.Hasher,r=e.algo,k=[];!function(){for(var e=0;e<64;e++)k[e]=4294967296*d.abs(d.sin(e+1))|0}();var i=r.MD5=n.extend({_doReset:function(){this._hash=new a.init([1732584193,4023233417,2562383102,271733878])},_doProcessBlock:function(e,t){for(var a=0;a<16;a++){var n=t+a,r=e[n];e[n]=16711935&(r<<8|r>>>24)|4278255360&(r<<24|r>>>8)}var i=this._hash.words,o=e[t+0],s=e[t+1],l=e[t+2],c=e[t+3],d=e[t+4],f=e[t+5],p=e[t+6],u=e[t+7],g=e[t+8],h=e[t+9],m=e[t+10],v=e[t+11],b=e[t+12],E=e[t+13],_=e[t+14],w=e[t+15],y=i[0],A=i[1],C=i[2],T=i[3];A=x(A=x(A=x(A=x(A=L(A=L(A=L(A=L(A=R(A=R(A=R(A=R(A=S(A=S(A=S(A=S(A,C=S(C,T=S(T,y=S(y,A,C,T,o,7,k[0]),A,C,s,12,k[1]),y,A,l,17,k[2]),T,y,c,22,k[3]),C=S(C,T=S(T,y=S(y,A,C,T,d,7,k[4]),A,C,f,12,k[5]),y,A,p,17,k[6]),T,y,u,22,k[7]),C=S(C,T=S(T,y=S(y,A,C,T,g,7,k[8]),A,C,h,12,k[9]),y,A,m,17,k[10]),T,y,v,22,k[11]),C=S(C,T=S(T,y=S(y,A,C,T,b,7,k[12]),A,C,E,12,k[13]),y,A,_,17,k[14]),T,y,w,22,k[15]),C=R(C,T=R(T,y=R(y,A,C,T,s,5,k[16]),A,C,p,9,k[17]),y,A,v,14,k[18]),T,y,o,20,k[19]),C=R(C,T=R(T,y=R(y,A,C,T,f,5,k[20]),A,C,m,9,k[21]),y,A,w,14,k[22]),T,y,d,20,k[23]),C=R(C,T=R(T,y=R(y,A,C,T,h,5,k[24]),A,C,_,9,k[25]),y,A,c,14,k[26]),T,y,g,20,k[27]),C=R(C,T=R(T,y=R(y,A,C,T,E,5,k[28]),A,C,l,9,k[29]),y,A,u,14,k[30]),T,y,b,20,k[31]),C=L(C,T=L(T,y=L(y,A,C,T,f,4,k[32]),A,C,g,11,k[33]),y,A,v,16,k[34]),T,y,_,23,k[35]),C=L(C,T=L(T,y=L(y,A,C,T,s,4,k[36]),A,C,d,11,k[37]),y,A,u,16,k[38]),T,y,m,23,k[39]),C=L(C,T=L(T,y=L(y,A,C,T,E,4,k[40]),A,C,o,11,k[41]),y,A,c,16,k[42]),T,y,p,23,k[43]),C=L(C,T=L(T,y=L(y,A,C,T,h,4,k[44]),A,C,b,11,k[45]),y,A,w,16,k[46]),T,y,l,23,k[47]),C=x(C,T=x(T,y=x(y,A,C,T,o,6,k[48]),A,C,u,10,k[49]),y,A,_,15,k[50]),T,y,f,21,k[51]),C=x(C,T=x(T,y=x(y,A,C,T,b,6,k[52]),A,C,c,10,k[53]),y,A,m,15,k[54]),T,y,s,21,k[55]),C=x(C,T=x(T,y=x(y,A,C,T,g,6,k[56]),A,C,w,10,k[57]),y,A,p,15,k[58]),T,y,E,21,k[59]),C=x(C,T=x(T,y=x(y,A,C,T,d,6,k[60]),A,C,v,10,k[61]),y,A,l,15,k[62]),T,y,h,21,k[63]),i[0]=i[0]+y|0,i[1]=i[1]+A|0,i[2]=i[2]+C|0,i[3]=i[3]+T|0},_doFinalize:function(){var e=this._data,t=e.words,a=8*this._nDataBytes,n=8*e.sigBytes;t[n>>>5]|=128<<24-n%32;var r=d.floor(a/4294967296),i=a;t[15+(n+64>>>9<<4)]=16711935&(r<<8|r>>>24)|4278255360&(r<<24|r>>>8),t[14+(n+64>>>9<<4)]=16711935&(i<<8|i>>>24)|4278255360&(i<<24|i>>>8),e.sigBytes=4*(t.length+1),this._process();for(var o=this._hash,s=o.words,l=0;l<4;l++){var c=s[l];s[l]=16711935&(c<<8|c>>>24)|4278255360&(c<<24|c>>>8)}return o},clone:function e(){var e=n.clone.call(this);return e._hash=this._hash.clone(),e}});function S(e,t,a,n,r,i,o){var s=e+(t&a|~t&n)+r+o;return(s<<i|s>>>32-i)+t}function R(e,t,a,n,r,i,o){var s=e+(t&n|a&~n)+r+o;return(s<<i|s>>>32-i)+t}function L(e,t,a,n,r,i,o){var s=e+(t^a^n)+r+o;return(s<<i|s>>>32-i)+t}function x(e,t,a,n,r,i,o){var s=e+(a^(t|~n))+r+o;return(s<<i|s>>>32-i)+t}e.MD5=n._createHelper(i),e.HmacMD5=n._createHmacHelper(i)}(Math),n=(a=ve).lib,r=n.WordArray,i=n.Hasher,o=a.algo,f=[],s=o.SHA1=i.extend({_doReset:function(){this._hash=new r.init([1732584193,4023233417,2562383102,271733878,3285377520])},_doProcessBlock:function(e,t){for(var a=this._hash.words,n=a[0],r=a[1],i=a[2],o=a[3],s=a[4],l=0;l<80;l++){if(l<16)f[l]=0|e[t+l];else{var c=f[l-3]^f[l-8]^f[l-14]^f[l-16];f[l]=c<<1|c>>>31}var d=(n<<5|n>>>27)+s+f[l];d+=l<20?1518500249+(r&i|~r&o):l<40?1859775393+(r^i^o):l<60?(r&i|r&o|i&o)-1894007588:(r^i^o)-899497514,s=o,o=i,i=r<<30|r>>>2,r=n,n=d}a[0]=a[0]+n|0,a[1]=a[1]+r|0,a[2]=a[2]+i|0,a[3]=a[3]+o|0,a[4]=a[4]+s|0},_doFinalize:function(){var e=this._data,t=e.words,a=8*this._nDataBytes,n=8*e.sigBytes;return t[n>>>5]|=128<<24-n%32,t[14+(n+64>>>9<<4)]=Math.floor(a/4294967296),t[15+(n+64>>>9<<4)]=a,e.sigBytes=4*t.length,this._process(),this._hash},clone:function e(){var e=i.clone.call(this);return e._hash=this._hash.clone(),e}}),a.SHA1=i._createHelper(s),a.HmacSHA1=i._createHmacHelper(s),function(r){var e=ve,t=e.lib,a=t.WordArray,n=t.Hasher,i=e.algo,o=[],E=[];!function(){function e(e){for(var t=r.sqrt(e),a=2;a<=t;a++)if(!(e%a))return!1;return!0}function t(e){return 4294967296*(e-(0|e))|0}for(var a=2,n=0;n<64;)e(a)&&(n<8&&(o[n]=t(r.pow(a,.5))),E[n]=t(r.pow(a,1/3)),n++),a++}();var _=[],s=i.SHA256=n.extend({_doReset:function(){this._hash=new a.init(o.slice(0))},_doProcessBlock:function(e,t){for(var a=this._hash.words,n=a[0],r=a[1],i=a[2],o=a[3],s=a[4],l=a[5],c=a[6],d=a[7],f=0;f<64;f++){if(f<16)_[f]=0|e[t+f];else{var p=_[f-15],u=(p<<25|p>>>7)^(p<<14|p>>>18)^p>>>3,g=_[f-2],h=(g<<15|g>>>17)^(g<<13|g>>>19)^g>>>10;_[f]=u+_[f-7]+h+_[f-16]}var m=n&r^n&i^r&i,v=(n<<30|n>>>2)^(n<<19|n>>>13)^(n<<10|n>>>22),b=d+((s<<26|s>>>6)^(s<<21|s>>>11)^(s<<7|s>>>25))+(s&l^~s&c)+E[f]+_[f];d=c,c=l,l=s,s=o+b|0,o=i,i=r,r=n,n=b+(v+m)|0}a[0]=a[0]+n|0,a[1]=a[1]+r|0,a[2]=a[2]+i|0,a[3]=a[3]+o|0,a[4]=a[4]+s|0,a[5]=a[5]+l|0,a[6]=a[6]+c|0,a[7]=a[7]+d|0},_doFinalize:function(){var e=this._data,t=e.words,a=8*this._nDataBytes,n=8*e.sigBytes;return t[n>>>5]|=128<<24-n%32,t[14+(n+64>>>9<<4)]=r.floor(a/4294967296),t[15+(n+64>>>9<<4)]=a,e.sigBytes=4*t.length,this._process(),this._hash},clone:function e(){var e=n.clone.call(this);return e._hash=this._hash.clone(),e}});e.SHA256=n._createHelper(s),e.HmacSHA256=n._createHmacHelper(s)}(Math),function(){var e=ve,r=e.lib.WordArray,t=e.enc;t.Utf16=t.Utf16BE={stringify:function(e){for(var t=e.words,a=e.sigBytes,n=[],r=0;r<a;r+=2){var i=t[r>>>2]>>>16-r%4*8&65535;n.push(String.fromCharCode(i))}return n.join("")},parse:function(e){for(var t=e.length,a=[],n=0;n<t;n++)a[n>>>1]|=e.charCodeAt(n)<<16-n%2*16;return r.create(a,2*t)}};function o(e){return e<<8&4278255360|e>>>8&16711935}t.Utf16LE={stringify:function(e){for(var t=e.words,a=e.sigBytes,n=[],r=0;r<a;r+=2){var i=o(t[r>>>2]>>>16-r%4*8&65535);n.push(String.fromCharCode(i))}return n.join("")},parse:function(e){for(var t=e.length,a=[],n=0;n<t;n++)a[n>>>1]|=o(e.charCodeAt(n)<<16-n%2*16);return r.create(a,2*t)}}}(),function(){if("function"==typeof ArrayBuffer){var e=ve.lib.WordArray,r=e.init;(e.init=function(e){if(e instanceof ArrayBuffer&&(e=new Uint8Array(e)),(e instanceof Int8Array||"undefined"!=typeof Uint8ClampedArray&&e instanceof Uint8ClampedArray||e instanceof Int16Array||e instanceof Uint16Array||e instanceof Int32Array||e instanceof Uint32Array||e instanceof Float32Array||e instanceof Float64Array)&&(e=new Uint8Array(e.buffer,e.byteOffset,e.byteLength)),e instanceof Uint8Array){for(var t=e.byteLength,a=[],n=0;n<t;n++)a[n>>>2]|=e[n]<<24-n%4*8;r.call(this,a,t)}else r.apply(this,arguments)}).prototype=e}}(),function(e){var t=ve,a=t.lib,n=a.WordArray,r=a.Hasher,i=t.algo,A=n.create([0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13]),C=n.create([5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11]),T=n.create([11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6]),k=n.create([8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11]),S=n.create([0,1518500249,1859775393,2400959708,2840853838]),R=n.create([1352829926,1548603684,1836072691,2053994217,0]),o=i.RIPEMD160=r.extend({_doReset:function(){this._hash=n.create([1732584193,4023233417,2562383102,271733878,3285377520])},_doProcessBlock:function(e,t){for(var a=0;a<16;a++){var n=t+a,r=e[n];e[n]=16711935&(r<<8|r>>>24)|4278255360&(r<<24|r>>>8)}var i,o,s,l,c,d,f,p,u,g,h,m=this._hash.words,v=S.words,b=R.words,E=A.words,_=C.words,w=T.words,y=k.words;d=i=m[0],f=o=m[1],p=s=m[2],u=l=m[3],g=c=m[4];for(a=0;a<80;a+=1)h=i+e[t+E[a]]|0,h+=a<16?L(o,s,l)+v[0]:a<32?x(o,s,l)+v[1]:a<48?I(o,s,l)+v[2]:a<64?O(o,s,l)+v[3]:F(o,s,l)+v[4],h=(h=M(h|=0,w[a]))+c|0,i=c,c=l,l=M(s,10),s=o,o=h,h=d+e[t+_[a]]|0,h+=a<16?F(f,p,u)+b[0]:a<32?O(f,p,u)+b[1]:a<48?I(f,p,u)+b[2]:a<64?x(f,p,u)+b[3]:L(f,p,u)+b[4],h=(h=M(h|=0,y[a]))+g|0,d=g,g=u,u=M(p,10),p=f,f=h;h=m[1]+s+u|0,m[1]=m[2]+l+g|0,m[2]=m[3]+c+d|0,m[3]=m[4]+i+f|0,m[4]=m[0]+o+p|0,m[0]=h},_doFinalize:function(){var e=this._data,t=e.words,a=8*this._nDataBytes,n=8*e.sigBytes;t[n>>>5]|=128<<24-n%32,t[14+(n+64>>>9<<4)]=16711935&(a<<8|a>>>24)|4278255360&(a<<24|a>>>8),e.sigBytes=4*(t.length+1),this._process();for(var r=this._hash,i=r.words,o=0;o<5;o++){var s=i[o];i[o]=16711935&(s<<8|s>>>24)|4278255360&(s<<24|s>>>8)}return r},clone:function e(){var e=r.clone.call(this);return e._hash=this._hash.clone(),e}});function L(e,t,a){return e^t^a}function x(e,t,a){return e&t|~e&a}function I(e,t,a){return(e|~t)^a}function O(e,t,a){return e&a|t&~a}function F(e,t,a){return e^(t|~a)}function M(e,t){return e<<t|e>>>32-t}t.RIPEMD160=r._createHelper(o),t.HmacRIPEMD160=r._createHmacHelper(o)}(Math),c=(l=ve).lib.Base,p=l.enc.Utf8,l.algo.HMAC=c.extend({init:function(e,t){e=this._hasher=new e.init,"string"==typeof t&&(t=p.parse(t));var a=e.blockSize,n=4*a;t.sigBytes>n&&(t=e.finalize(t)),t.clamp();for(var r=this._oKey=t.clone(),i=this._iKey=t.clone(),o=r.words,s=i.words,l=0;l<a;l++)o[l]^=1549556828,s[l]^=909522486;r.sigBytes=i.sigBytes=n,this.reset()},reset:function(){var e=this._hasher;e.reset(),e.update(this._iKey)},update:function(e){return this._hasher.update(e),this},finalize:function(e){var t=this._hasher,a=t.finalize(e);return t.reset(),t.finalize(this._oKey.clone().concat(a))}}),g=(u=ve).lib,h=g.Base,v=g.WordArray,m=u.algo,b=m.SHA1,E=m.HMAC,_=m.PBKDF2=h.extend({cfg:h.extend({keySize:4,hasher:b,iterations:1}),init:function(e){this.cfg=this.cfg.extend(e)},compute:function(e,t){for(var a=this.cfg,n=E.create(a.hasher,e),r=v.create(),i=v.create([1]),o=r.words,s=i.words,l=a.keySize,c=a.iterations;o.length<l;){var d=n.update(t).finalize(i);n.reset();for(var f=d.words,p=f.length,u=d,g=1;g<c;g++){u=n.finalize(u),n.reset();for(var h=u.words,m=0;m<p;m++)f[m]^=h[m]}r.concat(d),s[0]++}return r.sigBytes=4*l,r}}),u.PBKDF2=function(e,t,a){return _.create(a).compute(e,t)},y=(w=ve).lib,A=y.Base,C=y.WordArray,T=w.algo,k=T.MD5,S=T.EvpKDF=A.extend({cfg:A.extend({keySize:4,hasher:k,iterations:1}),init:function(e){this.cfg=this.cfg.extend(e)},compute:function(e,t){for(var a,n=this.cfg,r=n.hasher.create(),i=C.create(),o=i.words,s=n.keySize,l=n.iterations;o.length<s;){a&&r.update(a),a=r.update(e).finalize(t),r.reset();for(var c=1;c<l;c++)a=r.finalize(a),r.reset();i.concat(a)}return i.sigBytes=4*s,i}}),w.EvpKDF=function(e,t,a){return S.create(a).compute(e,t)},L=(R=ve).lib.WordArray,x=R.algo,I=x.SHA256,O=x.SHA224=I.extend({_doReset:function(){this._hash=new L.init([3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428])},_doFinalize:function(){var e=I._doFinalize.call(this);return e.sigBytes-=4,e}}),R.SHA224=I._createHelper(O),R.HmacSHA224=I._createHmacHelper(O),M=(F=ve).lib,N=M.Base,D=M.WordArray,(P=F.x64={}).Word=N.extend({init:function(e,t){this.high=e,this.low=t}}),P.WordArray=N.extend({init:function(e,t){e=this.words=e||[],this.sigBytes=null!=t?t:8*e.length},toX32:function(){for(var e=this.words,t=e.length,a=[],n=0;n<t;n++){var r=e[n];a.push(r.high),a.push(r.low)}return D.create(a,this.sigBytes)},clone:function e(){for(var e=N.clone.call(this),t=e.words=this.words.slice(0),a=t.length,n=0;n<a;n++)t[n]=t[n].clone();return e}}),function(p){var e=ve,t=e.lib,u=t.WordArray,n=t.Hasher,d=e.x64.Word,a=e.algo,L=[],x=[],I=[];!function(){for(var e=1,t=0,a=0;a<24;a++){L[e+5*t]=(a+1)*(a+2)/2%64;var n=(2*e+3*t)%5;e=t%5,t=n}for(e=0;e<5;e++)for(t=0;t<5;t++)x[e+5*t]=t+(2*e+3*t)%5*5;for(var r=1,i=0;i<24;i++){for(var o=0,s=0,l=0;l<7;l++){if(1&r){var c=(1<<l)-1;c<32?s^=1<<c:o^=1<<c-32}128&r?r=r<<1^113:r<<=1}I[i]=d.create(o,s)}}();var O=[];!function(){for(var e=0;e<25;e++)O[e]=d.create()}();var r=a.SHA3=n.extend({cfg:n.cfg.extend({outputLength:512}),_doReset:function(){for(var e=this._state=[],t=0;t<25;t++)e[t]=new d.init;this.blockSize=(1600-2*this.cfg.outputLength)/32},_doProcessBlock:function(e,t){for(var a=this._state,n=this.blockSize/2,r=0;r<n;r++){var i=e[t+2*r],o=e[t+2*r+1];i=16711935&(i<<8|i>>>24)|4278255360&(i<<24|i>>>8),o=16711935&(o<<8|o>>>24)|4278255360&(o<<24|o>>>8),(C=a[r]).high^=o,C.low^=i}for(var s=0;s<24;s++){for(var l=0;l<5;l++){for(var c=0,d=0,f=0;f<5;f++){c^=(C=a[l+5*f]).high,d^=C.low}var p=O[l];p.high=c,p.low=d}for(l=0;l<5;l++){var u=O[(l+4)%5],g=O[(l+1)%5],h=g.high,m=g.low;for(c=u.high^(h<<1|m>>>31),d=u.low^(m<<1|h>>>31),f=0;f<5;f++){(C=a[l+5*f]).high^=c,C.low^=d}}for(var v=1;v<25;v++){var b=(C=a[v]).high,E=C.low,_=L[v];d=_<32?(c=b<<_|E>>>32-_,E<<_|b>>>32-_):(c=E<<_-32|b>>>64-_,b<<_-32|E>>>64-_);var w=O[x[v]];w.high=c,w.low=d}var y=O[0],A=a[0];y.high=A.high,y.low=A.low;for(l=0;l<5;l++)for(f=0;f<5;f++){var C=a[v=l+5*f],T=O[v],k=O[(l+1)%5+5*f],S=O[(l+2)%5+5*f];C.high=T.high^~k.high&S.high,C.low=T.low^~k.low&S.low}C=a[0];var R=I[s];C.high^=R.high,C.low^=R.low}},_doFinalize:function(){var e=this._data,t=e.words,a=(this._nDataBytes,8*e.sigBytes),n=32*this.blockSize;t[a>>>5]|=1<<24-a%32,t[(p.ceil((a+1)/n)*n>>>5)-1]|=128,e.sigBytes=4*t.length,this._process();for(var r=this._state,i=this.cfg.outputLength/8,o=i/8,s=[],l=0;l<o;l++){var c=r[l],d=c.high,f=c.low;d=16711935&(d<<8|d>>>24)|4278255360&(d<<24|d>>>8),f=16711935&(f<<8|f>>>24)|4278255360&(f<<24|f>>>8),s.push(f),s.push(d)}return new u.init(s,i)},clone:function e(){for(var e=n.clone.call(this),t=e._state=this._state.slice(0),a=0;a<25;a++)t[a]=t[a].clone();return e}});e.SHA3=n._createHelper(r),e.HmacSHA3=n._createHmacHelper(r)}(Math),function(){var e=ve,t=e.lib.Hasher,a=e.x64,n=a.Word,r=a.WordArray,i=e.algo;function o(){return n.create.apply(n,arguments)}var Ae=[o(1116352408,3609767458),o(1899447441,602891725),o(3049323471,3964484399),o(3921009573,2173295548),o(961987163,4081628472),o(1508970993,3053834265),o(2453635748,2937671579),o(2870763221,3664609560),o(3624381080,2734883394),o(310598401,1164996542),o(607225278,1323610764),o(1426881987,3590304994),o(1925078388,4068182383),o(2162078206,991336113),o(2614888103,633803317),o(3248222580,3479774868),o(3835390401,2666613458),o(4022224774,944711139),o(264347078,2341262773),o(604807628,2007800933),o(770255983,1495990901),o(1249150122,1856431235),o(1555081692,3175218132),o(1996064986,2198950837),o(2554220882,3999719339),o(2821834349,766784016),o(2952996808,2566594879),o(3210313671,3203337956),o(3336571891,1034457026),o(3584528711,2466948901),o(113926993,3758326383),o(338241895,168717936),o(666307205,1188179964),o(773529912,1546045734),o(1294757372,1522805485),o(1396182291,2643833823),o(1695183700,2343527390),o(1986661051,1014477480),o(2177026350,1206759142),o(2456956037,344077627),o(2730485921,1290863460),o(2820302411,3158454273),o(3259730800,3505952657),o(3345764771,106217008),o(3516065817,3606008344),o(3600352804,1432725776),o(4094571909,1467031594),o(275423344,851169720),o(430227734,3100823752),o(506948616,1363258195),o(659060556,3750685593),o(883997877,3785050280),o(958139571,3318307427),o(1322822218,3812723403),o(1537002063,2003034995),o(1747873779,3602036899),o(1955562222,1575990012),o(2024104815,1125592928),o(2227730452,2716904306),o(2361852424,442776044),o(2428436474,593698344),o(2756734187,3733110249),o(3204031479,2999351573),o(3329325298,3815920427),o(3391569614,3928383900),o(3515267271,566280711),o(3940187606,3454069534),o(4118630271,4000239992),o(116418474,1914138554),o(174292421,2731055270),o(289380356,3203993006),o(460393269,320620315),o(685471733,587496836),o(852142971,1086792851),o(1017036298,365543100),o(1126000580,2618297676),o(1288033470,3409855158),o(1501505948,4234509866),o(1607167915,987167468),o(1816402316,1246189591)],Ce=[];!function(){for(var e=0;e<80;e++)Ce[e]=o()}();var s=i.SHA512=t.extend({_doReset:function(){this._hash=new r.init([new n.init(1779033703,4089235720),new n.init(3144134277,2227873595),new n.init(1013904242,4271175723),new n.init(2773480762,1595750129),new n.init(1359893119,2917565137),new n.init(2600822924,725511199),new n.init(528734635,4215389547),new n.init(1541459225,327033209)])},_doProcessBlock:function(e,t){for(var a=this._hash.words,n=a[0],r=a[1],i=a[2],o=a[3],s=a[4],l=a[5],c=a[6],d=a[7],f=n.high,p=n.low,u=r.high,g=r.low,h=i.high,m=i.low,v=o.high,b=o.low,E=s.high,_=s.low,w=l.high,y=l.low,A=c.high,C=c.low,T=d.high,k=d.low,S=f,R=p,L=u,x=g,I=h,O=m,F=v,M=b,N=E,D=_,P=w,B=y,U=A,H=C,$=T,z=k,W=0;W<80;W++){var K,G,V=Ce[W];if(W<16)G=V.high=0|e[t+2*W],K=V.low=0|e[t+2*W+1];else{var Y=Ce[W-15],j=Y.high,q=Y.low,X=(j>>>1|q<<31)^(j>>>8|q<<24)^j>>>7,Z=(q>>>1|j<<31)^(q>>>8|j<<24)^(q>>>7|j<<25),Q=Ce[W-2],J=Q.high,ee=Q.low,te=(J>>>19|ee<<13)^(J<<3|ee>>>29)^J>>>6,ae=(ee>>>19|J<<13)^(ee<<3|J>>>29)^(ee>>>6|J<<26),ne=Ce[W-7],re=ne.high,ie=ne.low,oe=Ce[W-16],se=oe.high,le=oe.low;G=(G=(G=X+re+((K=Z+ie)>>>0<Z>>>0?1:0))+te+((K+=ae)>>>0<ae>>>0?1:0))+se+((K+=le)>>>0<le>>>0?1:0),V.high=G,V.low=K}var ce,de=N&P^~N&U,fe=D&B^~D&H,pe=S&L^S&I^L&I,ue=R&x^R&O^x&O,ge=(S>>>28|R<<4)^(S<<30|R>>>2)^(S<<25|R>>>7),he=(R>>>28|S<<4)^(R<<30|S>>>2)^(R<<25|S>>>7),me=(N>>>14|D<<18)^(N>>>18|D<<14)^(N<<23|D>>>9),ve=(D>>>14|N<<18)^(D>>>18|N<<14)^(D<<23|N>>>9),be=Ae[W],Ee=be.high,_e=be.low,we=$+me+((ce=z+ve)>>>0<z>>>0?1:0),ye=he+ue;$=U,z=H,U=P,H=B,P=N,B=D,N=F+(we=(we=(we=we+de+((ce=ce+fe)>>>0<fe>>>0?1:0))+Ee+((ce=ce+_e)>>>0<_e>>>0?1:0))+G+((ce=ce+K)>>>0<K>>>0?1:0))+((D=M+ce|0)>>>0<M>>>0?1:0)|0,F=I,M=O,I=L,O=x,L=S,x=R,S=we+(ge+pe+(ye>>>0<he>>>0?1:0))+((R=ce+ye|0)>>>0<ce>>>0?1:0)|0}p=n.low=p+R,n.high=f+S+(p>>>0<R>>>0?1:0),g=r.low=g+x,r.high=u+L+(g>>>0<x>>>0?1:0),m=i.low=m+O,i.high=h+I+(m>>>0<O>>>0?1:0),b=o.low=b+M,o.high=v+F+(b>>>0<M>>>0?1:0),_=s.low=_+D,s.high=E+N+(_>>>0<D>>>0?1:0),y=l.low=y+B,l.high=w+P+(y>>>0<B>>>0?1:0),C=c.low=C+H,c.high=A+U+(C>>>0<H>>>0?1:0),k=d.low=k+z,d.high=T+$+(k>>>0<z>>>0?1:0)},_doFinalize:function(){var e=this._data,t=e.words,a=8*this._nDataBytes,n=8*e.sigBytes;return t[n>>>5]|=128<<24-n%32,t[30+(n+128>>>10<<5)]=Math.floor(a/4294967296),t[31+(n+128>>>10<<5)]=a,e.sigBytes=4*t.length,this._process(),this._hash.toX32()},clone:function e(){var e=t.clone.call(this);return e._hash=this._hash.clone(),e},blockSize:32});e.SHA512=t._createHelper(s),e.HmacSHA512=t._createHmacHelper(s)}(),U=(B=ve).x64,H=U.Word,$=U.WordArray,z=B.algo,W=z.SHA512,K=z.SHA384=W.extend({_doReset:function(){this._hash=new $.init([new H.init(3418070365,3238371032),new H.init(1654270250,914150663),new H.init(2438529370,812702999),new H.init(355462360,4144912697),new H.init(1731405415,4290775857),new H.init(2394180231,1750603025),new H.init(3675008525,1694076839),new H.init(1203062813,3204075428)])},_doFinalize:function(){var e=W._doFinalize.call(this);return e.sigBytes-=16,e}}),B.SHA384=W._createHelper(K),B.HmacSHA384=W._createHmacHelper(K),ve.lib.Cipher||(V=(G=ve).lib,Y=V.Base,j=V.WordArray,q=V.BufferedBlockAlgorithm,(X=G.enc).Utf8,Z=X.Base64,Q=G.algo.EvpKDF,J=V.Cipher=q.extend({cfg:Y.extend(),createEncryptor:function(e,t){return this.create(this._ENC_XFORM_MODE,e,t)},createDecryptor:function(e,t){return this.create(this._DEC_XFORM_MODE,e,t)},init:function(e,t,a){this.cfg=this.cfg.extend(a),this._xformMode=e,this._key=t,this.reset()},reset:function(){q.reset.call(this),this._doReset()},process:function(e){return this._append(e),this._process()},finalize:function(e){return e&&this._append(e),this._doFinalize()},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(){function r(e){return"string"==typeof e?le:oe}return function(n){return{encrypt:function(e,t,a){return r(t).encrypt(n,e,t,a)},decrypt:function(e,t,a){return r(t).decrypt(n,e,t,a)}}}}()}),V.StreamCipher=J.extend({_doFinalize:function(){return this._process(!0)},blockSize:1}),ee=G.mode={},te=V.BlockCipherMode=Y.extend({createEncryptor:function(e,t){return this.Encryptor.create(e,t)},createDecryptor:function(e,t){return this.Decryptor.create(e,t)},init:function(e,t){this._cipher=e,this._iv=t}}),ae=ee.CBC=function(){var e=te.extend();function i(e,t,a){var n,r=this._iv;r?(n=r,this._iv=void 0):n=this._prevBlock;for(var i=0;i<a;i++)e[t+i]^=n[i]}return e.Encryptor=e.extend({processBlock:function(e,t){var a=this._cipher,n=a.blockSize;i.call(this,e,t,n),a.encryptBlock(e,t),this._prevBlock=e.slice(t,t+n)}}),e.Decryptor=e.extend({processBlock:function(e,t){var a=this._cipher,n=a.blockSize,r=e.slice(t,t+n);a.decryptBlock(e,t),i.call(this,e,t,n),this._prevBlock=r}}),e}(),ne=(G.pad={}).Pkcs7={pad:function(e,t){for(var a=4*t,n=a-e.sigBytes%a,r=n<<24|n<<16|n<<8|n,i=[],o=0;o<n;o+=4)i.push(r);var s=j.create(i,n);e.concat(s)},unpad:function(e){var t=255&e.words[e.sigBytes-1>>>2];e.sigBytes-=t}},V.BlockCipher=J.extend({cfg:J.cfg.extend({mode:ae,padding:ne}),reset:function(){var e;J.reset.call(this);var t=this.cfg,a=t.iv,n=t.mode;this._xformMode==this._ENC_XFORM_MODE?e=n.createEncryptor:(e=n.createDecryptor,this._minBufferSize=1),this._mode&&this._mode.__creator==e?this._mode.init(this,a&&a.words):(this._mode=e.call(n,this,a&&a.words),this._mode.__creator=e)},_doProcessBlock:function(e,t){this._mode.processBlock(e,t)},_doFinalize:function(){var e,t=this.cfg.padding;return this._xformMode==this._ENC_XFORM_MODE?(t.pad(this._data,this.blockSize),e=this._process(!0)):(e=this._process(!0),t.unpad(e)),e},blockSize:4}),re=V.CipherParams=Y.extend({init:function(e){this.mixIn(e)},toString:function(e){return(e||this.formatter).stringify(this)}}),ie=(G.format={}).OpenSSL={stringify:function(e){var t=e.ciphertext,a=e.salt;return(a?j.create([1398893684,1701076831]).concat(a).concat(t):t).toString(Z)},parse:function(e){var t,a=Z.parse(e),n=a.words;return 1398893684==n[0]&&1701076831==n[1]&&(t=j.create(n.slice(2,4)),n.splice(0,4),a.sigBytes-=16),re.create({ciphertext:a,salt:t})}},oe=V.SerializableCipher=Y.extend({cfg:Y.extend({format:ie}),encrypt:function(e,t,a,n){n=this.cfg.extend(n);var r=e.createEncryptor(a,n),i=r.finalize(t),o=r.cfg;return re.create({ciphertext:i,key:a,iv:o.iv,algorithm:e,mode:o.mode,padding:o.padding,blockSize:e.blockSize,formatter:n.format})},decrypt:function(e,t,a,n){return n=this.cfg.extend(n),t=this._parse(t,n.format),e.createDecryptor(a,n).finalize(t.ciphertext)},_parse:function(e,t){return"string"==typeof e?t.parse(e,this):e}}),se=(G.kdf={}).OpenSSL={execute:function(e,t,a,n){n||(n=j.random(8));var r=Q.create({keySize:t+a}).compute(e,n),i=j.create(r.words.slice(t),4*a);return r.sigBytes=4*t,re.create({key:r,iv:i,salt:n})}},le=V.PasswordBasedCipher=oe.extend({cfg:oe.cfg.extend({kdf:se}),encrypt:function(e,t,a,n){var r=(n=this.cfg.extend(n)).kdf.execute(a,e.keySize,e.ivSize);n.iv=r.iv;var i=oe.encrypt.call(this,e,t,r.key,n);return i.mixIn(r),i},decrypt:function(e,t,a,n){n=this.cfg.extend(n),t=this._parse(t,n.format);var r=n.kdf.execute(a,e.keySize,e.ivSize,t.salt);return n.iv=r.iv,oe.decrypt.call(this,e,t,r.key,n)}})),ve.mode.CFB=function(){var e=ve.lib.BlockCipherMode.extend();function i(e,t,a,n){var r,i=this._iv;i?(r=i.slice(0),this._iv=undefined):r=this._prevBlock,n.encryptBlock(r,0);for(var o=0;o<a;o++)e[t+o]^=r[o]}return e.Encryptor=e.extend({processBlock:function(e,t){var a=this._cipher,n=a.blockSize;i.call(this,e,t,n,a),this._prevBlock=e.slice(t,t+n)}}),e.Decryptor=e.extend({processBlock:function(e,t){var a=this._cipher,n=a.blockSize,r=e.slice(t,t+n);i.call(this,e,t,n,a),this._prevBlock=r}}),e}(),ve.mode.ECB=((ce=ve.lib.BlockCipherMode.extend()).Encryptor=ce.extend({processBlock:function(e,t){this._cipher.encryptBlock(e,t)}}),ce.Decryptor=ce.extend({processBlock:function(e,t){this._cipher.decryptBlock(e,t)}}),ce),ve.pad.AnsiX923={pad:function(e,t){var a=e.sigBytes,n=4*t,r=n-a%n,i=a+r-1;e.clamp(),e.words[i>>>2]|=r<<24-i%4*8,e.sigBytes+=r},unpad:function(e){var t=255&e.words[e.sigBytes-1>>>2];e.sigBytes-=t}},ve.pad.Iso10126={pad:function(e,t){var a=4*t,n=a-e.sigBytes%a;e.concat(ve.lib.WordArray.random(n-1)).concat(ve.lib.WordArray.create([n<<24],1))},unpad:function(e){var t=255&e.words[e.sigBytes-1>>>2];e.sigBytes-=t}},ve.pad.Iso97971={pad:function(e,t){e.concat(ve.lib.WordArray.create([2147483648],1)),ve.pad.ZeroPadding.pad(e,t)},unpad:function(e){ve.pad.ZeroPadding.unpad(e),e.sigBytes--}},ve.mode.OFB=(de=ve.lib.BlockCipherMode.extend(),fe=de.Encryptor=de.extend({processBlock:function(e,t){var a=this._cipher,n=a.blockSize,r=this._iv,i=this._keystream;r&&(i=this._keystream=r.slice(0),this._iv=undefined),a.encryptBlock(i,0);for(var o=0;o<n;o++)e[t+o]^=i[o]}}),de.Decryptor=fe,de),ve.pad.NoPadding={pad:function(){},unpad:function(){}},ue=(pe=ve).lib.CipherParams,ge=pe.enc.Hex,pe.format.Hex={stringify:function(e){return e.ciphertext.toString(ge)},parse:function(e){var t=ge.parse(e);return ue.create({ciphertext:t})}},function(){var e=ve,t=e.lib.BlockCipher,a=e.algo,c=[],d=[],f=[],p=[],u=[],g=[],h=[],m=[],v=[],b=[];!function(){for(var e=[],t=0;t<256;t++)e[t]=t<128?t<<1:t<<1^283;var a=0,n=0;for(t=0;t<256;t++){var r=n^n<<1^n<<2^n<<3^n<<4;r=r>>>8^255&r^99,c[a]=r;var i=e[d[r]=a],o=e[i],s=e[o],l=257*e[r]^16843008*r;f[a]=l<<24|l>>>8,p[a]=l<<16|l>>>16,u[a]=l<<8|l>>>24,g[a]=l;l=16843009*s^65537*o^257*i^16843008*a;h[r]=l<<24|l>>>8,m[r]=l<<16|l>>>16,v[r]=l<<8|l>>>24,b[r]=l,a?(a=i^e[e[e[s^i]]],n^=e[e[n]]):a=n=1}}();var E=[0,1,2,4,8,16,32,64,128,27,54],n=a.AES=t.extend({_doReset:function(){if(!this._nRounds||this._keyPriorReset!==this._key){for(var e=this._keyPriorReset=this._key,t=e.words,a=e.sigBytes/4,n=4*((this._nRounds=a+6)+1),r=this._keySchedule=[],i=0;i<n;i++)i<a?r[i]=t[i]:(l=r[i-1],i%a?6<a&&i%a==4&&(l=c[l>>>24]<<24|c[l>>>16&255]<<16|c[l>>>8&255]<<8|c[255&l]):(l=c[(l=l<<8|l>>>24)>>>24]<<24|c[l>>>16&255]<<16|c[l>>>8&255]<<8|c[255&l],l^=E[i/a|0]<<24),r[i]=r[i-a]^l);for(var o=this._invKeySchedule=[],s=0;s<n;s++){i=n-s;if(s%4)var l=r[i];else l=r[i-4];o[s]=s<4||i<=4?l:h[c[l>>>24]]^m[c[l>>>16&255]]^v[c[l>>>8&255]]^b[c[255&l]]}}},encryptBlock:function(e,t){this._doCryptBlock(e,t,this._keySchedule,f,p,u,g,c)},decryptBlock:function(e,t){var a=e[t+1];e[t+1]=e[t+3],e[t+3]=a,this._doCryptBlock(e,t,this._invKeySchedule,h,m,v,b,d);a=e[t+1];e[t+1]=e[t+3],e[t+3]=a},_doCryptBlock:function(e,t,a,n,r,i,o,s){for(var l=this._nRounds,c=e[t]^a[0],d=e[t+1]^a[1],f=e[t+2]^a[2],p=e[t+3]^a[3],u=4,g=1;g<l;g++){var h=n[c>>>24]^r[d>>>16&255]^i[f>>>8&255]^o[255&p]^a[u++],m=n[d>>>24]^r[f>>>16&255]^i[p>>>8&255]^o[255&c]^a[u++],v=n[f>>>24]^r[p>>>16&255]^i[c>>>8&255]^o[255&d]^a[u++],b=n[p>>>24]^r[c>>>16&255]^i[d>>>8&255]^o[255&f]^a[u++];c=h,d=m,f=v,p=b}h=(s[c>>>24]<<24|s[d>>>16&255]<<16|s[f>>>8&255]<<8|s[255&p])^a[u++],m=(s[d>>>24]<<24|s[f>>>16&255]<<16|s[p>>>8&255]<<8|s[255&c])^a[u++],v=(s[f>>>24]<<24|s[p>>>16&255]<<16|s[c>>>8&255]<<8|s[255&d])^a[u++],b=(s[p>>>24]<<24|s[c>>>16&255]<<16|s[d>>>8&255]<<8|s[255&f])^a[u++];e[t]=h,e[t+1]=m,e[t+2]=v,e[t+3]=b},keySize:8});e.AES=t._createHelper(n)}(),function(){var e=ve,t=e.lib,r=t.WordArray,a=t.BlockCipher,n=e.algo,c=[57,49,41,33,25,17,9,1,58,50,42,34,26,18,10,2,59,51,43,35,27,19,11,3,60,52,44,36,63,55,47,39,31,23,15,7,62,54,46,38,30,22,14,6,61,53,45,37,29,21,13,5,28,20,12,4],d=[14,17,11,24,1,5,3,28,15,6,21,10,23,19,12,4,26,8,16,7,27,20,13,2,41,52,31,37,47,55,30,40,51,45,33,48,44,49,39,56,34,53,46,42,50,36,29,32],f=[1,2,4,6,8,10,12,14,15,17,19,21,23,25,27,28],p=[{0:8421888,268435456:32768,536870912:8421378,805306368:2,1073741824:512,1342177280:8421890,1610612736:8389122,1879048192:8388608,2147483648:514,2415919104:8389120,2684354560:33280,2952790016:8421376,3221225472:32770,3489660928:8388610,3758096384:0,4026531840:33282,134217728:0,402653184:8421890,671088640:33282,939524096:32768,1207959552:8421888,1476395008:512,1744830464:8421378,2013265920:2,2281701376:8389120,2550136832:33280,2818572288:8421376,3087007744:8389122,3355443200:8388610,3623878656:32770,3892314112:514,4160749568:8388608,1:32768,268435457:2,536870913:8421888,805306369:8388608,1073741825:8421378,1342177281:33280,1610612737:512,1879048193:8389122,2147483649:8421890,2415919105:8421376,2684354561:8388610,2952790017:33282,3221225473:514,3489660929:8389120,3758096385:32770,4026531841:0,134217729:8421890,402653185:8421376,671088641:8388608,939524097:512,1207959553:32768,1476395009:8388610,1744830465:2,2013265921:33282,2281701377:32770,2550136833:8389122,2818572289:514,3087007745:8421888,3355443201:8389120,3623878657:0,3892314113:33280,4160749569:8421378},{0:1074282512,16777216:16384,33554432:524288,50331648:1074266128,67108864:1073741840,83886080:1074282496,100663296:1073758208,117440512:16,134217728:540672,150994944:1073758224,167772160:1073741824,184549376:540688,201326592:524304,218103808:0,234881024:16400,251658240:1074266112,8388608:1073758208,25165824:540688,41943040:16,58720256:1073758224,75497472:1074282512,92274688:1073741824,109051904:524288,125829120:1074266128,142606336:524304,159383552:0,176160768:16384,192937984:1074266112,209715200:1073741840,226492416:540672,243269632:1074282496,260046848:16400,268435456:0,285212672:1074266128,301989888:1073758224,318767104:1074282496,335544320:1074266112,352321536:16,369098752:540688,385875968:16384,402653184:16400,419430400:524288,436207616:524304,452984832:1073741840,469762048:540672,486539264:1073758208,503316480:1073741824,520093696:1074282512,276824064:540688,293601280:524288,310378496:1074266112,327155712:16384,343932928:1073758208,360710144:1074282512,377487360:16,394264576:1073741824,411041792:1074282496,427819008:1073741840,444596224:1073758224,461373440:524304,478150656:0,494927872:16400,511705088:1074266128,528482304:540672},{0:260,1048576:0,2097152:67109120,3145728:65796,4194304:65540,5242880:67108868,6291456:67174660,7340032:67174400,8388608:67108864,9437184:67174656,10485760:65792,11534336:67174404,12582912:67109124,13631488:65536,14680064:4,15728640:256,524288:67174656,1572864:67174404,2621440:0,3670016:67109120,4718592:67108868,5767168:65536,6815744:65540,7864320:260,8912896:4,9961472:256,11010048:67174400,12058624:65796,13107200:65792,14155776:67109124,15204352:67174660,16252928:67108864,16777216:67174656,17825792:65540,18874368:65536,19922944:67109120,20971520:256,22020096:67174660,23068672:67108868,24117248:0,25165824:67109124,26214400:67108864,27262976:4,28311552:65792,29360128:67174400,30408704:260,31457280:65796,32505856:67174404,17301504:67108864,18350080:260,19398656:67174656,20447232:0,21495808:65540,22544384:67109120,23592960:256,24641536:67174404,25690112:65536,26738688:67174660,27787264:65796,28835840:67108868,29884416:67109124,30932992:67174400,31981568:4,33030144:65792},{0:2151682048,65536:2147487808,131072:4198464,196608:2151677952,262144:0,327680:4198400,393216:2147483712,458752:4194368,524288:2147483648,589824:4194304,655360:64,720896:2147487744,786432:2151678016,851968:4160,917504:4096,983040:2151682112,32768:2147487808,98304:64,163840:2151678016,229376:2147487744,294912:4198400,360448:2151682112,425984:0,491520:2151677952,557056:4096,622592:2151682048,688128:4194304,753664:4160,819200:2147483648,884736:4194368,950272:4198464,1015808:2147483712,1048576:4194368,1114112:4198400,1179648:2147483712,1245184:0,1310720:4160,1376256:2151678016,1441792:2151682048,1507328:2147487808,1572864:2151682112,1638400:2147483648,1703936:2151677952,1769472:4198464,1835008:2147487744,1900544:4194304,1966080:64,2031616:4096,1081344:2151677952,1146880:2151682112,1212416:0,1277952:4198400,1343488:4194368,1409024:2147483648,1474560:2147487808,1540096:64,1605632:2147483712,1671168:4096,1736704:2147487744,1802240:2151678016,1867776:4160,1933312:2151682048,1998848:4194304,2064384:4198464},{0:128,4096:17039360,8192:262144,12288:536870912,16384:537133184,20480:16777344,24576:553648256,28672:262272,32768:16777216,36864:537133056,40960:536871040,45056:553910400,49152:553910272,53248:0,57344:17039488,61440:553648128,2048:17039488,6144:553648256,10240:128,14336:17039360,18432:262144,22528:537133184,26624:553910272,30720:536870912,34816:537133056,38912:0,43008:553910400,47104:16777344,51200:536871040,55296:553648128,59392:16777216,63488:262272,65536:262144,69632:128,73728:536870912,77824:553648256,81920:16777344,86016:553910272,90112:537133184,94208:16777216,98304:553910400,102400:553648128,106496:17039360,110592:537133056,114688:262272,118784:536871040,122880:0,126976:17039488,67584:553648256,71680:16777216,75776:17039360,79872:537133184,83968:536870912,88064:17039488,92160:128,96256:553910272,100352:262272,104448:553910400,108544:0,112640:553648128,116736:16777344,120832:262144,124928:537133056,129024:536871040},{0:268435464,256:8192,512:270532608,768:270540808,1024:268443648,1280:2097152,1536:2097160,1792:268435456,2048:0,2304:268443656,2560:2105344,2816:8,3072:270532616,3328:2105352,3584:8200,3840:270540800,128:270532608,384:270540808,640:8,896:2097152,1152:2105352,1408:268435464,1664:268443648,1920:8200,2176:2097160,2432:8192,2688:268443656,2944:270532616,3200:0,3456:270540800,3712:2105344,3968:268435456,4096:268443648,4352:270532616,4608:270540808,4864:8200,5120:2097152,5376:268435456,5632:268435464,5888:2105344,6144:2105352,6400:0,6656:8,6912:270532608,7168:8192,7424:268443656,7680:270540800,7936:2097160,4224:8,4480:2105344,4736:2097152,4992:268435464,5248:268443648,5504:8200,5760:270540808,6016:270532608,6272:270540800,6528:270532616,6784:8192,7040:2105352,7296:2097160,7552:0,7808:268435456,8064:268443656},{0:1048576,16:33555457,32:1024,48:1049601,64:34604033,80:0,96:1,112:34603009,128:33555456,144:1048577,160:33554433,176:34604032,192:34603008,208:1025,224:1049600,240:33554432,8:34603009,24:0,40:33555457,56:34604032,72:1048576,88:33554433,104:33554432,120:1025,136:1049601,152:33555456,168:34603008,184:1048577,200:1024,216:34604033,232:1,248:1049600,256:33554432,272:1048576,288:33555457,304:34603009,320:1048577,336:33555456,352:34604032,368:1049601,384:1025,400:34604033,416:1049600,432:1,448:0,464:34603008,480:33554433,496:1024,264:1049600,280:33555457,296:34603009,312:1,328:33554432,344:1048576,360:1025,376:34604032,392:33554433,408:34603008,424:0,440:34604033,456:1049601,472:1024,488:33555456,504:1048577},{0:134219808,1:131072,2:134217728,3:32,4:131104,5:134350880,6:134350848,7:2048,8:134348800,9:134219776,10:133120,11:134348832,12:2080,13:0,14:134217760,15:133152,2147483648:2048,2147483649:134350880,2147483650:134219808,2147483651:134217728,2147483652:134348800,2147483653:133120,2147483654:133152,2147483655:32,2147483656:134217760,2147483657:2080,2147483658:131104,2147483659:134350848,2147483660:0,2147483661:134348832,2147483662:134219776,2147483663:131072,16:133152,17:134350848,18:32,19:2048,20:134219776,21:134217760,22:134348832,23:131072,24:0,25:131104,26:134348800,27:134219808,28:134350880,29:133120,30:2080,31:134217728,2147483664:131072,2147483665:2048,2147483666:134348832,2147483667:133152,2147483668:32,2147483669:134348800,2147483670:134217728,2147483671:134219808,2147483672:134350880,2147483673:134217760,2147483674:134219776,2147483675:0,2147483676:133120,2147483677:2080,2147483678:131104,2147483679:134350848}],u=[4160749569,528482304,33030144,2064384,129024,8064,504,2147483679],i=n.DES=a.extend({_doReset:function(){for(var e=this._key.words,t=[],a=0;a<56;a++){var n=c[a]-1;t[a]=e[n>>>5]>>>31-n%32&1}for(var r=this._subKeys=[],i=0;i<16;i++){var o=r[i]=[],s=f[i];for(a=0;a<24;a++)o[a/6|0]|=t[(d[a]-1+s)%28]<<31-a%6,o[4+(a/6|0)]|=t[28+(d[a+24]-1+s)%28]<<31-a%6;o[0]=o[0]<<1|o[0]>>>31;for(a=1;a<7;a++)o[a]=o[a]>>>4*(a-1)+3;o[7]=o[7]<<5|o[7]>>>27}var l=this._invSubKeys=[];for(a=0;a<16;a++)l[a]=r[15-a]},encryptBlock:function(e,t){this._doCryptBlock(e,t,this._subKeys)},decryptBlock:function(e,t){this._doCryptBlock(e,t,this._invSubKeys)},_doCryptBlock:function(e,t,a){this._lBlock=e[t],this._rBlock=e[t+1],g.call(this,4,252645135),g.call(this,16,65535),h.call(this,2,858993459),h.call(this,8,16711935),g.call(this,1,1431655765);for(var n=0;n<16;n++){for(var r=a[n],i=this._lBlock,o=this._rBlock,s=0,l=0;l<8;l++)s|=p[l][((o^r[l])&u[l])>>>0];this._lBlock=o,this._rBlock=i^s}var c=this._lBlock;this._lBlock=this._rBlock,this._rBlock=c,g.call(this,1,1431655765),h.call(this,8,16711935),h.call(this,2,858993459),g.call(this,16,65535),g.call(this,4,252645135),e[t]=this._lBlock,e[t+1]=this._rBlock},keySize:2,ivSize:2,blockSize:2});function g(e,t){var a=(this._lBlock>>>e^this._rBlock)&t;this._rBlock^=a,this._lBlock^=a<<e}function h(e,t){var a=(this._rBlock>>>e^this._lBlock)&t;this._lBlock^=a,this._rBlock^=a<<e}e.DES=a._createHelper(i);var o=n.TripleDES=a.extend({_doReset:function(){var e=this._key.words;if(2!==e.length&&4!==e.length&&e.length<6)throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");var t=e.slice(0,2),a=e.length<4?e.slice(0,2):e.slice(2,4),n=e.length<6?e.slice(0,2):e.slice(4,6);this._des1=i.createEncryptor(r.create(t)),this._des2=i.createEncryptor(r.create(a)),this._des3=i.createEncryptor(r.create(n))},encryptBlock:function(e,t){this._des1.encryptBlock(e,t),this._des2.decryptBlock(e,t),this._des3.encryptBlock(e,t)},decryptBlock:function(e,t){this._des3.decryptBlock(e,t),this._des2.encryptBlock(e,t),this._des1.decryptBlock(e,t)},keySize:6,ivSize:2,blockSize:2});e.TripleDES=a._createHelper(o)}(),function(){var e=ve,t=e.lib.StreamCipher,a=e.algo,n=a.RC4=t.extend({_doReset:function(){for(var e=this._key,t=e.words,a=e.sigBytes,n=this._S=[],r=0;r<256;r++)n[r]=r;r=0;for(var i=0;r<256;r++){var o=r%a,s=t[o>>>2]>>>24-o%4*8&255;i=(i+n[r]+s)%256;var l=n[r];n[r]=n[i],n[i]=l}this._i=this._j=0},_doProcessBlock:function(e,t){e[t]^=r.call(this)},keySize:8,ivSize:0});function r(){for(var e=this._S,t=this._i,a=this._j,n=0,r=0;r<4;r++){a=(a+e[t=(t+1)%256])%256;var i=e[t];e[t]=e[a],e[a]=i,n|=e[(e[t]+e[a])%256]<<24-8*r}return this._i=t,this._j=a,n}e.RC4=t._createHelper(n);var i=a.RC4Drop=n.extend({cfg:n.cfg.extend({drop:192}),_doReset:function(){n._doReset.call(this);for(var e=this.cfg.drop;0<e;e--)r.call(this)}});e.RC4Drop=t._createHelper(i)}(),ve.mode.CTRGladman=function(){var e=ve.lib.BlockCipherMode.extend();function c(e){if(255==(e>>24&255)){var t=e>>16&255,a=e>>8&255,n=255&e;255===t?(t=0,255===a?(a=0,255===n?n=0:++n):++a):++t,e=0,e+=t<<16,e+=a<<8,e+=n}else e+=1<<24;return e}var t=e.Encryptor=e.extend({processBlock:function(e,t){var a=this._cipher,n=a.blockSize,r=this._iv,i=this._counter;r&&(i=this._counter=r.slice(0),this._iv=undefined),function l(e){return 0===(e[0]=c(e[0]))&&(e[1]=c(e[1])),e}(i);var o=i.slice(0);a.encryptBlock(o,0);for(var s=0;s<n;s++)e[t+s]^=o[s]}});return e.Decryptor=t,e}(),function(){var e=ve,t=e.lib.StreamCipher,a=e.algo,r=[],l=[],c=[],n=a.Rabbit=t.extend({_doReset:function(){for(var e=this._key.words,t=this.cfg.iv,a=0;a<4;a++)e[a]=16711935&(e[a]<<8|e[a]>>>24)|4278255360&(e[a]<<24|e[a]>>>8);var n=this._X=[e[0],e[3]<<16|e[2]>>>16,e[1],e[0]<<16|e[3]>>>16,e[2],e[1]<<16|e[0]>>>16,e[3],e[2]<<16|e[1]>>>16],r=this._C=[e[2]<<16|e[2]>>>16,4294901760&e[0]|65535&e[1],e[3]<<16|e[3]>>>16,4294901760&e[1]|65535&e[2],e[0]<<16|e[0]>>>16,4294901760&e[2]|65535&e[3],e[1]<<16|e[1]>>>16,4294901760&e[3]|65535&e[0]];for(a=this._b=0;a<4;a++)p.call(this);for(a=0;a<8;a++)r[a]^=n[a+4&7];if(t){var i=t.words,o=i[0],s=i[1],l=16711935&(o<<8|o>>>24)|4278255360&(o<<24|o>>>8),c=16711935&(s<<8|s>>>24)|4278255360&(s<<24|s>>>8),d=l>>>16|4294901760&c,f=c<<16|65535&l;r[0]^=l,r[1]^=d,r[2]^=c,r[3]^=f,r[4]^=l,r[5]^=d,r[6]^=c,r[7]^=f;for(a=0;a<4;a++)p.call(this)}},_doProcessBlock:function(e,t){var a=this._X;p.call(this),r[0]=a[0]^a[5]>>>16^a[3]<<16,r[1]=a[2]^a[7]>>>16^a[5]<<16,r[2]=a[4]^a[1]>>>16^a[7]<<16,r[3]=a[6]^a[3]>>>16^a[1]<<16;for(var n=0;n<4;n++)r[n]=16711935&(r[n]<<8|r[n]>>>24)|4278255360&(r[n]<<24|r[n]>>>8),e[t+n]^=r[n]},blockSize:4,ivSize:2});function p(){for(var e=this._X,t=this._C,a=0;a<8;a++)l[a]=t[a];t[0]=t[0]+1295307597+this._b|0,t[1]=t[1]+3545052371+(t[0]>>>0<l[0]>>>0?1:0)|0,t[2]=t[2]+886263092+(t[1]>>>0<l[1]>>>0?1:0)|0,t[3]=t[3]+1295307597+(t[2]>>>0<l[2]>>>0?1:0)|0,t[4]=t[4]+3545052371+(t[3]>>>0<l[3]>>>0?1:0)|0,t[5]=t[5]+886263092+(t[4]>>>0<l[4]>>>0?1:0)|0,t[6]=t[6]+1295307597+(t[5]>>>0<l[5]>>>0?1:0)|0,t[7]=t[7]+3545052371+(t[6]>>>0<l[6]>>>0?1:0)|0,this._b=t[7]>>>0<l[7]>>>0?1:0;for(a=0;a<8;a++){var n=e[a]+t[a],r=65535&n,i=n>>>16,o=((r*r>>>17)+r*i>>>15)+i*i,s=((4294901760&n)*n|0)+((65535&n)*n|0);c[a]=o^s}e[0]=c[0]+(c[7]<<16|c[7]>>>16)+(c[6]<<16|c[6]>>>16)|0,e[1]=c[1]+(c[0]<<8|c[0]>>>24)+c[7]|0,e[2]=c[2]+(c[1]<<16|c[1]>>>16)+(c[0]<<16|c[0]>>>16)|0,e[3]=c[3]+(c[2]<<8|c[2]>>>24)+c[1]|0,e[4]=c[4]+(c[3]<<16|c[3]>>>16)+(c[2]<<16|c[2]>>>16)|0,e[5]=c[5]+(c[4]<<8|c[4]>>>24)+c[3]|0,e[6]=c[6]+(c[5]<<16|c[5]>>>16)+(c[4]<<16|c[4]>>>16)|0,e[7]=c[7]+(c[6]<<8|c[6]>>>24)+c[5]|0}e.Rabbit=t._createHelper(n)}(),ve.mode.CTR=(he=ve.lib.BlockCipherMode.extend(),me=he.Encryptor=he.extend({processBlock:function(e,t){var a=this._cipher,n=a.blockSize,r=this._iv,i=this._counter;r&&(i=this._counter=r.slice(0),this._iv=undefined);var o=i.slice(0);a.encryptBlock(o,0),i[n-1]=i[n-1]+1|0;for(var s=0;s<n;s++)e[t+s]^=o[s]}}),he.Decryptor=me,he),function(){var e=ve,t=e.lib.StreamCipher,a=e.algo,r=[],l=[],c=[],n=a.RabbitLegacy=t.extend({_doReset:function(){for(var e=this._key.words,t=this.cfg.iv,a=this._X=[e[0],e[3]<<16|e[2]>>>16,e[1],e[0]<<16|e[3]>>>16,e[2],e[1]<<16|e[0]>>>16,e[3],e[2]<<16|e[1]>>>16],n=this._C=[e[2]<<16|e[2]>>>16,4294901760&e[0]|65535&e[1],e[3]<<16|e[3]>>>16,4294901760&e[1]|65535&e[2],e[0]<<16|e[0]>>>16,4294901760&e[2]|65535&e[3],e[1]<<16|e[1]>>>16,4294901760&e[3]|65535&e[0]],r=this._b=0;r<4;r++)p.call(this);for(r=0;r<8;r++)n[r]^=a[r+4&7];if(t){var i=t.words,o=i[0],s=i[1],l=16711935&(o<<8|o>>>24)|4278255360&(o<<24|o>>>8),c=16711935&(s<<8|s>>>24)|4278255360&(s<<24|s>>>8),d=l>>>16|4294901760&c,f=c<<16|65535&l;n[0]^=l,n[1]^=d,n[2]^=c,n[3]^=f,n[4]^=l,n[5]^=d,n[6]^=c,n[7]^=f;for(r=0;r<4;r++)p.call(this)}},_doProcessBlock:function(e,t){var a=this._X;p.call(this),r[0]=a[0]^a[5]>>>16^a[3]<<16,r[1]=a[2]^a[7]>>>16^a[5]<<16,r[2]=a[4]^a[1]>>>16^a[7]<<16,r[3]=a[6]^a[3]>>>16^a[1]<<16;for(var n=0;n<4;n++)r[n]=16711935&(r[n]<<8|r[n]>>>24)|4278255360&(r[n]<<24|r[n]>>>8),e[t+n]^=r[n]},blockSize:4,ivSize:2});function p(){for(var e=this._X,t=this._C,a=0;a<8;a++)l[a]=t[a];t[0]=t[0]+1295307597+this._b|0,t[1]=t[1]+3545052371+(t[0]>>>0<l[0]>>>0?1:0)|0,t[2]=t[2]+886263092+(t[1]>>>0<l[1]>>>0?1:0)|0,t[3]=t[3]+1295307597+(t[2]>>>0<l[2]>>>0?1:0)|0,t[4]=t[4]+3545052371+(t[3]>>>0<l[3]>>>0?1:0)|0,t[5]=t[5]+886263092+(t[4]>>>0<l[4]>>>0?1:0)|0,t[6]=t[6]+1295307597+(t[5]>>>0<l[5]>>>0?1:0)|0,t[7]=t[7]+3545052371+(t[6]>>>0<l[6]>>>0?1:0)|0,this._b=t[7]>>>0<l[7]>>>0?1:0;for(a=0;a<8;a++){var n=e[a]+t[a],r=65535&n,i=n>>>16,o=((r*r>>>17)+r*i>>>15)+i*i,s=((4294901760&n)*n|0)+((65535&n)*n|0);c[a]=o^s}e[0]=c[0]+(c[7]<<16|c[7]>>>16)+(c[6]<<16|c[6]>>>16)|0,e[1]=c[1]+(c[0]<<8|c[0]>>>24)+c[7]|0,e[2]=c[2]+(c[1]<<16|c[1]>>>16)+(c[0]<<16|c[0]>>>16)|0,e[3]=c[3]+(c[2]<<8|c[2]>>>24)+c[1]|0,e[4]=c[4]+(c[3]<<16|c[3]>>>16)+(c[2]<<16|c[2]>>>16)|0,e[5]=c[5]+(c[4]<<8|c[4]>>>24)+c[3]|0,e[6]=c[6]+(c[5]<<16|c[5]>>>16)+(c[4]<<16|c[4]>>>16)|0,e[7]=c[7]+(c[6]<<8|c[6]>>>24)+c[5]|0}e.RabbitLegacy=t._createHelper(n)}(),ve.pad.ZeroPadding={pad:function(e,t){var a=4*t;e.clamp(),e.sigBytes+=a-(e.sigBytes%a||a)},unpad:function(e){var t=e.words,a=e.sigBytes-1;for(a=e.sigBytes-1;0<=a;a--)if(t[a>>>2]>>>24-a%4*8&255){e.sigBytes=a+1;break}}},{init:function be(){},cryptoJS:ve}},Object.assign(St.DEFAULTS,{fontFamily:{"Arial,Helvetica,sans-serif":"Arial","Georgia,serif":"Georgia","Impact,Charcoal,sans-serif":"Impact","Tahoma,Geneva,sans-serif":"Tahoma","Times New Roman,Times,serif,-webkit-standard":"Times New Roman","Verdana,Geneva,sans-serif":"Verdana"},fontFamilySelection:!1,fontFamilyDefaultSelection:"Font Family"}),St.PLUGINS.fontFamily=function(r){var i=r.$;function o(e){var t=e.replace(/(sans-serif|serif|monospace|cursive|fantasy)/gi,"").replace(/"|'| /g,"").split(",");return i(this).grep(t,function(e){return 0<e.length})}function s(e,t){for(var a=0;a<e.length;a++)for(var n=0;n<t.length;n++)if(e[a].toLowerCase()===t[n].toLowerCase())return[a,n];return null}function a(){var e=o(i(r.selection.element()).css("font-family")),t=[];for(var a in r.opts.fontFamily)if(r.opts.fontFamily.hasOwnProperty(a)){var n=s(e,o(a));n&&t.push([a,n])}return 0===t.length?null:(t.sort(function(e,t){var a=e[1][0]-t[1][0];return 0===a?e[1][1]-t[1][1]:a}),t[0][0])}return{apply:function t(e){r.format.applyStyle("font-family",e)},refreshOnShow:function n(e,t){t.find(".fr-command.fr-active").removeClass("fr-active").attr("aria-selected",!1),t.find('.fr-command[data-param1="'.concat(a(),'"]')).addClass("fr-active").attr("aria-selected",!0)},refresh:function l(e){if(r.opts.fontFamilySelection){var t=i(r.selection.element()).css("font-family").replace(/(sans-serif|serif|monospace|cursive|fantasy)/gi,"").replace(/"|'|/g,"").split(",");e.find("> span").text(r.opts.fontFamily[a()]||t[0]||r.language.translate(r.opts.fontFamilyDefaultSelection))}}}},St.RegisterCommand("fontFamily",{type:"dropdown",displaySelection:function(e){return e.opts.fontFamilySelection},defaultSelection:function(e){return e.opts.fontFamilyDefaultSelection},displaySelectionWidth:120,html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.fontFamily;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="fontFamily" data-param1="'.concat(a,'" \n        style="font-family: ').concat(a,'" title="').concat(t[a],'">').concat(t[a],"</a></li>"));return e+="</ul>"},title:"Font Family",callback:function(e,t){this.fontFamily.apply(t)},refresh:function(e){this.fontFamily.refresh(e)},refreshOnShow:function(e,t){this.fontFamily.refreshOnShow(e,t)},plugin:"fontFamily"}),St.DefineIcon("fontFamily",{NAME:"font",SVG_KEY:"fontFamily"}),Object.assign(St.DEFAULTS,{fontSize:["8","9","10","11","12","14","18","24","30","36","48","60","72","96"],fontSizeSelection:!1,fontSizeDefaultSelection:"Font Size",fontSizeUnit:"px"}),St.PLUGINS.fontSize=function(n){var r=n.$;return{apply:function t(e){n.format.applyStyle("font-size",e)},refreshOnShow:function i(e,t){var a=r(n.selection.element()).css("font-size");"pt"===n.opts.fontSizeUnit&&(a="".concat(Math.round(72*parseFloat(a,10)/96),"pt")),t.find(".fr-command.fr-active").removeClass("fr-active").attr("aria-selected",!1),t.find('.fr-command[data-param1="'.concat(a,'"]')).addClass("fr-active").attr("aria-selected",!0)},refresh:function a(e){if(n.opts.fontSizeSelection){var t=n.helpers.getPX(r(n.selection.element()).css("font-size"));"pt"===n.opts.fontSizeUnit&&(t="".concat(Math.round(72*parseFloat(t,10)/96),"pt")),e.find("> span").text(t)}}}},St.RegisterCommand("fontSize",{type:"dropdown",title:"Font Size",displaySelection:function(e){return e.opts.fontSizeSelection},displaySelectionWidth:30,defaultSelection:function(e){return e.opts.fontSizeDefaultSelection},html:function(){for(var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.fontSize,a=0;a<t.length;a++){var n=t[a];e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="fontSize" data-param1="'.concat(n).concat(this.opts.fontSizeUnit,'" title="').concat(n,'">').concat(n,"</a></li>")}return e+="</ul>"},callback:function(e,t){this.fontSize.apply(t)},refresh:function(e){this.fontSize.refresh(e)},refreshOnShow:function(e,t){this.fontSize.refreshOnShow(e,t)},plugin:"fontSize"}),St.DefineIcon("fontSize",{NAME:"text-height",SVG_KEY:"fontSize"}),Object.assign(St.POPUP_TEMPLATES,{"forms.edit":"[_BUTTONS_]","forms.update":"[_BUTTONS_][_TEXT_LAYER_]"}),Object.assign(St.DEFAULTS,{formEditButtons:["inputStyle","inputEdit"],formStyles:{"fr-rounded":"Rounded","fr-large":"Large"},formMultipleStyles:!0,formUpdateButtons:["inputBack","|"]}),St.PLUGINS.forms=function(o){var s,l=o.$;function t(e){o.selection.clear(),l(this).data("mousedown",!0)}function a(e){l(this).data("mousedown")&&(e.stopPropagation(),l(this).removeData("mousedown"),d(s=this)),e.preventDefault()}function n(){o.$el.find("input, textarea, button").removeData("mousedown")}function r(){l(this).removeData("mousedown")}function c(){return s||null}function d(e){if(-1==["checkbox","radio"].indexOf(e.type)){var t=o.popups.get("forms.edit");t||(t=function i(){var e="";0<o.opts.formEditButtons.length&&(e='<div class="fr-buttons">'.concat(o.button.buildList(o.opts.formEditButtons),"</div>"));var t={buttons:e},a=o.popups.create("forms.edit",t);return o.$wp&&o.events.$on(o.$wp,"scroll.link-edit",function(){c()&&o.popups.isVisible("forms.edit")&&d(c())}),a}());var a=l(s=e);o.popups.refresh("forms.edit"),o.popups.setContainer("forms.edit",o.$sc);var n=a.offset().left+a.outerWidth()/2,r=a.offset().top+a.outerHeight();o.popups.show("forms.edit",n,r,a.outerHeight())}}function i(){var e=o.popups.get("forms.update"),t=c();if(t){var a=l(t);a.is("button")?e.find('input[type="text"][name="text"]').val(a.text()):a.is("input[type=button]")||a.is("input[type=submit]")||a.is("input[type=reset]")?e.find('input[type="text"][name="text"]').val(a.val()):e.find('input[type="text"][name="text"]').val(a.attr("placeholder"))}e.find('input[type="text"][name="text"]').trigger("change")}function f(){s=null}function p(e){if(e)return o.popups.onRefresh("forms.update",i),o.popups.onHide("forms.update",f),!0;var t="";1<=o.opts.formUpdateButtons.length&&(t='<div class="fr-buttons">'.concat(o.button.buildList(o.opts.formUpdateButtons),"</div>"));var a=0,n={buttons:t,text_layer:'<div class="fr-forms-text-layer fr-layer fr-active"> \n    <div class="fr-input-line"><input name="text" type="text" placeholder="Text" tabIndex=" '.concat(++a,' "></div>\n    <div class="fr-action-buttons"><button class="fr-command fr-submit" data-cmd="updateInput" href="#" tabIndex="').concat(2,'" type="button">').concat(o.language.translate("Update"),"</button></div></div>")};return o.popups.create("forms.update",n)}return{_init:function u(){!function e(){o.events.$on(o.$el,o._mousedown,"input, textarea, button",t),o.events.$on(o.$el,o._mouseup,"input, textarea, button",a),o.events.$on(o.$el,"touchmove","input, textarea, button",r),o.events.$on(o.$el,o._mouseup,n),o.events.$on(o.$win,o._mouseup,n),p(!0)}(),o.events.$on(o.$el,"submit","form",function(e){return e.preventDefault(),!1})},updateInput:function g(){var e=o.popups.get("forms.update"),t=c();if(t){var a=l(t),n=e.find('input[type="text"][name="text"]').val()||"";a.is("button")?n.length?a.text(n):a.text("\u200b"):-1!=["button","submit","reset"].indexOf(t.type)?a.attr("value",n):a.attr("placeholder",n),o.popups.hide("forms.update"),d(t)}},getInput:c,applyStyle:function h(e,t,a){void 0===t&&(t=o.opts.formStyles),void 0===a&&(a=o.opts.formMultipleStyles);var n=c();if(!n)return!1;if(!a){var r=Object.keys(t);r.splice(r.indexOf(e),1),l(n).removeClass(r.join(" "))}l(n).toggleClass(e)},showUpdatePopup:function m(){var e=c();if(e){var t=l(e),a=o.popups.get("forms.update");a||(a=p()),o.popups.isVisible("forms.update")||o.popups.refresh("forms.update"),o.popups.setContainer("forms.update",o.$sc);var n=t.offset().left+t.outerWidth()/2,r=t.offset().top+t.outerHeight();o.popups.show("forms.update",n,r,t.outerHeight())}},showEditPopup:d,back:function v(){o.events.disableBlur(),o.selection.restore(),o.events.enableBlur();var e=c();e&&o.$wp&&("BUTTON"===e.tagName&&o.selection.restore(),d(e))}}},St.RegisterCommand("updateInput",{undo:!1,focus:!1,title:"Update",callback:function(){this.forms.updateInput()}}),St.DefineIcon("inputStyle",{NAME:"magic",SVG_KEY:"inlineStyle"}),St.RegisterCommand("inputStyle",{title:"Style",type:"dropdown",html:function(){var e='<ul class="fr-dropdown-list">',t=this.opts.formStyles;for(var a in t)t.hasOwnProperty(a)&&(e+='<li><a class="fr-command" tabIndex="-1" data-cmd="inputStyle" data-param1="'.concat(a,'">').concat(this.language.translate(t[a]),"</a></li>"));return e+="</ul>"},callback:function(e,t){var a=this.forms.getInput();a&&(this.forms.applyStyle(t),this.forms.showEditPopup(a))},refreshOnShow:function(e,t){var a=this.$,n=this.forms.getInput();if(n){var r=a(n);t.find(".fr-command").each(function(){var e=a(this).data("param1");a(this).toggleClass("fr-active",r.hasClass(e))})}}}),St.DefineIcon("inputEdit",{NAME:"edit",SVG_KEY:"edit"}),St.RegisterCommand("inputEdit",{title:"Edit Button",undo:!1,refreshAfterCallback:!1,callback:function(){this.forms.showUpdatePopup()}}),St.DefineIcon("inputBack",{NAME:"arrow-left",SVG_KEY:"back"}),St.RegisterCommand("inputBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.forms.back()}}),St.RegisterCommand("updateInput",{undo:!1,focus:!1,title:"Update",callback:function(){this.forms.updateInput()}}),St.PLUGINS.fullscreen=function(r){var t,a,n,i,o=r.$,s=function s(){return r.$box.hasClass("fr-fullscreen")};function l(){if(r.helpers.isIOS()&&r.core.hasFocus())return r.$el.blur(),setTimeout(d,250),!1;t=r.helpers.scrollTop(),r.opts.iframe&&r.markdown&&r.markdown.isEnabled()&&(r.$box=r.$oel),r.$box.toggleClass("fr-fullscreen"),o("body").first().toggleClass("fr-fullscreen"),r.helpers.isMobile()&&(r.opts.toolbarBottom?r.$tb[0].removeAttribute("style"):(r.$tb.data("parent",r.$tb.parent()),r.$box.prepend(r.$tb),r.$tb.data("sticky-dummy")&&r.$tb.after(r.$tb.data("sticky-dummy")))),a=r.opts.height,n=r.opts.heightMax,i=r.opts.zIndex,r.opts.height=r.o_win.innerHeight-(r.opts.toolbarInline?0:r.$tb.outerHeight()+(r.$second_tb?r.$second_tb.outerHeight():0)),r.opts.zIndex=2147483641,r.opts.heightMax=null,r.size.refresh(),r.opts.toolbarInline&&r.toolbar.showInline();for(var e=r.$box.parent();!e.first().is("body");)e.addClass("fr-fullscreen-wrapper"),e=e.parent();r.opts.toolbarContainer&&r.$box.prepend(r.$tb),r.events.trigger("charCounter.update"),r.events.trigger("codeView.update"),r.$win.trigger("scroll")}function c(){if(r.helpers.isIOS()&&r.core.hasFocus())return r.$el.blur(),setTimeout(d,250),!1;r.$box.toggleClass("fr-fullscreen"),o("body").first().toggleClass("fr-fullscreen"),r.$tb.data("parent")&&r.$tb.data("parent").prepend(r.$tb),r.$tb.data("sticky-dummy")&&r.$tb.after(r.$tb.data("sticky-dummy")),r.opts.height=a,r.opts.heightMax=n,r.opts.zIndex=i,r.size.refresh(),r.o_win.scroll(0,t),r.opts.toolbarInline&&r.toolbar.showInline(),r.events.trigger("charCounter.update"),r.opts.toolbarSticky&&r.opts.toolbarStickyOffset&&(r.opts.toolbarBottom?r.$tb.css("bottom",r.opts.toolbarStickyOffset).data("bottom",r.opts.toolbarStickyOffset):r.$tb.css("top",r.opts.toolbarStickyOffset).data("top",r.opts.toolbarStickyOffset));for(var e=r.$box.parent();!e.first().is("body");)e.removeClass("fr-fullscreen-wrapper"),e=e.parent();r.opts.toolbarContainer&&o(r.opts.toolbarContainer).append(r.$tb),o(r.o_win).trigger("scroll"),r.events.trigger("codeView.update")}function d(){s()?c():l(),f(r.$tb.find('.fr-command[data-cmd="fullscreen"]'));var e=r.$tb.find('.fr-command[data-cmd="moreText"]'),t=r.$tb.find('.fr-command[data-cmd="moreParagraph"]'),a=r.$tb.find('.fr-command[data-cmd="moreRich"]'),n=r.$tb.find('.fr-command[data-cmd="moreMisc"]');e.length&&r.refresh.moreText(e),t.length&&r.refresh.moreParagraph(t),a.length&&r.refresh.moreRich(a),n.length&&r.refresh.moreMisc(n)}function f(e){var t=s();e.toggleClass("fr-active",t).attr("aria-pressed",t),e.find("> *").not(".fr-sr-only").replaceWith(t?r.icon.create("fullscreenCompress"):r.icon.create("fullscreen"))}return{_init:function e(){if(!r.$wp)return!1;r.events.$on(o(r.o_win),"resize",function(){s()&&(c(),l())}),r.events.on("toolbar.hide",function(){if(s()&&r.helpers.isMobile())return!1}),r.events.on("position.refresh",function(){if(r.helpers.isIOS())return!s()}),r.events.on("destroy",function(){s()&&c()},!0)},toggle:d,refresh:f,isActive:s}},St.RegisterCommand("fullscreen",{title:"Fullscreen",undo:!1,focus:!1,accessibilityFocus:!0,forcedRefresh:!0,toggle:!0,callback:function(){this.fullscreen.toggle()},refresh:function(e){this.fullscreen.refresh(e)},plugin:"fullscreen"}),St.DefineIcon("fullscreen",{NAME:"expand",SVG_KEY:"fullscreen"}),St.DefineIcon("fullscreenCompress",{NAME:"compress",SVG_KEY:"exitFullscreen"}),Object.assign(St.DEFAULTS,{helpSets:[{title:"Inline Editor",commands:[{val:"OSkeyE",desc:"Show the editor"}]},{title:"Common actions",commands:[{val:"OSkeyC",desc:"Copy"},{val:"OSkeyX",desc:"Cut"},{val:"OSkeyV",desc:"Paste"},{val:"OSkeyZ",desc:"Undo"},{val:"OSkeyShift+Z",desc:"Redo"},{val:"OSkeyK",desc:"Insert Link"},{val:"OSkeyP",desc:"Insert Image"}]},{title:"Basic Formatting",commands:[{val:"OSkeyA",desc:"Select All"},{val:"OSkeyB",desc:"Bold"},{val:"OSkeyI",desc:"Italic"},{val:"OSkeyU",desc:"Underline"},{val:"OSkeyS",desc:"Strikethrough"},{val:"OSkey]",desc:"Increase Indent"},{val:"OSkey[",desc:"Decrease Indent"}]},{title:"Quote",commands:[{val:"OSkey'",desc:"Increase quote level"},{val:"OSkeyShift+'",desc:"Decrease quote level"}]},{title:"Image / Video",commands:[{val:"OSkey+",desc:"Resize larger"},{val:"OSkey-",desc:"Resize smaller"}]},{title:"Table",commands:[{val:"Alt+Space",desc:"Select table cell"},{val:"Shift+Left/Right arrow",desc:"Extend selection one cell"},{val:"Shift+Up/Down arrow",desc:"Extend selection one row"}]},{title:"Navigation",commands:[{val:"OSkey/",desc:"Shortcuts"},{val:"Alt+F10",desc:"Focus popup / toolbar"},{val:"Esc",desc:"Return focus to previous position"}]}]}),St.PLUGINS.help=function(s){var n,r=s.$,i="help";return{_init:function e(){},show:function l(){if(!n){var e="<h4>".concat(s.language.translate("Shortcuts"),"</h4>"),t=function o(){for(var e='<div class="fr-help-modal">',t=0;t<s.opts.helpSets.length;t++){var a=s.opts.helpSets[t],n="<table>";n+="<thead><tr><th>".concat(s.language.translate(a.title),"</th></tr></thead>"),n+="<tbody>";for(var r=0;r<a.commands.length;r++){var i=a.commands[r];n+="<tr>",n+="<td>".concat(s.language.translate(i.desc),"</td>"),n+="<td>".concat(i.val.replace("OSkey",s.helpers.isMac()?"&#8984;":"Ctrl+"),"</td>"),n+="</tr>"}e+=n+="</tbody></table>"}return e+="</div>"}(),a=s.modals.create(i,e,t);n=a.$modal,s.events.$on(r(s.o_win),"resize",function(){s.modals.resize(i)})}s.modals.show(i),s.modals.resize(i)},hide:function t(){s.modals.hide(i)}}},St.DefineIcon("help",{NAME:"question",SVG_KEY:"help"}),St.RegisterShortcut(St.KEYCODE.SLASH,"help",null,"/"),St.RegisterCommand("help",{title:"Help",icon:"help",undo:!1,focus:!1,modal:!0,callback:function(){this.help.show()},plugin:"help",showOnMobile:!1}),Object.assign(St.POPUP_TEMPLATES,{"image.insert":"[_BUTTONS_][_UPLOAD_LAYER_][_BY_URL_LAYER_][_PROGRESS_BAR_]","image.edit":"[_BUTTONS_]","image.alt":"[_BUTTONS_][_ALT_LAYER_]","image.size":"[_BUTTONS_][_SIZE_LAYER_]"}),Object.assign(St.DEFAULTS,{imageInsertButtons:["imageBack","|","imageUpload","imageByURL"],imageEditButtons:["imageReplace","imageAlign","imageCaption","imageRemove","imageLink","linkOpen","linkEdit","linkRemove","-","imageDisplay","imageStyle","imageAlt","imageSize"],imageAltButtons:["imageBack","|"],imageSizeButtons:["imageBack","|"],imageUpload:!0,imageUploadURL:null,imageCORSProxy:"https://cors-anywhere.froala.com",imageUploadRemoteUrls:!0,imageUploadParam:"file",imageUploadParams:{},imageUploadToS3:!1,imageUploadToAzure:!1,imageUploadMethod:"POST",imageMaxSize:10485760,imageAllowedTypes:["jpeg","jpg","png","gif","webp"],imageResize:!0,imageResizeWithPercent:!1,imageRoundPercent:!1,imageDefaultWidth:300,imageDefaultAlign:"center",imageDefaultDisplay:"block",imageSplitHTML:!1,imageStyles:{"fr-rounded":"Rounded","fr-bordered":"Bordered","fr-shadow":"Shadow"},imageMove:!0,imageMultipleStyles:!0,imageTextNear:!0,imagePaste:!0,imagePasteProcess:!1,imageMinWidth:16,imageOutputSize:!1,imageDefaultMargin:5,imageAddNewLine:!1}),St.IMAGE_ALLOW_REGEX=/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i,St.PLUGINS.image=function(w){var y,c,d,f,s,a,A=w.$,C="https://i.froala.com/upload",t=!1,n=1,p=2,u=3,g=4,T=5,k=6,r={};function h(){var e=w.popups.get("image.insert").find(".fr-image-by-url-layer input");e.val(""),y&&e.val(y.attr("src")),e.trigger("change")}function o(e){return window.pageYOffset+e.get(0).getBoundingClientRect().top}function i(){var e=w.popups.get("image.edit");if(e||(e=O()),e){var t=y;w.popups.setContainer("image.edit",w.$wp||w.$sc),w.popups.refresh("image.edit");var a=t.offset().left+t.outerWidth()/2,n=t&&o(t),r=w.$wp&&o(w.$wp);r||(r=n);var i=0;w.opts.iframe?((i=w.$wp.scrollTop()+e.outerHeight())<t.get(0).getBoundingClientRect().top&&(i=t.get(0).getBoundingClientRect().top),i>t.get(0).getBoundingClientRect().top+t.height()&&(i=t.get(0).getBoundingClientRect().top+t.height())):i=r<n?n:w.$wp&&n+t.height()<r+w.$wp.height()?n+t.height():r+e.outerHeight(),y.hasClass("fr-uploading")?F():w.popups.show("image.edit",a,i,1,!0)}}function m(){M()}function l(e){0<e.parents(".fr-img-caption").length&&(e=e.parents(".fr-img-caption").first());var t=e.hasClass("fr-dib")?"block":e.hasClass("fr-dii")?"inline":null,a=e.hasClass("fr-fil")?"left":e.hasClass("fr-fir")?"right":ve(e);me(e,t,a),e.removeClass("fr-dib fr-dii fr-fir fr-fil")}function v(){for(var e,t="IMG"==w.el.tagName?[w.el]:w.el.querySelectorAll("img"),a=0;a<t.length;a++){var n=A(t[a]);!w.opts.htmlUntouched&&w.opts.useClasses?((w.opts.imageDefaultAlign||w.opts.imageDefaultDisplay)&&(0<(e=n).parents(".fr-img-caption").length&&(e=e.parents(".fr-img-caption").first()),e.hasClass("fr-dii")||e.hasClass("fr-dib")||(e.addClass("fr-fi".concat(ve(e)[0])),e.addClass("fr-di".concat(be(e)[0])),e.css("margin",""),e.css("float",""),e.css("display",""),e.css("z-index",""),e.css("position",""),e.css("overflow",""),e.css("vertical-align",""))),w.opts.imageTextNear||(0<n.parents(".fr-img-caption").length?n.parents(".fr-img-caption").first().removeClass("fr-dii").addClass("fr-dib"):n.removeClass("fr-dii").addClass("fr-dib"))):w.opts.htmlUntouched||w.opts.useClasses||(w.opts.imageDefaultAlign||w.opts.imageDefaultDisplay)&&l(n),w.opts.iframe&&n.on("load",w.size.syncIframe)}}function b(e){void 0===e&&(e=!0);var t,a=Array.prototype.slice.call(w.el.querySelectorAll("img")),n=[];for(t=0;t<a.length;t++)if(n.push(a[t].getAttribute("src")),A(a[t]).toggleClass("fr-draggable",w.opts.imageMove),""===a[t].getAttribute("class")&&a[t].removeAttribute("class"),""===a[t].getAttribute("style")&&a[t].removeAttribute("style"),a[t].parentNode&&a[t].parentNode.parentNode&&w.node.hasClass(a[t].parentNode.parentNode,"fr-img-caption")){var r=a[t].parentNode.parentNode;w.browser.mozilla||r.setAttribute("contenteditable",!1),r.setAttribute("draggable",!1),r.classList.add("fr-draggable");var i=a[t].nextSibling;i&&!w.browser.mozilla&&i.setAttribute("contenteditable",!0)}if(s)for(t=0;t<s.length;t++)n.indexOf(s[t].getAttribute("src"))<0&&w.events.trigger("image.removed",[A(s[t])]);if(s&&e){var o=[];for(t=0;t<s.length;t++)o.push(s[t].getAttribute("src"));for(t=0;t<a.length;t++)o.indexOf(a[t].getAttribute("src"))<0&&w.events.trigger("image.loaded",[A(a[t])])}s=a}function S(){if(c||function o(){var e;w.shared.$image_resizer?(c=w.shared.$image_resizer,f=w.shared.$img_overlay,w.events.on("destroy",function(){A("body").first().append(c.removeClass("fr-active"))},!0)):(w.shared.$image_resizer=A(document.createElement("div")).attr("class","fr-image-resizer"),c=w.shared.$image_resizer,w.events.$on(c,"mousedown",function(e){e.stopPropagation()},!0),w.opts.imageResize&&(c.append(E("nw")+E("ne")+E("sw")+E("se")),w.shared.$img_overlay=A(document.createElement("div")).attr("class","fr-image-overlay"),f=w.shared.$img_overlay,e=c.get(0).ownerDocument,A(e).find("body").first().append(f)));w.events.on("shared.destroy",function(){c.html("").removeData().remove(),c=null,w.opts.imageResize&&(f.remove(),f=null)},!0),w.helpers.isMobile()||w.events.$on(A(w.o_win),"resize",function(){y&&!y.hasClass("fr-uploading")?pe(!0):y&&(S(),Ee(),F(!1))});if(w.opts.imageResize){e=c.get(0).ownerDocument,w.events.$on(c,w._mousedown,".fr-handler",R),w.events.$on(A(e),w._mousemove,L),w.events.$on(A(e.defaultView||e.parentWindow),w._mouseup,x),w.events.$on(f,"mouseleave",x);var n=1,r=null,i=0;w.events.on("keydown",function(e){if(y){var t=-1!=navigator.userAgent.indexOf("Mac OS X")?e.metaKey:e.ctrlKey,a=e.which;(a!==r||200<e.timeStamp-i)&&(n=1),(a==St.KEYCODE.EQUALS||w.browser.mozilla&&a==St.KEYCODE.FF_EQUALS)&&t&&!e.altKey?n=te.call(this,e,1,1,n):(a==St.KEYCODE.HYPHEN||w.browser.mozilla&&a==St.KEYCODE.FF_HYPHEN)&&t&&!e.altKey?n=te.call(this,e,2,-1,n):w.keys.ctrlKey(e)||a!=St.KEYCODE.ENTER||(y.before("<br>"),P(y)),r=a,i=e.timeStamp}},!0),w.events.on("keyup",function(){n=1})}}(),!y)return!1;var e=w.$wp||w.$sc;e.append(c),c.data("instance",w);var t=e.scrollTop()-("static"!=e.css("position")?e.offset().top:0),a=e.scrollLeft()-("static"!=e.css("position")?e.offset().left:0);a-=w.helpers.getPX(e.css("border-left-width")),t-=w.helpers.getPX(e.css("border-top-width")),w.$el.is("img")&&w.$sc.is("body")&&(a=t=0);var n=ye();Ae()&&(n=n.find(".fr-img-wrap"));var r=0,i=0;w.opts.iframe&&(r=w.helpers.getPX(w.$wp.find(".fr-iframe").css("padding-top")),i=w.helpers.getPX(w.$wp.find(".fr-iframe").css("padding-left"))),c.css("top",(w.opts.iframe?n.offset().top+r:n.offset().top+t)-1).css("left",(w.opts.iframe?n.offset().left+i:n.offset().left+a)-1).css("width",n.get(0).getBoundingClientRect().width).css("height",n.get(0).getBoundingClientRect().height).addClass("fr-active")}function E(e){return'<div class="fr-handler fr-h'.concat(e,'"></div>')}function _(e){Ae()&&y.parents(".fr-img-caption").css("width",e),y.css("width",e)}function R(e){if(!w.core.sameInstance(c))return!0;if(e.preventDefault(),e.stopPropagation(),w.$el.find("img.fr-error").left)return!1;w.undo.canDo()||w.undo.saveStep();var t=e.pageX||e.originalEvent.touches[0].pageX;if("mousedown"==e.type){var a=w.$oel.get(0),n=a.ownerDocument,r=n.defaultView||n.parentWindow,i=!1;try{i=r.location!=r.parent.location&&!(r.$&&r.$.FE)}catch(l){}i&&r.frameElement&&(t+=w.helpers.getPX(A(a).offset().left)+r.frameElement.clientLeft)}(d=A(this)).data("start-x",t),d.data("start-width",y.width()),d.data("start-height",y.height());var o=y.width();if(w.opts.imageResizeWithPercent){var s=y.parentsUntil(w.$el,w.html.blockTagsQuery()).get(0)||w.el;o=(o/A(s).outerWidth()*100).toFixed(2)+"%"}_(o),f.show(),w.popups.hideAll(),he()}function L(e){if(!w.core.sameInstance(c))return!0;var t;if(d&&y){if(e.preventDefault(),w.$el.find("img.fr-error").left)return!1;var a=e.pageX||(e.originalEvent.touches?e.originalEvent.touches[0].pageX:null);if(!a)return!1;var n=a-d.data("start-x"),r=d.data("start-width");if((d.hasClass("fr-hnw")||d.hasClass("fr-hsw"))&&(n=0-n),w.opts.imageResizeWithPercent){var i=y.parentsUntil(w.$el,w.html.blockTagsQuery()).get(0)||w.el;r=((r+n)/A(i).outerWidth()*100).toFixed(2),w.opts.imageRoundPercent&&(r=Math.round(r)),_("".concat(r,"%")),(t=Ae()?(w.helpers.getPX(y.parents(".fr-img-caption").css("width"))/A(i).outerWidth()*100).toFixed(2):(w.helpers.getPX(y.css("width"))/A(i).outerWidth()*100).toFixed(2))===r||w.opts.imageRoundPercent||_("".concat(t,"%")),y.css("height","").removeAttr("height")}else r+n>=w.opts.imageMinWidth&&(_(r+n),t=Ae()?w.helpers.getPX(y.parents(".fr-img-caption").css("width")):w.helpers.getPX(y.css("width"))),t!==r+n&&_(t),((y.attr("style")||"").match(/(^height:)|(; *height:)/)||y.attr("height"))&&(y.css("height",d.data("start-height")*y.width()/d.data("start-width")),y.removeAttr("height"));S(),w.events.trigger("image.resize",[we()])}}function x(e){if(!w.core.sameInstance(c))return!0;if(d&&y){if(e&&e.stopPropagation(),w.$el.find("img.fr-error").left)return!1;d=null,f.hide(),S(),i(),w.undo.saveStep(),w.events.trigger("image.resizeEnd",[we()])}else c.removeClass("fr-active")}function I(e,t,a){w.edit.on(),y&&y.addClass("fr-error"),r[e]?D(w.language.translate(r[e])):D(w.language.translate("Something went wrong. Please try again.")),!y&&a&&ae(a),w.events.trigger("image.error",[{code:e,message:r[e]},t,a])}function O(e){if(e)return w.$wp&&w.events.$on(w.$wp,"scroll.image-edit",function(){y&&w.popups.isVisible("image.edit")&&(w.events.disableBlur(),i())}),!0;var t="";if(0<w.opts.imageEditButtons.length){var a={buttons:t+='<div class="fr-buttons">\n        '.concat(w.button.buildList(w.opts.imageEditButtons),"\n        </div>")};return w.popups.create("image.edit",a)}return!1}function F(e){var t=w.popups.get("image.insert");if(t||(t=j()),t.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"),t.find(".fr-image-progress-bar-layer").addClass("fr-active"),t.find(".fr-buttons").hide(),y){var a=ye();w.popups.setContainer("image.insert",w.$sc);var n=a.offset().left,r=a.offset().top+a.height();w.popups.show("image.insert",n,r,a.outerHeight())}void 0===e&&N(w.language.translate("Uploading"),0)}function M(e){var t=w.popups.get("image.insert");if(t&&(t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"),t.find(".fr-image-progress-bar-layer").removeClass("fr-active"),t.find(".fr-buttons").show(),e||w.$el.find("img.fr-error").length)){if(w.events.focus(),w.$el.find("img.fr-error").length&&(w.$el.find("img.fr-error").remove(),w.undo.saveStep(),w.undo.run(),w.undo.dropRedo()),!w.$wp&&y){var a=y;pe(!0),w.selection.setAfter(a.get(0)),w.selection.restore()}w.popups.hide("image.insert")}}function N(e,t){var a=w.popups.get("image.insert");if(a){var n=a.find(".fr-image-progress-bar-layer");n.find("h3").text(e+(t?" ".concat(t,"%"):"")),n.removeClass("fr-error"),t?(n.find("div").removeClass("fr-indeterminate"),n.find("div > span").css("width","".concat(t,"%"))):n.find("div").addClass("fr-indeterminate")}}function D(e){F();var t=w.popups.get("image.insert").find(".fr-image-progress-bar-layer");t.addClass("fr-error");var a=t.find("h3");a.text(e),w.events.disableBlur(),a.focus()}function P(e){fe.call(e.get(0))}function B(){var e=A(this);w.popups.hide("image.insert"),e.removeClass("fr-uploading"),e.next().is("br")&&e.next().remove(),P(e),w.events.trigger("image.loaded",[e])}function U(o,e,s,l,c){l&&"string"==typeof l&&(l=w.$(l)),w.edit.off(),N(w.language.translate("Loading image")),e&&(o=w.helpers.sanitizeURL(o));var t=new Image;t.onload=function(){var e,t;if(l){w.undo.canDo()||l.hasClass("fr-uploading")||w.undo.saveStep();var a=l.data("fr-old-src");l.data("fr-image-pasted")&&(a=null),w.$wp?((e=l.clone().removeData("fr-old-src").removeClass("fr-uploading").removeAttr("data-fr-image-pasted")).off("load"),a&&l.attr("src",a),!w.opts.trackChangesEnabled||l[0].parentNode&&"SPAN"===l[0].parentNode.tagName&&l[0].parentNode.hasAttribute("data-tracking")||w.track_changes.replaceSpecialItem(l),l.replaceWith(e)):e=l;for(var n=e.get(0).attributes,r=0;r<n.length;r++){var i=n[r];0===i.nodeName.indexOf("data-")?e.removeAttr(i.nodeName):s&&s.hasOwnProperty(i.nodeName)&&e.removeAttr(i.nodeName)}if(void 0!==s)for(t in s)s.hasOwnProperty(t)&&"link"!=t&&e.attr("".concat(t),s[t]);e.on("load",B),e.attr("src",o),w.edit.on(),b(!1),l[0].src!=o&&w.selection.restore(),w.undo.saveStep(),w.events.disableBlur(),w.$el.blur(),w.events.trigger(a?"image.replaced":"image.inserted",[e,c])}else(e=W(o,s,B))&&(b(!1),w.undo.saveStep(),w.events.disableBlur(),w.$el.blur(),w.events.trigger("image.inserted",[e,c]))},t.onerror=function(){I(n)},F(w.language.translate("Loading image")),t.src=o}function H(e,t,a){N(w.language.translate("Loading image"));var n=this.status,r=this.response,i=this.responseXML,o=this.responseText;try{if(w.opts.imageUploadToS3||w.opts.imageUploadToAzure)if(201==n){var s;if(w.opts.imageUploadToAzure){if(!1===w.events.trigger("image.uploadedToAzure",[this.responseURL,a,r],!0))return w.edit.on(),!1;s=t}else s=function c(e){try{var t=A(e).find("Location").text(),a=A(e).find("Key").text();return!1===w.events.trigger("image.uploadedToS3",[t,a,e],!0)?(w.edit.on(),!1):t}catch(n){return I(g,e),!1}}(i);s&&U(s,!1,[],e,r||i)}else I(g,r||i,e);else if(200<=n&&n<300){var l=function d(e){try{if(!1===w.events.trigger("image.uploaded",[e],!0))return w.edit.on(),!1;var t=JSON.parse(e);return t.link?t:(I(p,e),!1)}catch(a){return I(g,e),!1}}(o);l&&U(l.link,!1,l,e,r||o)}else I(u,r||o,e)}catch(f){I(g,r||o,e)}}function $(){I(g,this.response||this.responseText||this.responseXML)}function z(e){if(e.lengthComputable){var t=e.loaded/e.total*100|0;N(w.language.translate("Uploading"),t)}}function W(e,t,a){var n,r=A(document.createElement("img")).attr("src",e);if(t&&void 0!==t)for(n in t)t.hasOwnProperty(n)&&"link"!=n&&(" data-".concat(n,'="').concat(t[n],'"'),r.attr("".concat(n),t[n]));var i=w.opts.imageDefaultWidth;i&&"auto"!=i&&(i=w.opts.imageResizeWithPercent?"100%":"".concat(i,"px")),r.attr("style",i?"width: ".concat(i,";"):""),me(r,w.opts.imageDefaultDisplay,w.opts.imageDefaultAlign),r.on("load",a),r.on("error",a),w.edit.on(),w.events.focus(!0),w.selection.restore(),w.undo.saveStep(),w.opts.imageSplitHTML?w.markers.split():w.markers.insert(),w.html.wrap();var o=w.$el.find(".fr-marker");if(o.length)(o.parent().is("hr")||o.parent().is("IMG"))&&o.parent().after(o),w.node.isLastSibling(o)&&o.parent().hasClass("fr-deletable")&&o.insertAfter(o.parent()),o.replaceWith(r);else{if(w.opts.trackChangesEnabled)return M(!0),!1;w.$el.append(r)}return w.selection.clear(),r}function K(){w.edit.on(),M(!0)}function G(e,t){if(void 0!==e&&0<e.length){if(!1===w.events.trigger("image.beforeUpload",[e,t]))return!1;var a,n=e[0];if(!(null!==w.opts.imageUploadURL&&w.opts.imageUploadURL!=C||w.opts.imageUploadToS3||w.opts.imageUploadToAzure))return function E(r,i){var o=new FileReader;o.onload=function(){var e=o.result;if(o.result.indexOf("svg+xml")<0){for(var t=atob(o.result.split(",")[1]),a=[],n=0;n<t.length;n++)a.push(t.charCodeAt(n));e=window.URL.createObjectURL(new Blob([new Uint8Array(a)],{type:r.type})),i&&i.data("fr-old-src",i.attr("src")),w.image.insert(e,!1,null,i)}else w.image.insert(e,null,null,w.image.get())},F(),o.readAsDataURL(r)}(n,t||y),!1;if(n.name||(n.name=(new Date).getTime()+"."+(n.type||"image/jpeg").replace(/image\//g,"")),n.size>w.opts.imageMaxSize)return I(T),!1;if(w.opts.imageAllowedTypes.indexOf(n.type.replace(/image\//g,""))<0)return I(k),!1;if(w.drag_support.formdata&&(a=w.drag_support.formdata?new FormData:null),a){var r;if(!1!==w.opts.imageUploadToS3)for(r in a.append("key",w.opts.imageUploadToS3.keyStart+(new Date).getTime()+"-"+(n.name||"untitled")),a.append("success_action_status","201"),a.append("X-Requested-With","xhr"),a.append("Content-Type",n.type),w.opts.imageUploadToS3.params)w.opts.imageUploadToS3.params.hasOwnProperty(r)&&a.append(r,w.opts.imageUploadToS3.params[r]);for(r in w.opts.imageUploadParams)w.opts.imageUploadParams.hasOwnProperty(r)&&a.append(r,w.opts.imageUploadParams[r]);a.append(w.opts.imageUploadParam,n,n.name);var i,o,s=w.opts.imageUploadURL,l=w.opts.imageUploadMethod;w.opts.imageUploadToS3&&(s=w.opts.imageUploadToS3.uploadURL?w.opts.imageUploadToS3.uploadURL:"https://".concat(w.opts.imageUploadToS3.region,".amazonaws.com/").concat(w.opts.imageUploadToS3.bucket)),w.opts.imageUploadToAzure&&(i=s=w.opts.imageUploadToAzure.uploadURL?"".concat(w.opts.imageUploadToAzure.uploadURL,"/").concat(n.name):encodeURI("https://".concat(w.opts.imageUploadToAzure.account,".blob.core.windows.net/").concat(w.opts.imageUploadToAzure.container,"/").concat(n.name)),w.opts.imageUploadToAzure.SASToken&&(s+=w.opts.imageUploadToAzure.SASToken),l="PUT");var c=w.core.getXHR(s,l);if(w.opts.imageUploadToAzure){var d=(new Date).toUTCString();if(!w.opts.imageUploadToAzure.SASToken&&w.opts.imageUploadToAzure.accessKey){var f=w.opts.imageUploadToAzure.account,p=w.opts.imageUploadToAzure.container;if(w.opts.imageUploadToAzure.uploadURL){var u=w.opts.imageUploadToAzure.uploadURL.split("/");p=u.pop(),f=u.pop().split(".")[0]}var g="x-ms-blob-type:BlockBlob\nx-ms-date:".concat(d,"\nx-ms-version:2019-07-07"),h=encodeURI("/"+f+"/"+p+"/"+n.name),m=l+"\n\n\n"+n.size+"\n\n"+n.type+"\n\n\n\n\n\n\n"+g+"\n"+h,v=w.cryptoJSPlugin.cryptoJS.HmacSHA256(m,w.cryptoJSPlugin.cryptoJS.enc.Base64.parse(w.opts.imageUploadToAzure.accessKey)).toString(w.cryptoJSPlugin.cryptoJS.enc.Base64),b="SharedKey "+f+":"+v;o=v,c.setRequestHeader("Authorization",b)}for(r in c.setRequestHeader("x-ms-version","2019-07-07"),c.setRequestHeader("x-ms-date",d),c.setRequestHeader("Content-Type",n.type),c.setRequestHeader("x-ms-blob-type","BlockBlob"),w.opts.imageUploadParams)w.opts.imageUploadParams.hasOwnProperty(r)&&c.setRequestHeader(r,w.opts.imageUploadParams[r]);for(r in w.opts.imageUploadToAzure.params)w.opts.imageUploadToAzure.params.hasOwnProperty(r)&&c.setRequestHeader(r,w.opts.imageUploadToAzure.params[r])}!function _(t,a,n,r,i,o){function s(){var e=A(this);e.off("load"),e.addClass("fr-uploading"),e.next().is("br")&&e.next().remove(),w.placeholder.refresh(),P(e),S(),F(),w.edit.off(),t.onload=function(){H.call(t,e,i,o)},t.onerror=$,t.upload.onprogress=z,t.onabort=K,A(e.off("abortUpload")).on("abortUpload",function(){4!=t.readyState&&(t.abort(),r?(r.attr("src",r.data("fr-old-src")),r.removeClass("fr-uploading")):e.remove(),pe(!0))}),t.send(w.opts.imageUploadToAzure?n:a)}var l=new FileReader;l.onload=function(){var e=l.result;if(l.result.indexOf("svg+xml")<0){for(var t=atob(l.result.split(",")[1]),a=[],n=0;n<t.length;n++)a.push(t.charCodeAt(n));e=window.URL.createObjectURL(new Blob([new Uint8Array(a)],{type:"image/jpeg"}))}r?(r.on("load",s),r.on("error",function(){s(),A(this).off("error")}),w.edit.on(),w.undo.saveStep(),r.data("fr-old-src",r.attr("src")),r.attr("src",e)):W(e,null,s)},l.readAsDataURL(n)}(c,a,n,t||y,i,o)}}}function V(e){if(e.is("img")&&0<e.parents(".fr-img-caption").length)return e.parents(".fr-img-caption")}function Y(e){var t=e.originalEvent.dataTransfer;if(t&&t.files&&t.files.length){var a=t.files[0];if(a&&a.type&&-1!==a.type.indexOf("image")&&0<=w.opts.imageAllowedTypes.indexOf(a.type.replace(/image\//g,""))){if(!w.opts.imageUpload)return e.preventDefault(),e.stopPropagation(),!1;w.markers.remove(),w.markers.insertAtPoint(e.originalEvent),w.$el.find(".fr-marker").replaceWith(St.MARKERS),0===w.$el.find(".fr-marker").length&&w.selection.setAtEnd(w.el),w.popups.hideAll();var n=w.popups.get("image.insert");n||(n=j()),w.popups.setContainer("image.insert",w.$sc);var r=e.originalEvent.pageX,i=e.originalEvent.pageY;if(w.opts.iframe){var o=w.helpers.getPX(w.$wp.find(".fr-iframe").css("padding-top")),s=w.helpers.getPX(w.$wp.find(".fr-iframe").css("padding-left"));i+=w.$iframe.offset().top+o,r+=w.$iframe.offset().left+s}return w.popups.show("image.insert",r,i),F(),0<=w.opts.imageAllowedTypes.indexOf(a.type.replace(/image\//g,""))?(pe(!0),G(t.files)):I(k),e.preventDefault(),e.stopPropagation(),!1}}}function j(e){if(e)return w.popups.onRefresh("image.insert",h),w.popups.onHide("image.insert",m),!0;var t,a,n="";w.opts.imageUpload||-1===w.opts.imageInsertButtons.indexOf("imageUpload")||w.opts.imageInsertButtons.splice(w.opts.imageInsertButtons.indexOf("imageUpload"),1);var r=w.button.buildList(w.opts.imageInsertButtons);""!==r&&(n='<div class="fr-buttons fr-tabs">'.concat(r,"</div>"));var i=w.opts.imageInsertButtons.indexOf("imageUpload"),o=w.opts.imageInsertButtons.indexOf("imageByURL"),s="";0<=i&&(t=" fr-active",0<=o&&o<i&&(t=""),s='<div class="fr-image-upload-layer'.concat(t,' fr-layer" id="fr-image-upload-layer-').concat(w.id,'"><strong>').concat(w.language.translate("Drop image"),"</strong><br>(").concat(w.language.translate("or click"),')<div class="fr-form"><input type="file" accept="image/').concat(w.opts.imageAllowedTypes.join(", image/").toLowerCase(),'" tabIndex="-1" aria-labelledby="fr-image-upload-layer-').concat(w.id,'" role="button"></div></div>'));var l="";0<=o&&(t=" fr-active",0<=i&&i<o&&(t=""),l='<div class="fr-image-by-url-layer'.concat(t,' fr-layer" id="fr-image-by-url-layer-').concat(w.id,'"><div class="fr-input-line"><input id="fr-image-by-url-layer-text-').concat(w.id,'" type="text" placeholder="http://" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageInsertByURL" tabIndex="2" role="button">').concat(w.language.translate("Insert"),"</button></div></div>"));var c={buttons:n,upload_layer:s,by_url_layer:l,progress_bar:'<div class="fr-image-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="imageDismissError" tabIndex="2" role="button">OK</button></div></div>'};return 1<=w.opts.imageInsertButtons.length&&(a=w.popups.create("image.insert",c)),w.$wp&&w.events.$on(w.$wp,"scroll",function(){y&&w.popups.isVisible("image.insert")&&Ee()}),function d(n){w.events.$on(n,"dragover dragenter",".fr-image-upload-layer",function(e){return A(this).addClass("fr-drop"),(w.browser.msie||w.browser.edge)&&e.preventDefault(),!1},!0),w.events.$on(n,"dragleave dragend",".fr-image-upload-layer",function(e){return A(this).removeClass("fr-drop"),(w.browser.msie||w.browser.edge)&&e.preventDefault(),!1},!0),w.events.$on(n,"drop",".fr-image-upload-layer",function(e){e.preventDefault(),e.stopPropagation(),A(this).removeClass("fr-drop");var t=e.originalEvent.dataTransfer;if(t&&t.files){var a=n.data("instance")||w;a.events.disableBlur(),a.image.upload(t.files),a.events.enableBlur()}},!0),w.helpers.isIOS()&&w.events.$on(n,"touchstart",'.fr-image-upload-layer input[type="file"]',function(){A(this).trigger("click")},!0),w.events.$on(n,"change",'.fr-image-upload-layer input[type="file"]',function(){if(this.files){var e=n.data("instance")||w;e.events.disableBlur(),n.find("input:focus").blur(),e.events.enableBlur(),e.image.upload(this.files,y)}A(this).val("")},!0)}(a),a}function q(){y&&w.popups.get("image.alt").find("input").val(y.attr("alt")||"").trigger("change")}function X(){var e=w.popups.get("image.alt");e||(e=Z()),M(),w.popups.refresh("image.alt"),w.popups.setContainer("image.alt",w.$sc);var t=ye(),a=t.outerWidth()/2;Ae()&&(t=t.find(".fr-img-wrap"),a=y.outerWidth()/2);var n=t.offset().left+a,r=t.offset().top+t.outerHeight(),i=t.outerHeight();w.opts.iframe&&Ae()&&(i=y?y.outerHeight():0),w.popups.show("image.alt",n,r,i,!0)}function Z(e){if(e)return w.popups.onRefresh("image.alt",q),!0;var t={buttons:'<div class="fr-buttons fr-tabs">'.concat(w.button.buildList(w.opts.imageAltButtons),"</div>"),alt_layer:'<div class="fr-image-alt-layer fr-layer fr-active" id="fr-image-alt-layer-'.concat(w.id,'"><div class="fr-input-line"><input id="fr-image-alt-layer-text-').concat(w.id,'" type="text" placeholder="').concat(w.language.translate("Alternative Text"),'" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetAlt" tabIndex="2" role="button">').concat(w.language.translate("Update"),"</button></div></div>")},a=w.popups.create("image.alt",t);return w.$wp&&w.events.$on(w.$wp,"scroll.image-alt",function(){y&&w.popups.isVisible("image.alt")&&X()}),a}function Q(){var e=w.popups.get("image.size"),t=y.get(0).style.height?y.get(0).style.height:"auto",a=y.get(0).style.width?y.get(0).style.width:"auto";if(y)if(Ae()){var n=y.parent();n.get(0).style.width||(n=y.parent().parent()),e.find('input[name="width"]').val(a).trigger("change"),e.find('input[name="height"]').val(t).trigger("change")}else e.find('input[name="width"]').val(a).trigger("change"),e.find('input[name="height"]').val(t).trigger("change")}function J(){var e=w.popups.get("image.size");e||(e=ee()),M(),w.popups.refresh("image.size"),w.popups.setContainer("image.size",w.$sc);var t=ye(),a=t.outerWidth()/2;Ae()&&(t=t.find(".fr-img-wrap"),a=y.outerWidth()/2);var n=t.outerHeight();w.opts.iframe&&Ae()&&(n=y?y.outerHeight():0);var r=t.offset().left+a,i=t.offset().top+t.outerHeight();w.popups.show("image.size",r,i,n,!0)}function ee(e){if(e)return w.popups.onRefresh("image.size",Q),!0;var t={buttons:'<div class="fr-buttons fr-tabs">'.concat(w.button.buildList(w.opts.imageSizeButtons),"</div>"),size_layer:'<div class="fr-image-size-layer fr-layer fr-active" id="fr-image-size-layer-'.concat(w.id,'"><div class="fr-image-group"><div class="fr-input-line"><input id="fr-image-size-layer-width-\'').concat(w.id,'" type="text" name="width" placeholder="').concat(w.language.translate("Width"),'" tabIndex="1"></div><div class="fr-input-line"><input id="fr-image-size-layer-height').concat(w.id,'" type="text" name="height" placeholder="').concat(w.language.translate("Height"),'" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetSize" tabIndex="2" role="button">').concat(w.language.translate("Update"),"</button></div></div>")},a=w.popups.create("image.size",t);return w.$wp&&w.events.$on(w.$wp,"scroll.image-size",function(){y&&w.popups.isVisible("image.size")&&J()}),a}function te(e,t,a,n){return e.pageX=t,R.call(this,e),e.pageX=e.pageX+a*Math.floor(Math.pow(1.1,n)),L.call(this,e),x.call(this,e),++n}function ae(e){if(e=e||ye(),w.opts.trackChangesEnabled&&!w.helpers.isMobile()&&(!e[0].parentNode||"SPAN"!==e[0].parentNode.tagName||!e[0].parentNode.hasAttribute("data-tracking")))return w.track_changes.removeSpecialItem(e),w.popups.hideAll(),void pe(!0);e&&!1!==w.events.trigger("image.beforeRemove",[e])&&(w.popups.hideAll(),_e(),pe(!0),w.undo.canDo()||w.undo.saveStep(),e.get(0)==w.el?e.removeAttr("src"):(e.get(0).parentNode&&"A"==e.get(0).parentNode.tagName?(w.selection.setBefore(e.get(0).parentNode)||w.selection.setAfter(e.get(0).parentNode)||e.parent().after(St.MARKERS),A(e.get(0).parentNode).remove()):(w.selection.setBefore(e.get(0))||w.selection.setAfter(e.get(0))||e.after(St.MARKERS),e.remove()),w.html.fillEmptyBlocks(),w.selection.restore()),w.undo.saveStep())}function ne(e){var t=e.which,a=document.getElementsByClassName("fs-transforms-container"),n=!1;if(a&&a.length){var r,i=He(a);try{for(i.s();!(r=i.n()).done;){var o=r.value;o.childNodes&&o.childNodes.length&&(n=!0)}}catch(c){i.e(c)}finally{i.f()}}if(n&&(y=null),y&&(t==St.KEYCODE.BACKSPACE||t==St.KEYCODE.DELETE))return e.preventDefault(),e.stopPropagation(),ae(),!1;if(y&&t==St.KEYCODE.ESC){var s=y;return pe(!0),w.selection.setAfter(s.get(0)),w.selection.restore(),e.preventDefault(),!1}if(!y||t!=St.KEYCODE.ARROW_LEFT&&t!=St.KEYCODE.ARROW_RIGHT)return y&&t===St.KEYCODE.TAB?(e.preventDefault(),e.stopPropagation(),pe(!0),!1):y&&t!=St.KEYCODE.F10&&!w.keys.isBrowserAction(e)?(e.preventDefault(),e.stopPropagation(),!1):void 0;var l=y.get(0);return pe(!0),t==St.KEYCODE.ARROW_LEFT?w.selection.setBefore(l):w.selection.setAfter(l),w.selection.restore(),e.preventDefault(),!1}function re(e){if(e&&"IMG"==e.tagName){if(w.node.hasClass(e,"fr-uploading")||w.node.hasClass(e,"fr-error")?e.parentNode.removeChild(e):w.node.hasClass(e,"fr-draggable")&&e.classList.remove("fr-draggable"),e.parentNode&&e.parentNode.parentNode&&w.node.hasClass(e.parentNode.parentNode,"fr-img-caption")){var t=e.parentNode.parentNode;t.removeAttribute("contenteditable"),t.removeAttribute("draggable"),t.classList.remove("fr-draggable");var a=e.nextSibling;a&&a.removeAttribute("contenteditable")}}else if(e&&e.nodeType==Node.ELEMENT_NODE)for(var n=e.querySelectorAll("img.fr-uploading, img.fr-error, img.fr-draggable"),r=0;r<n.length;r++)re(n[r])}function ie(e){if(!1===w.events.trigger("image.beforePasteUpload",[e]))return A(e).removeAttr("data-fr-image-pasted"),!1;y=A(e),S(),i(),F(),y.on("load",function(){var t=[];S(),A(w.popups.get("image.insert").get(0)).find("div.fr-active.fr-error").length<1&&F(),A(this).data("events").filter(function(e){"load"===e[0]&&t.push(e)}),t.length<=1&&A(this).off("load")});for(var t=A(e).attr("src").split(","),a=atob(t[1]),n=[],r=0;r<a.length;r++)n.push(a.charCodeAt(r));G([w.browser.safari&&!w.opts.imageUploadURL?new Blob([new Uint8Array(n)],{type:t[0].replace(/data\:/g,"")}):new Blob([new Uint8Array(n)],{type:t[0].replace(/data\:/g,"").replace(/;base64/g,"")})],y)}function oe(){w.opts.imagePaste?w.$el.find("img[data-fr-image-pasted]").each(function(e,a){if(w.opts.imagePasteProcess){var t=w.opts.imageDefaultWidth;t&&"auto"!=t&&(t+=w.opts.imageResizeWithPercent?"%":"px"),A(a).css("width",t).removeClass("fr-dii fr-dib fr-fir fr-fil"),me(A(a),w.opts.imageDefaultDisplay,w.opts.imageDefaultAlign)}if(0===a.src.indexOf("data:"))ie(a);else if(0===a.src.indexOf("blob:")||0===a.src.indexOf("http")&&w.opts.imageUploadRemoteUrls&&w.opts.imageCORSProxy){var n=new Image;n.crossOrigin="Anonymous",n.onload=function(){var e=w.o_doc.createElement("CANVAS"),t=e.getContext("2d");e.height=this.naturalHeight,e.width=this.naturalWidth,t.drawImage(this,0,0),setTimeout(function(){ie(a)},0),a.src=e.toDataURL(St.IMAGE_TYPE)},w.browser.msie&&St.IMAGE_ALLOW_REGEX.test(a.src)&&(St.IMAGE_TYPE="image/"+a.src.split(St.IMAGE_ALLOW_REGEX)[1]),n.src=(0===a.src.indexOf("blob:")?"":"".concat(w.opts.imageCORSProxy,"/"))+a.src,0!==a.src.indexOf("blob:")&&w.undo.saveStep()}else 0!==a.src.indexOf("http")||0===a.src.indexOf("https://mail.google.com/mail")?(w.selection.save(),A(a).remove(),w.selection.restore()):A(a).removeAttr("data-fr-image-pasted")}):w.$el.find("img[data-fr-image-pasted]").remove()}function se(e){var t=e.target.result,a=w.opts.imageDefaultWidth;a&&"auto"!=a&&(a+=w.opts.imageResizeWithPercent?"%":"px"),w.undo.saveStep(),w.html.insert('<img data-fr-image-pasted="true" src="'.concat(t,'"').concat(a?' style="width: '.concat(a,';"'):"",">"));var n=w.$el.find('img[data-fr-image-pasted="true"]');n&&me(n,w.opts.imageDefaultDisplay,w.opts.imageDefaultAlign),w.events.trigger("paste.after")}function le(e,t){var a=new FileReader;a.onload=function n(e){var t=w.opts.imageDefaultWidth;t&&"auto"!=t&&(t+=w.opts.imageResizeWithPercent?"%":"px"),w.html.insert('<img data-fr-image-pasted="true" src="'.concat(e,'"').concat(t?' style="width: '.concat(t,';"'):"",">"));var a=w.$el.find('img[data-fr-image-pasted="true"]');a&&me(a,w.opts.imageDefaultDisplay,w.opts.imageDefaultAlign),w.events.trigger("paste.after")}(t),a.readAsDataURL(e,t)}function ce(e,t){var a=t||e&&e.clipboardData;if(a&&a.items){var n=(a||window.clipboardData).getData("text/html")||"";w.browser.mozilla&&(""===n||/<!--StartFragment-->([ ])<!--EndFragment-->/.test(n))&&(n=w.win.localStorage.getItem("fr-copied-html"));var r=(new DOMParser).parseFromString(n,"text/html").querySelector("img");if(r&&!w.opts.imageUploadURL){if(!r)return!1;var i=r.src,o=null;if(a.types&&-1!=[].indexOf.call(a.types,"text/rtf")||a.getData("text/rtf"))o=a.items[0].getAsFile();else for(var s=0;s<a.items.length;s++)if(o=a.items[s].getAsFile()){St.IMAGE_TYPE=o.type;break}if(o)return le(o,i),!1}else{var l=null;if(a.types&&-1!=[].indexOf.call(a.types,"text/rtf")||a.getData("text/rtf"))l=a.items[0].getAsFile();else for(var c=0;c<a.items.length&&!(l=a.items[c].getAsFile());c++);if(l)return function d(e){var t=new FileReader;t.onload=se,t.readAsDataURL(e)}(l),!1}}}function de(e){return e=e.replace(/<img /gi,'<img data-fr-image-pasted="true" ')}function fe(e){if("false"==A(this).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable"))return!0;if(e&&"touchend"==e.type&&a)return!0;if(e&&w.edit.isDisabled())return e.stopPropagation(),e.preventDefault(),!1;for(var t=0;t<St.INSTANCES.length;t++)St.INSTANCES[t]!=w&&St.INSTANCES[t].events.trigger("image.hideResizer");w.toolbar.disable(),e&&(e.stopPropagation(),e.preventDefault()),w.helpers.isMobile()&&(w.events.disableBlur(),w.$el.blur(),w.events.enableBlur()),w.opts.iframe&&w.size.syncIframe(),y=A(this),_e(),S(),i(),w.browser.msie?(w.popups.areVisible()&&w.events.disableBlur(),w.win.getSelection&&(w.win.getSelection().removeAllRanges(),w.win.getSelection().addRange(w.doc.createRange()))):w.selection.clear(),w.helpers.isIOS()&&(w.events.disableBlur(),w.$el.blur()),w.button.bulkRefresh(),w.events.trigger("video.hideResizer")}function pe(e){y&&(function t(){return ue}()||!0===e)&&(w.toolbar.enable(),c.removeClass("fr-active"),w.popups.hideAll(),y=null,he(),d=null,f&&f.hide())}r[n]="Image cannot be loaded from the passed link.",r[p]="No link in upload response.",r[u]="Error during file upload.",r[g]="Parsing response failed.",r[T]="File is too large.",r[k]="Image file type is invalid.",r[7]="Files can be uploaded only to same domain in IE 8 and IE 9.";var ue=!(r[8]="Image file is corrupted.");function ge(){ue=!0}function he(){ue=!1}function me(e,t,a){if(!w.opts.htmlUntouched&&w.opts.useClasses)e.removeClass("fr-fil fr-fir fr-dib fr-dii"),a&&e.addClass("fr-fi".concat(a[0])),t&&e.addClass("fr-di".concat(t[0]));else if("inline"==t)if(e.css({display:"inline-block",verticalAlign:"bottom",margin:w.opts.imageDefaultMargin}),"center"==a)e.css({"float":"none",marginBottom:"",marginTop:"",maxWidth:"calc(100% - ".concat(2*w.opts.imageDefaultMargin,"px)"),textAlign:"center"});else if("left"==a){var n="0px",r=e.parent("span.fr-img-caption").get(0);r||(r=e.parent().get(0)),r&&"li"===r.tagName.toLowerCase()?n="20px":r&&"p"===r.tagName.toLowerCase()&&(n="15px"),e.css({"float":"left",marginLeft:0,maxWidth:"calc(100% - ".concat(w.opts.imageDefaultMargin,"px)"),textAlign:"left",marginRight:n})}else e.css({"float":"right",marginRight:0,maxWidth:"calc(100% - ".concat(w.opts.imageDefaultMargin,"px)"),textAlign:"right"});else"block"==t&&(e.css({display:"block","float":"none",verticalAlign:"top",margin:"".concat(w.opts.imageDefaultMargin,"px auto"),textAlign:"center"}),"left"==a?e.css({marginLeft:0,textAlign:"left"}):"right"==a&&e.css({marginRight:0,textAlign:"right"}))}function ve(e){if(void 0===e&&(e=ye()),e){if(e.hasClass("fr-fil"))return"left";if(e.hasClass("fr-fir"))return"right";if(e.hasClass("fr-dib")||e.hasClass("fr-dii"))return"center";var t=e.css("float");if(e.css("float","none"),"block"==e.css("display")){if(e.css("float",""),e.css("float")!=t&&e.css("float",t),0===parseInt(e.css("margin-left"),10))return"left";if(0===parseInt(e.css("margin-right"),10))return"right"}else{if(e.css("float",""),e.css("float")!=t&&e.css("float",t),"left"==e.css("float"))return"left";if("right"==e.css("float"))return"right"}}return"center"}function be(e){void 0===e&&(e=ye());var t=e.css("float");return e.css("float","none"),"block"==e.css("display")?(e.css("float",""),e.css("float")!=t&&e.css("float",t),"block"):(e.css("float",""),e.css("float")!=t&&e.css("float",t),"inline")}function Ee(){var e=w.popups.get("image.insert");e||(e=j()),w.popups.isVisible("image.insert")||(M(),w.popups.refresh("image.insert"),w.popups.setContainer("image.insert",w.$sc));var t=ye(),a=t&&t.outerWidth()/2;Ae()&&(t=t.find(".fr-img-wrap"),a=y.outerWidth()/2);var n,r=t.offset().left+a,i=t.outerHeight(!0);w.opts.iframe&&Ae()&&(i=y?y.outerHeight():0),n=0<w.$el.find("img[data-fr-image-pasted]").length?w.$wp.offset().top-w.helpers.scrollTop()+w.$wp.height():t.offset().top+t.outerHeight(),w.popups.show("image.insert",r,n,i,!0)}function _e(){if(y){w.events.disableBlur(),w.selection.clear();var e=w.doc.createRange();e.selectNode(y.get(0)),w.browser.msie&&e.collapse(!0),w.selection.get().addRange(e),w.events.enableBlur()}}function we(){return y}function ye(){return Ae()?y.parents(".fr-img-caption").first():y}function Ae(){return!!y&&0<y.parents(".fr-img-caption").length}function Ce(e){for(var t=document.createDocumentFragment();e.firstChild;){var a=e.removeChild(e.firstChild);t.appendChild(a)}e.parentNode.replaceChild(t,e)}return{_init:function Te(){var i;(function e(){w.events.$on(w.$el,w._mousedown,"IMG"==w.el.tagName?null:'img:not([contenteditable="false"])',function(e){if("false"==A(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable"))return!0;w.helpers.isMobile()||w.selection.clear(),t=!0,w.popups.areVisible()&&w.events.disableBlur(),w.browser.msie&&(w.events.disableBlur(),w.$el.attr("contenteditable",!1)),w.draggable||"touchstart"==e.type||e.preventDefault(),e.stopPropagation()}),w.events.$on(w.$el,w._mousedown,".fr-img-caption .fr-inner",function(e){w.core.hasFocus()||w.events.focus(),e.stopPropagation()}),w.events.$on(w.$el,"paste",".fr-img-caption .fr-inner",function(e){!0===w.opts.toolbarInline&&(w.toolbar.hide(),e.stopPropagation())}),w.events.$on(w.$el,w._mousedown,'img:not([contenteditable="false"])',function(e){var t=this;w.browser.mozilla&&3==e.which&&(A(this).attr("contenteditable",!1),setTimeout(function(){A(t).removeAttr("contenteditable")},200))}),w.events.$on(w.$el,w._mouseup,"IMG"==w.el.tagName?null:'img:not([contenteditable="false"])',function(e){if("false"==A(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable"))return!0;t&&(t=!1,e.stopPropagation(),w.browser.msie&&(w.$el.attr("contenteditable",!0),w.events.enableBlur()))}),w.events.on("keyup",function(e){if(e.shiftKey&&""===w.selection.text().replace(/\n/g,"")&&w.keys.isArrow(e.which)){var t=w.selection.element(),a=w.selection.endElement();t&&"IMG"==t.tagName?P(A(t)):a&&"IMG"==a.tagName&&P(A(a))}},!0),w.events.on("drop",Y),w.events.on("element.beforeDrop",V),w.events.on("mousedown window.mousedown",ge),w.events.on("window.touchmove",he),w.events.on("mouseup window.mouseup",function(){if(y&&!w.helpers.isMobile())return pe(),!1;he()}),w.events.on("touchstart touchend",function(){if(y&&w.helpers.isMobile())return pe(),!1;he()}),w.events.on("commands.mousedown",function(e){0<e.parents(".fr-toolbar").length&&pe()}),w.events.on("image.resizeEnd",function(){w.opts.iframe&&w.size.syncIframe()}),w.events.on("blur image.hideResizer commands.undo commands.redo element.dropped",function(){pe(!(t=!1))}),w.events.on("modals.hide",function(){y&&(_e(),w.selection.clear())}),w.events.on("image.resizeEnd",function(){w.win.getSelection&&P(y)}),w.events.on("filestack-init",function(){j()}),w.events.on("filestack-init-edit",function(){for(var e=w.$(".fr-popup"),t=e.length-1;0<=t;t--)e[t].parentElement.removeChild(e[t]);O()}),w.opts.imageAddNewLine&&w.events.on("image.inserted",function(e){var t=e.get(0);for(t.nextSibling&&"BR"===t.nextSibling.tagName&&(t=t.nextSibling);t&&!w.node.isElement(t);)t=w.node.isLastSibling(t)?t.parentNode:null;w.node.isElement(t)&&(w.opts.enter===St.ENTER_BR?e.after("<br>"):A(w.node.blockParent(e.get(0))).after("<".concat(w.html.defaultTag(),"><br></").concat(w.html.defaultTag(),">")))})})(),"IMG"==w.el.tagName&&w.$el.addClass("fr-view"),w.events.$on(w.$el,w.helpers.isMobile()&&!w.helpers.isWindowsPhone()?"touchend":"click","IMG"==w.el.tagName?null:'img:not([contenteditable="false"])',fe),w.helpers.isMobile()&&(w.events.$on(w.$el,"touchstart","IMG"==w.el.tagName?null:'img:not([contenteditable="false"])',function(){a=!1}),w.events.$on(w.$el,"touchmove",function(){a=!0})),w.$wp?(w.events.on("window.keydown keydown",ne,!0),w.events.on("keyup",function(e){if(y&&e.which==St.KEYCODE.ENTER)return!1},!0),w.events.$on(w.$el,"keydown",function(){var e=w.selection.element();(e.nodeType===Node.TEXT_NODE||"BR"==e.tagName&&w.node.isLastSibling(e))&&(e=e.parentNode),w.node.hasClass(e,"fr-inner")||(w.node.hasClass(e,"fr-img-caption")||(e=A(e).parents(".fr-img-caption").get(0)),w.node.hasClass(e,"fr-img-caption")&&(w.opts.trackChangesEnabled||A(e).after(St.INVISIBLE_SPACE+St.MARKERS),w.selection.restore()))})):w.events.$on(w.$win,"keydown",ne),w.events.on("toolbar.esc",function(){if(y){if(w.$wp)w.events.disableBlur(),w.events.focus();else{var e=y;pe(!0),w.selection.setAfter(e.get(0)),w.selection.restore()}return!1}},!0),w.events.on("toolbar.focusEditor",function(){if(y)return!1},!0),w.events.on("window.cut window.copy",function(e){if(y&&w.popups.isVisible("image.edit")&&!w.popups.get("image.edit").find(":focus").length){var t=ye();Ae()?(t.before(St.START_MARKER),t.after(St.END_MARKER),w.selection.restore(),w.paste.saveCopiedText(t.get(0).outerHTML,t.text())):(_e(),w.paste.saveCopiedText(y.get(0).outerHTML,y.attr("alt"))),"copy"==e.type?setTimeout(function(){P(y)}):(pe(!0),w.undo.saveStep(),setTimeout(function(){w.undo.saveStep()},0))}},!0),w.browser.msie&&w.events.on("keydown",function(e){if(!w.selection.isCollapsed()||!y)return!0;var t=e.which;t==St.KEYCODE.C&&w.keys.ctrlKey(e)?w.events.trigger("window.copy"):t==St.KEYCODE.X&&w.keys.ctrlKey(e)&&w.events.trigger("window.cut")}),w.events.$on(A(w.o_win),"keydown",function(e){if(w.opts.pluginsEnabled.includes("filestack")&&w.opts.iframe){var t=document.getElementsByClassName("fs-transforms-container"),a=!1;if(t&&t.length){var n,r=He(t);try{for(r.s();!(n=r.n()).done;){var i=n.value;i.childNodes&&i.childNodes.length&&(a=!0)}}catch(s){r.e(s)}finally{r.f()}}a&&(y=null)}var o=e.which;if(y&&o==St.KEYCODE.BACKSPACE)return e.preventDefault(),!1}),w.events.$on(w.$win,"keydown",function(e){var t=e.which;y&&y.hasClass("fr-uploading")&&t==St.KEYCODE.ESC&&y.trigger("abortUpload")}),w.events.on("destroy",function(){y&&y.hasClass("fr-uploading")&&y.trigger("abortUpload")}),w.events.on("paste.before",ce),w.events.on("paste.beforeCleanup",de),w.events.on("paste.after",oe),w.events.on("html.set",v),w.events.on("html.inserted",v),v(),w.events.on("destroy",function(){s=[]}),w.events.on("html.processGet",re),w.opts.imageOutputSize&&w.events.on("html.beforeGet",function(){i=w.el.querySelectorAll("img");for(var e=0;e<i.length;e++){var t=parseFloat(A(i[e]).css("padding-left"))+parseFloat(A(i[e]).css("padding-right")),a=A(i[e]).width()-t,n=i[e].style.width||a,r=i[e].style.height||A(i[e]).height();n&&i[e].setAttribute("width","".concat(n).replace(/px/,"")),r&&i[e].setAttribute("height","".concat(r).replace(/px/,""))}}),w.opts.iframe&&w.events.on("image.loaded",w.size.syncIframe),w.$wp&&(b(),w.events.on("contentChanged",b)),w.events.$on(A(w.o_win),"orientationchange.image",function(){setTimeout(function(){y&&P(y)},100)}),O(!0),j(!0),ee(!0),Z(!0),w.events.on("node.remove",function(e){if("IMG"==e.get(0).tagName)return ae(e),!1})},showInsertPopup:function ke(){var e=w.$tb.find('.fr-command[data-cmd="insertImage"]'),t=w.popups.get("image.insert");if(t||(t=j()),M(),!t.hasClass("fr-active"))if(w.popups.refresh("image.insert"),w.popups.setContainer("image.insert",w.$tb),e.isVisible()){var a=w.button.getPosition(e),n=a.left,r=a.top;w.popups.show("image.insert",n,r,e.outerHeight())}else w.position.forSelection(t),w.popups.show("image.insert")},showLayer:function Se(e){var t,a,n=w.popups.get("image.insert");if(y||w.opts.toolbarInline){if(y){var r=ye(),i=0;Ae()&&(r=r.find(".fr-img-wrap"),i=y.outerWidth()/2),a=r.offset().top+r.outerHeight(),t=r.offset().left+i}}else{var o=w.$tb.find('.fr-command[data-cmd="insertImage"]');t=o.offset().left,a=o.offset().top+(w.opts.toolbarBottom?10:o.outerHeight()-10)}!y&&w.opts.toolbarInline&&(a=n.offset().top-w.helpers.getPX(n.css("margin-top")),n.hasClass("fr-above")&&(a+=n.outerHeight())),n.find(".fr-layer").removeClass("fr-active"),n.find(".fr-".concat(e,"-layer")).addClass("fr-active"),w.popups.show("image.insert",t,a,y?y.outerHeight():0,Ae()),w.accessibility.focusPopup(n)},refreshUploadButton:function Re(e){var t=w.popups.get("image.insert");t&&t.find(".fr-image-upload-layer").hasClass("fr-active")&&e.addClass("fr-active").attr("aria-pressed",!0)},refreshByURLButton:function Le(e){var t=w.popups.get("image.insert");t&&t.find(".fr-image-by-url-layer").hasClass("fr-active")&&e.addClass("fr-active").attr("aria-pressed",!0)},upload:G,insertByURL:function xe(){var e=w.popups.get("image.insert").find(".fr-image-by-url-layer input");if(0<e.val().length){F(),N(w.language.translate("Loading image"));var t=e.val().trim();if(w.opts.imageUploadRemoteUrls&&w.opts.imageCORSProxy&&w.opts.imageUpload){var a=new XMLHttpRequest;a.onload=function(){200==this.status?G([new Blob([this.response],{type:this.response.type||"image/png"})],y):I(n)},a.onerror=function(){U(t,!0,[],y)},a.open("GET","".concat(w.opts.imageCORSProxy,"/").concat(t),!0),a.responseType="blob",a.send()}else U(t,!0,[],y);e.val(""),e.blur()}},align:function Ie(e){var t=ye();t.removeClass("fr-fir fr-fil"),!w.opts.htmlUntouched&&w.opts.useClasses?"left"==e?t.addClass("fr-fil"):"right"==e&&t.addClass("fr-fir"):me(t,be(),e),_e(),S(),i(),w.selection.clear()},refreshAlign:function Oe(e){y&&e.find("> *").first().replaceWith(w.icon.create("image-align-".concat(ve())))},refreshAlignOnShow:function Fe(e,t){y&&t.find('.fr-command[data-param1="'.concat(ve(),'"]')).addClass("fr-active").attr("aria-selected",!0)},display:function Me(e){var t=ye();t.removeClass("fr-dii fr-dib"),!w.opts.htmlUntouched&&w.opts.useClasses?"inline"==e?t.addClass("fr-dii"):"block"==e&&t.addClass("fr-dib"):me(t,e,ve()),_e(),S(),i(),w.selection.clear()},refreshDisplayOnShow:function Ne(e,t){y&&t.find('.fr-command[data-param1="'.concat(be(),'"]')).addClass("fr-active").attr("aria-selected",!0)},replace:Ee,back:function e(){y?(w.events.disableBlur(),A(".fr-popup input:focus").blur(),P(y)):(w.events.disableBlur(),w.selection.restore(),w.events.enableBlur(),w.popups.hide("image.insert"),w.toolbar.showInline())},get:we,getEl:ye,insert:U,showProgressBar:F,remove:ae,hideProgressBar:M,applyStyle:function De(e,t,a){if(void 0===t&&(t=w.opts.imageStyles),void 0===a&&(a=w.opts.imageMultipleStyles),!y)return!1;var n=ye();if(!a){var r=Object.keys(t);r.splice(r.indexOf(e),1),n.removeClass(r.join(" "))}"object"==Rt(t[e])?(n.removeAttr("style"),n.css(t[e].style)):(n.toggleClass(e),Ae()&&y.hasClass(e)&&y.removeClass(e)),P(y)},showAltPopup:X,showSizePopup:J,setAlt:function Pe(e){if(y){var t=w.popups.get("image.alt");y.attr("alt",e||t.find("input").val()||""),t.find("input:focus").blur(),P(y)}},setSize:function Be(e,t){if(y){var a=w.popups.get("image.size");e=e||a.find('input[name="width"]').val()||"",t=t||a.find('input[name="height"]').val()||"";var n=/^[\d]+((px)|%)*$/g;y.removeAttr("width").removeAttr("height"),e.match(n)?y.css("width",e):y.css("width",""),t.match(n)?y.css("height",t):y.css("height",""),Ae()&&(y.parents(".fr-img-caption").removeAttr("width").removeAttr("height"),e.match(n)?y.parents(".fr-img-caption").css("width",e):y.parents(".fr-img-caption").css("width",""),t.match(n)?y.parents(".fr-img-caption").css("height",t):y.parents(".fr-img-caption").css("height","")),a&&a.find("input:focus").blur(),P(y)}},toggleCaption:function Ue(){var e;if(y&&!Ae()){(e=y).parent().is("a")&&(e=y.parent());var t,a,n=y.parents("ul")&&0<y.parents("ul").length?y.parents("ul"):y.parents("ol")&&0<y.parents("ol").length?y.parents("ol"):[];if(0<n.length){var r=n.find("li").length,i=y.parents("li"),o=document.createElement("li");r-1===i.index()&&(n.append(o),o.innerHTML="&nbsp;")}e.attr("style")?a=-1<(t=e.attr("style").split(":")).indexOf("width")?t[t.indexOf("width")+1].replace(";",""):"":e.attr("width")&&(a=e.attr("width"));var s=w.opts.imageResizeWithPercent?(-1<a.indexOf("px")?null:a)||"100%":y.width()+"px";e.wrap('<div class="fr-img-space-wrap"><span '+(w.browser.mozilla?"":'contenteditable="false"')+'class="fr-img-caption '+y.attr("class")+'" style="'+(w.opts.useClasses?"":e.attr("style"))+'" draggable="false"></span></div>'),e.wrap('<span class="fr-img-wrap"></span>'),y.after('<span class="fr-inner"'.concat(w.browser.mozilla?"":' contenteditable="true"',">").concat(St.START_MARKER).concat(w.language.translate("Image Caption")).concat(St.END_MARKER,"</span>")),y.parents(".fr-img-caption").css("width",s);var l=y.parents(".fr-img-space-wrap").length;1==l?Ce(document.querySelector(".fr-img-space-wrap")):1<l&&(Ce(document.querySelector(".fr-img-space-wrap")),Ce(document.querySelector(".fr-img-space-wrap2"))),pe(!0),w.selection.restore()}else{if(e=ye(),y.insertBefore(e),null!==e[0].querySelector("a")){for(var c,d=e[0].querySelector("a"),f=document.createElement("a"),p=0,u=d.attributes,g=u.length;p<g;p++)c=u[p],f.setAttribute(c.nodeName,c.nodeValue);y.wrap(f)}y.attr("class",e.attr("class").replace("fr-img-caption","")).attr("style",e.attr("style")),e.remove();var h=y.parents(".fr-img-space-wrap").length;1==h?Ce(document.querySelector(".fr-img-space-wrap")):1<h&&(Ce(document.querySelector(".fr-img-space-wrap")),Ce(document.querySelector(".fr-img-space-wrap2"))),P(y)}},hasCaption:Ae,exitEdit:pe,edit:P}},St.DefineIcon("insertImage",{NAME:"image",SVG_KEY:"insertImage"}),St.RegisterShortcut(St.KEYCODE.P,"insertImage",null,"P"),St.RegisterCommand("insertImage",{title:"Insert Image",undo:!1,focus:!0,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible("image.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("image.insert")):this.image.showInsertPopup()},plugin:"image"}),St.DefineIcon("imageUpload",{NAME:"upload",SVG_KEY:"upload"}),St.RegisterCommand("imageUpload",{title:"Upload Image",undo:!1,focus:!1,toggle:!0,callback:function(){this.image.showLayer("image-upload")},refresh:function(e){this.image.refreshUploadButton(e)}}),St.DefineIcon("imageByURL",{NAME:"link",SVG_KEY:"insertLink"}),St.RegisterCommand("imageByURL",{title:"By URL",undo:!1,focus:!1,toggle:!0,callback:function(){this.image.showLayer("image-by-url")},refresh:function(e){this.image.refreshByURLButton(e)}}),St.RegisterCommand("imageInsertByURL",{title:"Insert Image",undo:!0,refreshAfterCallback:!1,callback:function(){this.image.insertByURL()},refresh:function(e){this.image.get()?e.text(this.language.translate("Replace")):e.text(this.language.translate("Insert"))}}),St.DefineIcon("imageDisplay",{NAME:"star",SVG_KEY:"imageDisplay"}),St.RegisterCommand("imageDisplay",{title:"Display",type:"dropdown",options:{inline:"Inline",block:"Break Text"},callback:function(e,t){this.image.display(t)},refresh:function(e){this.opts.imageTextNear||e.addClass("fr-hidden")},refreshOnShow:function(e,t){this.image.refreshDisplayOnShow(e,t)}}),St.DefineIcon("image-align",{NAME:"align-left",SVG_KEY:"alignLeft"}),St.DefineIcon("image-align-left",{NAME:"align-left",SVG_KEY:"alignLeft"}),St.DefineIcon("image-align-right",{NAME:"align-right",SVG_KEY:"alignRight"}),St.DefineIcon("image-align-center",{NAME:"align-justify",SVG_KEY:"alignCenter"}),St.DefineIcon("imageAlign",{NAME:"align-justify",SVG_KEY:"alignJustify"}),St.RegisterCommand("imageAlign",{type:"dropdown",title:"Align",options:{left:"Align Left",center:"None",right:"Align Right"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=St.COMMANDS.imageAlign.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="imageAlign" data-param1="'.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.icon.create("image-align-".concat(a)),'<span class="fr-sr-only">').concat(this.language.translate(t[a]),"</span></a></li>"));return e+="</ul>"},callback:function(e,t){this.image.align(t)},refresh:function(e){this.image.refreshAlign(e)},refreshOnShow:function(e,t){this.image.refreshAlignOnShow(e,t)}}),St.DefineIcon("imageReplace",{NAME:"exchange",FA5NAME:"exchange-alt",SVG_KEY:"replaceImage"}),St.RegisterCommand("imageReplace",{title:"Replace",undo:!1,focus:!1,popup:!0,refreshAfterCallback:!1,callback:function(){this.image.replace()}}),St.DefineIcon("imageRemove",{NAME:"trash",SVG_KEY:"remove"}),St.RegisterCommand("imageRemove",{title:"Remove",callback:function(){this.image.remove()}}),St.DefineIcon("imageBack",{NAME:"arrow-left",SVG_KEY:"back"}),St.RegisterCommand("imageBack",{title:"Back",undo:!1,focus:!1,back:!0,callback:function(){this.image.back()},refresh:function(e){this.$;this.image.get()||this.opts.toolbarInline?(e.removeClass("fr-hidden"),e.next(".fr-separator").removeClass("fr-hidden")):(e.addClass("fr-hidden"),e.next(".fr-separator").addClass("fr-hidden"))}}),St.RegisterCommand("imageDismissError",{title:"OK",undo:!1,callback:function(){this.image.hideProgressBar(!0)}}),St.DefineIcon("imageStyle",{NAME:"magic",SVG_KEY:"imageClass"}),St.RegisterCommand("imageStyle",{title:"Style",type:"dropdown",html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.imageStyles;for(var a in t)if(t.hasOwnProperty(a)){var n=t[a];"object"==Rt(n)&&(n=n.title),e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="imageStyle" data-param1="'.concat(a,'">').concat(this.language.translate(n),"</a></li>")}return e+="</ul>"},callback:function(e,t){this.image.applyStyle(t)},refreshOnShow:function(e,t){var a=this.$,n=this.image.getEl();n&&t.find(".fr-command").each(function(){var e=a(this).data("param1"),t=n.hasClass(e);a(this).toggleClass("fr-active",t).attr("aria-selected",t)})}}),St.DefineIcon("imageAlt",{NAME:"info",SVG_KEY:"imageAltText"}),St.RegisterCommand("imageAlt",{undo:!1,focus:!1,popup:!0,title:"Alternative Text",callback:function(){this.image.showAltPopup()}}),St.RegisterCommand("imageSetAlt",{undo:!0,focus:!1,title:"Update",refreshAfterCallback:!1,callback:function(){this.image.setAlt()}}),St.DefineIcon("imageSize",{NAME:"arrows-alt",SVG_KEY:"imageSize"}),St.RegisterCommand("imageSize",{undo:!1,focus:!1,popup:!0,title:"Change Size",callback:function(){this.image.showSizePopup()}}),St.RegisterCommand("imageSetSize",{undo:!0,focus:!1,title:"Update",refreshAfterCallback:!1,callback:function(){this.image.setSize()}}),St.DefineIcon("imageCaption",{NAME:"commenting",FA5NAME:"comment-alt",SVG_KEY:"imageCaption"}),St.RegisterCommand("imageCaption",{undo:!0,focus:!1,title:"Image Caption",refreshAfterCallback:!0,callback:function(){this.image.toggleCaption()},refresh:function(e){this.image.get()&&e.toggleClass("fr-active",this.image.hasCaption())}}),Object.assign(St.DEFAULTS,{imageManagerLoadURL:"https://i.froala.com/load-files",imageManagerLoadMethod:"get",imageManagerLoadParams:{},imageManagerPreloader:null,imageManagerDeleteURL:"",imageManagerDeleteMethod:"post",imageManagerDeleteParams:{},imageManagerPageSize:12,imageManagerScrollOffset:20,imageManagerToggleTags:!0}),St.PLUGINS.imageManager=function(s){var l,c,i,o,d,f,p,u,g,h,m,v=s.$,b="image_manager",e=10,E=11,_=12,w=13,y=14,A=15,a=21,n=22,r={};function C(){var e=v(window).outerWidth();return e<768?2:e<1200?3:4}function T(){d.empty();for(var e=0;e<m;e++)d.append('<div class="fr-list-column"></div>')}function k(){if(g<p.length&&i[0].scrollTop>=i[0].scrollHeight-s.opts.imageManagerScrollOffset-i.outerHeight()){u++;for(var e=s.opts.imageManagerPageSize*(u-1);e<Math.min(p.length,s.opts.imageManagerPageSize*u);e++)t(p[e])}}function t(r){var i=new Image,o=v(document.createElement("div")).attr("class","fr-image-container fr-empty fr-image-"+h++).attr("data-loading",s.language.translate("Loading")+"..").attr("data-deleting",s.language.translate("Deleting")+"..");x(!1),i.onload=function(){o.height(Math.floor(o.width()/i.width*i.height));var a=v(document.createElement("img"));if(r.thumb)a.attr("src",r.thumb);else{if(M(y,r),!r.url)return M(A,r),!1;a.attr("src",r.url)}if(r.url&&a.attr("data-url",r.url),r.tag)if(c.find(".fr-modal-more.fr-not-available").removeClass("fr-not-available"),c.find(".fr-modal-tags").show(),0<=r.tag.indexOf(",")){for(var e=r.tag.split(","),t=0;t<e.length;t++)e[t]=e[t].trim(),0===f.find('a[title="'.concat(e[t],'"]')).length&&f.append('<a role="button" title="'.concat(e[t],'">').concat(e[t],"</a>"));a.attr("data-tag",e.join())}else 0===f.find('a[title="'.concat(r.tag.trim(),'"]')).length&&f.append('<a role="button" title="'.concat(r.tag.trim(),'">').concat(r.tag.trim(),"</a>")),a.attr("data-tag",r.tag.trim());for(var n in r.name&&a.attr("alt",r.name),r)r.hasOwnProperty(n)&&"thumb"!==n&&"url"!==n&&"tag"!==n&&a.attr("data-".concat(n),r[n]);o.append(a).append(v(s.icon.create("imageManagerDelete")).addClass("fr-delete-img").attr("title",s.language.translate("Delete"))).append(v(s.icon.create("imageManagerInsert")).addClass("fr-insert-img").attr("title",s.language.translate("Insert"))),f.find(".fr-selected-tag").each(function(e,t){B(a,t.text)||o.hide()}),a.on("load",function(){o.removeClass("fr-empty"),o.height("auto"),g++,L(R(parseInt(a.parent().attr("class").match(/fr-image-(\d+)/)[1],10)+1)),x(!1),g%s.opts.imageManagerPageSize==0&&k()}),s.events.trigger("imageManager.imageLoaded",[a])},i.onerror=function(){g++,o.remove(),L(R(parseInt(o.attr("class").match(/fr-image-(\d+)/)[1],10)+1)),M(e,r),g%s.opts.imageManagerPageSize==0&&k()},i.src=r.thumb||r.url,S().append(o)}function S(){var n,r;return d.find(".fr-list-column").each(function(e,t){var a=v(t);0===e?(r=a.outerHeight(),n=a):a.outerHeight()<r&&(r=a.outerHeight(),n=a)}),n}function R(e){e===undefined&&(e=0);for(var t=[],a=h-1;e<=a;a--){var n=d.find(".fr-image-".concat(a));n.length&&(t.push(n),v(document.createElement("div")).attr("id","fr-image-hidden-container").append(n),d.find(".fr-image-".concat(a)).remove())}return t}function L(e){for(var t=e.length-1;0<=t;t--)S().append(e[t])}function x(e){if(e===undefined&&(e=!0),!l.isVisible())return!0;var t=C();if(t!==m){m=t;var a=R();T(),L(a)}s.modals.resize(b),e&&k()}function I(e){for(var t,a=e[0].attributes,n=a.length,r={};n--;)a[n]&&"src"!==(t=a[n].name)&&(r[t]=a[n].value);return r}function O(e){var t=v(e.currentTarget).siblings("img"),a=l.data("instance")||s,n=l.data("current-image");if(s.modals.hide(b),a.image.showProgressBar(),n)n.data("fr-old-src",n.attr("src")),n.trigger("click");else{a.events.focus(!0),a.selection.restore();var r=a.position.getBoundingRect(),i=r.left+r.width/2+v(s.doc).scrollLeft(),o=r.top+r.height+v(s.doc).scrollTop();a.popups.setContainer("image.insert",s.$sc),a.popups.show("image.insert",i,o)}a.image.insert(t.data("url"),!1,I(t),n)}function F(e){var i=v(e.currentTarget).siblings("img"),t=s.language.translate("Are you sure? Image will be deleted.");confirm(t)&&(s.opts.imageManagerDeleteURL?!1!==s.events.trigger("imageManager.beforeDeleteImage",[i])&&(i.parent().addClass("fr-image-deleting"),v(this).ajax({method:s.opts.imageManagerDeleteMethod,url:s.opts.imageManagerDeleteURL,data:Object.assign(Object.assign({src:i.attr("src")},I(i)),s.opts.imageManagerDeleteParams),crossDomain:s.opts.requestWithCORS,withCredentials:s.opts.requestWithCredentials,headers:s.opts.requestHeaders,done:function(e,t,a){s.events.trigger("imageManager.imageDeleted",[e]);var n=R(parseInt(i.parent().attr("class").match(/fr-image-(\d+)/)[1],10)+1);i.parent().remove(),L(n),function r(){l.find("#fr-modal-tags > a").each(function(){0===l.find('#fr-image-list [data-tag*="'.concat(v(this).text(),'"]')).length&&v(this).removeClass("fr-selected-tag").hide()}),D()}(),x(!0)},fail:function(e){M(a,e.response||e.responseText)}})):M(n))}function M(e,t){10<=e&&e<20?o.hide():20<=e&&e<30&&v(".fr-image-deleting").removeClass("fr-image-deleting"),s.events.trigger("imageManager.error",[{code:e,message:r[e]},t])}function N(){var e=c.find(".fr-modal-head-line").outerHeight(),t=f.outerHeight();c.toggleClass("fr-show-tags"),c.hasClass("fr-show-tags")?(c.css("height",e+t),i.css("marginTop",e+t),f.find("a").css("opacity",1)):(c.css("height",e),i.css("marginTop",e),f.find("a").css("opacity",0))}function D(){var e=f.find(".fr-selected-tag");0<e.length?(d.find("img").parents().show(),e.each(function(e,n){d.find("img").each(function(e,t){var a=v(t);B(a,n.text)||a.parent().hide()})})):d.find("img").parents().show(),L(R()),k()}function P(e){e.preventDefault();var t=v(e.currentTarget);t.toggleClass("fr-selected-tag"),s.opts.imageManagerToggleTags&&t.siblings("a").removeClass("fr-selected-tag"),D()}function B(e,t){for(var a=(e.attr("data-tag")||"").split(","),n=0;n<a.length;n++)if(a[n]===t)return!0;return!1}return r[e]="Image cannot be loaded from the passed link.",r[E]="Error during load images request.",r[_]="Missing imageManagerLoadURL option.",r[w]="Parsing load response failed.",r[y]="Missing image thumb.",r[A]="Missing image URL.",r[a]="Error during delete image request.",r[n]="Missing imageManagerDeleteURL option.",{require:["image"],_init:function U(){if(!s.$wp&&"IMG"!==s.el.tagName)return!1},show:function H(){if(!l){var e,t='<button class="fr-command fr-btn fr-modal-more fr-not-available" id="fr-modal-more-'.concat(s.sid,'"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24""><path d="').concat(St.SVG.tags,'"/></svg></button><h4 data-text="true">').concat(s.language.translate("Manage Images"),'</h4></div>\n      <div class="fr-modal-tags" id="fr-modal-tags">');e=s.opts.imageManagerPreloader?'<img class="fr-preloader" id="fr-preloader" alt="'.concat(s.language.translate("Loading"),'.." src="').concat(s.opts.imageManagerPreloader,'" style="display: none;">'):'<span class="fr-preloader" id="fr-preloader" style="display: none;">'.concat(s.language.translate("Loading"),"</span>"),e+='<div class="fr-image-list" id="fr-image-list"></div>';var a=s.modals.create(b,t,e);l=a.$modal,c=a.$head,i=a.$body}l.data("current-image",s.image.get()),s.modals.show(b),o||function n(){o=l.find("#fr-preloader"),d=l.find("#fr-image-list"),f=l.find("#fr-modal-tags"),m=C(),T(),c.css("height",c.find(".fr-modal-head-line").outerHeight()),s.events.$on(v(s.o_win),"resize",function(){x(!!p)}),s.events.bindClick(d,".fr-insert-img",O),s.events.bindClick(d,".fr-delete-img",F),s.helpers.isMobile()&&(s.events.bindClick(d,"div.fr-image-container",function(e){l.find(".fr-mobile-selected").removeClass("fr-mobile-selected"),v(e.currentTarget).addClass("fr-mobile-selected")}),l.on(s._mousedown,function(){l.find(".fr-mobile-selected").removeClass("fr-mobile-selected")})),l.on(s._mousedown+" "+s._mouseup,function(e){e.stopPropagation()}),l.on(s._mousedown,"*",function(){s.events.disableBlur()}),i.on("scroll",k),s.events.bindClick(l,"button#fr-modal-more-".concat(s.sid),N),s.events.bindClick(f,"a",P)}(),function r(){o.show(),d.find(".fr-list-column").empty(),s.opts.imageManagerLoadURL?v(this).ajax({url:s.opts.imageManagerLoadURL,method:s.opts.imageManagerLoadMethod,data:s.opts.imageManagerLoadParams,crossDomain:s.opts.requestWithCORS,withCredentials:s.opts.requestWithCredentials,headers:s.opts.requestHeaders,done:function(e,t,a){s.events.trigger("imageManager.imagesLoaded",[e]),function n(e,t){try{d.find(".fr-list-column").empty(),h=g=u=0,p=JSON.parse(e),k()}catch(a){M(w,t)}}(e,a.response),o.hide()},fail:function(e){M(E,e.response||e.responseText)}}):M(_)}()},hide:function $(){s.modals.hide(b)}}},!St.PLUGINS.image)throw new Error("Image manager plugin requires image plugin.");function n(e){var t={omitExtraWLInCodeBlocks:{defaultValue:!1,describe:"Omit the default extra whiteline added to code blocks",type:"boolean"},noHeaderId:{defaultValue:!1,describe:"Turn on/off generated header id",type:"boolean"},prefixHeaderId:{defaultValue:!1,describe:"Add a prefix to the generated header ids. Passing a string will prefix that string to the header id. Setting to true will add a generic 'section-' prefix",type:"string"},rawPrefixHeaderId:{defaultValue:!1,describe:'Setting this option to true will prevent showdown from modifying the prefix. This might result in malformed IDs (if, for instance, the " char is used in the prefix)',type:"boolean"},ghCompatibleHeaderId:{defaultValue:!1,describe:"Generate header ids compatible with github style (spaces are replaced with dashes, a bunch of non alphanumeric chars are removed)",type:"boolean"},rawHeaderId:{defaultValue:!1,describe:"Remove only spaces, ' and \" from generated header ids (including prefixes), replacing them with dashes (-). WARNING: This might result in malformed ids",type:"boolean"},headerLevelStart:{defaultValue:!1,describe:"The header blocks level start",type:"integer"},parseImgDimensions:{defaultValue:!1,describe:"Turn on/off image dimension parsing",type:"boolean"},simplifiedAutoLink:{defaultValue:!1,describe:"Turn on/off GFM autolink style",type:"boolean"},excludeTrailingPunctuationFromURLs:{defaultValue:!1,describe:"Excludes trailing punctuation from links generated with autoLinking",type:"boolean"},literalMidWordUnderscores:{defaultValue:!1,describe:"Parse midword underscores as literal underscores",type:"boolean"},literalMidWordAsterisks:{defaultValue:!1,describe:"Parse midword asterisks as literal asterisks",type:"boolean"},strikethrough:{defaultValue:!1,describe:"Turn on/off strikethrough support",type:"boolean"},tables:{defaultValue:!1,describe:"Turn on/off tables support",type:"boolean"},tablesHeaderId:{defaultValue:!1,describe:"Add an id to table headers",type:"boolean"},ghCodeBlocks:{defaultValue:!0,describe:"Turn on/off GFM fenced code blocks support",type:"boolean"},tasklists:{defaultValue:!1,describe:"Turn on/off GFM tasklist support",type:"boolean"},smoothLivePreview:{defaultValue:!1,describe:"Prevents weird effects in live previews due to incomplete input",type:"boolean"},smartIndentationFix:{defaultValue:!1,description:"Tries to smartly fix indentation in es6 strings",type:"boolean"},disableForced4SpacesIndentedSublists:{defaultValue:!1,description:"Disables the requirement of indenting nested sublists by 4 spaces",type:"boolean"},simpleLineBreaks:{defaultValue:!1,description:"Parses simple line breaks as <br> (GFM Style)",type:"boolean"},requireSpaceBeforeHeadingText:{defaultValue:!1,description:"Makes adding a space between `#` and the header text mandatory (GFM Style)",type:"boolean"},ghMentions:{defaultValue:!1,description:"Enables github @mentions",type:"boolean"},ghMentionsLink:{defaultValue:"https://github.com/{u}",description:"Changes the link generated by @mentions. Only applies if ghMentions option is enabled.",type:"string"},encodeEmails:{defaultValue:!0,description:"Encode e-mail addresses through the use of Character Entities, transforming ASCII e-mail addresses into its equivalent decimal entities",type:"boolean"},openLinksInNewWindow:{defaultValue:!1,description:"Open all links in new windows",type:"boolean"},backslashEscapesHTMLTags:{defaultValue:!1,description:"Support for HTML Tag escaping. ex: <div>foo</div>",type:"boolean"},emoji:{defaultValue:!1,description:"Enable emoji support. Ex: `this is a :smile: emoji`",type:"boolean"},underline:{defaultValue:!1,description:"Enable support for underline. Syntax is double or triple underscores: `__underline word__`. With this option enabled, underscores no longer parses into `<em>` and `<strong>`",type:"boolean"},completeHTMLDocument:{defaultValue:!1,description:"Outputs a complete html document, including `<html>`, `<head>` and `<body>` tags",type:"boolean"},metadata:{defaultValue:!1,description:"Enable support for document metadata (defined at the top of the document between `\xab\xab\xab` and `\xbb\xbb\xbb` or between `---` and `---`).",type:"boolean"},splitAdjacentBlockquotes:{defaultValue:!1,description:"Split adjacent blockquote blocks",type:"boolean"}};if(!1===e)return JSON.parse(JSON.stringify(t));var a={};for(var n in t)t.hasOwnProperty(n)&&(a[n]=t[n].defaultValue);return a}St.DEFAULTS.imageInsertButtons.push("imageManager"),St.RegisterCommand("imageManager",{title:"Browse",undo:!1,focus:!1,modal:!0,callback:function(){this.imageManager.show()},plugin:"imageManager"}),St.DefineIcon("imageManager",{NAME:"folder",SVG_KEY:"imageManager"}),St.DefineIcon("imageManagerInsert",{NAME:"plus",SVG_KEY:"add"}),St.DefineIcon("imageManagerDelete",{NAME:"trash",SVG_KEY:"remove"}),Object.assign(St.DEFAULTS,{inlineClasses:{"fr-class-code":"Code","fr-class-highlighted":"Highlighted","fr-class-transparency":"Transparent"}}),St.PLUGINS.inlineClass=function(a){var n=a.$;return{apply:function t(e){a.format.toggle("span",{"class":e})},refreshOnShow:function r(e,t){t.find(".fr-command").each(function(){var e=n(this).data("param1"),t=a.format.is("span",{"class":e});n(this).toggleClass("fr-active",t).attr("aria-selected",t)})}}},St.RegisterCommand("inlineClass",{type:"dropdown",title:"Inline Class",html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.inlineClasses;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="inlineClass" data-param1="'.concat(a,'" title="').concat(t[a],'">').concat(t[a],"</a></li>"));return e+="</ul>"},callback:function(e,t){this.inlineClass.apply(t)},refreshOnShow:function(e,t){this.inlineClass.refreshOnShow(e,t)},plugin:"inlineClass"}),St.DefineIcon("inlineClass",{NAME:"tag",SVG_KEY:"inlineClass"}),Object.assign(St.DEFAULTS,{inlineStyles:{"Big Red":"font-size: 20px; color: red;","Small Blue":"font-size: 14px; color: blue;"}}),St.PLUGINS.inlineStyle=function(r){return{apply:function i(e){for(var t=e.split(";"),a=0;a<t.length;a++){var n=t[a].split(":");t[a].length&&2==n.length&&r.format.applyStyle(n[0].trim(),n[1].trim())}}}},St.RegisterCommand("inlineStyle",{type:"dropdown",html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.inlineStyles;for(var a in t)if(t.hasOwnProperty(a)){var n=t[a]+(-1===t[a].indexOf("display:block;")?" display:block;":"");e+='<li role="presentation"><span style="'.concat(n,'" role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="inlineStyle" data-param1="').concat(t[a],'" title="').concat(this.language.translate(a),'">').concat(this.language.translate(a),"</a></span></li>")}return e+="</ul>"},title:"Inline Style",callback:function(e,t){this.inlineStyle.apply(t)},plugin:"inlineStyle"}),St.DefineIcon("inlineStyle",{NAME:"paint-brush",SVG_KEY:"inlineStyle"}),Object.assign(St.DEFAULTS,{lineBreakerTags:["table","hr","form","dl","span.fr-video",".fr-embedly","img"],lineBreakerOffset:15,lineBreakerHorizontalOffset:10}),St.PLUGINS.lineBreaker=function(g){var h,t,r,m=g.$;function l(e,t){var a,n,r,i,o,s,l,c;if(null==e)o=(i=t.parent()).offset().top,a=(l=t.offset().top)-Math.min((l-o)/2,g.opts.lineBreakerOffset),r=i.outerWidth(),n=i.offset().left;else if(null==t)(s=(i=e.parent()).offset().top+i.outerHeight())<(c=e.offset().top+e.outerHeight())&&(s=(i=m(i).parent()).offset().top+i.outerHeight()),a=c+Math.min(Math.abs(s-c)/2,g.opts.lineBreakerOffset),r=i.outerWidth(),n=i.offset().left;else{i=e.parent();var d=e.offset().top+e.height(),f=t.offset().top;if(f<d)return!1;a=(d+f)/2,r=i.outerWidth(),n=i.offset().left}if(g.opts.iframe){var p=g.helpers.getPX(g.$wp.find(".fr-iframe").css("padding-top")),u=g.helpers.getPX(g.$wp.find(".fr-iframe").css("padding-left"));n+=g.$iframe.offset().left-g.helpers.scrollLeft()+u,a+=g.$iframe.offset().top-g.helpers.scrollTop()+p}g.$box.append(h),h.css("top",a-g.win.pageYOffset),h.css("left",n-g.win.pageXOffset),h.css("width",r),h.data("tag1",e),h.data("tag2",t),h.addClass("fr-visible").data("instance",g)}function c(e){if(e){var t=m(e);if(0===g.$el.find(t).length)return null;if(e.nodeType!=Node.TEXT_NODE&&t.is(g.opts.lineBreakerTags.join(",")))return t;if(0<t.parents(g.opts.lineBreakerTags.join(",")).length)return e=t.parents(g.opts.lineBreakerTags.join(",")).get(0),0!==g.$el.find(m(e)).length&&m(e).is(g.opts.lineBreakerTags.join(","))?m(e):null}return null}function i(e,t){var a=g.doc.elementFromPoint(e,t);return a&&!m(a).closest(".fr-line-breaker").length&&!g.node.isElement(a)&&a!=g.$wp.get(0)&&function n(e){if("undefined"!=typeof e.inFroalaWrapper)return e.inFroalaWrapper;for(var t=e;e.parentNode&&e.parentNode!==g.$wp.get(0);)e=e.parentNode;return t.inFroalaWrapper=e.parentNode==g.$wp.get(0),t.inFroalaWrapper}(a)?a:null}function o(e,t,a){for(var n=a,r=null;n<=g.opts.lineBreakerOffset&&!r;)(r=i(e,t-n))||(r=i(e,t+n)),n+=a;return r}function d(e,t,a){for(var n=null,r=100;!n&&e>g.$box.offset().left&&e<g.$box.offset().left+g.$box.outerWidth()&&0<r;)(n=i(e,t))||(n=o(e,t,5)),"left"==a?e-=g.opts.lineBreakerHorizontalOffset:e+=g.opts.lineBreakerHorizontalOffset,r-=g.opts.lineBreakerHorizontalOffset;return n}function a(e){var t=r=null,a=null,n=g.doc.elementFromPoint(e.pageX-g.win.pageXOffset,e.pageY-g.win.pageYOffset);(t=n&&("HTML"==n.tagName||"BODY"==n.tagName||g.node.isElement(n)||0<=(n.getAttribute("class")||"").indexOf("fr-line-breaker"))?((a=o(e.pageX-g.win.pageXOffset,e.pageY-g.win.pageYOffset,1))||(a=d(e.pageX-g.win.pageXOffset-g.opts.lineBreakerHorizontalOffset,e.pageY-g.win.pageYOffset,"left")),a||(a=d(e.pageX-g.win.pageXOffset+g.opts.lineBreakerHorizontalOffset,e.pageY-g.win.pageYOffset,"right")),c(a)):c(n))?function s(e,t){var a,n,r=e.offset().top,i=e.offset().top+e.outerHeight();if(Math.abs(i-t)<=g.opts.lineBreakerOffset||Math.abs(t-r)<=g.opts.lineBreakerOffset)if(Math.abs(i-t)<Math.abs(t-r)){var o=null;for((n=e.get(0)).nextSibling&&(o=n.nextSibling.offsetParent?n.nextSibling:null);o&&o.nodeType==Node.TEXT_NODE&&0===o.textContent.length;)o=o.nextSibling;if(!o)return l(e,null),!0;if(a=c(o))return l(e,a),!0}else{if(!(n=e.get(0)).previousSibling)return l(null,e),!0;if(a=c(n.previousSibling))return l(a,e),!0}h.removeClass("fr-visible").removeData("instance")}(t,e.pageY):g.core.sameInstance(h)&&h.removeClass("fr-visible").removeData("instance")}function n(e){return!(h.hasClass("fr-visible")&&!g.core.sameInstance(h))&&(g.popups.areVisible()||g.el.querySelector(".fr-selected-cell")?(h.removeClass("fr-visible"),!0):void(!1!==t||g.edit.isDisabled()||(r&&clearTimeout(r),r=setTimeout(a,30,e))))}function s(){r&&clearTimeout(r),h&&h.hasClass("fr-visible")&&h.removeClass("fr-visible").removeData("instance")}var f=function f(){t=!0,s()},p=function p(){t=!1};function u(e){e.preventDefault();var t=h.data("instance")||g;h.removeClass("fr-visible").removeData("instance");var a=h.data("tag1"),n=h.data("tag2"),r=g.html.defaultTag();if(null==a)if(g.opts.keepTextFormatOnTable&&n.children().get(0)!=undefined&&"TBODY"==n.children().get(0).tagName){var i=n.find("span"),o=null!=i[i.length-1]?i[i.length-1].getAttribute("style"):null,s=null!=o?"<"+i[i.length-1].nodeName.toLowerCase()+' style="'+o+'">':"<"+n.parent().get(0).nodeName.toLowerCase()+">",l=null!=o?"</"+i[i.length-1].nodeName.toLowerCase()+">":"</"+n.parent().get(0).nodeName.toLowerCase()+">";r?n.before("<".concat(r,">").concat(s).concat(St.MARKERS,"<br>").concat(l,"</").concat(r,">")):n.before("".concat(s).concat(St.MARKERS,"<br>").concat(l))}else r&&"TD"!=n.parent().get(0).tagName&&0===n.parents(r).length?n.before("<".concat(r,">").concat(St.MARKERS,"<br></").concat(r,">")):n.before("".concat(St.MARKERS,"<br>"));else if(g.opts.keepTextFormatOnTable&&a.children().get(0)!=undefined&&"TBODY"==a.children().get(0).tagName){var c=a.find("span"),d=null!=c[c.length-1]?c[c.length-1].getAttribute("style"):null,f=null!=d?"<"+c[c.length-1].nodeName.toLowerCase()+' style="'+d+'">':"<"+a.parent().get(0).nodeName.toLowerCase()+">",p=null!=d?"</"+c[c.length-1].nodeName.toLowerCase()+">":"</"+a.parent().get(0).nodeName.toLowerCase()+">";r?a.after("<".concat(r,">").concat(f).concat(St.MARKERS,"<br>").concat(p,"</").concat(r,">")):a.after("".concat(f).concat(St.MARKERS,"<br>").concat(p))}else r&&"TD"!=a.parent().get(0).tagName&&0===a.parents(r).length?a.after("<".concat(r,">").concat(St.MARKERS,"<br></").concat(r,">")):a.after("".concat(St.MARKERS,"<br>"));t.selection.restore(),g.toolbar.enable()}return{_init:function v(){if(!g.$wp)return!1;!function e(){g.shared.$line_breaker||(g.shared.$line_breaker=m(document.createElement("div")).attr("class","fr-line-breaker").html('<a class="fr-floating-btn" role="button" tabIndex="-1" title="'.concat(g.language.translate("Break"),'"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect x="17" y="7" width="2" height="8"/><rect x="10" y="13" width="7" height="2"/><path d="M10.000,10.000 L10.000,18.013 L5.000,14.031 L10.000,10.000 Z"/></svg></a>'))),h=g.shared.$line_breaker,g.events.on("shared.destroy",function(){h.html("").removeData().remove(),h=null},!0),g.events.on("destroy",function(){h.removeData("instance").removeClass("fr-visible"),m("body").first().append(h),clearTimeout(r)},!0),g.events.$on(h,"mousemove",function(e){e.stopPropagation()},!0),g.events.bindClick(h,"a",u)}(),t=!1,g.events.$on(g.$win,"mousemove",n),g.events.$on(m(g.win),"scroll",s),g.events.on("popups.show.table.edit",s),g.events.on("commands.after",s),g.events.$on(m(g.win),"mousedown",f),g.events.$on(m(g.win),"mouseup",p)}}},Object.assign(St.DEFAULTS,{lineHeights:{Default:"",Single:"1",1.15:"1.15",1.5:"1.5",Double:"2"}}),St.PLUGINS.lineHeight=function(n){var s=n.$;return{_init:function e(){},apply:function r(e){n.selection.save(),n.html.wrap(!0,!0,!0,!0),n.selection.restore();var t=n.selection.blocks();t.length&&s(t[0]).parent().is("td")&&n.format.applyStyle("line-height",e.toString()),n.selection.save();for(var a=0;a<t.length;a++)s(t[a]).css("line-height",e),n.opts.enter!==St.ENTER_BR||t.length&&s(t[0]).parent().is("td")||(s(t[a]).hasClass("fr-temp-div")&&s(t[a]).removeClass("fr-temp-div"),""===s(t[a]).attr("class")&&s(t[a]).removeAttr("class")),""===s(t[a]).attr("style")&&s(t[a]).removeAttr("style");n.html.unwrap(),n.selection.restore()},refreshOnShow:function i(e,t){var a=n.selection.blocks();if(a.length){var o=s(a[0]);t.find(".fr-command").each(function(){var e=s(this).data("param1"),t=o.attr("style"),a=0<=(t||"").indexOf("line-height: "+e+";");if(t){var n=t.substring(t.indexOf("line-height")),r=n.substr(0,n.indexOf(";")),i=r&&r.split(":")[1];i&&i.length||"Default"!==o.text()||(a=!0)}t&&-1!==t.indexOf("line-height")||""!==e||(a=!0),s(this).toggleClass("fr-active",a).attr("aria-selected",a)})}}}},St.RegisterCommand("lineHeight",{type:"dropdown",html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.lineHeights;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command '.concat(a,'" tabIndex="-1" role="option" data-cmd="lineHeight" data-param1="').concat(t[a],'" title="').concat(this.language.translate(a),'">').concat(this.language.translate(a),"</a></li>"));return e+="</ul>"},title:"Line Height",callback:function(e,t){this.lineHeight.apply(t)},refreshOnShow:function(e,t){this.lineHeight.refreshOnShow(e,t)},plugin:"lineHeight"}),St.DefineIcon("lineHeight",{NAME:"arrows-v",FA5NAME:"arrows-alt-v",SVG_KEY:"lineHeight"}),Object.assign(St.POPUP_TEMPLATES,{"link.edit":"[_BUTTONS_]","link.insert":"[_BUTTONS_][_INPUT_LAYER_]"}),Object.assign(St.DEFAULTS,{linkEditButtons:["linkOpen","linkStyle","linkEdit","linkRemove"],linkInsertButtons:["linkBack","|","linkList"],linkAttributes:{},linkAutoPrefix:"http://",linkStyles:{"fr-green":"Green","fr-strong":"Thick"},linkMultipleStyles:!0,linkConvertEmailAddress:!0,linkAlwaysBlank:!1,linkAlwaysNoFollow:!1,linkNoOpener:!0,linkNoReferrer:!0,linkList:[{text:"Froala",href:"https://froala.com",target:"_blank"},{text:"Google",href:"https://google.com",target:"_blank"},{displayText:"Facebook",href:"https://facebook.com"}],linkText:!0}),St.PLUGINS.link=function(m){var v=m.$;function b(){var e=m.image?m.image.get():null;if(e||!m.$wp)return"A"==m.el.tagName?m.el:e&&e.get(0).parentNode&&"A"==e.get(0).parentNode.tagName?e.get(0).parentNode:void 0;var t=m.selection.ranges(0).commonAncestorContainer;try{t&&(t.contains&&t.contains(m.el)||!m.el.contains(t)||m.el==t)&&(t=null)}catch(o){t=null}if(t&&"A"===t.tagName)return t;var a,n,r=m.selection.element(),i=m.selection.endElement();"A"==r.tagName||m.node.isElement(r)||(r=m.opts.iframe&&null!==(a=m.markdown)&&void 0!==a&&a.isEnabled?null:v(r).parentsUntil(m.$el,"a").first().get(0));"A"==i.tagName||m.node.isElement(i)||(i=m.opts.iframe&&null!==(n=m.markdown)&&void 0!==n&&n.isEnabled?null:v(i).parentsUntil(m.$el,"a").first().get(0));try{i&&(i.contains&&i.contains(m.el)||!m.el.contains(i)||m.el==i)&&(i=null)}catch(o){i=null}try{r&&(r.contains&&r.contains(m.el)||!m.el.contains(r)||m.el==r)&&(r=null)}catch(o){r=null}return i&&i==r&&"A"==i.tagName?(m.browser.msie||m.helpers.isMobile())&&(m.selection.info(r).atEnd||m.selection.info(r).atStart)?null:r:null}function E(){var e,t,a,n,r=m.image?m.image.get():null,i=[];if(r)"A"==r.get(0).parentNode.tagName&&i.push(r.get(0).parentNode);else if(m.win.getSelection){var o=m.win.getSelection();if(o.getRangeAt&&o.rangeCount){n=m.doc.createRange();for(var s=0;s<o.rangeCount;++s)if((t=(e=o.getRangeAt(s)).commonAncestorContainer)&&1!=t.nodeType&&(t=t.parentNode),t&&"a"==t.nodeName.toLowerCase())i.push(t);else{a=t.getElementsByTagName("a");for(var l=0;l<a.length;++l)n.selectNodeContents(a[l]),n.compareBoundaryPoints(e.END_TO_START,e)<1&&-1<n.compareBoundaryPoints(e.START_TO_END,e)&&i.push(a[l])}}}else if(m.doc.selection&&"Control"!=m.doc.selection.type)if("a"==(t=(e=m.doc.selection.createRange()).parentElement()).nodeName.toLowerCase())i.push(t);else{a=t.getElementsByTagName("a"),n=m.doc.body.createTextRange();for(var c=0;c<a.length;++c)n.moveToElementText(a[c]),-1<n.compareEndPoints("StartToEnd",e)&&n.compareEndPoints("EndToStart",e)<1&&i.push(a[c])}return i}function _(r){if(m.core.hasFocus()||m.opts.iframe&&(!document.hasFocus||document.hasFocus())){if(i(),r&&"keyup"===r.type&&(r.altKey||r.which==St.KEYCODE.ALT))return!0;setTimeout(function(){if(!r||r&&(1==r.which||"mouseup"!=r.type)){var e=b(),t=m.image?m.image.get():null;if(e&&!t){if(m.image){var a=m.node.contents(e);if(1==a.length&&"IMG"==a[0].tagName){var n=m.selection.ranges(0);return 0===n.startOffset&&0===n.endOffset?v(e).before(St.INVISIBLE_SPACE+St.MARKERS):v(e).after(St.INVISIBLE_SPACE+St.MARKERS),m.selection.restore(),!1}}r&&r.stopPropagation(),o(e)}}},m.helpers.isIOS()?100:0)}}function o(e){var t=m.popups.get("link.edit");t||(t=function i(){var e="";1<=m.opts.linkEditButtons.length&&("A"==m.el.tagName&&0<=m.opts.linkEditButtons.indexOf("linkRemove")&&m.opts.linkEditButtons.splice(m.opts.linkEditButtons.indexOf("linkRemove"),1),e='<div class="fr-buttons">'.concat(m.button.buildList(m.opts.linkEditButtons),"</div>"));var t={buttons:e},a=m.popups.create("link.edit",t);m.$wp&&m.events.$on(m.$wp,"scroll.link-edit",function(){b()&&m.popups.isVisible("link.edit")&&o(b())});return a}());var a=v(e);m.popups.isVisible("link.edit")||m.popups.refresh("link.edit"),m.popups.setContainer("link.edit",m.$sc);var n=a.offset().left+a.outerWidth()/2,r=a.offset().top+a.outerHeight();m.popups.show("link.edit",n,r,a.outerHeight(),!0)}function i(){m.popups.hide("link.edit")}function l(){var e=m.popups.get("link.insert"),t=b();if(t){var a,n,r=v(t),i=e.find('input.fr-link-attr[type="text"]'),o=e.find('input.fr-link-attr[type="checkbox"]');for(a=0;a<i.length;a++){var s=(n=v(i[a])).attr("name")||"",l="href"===s?decodeURI(r.attr(s)):r.attr(s);n.val(l)}for(o.attr("checked",!1),a=0;a<o.length;a++)n=v(o[a]),r.attr(n.attr("name"))==n.data("checked")&&n.attr("checked",!0);e.find('input.fr-link-attr[type="text"][name="text"]').val(r.text())}else e.find('input.fr-link-attr[type="text"]').val(""),e.find('input.fr-link-attr[type="checkbox"]').attr("checked",!1),e.find('input.fr-link-attr[type="text"][name="text"]').val(m.selection.text());e.find("input.fr-link-attr").trigger("change"),(m.image?m.image.get():null)?e.find('.fr-link-attr[name="text"]').parent().hide():e.find('.fr-link-attr[name="text"]').parent().show()}function s(e){if(e)return m.popups.onRefresh("link.insert",l),!0;var t="";1<=m.opts.linkInsertButtons.length&&(t='<div class="fr-buttons fr-tabs">'.concat(m.button.buildList(m.opts.linkInsertButtons),"</div>"));var a="",n=0;for(var r in a='<div class="fr-link-insert-layer fr-layer fr-active" id="fr-link-insert-layer-'.concat(m.id,'">'),a+='<div class="fr-input-line"><input id="fr-link-insert-layer-url-'.concat(m.id,'" name="href" type="text" class="fr-link-attr" placeholder="').concat(m.language.translate("URL"),'" tabIndex="').concat(++n,'"></div>'),m.opts.linkText&&(a+='<div class="fr-input-line"><input id="fr-link-insert-layer-text-'.concat(m.id,'" name="text" type="text" class="fr-link-attr" placeholder="').concat(m.language.translate("Text"),'" tabIndex="').concat(++n,'"></div>')),m.opts.linkAttributes)if(m.opts.linkAttributes.hasOwnProperty(r)){var i=m.opts.linkAttributes[r];a+='<div class="fr-input-line"><input name="'.concat(r,'" type="text" class="fr-link-attr" placeholder="').concat(m.language.translate(i),'" tabIndex="').concat(++n,'"></div>')}m.opts.linkAlwaysBlank||(a+='<div class="fr-checkbox-line"><span class="fr-checkbox"><input name="target" class="fr-link-attr" data-checked="_blank" type="checkbox" id="fr-link-target-'.concat(m.id,'" tabIndex="').concat(++n,'"><span>').concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>','</span></span><label id="fr-label-target-').concat(m.id,'">').concat(m.language.translate("Open in new tab"),"</label></div>"));var o={buttons:t,input_layer:a+='<div class="fr-action-buttons"><button class="fr-command fr-submit" role="button" data-cmd="linkInsert" href="#" tabIndex="'.concat(++n,'" type="button">').concat(m.language.translate("Insert"),"</button></div></div>")},s=m.popups.create("link.insert",o);return m.$wp&&m.events.$on(m.$wp,"scroll.link-insert",function(){(m.image?m.image.get():null)&&m.popups.isVisible("link.insert")&&f(),m.popups.isVisible("link.insert")&&d()}),s}function c(e,t,a){if(m.opts.trackChangesEnabled){if(m.edit.on(),m.events.focus(!0),m.undo.saveStep(),m.markers.insert(),m.html.wrap(),!m.$el.find(".fr-marker").length)return void m.popups.hide("link.insert");m.markers.remove()}if(void 0===a&&(a={}),!1===m.events.trigger("link.beforeInsert",[e,t,a]))return!1;var n=m.image?m.image.get():null;n||"A"==m.el.tagName?"A"==m.el.tagName&&m.$el.focus():(m.selection.restore(),m.popups.hide("link.insert"));var r=e;m.opts.linkConvertEmailAddress&&m.helpers.isEmail(e)&&!/^mailto:.*/i.test(e)&&(e="mailto:".concat(e));if(""===m.opts.linkAutoPrefix||new RegExp("^("+St.LinkProtocols.join("|")+"):.","i").test(e)||/^data:image.*/i.test(e)||/^(https?:|ftps?:|file:|)\/\//i.test(e)||/^([A-Za-z]:(\\){1,2}|[A-Za-z]:((\\){1,2}[^\\]+)+)(\\)?$/i.test(e)||["/","{","[","#","(",".",'"',"\\"].indexOf((e||"")[0])<0&&(e=m.opts.linkAutoPrefix+e),e=m.helpers.sanitizeURL(e),e=encodeURI(e),m.opts.linkAlwaysBlank&&(a.target="_blank"),m.opts.linkAlwaysNoFollow&&(a.rel="nofollow"),m.helpers.isEmail(r)&&(a.target=null,a.rel=null),"_blank"==a.target?(m.opts.linkNoOpener&&(a.rel?a.rel+=" noopener":a.rel="noopener"),m.opts.linkNoReferrer&&(a.rel?a.rel+=" noreferrer":a.rel="noreferrer")):null==a.target&&(a.rel?a.rel=a.rel.replace(/noopener/,"").replace(/noreferrer/,""):a.rel=null),t=t||"",e===m.opts.linkAutoPrefix)return m.popups.get("link.insert").find('input[name="href"]').addClass("fr-error"),m.events.trigger("link.bad",[r]),!1;var i,o=b();if(o){if((i=v(o)).attr("href",e),0<t.length&&i.text()!=t&&!n){if(m.opts.trackChangesEnabled){var s=v(i.get(0).outerHTML);s.insertBefore(i.parent());var l=m.track_changes.wrapLinkInTracking(s,m.track_changes.getPendingChanges().length-1),c=m.track_changes.wrapInDelete(l);i.parent().append(c)}for(var d=i.get(0);1===d.childNodes.length&&d.childNodes[0].nodeType==Node.ELEMENT_NODE;)d=d.childNodes[0];v(d).text(t)}for(var f in n||i.prepend(St.START_MARKER).append(St.END_MARKER),a)a[f]?i.attr(f,a[f]):i.removeAttr(f);n||m.selection.restore()}else{n?(n.wrap('<a href="'.concat(e,'"></a>')),m.image.hasCaption()&&n.parent().append(n.parents(".fr-img-caption").find(".fr-inner"))):(m.format.remove("a"),m.selection.isCollapsed()?(t=0===t.length?r:t,m.html.insert('<a href="'.concat(e,'">').concat(St.START_MARKER).concat(t.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")).concat(St.END_MARKER,"</a>")),m.selection.restore()):0<t.length&&t!=m.selection.text().replace(/\n/g,"")?(m.selection.remove(),m.html.insert('<a href="'.concat(e,'">').concat(St.START_MARKER).concat(t.replace(/&/g,"&amp;")).concat(St.END_MARKER,"</a>")),m.selection.restore()):(!function h(){if(!m.selection.isCollapsed()){m.selection.save();for(var e=m.$el.find(".fr-marker").addClass("fr-unprocessed").toArray();e.length;){var t=v(e.pop());t.removeClass("fr-unprocessed");var a=m.node.deepestParent(t.get(0));if(a){for(var n=t.get(0),r="",i="";n=n.parentNode,m.node.isBlock(n)||(r+=m.node.closeTagString(n),i=m.node.openTagString(n)+i),n!=a;);var o=m.node.openTagString(t.get(0))+t.html()+m.node.closeTagString(t.get(0));t.replaceWith('<span id="fr-break"></span>');var s=a.outerHTML;s=(s=s.replace(/<span id="fr-break"><\/span>/g,r+o+i)).replace(i+r,""),a.outerHTML=s}e=m.$el.find(".fr-marker.fr-unprocessed").toArray()}m.html.cleanEmptyTags(),m.selection.restore()}}(),m.format.apply("a",{href:e})));for(var p=E(),u=0;u<p.length;u++)(i=v(p[u])).attr(a),i.removeAttr("_moz_dirty");1==p.length&&m.$wp&&!n&&(v(p[0]).prepend(St.START_MARKER).append(St.END_MARKER),m.selection.restore())}if(n){var g=m.popups.get("link.insert");g&&g.find("input:focus").blur(),m.image.edit(n)}else _()}function d(){i();var e=b();if(e){var t=m.popups.get("link.insert");t||(t=s()),m.popups.isVisible("link.insert")||(m.popups.refresh("link.insert"),m.selection.save(),m.helpers.isMobile()&&(m.events.disableBlur(),m.$el.blur(),m.events.enableBlur())),m.popups.setContainer("link.insert",m.$sc);var a=(m.image?m.image.get():null)||v(e),n=a.offset().left+a.outerWidth()/2,r=a.offset().top+a.outerHeight();m.popups.show("link.insert",n,r,a.outerHeight(),!0)}}function f(){var e=m.image?m.image.getEl():null;if(e){var t=m.popups.get("link.insert"),a=e.outerWidth()/2;m.image.hasCaption()&&(e=e.find(".fr-img-wrap"),v(e)&&v(e).find("img")&&(a=v(e).find("img").outerWidth()/2)),t||(t=s()),l(),m.popups.setContainer("link.insert",m.$sc);var n=e.offset().left+a,r=e.offset().top+e.outerHeight(),i=e.outerHeight();m.opts.iframe&&m.image.hasCaption()&&v(e)&&v(e).find("img")&&(i=v(e).find("img").outerHeight()),m.popups.show("link.insert",n,r,i,!0)}}return{_init:function e(){m.events.on("keyup",function(e){e.which!=St.KEYCODE.ESC&&_(e)}),m.events.on("window.mouseup",_),m.events.$on(m.$el,"click","a",function(e){m.edit.isDisabled()&&e.preventDefault()}),m.helpers.isMobile()&&m.events.$on(m.$doc,"selectionchange",_),s(!0),"A"==m.el.tagName&&m.$el.addClass("fr-view"),m.events.on("toolbar.esc",function(){if(m.popups.isVisible("link.edit"))return m.events.disableBlur(),m.events.focus(),!1},!0)},remove:function n(){var e=b(),t=m.image?m.image.get():null;if(!1===m.events.trigger("link.beforeRemove",[e]))return!1;if(t&&e)if(m.image.hasCaption()){t.addClass("img-link-caption"),v(e).replaceWith(v(e).html());var a=document.querySelectorAll("img.img-link-caption");m.image.edit(v(a[0])),v(a[0]).removeClass("img-link-caption")}else t.unwrap(),m.image.edit(t);else e&&(m.selection.save(),v(e).replaceWith(v(e).html()),m.selection.restore(),i())},showInsertPopup:function p(){var e=m.$tb.find('.fr-command[data-cmd="insertLink"]'),t=m.popups.get("link.insert");if(t||(t=s()),!t.hasClass("fr-active"))if(m.popups.refresh("link.insert"),m.popups.setContainer("link.insert",m.$tb||m.$sc),e.isVisible()){var a=m.button.getPosition(e),n=a.left,r=a.top;m.popups.show("link.insert",n,r,e.outerHeight())}else m.position.forSelection(t),m.popups.show("link.insert")},usePredefined:function u(e){var t,a,n=m.opts.linkList[e],r=m.popups.get("link.insert"),i=r.find('input.fr-link-attr[type="text"]'),o=r.find('input.fr-link-attr[type="checkbox"]');for(n.rel&&(r.rel=n.rel),a=0;a<i.length;a++)n[(t=v(i[a])).attr("name")]?(t.val(n[t.attr("name")]),t.toggleClass("fr-not-empty",!0)):"text"!=t.attr("name")&&t.val("");for(a=0;a<o.length;a++)(t=v(o[a])).attr("checked",t.data("checked")==n[t.attr("name")]);m.accessibility.focusPopup(r)},insertCallback:function g(){var e,t,a=m.popups.get("link.insert"),n=a.find('input.fr-link-attr[type="text"]'),r=a.find('input.fr-link-attr[type="checkbox"]'),i=(n.filter('[name="href"]').val()||"").trim(),o=m.opts.linkText?n.filter('[name="text"]').val():"",s={};for(t=0;t<n.length;t++)e=v(n[t]),["href","text"].indexOf(e.attr("name"))<0&&(s[e.attr("name")]=e.val());for(t=0;t<r.length;t++)(e=v(r[t])).is(":checked")?s[e.attr("name")]=e.data("checked"):s[e.attr("name")]=e.data("unchecked")||null;a.rel&&(s.rel=a.rel);var l=m.helpers.scrollTop();c(i,o,s),v(m.o_win).scrollTop(l)},insert:c,update:d,get:b,allSelected:E,back:function t(){m.image&&m.image.get()?m.image.back():(m.events.disableBlur(),m.selection.restore(),m.events.enableBlur(),b()&&m.$wp?(m.selection.restore(),i(),_()):"A"==m.el.tagName?(m.$el.focus(),_()):(m.popups.hide("link.insert"),m.toolbar.showInline()))},imageLink:f,applyStyle:function h(e,t,a){void 0===a&&(a=m.opts.linkMultipleStyles),void 0===t&&(t=m.opts.linkStyles);var n=b();if(!n)return!1;if(!a){var r=Object.keys(t);r.splice(r.indexOf(e),1),v(n).removeClass(r.join(" "))}v(n).toggleClass(e),_()}}},St.DefineIcon("insertLink",{NAME:"link",SVG_KEY:"insertLink"}),St.RegisterShortcut(St.KEYCODE.K,"insertLink",null,"K"),St.RegisterCommand("insertLink",{title:"Insert Link",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible("link.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("link.insert")):this.link.showInsertPopup()},plugin:"link"}),St.DefineIcon("linkOpen",{NAME:"external-link",FA5NAME:"external-link-alt",SVG_KEY:"openLink"}),St.RegisterCommand("linkOpen",{title:"Open Link",undo:!1,refresh:function(e){this.link.get()?e.removeClass("fr-hidden"):e.addClass("fr-hidden")},callback:function(){var e=this.link.get();e&&(-1!==e.href.indexOf("mailto:")?this.o_win.open(e.href).close():(e.target||(e.target="_self"),this.browser.msie||this.browser.edge?this.o_win.open(e.href,e.target):this.o_win.open(e.href,e.target,"noopener")),this.popups.hide("link.edit"))},plugin:"link"}),St.DefineIcon("linkEdit",{NAME:"edit",SVG_KEY:"edit"}),St.RegisterCommand("linkEdit",{title:"Edit Link",undo:!1,refreshAfterCallback:!1,popup:!0,callback:function(){this.link.update()},refresh:function(e){this.link.get()?e.removeClass("fr-hidden"):e.addClass("fr-hidden")},plugin:"link"}),St.DefineIcon("linkRemove",{NAME:"unlink",SVG_KEY:"unlink"}),St.RegisterCommand("linkRemove",{title:"Unlink",callback:function(){this.link.remove()},refresh:function(e){this.link.get()?e.removeClass("fr-hidden"):e.addClass("fr-hidden")},plugin:"link"}),St.DefineIcon("linkBack",{NAME:"arrow-left",SVG_KEY:"back"}),St.RegisterCommand("linkBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.link.back()},refresh:function(e){var t=this.link.get()&&this.doc.hasFocus();(this.image?this.image.get():null)||t||this.opts.toolbarInline?(e.removeClass("fr-hidden"),e.next(".fr-separator").removeClass("fr-hidden")):(e.addClass("fr-hidden"),e.next(".fr-separator").addClass("fr-hidden"))},plugin:"link"}),St.DefineIcon("linkList",{NAME:"search",SVG_KEY:"search"}),St.RegisterCommand("linkList",{title:"Choose Link",type:"dropdown",focus:!1,undo:!1,refreshAfterCallback:!1,html:function(){for(var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.linkList,a=0;a<t.length;a++)e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="linkList" data-param1="'.concat(a,'">').concat(t[a].displayText||t[a].text,"</a></li>");return e+="</ul>"},callback:function(e,t){this.link.usePredefined(t)},plugin:"link"}),St.RegisterCommand("linkInsert",{focus:!1,refreshAfterCallback:!1,callback:function(){this.link.insertCallback()},refresh:function(e){this.link.get()?e.text(this.language.translate("Update")):e.text(this.language.translate("Insert"))},plugin:"link"}),St.DefineIcon("imageLink",{NAME:"link",SVG_KEY:"insertLink"}),St.RegisterCommand("imageLink",{title:"Insert Link",undo:!1,focus:!1,popup:!0,callback:function(){this.link.imageLink()},refresh:function(e){var t;this.link.get()?((t=e.prev()).hasClass("fr-separator")&&t.removeClass("fr-hidden"),e.addClass("fr-hidden")):((t=e.prev()).hasClass("fr-separator")&&t.addClass("fr-hidden"),e.removeClass("fr-hidden"))},plugin:"link"}),St.DefineIcon("linkStyle",{NAME:"magic",SVG_KEY:"linkStyles"}),St.RegisterCommand("linkStyle",{title:"Style",type:"dropdown",html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.linkStyles;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="linkStyle" data-param1="'.concat(a,'">').concat(this.language.translate(t[a]),"</a></li>"));return e+="</ul>"},callback:function(e,t){this.link.applyStyle(t)},refreshOnShow:function(e,t){var a=this.$,n=this.link.get();if(n){var r=a(n);t.find(".fr-command").each(function(){var e=a(this).data("param1"),t=r.hasClass(e);a(this).toggleClass("fr-active",t).attr("aria-selected",t)})}},refresh:function(e){this.link.get()?e.removeClass("fr-hidden"):e.addClass("fr-hidden")},plugin:"link"}),Object.assign(St.DEFAULTS,{listAdvancedTypes:!0}),St.PLUGINS.lists=function(g){var h=g.$;function m(e){return'<span class="fr-open-'.concat(e.toLowerCase(),'"></span>')}function v(e){return'<span class="fr-close-'.concat(e.toLowerCase(),'"></span>')}function c(e,t){!function c(e,t){for(var a=[],n=0;n<e.length;n++){var r=e[n].parentNode;"LI"==e[n].tagName&&r.tagName!=t&&a.indexOf(r)<0&&a.push(r)}for(var i=a.length-1;0<=i;i--){var o=h(a[i]);o.replaceWith("<".concat(t.toLowerCase()," ").concat(g.node.attributes(o.get(0)),">").concat(o.html(),"</").concat(t.toLowerCase(),">"))}}(e,t);var a,n=g.html.defaultTag(),r=null;e.length&&(a="rtl"==g.opts.direction||"rtl"==h(e[0]).css("direction")?"margin-right":"margin-left");for(var i=0;i<e.length;i++)if("TD"!=e[i].tagName&&"TH"!=e[i].tagName&&"LI"!=e[i].tagName){var o=g.helpers.getPX(h(e[i]).css(a))||0;(e[i].style.marginLeft=null)===r&&(r=o);var s=0<r?"<".concat(t,' style="').concat(a,": ").concat(r,'px ">'):"<".concat(t,">"),l="</".concat(t,">");for(o-=r;0<o/g.opts.indentMargin;)s+="</".concat(t,">"),l+=l,o-=g.opts.indentMargin;n&&e[i].tagName.toLowerCase()==n?h(e[i]).replaceWith("".concat(s,"<li").concat(g.node.attributes(e[i]),">").concat(h(e[i]).html(),"</li>").concat(l)):h(e[i]).wrap("".concat(s,"<li></li>").concat(l))}g.clean.lists()}function d(e){var t,a,n=[];for(t=e.length-1;0<=t;t--)for(a=t-1;0<=a;a--){if(h(e[a]).find(e[t]).length||e[a]==e[t]){h(e[t]).addClass("fr-removed-block-".concat(t)),n.push(t),e.splice(t,1);break}if(h(e[a]).contains(e[t])){h(e[a]).addClass("fr-removed-block-".concat(a)),n.push(a),e.splice(a,1);break}}var r=[],i=!1;for(t=0;t<e.length;t++){var o=h(e[t]),s=e[t].parentNode,l=o.attr("class");if(o.is(":first-child")&&(i=!0,h(s.parentNode).removeAttr("start")),o.before(v(s.tagName)),"LI"==s.parentNode.tagName){if(o.is(":last-child")){var c=o.find("> ul, > ol").last();c.length&&c.wrap("<".concat(s.tagName,">"))}o.before(v("LI")),o.after(m("LI"))}else if("OL"==s.parentNode.tagName)i||(o.before(v("OL")),o.after(m("OL")));else if("UL"==s.parentNode.tagName)i||(o.before(v("UL")),o.after(m("UL")));else{var d="";l&&(d+=' class="'.concat(l,'"'));var f="rtl"==g.opts.direction||"rtl"==o.css("direction")?"margin-right":"margin-left";g.helpers.getPX(h(s).css(f))&&0<=(h(s).attr("style")||"").indexOf("".concat(f,":"))&&(d+=' style="'.concat(f,":").concat(g.helpers.getPX(h(s).css(f)),'px;"')),g.html.defaultTag()&&0===o.find(g.html.blockTagsQuery()).length&&o.wrapInner(g.html.defaultTag()+d),g.node.isEmpty(o.get(0),!0)||0!==o.find(g.html.blockTagsQuery()).length||("DIV"==s.parentNode.tagName&&g.html.defaultTag()?(o.prepend(m(g.html.defaultTag())),o.append(v(g.html.defaultTag()))):o.append("<br>")),o.append(m("LI")),o.prepend(v("LI"))}o.after(m(s.tagName)),"LI"==s.parentNode.tagName&&(s=s.parentNode.parentNode),r.indexOf(s)<0&&r.push(s)}for(t=0;t<r.length;t++){var p=h(r[t]),u=p.html();u=(u=u.replace(/<span class="fr-close-([a-z]*)"><\/span>/g,"</$1>")).replace(/<span class="fr-open-([a-z]*)"><\/span>/g,"<$1>"),p.replaceWith(g.node.openTagString(p.get(0))+u+g.node.closeTagString(p.get(0)))}return g.$el.find("li:empty").remove(),g.$el.find("ul:empty, ol:empty").remove(),g.clean.lists(),g.$el.find("ul:empty, ol:empty").remove(),g.html.wrap(),n}function u(e,t){var a=h(document.createElement("li"));if(e.childNodes.length)for(var n=e.childNodes[0].attributes,r=0;r<n.length;r++){var i=n[r];"style"===i.name&&(a[0].style.cssText+=i.value)}h(e).prepend(a),h(e).removeAttr("start");for(var o=g.node.contents(t)[0];o&&!g.node.isList(o);){var s=o.nextSibling;a.append(o),o=s}}function e(e){if("indent"==e||"outdent"==e){var t=!1,a=g.selection.blocks(!1,!0),n=[],r=a[0].previousSibling||a[0].parentElement;if("outdent"==e){if("UL"!=a[0].parentNode.tagName&&"UL"!=r.parentNode.tagName&&"OL"!=r.parentNode.tagName&&"LI"!=r.parentNode.tagName)return;if(!a[0].previousSibling&&"none"==r.parentNode.style.listStyleType)return void function o(e){for(g.selection.save();0<e.childNodes.length;)e.parentNode.parentNode.append(e.childNodes[0]);g.clean.lists(),g.selection.restore()}(r)}else{if("UL"!=a[0].parentElement.tagName&&"OL"!=a[0].parentElement.tagName&&"LI"!=a[0].parentElement.tagName)return;if(g.node.isBlock(a[0])&&"LI"!==a[0].tagName&&0<h(a[0]).parentsUntil(g.$el,"LI").length&&(a[0]=a[0].parentElement,r=a[0].parentElement),!a[0].previousSibling||"LI"!=a[0].previousSibling.tagName){if(0==h(a[0]).parents("li").length)return void function s(e){g.selection.save();var t="OL"==e.tagName?document.createElement("ol"):document.createElement("ul");for(h(t).css("list-style-type",h(e).css("list-style-type"));0<e.childNodes.length;)t.append(e.childNodes[0]);var a=document.createElement("li");t.append(a),e.append(t),g.clean.lists(),g.selection.restore()}(r);t=!0}}for(var i=0;i<a.length;i++)"LI"==a[i].tagName?(t=!0,n.push(a[i])):"LI"==a[i].parentNode.tagName&&n.indexOf(a[i].parentNode)<0&&(t=!0,n.push(a[i].parentNode));t&&("indent"==e?function p(e){g.selection.save();for(var t=!1,a=0;a<e.length;a++){var n=e[a].previousSibling;if(n&&"LI"==n.tagName&&!t){var r=h(e[a]).find("> ul, > ol").last().get(0);if(r)u(r,e[a]),h(n).append(h(r)),h(e[a]).remove();else{var i=h(n).find("> ul, > ol").last().get(0);if(i)h(i).append(h(e[a]));else{var o=h("<".concat(e[a].parentNode.tagName,">"));h(n).append(o),o.append(h(e[a]))}}}else if(!n||"OL"!=n.tagName&&"UL"!=n.tagName){var s=e[a].parentNode;if(t=!0,"UL"==s.tagName||"OL"==s.tagName){var l=h(e[a]).find("> ol, > ul"),c=null==e[a].previousSibling;if(l.length){var d=l.first().get(0);u(d,e[a]),c?h(s).prepend(h(d)):h(s).append(h(d)),h(e[a]).remove()}else h(e[a]).wrap("<".concat(s.tagName,">"));c&&0<h(s).find("> li").length&&h(s).attr("start","2")}}else{var f=h(e[a]).find("> ol, > ul").first().get(0);f?(u(f,e[a]),h(n).append(h(f).children()),h(e[a]).remove(),h(f).remove()):h(n).append(h(e[a]))}}g.clean.lists(),g.selection.restore()}(n):function l(e){g.selection.save();var t=[];do{t=d(e),e=[];for(var a=0;a<t.length;a++){var n=g.$el.find(".fr-removed-block-".concat(t[a])).first().get(0);h(n).removeClass("fr-removed-block-".concat(t[a])),""==h(n).attr("class")&&h(n).removeAttr("class"),e.push(n)}}while(0<t.length);g.selection.restore()}(n))}}return{_init:function t(){g.events.on("commands.after",e),g.events.on("keydown",function(e){if(e.which==St.KEYCODE.TAB){for(var t=g.selection.blocks(),a=[],n=0;n<t.length;n++)"LI"==t[n].tagName?a.push(t[n]):"LI"==t[n].parentNode.tagName&&a.push(t[n].parentNode);if(1<=a.length||a.length&&(g.selection.info(a[0]).atStart||g.node.isEmpty(a[0])))return e.preventDefault(),e.stopPropagation(),e.shiftKey?g.commands.outdent():g.commands.indent(),!1}},!0)},format:function f(e,t){var a,n,r=1<(n=g.selection.blocks(!0)).length&&n[n.length-1],i=g.selection.ranges();if(r&&i.length&&g.node.isEmpty(r)&&!i[0].endOffset&&i[0].setEndAfter(r.firstChild,1),g.html.syncInputs(),g.selection.save(),g.browser.safari&&g.helpers.getSafariVersion()<17){var o=g.selection.ranges();if(i&&i[0].endContainer&&o&&o[0].endContainer&&!i[0].endContainer.isSameNode(o[0].endContainer)&&i[0].endContainer.previousSibling&&i[0].endContainer.previousSibling.isSameNode(o[0].endContainer)){var s=h(o[0].endContainer).find('.fr-marker[data-type="false"]');h(i[0].endContainer).append(s[0])}}for(g.html.wrap(!0,!0,!0,!0),g.selection.restore(),n=g.selection.blocks(!0),a=0;a<n.length;a++)"LI"!=n[a].tagName&&"LI"==n[a].parentNode.tagName&&(n[a]=n[a].parentNode);if(g.selection.save(),function l(e,t){for(var a=!0,n=0;n<e.length;n++){if("LI"!=e[n].tagName)return!1;e[n].parentNode.tagName!=t&&(a=!1)}return a}(n,e)?t||d(n):c(n,e),g.html.unwrap(),g.selection.restore(),t=t||"default"){for(n=g.selection.blocks(),a=0;a<n.length;a++)"LI"!=n[a].tagName&&"LI"==n[a].parentNode.tagName&&(n[a]=n[a].parentNode);for(a=0;a<n.length;a++)"LI"==n[a].tagName&&(h(n[a].parentNode).css("list-style-type","default"===t?"":t),0===(h(n[a].parentNode).attr("style")||"").length&&h(n[a].parentNode).removeAttr("style"))}},refresh:function r(e,t){var a=h(g.selection.element());if(a.get(0)!=g.el){var n=a.get(0);(n="LI"!=n.tagName&&n.firstElementChild&&"LI"!=n.firstElementChild.tagName?a.parents("li").get(0):"LI"==n.tagName||n.firstElementChild?n.firstElementChild&&"LI"==n.firstElementChild.tagName?a.get(0).firstChild:a.get(0):a.parents("li").get(0))&&n.parentNode.tagName==t&&g.el.contains(n.parentNode)&&e.addClass("fr-active")}}}},St.DefineIcon("formatOLSimple",{NAME:"list-ol",SVG_KEY:"orderedList"}),St.RegisterCommand("formatOLSimple",{title:"Ordered List",type:"button",options:{"default":"Default",circle:"Circle",disc:"Disc",square:"Square"},refresh:function(e){this.lists.refresh(e,"OL")},callback:function(e,t){this.lists.format("OL",t)},plugin:"lists"}),St.RegisterCommand("formatUL",{title:"Unordered List",type:"button",hasOptions:function(){return this.opts.listAdvancedTypes},options:{"default":"Default",circle:"Circle",disc:"Disc",square:"Square"},refresh:function(e){this.lists.refresh(e,"UL")},callback:function(e,t){this.lists.format("UL",t)},plugin:"lists"}),St.RegisterCommand("formatOL",{title:"Ordered List",hasOptions:function(){return this.opts.listAdvancedTypes},options:{"default":"Default","lower-alpha":"Lower Alpha","lower-greek":"Lower Greek","lower-roman":"Lower Roman","upper-alpha":"Upper Alpha","upper-roman":"Upper Roman"},refresh:function(e){this.lists.refresh(e,"OL")},callback:function(e,t){this.lists.format("OL",t)},plugin:"lists"}),St.DefineIcon("formatUL",{NAME:"list-ul",SVG_KEY:"unorderedList"}),St.DefineIcon("formatOL",{NAME:"list-ol",SVG_KEY:"orderedList"}),Object.assign(St.DEFAULTS,{paragraphFormat:{N:"Normal",H1:"Heading 1",H2:"Heading 2",H3:"Heading 3",H4:"Heading 4",PRE:"Code"},paragraphFormatSelection:!1,paragraphDefaultSelection:"Paragraph Format"}),St.PLUGINS.paragraphFormat=function(u){var g=u.$;function h(e,t){var a=u.html.defaultTag();if(t&&t.toLowerCase()!=a)if(0<e.find("ul, ol").length){var n=g("<"+t+">");e.prepend(n);for(var r=u.node.contents(e.get(0))[0];r&&["UL","OL"].indexOf(r.tagName)<0;){var i=r.nextSibling;n.append(r),r=i}}else e.html("<"+t+">"+e.html()+"</"+t+">")}return{apply:function m(e){"N"==e&&(e=u.html.defaultTag()),u.selection.save(),u.html.wrap(!0,!0,!u.opts.paragraphFormat.BLOCKQUOTE,!0,!0),u.selection.restore();var t,a,n,r,i,o,s,l,c=u.selection.blocks();u.selection.save(),u.$el.find("pre").attr("skip",!0);for(var d=0;d<c.length;d++)if(c[d].tagName!=e&&!u.node.isList(c[d])){var f=g(c[d]);if("LI"==c[d].tagName)h(f,e);else if("LI"==c[d].parentNode.tagName&&c[d])o=f,s=e,l=u.html.defaultTag(),s&&s.toLowerCase()!=l||(s='div class="fr-temp-div"'),o.replaceWith(g("<"+s+">").html(o.html()));else if(0<=["TD","TH"].indexOf(c[d].parentNode.tagName))n=f,r=e,i=u.html.defaultTag(),r||(r='div class="fr-temp-div"'+(u.node.isEmpty(n.get(0),!0)?' data-empty="true"':"")),r.toLowerCase()==i?(u.node.isEmpty(n.get(0),!0)||n.append("<br/>"),n.replaceWith(n.html())):n.replaceWith(g("<"+r+">").html(n.html()));else{if("PRE"===e&&null===f[0].nextSibling){var p=g("<br>");f[0].after(p[0])}t=f,(a=e)||(a='div class="fr-temp-div"'+(u.node.isEmpty(t.get(0),!0)?' data-empty="true"':"")),("H1"==a||"H2"==a||"H3"==a||"H4"==a||"H5"==a)&&-1<u.node.attributes(t.get(0)).indexOf("font-size:")?t.replaceWith(g("<"+a+" "+u.node.attributes(t.get(0)).replace(/font-size:[0-9]+px;?/,"")+">").html(t.html()).removeAttr("data-empty")):t.replaceWith(g("<"+a+" "+u.node.attributes(t.get(0))+">").html(t.html()).removeAttr("data-empty"))}}u.$el.find('pre:not([skip="true"]) + pre:not([skip="true"])').each(function(){g(this).prev().append("<br>"+g(this).html()),g(this).remove()}),u.$el.find("pre").removeAttr("skip"),u.html.unwrap(),u.selection.restore()},refreshOnShow:function o(e,t){var a=u.selection.blocks();if(a.length){var n=a[0],r="N",i=u.html.defaultTag();n.tagName.toLowerCase()!=i&&n!=u.el&&(r=n.tagName),t.find('.fr-command[data-param1="'+r+'"]').addClass("fr-active").attr("aria-selected",!0)}else t.find('.fr-command[data-param1="N"]').addClass("fr-active").attr("aria-selected",!0)},refresh:function i(e){if(u.opts.paragraphFormatSelection){var t=u.selection.blocks();if(t.length){var a=t[0],n="N",r=u.html.defaultTag();a.tagName.toLowerCase()!=r&&a!=u.el&&(n=a.tagName),0<=["LI","TD","TH"].indexOf(n)&&(n="N"),e.find(">span").text(u.language.translate(u.opts.paragraphFormat[n]))}else e.find(">span").text(u.language.translate(u.opts.paragraphFormat.N))}}}},St.RegisterCommand("paragraphFormat",{type:"dropdown",displaySelection:function(e){return e.opts.paragraphFormatSelection},defaultSelection:function(e){return e.language.translate(e.opts.paragraphDefaultSelection)},displaySelectionWidth:80,html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.paragraphFormat;for(var a in t)if(t.hasOwnProperty(a)){var n=this.shortcuts.get("paragraphFormat."+a);n=n?'<span class="fr-shortcut">'+n+"</span>":"",e+='<li role="presentation"><'+("N"==a?this.html.defaultTag()||"DIV":a)+' style="padding: 0 !important; margin: 0 !important; border: 0 !important; background-color: transparent !important; '+("PRE"==a||"N"==a?"font-size: 15px":"font-weight: bold !important; ")+("H1"==a?"font-size: 2em !important; ":"")+("H2"==a?"font-size: 1.5em !important; ":"")+("H3"==a?"font-size: 1.17em !important; ":"")+("H4"==a?"font-size: 15px !important;":"")+'"  role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="paragraphFormat" data-param1="'+a+'" title="'+this.language.translate(t[a])+'">'+this.language.translate(t[a])+"</a></"+("N"==a?this.html.defaultTag()||"DIV":a)+"></li>"}return e+="</ul>"},title:"Paragraph Format",callback:function(e,t){this.paragraphFormat.apply(t)},refresh:function(e){this.paragraphFormat.refresh(e)},refreshOnShow:function(e,t){this.paragraphFormat.refreshOnShow(e,t)},plugin:"paragraphFormat"}),St.DefineIcon("paragraphFormat",{NAME:"paragraph",SVG_KEY:"paragraphFormat"}),Object.assign(St.DEFAULTS,{paragraphStyles:{"fr-text-gray":"Gray","fr-text-bordered":"Bordered","fr-text-spaced":"Spaced","fr-text-uppercase":"Uppercase"},paragraphMultipleStyles:!0}),St.PLUGINS.paragraphStyle=function(l){var c=l.$;return{_init:function e(){},apply:function d(e,t,a){void 0===t&&(t=l.opts.paragraphStyles),void 0===a&&(a=l.opts.paragraphMultipleStyles);var n="";a||((n=Object.keys(t)).splice(n.indexOf(e),1),n=n.join(" ")),l.selection.save(),l.html.wrap(!0,!0,!0,!0),l.selection.restore();var r=l.selection.blocks();l.selection.save();for(var i=c(r[0]).hasClass(e),o=0;o<r.length;o++)c(r[o]).removeClass(n).toggleClass(e,!i),c(r[o]).hasClass("fr-temp-div")&&c(r[o]).removeClass("fr-temp-div"),""===c(r[o]).attr("class")&&c(r[o]).removeAttr("class");if(1===r.length&&"fr-text-bordered"===e&&null===r[0].nextSibling){var s=c("<br>");r[0].after(s[0])}l.html.unwrap(),l.selection.restore()},refreshOnShow:function r(e,t){var a=l.selection.blocks();if(a.length){var n=c(a[0]);t.find(".fr-command").each(function(){var e=c(this).data("param1"),t=n.hasClass(e);c(this).toggleClass("fr-active",t).attr("aria-selected",t)})}}}},St.RegisterCommand("paragraphStyle",{type:"dropdown",html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.paragraphStyles;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command '.concat(a,'" tabIndex="-1" role="option" data-cmd="paragraphStyle" data-param1="').concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.language.translate(t[a]),"</a></li>"));return e+="</ul>"},title:"Paragraph Style",callback:function(e,t){this.paragraphStyle.apply(t)},refreshOnShow:function(e,t){this.paragraphStyle.refreshOnShow(e,t)},plugin:"paragraphStyle"}),St.DefineIcon("paragraphStyle",{NAME:"magic",SVG_KEY:"paragraphStyle"}),Object.assign(St.DEFAULTS,{html2pdf:window.html2pdf}),St.PLUGINS.print=function(l){return{run:function e(){!function s(e){var t=l.html.get(),a=null;l.shared.print_iframe?a=l.shared.print_iframe:((a=document.createElement("iframe")).name="fr-print",a.style.position="fixed",a.style.top="0",a.style.left="-9999px",a.style.height="100%",a.style.width="0",a.style.overflow="hidden",a.style["z-index"]="2147483647",a.style.tabIndex="-1",l.events.on("shared.destroy",function(){a.remove()}),l.shared.print_iframe=a);try{document.body.removeChild(a)}catch(o){}document.body.appendChild(a);var n=function(){e(),a.removeEventListener("load",n)};a.addEventListener("load",n);var r=a.contentWindow;r.document.open(),r.document.write("<!DOCTYPE html><html "+(l.opts.documentReady?'style="margin: 0; padding: 0;"':"")+"><head><title>"+document.title+"</title>"),Array.prototype.forEach.call(document.querySelectorAll("style"),function(e){e=e.cloneNode(!0),r.document.write(e.outerHTML)});var i=document.querySelectorAll("link[rel=stylesheet]");Array.prototype.forEach.call(i,function(e){var t=document.createElement("link");t.rel=e.rel,t.href=e.href,t.media="print",t.type="text/css",t.media="all",r.document.write(t.outerHTML)}),r.document.write('</head><body style="height:auto;text-align: '+("rtl"==l.opts.direction?"right":"left")+"; direction: "+l.opts.direction+"; "+(l.opts.documentReady?" padding: 2cm; width: 17cm; margin: 0;":"")+'"><div class="fr-view">'),r.document.write(t),r.document.write("</div></body></html>"),r.document.close()}(function(){setTimeout(function(){l.events.disableBlur(),window.frames["fr-print"].focus(),window.frames["fr-print"].print(),l.$win.get(0).focus(),l.events.disableBlur(),l.events.focus()},0)})},toPDF:function t(){l.opts.html2pdf&&(l.$el.css("text-align","left"),l.opts.html2pdf().set({margin:[10,20],html2canvas:{useCORS:!0}}).from(l.el).save(),setTimeout(function(){l.$el.css("text-align","")},100))}}},St.DefineIcon("print",{NAME:"print",SVG_KEY:"print"}),St.RegisterCommand("print",{title:"Print",undo:!1,focus:!1,plugin:"print",callback:function(){this.print.run()}}),St.DefineIcon("getPDF",{NAME:"file-pdf-o",FA5NAME:"file-pdf",SVG_KEY:"pdfExport"}),St.RegisterCommand("getPDF",{title:"Download PDF",type:"button",focus:!1,undo:!1,callback:function(){this.print.toPDF()}}),Object.assign(St.DEFAULTS,{quickInsertButtons:["image","video","embedly","table","ul","ol","hr"],quickInsertTags:["p","div","h1","h2","h3","h4","h5","h6","pre","blockquote"],quickInsertEnabled:!0}),St.QUICK_INSERT_BUTTONS={},St.DefineIcon("quickInsert",{SVG_KEY:"add",template:"svg"}),St.RegisterQuickInsertButton=function(e,t){St.QUICK_INSERT_BUTTONS[e]=Object.assign({undo:!0},t)},St.RegisterQuickInsertButton("image",{icon:"insertImage",requiredPlugin:"image",title:"Insert Image",undo:!1,callback:function(){var e=this,t=e.$;e.shared.$qi_image_input||(e.shared.$qi_image_input=t(document.createElement("input")).attr("accept","image/"+e.opts.imageAllowedTypes.join(", image/").toLowerCase()).attr("name","quickInsertImage".concat(this.id)).attr("style","display: none;").attr("type","file"),t("body").first().append(e.shared.$qi_image_input),e.events.$on(e.shared.$qi_image_input,"change",function(){var e=t(this).data("inst");this.files&&(e.quickInsert.hide(),e.image.upload(this.files)),t(this).val("")},!0)),e.$qi_image_input=e.shared.$qi_image_input,e.helpers.isMobile()&&e.selection.save(),e.events.disableBlur(),e.$qi_image_input.data("inst",e)[0].click()}}),St.RegisterQuickInsertButton("video",{icon:"insertVideo",requiredPlugin:"video",title:"Insert Video",undo:!1,callback:function(){var e=prompt(this.language.translate("Paste the URL of the video you want to insert."));e&&this.video.insertByURL(e)}}),St.RegisterQuickInsertButton("embedly",{icon:"embedly",requiredPlugin:"embedly",title:"Embed URL",undo:!1,callback:function(){var e=prompt(this.language.translate("Paste the URL of any web content you want to insert."));e&&this.embedly.add(e)}}),St.RegisterQuickInsertButton("table",{icon:"insertTable",requiredPlugin:"table",title:"Insert Table",callback:function(){this.table.insert(2,2)}}),St.RegisterQuickInsertButton("ol",{icon:"formatOL",requiredPlugin:"lists",title:"Ordered List",callback:function(){this.lists.format("OL")}}),St.RegisterQuickInsertButton("ul",{icon:"formatUL",requiredPlugin:"lists",title:"Unordered List",callback:function(){this.lists.format("UL")}}),St.RegisterQuickInsertButton("hr",{icon:"insertHR",title:"Insert Horizontal Line",callback:function(){this.commands.insertHR()}}),St.PLUGINS.quickInsert=function(o){var s,l,c=o.$,d=!1;function a(e){var t,a,n;(t=e.offset().top-o.$box.offset().top,a=(o.$iframe&&o.$iframe.offset().left||0)+e.offset().left-e.position().left-4<s.outerWidth()?e.offset().left+s.outerWidth():0-s.outerWidth(),o.opts.enter!=St.ENTER_BR)?n=(s.outerHeight()-e.outerHeight())/2:(c(document.createElement("span")).html(St.INVISIBLE_SPACE).insertAfter(e),n=(s.outerHeight()-e.next().outerHeight())/2,e.next().remove());if(o.opts.iframe){var r=o.helpers.getPX(o.$wp.find(".fr-iframe").css("padding-top"));t+=o.$iframe.offset().top+r}s.hasClass("fr-on")&&0<=t&&l.css("top",t-n),0<=t&&t-Math.abs(n)<=o.$box.outerHeight()-e.outerHeight()?(s.hasClass("fr-hidden")&&(s.hasClass("fr-on")&&f(),s.removeClass("fr-hidden")),s.css("top",t-n)):s.hasClass("fr-visible")&&!o.opts.toolbarInline&&(s.addClass("fr-hidden"),p()),s.css("left",a)}function r(e){o.markdown&&o.markdown.isEnabled()||(s||function t(){o.shared.$quick_insert||(o.shared.$quick_insert=c(document.createElement("div")).attr("class","fr-quick-insert").html('<a class="fr-floating-btn" role="button" tabIndex="-1" title="'.concat(o.language.translate("Quick Insert"),'">').concat(o.icon.create("quickInsert"),"</a>")));s=o.shared.$quick_insert,o.tooltip.bind(o.$box,".fr-quick-insert > a.fr-floating-btn"),o.events.on("destroy",function(){c("body").first().append(s.removeClass("fr-on")),l&&(p(),c("body").first().append(l.css("left",-9999).css("top",-9999)))},!0),o.events.on("shared.destroy",function(){s.html("").removeData().remove(),s=null,l&&(l.html("").removeData().remove(),l=null)},!0),o.events.on("commands.before",i),o.events.on("commands.after",function(){o.popups.areVisible()||n()}),o.events.bindClick(o.$box,".fr-quick-insert > a",f),o.events.bindClick(o.$box,".fr-qi-helper > a.fr-btn",function(e){var t=c(e.currentTarget).data("cmd");if(!1===o.events.trigger("quickInsert.commands.before",[t]))return!1;St.QUICK_INSERT_BUTTONS[t].callback.apply(o,[e.currentTarget]),St.QUICK_INSERT_BUTTONS[t].undo&&o.undo.saveStep(),o.events.trigger("quickInsert.commands.after",[t]),o.quickInsert.hide()}),o.events.$on(o.$wp,"scroll",u),o.events.$on(o.$tb,"transitionend",".fr-more-toolbar",u)}(),s.hasClass("fr-on")&&p(),o.$box.append(s),a(e),s.data("tag",e),s.addClass("fr-visible"))}function n(){if(o.core.hasFocus()){var e=o.selection.element();if(o.opts.enter==St.ENTER_BR||o.node.isBlock(e)||(e=o.node.blockParent(e)),o.opts.enter==St.ENTER_BR&&!o.node.isBlock(e)){var t=o.node.deepestParent(e);t&&(e=t)}var a=function a(){return o.opts.enter!=St.ENTER_BR&&o.node.isEmpty(e)&&0<=o.opts.quickInsertTags.indexOf(e.tagName.toLowerCase())},n=function n(){return o.opts.enter==St.ENTER_BR&&("BR"==e.tagName&&(!e.previousSibling||"BR"==e.previousSibling.tagName||o.node.isBlock(e.previousSibling))||o.node.isEmpty(e)&&(!e.previousSibling||"BR"==e.previousSibling.tagName||o.node.isBlock(e.previousSibling))&&(!e.nextSibling||"BR"==e.nextSibling.tagName||o.node.isBlock(e.nextSibling)))};e&&(a()||n())?s&&s.data("tag").is(c(e))&&s.hasClass("fr-on")?p():o.selection.isCollapsed()&&r(c(e)):i()}}function i(){s&&!d&&(s.hasClass("fr-on")&&p(),s.removeClass("fr-visible fr-on"),s.css("left",-9999).css("top",-9999))}function f(e){if(e&&e.preventDefault(),s.hasClass("fr-on")&&!s.hasClass("fr-hidden"))p();else{if(!o.shared.$qi_helper){for(var t=o.opts.quickInsertButtons,a='<div class="fr-qi-helper">',n=0,r=0;r<t.length;r++){var i=St.QUICK_INSERT_BUTTONS[t[r]];i&&(!i.requiredPlugin||St.PLUGINS[i.requiredPlugin]&&0<=o.opts.pluginsEnabled.indexOf(i.requiredPlugin))&&(a+='<a class="fr-btn fr-floating-btn" role="button" title="'.concat(o.language.translate(i.title),'" tabIndex="-1" data-cmd="').concat(t[r],'" style="transition-delay: ').concat(.025*n++,'s;">').concat(o.icon.create(i.icon),"</a>"))}a+="</div>",o.shared.$qi_helper=c(a),o.tooltip.bind(o.shared.$qi_helper,"a.fr-btn"),o.events.$on(o.shared.$qi_helper,"mousedown",function(e){e.preventDefault()},!0)}l=o.shared.$qi_helper,o.$box.append(l),d=!0,setTimeout(function(){d=!1,l.css("top",parseFloat(s.css("top"))),l.css("left",parseFloat(s.css("left"))+s.outerWidth()),l.find("a").addClass("fr-size-1"),s.addClass("fr-on")},10)}}function p(){var t=o.$box.find(".fr-qi-helper");if(t.length){for(var a=t.find("a"),e=0;e<a.length;e++)!function(e){setTimeout(function(){t.children().eq(a.length-1-e).removeClass("fr-size-1")},25*e)}(e);setTimeout(function(){t.css("left",-9999),s&&!s.hasClass("fr-hidden")&&s.removeClass("fr-on")},25*e)}}function u(){s.hasClass("fr-visible")&&a(s.data("tag"))}return{_init:function e(){if(!o.$wp||!o.opts.quickInsertEnabled)return!1;o.popups.onShow("image.edit",i),o.events.on("mouseup",n),o.helpers.isMobile()&&o.events.$on(c(o.o_doc),"selectionchange",n),o.events.on("blur",i),o.events.on("keyup",n),o.events.on("keydown",function(){setTimeout(function(){n()},0)})},hide:i}},St.PLUGINS.quote=function(i){var o=i.$;function s(e){for(;e.parentNode&&e.parentNode!=i.el;)e=e.parentNode;return e}return{apply:function t(e){i.selection.save(),i.html.wrap(!0,!0,!0,!0),i.selection.restore(),"increase"==e?function n(){var e,t=i.selection.blocks();for(e=0;e<t.length;e++)t[e]=s(t[e]);i.selection.save();var a=o(document.createElement("blockquote"));for(a.insertBefore(t[0]),e=0;e<t.length;e++)a.append(t[e]);i.opts.trackChangesEnabled&&i.track_changes.addQuote(a),i.html.unwrap(),i.selection.restore()}():"decrease"==e&&function r(){var e,t=i.opts.trackChangesEnabled,a=i.selection.blocks();for(e=0;e<a.length;e++)"BLOCKQUOTE"!=a[e].tagName&&(a[e]=t&&o(a[e]).parentsUntil(i.$el,"[data-track-id^=pending]").get(0)||o(a[e]).parentsUntil(i.$el,"BLOCKQUOTE").get(0));for(i.selection.save(),e=0;e<a.length;e++)a[e]&&(t?i.track_changes.removeQuote(o(a[e]),e):o(a[e]).replaceWith(a[e].innerHTML));i.html.unwrap(),i.selection.restore()}()}}},St.RegisterShortcut(St.KEYCODE.SINGLE_QUOTE,"quote","increase","'"),St.RegisterShortcut(St.KEYCODE.SINGLE_QUOTE,"quote","decrease","'",!0),St.RegisterCommand("quote",{title:"Quote",type:"dropdown",html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t={increase:"Increase",decrease:"Decrease"};for(var a in t)if(t.hasOwnProperty(a)){var n=this.shortcuts.get("quote.".concat(a));e+='<li role="presentation"><a class="fr-command fr-active '.concat(a,'" tabIndex="-1" role="option" data-cmd="quote" data-param1="').concat(a,'" title="').concat(t[a],'">').concat(this.language.translate(t[a])).concat(n?'<span class="fr-shortcut">'.concat(n,"</span>"):"","</a></li>")}return e+="</ul>"},callback:function(e,t){this.quote.apply(t)},plugin:"quote"}),St.DefineIcon("quote",{NAME:"quote-left",SVG_KEY:"blockquote"}),Object.assign(St.DEFAULTS,{saveInterval:1e4,saveURL:null,saveParams:{},saveParam:"body",saveMethod:"POST"}),St.PLUGINS.save=function(s){var l=s.$,n=null,c=null,t=!1,d=1,f=2,a={};function p(e,t){s.events.trigger("save.error",[{code:e,message:a[e]},t])}function r(e){void 0===e&&(e=s.html.get());var n=e,t=s.events.trigger("save.before",[e]);if(!1===t)return!1;if("string"==typeof t&&(e=t),s.opts.saveURL){var a={};for(var r in s.opts.saveParams)if(s.opts.saveParams.hasOwnProperty(r)){var i=s.opts.saveParams[r];a[r]="function"==typeof i?i.call(this):i}var o={};o[s.opts.saveParam]=e,l(this).ajax({method:s.opts.saveMethod,url:s.opts.saveURL,data:Object.assign(o,a),crossDomain:s.opts.requestWithCORS,withCredentials:s.opts.requestWithCredentials,headers:s.opts.requestHeaders,done:function(e,t,a){c=n,s.events.trigger("save.after",[e])},fail:function(e){p(f,e.response||e.responseText)}})}else p(d)}function i(){clearTimeout(n),n=setTimeout(function(){var e=s.html.get();(c!=e||t)&&(t=!1,r(c=e))},0)}return a[d]="Missing saveURL option.",a[f]="Something went wrong during save.",{_init:function o(){if(s.opts.letteringClass)for(var e=s.opts.letteringClass,t=s.$el.find(".".concat(e)).length,a=0;a<t;a++)s.$el.find(".".concat(e))[a].innerHTML=s.$el.find(".".concat(e))[a].innerText.replace(/([\w'-]+|[?.",])/g,"<span class = 'fr-word-select'>$1</span>");s.opts.saveInterval&&(c=s.html.get(),s.events.on("contentChanged",function(){setTimeout(i,s.opts.saveInterval)}),s.events.on("keydown destroy",function(){clearTimeout(n)}))},save:r,reset:function e(){i(),t=!1},force:function u(){t=!0}}},St.DefineIcon("save",{NAME:"floppy-o",FA5NAME:"save"}),St.RegisterCommand("save",{title:"Save",undo:!1,focus:!1,refreshAfterCallback:!1,callback:function(){this.save.save()},plugin:"save"}),Object.assign(St.DEFAULTS,{specialCharactersSets:[{title:"Latin","char":"&iexcl;",list:[{"char":"&iexcl;",desc:"INVERTED EXCLAMATION MARK"},{"char":"&cent;",desc:"CENT SIGN"},{"char":"&pound;",desc:"POUND SIGN"},{"char":"&curren;",desc:"CURRENCY SIGN"},{"char":"&yen;",desc:"YEN SIGN"},{"char":"&brvbar;",desc:"BROKEN BAR"},{"char":"&sect;",desc:"SECTION SIGN"},{"char":"&uml;",desc:"DIAERESIS"},{"char":"&copy;",desc:"COPYRIGHT SIGN"},{"char":"&trade;",desc:"TRADEMARK SIGN"},{"char":"&ordf;",desc:"FEMININE ORDINAL INDICATOR"},{"char":"&laquo;",desc:"LEFT-POINTING DOUBLE ANGLE QUOTATION MARK"},{"char":"&not;",desc:"NOT SIGN"},{"char":"&reg;",desc:"REGISTERED SIGN"},{"char":"&macr;",desc:"MACRON"},{"char":"&deg;",desc:"DEGREE SIGN"},{"char":"&plusmn;",desc:"PLUS-MINUS SIGN"},{"char":"&sup2;",desc:"SUPERSCRIPT TWO"},{"char":"&sup3;",desc:"SUPERSCRIPT THREE"},{"char":"&acute;",desc:"ACUTE ACCENT"},{"char":"&micro;",desc:"MICRO SIGN"},{"char":"&para;",desc:"PILCROW SIGN"},{"char":"&middot;",desc:"MIDDLE DOT"},{"char":"&cedil;",desc:"CEDILLA"},{"char":"&sup1;",desc:"SUPERSCRIPT ONE"},{"char":"&ordm;",desc:"MASCULINE ORDINAL INDICATOR"},{"char":"&raquo;",desc:"RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK"},{"char":"&frac14;",desc:"VULGAR FRACTION ONE QUARTER"},{"char":"&frac12;",desc:"VULGAR FRACTION ONE HALF"},{"char":"&frac34;",desc:"VULGAR FRACTION THREE QUARTERS"},{"char":"&iquest;",desc:"INVERTED QUESTION MARK"},{"char":"&Agrave;",desc:"LATIN CAPITAL LETTER A WITH GRAVE"},{"char":"&Aacute;",desc:"LATIN CAPITAL LETTER A WITH ACUTE"},{"char":"&Acirc;",desc:"LATIN CAPITAL LETTER A WITH CIRCUMFLEX"},{"char":"&Atilde;",desc:"LATIN CAPITAL LETTER A WITH TILDE"},{"char":"&Auml;",desc:"LATIN CAPITAL LETTER A WITH DIAERESIS "},{"char":"&Aring;",desc:"LATIN CAPITAL LETTER A WITH RING ABOVE"},{"char":"&AElig;",desc:"LATIN CAPITAL LETTER AE"},{"char":"&Ccedil;",desc:"LATIN CAPITAL LETTER C WITH CEDILLA"},{"char":"&Egrave;",desc:"LATIN CAPITAL LETTER E WITH GRAVE"},{"char":"&Eacute;",desc:"LATIN CAPITAL LETTER E WITH ACUTE"},{"char":"&Ecirc;",desc:"LATIN CAPITAL LETTER E WITH CIRCUMFLEX"},{"char":"&Euml;",desc:"LATIN CAPITAL LETTER E WITH DIAERESIS"},{"char":"&Igrave;",desc:"LATIN CAPITAL LETTER I WITH GRAVE"},{"char":"&Iacute;",desc:"LATIN CAPITAL LETTER I WITH ACUTE"},{"char":"&Icirc;",desc:"LATIN CAPITAL LETTER I WITH CIRCUMFLEX"},{"char":"&Iuml;",desc:"LATIN CAPITAL LETTER I WITH DIAERESIS"},{"char":"&ETH;",desc:"LATIN CAPITAL LETTER ETH"},{"char":"&Ntilde;",desc:"LATIN CAPITAL LETTER N WITH TILDE"},{"char":"&Ograve;",desc:"LATIN CAPITAL LETTER O WITH GRAVE"},{"char":"&Oacute;",desc:"LATIN CAPITAL LETTER O WITH ACUTE"},{"char":"&Ocirc;",desc:"LATIN CAPITAL LETTER O WITH CIRCUMFLEX"},{"char":"&Otilde;",desc:"LATIN CAPITAL LETTER O WITH TILDE"},{"char":"&Ouml;",desc:"LATIN CAPITAL LETTER O WITH DIAERESIS"},{"char":"&times;",desc:"MULTIPLICATION SIGN"},{"char":"&Oslash;",desc:"LATIN CAPITAL LETTER O WITH STROKE"},{"char":"&Ugrave;",desc:"LATIN CAPITAL LETTER U WITH GRAVE"},{"char":"&Uacute;",desc:"LATIN CAPITAL LETTER U WITH ACUTE"},{"char":"&Ucirc;",desc:"LATIN CAPITAL LETTER U WITH CIRCUMFLEX"},{"char":"&Uuml;",desc:"LATIN CAPITAL LETTER U WITH DIAERESIS"},{"char":"&Yacute;",desc:"LATIN CAPITAL LETTER Y WITH ACUTE"},{"char":"&THORN;",desc:"LATIN CAPITAL LETTER THORN"},{"char":"&szlig;",desc:"LATIN SMALL LETTER SHARP S"},{"char":"&agrave;",desc:"LATIN SMALL LETTER A WITH GRAVE"},{"char":"&aacute;",desc:"LATIN SMALL LETTER A WITH ACUTE "},{"char":"&acirc;",desc:"LATIN SMALL LETTER A WITH CIRCUMFLEX"},{"char":"&atilde;",desc:"LATIN SMALL LETTER A WITH TILDE"},{"char":"&auml;",desc:"LATIN SMALL LETTER A WITH DIAERESIS"},{"char":"&aring;",desc:"LATIN SMALL LETTER A WITH RING ABOVE"},{"char":"&aelig;",desc:"LATIN SMALL LETTER AE"},{"char":"&ccedil;",desc:"LATIN SMALL LETTER C WITH CEDILLA"},{"char":"&egrave;",desc:"LATIN SMALL LETTER E WITH GRAVE"},{"char":"&eacute;",desc:"LATIN SMALL LETTER E WITH ACUTE"},{"char":"&ecirc;",desc:"LATIN SMALL LETTER E WITH CIRCUMFLEX"},{"char":"&euml;",desc:"LATIN SMALL LETTER E WITH DIAERESIS"},{"char":"&igrave;",desc:"LATIN SMALL LETTER I WITH GRAVE"},{"char":"&iacute;",desc:"LATIN SMALL LETTER I WITH ACUTE"},{"char":"&icirc;",desc:"LATIN SMALL LETTER I WITH CIRCUMFLEX"},{"char":"&iuml;",desc:"LATIN SMALL LETTER I WITH DIAERESIS"},{"char":"&eth;",desc:"LATIN SMALL LETTER ETH"},{"char":"&ntilde;",desc:"LATIN SMALL LETTER N WITH TILDE"},{"char":"&ograve;",desc:"LATIN SMALL LETTER O WITH GRAVE"},{"char":"&oacute;",desc:"LATIN SMALL LETTER O WITH ACUTE"},{"char":"&ocirc;",desc:"LATIN SMALL LETTER O WITH CIRCUMFLEX"},{"char":"&otilde;",desc:"LATIN SMALL LETTER O WITH TILDE"},{"char":"&ouml;",desc:"LATIN SMALL LETTER O WITH DIAERESIS"},{"char":"&divide;",desc:"DIVISION SIGN"},{"char":"&oslash;",desc:"LATIN SMALL LETTER O WITH STROKE"},{"char":"&ugrave;",desc:"LATIN SMALL LETTER U WITH GRAVE"},{"char":"&uacute;",desc:"LATIN SMALL LETTER U WITH ACUTE"},{"char":"&ucirc;",desc:"LATIN SMALL LETTER U WITH CIRCUMFLEX"},{"char":"&uuml;",desc:"LATIN SMALL LETTER U WITH DIAERESIS"},{"char":"&yacute;",desc:"LATIN SMALL LETTER Y WITH ACUTE"},{"char":"&thorn;",desc:"LATIN SMALL LETTER THORN"},{"char":"&yuml;",desc:"LATIN SMALL LETTER Y WITH DIAERESIS"}]},{title:"Greek","char":"&Alpha;",list:[{"char":"&Alpha;",desc:"GREEK CAPITAL LETTER ALPHA"},{"char":"&Beta;",desc:"GREEK CAPITAL LETTER BETA"},{"char":"&Gamma;",desc:"GREEK CAPITAL LETTER GAMMA"},{"char":"&Delta;",desc:"GREEK CAPITAL LETTER DELTA"},{"char":"&Epsilon;",desc:"GREEK CAPITAL LETTER EPSILON"},{"char":"&Zeta;",desc:"GREEK CAPITAL LETTER ZETA"},{"char":"&Eta;",desc:"GREEK CAPITAL LETTER ETA"},{"char":"&Theta;",desc:"GREEK CAPITAL LETTER THETA"},{"char":"&Iota;",desc:"GREEK CAPITAL LETTER IOTA"},{"char":"&Kappa;",desc:"GREEK CAPITAL LETTER KAPPA"},{"char":"&Lambda;",desc:"GREEK CAPITAL LETTER LAMBDA"},{"char":"&Mu;",desc:"GREEK CAPITAL LETTER MU"},{"char":"&Nu;",desc:"GREEK CAPITAL LETTER NU"},{"char":"&Xi;",desc:"GREEK CAPITAL LETTER XI"},{"char":"&Omicron;",desc:"GREEK CAPITAL LETTER OMICRON"},{"char":"&Pi;",desc:"GREEK CAPITAL LETTER PI"},{"char":"&Rho;",desc:"GREEK CAPITAL LETTER RHO"},{"char":"&Sigma;",desc:"GREEK CAPITAL LETTER SIGMA"},{"char":"&Tau;",desc:"GREEK CAPITAL LETTER TAU"},{"char":"&Upsilon;",desc:"GREEK CAPITAL LETTER UPSILON"},{"char":"&Phi;",desc:"GREEK CAPITAL LETTER PHI"},{"char":"&Chi;",desc:"GREEK CAPITAL LETTER CHI"},{"char":"&Psi;",desc:"GREEK CAPITAL LETTER PSI"},{"char":"&Omega;",desc:"GREEK CAPITAL LETTER OMEGA"},{"char":"&alpha;",desc:"GREEK SMALL LETTER ALPHA"},{"char":"&beta;",desc:"GREEK SMALL LETTER BETA"},{"char":"&gamma;",desc:"GREEK SMALL LETTER GAMMA"},{"char":"&delta;",desc:"GREEK SMALL LETTER DELTA"},{"char":"&epsilon;",desc:"GREEK SMALL LETTER EPSILON"},{"char":"&zeta;",desc:"GREEK SMALL LETTER ZETA"},{"char":"&eta;",desc:"GREEK SMALL LETTER ETA"},{"char":"&theta;",desc:"GREEK SMALL LETTER THETA"},{"char":"&iota;",desc:"GREEK SMALL LETTER IOTA"},{"char":"&kappa;",desc:"GREEK SMALL LETTER KAPPA"},{"char":"&lambda;",desc:"GREEK SMALL LETTER LAMBDA"},{"char":"&mu;",desc:"GREEK SMALL LETTER MU"},{"char":"&nu;",desc:"GREEK SMALL LETTER NU"},{"char":"&xi;",desc:"GREEK SMALL LETTER XI"},{"char":"&omicron;",desc:"GREEK SMALL LETTER OMICRON"},{"char":"&pi;",desc:"GREEK SMALL LETTER PI"},{"char":"&rho;",desc:"GREEK SMALL LETTER RHO"},{"char":"&sigmaf;",desc:"GREEK SMALL LETTER FINAL SIGMA"},{"char":"&sigma;",desc:"GREEK SMALL LETTER SIGMA"},{"char":"&tau;",desc:"GREEK SMALL LETTER TAU"},{"char":"&upsilon;",desc:"GREEK SMALL LETTER UPSILON"},{"char":"&phi;",desc:"GREEK SMALL LETTER PHI"},{"char":"&chi;",desc:"GREEK SMALL LETTER CHI"},{"char":"&psi;",desc:"GREEK SMALL LETTER PSI"},{"char":"&omega;",desc:"GREEK SMALL LETTER OMEGA"},{"char":"&thetasym;",desc:"GREEK THETA SYMBOL"},{"char":"&upsih;",desc:"GREEK UPSILON WITH HOOK SYMBOL"},{"char":"&straightphi;",desc:"GREEK PHI SYMBOL"},{"char":"&piv;",desc:"GREEK PI SYMBOL"},{"char":"&Gammad;",desc:"GREEK LETTER DIGAMMA"},{"char":"&gammad;",desc:"GREEK SMALL LETTER DIGAMMA"},{"char":"&varkappa;",desc:"GREEK KAPPA SYMBOL"},{"char":"&varrho;",desc:"GREEK RHO SYMBOL"},{"char":"&straightepsilon;",desc:"GREEK LUNATE EPSILON SYMBOL"},{"char":"&backepsilon;",desc:"GREEK REVERSED LUNATE EPSILON SYMBOL"}]},{title:"Cyrillic","char":"&#x400",list:[{"char":"&#x400",desc:"CYRILLIC CAPITAL LETTER IE WITH GRAVE"},{"char":"&#x401",desc:"CYRILLIC CAPITAL LETTER IO"},{"char":"&#x402",desc:"CYRILLIC CAPITAL LETTER DJE"},{"char":"&#x403",desc:"CYRILLIC CAPITAL LETTER GJE"},{"char":"&#x404",desc:"CYRILLIC CAPITAL LETTER UKRAINIAN IE"},{"char":"&#x405",desc:"CYRILLIC CAPITAL LETTER DZE"},{"char":"&#x406",desc:"CYRILLIC CAPITAL LETTER BYELORUSSIAN-UKRAINIAN I"},{"char":"&#x407",desc:"CYRILLIC CAPITAL LETTER YI"},{"char":"&#x408",desc:"CYRILLIC CAPITAL LETTER JE"},{"char":"&#x409",desc:"CYRILLIC CAPITAL LETTER LJE"},{"char":"&#x40A",desc:"CYRILLIC CAPITAL LETTER NJE"},{"char":"&#x40B",desc:"CYRILLIC CAPITAL LETTER TSHE"},{"char":"&#x40C",desc:"CYRILLIC CAPITAL LETTER KJE"},{"char":"&#x40D",desc:"CYRILLIC CAPITAL LETTER I WITH GRAVE"},{"char":"&#x40E",desc:"CYRILLIC CAPITAL LETTER SHORT U"},{"char":"&#x40F",desc:"CYRILLIC CAPITAL LETTER DZHE"},{"char":"&#x410",desc:"CYRILLIC CAPITAL LETTER A"},{"char":"&#x411",desc:"CYRILLIC CAPITAL LETTER BE"},{"char":"&#x412",desc:"CYRILLIC CAPITAL LETTER VE"},{"char":"&#x413",desc:"CYRILLIC CAPITAL LETTER GHE"},{"char":"&#x414",desc:"CYRILLIC CAPITAL LETTER DE"},{"char":"&#x415",desc:"CYRILLIC CAPITAL LETTER IE"},{"char":"&#x416",desc:"CYRILLIC CAPITAL LETTER ZHE"},{"char":"&#x417",desc:"CYRILLIC CAPITAL LETTER ZE"},{"char":"&#x418",desc:"CYRILLIC CAPITAL LETTER I"},{"char":"&#x419",desc:"CYRILLIC CAPITAL LETTER SHORT I"},{"char":"&#x41A",desc:"CYRILLIC CAPITAL LETTER KA"},{"char":"&#x41B",desc:"CYRILLIC CAPITAL LETTER EL"},{"char":"&#x41C",desc:"CYRILLIC CAPITAL LETTER EM"},{"char":"&#x41D",desc:"CYRILLIC CAPITAL LETTER EN"},{"char":"&#x41E",desc:"CYRILLIC CAPITAL LETTER O"},{"char":"&#x41F",desc:"CYRILLIC CAPITAL LETTER PE"},{"char":"&#x420",desc:"CYRILLIC CAPITAL LETTER ER"},{"char":"&#x421",desc:"CYRILLIC CAPITAL LETTER ES"},{"char":"&#x422",desc:"CYRILLIC CAPITAL LETTER TE"},{"char":"&#x423",desc:"CYRILLIC CAPITAL LETTER U"},{"char":"&#x424",desc:"CYRILLIC CAPITAL LETTER EF"},{"char":"&#x425",desc:"CYRILLIC CAPITAL LETTER HA"},{"char":"&#x426",desc:"CYRILLIC CAPITAL LETTER TSE"},{"char":"&#x427",desc:"CYRILLIC CAPITAL LETTER CHE"},{"char":"&#x428",desc:"CYRILLIC CAPITAL LETTER SHA"},{"char":"&#x429",desc:"CYRILLIC CAPITAL LETTER SHCHA"},{"char":"&#x42A",desc:"CYRILLIC CAPITAL LETTER HARD SIGN"},{"char":"&#x42B",desc:"CYRILLIC CAPITAL LETTER YERU"},{"char":"&#x42C",desc:"CYRILLIC CAPITAL LETTER SOFT SIGN"},{"char":"&#x42D",desc:"CYRILLIC CAPITAL LETTER E"},{"char":"&#x42E",desc:"CYRILLIC CAPITAL LETTER YU"},{"char":"&#x42F",desc:"CYRILLIC CAPITAL LETTER YA"},{"char":"&#x430",desc:"CYRILLIC SMALL LETTER A"},{"char":"&#x431",desc:"CYRILLIC SMALL LETTER BE"},{"char":"&#x432",desc:"CYRILLIC SMALL LETTER VE"},{"char":"&#x433",desc:"CYRILLIC SMALL LETTER GHE"},{"char":"&#x434",desc:"CYRILLIC SMALL LETTER DE"},{"char":"&#x435",desc:"CYRILLIC SMALL LETTER IE"},{"char":"&#x436",desc:"CYRILLIC SMALL LETTER ZHE"},{"char":"&#x437",desc:"CYRILLIC SMALL LETTER ZE"},{"char":"&#x438",desc:"CYRILLIC SMALL LETTER I"},{"char":"&#x439",desc:"CYRILLIC SMALL LETTER SHORT I"},{"char":"&#x43A",desc:"CYRILLIC SMALL LETTER KA"},{"char":"&#x43B",desc:"CYRILLIC SMALL LETTER EL"},{"char":"&#x43C",desc:"CYRILLIC SMALL LETTER EM"},{"char":"&#x43D",desc:"CYRILLIC SMALL LETTER EN"},{"char":"&#x43E",desc:"CYRILLIC SMALL LETTER O"},{"char":"&#x43F",desc:"CYRILLIC SMALL LETTER PE"},{"char":"&#x440",desc:"CYRILLIC SMALL LETTER ER"},{"char":"&#x441",desc:"CYRILLIC SMALL LETTER ES"},{"char":"&#x442",desc:"CYRILLIC SMALL LETTER TE"},{"char":"&#x443",desc:"CYRILLIC SMALL LETTER U"},{"char":"&#x444",desc:"CYRILLIC SMALL LETTER EF"},{"char":"&#x445",desc:"CYRILLIC SMALL LETTER HA"},{"char":"&#x446",desc:"CYRILLIC SMALL LETTER TSE"},{"char":"&#x447",desc:"CYRILLIC SMALL LETTER CHE"},{"char":"&#x448",desc:"CYRILLIC SMALL LETTER SHA"},{"char":"&#x449",desc:"CYRILLIC SMALL LETTER SHCHA"},{"char":"&#x44A",desc:"CYRILLIC SMALL LETTER HARD SIGN"},{"char":"&#x44B",desc:"CYRILLIC SMALL LETTER YERU"},{"char":"&#x44C",desc:"CYRILLIC SMALL LETTER SOFT SIGN"},{"char":"&#x44D",desc:"CYRILLIC SMALL LETTER E"},{"char":"&#x44E",desc:"CYRILLIC SMALL LETTER YU"},{"char":"&#x44F",desc:"CYRILLIC SMALL LETTER YA"},{"char":"&#x450",desc:"CYRILLIC SMALL LETTER IE WITH GRAVE"},{"char":"&#x451",desc:"CYRILLIC SMALL LETTER IO"},{"char":"&#x452",desc:"CYRILLIC SMALL LETTER DJE"},{"char":"&#x453",desc:"CYRILLIC SMALL LETTER GJE"},{"char":"&#x454",desc:"CYRILLIC SMALL LETTER UKRAINIAN IE"},{"char":"&#x455",desc:"CYRILLIC SMALL LETTER DZE"},{"char":"&#x456",desc:"CYRILLIC SMALL LETTER BYELORUSSIAN-UKRAINIAN I"},{"char":"&#x457",desc:"CYRILLIC SMALL LETTER YI"},{"char":"&#x458",desc:"CYRILLIC SMALL LETTER JE"},{"char":"&#x459",desc:"CYRILLIC SMALL LETTER LJE"},{"char":"&#x45A",desc:"CYRILLIC SMALL LETTER NJE"},{"char":"&#x45B",desc:"CYRILLIC SMALL LETTER TSHE"},{"char":"&#x45C",desc:"CYRILLIC SMALL LETTER KJE"},{"char":"&#x45D",desc:"CYRILLIC SMALL LETTER I WITH GRAVE"},{"char":"&#x45E",desc:"CYRILLIC SMALL LETTER SHORT U"},{"char":"&#x45F",desc:"CYRILLIC SMALL LETTER DZHE"}]},{title:"Punctuation","char":"&ndash;",list:[{"char":"&ndash;",desc:"EN DASH"},{"char":"&mdash;",desc:"EM DASH"},{"char":"&lsquo;",desc:"LEFT SINGLE QUOTATION MARK"},{"char":"&rsquo;",desc:"RIGHT SINGLE QUOTATION MARK"},{"char":"&sbquo;",desc:"SINGLE LOW-9 QUOTATION MARK"},{"char":"&ldquo;",desc:"LEFT DOUBLE QUOTATION MARK"},{"char":"&rdquo;",desc:"RIGHT DOUBLE QUOTATION MARK"},{"char":"&bdquo;",desc:"DOUBLE LOW-9 QUOTATION MARK"},{"char":"&dagger;",desc:"DAGGER"},{"char":"&Dagger;",desc:"DOUBLE DAGGER"},{"char":"&bull;",desc:"BULLET"},{"char":"&hellip;",desc:"HORIZONTAL ELLIPSIS"},{"char":"&permil;",desc:"PER MILLE SIGN"},{"char":"&prime;",desc:"PRIME"},{"char":"&Prime;",desc:"DOUBLE PRIME"},{"char":"&lsaquo;",desc:"SINGLE LEFT-POINTING ANGLE QUOTATION MARK"},{"char":"&rsaquo;",desc:"SINGLE RIGHT-POINTING ANGLE QUOTATION MARK"},{"char":"&oline;",desc:"OVERLINE"},{"char":"&frasl;",desc:"FRACTION SLASH"}]},{title:"Currency","char":"&#x20A0",list:[{"char":"&#x20A0",desc:"EURO-CURRENCY SIGN"},{"char":"&#x20A1",desc:"COLON SIGN"},{"char":"&#x20A2",desc:"CRUZEIRO SIGN"},{"char":"&#x20A3",desc:"FRENCH FRANC SIGN"},{"char":"&#x20A4",desc:"LIRA SIGN"},{"char":"&#x20A5",desc:"MILL SIGN"},{"char":"&#x20A6",desc:"NAIRA SIGN"},{"char":"&#x20A7",desc:"PESETA SIGN"},{"char":"&#x20A8",desc:"RUPEE SIGN"},{"char":"&#x20A9",desc:"WON SIGN"},{"char":"&#x20AA",desc:"NEW SHEQEL SIGN"},{"char":"&#x20AB",desc:"DONG SIGN"},{"char":"&#x20AC",desc:"EURO SIGN"},{"char":"&#x20AD",desc:"KIP SIGN"},{"char":"&#x20AE",desc:"TUGRIK SIGN"},{"char":"&#x20AF",desc:"DRACHMA SIGN"},{"char":"&#x20B0",desc:"GERMAN PENNY SYMBOL"},{"char":"&#x20B1",desc:"PESO SIGN"},{"char":"&#x20B2",desc:"GUARANI SIGN"},{"char":"&#x20B3",desc:"AUSTRAL SIGN"},{"char":"&#x20B4",desc:"HRYVNIA SIGN"},{"char":"&#x20B5",desc:"CEDI SIGN"},{"char":"&#x20B6",desc:"LIVRE TOURNOIS SIGN"},{"char":"&#x20B7",desc:"SPESMILO SIGN"},{"char":"&#x20B8",desc:"TENGE SIGN"},{"char":"&#x20B9",desc:"INDIAN RUPEE SIGN"}]},{title:"Arrows","char":"&#x2190",list:[{"char":"&#x2190",desc:"LEFTWARDS ARROW"},{"char":"&#x2191",desc:"UPWARDS ARROW"},{"char":"&#x2192",desc:"RIGHTWARDS ARROW"},{"char":"&#x2193",desc:"DOWNWARDS ARROW"},{"char":"&#x2194",desc:"LEFT RIGHT ARROW"},{"char":"&#x2195",desc:"UP DOWN ARROW"},{"char":"&#x2196",desc:"NORTH WEST ARROW"},{"char":"&#x2197",desc:"NORTH EAST ARROW"},{"char":"&#x2198",desc:"SOUTH EAST ARROW"},{"char":"&#x2199",desc:"SOUTH WEST ARROW"},{"char":"&#x219A",desc:"LEFTWARDS ARROW WITH STROKE"},{"char":"&#x219B",desc:"RIGHTWARDS ARROW WITH STROKE"},{"char":"&#x219C",desc:"LEFTWARDS WAVE ARROW"},{"char":"&#x219D",desc:"RIGHTWARDS WAVE ARROW"},{"char":"&#x219E",desc:"LEFTWARDS TWO HEADED ARROW"},{"char":"&#x219F",desc:"UPWARDS TWO HEADED ARROW"},{"char":"&#x21A0",desc:"RIGHTWARDS TWO HEADED ARROW"},{"char":"&#x21A1",desc:"DOWNWARDS TWO HEADED ARROW"},{"char":"&#x21A2",desc:"LEFTWARDS ARROW WITH TAIL"},{"char":"&#x21A3",desc:"RIGHTWARDS ARROW WITH TAIL"},{"char":"&#x21A4",desc:"LEFTWARDS ARROW FROM BAR"},{"char":"&#x21A5",desc:"UPWARDS ARROW FROM BAR"},{"char":"&#x21A6",desc:"RIGHTWARDS ARROW FROM BAR"},{"char":"&#x21A7",desc:"DOWNWARDS ARROW FROM BAR"},{"char":"&#x21A8",desc:"UP DOWN ARROW WITH BASE"},{"char":"&#x21A9",desc:"LEFTWARDS ARROW WITH HOOK"},{"char":"&#x21AA",desc:"RIGHTWARDS ARROW WITH HOOK"},{"char":"&#x21AB",desc:"LEFTWARDS ARROW WITH LOOP"},{"char":"&#x21AC",desc:"RIGHTWARDS ARROW WITH LOOP"},{"char":"&#x21AD",desc:"LEFT RIGHT WAVE ARROW"},{"char":"&#x21AE",desc:"LEFT RIGHT ARROW WITH STROKE"},{"char":"&#x21AF",desc:"DOWNWARDS ZIGZAG ARROW"},{"char":"&#x21B0",desc:"UPWARDS ARROW WITH TIP LEFTWARDS"},{"char":"&#x21B1",desc:"UPWARDS ARROW WITH TIP RIGHTWARDS"},{"char":"&#x21B2",desc:"DOWNWARDS ARROW WITH TIP LEFTWARDS"},{"char":"&#x21B3",desc:"DOWNWARDS ARROW WITH TIP RIGHTWARDS"},{"char":"&#x21B4",desc:"RIGHTWARDS ARROW WITH CORNER DOWNWARDS"},{"char":"&#x21B5",desc:"DOWNWARDS ARROW WITH CORNER LEFTWARDS"},{"char":"&#x21B6",desc:"ANTICLOCKWISE TOP SEMICIRCLE ARROW"},{"char":"&#x21B7",desc:"CLOCKWISE TOP SEMICIRCLE ARROW"},{"char":"&#x21B8",desc:"NORTH WEST ARROW TO LONG BAR"},{"char":"&#x21B9",desc:"LEFTWARDS ARROW TO BAR OVER RIGHTWARDS ARROW TO BAR"},{"char":"&#x21BA",desc:"ANTICLOCKWISE OPEN CIRCLE ARROW"},{"char":"&#x21BB",desc:"CLOCKWISE OPEN CIRCLE ARROW"},{"char":"&#x21BC",desc:"LEFTWARDS HARPOON WITH BARB UPWARDS"},{"char":"&#x21BD",desc:"LEFTWARDS HARPOON WITH BARB DOWNWARDS"},{"char":"&#x21BE",desc:"UPWARDS HARPOON WITH BARB RIGHTWARDS"},{"char":"&#x21BF",desc:"UPWARDS HARPOON WITH BARB LEFTWARDS"},{"char":"&#x21C0",desc:"RIGHTWARDS HARPOON WITH BARB UPWARDS"},{"char":"&#x21C1",desc:"RIGHTWARDS HARPOON WITH BARB DOWNWARDS"},{"char":"&#x21C2",desc:"DOWNWARDS HARPOON WITH BARB RIGHTWARDS"},{"char":"&#x21C3",desc:"DOWNWARDS HARPOON WITH BARB LEFTWARDS"},{"char":"&#x21C4",desc:"RIGHTWARDS ARROW OVER LEFTWARDS ARROW"},{"char":"&#x21C5",desc:"UPWARDS ARROW LEFTWARDS OF DOWNWARDS ARROW"},{"char":"&#x21C6",desc:"LEFTWARDS ARROW OVER RIGHTWARDS ARROW"},{"char":"&#x21C7",desc:"LEFTWARDS PAIRED ARROWS"},{"char":"&#x21C8",desc:"UPWARDS PAIRED ARROWS"},{"char":"&#x21C9",desc:"RIGHTWARDS PAIRED ARROWS"},{"char":"&#x21CA",desc:"DOWNWARDS PAIRED ARROWS"},{"char":"&#x21CB",desc:"LEFTWARDS HARPOON OVER RIGHTWARDS HARPOON"},{"char":"&#x21CC",desc:"RIGHTWARDS HARPOON OVER LEFTWARDS HARPOON"},{"char":"&#x21CD",desc:"LEFTWARDS DOUBLE ARROW WITH STROKE"},{"char":"&#x21CE",desc:"LEFT RIGHT DOUBLE ARROW WITH STROKE"},{"char":"&#x21CF",desc:"RIGHTWARDS DOUBLE ARROW WITH STROKE"},{"char":"&#x21D0",desc:"LEFTWARDS DOUBLE ARROW"},{"char":"&#x21D1",desc:"UPWARDS DOUBLE ARROW"},{"char":"&#x21D2",desc:"RIGHTWARDS DOUBLE ARROW"},{"char":"&#x21D3",desc:"DOWNWARDS DOUBLE ARROW"},{"char":"&#x21D4",desc:"LEFT RIGHT DOUBLE ARROW"},{"char":"&#x21D5",desc:"UP DOWN DOUBLE ARROW"},{"char":"&#x21D6",desc:"NORTH WEST DOUBLE ARROW"},{"char":"&#x21D7",desc:"NORTH EAST DOUBLE ARROW"},{"char":"&#x21D8",desc:"SOUTH EAST DOUBLE ARROW"},{"char":"&#x21D9",desc:"SOUTH WEST DOUBLE ARROW"},{"char":"&#x21DA",desc:"LEFTWARDS TRIPLE ARROW"},{"char":"&#x21DB",desc:"RIGHTWARDS TRIPLE ARROW"},{"char":"&#x21DC",desc:"LEFTWARDS SQUIGGLE ARROW"},{"char":"&#x21DD",desc:"RIGHTWARDS SQUIGGLE ARROW"},{"char":"&#x21DE",desc:"UPWARDS ARROW WITH DOUBLE STROKE"},{"char":"&#x21DF",desc:"DOWNWARDS ARROW WITH DOUBLE STROKE"},{"char":"&#x21E0",desc:"LEFTWARDS DASHED ARROW"},{"char":"&#x21E1",desc:"UPWARDS DASHED ARROW"},{"char":"&#x21E2",desc:"RIGHTWARDS DASHED ARROW"},{"char":"&#x21E3",desc:"DOWNWARDS DASHED ARROW"},{"char":"&#x21E4",desc:"LEFTWARDS ARROW TO BAR"},{"char":"&#x21E5",desc:"RIGHTWARDS ARROW TO BAR"},{"char":"&#x21E6",desc:"LEFTWARDS WHITE ARROW"},{"char":"&#x21E7",desc:"UPWARDS WHITE ARROW"},{"char":"&#x21E8",desc:"RIGHTWARDS WHITE ARROW"},{"char":"&#x21E9",desc:"DOWNWARDS WHITE ARROW"},{"char":"&#x21EA",desc:"UPWARDS WHITE ARROW FROM BAR"},{"char":"&#x21EB",desc:"UPWARDS WHITE ARROW ON PEDESTAL"},{"char":"&#x21EC",desc:"UPWARDS WHITE ARROW ON PEDESTAL WITH HORIZONTAL BAR"},{"char":"&#x21ED",desc:"UPWARDS WHITE ARROW ON PEDESTAL WITH VERTICAL BAR"},{"char":"&#x21EE",desc:"UPWARDS WHITE DOUBLE ARROW"},{"char":"&#x21EF",desc:"UPWARDS WHITE DOUBLE ARROW ON PEDESTAL"},{"char":"&#x21F0",desc:"RIGHTWARDS WHITE ARROW FROM WALL"},{"char":"&#x21F1",desc:"NORTH WEST ARROW TO CORNER"},{"char":"&#x21F2",desc:"SOUTH EAST ARROW TO CORNER"},{"char":"&#x21F3",desc:"UP DOWN WHITE ARROW"},{"char":"&#x21F4",desc:"RIGHT ARROW WITH SMALL CIRCLE"},{"char":"&#x21F5",desc:"DOWNWARDS ARROW LEFTWARDS OF UPWARDS ARROW"},{"char":"&#x21F6",desc:"THREE RIGHTWARDS ARROWS"},{"char":"&#x21F7",desc:"LEFTWARDS ARROW WITH VERTICAL STROKE"},{"char":"&#x21F8",desc:"RIGHTWARDS ARROW WITH VERTICAL STROKE"},{"char":"&#x21F9",desc:"LEFT RIGHT ARROW WITH VERTICAL STROKE"},{"char":"&#x21FA",desc:"LEFTWARDS ARROW WITH DOUBLE VERTICAL STROKE"},{"char":"&#x21FB",desc:"RIGHTWARDS ARROW WITH DOUBLE VERTICAL STROKE"},{"char":"&#x21FC",desc:"LEFT RIGHT ARROW WITH DOUBLE VERTICAL STROKE"},{"char":"&#x21FD",desc:"LEFTWARDS OPEN-HEADED ARROW"},{"char":"&#x21FE",desc:"RIGHTWARDS OPEN-HEADED ARROW"},{"char":"&#x21FF",desc:"LEFT RIGHT OPEN-HEADED ARROW"}]},{title:"Math","char":"&forall;",list:[{"char":"&forall;",desc:"FOR ALL"},{"char":"&part;",desc:"PARTIAL DIFFERENTIAL"},{"char":"&exist;",desc:"THERE EXISTS"},{"char":"&empty;",desc:"EMPTY SET"},{"char":"&nabla;",desc:"NABLA"},{"char":"&isin;",desc:"ELEMENT OF"},{"char":"&notin;",desc:"NOT AN ELEMENT OF"},{"char":"&ni;",desc:"CONTAINS AS MEMBER"},{"char":"&prod;",desc:"N-ARY PRODUCT"},{"char":"&sum;",desc:"N-ARY SUMMATION"},{"char":"&minus;",desc:"MINUS SIGN"},{"char":"&lowast;",desc:"ASTERISK OPERATOR"},{"char":"&radic;",desc:"SQUARE ROOT"},{"char":"&prop;",desc:"PROPORTIONAL TO"},{"char":"&infin;",desc:"INFINITY"},{"char":"&ang;",desc:"ANGLE"},{"char":"&and;",desc:"LOGICAL AND"},{"char":"&or;",desc:"LOGICAL OR"},{"char":"&cap;",desc:"INTERSECTION"},{"char":"&cup;",desc:"UNION"},{"char":"&int;",desc:"INTEGRAL"},{"char":"&there4;",desc:"THEREFORE"},{"char":"&sim;",desc:"TILDE OPERATOR"},{"char":"&cong;",desc:"APPROXIMATELY EQUAL TO"},{"char":"&asymp;",desc:"ALMOST EQUAL TO"},{"char":"&ne;",desc:"NOT EQUAL TO"},{"char":"&equiv;",desc:"IDENTICAL TO"},{"char":"&le;",desc:"LESS-THAN OR EQUAL TO"},{"char":"&ge;",desc:"GREATER-THAN OR EQUAL TO"},{"char":"&sub;",desc:"SUBSET OF"},{"char":"&sup;",desc:"SUPERSET OF"},{"char":"&nsub;",desc:"NOT A SUBSET OF"},{"char":"&sube;",desc:"SUBSET OF OR EQUAL TO"},{"char":"&supe;",desc:"SUPERSET OF OR EQUAL TO"},{"char":"&oplus;",desc:"CIRCLED PLUS"},{"char":"&otimes;",desc:"CIRCLED TIMES"},{"char":"&perp;",desc:"UP TACK"}]},{title:"Misc","char":"&spades;",list:[{"char":"&spades;",desc:"BLACK SPADE SUIT"},{"char":"&clubs;",desc:"BLACK CLUB SUIT"},{"char":"&hearts;",desc:"BLACK HEART SUIT"},{"char":"&diams;",desc:"BLACK DIAMOND SUIT"},{"char":"&#x2669",desc:"QUARTER NOTE"},{"char":"&#x266A",desc:"EIGHTH NOTE"},{"char":"&#x266B",desc:"BEAMED EIGHTH NOTES"},{"char":"&#x266C",desc:"BEAMED SIXTEENTH NOTES"},{"char":"&#x266D",desc:"MUSIC FLAT SIGN"},{"char":"&#x266E",desc:"MUSIC NATURAL SIGN"},{"char":"&#x2600",desc:"BLACK SUN WITH RAYS"},{"char":"&#x2601",desc:"CLOUD"},{"char":"&#x2602",desc:"UMBRELLA"},{"char":"&#x2603",desc:"SNOWMAN"},{"char":"&#x2615",desc:"HOT BEVERAGE"},{"char":"&#x2618",desc:"SHAMROCK"},{"char":"&#x262F",desc:"YIN YANG"},{"char":"&#x2714",desc:"HEAVY CHECK MARK"},{"char":"&#x2716",desc:"HEAVY MULTIPLICATION X"},{"char":"&#x2744",desc:"SNOWFLAKE"},{"char":"&#x275B",desc:"HEAVY SINGLE TURNED COMMA QUOTATION MARK ORNAMENT"},{"char":"&#x275C",desc:"HEAVY SINGLE COMMA QUOTATION MARK ORNAMENT"},{"char":"&#x275D",desc:"HEAVY DOUBLE TURNED COMMA QUOTATION MARK ORNAMENT"},{"char":"&#x275E",desc:"HEAVY DOUBLE COMMA QUOTATION MARK ORNAMENT"},{"char":"&#x2764",desc:"HEAVY BLACK HEART"}]}],specialCharButtons:["specialCharBack","|"]}),Object.assign(St.POPUP_TEMPLATES,{specialCharacters:"[_BUTTONS_][_CUSTOM_LAYER_]"}),St.PLUGINS.specialCharacters=function(E){var _=E.$,e=E.opts.specialCharactersSets,r=E.opts.specialCharactersSets[0],o="";function s(){return'\n        <div class="fr-buttons fr-tabs fr-tabs-scroll">\n          '.concat(function t(e,a){var n="";return e.forEach(function(e){var t={elementClass:e.title===a.title?"fr-active fr-active-tab":"",title:e.title,dataParam1:e.title,desc:e["char"]};n+='<button class="fr-command fr-btn fr-special-character-category '.concat(t.elementClass,'" title="').concat(t.title,'" data-cmd="setSpecialCharacterCategory" data-param1="').concat(t.dataParam1,'"><span>').concat(t.desc,"</span></button>")}),n}(e,r),'\n        </div>\n        <div class="fr-icon-container fr-sc-container" style="outline: none;">\n          ').concat(function n(e){var a="";return e.list.forEach(function(e){var t={dataParam1:e["char"],title:e.desc,splCharValue:e["char"]};a+='<span class="fr-command fr-special-character fr-icon" role="button" \n      data-cmd="insertSpecialCharacter" data-param1="'.concat(t.dataParam1,'" tabindex="0"\n      title="').concat(t.title,'">').concat(t.splCharValue,"</span>")}),a}(r),"\n        </div>")}return{setSpecialCharacterCategory:function n(t){r=e.filter(function(e){return e.title===t})[0],function a(){E.popups.get("specialCharacters").html(o+s());var e=E.popups.get("specialCharacters").children().not(".fr-buttons");E.accessibility.registerPopup("specialCharacters"),E.accessibility.focusContent(e)}()},showSpecialCharsPopup:function l(){var e=E.popups.get("specialCharacters");if(e||(e=function i(){E.opts.toolbarInline&&0<E.opts.specialCharButtons.length&&(o='<div class="fr-buttons fr-tabs">'.concat(E.button.buildList(E.opts.specialCharButtons),"</div>"));var e={buttons:o,custom_layer:s()},t=E.popups.create("specialCharacters",e);return function a(b){E.events.on("popup.tab",function(e){var t=_(e.currentTarget);if(!E.popups.isVisible("specialCharacters")||!t.is("span, a"))return!0;var a,n,r,i=e.which,o=window.getComputedStyle(b.find(".fr-icon-container")[0]),s=o.getPropertyValue("grid-template-columns").split(" ").length;if(St.KEYCODE.TAB==i){var l=b.find("span.fr-special-character");if(t.is(l.first())&&e.shiftKey||t.is(l.last())&&!e.shiftKey){var c=b.find(".fr-buttons");a=!E.accessibility.focusToolbar(c,!!e.shiftKey)}if(!1!==a){var d=b.find("span.fr-special-character");d.add(b.find("button.fr-btn")),n=d.index(t),n=e.shiftKey?((n-1)%d.length+d.length)%d.length:(n+1)%d.length,r=d.get(n),E.events.disableBlur(),r.focus(),a=!1}}else if(St.KEYCODE.ARROW_UP==i||St.KEYCODE.ARROW_DOWN==i||St.KEYCODE.ARROW_LEFT==i||St.KEYCODE.ARROW_RIGHT==i){if(t.is("span.fr-icon")){var f=t.parent().find("span.fr-icon");n=f.index(t);var p=s,u=Math.ceil(f.length/p),g=n%p,h=Math.floor(n/p),m=h*p+g,v=u*p;St.KEYCODE.ARROW_UP==i?m=((m-p)%v+v)%v:St.KEYCODE.ARROW_DOWN==i?m=(m+p)%v:St.KEYCODE.ARROW_LEFT==i?m=((m-1)%v+v)%v:St.KEYCODE.ARROW_RIGHT==i&&(m=(m+1)%v),r=_(f.get(m)),E.events.disableBlur(),r.focus(),a=!1}}else St.KEYCODE.ENTER==i&&(t.is("a")?t[0].click():E.button.exec(t),a=!1);return!1===a&&(e.preventDefault(),e.stopPropagation()),a},!0)}(t),t}()),!e.hasClass("fr-active")){E.popups.refresh("specialCharacters"),E.popups.setContainer("specialCharacters",E.$tb);var t=E.$tb.find('.fr-command[data-cmd="specialCharacters"]'),a=E.button.getPosition(t),n=a.left,r=a.top;E.popups.show("specialCharacters",n,r,outerHeight)}},back:function t(){E.popups.hide("specialCharacters"),E.toolbar.showInline()}}},St.DefineIcon("specialCharacters",{NAME:"dollar-sign",SVG_KEY:"symbols"}),St.RegisterCommand("specialCharacters",{title:"Special Characters",icon:"specialCharacters",undo:!1,focus:!1,popup:!0,refreshAfterCallback:!1,plugin:"specialCharacters",showOnMobile:!0,callback:function(){this.popups.isVisible("specialCharacters")?(this.$el.find(".fr-marker")&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("specialCharacters")):this.specialCharacters.showSpecialCharsPopup()}}),St.RegisterCommand("insertSpecialCharacter",{callback:function(e,t){this.undo.saveStep(),this.html.insert(t),this.undo.saveStep(),this.popups.hide("specialCharacters")}}),St.RegisterCommand("setSpecialCharacterCategory",{undo:!1,focus:!1,callback:function(e,t){this.specialCharacters.setSpecialCharacterCategory(t)}}),St.DefineIcon("specialCharBack",{NAME:"arrow-left",SVG_KEY:"back"}),St.RegisterCommand("specialCharBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.specialCharacters.back()}}),Object.assign(St.POPUP_TEMPLATES,{"table.insert":"[_BUTTONS_][_ROWS_COLUMNS_]","table.edit":"[_BUTTONS_]","table.colors":"[_BUTTONS_][_COLORS_][_CUSTOM_COLOR_]"}),Object.assign(St.DEFAULTS,{tableInsertMaxSize:10,tableEditButtons:["tableHeader","tableFooter","tableRemove","tableRows","tableColumns","tableStyle","-","tableCells","tableCellBackground","tableCellVerticalAlign","tableCellHorizontalAlign","tableCellStyle"],tableInsertButtons:["tableBack","|"],tableResizer:!0,tableDefaultWidth:"100%",tableResizerOffset:5,tableResizingLimit:30,tableColorsButtons:["tableBack","|"],tableColors:["#61BD6D","#1ABC9C","#54ACD2","#2C82C9","#9365B8","#475577","#CCCCCC","#41A85F","#00A885","#3D8EB9","#2969B0","#553982","#28324E","#000000","#F7DA64","#FBA026","#EB6B56","#E25041","#A38F84","#EFEFEF","#FFFFFF","#FAC51C","#F37934","#D14841","#B8312F","#7C706B","#D1D5D8","REMOVE"],tableColorsStep:7,tableCellStyles:{"fr-highlighted":"Highlighted","fr-thick":"Thick"},tableStyles:{"fr-dashed-borders":"Dashed Borders","fr-alternate-rows":"Alternate Rows"},tableCellMultipleStyles:!0,tableMultipleStyles:!0,tableInsertHelper:!0,keepTextFormatOnTable:!1,tableInsertHelperOffset:15}),St.PLUGINS.table=function(C){var T,c,r,i,n,o,y,k=C.$;function h(){var e=S();if(e){var t=C.popups.get("table.edit");if(t||(t=p()),t){C.popups.setContainer("table.edit",C.$sc);var a=M(e),n=a.left+(a.right-a.left)/2,r=a.bottom;C.popups.show("table.edit",n,r,a.bottom-a.top,!0),C.edit.isDisabled()&&(C.$el.removeClass("fr-no-selection"),C.edit.on(),C.button.bulkRefresh(),C.selection.setAtEnd(C.$el.find(".fr-selected-cell").last().get(0)),C.selection.restore())}}}function s(){var e=S();if(e){var t=C.popups.get("table.colors");t||(t=function o(){var e="";0<C.opts.tableColorsButtons.length&&(e='<div class="fr-buttons fr-tabs">'.concat(C.button.buildList(C.opts.tableColorsButtons),"</div>"));var t="";C.opts.colorsHEXInput&&(t='<div class="fr-color-hex-layer fr-table-colors-hex-layer fr-active fr-layer" id="fr-table-colors-hex-layer-'.concat(C.id,'"><div class="fr-input-line"><input maxlength="7" id="fr-table-colors-hex-layer-text-').concat(C.id,'" type="text" placeholder="').concat(C.language.translate("HEX Color"),'" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="tableCellBackgroundCustomColor" tabIndex="2" role="button">').concat(C.language.translate("OK"),"</button></div></div>"));var a={buttons:e,colors:function r(){for(var e='<div class="fr-color-set fr-table-colors">',t=0;t<C.opts.tableColors.length;t++)0!==t&&t%C.opts.tableColorsStep==0&&(e+="<br>"),"REMOVE"!=C.opts.tableColors[t]?e+='<span class="fr-command" style="background: '.concat(C.opts.tableColors[t],';" tabIndex="-1" role="button" data-cmd="tableCellBackgroundColor" data-param1="').concat(C.opts.tableColors[t],'"><span class="fr-sr-only">').concat(C.language.translate("Color")," ").concat(C.opts.tableColors[t],"&nbsp;&nbsp;&nbsp;</span></span>"):e+='<span class="fr-command" data-cmd="tableCellBackgroundColor" tabIndex="-1" role="button" data-param1="REMOVE" title="'.concat(C.language.translate("Clear Formatting"),'">').concat(C.icon.create("tableColorRemove"),'<span class="fr-sr-only">').concat(C.language.translate("Clear Formatting"),"</span></span>");return e+="</div>"}(),custom_color:t},n=C.popups.create("table.colors",a);return C.events.$on(C.$wp,"scroll.table-colors",function(){C.popups.isVisible("table.colors")&&s()}),function i(g){C.events.on("popup.tab",function(e){var t=k(e.currentTarget);if(!C.popups.isVisible("table.colors")||!t.is("span"))return!0;var a=e.which,n=!0;if(St.KEYCODE.TAB==a){var r=g.find(".fr-buttons");n=!C.accessibility.focusToolbar(r,!!e.shiftKey)}else if(St.KEYCODE.ARROW_UP==a||St.KEYCODE.ARROW_DOWN==a||St.KEYCODE.ARROW_LEFT==a||St.KEYCODE.ARROW_RIGHT==a){var i=t.parent().find("span.fr-command"),o=i.index(t),s=C.opts.colorsStep,l=Math.floor(i.length/s),c=o%s,d=Math.floor(o/s),f=d*s+c,p=l*s;St.KEYCODE.ARROW_UP==a?f=((f-s)%p+p)%p:St.KEYCODE.ARROW_DOWN==a?f=(f+s)%p:St.KEYCODE.ARROW_LEFT==a?f=((f-1)%p+p)%p:St.KEYCODE.ARROW_RIGHT==a&&(f=(f+1)%p);var u=k(i.get(f));C.events.disableBlur(),u.focus(),n=!1}else St.KEYCODE.ENTER==a&&(C.button.exec(t),n=!1);return!1===n&&(e.preventDefault(),e.stopPropagation()),n},!0)}(n),n}()),C.popups.setContainer("table.colors",C.$sc);var a=M(e),n=(a.left+a.right)/2,r=a.bottom;!function i(){var e=C.popups.get("table.colors"),t=C.$el.find(".fr-selected-cell").first(),a=C.helpers.RGBToHex(t.css("background-color")),n=e.find(".fr-table-colors-hex-layer input");e.find(".fr-selected-color").removeClass("fr-selected-color fr-active-item"),e.find('span[data-param1="'.concat(a,'"]')).addClass("fr-selected-color fr-active-item"),n.val(a).trigger("change")}(),C.popups.show("table.colors",n,r,a.bottom-a.top,!0)}}function l(){0===te().length&&C.toolbar.enable()}function d(e){if(e)return C.popups.onHide("table.insert",function(){C.popups.get("table.insert").find('.fr-table-size .fr-select-table-size > span[data-row="1"][data-col="1"]').trigger("mouseover")}),!0;var t="";0<C.opts.tableInsertButtons.length&&(t='<div class="fr-buttons fr-tabs">'.concat(C.button.buildList(C.opts.tableInsertButtons),"</div>"));var a={buttons:t,rows_columns:function i(){for(var e='<div class="fr-table-size"><div class="fr-table-size-info">1 &times; 1</div><div class="fr-select-table-size">',t=1;t<=C.opts.tableInsertMaxSize;t++){for(var a=1;a<=C.opts.tableInsertMaxSize;a++){var n="inline-block";2<t&&!C.helpers.isMobile()&&(n="none");var r="fr-table-cell ";1==t&&1==a&&(r+=" hover"),e+='<span class="fr-command '.concat(r,'" tabIndex="-1" data-cmd="tableInsert" data-row="').concat(t,'" data-col="').concat(a,'" data-param1="').concat(t,'" data-param2="').concat(a,'" style="display: ').concat(n,';" role="button"><span></span><span class="fr-sr-only">').concat(t," &times; ").concat(a,"&nbsp;&nbsp;&nbsp;</span></span>")}e+='<div class="new-line"></div>'}return e+="</div></div>"}()},n=C.popups.create("table.insert",a);return C.events.$on(n,"mouseover",".fr-table-size .fr-select-table-size .fr-table-cell",function(e){f(k(e.currentTarget))},!0),function r(e){C.events.$on(e,"focus","[tabIndex]",function(e){var t=k(e.currentTarget);f(t)}),C.events.on("popup.tab",function(e){var t=k(e.currentTarget);if(!C.popups.isVisible("table.insert")||!t.is("span, a"))return!0;var a,n=e.which;if(St.KEYCODE.ARROW_UP==n||St.KEYCODE.ARROW_DOWN==n||St.KEYCODE.ARROW_LEFT==n||St.KEYCODE.ARROW_RIGHT==n){if(t.is("span.fr-table-cell")){var r=t.parent().find("span.fr-table-cell"),i=r.index(t),o=C.opts.tableInsertMaxSize,s=i%o,l=Math.floor(i/o);St.KEYCODE.ARROW_UP==n?l=Math.max(0,l-1):St.KEYCODE.ARROW_DOWN==n?l=Math.min(C.opts.tableInsertMaxSize-1,l+1):St.KEYCODE.ARROW_LEFT==n?s=Math.max(0,s-1):St.KEYCODE.ARROW_RIGHT==n&&(s=Math.min(C.opts.tableInsertMaxSize-1,s+1));var c=l*o+s,d=k(r.get(c));f(d),C.events.disableBlur(),d.focus(),a=!1}}else St.KEYCODE.ENTER==n&&(C.button.exec(t),a=!1);return!1===a&&(e.preventDefault(),e.stopPropagation()),a},!0)}(n),n}function f(e){var t=e.data("row");null!==t&&(t=parseInt(t));var a=e.data("col");null!==a&&(a=parseInt(a));var n=e.parent();n.siblings(".fr-table-size-info").html("".concat(t," &times; ").concat(a)),n.find("> span").removeClass("hover fr-active-item");for(var r=1;r<=C.opts.tableInsertMaxSize;r++)for(var i=0;i<=C.opts.tableInsertMaxSize;i++){var o=n.find('> span[data-row="'.concat(r,'"][data-col="').concat(i,'"]'));r<=t&&i<=a?o.addClass("hover"):r<=t+1||r<=2&&!C.helpers.isMobile()?o.css("display","inline-block"):2<r&&!C.helpers.isMobile()&&o.css("display","none")}e.addClass("fr-active-item")}function p(e){if(e)return C.popups.onHide("table.edit",l),!0;if(0<C.opts.tableEditButtons.length){var t={buttons:'<div class="fr-buttons">'.concat(C.button.buildList(C.opts.tableEditButtons),"</div>")},a=C.popups.create("table.edit",t);return C.events.$on(C.$wp,"scroll.table-edit",function(){C.popups.isVisible("table.edit")&&h()}),a}return!1}function m(e){var t={startTag:"",closeTag:""};return C.opts.keepTextFormatOnTable&&(t=u(function s(e){var t=new Set,a=e.textContent,n=0,r=[e.firstChild];for(;0<r.length;){var i=r.pop();if(i&&(t.has(i)||(0===n&&a!==i.textContent&&(a=i.textContent,n++),t.add(i)),i.hasChildNodes()))for(var o=0;o<i.childNodes.length;){if(3===i.childNodes[o].nodeType)return ye(t);if(i.childNodes[o].textContent){if(0===n&&i.childNodes[o].textContent!==a){a=i.childNodes[o].textContent,r.push(i.childNodes[o]),n++;break}i.childNodes[o].textContent===a&&r.push(i.childNodes[o])}o++}}return ye(t)}(e).reverse())),{startTag:t.startTag,closeTag:t.closeTag}}function u(e){var t="",a="",n=["br","#text","#comment","font"];if(0<e.length)for(var r=e.length-1;0<=r;r--){var i=e[r],o=C.node.isBlock(i),s=n.indexOf(i.nodeName.toLowerCase());if(!o&&s<0){var l=i.style,c="";if(l&&l.length){for(var d=0;d<l.length;d++)c+=l[d]+": "+l[l[d]].replace(/"/gi,"")+"; ";c=c.trim()}t+=c?"<"+i.nodeName.toLowerCase()+' style="'+c+'">':"<"+i.nodeName.toLowerCase()+">",a="</"+i.nodeName.toLowerCase()+">"+a}}return{startTag:t,closeTag:a}}function g(){if(0<te().length){var e=ae();C.selection.setBefore(e.get(0))||C.selection.setAfter(e.get(0)),C.selection.restore(),C.popups.hide("table.edit"),C.opts.trackChangesEnabled?(C.track_changes.removedTable(e),I()):e.remove(),C.toolbar.enable()}}function v(e){var t=ae();if(0<t.length){if(0<C.$el.find("thead .fr-selected-cell").length&&"above"==e||0<C.$el.find("tfoot td.fr-selected-cell").length&&"below"==e)return;var a,n,r,i=S(),o=F(i);if(null==o)return;n="above"==e?o.min_i:o.max_i;var s="<tr>";for(a=0;a<i[n].length;a++)if("below"==e&&n<i.length-1&&i[n][a]==i[n+1][a]||"above"==e&&0<n&&i[n][a]==i[n-1][a]){if(0===a||0<a&&i[n][a]!=i[n][a-1]){var l=k(i[n][a]);l.attr("rowspan",parseInt(l.attr("rowspan"),10)+1)}}else{var c=k(i[n][a]);if("TH"==c.attr("tagName").toUpperCase())s+='<th style="'+c.attr("style")+'" ><br></th>';else{var d=m(i[n][a]);s+='<td style="'+c.attr("style")+'" >'+d.startTag+"<br>"+d.closeTag+"</td>"}}s+="</tr>",r=0<C.$el.find("thead .fr-selected-cell").length&&"below"==e||0<C.$el.find("tfoot td.fr-selected-cell").length&&"above"==e?k(t.find("tbody").not(t.find("> table tbody"))):k(t.find("tr").not(t.find("> table tr")).get(n)),"below"==e?"TBODY"==r.attr("tagName")?r.prepend(s):r[0].parentNode&&r[0].insertAdjacentHTML("afterend",s):"above"==e&&("TBODY"==r.attr("tagName")?r.append(s):r.before(s),C.popups.isVisible("table.edit")&&h())}}function b(e,t,a){var n,r,i,o,s,l=0,c=S(a);if(e<(t=Math.min(t,c[0].length-1)))for(r=e;r<=t;r++)if(!(e<r&&c[0][r]==c[0][r-1])&&1<(o=Math.min(parseInt(c[0][r].getAttribute("colspan"),10)||1,t-e+1))&&c[0][r]==c[0][r+1])for(l=o-1,n=1;n<c.length;n++)if(c[n][r]!=c[n-1][r]){for(i=r;i<r+o;i++)if(c[n][i]!==undefined)if(1<(s=parseInt(c[n][i].getAttribute("colspan"),10)||1)&&c[n][i]==c[n][i+1])i+=l=Math.min(l,s-1);else if(!(l=Math.max(0,l-1)))break;if(!l)break}l&&_(c,l,"colspan",0,c.length-1,e,t)}function E(e,t,a){var n,r,i,o,s,l=0,c=S(a);if(e<(t=Math.min(t,c.length-1)))for(n=e;n<=t;n++)if(!(e<n&&c[n][0]==c[n-1][0])&&c[n][0]!==undefined&&1<(o=Math.min(parseInt(c[n][0].getAttribute("rowspan"),10)||1,t-e+1))&&c[n][0]==c[n+1][0])for(l=o-1,r=1;r<c[0].length;r++)if(c[n][r]!=c[n][r-1]){for(i=n;i<n+o;i++)if(c[i][r]!==undefined)if(1<(s=parseInt(c[i][r].getAttribute("rowspan"),10)||1)&&c[i][r]==c[i+1][r])i+=l=Math.min(l,s-1);else if(!(l=Math.max(0,l-1)))break;if(!l)break}l&&_(c,l,"rowspan",e,t,0,c[0].length-1)}function _(e,t,a,n,r,i,o){var s,l,c;for(s=n;s<=r;s++)for(l=i;l<=o;l++)n<s&&e[s][l]==e[s-1][l]||i<l&&e[s][l]==e[s][l-1]||e[s][l]!==undefined&&1<(c=parseInt(e[s][l].getAttribute(a),10)||1)&&(1<c-t?e[s][l].setAttribute(a,c-t):e[s][l].removeAttribute(a))}function w(e,t,a,n,r){E(e,t,r),b(a,n,r)}function t(e){var t=C.$el.find(".fr-selected-cell");"REMOVE"!=e?t.css("background-color",C.helpers.HEXtoRGB(e)):t.css("background-color",""),h()}function A(e){e.style.removeProperty("border"),e.style.removeProperty("border-top"),e.style.removeProperty("border-bottom"),e.style.removeProperty("border-left"),e.style.removeProperty("border-right")}function S(e){var c=[];if(null==(e=e||null)&&0<te().length&&(e=ae()),e){if(!e.find("tr").html().match(/xl[0-9]+/gi))for(var t=e.find("tr:empty"),a=t.length-1;0<=a;a--)k(t[a]).remove();e.find("tr").not(e.find("> table tr")).each(function(s,e){var t=k(e),l=0;t.find("> th, > td").each(function(e,t){for(var a=k(t),n=parseInt(a.attr("colspan"),10)||1,r=parseInt(a.attr("rowspan"),10)||1,i=s;i<s+r;i++)for(var o=l;o<l+n;o++)c[i]||(c[i]=[]),c[i][o]?l++:c[i][o]=t;l+=n})})}return c}function R(e,t){for(var a=0;a<t.length;a++)for(var n=0;n<t[a].length;n++)if(t[a][n]==e)return{row:a,col:n}}function L(e,t,a){for(var n=e+1,r=t+1;n<a.length;){if(a[n][t]!=a[e][t]){n--;break}n++}for(n==a.length&&n--;r<a[e].length;){if(a[e][r]!=a[e][t]){r--;break}r++}return r==a[e].length&&r--,{row:n,col:r}}function x(){C.el.querySelector(".fr-cell-fixed")&&C.el.querySelector(".fr-cell-fixed").classList.remove("fr-cell-fixed"),C.el.querySelector(".fr-cell-handler")&&C.el.querySelector(".fr-cell-handler").classList.remove("fr-cell-handler")}function I(){var e=C.$el.find(".fr-selected-cell");0<e.length&&e.each(function(){var e=k(this);e.removeClass("fr-selected-cell"),""===e.attr("class")&&e.removeAttr("class")}),x()}function O(){C.events.disableBlur(),C.selection.clear(),C.$el.addClass("fr-no-selection"),C.$el.blur(),C.events.enableBlur()}function F(e){var t=C.$el.find(".fr-selected-cell");if(0<t.length){var a,n=e.length,r=0,i=e[0].length,o=0;for(a=0;a<t.length;a++){var s=R(t[a],e),l=L(s.row,s.col,e);n=Math.min(s.row,n),r=Math.max(l.row,r),i=Math.min(s.col,i),o=Math.max(l.col,o)}return{min_i:n,max_i:r,min_j:i,max_j:o}}return null}function M(e){var t=F(e);if(null!=t){var a=k(e[t.min_i][t.min_j]),n=k(e[t.min_i][t.max_j]),r=k(e[t.max_i][t.min_j]);return{left:a.length&&a.offset().left,right:n.length&&n.offset().left+n.outerWidth(),top:a.length&&a.offset().top,bottom:r.length&&r.offset().top+r.outerHeight()}}}function N(e,t){if(k(e).is(t))I(),k(e).addClass("fr-selected-cell");else{O(),C.edit.off();var a=S(),n=R(e,a),r=R(t,a);if(!n||!r)return;var i=function u(e,t,a,n,r){var i,o,s,l,c=e,d=t,f=a,p=n;for(i=c;i<=d;i++)(1<(parseInt(k(r[i][f]).attr("rowspan"),10)||1)||1<(parseInt(k(r[i][f]).attr("colspan"),10)||1))&&(l=L((s=R(r[i][f],r)).row,s.col,r),c=Math.min(s.row,c),d=Math.max(l.row,d),f=Math.min(s.col,f),p=Math.max(l.col,p)),(1<(parseInt(k(r[i][p]).attr("rowspan"),10)||1)||1<(parseInt(k(r[i][p]).attr("colspan"),10)||1))&&(l=L((s=R(r[i][p],r)).row,s.col,r),c=Math.min(s.row,c),d=Math.max(l.row,d),f=Math.min(s.col,f),p=Math.max(l.col,p));for(o=f;o<=p;o++)(1<(parseInt(k(r[c][o]).attr("rowspan"),10)||1)||1<(parseInt(k(r[c][o]).attr("colspan"),10)||1))&&(l=L((s=R(r[c][o],r)).row,s.col,r),c=Math.min(s.row,c),d=Math.max(l.row,d),f=Math.min(s.col,f),p=Math.max(l.col,p)),(1<(parseInt(k(r[d][o]).attr("rowspan"),10)||1)||1<(parseInt(k(r[d][o]).attr("colspan"),10)||1))&&(l=L((s=R(r[d][o],r)).row,s.col,r),c=Math.min(s.row,c),d=Math.max(l.row,d),f=Math.min(s.col,f),p=Math.max(l.col,p));return c==e&&d==t&&f==a&&p==n?{min_i:e,max_i:t,min_j:a,max_j:n}:u(c,d,f,p,r)}(Math.min(n.row,r.row),Math.max(n.row,r.row),Math.min(n.col,r.col),Math.max(n.col,r.col),a);I(),e.classList.add("fr-cell-fixed"),t.classList.add("fr-cell-handler");for(var o=i.min_i;o<=i.max_i;o++)for(var s=i.min_j;s<=i.max_j;s++)k(e).closest("table").is(k(a[o][s]).closest("table"))&&k(a[o][s]).addClass("fr-selected-cell")}}function D(e){var t=null,a=k(e.target);return"TD"==e.target.tagName||"TH"==e.target.tagName?t=e.target:0<a.closest("th",a.closest("thead")[0]).length?t=a.closest("th",a.closest("thead")[0]).get(0):0<a.closest("td",a.closest("tr")[0]).length&&(t=a.closest("td",a.closest("tr")[0]).get(0)),-1===C.$el.html.toString().search(t)?null:t}function P(){I(),C.popups.hide("table.edit")}function e(e){var t=D(e);if("false"==k(t).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable"))return!0;if(0<te().length&&!t&&P(),!C.edit.isDisabled()||C.popups.isVisible("table.edit"))if(1!=e.which||1==e.which&&C.helpers.isMac()&&e.ctrlKey)(3==e.which||1==e.which&&C.helpers.isMac()&&e.ctrlKey)&&t&&P();else if(i=!0,t){0<te().length&&!e.shiftKey&&P(),e.stopPropagation(),C.events.trigger("image.hideResizer"),C.events.trigger("video.hideResizer"),r=!0;var a=t.tagName.toLowerCase();e.shiftKey&&0<C.$el.find("".concat(a,".fr-selected-cell")).length?k(C.$el.find("".concat(a,".fr-selected-cell")).closest("table")).is(k(t).closest("table"))?N(n,t):O():((C.keys.ctrlKey(e)||e.shiftKey)&&"TD"===e.currentTarget.tagName&&(1<te().length||0===k(t).find(C.selection.element()).length&&!k(t).is(C.selection.element()))&&O(),n=t,0<C.opts.tableEditButtons.length&&N(n,n))}}function a(e){if(!C.edit.isDisabled()&&C.popups.areVisible())return!0;var t=D(e);if(1===te().length&&null===t&&(C.toolbar.enable(),I()),(1===te().length&&t&&"TD"!==t.tagName&&"TH"!==t.tagName||!r&&!C.$tb.is(e.target)&&!C.$tb.is(k(e.target).closest(".fr-toolbar")))&&(C.toolbar.enable(),I()),("BODY"===e.target.tagName||"HTML"===e.target.tagName)&&!t&&0<te().length&&C.toolbar.enable(),!(1!=e.which||1==e.which&&C.helpers.isMac()&&e.ctrlKey)){if(i=!1,r)r=!1,D(e)||1!=te().length?0<te().length?C.selection.isCollapsed()?(h(),C.toolbar.enable()):(I(),C.edit.on()):te().length||(C.$el.removeClass("fr-no-selection"),C.edit.on()):I();if(y){y=!1,T.removeClass("fr-moving"),C.$el.removeClass("fr-no-selection"),C.edit.on();var a=parseFloat(T.css("left"))+C.opts.tableResizerOffset+C.$wp.offset().left;C.opts.iframe&&(a-=C.$iframe.offset().left),T.data("release-position",a),T.removeData("max-left"),T.removeData("max-right"),function A(){var e=T.data("origin"),t=T.data("release-position");if(e!==t){var a=T.data("first"),n=T.data("second"),r=T.data("table"),i=r.outerWidth();if(C.undo.canDo()||C.undo.saveStep(),null!=a&&null!=n){var o,s,l,c=S(r),d=[],f=[],p=[],u=[];for(o=0;o<c.length;o++)s=k(c[o][a]),l=k(c[o][n]),d[o]=s.outerWidth(),p[o]=l.outerWidth(),f[o]=d[o]/i*100,u[o]=p[o]/i*100;for(o=0;o<c.length;o++)if(s=k(c[o][a]),l=k(c[o][n]),c[o][a]!=c[o][n]){var g=(f[o]*(d[o]+t-e)/d[o]).toFixed(4);s.css("width",g+"%"),l.css("width",(f[o]+u[o]-g).toFixed(4)+"%")}}else{var h,m=r.parent(),v=parseFloat(m.css("padding-left")),b=parseFloat(m.css("padding-right")),E=v+b,_=i/(m.width()-E)*100,w=(parseInt(r.css("margin-left"),10)||0)/m.width()*100,y=(parseInt(r.css("margin-right"),10)||0)/m.width()*100;"rtl"==C.opts.direction&&0===n||"rtl"!=C.opts.direction&&0!==n?(h=(i+t-e)/i*_,r.css("margin-right","calc(100% - ".concat(Math.round(h).toFixed(4),"% - ").concat(Math.round(w).toFixed(4),"%)"))):("rtl"==C.opts.direction&&0!==n||"rtl"!=C.opts.direction&&0===n)&&(h=(i-t+e)/i*_,r.css("margin-left","calc(100% - ".concat(Math.round(h).toFixed(4),"% - ").concat(Math.round(y).toFixed(4),"%)"))),r.css("width","".concat(Math.round(h).toFixed(4),"%"))}C.selection.restore(),C.undo.saveStep(),C.events.trigger("table.resized",[r.get(0)])}T.removeData("origin"),T.removeData("release-position"),T.removeData("first"),T.removeData("second"),T.removeData("table")}(),z()}}}function B(e){if((!(k(e.currentTarget).is(k(e.originalEvent.relatedTarget))||e.currentTarget.contains(e.originalEvent.relatedTarget)||e.originalEvent.relatedTarget&&e.originalEvent.relatedTarget.contains(e.currentTarget))||e.currentTarget.querySelector("input, textarea"))&&(C.events.$on(k("input, textarea"),"click",ne),!0===r&&0<C.opts.tableEditButtons.length)){if(k(e.currentTarget).closest("table").is(ae())){if("TBODY"===e.currentTarget.parentElement.parentElement.tagName&&"TD"==e.currentTarget.tagName&&0===C.$el.find("th.fr-selected-cell").length&&0===C.$el.find("tfoot td.fr-selected-cell").length)return void N(n,e.currentTarget);if("TFOOT"===e.currentTarget.parentElement.parentElement.tagName&&"TD"==e.currentTarget.tagName&&0===C.$el.find("tbody td.fr-selected-cell").length)return void N(n,e.currentTarget);if("TH"==e.currentTarget.tagName&&0===C.$el.find("td.fr-selected-cell").length)return void N(n,e.currentTarget)}"TD"!==e.currentTarget.tagName&&"TH"!==e.currentTarget.tagName&&O()}}function U(e,t,a,n){for(var r,i=t;i!=C.el&&"TD"!=i.tagName&&"TH"!=i.tagName&&("up"==n?r=i.previousElementSibling:"down"==n&&(r=i.nextElementSibling),!r);)i=i.parentNode;"TD"==i.tagName||"TH"==i.tagName?function o(e,t){for(var a=e;a&&"TABLE"!=a.tagName&&a.parentNode!=C.el;)a=a.parentNode;if(a&&"TABLE"==a.tagName){var n=S(k(a));"up"==t?H(R(e,n),a,n):"down"==t&&$(R(e,n),a,n)}}(i,n):r&&("up"==n&&C.selection.setAtEnd(r),"down"==n&&C.selection.setAtStart(r))}function H(e,t,a){0<k(".tribute-container").length&&"none"!=k(".tribute-container").css("display")||(0<e.row?C.selection.setAtEnd(a[e.row-1][e.col]):U(0,t,0,"up"))}function $(e,t,a){if(!(0<k(".tribute-container").length&&"none"!=k(".tribute-container").css("display"))){var n=parseInt(a[e.row][e.col].getAttribute("rowspan"),10)||1;e.row<a.length-n?C.selection.setAtStart(a[e.row+n][e.col]):U(0,t,0,"down")}}function z(){T&&(T.find("div").css("opacity",0),T.css("top",0),T.css("left",0),T.css("height",0),T.find("div").css("height",0),T.hide())}function W(){c&&c.removeClass("fr-visible").css("left","-9999px")}function K(e,t){var a,n=k(t);n&&(a=n.closest("table"));var r=a.parent();if(t&&"TD"!=t.tagName&&"TH"!=t.tagName&&(0<n.closest("td").length?t=n.closest("td"):0<n.closest("th").length&&(t=n.closest("th"))),!t||"TD"!=t.tagName&&"TH"!=t.tagName)T&&n.get(0)!=T.get(0)&&n.parent().get(0)!=T.get(0)&&C.core.sameInstance(T)&&z();else{if(n=k(t),0===C.$el.find(n).length)return!1;var i=n.offset().left-1,o=i+n.outerWidth();if(Math.abs(e.pageX-i)<=C.opts.tableResizerOffset||Math.abs(o-e.pageX)<=C.opts.tableResizerOffset){var s,l,c,d,f,p=S(a),u=R(t,p),g=L(u.row,u.col,p),h=a.offset().top,m=a.outerHeight()-1;"rtl"!=C.opts.direction?e.pageX-i<=C.opts.tableResizerOffset?(c=i,0<u.col?(d=i-q(u.col-1,p)+C.opts.tableResizingLimit,f=i+q(u.col,p)-C.opts.tableResizingLimit,s=u.col-1,l=u.col):(s=null,l=0,d=a.offset().left-1-parseInt(a.css("margin-left"),10),f=a.offset().left-1+a.width()-p[0].length*C.opts.tableResizingLimit)):o-e.pageX<=C.opts.tableResizerOffset&&(c=o,g.col<p[g.row].length&&p[g.row][g.col+1]?(d=o-q(g.col,p)+C.opts.tableResizingLimit,f=o+q(g.col+1,p)-C.opts.tableResizingLimit,s=g.col,l=g.col+1):(s=g.col,l=null,d=a.offset().left-1+p[0].length*C.opts.tableResizingLimit,f=r.offset().left-1+r.width()+parseFloat(r.css("padding-left")))):o-e.pageX<=C.opts.tableResizerOffset?(c=o,0<u.col?(d=o-q(u.col,p)+C.opts.tableResizingLimit,f=o+q(u.col-1,p)-C.opts.tableResizingLimit,s=u.col,l=u.col-1):(s=null,l=0,d=a.offset().left+p[0].length*C.opts.tableResizingLimit,f=r.offset().left-1+r.width()+parseFloat(r.css("padding-left")))):e.pageX-i<=C.opts.tableResizerOffset&&(c=i,g.col<p[g.row].length&&p[g.row][g.col+1]?(d=i-q(g.col+1,p)+C.opts.tableResizingLimit,f=i+q(g.col,p)-C.opts.tableResizingLimit,s=g.col+1,l=g.col):(s=g.col,l=null,d=r.offset().left+parseFloat(r.css("padding-left")),f=a.offset().left-1+a.width()-p[0].length*C.opts.tableResizingLimit)),T||function w(){C.shared.$table_resizer||(C.shared.$table_resizer=k(document.createElement("div")).attr("class","fr-table-resizer").html("<div></div>")),T=C.shared.$table_resizer,C.events.$on(T,"mousedown",function(e){return!C.core.sameInstance(T)||(0<te().length&&P(),1==e.which?(C.selection.save(),y=!0,T.addClass("fr-moving"),O(),C.edit.off(),T.find("div").css("opacity",1),!1):void 0)}),C.events.$on(T,"mousemove",function(e){if(!C.core.sameInstance(T))return!0;y&&(C.opts.iframe&&(e.pageX-=C.$iframe.offset().left),Z(e))}),C.events.on("shared.destroy",function(){T.html("").removeData().remove(),T=null},!0),C.events.on("destroy",function(){C.$el.find(".fr-selected-cell").removeClass("fr-selected-cell"),k("body").first().append(T.hide())},!0)}(),T.data("table",a),T.data("first",s),T.data("second",l),T.data("instance",C),C.$wp.append(T);var v=c-C.win.pageXOffset-C.opts.tableResizerOffset-C.$wp.offset().left,b=h-C.$wp.offset().top+C.$wp.scrollTop();if(C.opts.iframe){var E=C.helpers.getPX(C.$wp.find(".fr-iframe").css("padding-top")),_=C.helpers.getPX(C.$wp.find(".fr-iframe").css("padding-left"));v+=C.$iframe.offset().left+_,b+=C.$iframe.offset().top+E,d+=C.$iframe.offset().left,f+=C.$iframe.offset().left}T.data("max-left",d),T.data("max-right",f),T.data("origin",c-C.win.pageXOffset),T.css("top",b),T.css("left",v),T.css("height",m),T.find("div").css("height",m),T.css("padding-left",C.opts.tableResizerOffset),T.css("padding-right",C.opts.tableResizerOffset),T.show()}else C.core.sameInstance(T)&&z()}}function G(e,t){if(C.$box.find(".fr-line-breaker").isVisible())return!1;c||J(),C.$box.append(c),c.data("instance",C);var a,n=k(t).find("tr").first(),r=e.pageX,i=0,o=0;if(C.opts.iframe){var s=C.helpers.getPX(C.$wp.find(".fr-iframe").css("padding-top")),l=C.helpers.getPX(C.$wp.find(".fr-iframe").css("padding-left"));i+=C.$iframe.offset().left-C.helpers.scrollLeft()+l,o+=C.$iframe.offset().top-C.helpers.scrollTop()+s}n.find("th, td").each(function(){var e=k(this);return e.offset().left<=r&&r<e.offset().left+e.outerWidth()/2?(a=parseInt(c.find("a").css("width"),10),c.css("top",o+e.offset().top-C.$box.offset().top-a-5),c.css("left",i+e.offset().left-C.$box.offset().left-a/2),c.data("selected-cell",e),c.data("position","before"),c.addClass("fr-visible"),!1):e.offset().left+e.outerWidth()/2<=r&&r<e.offset().left+e.outerWidth()?(a=parseInt(c.find("a").css("width"),10),c.css("top",o+e.offset().top-C.$box.offset().top-a-5),c.css("left",i+e.offset().left-C.$box.offset().left+e.outerWidth()-a/2),c.data("selected-cell",e),c.data("position","after"),c.addClass("fr-visible"),!1):void 0})}function V(e,t){if(C.$box.find(".fr-line-breaker").isVisible())return!1;c||J(),C.$box.append(c),c.data("instance",C);var a,n=k(t),r=e.pageY,i=0,o=0;if(C.opts.iframe){var s=C.helpers.getPX(C.$wp.find(".fr-iframe").css("padding-top")),l=C.helpers.getPX(C.$wp.find(".fr-iframe").css("padding-left"));i+=C.$iframe.offset().left-C.helpers.scrollLeft()+l,o+=C.$iframe.offset().top-C.helpers.scrollTop()+s}n.find("tr").each(function(){var e=k(this);a=parseInt(c.find("a").css("width"),10);var t=i+e.offset().left-C.$box.offset().left;return t=0!==C.$box.offset().left?t-a-5:t+a-5,e.offset().top<=r&&r<e.offset().top+e.outerHeight()/2?(c.css("top",o+e.offset().top-C.$box.offset().top-a/2),c.css("left",t),c.data("selected-cell",e.find("td").first()),c.data("position","above"),c.addClass("fr-visible"),!1):e.offset().top+e.outerHeight()/2<=r&&r<e.offset().top+e.outerHeight()?(c.css("top",o+e.offset().top-C.$box.offset().top+e.outerHeight()-a/2),c.css("left",t),c.data("selected-cell",e.find("td").first()),c.data("position","below"),c.addClass("fr-visible"),!1):void 0})}function Y(e){o=null;var t=C.doc.elementFromPoint(e.pageX-C.win.pageXOffset,e.pageY-C.win.pageYOffset);C.opts.tableResizer&&(!C.popups.areVisible()||C.popups.areVisible()&&C.popups.isVisible("table.edit"))&&K(e,t),!C.opts.tableInsertHelper||C.popups.areVisible()||C.$tb.hasClass("fr-inline")&&C.$tb.isVisible()||function i(e,t){if(0===te().length){var a,n,r;if(t&&("HTML"==t.tagName||"BODY"==t.tagName||C.node.isElement(t)))for(a=1;a<=C.opts.tableInsertHelperOffset;a++){if(n=C.doc.elementFromPoint(e.pageX-C.win.pageXOffset,e.pageY-C.win.pageYOffset+a),k(n).hasClass("fr-tooltip"))return!0;if(n&&("TH"==n.tagName||"TD"==n.tagName||"TABLE"==n.tagName)&&(k(n).parents(".fr-wrapper").length||C.opts.iframe)&&"false"!=k(n).closest("table").attr("contenteditable"))return G(e,k(n).closest("table")),!0;if(r=C.doc.elementFromPoint(e.pageX-C.win.pageXOffset+a,e.pageY-C.win.pageYOffset),k(r).hasClass("fr-tooltip"))return!0;if(r&&("TH"==r.tagName||"TD"==r.tagName||"TABLE"==r.tagName)&&(k(r).parents(".fr-wrapper").length||C.opts.iframe)&&"false"!=k(r).closest("table").attr("contenteditable"))return V(e,k(r).closest("table")),!0}C.core.sameInstance(c)&&W()}}(e,t)}function j(){if(y){var e=T.data("table").offset().top-C.win.pageYOffset;if(C.opts.iframe){var t=C.helpers.getPX(C.$wp.find(".fr-iframe").css("padding-top"));e+=C.$iframe.offset().top-C.helpers.scrollTop()+t}T.css("top",e)}}function q(e,t){var a,n=k(t[0][e]).outerWidth();for(a=1;a<t.length;a++)n=Math.min(n,k(t[a][e]).outerWidth());return n}function X(e,t,a){var n,r=0;for(n=e;n<=t;n++)r+=q(n,a);return r}function Z(e){if(1<te().length&&i&&O(),!1===i&&!1===r&&!1===y)o&&clearTimeout(o),C.edit.isDisabled()&&!C.popups.isVisible("table.edit")||(o=setTimeout(Y,30,e));else if(y){var t=e.pageX-C.win.pageXOffset;C.opts.iframe&&(t+=C.$iframe.offset().left);var a=T.data("max-left"),n=T.data("max-right");a<=t&&t<=n?T.css("left",t-C.opts.tableResizerOffset-C.$wp.offset().left):t<a&&parseFloat(T.css("left"),10)>a-C.opts.tableResizerOffset?T.css("left",a-C.opts.tableResizerOffset-C.$wp.offset().left):n<t&&parseFloat(T.css("left"),10)<n-C.opts.tableResizerOffset&&T.css("left",n-C.opts.tableResizerOffset-C.$wp.offset().left)}else i&&W()}function Q(e){C.node.isEmpty(e.get(0))?C.opts.keepTextFormatOnTable&&C.browser.mozilla?e.append(St.MARKERS):e.prepend(St.MARKERS):e.prepend(St.START_MARKER).append(St.END_MARKER)}function J(){C.shared.$ti_helper||(C.shared.$ti_helper=k(document.createElement("div")).attr("class","fr-insert-helper").html('<a class="fr-floating-btn" role="button" tabIndex="-1" title="'.concat(C.language.translate("Insert"),'"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M22,16.75 L16.75,16.75 L16.75,22 L15.25,22.000 L15.25,16.75 L10,16.75 L10,15.25 L15.25,15.25 L15.25,10 L16.75,10 L16.75,15.25 L22,15.25 L22,16.75 Z"/></svg></a>')),C.events.bindClick(C.shared.$ti_helper,"a",function(){var e=c.data("selected-cell"),t=c.data("position"),a=c.data("instance")||C;"before"==t?(C.undo.saveStep(),e.addClass("fr-selected-cell"),a.table.insertColumn(t),e.removeClass("fr-selected-cell"),C.undo.saveStep()):"after"==t?(C.undo.saveStep(),e.addClass("fr-selected-cell"),a.table.insertColumn(t),e.removeClass("fr-selected-cell"),C.undo.saveStep()):"above"==t?(C.undo.saveStep(),e.addClass("fr-selected-cell"),a.table.insertRow(t),e.removeClass("fr-selected-cell"),C.undo.saveStep()):"below"==t&&(C.undo.saveStep(),e.addClass("fr-selected-cell"),a.table.insertRow(t),e.removeClass("fr-selected-cell"),C.undo.saveStep()),W()}),C.events.on("shared.destroy",function(){C.shared.$ti_helper.html("").removeData().remove(),C.shared.$ti_helper=null},!0),C.events.$on(C.shared.$ti_helper,"mousemove",function(e){e.stopPropagation()},!0),C.events.$on(k(C.o_win),"scroll",function(){W()},!0),C.events.$on(C.$wp,"scroll",function(){W()},!0)),c=C.shared.$ti_helper,C.events.on("destroy",function(){c=null}),C.tooltip.bind(C.$box,".fr-insert-helper > a.fr-floating-btn")}function ee(){n=null,clearTimeout(o)}function te(){return C.el.querySelectorAll(".fr-selected-cell")}function ae(){var e=te();if(e.length){for(var t=e[0];t&&"TABLE"!=t.tagName&&t.parentNode!=C.el;)t=t.parentNode;return t&&"TABLE"==t.tagName?k(t):k([])}return k([])}function ne(){r=!1}return{_init:function re(){if(!C.$wp)return!1;if(C.helpers.isMobile()&&(C.events.$on(C.$el,"mousedown",e),C.events.$on(C.$win,"mouseup",a)),!C.helpers.isMobile()){y=r=i=!1,C.events.$on(C.$el,"mousedown",e),C.popups.onShow("image.edit",function(){I(),r=i=!1}),C.popups.onShow("link.edit",function(){I(),r=i=!1}),C.events.on("commands.mousedown",function(e){0<e.parents(".fr-toolbar").length&&I()}),C.events.$on(C.$el,"mouseover","th, td",B),C.events.$on(C.$win,"mouseup",a),C.opts.iframe&&C.events.$on(k(C.o_win),"mouseup",a),C.events.$on(C.$win,"mousemove",Z),C.events.$on(k(C.o_win),"scroll",j),C.events.on("contentChanged",function(){0<te().length&&(h(),C.$el.find("img").on("load.selected-cells",function(){k(this).off("load.selected-cells"),0<te().length&&h()}))}),C.events.$on(k(C.o_win),"resize",function(){I()}),C.events.on("toolbar.esc",function(){if(0<te().length)return C.events.disableBlur(),C.events.focus(),!1},!0),C.events.$on(k(C.o_win),"keydown",function(){i&&r&&(r=i=!1,C.$el.removeClass("fr-no-selection"),C.edit.on(),C.selection.setAtEnd(C.$el.find(".fr-selected-cell").last().get(0)),C.selection.restore(),I())}),C.events.$on(C.$el,"keydown",function(e){e.shiftKey?!1===function o(e){var t=te();if(null!=t&&0<t.length){var a,n=S(),r=e.which,i=R(1==t.length?a=t[0]:(a=C.el.querySelector(".fr-cell-fixed"),C.el.querySelector(".fr-cell-handler")),n);if(St.KEYCODE.ARROW_RIGHT==r){if(i.col<n[0].length-1)return N(a,n[i.row][i.col+1]),!1}else if(St.KEYCODE.ARROW_DOWN==r){if(i.row<n.length-1)return N(a,n[i.row+1][i.col]),!1}else if(St.KEYCODE.ARROW_LEFT==r){if(0<i.col)return N(a,n[i.row][i.col-1]),!1}else if(St.KEYCODE.ARROW_UP==r&&0<i.row)return N(a,n[i.row-1][i.col]),!1}}(e)&&setTimeout(function(){h()},0):function s(e){var t=e.which,a=C.selection.blocks();if(a.length&&("P"!==(a=a[0]).tagName&&"DIV"!==a.tagName||(a=a.parentNode),"TD"==a.tagName||"TH"==a.tagName)){for(var n=a;n&&"TABLE"!=n.tagName&&n.parentNode!=C.el;)n=n.parentNode;if(n&&"TABLE"==n.tagName&&(St.KEYCODE.ARROW_LEFT==t||St.KEYCODE.ARROW_UP==t||St.KEYCODE.ARROW_RIGHT==t||St.KEYCODE.ARROW_DOWN==t)&&(0<te().length&&P(),C.browser.webkit&&(St.KEYCODE.ARROW_UP==t||St.KEYCODE.ARROW_DOWN==t))){var r=C.selection.ranges(0).startContainer;if(r.nodeType==Node.TEXT_NODE&&(St.KEYCODE.ARROW_UP==t&&(r.previousSibling&&"BR"!==r.previousSibling.tagName||r.previousSibling&&"BR"===r.previousSibling.tagName&&r.previousSibling.previousSibling)||St.KEYCODE.ARROW_DOWN==t&&(r.nextSibling&&"BR"!==r.nextSibling.tagName||r.nextSibling&&"BR"===r.nextSibling.tagName&&r.nextSibling.nextSibling)))return;e.preventDefault(),e.stopPropagation();var i=S(k(n)),o=R(a,i);return St.KEYCODE.ARROW_UP==t?H(o,n,i):St.KEYCODE.ARROW_DOWN==t&&$(o,n,i),C.selection.restore(),!1}}}(e)}),C.events.on("keydown",function(e){if(!1===function n(e){if(e.which==St.KEYCODE.TAB){var t;if(0<te().length)t=C.$el.find(".fr-selected-cell").last();else{var a=C.selection.element();"TD"==a.tagName||"TH"==a.tagName?t=k(a):a!=C.el&&(0<k(a).parentsUntil(C.$el,"td").length?t=k(a).parents("td").first():0<k(a).parentsUntil(C.$el,"th").length&&(t=k(a).parents("th").first()))}if(t)return e.preventDefault(),!!(0===C.selection.get().focusOffset&&0<k(C.selection.element()).parentsUntil(C.$el,"ol, ul").length&&(0<k(C.selection.element()).closest("li").prev().length||k(C.selection.element()).is("li")&&0<k(C.selection.element()).prev().length))||(P(),e.shiftKey?0<t.prev().length?Q(t.prev()):0<t.closest("tr").length&&0<t.closest("tr").prev().length?Q(t.closest("tr").prev().find("td").last()):0<t.closest("tbody").length&&0<t.closest("table").find("thead tr").length&&Q(t.closest("table").find("thead tr th").last()):0<t.next().length?Q(t.next()):0<t.closest("tr").length&&0<t.closest("tr").next().length?Q(t.closest("tr").next().find("td").first()):0<t.closest("thead").length&&0<t.closest("table").find("tbody tr").length?Q(t.closest("table").find("tbody tr td").first()):(t.addClass("fr-selected-cell"),v("below"),I(),Q(t.closest("tr").next().find("td").first())),C.selection.restore(),!1)}}(e))return!1;var t=te();if(0<t.length){if(0<t.length&&C.keys.ctrlKey(e)&&e.which==St.KEYCODE.A)return I(),C.popups.isVisible("table.edit")&&C.popups.hide("table.edit"),t=[],!0;if(e.which==St.KEYCODE.ESC&&C.popups.isVisible("table.edit"))return I(),C.popups.hide("table.edit"),e.preventDefault(),e.stopPropagation(),e.stopImmediatePropagation(),!(t=[]);if(1<t.length&&(e.which==St.KEYCODE.BACKSPACE||e.which==St.KEYCODE.DELETE)){C.undo.saveStep();for(var a=0;a<t.length;a++)k(t[a]).html("<br>"),a==t.length-1&&k(t[a]).prepend(St.MARKERS);return C.selection.restore(),C.undo.saveStep(),!(t=[])}if(1<t.length&&e.which!=St.KEYCODE.F10&&!C.keys.isBrowserAction(e))return e.preventDefault(),!(t=[])}else if(!(t=[])===function r(e){if(e.altKey&&e.which==St.KEYCODE.SPACE){var t,a=C.selection.element();if("TD"==a.tagName||"TH"==a.tagName?t=a:0<k(a).closest("td").length?t=k(a).closest("td").get(0):0<k(a).closest("th").length&&(t=k(a).closest("th").get(0)),t)return e.preventDefault(),N(t,t),h(),!1}}(e))return!1},!0);var t=[];C.events.on("html.beforeGet",function(){t=te();for(var e=0;e<t.length;e++)t[e].className=(t[e].className||"").replace(/fr-selected-cell/g,"")}),C.events.on("html.afterGet",function(){for(var e=0;e<t.length;e++)t[e].className=(t[e].className?t[e].className.trim()+" ":"")+"fr-selected-cell";t=[]}),d(!0),p(!0)}C.events.on("destroy",ee)},insert:function ie(e,t){var a,n,r=function c(){var e={startTag:"",closeTag:""};if(C.opts.keepTextFormatOnTable){var t=k(C.selection.element().firstChild).parentsUntil(C.$el);e=u(t)}return{startTag:e.startTag,closeTag:e.closeTag}}(),i="<table "+(C.opts.tableDefaultWidth?'style="width: '+C.opts.tableDefaultWidth+';" ':"")+'class="fr-inserted-table"><tbody>',o=100/t;for(a=0;a<e;a++){for(i+="<tr>",n=0;n<t;n++)i+="<td"+(C.opts.tableDefaultWidth?' style="width: '+o.toFixed(4)+'%;"':"")+">"+r.startTag,0===a&&0===n&&(i+=St.MARKERS),i+="<br>"+r.closeTag+"</td>";i+="</tr>"}if(i+="</tbody></table>",C.opts.trackChangesEnabled){C.edit.on(),C.events.focus(!0),C.selection.restore(),C.undo.saveStep(),C.markers.insert(),C.html.wrap();var s=C.$el.find(".fr-marker");C.node.isLastSibling(s)&&s.parent().hasClass("fr-deletable")&&s.insertAfter(s.parent()),s.replaceWith(i),C.selection.clear()}else C.html.insert(i);C.selection.restore();var l=C.$el.find(".fr-inserted-table");l.removeClass("fr-inserted-table"),C.events.trigger("table.inserted",[l.get(0)])},remove:g,insertRow:v,deleteRow:function oe(){var e=ae();if(0<e.length){var t,a,n,r=S(),i=F(r);if(null==i)return;if(0===i.min_i&&i.max_i==r.length-1)g();else{for(t=i.max_i;t>=i.min_i;t--){for(n=k(e.find("tr").not(e.find("> table tr")).get(t)),a=0;a<r[t].length;a++)if(0===a||r[t][a]!=r[t][a-1]){var o=k(r[t][a]);if(1<parseInt(o.attr("rowspan"),10)){var s=parseInt(o.attr("rowspan"),10)-1;1==s?o.removeAttr("rowspan"):o.attr("rowspan",s)}if(t<r.length-1&&r[t][a]==r[t+1][a]&&(0===t||r[t][a]!=r[t-1][a])){for(var l=r[t][a],c=a;0<c&&r[t][c]==r[t][c-1];)c--;0===c?k(e.find("tr").not(e.find("> table tr")).get(t+1)).prepend(l):k(r[t+1][c-1])[0].parentNode&&k(r[t+1][c-1])[0].insertAdjacentElement("afterend",l)}}var d=n.parent();n.remove(),0===d.find("tr").length&&d.remove(),r=S(e)}w(0,r.length-1,0,r[0].length-1,e),0<i.min_i?C.selection.setAtEnd(r[i.min_i-1][0]):C.selection.setAtEnd(r[0][0]),C.selection.restore(),C.popups.hide("table.edit")}}},insertColumn:function se(d){var e=ae();if(0<e.length){var f,p=S(),t=F(p);f="before"==d?t.min_j:t.max_j;var a,u=100/p[0].length,g=100/(p[0].length+1);e.find("th, td").each(function(){(a=k(this)).data("old-width",a.outerWidth()/e.outerWidth()*100)}),e.find("tr").not(e.find("> table tr")).each(function(e){for(var t,a=k(this),n=0,r=0;n-1<f;){if(!(t=a.find("> th, > td").get(r))){t=null;break}t==p[e][n]?(n+=parseInt(k(t).attr("colspan"),10)||1,r++):(n+=parseInt(k(p[e][n]).attr("colspan"),10)||1,"after"==d&&(t=0===r?-1:a.find("> th, > td").get(r-1)))}var i=k(t);if("after"==d&&f<n-1||"before"==d&&0<f&&p[e][f]==p[e][f-1]){if(0===e||0<e&&p[e][f]!=p[e-1][f]){var o=parseInt(i.attr("colspan"),10)+1;i.attr("colspan",o),i.css("width",(i.data("old-width")*g/u+g).toFixed(4)+"%"),i.removeData("old-width")}}else{var s,l=(i.get(0)||"").tagName;if(0<a.find("th").length&&"TH"===l)s='<th style="width: '.concat(g.toFixed(4),'%;"><br></th>');else{var c=m(p[e][f]);s='<td style="'.concat(i.attr("style"),"; width: ").concat(g.toFixed(4),'%;">')+c.startTag+"<br>"+c.closeTag+"</td>"}k(s).append("<br>"),k(s).css("width","".concat(g.toFixed(4),"%")),-1==t?a.prepend(s):null==t?a.append(s):"before"==d?i.before(s):"after"==d&&i.after(s)}}),e.find("th, td").each(function(){(a=k(this)).data("old-width")&&(a.css("width",(a.data("old-width")*g/u).toFixed(4)+"%"),a.removeData("old-width"))}),C.popups.isVisible("table.edit")&&h()}},deleteColumn:function le(){var e=ae();if(0<e.length){var t,a,n,r=S(),i=F(r);if(null==i)return;if(0===i.min_j&&i.max_j==r[0].length-1)g();else{var o=0;for(t=0;t<r.length;t++)for(a=0;a<r[0].length;a++)(n=k(r[t][a])).hasClass("fr-selected-cell")||(n.data("old-width",n.outerWidth()/e.outerWidth()*100),(a<i.min_j||a>i.max_j)&&(o+=n.outerWidth()/e.outerWidth()*100));for(o/=r.length,a=i.max_j;a>=i.min_j;a--)for(t=0;t<r.length;t++)if(0===t||r[t][a]!=r[t-1][a])if(n=k(r[t][a]),1<(parseInt(n.attr("colspan"),10)||1)){var s=parseInt(n.attr("colspan"),10)-1;1==s?n.removeAttr("colspan"):n.attr("colspan",s),n.css("width",(100*(n.data("old-width")-q(a,r))/o).toFixed(4)+"%"),n.removeData("old-width")}else{var l=k(n.parent().get(0));n.remove(),0===l.find("> th, > td").length&&(0===l.prev().length||0===l.next().length||l.prev().find("> th[rowspan], > td[rowspan]").length<l.prev().find("> th, > td").length)&&l.remove()}w(0,r.length-1,0,r[0].length-1,e),0<i.min_j?C.selection.setAtEnd(r[i.min_i][i.min_j-1]):C.selection.setAtEnd(r[i.min_i][0]),C.selection.restore(),C.popups.hide("table.edit"),e.find("th, td").each(function(){(n=k(this)).data("old-width")&&(n.css("width",(100*n.data("old-width")/o).toFixed(4)+"%"),n.removeData("old-width"))})}}},mergeCells:function ce(){if(1<te().length&&(0===C.$el.find("th.fr-selected-cell").length||0===C.$el.find("td.fr-selected-cell").length)){x();var e,t,a=F(S());if(null==a)return;var n=C.$el.find(".fr-selected-cell"),r=k(n[0]),i=r.parent().find(".fr-selected-cell"),o=r.closest("table"),s=r.html(),l=0;for(e=0;e<i.length;e++)l+=k(i[e]).outerWidth();for(r.css("width",Math.min(100,l/o.outerWidth()*100).toFixed(4)+"%"),a.min_j<a.max_j&&r.attr("colspan",a.max_j-a.min_j+1),a.min_i<a.max_i&&r.attr("rowspan",a.max_i-a.min_i+1),e=1;e<n.length;e++)"<br>"!=(t=k(n[e])).html()&&""!==t.html()&&(s+="<br>".concat(t.html())),t.remove();r.html(s),C.selection.setAtEnd(r.get(0)),C.selection.restore(),C.toolbar.enable(),E(a.min_i,a.max_i,o);var c=o.find("tr:empty");for(e=c.length-1;0<=e;e--)k(c[e]).remove();b(a.min_j,a.max_j,o),h()}},splitCellVertically:function de(){if(1==te().length){var e=C.$el.find(".fr-selected-cell"),t=parseInt(e.attr("colspan"),10)||1,a=e.parent().outerWidth(),n=e.outerWidth(),r=e.clone().html("<br>"),i=S(),o=R(e.get(0),i);if(1<t){var s=Math.ceil(t/2);n=X(o.col,o.col+s-1,i)/a*100;var l=X(o.col+s,o.col+t-1,i)/a*100;1<s?e.attr("colspan",s):e.removeAttr("colspan"),1<t-s?r.attr("colspan",t-s):r.removeAttr("colspan"),e.css("width",n.toFixed(4)+"%"),r.css("width",l.toFixed(4)+"%")}else{var c;for(c=0;c<i.length;c++)if(0===c||i[c][o.col]!=i[c-1][o.col]){var d=k(i[c][o.col]);if(!d.is(e)){var f=(parseInt(d.attr("colspan"),10)||1)+1;d.attr("colspan",f)}}n=n/a*100/2,e.css("width","".concat(n.toFixed(4),"%")),r.css("width","".concat(n.toFixed(4),"%"))}e[0].parentNode&&e[0].insertAdjacentElement("afterend",r[0]),I(),C.popups.hide("table.edit")}},splitCellHorizontally:function fe(){if(1==te().length){var e=C.$el.find(".fr-selected-cell"),t=e.parent(),a=e.closest("table"),n=parseInt(e.attr("rowspan"),10),r=S(),i=R(e.get(0),r),o=e.clone().html("<br>");if(1<n){var s=Math.ceil(n/2);1<s?e.attr("rowspan",s):e.removeAttr("rowspan"),1<n-s?o.attr("rowspan",n-s):o.removeAttr("rowspan");for(var l=i.row+s,c=0===i.col?i.col:i.col-1;0<=c&&(r[l][c]==r[l][c-1]||0<l&&r[l][c]==r[l-1][c]);)c--;-1==c?k(a.find("tr").not(a.find("> table tr")).get(l)).prepend(o):k(r[l][c])[0].parentNode&&k(r[l][c])[0].insertAdjacentElement("afterend",o[0])}else{var d,f=k(document.createElement("tr")).append(o);for(d=0;d<r[0].length;d++)if(0===d||r[i.row][d]!=r[i.row][d-1]){var p=k(r[i.row][d]);p.is(e)||p.attr("rowspan",(parseInt(p.attr("rowspan"),10)||1)+1)}t[0].parentNode&&t[0].insertAdjacentElement("afterend",f[0])}I(),C.popups.hide("table.edit")}},addHeader:function pe(){var e=ae();if(0<e.length&&0===e.find("> th").length){var t,a="<thead><tr>",n=0;for(n=e.find("tr").first().find("> th").length,e.find("tr").first().find("> td").each(function(){var e=k(this);n+=parseInt(e.attr("colspan"),10)||1}),t=0;t<n;t++)a+="<th><br></th>";a+="</tr></thead>",e.prepend(a),h()}},addFooter:function ue(){var e=ae();if(0<e.length&&0===e.find("tfoot").length){var t,a="<tfoot><tr>",n=0,r="> td";for(0<e.find("thead").length&&(r="> th"),e.find("tr").first().find(r).each(function(){var e=k(this);n+=parseInt(e.attr("colspan"),10)||1}),t=0;t<n;t++)a+="<td><br></td>";a+="</tr></tfoot>",e.append(a),h()}},removeHeader:function ge(){var e=ae(),t=e.find("> thead");if(0<(t=k(t)).length)if(0===e.find("tbody tr").length)g();else if(t.remove(),0<te().length)h();else{C.popups.hide("table.edit");var a=e.find("tbody tr").first().find("td").first().get(0);a&&(C.selection.setAtEnd(a),C.selection.restore())}},removeFooter:function he(){var e=ae(),t=e.find("tfoot");if(0<t.length)if(0===e.find("tbody tr").length)g();else if(t.remove(),0<te().length)h();else{C.popups.hide("table.edit");var a=e.find("tbody tr").first().find("td").first().get(0);a&&(C.selection.setAtEnd(a),C.selection.restore())}},setBackground:t,showInsertPopup:function me(){var e=C.$tb.find('.fr-command[data-cmd="insertTable"]'),t=C.popups.get("table.insert");if(t||(t=d()),!t.hasClass("fr-active")){C.popups.refresh("table.insert"),C.popups.setContainer("table.insert",C.$tb);var a=C.button.getPosition(e),n=a.left,r=a.top;C.popups.show("table.insert",n,r,e.outerHeight())}},showEditPopup:h,showColorsPopup:s,back:function ve(){0<te().length?h():(C.popups.hide("table.insert"),C.toolbar.showInline())},verticalAlign:function be(e){C.$el.find(".fr-selected-cell").css("vertical-align",e)},horizontalAlign:function Ee(e){C.$el.find(".fr-selected-cell").css("text-align",e)},applyStyle:function _e(e,t,a,n){if(0<t.length){if(C.opts.useClasses||("TABLE"===t.get(0).tagName?function i(e,t){var a=e.childNodes;if(0<a.length)for(var n=0;n<a.length;n++)"TD"===a[n].tagName?"fr-dashed-borders"===t||"fr-highlighted"===t||"fr-thick"===t?A(a[n]):"fr-alternate-rows"===t&&a[n].style.removeProperty("background-color"):i(a[n],t)}(t.get(0),e):A(t.get(0))),!a){var r=Object.keys(n);r.splice(r.indexOf(e),1),t.removeClass(r.join(" "))}t.toggleClass(e)}},selectedTable:ae,selectedCells:te,customColor:function we(){var e=C.popups.get("table.colors").find(".fr-table-colors-hex-layer input");e.length&&t(e.val())},selectCells:N}},St.DefineIcon("insertTable",{NAME:"table",SVG_KEY:"insertTable"}),St.RegisterCommand("insertTable",{title:"Insert Table",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible("table.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("table.insert")):this.table.showInsertPopup()},plugin:"table"}),St.RegisterCommand("tableInsert",{callback:function(e,t,a){this.table.insert(t,a),this.popups.hide("table.insert")}}),St.DefineIcon("tableHeader",{NAME:"header",FA5NAME:"heading",SVG_KEY:"tableHeader"}),St.RegisterCommand("tableHeader",{title:"Table Header",focus:!1,toggle:!0,callback:function(){this.popups.get("table.edit").find('.fr-command[data-cmd="tableHeader"]').hasClass("fr-active")?this.table.removeHeader():this.table.addHeader()},refresh:function(e){var t=this.table.selectedTable();0<t.length&&(0===t.find("> thead").length?e.removeClass("fr-active").attr("aria-pressed",!1):e.addClass("fr-active").attr("aria-pressed",!0))}}),St.DefineIcon("tableFooter",{NAME:"table",FA5NAME:"table",SVG_KEY:"tableFooter"}),St.RegisterCommand("tableFooter",{title:"Table Footer",focus:!1,toggle:!0,callback:function(){this.popups.get("table.edit").find('.fr-command[data-cmd="tableFooter"]').hasClass("fr-active")?this.table.removeFooter():this.table.addFooter()},refresh:function(e){var t=this.table.selectedTable();0<t.length&&(0===t.find("tfoot").length?e.removeClass("fr-active").attr("aria-pressed",!1):e.addClass("fr-active").attr("aria-pressed",!0))}}),St.DefineIcon("tableRows",{NAME:"bars",SVG_KEY:"row"}),St.RegisterCommand("tableRows",{type:"dropdown",focus:!1,title:"Row",options:{above:"Insert row above",below:"Insert row below","delete":"Delete row"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=St.COMMANDS.tableRows.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableRows" data-param1="'+a+'" title="'+this.language.translate(t[a])+'">'+this.language.translate(t[a])+"</a></li>");return e+="</ul>"},callback:function(e,t){"above"==t||"below"==t?this.table.insertRow(t):this.table.deleteRow()}}),St.DefineIcon("tableColumns",{NAME:"bars fa-rotate-90",SVG_KEY:"columns"}),St.RegisterCommand("tableColumns",{type:"dropdown",focus:!1,title:"Column",options:{before:"Insert column before",after:"Insert column after","delete":"Delete column"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=St.COMMANDS.tableColumns.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableColumns" data-param1="'.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.language.translate(t[a]),"</a></li>"));return e+="</ul>"},callback:function(e,t){"before"==t||"after"==t?this.table.insertColumn(t):this.table.deleteColumn()}}),St.DefineIcon("tableCells",{NAME:"square-o",FA5NAME:"square",SVG_KEY:"cellOptions"}),St.RegisterCommand("tableCells",{type:"dropdown",focus:!1,title:"Cell",options:{merge:"Merge cells","vertical-split":"Vertical split","horizontal-split":"Horizontal split"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=St.COMMANDS.tableCells.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCells" data-param1="'.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.language.translate(t[a]),"</a></li>"));return e+="</ul>"},callback:function(e,t){"merge"==t?this.table.mergeCells():"vertical-split"==t?this.table.splitCellVertically():this.table.splitCellHorizontally()},refreshOnShow:function(e,t){1<this.$el.find(".fr-selected-cell").length?(t.find('a[data-param1="vertical-split"]').addClass("fr-disabled").attr("aria-disabled",!0),t.find('a[data-param1="horizontal-split"]').addClass("fr-disabled").attr("aria-disabled",!0),t.find('a[data-param1="merge"]').removeClass("fr-disabled").attr("aria-disabled",!1)):(t.find('a[data-param1="merge"]').addClass("fr-disabled").attr("aria-disabled",!0),t.find('a[data-param1="vertical-split"]').removeClass("fr-disabled").attr("aria-disabled",!1),t.find('a[data-param1="horizontal-split"]').removeClass("fr-disabled").attr("aria-disabled",!1))}}),St.DefineIcon("tableRemove",{NAME:"trash",SVG_KEY:"removeTable"}),St.RegisterCommand("tableRemove",{title:"Remove Table",focus:!1,callback:function(){this.table.remove()}}),St.DefineIcon("tableStyle",{NAME:"paint-brush",SVG_KEY:"tableStyle"}),St.RegisterCommand("tableStyle",{title:"Table Style",type:"dropdown",focus:!1,html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.tableStyles;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableStyle" data-param1="'.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.language.translate(t[a]),"</a></li>"));return e+="</ul>"},callback:function(e,t){this.table.applyStyle(t,this.$el.find(".fr-selected-cell").closest("table"),this.opts.tableMultipleStyles,this.opts.tableStyles)},refreshOnShow:function(e,t){var a=this.$,n=this.$el.find(".fr-selected-cell").closest("table");n&&t.find(".fr-command").each(function(){var e=a(this).data("param1"),t=n.hasClass(e);a(this).toggleClass("fr-active",t).attr("aria-selected",t)})}}),St.DefineIcon("tableCellBackground",{NAME:"tint",SVG_KEY:"cellBackground"}),St.RegisterCommand("tableCellBackground",{title:"Cell Background",focus:!1,popup:!0,callback:function(){this.table.showColorsPopup()}}),St.RegisterCommand("tableCellBackgroundColor",{undo:!0,focus:!1,callback:function(e,t){this.table.setBackground(t)}}),St.DefineIcon("tableBack",{NAME:"arrow-left",SVG_KEY:"back"}),St.RegisterCommand("tableBack",{title:"Back",undo:!1,focus:!1,back:!0,callback:function(){this.table.back()},refresh:function(e){0!==this.table.selectedCells().length||this.opts.toolbarInline?(e.removeClass("fr-hidden"),e.next(".fr-separator").removeClass("fr-hidden")):(e.addClass("fr-hidden"),e.next(".fr-separator").addClass("fr-hidden"))}}),St.DefineIcon("tableCellVerticalAlign",{NAME:"arrows-v",FA5NAME:"arrows-alt-v",SVG_KEY:"verticalAlignMiddle"}),St.RegisterCommand("tableCellVerticalAlign",{type:"dropdown",focus:!1,title:"Vertical Align",options:{Top:"Align Top",Middle:"Align Middle",Bottom:"Align Bottom"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=St.COMMANDS.tableCellVerticalAlign.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCellVerticalAlign" data-param1="'.concat(a.toLowerCase(),'" title="').concat(this.language.translate(t[a]),'">').concat(this.language.translate(a),"</a></li>"));return e+="</ul>"},callback:function(e,t){this.table.verticalAlign(t)},refreshOnShow:function(e,t){t.find('.fr-command[data-param1="'+this.$el.find(".fr-selected-cell").css("vertical-align")+'"]').addClass("fr-active").attr("aria-selected",!0)}}),St.DefineIcon("tableCellHorizontalAlign",{NAME:"align-left",SVG_KEY:"alignLeft"}),St.DefineIcon("align-left",{NAME:"align-left",SVG_KEY:"alignLeft"}),St.DefineIcon("align-right",{NAME:"align-right",SVG_KEY:"alignRight"}),St.DefineIcon("align-center",{NAME:"align-center",SVG_KEY:"alignCenter"}),St.DefineIcon("align-justify",{NAME:"align-justify",SVG_KEY:"alignJustify"}),St.RegisterCommand("tableCellHorizontalAlign",{type:"dropdown",focus:!1,title:"Horizontal Align",options:{left:"Align Left",center:"Align Center",right:"Align Right",justify:"Align Justify"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=St.COMMANDS.tableCellHorizontalAlign.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="tableCellHorizontalAlign" data-param1="'.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.icon.create("align-".concat(a)),'<span class="fr-sr-only">').concat(this.language.translate(t[a]),"</span></a></li>"));return e+="</ul>"},callback:function(e,t){this.table.horizontalAlign(t)},refresh:function(e){var t=this.table.selectedCells(),a=this.$;t.length&&e.find("> *").first().replaceWith(this.icon.create("align-".concat(this.helpers.getAlignment(a(t[0])))))},refreshOnShow:function(e,t){t.find('.fr-command[data-param1="'+this.helpers.getAlignment(this.$el.find(".fr-selected-cell").first())+'"]').addClass("fr-active").attr("aria-selected",!0)}}),St.DefineIcon("tableCellStyle",{NAME:"magic",SVG_KEY:"cellStyle"}),St.RegisterCommand("tableCellStyle",{title:"Cell Style",type:"dropdown",focus:!1,html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.tableCellStyles;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCellStyle" data-param1="'.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.language.translate(t[a]),"</a></li>"));return e+="</ul>"},callback:function(e,t){this.table.applyStyle(t,this.$el.find(".fr-selected-cell"),this.opts.tableCellMultipleStyles,this.opts.tableCellStyles)},refreshOnShow:function(e,t){var a=this.$,n=this.$el.find(".fr-selected-cell").first();n&&t.find(".fr-command").each(function(){var e=a(this).data("param1"),t=n.hasClass(e);a(this).toggleClass("fr-active",t).attr("aria-selected",t)})}}),St.RegisterCommand("tableCellBackgroundCustomColor",{title:"OK",undo:!0,callback:function(){this.table.customColor()}}),St.DefineIcon("tableColorRemove",{NAME:"eraser",SVG_KEY:"remove"}),St.URLRegEx="(^| |\\u00A0)(".concat(St.LinkRegEx,"|([a-z0-9+-_.]{1,}@[a-z0-9+-_.]{1,}\\.[a-z0-9+-_]{1,}))$"),St.PLUGINS.url=function(f){var p=f.$,i=null;function t(e,t,a){for(var n="";a.length&&"."==a[a.length-1];)n+=".",a=a.substring(0,a.length-1);var r=a;if(f.opts.linkConvertEmailAddress)f.helpers.isEmail(r)&&!/^mailto:.*/i.test(r)&&(r="mailto:".concat(r));else if(f.helpers.isEmail(r))return t+a;return/^((http|https|ftp|ftps|mailto|tel|sms|notes|data)\:)/i.test(r)||(r="//".concat(r)),(t||"")+"<a".concat(f.opts.linkAlwaysBlank?' target="_blank"':"").concat(i?' rel="'.concat(i,'"'):"",' data-fr-linked="true" href="').concat(r,'">').concat(a.replace(/&amp;/g,"&").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;"),"</a>").concat(n)}var u=function u(){return new RegExp(St.URLRegEx,"gi")};function g(e){return f.opts.linkAlwaysNoFollow&&(i="nofollow"),f.opts.linkAlwaysBlank&&(f.opts.linkNoOpener&&(i?i+=" noopener":i="noopener"),f.opts.linkNoReferrer&&(i?i+=" noreferrer":i="noreferrer")),e.replace(u(),t)}function h(e){var t=e.split(" ");return t[t.length-1]}function a(){var e=f.selection.ranges(0),t=e.startContainer;if(t.nodeType!==Node.TEXT_NODE)return!1;if(!t||e.startOffset!==(t.textContent||"").length){f.markers.insert();var a=f.$el.find(".fr-marker"),n=t.textContent.match(/(^| |\u00A0)(((([a-z\u0080-\u009f\u00a1-\uffff0-9-_\.]{1,})(\.(com|net|org|edu|mil|gov|co|biz|info|me|dev)))|((ftp|http|https):\/\/[a-z\u0080-\u009f\u00a1-\uffff0-9-_\.]{1,})|(www\.[a-z\u0080-\u009f\u00a1-\uffff0-9-_\.]{1,}\.[a-z0-9-]{2,24})|((ftp|http|https):\/\/[\u0021-\uffff]{1,}@[a-z\u0080-\u009f\u00a1-\uffff0-9-_\.]{1,}))((:[0-9]{1,5})|)(((\/|\?|#)[a-z\u00a1-\uffff0-9@?\|!^=%&amp;\/~+#-\'*-_{}]*)|())|([a-z0-9+-_.]{1,}@[a-z0-9+-_.]{1,}\.[a-z0-9+-_]{1,}))$/gi);if(a.remove(),!n)return!1}if(function d(e){return!!e&&("A"===e.tagName||!(!e.parentNode||e.parentNode==f.el)&&d(e.parentNode))}(t))return!1;if(u().test(h(t.textContent))){var r,i=t.textContent.length;if(0<i&&","===t.textContent.charAt(i-1)){p(t).before(g(t.textContent.substring(0,i-1))),(r=p(t.parentNode).find("a[data-fr-linked]")).removeAttr("data-fr-linked"),t.textContent=",";var o=f.win.getSelection().getRangeAt(0);o.setStart(t,1),o.setEnd(t,1)}else p(t).before(g(t.textContent)),(r=p(t.parentNode).find("a[data-fr-linked]")).removeAttr("data-fr-linked"),t.parentNode.removeChild(t);f.events.trigger("url.linked",[r.get(0)])}else if(t.textContent.split(" ").length<=2&&t.previousSibling&&"A"===t.previousSibling.tagName){var s=t.previousSibling.innerText+t.textContent,l=t.textContent.length;if(u().test(h(s))&&","!==t.textContent.charAt(l-1)){var c=(new DOMParser).parseFromString(g(s),"text/html").body.childNodes;t.parentNode.replaceChild(c[0],t.previousSibling),c.length&&p(t).before(c[0]),t.parentNode.removeChild(t)}}}return{_init:function e(){f.events.on("keypress",function(e){!f.selection.isCollapsed()||")"!=e.key&&"("!=e.key||a()},!0),f.events.on("keydown",function(e){var t=e.which;!f.selection.isCollapsed()||t!=St.KEYCODE.ENTER&&t!=St.KEYCODE.SPACE||a()},!0),f.events.on("paste.beforeCleanup",function(e){if(f.helpers.isURL(e)&&!f.$el[0].getAttribute("plainpaste")){var t=null;return f.opts.linkAlwaysBlank&&(f.opts.linkNoOpener&&(t?t+=" noopener":t="noopener"),f.opts.linkNoReferrer&&(t?t+=" noreferrer":t="noreferrer")),"<a".concat(f.opts.linkAlwaysBlank?' target="_blank"':"").concat(t?' rel="'.concat(t,'"'):"",' href="').concat(e,'" >').concat(e,"</a>")}if(f.$el[0].getAttribute("plainpaste"))return function a(e){if("string"==typeof e)return(e=e.replace(/&amp;/g,"&")).replace(/(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim,g).replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gim,g)}(e)})}}},Object.assign(St.POPUP_TEMPLATES,{"video.insert":"[_BUTTONS_][_BY_URL_LAYER_][_EMBED_LAYER_][_UPLOAD_LAYER_][_PROGRESS_BAR_]","video.edit":"[_BUTTONS_]","video.size":"[_BUTTONS_][_SIZE_LAYER_]"}),Object.assign(St.DEFAULTS,{videoAllowedTypes:["mp4","webm","ogg","mp3","mpeg","url"],videoAllowedProviders:[".*"],videoDefaultAlign:"center",videoDefaultDisplay:"block",videoDefaultWidth:600,videoEditButtons:["videoReplace","videoRemove","videoDisplay","videoAlign","videoSize","autoplay"],videoInsertButtons:["videoBack","|","videoByURL","videoEmbed","videoUpload"],videoMaxSize:52428800,videoMove:!0,videoResize:!0,videoResponsive:!1,videoSizeButtons:["videoBack","|"],videoSplitHTML:!1,videoTextNear:!0,videoUpload:!0,videoUploadMethod:"POST",videoUploadParam:"file",videoUploadParams:{},videoUploadToS3:!1,videoUploadToAzure:!1,videoUploadURL:null}),St.VIDEO_PROVIDERS=[{test_regex:/^.*((youtu.be)|(youtube.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))?\/?((shorts\/)|(v=))?([^#\&\?]*).*/,url_regex:/(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/|shorts\/)?([0-9a-zA-Z_\-]+)(.*)?/g,url_text:"https://www.youtube.com/embed/$1?$2",html:'<iframe width="640" height="360" src="{url}&wmode=opaque&rel=0" frameborder="0" allowfullscreen></iframe>',provider:"youtube"},{test_regex:/^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/\u200b\d+\/|video\/|)(\d+)(?:$|\/|\?)/,url_regex:/(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?(\/[a-zA-Z0-9_\-]+)?/i,url_text:"https://player.vimeo.com/video/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',provider:"vimeo"},{test_regex:/^.+(dailymotion.com|dai.ly)\/(video|hub)?\/?([^_]+)[^#]*(#video=([^_&]+))?/,url_regex:/(?:https?:\/\/)?(?:www\.)?(?:dailymotion\.com|dai\.ly)\/(?:video|hub)?\/?(.+)/g,url_text:"https://www.dailymotion.com/embed/video/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',provider:"dailymotion"},{test_regex:/^.+(screen.yahoo.com)\/[^_&]+/,url_regex:"",url_text:"",html:'<iframe width="640" height="360" src="{url}?format=embed" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',provider:"yahoo"},{test_regex:/^.+(rutube.ru)\/[^_&]+/,url_regex:/(?:https?:\/\/)?(?:www\.)?(?:rutube\.ru)\/(?:video)?\/?(.+)/g,url_text:"https://rutube.ru/play/embed/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',provider:"rutube"},{test_regex:/^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/,url_regex:/^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/g,url_text:"https://play.vidyard.com/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',provider:"vidyard"}],St.VIDEO_EMBED_REGEX=/^\W*(<div[^>]*>\s*<iframe[^>]*>.*?<\/iframe>\s*<\/div>(\s*<script[^>]*>.*?<\/script>)?|<iframe[^>]*>.*?<\/iframe>|<embed(.|\n)*>)\W*$/i,St.PLUGINS.video=function(_){var s,d,f,w,n,a,y=_.$,A="https://i.froala.com/upload",p=2,u=3,g=4,C=5,T=6,r={};function h(){var e=_.popups.get("video.insert");e.find(".fr-video-by-url-layer input").val("").trigger("change");var t=e.find(".fr-video-embed-layer textarea");t.val("").trigger("change"),(t=e.find(".fr-video-upload-layer input")).val("").trigger("change")}function i(){var e=_.popups.get("video.edit");if(e||(e=function o(){var e="";if(0<_.opts.videoEditButtons.length){_.opts.videoResponsive&&(-1<_.opts.videoEditButtons.indexOf("videoSize")&&_.opts.videoEditButtons.splice(_.opts.videoEditButtons.indexOf("videoSize"),1),-1<_.opts.videoEditButtons.indexOf("videoDisplay")&&_.opts.videoEditButtons.splice(_.opts.videoEditButtons.indexOf("videoDisplay"),1),-1<_.opts.videoEditButtons.indexOf("videoAlign")&&_.opts.videoEditButtons.splice(_.opts.videoEditButtons.indexOf("videoAlign"),1));var t={buttons:e+='<div class="fr-buttons"> \n      '.concat(_.button.buildList(_.opts.videoEditButtons)," \n      </div>")},a=_.popups.create("video.edit",t);return _.events.$on(_.$wp,"scroll.video-edit",function(){w&&_.popups.isVisible("video.edit")&&(_.events.disableBlur(),c(w))}),a}return!1}()),e){_.popups.setContainer("video.edit",_.$sc),_.popups.refresh("video.edit");var t=w.find("iframe, embed, ".concat(w.find("iframe, embed, audio").get(0)?"audio":"video")),a=t.offset().left+t.outerWidth()/2,n=t.offset().top+t.outerHeight(),r=t.get(0).src?t.get(0).src:t.get(0).currentSrc,i=!(!(r=(r=r.split("."))[r.length-1]).includes("pdf")&&!r.includes("txt"));t.hasClass("fr-file")||i||w.find("audio").get(0)?(document.getElementById("autoplay-".concat(_.id))&&(document.getElementById("autoplay-".concat(_.id)).style.display="none"),document.getElementById("videoReplace-".concat(_.id))&&(document.getElementById("videoReplace-".concat(_.id)).style.display="none")):(document.getElementById("autoplay-".concat(_.id))&&(document.getElementById("autoplay-".concat(_.id)).style.display=""),document.getElementById("videoReplace-".concat(_.id))&&(document.getElementById("videoReplace-".concat(_.id)).style.display="")),_.popups.show("video.edit",a,n,t.outerHeight(),!0)}}function o(e){if(e)return _.popups.onRefresh("video.insert",h),_.popups.onHide("video.insert",Z),!0;var t="";_.opts.videoUpload||-1===_.opts.videoInsertButtons.indexOf("videoUpload")||_.opts.videoInsertButtons.splice(_.opts.videoInsertButtons.indexOf("videoUpload"),1);var a=_.button.buildList(_.opts.videoInsertButtons);""!==a&&(t='<div class="fr-buttons">'+a+"</div>");var n,r="",i=_.opts.videoInsertButtons.indexOf("videoUpload"),o=_.opts.videoInsertButtons.indexOf("videoByURL"),s=_.opts.videoInsertButtons.indexOf("videoEmbed");if(0<=o){n=" fr-active",(i<o&&0<=i||s<o&&0<=s)&&(n="");r='<div class="fr-video-by-url-layer fr-layer'.concat(n,'" id="fr-video-by-url-layer-').concat(_.id,'"><div class="fr-input-line"><input id="fr-video-by-url-layer-text-').concat(_.id,'" type="text" placeholder="').concat(_.language.translate("Paste in a video URL"),'" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><span style=\'float:left\'><div class="fr-checkbox-line fr-autoplay-margin"><span class="fr-checkbox"> <input id=\'videoPluginAutoplay\' data-checked="_blank" type="checkbox"> <span>').concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>','</span></span> <label id="fr-label-target-').concat(_.id,'">Autoplay</label></div> </span><button type="button" class="fr-command fr-submit" data-cmd="videoInsertByURL" tabIndex="2" role="button">').concat(_.language.translate("Insert"),"</button></div></div>")}var l="";0<=s&&(n=" fr-active",(i<s&&0<=i||o<s&&0<=o)&&(n=""),l='<div class="fr-video-embed-layer fr-layer'.concat(n,'" id="fr-video-embed-layer-').concat(_.id,'"><div class="fr-input-line"><textarea id="fr-video-embed-layer-text').concat(_.id,'" type="text" placeholder="').concat(_.language.translate("Embedded Code"),'" tabIndex="1" aria-required="true" rows="5"></textarea></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="videoInsertEmbed" tabIndex="2" role="button">').concat(_.language.translate("Insert"),"</button></div></div>"));var c="";0<=i&&(n=" fr-active",(s<i&&0<=s||o<i&&0<=o)&&(n=""),c='<div class="fr-video-upload-layer fr-layer'.concat(n,'" id="fr-video-upload-layer-').concat(_.id,'"><strong>').concat(_.language.translate("Drop video"),"</strong><br>(").concat(_.language.translate("or click"),')<div class="fr-form"><input type="file" accept="video/').concat(_.opts.videoAllowedTypes.join(", video/").toLowerCase(),'" tabIndex="-1" aria-labelledby="fr-video-upload-layer-').concat(_.id,'" role="button"></div></div>'));var d={buttons:t,by_url_layer:r,embed_layer:l,upload_layer:c,progress_bar:'<div class="fr-video-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="videoDismissError" tabIndex="2" role="button">OK</button></div></div>'},f=_.popups.create("video.insert",d);return function p(n){_.events.$on(n,"dragover dragenter",".fr-video-upload-layer",function(){return y(this).addClass("fr-drop"),!1},!0),_.events.$on(n,"dragleave dragend",".fr-video-upload-layer",function(){return y(this).removeClass("fr-drop"),!1},!0),_.events.$on(n,"drop",".fr-video-upload-layer",function(e){e.preventDefault(),e.stopPropagation(),y(this).removeClass("fr-drop");var t=e.originalEvent.dataTransfer;if(t&&t.files){var a=n.data("instance")||_;a.events.disableBlur(),a.video.upload(t.files),a.events.enableBlur()}},!0),_.helpers.isIOS()&&_.events.$on(n,"touchstart",'.fr-video-upload-layer input[type="file"]',function(){y(this).trigger("click")},!0);_.events.$on(n,"change",'.fr-video-upload-layer input[type="file"]',function(){if(this.files){var e=n.data("instance")||_;e.events.disableBlur(),n.find("input:focus").blur(),e.events.enableBlur(),e.video.upload(this.files)}y(this).val("")},!0)}(f),f}function m(e){_.events.focus(!0),_.selection.restore();var t=!1;if(w&&(X(),t=!0),_.opts.trackChangesEnabled){_.edit.on(),_.events.focus(!0),_.selection.restore(),_.undo.saveStep(),_.markers.insert(),_.html.wrap();var a=_.$el.find(".fr-marker");_.node.isLastSibling(a)&&a.parent().hasClass("fr-deletable")&&a.insertAfter(a.parent()),a.replaceWith('<span contenteditable="false" draggable="true" class="fr-jiv fr-video fr-deletable">'.concat(e,"</span>")),_.selection.clear()}else _.html.insert('<span contenteditable="false" draggable="true" class="fr-jiv fr-video fr-deletable">'.concat(e,"</span>"),!1,_.opts.videoSplitHTML);_.popups.hide("video.insert");var n=_.$el.find(".fr-jiv");n.removeClass("fr-jiv"),n.toggleClass("fr-rv",_.opts.videoResponsive),Q(n,_.opts.videoDefaultDisplay,_.opts.videoDefaultAlign),n.toggleClass("fr-draggable",_.opts.videoMove),_.events.trigger(t?"video.replaced":"video.inserted",[n])}function v(){var e=y(this);_.popups.hide("video.insert"),e.removeClass("fr-uploading"),e.parent().next().is("br")&&e.parent().next().remove(),c(e.parent()),_.events.trigger("video.loaded",[e.parent()])}function k(s,e,l,c,d,f){_.edit.off(),b("Loading video"),e&&(s=_.helpers.sanitizeURL(s));var p=function p(){var e,t;if(c){_.undo.canDo()||c.find("video").hasClass("fr-uploading")||_.undo.saveStep();var a=c.find("video").data("fr-old-src"),n=c.data("fr-replaced");if(c.data("fr-replaced",!1),0<c.find("iframe").length)c.remove(),e=O(s,l,v);else{_.$wp?((e=c.clone(!0)).find("video").removeData("fr-old-src").removeClass("fr-uploading"),e.find("video").off("canplay"),a&&c.find("video").attr("src",a),c.replaceWith(e)):e=c;for(var r=e.find("video").get(0).attributes,i=0;i<r.length;i++){var o=r[i];0===o.nodeName.indexOf("data-")&&e.find("video").removeAttr(o.nodeName)}if(void 0!==l)for(t in l)l.hasOwnProperty(t)&&"link"!=t&&e.find("video").attr("data-".concat(t),l[t]);e.find("video").on("canplay",v),e.find("video").attr("src",s)}_.edit.on(),B(),_.undo.saveStep(),_.$el.blur(),_.events.trigger(n?"video.replaced":"video.inserted",[e,d])}else e=O(s,l,v,f),B(),_.undo.saveStep(),_.events.trigger("video.inserted",[e,d])};S("Loading video"),p()}function S(e){var t=_.popups.get("video.insert");if(t||(t=o()),t.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"),t.find(".fr-video-progress-bar-layer").addClass("fr-active"),t.find(".fr-buttons").hide(),w){var a=w.find("iframe, embed, ".concat(w.find("iframe, embed, audio").get(0)?"audio":"video"));_.popups.setContainer("video.insert",_.$sc);var n=a.offset().left,r=a.offset().top+a.height();_.popups.show("video.insert",n,r,a.outerHeight())}void 0===e&&b(_.language.translate("Uploading"),0)}function l(e){var t=_.popups.get("video.insert");if(t&&(t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"),t.find(".fr-video-progress-bar-layer").removeClass("fr-active"),t.find(".fr-buttons").show(),e||_.$el.find("video.fr-error").length)){if(_.events.focus(),_.$el.find("video.fr-error").length&&(_.$el.find("video.fr-error").parent().remove(),_.undo.saveStep(),_.undo.run(),_.undo.dropRedo()),!_.$wp&&w){var a=w;H(!0),_.selection.setAfter(a.find("video").get(0)),_.selection.restore()}_.popups.hide("video.insert")}}function b(e,t){var a=_.popups.get("video.insert");if(a){var n=a.find(".fr-video-progress-bar-layer");n.find("h3").text(e+(t?" ".concat(t,"%"):"")),n.removeClass("fr-error"),t?(n.find("div").removeClass("fr-indeterminate"),n.find("div > span").css("width","".concat(t,"%"))):n.find("div").addClass("fr-indeterminate")}}function E(e){S();var t=_.popups.get("video.insert").find(".fr-video-progress-bar-layer");t.addClass("fr-error");var a=t.find("h3");a.text(e),_.events.disableBlur(),a.focus()}function c(e){t.call(e.get(0))}function R(e,t,a){b("Loading video");var n=this.status,r=this.response,i=this.responseXML,o=this.responseText;try{if(_.opts.videoUploadToS3||_.opts.videoUploadToAzure)if(201==n){var s;if(_.opts.videoUploadToAzure){if(!1===_.events.trigger("video.uploadedToAzure",[this.responseURL,a,r],!0))return _.edit.on(),!1;s=t}else s=function c(e){try{var t=y(e).find("Location").text(),a=y(e).find("Key").text();return!1===_.events.trigger("video.uploadedToS3",[t,a,e],!0)?(_.edit.on(),!1):t}catch(n){return G(g,e),!1}}(i);s&&k(s,!1,[],e,r||i)}else G(g,r||i);else if(200<=n&&n<300){var l=function d(e){try{if(!1===_.events.trigger("video.uploaded",[e],!0))return _.edit.on(),!1;var t=JSON.parse(e);return t.link?t:(G(p,e),!1)}catch(a){return G(g,e),!1}}(o);l&&k(l.link,!1,l,e,r||o)}else G(u,r||o)}catch(f){G(g,r||o)}}function L(){G(g,this.response||this.responseText||this.responseXML)}function x(e){if(e.lengthComputable){var t=e.loaded/e.total*100|0;b(_.language.translate("Uploading"),t)}}function I(){_.edit.on(),l(!0)}function O(e,t,a,n){var r,i,o="";if(t&&void 0!==t)for(r in t)t.hasOwnProperty(r)&&"link"!=r&&(o+=" ".concat(r,'="').concat(t[r],'"'));var s=_.opts.videoDefaultWidth;s&&"auto"!=s&&(s="".concat(s,"px")),_.helpers.isMobile()&&_.browser.safari&&(o+=" autoplay playsinline"),(i="audio"==n?y(document.createElement("span")).attr("contenteditable","false").attr("draggable","true").attr("class","fr-video fr-dv"+_.opts.videoDefaultDisplay[0]+("center"!=_.opts.videoDefaultAlign?" fr-fv"+_.opts.videoDefaultAlign[0]:"")).html('<audio src="'+e+'" '+o+" controls>"+_.language.translate("Your browser does not support HTML5 video.")+"</audio>"):y(document.createElement("span")).attr("contenteditable","false").attr("draggable","true").attr("class","fr-video fr-dv"+_.opts.videoDefaultDisplay[0]+("center"!=_.opts.videoDefaultAlign?" fr-fv"+_.opts.videoDefaultAlign[0]:"")).html('<video src="'+e+'" '+o+(s?' style="width: '+s+';" ':"")+" controls>"+_.language.translate("Your browser does not support HTML5 video.")+"</video>")).toggleClass("fr-draggable",_.opts.videoMove),_.edit.on(),_.events.focus(!0),_.selection.restore(),_.undo.saveStep(),_.opts.videoSplitHTML?_.markers.split():(_.cursor.enter(),_.markers.insert()),_.html.wrap();var l=_.$el.find(".fr-marker");return _.node.isLastSibling(l)&&l.parent().hasClass("fr-deletable")&&l.insertAfter(l.parent()),l.replaceWith(i),_.selection.clear(),"audio"!==n&&(i.find("video").get(0).readyState>i.find("video").get(0).HAVE_FUTURE_DATA||_.helpers.isIOS()?a.call(i.find("video").get(0)):i.find("video").on("canplaythrough load",a)),i}function F(e){if(!_.core.sameInstance(f))return!0;e.preventDefault(),e.stopPropagation();var t=e.pageX||(e.originalEvent.touches?e.originalEvent.touches[0].pageX:null),a=e.pageY||(e.originalEvent.touches?e.originalEvent.touches[0].pageY:null);if(!t||!a)return!1;if("mousedown"==e.type){var n=_.$oel.get(0).ownerDocument,r=n.defaultView||n.parentWindow,i=!1;try{i=r.location!=r.parent.location&&!(r.$&&r.$.FE)}catch(o){}i&&r.frameElement&&(t+=_.helpers.getPX(y(r.frameElement).offset().left)+r.frameElement.clientLeft,a=e.clientY+_.helpers.getPX(y(r.frameElement).offset().top)+r.frameElement.clientTop)}_.undo.canDo()||_.undo.saveStep(),(d=y(this)).data("start-x",t),d.data("start-y",a),s.show(),_.popups.hideAll(),z()}function M(e){if(!_.core.sameInstance(f))return!0;if(d){e.preventDefault();var t=e.pageX||(e.originalEvent.touches?e.originalEvent.touches[0].pageX:null),a=e.pageY||(e.originalEvent.touches?e.originalEvent.touches[0].pageY:null);if(!t||!a)return!1;var n=d.data("start-x"),r=d.data("start-y");d.data("start-x",t),d.data("start-y",a);var i=t-n,o=a-r,s=w.find("iframe, embed, ".concat(w.find("iframe, embed, audio").get(0)?"audio":"video")),l=s.width(),c=s.height();(d.hasClass("fr-hnw")||d.hasClass("fr-hsw"))&&(i=0-i),(d.hasClass("fr-hnw")||d.hasClass("fr-hne"))&&(o=0-o),s.css("width",l+i),s.css("height",c+o),s.removeAttr("width"),s.removeAttr("height"),U()}}function N(e){if(!_.core.sameInstance(f))return!0;d&&w&&(e&&e.stopPropagation(),d=null,s.hide(),U(),i(),_.undo.saveStep())}function D(e){return'<div class="fr-handler fr-h'.concat(e,'"></div>')}function P(e,t,a,n){return e.pageX=t,e.pageY=t,F.call(this,e),e.pageX=e.pageX+a*Math.floor(Math.pow(1.1,n)),e.pageY=e.pageY+a*Math.floor(Math.pow(1.1,n)),M.call(this,e),N.call(this,e),++n}function B(){var e,t=Array.prototype.slice.call(_.el.querySelectorAll("video, .fr-video > *")),a=[];for(e=0;e<t.length;e++)a.push(t[e].getAttribute("src")),y(t[e]).toggleClass("fr-draggable",_.opts.videoMove),""===t[e].getAttribute("class")&&t[e].removeAttribute("class"),""===t[e].getAttribute("style")&&t[e].removeAttribute("style");if(n)for(e=0;e<n.length;e++)a.indexOf(n[e].getAttribute("src"))<0&&_.events.trigger("video.removed",[y(n[e])]);n=t}function U(){f||function o(){var e;if(_.shared.$video_resizer?(f=_.shared.$video_resizer,s=_.shared.$vid_overlay,_.events.on("destroy",function(){y("body").first().append(f.removeClass("fr-active"))},!0)):(_.shared.$video_resizer=y(document.createElement("div")).attr("class","fr-video-resizer"),f=_.shared.$video_resizer,_.events.$on(f,"mousedown",function(e){e.stopPropagation()},!0),_.opts.videoResize&&(f.append(D("nw")+D("ne")+D("sw")+D("se")),_.shared.$vid_overlay=y(document.createElement("div")).attr("class","fr-video-overlay"),s=_.shared.$vid_overlay,e=f.get(0).ownerDocument,y(e).find("body").first().append(s))),_.events.on("shared.destroy",function(){f.html("").removeData().remove(),f=null,_.opts.videoResize&&(s.remove(),s=null)},!0),_.helpers.isMobile()||_.events.$on(y(_.o_win),"resize.video",function(){H(!0)}),_.opts.videoResize){e=f.get(0).ownerDocument,_.events.$on(f,_._mousedown,".fr-handler",F),_.events.$on(y(e),_._mousemove,M),_.events.$on(y(e.defaultView||e.parentWindow),_._mouseup,N),_.events.$on(s,"mouseleave",N);var n=1,r=null,i=0;_.events.on("keydown",function(e){if(w){var t=-1!=navigator.userAgent.indexOf("Mac OS X")?e.metaKey:e.ctrlKey,a=e.which;(a!==r||200<e.timeStamp-i)&&(n=1),(a==St.KEYCODE.EQUALS||_.browser.mozilla&&a==St.KEYCODE.FF_EQUALS)&&t&&!e.altKey?n=P.call(this,e,1,1,n):(a==St.KEYCODE.HYPHEN||_.browser.mozilla&&a==St.KEYCODE.FF_HYPHEN)&&t&&!e.altKey&&(n=P.call(this,e,2,-1,n)),r=a,i=e.timeStamp}}),_.events.on("keyup",function(){n=1})}}(),(_.$wp||_.$sc).append(f),f.data("instance",_);var e=w.find("iframe, embed, ".concat(w.find("iframe, embed, audio").get(0)?"audio":"video")),t=0,a=0;_.opts.iframe&&(a=_.helpers.getPX(_.$wp.find(".fr-iframe").css("padding-top")),t=_.helpers.getPX(_.$wp.find(".fr-iframe").css("padding-left"))),f.css("top",(_.opts.iframe?e.offset().top+a-1:e.offset().top-_.$wp.offset().top-1)+_.$wp.scrollTop()).css("left",(_.opts.iframe?e.offset().left+t-1:e.offset().left-_.$wp.offset().left-1)+_.$wp.scrollLeft()).css("width",e.get(0).getBoundingClientRect().width).css("height",e.get(0).getBoundingClientRect().height).addClass("fr-active")}function t(e){if(e&&"touchend"==e.type&&a)return!0;if(e&&_.edit.isDisabled())return e.stopPropagation(),e.preventDefault(),!1;if(_.edit.isDisabled())return!1;for(var t=0;t<St.INSTANCES.length;t++)St.INSTANCES[t]!=_&&St.INSTANCES[t].events.trigger("video.hideResizer");_.toolbar.disable(),_.helpers.isMobile()&&(_.events.disableBlur(),_.$el.blur(),_.events.enableBlur()),_.$el.find(".fr-video.fr-active").removeClass("fr-active"),(w=y(this)).addClass("fr-active"),_.opts.iframe&&_.size.syncIframe(),te(),U(),i(),_.selection.clear(),_.button.bulkRefresh(),_.events.trigger("image.hideResizer")}function H(e){w&&(function t(){return _.shared.vid_exit_flag}()||!0===e)&&(f.removeClass("fr-active"),_.toolbar.enable(),w.removeClass("fr-active"),w=null,z())}function $(){_.shared.vid_exit_flag=!0}function z(){_.shared.vid_exit_flag=!1}function W(e){var t=e.originalEvent.dataTransfer;if(t&&t.files&&t.files.length){var a=t.files[0];if(a&&a.type&&-1!==a.type.indexOf("video")){if(!_.opts.videoUpload)return e.preventDefault(),e.stopPropagation(),!1;_.markers.remove(),_.markers.insertAtPoint(e.originalEvent),_.$el.find(".fr-marker").replaceWith(St.MARKERS),_.popups.hideAll();var n=_.popups.get("video.insert");return n||(n=o()),_.popups.setContainer("video.insert",_.$sc),_.popups.show("video.insert",e.originalEvent.pageX,e.originalEvent.pageY),S(),0<=_.opts.videoAllowedTypes.indexOf(a.type.replace(/video\//g,""))?K(t.files):G(T),e.preventDefault(),e.stopPropagation(),!1}}}function K(e){if(void 0!==e&&0<e.length){if(!1===_.events.trigger("video.beforeUpload",[e]))return!1;var t,a=e[0];if(!(null!==_.opts.videoUploadURL&&_.opts.videoUploadURL!=A||_.opts.videoUploadToS3||_.opts.videoUploadToAzure))return function E(n){w&&w.find("iframe")&&w.find("iframe").length&&X();var r=new FileReader;r.onload=function(){r.result;for(var e=atob(r.result.split(",")[1]),t=[],a=0;a<e.length;a++)t.push(e.charCodeAt(a));k(window.URL.createObjectURL(new Blob([new Uint8Array(t)],{type:n.type})),!1,null,w)},S(),r.readAsDataURL(n)}(a),!1;if(a.size>_.opts.videoMaxSize)return G(C),!1;if(_.opts.videoAllowedTypes.indexOf(a.type.replace(/video\//g,""))<0)return G(T),!1;if(_.drag_support.formdata&&(t=_.drag_support.formdata?new FormData:null),t){var n;if(!1!==_.opts.videoUploadToS3)for(n in t.append("key",_.opts.videoUploadToS3.keyStart+(new Date).getTime()+"-"+(a.name||"untitled")),t.append("success_action_status","201"),t.append("X-Requested-With","xhr"),t.append("Content-Type",a.type),_.opts.videoUploadToS3.params)_.opts.videoUploadToS3.params.hasOwnProperty(n)&&t.append(n,_.opts.videoUploadToS3.params[n]);for(n in _.opts.videoUploadParams)_.opts.videoUploadParams.hasOwnProperty(n)&&t.append(n,_.opts.videoUploadParams[n]);t.append(_.opts.videoUploadParam,a);var r,i,o=_.opts.videoUploadURL;_.opts.videoUploadToS3&&(o=_.opts.videoUploadToS3.uploadURL?_.opts.videoUploadToS3.uploadURL:"https://".concat(_.opts.videoUploadToS3.region,".amazonaws.com/").concat(_.opts.videoUploadToS3.bucket));var s=_.opts.videoUploadMethod;_.opts.videoUploadToAzure&&(o=_.opts.videoUploadToAzure.uploadURL?"".concat(_.opts.videoUploadToAzure.uploadURL,"/").concat(a.name):encodeURI("https://".concat(_.opts.videoUploadToAzure.account,".blob.core.windows.net/").concat(_.opts.videoUploadToAzure.container,"/").concat(a.name)),r=o,_.opts.videoUploadToAzure.SASToken&&(o+=_.opts.videoUploadToAzure.SASToken),s="PUT");var l=_.core.getXHR(o,s);if(_.opts.videoUploadToAzure){var c=(new Date).toUTCString();if(!_.opts.videoUploadToAzure.SASToken&&_.opts.videoUploadToAzure.accessKey){var d=_.opts.videoUploadToAzure.account,f=_.opts.videoUploadToAzure.container;if(_.opts.videoUploadToAzure.uploadURL){var p=_.opts.videoUploadToAzure.uploadURL.split("/");f=p.pop(),d=p.pop().split(".")[0]}var u="x-ms-blob-type:BlockBlob\nx-ms-date:".concat(c,"\nx-ms-version:2019-07-07"),g=encodeURI("/"+d+"/"+f+"/"+a.name),h=s+"\n\n\n"+a.size+"\n\n"+a.type+"\n\n\n\n\n\n\n"+u+"\n"+g,m=_.cryptoJSPlugin.cryptoJS.HmacSHA256(h,_.cryptoJSPlugin.cryptoJS.enc.Base64.parse(_.opts.videoUploadToAzure.accessKey)).toString(_.cryptoJSPlugin.cryptoJS.enc.Base64),v="SharedKey "+d+":"+m;i=m,l.setRequestHeader("Authorization",v)}for(n in l.setRequestHeader("x-ms-version","2019-07-07"),l.setRequestHeader("x-ms-date",c),l.setRequestHeader("Content-Type",a.type),l.setRequestHeader("x-ms-blob-type","BlockBlob"),_.opts.videoUploadParams)_.opts.videoUploadParams.hasOwnProperty(n)&&l.setRequestHeader(n,_.opts.videoUploadParams[n]);for(n in _.opts.videoUploadToAzure.params)_.opts.videoUploadToAzure.params.hasOwnProperty(n)&&l.setRequestHeader(n,_.opts.videoUploadToAzure.params[n])}l.onload=function(){R.call(l,w,r,i)},l.onerror=L,l.upload.onprogress=x,l.onabort=I,S(),_.events.disableBlur(),_.edit.off(),_.events.enableBlur();var b=_.popups.get("video.insert");b&&y(b.off("abortUpload")).on("abortUpload",function(){4!=l.readyState&&l.abort()}),l.send(_.opts.videoUploadToAzure?a:t)}}}function G(e,t){_.edit.on(),w&&w.find("video").addClass("fr-error"),E(_.language.translate("Something went wrong. Please try again.")),_.events.trigger("video.error",[{code:e,message:r[e]},t])}function V(){if(w){var e=_.popups.get("video.size"),t=w.find("iframe, embed, ".concat(w.find("iframe, embed, audio").get(0)?"audio":"video"));e.find('input[name="width"]').val(t.get(0).style.width||t.attr("width")).trigger("change"),e.find('input[name="height"]').val(t.get(0).style.height||t.attr("height")).trigger("change")}}function Y(e){if(e)return _.popups.onRefresh("video.size",V),!0;var t={buttons:'<div class="fr-buttons fr-tabs">'.concat(_.button.buildList(_.opts.videoSizeButtons),"</div>"),size_layer:'<div class="fr-video-size-layer fr-layer fr-active" id="fr-video-size-layer-'.concat(_.id,'"><div class="fr-video-group"><div class="fr-input-line"><input id="fr-video-size-layer-width-').concat(_.id,'" type="text" name="width" placeholder="').concat(_.language.translate("Width"),'" tabIndex="1"></div><div class="fr-input-line"><input id="fr-video-size-layer-height-').concat(_.id,'" type="text" name="height" placeholder="').concat(_.language.translate("Height"),'" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="videoSetSize" tabIndex="2" role="button">').concat(_.language.translate("Update"),"</button></div></div>")},a=_.popups.create("video.size",t);return _.events.$on(_.$wp,"scroll",function(){w&&_.popups.isVisible("video.size")&&(_.events.disableBlur(),c(w))}),a}function j(e){if(void 0===e&&(e=w),e){if(e.hasClass("fr-fvl"))return"left";if(e.hasClass("fr-fvr"))return"right";if(e.hasClass("fr-dvb")||e.hasClass("fr-dvi"))return"center";if("block"==e.css("display")){if("left"==e.css("text-algin"))return"left";if("right"==e.css("text-align"))return"right"}else{if("left"==e.css("float"))return"left";if("right"==e.css("float"))return"right"}}return"center"}function q(e){void 0===e&&(e=w);var t=e.css("float");return e.css("float","none"),"block"==e.css("display")?(e.css("float",""),e.css("float")!=t&&e.css("float",t),"block"):(e.css("float",""),e.css("float")!=t&&e.css("float",t),"inline")}function X(){if(w&&!1!==_.events.trigger("video.beforeRemove",[w])){var e=w;if(_.popups.hideAll(),H(!0),_.opts.trackChangesEnabled&&(!e[0].parentNode||"SPAN"!==e[0].parentNode.tagName||!e[0].parentNode.hasAttribute("data-tracking")))return void _.track_changes.removeSpecialItem(e);_.selection.setBefore(e.get(0))||_.selection.setAfter(e.get(0)),e.remove(),_.selection.restore(),_.html.fillEmptyBlocks()}}function Z(){l()}function Q(e,t,a){!_.opts.htmlUntouched&&_.opts.useClasses?(e.removeClass("fr-fvl fr-fvr fr-dvb fr-dvi"),e.addClass("fr-fv".concat(a[0]," fr-dv").concat(t[0]))):"inline"==t?(e.css({display:"inline-block"}),"center"==a?e.css({"float":"none"}):"left"==a?e.css({"float":"left"}):e.css({"float":"right"})):(e.css({display:"block",clear:"both"}),"left"==a?e.css({textAlign:"left"}):"right"==a?e.css({textAlign:"right"}):e.css({textAlign:"center"}))}function J(){var e=_.$el.find("video").filter(function(){return 0===y(this).parents("span.fr-video").length});if(0!=e.length){e.wrap(y(document.createElement("span")).attr("class","fr-video fr-deletable").attr("contenteditable","false")),_.$el.find("embed, iframe").filter(function(){if(_.browser.safari&&this.getAttribute("src")&&this.setAttribute("src",this.src),0<y(this).parents("span.fr-video").length)return!1;for(var e=y(this).attr("src"),t=0;t<St.VIDEO_PROVIDERS.length;t++){var a=St.VIDEO_PROVIDERS[t];if(a.test_regex.test(e)&&new RegExp(_.opts.videoAllowedProviders.join("|")).test(a.provider))return!0}return!1}).map(function(){return 0===y(this).parents("object").length?this:y(this).parents("object").get(0)}).wrap(y(document.createElement("span")).attr("class","fr-video").attr("contenteditable","false"));for(var t,a,n,r,i=_.$el.find("span.fr-video, video"),o=0;o<i.length;o++){var s=y(i[o]);!_.opts.htmlUntouched&&_.opts.useClasses?((r=s).hasClass("fr-dvi")||r.hasClass("fr-dvb")||(r.addClass("fr-fv".concat(j(r)[0])),r.addClass("fr-dv".concat(q(r)[0]))),_.opts.videoTextNear||s.removeClass("fr-dvi").addClass("fr-dvb")):_.opts.htmlUntouched||_.opts.useClasses||(void 0,a=(t=s).hasClass("fr-dvb")?"block":t.hasClass("fr-dvi")?"inline":null,n=t.hasClass("fr-fvl")?"left":t.hasClass("fr-fvr")?"right":j(t),Q(t,a,n),t.removeClass("fr-dvb fr-dvi fr-fvr fr-fvl"))}i.toggleClass("fr-draggable",_.opts.videoMove)}}function ee(e){document.getElementById("autoplay-".concat(_.id)).style.cssText="background:".concat(e)}function te(){if(w){_.selection.clear();var e=_.doc.createRange();e.selectNode(w.get(0)),_.selection.get().addRange(e)}}return r[1]="Video cannot be loaded from the passed link.",r[p]="No link in upload response.",r[u]="Error during file upload.",r[g]="Parsing response failed.",r[C]="File is too large.",r[T]="Video file type is invalid.",r[7]="Files can be uploaded only to same domain in IE 8 and IE 9.",_.shared.vid_exit_flag=!1,{_init:function ae(){_.opts.videoResponsive&&(_.opts.videoResize=!1),function e(){_.events.on("drop",W,!0),_.events.on("mousedown window.mousedown",$),_.events.on("window.touchmove",z),_.events.on("mouseup window.mouseup",H),_.events.on("commands.mousedown",function(e){0<e.parents(".fr-toolbar").length&&H()}),_.events.on("video.hideResizer commands.undo commands.redo element.dropped",function(){H(!0)}),_.events.on("filestack-init-video",function(){o()})}(),_.helpers.isMobile()&&(_.events.$on(_.$el,"touchstart","span.fr-video",function(){a=!1}),_.events.$on(_.$el,"touchmove",function(){a=!0})),_.events.on("html.set",J),J(),_.events.$on(_.$el,"mousedown","span.fr-video",function(e){e.stopPropagation(),(_.browser.msie||_.browser.edge)&&(e.target.innerText||(e.target.dragDrop(),t.call(this,e)))}),_.events.$on(_.$el,"click touchend","span.fr-video",function(e){if(e.target.innerText.length||"false"==y(this).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable"))return!0;t.call(this,e)}),_.events.on("keydown",function(e){var t=e.which;return!w||t!=St.KEYCODE.BACKSPACE&&t!=St.KEYCODE.DELETE?w&&t==St.KEYCODE.ESC?(H(!0),e.preventDefault(),!1):w&&t!=St.KEYCODE.F10&&!_.keys.isBrowserAction(e)?(e.preventDefault(),!1):void 0:(e.preventDefault(),X(),_.undo.saveStep(),!1)},!0),_.events.on("toolbar.esc",function(){if(w)return _.events.disableBlur(),_.events.focus(),!1},!0),_.events.on("toolbar.focusEditor",function(){if(w)return!1},!0),_.events.on("keydown",function(){_.$el.find("span.fr-video:empty").remove()}),_.$wp&&(B(),_.events.on("contentChanged",B)),o(!0),Y(!0)},showInsertPopup:function ne(){var e=_.$tb.find('.fr-command[data-cmd="insertVideo"]'),t=_.popups.get("video.insert");if(t||(t=o()),l(),!t.hasClass("fr-active"))if(_.popups.refresh("video.insert"),_.popups.setContainer("video.insert",_.$tb),e.isVisible()){var a=_.button.getPosition(e),n=a.left,r=a.top;_.popups.show("video.insert",n,r,e.outerHeight())}else _.position.forSelection(t),_.popups.show("video.insert")},showLayer:function re(e){var t,a,n=_.popups.get("video.insert");if(!w&&!_.opts.toolbarInline){var r=_.$tb.find('.fr-command[data-cmd="insertVideo"]');t=r.offset().left,a=r.offset().top+(_.opts.toolbarBottom?10:r.outerHeight()-10)}_.opts.toolbarInline&&(a=n.offset().top-_.helpers.getPX(n.css("margin-top")),n.hasClass("fr-above")&&(a+=n.outerHeight())),n.find(".fr-layer").removeClass("fr-active"),n.find(".fr-".concat(e,"-layer")).addClass("fr-active"),_.popups.show("video.insert",t,a,0),_.accessibility.focusPopup(n)},refreshByURLButton:function ie(e){var t=_.popups.get("video.insert");t&&t.find(".fr-video-by-url-layer").hasClass("fr-active")&&e.addClass("fr-active").attr("aria-pressed",!0)},refreshEmbedButton:function oe(e){var t=_.popups.get("video.insert");t&&t.find(".fr-video-embed-layer").hasClass("fr-active")&&e.addClass("fr-active").attr("aria-pressed",!0)},refreshUploadButton:function se(e){var t=_.popups.get("video.insert");t&&t.find(".fr-video-upload-layer").hasClass("fr-active")&&e.addClass("fr-active").attr("aria-pressed",!0)},upload:K,insertByURL:function le(e){var t=!!document.getElementById("videoPluginAutoplay")&&document.getElementById("videoPluginAutoplay").checked;if(void 0===e){var a=(e=(_.popups.get("video.insert").find('.fr-video-by-url-layer input[type="text"]').val()||"").trim()).match(/(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/?(showcase\/)*([0-9))([a-z]*\/)*([0-9]{6,11})[?]?.*/);if(a&&7==a.length){var n=a[6],r=e.substring(0,e.lastIndexOf("/")),i=e.substring(e.lastIndexOf("/")+1,e.length);e=i.includes("?h=")||i.includes("?v=")||n===i?("".concat(r,"/").concat(i)||"").trim():("".concat(r,"?h=").concat(i)||"").trim()}}var o=null;if(/^http/.test(e)||(e="https://".concat(e)),_.helpers.isURL(e))for(var s=0;s<St.VIDEO_PROVIDERS.length;s++){var l=St.VIDEO_PROVIDERS[s],c="autoplay=1&mute=1";if(l.html.includes("autoplay=1")&&document.getElementById("videoPluginAutoplay").checked)l.html=l.html,document.getElementById("videoPluginAutoplay").checked=!1;else if(t){var d=l.html.indexOf("{url}")+5;l.html=[l.html.slice(0,d),c,l.html.slice(d)].join(""),t=!1,document.getElementById("videoPluginAutoplay").checked=!1}else(l=St.VIDEO_PROVIDERS[s]).html=l.html.replace(c,"");if(l.test_regex.test(e)&&new RegExp(_.opts.videoAllowedProviders.join("|")).test(l.provider)){o=e.replace(l.url_regex,l.url_text),o=l.html.replace(/\{url\}/,o);break}}o?m(o):(E(_.language.translate("Something went wrong. Please try again.")),_.events.trigger("video.linkError",[e]))},insertEmbed:function ce(e){void 0===e&&(e=_.popups.get("video.insert").find(".fr-video-embed-layer textarea").val()||""),0!==e.length&&St.VIDEO_EMBED_REGEX.test(e)?m(e):(E(_.language.translate("Something went wrong. Please try again.")),_.events.trigger("video.codeError",[e]))},insert:m,align:function de(e){w.removeClass("fr-fvr fr-fvl"),!_.opts.htmlUntouched&&_.opts.useClasses?"left"==e?w.addClass("fr-fvl"):"right"==e&&w.addClass("fr-fvr"):Q(w,q(),e),te(),U(),i(),_.selection.clear()},refreshAlign:function fe(e){if(!w)return!1;e.find(">*").first().replaceWith(_.icon.create("video-align-".concat(j())))},refreshAlignOnShow:function pe(e,t){w&&t.find('.fr-command[data-param1="'.concat(j(),'"]')).addClass("fr-active").attr("aria-selected",!0)},display:function ue(e){w.removeClass("fr-dvi fr-dvb"),!_.opts.htmlUntouched&&_.opts.useClasses?"inline"==e?w.addClass("fr-dvi"):"block"==e&&w.addClass("fr-dvb"):Q(w,e,j()),te(),U(),i(),_.selection.clear()},refreshDisplayOnShow:function ge(e,t){w&&t.find('.fr-command[data-param1="'.concat(q(),'"]')).addClass("fr-active").attr("aria-selected",!0)},remove:X,hideProgressBar:l,showSizePopup:function he(){var e=_.popups.get("video.size");e||(e=Y()),l(),_.popups.refresh("video.size"),_.popups.setContainer("video.size",_.$sc);var t=w.find("iframe, embed, ".concat(w.find("iframe, embed, audio").get(0)?"audio":"video")),a=t.offset().left+t.outerWidth()/2,n=t.offset().top+t.height();_.popups.show("video.size",a,n,t.height(),!0)},replace:function me(){var e=_.popups.get("video.insert");e||(e=o()),_.popups.isVisible("video.insert")||(l(),_.popups.refresh("video.insert"),_.popups.setContainer("video.insert",_.$sc));var t=w.offset().left+w.outerWidth()/2,a=w.offset().top+w.height();_.popups.show("video.insert",t,a,w.outerHeight(),!0)},back:function e(){w?(_.events.disableBlur(),w[0].click()):(_.events.disableBlur(),_.selection.restore(),_.events.enableBlur(),_.popups.hide("video.insert"),_.toolbar.showInline())},setSize:function ve(e,t){if(w){var a=_.popups.get("video.size"),n=w.find("iframe, embed, ".concat(w.find("iframe, embed, audio").get(0)?"audio":"video"));n.css("width",e||a.find('input[name="width"]').val()),n.css("height",t||a.find('input[name="height"]').val()),n.get(0).style.width&&n.removeAttr("width"),n.get(0).style.height&&n.removeAttr("height"),a.find("input:focus").blur(),setTimeout(function(){w.trigger("click")},_.helpers.isAndroid()?50:0)}},get:function be(){return w},showProgressBar:S,_editVideo:c,setAutoplay:function Ee(){var e;if(w.find("iframe, embed, audio").get(0))(e=w.find("iframe, embed, audio")).get(0).src.includes("autoplay=1")?(ee("#FFFFFF"),e.get(0).src=e.get(0).src.replace("&autoplay=1","")):(ee("#D6D6D6"),e.get(0).src=e.get(0).src+"&autoplay=1");else if((e=w.find("iframe, embed, video")).get(0).outerHTML.includes("autoplay"))ee("#FFFFFF"),e.get(0).outerHTML=e.get(0).outerHTML.replace("autoplay","");else{ee("#D6D6D6");var t=e.get(0).outerHTML.indexOf("class")-1;e.get(0).outerHTML=[e.get(0).outerHTML.slice(0,t),"autoplay",e.get(0).outerHTML.slice(t)].join("")}},insertHtmlVideo:k}},St.RegisterCommand("insertVideo",{title:"Insert Video",undo:!1,focus:!0,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible("video.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("video.insert")):this.video.showInsertPopup()},plugin:"video"}),St.DefineIcon("insertVideo",{NAME:"video-camera",FA5NAME:"camera",SVG_KEY:"insertVideo"}),St.DefineIcon("videoByURL",{NAME:"link",SVG_KEY:"insertLink"}),St.RegisterCommand("videoByURL",{title:"By URL",undo:!1,focus:!1,toggle:!0,callback:function(){this.video.showLayer("video-by-url")},refresh:function(e){this.video.refreshByURLButton(e)}}),St.DefineIcon("videoEmbed",{NAME:"code",SVG_KEY:"codeView"}),St.RegisterCommand("videoEmbed",{title:"Embedded Code",undo:!1,focus:!1,toggle:!0,callback:function(){this.video.showLayer("video-embed")},refresh:function(e){this.video.refreshEmbedButton(e)}}),St.DefineIcon("videoUpload",{NAME:"upload",SVG_KEY:"upload"}),St.RegisterCommand("videoUpload",{title:"Upload Video",undo:!1,focus:!1,toggle:!0,callback:function(){this.video.showLayer("video-upload")},refresh:function(e){this.video.refreshUploadButton(e)}}),St.RegisterCommand("videoInsertByURL",{undo:!0,focus:!0,callback:function(){this.video.insertByURL()}}),St.RegisterCommand("videoInsertEmbed",{undo:!0,focus:!0,callback:function(){this.video.insertEmbed()}}),St.DefineIcon("videoDisplay",{NAME:"star",SVG_KEY:"star"}),St.RegisterCommand("videoDisplay",{title:"Display",type:"dropdown",options:{inline:"Inline",block:"Break Text"},callback:function(e,t){this.video.display(t)},refresh:function(e){this.opts.videoTextNear||e.addClass("fr-hidden")},refreshOnShow:function(e,t){this.video.refreshDisplayOnShow(e,t)}}),St.DefineIcon("video-align",{NAME:"align-left",SVG_KEY:"align Left"}),St.DefineIcon("video-align-left",{NAME:"align-left",SVG_KEY:"alignLeft"}),St.DefineIcon("video-align-right",{NAME:"align-right",SVG_KEY:"alignRight"}),St.DefineIcon("video-align-center",{NAME:"align-justify",SVG_KEY:"alignJustify"}),St.DefineIcon("videoAlign",{NAME:"align-center",SVG_KEY:"alignCenter"}),St.RegisterCommand("videoAlign",{type:"dropdown",title:"Align",options:{left:"Align Left",center:"None",right:"Align Right"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=St.COMMANDS.videoAlign.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="videoAlign" data-param1="'.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.icon.create("video-align-".concat(a)),'<span class="fr-sr-only">').concat(this.language.translate(t[a]),"</span></a></li>"));return e+="</ul>"},callback:function(e,t){this.video.align(t)},refresh:function(e){this.video.refreshAlign(e)},refreshOnShow:function(e,t){this.video.refreshAlignOnShow(e,t)}}),St.DefineIcon("videoReplace",{NAME:"exchange",FA5NAME:"exchange-alt",SVG_KEY:"replaceImage"}),St.RegisterCommand("videoReplace",{title:"Replace",undo:!1,focus:!1,popup:!0,refreshAfterCallback:!1,callback:function(){this.video.replace()}}),St.DefineIcon("videoRemove",{NAME:"trash",SVG_KEY:"remove"}),St.RegisterCommand("videoRemove",{title:"Remove",callback:function(){this.video.remove()}}),St.DefineIcon("autoplay",{NAME:"autoplay",SVG_KEY:"autoplay"}),St.RegisterCommand("autoplay",{undo:!1,focus:!1,popup:!0,title:"Autoplay",callback:function(){this.video.setAutoplay()}}),St.DefineIcon("videoSize",{NAME:"arrows-alt",SVG_KEY:"imageSize"}),St.RegisterCommand("videoSize",{undo:!1,focus:!1,popup:!0,title:"Change Size",callback:function(){this.video.showSizePopup()}}),St.DefineIcon("videoBack",{NAME:"arrow-left",SVG_KEY:"back"}),St.RegisterCommand("videoBack",{title:"Back",undo:!1,focus:!1,back:!0,callback:function(){this.video.back()},refresh:function(e){this.video.get()||this.opts.toolbarInline?(e.removeClass("fr-hidden"),e.next().hasClass("fr-separator")&&e.next().removeClass("fr-hidden")):(e.addClass("fr-hidden"),e.next().hasClass("fr-separator")&&e.next().addClass("fr-hidden"))}}),St.RegisterCommand("videoDismissError",{title:"OK",undo:!1,callback:function(){this.video.hideProgressBar(!0)}}),St.RegisterCommand("videoSetSize",{undo:!0,focus:!1,title:"Update",refreshAfterCallback:!1,callback:function(){this.video.setSize()}}),Object.assign(St.DEFAULTS,{wordDeniedTags:[],wordDeniedAttrs:[],wordAllowedStyleProps:["font-family","font-size","background","color","width","text-align","vertical-align","background-color","padding","margin","height","margin-top","margin-left","margin-right","margin-bottom","text-decoration","font-weight","font-style","text-indent","border","border-.*","line-height","list-style-type"],wordPasteModal:!0,wordPasteKeepFormatting:!0}),St.PLUGINS.wordPaste=function(y){var o,r,A,M=y.$,s="word_paste",g={},C=!0;function t(e){var t=y.opts.wordAllowedStyleProps;e||(y.opts.wordAllowedStyleProps=[]),0===r.indexOf("<colgroup>")&&(r="<table>"+r+"</table>"),r=i(r=r.replace(/<span[\n\r ]*style='mso-spacerun:yes'>([\r\n\u00a0 ]*)<\/span>/g,function(e,t){for(var a="",n=0;n++<t.length;)a+="&nbsp;";return a}),y.paste.getRtfClipboard());var a=y.doc.createElement("DIV");a.innerHTML=r,y.html.cleanBlankSpaces(a),r=a.innerHTML,r=(r=y.paste.cleanEmptyTagsAndDivs(r)).replace(/\u200b/g,""),function n(){y.modals.hide(s)}(),y.helpers.isMobile()&&y.events.focus(),y.paste.clean(r,!0,!0),y.opts.wordAllowedStyleProps=t}function T(e){e.parentNode&&e.parentNode.removeChild(e)}function h(e,t){if(t(e))for(var a=e.firstChild;a;){var n=a,r=a.previousSibling;a=a.nextSibling,h(n,t),n.previousSibling||n.nextSibling||n.parentNode||!a||r===a.previousSibling||!a.parentNode?n.previousSibling||n.nextSibling||n.parentNode||!a||a.previousSibling||a.nextSibling||a.parentNode||(r?a=r.nextSibling?r.nextSibling.nextSibling:null:e.firstChild&&(a=e.firstChild.nextSibling)):a=r?r.nextSibling:e.firstChild}}function N(e){return M(e).hasClass("ListContainerWrapper")&&0<M(e).find("ol").length}function D(e){return M(e).hasClass("ListContainerWrapper")&&0<M(e).find("ul").length}function P(e){if(N(e)||D(e))return!0;if(!e.getAttribute("style")||!/mso-list:[\s]*l/gi.test(e.getAttribute("style").replace(/\n/gi,"")))return!1;try{if(!e.querySelector('[style="mso-list:Ignore"]'))return!!(e.outerHTML&&0<=e.outerHTML.indexOf("\x3c!--[if !supportLists]--\x3e"))}catch(t){return!1}return!0}var m=null,v={};function B(e){var t;if(N(e)||D(e))t=M(e).find("li").attr("data-aria-level");else{var a,n,r=(null===(a=e.getAttribute("style"))||void 0===a?void 0:a.replace(/\n/g,""))||"",i=m&&(null===(n=m.getAttribute("style"))||void 0===n?void 0:n.replace(/\n/g,""))||"",o=r.match(/mso-list:(\s*l([0-9]+)\s*level([0-9]+)\s*)lfo([0-9]+)/i),s=i.match(/mso-list:(\s*l([0-9]+)\s*level([0-9]+)\s*)lfo([0-9]+)/i);if(o){if(v[o[1]])return m=e,v[o[1]].toString();var l=s&&s[2],c=o[2],d=i&&v[s[1]]||0;t=l&&l!==c&&parseFloat(m.style.marginLeft)<parseFloat(e.style.marginLeft)?(d+parseInt(o[3])).toString():o[3],v[o[1]]=parseInt(t)}else t=r.replace(/.*level([0-9]+?).*/gi,"$1")}return m=e,t}function U(e,n){var t=e.cloneNode(!0);if(-1!==["H1","H2","H3","H4","H5","H6"].indexOf(e.tagName)){var a=document.createElement(e.tagName.toLowerCase());a.setAttribute("style",e.getAttribute("style")),a.innerHTML=t.innerHTML,t.innerHTML=a.outerHTML}h(t,function(e){if(e.nodeType==Node.COMMENT_NODE&&(y.browser.msie||y.browser.safari||y.browser.edge))try{if("[if !supportLists]"===e.data){for(e=e.nextSibling;e&&e.nodeType!==Node.COMMENT_NODE;){var t=e.nextSibling;e.parentNode.removeChild(e),e=t}e&&e.nodeType==Node.COMMENT_NODE&&e.parentNode.removeChild(e)}}catch(a){return!1}return e.nodeType===Node.ELEMENT_NODE&&("mso-list:\nIgnore"===e.getAttribute("style")&&e.setAttribute("style","mso-list:Ignore"),"mso-list:Ignore"===e.getAttribute("style")&&e.parentNode.removeChild(e),e.setAttribute("style",b(e)),L(e,n)),!0});var r=N(e)?M(e).find("li").get(0).innerHTML:t.innerHTML;if(N(e)||D(e)){r="";for(var i=M(e).find("li"),o=0;o<i.length;o++){var s=M(i.get(o).innerHTML);s.find("span").each(function(){"&nbsp;"===M(this).html()&&(0<M(this).prev().text().trim().length?M(this).remove():M(this).html("&ZeroWidthSpace;"))});var l=i[o].style.marginLeft;l?(l=parseFloat(parseFloat(l).toFixed(2))+l.match(/[a-zA-Z]+/g)[0],r+='<li style = "margin-left: '.concat(l,';">').concat(s.get(0).innerHTML,"</li>")):r+="<li >".concat(s.get(0).innerHTML,"</li>")}}else{var c,d=null===(c=M(e).find("p").get(0))||void 0===c?void 0:c.style.marginLeft;r=d?(d=parseFloat(parseFloat(d).toFixed(2))+d.match(/[a-zA-Z]+/g)[0],'<li style = "margin-left: '.concat(d,';">').concat(r,"</li>")):"<li>".concat(r,"</li>")}return r=r.replace(/<!--[\s\S]*?-->/gi,"")}function b(e){var t=1<arguments.length&&arguments[1]!==undefined?arguments[1]:null,a="",n=["line-height","font-family","font-size","color","background"].concat(ye(t||[])),r=e.getAttribute("style");return r&&n.forEach(function(t){var e=r.split(";").find(function(e){return e.trim().includes(t+":")});e&&(e.includes("mso")&&(e=e.match(new RegExp(t+":.*(;|)"))[0]),e.trim().startsWith(t)&&(a+=e+";"))}),a}function E(e,t){for(var a=document.createElement(t),n=0;n<e.attributes.length;n++){var r=e.attributes[n].name;"FONT"===e.tagName&&(y.browser.msie&&["id","class","style"].indexOf(r)<0||!y.browser.msie&&CSS.supports(r,e.getAttribute(r)))?M(a).css(r,e.getAttribute(r)):a.setAttribute(r,e.getAttribute(r))}return a.innerHTML=e.innerHTML,e.parentNode.replaceChild(a,e),a}function _(e,t){y.node.clearAttributes(e);for(var a=e.firstElementChild,n=0,r=!1,i=null;a;){if(a.firstElementChild&&-1!==a.firstElementChild.tagName.indexOf("W:"))for(var o=0;o<a.children.length;o++)"<('[^']*'|\"[^\"]*\"|[^\"'>])*>"==a.children[o]&&(a.innerHTML+=a.children[o]);(i=a.getAttribute("width"))||(i=a.style.width),i||r||(r=!0),n+=parseInt(i,10),(!a.firstChild||a.firstChild&&a.firstChild.data===St.UNICODE_NBSP)&&(a.firstChild&&T(a.firstChild),a.innerHTML="<br>");for(var s=a.firstElementChild,l=1===a.children.length;s;)"P"!==s.tagName||P(s)||l&&k(s),s=s.nextElementSibling;if(t){var c=a.getAttribute("class");if(c){var d=(c=S(c)).match(/xl[0-9]+/gi);if(d){var f="."+d[0];t[f]&&R(a,t[f])}}t.td&&R(a,t.td)}var p=a.getAttribute("style");p&&(p=S(p))&&";"!==p.slice(-1)&&(p+=";");var u=a.getAttribute("valign");if(!u&&p){var g=p.match(/vertical-align:.+?[; "]{1,1}/gi);g&&(u=g[g.length-1].replace(/vertical-align:(.+?)[; "]{1,1}/gi,"$1"))}var h=null;if(p){var m=p.match(/text-align:.+?[; "]{1,1}/gi);m&&(h=m[m.length-1].replace(/text-align:(.+?)[; "]{1,1}/gi,"$1")),"general"===h&&(h=null)}var v=null;if(p){var b=p.match(/background:.+?[; "]{1,1}/gi);b&&(v=b[b.length-1].replace(/background:(.+?)[; "]{1,1}/gi,"$1"))}var E=a.getAttribute("colspan"),_=a.getAttribute("rowspan");E&&a.setAttribute("colspan",E),_&&a.setAttribute("rowspan",_),u&&(a.style["vertical-align"]=u),h&&(a.style["text-align"]=h),v&&(a.style["background-color"]=v),i&&a.setAttribute("width",i),a=a.nextElementSibling}for(a=e.firstElementChild;a;)i=a.getAttribute("width"),r&&a.removeAttribute("width"),a=a.nextElementSibling;e.previousSibling?A!=n&&(C=!1):A=n,e.nextElementSibling||function w(e){var t=e.closest("table"),a=0,r=function r(){var n=0;Array.from(e.children).forEach(function(e){var t=parseInt(e.getAttribute("width"),10);isNaN(t)||(n+=t)}),a<n&&(a=n),C?Array.from(e.children).forEach(function(e){var t=parseInt(e.getAttribute("width"),10);if(!isNaN(t)&&0<n){var a=100*t/n;e.setAttribute("width","".concat(a,"%"))}}):Array.from(e.children).forEach(function(e){var t=parseInt(e.getAttribute("width"),10);isNaN(t)||e.setAttribute("width","".concat(t,"px"))}),e=e.previousElementSibling};for(;e;)r();if(t&&0<a){var n=parseInt(t.style.width,10);(isNaN(n)||0===n)&&(t.style.width="".concat(a,"px"))}}(e)}function k(e){var t=e.getAttribute("align");t&&(e.style["text-align"]=t,e.removeAttribute("align"))}function S(e){return e.replace(/\n|\r|\n\r|&quot;/g,"")}function R(e,t,a){if(t){var n=e.getAttribute("style");n&&";"!==n.slice(-1)&&(n+=";"),t&&";"!==t.slice(-1)&&(t+=";"),t=t.replace(/\n/gi,"");var r=null;r=a?(n||"")+t:t+(n||""),e.setAttribute("style",r)}}var u=null;function c(e,t,a){for(var n=e.split(a),r=1;r<n.length;r++){var i=n[r];if(1<(i=i.split("shplid")).length){i=i[1];for(var o="",s=0;s<i.length&&"\\"!==i[s]&&"{"!==i[s]&&" "!==i[s]&&"\r"!==i[s]&&"\n"!==i[s];)o+=i[s],s++;var l=i.split("bliptag");if(l&&l.length<2)continue;var c=null;if(-1!==l[0].indexOf("pngblip")?c="image/png":-1!==l[0].indexOf("jpegblip")&&(c="image/jpeg"),!c)continue;var d=l[1].split("}");if(d&&d.length<2)continue;var f=void 0;if(2<d.length&&-1!==d[0].indexOf("blipuid"))f=d[1].split(" ");else{if((f=d[0].split(" "))&&f.length<2)continue;f.shift()}var p=f.join("");u[t+o]={image_hex:p,image_type:c}}}}function w(e,t){if(t){var a;if("IMG"===e.tagName){var n=e.getAttribute("src");if(!n||-1===n.indexOf("file://"))return;if(0===n.indexOf("file://")&&y.helpers.isURL(e.getAttribute("alt")))return void e.setAttribute("src",e.getAttribute("alt"));(a=g[e.getAttribute("v:shapes")])||(a=e.getAttribute("v:shapes"),e.parentNode&&e.parentNode.parentNode&&0<=e.parentNode.parentNode.innerHTML.indexOf("msEquation")&&(a=null))}else a=e.parentNode.getAttribute("o:spid");if(e.removeAttribute("height"),a){!function s(e){u={},c(e,"i","\\shppict"),c(e,"s","\\shp{")}(t);var r=u[a.substring(7)];if(r){var i=function l(e){for(var t=e.match(/[0-9a-f]{2}/gi),a=[],n=0;n<t.length;n++)a.push(String.fromCharCode(parseInt(t[n],16)));var r=a.join("");return btoa(r)}(r.image_hex),o="data:"+r.image_type+";base64,"+i;"IMG"===e.tagName?(e.src=o,e.setAttribute("data-fr-image-pasted",!0)):M(e).parent().before('<img data-fr-image-pasted="true" src="'.concat(o,'" style="').concat(e.parentNode.getAttribute("style"),'">')).remove()}}}}function L(e,t){var a=e.tagName,n=a.toLowerCase();e.firstElementChild&&("I"===e.firstElementChild.tagName?E(e.firstElementChild,"em"):"B"===e.firstElementChild.tagName&&E(e.firstElementChild,"strong"));if(-1!==["SCRIPT","APPLET","EMBED","NOFRAMES","NOSCRIPT"].indexOf(a))return T(e),!1;for(var r=["META","LINK","XML","ST1:","O:","W:","FONT"],i=0;i<r.length;i++)if(-1!==a.indexOf(r[i]))return e.innerHTML&&(e.outerHTML=e.innerHTML),T(e),!1;if("TD"!==a){var o=e.getAttribute("class")||"MsoNormal";if(t&&o){for(var s=(o=S(o)).split(" "),l=0;l<s.length;l++){var c=[],d="."+s[l];c.push(d),d=n+d,c.push(d);for(var f=0;f<c.length;f++)t[c[f]]&&R(e,t[c[f]])}e.removeAttribute("class")}t&&t[n]&&R(e,t[n])}if(-1!==["P","H1","H2","H3","H4","H5","H6","PRE"].indexOf(a)){var p=e.getAttribute("class");if(p&&(t&&t[a.toLowerCase()+"."+p]&&R(e,t[a.toLowerCase()+"."+p]),-1!==p.toLowerCase().indexOf("mso"))){var u=S(p);(u=u.replace(/[0-9a-z-_]*mso[0-9a-z-_]*/gi,""))?e.setAttribute("class",u):e.removeAttribute("class")}var g=e.getAttribute("style");if(g){var h=g.match(/text-align:.+?[; "]{1,1}/gi);h&&h[h.length-1].replace(/(text-align:.+?[; "]{1,1})/gi,"$1")}k(e)}if("TR"===a&&_(e,t),"A"!==a||e.attributes.getNamedItem("href")||e.attributes.getNamedItem("name")||!e.innerHTML||(e.outerHTML=e.innerHTML),"A"==a&&e.getAttribute("href")&&e.querySelector("img"))for(var m=e.querySelectorAll("span"),v=0;v<m.length;v++)m[v].innerText||(m[v].outerHTML=m[v].innerHTML);if("TD"!==a&&"TH"!==a||e.innerHTML||(e.innerHTML="<br>"),e.getAttribute("lang")&&e.removeAttribute("lang"),e.getAttribute("style")&&-1!==e.getAttribute("style").toLowerCase().indexOf("mso")){var b=S(e.getAttribute("style"));(b=b.replace(/[0-9a-z-_]*mso[0-9a-z-_]*:.+?(;{1,1}|$)/gi,"").replace("line-height:107%",""))?e.setAttribute("style",b):e.removeAttribute("style")}return!0}function i(e,t){0<=e.indexOf("<html")&&(e=e.replace(/[.\s\S\w\W<>]*(<html[^>]*>[.\s\S\w\W<>]*<\/html>)[.\s\S\w\W<>]*/i,"$1"));var l=e.match(/(MSFontService|class="?Mso|class='?Mso|class="?Xl|class='?Xl|class=Xl|style="[^"]*\bmso-|style='[^']*\bmso-|w:WordDocument|LibreOffice)/gi);!function f(e){for(var t=e.split("v:shape"),a=1;a<t.length;a++){var n=t[a],r=n.split(' id="')[1];if(r&&1<r.length){r=r.split('"')[0];var i=n.split(' o:spid="')[1];i&&1<i.length&&(i=i.split('"')[0],g[r]=i)}}}(e);var a=(new DOMParser).parseFromString(e,"text/html"),n=a.head,r=a.body,c=function p(e){var t={},a=e.getElementsByTagName("style");if(a.length){var n=a[0].innerHTML.match(/[\S ]+\s+{[\s\S]+?}/gi);if(n)for(var r=0;r<n.length;r++){var i=n[r],o=i.replace(/([\S ]+\s+){[\s\S]+?}/gi,"$1"),s=i.replace(/[\S ]+\s+{([\s\S]+?)}/gi,"$1");o=o.replace(/^[\s]|[\s]$/gm,""),s=s.replace(/^[\s]|[\s]$/gm,""),o=o.replace(/\n|\r|\n\r/g,""),s=s.replace(/\n|\r|\n\r/g,"");for(var l=o.split(", "),c=0;c<l.length;c++)t[l[c]]=s}}return t}(n);h(r,function(e){if(e.nodeType===Node.ELEMENT_NODE&&e.hasAttribute("style")){var t=e.getAttribute("style");e.setAttribute("style",t),e.style.fontFamily||e.setAttribute("style",function a(e){return e.replace(/mso-(bidi|fareast|fareast-theme)-font-family/g,"font-family")}(t))}return!0}),h(r,function(e){if(e.nodeType===Node.TEXT_NODE&&/\n|\u00a0|\r/.test(e.data)){if(!/\S| /.test(e.data)&&!/[\u00a0]+/.test(e.data))return e.data===St.UNICODE_NBSP?(e.data="\u200b",!0):1===e.data.length&&10===e.data.charCodeAt(0)?(e.data=" ",!0):(T(e),!1);e.data=e.data.replace(/\n|\r/gi," ")}return!0}),h(r,function(e){return e.nodeType!==Node.ELEMENT_NODE||"V:IMAGEDATA"!==e.tagName&&"IMG"!==e.tagName||w(e,t),!0});for(var i=r.querySelectorAll("ul > ul, ul > ol, ol > ul, ol > ol"),o=i.length-1;0<=o;o--)i[o].previousElementSibling&&"LI"===i[o].previousElementSibling.tagName&&i[o].previousElementSibling.appendChild(i[o]);h(r,function(e){if(e.nodeType===Node.TEXT_NODE)return e.data=e.data.replace(/<br>(\n|\r)/gi,"<br>"),!1;if(e.nodeType===Node.ELEMENT_NODE){if(P(e)){var t=e.parentNode,a=e.previousSibling,n=function F(e,t,a,n){var r,i,o,s,l,c,d,f=navigator.userAgent.toLowerCase();-1!=f.indexOf("safari")&&(f=-1<f.indexOf("chrome")?1:"safari"),e.innerHTML.includes("mso-list:\nIgnore")&&(e.innerHTML=e.innerHTML.replace(/mso-list:\nIgnore/gi,"mso-list:Ignore"));var p,u,g,h,m=/[0-9a-zA-Z]./gi,v="",b=N(e),E=null===(r=M(e).find("ol"))||void 0===r||null===(r=r.attr("style"))||void 0===r||null===(r=r.split(";"))||void 0===r?void 0:r.find(function(e){return e.trim().startsWith("list-style-type")});E==undefined&&D(e)&&(E=null===(u=M(e).find("ul"))||void 0===u||null===(u=u.attr("style"))||void 0===u||null===(u=u.split(";"))||void 0===u?void 0:u.find(function(e){return e.trim().startsWith("list-style-type")}));if(b)c="ol",d=E?"list-style-type: "+E.replace("list-style-type:","").trim()+";":"";else if(D(e))c="ul",d=E?"list-style-type: "+E.replace("list-style-type:","").trim()+";":"";else{var _=e.querySelector('span[style="mso-list:Ignore"]');null==_&&"safari"==f&&(_=e.querySelector('span[lang="PT-BR"]'));var w=!1;_&&(w=w||m.test(_.textContent)),null!==_&&(p=_.textContent.trim().split(".")[0]),c=1==w?(p=(p=_.textContent.trim().split(".")[0]).replace(/\(([^)]+)\)/g,"$1"),isNaN(parseInt(p))?/^(m{0,4}(cm|cd|d?c{0,3})(xc|xl|l?x{0,3})(ix|iv|v?i{0,3}))$/.test(p)?(d="lower-roman;",e.nextElementSibling&&1===e.nextElementSibling.textContent.trim().split(".")[0].length&&(d="lower-alpha;")):/^(M{0,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3}))$/.test(p)?(d="upper-roman;",e.nextElementSibling&&1===e.nextElementSibling.textContent.trim().split(".")[0].length&&(d="upper-alpha;")):"o"==p?d="circle;":p.match(/^v$/)||(p.match(/^[a-z]$/)||p.match(/^[a-z]\)$/)?d="lower-alpha;":(p.match(/^[A-Z]$/)||p.match(/^[A-Z]\)$/))&&(d="upper-alpha;")):d="decimal;",d="list-style-type: "+d,"ol"):(null!=_&&(p=_.textContent.trim().split(".")[0]),"\xa7"==p?d="square;":"\xb7"==p&&(d="disc;"),d="list-style-type: "+d,"ul"),_==undefined||_.textContent==undefined||isNaN(parseInt(_.textContent.trim().split(".")[1],10))||(v=' class="decimal_type" ')}var y=1,A="",C=(B(e),e.style.marginLeft),T="";C.includes("in")?(T="in",C=parseFloat(C)-.5):C.includes("pt")&&(T="px",C=parseFloat(C)-10),C&&(h=" margin-left: "+C+T+";"),y="list-style-type: upper-alpha;"==d?b?parseInt(M(e).find("ol").attr("start")):p.charCodeAt(0)-64:"list-style-type: lower-alpha;"==d?b?parseInt(M(e).find("ol").attr("start")):p.charCodeAt(0)-96:"list-style-type: upper-roman;"==d||"list-style-type: lower-roman;"==d?b?parseInt(M(e).find("ol").attr("start")):function O(e){for(var t={I:1,V:5,X:10,L:50,C:100,D:500,M:1e3,i:1,v:5,x:10,l:50,c:100,d:500,m:1e3},a=0,n=0,r=e.length-1;0<=r;r--){var i=t[e[r]];n<=i?a+=i:a-=i,n=i}return a}(p):b?parseInt(M(e).find("ol").attr("start")):parseInt(p),A+=d||"",A+=h||"",g="<"+c,"none"===e.style.display&&(g+=' class="fr-mso-hidden"'),g+=v||"",g+="ol"!=c||1==y||isNaN(y)?"":' start = "'+y+'"',g+=A?' style = "'+A+'"':"",g+=">";for(var k=!1;e;){if(!P(e)){if(e.outerHTML&&0<e.outerHTML.indexOf("mso-bookmark")&&0==(e.textContent||"").length){e=e.nextElementSibling;continue}break}var S=B(e);if((a=a||S)<S)g+=(l=F(e,t,S,e.style.marginLeft)).el.outerHTML,e=l.currentNode;else{if(S<a)break;e.firstElementChild&&e.firstElementChild.firstElementChild&&e.firstElementChild.firstElementChild.firstChild&&(m.lastIndex=0),o&&o.firstElementChild&&o.firstElementChild.firstElementChild&&o.firstElementChild.firstElementChild.firstChild&&(m.lastIndex=0,i=m.test(o.firstElementChild.firstElementChild.firstChild.data||o.firstElementChild.firstElementChild.firstChild.firstChild&&o.firstElementChild.firstElementChild.firstChild.firstChild.data||""));var R=!1,L=o&&B(o);(!n&&!e.style.marginLeft||n&&e.style.marginLeft&&n===e.style.marginLeft||L&&L===S)&&(R=!0),n=e.style.marginLeft,R||i===undefined?(s=U(e,t),e.nextSibling&&e.nextSibling.innerText!=undefined&&e.nextSibling.innerText!=undefined&&!g.includes('class="decimal_type"')&&(isNaN(parseInt(e.nextSibling.innerText.trim().split(".")[1],10))||(g=g.substring(3,0)+' class="decimal_type"'+g.substring(3,g.length))),g+=s):(1==S&&(g+="</"+c+">",k=!0,o=null),g+=(l=F(e,t,S,e.style.marginLeft)).el.outerHTML,e=l.currentNode);var x=e&&e.nextElementSibling;if(x&&(o=x.previousElementSibling),e&&!P(e)){if(e.outerHTML&&0<e.outerHTML.indexOf("mso-bookmark")&&0==(e.textContent||"").length){e=e.nextElementSibling;continue}break}e&&e.parentNode&&e.parentNode.removeChild(e),e=x}}k||(g+="</"+c+">");var I=document.createElement("div");return I.innerHTML=g,{el:I,currentNode:e}}(e,c).el,r=null;return(r=a?a.nextSibling:t.firstChild)?t.insertBefore(n,r):t.appendChild(n),!1}return"FONT"===e.tagName&&(l&&"LibreOffice"===l[0]||c["."+e.getAttribute("class")])?e=E(e,"span"):l&&"\x3c!--StartFragment--\x3e"===l[0]&&"UL"===e.tagName&&(M(e).find("li span").each(function(){"&nbsp;"===M(this).html()&&(0<M(this).prev().text().trim().length?M(this).remove():M(this).html("&ZeroWidthSpace;"))}),M(e).is("ul")&&e.setAttribute("style",b(e,["margin","margin-left","list-style-type"])),M(e).find("ul").each(function(){this.setAttribute("style",b(this,["margin","margin-left","list-style-type"]))})),"img"!==e.tagName.toLowerCase()&&function s(t){Array.from(t.attributes).map(function(e){return e.name}).filter(function(e){return e.toLowerCase().startsWith("data-")||e.toLowerCase().startsWith("xml:")}).forEach(function(e){M(t).removeAttr(e)})}(e),L(e,c)}if(e.nodeType!==Node.COMMENT_NODE)return!0;if(-1<e.data.indexOf("[if !supportLineBreakNewLine]"))for(var i=e.nextSibling;i;)(i=e.nextSibling)&&T(i),i.data&&-1<i.data.indexOf("[endif]")&&(i=null);if(-1<e.data.indexOf("[if supportFields]")&&-1<e.data.indexOf("FORMCHECKBOX")){var o=document.createElement("input");o.type="checkbox",e.parentNode.insertBefore(o,e.nextSibling)}return T(e),!1}),m=null,v={},r.innerHTML=function u(e){var t=M(document.createElement("div")).attr("id","top-level");t.html(e);for(var a=t[0].querySelectorAll("ol, ul"),n=0;n<a.length;n++)if(M(a[n]).parentsUntil("#top-level","ol, ul").length){a[n].style.removeProperty("margin-left");for(var r=a[n].children,i=0;i<r.length;i++)"LI"==r[i].tagName&&r[i].style.removeProperty("margin-left")}return t[0].innerHTML}(r.innerHTML),h(r,function(e){if(e.nodeType===Node.ELEMENT_NODE){var t=e.tagName;if(!e.innerHTML&&-1===["BR","IMG","INPUT"].indexOf(t)){for(var a=e.parentNode;a&&(T(e),!(e=a).innerHTML)&&"TD"!==e.parentNode.tagName;)a=e.parentNode;return!1}!function f(e){var t=e.getAttribute("style");if(t){(t=S(t))&&";"!==t.slice(-1)&&(t+=";");var a=t.match(/(^|\S+?):.+?;{1,1}/gi);if(a){for(var n={},r=0;r<a.length;r++){var i=a[r].split(":");2===i.length&&("text-align"===i[0]&&"SPAN"===e.tagName||(n[i[0]]=i[1]))}var o="";for(var s in n)if(n.hasOwnProperty(s)){if("font-size"===s&&"pt;"===n[s].slice(-3)){var l=null;try{l=parseFloat(n[s].slice(0,-3),10)}catch(d){l=null}if(l){var c=y.opts.fontSizeUnit;"px"===c?(l=Math.round(1.33*l),n[s]=l+"px;"):"pt"===c&&(l=Math.round(l),n[s]=l+"pt;")}}o+=s+":"+n[s]}o&&e.setAttribute("style",o)}}}(e)}return!0}),h(r,function(e){if(e&&"A"===e.nodeName){if(e.hasAttribute("name")&&e.getAttribute("name").startsWith("_Toc")&&e.parentNode&&(e.parentNode.id=e.getAttribute("name")),""===e.href){for(var t=document.createDocumentFragment();e.firstChild;)t.appendChild(e.firstChild);e.parentNode.replaceChild(t,e)}e.hasAttribute("href")&&e.getAttribute("href").startsWith("#_Toc")&&(e.removeChild(e.lastChild),e.removeChild(e.lastChild))}return!0}),h(r,function(e){return e&&"P"===e.tagName&&"DIV"===e.parentNode.tagName&&1==e.parentNode.children.length&&M(e).unwrap(),!0}),h(r,function(e){if(e&&"SPAN"===e.tagName)for(;e.nextSibling&&e.nextSibling.nodeType===Node.ELEMENT_NODE&&"SPAN"===e.nextSibling.tagName&&e.getAttribute("style")===e.nextSibling.getAttribute("style");)M(e).append(e.nextSibling.innerHTML),M(e.nextSibling).remove();return!0});var s=r.outerHTML,d=y.opts.htmlAllowedStyleProps;return y.opts.htmlAllowedStyleProps=y.opts.wordAllowedStyleProps,s=y.clean.html(s,y.opts.wordDeniedTags,y.opts.wordDeniedAttrs,!1),y.opts.htmlAllowedStyleProps=d,s}return{_init:function e(){y.events.on("paste.wordPaste",function(e){return r=e,y.opts.wordPasteModal?function i(){if(!o){var e='<h4><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.95 73.23" style="height: 25px; vertical-align: text-bottom; margin-right: 5px; display: inline-block"><defs><style>.a{fill:#2a5699;}.b{fill:#fff;}</style></defs><path class="a" d="M615.15,827.22h5.09V834c9.11.05,18.21-.09,27.32.05a2.93,2.93,0,0,1,3.29,3.25c.14,16.77,0,33.56.09,50.33-.09,1.72.17,3.63-.83,5.15-1.24.89-2.85.78-4.3.84-8.52,0-17,0-25.56,0v6.81h-5.32c-13-2.37-26-4.54-38.94-6.81q0-29.8,0-59.59c13.05-2.28,26.11-4.5,39.17-6.83Z" transform="translate(-575.97 -827.22)"/><path class="b" d="M620.24,836.59h28.1v54.49h-28.1v-6.81h22.14v-3.41H620.24v-4.26h22.14V873.2H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24V846h22.14v-3.41H620.24Zm-26.67,15c1.62-.09,3.24-.16,4.85-.25,1.13,5.75,2.29,11.49,3.52,17.21,1-5.91,2-11.8,3.06-17.7,1.7-.06,3.41-.15,5.1-.26-1.92,8.25-3.61,16.57-5.71,24.77-1.42.74-3.55,0-5.24.09-1.13-5.64-2.45-11.24-3.47-16.9-1,5.5-2.29,10.95-3.43,16.42q-2.45-.13-4.92-.3c-1.41-7.49-3.07-14.93-4.39-22.44l4.38-.18c.88,5.42,1.87,10.82,2.64,16.25,1.2-5.57,2.43-11.14,3.62-16.71Z" transform="translate(-575.97 -827.22)"/></svg> '+y.language.translate("Word Paste Detected")+"</h4>",t=function r(){var e='<div class="fr-word-paste-modal" style="padding: 20px 20px 10px 20px;">';return e+='<p style="text-align: left;">'+y.language.translate("The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?")+"</p>",e+='<div style="text-align: right; margin-top: 50px;"><button class="fr-remove-word fr-command">'+y.language.translate("Clean")+'</button> <button class="fr-keep-word fr-command">'+y.language.translate("Keep")+"</button></div>",e+="</div>"}(),a=y.modals.create(s,e,t),n=a.$body;o=a.$modal,a.$modal.addClass("fr-middle"),y.events.bindClick(n,"button.fr-remove-word",function(){var e=o.data("instance")||y;e.wordPaste.clean()}),y.events.bindClick(n,"button.fr-keep-word",function(){var e=o.data("instance")||y;e.wordPaste.clean(!0)}),y.events.$on(M(y.o_win),"resize",function(){y.modals.resize(s)})}y.modals.show(s),y.modals.resize(s)}():t(y.opts.wordPasteKeepFormatting),!1})},clean:t,_wordClean:i}};var y={},a={},p={},u=n(!0),g="vanilla",h={github:{omitExtraWLInCodeBlocks:!0,simplifiedAutoLink:!0,excludeTrailingPunctuationFromURLs:!0,literalMidWordUnderscores:!0,strikethrough:!0,tables:!0,tablesHeaderId:!0,ghCodeBlocks:!0,tasklists:!0,disableForced4SpacesIndentedSublists:!0,simpleLineBreaks:!0,requireSpaceBeforeHeadingText:!0,ghCompatibleHeaderId:!0,ghMentions:!0,backslashEscapesHTMLTags:!0,emoji:!0,splitAdjacentBlockquotes:!0},original:{noHeaderId:!0,ghCodeBlocks:!1},ghost:{omitExtraWLInCodeBlocks:!0,parseImgDimensions:!0,simplifiedAutoLink:!0,excludeTrailingPunctuationFromURLs:!0,literalMidWordUnderscores:!0,strikethrough:!0,tables:!0,tablesHeaderId:!0,ghCodeBlocks:!0,tasklists:!0,smoothLivePreview:!0,simpleLineBreaks:!0,requireSpaceBeforeHeadingText:!0,ghMentions:!1,encodeEmails:!0},vanilla:n(!0),allOn:function _(){var e=n(!0),t={};for(var a in e)e.hasOwnProperty(a)&&(t[a]=!0);return t}()};function m(e,t){var a=t?"Error in "+t+" extension->":"Error in unnamed extension",n={valid:!0,error:""};y.helper.isArray(e)||(e=[e]);for(var r=0;r<e.length;++r){var i=a+" sub-extension "+r+": ",o=e[r];if("object"!==Rt(o))return n.valid=!1,n.error=i+"must be an object, but "+Rt(o)+" given",n;if(!y.helper.isString(o.type))return n.valid=!1,n.error=i+'property "type" must be a string, but '+Rt(o.type)+" given",n;var s=o.type=o.type.toLowerCase();if("language"===s&&(s=o.type="lang"),"html"===s&&(s=o.type="output"),"lang"!==s&&"output"!==s&&"listener"!==s)return n.valid=!1,n.error=i+"type "+s+' is not recognized. Valid values: "lang/language", "output/html" or "listener"',n;if("listener"===s){if(y.helper.isUndefined(o.listeners))return n.valid=!1,n.error=i+'. Extensions of type "listener" must have a property called "listeners"',n}else if(y.helper.isUndefined(o.filter)&&y.helper.isUndefined(o.regex))return n.valid=!1,n.error=i+s+' extensions must define either a "regex" property or a "filter" method',n;if(o.listeners){if("object"!==Rt(o.listeners))return n.valid=!1,n.error=i+'"listeners" property must be an object but '+Rt(o.listeners)+" given",n;for(var l in o.listeners)if(o.listeners.hasOwnProperty(l)&&"function"!=typeof o.listeners[l])return n.valid=!1,n.error=i+'"listeners" property must be an hash of [event name]: [callback]. listeners.'+l+" must be a function but "+Rt(o.listeners[l])+" given",n}if(o.filter){if("function"!=typeof o.filter)return n.valid=!1,n.error=i+'"filter" must be a function, but '+Rt(o.filter)+" given",n}else if(o.regex){if(y.helper.isString(o.regex)&&(o.regex=new RegExp(o.regex,"g")),!(o.regex instanceof RegExp))return n.valid=!1,n.error=i+'"regex" property must either be a string or a RegExp object, but '+Rt(o.regex)+" given",n;if(y.helper.isUndefined(o.replace))return n.valid=!1,n.error=i+'"regex" extensions must implement a replace string or function',n}}return n}function i(e,t){return"\xa8E"+t.charCodeAt(0)+"E"}y.helper={},y.extensions={},y.setOption=function(e,t){return u[e]=t,this},y.getOption=function(e){return u[e]},y.getOptions=function(){return u},y.resetOptions=function(){u=n(!0)},y.setFlavor=function(e){if(!h.hasOwnProperty(e))throw Error(e+" flavor was not found");y.resetOptions();var t=h[e];for(var a in g=e,t)t.hasOwnProperty(a)&&(u[a]=t[a])},y.getFlavor=function(){return g},y.getFlavorOptions=function(e){if(h.hasOwnProperty(e))return h[e]},y.getDefaultOptions=function(e){return n(e)},y.subParser=function(e,t){if(y.helper.isString(e)){if(void 0===t){if(a.hasOwnProperty(e))return a[e];throw Error("SubParser named "+e+" not registered!")}a[e]=t}},y.extension=function(e,t){if(!y.helper.isString(e))throw Error("Extension 'name' must be a string");if(e=y.helper.stdExtName(e),y.helper.isUndefined(t)){if(!p.hasOwnProperty(e))throw Error("Extension named "+e+" is not registered!");return p[e]}"function"==typeof t&&(t=t()),y.helper.isArray(t)||(t=[t]);var a=m(t,e);if(!a.valid)throw Error(a.error);p[e]=t},y.getAllExtensions=function(){return p},y.removeExtension=function(e){delete p[e]},y.resetExtensions=function(){p={}},y.validateExtension=function(e){var t=m(e,null);return!!t.valid},y.hasOwnProperty("helper")||(y.helper={}),y.helper.isString=function(e){return"string"==typeof e||e instanceof String},y.helper.isFunction=function(e){return e&&"[object Function]"==={}.toString.call(e)},y.helper.isArray=function(e){return Array.isArray(e)},y.helper.isUndefined=function(e){return void 0===e},y.helper.forEach=function(e,t){if(y.helper.isUndefined(e))throw new Error("obj param is required");if(y.helper.isUndefined(t))throw new Error("callback param is required");if(!y.helper.isFunction(t))throw new Error("callback param must be a function/closure");if("function"==typeof e.forEach)e.forEach(t);else if(y.helper.isArray(e))for(var a=0;a<e.length;a++)t(e[a],a,e);else{if("object"!==Rt(e))throw new Error("obj does not seem to be an array or an iterable object");for(var n in e)e.hasOwnProperty(n)&&t(e[n],n,e)}},y.helper.stdExtName=function(e){return e.replace(/[_?*+\/\\.^-]/g,"").replace(/\s/g,"").toLowerCase()},y.helper.escapeCharactersCallback=i,y.helper.escapeCharacters=function(e,t,a){var n="(["+t.replace(/([\[\]\\])/g,"\\$1")+"])";a&&(n="\\\\"+n);var r=new RegExp(n,"g");return e=e.replace(r,i)},y.helper.unescapeHTMLEntities=function(e){return e.replace(/&quot;/g,'"').replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&")};var v=function v(e,t,a,n){var r,i,o,s,l,c=n||"",d=-1<c.indexOf("g"),f=new RegExp(t+"|"+a,"g"+c.replace(/g/g,"")),p=new RegExp(t,c.replace(/g/g,"")),u=[];do{for(r=0;o=f.exec(e);)if(p.test(o[0]))r++||(s=(i=f.lastIndex)-o[0].length);else if(r&&!--r){l=o.index+o[0].length;var g={left:{start:s,end:i},match:{start:i,end:o.index},right:{start:o.index,end:l},wholeMatch:{start:s,end:l}};if(u.push(g),!d)return u}}while(r&&(f.lastIndex=i));return u};y.helper.matchRecursiveRegExp=function(e,t,a,n){for(var r=v(e,t,a,n),i=[],o=0;o<r.length;++o)i.push([e.slice(r[o].wholeMatch.start,r[o].wholeMatch.end),e.slice(r[o].match.start,r[o].match.end),e.slice(r[o].left.start,r[o].left.end),e.slice(r[o].right.start,r[o].right.end)]);return i},y.helper.replaceRecursiveRegExp=function(e,t,a,n,r){if(!y.helper.isFunction(t)){var i=t;t=function t(){return i}}var o=v(e,a,n,r),s=e,l=o.length;if(0<l){var c=[];0!==o[0].wholeMatch.start&&c.push(e.slice(0,o[0].wholeMatch.start));for(var d=0;d<l;++d)c.push(t(e.slice(o[d].wholeMatch.start,o[d].wholeMatch.end),e.slice(o[d].match.start,o[d].match.end),e.slice(o[d].left.start,o[d].left.end),e.slice(o[d].right.start,o[d].right.end))),d<l-1&&c.push(e.slice(o[d].wholeMatch.end,o[d+1].wholeMatch.start));o[l-1].wholeMatch.end<e.length&&c.push(e.slice(o[l-1].wholeMatch.end)),s=c.join("")}return s},y.helper.regexIndexOf=function(e,t,a){if(!y.helper.isString(e))throw"InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string";if(t instanceof RegExp==!1)throw"InvalidArgumentError: second parameter of showdown.helper.regexIndexOf function must be an instance of RegExp";var n=e.substring(a||0).search(t);return 0<=n?n+(a||0):n},y.helper.splitAtIndex=function(e,t){if(!y.helper.isString(e))throw"InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string";return[e.substring(0,t),e.substring(t)]},y.helper.encodeEmailAddress=function(e){var a=[function(e){return"&#"+e.charCodeAt(0)+";"},function(e){return"&#x"+e.charCodeAt(0).toString(16)+";"},function(e){return e}];return e=e.replace(/./g,function(e){if("@"===e)e=a[Math.floor(2*Math.random())](e);else{var t=Math.random();e=.9<t?a[2](e):.45<t?a[1](e):a[0](e)}return e})},y.helper.padEnd=function(e,t,a){return t>>=0,a=String(a||" "),e.length>t?String(e):((t-=e.length)>a.length&&(a+=a.repeat(t/a.length)),String(e)+a.slice(0,t))},"undefined"==typeof console&&(console={warn:function(e){alert(e)},log:function(e){alert(e)},error:function(e){throw e}}),y.helper.regexes={asteriskDashAndColon:/([*_:~])/g},y.helper.emojis={"+1":"\ud83d\udc4d","-1":"\ud83d\udc4e",100:"\ud83d\udcaf",1234:"\ud83d\udd22","1st_place_medal":"\ud83e\udd47","2nd_place_medal":"\ud83e\udd48","3rd_place_medal":"\ud83e\udd49","8ball":"\ud83c\udfb1",a:"\ud83c\udd70\ufe0f",ab:"\ud83c\udd8e",abc:"\ud83d\udd24",abcd:"\ud83d\udd21",accept:"\ud83c\ude51",aerial_tramway:"\ud83d\udea1",airplane:"\u2708\ufe0f",alarm_clock:"\u23f0",alembic:"\u2697\ufe0f",alien:"\ud83d\udc7d",ambulance:"\ud83d\ude91",amphora:"\ud83c\udffa",anchor:"\u2693\ufe0f",angel:"\ud83d\udc7c",anger:"\ud83d\udca2",angry:"\ud83d\ude20",anguished:"\ud83d\ude27",ant:"\ud83d\udc1c",apple:"\ud83c\udf4e",aquarius:"\u2652\ufe0f",aries:"\u2648\ufe0f",arrow_backward:"\u25c0\ufe0f",arrow_double_down:"\u23ec",arrow_double_up:"\u23eb",arrow_down:"\u2b07\ufe0f",arrow_down_small:"\ud83d\udd3d",arrow_forward:"\u25b6\ufe0f",arrow_heading_down:"\u2935\ufe0f",arrow_heading_up:"\u2934\ufe0f",arrow_left:"\u2b05\ufe0f",arrow_lower_left:"\u2199\ufe0f",arrow_lower_right:"\u2198\ufe0f",arrow_right:"\u27a1\ufe0f",arrow_right_hook:"\u21aa\ufe0f",arrow_up:"\u2b06\ufe0f",arrow_up_down:"\u2195\ufe0f",arrow_up_small:"\ud83d\udd3c",arrow_upper_left:"\u2196\ufe0f",arrow_upper_right:"\u2197\ufe0f",arrows_clockwise:"\ud83d\udd03",arrows_counterclockwise:"\ud83d\udd04",art:"\ud83c\udfa8",articulated_lorry:"\ud83d\ude9b",artificial_satellite:"\ud83d\udef0",astonished:"\ud83d\ude32",athletic_shoe:"\ud83d\udc5f",atm:"\ud83c\udfe7",atom_symbol:"\u269b\ufe0f",avocado:"\ud83e\udd51",b:"\ud83c\udd71\ufe0f",baby:"\ud83d\udc76",baby_bottle:"\ud83c\udf7c",baby_chick:"\ud83d\udc24",baby_symbol:"\ud83d\udebc",back:"\ud83d\udd19",bacon:"\ud83e\udd53",badminton:"\ud83c\udff8",baggage_claim:"\ud83d\udec4",baguette_bread:"\ud83e\udd56",balance_scale:"\u2696\ufe0f",balloon:"\ud83c\udf88",ballot_box:"\ud83d\uddf3",ballot_box_with_check:"\u2611\ufe0f",bamboo:"\ud83c\udf8d",banana:"\ud83c\udf4c",bangbang:"\u203c\ufe0f",bank:"\ud83c\udfe6",bar_chart:"\ud83d\udcca",barber:"\ud83d\udc88",baseball:"\u26be\ufe0f",basketball:"\ud83c\udfc0",basketball_man:"\u26f9\ufe0f",basketball_woman:"\u26f9\ufe0f&zwj;\u2640\ufe0f",bat:"\ud83e\udd87",bath:"\ud83d\udec0",bathtub:"\ud83d\udec1",battery:"\ud83d\udd0b",beach_umbrella:"\ud83c\udfd6",bear:"\ud83d\udc3b",bed:"\ud83d\udecf",bee:"\ud83d\udc1d",beer:"\ud83c\udf7a",beers:"\ud83c\udf7b",beetle:"\ud83d\udc1e",beginner:"\ud83d\udd30",bell:"\ud83d\udd14",bellhop_bell:"\ud83d\udece",bento:"\ud83c\udf71",biking_man:"\ud83d\udeb4",bike:"\ud83d\udeb2",biking_woman:"\ud83d\udeb4&zwj;\u2640\ufe0f",bikini:"\ud83d\udc59",biohazard:"\u2623\ufe0f",bird:"\ud83d\udc26",birthday:"\ud83c\udf82",black_circle:"\u26ab\ufe0f",black_flag:"\ud83c\udff4",black_heart:"\ud83d\udda4",black_joker:"\ud83c\udccf",black_large_square:"\u2b1b\ufe0f",black_medium_small_square:"\u25fe\ufe0f",black_medium_square:"\u25fc\ufe0f",black_nib:"\u2712\ufe0f",black_small_square:"\u25aa\ufe0f",black_square_button:"\ud83d\udd32",blonde_man:"\ud83d\udc71",blonde_woman:"\ud83d\udc71&zwj;\u2640\ufe0f",blossom:"\ud83c\udf3c",blowfish:"\ud83d\udc21",blue_book:"\ud83d\udcd8",blue_car:"\ud83d\ude99",blue_heart:"\ud83d\udc99",blush:"\ud83d\ude0a",boar:"\ud83d\udc17",boat:"\u26f5\ufe0f",bomb:"\ud83d\udca3",book:"\ud83d\udcd6",bookmark:"\ud83d\udd16",bookmark_tabs:"\ud83d\udcd1",books:"\ud83d\udcda",boom:"\ud83d\udca5",boot:"\ud83d\udc62",bouquet:"\ud83d\udc90",bowing_man:"\ud83d\ude47",bow_and_arrow:"\ud83c\udff9",bowing_woman:"\ud83d\ude47&zwj;\u2640\ufe0f",bowling:"\ud83c\udfb3",boxing_glove:"\ud83e\udd4a",boy:"\ud83d\udc66",bread:"\ud83c\udf5e",bride_with_veil:"\ud83d\udc70",bridge_at_night:"\ud83c\udf09",briefcase:"\ud83d\udcbc",broken_heart:"\ud83d\udc94",bug:"\ud83d\udc1b",building_construction:"\ud83c\udfd7",bulb:"\ud83d\udca1",bullettrain_front:"\ud83d\ude85",bullettrain_side:"\ud83d\ude84",burrito:"\ud83c\udf2f",bus:"\ud83d\ude8c",business_suit_levitating:"\ud83d\udd74",busstop:"\ud83d\ude8f",bust_in_silhouette:"\ud83d\udc64",busts_in_silhouette:"\ud83d\udc65",butterfly:"\ud83e\udd8b",cactus:"\ud83c\udf35",cake:"\ud83c\udf70",calendar:"\ud83d\udcc6",call_me_hand:"\ud83e\udd19",calling:"\ud83d\udcf2",camel:"\ud83d\udc2b",camera:"\ud83d\udcf7",camera_flash:"\ud83d\udcf8",camping:"\ud83c\udfd5",cancer:"\u264b\ufe0f",candle:"\ud83d\udd6f",candy:"\ud83c\udf6c",canoe:"\ud83d\udef6",capital_abcd:"\ud83d\udd20",capricorn:"\u2651\ufe0f",car:"\ud83d\ude97",card_file_box:"\ud83d\uddc3",card_index:"\ud83d\udcc7",card_index_dividers:"\ud83d\uddc2",carousel_horse:"\ud83c\udfa0",carrot:"\ud83e\udd55",cat:"\ud83d\udc31",cat2:"\ud83d\udc08",cd:"\ud83d\udcbf",chains:"\u26d3",champagne:"\ud83c\udf7e",chart:"\ud83d\udcb9",chart_with_downwards_trend:"\ud83d\udcc9",chart_with_upwards_trend:"\ud83d\udcc8",checkered_flag:"\ud83c\udfc1",cheese:"\ud83e\uddc0",cherries:"\ud83c\udf52",cherry_blossom:"\ud83c\udf38",chestnut:"\ud83c\udf30",chicken:"\ud83d\udc14",children_crossing:"\ud83d\udeb8",chipmunk:"\ud83d\udc3f",chocolate_bar:"\ud83c\udf6b",christmas_tree:"\ud83c\udf84",church:"\u26ea\ufe0f",cinema:"\ud83c\udfa6",circus_tent:"\ud83c\udfaa",city_sunrise:"\ud83c\udf07",city_sunset:"\ud83c\udf06",cityscape:"\ud83c\udfd9",cl:"\ud83c\udd91",clamp:"\ud83d\udddc",clap:"\ud83d\udc4f",clapper:"\ud83c\udfac",classical_building:"\ud83c\udfdb",clinking_glasses:"\ud83e\udd42",clipboard:"\ud83d\udccb",clock1:"\ud83d\udd50",clock10:"\ud83d\udd59",clock1030:"\ud83d\udd65",clock11:"\ud83d\udd5a",clock1130:"\ud83d\udd66",clock12:"\ud83d\udd5b",clock1230:"\ud83d\udd67",clock130:"\ud83d\udd5c",clock2:"\ud83d\udd51",clock230:"\ud83d\udd5d",clock3:"\ud83d\udd52",clock330:"\ud83d\udd5e",clock4:"\ud83d\udd53",clock430:"\ud83d\udd5f",clock5:"\ud83d\udd54",clock530:"\ud83d\udd60",clock6:"\ud83d\udd55",clock630:"\ud83d\udd61",clock7:"\ud83d\udd56",clock730:"\ud83d\udd62",clock8:"\ud83d\udd57",clock830:"\ud83d\udd63",clock9:"\ud83d\udd58",clock930:"\ud83d\udd64",closed_book:"\ud83d\udcd5",closed_lock_with_key:"\ud83d\udd10",closed_umbrella:"\ud83c\udf02",cloud:"\u2601\ufe0f",cloud_with_lightning:"\ud83c\udf29",cloud_with_lightning_and_rain:"\u26c8",cloud_with_rain:"\ud83c\udf27",cloud_with_snow:"\ud83c\udf28",clown_face:"\ud83e\udd21",clubs:"\u2663\ufe0f",cocktail:"\ud83c\udf78",coffee:"\u2615\ufe0f",coffin:"\u26b0\ufe0f",cold_sweat:"\ud83d\ude30",comet:"\u2604\ufe0f",computer:"\ud83d\udcbb",computer_mouse:"\ud83d\uddb1",confetti_ball:"\ud83c\udf8a",confounded:"\ud83d\ude16",confused:"\ud83d\ude15",congratulations:"\u3297\ufe0f",construction:"\ud83d\udea7",construction_worker_man:"\ud83d\udc77",construction_worker_woman:"\ud83d\udc77&zwj;\u2640\ufe0f",control_knobs:"\ud83c\udf9b",convenience_store:"\ud83c\udfea",cookie:"\ud83c\udf6a",cool:"\ud83c\udd92",policeman:"\ud83d\udc6e",copyright:"\xa9\ufe0f",corn:"\ud83c\udf3d",couch_and_lamp:"\ud83d\udecb",couple:"\ud83d\udc6b",couple_with_heart_woman_man:"\ud83d\udc91",couple_with_heart_man_man:"\ud83d\udc68&zwj;\u2764\ufe0f&zwj;\ud83d\udc68",couple_with_heart_woman_woman:"\ud83d\udc69&zwj;\u2764\ufe0f&zwj;\ud83d\udc69",couplekiss_man_man:"\ud83d\udc68&zwj;\u2764\ufe0f&zwj;\ud83d\udc8b&zwj;\ud83d\udc68",couplekiss_man_woman:"\ud83d\udc8f",couplekiss_woman_woman:"\ud83d\udc69&zwj;\u2764\ufe0f&zwj;\ud83d\udc8b&zwj;\ud83d\udc69",cow:"\ud83d\udc2e",cow2:"\ud83d\udc04",cowboy_hat_face:"\ud83e\udd20",crab:"\ud83e\udd80",crayon:"\ud83d\udd8d",credit_card:"\ud83d\udcb3",crescent_moon:"\ud83c\udf19",cricket:"\ud83c\udfcf",crocodile:"\ud83d\udc0a",croissant:"\ud83e\udd50",crossed_fingers:"\ud83e\udd1e",crossed_flags:"\ud83c\udf8c",crossed_swords:"\u2694\ufe0f",crown:"\ud83d\udc51",cry:"\ud83d\ude22",crying_cat_face:"\ud83d\ude3f",crystal_ball:"\ud83d\udd2e",cucumber:"\ud83e\udd52",cupid:"\ud83d\udc98",curly_loop:"\u27b0",currency_exchange:"\ud83d\udcb1",curry:"\ud83c\udf5b",custard:"\ud83c\udf6e",customs:"\ud83d\udec3",cyclone:"\ud83c\udf00",dagger:"\ud83d\udde1",dancer:"\ud83d\udc83",dancing_women:"\ud83d\udc6f",dancing_men:"\ud83d\udc6f&zwj;\u2642\ufe0f",dango:"\ud83c\udf61",dark_sunglasses:"\ud83d\udd76",dart:"\ud83c\udfaf",dash:"\ud83d\udca8",date:"\ud83d\udcc5",deciduous_tree:"\ud83c\udf33",deer:"\ud83e\udd8c",department_store:"\ud83c\udfec",derelict_house:"\ud83c\udfda",desert:"\ud83c\udfdc",desert_island:"\ud83c\udfdd",desktop_computer:"\ud83d\udda5",male_detective:"\ud83d\udd75\ufe0f",diamond_shape_with_a_dot_inside:"\ud83d\udca0",diamonds:"\u2666\ufe0f",disappointed:"\ud83d\ude1e",disappointed_relieved:"\ud83d\ude25",dizzy:"\ud83d\udcab",dizzy_face:"\ud83d\ude35",do_not_litter:"\ud83d\udeaf",dog:"\ud83d\udc36",dog2:"\ud83d\udc15",dollar:"\ud83d\udcb5",dolls:"\ud83c\udf8e",dolphin:"\ud83d\udc2c",door:"\ud83d\udeaa",doughnut:"\ud83c\udf69",dove:"\ud83d\udd4a",dragon:"\ud83d\udc09",dragon_face:"\ud83d\udc32",dress:"\ud83d\udc57",dromedary_camel:"\ud83d\udc2a",drooling_face:"\ud83e\udd24",droplet:"\ud83d\udca7",drum:"\ud83e\udd41",duck:"\ud83e\udd86",dvd:"\ud83d\udcc0","e-mail":"\ud83d\udce7",eagle:"\ud83e\udd85",ear:"\ud83d\udc42",ear_of_rice:"\ud83c\udf3e",earth_africa:"\ud83c\udf0d",earth_americas:"\ud83c\udf0e",earth_asia:"\ud83c\udf0f",egg:"\ud83e\udd5a",eggplant:"\ud83c\udf46",eight_pointed_black_star:"\u2734\ufe0f",eight_spoked_asterisk:"\u2733\ufe0f",electric_plug:"\ud83d\udd0c",elephant:"\ud83d\udc18",email:"\u2709\ufe0f",end:"\ud83d\udd1a",envelope_with_arrow:"\ud83d\udce9",euro:"\ud83d\udcb6",european_castle:"\ud83c\udff0",european_post_office:"\ud83c\udfe4",evergreen_tree:"\ud83c\udf32",exclamation:"\u2757\ufe0f",expressionless:"\ud83d\ude11",eye:"\ud83d\udc41",eye_speech_bubble:"\ud83d\udc41&zwj;\ud83d\udde8",eyeglasses:"\ud83d\udc53",eyes:"\ud83d\udc40",face_with_head_bandage:"\ud83e\udd15",face_with_thermometer:"\ud83e\udd12",fist_oncoming:"\ud83d\udc4a",factory:"\ud83c\udfed",fallen_leaf:"\ud83c\udf42",family_man_woman_boy:"\ud83d\udc6a",family_man_boy:"\ud83d\udc68&zwj;\ud83d\udc66",family_man_boy_boy:"\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66",family_man_girl:"\ud83d\udc68&zwj;\ud83d\udc67",family_man_girl_boy:"\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66",family_man_girl_girl:"\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67",family_man_man_boy:"\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66",family_man_man_boy_boy:"\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66",family_man_man_girl:"\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67",family_man_man_girl_boy:"\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66",family_man_man_girl_girl:"\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67",family_man_woman_boy_boy:"\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",family_man_woman_girl:"\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67",family_man_woman_girl_boy:"\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",family_man_woman_girl_girl:"\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",family_woman_boy:"\ud83d\udc69&zwj;\ud83d\udc66",family_woman_boy_boy:"\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",family_woman_girl:"\ud83d\udc69&zwj;\ud83d\udc67",family_woman_girl_boy:"\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",family_woman_girl_girl:"\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",family_woman_woman_boy:"\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66",family_woman_woman_boy_boy:"\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",family_woman_woman_girl:"\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67",family_woman_woman_girl_boy:"\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",family_woman_woman_girl_girl:"\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",fast_forward:"\u23e9",fax:"\ud83d\udce0",fearful:"\ud83d\ude28",feet:"\ud83d\udc3e",female_detective:"\ud83d\udd75\ufe0f&zwj;\u2640\ufe0f",ferris_wheel:"\ud83c\udfa1",ferry:"\u26f4",field_hockey:"\ud83c\udfd1",file_cabinet:"\ud83d\uddc4",file_folder:"\ud83d\udcc1",film_projector:"\ud83d\udcfd",film_strip:"\ud83c\udf9e",fire:"\ud83d\udd25",fire_engine:"\ud83d\ude92",fireworks:"\ud83c\udf86",first_quarter_moon:"\ud83c\udf13",first_quarter_moon_with_face:"\ud83c\udf1b",fish:"\ud83d\udc1f",fish_cake:"\ud83c\udf65",fishing_pole_and_fish:"\ud83c\udfa3",fist_raised:"\u270a",fist_left:"\ud83e\udd1b",fist_right:"\ud83e\udd1c",flags:"\ud83c\udf8f",flashlight:"\ud83d\udd26",fleur_de_lis:"\u269c\ufe0f",flight_arrival:"\ud83d\udeec",flight_departure:"\ud83d\udeeb",floppy_disk:"\ud83d\udcbe",flower_playing_cards:"\ud83c\udfb4",flushed:"\ud83d\ude33",fog:"\ud83c\udf2b",foggy:"\ud83c\udf01",football:"\ud83c\udfc8",footprints:"\ud83d\udc63",fork_and_knife:"\ud83c\udf74",fountain:"\u26f2\ufe0f",fountain_pen:"\ud83d\udd8b",four_leaf_clover:"\ud83c\udf40",fox_face:"\ud83e\udd8a",framed_picture:"\ud83d\uddbc",free:"\ud83c\udd93",fried_egg:"\ud83c\udf73",fried_shrimp:"\ud83c\udf64",fries:"\ud83c\udf5f",frog:"\ud83d\udc38",frowning:"\ud83d\ude26",frowning_face:"\u2639\ufe0f",frowning_man:"\ud83d\ude4d&zwj;\u2642\ufe0f",frowning_woman:"\ud83d\ude4d",middle_finger:"\ud83d\udd95",fuelpump:"\u26fd\ufe0f",full_moon:"\ud83c\udf15",full_moon_with_face:"\ud83c\udf1d",funeral_urn:"\u26b1\ufe0f",game_die:"\ud83c\udfb2",gear:"\u2699\ufe0f",gem:"\ud83d\udc8e",gemini:"\u264a\ufe0f",ghost:"\ud83d\udc7b",gift:"\ud83c\udf81",gift_heart:"\ud83d\udc9d",girl:"\ud83d\udc67",globe_with_meridians:"\ud83c\udf10",goal_net:"\ud83e\udd45",goat:"\ud83d\udc10",golf:"\u26f3\ufe0f",golfing_man:"\ud83c\udfcc\ufe0f",golfing_woman:"\ud83c\udfcc\ufe0f&zwj;\u2640\ufe0f",gorilla:"\ud83e\udd8d",grapes:"\ud83c\udf47",green_apple:"\ud83c\udf4f",green_book:"\ud83d\udcd7",green_heart:"\ud83d\udc9a",green_salad:"\ud83e\udd57",grey_exclamation:"\u2755",grey_question:"\u2754",grimacing:"\ud83d\ude2c",grin:"\ud83d\ude01",grinning:"\ud83d\ude00",guardsman:"\ud83d\udc82",guardswoman:"\ud83d\udc82&zwj;\u2640\ufe0f",guitar:"\ud83c\udfb8",gun:"\ud83d\udd2b",haircut_woman:"\ud83d\udc87",haircut_man:"\ud83d\udc87&zwj;\u2642\ufe0f",hamburger:"\ud83c\udf54",hammer:"\ud83d\udd28",hammer_and_pick:"\u2692",hammer_and_wrench:"\ud83d\udee0",hamster:"\ud83d\udc39",hand:"\u270b",handbag:"\ud83d\udc5c",handshake:"\ud83e\udd1d",hankey:"\ud83d\udca9",hatched_chick:"\ud83d\udc25",hatching_chick:"\ud83d\udc23",headphones:"\ud83c\udfa7",hear_no_evil:"\ud83d\ude49",heart:"\u2764\ufe0f",heart_decoration:"\ud83d\udc9f",heart_eyes:"\ud83d\ude0d",heart_eyes_cat:"\ud83d\ude3b",heartbeat:"\ud83d\udc93",heartpulse:"\ud83d\udc97",hearts:"\u2665\ufe0f",heavy_check_mark:"\u2714\ufe0f",heavy_division_sign:"\u2797",heavy_dollar_sign:"\ud83d\udcb2",heavy_heart_exclamation:"\u2763\ufe0f",heavy_minus_sign:"\u2796",heavy_multiplication_x:"\u2716\ufe0f",heavy_plus_sign:"\u2795",helicopter:"\ud83d\ude81",herb:"\ud83c\udf3f",hibiscus:"\ud83c\udf3a",high_brightness:"\ud83d\udd06",high_heel:"\ud83d\udc60",hocho:"\ud83d\udd2a",hole:"\ud83d\udd73",honey_pot:"\ud83c\udf6f",horse:"\ud83d\udc34",horse_racing:"\ud83c\udfc7",hospital:"\ud83c\udfe5",hot_pepper:"\ud83c\udf36",hotdog:"\ud83c\udf2d",hotel:"\ud83c\udfe8",hotsprings:"\u2668\ufe0f",hourglass:"\u231b\ufe0f",hourglass_flowing_sand:"\u23f3",house:"\ud83c\udfe0",house_with_garden:"\ud83c\udfe1",houses:"\ud83c\udfd8",hugs:"\ud83e\udd17",hushed:"\ud83d\ude2f",ice_cream:"\ud83c\udf68",ice_hockey:"\ud83c\udfd2",ice_skate:"\u26f8",icecream:"\ud83c\udf66",id:"\ud83c\udd94",ideograph_advantage:"\ud83c\ude50",imp:"\ud83d\udc7f",inbox_tray:"\ud83d\udce5",incoming_envelope:"\ud83d\udce8",tipping_hand_woman:"\ud83d\udc81",information_source:"\u2139\ufe0f",innocent:"\ud83d\ude07",interrobang:"\u2049\ufe0f",iphone:"\ud83d\udcf1",izakaya_lantern:"\ud83c\udfee",jack_o_lantern:"\ud83c\udf83",japan:"\ud83d\uddfe",japanese_castle:"\ud83c\udfef",japanese_goblin:"\ud83d\udc7a",japanese_ogre:"\ud83d\udc79",jeans:"\ud83d\udc56",joy:"\ud83d\ude02",joy_cat:"\ud83d\ude39",joystick:"\ud83d\udd79",kaaba:"\ud83d\udd4b",key:"\ud83d\udd11",keyboard:"\u2328\ufe0f",keycap_ten:"\ud83d\udd1f",kick_scooter:"\ud83d\udef4",kimono:"\ud83d\udc58",kiss:"\ud83d\udc8b",kissing:"\ud83d\ude17",kissing_cat:"\ud83d\ude3d",kissing_closed_eyes:"\ud83d\ude1a",kissing_heart:"\ud83d\ude18",kissing_smiling_eyes:"\ud83d\ude19",kiwi_fruit:"\ud83e\udd5d",koala:"\ud83d\udc28",koko:"\ud83c\ude01",label:"\ud83c\udff7",large_blue_circle:"\ud83d\udd35",large_blue_diamond:"\ud83d\udd37",large_orange_diamond:"\ud83d\udd36",last_quarter_moon:"\ud83c\udf17",last_quarter_moon_with_face:"\ud83c\udf1c",latin_cross:"\u271d\ufe0f",laughing:"\ud83d\ude06",leaves:"\ud83c\udf43",ledger:"\ud83d\udcd2",left_luggage:"\ud83d\udec5",left_right_arrow:"\u2194\ufe0f",leftwards_arrow_with_hook:"\u21a9\ufe0f",lemon:"\ud83c\udf4b",leo:"\u264c\ufe0f",leopard:"\ud83d\udc06",level_slider:"\ud83c\udf9a",libra:"\u264e\ufe0f",light_rail:"\ud83d\ude88",link:"\ud83d\udd17",lion:"\ud83e\udd81",lips:"\ud83d\udc44",lipstick:"\ud83d\udc84",lizard:"\ud83e\udd8e",lock:"\ud83d\udd12",lock_with_ink_pen:"\ud83d\udd0f",lollipop:"\ud83c\udf6d",loop:"\u27bf",loud_sound:"\ud83d\udd0a",loudspeaker:"\ud83d\udce2",love_hotel:"\ud83c\udfe9",love_letter:"\ud83d\udc8c",low_brightness:"\ud83d\udd05",lying_face:"\ud83e\udd25",m:"\u24c2\ufe0f",mag:"\ud83d\udd0d",mag_right:"\ud83d\udd0e",mahjong:"\ud83c\udc04\ufe0f",mailbox:"\ud83d\udceb",mailbox_closed:"\ud83d\udcea",mailbox_with_mail:"\ud83d\udcec",mailbox_with_no_mail:"\ud83d\udced",man:"\ud83d\udc68",man_artist:"\ud83d\udc68&zwj;\ud83c\udfa8",man_astronaut:"\ud83d\udc68&zwj;\ud83d\ude80",man_cartwheeling:"\ud83e\udd38&zwj;\u2642\ufe0f",man_cook:"\ud83d\udc68&zwj;\ud83c\udf73",man_dancing:"\ud83d\udd7a",man_facepalming:"\ud83e\udd26&zwj;\u2642\ufe0f",man_factory_worker:"\ud83d\udc68&zwj;\ud83c\udfed",man_farmer:"\ud83d\udc68&zwj;\ud83c\udf3e",man_firefighter:"\ud83d\udc68&zwj;\ud83d\ude92",man_health_worker:"\ud83d\udc68&zwj;\u2695\ufe0f",man_in_tuxedo:"\ud83e\udd35",man_judge:"\ud83d\udc68&zwj;\u2696\ufe0f",man_juggling:"\ud83e\udd39&zwj;\u2642\ufe0f",man_mechanic:"\ud83d\udc68&zwj;\ud83d\udd27",man_office_worker:"\ud83d\udc68&zwj;\ud83d\udcbc",man_pilot:"\ud83d\udc68&zwj;\u2708\ufe0f",man_playing_handball:"\ud83e\udd3e&zwj;\u2642\ufe0f",man_playing_water_polo:"\ud83e\udd3d&zwj;\u2642\ufe0f",man_scientist:"\ud83d\udc68&zwj;\ud83d\udd2c",man_shrugging:"\ud83e\udd37&zwj;\u2642\ufe0f",man_singer:"\ud83d\udc68&zwj;\ud83c\udfa4",man_student:"\ud83d\udc68&zwj;\ud83c\udf93",man_teacher:"\ud83d\udc68&zwj;\ud83c\udfeb",man_technologist:"\ud83d\udc68&zwj;\ud83d\udcbb",man_with_gua_pi_mao:"\ud83d\udc72",man_with_turban:"\ud83d\udc73",tangerine:"\ud83c\udf4a",mans_shoe:"\ud83d\udc5e",mantelpiece_clock:"\ud83d\udd70",maple_leaf:"\ud83c\udf41",martial_arts_uniform:"\ud83e\udd4b",mask:"\ud83d\ude37",massage_woman:"\ud83d\udc86",massage_man:"\ud83d\udc86&zwj;\u2642\ufe0f",meat_on_bone:"\ud83c\udf56",medal_military:"\ud83c\udf96",medal_sports:"\ud83c\udfc5",mega:"\ud83d\udce3",melon:"\ud83c\udf48",memo:"\ud83d\udcdd",men_wrestling:"\ud83e\udd3c&zwj;\u2642\ufe0f",menorah:"\ud83d\udd4e",mens:"\ud83d\udeb9",metal:"\ud83e\udd18",metro:"\ud83d\ude87",microphone:"\ud83c\udfa4",microscope:"\ud83d\udd2c",milk_glass:"\ud83e\udd5b",milky_way:"\ud83c\udf0c",minibus:"\ud83d\ude90",minidisc:"\ud83d\udcbd",mobile_phone_off:"\ud83d\udcf4",money_mouth_face:"\ud83e\udd11",money_with_wings:"\ud83d\udcb8",moneybag:"\ud83d\udcb0",monkey:"\ud83d\udc12",monkey_face:"\ud83d\udc35",monorail:"\ud83d\ude9d",moon:"\ud83c\udf14",mortar_board:"\ud83c\udf93",mosque:"\ud83d\udd4c",motor_boat:"\ud83d\udee5",motor_scooter:"\ud83d\udef5",motorcycle:"\ud83c\udfcd",motorway:"\ud83d\udee3",mount_fuji:"\ud83d\uddfb",mountain:"\u26f0",mountain_biking_man:"\ud83d\udeb5",mountain_biking_woman:"\ud83d\udeb5&zwj;\u2640\ufe0f",mountain_cableway:"\ud83d\udea0",mountain_railway:"\ud83d\ude9e",mountain_snow:"\ud83c\udfd4",mouse:"\ud83d\udc2d",mouse2:"\ud83d\udc01",movie_camera:"\ud83c\udfa5",moyai:"\ud83d\uddff",mrs_claus:"\ud83e\udd36",muscle:"\ud83d\udcaa",mushroom:"\ud83c\udf44",musical_keyboard:"\ud83c\udfb9",musical_note:"\ud83c\udfb5",musical_score:"\ud83c\udfbc",mute:"\ud83d\udd07",nail_care:"\ud83d\udc85",name_badge:"\ud83d\udcdb",national_park:"\ud83c\udfde",nauseated_face:"\ud83e\udd22",necktie:"\ud83d\udc54",negative_squared_cross_mark:"\u274e",nerd_face:"\ud83e\udd13",neutral_face:"\ud83d\ude10","new":"\ud83c\udd95",new_moon:"\ud83c\udf11",new_moon_with_face:"\ud83c\udf1a",newspaper:"\ud83d\udcf0",newspaper_roll:"\ud83d\uddde",next_track_button:"\u23ed",ng:"\ud83c\udd96",no_good_man:"\ud83d\ude45&zwj;\u2642\ufe0f",no_good_woman:"\ud83d\ude45",night_with_stars:"\ud83c\udf03",no_bell:"\ud83d\udd15",no_bicycles:"\ud83d\udeb3",no_entry:"\u26d4\ufe0f",no_entry_sign:"\ud83d\udeab",no_mobile_phones:"\ud83d\udcf5",no_mouth:"\ud83d\ude36",no_pedestrians:"\ud83d\udeb7",no_smoking:"\ud83d\udead","non-potable_water":"\ud83d\udeb1",nose:"\ud83d\udc43",notebook:"\ud83d\udcd3",notebook_with_decorative_cover:"\ud83d\udcd4",notes:"\ud83c\udfb6",nut_and_bolt:"\ud83d\udd29",o:"\u2b55\ufe0f",o2:"\ud83c\udd7e\ufe0f",ocean:"\ud83c\udf0a",octopus:"\ud83d\udc19",oden:"\ud83c\udf62",office:"\ud83c\udfe2",oil_drum:"\ud83d\udee2",ok:"\ud83c\udd97",ok_hand:"\ud83d\udc4c",ok_man:"\ud83d\ude46&zwj;\u2642\ufe0f",ok_woman:"\ud83d\ude46",old_key:"\ud83d\udddd",older_man:"\ud83d\udc74",older_woman:"\ud83d\udc75",om:"\ud83d\udd49",on:"\ud83d\udd1b",oncoming_automobile:"\ud83d\ude98",oncoming_bus:"\ud83d\ude8d",oncoming_police_car:"\ud83d\ude94",oncoming_taxi:"\ud83d\ude96",open_file_folder:"\ud83d\udcc2",open_hands:"\ud83d\udc50",open_mouth:"\ud83d\ude2e",open_umbrella:"\u2602\ufe0f",ophiuchus:"\u26ce",orange_book:"\ud83d\udcd9",orthodox_cross:"\u2626\ufe0f",outbox_tray:"\ud83d\udce4",owl:"\ud83e\udd89",ox:"\ud83d\udc02","package":"\ud83d\udce6",page_facing_up:"\ud83d\udcc4",page_with_curl:"\ud83d\udcc3",pager:"\ud83d\udcdf",paintbrush:"\ud83d\udd8c",palm_tree:"\ud83c\udf34",pancakes:"\ud83e\udd5e",panda_face:"\ud83d\udc3c",paperclip:"\ud83d\udcce",paperclips:"\ud83d\udd87",parasol_on_ground:"\u26f1",parking:"\ud83c\udd7f\ufe0f",part_alternation_mark:"\u303d\ufe0f",partly_sunny:"\u26c5\ufe0f",passenger_ship:"\ud83d\udef3",passport_control:"\ud83d\udec2",pause_button:"\u23f8",peace_symbol:"\u262e\ufe0f",peach:"\ud83c\udf51",peanuts:"\ud83e\udd5c",pear:"\ud83c\udf50",pen:"\ud83d\udd8a",pencil2:"\u270f\ufe0f",penguin:"\ud83d\udc27",pensive:"\ud83d\ude14",performing_arts:"\ud83c\udfad",persevere:"\ud83d\ude23",person_fencing:"\ud83e\udd3a",pouting_woman:"\ud83d\ude4e",phone:"\u260e\ufe0f",pick:"\u26cf",pig:"\ud83d\udc37",pig2:"\ud83d\udc16",pig_nose:"\ud83d\udc3d",pill:"\ud83d\udc8a",pineapple:"\ud83c\udf4d",ping_pong:"\ud83c\udfd3",pisces:"\u2653\ufe0f",pizza:"\ud83c\udf55",place_of_worship:"\ud83d\uded0",plate_with_cutlery:"\ud83c\udf7d",play_or_pause_button:"\u23ef",point_down:"\ud83d\udc47",point_left:"\ud83d\udc48",point_right:"\ud83d\udc49",point_up:"\u261d\ufe0f",point_up_2:"\ud83d\udc46",police_car:"\ud83d\ude93",policewoman:"\ud83d\udc6e&zwj;\u2640\ufe0f",poodle:"\ud83d\udc29",popcorn:"\ud83c\udf7f",post_office:"\ud83c\udfe3",postal_horn:"\ud83d\udcef",postbox:"\ud83d\udcee",potable_water:"\ud83d\udeb0",potato:"\ud83e\udd54",pouch:"\ud83d\udc5d",poultry_leg:"\ud83c\udf57",pound:"\ud83d\udcb7",rage:"\ud83d\ude21",pouting_cat:"\ud83d\ude3e",pouting_man:"\ud83d\ude4e&zwj;\u2642\ufe0f",pray:"\ud83d\ude4f",prayer_beads:"\ud83d\udcff",pregnant_woman:"\ud83e\udd30",previous_track_button:"\u23ee",prince:"\ud83e\udd34",princess:"\ud83d\udc78",printer:"\ud83d\udda8",purple_heart:"\ud83d\udc9c",purse:"\ud83d\udc5b",pushpin:"\ud83d\udccc",put_litter_in_its_place:"\ud83d\udeae",question:"\u2753",rabbit:"\ud83d\udc30",rabbit2:"\ud83d\udc07",racehorse:"\ud83d\udc0e",racing_car:"\ud83c\udfce",radio:"\ud83d\udcfb",radio_button:"\ud83d\udd18",radioactive:"\u2622\ufe0f",railway_car:"\ud83d\ude83",railway_track:"\ud83d\udee4",rainbow:"\ud83c\udf08",rainbow_flag:"\ud83c\udff3\ufe0f&zwj;\ud83c\udf08",raised_back_of_hand:"\ud83e\udd1a",raised_hand_with_fingers_splayed:"\ud83d\udd90",raised_hands:"\ud83d\ude4c",raising_hand_woman:"\ud83d\ude4b",raising_hand_man:"\ud83d\ude4b&zwj;\u2642\ufe0f",ram:"\ud83d\udc0f",ramen:"\ud83c\udf5c",rat:"\ud83d\udc00",record_button:"\u23fa",recycle:"\u267b\ufe0f",red_circle:"\ud83d\udd34",registered:"\xae\ufe0f",relaxed:"\u263a\ufe0f",relieved:"\ud83d\ude0c",reminder_ribbon:"\ud83c\udf97",repeat:"\ud83d\udd01",repeat_one:"\ud83d\udd02",rescue_worker_helmet:"\u26d1",restroom:"\ud83d\udebb",revolving_hearts:"\ud83d\udc9e",rewind:"\u23ea",rhinoceros:"\ud83e\udd8f",ribbon:"\ud83c\udf80",rice:"\ud83c\udf5a",rice_ball:"\ud83c\udf59",rice_cracker:"\ud83c\udf58",rice_scene:"\ud83c\udf91",right_anger_bubble:"\ud83d\uddef",ring:"\ud83d\udc8d",robot:"\ud83e\udd16",rocket:"\ud83d\ude80",rofl:"\ud83e\udd23",roll_eyes:"\ud83d\ude44",roller_coaster:"\ud83c\udfa2",rooster:"\ud83d\udc13",rose:"\ud83c\udf39",rosette:"\ud83c\udff5",rotating_light:"\ud83d\udea8",round_pushpin:"\ud83d\udccd",rowing_man:"\ud83d\udea3",rowing_woman:"\ud83d\udea3&zwj;\u2640\ufe0f",rugby_football:"\ud83c\udfc9",running_man:"\ud83c\udfc3",running_shirt_with_sash:"\ud83c\udfbd",running_woman:"\ud83c\udfc3&zwj;\u2640\ufe0f",sa:"\ud83c\ude02\ufe0f",sagittarius:"\u2650\ufe0f",sake:"\ud83c\udf76",sandal:"\ud83d\udc61",santa:"\ud83c\udf85",satellite:"\ud83d\udce1",saxophone:"\ud83c\udfb7",school:"\ud83c\udfeb",school_satchel:"\ud83c\udf92",scissors:"\u2702\ufe0f",scorpion:"\ud83e\udd82",scorpius:"\u264f\ufe0f",scream:"\ud83d\ude31",scream_cat:"\ud83d\ude40",scroll:"\ud83d\udcdc",seat:"\ud83d\udcba",secret:"\u3299\ufe0f",see_no_evil:"\ud83d\ude48",seedling:"\ud83c\udf31",selfie:"\ud83e\udd33",shallow_pan_of_food:"\ud83e\udd58",shamrock:"\u2618\ufe0f",shark:"\ud83e\udd88",shaved_ice:"\ud83c\udf67",sheep:"\ud83d\udc11",shell:"\ud83d\udc1a",shield:"\ud83d\udee1",shinto_shrine:"\u26e9",ship:"\ud83d\udea2",shirt:"\ud83d\udc55",shopping:"\ud83d\udecd",shopping_cart:"\ud83d\uded2",shower:"\ud83d\udebf",shrimp:"\ud83e\udd90",signal_strength:"\ud83d\udcf6",six_pointed_star:"\ud83d\udd2f",ski:"\ud83c\udfbf",skier:"\u26f7",skull:"\ud83d\udc80",skull_and_crossbones:"\u2620\ufe0f",sleeping:"\ud83d\ude34",sleeping_bed:"\ud83d\udecc",sleepy:"\ud83d\ude2a",slightly_frowning_face:"\ud83d\ude41",slightly_smiling_face:"\ud83d\ude42",slot_machine:"\ud83c\udfb0",small_airplane:"\ud83d\udee9",small_blue_diamond:"\ud83d\udd39",small_orange_diamond:"\ud83d\udd38",small_red_triangle:"\ud83d\udd3a",small_red_triangle_down:"\ud83d\udd3b",smile:"\ud83d\ude04",smile_cat:"\ud83d\ude38",smiley:"\ud83d\ude03",smiley_cat:"\ud83d\ude3a",smiling_imp:"\ud83d\ude08",smirk:"\ud83d\ude0f",smirk_cat:"\ud83d\ude3c",smoking:"\ud83d\udeac",snail:"\ud83d\udc0c",snake:"\ud83d\udc0d",sneezing_face:"\ud83e\udd27",snowboarder:"\ud83c\udfc2",snowflake:"\u2744\ufe0f",snowman:"\u26c4\ufe0f",snowman_with_snow:"\u2603\ufe0f",sob:"\ud83d\ude2d",soccer:"\u26bd\ufe0f",soon:"\ud83d\udd1c",sos:"\ud83c\udd98",sound:"\ud83d\udd09",space_invader:"\ud83d\udc7e",spades:"\u2660\ufe0f",spaghetti:"\ud83c\udf5d",sparkle:"\u2747\ufe0f",sparkler:"\ud83c\udf87",sparkles:"\u2728",sparkling_heart:"\ud83d\udc96",speak_no_evil:"\ud83d\ude4a",speaker:"\ud83d\udd08",speaking_head:"\ud83d\udde3",speech_balloon:"\ud83d\udcac",speedboat:"\ud83d\udea4",spider:"\ud83d\udd77",spider_web:"\ud83d\udd78",spiral_calendar:"\ud83d\uddd3",spiral_notepad:"\ud83d\uddd2",spoon:"\ud83e\udd44",squid:"\ud83e\udd91",stadium:"\ud83c\udfdf",star:"\u2b50\ufe0f",star2:"\ud83c\udf1f",star_and_crescent:"\u262a\ufe0f",star_of_david:"\u2721\ufe0f",stars:"\ud83c\udf20",station:"\ud83d\ude89",statue_of_liberty:"\ud83d\uddfd",steam_locomotive:"\ud83d\ude82",stew:"\ud83c\udf72",stop_button:"\u23f9",stop_sign:"\ud83d\uded1",stopwatch:"\u23f1",straight_ruler:"\ud83d\udccf",strawberry:"\ud83c\udf53",stuck_out_tongue:"\ud83d\ude1b",stuck_out_tongue_closed_eyes:"\ud83d\ude1d",stuck_out_tongue_winking_eye:"\ud83d\ude1c",studio_microphone:"\ud83c\udf99",stuffed_flatbread:"\ud83e\udd59",sun_behind_large_cloud:"\ud83c\udf25",sun_behind_rain_cloud:"\ud83c\udf26",sun_behind_small_cloud:"\ud83c\udf24",sun_with_face:"\ud83c\udf1e",sunflower:"\ud83c\udf3b",sunglasses:"\ud83d\ude0e",sunny:"\u2600\ufe0f",sunrise:"\ud83c\udf05",sunrise_over_mountains:"\ud83c\udf04",surfing_man:"\ud83c\udfc4",surfing_woman:"\ud83c\udfc4&zwj;\u2640\ufe0f",sushi:"\ud83c\udf63",suspension_railway:"\ud83d\ude9f",sweat:"\ud83d\ude13",sweat_drops:"\ud83d\udca6",sweat_smile:"\ud83d\ude05",sweet_potato:"\ud83c\udf60",swimming_man:"\ud83c\udfca",swimming_woman:"\ud83c\udfca&zwj;\u2640\ufe0f",symbols:"\ud83d\udd23",synagogue:"\ud83d\udd4d",syringe:"\ud83d\udc89",taco:"\ud83c\udf2e",tada:"\ud83c\udf89",tanabata_tree:"\ud83c\udf8b",taurus:"\u2649\ufe0f",taxi:"\ud83d\ude95",tea:"\ud83c\udf75",telephone_receiver:"\ud83d\udcde",telescope:"\ud83d\udd2d",tennis:"\ud83c\udfbe",tent:"\u26fa\ufe0f",thermometer:"\ud83c\udf21",thinking:"\ud83e\udd14",thought_balloon:"\ud83d\udcad",ticket:"\ud83c\udfab",tickets:"\ud83c\udf9f",tiger:"\ud83d\udc2f",tiger2:"\ud83d\udc05",timer_clock:"\u23f2",tipping_hand_man:"\ud83d\udc81&zwj;\u2642\ufe0f",tired_face:"\ud83d\ude2b",tm:"\u2122\ufe0f",toilet:"\ud83d\udebd",tokyo_tower:"\ud83d\uddfc",tomato:"\ud83c\udf45",tongue:"\ud83d\udc45",top:"\ud83d\udd1d",tophat:"\ud83c\udfa9",tornado:"\ud83c\udf2a",trackball:"\ud83d\uddb2",tractor:"\ud83d\ude9c",traffic_light:"\ud83d\udea5",train:"\ud83d\ude8b",train2:"\ud83d\ude86",tram:"\ud83d\ude8a",triangular_flag_on_post:"\ud83d\udea9",triangular_ruler:"\ud83d\udcd0",trident:"\ud83d\udd31",triumph:"\ud83d\ude24",trolleybus:"\ud83d\ude8e",trophy:"\ud83c\udfc6",tropical_drink:"\ud83c\udf79",tropical_fish:"\ud83d\udc20",truck:"\ud83d\ude9a",trumpet:"\ud83c\udfba",tulip:"\ud83c\udf37",tumbler_glass:"\ud83e\udd43",turkey:"\ud83e\udd83",turtle:"\ud83d\udc22",tv:"\ud83d\udcfa",twisted_rightwards_arrows:"\ud83d\udd00",two_hearts:"\ud83d\udc95",two_men_holding_hands:"\ud83d\udc6c",two_women_holding_hands:"\ud83d\udc6d",u5272:"\ud83c\ude39",u5408:"\ud83c\ude34",u55b6:"\ud83c\ude3a",u6307:"\ud83c\ude2f\ufe0f",u6708:"\ud83c\ude37\ufe0f",u6709:"\ud83c\ude36",u6e80:"\ud83c\ude35",u7121:"\ud83c\ude1a\ufe0f",u7533:"\ud83c\ude38",u7981:"\ud83c\ude32",u7a7a:"\ud83c\ude33",umbrella:"\u2614\ufe0f",unamused:"\ud83d\ude12",underage:"\ud83d\udd1e",unicorn:"\ud83e\udd84",unlock:"\ud83d\udd13",up:"\ud83c\udd99",upside_down_face:"\ud83d\ude43",v:"\u270c\ufe0f",vertical_traffic_light:"\ud83d\udea6",vhs:"\ud83d\udcfc",vibration_mode:"\ud83d\udcf3",video_camera:"\ud83d\udcf9",video_game:"\ud83c\udfae",violin:"\ud83c\udfbb",virgo:"\u264d\ufe0f",volcano:"\ud83c\udf0b",volleyball:"\ud83c\udfd0",vs:"\ud83c\udd9a",vulcan_salute:"\ud83d\udd96",walking_man:"\ud83d\udeb6",walking_woman:"\ud83d\udeb6&zwj;\u2640\ufe0f",waning_crescent_moon:"\ud83c\udf18",waning_gibbous_moon:"\ud83c\udf16",warning:"\u26a0\ufe0f",wastebasket:"\ud83d\uddd1",watch:"\u231a\ufe0f",water_buffalo:"\ud83d\udc03",watermelon:"\ud83c\udf49",wave:"\ud83d\udc4b",wavy_dash:"\u3030\ufe0f",waxing_crescent_moon:"\ud83c\udf12",wc:"\ud83d\udebe",weary:"\ud83d\ude29",wedding:"\ud83d\udc92",weight_lifting_man:"\ud83c\udfcb\ufe0f",weight_lifting_woman:"\ud83c\udfcb\ufe0f&zwj;\u2640\ufe0f",whale:"\ud83d\udc33",whale2:"\ud83d\udc0b",wheel_of_dharma:"\u2638\ufe0f",wheelchair:"\u267f\ufe0f",white_check_mark:"\u2705",white_circle:"\u26aa\ufe0f",white_flag:"\ud83c\udff3\ufe0f",white_flower:"\ud83d\udcae",white_large_square:"\u2b1c\ufe0f",white_medium_small_square:"\u25fd\ufe0f",white_medium_square:"\u25fb\ufe0f",white_small_square:"\u25ab\ufe0f",white_square_button:"\ud83d\udd33",wilted_flower:"\ud83e\udd40",wind_chime:"\ud83c\udf90",wind_face:"\ud83c\udf2c",wine_glass:"\ud83c\udf77",wink:"\ud83d\ude09",wolf:"\ud83d\udc3a",woman:"\ud83d\udc69",woman_artist:"\ud83d\udc69&zwj;\ud83c\udfa8",woman_astronaut:"\ud83d\udc69&zwj;\ud83d\ude80",woman_cartwheeling:"\ud83e\udd38&zwj;\u2640\ufe0f",woman_cook:"\ud83d\udc69&zwj;\ud83c\udf73",woman_facepalming:"\ud83e\udd26&zwj;\u2640\ufe0f",woman_factory_worker:"\ud83d\udc69&zwj;\ud83c\udfed",woman_farmer:"\ud83d\udc69&zwj;\ud83c\udf3e",woman_firefighter:"\ud83d\udc69&zwj;\ud83d\ude92",woman_health_worker:"\ud83d\udc69&zwj;\u2695\ufe0f",woman_judge:"\ud83d\udc69&zwj;\u2696\ufe0f",woman_juggling:"\ud83e\udd39&zwj;\u2640\ufe0f",woman_mechanic:"\ud83d\udc69&zwj;\ud83d\udd27",woman_office_worker:"\ud83d\udc69&zwj;\ud83d\udcbc",woman_pilot:"\ud83d\udc69&zwj;\u2708\ufe0f",woman_playing_handball:"\ud83e\udd3e&zwj;\u2640\ufe0f",woman_playing_water_polo:"\ud83e\udd3d&zwj;\u2640\ufe0f",woman_scientist:"\ud83d\udc69&zwj;\ud83d\udd2c",woman_shrugging:"\ud83e\udd37&zwj;\u2640\ufe0f",woman_singer:"\ud83d\udc69&zwj;\ud83c\udfa4",woman_student:"\ud83d\udc69&zwj;\ud83c\udf93",woman_teacher:"\ud83d\udc69&zwj;\ud83c\udfeb",woman_technologist:"\ud83d\udc69&zwj;\ud83d\udcbb",woman_with_turban:"\ud83d\udc73&zwj;\u2640\ufe0f",womans_clothes:"\ud83d\udc5a",womans_hat:"\ud83d\udc52",women_wrestling:"\ud83e\udd3c&zwj;\u2640\ufe0f",womens:"\ud83d\udeba",world_map:"\ud83d\uddfa",worried:"\ud83d\ude1f",wrench:"\ud83d\udd27",writing_hand:"\u270d\ufe0f",x:"\u274c",yellow_heart:"\ud83d\udc9b",yen:"\ud83d\udcb4",yin_yang:"\u262f\ufe0f",yum:"\ud83d\ude0b",zap:"\u26a1\ufe0f",zipper_mouth_face:"\ud83e\udd10",zzz:"\ud83d\udca4",octocat:'<img alt=":octocat:" height="20" width="20" align="absmiddle" src="https://assets-cdn.github.com/images/icons/emoji/octocat.png">',showdown:"<span style=\"font-family: 'Anonymous Pro', monospace; text-decoration: underline; text-decoration-style: dashed; text-decoration-color: #3e8b8a;text-underline-position: under;\">S</span>"},y.Converter=function(a){var r={},o=[],s=[],l={},n=g,i={parsed:{},raw:"",format:""};function c(e,t){if(t=t||null,y.helper.isString(e)){if(t=e=y.helper.stdExtName(e),y.extensions[e])return void function i(e,t){"function"==typeof e&&(e=e(new y.Converter));y.helper.isArray(e)||(e=[e]);var a=m(e,t);if(!a.valid)throw Error(a.error);for(var n=0;n<e.length;++n)switch(e[n].type){case"lang":o.push(e[n]);break;case"output":s.push(e[n]);break;default:throw Error("Extension loader error: Type unrecognized!!!")}}(y.extensions[e],e);if(y.helper.isUndefined(p[e]))throw Error('Extension "'+e+'" could not be loaded. It was either not found or is not a valid extension.');e=p[e]}"function"==typeof e&&(e=e()),y.helper.isArray(e)||(e=[e]);var a=m(e,t);if(!a.valid)throw Error(a.error);for(var n=0;n<e.length;++n){switch(e[n].type){case"lang":o.push(e[n]);break;case"output":s.push(e[n])}if(e[n].hasOwnProperty("listeners"))for(var r in e[n].listeners)e[n].listeners.hasOwnProperty(r)&&d(r,e[n].listeners[r])}}function d(e,t){if(!y.helper.isString(e))throw Error("Invalid argument in converter.listen() method: name must be a string, but "+Rt(e)+" given");if("function"!=typeof t)throw Error("Invalid argument in converter.listen() method: callback must be a function, but "+Rt(t)+" given");l.hasOwnProperty(e)||(l[e]=[]),l[e].push(t)}!function f(){for(var e in a=a||{},u)u.hasOwnProperty(e)&&(r[e]=u[e]);{if("object"!==Rt(a))throw Error("Converter expects the passed parameter to be an object, but "+Rt(a)+" was passed instead.");for(var t in a)a.hasOwnProperty(t)&&(r[t]=a[t])}r.extensions&&y.helper.forEach(r.extensions,c)}(),this._dispatch=function(e,t,a,n){if(l.hasOwnProperty(e))for(var r=0;r<l[e].length;++r){var i=l[e][r](e,t,this,a,n);i&&void 0!==i&&(t=i)}return t},this.listen=function(e,t){return d(e,t),this},this.makeHtml=function(t){if(!t)return t;var a={gHtmlBlocks:[],gHtmlMdBlocks:[],gHtmlSpans:[],gUrls:{},gTitles:{},gDimensions:{},gListLevel:0,hashLinkCounts:{},langExtensions:o,outputModifiers:s,converter:this,ghCodeBlocks:[],metadata:{parsed:{},raw:"",format:""}};return t=(t=(t=(t=(t=t.replace(/\xa8/g,"\xa8T")).replace(/\$/g,"\xa8D")).replace(/\r\n/g,"\n")).replace(/\r/g,"\n")).replace(/\u00A0/g,"&nbsp;"),r.smartIndentationFix&&(t=function n(e){var t=e.match(/^\s*/)[0].length,a=new RegExp("^\\s{0,"+t+"}","gm");return e.replace(a,"")}(t)),t="\n\n"+t+"\n\n",t=(t=y.subParser("detab")(t,r,a)).replace(/^[ \t]+$/gm,""),y.helper.forEach(o,function(e){t=y.subParser("runExtension")(e,t,r,a)}),t=y.subParser("metadata")(t,r,a),t=y.subParser("hashPreCodeTags")(t,r,a),t=y.subParser("githubCodeBlocks")(t,r,a),t=y.subParser("hashHTMLBlocks")(t,r,a),t=y.subParser("hashCodeTags")(t,r,a),t=y.subParser("stripLinkDefinitions")(t,r,a),t=y.subParser("blockGamut")(t,r,a),t=y.subParser("unhashHTMLSpans")(t,r,a),t=(t=(t=y.subParser("unescapeSpecialChars")(t,r,a)).replace(/\xa8D/g,"$$")).replace(/\xa8T/g,"\xa8"),t=y.subParser("completeHTMLDocument")(t,r,a),y.helper.forEach(s,function(e){t=y.subParser("runExtension")(e,t,r,a)}),i=a.metadata,t},this.makeMarkdown=this.makeMd=function(e,t){if(e=(e=(e=e.replace(/\r\n/g,"\n")).replace(/\r/g,"\n")).replace(/>[ \t]+</,">\xa8NBSP;<"),!t){if(!window||!window.document)throw new Error("HTMLParser is undefined. If in a webworker or nodejs environment, you need to provide a WHATWG DOM and HTML such as JSDOM");t=window.document}var a=t.createElement("div");a.innerHTML=e;var n={preList:function c(e){for(var t=e.querySelectorAll("pre"),a=[],n=0;n<t.length;++n)if(1===t[n].childElementCount&&"code"===t[n].firstChild.tagName.toLowerCase()){var r=t[n].firstChild.innerHTML.trim(),i=t[n].firstChild.getAttribute("data-language")||"";if(""===i)for(var o=t[n].firstChild.className.split(" "),s=0;s<o.length;++s){var l=o[s].match(/^language-(.+)$/);if(null!==l){i=l[1];break}}r=y.helper.unescapeHTMLEntities(r),a.push(r),t[n].outerHTML='<precode language="'+i+'" precodenum="'+n.toString()+'"></precode>'}else a.push(t[n].innerHTML),t[n].innerHTML="",t[n].setAttribute("prenum",n.toString());return a}(a)};!function s(e){for(var t=0;t<e.childNodes.length;++t){var a=e.childNodes[t];3===a.nodeType?/\S/.test(a.nodeValue)?(a.nodeValue=a.nodeValue.split("\n").join(" "),a.nodeValue=a.nodeValue.replace(/(\s)+/g,"$1")):(e.removeChild(a),--t):1===a.nodeType&&s(a)}}(a);for(var r=a.childNodes,i="",o=0;o<r.length;o++)i+=y.subParser("makeMarkdown.node")(r[o],n);return i},this.setOption=function(e,t){r[e]=t},this.getOption=function(e){return r[e]},this.getOptions=function(){return r},this.addExtension=function(e,t){c(e,t=t||null)},this.useExtension=function(e){c(e)},this.setFlavor=function(e){if(!h.hasOwnProperty(e))throw Error(e+" flavor was not found");var t=h[e];for(var a in n=e,t)t.hasOwnProperty(a)&&(r[a]=t[a])},this.getFlavor=function(){return n},this.removeExtension=function(e){y.helper.isArray(e)||(e=[e]);for(var t=0;t<e.length;++t){for(var a=e[t],n=0;n<o.length;++n)o[n]===a&&o[n].splice(n,1);for(;0<s.length;++n)s[0]===a&&s[0].splice(n,1)}},this.getAllExtensions=function(){return{language:o,output:s}},this.getMetadata=function(e){return e?i.raw:i.parsed},this.getMetadataFormat=function(){return i.format},this._setMetadataPair=function(e,t){i.parsed[e]=t},this._setMetadataFormat=function(e){i.format=e},this._setMetadataRaw=function(e){i.raw=e}},y.subParser("anchors",function(e,l,c){var d=function d(e,t,a,n,r,i,o){if(y.helper.isUndefined(o)&&(o=""),a=a.toLowerCase(),-1<e.search(/\(<?\s*>? ?(['"].*['"])?\)$/m))n="";else if(!n){if(a||(a=t.toLowerCase().replace(/ ?\n/g," ")),n="#"+a,y.helper.isUndefined(c.gUrls[a]))return e;n=c.gUrls[a],y.helper.isUndefined(c.gTitles[a])||(o=c.gTitles[a])}var s='<a href="'+(n=n.replace(y.helper.regexes.asteriskDashAndColon,y.helper.escapeCharactersCallback))+'"';return""!==o&&null!==o&&(s+=' title="'+(o=(o=o.replace(/"/g,"&quot;")).replace(y.helper.regexes.asteriskDashAndColon,y.helper.escapeCharactersCallback))+'"'),l.openLinksInNewWindow&&!/^#/.test(n)&&(s+=' rel="noopener noreferrer" target="\xa8E95Eblank"'),s+=">"+t+"</a>"};return e=(e=(e=(e=(e=c.converter._dispatch("anchors.before",e,l,c)).replace(/\[((?:\[[^\]]*]|[^\[\]])*)] ?(?:\n *)?\[(.*?)]()()()()/g,d)).replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<([^>]*)>(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g,d)).replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g,d)).replace(/\[([^\[\]]+)]()()()()()/g,d),l.ghMentions&&(e=e.replace(/(^|\s)(\\)?(@([a-z\d]+(?:[a-z\d.-]+?[a-z\d]+)*))/gim,function(e,t,a,n,r){if("\\"===a)return t+n;if(!y.helper.isString(l.ghMentionsLink))throw new Error("ghMentionsLink option must be a string");var i=l.ghMentionsLink.replace(/\{u}/g,r),o="";return l.openLinksInNewWindow&&(o=' rel="noopener noreferrer" target="\xa8E95Eblank"'),t+'<a href="'+i+'"'+o+">"+n+"</a>"})),e=c.converter._dispatch("anchors.after",e,l,c)});var I,O,o=/([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+?\.[^'">\s]+?)()(\1)?(?=\s|$)(?!["<>])/gi,s=/([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+\.[^'">\s]+?)([.!?,()\[\]])?(\1)?(?=\s|$)(?!["<>])/gi,c=/()<(((https?|ftp|dict):\/\/|www\.)[^'">\s]+)()>()/gi,d=/(^|\s)(?:mailto:)?([A-Za-z0-9!#$%&'*+-/=?^_`{|}~.]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)(?=$|\s)/gim,f=/<()(?:mailto:)?([-.\w]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)>/gi,b=function b(p){return function(e,t,a,n,r,i,o){var s=a=a.replace(y.helper.regexes.asteriskDashAndColon,y.helper.escapeCharactersCallback),l="",c="",d=t||"",f=o||"";return/^www\./i.test(a)&&(a=a.replace(/^www\./i,"http://www.")),p.excludeTrailingPunctuationFromURLs&&i&&(l=i),p.openLinksInNewWindow&&(c=' rel="noopener noreferrer" target="\xa8E95Eblank"'),d+'<a href="'+a+'"'+c+">"+s+"</a>"+l+f}},E=function E(r,i){return function(e,t,a){var n="mailto:";return t=t||"",a=y.subParser("unescapeSpecialChars")(a,r,i),r.encodeEmails?(n=y.helper.encodeEmailAddress(n+a),a=y.helper.encodeEmailAddress(a)):n+=a,t+'<a href="'+n+'">'+a+"</a>"}};y.subParser("autoLinks",function(e,t,a){return e=(e=(e=a.converter._dispatch("autoLinks.before",e,t,a)).replace(c,b(t))).replace(f,E(t,a)),e=a.converter._dispatch("autoLinks.after",e,t,a)}),y.subParser("simplifiedAutoLinks",function(e,t,a){return t.simplifiedAutoLink?(e=a.converter._dispatch("simplifiedAutoLinks.before",e,t,a),e=(e=t.excludeTrailingPunctuationFromURLs?e.replace(s,b(t)):e.replace(o,b(t))).replace(d,E(t,a)),e=a.converter._dispatch("simplifiedAutoLinks.after",e,t,a)):e}),y.subParser("blockGamut",function(e,t,a){return e=a.converter._dispatch("blockGamut.before",e,t,a),e=y.subParser("blockQuotes")(e,t,a),e=y.subParser("headers")(e,t,a),e=y.subParser("horizontalRule")(e,t,a),e=y.subParser("lists")(e,t,a),e=y.subParser("codeBlocks")(e,t,a),e=y.subParser("tables")(e,t,a),e=y.subParser("hashHTMLBlocks")(e,t,a),e=y.subParser("paragraphs")(e,t,a),e=a.converter._dispatch("blockGamut.after",e,t,a)}),y.subParser("blockQuotes",function(e,t,a){e=a.converter._dispatch("blockQuotes.before",e,t,a),e+="\n\n";var n=/(^ {0,3}>[ \t]?.+\n(.+\n)*\n*)+/gm;return t.splitAdjacentBlockquotes&&(n=/^ {0,3}>[\s\S]*?(?:\n\n)/gm),e=e.replace(n,function(e){return e=(e=(e=e.replace(/^[ \t]*>[ \t]?/gm,"")).replace(/\xa80/g,"")).replace(/^[ \t]+$/gm,""),e=y.subParser("githubCodeBlocks")(e,t,a),e=(e=(e=y.subParser("blockGamut")(e,t,a)).replace(/(^|\n)/g,"$1  ")).replace(/(\s*<pre>[^\r]+?<\/pre>)/gm,function(e,t){var a=t;return a=(a=a.replace(/^ {2}/gm,"\xa80")).replace(/\xa80/g,"")}),y.subParser("hashBlock")("<blockquote>\n"+e+"\n</blockquote>",t,a)}),e=a.converter._dispatch("blockQuotes.after",e,t,a)}),y.subParser("codeBlocks",function(e,o,s){e=s.converter._dispatch("codeBlocks.before",e,o,s);return e=(e=(e+="\xa80").replace(/(?:\n\n|^)((?:(?:[ ]{4}|\t).*\n+)+)(\n*[ ]{0,3}[^ \t\n]|(?=\xa80))/g,function(e,t,a){var n=t,r=a,i="\n";return n=y.subParser("outdent")(n,o,s),n=y.subParser("encodeCode")(n,o,s),n=(n=(n=y.subParser("detab")(n,o,s)).replace(/^\n+/g,"")).replace(/\n+$/g,""),o.omitExtraWLInCodeBlocks&&(i=""),n="<pre><code>"+n+i+"</code></pre>",y.subParser("hashBlock")(n,o,s)+r})).replace(/\xa80/,""),e=s.converter._dispatch("codeBlocks.after",e,o,s)}),y.subParser("codeSpans",function(e,i,o){return void 0===(e=o.converter._dispatch("codeSpans.before",e,i,o))&&(e=""),e=e.replace(/(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm,function(e,t,a,n){var r=n;return r=(r=r.replace(/^([ \t]*)/g,"")).replace(/[ \t]*$/g,""),r=t+"<code>"+(r=y.subParser("encodeCode")(r,i,o))+"</code>",r=y.subParser("hashHTMLSpans")(r,i,o)}),e=o.converter._dispatch("codeSpans.after",e,i,o)}),y.subParser("completeHTMLDocument",function(e,t,a){if(!t.completeHTMLDocument)return e;e=a.converter._dispatch("completeHTMLDocument.before",e,t,a);var n="html",r="<!DOCTYPE HTML>\n",i="",o='<meta charset="utf-8">\n',s="",l="";for(var c in"undefined"!=typeof a.metadata.parsed.doctype&&(r="<!DOCTYPE "+a.metadata.parsed.doctype+">\n","html"!==(n=a.metadata.parsed.doctype.toString().toLowerCase())&&"html5"!==n||(o='<meta charset="utf-8">')),a.metadata.parsed)if(a.metadata.parsed.hasOwnProperty(c))switch(c.toLowerCase()){case"doctype":break;case"title":i="<title>"+a.metadata.parsed.title+"</title>\n";break;case"charset":o="html"===n||"html5"===n?'<meta charset="'+a.metadata.parsed.charset+'">\n':'<meta name="charset" content="'+a.metadata.parsed.charset+'">\n';break;case"language":case"lang":s=' lang="'+a.metadata.parsed[c]+'"',l+='<meta name="'+c+'" content="'+a.metadata.parsed[c]+'">\n';break;default:l+='<meta name="'+c+'" content="'+a.metadata.parsed[c]+'">\n'}return e=r+"<html"+s+">\n<head>\n"+i+o+l+"</head>\n<body>\n"+e.trim()+"\n</body>\n</html>",e=a.converter._dispatch("completeHTMLDocument.after",e,t,a)}),y.subParser("detab",function(e,t,a){return e=(e=(e=(e=(e=(e=a.converter._dispatch("detab.before",e,t,a)).replace(/\t(?=\t)/g,"    ")).replace(/\t/g,"\xa8A\xa8B")).replace(/\xa8B(.+?)\xa8A/g,function(e,t){for(var a=t,n=4-a.length%4,r=0;r<n;r++)a+=" ";return a})).replace(/\xa8A/g,"    ")).replace(/\xa8B/g,""),e=a.converter._dispatch("detab.after",e,t,a)}),y.subParser("ellipsis",function(e,t,a){return e=(e=a.converter._dispatch("ellipsis.before",e,t,a)).replace(/\.\.\./g,"\u2026"),e=a.converter._dispatch("ellipsis.after",e,t,a)}),y.subParser("emoji",function(e,t,a){if(!t.emoji)return e;return e=(e=a.converter._dispatch("emoji.before",e,t,a)).replace(/:([\S]+?):/g,function(e,t){return y.helper.emojis.hasOwnProperty(t)?y.helper.emojis[t]:e}),e=a.converter._dispatch("emoji.after",e,t,a)}),y.subParser("encodeAmpsAndAngles",function(e,t,a){return e=(e=(e=(e=(e=a.converter._dispatch("encodeAmpsAndAngles.before",e,t,a)).replace(/&(?!#?[xX]?(?:[0-9a-fA-F]+|\w+);)/g,"&amp;")).replace(/<(?![a-z\/?$!])/gi,"&lt;")).replace(/</g,"&lt;")).replace(/>/g,"&gt;"),e=a.converter._dispatch("encodeAmpsAndAngles.after",e,t,a)}),y.subParser("encodeBackslashEscapes",function(e,t,a){return e=(e=(e=a.converter._dispatch("encodeBackslashEscapes.before",e,t,a)).replace(/\\(\\)/g,y.helper.escapeCharactersCallback)).replace(/\\([`*_{}\[\]()>#+.!~=|-])/g,y.helper.escapeCharactersCallback),e=a.converter._dispatch("encodeBackslashEscapes.after",e,t,a)}),y.subParser("encodeCode",function(e,t,a){return e=(e=a.converter._dispatch("encodeCode.before",e,t,a)).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/([*_{}\[\]\\=~-])/g,y.helper.escapeCharactersCallback),e=a.converter._dispatch("encodeCode.after",e,t,a)}),y.subParser("escapeSpecialCharsWithinTagAttributes",function(e,t,a){return e=(e=(e=a.converter._dispatch("escapeSpecialCharsWithinTagAttributes.before",e,t,a)).replace(/<\/?[a-z\d_:-]+(?:[\s]+[\s\S]+?)?>/gi,function(e){return e.replace(/(.)<\/?code>(?=.)/g,"$1`").replace(/([\\`*_~=|])/g,y.helper.escapeCharactersCallback)})).replace(/<!(--(?:(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)>/gi,function(e){return e.replace(/([\\`*_~=|])/g,y.helper.escapeCharactersCallback)}),e=a.converter._dispatch("escapeSpecialCharsWithinTagAttributes.after",e,t,a)}),y.subParser("githubCodeBlocks",function(e,i,o){return i.ghCodeBlocks?(e=o.converter._dispatch("githubCodeBlocks.before",e,i,o),e=(e=(e+="\xa80").replace(/(?:^|\n)(?: {0,3})(```+|~~~+)(?: *)([^\s`~]*)\n([\s\S]*?)\n(?: {0,3})\1/g,function(e,t,a,n){var r=i.omitExtraWLInCodeBlocks?"":"\n";return n=y.subParser("encodeCode")(n,i,o),n="<pre><code"+(a?' class="'+a+" language-"+a+'"':"")+">"+(n=(n=(n=y.subParser("detab")(n,i,o)).replace(/^\n+/g,"")).replace(/\n+$/g,""))+r+"</code></pre>",n=y.subParser("hashBlock")(n,i,o),"\n\n\xa8G"+(o.ghCodeBlocks.push({text:e,codeblock:n})-1)+"G\n\n"})).replace(/\xa80/,""),o.converter._dispatch("githubCodeBlocks.after",e,i,o)):e}),y.subParser("hashBlock",function(e,t,a){return e=(e=a.converter._dispatch("hashBlock.before",e,t,a)).replace(/(^\n+|\n+$)/g,""),e="\n\n\xa8K"+(a.gHtmlBlocks.push(e)-1)+"K\n\n",e=a.converter._dispatch("hashBlock.after",e,t,a)}),y.subParser("hashCodeTags",function(e,i,o){e=o.converter._dispatch("hashCodeTags.before",e,i,o);var s=function s(e,t,a,n){var r=a+y.subParser("encodeCode")(t,i,o)+n;return"\xa8C"+(o.gHtmlSpans.push(r)-1)+"C"};return e=y.helper.replaceRecursiveRegExp(e,s,"<code\\b[^>]*>","</code>","gim"),e=o.converter._dispatch("hashCodeTags.after",e,i,o)}),y.subParser("hashElement",function(e,t,n){return function(e,t){var a=t;return a=(a=(a=a.replace(/\n\n/g,"\n")).replace(/^\n/,"")).replace(/\n+$/g,""),a="\n\n\xa8K"+(n.gHtmlBlocks.push(a)-1)+"K\n\n"}}),y.subParser("hashHTMLBlocks",function(e,t,i){e=i.converter._dispatch("hashHTMLBlocks.before",e,t,i);var a=["pre","div","h1","h2","h3","h4","h5","h6","blockquote","table","dl","ol","ul","script","noscript","form","fieldset","iframe","math","style","section","header","footer","nav","article","aside","address","audio","canvas","figure","hgroup","output","video","p"],o=function o(e,t,a,n){var r=e;return-1!==a.search(/\bmarkdown\b/)&&(r=a+i.converter.makeHtml(t)+n),"\n\n\xa8K"+(i.gHtmlBlocks.push(r)-1)+"K\n\n"};t.backslashEscapesHTMLTags&&(e=e.replace(/\\<(\/?[^>]+?)>/g,function(e,t){return"&lt;"+t+"&gt;"}));for(var n=0;n<a.length;++n)for(var r,s=new RegExp("^ {0,3}(<"+a[n]+"\\b[^>]*>)","im"),l="<"+a[n]+"\\b[^>]*>",c="</"+a[n]+">";-1!==(r=y.helper.regexIndexOf(e,s));){var d=y.helper.splitAtIndex(e,r),f=y.helper.replaceRecursiveRegExp(d[1],o,l,c,"im");if(f===d[1])break;e=d[0].concat(f)}return e=e.replace(/(\n {0,3}(<(hr)\b([^<>])*?\/?>)[ \t]*(?=\n{2,}))/g,y.subParser("hashElement")(e,t,i)),e=(e=y.helper.replaceRecursiveRegExp(e,function(e){return"\n\n\xa8K"+(i.gHtmlBlocks.push(e)-1)+"K\n\n"},"^ {0,3}\x3c!--","--\x3e","gm")).replace(/(?:\n\n)( {0,3}(?:<([?%])[^\r]*?\2>)[ \t]*(?=\n{2,}))/g,y.subParser("hashElement")(e,t,i)),e=i.converter._dispatch("hashHTMLBlocks.after",e,t,i)}),y.subParser("hashHTMLSpans",function(e,t,a){function n(e){return"\xa8C"+(a.gHtmlSpans.push(e)-1)+"C"}return e=(e=(e=(e=(e=a.converter._dispatch("hashHTMLSpans.before",e,t,a)).replace(/<[^>]+?\/>/gi,function(e){return n(e)})).replace(/<([^>]+?)>[\s\S]*?<\/\1>/g,function(e){return n(e)})).replace(/<([^>]+?)\s[^>]+?>[\s\S]*?<\/\1>/g,function(e){return n(e)})).replace(/<[^>]+?>/gi,function(e){return n(e)}),e=a.converter._dispatch("hashHTMLSpans.after",e,t,a)}),y.subParser("unhashHTMLSpans",function(e,t,a){e=a.converter._dispatch("unhashHTMLSpans.before",e,t,a);for(var n=0;n<a.gHtmlSpans.length;++n){for(var r=a.gHtmlSpans[n],i=0;/\xa8C(\d+)C/.test(r);){var o=RegExp.$1;if(r=r.replace("\xa8C"+o+"C",a.gHtmlSpans[o]),10===i)break;++i}e=e.replace("\xa8C"+n+"C",r)}return e=a.converter._dispatch("unhashHTMLSpans.after",e,t,a)}),y.subParser("hashPreCodeTags",function(e,i,o){e=o.converter._dispatch("hashPreCodeTags.before",e,i,o);var s=function s(e,t,a,n){var r=a+y.subParser("encodeCode")(t,i,o)+n;return"\n\n\xa8G"+(o.ghCodeBlocks.push({text:e,codeblock:r})-1)+"G\n\n"};return e=y.helper.replaceRecursiveRegExp(e,s,"^ {0,3}<pre\\b[^>]*>\\s*<code\\b[^>]*>","^ {0,3}</code>\\s*</pre>","gim"),e=o.converter._dispatch("hashPreCodeTags.after",e,i,o)}),y.subParser("headers",function(e,l,c){e=c.converter._dispatch("headers.before",e,l,c);var d=isNaN(parseInt(l.headerLevelStart))?1:parseInt(l.headerLevelStart),t=l.smoothLivePreview?/^(.+)[ \t]*\n={2,}[ \t]*\n+/gm:/^(.+)[ \t]*\n=+[ \t]*\n+/gm,a=l.smoothLivePreview?/^(.+)[ \t]*\n-{2,}[ \t]*\n+/gm:/^(.+)[ \t]*\n-+[ \t]*\n+/gm;e=(e=e.replace(t,function(e,t){var a=y.subParser("spanGamut")(t,l,c),n=l.noHeaderId?"":' id="'+f(t)+'"',r="<h"+d+n+">"+a+"</h"+d+">";return y.subParser("hashBlock")(r,l,c)})).replace(a,function(e,t){var a=y.subParser("spanGamut")(t,l,c),n=l.noHeaderId?"":' id="'+f(t)+'"',r=d+1,i="<h"+r+n+">"+a+"</h"+r+">";return y.subParser("hashBlock")(i,l,c)});var n=l.requireSpaceBeforeHeadingText?/^(#{1,6})[ \t]+(.+?)[ \t]*#*\n+/gm:/^(#{1,6})[ \t]*(.+?)[ \t]*#*\n+/gm;function f(e){var t,a;if(l.customizedHeaderId){var n=e.match(/\{([^{]+?)}\s*$/);n&&n[1]&&(e=n[1])}return t=e,a=y.helper.isString(l.prefixHeaderId)?l.prefixHeaderId:!0===l.prefixHeaderId?"section-":"",l.rawPrefixHeaderId||(t=a+t),t=l.ghCompatibleHeaderId?t.replace(/ /g,"-").replace(/&amp;/g,"").replace(/\xa8T/g,"").replace(/\xa8D/g,"").replace(/[&+$,\/:;=?@"#{}|^\xa8~\[\]`\\*)(%.!'<>]/g,"").toLowerCase():l.rawHeaderId?t.replace(/ /g,"-").replace(/&amp;/g,"&").replace(/\xa8T/g,"\xa8").replace(/\xa8D/g,"$").replace(/["']/g,"-").toLowerCase():t.replace(/[^\w]/g,"").toLowerCase(),l.rawPrefixHeaderId&&(t=a+t),c.hashLinkCounts[t]?t=t+"-"+c.hashLinkCounts[t]++:c.hashLinkCounts[t]=1,t}return e=e.replace(n,function(e,t,a){var n=a;l.customizedHeaderId&&(n=a.replace(/\s?\{([^{]+?)}\s*$/,""));var r=y.subParser("spanGamut")(n,l,c),i=l.noHeaderId?"":' id="'+f(a)+'"',o=d-1+t.length,s="<h"+o+i+">"+r+"</h"+o+">";return y.subParser("hashBlock")(s,l,c)}),e=c.converter._dispatch("headers.after",e,l,c)}),y.subParser("horizontalRule",function(e,t,a){e=a.converter._dispatch("horizontalRule.before",e,t,a);var n=y.subParser("hashBlock")("<hr />",t,a);return e=(e=(e=e.replace(/^ {0,2}( ?-){3,}[ \t]*$/gm,n)).replace(/^ {0,2}( ?\*){3,}[ \t]*$/gm,n)).replace(/^ {0,2}( ?_){3,}[ \t]*$/gm,n),e=a.converter._dispatch("horizontalRule.after",e,t,a)}),y.subParser("images",function(e,t,p){function l(e,t,a,n,r,i,o,s){var l=p.gUrls,c=p.gTitles,d=p.gDimensions;if(a=a.toLowerCase(),s||(s=""),-1<e.search(/\(<?\s*>? ?(['"].*['"])?\)$/m))n="";else if(""===n||null===n){if(""!==a&&null!==a||(a=t.toLowerCase().replace(/ ?\n/g," ")),n="#"+a,y.helper.isUndefined(l[a]))return e;n=l[a],y.helper.isUndefined(c[a])||(s=c[a]),y.helper.isUndefined(d[a])||(r=d[a].width,i=d[a].height)}t=t.replace(/"/g,"&quot;").replace(y.helper.regexes.asteriskDashAndColon,y.helper.escapeCharactersCallback);var f='<img src="'+(n=n.replace(y.helper.regexes.asteriskDashAndColon,y.helper.escapeCharactersCallback))+'" alt="'+t+'"';return s&&y.helper.isString(s)&&(f+=' title="'+(s=s.replace(/"/g,"&quot;").replace(y.helper.regexes.asteriskDashAndColon,y.helper.escapeCharactersCallback))+'"'),r&&i&&(f+=' width="'+(r="*"===r?"auto":r)+'"',f+=' height="'+(i="*"===i?"auto":i)+'"'),f+=" />"}return e=(e=(e=(e=(e=(e=p.converter._dispatch("images.before",e,t,p)).replace(/!\[([^\]]*?)] ?(?:\n *)?\[([\s\S]*?)]()()()()()/g,l)).replace(/!\[([^\]]*?)][ \t]*()\([ \t]?<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g,function c(e,t,a,n,r,i,o,s){return l(e,t,a,n=n.replace(/\s/g,""),r,i,0,s)})).replace(/!\[([^\]]*?)][ \t]*()\([ \t]?<([^>]*)>(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(?:(["'])([^"]*?)\6))?[ \t]?\)/g,l)).replace(/!\[([^\]]*?)][ \t]*()\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g,l)).replace(/!\[([^\[\]]+)]()()()()()/g,l),e=p.converter._dispatch("images.after",e,t,p)}),y.subParser("italicsAndBold",function(e,t,a){function n(e,t,a){return t+e+a}return e=a.converter._dispatch("italicsAndBold.before",e,t,a),e=t.literalMidWordUnderscores?(e=(e=e.replace(/\b___(\S[\s\S]*?)___\b/g,function(e,t){return n(t,"<strong><em>","</em></strong>")})).replace(/\b__(\S[\s\S]*?)__\b/g,function(e,t){return n(t,"<strong>","</strong>")})).replace(/\b_(\S[\s\S]*?)_\b/g,function(e,t){return n(t,"<em>","</em>")}):(e=(e=e.replace(/___(\S[\s\S]*?)___/g,function(e,t){return/\S$/.test(t)?n(t,"<strong><em>","</em></strong>"):e})).replace(/__(\S[\s\S]*?)__/g,function(e,t){return/\S$/.test(t)?n(t,"<strong>","</strong>"):e})).replace(/_([^\s_][\s\S]*?)_/g,function(e,t){return/\S$/.test(t)?n(t,"<em>","</em>"):e}),e=t.literalMidWordAsterisks?(e=(e=e.replace(/([^*]|^)\B\*\*\*(\S[\s\S]*?)\*\*\*\B(?!\*)/g,function(e,t,a){return n(a,t+"<strong><em>","</em></strong>")})).replace(/([^*]|^)\B\*\*(\S[\s\S]*?)\*\*\B(?!\*)/g,function(e,t,a){return n(a,t+"<strong>","</strong>")})).replace(/([^*]|^)\B\*(\S[\s\S]*?)\*\B(?!\*)/g,function(e,t,a){return n(a,t+"<em>","</em>")}):(e=(e=e.replace(/\*\*\*(\S[\s\S]*?)\*\*\*/g,function(e,t){return/\S$/.test(t)?n(t,"<strong><em>","</em></strong>"):e})).replace(/\*\*(\S[\s\S]*?)\*\*/g,function(e,t){return/\S$/.test(t)?n(t,"<strong>","</strong>"):e})).replace(/\*([^\s*][\s\S]*?)\*/g,function(e,t){return/\S$/.test(t)?n(t,"<em>","</em>"):e}),e=a.converter._dispatch("italicsAndBold.after",e,t,a)}),y.subParser("lists",function(e,p,d){function u(e,t){d.gListLevel++,e=e.replace(/\n{2,}$/,"\n");var a=/(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(\xa80| {0,3}([*+-]|\d+[.])[ \t]+))/gm,c=/\n[ \t]*\n(?!\xa80)/.test(e+="\xa80");return p.disableForced4SpacesIndentedSublists&&(a=/(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(\xa80|\2([*+-]|\d+[.])[ \t]+))/gm),e=(e=e.replace(a,function(e,t,a,n,r,i,o){o=o&&""!==o.trim();var s=y.subParser("outdent")(r,p,d),l="";return i&&p.tasklists&&(l=' class="task-list-item" style="list-style-type: none;"',s=s.replace(/^[ \t]*\[(x|X| )?]/m,function(){var e='<input type="checkbox" disabled style="margin: 0px 0.35em 0.25em -1.6em; vertical-align: middle;"';return o&&(e+=" checked"),e+=">"})),s=s.replace(/^([-*+]|\d\.)[ \t]+[\S\n ]*/g,function(e){return"\xa8A"+e}),s="<li"+l+">"+(s=(s=t||-1<s.search(/\n{2,}/)?(s=y.subParser("githubCodeBlocks")(s,p,d),y.subParser("blockGamut")(s,p,d)):(s=(s=y.subParser("lists")(s,p,d)).replace(/\n$/,""),s=(s=y.subParser("hashHTMLBlocks")(s,p,d)).replace(/\n\n+/g,"\n\n"),c?y.subParser("paragraphs")(s,p,d):y.subParser("spanGamut")(s,p,d))).replace("\xa8A",""))+"</li>\n"})).replace(/\xa80/g,""),d.gListLevel--,t&&(e=e.replace(/\s+$/,"")),e}function g(e,t){if("ol"===t){var a=e.match(/^ *(\d+)\./);if(a&&"1"!==a[1])return' start="'+a[1]+'"'}return""}function h(e){return"ul"===e?' style="list-style: disc !important;padding: 0px 0px 0px 40px !important;"':' style="list-style: decimal !important;padding: 0px 0px 0px 40px !important;"'}function r(n,r,i){var o=p.disableForced4SpacesIndentedSublists?/^ ?\d+\.[ \t]/gm:/^ {0,3}\d+\.[ \t]/gm,s=p.disableForced4SpacesIndentedSublists?/^ ?[*+-][ \t]/gm:/^ {0,3}[*+-][ \t]/gm,l="ul"===r?o:s,c="",d=h(r);if(-1!==n.search(l))!function f(e){var t=e.search(l),a=g(n,r);d=h(r),-1!==t?(c+="\n\n<"+r+d+a+">\n"+u(e.slice(0,t),!!i)+"</"+r+">\n",l="ul"===(r="ul"===r?"ol":"ul")?o:s,f(e.slice(t))):c+="\n\n<"+r+d+a+">\n"+u(e,!!i)+"</"+r+">\n"}(n);else{var e=g(n,r);c="\n\n<"+r+d+e+">\n"+u(n,!!i)+"</"+r+">\n"}return c}return e=d.converter._dispatch("lists.before",e,p,d),e+="\xa80",e=(e=d.gListLevel?e.replace(/^(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(\xa80|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm,function(e,t,a){return r(t,-1<a.search(/[*+-]/g)?"ul":"ol",!0)}):e.replace(/(\n\n|^\n?)(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(\xa80|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm,function(e,t,a,n){return r(a,-1<n.search(/[*+-]/g)?"ul":"ol",!1)})).replace(/\xa80/,""),e=d.converter._dispatch("lists.after",e,p,d)}),y.subParser("metadata",function(e,t,n){if(!t.metadata)return e;function r(e){(e=(e=(n.metadata.raw=e).replace(/&/g,"&amp;").replace(/"/g,"&quot;")).replace(/\n {4}/g," ")).replace(/^([\S ]+): +([\s\S]+?)$/gm,function(e,t,a){return n.metadata.parsed[t]=a,""})}return e=(e=(e=(e=n.converter._dispatch("metadata.before",e,t,n)).replace(/^\s*\xab\xab\xab+(\S*?)\n([\s\S]+?)\n\xbb\xbb\xbb+\n/,function(e,t,a){return r(a),"\xa8M"})).replace(/^\s*---+(\S*?)\n([\s\S]+?)\n---+\n/,function(e,t,a){return t&&(n.metadata.format=t),r(a),"\xa8M"})).replace(/\xa8M/g,""),e=n.converter._dispatch("metadata.after",e,t,n)}),y.subParser("outdent",function(e,t,a){return e=(e=(e=a.converter._dispatch("outdent.before",e,t,a)).replace(/^(\t|[ ]{1,4})/gm,"\xa80")).replace(/\xa80/g,""),e=a.converter._dispatch("outdent.after",e,t,a)}),y.subParser("paragraphs",function(e,t,a){for(var n=(e=(e=(e=a.converter._dispatch("paragraphs.before",e,t,a)).replace(/^\n+/g,"")).replace(/\n+$/g,"")).split(/\n{2,}/g),r=[],i=n.length,o=0;o<i;o++){var s=n[o];0<=s.search(/\xa8(K|G)(\d+)\1/g)?r.push(s):0<=s.search(/\S/)&&(s=(s=y.subParser("spanGamut")(s,t,a)).replace(/^([ \t]*)/g,"<p>"),s+="</p>",r.push(s))}for(i=r.length,o=0;o<i;o++){for(var l="",c=r[o],d=!1;/\xa8(K|G)(\d+)\1/.test(c);){var f=RegExp.$1,p=RegExp.$2;l=(l="K"===f?a.gHtmlBlocks[p]:d?y.subParser("encodeCode")(a.ghCodeBlocks[p].text,t,a):a.ghCodeBlocks[p].codeblock).replace(/\$/g,"$$$$"),c=c.replace(/(\n\n)?\xa8(K|G)\d+\2(\n\n)?/,l),/^<pre\b[^>]*>\s*<code\b[^>]*>/.test(c)&&(d=!0)}r[o]=c}return e=(e=(e=r.join("\n")).replace(/^\n+/g,"")).replace(/\n+$/g,""),a.converter._dispatch("paragraphs.after",e,t,a)}),y.subParser("runExtension",function(e,t,a,n){if(e.filter)t=e.filter(t,n.converter,a);else if(e.regex){var r=e.regex;r instanceof RegExp||(r=new RegExp(r,"g")),t=t.replace(r,e.replace)}return t}),y.subParser("spanGamut",function(e,t,a){return e=a.converter._dispatch("spanGamut.before",e,t,a),e=y.subParser("codeSpans")(e,t,a),e=y.subParser("escapeSpecialCharsWithinTagAttributes")(e,t,a),e=y.subParser("encodeBackslashEscapes")(e,t,a),e=y.subParser("images")(e,t,a),e=y.subParser("anchors")(e,t,a),e=y.subParser("autoLinks")(e,t,a),e=y.subParser("simplifiedAutoLinks")(e,t,a),e=y.subParser("emoji")(e,t,a),e=y.subParser("underline")(e,t,a),e=y.subParser("italicsAndBold")(e,t,a),e=y.subParser("strikethrough")(e,t,a),e=y.subParser("ellipsis")(e,t,a),e=y.subParser("hashHTMLSpans")(e,t,a),e=y.subParser("encodeAmpsAndAngles")(e,t,a),t.simpleLineBreaks?/\n\n\xa8K/.test(e)||(e=e.replace(/\n+/g,"<br />\n")):e=e.replace(/  +\n/g,"<br />\n"),e=a.converter._dispatch("spanGamut.after",e,t,a)}),y.subParser("strikethrough",function(e,n,r){return n.strikethrough&&(e=(e=r.converter._dispatch("strikethrough.before",e,n,r)).replace(/(?:~){2}([\s\S]+?)(?:~){2}/g,function(e,t){return function a(e){return n.simplifiedAutoLink&&(e=y.subParser("simplifiedAutoLinks")(e,n,r)),"<del>"+e+"</del>"}(t)}),e=r.converter._dispatch("strikethrough.after",e,n,r)),e}),y.subParser("stripLinkDefinitions",function(e,s,l){var c=function c(e,t,a,n,r,i,o){return t=t.toLowerCase(),a.match(/^data:.+?\/.+?;base64,/)?l.gUrls[t]=a.replace(/\s/g,""):l.gUrls[t]=y.subParser("encodeAmpsAndAngles")(a,s,l),i?i+o:(o&&(l.gTitles[t]=o.replace(/"|'/g,"&quot;")),s.parseImgDimensions&&n&&r&&(l.gDimensions[t]={width:n,height:r}),"")};return e=(e=(e=(e+="\xa80").replace(/^ {0,3}\[(.+)]:[ \t]*\n?[ \t]*<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n\n|(?=\xa80)|(?=\n\[))/gm,c)).replace(/^ {0,3}\[(.+)]:[ \t]*\n?[ \t]*<?([^>\s]+)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n+|(?=\xa80))/gm,c)).replace(/\xa80/,"")}),y.subParser("tables",function(e,v,b){if(!v.tables)return e;function t(e){var t,a=e.split("\n");for(t=0;t<a.length;++t)/^ {0,3}\|/.test(a[t])&&(a[t]=a[t].replace(/^ {0,3}\|/,"")),/\|[ \t]*$/.test(a[t])&&(a[t]=a[t].replace(/\|[ \t]*$/,"")),a[t]=y.subParser("codeSpans")(a[t],v,b);var n,r,i,o,s,l=a[0].split("|").map(function(e){return e.trim()}),c=a[1].split("|").map(function(e){return e.trim()}),d=[],f=[],p=[],u=[];for(a.shift(),a.shift(),t=0;t<a.length;++t)""!==a[t].trim()&&d.push(a[t].split("|").map(function(e){return e.trim()}));if(l.length<c.length)return e;for(t=0;t<c.length;++t)p.push((n=c[t],/^:[ \t]*--*$/.test(n)?' style="text-align:left;"':/^--*[ \t]*:[ \t]*$/.test(n)?' style="text-align:right;"':/^:[ \t]*--*[ \t]*:$/.test(n)?' style="text-align:center;"':""));for(t=0;t<l.length;++t)y.helper.isUndefined(p[t])&&(p[t]=""),f.push((r=l[t],i=p[t],o=void 0,o="",r=r.trim(),(v.tablesHeaderId||v.tableHeaderId)&&(o=' id="'+r.replace(/ /g,"_").toLowerCase()+'"'),"<th"+o+i+">"+(r=y.subParser("spanGamut")(r,v,b))+"</th>\n"));for(t=0;t<d.length;++t){for(var g=[],h=0;h<f.length;++h)y.helper.isUndefined(d[t][h]),g.push((s=d[t][h],"<td"+p[h]+">"+y.subParser("spanGamut")(s,v,b)+"</td>\n"));u.push(g)}return function m(e,t){for(var a="<table>\n<thead>\n<tr>\n",n=e.length,r=0;r<n;++r)a+=e[r];for(a+="</tr>\n</thead>\n<tbody>\n",r=0;r<t.length;++r){a+="<tr>\n";for(var i=0;i<n;++i)a+=t[r][i];a+="</tr>\n"}return a+="</tbody>\n</table>\n"}(f,u)}return e=(e=(e=(e=b.converter._dispatch("tables.before",e,v,b)).replace(/\\(\|)/g,y.helper.escapeCharactersCallback)).replace(/^ {0,3}\|?.+\|.+\n {0,3}\|?[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*:?[ \t]*(?:[-=]){2,}[\s\S]+?(?:\n\n|\xa80)/gm,t)).replace(/^ {0,3}\|.+\|[ \t]*\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n( {0,3}\|.+\|[ \t]*\n)*(?:\n|\xa80)/gm,t),e=b.converter._dispatch("tables.after",e,v,b)}),y.subParser("underline",function(e,t,a){return t.underline?(e=a.converter._dispatch("underline.before",e,t,a),e=(e=t.literalMidWordUnderscores?(e=e.replace(/\b___(\S[\s\S]*?)___\b/g,function(e,t){return"<u>"+t+"</u>"})).replace(/\b__(\S[\s\S]*?)__\b/g,function(e,t){return"<u>"+t+"</u>"}):(e=e.replace(/___(\S[\s\S]*?)___/g,function(e,t){return/\S$/.test(t)?"<u>"+t+"</u>":e})).replace(/__(\S[\s\S]*?)__/g,function(e,t){return/\S$/.test(t)?"<u>"+t+"</u>":e})).replace(/(_)/g,y.helper.escapeCharactersCallback),e=a.converter._dispatch("underline.after",e,t,a)):e}),y.subParser("unescapeSpecialChars",function(e,t,a){return e=(e=a.converter._dispatch("unescapeSpecialChars.before",e,t,a)).replace(/\xa8E(\d+)E/g,function(e,t){var a=parseInt(t);return String.fromCharCode(a)}),e=a.converter._dispatch("unescapeSpecialChars.after",e,t,a)}),y.subParser("makeMarkdown.blockquote",function(e,t){var a="";if(e.hasChildNodes())for(var n=e.childNodes,r=n.length,i=0;i<r;++i){var o=y.subParser("makeMarkdown.node")(n[i],t);""!==o&&(a+=o)}return a="> "+(a=a.trim()).split("\n").join("\n> ")}),y.subParser("makeMarkdown.codeBlock",function(e,t){var a=e.getAttribute("language"),n=e.getAttribute("precodenum");return"```"+a+"\n"+t.preList[n]+"\n```"}),y.subParser("makeMarkdown.codeSpan",function(e){return"`"+e.innerHTML+"`"}),y.subParser("makeMarkdown.emphasis",function(e,t){var a="";if(e.hasChildNodes()){a+="*";for(var n=e.childNodes,r=n.length,i=0;i<r;++i)a+=y.subParser("makeMarkdown.node")(n[i],t);a+="*"}return a}),y.subParser("makeMarkdown.header",function(e,t,a){var n=new Array(a+1).join("#"),r="";if(e.hasChildNodes()){r=n+" ";for(var i=e.childNodes,o=i.length,s=0;s<o;++s)r+=y.subParser("makeMarkdown.node")(i[s],t)}return r}),y.subParser("makeMarkdown.hr",function(){return"---"}),y.subParser("makeMarkdown.image",function(e){var t="";return e.hasAttribute("src")&&(t+="!["+e.getAttribute("alt")+"](",t+="<"+e.getAttribute("src")+">",e.hasAttribute("width")&&e.hasAttribute("height")&&(t+=" ="+e.getAttribute("width")+"x"+e.getAttribute("height")),e.hasAttribute("title")&&(t+=' "'+e.getAttribute("title")+'"'),t+=")"),t}),y.subParser("makeMarkdown.links",function(e,t){var a="";if(e.hasChildNodes()&&e.hasAttribute("href")){var n=e.childNodes,r=n.length;a="[";for(var i=0;i<r;++i)a+=y.subParser("makeMarkdown.node")(n[i],t);a+="](",a+="<"+e.getAttribute("href")+">",e.hasAttribute("title")&&(a+=' "'+e.getAttribute("title")+'"'),a+=")"}return a}),y.subParser("makeMarkdown.list",function(e,t,a){var n="";if(!e.hasChildNodes())return"";for(var r=e.childNodes,i=r.length,o=e.getAttribute("start")||1,s=0;s<i;++s)if("undefined"!=typeof r[s].tagName&&"li"===r[s].tagName.toLowerCase()){n+=("ol"===a?o.toString()+". ":"- ")+y.subParser("makeMarkdown.listItem")(r[s],t),++o}return(n+="\n\x3c!-- --\x3e\n").trim()}),y.subParser("makeMarkdown.listItem",function(e,t){for(var a="",n=e.childNodes,r=n.length,i=0;i<r;++i)a+=y.subParser("makeMarkdown.node")(n[i],t);return/\n$/.test(a)?a=a.split("\n").join("\n    ").replace(/^ {4}$/gm,"").replace(/\n\n+/g,"\n\n"):a+="\n",a}),y.subParser("makeMarkdown.node",function(e,t,a){a=a||!1;var n="";if(3===e.nodeType)return y.subParser("makeMarkdown.txt")(e,t);if(8===e.nodeType)return"\x3c!--"+e.data+"--\x3e\n\n";if(1!==e.nodeType)return"";switch(e.tagName.toLowerCase()){case"h1":a||(n=y.subParser("makeMarkdown.header")(e,t,1)+"\n\n");break;case"h2":a||(n=y.subParser("makeMarkdown.header")(e,t,2)+"\n\n");break;case"h3":a||(n=y.subParser("makeMarkdown.header")(e,t,3)+"\n\n");break;case"h4":a||(n=y.subParser("makeMarkdown.header")(e,t,4)+"\n\n");break;case"h5":a||(n=y.subParser("makeMarkdown.header")(e,t,5)+"\n\n");break;case"h6":a||(n=y.subParser("makeMarkdown.header")(e,t,6)+"\n\n");break;case"p":a||(n=y.subParser("makeMarkdown.paragraph")(e,t)+"\n\n");break;case"blockquote":a||(n=y.subParser("makeMarkdown.blockquote")(e,t)+"\n\n");break;case"hr":a||(n=y.subParser("makeMarkdown.hr")(e,t)+"\n\n");break;case"ol":a||(n=y.subParser("makeMarkdown.list")(e,t,"ol")+"\n\n");break;case"ul":a||(n=y.subParser("makeMarkdown.list")(e,t,"ul")+"\n\n");break;case"precode":a||(n=y.subParser("makeMarkdown.codeBlock")(e,t)+"\n\n");break;case"pre":a||(n=y.subParser("makeMarkdown.pre")(e,t)+"\n\n");break;case"table":a||(n=y.subParser("makeMarkdown.table")(e,t)+"\n\n");break;case"code":n=y.subParser("makeMarkdown.codeSpan")(e,t);break;case"em":case"i":n=y.subParser("makeMarkdown.emphasis")(e,t);break;case"strong":case"b":n=y.subParser("makeMarkdown.strong")(e,t);break;case"del":n=y.subParser("makeMarkdown.strikethrough")(e,t);break;case"a":n=y.subParser("makeMarkdown.links")(e,t);break;case"img":n=y.subParser("makeMarkdown.image")(e,t);break;default:n=e.outerHTML+"\n\n"}return n}),y.subParser("makeMarkdown.paragraph",function(e,t){var a="";if(e.hasChildNodes())for(var n=e.childNodes,r=n.length,i=0;i<r;++i)a+=y.subParser("makeMarkdown.node")(n[i],t);return a=a.trim()}),y.subParser("makeMarkdown.pre",function(e,t){var a=e.getAttribute("prenum");return"<pre>"+t.preList[a]+"</pre>"}),y.subParser("makeMarkdown.strikethrough",function(e,t){var a="";if(e.hasChildNodes()){a+="~~";for(var n=e.childNodes,r=n.length,i=0;i<r;++i)a+=y.subParser("makeMarkdown.node")(n[i],t);a+="~~"}return a}),y.subParser("makeMarkdown.strong",function(e,t){var a="";if(e.hasChildNodes()){a+="**";for(var n=e.childNodes,r=n.length,i=0;i<r;++i)a+=y.subParser("makeMarkdown.node")(n[i],t);a+="**"}return a}),y.subParser("makeMarkdown.table",function(e,t){var a,n,r="",i=[[],[]],o=e.querySelectorAll("thead>tr>th"),s=e.querySelectorAll("tbody>tr");for(a=0;a<o.length;++a){var l=y.subParser("makeMarkdown.tableCell")(o[a],t),c="---";if(o[a].hasAttribute("style"))switch(o[a].getAttribute("style").toLowerCase().replace(/\s/g,"")){case"text-align:left;":c=":---";break;case"text-align:right;":c="---:";break;case"text-align:center;":c=":---:"}i[0][a]=l.trim(),i[1][a]=c}for(a=0;a<s.length;++a){var d=i.push([])-1,f=s[a].getElementsByTagName("td");for(n=0;n<o.length;++n){var p=" ";"undefined"!=typeof f[n]&&(p=y.subParser("makeMarkdown.tableCell")(f[n],t)),i[d].push(p)}}var u=3;for(a=0;a<i.length;++a)for(n=0;n<i[a].length;++n){var g=i[a][n].length;u<g&&(u=g)}for(a=0;a<i.length;++a){for(n=0;n<i[a].length;++n)1===a?":"===i[a][n].slice(-1)?i[a][n]=y.helper.padEnd(i[a][n].slice(-1),u-1,"-")+":":i[a][n]=y.helper.padEnd(i[a][n],u,"-"):i[a][n]=y.helper.padEnd(i[a][n],u);r+="| "+i[a].join(" | ")+" |\n"}return r.trim()}),y.subParser("makeMarkdown.tableCell",function(e,t){var a="";if(!e.hasChildNodes())return"";for(var n=e.childNodes,r=n.length,i=0;i<r;++i)a+=y.subParser("makeMarkdown.node")(n[i],t,!0);return a.trim()}),y.subParser("makeMarkdown.txt",function(e){var t=e.nodeValue;return t=(t=t.replace(/ +/g," ")).replace(/\xa8NBSP;/g," "),t=(t=(t=(t=(t=(t=(t=(t=(t=y.helper.unescapeHTMLEntities(t)).replace(/([*_~|`])/g,"\\$1")).replace(/^(\s*)>/g,"\\$1>")).replace(/^#/gm,"\\#")).replace(/^(\s*)([-=]{3,})(\s*)$/,"$1\\$2$3")).replace(/^( {0,3}\d+)\./gm,"$1\\.")).replace(/^( {0,3})([+-])/gm,"$1\\$2")).replace(/]([\s]*)\(/g,"\\]$1\\(")).replace(/^ {0,3}\[([\S \t]*?)]:/gm,"\\[$1]:")}),St.PLUGINS.markdown=function(o){var s,l,a,n,r,c=o.$,i=!1,d="",f="",p="",u="",g=[],h=[],m="",v=null,b=null;function E(e){e=function u(e){var t=e,a=e.match(/(\[\^(.+?)\])[^:]/g),n=e.match(/(\[\^(.+?)\]:)/g);if(a&&n){a.forEach(function(e,t,a){a[t]=a[t].substring(0,a[t].length-1)}),a=a.filter(function(e,t){return a.indexOf(e)===t}),n=n.filter(function(e,t){return n.indexOf(e)===t});for(var r=1,i=0;i<a.length;i++){var o="";if(1==r&&(o='<hr class="footnote-sep"><ol>'),-1<n.indexOf(a[i]+":")){for(var s=-1<(t=(t=t.split(n[i]).join("{ftnt-plc}")).replace(n[i].substring(0,n[i].length-1),'<sup id="fnref:'.concat(r,'"><a href="#fn:').concat(r,'" class="footnote-a">').concat(r,"</a></sup>"))).indexOf(a[i])?1:0,l=0;s&&(l++,t=t.replace(n[i].substring(0,n[i].length-1),'<sup id="fnref:'.concat(r,":").concat(l,'"><a href="#fn:').concat(r,":").concat(l,'" class="footnote-a">').concat(r,":").concat(l,"</a></sup>")),s=-1<t.indexOf(a[i])?1:0););var c=(t=t.split("{ftnt-plc}").join(n[i])).indexOf(n[i]),d=t,f=d.substring(c,d.length-1);if(f=f.split("\n")[0],t=t.replace(f,""),-1<f.indexOf(": ")){f=f.split(": ")[1],f+='<a href="#fnref:'.concat(r,'" class="footnote-a">\u21a9</a>');for(var p=l;0!=l;)f+='<a href="#fnref:'.concat(r,":").concat(p-l+1,'" class="footnote-a">\u21a9</a>'),l--;f+="</p></li>",t=t+o+'<li id="fn:'.concat(r,'"><p>')+f,r++}}}1!=r&&(t+="</ol>")}return e=t}(e=function s(e){for(var t=/^[A-Za-z0-9]/g,a=/^:[ ]{1}(.+?)+/g,n=e.split("\n"),r=n,i=n.length-1,o=1;o<i;o++)null!==n[o].match(a)&&(null!==n[o-1].match(t)&&o<i-1&&null!==n[o+1].match(a)?(r[o-1]="<dl><dt>"+n[o-1]+"</dt>",r[o]="<dd>"+n[o].substring(2)+"</dd>"):null!==n[o-1].match(t)&&(o<i-1&&null===n[o+1].match(a)||o==i-1)?(r[o-1]="<dl><dt>"+n[o-1]+"</dt>",r[o]="<dd>"+n[o].substring(2)+"</dd></dl>"):o<i-1&&null!==n[o+1].match(a)?r[o]="<dd>"+n[o].substring(2)+"</dd>":r[o]="<dd>"+n[o].substring(2)+"</dd></dl>");return e=r.join("\n")}(e=function t(e){var n=e.indexOf("```"),r=0;-1<n&&(r=-1<(r=e.substring(n+1).indexOf("```"))?r+3:r);return e=e.replace(/^ {0,2}( ?-){3,}[ \t]*$/gm,function(e,t,a){return n<a&&a<r?"---":"<hr />\n"})}(e=function a(e){return-1<(e=(e=(e=(e=(e=(e=(e=(e=(e=(e=e.split("</p>").join("</p>\n")).split("</div>").join("\n")).replace(/(<([^>]+)>)/gi,"")).replace(/&gt;/gi,">")).replace(/&lt;/gi,"<")).split("&quot;").join('"')).split("&amp;").join("&")).split("&#39;").join("'")).split("&nbsp;").join(" ")).replace(/\|+\n[^\|]/g,function(e){return e.replace("\n","\n\n")})).indexOf("Powered by Froala Editor")&&(e=e.replace("Powered by Froala Editor","")),e}(e)))),e=n.makeHtml(e),e=o.clean.html(e),o.$wp.find(l)[0].innerHTML=e}return{_init:function t(){if(function e(){o.events.on("contentChanged",function(){i&&E(o.html.get(!1,!1))},!0),o.events.$on(c(o.o_win),"resize",function(){i&&(l[0].style.width=o.$wp[0].clientWidth-o.$el[0].clientWidth+2+"px")}),o.events.on("paste.afterCleanup",function(e){if(i){var t=o.doc.createElement("div");t.innerHTML=e;for(var a,n=t.querySelectorAll("img"),r=0;r<n.length;r++)(a=n[r]).outerHTML=a.outerHTML.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#039;");e=t.innerHTML}return e})}(),n=new y.Converter({strikethrough:!0,tables:!0,tablesHeaderId:!0,simpleLineBreaks:!0,ghCodeBlocks:!0,tasklists:!0,customizedHeaderId:!0,requireSpaceBeforeHeadingText:!0,underline:!0}),o.$tb&&(a=o.$tb.find('.fr-command[data-cmd="markdown"]')),!o.$wp)return!1},refresh:function _(e){var t=i;e.toggleClass("fr-active",t).attr("aria-pressed",t)},toggle:function w(){i?function e(){f=o.html.get(!0,!0),o.opts.pastePlain=!1,o.$el.removeClass("fr-markdown-editor"),o.$wp.append(r[0].firstChild),c(r).remove(),o.$wp.find(s).remove(),o.$wp.find(l).remove(),o.$wp[0].lastChild.after(o.$placeholder[0]),o.$el.removeAttr("style"),o.size.refresh(),o.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").not(a).removeClass("fr-disabled").attr("aria-disabled",!1),o.opts.iframe&&(o.$el=b,o.$wp=v,Object.keys(h).map(function(e){o.$el[0].setAttribute(e,h[e]),"class"!=e&&m[0].removeAttribute(e)}),o.$el[0].style.removeProperty("padding")),o.html.set(d),o.opts.iframe&&(o.$el=b,o.$wp=v,o.$placeholder=null,o.placeholder.show(),o.placeholder.refresh())}():function t(){var i;d=o.html.get(!0,!0),o.html.set(f),o.opts.pastePlain=!0,o.opts.iframe?(o.$el[0].removeAttribute("spellcheck"),Array.from(o.$el[0].attributes).map(function(e){var t=e.name,a=e.value;return"class"!=t&&(g[t]=a),h[t]=a,o.$el[0].removeAttribute(t)}),o.$el[0].style.padding=0,o.$el[0].innerHTML="",o.$placeholder.hide()):o.$el.addClass("fr-markdown-editor"),r=c('<div class="fr-wrapper-markdown" />'),o.opts.heightMin?r.css("min-height","".concat(o.opts.heightMin,"px")):r.css("min-height","200px"),o.opts.heightMax?(r.css("maxHeight","".concat(o.opts.heightMax,"px")),r.css("overflow","auto")):(r.css("maxHeight",""),r.css("overflow","")),o.opts.height&&(r.css("height","".concat(o.opts.height,"px")),r.css("overflow","auto"),r.css("minHeight",o.opts.height-o.helpers.getPX(o.$el.css("padding-top"))-o.helpers.getPX(o.$el.css("padding-bottom")))),o.opts.iframe?(u=c('<div class="fr-box fr-basic fr-top"></div>'),p=c('<div class="fr-markdown-wrapper"></div>'),m=c('<div class="fr-element fr-markdown-editor"><p><br></p></div>'),Object.keys(g).map(function(e){return m[0].setAttribute(e,g[e])}),f&&(m[0].innerHTML=f),r[0].appendChild(m[0]),p[0].appendChild(r[0]),u[0].appendChild(p[0]),1==c(o.$html.find("body")[0]).find(".fr-box").length?(o.$el.prevAll().filter(function(e){return!["CodeMirror cm-s-default CodeMirror-wrap","fr-code"].includes(e.className)}).remove(),o.$el[0].appendChild(r[0])):(o.$el[0].appendChild(u[0]),v=o.$wp,o.$wp=p),b=o.$el,o.$el=m):(o.$wp.append(r),r[0].appendChild(o.$el[0])),s=c('<div class="gutter-horizontal"><div class="e-resize-handler"><i class="fa fa-circle-thin" aria-hidden="true"></i></div></div>'),c(r).append(s[0]),l=c('<div class="fr-element fr-markdown-view"></div>'),c(r).append(l[0]),c(r).after(o.$placeholder[0]),o.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").not(a).filter(function(){return"fullscreen"!==c(this).data("cmd")&&"moreMisc"!==c(this).data("cmd")}).addClass("fr-disabled").attr("aria-disabled",!0),c(s).on("mousedown touchstart",function(e){i={e:e,offsetLeft:s[0].offsetLeft,offsetTop:s[0].offsetTop,firstWidth:o.$el[0].offsetWidth,secondWidth:l[0].offsetWidth};var a=function a(e){o.selection.clear();var t={x:e.clientX-i.e.clientX,y:e.clientY-i.e.clientY};t.x=Math.min(Math.max(t.x,-i.firstWidth),i.secondWidth),i.firstWidth+t.x<125||i.secondWidth-t.x<125||(s[0].style.left=i.offsetLeft+t.x+"px",o.$el[0].style.width=i.firstWidth+t.x+"px",l[0].style.width=i.secondWidth-t.x+"px")},n=function n(e){o.selection.clear();var t={x:e.changedTouches[0].clientX-i.e.changedTouches[0].clientX,y:e.changedTouches[0].clientY-i.e.changedTouches[0].clientY};t.x=Math.min(Math.max(t.x,-i.firstWidth),i.secondWidth),i.firstWidth+t.x<100||i.secondWidth-t.x<100||(s[0].style.left=i.offsetLeft+t.x+"px",o.$el[0].style.width=i.firstWidth+t.x+"px",l[0].style.width=i.secondWidth-t.x+"px")},t=function t(){document.onmousemove=document.onmouseup=null,document.ontouchmove=document.ontouchend=null},r=function r(){o.$doc[0].onmousemove=o.$doc[0].onmouseup=null,o.$doc[0].ontouchmove=o.$doc[0].ontouchend=null};o.opts.iframe&&o.markdown.isEnabled?(o.$doc[0].onmousemove=a,o.$doc[0].ontouchmove=n,o.$doc[0].onmouseup=r,o.$doc[0].ontouchend=r):(document.onmousemove=a,document.ontouchmove=n,document.onmouseup=t,document.ontouchend=t)}),E(f)}(),i=!i},isEnabled:function e(){return i}}},St.DefineIcon("markdown",{NAME:"markdown",SVG_KEY:"markdown"}),St.RegisterCommand("markdown",{title:"Markdown",undo:!1,focus:!1,toggle:!0,forcedRefresh:!0,accessibilityFocus:!0,callback:function(){this.markdown.toggle()},refresh:function(e){this.markdown.refresh(e)},plugin:"markdown"}),Object.assign(St.DEFAULTS,{wordCounterMax:-1,wordCounterCount:!0}),St.PLUGINS.wordCounter=function(p){var a,t=p.$;function u(){var e=p.el.innerText.toString();e=(e=(e=(e=(e=(e=(e=(e=e.replace(/(^\s*)|(\s*$)/gi," ")).replace(/\u00a0/g," ")).replace(/[ ]{2,}/gi," ")).replace(/\n /,"\n")).replace(/[\u200A\u200C-\u200D\uFEFF\u202F\u2000-\u2009\u205F\u3000\u1680\u00A0\u0020]/g," ")).replace(/[\u200B]/g,"")).replace(/\t+/g," ")).split(" ").join("\n");var t=p.$el.find(".fr-pagebreak"),a=e.split(/\r?\n/),n=0;return a.forEach(function(e){0<(e=e.replace(/\s/g,"")).length&&n++}),n-2*t.length}function e(e){var t=!1;if(p.opts.wordCounterMax<0)return!0;if(u()<p.opts.wordCounterMax)return!0;var a=e.which,n=p.selection.get(),r=n.focusOffset,i=n.focusNode.textContent,o=(i=i.replace(/\u00a0/g," ")).toUpperCase().charCodeAt(r-1),s=i.toUpperCase().charCodeAt(r);return n.focusNode.data||(o=s=NaN),!function l(e,t){if(p.keys.isCharacter(e)&&p.keys.isCharacter(t)&&e!=St.KEYCODE.SPACE&&t!=St.KEYCODE.SPACE)return!0;return!1}(o,s)||a!==St.KEYCODE.ENTER&&a!==St.KEYCODE.SPACE||(t=!0),(function c(e,t){return e===St.KEYCODE.SPACE&&t===St.KEYCODE.SPACE}(o,s)||function d(e,t){if(isNaN(e)&&t===St.KEYCODE.SPACE||e===St.KEYCODE.SPACE&&isNaN(t))return!0;return!1}(o,s)||function f(e,t){if(isNaN(e)&&isNaN(t))return!0;return!1}(o,s))&&p.keys.isCharacter(a)&&a!=St.KEYCODE.SPACE&&(t=!0),u()>p.opts.wordCounterMax&&(p.keys.isCharacter(a)||a===St.KEYCODE.ENTER)&&(t=!0),!(!p.keys.ctrlKey(e)&&t||a===St.KEYCODE.IME)||(e.preventDefault(),e.stopPropagation(),p.events.trigger("wordCounter.exceeded"),!1)}function n(){if(p.opts.wordCounterCount){var e=u()+(0<p.opts.wordCounterMax?"/"+p.opts.wordCounterMax:"");a.text("".concat(p.language.translate("Words")," : ").concat(e)),p.opts.toolbarBottom&&a.css("margin-bottom",p.$tb.outerHeight(!0));var t=p.$wp.get(0).offsetWidth-p.$wp.get(0).clientWidth;0<=t&&("rtl"==p.opts.direction?a.css("margin-left",t):a.css("margin-right",t))}}function r(e){return p.opts.wordCounterMax<0?e:t("<div>").html(e).text().split(" ").length+u()<=p.opts.wordCounterMax?e:(p.events.trigger("wordCounter.exceeded"),"")}return{_init:function i(){return!!p.$wp&&!!p.opts.wordCounterCount&&((a=t(document.createElement("span")).attr("class","fr-counter fr-wCounter")).css("bottom",p.$wp.css("border-bottom-width")),p.$second_tb?p.$second_tb.append(a):p.$wp.append(a),p.events.on("keydown",e,!0),p.events.on("paste.afterCleanup",r),p.events.on("keyup contentChanged input",function(){p.events.trigger("wordCounter.update")}),p.events.on("wordCounter.update",n),p.events.trigger("wordCounter.update"),void p.events.on("destroy",function(){t(p.o_win).off("resize.char".concat(p.id)),a.removeData().remove(),a=null}))},wordCount:u}},Object.assign(St.POPUP_TEMPLATES,{"filestackPlugin.error":"[_UPLOAD_LAYER_]"}),St.FILESTACK_PICKER_OPTIONS_MEDIA_MAX_SUPPORTED=[".pdf",".docx",".ppt",".pptx",".doc",".xlsx",".xls",".csv",".txt","image/jpeg","image/png","image/jpg","image/gif","image/webp","video/*","audio/*","mp3"],St.REQUIRED_PLUGINS=["image","video","file","filesManager"],St.FILESTACK_PICKER_OPTIONS_IMAGE_ONLY_SUPPORTED=["image/jpeg","image/png","image/jpg","image/gif","image/webp"],St.FILESTACK_DEFAULT_ACCEPT_FILE_TYPES=[".pdf",".docx",".ppt",".pptx",".doc",".xlsx",".xls",".csv",".txt"],St.FILESTACK_PICKER_OPTIONS_VIDEO_ONLY_SUPPORTED=["video/*"],St.FILESTACK_PICKER_OPTIONS_FROMSOURCES_MAX_SUPPORTED=["local_file_system","imagesearch","url","googledrive","facebook","instagram","dropbox"],St.FILESTACK_PICKER_DEFAULT_OPTIONS={displayMode:"overlay",uploadInBackground:!1,stage:{cname:"stage.filestackapi.com"}},Object.assign(St.DEFAULTS,{filestackOptions:{}}),St.FILE_STACK_URL_PART="filestack",St.PLUGINS.filestack=function(f){var r,p,t=["pdf","msword","vnd.openxmlformats-officedocument.wordprocessingml.document","vnd.ms-excel","vnd.openxmlformats-officedocument.spreadsheetml.sheet","vnd.ms-powerpoint","vnd.openxmlformats-officedocument.presentationml.presentation","csv","plain","ogg"],u=1,o=4,g=5,h=6,s=7,l={};function m(e,t,a){v(a?f.language.translate(l[e])+"\nResponse: "+JSON.stringify(a):f.language.translate(l[e]),t)}function v(e,t,a,n){var r;if((r=f.popups.get("filestackPlugin.error"))||(r=d(e)),a&&(r.find(".fr-image-progress-bar-layer").addClass("fr-active"),r.find(".fr-error-message").addClass("fr-layer"),r.find(".fr-buttons").hide()),!!f.$tb){var i;"openFilePicker"===t?i="openFilePicker":"openFilePickerReplaceImageOnly"===t||"openFilePickerImage"===t?i="insertImage":"openFilePickerReplaceVideoOnly"===t||"openFilePickerVideo"===t?i="insertVideo":"openFilePickerVideoOnly"===t?i="openFilePickerVideoOnly":"openFilePickerImageOnly"===t?i="openFilePickerImageOnly":"openFilePickerFile"===t&&(i="openFilePickerFile");var o=f.$tb.find(".fr-command[data-cmd='".concat(i,"']"));if(a)f.popups.show("filestackPlugin.error",n.x,n.y);else if(!r.hasClass("fr-active")&&(f.popups.refresh("filestackPlugin.error"),f.popups.setContainer("filestackPlugin.error",f.$tb),o.isVisible()||f.opts.toolbarInline)){var s=f.opts.toolbarInline&&["openFilePickerImage","openFilePickerVideo"].includes(t)?f.$(".fr-popup")[0].style:f.button.getPosition(o),l=s.left,c=s.top;f.popups.show("filestackPlugin.error",l,c,o.outerHeight())}}}function b(){var e="",t=function a(){var t=[];return St.REQUIRED_PLUGINS.forEach(function(e){f.opts.pluginsEnabled.indexOf(e)<0&&t.push(e.charAt(0).toUpperCase()+e.slice(1))}),t}();return e=t.join(", "),1<t.length?e+=" plugin are":e+=" plugin is",e}function d(e){var t=e.includes("Do you want to enable"),a=t?"<div style='text-align:right;' class='fr-buttons'>\n          <button class='fr-trim-button fr-plugins-enable'>".concat(f.language.translate("Enable"),"</button>               \n          <button class='fr-trim-button fr-plugins-cancel'>").concat(f.language.translate("Cancel"),"</button>\n        </div>"):"<div style='text-align:right;' class='fr-buttons'>\n          <button class='fr-trim-button fr-plugins-ok'>".concat(f.language.translate("OK"),"</button>               \n        </div>"),n={upload_layer:"".concat('<div class="fr-image-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader fr-indeterminate"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="imageDismissError" tabIndex="2" role="button">OK</button></div></div>',"\n      <div style= 'padding:10px'>\n      <div class = 'fr-message fr-error-message'><h3 style ='font-size: 16px; margin: 10px 10px;font-weight: normal;'>").concat(f.language.translate(e),"</h3></div>\n      ").concat(a,"\n    ")},r=f.popups.create("filestackPlugin.error",n);if(t){var i=r.find(".fr-plugins-enable")[0],o=r.find(".fr-plugins-cancel")[0];i.addEventListener("click",function(e){!function t(){St.REQUIRED_PLUGINS.forEach(function(e){f.opts.pluginsEnabled.indexOf(e)<0&&f.opts.pluginsEnabled.push(e)})}(),function a(e){for(var t in e)if(!f[t]){if(St.PLUGINS[t]&&f.opts.pluginsEnabled.indexOf(t)<0)continue;f[t]=new e[t](f),f[t]._init&&f[t]._init()}}(St.PLUGINS),R(),f.events.trigger("filestack.pluginsEnabled"),f.popups.hide("filestackPlugin.error"),y(),e.preventDefault()}),o.addEventListener("click",function(e){f.popups.hide("filestackPlugin.error"),y(),e.preventDefault()})}else{var s=r.find(".fr-plugins-ok")[0];s&&s.addEventListener("click",function(e){f.popups.hide("filestackPlugin.error"),e.preventDefault()})}return r}function E(){var t=!0;return St.REQUIRED_PLUGINS.forEach(function(e){f.opts.pluginsEnabled.indexOf(e)<0&&(t=!1)}),t}l[u]="Filestack api is missing",l[2]="The Filestack options are missing. Please check filestackOptions",l[3]="The Filestack picker is missing. Please check filestackOption",l[o]="Image upload to filestack failed while processing the request",l[g]="Filestack plugin is currently not supported on this browser",l[h]="The selected media types are not supported",l[s]="The selected source types are not supported by Filestack",l[8]="Error opening Filestack picker due to invalid picker parameters",l[9]="This image is not supported for image transformation",l[10]="The Filestack client is not created yet";var _=f.opts.filestackOptions.filestackAPI;if(_)try{p=f.opts.filestackOptions.staging?filestack.init(_,St.FILESTACK_PICKER_DEFAULT_OPTIONS.stage):filestack.init(_,St.FILESTACK_PICKER_DEFAULT_OPTIONS)}catch(L){0===!Object.keys(f.opts.filestackOptions).length&&m(10)}else;function w(){var e=navigator.userAgent,t=f||"",a=t.helpers,n=t.browser;if(a.isMac()&&n.mozilla)return!1;var r=-1!=e.indexOf("Windows NT 10.")||-1!=e.indexOf("Windows NT 7."),i=e.match(/(chrome|safari|firefox|trident(?=\/))\/?\s*(\d+)/i)[2]||[],o=null;return 0<=e.indexOf("Android")&&(o=parseFloat(e.slice(e.indexOf("Android")+8))),!!((a.isMac()||a.isIOS())&&12<a.getSafariVersion())||(!!(r&&n.chrome&&70<i||-1!=e.indexOf("Edg")&&40<i)||!!(a.isAndroid()&&6<o&&n.chrome&&70<i))}function c(e){return!1===f.events.trigger("filestack.uploadedToFilestack",[e],!0)?(f.edit.on(),!1):e}function y(e){var t=f.button.getButtons('button[data-cmd="openFilePicker"]'),a=f.button.getButtons('button[data-cmd="openFilePickerImageOnly"]'),n=f.button.getButtons('button[data-cmd="openFilePickerVideoOnly"]'),r=f.button.getButtons('button[data-cmd="openFilePickerFile"]');t.removeClass("fr-filestack-active"),a.removeClass("fr-filestack-active"),n.removeClass("fr-filestack-active"),r.removeClass("fr-filestack-active"),!1===f.events.trigger("filestack.filestackPickerClosed",[e],!0)&&f.edit.on()}function A(){O=I=null,f.selection.restore()}function C(e){m(o,e),!1===f.events.trigger("filestack.uploadFailedToFilestack",[e],!0)&&f.edit.on()}function T(e){return t.includes(e.split("/")[1])}function k(e){var t=!1;f.opts.imageInsertButtons=f.opts.imageInsertButtons.map(function(e){return"openFilePickerImage"===e?(t=!0,"openFilePickerReplaceImageOnly"):e}),t&&f.events.trigger("filestack-init"),f.popups.hide("image.edit");var a=f.doc.querySelector(".fr-popup");a&&a.remove(),f.opts.pluginsEnabled.includes("filestack")&&function n(e){f.opts.imageEditButtons.includes("filestackIcon")&&(r=f.opts.imageEditButtons.indexOf("filestackIcon"));!f.opts.imageEditButtons.includes("filestackIcon")&&e&&f.opts.pluginsEnabled.includes("filestack")?(r||0===r)&&f.opts.imageEditButtons.splice(r,0,"filestackIcon"):e||(f.opts.imageEditButtons=f.opts.imageEditButtons.filter(function(e){return"filestackIcon"!=e}));f.opts.filestackOptions.uploadToFilestackOnly&&e?f.opts.imageEditButtons=f.opts.imageEditButtons.filter(function(e){return"imageTUI"!=e}):f.opts.pluginsEnabled.includes("imageTUI")&&!f.opts.imageEditButtons.includes("imageTUI")&&f.opts.imageEditButtons.push("imageTUI")}(e),f.events.trigger("filestack-init-edit")}function S(){var t=!1;f.opts.videoInsertButtons=f.opts.videoInsertButtons.map(function(e){return"openFilePickerVideo"===e?(t=!0,"openFilePickerReplaceVideoOnly"):e}),t&&f.events.trigger("filestack-init-video")}function R(){St.DEFAULTS.imageInsertButtons&&!St.DEFAULTS.imageInsertButtons.includes("openFilePickerImage")&&St.DEFAULTS.imageInsertButtons.push("openFilePickerImage"),St.DEFAULTS.imageEditButtons&&!St.DEFAULTS.imageEditButtons.includes("filestackIcon")&&St.DEFAULTS.imageEditButtons.push("filestackIcon"),St.DEFAULTS.videoInsertButtons&&!St.DEFAULTS.videoInsertButtons.includes("openFilePickerVideo")&&St.DEFAULTS.videoInsertButtons.push("openFilePickerVideo"),St.DEFAULTS.filesInsertButtons&&!St.DEFAULTS.filesInsertButtons.includes("openFilePicker")&&St.DEFAULTS.filesInsertButtons.push("openFilePicker"),St.DEFAULTS.fileInsertButtons&&!St.DEFAULTS.fileInsertButtons.includes("openFilePickerFile")&&St.DEFAULTS.fileInsertButtons.push("openFilePickerFile"),f.popups.onHide("image.insert",function(){var e=f.button.getButtons('button[data-cmd="openFilePickerImage"]'),t=f.button.getButtons('button[data-cmd="openFilePickerReplaceImageOnly"]');e.removeClass("fr-filestack-active"),t.removeClass("fr-filestack-active")}),f.popups.onHide("video.insert",function(){var e=f.button.getButtons('button[data-cmd="openFilePickerVideo"]'),t=f.button.getButtons('button[data-cmd="openFilePickerReplaceVideoOnly"]');e.removeClass("fr-filestack-active"),t.removeClass("fr-filestack-active")}),f.popups.onHide("filesManager.insert",function(){f.button.getButtons('button[data-cmd="openFilePicker"]').removeClass("fr-filestack-active")});var e=f.opts.filestackOptions.pickerOptions?Object.assign({},f.opts.filestackOptions.pickerOptions,{accept:f.opts.filestackOptions.pickerOptions.accept?f.opts.filestackOptions.pickerOptions.accept:[],fromSources:f.opts.filestackOptions.pickerOptions.fromSources?f.opts.filestackOptions.pickerOptions.fromSources:[]}):{accept:[],fromSources:[]};e.fromSources=function o(t,e){if(!e||0===e.length)return t;var a=[];return e.forEach(function(e){-1<t.indexOf(e)&&a.push(e)}),0===a.length&&m(s),a}(St.FILESTACK_PICKER_OPTIONS_FROMSOURCES_MAX_SUPPORTED,e.fromSources),e.onOpen=function(e){f.events.on("window.mouseup",function(e){if(document.getElementById("__filestack-picker")&&f.helpers.isMobile())return e.preventDefault(),e.stopPropagation(),!1},!0),!1===f.events.trigger("filestack.filestackPickerOpened",[e],!0)&&f.edit.on();var t=f.selection.get();t&&(t.anchorNode,t.anchorOffset)},e.onUploadDone=function(e){return function o(e){if("undefined"!=typeof e.filesUploaded){var n,t=He(e.filesUploaded);try{var a,r=function r(){var t=n.value;if(T(t.mimetype)||t.mimetype.includes("image/jpeg")||t.mimetype.includes("image/png")||t.mimetype.includes("image/")||t.mimetype.includes("video/")||t.mimetype.includes("audio/mpeg")){t.mimetype.includes("image/")&&k(!0),t.mimetype.includes("video/")&&S();var a=function a(e){t.mimetype.includes("image")?e.next().is("br")&&e.next().remove():(e.next()&&e.next().is("br")&&e.next().remove(),e.prev()&&e.prev().is("br")&&e.prev().remove()),f.selection.setAfter(e[0])};if(!c(e)||I||O||(t.mimetype.includes("ogg")?f.file.insert(t.url,t.filename,null):t.mimetype.includes("image")?(f.image.insert(t.url,!1,null,null),f.events.on("image.loaded",a)):t.mimetype.includes("video")?(f.events.on("video.inserted",a),f.video.insertHtmlVideo(t.url,null,null,null,null)):t.mimetype.includes("audio/mpeg")?(f.events.on("video.inserted",a),f.video.insertHtmlVideo(t.url,null,null,null,null,"audio")):T(t.mimetype)&&f.file.insert(t.url,t.filename,null)),I)return f.image.insert(t.url,!1,null,I),I=null,{v:void 0};if(O)return f.video.insertHtmlVideo(t.url,!1,null,O),O=null,{v:void 0}}};for(t.s();!(n=t.n()).done;)if(a=r())return a.v}catch(i){t.e(i)}finally{t.f()}}}(e)},e.onFileUploadFailed=C,e.onClose=y,e.onCancel=A,f.opts.filestackOptions.pickerOptions=e;var r=function r(e){var t="IMG"===e.target.tagName,a="VIDEO"===e.target.tagName,n=e.target.src&&e.target.src.includes(St.FILE_STACK_URL_PART)&&!e.target.src.includes("blob:");t?k(n):a&&S()},t=f.helpers.isMobile()&&!f.helpers.isWindowsPhone();if(f.events.on(t?"touchend":"click",r,t),f.events.on("drop",function(){k(!1),S()},!0),f.opts.filestackOptions.uploadToFilestackOnly&&!f.opts.iframe&&!f.opts.fullPage){if(p&&w()&&E()){var a=filestackDnD.init(p,f.el);a&&a.on("uploadFileFinish",function(e){if(e.files[0].mimetype.includes("image/")&&k(!0),e.files[0].mimetype.includes("video/")&&S(),T(e.files[0].mimetype)||e.files[0].mimetype.includes("pdf")||e.files[0].mimetype.includes("image/jpeg")||e.files[0].mimetype.includes("image/png")||e.files[0].mimetype.includes("image/")||e.files[0].mimetype.includes("video/")||e.files[0].name&&e.files[0].name.includes(".ogg")){var t=function t(e){f.popups.hide("filestackPlugin.error"),f.selection.setAfter(e[0])};if(e.files[0].mimetype.includes("image"))c(e)&&(f.image.insert(e.data.url,!1),f.events.on("image.inserted",t));else e.files[0].mimetype.includes("video")?(f.video.insertHtmlVideo(e.data.url),f.events.on("video.inserted",t)):(e.files[0].mimetype.includes("pdf")||T(e.files[0].mimetype)||e.files[0].name&&e.files[0].name.includes(".ogg"))&&f.file.insert(e.data.url,e.data._file.name,null);f.popups.hide("filestackPlugin.error")}})}f.events.on("drop",function(e){return p?w()?E()?(f.markers.remove(),f.markers.insertAtPoint(e.originalEvent),f.$el.find(".fr-marker").replaceWith(St.MARKERS),0===f.$el.find(".fr-marker").length&&f.selection.setAtEnd(f.el),v("Image loading","",!0,{x:e.originalEvent.x,y:e.originalEvent.y})):v(b()+" not enabled. Do you want to enable?","openFilePicker"):(d(l[g]),f.popups.show("filestackPlugin.error",e.originalEvent.x,e.originalEvent.y)):(d(l[u]),f.popups.show("filestackPlugin.error",e.originalEvent.x,e.originalEvent.y)),e.preventDefault(),e.stopPropagation(),!1},!0)}var n=document.getElementById("insertImage-".concat(f.id));n&&n.addEventListener("mouseup",function(){var t=!1;f.opts.imageInsertButtons=f.opts.imageInsertButtons.map(function(e){return"openFilePickerReplaceImageOnly"===e?(t=!0,"openFilePickerImage"):e}),t&&f.events.trigger("filestack-init")});var i=document.getElementById("insertVideo-".concat(f.id));i&&i.addEventListener("mouseup",function(){var t=!1;f.opts.videoInsertButtons=f.opts.videoInsertButtons.map(function(e){return"openFilePickerReplaceVideoOnly"===e?(t=!0,"openFilePickerVideo"):e}),t&&f.events.trigger("filestack-init-video")}),f.events.on("image.loaded",function(e){(!e[0].src.includes(St.FILE_STACK_URL_PART)||e[0].src.includes(St.FILE_STACK_URL_PART)&&e[0].src.includes("blob:"))&&setTimeout(function(){var e=document.querySelector("#filestackIcon-".concat(f.id));e&&e.parentNode.removeChild(e)},10)})}return f.events.on("filestack.imageTransformation.click",function(){!function i(e){I=e;var a=f.image.get()[0].currentSrc||"",t=filestack.init(_),n=new FilestackTransform(t);n.setConfigKey("output.blob",!0),n.open(a).then(function(e){t.upload(e).then(function(e){var t=f.selection.save();void 0!==a&&(f.image.insert(e.url,!1,null,I),I=null,f.selection.restore(t))}),t.on("upload.error",function(){m(o)})}),f.events.on("keydown",function(){var e=document.getElementsByClassName("fs-transforms-container");f.helpers.isMobile()&&e&&e[0].childNodes&&e[0].childNodes.length&&(I=null)});var r=f.button.getButtons('button[data-cmd="filestackIcon"]');n.on("canvas:save",function(){r.removeClass("fr-filestack-active"),v("Image loading","",!0,{x:I.offset().left,y:I.offset().top+I.height()})}),n.on("canvas:cancel",function(){r.removeClass("fr-filestack-active")})}(f.image.get())}),f.events.on("filestack.imageTransformation.error",function(){m(9)}),{_init:R,showFilestackPopup:function x(e,t,a){if(!e)return!1;var n;if("openFilePicker"===e||"openFilePickerFile"===e?n=St.FILESTACK_PICKER_OPTIONS_MEDIA_MAX_SUPPORTED:"openFilePickerImageOnly"===e||"openFilePickerReplaceImageOnly"===e||"openFilePickerImage"===e?n=St.FILESTACK_PICKER_OPTIONS_IMAGE_ONLY_SUPPORTED:"openFilePickerVideoOnly"!==e&&"openFilePickerReplaceVideoOnly"!==e&&"openFilePickerVideo"!==e||(n=St.FILESTACK_PICKER_OPTIONS_VIDEO_ONLY_SUPPORTED),!_)return m(u,e),!1;if(!w())return m(g,e),!1;if(!E())return v(b()+" not enabled. Do you want to enable?",e),!1;if(!p&&0===!Object.keys(f.opts.filestackOptions).length)return m(10,e),!1;t&&(I=t),a&&(O=a);var r,i=f.opts.filestackOptions.pickerOptions?Object.assign({},f.opts.filestackOptions.pickerOptions,{accept:f.opts.filestackOptions.pickerOptions.accept?f.opts.filestackOptions.pickerOptions.accept:[],fromSources:f.opts.filestackOptions.pickerOptions.fromSources?f.opts.filestackOptions.pickerOptions.fromSources:[]}):{accept:[],fromSources:[]};r=f.opts.fileAllowedTypes&&1===f.opts.fileAllowedTypes.length&&"*"===f.opts.fileAllowedTypes[0]?St.FILESTACK_PICKER_OPTIONS_MEDIA_MAX_SUPPORTED:f.opts.fileAllowedTypes,0===i.accept.length&&(i.accept=St.FILESTACK_PICKER_OPTIONS_MEDIA_MAX_SUPPORTED);var o=St.FILESTACK_PICKER_OPTIONS_VIDEO_ONLY_SUPPORTED;f.opts.videoAllowedTypes&&(o=f.opts.videoAllowedTypes.map(function(e){return"mp3"===e?"audio/".concat(e):"video/".concat(e)})),"openFilePickerImageOnly"===e||"openFilePickerReplaceImageOnly"===e||"openFilePickerImage"===e?n=f.opts.imageAllowedTypes.map(function(e){return"image/".concat(e)}):"openFilePickerVideoOnly"===e||"openFilePickerReplaceVideoOnly"===e||"openFilePickerVideo"===e?n=o:"openFilePickerFile"===e&&(n=r);var s=i.maxFiles;(t||a)&&(s=1);var l="openFilePicker"===e?function d(t,e){if(!e||0===e.length)return t;var a=[];return e.forEach(function(e){-1<t.indexOf(e)&&a.push(e)}),0===a.length&&m(h),a}(n,i.accept):n,c=Object.assign({},i,{accept:l,maxFiles:s});try{p.picker(c).open(),f.popups.hideAll(),f.selection.save()}catch(L){0===Object.keys(f.opts.filestackOptions).length&&m(8,e)}},isBrowserSupported:w}},St.DefineIcon("filestackIcon",{ALT:"Open Filestack file picker",NAME:"filestack",SVG_KEY:"filestackIcon"}),St.DefineIcon("filestackIconAdd",{ALT:"Open Filestack file picker",NAME:"filestackAdd",SVG_KEY:"filestackIconAdd"}),St.DefineIcon("imageTransformations",{ALT:"Open Filestack image transformations",NAME:"imageTransformations",SVG_KEY:"imageTransformations"}),St.DefineIcon("imageFilestackOnly",{template:"svgMultiplePath",PATHS:'<path d="M11.1 15.8h7.7V5.7H5.1v4.2H3.4V5.7c0-.9.8-1.7 1.7-1.7h13.7c.9 0 1.7.8 1.7 1.7v10.1c0 .9-.8 1.7-1.7 1.7h-7.7v-1.7Zm0-2.5 2.6-3.4h.2l3.3 4.2h-6.1v-.8ZM8.9 6.9c.7 0 1.3.6 1.3 1.3s-.6 1.3-1.3 1.3-1.3-.6-1.3-1.3.6-1.3 1.3-1.3Z"/><path d="M11.1 17.5 8.7 20v-2.5h2.4Zm-4.9-1.6v.9h-.9v-.9h.9Zm4.9.9h-.9v-6H3.5V19h4.6v.9H2.5V9.8h8.6v7Zm-3.4-1.6H5.3v-.9h2.4v.9Zm.6-2.5v.9h-3v-.9h3Z"/>'}),St.DefineIcon("videoFilestackOnly",{template:"svgMultiplePath",PATHS:'<path d="m11 11.3 1 2.6h3.6V6.8h-9v3.6H4.8V6c0-.2.1-.5.3-.6s.4-.3.6-.3h10.8c.2 0 .5.1.6.3s.3.4.3.6v3.1l2.1-2c.3-.3.6-.3 1-.2.3 0 .6.5.6.8v5.5c0 .4-.2.7-.6.8-.3.1-.7 0-1-.2l-2.1-2v3.1c0 .2 0 .5-.3.6-.2.2-.4.3-.6.3H12V14l-1-2.7Z" /><path d="M11.1 17.5 8.7 20v-2.5h2.4Zm-4.9-1.6v.9h-.9v-.9h.9Zm4.9.9h-.9v-6H3.5V19h4.6v.9H2.5V9.8h8.6v7Zm-3.4-1.6H5.3v-.9h2.4v.9Zm.6-2.5v.9h-3v-.9h3Z"/>'}),St.RegisterCommand("openFilePicker",{type:"button",icon:"filestackIcon",title:"Open Filestack File Picker",callback:function(){this.button.getButtons('button[data-cmd="openFilePicker"]').addClass("fr-filestack-active"),this.filestack.showFilestackPopup("openFilePicker")},plugin:"filestack"}),St.RegisterCommand("openFilePickerImageOnly",{type:"button",icon:"imageFilestackOnly",title:"Open Filestack Image Picker",callback:function(){this.button.getButtons('button[data-cmd="openFilePickerImageOnly"]').addClass("fr-filestack-active"),this.filestack.showFilestackPopup("openFilePickerImageOnly",this.image&&this.image.get())},plugin:"filestack"}),St.RegisterCommand("openFilePickerImage",{type:"button",icon:"filestackIcon",title:"Open Filestack Image Picker",callback:function(){this.button.getButtons('button[data-cmd="openFilePickerImage"]').addClass("fr-filestack-active"),this.filestack.showFilestackPopup("openFilePickerImage",this.image&&this.image.get())},plugin:"filestack"}),St.RegisterCommand("openFilePickerReplaceImageOnly",{type:"button",icon:"filestackIconAdd",title:"Open Filestack File Picker",callback:function(){this.button.getButtons('button[data-cmd="openFilePickerReplaceImageOnly"]').addClass("fr-filestack-active"),this.filestack.showFilestackPopup("openFilePickerReplaceImageOnly",this.image&&this.image.get())},plugin:"filestack"}),St.RegisterCommand("openFilePickerVideoOnly",{type:"button",icon:"videoFilestackOnly",title:"Open Filestack Video Picker",callback:function(){this.button.getButtons('button[data-cmd="openFilePickerVideoOnly"]').addClass("fr-filestack-active"),this.filestack.showFilestackPopup("openFilePickerVideoOnly",null,this.video&&this.video.get())},plugin:"filestack"}),St.RegisterCommand("openFilePickerVideo",{type:"button",icon:"filestackIcon",title:"Open Filestack Video Picker",callback:function(){this.button.getButtons('button[data-cmd="openFilePickerVideo"]').addClass("fr-filestack-active"),this.filestack.showFilestackPopup("openFilePickerVideo",null,this.video&&this.video.get())},plugin:"filestack"}),St.RegisterCommand("openFilePickerReplaceVideoOnly",{type:"button",icon:"filestackIconAdd",title:"Open Filestack File Picker",callback:function(){this.button.getButtons('button[data-cmd="openFilePickerReplaceVideoOnly"]').addClass("fr-filestack-active"),this.filestack.showFilestackPopup("openFilePickerReplaceVideoOnly",null,this.video&&this.video.get())},plugin:"filestack"}),St.RegisterCommand("filestackIcon",{type:"button",icon:"imageTransformations",title:"Image Transformations",plugin:"filestack",callback:function(){var e=!1,t=this.image.get(0)[0];(t&&t.currentSrc&&(e=t.currentSrc.includes(St.FILE_STACK_URL_PART)&&!t.currentSrc.includes("blob:")),e)?(this.button.getButtons('button[data-cmd="filestackIcon"]').addClass("fr-filestack-active"),this.events.trigger("filestack.imageTransformation.click")):this.events.trigger("filestack.imageTransformation.error")}}),St.RegisterCommand("openFilePickerFile",{type:"button",icon:"filestackIcon",title:"Open Filestack Upload File",callback:function(){this.button.getButtons('button[data-cmd="openFilePickerFile"]').addClass("fr-filestack-active"),this.filestack.showFilestackPopup("openFilePickerFile")},plugin:"filestack"})});

/***/ }),

/***/ 6782:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(n,t){ true?t(__webpack_require__(189)):0}(this,function(i){"use strict";(i=i&&i.hasOwnProperty("default")?i["default"]:i).PLUGINS.align=function(a){var l=a.$;return{apply:function r(n){var t=a.selection.element();if(l(t).parents(".fr-img-caption").length)l(t).css("text-align",n);else{a.selection.save(),a.html.wrap(!0,!0,!0,!0),a.selection.restore();for(var e=a.selection.blocks(),i=0;i<e.length;i++)l(e[i]).css("text-align",n).removeClass("fr-temp-div"),""===l(e[i]).attr("class")&&l(e[i]).removeAttr("class"),""===l(e[i]).attr("style")&&l(e[i]).removeAttr("style");a.selection.save(),a.html.unwrap(),a.selection.restore()}},refresh:function i(n){var t=a.selection.blocks();if(t.length){var e=a.helpers.getAlignment(l(t[0]));n.find("> *").first().replaceWith(a.icon.create("align-".concat(e)))}},refreshOnShow:function o(n,t){var e=a.selection.blocks();if(e.length){var i=a.helpers.getAlignment(l(e[0]));t.find('a.fr-command[data-param1="'.concat(i,'"]')).addClass("fr-active").attr("aria-selected",!0)}},refreshForToolbar:function s(n){var t=a.selection.blocks();if(t.length){var e=a.helpers.getAlignment(l(t[0]));e=e.charAt(0).toUpperCase()+e.slice(1),"align".concat(e)===n.attr("data-cmd")&&n.addClass("fr-active")}}}},i.DefineIcon("align",{NAME:"align-left",SVG_KEY:"alignLeft"}),i.DefineIcon("align-left",{NAME:"align-left",SVG_KEY:"alignLeft"}),i.DefineIcon("align-right",{NAME:"align-right",SVG_KEY:"alignRight"}),i.DefineIcon("align-center",{NAME:"align-center",SVG_KEY:"alignCenter"}),i.DefineIcon("align-justify",{NAME:"align-justify",SVG_KEY:"alignJustify"}),i.RegisterCommand("align",{type:"dropdown",title:"Align",options:{left:"Align Left",center:"Align Center",right:"Align Right",justify:"Align Justify"},html:function(){var n='<ul class="fr-dropdown-list" role="presentation">',t=i.COMMANDS.align.options;for(var e in t)t.hasOwnProperty(e)&&(n+='<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="align"data-param1="\n        '.concat(e,'" title="').concat(this.language.translate(t[e]),'">').concat(this.icon.create("align-".concat(e)),'<span class="fr-sr-only">\n        ').concat(this.language.translate(t[e]),"</span></a></li>"));return n+="</ul>"},callback:function(n,t){this.align.apply(t)},refresh:function(n){this.align.refresh(n)},refreshOnShow:function(n,t){this.align.refreshOnShow(n,t)},plugin:"align"}),i.RegisterCommand("alignLeft",{type:"button",icon:"align-left",title:"Align Left",callback:function(){this.align.apply("left")},refresh:function(n){this.align.refreshForToolbar(n)},plugin:"align"}),i.RegisterCommand("alignRight",{type:"button",icon:"align-right",title:"Align Right",callback:function(){this.align.apply("right")},refresh:function(n){this.align.refreshForToolbar(n)},plugin:"align"}),i.RegisterCommand("alignCenter",{type:"button",icon:"align-center",title:"Align Center",callback:function(){this.align.apply("center")},refresh:function(n){this.align.refreshForToolbar(n)},plugin:"align"}),i.RegisterCommand("alignJustify",{type:"button",icon:"align-justify",title:"Align Justify",callback:function(){this.align.apply("justify")},refresh:function(n){this.align.refreshForToolbar(n)},plugin:"align"})});

/***/ }),

/***/ 9152:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(e,t){ true?t(__webpack_require__(189)):0}(this,function(e){"use strict";e=e&&e.hasOwnProperty("default")?e["default"]:e,Object.assign(e.DEFAULTS,{codeMirror:window.CodeMirror,codeMirrorOptions:{lineNumbers:!0,tabMode:"indent",indentWithTabs:!0,lineWrapping:!0,mode:"text/html",tabSize:2},codeBeautifierOptions:{end_with_newline:!0,indent_inner_html:!0,extra_liners:["p","h1","h2","h3","h4","h5","h6","blockquote","pre","ul","ol","table","dl"],brace_style:"expand",indent_char:"\t",indent_size:1,wrap_line_length:0},codeViewKeepActiveButtons:["fullscreen"]}),e.PLUGINS.codeView=function(c){var d,f,h=c.$,p=function p(){return c.$box.hasClass("fr-code-view")};function u(){return f?f.getValue():d.val()}function g(){p()&&(f&&f.setSize(null,c.opts.height?c.opts.height:"auto"),c.opts.heightMin||c.opts.height?(c.$box.find(".CodeMirror-scroll, .CodeMirror-gutters").css("min-height",c.opts.heightMin||c.opts.height),d.css("height",c.opts.height)):c.$box.find(".CodeMirror-scroll, .CodeMirror-gutters").css("min-height",""))}var m,b=!1;function v(){p()&&c.events.trigger("blur")}function w(){p()&&b&&c.events.trigger("focus")}function o(e){d||(!function l(){d=h('<textarea class="fr-code" tabIndex="-1">'),c.$wp.append(d),d.attr("dir",c.opts.direction),c.$box.hasClass("fr-basic")||(m=h('<a data-cmd="html" title="Code View" class="fr-command fr-btn html-switch'.concat(c.helpers.isMobile()?"":" fr-desktop",'" role="button" tabIndex="-1"><i class="fa fa-code"></i></button>')),c.$box.append(m),c.events.bindClick(c.$box,"a.html-switch",function(){c.events.trigger("commands.before",["html"]),M(!1),c.events.trigger("commands.after",["html"])}));var e=function e(){return!p()};c.events.on("buttons.refresh",e),c.events.on("copy",e,!0),c.events.on("cut",e,!0),c.events.on("paste",e,!0),c.events.on("destroy",x,!0),c.events.on("html.set",function(){p()&&M(!0)}),c.events.on("codeView.update",g),c.events.on("codeView.toggle",function(){c.$box.hasClass("fr-code-view")&&M()}),c.events.on("form.submit",function(){p()&&(c.html.set(u()),c.events.trigger("contentChanged",[],!0))},!0)}(),!f&&c.opts.codeMirror?((f=c.opts.codeMirror.fromTextArea(d.get(0),c.opts.codeMirrorOptions)).on("blur",v),f.on("focus",w)):(c.events.$on(d,"keydown keyup change input",function(){c.opts.height?this.removeAttribute("rows"):(this.rows=1,0===this.value.length?this.style.height="auto":this.style.height="".concat(this.scrollHeight,"px"))}),c.events.$on(d,"blur",v),c.events.$on(d,"focus",w))),c.undo.saveStep(),c.html.cleanEmptyTags(),c.html.cleanWhiteTags(!0),c.core.hasFocus()&&(c.core.isEmpty()||(c.selection.save(),c.$el.find('.fr-marker[data-type="true"]').first().replaceWith('<span class="fr-tmp fr-sm">F</span>'),c.$el.find('.fr-marker[data-type="false"]').last().replaceWith('<span class="fr-tmp fr-em">F</span>')));var t=c.html.get(!1,!0);c.$el.find("span.fr-tmp").remove(),c.$box.toggleClass("fr-code-view",!0);var r,o,n=!1;if(c.core.hasFocus()&&(n=!0,c.events.disableBlur(),c.$el.blur()),t=(t=t.replace(/<span class="fr-tmp fr-sm">F<\/span>/,"FROALA-SM")).replace(/<span class="fr-tmp fr-em">F<\/span>/,"FROALA-EM"),c.codeBeautifier&&!t.includes("fr-embedly")&&(t=c.codeBeautifier.run(t,c.opts.codeBeautifierOptions)),f){r=t.indexOf("FROALA-SM"),(o=t.indexOf("FROALA-EM"))<r?r=o:o-=9;var s=(t=t.replace(/FROALA-SM/g,"").replace(/FROALA-EM/g,"")).substring(0,r).length-t.substring(0,r).replace(/\n/g,"").length,i=t.substring(0,o).length-t.substring(0,o).replace(/\n/g,"").length;r=t.substring(0,r).length-t.substring(0,t.substring(0,r).lastIndexOf("\n")+1).length,o=t.substring(0,o).length-t.substring(0,t.substring(0,o).lastIndexOf("\n")+1).length,f.setSize(null,c.opts.height?c.opts.height:"auto"),c.opts.heightMin&&c.$box.find(".CodeMirror-scroll").css("min-height",c.opts.heightMin),f.setValue(t),b=!n,f.focus(),b=!0,f.setSelection({line:s,ch:r},{line:i,ch:o}),f.refresh(),f.clearHistory()}else{r=t.indexOf("FROALA-SM"),o=t.indexOf("FROALA-EM")-9,c.opts.heightMin&&d.css("min-height",c.opts.heightMin),c.opts.height&&d.css("height",c.opts.height),c.opts.heightMax&&d.css("max-height",c.opts.height||c.opts.heightMax),d.val(t.replace(/FROALA-SM/g,"").replace(/FROALA-EM/g,"")).trigger("change");var a=h(c.o_doc).scrollTop();b=!n,d.focus(),b=!0,d.get(0).setSelectionRange(r,o),h(c.o_doc).scrollTop(a)}c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").not(e).filter(function(){return c.opts.codeViewKeepActiveButtons.indexOf(h(this).data("cmd"))<0}).addClass("fr-disabled").attr("aria-disabled",!0),e.addClass("fr-active").attr("aria-pressed",!0),!c.helpers.isMobile()&&c.opts.toolbarInline&&c.toolbar.hide()}function M(e){void 0===e&&(e=!p());var t=c.$tb.find('.fr-command[data-cmd="html"]');e?(c.popups.hideAll(),o(t)):(c.$box.toggleClass("fr-code-view",!1),function r(e){var t=u();c.html.set(t),c.$el.blur(),c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").not(e).removeClass("fr-disabled").attr("aria-disabled",!1),e.removeClass("fr-active").attr("aria-pressed",!1),c.selection.setAtStart(c.el),c.selection.restore(),c.placeholder.refresh(),c.undo.saveStep()}(t),c.events.trigger("codeView.update"))}function x(){p()&&M(!1),f&&f.toTextArea(),d.val("").removeData().remove(),d=null,m&&(m.remove(),m=null)}return{_init:function e(){if(c.events.on("focus",function(){c.opts.toolbarContainer&&function t(){var e=c.$tb.find('.fr-command[data-cmd="html"]');p()?(c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").not(e).filter(function(){return c.opts.codeViewKeepActiveButtons.indexOf(h(this).data("cmd"))<0}).addClass("fr-disabled").attr("aria-disabled",!1),e.addClass("fr-active").attr("aria-pressed",!1)):(c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").not(e).removeClass("fr-disabled").attr("aria-disabled",!1),e.removeClass("fr-active").attr("aria-pressed",!1))}()}),!c.$wp)return!1},toggle:M,isActive:p,get:u}},e.RegisterCommand("html",{title:"Code View",undo:!1,focus:!1,forcedRefresh:!0,toggle:!0,callback:function(){this.codeView.toggle()},plugin:"codeView"}),e.DefineIcon("html",{NAME:"code",SVG_KEY:"codeView"})});

/***/ }),

/***/ 9291:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(o,t){ true?t(__webpack_require__(189)):0}(this,function(k){"use strict";k=k&&k.hasOwnProperty("default")?k["default"]:k,Object.assign(k.POPUP_TEMPLATES,{"textColor.picker":"[_BUTTONS_][_TEXT_COLORS_][_CUSTOM_COLOR_]","backgroundColor.picker":"[_BUTTONS_][_BACKGROUND_COLORS_][_CUSTOM_COLOR_]"}),Object.assign(k.DEFAULTS,{colorsText:["#61BD6D","#1ABC9C","#54ACD2","#2C82C9","#9365B8","#475577","#CCCCCC","#41A85F","#00A885","#3D8EB9","#2969B0","#553982","#28324E","#000000","#F7DA64","#FBA026","#EB6B56","#E25041","#A38F84","#EFEFEF","#FFFFFF","#FAC51C","#F37934","#D14841","#B8312F","#7C706B","#D1D5D8","REMOVE"],colorsBackground:["#61BD6D","#1ABC9C","#54ACD2","#2C82C9","#9365B8","#475577","#CCCCCC","#41A85F","#00A885","#3D8EB9","#2969B0","#553982","#28324E","#000000","#F7DA64","#FBA026","#EB6B56","#E25041","#A38F84","#EFEFEF","#FFFFFF","#FAC51C","#F37934","#D14841","#B8312F","#7C706B","#D1D5D8","REMOVE"],colorsStep:7,colorsHEXInput:!0,colorsButtons:["colorsBack","|","-"]}),k.PLUGINS.colors=function(g){var E=g.$,l='<div class="fr-color-hex-layer fr-active fr-layer" id="fr-color-hex-layer- \n  '.concat(g.id,'"><div class="fr-input-line"><input maxlength="7" id="[ID]"\n  type="text" placeholder="').concat(g.language.translate("HEX Color"),'" \n  tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button \n  type="button" class="fr-command fr-submit" data-cmd="[COMMAND]" tabIndex="2" role="button">\n  ').concat(g.language.translate("OK"),"</button></div></div>");function s(o){for(var t="text"===o?g.opts.colorsText:g.opts.colorsBackground,r='<div class="fr-color-set fr-'.concat(o,'-color fr-selected-set">'),e=0;e<t.length;e++)0!==e&&e%g.opts.colorsStep==0&&(r+="<br>"),"REMOVE"!==t[e]?r+='<span class="fr-command fr-select-color" style="background:'.concat(t[e],';" \n        tabIndex="-1" aria-selected="false" role="button" data-cmd="apply').concat(o,'Color" \n        data-param1="').concat(t[e],'"><span class="fr-sr-only"> ').concat(g.language.translate("Color")).concat(t[e]," \n        &nbsp;&nbsp;&nbsp;</span></span>"):r+='<span class="fr-command fr-select-color" data-cmd="apply'.concat(o,'Color"\n         tabIndex="-1" role="button" data-param1="REMOVE" \n         title="').concat(g.language.translate("Clear Formatting"),'">').concat(g.icon.create("remove"),' \n        <span class="fr-sr-only"> ').concat(g.language.translate("Clear Formatting")," </span></span>");return"".concat(r,"</div>")}function i(o){var t,r=g.popups.get("".concat(o,"Color.picker")),e=E(g.selection.element());t="background"===o?"background-color":"color";var c=r.find(".fr-".concat(o,"-color .fr-select-color"));for(c.find(".fr-selected-color").remove(),c.removeClass("fr-active-item"),c.not('[data-param1="REMOVE"]').attr("aria-selected",!1);e.get(0)!==g.el;){if("transparent"!==e.css(t)&&"rgba(0, 0, 0, 0)"!==e.css(t)){var a=r.find(".fr-".concat(o,'-color .fr-select-color[data-param1="').concat(g.helpers.RGBToHex(e.css(t)),'"]'));a.append('<span class="fr-selected-color" aria-hidden="true">\uf00c</span>'),a.addClass("fr-active-item").attr("aria-selected",!0);break}e=e.parent()}!function n(o){var t=g.popups.get("".concat(o,"Color.picker")),r=t.find(".fr-".concat(o,"-color .fr-active-item")).attr("data-param1"),e=t.find(".fr-color-hex-layer input");r||(r="");e.length&&E(e.val(r).input).trigger("change")}(o)}function e(o){"REMOVE"!==o?g.format.applyStyle("background-color",g.helpers.HEXtoRGB(o)):g.format.removeStyle("background-color"),g.popups.hide("backgroundColor.picker")}function c(o){"REMOVE"!==o?g.format.applyStyle("color",g.helpers.HEXtoRGB(o)):g.format.removeStyle("color"),g.popups.hide("textColor.picker")}return{showColorsPopup:function p(o){var t=g.$tb.find('.fr-command[data-cmd="'.concat(o,'"]')),r=g.popups.get("".concat(o,".picker"));if(r||(r=function n(o){var t="";g.opts.toolbarInline&&0<g.opts.colorsButtons.length&&(t+='<div class="fr-buttons fr-colors-buttons fr-tabs">\n        '.concat(g.button.buildList(g.opts.colorsButtons),"\n        </div>"));var r,e="";r="textColor"===o?(g.opts.colorsHEXInput&&(e=l.replace(/\[ID\]/g,"fr-color-hex-layer-text-".concat(g.id)).replace(/\[COMMAND\]/g,"customTextColor")),{buttons:t,text_colors:s("text"),custom_color:e}):(g.opts.colorsHEXInput&&(e=l.replace(/\[ID\]/g,"fr-color-hex-layer-background-".concat(g.id)).replace(/\[COMMAND\]/g,"customBackgroundColor")),{buttons:t,background_colors:s("background"),custom_color:e});var c=g.popups.create("".concat(o,".picker"),r);return function a(C,b){g.events.on("popup.tab",function(o){var t=E(o.currentTarget);if(!g.popups.isVisible(b)||!t.is("span"))return!0;var r=o.which,e=!0;if(k.KEYCODE.TAB===r){var c=C.find(".fr-buttons");e=!g.accessibility.focusToolbar(c,!!o.shiftKey)}else if(k.KEYCODE.ARROW_UP===r||k.KEYCODE.ARROW_DOWN===r||k.KEYCODE.ARROW_LEFT===r||k.KEYCODE.ARROW_RIGHT===r){if(t.is("span.fr-select-color")){var a=t.parent().find("span.fr-select-color"),n=a.index(t),l=g.opts.colorsStep,s=Math.floor(a.length/l),i=n%l,p=Math.floor(n/l),u=p*l+i,d=s*l;k.KEYCODE.ARROW_UP===r?u=((u-l)%d+d)%d:k.KEYCODE.ARROW_DOWN===r?u=(u+l)%d:k.KEYCODE.ARROW_LEFT===r?u=((u-1)%d+d)%d:k.KEYCODE.ARROW_RIGHT===r&&(u=(u+1)%d);var f=E(a.get(u));g.events.disableBlur(),f.focus(),e=!1}}else k.KEYCODE.ENTER===r&&(g.button.exec(t),e=!1);return!1===e&&(o.preventDefault(),o.stopPropagation()),e},!0)}(c,"".concat(o,".picker")),c}(o)),!r.hasClass("fr-active"))if(g.popups.setContainer("".concat(o,".picker"),g.$tb),i("textColor"===o?"text":"background"),t.isVisible()){var e=g.button.getPosition(t),c=e.left,a=e.top;g.popups.show("".concat(o,".picker"),c,a,t.outerHeight())}else g.position.forSelection(r),g.popups.show("".concat(o,".picker"))},background:e,customColor:function a(o){var t=g.popups.get("".concat(o,"Color.picker")).find(".fr-color-hex-layer input");if(t.length){var r=t.val();"background"===o?e(r):c(r)}},text:c,back:function o(){g.popups.hide("textColor.picker"),g.popups.hide("backgroundColor.picker"),g.toolbar.showInline()}}},k.DefineIcon("textColor",{NAME:"tint",SVG_KEY:"textColor"}),k.RegisterCommand("textColor",{title:"Text Color",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible("textColor.picker")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("textColor.picker")):this.colors.showColorsPopup("textColor")}}),k.RegisterCommand("applytextColor",{undo:!0,callback:function(o,t){this.colors.text(t)}}),k.RegisterCommand("customTextColor",{title:"OK",undo:!0,callback:function(){this.colors.customColor("text")}}),k.DefineIcon("backgroundColor",{NAME:"paint-brush",SVG_KEY:"backgroundColor"}),k.RegisterCommand("backgroundColor",{title:"Background Color",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible("backgroundColor.picker")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("backgroundColor.picker")):this.colors.showColorsPopup("backgroundColor")}}),k.RegisterCommand("applybackgroundColor",{undo:!0,callback:function(o,t){this.colors.background(t)}}),k.RegisterCommand("customBackgroundColor",{title:"OK",undo:!0,callback:function(){this.colors.customColor("background")}}),k.DefineIcon("colorsBack",{NAME:"arrow-left",SVG_KEY:"back"}),k.RegisterCommand("colorsBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.colors.back()}}),k.DefineIcon("remove",{NAME:"eraser",SVG_KEY:"remove"})});

/***/ }),

/***/ 654:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(e,c){ true?c(__webpack_require__(189)):0}(this,function(B){"use strict";B=B&&B.hasOwnProperty("default")?B["default"]:B,Object.assign(B.POPUP_TEMPLATES,{emoticons:"[_BUTTONS_][_CUSTOM_LAYER_]"}),Object.assign(B.DEFAULTS,{emoticonsSet:[{id:"people",name:"Smileys & People",code:"1f600",emoticons:[{code:"1f600",desc:"Grinning face"},{code:"1f601",desc:"Grinning Face with Smiling Eyes"},{code:"1f602",desc:"Face with Tears of Joy"},{code:"1f603",desc:"Smiling Face with Open Mouth"},{code:"1f604",desc:"Smiling Face with Open Mouth and Smiling Eyes"},{code:"1f605",desc:"Smiling Face with Open Mouth and Cold Sweat"},{code:"1f606",desc:"Smiling Face with Open Mouth and Tightly-Closed Eyes"},{code:"1f609",desc:"Winking Face"},{code:"1f60a",desc:"Smiling Face with Smiling Eyes"},{code:"1f608",desc:"Face Savouring Delicious Food"},{code:"1f60e",desc:"Smiling Face with Sunglasses"},{code:"1f60d",desc:"Smiling Face with Heart-Shaped Eyes"},{code:"1f618",desc:"Face Throwing a Kiss"},{code:"1f617",desc:"Kissing Face"},{code:"1f619",desc:"Kissing Face with Smiling Eyes"},{code:"1f61a",desc:"Kissing Face with Closed Eyes"},{code:"263a",desc:"White Smiling Face"},{code:"1f642",desc:"Slightly Smiling Face"},{code:"1f610",desc:"Neutral Face"},{code:"1f611",desc:"Expressionless Face"},{code:"1f636",desc:"Face Without Mouth"},{code:"1f60f",desc:"Smirking Face"},{code:"1f623",desc:"Persevering Face"},{code:"1f625",desc:"Disappointed but Relieved Face"},{code:"1f62e",desc:"Face with Open Mouth"},{code:"1f62f",desc:"Hushed Face"},{code:"1f62a",desc:"Sleepy Face"},{code:"1f62b",desc:"Tired Face"},{code:"1f634",desc:"Sleeping Face"},{code:"1f60c",desc:"Relieved Face"},{code:"1f61b",desc:"Face with Stuck-out Tongue"},{code:"1f61c",desc:"Face with Stuck-out Tongue and Winking Eye"},{code:"1f61d",desc:"Face with Stuck-out Tongue and Tightly-Closed Eyes"},{code:"1f612",desc:"Unamused Face"},{code:"1f613",desc:"Face with Cold Sweat"},{code:"1f613",desc:"Face with Cold Sweat"},{code:"1f614",desc:"Pensive Face"},{code:"1f615",desc:"Confused Face"},{code:"1f632",desc:"Astonished  Face"},{code:"1f616",desc:"Confounded Face"},{code:"1f61e",desc:"Disappointed Face"},{code:"1f61f",desc:"Worried Face"},{code:"1f624",desc:"Face with Look of Triumph"},{code:"1f622",desc:"Crying Face"},{code:"1f62d",desc:"Loudly Crying Face"},{code:"1f626",desc:"Frowning Face with Open Mouth"},{code:"1f627",desc:"Anguished Face"},{code:"1f628",desc:"Fearful Face"},{code:"1f629",desc:"Weary Face"},{code:"1f62c",desc:"Grimacing Face"},{code:"1f630",desc:"Face with Open Mouth and Cold Sweat"},{code:"1f631",desc:"Face Screaming in Fear"},{code:"1f633",desc:"Flushed Face"},{code:"1f635",desc:"Dizzy Face"},{code:"1f621",desc:"Pouting Face"},{code:"1f620",desc:"Angry Face"},{code:"1f637",desc:"Face with Medical Mask"},{code:"1f607",desc:"Smiling Face with Halo"},{code:"1f608",desc:"Smiling Face with Horns"},{code:"1f47f",desc:"Imp"},{code:"1f479",desc:"Japanese Ogre"},{code:"1f47a",desc:"Japanese Goblin"},{code:"1f480",desc:"Skull"},{code:"1f47b",desc:"Ghost"},{code:"1f47d",desc:"Extraterrestrial Alien"},{code:"1f47e",desc:"Alien Monster"},{code:"1f4a9",desc:"Pile of Poo"},{code:"1f63a",desc:"Smiling Cat Face with Open Mouth"},{code:"1f638",desc:"Grinning Cat Face with Smiling Eyes"},{code:"1f639",desc:"Cat Face with Tears of Joy"},{code:"1f63b",desc:"Smiling Cat Face with Heart-Shaped Eyes"},{code:"1f63c",desc:"Cat Face with Wry Smile"},{code:"1f63d",desc:"Kissing Cat Face with Closed Eyes"},{code:"1f640",desc:"Weary Cat Face"},{code:"1f63f",desc:"Crying Cat Face"},{code:"1f63e",desc:"Pouting Cat Face"},{code:"1f648",desc:"See-No-Evil Monkey"},{code:"1f649",desc:"Hear-No-Evil Monkey"},{code:"1f64a",desc:"Speak-No-Evil Monkey"},{code:"1f476",desc:"Baby"},{code:"1f466",desc:"Boy"},{code:"1f467",desc:"Girl"},{code:"1f468",desc:"Man"},{code:"1f469",desc:"Woman"},{code:"1f474",desc:"Older Man"},{code:"1f475",desc:"Older Woman"},{code:"1f46e",desc:"Police Officer"},{code:"1f482",desc:" Guardsman"},{code:"1f477",desc:" Construction Worker"},{code:"1f478",desc:"Princess"},{code:"1f473",desc:"Man with Turban"},{code:"1f472",desc:"Man with Gua Pi Mao"},{code:"1f471",desc:"Person with Blond Hair"},{code:"1f470",desc:"Bride with Veil"},{code:"1f47c",desc:"Baby Angel"},{code:"1f385",desc:"Father Christmas"},{code:"1f64e",desc:"Person with Pouting Face"},{code:"1f645",desc:"Face with No Good Gesture"},{code:"1f646",desc:"Face with Ok Gesture"},{code:"1f481",desc:"Information Desk Person"},{code:"1f64b",desc:"Happy Person Raising One Hand"},{code:"1f647",desc:"Person Bowing Deeply"},{code:"1f486",desc:"Face Massage"},{code:"1f487",desc:"Haircut"},{code:"1f6b6",desc:"Pedestrian"},{code:"1f3c3",desc:"Runner"},{code:"1f483",desc:"Dancer"},{code:"1f46f",desc:"Woman with Bunny Ears"},{code:"1f6c0",desc:"Bath"},{code:"1f464",desc:"Bust in Silhouette"},{code:"1f465",desc:"Busts in Silhouette"},{code:"1f3c7",desc:"Horse Racing"},{code:"1f3c2",desc:" Snowboarder"},{code:"1f3c4",desc:" Surfer"},{code:"1f6a3",desc:" Rowboat"},{code:"1f3ca",desc:" Swimmer"},{code:"1f6b4",desc:" Bicyclist"},{code:"1f6b5",desc:"Mountain Bicyclist"},{code:"1f46b",desc:" Man and Woman Holding Hands"},{code:"1f46c",desc:"Two Men Holding Hands"},{code:"1f46d",desc:"Two Women Holding Hands"},{code:"1f48f",desc:"Kiss"},{code:"1f468-2764-1f48b-1f468",uCode:"\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68",desc:"Man Kiss Man"},{code:"1f469-2764-1f48b-1f469",uCode:"\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc69",desc:"Woman Kiss Woman"},{code:"1f491",desc:"Couple with Heart"},{code:"1f468-2764-1f468",uCode:"\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68",desc:"Man Heart Man"},{code:"1f469-2764-1f469",uCode:"\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc69",desc:"Woman Heart Woman"},{code:"1f46a",desc:"Family"},{code:"1f468",desc:"Man Woman Boy"},{code:"1f468-1f469-1f467",desc:"Man Woman Girl"},{code:"1f468-1f469-1f467-1f466",desc:"Man Woman Girl Boy"},{code:"1f468-1f469-1f466-1f466",desc:"Man Woman Boy Boy"},{code:"1f468-1f469-1f467-1f467",desc:"Man Woman Girl Girl"},{code:"1f468-1f468-1f466",desc:"Man Man Boy"},{code:"1f468-1f468-1f467",desc:"Man Man Girl"},{code:"1f468-1f468-1f467-1f466",desc:"Man Man Girl Boy"},{code:"1f468-1f468-1f466-1f466",desc:"Man Man Boy Boy"},{code:"1f469-1f469-1f466",desc:"Woman Woman Boy"},{code:"1f469-1f469-1f467",desc:"Woman Woman Girl"},{code:"1f469-1f469-1f467-1f466",desc:"Woman Woman Girl Boy"},{code:"1f469-1f469-1f467-1f467",desc:"Woman Woman Girl Girl"},{code:"1f4aa",desc:"Flexed Biceps"},{code:"1f448",desc:"White Left Pointing Backhand Index"},{code:"1f449",desc:"White Right Pointing Backhand Index"},{code:"1f446",desc:"White Up Pointing Backhand Index"},{code:"1f447",desc:"White Down Pointing Backhand Index"},{code:"270c",desc:"Victory Hand"},{code:"270b",desc:"Raised Hand"},{code:"1f44c",desc:"Ok Hand Sign"},{code:"1f44d",desc:"Thumbs Up Sign"},{code:"1f44e",desc:"Thumbs Down Sign"},{code:"270a",desc:"Raised Fist"},{code:"1f44a",desc:"Fisted Hand Sign"},{code:"1f44b",desc:"Waving Hand Sign"},{code:"1f44f",desc:"Clapping Hands Sign"},{code:"1f450",desc:"Open  Hands Sign"},{code:"1f64c",desc:"Person Raising Both Hands in Celebration"},{code:"1f64f",desc:"Person with Folded Hands"},{code:"1f485",desc:"Nail Polish"},{code:"1f442",desc:"Ear"},{code:"1f443",desc:"Nose"},{code:"1f463",desc:"Footprints"},{code:"1f440",desc:"Eyes"},{code:"1f445",desc:"Tongue"},{code:"1f444",desc:"Mouth"},{code:"1f48b",desc:"Kiss Mark"},{code:"1f498",desc:"Heart with Arrow"},{code:"2764",desc:"Heavy Black Heart"},{code:"1f493",desc:"Heavy Black Heart"},{code:"1f494",desc:"Broken Heart"},{code:"1f495",desc:"Two Hearts"},{code:"1f496",desc:"Sparkling Hearts"},{code:"1f497",desc:"Growing Hearts"},{code:"1f499",desc:"Blue Heart"},{code:"1f49a",desc:"Green Heart"},{code:"1f49b",desc:"Yellow Heart"},{code:"1f49c",desc:"Purple Heart"},{code:"1f49d",desc:"Heart with Ribbon"},{code:"1f49e",desc:"Revolving Hearts"},{code:"1f49f",desc:"Heart Decoration"},{code:"1f48c",desc:"Love Letter"},{code:"1f4a4",desc:"Sleeping Symbol"},{code:"1f4a2",desc:"Anger Symbol"},{code:"1f4a3",desc:"Bomb"},{code:"1f4a5",desc:"Collision Symbol"},{code:"1f4a6",desc:"Splashing Sweat Symbol"},{code:"1f4a8",desc:"Dash Symbol"},{code:"1f4ab",desc:"Dizzy Symbol"},{code:"1f4ab",desc:"Dizzy Symbol"},{code:"1f4ac",desc:"Speech Balloon"},{code:"1f4ad",desc:"Thought Balloon"},{code:"1f453",desc:"Eyeglasses"},{code:"1f454",desc:"Necktie"},{code:"1f455",desc:"T-Shirt"},{code:"1f456",desc:"Jeans"},{code:"1f457",desc:"Dress"},{code:"1f458",desc:"Kimono"},{code:"1f459",desc:"Bikini"},{code:"1f45a",desc:"Womans Clothes"},{code:"1f45b",desc:"Purse"},{code:"1f45c",desc:"Handbag"},{code:"1f45d",desc:"Pouch"},{code:"1f392",desc:"School Satchel"},{code:"1f45e",desc:"Mans Shoe"},{code:"1f45f",desc:"Athletic Shoe"},{code:"1f460",desc:"High-Heeled Shoe"},{code:"1f461",desc:"Womans Sandal"},{code:"1f462",desc:"Womans Boots"},{code:"1f451",desc:"Crown"},{code:"1f452",desc:"Womans Hat"},{code:"1f462",desc:"Top Hat"},{code:"1f393",desc:"Graduation Cap"},{code:"1f484",desc:"Lipstick"},{code:"1f48d",desc:"Ring"},{code:"1f48e",desc:"Gem Stone"}]},{id:"nature",name:"Animals & Nature",code:"1F435",emoticons:[{code:"1F435",desc:"Monkey Face"},{code:"1F412",desc:"Monkey"},{code:"1F436",desc:"Dog Face"},{code:"1F415",desc:"Dog"},{code:"1F429",desc:"Poodle"},{code:"1F43A",desc:"Wolf Face"},{code:"1F431",desc:"Cat Face"},{code:"1F408",desc:"Cat"},{code:"1F42F",desc:"Tiger Face"},{code:"1F405",desc:"Tiger"},{code:"1F406",desc:"Leopard"},{code:"1F434",desc:"Horse Face"},{code:"1F40E",desc:"Horse"},{code:"1F42E",desc:"Cow Face"},{code:"1F402",desc:"Ox"},{code:"1F403",desc:"Water Buffalo"},{code:"1F404",desc:"Cow"},{code:"1F437",desc:"Pig Face"},{code:"1F416",desc:"Pig"},{code:"1F417",desc:"Boar"},{code:"1F43D",desc:"Pig Nose"},{code:"1F40F",desc:"Ram"},{code:"1F411",desc:"Sheep"},{code:"1F410",desc:"Goat"},{code:"1F42A",desc:"Dromedary Camel"},{code:"1F42B",desc:"Bactrian Camel"},{code:"1F418",desc:"Elephant"},{code:"1F42D",desc:"Mouse Face"},{code:"1F401",desc:"Mouse"},{code:"1F400",desc:"Rat"},{code:"1F439",desc:"Hamster Face"},{code:"1F430",desc:"Rabbit Face"},{code:"1F407",desc:"Rabbit"},{code:"1F43B",desc:"Bear Face"},{code:"1F428",desc:"Koala"},{code:"1F43C",desc:"Panda Face"},{code:"1F43E",desc:"Paw Prints"},{code:"1F414",desc:"Chicken"},{code:"1F413",desc:"Rooster"},{code:"1F423",desc:"Hatching Chick"},{code:"1F424",desc:"Baby Chick"},{code:"1F425",desc:"Front-Facing Baby Chick"},{code:"1F426",desc:"Bird"},{code:"1F427",desc:"Penguin"},{code:"1F438",desc:"Frog Face"},{code:"1F40A",desc:"Crocodile"},{code:"1F422",desc:"Turtle"},{code:"1F40D",desc:"Snake"},{code:"1F432",desc:"Dragon Face"},{code:"1F409",desc:"Dragon"},{code:"1F433",desc:"Spouting Whale"},{code:"1F40B",desc:"Whale"},{code:"1F42C",desc:"Dolphin"},{code:"1F41F",desc:"Fish"},{code:"1F420",desc:"Tropical Fish"},{code:"1F421",desc:"Blowfish"},{code:"1F419",desc:"Octopus"},{code:"1F41A",desc:"Spiral Shell"},{code:"1F40C",desc:"Snail"},{code:"1F41B",desc:"Bug"},{code:"1F41C",desc:"Ant"},{code:"1F41D",desc:"Honeybee"},{code:"1F41E",desc:"Lady Beetle"},{code:"1F490",desc:"Bouquet"},{code:"1F338",desc:"Cherry Blossom"},{code:"1F4AE",desc:"White Flower"},{code:"1F339",desc:"Rose"},{code:"1F33A",desc:"Hibiscus"},{code:"1F33B",desc:"Sunflower"},{code:"1F33C",desc:"Blossom"},{code:"1F337",desc:"Tulip"},{code:"1F331",desc:"Seedling"},{code:"1F332",desc:"Evergreen Tree"},{code:"1F333",desc:"Deciduous Tree"},{code:"1F334",desc:"Palm Tree"},{code:"1F335",desc:"Cactus"},{code:"1F33E",desc:"Ear of Rice"},{code:"1F33F",desc:"Herb"},{code:"2618",desc:"Four Leaf Clover"},{code:"1F341",desc:"Maple Leaf"},{code:"1F342",desc:"Fallen Leaf"},{code:"1F343",desc:"Leaf Fluttering in Wind"}]},{id:"foods",name:"Food & Drink",code:"1F347",emoticons:[{code:"1F347",desc:"Grapes"},{code:"1F348",desc:"Melon"},{code:"1F349",desc:"Watermelon"},{code:"1F34A",desc:"Tangerine"},{code:"1F34B",desc:"Lemon"},{code:"1F34C",desc:"Banana"},{code:"1F34D",desc:"Pineapple"},{code:"1F34E",desc:"Red Apple"},{code:"1F34F",desc:"Green Apple"},{code:"1F350",desc:"Pear"},{code:"1F351",desc:"Peach"},{code:"1F352",desc:"Cherries"},{code:"1F353",desc:"Strawberry"},{code:"1F345",desc:"Tomato"},{code:"1F346",desc:"Aubergine"},{code:"1F33D",desc:"Ear of Maize"},{code:"1F344",desc:"Mushroom"},{code:"1F330",desc:"Chestnut"},{code:"1F35E",desc:"Bread"},{code:"1F356",desc:"Meat on Bone"},{code:"1F357",desc:"Poultry Leg"},{code:"1F354",desc:"Hamburger"},{code:"1F35F",desc:"French Fries"},{code:"1F355",desc:"Slice of Pizza"},{code:"1F373",desc:"Cooking"},{code:"1F372",desc:"Pot of Food"},{code:"1F371",desc:"Bento Box"},{code:"1F358",desc:"Rice Cracker"},{code:"1F359",desc:"Rice Ball"},{code:"1F35A",desc:"Cooked Rice"},{code:"1F35B",desc:"Curry and Rice"},{code:"1F35C",desc:"Steaming Bowl"},{code:"1F35D",desc:"Spaghetti"},{code:"1F360",desc:"Roasted Sweet Potato"},{code:"1F362",desc:"Oden"},{code:"1F363",desc:"Sushi"},{code:"1F364",desc:"Fried Shrimp"},{code:"1F365",desc:"Fish Cake with Swirl Design"},{code:"1F361",desc:"Dango"},{code:"1F366",desc:"Soft Ice Cream"},{code:"1F367",desc:"Shaved Ice"},{code:"1F368",desc:"Ice Cream"},{code:"1F369",desc:"Doughnut"},{code:"1F36A",desc:"Cookie"},{code:"1F382",desc:"Birthday Cake"},{code:"1F370",desc:"Shortcake"},{code:"1F36B",desc:"Chocolate Bar"},{code:"1F36C",desc:"Candy"},{code:"1F36D",desc:"Lollipop"},{code:"1F36E",desc:"Custard"},{code:"1F36F",desc:"Honey Pot"},{code:"1F37C",desc:"Baby Bottle"},{code:"2615",desc:"Hot Beverage"},{code:"1F375",desc:"Teacup Without Handle"},{code:"1F376",desc:"Sake Bottle and Cup"},{code:"1F377",desc:"Wine Glass"},{code:"1F378",desc:"Cocktail Glass"},{code:"1F379",desc:"Tropical Drink"},{code:"1F37A",desc:"Beer Mug"},{code:"1F37B",desc:"Clinking Beer Mugs"},{code:"1F374",desc:"Fork and Knife"},{code:"1F52A",desc:"Hocho"}]},{id:"activity",name:"Activities",code:"1f383",emoticons:[{code:"1f383",desc:" Jack-O-Lantern"},{code:"1f384",desc:"Christmas Tree"},{code:"1f386",desc:" Fireworks"},{code:"1f387",desc:"Firework Sparkler"},{code:"2728",desc:" Sparkles"},{code:"1f388",desc:"Balloon"},{code:"1f389",desc:"Party Popper"},{code:"1f38a",desc:"Confetti Ball"},{code:"1f38b",desc:"Tanabata Tree"},{code:"1f38d",desc:"Pine Decoration"},{code:"1f38e",desc:"Japanese Dolls"},{code:"1f38f",desc:"Carp Streamer"},{code:"1f390",desc:"Wind Chime"},{code:"1f391",desc:"Moon Viewing Ceremony"},{code:"1f380",desc:"Ribbon"},{code:"1f381",desc:"Wrapped Present"},{code:"1f3ab",desc:"Ticket"},{code:"1f3c6",desc:"Trophy"},{code:"1f388",desc:"Balloon"},{code:"26bd",desc:"Soccer Ball"},{code:"26be",desc:"Baseball"},{code:"1f3c0",desc:"Basketball and Hoop"},{code:"1f3c8",desc:"American Football"},{code:"1f3c9",desc:"Rugby Football"},{code:"1f3be",desc:"Tennis Racquet and Ball"},{code:"1f3b1",desc:"Billiards"},{code:"1f3b3",desc:"Bowling"},{code:"1f3af",desc:"Direct Hit"},{code:"26f3",desc:"Flag in Hole"},{code:"1f3a3",desc:"Fishing Pole and Fish"},{code:"1f3bd",desc:"Running Shirt with Sash"},{code:"1f3bf",desc:"Ski and Ski Boot"},{code:"1f3ae",desc:"Video Game"},{code:"1f3b2",desc:"Game Die"},{code:"2660",desc:"Black Spade Suit"},{code:"2665",desc:"Black Heart SuiT"},{code:"2666",desc:"Black Diamond Suit"},{code:"2663",desc:"Black Club Suit"},{code:"1f0cf",desc:"Playing Card Black Joker"},{code:"1f004",desc:"Mahjong Tile Red Dragon"},{code:"1f3b4",desc:"Flower Playing Cards"}]},{id:"places",name:"Travel & Places",code:"1f30d",emoticons:[{code:"1f30d",desc:"Earth Globe Europe-Africa"},{code:"1f30e",desc:"Earth Globe Americas"},{code:"1f30f",desc:"Earth Globe Asia-Australia"},{code:"1f310",desc:"Globe with Meridians"},{code:"1f5fe",desc:"Silhouette of Japan"},{code:"1f30b",desc:"Volcano"},{code:"1f5fb",desc:"Mount Fuji"},{code:"1f3e0",desc:"House Building"},{code:"1f3e1",desc:"House with Garden"},{code:"1f3e2",desc:"Office Building"},{code:"1f3e3",desc:"Japanese Post Office"},{code:"1f3e4",desc:"European Post Office"},{code:"1f3e5",desc:"Hospital"},{code:"1f3e6",desc:"Bank"},{code:"1f3e8",desc:"Hotel"},{code:"1f3e9",desc:"Love Hotel"},{code:"1f3ea",desc:"Convenience Store"},{code:"1f3eb",desc:"School"},{code:"1f3ec",desc:"Department Store"},{code:"1f3ed",desc:"Factory"},{code:"1f3ef",desc:"Japanese Castle"},{code:"1f3f0",desc:"European Castle"},{code:"1f492",desc:"Wedding"},{code:"1f5fc",desc:"Tokyo Tower"},{code:"1f5fd",desc:"Statue of Liberty"},{code:"26ea",desc:"Church"},{code:"26f2",desc:"Fountain"},{code:"26fa",desc:"Tent"},{code:"1f301",desc:"Foggy"},{code:"1f303",desc:"Night with Stars"},{code:"1f304",desc:"Sunrise over Mountains"},{code:"1f305",desc:"Sunrise"},{code:"1f306",desc:"Cityscape at Dusk"},{code:"1f307",desc:"Sunset over Buildings"},{code:"1f309",desc:"Bridge at Night"},{code:"2668",desc:"Hot Springs"},{code:"1f30c",desc:"Milky Way"},{code:"1f3a0",desc:"Carousel Horse"},{code:"1f3a1",desc:"Ferris Wheel"},{code:"1f3a2",desc:"Roller Coaster"},{code:"1f488",desc:"Barber Pole"},{code:"1f3aa",desc:"Circus Tent"},{code:"1f3ad",desc:"Performing Arts"},{code:"1f3a8",desc:"Artist Palette"},{code:"1f3b0",desc:"Slot Machine"},{code:"1f682",desc:"Steam Locomotive"},{code:"1f683",desc:"Railway Car"},{code:"1f684",desc:"High-Speed Train"},{code:"1f685",desc:"High-Speed Train with Bullet Nose"},{code:"1f686",desc:"Train"},{code:"1f687",desc:"Metro"},{code:"1f688",desc:"Light Rail"},{code:"1f689",desc:"Station"},{code:"1f68a",desc:"Tram"},{code:"1f69d",desc:"Monorail"},{code:"1f69e",desc:"Mountain Railway"},{code:"1f68b",desc:"Tram Car"},{code:"1f68c",desc:"Bus"},{code:"1f68d",desc:"Oncoming Bus"},{code:"1f68e",desc:"Trolleybus"},{code:"1f690",desc:"Minibus"},{code:"1f691",desc:"Ambulance"},{code:"1f692",desc:"Fire Engine"},{code:"1f693",desc:"Police Car"},{code:"1f694",desc:"Oncoming Police Car"},{code:"1f695",desc:"Taxi"},{code:"1f695",desc:"Oncoming Taxi"},{code:"1f697",desc:"Automobile"},{code:"1f698",desc:"Oncoming Automobile"},{code:"1f699",desc:"Recreational Vehicle"},{code:"1f69a",desc:"Delivery Truck"},{code:"1f69b",desc:"Articulated Lorry"},{code:"1f69c",desc:"Tractor"},{code:"1f6b2",desc:"Bicycle"},{code:"1f68f",desc:"Bus Stop"},{code:"26fd",desc:"Fuel Pump"},{code:"1f6a8",desc:"Police Cars Revolving Light"},{code:"1f6a5",desc:"Horizontal Traffic Light"},{code:"1f6a6",desc:"Vertical Traffic Light"},{code:"1f6a7",desc:"Construction Sign"},{code:"2693",desc:"Anchor"},{code:"26f5",desc:"Sailboat"},{code:"1f6a4",desc:"Speedboat"},{code:"1f6a2",desc:"Ship"},{code:"2708",desc:"Airplane"},{code:"1f4ba",desc:"Seat"},{code:"1f681",desc:"Helicopter"},{code:"1f69f",desc:"Suspension Railway"},{code:"1f6a0",desc:"Mountain Cableway"},{code:"1f6a1",desc:"Aerial Tramway"},{code:"1f680",desc:"Rocket"},{code:"1f6aa",desc:"Door"},{code:"1f6bd",desc:"Toilet"},{code:"1f6bf",desc:"Shower"},{code:"1f6c1",desc:"Bathtub"},{code:"231b",desc:"Hourglass"},{code:"23f3",desc:"Hourglass with Flowing Sand"},{code:"231a",desc:"Watch"},{code:"23f0",desc:"Alarm Clock"},{code:"1f55b",desc:"Clock Face Twelve Oclock"},{code:"1f567",desc:"Clock Face Twelve-Thirty"},{code:"1f550",desc:"Clock Face One Oclock"},{code:"1f55c",desc:"Clock Face One-thirty"},{code:"1f551",desc:"Clock Face Two Oclock"},{code:"1f55d",desc:"Clock Face Two-thirty"},{code:"1f552",desc:"Clock Face Three Oclock"},{code:"1f55e",desc:"Clock Face Three-thirty"},{code:"1f553",desc:"Clock Face Four Oclock"},{code:"1f55f",desc:"Clock Face Four-thirty"},{code:"1f554",desc:"Clock Face Five Oclock"},{code:"1f560",desc:"Clock Face Five-thirty"},{code:"1f555",desc:"Clock Face Six Oclock"},{code:"1f561",desc:"Clock Face Six-thirty"},{code:"1f556",desc:"Clock Face Seven Oclock"},{code:"1f562",desc:"Clock Face Seven-thirty"},{code:"1f557",desc:"Clock Face Eight Oclock"},{code:"1f563",desc:"Clock Face Eight-thirty"},{code:"1f558",desc:"Clock Face Nine Oclock"},{code:"1f564",desc:"Clock Face Nine-thirty"},{code:"1f559",desc:"Clock Face Ten Oclock"},{code:"1f565",desc:"Clock Face Ten-thirty"},{code:"1f55a",desc:"Clock Face Eleven Oclock"},{code:"1f566",desc:"Clock Face Eleven-thirty"},{code:"1f311",desc:"New Moon Symbol"},{code:"1f312",desc:"Waxing Crescent Moon Symbol"},{code:"1f313",desc:"First Quarter Moon Symbol"},{code:"1f314",desc:"Waxing Gibbous Moon Symbol"},{code:"1f315",desc:"Full Moon Symbol"},{code:"1f316",desc:"Waning Gibbous Moon Symbol"},{code:"1f317",desc:"Last Quarter Moon Symbol"},{code:"1f318",desc:"Waning Crescent Moon Symbol"},{code:"1f319",desc:"Crescent Moon"},{code:"1f31a",desc:"New Moon with Face"},{code:"1f31b",desc:"First Quarter Moon with Face"},{code:"1f31c",desc:"Last Quarter Moon with Face"},{code:"2600",desc:"Black Sun with Rays"},{code:"1f31d",desc:"Full Moon with Face"},{code:"1f31e",desc:"Sun with Face"},{code:"2b50",desc:"White Medium Star"},{code:"1f31f",desc:"Glowing Star"},{code:"1f320",desc:"Shooting Star"},{code:"2601",desc:"Cloud"},{code:"26c5",desc:"Sun Behind Cloud"},{code:"1f300",desc:"Cyclone"},{code:"1f308",desc:"Rainbow"},{code:"1f302",desc:"Closed Umbrella"},{code:"2614",desc:"Umbrella with Rain Drops"},{code:"26a1",desc:"High Voltage Sign"},{code:"2744",desc:"Snowflake"},{code:"2603",desc:"Snowman Without Snow"},{code:"1f525",desc:"Fire"},{code:"1f4a7",desc:"Droplet"},{code:"1F30A",desc:"Water Wave"}]},{id:"objects",name:"Objects",code:"1F507",emoticons:[{code:"1F507",desc:"Speaker with Cancellation Stroke"},{code:"1F508",desc:"Speaker"},{code:"1F509",desc:"Speaker with One Sound Wave"},{code:"1F50A",desc:"Speaker with Three Sound Wave"},{code:"1F4E2",desc:"Public Address Loudspeaker"},{code:"1F4E3",desc:"Cheering Megaphone"},{code:"1F4EF",desc:"Postal Horn"},{code:"1F514",desc:"Bell"},{code:"1F515",desc:"Bell with Cancellation Stroke"},{code:"1F3BC",desc:"Musical Score"},{code:"1F3B5",desc:"Musical Note"},{code:"1F3B6",desc:"Multiple Musical Notes"},{code:"1F3A4",desc:"Microphone"},{code:"1F3A7",desc:"Headphone"},{code:"1F4FB",desc:"Radio"},{code:"1F3B7",desc:"Saxophone"},{code:"1F3B8",desc:"Guitar"},{code:"1F3B9",desc:"Musical Keyboard"},{code:"1F3BA",desc:"Trumpet"},{code:"1F3BB",desc:"Violin"},{code:"1F4F1",desc:"Mobile Phone"},{code:"1F4F2",desc:"Mobile Phone with Rightwards Arrow at Left"},{code:"260E",desc:"Black Telephone"},{code:"1F4DE",desc:"Telephone Receiver"},{code:"1F4DF",desc:"Pager"},{code:"1F4E0",desc:"Fax Machine"},{code:"1F50B",desc:"Battery"},{code:"1F50C",desc:"Electric Plug"},{code:"1F4BB",desc:"Personal Computer"},{code:"1F4BD",desc:"Minidisc"},{code:"1F4BE",desc:"Floppy Disk"},{code:"1F4BF",desc:"Optical Disk"},{code:"1F4C0",desc:"Dvd"},{code:"1F3A5",desc:"Movie Camera"},{code:"1F3AC",desc:"Clapper Board"},{code:"1F4FA",desc:"Television"},{code:"1F4F7",desc:"Camera"},{code:"1F4F9",desc:"Video Camera"},{code:"1F4FC",desc:"Videocassette"},{code:"1F50D",desc:"Left-Pointing Magnifying Glass"},{code:"1F50E",desc:"Right-Pointing Magnifying Glass"},{code:"1F52C",desc:"Microscope"},{code:"1F52D",desc:"Telelscope"},{code:"1F4E1",desc:"Satellite Antenna"},{code:"1F4A1",desc:"Electric Light Bulb"},{code:"1F526",desc:"Electric Torch"},{code:"1F3EE",desc:"Izakaya Lantern"},{code:"1F4D4",desc:"Notebook with Decorative Cover"},{code:"1F4D5",desc:"Closed Book"},{code:"1F4D6",desc:"Open Book"},{code:"1F4D7",desc:"Green Book"},{code:"1F4D8",desc:"Blue Book"},{code:"1F4D9",desc:"Orange Book"},{code:"1F4DA",desc:"Books"},{code:"1F4D3",desc:"Notebook"},{code:"1F4D2",desc:"Ledger"},{code:"1F4C3",desc:"Curl"},{code:"1F4DC",desc:"Scroll"},{code:"1F4C4",desc:"Page Facing Up"},{code:"1F4F0",desc:"Newspaper"},{code:"1F4D1",desc:"Bookmark Tabs"},{code:"1F516",desc:"Bookmark"},{code:"1F4B0",desc:"Money Bag"},{code:"1F4B4",desc:"Banknote with Yen Sign"},{code:"1F4B5",desc:"Banknote with Dollar Sign"},{code:"1F4B6",desc:"Banknote with Euro Sign"},{code:"1F4B7",desc:"Banknote with Pound Sign"},{code:"1F4B8",desc:"Money with Wings"},{code:"1F4B3",desc:"Credit Card"},{code:"1F4B9",desc:"Chart with Upwards Trend and Yen Sign"},{code:"1F4B1",desc:"Currency Exchange"},{code:"1F4B2",desc:"Heavy Dollar Sign"},{code:"2709",desc:"Envelope"},{code:"1F4E7",desc:"E-Mail Symbol"},{code:"1F4E8",desc:"Incoming Envelope"},{code:"1F4E9",desc:"Envelope with Downwards Arrow Above"},{code:"1F4E4",desc:"Outbox Tray"},{code:"1F4E5",desc:"Inbox Tray"},{code:"1F4E6",desc:"Package"},{code:"1F4BE",desc:"Closed Mailbox with Raised Flag"},{code:"1F4EA",desc:"Closed Mailbox with Lowered Flag"},{code:"1F4EC",desc:"Open Mailbox with Raised Flag"},{code:"1F4ED",desc:"Open Mailbox with Lowered Flag"},{code:"1F5F3",desc:"Postbox"},{code:"270F",desc:"Pencil"},{code:"2712",desc:"Black Nib"},{code:"1F4DD",desc:"Memo"},{code:"1F4BC",desc:"Briefcase"},{code:"1F4C1",desc:"File Folder"},{code:"1F4C2",desc:"Open File Folder"},{code:"1F4C5",desc:"Calender"},{code:"1F4C6",desc:"Tear-off Calender"},{code:"1F4C7",desc:"Card Index"},{code:"1F4C8",desc:"Chart with Upwards Trend"},{code:"1F4C9",desc:"Chart with Downwards Trend"},{code:"1F4CA",desc:"Bar Chart"},{code:"1F4CB",desc:"Clipboard"},{code:"1F4CC",desc:"Pushpin"},{code:"1F4CD",desc:"Round Pushpin"},{code:"1F4CE",desc:"Paperclip"},{code:"1F4CF",desc:"Straight Ruler"},{code:"1F4D0",desc:"Triangular Ruler"},{code:"2702",desc:"Black Scissors"},{code:"1F512",desc:"Lock"},{code:"1F513",desc:"Open Lock"},{code:"1F50F",desc:"Lock with Ink Pen"},{code:"1F510",desc:"Closed Lock with Key"},{code:"1F511",desc:"Key"},{code:"1F528",desc:"Hammer"},{code:"1F52B",desc:"Pistol"},{code:"1F527",desc:"Wrench"},{code:"1F529",desc:"Nut and Bolt"},{code:"1F517",desc:"Link Symbol"},{code:"1F489",desc:"Syringe"},{code:"1F48A",desc:"Pill"},{code:"1F6AC",desc:"Smoking Symbol"},{code:"1F5FF",desc:"Moyai"},{code:"1F52E",desc:"Crystal Ball"}]},{id:"symbols",name:"Symbols",code:"1F3E7",emoticons:[{code:"1F3E7",desc:"Automated Teller Machine"},{code:"1F6AE",desc:"Put Litter in Its Place Symbol"},{code:"1F6B0",desc:"Potable Water Symbol"},{code:"267F",desc:"Wheelchair Symbol"},{code:"1F6B9",desc:"Mens Symbol"},{code:"1F6BA",desc:"Womens Symbol"},{code:"1F6BB",desc:"Restroom"},{code:"1F6BC",desc:"Baby Symbol"},{code:"1F6BE",desc:"Water Closet"},{code:"1F6C2",desc:"Passport Control"},{code:"1F6C3",desc:"Customs"},{code:"1F6C4",desc:"Baggage Claim"},{code:"1F6C5",desc:"Left Luggage"},{code:"26A0",desc:"Warning Sign"},{code:"1F6B8",desc:"Children Crossing"},{code:"26D4",desc:"No Entry"},{code:"1F6AB",desc:"No Entry Sign"},{code:"1F6B3",desc:"No Bicycles"},{code:"1F6AD",desc:"No Smoking Symbol"},{code:"1F6AF",desc:"Do Not Litter Symbol"},{code:"1F6B1",desc:"Non-Potable Water Symbol"},{code:"1F6B7",desc:"No Pedestrians"},{code:"1F4F5",desc:"No Mobile Phones"},{code:"1F51E",desc:"No One Under Eighteen Symbol"},{code:"2B06",desc:"Upwards Black Arrow"},{code:"2197",desc:"North East Arrow"},{code:"27A1",desc:"Black Rightwards Arrow"},{code:"2198",desc:"South East Arrow"},{code:"2B07",desc:"Downwards Black Arrow"},{code:"2199",desc:"South West Arrow"},{code:"2B05",desc:"Leftwards Black Arrow"},{code:"2196",desc:"North West Arrow"},{code:"2195",desc:"Up Down Arrow"},{code:"2194",desc:"Left Right Arrow"},{code:"21A9",desc:"Leftwards Arrow with Hook"},{code:"21AA",desc:"Rightwards Arrow with Hook"},{code:"2934",desc:"Arrow Pointing Rightwards Then Curving Upwards"},{code:"2935",desc:"Arrow Pointing Rightwards Then Curving Downwards"},{code:"1F503",desc:"Clockwise Downwards and Upwards Open Circle Arrows"},{code:"1F504",desc:"Anticlockwise Downwards and Upwards Open Circle Arrows"},{code:"1F519",desc:"Back with Leftwards Arrow Above"},{code:"1F51A",desc:"End with Leftwards Arrow Above"},{code:"1F51B",desc:"On with Exclamation Mark with Left Right Arrow Above"},{code:"1F51C",desc:"Soon with Rightwards Arrow Above"},{code:"1F51D",desc:"Top with Upwards Arrow Above"},{code:"1F52F",desc:"Six Pointed Star with Middle Dot"},{code:"2648",desc:"Aries"},{code:"2649",desc:"Taurus"},{code:"264A",desc:"Gemini"},{code:"264B",desc:"Cancer"},{code:"264C",desc:"Leo"},{code:"264D",desc:"Virgo"},{code:"264E",desc:"Libra"},{code:"264F",desc:"Scorpius"},{code:"2650",desc:"Sagittarius"},{code:"2651",desc:"Capricorn"},{code:"2652",desc:"Aquarius"},{code:"2653",desc:"Pisces"},{code:"26CE",desc:"Ophiuchus"},{code:"1F500",desc:"Twisted Rightwards Arrows"},{code:"1F501",desc:"Clockwise Rightwards and Leftwards Open Circle Arrows"},{code:"1F502",desc:"Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay"},{code:"25B6",desc:"Black Right-Pointing Triangle"},{code:"23E9",desc:"Black Right-Pointing Double Triangle"},{code:"25C0",desc:"Black Left-Pointing Triangle"},{code:"23EA",desc:"Black Left-Pointing Double Triangle"},{code:"1F53C",desc:"Up-Pointing Small Red Triangle"},{code:"23EB",desc:"Black Up-Pointing Double Triangle"},{code:"1F53D",desc:"Down-Pointing Small Red Triangle"},{code:"23EC",desc:"Black Down-Pointing Double Triangle"},{code:"1F3A6",desc:"Cinema"},{code:"1F505",desc:"Low Brightness Symbol"},{code:"1F506",desc:"High Brightness Symbol"},{code:"1F4F6",desc:"Antenna with Bars"},{code:"1F4F3",desc:"Vibration Mode"},{code:"1F4F4",desc:"Mobile Phone off"},{code:"267B",desc:"Black Universal Recycling Symbol"},{code:"1F531",desc:"Trident Emblem"},{code:"1F4DB",desc:"Name Badge"},{code:"1F530",desc:"Japanese Symbol for Beginner"},{code:"2B55",desc:"Heavy Large Circle"},{code:"2705",desc:"White Heavy Check Mark"},{code:"2611",desc:"Ballot Box with Check"},{code:"2714",desc:"Heavy Check Mark"},{code:"2716",desc:"Heavy Multiplication X"},{code:"274C",desc:"Cross Mark"},{code:"274E",desc:"Negative Squared Cross Mark"},{code:"2795",desc:"Heavy Plus Sign"},{code:"2796",desc:"Heavy Minus Sign"},{code:"2797",desc:"Heavy Division Sign"},{code:"27B0",desc:"Curly Loop"},{code:"27BF",desc:"Double Curly Loop"},{code:"303D",desc:"Part Alternation Mark"},{code:"2733",desc:"Eight Spoked Asterisk"},{code:"2734",desc:"Eight Pointed Black Star"},{code:"2747",desc:"Sparkle"},{code:"203C",desc:"Double Exclamation Mark"},{code:"2049",desc:"Exclamation Question Mark"},{code:"2753",desc:"Black Question Mark Ornament"},{code:"2754",desc:"White Question Mark Ornament"},{code:"2755",desc:"White Exclamation Mark Ornament"},{code:"2757",desc:"Heavy Exclamation Mark Symbol"},{code:"3030",desc:"Wavy Dash"},{code:"2122",desc:"Trade Mark Sign"},{code:"1F51F",desc:"Keycap Ten"},{code:"1F4AF",desc:"Hundred Points Symbol"},{code:"1F520",desc:"Input Symbol for Latin Capital Letters"},{code:"1F521",desc:"Input Symbol for Latin Small Letters"},{code:"1F522",desc:"Input Symbol for Numbers"},{code:"1F523",desc:"Input Symbol for Symbols"},{code:"1F524",desc:"Input Symbol for Latin Letters"},{code:"1F170",desc:"Negative Squared Latin Capital Letter a"},{code:"1F18E",desc:"Negative Squared Ab"},{code:"1F171",desc:"Negative Squared Latin Capital Letter B"},{code:"1F191",desc:"Squared Cl"},{code:"1F192",desc:"Squared Cool"},{code:"1F193",desc:"Squared Free"},{code:"2139",desc:"Information Source"},{code:"1F194",desc:"Squared Id"},{code:"24C2",desc:"Circled Latin Capital Letter M"},{code:"1F195",desc:"Squared New"},{code:"1F196",desc:"Squared Ng"},{code:"1F17E",desc:"Negative Squared Latin Capital Letter O"},{code:"1F197",desc:"Squared Ok"},{code:"1F17F",desc:"Negative Squared Latin Capital Letter P"},{code:"1F198",desc:"Squared Sos"},{code:"1F199",desc:"Squared Up with Exclamation Mark"},{code:"1F19A",desc:"Squared Vs"},{code:"1F201",desc:"Squared Katakana Koko"},{code:"1F202",desc:"Squared Katakana Sa"},{code:"1F237",desc:"Squared Cjk Unified Ideograph-6708"},{code:"1F236",desc:"Squared Cjk Unified Ideograph-6709"},{code:"1F22F",desc:"Squared Cjk Unified Ideograph-6307"},{code:"1F250",desc:"Circled Ideograph Advantage"},{code:"1F239",desc:"Squared Cjk Unified Ideograph-5272"},{code:"1F21A",desc:"Squared Cjk Unified Ideograph-7121"},{code:"1F232",desc:"Squared Cjk Unified Ideograph-7981"},{code:"1F251",desc:"Circled Ideograph Accept"},{code:"1F238",desc:"Squared Cjk Unified Ideograph-7533"},{code:"1F234",desc:"Squared Cjk Unified Ideograph-5408"},{code:"1F233",desc:"Squared Cjk Unified Ideograph-7a7a"},{code:"3297",desc:"Circled Ideograph Congratulation"},{code:"3299",desc:"Circled Ideograph Secret"},{code:"1F23A",desc:"Squared Cjk Unified Ideograph-55b6"},{code:"1F235",desc:"Squared Cjk Unified Ideograph-6e80"},{code:"25AA",desc:"Black Small Square"},{code:"25AB",desc:"White Small Square"},{code:"25FB",desc:"White Medium Square"},{code:"25FC",desc:"Black Medium Square"},{code:"25FD",desc:"White Medium Small Square"},{code:"25FE",desc:"Black Medium Small Square"},{code:"2B1B",desc:"Black Large Square"},{code:"2B1C",desc:"White Large Square"},{code:"1F536",desc:"Large Orange Diamond"},{code:"1F537",desc:"Large Blue Diamond"},{code:"1F538",desc:"Small Orange Diamond"},{code:"1F539",desc:"Small Blue Diamond"},{code:"1F53A",desc:"Up-Pointing Red Triangle"},{code:"1F53B",desc:"Down-Pointing Red Triangle"},{code:"1F4A0",desc:"Diamond Shape with a Dot Inside"},{code:"1F518",desc:"Radio Button"},{code:"1F532",desc:"Black Square Button"},{code:"1F533",desc:"White Square Button"},{code:"26AA",desc:"Medium White Circle"},{code:"26AB",desc:"Medium Black Circle"},{code:"1F534",desc:"Large Red Circle"},{code:"1F535",desc:"Large Blue Circle"}]},{id:"flags",name:"Flags",code:"1F3C1",emoticons:[{code:"1f3c1",desc:"Chequered Flag"},{code:"1f1e8-1f1f3",desc:"China Flag"},{code:"1f38c",desc:"Crossed Flags"},{code:"1f1e9-1f1ea",desc:"Germany Flag"},{code:"1f1ea-1f1f8",desc:"Spain Flag"},{code:"1f1e6-1f1e8",desc:"Ascension Island Flag"},{code:"1f1e6-1f1e9",desc:"Andorra Flag"},{code:"1f1e6-1f1ea",desc:"United Arab Emirates Flag"},{code:"1f1e6-1f1eb",desc:"Afghanistan Flag"},{code:"1f1e6-1f1ec",desc:"Antigua & Barbuda Flag"},{code:"1f1e6-1f1ee",desc:"Anguilla Flag"},{code:"1f1e6-1f1f1",desc:"Albania Flag"},{code:"1f1e6-1f1f2",desc:"Armenia Flag"},{code:"1f1e6-1f1f4",desc:"Angola Flag"},{code:"1f1e6-1f1f6",desc:"Antarctica Flag"},{code:"1f1e6-1f1f7",desc:"Argentina Flag"},{code:"1f1e6-1f1f8",desc:"American Samoa Flag"},{code:"1f1e6-1f1f9",desc:"Austria Flag"},{code:"1f1e6-1f1fa",desc:"Australia Flag"},{code:"1f1e6-1f1fc",desc:"Aruba Flag"},{code:"1f1e6-1f1fd",desc:"\xc5land Islands Flag"},{code:"1f1e6-1f1ff",desc:"Azerbaijan Flag"},{code:"1f1e7-1f1e7",desc:"Barbados Flag"},{code:"1f1e7-1f1e9",desc:"Bangladesh Flag"},{code:"1f1e7-1f1ea",desc:"Belgium Flag"},{code:"1f1e7-1f1eb",desc:"Burkina Faso Flag"},{code:"1f1e7-1f1ec",desc:"Bulgaria Flag"},{code:"1f1e7-1f1ed",desc:"Bahrain Flag"},{code:"1f1e7-1f1ee",desc:"Burundi Flag"},{code:"1f1e7-1f1ef",desc:"Benin Flag"},{code:"1f1e7-1f1f1",desc:"St. Barth\xe9lemy Flag"},{code:"1f1e7-1f1f2",desc:"Bermuda Flag"},{code:"1f1e7-1f1f4",desc:"Bolivia Flag"},{code:"1f1e7-1f1f6",desc:"Caribbean Netherlands Flag"},{code:"1f1e7-1f1f7",desc:"Brazil Flag"},{code:"1f1e7-1f1f8",desc:"Bahamas Flag"},{code:"1f1e7-1f1f9",desc:"Bhutan Flag"},{code:"1f1e7-1f1fb",desc:"Bouvet Island Flag"},{code:"1f1e7-1f1fc",desc:"Botswana Flag"},{code:"1f1e7-1f1fe",desc:"Belarus Flag"},{code:"1f1e7-1f1ff",desc:"Belize Flag"},{code:"1f1e8-1f1e6",desc:"Canada Flag"},{code:"1f1e8-1f1e8",desc:"Cocos (keeling) Islands Flag"},{code:"1f1e8-1f1e9",desc:"Congo - Kinshasa Flag"},{code:"1f1e8-1f1eb",desc:"Central African Republic Flag"},{code:"1f1e8-1f1ec",desc:"Congo - Brazzaville Flag"},{code:"1f1e8-1f1ed",desc:"Switzerland Flag"},{code:"1f1e8-1f1ee",desc:"C\xf4te D\u2019ivoire Flag"},{code:"1f1e8-1f1f0",desc:"Cook Islands Flag"},{code:"1f1e8-1f1f1",desc:"Chile Flag"},{code:"1f1e8-1f1f2",desc:"Cameroon Flag"},{code:"1f1e8-1f1f4",desc:"Colombia Flag"},{code:"1f1e8-1f1f7",desc:"Costa Rica Flag"},{code:"1f1e8-1f1fa",desc:"Cuba Flag"},{code:"1f1e8-1f1fb",desc:"Cape Verde Flag"},{code:"1f1e8-1f1fc",desc:"Cura\xe7ao Flag"},{code:"1f1e8-1f1fd",desc:"Christmas Island Flag"},{code:"1f1e8-1f1fe",desc:"Cyprus Flag"},{code:"1f1e8-1f1ff",desc:'Czechia Flag"'},{code:"1f1e9-1f1ec",desc:"Diego Garcia Flag"},{code:"1f1e9-1f1ef",desc:"Djibouti Flag"},{code:"1f1e9-1f1f0",desc:"Denmark Flag"},{code:"1f1e9-1f1f2",desc:"Dominica Flag"},{code:"1f1e9-1f1f4",desc:"Dominican Republic Flag"},{code:"1f1e9-1f1ff",desc:"Algeria Flag"},{code:"1f1ea-1f1e6",desc:"Ceuta & Melilla Flag"},{code:"1f1ea-1f1e8",desc:"Ecuador Flag"},{code:"1f1ea-1f1ea",desc:"Estonia Flag"},{code:"1f1ea-1f1ec",desc:"Egypt Flag"},{code:"1f1ea-1f1ed",desc:"Western Sahara Flag"},{code:"1f1ea-1f1f7",desc:"Eritrea Flag"},{code:"1f1ea-1f1f9",desc:"Ethiopia Flag"},{code:"1f1ea-1f1fa",desc:"European Union Flag"},{code:"1f1eb-1f1ee",desc:"Finland Flag"},{code:"1f1eb-1f1ef",desc:"Fiji Flag"},{code:"1f1eb-1f1f0",desc:"Falkland Islands Flag"},{code:"1f1eb-1f1f2",desc:"Micronesia Flag"},{code:"1f1eb-1f1f4",desc:"Faroe Islands Flag"},{code:"1f1ec-1f1e6",desc:"Gabon Flag"},{code:"1f1ec-1f1e9",desc:"Grenada Flag"},{code:"1f1ec-1f1ea",desc:"Georgia Flag"},{code:"1f1ec-1f1eb",desc:"French Guiana Flag"},{code:"1f1ec-1f1ec",desc:"Guernsey Flag"},{code:"1f1ec-1f1ed",desc:"Ghana Flag"},{code:"1f1ec-1f1ee",desc:"Gibraltar Flag"},{code:"1f1ec-1f1f1",desc:"Greenland Flag"},{code:"1f1ec-1f1f2",desc:"Gambia Flag"},{code:"1f1ec-1f1f3",desc:"Guinea Flag"},{code:"1f1ec-1f1f5",desc:"Guadeloupe Flag"},{code:"1f1ec-1f1f6",desc:"Equatorial Guinea Flag"},{code:"1f1ec-1f1f7",desc:"Greece Flag"},{code:"1f1ec-1f1f8",desc:"South Georgia & South Sandwich Islands Flag"},{code:"1f1ec-1f1f9",desc:"Guatemala Flag"},{code:"1f1ec-1f1fa",desc:"Guam Flag"},{code:"1f1ec-1f1fc",desc:"Guinea-Bissau Flag"},{code:"1f1ec-1f1fe",desc:"Guyana Flag"},{code:"1f1ed-1f1f0",desc:"Hong Kong Sar China Flag"},{code:"1f1ed-1f1f2",desc:"Heard & Mcdonald Islands Flag"},{code:"1f1ed-1f1f3",desc:"Honduras Flag"},{code:"1f1ed-1f1f7",desc:"Croatia Flag"},{code:"1f1ed-1f1f9",desc:"Haiti Flag"},{code:"1f1ed-1f1fa",desc:"Hungary Flag"},{code:"1f1ee-1f1e8",desc:"Canary Islands Flag"},{code:"1f1ee-1f1e9",desc:"Indonesia Flag"},{code:"1f1ee-1f1ea",desc:"Ireland Flag"},{code:"1f1ee-1f1f1",desc:"Israel Flag"},{code:"1f1ee-1f1f2",desc:"Isle of Man Flag"},{code:"1f1ee-1f1f3",desc:"India Flag"},{code:"1f1ee-1f1f4",desc:"British Indian Ocean Territory Flag"},{code:"1f1ee-1f1f6",desc:"Iraq Flag"},{code:"1f1ee-1f1f7",desc:"Iran Flag"},{code:"1f1ee-1f1f8",desc:"Iceland Flag"},{code:"1f1ef-1f1ea",desc:"Jersey Flag"},{code:"1f1ef-1f1f2",desc:"Jamaica Flag"},{code:"1f1ef-1f1f4",desc:"Jordan Flag"},{code:"1f1f0-1f1ea",desc:"Kenya Flag"},{code:"1f1f0-1f1ec",desc:"Kyrgyzstan Flag"},{code:"1f1f0-1f1ed",desc:"Cambodia Flag"},{code:"1f1f0-1f1ee",desc:"Kiribati Flag"},{code:"1f1f0-1f1f2",desc:"Comoros Flag"},{code:"1f1f0-1f1f3",desc:"St. Kitts & Nevis Flag"},{code:"1f1f0-1f1f5",desc:"North Korea Flag"},{code:"1f1f0-1f1fc",desc:"Kuwait Flag"},{code:"1f1f0-1f1fe",desc:"Cayman Islands Flag"},{code:"1f1f0-1f1ff",desc:"Kazakhstan Flag"},{code:"1f1f1-1f1e6",desc:"Laos Flag"},{code:"1f1f1-1f1e7",desc:"Lebanon Flag"},{code:"1f1f1-1f1e8",desc:"St. Lucia Flag"},{code:"1f1f1-1f1ee",desc:"Liechtenstein Flag"},{code:"1f1f1-1f1f0",desc:"Sri Lanka Flag"},{code:"1f1f1-1f1f7",desc:"Liberia Flag"},{code:"1f1f1-1f1f8",desc:"Lesotho Flag"},{code:"1f1f1-1f1f9",desc:"Lithuania Flag"},{code:"1f1f1-1f1fa",desc:"Luxembourg Flag"},{code:"1f1f1-1f1fb",desc:"Latvia Flag"},{code:"1f1f1-1f1fe",desc:"Libya Flag"},{code:"1f1f2-1f1e6",desc:"Morocco Flag"},{code:"1f1f2-1f1e8",desc:"Monaco Flag"},{code:"1f1f2-1f1e9",desc:"Moldova Flag"},{code:"1f1f2-1f1ea",desc:"Montenegro Flag"},{code:"1f1f2-1f1eb",desc:"St. Martin Flag"},{code:"1f1f2-1f1ec",desc:"Madagascar Flag"},{code:"1f1f2-1f1ed",desc:"Marshall Islands Flag"},{code:"1f1f2-1f1f0",desc:"Macedonia Flag"},{code:"1f1f2-1f1f1",desc:"Mali Flag"},{code:"1f1f2-1f1f2",desc:"Myanmar (burma) Flag"},{code:"1f1f2-1f1f3",desc:"Mongolia Flag"},{code:"1f1f2-1f1f4",desc:"Macau Sar China Flag"},{code:"1f1f2-1f1f5",desc:"Northern Mariana Islands Flag"},{code:"1f1f2-1f1f6",desc:"Martinique Flag"},{code:"1f1f2-1f1f7",desc:"Mauritania Flag"},{code:"1f1f2-1f1f8",desc:"Montserrat Flag"},{code:"1f1f2-1f1f9",desc:"Malta Flag"},{code:"1f1f2-1f1fa",desc:"Mauritius Flag"},{code:"1f1f2-1f1fb",desc:"Maldives Flag"},{code:"1f1f2-1f1fc",desc:"Malawi Flag"},{code:"1f1f2-1f1fd",desc:"Mexico Flag"},{code:"1f1f2-1f1fe",desc:"Malaysia Flag"},{code:"1f1f2-1f1ff",desc:"Mozambique Flag"},{code:"1f1f3-1f1e6",desc:"Namibia Flag"},{code:"1f1f3-1f1e8",desc:"New Caledonia Flag"},{code:"1f1f3-1f1ea",desc:"Niger Flag"},{code:"1f1f3-1f1eb",desc:"Norfolk Island Flag"},{code:"1f1f3-1f1ec",desc:"Nigeria Flag"},{code:"1f1f3-1f1ee",desc:"Nicaragua Flag"},{code:"1f1f3-1f1f1",desc:"Netherlands Flag"},{code:"1f1f3-1f1f4",desc:"Norway Flag"},{code:"1f1f3-1f1f5",desc:"Nepal Flag"},{code:"1f1f3-1f1f7",desc:"Nauru Flag"},{code:"1f1f3-1f1fa",desc:"Niue Flag"},{code:"1f1f3-1f1ff",desc:"New Zealand Flag"},{code:"1f1f4-1f1f2",desc:"Oman Flag"},{code:"1f1f8-1f1ff",desc:"Swaziland Flag"},{code:"1f1f5-1f1e6",desc:"Panama Flag"},{code:"1f1f5-1f1ea",desc:"Peru Flag"},{code:"1f1f5-1f1eb",desc:"French Polynesia Flag"},{code:"1f1f5-1f1ec",desc:"Papua New Guinea Flag"},{code:"1f1f5-1f1ed",desc:"Philippines Flag"},{code:"1f1f5-1f1f0",desc:"Pakistan Flag"},{code:"1f1f5-1f1f1",desc:"Poland Flag"},{code:"1f1f5-1f1f2",desc:"St. Pierre & Miquelon  Flag"},{code:"1f1f5-1f1f3",desc:"Pitcairn Islands Flag"},{code:"1f1f5-1f1f7",desc:"Puerto Rico Flag"},{code:"1f1f5-1f1f8",desc:"Palestinian Territories Flag"},{code:"1f1f5-1f1f9",desc:"Portugal Flag"},{code:"1f1f5-1f1fc",desc:"Palau Flag"},{code:"1f1f5-1f1fe",desc:"Paraguay Flag"},{code:"1f1f6-1f1e6",desc:"Qatar Flag"},{code:"1f1f7-1f1ea",desc:"R\xe9union Flag"},{code:"1f1f7-1f1f4",desc:"Romania Flag"},{code:"1f1f7-1f1f8",desc:"Serbia Flag"},{code:"1f1f7-1f1fc",desc:"Rwanda Flag"},{code:"1f1f8-1f1e6",desc:"Saudi Arabia Flag"},{code:"1f1f8-1f1e7",desc:"Solomon Islands Flag"},{code:"1f1f8-1f1e8",desc:"Seychelles Flag"},{code:"1f1f8-1f1e9",desc:"Sudan Flag"},{code:"1f1f8-1f1ea",desc:"Sweden Flag"},{code:"1f1f8-1f1ec",desc:"Singapore Flag"},{code:"1f1f8-1f1ee",desc:"Slovenia Flag"},{code:"1f1f8-1f1ed",desc:"St. Helena  Flag"},{code:"1f1f8-1f1ef",desc:"Svalbard & Jan Mayen  Flag"},{code:"1f1f8-1f1f1",desc:"Sierra Leone Flag"},{code:"1f1f8-1f1f2",desc:"San Marino Flag"},{code:"1f1f8-1f1f3",desc:"Senegal Flag"},{code:"1f1f8-1f1f4",desc:"Somalia Flag"},{code:"1f1f8-1f1f7",desc:"Suriname Flag"},{code:"1f1f8-1f1f8",desc:"South Sudan  Flag"},{code:"1f1f8-1f1f9",desc:"S\xe3o Tom\xe9 & Pr\xedncipe Flag"},{code:"1f1f8-1f1fb",desc:"El Salvador Flag"},{code:"1f1f8-1f1fd",desc:"Sint Maarten Flag"},{code:"1f1f8-1f1fe",desc:"Syria Flag"},{code:"1f1f9-1f1e6",desc:"Tristan Da Cunha Flag"},{code:"1f1f9-1f1e8",desc:"Turks & Caicos Islands  Flag"},{code:"1f1f9-1f1eb",desc:"French Southern Territories Flag"},{code:"1f1f9-1f1ec",desc:"Togo Flag"},{code:"1f1f9-1f1ed",desc:"Thailand Flag"},{code:"1f1f9-1f1ef",desc:"Tajikistan Flag"},{code:"1f1f9-1f1f0",desc:"Tokelau Flag"},{code:"1f1f9-1f1f1",desc:"Timor-Leste Flag"},{code:"1f1f9-1f1f2",desc:"Turkmenistan Flag"},{code:"1f1f9-1f1f3",desc:"Tunisia Flag"},{code:"1f1f9-1f1f4",desc:"Tonga Flag"},{code:"1f1f9-1f1f7",desc:"Turkey Flag"},{code:"1f1f9-1f1f9",desc:"Trinidad & Tobago Flag"},{code:"1f1f9-1f1fb",desc:"Tuvalu Flag"},{code:"1f1f9-1f1fc",desc:"Taiwan Flag"},{code:"1f1f9-1f1ff",desc:"Tanzania Flag"},{code:"1f1fa-1f1e6",desc:"Ukraine City  Flag"},{code:"1f1fa-1f1ec",desc:"Uganda Flag"},{code:"1f1fa-1f1f2",desc:"U.s. Outlying Islands  Flag"},{code:"1f1fa-1f1fe",desc:"Uruguay  Flag"},{code:"1f1fa-1f1ff",desc:"Uzbekistan Flag"},{code:"1f1fb-1f1e6",desc:"Vatican City  Flag"},{code:"1f1fb-1f1e8",desc:"St. Vincent & Grenadines Flag"},{code:"1f1fb-1f1ea",desc:"Venezuela Flag"},{code:"1f1fb-1f1ec",desc:"British Virgin Islands Flag"},{code:"1f1fb-1f1ee",desc:"U.s. Virgin Islands Flag"},{code:"1f1fb-1f1f3",desc:"Vietnam Flag"},{code:"1f1fc-1f1f8",desc:"Samoa Flag"},{code:"1f1fb-1f1fa",desc:"Vanuatu Flag"},{code:"1f1fc-1f1eb",desc:'"Wallis & Futuna Flag'},{code:"1f1fd-1f1f0",desc:"Kosovo Flag"},{code:"1f1fe-1f1ea",desc:"Yemen Flag"},{code:"1f1fe-1f1f9",desc:"Mayotte Flag"},{code:"1f1ff-1f1e6",desc:"South Africa Flag"},{code:"1f1ff-1f1f2",desc:"Zambia Flag"},{code:"1f1ff-1f1fc",desc:"Zimbabwe Flag"},{code:"1f1eb-1f1f7",desc:"France Flag"},{code:"1f1ec-1f1e7",desc:"United Kingdom  Flag"},{code:"1f1ee-1f1f9",desc:"Italy Flag"},{code:"1f1ef-1f1f5",desc:"Japan Flag"},{code:"1f1f0-1f1f7",desc:"South Korea Flag"},{code:"1f1f7-1f1fa",desc:"Russia Flag"},{code:"1F6A9",desc:"Triangular Flag on Post"},{code:"1f1fa-1f1f8",desc:"United States Flag"}]}],emoticonsButtons:["emoticonsBack","|"],emoticonsUseImage:!0}),B.PLUGINS.emoticons=function(p){var b=p.$,a=p.opts.emoticonsSet,s=a&&a[0],f="";function i(){if(!p.selection.isCollapsed())return!1;var e=p.selection.element(),c=p.selection.endElement();if(e&&p.node.hasClass(e,"fr-emoticon"))return e;if(c&&p.node.hasClass(c,"fr-emoticon"))return c;var d=p.selection.ranges(0),o=d.startContainer;if(o.nodeType==Node.ELEMENT_NODE&&0<o.childNodes.length&&0<d.startOffset){var a=o.childNodes[d.startOffset-1];if(p.node.hasClass(a,"fr-emoticon"))return a}return!1}function n(){return"".concat(function o(e,c){return'<div class="fr-buttons fr-tabs fr-tabs-scroll">\n                        '.concat(function d(e,o){var a="";return e.forEach(function(e){var c={image:e.code.toLowerCase()},d={elementClass:e.id===o.id?"fr-active fr-active-tab":"",emoticonsUnicodeClass:p.opts.emoticonsUseImage?"":"fr-tabs-unicode",title:p.language.translate(e.name),dataCmd:"setEmoticonCategory",dataParam1:e.id,image:p.opts.emoticonsUseImage?'<img src="https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/'.concat(c.image,'.svg"/>'):"&#x".concat(c.image,";")};a+='<button class="fr-command fr-btn '.concat(d.elementClass," ").concat(d.emoticonsUnicodeClass,'" \n      title="').concat(d.title,'" data-cmd="').concat(d.dataCmd,'" data-param1="').concat(d.dataParam1,'">\n       ').concat(d.image," </button>")}),a}(e,c),"\n                        </div>")}(a,s),"\n                      ").concat(function d(e){return'\n        <div class="fr-icon-container fr-emoticon-container">\n            '.concat(function c(e){var a="";return e.emoticons.forEach(function(e){var c=e.code.split("-").reduce(function(e,c){return e?"".concat(e,"&zwj;&#x").concat(c.toLowerCase(),";"):"&#x".concat(c.toLowerCase(),";")},""),d={image:e.code.toLowerCase(),compiledCode:e.uCode?e.uCode:c},o={dataParam1:e.code.toLowerCase(),dataParam2:d.compiledCode,title:p.language.translate(e.desc),image:p.opts.emoticonsUseImage?'<img src="https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/'.concat(d.image,'.svg"/>'):"".concat(d.compiledCode),desc:p.language.translate(e.desc)};a+='<span class="fr-command fr-emoticon fr-icon" role="button" \n      data-cmd="insertEmoticon" data-param1="'.concat(o.dataParam1,'" tabindex="0"\n      data-param2="').concat(o.dataParam2,'"  title="').concat(o.title,'" >\n      ').concat(o.image,'<span class="fr-sr-only">').concat(o.desc,"&nbsp;&nbsp;&nbsp;</span></span>")}),a}(e),"\n        </div>\n        ")}(s),"\n                      ").concat(function e(){return p.opts.emoticonsUseImage?'<p style="font-size: 12px; text-align: center; padding: 0 5px;">Emoji free by <a class="fr-link" tabIndex="-1" href="http://emojione.com/" target="_blank" rel="nofollow noopener noreferrer" role="link" aria-label="Open Emoji One website.">Emoji One</a></p>':""}())}return{_init:function e(){var d=function d(){for(var e=p.el.querySelectorAll(".fr-emoticon:not(.fr-deletable)"),c=0;c<e.length;c++)e[c].className+=" fr-deletable"};d(),p.events.on("html.set",d),p.events.on("keydown",function(e){if(p.keys.isCharacter(e.which)&&p.selection.inEditor()){var c=p.selection.ranges(0),d=i();p.node.hasClass(d,"fr-emoticon-img")&&d&&(0===c.startOffset&&p.selection.element()===d?b(d).before(B.MARKERS+B.INVISIBLE_SPACE):b(d).after(B.INVISIBLE_SPACE+B.MARKERS),p.selection.restore())}}),p.events.on("keyup",function(e){for(var c=p.el.querySelectorAll(".fr-emoticon"),d=0;d<c.length;d++)"undefined"!=typeof c[d].textContent&&0===c[d].textContent.replace(/\u200B/gi,"").length&&b(c[d]).remove();if(!(e.which>=B.KEYCODE.ARROW_LEFT&&e.which<=B.KEYCODE.ARROW_DOWN)){var o=i();p.node.hasClass(o,"fr-emoticon-img")&&(b(o).append(B.MARKERS),p.selection.restore())}})},insert:function t(e,c){var d=i(),o=p.selection.ranges(0);d?(0===o.startOffset&&p.selection.element()===d?b(d).before(B.MARKERS+B.INVISIBLE_SPACE):0<o.startOffset&&p.selection.element()===d&&o.commonAncestorContainer.parentNode.classList.contains("fr-emoticon")&&b(d).after(B.INVISIBLE_SPACE+B.MARKERS),p.selection.restore(),p.html.insert('<span class="fr-emoticon fr-deletable'.concat(c?" fr-emoticon-img":"",'"').concat(c?' style="background: url('.concat(c,');"'):"",">").concat(c?"&nbsp;":e,"</span>&nbsp;").concat(B.MARKERS),!0)):p.html.insert('<span class="fr-emoticon fr-deletable'.concat(c?" fr-emoticon-img":"",'"').concat(c?' style="background: url('.concat(c,');"'):"",">").concat(c?"&nbsp;":e,"</span>").concat(B.INVISIBLE_SPACE),!0)},setEmoticonCategory:function o(c){s=a.filter(function(e){return e.id===c})[0],function d(){p.popups.get("emoticons").html(f+n());var e=p.popups.get("emoticons").children().not(".fr-buttons");p.accessibility.registerPopup("emoticons"),p.accessibility.focusContent(e)}()},showEmoticonsPopup:function l(){var e=p.popups.get("emoticons");if(e||(e=function s(){p.opts.toolbarInline&&0<p.opts.emoticonsButtons.length&&(f='<div class="fr-buttons fr-emoticons-buttons fr-tabs">'.concat(p.button.buildList(p.opts.emoticonsButtons),"</div>"));var e={buttons:f,custom_layer:n()},c=p.popups.create("emoticons",e);return function d(S){p.events.on("popup.tab",function(e){var c=b(e.currentTarget);if(!p.popups.isVisible("emoticons")||!c.is("span, a"))return!0;var d,o,a,s=e.which,f=window.getComputedStyle(S.find(".fr-icon-container")[0]),i=f.getPropertyValue("grid-template-columns").split(" ").length;if(B.KEYCODE.TAB==s){var n=S.find("span.fr-emoticon");if(c.is(n.first())&&e.shiftKey||c.is("a")&&!e.shiftKey){var t=S.find(".fr-buttons");d=!p.accessibility.focusToolbar(t,!!e.shiftKey)}if(!1!==d){var l=S.find("span.fr-emoticon");l.add(S.find("a.fr-link")),l.add(S.find("button.fr-btn")),o=l.index(c),o=e.shiftKey?((o-1)%l.length+l.length)%l.length:(o+1)%l.length,a=l.get(o),p.events.disableBlur(),a.focus(),d=!1}}else if(B.KEYCODE.ARROW_UP==s||B.KEYCODE.ARROW_DOWN==s||B.KEYCODE.ARROW_LEFT==s||B.KEYCODE.ARROW_RIGHT==s){if(c.is("span.fr-emoticon")){var r=c.parent().find("span.fr-emoticon");o=r.index(c);var F=i,g=Math.ceil(r.length/F),u=o%F,h=Math.floor(o/F),m=h*F+u,C=g*F;B.KEYCODE.ARROW_UP==s?m=((m-F)%C+C)%C:B.KEYCODE.ARROW_DOWN==s?m=(m+F)%C:B.KEYCODE.ARROW_LEFT==s?m=((m-1)%C+C)%C:B.KEYCODE.ARROW_RIGHT==s&&(m=(m+1)%C),a=b(r.get(m)),p.events.disableBlur(),a.focus(),d=!1}}else B.KEYCODE.ENTER==s&&(c.is("a")?c[0].click():p.button.exec(c),d=!1);return!1===d&&(e.preventDefault(),e.stopPropagation()),d},!0)}(c),c}()),!e.hasClass("fr-active")){p.popups.refresh("emoticons"),p.popups.setContainer("emoticons",p.$tb);var c=p.$tb.find('.fr-command[data-cmd="emoticons"]'),d=p.button.getPosition(c),o=d.left,a=d.top;p.popups.show("emoticons",o,a,c.outerHeight()),p.popups.get("emoticons").css("overflow","hidden")}},back:function c(){p.popups.hide("emoticons"),p.toolbar.showInline()}}},B.DefineIcon("emoticons",{NAME:"smile-o",FA5NAME:"smile",SVG_KEY:"smile"}),B.RegisterCommand("emoticons",{title:"Emoticons",undo:!1,focus:!0,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible("emoticons")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("emoticons")):this.emoticons.showEmoticonsPopup()},plugin:"emoticons"}),B.RegisterCommand("insertEmoticon",{callback:function(e,c,d){this.emoticons.insert(d,this.opts.emoticonsUseImage?"https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/".concat(c,".svg"):null),this.popups.hide("emoticons")}}),B.RegisterCommand("setEmoticonCategory",{undo:!1,focus:!1,callback:function(e,c){this.emoticons.setEmoticonCategory(c)}}),B.DefineIcon("emoticonsBack",{NAME:"arrow-left",SVG_KEY:"back"}),B.RegisterCommand("emoticonsBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.emoticons.back()}})});

/***/ }),

/***/ 1817:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(e,t){ true?t(__webpack_require__(189)):0}(this,function(e){"use strict";e=e&&e.hasOwnProperty("default")?e["default"]:e,Object.assign(e.DEFAULTS,{fontFamily:{"Arial,Helvetica,sans-serif":"Arial","Georgia,serif":"Georgia","Impact,Charcoal,sans-serif":"Impact","Tahoma,Geneva,sans-serif":"Tahoma","Times New Roman,Times,serif,-webkit-standard":"Times New Roman","Verdana,Geneva,sans-serif":"Verdana"},fontFamilySelection:!1,fontFamilyDefaultSelection:"Font Family"}),e.PLUGINS.fontFamily=function(o){var i=o.$;function r(e){var t=e.replace(/(sans-serif|serif|monospace|cursive|fantasy)/gi,"").replace(/"|'| /g,"").split(",");return i(this).grep(t,function(e){return 0<e.length})}function f(e,t){for(var n=0;n<e.length;n++)for(var a=0;a<t.length;a++)if(e[n].toLowerCase()===t[a].toLowerCase())return[n,a];return null}function n(){var e=r(i(o.selection.element()).css("font-family")),t=[];for(var n in o.opts.fontFamily)if(o.opts.fontFamily.hasOwnProperty(n)){var a=f(e,r(n));a&&t.push([n,a])}return 0===t.length?null:(t.sort(function(e,t){var n=e[1][0]-t[1][0];return 0===n?e[1][1]-t[1][1]:n}),t[0][0])}return{apply:function t(e){o.format.applyStyle("font-family",e)},refreshOnShow:function a(e,t){t.find(".fr-command.fr-active").removeClass("fr-active").attr("aria-selected",!1),t.find('.fr-command[data-param1="'.concat(n(),'"]')).addClass("fr-active").attr("aria-selected",!0)},refresh:function l(e){if(o.opts.fontFamilySelection){var t=i(o.selection.element()).css("font-family").replace(/(sans-serif|serif|monospace|cursive|fantasy)/gi,"").replace(/"|'|/g,"").split(",");e.find("> span").text(o.opts.fontFamily[n()]||t[0]||o.language.translate(o.opts.fontFamilyDefaultSelection))}}}},e.RegisterCommand("fontFamily",{type:"dropdown",displaySelection:function(e){return e.opts.fontFamilySelection},defaultSelection:function(e){return e.opts.fontFamilyDefaultSelection},displaySelectionWidth:120,html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.fontFamily;for(var n in t)t.hasOwnProperty(n)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="fontFamily" data-param1="'.concat(n,'" \n        style="font-family: ').concat(n,'" title="').concat(t[n],'">').concat(t[n],"</a></li>"));return e+="</ul>"},title:"Font Family",callback:function(e,t){this.fontFamily.apply(t)},refresh:function(e){this.fontFamily.refresh(e)},refreshOnShow:function(e,t){this.fontFamily.refreshOnShow(e,t)},plugin:"fontFamily"}),e.DefineIcon("fontFamily",{NAME:"font",SVG_KEY:"fontFamily"})});

/***/ }),

/***/ 4812:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(t,e){ true?e(__webpack_require__(189)):0}(this,function(t){"use strict";t=t&&t.hasOwnProperty("default")?t["default"]:t,Object.assign(t.DEFAULTS,{fontSize:["8","9","10","11","12","14","18","24","30","36","48","60","72","96"],fontSizeSelection:!1,fontSizeDefaultSelection:"Font Size",fontSizeUnit:"px"}),t.PLUGINS.fontSize=function(o){var i=o.$;return{apply:function e(t){o.format.applyStyle("font-size",t)},refreshOnShow:function a(t,e){var n=i(o.selection.element()).css("font-size");"pt"===o.opts.fontSizeUnit&&(n="".concat(Math.round(72*parseFloat(n,10)/96),"pt")),e.find(".fr-command.fr-active").removeClass("fr-active").attr("aria-selected",!1),e.find('.fr-command[data-param1="'.concat(n,'"]')).addClass("fr-active").attr("aria-selected",!0)},refresh:function n(t){if(o.opts.fontSizeSelection){var e=o.helpers.getPX(i(o.selection.element()).css("font-size"));"pt"===o.opts.fontSizeUnit&&(e="".concat(Math.round(72*parseFloat(e,10)/96),"pt")),t.find("> span").text(e)}}}},t.RegisterCommand("fontSize",{type:"dropdown",title:"Font Size",displaySelection:function(t){return t.opts.fontSizeSelection},displaySelectionWidth:30,defaultSelection:function(t){return t.opts.fontSizeDefaultSelection},html:function(){for(var t='<ul class="fr-dropdown-list" role="presentation">',e=this.opts.fontSize,n=0;n<e.length;n++){var o=e[n];t+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="fontSize" data-param1="'.concat(o).concat(this.opts.fontSizeUnit,'" title="').concat(o,'">').concat(o,"</a></li>")}return t+="</ul>"},callback:function(t,e){this.fontSize.apply(e)},refresh:function(t){this.fontSize.refresh(t)},refreshOnShow:function(t,e){this.fontSize.refreshOnShow(t,e)},plugin:"fontSize"}),t.DefineIcon("fontSize",{NAME:"text-height",SVG_KEY:"fontSize"})});

/***/ }),

/***/ 2802:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(e,t){ true?t(__webpack_require__(189)):0}(this,function(e){"use strict";(e=e&&e.hasOwnProperty("default")?e["default"]:e).PLUGINS.fullscreen=function(s){var t,r,o,n,i=s.$,a=function a(){return s.$box.hasClass("fr-fullscreen")};function l(){if(s.helpers.isIOS()&&s.core.hasFocus())return s.$el.blur(),setTimeout(c,250),!1;t=s.helpers.scrollTop(),s.opts.iframe&&s.markdown&&s.markdown.isEnabled()&&(s.$box=s.$oel),s.$box.toggleClass("fr-fullscreen"),i("body").first().toggleClass("fr-fullscreen"),s.helpers.isMobile()&&(s.opts.toolbarBottom?s.$tb[0].removeAttribute("style"):(s.$tb.data("parent",s.$tb.parent()),s.$box.prepend(s.$tb),s.$tb.data("sticky-dummy")&&s.$tb.after(s.$tb.data("sticky-dummy")))),r=s.opts.height,o=s.opts.heightMax,n=s.opts.zIndex,s.opts.height=s.o_win.innerHeight-(s.opts.toolbarInline?0:s.$tb.outerHeight()+(s.$second_tb?s.$second_tb.outerHeight():0)),s.opts.zIndex=2147483641,s.opts.heightMax=null,s.size.refresh(),s.opts.toolbarInline&&s.toolbar.showInline();for(var e=s.$box.parent();!e.first().is("body");)e.addClass("fr-fullscreen-wrapper"),e=e.parent();s.opts.toolbarContainer&&s.$box.prepend(s.$tb),s.events.trigger("charCounter.update"),s.events.trigger("codeView.update"),s.$win.trigger("scroll")}function f(){if(s.helpers.isIOS()&&s.core.hasFocus())return s.$el.blur(),setTimeout(c,250),!1;s.$box.toggleClass("fr-fullscreen"),i("body").first().toggleClass("fr-fullscreen"),s.$tb.data("parent")&&s.$tb.data("parent").prepend(s.$tb),s.$tb.data("sticky-dummy")&&s.$tb.after(s.$tb.data("sticky-dummy")),s.opts.height=r,s.opts.heightMax=o,s.opts.zIndex=n,s.size.refresh(),s.o_win.scroll(0,t),s.opts.toolbarInline&&s.toolbar.showInline(),s.events.trigger("charCounter.update"),s.opts.toolbarSticky&&s.opts.toolbarStickyOffset&&(s.opts.toolbarBottom?s.$tb.css("bottom",s.opts.toolbarStickyOffset).data("bottom",s.opts.toolbarStickyOffset):s.$tb.css("top",s.opts.toolbarStickyOffset).data("top",s.opts.toolbarStickyOffset));for(var e=s.$box.parent();!e.first().is("body");)e.removeClass("fr-fullscreen-wrapper"),e=e.parent();s.opts.toolbarContainer&&i(s.opts.toolbarContainer).append(s.$tb),i(s.o_win).trigger("scroll"),s.events.trigger("codeView.update")}function c(){a()?f():l(),d(s.$tb.find('.fr-command[data-cmd="fullscreen"]'));var e=s.$tb.find('.fr-command[data-cmd="moreText"]'),t=s.$tb.find('.fr-command[data-cmd="moreParagraph"]'),r=s.$tb.find('.fr-command[data-cmd="moreRich"]'),o=s.$tb.find('.fr-command[data-cmd="moreMisc"]');e.length&&s.refresh.moreText(e),t.length&&s.refresh.moreParagraph(t),r.length&&s.refresh.moreRich(r),o.length&&s.refresh.moreMisc(o)}function d(e){var t=a();e.toggleClass("fr-active",t).attr("aria-pressed",t),e.find("> *").not(".fr-sr-only").replaceWith(t?s.icon.create("fullscreenCompress"):s.icon.create("fullscreen"))}return{_init:function e(){if(!s.$wp)return!1;s.events.$on(i(s.o_win),"resize",function(){a()&&(f(),l())}),s.events.on("toolbar.hide",function(){if(a()&&s.helpers.isMobile())return!1}),s.events.on("position.refresh",function(){if(s.helpers.isIOS())return!a()}),s.events.on("destroy",function(){a()&&f()},!0)},toggle:c,refresh:d,isActive:a}},e.RegisterCommand("fullscreen",{title:"Fullscreen",undo:!1,focus:!1,accessibilityFocus:!0,forcedRefresh:!0,toggle:!0,callback:function(){this.fullscreen.toggle()},refresh:function(e){this.fullscreen.refresh(e)},plugin:"fullscreen"}),e.DefineIcon("fullscreen",{NAME:"expand",SVG_KEY:"fullscreen"}),e.DefineIcon("fullscreenCompress",{NAME:"compress",SVG_KEY:"exitFullscreen"})});

/***/ }),

/***/ 1346:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(e,t){ true?t(__webpack_require__(189)):0}(this,function(Me){"use strict";function p(e,t){(null==t||t>e.length)&&(t=e.length);for(var a=0,i=Array(t);a<t;a++)i[a]=e[a];return i}function Ke(e,t){var a="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!a){if(Array.isArray(e)||(a=function l(e,t){if(e){if("string"==typeof e)return p(e,t);var a={}.toString.call(e).slice(8,-1);return"Object"===a&&e.constructor&&(a=e.constructor.name),"Map"===a||"Set"===a?Array.from(e):"Arguments"===a||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)?p(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){a&&(e=a);var i=0,r=function(){};return{s:r,n:function(){return i>=e.length?{done:!0}:{done:!1,value:e[i++]}},e:function(e){throw e},f:r}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var n,o=!0,s=!1;return{s:function(){a=a.call(e)},n:function(){var e=a.next();return o=e.done,e},e:function(e){s=!0,n=e},f:function(){try{o||null==a["return"]||a["return"]()}finally{if(s)throw n}}}}function Ye(e){return(Ye="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}Me=Me&&Me.hasOwnProperty("default")?Me["default"]:Me,Object.assign(Me.POPUP_TEMPLATES,{"image.insert":"[_BUTTONS_][_UPLOAD_LAYER_][_BY_URL_LAYER_][_PROGRESS_BAR_]","image.edit":"[_BUTTONS_]","image.alt":"[_BUTTONS_][_ALT_LAYER_]","image.size":"[_BUTTONS_][_SIZE_LAYER_]"}),Object.assign(Me.DEFAULTS,{imageInsertButtons:["imageBack","|","imageUpload","imageByURL"],imageEditButtons:["imageReplace","imageAlign","imageCaption","imageRemove","imageLink","linkOpen","linkEdit","linkRemove","-","imageDisplay","imageStyle","imageAlt","imageSize"],imageAltButtons:["imageBack","|"],imageSizeButtons:["imageBack","|"],imageUpload:!0,imageUploadURL:null,imageCORSProxy:"https://cors-anywhere.froala.com",imageUploadRemoteUrls:!0,imageUploadParam:"file",imageUploadParams:{},imageUploadToS3:!1,imageUploadToAzure:!1,imageUploadMethod:"POST",imageMaxSize:10485760,imageAllowedTypes:["jpeg","jpg","png","gif","webp"],imageResize:!0,imageResizeWithPercent:!1,imageRoundPercent:!1,imageDefaultWidth:300,imageDefaultAlign:"center",imageDefaultDisplay:"block",imageSplitHTML:!1,imageStyles:{"fr-rounded":"Rounded","fr-bordered":"Bordered","fr-shadow":"Shadow"},imageMove:!0,imageMultipleStyles:!0,imageTextNear:!0,imagePaste:!0,imagePasteProcess:!1,imageMinWidth:16,imageOutputSize:!1,imageDefaultMargin:5,imageAddNewLine:!1}),Me.IMAGE_ALLOW_REGEX=/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i,Me.PLUGINS.image=function(A){var C,p,f,g,s,a,S=A.$,E="https://i.froala.com/upload",t=!1,i=1,c=2,d=3,u=4,R=5,U=6,r={};function m(){var e=A.popups.get("image.insert").find(".fr-image-by-url-layer input");e.val(""),C&&e.val(C.attr("src")),e.trigger("change")}function o(e){return window.pageYOffset+e.get(0).getBoundingClientRect().top}function n(){var e=A.popups.get("image.edit");if(e||(e=N()),e){var t=C;A.popups.setContainer("image.edit",A.$wp||A.$sc),A.popups.refresh("image.edit");var a=t.offset().left+t.outerWidth()/2,i=t&&o(t),r=A.$wp&&o(A.$wp);r||(r=i);var n=0;A.opts.iframe?((n=A.$wp.scrollTop()+e.outerHeight())<t.get(0).getBoundingClientRect().top&&(n=t.get(0).getBoundingClientRect().top),n>t.get(0).getBoundingClientRect().top+t.height()&&(n=t.get(0).getBoundingClientRect().top+t.height())):n=r<i?i:A.$wp&&i+t.height()<r+A.$wp.height()?i+t.height():r+e.outerHeight(),C.hasClass("fr-uploading")?P():A.popups.show("image.edit",a,n,1,!0)}}function h(){k()}function l(e){0<e.parents(".fr-img-caption").length&&(e=e.parents(".fr-img-caption").first());var t=e.hasClass("fr-dib")?"block":e.hasClass("fr-dii")?"inline":null,a=e.hasClass("fr-fil")?"left":e.hasClass("fr-fir")?"right":ve(e);he(e,t,a),e.removeClass("fr-dib fr-dii fr-fir fr-fil")}function v(){for(var e,t="IMG"==A.el.tagName?[A.el]:A.el.querySelectorAll("img"),a=0;a<t.length;a++){var i=S(t[a]);!A.opts.htmlUntouched&&A.opts.useClasses?((A.opts.imageDefaultAlign||A.opts.imageDefaultDisplay)&&(0<(e=i).parents(".fr-img-caption").length&&(e=e.parents(".fr-img-caption").first()),e.hasClass("fr-dii")||e.hasClass("fr-dib")||(e.addClass("fr-fi".concat(ve(e)[0])),e.addClass("fr-di".concat(be(e)[0])),e.css("margin",""),e.css("float",""),e.css("display",""),e.css("z-index",""),e.css("position",""),e.css("overflow",""),e.css("vertical-align",""))),A.opts.imageTextNear||(0<i.parents(".fr-img-caption").length?i.parents(".fr-img-caption").first().removeClass("fr-dii").addClass("fr-dib"):i.removeClass("fr-dii").addClass("fr-dib"))):A.opts.htmlUntouched||A.opts.useClasses||(A.opts.imageDefaultAlign||A.opts.imageDefaultDisplay)&&l(i),A.opts.iframe&&i.on("load",A.size.syncIframe)}}function b(e){void 0===e&&(e=!0);var t,a=Array.prototype.slice.call(A.el.querySelectorAll("img")),i=[];for(t=0;t<a.length;t++)if(i.push(a[t].getAttribute("src")),S(a[t]).toggleClass("fr-draggable",A.opts.imageMove),""===a[t].getAttribute("class")&&a[t].removeAttribute("class"),""===a[t].getAttribute("style")&&a[t].removeAttribute("style"),a[t].parentNode&&a[t].parentNode.parentNode&&A.node.hasClass(a[t].parentNode.parentNode,"fr-img-caption")){var r=a[t].parentNode.parentNode;A.browser.mozilla||r.setAttribute("contenteditable",!1),r.setAttribute("draggable",!1),r.classList.add("fr-draggable");var n=a[t].nextSibling;n&&!A.browser.mozilla&&n.setAttribute("contenteditable",!0)}if(s)for(t=0;t<s.length;t++)i.indexOf(s[t].getAttribute("src"))<0&&A.events.trigger("image.removed",[S(s[t])]);if(s&&e){var o=[];for(t=0;t<s.length;t++)o.push(s[t].getAttribute("src"));for(t=0;t<a.length;t++)o.indexOf(a[t].getAttribute("src"))<0&&A.events.trigger("image.loaded",[S(a[t])])}s=a}function x(){if(p||function o(){var e;A.shared.$image_resizer?(p=A.shared.$image_resizer,g=A.shared.$img_overlay,A.events.on("destroy",function(){S("body").first().append(p.removeClass("fr-active"))},!0)):(A.shared.$image_resizer=S(document.createElement("div")).attr("class","fr-image-resizer"),p=A.shared.$image_resizer,A.events.$on(p,"mousedown",function(e){e.stopPropagation()},!0),A.opts.imageResize&&(p.append(y("nw")+y("ne")+y("sw")+y("se")),A.shared.$img_overlay=S(document.createElement("div")).attr("class","fr-image-overlay"),g=A.shared.$img_overlay,e=p.get(0).ownerDocument,S(e).find("body").first().append(g)));A.events.on("shared.destroy",function(){p.html("").removeData().remove(),p=null,A.opts.imageResize&&(g.remove(),g=null)},!0),A.helpers.isMobile()||A.events.$on(S(A.o_win),"resize",function(){C&&!C.hasClass("fr-uploading")?ce(!0):C&&(x(),ye(),P(!1))});if(A.opts.imageResize){e=p.get(0).ownerDocument,A.events.$on(p,A._mousedown,".fr-handler",D),A.events.$on(S(e),A._mousemove,T),A.events.$on(S(e.defaultView||e.parentWindow),A._mouseup,$),A.events.$on(g,"mouseleave",$);var i=1,r=null,n=0;A.events.on("keydown",function(e){if(C){var t=-1!=navigator.userAgent.indexOf("Mac OS X")?e.metaKey:e.ctrlKey,a=e.which;(a!==r||200<e.timeStamp-n)&&(i=1),(a==Me.KEYCODE.EQUALS||A.browser.mozilla&&a==Me.KEYCODE.FF_EQUALS)&&t&&!e.altKey?i=te.call(this,e,1,1,i):(a==Me.KEYCODE.HYPHEN||A.browser.mozilla&&a==Me.KEYCODE.FF_HYPHEN)&&t&&!e.altKey?i=te.call(this,e,2,-1,i):A.keys.ctrlKey(e)||a!=Me.KEYCODE.ENTER||(C.before("<br>"),z(C)),r=a,n=e.timeStamp}},!0),A.events.on("keyup",function(){i=1})}}(),!C)return!1;var e=A.$wp||A.$sc;e.append(p),p.data("instance",A);var t=e.scrollTop()-("static"!=e.css("position")?e.offset().top:0),a=e.scrollLeft()-("static"!=e.css("position")?e.offset().left:0);a-=A.helpers.getPX(e.css("border-left-width")),t-=A.helpers.getPX(e.css("border-top-width")),A.$el.is("img")&&A.$sc.is("body")&&(a=t=0);var i=Ce();Se()&&(i=i.find(".fr-img-wrap"));var r=0,n=0;A.opts.iframe&&(r=A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-top")),n=A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-left"))),p.css("top",(A.opts.iframe?i.offset().top+r:i.offset().top+t)-1).css("left",(A.opts.iframe?i.offset().left+n:i.offset().left+a)-1).css("width",i.get(0).getBoundingClientRect().width).css("height",i.get(0).getBoundingClientRect().height).addClass("fr-active")}function y(e){return'<div class="fr-handler fr-h'.concat(e,'"></div>')}function w(e){Se()&&C.parents(".fr-img-caption").css("width",e),C.css("width",e)}function D(e){if(!A.core.sameInstance(p))return!0;if(e.preventDefault(),e.stopPropagation(),A.$el.find("img.fr-error").left)return!1;A.undo.canDo()||A.undo.saveStep();var t=e.pageX||e.originalEvent.touches[0].pageX;if("mousedown"==e.type){var a=A.$oel.get(0),i=a.ownerDocument,r=i.defaultView||i.parentWindow,n=!1;try{n=r.location!=r.parent.location&&!(r.$&&r.$.FE)}catch(l){}n&&r.frameElement&&(t+=A.helpers.getPX(S(a).offset().left)+r.frameElement.clientLeft)}(f=S(this)).data("start-x",t),f.data("start-width",C.width()),f.data("start-height",C.height());var o=C.width();if(A.opts.imageResizeWithPercent){var s=C.parentsUntil(A.$el,A.html.blockTagsQuery()).get(0)||A.el;o=(o/S(s).outerWidth()*100).toFixed(2)+"%"}w(o),g.show(),A.popups.hideAll(),me()}function T(e){if(!A.core.sameInstance(p))return!0;var t;if(f&&C){if(e.preventDefault(),A.$el.find("img.fr-error").left)return!1;var a=e.pageX||(e.originalEvent.touches?e.originalEvent.touches[0].pageX:null);if(!a)return!1;var i=a-f.data("start-x"),r=f.data("start-width");if((f.hasClass("fr-hnw")||f.hasClass("fr-hsw"))&&(i=0-i),A.opts.imageResizeWithPercent){var n=C.parentsUntil(A.$el,A.html.blockTagsQuery()).get(0)||A.el;r=((r+i)/S(n).outerWidth()*100).toFixed(2),A.opts.imageRoundPercent&&(r=Math.round(r)),w("".concat(r,"%")),(t=Se()?(A.helpers.getPX(C.parents(".fr-img-caption").css("width"))/S(n).outerWidth()*100).toFixed(2):(A.helpers.getPX(C.css("width"))/S(n).outerWidth()*100).toFixed(2))===r||A.opts.imageRoundPercent||w("".concat(t,"%")),C.css("height","").removeAttr("height")}else r+i>=A.opts.imageMinWidth&&(w(r+i),t=Se()?A.helpers.getPX(C.parents(".fr-img-caption").css("width")):A.helpers.getPX(C.css("width"))),t!==r+i&&w(t),((C.attr("style")||"").match(/(^height:)|(; *height:)/)||C.attr("height"))&&(C.css("height",f.data("start-height")*C.width()/f.data("start-width")),C.removeAttr("height"));x(),A.events.trigger("image.resize",[Ae()])}}function $(e){if(!A.core.sameInstance(p))return!0;if(f&&C){if(e&&e.stopPropagation(),A.$el.find("img.fr-error").left)return!1;f=null,g.hide(),x(),n(),A.undo.saveStep(),A.events.trigger("image.resizeEnd",[Ae()])}else p.removeClass("fr-active")}function I(e,t,a){A.edit.on(),C&&C.addClass("fr-error"),r[e]?O(A.language.translate(r[e])):O(A.language.translate("Something went wrong. Please try again.")),!C&&a&&ae(a),A.events.trigger("image.error",[{code:e,message:r[e]},t,a])}function N(e){if(e)return A.$wp&&A.events.$on(A.$wp,"scroll.image-edit",function(){C&&A.popups.isVisible("image.edit")&&(A.events.disableBlur(),n())}),!0;var t="";if(0<A.opts.imageEditButtons.length){var a={buttons:t+='<div class="fr-buttons">\n        '.concat(A.button.buildList(A.opts.imageEditButtons),"\n        </div>")};return A.popups.create("image.edit",a)}return!1}function P(e){var t=A.popups.get("image.insert");if(t||(t=X()),t.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"),t.find(".fr-image-progress-bar-layer").addClass("fr-active"),t.find(".fr-buttons").hide(),C){var a=Ce();A.popups.setContainer("image.insert",A.$sc);var i=a.offset().left,r=a.offset().top+a.height();A.popups.show("image.insert",i,r,a.outerHeight())}void 0===e&&B(A.language.translate("Uploading"),0)}function k(e){var t=A.popups.get("image.insert");if(t&&(t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"),t.find(".fr-image-progress-bar-layer").removeClass("fr-active"),t.find(".fr-buttons").show(),e||A.$el.find("img.fr-error").length)){if(A.events.focus(),A.$el.find("img.fr-error").length&&(A.$el.find("img.fr-error").remove(),A.undo.saveStep(),A.undo.run(),A.undo.dropRedo()),!A.$wp&&C){var a=C;ce(!0),A.selection.setAfter(a.get(0)),A.selection.restore()}A.popups.hide("image.insert")}}function B(e,t){var a=A.popups.get("image.insert");if(a){var i=a.find(".fr-image-progress-bar-layer");i.find("h3").text(e+(t?" ".concat(t,"%"):"")),i.removeClass("fr-error"),t?(i.find("div").removeClass("fr-indeterminate"),i.find("div > span").css("width","".concat(t,"%"))):i.find("div").addClass("fr-indeterminate")}}function O(e){P();var t=A.popups.get("image.insert").find(".fr-image-progress-bar-layer");t.addClass("fr-error");var a=t.find("h3");a.text(e),A.events.disableBlur(),a.focus()}function z(e){ge.call(e.get(0))}function L(){var e=S(this);A.popups.hide("image.insert"),e.removeClass("fr-uploading"),e.next().is("br")&&e.next().remove(),z(e),A.events.trigger("image.loaded",[e])}function _(o,e,s,l,p){l&&"string"==typeof l&&(l=A.$(l)),A.edit.off(),B(A.language.translate("Loading image")),e&&(o=A.helpers.sanitizeURL(o));var t=new Image;t.onload=function(){var e,t;if(l){A.undo.canDo()||l.hasClass("fr-uploading")||A.undo.saveStep();var a=l.data("fr-old-src");l.data("fr-image-pasted")&&(a=null),A.$wp?((e=l.clone().removeData("fr-old-src").removeClass("fr-uploading").removeAttr("data-fr-image-pasted")).off("load"),a&&l.attr("src",a),!A.opts.trackChangesEnabled||l[0].parentNode&&"SPAN"===l[0].parentNode.tagName&&l[0].parentNode.hasAttribute("data-tracking")||A.track_changes.replaceSpecialItem(l),l.replaceWith(e)):e=l;for(var i=e.get(0).attributes,r=0;r<i.length;r++){var n=i[r];0===n.nodeName.indexOf("data-")?e.removeAttr(n.nodeName):s&&s.hasOwnProperty(n.nodeName)&&e.removeAttr(n.nodeName)}if(void 0!==s)for(t in s)s.hasOwnProperty(t)&&"link"!=t&&e.attr("".concat(t),s[t]);e.on("load",L),e.attr("src",o),A.edit.on(),b(!1),l[0].src!=o&&A.selection.restore(),A.undo.saveStep(),A.events.disableBlur(),A.$el.blur(),A.events.trigger(a?"image.replaced":"image.inserted",[e,p])}else(e=W(o,s,L))&&(b(!1),A.undo.saveStep(),A.events.disableBlur(),A.$el.blur(),A.events.trigger("image.inserted",[e,p]))},t.onerror=function(){I(i)},P(A.language.translate("Loading image")),t.src=o}function M(e,t,a){B(A.language.translate("Loading image"));var i=this.status,r=this.response,n=this.responseXML,o=this.responseText;try{if(A.opts.imageUploadToS3||A.opts.imageUploadToAzure)if(201==i){var s;if(A.opts.imageUploadToAzure){if(!1===A.events.trigger("image.uploadedToAzure",[this.responseURL,a,r],!0))return A.edit.on(),!1;s=t}else s=function p(e){try{var t=S(e).find("Location").text(),a=S(e).find("Key").text();return!1===A.events.trigger("image.uploadedToS3",[t,a,e],!0)?(A.edit.on(),!1):t}catch(i){return I(u,e),!1}}(n);s&&_(s,!1,[],e,r||n)}else I(u,r||n,e);else if(200<=i&&i<300){var l=function f(e){try{if(!1===A.events.trigger("image.uploaded",[e],!0))return A.edit.on(),!1;var t=JSON.parse(e);return t.link?t:(I(c,e),!1)}catch(a){return I(u,e),!1}}(o);l&&_(l.link,!1,l,e,r||o)}else I(d,r||o,e)}catch(g){I(u,r||o,e)}}function K(){I(u,this.response||this.responseText||this.responseXML)}function Y(e){if(e.lengthComputable){var t=e.loaded/e.total*100|0;B(A.language.translate("Uploading"),t)}}function W(e,t,a){var i,r=S(document.createElement("img")).attr("src",e);if(t&&void 0!==t)for(i in t)t.hasOwnProperty(i)&&"link"!=i&&(" data-".concat(i,'="').concat(t[i],'"'),r.attr("".concat(i),t[i]));var n=A.opts.imageDefaultWidth;n&&"auto"!=n&&(n=A.opts.imageResizeWithPercent?"100%":"".concat(n,"px")),r.attr("style",n?"width: ".concat(n,";"):""),he(r,A.opts.imageDefaultDisplay,A.opts.imageDefaultAlign),r.on("load",a),r.on("error",a),A.edit.on(),A.events.focus(!0),A.selection.restore(),A.undo.saveStep(),A.opts.imageSplitHTML?A.markers.split():A.markers.insert(),A.html.wrap();var o=A.$el.find(".fr-marker");if(o.length)(o.parent().is("hr")||o.parent().is("IMG"))&&o.parent().after(o),A.node.isLastSibling(o)&&o.parent().hasClass("fr-deletable")&&o.insertAfter(o.parent()),o.replaceWith(r);else{if(A.opts.trackChangesEnabled)return k(!0),!1;A.$el.append(r)}return A.selection.clear(),r}function G(){A.edit.on(),k(!0)}function H(e,t){if(void 0!==e&&0<e.length){if(!1===A.events.trigger("image.beforeUpload",[e,t]))return!1;var a,i=e[0];if(!(null!==A.opts.imageUploadURL&&A.opts.imageUploadURL!=E||A.opts.imageUploadToS3||A.opts.imageUploadToAzure))return function y(r,n){var o=new FileReader;o.onload=function(){var e=o.result;if(o.result.indexOf("svg+xml")<0){for(var t=atob(o.result.split(",")[1]),a=[],i=0;i<t.length;i++)a.push(t.charCodeAt(i));e=window.URL.createObjectURL(new Blob([new Uint8Array(a)],{type:r.type})),n&&n.data("fr-old-src",n.attr("src")),A.image.insert(e,!1,null,n)}else A.image.insert(e,null,null,A.image.get())},P(),o.readAsDataURL(r)}(i,t||C),!1;if(i.name||(i.name=(new Date).getTime()+"."+(i.type||"image/jpeg").replace(/image\//g,"")),i.size>A.opts.imageMaxSize)return I(R),!1;if(A.opts.imageAllowedTypes.indexOf(i.type.replace(/image\//g,""))<0)return I(U),!1;if(A.drag_support.formdata&&(a=A.drag_support.formdata?new FormData:null),a){var r;if(!1!==A.opts.imageUploadToS3)for(r in a.append("key",A.opts.imageUploadToS3.keyStart+(new Date).getTime()+"-"+(i.name||"untitled")),a.append("success_action_status","201"),a.append("X-Requested-With","xhr"),a.append("Content-Type",i.type),A.opts.imageUploadToS3.params)A.opts.imageUploadToS3.params.hasOwnProperty(r)&&a.append(r,A.opts.imageUploadToS3.params[r]);for(r in A.opts.imageUploadParams)A.opts.imageUploadParams.hasOwnProperty(r)&&a.append(r,A.opts.imageUploadParams[r]);a.append(A.opts.imageUploadParam,i,i.name);var n,o,s=A.opts.imageUploadURL,l=A.opts.imageUploadMethod;A.opts.imageUploadToS3&&(s=A.opts.imageUploadToS3.uploadURL?A.opts.imageUploadToS3.uploadURL:"https://".concat(A.opts.imageUploadToS3.region,".amazonaws.com/").concat(A.opts.imageUploadToS3.bucket)),A.opts.imageUploadToAzure&&(n=s=A.opts.imageUploadToAzure.uploadURL?"".concat(A.opts.imageUploadToAzure.uploadURL,"/").concat(i.name):encodeURI("https://".concat(A.opts.imageUploadToAzure.account,".blob.core.windows.net/").concat(A.opts.imageUploadToAzure.container,"/").concat(i.name)),A.opts.imageUploadToAzure.SASToken&&(s+=A.opts.imageUploadToAzure.SASToken),l="PUT");var p=A.core.getXHR(s,l);if(A.opts.imageUploadToAzure){var f=(new Date).toUTCString();if(!A.opts.imageUploadToAzure.SASToken&&A.opts.imageUploadToAzure.accessKey){var g=A.opts.imageUploadToAzure.account,c=A.opts.imageUploadToAzure.container;if(A.opts.imageUploadToAzure.uploadURL){var d=A.opts.imageUploadToAzure.uploadURL.split("/");c=d.pop(),g=d.pop().split(".")[0]}var u="x-ms-blob-type:BlockBlob\nx-ms-date:".concat(f,"\nx-ms-version:2019-07-07"),m=encodeURI("/"+g+"/"+c+"/"+i.name),h=l+"\n\n\n"+i.size+"\n\n"+i.type+"\n\n\n\n\n\n\n"+u+"\n"+m,v=A.cryptoJSPlugin.cryptoJS.HmacSHA256(h,A.cryptoJSPlugin.cryptoJS.enc.Base64.parse(A.opts.imageUploadToAzure.accessKey)).toString(A.cryptoJSPlugin.cryptoJS.enc.Base64),b="SharedKey "+g+":"+v;o=v,p.setRequestHeader("Authorization",b)}for(r in p.setRequestHeader("x-ms-version","2019-07-07"),p.setRequestHeader("x-ms-date",f),p.setRequestHeader("Content-Type",i.type),p.setRequestHeader("x-ms-blob-type","BlockBlob"),A.opts.imageUploadParams)A.opts.imageUploadParams.hasOwnProperty(r)&&p.setRequestHeader(r,A.opts.imageUploadParams[r]);for(r in A.opts.imageUploadToAzure.params)A.opts.imageUploadToAzure.params.hasOwnProperty(r)&&p.setRequestHeader(r,A.opts.imageUploadToAzure.params[r])}!function w(t,a,i,r,n,o){function s(){var e=S(this);e.off("load"),e.addClass("fr-uploading"),e.next().is("br")&&e.next().remove(),A.placeholder.refresh(),z(e),x(),P(),A.edit.off(),t.onload=function(){M.call(t,e,n,o)},t.onerror=K,t.upload.onprogress=Y,t.onabort=G,S(e.off("abortUpload")).on("abortUpload",function(){4!=t.readyState&&(t.abort(),r?(r.attr("src",r.data("fr-old-src")),r.removeClass("fr-uploading")):e.remove(),ce(!0))}),t.send(A.opts.imageUploadToAzure?i:a)}var l=new FileReader;l.onload=function(){var e=l.result;if(l.result.indexOf("svg+xml")<0){for(var t=atob(l.result.split(",")[1]),a=[],i=0;i<t.length;i++)a.push(t.charCodeAt(i));e=window.URL.createObjectURL(new Blob([new Uint8Array(a)],{type:"image/jpeg"}))}r?(r.on("load",s),r.on("error",function(){s(),S(this).off("error")}),A.edit.on(),A.undo.saveStep(),r.data("fr-old-src",r.attr("src")),r.attr("src",e)):W(e,null,s)},l.readAsDataURL(i)}(p,a,i,t||C,n,o)}}}function F(e){if(e.is("img")&&0<e.parents(".fr-img-caption").length)return e.parents(".fr-img-caption")}function V(e){var t=e.originalEvent.dataTransfer;if(t&&t.files&&t.files.length){var a=t.files[0];if(a&&a.type&&-1!==a.type.indexOf("image")&&0<=A.opts.imageAllowedTypes.indexOf(a.type.replace(/image\//g,""))){if(!A.opts.imageUpload)return e.preventDefault(),e.stopPropagation(),!1;A.markers.remove(),A.markers.insertAtPoint(e.originalEvent),A.$el.find(".fr-marker").replaceWith(Me.MARKERS),0===A.$el.find(".fr-marker").length&&A.selection.setAtEnd(A.el),A.popups.hideAll();var i=A.popups.get("image.insert");i||(i=X()),A.popups.setContainer("image.insert",A.$sc);var r=e.originalEvent.pageX,n=e.originalEvent.pageY;if(A.opts.iframe){var o=A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-top")),s=A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-left"));n+=A.$iframe.offset().top+o,r+=A.$iframe.offset().left+s}return A.popups.show("image.insert",r,n),P(),0<=A.opts.imageAllowedTypes.indexOf(a.type.replace(/image\//g,""))?(ce(!0),H(t.files)):I(U),e.preventDefault(),e.stopPropagation(),!1}}}function X(e){if(e)return A.popups.onRefresh("image.insert",m),A.popups.onHide("image.insert",h),!0;var t,a,i="";A.opts.imageUpload||-1===A.opts.imageInsertButtons.indexOf("imageUpload")||A.opts.imageInsertButtons.splice(A.opts.imageInsertButtons.indexOf("imageUpload"),1);var r=A.button.buildList(A.opts.imageInsertButtons);""!==r&&(i='<div class="fr-buttons fr-tabs">'.concat(r,"</div>"));var n=A.opts.imageInsertButtons.indexOf("imageUpload"),o=A.opts.imageInsertButtons.indexOf("imageByURL"),s="";0<=n&&(t=" fr-active",0<=o&&o<n&&(t=""),s='<div class="fr-image-upload-layer'.concat(t,' fr-layer" id="fr-image-upload-layer-').concat(A.id,'"><strong>').concat(A.language.translate("Drop image"),"</strong><br>(").concat(A.language.translate("or click"),')<div class="fr-form"><input type="file" accept="image/').concat(A.opts.imageAllowedTypes.join(", image/").toLowerCase(),'" tabIndex="-1" aria-labelledby="fr-image-upload-layer-').concat(A.id,'" role="button"></div></div>'));var l="";0<=o&&(t=" fr-active",0<=n&&n<o&&(t=""),l='<div class="fr-image-by-url-layer'.concat(t,' fr-layer" id="fr-image-by-url-layer-').concat(A.id,'"><div class="fr-input-line"><input id="fr-image-by-url-layer-text-').concat(A.id,'" type="text" placeholder="http://" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageInsertByURL" tabIndex="2" role="button">').concat(A.language.translate("Insert"),"</button></div></div>"));var p={buttons:i,upload_layer:s,by_url_layer:l,progress_bar:'<div class="fr-image-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="imageDismissError" tabIndex="2" role="button">OK</button></div></div>'};return 1<=A.opts.imageInsertButtons.length&&(a=A.popups.create("image.insert",p)),A.$wp&&A.events.$on(A.$wp,"scroll",function(){C&&A.popups.isVisible("image.insert")&&ye()}),function f(i){A.events.$on(i,"dragover dragenter",".fr-image-upload-layer",function(e){return S(this).addClass("fr-drop"),(A.browser.msie||A.browser.edge)&&e.preventDefault(),!1},!0),A.events.$on(i,"dragleave dragend",".fr-image-upload-layer",function(e){return S(this).removeClass("fr-drop"),(A.browser.msie||A.browser.edge)&&e.preventDefault(),!1},!0),A.events.$on(i,"drop",".fr-image-upload-layer",function(e){e.preventDefault(),e.stopPropagation(),S(this).removeClass("fr-drop");var t=e.originalEvent.dataTransfer;if(t&&t.files){var a=i.data("instance")||A;a.events.disableBlur(),a.image.upload(t.files),a.events.enableBlur()}},!0),A.helpers.isIOS()&&A.events.$on(i,"touchstart",'.fr-image-upload-layer input[type="file"]',function(){S(this).trigger("click")},!0),A.events.$on(i,"change",'.fr-image-upload-layer input[type="file"]',function(){if(this.files){var e=i.data("instance")||A;e.events.disableBlur(),i.find("input:focus").blur(),e.events.enableBlur(),e.image.upload(this.files,C)}S(this).val("")},!0)}(a),a}function q(){C&&A.popups.get("image.alt").find("input").val(C.attr("alt")||"").trigger("change")}function j(){var e=A.popups.get("image.alt");e||(e=J()),k(),A.popups.refresh("image.alt"),A.popups.setContainer("image.alt",A.$sc);var t=Ce(),a=t.outerWidth()/2;Se()&&(t=t.find(".fr-img-wrap"),a=C.outerWidth()/2);var i=t.offset().left+a,r=t.offset().top+t.outerHeight(),n=t.outerHeight();A.opts.iframe&&Se()&&(n=C?C.outerHeight():0),A.popups.show("image.alt",i,r,n,!0)}function J(e){if(e)return A.popups.onRefresh("image.alt",q),!0;var t={buttons:'<div class="fr-buttons fr-tabs">'.concat(A.button.buildList(A.opts.imageAltButtons),"</div>"),alt_layer:'<div class="fr-image-alt-layer fr-layer fr-active" id="fr-image-alt-layer-'.concat(A.id,'"><div class="fr-input-line"><input id="fr-image-alt-layer-text-').concat(A.id,'" type="text" placeholder="').concat(A.language.translate("Alternative Text"),'" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetAlt" tabIndex="2" role="button">').concat(A.language.translate("Update"),"</button></div></div>")},a=A.popups.create("image.alt",t);return A.$wp&&A.events.$on(A.$wp,"scroll.image-alt",function(){C&&A.popups.isVisible("image.alt")&&j()}),a}function Q(){var e=A.popups.get("image.size"),t=C.get(0).style.height?C.get(0).style.height:"auto",a=C.get(0).style.width?C.get(0).style.width:"auto";if(C)if(Se()){var i=C.parent();i.get(0).style.width||(i=C.parent().parent()),e.find('input[name="width"]').val(a).trigger("change"),e.find('input[name="height"]').val(t).trigger("change")}else e.find('input[name="width"]').val(a).trigger("change"),e.find('input[name="height"]').val(t).trigger("change")}function Z(){var e=A.popups.get("image.size");e||(e=ee()),k(),A.popups.refresh("image.size"),A.popups.setContainer("image.size",A.$sc);var t=Ce(),a=t.outerWidth()/2;Se()&&(t=t.find(".fr-img-wrap"),a=C.outerWidth()/2);var i=t.outerHeight();A.opts.iframe&&Se()&&(i=C?C.outerHeight():0);var r=t.offset().left+a,n=t.offset().top+t.outerHeight();A.popups.show("image.size",r,n,i,!0)}function ee(e){if(e)return A.popups.onRefresh("image.size",Q),!0;var t={buttons:'<div class="fr-buttons fr-tabs">'.concat(A.button.buildList(A.opts.imageSizeButtons),"</div>"),size_layer:'<div class="fr-image-size-layer fr-layer fr-active" id="fr-image-size-layer-'.concat(A.id,'"><div class="fr-image-group"><div class="fr-input-line"><input id="fr-image-size-layer-width-\'').concat(A.id,'" type="text" name="width" placeholder="').concat(A.language.translate("Width"),'" tabIndex="1"></div><div class="fr-input-line"><input id="fr-image-size-layer-height').concat(A.id,'" type="text" name="height" placeholder="').concat(A.language.translate("Height"),'" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetSize" tabIndex="2" role="button">').concat(A.language.translate("Update"),"</button></div></div>")},a=A.popups.create("image.size",t);return A.$wp&&A.events.$on(A.$wp,"scroll.image-size",function(){C&&A.popups.isVisible("image.size")&&Z()}),a}function te(e,t,a,i){return e.pageX=t,D.call(this,e),e.pageX=e.pageX+a*Math.floor(Math.pow(1.1,i)),T.call(this,e),$.call(this,e),++i}function ae(e){if(e=e||Ce(),A.opts.trackChangesEnabled&&!A.helpers.isMobile()&&(!e[0].parentNode||"SPAN"!==e[0].parentNode.tagName||!e[0].parentNode.hasAttribute("data-tracking")))return A.track_changes.removeSpecialItem(e),A.popups.hideAll(),void ce(!0);e&&!1!==A.events.trigger("image.beforeRemove",[e])&&(A.popups.hideAll(),we(),ce(!0),A.undo.canDo()||A.undo.saveStep(),e.get(0)==A.el?e.removeAttr("src"):(e.get(0).parentNode&&"A"==e.get(0).parentNode.tagName?(A.selection.setBefore(e.get(0).parentNode)||A.selection.setAfter(e.get(0).parentNode)||e.parent().after(Me.MARKERS),S(e.get(0).parentNode).remove()):(A.selection.setBefore(e.get(0))||A.selection.setAfter(e.get(0))||e.after(Me.MARKERS),e.remove()),A.html.fillEmptyBlocks(),A.selection.restore()),A.undo.saveStep())}function ie(e){var t=e.which,a=document.getElementsByClassName("fs-transforms-container"),i=!1;if(a&&a.length){var r,n=Ke(a);try{for(n.s();!(r=n.n()).done;){var o=r.value;o.childNodes&&o.childNodes.length&&(i=!0)}}catch(p){n.e(p)}finally{n.f()}}if(i&&(C=null),C&&(t==Me.KEYCODE.BACKSPACE||t==Me.KEYCODE.DELETE))return e.preventDefault(),e.stopPropagation(),ae(),!1;if(C&&t==Me.KEYCODE.ESC){var s=C;return ce(!0),A.selection.setAfter(s.get(0)),A.selection.restore(),e.preventDefault(),!1}if(!C||t!=Me.KEYCODE.ARROW_LEFT&&t!=Me.KEYCODE.ARROW_RIGHT)return C&&t===Me.KEYCODE.TAB?(e.preventDefault(),e.stopPropagation(),ce(!0),!1):C&&t!=Me.KEYCODE.F10&&!A.keys.isBrowserAction(e)?(e.preventDefault(),e.stopPropagation(),!1):void 0;var l=C.get(0);return ce(!0),t==Me.KEYCODE.ARROW_LEFT?A.selection.setBefore(l):A.selection.setAfter(l),A.selection.restore(),e.preventDefault(),!1}function re(e){if(e&&"IMG"==e.tagName){if(A.node.hasClass(e,"fr-uploading")||A.node.hasClass(e,"fr-error")?e.parentNode.removeChild(e):A.node.hasClass(e,"fr-draggable")&&e.classList.remove("fr-draggable"),e.parentNode&&e.parentNode.parentNode&&A.node.hasClass(e.parentNode.parentNode,"fr-img-caption")){var t=e.parentNode.parentNode;t.removeAttribute("contenteditable"),t.removeAttribute("draggable"),t.classList.remove("fr-draggable");var a=e.nextSibling;a&&a.removeAttribute("contenteditable")}}else if(e&&e.nodeType==Node.ELEMENT_NODE)for(var i=e.querySelectorAll("img.fr-uploading, img.fr-error, img.fr-draggable"),r=0;r<i.length;r++)re(i[r])}function ne(e){if(!1===A.events.trigger("image.beforePasteUpload",[e]))return S(e).removeAttr("data-fr-image-pasted"),!1;C=S(e),x(),n(),P(),C.on("load",function(){var t=[];x(),S(A.popups.get("image.insert").get(0)).find("div.fr-active.fr-error").length<1&&P(),S(this).data("events").filter(function(e){"load"===e[0]&&t.push(e)}),t.length<=1&&S(this).off("load")});for(var t=S(e).attr("src").split(","),a=atob(t[1]),i=[],r=0;r<a.length;r++)i.push(a.charCodeAt(r));H([A.browser.safari&&!A.opts.imageUploadURL?new Blob([new Uint8Array(i)],{type:t[0].replace(/data\:/g,"")}):new Blob([new Uint8Array(i)],{type:t[0].replace(/data\:/g,"").replace(/;base64/g,"")})],C)}function oe(){A.opts.imagePaste?A.$el.find("img[data-fr-image-pasted]").each(function(e,a){if(A.opts.imagePasteProcess){var t=A.opts.imageDefaultWidth;t&&"auto"!=t&&(t+=A.opts.imageResizeWithPercent?"%":"px"),S(a).css("width",t).removeClass("fr-dii fr-dib fr-fir fr-fil"),he(S(a),A.opts.imageDefaultDisplay,A.opts.imageDefaultAlign)}if(0===a.src.indexOf("data:"))ne(a);else if(0===a.src.indexOf("blob:")||0===a.src.indexOf("http")&&A.opts.imageUploadRemoteUrls&&A.opts.imageCORSProxy){var i=new Image;i.crossOrigin="Anonymous",i.onload=function(){var e=A.o_doc.createElement("CANVAS"),t=e.getContext("2d");e.height=this.naturalHeight,e.width=this.naturalWidth,t.drawImage(this,0,0),setTimeout(function(){ne(a)},0),a.src=e.toDataURL(Me.IMAGE_TYPE)},A.browser.msie&&Me.IMAGE_ALLOW_REGEX.test(a.src)&&(Me.IMAGE_TYPE="image/"+a.src.split(Me.IMAGE_ALLOW_REGEX)[1]),i.src=(0===a.src.indexOf("blob:")?"":"".concat(A.opts.imageCORSProxy,"/"))+a.src,0!==a.src.indexOf("blob:")&&A.undo.saveStep()}else 0!==a.src.indexOf("http")||0===a.src.indexOf("https://mail.google.com/mail")?(A.selection.save(),S(a).remove(),A.selection.restore()):S(a).removeAttr("data-fr-image-pasted")}):A.$el.find("img[data-fr-image-pasted]").remove()}function se(e){var t=e.target.result,a=A.opts.imageDefaultWidth;a&&"auto"!=a&&(a+=A.opts.imageResizeWithPercent?"%":"px"),A.undo.saveStep(),A.html.insert('<img data-fr-image-pasted="true" src="'.concat(t,'"').concat(a?' style="width: '.concat(a,';"'):"",">"));var i=A.$el.find('img[data-fr-image-pasted="true"]');i&&he(i,A.opts.imageDefaultDisplay,A.opts.imageDefaultAlign),A.events.trigger("paste.after")}function le(e,t){var a=new FileReader;a.onload=function i(e){var t=A.opts.imageDefaultWidth;t&&"auto"!=t&&(t+=A.opts.imageResizeWithPercent?"%":"px"),A.html.insert('<img data-fr-image-pasted="true" src="'.concat(e,'"').concat(t?' style="width: '.concat(t,';"'):"",">"));var a=A.$el.find('img[data-fr-image-pasted="true"]');a&&he(a,A.opts.imageDefaultDisplay,A.opts.imageDefaultAlign),A.events.trigger("paste.after")}(t),a.readAsDataURL(e,t)}function pe(e,t){var a=t||e&&e.clipboardData;if(a&&a.items){var i=(a||window.clipboardData).getData("text/html")||"";A.browser.mozilla&&(""===i||/<!--StartFragment-->([ ])<!--EndFragment-->/.test(i))&&(i=A.win.localStorage.getItem("fr-copied-html"));var r=(new DOMParser).parseFromString(i,"text/html").querySelector("img");if(r&&!A.opts.imageUploadURL){if(!r)return!1;var n=r.src,o=null;if(a.types&&-1!=[].indexOf.call(a.types,"text/rtf")||a.getData("text/rtf"))o=a.items[0].getAsFile();else for(var s=0;s<a.items.length;s++)if(o=a.items[s].getAsFile()){Me.IMAGE_TYPE=o.type;break}if(o)return le(o,n),!1}else{var l=null;if(a.types&&-1!=[].indexOf.call(a.types,"text/rtf")||a.getData("text/rtf"))l=a.items[0].getAsFile();else for(var p=0;p<a.items.length&&!(l=a.items[p].getAsFile());p++);if(l)return function f(e){var t=new FileReader;t.onload=se,t.readAsDataURL(e)}(l),!1}}}function fe(e){return e=e.replace(/<img /gi,'<img data-fr-image-pasted="true" ')}function ge(e){if("false"==S(this).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable"))return!0;if(e&&"touchend"==e.type&&a)return!0;if(e&&A.edit.isDisabled())return e.stopPropagation(),e.preventDefault(),!1;for(var t=0;t<Me.INSTANCES.length;t++)Me.INSTANCES[t]!=A&&Me.INSTANCES[t].events.trigger("image.hideResizer");A.toolbar.disable(),e&&(e.stopPropagation(),e.preventDefault()),A.helpers.isMobile()&&(A.events.disableBlur(),A.$el.blur(),A.events.enableBlur()),A.opts.iframe&&A.size.syncIframe(),C=S(this),we(),x(),n(),A.browser.msie?(A.popups.areVisible()&&A.events.disableBlur(),A.win.getSelection&&(A.win.getSelection().removeAllRanges(),A.win.getSelection().addRange(A.doc.createRange()))):A.selection.clear(),A.helpers.isIOS()&&(A.events.disableBlur(),A.$el.blur()),A.button.bulkRefresh(),A.events.trigger("video.hideResizer")}function ce(e){C&&(function t(){return de}()||!0===e)&&(A.toolbar.enable(),p.removeClass("fr-active"),A.popups.hideAll(),C=null,me(),f=null,g&&g.hide())}r[i]="Image cannot be loaded from the passed link.",r[c]="No link in upload response.",r[d]="Error during file upload.",r[u]="Parsing response failed.",r[R]="File is too large.",r[U]="Image file type is invalid.",r[7]="Files can be uploaded only to same domain in IE 8 and IE 9.";var de=!(r[8]="Image file is corrupted.");function ue(){de=!0}function me(){de=!1}function he(e,t,a){if(!A.opts.htmlUntouched&&A.opts.useClasses)e.removeClass("fr-fil fr-fir fr-dib fr-dii"),a&&e.addClass("fr-fi".concat(a[0])),t&&e.addClass("fr-di".concat(t[0]));else if("inline"==t)if(e.css({display:"inline-block",verticalAlign:"bottom",margin:A.opts.imageDefaultMargin}),"center"==a)e.css({"float":"none",marginBottom:"",marginTop:"",maxWidth:"calc(100% - ".concat(2*A.opts.imageDefaultMargin,"px)"),textAlign:"center"});else if("left"==a){var i="0px",r=e.parent("span.fr-img-caption").get(0);r||(r=e.parent().get(0)),r&&"li"===r.tagName.toLowerCase()?i="20px":r&&"p"===r.tagName.toLowerCase()&&(i="15px"),e.css({"float":"left",marginLeft:0,maxWidth:"calc(100% - ".concat(A.opts.imageDefaultMargin,"px)"),textAlign:"left",marginRight:i})}else e.css({"float":"right",marginRight:0,maxWidth:"calc(100% - ".concat(A.opts.imageDefaultMargin,"px)"),textAlign:"right"});else"block"==t&&(e.css({display:"block","float":"none",verticalAlign:"top",margin:"".concat(A.opts.imageDefaultMargin,"px auto"),textAlign:"center"}),"left"==a?e.css({marginLeft:0,textAlign:"left"}):"right"==a&&e.css({marginRight:0,textAlign:"right"}))}function ve(e){if(void 0===e&&(e=Ce()),e){if(e.hasClass("fr-fil"))return"left";if(e.hasClass("fr-fir"))return"right";if(e.hasClass("fr-dib")||e.hasClass("fr-dii"))return"center";var t=e.css("float");if(e.css("float","none"),"block"==e.css("display")){if(e.css("float",""),e.css("float")!=t&&e.css("float",t),0===parseInt(e.css("margin-left"),10))return"left";if(0===parseInt(e.css("margin-right"),10))return"right"}else{if(e.css("float",""),e.css("float")!=t&&e.css("float",t),"left"==e.css("float"))return"left";if("right"==e.css("float"))return"right"}}return"center"}function be(e){void 0===e&&(e=Ce());var t=e.css("float");return e.css("float","none"),"block"==e.css("display")?(e.css("float",""),e.css("float")!=t&&e.css("float",t),"block"):(e.css("float",""),e.css("float")!=t&&e.css("float",t),"inline")}function ye(){var e=A.popups.get("image.insert");e||(e=X()),A.popups.isVisible("image.insert")||(k(),A.popups.refresh("image.insert"),A.popups.setContainer("image.insert",A.$sc));var t=Ce(),a=t&&t.outerWidth()/2;Se()&&(t=t.find(".fr-img-wrap"),a=C.outerWidth()/2);var i,r=t.offset().left+a,n=t.outerHeight(!0);A.opts.iframe&&Se()&&(n=C?C.outerHeight():0),i=0<A.$el.find("img[data-fr-image-pasted]").length?A.$wp.offset().top-A.helpers.scrollTop()+A.$wp.height():t.offset().top+t.outerHeight(),A.popups.show("image.insert",r,i,n,!0)}function we(){if(C){A.events.disableBlur(),A.selection.clear();var e=A.doc.createRange();e.selectNode(C.get(0)),A.browser.msie&&e.collapse(!0),A.selection.get().addRange(e),A.events.enableBlur()}}function Ae(){return C}function Ce(){return Se()?C.parents(".fr-img-caption").first():C}function Se(){return!!C&&0<C.parents(".fr-img-caption").length}function Ee(e){for(var t=document.createDocumentFragment();e.firstChild;){var a=e.removeChild(e.firstChild);t.appendChild(a)}e.parentNode.replaceChild(t,e)}return{_init:function Re(){var n;(function e(){A.events.$on(A.$el,A._mousedown,"IMG"==A.el.tagName?null:'img:not([contenteditable="false"])',function(e){if("false"==S(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable"))return!0;A.helpers.isMobile()||A.selection.clear(),t=!0,A.popups.areVisible()&&A.events.disableBlur(),A.browser.msie&&(A.events.disableBlur(),A.$el.attr("contenteditable",!1)),A.draggable||"touchstart"==e.type||e.preventDefault(),e.stopPropagation()}),A.events.$on(A.$el,A._mousedown,".fr-img-caption .fr-inner",function(e){A.core.hasFocus()||A.events.focus(),e.stopPropagation()}),A.events.$on(A.$el,"paste",".fr-img-caption .fr-inner",function(e){!0===A.opts.toolbarInline&&(A.toolbar.hide(),e.stopPropagation())}),A.events.$on(A.$el,A._mousedown,'img:not([contenteditable="false"])',function(e){var t=this;A.browser.mozilla&&3==e.which&&(S(this).attr("contenteditable",!1),setTimeout(function(){S(t).removeAttr("contenteditable")},200))}),A.events.$on(A.$el,A._mouseup,"IMG"==A.el.tagName?null:'img:not([contenteditable="false"])',function(e){if("false"==S(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable"))return!0;t&&(t=!1,e.stopPropagation(),A.browser.msie&&(A.$el.attr("contenteditable",!0),A.events.enableBlur()))}),A.events.on("keyup",function(e){if(e.shiftKey&&""===A.selection.text().replace(/\n/g,"")&&A.keys.isArrow(e.which)){var t=A.selection.element(),a=A.selection.endElement();t&&"IMG"==t.tagName?z(S(t)):a&&"IMG"==a.tagName&&z(S(a))}},!0),A.events.on("drop",V),A.events.on("element.beforeDrop",F),A.events.on("mousedown window.mousedown",ue),A.events.on("window.touchmove",me),A.events.on("mouseup window.mouseup",function(){if(C&&!A.helpers.isMobile())return ce(),!1;me()}),A.events.on("touchstart touchend",function(){if(C&&A.helpers.isMobile())return ce(),!1;me()}),A.events.on("commands.mousedown",function(e){0<e.parents(".fr-toolbar").length&&ce()}),A.events.on("image.resizeEnd",function(){A.opts.iframe&&A.size.syncIframe()}),A.events.on("blur image.hideResizer commands.undo commands.redo element.dropped",function(){ce(!(t=!1))}),A.events.on("modals.hide",function(){C&&(we(),A.selection.clear())}),A.events.on("image.resizeEnd",function(){A.win.getSelection&&z(C)}),A.events.on("filestack-init",function(){X()}),A.events.on("filestack-init-edit",function(){for(var e=A.$(".fr-popup"),t=e.length-1;0<=t;t--)e[t].parentElement.removeChild(e[t]);N()}),A.opts.imageAddNewLine&&A.events.on("image.inserted",function(e){var t=e.get(0);for(t.nextSibling&&"BR"===t.nextSibling.tagName&&(t=t.nextSibling);t&&!A.node.isElement(t);)t=A.node.isLastSibling(t)?t.parentNode:null;A.node.isElement(t)&&(A.opts.enter===Me.ENTER_BR?e.after("<br>"):S(A.node.blockParent(e.get(0))).after("<".concat(A.html.defaultTag(),"><br></").concat(A.html.defaultTag(),">")))})})(),"IMG"==A.el.tagName&&A.$el.addClass("fr-view"),A.events.$on(A.$el,A.helpers.isMobile()&&!A.helpers.isWindowsPhone()?"touchend":"click","IMG"==A.el.tagName?null:'img:not([contenteditable="false"])',ge),A.helpers.isMobile()&&(A.events.$on(A.$el,"touchstart","IMG"==A.el.tagName?null:'img:not([contenteditable="false"])',function(){a=!1}),A.events.$on(A.$el,"touchmove",function(){a=!0})),A.$wp?(A.events.on("window.keydown keydown",ie,!0),A.events.on("keyup",function(e){if(C&&e.which==Me.KEYCODE.ENTER)return!1},!0),A.events.$on(A.$el,"keydown",function(){var e=A.selection.element();(e.nodeType===Node.TEXT_NODE||"BR"==e.tagName&&A.node.isLastSibling(e))&&(e=e.parentNode),A.node.hasClass(e,"fr-inner")||(A.node.hasClass(e,"fr-img-caption")||(e=S(e).parents(".fr-img-caption").get(0)),A.node.hasClass(e,"fr-img-caption")&&(A.opts.trackChangesEnabled||S(e).after(Me.INVISIBLE_SPACE+Me.MARKERS),A.selection.restore()))})):A.events.$on(A.$win,"keydown",ie),A.events.on("toolbar.esc",function(){if(C){if(A.$wp)A.events.disableBlur(),A.events.focus();else{var e=C;ce(!0),A.selection.setAfter(e.get(0)),A.selection.restore()}return!1}},!0),A.events.on("toolbar.focusEditor",function(){if(C)return!1},!0),A.events.on("window.cut window.copy",function(e){if(C&&A.popups.isVisible("image.edit")&&!A.popups.get("image.edit").find(":focus").length){var t=Ce();Se()?(t.before(Me.START_MARKER),t.after(Me.END_MARKER),A.selection.restore(),A.paste.saveCopiedText(t.get(0).outerHTML,t.text())):(we(),A.paste.saveCopiedText(C.get(0).outerHTML,C.attr("alt"))),"copy"==e.type?setTimeout(function(){z(C)}):(ce(!0),A.undo.saveStep(),setTimeout(function(){A.undo.saveStep()},0))}},!0),A.browser.msie&&A.events.on("keydown",function(e){if(!A.selection.isCollapsed()||!C)return!0;var t=e.which;t==Me.KEYCODE.C&&A.keys.ctrlKey(e)?A.events.trigger("window.copy"):t==Me.KEYCODE.X&&A.keys.ctrlKey(e)&&A.events.trigger("window.cut")}),A.events.$on(S(A.o_win),"keydown",function(e){if(A.opts.pluginsEnabled.includes("filestack")&&A.opts.iframe){var t=document.getElementsByClassName("fs-transforms-container"),a=!1;if(t&&t.length){var i,r=Ke(t);try{for(r.s();!(i=r.n()).done;){var n=i.value;n.childNodes&&n.childNodes.length&&(a=!0)}}catch(s){r.e(s)}finally{r.f()}}a&&(C=null)}var o=e.which;if(C&&o==Me.KEYCODE.BACKSPACE)return e.preventDefault(),!1}),A.events.$on(A.$win,"keydown",function(e){var t=e.which;C&&C.hasClass("fr-uploading")&&t==Me.KEYCODE.ESC&&C.trigger("abortUpload")}),A.events.on("destroy",function(){C&&C.hasClass("fr-uploading")&&C.trigger("abortUpload")}),A.events.on("paste.before",pe),A.events.on("paste.beforeCleanup",fe),A.events.on("paste.after",oe),A.events.on("html.set",v),A.events.on("html.inserted",v),v(),A.events.on("destroy",function(){s=[]}),A.events.on("html.processGet",re),A.opts.imageOutputSize&&A.events.on("html.beforeGet",function(){n=A.el.querySelectorAll("img");for(var e=0;e<n.length;e++){var t=parseFloat(S(n[e]).css("padding-left"))+parseFloat(S(n[e]).css("padding-right")),a=S(n[e]).width()-t,i=n[e].style.width||a,r=n[e].style.height||S(n[e]).height();i&&n[e].setAttribute("width","".concat(i).replace(/px/,"")),r&&n[e].setAttribute("height","".concat(r).replace(/px/,""))}}),A.opts.iframe&&A.events.on("image.loaded",A.size.syncIframe),A.$wp&&(b(),A.events.on("contentChanged",b)),A.events.$on(S(A.o_win),"orientationchange.image",function(){setTimeout(function(){C&&z(C)},100)}),N(!0),X(!0),ee(!0),J(!0),A.events.on("node.remove",function(e){if("IMG"==e.get(0).tagName)return ae(e),!1})},showInsertPopup:function Ue(){var e=A.$tb.find('.fr-command[data-cmd="insertImage"]'),t=A.popups.get("image.insert");if(t||(t=X()),k(),!t.hasClass("fr-active"))if(A.popups.refresh("image.insert"),A.popups.setContainer("image.insert",A.$tb),e.isVisible()){var a=A.button.getPosition(e),i=a.left,r=a.top;A.popups.show("image.insert",i,r,e.outerHeight())}else A.position.forSelection(t),A.popups.show("image.insert")},showLayer:function xe(e){var t,a,i=A.popups.get("image.insert");if(C||A.opts.toolbarInline){if(C){var r=Ce(),n=0;Se()&&(r=r.find(".fr-img-wrap"),n=C.outerWidth()/2),a=r.offset().top+r.outerHeight(),t=r.offset().left+n}}else{var o=A.$tb.find('.fr-command[data-cmd="insertImage"]');t=o.offset().left,a=o.offset().top+(A.opts.toolbarBottom?10:o.outerHeight()-10)}!C&&A.opts.toolbarInline&&(a=i.offset().top-A.helpers.getPX(i.css("margin-top")),i.hasClass("fr-above")&&(a+=i.outerHeight())),i.find(".fr-layer").removeClass("fr-active"),i.find(".fr-".concat(e,"-layer")).addClass("fr-active"),A.popups.show("image.insert",t,a,C?C.outerHeight():0,Se()),A.accessibility.focusPopup(i)},refreshUploadButton:function De(e){var t=A.popups.get("image.insert");t&&t.find(".fr-image-upload-layer").hasClass("fr-active")&&e.addClass("fr-active").attr("aria-pressed",!0)},refreshByURLButton:function Te(e){var t=A.popups.get("image.insert");t&&t.find(".fr-image-by-url-layer").hasClass("fr-active")&&e.addClass("fr-active").attr("aria-pressed",!0)},upload:H,insertByURL:function $e(){var e=A.popups.get("image.insert").find(".fr-image-by-url-layer input");if(0<e.val().length){P(),B(A.language.translate("Loading image"));var t=e.val().trim();if(A.opts.imageUploadRemoteUrls&&A.opts.imageCORSProxy&&A.opts.imageUpload){var a=new XMLHttpRequest;a.onload=function(){200==this.status?H([new Blob([this.response],{type:this.response.type||"image/png"})],C):I(i)},a.onerror=function(){_(t,!0,[],C)},a.open("GET","".concat(A.opts.imageCORSProxy,"/").concat(t),!0),a.responseType="blob",a.send()}else _(t,!0,[],C);e.val(""),e.blur()}},align:function Ie(e){var t=Ce();t.removeClass("fr-fir fr-fil"),!A.opts.htmlUntouched&&A.opts.useClasses?"left"==e?t.addClass("fr-fil"):"right"==e&&t.addClass("fr-fir"):he(t,be(),e),we(),x(),n(),A.selection.clear()},refreshAlign:function Ne(e){C&&e.find("> *").first().replaceWith(A.icon.create("image-align-".concat(ve())))},refreshAlignOnShow:function Pe(e,t){C&&t.find('.fr-command[data-param1="'.concat(ve(),'"]')).addClass("fr-active").attr("aria-selected",!0)},display:function ke(e){var t=Ce();t.removeClass("fr-dii fr-dib"),!A.opts.htmlUntouched&&A.opts.useClasses?"inline"==e?t.addClass("fr-dii"):"block"==e&&t.addClass("fr-dib"):he(t,e,ve()),we(),x(),n(),A.selection.clear()},refreshDisplayOnShow:function Be(e,t){C&&t.find('.fr-command[data-param1="'.concat(be(),'"]')).addClass("fr-active").attr("aria-selected",!0)},replace:ye,back:function e(){C?(A.events.disableBlur(),S(".fr-popup input:focus").blur(),z(C)):(A.events.disableBlur(),A.selection.restore(),A.events.enableBlur(),A.popups.hide("image.insert"),A.toolbar.showInline())},get:Ae,getEl:Ce,insert:_,showProgressBar:P,remove:ae,hideProgressBar:k,applyStyle:function Oe(e,t,a){if(void 0===t&&(t=A.opts.imageStyles),void 0===a&&(a=A.opts.imageMultipleStyles),!C)return!1;var i=Ce();if(!a){var r=Object.keys(t);r.splice(r.indexOf(e),1),i.removeClass(r.join(" "))}"object"==Ye(t[e])?(i.removeAttr("style"),i.css(t[e].style)):(i.toggleClass(e),Se()&&C.hasClass(e)&&C.removeClass(e)),z(C)},showAltPopup:j,showSizePopup:Z,setAlt:function ze(e){if(C){var t=A.popups.get("image.alt");C.attr("alt",e||t.find("input").val()||""),t.find("input:focus").blur(),z(C)}},setSize:function Le(e,t){if(C){var a=A.popups.get("image.size");e=e||a.find('input[name="width"]').val()||"",t=t||a.find('input[name="height"]').val()||"";var i=/^[\d]+((px)|%)*$/g;C.removeAttr("width").removeAttr("height"),e.match(i)?C.css("width",e):C.css("width",""),t.match(i)?C.css("height",t):C.css("height",""),Se()&&(C.parents(".fr-img-caption").removeAttr("width").removeAttr("height"),e.match(i)?C.parents(".fr-img-caption").css("width",e):C.parents(".fr-img-caption").css("width",""),t.match(i)?C.parents(".fr-img-caption").css("height",t):C.parents(".fr-img-caption").css("height","")),a&&a.find("input:focus").blur(),z(C)}},toggleCaption:function _e(){var e;if(C&&!Se()){(e=C).parent().is("a")&&(e=C.parent());var t,a,i=C.parents("ul")&&0<C.parents("ul").length?C.parents("ul"):C.parents("ol")&&0<C.parents("ol").length?C.parents("ol"):[];if(0<i.length){var r=i.find("li").length,n=C.parents("li"),o=document.createElement("li");r-1===n.index()&&(i.append(o),o.innerHTML="&nbsp;")}e.attr("style")?a=-1<(t=e.attr("style").split(":")).indexOf("width")?t[t.indexOf("width")+1].replace(";",""):"":e.attr("width")&&(a=e.attr("width"));var s=A.opts.imageResizeWithPercent?(-1<a.indexOf("px")?null:a)||"100%":C.width()+"px";e.wrap('<div class="fr-img-space-wrap"><span '+(A.browser.mozilla?"":'contenteditable="false"')+'class="fr-img-caption '+C.attr("class")+'" style="'+(A.opts.useClasses?"":e.attr("style"))+'" draggable="false"></span></div>'),e.wrap('<span class="fr-img-wrap"></span>'),C.after('<span class="fr-inner"'.concat(A.browser.mozilla?"":' contenteditable="true"',">").concat(Me.START_MARKER).concat(A.language.translate("Image Caption")).concat(Me.END_MARKER,"</span>")),C.parents(".fr-img-caption").css("width",s);var l=C.parents(".fr-img-space-wrap").length;1==l?Ee(document.querySelector(".fr-img-space-wrap")):1<l&&(Ee(document.querySelector(".fr-img-space-wrap")),Ee(document.querySelector(".fr-img-space-wrap2"))),ce(!0),A.selection.restore()}else{if(e=Ce(),C.insertBefore(e),null!==e[0].querySelector("a")){for(var p,f=e[0].querySelector("a"),g=document.createElement("a"),c=0,d=f.attributes,u=d.length;c<u;c++)p=d[c],g.setAttribute(p.nodeName,p.nodeValue);C.wrap(g)}C.attr("class",e.attr("class").replace("fr-img-caption","")).attr("style",e.attr("style")),e.remove();var m=C.parents(".fr-img-space-wrap").length;1==m?Ee(document.querySelector(".fr-img-space-wrap")):1<m&&(Ee(document.querySelector(".fr-img-space-wrap")),Ee(document.querySelector(".fr-img-space-wrap2"))),z(C)}},hasCaption:Se,exitEdit:ce,edit:z}},Me.DefineIcon("insertImage",{NAME:"image",SVG_KEY:"insertImage"}),Me.RegisterShortcut(Me.KEYCODE.P,"insertImage",null,"P"),Me.RegisterCommand("insertImage",{title:"Insert Image",undo:!1,focus:!0,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible("image.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("image.insert")):this.image.showInsertPopup()},plugin:"image"}),Me.DefineIcon("imageUpload",{NAME:"upload",SVG_KEY:"upload"}),Me.RegisterCommand("imageUpload",{title:"Upload Image",undo:!1,focus:!1,toggle:!0,callback:function(){this.image.showLayer("image-upload")},refresh:function(e){this.image.refreshUploadButton(e)}}),Me.DefineIcon("imageByURL",{NAME:"link",SVG_KEY:"insertLink"}),Me.RegisterCommand("imageByURL",{title:"By URL",undo:!1,focus:!1,toggle:!0,callback:function(){this.image.showLayer("image-by-url")},refresh:function(e){this.image.refreshByURLButton(e)}}),Me.RegisterCommand("imageInsertByURL",{title:"Insert Image",undo:!0,refreshAfterCallback:!1,callback:function(){this.image.insertByURL()},refresh:function(e){this.image.get()?e.text(this.language.translate("Replace")):e.text(this.language.translate("Insert"))}}),Me.DefineIcon("imageDisplay",{NAME:"star",SVG_KEY:"imageDisplay"}),Me.RegisterCommand("imageDisplay",{title:"Display",type:"dropdown",options:{inline:"Inline",block:"Break Text"},callback:function(e,t){this.image.display(t)},refresh:function(e){this.opts.imageTextNear||e.addClass("fr-hidden")},refreshOnShow:function(e,t){this.image.refreshDisplayOnShow(e,t)}}),Me.DefineIcon("image-align",{NAME:"align-left",SVG_KEY:"alignLeft"}),Me.DefineIcon("image-align-left",{NAME:"align-left",SVG_KEY:"alignLeft"}),Me.DefineIcon("image-align-right",{NAME:"align-right",SVG_KEY:"alignRight"}),Me.DefineIcon("image-align-center",{NAME:"align-justify",SVG_KEY:"alignCenter"}),Me.DefineIcon("imageAlign",{NAME:"align-justify",SVG_KEY:"alignJustify"}),Me.RegisterCommand("imageAlign",{type:"dropdown",title:"Align",options:{left:"Align Left",center:"None",right:"Align Right"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=Me.COMMANDS.imageAlign.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="imageAlign" data-param1="'.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.icon.create("image-align-".concat(a)),'<span class="fr-sr-only">').concat(this.language.translate(t[a]),"</span></a></li>"));return e+="</ul>"},callback:function(e,t){this.image.align(t)},refresh:function(e){this.image.refreshAlign(e)},refreshOnShow:function(e,t){this.image.refreshAlignOnShow(e,t)}}),Me.DefineIcon("imageReplace",{NAME:"exchange",FA5NAME:"exchange-alt",SVG_KEY:"replaceImage"}),Me.RegisterCommand("imageReplace",{title:"Replace",undo:!1,focus:!1,popup:!0,refreshAfterCallback:!1,callback:function(){this.image.replace()}}),Me.DefineIcon("imageRemove",{NAME:"trash",SVG_KEY:"remove"}),Me.RegisterCommand("imageRemove",{title:"Remove",callback:function(){this.image.remove()}}),Me.DefineIcon("imageBack",{NAME:"arrow-left",SVG_KEY:"back"}),Me.RegisterCommand("imageBack",{title:"Back",undo:!1,focus:!1,back:!0,callback:function(){this.image.back()},refresh:function(e){this.$;this.image.get()||this.opts.toolbarInline?(e.removeClass("fr-hidden"),e.next(".fr-separator").removeClass("fr-hidden")):(e.addClass("fr-hidden"),e.next(".fr-separator").addClass("fr-hidden"))}}),Me.RegisterCommand("imageDismissError",{title:"OK",undo:!1,callback:function(){this.image.hideProgressBar(!0)}}),Me.DefineIcon("imageStyle",{NAME:"magic",SVG_KEY:"imageClass"}),Me.RegisterCommand("imageStyle",{title:"Style",type:"dropdown",html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.imageStyles;for(var a in t)if(t.hasOwnProperty(a)){var i=t[a];"object"==Ye(i)&&(i=i.title),e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="imageStyle" data-param1="'.concat(a,'">').concat(this.language.translate(i),"</a></li>")}return e+="</ul>"},callback:function(e,t){this.image.applyStyle(t)},refreshOnShow:function(e,t){var a=this.$,i=this.image.getEl();i&&t.find(".fr-command").each(function(){var e=a(this).data("param1"),t=i.hasClass(e);a(this).toggleClass("fr-active",t).attr("aria-selected",t)})}}),Me.DefineIcon("imageAlt",{NAME:"info",SVG_KEY:"imageAltText"}),Me.RegisterCommand("imageAlt",{undo:!1,focus:!1,popup:!0,title:"Alternative Text",callback:function(){this.image.showAltPopup()}}),Me.RegisterCommand("imageSetAlt",{undo:!0,focus:!1,title:"Update",refreshAfterCallback:!1,callback:function(){this.image.setAlt()}}),Me.DefineIcon("imageSize",{NAME:"arrows-alt",SVG_KEY:"imageSize"}),Me.RegisterCommand("imageSize",{undo:!1,focus:!1,popup:!0,title:"Change Size",callback:function(){this.image.showSizePopup()}}),Me.RegisterCommand("imageSetSize",{undo:!0,focus:!1,title:"Update",refreshAfterCallback:!1,callback:function(){this.image.setSize()}}),Me.DefineIcon("imageCaption",{NAME:"commenting",FA5NAME:"comment-alt",SVG_KEY:"imageCaption"}),Me.RegisterCommand("imageCaption",{undo:!0,focus:!1,title:"Image Caption",refreshAfterCallback:!0,callback:function(){this.image.toggleCaption()},refresh:function(e){this.image.get()&&e.toggleClass("fr-active",this.image.hasCaption())}})});

/***/ }),

/***/ 8867:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(e,t){ true?t(__webpack_require__(189)):0}(this,function(l){"use strict";l=l&&l.hasOwnProperty("default")?l["default"]:l,Object.assign(l.DEFAULTS,{lineHeights:{Default:"",Single:"1",1.15:"1.15",1.5:"1.5",Double:"2"}}),l.PLUGINS.lineHeight=function(n){var o=n.$;return{_init:function e(){},apply:function a(e){n.selection.save(),n.html.wrap(!0,!0,!0,!0),n.selection.restore();var t=n.selection.blocks();t.length&&o(t[0]).parent().is("td")&&n.format.applyStyle("line-height",e.toString()),n.selection.save();for(var i=0;i<t.length;i++)o(t[i]).css("line-height",e),n.opts.enter!==l.ENTER_BR||t.length&&o(t[0]).parent().is("td")||(o(t[i]).hasClass("fr-temp-div")&&o(t[i]).removeClass("fr-temp-div"),""===o(t[i]).attr("class")&&o(t[i]).removeAttr("class")),""===o(t[i]).attr("style")&&o(t[i]).removeAttr("style");n.html.unwrap(),n.selection.restore()},refreshOnShow:function r(e,t){var i=n.selection.blocks();if(i.length){var l=o(i[0]);t.find(".fr-command").each(function(){var e=o(this).data("param1"),t=l.attr("style"),i=0<=(t||"").indexOf("line-height: "+e+";");if(t){var n=t.substring(t.indexOf("line-height")),a=n.substr(0,n.indexOf(";")),r=a&&a.split(":")[1];r&&r.length||"Default"!==l.text()||(i=!0)}t&&-1!==t.indexOf("line-height")||""!==e||(i=!0),o(this).toggleClass("fr-active",i).attr("aria-selected",i)})}}}},l.RegisterCommand("lineHeight",{type:"dropdown",html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.lineHeights;for(var i in t)t.hasOwnProperty(i)&&(e+='<li role="presentation"><a class="fr-command '.concat(i,'" tabIndex="-1" role="option" data-cmd="lineHeight" data-param1="').concat(t[i],'" title="').concat(this.language.translate(i),'">').concat(this.language.translate(i),"</a></li>"));return e+="</ul>"},title:"Line Height",callback:function(e,t){this.lineHeight.apply(t)},refreshOnShow:function(e,t){this.lineHeight.refreshOnShow(e,t)},plugin:"lineHeight"}),l.DefineIcon("lineHeight",{NAME:"arrows-v",FA5NAME:"arrows-alt-v",SVG_KEY:"lineHeight"})});

/***/ }),

/***/ 9699:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(e,t){ true?t(__webpack_require__(189)):0}(this,function(y){"use strict";y=y&&y.hasOwnProperty("default")?y["default"]:y,Object.assign(y.POPUP_TEMPLATES,{"link.edit":"[_BUTTONS_]","link.insert":"[_BUTTONS_][_INPUT_LAYER_]"}),Object.assign(y.DEFAULTS,{linkEditButtons:["linkOpen","linkStyle","linkEdit","linkRemove"],linkInsertButtons:["linkBack","|","linkList"],linkAttributes:{},linkAutoPrefix:"http://",linkStyles:{"fr-green":"Green","fr-strong":"Thick"},linkMultipleStyles:!0,linkConvertEmailAddress:!0,linkAlwaysBlank:!1,linkAlwaysNoFollow:!1,linkNoOpener:!0,linkNoReferrer:!0,linkList:[{text:"Froala",href:"https://froala.com",target:"_blank"},{text:"Google",href:"https://google.com",target:"_blank"},{displayText:"Facebook",href:"https://facebook.com"}],linkText:!0}),y.PLUGINS.link=function(h){var m=h.$;function v(){var e=h.image?h.image.get():null;if(e||!h.$wp)return"A"==h.el.tagName?h.el:e&&e.get(0).parentNode&&"A"==e.get(0).parentNode.tagName?e.get(0).parentNode:void 0;var t=h.selection.ranges(0).commonAncestorContainer;try{t&&(t.contains&&t.contains(h.el)||!h.el.contains(t)||h.el==t)&&(t=null)}catch(l){t=null}if(t&&"A"===t.tagName)return t;var n,i,r=h.selection.element(),a=h.selection.endElement();"A"==r.tagName||h.node.isElement(r)||(r=h.opts.iframe&&null!==(n=h.markdown)&&void 0!==n&&n.isEnabled?null:m(r).parentsUntil(h.$el,"a").first().get(0));"A"==a.tagName||h.node.isElement(a)||(a=h.opts.iframe&&null!==(i=h.markdown)&&void 0!==i&&i.isEnabled?null:m(a).parentsUntil(h.$el,"a").first().get(0));try{a&&(a.contains&&a.contains(h.el)||!h.el.contains(a)||h.el==a)&&(a=null)}catch(l){a=null}try{r&&(r.contains&&r.contains(h.el)||!h.el.contains(r)||h.el==r)&&(r=null)}catch(l){r=null}return a&&a==r&&"A"==a.tagName?(h.browser.msie||h.helpers.isMobile())&&(h.selection.info(r).atEnd||h.selection.info(r).atStart)?null:r:null}function b(){var e,t,n,i,r=h.image?h.image.get():null,a=[];if(r)"A"==r.get(0).parentNode.tagName&&a.push(r.get(0).parentNode);else if(h.win.getSelection){var l=h.win.getSelection();if(l.getRangeAt&&l.rangeCount){i=h.doc.createRange();for(var s=0;s<l.rangeCount;++s)if((t=(e=l.getRangeAt(s)).commonAncestorContainer)&&1!=t.nodeType&&(t=t.parentNode),t&&"a"==t.nodeName.toLowerCase())a.push(t);else{n=t.getElementsByTagName("a");for(var o=0;o<n.length;++o)i.selectNodeContents(n[o]),i.compareBoundaryPoints(e.END_TO_START,e)<1&&-1<i.compareBoundaryPoints(e.START_TO_END,e)&&a.push(n[o])}}}else if(h.doc.selection&&"Control"!=h.doc.selection.type)if("a"==(t=(e=h.doc.selection.createRange()).parentElement()).nodeName.toLowerCase())a.push(t);else{n=t.getElementsByTagName("a"),i=h.doc.body.createTextRange();for(var p=0;p<n.length;++p)i.moveToElementText(n[p]),-1<i.compareEndPoints("StartToEnd",e)&&i.compareEndPoints("EndToStart",e)<1&&a.push(n[p])}return a}function E(r){if(h.core.hasFocus()||h.opts.iframe&&(!document.hasFocus||document.hasFocus())){if(a(),r&&"keyup"===r.type&&(r.altKey||r.which==y.KEYCODE.ALT))return!0;setTimeout(function(){if(!r||r&&(1==r.which||"mouseup"!=r.type)){var e=v(),t=h.image?h.image.get():null;if(e&&!t){if(h.image){var n=h.node.contents(e);if(1==n.length&&"IMG"==n[0].tagName){var i=h.selection.ranges(0);return 0===i.startOffset&&0===i.endOffset?m(e).before(y.INVISIBLE_SPACE+y.MARKERS):m(e).after(y.INVISIBLE_SPACE+y.MARKERS),h.selection.restore(),!1}}r&&r.stopPropagation(),l(e)}}},h.helpers.isIOS()?100:0)}}function l(e){var t=h.popups.get("link.edit");t||(t=function a(){var e="";1<=h.opts.linkEditButtons.length&&("A"==h.el.tagName&&0<=h.opts.linkEditButtons.indexOf("linkRemove")&&h.opts.linkEditButtons.splice(h.opts.linkEditButtons.indexOf("linkRemove"),1),e='<div class="fr-buttons">'.concat(h.button.buildList(h.opts.linkEditButtons),"</div>"));var t={buttons:e},n=h.popups.create("link.edit",t);h.$wp&&h.events.$on(h.$wp,"scroll.link-edit",function(){v()&&h.popups.isVisible("link.edit")&&l(v())});return n}());var n=m(e);h.popups.isVisible("link.edit")||h.popups.refresh("link.edit"),h.popups.setContainer("link.edit",h.$sc);var i=n.offset().left+n.outerWidth()/2,r=n.offset().top+n.outerHeight();h.popups.show("link.edit",i,r,n.outerHeight(),!0)}function a(){h.popups.hide("link.edit")}function o(){var e=h.popups.get("link.insert"),t=v();if(t){var n,i,r=m(t),a=e.find('input.fr-link-attr[type="text"]'),l=e.find('input.fr-link-attr[type="checkbox"]');for(n=0;n<a.length;n++){var s=(i=m(a[n])).attr("name")||"",o="href"===s?decodeURI(r.attr(s)):r.attr(s);i.val(o)}for(l.attr("checked",!1),n=0;n<l.length;n++)i=m(l[n]),r.attr(i.attr("name"))==i.data("checked")&&i.attr("checked",!0);e.find('input.fr-link-attr[type="text"][name="text"]').val(r.text())}else e.find('input.fr-link-attr[type="text"]').val(""),e.find('input.fr-link-attr[type="checkbox"]').attr("checked",!1),e.find('input.fr-link-attr[type="text"][name="text"]').val(h.selection.text());e.find("input.fr-link-attr").trigger("change"),(h.image?h.image.get():null)?e.find('.fr-link-attr[name="text"]').parent().hide():e.find('.fr-link-attr[name="text"]').parent().show()}function s(e){if(e)return h.popups.onRefresh("link.insert",o),!0;var t="";1<=h.opts.linkInsertButtons.length&&(t='<div class="fr-buttons fr-tabs">'.concat(h.button.buildList(h.opts.linkInsertButtons),"</div>"));var n="",i=0;for(var r in n='<div class="fr-link-insert-layer fr-layer fr-active" id="fr-link-insert-layer-'.concat(h.id,'">'),n+='<div class="fr-input-line"><input id="fr-link-insert-layer-url-'.concat(h.id,'" name="href" type="text" class="fr-link-attr" placeholder="').concat(h.language.translate("URL"),'" tabIndex="').concat(++i,'"></div>'),h.opts.linkText&&(n+='<div class="fr-input-line"><input id="fr-link-insert-layer-text-'.concat(h.id,'" name="text" type="text" class="fr-link-attr" placeholder="').concat(h.language.translate("Text"),'" tabIndex="').concat(++i,'"></div>')),h.opts.linkAttributes)if(h.opts.linkAttributes.hasOwnProperty(r)){var a=h.opts.linkAttributes[r];n+='<div class="fr-input-line"><input name="'.concat(r,'" type="text" class="fr-link-attr" placeholder="').concat(h.language.translate(a),'" tabIndex="').concat(++i,'"></div>')}h.opts.linkAlwaysBlank||(n+='<div class="fr-checkbox-line"><span class="fr-checkbox"><input name="target" class="fr-link-attr" data-checked="_blank" type="checkbox" id="fr-link-target-'.concat(h.id,'" tabIndex="').concat(++i,'"><span>').concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>','</span></span><label id="fr-label-target-').concat(h.id,'">').concat(h.language.translate("Open in new tab"),"</label></div>"));var l={buttons:t,input_layer:n+='<div class="fr-action-buttons"><button class="fr-command fr-submit" role="button" data-cmd="linkInsert" href="#" tabIndex="'.concat(++i,'" type="button">').concat(h.language.translate("Insert"),"</button></div></div>")},s=h.popups.create("link.insert",l);return h.$wp&&h.events.$on(h.$wp,"scroll.link-insert",function(){(h.image?h.image.get():null)&&h.popups.isVisible("link.insert")&&f(),h.popups.isVisible("link.insert")&&c()}),s}function p(e,t,n){if(h.opts.trackChangesEnabled){if(h.edit.on(),h.events.focus(!0),h.undo.saveStep(),h.markers.insert(),h.html.wrap(),!h.$el.find(".fr-marker").length)return void h.popups.hide("link.insert");h.markers.remove()}if(void 0===n&&(n={}),!1===h.events.trigger("link.beforeInsert",[e,t,n]))return!1;var i=h.image?h.image.get():null;i||"A"==h.el.tagName?"A"==h.el.tagName&&h.$el.focus():(h.selection.restore(),h.popups.hide("link.insert"));var r=e;h.opts.linkConvertEmailAddress&&h.helpers.isEmail(e)&&!/^mailto:.*/i.test(e)&&(e="mailto:".concat(e));if(""===h.opts.linkAutoPrefix||new RegExp("^("+y.LinkProtocols.join("|")+"):.","i").test(e)||/^data:image.*/i.test(e)||/^(https?:|ftps?:|file:|)\/\//i.test(e)||/^([A-Za-z]:(\\){1,2}|[A-Za-z]:((\\){1,2}[^\\]+)+)(\\)?$/i.test(e)||["/","{","[","#","(",".",'"',"\\"].indexOf((e||"")[0])<0&&(e=h.opts.linkAutoPrefix+e),e=h.helpers.sanitizeURL(e),e=encodeURI(e),h.opts.linkAlwaysBlank&&(n.target="_blank"),h.opts.linkAlwaysNoFollow&&(n.rel="nofollow"),h.helpers.isEmail(r)&&(n.target=null,n.rel=null),"_blank"==n.target?(h.opts.linkNoOpener&&(n.rel?n.rel+=" noopener":n.rel="noopener"),h.opts.linkNoReferrer&&(n.rel?n.rel+=" noreferrer":n.rel="noreferrer")):null==n.target&&(n.rel?n.rel=n.rel.replace(/noopener/,"").replace(/noreferrer/,""):n.rel=null),t=t||"",e===h.opts.linkAutoPrefix)return h.popups.get("link.insert").find('input[name="href"]').addClass("fr-error"),h.events.trigger("link.bad",[r]),!1;var a,l=v();if(l){if((a=m(l)).attr("href",e),0<t.length&&a.text()!=t&&!i){if(h.opts.trackChangesEnabled){var s=m(a.get(0).outerHTML);s.insertBefore(a.parent());var o=h.track_changes.wrapLinkInTracking(s,h.track_changes.getPendingChanges().length-1),p=h.track_changes.wrapInDelete(o);a.parent().append(p)}for(var c=a.get(0);1===c.childNodes.length&&c.childNodes[0].nodeType==Node.ELEMENT_NODE;)c=c.childNodes[0];m(c).text(t)}for(var f in i||a.prepend(y.START_MARKER).append(y.END_MARKER),n)n[f]?a.attr(f,n[f]):a.removeAttr(f);i||h.selection.restore()}else{i?(i.wrap('<a href="'.concat(e,'"></a>')),h.image.hasCaption()&&i.parent().append(i.parents(".fr-img-caption").find(".fr-inner"))):(h.format.remove("a"),h.selection.isCollapsed()?(t=0===t.length?r:t,h.html.insert('<a href="'.concat(e,'">').concat(y.START_MARKER).concat(t.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")).concat(y.END_MARKER,"</a>")),h.selection.restore()):0<t.length&&t!=h.selection.text().replace(/\n/g,"")?(h.selection.remove(),h.html.insert('<a href="'.concat(e,'">').concat(y.START_MARKER).concat(t.replace(/&/g,"&amp;")).concat(y.END_MARKER,"</a>")),h.selection.restore()):(!function g(){if(!h.selection.isCollapsed()){h.selection.save();for(var e=h.$el.find(".fr-marker").addClass("fr-unprocessed").toArray();e.length;){var t=m(e.pop());t.removeClass("fr-unprocessed");var n=h.node.deepestParent(t.get(0));if(n){for(var i=t.get(0),r="",a="";i=i.parentNode,h.node.isBlock(i)||(r+=h.node.closeTagString(i),a=h.node.openTagString(i)+a),i!=n;);var l=h.node.openTagString(t.get(0))+t.html()+h.node.closeTagString(t.get(0));t.replaceWith('<span id="fr-break"></span>');var s=n.outerHTML;s=(s=s.replace(/<span id="fr-break"><\/span>/g,r+l+a)).replace(a+r,""),n.outerHTML=s}e=h.$el.find(".fr-marker.fr-unprocessed").toArray()}h.html.cleanEmptyTags(),h.selection.restore()}}(),h.format.apply("a",{href:e})));for(var d=b(),u=0;u<d.length;u++)(a=m(d[u])).attr(n),a.removeAttr("_moz_dirty");1==d.length&&h.$wp&&!i&&(m(d[0]).prepend(y.START_MARKER).append(y.END_MARKER),h.selection.restore())}if(i){var k=h.popups.get("link.insert");k&&k.find("input:focus").blur(),h.image.edit(i)}else E()}function c(){a();var e=v();if(e){var t=h.popups.get("link.insert");t||(t=s()),h.popups.isVisible("link.insert")||(h.popups.refresh("link.insert"),h.selection.save(),h.helpers.isMobile()&&(h.events.disableBlur(),h.$el.blur(),h.events.enableBlur())),h.popups.setContainer("link.insert",h.$sc);var n=(h.image?h.image.get():null)||m(e),i=n.offset().left+n.outerWidth()/2,r=n.offset().top+n.outerHeight();h.popups.show("link.insert",i,r,n.outerHeight(),!0)}}function f(){var e=h.image?h.image.getEl():null;if(e){var t=h.popups.get("link.insert"),n=e.outerWidth()/2;h.image.hasCaption()&&(e=e.find(".fr-img-wrap"),m(e)&&m(e).find("img")&&(n=m(e).find("img").outerWidth()/2)),t||(t=s()),o(),h.popups.setContainer("link.insert",h.$sc);var i=e.offset().left+n,r=e.offset().top+e.outerHeight(),a=e.outerHeight();h.opts.iframe&&h.image.hasCaption()&&m(e)&&m(e).find("img")&&(a=m(e).find("img").outerHeight()),h.popups.show("link.insert",i,r,a,!0)}}return{_init:function e(){h.events.on("keyup",function(e){e.which!=y.KEYCODE.ESC&&E(e)}),h.events.on("window.mouseup",E),h.events.$on(h.$el,"click","a",function(e){h.edit.isDisabled()&&e.preventDefault()}),h.helpers.isMobile()&&h.events.$on(h.$doc,"selectionchange",E),s(!0),"A"==h.el.tagName&&h.$el.addClass("fr-view"),h.events.on("toolbar.esc",function(){if(h.popups.isVisible("link.edit"))return h.events.disableBlur(),h.events.focus(),!1},!0)},remove:function i(){var e=v(),t=h.image?h.image.get():null;if(!1===h.events.trigger("link.beforeRemove",[e]))return!1;if(t&&e)if(h.image.hasCaption()){t.addClass("img-link-caption"),m(e).replaceWith(m(e).html());var n=document.querySelectorAll("img.img-link-caption");h.image.edit(m(n[0])),m(n[0]).removeClass("img-link-caption")}else t.unwrap(),h.image.edit(t);else e&&(h.selection.save(),m(e).replaceWith(m(e).html()),h.selection.restore(),a())},showInsertPopup:function d(){var e=h.$tb.find('.fr-command[data-cmd="insertLink"]'),t=h.popups.get("link.insert");if(t||(t=s()),!t.hasClass("fr-active"))if(h.popups.refresh("link.insert"),h.popups.setContainer("link.insert",h.$tb||h.$sc),e.isVisible()){var n=h.button.getPosition(e),i=n.left,r=n.top;h.popups.show("link.insert",i,r,e.outerHeight())}else h.position.forSelection(t),h.popups.show("link.insert")},usePredefined:function u(e){var t,n,i=h.opts.linkList[e],r=h.popups.get("link.insert"),a=r.find('input.fr-link-attr[type="text"]'),l=r.find('input.fr-link-attr[type="checkbox"]');for(i.rel&&(r.rel=i.rel),n=0;n<a.length;n++)i[(t=m(a[n])).attr("name")]?(t.val(i[t.attr("name")]),t.toggleClass("fr-not-empty",!0)):"text"!=t.attr("name")&&t.val("");for(n=0;n<l.length;n++)(t=m(l[n])).attr("checked",t.data("checked")==i[t.attr("name")]);h.accessibility.focusPopup(r)},insertCallback:function k(){var e,t,n=h.popups.get("link.insert"),i=n.find('input.fr-link-attr[type="text"]'),r=n.find('input.fr-link-attr[type="checkbox"]'),a=(i.filter('[name="href"]').val()||"").trim(),l=h.opts.linkText?i.filter('[name="text"]').val():"",s={};for(t=0;t<i.length;t++)e=m(i[t]),["href","text"].indexOf(e.attr("name"))<0&&(s[e.attr("name")]=e.val());for(t=0;t<r.length;t++)(e=m(r[t])).is(":checked")?s[e.attr("name")]=e.data("checked"):s[e.attr("name")]=e.data("unchecked")||null;n.rel&&(s.rel=n.rel);var o=h.helpers.scrollTop();p(a,l,s),m(h.o_win).scrollTop(o)},insert:p,update:c,get:v,allSelected:b,back:function t(){h.image&&h.image.get()?h.image.back():(h.events.disableBlur(),h.selection.restore(),h.events.enableBlur(),v()&&h.$wp?(h.selection.restore(),a(),E()):"A"==h.el.tagName?(h.$el.focus(),E()):(h.popups.hide("link.insert"),h.toolbar.showInline()))},imageLink:f,applyStyle:function g(e,t,n){void 0===n&&(n=h.opts.linkMultipleStyles),void 0===t&&(t=h.opts.linkStyles);var i=v();if(!i)return!1;if(!n){var r=Object.keys(t);r.splice(r.indexOf(e),1),m(i).removeClass(r.join(" "))}m(i).toggleClass(e),E()}}},y.DefineIcon("insertLink",{NAME:"link",SVG_KEY:"insertLink"}),y.RegisterShortcut(y.KEYCODE.K,"insertLink",null,"K"),y.RegisterCommand("insertLink",{title:"Insert Link",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible("link.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("link.insert")):this.link.showInsertPopup()},plugin:"link"}),y.DefineIcon("linkOpen",{NAME:"external-link",FA5NAME:"external-link-alt",SVG_KEY:"openLink"}),y.RegisterCommand("linkOpen",{title:"Open Link",undo:!1,refresh:function(e){this.link.get()?e.removeClass("fr-hidden"):e.addClass("fr-hidden")},callback:function(){var e=this.link.get();e&&(-1!==e.href.indexOf("mailto:")?this.o_win.open(e.href).close():(e.target||(e.target="_self"),this.browser.msie||this.browser.edge?this.o_win.open(e.href,e.target):this.o_win.open(e.href,e.target,"noopener")),this.popups.hide("link.edit"))},plugin:"link"}),y.DefineIcon("linkEdit",{NAME:"edit",SVG_KEY:"edit"}),y.RegisterCommand("linkEdit",{title:"Edit Link",undo:!1,refreshAfterCallback:!1,popup:!0,callback:function(){this.link.update()},refresh:function(e){this.link.get()?e.removeClass("fr-hidden"):e.addClass("fr-hidden")},plugin:"link"}),y.DefineIcon("linkRemove",{NAME:"unlink",SVG_KEY:"unlink"}),y.RegisterCommand("linkRemove",{title:"Unlink",callback:function(){this.link.remove()},refresh:function(e){this.link.get()?e.removeClass("fr-hidden"):e.addClass("fr-hidden")},plugin:"link"}),y.DefineIcon("linkBack",{NAME:"arrow-left",SVG_KEY:"back"}),y.RegisterCommand("linkBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.link.back()},refresh:function(e){var t=this.link.get()&&this.doc.hasFocus();(this.image?this.image.get():null)||t||this.opts.toolbarInline?(e.removeClass("fr-hidden"),e.next(".fr-separator").removeClass("fr-hidden")):(e.addClass("fr-hidden"),e.next(".fr-separator").addClass("fr-hidden"))},plugin:"link"}),y.DefineIcon("linkList",{NAME:"search",SVG_KEY:"search"}),y.RegisterCommand("linkList",{title:"Choose Link",type:"dropdown",focus:!1,undo:!1,refreshAfterCallback:!1,html:function(){for(var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.linkList,n=0;n<t.length;n++)e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="linkList" data-param1="'.concat(n,'">').concat(t[n].displayText||t[n].text,"</a></li>");return e+="</ul>"},callback:function(e,t){this.link.usePredefined(t)},plugin:"link"}),y.RegisterCommand("linkInsert",{focus:!1,refreshAfterCallback:!1,callback:function(){this.link.insertCallback()},refresh:function(e){this.link.get()?e.text(this.language.translate("Update")):e.text(this.language.translate("Insert"))},plugin:"link"}),y.DefineIcon("imageLink",{NAME:"link",SVG_KEY:"insertLink"}),y.RegisterCommand("imageLink",{title:"Insert Link",undo:!1,focus:!1,popup:!0,callback:function(){this.link.imageLink()},refresh:function(e){var t;this.link.get()?((t=e.prev()).hasClass("fr-separator")&&t.removeClass("fr-hidden"),e.addClass("fr-hidden")):((t=e.prev()).hasClass("fr-separator")&&t.addClass("fr-hidden"),e.removeClass("fr-hidden"))},plugin:"link"}),y.DefineIcon("linkStyle",{NAME:"magic",SVG_KEY:"linkStyles"}),y.RegisterCommand("linkStyle",{title:"Style",type:"dropdown",html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.linkStyles;for(var n in t)t.hasOwnProperty(n)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="linkStyle" data-param1="'.concat(n,'">').concat(this.language.translate(t[n]),"</a></li>"));return e+="</ul>"},callback:function(e,t){this.link.applyStyle(t)},refreshOnShow:function(e,t){var n=this.$,i=this.link.get();if(i){var r=n(i);t.find(".fr-command").each(function(){var e=n(this).data("param1"),t=r.hasClass(e);n(this).toggleClass("fr-active",t).attr("aria-selected",t)})}},refresh:function(e){this.link.get()?e.removeClass("fr-hidden"):e.addClass("fr-hidden")},plugin:"link"})});

/***/ }),

/***/ 6418:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(e,t){ true?t(__webpack_require__(189)):0}(this,function(o){"use strict";o=o&&o.hasOwnProperty("default")?o["default"]:o,Object.assign(o.DEFAULTS,{listAdvancedTypes:!0}),o.PLUGINS.lists=function(g){var u=g.$;function h(e){return'<span class="fr-open-'.concat(e.toLowerCase(),'"></span>')}function N(e){return'<span class="fr-close-'.concat(e.toLowerCase(),'"></span>')}function c(e,t){!function c(e,t){for(var a=[],n=0;n<e.length;n++){var r=e[n].parentNode;"LI"==e[n].tagName&&r.tagName!=t&&a.indexOf(r)<0&&a.push(r)}for(var o=a.length-1;0<=o;o--){var l=u(a[o]);l.replaceWith("<".concat(t.toLowerCase()," ").concat(g.node.attributes(l.get(0)),">").concat(l.html(),"</").concat(t.toLowerCase(),">"))}}(e,t);var a,n=g.html.defaultTag(),r=null;e.length&&(a="rtl"==g.opts.direction||"rtl"==u(e[0]).css("direction")?"margin-right":"margin-left");for(var o=0;o<e.length;o++)if("TD"!=e[o].tagName&&"TH"!=e[o].tagName&&"LI"!=e[o].tagName){var l=g.helpers.getPX(u(e[o]).css(a))||0;(e[o].style.marginLeft=null)===r&&(r=l);var i=0<r?"<".concat(t,' style="').concat(a,": ").concat(r,'px ">'):"<".concat(t,">"),s="</".concat(t,">");for(l-=r;0<l/g.opts.indentMargin;)i+="</".concat(t,">"),s+=s,l-=g.opts.indentMargin;n&&e[o].tagName.toLowerCase()==n?u(e[o]).replaceWith("".concat(i,"<li").concat(g.node.attributes(e[o]),">").concat(u(e[o]).html(),"</li>").concat(s)):u(e[o]).wrap("".concat(i,"<li></li>").concat(s))}g.clean.lists()}function d(e){var t,a,n=[];for(t=e.length-1;0<=t;t--)for(a=t-1;0<=a;a--){if(u(e[a]).find(e[t]).length||e[a]==e[t]){u(e[t]).addClass("fr-removed-block-".concat(t)),n.push(t),e.splice(t,1);break}if(u(e[a]).contains(e[t])){u(e[a]).addClass("fr-removed-block-".concat(a)),n.push(a),e.splice(a,1);break}}var r=[],o=!1;for(t=0;t<e.length;t++){var l=u(e[t]),i=e[t].parentNode,s=l.attr("class");if(l.is(":first-child")&&(o=!0,u(i.parentNode).removeAttr("start")),l.before(N(i.tagName)),"LI"==i.parentNode.tagName){if(l.is(":last-child")){var c=l.find("> ul, > ol").last();c.length&&c.wrap("<".concat(i.tagName,">"))}l.before(N("LI")),l.after(h("LI"))}else if("OL"==i.parentNode.tagName)o||(l.before(N("OL")),l.after(h("OL")));else if("UL"==i.parentNode.tagName)o||(l.before(N("UL")),l.after(h("UL")));else{var d="";s&&(d+=' class="'.concat(s,'"'));var p="rtl"==g.opts.direction||"rtl"==l.css("direction")?"margin-right":"margin-left";g.helpers.getPX(u(i).css(p))&&0<=(u(i).attr("style")||"").indexOf("".concat(p,":"))&&(d+=' style="'.concat(p,":").concat(g.helpers.getPX(u(i).css(p)),'px;"')),g.html.defaultTag()&&0===l.find(g.html.blockTagsQuery()).length&&l.wrapInner(g.html.defaultTag()+d),g.node.isEmpty(l.get(0),!0)||0!==l.find(g.html.blockTagsQuery()).length||("DIV"==i.parentNode.tagName&&g.html.defaultTag()?(l.prepend(h(g.html.defaultTag())),l.append(N(g.html.defaultTag()))):l.append("<br>")),l.append(h("LI")),l.prepend(N("LI"))}l.after(h(i.tagName)),"LI"==i.parentNode.tagName&&(i=i.parentNode.parentNode),r.indexOf(i)<0&&r.push(i)}for(t=0;t<r.length;t++){var f=u(r[t]),m=f.html();m=(m=m.replace(/<span class="fr-close-([a-z]*)"><\/span>/g,"</$1>")).replace(/<span class="fr-open-([a-z]*)"><\/span>/g,"<$1>"),f.replaceWith(g.node.openTagString(f.get(0))+m+g.node.closeTagString(f.get(0)))}return g.$el.find("li:empty").remove(),g.$el.find("ul:empty, ol:empty").remove(),g.clean.lists(),g.$el.find("ul:empty, ol:empty").remove(),g.html.wrap(),n}function m(e,t){var a=u(document.createElement("li"));if(e.childNodes.length)for(var n=e.childNodes[0].attributes,r=0;r<n.length;r++){var o=n[r];"style"===o.name&&(a[0].style.cssText+=o.value)}u(e).prepend(a),u(e).removeAttr("start");for(var l=g.node.contents(t)[0];l&&!g.node.isList(l);){var i=l.nextSibling;a.append(l),l=i}}function e(e){if("indent"==e||"outdent"==e){var t=!1,a=g.selection.blocks(!1,!0),n=[],r=a[0].previousSibling||a[0].parentElement;if("outdent"==e){if("UL"!=a[0].parentNode.tagName&&"UL"!=r.parentNode.tagName&&"OL"!=r.parentNode.tagName&&"LI"!=r.parentNode.tagName)return;if(!a[0].previousSibling&&"none"==r.parentNode.style.listStyleType)return void function l(e){for(g.selection.save();0<e.childNodes.length;)e.parentNode.parentNode.append(e.childNodes[0]);g.clean.lists(),g.selection.restore()}(r)}else{if("UL"!=a[0].parentElement.tagName&&"OL"!=a[0].parentElement.tagName&&"LI"!=a[0].parentElement.tagName)return;if(g.node.isBlock(a[0])&&"LI"!==a[0].tagName&&0<u(a[0]).parentsUntil(g.$el,"LI").length&&(a[0]=a[0].parentElement,r=a[0].parentElement),!a[0].previousSibling||"LI"!=a[0].previousSibling.tagName){if(0==u(a[0]).parents("li").length)return void function i(e){g.selection.save();var t="OL"==e.tagName?document.createElement("ol"):document.createElement("ul");for(u(t).css("list-style-type",u(e).css("list-style-type"));0<e.childNodes.length;)t.append(e.childNodes[0]);var a=document.createElement("li");t.append(a),e.append(t),g.clean.lists(),g.selection.restore()}(r);t=!0}}for(var o=0;o<a.length;o++)"LI"==a[o].tagName?(t=!0,n.push(a[o])):"LI"==a[o].parentNode.tagName&&n.indexOf(a[o].parentNode)<0&&(t=!0,n.push(a[o].parentNode));t&&("indent"==e?function f(e){g.selection.save();for(var t=!1,a=0;a<e.length;a++){var n=e[a].previousSibling;if(n&&"LI"==n.tagName&&!t){var r=u(e[a]).find("> ul, > ol").last().get(0);if(r)m(r,e[a]),u(n).append(u(r)),u(e[a]).remove();else{var o=u(n).find("> ul, > ol").last().get(0);if(o)u(o).append(u(e[a]));else{var l=u("<".concat(e[a].parentNode.tagName,">"));u(n).append(l),l.append(u(e[a]))}}}else if(!n||"OL"!=n.tagName&&"UL"!=n.tagName){var i=e[a].parentNode;if(t=!0,"UL"==i.tagName||"OL"==i.tagName){var s=u(e[a]).find("> ol, > ul"),c=null==e[a].previousSibling;if(s.length){var d=s.first().get(0);m(d,e[a]),c?u(i).prepend(u(d)):u(i).append(u(d)),u(e[a]).remove()}else u(e[a]).wrap("<".concat(i.tagName,">"));c&&0<u(i).find("> li").length&&u(i).attr("start","2")}}else{var p=u(e[a]).find("> ol, > ul").first().get(0);p?(m(p,e[a]),u(n).append(u(p).children()),u(e[a]).remove(),u(p).remove()):u(n).append(u(e[a]))}}g.clean.lists(),g.selection.restore()}(n):function s(e){g.selection.save();var t=[];do{t=d(e),e=[];for(var a=0;a<t.length;a++){var n=g.$el.find(".fr-removed-block-".concat(t[a])).first().get(0);u(n).removeClass("fr-removed-block-".concat(t[a])),""==u(n).attr("class")&&u(n).removeAttr("class"),e.push(n)}}while(0<t.length);g.selection.restore()}(n))}}return{_init:function t(){g.events.on("commands.after",e),g.events.on("keydown",function(e){if(e.which==o.KEYCODE.TAB){for(var t=g.selection.blocks(),a=[],n=0;n<t.length;n++)"LI"==t[n].tagName?a.push(t[n]):"LI"==t[n].parentNode.tagName&&a.push(t[n].parentNode);if(1<=a.length||a.length&&(g.selection.info(a[0]).atStart||g.node.isEmpty(a[0])))return e.preventDefault(),e.stopPropagation(),e.shiftKey?g.commands.outdent():g.commands.indent(),!1}},!0)},format:function p(e,t){var a,n,r=1<(n=g.selection.blocks(!0)).length&&n[n.length-1],o=g.selection.ranges();if(r&&o.length&&g.node.isEmpty(r)&&!o[0].endOffset&&o[0].setEndAfter(r.firstChild,1),g.html.syncInputs(),g.selection.save(),g.browser.safari&&g.helpers.getSafariVersion()<17){var l=g.selection.ranges();if(o&&o[0].endContainer&&l&&l[0].endContainer&&!o[0].endContainer.isSameNode(l[0].endContainer)&&o[0].endContainer.previousSibling&&o[0].endContainer.previousSibling.isSameNode(l[0].endContainer)){var i=u(l[0].endContainer).find('.fr-marker[data-type="false"]');u(o[0].endContainer).append(i[0])}}for(g.html.wrap(!0,!0,!0,!0),g.selection.restore(),n=g.selection.blocks(!0),a=0;a<n.length;a++)"LI"!=n[a].tagName&&"LI"==n[a].parentNode.tagName&&(n[a]=n[a].parentNode);if(g.selection.save(),function s(e,t){for(var a=!0,n=0;n<e.length;n++){if("LI"!=e[n].tagName)return!1;e[n].parentNode.tagName!=t&&(a=!1)}return a}(n,e)?t||d(n):c(n,e),g.html.unwrap(),g.selection.restore(),t=t||"default"){for(n=g.selection.blocks(),a=0;a<n.length;a++)"LI"!=n[a].tagName&&"LI"==n[a].parentNode.tagName&&(n[a]=n[a].parentNode);for(a=0;a<n.length;a++)"LI"==n[a].tagName&&(u(n[a].parentNode).css("list-style-type","default"===t?"":t),0===(u(n[a].parentNode).attr("style")||"").length&&u(n[a].parentNode).removeAttr("style"))}},refresh:function r(e,t){var a=u(g.selection.element());if(a.get(0)!=g.el){var n=a.get(0);(n="LI"!=n.tagName&&n.firstElementChild&&"LI"!=n.firstElementChild.tagName?a.parents("li").get(0):"LI"==n.tagName||n.firstElementChild?n.firstElementChild&&"LI"==n.firstElementChild.tagName?a.get(0).firstChild:a.get(0):a.parents("li").get(0))&&n.parentNode.tagName==t&&g.el.contains(n.parentNode)&&e.addClass("fr-active")}}}},o.DefineIcon("formatOLSimple",{NAME:"list-ol",SVG_KEY:"orderedList"}),o.RegisterCommand("formatOLSimple",{title:"Ordered List",type:"button",options:{"default":"Default",circle:"Circle",disc:"Disc",square:"Square"},refresh:function(e){this.lists.refresh(e,"OL")},callback:function(e,t){this.lists.format("OL",t)},plugin:"lists"}),o.RegisterCommand("formatUL",{title:"Unordered List",type:"button",hasOptions:function(){return this.opts.listAdvancedTypes},options:{"default":"Default",circle:"Circle",disc:"Disc",square:"Square"},refresh:function(e){this.lists.refresh(e,"UL")},callback:function(e,t){this.lists.format("UL",t)},plugin:"lists"}),o.RegisterCommand("formatOL",{title:"Ordered List",hasOptions:function(){return this.opts.listAdvancedTypes},options:{"default":"Default","lower-alpha":"Lower Alpha","lower-greek":"Lower Greek","lower-roman":"Lower Roman","upper-alpha":"Upper Alpha","upper-roman":"Upper Roman"},refresh:function(e){this.lists.refresh(e,"OL")},callback:function(e,t){this.lists.format("OL",t)},plugin:"lists"}),o.DefineIcon("formatUL",{NAME:"list-ul",SVG_KEY:"unorderedList"}),o.DefineIcon("formatOL",{NAME:"list-ol",SVG_KEY:"orderedList"})});

/***/ }),

/***/ 4007:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(e,t){ true?t(__webpack_require__(189)):0}(this,function(e){"use strict";(e=e&&e.hasOwnProperty("default")?e["default"]:e).PLUGINS.quote=function(r){var c=r.$;function s(e){for(;e.parentNode&&e.parentNode!=r.el;)e=e.parentNode;return e}return{apply:function t(e){r.selection.save(),r.html.wrap(!0,!0,!0,!0),r.selection.restore(),"increase"==e?function o(){var e,t=r.selection.blocks();for(e=0;e<t.length;e++)t[e]=s(t[e]);r.selection.save();var n=c(document.createElement("blockquote"));for(n.insertBefore(t[0]),e=0;e<t.length;e++)n.append(t[e]);r.opts.trackChangesEnabled&&r.track_changes.addQuote(n),r.html.unwrap(),r.selection.restore()}():"decrease"==e&&function a(){var e,t=r.opts.trackChangesEnabled,n=r.selection.blocks();for(e=0;e<n.length;e++)"BLOCKQUOTE"!=n[e].tagName&&(n[e]=t&&c(n[e]).parentsUntil(r.$el,"[data-track-id^=pending]").get(0)||c(n[e]).parentsUntil(r.$el,"BLOCKQUOTE").get(0));for(r.selection.save(),e=0;e<n.length;e++)n[e]&&(t?r.track_changes.removeQuote(c(n[e]),e):c(n[e]).replaceWith(n[e].innerHTML));r.html.unwrap(),r.selection.restore()}()}}},e.RegisterShortcut(e.KEYCODE.SINGLE_QUOTE,"quote","increase","'"),e.RegisterShortcut(e.KEYCODE.SINGLE_QUOTE,"quote","decrease","'",!0),e.RegisterCommand("quote",{title:"Quote",type:"dropdown",html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t={increase:"Increase",decrease:"Decrease"};for(var n in t)if(t.hasOwnProperty(n)){var o=this.shortcuts.get("quote.".concat(n));e+='<li role="presentation"><a class="fr-command fr-active '.concat(n,'" tabIndex="-1" role="option" data-cmd="quote" data-param1="').concat(n,'" title="').concat(t[n],'">').concat(this.language.translate(t[n])).concat(o?'<span class="fr-shortcut">'.concat(o,"</span>"):"","</a></li>")}return e+="</ul>"},callback:function(e,t){this.quote.apply(t)},plugin:"quote"}),e.DefineIcon("quote",{NAME:"quote-left",SVG_KEY:"blockquote"})});

/***/ }),

/***/ 3211:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(c,E){ true?E(__webpack_require__(189)):0}(this,function(H){"use strict";H=H&&H.hasOwnProperty("default")?H["default"]:H,Object.assign(H.DEFAULTS,{specialCharactersSets:[{title:"Latin","char":"&iexcl;",list:[{"char":"&iexcl;",desc:"INVERTED EXCLAMATION MARK"},{"char":"&cent;",desc:"CENT SIGN"},{"char":"&pound;",desc:"POUND SIGN"},{"char":"&curren;",desc:"CURRENCY SIGN"},{"char":"&yen;",desc:"YEN SIGN"},{"char":"&brvbar;",desc:"BROKEN BAR"},{"char":"&sect;",desc:"SECTION SIGN"},{"char":"&uml;",desc:"DIAERESIS"},{"char":"&copy;",desc:"COPYRIGHT SIGN"},{"char":"&trade;",desc:"TRADEMARK SIGN"},{"char":"&ordf;",desc:"FEMININE ORDINAL INDICATOR"},{"char":"&laquo;",desc:"LEFT-POINTING DOUBLE ANGLE QUOTATION MARK"},{"char":"&not;",desc:"NOT SIGN"},{"char":"&reg;",desc:"REGISTERED SIGN"},{"char":"&macr;",desc:"MACRON"},{"char":"&deg;",desc:"DEGREE SIGN"},{"char":"&plusmn;",desc:"PLUS-MINUS SIGN"},{"char":"&sup2;",desc:"SUPERSCRIPT TWO"},{"char":"&sup3;",desc:"SUPERSCRIPT THREE"},{"char":"&acute;",desc:"ACUTE ACCENT"},{"char":"&micro;",desc:"MICRO SIGN"},{"char":"&para;",desc:"PILCROW SIGN"},{"char":"&middot;",desc:"MIDDLE DOT"},{"char":"&cedil;",desc:"CEDILLA"},{"char":"&sup1;",desc:"SUPERSCRIPT ONE"},{"char":"&ordm;",desc:"MASCULINE ORDINAL INDICATOR"},{"char":"&raquo;",desc:"RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK"},{"char":"&frac14;",desc:"VULGAR FRACTION ONE QUARTER"},{"char":"&frac12;",desc:"VULGAR FRACTION ONE HALF"},{"char":"&frac34;",desc:"VULGAR FRACTION THREE QUARTERS"},{"char":"&iquest;",desc:"INVERTED QUESTION MARK"},{"char":"&Agrave;",desc:"LATIN CAPITAL LETTER A WITH GRAVE"},{"char":"&Aacute;",desc:"LATIN CAPITAL LETTER A WITH ACUTE"},{"char":"&Acirc;",desc:"LATIN CAPITAL LETTER A WITH CIRCUMFLEX"},{"char":"&Atilde;",desc:"LATIN CAPITAL LETTER A WITH TILDE"},{"char":"&Auml;",desc:"LATIN CAPITAL LETTER A WITH DIAERESIS "},{"char":"&Aring;",desc:"LATIN CAPITAL LETTER A WITH RING ABOVE"},{"char":"&AElig;",desc:"LATIN CAPITAL LETTER AE"},{"char":"&Ccedil;",desc:"LATIN CAPITAL LETTER C WITH CEDILLA"},{"char":"&Egrave;",desc:"LATIN CAPITAL LETTER E WITH GRAVE"},{"char":"&Eacute;",desc:"LATIN CAPITAL LETTER E WITH ACUTE"},{"char":"&Ecirc;",desc:"LATIN CAPITAL LETTER E WITH CIRCUMFLEX"},{"char":"&Euml;",desc:"LATIN CAPITAL LETTER E WITH DIAERESIS"},{"char":"&Igrave;",desc:"LATIN CAPITAL LETTER I WITH GRAVE"},{"char":"&Iacute;",desc:"LATIN CAPITAL LETTER I WITH ACUTE"},{"char":"&Icirc;",desc:"LATIN CAPITAL LETTER I WITH CIRCUMFLEX"},{"char":"&Iuml;",desc:"LATIN CAPITAL LETTER I WITH DIAERESIS"},{"char":"&ETH;",desc:"LATIN CAPITAL LETTER ETH"},{"char":"&Ntilde;",desc:"LATIN CAPITAL LETTER N WITH TILDE"},{"char":"&Ograve;",desc:"LATIN CAPITAL LETTER O WITH GRAVE"},{"char":"&Oacute;",desc:"LATIN CAPITAL LETTER O WITH ACUTE"},{"char":"&Ocirc;",desc:"LATIN CAPITAL LETTER O WITH CIRCUMFLEX"},{"char":"&Otilde;",desc:"LATIN CAPITAL LETTER O WITH TILDE"},{"char":"&Ouml;",desc:"LATIN CAPITAL LETTER O WITH DIAERESIS"},{"char":"&times;",desc:"MULTIPLICATION SIGN"},{"char":"&Oslash;",desc:"LATIN CAPITAL LETTER O WITH STROKE"},{"char":"&Ugrave;",desc:"LATIN CAPITAL LETTER U WITH GRAVE"},{"char":"&Uacute;",desc:"LATIN CAPITAL LETTER U WITH ACUTE"},{"char":"&Ucirc;",desc:"LATIN CAPITAL LETTER U WITH CIRCUMFLEX"},{"char":"&Uuml;",desc:"LATIN CAPITAL LETTER U WITH DIAERESIS"},{"char":"&Yacute;",desc:"LATIN CAPITAL LETTER Y WITH ACUTE"},{"char":"&THORN;",desc:"LATIN CAPITAL LETTER THORN"},{"char":"&szlig;",desc:"LATIN SMALL LETTER SHARP S"},{"char":"&agrave;",desc:"LATIN SMALL LETTER A WITH GRAVE"},{"char":"&aacute;",desc:"LATIN SMALL LETTER A WITH ACUTE "},{"char":"&acirc;",desc:"LATIN SMALL LETTER A WITH CIRCUMFLEX"},{"char":"&atilde;",desc:"LATIN SMALL LETTER A WITH TILDE"},{"char":"&auml;",desc:"LATIN SMALL LETTER A WITH DIAERESIS"},{"char":"&aring;",desc:"LATIN SMALL LETTER A WITH RING ABOVE"},{"char":"&aelig;",desc:"LATIN SMALL LETTER AE"},{"char":"&ccedil;",desc:"LATIN SMALL LETTER C WITH CEDILLA"},{"char":"&egrave;",desc:"LATIN SMALL LETTER E WITH GRAVE"},{"char":"&eacute;",desc:"LATIN SMALL LETTER E WITH ACUTE"},{"char":"&ecirc;",desc:"LATIN SMALL LETTER E WITH CIRCUMFLEX"},{"char":"&euml;",desc:"LATIN SMALL LETTER E WITH DIAERESIS"},{"char":"&igrave;",desc:"LATIN SMALL LETTER I WITH GRAVE"},{"char":"&iacute;",desc:"LATIN SMALL LETTER I WITH ACUTE"},{"char":"&icirc;",desc:"LATIN SMALL LETTER I WITH CIRCUMFLEX"},{"char":"&iuml;",desc:"LATIN SMALL LETTER I WITH DIAERESIS"},{"char":"&eth;",desc:"LATIN SMALL LETTER ETH"},{"char":"&ntilde;",desc:"LATIN SMALL LETTER N WITH TILDE"},{"char":"&ograve;",desc:"LATIN SMALL LETTER O WITH GRAVE"},{"char":"&oacute;",desc:"LATIN SMALL LETTER O WITH ACUTE"},{"char":"&ocirc;",desc:"LATIN SMALL LETTER O WITH CIRCUMFLEX"},{"char":"&otilde;",desc:"LATIN SMALL LETTER O WITH TILDE"},{"char":"&ouml;",desc:"LATIN SMALL LETTER O WITH DIAERESIS"},{"char":"&divide;",desc:"DIVISION SIGN"},{"char":"&oslash;",desc:"LATIN SMALL LETTER O WITH STROKE"},{"char":"&ugrave;",desc:"LATIN SMALL LETTER U WITH GRAVE"},{"char":"&uacute;",desc:"LATIN SMALL LETTER U WITH ACUTE"},{"char":"&ucirc;",desc:"LATIN SMALL LETTER U WITH CIRCUMFLEX"},{"char":"&uuml;",desc:"LATIN SMALL LETTER U WITH DIAERESIS"},{"char":"&yacute;",desc:"LATIN SMALL LETTER Y WITH ACUTE"},{"char":"&thorn;",desc:"LATIN SMALL LETTER THORN"},{"char":"&yuml;",desc:"LATIN SMALL LETTER Y WITH DIAERESIS"}]},{title:"Greek","char":"&Alpha;",list:[{"char":"&Alpha;",desc:"GREEK CAPITAL LETTER ALPHA"},{"char":"&Beta;",desc:"GREEK CAPITAL LETTER BETA"},{"char":"&Gamma;",desc:"GREEK CAPITAL LETTER GAMMA"},{"char":"&Delta;",desc:"GREEK CAPITAL LETTER DELTA"},{"char":"&Epsilon;",desc:"GREEK CAPITAL LETTER EPSILON"},{"char":"&Zeta;",desc:"GREEK CAPITAL LETTER ZETA"},{"char":"&Eta;",desc:"GREEK CAPITAL LETTER ETA"},{"char":"&Theta;",desc:"GREEK CAPITAL LETTER THETA"},{"char":"&Iota;",desc:"GREEK CAPITAL LETTER IOTA"},{"char":"&Kappa;",desc:"GREEK CAPITAL LETTER KAPPA"},{"char":"&Lambda;",desc:"GREEK CAPITAL LETTER LAMBDA"},{"char":"&Mu;",desc:"GREEK CAPITAL LETTER MU"},{"char":"&Nu;",desc:"GREEK CAPITAL LETTER NU"},{"char":"&Xi;",desc:"GREEK CAPITAL LETTER XI"},{"char":"&Omicron;",desc:"GREEK CAPITAL LETTER OMICRON"},{"char":"&Pi;",desc:"GREEK CAPITAL LETTER PI"},{"char":"&Rho;",desc:"GREEK CAPITAL LETTER RHO"},{"char":"&Sigma;",desc:"GREEK CAPITAL LETTER SIGMA"},{"char":"&Tau;",desc:"GREEK CAPITAL LETTER TAU"},{"char":"&Upsilon;",desc:"GREEK CAPITAL LETTER UPSILON"},{"char":"&Phi;",desc:"GREEK CAPITAL LETTER PHI"},{"char":"&Chi;",desc:"GREEK CAPITAL LETTER CHI"},{"char":"&Psi;",desc:"GREEK CAPITAL LETTER PSI"},{"char":"&Omega;",desc:"GREEK CAPITAL LETTER OMEGA"},{"char":"&alpha;",desc:"GREEK SMALL LETTER ALPHA"},{"char":"&beta;",desc:"GREEK SMALL LETTER BETA"},{"char":"&gamma;",desc:"GREEK SMALL LETTER GAMMA"},{"char":"&delta;",desc:"GREEK SMALL LETTER DELTA"},{"char":"&epsilon;",desc:"GREEK SMALL LETTER EPSILON"},{"char":"&zeta;",desc:"GREEK SMALL LETTER ZETA"},{"char":"&eta;",desc:"GREEK SMALL LETTER ETA"},{"char":"&theta;",desc:"GREEK SMALL LETTER THETA"},{"char":"&iota;",desc:"GREEK SMALL LETTER IOTA"},{"char":"&kappa;",desc:"GREEK SMALL LETTER KAPPA"},{"char":"&lambda;",desc:"GREEK SMALL LETTER LAMBDA"},{"char":"&mu;",desc:"GREEK SMALL LETTER MU"},{"char":"&nu;",desc:"GREEK SMALL LETTER NU"},{"char":"&xi;",desc:"GREEK SMALL LETTER XI"},{"char":"&omicron;",desc:"GREEK SMALL LETTER OMICRON"},{"char":"&pi;",desc:"GREEK SMALL LETTER PI"},{"char":"&rho;",desc:"GREEK SMALL LETTER RHO"},{"char":"&sigmaf;",desc:"GREEK SMALL LETTER FINAL SIGMA"},{"char":"&sigma;",desc:"GREEK SMALL LETTER SIGMA"},{"char":"&tau;",desc:"GREEK SMALL LETTER TAU"},{"char":"&upsilon;",desc:"GREEK SMALL LETTER UPSILON"},{"char":"&phi;",desc:"GREEK SMALL LETTER PHI"},{"char":"&chi;",desc:"GREEK SMALL LETTER CHI"},{"char":"&psi;",desc:"GREEK SMALL LETTER PSI"},{"char":"&omega;",desc:"GREEK SMALL LETTER OMEGA"},{"char":"&thetasym;",desc:"GREEK THETA SYMBOL"},{"char":"&upsih;",desc:"GREEK UPSILON WITH HOOK SYMBOL"},{"char":"&straightphi;",desc:"GREEK PHI SYMBOL"},{"char":"&piv;",desc:"GREEK PI SYMBOL"},{"char":"&Gammad;",desc:"GREEK LETTER DIGAMMA"},{"char":"&gammad;",desc:"GREEK SMALL LETTER DIGAMMA"},{"char":"&varkappa;",desc:"GREEK KAPPA SYMBOL"},{"char":"&varrho;",desc:"GREEK RHO SYMBOL"},{"char":"&straightepsilon;",desc:"GREEK LUNATE EPSILON SYMBOL"},{"char":"&backepsilon;",desc:"GREEK REVERSED LUNATE EPSILON SYMBOL"}]},{title:"Cyrillic","char":"&#x400",list:[{"char":"&#x400",desc:"CYRILLIC CAPITAL LETTER IE WITH GRAVE"},{"char":"&#x401",desc:"CYRILLIC CAPITAL LETTER IO"},{"char":"&#x402",desc:"CYRILLIC CAPITAL LETTER DJE"},{"char":"&#x403",desc:"CYRILLIC CAPITAL LETTER GJE"},{"char":"&#x404",desc:"CYRILLIC CAPITAL LETTER UKRAINIAN IE"},{"char":"&#x405",desc:"CYRILLIC CAPITAL LETTER DZE"},{"char":"&#x406",desc:"CYRILLIC CAPITAL LETTER BYELORUSSIAN-UKRAINIAN I"},{"char":"&#x407",desc:"CYRILLIC CAPITAL LETTER YI"},{"char":"&#x408",desc:"CYRILLIC CAPITAL LETTER JE"},{"char":"&#x409",desc:"CYRILLIC CAPITAL LETTER LJE"},{"char":"&#x40A",desc:"CYRILLIC CAPITAL LETTER NJE"},{"char":"&#x40B",desc:"CYRILLIC CAPITAL LETTER TSHE"},{"char":"&#x40C",desc:"CYRILLIC CAPITAL LETTER KJE"},{"char":"&#x40D",desc:"CYRILLIC CAPITAL LETTER I WITH GRAVE"},{"char":"&#x40E",desc:"CYRILLIC CAPITAL LETTER SHORT U"},{"char":"&#x40F",desc:"CYRILLIC CAPITAL LETTER DZHE"},{"char":"&#x410",desc:"CYRILLIC CAPITAL LETTER A"},{"char":"&#x411",desc:"CYRILLIC CAPITAL LETTER BE"},{"char":"&#x412",desc:"CYRILLIC CAPITAL LETTER VE"},{"char":"&#x413",desc:"CYRILLIC CAPITAL LETTER GHE"},{"char":"&#x414",desc:"CYRILLIC CAPITAL LETTER DE"},{"char":"&#x415",desc:"CYRILLIC CAPITAL LETTER IE"},{"char":"&#x416",desc:"CYRILLIC CAPITAL LETTER ZHE"},{"char":"&#x417",desc:"CYRILLIC CAPITAL LETTER ZE"},{"char":"&#x418",desc:"CYRILLIC CAPITAL LETTER I"},{"char":"&#x419",desc:"CYRILLIC CAPITAL LETTER SHORT I"},{"char":"&#x41A",desc:"CYRILLIC CAPITAL LETTER KA"},{"char":"&#x41B",desc:"CYRILLIC CAPITAL LETTER EL"},{"char":"&#x41C",desc:"CYRILLIC CAPITAL LETTER EM"},{"char":"&#x41D",desc:"CYRILLIC CAPITAL LETTER EN"},{"char":"&#x41E",desc:"CYRILLIC CAPITAL LETTER O"},{"char":"&#x41F",desc:"CYRILLIC CAPITAL LETTER PE"},{"char":"&#x420",desc:"CYRILLIC CAPITAL LETTER ER"},{"char":"&#x421",desc:"CYRILLIC CAPITAL LETTER ES"},{"char":"&#x422",desc:"CYRILLIC CAPITAL LETTER TE"},{"char":"&#x423",desc:"CYRILLIC CAPITAL LETTER U"},{"char":"&#x424",desc:"CYRILLIC CAPITAL LETTER EF"},{"char":"&#x425",desc:"CYRILLIC CAPITAL LETTER HA"},{"char":"&#x426",desc:"CYRILLIC CAPITAL LETTER TSE"},{"char":"&#x427",desc:"CYRILLIC CAPITAL LETTER CHE"},{"char":"&#x428",desc:"CYRILLIC CAPITAL LETTER SHA"},{"char":"&#x429",desc:"CYRILLIC CAPITAL LETTER SHCHA"},{"char":"&#x42A",desc:"CYRILLIC CAPITAL LETTER HARD SIGN"},{"char":"&#x42B",desc:"CYRILLIC CAPITAL LETTER YERU"},{"char":"&#x42C",desc:"CYRILLIC CAPITAL LETTER SOFT SIGN"},{"char":"&#x42D",desc:"CYRILLIC CAPITAL LETTER E"},{"char":"&#x42E",desc:"CYRILLIC CAPITAL LETTER YU"},{"char":"&#x42F",desc:"CYRILLIC CAPITAL LETTER YA"},{"char":"&#x430",desc:"CYRILLIC SMALL LETTER A"},{"char":"&#x431",desc:"CYRILLIC SMALL LETTER BE"},{"char":"&#x432",desc:"CYRILLIC SMALL LETTER VE"},{"char":"&#x433",desc:"CYRILLIC SMALL LETTER GHE"},{"char":"&#x434",desc:"CYRILLIC SMALL LETTER DE"},{"char":"&#x435",desc:"CYRILLIC SMALL LETTER IE"},{"char":"&#x436",desc:"CYRILLIC SMALL LETTER ZHE"},{"char":"&#x437",desc:"CYRILLIC SMALL LETTER ZE"},{"char":"&#x438",desc:"CYRILLIC SMALL LETTER I"},{"char":"&#x439",desc:"CYRILLIC SMALL LETTER SHORT I"},{"char":"&#x43A",desc:"CYRILLIC SMALL LETTER KA"},{"char":"&#x43B",desc:"CYRILLIC SMALL LETTER EL"},{"char":"&#x43C",desc:"CYRILLIC SMALL LETTER EM"},{"char":"&#x43D",desc:"CYRILLIC SMALL LETTER EN"},{"char":"&#x43E",desc:"CYRILLIC SMALL LETTER O"},{"char":"&#x43F",desc:"CYRILLIC SMALL LETTER PE"},{"char":"&#x440",desc:"CYRILLIC SMALL LETTER ER"},{"char":"&#x441",desc:"CYRILLIC SMALL LETTER ES"},{"char":"&#x442",desc:"CYRILLIC SMALL LETTER TE"},{"char":"&#x443",desc:"CYRILLIC SMALL LETTER U"},{"char":"&#x444",desc:"CYRILLIC SMALL LETTER EF"},{"char":"&#x445",desc:"CYRILLIC SMALL LETTER HA"},{"char":"&#x446",desc:"CYRILLIC SMALL LETTER TSE"},{"char":"&#x447",desc:"CYRILLIC SMALL LETTER CHE"},{"char":"&#x448",desc:"CYRILLIC SMALL LETTER SHA"},{"char":"&#x449",desc:"CYRILLIC SMALL LETTER SHCHA"},{"char":"&#x44A",desc:"CYRILLIC SMALL LETTER HARD SIGN"},{"char":"&#x44B",desc:"CYRILLIC SMALL LETTER YERU"},{"char":"&#x44C",desc:"CYRILLIC SMALL LETTER SOFT SIGN"},{"char":"&#x44D",desc:"CYRILLIC SMALL LETTER E"},{"char":"&#x44E",desc:"CYRILLIC SMALL LETTER YU"},{"char":"&#x44F",desc:"CYRILLIC SMALL LETTER YA"},{"char":"&#x450",desc:"CYRILLIC SMALL LETTER IE WITH GRAVE"},{"char":"&#x451",desc:"CYRILLIC SMALL LETTER IO"},{"char":"&#x452",desc:"CYRILLIC SMALL LETTER DJE"},{"char":"&#x453",desc:"CYRILLIC SMALL LETTER GJE"},{"char":"&#x454",desc:"CYRILLIC SMALL LETTER UKRAINIAN IE"},{"char":"&#x455",desc:"CYRILLIC SMALL LETTER DZE"},{"char":"&#x456",desc:"CYRILLIC SMALL LETTER BYELORUSSIAN-UKRAINIAN I"},{"char":"&#x457",desc:"CYRILLIC SMALL LETTER YI"},{"char":"&#x458",desc:"CYRILLIC SMALL LETTER JE"},{"char":"&#x459",desc:"CYRILLIC SMALL LETTER LJE"},{"char":"&#x45A",desc:"CYRILLIC SMALL LETTER NJE"},{"char":"&#x45B",desc:"CYRILLIC SMALL LETTER TSHE"},{"char":"&#x45C",desc:"CYRILLIC SMALL LETTER KJE"},{"char":"&#x45D",desc:"CYRILLIC SMALL LETTER I WITH GRAVE"},{"char":"&#x45E",desc:"CYRILLIC SMALL LETTER SHORT U"},{"char":"&#x45F",desc:"CYRILLIC SMALL LETTER DZHE"}]},{title:"Punctuation","char":"&ndash;",list:[{"char":"&ndash;",desc:"EN DASH"},{"char":"&mdash;",desc:"EM DASH"},{"char":"&lsquo;",desc:"LEFT SINGLE QUOTATION MARK"},{"char":"&rsquo;",desc:"RIGHT SINGLE QUOTATION MARK"},{"char":"&sbquo;",desc:"SINGLE LOW-9 QUOTATION MARK"},{"char":"&ldquo;",desc:"LEFT DOUBLE QUOTATION MARK"},{"char":"&rdquo;",desc:"RIGHT DOUBLE QUOTATION MARK"},{"char":"&bdquo;",desc:"DOUBLE LOW-9 QUOTATION MARK"},{"char":"&dagger;",desc:"DAGGER"},{"char":"&Dagger;",desc:"DOUBLE DAGGER"},{"char":"&bull;",desc:"BULLET"},{"char":"&hellip;",desc:"HORIZONTAL ELLIPSIS"},{"char":"&permil;",desc:"PER MILLE SIGN"},{"char":"&prime;",desc:"PRIME"},{"char":"&Prime;",desc:"DOUBLE PRIME"},{"char":"&lsaquo;",desc:"SINGLE LEFT-POINTING ANGLE QUOTATION MARK"},{"char":"&rsaquo;",desc:"SINGLE RIGHT-POINTING ANGLE QUOTATION MARK"},{"char":"&oline;",desc:"OVERLINE"},{"char":"&frasl;",desc:"FRACTION SLASH"}]},{title:"Currency","char":"&#x20A0",list:[{"char":"&#x20A0",desc:"EURO-CURRENCY SIGN"},{"char":"&#x20A1",desc:"COLON SIGN"},{"char":"&#x20A2",desc:"CRUZEIRO SIGN"},{"char":"&#x20A3",desc:"FRENCH FRANC SIGN"},{"char":"&#x20A4",desc:"LIRA SIGN"},{"char":"&#x20A5",desc:"MILL SIGN"},{"char":"&#x20A6",desc:"NAIRA SIGN"},{"char":"&#x20A7",desc:"PESETA SIGN"},{"char":"&#x20A8",desc:"RUPEE SIGN"},{"char":"&#x20A9",desc:"WON SIGN"},{"char":"&#x20AA",desc:"NEW SHEQEL SIGN"},{"char":"&#x20AB",desc:"DONG SIGN"},{"char":"&#x20AC",desc:"EURO SIGN"},{"char":"&#x20AD",desc:"KIP SIGN"},{"char":"&#x20AE",desc:"TUGRIK SIGN"},{"char":"&#x20AF",desc:"DRACHMA SIGN"},{"char":"&#x20B0",desc:"GERMAN PENNY SYMBOL"},{"char":"&#x20B1",desc:"PESO SIGN"},{"char":"&#x20B2",desc:"GUARANI SIGN"},{"char":"&#x20B3",desc:"AUSTRAL SIGN"},{"char":"&#x20B4",desc:"HRYVNIA SIGN"},{"char":"&#x20B5",desc:"CEDI SIGN"},{"char":"&#x20B6",desc:"LIVRE TOURNOIS SIGN"},{"char":"&#x20B7",desc:"SPESMILO SIGN"},{"char":"&#x20B8",desc:"TENGE SIGN"},{"char":"&#x20B9",desc:"INDIAN RUPEE SIGN"}]},{title:"Arrows","char":"&#x2190",list:[{"char":"&#x2190",desc:"LEFTWARDS ARROW"},{"char":"&#x2191",desc:"UPWARDS ARROW"},{"char":"&#x2192",desc:"RIGHTWARDS ARROW"},{"char":"&#x2193",desc:"DOWNWARDS ARROW"},{"char":"&#x2194",desc:"LEFT RIGHT ARROW"},{"char":"&#x2195",desc:"UP DOWN ARROW"},{"char":"&#x2196",desc:"NORTH WEST ARROW"},{"char":"&#x2197",desc:"NORTH EAST ARROW"},{"char":"&#x2198",desc:"SOUTH EAST ARROW"},{"char":"&#x2199",desc:"SOUTH WEST ARROW"},{"char":"&#x219A",desc:"LEFTWARDS ARROW WITH STROKE"},{"char":"&#x219B",desc:"RIGHTWARDS ARROW WITH STROKE"},{"char":"&#x219C",desc:"LEFTWARDS WAVE ARROW"},{"char":"&#x219D",desc:"RIGHTWARDS WAVE ARROW"},{"char":"&#x219E",desc:"LEFTWARDS TWO HEADED ARROW"},{"char":"&#x219F",desc:"UPWARDS TWO HEADED ARROW"},{"char":"&#x21A0",desc:"RIGHTWARDS TWO HEADED ARROW"},{"char":"&#x21A1",desc:"DOWNWARDS TWO HEADED ARROW"},{"char":"&#x21A2",desc:"LEFTWARDS ARROW WITH TAIL"},{"char":"&#x21A3",desc:"RIGHTWARDS ARROW WITH TAIL"},{"char":"&#x21A4",desc:"LEFTWARDS ARROW FROM BAR"},{"char":"&#x21A5",desc:"UPWARDS ARROW FROM BAR"},{"char":"&#x21A6",desc:"RIGHTWARDS ARROW FROM BAR"},{"char":"&#x21A7",desc:"DOWNWARDS ARROW FROM BAR"},{"char":"&#x21A8",desc:"UP DOWN ARROW WITH BASE"},{"char":"&#x21A9",desc:"LEFTWARDS ARROW WITH HOOK"},{"char":"&#x21AA",desc:"RIGHTWARDS ARROW WITH HOOK"},{"char":"&#x21AB",desc:"LEFTWARDS ARROW WITH LOOP"},{"char":"&#x21AC",desc:"RIGHTWARDS ARROW WITH LOOP"},{"char":"&#x21AD",desc:"LEFT RIGHT WAVE ARROW"},{"char":"&#x21AE",desc:"LEFT RIGHT ARROW WITH STROKE"},{"char":"&#x21AF",desc:"DOWNWARDS ZIGZAG ARROW"},{"char":"&#x21B0",desc:"UPWARDS ARROW WITH TIP LEFTWARDS"},{"char":"&#x21B1",desc:"UPWARDS ARROW WITH TIP RIGHTWARDS"},{"char":"&#x21B2",desc:"DOWNWARDS ARROW WITH TIP LEFTWARDS"},{"char":"&#x21B3",desc:"DOWNWARDS ARROW WITH TIP RIGHTWARDS"},{"char":"&#x21B4",desc:"RIGHTWARDS ARROW WITH CORNER DOWNWARDS"},{"char":"&#x21B5",desc:"DOWNWARDS ARROW WITH CORNER LEFTWARDS"},{"char":"&#x21B6",desc:"ANTICLOCKWISE TOP SEMICIRCLE ARROW"},{"char":"&#x21B7",desc:"CLOCKWISE TOP SEMICIRCLE ARROW"},{"char":"&#x21B8",desc:"NORTH WEST ARROW TO LONG BAR"},{"char":"&#x21B9",desc:"LEFTWARDS ARROW TO BAR OVER RIGHTWARDS ARROW TO BAR"},{"char":"&#x21BA",desc:"ANTICLOCKWISE OPEN CIRCLE ARROW"},{"char":"&#x21BB",desc:"CLOCKWISE OPEN CIRCLE ARROW"},{"char":"&#x21BC",desc:"LEFTWARDS HARPOON WITH BARB UPWARDS"},{"char":"&#x21BD",desc:"LEFTWARDS HARPOON WITH BARB DOWNWARDS"},{"char":"&#x21BE",desc:"UPWARDS HARPOON WITH BARB RIGHTWARDS"},{"char":"&#x21BF",desc:"UPWARDS HARPOON WITH BARB LEFTWARDS"},{"char":"&#x21C0",desc:"RIGHTWARDS HARPOON WITH BARB UPWARDS"},{"char":"&#x21C1",desc:"RIGHTWARDS HARPOON WITH BARB DOWNWARDS"},{"char":"&#x21C2",desc:"DOWNWARDS HARPOON WITH BARB RIGHTWARDS"},{"char":"&#x21C3",desc:"DOWNWARDS HARPOON WITH BARB LEFTWARDS"},{"char":"&#x21C4",desc:"RIGHTWARDS ARROW OVER LEFTWARDS ARROW"},{"char":"&#x21C5",desc:"UPWARDS ARROW LEFTWARDS OF DOWNWARDS ARROW"},{"char":"&#x21C6",desc:"LEFTWARDS ARROW OVER RIGHTWARDS ARROW"},{"char":"&#x21C7",desc:"LEFTWARDS PAIRED ARROWS"},{"char":"&#x21C8",desc:"UPWARDS PAIRED ARROWS"},{"char":"&#x21C9",desc:"RIGHTWARDS PAIRED ARROWS"},{"char":"&#x21CA",desc:"DOWNWARDS PAIRED ARROWS"},{"char":"&#x21CB",desc:"LEFTWARDS HARPOON OVER RIGHTWARDS HARPOON"},{"char":"&#x21CC",desc:"RIGHTWARDS HARPOON OVER LEFTWARDS HARPOON"},{"char":"&#x21CD",desc:"LEFTWARDS DOUBLE ARROW WITH STROKE"},{"char":"&#x21CE",desc:"LEFT RIGHT DOUBLE ARROW WITH STROKE"},{"char":"&#x21CF",desc:"RIGHTWARDS DOUBLE ARROW WITH STROKE"},{"char":"&#x21D0",desc:"LEFTWARDS DOUBLE ARROW"},{"char":"&#x21D1",desc:"UPWARDS DOUBLE ARROW"},{"char":"&#x21D2",desc:"RIGHTWARDS DOUBLE ARROW"},{"char":"&#x21D3",desc:"DOWNWARDS DOUBLE ARROW"},{"char":"&#x21D4",desc:"LEFT RIGHT DOUBLE ARROW"},{"char":"&#x21D5",desc:"UP DOWN DOUBLE ARROW"},{"char":"&#x21D6",desc:"NORTH WEST DOUBLE ARROW"},{"char":"&#x21D7",desc:"NORTH EAST DOUBLE ARROW"},{"char":"&#x21D8",desc:"SOUTH EAST DOUBLE ARROW"},{"char":"&#x21D9",desc:"SOUTH WEST DOUBLE ARROW"},{"char":"&#x21DA",desc:"LEFTWARDS TRIPLE ARROW"},{"char":"&#x21DB",desc:"RIGHTWARDS TRIPLE ARROW"},{"char":"&#x21DC",desc:"LEFTWARDS SQUIGGLE ARROW"},{"char":"&#x21DD",desc:"RIGHTWARDS SQUIGGLE ARROW"},{"char":"&#x21DE",desc:"UPWARDS ARROW WITH DOUBLE STROKE"},{"char":"&#x21DF",desc:"DOWNWARDS ARROW WITH DOUBLE STROKE"},{"char":"&#x21E0",desc:"LEFTWARDS DASHED ARROW"},{"char":"&#x21E1",desc:"UPWARDS DASHED ARROW"},{"char":"&#x21E2",desc:"RIGHTWARDS DASHED ARROW"},{"char":"&#x21E3",desc:"DOWNWARDS DASHED ARROW"},{"char":"&#x21E4",desc:"LEFTWARDS ARROW TO BAR"},{"char":"&#x21E5",desc:"RIGHTWARDS ARROW TO BAR"},{"char":"&#x21E6",desc:"LEFTWARDS WHITE ARROW"},{"char":"&#x21E7",desc:"UPWARDS WHITE ARROW"},{"char":"&#x21E8",desc:"RIGHTWARDS WHITE ARROW"},{"char":"&#x21E9",desc:"DOWNWARDS WHITE ARROW"},{"char":"&#x21EA",desc:"UPWARDS WHITE ARROW FROM BAR"},{"char":"&#x21EB",desc:"UPWARDS WHITE ARROW ON PEDESTAL"},{"char":"&#x21EC",desc:"UPWARDS WHITE ARROW ON PEDESTAL WITH HORIZONTAL BAR"},{"char":"&#x21ED",desc:"UPWARDS WHITE ARROW ON PEDESTAL WITH VERTICAL BAR"},{"char":"&#x21EE",desc:"UPWARDS WHITE DOUBLE ARROW"},{"char":"&#x21EF",desc:"UPWARDS WHITE DOUBLE ARROW ON PEDESTAL"},{"char":"&#x21F0",desc:"RIGHTWARDS WHITE ARROW FROM WALL"},{"char":"&#x21F1",desc:"NORTH WEST ARROW TO CORNER"},{"char":"&#x21F2",desc:"SOUTH EAST ARROW TO CORNER"},{"char":"&#x21F3",desc:"UP DOWN WHITE ARROW"},{"char":"&#x21F4",desc:"RIGHT ARROW WITH SMALL CIRCLE"},{"char":"&#x21F5",desc:"DOWNWARDS ARROW LEFTWARDS OF UPWARDS ARROW"},{"char":"&#x21F6",desc:"THREE RIGHTWARDS ARROWS"},{"char":"&#x21F7",desc:"LEFTWARDS ARROW WITH VERTICAL STROKE"},{"char":"&#x21F8",desc:"RIGHTWARDS ARROW WITH VERTICAL STROKE"},{"char":"&#x21F9",desc:"LEFT RIGHT ARROW WITH VERTICAL STROKE"},{"char":"&#x21FA",desc:"LEFTWARDS ARROW WITH DOUBLE VERTICAL STROKE"},{"char":"&#x21FB",desc:"RIGHTWARDS ARROW WITH DOUBLE VERTICAL STROKE"},{"char":"&#x21FC",desc:"LEFT RIGHT ARROW WITH DOUBLE VERTICAL STROKE"},{"char":"&#x21FD",desc:"LEFTWARDS OPEN-HEADED ARROW"},{"char":"&#x21FE",desc:"RIGHTWARDS OPEN-HEADED ARROW"},{"char":"&#x21FF",desc:"LEFT RIGHT OPEN-HEADED ARROW"}]},{title:"Math","char":"&forall;",list:[{"char":"&forall;",desc:"FOR ALL"},{"char":"&part;",desc:"PARTIAL DIFFERENTIAL"},{"char":"&exist;",desc:"THERE EXISTS"},{"char":"&empty;",desc:"EMPTY SET"},{"char":"&nabla;",desc:"NABLA"},{"char":"&isin;",desc:"ELEMENT OF"},{"char":"&notin;",desc:"NOT AN ELEMENT OF"},{"char":"&ni;",desc:"CONTAINS AS MEMBER"},{"char":"&prod;",desc:"N-ARY PRODUCT"},{"char":"&sum;",desc:"N-ARY SUMMATION"},{"char":"&minus;",desc:"MINUS SIGN"},{"char":"&lowast;",desc:"ASTERISK OPERATOR"},{"char":"&radic;",desc:"SQUARE ROOT"},{"char":"&prop;",desc:"PROPORTIONAL TO"},{"char":"&infin;",desc:"INFINITY"},{"char":"&ang;",desc:"ANGLE"},{"char":"&and;",desc:"LOGICAL AND"},{"char":"&or;",desc:"LOGICAL OR"},{"char":"&cap;",desc:"INTERSECTION"},{"char":"&cup;",desc:"UNION"},{"char":"&int;",desc:"INTEGRAL"},{"char":"&there4;",desc:"THEREFORE"},{"char":"&sim;",desc:"TILDE OPERATOR"},{"char":"&cong;",desc:"APPROXIMATELY EQUAL TO"},{"char":"&asymp;",desc:"ALMOST EQUAL TO"},{"char":"&ne;",desc:"NOT EQUAL TO"},{"char":"&equiv;",desc:"IDENTICAL TO"},{"char":"&le;",desc:"LESS-THAN OR EQUAL TO"},{"char":"&ge;",desc:"GREATER-THAN OR EQUAL TO"},{"char":"&sub;",desc:"SUBSET OF"},{"char":"&sup;",desc:"SUPERSET OF"},{"char":"&nsub;",desc:"NOT A SUBSET OF"},{"char":"&sube;",desc:"SUBSET OF OR EQUAL TO"},{"char":"&supe;",desc:"SUPERSET OF OR EQUAL TO"},{"char":"&oplus;",desc:"CIRCLED PLUS"},{"char":"&otimes;",desc:"CIRCLED TIMES"},{"char":"&perp;",desc:"UP TACK"}]},{title:"Misc","char":"&spades;",list:[{"char":"&spades;",desc:"BLACK SPADE SUIT"},{"char":"&clubs;",desc:"BLACK CLUB SUIT"},{"char":"&hearts;",desc:"BLACK HEART SUIT"},{"char":"&diams;",desc:"BLACK DIAMOND SUIT"},{"char":"&#x2669",desc:"QUARTER NOTE"},{"char":"&#x266A",desc:"EIGHTH NOTE"},{"char":"&#x266B",desc:"BEAMED EIGHTH NOTES"},{"char":"&#x266C",desc:"BEAMED SIXTEENTH NOTES"},{"char":"&#x266D",desc:"MUSIC FLAT SIGN"},{"char":"&#x266E",desc:"MUSIC NATURAL SIGN"},{"char":"&#x2600",desc:"BLACK SUN WITH RAYS"},{"char":"&#x2601",desc:"CLOUD"},{"char":"&#x2602",desc:"UMBRELLA"},{"char":"&#x2603",desc:"SNOWMAN"},{"char":"&#x2615",desc:"HOT BEVERAGE"},{"char":"&#x2618",desc:"SHAMROCK"},{"char":"&#x262F",desc:"YIN YANG"},{"char":"&#x2714",desc:"HEAVY CHECK MARK"},{"char":"&#x2716",desc:"HEAVY MULTIPLICATION X"},{"char":"&#x2744",desc:"SNOWFLAKE"},{"char":"&#x275B",desc:"HEAVY SINGLE TURNED COMMA QUOTATION MARK ORNAMENT"},{"char":"&#x275C",desc:"HEAVY SINGLE COMMA QUOTATION MARK ORNAMENT"},{"char":"&#x275D",desc:"HEAVY DOUBLE TURNED COMMA QUOTATION MARK ORNAMENT"},{"char":"&#x275E",desc:"HEAVY DOUBLE COMMA QUOTATION MARK ORNAMENT"},{"char":"&#x2764",desc:"HEAVY BLACK HEART"}]}],specialCharButtons:["specialCharBack","|"]}),Object.assign(H.POPUP_TEMPLATES,{specialCharacters:"[_BUTTONS_][_CUSTOM_LAYER_]"}),H.PLUGINS.specialCharacters=function(D){var i=D.$,c=D.opts.specialCharactersSets,L=D.opts.specialCharactersSets[0],a="";function I(){return'\n        <div class="fr-buttons fr-tabs fr-tabs-scroll">\n          '.concat(function E(c,T){var R="";return c.forEach(function(c){var E={elementClass:c.title===T.title?"fr-active fr-active-tab":"",title:c.title,dataParam1:c.title,desc:c["char"]};R+='<button class="fr-command fr-btn fr-special-character-category '.concat(E.elementClass,'" title="').concat(E.title,'" data-cmd="setSpecialCharacterCategory" data-param1="').concat(E.dataParam1,'"><span>').concat(E.desc,"</span></button>")}),R}(c,L),'\n        </div>\n        <div class="fr-icon-container fr-sc-container" style="outline: none;">\n          ').concat(function R(c){var T="";return c.list.forEach(function(c){var E={dataParam1:c["char"],title:c.desc,splCharValue:c["char"]};T+='<span class="fr-command fr-special-character fr-icon" role="button" \n      data-cmd="insertSpecialCharacter" data-param1="'.concat(E.dataParam1,'" tabindex="0"\n      title="').concat(E.title,'">').concat(E.splCharValue,"</span>")}),T}(L),"\n        </div>")}return{setSpecialCharacterCategory:function R(E){L=c.filter(function(c){return c.title===E})[0],function T(){D.popups.get("specialCharacters").html(a+I());var c=D.popups.get("specialCharacters").children().not(".fr-buttons");D.accessibility.registerPopup("specialCharacters"),D.accessibility.focusContent(c)}()},showSpecialCharsPopup:function e(){var c=D.popups.get("specialCharacters");if(c||(c=function A(){D.opts.toolbarInline&&0<D.opts.specialCharButtons.length&&(a='<div class="fr-buttons fr-tabs">'.concat(D.button.buildList(D.opts.specialCharButtons),"</div>"));var c={buttons:a,custom_layer:I()},E=D.popups.create("specialCharacters",c);return function T(N){D.events.on("popup.tab",function(c){var E=i(c.currentTarget);if(!D.popups.isVisible("specialCharacters")||!E.is("span, a"))return!0;var T,R,L,A=c.which,a=window.getComputedStyle(N.find(".fr-icon-container")[0]),I=a.getPropertyValue("grid-template-columns").split(" ").length;if(H.KEYCODE.TAB==A){var e=N.find("span.fr-special-character");if(E.is(e.first())&&c.shiftKey||E.is(e.last())&&!c.shiftKey){var r=N.find(".fr-buttons");T=!D.accessibility.focusToolbar(r,!!c.shiftKey)}if(!1!==T){var s=N.find("span.fr-special-character");s.add(N.find("button.fr-btn")),R=s.index(E),R=c.shiftKey?((R-1)%s.length+s.length)%s.length:(R+1)%s.length,L=s.get(R),D.events.disableBlur(),L.focus(),T=!1}}else if(H.KEYCODE.ARROW_UP==A||H.KEYCODE.ARROW_DOWN==A||H.KEYCODE.ARROW_LEFT==A||H.KEYCODE.ARROW_RIGHT==A){if(E.is("span.fr-icon")){var h=E.parent().find("span.fr-icon");R=h.index(E);var d=I,C=Math.ceil(h.length/d),O=R%d,S=Math.floor(R/d),W=S*d+O,t=C*d;H.KEYCODE.ARROW_UP==A?W=((W-d)%t+t)%t:H.KEYCODE.ARROW_DOWN==A?W=(W+d)%t:H.KEYCODE.ARROW_LEFT==A?W=((W-1)%t+t)%t:H.KEYCODE.ARROW_RIGHT==A&&(W=(W+1)%t),L=i(h.get(W)),D.events.disableBlur(),L.focus(),T=!1}}else H.KEYCODE.ENTER==A&&(E.is("a")?E[0].click():D.button.exec(E),T=!1);return!1===T&&(c.preventDefault(),c.stopPropagation()),T},!0)}(E),E}()),!c.hasClass("fr-active")){D.popups.refresh("specialCharacters"),D.popups.setContainer("specialCharacters",D.$tb);var E=D.$tb.find('.fr-command[data-cmd="specialCharacters"]'),T=D.button.getPosition(E),R=T.left,L=T.top;D.popups.show("specialCharacters",R,L,outerHeight)}},back:function E(){D.popups.hide("specialCharacters"),D.toolbar.showInline()}}},H.DefineIcon("specialCharacters",{NAME:"dollar-sign",SVG_KEY:"symbols"}),H.RegisterCommand("specialCharacters",{title:"Special Characters",icon:"specialCharacters",undo:!1,focus:!1,popup:!0,refreshAfterCallback:!1,plugin:"specialCharacters",showOnMobile:!0,callback:function(){this.popups.isVisible("specialCharacters")?(this.$el.find(".fr-marker")&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("specialCharacters")):this.specialCharacters.showSpecialCharsPopup()}}),H.RegisterCommand("insertSpecialCharacter",{callback:function(c,E){this.undo.saveStep(),this.html.insert(E),this.undo.saveStep(),this.popups.hide("specialCharacters")}}),H.RegisterCommand("setSpecialCharacterCategory",{undo:!1,focus:!1,callback:function(c,E){this.specialCharacters.setSpecialCharacterCategory(E)}}),H.DefineIcon("specialCharBack",{NAME:"arrow-left",SVG_KEY:"back"}),H.RegisterCommand("specialCharBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.specialCharacters.back()}})});

/***/ }),

/***/ 6975:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(e,t){ true?t(__webpack_require__(189)):0}(this,function(ye){"use strict";function r(e,t){(null==t||t>e.length)&&(t=e.length);for(var a=0,l=Array(t);a<t;a++)l[a]=e[a];return l}function Re(e){return function t(e){if(Array.isArray(e))return r(e)}(e)||function a(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function l(e,t){if(e){if("string"==typeof e)return r(e,t);var a={}.toString.call(e).slice(8,-1);return"Object"===a&&e.constructor&&(a=e.constructor.name),"Map"===a||"Set"===a?Array.from(e):"Arguments"===a||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)?r(e,t):void 0}}(e)||function n(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}ye=ye&&ye.hasOwnProperty("default")?ye["default"]:ye,Object.assign(ye.POPUP_TEMPLATES,{"table.insert":"[_BUTTONS_][_ROWS_COLUMNS_]","table.edit":"[_BUTTONS_]","table.colors":"[_BUTTONS_][_COLORS_][_CUSTOM_COLOR_]"}),Object.assign(ye.DEFAULTS,{tableInsertMaxSize:10,tableEditButtons:["tableHeader","tableFooter","tableRemove","tableRows","tableColumns","tableStyle","-","tableCells","tableCellBackground","tableCellVerticalAlign","tableCellHorizontalAlign","tableCellStyle"],tableInsertButtons:["tableBack","|"],tableResizer:!0,tableDefaultWidth:"100%",tableResizerOffset:5,tableResizingLimit:30,tableColorsButtons:["tableBack","|"],tableColors:["#61BD6D","#1ABC9C","#54ACD2","#2C82C9","#9365B8","#475577","#CCCCCC","#41A85F","#00A885","#3D8EB9","#2969B0","#553982","#28324E","#000000","#F7DA64","#FBA026","#EB6B56","#E25041","#A38F84","#EFEFEF","#FFFFFF","#FAC51C","#F37934","#D14841","#B8312F","#7C706B","#D1D5D8","REMOVE"],tableColorsStep:7,tableCellStyles:{"fr-highlighted":"Highlighted","fr-thick":"Thick"},tableStyles:{"fr-dashed-borders":"Dashed Borders","fr-alternate-rows":"Alternate Rows"},tableCellMultipleStyles:!0,tableMultipleStyles:!0,tableInsertHelper:!0,keepTextFormatOnTable:!1,tableInsertHelperOffset:15}),ye.PLUGINS.table=function(A){var O,f,n,r,l,o,y,T=A.$;function g(){var e=x();if(e){var t=A.popups.get("table.edit");if(t||(t=p()),t){A.popups.setContainer("table.edit",A.$sc);var a=I(e),l=a.left+(a.right-a.left)/2,n=a.bottom;A.popups.show("table.edit",l,n,a.bottom-a.top,!0),A.edit.isDisabled()&&(A.$el.removeClass("fr-no-selection"),A.edit.on(),A.button.bulkRefresh(),A.selection.setAtEnd(A.$el.find(".fr-selected-cell").last().get(0)),A.selection.restore())}}}function s(){var e=x();if(e){var t=A.popups.get("table.colors");t||(t=function o(){var e="";0<A.opts.tableColorsButtons.length&&(e='<div class="fr-buttons fr-tabs">'.concat(A.button.buildList(A.opts.tableColorsButtons),"</div>"));var t="";A.opts.colorsHEXInput&&(t='<div class="fr-color-hex-layer fr-table-colors-hex-layer fr-active fr-layer" id="fr-table-colors-hex-layer-'.concat(A.id,'"><div class="fr-input-line"><input maxlength="7" id="fr-table-colors-hex-layer-text-').concat(A.id,'" type="text" placeholder="').concat(A.language.translate("HEX Color"),'" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="tableCellBackgroundCustomColor" tabIndex="2" role="button">').concat(A.language.translate("OK"),"</button></div></div>"));var a={buttons:e,colors:function n(){for(var e='<div class="fr-color-set fr-table-colors">',t=0;t<A.opts.tableColors.length;t++)0!==t&&t%A.opts.tableColorsStep==0&&(e+="<br>"),"REMOVE"!=A.opts.tableColors[t]?e+='<span class="fr-command" style="background: '.concat(A.opts.tableColors[t],';" tabIndex="-1" role="button" data-cmd="tableCellBackgroundColor" data-param1="').concat(A.opts.tableColors[t],'"><span class="fr-sr-only">').concat(A.language.translate("Color")," ").concat(A.opts.tableColors[t],"&nbsp;&nbsp;&nbsp;</span></span>"):e+='<span class="fr-command" data-cmd="tableCellBackgroundColor" tabIndex="-1" role="button" data-param1="REMOVE" title="'.concat(A.language.translate("Clear Formatting"),'">').concat(A.icon.create("tableColorRemove"),'<span class="fr-sr-only">').concat(A.language.translate("Clear Formatting"),"</span></span>");return e+="</div>"}(),custom_color:t},l=A.popups.create("table.colors",a);return A.events.$on(A.$wp,"scroll.table-colors",function(){A.popups.isVisible("table.colors")&&s()}),function r(u){A.events.on("popup.tab",function(e){var t=T(e.currentTarget);if(!A.popups.isVisible("table.colors")||!t.is("span"))return!0;var a=e.which,l=!0;if(ye.KEYCODE.TAB==a){var n=u.find(".fr-buttons");l=!A.accessibility.focusToolbar(n,!!e.shiftKey)}else if(ye.KEYCODE.ARROW_UP==a||ye.KEYCODE.ARROW_DOWN==a||ye.KEYCODE.ARROW_LEFT==a||ye.KEYCODE.ARROW_RIGHT==a){var r=t.parent().find("span.fr-command"),o=r.index(t),s=A.opts.colorsStep,i=Math.floor(r.length/s),f=o%s,c=Math.floor(o/s),d=c*s+f,p=i*s;ye.KEYCODE.ARROW_UP==a?d=((d-s)%p+p)%p:ye.KEYCODE.ARROW_DOWN==a?d=(d+s)%p:ye.KEYCODE.ARROW_LEFT==a?d=((d-1)%p+p)%p:ye.KEYCODE.ARROW_RIGHT==a&&(d=(d+1)%p);var h=T(r.get(d));A.events.disableBlur(),h.focus(),l=!1}else ye.KEYCODE.ENTER==a&&(A.button.exec(t),l=!1);return!1===l&&(e.preventDefault(),e.stopPropagation()),l},!0)}(l),l}()),A.popups.setContainer("table.colors",A.$sc);var a=I(e),l=(a.left+a.right)/2,n=a.bottom;!function r(){var e=A.popups.get("table.colors"),t=A.$el.find(".fr-selected-cell").first(),a=A.helpers.RGBToHex(t.css("background-color")),l=e.find(".fr-table-colors-hex-layer input");e.find(".fr-selected-color").removeClass("fr-selected-color fr-active-item"),e.find('span[data-param1="'.concat(a,'"]')).addClass("fr-selected-color fr-active-item"),l.val(a).trigger("change")}(),A.popups.show("table.colors",l,n,a.bottom-a.top,!0)}}function i(){0===te().length&&A.toolbar.enable()}function c(e){if(e)return A.popups.onHide("table.insert",function(){A.popups.get("table.insert").find('.fr-table-size .fr-select-table-size > span[data-row="1"][data-col="1"]').trigger("mouseover")}),!0;var t="";0<A.opts.tableInsertButtons.length&&(t='<div class="fr-buttons fr-tabs">'.concat(A.button.buildList(A.opts.tableInsertButtons),"</div>"));var a={buttons:t,rows_columns:function r(){for(var e='<div class="fr-table-size"><div class="fr-table-size-info">1 &times; 1</div><div class="fr-select-table-size">',t=1;t<=A.opts.tableInsertMaxSize;t++){for(var a=1;a<=A.opts.tableInsertMaxSize;a++){var l="inline-block";2<t&&!A.helpers.isMobile()&&(l="none");var n="fr-table-cell ";1==t&&1==a&&(n+=" hover"),e+='<span class="fr-command '.concat(n,'" tabIndex="-1" data-cmd="tableInsert" data-row="').concat(t,'" data-col="').concat(a,'" data-param1="').concat(t,'" data-param2="').concat(a,'" style="display: ').concat(l,';" role="button"><span></span><span class="fr-sr-only">').concat(t," &times; ").concat(a,"&nbsp;&nbsp;&nbsp;</span></span>")}e+='<div class="new-line"></div>'}return e+="</div></div>"}()},l=A.popups.create("table.insert",a);return A.events.$on(l,"mouseover",".fr-table-size .fr-select-table-size .fr-table-cell",function(e){d(T(e.currentTarget))},!0),function n(e){A.events.$on(e,"focus","[tabIndex]",function(e){var t=T(e.currentTarget);d(t)}),A.events.on("popup.tab",function(e){var t=T(e.currentTarget);if(!A.popups.isVisible("table.insert")||!t.is("span, a"))return!0;var a,l=e.which;if(ye.KEYCODE.ARROW_UP==l||ye.KEYCODE.ARROW_DOWN==l||ye.KEYCODE.ARROW_LEFT==l||ye.KEYCODE.ARROW_RIGHT==l){if(t.is("span.fr-table-cell")){var n=t.parent().find("span.fr-table-cell"),r=n.index(t),o=A.opts.tableInsertMaxSize,s=r%o,i=Math.floor(r/o);ye.KEYCODE.ARROW_UP==l?i=Math.max(0,i-1):ye.KEYCODE.ARROW_DOWN==l?i=Math.min(A.opts.tableInsertMaxSize-1,i+1):ye.KEYCODE.ARROW_LEFT==l?s=Math.max(0,s-1):ye.KEYCODE.ARROW_RIGHT==l&&(s=Math.min(A.opts.tableInsertMaxSize-1,s+1));var f=i*o+s,c=T(n.get(f));d(c),A.events.disableBlur(),c.focus(),a=!1}}else ye.KEYCODE.ENTER==l&&(A.button.exec(t),a=!1);return!1===a&&(e.preventDefault(),e.stopPropagation()),a},!0)}(l),l}function d(e){var t=e.data("row");null!==t&&(t=parseInt(t));var a=e.data("col");null!==a&&(a=parseInt(a));var l=e.parent();l.siblings(".fr-table-size-info").html("".concat(t," &times; ").concat(a)),l.find("> span").removeClass("hover fr-active-item");for(var n=1;n<=A.opts.tableInsertMaxSize;n++)for(var r=0;r<=A.opts.tableInsertMaxSize;r++){var o=l.find('> span[data-row="'.concat(n,'"][data-col="').concat(r,'"]'));n<=t&&r<=a?o.addClass("hover"):n<=t+1||n<=2&&!A.helpers.isMobile()?o.css("display","inline-block"):2<n&&!A.helpers.isMobile()&&o.css("display","none")}e.addClass("fr-active-item")}function p(e){if(e)return A.popups.onHide("table.edit",i),!0;if(0<A.opts.tableEditButtons.length){var t={buttons:'<div class="fr-buttons">'.concat(A.button.buildList(A.opts.tableEditButtons),"</div>")},a=A.popups.create("table.edit",t);return A.events.$on(A.$wp,"scroll.table-edit",function(){A.popups.isVisible("table.edit")&&g()}),a}return!1}function b(e){var t={startTag:"",closeTag:""};return A.opts.keepTextFormatOnTable&&(t=h(function s(e){var t=new Set,a=e.textContent,l=0,n=[e.firstChild];for(;0<n.length;){var r=n.pop();if(r&&(t.has(r)||(0===l&&a!==r.textContent&&(a=r.textContent,l++),t.add(r)),r.hasChildNodes()))for(var o=0;o<r.childNodes.length;){if(3===r.childNodes[o].nodeType)return Re(t);if(r.childNodes[o].textContent){if(0===l&&r.childNodes[o].textContent!==a){a=r.childNodes[o].textContent,n.push(r.childNodes[o]),l++;break}r.childNodes[o].textContent===a&&n.push(r.childNodes[o])}o++}}return Re(t)}(e).reverse())),{startTag:t.startTag,closeTag:t.closeTag}}function h(e){var t="",a="",l=["br","#text","#comment","font"];if(0<e.length)for(var n=e.length-1;0<=n;n--){var r=e[n],o=A.node.isBlock(r),s=l.indexOf(r.nodeName.toLowerCase());if(!o&&s<0){var i=r.style,f="";if(i&&i.length){for(var c=0;c<i.length;c++)f+=i[c]+": "+i[i[c]].replace(/"/gi,"")+"; ";f=f.trim()}t+=f?"<"+r.nodeName.toLowerCase()+' style="'+f+'">':"<"+r.nodeName.toLowerCase()+">",a="</"+r.nodeName.toLowerCase()+">"+a}}return{startTag:t,closeTag:a}}function u(){if(0<te().length){var e=ae();A.selection.setBefore(e.get(0))||A.selection.setAfter(e.get(0)),A.selection.restore(),A.popups.hide("table.edit"),A.opts.trackChangesEnabled?(A.track_changes.removedTable(e),N()):e.remove(),A.toolbar.enable()}}function m(e){var t=ae();if(0<t.length){if(0<A.$el.find("thead .fr-selected-cell").length&&"above"==e||0<A.$el.find("tfoot td.fr-selected-cell").length&&"below"==e)return;var a,l,n,r=x(),o=M(r);if(null==o)return;l="above"==e?o.min_i:o.max_i;var s="<tr>";for(a=0;a<r[l].length;a++)if("below"==e&&l<r.length-1&&r[l][a]==r[l+1][a]||"above"==e&&0<l&&r[l][a]==r[l-1][a]){if(0===a||0<a&&r[l][a]!=r[l][a-1]){var i=T(r[l][a]);i.attr("rowspan",parseInt(i.attr("rowspan"),10)+1)}}else{var f=T(r[l][a]);if("TH"==f.attr("tagName").toUpperCase())s+='<th style="'+f.attr("style")+'" ><br></th>';else{var c=b(r[l][a]);s+='<td style="'+f.attr("style")+'" >'+c.startTag+"<br>"+c.closeTag+"</td>"}}s+="</tr>",n=0<A.$el.find("thead .fr-selected-cell").length&&"below"==e||0<A.$el.find("tfoot td.fr-selected-cell").length&&"above"==e?T(t.find("tbody").not(t.find("> table tbody"))):T(t.find("tr").not(t.find("> table tr")).get(l)),"below"==e?"TBODY"==n.attr("tagName")?n.prepend(s):n[0].parentNode&&n[0].insertAdjacentHTML("afterend",s):"above"==e&&("TBODY"==n.attr("tagName")?n.append(s):n.before(s),A.popups.isVisible("table.edit")&&g())}}function v(e,t,a){var l,n,r,o,s,i=0,f=x(a);if(e<(t=Math.min(t,f[0].length-1)))for(n=e;n<=t;n++)if(!(e<n&&f[0][n]==f[0][n-1])&&1<(o=Math.min(parseInt(f[0][n].getAttribute("colspan"),10)||1,t-e+1))&&f[0][n]==f[0][n+1])for(i=o-1,l=1;l<f.length;l++)if(f[l][n]!=f[l-1][n]){for(r=n;r<n+o;r++)if(f[l][r]!==undefined)if(1<(s=parseInt(f[l][r].getAttribute("colspan"),10)||1)&&f[l][r]==f[l][r+1])r+=i=Math.min(i,s-1);else if(!(i=Math.max(0,i-1)))break;if(!i)break}i&&C(f,i,"colspan",0,f.length-1,e,t)}function w(e,t,a){var l,n,r,o,s,i=0,f=x(a);if(e<(t=Math.min(t,f.length-1)))for(l=e;l<=t;l++)if(!(e<l&&f[l][0]==f[l-1][0])&&f[l][0]!==undefined&&1<(o=Math.min(parseInt(f[l][0].getAttribute("rowspan"),10)||1,t-e+1))&&f[l][0]==f[l+1][0])for(i=o-1,n=1;n<f[0].length;n++)if(f[l][n]!=f[l][n-1]){for(r=l;r<l+o;r++)if(f[r][n]!==undefined)if(1<(s=parseInt(f[r][n].getAttribute("rowspan"),10)||1)&&f[r][n]==f[r+1][n])r+=i=Math.min(i,s-1);else if(!(i=Math.max(0,i-1)))break;if(!i)break}i&&C(f,i,"rowspan",e,t,0,f[0].length-1)}function C(e,t,a,l,n,r,o){var s,i,f;for(s=l;s<=n;s++)for(i=r;i<=o;i++)l<s&&e[s][i]==e[s-1][i]||r<i&&e[s][i]==e[s][i-1]||e[s][i]!==undefined&&1<(f=parseInt(e[s][i].getAttribute(a),10)||1)&&(1<f-t?e[s][i].setAttribute(a,f-t):e[s][i].removeAttribute(a))}function E(e,t,a,l,n){w(e,t,n),v(a,l,n)}function t(e){var t=A.$el.find(".fr-selected-cell");"REMOVE"!=e?t.css("background-color",A.helpers.HEXtoRGB(e)):t.css("background-color",""),g()}function R(e){e.style.removeProperty("border"),e.style.removeProperty("border-top"),e.style.removeProperty("border-bottom"),e.style.removeProperty("border-left"),e.style.removeProperty("border-right")}function x(e){var f=[];if(null==(e=e||null)&&0<te().length&&(e=ae()),e){if(!e.find("tr").html().match(/xl[0-9]+/gi))for(var t=e.find("tr:empty"),a=t.length-1;0<=a;a--)T(t[a]).remove();e.find("tr").not(e.find("> table tr")).each(function(s,e){var t=T(e),i=0;t.find("> th, > td").each(function(e,t){for(var a=T(t),l=parseInt(a.attr("colspan"),10)||1,n=parseInt(a.attr("rowspan"),10)||1,r=s;r<s+n;r++)for(var o=i;o<i+l;o++)f[r]||(f[r]=[]),f[r][o]?i++:f[r][o]=t;i+=l})})}return f}function $(e,t){for(var a=0;a<t.length;a++)for(var l=0;l<t[a].length;l++)if(t[a][l]==e)return{row:a,col:l}}function D(e,t,a){for(var l=e+1,n=t+1;l<a.length;){if(a[l][t]!=a[e][t]){l--;break}l++}for(l==a.length&&l--;n<a[e].length;){if(a[e][n]!=a[e][t]){n--;break}n++}return n==a[e].length&&n--,{row:l,col:n}}function _(){A.el.querySelector(".fr-cell-fixed")&&A.el.querySelector(".fr-cell-fixed").classList.remove("fr-cell-fixed"),A.el.querySelector(".fr-cell-handler")&&A.el.querySelector(".fr-cell-handler").classList.remove("fr-cell-handler")}function N(){var e=A.$el.find(".fr-selected-cell");0<e.length&&e.each(function(){var e=T(this);e.removeClass("fr-selected-cell"),""===e.attr("class")&&e.removeAttr("class")}),_()}function S(){A.events.disableBlur(),A.selection.clear(),A.$el.addClass("fr-no-selection"),A.$el.blur(),A.events.enableBlur()}function M(e){var t=A.$el.find(".fr-selected-cell");if(0<t.length){var a,l=e.length,n=0,r=e[0].length,o=0;for(a=0;a<t.length;a++){var s=$(t[a],e),i=D(s.row,s.col,e);l=Math.min(s.row,l),n=Math.max(i.row,n),r=Math.min(s.col,r),o=Math.max(i.col,o)}return{min_i:l,max_i:n,min_j:r,max_j:o}}return null}function I(e){var t=M(e);if(null!=t){var a=T(e[t.min_i][t.min_j]),l=T(e[t.min_i][t.max_j]),n=T(e[t.max_i][t.min_j]);return{left:a.length&&a.offset().left,right:l.length&&l.offset().left+l.outerWidth(),top:a.length&&a.offset().top,bottom:n.length&&n.offset().top+n.outerHeight()}}}function k(e,t){if(T(e).is(t))N(),T(e).addClass("fr-selected-cell");else{S(),A.edit.off();var a=x(),l=$(e,a),n=$(t,a);if(!l||!n)return;var r=function h(e,t,a,l,n){var r,o,s,i,f=e,c=t,d=a,p=l;for(r=f;r<=c;r++)(1<(parseInt(T(n[r][d]).attr("rowspan"),10)||1)||1<(parseInt(T(n[r][d]).attr("colspan"),10)||1))&&(i=D((s=$(n[r][d],n)).row,s.col,n),f=Math.min(s.row,f),c=Math.max(i.row,c),d=Math.min(s.col,d),p=Math.max(i.col,p)),(1<(parseInt(T(n[r][p]).attr("rowspan"),10)||1)||1<(parseInt(T(n[r][p]).attr("colspan"),10)||1))&&(i=D((s=$(n[r][p],n)).row,s.col,n),f=Math.min(s.row,f),c=Math.max(i.row,c),d=Math.min(s.col,d),p=Math.max(i.col,p));for(o=d;o<=p;o++)(1<(parseInt(T(n[f][o]).attr("rowspan"),10)||1)||1<(parseInt(T(n[f][o]).attr("colspan"),10)||1))&&(i=D((s=$(n[f][o],n)).row,s.col,n),f=Math.min(s.row,f),c=Math.max(i.row,c),d=Math.min(s.col,d),p=Math.max(i.col,p)),(1<(parseInt(T(n[c][o]).attr("rowspan"),10)||1)||1<(parseInt(T(n[c][o]).attr("colspan"),10)||1))&&(i=D((s=$(n[c][o],n)).row,s.col,n),f=Math.min(s.row,f),c=Math.max(i.row,c),d=Math.min(s.col,d),p=Math.max(i.col,p));return f==e&&c==t&&d==a&&p==l?{min_i:e,max_i:t,min_j:a,max_j:l}:h(f,c,d,p,n)}(Math.min(l.row,n.row),Math.max(l.row,n.row),Math.min(l.col,n.col),Math.max(l.col,n.col),a);N(),e.classList.add("fr-cell-fixed"),t.classList.add("fr-cell-handler");for(var o=r.min_i;o<=r.max_i;o++)for(var s=r.min_j;s<=r.max_j;s++)T(e).closest("table").is(T(a[o][s]).closest("table"))&&T(a[o][s]).addClass("fr-selected-cell")}}function K(e){var t=null,a=T(e.target);return"TD"==e.target.tagName||"TH"==e.target.tagName?t=e.target:0<a.closest("th",a.closest("thead")[0]).length?t=a.closest("th",a.closest("thead")[0]).get(0):0<a.closest("td",a.closest("tr")[0]).length&&(t=a.closest("td",a.closest("tr")[0]).get(0)),-1===A.$el.html.toString().search(t)?null:t}function B(){N(),A.popups.hide("table.edit")}function e(e){var t=K(e);if("false"==T(t).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable"))return!0;if(0<te().length&&!t&&B(),!A.edit.isDisabled()||A.popups.isVisible("table.edit"))if(1!=e.which||1==e.which&&A.helpers.isMac()&&e.ctrlKey)(3==e.which||1==e.which&&A.helpers.isMac()&&e.ctrlKey)&&t&&B();else if(r=!0,t){0<te().length&&!e.shiftKey&&B(),e.stopPropagation(),A.events.trigger("image.hideResizer"),A.events.trigger("video.hideResizer"),n=!0;var a=t.tagName.toLowerCase();e.shiftKey&&0<A.$el.find("".concat(a,".fr-selected-cell")).length?T(A.$el.find("".concat(a,".fr-selected-cell")).closest("table")).is(T(t).closest("table"))?k(l,t):S():((A.keys.ctrlKey(e)||e.shiftKey)&&"TD"===e.currentTarget.tagName&&(1<te().length||0===T(t).find(A.selection.element()).length&&!T(t).is(A.selection.element()))&&S(),l=t,0<A.opts.tableEditButtons.length&&k(l,l))}}function a(e){if(!A.edit.isDisabled()&&A.popups.areVisible())return!0;var t=K(e);if(1===te().length&&null===t&&(A.toolbar.enable(),N()),(1===te().length&&t&&"TD"!==t.tagName&&"TH"!==t.tagName||!n&&!A.$tb.is(e.target)&&!A.$tb.is(T(e.target).closest(".fr-toolbar")))&&(A.toolbar.enable(),N()),("BODY"===e.target.tagName||"HTML"===e.target.tagName)&&!t&&0<te().length&&A.toolbar.enable(),!(1!=e.which||1==e.which&&A.helpers.isMac()&&e.ctrlKey)){if(r=!1,n)n=!1,K(e)||1!=te().length?0<te().length?A.selection.isCollapsed()?(g(),A.toolbar.enable()):(N(),A.edit.on()):te().length||(A.$el.removeClass("fr-no-selection"),A.edit.on()):N();if(y){y=!1,O.removeClass("fr-moving"),A.$el.removeClass("fr-no-selection"),A.edit.on();var a=parseFloat(O.css("left"))+A.opts.tableResizerOffset+A.$wp.offset().left;A.opts.iframe&&(a-=A.$iframe.offset().left),O.data("release-position",a),O.removeData("max-left"),O.removeData("max-right"),function R(){var e=O.data("origin"),t=O.data("release-position");if(e!==t){var a=O.data("first"),l=O.data("second"),n=O.data("table"),r=n.outerWidth();if(A.undo.canDo()||A.undo.saveStep(),null!=a&&null!=l){var o,s,i,f=x(n),c=[],d=[],p=[],h=[];for(o=0;o<f.length;o++)s=T(f[o][a]),i=T(f[o][l]),c[o]=s.outerWidth(),p[o]=i.outerWidth(),d[o]=c[o]/r*100,h[o]=p[o]/r*100;for(o=0;o<f.length;o++)if(s=T(f[o][a]),i=T(f[o][l]),f[o][a]!=f[o][l]){var u=(d[o]*(c[o]+t-e)/c[o]).toFixed(4);s.css("width",u+"%"),i.css("width",(d[o]+h[o]-u).toFixed(4)+"%")}}else{var g,b=n.parent(),m=parseFloat(b.css("padding-left")),v=parseFloat(b.css("padding-right")),w=m+v,C=r/(b.width()-w)*100,E=(parseInt(n.css("margin-left"),10)||0)/b.width()*100,y=(parseInt(n.css("margin-right"),10)||0)/b.width()*100;"rtl"==A.opts.direction&&0===l||"rtl"!=A.opts.direction&&0!==l?(g=(r+t-e)/r*C,n.css("margin-right","calc(100% - ".concat(Math.round(g).toFixed(4),"% - ").concat(Math.round(E).toFixed(4),"%)"))):("rtl"==A.opts.direction&&0!==l||"rtl"!=A.opts.direction&&0===l)&&(g=(r-t+e)/r*C,n.css("margin-left","calc(100% - ".concat(Math.round(g).toFixed(4),"% - ").concat(Math.round(y).toFixed(4),"%)"))),n.css("width","".concat(Math.round(g).toFixed(4),"%"))}A.selection.restore(),A.undo.saveStep(),A.events.trigger("table.resized",[n.get(0)])}O.removeData("origin"),O.removeData("release-position"),O.removeData("first"),O.removeData("second"),O.removeData("table")}(),W()}}}function F(e){if((!(T(e.currentTarget).is(T(e.originalEvent.relatedTarget))||e.currentTarget.contains(e.originalEvent.relatedTarget)||e.originalEvent.relatedTarget&&e.originalEvent.relatedTarget.contains(e.currentTarget))||e.currentTarget.querySelector("input, textarea"))&&(A.events.$on(T("input, textarea"),"click",le),!0===n&&0<A.opts.tableEditButtons.length)){if(T(e.currentTarget).closest("table").is(ae())){if("TBODY"===e.currentTarget.parentElement.parentElement.tagName&&"TD"==e.currentTarget.tagName&&0===A.$el.find("th.fr-selected-cell").length&&0===A.$el.find("tfoot td.fr-selected-cell").length)return void k(l,e.currentTarget);if("TFOOT"===e.currentTarget.parentElement.parentElement.tagName&&"TD"==e.currentTarget.tagName&&0===A.$el.find("tbody td.fr-selected-cell").length)return void k(l,e.currentTarget);if("TH"==e.currentTarget.tagName&&0===A.$el.find("td.fr-selected-cell").length)return void k(l,e.currentTarget)}"TD"!==e.currentTarget.tagName&&"TH"!==e.currentTarget.tagName&&S()}}function Y(e,t,a,l){for(var n,r=t;r!=A.el&&"TD"!=r.tagName&&"TH"!=r.tagName&&("up"==l?n=r.previousElementSibling:"down"==l&&(n=r.nextElementSibling),!n);)r=r.parentNode;"TD"==r.tagName||"TH"==r.tagName?function o(e,t){for(var a=e;a&&"TABLE"!=a.tagName&&a.parentNode!=A.el;)a=a.parentNode;if(a&&"TABLE"==a.tagName){var l=x(T(a));"up"==t?z($(e,l),a,l):"down"==t&&L($(e,l),a,l)}}(r,l):n&&("up"==l&&A.selection.setAtEnd(n),"down"==l&&A.selection.setAtStart(n))}function z(e,t,a){0<T(".tribute-container").length&&"none"!=T(".tribute-container").css("display")||(0<e.row?A.selection.setAtEnd(a[e.row-1][e.col]):Y(0,t,0,"up"))}function L(e,t,a){if(!(0<T(".tribute-container").length&&"none"!=T(".tribute-container").css("display"))){var l=parseInt(a[e.row][e.col].getAttribute("rowspan"),10)||1;e.row<a.length-l?A.selection.setAtStart(a[e.row+l][e.col]):Y(0,t,0,"down")}}function W(){O&&(O.find("div").css("opacity",0),O.css("top",0),O.css("left",0),O.css("height",0),O.find("div").css("height",0),O.hide())}function H(){f&&f.removeClass("fr-visible").css("left","-9999px")}function P(e,t){var a,l=T(t);l&&(a=l.closest("table"));var n=a.parent();if(t&&"TD"!=t.tagName&&"TH"!=t.tagName&&(0<l.closest("td").length?t=l.closest("td"):0<l.closest("th").length&&(t=l.closest("th"))),!t||"TD"!=t.tagName&&"TH"!=t.tagName)O&&l.get(0)!=O.get(0)&&l.parent().get(0)!=O.get(0)&&A.core.sameInstance(O)&&W();else{if(l=T(t),0===A.$el.find(l).length)return!1;var r=l.offset().left-1,o=r+l.outerWidth();if(Math.abs(e.pageX-r)<=A.opts.tableResizerOffset||Math.abs(o-e.pageX)<=A.opts.tableResizerOffset){var s,i,f,c,d,p=x(a),h=$(t,p),u=D(h.row,h.col,p),g=a.offset().top,b=a.outerHeight()-1;"rtl"!=A.opts.direction?e.pageX-r<=A.opts.tableResizerOffset?(f=r,0<h.col?(c=r-U(h.col-1,p)+A.opts.tableResizingLimit,d=r+U(h.col,p)-A.opts.tableResizingLimit,s=h.col-1,i=h.col):(s=null,i=0,c=a.offset().left-1-parseInt(a.css("margin-left"),10),d=a.offset().left-1+a.width()-p[0].length*A.opts.tableResizingLimit)):o-e.pageX<=A.opts.tableResizerOffset&&(f=o,u.col<p[u.row].length&&p[u.row][u.col+1]?(c=o-U(u.col,p)+A.opts.tableResizingLimit,d=o+U(u.col+1,p)-A.opts.tableResizingLimit,s=u.col,i=u.col+1):(s=u.col,i=null,c=a.offset().left-1+p[0].length*A.opts.tableResizingLimit,d=n.offset().left-1+n.width()+parseFloat(n.css("padding-left")))):o-e.pageX<=A.opts.tableResizerOffset?(f=o,0<h.col?(c=o-U(h.col,p)+A.opts.tableResizingLimit,d=o+U(h.col-1,p)-A.opts.tableResizingLimit,s=h.col,i=h.col-1):(s=null,i=0,c=a.offset().left+p[0].length*A.opts.tableResizingLimit,d=n.offset().left-1+n.width()+parseFloat(n.css("padding-left")))):e.pageX-r<=A.opts.tableResizerOffset&&(f=r,u.col<p[u.row].length&&p[u.row][u.col+1]?(c=r-U(u.col+1,p)+A.opts.tableResizingLimit,d=r+U(u.col,p)-A.opts.tableResizingLimit,s=u.col+1,i=u.col):(s=u.col,i=null,c=n.offset().left+parseFloat(n.css("padding-left")),d=a.offset().left-1+a.width()-p[0].length*A.opts.tableResizingLimit)),O||function E(){A.shared.$table_resizer||(A.shared.$table_resizer=T(document.createElement("div")).attr("class","fr-table-resizer").html("<div></div>")),O=A.shared.$table_resizer,A.events.$on(O,"mousedown",function(e){return!A.core.sameInstance(O)||(0<te().length&&B(),1==e.which?(A.selection.save(),y=!0,O.addClass("fr-moving"),S(),A.edit.off(),O.find("div").css("opacity",1),!1):void 0)}),A.events.$on(O,"mousemove",function(e){if(!A.core.sameInstance(O))return!0;y&&(A.opts.iframe&&(e.pageX-=A.$iframe.offset().left),J(e))}),A.events.on("shared.destroy",function(){O.html("").removeData().remove(),O=null},!0),A.events.on("destroy",function(){A.$el.find(".fr-selected-cell").removeClass("fr-selected-cell"),T("body").first().append(O.hide())},!0)}(),O.data("table",a),O.data("first",s),O.data("second",i),O.data("instance",A),A.$wp.append(O);var m=f-A.win.pageXOffset-A.opts.tableResizerOffset-A.$wp.offset().left,v=g-A.$wp.offset().top+A.$wp.scrollTop();if(A.opts.iframe){var w=A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-top")),C=A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-left"));m+=A.$iframe.offset().left+C,v+=A.$iframe.offset().top+w,c+=A.$iframe.offset().left,d+=A.$iframe.offset().left}O.data("max-left",c),O.data("max-right",d),O.data("origin",f-A.win.pageXOffset),O.css("top",v),O.css("left",m),O.css("height",b),O.find("div").css("height",b),O.css("padding-left",A.opts.tableResizerOffset),O.css("padding-right",A.opts.tableResizerOffset),O.show()}else A.core.sameInstance(O)&&W()}}function V(e,t){if(A.$box.find(".fr-line-breaker").isVisible())return!1;f||Q(),A.$box.append(f),f.data("instance",A);var a,l=T(t).find("tr").first(),n=e.pageX,r=0,o=0;if(A.opts.iframe){var s=A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-top")),i=A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-left"));r+=A.$iframe.offset().left-A.helpers.scrollLeft()+i,o+=A.$iframe.offset().top-A.helpers.scrollTop()+s}l.find("th, td").each(function(){var e=T(this);return e.offset().left<=n&&n<e.offset().left+e.outerWidth()/2?(a=parseInt(f.find("a").css("width"),10),f.css("top",o+e.offset().top-A.$box.offset().top-a-5),f.css("left",r+e.offset().left-A.$box.offset().left-a/2),f.data("selected-cell",e),f.data("position","before"),f.addClass("fr-visible"),!1):e.offset().left+e.outerWidth()/2<=n&&n<e.offset().left+e.outerWidth()?(a=parseInt(f.find("a").css("width"),10),f.css("top",o+e.offset().top-A.$box.offset().top-a-5),f.css("left",r+e.offset().left-A.$box.offset().left+e.outerWidth()-a/2),f.data("selected-cell",e),f.data("position","after"),f.addClass("fr-visible"),!1):void 0})}function j(e,t){if(A.$box.find(".fr-line-breaker").isVisible())return!1;f||Q(),A.$box.append(f),f.data("instance",A);var a,l=T(t),n=e.pageY,r=0,o=0;if(A.opts.iframe){var s=A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-top")),i=A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-left"));r+=A.$iframe.offset().left-A.helpers.scrollLeft()+i,o+=A.$iframe.offset().top-A.helpers.scrollTop()+s}l.find("tr").each(function(){var e=T(this);a=parseInt(f.find("a").css("width"),10);var t=r+e.offset().left-A.$box.offset().left;return t=0!==A.$box.offset().left?t-a-5:t+a-5,e.offset().top<=n&&n<e.offset().top+e.outerHeight()/2?(f.css("top",o+e.offset().top-A.$box.offset().top-a/2),f.css("left",t),f.data("selected-cell",e.find("td").first()),f.data("position","above"),f.addClass("fr-visible"),!1):e.offset().top+e.outerHeight()/2<=n&&n<e.offset().top+e.outerHeight()?(f.css("top",o+e.offset().top-A.$box.offset().top+e.outerHeight()-a/2),f.css("left",t),f.data("selected-cell",e.find("td").first()),f.data("position","below"),f.addClass("fr-visible"),!1):void 0})}function G(e){o=null;var t=A.doc.elementFromPoint(e.pageX-A.win.pageXOffset,e.pageY-A.win.pageYOffset);A.opts.tableResizer&&(!A.popups.areVisible()||A.popups.areVisible()&&A.popups.isVisible("table.edit"))&&P(e,t),!A.opts.tableInsertHelper||A.popups.areVisible()||A.$tb.hasClass("fr-inline")&&A.$tb.isVisible()||function r(e,t){if(0===te().length){var a,l,n;if(t&&("HTML"==t.tagName||"BODY"==t.tagName||A.node.isElement(t)))for(a=1;a<=A.opts.tableInsertHelperOffset;a++){if(l=A.doc.elementFromPoint(e.pageX-A.win.pageXOffset,e.pageY-A.win.pageYOffset+a),T(l).hasClass("fr-tooltip"))return!0;if(l&&("TH"==l.tagName||"TD"==l.tagName||"TABLE"==l.tagName)&&(T(l).parents(".fr-wrapper").length||A.opts.iframe)&&"false"!=T(l).closest("table").attr("contenteditable"))return V(e,T(l).closest("table")),!0;if(n=A.doc.elementFromPoint(e.pageX-A.win.pageXOffset+a,e.pageY-A.win.pageYOffset),T(n).hasClass("fr-tooltip"))return!0;if(n&&("TH"==n.tagName||"TD"==n.tagName||"TABLE"==n.tagName)&&(T(n).parents(".fr-wrapper").length||A.opts.iframe)&&"false"!=T(n).closest("table").attr("contenteditable"))return j(e,T(n).closest("table")),!0}A.core.sameInstance(f)&&H()}}(e,t)}function X(){if(y){var e=O.data("table").offset().top-A.win.pageYOffset;if(A.opts.iframe){var t=A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-top"));e+=A.$iframe.offset().top-A.helpers.scrollTop()+t}O.css("top",e)}}function U(e,t){var a,l=T(t[0][e]).outerWidth();for(a=1;a<t.length;a++)l=Math.min(l,T(t[a][e]).outerWidth());return l}function q(e,t,a){var l,n=0;for(l=e;l<=t;l++)n+=U(l,a);return n}function J(e){if(1<te().length&&r&&S(),!1===r&&!1===n&&!1===y)o&&clearTimeout(o),A.edit.isDisabled()&&!A.popups.isVisible("table.edit")||(o=setTimeout(G,30,e));else if(y){var t=e.pageX-A.win.pageXOffset;A.opts.iframe&&(t+=A.$iframe.offset().left);var a=O.data("max-left"),l=O.data("max-right");a<=t&&t<=l?O.css("left",t-A.opts.tableResizerOffset-A.$wp.offset().left):t<a&&parseFloat(O.css("left"),10)>a-A.opts.tableResizerOffset?O.css("left",a-A.opts.tableResizerOffset-A.$wp.offset().left):l<t&&parseFloat(O.css("left"),10)<l-A.opts.tableResizerOffset&&O.css("left",l-A.opts.tableResizerOffset-A.$wp.offset().left)}else r&&H()}function Z(e){A.node.isEmpty(e.get(0))?A.opts.keepTextFormatOnTable&&A.browser.mozilla?e.append(ye.MARKERS):e.prepend(ye.MARKERS):e.prepend(ye.START_MARKER).append(ye.END_MARKER)}function Q(){A.shared.$ti_helper||(A.shared.$ti_helper=T(document.createElement("div")).attr("class","fr-insert-helper").html('<a class="fr-floating-btn" role="button" tabIndex="-1" title="'.concat(A.language.translate("Insert"),'"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M22,16.75 L16.75,16.75 L16.75,22 L15.25,22.000 L15.25,16.75 L10,16.75 L10,15.25 L15.25,15.25 L15.25,10 L16.75,10 L16.75,15.25 L22,15.25 L22,16.75 Z"/></svg></a>')),A.events.bindClick(A.shared.$ti_helper,"a",function(){var e=f.data("selected-cell"),t=f.data("position"),a=f.data("instance")||A;"before"==t?(A.undo.saveStep(),e.addClass("fr-selected-cell"),a.table.insertColumn(t),e.removeClass("fr-selected-cell"),A.undo.saveStep()):"after"==t?(A.undo.saveStep(),e.addClass("fr-selected-cell"),a.table.insertColumn(t),e.removeClass("fr-selected-cell"),A.undo.saveStep()):"above"==t?(A.undo.saveStep(),e.addClass("fr-selected-cell"),a.table.insertRow(t),e.removeClass("fr-selected-cell"),A.undo.saveStep()):"below"==t&&(A.undo.saveStep(),e.addClass("fr-selected-cell"),a.table.insertRow(t),e.removeClass("fr-selected-cell"),A.undo.saveStep()),H()}),A.events.on("shared.destroy",function(){A.shared.$ti_helper.html("").removeData().remove(),A.shared.$ti_helper=null},!0),A.events.$on(A.shared.$ti_helper,"mousemove",function(e){e.stopPropagation()},!0),A.events.$on(T(A.o_win),"scroll",function(){H()},!0),A.events.$on(A.$wp,"scroll",function(){H()},!0)),f=A.shared.$ti_helper,A.events.on("destroy",function(){f=null}),A.tooltip.bind(A.$box,".fr-insert-helper > a.fr-floating-btn")}function ee(){l=null,clearTimeout(o)}function te(){return A.el.querySelectorAll(".fr-selected-cell")}function ae(){var e=te();if(e.length){for(var t=e[0];t&&"TABLE"!=t.tagName&&t.parentNode!=A.el;)t=t.parentNode;return t&&"TABLE"==t.tagName?T(t):T([])}return T([])}function le(){n=!1}return{_init:function ne(){if(!A.$wp)return!1;if(A.helpers.isMobile()&&(A.events.$on(A.$el,"mousedown",e),A.events.$on(A.$win,"mouseup",a)),!A.helpers.isMobile()){y=n=r=!1,A.events.$on(A.$el,"mousedown",e),A.popups.onShow("image.edit",function(){N(),n=r=!1}),A.popups.onShow("link.edit",function(){N(),n=r=!1}),A.events.on("commands.mousedown",function(e){0<e.parents(".fr-toolbar").length&&N()}),A.events.$on(A.$el,"mouseover","th, td",F),A.events.$on(A.$win,"mouseup",a),A.opts.iframe&&A.events.$on(T(A.o_win),"mouseup",a),A.events.$on(A.$win,"mousemove",J),A.events.$on(T(A.o_win),"scroll",X),A.events.on("contentChanged",function(){0<te().length&&(g(),A.$el.find("img").on("load.selected-cells",function(){T(this).off("load.selected-cells"),0<te().length&&g()}))}),A.events.$on(T(A.o_win),"resize",function(){N()}),A.events.on("toolbar.esc",function(){if(0<te().length)return A.events.disableBlur(),A.events.focus(),!1},!0),A.events.$on(T(A.o_win),"keydown",function(){r&&n&&(n=r=!1,A.$el.removeClass("fr-no-selection"),A.edit.on(),A.selection.setAtEnd(A.$el.find(".fr-selected-cell").last().get(0)),A.selection.restore(),N())}),A.events.$on(A.$el,"keydown",function(e){e.shiftKey?!1===function o(e){var t=te();if(null!=t&&0<t.length){var a,l=x(),n=e.which,r=$(1==t.length?a=t[0]:(a=A.el.querySelector(".fr-cell-fixed"),A.el.querySelector(".fr-cell-handler")),l);if(ye.KEYCODE.ARROW_RIGHT==n){if(r.col<l[0].length-1)return k(a,l[r.row][r.col+1]),!1}else if(ye.KEYCODE.ARROW_DOWN==n){if(r.row<l.length-1)return k(a,l[r.row+1][r.col]),!1}else if(ye.KEYCODE.ARROW_LEFT==n){if(0<r.col)return k(a,l[r.row][r.col-1]),!1}else if(ye.KEYCODE.ARROW_UP==n&&0<r.row)return k(a,l[r.row-1][r.col]),!1}}(e)&&setTimeout(function(){g()},0):function s(e){var t=e.which,a=A.selection.blocks();if(a.length&&("P"!==(a=a[0]).tagName&&"DIV"!==a.tagName||(a=a.parentNode),"TD"==a.tagName||"TH"==a.tagName)){for(var l=a;l&&"TABLE"!=l.tagName&&l.parentNode!=A.el;)l=l.parentNode;if(l&&"TABLE"==l.tagName&&(ye.KEYCODE.ARROW_LEFT==t||ye.KEYCODE.ARROW_UP==t||ye.KEYCODE.ARROW_RIGHT==t||ye.KEYCODE.ARROW_DOWN==t)&&(0<te().length&&B(),A.browser.webkit&&(ye.KEYCODE.ARROW_UP==t||ye.KEYCODE.ARROW_DOWN==t))){var n=A.selection.ranges(0).startContainer;if(n.nodeType==Node.TEXT_NODE&&(ye.KEYCODE.ARROW_UP==t&&(n.previousSibling&&"BR"!==n.previousSibling.tagName||n.previousSibling&&"BR"===n.previousSibling.tagName&&n.previousSibling.previousSibling)||ye.KEYCODE.ARROW_DOWN==t&&(n.nextSibling&&"BR"!==n.nextSibling.tagName||n.nextSibling&&"BR"===n.nextSibling.tagName&&n.nextSibling.nextSibling)))return;e.preventDefault(),e.stopPropagation();var r=x(T(l)),o=$(a,r);return ye.KEYCODE.ARROW_UP==t?z(o,l,r):ye.KEYCODE.ARROW_DOWN==t&&L(o,l,r),A.selection.restore(),!1}}}(e)}),A.events.on("keydown",function(e){if(!1===function l(e){if(e.which==ye.KEYCODE.TAB){var t;if(0<te().length)t=A.$el.find(".fr-selected-cell").last();else{var a=A.selection.element();"TD"==a.tagName||"TH"==a.tagName?t=T(a):a!=A.el&&(0<T(a).parentsUntil(A.$el,"td").length?t=T(a).parents("td").first():0<T(a).parentsUntil(A.$el,"th").length&&(t=T(a).parents("th").first()))}if(t)return e.preventDefault(),!!(0===A.selection.get().focusOffset&&0<T(A.selection.element()).parentsUntil(A.$el,"ol, ul").length&&(0<T(A.selection.element()).closest("li").prev().length||T(A.selection.element()).is("li")&&0<T(A.selection.element()).prev().length))||(B(),e.shiftKey?0<t.prev().length?Z(t.prev()):0<t.closest("tr").length&&0<t.closest("tr").prev().length?Z(t.closest("tr").prev().find("td").last()):0<t.closest("tbody").length&&0<t.closest("table").find("thead tr").length&&Z(t.closest("table").find("thead tr th").last()):0<t.next().length?Z(t.next()):0<t.closest("tr").length&&0<t.closest("tr").next().length?Z(t.closest("tr").next().find("td").first()):0<t.closest("thead").length&&0<t.closest("table").find("tbody tr").length?Z(t.closest("table").find("tbody tr td").first()):(t.addClass("fr-selected-cell"),m("below"),N(),Z(t.closest("tr").next().find("td").first())),A.selection.restore(),!1)}}(e))return!1;var t=te();if(0<t.length){if(0<t.length&&A.keys.ctrlKey(e)&&e.which==ye.KEYCODE.A)return N(),A.popups.isVisible("table.edit")&&A.popups.hide("table.edit"),t=[],!0;if(e.which==ye.KEYCODE.ESC&&A.popups.isVisible("table.edit"))return N(),A.popups.hide("table.edit"),e.preventDefault(),e.stopPropagation(),e.stopImmediatePropagation(),!(t=[]);if(1<t.length&&(e.which==ye.KEYCODE.BACKSPACE||e.which==ye.KEYCODE.DELETE)){A.undo.saveStep();for(var a=0;a<t.length;a++)T(t[a]).html("<br>"),a==t.length-1&&T(t[a]).prepend(ye.MARKERS);return A.selection.restore(),A.undo.saveStep(),!(t=[])}if(1<t.length&&e.which!=ye.KEYCODE.F10&&!A.keys.isBrowserAction(e))return e.preventDefault(),!(t=[])}else if(!(t=[])===function n(e){if(e.altKey&&e.which==ye.KEYCODE.SPACE){var t,a=A.selection.element();if("TD"==a.tagName||"TH"==a.tagName?t=a:0<T(a).closest("td").length?t=T(a).closest("td").get(0):0<T(a).closest("th").length&&(t=T(a).closest("th").get(0)),t)return e.preventDefault(),k(t,t),g(),!1}}(e))return!1},!0);var t=[];A.events.on("html.beforeGet",function(){t=te();for(var e=0;e<t.length;e++)t[e].className=(t[e].className||"").replace(/fr-selected-cell/g,"")}),A.events.on("html.afterGet",function(){for(var e=0;e<t.length;e++)t[e].className=(t[e].className?t[e].className.trim()+" ":"")+"fr-selected-cell";t=[]}),c(!0),p(!0)}A.events.on("destroy",ee)},insert:function re(e,t){var a,l,n=function f(){var e={startTag:"",closeTag:""};if(A.opts.keepTextFormatOnTable){var t=T(A.selection.element().firstChild).parentsUntil(A.$el);e=h(t)}return{startTag:e.startTag,closeTag:e.closeTag}}(),r="<table "+(A.opts.tableDefaultWidth?'style="width: '+A.opts.tableDefaultWidth+';" ':"")+'class="fr-inserted-table"><tbody>',o=100/t;for(a=0;a<e;a++){for(r+="<tr>",l=0;l<t;l++)r+="<td"+(A.opts.tableDefaultWidth?' style="width: '+o.toFixed(4)+'%;"':"")+">"+n.startTag,0===a&&0===l&&(r+=ye.MARKERS),r+="<br>"+n.closeTag+"</td>";r+="</tr>"}if(r+="</tbody></table>",A.opts.trackChangesEnabled){A.edit.on(),A.events.focus(!0),A.selection.restore(),A.undo.saveStep(),A.markers.insert(),A.html.wrap();var s=A.$el.find(".fr-marker");A.node.isLastSibling(s)&&s.parent().hasClass("fr-deletable")&&s.insertAfter(s.parent()),s.replaceWith(r),A.selection.clear()}else A.html.insert(r);A.selection.restore();var i=A.$el.find(".fr-inserted-table");i.removeClass("fr-inserted-table"),A.events.trigger("table.inserted",[i.get(0)])},remove:u,insertRow:m,deleteRow:function oe(){var e=ae();if(0<e.length){var t,a,l,n=x(),r=M(n);if(null==r)return;if(0===r.min_i&&r.max_i==n.length-1)u();else{for(t=r.max_i;t>=r.min_i;t--){for(l=T(e.find("tr").not(e.find("> table tr")).get(t)),a=0;a<n[t].length;a++)if(0===a||n[t][a]!=n[t][a-1]){var o=T(n[t][a]);if(1<parseInt(o.attr("rowspan"),10)){var s=parseInt(o.attr("rowspan"),10)-1;1==s?o.removeAttr("rowspan"):o.attr("rowspan",s)}if(t<n.length-1&&n[t][a]==n[t+1][a]&&(0===t||n[t][a]!=n[t-1][a])){for(var i=n[t][a],f=a;0<f&&n[t][f]==n[t][f-1];)f--;0===f?T(e.find("tr").not(e.find("> table tr")).get(t+1)).prepend(i):T(n[t+1][f-1])[0].parentNode&&T(n[t+1][f-1])[0].insertAdjacentElement("afterend",i)}}var c=l.parent();l.remove(),0===c.find("tr").length&&c.remove(),n=x(e)}E(0,n.length-1,0,n[0].length-1,e),0<r.min_i?A.selection.setAtEnd(n[r.min_i-1][0]):A.selection.setAtEnd(n[0][0]),A.selection.restore(),A.popups.hide("table.edit")}}},insertColumn:function se(c){var e=ae();if(0<e.length){var d,p=x(),t=M(p);d="before"==c?t.min_j:t.max_j;var a,h=100/p[0].length,u=100/(p[0].length+1);e.find("th, td").each(function(){(a=T(this)).data("old-width",a.outerWidth()/e.outerWidth()*100)}),e.find("tr").not(e.find("> table tr")).each(function(e){for(var t,a=T(this),l=0,n=0;l-1<d;){if(!(t=a.find("> th, > td").get(n))){t=null;break}t==p[e][l]?(l+=parseInt(T(t).attr("colspan"),10)||1,n++):(l+=parseInt(T(p[e][l]).attr("colspan"),10)||1,"after"==c&&(t=0===n?-1:a.find("> th, > td").get(n-1)))}var r=T(t);if("after"==c&&d<l-1||"before"==c&&0<d&&p[e][d]==p[e][d-1]){if(0===e||0<e&&p[e][d]!=p[e-1][d]){var o=parseInt(r.attr("colspan"),10)+1;r.attr("colspan",o),r.css("width",(r.data("old-width")*u/h+u).toFixed(4)+"%"),r.removeData("old-width")}}else{var s,i=(r.get(0)||"").tagName;if(0<a.find("th").length&&"TH"===i)s='<th style="width: '.concat(u.toFixed(4),'%;"><br></th>');else{var f=b(p[e][d]);s='<td style="'.concat(r.attr("style"),"; width: ").concat(u.toFixed(4),'%;">')+f.startTag+"<br>"+f.closeTag+"</td>"}T(s).append("<br>"),T(s).css("width","".concat(u.toFixed(4),"%")),-1==t?a.prepend(s):null==t?a.append(s):"before"==c?r.before(s):"after"==c&&r.after(s)}}),e.find("th, td").each(function(){(a=T(this)).data("old-width")&&(a.css("width",(a.data("old-width")*u/h).toFixed(4)+"%"),a.removeData("old-width"))}),A.popups.isVisible("table.edit")&&g()}},deleteColumn:function ie(){var e=ae();if(0<e.length){var t,a,l,n=x(),r=M(n);if(null==r)return;if(0===r.min_j&&r.max_j==n[0].length-1)u();else{var o=0;for(t=0;t<n.length;t++)for(a=0;a<n[0].length;a++)(l=T(n[t][a])).hasClass("fr-selected-cell")||(l.data("old-width",l.outerWidth()/e.outerWidth()*100),(a<r.min_j||a>r.max_j)&&(o+=l.outerWidth()/e.outerWidth()*100));for(o/=n.length,a=r.max_j;a>=r.min_j;a--)for(t=0;t<n.length;t++)if(0===t||n[t][a]!=n[t-1][a])if(l=T(n[t][a]),1<(parseInt(l.attr("colspan"),10)||1)){var s=parseInt(l.attr("colspan"),10)-1;1==s?l.removeAttr("colspan"):l.attr("colspan",s),l.css("width",(100*(l.data("old-width")-U(a,n))/o).toFixed(4)+"%"),l.removeData("old-width")}else{var i=T(l.parent().get(0));l.remove(),0===i.find("> th, > td").length&&(0===i.prev().length||0===i.next().length||i.prev().find("> th[rowspan], > td[rowspan]").length<i.prev().find("> th, > td").length)&&i.remove()}E(0,n.length-1,0,n[0].length-1,e),0<r.min_j?A.selection.setAtEnd(n[r.min_i][r.min_j-1]):A.selection.setAtEnd(n[r.min_i][0]),A.selection.restore(),A.popups.hide("table.edit"),e.find("th, td").each(function(){(l=T(this)).data("old-width")&&(l.css("width",(100*l.data("old-width")/o).toFixed(4)+"%"),l.removeData("old-width"))})}}},mergeCells:function fe(){if(1<te().length&&(0===A.$el.find("th.fr-selected-cell").length||0===A.$el.find("td.fr-selected-cell").length)){_();var e,t,a=M(x());if(null==a)return;var l=A.$el.find(".fr-selected-cell"),n=T(l[0]),r=n.parent().find(".fr-selected-cell"),o=n.closest("table"),s=n.html(),i=0;for(e=0;e<r.length;e++)i+=T(r[e]).outerWidth();for(n.css("width",Math.min(100,i/o.outerWidth()*100).toFixed(4)+"%"),a.min_j<a.max_j&&n.attr("colspan",a.max_j-a.min_j+1),a.min_i<a.max_i&&n.attr("rowspan",a.max_i-a.min_i+1),e=1;e<l.length;e++)"<br>"!=(t=T(l[e])).html()&&""!==t.html()&&(s+="<br>".concat(t.html())),t.remove();n.html(s),A.selection.setAtEnd(n.get(0)),A.selection.restore(),A.toolbar.enable(),w(a.min_i,a.max_i,o);var f=o.find("tr:empty");for(e=f.length-1;0<=e;e--)T(f[e]).remove();v(a.min_j,a.max_j,o),g()}},splitCellVertically:function ce(){if(1==te().length){var e=A.$el.find(".fr-selected-cell"),t=parseInt(e.attr("colspan"),10)||1,a=e.parent().outerWidth(),l=e.outerWidth(),n=e.clone().html("<br>"),r=x(),o=$(e.get(0),r);if(1<t){var s=Math.ceil(t/2);l=q(o.col,o.col+s-1,r)/a*100;var i=q(o.col+s,o.col+t-1,r)/a*100;1<s?e.attr("colspan",s):e.removeAttr("colspan"),1<t-s?n.attr("colspan",t-s):n.removeAttr("colspan"),e.css("width",l.toFixed(4)+"%"),n.css("width",i.toFixed(4)+"%")}else{var f;for(f=0;f<r.length;f++)if(0===f||r[f][o.col]!=r[f-1][o.col]){var c=T(r[f][o.col]);if(!c.is(e)){var d=(parseInt(c.attr("colspan"),10)||1)+1;c.attr("colspan",d)}}l=l/a*100/2,e.css("width","".concat(l.toFixed(4),"%")),n.css("width","".concat(l.toFixed(4),"%"))}e[0].parentNode&&e[0].insertAdjacentElement("afterend",n[0]),N(),A.popups.hide("table.edit")}},splitCellHorizontally:function de(){if(1==te().length){var e=A.$el.find(".fr-selected-cell"),t=e.parent(),a=e.closest("table"),l=parseInt(e.attr("rowspan"),10),n=x(),r=$(e.get(0),n),o=e.clone().html("<br>");if(1<l){var s=Math.ceil(l/2);1<s?e.attr("rowspan",s):e.removeAttr("rowspan"),1<l-s?o.attr("rowspan",l-s):o.removeAttr("rowspan");for(var i=r.row+s,f=0===r.col?r.col:r.col-1;0<=f&&(n[i][f]==n[i][f-1]||0<i&&n[i][f]==n[i-1][f]);)f--;-1==f?T(a.find("tr").not(a.find("> table tr")).get(i)).prepend(o):T(n[i][f])[0].parentNode&&T(n[i][f])[0].insertAdjacentElement("afterend",o[0])}else{var c,d=T(document.createElement("tr")).append(o);for(c=0;c<n[0].length;c++)if(0===c||n[r.row][c]!=n[r.row][c-1]){var p=T(n[r.row][c]);p.is(e)||p.attr("rowspan",(parseInt(p.attr("rowspan"),10)||1)+1)}t[0].parentNode&&t[0].insertAdjacentElement("afterend",d[0])}N(),A.popups.hide("table.edit")}},addHeader:function pe(){var e=ae();if(0<e.length&&0===e.find("> th").length){var t,a="<thead><tr>",l=0;for(l=e.find("tr").first().find("> th").length,e.find("tr").first().find("> td").each(function(){var e=T(this);l+=parseInt(e.attr("colspan"),10)||1}),t=0;t<l;t++)a+="<th><br></th>";a+="</tr></thead>",e.prepend(a),g()}},addFooter:function he(){var e=ae();if(0<e.length&&0===e.find("tfoot").length){var t,a="<tfoot><tr>",l=0,n="> td";for(0<e.find("thead").length&&(n="> th"),e.find("tr").first().find(n).each(function(){var e=T(this);l+=parseInt(e.attr("colspan"),10)||1}),t=0;t<l;t++)a+="<td><br></td>";a+="</tr></tfoot>",e.append(a),g()}},removeHeader:function ue(){var e=ae(),t=e.find("> thead");if(0<(t=T(t)).length)if(0===e.find("tbody tr").length)u();else if(t.remove(),0<te().length)g();else{A.popups.hide("table.edit");var a=e.find("tbody tr").first().find("td").first().get(0);a&&(A.selection.setAtEnd(a),A.selection.restore())}},removeFooter:function ge(){var e=ae(),t=e.find("tfoot");if(0<t.length)if(0===e.find("tbody tr").length)u();else if(t.remove(),0<te().length)g();else{A.popups.hide("table.edit");var a=e.find("tbody tr").first().find("td").first().get(0);a&&(A.selection.setAtEnd(a),A.selection.restore())}},setBackground:t,showInsertPopup:function be(){var e=A.$tb.find('.fr-command[data-cmd="insertTable"]'),t=A.popups.get("table.insert");if(t||(t=c()),!t.hasClass("fr-active")){A.popups.refresh("table.insert"),A.popups.setContainer("table.insert",A.$tb);var a=A.button.getPosition(e),l=a.left,n=a.top;A.popups.show("table.insert",l,n,e.outerHeight())}},showEditPopup:g,showColorsPopup:s,back:function me(){0<te().length?g():(A.popups.hide("table.insert"),A.toolbar.showInline())},verticalAlign:function ve(e){A.$el.find(".fr-selected-cell").css("vertical-align",e)},horizontalAlign:function we(e){A.$el.find(".fr-selected-cell").css("text-align",e)},applyStyle:function Ce(e,t,a,l){if(0<t.length){if(A.opts.useClasses||("TABLE"===t.get(0).tagName?function r(e,t){var a=e.childNodes;if(0<a.length)for(var l=0;l<a.length;l++)"TD"===a[l].tagName?"fr-dashed-borders"===t||"fr-highlighted"===t||"fr-thick"===t?R(a[l]):"fr-alternate-rows"===t&&a[l].style.removeProperty("background-color"):r(a[l],t)}(t.get(0),e):R(t.get(0))),!a){var n=Object.keys(l);n.splice(n.indexOf(e),1),t.removeClass(n.join(" "))}t.toggleClass(e)}},selectedTable:ae,selectedCells:te,customColor:function Ee(){var e=A.popups.get("table.colors").find(".fr-table-colors-hex-layer input");e.length&&t(e.val())},selectCells:k}},ye.DefineIcon("insertTable",{NAME:"table",SVG_KEY:"insertTable"}),ye.RegisterCommand("insertTable",{title:"Insert Table",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible("table.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("table.insert")):this.table.showInsertPopup()},plugin:"table"}),ye.RegisterCommand("tableInsert",{callback:function(e,t,a){this.table.insert(t,a),this.popups.hide("table.insert")}}),ye.DefineIcon("tableHeader",{NAME:"header",FA5NAME:"heading",SVG_KEY:"tableHeader"}),ye.RegisterCommand("tableHeader",{title:"Table Header",focus:!1,toggle:!0,callback:function(){this.popups.get("table.edit").find('.fr-command[data-cmd="tableHeader"]').hasClass("fr-active")?this.table.removeHeader():this.table.addHeader()},refresh:function(e){var t=this.table.selectedTable();0<t.length&&(0===t.find("> thead").length?e.removeClass("fr-active").attr("aria-pressed",!1):e.addClass("fr-active").attr("aria-pressed",!0))}}),ye.DefineIcon("tableFooter",{NAME:"table",FA5NAME:"table",SVG_KEY:"tableFooter"}),ye.RegisterCommand("tableFooter",{title:"Table Footer",focus:!1,toggle:!0,callback:function(){this.popups.get("table.edit").find('.fr-command[data-cmd="tableFooter"]').hasClass("fr-active")?this.table.removeFooter():this.table.addFooter()},refresh:function(e){var t=this.table.selectedTable();0<t.length&&(0===t.find("tfoot").length?e.removeClass("fr-active").attr("aria-pressed",!1):e.addClass("fr-active").attr("aria-pressed",!0))}}),ye.DefineIcon("tableRows",{NAME:"bars",SVG_KEY:"row"}),ye.RegisterCommand("tableRows",{type:"dropdown",focus:!1,title:"Row",options:{above:"Insert row above",below:"Insert row below","delete":"Delete row"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=ye.COMMANDS.tableRows.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableRows" data-param1="'+a+'" title="'+this.language.translate(t[a])+'">'+this.language.translate(t[a])+"</a></li>");return e+="</ul>"},callback:function(e,t){"above"==t||"below"==t?this.table.insertRow(t):this.table.deleteRow()}}),ye.DefineIcon("tableColumns",{NAME:"bars fa-rotate-90",SVG_KEY:"columns"}),ye.RegisterCommand("tableColumns",{type:"dropdown",focus:!1,title:"Column",options:{before:"Insert column before",after:"Insert column after","delete":"Delete column"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=ye.COMMANDS.tableColumns.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableColumns" data-param1="'.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.language.translate(t[a]),"</a></li>"));return e+="</ul>"},callback:function(e,t){"before"==t||"after"==t?this.table.insertColumn(t):this.table.deleteColumn()}}),ye.DefineIcon("tableCells",{NAME:"square-o",FA5NAME:"square",SVG_KEY:"cellOptions"}),ye.RegisterCommand("tableCells",{type:"dropdown",focus:!1,title:"Cell",options:{merge:"Merge cells","vertical-split":"Vertical split","horizontal-split":"Horizontal split"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=ye.COMMANDS.tableCells.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCells" data-param1="'.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.language.translate(t[a]),"</a></li>"));return e+="</ul>"},callback:function(e,t){"merge"==t?this.table.mergeCells():"vertical-split"==t?this.table.splitCellVertically():this.table.splitCellHorizontally()},refreshOnShow:function(e,t){1<this.$el.find(".fr-selected-cell").length?(t.find('a[data-param1="vertical-split"]').addClass("fr-disabled").attr("aria-disabled",!0),t.find('a[data-param1="horizontal-split"]').addClass("fr-disabled").attr("aria-disabled",!0),t.find('a[data-param1="merge"]').removeClass("fr-disabled").attr("aria-disabled",!1)):(t.find('a[data-param1="merge"]').addClass("fr-disabled").attr("aria-disabled",!0),t.find('a[data-param1="vertical-split"]').removeClass("fr-disabled").attr("aria-disabled",!1),t.find('a[data-param1="horizontal-split"]').removeClass("fr-disabled").attr("aria-disabled",!1))}}),ye.DefineIcon("tableRemove",{NAME:"trash",SVG_KEY:"removeTable"}),ye.RegisterCommand("tableRemove",{title:"Remove Table",focus:!1,callback:function(){this.table.remove()}}),ye.DefineIcon("tableStyle",{NAME:"paint-brush",SVG_KEY:"tableStyle"}),ye.RegisterCommand("tableStyle",{title:"Table Style",type:"dropdown",focus:!1,html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.tableStyles;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableStyle" data-param1="'.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.language.translate(t[a]),"</a></li>"));return e+="</ul>"},callback:function(e,t){this.table.applyStyle(t,this.$el.find(".fr-selected-cell").closest("table"),this.opts.tableMultipleStyles,this.opts.tableStyles)},refreshOnShow:function(e,t){var a=this.$,l=this.$el.find(".fr-selected-cell").closest("table");l&&t.find(".fr-command").each(function(){var e=a(this).data("param1"),t=l.hasClass(e);a(this).toggleClass("fr-active",t).attr("aria-selected",t)})}}),ye.DefineIcon("tableCellBackground",{NAME:"tint",SVG_KEY:"cellBackground"}),ye.RegisterCommand("tableCellBackground",{title:"Cell Background",focus:!1,popup:!0,callback:function(){this.table.showColorsPopup()}}),ye.RegisterCommand("tableCellBackgroundColor",{undo:!0,focus:!1,callback:function(e,t){this.table.setBackground(t)}}),ye.DefineIcon("tableBack",{NAME:"arrow-left",SVG_KEY:"back"}),ye.RegisterCommand("tableBack",{title:"Back",undo:!1,focus:!1,back:!0,callback:function(){this.table.back()},refresh:function(e){0!==this.table.selectedCells().length||this.opts.toolbarInline?(e.removeClass("fr-hidden"),e.next(".fr-separator").removeClass("fr-hidden")):(e.addClass("fr-hidden"),e.next(".fr-separator").addClass("fr-hidden"))}}),ye.DefineIcon("tableCellVerticalAlign",{NAME:"arrows-v",FA5NAME:"arrows-alt-v",SVG_KEY:"verticalAlignMiddle"}),ye.RegisterCommand("tableCellVerticalAlign",{type:"dropdown",focus:!1,title:"Vertical Align",options:{Top:"Align Top",Middle:"Align Middle",Bottom:"Align Bottom"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=ye.COMMANDS.tableCellVerticalAlign.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCellVerticalAlign" data-param1="'.concat(a.toLowerCase(),'" title="').concat(this.language.translate(t[a]),'">').concat(this.language.translate(a),"</a></li>"));return e+="</ul>"},callback:function(e,t){this.table.verticalAlign(t)},refreshOnShow:function(e,t){t.find('.fr-command[data-param1="'+this.$el.find(".fr-selected-cell").css("vertical-align")+'"]').addClass("fr-active").attr("aria-selected",!0)}}),ye.DefineIcon("tableCellHorizontalAlign",{NAME:"align-left",SVG_KEY:"alignLeft"}),ye.DefineIcon("align-left",{NAME:"align-left",SVG_KEY:"alignLeft"}),ye.DefineIcon("align-right",{NAME:"align-right",SVG_KEY:"alignRight"}),ye.DefineIcon("align-center",{NAME:"align-center",SVG_KEY:"alignCenter"}),ye.DefineIcon("align-justify",{NAME:"align-justify",SVG_KEY:"alignJustify"}),ye.RegisterCommand("tableCellHorizontalAlign",{type:"dropdown",focus:!1,title:"Horizontal Align",options:{left:"Align Left",center:"Align Center",right:"Align Right",justify:"Align Justify"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=ye.COMMANDS.tableCellHorizontalAlign.options;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="tableCellHorizontalAlign" data-param1="'.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.icon.create("align-".concat(a)),'<span class="fr-sr-only">').concat(this.language.translate(t[a]),"</span></a></li>"));return e+="</ul>"},callback:function(e,t){this.table.horizontalAlign(t)},refresh:function(e){var t=this.table.selectedCells(),a=this.$;t.length&&e.find("> *").first().replaceWith(this.icon.create("align-".concat(this.helpers.getAlignment(a(t[0])))))},refreshOnShow:function(e,t){t.find('.fr-command[data-param1="'+this.helpers.getAlignment(this.$el.find(".fr-selected-cell").first())+'"]').addClass("fr-active").attr("aria-selected",!0)}}),ye.DefineIcon("tableCellStyle",{NAME:"magic",SVG_KEY:"cellStyle"}),ye.RegisterCommand("tableCellStyle",{title:"Cell Style",type:"dropdown",focus:!1,html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=this.opts.tableCellStyles;for(var a in t)t.hasOwnProperty(a)&&(e+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCellStyle" data-param1="'.concat(a,'" title="').concat(this.language.translate(t[a]),'">').concat(this.language.translate(t[a]),"</a></li>"));return e+="</ul>"},callback:function(e,t){this.table.applyStyle(t,this.$el.find(".fr-selected-cell"),this.opts.tableCellMultipleStyles,this.opts.tableCellStyles)},refreshOnShow:function(e,t){var a=this.$,l=this.$el.find(".fr-selected-cell").first();l&&t.find(".fr-command").each(function(){var e=a(this).data("param1"),t=l.hasClass(e);a(this).toggleClass("fr-active",t).attr("aria-selected",t)})}}),ye.RegisterCommand("tableCellBackgroundCustomColor",{title:"OK",undo:!0,callback:function(){this.table.customColor()}}),ye.DefineIcon("tableColorRemove",{NAME:"eraser",SVG_KEY:"remove"})});

/***/ }),

/***/ 264:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(e,t){ true?t(__webpack_require__(189)):0}(this,function(we){"use strict";we=we&&we.hasOwnProperty("default")?we["default"]:we,Object.assign(we.POPUP_TEMPLATES,{"video.insert":"[_BUTTONS_][_BY_URL_LAYER_][_EMBED_LAYER_][_UPLOAD_LAYER_][_PROGRESS_BAR_]","video.edit":"[_BUTTONS_]","video.size":"[_BUTTONS_][_SIZE_LAYER_]"}),Object.assign(we.DEFAULTS,{videoAllowedTypes:["mp4","webm","ogg","mp3","mpeg","url"],videoAllowedProviders:[".*"],videoDefaultAlign:"center",videoDefaultDisplay:"block",videoDefaultWidth:600,videoEditButtons:["videoReplace","videoRemove","videoDisplay","videoAlign","videoSize","autoplay"],videoInsertButtons:["videoBack","|","videoByURL","videoEmbed","videoUpload"],videoMaxSize:52428800,videoMove:!0,videoResize:!0,videoResponsive:!1,videoSizeButtons:["videoBack","|"],videoSplitHTML:!1,videoTextNear:!0,videoUpload:!0,videoUploadMethod:"POST",videoUploadParam:"file",videoUploadParams:{},videoUploadToS3:!1,videoUploadToAzure:!1,videoUploadURL:null}),we.VIDEO_PROVIDERS=[{test_regex:/^.*((youtu.be)|(youtube.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))?\/?((shorts\/)|(v=))?([^#\&\?]*).*/,url_regex:/(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/|shorts\/)?([0-9a-zA-Z_\-]+)(.*)?/g,url_text:"https://www.youtube.com/embed/$1?$2",html:'<iframe width="640" height="360" src="{url}&wmode=opaque&rel=0" frameborder="0" allowfullscreen></iframe>',provider:"youtube"},{test_regex:/^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/\u200b\d+\/|video\/|)(\d+)(?:$|\/|\?)/,url_regex:/(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?(\/[a-zA-Z0-9_\-]+)?/i,url_text:"https://player.vimeo.com/video/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',provider:"vimeo"},{test_regex:/^.+(dailymotion.com|dai.ly)\/(video|hub)?\/?([^_]+)[^#]*(#video=([^_&]+))?/,url_regex:/(?:https?:\/\/)?(?:www\.)?(?:dailymotion\.com|dai\.ly)\/(?:video|hub)?\/?(.+)/g,url_text:"https://www.dailymotion.com/embed/video/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',provider:"dailymotion"},{test_regex:/^.+(screen.yahoo.com)\/[^_&]+/,url_regex:"",url_text:"",html:'<iframe width="640" height="360" src="{url}?format=embed" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',provider:"yahoo"},{test_regex:/^.+(rutube.ru)\/[^_&]+/,url_regex:/(?:https?:\/\/)?(?:www\.)?(?:rutube\.ru)\/(?:video)?\/?(.+)/g,url_text:"https://rutube.ru/play/embed/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',provider:"rutube"},{test_regex:/^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/,url_regex:/^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/g,url_text:"https://play.vidyard.com/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',provider:"vidyard"}],we.VIDEO_EMBED_REGEX=/^\W*(<div[^>]*>\s*<iframe[^>]*>.*?<\/iframe>\s*<\/div>(\s*<script[^>]*>.*?<\/script>)?|<iframe[^>]*>.*?<\/iframe>|<embed(.|\n)*>)\W*$/i,we.PLUGINS.video=function(w){var s,f,p,E,i,o,A=w.$,C="https://i.froala.com/upload",c=2,v=3,u=4,S=5,U=6,a={};function g(){var e=w.popups.get("video.insert");e.find(".fr-video-by-url-layer input").val("").trigger("change");var t=e.find(".fr-video-embed-layer textarea");t.val("").trigger("change"),(t=e.find(".fr-video-upload-layer input")).val("").trigger("change")}function r(){var e=w.popups.get("video.edit");if(e||(e=function n(){var e="";if(0<w.opts.videoEditButtons.length){w.opts.videoResponsive&&(-1<w.opts.videoEditButtons.indexOf("videoSize")&&w.opts.videoEditButtons.splice(w.opts.videoEditButtons.indexOf("videoSize"),1),-1<w.opts.videoEditButtons.indexOf("videoDisplay")&&w.opts.videoEditButtons.splice(w.opts.videoEditButtons.indexOf("videoDisplay"),1),-1<w.opts.videoEditButtons.indexOf("videoAlign")&&w.opts.videoEditButtons.splice(w.opts.videoEditButtons.indexOf("videoAlign"),1));var t={buttons:e+='<div class="fr-buttons"> \n      '.concat(w.button.buildList(w.opts.videoEditButtons)," \n      </div>")},o=w.popups.create("video.edit",t);return w.events.$on(w.$wp,"scroll.video-edit",function(){E&&w.popups.isVisible("video.edit")&&(w.events.disableBlur(),l(E))}),o}return!1}()),e){w.popups.setContainer("video.edit",w.$sc),w.popups.refresh("video.edit");var t=E.find("iframe, embed, ".concat(E.find("iframe, embed, audio").get(0)?"audio":"video")),o=t.offset().left+t.outerWidth()/2,i=t.offset().top+t.outerHeight(),a=t.get(0).src?t.get(0).src:t.get(0).currentSrc,r=!(!(a=(a=a.split("."))[a.length-1]).includes("pdf")&&!a.includes("txt"));t.hasClass("fr-file")||r||E.find("audio").get(0)?(document.getElementById("autoplay-".concat(w.id))&&(document.getElementById("autoplay-".concat(w.id)).style.display="none"),document.getElementById("videoReplace-".concat(w.id))&&(document.getElementById("videoReplace-".concat(w.id)).style.display="none")):(document.getElementById("autoplay-".concat(w.id))&&(document.getElementById("autoplay-".concat(w.id)).style.display=""),document.getElementById("videoReplace-".concat(w.id))&&(document.getElementById("videoReplace-".concat(w.id)).style.display="")),w.popups.show("video.edit",o,i,t.outerHeight(),!0)}}function n(e){if(e)return w.popups.onRefresh("video.insert",g),w.popups.onHide("video.insert",J),!0;var t="";w.opts.videoUpload||-1===w.opts.videoInsertButtons.indexOf("videoUpload")||w.opts.videoInsertButtons.splice(w.opts.videoInsertButtons.indexOf("videoUpload"),1);var o=w.button.buildList(w.opts.videoInsertButtons);""!==o&&(t='<div class="fr-buttons">'+o+"</div>");var i,a="",r=w.opts.videoInsertButtons.indexOf("videoUpload"),n=w.opts.videoInsertButtons.indexOf("videoByURL"),s=w.opts.videoInsertButtons.indexOf("videoEmbed");if(0<=n){i=" fr-active",(r<n&&0<=r||s<n&&0<=s)&&(i="");a='<div class="fr-video-by-url-layer fr-layer'.concat(i,'" id="fr-video-by-url-layer-').concat(w.id,'"><div class="fr-input-line"><input id="fr-video-by-url-layer-text-').concat(w.id,'" type="text" placeholder="').concat(w.language.translate("Paste in a video URL"),'" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><span style=\'float:left\'><div class="fr-checkbox-line fr-autoplay-margin"><span class="fr-checkbox"> <input id=\'videoPluginAutoplay\' data-checked="_blank" type="checkbox"> <span>').concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>','</span></span> <label id="fr-label-target-').concat(w.id,'">Autoplay</label></div> </span><button type="button" class="fr-command fr-submit" data-cmd="videoInsertByURL" tabIndex="2" role="button">').concat(w.language.translate("Insert"),"</button></div></div>")}var d="";0<=s&&(i=" fr-active",(r<s&&0<=r||n<s&&0<=n)&&(i=""),d='<div class="fr-video-embed-layer fr-layer'.concat(i,'" id="fr-video-embed-layer-').concat(w.id,'"><div class="fr-input-line"><textarea id="fr-video-embed-layer-text').concat(w.id,'" type="text" placeholder="').concat(w.language.translate("Embedded Code"),'" tabIndex="1" aria-required="true" rows="5"></textarea></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="videoInsertEmbed" tabIndex="2" role="button">').concat(w.language.translate("Insert"),"</button></div></div>"));var l="";0<=r&&(i=" fr-active",(s<r&&0<=s||n<r&&0<=n)&&(i=""),l='<div class="fr-video-upload-layer fr-layer'.concat(i,'" id="fr-video-upload-layer-').concat(w.id,'"><strong>').concat(w.language.translate("Drop video"),"</strong><br>(").concat(w.language.translate("or click"),')<div class="fr-form"><input type="file" accept="video/').concat(w.opts.videoAllowedTypes.join(", video/").toLowerCase(),'" tabIndex="-1" aria-labelledby="fr-video-upload-layer-').concat(w.id,'" role="button"></div></div>'));var f={buttons:t,by_url_layer:a,embed_layer:d,upload_layer:l,progress_bar:'<div class="fr-video-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="videoDismissError" tabIndex="2" role="button">OK</button></div></div>'},p=w.popups.create("video.insert",f);return function c(i){w.events.$on(i,"dragover dragenter",".fr-video-upload-layer",function(){return A(this).addClass("fr-drop"),!1},!0),w.events.$on(i,"dragleave dragend",".fr-video-upload-layer",function(){return A(this).removeClass("fr-drop"),!1},!0),w.events.$on(i,"drop",".fr-video-upload-layer",function(e){e.preventDefault(),e.stopPropagation(),A(this).removeClass("fr-drop");var t=e.originalEvent.dataTransfer;if(t&&t.files){var o=i.data("instance")||w;o.events.disableBlur(),o.video.upload(t.files),o.events.enableBlur()}},!0),w.helpers.isIOS()&&w.events.$on(i,"touchstart",'.fr-video-upload-layer input[type="file"]',function(){A(this).trigger("click")},!0);w.events.$on(i,"change",'.fr-video-upload-layer input[type="file"]',function(){if(this.files){var e=i.data("instance")||w;e.events.disableBlur(),i.find("input:focus").blur(),e.events.enableBlur(),e.video.upload(this.files)}A(this).val("")},!0)}(p),p}function h(e){w.events.focus(!0),w.selection.restore();var t=!1;if(E&&(q(),t=!0),w.opts.trackChangesEnabled){w.edit.on(),w.events.focus(!0),w.selection.restore(),w.undo.saveStep(),w.markers.insert(),w.html.wrap();var o=w.$el.find(".fr-marker");w.node.isLastSibling(o)&&o.parent().hasClass("fr-deletable")&&o.insertAfter(o.parent()),o.replaceWith('<span contenteditable="false" draggable="true" class="fr-jiv fr-video fr-deletable">'.concat(e,"</span>")),w.selection.clear()}else w.html.insert('<span contenteditable="false" draggable="true" class="fr-jiv fr-video fr-deletable">'.concat(e,"</span>"),!1,w.opts.videoSplitHTML);w.popups.hide("video.insert");var i=w.$el.find(".fr-jiv");i.removeClass("fr-jiv"),i.toggleClass("fr-rv",w.opts.videoResponsive),Z(i,w.opts.videoDefaultDisplay,w.opts.videoDefaultAlign),i.toggleClass("fr-draggable",w.opts.videoMove),w.events.trigger(t?"video.replaced":"video.inserted",[i])}function m(){var e=A(this);w.popups.hide("video.insert"),e.removeClass("fr-uploading"),e.parent().next().is("br")&&e.parent().next().remove(),l(e.parent()),w.events.trigger("video.loaded",[e.parent()])}function x(s,e,d,l,f,p){w.edit.off(),b("Loading video"),e&&(s=w.helpers.sanitizeURL(s));var c=function c(){var e,t;if(l){w.undo.canDo()||l.find("video").hasClass("fr-uploading")||w.undo.saveStep();var o=l.find("video").data("fr-old-src"),i=l.data("fr-replaced");if(l.data("fr-replaced",!1),0<l.find("iframe").length)l.remove(),e=I(s,d,m);else{w.$wp?((e=l.clone(!0)).find("video").removeData("fr-old-src").removeClass("fr-uploading"),e.find("video").off("canplay"),o&&l.find("video").attr("src",o),l.replaceWith(e)):e=l;for(var a=e.find("video").get(0).attributes,r=0;r<a.length;r++){var n=a[r];0===n.nodeName.indexOf("data-")&&e.find("video").removeAttr(n.nodeName)}if(void 0!==d)for(t in d)d.hasOwnProperty(t)&&"link"!=t&&e.find("video").attr("data-".concat(t),d[t]);e.find("video").on("canplay",m),e.find("video").attr("src",s)}w.edit.on(),O(),w.undo.saveStep(),w.$el.blur(),w.events.trigger(i?"video.replaced":"video.inserted",[e,f])}else e=I(s,d,m,p),O(),w.undo.saveStep(),w.events.trigger("video.inserted",[e,f])};R("Loading video"),c()}function R(e){var t=w.popups.get("video.insert");if(t||(t=n()),t.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"),t.find(".fr-video-progress-bar-layer").addClass("fr-active"),t.find(".fr-buttons").hide(),E){var o=E.find("iframe, embed, ".concat(E.find("iframe, embed, audio").get(0)?"audio":"video"));w.popups.setContainer("video.insert",w.$sc);var i=o.offset().left,a=o.offset().top+o.height();w.popups.show("video.insert",i,a,o.outerHeight())}void 0===e&&b(w.language.translate("Uploading"),0)}function d(e){var t=w.popups.get("video.insert");if(t&&(t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"),t.find(".fr-video-progress-bar-layer").removeClass("fr-active"),t.find(".fr-buttons").show(),e||w.$el.find("video.fr-error").length)){if(w.events.focus(),w.$el.find("video.fr-error").length&&(w.$el.find("video.fr-error").parent().remove(),w.undo.saveStep(),w.undo.run(),w.undo.dropRedo()),!w.$wp&&E){var o=E;V(!0),w.selection.setAfter(o.find("video").get(0)),w.selection.restore()}w.popups.hide("video.insert")}}function b(e,t){var o=w.popups.get("video.insert");if(o){var i=o.find(".fr-video-progress-bar-layer");i.find("h3").text(e+(t?" ".concat(t,"%"):"")),i.removeClass("fr-error"),t?(i.find("div").removeClass("fr-indeterminate"),i.find("div > span").css("width","".concat(t,"%"))):i.find("div").addClass("fr-indeterminate")}}function y(e){R();var t=w.popups.get("video.insert").find(".fr-video-progress-bar-layer");t.addClass("fr-error");var o=t.find("h3");o.text(e),w.events.disableBlur(),o.focus()}function l(e){t.call(e.get(0))}function _(e,t,o){b("Loading video");var i=this.status,a=this.response,r=this.responseXML,n=this.responseText;try{if(w.opts.videoUploadToS3||w.opts.videoUploadToAzure)if(201==i){var s;if(w.opts.videoUploadToAzure){if(!1===w.events.trigger("video.uploadedToAzure",[this.responseURL,o,a],!0))return w.edit.on(),!1;s=t}else s=function l(e){try{var t=A(e).find("Location").text(),o=A(e).find("Key").text();return!1===w.events.trigger("video.uploadedToS3",[t,o,e],!0)?(w.edit.on(),!1):t}catch(i){return F(u,e),!1}}(r);s&&x(s,!1,[],e,a||r)}else F(u,a||r);else if(200<=i&&i<300){var d=function f(e){try{if(!1===w.events.trigger("video.uploaded",[e],!0))return w.edit.on(),!1;var t=JSON.parse(e);return t.link?t:(F(c,e),!1)}catch(o){return F(u,e),!1}}(n);d&&x(d.link,!1,d,e,a||n)}else F(v,a||n)}catch(p){F(u,a||n)}}function B(){F(u,this.response||this.responseText||this.responseXML)}function D(e){if(e.lengthComputable){var t=e.loaded/e.total*100|0;b(w.language.translate("Uploading"),t)}}function k(){w.edit.on(),d(!0)}function I(e,t,o,i){var a,r,n="";if(t&&void 0!==t)for(a in t)t.hasOwnProperty(a)&&"link"!=a&&(n+=" ".concat(a,'="').concat(t[a],'"'));var s=w.opts.videoDefaultWidth;s&&"auto"!=s&&(s="".concat(s,"px")),w.helpers.isMobile()&&w.browser.safari&&(n+=" autoplay playsinline"),(r="audio"==i?A(document.createElement("span")).attr("contenteditable","false").attr("draggable","true").attr("class","fr-video fr-dv"+w.opts.videoDefaultDisplay[0]+("center"!=w.opts.videoDefaultAlign?" fr-fv"+w.opts.videoDefaultAlign[0]:"")).html('<audio src="'+e+'" '+n+" controls>"+w.language.translate("Your browser does not support HTML5 video.")+"</audio>"):A(document.createElement("span")).attr("contenteditable","false").attr("draggable","true").attr("class","fr-video fr-dv"+w.opts.videoDefaultDisplay[0]+("center"!=w.opts.videoDefaultAlign?" fr-fv"+w.opts.videoDefaultAlign[0]:"")).html('<video src="'+e+'" '+n+(s?' style="width: '+s+';" ':"")+" controls>"+w.language.translate("Your browser does not support HTML5 video.")+"</video>")).toggleClass("fr-draggable",w.opts.videoMove),w.edit.on(),w.events.focus(!0),w.selection.restore(),w.undo.saveStep(),w.opts.videoSplitHTML?w.markers.split():(w.cursor.enter(),w.markers.insert()),w.html.wrap();var d=w.$el.find(".fr-marker");return w.node.isLastSibling(d)&&d.parent().hasClass("fr-deletable")&&d.insertAfter(d.parent()),d.replaceWith(r),w.selection.clear(),"audio"!==i&&(r.find("video").get(0).readyState>r.find("video").get(0).HAVE_FUTURE_DATA||w.helpers.isIOS()?o.call(r.find("video").get(0)):r.find("video").on("canplaythrough load",o)),r}function T(e){if(!w.core.sameInstance(p))return!0;e.preventDefault(),e.stopPropagation();var t=e.pageX||(e.originalEvent.touches?e.originalEvent.touches[0].pageX:null),o=e.pageY||(e.originalEvent.touches?e.originalEvent.touches[0].pageY:null);if(!t||!o)return!1;if("mousedown"==e.type){var i=w.$oel.get(0).ownerDocument,a=i.defaultView||i.parentWindow,r=!1;try{r=a.location!=a.parent.location&&!(a.$&&a.$.FE)}catch(n){}r&&a.frameElement&&(t+=w.helpers.getPX(A(a.frameElement).offset().left)+a.frameElement.clientLeft,o=e.clientY+w.helpers.getPX(A(a.frameElement).offset().top)+a.frameElement.clientTop)}w.undo.canDo()||w.undo.saveStep(),(f=A(this)).data("start-x",t),f.data("start-y",o),s.show(),w.popups.hideAll(),Y()}function z(e){if(!w.core.sameInstance(p))return!0;if(f){e.preventDefault();var t=e.pageX||(e.originalEvent.touches?e.originalEvent.touches[0].pageX:null),o=e.pageY||(e.originalEvent.touches?e.originalEvent.touches[0].pageY:null);if(!t||!o)return!1;var i=f.data("start-x"),a=f.data("start-y");f.data("start-x",t),f.data("start-y",o);var r=t-i,n=o-a,s=E.find("iframe, embed, ".concat(E.find("iframe, embed, audio").get(0)?"audio":"video")),d=s.width(),l=s.height();(f.hasClass("fr-hnw")||f.hasClass("fr-hsw"))&&(r=0-r),(f.hasClass("fr-hnw")||f.hasClass("fr-hne"))&&(n=0-n),s.css("width",d+r),s.css("height",l+n),s.removeAttr("width"),s.removeAttr("height"),M()}}function P(e){if(!w.core.sameInstance(p))return!0;f&&E&&(e&&e.stopPropagation(),f=null,s.hide(),M(),r(),w.undo.saveStep())}function $(e){return'<div class="fr-handler fr-h'.concat(e,'"></div>')}function L(e,t,o,i){return e.pageX=t,e.pageY=t,T.call(this,e),e.pageX=e.pageX+o*Math.floor(Math.pow(1.1,i)),e.pageY=e.pageY+o*Math.floor(Math.pow(1.1,i)),z.call(this,e),P.call(this,e),++i}function O(){var e,t=Array.prototype.slice.call(w.el.querySelectorAll("video, .fr-video > *")),o=[];for(e=0;e<t.length;e++)o.push(t[e].getAttribute("src")),A(t[e]).toggleClass("fr-draggable",w.opts.videoMove),""===t[e].getAttribute("class")&&t[e].removeAttribute("class"),""===t[e].getAttribute("style")&&t[e].removeAttribute("style");if(i)for(e=0;e<i.length;e++)o.indexOf(i[e].getAttribute("src"))<0&&w.events.trigger("video.removed",[A(i[e])]);i=t}function M(){p||function n(){var e;if(w.shared.$video_resizer?(p=w.shared.$video_resizer,s=w.shared.$vid_overlay,w.events.on("destroy",function(){A("body").first().append(p.removeClass("fr-active"))},!0)):(w.shared.$video_resizer=A(document.createElement("div")).attr("class","fr-video-resizer"),p=w.shared.$video_resizer,w.events.$on(p,"mousedown",function(e){e.stopPropagation()},!0),w.opts.videoResize&&(p.append($("nw")+$("ne")+$("sw")+$("se")),w.shared.$vid_overlay=A(document.createElement("div")).attr("class","fr-video-overlay"),s=w.shared.$vid_overlay,e=p.get(0).ownerDocument,A(e).find("body").first().append(s))),w.events.on("shared.destroy",function(){p.html("").removeData().remove(),p=null,w.opts.videoResize&&(s.remove(),s=null)},!0),w.helpers.isMobile()||w.events.$on(A(w.o_win),"resize.video",function(){V(!0)}),w.opts.videoResize){e=p.get(0).ownerDocument,w.events.$on(p,w._mousedown,".fr-handler",T),w.events.$on(A(e),w._mousemove,z),w.events.$on(A(e.defaultView||e.parentWindow),w._mouseup,P),w.events.$on(s,"mouseleave",P);var i=1,a=null,r=0;w.events.on("keydown",function(e){if(E){var t=-1!=navigator.userAgent.indexOf("Mac OS X")?e.metaKey:e.ctrlKey,o=e.which;(o!==a||200<e.timeStamp-r)&&(i=1),(o==we.KEYCODE.EQUALS||w.browser.mozilla&&o==we.KEYCODE.FF_EQUALS)&&t&&!e.altKey?i=L.call(this,e,1,1,i):(o==we.KEYCODE.HYPHEN||w.browser.mozilla&&o==we.KEYCODE.FF_HYPHEN)&&t&&!e.altKey&&(i=L.call(this,e,2,-1,i)),a=o,r=e.timeStamp}}),w.events.on("keyup",function(){i=1})}}(),(w.$wp||w.$sc).append(p),p.data("instance",w);var e=E.find("iframe, embed, ".concat(E.find("iframe, embed, audio").get(0)?"audio":"video")),t=0,o=0;w.opts.iframe&&(o=w.helpers.getPX(w.$wp.find(".fr-iframe").css("padding-top")),t=w.helpers.getPX(w.$wp.find(".fr-iframe").css("padding-left"))),p.css("top",(w.opts.iframe?e.offset().top+o-1:e.offset().top-w.$wp.offset().top-1)+w.$wp.scrollTop()).css("left",(w.opts.iframe?e.offset().left+t-1:e.offset().left-w.$wp.offset().left-1)+w.$wp.scrollLeft()).css("width",e.get(0).getBoundingClientRect().width).css("height",e.get(0).getBoundingClientRect().height).addClass("fr-active")}function t(e){if(e&&"touchend"==e.type&&o)return!0;if(e&&w.edit.isDisabled())return e.stopPropagation(),e.preventDefault(),!1;if(w.edit.isDisabled())return!1;for(var t=0;t<we.INSTANCES.length;t++)we.INSTANCES[t]!=w&&we.INSTANCES[t].events.trigger("video.hideResizer");w.toolbar.disable(),w.helpers.isMobile()&&(w.events.disableBlur(),w.$el.blur(),w.events.enableBlur()),w.$el.find(".fr-video.fr-active").removeClass("fr-active"),(E=A(this)).addClass("fr-active"),w.opts.iframe&&w.size.syncIframe(),te(),M(),r(),w.selection.clear(),w.button.bulkRefresh(),w.events.trigger("image.hideResizer")}function V(e){E&&(function t(){return w.shared.vid_exit_flag}()||!0===e)&&(p.removeClass("fr-active"),w.toolbar.enable(),E.removeClass("fr-active"),E=null,Y())}function N(){w.shared.vid_exit_flag=!0}function Y(){w.shared.vid_exit_flag=!1}function H(e){var t=e.originalEvent.dataTransfer;if(t&&t.files&&t.files.length){var o=t.files[0];if(o&&o.type&&-1!==o.type.indexOf("video")){if(!w.opts.videoUpload)return e.preventDefault(),e.stopPropagation(),!1;w.markers.remove(),w.markers.insertAtPoint(e.originalEvent),w.$el.find(".fr-marker").replaceWith(we.MARKERS),w.popups.hideAll();var i=w.popups.get("video.insert");return i||(i=n()),w.popups.setContainer("video.insert",w.$sc),w.popups.show("video.insert",e.originalEvent.pageX,e.originalEvent.pageY),R(),0<=w.opts.videoAllowedTypes.indexOf(o.type.replace(/video\//g,""))?K(t.files):F(U),e.preventDefault(),e.stopPropagation(),!1}}}function K(e){if(void 0!==e&&0<e.length){if(!1===w.events.trigger("video.beforeUpload",[e]))return!1;var t,o=e[0];if(!(null!==w.opts.videoUploadURL&&w.opts.videoUploadURL!=C||w.opts.videoUploadToS3||w.opts.videoUploadToAzure))return function y(i){E&&E.find("iframe")&&E.find("iframe").length&&q();var a=new FileReader;a.onload=function(){a.result;for(var e=atob(a.result.split(",")[1]),t=[],o=0;o<e.length;o++)t.push(e.charCodeAt(o));x(window.URL.createObjectURL(new Blob([new Uint8Array(t)],{type:i.type})),!1,null,E)},R(),a.readAsDataURL(i)}(o),!1;if(o.size>w.opts.videoMaxSize)return F(S),!1;if(w.opts.videoAllowedTypes.indexOf(o.type.replace(/video\//g,""))<0)return F(U),!1;if(w.drag_support.formdata&&(t=w.drag_support.formdata?new FormData:null),t){var i;if(!1!==w.opts.videoUploadToS3)for(i in t.append("key",w.opts.videoUploadToS3.keyStart+(new Date).getTime()+"-"+(o.name||"untitled")),t.append("success_action_status","201"),t.append("X-Requested-With","xhr"),t.append("Content-Type",o.type),w.opts.videoUploadToS3.params)w.opts.videoUploadToS3.params.hasOwnProperty(i)&&t.append(i,w.opts.videoUploadToS3.params[i]);for(i in w.opts.videoUploadParams)w.opts.videoUploadParams.hasOwnProperty(i)&&t.append(i,w.opts.videoUploadParams[i]);t.append(w.opts.videoUploadParam,o);var a,r,n=w.opts.videoUploadURL;w.opts.videoUploadToS3&&(n=w.opts.videoUploadToS3.uploadURL?w.opts.videoUploadToS3.uploadURL:"https://".concat(w.opts.videoUploadToS3.region,".amazonaws.com/").concat(w.opts.videoUploadToS3.bucket));var s=w.opts.videoUploadMethod;w.opts.videoUploadToAzure&&(n=w.opts.videoUploadToAzure.uploadURL?"".concat(w.opts.videoUploadToAzure.uploadURL,"/").concat(o.name):encodeURI("https://".concat(w.opts.videoUploadToAzure.account,".blob.core.windows.net/").concat(w.opts.videoUploadToAzure.container,"/").concat(o.name)),a=n,w.opts.videoUploadToAzure.SASToken&&(n+=w.opts.videoUploadToAzure.SASToken),s="PUT");var d=w.core.getXHR(n,s);if(w.opts.videoUploadToAzure){var l=(new Date).toUTCString();if(!w.opts.videoUploadToAzure.SASToken&&w.opts.videoUploadToAzure.accessKey){var f=w.opts.videoUploadToAzure.account,p=w.opts.videoUploadToAzure.container;if(w.opts.videoUploadToAzure.uploadURL){var c=w.opts.videoUploadToAzure.uploadURL.split("/");p=c.pop(),f=c.pop().split(".")[0]}var v="x-ms-blob-type:BlockBlob\nx-ms-date:".concat(l,"\nx-ms-version:2019-07-07"),u=encodeURI("/"+f+"/"+p+"/"+o.name),g=s+"\n\n\n"+o.size+"\n\n"+o.type+"\n\n\n\n\n\n\n"+v+"\n"+u,h=w.cryptoJSPlugin.cryptoJS.HmacSHA256(g,w.cryptoJSPlugin.cryptoJS.enc.Base64.parse(w.opts.videoUploadToAzure.accessKey)).toString(w.cryptoJSPlugin.cryptoJS.enc.Base64),m="SharedKey "+f+":"+h;r=h,d.setRequestHeader("Authorization",m)}for(i in d.setRequestHeader("x-ms-version","2019-07-07"),d.setRequestHeader("x-ms-date",l),d.setRequestHeader("Content-Type",o.type),d.setRequestHeader("x-ms-blob-type","BlockBlob"),w.opts.videoUploadParams)w.opts.videoUploadParams.hasOwnProperty(i)&&d.setRequestHeader(i,w.opts.videoUploadParams[i]);for(i in w.opts.videoUploadToAzure.params)w.opts.videoUploadToAzure.params.hasOwnProperty(i)&&d.setRequestHeader(i,w.opts.videoUploadToAzure.params[i])}d.onload=function(){_.call(d,E,a,r)},d.onerror=B,d.upload.onprogress=D,d.onabort=k,R(),w.events.disableBlur(),w.edit.off(),w.events.enableBlur();var b=w.popups.get("video.insert");b&&A(b.off("abortUpload")).on("abortUpload",function(){4!=d.readyState&&d.abort()}),d.send(w.opts.videoUploadToAzure?o:t)}}}function F(e,t){w.edit.on(),E&&E.find("video").addClass("fr-error"),y(w.language.translate("Something went wrong. Please try again.")),w.events.trigger("video.error",[{code:e,message:a[e]},t])}function X(){if(E){var e=w.popups.get("video.size"),t=E.find("iframe, embed, ".concat(E.find("iframe, embed, audio").get(0)?"audio":"video"));e.find('input[name="width"]').val(t.get(0).style.width||t.attr("width")).trigger("change"),e.find('input[name="height"]').val(t.get(0).style.height||t.attr("height")).trigger("change")}}function G(e){if(e)return w.popups.onRefresh("video.size",X),!0;var t={buttons:'<div class="fr-buttons fr-tabs">'.concat(w.button.buildList(w.opts.videoSizeButtons),"</div>"),size_layer:'<div class="fr-video-size-layer fr-layer fr-active" id="fr-video-size-layer-'.concat(w.id,'"><div class="fr-video-group"><div class="fr-input-line"><input id="fr-video-size-layer-width-').concat(w.id,'" type="text" name="width" placeholder="').concat(w.language.translate("Width"),'" tabIndex="1"></div><div class="fr-input-line"><input id="fr-video-size-layer-height-').concat(w.id,'" type="text" name="height" placeholder="').concat(w.language.translate("Height"),'" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="videoSetSize" tabIndex="2" role="button">').concat(w.language.translate("Update"),"</button></div></div>")},o=w.popups.create("video.size",t);return w.events.$on(w.$wp,"scroll",function(){E&&w.popups.isVisible("video.size")&&(w.events.disableBlur(),l(E))}),o}function j(e){if(void 0===e&&(e=E),e){if(e.hasClass("fr-fvl"))return"left";if(e.hasClass("fr-fvr"))return"right";if(e.hasClass("fr-dvb")||e.hasClass("fr-dvi"))return"center";if("block"==e.css("display")){if("left"==e.css("text-algin"))return"left";if("right"==e.css("text-align"))return"right"}else{if("left"==e.css("float"))return"left";if("right"==e.css("float"))return"right"}}return"center"}function W(e){void 0===e&&(e=E);var t=e.css("float");return e.css("float","none"),"block"==e.css("display")?(e.css("float",""),e.css("float")!=t&&e.css("float",t),"block"):(e.css("float",""),e.css("float")!=t&&e.css("float",t),"inline")}function q(){if(E&&!1!==w.events.trigger("video.beforeRemove",[E])){var e=E;if(w.popups.hideAll(),V(!0),w.opts.trackChangesEnabled&&(!e[0].parentNode||"SPAN"!==e[0].parentNode.tagName||!e[0].parentNode.hasAttribute("data-tracking")))return void w.track_changes.removeSpecialItem(e);w.selection.setBefore(e.get(0))||w.selection.setAfter(e.get(0)),e.remove(),w.selection.restore(),w.html.fillEmptyBlocks()}}function J(){d()}function Z(e,t,o){!w.opts.htmlUntouched&&w.opts.useClasses?(e.removeClass("fr-fvl fr-fvr fr-dvb fr-dvi"),e.addClass("fr-fv".concat(o[0]," fr-dv").concat(t[0]))):"inline"==t?(e.css({display:"inline-block"}),"center"==o?e.css({"float":"none"}):"left"==o?e.css({"float":"left"}):e.css({"float":"right"})):(e.css({display:"block",clear:"both"}),"left"==o?e.css({textAlign:"left"}):"right"==o?e.css({textAlign:"right"}):e.css({textAlign:"center"}))}function Q(){var e=w.$el.find("video").filter(function(){return 0===A(this).parents("span.fr-video").length});if(0!=e.length){e.wrap(A(document.createElement("span")).attr("class","fr-video fr-deletable").attr("contenteditable","false")),w.$el.find("embed, iframe").filter(function(){if(w.browser.safari&&this.getAttribute("src")&&this.setAttribute("src",this.src),0<A(this).parents("span.fr-video").length)return!1;for(var e=A(this).attr("src"),t=0;t<we.VIDEO_PROVIDERS.length;t++){var o=we.VIDEO_PROVIDERS[t];if(o.test_regex.test(e)&&new RegExp(w.opts.videoAllowedProviders.join("|")).test(o.provider))return!0}return!1}).map(function(){return 0===A(this).parents("object").length?this:A(this).parents("object").get(0)}).wrap(A(document.createElement("span")).attr("class","fr-video").attr("contenteditable","false"));for(var t,o,i,a,r=w.$el.find("span.fr-video, video"),n=0;n<r.length;n++){var s=A(r[n]);!w.opts.htmlUntouched&&w.opts.useClasses?((a=s).hasClass("fr-dvi")||a.hasClass("fr-dvb")||(a.addClass("fr-fv".concat(j(a)[0])),a.addClass("fr-dv".concat(W(a)[0]))),w.opts.videoTextNear||s.removeClass("fr-dvi").addClass("fr-dvb")):w.opts.htmlUntouched||w.opts.useClasses||(void 0,o=(t=s).hasClass("fr-dvb")?"block":t.hasClass("fr-dvi")?"inline":null,i=t.hasClass("fr-fvl")?"left":t.hasClass("fr-fvr")?"right":j(t),Z(t,o,i),t.removeClass("fr-dvb fr-dvi fr-fvr fr-fvl"))}r.toggleClass("fr-draggable",w.opts.videoMove)}}function ee(e){document.getElementById("autoplay-".concat(w.id)).style.cssText="background:".concat(e)}function te(){if(E){w.selection.clear();var e=w.doc.createRange();e.selectNode(E.get(0)),w.selection.get().addRange(e)}}return a[1]="Video cannot be loaded from the passed link.",a[c]="No link in upload response.",a[v]="Error during file upload.",a[u]="Parsing response failed.",a[S]="File is too large.",a[U]="Video file type is invalid.",a[7]="Files can be uploaded only to same domain in IE 8 and IE 9.",w.shared.vid_exit_flag=!1,{_init:function oe(){w.opts.videoResponsive&&(w.opts.videoResize=!1),function e(){w.events.on("drop",H,!0),w.events.on("mousedown window.mousedown",N),w.events.on("window.touchmove",Y),w.events.on("mouseup window.mouseup",V),w.events.on("commands.mousedown",function(e){0<e.parents(".fr-toolbar").length&&V()}),w.events.on("video.hideResizer commands.undo commands.redo element.dropped",function(){V(!0)}),w.events.on("filestack-init-video",function(){n()})}(),w.helpers.isMobile()&&(w.events.$on(w.$el,"touchstart","span.fr-video",function(){o=!1}),w.events.$on(w.$el,"touchmove",function(){o=!0})),w.events.on("html.set",Q),Q(),w.events.$on(w.$el,"mousedown","span.fr-video",function(e){e.stopPropagation(),(w.browser.msie||w.browser.edge)&&(e.target.innerText||(e.target.dragDrop(),t.call(this,e)))}),w.events.$on(w.$el,"click touchend","span.fr-video",function(e){if(e.target.innerText.length||"false"==A(this).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable"))return!0;t.call(this,e)}),w.events.on("keydown",function(e){var t=e.which;return!E||t!=we.KEYCODE.BACKSPACE&&t!=we.KEYCODE.DELETE?E&&t==we.KEYCODE.ESC?(V(!0),e.preventDefault(),!1):E&&t!=we.KEYCODE.F10&&!w.keys.isBrowserAction(e)?(e.preventDefault(),!1):void 0:(e.preventDefault(),q(),w.undo.saveStep(),!1)},!0),w.events.on("toolbar.esc",function(){if(E)return w.events.disableBlur(),w.events.focus(),!1},!0),w.events.on("toolbar.focusEditor",function(){if(E)return!1},!0),w.events.on("keydown",function(){w.$el.find("span.fr-video:empty").remove()}),w.$wp&&(O(),w.events.on("contentChanged",O)),n(!0),G(!0)},showInsertPopup:function ie(){var e=w.$tb.find('.fr-command[data-cmd="insertVideo"]'),t=w.popups.get("video.insert");if(t||(t=n()),d(),!t.hasClass("fr-active"))if(w.popups.refresh("video.insert"),w.popups.setContainer("video.insert",w.$tb),e.isVisible()){var o=w.button.getPosition(e),i=o.left,a=o.top;w.popups.show("video.insert",i,a,e.outerHeight())}else w.position.forSelection(t),w.popups.show("video.insert")},showLayer:function ae(e){var t,o,i=w.popups.get("video.insert");if(!E&&!w.opts.toolbarInline){var a=w.$tb.find('.fr-command[data-cmd="insertVideo"]');t=a.offset().left,o=a.offset().top+(w.opts.toolbarBottom?10:a.outerHeight()-10)}w.opts.toolbarInline&&(o=i.offset().top-w.helpers.getPX(i.css("margin-top")),i.hasClass("fr-above")&&(o+=i.outerHeight())),i.find(".fr-layer").removeClass("fr-active"),i.find(".fr-".concat(e,"-layer")).addClass("fr-active"),w.popups.show("video.insert",t,o,0),w.accessibility.focusPopup(i)},refreshByURLButton:function re(e){var t=w.popups.get("video.insert");t&&t.find(".fr-video-by-url-layer").hasClass("fr-active")&&e.addClass("fr-active").attr("aria-pressed",!0)},refreshEmbedButton:function ne(e){var t=w.popups.get("video.insert");t&&t.find(".fr-video-embed-layer").hasClass("fr-active")&&e.addClass("fr-active").attr("aria-pressed",!0)},refreshUploadButton:function se(e){var t=w.popups.get("video.insert");t&&t.find(".fr-video-upload-layer").hasClass("fr-active")&&e.addClass("fr-active").attr("aria-pressed",!0)},upload:K,insertByURL:function de(e){var t=!!document.getElementById("videoPluginAutoplay")&&document.getElementById("videoPluginAutoplay").checked;if(void 0===e){var o=(e=(w.popups.get("video.insert").find('.fr-video-by-url-layer input[type="text"]').val()||"").trim()).match(/(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/?(showcase\/)*([0-9))([a-z]*\/)*([0-9]{6,11})[?]?.*/);if(o&&7==o.length){var i=o[6],a=e.substring(0,e.lastIndexOf("/")),r=e.substring(e.lastIndexOf("/")+1,e.length);e=r.includes("?h=")||r.includes("?v=")||i===r?("".concat(a,"/").concat(r)||"").trim():("".concat(a,"?h=").concat(r)||"").trim()}}var n=null;if(/^http/.test(e)||(e="https://".concat(e)),w.helpers.isURL(e))for(var s=0;s<we.VIDEO_PROVIDERS.length;s++){var d=we.VIDEO_PROVIDERS[s],l="autoplay=1&mute=1";if(d.html.includes("autoplay=1")&&document.getElementById("videoPluginAutoplay").checked)d.html=d.html,document.getElementById("videoPluginAutoplay").checked=!1;else if(t){var f=d.html.indexOf("{url}")+5;d.html=[d.html.slice(0,f),l,d.html.slice(f)].join(""),t=!1,document.getElementById("videoPluginAutoplay").checked=!1}else(d=we.VIDEO_PROVIDERS[s]).html=d.html.replace(l,"");if(d.test_regex.test(e)&&new RegExp(w.opts.videoAllowedProviders.join("|")).test(d.provider)){n=e.replace(d.url_regex,d.url_text),n=d.html.replace(/\{url\}/,n);break}}n?h(n):(y(w.language.translate("Something went wrong. Please try again.")),w.events.trigger("video.linkError",[e]))},insertEmbed:function le(e){void 0===e&&(e=w.popups.get("video.insert").find(".fr-video-embed-layer textarea").val()||""),0!==e.length&&we.VIDEO_EMBED_REGEX.test(e)?h(e):(y(w.language.translate("Something went wrong. Please try again.")),w.events.trigger("video.codeError",[e]))},insert:h,align:function fe(e){E.removeClass("fr-fvr fr-fvl"),!w.opts.htmlUntouched&&w.opts.useClasses?"left"==e?E.addClass("fr-fvl"):"right"==e&&E.addClass("fr-fvr"):Z(E,W(),e),te(),M(),r(),w.selection.clear()},refreshAlign:function pe(e){if(!E)return!1;e.find(">*").first().replaceWith(w.icon.create("video-align-".concat(j())))},refreshAlignOnShow:function ce(e,t){E&&t.find('.fr-command[data-param1="'.concat(j(),'"]')).addClass("fr-active").attr("aria-selected",!0)},display:function ve(e){E.removeClass("fr-dvi fr-dvb"),!w.opts.htmlUntouched&&w.opts.useClasses?"inline"==e?E.addClass("fr-dvi"):"block"==e&&E.addClass("fr-dvb"):Z(E,e,j()),te(),M(),r(),w.selection.clear()},refreshDisplayOnShow:function ue(e,t){E&&t.find('.fr-command[data-param1="'.concat(W(),'"]')).addClass("fr-active").attr("aria-selected",!0)},remove:q,hideProgressBar:d,showSizePopup:function ge(){var e=w.popups.get("video.size");e||(e=G()),d(),w.popups.refresh("video.size"),w.popups.setContainer("video.size",w.$sc);var t=E.find("iframe, embed, ".concat(E.find("iframe, embed, audio").get(0)?"audio":"video")),o=t.offset().left+t.outerWidth()/2,i=t.offset().top+t.height();w.popups.show("video.size",o,i,t.height(),!0)},replace:function he(){var e=w.popups.get("video.insert");e||(e=n()),w.popups.isVisible("video.insert")||(d(),w.popups.refresh("video.insert"),w.popups.setContainer("video.insert",w.$sc));var t=E.offset().left+E.outerWidth()/2,o=E.offset().top+E.height();w.popups.show("video.insert",t,o,E.outerHeight(),!0)},back:function e(){E?(w.events.disableBlur(),E[0].click()):(w.events.disableBlur(),w.selection.restore(),w.events.enableBlur(),w.popups.hide("video.insert"),w.toolbar.showInline())},setSize:function me(e,t){if(E){var o=w.popups.get("video.size"),i=E.find("iframe, embed, ".concat(E.find("iframe, embed, audio").get(0)?"audio":"video"));i.css("width",e||o.find('input[name="width"]').val()),i.css("height",t||o.find('input[name="height"]').val()),i.get(0).style.width&&i.removeAttr("width"),i.get(0).style.height&&i.removeAttr("height"),o.find("input:focus").blur(),setTimeout(function(){E.trigger("click")},w.helpers.isAndroid()?50:0)}},get:function be(){return E},showProgressBar:R,_editVideo:l,setAutoplay:function ye(){var e;if(E.find("iframe, embed, audio").get(0))(e=E.find("iframe, embed, audio")).get(0).src.includes("autoplay=1")?(ee("#FFFFFF"),e.get(0).src=e.get(0).src.replace("&autoplay=1","")):(ee("#D6D6D6"),e.get(0).src=e.get(0).src+"&autoplay=1");else if((e=E.find("iframe, embed, video")).get(0).outerHTML.includes("autoplay"))ee("#FFFFFF"),e.get(0).outerHTML=e.get(0).outerHTML.replace("autoplay","");else{ee("#D6D6D6");var t=e.get(0).outerHTML.indexOf("class")-1;e.get(0).outerHTML=[e.get(0).outerHTML.slice(0,t),"autoplay",e.get(0).outerHTML.slice(t)].join("")}},insertHtmlVideo:x}},we.RegisterCommand("insertVideo",{title:"Insert Video",undo:!1,focus:!0,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible("video.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("video.insert")):this.video.showInsertPopup()},plugin:"video"}),we.DefineIcon("insertVideo",{NAME:"video-camera",FA5NAME:"camera",SVG_KEY:"insertVideo"}),we.DefineIcon("videoByURL",{NAME:"link",SVG_KEY:"insertLink"}),we.RegisterCommand("videoByURL",{title:"By URL",undo:!1,focus:!1,toggle:!0,callback:function(){this.video.showLayer("video-by-url")},refresh:function(e){this.video.refreshByURLButton(e)}}),we.DefineIcon("videoEmbed",{NAME:"code",SVG_KEY:"codeView"}),we.RegisterCommand("videoEmbed",{title:"Embedded Code",undo:!1,focus:!1,toggle:!0,callback:function(){this.video.showLayer("video-embed")},refresh:function(e){this.video.refreshEmbedButton(e)}}),we.DefineIcon("videoUpload",{NAME:"upload",SVG_KEY:"upload"}),we.RegisterCommand("videoUpload",{title:"Upload Video",undo:!1,focus:!1,toggle:!0,callback:function(){this.video.showLayer("video-upload")},refresh:function(e){this.video.refreshUploadButton(e)}}),we.RegisterCommand("videoInsertByURL",{undo:!0,focus:!0,callback:function(){this.video.insertByURL()}}),we.RegisterCommand("videoInsertEmbed",{undo:!0,focus:!0,callback:function(){this.video.insertEmbed()}}),we.DefineIcon("videoDisplay",{NAME:"star",SVG_KEY:"star"}),we.RegisterCommand("videoDisplay",{title:"Display",type:"dropdown",options:{inline:"Inline",block:"Break Text"},callback:function(e,t){this.video.display(t)},refresh:function(e){this.opts.videoTextNear||e.addClass("fr-hidden")},refreshOnShow:function(e,t){this.video.refreshDisplayOnShow(e,t)}}),we.DefineIcon("video-align",{NAME:"align-left",SVG_KEY:"align Left"}),we.DefineIcon("video-align-left",{NAME:"align-left",SVG_KEY:"alignLeft"}),we.DefineIcon("video-align-right",{NAME:"align-right",SVG_KEY:"alignRight"}),we.DefineIcon("video-align-center",{NAME:"align-justify",SVG_KEY:"alignJustify"}),we.DefineIcon("videoAlign",{NAME:"align-center",SVG_KEY:"alignCenter"}),we.RegisterCommand("videoAlign",{type:"dropdown",title:"Align",options:{left:"Align Left",center:"None",right:"Align Right"},html:function(){var e='<ul class="fr-dropdown-list" role="presentation">',t=we.COMMANDS.videoAlign.options;for(var o in t)t.hasOwnProperty(o)&&(e+='<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="videoAlign" data-param1="'.concat(o,'" title="').concat(this.language.translate(t[o]),'">').concat(this.icon.create("video-align-".concat(o)),'<span class="fr-sr-only">').concat(this.language.translate(t[o]),"</span></a></li>"));return e+="</ul>"},callback:function(e,t){this.video.align(t)},refresh:function(e){this.video.refreshAlign(e)},refreshOnShow:function(e,t){this.video.refreshAlignOnShow(e,t)}}),we.DefineIcon("videoReplace",{NAME:"exchange",FA5NAME:"exchange-alt",SVG_KEY:"replaceImage"}),we.RegisterCommand("videoReplace",{title:"Replace",undo:!1,focus:!1,popup:!0,refreshAfterCallback:!1,callback:function(){this.video.replace()}}),we.DefineIcon("videoRemove",{NAME:"trash",SVG_KEY:"remove"}),we.RegisterCommand("videoRemove",{title:"Remove",callback:function(){this.video.remove()}}),we.DefineIcon("autoplay",{NAME:"autoplay",SVG_KEY:"autoplay"}),we.RegisterCommand("autoplay",{undo:!1,focus:!1,popup:!0,title:"Autoplay",callback:function(){this.video.setAutoplay()}}),we.DefineIcon("videoSize",{NAME:"arrows-alt",SVG_KEY:"imageSize"}),we.RegisterCommand("videoSize",{undo:!1,focus:!1,popup:!0,title:"Change Size",callback:function(){this.video.showSizePopup()}}),we.DefineIcon("videoBack",{NAME:"arrow-left",SVG_KEY:"back"}),we.RegisterCommand("videoBack",{title:"Back",undo:!1,focus:!1,back:!0,callback:function(){this.video.back()},refresh:function(e){this.video.get()||this.opts.toolbarInline?(e.removeClass("fr-hidden"),e.next().hasClass("fr-separator")&&e.next().removeClass("fr-hidden")):(e.addClass("fr-hidden"),e.next().hasClass("fr-separator")&&e.next().addClass("fr-hidden"))}}),we.RegisterCommand("videoDismissError",{title:"OK",undo:!1,callback:function(){this.video.hideProgressBar(!0)}}),we.RegisterCommand("videoSetSize",{undo:!0,focus:!1,title:"Update",refreshAfterCallback:!1,callback:function(){this.video.setSize()}})});

/***/ }),

/***/ 5119:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/*!
 * froala_editor v4.4.0 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(t,e){ true?e(__webpack_require__(189)):0}(this,function(H){"use strict";function l(t,e){(null==e||e>t.length)&&(e=t.length);for(var r=0,i=Array(e);r<e;r++)i[r]=t[r];return i}function o(t){return function e(t){if(Array.isArray(t))return l(t)}(t)||function r(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||function i(t,e){if(t){if("string"==typeof t)return l(t,e);var r={}.toString.call(t).slice(8,-1);return"Object"===r&&t.constructor&&(r=t.constructor.name),"Map"===r||"Set"===r?Array.from(t):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?l(t,e):void 0}}(t)||function n(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}H=H&&H.hasOwnProperty("default")?H["default"]:H,Object.assign(H.DEFAULTS,{wordDeniedTags:[],wordDeniedAttrs:[],wordAllowedStyleProps:["font-family","font-size","background","color","width","text-align","vertical-align","background-color","padding","margin","height","margin-top","margin-left","margin-right","margin-bottom","text-decoration","font-weight","font-style","text-indent","border","border-.*","line-height","list-style-type"],wordPasteModal:!0,wordPasteKeepFormatting:!0}),H.PLUGINS.wordPaste=function(A){var a,n,C,D=A.$,s="word_paste",p={},E=!0;function e(t){var e=A.opts.wordAllowedStyleProps;t||(A.opts.wordAllowedStyleProps=[]),0===n.indexOf("<colgroup>")&&(n="<table>"+n+"</table>"),n=l(n=n.replace(/<span[\n\r ]*style='mso-spacerun:yes'>([\r\n\u00a0 ]*)<\/span>/g,function(t,e){for(var r="",i=0;i++<e.length;)r+="&nbsp;";return r}),A.paste.getRtfClipboard());var r=A.doc.createElement("DIV");r.innerHTML=n,A.html.cleanBlankSpaces(r),n=r.innerHTML,n=(n=A.paste.cleanEmptyTagsAndDivs(n)).replace(/\u200b/g,""),function i(){A.modals.hide(s)}(),A.helpers.isMobile()&&A.events.focus(),A.paste.clean(n,!0,!0),A.opts.wordAllowedStyleProps=e}function S(t){t.parentNode&&t.parentNode.removeChild(t)}function m(t,e){if(e(t))for(var r=t.firstChild;r;){var i=r,n=r.previousSibling;r=r.nextSibling,m(i,e),i.previousSibling||i.nextSibling||i.parentNode||!r||n===r.previousSibling||!r.parentNode?i.previousSibling||i.nextSibling||i.parentNode||!r||r.previousSibling||r.nextSibling||r.parentNode||(n?r=n.nextSibling?n.nextSibling.nextSibling:null:t.firstChild&&(r=t.firstChild.nextSibling)):r=n?n.nextSibling:t.firstChild}}function _(t){return D(t).hasClass("ListContainerWrapper")&&0<D(t).find("ol").length}function F(t){return D(t).hasClass("ListContainerWrapper")&&0<D(t).find("ul").length}function $(t){if(_(t)||F(t))return!0;if(!t.getAttribute("style")||!/mso-list:[\s]*l/gi.test(t.getAttribute("style").replace(/\n/gi,"")))return!1;try{if(!t.querySelector('[style="mso-list:Ignore"]'))return!!(t.outerHTML&&0<=t.outerHTML.indexOf("\x3c!--[if !supportLists]--\x3e"))}catch(e){return!1}return!0}var h=null,v={};function k(t){var e;if(_(t)||F(t))e=D(t).find("li").attr("data-aria-level");else{var r,i,n=(null===(r=t.getAttribute("style"))||void 0===r?void 0:r.replace(/\n/g,""))||"",l=h&&(null===(i=h.getAttribute("style"))||void 0===i?void 0:i.replace(/\n/g,""))||"",a=n.match(/mso-list:(\s*l([0-9]+)\s*level([0-9]+)\s*)lfo([0-9]+)/i),s=l.match(/mso-list:(\s*l([0-9]+)\s*level([0-9]+)\s*)lfo([0-9]+)/i);if(a){if(v[a[1]])return h=t,v[a[1]].toString();var o=s&&s[2],d=a[2],f=l&&v[s[1]]||0;e=o&&o!==d&&parseFloat(h.style.marginLeft)<parseFloat(t.style.marginLeft)?(f+parseInt(a[3])).toString():a[3],v[a[1]]=parseInt(e)}else e=n.replace(/.*level([0-9]+?).*/gi,"$1")}return h=t,e}function W(t,i){var e=t.cloneNode(!0);if(-1!==["H1","H2","H3","H4","H5","H6"].indexOf(t.tagName)){var r=document.createElement(t.tagName.toLowerCase());r.setAttribute("style",t.getAttribute("style")),r.innerHTML=e.innerHTML,e.innerHTML=r.outerHTML}m(e,function(t){if(t.nodeType==Node.COMMENT_NODE&&(A.browser.msie||A.browser.safari||A.browser.edge))try{if("[if !supportLists]"===t.data){for(t=t.nextSibling;t&&t.nodeType!==Node.COMMENT_NODE;){var e=t.nextSibling;t.parentNode.removeChild(t),t=e}t&&t.nodeType==Node.COMMENT_NODE&&t.parentNode.removeChild(t)}}catch(r){return!1}return t.nodeType===Node.ELEMENT_NODE&&("mso-list:\nIgnore"===t.getAttribute("style")&&t.setAttribute("style","mso-list:Ignore"),"mso-list:Ignore"===t.getAttribute("style")&&t.parentNode.removeChild(t),t.setAttribute("style",b(t)),M(t,i)),!0});var n=_(t)?D(t).find("li").get(0).innerHTML:e.innerHTML;if(_(t)||F(t)){n="";for(var l=D(t).find("li"),a=0;a<l.length;a++){var s=D(l.get(a).innerHTML);s.find("span").each(function(){"&nbsp;"===D(this).html()&&(0<D(this).prev().text().trim().length?D(this).remove():D(this).html("&ZeroWidthSpace;"))});var o=l[a].style.marginLeft;o?(o=parseFloat(parseFloat(o).toFixed(2))+o.match(/[a-zA-Z]+/g)[0],n+='<li style = "margin-left: '.concat(o,';">').concat(s.get(0).innerHTML,"</li>")):n+="<li >".concat(s.get(0).innerHTML,"</li>")}}else{var d,f=null===(d=D(t).find("p").get(0))||void 0===d?void 0:d.style.marginLeft;n=f?(f=parseFloat(parseFloat(f).toFixed(2))+f.match(/[a-zA-Z]+/g)[0],'<li style = "margin-left: '.concat(f,';">').concat(n,"</li>")):"<li>".concat(n,"</li>")}return n=n.replace(/<!--[\s\S]*?-->/gi,"")}function b(t){var e=1<arguments.length&&arguments[1]!==undefined?arguments[1]:null,r="",i=["line-height","font-family","font-size","color","background"].concat(o(e||[])),n=t.getAttribute("style");return n&&i.forEach(function(e){var t=n.split(";").find(function(t){return t.trim().includes(e+":")});t&&(t.includes("mso")&&(t=t.match(new RegExp(e+":.*(;|)"))[0]),t.trim().startsWith(e)&&(r+=t+";"))}),r}function y(t,e){for(var r=document.createElement(e),i=0;i<t.attributes.length;i++){var n=t.attributes[i].name;"FONT"===t.tagName&&(A.browser.msie&&["id","class","style"].indexOf(n)<0||!A.browser.msie&&CSS.supports(n,t.getAttribute(n)))?D(r).css(n,t.getAttribute(n)):r.setAttribute(n,t.getAttribute(n))}return r.innerHTML=t.innerHTML,t.parentNode.replaceChild(r,t),r}function N(t,e){A.node.clearAttributes(t);for(var r=t.firstElementChild,i=0,n=!1,l=null;r;){if(r.firstElementChild&&-1!==r.firstElementChild.tagName.indexOf("W:"))for(var a=0;a<r.children.length;a++)"<('[^']*'|\"[^\"]*\"|[^\"'>])*>"==r.children[a]&&(r.innerHTML+=r.children[a]);(l=r.getAttribute("width"))||(l=r.style.width),l||n||(n=!0),i+=parseInt(l,10),(!r.firstChild||r.firstChild&&r.firstChild.data===H.UNICODE_NBSP)&&(r.firstChild&&S(r.firstChild),r.innerHTML="<br>");for(var s=r.firstElementChild,o=1===r.children.length;s;)"P"!==s.tagName||$(s)||o&&T(s),s=s.nextElementSibling;if(e){var d=r.getAttribute("class");if(d){var f=(d=L(d)).match(/xl[0-9]+/gi);if(f){var u="."+f[0];e[u]&&w(r,e[u])}}e.td&&w(r,e.td)}var g=r.getAttribute("style");g&&(g=L(g))&&";"!==g.slice(-1)&&(g+=";");var c=r.getAttribute("valign");if(!c&&g){var p=g.match(/vertical-align:.+?[; "]{1,1}/gi);p&&(c=p[p.length-1].replace(/vertical-align:(.+?)[; "]{1,1}/gi,"$1"))}var m=null;if(g){var h=g.match(/text-align:.+?[; "]{1,1}/gi);h&&(m=h[h.length-1].replace(/text-align:(.+?)[; "]{1,1}/gi,"$1")),"general"===m&&(m=null)}var v=null;if(g){var b=g.match(/background:.+?[; "]{1,1}/gi);b&&(v=b[b.length-1].replace(/background:(.+?)[; "]{1,1}/gi,"$1"))}var y=r.getAttribute("colspan"),N=r.getAttribute("rowspan");y&&r.setAttribute("colspan",y),N&&r.setAttribute("rowspan",N),c&&(r.style["vertical-align"]=c),m&&(r.style["text-align"]=m),v&&(r.style["background-color"]=v),l&&r.setAttribute("width",l),r=r.nextElementSibling}for(r=t.firstElementChild;r;)l=r.getAttribute("width"),n&&r.removeAttribute("width"),r=r.nextElementSibling;t.previousSibling?C!=i&&(E=!1):C=i,t.nextElementSibling||function x(t){var e=t.closest("table"),r=0,n=function n(){var i=0;Array.from(t.children).forEach(function(t){var e=parseInt(t.getAttribute("width"),10);isNaN(e)||(i+=e)}),r<i&&(r=i),E?Array.from(t.children).forEach(function(t){var e=parseInt(t.getAttribute("width"),10);if(!isNaN(e)&&0<i){var r=100*e/i;t.setAttribute("width","".concat(r,"%"))}}):Array.from(t.children).forEach(function(t){var e=parseInt(t.getAttribute("width"),10);isNaN(e)||t.setAttribute("width","".concat(e,"px"))}),t=t.previousElementSibling};for(;t;)n();if(e&&0<r){var i=parseInt(e.style.width,10);(isNaN(i)||0===i)&&(e.style.width="".concat(r,"px"))}}(t)}function T(t){var e=t.getAttribute("align");e&&(t.style["text-align"]=e,t.removeAttribute("align"))}function L(t){return t.replace(/\n|\r|\n\r|&quot;/g,"")}function w(t,e,r){if(e){var i=t.getAttribute("style");i&&";"!==i.slice(-1)&&(i+=";"),e&&";"!==e.slice(-1)&&(e+=";"),e=e.replace(/\n/gi,"");var n=null;n=r?(i||"")+e:e+(i||""),t.setAttribute("style",n)}}var c=null;function d(t,e,r){for(var i=t.split(r),n=1;n<i.length;n++){var l=i[n];if(1<(l=l.split("shplid")).length){l=l[1];for(var a="",s=0;s<l.length&&"\\"!==l[s]&&"{"!==l[s]&&" "!==l[s]&&"\r"!==l[s]&&"\n"!==l[s];)a+=l[s],s++;var o=l.split("bliptag");if(o&&o.length<2)continue;var d=null;if(-1!==o[0].indexOf("pngblip")?d="image/png":-1!==o[0].indexOf("jpegblip")&&(d="image/jpeg"),!d)continue;var f=o[1].split("}");if(f&&f.length<2)continue;var u=void 0;if(2<f.length&&-1!==f[0].indexOf("blipuid"))u=f[1].split(" ");else{if((u=f[0].split(" "))&&u.length<2)continue;u.shift()}var g=u.join("");c[e+a]={image_hex:g,image_type:d}}}}function x(t,e){if(e){var r;if("IMG"===t.tagName){var i=t.getAttribute("src");if(!i||-1===i.indexOf("file://"))return;if(0===i.indexOf("file://")&&A.helpers.isURL(t.getAttribute("alt")))return void t.setAttribute("src",t.getAttribute("alt"));(r=p[t.getAttribute("v:shapes")])||(r=t.getAttribute("v:shapes"),t.parentNode&&t.parentNode.parentNode&&0<=t.parentNode.parentNode.innerHTML.indexOf("msEquation")&&(r=null))}else r=t.parentNode.getAttribute("o:spid");if(t.removeAttribute("height"),r){!function s(t){c={},d(t,"i","\\shppict"),d(t,"s","\\shp{")}(e);var n=c[r.substring(7)];if(n){var l=function o(t){for(var e=t.match(/[0-9a-f]{2}/gi),r=[],i=0;i<e.length;i++)r.push(String.fromCharCode(parseInt(e[i],16)));var n=r.join("");return btoa(n)}(n.image_hex),a="data:"+n.image_type+";base64,"+l;"IMG"===t.tagName?(t.src=a,t.setAttribute("data-fr-image-pasted",!0)):D(t).parent().before('<img data-fr-image-pasted="true" src="'.concat(a,'" style="').concat(t.parentNode.getAttribute("style"),'">')).remove()}}}}function M(t,e){var r=t.tagName,i=r.toLowerCase();t.firstElementChild&&("I"===t.firstElementChild.tagName?y(t.firstElementChild,"em"):"B"===t.firstElementChild.tagName&&y(t.firstElementChild,"strong"));if(-1!==["SCRIPT","APPLET","EMBED","NOFRAMES","NOSCRIPT"].indexOf(r))return S(t),!1;for(var n=["META","LINK","XML","ST1:","O:","W:","FONT"],l=0;l<n.length;l++)if(-1!==r.indexOf(n[l]))return t.innerHTML&&(t.outerHTML=t.innerHTML),S(t),!1;if("TD"!==r){var a=t.getAttribute("class")||"MsoNormal";if(e&&a){for(var s=(a=L(a)).split(" "),o=0;o<s.length;o++){var d=[],f="."+s[o];d.push(f),f=i+f,d.push(f);for(var u=0;u<d.length;u++)e[d[u]]&&w(t,e[d[u]])}t.removeAttribute("class")}e&&e[i]&&w(t,e[i])}if(-1!==["P","H1","H2","H3","H4","H5","H6","PRE"].indexOf(r)){var g=t.getAttribute("class");if(g&&(e&&e[r.toLowerCase()+"."+g]&&w(t,e[r.toLowerCase()+"."+g]),-1!==g.toLowerCase().indexOf("mso"))){var c=L(g);(c=c.replace(/[0-9a-z-_]*mso[0-9a-z-_]*/gi,""))?t.setAttribute("class",c):t.removeAttribute("class")}var p=t.getAttribute("style");if(p){var m=p.match(/text-align:.+?[; "]{1,1}/gi);m&&m[m.length-1].replace(/(text-align:.+?[; "]{1,1})/gi,"$1")}T(t)}if("TR"===r&&N(t,e),"A"!==r||t.attributes.getNamedItem("href")||t.attributes.getNamedItem("name")||!t.innerHTML||(t.outerHTML=t.innerHTML),"A"==r&&t.getAttribute("href")&&t.querySelector("img"))for(var h=t.querySelectorAll("span"),v=0;v<h.length;v++)h[v].innerText||(h[v].outerHTML=h[v].innerHTML);if("TD"!==r&&"TH"!==r||t.innerHTML||(t.innerHTML="<br>"),t.getAttribute("lang")&&t.removeAttribute("lang"),t.getAttribute("style")&&-1!==t.getAttribute("style").toLowerCase().indexOf("mso")){var b=L(t.getAttribute("style"));(b=b.replace(/[0-9a-z-_]*mso[0-9a-z-_]*:.+?(;{1,1}|$)/gi,"").replace("line-height:107%",""))?t.setAttribute("style",b):t.removeAttribute("style")}return!0}function l(t,e){0<=t.indexOf("<html")&&(t=t.replace(/[.\s\S\w\W<>]*(<html[^>]*>[.\s\S\w\W<>]*<\/html>)[.\s\S\w\W<>]*/i,"$1"));var o=t.match(/(MSFontService|class="?Mso|class='?Mso|class="?Xl|class='?Xl|class=Xl|style="[^"]*\bmso-|style='[^']*\bmso-|w:WordDocument|LibreOffice)/gi);!function u(t){for(var e=t.split("v:shape"),r=1;r<e.length;r++){var i=e[r],n=i.split(' id="')[1];if(n&&1<n.length){n=n.split('"')[0];var l=i.split(' o:spid="')[1];l&&1<l.length&&(l=l.split('"')[0],p[n]=l)}}}(t);var r=(new DOMParser).parseFromString(t,"text/html"),i=r.head,n=r.body,d=function g(t){var e={},r=t.getElementsByTagName("style");if(r.length){var i=r[0].innerHTML.match(/[\S ]+\s+{[\s\S]+?}/gi);if(i)for(var n=0;n<i.length;n++){var l=i[n],a=l.replace(/([\S ]+\s+){[\s\S]+?}/gi,"$1"),s=l.replace(/[\S ]+\s+{([\s\S]+?)}/gi,"$1");a=a.replace(/^[\s]|[\s]$/gm,""),s=s.replace(/^[\s]|[\s]$/gm,""),a=a.replace(/\n|\r|\n\r/g,""),s=s.replace(/\n|\r|\n\r/g,"");for(var o=a.split(", "),d=0;d<o.length;d++)e[o[d]]=s}}return e}(i);m(n,function(t){if(t.nodeType===Node.ELEMENT_NODE&&t.hasAttribute("style")){var e=t.getAttribute("style");t.setAttribute("style",e),t.style.fontFamily||t.setAttribute("style",function r(t){return t.replace(/mso-(bidi|fareast|fareast-theme)-font-family/g,"font-family")}(e))}return!0}),m(n,function(t){if(t.nodeType===Node.TEXT_NODE&&/\n|\u00a0|\r/.test(t.data)){if(!/\S| /.test(t.data)&&!/[\u00a0]+/.test(t.data))return t.data===H.UNICODE_NBSP?(t.data="\u200b",!0):1===t.data.length&&10===t.data.charCodeAt(0)?(t.data=" ",!0):(S(t),!1);t.data=t.data.replace(/\n|\r/gi," ")}return!0}),m(n,function(t){return t.nodeType!==Node.ELEMENT_NODE||"V:IMAGEDATA"!==t.tagName&&"IMG"!==t.tagName||x(t,e),!0});for(var l=n.querySelectorAll("ul > ul, ul > ol, ol > ul, ol > ol"),a=l.length-1;0<=a;a--)l[a].previousElementSibling&&"LI"===l[a].previousElementSibling.tagName&&l[a].previousElementSibling.appendChild(l[a]);m(n,function(t){if(t.nodeType===Node.TEXT_NODE)return t.data=t.data.replace(/<br>(\n|\r)/gi,"<br>"),!1;if(t.nodeType===Node.ELEMENT_NODE){if($(t)){var e=t.parentNode,r=t.previousSibling,i=function P(t,e,r,i){var n,l,a,s,o,d,f,u=navigator.userAgent.toLowerCase();-1!=u.indexOf("safari")&&(u=-1<u.indexOf("chrome")?1:"safari"),t.innerHTML.includes("mso-list:\nIgnore")&&(t.innerHTML=t.innerHTML.replace(/mso-list:\nIgnore/gi,"mso-list:Ignore"));var g,c,p,m,h=/[0-9a-zA-Z]./gi,v="",b=_(t),y=null===(n=D(t).find("ol"))||void 0===n||null===(n=n.attr("style"))||void 0===n||null===(n=n.split(";"))||void 0===n?void 0:n.find(function(t){return t.trim().startsWith("list-style-type")});y==undefined&&F(t)&&(y=null===(c=D(t).find("ul"))||void 0===c||null===(c=c.attr("style"))||void 0===c||null===(c=c.split(";"))||void 0===c?void 0:c.find(function(t){return t.trim().startsWith("list-style-type")}));if(b)d="ol",f=y?"list-style-type: "+y.replace("list-style-type:","").trim()+";":"";else if(F(t))d="ul",f=y?"list-style-type: "+y.replace("list-style-type:","").trim()+";":"";else{var N=t.querySelector('span[style="mso-list:Ignore"]');null==N&&"safari"==u&&(N=t.querySelector('span[lang="PT-BR"]'));var x=!1;N&&(x=x||h.test(N.textContent)),null!==N&&(g=N.textContent.trim().split(".")[0]),d=1==x?(g=(g=N.textContent.trim().split(".")[0]).replace(/\(([^)]+)\)/g,"$1"),isNaN(parseInt(g))?/^(m{0,4}(cm|cd|d?c{0,3})(xc|xl|l?x{0,3})(ix|iv|v?i{0,3}))$/.test(g)?(f="lower-roman;",t.nextElementSibling&&1===t.nextElementSibling.textContent.trim().split(".")[0].length&&(f="lower-alpha;")):/^(M{0,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3}))$/.test(g)?(f="upper-roman;",t.nextElementSibling&&1===t.nextElementSibling.textContent.trim().split(".")[0].length&&(f="upper-alpha;")):"o"==g?f="circle;":g.match(/^v$/)||(g.match(/^[a-z]$/)||g.match(/^[a-z]\)$/)?f="lower-alpha;":(g.match(/^[A-Z]$/)||g.match(/^[A-Z]\)$/))&&(f="upper-alpha;")):f="decimal;",f="list-style-type: "+f,"ol"):(null!=N&&(g=N.textContent.trim().split(".")[0]),"\xa7"==g?f="square;":"\xb7"==g&&(f="disc;"),f="list-style-type: "+f,"ul"),N==undefined||N.textContent==undefined||isNaN(parseInt(N.textContent.trim().split(".")[1],10))||(v=' class="decimal_type" ')}var A=1,C="",E=(k(t),t.style.marginLeft),S="";E.includes("in")?(S="in",E=parseFloat(E)-.5):E.includes("pt")&&(S="px",E=parseFloat(E)-10),E&&(m=" margin-left: "+E+S+";"),A="list-style-type: upper-alpha;"==f?b?parseInt(D(t).find("ol").attr("start")):g.charCodeAt(0)-64:"list-style-type: lower-alpha;"==f?b?parseInt(D(t).find("ol").attr("start")):g.charCodeAt(0)-96:"list-style-type: upper-roman;"==f||"list-style-type: lower-roman;"==f?b?parseInt(D(t).find("ol").attr("start")):function I(t){for(var e={I:1,V:5,X:10,L:50,C:100,D:500,M:1e3,i:1,v:5,x:10,l:50,c:100,d:500,m:1e3},r=0,i=0,n=t.length-1;0<=n;n--){var l=e[t[n]];i<=l?r+=l:r-=l,i=l}return r}(g):b?parseInt(D(t).find("ol").attr("start")):parseInt(g),C+=f||"",C+=m||"",p="<"+d,"none"===t.style.display&&(p+=' class="fr-mso-hidden"'),p+=v||"",p+="ol"!=d||1==A||isNaN(A)?"":' start = "'+A+'"',p+=C?' style = "'+C+'"':"",p+=">";for(var T=!1;t;){if(!$(t)){if(t.outerHTML&&0<t.outerHTML.indexOf("mso-bookmark")&&0==(t.textContent||"").length){t=t.nextElementSibling;continue}break}var L=k(t);if((r=r||L)<L)p+=(o=P(t,e,L,t.style.marginLeft)).el.outerHTML,t=o.currentNode;else{if(L<r)break;t.firstElementChild&&t.firstElementChild.firstElementChild&&t.firstElementChild.firstElementChild.firstChild&&(h.lastIndex=0),a&&a.firstElementChild&&a.firstElementChild.firstElementChild&&a.firstElementChild.firstElementChild.firstChild&&(h.lastIndex=0,l=h.test(a.firstElementChild.firstElementChild.firstChild.data||a.firstElementChild.firstElementChild.firstChild.firstChild&&a.firstElementChild.firstElementChild.firstChild.firstChild.data||""));var w=!1,M=a&&k(a);(!i&&!t.style.marginLeft||i&&t.style.marginLeft&&i===t.style.marginLeft||M&&M===L)&&(w=!0),i=t.style.marginLeft,w||l===undefined?(s=W(t,e),t.nextSibling&&t.nextSibling.innerText!=undefined&&t.nextSibling.innerText!=undefined&&!p.includes('class="decimal_type"')&&(isNaN(parseInt(t.nextSibling.innerText.trim().split(".")[1],10))||(p=p.substring(3,0)+' class="decimal_type"'+p.substring(3,p.length))),p+=s):(1==L&&(p+="</"+d+">",T=!0,a=null),p+=(o=P(t,e,L,t.style.marginLeft)).el.outerHTML,t=o.currentNode);var H=t&&t.nextElementSibling;if(H&&(a=H.previousElementSibling),t&&!$(t)){if(t.outerHTML&&0<t.outerHTML.indexOf("mso-bookmark")&&0==(t.textContent||"").length){t=t.nextElementSibling;continue}break}t&&t.parentNode&&t.parentNode.removeChild(t),t=H}}T||(p+="</"+d+">");var O=document.createElement("div");return O.innerHTML=p,{el:O,currentNode:t}}(t,d).el,n=null;return(n=r?r.nextSibling:e.firstChild)?e.insertBefore(i,n):e.appendChild(i),!1}return"FONT"===t.tagName&&(o&&"LibreOffice"===o[0]||d["."+t.getAttribute("class")])?t=y(t,"span"):o&&"\x3c!--StartFragment--\x3e"===o[0]&&"UL"===t.tagName&&(D(t).find("li span").each(function(){"&nbsp;"===D(this).html()&&(0<D(this).prev().text().trim().length?D(this).remove():D(this).html("&ZeroWidthSpace;"))}),D(t).is("ul")&&t.setAttribute("style",b(t,["margin","margin-left","list-style-type"])),D(t).find("ul").each(function(){this.setAttribute("style",b(this,["margin","margin-left","list-style-type"]))})),"img"!==t.tagName.toLowerCase()&&function s(e){Array.from(e.attributes).map(function(t){return t.name}).filter(function(t){return t.toLowerCase().startsWith("data-")||t.toLowerCase().startsWith("xml:")}).forEach(function(t){D(e).removeAttr(t)})}(t),M(t,d)}if(t.nodeType!==Node.COMMENT_NODE)return!0;if(-1<t.data.indexOf("[if !supportLineBreakNewLine]"))for(var l=t.nextSibling;l;)(l=t.nextSibling)&&S(l),l.data&&-1<l.data.indexOf("[endif]")&&(l=null);if(-1<t.data.indexOf("[if supportFields]")&&-1<t.data.indexOf("FORMCHECKBOX")){var a=document.createElement("input");a.type="checkbox",t.parentNode.insertBefore(a,t.nextSibling)}return S(t),!1}),h=null,v={},n.innerHTML=function c(t){var e=D(document.createElement("div")).attr("id","top-level");e.html(t);for(var r=e[0].querySelectorAll("ol, ul"),i=0;i<r.length;i++)if(D(r[i]).parentsUntil("#top-level","ol, ul").length){r[i].style.removeProperty("margin-left");for(var n=r[i].children,l=0;l<n.length;l++)"LI"==n[l].tagName&&n[l].style.removeProperty("margin-left")}return e[0].innerHTML}(n.innerHTML),m(n,function(t){if(t.nodeType===Node.ELEMENT_NODE){var e=t.tagName;if(!t.innerHTML&&-1===["BR","IMG","INPUT"].indexOf(e)){for(var r=t.parentNode;r&&(S(t),!(t=r).innerHTML)&&"TD"!==t.parentNode.tagName;)r=t.parentNode;return!1}!function u(t){var e=t.getAttribute("style");if(e){(e=L(e))&&";"!==e.slice(-1)&&(e+=";");var r=e.match(/(^|\S+?):.+?;{1,1}/gi);if(r){for(var i={},n=0;n<r.length;n++){var l=r[n].split(":");2===l.length&&("text-align"===l[0]&&"SPAN"===t.tagName||(i[l[0]]=l[1]))}var a="";for(var s in i)if(i.hasOwnProperty(s)){if("font-size"===s&&"pt;"===i[s].slice(-3)){var o=null;try{o=parseFloat(i[s].slice(0,-3),10)}catch(f){o=null}if(o){var d=A.opts.fontSizeUnit;"px"===d?(o=Math.round(1.33*o),i[s]=o+"px;"):"pt"===d&&(o=Math.round(o),i[s]=o+"pt;")}}a+=s+":"+i[s]}a&&t.setAttribute("style",a)}}}(t)}return!0}),m(n,function(t){if(t&&"A"===t.nodeName){if(t.hasAttribute("name")&&t.getAttribute("name").startsWith("_Toc")&&t.parentNode&&(t.parentNode.id=t.getAttribute("name")),""===t.href){for(var e=document.createDocumentFragment();t.firstChild;)e.appendChild(t.firstChild);t.parentNode.replaceChild(e,t)}t.hasAttribute("href")&&t.getAttribute("href").startsWith("#_Toc")&&(t.removeChild(t.lastChild),t.removeChild(t.lastChild))}return!0}),m(n,function(t){return t&&"P"===t.tagName&&"DIV"===t.parentNode.tagName&&1==t.parentNode.children.length&&D(t).unwrap(),!0}),m(n,function(t){if(t&&"SPAN"===t.tagName)for(;t.nextSibling&&t.nextSibling.nodeType===Node.ELEMENT_NODE&&"SPAN"===t.nextSibling.tagName&&t.getAttribute("style")===t.nextSibling.getAttribute("style");)D(t).append(t.nextSibling.innerHTML),D(t.nextSibling).remove();return!0});var s=n.outerHTML,f=A.opts.htmlAllowedStyleProps;return A.opts.htmlAllowedStyleProps=A.opts.wordAllowedStyleProps,s=A.clean.html(s,A.opts.wordDeniedTags,A.opts.wordDeniedAttrs,!1),A.opts.htmlAllowedStyleProps=f,s}return{_init:function t(){A.events.on("paste.wordPaste",function(t){return n=t,A.opts.wordPasteModal?function l(){if(!a){var t='<h4><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.95 73.23" style="height: 25px; vertical-align: text-bottom; margin-right: 5px; display: inline-block"><defs><style>.a{fill:#2a5699;}.b{fill:#fff;}</style></defs><path class="a" d="M615.15,827.22h5.09V834c9.11.05,18.21-.09,27.32.05a2.93,2.93,0,0,1,3.29,3.25c.14,16.77,0,33.56.09,50.33-.09,1.72.17,3.63-.83,5.15-1.24.89-2.85.78-4.3.84-8.52,0-17,0-25.56,0v6.81h-5.32c-13-2.37-26-4.54-38.94-6.81q0-29.8,0-59.59c13.05-2.28,26.11-4.5,39.17-6.83Z" transform="translate(-575.97 -827.22)"/><path class="b" d="M620.24,836.59h28.1v54.49h-28.1v-6.81h22.14v-3.41H620.24v-4.26h22.14V873.2H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24V846h22.14v-3.41H620.24Zm-26.67,15c1.62-.09,3.24-.16,4.85-.25,1.13,5.75,2.29,11.49,3.52,17.21,1-5.91,2-11.8,3.06-17.7,1.7-.06,3.41-.15,5.1-.26-1.92,8.25-3.61,16.57-5.71,24.77-1.42.74-3.55,0-5.24.09-1.13-5.64-2.45-11.24-3.47-16.9-1,5.5-2.29,10.95-3.43,16.42q-2.45-.13-4.92-.3c-1.41-7.49-3.07-14.93-4.39-22.44l4.38-.18c.88,5.42,1.87,10.82,2.64,16.25,1.2-5.57,2.43-11.14,3.62-16.71Z" transform="translate(-575.97 -827.22)"/></svg> '+A.language.translate("Word Paste Detected")+"</h4>",e=function n(){var t='<div class="fr-word-paste-modal" style="padding: 20px 20px 10px 20px;">';return t+='<p style="text-align: left;">'+A.language.translate("The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?")+"</p>",t+='<div style="text-align: right; margin-top: 50px;"><button class="fr-remove-word fr-command">'+A.language.translate("Clean")+'</button> <button class="fr-keep-word fr-command">'+A.language.translate("Keep")+"</button></div>",t+="</div>"}(),r=A.modals.create(s,t,e),i=r.$body;a=r.$modal,r.$modal.addClass("fr-middle"),A.events.bindClick(i,"button.fr-remove-word",function(){var t=a.data("instance")||A;t.wordPaste.clean()}),A.events.bindClick(i,"button.fr-keep-word",function(){var t=a.data("instance")||A;t.wordPaste.clean(!0)}),A.events.$on(D(A.o_win),"resize",function(){A.modals.resize(s)})}A.modals.show(s),A.modals.resize(s)}():e(A.opts.wordPasteKeepFormatting),!1})},clean:e,_wordClean:l}}});

/***/ }),

/***/ 5623:
/***/ (function(module) {

/*
 * International Telephone Input v23.9.3
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */

// UMD
(function(factory) {
  if ( true && module.exports) {
    module.exports = factory();
  } else {
    window.intlTelInput = factory();
  }
}(() => {

var factoryOutput = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // src/js/intl-tel-input/intlTelInputWithUtils.ts
  var intlTelInputWithUtils_exports = {};
  __export(intlTelInputWithUtils_exports, {
    default: () => intlTelInputWithUtils_default
  });

  // src/js/intl-tel-input/data.ts
  var rawCountryData = [
    [
      "af",
      "93"
    ],
    [
      "al",
      "355"
    ],
    [
      "dz",
      "213"
    ],
    [
      "as",
      "1",
      5,
      ["684"]
    ],
    [
      "ad",
      "376"
    ],
    [
      "ao",
      "244"
    ],
    [
      "ai",
      "1",
      6,
      ["264"]
    ],
    [
      "ag",
      "1",
      7,
      ["268"]
    ],
    [
      "ar",
      "54"
    ],
    [
      "am",
      "374"
    ],
    [
      "aw",
      "297"
    ],
    [
      "ac",
      "247"
    ],
    [
      "au",
      "61",
      0
    ],
    [
      "at",
      "43"
    ],
    [
      "az",
      "994"
    ],
    [
      "bs",
      "1",
      8,
      ["242"]
    ],
    [
      "bh",
      "973"
    ],
    [
      "bd",
      "880"
    ],
    [
      "bb",
      "1",
      9,
      ["246"]
    ],
    [
      "by",
      "375"
    ],
    [
      "be",
      "32"
    ],
    [
      "bz",
      "501"
    ],
    [
      "bj",
      "229"
    ],
    [
      "bm",
      "1",
      10,
      ["441"]
    ],
    [
      "bt",
      "975"
    ],
    [
      "bo",
      "591"
    ],
    [
      "ba",
      "387"
    ],
    [
      "bw",
      "267"
    ],
    [
      "br",
      "55"
    ],
    [
      "io",
      "246"
    ],
    [
      "vg",
      "1",
      11,
      ["284"]
    ],
    [
      "bn",
      "673"
    ],
    [
      "bg",
      "359"
    ],
    [
      "bf",
      "226"
    ],
    [
      "bi",
      "257"
    ],
    [
      "kh",
      "855"
    ],
    [
      "cm",
      "237"
    ],
    [
      "ca",
      "1",
      1,
      ["204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "879", "902", "905"]
    ],
    [
      "cv",
      "238"
    ],
    [
      "bq",
      "599",
      1,
      ["3", "4", "7"]
    ],
    [
      "ky",
      "1",
      12,
      ["345"]
    ],
    [
      "cf",
      "236"
    ],
    [
      "td",
      "235"
    ],
    [
      "cl",
      "56"
    ],
    [
      "cn",
      "86"
    ],
    [
      "cx",
      "61",
      2,
      ["89164"]
    ],
    [
      "cc",
      "61",
      1,
      ["89162"]
    ],
    [
      "co",
      "57"
    ],
    [
      "km",
      "269"
    ],
    [
      "cg",
      "242"
    ],
    [
      "cd",
      "243"
    ],
    [
      "ck",
      "682"
    ],
    [
      "cr",
      "506"
    ],
    [
      "ci",
      "225"
    ],
    [
      "hr",
      "385"
    ],
    [
      "cu",
      "53"
    ],
    [
      "cw",
      "599",
      0
    ],
    [
      "cy",
      "357"
    ],
    [
      "cz",
      "420"
    ],
    [
      "dk",
      "45"
    ],
    [
      "dj",
      "253"
    ],
    [
      "dm",
      "1",
      13,
      ["767"]
    ],
    [
      "do",
      "1",
      2,
      ["809", "829", "849"]
    ],
    [
      "ec",
      "593"
    ],
    [
      "eg",
      "20"
    ],
    [
      "sv",
      "503"
    ],
    [
      "gq",
      "240"
    ],
    [
      "er",
      "291"
    ],
    [
      "ee",
      "372"
    ],
    [
      "sz",
      "268"
    ],
    [
      "et",
      "251"
    ],
    [
      "fk",
      "500"
    ],
    [
      "fo",
      "298"
    ],
    [
      "fj",
      "679"
    ],
    [
      "fi",
      "358",
      0
    ],
    [
      "fr",
      "33"
    ],
    [
      "gf",
      "594"
    ],
    [
      "pf",
      "689"
    ],
    [
      "ga",
      "241"
    ],
    [
      "gm",
      "220"
    ],
    [
      "ge",
      "995"
    ],
    [
      "de",
      "49"
    ],
    [
      "gh",
      "233"
    ],
    [
      "gi",
      "350"
    ],
    [
      "gr",
      "30"
    ],
    [
      "gl",
      "299"
    ],
    [
      "gd",
      "1",
      14,
      ["473"]
    ],
    [
      "gp",
      "590",
      0
    ],
    [
      "gu",
      "1",
      15,
      ["671"]
    ],
    [
      "gt",
      "502"
    ],
    [
      "gg",
      "44",
      1,
      ["1481", "7781", "7839", "7911"]
    ],
    [
      "gn",
      "224"
    ],
    [
      "gw",
      "245"
    ],
    [
      "gy",
      "592"
    ],
    [
      "ht",
      "509"
    ],
    [
      "hn",
      "504"
    ],
    [
      "hk",
      "852"
    ],
    [
      "hu",
      "36"
    ],
    [
      "is",
      "354"
    ],
    [
      "in",
      "91"
    ],
    [
      "id",
      "62"
    ],
    [
      "ir",
      "98"
    ],
    [
      "iq",
      "964"
    ],
    [
      "ie",
      "353"
    ],
    [
      "im",
      "44",
      2,
      ["1624", "74576", "7524", "7924", "7624"]
    ],
    [
      "il",
      "972"
    ],
    [
      "it",
      "39",
      0
    ],
    [
      "jm",
      "1",
      4,
      ["876", "658"]
    ],
    [
      "jp",
      "81"
    ],
    [
      "je",
      "44",
      3,
      ["1534", "7509", "7700", "7797", "7829", "7937"]
    ],
    [
      "jo",
      "962"
    ],
    [
      "kz",
      "7",
      1,
      ["33", "7"]
    ],
    [
      "ke",
      "254"
    ],
    [
      "ki",
      "686"
    ],
    [
      "xk",
      "383"
    ],
    [
      "kw",
      "965"
    ],
    [
      "kg",
      "996"
    ],
    [
      "la",
      "856"
    ],
    [
      "lv",
      "371"
    ],
    [
      "lb",
      "961"
    ],
    [
      "ls",
      "266"
    ],
    [
      "lr",
      "231"
    ],
    [
      "ly",
      "218"
    ],
    [
      "li",
      "423"
    ],
    [
      "lt",
      "370"
    ],
    [
      "lu",
      "352"
    ],
    [
      "mo",
      "853"
    ],
    [
      "mg",
      "261"
    ],
    [
      "mw",
      "265"
    ],
    [
      "my",
      "60"
    ],
    [
      "mv",
      "960"
    ],
    [
      "ml",
      "223"
    ],
    [
      "mt",
      "356"
    ],
    [
      "mh",
      "692"
    ],
    [
      "mq",
      "596"
    ],
    [
      "mr",
      "222"
    ],
    [
      "mu",
      "230"
    ],
    [
      "yt",
      "262",
      1,
      ["269", "639"]
    ],
    [
      "mx",
      "52"
    ],
    [
      "fm",
      "691"
    ],
    [
      "md",
      "373"
    ],
    [
      "mc",
      "377"
    ],
    [
      "mn",
      "976"
    ],
    [
      "me",
      "382"
    ],
    [
      "ms",
      "1",
      16,
      ["664"]
    ],
    [
      "ma",
      "212",
      0
    ],
    [
      "mz",
      "258"
    ],
    [
      "mm",
      "95"
    ],
    [
      "na",
      "264"
    ],
    [
      "nr",
      "674"
    ],
    [
      "np",
      "977"
    ],
    [
      "nl",
      "31"
    ],
    [
      "nc",
      "687"
    ],
    [
      "nz",
      "64"
    ],
    [
      "ni",
      "505"
    ],
    [
      "ne",
      "227"
    ],
    [
      "ng",
      "234"
    ],
    [
      "nu",
      "683"
    ],
    [
      "nf",
      "672"
    ],
    [
      "kp",
      "850"
    ],
    [
      "mk",
      "389"
    ],
    [
      "mp",
      "1",
      17,
      ["670"]
    ],
    [
      "no",
      "47",
      0
    ],
    [
      "om",
      "968"
    ],
    [
      "pk",
      "92"
    ],
    [
      "pw",
      "680"
    ],
    [
      "ps",
      "970"
    ],
    [
      "pa",
      "507"
    ],
    [
      "pg",
      "675"
    ],
    [
      "py",
      "595"
    ],
    [
      "pe",
      "51"
    ],
    [
      "ph",
      "63"
    ],
    [
      "pl",
      "48"
    ],
    [
      "pt",
      "351"
    ],
    [
      "pr",
      "1",
      3,
      ["787", "939"]
    ],
    [
      "qa",
      "974"
    ],
    [
      "re",
      "262",
      0
    ],
    [
      "ro",
      "40"
    ],
    [
      "ru",
      "7",
      0
    ],
    [
      "rw",
      "250"
    ],
    [
      "ws",
      "685"
    ],
    [
      "sm",
      "378"
    ],
    [
      "st",
      "239"
    ],
    [
      "sa",
      "966"
    ],
    [
      "sn",
      "221"
    ],
    [
      "rs",
      "381"
    ],
    [
      "sc",
      "248"
    ],
    [
      "sl",
      "232"
    ],
    [
      "sg",
      "65"
    ],
    [
      "sx",
      "1",
      21,
      ["721"]
    ],
    [
      "sk",
      "421"
    ],
    [
      "si",
      "386"
    ],
    [
      "sb",
      "677"
    ],
    [
      "so",
      "252"
    ],
    [
      "za",
      "27"
    ],
    [
      "kr",
      "82"
    ],
    [
      "ss",
      "211"
    ],
    [
      "es",
      "34"
    ],
    [
      "lk",
      "94"
    ],
    [
      "bl",
      "590",
      1
    ],
    [
      "sh",
      "290"
    ],
    [
      "kn",
      "1",
      18,
      ["869"]
    ],
    [
      "lc",
      "1",
      19,
      ["758"]
    ],
    [
      "mf",
      "590",
      2
    ],
    [
      "pm",
      "508"
    ],
    [
      "vc",
      "1",
      20,
      ["784"]
    ],
    [
      "sd",
      "249"
    ],
    [
      "sr",
      "597"
    ],
    [
      "sj",
      "47",
      1,
      ["79"]
    ],
    [
      "se",
      "46"
    ],
    [
      "ch",
      "41"
    ],
    [
      "sy",
      "963"
    ],
    [
      "tw",
      "886"
    ],
    [
      "tj",
      "992"
    ],
    [
      "tz",
      "255"
    ],
    [
      "th",
      "66"
    ],
    [
      "tl",
      "670"
    ],
    [
      "tg",
      "228"
    ],
    [
      "tk",
      "690"
    ],
    [
      "to",
      "676"
    ],
    [
      "tt",
      "1",
      22,
      ["868"]
    ],
    [
      "tn",
      "216"
    ],
    [
      "tr",
      "90"
    ],
    [
      "tm",
      "993"
    ],
    [
      "tc",
      "1",
      23,
      ["649"]
    ],
    [
      "tv",
      "688"
    ],
    [
      "ug",
      "256"
    ],
    [
      "ua",
      "380"
    ],
    [
      "ae",
      "971"
    ],
    [
      "gb",
      "44",
      0
    ],
    [
      "us",
      "1",
      0
    ],
    [
      "uy",
      "598"
    ],
    [
      "vi",
      "1",
      24,
      ["340"]
    ],
    [
      "uz",
      "998"
    ],
    [
      "vu",
      "678"
    ],
    [
      "va",
      "39",
      1,
      ["06698"]
    ],
    [
      "ve",
      "58"
    ],
    [
      "vn",
      "84"
    ],
    [
      "wf",
      "681"
    ],
    [
      "eh",
      "212",
      1,
      ["5288", "5289"]
    ],
    [
      "ye",
      "967"
    ],
    [
      "zm",
      "260"
    ],
    [
      "zw",
      "263"
    ],
    [
      "ax",
      "358",
      1,
      ["18"]
    ]
  ];
  var allCountries = [];
  for (let i = 0; i < rawCountryData.length; i++) {
    const c = rawCountryData[i];
    allCountries[i] = {
      name: "",
      // this is now populated in the plugin
      iso2: c[0],
      dialCode: c[1],
      priority: c[2] || 0,
      areaCodes: c[3] || null,
      nodeById: {}
    };
  }
  var data_default = allCountries;

  // src/js/intl-tel-input/i18n/en/countries.ts
  var countryTranslations = {
    ad: "Andorra",
    ae: "United Arab Emirates",
    af: "Afghanistan",
    ag: "Antigua & Barbuda",
    ai: "Anguilla",
    al: "Albania",
    am: "Armenia",
    ao: "Angola",
    ar: "Argentina",
    as: "American Samoa",
    at: "Austria",
    au: "Australia",
    aw: "Aruba",
    ax: "\xC5land Islands",
    az: "Azerbaijan",
    ba: "Bosnia & Herzegovina",
    bb: "Barbados",
    bd: "Bangladesh",
    be: "Belgium",
    bf: "Burkina Faso",
    bg: "Bulgaria",
    bh: "Bahrain",
    bi: "Burundi",
    bj: "Benin",
    bl: "St. Barth\xE9lemy",
    bm: "Bermuda",
    bn: "Brunei",
    bo: "Bolivia",
    bq: "Caribbean Netherlands",
    br: "Brazil",
    bs: "Bahamas",
    bt: "Bhutan",
    bw: "Botswana",
    by: "Belarus",
    bz: "Belize",
    ca: "Canada",
    cc: "Cocos (Keeling) Islands",
    cd: "Congo - Kinshasa",
    cf: "Central African Republic",
    cg: "Congo - Brazzaville",
    ch: "Switzerland",
    ci: "C\xF4te d\u2019Ivoire",
    ck: "Cook Islands",
    cl: "Chile",
    cm: "Cameroon",
    cn: "China",
    co: "Colombia",
    cr: "Costa Rica",
    cu: "Cuba",
    cv: "Cape Verde",
    cw: "Cura\xE7ao",
    cx: "Christmas Island",
    cy: "Cyprus",
    cz: "Czechia",
    de: "Germany",
    dj: "Djibouti",
    dk: "Denmark",
    dm: "Dominica",
    do: "Dominican Republic",
    dz: "Algeria",
    ec: "Ecuador",
    ee: "Estonia",
    eg: "Egypt",
    eh: "Western Sahara",
    er: "Eritrea",
    es: "Spain",
    et: "Ethiopia",
    fi: "Finland",
    fj: "Fiji",
    fk: "Falkland Islands",
    fm: "Micronesia",
    fo: "Faroe Islands",
    fr: "France",
    ga: "Gabon",
    gb: "United Kingdom",
    gd: "Grenada",
    ge: "Georgia",
    gf: "French Guiana",
    gg: "Guernsey",
    gh: "Ghana",
    gi: "Gibraltar",
    gl: "Greenland",
    gm: "Gambia",
    gn: "Guinea",
    gp: "Guadeloupe",
    gq: "Equatorial Guinea",
    gr: "Greece",
    gt: "Guatemala",
    gu: "Guam",
    gw: "Guinea-Bissau",
    gy: "Guyana",
    hk: "Hong Kong SAR China",
    hn: "Honduras",
    hr: "Croatia",
    ht: "Haiti",
    hu: "Hungary",
    id: "Indonesia",
    ie: "Ireland",
    il: "Israel",
    im: "Isle of Man",
    in: "India",
    io: "British Indian Ocean Territory",
    iq: "Iraq",
    ir: "Iran",
    is: "Iceland",
    it: "Italy",
    je: "Jersey",
    jm: "Jamaica",
    jo: "Jordan",
    jp: "Japan",
    ke: "Kenya",
    kg: "Kyrgyzstan",
    kh: "Cambodia",
    ki: "Kiribati",
    km: "Comoros",
    kn: "St. Kitts & Nevis",
    kp: "North Korea",
    kr: "South Korea",
    kw: "Kuwait",
    ky: "Cayman Islands",
    kz: "Kazakhstan",
    la: "Laos",
    lb: "Lebanon",
    lc: "St. Lucia",
    li: "Liechtenstein",
    lk: "Sri Lanka",
    lr: "Liberia",
    ls: "Lesotho",
    lt: "Lithuania",
    lu: "Luxembourg",
    lv: "Latvia",
    ly: "Libya",
    ma: "Morocco",
    mc: "Monaco",
    md: "Moldova",
    me: "Montenegro",
    mf: "St. Martin",
    mg: "Madagascar",
    mh: "Marshall Islands",
    mk: "North Macedonia",
    ml: "Mali",
    mm: "Myanmar (Burma)",
    mn: "Mongolia",
    mo: "Macao SAR China",
    mp: "Northern Mariana Islands",
    mq: "Martinique",
    mr: "Mauritania",
    ms: "Montserrat",
    mt: "Malta",
    mu: "Mauritius",
    mv: "Maldives",
    mw: "Malawi",
    mx: "Mexico",
    my: "Malaysia",
    mz: "Mozambique",
    na: "Namibia",
    nc: "New Caledonia",
    ne: "Niger",
    nf: "Norfolk Island",
    ng: "Nigeria",
    ni: "Nicaragua",
    nl: "Netherlands",
    no: "Norway",
    np: "Nepal",
    nr: "Nauru",
    nu: "Niue",
    nz: "New Zealand",
    om: "Oman",
    pa: "Panama",
    pe: "Peru",
    pf: "French Polynesia",
    pg: "Papua New Guinea",
    ph: "Philippines",
    pk: "Pakistan",
    pl: "Poland",
    pm: "St. Pierre & Miquelon",
    pr: "Puerto Rico",
    ps: "Palestinian Territories",
    pt: "Portugal",
    pw: "Palau",
    py: "Paraguay",
    qa: "Qatar",
    re: "R\xE9union",
    ro: "Romania",
    rs: "Serbia",
    ru: "Russia",
    rw: "Rwanda",
    sa: "Saudi Arabia",
    sb: "Solomon Islands",
    sc: "Seychelles",
    sd: "Sudan",
    se: "Sweden",
    sg: "Singapore",
    sh: "St. Helena",
    si: "Slovenia",
    sj: "Svalbard & Jan Mayen",
    sk: "Slovakia",
    sl: "Sierra Leone",
    sm: "San Marino",
    sn: "Senegal",
    so: "Somalia",
    sr: "Suriname",
    ss: "South Sudan",
    st: "S\xE3o Tom\xE9 & Pr\xEDncipe",
    sv: "El Salvador",
    sx: "Sint Maarten",
    sy: "Syria",
    sz: "Eswatini",
    tc: "Turks & Caicos Islands",
    td: "Chad",
    tg: "Togo",
    th: "Thailand",
    tj: "Tajikistan",
    tk: "Tokelau",
    tl: "Timor-Leste",
    tm: "Turkmenistan",
    tn: "Tunisia",
    to: "Tonga",
    tr: "Turkey",
    tt: "Trinidad & Tobago",
    tv: "Tuvalu",
    tw: "Taiwan",
    tz: "Tanzania",
    ua: "Ukraine",
    ug: "Uganda",
    us: "United States",
    uy: "Uruguay",
    uz: "Uzbekistan",
    va: "Vatican City",
    vc: "St. Vincent & Grenadines",
    ve: "Venezuela",
    vg: "British Virgin Islands",
    vi: "U.S. Virgin Islands",
    vn: "Vietnam",
    vu: "Vanuatu",
    wf: "Wallis & Futuna",
    ws: "Samoa",
    ye: "Yemen",
    yt: "Mayotte",
    za: "South Africa",
    zm: "Zambia",
    zw: "Zimbabwe"
  };
  var countries_default = countryTranslations;

  // src/js/intl-tel-input/i18n/en/interface.ts
  var interfaceTranslations = {
    selectedCountryAriaLabel: "Selected country",
    noCountrySelected: "No country selected",
    countryListAriaLabel: "List of countries",
    searchPlaceholder: "Search",
    zeroSearchResults: "No results found",
    oneSearchResult: "1 result found",
    multipleSearchResults: "${count} results found",
    // additional countries (not supported by country-list library)
    ac: "Ascension Island",
    xk: "Kosovo"
  };
  var interface_default = interfaceTranslations;

  // src/js/intl-tel-input/i18n/en/index.ts
  var allTranslations = { ...countries_default, ...interface_default };
  var en_default = allTranslations;

  // src/js/intl-tel-input.ts
  for (let i = 0; i < data_default.length; i++) {
    data_default[i].name = en_default[data_default[i].iso2];
  }
  var id = 0;
  var defaults = {
    //* Whether or not to allow the dropdown.
    allowDropdown: true,
    //* Add a placeholder in the input with an example number for the selected country.
    autoPlaceholder: "polite",
    //* Modify the parentClass.
    containerClass: "",
    //* The order of the countries in the dropdown. Defaults to alphabetical.
    countryOrder: null,
    //* Add a country search input at the top of the dropdown.
    countrySearch: true,
    //* Modify the auto placeholder.
    customPlaceholder: null,
    //* Append menu to specified element.
    dropdownContainer: null,
    //* Don't display these countries.
    excludeCountries: [],
    //* Fix the dropdown width to the input width (rather than being as wide as the longest country name).
    fixDropdownWidth: true,
    //* Format the number as the user types
    formatAsYouType: true,
    //* Format the input value during initialisation and on setNumber.
    formatOnDisplay: true,
    //* geoIp lookup function.
    geoIpLookup: null,
    //* Inject a hidden input with the name returned from this function, and on submit, populate it with the result of getNumber.
    hiddenInput: null,
    //* Internationalise the plugin text e.g. search input placeholder, country names.
    i18n: {},
    //* Initial country.
    initialCountry: "",
    //* National vs international formatting for numbers e.g. placeholders and displaying existing numbers.
    nationalMode: true,
    //* Display only these countries.
    onlyCountries: [],
    //* Number type to use for placeholders.
    placeholderNumberType: "MOBILE",
    //* Show flags - for both the selected country, and in the country dropdown
    showFlags: true,
    //* Display the international dial code next to the selected flag.
    separateDialCode: false,
    //* Only allow certain chars e.g. a plus followed by numeric digits, and cap at max valid length.
    strictMode: false,
    //* Use full screen popup instead of dropdown for country list.
    useFullscreenPopup: typeof navigator !== "undefined" && typeof window !== "undefined" ? (
      //* We cannot just test screen size as some smartphones/website meta tags will report desktop resolutions.
      //* Note: to target Android Mobiles (and not Tablets), we must find 'Android' and 'Mobile'
      /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) || window.innerWidth <= 500
    ) : false,
    //* Specify the path to the libphonenumber script to enable validation/formatting.
    utilsScript: "",
    //* The number type to enforce during validation.
    validationNumberType: "MOBILE"
  };
  var regionlessNanpNumbers = [
    "800",
    "822",
    "833",
    "844",
    "855",
    "866",
    "877",
    "880",
    "881",
    "882",
    "883",
    "884",
    "885",
    "886",
    "887",
    "888",
    "889"
  ];
  var getNumeric = (s) => s.replace(/\D/g, "");
  var normaliseString = (s = "") => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  var isRegionlessNanp = (number) => {
    const numeric = getNumeric(number);
    if (numeric.charAt(0) === "1") {
      const areaCode = numeric.substr(1, 3);
      return regionlessNanpNumbers.indexOf(areaCode) !== -1;
    }
    return false;
  };
  var translateCursorPosition = (relevantChars, formattedValue, prevCaretPos, isDeleteForwards) => {
    if (prevCaretPos === 0 && !isDeleteForwards) {
      return 0;
    }
    let count = 0;
    for (let i = 0; i < formattedValue.length; i++) {
      if (/[+0-9]/.test(formattedValue[i])) {
        count++;
      }
      if (count === relevantChars && !isDeleteForwards) {
        return i + 1;
      }
      if (isDeleteForwards && count === relevantChars + 1) {
        return i;
      }
    }
    return formattedValue.length;
  };
  var createEl = (name, attrs, container) => {
    const el = document.createElement(name);
    if (attrs) {
      Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
    }
    if (container) {
      container.appendChild(el);
    }
    return el;
  };
  var forEachInstance = (method) => {
    const { instances } = intlTelInput;
    Object.values(instances).forEach((instance) => instance[method]());
  };
  var Iti = class {
    constructor(input, customOptions = {}) {
      this.id = id++;
      this.telInput = input;
      this.highlightedItem = null;
      this.options = Object.assign({}, defaults, customOptions);
      this.hadInitialPlaceholder = Boolean(input.getAttribute("placeholder"));
    }
    //* Can't be private as it's called from intlTelInput convenience wrapper.
    _init() {
      if (this.options.useFullscreenPopup) {
        this.options.fixDropdownWidth = false;
      }
      if (this.options.separateDialCode) {
        this.options.allowDropdown = true;
        this.options.nationalMode = false;
        this.options.countrySearch = true;
      }
      if (!this.options.showFlags && !this.options.separateDialCode) {
        this.options.nationalMode = false;
      }
      if (this.options.useFullscreenPopup && !this.options.dropdownContainer) {
        this.options.dropdownContainer = document.body;
      }
      this.isAndroid = typeof navigator !== "undefined" ? /Android/i.test(navigator.userAgent) : false;
      this.isRTL = !!this.telInput.closest("[dir=rtl]");
      if (this.options.separateDialCode) {
        if (this.isRTL) {
          this.originalPaddingRight = this.telInput.style.paddingRight;
        } else {
          this.originalPaddingLeft = this.telInput.style.paddingLeft;
        }
      }
      this.options.i18n = { ...en_default, ...this.options.i18n };
      const autoCountryPromise = new Promise((resolve, reject) => {
        this.resolveAutoCountryPromise = resolve;
        this.rejectAutoCountryPromise = reject;
      });
      const utilsScriptPromise = new Promise((resolve, reject) => {
        this.resolveUtilsScriptPromise = resolve;
        this.rejectUtilsScriptPromise = reject;
      });
      this.promise = Promise.all([autoCountryPromise, utilsScriptPromise]);
      this.selectedCountryData = {};
      this._processCountryData();
      this._generateMarkup();
      this._setInitialState();
      this._initListeners();
      this._initRequests();
    }
    //********************
    //*  PRIVATE METHODS
    //********************
    //* Prepare all of the country data, including onlyCountries, excludeCountries, countryOrder options.
    _processCountryData() {
      this._processAllCountries();
      this._processDialCodes();
      this._translateCountryNames();
      this._sortCountries();
    }
    //* Sort countries by countryOrder option (if present), then name.
    _sortCountries() {
      if (this.options.countryOrder) {
        this.options.countryOrder = this.options.countryOrder.map((country) => country.toLowerCase());
      }
      this.countries.sort((a, b) => {
        const { countryOrder } = this.options;
        if (countryOrder) {
          const aIndex = countryOrder.indexOf(a.iso2);
          const bIndex = countryOrder.indexOf(b.iso2);
          const aIndexExists = aIndex > -1;
          const bIndexExists = bIndex > -1;
          if (aIndexExists || bIndexExists) {
            if (aIndexExists && bIndexExists) {
              return aIndex - bIndex;
            }
            return aIndexExists ? -1 : 1;
          }
        }
        return a.name.localeCompare(b.name);
      });
    }
    //* Add a dial code to this.dialCodeToIso2Map.
    _addToDialCodeMap(iso2, dialCode, priority) {
      if (dialCode.length > this.dialCodeMaxLen) {
        this.dialCodeMaxLen = dialCode.length;
      }
      if (!this.dialCodeToIso2Map.hasOwnProperty(dialCode)) {
        this.dialCodeToIso2Map[dialCode] = [];
      }
      for (let i = 0; i < this.dialCodeToIso2Map[dialCode].length; i++) {
        if (this.dialCodeToIso2Map[dialCode][i] === iso2) {
          return;
        }
      }
      const index = priority !== void 0 ? priority : this.dialCodeToIso2Map[dialCode].length;
      this.dialCodeToIso2Map[dialCode][index] = iso2;
    }
    //* Process onlyCountries or excludeCountries array if present.
    _processAllCountries() {
      const { onlyCountries, excludeCountries } = this.options;
      if (onlyCountries.length) {
        const lowerCaseOnlyCountries = onlyCountries.map(
          (country) => country.toLowerCase()
        );
        this.countries = data_default.filter(
          (country) => lowerCaseOnlyCountries.indexOf(country.iso2) > -1
        );
      } else if (excludeCountries.length) {
        const lowerCaseExcludeCountries = excludeCountries.map(
          (country) => country.toLowerCase()
        );
        this.countries = data_default.filter(
          (country) => lowerCaseExcludeCountries.indexOf(country.iso2) === -1
        );
      } else {
        this.countries = data_default;
      }
    }
    //* Translate Countries by object literal provided on config.
    _translateCountryNames() {
      for (let i = 0; i < this.countries.length; i++) {
        const iso2 = this.countries[i].iso2.toLowerCase();
        if (this.options.i18n.hasOwnProperty(iso2)) {
          this.countries[i].name = this.options.i18n[iso2];
        }
      }
    }
    //* Generate this.dialCodes and this.dialCodeToIso2Map.
    _processDialCodes() {
      this.dialCodes = {};
      this.dialCodeMaxLen = 0;
      this.dialCodeToIso2Map = {};
      for (let i = 0; i < this.countries.length; i++) {
        const c = this.countries[i];
        if (!this.dialCodes[c.dialCode]) {
          this.dialCodes[c.dialCode] = true;
        }
        this._addToDialCodeMap(c.iso2, c.dialCode, c.priority);
      }
      for (let i = 0; i < this.countries.length; i++) {
        const c = this.countries[i];
        if (c.areaCodes) {
          const rootIso2Code = this.dialCodeToIso2Map[c.dialCode][0];
          for (let j = 0; j < c.areaCodes.length; j++) {
            const areaCode = c.areaCodes[j];
            for (let k = 1; k < areaCode.length; k++) {
              const partialDialCode = c.dialCode + areaCode.substr(0, k);
              this._addToDialCodeMap(rootIso2Code, partialDialCode);
              this._addToDialCodeMap(c.iso2, partialDialCode);
            }
            this._addToDialCodeMap(c.iso2, c.dialCode + areaCode);
          }
        }
      }
    }
    //* Generate all of the markup for the plugin: the selected country overlay, and the dropdown.
    _generateMarkup() {
      this.telInput.classList.add("iti__tel-input");
      if (!this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete"))) {
        this.telInput.setAttribute("autocomplete", "off");
      }
      const {
        allowDropdown,
        separateDialCode,
        showFlags,
        containerClass,
        hiddenInput,
        dropdownContainer,
        fixDropdownWidth,
        useFullscreenPopup,
        countrySearch,
        i18n
      } = this.options;
      let parentClass = "iti";
      if (allowDropdown) {
        parentClass += " iti--allow-dropdown";
      }
      if (showFlags) {
        parentClass += " iti--show-flags";
      }
      if (containerClass) {
        parentClass += ` ${containerClass}`;
      }
      if (!useFullscreenPopup) {
        parentClass += " iti--inline-dropdown";
      }
      const wrapper = createEl("div", { class: parentClass });
      this.telInput.parentNode?.insertBefore(wrapper, this.telInput);
      if (allowDropdown || showFlags) {
        this.countryContainer = createEl(
          "div",
          { class: "iti__country-container" },
          wrapper
        );
        if (allowDropdown) {
          this.selectedCountry = createEl(
            "button",
            {
              type: "button",
              class: "iti__selected-country",
              "aria-expanded": "false",
              "aria-label": this.options.i18n.selectedCountryAriaLabel,
              "aria-haspopup": "true",
              "aria-controls": `iti-${this.id}__dropdown-content`,
              "role": "combobox"
            },
            this.countryContainer
          );
          if (this.telInput.disabled) {
            this.selectedCountry.setAttribute("disabled", "true");
          }
        } else {
          this.selectedCountry = createEl(
            "div",
            { class: "iti__selected-country" },
            this.countryContainer
          );
        }
        const selectedCountryPrimary = createEl("div", { class: "iti__selected-country-primary" }, this.selectedCountry);
        this.selectedCountryInner = createEl("div", { class: "iti__flag" }, selectedCountryPrimary);
        this.selectedCountryA11yText = createEl(
          "span",
          { class: "iti__a11y-text" },
          this.selectedCountryInner
        );
        if (allowDropdown) {
          this.dropdownArrow = createEl(
            "div",
            { class: "iti__arrow", "aria-hidden": "true" },
            selectedCountryPrimary
          );
        }
        if (separateDialCode) {
          this.selectedDialCode = createEl(
            "div",
            { class: "iti__selected-dial-code" },
            this.selectedCountry
          );
        }
        if (allowDropdown) {
          const extraClasses = fixDropdownWidth ? "" : "iti--flexible-dropdown-width";
          this.dropdownContent = createEl("div", {
            id: `iti-${this.id}__dropdown-content`,
            class: `iti__dropdown-content iti__hide ${extraClasses}`
          });
          if (countrySearch) {
            this.searchInput = createEl(
              "input",
              {
                type: "text",
                class: "iti__search-input",
                placeholder: i18n.searchPlaceholder,
                role: "combobox",
                "aria-expanded": "true",
                "aria-label": i18n.searchPlaceholder,
                "aria-controls": `iti-${this.id}__country-listbox`,
                "aria-autocomplete": "list",
                "autocomplete": "off"
              },
              this.dropdownContent
            );
            this.searchResultsA11yText = createEl(
              "span",
              { class: "iti__a11y-text" },
              this.dropdownContent
            );
          }
          this.countryList = createEl(
            "ul",
            {
              class: "iti__country-list",
              id: `iti-${this.id}__country-listbox`,
              role: "listbox",
              "aria-label": i18n.countryListAriaLabel
            },
            this.dropdownContent
          );
          this._appendListItems();
          if (countrySearch) {
            this._updateSearchResultsText();
          }
          if (dropdownContainer) {
            let dropdownClasses = "iti iti--container";
            if (useFullscreenPopup) {
              dropdownClasses += " iti--fullscreen-popup";
            } else {
              dropdownClasses += " iti--inline-dropdown";
            }
            this.dropdown = createEl("div", { class: dropdownClasses });
            this.dropdown.appendChild(this.dropdownContent);
          } else {
            this.countryContainer.appendChild(this.dropdownContent);
          }
        }
      }
      wrapper.appendChild(this.telInput);
      if (hiddenInput) {
        const telInputName = this.telInput.getAttribute("name") || "";
        const names = hiddenInput(telInputName);
        if (names.phone) {
          this.hiddenInput = createEl("input", {
            type: "hidden",
            name: names.phone
          });
          wrapper.appendChild(this.hiddenInput);
        }
        if (names.country) {
          this.hiddenInputCountry = createEl("input", {
            type: "hidden",
            name: names.country
          });
          wrapper.appendChild(this.hiddenInputCountry);
        }
      }
    }
    //* For each country: add a country list item <li> to the countryList <ul> container.
    _appendListItems() {
      for (let i = 0; i < this.countries.length; i++) {
        const c = this.countries[i];
        const extraClass = i === 0 ? "iti__highlight" : "";
        const listItem = createEl(
          "li",
          {
            id: `iti-${this.id}__item-${c.iso2}`,
            class: `iti__country ${extraClass}`,
            tabindex: "-1",
            role: "option",
            "data-dial-code": c.dialCode,
            "data-country-code": c.iso2,
            "aria-selected": "false"
          },
          this.countryList
        );
        c.nodeById[this.id] = listItem;
        let content = "";
        if (this.options.showFlags) {
          content += `<div class='iti__flag-box'><div class='iti__flag iti__${c.iso2}'></div></div>`;
        }
        content += `<span class='iti__country-name'>${c.name}</span>`;
        content += `<span class='iti__dial-code'>+${c.dialCode}</span>`;
        listItem.insertAdjacentHTML("beforeend", content);
      }
    }
    //* Set the initial state of the input value and the selected country by:
    //* 1. Extracting a dial code from the given number
    //* 2. Using explicit initialCountry
    _setInitialState(overrideAutoCountry = false) {
      const attributeValue = this.telInput.getAttribute("value");
      const inputValue = this.telInput.value;
      const useAttribute = attributeValue && attributeValue.charAt(0) === "+" && (!inputValue || inputValue.charAt(0) !== "+");
      const val = useAttribute ? attributeValue : inputValue;
      const dialCode = this._getDialCode(val);
      const isRegionlessNanpNumber = isRegionlessNanp(val);
      const { initialCountry, geoIpLookup } = this.options;
      const isAutoCountry = initialCountry === "auto" && geoIpLookup;
      if (dialCode && !isRegionlessNanpNumber) {
        this._updateCountryFromNumber(val);
      } else if (!isAutoCountry || overrideAutoCountry) {
        const lowerInitialCountry = initialCountry ? initialCountry.toLowerCase() : "";
        const isValidInitialCountry = lowerInitialCountry && this._getCountryData(lowerInitialCountry, true);
        if (isValidInitialCountry) {
          this._setCountry(lowerInitialCountry);
        } else {
          if (dialCode && isRegionlessNanpNumber) {
            this._setCountry("us");
          } else {
            this._setCountry();
          }
        }
      }
      if (val) {
        this._updateValFromNumber(val);
      }
    }
    //* Initialise the main event listeners: input keyup, and click selected country.
    _initListeners() {
      this._initTelInputListeners();
      if (this.options.allowDropdown) {
        this._initDropdownListeners();
      }
      if ((this.hiddenInput || this.hiddenInputCountry) && this.telInput.form) {
        this._initHiddenInputListener();
      }
    }
    //* Update hidden input on form submit.
    _initHiddenInputListener() {
      this._handleHiddenInputSubmit = () => {
        if (this.hiddenInput) {
          this.hiddenInput.value = this.getNumber();
        }
        if (this.hiddenInputCountry) {
          this.hiddenInputCountry.value = this.getSelectedCountryData().iso2 || "";
        }
      };
      this.telInput.form?.addEventListener(
        "submit",
        this._handleHiddenInputSubmit
      );
    }
    //* initialise the dropdown listeners.
    _initDropdownListeners() {
      this._handleLabelClick = (e) => {
        if (this.dropdownContent.classList.contains("iti__hide")) {
          this.telInput.focus();
        } else {
          e.preventDefault();
        }
      };
      const label = this.telInput.closest("label");
      if (label) {
        label.addEventListener("click", this._handleLabelClick);
      }
      this._handleClickSelectedCountry = () => {
        if (this.dropdownContent.classList.contains("iti__hide") && !this.telInput.disabled && !this.telInput.readOnly) {
          this._openDropdown();
        }
      };
      this.selectedCountry.addEventListener("click", this._handleClickSelectedCountry);
      this._handleCountryContainerKeydown = (e) => {
        const isDropdownHidden = this.dropdownContent.classList.contains("iti__hide");
        if (isDropdownHidden && ["ArrowUp", "ArrowDown", " ", "Enter"].includes(e.key)) {
          e.preventDefault();
          e.stopPropagation();
          this._openDropdown();
        }
        if (e.key === "Tab") {
          this._closeDropdown();
        }
      };
      this.countryContainer.addEventListener(
        "keydown",
        this._handleCountryContainerKeydown
      );
    }
    //* Init many requests: utils script / geo ip lookup.
    _initRequests() {
      const { utilsScript, initialCountry, geoIpLookup } = this.options;
      if (utilsScript && !intlTelInput.utils) {
        if (intlTelInput.documentReady()) {
          intlTelInput.loadUtils(utilsScript);
        } else {
          window.addEventListener("load", () => {
            intlTelInput.loadUtils(utilsScript);
          });
        }
      } else {
        this.resolveUtilsScriptPromise();
      }
      const isAutoCountry = initialCountry === "auto" && geoIpLookup;
      if (isAutoCountry && !this.selectedCountryData.iso2) {
        this._loadAutoCountry();
      } else {
        this.resolveAutoCountryPromise();
      }
    }
    //* Perform the geo ip lookup.
    _loadAutoCountry() {
      if (intlTelInput.autoCountry) {
        this.handleAutoCountry();
      } else if (!intlTelInput.startedLoadingAutoCountry) {
        intlTelInput.startedLoadingAutoCountry = true;
        if (typeof this.options.geoIpLookup === "function") {
          this.options.geoIpLookup(
            (iso2 = "") => {
              const iso2Lower = iso2.toLowerCase();
              const isValidIso2 = iso2Lower && this._getCountryData(iso2Lower, true);
              if (isValidIso2) {
                intlTelInput.autoCountry = iso2Lower;
                setTimeout(() => forEachInstance("handleAutoCountry"));
              } else {
                this._setInitialState(true);
                forEachInstance("rejectAutoCountryPromise");
              }
            },
            () => {
              this._setInitialState(true);
              forEachInstance("rejectAutoCountryPromise");
            }
          );
        }
      }
    }
    //* Initialize the tel input listeners.
    _initTelInputListeners() {
      const { strictMode, formatAsYouType, separateDialCode, formatOnDisplay } = this.options;
      let userOverrideFormatting = false;
      if (/\p{L}/u.test(this.telInput.value)) {
        userOverrideFormatting = true;
      }
      const openDropdownWithPlus = () => {
        this._openDropdown();
        this.searchInput.value = "+";
        this._filterCountries("", true);
      };
      this._handleInputEvent = (e) => {
        if (this.isAndroid && e?.data === "+" && separateDialCode) {
          const currentCaretPos = this.telInput.selectionStart || 0;
          const valueBeforeCaret = this.telInput.value.substring(0, currentCaretPos - 1);
          const valueAfterCaret = this.telInput.value.substring(currentCaretPos);
          this.telInput.value = valueBeforeCaret + valueAfterCaret;
          openDropdownWithPlus();
          return;
        }
        if (this._updateCountryFromNumber(this.telInput.value)) {
          this._triggerCountryChange();
        }
        const isFormattingChar = e?.data && /[^+0-9]/.test(e.data);
        const isPaste = e?.inputType === "insertFromPaste" && this.telInput.value;
        if (isFormattingChar || isPaste && !strictMode) {
          userOverrideFormatting = true;
        } else if (!/[^+0-9]/.test(this.telInput.value)) {
          userOverrideFormatting = false;
        }
        const disableFormatOnSetNumber = e?.detail && e.detail["isSetNumber"] && !formatOnDisplay;
        if (formatAsYouType && !userOverrideFormatting && !disableFormatOnSetNumber) {
          const currentCaretPos = this.telInput.selectionStart || 0;
          const valueBeforeCaret = this.telInput.value.substring(0, currentCaretPos);
          const relevantCharsBeforeCaret = valueBeforeCaret.replace(/[^+0-9]/g, "").length;
          const isDeleteForwards = e?.inputType === "deleteContentForward";
          const formattedValue = this._formatNumberAsYouType();
          const newCaretPos = translateCursorPosition(relevantCharsBeforeCaret, formattedValue, currentCaretPos, isDeleteForwards);
          this.telInput.value = formattedValue;
          this.telInput.setSelectionRange(newCaretPos, newCaretPos);
        }
      };
      this.telInput.addEventListener("input", this._handleInputEvent);
      if (strictMode || separateDialCode) {
        this._handleKeydownEvent = (e) => {
          if (e.key && e.key.length === 1 && !e.altKey && !e.ctrlKey && !e.metaKey) {
            if (separateDialCode && e.key === "+") {
              e.preventDefault();
              openDropdownWithPlus();
              return;
            }
            if (strictMode) {
              const isInitialPlus = this.telInput.selectionStart === 0 && e.key === "+";
              const isNumeric = /^[0-9]$/.test(e.key);
              const isAllowedChar = isInitialPlus || isNumeric;
              const fullNumber = this._getFullNumber();
              const coreNumber = intlTelInput.utils.getCoreNumber(fullNumber, this.selectedCountryData.iso2);
              const hasReachedMaxLength = this.maxCoreNumberLength && coreNumber.length >= this.maxCoreNumberLength;
              const selectedText = this.telInput.value.substring(this.telInput.selectionStart, this.telInput.selectionEnd);
              const hasSelectedDigit = /\d/.test(selectedText);
              if (!isAllowedChar || hasReachedMaxLength && !hasSelectedDigit) {
                e.preventDefault();
              }
            }
          }
        };
        this.telInput.addEventListener("keydown", this._handleKeydownEvent);
      }
    }
    //* Adhere to the input's maxlength attr.
    _cap(number) {
      const max = parseInt(this.telInput.getAttribute("maxlength") || "", 10);
      return max && number.length > max ? number.substr(0, max) : number;
    }
    //* Trigger a custom event on the input.
    _trigger(name, detailProps = {}) {
      const e = new CustomEvent(name, {
        bubbles: true,
        cancelable: true,
        detail: detailProps
      });
      this.telInput.dispatchEvent(e);
    }
    //* Open the dropdown.
    _openDropdown() {
      const { fixDropdownWidth, countrySearch } = this.options;
      if (fixDropdownWidth) {
        this.dropdownContent.style.width = `${this.telInput.offsetWidth}px`;
      }
      this.dropdownContent.classList.remove("iti__hide");
      this.selectedCountry.setAttribute("aria-expanded", "true");
      this._setDropdownPosition();
      if (countrySearch) {
        const firstCountryItem = this.countryList.firstElementChild;
        if (firstCountryItem) {
          this._highlightListItem(firstCountryItem, false);
          this.countryList.scrollTop = 0;
        }
        this.searchInput.focus();
      }
      this._bindDropdownListeners();
      this.dropdownArrow.classList.add("iti__arrow--up");
      this._trigger("open:countrydropdown");
    }
    //* Set the dropdown position
    _setDropdownPosition() {
      if (this.options.dropdownContainer) {
        this.options.dropdownContainer.appendChild(this.dropdown);
      }
      if (!this.options.useFullscreenPopup) {
        const inputPosRelativeToVP = this.telInput.getBoundingClientRect();
        const inputHeight = this.telInput.offsetHeight;
        if (this.options.dropdownContainer) {
          this.dropdown.style.top = `${inputPosRelativeToVP.top + inputHeight}px`;
          this.dropdown.style.left = `${inputPosRelativeToVP.left}px`;
          this._handleWindowScroll = () => this._closeDropdown();
          window.addEventListener("scroll", this._handleWindowScroll);
        }
      }
    }
    //* We only bind dropdown listeners when the dropdown is open.
    _bindDropdownListeners() {
      this._handleMouseoverCountryList = (e) => {
        const listItem = e.target?.closest(".iti__country");
        if (listItem) {
          this._highlightListItem(listItem, false);
        }
      };
      this.countryList.addEventListener(
        "mouseover",
        this._handleMouseoverCountryList
      );
      this._handleClickCountryList = (e) => {
        const listItem = e.target?.closest(".iti__country");
        if (listItem) {
          this._selectListItem(listItem);
        }
      };
      this.countryList.addEventListener("click", this._handleClickCountryList);
      let isOpening = true;
      this._handleClickOffToClose = () => {
        if (!isOpening) {
          this._closeDropdown();
        }
        isOpening = false;
      };
      document.documentElement.addEventListener(
        "click",
        this._handleClickOffToClose
      );
      let query = "";
      let queryTimer = null;
      this._handleKeydownOnDropdown = (e) => {
        if (["ArrowUp", "ArrowDown", "Enter", "Escape"].includes(e.key)) {
          e.preventDefault();
          e.stopPropagation();
          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
            this._handleUpDownKey(e.key);
          } else if (e.key === "Enter") {
            this._handleEnterKey();
          } else if (e.key === "Escape") {
            this._closeDropdown();
          }
        }
        if (!this.options.countrySearch && /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(e.key)) {
          e.stopPropagation();
          if (queryTimer) {
            clearTimeout(queryTimer);
          }
          query += e.key.toLowerCase();
          this._searchForCountry(query);
          queryTimer = setTimeout(() => {
            query = "";
          }, 1e3);
        }
      };
      document.addEventListener("keydown", this._handleKeydownOnDropdown);
      if (this.options.countrySearch) {
        const doFilter = () => {
          const inputQuery = this.searchInput.value.trim();
          if (inputQuery) {
            this._filterCountries(inputQuery);
          } else {
            this._filterCountries("", true);
          }
        };
        let keyupTimer = null;
        this._handleSearchChange = () => {
          if (keyupTimer) {
            clearTimeout(keyupTimer);
          }
          keyupTimer = setTimeout(() => {
            doFilter();
            keyupTimer = null;
          }, 100);
        };
        this.searchInput.addEventListener("input", this._handleSearchChange);
        this.searchInput.addEventListener("click", (e) => e.stopPropagation());
      }
    }
    //* Hidden search (countrySearch disabled): Find the first list item whose name starts with the query string.
    _searchForCountry(query) {
      for (let i = 0; i < this.countries.length; i++) {
        const c = this.countries[i];
        const startsWith = c.name.substr(0, query.length).toLowerCase() === query;
        if (startsWith) {
          const listItem = c.nodeById[this.id];
          this._highlightListItem(listItem, false);
          this._scrollTo(listItem);
          break;
        }
      }
    }
    //* Country search enabled: Filter the countries according to the search query.
    _filterCountries(query, isReset = false) {
      let noCountriesAddedYet = true;
      this.countryList.innerHTML = "";
      const normalisedQuery = normaliseString(query);
      for (let i = 0; i < this.countries.length; i++) {
        const c = this.countries[i];
        const normalisedCountryName = normaliseString(c.name);
        const fullDialCode = `+${c.dialCode}`;
        if (isReset || normalisedCountryName.includes(normalisedQuery) || fullDialCode.includes(normalisedQuery) || c.iso2.includes(normalisedQuery)) {
          const listItem = c.nodeById[this.id];
          if (listItem) {
            this.countryList.appendChild(listItem);
          }
          if (noCountriesAddedYet) {
            this._highlightListItem(listItem, false);
            noCountriesAddedYet = false;
          }
        }
      }
      if (noCountriesAddedYet) {
        this._highlightListItem(null, false);
      }
      this.countryList.scrollTop = 0;
      this._updateSearchResultsText();
    }
    //* Update search results text (for a11y).
    _updateSearchResultsText() {
      const { i18n } = this.options;
      const count = this.countryList.childElementCount;
      let searchText;
      if (count === 0) {
        searchText = i18n.zeroSearchResults;
      } else if (count === 1) {
        searchText = i18n.oneSearchResult;
      } else {
        searchText = i18n.multipleSearchResults.replace("${count}", count.toString());
      }
      this.searchResultsA11yText.textContent = searchText;
    }
    //* Highlight the next/prev item in the list (and ensure it is visible).
    _handleUpDownKey(key) {
      let next = key === "ArrowUp" ? this.highlightedItem?.previousElementSibling : this.highlightedItem?.nextElementSibling;
      if (!next && this.countryList.childElementCount > 1) {
        next = key === "ArrowUp" ? this.countryList.lastElementChild : this.countryList.firstElementChild;
      }
      if (next) {
        this._scrollTo(next);
        this._highlightListItem(next, false);
      }
    }
    //* Select the currently highlighted item.
    _handleEnterKey() {
      if (this.highlightedItem) {
        this._selectListItem(this.highlightedItem);
      }
    }
    //* Update the input's value to the given val (format first if possible)
    //* NOTE: this is called from _setInitialState, handleUtils and setNumber.
    _updateValFromNumber(fullNumber) {
      let number = fullNumber;
      if (this.options.formatOnDisplay && intlTelInput.utils && this.selectedCountryData) {
        const useNational = this.options.nationalMode || number.charAt(0) !== "+" && !this.options.separateDialCode;
        const { NATIONAL, INTERNATIONAL } = intlTelInput.utils.numberFormat;
        const format = useNational ? NATIONAL : INTERNATIONAL;
        number = intlTelInput.utils.formatNumber(
          number,
          this.selectedCountryData.iso2,
          format
        );
      }
      number = this._beforeSetNumber(number);
      this.telInput.value = number;
    }
    //* Check if need to select a new country based on the given number
    //* Note: called from _setInitialState, keyup handler, setNumber.
    _updateCountryFromNumber(fullNumber) {
      const plusIndex = fullNumber.indexOf("+");
      let number = plusIndex ? fullNumber.substring(plusIndex) : fullNumber;
      const selectedDialCode = this.selectedCountryData.dialCode;
      const isNanp = selectedDialCode === "1";
      if (number && isNanp && number.charAt(0) !== "+") {
        if (number.charAt(0) !== "1") {
          number = `1${number}`;
        }
        number = `+${number}`;
      }
      if (this.options.separateDialCode && selectedDialCode && number.charAt(0) !== "+") {
        number = `+${selectedDialCode}${number}`;
      }
      const dialCode = this._getDialCode(number, true);
      const numeric = getNumeric(number);
      let iso2 = null;
      if (dialCode) {
        const iso2Codes = this.dialCodeToIso2Map[getNumeric(dialCode)];
        const alreadySelected = iso2Codes.indexOf(this.selectedCountryData.iso2) !== -1 && numeric.length <= dialCode.length - 1;
        const isRegionlessNanpNumber = selectedDialCode === "1" && isRegionlessNanp(numeric);
        if (!isRegionlessNanpNumber && !alreadySelected) {
          for (let j = 0; j < iso2Codes.length; j++) {
            if (iso2Codes[j]) {
              iso2 = iso2Codes[j];
              break;
            }
          }
        }
      } else if (number.charAt(0) === "+" && numeric.length) {
        iso2 = "";
      } else if ((!number || number === "+") && !this.selectedCountryData.iso2) {
        iso2 = this.defaultCountry;
      }
      if (iso2 !== null) {
        return this._setCountry(iso2);
      }
      return false;
    }
    //* Remove highlighting from other list items and highlight the given item.
    _highlightListItem(listItem, shouldFocus) {
      const prevItem = this.highlightedItem;
      if (prevItem) {
        prevItem.classList.remove("iti__highlight");
        prevItem.setAttribute("aria-selected", "false");
      }
      this.highlightedItem = listItem;
      if (this.highlightedItem) {
        this.highlightedItem.classList.add("iti__highlight");
        this.highlightedItem.setAttribute("aria-selected", "true");
        const activeDescendant = this.highlightedItem.getAttribute("id") || "";
        this.selectedCountry.setAttribute("aria-activedescendant", activeDescendant);
        if (this.options.countrySearch) {
          this.searchInput.setAttribute("aria-activedescendant", activeDescendant);
        }
      }
      if (shouldFocus) {
        this.highlightedItem.focus();
      }
    }
    //* Find the country data for the given iso2 code
    //* the ignoreOnlyCountriesOption is only used during init() while parsing the onlyCountries array
    _getCountryData(iso2, allowFail) {
      for (let i = 0; i < this.countries.length; i++) {
        if (this.countries[i].iso2 === iso2) {
          return this.countries[i];
        }
      }
      if (allowFail) {
        return null;
      }
      throw new Error(`No country data for '${iso2}'`);
    }
    //* Update the selected country, dial code (if separateDialCode), placeholder, title, and active list item.
    //* Note: called from _setInitialState, _updateCountryFromNumber, _selectListItem, setCountry.
    _setCountry(iso2) {
      const { separateDialCode, showFlags, i18n } = this.options;
      const prevCountry = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
      this.selectedCountryData = iso2 ? this._getCountryData(iso2, false) || {} : {};
      if (this.selectedCountryData.iso2) {
        this.defaultCountry = this.selectedCountryData.iso2;
      }
      if (this.selectedCountryInner) {
        let flagClass = "";
        let a11yText = "";
        if (iso2 && showFlags) {
          flagClass = `iti__flag iti__${iso2}`;
          a11yText = `${this.selectedCountryData.name} +${this.selectedCountryData.dialCode}`;
        } else {
          flagClass = "iti__flag iti__globe";
          a11yText = i18n.noCountrySelected;
        }
        this.selectedCountryInner.className = flagClass;
        this.selectedCountryA11yText.textContent = a11yText;
      }
      this._setSelectedCountryTitleAttribute(iso2, separateDialCode);
      if (separateDialCode) {
        const dialCode = this.selectedCountryData.dialCode ? `+${this.selectedCountryData.dialCode}` : "";
        this.selectedDialCode.innerHTML = dialCode;
        const selectedCountryWidth = this.selectedCountry.offsetWidth || this._getHiddenSelectedCountryWidth();
        const inputPadding = selectedCountryWidth + 8;
        if (this.isRTL) {
          this.telInput.style.paddingRight = `${inputPadding}px`;
        } else {
          this.telInput.style.paddingLeft = `${inputPadding}px`;
        }
      }
      this._updatePlaceholder();
      this._updateMaxLength();
      return prevCountry.iso2 !== iso2;
    }
    //* Update the maximum valid number length for the currently selected country.
    _updateMaxLength() {
      const { strictMode, placeholderNumberType, validationNumberType } = this.options;
      if (strictMode && intlTelInput.utils) {
        if (this.selectedCountryData.iso2) {
          const numberType = intlTelInput.utils.numberType[placeholderNumberType];
          let exampleNumber = intlTelInput.utils.getExampleNumber(
            this.selectedCountryData.iso2,
            false,
            numberType,
            true
          );
          let validNumber = exampleNumber;
          while (intlTelInput.utils.isPossibleNumber(exampleNumber, this.selectedCountryData.iso2, validationNumberType)) {
            validNumber = exampleNumber;
            exampleNumber += "0";
          }
          const coreNumber = intlTelInput.utils.getCoreNumber(validNumber, this.selectedCountryData.iso2);
          this.maxCoreNumberLength = coreNumber.length;
        } else {
          this.maxCoreNumberLength = null;
        }
      }
    }
    _setSelectedCountryTitleAttribute(iso2 = null, separateDialCode) {
      if (!this.selectedCountry) {
        return;
      }
      let title;
      if (iso2 && !separateDialCode) {
        title = `${this.selectedCountryData.name}: +${this.selectedCountryData.dialCode}`;
      } else if (iso2) {
        title = this.selectedCountryData.name;
      } else {
        title = "Unknown";
      }
      this.selectedCountry.setAttribute("title", title);
    }
    //* When the input is in a hidden container during initialisation, we must inject some markup
    //* into the end of the DOM to calculate the correct offsetWidth.
    //* NOTE: this is only used when separateDialCode is enabled, so countryContainer and selectedCountry
    //* will definitely exist.
    _getHiddenSelectedCountryWidth() {
      if (this.telInput.parentNode) {
        const containerClone = this.telInput.parentNode.cloneNode(false);
        containerClone.style.visibility = "hidden";
        document.body.appendChild(containerClone);
        const countryContainerClone = this.countryContainer.cloneNode();
        containerClone.appendChild(countryContainerClone);
        const selectedCountryClone = this.selectedCountry.cloneNode(true);
        countryContainerClone.appendChild(selectedCountryClone);
        const width = selectedCountryClone.offsetWidth;
        document.body.removeChild(containerClone);
        return width;
      }
      return 0;
    }
    //* Update the input placeholder to an example number from the currently selected country.
    _updatePlaceholder() {
      const {
        autoPlaceholder,
        placeholderNumberType,
        nationalMode,
        customPlaceholder
      } = this.options;
      const shouldSetPlaceholder = autoPlaceholder === "aggressive" || !this.hadInitialPlaceholder && autoPlaceholder === "polite";
      if (intlTelInput.utils && shouldSetPlaceholder) {
        const numberType = intlTelInput.utils.numberType[placeholderNumberType];
        let placeholder = this.selectedCountryData.iso2 ? intlTelInput.utils.getExampleNumber(
          this.selectedCountryData.iso2,
          nationalMode,
          numberType
        ) : "";
        placeholder = this._beforeSetNumber(placeholder);
        if (typeof customPlaceholder === "function") {
          placeholder = customPlaceholder(placeholder, this.selectedCountryData);
        }
        this.telInput.setAttribute("placeholder", placeholder);
      }
    }
    //* Called when the user selects a list item from the dropdown.
    _selectListItem(listItem) {
      const countryChanged = this._setCountry(
        listItem.getAttribute("data-country-code")
      );
      this._closeDropdown();
      this._updateDialCode(listItem.getAttribute("data-dial-code"));
      this.telInput.focus();
      if (countryChanged) {
        this._triggerCountryChange();
      }
    }
    //* Close the dropdown and unbind any listeners.
    _closeDropdown() {
      this.dropdownContent.classList.add("iti__hide");
      this.selectedCountry.setAttribute("aria-expanded", "false");
      this.selectedCountry.removeAttribute("aria-activedescendant");
      if (this.highlightedItem) {
        this.highlightedItem.setAttribute("aria-selected", "false");
      }
      if (this.options.countrySearch) {
        this.searchInput.removeAttribute("aria-activedescendant");
      }
      this.dropdownArrow.classList.remove("iti__arrow--up");
      document.removeEventListener("keydown", this._handleKeydownOnDropdown);
      if (this.options.countrySearch) {
        this.searchInput.removeEventListener("input", this._handleSearchChange);
      }
      document.documentElement.removeEventListener(
        "click",
        this._handleClickOffToClose
      );
      this.countryList.removeEventListener(
        "mouseover",
        this._handleMouseoverCountryList
      );
      this.countryList.removeEventListener("click", this._handleClickCountryList);
      if (this.options.dropdownContainer) {
        if (!this.options.useFullscreenPopup) {
          window.removeEventListener("scroll", this._handleWindowScroll);
        }
        if (this.dropdown.parentNode) {
          this.dropdown.parentNode.removeChild(this.dropdown);
        }
      }
      this._trigger("close:countrydropdown");
    }
    //* Check if an element is visible within it's container, else scroll until it is.
    _scrollTo(element) {
      const container = this.countryList;
      const scrollTop = document.documentElement.scrollTop;
      const containerHeight = container.offsetHeight;
      const containerTop = container.getBoundingClientRect().top + scrollTop;
      const containerBottom = containerTop + containerHeight;
      const elementHeight = element.offsetHeight;
      const elementTop = element.getBoundingClientRect().top + scrollTop;
      const elementBottom = elementTop + elementHeight;
      const newScrollTop = elementTop - containerTop + container.scrollTop;
      if (elementTop < containerTop) {
        container.scrollTop = newScrollTop;
      } else if (elementBottom > containerBottom) {
        const heightDifference = containerHeight - elementHeight;
        container.scrollTop = newScrollTop - heightDifference;
      }
    }
    //* Replace any existing dial code with the new one
    //* Note: called from _selectListItem and setCountry
    _updateDialCode(newDialCodeBare) {
      const inputVal = this.telInput.value;
      const newDialCode = `+${newDialCodeBare}`;
      let newNumber;
      if (inputVal.charAt(0) === "+") {
        const prevDialCode = this._getDialCode(inputVal);
        if (prevDialCode) {
          newNumber = inputVal.replace(prevDialCode, newDialCode);
        } else {
          newNumber = newDialCode;
        }
        this.telInput.value = newNumber;
      }
    }
    //* Try and extract a valid international dial code from a full telephone number.
    //* Note: returns the raw string inc plus character and any whitespace/dots etc.
    _getDialCode(number, includeAreaCode) {
      let dialCode = "";
      if (number.charAt(0) === "+") {
        let numericChars = "";
        for (let i = 0; i < number.length; i++) {
          const c = number.charAt(i);
          if (!isNaN(parseInt(c, 10))) {
            numericChars += c;
            if (includeAreaCode) {
              if (this.dialCodeToIso2Map[numericChars]) {
                dialCode = number.substr(0, i + 1);
              }
            } else {
              if (this.dialCodes[numericChars]) {
                dialCode = number.substr(0, i + 1);
                break;
              }
            }
            if (numericChars.length === this.dialCodeMaxLen) {
              break;
            }
          }
        }
      }
      return dialCode;
    }
    //* Get the input val, adding the dial code if separateDialCode is enabled.
    _getFullNumber() {
      const val = this.telInput.value.trim();
      const { dialCode } = this.selectedCountryData;
      let prefix;
      const numericVal = getNumeric(val);
      if (this.options.separateDialCode && val.charAt(0) !== "+" && dialCode && numericVal) {
        prefix = `+${dialCode}`;
      } else {
        prefix = "";
      }
      return prefix + val;
    }
    //* Remove the dial code if separateDialCode is enabled also cap the length if the input has a maxlength attribute
    _beforeSetNumber(fullNumber) {
      let number = fullNumber;
      if (this.options.separateDialCode) {
        let dialCode = this._getDialCode(number);
        if (dialCode) {
          dialCode = `+${this.selectedCountryData.dialCode}`;
          const start = number[dialCode.length] === " " || number[dialCode.length] === "-" ? dialCode.length + 1 : dialCode.length;
          number = number.substr(start);
        }
      }
      return this._cap(number);
    }
    //* Trigger the 'countrychange' event.
    _triggerCountryChange() {
      this._trigger("countrychange");
    }
    //* Format the number as the user types.
    _formatNumberAsYouType() {
      const val = this._getFullNumber();
      const result = intlTelInput.utils ? intlTelInput.utils.formatNumberAsYouType(val, this.selectedCountryData.iso2) : val;
      const { dialCode } = this.selectedCountryData;
      if (this.options.separateDialCode && this.telInput.value.charAt(0) !== "+" && result.includes(`+${dialCode}`)) {
        const afterDialCode = result.split(`+${dialCode}`)[1] || "";
        return afterDialCode.trim();
      }
      return result;
    }
    //**************************
    //*  SECRET PUBLIC METHODS
    //**************************
    //* This is called when the geoip call returns.
    handleAutoCountry() {
      if (this.options.initialCountry === "auto" && intlTelInput.autoCountry) {
        this.defaultCountry = intlTelInput.autoCountry;
        const hasSelectedCountryOrGlobe = this.selectedCountryData.iso2 || this.selectedCountryInner.classList.contains("iti__globe");
        if (!hasSelectedCountryOrGlobe) {
          this.setCountry(this.defaultCountry);
        }
        this.resolveAutoCountryPromise();
      }
    }
    //* This is called when the utils request completes.
    handleUtils() {
      if (intlTelInput.utils) {
        if (this.telInput.value) {
          this._updateValFromNumber(this.telInput.value);
        }
        if (this.selectedCountryData.iso2) {
          this._updatePlaceholder();
          this._updateMaxLength();
        }
      }
      this.resolveUtilsScriptPromise();
    }
    //********************
    //*  PUBLIC METHODS
    //********************
    //* Remove plugin.
    destroy() {
      const { allowDropdown, separateDialCode } = this.options;
      if (allowDropdown) {
        this._closeDropdown();
        this.selectedCountry.removeEventListener(
          "click",
          this._handleClickSelectedCountry
        );
        this.countryContainer.removeEventListener(
          "keydown",
          this._handleCountryContainerKeydown
        );
        const label = this.telInput.closest("label");
        if (label) {
          label.removeEventListener("click", this._handleLabelClick);
        }
      }
      const { form } = this.telInput;
      if (this._handleHiddenInputSubmit && form) {
        form.removeEventListener("submit", this._handleHiddenInputSubmit);
      }
      this.telInput.removeEventListener("input", this._handleInputEvent);
      if (this._handleKeydownEvent) {
        this.telInput.removeEventListener("keydown", this._handleKeydownEvent);
      }
      this.telInput.removeAttribute("data-intl-tel-input-id");
      if (separateDialCode) {
        if (this.isRTL) {
          this.telInput.style.paddingRight = this.originalPaddingRight;
        } else {
          this.telInput.style.paddingLeft = this.originalPaddingLeft;
        }
      }
      const wrapper = this.telInput.parentNode;
      wrapper?.parentNode?.insertBefore(this.telInput, wrapper);
      wrapper?.parentNode?.removeChild(wrapper);
      delete intlTelInput.instances[this.id];
    }
    //* Get the extension from the current number.
    getExtension() {
      if (intlTelInput.utils) {
        return intlTelInput.utils.getExtension(
          this._getFullNumber(),
          this.selectedCountryData.iso2
        );
      }
      return "";
    }
    //* Format the number to the given format.
    getNumber(format) {
      if (intlTelInput.utils) {
        const { iso2 } = this.selectedCountryData;
        return intlTelInput.utils.formatNumber(
          this._getFullNumber(),
          iso2,
          format
        );
      }
      return "";
    }
    //* Get the type of the entered number e.g. landline/mobile.
    getNumberType() {
      if (intlTelInput.utils) {
        return intlTelInput.utils.getNumberType(
          this._getFullNumber(),
          this.selectedCountryData.iso2
        );
      }
      return -99;
    }
    //* Get the country data for the currently selected country.
    getSelectedCountryData() {
      return this.selectedCountryData;
    }
    //* Get the validation error.
    getValidationError() {
      if (intlTelInput.utils) {
        const { iso2 } = this.selectedCountryData;
        return intlTelInput.utils.getValidationError(this._getFullNumber(), iso2);
      }
      return -99;
    }
    //* Validate the input val
    isValidNumber() {
      const val = this._getFullNumber();
      const alphaCharPosition = val.search(/\p{L}/u);
      if (alphaCharPosition > -1) {
        const beforeAlphaChar = val.substring(0, alphaCharPosition);
        const beforeAlphaIsValid = this._utilsIsPossibleNumber(beforeAlphaChar);
        const isValid = this._utilsIsPossibleNumber(val);
        return beforeAlphaIsValid && isValid;
      }
      return this._utilsIsPossibleNumber(val);
    }
    _utilsIsPossibleNumber(val) {
      return intlTelInput.utils ? intlTelInput.utils.isPossibleNumber(val, this.selectedCountryData.iso2, this.options.validationNumberType) : null;
    }
    //* Validate the input val (precise)
    isValidNumberPrecise() {
      const val = this._getFullNumber();
      const alphaCharPosition = val.search(/\p{L}/u);
      if (alphaCharPosition > -1) {
        const beforeAlphaChar = val.substring(0, alphaCharPosition);
        const beforeAlphaIsValid = this._utilsIsValidNumber(beforeAlphaChar);
        const isValid = this._utilsIsValidNumber(val);
        return beforeAlphaIsValid && isValid;
      }
      return this._utilsIsValidNumber(val);
    }
    _utilsIsValidNumber(val) {
      return intlTelInput.utils ? intlTelInput.utils.isValidNumber(val, this.selectedCountryData.iso2) : null;
    }
    //* Update the selected country, and update the input val accordingly.
    setCountry(iso2) {
      const iso2Lower = iso2?.toLowerCase();
      const currentCountry = this.selectedCountryData.iso2;
      const isCountryChange = iso2 && iso2Lower !== currentCountry || !iso2 && currentCountry;
      if (isCountryChange) {
        this._setCountry(iso2Lower);
        this._updateDialCode(this.selectedCountryData.dialCode);
        this._triggerCountryChange();
      }
    }
    //* Set the input value and update the country.
    setNumber(number) {
      const countryChanged = this._updateCountryFromNumber(number);
      this._updateValFromNumber(number);
      if (countryChanged) {
        this._triggerCountryChange();
      }
      this._trigger("input", { isSetNumber: true });
    }
    //* Set the placeholder number typ
    setPlaceholderNumberType(type) {
      this.options.placeholderNumberType = type;
      this._updatePlaceholder();
    }
    setDisabled(disabled) {
      this.telInput.disabled = disabled;
      if (disabled) {
        this.selectedCountry.setAttribute("disabled", "true");
      } else {
        this.selectedCountry.removeAttribute("disabled");
      }
    }
  };
  var loadUtils = (path) => {
    if (!intlTelInput.utils && !intlTelInput.startedLoadingUtilsScript) {
      intlTelInput.startedLoadingUtilsScript = true;
      return new Promise((resolve, reject) => {
        import_INTENTIONALLY_BROKEN(
          /* webpackIgnore: true */
          /* @vite-ignore */
          path
        ).then(({ default: utils2 }) => {
          intlTelInput.utils = utils2;
          forEachInstance("handleUtils");
          resolve(true);
        }).catch(() => {
          forEachInstance("rejectUtilsScriptPromise");
          reject();
        });
      });
    }
    return null;
  };
  var intlTelInput = Object.assign(
    (input, options) => {
      const iti = new Iti(input, options);
      iti._init();
      input.setAttribute("data-intl-tel-input-id", iti.id.toString());
      intlTelInput.instances[iti.id] = iti;
      return iti;
    },
    {
      defaults,
      //* Using a static var like this allows us to mock it in the tests.
      documentReady: () => document.readyState === "complete",
      //* Get the country data object.
      getCountryData: () => data_default,
      //* A getter for the plugin instance.
      getInstance: (input) => {
        const id2 = input.getAttribute("data-intl-tel-input-id");
        return id2 ? intlTelInput.instances[id2] : null;
      },
      //* A map from instance ID to instance object.
      instances: {},
      loadUtils,
      version: "23.9.3"
    }
  );
  var intl_tel_input_default = intlTelInput;

  // build/js/utils.js
  (function() {
    var k = this || self;
    function m(a, b) {
      a = a.split(".");
      var c = k;
      a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);
      for (var d; a.length && (d = a.shift()); ) a.length || void 0 === b ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
    }
    function n(a, b) {
      function c() {
      }
      c.prototype = b.prototype;
      a.ma = b.prototype;
      a.prototype = new c();
      a.prototype.constructor = a;
      a.sa = function(d, e, f) {
        for (var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++) g[h - 2] = arguments[h];
        return b.prototype[e].apply(d, g);
      };
    }
    ;
    function aa(a) {
      const b = [];
      let c = 0;
      for (const d in a) b[c++] = a[d];
      return b;
    }
    ;
    var ca = class {
      constructor(a) {
        if (ba !== ba) throw Error("SafeUrl is not meant to be built directly");
        this.g = a;
      }
      toString() {
        return this.g.toString();
      }
    }, ba = {};
    new ca("about:invalid#zClosurez");
    new ca("about:blank");
    const ea = {};
    class fa {
      constructor() {
        if (ea !== ea) throw Error("SafeStyle is not meant to be built directly");
      }
      toString() {
        return "".toString();
      }
    }
    new fa();
    const ha = {};
    class ia {
      constructor() {
        if (ha !== ha) throw Error("SafeStyleSheet is not meant to be built directly");
      }
      toString() {
        return "".toString();
      }
    }
    new ia();
    const ja = {};
    class ka {
      constructor() {
        var a = k.trustedTypes && k.trustedTypes.emptyHTML || "";
        if (ja !== ja) throw Error("SafeHtml is not meant to be built directly");
        this.g = a;
      }
      toString() {
        return this.g.toString();
      }
    }
    new ka();
    function la(a, b) {
      this.g = a;
      this.l = !!b.aa;
      this.h = b.i;
      this.s = b.type;
      this.o = false;
      switch (this.h) {
        case ma:
        case na:
        case oa:
        case pa:
        case qa:
        case ra:
        case sa:
          this.o = true;
      }
      this.j = b.defaultValue;
    }
    var sa = 1, ra = 2, ma = 3, na = 4, oa = 6, pa = 16, qa = 18;
    function ta(a, b) {
      this.h = a;
      this.g = {};
      for (a = 0; a < b.length; a++) {
        var c = b[a];
        this.g[c.g] = c;
      }
    }
    function ua(a) {
      a = aa(a.g);
      a.sort(function(b, c) {
        return b.g - c.g;
      });
      return a;
    }
    ;
    function p() {
      this.h = {};
      this.j = this.m().g;
      this.g = this.l = null;
    }
    p.prototype.has = function(a) {
      return q(this, a.g);
    };
    p.prototype.get = function(a, b) {
      return r(this, a.g, b);
    };
    p.prototype.set = function(a, b) {
      t(this, a.g, b);
    };
    p.prototype.add = function(a, b) {
      va(this, a.g, b);
    };
    function wa(a, b) {
      for (var c = ua(a.m()), d = 0; d < c.length; d++) {
        var e = c[d], f = e.g;
        if (q(b, f)) {
          a.g && delete a.g[e.g];
          var g = 11 == e.h || 10 == e.h;
          if (e.l) {
            e = u(b, f);
            for (var h = 0; h < e.length; h++) va(a, f, g ? e[h].clone() : e[h]);
          } else e = v(b, f), g ? (g = v(a, f)) ? wa(g, e) : t(a, f, e.clone()) : t(a, f, e);
        }
      }
    }
    p.prototype.clone = function() {
      var a = new this.constructor();
      a != this && (a.h = {}, a.g && (a.g = {}), wa(a, this));
      return a;
    };
    function q(a, b) {
      return null != a.h[b];
    }
    function v(a, b) {
      var c = a.h[b];
      if (null == c) return null;
      if (a.l) {
        if (!(b in a.g)) {
          var d = a.l, e = a.j[b];
          if (null != c) if (e.l) {
            for (var f = [], g = 0; g < c.length; g++) f[g] = d.h(e, c[g]);
            c = f;
          } else c = d.h(e, c);
          return a.g[b] = c;
        }
        return a.g[b];
      }
      return c;
    }
    function r(a, b, c) {
      var d = v(a, b);
      return a.j[b].l ? d[c || 0] : d;
    }
    function w(a, b) {
      if (q(a, b)) a = r(a, b);
      else a: {
        a = a.j[b];
        if (void 0 === a.j) if (b = a.s, b === Boolean) a.j = false;
        else if (b === Number) a.j = 0;
        else if (b === String) a.j = a.o ? "0" : "";
        else {
          a = new b();
          break a;
        }
        a = a.j;
      }
      return a;
    }
    function u(a, b) {
      return v(a, b) || [];
    }
    function x(a, b) {
      return a.j[b].l ? q(a, b) ? a.h[b].length : 0 : q(a, b) ? 1 : 0;
    }
    function t(a, b, c) {
      a.h[b] = c;
      a.g && (a.g[b] = c);
    }
    function va(a, b, c) {
      a.h[b] || (a.h[b] = []);
      a.h[b].push(c);
      a.g && delete a.g[b];
    }
    function y(a, b) {
      var c = [], d;
      for (d in b) 0 != d && c.push(new la(d, b[d]));
      return new ta(a, c);
    }
    ;
    function z() {
    }
    z.prototype.g = function(a) {
      new a.h();
      throw Error("Unimplemented");
    };
    z.prototype.h = function(a, b) {
      if (11 == a.h || 10 == a.h) return b instanceof p ? b : this.g(a.s.prototype.m(), b);
      if (14 == a.h) return "string" === typeof b && xa.test(b) && (a = Number(b), 0 < a) ? a : b;
      if (!a.o) return b;
      a = a.s;
      if (a === String) {
        if ("number" === typeof b) return String(b);
      } else if (a === Number && "string" === typeof b && ("Infinity" === b || "-Infinity" === b || "NaN" === b || xa.test(b))) return Number(b);
      return b;
    };
    var xa = /^-?[0-9]+$/;
    function ya() {
    }
    n(ya, z);
    ya.prototype.g = function(a, b) {
      a = new a.h();
      a.l = this;
      a.h = b;
      a.g = {};
      return a;
    };
    function B() {
    }
    n(B, ya);
    B.prototype.h = function(a, b) {
      return 8 == a.h ? !!b : z.prototype.h.apply(this, arguments);
    };
    B.prototype.g = function(a, b) {
      return B.ma.g.call(this, a, b);
    };
    function C(a, b) {
      null != a && this.g.apply(this, arguments);
    }
    C.prototype.h = "";
    C.prototype.set = function(a) {
      this.h = "" + a;
    };
    C.prototype.g = function(a, b, c) {
      this.h += String(a);
      if (null != b) for (let d = 1; d < arguments.length; d++) this.h += arguments[d];
      return this;
    };
    function D(a) {
      a.h = "";
    }
    C.prototype.toString = function() {
      return this.h;
    };
    function E() {
      p.call(this);
    }
    n(E, p);
    var za = null;
    function F() {
      p.call(this);
    }
    n(F, p);
    var Aa = null;
    function G() {
      p.call(this);
    }
    n(G, p);
    var Ba = null;
    E.prototype.m = function() {
      var a = za;
      a || (za = a = y(E, { 0: { name: "NumberFormat", ia: "i18n.phonenumbers.NumberFormat" }, 1: { name: "pattern", required: true, i: 9, type: String }, 2: { name: "format", required: true, i: 9, type: String }, 3: { name: "leading_digits_pattern", aa: true, i: 9, type: String }, 4: { name: "national_prefix_formatting_rule", i: 9, type: String }, 6: { name: "national_prefix_optional_when_formatting", i: 8, defaultValue: false, type: Boolean }, 5: { name: "domestic_carrier_code_formatting_rule", i: 9, type: String } }));
      return a;
    };
    E.m = E.prototype.m;
    F.prototype.m = function() {
      var a = Aa;
      a || (Aa = a = y(F, { 0: { name: "PhoneNumberDesc", ia: "i18n.phonenumbers.PhoneNumberDesc" }, 2: { name: "national_number_pattern", i: 9, type: String }, 9: { name: "possible_length", aa: true, i: 5, type: Number }, 10: { name: "possible_length_local_only", aa: true, i: 5, type: Number }, 6: { name: "example_number", i: 9, type: String } }));
      return a;
    };
    F.m = F.prototype.m;
    G.prototype.m = function() {
      var a = Ba;
      a || (Ba = a = y(G, {
        0: { name: "PhoneMetadata", ia: "i18n.phonenumbers.PhoneMetadata" },
        1: { name: "general_desc", i: 11, type: F },
        2: { name: "fixed_line", i: 11, type: F },
        3: { name: "mobile", i: 11, type: F },
        4: { name: "toll_free", i: 11, type: F },
        5: { name: "premium_rate", i: 11, type: F },
        6: { name: "shared_cost", i: 11, type: F },
        7: { name: "personal_number", i: 11, type: F },
        8: { name: "voip", i: 11, type: F },
        21: { name: "pager", i: 11, type: F },
        25: { name: "uan", i: 11, type: F },
        27: { name: "emergency", i: 11, type: F },
        28: { name: "voicemail", i: 11, type: F },
        29: { name: "short_code", i: 11, type: F },
        30: { name: "standard_rate", i: 11, type: F },
        31: { name: "carrier_specific", i: 11, type: F },
        33: { name: "sms_services", i: 11, type: F },
        24: { name: "no_international_dialling", i: 11, type: F },
        9: { name: "id", required: true, i: 9, type: String },
        10: { name: "country_code", i: 5, type: Number },
        11: { name: "international_prefix", i: 9, type: String },
        17: { name: "preferred_international_prefix", i: 9, type: String },
        12: { name: "national_prefix", i: 9, type: String },
        13: { name: "preferred_extn_prefix", i: 9, type: String },
        15: {
          name: "national_prefix_for_parsing",
          i: 9,
          type: String
        },
        16: { name: "national_prefix_transform_rule", i: 9, type: String },
        18: { name: "same_mobile_and_fixed_line_pattern", i: 8, defaultValue: false, type: Boolean },
        19: { name: "number_format", aa: true, i: 11, type: E },
        20: { name: "intl_number_format", aa: true, i: 11, type: E },
        22: { name: "main_country_for_code", i: 8, defaultValue: false, type: Boolean },
        23: { name: "leading_digits", i: 9, type: String }
      }));
      return a;
    };
    G.m = G.prototype.m;
    function H() {
      p.call(this);
    }
    n(H, p);
    var Ca = null, Da = { ra: 0, qa: 1, pa: 5, oa: 10, na: 20 };
    H.prototype.m = function() {
      var a = Ca;
      a || (Ca = a = y(H, { 0: { name: "PhoneNumber", ia: "i18n.phonenumbers.PhoneNumber" }, 1: { name: "country_code", required: true, i: 5, type: Number }, 2: { name: "national_number", required: true, i: 4, type: Number }, 3: { name: "extension", i: 9, type: String }, 4: { name: "italian_leading_zero", i: 8, type: Boolean }, 8: { name: "number_of_leading_zeros", i: 5, defaultValue: 1, type: Number }, 5: { name: "raw_input", i: 9, type: String }, 6: { name: "country_code_source", i: 14, defaultValue: 0, type: Da }, 7: {
        name: "preferred_domestic_carrier_code",
        i: 9,
        type: String
      } }));
      return a;
    };
    H.ctor = H;
    H.ctor.m = H.prototype.m;
    var I = {
      1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
      7: ["RU", "KZ"],
      20: ["EG"],
      27: ["ZA"],
      30: ["GR"],
      31: ["NL"],
      32: ["BE"],
      33: ["FR"],
      34: ["ES"],
      36: ["HU"],
      39: ["IT", "VA"],
      40: ["RO"],
      41: ["CH"],
      43: ["AT"],
      44: ["GB", "GG", "IM", "JE"],
      45: ["DK"],
      46: ["SE"],
      47: ["NO", "SJ"],
      48: ["PL"],
      49: ["DE"],
      51: ["PE"],
      52: ["MX"],
      53: ["CU"],
      54: ["AR"],
      55: ["BR"],
      56: ["CL"],
      57: ["CO"],
      58: ["VE"],
      60: ["MY"],
      61: ["AU", "CC", "CX"],
      62: ["ID"],
      63: ["PH"],
      64: ["NZ"],
      65: ["SG"],
      66: ["TH"],
      81: ["JP"],
      82: ["KR"],
      84: ["VN"],
      86: ["CN"],
      90: ["TR"],
      91: ["IN"],
      92: ["PK"],
      93: ["AF"],
      94: ["LK"],
      95: ["MM"],
      98: ["IR"],
      211: ["SS"],
      212: ["MA", "EH"],
      213: ["DZ"],
      216: ["TN"],
      218: ["LY"],
      220: ["GM"],
      221: ["SN"],
      222: ["MR"],
      223: ["ML"],
      224: ["GN"],
      225: ["CI"],
      226: ["BF"],
      227: ["NE"],
      228: ["TG"],
      229: ["BJ"],
      230: ["MU"],
      231: ["LR"],
      232: ["SL"],
      233: ["GH"],
      234: ["NG"],
      235: ["TD"],
      236: ["CF"],
      237: ["CM"],
      238: ["CV"],
      239: ["ST"],
      240: ["GQ"],
      241: ["GA"],
      242: ["CG"],
      243: ["CD"],
      244: ["AO"],
      245: ["GW"],
      246: ["IO"],
      247: ["AC"],
      248: ["SC"],
      249: ["SD"],
      250: ["RW"],
      251: ["ET"],
      252: ["SO"],
      253: ["DJ"],
      254: ["KE"],
      255: ["TZ"],
      256: ["UG"],
      257: ["BI"],
      258: ["MZ"],
      260: ["ZM"],
      261: ["MG"],
      262: ["RE", "YT"],
      263: ["ZW"],
      264: ["NA"],
      265: ["MW"],
      266: ["LS"],
      267: ["BW"],
      268: ["SZ"],
      269: ["KM"],
      290: ["SH", "TA"],
      291: ["ER"],
      297: ["AW"],
      298: ["FO"],
      299: ["GL"],
      350: ["GI"],
      351: ["PT"],
      352: ["LU"],
      353: ["IE"],
      354: ["IS"],
      355: ["AL"],
      356: ["MT"],
      357: ["CY"],
      358: ["FI", "AX"],
      359: ["BG"],
      370: ["LT"],
      371: ["LV"],
      372: ["EE"],
      373: ["MD"],
      374: ["AM"],
      375: ["BY"],
      376: ["AD"],
      377: ["MC"],
      378: ["SM"],
      380: ["UA"],
      381: ["RS"],
      382: ["ME"],
      383: ["XK"],
      385: ["HR"],
      386: ["SI"],
      387: ["BA"],
      389: ["MK"],
      420: ["CZ"],
      421: ["SK"],
      423: ["LI"],
      500: ["FK"],
      501: ["BZ"],
      502: ["GT"],
      503: ["SV"],
      504: ["HN"],
      505: ["NI"],
      506: ["CR"],
      507: ["PA"],
      508: ["PM"],
      509: ["HT"],
      590: ["GP", "BL", "MF"],
      591: ["BO"],
      592: ["GY"],
      593: ["EC"],
      594: ["GF"],
      595: ["PY"],
      596: ["MQ"],
      597: ["SR"],
      598: ["UY"],
      599: ["CW", "BQ"],
      670: ["TL"],
      672: ["NF"],
      673: ["BN"],
      674: ["NR"],
      675: ["PG"],
      676: ["TO"],
      677: ["SB"],
      678: ["VU"],
      679: ["FJ"],
      680: ["PW"],
      681: ["WF"],
      682: ["CK"],
      683: ["NU"],
      685: ["WS"],
      686: ["KI"],
      687: ["NC"],
      688: ["TV"],
      689: ["PF"],
      690: ["TK"],
      691: ["FM"],
      692: ["MH"],
      800: ["001"],
      808: ["001"],
      850: ["KP"],
      852: ["HK"],
      853: ["MO"],
      855: ["KH"],
      856: ["LA"],
      870: ["001"],
      878: ["001"],
      880: ["BD"],
      881: ["001"],
      882: ["001"],
      883: ["001"],
      886: ["TW"],
      888: ["001"],
      960: ["MV"],
      961: ["LB"],
      962: ["JO"],
      963: ["SY"],
      964: ["IQ"],
      965: ["KW"],
      966: ["SA"],
      967: ["YE"],
      968: ["OM"],
      970: ["PS"],
      971: ["AE"],
      972: ["IL"],
      973: ["BH"],
      974: ["QA"],
      975: ["BT"],
      976: ["MN"],
      977: ["NP"],
      979: ["001"],
      992: ["TJ"],
      993: ["TM"],
      994: ["AZ"],
      995: ["GE"],
      996: ["KG"],
      998: ["UZ"]
    }, Ea = {
      AC: [, [
        ,
        ,
        "(?:[01589]\\d|[46])\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6]
      ], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:0[1-9]|[1589]\\d)\\d{4}", , , , "542011", , , [6]], , , [, , , , , , , , , [-1]]],
      AD: [
        ,
        [, , "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", , , , , , , [6, 8, 9]],
        [, , "[78]\\d{5}", , , , "712345", , , [6]],
        [, , "690\\d{6}|[356]\\d{5}", , , , "312345", , , [6, 9]],
        [, , "180[02]\\d{4}", , , , "18001234", , , [8]],
        [, , "[19]\\d{5}", , , , "912345", , , [6]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AD",
        376,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "1800\\d{4}", , , , , , , [8]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AE: [
        ,
        [, , "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
        [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]],
        [, , "5[024-68]\\d{7}", , , , "501234567", , , [9]],
        [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"],
        [, , "900[02]\\d{5}", , , , "900234567", , , [9]],
        [, , "700[05]\\d{5}", , , , "700012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AE",
        971,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], [, "(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "600[25]\\d{5}", , , , "600212345", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AF: [, [, , "[2-7]\\d{8}", , , , , , , [9], [7]], [
        ,
        ,
        "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
        ,
        ,
        ,
        "234567890",
        ,
        ,
        ,
        [7]
      ], [, , "7\\d{8}", , , , "701234567", , , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AG: [
        ,
        [, , "(?:268|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
          ,
          ,
          ,
          "2684601234",
          ,
          ,
          ,
          [7]
        ],
        [, , "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}", , , , "2684641234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , "26848[01]\\d{4}", , , , "2684801234", , , , [7]],
        "AG",
        1,
        "011",
        "1",
        ,
        ,
        "([457]\\d{6})$|1",
        "268$1",
        ,
        ,
        ,
        ,
        [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]],
        ,
        "268",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AI: [, [, , "(?:264|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "264(?:292|4(?:6[12]|9[78]))\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "([2457]\\d{6})$|1", "264$1", , , , , [, , "264724\\d{4}", , , , "2647241234", , , , [7]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AL: [, [, , "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", , , , , , , [6, 7, 8, 9], [5]], [, , "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", , , , "22345678", , , [8], [5, 6, 7]], [, , "6(?:[78][2-9]|9\\d)\\d{6}", , , , "672123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [
        ,
        ,
        "900[1-9]\\d\\d",
        ,
        ,
        ,
        "900123",
        ,
        ,
        [6]
      ], [, , "808[1-9]\\d\\d", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AM: [, [
        ,
        ,
        "(?:[1-489]\\d|55|60|77)\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8],
        [5, 6]
      ], [, , "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}", , , , "10123456", , , , [5, 6]], [, , "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}", , , , "77123456"], [, , "800\\d{5}", , , , "80012345"], [, , "90[016]\\d{5}", , , , "90012345"], [, , "80[1-4]\\d{5}", , , , "80112345"], [, , , , , , , , , [-1]], [, , "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}", , , , "60271234"], "AM", 374, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], [
        ,
        "(\\d{3})(\\d{5})",
        "$1 $2",
        ["2|3[12]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AO: [
        ,
        [, , "[29]\\d{8}", , , , , , , [9]],
        [, , "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}", , , , "222123456"],
        [, , "9[1-79]\\d{7}", , , , "923123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AO",
        244,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AR: [
        ,
        [, , "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", , , , , , , [10, 11], [6, 7, 8]],
        [
          ,
          ,
          "3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|5[3-6]|8[3-68])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
          ,
          ,
          ,
          "1123456789",
          ,
          ,
          [10],
          [6, 7, 8]
        ],
        [
          ,
          ,
          "93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|5[3-6]|8[3-68]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
          ,
          ,
          ,
          "91123456789",
          ,
          ,
          ,
          [6, 7, 8]
        ],
        [, , "800\\d{7,8}", , , , "8001234567"],
        [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AR",
        54,
        "00",
        "0",
        ,
        ,
        "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
        "9$1",
        ,
        ,
        [[, "(\\d{3})", "$1", ["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]], [, "(\\d{2})(\\d{4})", "$1-$2", ["[1-9]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[1-8]"]], [
          ,
          "(\\d{4})(\\d{2})(\\d{4})",
          "$1 $2-$3",
          [
            "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
            "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ],
          "0$1",
          ,
          1
        ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [
          ,
          "(\\d)(\\d{4})(\\d{2})(\\d{4})",
          "$2 15-$3-$4",
          [
            "9(?:2[2-469]|3[3-578])",
            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ],
          "0$1"
        ], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1"]],
        [
          [
            ,
            "(\\d{4})(\\d{2})(\\d{4})",
            "$1 $2-$3",
            [
              "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
              "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
            ],
            "0$1",
            ,
            1
          ],
          [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1],
          [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", [
            "9(?:2[2-469]|3[3-578])",
            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ]],
          [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["91"]],
          [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"],
          [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9"]]
        ],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "810\\d{7}", , , , , , , [10]],
        [, , "810\\d{7}", , , , "8101234567", , , [10]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AS: [, [, , "(?:[58]\\d\\d|684|900)\\d{7}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}", , , , "6847331234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "([267]\\d{6})$|1", "684$1", , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AT: [, [
        ,
        ,
        "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
        ,
        ,
        ,
        ,
        ,
        ,
        [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        [3]
      ], [, , "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}", , , , "1234567890", , , , [3]], [, , "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", , , , "664123456", , , [7, 8, 9, 10, 11, 12, 13]], [
        ,
        ,
        "800\\d{6,10}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [9, 10, 11, 12, 13]
      ], [, , "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10|2[018])\\d{6,10}|828\\d{5}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", , , , "780123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , [
        [, "(\\d{4})", "$1", ["14"]],
        [, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"],
        [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"],
        [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"],
        [, "(\\d{6})", "$1", ["[18]"]],
        [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"],
        [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"],
        [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"],
        [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]
      ], [[, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [
        ,
        "(\\d{3})(\\d{3,10})",
        "$1 $2",
        ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],
        "0$1"
      ], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AU: [
        ,
        [, , "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", , , , , , , [5, 6, 7, 8, 9, 10, 12]],
        [
          ,
          ,
          "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
          ,
          ,
          ,
          "212345678",
          ,
          ,
          [9],
          [8]
        ],
        [, , "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", , , , "412345678", , , [9]],
        [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
        [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
        [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
        "AU",
        61,
        "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
        "0",
        ,
        ,
        "(183[12])|0",
        ,
        "0011",
        ,
        [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["13"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["19"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["180", "1802"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["19"]], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]], [
          ,
          "(\\d{4})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["130"]
        ]],
        [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]],
        [, , "163\\d{2,6}", , , , "1631234", , , [5, 6, 7, 8, 9]],
        1,
        ,
        [, , "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}", , , , , , , [6, 7, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AW: [, [
        ,
        ,
        "(?:[25-79]\\d\\d|800)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7]
      ], [, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"], [, , "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], [, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:28\\d|501)\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AX: [, [
        ,
        ,
        "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 8, 9, 10, 11, 12]
      ], [, , "18[1-8]\\d{3,6}", , , , "181234567", , , [6, 7, 8, 9]], [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , "18", [, , , , , , , , , [-1]], [
        ,
        ,
        "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
        ,
        ,
        ,
        "10112345"
      ], , , [, , , , , , , , , [-1]]],
      AZ: [, [, , "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", , , , , , , [9], [7]], [, , "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}", , , , "123123456", , , , [7]], [, , "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 994, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[1-9]"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["90"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[13-9]"],
        "0$1"
      ]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BA: [
        ,
        [, , "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", , , , , , , [8, 9], [6]],
        [, , "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", , , , "30212345", , , [8], [6]],
        [, , "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}", , , , "61123456"],
        [, , "8[08]\\d{6}", , , , "80123456", , , [8]],
        [, , "9[0246]\\d{6}", , , , "90123456", , , [8]],
        [, , "8[12]\\d{6}", , , , "82123456", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BA",
        387,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
        [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", , , , "70341234", , , [8]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BB: [, [, , "(?:246|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}", , , , "2464123456", , , , [7]], [, , "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}", , , , "2462501234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "(?:246976|900[2-9]\\d\\d)\\d{4}", , , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "([2-9]\\d{6})$|1", "246$1", , , , , [, , , , , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [
        ,
        ,
        "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
        ,
        ,
        ,
        "2464301234",
        ,
        ,
        ,
        [7]
      ], , , [, , , , , , , , , [-1]]],
      BD: [, [, , "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [
        ,
        ,
        "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
        ,
        ,
        ,
        "27111234"
      ], [, , "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], [
        ,
        "(\\d{3})(\\d{3,7})",
        "$1-$2",
        ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
        "0$1"
      ], [, "(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], [, "(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BE: [, [, , "4\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9]], [, , "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", , , , "12345678", , , [8]], [, , "4[5-9]\\d{7}", , , , "470123456", , , [9]], [, , "800[1-9]\\d{4}", , , , "80012345", , , [8]], [, , "(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}", , , , "90012345", , , [8]], [
        ,
        ,
        "7879\\d{4}",
        ,
        ,
        ,
        "78791234",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BE", 32, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}", , , , "78102345", , , [8]], , , [, , , , , , , , , [-1]]],
      BF: [, [
        ,
        ,
        "[025-7]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:0[1-35-7]|5[0-8]|[67]\\d)\\d{6}", , , , "70123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BG: [
        ,
        [, , "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", , , , , , , [6, 7, 8, 9, 12], [4, 5]],
        [, , "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", , , , "2123456", , , [6, 7, 8], [4, 5]],
        [, , "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", , , , "43012345", , , [8, 9]],
        [, , "(?:00800\\d\\d|800)\\d{5}", , , , "80012345", , , [8, 12]],
        [, , "90\\d{6}", , , , "90123456", , , [8]],
        [, , "700\\d{5}", , , , "70012345", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BG",
        359,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{6})", "$1", ["1"]], [, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
          ,
          "(\\d{3})(\\d{4})",
          "$1 $2",
          ["43[1-6]|70[1-9]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
        [[, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
          ,
          "(\\d{3})(\\d{4})",
          "$1 $2",
          ["43[1-6]|70[1-9]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BH: [, [, , "[136-9]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
        ,
        ,
        ,
        "17001234"
      ], [, , "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}", , , , "36001234"], [, , "8[02369]\\d{6}", , , , "80123456"], [, , "(?:87|9[0-8])\\d{6}", , , , "90123456"], [, , "84\\d{6}", , , , "84123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BH", 973, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BI: [, [, , "(?:[267]\\d|31)\\d{6}", , , , , , , [8]], [, , "(?:22|31)\\d{6}", , , , "22201234"], [
        ,
        ,
        "(?:29|[67][125-9])\\d{6}",
        ,
        ,
        ,
        "79561234"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BJ: [
        ,
        [, , "[24-689]\\d{7}", , , , , , , [8]],
        [, , "2090\\d{4}|2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}", , , , "20211234"],
        [, , "(?:4[0-8]|[56]\\d|9[013-9])\\d{6}", , , , "90011234"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "857[58]\\d{4}", , , , "85751234"],
        "BJ",
        229,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "81\\d{6}", , , , "81123456"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BL: [, [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]], [, , "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}", , , , "590271234"], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}",
        ,
        ,
        ,
        "976012345"
      ], "BL", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BM: [, [, , "(?:441|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}", , , , "4414123456", , , , [7]], [, , "441(?:[2378]\\d|5[0-39]|9[02])\\d{5}", , , , "4413701234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "BM", 1, "011", "1", , , "([2-9]\\d{6})$|1", "441$1", , , , , [, , , , , , , , , [-1]], , "441", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BN: [
        ,
        [, , "[2-578]\\d{6}", , , , , , , [7]],
        [, , "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}", , , , "2345678"],
        [, , "(?:22[89]|[78]\\d\\d)\\d{4}", , , , "7123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "5[34]\\d{5}", , , , "5345678"],
        "BN",
        673,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BO: [, [, , "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", , , , , , , [8, 9], [7]], [, , "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", , , , "22123456", , , [8], [7]], [, , "[67]\\d{7}", , , , "71234567", , , [8]], [, , "8001[07]\\d{4}", , , , "800171234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "50\\d{6}",
        ,
        ,
        ,
        "50123456",
        ,
        ,
        [8],
        [7]
      ], "BO", 591, "00(?:1\\d)?", "0", , , "0(1\\d)?", , , , [[, "(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"], , "0$CC $1"], [, "(\\d{8})", "$1", ["[67]"], , "0$CC $1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"], , "0$CC $1"]], , [, , , , , , , , , [-1]], , , [, , "8001[07]\\d{4}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BQ: [, [, , "(?:[34]1|7\\d)\\d{5}", , , , , , , [7]], [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}", , , , "7151234"], [, , "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BQ", 599, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "[347]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BR: [, [, , "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", , , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", , , , "11961234567", , , [10, 11], [8, 9]], [
        ,
        ,
        "800\\d{6,7}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [9, 10]
      ], [, , "300\\d{6}|[59]00\\d{6,7}", , , , "300123456", , , [9, 10]], [, , "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", , , , "40041234", , , [8, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [
        [, "(\\d{3,6})", "$1", ["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]],
        [, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]],
        [, "(\\d{4})(\\d{4})", "$1-$2", ["[2-57]", "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]],
        [, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"],
        [, "(\\d{5})(\\d{4})", "$1-$2", ["9"]],
        [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"],
        [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]
      ], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [
        ,
        "(\\d{3})(\\d{2,3})(\\d{4})",
        "$1 $2 $3",
        ["(?:[358]|90)0"],
        "0$1"
      ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "30(?:0\\d{5,7}|3\\d{7})|40(?:0\\d|20)\\d{4}|800\\d{6,7}", , , , , , , [8, 9, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BS: [, [, , "(?:242|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
        ,
        ,
        ,
        "2423456789",
        ,
        ,
        ,
        [7]
      ], [, , "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}", , , , "2423591234", , , , [7]], [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , , [7]], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "BS", 1, "011", "1", , , "([3-8]\\d{6})$|1", "242$1", , , , , [, , , , , , , , , [-1]], , "242", [, , , , , , , , , [-1]], [, , "242225\\d{4}", , , , "2422250123"], , , [, , , , , , , , , [-1]]],
      BT: [, [, , "[17]\\d{7}|[2-8]\\d{6}", , , , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], [, , "(?:1[67]|77)\\d{6}", , , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[2-7]"]], [
        ,
        "(\\d)(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[2-68]|7[246]"]
      ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BW: [, [, , "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", , , , , , , [7, 8, 10]], [
        ,
        ,
        "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}",
        ,
        ,
        ,
        "2401234",
        ,
        ,
        [7]
      ], [, , "(?:321|7[1-8]\\d)\\d{5}", , , , "71123456", , , [8]], [, , "(?:0800|800\\d)\\d{6}", , , , "0800012345", , , [10]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["90"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], [
        ,
        "(\\d{3})(\\d{4})(\\d{3})",
        "$1 $2 $3",
        ["8"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BY: [, [, , "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", , , , "152450911", , , [9], [5, 6, 7]], [
        ,
        ,
        "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
        ,
        ,
        ,
        "294911911",
        ,
        ,
        [9]
      ], [, , "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}", , , , "8011234567"], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "0|80?", , "8~10", , [[, "(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], [
        ,
        "(\\d{4})(\\d{2})(\\d{3})",
        "$1 $2-$3",
        ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
        "8 0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BZ: [, [, , "(?:0800\\d|[2-8])\\d{6}", , , , , , , [7, 11]], [, , "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", , , , "2221234", , , [7]], [
        ,
        ,
        "6[0-35-7]\\d{5}",
        ,
        ,
        ,
        "6221234",
        ,
        ,
        [7]
      ], [, , "0800\\d{7}", , , , "08001234123", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CA: [, [, , "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", , , , , , , [7, 10]], [
        ,
        ,
        "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}",
        ,
        ,
        ,
        "5062345678",
        ,
        ,
        [10],
        [7]
      ], [, , "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}", , , , "5062345678", , , [10], [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , [10]], [, , "900[2-9]\\d{6}", , , , "9002123456", , , [10]], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678",
        ,
        ,
        [10]
      ], [, , "600[2-9]\\d{6}", , , , "6002012345", , , [10]], "CA", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "310\\d{4}", , , , "3101234", , , [7]], , , [, , , , , , , , , [-1]]],
      CC: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", , , , "891621234", , , [9], [8]], [
        ,
        ,
        "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
        ,
        ,
        ,
        "412345678",
        ,
        ,
        [9]
      ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CC", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CD: [, [
        ,
        ,
        "[189]\\d{8}|[1-68]\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 9]
      ], [, , "12\\d{7}|[1-6]\\d{6}", , , , "1234567"], [, , "88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", , , , "991234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CF: [, [
        ,
        ,
        "(?:[27]\\d{3}|8776)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[024-7]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CG: [, [, , "222\\d{6}|(?:0\\d|80)\\d{7}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [
        ,
        ,
        "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
        ,
        ,
        ,
        "061234567"
      ], [, , , , , , , , , [-1]], [, , "80[0-2]\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CH: [, [, , "8\\d{11}|[2-9]\\d{8}", , , , , , , [9, 12]], [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", , , [9]], [, , "(?:6[89]|7[235-9])\\d{7}", , , , "781234567", , , [9]], [
        ,
        ,
        "800\\d{6}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [9]
      ], [, , "90[016]\\d{6}", , , , "900123456", , , [9]], [, , "84[0248]\\d{6}", , , , "840123456", , , [9]], [, , "878\\d{6}", , , , "878123456", , , [9]], [, , , , , , , , , [-1]], "CH", 41, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], , [, , "74[0248]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "5[18]\\d{7}", , , , "581234567", , , [9]], , , [
        ,
        ,
        "860\\d{9}",
        ,
        ,
        ,
        "860123456789",
        ,
        ,
        [12]
      ]],
      CI: [, [, , "[02]\\d{9}", , , , , , , [10]], [, , "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}", , , , "2123456789"], [, , "0[157]\\d{8}", , , , "0123456789"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CI", 225, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CK: [, [
        ,
        ,
        "[2-578]\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5]
      ], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[578]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CL: [, [, , "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", , , , , , , [9, 10, 11]], [
        ,
        ,
        "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
        ,
        ,
        ,
        "221234567",
        ,
        ,
        [9]
      ], [, , "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", , , , "221234567", , , [9]], [, , "(?:123|8)00\\d{6}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [
        ,
        ,
        "600\\d{7,8}",
        ,
        ,
        ,
        "6001234567",
        ,
        ,
        [10, 11]
      ], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", , , , , , , 1, [[, "(\\d{4})", "$1", ["1(?:[03-589]|21)|[29]0|78"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],
        "($1)"
      ], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [[, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["60|8"]
      ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , , , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CM: [, [, , "[26]\\d{8}|88\\d{6,7}", , , , , , , [8, 9]], [, , "2(?:22|33)\\d{6}", , , , "222123456", , , [9]], [, , "(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", , , , "671234567", , , [9]], [, , "88\\d{6,7}", , , , "88012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CM", 237, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["88"]
      ], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CN: [, [, , "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [
        ,
        ,
        "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
        ,
        ,
        ,
        "1012345678",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", , , , "13123456789", , , [11]], [, , "(?:(?:10|21)8|8)00\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [
        ,
        ,
        "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
        ,
        ,
        ,
        "4001234567",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "00|1(?:[12]\\d|79)\\d\\d00", "0", , , "(1(?:[12]\\d|79)\\d\\d)|0", , "00", , [
        [, "(\\d{5,6})", "$1", ["1(?:00|2[13])|9[56]", "1(?:00|2(?:1|39))|9[56]", "1(?:00|2(?:1|395))|9[56]"]],
        [, "(\\d{5,6})", "$1", ["1(?:0|23)|781|[1-9]12", "1(?:0|23)|7812|[1-9]123", "1(?:0|23(?:[0-8]|9[0-46-9]))|78123|[1-9]123"]],
        [
          ,
          "(\\d{2})(\\d{5,6})",
          "$1 $2",
          [
            "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
            "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
            "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
          ],
          "0$1",
          "$CC $1"
        ],
        [, "(\\d{3})(\\d{4})", "$1 $2", [
          "[1-9]",
          "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])",
          "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|[3-9]",
          "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))",
          "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:0(?:[0-689]|7[0-79])|1[01459]|2[0-489]|[46]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))"
        ]],
        [, "(\\d{4})(\\d{4})", "$1 $2", ["16[08]"]],
        [
          ,
          "(\\d{3})(\\d{5,6})",
          "$1 $2",
          [
            "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
            "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
            "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
            "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
          ],
          "0$1",
          "$CC $1"
        ],
        [, "(\\d{4})(\\d{4})", "$1 $2", [
          "[1-9]",
          "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
          "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
          "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
        ]],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
        [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
        [
          ,
          "(\\d{3})(\\d{7,8})",
          "$1 $2",
          ["9"]
        ],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
      ], [[
        ,
        "(\\d{2})(\\d{5,6})",
        "$1 $2",
        [
          "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
          "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
          "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
          "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
          "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
        ],
        "0$1",
        "$CC $1"
      ], [
        ,
        "(\\d{3})(\\d{5,6})",
        "$1 $2",
        [
          "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
          "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
          "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
          "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
        ],
        "0$1",
        "$CC $1"
      ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1], [
        ,
        "(\\d{3})(\\d{7,8})",
        "$1 $2",
        ["9"]
      ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}", , , , , , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CO: [, [, , "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", , , , , , , [10, 11], [7]], [
        ,
        ,
        "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60(?:[124-7][2-9]|8[1-9])\\d{6}",
        ,
        ,
        ,
        "6012345678",
        ,
        ,
        [10],
        [7]
      ], [, , "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", , , , "3211234567", , , [10]], [, , "1800\\d{7}", , , , "18001234567", , , [11]], [, , "19(?:0[01]|4[78])\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0([3579]|4(?:[14]4|56))?", , , , [[, "(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)", "0$CC $1"], [
        ,
        "(\\d{3})(\\d{7})",
        "$1 $2",
        ["3[0-357]|91"],
        ,
        "0$CC $1"
      ], [, "(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1"]], [[, "(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CR: [, [, , "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", , , , , , , [8, 10]], [, , "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", , , , "22123456", , , [8]], [
        ,
        ,
        "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
        ,
        ,
        ,
        "83123456",
        ,
        ,
        [8]
      ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "90[059]\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:210[0-6]|4\\d{3}|5100)\\d{4}", , , , "40001234", , , [8]], "CR", 506, "00", , , , "(19(?:0[0-2468]|1[09]|20|66|77|99))", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CU: [, [
        ,
        ,
        "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
        ,
        ,
        ,
        ,
        ,
        ,
        [6, 7, 8, 10],
        [4, 5]
      ], [, , "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}", , , , "71234567", , , , [4, 5]], [, , "(?:5\\d|6[2-4])\\d{6}", , , , "51234567", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , "807\\d{7}", , , , "8071234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], [, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], [
        ,
        "(\\d{3})(\\d{7})",
        "$1 $2",
        ["8"],
        "0$1"
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CV: [, [, , "(?:[2-59]\\d\\d|800)\\d{4}", , , , , , , [7]], [, , "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}", , , , "2211234"], [, , "(?:36|5[1-389]|9\\d)\\d{5}", , , , "9911234"], [, , "800\\d{4}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[3-5]|4[356])\\d{5}", , , , "3401234"], "CV", 238, "0", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      CW: [, [, , "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", , , , , , , [7, 8]], [, , "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}", , , , "94351234"], [, , "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}", , , , "95181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], , [
        ,
        ,
        "955\\d{5}",
        ,
        ,
        ,
        "95581234",
        ,
        ,
        [8]
      ], 1, "[69]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CX: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", , , , "891641234", , , [9], [8]], [, , "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", , , , "412345678", , , [9]], [
        ,
        ,
        "180(?:0\\d{3}|2)\\d{3}",
        ,
        ,
        ,
        "1800123456",
        ,
        ,
        [7, 10]
      ], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CX", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CY: [, [, , "(?:[279]\\d|[58]0)\\d{6}", , , , , , , [8]], [, , "2[2-6]\\d{6}", , , , "22345678"], [
        ,
        ,
        "9(?:10|[4-79]\\d)\\d{5}",
        ,
        ,
        ,
        "96123456"
      ], [, , "800\\d{5}", , , , "80001234"], [, , "90[09]\\d{5}", , , , "90012345"], [, , "80[1-9]\\d{5}", , , , "80112345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "CY", 357, "00", , , , , , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:50|77)\\d{6}", , , , "77123456"], , , [, , , , , , , , , [-1]]],
      CZ: [
        ,
        [, , "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]],
        [, , "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", , , , "212345678", , , [9]],
        [
          ,
          ,
          "(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|190|[2379]\\d\\d))\\d{5}",
          ,
          ,
          ,
          "601123456",
          ,
          ,
          [9]
        ],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]],
        [, , "8[134]\\d{7}", , , , "811234567", , , [9]],
        [, , "70[01]\\d{6}", , , , "700123456", , , [9]],
        [, , "9[17]0\\d{6}", , , , "910123456", , , [9]],
        "CZ",
        420,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "9(?:5\\d|7[2-4])\\d{6}", , , , "972123456", , , [9]],
        ,
        ,
        [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]
      ],
      DE: [, [, , "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [2, 3]], [
        ,
        ,
        "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
        ,
        ,
        ,
        "30123456",
        ,
        ,
        [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        [2, 3, 4]
      ], [, , "15310\\d{6}|1(?:6[023]|7[0-57-9])\\d{7,8}|1(?:5[0-25-9]|76)\\d{8}", , , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", , , , "9001234567", , , [10, 11]], [, , "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], "DE", 49, "00", "0", , , "0", , , , [
        [
          ,
          "(\\d{2})(\\d{3,13})",
          "$1 $2",
          ["3[02]|40|[68]9"],
          "0$1"
        ],
        [, "(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"],
        [
          ,
          "(\\d{4})(\\d{2,11})",
          "$1 $2",
          ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
          "0$1"
        ],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
        [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
        [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
        [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
        [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
        [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
        [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
        [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
        [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
        [, "(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"],
        [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
        [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"],
        [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
        [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]
      ], , [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", , , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [
        ,
        ,
        "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
        ,
        ,
        ,
        "177991234567",
        ,
        ,
        [12, 13]
      ]],
      DJ: [, [, , "(?:2\\d|77)\\d{6}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DK: [, [, , "[2-9]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "(?:(?:2\\d|9[1-46-9])\\d|3(?:[0-37]\\d|4[013]|5[0-58]|6[01347-9]|8[0-8]|9[0-79])|4(?:[0-25]\\d|[34][02-9]|6[013-579]|7[013579]|8[0-47]|9[0-27])|5(?:[0-36]\\d|4[0146-9]|5[03-57-9]|7[0568]|8[0-358]|9[0-69])|6(?:[013578]\\d|2[0-68]|4[02-8]|6[01689]|9[015689])|7(?:[0-69]\\d|7[03-9]|8[0147])|8(?:[16-9]\\d|2[0-58]))\\d{5}",
        ,
        ,
        ,
        "32123456"
      ], [, , "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}", , , , "34412345"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DK", 45, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DM: [, [, , "(?:[58]\\d\\d|767|900)\\d{7}", , , , , , , [10], [7]], [, , "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}", , , , "7674201234", , , , [7]], [
        ,
        ,
        "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",
        ,
        ,
        ,
        "7672251234",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DM", 1, "011", "1", , , "([2-7]\\d{6})$|1", "767$1", , , , , [, , , , , , , , , [-1]], , "767", [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      DO: [
        ,
        [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [, , "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}", , , , "8092345678", , , , [7]],
        [
          ,
          ,
          "8[024]9[2-9]\\d{6}",
          ,
          ,
          ,
          "8092345678",
          ,
          ,
          ,
          [7]
        ],
        [, , "8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "DO",
        1,
        "011",
        "1",
        ,
        ,
        "1",
        ,
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "8001|8[024]9",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      DZ: [, [, , "(?:[1-4]|[5-79]\\d|80)\\d{7}", , , , , , , [8, 9]], [, , "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}", , , , "12345678"], [, , "(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", , , , "551234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]], [, , "80[12]1\\d{5}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , "98[23]\\d{6}", , , , "983123456", , , [9]], "DZ", 213, "00", "0", , , "0", , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[1-4]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      EC: [, [, , "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", , , , , , , [8, 9, 10, 11], [7]], [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]], [, , "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", , , , "991234567", , , [9]], [, , "1800\\d{7}|1[78]00\\d{6}", , , , "18001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]], "EC", 593, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-7]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      EE: [
        ,
        [, , "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", , , , , , , [7, 8, 10]],
        [, , "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", , , , "3212345", , , [7]],
        [, , "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", , , , "51234567", , , [7, 8]],
        [
          ,
          ,
          "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",
          ,
          ,
          ,
          "80012345"
        ],
        [, , "(?:40\\d\\d|900)\\d{4}", , , , "9001234", , , [7, 8]],
        [, , , , , , , , , [-1]],
        [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]],
        [, , , , , , , , , [-1]],
        "EE",
        372,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],
        ,
        [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ],
        ,
        ,
        [, , "800[2-9]\\d{3}", , , , , , , [7]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      EG: [, [, , "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", , , , , , , [8, 9, 10], [6, 7]], [, , "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", , , , "234567890", , , [8, 9], [6, 7]], [, , "1[0-25]\\d{8}", , , , "1001234567", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "EG", 20, "00", "0", , , "0", , , , [[
        ,
        "(\\d)(\\d{7,8})",
        "$1 $2",
        ["[23]"],
        "0$1"
      ], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      EH: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "528[89]\\d{5}", , , , "528812345"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}", , , , "650123456"], [, , "80[0-7]\\d{6}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}", , , , "592401234"], "EH", 212, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , "528[89]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ER: [, [, , "[178]\\d{6}", , , , , , , [7], [6]], [, , "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}", , , , "8370362", , , , [6]], [, , "(?:17[1-3]|7\\d\\d)\\d{4}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ES: [
        ,
        [, , "[5-9]\\d{8}", , , , , , , [9]],
        [, , "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}", , , , "810123456"],
        [, , "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}", , , , "612345678"],
        [, , "[89]00\\d{6}", , , , "800123456"],
        [, , "80[367]\\d{6}", , , , "803123456"],
        [, , "90[12]\\d{6}", , , , "901123456"],
        [, , "70\\d{7}", , , , "701234567"],
        [, , , , , , , , , [-1]],
        "ES",
        34,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{4})", "$1", ["905"]], [, "(\\d{6})", "$1", ["[79]9"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]],
        [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "51\\d{7}", , , , "511234567"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      ET: [, [, , "(?:11|[2-579]\\d)\\d{7}", , , , , , , [9], [7]], [
        ,
        ,
        "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
        ,
        ,
        ,
        "111112345",
        ,
        ,
        ,
        [7]
      ], [, , "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FI: [, [, , "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]], [
        ,
        ,
        "1[35-7][1-8]\\d{3,6}|(?:1[49][1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}",
        ,
        ,
        ,
        "131234567",
        ,
        ,
        [5, 6, 7, 8, 9]
      ], [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FI", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , [[, "(\\d{5})", "$1", ["75[12]"], "0$1"], [, "(\\d{5})", "$1", ["20[2-59]"], "0$1"], [, "(\\d{6})", "$1", ["11"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], [
        ,
        "(\\d{2})(\\d{4,8})",
        "$1 $2",
        ["[14]|2[09]|50|7[135]"],
        "0$1"
      ], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], [[, "(\\d{5})", "$1", ["20[2-59]"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], [, , , , , , , , , [-1]], 1, "1[03-79]|[2-9]", [
        ,
        ,
        "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"
      ], [, , "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}", , , , "10112345"], , , [, , , , , , , , , [-1]]],
      FJ: [, [, , "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", , , , , , , [7, 11]], [, , "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]], [
        ,
        ,
        "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
        ,
        ,
        ,
        "7012345",
        ,
        ,
        [7]
      ], [, , "0800\\d{7}", , , , "08001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FJ", 679, "0(?:0|52)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FK: [
        ,
        [, , "[2-7]\\d{4}", , , , , , , [5]],
        [, , "[2-47]\\d{4}", , , , "31234"],
        [, , "[56]\\d{4}", , , , "51234"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "FK",
        500,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      FM: [, [, , "(?:[39]\\d\\d|820)\\d{4}", , , , , , , [7]], [, , "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}", , , , "3201234"], [, , "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}", , , , "3501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], , [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FO: [, [, , "[2-9]\\d{5}", , , , , , , [6]], [, , "(?:20|[34]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d|9[16])\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [, , "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d", , , , "901123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6[0-36]|88)\\d{4}", , , , "601234"], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", ["[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FR: [, [
        ,
        ,
        "[1-9]\\d{8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9]
      ], [, , "(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}", , , , "123456789"], [, , "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}", , , , "612345678"], [, , "80[0-5]\\d{6}", , , , "801234567"], [, , "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}", , , , "891123456"], [, , "8(?:1[01]|2[0156]|4[024]|84)\\d{6}", , , , "884012345"], [, , , , , , , , , [-1]], [, , "9\\d{8}", , , , "912345678"], "FR", 33, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["10"]], [
        ,
        "(\\d{3})(\\d{3})",
        "$1 $2",
        ["1"]
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "80[6-9]\\d{6}", , , , "806123456"], , , [, , , , , , , , , [-1]]],
      GA: [, [, , "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", , , , , , , [7, 8]], [, , "[01]1\\d{6}", , , , "01441234", , , [8]], [
        ,
        ,
        "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",
        ,
        ,
        ,
        "06031234"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GB: [, [
        ,
        ,
        "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 9, 10],
        [4, 5, 6, 8]
      ], [
        ,
        ,
        "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
        ,
        ,
        ,
        "1212345678",
        ,
        ,
        [9, 10],
        [4, 5, 6, 7, 8]
      ], [, , "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", , , , "7400123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [
        ,
        ,
        "56\\d{8}",
        ,
        ,
        ,
        "5612345678",
        ,
        ,
        [10]
      ], "GB", 44, "00", "0", " x", , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", [
        "[25]|7(?:0|6[02-9])",
        "[25]|7(?:0|6(?:[03-9]|2[356]))"
      ], "0$1"], [, "(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456", , , [10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
      GD: [, [, , "(?:473|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[579]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
        ,
        ,
        ,
        "4732691234",
        ,
        ,
        ,
        [7]
      ], [, , "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[68])|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], "GD", 1, "011", "1", , , "([2-9]\\d{6})$|1", "473$1", , , , , [, , , , , , , , , [-1]], , "473", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GE: [, [, , "(?:[3-57]\\d\\d|800)\\d{6}", , , , , , , [9], [6, 7]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , , "322123456", , , , [6, 7]], [
        ,
        ,
        "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|111|22[02]|77\\d)|1(?:1(?:[03][01]|[124]\\d)|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}",
        ,
        ,
        ,
        "555123456"
      ], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70[67]\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "70[67]\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GF: [, [
        ,
        ,
        "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9]
      ], [, , "594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}", , , , "594101234"], [, , "694(?:[0-249]\\d|3[0-8])\\d{4}", , , , "694201234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}", , , , "976012345"], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      GG: [, [, , "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", , , , , , , [7, 9, 10], [6]], [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]], [, , "7(?:(?:781|839)\\d|911[17])\\d{5}", , , , "7781123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GG", 44, "00", "0", , , "([25-9]\\d{5})$|0", "1481$1", , , , , [
        ,
        ,
        "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
        ,
        ,
        ,
        "7640123456",
        ,
        ,
        [10]
      ], , , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
      GH: [, [, , "(?:[235]\\d{3}|800)\\d{5}", , , , , , , [8, 9], [7]], [, , "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", , , , "302345678", , , [9], [7]], [, , "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", , , , "231234567", , , [9]], [
        ,
        ,
        "800\\d{5}",
        ,
        ,
        ,
        "80012345",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[237]|8[0-2]"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [[, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GI: [, [, , "(?:[25]\\d|60)\\d{6}", , , , , , , [8]], [
        ,
        ,
        "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
        ,
        ,
        ,
        "20012345"
      ], [, , "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GL: [
        ,
        [, , "(?:19|[2-689]\\d|70)\\d{4}", , , , , , , [6]],
        [, , "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}", , , , "321000"],
        [, , "[245]\\d{5}", , , , "221234"],
        [, , "80\\d{4}", , , , "801234"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "3[89]\\d{4}", , , , "381234"],
        "GL",
        299,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GM: [
        ,
        [, , "[2-9]\\d{6}", , , , , , , [7]],
        [, , "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}", , , , "5661234"],
        [, , "(?:[23679]\\d|5[0-489])\\d{5}", , , , "3012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "GM",
        220,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GN: [, [, , "722\\d{6}|(?:3|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", , , , "30241234", , , [8]], [, , "6[0-356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "722\\d{6}", , , , "722123456", , , [9]], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[67]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GP: [
        ,
        [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
        [, , "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}", , , , "590201234"],
        [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}", , , , "690001234"],
        [, , "80[0-5]\\d{6}", , , , "800012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"],
        "GP",
        590,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        1,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GQ: [, [, , "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", , , , , , , [9]], [, , "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}", , , , "333091234"], [, , "(?:222|55\\d)\\d{6}", , , , "222123456"], [, , "80\\d[1-9]\\d{5}", , , , "800123456"], [, , "90\\d[1-9]\\d{5}", , , , "900123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], "GQ", 240, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GR: [, [, , "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", , , , , , , [10, 11, 12]], [
        ,
        ,
        "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
        ,
        ,
        ,
        "2123456789",
        ,
        ,
        [10]
      ], [, , "68[57-9]\\d{7}|(?:69|94)\\d{8}", , , , "6912345678", , , [10]], [, , "800\\d{7,9}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567", , , [10]], [, , "8(?:0[16]|12|[27]5|50)\\d{7}", , , , "8011234567", , , [10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], [
        ,
        "(\\d{3})(\\d{3,4})(\\d{5})",
        "$1 $2 $3",
        ["8"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "5005000\\d{3}", , , , "5005000123", , , [10]], , , [, , , , , , , , , [-1]]],
      GT: [, [, , "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", , , , , , , [8, 11]], [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]], [, , "(?:[3-5]\\d\\d|80[0-4])\\d{5}", , , , "51234567", , , [8]], [, , "18[01]\\d{8}", , , , "18001112222", , , [11]], [, , "19\\d{9}", , , , "19001112222", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GT", 502, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], [
        ,
        "(\\d{4})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["1"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GU: [, [, , "(?:[58]\\d\\d|671|900)\\d{7}", , , , , , , [10], [7]], [, , "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [
        ,
        ,
        "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
        ,
        ,
        ,
        "6713001234",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GU", 1, "011", "1", , , "([2-9]\\d{6})$|1", "671$1", , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      GW: [, [, , "[49]\\d{8}|4\\d{6}", , , , , , , [7, 9]], [, , "443\\d{6}", , , , "443201234", , , [9]], [, , "9(?:5\\d|6[569]|77)\\d{6}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["40"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GY: [, [, , "(?:[2-8]\\d{3}|9008)\\d{3}", , , , , , , [7]], [
        ,
        ,
        "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
        ,
        ,
        ,
        "2201234"
      ], [, , "510\\d{4}|(?:6\\d|7[0-5])\\d{5}", , , , "6091234"], [, , "(?:289|8(?:00|6[28]|88|99))\\d{4}", , , , "2891234"], [, , "9008\\d{3}", , , , "9008123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "515\\d{4}", , , , "5151234"], "GY", 592, "001", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      HK: [
        ,
        [, , "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", , , , , , , [5, 6, 7, 8, 9, 11]],
        [
          ,
          ,
          "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}",
          ,
          ,
          ,
          "21234567",
          ,
          ,
          [8]
        ],
        [, , "(?:4(?:44[0-25-9]|6(?:1[0-7]|4[0-57-9]|6[0-4]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-8]|8[0-4])|848[0-35-9]|9(?:29[013-9]|39[01]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|70)|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-39]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", , , , "51234567", , , [8]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "900(?:[0-24-9]\\d{7}|3\\d{1,4})", , , , "90012345678", , , [5, 6, 7, 8, 11]],
        [, , , , , , , , , [-1]],
        [, , "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", , , , "81123456", , , [8]],
        [, , , , , , , , , [-1]],
        "HK",
        852,
        "00(?:30|5[09]|[126-9]?)",
        ,
        ,
        ,
        ,
        ,
        "00",
        ,
        [[, "(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]],
        ,
        [
          ,
          ,
          "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
          ,
          ,
          ,
          "71123456",
          ,
          ,
          [8]
        ],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", , , , "30161234", , , [8]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      HN: [, [, , "8\\d{10}|[237-9]\\d{7}", , , , , , , [8, 11]], [
        ,
        ,
        "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
        ,
        ,
        ,
        "22123456",
        ,
        ,
        [8]
      ], [, , "[37-9]\\d{7}", , , , "91234567", , , [8]], [, , "8002\\d{7}", , , , "80021234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], [, , , , , , , , , [-1]], , , [, , "8002\\d{7}", , , , , , , [11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      HR: [, [, , "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", , , , , , , [6, 7, 8, 9]], [
        ,
        ,
        "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
        ,
        ,
        ,
        "12345678",
        ,
        ,
        [8, 9],
        [6, 7]
      ], [, , "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-7])))\\d{4}|98\\d{6}", , , , "921234567", , , [8, 9]], [, , "80\\d{5,7}", , , , "800123456", , , [7, 8, 9]], [, , "6[01459]\\d{6}|6[01]\\d{4,5}", , , , "611234", , , [6, 7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", , , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [
        ,
        "(\\d)(\\d{4})(\\d{3})",
        "$1 $2 $3",
        ["1"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "62\\d{6,7}|72\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]],
      HT: [, [, , "(?:[2-489]\\d|55)\\d{6}", , , , , , , [8]], [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"], [, , "(?:[34]\\d|55)\\d{6}", , , , "34101234"], [
        ,
        ,
        "8\\d{7}",
        ,
        ,
        ,
        "80012345"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}", , , , "98901234"], "HT", 509, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      HU: [, [, , "[235-7]\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", , , , "12345678", , , [8], [6, 7]], [, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]], [
        ,
        ,
        "(?:[48]0\\d|680[29])\\d{5}",
        ,
        ,
        ,
        "80123456"
      ], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "21\\d{7}", , , , "211234567", , , [9]], "HU", 36, "00", "06", , , "06", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], , [, , , , , , , , , [-1]], , , [, , "(?:[48]0\\d|680[29])\\d{5}"], [, , "38\\d{7}", , , , "381234567", , , [9]], , , [, , , , , , , , , [-1]]],
      ID: [, [
        ,
        ,
        "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 8, 9, 10, 11, 12, 13],
        [5, 6]
      ], [
        ,
        ,
        "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
        ,
        ,
        ,
        "218350123",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , "8[1-35-9]\\d{7,10}", , , , "812345678", , , [9, 10, 11, 12]], [, , "00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}", , , , "8001234567", , , [8, 9, 10, 11, 12, 13]], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , "804\\d{7}", , , , "8041234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ID", 62, "00[89]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [
        ,
        "(\\d{3})(\\d{5,8})",
        "$1 $2",
        ["[2-79]"],
        "(0$1)"
      ], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["001"]], [, "(\\d{2})(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [
        ,
        "(\\d{2})(\\d{5,9})",
        "$1 $2",
        ["2[124]|[36]1"],
        "(0$1)"
      ], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "001803\\d{6,7}|(?:007803\\d|8071)\\d{6}", , , , , , , [10, 12, 13]], [
        ,
        ,
        "(?:1500|8071\\d{3})\\d{3}",
        ,
        ,
        ,
        "8071123456",
        ,
        ,
        [7, 10]
      ], , , [, , , , , , , , , [-1]]],
      IE: [, [, , "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", , , , , , , [7, 8, 9, 10], [5, 6]], [, , "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}", , , , "2212345", , , , [5, 6]], [, , "8(?:22|[35-9]\\d)\\d{6}", , , , "850123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "15(?:1[2-8]|[2-8]0|9[089])\\d{6}", , , , "1520123456", , , [10]], [
        ,
        ,
        "18[59]0\\d{6}",
        ,
        ,
        ,
        "1850123456",
        ,
        ,
        [10]
      ], [, , "700\\d{6}", , , , "700123456", , , [9]], [, , "76\\d{7}", , , , "761234567", , , [9]], "IE", 353, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["[78]"],
        "0$1"
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], [, "(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "18[59]0\\d{6}", , , , , , , [10]], [, , "818\\d{6}", , , , "818123456", , , [9]], , , [, , "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", , , , "8551234567", , , [10]]],
      IL: [, [, , "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", , , , , , , [7, 8, 9, 10, 11, 12]], [
        ,
        ,
        "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
        ,
        ,
        ,
        "21234567",
        ,
        ,
        [8, 11, 12],
        [7]
      ], [, , "55(?:410|57[0-289])\\d{4}|5(?:(?:[02][02-9]|[149][2-9]|[36]\\d|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", , , , "502345678", , , [9]], [, , "1(?:255|80[019]\\d{3})\\d{3}", , , , "1800123456", , , [7, 10]], [, , "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", , , , "1919123456", , , [8, 10]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [
        ,
        ,
        "7(?:38(?:0\\d|5[0-2569]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
        ,
        ,
        ,
        "771234567",
        ,
        ,
        [9]
      ], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [[, "(\\d{4})(\\d{3})", "$1-$2", ["125"]], [, "(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], [, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], [, "(\\d{4})(\\d{6})", "$1-$2", ["159"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], [, "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], , [, , , , , , , , , [-1]], , , [
        ,
        ,
        "1700\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [10]
      ], [, , "1599\\d{6}", , , , "1599123456", , , [10]], , , [, , "151\\d{8,9}", , , , "15112340000", , , [11, 12]]],
      IM: [
        ,
        [, , "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]],
        [, , "1624(?:230|[5-8]\\d\\d)\\d{3}", , , , "1624756789", , , , [6]],
        [, , "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}", , , , "7924123456"],
        [, , "808162\\d{4}", , , , "8081624567"],
        [, , "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}", , , , "9016247890"],
        [, , , , , , , , , [-1]],
        [, , "70\\d{8}", , , , "7012345678"],
        [, , "56\\d{8}", , , , "5612345678"],
        "IM",
        44,
        "00",
        "0",
        ,
        ,
        "([25-8]\\d{5})$|0",
        "1624$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "74576|(?:16|7[56])24",
        [, , , , , , , , , [-1]],
        [, , "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}", , , , "5512345678"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      IN: [, [, , "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [
        ,
        ,
        "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
        ,
        ,
        ,
        "7410410123",
        ,
        ,
        [10],
        [6, 7, 8]
      ], [
        ,
        ,
        "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
        ,
        ,
        ,
        "8123456789",
        ,
        ,
        [10]
      ], [, , "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{7})", "$1", ["575"]], [, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["140"],
        ,
        ,
        1
      ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        [
          "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
        ],
        "0$1",
        ,
        1
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
      ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3 $4",
        ["0"]
      ], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], , , 1]], [[, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], , , 1], [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
        "0$1",
        ,
        1
      ], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        [
          "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
        ],
        "0$1",
        ,
        1
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
      ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
        ,
        "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3 $4",
        ["18"],
        ,
        ,
        1
      ]], [, , , , , , , , , [-1]], , , [, , "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"], [, , "140\\d{7}", , , , "1409305260", , , [10]], , , [, , , , , , , , , [-1]]],
      IO: [, [, , "3\\d{6}", , , , , , , [7]], [, , "37\\d{5}", , , , "3709100"], [, , "38\\d{5}", , , , "3801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IO", 246, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      IQ: [, [
        ,
        ,
        "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10],
        [6, 7]
      ], [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IQ", 964, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      IR: [
        ,
        [, , "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", , , , , , , [4, 5, 6, 7, 10], [8]],
        [, , "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", , , , "2123456789", , , [6, 7, 10], [4, 5, 8]],
        [, , "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", , , , "9123456789", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "IR",
        98,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))", , , , , , , [4, 5, 10]],
        [
          ,
          ,
          "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
          ,
          ,
          ,
          "9601",
          ,
          ,
          [4, 5]
        ],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      IS: [, [, , "(?:38\\d|[4-9])\\d{6}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", , , , "4101234", , , [7]], [, , "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}", , , , "6111234"], [, , "80[0-8]\\d{4}", , , , "8001234", , , [7]], [
        ,
        ,
        "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
        ,
        ,
        ,
        "9001234",
        ,
        ,
        [7]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49[0-24-79]\\d{4}", , , , "4921234", , , [7]], "IS", 354, "00|1(?:0(?:01|[12]0)|100)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:689|8(?:7[18]|80)|95[48])\\d{4}", , , , "6891234", , , [7]]],
      IT: [, [, , "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [
        ,
        ,
        "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
        ,
        ,
        ,
        "0212345678",
        ,
        ,
        [6, 7, 8, 9, 10, 11]
      ], [, , "3[2-9]\\d{7,8}|(?:31|43)\\d{8}", , , , "3123456789", , , [9, 10]], [, , "80(?:0\\d{3}|3)\\d{3}", , , , "800123456", , , [6, 9]], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "IT", 39, "00", , , , , , , , [
        [, "(\\d{4,5})", "$1", ["1(?:0|9[246])", "1(?:0|9(?:2[2-9]|[46]))"]],
        [, "(\\d{6})", "$1", ["1(?:1|92)"]],
        [, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]],
        [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],
        [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]],
        [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]],
        [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]],
        [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]],
        [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
        [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]
      ], [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [
        ,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["1(?:44|[679])|[378]|43"]
      ], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
      JE: [, [, , "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [
        ,
        ,
        "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}",
        ,
        ,
        ,
        "7797712345"
      ], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , , , , , , , , [-1]], [, , "701511\\d{4}", , , , "7015115678"], [, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", , , "([0-24-8]\\d{5})$|0", "1534$1", , , , , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
        ,
        ,
        ,
        "5512345678"
      ], , , [, , , , , , , , , [-1]]],
      JM: [, [, , "(?:[58]\\d\\d|658|900)\\d{7}", , , , , , , [10], [7]], [, , "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}", , , , "8765230123", , , , [7]], [
        ,
        ,
        "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
        ,
        ,
        ,
        "8762101234",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "658|876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      JO: [, [, , "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", , , , , , , [8, 9]], [
        ,
        ,
        "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
        ,
        ,
        ,
        "62001234",
        ,
        ,
        [8]
      ], [, , "7(?:[78][0-25-9]|9\\d)\\d{6}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "9\\d{7}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [
        ,
        ,
        "74(?:66|77)\\d{5}",
        ,
        ,
        ,
        "746612345",
        ,
        ,
        [9]
      ], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]],
      JP: [, [, , "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", , , , "312345678", , , [9]], [
        ,
        ,
        "[7-9]0[1-9]\\d{7}",
        ,
        ,
        ,
        "9012345678",
        ,
        ,
        [10]
      ], [, , "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}", , , , "120123456"], [, , "990\\d{6}", , , , "990123456", , , [9]], [, , , , , , , , , [-1]], [, , "60\\d{7}", , , , "601234567", , , [9]], [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]], "JP", 81, "010", "0", , , "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077", "00777", "00777[01]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
        ,
        "(\\d{4})(\\d)(\\d{4})",
        "$1-$2-$3",
        ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
        "0$1"
      ], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        ["60"],
        "0$1"
      ], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        [
          "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
        ],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007", "0077"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["0"]], [
        ,
        "(\\d{4})(\\d{6})(\\d{6,7})",
        "$1-$2-$3",
        ["0"]
      ]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
        ,
        "(\\d{4})(\\d)(\\d{4})",
        "$1-$2-$3",
        ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        [
          "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
        ],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], [, , "20\\d{8}", , , , "2012345678", , , [10]], , , [, , "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"], [, , "570\\d{6}", , , , "570123456", , , [9]], , , [, , , , , , , , , [-1]]],
      KE: [, [, , "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", , , , , , , [7, 8, 9, 10]], [
        ,
        ,
        "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
        ,
        ,
        ,
        "202012345",
        ,
        ,
        [7, 8, 9]
      ], [, , "(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", , , , "712123456", , , [9]], [, , "800[02-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KG: [, [
        ,
        ,
        "8\\d{9}|[235-9]\\d{8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9, 10],
        [5, 6]
      ], [, , "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", , , , "312123456", , , [9], [5, 6]], [, , "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", , , , "700123456", , , [9]], [, , "800\\d{6,7}", , , , "800123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KG", 996, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KH: [
        ,
        [, , "1\\d{9}|[1-9]\\d{7,8}", , , , , , , [8, 9, 10], [6, 7]],
        [
          ,
          ,
          "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
          ,
          ,
          ,
          "23756789",
          ,
          ,
          [8, 9],
          [6, 7]
        ],
        [, , "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", , , , "91234567", , , [8, 9]],
        [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]],
        [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "KH",
        855,
        "00[14-9]",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      KI: [, [, , "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", , , , , , , [5, 8]], [, , "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}", , , , "31234"], [
        ,
        ,
        "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
        ,
        ,
        ,
        "72001234",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", , , , "30010000", , , [8]], "KI", 686, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KM: [, [, , "[3478]\\d{6}", , , , , , , [7], [4]], [, , "7[4-7]\\d{5}", , , , "7712345", , , , [4]], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "8\\d{6}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[
        ,
        "(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3",
        ["[3478]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KN: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}", , , , "8692361234", , , , [7]], [, , "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "KN", 1, "011", "1", , , "([2-7]\\d{6})$|1", "869$1", , , , , [, , , , , , , , , [-1]], , "869", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KP: [, [, , "85\\d{6}|(?:19\\d|[2-7])\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}", , , , "21234567", , , , [6, 7]], [, , "19[1-3]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[
        ,
        "(\\d{2})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["8"],
        "0$1"
      ], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KR: [, [, , "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", , , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 4, 7]], [
        ,
        ,
        "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
        ,
        ,
        ,
        "22123456",
        ,
        ,
        [5, 6, 8, 9, 10],
        [3, 4, 7]
      ], [, , "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", , , , "1020000000", , , [9, 10]], [, , "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", , , , "801234567", , , [9, 11, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8,9}", , , , "5012345678", , , [10, 11]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "0", , , "0(8(?:[1-46-8]|5\\d\\d))?", , , , [[
        ,
        "(\\d{5})",
        "$1",
        ["1[016-9]1", "1[016-9]11", "1[016-9]114"],
        "0$1"
      ], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030"]], [
        ,
        "(\\d{2})(\\d{5})(\\d{4})",
        "$1-$2-$3",
        ["5"],
        "0$1",
        "0$CC-$1"
      ], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [
        [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"],
        [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]],
        [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"],
        [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"]
      ], [, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]], , , [, , "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})", , , , , , , [11, 12, 13, 14]], [, , "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], , , [, , , , , , , , , [-1]]],
      KW: [, [, , "18\\d{5}|(?:[2569]\\d|41)\\d{6}", , , , , , , [7, 8]], [, , "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", , , , "22345678", , , [8]], [
        ,
        ,
        "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
        ,
        ,
        ,
        "50012345",
        ,
        ,
        [8]
      ], [, , "18\\d{5}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KY: [, [, , "(?:345|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}",
        ,
        ,
        ,
        "3452221234",
        ,
        ,
        ,
        [7]
      ], [, , "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "(?:345976|900[2-9]\\d\\d)\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "KY", 1, "011", "1", , , "([2-9]\\d{6})$|1", "345$1", , , , , [, , "345849\\d{4}", , , , "3458491234"], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KZ: [, [, , "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", , , , , , , [10, 14], [5, 6, 7]], [
        ,
        ,
        "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
        ,
        ,
        ,
        "7123456789",
        ,
        ,
        [10],
        [5, 6, 7]
      ], [, , "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", , , , "7710009998", , , [10]], [, , "8(?:00|108\\d{3})\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , "751\\d{7}", , , , "7511234567", , , [10]], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , "33|7", [, , "751\\d{7}", , , , , , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LA: [, [, , "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", , , , , , , [8, 9, 10], [6]], [
        ,
        ,
        "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
        ,
        ,
        ,
        "21212862",
        ,
        ,
        [8],
        [6]
      ], [, , "208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}", , , , "2023123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LA", 856, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "30[0135-9]\\d{6}", , , , "301234567", , , [9]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      LB: [, [, , "[27-9]\\d{7}|[13-9]\\d{6}", , , , , , , [7, 8]], [, , "7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}", , , , "1123456"], [, , "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", , , , "80123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[
        ,
        "(\\d)(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LC: [
        ,
        [, , "(?:[58]\\d\\d|758|900)\\d{7}", , , , , , , [10], [7]],
        [, , "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}", , , , "7584305678", , , , [7]],
        [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}", , , , "7582845678", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "LC",
        1,
        "011",
        "1",
        ,
        ,
        "([2-8]\\d{6})$|1",
        "758$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "758",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      LI: [, [, , "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", , , , , , , [7, 9]], [
        ,
        ,
        "(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
        ,
        ,
        ,
        "2345678",
        ,
        ,
        [7]
      ], [, , "(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}", , , , "660234567"], [, , "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}", , , , "8002222"], [, , "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", , , , "9002222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LI", 423, "00", "0", , , "(1001)|0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["69"],
        ,
        "$CC $1"
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d\\d", , , , "8702812", , , [7]], , , [, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]],
      LK: [, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}", , , , "112345678", , , , [7]], [, , "7(?:[0-25-8]\\d|4[0-4])\\d{6}", , , , "712345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], "LK", 94, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "1973\\d{5}", , , , "197312345"], , , [, , , , , , , , , [-1]]],
      LR: [, [, , "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", , , , , , , [7, 8, 9]], [, , "2\\d{7}", , , , "21234567", , , [8]], [, , "(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [
        ,
        ,
        "332(?:02|[34]\\d)\\d{4}",
        ,
        ,
        ,
        "332021234",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LS: [, [, , "(?:[256]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[1256]\\d{4}", , , , "80021234"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LT: [
        ,
        [, , "(?:[3469]\\d|52|[78]0)\\d{6}", , , , , , , [8]],
        [, , "(?:3[1478]|4[124-6]|52)\\d{6}", , , , "31234567"],
        [, , "6\\d{7}", , , , "61234567"],
        [, , "80[02]\\d{5}", , , , "80012345"],
        [, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"],
        [, , "808\\d{5}", , , , "80812345"],
        [, , "70[05]\\d{5}", , , , "70012345"],
        [, , "[89]01\\d{5}", , , , "80123456"],
        "LT",
        370,
        "00",
        "0",
        ,
        ,
        "[08]",
        ,
        ,
        ,
        [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", , 1], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", , 1], [, "(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", , 1], [, "(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", , 1]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "70[67]\\d{5}", , , , "70712345"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      LU: [, [, , "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11]], [
        ,
        ,
        "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
        ,
        ,
        ,
        "27123456"
      ], [, , "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , , , , , , , , [-1]], [, , "20(?:1\\d{5}|[2-689]\\d{1,7})", , , , "20201234", , , [4, 5, 6, 7, 8, 9, 10]], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3",
        ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
        ,
        "$CC $1"
      ], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
        "$1 $2 $3 $4",
        ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],
        ,
        "$CC $1"
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LV: [, [, , "(?:[268]\\d|90)\\d{6}", , , , , , , [8]], [, , "6\\d{7}", , , , "63123456"], [, , "23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[269]|8[01]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LY: [
        ,
        [, , "[2-9]\\d{8}", , , , , , , [9], [7]],
        [, , "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}", , , , "212345678", , , , [7]],
        [, , "9[1-6]\\d{7}", , , , "912345678"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "LY",
        218,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MA: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}", , , , "520123456"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}", , , , "650123456"], [, , "80[0-7]\\d{6}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
        ,
        ,
        ,
        "592401234"
      ], "MA", 212, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], [, "(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], [, "(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MC: [
        ,
        [, , "(?:[3489]|6\\d)\\d{7}", , , , , , , [8, 9]],
        [, , "(?:870|9[2-47-9]\\d)\\d{5}", , , , "99123456", , , [8]],
        [, , "4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}", , , , "612345678"],
        [, , "(?:800|90\\d)\\d{5}", , , , "90123456", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "MC",
        377,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["87"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]],
        [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [
          ,
          "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
          "$1 $2 $3 $4 $5",
          ["6"],
          "0$1"
        ]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "8[07]0\\d{5}", , , , , , , [8]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MD: [, [, , "(?:[235-7]\\d|[89]0)\\d{6}", , , , , , , [8]], [, , "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"], [, , "562\\d{5}|(?:6\\d|7[16-9])\\d{6}", , , , "62112345"], [, , "800\\d{5}", , , , "80012345"], [, , "90[056]\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , , , , , , , , [-1]], [, , "3[08]\\d{6}", , , , "30123456"], "MD", 373, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["22|3"],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "803\\d{5}", , , , "80312345"], , , [, , , , , , , , , [-1]]],
      ME: [, [, , "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", , , , , , , [8, 9], [6]], [, , "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", , , , "30234567", , , [8], [6]], [, , "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", , , , "67622901", , , [8]], [, , "80(?:[0-2578]|9\\d)\\d{5}", , , , "80080002"], [
        ,
        ,
        "9(?:4[1568]|5[178])\\d{5}",
        ,
        ,
        ,
        "94515151",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780", , , [8]], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012", , , [8]], , , [, , , , , , , , , [-1]]],
      MF: [
        ,
        [, , "590\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
        [, , "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}", , , , "590271234"],
        [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}", , , , "690001234"],
        [, , "80[0-5]\\d{6}", , , , "800012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}", , , , "976012345"],
        "MF",
        590,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MG: [
        ,
        [, , "[23]\\d{8}", , , , , , , [9], [7]],
        [, , "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}", , , , "202123456", , , , [7]],
        [, , "3[2-47-9]\\d{7}", , , , "321234567"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "22\\d{7}", , , , "221234567"],
        "MG",
        261,
        "00",
        "0",
        ,
        ,
        "([24-9]\\d{6})$|0",
        "20$1",
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MH: [, [, , "329\\d{4}|(?:[256]\\d|45)\\d{5}", , , , , , , [7]], [, , "(?:247|528|625)\\d{4}", , , , "2471234"], [, , "(?:(?:23|54)5|329|45[35-8])\\d{4}", , , , "2351234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "635\\d{4}", , , , "6351234"], "MH", 692, "011", "1", , , "1", , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MK: [, [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]], [, , "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}", , , , "22012345", , , , [6, 7]], [, , "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|6[01]|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}", , , , "72345678"], [
        ,
        ,
        "800\\d{5}",
        ,
        ,
        ,
        "80012345"
      ], [, , "5\\d{7}", , , , "50012345"], [, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MK", 389, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ML: [, [, , "[24-9]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",
        ,
        ,
        ,
        "20212345"
      ], [, , "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}", , , , "65012345"], [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ML", 223, "00", , , , , , , , [[, "(\\d{4})", "$1", ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [, , , , , , , , , [-1]], , , [, , "80\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MM: [
        ,
        [, , "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", , , , , , , [6, 7, 8, 9, 10], [5]],
        [
          ,
          ,
          "(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:(?:3\\d|8[01459])\\d|4[67]0)))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
          ,
          ,
          ,
          "1234567",
          ,
          ,
          [6, 7, 8, 9],
          [5]
        ],
        [, , "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", , , , "92123456", , , [7, 8, 9, 10]],
        [, , "80080(?:0[1-9]|2\\d)\\d{3}", , , , "8008001234", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "1333\\d{4}|[12]468\\d{4}", , , , "13331234", , , [8]],
        "MM",
        95,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [
          ,
          "(\\d{2})(\\d{2})(\\d{3})",
          "$1 $2 $3",
          ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],
          "0$1"
        ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], [, "(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], [, "(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]],
        ,
        [
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          [-1]
        ],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MN: [, [, , "[12]\\d{7,9}|[5-9]\\d{7}", , , , , , , [8, 9, 10], [4, 5, 6]], [, , "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}", , , , "53123456", , , , [4, 5, 6]], [, , "(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}", , , , "88123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}",
        ,
        ,
        ,
        "75123456",
        ,
        ,
        [8]
      ], "MN", 976, "001", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MO: [, [, , "0800\\d{3}|(?:28|[68]\\d)\\d{6}", , , , , , , [7, 8]], [
        ,
        ,
        "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
        ,
        ,
        ,
        "28212345",
        ,
        ,
        [8]
      ], [, , "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", , , , "66123456", , , [8]], [, , "0800\\d{3}", , , , "0800501", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , [[, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MP: [, [, , "[58]\\d{9}|(?:67|90)0\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
        ,
        ,
        ,
        "6702345678",
        ,
        ,
        ,
        [7]
      ], [, , "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "([2-9]\\d{6})$|1", "670$1", , 1, , , [, , , , , , , , , [-1]], , "670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MQ: [
        ,
        [, , "596\\d{6}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
        [, , "596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])\\d{4}", , , , "596301234"],
        [, , "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}", , , , "696201234"],
        [, , "80[0-5]\\d{6}", , , , "800012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}", , , , "976612345"],
        "MQ",
        596,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MR: [, [, , "(?:[2-4]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "(?:25[08]|35\\d|45[1-7])\\d{5}", , , , "35123456"], [, , "[2-4][0-46-9]\\d{6}", , , , "22123456"], [, , "800\\d{5}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MR", 222, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[2-48]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MS: [, [, , "(?:[58]\\d\\d|664|900)\\d{7}", , , , , , , [10], [7]], [, , "6644(?:1[0-3]|91)\\d{4}", , , , "6644912345", , , , [7]], [, , "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}", , , , "6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "([34]\\d{6})$|1", "664$1", , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MT: [, [, , "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}", , , , "21001234"], [, , "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}", , , , "96961234"], [, , "800(?:02|[3467]\\d)\\d{3}", , , , "80071234"], [
        ,
        ,
        "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
        ,
        ,
        ,
        "50037123"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], , [, , "7117\\d{4}", , , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", , , , "50112345"], , , [, , , , , , , , , [-1]]],
      MU: [, [, , "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", , , , , , , [7, 8, 10]], [, , "(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", , , , "54480123", , , [7, 8]], [
        ,
        ,
        "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}",
        ,
        ,
        ,
        "52512345",
        ,
        ,
        [8]
      ], [, , "802\\d{7}|80[0-2]\\d{4}", , , , "8001234", , , [7, 10]], [, , "30\\d{5}", , , , "3012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[24-7]0|3[03])", , , , , , "020", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], [, "(\\d{5})(\\d{5})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MV: [, [, , "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", , , , , , , [7, 10]], [
        ,
        ,
        "(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
        ,
        ,
        ,
        "6701234",
        ,
        ,
        [7]
      ], [, , "(?:46[46]|[79]\\d\\d)\\d{4}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "4(?:0[01]|50)\\d{4}", , , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]],
      MW: [, [, , "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", , , , , , , [7, 9]], [
        ,
        ,
        "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
        ,
        ,
        ,
        "1234567"
      ], [, , "111\\d{6}|(?:31|77|[89][89])\\d{7}", , , , "991234567", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MW", 265, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MX: [, [, , "[2-9]\\d{9}", , , , , , , [10], [7, 8]], [
        ,
        ,
        "657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
        ,
        ,
        ,
        "2001234567",
        ,
        ,
        ,
        [7, 8]
      ], [, , "657[12]\\d{6}|(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}", , , , "2221234567", , , , [7, 8]], [
        ,
        ,
        "8(?:00|88)\\d{7}",
        ,
        ,
        ,
        "8001234567"
      ], [, , "900\\d{7}", , , , "9001234567"], [, , "300\\d{7}", , , , "3001234567"], [, , "500\\d{7}", , , , "5001234567"], [, , , , , , , , , [-1]], "MX", 52, "0[09]", , , , , , "00", , [[, "(\\d{5})", "$1", ["53"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MY: [, [
        ,
        ,
        "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10],
        [6, 7]
      ], [, , "4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", , , , "323856789", , , [8, 9], [6, 7]], [
        ,
        ,
        "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
        ,
        ,
        ,
        "123456789",
        ,
        ,
        [9, 10]
      ], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", , , , "1546012345", , , [10]], "MY", 60, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], [
        ,
        "(\\d)(\\d{4})(\\d{4})",
        "$1-$2 $3",
        ["3"],
        "0$1"
      ], [, "(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MZ: [
        ,
        [, , "(?:2|8\\d)\\d{7}", , , , , , , [8, 9]],
        [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]],
        [, , "8[2-79]\\d{7}", , , , "821234567", , , [9]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "MZ",
        258,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      NA: [, [, , "[68]\\d{7,8}", , , , , , , [8, 9]], [
        ,
        ,
        "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
        ,
        ,
        ,
        "61221234"
      ], [, , "(?:60|8[1245])\\d{7}", , , , "811234567", , , [9]], [, , "80\\d{7}", , , , "800123456", , , [9]], [, , "8701\\d{5}", , , , "870123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d\\d|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      NC: [, [, , "(?:050|[2-57-9]\\d\\d)\\d{3}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [, , "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}", , , , "751234"], [, , "050\\d{3}", , , , "050012"], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{3})", "$1", ["5[6-8]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      NE: [
        ,
        [, , "[027-9]\\d{7}", , , , , , , [8]],
        [, , "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}", , , , "20201234"],
        [, , "(?:23|7[0467]|[89]\\d)\\d{6}", , , , "93123456"],
        [, , "08\\d{6}", , , , "08123456"],
        [, , "09\\d{6}", , , , "09123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "NE",
        227,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      NF: [, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}", , , , "106609", , , , [5]], [, , "(?:14|3[58])\\d{4}", , , , "381234", , , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , "([0-258]\\d{4})$", "3$1", , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], [, "(\\d)(\\d{5})", "$1 $2", ["[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NG: [
        ,
        [
          ,
          ,
          "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7, 8, 10, 11, 12, 13, 14],
          [5, 6]
        ],
        [, , "20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])\\d{6}|(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}", , , , "18040123", , , [7, 8, 10], [5, 6]],
        [, , "(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", , , , "8021234567", , , [10]],
        [, , "800\\d{7,11}", , , , "80017591759", , , [10, 11, 12, 13, 14]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "NG",
        234,
        "009",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-6]|7(?:0[0-689]|[1-79])|8[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [
          ,
          "(\\d{3})(\\d{4})(\\d{4,5})",
          "$1 $2 $3",
          ["[78]"],
          "0$1"
        ], [, "(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "700\\d{7,11}", , , , "7001234567", , , [10, 11, 12, 13, 14]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      NI: [, [, , "(?:1800|[25-8]\\d{3})\\d{4}", , , , , , , [8]], [, , "2\\d{7}", , , , "21234567"], [, , "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}", , , , "81234567"], [, , "1800\\d{4}", , , , "18001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NI", 505, "00", , , , , , , , [[
        ,
        "(\\d{4})(\\d{4})",
        "$1 $2",
        ["[125-8]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NL: [, [, , "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", , , , , , , [5, 6, 7, 8, 9, 10, 11]], [, , "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", , , , "101234567", , , [9]], [
        ,
        ,
        "(?:6[1-58]|970\\d)\\d{7}",
        ,
        ,
        ,
        "612345678",
        ,
        ,
        [9, 11]
      ], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:85|91)\\d{7}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["1[238]|[34]"]], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["14"]], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], [, , "66\\d{7}", , , , "662345678", , , [9]], , , [
        ,
        ,
        "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6]
      ], [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", , , , "14020", , , [5, 6, 9]], , , [, , , , , , , , , [-1]]],
      NO: [, [, , "(?:0|[2-9]\\d{3})\\d{4}", , , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", , , , "21234567", , , [8]], [, , "(?:4[015-8]|9\\d)\\d{6}", , , , "40612345", , , [8]], [
        ,
        ,
        "80[01]\\d{5}",
        ,
        ,
        ,
        "80012345",
        ,
        ,
        [8]
      ], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], , [, , , , , , , , , [-1]], 1, "[02-689]|7[0-8]", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [, , "81[23]\\d{5}", , , , "81212345", , , [8]]],
      NP: [, [
        ,
        ,
        "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 10, 11],
        [6, 7]
      ], [, , "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", , , , "14567890", , , [8], [6, 7]], [, , "9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}", , , , "9841234567", , , [10]], [, , "1(?:66001|800\\d\\d)\\d{5}", , , , "16600101234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [
        [, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"],
        [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"],
        [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]],
        [, "(\\d{4})(\\d{2})(\\d{5})", "$1-$2-$3", ["1"]]
      ], [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NR: [
        ,
        [, , "(?:444|(?:55|8\\d)\\d|666)\\d{4}", , , , , , , [7]],
        [, , "444\\d{4}", , , , "4441234"],
        [, , "(?:55[3-9]|666|8\\d\\d)\\d{4}", , , , "5551234"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "NR",
        674,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      NU: [, [, , "(?:[4-7]|888\\d)\\d{3}", , , , , , , [4, 7]], [, , "[47]\\d{3}", , , , "7012", , , [4]], [, , "(?:[56]|888[1-9])\\d{3}", , , , "8884012"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NU", 683, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NZ: [, [
        ,
        ,
        "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 8, 9, 10]
      ], [, , "24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", , , , "32345678", , , [8], [7]], [, , "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", , , , "211234567", , , [8, 9, 10]], [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456", , , [8, 9, 10]], [, , "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", , , , "900123456", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , "70\\d{7}", , , , "701234567", , , [9]], [, , , , , , , , , [-1]], "NZ", 64, "0(?:0|161)", "0", , , "0", , "00", , [[, "(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], [
        ,
        "(\\d{3})(\\d{2})(\\d{2,3})",
        "$1 $2 $3",
        ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"],
        "0$1"
      ], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}", , , , "83012378"], , , [, , , , , , , , , [-1]]],
      OM: [, [
        ,
        ,
        "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 8, 9]
      ], [, , "2[1-6]\\d{6}", , , , "23123456", , , [8]], [, , "(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}", , , , "92123456", , , [8]], [, , "8007\\d{4,5}|(?:500|800[05])\\d{4}", , , , "80071234"], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "OM", 968, "00", , , , , , , , [[, "(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["2"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PA: [, [
        ,
        ,
        "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 8, 10, 11]
      ], [, , "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", , , , "2001234", , , [7]], [
        ,
        ,
        "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",
        ,
        ,
        ,
        "61234567",
        ,
        ,
        [7, 8]
      ], [, , "800\\d{4,5}|(?:00800|800\\d)\\d{6}", , , , "8001234"], [, , "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PE: [
        ,
        [, , "(?:[14-8]|9\\d)\\d{7}", , , , , , , [8, 9], [6, 7]],
        [
          ,
          ,
          "(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",
          ,
          ,
          ,
          "11234567",
          ,
          ,
          [8],
          [6, 7]
        ],
        [, , "9\\d{8}", , , , "912345678", , , [9]],
        [, , "800\\d{5}", , , , "80012345", , , [8]],
        [, , "805\\d{5}", , , , "80512345", , , [8]],
        [, , "801\\d{5}", , , , "80112345", , , [8]],
        [, , "80[24]\\d{5}", , , , "80212345", , , [8]],
        [, , , , , , , , , [-1]],
        "PE",
        51,
        "00|19(?:1[124]|77|90)00",
        "0",
        " Anexo ",
        ,
        "0",
        ,
        "00",
        ,
        [[, "(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PF: [
        ,
        [, , "4\\d{5}(?:\\d{2})?|8\\d{7,8}", , , , , , , [6, 8, 9]],
        [, , "4(?:0[4-689]|9[4-68])\\d{5}", , , , "40412345", , , [8]],
        [, , "8[7-9]\\d{6}", , , , "87123456", , , [8]],
        [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "499\\d{5}", , , , "49901234", , , [8]],
        "PF",
        689,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "44\\d{4}", , , , , , , [6]],
        [, , "44\\d{4}", , , , "440123", , , [6]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PG: [, [, , "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", , , , , , , [7, 8]], [, , "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", , , , "3123456", , , [7]], [, , "(?:7\\d|8[1-38])\\d{6}", , , , "70123456", , , [8]], [, , "180\\d{4}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-57]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "00|140[1-3]", , , , , , "00", , [[
        ,
        "(\\d{3})(\\d{4})",
        "$1 $2",
        ["18|[2-69]|85"]
      ], [, "(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], , [, , "27[01]\\d{4}", , , , "2700123", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PH: [, [, , "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]], [, , "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", , , , "232345678", , , [6, 8, 9, 10], [4, 5, 7]], [
        ,
        ,
        "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",
        ,
        ,
        ,
        "9051234567",
        ,
        ,
        [10]
      ], [, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], [
        ,
        "(\\d{5})(\\d{4})",
        "$1 $2",
        ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"],
        "(0$1)"
      ], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PK: [, [
        ,
        ,
        "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10, 11, 12],
        [5, 6, 7]
      ], [, , "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", , , , "2123456789", , , [9, 10], [5, 6, 7, 8]], [, , "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}(?:\\d{3})?", , , , "80012345", , , [8, 11]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [
        ,
        ,
        "122\\d{6}",
        ,
        ,
        ,
        "122044444",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["1"]], [
        ,
        "(\\d{3})(\\d{6,7})",
        "$1 $2",
        ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
        ,
        ,
        ,
        "21111825888",
        ,
        ,
        [11, 12]
      ], , , [, , , , , , , , , [-1]]],
      PL: [, [, , "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [, , "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", , , , "123456789", , , [7, 9]], [, , "21(?:1[013-5]|2\\d)\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "70[01346-8]\\d{6}", , , , "701234567", , , [9]], [
        ,
        ,
        "801\\d{6}",
        ,
        ,
        ,
        "801234567",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [[, "(\\d{5})", "$1", ["19"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], [
        ,
        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["1[2-8]|[2-7]|8[1-79]|9[145]"]
      ], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], , [, , "64\\d{4,7}", , , , "641234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]], [, , "804\\d{6}", , , , "804123456", , , [9]], , , [, , , , , , , , , [-1]]],
      PM: [
        ,
        [, , "[45]\\d{5}|(?:708|80\\d)\\d{6}", , , , , , , [6, 9]],
        [, , "(?:4[1-35-7]|5[01])\\d{4}", , , , "430123", , , [6]],
        [, , "(?:4[02-4]|5[056]|708[45][0-5])\\d{4}", , , , "551234"],
        [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "PM",
        508,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PR: [, [, , "(?:[589]\\d\\d|787)\\d{7}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PS: [, [, , "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", , , , , , , [8, 9, 10], [7]], [
        ,
        ,
        "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
        ,
        ,
        ,
        "22234567",
        ,
        ,
        [8],
        [7]
      ], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , , , , , , , , [-1]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PT: [
        ,
        [, , "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", , , , , , , [9]],
        [, , "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}", , , , "212345678"],
        [, , "6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}", , , , "912345678"],
        [, , "80[02]\\d{6}", , , , "800123456"],
        [, , "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}", , , , "760123456"],
        [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"],
        [, , "884[0-4689]\\d{5}", , , , "884123456"],
        [, , "30\\d{7}", , , , "301234567"],
        "PT",
        351,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[
          ,
          "(\\d{2})(\\d{3})(\\d{4})",
          "$1 $2 $3",
          ["2[12]"]
        ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]],
        ,
        [, , "6(?:222\\d|8988)\\d{4}", , , , "622212345"],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}", , , , "707123456"],
        ,
        ,
        [, , "600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}", , , , "600110000"]
      ],
      PW: [
        ,
        [, , "(?:[24-8]\\d\\d|345|900)\\d{4}", , , , , , , [7]],
        [, , "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}", , , , "2771234"],
        [, , "(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}", , , , "6201234"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "PW",
        680,
        "01[12]",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PY: [, [, , "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [
        ,
        ,
        "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
        ,
        ,
        ,
        "212345678",
        ,
        ,
        [7, 8, 9],
        [5, 6]
      ], [, , "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , "9800\\d{5,7}", , , , "98000123456", , , [9, 10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]]],
      QA: [, [, , "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", , , , , , , [7, 8, 9, 11]], [
        ,
        ,
        "4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
        ,
        ,
        ,
        "44123456",
        ,
        ,
        [8]
      ], [, , "[35-7]\\d{7}", , , , "33123456", , , [8]], [, , "800\\d{4}|(?:0080[01]|800)\\d{6}", , , , "8001234", , , [7, 9, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "QA", 974, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], , [, , "2[16]\\d{5}", , , , "2123456", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RE: [, [, , "(?:26|[689]\\d)\\d{7}", , , , , , , [9]], [, , "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}", , , , "262161234"], [
        ,
        ,
        "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}",
        ,
        ,
        ,
        "692123456"
      ], [, , "80\\d{7}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}", , , , "939901234"], "RE", 262, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RO: [, [, , "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", , , , , , , [6, 9]], [
        ,
        ,
        "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
        ,
        ,
        ,
        "211234567"
      ], [, , "(?:630|702)0\\d{5}|(?:6(?:[04]0|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", , , , "712034567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[0136]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], [, "(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[236-9]"],
        "0$1"
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:37\\d|80[578])\\d{6}", , , , "372123456", , , [9]], , , [, , , , , , , , , [-1]]],
      RS: [, [, , "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", , , , , , , [6, 7, 8, 9, 10, 11, 12], [4, 5]], [, , "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", , , , "10234567", , , [7, 8, 9, 10, 11, 12], [4, 5, 6]], [, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [
        ,
        ,
        "800\\d{3,9}",
        ,
        ,
        ,
        "80012345"
      ], [, , "(?:78\\d|90[0169])\\d{3,7}", , , , "90012345", , , [6, 7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RS", 381, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], [, "(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , , [-1]]],
      RU: [, [, , "8\\d{13}|[347-9]\\d{9}", , , , , , , [10, 14], [7]], [
        ,
        ,
        "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
        ,
        ,
        ,
        "3011234567",
        ,
        ,
        [10],
        [7]
      ], [, , "9\\d{9}", , , , "9123456789", , , [10]], [, , "8(?:0[04]|108\\d{3})\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[0-79]"]], [
        ,
        "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2-$3-$4",
        ["[349]|8(?:[02-7]|1[1-8])"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [[, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [
        ,
        "(\\d{5})(\\d)(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", , 1], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [, , , , , , , , , [-1]], 1, "3[04-689]|[489]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RW: [, [, , "(?:06|[27]\\d\\d|[89]00)\\d{6}", , , , , , , [8, 9]], [, , "(?:06|2[23568]\\d)\\d{6}", , , , "250123456"], [, , "7[237-9]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [
        ,
        ,
        "900\\d{6}",
        ,
        ,
        ,
        "900123456",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SA: [, [, , "92\\d{7}|(?:[15]|8\\d)\\d{8}", , , , , , , [9, 10], [7]], [, , "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", , , , "112345678", , , [9], [7]], [
        ,
        ,
        "579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
        ,
        ,
        ,
        "512345678",
        ,
        ,
        [9]
      ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "925\\d{6}", , , , "925012345", , , [9]], [, , "920\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["9"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "811\\d{7}",
        ,
        ,
        ,
        "8110123456",
        ,
        ,
        [10]
      ], , , [, , , , , , , , , [-1]]],
      SB: [, [, , "[6-9]\\d{6}|[1-6]\\d{4}", , , , , , , [5, 7]], [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]], [, , "48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}", , , , "7421234"], [, , "1[38]\\d{3}", , , , "18123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5[12]\\d{3}", , , , "51123", , , [5]], "SB", 677, "0[01]", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SC: [, [, , "(?:[2489]\\d|64)\\d{5}", , , , , , , [7]], [, , "4[2-46]\\d{5}", , , , "4217123"], [, , "2[125-8]\\d{5}", , , , "2510123"], [, , "800[08]\\d{3}", , , , "8000000"], [, , "85\\d{5}", , , , "8512345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "971\\d{4}|(?:64|95)\\d{5}", , , , "6412345"], "SC", 248, "010|0[0-2]", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SD: [, [, , "[19]\\d{8}", , , , , , , [9]], [
        ,
        ,
        "1(?:5\\d|8[35-7])\\d{6}",
        ,
        ,
        ,
        "153123456"
      ], [, , "(?:1[0-2]|9[0-3569])\\d{7}", , , , "911231234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SE: [, [, , "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", , , , , , , [6, 7, 8, 9, 10, 12]], [
        ,
        ,
        "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
        ,
        ,
        ,
        "8123456",
        ,
        ,
        [7, 8, 9]
      ], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77[0-7]\\d{6}", , , , "771234567", , , [9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{2})",
        "$1-$2 $3",
        ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
        "0$1"
      ], [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1"], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1"], [
        ,
        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
        "$1-$2 $3 $4",
        ["8"],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1"]], [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["9(?:00|39|44|9)"]], [, "(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]], [
        ,
        "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["8"]
      ], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1 $2 $3", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["10|7"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "10[1-8]\\d{6}", , , , "102345678", , , [9]], , , [, , "(?:25[245]|67[3-68])\\d{9}", , , , "254123456789", , , [12]]],
      SG: [, [, , "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", , , , , , , [8, 10, 11]], [
        ,
        ,
        "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
        ,
        ,
        ,
        "61234567",
        ,
        ,
        [8]
      ], [, , "8(?:09[0-68]|95[0-2])\\d{4}|(?:8(?:0[1-8]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}", , , , "81234567", , , [8]], [, , "(?:18|8)00\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[12]\\d|666)\\d{5}", , , , "31234567", , , [8]], "SG", 65, "0[0-3]\\d", , , , , , , , [
        [, "(\\d{4,5})", "$1", ["1[013-9]|77", "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]],
        [, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]],
        [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]
      ], [[, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]],
      SH: [, [, , "(?:[256]\\d|8)\\d{3}", , , , , , , [4, 5]], [, , "2(?:[0-57-9]\\d|6[4-9])\\d\\d", , , , "22158"], [
        ,
        ,
        "[56]\\d{4}",
        ,
        ,
        ,
        "51234",
        ,
        ,
        [5]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "262\\d\\d", , , , "26212", , , [5]], "SH", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], 1, "[256]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SI: [
        ,
        [, , "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", , , , , , , [5, 6, 7, 8]],
        [, , "(?:[1-357][2-8]|4[24-8])\\d{6}", , , , "12345678", , , [8], [7]],
        [, , "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", , , , "31234567", , , [8]],
        [, , "80\\d{4,6}", , , , "80123456", , , [6, 7, 8]],
        [, , "89[1-3]\\d{2,5}|90\\d{4,6}", , , , "90123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", , , , "59012345", , , [8]],
        "SI",
        386,
        "00|10(?:22|66|88|99)",
        "0",
        ,
        ,
        "0",
        ,
        "00",
        ,
        [[, "(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SJ: [, [, , "0\\d{4}|(?:[489]\\d|79)\\d{6}", , , , , , , [5, 8]], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "79", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
        ,
        ,
        "81[23]\\d{5}",
        ,
        ,
        ,
        "81212345",
        ,
        ,
        [8]
      ]],
      SK: [
        ,
        [, , "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", , , , , , , [6, 7, 9]],
        [, , "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d", , , , "221234567"],
        [, , "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", , , , "912123456", , , [9]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "9(?:00|[78]\\d)\\d{6}", , , , "900123456", , , [9]],
        [, , "8[5-9]\\d{7}", , , , "850123456", , , [9]],
        [, , , , , , , , , [-1]],
        [, , "6(?:02|5[0-4]|9[0-6])\\d{6}", , , , "690123456", , , [9]],
        "SK",
        421,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d{4})(\\d{3})", "$1 $2", ["909", "9090"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]],
        [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", [
          "[3-5][1-8]1",
          "[3-5][1-8]1[67]"
        ], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]],
        [, , "9090\\d{3}", , , , "9090123", , , [7]],
        ,
        ,
        [, , "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}", , , , , , , [7, 9]],
        [, , "96\\d{7}", , , , "961234567", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SL: [, [, , "(?:[237-9]\\d|66)\\d{6}", , , , , , , [8], [6]], [, , "22[2-4][2-9]\\d{4}", , , , "22221234", , , , [6]], [
        ,
        ,
        "(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}",
        ,
        ,
        ,
        "25123456"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SM: [, [, , "(?:0549|[5-7]\\d)\\d{6}", , , , , , , [8, 10], [6]], [, , "0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]], [, , "6[16]\\d{6}", , , , "66661212", , , [8]], [, , , , , , , , , [-1]], [, , "7[178]\\d{6}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "5[158]\\d{6}",
        ,
        ,
        ,
        "58001110",
        ,
        ,
        [8]
      ], "SM", 378, "00", , , , "([89]\\d{5})$", "0549$1", , , [[, "(\\d{6})", "$1", ["[89]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SN: [, [, , "(?:[378]\\d|93)\\d{7}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , "301012345"], [
        ,
        ,
        "7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}",
        ,
        ,
        ,
        "701234567"
      ], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", , , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}", , , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SO: [, [, , "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", , , , , , , [6, 7, 8, 9]], [
        ,
        ,
        "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
        ,
        ,
        ,
        "4012345",
        ,
        ,
        [6, 7]
      ], [, , "(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", , , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], [, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], [
        ,
        "(\\d)(\\d{7})",
        "$1 $2",
        ["(?:2|90)4|[67]"]
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SR: [, [, , "(?:[2-5]|68|[78]\\d)\\d{5}", , , , , , , [6, 7]], [, , "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}", , , , "211234"], [, , "(?:7[124-7]|8[124-9])\\d{5}", , , , "7412345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "56\\d{4}", , , , "561234", , , [6]], "SR", 597, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})",
        "$1-$2-$3",
        ["56"]
      ], [, "(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SS: [, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1[89]\\d{7}", , , , "181234567"], [, , "(?:12|9[1257-9])\\d{7}", , , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      ST: [, [, , "(?:22|9\\d)\\d{5}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}", , , , "9812345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SV: [, [, , "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", , , , , , , [7, 8, 11]], [
        ,
        ,
        "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
        ,
        ,
        ,
        "21234567",
        ,
        ,
        [8]
      ], [, , "[67]\\d{7}", , , , "70123456", , , [8]], [, , "800\\d{8}|80[01]\\d{4}", , , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SX: [
        ,
        [, , "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "7215(?:4[2-8]|8[239]|9[056])\\d{4}",
          ,
          ,
          ,
          "7215425678",
          ,
          ,
          ,
          [7]
        ],
        [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "SX",
        1,
        "011",
        "1",
        ,
        ,
        "(5\\d{6})$|1",
        "721$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "721",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SY: [, [, , "[1-39]\\d{8}|[1-5]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}", , , , "112345678", , , , [6, 7]], [, , "9[1-689]\\d{7}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["9"],
        "0$1",
        ,
        1
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SZ: [, [, , "0800\\d{4}|(?:[237]\\d|900)\\d{6}", , , , , , , [8, 9]], [, , "[23][2-5]\\d{6}", , , , "22171234", , , [8]], [, , "7[6-9]\\d{6}", , , , "76123456", , , [8]], [, , "0800\\d{4}", , , , "08001234", , , [8]], [, , "900\\d{6}", , , , "900012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70\\d{6}", , , , "70012345", , , [8]], "SZ", 268, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["9"]]], , [, , , , , , , , , [-1]], , , [
        ,
        ,
        "0800\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TA: [, [, , "8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TC: [, [, , "(?:[58]\\d\\d|649|900)\\d{7}", , , , , , , [10], [7]], [, , "649(?:266|712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]], [, , "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}", , , , "6492311234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002345678"
      ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "649(?:71[01]|966)\\d{4}", , , , "6497101234", , , , [7]], "TC", 1, "011", "1", , , "([2-479]\\d{6})$|1", "649$1", , , , , [, , , , , , , , , [-1]], , "649", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TD: [, [, , "(?:22|[689]\\d|77)\\d{6}", , , , , , , [8]], [, , "22(?:[37-9]0|5[0-5]|6[89])\\d{4}", , , , "22501234"], [, , "(?:[69]\\d|77|8[56])\\d{6}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", , , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TG: [, [, , "[279]\\d{7}", , , , , , , [8]], [, , "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}", , , , "22212345"], [
        ,
        ,
        "(?:7[019]|9[0-36-9])\\d{6}",
        ,
        ,
        ,
        "90112345"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 228, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TH: [, [, , "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", , , , , , , [8, 9, 10, 13]], [, , "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", , , , "21234567", , , [8]], [, , "67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", , , , "812345678", , , [9]], [
        ,
        ,
        "(?:001800\\d|1800)\\d{6}",
        ,
        ,
        ,
        "1800123456",
        ,
        ,
        [10, 13]
      ], [, , "1900\\d{6}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00[1-9]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TJ: [
        ,
        [, , "[0-57-9]\\d{8}", , , , , , , [9], [3, 5, 6, 7]],
        [
          ,
          ,
          "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
          ,
          ,
          ,
          "372123456",
          ,
          ,
          ,
          [3, 5, 6, 7]
        ],
        [, , "(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:0[0-57-9]|1[017]|2[02]|[34]0|5[05]|7[01578]|8[078]|9\\d)\\d{7}", , , , "917123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "TJ",
        992,
        "810",
        ,
        ,
        ,
        ,
        ,
        "8~10",
        ,
        [[, "(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      TK: [, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TL: [, [, , "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", , , , , , , [7, 8]], [, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]], [
        ,
        ,
        "7[2-8]\\d{6}",
        ,
        ,
        ,
        "77212345",
        ,
        ,
        [8]
      ], [, , "80\\d{5}", , , , "8012345", , , [7]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , "70\\d{5}", , , , "7012345", , , [7]], [, , , , , , , , , [-1]], "TL", 670, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TM: [, [, , "(?:[1-6]\\d|71)\\d{6}", , , , , , , [8]], [, , "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", , , , "12345678"], [
        ,
        ,
        "(?:6\\d|71)\\d{6}",
        ,
        ,
        ,
        "66123456"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TM", 993, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TN: [, [, , "[2-57-9]\\d{7}", , , , , , , [8]], [, , "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}", , , , "30010123"], [
        ,
        ,
        "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
        ,
        ,
        ,
        "20123456"
      ], [, , "8010\\d{4}", , , , "80101234"], [, , "88\\d{6}", , , , "88123456"], [, , "8[12]10\\d{4}", , , , "81101234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TN", 216, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TO: [, [, , "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", , , , , , , [5, 7]], [, , "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", , , , "20123", , , [5]], [
        ,
        ,
        "(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
        ,
        ,
        ,
        "7715123",
        ,
        ,
        [7]
      ], [, , "0800\\d{3}", , , , "0800222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "55[0-37-9]\\d{4}", , , , "5510123", , , [7]], "TO", 676, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TR: [, [, , "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", , , , , , , [7, 10, 12, 13]], [
        ,
        ,
        "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
        ,
        ,
        ,
        "2123456789",
        ,
        ,
        [10]
      ], [, , "561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", , , , "5012345678", , , [10]], [, , "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", , , , "8001234567", , , [10, 12, 13]], [, , "(?:8[89]8|900)\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , "592(?:21[12]|461)\\d{4}", , , , "5922121234", , , [10]], [, , "850\\d{7}", , , , "8500123456", , , [10]], "TR", 90, "00", "0", , , "0", , , , [
        [, "(\\d{3})(\\d)(\\d{3})", "$1 $2 $3", ["444"], , , 1],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1],
        [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", , 1],
        [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1],
        [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]
      ], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[24][1-8]|3[1-9]"],
        "(0$1)",
        ,
        1
      ], [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]], [, , "512\\d{7}", , , , "5123456789", , , [10]], , , [, , "(?:444|811\\d{3})\\d{4}", , , , , , , [7, 10]], [, , "444\\d{4}", , , , "4441444", , , [7]], , , [, , , , , , , , , [-1]]],
      TT: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", , , , "8682211234", , , , [7]], [
        ,
        ,
        "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
        ,
        ,
        ,
        "8682911234",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "([2-46-8]\\d{6})$|1", "868$1", , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]],
      TV: [, [, , "(?:2|7\\d\\d|90)\\d{4}", , , , , , , [5, 6, 7]], [, , "2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:7[01]\\d|90)\\d{4}", , , , "901234", , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2"]], [, "(\\d{2})(\\d{4})", "$1 $2", ["90"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TW: [, [
        ,
        ,
        "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 8, 9, 10, 11]
      ], [
        ,
        ,
        "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
        ,
        ,
        ,
        "221234567",
        ,
        ,
        [8, 9]
      ], [, , "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", , , , "912345678", , , [9]], [, , "80[0-79]\\d{6}|800\\d{5}", , , , "800123456", , , [8, 9]], [, , "20(?:[013-9]\\d\\d|2)\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "99\\d{7}", , , , "990123456", , , [9]], [, , "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", , , , "7012345678", , , [10, 11]], "TW", 886, "0(?:0[25-79]|19)", "0", "#", , "0", , , , [[, "(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], [
        ,
        "(\\d)(\\d{3,4})(\\d{4})",
        "$1 $2 $3",
        ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],
        "0$1"
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "50[0-46-9]\\d{6}", , , , "500123456", , , [9]], , , [, , , , , , , , , [-1]]],
      TZ: [
        ,
        [, , "(?:[25-8]\\d|41|90)\\d{7}", , , , , , , [9]],
        [, , "2[2-8]\\d{7}", , , , "222345678"],
        [, , "(?:6[125-9]|7[13-9])\\d{7}", , , , "621234567"],
        [, , "80[08]\\d{6}", , , , "800123456"],
        [, , "90\\d{7}", , , , "900123456"],
        [, , "8(?:40|6[01])\\d{6}", , , , "840123456"],
        [, , , , , , , , , [-1]],
        [, , "41\\d{7}", , , , "412345678"],
        "TZ",
        255,
        "00[056]",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["5"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      UA: [, [, , "[89]\\d{9}|[3-9]\\d{8}", , , , , , , [9, 10], [5, 6, 7]], [
        ,
        ,
        "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
        ,
        ,
        ,
        "311234567",
        ,
        ,
        [9],
        [5, 6, 7]
      ], [, , "(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", , , , "501234567", , , [9]], [, , "800[1-8]\\d{5,6}", , , , "800123456"], [, , "900[239]\\d{5,6}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89[1-579]\\d{6}", , , , "891234567", , , [9]], "UA", 380, "00", "0", , , "0", , "0~0", , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], [
        ,
        "(\\d{4})(\\d{5})",
        "$1 $2",
        ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UG: [, [, , "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", , , , , , , [9], [5, 6, 7]], [
        ,
        ,
        "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
        ,
        ,
        ,
        "312345678",
        ,
        ,
        ,
        [5, 6, 7]
      ], [, , "72(?:[48]0|6[01])\\d{5}|7(?:[015-8]\\d|20|36|4[0-5]|9[89])\\d{6}", , , , "712345678"], [, , "800[1-3]\\d{5}", , , , "800123456"], [, , "90[1-3]\\d{6}", , , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      US: [
        ,
        [, , "[2-9]\\d{9}|3\\d{6}", , , , , , , [10], [7]],
        [
          ,
          ,
          "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
          ,
          ,
          ,
          "2015550123",
          ,
          ,
          ,
          [7]
        ],
        [
          ,
          ,
          "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
          ,
          ,
          ,
          "2015550123",
          ,
          ,
          ,
          [7]
        ],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
        [, , "900[2-9]\\d{6}", , , , "9002345678"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , "305209\\d{4}", , , , "3052090123", , , , [7]],
        "US",
        1,
        "011",
        "1",
        ,
        ,
        "1",
        ,
        ,
        1,
        [
          [, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1],
          [, "(\\d{3})(\\d{4})", "$1-$2", ["[24-9]|3(?:[02-9]|1[1-9])"]],
          [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], , , 1]
        ],
        [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]],
        [, , , , , , , , , [-1]],
        1,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      UY: [, [, , "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11, 12, 13]], [, , "(?:1(?:770|9(?:20|87))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", , , , "21231234", , , [8], [7]], [, , "9[1-9]\\d{6}", , , , "94231234", , , [8]], [
        ,
        ,
        "0004\\d{2,9}|(?:405|80[05])\\d{4}",
        ,
        ,
        ,
        "8001234"
      ], [, , "90[0-8]\\d{4}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:0|1[3-9]\\d)", "0", " int. ", , "0", , "00", , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], [, "(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      UZ: [, [, , "(?:20|33|[5-79]\\d|88)\\d{7}", , , , , , , [9]], [, , "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}", , , , "669050123"], [
        ,
        ,
        "(?:(?:[25]0|33|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
        ,
        ,
        ,
        "912345678"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UZ", 998, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VA: [, [, , "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [, , "06698\\d{1,6}", , , , "0669812345", , , [6, 7, 8, 9, 10, 11]], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [
        ,
        ,
        "80(?:0\\d{3}|3)\\d{3}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [6, 9]
      ], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "06698", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
      VC: [
        ,
        [, , "(?:[58]\\d\\d|784|900)\\d{7}", , , , , , , [10], [7]],
        [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]],
        [, , "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}", , , , "7844301234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
        [, , "900[2-9]\\d{6}", , , , "9002345678"],
        [, , , , , , , , , [-1]],
        [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ],
        [, , "78451[0-2]\\d{4}", , , , "7845101234", , , , [7]],
        "VC",
        1,
        "011",
        "1",
        ,
        ,
        "([2-7]\\d{6})$|1",
        "784$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "784",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      VE: [
        ,
        [, , "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", , , , , , , [10], [7]],
        [, , "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}", , , , "2121234567", , , , [7]],
        [, , "4(?:1[24-8]|2[46])\\d{7}", , , , "4121234567"],
        [, , "800\\d{7}", , , , "8001234567"],
        [, , "90[01]\\d{7}", , , , "9001234567"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "VE",
        58,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1", "$CC $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "501\\d{7}", , , , "5010123456", , , , [7]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      VG: [, [, , "(?:284|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}", , , , "2842291234", , , , [7]], [, , "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}", , , , "2843001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [
        ,
        ,
        "900[2-9]\\d{6}",
        ,
        ,
        ,
        "9002345678"
      ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", "1", , , "([2-578]\\d{6})$|1", "284$1", , , , , [, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VI: [, [, , "[58]\\d{9}|(?:34|90)0\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
        ,
        ,
        ,
        "3406421234",
        ,
        ,
        ,
        [7]
      ], [, , "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "([2-9]\\d{6})$|1", "340$1", , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VN: [, [, , "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", , , , , , , [7, 8, 9, 10]], [, , "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", , , , "2101234567", , , [10]], [, , "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", , , , "912345678", , , [9]], [
        ,
        ,
        "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
        ,
        ,
        ,
        "1800123456",
        ,
        ,
        [8, 9, 10]
      ], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "672\\d{6}", , , , "672012345", , , [9]], "VN", 84, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1], [, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["2[48]"],
        "0$1",
        ,
        1
      ], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [[, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "[17]99\\d{4}|69\\d{5,6}", , , , , , , [7, 8]], [
        ,
        ,
        "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
        ,
        ,
        ,
        "1992000",
        ,
        ,
        [7, 8]
      ], , , [, , , , , , , , , [-1]]],
      VU: [
        ,
        [, , "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", , , , , , , [5, 7]],
        [, , "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", , , , "22123", , , [5]],
        [, , "(?:[58]\\d|7[013-7])\\d{5}", , , , "5912345", , , [7]],
        [, , "81[18]\\d\\d", , , , "81123", , , [5]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:0[1-9]|1[01])\\d{4}", , , , "9010123", , , [7]],
        "VU",
        678,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "(?:3[03]|900\\d)\\d{3}", , , , "30123"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      WF: [, [, , "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", , , , , , , [6, 9]], [, , "72\\d{4}", , , , "721234", , , [6]], [, , "(?:72|8[23])\\d{4}", , , , "821234", , , [6]], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WF", 681, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234", , , [6]]],
      WS: [, [
        ,
        ,
        "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 10]
      ], [, , "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", , , , "22123", , , [5, 6]], [, , "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", , , , "7212345", , , [7, 10]], [, , "800\\d{3}", , , , "800123", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WS", 685, "0", , , , , , , , [[, "(\\d{5})", "$1", ["[2-5]|6[1-9]"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      XK: [
        ,
        [
          ,
          ,
          "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
          ,
          ,
          ,
          ,
          ,
          ,
          [8, 9, 10, 11, 12]
        ],
        [, , "38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})", , , , "28012345"],
        [, , "4[3-9]\\d{6}", , , , "43201234", , , [8]],
        [, , "800\\d{5}", , , , "80001234", , , [8]],
        [, , "900\\d{5}", , , , "90001234", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "XK",
        383,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], [, "(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      YE: [
        ,
        [, , "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", , , , , , , [7, 8, 9], [6]],
        [, , "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", , , , "1234567", , , [7, 8], [6]],
        [, , "7[01378]\\d{7}", , , , "712345678", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "YE",
        967,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      YT: [, [, , "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", , , , , , , [9]], [, , "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}", , , , "269601234"], [, , "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}", , , , "639012345"], [, , "80\\d{7}", , , , "801234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:39|47)8[01]|769\\d)\\d{4}", , , , "939801234"], "YT", 262, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ZA: [, [, , "[1-79]\\d{8}|8\\d{4,9}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", , , , "101234567", , , [9]], [, , "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", , , , "711234567", , , [5, 6, 7, 8, 9]], [
        ,
        ,
        "80\\d{7}",
        ,
        ,
        ,
        "801234567",
        ,
        ,
        [9]
      ], [, , "(?:86[2-9]|9[0-2]\\d)\\d{6}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , , , , , , , [-1]], [, , "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", , , , "871234567", , , [9]], "ZA", 27, "00", "0", , , "0", , , , [
        [, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"],
        [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"],
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"],
        [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]
      ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "861\\d{6,7}", , , , "861123456", , , [9, 10]], , , [, , , , , , , , , [-1]]],
      ZM: [, [, , "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", , , , , , , [9], [6]], [, , "21[1-8]\\d{6}", , , , "211234567", , , , [6]], [, , "(?:7[5-79]|9[5-8])\\d{7}", , , , "955123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "63\\d{7}", , , , "630123456"], "ZM", 260, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[1-9]"]], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[28]"],
        "0$1"
      ], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ZW: [, [, , "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [
        ,
        ,
        "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
        ,
        ,
        ,
        "1312345",
        ,
        ,
        ,
        [3, 4]
      ], [, , "7(?:[1278]\\d|3[1-9])\\d{6}", , , , "712345678", , , [9]], [, , "80(?:[01]\\d|20|8[0-8])\\d{3}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [
        [, "(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"],
        [, "(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"],
        [, "(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"],
        [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"],
        [, "(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"],
        [
          ,
          "(\\d{2})(\\d{3,5})",
          "$1 $2",
          ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
          "0$1"
        ],
        [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"],
        [, "(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]
      ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      800: [
        ,
        [, , "(?:00|[1-9]\\d)\\d{6}", , , , , , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "(?:00|[1-9]\\d)\\d{6}", , , , "12345678"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "001",
        800,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        1,
        [[, "(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      808: [, [, , "[1-9]\\d{7}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1-9]\\d{7}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      870: [, [, , "7\\d{11}|[35-7]\\d{8}", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      878: [, [, , "10\\d{10}", , , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      881: [
        ,
        [, , "6\\d{9}|[0-36-9]\\d{8}", , , , , , , [9, 10]],
        [, , , , , , , , , [-1]],
        [, , "6\\d{9}|[0-36-9]\\d{8}", , , , "612345678"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "001",
        881,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], [, "(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      882: [, [, , "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [
        ,
        ,
        "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
        ,
        ,
        ,
        "3421234",
        ,
        ,
        [7, 8, 9, 10, 12]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}", , , , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["49"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], [, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [
        ,
        "(\\d{2})(\\d{3,4})(\\d{4})",
        "$1 $2 $3",
        ["16"]
      ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]],
      883: [, [, , "(?:[1-4]\\d|51)\\d{6,10}", , , , , , , [8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
        ,
        ,
        ,
        "510012345"
      ], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      888: [, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", , , , "12345678901"], , , [, , , , , , , , , [-1]]],
      979: [, [, , "[1359]\\d{8}", , , , , , , [9], [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1359]\\d{8}", , , , "123456789", , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]]
    };
    function J() {
      this.g = {};
    }
    J.h = void 0;
    J.g = function() {
      return J.h ? J.h : J.h = new J();
    };
    var Fa = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "\uFF10": "0", "\uFF11": "1", "\uFF12": "2", "\uFF13": "3", "\uFF14": "4", "\uFF15": "5", "\uFF16": "6", "\uFF17": "7", "\uFF18": "8", "\uFF19": "9", "\u0660": "0", "\u0661": "1", "\u0662": "2", "\u0663": "3", "\u0664": "4", "\u0665": "5", "\u0666": "6", "\u0667": "7", "\u0668": "8", "\u0669": "9", "\u06F0": "0", "\u06F1": "1", "\u06F2": "2", "\u06F3": "3", "\u06F4": "4", "\u06F5": "5", "\u06F6": "6", "\u06F7": "7", "\u06F8": "8", "\u06F9": "9" }, Ga = {
      0: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      "+": "+",
      "*": "*",
      "#": "#"
    }, Ha = {
      0: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      "\uFF10": "0",
      "\uFF11": "1",
      "\uFF12": "2",
      "\uFF13": "3",
      "\uFF14": "4",
      "\uFF15": "5",
      "\uFF16": "6",
      "\uFF17": "7",
      "\uFF18": "8",
      "\uFF19": "9",
      "\u0660": "0",
      "\u0661": "1",
      "\u0662": "2",
      "\u0663": "3",
      "\u0664": "4",
      "\u0665": "5",
      "\u0666": "6",
      "\u0667": "7",
      "\u0668": "8",
      "\u0669": "9",
      "\u06F0": "0",
      "\u06F1": "1",
      "\u06F2": "2",
      "\u06F3": "3",
      "\u06F4": "4",
      "\u06F5": "5",
      "\u06F6": "6",
      "\u06F7": "7",
      "\u06F8": "8",
      "\u06F9": "9",
      A: "2",
      B: "2",
      C: "2",
      D: "3",
      E: "3",
      F: "3",
      G: "4",
      H: "4",
      I: "4",
      J: "5",
      K: "5",
      L: "5",
      M: "6",
      N: "6",
      O: "6",
      P: "7",
      Q: "7",
      R: "7",
      S: "7",
      T: "8",
      U: "8",
      V: "8",
      W: "9",
      X: "9",
      Y: "9",
      Z: "9"
    }, Ia = RegExp("[+\uFF0B]+"), K = RegExp("^[+\uFF0B]+"), Ja = RegExp("([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9])"), Ka = RegExp("[+\uFF0B0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]"), La = /[\\\/] *x/, Ma = RegExp("[^0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9A-Za-z#]+$"), Na = /(?:.*?[A-Za-z]){3}.*/, Oa = RegExp("^\\+([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]|[\\-\\.\\(\\)]?)*[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]|[\\-\\.\\(\\)]?)*$"), Pa = RegExp("^([A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]+((\\-)*[A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9])*\\.)*[A-Za-z]+((\\-)*[A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9])*\\.?$");
    function L(a) {
      return "([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]{1," + a + "})";
    }
    function Qa() {
      return ";ext=" + L("20") + "|[ \xA0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)[:\\.\uFF0E]?[ \xA0\\t,-]*" + (L("20") + "#?|[ \xA0\\t,]*(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)[:\\.\uFF0E]?[ \xA0\\t,-]*") + (L("9") + "#?|[- ]+") + (L("6") + "#|[ \xA0\\t]*(?:,{2}|;)[:\\.\uFF0E]?[ \xA0\\t,-]*") + (L("15") + "#?|[ \xA0\\t]*(?:,)+[:\\.\uFF0E]?[ \xA0\\t,-]*") + (L("9") + "#?");
    }
    var Ra = new RegExp("(?:" + Qa() + ")$", "i"), Sa = new RegExp("^[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]{2}$|^[+\uFF0B]*(?:[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E*]*[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]){3,}[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E*A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]*(?:" + Qa() + ")?$", "i"), Ta = /(\$\d)/, Ua = /^\(?\$1\)?$/;
    function Va(a) {
      return 2 > a.length ? false : M(Sa, a);
    }
    function Wa(a) {
      return M(Na, a) ? N(a, Ha) : N(a, Fa);
    }
    function Xa(a) {
      var b = Wa(a.toString());
      D(a);
      a.g(b);
    }
    function Ya(a) {
      return null != a && (1 != x(a, 9) || -1 != u(a, 9)[0]);
    }
    function N(a, b) {
      for (var c = new C(), d, e = a.length, f = 0; f < e; ++f) d = a.charAt(f), d = b[d.toUpperCase()], null != d && c.g(d);
      return c.toString();
    }
    function Za(a) {
      return 0 == a.length || Ua.test(a);
    }
    function O(a) {
      return null != a && isNaN(a) && a.toUpperCase() in Ea;
    }
    J.prototype.format = function(a, b) {
      if (0 == r(a, 2) && q(a, 5)) {
        var c = w(a, 5);
        if (0 < c.length) return c;
      }
      c = w(a, 1);
      var d = P(a);
      if (0 == b) return $a(c, 0, d, "");
      if (!(c in I)) return d;
      var e = Q(this, c, R(c));
      a = q(a, 3) && 0 != r(a, 3).length ? 3 == b ? ";ext=" + r(a, 3) : q(e, 13) ? r(e, 13) + w(a, 3) : " ext. " + w(a, 3) : "";
      a: {
        e = 0 == u(e, 20).length || 2 == b ? u(e, 19) : u(e, 20);
        for (var f, g = e.length, h = 0; h < g; ++h) {
          f = e[h];
          var l = x(f, 3);
          if (0 == l || 0 == d.search(r(f, 3, l - 1))) {
            if (l = new RegExp(r(f, 1)), M(l, d)) {
              e = f;
              break a;
            }
          }
        }
        e = null;
      }
      null != e && (g = e, e = w(g, 2), f = new RegExp(r(g, 1)), w(
        g,
        5
      ), g = w(g, 4), d = 2 == b && null != g && 0 < g.length ? d.replace(f, e.replace(Ta, g)) : d.replace(f, e), 3 == b && (d = d.replace(RegExp("^[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]+"), ""), d = d.replace(RegExp("[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]+", "g"), "-")));
      return $a(c, b, d, a);
    };
    function Q(a, b, c) {
      return "001" == c ? S(a, "" + b) : S(a, c);
    }
    function P(a) {
      if (!q(a, 2)) return "";
      var b = "" + r(a, 2);
      return q(a, 4) && r(a, 4) && 0 < w(a, 8) ? Array(w(a, 8) + 1).join("0") + b : b;
    }
    function $a(a, b, c, d) {
      switch (b) {
        case 0:
          return "+" + a + c + d;
        case 1:
          return "+" + a + " " + c + d;
        case 3:
          return "tel:+" + a + "-" + c + d;
        default:
          return c + d;
      }
    }
    function T(a, b) {
      switch (b) {
        case 4:
          return r(a, 5);
        case 3:
          return r(a, 4);
        case 1:
          return r(a, 3);
        case 0:
        case 2:
          return r(a, 2);
        case 5:
          return r(a, 6);
        case 6:
          return r(a, 8);
        case 7:
          return r(a, 7);
        case 8:
          return r(a, 21);
        case 9:
          return r(a, 25);
        case 10:
          return r(a, 28);
        default:
          return r(a, 1);
      }
    }
    function ab(a, b) {
      return U(a, r(b, 1)) ? U(a, r(b, 5)) ? 4 : U(a, r(b, 4)) ? 3 : U(a, r(b, 6)) ? 5 : U(a, r(b, 8)) ? 6 : U(a, r(b, 7)) ? 7 : U(a, r(b, 21)) ? 8 : U(a, r(b, 25)) ? 9 : U(a, r(b, 28)) ? 10 : U(a, r(b, 2)) ? r(b, 18) || U(a, r(b, 3)) ? 2 : 0 : !r(b, 18) && U(a, r(b, 3)) ? 1 : -1 : -1;
    }
    function S(a, b) {
      if (null == b) return null;
      b = b.toUpperCase();
      var c = a.g[b];
      if (null == c) {
        c = Ea[b];
        if (null == c) return null;
        c = new B().g(G.m(), c);
        a.g[b] = c;
      }
      return c;
    }
    function U(a, b) {
      var c = a.length;
      return 0 < x(b, 9) && -1 == u(b, 9).indexOf(c) ? false : M(w(b, 2), a);
    }
    function bb(a, b) {
      if (null == b) return null;
      var c = w(b, 1);
      c = I[c];
      if (null == c) a = null;
      else if (1 == c.length) a = c[0];
      else a: {
        b = P(b);
        for (var d, e = c.length, f = 0; f < e; f++) {
          d = c[f];
          var g = S(a, d);
          if (q(g, 23)) {
            if (0 == b.search(r(g, 23))) {
              a = d;
              break a;
            }
          } else if (-1 != ab(b, g)) {
            a = d;
            break a;
          }
        }
        a = null;
      }
      return a;
    }
    function R(a) {
      a = I[a];
      return null == a ? "ZZ" : a[0];
    }
    function cb(a, b) {
      a = S(a, b);
      if (null == a) throw Error("Invalid region code: " + b);
      return w(a, 10);
    }
    function V(a, b, c, d) {
      var e = T(c, d), f = 0 == x(e, 9) ? u(r(c, 1), 9) : u(e, 9);
      e = u(e, 10);
      if (2 == d) if (Ya(T(c, 0))) a = T(c, 1), Ya(a) && (f = f.concat(0 == x(a, 9) ? u(r(c, 1), 9) : u(a, 9)), f.sort(), 0 == e.length ? e = u(a, 10) : (e = e.concat(u(a, 10)), e.sort()));
      else return V(a, b, c, 1);
      if (-1 == f[0]) return 5;
      b = b.length;
      if (-1 < e.indexOf(b)) return 4;
      c = f[0];
      return c == b ? 0 : c > b ? 2 : f[f.length - 1] < b ? 3 : -1 < f.indexOf(b, 1) ? 0 : 5;
    }
    function W(a, b, c) {
      var d = P(b);
      b = w(b, 1);
      if (!(b in I)) return 1;
      b = Q(a, b, R(b));
      return V(a, d, b, c);
    }
    function db(a, b) {
      a = a.toString();
      if (0 == a.length || "0" == a.charAt(0)) return 0;
      for (var c, d = a.length, e = 1; 3 >= e && e <= d; ++e) if (c = parseInt(a.substring(0, e), 10), c in I) return b.g(a.substring(e)), c;
      return 0;
    }
    function eb(a, b, c, d, e, f) {
      if (0 == b.length) return 0;
      b = new C(b);
      var g;
      null != c && (g = r(c, 11));
      null == g && (g = "NonMatch");
      var h = b.toString();
      if (0 == h.length) g = 20;
      else if (K.test(h)) h = h.replace(K, ""), D(b), b.g(Wa(h)), g = 1;
      else {
        h = new RegExp(g);
        Xa(b);
        g = b.toString();
        if (0 == g.search(h)) {
          h = g.match(h)[0].length;
          var l = g.substring(h).match(Ja);
          l && null != l[1] && 0 < l[1].length && "0" == N(l[1], Fa) ? g = false : (D(b), b.g(g.substring(h)), g = true);
        } else g = false;
        g = g ? 5 : 20;
      }
      e && t(f, 6, g);
      if (20 != g) {
        if (2 >= b.h.length) throw Error("Phone number too short after IDD");
        a = db(b, d);
        if (0 != a) return t(f, 1, a), a;
        throw Error("Invalid country calling code");
      }
      if (null != c && (g = w(c, 10), h = "" + g, l = b.toString(), 0 == l.lastIndexOf(h, 0) && (h = new C(l.substring(h.length)), l = r(c, 1), l = new RegExp(w(l, 2)), fb(h, c, null), h = h.toString(), !M(l, b.toString()) && M(l, h) || 3 == V(a, b.toString(), c, -1)))) return d.g(h), e && t(f, 6, 10), t(f, 1, g), g;
      t(f, 1, 0);
      return 0;
    }
    function fb(a, b, c) {
      var d = a.toString(), e = d.length, f = r(b, 15);
      if (0 != e && null != f && 0 != f.length) {
        var g = new RegExp("^(?:" + f + ")");
        if (e = g.exec(d)) {
          f = new RegExp(w(r(b, 1), 2));
          var h = M(f, d), l = e.length - 1;
          b = r(b, 16);
          if (null == b || 0 == b.length || null == e[l] || 0 == e[l].length) {
            if (!h || M(f, d.substring(e[0].length))) null != c && 0 < l && null != e[l] && c.g(e[1]), a.set(d.substring(e[0].length));
          } else if (d = d.replace(g, b), !h || M(f, d)) null != c && 0 < l && c.g(e[1]), a.set(d);
        }
      }
    }
    function X(a, b, c) {
      if (!O(c) && 0 < b.length && "+" != b.charAt(0)) throw Error("Invalid country calling code");
      return gb(a, b, c, true);
    }
    function gb(a, b, c, d) {
      if (null == b) throw Error("The string supplied did not seem to be a phone number");
      if (250 < b.length) throw Error("The string supplied is too long to be a phone number");
      var e = new C();
      var f = b.indexOf(";phone-context=");
      if (-1 === f) f = null;
      else if (f += 15, f >= b.length) f = "";
      else {
        var g = b.indexOf(";", f);
        f = -1 !== g ? b.substring(f, g) : b.substring(f);
      }
      var h = f;
      null == h ? g = true : 0 === h.length ? g = false : (g = Oa.exec(h), h = Pa.exec(h), g = null !== g || null !== h);
      if (!g) throw Error("The string supplied did not seem to be a phone number");
      null != f ? ("+" === f.charAt(0) && e.g(f), f = b.indexOf("tel:"), e.g(b.substring(0 <= f ? f + 4 : 0, b.indexOf(";phone-context=")))) : (f = e.g, g = b ?? "", h = g.search(Ka), 0 <= h ? (g = g.substring(h), g = g.replace(Ma, ""), h = g.search(La), 0 <= h && (g = g.substring(0, h))) : g = "", f.call(e, g));
      f = e.toString();
      g = f.indexOf(";isub=");
      0 < g && (D(e), e.g(f.substring(0, g)));
      if (!Va(e.toString())) throw Error("The string supplied did not seem to be a phone number");
      f = e.toString();
      if (!(O(c) || null != f && 0 < f.length && K.test(f))) throw Error("Invalid country calling code");
      f = new H();
      d && t(f, 5, b);
      a: {
        b = e.toString();
        g = b.search(Ra);
        if (0 <= g && Va(b.substring(0, g))) {
          h = b.match(Ra);
          for (var l = h.length, A = 1; A < l; ++A) if (null != h[A] && 0 < h[A].length) {
            D(e);
            e.g(b.substring(0, g));
            b = h[A];
            break a;
          }
        }
        b = "";
      }
      0 < b.length && t(f, 3, b);
      g = S(a, c);
      b = new C();
      h = 0;
      l = e.toString();
      try {
        h = eb(a, l, g, b, d, f);
      } catch (da) {
        if ("Invalid country calling code" == da.message && K.test(l)) {
          if (l = l.replace(K, ""), h = eb(a, l, g, b, d, f), 0 == h) throw da;
        } else throw da;
      }
      0 != h ? (e = R(h), e != c && (g = Q(a, h, e))) : (Xa(e), b.g(e.toString()), null != c ? (h = w(g, 10), t(
        f,
        1,
        h
      )) : d && (delete f.h[6], f.g && delete f.g[6]));
      if (2 > b.h.length) throw Error("The string supplied is too short to be a phone number");
      null != g && (c = new C(), e = new C(b.toString()), fb(e, g, c), a = V(a, e.toString(), g, -1), 2 != a && 4 != a && 5 != a && (b = e, d && 0 < c.toString().length && t(f, 7, c.toString())));
      d = b.toString();
      a = d.length;
      if (2 > a) throw Error("The string supplied is too short to be a phone number");
      if (17 < a) throw Error("The string supplied is too long to be a phone number");
      if (1 < d.length && "0" == d.charAt(0)) {
        t(f, 4, true);
        for (a = 1; a < d.length - 1 && "0" == d.charAt(a); ) a++;
        1 != a && t(f, 8, a);
      }
      t(f, 2, parseInt(d, 10));
      return f;
    }
    function M(a, b) {
      return (a = "string" == typeof a ? b.match("^(?:" + a + ")$") : b.match(a)) && a[0].length == b.length ? true : false;
    }
    ;
    function hb(a) {
      this.fa = RegExp("\u2008");
      this.ja = "";
      this.v = new C();
      this.da = "";
      this.s = new C();
      this.ba = new C();
      this.u = true;
      this.ea = this.ca = this.la = false;
      this.ga = J.g();
      this.$ = 0;
      this.h = new C();
      this.ha = false;
      this.o = "";
      this.g = new C();
      this.j = [];
      this.ka = a;
      this.l = ib(this, this.ka);
    }
    var jb = new G();
    t(jb, 11, "NA");
    var kb = RegExp("^[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*\\$1[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*(\\$\\d[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*)*$"), lb = /[- ]/;
    function ib(a, b) {
      var c = a.ga;
      b = O(b) ? cb(c, b) : 0;
      a = S(a.ga, R(b));
      return null != a ? a : jb;
    }
    function mb(a) {
      for (var b = a.j.length, c = 0; c < b; ++c) {
        var d = a.j[c], e = w(d, 1);
        if (a.da == e) return false;
        var f = a;
        var g = d, h = w(g, 1);
        D(f.v);
        var l = f;
        g = w(g, 2);
        var A = "999999999999999".match(h)[0];
        A.length < l.g.h.length ? l = "" : (l = A.replace(new RegExp(h, "g"), g), l = l.replace(RegExp("9", "g"), "\u2008"));
        0 < l.length ? (f.v.g(l), f = true) : f = false;
        if (f) return a.da = e, a.ha = lb.test(r(d, 4)), a.$ = 0, true;
      }
      return a.u = false;
    }
    function nb(a, b) {
      for (var c = [], d = b.length - 3, e = a.j.length, f = 0; f < e; ++f) {
        var g = a.j[f];
        0 == x(g, 3) ? c.push(a.j[f]) : (g = r(g, 3, Math.min(d, x(g, 3) - 1)), 0 == b.search(g) && c.push(a.j[f]));
      }
      a.j = c;
    }
    function ob(a, b) {
      a.s.g(b);
      var c = b;
      Ja.test(c) || 1 == a.s.h.length && Ia.test(c) ? ("+" == b ? (c = b, a.ba.g(b)) : (c = Fa[b], a.ba.g(c), a.g.g(c)), b = c) : (a.u = false, a.la = true);
      if (!a.u) {
        if (!a.la) {
          if (pb(a)) {
            if (qb(a)) return rb(a);
          } else if (0 < a.o.length && (b = a.g.toString(), D(a.g), a.g.g(a.o), a.g.g(b), b = a.h.toString(), c = b.lastIndexOf(a.o), D(a.h), a.h.g(b.substring(0, c))), a.o != sb(a)) return a.h.g(" "), rb(a);
        }
        return a.s.toString();
      }
      switch (a.ba.h.length) {
        case 0:
        case 1:
        case 2:
          return a.s.toString();
        case 3:
          if (pb(a)) a.ea = true;
          else return a.o = sb(a), tb(a);
        default:
          if (a.ea) return qb(a) && (a.ea = false), a.h.toString() + a.g.toString();
          if (0 < a.j.length) {
            b = ub(a, b);
            c = vb(a);
            if (0 < c.length) return c;
            nb(a, a.g.toString());
            return mb(a) ? wb(a) : a.u ? Y(a, b) : a.s.toString();
          }
          return tb(a);
      }
    }
    function rb(a) {
      a.u = true;
      a.ea = false;
      a.j = [];
      a.$ = 0;
      D(a.v);
      a.da = "";
      return tb(a);
    }
    function vb(a) {
      for (var b = a.g.toString(), c = a.j.length, d = 0; d < c; ++d) {
        var e = a.j[d], f = w(e, 1);
        if (new RegExp("^(?:" + f + ")$").test(b) && (a.ha = lb.test(r(e, 4)), e = b.replace(new RegExp(f, "g"), r(e, 2)), e = Y(a, e), N(e, Ga) == a.ba)) return e;
      }
      return "";
    }
    function Y(a, b) {
      var c = a.h.h.length;
      return a.ha && 0 < c && " " != a.h.toString().charAt(c - 1) ? a.h + " " + b : a.h + b;
    }
    function tb(a) {
      var b = a.g.toString();
      if (3 <= b.length) {
        for (var c = a.ca && 0 == a.o.length && 0 < x(a.l, 20) ? u(a.l, 20) : u(a.l, 19), d = c.length, e = 0; e < d; ++e) {
          var f = c[e];
          0 < a.o.length && Za(w(f, 4)) && !r(f, 6) && !q(f, 5) || (0 != a.o.length || a.ca || Za(w(f, 4)) || r(f, 6)) && kb.test(w(f, 2)) && a.j.push(f);
        }
        nb(a, b);
        b = vb(a);
        return 0 < b.length ? b : mb(a) ? wb(a) : a.s.toString();
      }
      return Y(a, b);
    }
    function wb(a) {
      var b = a.g.toString(), c = b.length;
      if (0 < c) {
        for (var d = "", e = 0; e < c; e++) d = ub(a, b.charAt(e));
        return a.u ? Y(a, d) : a.s.toString();
      }
      return a.h.toString();
    }
    function sb(a) {
      var b = a.g.toString(), c = 0;
      if (1 != r(a.l, 10)) var d = false;
      else d = a.g.toString(), d = "1" == d.charAt(0) && "0" != d.charAt(1) && "1" != d.charAt(1);
      d ? (c = 1, a.h.g("1").g(" "), a.ca = true) : q(a.l, 15) && (d = new RegExp("^(?:" + r(a.l, 15) + ")"), d = b.match(d), null != d && null != d[0] && 0 < d[0].length && (a.ca = true, c = d[0].length, a.h.g(b.substring(0, c))));
      D(a.g);
      a.g.g(b.substring(c));
      return b.substring(0, c);
    }
    function pb(a) {
      var b = a.ba.toString(), c = new RegExp("^(?:\\+|" + r(a.l, 11) + ")");
      c = b.match(c);
      return null != c && null != c[0] && 0 < c[0].length ? (a.ca = true, c = c[0].length, D(a.g), a.g.g(b.substring(c)), D(a.h), a.h.g(b.substring(0, c)), "+" != b.charAt(0) && a.h.g(" "), true) : false;
    }
    function qb(a) {
      if (0 == a.g.h.length) return false;
      var b = new C(), c = db(a.g, b);
      if (0 == c) return false;
      D(a.g);
      a.g.g(b.toString());
      b = R(c);
      "001" == b ? a.l = S(a.ga, "" + c) : b != a.ka && (a.l = ib(a, b));
      a.h.g("" + c).g(" ");
      a.o = "";
      return true;
    }
    function ub(a, b) {
      var c = a.v.toString();
      if (0 <= c.substring(a.$).search(a.fa)) {
        var d = c.search(a.fa);
        b = c.replace(a.fa, b);
        D(a.v);
        a.v.g(b);
        a.$ = d;
        return b.substring(0, a.$ + 1);
      }
      1 == a.j.length && (a.u = false);
      a.da = "";
      return a.s.toString();
    }
    ;
    const Z = { FIXED_LINE: 0, MOBILE: 1, FIXED_LINE_OR_MOBILE: 2, TOLL_FREE: 3, PREMIUM_RATE: 4, SHARED_COST: 5, VOIP: 6, PERSONAL_NUMBER: 7, PAGER: 8, UAN: 9, VOICEMAIL: 10, UNKNOWN: -1 };
    m("intlTelInputUtilsTemp", {});
    m("intlTelInputUtilsTemp.formatNumberAsYouType", (a, b) => {
      try {
        const c = a.replace(/[^+0-9]/g, ""), d = new hb(b);
        b = "";
        for (let e = 0; e < c.length; e++) d.ja = ob(d, c.charAt(e)), b = d.ja;
        return b;
      } catch (c) {
        return a;
      }
    });
    m("intlTelInputUtilsTemp.formatNumber", (a, b, c) => {
      try {
        const e = J.g(), f = X(e, a, b);
        var d = W(e, f, -1);
        return 0 == d || 4 == d ? e.format(f, "undefined" === typeof c ? 0 : c) : a;
      } catch (e) {
        return a;
      }
    });
    m("intlTelInputUtilsTemp.getExampleNumber", (a, b, c, d) => {
      try {
        const l = J.g();
        a: {
          var e = l;
          if (O(a)) {
            var f = T(S(e, a), c);
            try {
              if (q(f, 6)) {
                var g = r(f, 6);
                var h = gb(e, g, a, false);
                break a;
              }
            } catch (A) {
            }
          }
          h = null;
        }
        return l.format(h, d ? 0 : b ? 2 : 1);
      } catch (l) {
        return "";
      }
    });
    m("intlTelInputUtilsTemp.getExtension", (a, b) => {
      try {
        return r(X(J.g(), a, b), 3);
      } catch (c) {
        return "";
      }
    });
    m("intlTelInputUtilsTemp.getNumberType", (a, b) => {
      try {
        const g = J.g(), h = X(g, a, b);
        var c = bb(g, h), d = Q(g, w(h, 1), c);
        if (null == d) var e = -1;
        else {
          var f = P(h);
          e = ab(f, d);
        }
        return e;
      } catch (g) {
        return -99;
      }
    });
    m("intlTelInputUtilsTemp.getValidationError", (a, b) => {
      try {
        const c = J.g(), d = X(c, a, b);
        return W(c, d, -1);
      } catch (c) {
        return "Invalid country calling code" === c.message ? 1 : 3 >= a.length || "Phone number too short after IDD" === c.message || "The string supplied is too short to be a phone number" === c.message ? 2 : "The string supplied is too long to be a phone number" === c.message ? 3 : -99;
      }
    });
    m("intlTelInputUtilsTemp.isValidNumber", (a, b) => {
      try {
        const l = J.g();
        var c = X(l, a, b), d = bb(l, c);
        a = l;
        var e = w(c, 1), f = Q(a, e, d);
        if (null == f || "001" != d && e != cb(a, d)) var g = false;
        else {
          var h = P(c);
          g = -1 != ab(h, f);
        }
        return g;
      } catch (l) {
        return false;
      }
    });
    m("intlTelInputUtilsTemp.isPossibleNumber", (a, b, c) => {
      try {
        const d = J.g(), e = X(d, a, b);
        if (c) {
          const f = 0 === W(d, e, Z[c]);
          if ("FIXED_LINE_OR_MOBILE" === c) {
            const g = 0 === W(d, e, Z.MOBILE), h = 0 === W(d, e, Z.FIXED_LINE);
            return g || h || f;
          }
          return f;
        }
        return 0 === W(d, e, -1);
      } catch (d) {
        return false;
      }
    });
    m("intlTelInputUtilsTemp.getCoreNumber", (a, b) => {
      try {
        return r(X(J.g(), a, b), 2).toString();
      } catch (c) {
        return "";
      }
    });
    m("intlTelInputUtilsTemp.numberFormat", { E164: 0, INTERNATIONAL: 1, NATIONAL: 2, RFC3966: 3 });
    m("intlTelInputUtilsTemp.numberType", Z);
    m("intlTelInputUtilsTemp.validationError", { IS_POSSIBLE: 0, INVALID_COUNTRY_CODE: 1, TOO_SHORT: 2, TOO_LONG: 3, IS_POSSIBLE_LOCAL_ONLY: 4, INVALID_LENGTH: 5 });
  })();
  var utils = window.intlTelInputUtilsTemp;
  delete window.intlTelInputUtilsTemp;
  var utils_default = utils;

  // src/js/intl-tel-input/intlTelInputWithUtils.ts
  intl_tel_input_default.utils = utils_default;
  var intlTelInputWithUtils_default = intl_tel_input_default;
  return __toCommonJS(intlTelInputWithUtils_exports);
})();

// UMD
  return factoryOutput.default;
}));


/***/ }),

/***/ 5580:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(2032),
    hashDelete = __webpack_require__(3862),
    hashGet = __webpack_require__(6721),
    hashHas = __webpack_require__(2749),
    hashSet = __webpack_require__(5749);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 79:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(3702),
    listCacheDelete = __webpack_require__(80),
    listCacheGet = __webpack_require__(4739),
    listCacheHas = __webpack_require__(8655),
    listCacheSet = __webpack_require__(1175);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 8223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 3661:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(3040),
    mapCacheDelete = __webpack_require__(7670),
    mapCacheGet = __webpack_require__(289),
    mapCacheHas = __webpack_require__(4509),
    mapCacheSet = __webpack_require__(2949);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 2804:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 6545:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 8859:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3661),
    setCacheAdd = __webpack_require__(1380),
    setCacheHas = __webpack_require__(1459);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 7217:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    stackClear = __webpack_require__(1420),
    stackDelete = __webpack_require__(938),
    stackGet = __webpack_require__(3605),
    stackHas = __webpack_require__(9817),
    stackSet = __webpack_require__(945);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 1873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 7828:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 8303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 1033:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 3729:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 9770:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(8096),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isIndex = __webpack_require__(361),
    isTypedArray = __webpack_require__(7167);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 4932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 4528:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 4248:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 7805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(3360),
    eq = __webpack_require__(5288);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 6547:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(3360),
    eq = __webpack_require__(5288);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 6025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(5288);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 4733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(1791),
    keys = __webpack_require__(5950);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 3838:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(1791),
    keysIn = __webpack_require__(7241);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 3360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(3243);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 7133:
/***/ (function(module) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),

/***/ 9999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    arrayEach = __webpack_require__(3729),
    assignValue = __webpack_require__(6547),
    baseAssign = __webpack_require__(4733),
    baseAssignIn = __webpack_require__(3838),
    cloneBuffer = __webpack_require__(3290),
    copyArray = __webpack_require__(3007),
    copySymbols = __webpack_require__(2271),
    copySymbolsIn = __webpack_require__(8948),
    getAllKeys = __webpack_require__(2),
    getAllKeysIn = __webpack_require__(3349),
    getTag = __webpack_require__(5861),
    initCloneArray = __webpack_require__(6189),
    initCloneByTag = __webpack_require__(7199),
    initCloneObject = __webpack_require__(5529),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isMap = __webpack_require__(7730),
    isObject = __webpack_require__(3805),
    isSet = __webpack_require__(8440),
    keys = __webpack_require__(5950),
    keysIn = __webpack_require__(7241);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 9344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3805);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(641),
    createBaseEach = __webpack_require__(8329);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 3220:
/***/ (function(module) {

/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function(value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

module.exports = baseFindKey;


/***/ }),

/***/ 3120:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(4528),
    isFlattenable = __webpack_require__(5891);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 6649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(3221);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 641:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(6649),
    keys = __webpack_require__(5950);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 7422:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1769),
    toKey = __webpack_require__(7797);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 2199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(4528),
    isArray = __webpack_require__(6449);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 2552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    getRawTag = __webpack_require__(659),
    objectToString = __webpack_require__(9350);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 426:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),

/***/ 8077:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 7534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 4688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike(value) && baseGetTag(value) == dateTag;
}

module.exports = baseIsDate;


/***/ }),

/***/ 270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(7068),
    isObjectLike = __webpack_require__(346);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 7068:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    equalArrays = __webpack_require__(5911),
    equalByTag = __webpack_require__(1986),
    equalObjects = __webpack_require__(689),
    getTag = __webpack_require__(5861),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isTypedArray = __webpack_require__(7167);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 9172:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(5861),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 1799:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    baseIsEqual = __webpack_require__(270);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 5083:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isMasked = __webpack_require__(7296),
    isObject = __webpack_require__(3805),
    toSource = __webpack_require__(7473);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 6038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(5861),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 7282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isLength = __webpack_require__(294),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 5389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(3663),
    baseMatchesProperty = __webpack_require__(7978),
    identity = __webpack_require__(3488),
    isArray = __webpack_require__(6449),
    property = __webpack_require__(583);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 8984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(5527),
    nativeKeys = __webpack_require__(3650);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 2903:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3805),
    isPrototype = __webpack_require__(5527),
    nativeKeysIn = __webpack_require__(181);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 5128:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(909),
    isArrayLike = __webpack_require__(4894);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 3663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1799),
    getMatchData = __webpack_require__(776),
    matchesStrictComparable = __webpack_require__(7197);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 7978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(270),
    get = __webpack_require__(8156),
    hasIn = __webpack_require__(631),
    isKey = __webpack_require__(8586),
    isStrictComparable = __webpack_require__(756),
    matchesStrictComparable = __webpack_require__(7197),
    toKey = __webpack_require__(7797);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 5250:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    assignMergeValue = __webpack_require__(7805),
    baseFor = __webpack_require__(6649),
    baseMergeDeep = __webpack_require__(2824),
    isObject = __webpack_require__(3805),
    keysIn = __webpack_require__(7241),
    safeGet = __webpack_require__(4974);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 2824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(7805),
    cloneBuffer = __webpack_require__(3290),
    cloneTypedArray = __webpack_require__(1961),
    copyArray = __webpack_require__(3007),
    initCloneObject = __webpack_require__(5529),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isArrayLikeObject = __webpack_require__(3693),
    isBuffer = __webpack_require__(3656),
    isFunction = __webpack_require__(1882),
    isObject = __webpack_require__(3805),
    isPlainObject = __webpack_require__(1331),
    isTypedArray = __webpack_require__(7167),
    safeGet = __webpack_require__(4974),
    toPlainObject = __webpack_require__(9884);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 6001:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePickBy = __webpack_require__(7420),
    hasIn = __webpack_require__(631);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),

/***/ 7420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7422),
    baseSet = __webpack_require__(3170),
    castPath = __webpack_require__(1769);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),

/***/ 7237:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 7255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7422);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 9302:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(3488),
    overRest = __webpack_require__(6757),
    setToString = __webpack_require__(2865);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 3170:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(6547),
    castPath = __webpack_require__(1769),
    isIndex = __webpack_require__(361),
    isObject = __webpack_require__(3805),
    toKey = __webpack_require__(7797);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ 9570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(7334),
    defineProperty = __webpack_require__(3243),
    identity = __webpack_require__(3488);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 5160:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(909);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),

/***/ 8096:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 1372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(4932);

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

module.exports = baseToPairs;


/***/ }),

/***/ 7556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    arrayMap = __webpack_require__(4932),
    isArray = __webpack_require__(6449),
    isSymbol = __webpack_require__(4394);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 4128:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(1800);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 7301:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 9931:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1769),
    last = __webpack_require__(8090),
    parent = __webpack_require__(8969),
    toKey = __webpack_require__(7797);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 9219:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 4066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(3488);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 1769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(6449),
    isKey = __webpack_require__(8586),
    stringToPath = __webpack_require__(1802),
    toString = __webpack_require__(3222);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 9653:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(7828);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 3290:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 6169:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(9653);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 3201:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 3736:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 1961:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(9653);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 3007:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 1791:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(6547),
    baseAssignValue = __webpack_require__(3360);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 2271:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(1791),
    getSymbols = __webpack_require__(4664);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 8948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(1791),
    getSymbolsIn = __webpack_require__(6375);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 5481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRest = __webpack_require__(9302),
    isIterateeCall = __webpack_require__(6800);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 8329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(4894);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 3221:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 2963:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToPairs = __webpack_require__(1372),
    getTag = __webpack_require__(5861),
    mapToArray = __webpack_require__(317),
    setToPairs = __webpack_require__(799);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

module.exports = createToPairs;


/***/ }),

/***/ 2606:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(5250),
    isObject = __webpack_require__(3805);

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

module.exports = customDefaultsMerge;


/***/ }),

/***/ 3138:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPlainObject = __webpack_require__(1331);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 3243:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 5911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(8859),
    arraySome = __webpack_require__(4248),
    cacheHas = __webpack_require__(9219);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 1986:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    Uint8Array = __webpack_require__(7828),
    eq = __webpack_require__(5288),
    equalArrays = __webpack_require__(5911),
    mapToArray = __webpack_require__(317),
    setToArray = __webpack_require__(4247);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(2);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 8816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var flatten = __webpack_require__(5970),
    overRest = __webpack_require__(6757),
    setToString = __webpack_require__(2865);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 4840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 2:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(2199),
    getSymbols = __webpack_require__(4664),
    keys = __webpack_require__(5950);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 3349:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(2199),
    getSymbolsIn = __webpack_require__(6375),
    keysIn = __webpack_require__(7241);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 2651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(4218);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 776:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(756),
    keys = __webpack_require__(5950);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 6110:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(5083),
    getValue = __webpack_require__(392);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 8879:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(4335);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(9770),
    stubArray = __webpack_require__(3345);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 6375:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(4528),
    getPrototype = __webpack_require__(8879),
    getSymbols = __webpack_require__(4664),
    stubArray = __webpack_require__(3345);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 5861:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(5580),
    Map = __webpack_require__(8223),
    Promise = __webpack_require__(2804),
    Set = __webpack_require__(6545),
    WeakMap = __webpack_require__(8303),
    baseGetTag = __webpack_require__(2552),
    toSource = __webpack_require__(7473);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 392:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 9326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1769),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isIndex = __webpack_require__(361),
    isLength = __webpack_require__(294),
    toKey = __webpack_require__(7797);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 2032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 3862:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 6721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 2749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 5749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 6189:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 7199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(9653),
    cloneDataView = __webpack_require__(6169),
    cloneRegExp = __webpack_require__(3201),
    cloneSymbol = __webpack_require__(3736),
    cloneTypedArray = __webpack_require__(1961);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 5529:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(9344),
    getPrototype = __webpack_require__(8879),
    isPrototype = __webpack_require__(5527);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 5891:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 361:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 6800:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(5288),
    isArrayLike = __webpack_require__(4894),
    isIndex = __webpack_require__(361),
    isObject = __webpack_require__(3805);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 8586:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(6449),
    isSymbol = __webpack_require__(4394);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 4218:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 7296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(5481);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 5527:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 756:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3805);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 3702:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 80:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 4739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 8655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 1175:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 3040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1549),
    ListCache = __webpack_require__(79),
    Map = __webpack_require__(8223);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 7670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 4509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 2949:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 317:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 7197:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 2224:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(104);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 1042:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 3650:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(4335);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 181:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 6009:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(4840);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 9350:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 4335:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 6757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(1033);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 8969:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7422),
    baseSlice = __webpack_require__(5160);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 9325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(4840);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 4974:
/***/ (function(module) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 1380:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 1459:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 4247:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 799:
/***/ (function(module) {

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;


/***/ }),

/***/ 2865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(9570),
    shortOut = __webpack_require__(1811);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 1811:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 1420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 938:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 3605:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 9817:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    Map = __webpack_require__(8223),
    MapCache = __webpack_require__(3661);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 1802:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(2224);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 7797:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4394);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 7473:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 1800:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 8659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClamp = __webpack_require__(7133),
    toNumber = __webpack_require__(9374);

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;


/***/ }),

/***/ 7334:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 4684:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRest = __webpack_require__(9302),
    eq = __webpack_require__(5288),
    isIterateeCall = __webpack_require__(6800),
    keysIn = __webpack_require__(7241);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;


/***/ }),

/***/ 4354:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(1033),
    baseRest = __webpack_require__(9302),
    customDefaultsMerge = __webpack_require__(2606),
    mergeWith = __webpack_require__(6924);

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, customDefaultsMerge);
  return apply(mergeWith, undefined, args);
});

module.exports = defaultsDeep;


/***/ }),

/***/ 5288:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 826:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindKey = __webpack_require__(3220),
    baseForOwn = __webpack_require__(641),
    baseIteratee = __webpack_require__(5389);

/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwn);
}

module.exports = findKey;


/***/ }),

/***/ 5970:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(3120);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 9754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(3729),
    baseEach = __webpack_require__(909),
    castFunction = __webpack_require__(4066),
    isArray = __webpack_require__(6449);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 5596:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(641),
    castFunction = __webpack_require__(4066);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),

/***/ 8156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7422);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 1448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHas = __webpack_require__(426),
    hasPath = __webpack_require__(9326);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),

/***/ 631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(8077),
    hasPath = __webpack_require__(9326);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 912:
/***/ (function(module) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),

/***/ 3488:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 2428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(7534),
    isObjectLike = __webpack_require__(346);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 6449:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 4894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isLength = __webpack_require__(294);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 3693:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(4894),
    isObjectLike = __webpack_require__(346);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 3812:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),

/***/ 3656:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325),
    stubFalse = __webpack_require__(9935);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 3602:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsDate = __webpack_require__(4688),
    baseUnary = __webpack_require__(7301),
    nodeUtil = __webpack_require__(6009);

/* Node.js helper references. */
var nodeIsDate = nodeUtil && nodeUtil.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

module.exports = isDate;


/***/ }),

/***/ 2404:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(270);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 1882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObject = __webpack_require__(3805);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 294:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 7730:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(9172),
    baseUnary = __webpack_require__(7301),
    nodeUtil = __webpack_require__(6009);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 8023:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ 3805:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 346:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 1331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    getPrototype = __webpack_require__(8879),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 8440:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(6038),
    baseUnary = __webpack_require__(7301),
    nodeUtil = __webpack_require__(6009);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 5015:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isArray = __webpack_require__(6449),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 4394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 7167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(7282),
    baseUnary = __webpack_require__(7301),
    nodeUtil = __webpack_require__(6009);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 2216:
/***/ (function(module) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),

/***/ 5950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(695),
    baseKeys = __webpack_require__(8984),
    isArrayLike = __webpack_require__(4894);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 7241:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(695),
    baseKeysIn = __webpack_require__(2903),
    isArrayLike = __webpack_require__(4894);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 8090:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 5378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(4932),
    baseIteratee = __webpack_require__(5389),
    baseMap = __webpack_require__(5128),
    isArray = __webpack_require__(6449);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 3916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(3360),
    baseForOwn = __webpack_require__(641),
    baseIteratee = __webpack_require__(5389);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ 104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3661);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 5364:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(5250),
    createAssigner = __webpack_require__(999);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 6924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(5250),
    createAssigner = __webpack_require__(999);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ 179:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(4932),
    baseClone = __webpack_require__(9999),
    baseUnset = __webpack_require__(9931),
    castPath = __webpack_require__(1769),
    copyObject = __webpack_require__(1791),
    customOmitClone = __webpack_require__(3138),
    flatRest = __webpack_require__(8816),
    getAllKeysIn = __webpack_require__(3349);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 4383:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePick = __webpack_require__(6001),
    flatRest = __webpack_require__(8816);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),

/***/ 583:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(7237),
    basePropertyDeep = __webpack_require__(7255),
    isKey = __webpack_require__(8586),
    toKey = __webpack_require__(7797);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 3560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSet = __webpack_require__(3170);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ 2426:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arraySome = __webpack_require__(4248),
    baseIteratee = __webpack_require__(5389),
    baseSome = __webpack_require__(916),
    isArray = __webpack_require__(6449),
    isIterateeCall = __webpack_require__(6800);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),

/***/ 3345:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 9935:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 9374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(4128),
    isObject = __webpack_require__(3805),
    isSymbol = __webpack_require__(4394);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 8938:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createToPairs = __webpack_require__(2963),
    keys = __webpack_require__(5950);

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;


/***/ }),

/***/ 9884:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(1791),
    keysIn = __webpack_require__(7241);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 3222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(7556);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 189:
/***/ (function(module) {

"use strict";
module.exports = require("froala-editor");

/***/ }),

/***/ 9271:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 9306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(4901);
var tryToString = __webpack_require__(6823);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 3506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isPossiblePrototype = __webpack_require__(3925);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ 7080:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var has = (__webpack_require__(4402).has);

// Perform ? RequireInternalSlot(M, [[SetData]])
module.exports = function (it) {
  has(it);
  return it;
};


/***/ }),

/***/ 679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isPrototypeOf = __webpack_require__(1625);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};


/***/ }),

/***/ 8551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(34);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 7811:
/***/ (function(module) {

"use strict";

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),

/***/ 7394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);
var uncurryThisAccessor = __webpack_require__(6706);
var classof = __webpack_require__(2195);

var ArrayBuffer = globalThis.ArrayBuffer;
var TypeError = globalThis.TypeError;

// Includes
// - Perform ? RequireInternalSlot(O, [[ArrayBufferData]]).
// - If IsSharedArrayBuffer(O) is true, throw a TypeError exception.
module.exports = ArrayBuffer && uncurryThisAccessor(ArrayBuffer.prototype, 'byteLength', 'get') || function (O) {
  if (classof(O) !== 'ArrayBuffer') throw new TypeError('ArrayBuffer expected');
  return O.byteLength;
};


/***/ }),

/***/ 3238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);
var NATIVE_ARRAY_BUFFER = __webpack_require__(7811);
var arrayBufferByteLength = __webpack_require__(7394);

var DataView = globalThis.DataView;

module.exports = function (O) {
  if (!NATIVE_ARRAY_BUFFER || arrayBufferByteLength(O) !== 0) return false;
  try {
    // eslint-disable-next-line no-new -- thrower
    new DataView(O);
    return false;
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 5169:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isDetached = __webpack_require__(3238);

var $TypeError = TypeError;

module.exports = function (it) {
  if (isDetached(it)) throw new $TypeError('ArrayBuffer is detached');
  return it;
};


/***/ }),

/***/ 5636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);
var uncurryThis = __webpack_require__(9504);
var uncurryThisAccessor = __webpack_require__(6706);
var toIndex = __webpack_require__(7696);
var notDetached = __webpack_require__(5169);
var arrayBufferByteLength = __webpack_require__(7394);
var detachTransferable = __webpack_require__(4483);
var PROPER_STRUCTURED_CLONE_TRANSFER = __webpack_require__(1548);

var structuredClone = globalThis.structuredClone;
var ArrayBuffer = globalThis.ArrayBuffer;
var DataView = globalThis.DataView;
var min = Math.min;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataViewPrototype = DataView.prototype;
var slice = uncurryThis(ArrayBufferPrototype.slice);
var isResizable = uncurryThisAccessor(ArrayBufferPrototype, 'resizable', 'get');
var maxByteLength = uncurryThisAccessor(ArrayBufferPrototype, 'maxByteLength', 'get');
var getInt8 = uncurryThis(DataViewPrototype.getInt8);
var setInt8 = uncurryThis(DataViewPrototype.setInt8);

module.exports = (PROPER_STRUCTURED_CLONE_TRANSFER || detachTransferable) && function (arrayBuffer, newLength, preserveResizability) {
  var byteLength = arrayBufferByteLength(arrayBuffer);
  var newByteLength = newLength === undefined ? byteLength : toIndex(newLength);
  var fixedLength = !isResizable || !isResizable(arrayBuffer);
  var newBuffer;
  notDetached(arrayBuffer);
  if (PROPER_STRUCTURED_CLONE_TRANSFER) {
    arrayBuffer = structuredClone(arrayBuffer, { transfer: [arrayBuffer] });
    if (byteLength === newByteLength && (preserveResizability || fixedLength)) return arrayBuffer;
  }
  if (byteLength >= newByteLength && (!preserveResizability || fixedLength)) {
    newBuffer = slice(arrayBuffer, 0, newByteLength);
  } else {
    var options = preserveResizability && !fixedLength && maxByteLength ? { maxByteLength: maxByteLength(arrayBuffer) } : undefined;
    newBuffer = new ArrayBuffer(newByteLength, options);
    var a = new DataView(arrayBuffer);
    var b = new DataView(newBuffer);
    var copyLength = min(newByteLength, byteLength);
    for (var i = 0; i < copyLength; i++) setInt8(b, i, getInt8(a, i));
  }
  if (!PROPER_STRUCTURED_CLONE_TRANSFER) detachTransferable(arrayBuffer);
  return newBuffer;
};


/***/ }),

/***/ 4644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__(7811);
var DESCRIPTORS = __webpack_require__(3724);
var globalThis = __webpack_require__(4576);
var isCallable = __webpack_require__(4901);
var isObject = __webpack_require__(34);
var hasOwn = __webpack_require__(9297);
var classof = __webpack_require__(6955);
var tryToString = __webpack_require__(6823);
var createNonEnumerableProperty = __webpack_require__(6699);
var defineBuiltIn = __webpack_require__(6840);
var defineBuiltInAccessor = __webpack_require__(2106);
var isPrototypeOf = __webpack_require__(1625);
var getPrototypeOf = __webpack_require__(2787);
var setPrototypeOf = __webpack_require__(2967);
var wellKnownSymbol = __webpack_require__(8227);
var uid = __webpack_require__(3392);
var InternalStateModule = __webpack_require__(1181);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = globalThis.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = globalThis.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = globalThis.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(globalThis.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw new TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw new TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = globalThis[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = globalThis[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = globalThis[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = globalThis[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = globalThis[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw new TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (globalThis[NAME]) setPrototypeOf(globalThis[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (globalThis[NAME]) setPrototypeOf(globalThis[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (globalThis[NAME]) {
    createNonEnumerableProperty(globalThis[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ 5370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__(6198);

module.exports = function (Constructor, list, $length) {
  var index = 0;
  var length = arguments.length > 2 ? $length : lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};


/***/ }),

/***/ 9617:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(5397);
var toAbsoluteIndex = __webpack_require__(5610);
var lengthOfArrayLike = __webpack_require__(6198);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 4527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var isArray = __webpack_require__(4376);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ 7628:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__(6198);

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toReversed
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toReversed
module.exports = function (O, C) {
  var len = lengthOfArrayLike(O);
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = O[len - k - 1];
  return A;
};


/***/ }),

/***/ 9928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__(6198);
var toIntegerOrInfinity = __webpack_require__(1291);

var $RangeError = RangeError;

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with
module.exports = function (O, C, index, value) {
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
  if (actualIndex >= len || actualIndex < 0) throw new $RangeError('Incorrect index');
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = k === actualIndex ? value : O[k];
  return A;
};


/***/ }),

/***/ 6319:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(8551);
var iteratorClose = __webpack_require__(9539);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ 2195:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 6955:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(2140);
var isCallable = __webpack_require__(4901);
var classofRaw = __webpack_require__(2195);
var wellKnownSymbol = __webpack_require__(8227);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 7740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(9297);
var ownKeys = __webpack_require__(5031);
var getOwnPropertyDescriptorModule = __webpack_require__(7347);
var definePropertyModule = __webpack_require__(4913);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 2211:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9039);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 2529:
/***/ (function(module) {

"use strict";

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ 6699:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var definePropertyModule = __webpack_require__(4913);
var createPropertyDescriptor = __webpack_require__(6980);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 6980:
/***/ (function(module) {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 4659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var definePropertyModule = __webpack_require__(4913);
var createPropertyDescriptor = __webpack_require__(6980);

module.exports = function (object, key, value) {
  if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};


/***/ }),

/***/ 2106:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var makeBuiltIn = __webpack_require__(283);
var defineProperty = __webpack_require__(4913);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 6840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(4901);
var definePropertyModule = __webpack_require__(4913);
var makeBuiltIn = __webpack_require__(283);
var defineGlobalProperty = __webpack_require__(9433);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 6279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(6840);

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ 9433:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(globalThis, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis[key] = value;
  } return value;
};


/***/ }),

/***/ 3724:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9039);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),

/***/ 4483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);
var getBuiltInNodeModule = __webpack_require__(9429);
var PROPER_STRUCTURED_CLONE_TRANSFER = __webpack_require__(1548);

var structuredClone = globalThis.structuredClone;
var $ArrayBuffer = globalThis.ArrayBuffer;
var $MessageChannel = globalThis.MessageChannel;
var detach = false;
var WorkerThreads, channel, buffer, $detach;

if (PROPER_STRUCTURED_CLONE_TRANSFER) {
  detach = function (transferable) {
    structuredClone(transferable, { transfer: [transferable] });
  };
} else if ($ArrayBuffer) try {
  if (!$MessageChannel) {
    WorkerThreads = getBuiltInNodeModule('worker_threads');
    if (WorkerThreads) $MessageChannel = WorkerThreads.MessageChannel;
  }

  if ($MessageChannel) {
    channel = new $MessageChannel();
    buffer = new $ArrayBuffer(2);

    $detach = function (transferable) {
      channel.port1.postMessage(null, [transferable]);
    };

    if (buffer.byteLength === 2) {
      $detach(buffer);
      if (buffer.byteLength === 0) detach = $detach;
    }
  }
} catch (error) { /* empty */ }

module.exports = detach;


/***/ }),

/***/ 4055:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);
var isObject = __webpack_require__(34);

var document = globalThis.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 6837:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 8727:
/***/ (function(module) {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 6193:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ENVIRONMENT = __webpack_require__(4215);

module.exports = ENVIRONMENT === 'NODE';


/***/ }),

/***/ 2839:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);

var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;

module.exports = userAgent ? String(userAgent) : '';


/***/ }),

/***/ 9519:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);
var userAgent = __webpack_require__(2839);

var process = globalThis.process;
var Deno = globalThis.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 4215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* global Bun, Deno -- detection */
var globalThis = __webpack_require__(4576);
var userAgent = __webpack_require__(2839);
var classof = __webpack_require__(2195);

var userAgentStartsWith = function (string) {
  return userAgent.slice(0, string.length) === string;
};

module.exports = (function () {
  if (userAgentStartsWith('Bun/')) return 'BUN';
  if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
  if (userAgentStartsWith('Deno/')) return 'DENO';
  if (userAgentStartsWith('Node.js/')) return 'NODE';
  if (globalThis.Bun && typeof Bun.version == 'string') return 'BUN';
  if (globalThis.Deno && typeof Deno.version == 'object') return 'DENO';
  if (classof(globalThis.process) === 'process') return 'NODE';
  if (globalThis.window && globalThis.document) return 'BROWSER';
  return 'REST';
})();


/***/ }),

/***/ 6518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);
var getOwnPropertyDescriptor = (__webpack_require__(7347).f);
var createNonEnumerableProperty = __webpack_require__(6699);
var defineBuiltIn = __webpack_require__(6840);
var defineGlobalProperty = __webpack_require__(9433);
var copyConstructorProperties = __webpack_require__(7740);
var isForced = __webpack_require__(2796);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis;
  } else if (STATIC) {
    target = globalThis[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis[TARGET] && globalThis[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 9039:
/***/ (function(module) {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 6080:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(7476);
var aCallable = __webpack_require__(9306);
var NATIVE_BIND = __webpack_require__(616);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 616:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9039);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 9565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(616);

var call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var hasOwn = __webpack_require__(9297);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 6706:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var aCallable = __webpack_require__(9306);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 7476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classofRaw = __webpack_require__(2195);
var uncurryThis = __webpack_require__(9504);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ 9504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(616);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 9429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);
var IS_NODE = __webpack_require__(6193);

module.exports = function (name) {
  if (IS_NODE) {
    try {
      return globalThis.process.getBuiltinModule(name);
    } catch (error) { /* empty */ }
    try {
      // eslint-disable-next-line no-new-func -- safe
      return Function('return require("' + name + '")')();
    } catch (error) { /* empty */ }
  }
};


/***/ }),

/***/ 7751:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);
var isCallable = __webpack_require__(4901);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis[namespace]) : globalThis[namespace] && globalThis[namespace][method];
};


/***/ }),

/***/ 1767:
/***/ (function(module) {

"use strict";

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
module.exports = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};


/***/ }),

/***/ 851:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(6955);
var getMethod = __webpack_require__(5966);
var isNullOrUndefined = __webpack_require__(4117);
var Iterators = __webpack_require__(6269);
var wellKnownSymbol = __webpack_require__(8227);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 81:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9565);
var aCallable = __webpack_require__(9306);
var anObject = __webpack_require__(8551);
var tryToString = __webpack_require__(6823);
var getIteratorMethod = __webpack_require__(851);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw new $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ 5966:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(9306);
var isNullOrUndefined = __webpack_require__(4117);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 3789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(9306);
var anObject = __webpack_require__(8551);
var call = __webpack_require__(9565);
var toIntegerOrInfinity = __webpack_require__(1291);
var getIteratorDirect = __webpack_require__(1767);

var INVALID_SIZE = 'Invalid size';
var $RangeError = RangeError;
var $TypeError = TypeError;
var max = Math.max;

var SetRecord = function (set, intSize) {
  this.set = set;
  this.size = max(intSize, 0);
  this.has = aCallable(set.has);
  this.keys = aCallable(set.keys);
};

SetRecord.prototype = {
  getIterator: function () {
    return getIteratorDirect(anObject(call(this.keys, this.set)));
  },
  includes: function (it) {
    return call(this.has, this.set, it);
  }
};

// `GetSetRecord` abstract operation
// https://tc39.es/proposal-set-methods/#sec-getsetrecord
module.exports = function (obj) {
  anObject(obj);
  var numSize = +obj.size;
  // NOTE: If size is undefined, then numSize will be NaN
  // eslint-disable-next-line no-self-compare -- NaN check
  if (numSize !== numSize) throw new $TypeError(INVALID_SIZE);
  var intSize = toIntegerOrInfinity(numSize);
  if (intSize < 0) throw new $RangeError(INVALID_SIZE);
  return new SetRecord(obj, intSize);
};


/***/ }),

/***/ 4576:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  check(typeof this == 'object' && this) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 9297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var toObject = __webpack_require__(8981);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 421:
/***/ (function(module) {

"use strict";

module.exports = {};


/***/ }),

/***/ 397:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(7751);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 5917:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var fails = __webpack_require__(9039);
var createElement = __webpack_require__(4055);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),

/***/ 7055:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var fails = __webpack_require__(9039);
var classof = __webpack_require__(2195);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 3706:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var isCallable = __webpack_require__(4901);
var store = __webpack_require__(7629);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 1181:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__(8622);
var globalThis = __webpack_require__(4576);
var isObject = __webpack_require__(34);
var createNonEnumerableProperty = __webpack_require__(6699);
var hasOwn = __webpack_require__(9297);
var shared = __webpack_require__(7629);
var sharedKey = __webpack_require__(6119);
var hiddenKeys = __webpack_require__(421);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = globalThis.TypeError;
var WeakMap = globalThis.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 4209:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(8227);
var Iterators = __webpack_require__(6269);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 4376:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(2195);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),

/***/ 1108:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(6955);

module.exports = function (it) {
  var klass = classof(it);
  return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};


/***/ }),

/***/ 4901:
/***/ (function(module) {

"use strict";

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 2796:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9039);
var isCallable = __webpack_require__(4901);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 4117:
/***/ (function(module) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 34:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(4901);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 3925:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(34);

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};


/***/ }),

/***/ 6395:
/***/ (function(module) {

"use strict";

module.exports = false;


/***/ }),

/***/ 757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(7751);
var isCallable = __webpack_require__(4901);
var isPrototypeOf = __webpack_require__(1625);
var USE_SYMBOL_AS_UID = __webpack_require__(7040);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9565);

module.exports = function (record, fn, ITERATOR_INSTEAD_OF_RECORD) {
  var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
  var next = record.next;
  var step, result;
  while (!(step = call(next, iterator)).done) {
    result = fn(step.value);
    if (result !== undefined) return result;
  }
};


/***/ }),

/***/ 2652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(6080);
var call = __webpack_require__(9565);
var anObject = __webpack_require__(8551);
var tryToString = __webpack_require__(6823);
var isArrayIteratorMethod = __webpack_require__(4209);
var lengthOfArrayLike = __webpack_require__(6198);
var isPrototypeOf = __webpack_require__(1625);
var getIterator = __webpack_require__(81);
var getIteratorMethod = __webpack_require__(851);
var iteratorClose = __webpack_require__(9539);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ 9539:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9565);
var anObject = __webpack_require__(8551);
var getMethod = __webpack_require__(5966);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 9462:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9565);
var create = __webpack_require__(2360);
var createNonEnumerableProperty = __webpack_require__(6699);
var defineBuiltIns = __webpack_require__(6279);
var wellKnownSymbol = __webpack_require__(8227);
var InternalStateModule = __webpack_require__(1181);
var getMethod = __webpack_require__(5966);
var IteratorPrototype = (__webpack_require__(7657).IteratorPrototype);
var createIterResultObject = __webpack_require__(2529);
var iteratorClose = __webpack_require__(9539);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var setInternalState = InternalStateModule.set;

var createIteratorProxyPrototype = function (IS_ITERATOR) {
  var getInternalState = InternalStateModule.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);

  return defineBuiltIns(create(IteratorPrototype), {
    next: function next() {
      var state = getInternalState(this);
      // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` or with `state.returnHandlerResult` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value
      if (IS_ITERATOR) return state.nextHandler();
      if (state.done) return createIterResultObject(undefined, true);
      try {
        var result = state.nextHandler();
        return state.returnHandlerResult ? result : createIterResultObject(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function () {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      if (IS_ITERATOR) {
        var returnMethod = getMethod(iterator, 'return');
        return returnMethod ? call(returnMethod, iterator) : createIterResultObject(undefined, true);
      }
      if (state.inner) try {
        iteratorClose(state.inner.iterator, 'normal');
      } catch (error) {
        return iteratorClose(iterator, 'throw', error);
      }
      if (iterator) iteratorClose(iterator, 'normal');
      return createIterResultObject(undefined, true);
    }
  });
};

var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
var IteratorHelperPrototype = createIteratorProxyPrototype(false);

createNonEnumerableProperty(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');

module.exports = function (nextHandler, IS_ITERATOR, RETURN_HANDLER_RESULT) {
  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;
    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
    state.returnHandlerResult = !!RETURN_HANDLER_RESULT;
    state.nextHandler = nextHandler;
    state.counter = 0;
    state.done = false;
    setInternalState(this, state);
  };

  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;

  return IteratorProxy;
};


/***/ }),

/***/ 713:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9565);
var aCallable = __webpack_require__(9306);
var anObject = __webpack_require__(8551);
var getIteratorDirect = __webpack_require__(1767);
var createIteratorProxy = __webpack_require__(9462);
var callWithSafeIterationClosing = __webpack_require__(6319);

var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  var result = anObject(call(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, [result.value, this.counter++], true);
});

// `Iterator.prototype.map` method
// https://github.com/tc39/proposal-iterator-helpers
module.exports = function map(mapper) {
  anObject(this);
  aCallable(mapper);
  return new IteratorProxy(getIteratorDirect(this), {
    mapper: mapper
  });
};


/***/ }),

/***/ 7657:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9039);
var isCallable = __webpack_require__(4901);
var isObject = __webpack_require__(34);
var create = __webpack_require__(2360);
var getPrototypeOf = __webpack_require__(2787);
var defineBuiltIn = __webpack_require__(6840);
var wellKnownSymbol = __webpack_require__(8227);
var IS_PURE = __webpack_require__(6395);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 6269:
/***/ (function(module) {

"use strict";

module.exports = {};


/***/ }),

/***/ 6198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toLength = __webpack_require__(8014);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 283:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var fails = __webpack_require__(9039);
var isCallable = __webpack_require__(4901);
var hasOwn = __webpack_require__(9297);
var DESCRIPTORS = __webpack_require__(3724);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(350).CONFIGURABLE);
var inspectSource = __webpack_require__(3706);
var InternalStateModule = __webpack_require__(1181);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 741:
/***/ (function(module) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 2360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(8551);
var definePropertiesModule = __webpack_require__(6801);
var enumBugKeys = __webpack_require__(8727);
var hiddenKeys = __webpack_require__(421);
var html = __webpack_require__(397);
var documentCreateElement = __webpack_require__(4055);
var sharedKey = __webpack_require__(6119);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ 6801:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(8686);
var definePropertyModule = __webpack_require__(4913);
var anObject = __webpack_require__(8551);
var toIndexedObject = __webpack_require__(5397);
var objectKeys = __webpack_require__(1072);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ 4913:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var IE8_DOM_DEFINE = __webpack_require__(5917);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(8686);
var anObject = __webpack_require__(8551);
var toPropertyKey = __webpack_require__(6969);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 7347:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var call = __webpack_require__(9565);
var propertyIsEnumerableModule = __webpack_require__(8773);
var createPropertyDescriptor = __webpack_require__(6980);
var toIndexedObject = __webpack_require__(5397);
var toPropertyKey = __webpack_require__(6969);
var hasOwn = __webpack_require__(9297);
var IE8_DOM_DEFINE = __webpack_require__(5917);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 8480:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(1828);
var enumBugKeys = __webpack_require__(8727);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 3717:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 2787:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(9297);
var isCallable = __webpack_require__(4901);
var toObject = __webpack_require__(8981);
var sharedKey = __webpack_require__(6119);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(2211);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 1625:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 1828:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var hasOwn = __webpack_require__(9297);
var toIndexedObject = __webpack_require__(5397);
var indexOf = (__webpack_require__(9617).indexOf);
var hiddenKeys = __webpack_require__(421);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 1072:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(1828);
var enumBugKeys = __webpack_require__(8727);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 8773:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 2967:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(6706);
var isObject = __webpack_require__(34);
var requireObjectCoercible = __webpack_require__(7750);
var aPossiblePrototype = __webpack_require__(3506);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 4270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9565);
var isCallable = __webpack_require__(4901);
var isObject = __webpack_require__(34);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 5031:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(7751);
var uncurryThis = __webpack_require__(9504);
var getOwnPropertyNamesModule = __webpack_require__(8480);
var getOwnPropertySymbolsModule = __webpack_require__(3717);
var anObject = __webpack_require__(8551);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 7750:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isNullOrUndefined = __webpack_require__(4117);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 9286:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var SetHelpers = __webpack_require__(4402);
var iterate = __webpack_require__(8469);

var Set = SetHelpers.Set;
var add = SetHelpers.add;

module.exports = function (set) {
  var result = new Set();
  iterate(set, function (it) {
    add(result, it);
  });
  return result;
};


/***/ }),

/***/ 3440:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(7080);
var SetHelpers = __webpack_require__(4402);
var clone = __webpack_require__(9286);
var size = __webpack_require__(5170);
var getSetRecord = __webpack_require__(3789);
var iterateSet = __webpack_require__(8469);
var iterateSimple = __webpack_require__(507);

var has = SetHelpers.has;
var remove = SetHelpers.remove;

// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
module.exports = function difference(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  var result = clone(O);
  if (size(O) <= otherRec.size) iterateSet(O, function (e) {
    if (otherRec.includes(e)) remove(result, e);
  });
  else iterateSimple(otherRec.getIterator(), function (e) {
    if (has(O, e)) remove(result, e);
  });
  return result;
};


/***/ }),

/***/ 4402:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);

// eslint-disable-next-line es/no-set -- safe
var SetPrototype = Set.prototype;

module.exports = {
  // eslint-disable-next-line es/no-set -- safe
  Set: Set,
  add: uncurryThis(SetPrototype.add),
  has: uncurryThis(SetPrototype.has),
  remove: uncurryThis(SetPrototype['delete']),
  proto: SetPrototype
};


/***/ }),

/***/ 8750:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(7080);
var SetHelpers = __webpack_require__(4402);
var size = __webpack_require__(5170);
var getSetRecord = __webpack_require__(3789);
var iterateSet = __webpack_require__(8469);
var iterateSimple = __webpack_require__(507);

var Set = SetHelpers.Set;
var add = SetHelpers.add;
var has = SetHelpers.has;

// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
module.exports = function intersection(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  var result = new Set();

  if (size(O) > otherRec.size) {
    iterateSimple(otherRec.getIterator(), function (e) {
      if (has(O, e)) add(result, e);
    });
  } else {
    iterateSet(O, function (e) {
      if (otherRec.includes(e)) add(result, e);
    });
  }

  return result;
};


/***/ }),

/***/ 4449:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(7080);
var has = (__webpack_require__(4402).has);
var size = __webpack_require__(5170);
var getSetRecord = __webpack_require__(3789);
var iterateSet = __webpack_require__(8469);
var iterateSimple = __webpack_require__(507);
var iteratorClose = __webpack_require__(9539);

// `Set.prototype.isDisjointFrom` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
module.exports = function isDisjointFrom(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  if (size(O) <= otherRec.size) return iterateSet(O, function (e) {
    if (otherRec.includes(e)) return false;
  }, true) !== false;
  var iterator = otherRec.getIterator();
  return iterateSimple(iterator, function (e) {
    if (has(O, e)) return iteratorClose(iterator, 'normal', false);
  }) !== false;
};


/***/ }),

/***/ 1457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(7080);
var size = __webpack_require__(5170);
var iterate = __webpack_require__(8469);
var getSetRecord = __webpack_require__(3789);

// `Set.prototype.isSubsetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
module.exports = function isSubsetOf(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  if (size(O) > otherRec.size) return false;
  return iterate(O, function (e) {
    if (!otherRec.includes(e)) return false;
  }, true) !== false;
};


/***/ }),

/***/ 8527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(7080);
var has = (__webpack_require__(4402).has);
var size = __webpack_require__(5170);
var getSetRecord = __webpack_require__(3789);
var iterateSimple = __webpack_require__(507);
var iteratorClose = __webpack_require__(9539);

// `Set.prototype.isSupersetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
module.exports = function isSupersetOf(other) {
  var O = aSet(this);
  var otherRec = getSetRecord(other);
  if (size(O) < otherRec.size) return false;
  var iterator = otherRec.getIterator();
  return iterateSimple(iterator, function (e) {
    if (!has(O, e)) return iteratorClose(iterator, 'normal', false);
  }) !== false;
};


/***/ }),

/***/ 8469:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var iterateSimple = __webpack_require__(507);
var SetHelpers = __webpack_require__(4402);

var Set = SetHelpers.Set;
var SetPrototype = SetHelpers.proto;
var forEach = uncurryThis(SetPrototype.forEach);
var keys = uncurryThis(SetPrototype.keys);
var next = keys(new Set()).next;

module.exports = function (set, fn, interruptible) {
  return interruptible ? iterateSimple({ iterator: keys(set), next: next }, fn) : forEach(set, fn);
};


/***/ }),

/***/ 4916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(7751);

var createSetLike = function (size) {
  return {
    size: size,
    has: function () {
      return false;
    },
    keys: function () {
      return {
        next: function () {
          return { done: true };
        }
      };
    }
  };
};

var createSetLikeWithInfinitySize = function (size) {
  return {
    size: size,
    has: function () {
      return true;
    },
    keys: function () {
      throw new Error('e');
    }
  };
};

module.exports = function (name, callback) {
  var Set = getBuiltIn('Set');
  try {
    new Set()[name](createSetLike(0));
    try {
      // late spec change, early WebKit ~ Safari 17.0 beta implementation does not pass it
      // https://github.com/tc39/proposal-set-methods/pull/88
      new Set()[name](createSetLike(-1));
      return false;
    } catch (error2) {
      if (!callback) return true;
      // early V8 implementation bug
      // https://issues.chromium.org/issues/351332634
      try {
        new Set()[name](createSetLikeWithInfinitySize(-Infinity));
        return false;
      } catch (error) {
        var set = new Set();
        set.add(1);
        set.add(2);
        return callback(set[name](createSetLikeWithInfinitySize(Infinity)));
      }
    }
  } catch (error) {
    return false;
  }
};


/***/ }),

/***/ 5170:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThisAccessor = __webpack_require__(6706);
var SetHelpers = __webpack_require__(4402);

module.exports = uncurryThisAccessor(SetHelpers.proto, 'size', 'get') || function (set) {
  return set.size;
};


/***/ }),

/***/ 1269:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(7080);
var SetHelpers = __webpack_require__(4402);
var clone = __webpack_require__(9286);
var getSetRecord = __webpack_require__(3789);
var iterateSimple = __webpack_require__(507);

var add = SetHelpers.add;
var has = SetHelpers.has;
var remove = SetHelpers.remove;

// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
module.exports = function symmetricDifference(other) {
  var O = aSet(this);
  var keysIter = getSetRecord(other).getIterator();
  var result = clone(O);
  iterateSimple(keysIter, function (e) {
    if (has(O, e)) remove(result, e);
    else add(result, e);
  });
  return result;
};


/***/ }),

/***/ 4204:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aSet = __webpack_require__(7080);
var add = (__webpack_require__(4402).add);
var clone = __webpack_require__(9286);
var getSetRecord = __webpack_require__(3789);
var iterateSimple = __webpack_require__(507);

// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
module.exports = function union(other) {
  var O = aSet(this);
  var keysIter = getSetRecord(other).getIterator();
  var result = clone(O);
  iterateSimple(keysIter, function (it) {
    add(result, it);
  });
  return result;
};


/***/ }),

/***/ 6119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var shared = __webpack_require__(5745);
var uid = __webpack_require__(3392);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 7629:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(6395);
var globalThis = __webpack_require__(4576);
var defineGlobalProperty = __webpack_require__(9433);

var SHARED = '__core-js_shared__';
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});

(store.versions || (store.versions = [])).push({
  version: '3.40.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.40.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 5745:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var store = __webpack_require__(7629);

module.exports = function (key, value) {
  return store[key] || (store[key] = value || {});
};


/***/ }),

/***/ 1548:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);
var fails = __webpack_require__(9039);
var V8 = __webpack_require__(9519);
var ENVIRONMENT = __webpack_require__(4215);

var structuredClone = globalThis.structuredClone;

module.exports = !!structuredClone && !fails(function () {
  // prevent V8 ArrayBufferDetaching protector cell invalidation and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if ((ENVIRONMENT === 'DENO' && V8 > 92) || (ENVIRONMENT === 'NODE' && V8 > 94) || (ENVIRONMENT === 'BROWSER' && V8 > 97)) return false;
  var buffer = new ArrayBuffer(8);
  var clone = structuredClone(buffer, { transfer: [buffer] });
  return buffer.byteLength !== 0 || clone.byteLength !== 8;
});


/***/ }),

/***/ 4495:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(9519);
var fails = __webpack_require__(9039);
var globalThis = __webpack_require__(4576);

var $String = globalThis.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 5610:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(1291);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 5854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(2777);

var $TypeError = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
module.exports = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw new $TypeError("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};


/***/ }),

/***/ 7696:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(1291);
var toLength = __webpack_require__(8014);

var $RangeError = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw new $RangeError('Wrong length or index');
  return length;
};


/***/ }),

/***/ 5397:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(7055);
var requireObjectCoercible = __webpack_require__(7750);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 1291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var trunc = __webpack_require__(741);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 8014:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(1291);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 8981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var requireObjectCoercible = __webpack_require__(7750);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 2777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9565);
var isObject = __webpack_require__(34);
var isSymbol = __webpack_require__(757);
var getMethod = __webpack_require__(5966);
var ordinaryToPrimitive = __webpack_require__(4270);
var wellKnownSymbol = __webpack_require__(8227);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 6969:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(2777);
var isSymbol = __webpack_require__(757);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 2140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(8227);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(6955);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 6823:
/***/ (function(module) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 3392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 7040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(4495);

module.exports = NATIVE_SYMBOL &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 8686:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var fails = __webpack_require__(9039);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),

/***/ 2812:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 8622:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);
var isCallable = __webpack_require__(4901);

var WeakMap = globalThis.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 8227:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(4576);
var shared = __webpack_require__(5745);
var hasOwn = __webpack_require__(9297);
var uid = __webpack_require__(3392);
var NATIVE_SYMBOL = __webpack_require__(4495);
var USE_SYMBOL_AS_UID = __webpack_require__(7040);

var Symbol = globalThis.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 6573:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var defineBuiltInAccessor = __webpack_require__(2106);
var isDetached = __webpack_require__(3238);

var ArrayBufferPrototype = ArrayBuffer.prototype;

// `ArrayBuffer.prototype.detached` getter
// https://tc39.es/ecma262/#sec-get-arraybuffer.prototype.detached
if (DESCRIPTORS && !('detached' in ArrayBufferPrototype)) {
  defineBuiltInAccessor(ArrayBufferPrototype, 'detached', {
    configurable: true,
    get: function detached() {
      return isDetached(this);
    }
  });
}


/***/ }),

/***/ 7936:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var $transfer = __webpack_require__(5636);

// `ArrayBuffer.prototype.transferToFixedLength` method
// https://tc39.es/proposal-arraybuffer-transfer/#sec-arraybuffer.prototype.transfertofixedlength
if ($transfer) $({ target: 'ArrayBuffer', proto: true }, {
  transferToFixedLength: function transferToFixedLength() {
    return $transfer(this, arguments.length ? arguments[0] : undefined, false);
  }
});


/***/ }),

/***/ 8100:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var $transfer = __webpack_require__(5636);

// `ArrayBuffer.prototype.transfer` method
// https://tc39.es/proposal-arraybuffer-transfer/#sec-arraybuffer.prototype.transfer
if ($transfer) $({ target: 'ArrayBuffer', proto: true }, {
  transfer: function transfer() {
    return $transfer(this, arguments.length ? arguments[0] : undefined, true);
  }
});


/***/ }),

/***/ 4114:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var toObject = __webpack_require__(8981);
var lengthOfArrayLike = __webpack_require__(6198);
var setArrayLength = __webpack_require__(4527);
var doesNotExceedSafeInteger = __webpack_require__(6837);
var fails = __webpack_require__(9039);

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ 8111:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var globalThis = __webpack_require__(4576);
var anInstance = __webpack_require__(679);
var anObject = __webpack_require__(8551);
var isCallable = __webpack_require__(4901);
var getPrototypeOf = __webpack_require__(2787);
var defineBuiltInAccessor = __webpack_require__(2106);
var createProperty = __webpack_require__(4659);
var fails = __webpack_require__(9039);
var hasOwn = __webpack_require__(9297);
var wellKnownSymbol = __webpack_require__(8227);
var IteratorPrototype = (__webpack_require__(7657).IteratorPrototype);
var DESCRIPTORS = __webpack_require__(3724);
var IS_PURE = __webpack_require__(6395);

var CONSTRUCTOR = 'constructor';
var ITERATOR = 'Iterator';
var TO_STRING_TAG = wellKnownSymbol('toStringTag');

var $TypeError = TypeError;
var NativeIterator = globalThis[ITERATOR];

// FF56- have non-standard global helper `Iterator`
var FORCED = IS_PURE
  || !isCallable(NativeIterator)
  || NativeIterator.prototype !== IteratorPrototype
  // FF44- non-standard `Iterator` passes previous tests
  || !fails(function () { NativeIterator({}); });

var IteratorConstructor = function Iterator() {
  anInstance(this, IteratorPrototype);
  if (getPrototypeOf(this) === IteratorPrototype) throw new $TypeError('Abstract class Iterator not directly constructable');
};

var defineIteratorPrototypeAccessor = function (key, value) {
  if (DESCRIPTORS) {
    defineBuiltInAccessor(IteratorPrototype, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject(this);
        if (this === IteratorPrototype) throw new $TypeError("You can't redefine this property");
        if (hasOwn(this, key)) this[key] = replacement;
        else createProperty(this, key, replacement);
      }
    });
  } else IteratorPrototype[key] = value;
};

if (!hasOwn(IteratorPrototype, TO_STRING_TAG)) defineIteratorPrototypeAccessor(TO_STRING_TAG, ITERATOR);

if (FORCED || !hasOwn(IteratorPrototype, CONSTRUCTOR) || IteratorPrototype[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}

IteratorConstructor.prototype = IteratorPrototype;

// `Iterator` constructor
// https://tc39.es/ecma262/#sec-iterator
$({ global: true, constructor: true, forced: FORCED }, {
  Iterator: IteratorConstructor
});


/***/ }),

/***/ 1148:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var iterate = __webpack_require__(2652);
var aCallable = __webpack_require__(9306);
var anObject = __webpack_require__(8551);
var getIteratorDirect = __webpack_require__(1767);

// `Iterator.prototype.every` method
// https://tc39.es/ecma262/#sec-iterator.prototype.every
$({ target: 'Iterator', proto: true, real: true }, {
  every: function every(predicate) {
    anObject(this);
    aCallable(predicate);
    var record = getIteratorDirect(this);
    var counter = 0;
    return !iterate(record, function (value, stop) {
      if (!predicate(value, counter++)) return stop();
    }, { IS_RECORD: true, INTERRUPTED: true }).stopped;
  }
});


/***/ }),

/***/ 2489:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var call = __webpack_require__(9565);
var aCallable = __webpack_require__(9306);
var anObject = __webpack_require__(8551);
var getIteratorDirect = __webpack_require__(1767);
var createIteratorProxy = __webpack_require__(9462);
var callWithSafeIterationClosing = __webpack_require__(6319);
var IS_PURE = __webpack_require__(6395);

var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  var predicate = this.predicate;
  var next = this.next;
  var result, done, value;
  while (true) {
    result = anObject(call(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing(iterator, predicate, [value, this.counter++], true)) return value;
  }
});

// `Iterator.prototype.filter` method
// https://tc39.es/ecma262/#sec-iterator.prototype.filter
$({ target: 'Iterator', proto: true, real: true, forced: IS_PURE }, {
  filter: function filter(predicate) {
    anObject(this);
    aCallable(predicate);
    return new IteratorProxy(getIteratorDirect(this), {
      predicate: predicate
    });
  }
});


/***/ }),

/***/ 116:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var iterate = __webpack_require__(2652);
var aCallable = __webpack_require__(9306);
var anObject = __webpack_require__(8551);
var getIteratorDirect = __webpack_require__(1767);

// `Iterator.prototype.find` method
// https://tc39.es/ecma262/#sec-iterator.prototype.find
$({ target: 'Iterator', proto: true, real: true }, {
  find: function find(predicate) {
    anObject(this);
    aCallable(predicate);
    var record = getIteratorDirect(this);
    var counter = 0;
    return iterate(record, function (value, stop) {
      if (predicate(value, counter++)) return stop(value);
    }, { IS_RECORD: true, INTERRUPTED: true }).result;
  }
});


/***/ }),

/***/ 7588:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var iterate = __webpack_require__(2652);
var aCallable = __webpack_require__(9306);
var anObject = __webpack_require__(8551);
var getIteratorDirect = __webpack_require__(1767);

// `Iterator.prototype.forEach` method
// https://tc39.es/ecma262/#sec-iterator.prototype.foreach
$({ target: 'Iterator', proto: true, real: true }, {
  forEach: function forEach(fn) {
    anObject(this);
    aCallable(fn);
    var record = getIteratorDirect(this);
    var counter = 0;
    iterate(record, function (value) {
      fn(value, counter++);
    }, { IS_RECORD: true });
  }
});


/***/ }),

/***/ 1701:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var map = __webpack_require__(713);
var IS_PURE = __webpack_require__(6395);

// `Iterator.prototype.map` method
// https://tc39.es/ecma262/#sec-iterator.prototype.map
$({ target: 'Iterator', proto: true, real: true, forced: IS_PURE }, {
  map: map
});


/***/ }),

/***/ 8237:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var iterate = __webpack_require__(2652);
var aCallable = __webpack_require__(9306);
var anObject = __webpack_require__(8551);
var getIteratorDirect = __webpack_require__(1767);

var $TypeError = TypeError;

// `Iterator.prototype.reduce` method
// https://tc39.es/ecma262/#sec-iterator.prototype.reduce
$({ target: 'Iterator', proto: true, real: true }, {
  reduce: function reduce(reducer /* , initialValue */) {
    anObject(this);
    aCallable(reducer);
    var record = getIteratorDirect(this);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    var counter = 0;
    iterate(record, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = reducer(accumulator, value, counter);
      }
      counter++;
    }, { IS_RECORD: true });
    if (noInitial) throw new $TypeError('Reduce of empty iterator with no initial value');
    return accumulator;
  }
});


/***/ }),

/***/ 3579:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var iterate = __webpack_require__(2652);
var aCallable = __webpack_require__(9306);
var anObject = __webpack_require__(8551);
var getIteratorDirect = __webpack_require__(1767);

// `Iterator.prototype.some` method
// https://tc39.es/ecma262/#sec-iterator.prototype.some
$({ target: 'Iterator', proto: true, real: true }, {
  some: function some(predicate) {
    anObject(this);
    aCallable(predicate);
    var record = getIteratorDirect(this);
    var counter = 0;
    return iterate(record, function (value, stop) {
      if (predicate(value, counter++)) return stop();
    }, { IS_RECORD: true, INTERRUPTED: true }).stopped;
  }
});


/***/ }),

/***/ 7642:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var difference = __webpack_require__(3440);
var setMethodAcceptSetLike = __webpack_require__(4916);

var INCORRECT = !setMethodAcceptSetLike('difference', function (result) {
  return result.size === 0;
});

// `Set.prototype.difference` method
// https://tc39.es/ecma262/#sec-set.prototype.difference
$({ target: 'Set', proto: true, real: true, forced: INCORRECT }, {
  difference: difference
});


/***/ }),

/***/ 8004:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var fails = __webpack_require__(9039);
var intersection = __webpack_require__(8750);
var setMethodAcceptSetLike = __webpack_require__(4916);

var INCORRECT = !setMethodAcceptSetLike('intersection', function (result) {
  return result.size === 2 && result.has(1) && result.has(2);
}) || fails(function () {
  // eslint-disable-next-line es/no-array-from, es/no-set, es/no-set-prototype-intersection -- testing
  return String(Array.from(new Set([1, 2, 3]).intersection(new Set([3, 2])))) !== '3,2';
});

// `Set.prototype.intersection` method
// https://tc39.es/ecma262/#sec-set.prototype.intersection
$({ target: 'Set', proto: true, real: true, forced: INCORRECT }, {
  intersection: intersection
});


/***/ }),

/***/ 3853:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var isDisjointFrom = __webpack_require__(4449);
var setMethodAcceptSetLike = __webpack_require__(4916);

var INCORRECT = !setMethodAcceptSetLike('isDisjointFrom', function (result) {
  return !result;
});

// `Set.prototype.isDisjointFrom` method
// https://tc39.es/ecma262/#sec-set.prototype.isdisjointfrom
$({ target: 'Set', proto: true, real: true, forced: INCORRECT }, {
  isDisjointFrom: isDisjointFrom
});


/***/ }),

/***/ 5876:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var isSubsetOf = __webpack_require__(1457);
var setMethodAcceptSetLike = __webpack_require__(4916);

var INCORRECT = !setMethodAcceptSetLike('isSubsetOf', function (result) {
  return result;
});

// `Set.prototype.isSubsetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issubsetof
$({ target: 'Set', proto: true, real: true, forced: INCORRECT }, {
  isSubsetOf: isSubsetOf
});


/***/ }),

/***/ 2475:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var isSupersetOf = __webpack_require__(8527);
var setMethodAcceptSetLike = __webpack_require__(4916);

var INCORRECT = !setMethodAcceptSetLike('isSupersetOf', function (result) {
  return !result;
});

// `Set.prototype.isSupersetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issupersetof
$({ target: 'Set', proto: true, real: true, forced: INCORRECT }, {
  isSupersetOf: isSupersetOf
});


/***/ }),

/***/ 5024:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var symmetricDifference = __webpack_require__(1269);
var setMethodAcceptSetLike = __webpack_require__(4916);

// `Set.prototype.symmetricDifference` method
// https://tc39.es/ecma262/#sec-set.prototype.symmetricdifference
$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('symmetricDifference') }, {
  symmetricDifference: symmetricDifference
});


/***/ }),

/***/ 1698:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var union = __webpack_require__(4204);
var setMethodAcceptSetLike = __webpack_require__(4916);

// `Set.prototype.union` method
// https://tc39.es/ecma262/#sec-set.prototype.union
$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('union') }, {
  union: union
});


/***/ }),

/***/ 7467:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arrayToReversed = __webpack_require__(7628);
var ArrayBufferViewCore = __webpack_require__(4644);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;

// `%TypedArray%.prototype.toReversed` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.toreversed
exportTypedArrayMethod('toReversed', function toReversed() {
  return arrayToReversed(aTypedArray(this), getTypedArrayConstructor(this));
});


/***/ }),

/***/ 4732:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(4644);
var uncurryThis = __webpack_require__(9504);
var aCallable = __webpack_require__(9306);
var arrayFromConstructorAndList = __webpack_require__(5370);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var sort = uncurryThis(ArrayBufferViewCore.TypedArrayPrototype.sort);

// `%TypedArray%.prototype.toSorted` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tosorted
exportTypedArrayMethod('toSorted', function toSorted(compareFn) {
  if (compareFn !== undefined) aCallable(compareFn);
  var O = aTypedArray(this);
  var A = arrayFromConstructorAndList(getTypedArrayConstructor(O), O);
  return sort(A, compareFn);
});


/***/ }),

/***/ 9577:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arrayWith = __webpack_require__(9928);
var ArrayBufferViewCore = __webpack_require__(4644);
var isBigIntArray = __webpack_require__(1108);
var toIntegerOrInfinity = __webpack_require__(1291);
var toBigInt = __webpack_require__(5854);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var PROPER_ORDER = !!function () {
  try {
    // eslint-disable-next-line no-throw-literal, es/no-typed-arrays, es/no-array-prototype-with -- required for testing
    new Int8Array(1)['with'](2, { valueOf: function () { throw 8; } });
  } catch (error) {
    // some early implementations, like WebKit, does not follow the final semantic
    // https://github.com/tc39/proposal-change-array-by-copy/pull/86
    return error === 8;
  }
}();

// `%TypedArray%.prototype.with` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.with
exportTypedArrayMethod('with', { 'with': function (index, value) {
  var O = aTypedArray(this);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualValue = isBigIntArray(O) ? toBigInt(value) : +value;
  return arrayWith(O, getTypedArrayConstructor(O), relativeIndex, actualValue);
} }['with'], !PROPER_ORDER);


/***/ }),

/***/ 8992:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(8111);


/***/ }),

/***/ 3215:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(1148);


/***/ }),

/***/ 4520:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(2489);


/***/ }),

/***/ 2577:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(116);


/***/ }),

/***/ 3949:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(7588);


/***/ }),

/***/ 1454:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(1701);


/***/ }),

/***/ 8872:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(8237);


/***/ }),

/***/ 7550:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
__webpack_require__(3579);


/***/ }),

/***/ 4603:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(6840);
var uncurryThis = __webpack_require__(9504);
var toString = __webpack_require__(655);
var validateArgumentsLength = __webpack_require__(2812);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var append = uncurryThis(URLSearchParamsPrototype.append);
var $delete = uncurryThis(URLSearchParamsPrototype['delete']);
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
var push = uncurryThis([].push);
var params = new $URLSearchParams('a=1&a=2&b=3');

params['delete']('a', 1);
// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
params['delete']('b', undefined);

if (params + '' !== 'a=2') {
  defineBuiltIn(URLSearchParamsPrototype, 'delete', function (name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $delete(this, name);
    var entries = [];
    forEach(this, function (v, k) { // also validates `this`
      push(entries, { key: k, value: v });
    });
    validateArgumentsLength(length, 1);
    var key = toString(name);
    var value = toString($value);
    var index = 0;
    var dindex = 0;
    var found = false;
    var entriesLength = entries.length;
    var entry;
    while (index < entriesLength) {
      entry = entries[index++];
      if (found || entry.key === key) {
        found = true;
        $delete(this, entry.key);
      } else dindex++;
    }
    while (dindex < entriesLength) {
      entry = entries[dindex++];
      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
    }
  }, { enumerable: true, unsafe: true });
}


/***/ }),

/***/ 7566:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(6840);
var uncurryThis = __webpack_require__(9504);
var toString = __webpack_require__(655);
var validateArgumentsLength = __webpack_require__(2812);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var getAll = uncurryThis(URLSearchParamsPrototype.getAll);
var $has = uncurryThis(URLSearchParamsPrototype.has);
var params = new $URLSearchParams('a=1');

// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
if (params.has('a', 2) || !params.has('a', undefined)) {
  defineBuiltIn(URLSearchParamsPrototype, 'has', function has(name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $has(this, name);
    var values = getAll(this, name); // also validates `this`
    validateArgumentsLength(length, 1);
    var value = toString($value);
    var index = 0;
    while (index < values.length) {
      if (values[index++] === value) return true;
    } return false;
  }, { enumerable: true, unsafe: true });
}


/***/ }),

/***/ 8721:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var uncurryThis = __webpack_require__(9504);
var defineBuiltInAccessor = __webpack_require__(2106);

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach(this, function () { count++; });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}


/***/ }),

/***/ 4533:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = newDateUTC;

/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
  var utcDate = new Date(0);
  utcDate.setUTCFullYear(fullYear, month, day);
  utcDate.setUTCHours(hour, minute, second, millisecond);
  return utcDate;
}

module.exports = exports.default;

/***/ }),

/***/ 8509:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = tzParseTimezone;

var _index = _interopRequireDefault(__webpack_require__(2506));

var _index2 = _interopRequireDefault(__webpack_require__(4533));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var patterns = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
}; // Parse various time zone offset formats to an offset in milliseconds

function tzParseTimezone(timezoneString, date, isUtcDate) {
  var token;
  var absoluteOffset; // Empty string

  if (!timezoneString) {
    return 0;
  } // Z


  token = patterns.timezoneZ.exec(timezoneString);

  if (token) {
    return 0;
  }

  var hours; // ±hh

  token = patterns.timezoneHH.exec(timezoneString);

  if (token) {
    hours = parseInt(token[1], 10);

    if (!validateTimezone(hours)) {
      return NaN;
    }

    return -(hours * MILLISECONDS_IN_HOUR);
  } // ±hh:mm or ±hhmm


  token = patterns.timezoneHHMM.exec(timezoneString);

  if (token) {
    hours = parseInt(token[1], 10);
    var minutes = parseInt(token[2], 10);

    if (!validateTimezone(hours, minutes)) {
      return NaN;
    }

    absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
    return hours > 0 ? -absoluteOffset : absoluteOffset;
  } // IANA time zone


  if (isValidTimezoneIANAString(timezoneString)) {
    date = new Date(date || Date.now());
    var utcDate = isUtcDate ? date : toUtcDate(date);
    var offset = calcOffset(utcDate, timezoneString);
    var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);
    return -fixedOffset;
  }

  return NaN;
}

function toUtcDate(date) {
  return (0, _index2.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}

function calcOffset(date, timezoneString) {
  var tokens = (0, _index.default)(date, timezoneString); // ms dropped because it's not provided by tzTokenizeDate

  var asUTC = (0, _index2.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
  var asTS = date.getTime();
  var over = asTS % 1000;
  asTS -= over >= 0 ? over : 1000 + over;
  return asUTC - asTS;
}

function fixOffset(date, offset, timezoneString) {
  var localTS = date.getTime(); // Our UTC time is just a guess because our offset is just a guess

  var utcGuess = localTS - offset; // Test whether the zone matches the offset for this ts

  var o2 = calcOffset(new Date(utcGuess), timezoneString); // If so, offset didn't change, and we're done

  if (offset === o2) {
    return offset;
  } // If not, change the ts by the difference in the offset


  utcGuess -= o2 - offset; // If that gives us the local time we want, we're done

  var o3 = calcOffset(new Date(utcGuess), timezoneString);

  if (o2 === o3) {
    return o2;
  } // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time


  return Math.max(o2, o3);
}

function validateTimezone(hours, minutes) {
  return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}

var validIANATimezoneCache = {};

function isValidTimezoneIANAString(timeZoneString) {
  if (validIANATimezoneCache[timeZoneString]) return true;

  try {
    new Intl.DateTimeFormat(undefined, {
      timeZone: timeZoneString
    });
    validIANATimezoneCache[timeZoneString] = true;
    return true;
  } catch (error) {
    return false;
  }
}

module.exports = exports.default;

/***/ }),

/***/ 1839:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/** Regex to identify the presence of a time zone specifier in a date string */
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var _default = tzPattern;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 2506:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = tzTokenizeDate;

/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */
function tzTokenizeDate(date, timeZone) {
  var dtf = getDateTimeFormat(timeZone);
  return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
}

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};

function partsOffset(dtf, date) {
  try {
    var formatted = dtf.formatToParts(date);
    var filled = [];

    for (var i = 0; i < formatted.length; i++) {
      var pos = typeToPos[formatted[i].type];

      if (pos >= 0) {
        filled[pos] = parseInt(formatted[i].value, 10);
      }
    }

    return filled;
  } catch (error) {
    if (error instanceof RangeError) {
      return [NaN];
    }

    throw error;
  }
}

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '');
  var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted); // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
  // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]

  return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]];
} // Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.


var dtfCache = {};

function getDateTimeFormat(timeZone) {
  if (!dtfCache[timeZone]) {
    // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
    var testDateFormatted = new Intl.DateTimeFormat('en-US', {
      hour12: false,
      timeZone: 'America/New_York',
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(new Date('2014-06-25T04:00:00.123Z'));
    var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === '‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00';
    dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
      hour12: false,
      timeZone: timeZone,
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }) : new Intl.DateTimeFormat('en-US', {
      hourCycle: 'h23',
      timeZone: timeZone,
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  return dtfCache[timeZone];
}

module.exports = exports.default;

/***/ }),

/***/ 8305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toDate;

var _index = _interopRequireDefault(__webpack_require__(9784));

var _index2 = _interopRequireDefault(__webpack_require__(9720));

var _index3 = _interopRequireDefault(__webpack_require__(8509));

var _index4 = _interopRequireDefault(__webpack_require__(1839));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [/^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [/^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: _index4.default
};
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */

function toDate(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  if (argument === null) {
    return new Date(NaN);
  }

  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _index.default)(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  } // Clone the date


  if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') {
    return new Date(argument);
  } else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;
  var date = parseDate(restDateString, year);

  if (isNaN(date)) {
    return new Date(NaN);
  }

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);

      if (isNaN(time)) {
        return new Date(NaN);
      }
    }

    if (dateStrings.timeZone || options.timeZone) {
      offset = (0, _index3.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));

      if (isNaN(offset)) {
        return new Date(NaN);
      }
    } else {
      // get offset accurate to hour in time zones that change offset
      offset = (0, _index2.default)(new Date(timestamp + time));
      offset = (0, _index2.default)(new Date(timestamp + time + offset));
    }

    return new Date(timestamp + time + offset);
  } else {
    return new Date(NaN);
  }
}

function splitDateString(dateString) {
  var dateStrings = {};
  var parts = patterns.dateTimePattern.exec(dateString);
  var timeString;

  if (!parts) {
    parts = patterns.datePattern.exec(dateString);

    if (parts) {
      dateStrings.date = parts[1];
      timeString = parts[2];
    } else {
      dateStrings.date = null;
      timeString = dateString;
    }
  } else {
    dateStrings.date = parts[1];
    timeString = parts[3];
  }

  if (timeString) {
    var token = patterns.timeZone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timeZone = token[1].trim();
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits];
  var patternYYYYY = patterns.YYYYY[additionalDigits];
  var token; // YYYY or ±YYYYY

  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);

  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    };
  } // YY or ±YYY


  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);

  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    };
  } // Invalid ISO-formatted year


  return {
    year: null
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null;
  }

  var token;
  var date;
  var month;
  var week; // YYYY

  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date;
  } // YYYY-MM


  token = patterns.MM.exec(dateString);

  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;

    if (!validateDate(year, month)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month);
    return date;
  } // YYYY-DDD or YYYYDDD


  token = patterns.DDD.exec(dateString);

  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);

    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, 0, dayOfYear);
    return date;
  } // yyyy-MM-dd or YYYYMMDD


  token = patterns.MMDD.exec(dateString);

  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);

    if (!validateDate(year, month, day)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, day);
    return date;
  } // YYYY-Www or YYYYWww


  token = patterns.Www.exec(dateString);

  if (token) {
    week = parseInt(token[1], 10) - 1;

    if (!validateWeekDate(year, week)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week);
  } // YYYY-Www-D or YYYYWwwD


  token = patterns.WwwD.exec(dateString);

  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;

    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } // Invalid ISO-formatted date


  return null;
}

function parseTime(timeString) {
  var token;
  var hours;
  var minutes; // hh

  token = patterns.HH.exec(timeString);

  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));

    if (!validateTime(hours)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR;
  } // hh:mm or hhmm


  token = patterns.HHMM.exec(timeString);

  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));

    if (!validateTime(hours, minutes)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
  } // hh:mm:ss or hhmmss


  token = patterns.HHMMSS.exec(timeString);

  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));

    if (!validateTime(hours, minutes, seconds)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
  } // Invalid ISO-formatted time


  return null;
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions


var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  if (month < 0 || month > 11) {
    return false;
  }

  if (date != null) {
    if (date < 1) {
      return false;
    }

    var isLeapYear = isLeapYearIndex(year);

    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false;
    }

    if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
      return false;
    }
  }

  return true;
}

function validateDayOfYearDate(year, dayOfYear) {
  if (dayOfYear < 1) {
    return false;
  }

  var isLeapYear = isLeapYearIndex(year);

  if (isLeapYear && dayOfYear > 366) {
    return false;
  }

  if (!isLeapYear && dayOfYear > 365) {
    return false;
  }

  return true;
}

function validateWeekDate(year, week, day) {
  if (week < 0 || week > 52) {
    return false;
  }

  if (day != null && (day < 0 || day > 6)) {
    return false;
  }

  return true;
}

function validateTime(hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false;
  }

  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false;
  }

  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false;
  }

  return true;
}

module.exports = exports.default;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  EditorConfigComplete: function() { return /* reexport */ complete; },
  EditorConfigPdf: function() { return /* reexport */ pdf; },
  EditorConfigSimple: function() { return /* reexport */ simple; },
  FroalaEditor: function() { return /* reexport */ FroalaEditor; },
  FroalaView: function() { return /* reexport */ FroalaView; },
  KForm: function() { return /* reexport */ Form_Form; },
  KFormAddress: function() { return /* reexport */ Address_Address; },
  KFormAddressSearch: function() { return /* reexport */ AddressSearch; },
  KFormCheckbox: function() { return /* reexport */ Checkbox_Checkbox; },
  KFormCheckboxGroup: function() { return /* reexport */ CheckboxGroup; },
  KFormDatepicker: function() { return /* reexport */ DatePicker_DatePicker; },
  KFormDatetime: function() { return /* reexport */ DateTime_DateTime; },
  KFormEditor: function() { return /* reexport */ Editor_Editor; },
  KFormFile: function() { return /* reexport */ FileUpload_FileUpload; },
  KFormFileUpload: function() { return /* reexport */ FileUpload_FileUpload; },
  KFormInput: function() { return /* reexport */ Input_Input; },
  KFormNumber: function() { return /* reexport */ InputNumber_InputNumber; },
  KFormPeriodSelect: function() { return /* reexport */ PeriodSelect_PeriodSelect; },
  KFormPhone: function() { return /* reexport */ Phone_Phone; },
  KFormSelect: function() { return /* reexport */ Select_Select; },
  KFormSpinner: function() { return /* reexport */ Spinner; },
  KFormStickyBar: function() { return /* reexport */ StickyBar_StickyBar; },
  KFormTextarea: function() { return /* reexport */ Textarea_Textarea; },
  KFormTimepicker: function() { return /* reexport */ TimePicker_TimePicker; },
  KwixeoForm: function() { return /* reexport */ install; },
  Lang: function() { return /* reexport */ src_lang; },
  applyMessage: function() { return /* reexport */ applyMessage; },
  arrayOf: function() { return /* reexport */ validate_arrayOf; },
  decimal: function() { return /* reexport */ validate_decimal; },
  domain: function() { return /* reexport */ validate_domain; },
  email: function() { return /* reexport */ validate_email; },
  getElement: function() { return /* reexport */ getElement; },
  getMessage: function() { return /* reexport */ getMessage; },
  hexColor: function() { return /* reexport */ validate_hexColor; },
  integer: function() { return /* reexport */ validate_integer; },
  max: function() { return /* reexport */ validate_max; },
  maxChecked: function() { return /* reexport */ validate_maxChecked; },
  min: function() { return /* reexport */ validate_min; },
  minChecked: function() { return /* reexport */ validate_minChecked; },
  password: function() { return /* reexport */ validate_password; },
  phone: function() { return /* reexport */ validate_phone; },
  required: function() { return /* reexport */ validate_required; },
  requiredCheckbox: function() { return /* reexport */ validate_requiredCheckbox; },
  sameValue: function() { return /* reexport */ validate_sameValue; },
  time: function() { return /* reexport */ validate_time; },
  url: function() { return /* reexport */ validate_url; },
  validate: function() { return /* reexport */ external_validate_js_namespaceObject; }
});

;// ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Address/Address.vue?vue&type=template&id=24fc58ff
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "kw-form-control"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('k-form-input', {
    staticClass: "mb-2",
    attrs: {
      "size": _vm.size,
      "placeholder": _vm.roadPlaceholder,
      "required": _vm.roadRequired,
      "name": _vm.computedRoadName,
      "id": _vm.computedRoadId,
      "autocomplete": "off",
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.searchAddress
    },
    model: {
      value: _vm.road,
      callback: function ($$v) {
        _vm.road = $$v;
      },
      expression: "road"
    }
  }), _vm.computedDropdownVisibility ? _c('div', {
    staticClass: "dropdown-menu address-dropdown-menu"
  }, [_vm.dropdownLoading ? _c('div', {
    staticClass: "dropdown-item text-center disabled"
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  })], 1) : _vm._e(), _vm._l(_vm.addressesList, function (value, key) {
    return _c('button', {
      key: key,
      ref: 'dropdown-entry-' + key,
      refInFor: true,
      class: {
        'dropdown-item': true,
        'btn-sm': _vm.computedDropdownSize === 'sm',
        'btn-lg': _vm.computedDropdownSize === 'lg'
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.selectValue(value);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.getApiLabel(value)) + " ")]);
  })], 2) : _vm._e()], 1), _c('k-form-input', {
    staticClass: "mb-2",
    attrs: {
      "size": _vm.size,
      "placeholder": _vm.road2Placeholder,
      "name": _vm.computedRoad2Name,
      "id": _vm.computedRoad2Id,
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.road2,
      callback: function ($$v) {
        _vm.road2 = $$v;
      },
      expression: "road2"
    }
  }), _vm.withRoad3 !== false ? _c('k-form-input', {
    staticClass: "mb-2",
    attrs: {
      "size": _vm.size,
      "placeholder": _vm.road3Placeholder,
      "name": _vm.computedRoad3Name,
      "id": _vm.computedRoad3Id,
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.road3,
      callback: function ($$v) {
        _vm.road3 = $$v;
      },
      expression: "road3"
    }
  }) : _vm._e(), _c('b-form-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "4"
    }
  }, [_c('k-form-input', {
    staticClass: "mb-2",
    attrs: {
      "size": _vm.size,
      "placeholder": _vm.postalCodePlaceholder,
      "required": _vm.required,
      "name": _vm.computedPostalCodeName,
      "id": _vm.computedPostalCodeId,
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.postalCode,
      callback: function ($$v) {
        _vm.postalCode = $$v;
      },
      expression: "postalCode"
    }
  })], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "8"
    }
  }, [_c('k-form-input', {
    staticClass: "mb-2",
    attrs: {
      "size": _vm.size,
      "placeholder": _vm.cityPlaceholder,
      "required": _vm.required,
      "name": _vm.computedCityName,
      "id": _vm.computedCityId,
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.city,
      callback: function ($$v) {
        _vm.city = $$v;
      },
      expression: "city"
    }
  })], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "4"
    }
  }, [_c('k-form-select', {
    attrs: {
      "size": _vm.size,
      "placeholder": _vm.countryPlaceholder,
      "required": _vm.required,
      "name": _vm.computedCountryName,
      "id": _vm.computedCountryId,
      "options": _vm.countriesList,
      "get-option-label": v => v.name,
      "get-option-key": v => v.code,
      "disabled": _vm.disabled,
      "clearable": false
    },
    model: {
      value: _vm.country,
      callback: function ($$v) {
        _vm.country = $$v;
      },
      expression: "country"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(8992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(2577);
;// ./node_modules/tslib/tslib.es6.mjs
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* harmony default export */ var tslib_es6 = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});

;// external "vue"
var external_vue_namespaceObject = require("vue");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_namespaceObject);
;// ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function vue_class_component_esm_createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_vue_default().extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) {}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof (external_vue_default()) ? superProto.constructor : (external_vue_default());
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter']));
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) {}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (Component);


;// ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var Emit_spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, Emit_spreadArrays([emitName], args));
                    }
                }
                else {
                    args.unshift(returnValue);
                    _this.$emit.apply(_this, Emit_spreadArrays([emitName], args));
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

;// ./node_modules/vue-property-decorator/lib/decorators/Inject.js

/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return vue_class_component_esm_createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}

;// ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function metadata_applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            !options.hasOwnProperty('type') &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}

;// ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function ModelSync(propName, event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = { prop: propName, event: event || k };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit(event, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        metadata_applyMetadata(options, target, key);
        vue_class_component_esm_createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/helpers/provideInject.js
function needToProduceProvide(original) {
    return (typeof original !== 'function' ||
        (!original.managed && !original.managedReactive));
}
function produceProvide(original) {
    var provide = function () {
        var _this = this;
        var rv = typeof original === 'function' ? original.call(this) : original;
        rv = Object.create(rv || null);
        // set reactive services (propagates previous services if necessary)
        rv[reactiveInjectKey] = Object.create(this[reactiveInjectKey] || {});
        for (var i in provide.managed) {
            rv[provide.managed[i]] = this[i];
        }
        var _loop_1 = function (i) {
            rv[provide.managedReactive[i]] = this_1[i]; // Duplicates the behavior of `@Provide`
            Object.defineProperty(rv[reactiveInjectKey], provide.managedReactive[i], {
                enumerable: true,
                configurable: true,
                get: function () { return _this[i]; },
            });
        };
        var this_1 = this;
        for (var i in provide.managedReactive) {
            _loop_1(i);
        }
        return rv;
    };
    provide.managed = {};
    provide.managedReactive = {};
    return provide;
}
/** Used for keying reactive provide/inject properties */
var reactiveInjectKey = '__reactiveInject__';
function inheritInjected(componentOptions) {
    // inject parent reactive services (if any)
    if (!Array.isArray(componentOptions.inject)) {
        componentOptions.inject = componentOptions.inject || {};
        componentOptions.inject[reactiveInjectKey] = {
            from: reactiveInjectKey,
            default: {},
        };
    }
}

;// ./node_modules/vue-property-decorator/lib/decorators/Provide.js


/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return vue_class_component_esm_createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        inheritInjected(componentOptions);
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managed[k] = key || k;
    });
}

;// ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return vue_class_component_esm_createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

;// ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>
















;// external "bootstrap-vue"
var external_bootstrap_vue_namespaceObject = require("bootstrap-vue");
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(5364);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
;// external "axios"
var external_axios_namespaceObject = require("axios");
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_namespaceObject);
;// ./src/mixins/HereApi.ts



var HereApi = /** @class */function (_super) {
  __extends(HereApi, _super);
  function HereApi() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.addressesList = [];
    _this.dropdownVisibility = false;
    _this.dropdownLoading = false;
    // Click event on document for automaticaly close the dropdown
    _this.hideDropdownClick = function (e) {
      var target = e.target;
      if (target && !_this.hasParent(target, '.address-geocode-group')) {
        _this.clearAddresses();
      }
    };
    // Hide dropdown when pressing escape
    _this.hideDropdownEsc = function (e) {
      if (e.code === 'Escape') {
        _this.clearAddresses();
      }
    };
    return _this;
  }
  Object.defineProperty(HereApi.prototype, "computedDropdownSize", {
    // Return size for dropdown
    get: function () {
      var _a, _b;
      return (_b = (_a = this.dropdownSize) !== null && _a !== void 0 ? _a : this.size) !== null && _b !== void 0 ? _b : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(HereApi.prototype, "computedDropdownVisibility", {
    // Return dropdown visibility
    get: function () {
      return this.dropdownVisibility && (this.addressesList.length > 0 || this.dropdownLoading);
    },
    enumerable: false,
    configurable: true
  });
  // Call when input event is triggered in input search
  HereApi.prototype.searchAddress = function (val) {
    var _this = this;
    if (val === '') {
      this.addressesList = [];
      return;
    }
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = undefined;
    }
    this.searchTimeout = setTimeout(function () {
      _this.hereRequest(val);
    }, 400);
  };
  // Show dropdown with spinner
  HereApi.prototype.searchingAddresses = function () {
    this.addressesList = [];
    this.dropdownVisibility = true;
    this.dropdownLoading = true;
  };
  // Make an api request to Here.com
  HereApi.prototype.hereRequest = function (query) {
    var _this = this;
    this.searchingAddresses();
    var apiKey = this.$KwFormConfig.hereApiKey;
    var url = 'https://autocomplete.search.hereapi.com/v1/autocomplete';
    external_axios_default().get(url, {
      params: {
        apiKey: apiKey,
        q: query,
        lang: this.hereLang,
        limit: this.hereNbResults,
        in: 'countryCode:' + this.hereCountry.toUpperCase()
      }
    }).then(function (response) {
      _this.dropdownLoading = false;
      var addresses = response.data.items;
      if (addresses.length === 0) {
        _this.clearAddresses();
        return;
      }
      _this.addressesList = addresses;
      _this.initDropdownEvent();
    }).catch(function () {
      _this.clearAddresses();
      throw new Error('Unable to get addresses informations');
    });
  };
  // Return label for a Here.com result
  HereApi.prototype.getApiLabel = function (data) {
    var label = '';
    if (data.address.houseNumber) label += data.address.houseNumber + ' ';
    if (data.address.street) label += data.address.street;
    if (label !== '' && (data.address.postalCode || data.address.city)) label += ', ';
    if (data.address.postalCode) label += data.address.postalCode + ' ';
    if (data.address.city) label += data.address.city;
    if (data.address.countryName) {
      if (label !== '') label += ', ';
      label += data.address.countryName;
    }
    return label;
  };
  // Clear and hide the dropdown
  HereApi.prototype.clearAddresses = function () {
    this.addressesList = [];
    this.dropdownLoading = false;
    this.dropdownVisibility = false;
    this.removeDropdownEvent();
    clearTimeout(this.searchTimeout);
  };
  // Init dropdown events when opening it
  HereApi.prototype.initDropdownEvent = function () {
    window.addEventListener('click', this.hideDropdownClick);
    window.addEventListener('keydown', this.hideDropdownEsc);
  };
  // Init dropdown events when opening it
  HereApi.prototype.removeDropdownEvent = function () {
    window.removeEventListener('click', this.hideDropdownClick);
    window.removeEventListener('keydown', this.hideDropdownEsc);
  };
  // Check parent of target
  HereApi.prototype.hasParent = function (element, selector) {
    if (typeof selector === 'string') {
      selector = document.querySelector(selector);
    }
    if (!selector) return;
    var node = element.parentNode;
    while (node !== null) {
      if (node === selector) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  };
  __decorate([Prop({
    default: null
  })], HereApi.prototype, "size", void 0);
  __decorate([Prop()], HereApi.prototype, "dropdownSize", void 0);
  __decorate([Prop({
    default: 'fr'
  })], HereApi.prototype, "hereLang", void 0);
  __decorate([Prop({
    default: 'FRA'
  })], HereApi.prototype, "hereCountry", void 0);
  __decorate([Prop({
    default: 10
  })], HereApi.prototype, "hereNbResults", void 0);
  HereApi = __decorate([vue_class_component_esm], HereApi);
  return HereApi;
}((external_vue_default()));
/* harmony default export */ var mixins_HereApi = (HereApi);
;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Select/Select.vue?vue&type=template&id=28d102ba
var Selectvue_type_template_id_28d102ba_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: {
      'kw-form-control': true,
      'select-multiple': _vm.multiple !== undefined && _vm.multiple !== false,
      'required-indicator': _vm.required !== false
    }
  }, [_vm.name ? _c('select', {
    staticClass: "d-none",
    attrs: {
      "name": _vm.name,
      "multiple": _vm.multiple,
      "disabled": _vm.disabled
    }
  }, _vm._l(_vm.formSelectOptions, function (opt, i) {
    return _c('option', {
      key: i,
      attrs: {
        "selected": ""
      },
      domProps: {
        "value": opt.value
      }
    }, [_vm._v(" " + _vm._s(opt.label) + " ")]);
  }), 0) : _vm._e(), _c('v-select', _vm._b({
    attrs: {
      "options": _vm.computedOptions,
      "transition": "",
      "append-to-body": "",
      "calculate-position": _vm.withPopper
    },
    on: {
      "input": _vm.onInput,
      "option:created": _vm.onOptionCreated,
      "open": _vm.onOpen,
      "close": _vm.onClose,
      "search": _vm.searchAjaxDatas
    },
    scopedSlots: _vm._u([_vm.taggable !== false ? {
      key: "list-header",
      fn: function () {
        return [_c('li', {
          staticClass: "small text-muted dropdown-toggle-header tags-explain"
        }, [_vm._v(" " + _vm._s(_vm.computedTagsExplain) + " ")])];
      },
      proxy: true
    } : null, {
      key: "open-indicator",
      fn: function ({
        attributes
      }) {
        return [_c('span', _vm._b({}, 'span', attributes, false), [_c('font-awesome-icon', {
          attrs: {
            "icon": _vm.indicator
          }
        })], 1)];
      }
    }, {
      key: "no-options",
      fn: function () {
        return [_vm._v(" " + _vm._s(_vm.$t('kwForm.validation.noOption')) + " ")];
      },
      proxy: true
    }, {
      key: "list-footer",
      fn: function () {
        return [_c('li', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.ajax && _vm.ajaxPaginate && _vm.nextPage,
            expression: "ajax && ajaxPaginate && nextPage"
          }],
          ref: "loader",
          staticClass: "px-3 py-2 text-muted"
        }, [_vm._v(" " + _vm._s(_vm.$t('kwForm.validation.loading')) + " ")])];
      },
      proxy: true
    }, _vm.hasSlot('option') ? {
      key: "option",
      fn: function (option) {
        return [_vm._t("option", null, null, option)];
      }
    } : null, _vm.hasSlot('selected-option') ? {
      key: "selected-option",
      fn: function (option) {
        return [_vm._t("selected-option", null, null, option)];
      }
    } : null], null, true),
    model: {
      value: _vm.selectValue,
      callback: function ($$v) {
        _vm.selectValue = $$v;
      },
      expression: "selectValue"
    }
  }, 'v-select', _vm.attributes, false))], 1);
};
var Selectvue_type_template_id_28d102ba_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(4114);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(4520);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(1454);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(8872);
;// external "vue-select"
var external_vue_select_namespaceObject = require("vue-select");
var external_vue_select_default = /*#__PURE__*/__webpack_require__.n(external_vue_select_namespaceObject);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(3949);
;// external "moment"
var external_moment_namespaceObject = require("moment");
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_namespaceObject);
;// external "validate.js"
var external_validate_js_namespaceObject = require("validate.js");
;// ./src/validate/methods.ts
// Find and return a form element by name or id
var getElement = function (key, options) {
  var element;
  if (options.element) element = options.element;else if (options.form) {
    element = options.form.querySelector('[name="' + key + '"]');
  }
  return element;
};
// Return error message to show
var getMessage = function (globalOptions, key, value, number) {
  if (number !== undefined) return globalOptions.i18n.tc('kwForm.validation.' + key, number, {
    value: value
  });else return globalOptions.i18n.t('kwForm.validation.' + key, {
    value: value
  });
};
// Apply a message with tranlation datas
var applyMessage = function (options, globalOptions, key, value, number) {
  if (typeof options === 'boolean') options = {};
  if (options.message === undefined) {
    options.message = getMessage(globalOptions, key, value, number);
  }
  return options;
};

;// ./src/validate/requiredCheckbox.ts

// Validate required checkbox
var requiredCheckbox = function (value, options, key, attributes, globalOptions) {
  if (!globalOptions.element.checked) {
    options = applyMessage(options, globalOptions, 'requiredCheckbox', value);
    return options.message;
  }
};
/* harmony default export */ var validate_requiredCheckbox = (requiredCheckbox);
;// ./src/validate/required.ts



// Overwritte presence validator function to avoid required inputs who are disabled
var required = function (value, options, key, attributes, globalOptions) {
  if (value === '' || Array.isArray(value) && value.length === 0) value = null;
  var el = globalOptions && globalOptions.element;
  if (el instanceof HTMLInputElement && el.type === 'checkbox') {
    return validate_requiredCheckbox(value, options, key, attributes, globalOptions);
  }
  options = applyMessage(options, globalOptions, 'required', value);
  // const presenceKey = 'originalPresence' in validate.validators ? 'originalPresence' : 'presence'
  var presenceKey = 'presence';
  if (key === 'single' || key === '') {
    return external_validate_js_namespaceObject.validators[presenceKey](value, options);
  }
  if (value instanceof Array && value.length === 0) {
    value = null;
  }
  var element = getElement(key, globalOptions);
  if (element === null) {
    return external_validate_js_namespaceObject.validators[presenceKey](value, options);
  }
  var disabled = element ? element.getAttribute('disabled') : '';
  if (disabled !== 'disabled') {
    return external_validate_js_namespaceObject.validators[presenceKey](value, options);
  }
};
/* harmony default export */ var validate_required = (required);
;// ./src/validate/minChecked.ts

// Validate minimum checked checkbox
var minChecked = function (value, options, key, attributes, globalOptions) {
  if (typeof options !== 'object') {
    options = {
      value: options
    };
  }
  var min = options.value;
  var length = value === null ? 0 : value.length;
  if (length < min) {
    options = applyMessage(options, globalOptions, 'minChecked', min);
    return options.message;
  }
};
/* harmony default export */ var validate_minChecked = (minChecked);
;// ./src/validate/maxChecked.ts

// Validate maximum checked checkbox
var maxChecked = function (value, options, key, attributes, globalOptions) {
  if (typeof options !== 'object') {
    options = {
      value: options
    };
  }
  var max = options.value;
  var length = value === null ? 0 : value.length;
  if (length > max) {
    options = applyMessage(options, globalOptions, 'maxChecked', max);
    return options.message;
  }
};
/* harmony default export */ var validate_maxChecked = (maxChecked);
;// ./src/validate/integer.ts


// Validate integer number
// Is a simple shortcut for numericality rule
var integer = function (value, options, key, attributes, globalOptions) {
  if (value === undefined || value === null || value === '') {
    return;
  }
  options = merge_default()({}, options, {
    onlyInteger: true
  });
  return external_validate_js_namespaceObject.validators.numericality(value, options, attributes, globalOptions);
};
/* harmony default export */ var validate_integer = (integer);
;// ./src/validate/decimal.ts


// Validate decimal number
// Is a simple shortcut for numericality rule
var decimal = function (value, options, key, attributes, globalOptions) {
  if (value === undefined || value === null || value === '') {
    return;
  }
  options = merge_default()({}, options, {
    onlyInteger: false
  });
  return external_validate_js_namespaceObject.validators.numericality(value, options, attributes, globalOptions);
};
/* harmony default export */ var validate_decimal = (decimal);
;// ./src/validate/time.ts



// Validate Time
var time = function (value, options, key, attributes, globalOptions) {
  if (!external_validate_js_namespaceObject.isDefined(value) || value === '' || key === '') {
    return;
  }
  var pattern;
  if (options && options.mode && options.mode === '12') {
    pattern = /^[01][0-9]:[0-5][0-9]((:[0-5][0-9])?)( ?)(am|pm)$/i;
  } else {
    pattern = /^(([01][0-9])|([2][0-3])):[0-5][0-9]((:[0-5][0-9])?)$/;
  }
  if (!new RegExp(pattern).test(value)) {
    options = applyMessage(options, globalOptions, 'time', value);
    return options.message;
  }
  var format = options.mode === '12' ? ' A' : '';
  var isSameDay = !options.minDate && !options.maxDate || options.minDate !== null && options.maxDate !== null && options.minDate === options.maxDate;
  if (options.minTime && isSameDay) {
    var val1 = external_moment_default()(value, 'HH:mm:ss' + format);
    var val2 = external_moment_default()(options.minTime, 'HH:mm:ss' + format);
    if (val1.unix() < val2.unix()) {
      return getMessage(globalOptions, 'minTime', value);
    }
  }
  if (options.maxTime && isSameDay) {
    var val1 = external_moment_default()(value, 'HH:mm:ss' + format);
    var val2 = external_moment_default()(options.maxTime, 'HH:mm:ss' + format);
    if (val1.unix() > val2.unix()) {
      return getMessage(globalOptions, 'maxTime', value);
    }
  }
};
/* harmony default export */ var validate_time = (time);
;// ./src/validate/password.ts


// Validate Password
var password_password = function (value, options, key, attributes, globalOptions) {
  if (!external_validate_js_namespaceObject.isDefined(value)) {
    return;
  }
  var pattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[,;:=+_()#?!@$%^&*-]).{8,}$/;
  if (!new RegExp(pattern).test(value)) {
    options = applyMessage(options, globalOptions, 'password', value);
    return options.message;
  }
};
/* harmony default export */ var validate_password = (password_password);
;// ./src/validate/phone.ts


// Validate Phone Number
var phone = function (value, options, key, attributes, globalOptions) {
  if (!external_validate_js_namespaceObject.isDefined(value) || value === '' || key === '') {
    return;
  }
  var intl = globalOptions.element && globalOptions.element.intlInstance;
  if (intl && !intl.isValidNumberPrecise()) {
    options = applyMessage(options, globalOptions, 'phone', value);
    return options.message;
  }
  var type = intl.options.placeholderNumberType;
  if (type === 'MOBILE' && intl.getNumberType() !== 1) {
    return getMessage(globalOptions, 'phoneMobile', value);
  }
};
/* harmony default export */ var validate_phone = (phone);
;// ./src/validate/domain.ts


// Validate domain (Not URL)
var domain = function (value, options, key, attributes, globalOptions) {
  if (!external_validate_js_namespaceObject.isDefined(value) || value === '' || key === '') {
    return;
  }
  var pattern = /^([a-zA-Z])([a-zA-Z0-9-\\.]{0,60})\\.[a-zA-Z]{2,}$/;
  var regex = RegExp(pattern, 'i');
  if (regex.exec(value) === null) {
    options = applyMessage(options, globalOptions, 'domain', value);
    return options.message;
  }
};
/* harmony default export */ var validate_domain = (domain);
;// ./src/validate/url.ts


// Validate an url
var url = function (value, options, key, attributes, globalOptions) {
  if (!external_validate_js_namespaceObject.isDefined(value) || value === '' || key === '') {
    return;
  }
  var pattern = '^(?:http(s)?:\\/\\/)?[\\w.-]+(?:\\.[\\w\\.-]+)+[\\w\\-\\._~:/?#[\\]@!\\$&\'\\(\\)\\*\\+,;=.]+$';
  var regex = RegExp(pattern, 'i');
  if (regex.exec(value) === null) {
    options = applyMessage(options, globalOptions, 'url', value);
    return options.message;
  }
};
/* harmony default export */ var validate_url = (url);
;// ./src/validate/email.ts


// Validate an email
var email = function (value, options, key, attributes, globalOptions) {
  if (!external_validate_js_namespaceObject.isDefined(value) || value === '' || key === '') {
    return;
  }
  /* eslint-disable-next-line no-control-regex */
  var pattern = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
  var regex = RegExp(pattern, 'i');
  if (regex.exec(value) === null) {
    options = applyMessage(options, globalOptions, 'email', value);
    return options.message;
  }
};
/* harmony default export */ var validate_email = (email);
;// ./src/validate/hexColor.ts


// Validate HEX color
var hexColor = function (value, options, key, attributes, globalOptions) {
  if (!external_validate_js_namespaceObject.isDefined(value) || value === '' || key === '') {
    return;
  }
  var pattern = /^#[0-9A-F]{6}$/;
  var regex = RegExp(pattern, 'i');
  if (regex.exec(value) === null) {
    options = applyMessage(options, globalOptions, 'hexColor', value);
    return options.message;
  }
};
/* harmony default export */ var validate_hexColor = (hexColor);
;// ./src/validate/arrayOf.ts






// Validate array of elements
var arrayOf = function (values, options, key, attributes, globalOptions) {
  if (values === null || values === undefined || values === '') {
    return;
  } else if (!Array.isArray(values)) {
    return getMessage(globalOptions, 'array');
  } else if (values.length === 0) {
    return;
  }
  var valid;
  switch (typeof options.items) {
    case 'string':
      valid = external_validate_js_namespaceObject.validators[options.items];
      break;
    case 'function':
      valid = options.items;
      break;
    default:
      return;
  }
  var errors = [];
  values.forEach(function (value) {
    var error = valid(value, options, key, attributes, globalOptions);
    if (typeof error === 'string') {
      errors.push(error);
    }
  });
  errors = errors.filter(function (v, i) {
    return errors.indexOf(v) === i;
  });
  return errors;
};
/* harmony default export */ var validate_arrayOf = (arrayOf);
;// ./src/validate/sameValue.ts

// Validate value is equals to an other value
var sameValue = function (value, options, key, attributes, globalOptions) {
  if (value !== globalOptions.equalityValue) {
    options = applyMessage(options, globalOptions, 'sameValue', value);
    return options.message;
  }
};
/* harmony default export */ var validate_sameValue = (sameValue);
;// ./src/validate/min.ts

// Validate numerical value
var min = function (value, options, key, attributes, globalOptions) {
  if (value === undefined || value === null || value === '') {
    return;
  } else if (typeof value === 'string') {
    value = parseFloat(value);
  }
  if (value < options) {
    return getMessage(globalOptions, 'minNumber', value, options);
  }
};
/* harmony default export */ var validate_min = (min);
;// ./src/validate/max.ts

// Validate numerical value
var max = function (value, options, key, attributes, globalOptions) {
  if (value === undefined || value === null || value === '') {
    return;
  } else if (typeof value === 'string') {
    value = parseFloat(value);
  }
  if (value > options) {
    return getMessage(globalOptions, 'maxNumber', value, options);
  }
};
/* harmony default export */ var validate_max = (max);
;// ./src/validate/index.ts



















// Initialize date management in validate.js
external_validate_js_namespaceObject.extend(external_validate_js_namespaceObject.validators.datetime, {
  parse: function (value, options) {
    var format = options.dateOnly ? 'YYYY/MM/DD' : 'YYYY-MM-DD hh:mm:ss';
    return +external_moment_default().utc(value, format);
  },
  format: function (value, options) {
    var format = options.dateOnly ? 'YYYY/MM/DD' : 'YYYY-MM-DD hh:mm:ss';
    return external_moment_default().utc(value).format(format);
  }
});
// validate.validators.originalPresence = validate.validators.presence
// validate.validators.presence = required
external_validate_js_namespaceObject.validators.required = validate_required;
external_validate_js_namespaceObject.validators.requiredCheckbox = validate_requiredCheckbox;
external_validate_js_namespaceObject.validators.minChecked = validate_minChecked;
external_validate_js_namespaceObject.validators.maxChecked = validate_maxChecked;
external_validate_js_namespaceObject.validators.integer = validate_integer;
external_validate_js_namespaceObject.validators.decimal = validate_decimal;
external_validate_js_namespaceObject.validators.time = validate_time;
external_validate_js_namespaceObject.validators.password = validate_password;
external_validate_js_namespaceObject.validators.phone = validate_phone;
external_validate_js_namespaceObject.validators.domain = validate_domain;
external_validate_js_namespaceObject.validators.url = validate_url;
external_validate_js_namespaceObject.validators.email = validate_email;
external_validate_js_namespaceObject.validators.hexColor = validate_hexColor;
external_validate_js_namespaceObject.validators.arrayOf = validate_arrayOf;
external_validate_js_namespaceObject.validators.sameValue = validate_sameValue;
external_validate_js_namespaceObject.validators.min = validate_min;
external_validate_js_namespaceObject.validators.max = validate_max;
/* harmony default export */ var validate = (external_validate_js_namespaceObject);
;// external "tippy.js"
var external_tippy_js_namespaceObject = require("tippy.js");
var external_tippy_js_default = /*#__PURE__*/__webpack_require__.n(external_tippy_js_namespaceObject);
;// ./src/mixins/FormValidation.ts







var FormValidation = /** @class */function (_super) {
  __extends(FormValidation, _super);
  function FormValidation() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.withDataValidation = true;
    // Error message to show
    _this.errorMessages = null;
    // If error must be show
    _this.showValidationError = false;
    // Store tippy instance
    _this.tippyInstance = null;
    _this.formComponent = null;
    return _this;
  }
  FormValidation_1 = FormValidation;
  Object.defineProperty(FormValidation.prototype, "validationRules", {
    // Return validation rules
    get: function () {
      var rules = typeof this.validate === 'string' ? this.parseValidationRules(this.validate) : this.validate;
      if (this.noCustomRules === false) {
        var custom = this.customRules;
        if (custom) {
          rules = Object.assign({}, rules, custom);
        }
      }
      if (this.required !== false) {
        var el = this.getElement();
        if (el instanceof HTMLInputElement && el.getAttribute('type') === 'checkbox' && (!rules || rules.requiredCheckbox === undefined)) {
          rules = Object.assign({}, rules, {
            requiredCheckbox: true
          });
        } else if (!rules || rules.presence === undefined) {
          rules = Object.assign({}, rules, {
            required: true
          });
        }
      }
      return rules;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FormValidation.prototype, "customRules", {
    // Override to add custom rules
    get: function () {
      return null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FormValidation.prototype, "haveValidationError", {
    // Check if error validation is present
    get: function () {
      if (!this.errorMessages) {
        return false;
      }
      var message = Array.isArray(this.errorMessages) ? this.errorMessages : [this.errorMessages];
      if (message) {
        message = message.filter(function (error) {
          return error !== '' && error != null;
        });
      }
      return message.length > 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FormValidation.prototype, "computedState", {
    // Override computedState to use haveValidationError
    get: function () {
      // If not a boolean, ensure that value is null
      // noinspection PointlessBooleanExpressionJS
      return this.haveValidationError === true ? false : this.state;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FormValidation.prototype, "stateClass", {
    // Override stateClass to use haveValidationError
    get: function () {
      var state = this.computedState;
      return state === true ? 'is-valid' : state === false ? 'is-invalid' : null;
    },
    enumerable: false,
    configurable: true
  });
  // Return the form element (input, select...)
  // Use function to allow override
  FormValidation.prototype.getElement = function () {
    return this.$el;
  };
  // Return the element where attach tippy
  FormValidation.prototype.getTippyElement = function () {
    return this.getElement();
  };
  // Return the value of form element (input, select...)
  // Use function to allow override
  FormValidation.prototype.getValue = function () {
    var el = this.getElement();
    var value = null;
    if (el instanceof HTMLInputElement && el.getAttribute('type') === 'checkbox') {
      value = el.checked ? true : '';
    } else if (el instanceof HTMLInputElement || el instanceof HTMLSelectElement || el instanceof HTMLTextAreaElement) {
      value = el.value;
    }
    if (value === '') {
      // Return null when value is empty
      value = null;
    }
    return value;
  };
  // Parse validation property when type is string
  FormValidation.prototype.parseValidationRules = function (rules) {
    var _this = this;
    if (rules === '') {
      return null;
    }
    // Split all rules
    var parsedRules = rules.split(FormValidation_1.RULES_SEPARATOR);
    // Parse each rules
    var constraint = {};
    parsedRules.forEach(function (rule) {
      var _a;
      // Split rules name & parameters
      var parse = rule.split(FormValidation_1.NAME_SEPARATOR);
      var key = parse[0];
      // Split parameters
      var params = parse[1] ? parse[1].split(FormValidation_1.PARAMS_SEPARATOR) : null;
      // Apply rules
      switch (key) {
        case 'presence':
        case 'required':
          constraint.required = true;
          break;
        case 'integer':
        case 'decimal':
          constraint.numericality = {
            onlyInteger: key === 'integer',
            min: _this.getElement().getAttribute('min'),
            max: _this.getElement().getAttribute('max')
          };
          break;
        case 'equals':
          if (params) {
            constraint.sameValue = {
              attribute: params[0],
              message: (_a = params[1]) !== null && _a !== void 0 ? _a : undefined
            };
          }
          break;
        case 'minLength':
          if (constraint.length === undefined) constraint.length = {};
          if (params) {
            constraint.length.minimum = Number(params[0]);
          }
          break;
        case 'maxLength':
          if (constraint.length === undefined) constraint.length = {};
          if (params) {
            constraint.length.maximum = Number(params[0]);
          }
          break;
        case 'time':
          constraint.time = params && params[0] ? {
            mode: params[0]
          } : true;
          break;
        default:
          constraint[key] = {};
      }
    });
    return constraint;
  };
  // Validate data and show errors if needed
  FormValidation.prototype.valid = function (showTooltip) {
    if (showTooltip === void 0) {
      showTooltip = true;
    }
    // noinspection PointlessBooleanExpressionJS
    if (this.withValidation !== true) {
      return;
    }
    this.errorMessages = null;
    this.showValidationError = false;
    var validationRules = this.validationRules;
    var form = this.formComponent ? this.formComponent.$el : null;
    var validateOptions = {
      form: form,
      element: this.getElement(),
      i18n: this.$i18n // Pass i18n for traduction
    };
    var sameValue = validationRules === null || validationRules === void 0 ? void 0 : validationRules.sameValue;
    if (sameValue) {
      var el = form === null || form === void 0 ? void 0 : form.querySelector('[name="' + sameValue.attribute + '"]');
      validateOptions.equalityValue = el === null || el === void 0 ? void 0 : el.value;
    }
    var errors = validate.single(this.getValue(), validationRules, validateOptions);
    if (errors) {
      this.showError(errors, showTooltip);
      this.setInvalidState();
      this.$emit('onValidationError', this, errors);
    } else {
      this.hideError();
      this.removeInvalidState();
      this.$emit('onValidationOk', this);
    }
    return errors;
  };
  // Show the validation errors
  FormValidation.prototype.showError = function (errors, showTooltip) {
    if (showTooltip === void 0) {
      showTooltip = true;
    }
    this.errorMessages = errors;
    this.showValidationError = true;
    if (showTooltip) {
      this.initTippy();
    }
  };
  // Hide the validation errors
  FormValidation.prototype.hideError = function (e) {
    if (e === void 0) {
      e = null;
    }
    if (e) {
      e.preventDefault();
    }
    this.destroyTippy();
  };
  // Init tippy instance
  FormValidation.prototype.initTippy = function () {
    if (this.tippyInstance) {
      this.destroyTippy();
    }
    this.tippyInstance = external_tippy_js_default()(this.getTippyElement(), this.tippyOptions());
    this.tippyInstance.show();
    // noinspection PointlessBooleanExpressionJS
    if (this.cantHideTooltipError === false) {
      this.tippyInstance.popper.addEventListener('click', this.destroyTippy);
    }
  };
  // Return tippy options
  FormValidation.prototype.tippyOptions = function () {
    return {
      ignoreAttributes: true,
      content: this.errorMessages ? this.errorMessages.join('<br>') : '',
      placement: 'top-start',
      trigger: 'manual',
      hideOnClick: false,
      theme: 'form-errors',
      allowHTML: true
    };
  };
  // Destroy tippy instance
  FormValidation.prototype.destroyTippy = function () {
    if (!this.tippyInstance) {
      return;
    }
    // noinspection PointlessBooleanExpressionJS
    if (this.cantHideTooltipError === false && this.tippyInstance.popper) {
      this.tippyInstance.popper.removeEventListener('click', this.destroyTippy);
    }
    // noinspection PointlessBooleanExpressionJS
    if (this.tippyInstance.state && this.tippyInstance.state.isDestroyed !== true) {
      this.tippyInstance.destroy();
    }
    this.tippyInstance = null;
  };
  FormValidation.prototype.mounted = function () {
    // If registerElement method if defined by a parent form component
    // Register the component for data valisation
    if (this.registerElement) {
      this.formComponent = this.registerElement(this);
    }
  };
  FormValidation.prototype.destroyed = function () {
    this.destroyTippy();
    // If registerElement method if defined by a parent form component
    // Unregister the component from data valisation
    if (this.unRegisterElement) {
      this.unRegisterElement(this);
      this.formComponent = null;
    }
  };
  // Override this function to add custom implementation of invalid state
  FormValidation.prototype.setInvalidState = function () {
    //
  };
  // Override this function to add custom implementation of valid state
  FormValidation.prototype.removeInvalidState = function () {
    //
  };
  var FormValidation_1;
  // Parameters used when validate is string
  FormValidation.RULES_SEPARATOR = '|'; // Separator to use for separate rules in RULES_HTML_ATTRIBUTE
  FormValidation.NAME_SEPARATOR = ':'; // Separator to use for separate rule name & rule parameters
  FormValidation.PARAMS_SEPARATOR = ','; // Separator to use for separate parameters
  __decorate([Prop({
    default: ''
  })], FormValidation.prototype, "validate", void 0);
  __decorate([Prop({
    default: true
  })], FormValidation.prototype, "withValidation", void 0);
  __decorate([Prop({
    default: null
  })], FormValidation.prototype, "state", void 0);
  __decorate([Prop({
    default: false
  })], FormValidation.prototype, "required", void 0);
  __decorate([Prop({
    default: true
  })], FormValidation.prototype, "requiredIndicator", void 0);
  __decorate([Prop({
    default: false
  })], FormValidation.prototype, "cantHideTooltipError", void 0);
  __decorate([Prop({
    default: false
  })], FormValidation.prototype, "noCustomRules", void 0);
  __decorate([Prop({
    default: null
  })], FormValidation.prototype, "validationName", void 0);
  __decorate([Inject({
    from: 'registerElement',
    default: null
  })], FormValidation.prototype, "registerElement", void 0);
  __decorate([Inject({
    from: 'unRegisterElement',
    default: null
  })], FormValidation.prototype, "unRegisterElement", void 0);
  FormValidation = FormValidation_1 = __decorate([vue_class_component_esm], FormValidation);
  return FormValidation;
}((external_vue_default()));
/* harmony default export */ var mixins_FormValidation = (FormValidation);
;// external "@fortawesome/vue-fontawesome"
var vue_fontawesome_namespaceObject = require("@fortawesome/vue-fontawesome");
;// external "@fortawesome/free-solid-svg-icons"
var free_solid_svg_icons_namespaceObject = require("@fortawesome/free-solid-svg-icons");
;// ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// ./node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
;// ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle_getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle_getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle_getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle_getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle_getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle_getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle_getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// ./node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// ./node_modules/@popperjs/core/lib/createPopper.js









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle_getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// ./node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle_getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle_getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// ./node_modules/@popperjs/core/lib/modifiers/arrow.js








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// ./node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// ./node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(2404);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/Select/Select.ts?vue&type=script&lang=ts&external
















var Select = /** @class */function (_super) {
  __extends(Select, _super);
  function Select() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.componentName = 'Select';
    _this.indicator = free_solid_svg_icons_namespaceObject.faCaretDown;
    // Local value
    _this.selectValue = null;
    // Local options
    _this.localOptions = [];
    // Next page link for ajax pagination
    _this.page = 0;
    _this.totalPage = null;
    // Cache
    _this.updateLocalCache = false;
    // Ajax search
    _this.searchTerm = null;
    _this.searchTimeout = null;
    _this.searchPage = 0;
    _this.searchTotalPage = null;
    _this.searchResults = [];
    return _this;
  }
  // Set local values
  Select.prototype.mounted = function () {
    this.selectValue = this.value;
    this.localOptions = this.options;
    this.installAjax();
  };
  Object.defineProperty(Select.prototype, "computedTagsExplain", {
    get: function () {
      var _a;
      return (_a = this.tagsExplain) !== null && _a !== void 0 ? _a : this.$t('kwForm.validation.tagsExplain');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Select.prototype, "attributes", {
    // vSelect component attributes
    get: function () {
      return {
        selectOnTab: this.selectOnTab,
        autoscroll: this.autoscroll,
        autocomplete: this.autocomplete,
        appendToBody: this.computedAppendToBody,
        clearable: this.computedClearable,
        searchable: this.computedSearchable,
        multiple: this.multiple,
        placeholder: this.placeholder,
        calculatePosition: this.computedCalculatePosition,
        clearSearchOnSelect: this.clearSearchOnSelect,
        clearSearchOnBlur: this.clearSearchOnBlur,
        closeOnSelect: this.closeOnSelect,
        label: this.label,
        reduce: this.reduce,
        getOptionLabel: this.getOptionLabel,
        getOptionKey: this.getOptionKey,
        taggable: this.taggable,
        pushTags: this.pushTags,
        filterable: this.ajax && this.ajaxPaginate ? false : this.filterable,
        filterBy: this.filterBy,
        disabled: this.disabled,
        filter: this.filter,
        createOption: this.createOption,
        resetOnOptionsChange: this.resetOnOptionsChange,
        noDrop: this.noDrop,
        inputId: this.inputId,
        dropdownShouldOpen: this.dropdownShouldOpen,
        class: {
          'size-sm': this.size === 'sm',
          'size-lg': this.size === 'lg',
          'is-invalid': this.haveValidationError
        },
        selectable: this.selectable
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Select.prototype, "computedAppendToBody", {
    // Return appendToBody property
    get: function () {
      // noinspection PointlessBooleanExpressionJS
      if (this.modalMode !== false && this.appendToBody === undefined) {
        return true;
      }
      return this.appendToBody;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Select.prototype, "computedCalculatePosition", {
    // Return calculate position function to use
    get: function () {
      // noinspection PointlessBooleanExpressionJS
      if (this.modalMode !== false && !this.calculatePosition) {
        return function (dropdownList, component, _a) {
          var width = _a.width,
            top = _a.top,
            left = _a.left;
          dropdownList.style.top = top;
          dropdownList.style.left = left;
          dropdownList.style.width = width;
          dropdownList.style.zIndex = '9999';
        };
      }
      return this.calculatePosition;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Select.prototype, "computedClearable", {
    // Return clearable state
    get: function () {
      return this.clearable && !this.disabled;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Select.prototype, "computedSearchable", {
    // Get searchable state
    get: function () {
      // noinspection PointlessBooleanExpressionJS
      if (this.taggable !== false) {
        return true;
      } else if (this.searchable !== undefined) {
        return this.searchable;
      }
      return this.options.length > 10;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Select.prototype, "formSelectOptions", {
    // Return options
    get: function () {
      var _this = this;
      var values = Array.isArray(this.selectValue) ? this.selectValue : [this.selectValue];
      return values.map(function (v) {
        var value = '';
        var label = '';
        if (typeof v === 'object' && v !== null && _this.getOptionKey && _this.getOptionLabel) {
          value = String(_this.getOptionKey(v));
          label = String(_this.getOptionLabel(v));
        } else if (typeof v === 'object' && v !== null && _this.reduce) {
          value = String(_this.reduce(v));
          label = value;
        } else if (typeof v !== 'object') {
          value = String(v);
          label = value;
        }
        if (value === '') {
          return false;
        } else if (label === '') {
          label = value;
        }
        return {
          value: value,
          label: label
        };
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Select.prototype, "computedOptions", {
    // Return options for select
    get: function () {
      return this.searchTerm !== null ? this.searchResults : this.localOptions;
    },
    enumerable: false,
    configurable: true
  });
  // Send event when value is updated
  Select.prototype.onInput = function (val) {
    this.valid(); // Validate the datas
    this.$emit('input', val, this);
  };
  // Send event when option is created
  Select.prototype.onOptionCreated = function (newOption) {
    return newOption;
  };
  // Watch ajax params change
  Select.prototype.watchAjax = function () {
    this.localOptions = [];
    this.page = 0;
    this.totalPage = null;
  };
  // Watch value update from parent
  Select.prototype.watchValue = function (val) {
    if (this.selectValue !== val) {
      this.selectValue = val;
    }
  };
  // Watch options update from parent
  Select.prototype.watchOption = function (val) {
    if (this.localOptions !== val) {
      this.localOptions = val;
    }
  };
  // Watch ajax cache updates
  Select.prototype.watchAjaxCache = function (cache) {
    this.setLocalCache(cache);
  };
  // Watch local change to push cache update
  Select.prototype.cacheUpdated = function () {
    if (!this.ajax || !this.ajaxCache) {
      return;
    }
    this.$emit('cacheUpdated', {
      page: this.page,
      totalPage: this.totalPage,
      options: JSON.parse(JSON.stringify(this.localOptions))
    });
  };
  // Return value for validation
  Select.prototype.getValue = function () {
    return this.selectValue;
  };
  // Initialize Ajax
  Select.prototype.installAjax = function () {
    if (!this.ajax) {
      return;
    }
    if (this.ajaxCache) {
      this.setLocalCache(this.ajaxCache);
    }
    if (!this.lazyLoading) {
      this.getAjaxDatas();
    }
    if (this.ajaxPaginate) {
      var scrolling = this.infiniteScroll;
      this.observer = new IntersectionObserver(scrolling);
    }
  };
  // Ajax - Set local cache
  Select.prototype.setLocalCache = function (cache) {
    var _a;
    cache = JSON.parse(JSON.stringify(cache));
    var page = cache.page !== undefined ? cache.page : null;
    if (page && this.page !== page) {
      this.page = page;
    }
    var totalPage = cache.totalPage !== undefined ? cache.totalPage : null;
    if (this.totalPage !== totalPage) {
      this.totalPage = totalPage;
    }
    var options = (_a = cache.options) !== null && _a !== void 0 ? _a : [];
    if (!isEqual_default()(this.localOptions, options)) {
      this.localOptions = options;
    }
  };
  Object.defineProperty(Select.prototype, "nextPage", {
    // Ajax - Return url for next page
    get: function () {
      var next;
      var totalPage;
      if (this.searchTerm !== null) {
        next = this.searchPage;
        totalPage = this.searchTotalPage;
      } else {
        next = this.page;
        totalPage = this.totalPage;
      }
      next++;
      if (totalPage && next > totalPage) {
        return false;
      }
      return next;
    },
    enumerable: false,
    configurable: true
  });
  // Event when the dropdown is open - For ajax pagination
  Select.prototype.onOpen = function (loadData) {
    if (loadData === void 0) {
      loadData = true;
    }
    return __awaiter(this, void 0, Promise, function () {
      var loader;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.$emit('open');
            if (!this.ajax) {
              return [2 /*return*/];
            }
            if (!this.nextPage) return [3 /*break*/, 4];
            if (!loadData) return [3 /*break*/, 2];
            return [4 /*yield*/, this.getAjaxDatas()];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            return [4 /*yield*/, this.$nextTick()];
          case 3:
            _a.sent();
            loader = this.$refs.loader;
            if (loader) {
              this.observer && this.observer.observe(loader);
            }
            _a.label = 4;
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  // Event when the dropdown is closed - For ajax pagination
  Select.prototype.onClose = function () {
    this.$emit('close');
    this.observer && this.observer.disconnect();
  };
  // Listen the scroll and go to the next page if necessary - For ajax pagination
  Select.prototype.infiniteScroll = function (_a) {
    var _b = _a[0],
      isIntersecting = _b.isIntersecting,
      target = _b.target;
    return __awaiter(this, void 0, Promise, function () {
      var ul, scrollTop;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (!(isIntersecting && this.nextPage !== false)) return [3 /*break*/, 3];
            ul = target.offsetParent;
            if (!ul) return [3 /*break*/, 3];
            scrollTop = ul.scrollTop;
            return [4 /*yield*/, this.getAjaxDatas()];
          case 1:
            _c.sent();
            return [4 /*yield*/, this.$nextTick()];
          case 2:
            _c.sent();
            ul.scrollTop = scrollTop;
            _c.label = 3;
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
  // Make an ajax search
  Select.prototype.searchAjaxDatas = function (search, loading) {
    var _this = this;
    this.$emit('search', search, loading);
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
    if (!this.ajax || !this.ajaxPaginate) {
      return;
    }
    this.resetSearch();
    if (search === '') {
      this.searchTerm = null;
      loading(false);
      this.onOpen(false);
      return;
    }
    this.onClose();
    loading(true);
    this.searchTerm = search;
    this.searchTimeout = setTimeout(function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, this.getAjaxDatas()];
            case 1:
              _a.sent();
              loading(false);
              this.onOpen(false);
              return [2 /*return*/];
          }
        });
      });
    }, 500);
    return undefined;
  };
  // Reset the ajax search params
  Select.prototype.resetSearch = function () {
    this.searchPage = 0;
    this.searchTotalPage = null;
    this.searchResults = [];
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
  };
  // Get options list from ajax
  Select.prototype.getAjaxDatas = function () {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
      var defaultDatas, axiosInstance;
      var _this = this;
      return __generator(this, function (_c) {
        if (!this.ajax || this.nextPage === false) {
          return [2 /*return*/];
        }
        defaultDatas = {};
        if (this.ajaxPaginate) {
          defaultDatas = {
            per_page: 50,
            page: this.nextPage
          };
        }
        axiosInstance = (_a = this.$KwFormConfig.axios) !== null && _a !== void 0 ? _a : (external_axios_default());
        return [2 /*return*/, axiosInstance.get(this.ajax, {
          headers: (_b = this.$KwFormConfig.headers) !== null && _b !== void 0 ? _b : {},
          params: this.ajaxSearch(merge_default()({}, defaultDatas, this.ajaxDatas), this.searchTerm)
        }).then(function (response) {
          if (!_this.ajaxPaginate) {
            if (_this.searchTerm !== null) {
              _this.searchResults = response.data;
            } else {
              _this.localOptions = response.data;
            }
            return;
          }
          var data = response.data;
          var page = _this.searchTerm !== null ? _this.searchPage : _this.page;
          if (page === 0 && !_this.lazyLoading) {
            var values = data.data;
            if (_this.searchTerm !== null) {
              _this.searchResults = values;
            } else {
              _this.localOptions = values;
            }
            if (_this.defaultAjaxValue && !_this.selectValue) {
              var defaultValue = values.find(function (val) {
                if (typeof val !== 'object') {
                  return false;
                }
                return val[_this.defaultAjaxValue] === true;
              });
              if (defaultValue) {
                _this.selectValue = [defaultValue];
                _this.onInput(defaultValue);
              }
            }
          } else {
            var options = _this.searchTerm !== null ? _this.searchResults : _this.localOptions;
            options.push.apply(options, data.data);
          }
          if (_this.searchTerm !== null) {
            _this.searchPage++;
          } else {
            _this.page++;
          }
          if (data.meta.last_page) {
            if (_this.searchTerm !== null) {
              _this.searchTotalPage = data.meta.last_page;
            } else {
              _this.totalPage = data.meta.last_page;
            }
          }
        })];
      });
    });
  };
  // Manage dropdown position
  Select.prototype.withPopper = function (dropdownList, component, _a) {
    var width = _a.width;
    dropdownList.style.width = width;
    var el = component.$refs.toggle;
    var popper = popper_createPopper(el, dropdownList, {
      placement: 'bottom-start',
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, -1]
        }
      }, {
        name: 'toggleClass',
        enabled: true,
        phase: 'write',
        fn: function (_a) {
          var state = _a.state;
          component.$el.classList.toggle('drop-up', state.placement === 'top');
        }
      }]
    });
    return function () {
      return popper.destroy();
    };
  };
  // Insert new option
  Select.prototype.addOption = function (option) {
    this.localOptions.unshift(option);
  };
  // Update an existing option
  Select.prototype.updateOption = function (option, findOption) {
    if (!findOption) {
      findOption = function (opt) {
        if (typeof opt === 'string' || typeof opt === 'number' || typeof option === 'string' || typeof option === 'number') {
          return opt === option;
        }
        return option.id === opt.id;
      };
    }
    var index = this.localOptions.findIndex(findOption);
    if (index >= 0) {
      external_vue_default().set(this.localOptions, index, option);
    } else {
      this.localOptions.push(option);
    }
  };
  // Check if a slot exist
  Select.prototype.hasSlot = function (name) {
    return !!this.$slots[name] || !!this.$scopedSlots[name];
  };
  __decorate([Prop({
    default: null
  })], Select.prototype, "value", void 0);
  __decorate([Prop({
    default: null
  })], Select.prototype, "name", void 0);
  __decorate([Prop({
    default: null
  })], Select.prototype, "size", void 0);
  __decorate([Prop()], Select.prototype, "autoscroll", void 0);
  __decorate([Prop()], Select.prototype, "autocomplete", void 0);
  __decorate([Prop()], Select.prototype, "appendToBody", void 0);
  __decorate([Prop({
    default: function () {
      return [];
    }
  })], Select.prototype, "options", void 0);
  __decorate([Prop({
    default: true
  })], Select.prototype, "clearable", void 0);
  __decorate([Prop()], Select.prototype, "searchable", void 0);
  __decorate([Prop()], Select.prototype, "multiple", void 0);
  __decorate([Prop()], Select.prototype, "placeholder", void 0);
  __decorate([Prop()], Select.prototype, "calculatePosition", void 0);
  __decorate([Prop()], Select.prototype, "clearSearchOnSelect", void 0);
  __decorate([Prop()], Select.prototype, "clearSearchOnBlur", void 0);
  __decorate([Prop()], Select.prototype, "closeOnSelect", void 0);
  __decorate([Prop()], Select.prototype, "label", void 0);
  __decorate([Prop()], Select.prototype, "reduce", void 0);
  __decorate([Prop()], Select.prototype, "getOptionLabel", void 0);
  __decorate([Prop()], Select.prototype, "getOptionKey", void 0);
  __decorate([Prop({
    default: false
  })], Select.prototype, "taggable", void 0);
  __decorate([Prop()], Select.prototype, "pushTags", void 0);
  __decorate([Prop()], Select.prototype, "filterable", void 0);
  __decorate([Prop()], Select.prototype, "filterBy", void 0);
  __decorate([Prop()], Select.prototype, "filter", void 0);
  __decorate([Prop()], Select.prototype, "createOption", void 0);
  __decorate([Prop()], Select.prototype, "resetOnOptionsChange", void 0);
  __decorate([Prop()], Select.prototype, "noDrop", void 0);
  __decorate([Prop()], Select.prototype, "inputId", void 0);
  __decorate([Prop({
    default: false
  })], Select.prototype, "selectOnTab", void 0);
  __decorate([Prop({
    default: false
  })], Select.prototype, "disabled", void 0);
  __decorate([Prop({
    default: false
  })], Select.prototype, "modalMode", void 0);
  __decorate([Prop({
    default: null
  })], Select.prototype, "ajax", void 0);
  __decorate([Prop({
    default: function () {
      return {};
    }
  })], Select.prototype, "ajaxDatas", void 0);
  __decorate([Prop({
    default: function () {
      return function (params, term) {
        if (term !== '' && term !== null) {
          term = encodeURIComponent('%' + term + '%');
        }
        params.search = term;
        return params;
      };
    }
  })], Select.prototype, "ajaxSearch", void 0);
  __decorate([Prop({
    default: true
  })], Select.prototype, "ajaxPaginate", void 0);
  __decorate([Prop({
    default: null
  })], Select.prototype, "ajaxCache", void 0);
  __decorate([Prop({
    default: null
  })], Select.prototype, "defaultAjaxValue", void 0);
  __decorate([Prop({
    default: true
  })], Select.prototype, "lazyLoading", void 0);
  __decorate([Prop({
    default: undefined
  })], Select.prototype, "dropdownShouldOpen", void 0);
  __decorate([Prop({
    default: function () {
      return function (option) {
        return typeof option !== 'object' || option.disabled === undefined || option.disabled === false;
      };
    }
  })], Select.prototype, "selectable", void 0);
  __decorate([Prop({
    default: null
  })], Select.prototype, "tagsExplain", void 0);
  __decorate([Emit('option:created')], Select.prototype, "onOptionCreated", null);
  __decorate([Watch('ajax'), Watch('ajaxDatas')], Select.prototype, "watchAjax", null);
  __decorate([Watch('value')], Select.prototype, "watchValue", null);
  __decorate([Watch('options')], Select.prototype, "watchOption", null);
  __decorate([Watch('ajaxCache', {
    deep: true
  })], Select.prototype, "watchAjaxCache", null);
  __decorate([Watch('localOptions'), Watch('page'), Watch('totalPage')], Select.prototype, "cacheUpdated", null);
  Select = __decorate([vue_class_component_esm({
    components: {
      'v-select': (external_vue_select_default()),
      FontAwesomeIcon: vue_fontawesome_namespaceObject.FontAwesomeIcon
    }
  })], Select);
  return Select;
}(mixins(mixins_FormValidation));
/* harmony default export */ var Selectvue_type_script_lang_ts_external = (Select);
;// ./src/components/Select/Select.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Select_Selectvue_type_script_lang_ts_external = (Selectvue_type_script_lang_ts_external); 
;// ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// ./src/components/Select/Select.vue





/* normalize component */
;
var component = normalizeComponent(
  Select_Selectvue_type_script_lang_ts_external,
  Selectvue_type_template_id_28d102ba_render,
  Selectvue_type_template_id_28d102ba_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Select_Select = (component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/Input/Input.ts?vue&type=script&lang=ts&external





var Input = /** @class */function (_super) {
  __extends(Input, _super);
  function Input() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(Input.prototype, "computedListeners", {
    // Override to apply custom listeners
    get: function () {
      return __assign(__assign({}, this.bvListeners), {
        input: this.onInput,
        change: this.onChangeWithValidation,
        blur: this.onBlurWithValidation,
        keydown: this.onKeyDown
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Input.prototype, "customComputedAttrs", {
    // Override to remove required attribute
    get: function () {
      return merge_default()({}, this.computedAttrs, {
        required: false,
        minlength: this.minlength,
        maxlength: this.maxlength
      });
    },
    enumerable: false,
    configurable: true
  });
  // Override render function
  Input.prototype.render = function (h) {
    return h('div', {
      class: {
        'required-indicator': this.required !== false && this.requiredIndicator !== false,
        'kw-form-control': true
      }
    }, [this.renderInput(h)]);
  };
  // Original render function with change computedAttrs to customComputedAttrs
  Input.prototype.renderInput = function (h) {
    return h('input', {
      ref: 'input',
      class: this.computedClass,
      attrs: this.customComputedAttrs,
      domProps: {
        value: this.localValue
      },
      on: this.computedListeners
    });
  };
  // Override change event to add validation
  Input.prototype.onChangeWithValidation = function (e) {
    this.onChange(e);
    this.valid();
  };
  // Override blur event to add validation
  Input.prototype.onBlurWithValidation = function (e) {
    this.onBlur(e);
    this.valid();
  };
  // Keydown event for hide er  rors
  Input.prototype.onKeyDown = function () {
    this.hideError();
  };
  Object.defineProperty(Input.prototype, "customRules", {
    // Apply custom validation rules base on input type
    get: function () {
      if (this.automaticRules === false) {
        return null;
      }
      switch (this.type) {
        case 'email':
          return {
            email: true
          };
        case 'tel':
          return {
            phone: true
          };
        case 'password':
          return {
            password: true
          };
        case 'color':
          if (this.$attrs.hex !== undefined) {
            return {
              hexColor: true
            };
          }
      }
      return null;
    },
    enumerable: false,
    configurable: true
  });
  Input.prototype.getElement = function () {
    return this.$refs.input;
  };
  __decorate([Prop({
    default: true
  })], Input.prototype, "automaticRules", void 0);
  __decorate([Prop({
    default: null
  })], Input.prototype, "minlength", void 0);
  __decorate([Prop({
    default: null
  })], Input.prototype, "maxlength", void 0);
  Input = __decorate([vue_class_component_esm], Input);
  return Input;
}(mixins(external_bootstrap_vue_namespaceObject.BFormInput, mixins_FormValidation));
/* harmony default export */ var Inputvue_type_script_lang_ts_external = (Input);
;// ./src/components/Input/Input.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Input_Inputvue_type_script_lang_ts_external = (Inputvue_type_script_lang_ts_external); 
;// ./src/components/Input/Input.vue
var Input_render, Input_staticRenderFns
;



/* normalize component */
;
var Input_component = normalizeComponent(
  Input_Inputvue_type_script_lang_ts_external,
  Input_render,
  Input_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Input_Input = (Input_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/Address/Address.ts?vue&type=script&lang=ts&external



/* eslint-disable @typescript-eslint/ban-ts-comment */






var Address = /** @class */function (_super) {
  __extends(Address, _super);
  function Address() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    // Inputs value
    _this.road = null;
    _this.road2 = null;
    _this.road3 = null;
    _this.postalCode = null;
    _this.city = null;
    _this.country = null;
    return _this;
  }
  Object.defineProperty(Address.prototype, "computedRoadName", {
    get: function () {
      return this.getInputName('road');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Address.prototype, "computedRoadId", {
    get: function () {
      return this.getInputId('road');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Address.prototype, "computedRoad2Name", {
    get: function () {
      return this.getInputName('road2');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Address.prototype, "computedRoad2Id", {
    get: function () {
      return this.getInputId('road2');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Address.prototype, "computedRoad3Name", {
    get: function () {
      return this.getInputName('road3');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Address.prototype, "computedRoad3Id", {
    get: function () {
      return this.getInputId('road3');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Address.prototype, "computedPostalCodeName", {
    get: function () {
      return this.getInputName('postalCode');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Address.prototype, "computedPostalCodeId", {
    get: function () {
      return this.getInputId('postalCode');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Address.prototype, "computedCityName", {
    get: function () {
      return this.getInputName('city');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Address.prototype, "computedCityId", {
    get: function () {
      return this.getInputId('city');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Address.prototype, "computedCountryName", {
    get: function () {
      return this.getInputName('country');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Address.prototype, "computedCountryId", {
    get: function () {
      return this.getInputId('country');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Address.prototype, "computedValueMap", {
    get: function () {
      return merge_default()({
        road: 'road',
        road2: 'road2',
        road3: 'road3',
        postalCode: 'postalCode',
        city: 'city',
        country: 'country'
      }, this.$KwFormConfig.addressValuesMap, this.valuesMap);
    },
    enumerable: false,
    configurable: true
  });
  Address.prototype.watchValue = function (value) {
    this.parseValue(value);
  };
  Address.prototype.watchLocalValue = function () {
    var _this = this;
    if (this.selectTimeout) {
      clearTimeout(this.selectTimeout);
      this.selectTimeout = undefined;
    }
    this.selectTimeout = setTimeout(function () {
      var keys = _this.computedValueMap;
      var value = JSON.parse(JSON.stringify(_this.value));
      value[keys.road] = _this.road;
      value[keys.road2] = _this.road2;
      value[keys.road3] = _this.road3;
      value[keys.postalCode] = _this.postalCode;
      value[keys.city] = _this.city;
      value[keys.country] = _this.country;
      _this.$emit('input', value);
    }, 400);
  };
  Address.prototype.mounted = function () {
    this.parseValue(this.value);
  };
  // Parse value property to datas
  Address.prototype.parseValue = function (value) {
    var _a, _b, _c, _d, _e, _f;
    if (!value || typeof value !== 'object') {
      return;
    }
    var keys = this.computedValueMap;
    this.road = (_a = value[keys.road]) !== null && _a !== void 0 ? _a : null;
    this.road2 = (_b = value[keys.road2]) !== null && _b !== void 0 ? _b : null;
    this.road3 = (_c = value[keys.road3]) !== null && _c !== void 0 ? _c : null;
    this.postalCode = (_d = value[keys.postalCode]) !== null && _d !== void 0 ? _d : null;
    this.city = (_e = value[keys.city]) !== null && _e !== void 0 ? _e : null;
    this.country = (_f = value[keys.country]) !== null && _f !== void 0 ? _f : null;
  };
  // Return name to use for inputs
  Address.prototype.getInputName = function (key) {
    var _a;
    key += 'Name';
    // @ts-ignore
    if (!this[key]) {
      return null;
    }
    // @ts-ignore
    return ((_a = this.prefixName) !== null && _a !== void 0 ? _a : '') + this[key];
  };
  // Return id to use for inputs
  Address.prototype.getInputId = function (key) {
    var _a, _b;
    var id = key + 'Id';
    var name = key + 'Name';
    // @ts-ignore
    if (this[id]) {
      // @ts-ignore
      return ((_a = this.prefixId) !== null && _a !== void 0 ? _a : '') + this[id];
      // @ts-ignore
    } else if (this.prefixId && this[name]) {
      // @ts-ignore
      return ((_b = this.prefixId) !== null && _b !== void 0 ? _b : '') + this[name];
    } else if (this.generateId !== false) {
      var strUcFirst = function (a) {
        return (a + '').charAt(0).toUpperCase() + a.substr(1);
      };
      // @ts-ignore
      return this['computed' + strUcFirst(key) + 'Name'];
    }
    return null;
  };
  // Select a value in dropdown
  Address.prototype.selectValue = function (data) {
    var _a, _b;
    var road = '';
    if (data.address.houseNumber) road += data.address.houseNumber + ' ';
    if (data.address.street) road += data.address.street;
    this.road = road;
    this.postalCode = (_a = data.address.postalCode) !== null && _a !== void 0 ? _a : '';
    this.city = (_b = data.address.city) !== null && _b !== void 0 ? _b : '';
    if (data.address.countryName) {
      var country = this.countriesList.find(function (country) {
        return country.code === data.address.countryCode.substr(0, 2);
      });
      if (country) {
        this.country = country;
      } else {
        this.country = {
          name: data.address.countryName,
          code: data.address.countryCode.substr(0, 2)
        };
      }
    } else {
      this.country = null;
    }
    this.clearAddresses();
  };
  __decorate([Prop({
    default: function () {
      return {};
    }
  })], Address.prototype, "value", void 0);
  __decorate([Prop({
    default: null
  })], Address.prototype, "valuesMap", void 0);
  __decorate([Prop({
    default: false
  })], Address.prototype, "required", void 0);
  __decorate([Prop({
    default: false
  })], Address.prototype, "roadRequired", void 0);
  __decorate([Prop({
    default: 'Rechercher une adresse'
  })], Address.prototype, "roadPlaceholder", void 0);
  __decorate([Prop({
    default: 'Complément d\'adresse'
  })], Address.prototype, "road2Placeholder", void 0);
  __decorate([Prop({
    default: ''
  })], Address.prototype, "road3Placeholder", void 0);
  __decorate([Prop({
    default: 'Ville'
  })], Address.prototype, "cityPlaceholder", void 0);
  __decorate([Prop({
    default: 'Code postal'
  })], Address.prototype, "postalCodePlaceholder", void 0);
  __decorate([Prop({
    default: 'Pays'
  })], Address.prototype, "countryPlaceholder", void 0);
  __decorate([Prop({
    default: function () {
      return [];
    }
  })], Address.prototype, "countriesList", void 0);
  __decorate([Prop({
    default: null
  })], Address.prototype, "prefixName", void 0);
  __decorate([Prop({
    default: null
  })], Address.prototype, "prefixId", void 0);
  __decorate([Prop({
    default: false
  })], Address.prototype, "generateId", void 0);
  __decorate([Prop({
    default: 'road1'
  })], Address.prototype, "roadName", void 0);
  __decorate([Prop({
    default: 'road2'
  })], Address.prototype, "road2Name", void 0);
  __decorate([Prop({
    default: 'road3'
  })], Address.prototype, "road3Name", void 0);
  __decorate([Prop({
    default: 'town'
  })], Address.prototype, "cityName", void 0);
  __decorate([Prop({
    default: 'postal_code'
  })], Address.prototype, "postalCodeName", void 0);
  __decorate([Prop({
    default: 'country'
  })], Address.prototype, "countryName", void 0);
  __decorate([Prop({
    default: null
  })], Address.prototype, "roadId", void 0);
  __decorate([Prop({
    default: null
  })], Address.prototype, "road2Id", void 0);
  __decorate([Prop({
    default: null
  })], Address.prototype, "road3Id", void 0);
  __decorate([Prop({
    default: null
  })], Address.prototype, "cityId", void 0);
  __decorate([Prop({
    default: null
  })], Address.prototype, "postalCodeId", void 0);
  __decorate([Prop({
    default: null
  })], Address.prototype, "countryId", void 0);
  __decorate([Prop({
    default: false
  })], Address.prototype, "withRoad3", void 0);
  __decorate([Prop({
    default: false
  })], Address.prototype, "disabled", void 0);
  __decorate([Watch('value', {
    deep: true
  })], Address.prototype, "watchValue", null);
  __decorate([Watch('road'), Watch('road2'), Watch('road3'), Watch('postalCode'), Watch('city'), Watch('country')], Address.prototype, "watchLocalValue", null);
  Address = __decorate([vue_class_component_esm({
    components: {
      BFormRow: external_bootstrap_vue_namespaceObject.BFormRow,
      BCol: external_bootstrap_vue_namespaceObject.BCol,
      BSpinner: external_bootstrap_vue_namespaceObject.BSpinner,
      'k-form-input': Input_Input,
      'k-form-select': Select_Select
    }
  })], Address);
  return Address;
}(mixins(mixins_HereApi));
/* harmony default export */ var Addressvue_type_script_lang_ts_external = (Address);
;// ./src/components/Address/Address.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Address_Addressvue_type_script_lang_ts_external = (Addressvue_type_script_lang_ts_external); 
;// ./src/components/Address/Address.vue





/* normalize component */
;
var Address_component = normalizeComponent(
  Address_Addressvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Address_Address = (Address_component.exports);
;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AddressSearch/AddressSearch.vue?vue&type=template&id=5e6aa1f0
var AddressSearchvue_type_template_id_5e6aa1f0_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: {
      'kw-form-control': true,
      dropdown: true,
      'required-indicator': _vm.required !== false
    }
  }, [_c('k-form-input', {
    attrs: {
      "size": _vm.size,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "name": _vm.name,
      "id": _vm.id
    },
    on: {
      "input": _vm.onInput
    },
    model: {
      value: _vm.addressLabel,
      callback: function ($$v) {
        _vm.addressLabel = $$v;
      },
      expression: "addressLabel"
    }
  }), _vm.computedDropdownVisibility ? _c('div', {
    staticClass: "dropdown-menu address-dropdown-menu"
  }, [_vm.dropdownLoading ? _c('div', {
    staticClass: "dropdown-item text-center disabled"
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  })], 1) : _vm._e(), _vm._l(_vm.addressesList, function (value, key) {
    return _c('button', {
      key: key,
      ref: 'dropdown-entry-' + key,
      refInFor: true,
      class: {
        'dropdown-item': true,
        'btn-sm': _vm.computedDropdownSize === 'sm',
        'btn-lg': _vm.computedDropdownSize === 'lg'
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.selectValue(value);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.getApiLabel(value)) + " ")]);
  })], 2) : _vm._e()], 1);
};
var AddressSearchvue_type_template_id_5e6aa1f0_staticRenderFns = [];

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/AddressSearch/AddressSearch.ts?vue&type=script&lang=ts&external





var AddressSearchvue_type_script_lang_ts_external_Address = /** @class */function (_super) {
  __extends(Address, _super);
  function Address() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    // Inputs value
    _this.address = null;
    _this.addressLabel = null;
    return _this;
  }
  Address.prototype.watchValue = function () {
    this.addressLabel = this.value;
  };
  // Select a value in dropdown
  Address.prototype.onInput = function (val) {
    this.searchAddress(val);
    return val;
  };
  // Select a value in dropdown
  Address.prototype.selectValue = function (data) {
    this.addressLabel = this.getApiLabel(data);
    this.onInput(this.addressLabel);
    this.clearAddresses();
    return data;
  };
  __decorate([Prop({
    default: null
  })], Address.prototype, "value", void 0);
  __decorate([Prop({
    default: false
  })], Address.prototype, "required", void 0);
  __decorate([Prop({
    default: null
  })], Address.prototype, "name", void 0);
  __decorate([Prop({
    default: null
  })], Address.prototype, "id", void 0);
  __decorate([Prop({
    default: 'Rechercher une adresse'
  })], Address.prototype, "placeholder", void 0);
  __decorate([Watch('value', {
    immediate: true
  })], Address.prototype, "watchValue", null);
  __decorate([Emit('input')], Address.prototype, "onInput", null);
  __decorate([Emit('select')], Address.prototype, "selectValue", null);
  Address = __decorate([vue_class_component_esm({
    components: {
      BSpinner: external_bootstrap_vue_namespaceObject.BSpinner,
      'k-form-input': Input_Input
    }
  })], Address);
  return Address;
}(mixins(mixins_HereApi));
/* harmony default export */ var AddressSearchvue_type_script_lang_ts_external = (AddressSearchvue_type_script_lang_ts_external_Address);
;// ./src/components/AddressSearch/AddressSearch.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AddressSearch_AddressSearchvue_type_script_lang_ts_external = (AddressSearchvue_type_script_lang_ts_external); 
;// ./src/components/AddressSearch/AddressSearch.vue





/* normalize component */
;
var AddressSearch_component = normalizeComponent(
  AddressSearch_AddressSearchvue_type_script_lang_ts_external,
  AddressSearchvue_type_template_id_5e6aa1f0_render,
  AddressSearchvue_type_template_id_5e6aa1f0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AddressSearch = (AddressSearch_component.exports);
;// ./node_modules/bootstrap-vue/src/utils/object.js


// --- Static ---

const object_assign = (...args) => Object.assign(...args)
const create = (proto, optionalProps) => Object.create(proto, optionalProps)
const defineProperties = (obj, props) => Object.defineProperties(obj, props)
const defineProperty = (obj, prop, descriptor) =>
  Object.defineProperty(obj, prop, descriptor)
const freeze = obj => Object.freeze(obj)
const getOwnPropertyNames = obj => Object.getOwnPropertyNames(obj)
const getOwnPropertyDescriptor = (obj, prop) => Object.getOwnPropertyDescriptor(obj, prop)
const getOwnPropertySymbols = obj => Object.getOwnPropertySymbols(obj)
const getPrototypeOf = obj => Object.getPrototypeOf(obj)
const is = (value1, value2) => Object.is(value1, value2)
const isFrozen = obj => Object.isFrozen(obj)
const keys = obj => Object.keys(obj)

// --- "Instance" ---

const object_hasOwnProperty = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop)
const object_toString = obj => Object.prototype.toString.call(obj)

// --- Utilities ---

// Shallow copy an object
const clone = obj => ({ ...obj })

// Return a shallow copy of object with the specified properties only
// See: https://gist.github.com/bisubus/2da8af7e801ffd813fab7ac221aa7afc
const pick = (obj, props) =>
  keys(obj)
    .filter(key => props.indexOf(key) !== -1)
    .reduce((result, key) => ({ ...result, [key]: obj[key] }), {})

// Return a shallow copy of object with the specified properties omitted
// See: https://gist.github.com/bisubus/2da8af7e801ffd813fab7ac221aa7afc
const omit = (obj, props) =>
  keys(obj)
    .filter(key => props.indexOf(key) === -1)
    .reduce((result, key) => ({ ...result, [key]: obj[key] }), {})

// Merges two object deeply together
// See: https://gist.github.com/Salakar/1d7137de9cb8b704e48a
const mergeDeep = (target, source) => {
  if (isObject(target) && isObject(source)) {
    keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!target[key] || !isObject(target[key])) {
          target[key] = source[key]
        }
        mergeDeep(target[key], source[key])
      } else {
        object_assign(target, { [key]: source[key] })
      }
    })
  }
  return target
}

// Returns a shallow copy of the object with keys in sorted order
const sortKeys = obj =>
  keys(obj)
    .sort()
    .reduce((result, key) => ({ ...result, [key]: obj[key] }), {})

// Convenience method to create a read-only descriptor
const readonlyDescriptor = () => ({ enumerable: true, configurable: false, writable: false })

;// ./node_modules/bootstrap-vue/src/utils/inspect.js



// --- Convenience inspection utilities ---

const toType = value => typeof value

const toRawType = value => Object.prototype.toString.call(value).slice(8, -1)

const toRawTypeLC = value => toRawType(value).toLowerCase()

const isUndefined = value => value === undefined

const isNull = value => value === null

const isEmptyString = value => value === ''

const isUndefinedOrNull = value => isUndefined(value) || isNull(value)

const isUndefinedOrNullOrEmpty = value => isUndefinedOrNull(value) || isEmptyString(value)

const inspect_isFunction = value => toType(value) === 'function'

const isBoolean = value => toType(value) === 'boolean'

const isString = value => toType(value) === 'string'

const isNumber = value => toType(value) === 'number'

const isNumeric = value => RX_NUMBER.test(String(value))

const inspect_isPrimitive = value => isBoolean(value) || isString(value) || isNumber(value)

const isArray = value => Array.isArray(value)

// Quick object check
// This is primarily used to tell Objects from primitive values
// when we know the value is a JSON-compliant type
// Note object could be a complex type like array, Date, etc.
const inspect_isObject = obj => obj !== null && typeof obj === 'object'

// Strict object type check
// Only returns true for plain JavaScript objects
const isPlainObject = obj => Object.prototype.toString.call(obj) === '[object Object]'

const isDate = value => value instanceof Date

const isEvent = value => value instanceof Event

const isFile = value => value instanceof File

const isRegExp = value => toRawType(value) === 'RegExp'

const inspect_isPromise = value =>
  !isUndefinedOrNull(value) && inspect_isFunction(value.then) && inspect_isFunction(value.catch)

;// ./node_modules/bootstrap-vue/src/utils/loose-equal.js



// Assumes both a and b are arrays!
// Handles when arrays are "sparse" (array.every(...) doesn't handle sparse)
const compareArrays = (a, b) => {
  if (a.length !== b.length) {
    return false
  }
  let equal = true
  for (let i = 0; equal && i < a.length; i++) {
    equal = looseEqual(a[i], b[i])
  }
  return equal
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 * Returns boolean true or false
 */
const looseEqual = (a, b) => {
  if (a === b) {
    return true
  }
  let aValidType = isDate(a)
  let bValidType = isDate(b)
  if (aValidType || bValidType) {
    return aValidType && bValidType ? a.getTime() === b.getTime() : false
  }
  aValidType = isArray(a)
  bValidType = isArray(b)
  if (aValidType || bValidType) {
    return aValidType && bValidType ? compareArrays(a, b) : false
  }
  aValidType = inspect_isObject(a)
  bValidType = inspect_isObject(b)
  if (aValidType || bValidType) {
    /* istanbul ignore if: this if will probably never be called */
    if (!aValidType || !bValidType) {
      return false
    }
    const aKeysCount = keys(a).length
    const bKeysCount = keys(b).length
    if (aKeysCount !== bKeysCount) {
      return false
    }
    for (const key in a) {
      const aHasKey = object_hasOwnProperty(a, key)
      const bHasKey = object_hasOwnProperty(b, key)
      if ((aHasKey && !bHasKey) || (!aHasKey && bHasKey) || !looseEqual(a[key], b[key])) {
        return false
      }
    }
  }
  return String(a) === String(b)
}

;// ./node_modules/bootstrap-vue/src/utils/loose-index-of.js


// Assumes that the first argument is an array
const looseIndexOf = (array, value) => {
  for (let i = 0; i < array.length; i++) {
    if (looseEqual(array[i], value)) {
      return i
    }
  }
  return -1
}

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/Checkbox/Checkbox.ts?vue&type=script&lang=ts&external






var Checkbox = /** @class */function (_super) {
  __extends(Checkbox, _super);
  function Checkbox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  // Override Bootstrap Vue handleChange function to add data validation
  Checkbox.prototype.handleChange = function (_a) {
    var _this = this;
    var _b = _a.target,
      checked = _b.checked,
      indeterminate = _b.indeterminate;
    this.valid();
    var _c = this,
      value = _c.value,
      uncheckedValue = _c.uncheckedValue;
    // Update `computedLocalChecked`
    var localChecked = this.computedLocalChecked;
    if (isArray(localChecked)) {
      var index = looseIndexOf(localChecked, value);
      if (checked && index < 0) {
        // Add value to array
        localChecked = localChecked.concat(value);
      } else if (!checked && index > -1) {
        // Remove value from array
        localChecked = localChecked.slice(0, index).concat(localChecked.slice(index + 1));
      }
    } else {
      localChecked = checked ? value : uncheckedValue;
    }
    this.computedLocalChecked = localChecked;
    // Fire events in a `$nextTick()` to ensure the `v-model` is updated
    this.$nextTick(function () {
      // Change is only emitted on user interaction
      _this.$emit('change', localChecked);
      // If this is a child of a group, we emit a change event on it as well
      if (_this.isGroup) {
        _this.bvGroup.$emit('change', localChecked);
      }
      _this.$emit('update:indeterminate', indeterminate);
    });
  };
  // Return the form element (input, select...)
  Checkbox.prototype.getElement = function () {
    return this.$refs.input;
  };
  // Return the value for validation
  Checkbox.prototype.getValue = function () {
    return this.getElement().checked;
  };
  // Return the element where attach tippy
  Checkbox.prototype.getTippyElement = function () {
    var input = this.$refs.input;
    var label = this.$el.querySelector('label[for="' + input.id + '"]');
    return label !== null && label !== void 0 ? label : input;
  };
  Checkbox.prototype.render = function (h) {
    var _a;
    var _b = this,
      isRadio = _b.isRadio,
      isBtnMode = _b.isBtnMode,
      isPlain = _b.isPlain,
      isCustom = _b.isCustom,
      isInline = _b.isInline,
      isSwitch = _b.isSwitch,
      computedSize = _b.computedSize,
      bvAttrs = _b.bvAttrs;
    var $content = this.normalizeSlot();
    var $input = h('input', {
      class: [{
        'form-check-input': isPlain,
        'custom-control-input': isCustom,
        // https://github.com/bootstrap-vue/bootstrap-vue/issues/2911
        'position-static': isPlain && !$content
      }, isBtnMode ? '' : this.stateClass],
      directives: [{
        name: 'model',
        value: this.computedLocalChecked
      }],
      attrs: this.computedAttrs,
      domProps: {
        value: this.value,
        checked: this.isChecked
      },
      on: __assign({
        change: this.handleChange
      }, isBtnMode ? {
        focus: this.handleFocus,
        blur: this.handleFocus
      } : {}),
      key: 'input',
      ref: 'input'
    });
    if (isBtnMode) {
      var $button = h('label', {
        class: this.buttonClasses
      }, [$input, $content]);
      if (!this.isGroup) {
        // Standalone button mode, so wrap in 'btn-group-toggle'
        // and flag it as inline-block to mimic regular buttons
        $button = h('div', {
          class: ['btn-group-toggle', 'd-inline-block']
        }, [$button]);
      }
      return $button;
    }
    // If no label content in plain mode we dont render the label
    // See: https://github.com/bootstrap-vue/bootstrap-vue/issues/2911
    var $label = h();
    if (!(isPlain && !$content)) {
      $label = h('label', {
        class: {
          'form-check-label': isPlain,
          'custom-control-label': isCustom
        },
        attrs: {
          for: this.safeId()
        }
      }, $content);
    }
    return h('div', {
      class: [(_a = {
        'form-check': isPlain,
        'form-check-inline': isPlain && isInline,
        'custom-control': isCustom,
        'custom-control-inline': isCustom && isInline,
        'custom-checkbox': isCustom && !isRadio && !isSwitch,
        'custom-switch': isSwitch,
        'custom-radio': isCustom && isRadio,
        'custom-checkbox-nolabel': this.noLabel !== false
      },
      // Temporary until Bootstrap v4 supports sizing (most likely in V5)
      _a["b-custom-control-" + computedSize] = computedSize && !isBtnMode, _a), bvAttrs.class],
      style: bvAttrs.style
    }, [$input, $label]);
  };
  __decorate([Prop({
    default: false
  })], Checkbox.prototype, "noLabel", void 0);
  Checkbox = __decorate([vue_class_component_esm], Checkbox);
  return Checkbox;
}(mixins(external_bootstrap_vue_namespaceObject.BFormCheckbox, mixins_FormValidation));
/* harmony default export */ var Checkboxvue_type_script_lang_ts_external = (Checkbox);
;// ./src/components/Checkbox/Checkbox.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Checkbox_Checkboxvue_type_script_lang_ts_external = (Checkboxvue_type_script_lang_ts_external); 
;// ./src/components/Checkbox/Checkbox.vue
var Checkbox_render, Checkbox_staticRenderFns
;



/* normalize component */
;
var Checkbox_component = normalizeComponent(
  Checkbox_Checkboxvue_type_script_lang_ts_external,
  Checkbox_render,
  Checkbox_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Checkbox_Checkbox = (Checkbox_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/Checkbox/CheckboxGroup.ts?vue&type=script&lang=ts&external





var CheckboxGroupvue_type_script_lang_ts_external_Checkbox = /** @class */function (_super) {
  __extends(Checkbox, _super);
  function Checkbox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Checkbox.prototype.watchChecked = function (newVal) {
    this.localChecked = newVal;
    this.valid();
  };
  Checkbox.prototype.watchLocalChecked = function (newVal, oldVal) {
    if (!looseEqual(newVal, oldVal)) {
      this.$emit('input', newVal);
      this.valid();
    }
  };
  // Return the value for validation
  Checkbox.prototype.getValue = function () {
    return this.localChecked;
  };
  __decorate([Watch('checked')], Checkbox.prototype, "watchChecked", null);
  __decorate([Watch('localChecked')], Checkbox.prototype, "watchLocalChecked", null);
  Checkbox = __decorate([vue_class_component_esm], Checkbox);
  return Checkbox;
}(mixins(external_bootstrap_vue_namespaceObject.BFormCheckboxGroup, mixins_FormValidation));
/* harmony default export */ var CheckboxGroupvue_type_script_lang_ts_external = (CheckboxGroupvue_type_script_lang_ts_external_Checkbox);
;// ./src/components/Checkbox/CheckboxGroup.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Checkbox_CheckboxGroupvue_type_script_lang_ts_external = (CheckboxGroupvue_type_script_lang_ts_external); 
;// ./src/components/Checkbox/CheckboxGroup.vue
var CheckboxGroup_render, CheckboxGroup_staticRenderFns
;



/* normalize component */
;
var CheckboxGroup_component = normalizeComponent(
  Checkbox_CheckboxGroupvue_type_script_lang_ts_external,
  CheckboxGroup_render,
  CheckboxGroup_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CheckboxGroup = (CheckboxGroup_component.exports);
;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DatePicker/DatePicker.vue?vue&type=template&id=1c32d541
var DatePickervue_type_template_id_1c32d541_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: {
      'kw-form-control': true,
      'required-indicator': _vm.required !== false,
      'datepicker-wrapper': true
    }
  }, [_vm.name || _vm.id ? _c('input', {
    attrs: {
      "id": _vm.id,
      "name": _vm.name,
      "type": "hidden"
    },
    domProps: {
      "value": _vm.computedValue
    }
  }) : _vm._e(), _c('datepicker', {
    attrs: {
      "is-range": _vm.isRange,
      "mode": "date",
      "keepVisibleOnInput": _vm.keepVisibleOnInput,
      "show-weeknumbers": _vm.showWeekNumbers,
      "dragAttribute": _vm.dragAttribute,
      "selectAttribute": _vm.selectAttribute,
      "available-dates": _vm.availableDates,
      "disabled-dates": _vm.disabledDates,
      "popover": _vm.computedPopover,
      "min-date": _vm.minDate,
      "max-date": _vm.maxDate
    },
    on: {
      "input": _vm.onInput
    },
    scopedSlots: _vm._u([!_vm.isInline ? {
      key: "default",
      fn: function ({
        inputValue,
        inputEvents
      }) {
        return [_c('input', _vm._g(_vm._b({
          ref: "input",
          domProps: {
            "value": inputValue
          }
        }, 'input', _vm.computedInputProps, false), inputEvents))];
      }
    } : null], null, true),
    model: {
      value: _vm.inputValue,
      callback: function ($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1);
};
var DatePickervue_type_template_id_1c32d541_staticRenderFns = [];

;// ./node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
;// ./node_modules/@babel/runtime/helpers/esm/typeof.js
function typeof_typeof(o) {
  "@babel/helpers - typeof";

  return typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, typeof_typeof(o);
}

;// ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
;// ./node_modules/date-fns/esm/toDate/index.js


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || typeof_typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}
;// ./node_modules/date-fns/esm/addDays/index.js



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}
;// ./node_modules/date-fns/esm/addMonths/index.js



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
;// ./node_modules/date-fns/esm/addYears/index.js



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
// EXTERNAL MODULE: ./node_modules/lodash/isBoolean.js
var lodash_isBoolean = __webpack_require__(3812);
var isBoolean_default = /*#__PURE__*/__webpack_require__.n(lodash_isBoolean);
// EXTERNAL MODULE: ./node_modules/lodash/isNumber.js
var lodash_isNumber = __webpack_require__(8023);
var isNumber_default = /*#__PURE__*/__webpack_require__.n(lodash_isNumber);
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var lodash_isString = __webpack_require__(5015);
var isString_default = /*#__PURE__*/__webpack_require__.n(lodash_isString);
// EXTERNAL MODULE: ./node_modules/lodash/isArrayLikeObject.js
var isArrayLikeObject = __webpack_require__(3693);
var isArrayLikeObject_default = /*#__PURE__*/__webpack_require__.n(isArrayLikeObject);
// EXTERNAL MODULE: ./node_modules/lodash/isFunction.js
var lodash_isFunction = __webpack_require__(1882);
var isFunction_default = /*#__PURE__*/__webpack_require__.n(lodash_isFunction);
// EXTERNAL MODULE: ./node_modules/lodash/isUndefined.js
var lodash_isUndefined = __webpack_require__(2216);
var isUndefined_default = /*#__PURE__*/__webpack_require__.n(lodash_isUndefined);
// EXTERNAL MODULE: ./node_modules/lodash/isDate.js
var lodash_isDate = __webpack_require__(3602);
var isDate_default = /*#__PURE__*/__webpack_require__.n(lodash_isDate);
// EXTERNAL MODULE: ./node_modules/lodash/clamp.js
var clamp = __webpack_require__(8659);
var clamp_default = /*#__PURE__*/__webpack_require__.n(clamp);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(8156);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/set.js
var set = __webpack_require__(3560);
var set_default = /*#__PURE__*/__webpack_require__.n(set);
// EXTERNAL MODULE: ./node_modules/lodash/mapValues.js
var mapValues = __webpack_require__(3916);
var mapValues_default = /*#__PURE__*/__webpack_require__.n(mapValues);
// EXTERNAL MODULE: ./node_modules/lodash/toPairs.js
var toPairs = __webpack_require__(8938);
var toPairs_default = /*#__PURE__*/__webpack_require__.n(toPairs);
// EXTERNAL MODULE: ./node_modules/lodash/defaults.js
var defaults = __webpack_require__(4684);
var defaults_default = /*#__PURE__*/__webpack_require__.n(defaults);
// EXTERNAL MODULE: ./node_modules/lodash/defaultsDeep.js
var defaultsDeep = __webpack_require__(4354);
var defaultsDeep_default = /*#__PURE__*/__webpack_require__.n(defaultsDeep);
// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var lodash_pick = __webpack_require__(4383);
var pick_default = /*#__PURE__*/__webpack_require__.n(lodash_pick);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var lodash_omit = __webpack_require__(179);
var omit_default = /*#__PURE__*/__webpack_require__.n(lodash_omit);
// EXTERNAL MODULE: ./node_modules/lodash/has.js
var has = __webpack_require__(1448);
var has_default = /*#__PURE__*/__webpack_require__.n(has);
// EXTERNAL MODULE: ./node_modules/lodash/map.js
var map = __webpack_require__(5378);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
// EXTERNAL MODULE: ./node_modules/lodash/head.js
var head = __webpack_require__(912);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/lodash/last.js
var last = __webpack_require__(8090);
var last_default = /*#__PURE__*/__webpack_require__.n(last);
// EXTERNAL MODULE: ./node_modules/lodash/some.js
var some = __webpack_require__(2426);
var some_default = /*#__PURE__*/__webpack_require__.n(some);
;// ./node_modules/v-calendar/src/utils/_.js
// Type utils








// Number utils


// Object utils










// Collection utils





// Type checkers
const getType = value =>
  Object.prototype.toString.call(value).slice(8, -1);
const _isDate = value => isDate_default()(value) && !isNaN(value.getTime());
const _isObject = value => getType(value) === 'Object';
// Object utils
const _has = (has_default());
const hasAny = (obj, props) => some_default()(props, p => has_default()(obj, p));
// Collection utils
const _some = (some_default());

;// ./node_modules/v-calendar/src/utils/helpers.js


const pad = (val, len, char = '0') => {
  val = val !== null && val !== undefined ? String(val) : '';
  len = len || 2;
  while (val.length < len) {
    val = `${char}${val}`;
  }
  return val;
};

const evalFn = (fn, args) => (isFunction(fn) ? fn(args) : fn);

const mergeEvents = (...args) => {
  const result = {};
  args.forEach(e =>
    Object.entries(e).forEach(([key, value]) => {
      if (!result[key]) {
        result[key] = value;
      } else if (isArrayLikeObject_default()(result[key])) {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    }),
  );
  return result;
};

const pageIsValid = page => !!(page && page.month && page.year);

const pageIsBeforePage = (page, comparePage) => {
  if (!pageIsValid(page) || !pageIsValid(comparePage)) return false;
  if (page.year === comparePage.year) return page.month < comparePage.month;
  return page.year < comparePage.year;
};

const pageIsAfterPage = (page, comparePage) => {
  if (!pageIsValid(page) || !pageIsValid(comparePage)) return false;
  if (page.year === comparePage.year) return page.month > comparePage.month;
  return page.year > comparePage.year;
};

const pageIsBetweenPages = (page, fromPage, toPage) =>
  (page || false) &&
  !pageIsBeforePage(page, fromPage) &&
  !pageIsAfterPage(page, toPage);

const pageIsEqualToPage = (aPage, bPage) => {
  if (!aPage && bPage) return false;
  if (aPage && !bPage) return false;
  if (!aPage && !bPage) return true;
  return aPage.month === bPage.month && aPage.year === bPage.year;
};

const addPages = ({ month, year }, count) => {
  const incr = count > 0 ? 1 : -1;
  for (let i = 0; i < Math.abs(count); i++) {
    month += incr;
    if (month > 12) {
      month = 1;
      year++;
    } else if (month < 1) {
      month = 12;
      year--;
    }
  }
  return {
    month,
    year,
  };
};

const pageRangeToArray = (from, to) => {
  if (!pageIsValid(from) || !pageIsValid(to)) return [];
  const result = [];
  while (!pageIsAfterPage(from, to)) {
    result.push(from);
    from = addPages(from, 1);
  }
  return result;
};

function datesAreEqual(a, b) {
  const aIsDate = _isDate(a);
  const bIsDate = _isDate(b);
  if (!aIsDate && !bIsDate) return true;
  if (aIsDate !== bIsDate) return false;
  return a.getTime() === b.getTime();
}

const arrayHasItems = array => isArrayLikeObject_default()(array) && array.length;

const mixinOptionalProps = (source, target, props) => {
  const assigned = [];
  props.forEach(p => {
    const name = p.name || p.toString();
    const mixin = p.mixin;
    const validate = p.validate;
    if (Object.prototype.hasOwnProperty.call(source, name)) {
      const value = validate ? validate(source[name]) : source[name];
      target[name] = mixin && _isObject(value) ? { ...mixin, ...value } : value;
      assigned.push(name);
    }
  });
  return {
    target,
    assigned: assigned.length ? assigned : null,
  };
};

const on = (element, event, handler, opts) => {
  if (element && event && handler) {
    element.addEventListener(event, handler, opts);
  }
};

const off = (element, event, handler, opts) => {
  if (element && event) {
    element.removeEventListener(event, handler, opts);
  }
};

const elementContains = (element, child) =>
  !!element && !!child && (element === child || element.contains(child));

const onSpaceOrEnter = (event, handler) => {
  if (event.key === ' ' || event.key === 'Enter') {
    handler(event);
    event.preventDefault();
  }
};

/* eslint-disable no-bitwise */

const createGuid = () => {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return `${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`;
};

function helpers_hash(str) {
  let hashcode = 0;
  let i = 0;
  let chr;
  if (str.length === 0) return hashcode;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hashcode = (hashcode << 5) - hashcode + chr;
    hashcode |= 0; // Convert to 32bit integer
  }
  return hashcode;
}

/* eslint-enable no-bitwise */

;// ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/Popover.vue?vue&type=script&lang=js





/* harmony default export */ var Popovervue_type_script_lang_js = ({
  name: 'Popover',
  render(h) {
    return h(
      'div',
      {
        class: [
          'vc-popover-content-wrapper',
          {
            'is-interactive': this.isInteractive,
          },
        ],
        ref: 'popover',
      },
      [
        h(
          'transition',
          {
            props: {
              name: this.transition,
              appear: true,
            },
            on: {
              beforeEnter: this.beforeEnter,
              afterEnter: this.afterEnter,
              beforeLeave: this.beforeLeave,
              afterLeave: this.afterLeave,
            },
          },
          [
            this.isVisible &&
              h(
                'div',
                {
                  attrs: {
                    tabindex: -1,
                  },
                  class: [
                    'vc-popover-content',
                    `direction-${this.direction}`,
                    this.contentClass,
                  ],
                },
                [
                  this.content,
                  h('span', {
                    class: [
                      'vc-popover-caret',
                      `direction-${this.direction}`,
                      `align-${this.alignment}`,
                    ],
                  }),
                ],
              ),
          ],
        ),
      ],
    );
  },
  props: {
    id: { type: String, required: true },
    contentClass: String,
  },
  data() {
    return {
      ref: null,
      opts: null,
      data: null,
      transition: 'slide-fade',
      placement: 'bottom',
      positionFixed: false,
      modifiers: [],
      isInteractive: false,
      isHovered: false,
      isFocused: false,
      showDelay: 0,
      hideDelay: 110,
      autoHide: false,
      popperEl: null,
    };
  },
  computed: {
    content() {
      return (
        (isFunction_default()(this.$scopedSlots.default) &&
          this.$scopedSlots.default({
            direction: this.direction,
            alignment: this.alignment,
            data: this.data,
            updateLayout: this.setupPopper,
            hide: opts => this.hide(opts),
          })) ||
        this.$slots.default
      );
    },
    popperOptions() {
      return {
        placement: this.placement,
        strategy: this.positionFixed ? 'fixed' : 'absolute',
        modifiers: [
          {
            name: 'onUpdate',
            enabled: true,
            phase: 'afterWrite',
            fn: this.onPopperUpdate,
          },
          ...(this.modifiers || []),
        ],
        onFirstUpdate: this.onPopperUpdate,
      };
    },
    isVisible() {
      return !!(this.ref && this.content);
    },
    direction() {
      return (this.placement && this.placement.split('-')[0]) || 'bottom';
    },
    alignment() {
      const isLeftRight =
        this.direction === 'left' || this.direction === 'right';
      let alignment = this.placement.split('-');
      alignment = alignment.length > 1 ? alignment[1] : '';
      if (['start', 'top', 'left'].includes(alignment)) {
        return isLeftRight ? 'top' : 'left';
      }
      if (['end', 'bottom', 'right'].includes(alignment)) {
        return isLeftRight ? 'bottom' : 'right';
      }
      return isLeftRight ? 'middle' : 'center';
    },
    state() {
      return this.$popovers[this.id];
    },
  },
  watch: {
    opts(val, oldVal) {
      if (oldVal && oldVal.callback) {
        oldVal.callback({
          ...oldVal,
          completed: !val,
          reason: val ? 'Overridden by action' : null,
        });
      }
    },
  },
  mounted() {
    this.popoverEl = this.$refs.popover;
    this.addEvents();
  },
  beforeDestroy() {
    this.destroyPopper();
    this.removeEvents();
    this.popoverEl = null;
  },
  methods: {
    addEvents() {
      on(this.popoverEl, 'click', this.onClick);
      on(this.popoverEl, 'mouseover', this.onMouseOver);
      on(this.popoverEl, 'mouseleave', this.onMouseLeave);
      on(this.popoverEl, 'focusin', this.onFocusIn);
      on(this.popoverEl, 'focusout', this.onFocusOut);
      on(document, 'keydown', this.onDocumentKeydown);
      on(document, 'click', this.onDocumentClick);
      on(document, 'show-popover', this.onDocumentShowPopover);
      on(document, 'hide-popover', this.onDocumentHidePopover);
      on(document, 'toggle-popover', this.onDocumentTogglePopover);
      on(document, 'update-popover', this.onDocumentUpdatePopover);
    },
    removeEvents() {
      off(this.popoverEl, 'click', this.onClick);
      off(this.popoverEl, 'mouseover', this.onMouseOver);
      off(this.popoverEl, 'mouseleave', this.onMouseLeave);
      off(this.popoverEl, 'focusin', this.onFocusIn);
      off(this.popoverEl, 'focusout', this.onFocusOut);
      off(document, 'keydown', this.onDocumentKeydown);
      off(document, 'click', this.onDocumentClick);
      off(document, 'show-popover', this.onDocumentShowPopover);
      off(document, 'hide-popover', this.onDocumentHidePopover);
      off(document, 'toggle-popover', this.onDocumentTogglePopover);
      off(document, 'update-popover', this.onDocumentUpdatePopover);
    },
    onClick(e) {
      e.stopPropagation();
    },
    onMouseOver() {
      this.isHovered = true;
      if (this.isInteractive) this.show();
    },
    onMouseLeave() {
      this.isHovered = false;
      if (
        this.autoHide &&
        !this.isFocused &&
        (!this.ref || this.ref !== document.activeElement)
      ) {
        this.hide();
      }
    },
    onFocusIn() {
      this.isFocused = true;
      if (this.isInteractive) this.show();
    },
    onFocusOut(e) {
      if (
        !e.relatedTarget ||
        !elementContains(this.popoverEl, e.relatedTarget)
      ) {
        this.isFocused = false;
        if (!this.isHovered && this.autoHide) this.hide();
      }
    },
    onDocumentClick(e) {
      if (!this.$refs.popover || !this.ref) {
        return;
      }
      // Don't hide if target element is contained within popover ref or content
      if (
        elementContains(this.popoverEl, e.target) ||
        elementContains(this.ref, e.target)
      ) {
        return;
      }
      // Hide the popover
      this.hide();
    },
    onDocumentKeydown(e) {
      if (e.key === 'Esc' || e.key === 'Escape') {
        this.hide();
      }
    },
    onDocumentShowPopover({ detail }) {
      if (!detail.id || detail.id !== this.id) return;
      this.show(detail);
    },
    onDocumentHidePopover({ detail }) {
      if (!detail.id || detail.id !== this.id) return;
      this.hide(detail);
    },
    onDocumentTogglePopover({ detail }) {
      if (!detail.id || detail.id !== this.id) return;
      this.toggle(detail);
    },
    onDocumentUpdatePopover({ detail }) {
      if (!detail.id || detail.id !== this.id) return;
      this.update(detail);
    },
    show(opts = {}) {
      opts.action = 'show';
      const ref = opts.ref || this.ref;
      const delay = opts.showDelay >= 0 ? opts.showDelay : this.showDelay;
      // Validate options
      if (!ref) {
        if (opts.callback) {
          opts.callback({
            completed: false,
            reason: 'Invalid reference element provided',
          });
        }
        return;
      }
      clearTimeout(this.timeout);
      this.opts = opts;
      const fn = () => {
        Object.assign(this, opts);
        this.setupPopper();
        this.opts = null;
      };
      if (delay > 0) {
        this.timeout = setTimeout(() => fn(), delay);
      } else {
        fn();
      }
    },
    hide(opts = {}) {
      opts.action = 'hide';
      const ref = opts.ref || this.ref;
      const delay = opts.hideDelay >= 0 ? opts.hideDelay : this.hideDelay;
      if (!this.ref || ref !== this.ref) {
        if (opts.callback) {
          opts.callback({
            ...opts,
            completed: false,
            reason: this.ref
              ? 'Invalid reference element provided'
              : 'Popover already hidden',
          });
        }
        return;
      }
      const fn = () => {
        this.ref = null;
        this.opts = null;
      };
      clearTimeout(this.timeout);
      this.opts = opts;
      if (delay > 0) {
        this.timeout = setTimeout(fn, delay);
      } else {
        fn();
      }
    },
    toggle(opts = {}) {
      if (this.isVisible && opts.ref === this.ref) {
        this.hide(opts);
      } else {
        this.show(opts);
      }
    },
    update(opts = {}) {
      Object.assign(this, opts);
      this.setupPopper();
    },
    setupPopper() {
      this.$nextTick(() => {
        if (!this.ref || !this.$refs.popover) return;
        if (this.popper && this.popper.reference !== this.ref) {
          this.destroyPopper();
        }
        if (!this.popper) {
          this.popper = popper_createPopper(
            this.ref,
            this.popoverEl,
            this.popperOptions,
          );
        } else {
          this.popper.update();
        }
      });
    },
    onPopperUpdate(args) {
      if (args.placement) {
        this.placement = args.placement;
      } else if (args.state) {
        this.placement = args.state.placement;
      }
    },
    beforeEnter(e) {
      this.$emit('beforeShow', e);
    },
    afterEnter(e) {
      this.$emit('afterShow', e);
    },
    beforeLeave(e) {
      this.$emit('beforeHide', e);
    },
    afterLeave(e) {
      this.destroyPopper();
      this.$emit('afterHide', e);
    },
    destroyPopper() {
      if (this.popper) {
        this.popper.destroy();
        this.popper = null;
      }
    },
  },
});

;// ./node_modules/v-calendar/src/components/Popover.vue?vue&type=script&lang=js
 /* harmony default export */ var components_Popovervue_type_script_lang_js = (Popovervue_type_script_lang_js); 
;// ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-17.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-17.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-17.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/Popover.vue?vue&type=style&index=0&id=bbffc602&prod&lang=postcss&scoped=true
// extracted by mini-css-extract-plugin

;// ./node_modules/v-calendar/src/components/Popover.vue?vue&type=style&index=0&id=bbffc602&prod&lang=postcss&scoped=true

;// ./node_modules/v-calendar/src/components/Popover.vue
var Popover_render, Popover_staticRenderFns
;

;


/* normalize component */

var Popover_component = normalizeComponent(
  components_Popovervue_type_script_lang_js,
  Popover_render,
  Popover_staticRenderFns,
  false,
  null,
  "bbffc602",
  null
  
)

/* harmony default export */ var Popover = (Popover_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/PopoverRow.vue?vue&type=template&id=0ccf1808&scoped=true
var PopoverRowvue_type_template_id_0ccf1808_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vc-day-popover-row"},[(_vm.indicator)?_c('div',{staticClass:"vc-day-popover-row-indicator"},[_c('span',{class:_vm.indicator.class,style:(_vm.indicator.style)})]):_vm._e(),_c('div',{staticClass:"vc-day-popover-row-content"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.attribute.popover ? _vm.attribute.popover.label : 'No content provided'))]})],2)])
}
var PopoverRowvue_type_template_id_0ccf1808_scoped_true_staticRenderFns = []


;// ./node_modules/v-calendar/src/utils/defaults/touch.json
var touch_namespaceObject = /*#__PURE__*/JSON.parse('{"maxSwipeTime":300,"minHorizontalSwipeDistance":60,"maxVerticalSwipeDistance":80}');
;// ./node_modules/v-calendar/src/utils/defaults/masks.json
var masks_namespaceObject = /*#__PURE__*/JSON.parse('{"title":"MMMM YYYY","weekdays":"W","navMonths":"MMM","input":["L","YYYY-MM-DD","YYYY/MM/DD"],"inputDateTime":["L h:mm A","YYYY-MM-DD h:mm A","YYYY/MM/DD h:mm A"],"inputDateTime24hr":["L HH:mm","YYYY-MM-DD HH:mm","YYYY/MM/DD HH:mm"],"inputTime":["h:mm A"],"inputTime24hr":["HH:mm"],"dayPopover":"WWW, MMM D, YYYY","data":["L","YYYY-MM-DD","YYYY/MM/DD"],"iso":"YYYY-MM-DDTHH:mm:ss.SSSZ"}');
;// ./node_modules/v-calendar/src/utils/defaults/screens.json
var screens_namespaceObject = /*#__PURE__*/JSON.parse('{"sm":"640px","md":"768px","lg":"1024px","xl":"1280px"}');
;// ./node_modules/v-calendar/src/utils/defaults/locales.js


const locales = {
  // Arabic
  ar: { dow: 7, L: 'D/\u200FM/\u200FYYYY' },
  // Bulgarian
  bg: { dow: 2, L: 'D.MM.YYYY' },
  // Catalan
  ca: { dow: 2, L: 'DD/MM/YYYY' },
  // Chinese (China)
  'zh-CN': { dow: 2, L: 'YYYY/MM/DD' },
  // Chinese (Taiwan)
  'zh-TW': { dow: 1, L: 'YYYY/MM/DD' },
  // Croatian
  hr: { dow: 2, L: 'DD.MM.YYYY' },
  // Czech
  cs: { dow: 2, L: 'DD.MM.YYYY' },
  // Danish
  da: { dow: 2, L: 'DD.MM.YYYY' },
  // Dutch
  nl: { dow: 2, L: 'DD-MM-YYYY' },
  // English (US)
  'en-US': { dow: 1, L: 'MM/DD/YYYY' },
  // English (Australia)
  'en-AU': { dow: 2, L: 'DD/MM/YYYY' },
  // English (Canada)
  'en-CA': { dow: 1, L: 'YYYY-MM-DD' },
  // English (Great Britain)
  'en-GB': { dow: 2, L: 'DD/MM/YYYY' },
  // English (Ireland)
  'en-IE': { dow: 2, L: 'DD-MM-YYYY' },
  // English (New Zealand)
  'en-NZ': { dow: 2, L: 'DD/MM/YYYY' },
  // English (South Africa)
  'en-ZA': { dow: 1, L: 'YYYY/MM/DD' },
  // Esperanto
  eo: { dow: 2, L: 'YYYY-MM-DD' },
  // Estonian
  et: { dow: 2, L: 'DD.MM.YYYY' },
  // Finnish
  fi: { dow: 2, L: 'DD.MM.YYYY' },
  // French
  fr: { dow: 2, L: 'DD/MM/YYYY' },
  // French (Canada)
  'fr-CA': { dow: 1, L: 'YYYY-MM-DD' },
  // French (Switzerland)
  'fr-CH': { dow: 2, L: 'DD.MM.YYYY' },
  // German
  de: { dow: 2, L: 'DD.MM.YYYY' },
  // Hebrew
  he: { dow: 1, L: 'DD.MM.YYYY' },
  // Indonesian
  id: { dow: 2, L: 'DD/MM/YYYY' },
  // Italian
  it: { dow: 2, L: 'DD/MM/YYYY' },
  // Japanese
  ja: { dow: 1, L: 'YYYY年M月D日' },
  // Korean
  ko: { dow: 1, L: 'YYYY.MM.DD' },
  // Latvian
  lv: { dow: 2, L: 'DD.MM.YYYY' },
  // Lithuanian
  lt: { dow: 2, L: 'DD.MM.YYYY' },
  // Macedonian
  mk: { dow: 2, L: 'D.MM.YYYY' },
  // Norwegian
  nb: { dow: 2, L: 'D. MMMM YYYY' },
  nn: { dow: 2, L: 'D. MMMM YYYY' },
  // Polish
  pl: { dow: 2, L: 'DD.MM.YYYY' },
  // Portuguese
  pt: { dow: 2, L: 'DD/MM/YYYY' },
  // Romanian
  ro: { dow: 2, L: 'DD.MM.YYYY' },
  // Russian
  ru: { dow: 2, L: 'DD.MM.YYYY' },
  // Slovak
  sk: { dow: 2, L: 'DD.MM.YYYY' },
  // Spanish (Spain)
  'es-ES': { dow: 2, L: 'DD/MM/YYYY' },
  // Spanish (Mexico)
  'es-MX': { dow: 2, L: 'DD/MM/YYYY' },
  // Swedish
  sv: { dow: 2, L: 'YYYY-MM-DD' },
  // Thai
  th: { dow: 1, L: 'DD/MM/YYYY' },
  // Turkish
  tr: { dow: 2, L: 'DD.MM.YYYY' },
  // Ukrainian
  uk: { dow: 2, L: 'DD.MM.YYYY' },
  // Vietnam
  vi: { dow: 2, L: 'DD/MM/YYYY' },
};
locales.en = locales['en-US'];
locales.es = locales['es-ES'];
locales.no = locales.nb;
locales.zh = locales['zh-CN'];

// Remap from abbr. to intuitive property names
toPairs_default()(locales).forEach(([id, { dow, L }]) => {
  locales[id] = {
    id,
    firstDayOfWeek: dow,
    masks: { L },
  };
});

/* harmony default export */ var defaults_locales = (locales);

;// ./node_modules/v-calendar/src/utils/defaults/index.js
// Vue won't get included in bundle as it is externalized
// https://cli.vuejs.org/guide/build-targets.html#library







const pluginDefaults = {
  componentPrefix: 'v',
  navVisibility: 'click',
  titlePosition: 'center',
  transition: 'slide-h',
  touch: touch_namespaceObject,
  masks: masks_namespaceObject,
  screens: screens_namespaceObject,
  locales: defaults_locales,
  datePicker: {
    updateOnInput: true,
    inputDebounce: 1000,
    popover: {
      visibility: 'hover-focus',
      placement: 'bottom-start',
      keepVisibleOnInput: false,
      isInteractive: true,
    },
  },
};

let defaults_ = null;

const setupDefaults = opts => {
  if (!defaults_) {
    defaults_ = new (external_vue_default())({
      data() {
        return {
          defaults: defaultsDeep_default()(opts, pluginDefaults),
        };
      },
      computed: {
        locales() {
          return mapValues_default()(this.defaults.locales, v => {
            v.masks = defaultsDeep_default()(v.masks, this.defaults.masks);
            return v;
          });
        },
      },
    });
  }
  return defaults_.defaults;
};

const defaultsMixin = {
  beforeCreate() {
    setupDefaults();
  },
  computed: {
    $defaults() {
      return defaults_.defaults;
    },
    $locales() {
      return defaults_.locales;
    },
  },
  methods: {
    propOrDefault(prop, defaultPath, strategy) {
      return this.passedProp(prop, get_default()(this.$defaults, defaultPath), strategy);
    },
    passedProp(prop, fallback, strategy) {
      if (_has(this.$options.propsData, prop)) {
        const propValue = this[prop];
        if (_isObject(propValue) && strategy === 'merge') {
          return defaultsDeep_default()(propValue, fallback);
        }
        return propValue;
      }
      return fallback;
    },
  },
};

;// ./node_modules/v-calendar/src/utils/mixins/child.js


const childMixin = {
  inject: ['sharedState'],
  mixins: [defaultsMixin],
  computed: {
    masks() {
      return this.sharedState.masks;
    },
    theme() {
      return this.sharedState.theme;
    },
    locale() {
      return this.sharedState.locale;
    },
    dayPopoverId() {
      return this.sharedState.dayPopoverId;
    },
  },
  methods: {
    format(date, mask) {
      return this.locale.format(date, mask);
    },
    pageForDate(date) {
      return this.locale.getDateParts(this.locale.normalizeDate(date));
    },
  },
};

;// ./node_modules/v-calendar/src/utils/theme.js


const targetProps = ['base', 'start', 'end', 'startEnd'];
const displayProps = [
  'class',
  'contentClass',
  'style',
  'contentStyle',
  'color',
  'fillMode',
];
const defConfig = {
  color: 'blue',
  isDark: false,
  highlight: {
    base: { fillMode: 'light' },
    start: { fillMode: 'solid' },
    end: { fillMode: 'solid' },
  },
  dot: {
    base: { fillMode: 'solid' },
    start: { fillMode: 'solid' },
    end: { fillMode: 'solid' },
  },
  bar: {
    base: { fillMode: 'solid' },
    start: { fillMode: 'solid' },
    end: { fillMode: 'solid' },
  },
  content: {
    base: {},
    start: {},
    end: {},
  },
};

class Theme {
  constructor(config) {
    Object.assign(this, defConfig, config);
  }

  // Normalizes attribute config to the structure defined by the properties
  normalizeAttr({ config, type }) {
    let rootColor = this.color;
    let root = {};
    // Get the normalized root config
    const normAttr = this[type];
    if (config === true || isString_default()(config)) {
      // Assign default color for booleans or strings
      rootColor = isString_default()(config) ? config : rootColor;
      // Set the default root
      root = { ...normAttr };
    } else if (_isObject(config)) {
      if (hasAny(config, targetProps)) {
        // Mixin target configs
        root = { ...config };
      } else {
        // Mixin display configs
        root = {
          base: { ...config },
          start: { ...config },
          end: { ...config },
        };
      }
    } else {
      return null;
    }
    // Fill in missing targets
    defaults_default()(root, { start: root.startEnd, end: root.startEnd }, normAttr);
    // Normalize each target
    toPairs_default()(root).forEach(([targetType, targetConfig]) => {
      let targetColor = rootColor;
      if (targetConfig === true || isString_default()(targetConfig)) {
        targetColor = isString_default()(targetConfig) ? targetConfig : targetColor;
        root[targetType] = { color: targetColor };
      } else if (_isObject(targetConfig)) {
        if (hasAny(targetConfig, displayProps)) {
          root[targetType] = { ...targetConfig };
        } else {
          root[targetType] = {};
        }
      }
      // Set the theme color if it is missing
      if (!_has(root, `${targetType}.color`)) {
        set_default()(root, `${targetType}.color`, targetColor);
      }
    });
    return root;
  }

  normalizeHighlight(config) {
    const highlight = this.normalizeAttr({
      config,
      type: 'highlight',
    });
    toPairs_default()(highlight).forEach(([_, targetConfig]) => {
      const c = defaults_default()(targetConfig, {
        isDark: this.isDark,
        color: this.color,
      });
      targetConfig.style = {
        ...this.getHighlightBgStyle(c),
        ...targetConfig.style,
      };
      targetConfig.contentStyle = {
        ...this.getHighlightContentStyle(c),
        ...targetConfig.contentStyle,
      };
    });
    return highlight;
  }

  getHighlightBgStyle({ fillMode, color, isDark }) {
    switch (fillMode) {
      case 'outline':
      case 'none':
        return {
          backgroundColor: isDark ? 'var(--gray-900)' : 'var(--white)',
          border: '2px solid',
          borderColor: isDark ? `var(--${color}-200)` : `var(--${color}-700)`,
          borderRadius: 'var(--rounded-full)',
        };
      case 'light':
        return {
          backgroundColor: isDark
            ? `var(--${color}-800)`
            : `var(--${color}-200)`,
          opacity: isDark ? 0.75 : 1,
          borderRadius: 'var(--rounded-full)',
        };
      case 'solid':
        return {
          backgroundColor: isDark
            ? `var(--${color}-500)`
            : `var(--${color}-600)`,
          borderRadius: 'var(--rounded-full)',
        };
      default:
        return {
          borderRadius: 'var(--rounded-full)',
        };
    }
  }

  getHighlightContentStyle({ fillMode, color, isDark }) {
    switch (fillMode) {
      case 'outline':
      case 'none':
        return {
          fontWeight: 'var(--font-bold)',
          color: isDark ? `var(--${color}-100)` : `var(--${color}-900)`,
        };
      case 'light':
        return {
          fontWeight: 'var(--font-bold)',
          color: isDark ? `var(--${color}-100)` : `var(--${color}-900)`,
        };
      case 'solid':
        return {
          fontWeight: 'var(--font-bold)',
          color: 'var(--white)',
        };
      default:
        return '';
    }
  }

  bgAccentHigh({ color, isDark }) {
    return {
      backgroundColor: isDark ? `var(--${color}-500)` : `var(--${color}-600)`,
    };
  }

  contentAccent({ color, isDark }) {
    if (!color) return null;
    return {
      fontWeight: 'var(--font-bold)',
      color: isDark ? `var(--${color}-100)` : `var(--${color}-900)`,
    };
  }

  normalizeDot(config) {
    return this.normalizeNonHighlight('dot', config, this.bgAccentHigh);
  }

  normalizeBar(config) {
    return this.normalizeNonHighlight('bar', config, this.bgAccentHigh);
  }

  normalizeContent(config) {
    return this.normalizeNonHighlight('content', config, this.contentAccent);
  }

  normalizeNonHighlight(type, config, styleFn) {
    const attr = this.normalizeAttr({ type, config });
    toPairs_default()(attr).forEach(([_, targetConfig]) => {
      defaults_default()(targetConfig, { isDark: this.isDark, color: this.color });
      targetConfig.style = {
        ...styleFn(targetConfig),
        ...targetConfig.style,
      };
    });
    return attr;
  }
}

// EXTERNAL MODULE: ./node_modules/date-fns-tz/toDate/index.js
var date_fns_tz_toDate = __webpack_require__(8305);
var toDate_default = /*#__PURE__*/__webpack_require__.n(date_fns_tz_toDate);
;// ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}
;// ./node_modules/date-fns/esm/startOfWeek/index.js




/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// ./node_modules/date-fns/esm/startOfISOWeek/index.js


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
;// ./node_modules/date-fns/esm/getISOWeekYear/index.js



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// ./node_modules/date-fns/esm/startOfISOWeekYear/index.js



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}
;// ./node_modules/date-fns/esm/getISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
;// ./node_modules/date-fns/esm/getWeekYear/index.js





/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the local week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// ./node_modules/date-fns/esm/startOfWeekYear/index.js





/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the start of a week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date = startOfWeek(firstWeek, options);
  return date;
}
;// ./node_modules/date-fns/esm/getWeek/index.js




var getWeek_MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfWeek(date, options).getTime() - startOfWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / getWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
;// ./node_modules/date-fns/esm/differenceInCalendarWeeks/index.js



var differenceInCalendarWeeks_MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */
function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
  requiredArgs(2, arguments);
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, options);
  var startOfWeekRight = startOfWeek(dirtyDateRight, options);
  var timestampLeft = startOfWeekLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - getTimezoneOffsetInMilliseconds(startOfWeekRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / differenceInCalendarWeeks_MILLISECONDS_IN_WEEK);
}
;// ./node_modules/date-fns/esm/lastDayOfMonth/index.js


/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// ./node_modules/date-fns/esm/startOfMonth/index.js


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// ./node_modules/date-fns/esm/getWeeksInMonth/index.js




/**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */
function getWeeksInMonth(date, options) {
  requiredArgs(1, arguments);
  return differenceInCalendarWeeks(lastDayOfMonth(date), startOfMonth(date), options) + 1;
}
;// ./node_modules/v-calendar/src/utils/dateInfo.js
/* eslint-disable import/no-cycle */





const millisecondsPerDay = 24 * 60 * 60 * 1000;

class DateInfo {
  constructor(config, { order = 0, locale, isFullDay } = {}) {
    this.isDateInfo = true;
    this.order = order;
    this.locale = locale instanceof Locale ? locale : new Locale(locale);
    this.firstDayOfWeek = this.locale.firstDayOfWeek;

    // Adjust config for simple dates
    if (!_isObject(config)) {
      const date = this.locale.normalizeDate(config);
      if (isFullDay) {
        config = {
          start: date,
          end: date,
        };
      } else {
        config = {
          startOn: date,
          endOn: date,
        };
      }
    }

    let start = null;
    let end = null;
    if (config.start) {
      start = this.locale.normalizeDate(config.start, {
        ...this.opts,
        time: '00:00:00',
      });
    } else if (config.startOn) {
      start = this.locale.normalizeDate(config.startOn, this.opts);
    }
    if (config.end) {
      end = this.locale.normalizeDate(config.end, {
        ...this.opts,
        time: '23:59:59',
      });
    } else if (config.endOn) {
      end = this.locale.normalizeDate(config.endOn, this.opts);
    }

    // Reconfigure start and end dates if needed
    if (start && end && start > end) {
      const temp = start;
      start = end;
      end = temp;
    } else if (start && config.span >= 1) {
      end = addDays(start, config.span - 1);
    }

    // Assign start and end dates
    this.start = start;
    this.startTime = start ? start.getTime() : NaN;
    this.end = end;
    this.endTime = end ? end.getTime() : NaN;
    this.isDate = this.startTime && this.startTime === this.endTime;
    this.isRange = !this.isDate;

    // Assign 'and' condition
    const andOpt = mixinOptionalProps(config, {}, DateInfo.patternProps);
    if (andOpt.assigned) {
      this.on = { and: andOpt.target };
    }
    // Assign 'or' conditions
    if (config.on) {
      const or = (isArrayLikeObject_default()(config.on) ? config.on : [config.on])
        .map(o => {
          if (isFunction_default()(o)) return o;
          const opt = mixinOptionalProps(o, {}, DateInfo.patternProps);
          return opt.assigned ? opt.target : null;
        })
        .filter(o => o);
      if (or.length) this.on = { ...this.on, or };
    }
    // Assign flag if date is complex
    this.isComplex = !!this.on;
  }

  get opts() {
    return {
      order: this.order,
      locale: this.locale,
    };
  }

  toDateInfo(date) {
    return date.isDateInfo ? date : new DateInfo(date, this.opts);
  }

  startOfWeek(date) {
    const day = date.getDay() + 1;
    const daysToAdd =
      day >= this.firstDayOfWeek
        ? this.firstDayOfWeek - day
        : -(7 - (this.firstDayOfWeek - day));
    return addDays(date, daysToAdd);
  }

  diffInDays(d1, d2) {
    return Math.round((d2 - d1) / millisecondsPerDay);
  }

  diffInWeeks(d1, d2) {
    return this.diffInDays(this.startOfWeek(d1), this.startOfWeek(d2));
  }

  diffInYears(d1, d2) {
    return d2.getUTCFullYear() - d1.getUTCFullYear();
  }

  diffInMonths(d1, d2) {
    return this.diffInYears(d1, d2) * 12 + (d2.getMonth() - d1.getMonth());
  }

  static get patterns() {
    return {
      dailyInterval: {
        test: (day, interval, di) =>
          di.diffInDays(di.start || new Date(), day.date) % interval === 0,
      },
      weeklyInterval: {
        test: (day, interval, di) =>
          di.diffInWeeks(di.start || new Date(), day.date) % interval === 0,
      },
      monthlyInterval: {
        test: (day, interval, di) =>
          di.diffInMonths(di.start || new Date(), day.date) % interval === 0,
      },
      yearlyInterval: {
        test: () => (day, interval, di) =>
          di.diffInYears(di.start || new Date(), day.date) % interval === 0,
      },
      days: {
        validate: days => (isArrayLikeObject_default()(days) ? days : [parseInt(days, 10)]),
        test: (day, days) =>
          days.includes(day.day) || days.includes(-day.dayFromEnd),
      },
      weekdays: {
        validate: weekdays =>
          isArrayLikeObject_default()(weekdays) ? weekdays : [parseInt(weekdays, 10)],
        test: (day, weekdays) => weekdays.includes(day.weekday),
      },
      ordinalWeekdays: {
        validate: ordinalWeekdays =>
          Object.keys(ordinalWeekdays).reduce((obj, ck) => {
            const weekdays = ordinalWeekdays[ck];
            if (!weekdays) return obj;
            obj[ck] = isArrayLikeObject_default()(weekdays) ? weekdays : [parseInt(weekdays, 10)];
            return obj;
          }, {}),
        test: (day, ordinalWeekdays) =>
          Object.keys(ordinalWeekdays)
            .map(k => parseInt(k, 10))
            .find(
              k =>
                ordinalWeekdays[k].includes(day.weekday) &&
                (k === day.weekdayOrdinal || k === -day.weekdayOrdinalFromEnd),
            ),
      },
      weekends: {
        validate: config => config,
        test: day => day.weekday === 1 || day.weekday === 7,
      },
      workweek: {
        validate: config => config,
        test: day => day.weekday >= 2 && day.weekday <= 6,
      },
      weeks: {
        validate: weeks => (isArrayLikeObject_default()(weeks) ? weeks : [parseInt(weeks, 10)]),
        test: (day, weeks) =>
          weeks.includes(day.week) || weeks.includes(-day.weekFromEnd),
      },
      months: {
        validate: months => (isArrayLikeObject_default()(months) ? months : [parseInt(months, 10)]),
        test: (day, months) => months.includes(day.month),
      },
      years: {
        validate: years => (isArrayLikeObject_default()(years) ? years : [parseInt(years, 10)]),
        test: (day, years) => years.includes(day.year),
      },
    };
  }

  static get patternProps() {
    return Object.keys(DateInfo.patterns).map(k => ({
      name: k,
      validate: DateInfo.patterns[k].validate,
    }));
  }

  static testConfig(config, day, dateInfo) {
    if (isFunction_default()(config)) return config(day);
    if (_isObject(config)) {
      return Object.keys(config).every(k =>
        DateInfo.patterns[k].test(day, config[k], dateInfo),
      );
    }
    return null;
  }

  iterateDatesInRange({ start, end }, fn) {
    if (!start || !end || !isFunction_default()(fn)) return null;
    start = this.locale.normalizeDate(start, {
      ...this.opts,
      time: '00:00:00',
    });
    const state = {
      i: 0,
      date: start,
      day: this.locale.getDateParts(start),
      finished: false,
    };
    let result = null;
    for (; !state.finished && state.date <= end; state.i++) {
      result = fn(state);
      state.date = addDays(state.date, 1);
      state.day = this.locale.getDateParts(state.date);
    }
    return result;
  }

  shallowIntersectingRange(other) {
    return this.rangeShallowIntersectingRange(this, this.toDateInfo(other));
  }

  // Returns a date range that intersects two DateInfo objects
  // NOTE: This is a shallow calculation (does not take patterns into account),
  //   so this method should only really be called for special conditions
  //   where absolute accuracy is not necessarily needed
  rangeShallowIntersectingRange(date1, date2) {
    if (!this.dateShallowIntersectsDate(date1, date2)) {
      return null;
    }
    const thisRange = date1.toRange();
    const otherRange = date2.toRange();
    // Start with infinite start and end dates
    let start = null;
    let end = null;
    // This start date exists
    if (thisRange.start) {
      // Use this definite start date if other start date is infinite
      if (!otherRange.start) {
        start = thisRange.start;
      } else {
        // Otherwise, use the latest start date
        start =
          thisRange.start > otherRange.start
            ? thisRange.start
            : otherRange.start;
      }
      // Other start date exists
    } else if (otherRange.start) {
      // Use other definite start date as this one is infinite
      start = otherRange.start;
    }
    // This end date exists
    if (thisRange.end) {
      // Use this definite end date if other end date is infinite
      if (!otherRange.end) {
        end = thisRange.end;
      } else {
        // Otherwise, use the earliest end date
        end = thisRange.end < otherRange.end ? thisRange.end : otherRange.end;
      }
      // Other end date exists
    } else if (otherRange.end) {
      // Use other definite end date as this one is infinite
      end = otherRange.end;
    }
    // Return calculated range
    return { start, end };
  }

  // ========================================================
  // Determines if this date partially intersects another date
  // NOTE: This is a deep test (patterns tested)
  intersectsDate(other) {
    const date = this.toDateInfo(other);
    if (!this.shallowIntersectsDate(date)) return null;
    if (!this.on) return this;
    const range = this.rangeShallowIntersectingRange(this, date);
    let result = false;
    this.iterateDatesInRange(range, state => {
      if (this.matchesDay(state.day)) {
        result = result || date.matchesDay(state.day);
        state.finished = result;
      }
    });
    return result;
  }

  // ========================================================
  // Determines if this date partially intersects another date
  // NOTE: This is a shallow test (no patterns tested)
  shallowIntersectsDate(other) {
    return this.dateShallowIntersectsDate(this, this.toDateInfo(other));
  }

  // ========================================================
  // Determines if first date partially intersects second date
  // NOTE: This is a shallow test (no patterns tested)
  dateShallowIntersectsDate(date1, date2) {
    if (date1.isDate) {
      return date2.isDate
        ? date1.startTime === date2.startTime
        : this.dateShallowIncludesDate(date2, date1);
    }
    if (date2.isDate) {
      return this.dateShallowIncludesDate(date1, date2);
    }
    // Both ranges
    if (date1.start && date2.end && date1.start > date2.end) {
      return false;
    }
    if (date1.end && date2.start && date1.end < date2.start) {
      return false;
    }
    return true;
  }

  // ========================================================
  // Determines if this date completely includes another date
  // NOTE: This is a deep test (patterns tested)
  includesDate(other) {
    const date = this.toDateInfo(other);
    if (!this.shallowIncludesDate(date)) {
      return false;
    }
    if (!this.on) {
      return true;
    }
    const range = this.rangeShallowIntersectingRange(this, date);
    let result = true;
    this.iterateDatesInRange(range, state => {
      if (this.matchesDay(state.day)) {
        result = result && date.matchesDay(state.day);
        state.finished = !result;
      }
    });
    return result;
  }

  // ========================================================
  // Determines if this date completely includes another date
  // NOTE: This is a shallow test (no patterns tested)
  shallowIncludesDate(other) {
    return this.dateShallowIncludesDate(
      this,
      other.isDate ? other : new DateInfo(other, this.opts),
    );
  }

  // ========================================================
  // Determines if first date completely includes second date
  // NOTE: This is a shallow test (no patterns tested)
  dateShallowIncludesDate(date1, date2) {
    // First date is simple date
    if (date1.isDate) {
      if (date2.isDate) {
        return date1.startTime === date2.startTime;
      }
      if (!date2.startTime || !date2.endTime) {
        return false;
      }
      return (
        date1.startTime === date2.startTime && date1.startTime === date2.endTime
      );
    }
    // Second date is simple date and first is date range
    if (date2.isDate) {
      if (date1.start && date2.start < date1.start) {
        return false;
      }
      if (date1.end && date2.start > date1.end) {
        return false;
      }
      return true;
    }
    // Both dates are date ranges
    if (date1.start && (!date2.start || date2.start < date1.start)) {
      return false;
    }
    if (date1.end && (!date2.end || date2.end > date1.end)) {
      return false;
    }
    return true;
  }

  intersectsDay(day) {
    // Date is outside general range - return null
    if (!this.shallowIntersectsDate(day.range)) return null;
    // Return this date if patterns match
    return this.matchesDay(day) ? this : null;
  }

  matchesDay(day) {
    // No patterns to test
    if (!this.on) return true;
    // Fail if 'and' condition fails
    if (this.on.and && !DateInfo.testConfig(this.on.and, day, this)) {
      return false;
    }
    // Fail if every 'or' condition fails
    if (
      this.on.or &&
      !this.on.or.some(or => DateInfo.testConfig(or, day, this))
    ) {
      return false;
    }
    // Patterns match
    return true;
  }

  toRange() {
    return new DateInfo(
      {
        start: this.start,
        end: this.end,
      },
      this.opts,
    );
  }

  // Build the 'compare to other' function
  compare(other) {
    if (this.order !== other.order) return this.order - other.order;
    if (this.isDate !== other.isDate) return this.isDate ? 1 : -1;
    if (this.isDate) return 0;
    const diff = this.start - other.start;
    return diff !== 0 ? diff : this.end - other.end;
  }
}

;// ./node_modules/v-calendar/src/utils/locale.js
/* eslint-disable no-bitwise, no-multi-assign, import/no-cycle */










const PATCH = {
  DATE_TIME: 1,
  DATE: 2,
  TIME: 3,
};

const PATCH_KEYS = {
  1: ['year', 'month', 'day', 'hours', 'minutes', 'seconds', 'milliseconds'],
  2: ['year', 'month', 'day'],
  3: ['hours', 'minutes', 'seconds', 'milliseconds'],
};

const token =
  /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
const twoDigits = /\d\d?/;
const threeDigits = /\d{3}/;
const fourDigits = /\d{4}/;
const word =
  /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
const literal = /\[([^]*?)\]/gm;
const noop = () => {};
const monthUpdate = arrName => (d, v, l) => {
  const index = l[arrName].indexOf(
    v.charAt(0).toUpperCase() + v.substr(1).toLowerCase(),
  );
  if (~index) {
    d.month = index;
  }
};
const maskMacros = ['L', 'iso'];

const daysInWeek = 7;
const daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const hourOptions = [
  { value: 0, label: '00' },
  { value: 1, label: '01' },
  { value: 2, label: '02' },
  { value: 3, label: '03' },
  { value: 4, label: '04' },
  { value: 5, label: '05' },
  { value: 6, label: '06' },
  { value: 7, label: '07' },
  { value: 8, label: '08' },
  { value: 9, label: '09' },
  { value: 10, label: '10' },
  { value: 11, label: '11' },
  { value: 12, label: '12' },
  { value: 13, label: '13' },
  { value: 14, label: '14' },
  { value: 15, label: '15' },
  { value: 16, label: '16' },
  { value: 17, label: '17' },
  { value: 18, label: '18' },
  { value: 19, label: '19' },
  { value: 20, label: '20' },
  { value: 21, label: '21' },
  { value: 22, label: '22' },
  { value: 23, label: '23' },
];
const formatFlags = {
  D(d) {
    return d.day;
  },
  DD(d) {
    return pad(d.day);
  },
  Do(d, l) {
    return l.DoFn(d.day);
  },
  d(d) {
    return d.weekday - 1;
  },
  dd(d) {
    return pad(d.weekday - 1);
  },
  W(d, l) {
    return l.dayNamesNarrow[d.weekday - 1];
  },
  WW(d, l) {
    return l.dayNamesShorter[d.weekday - 1];
  },
  WWW(d, l) {
    return l.dayNamesShort[d.weekday - 1];
  },
  WWWW(d, l) {
    return l.dayNames[d.weekday - 1];
  },
  M(d) {
    return d.month;
  },
  MM(d) {
    return pad(d.month);
  },
  MMM(d, l) {
    return l.monthNamesShort[d.month - 1];
  },
  MMMM(d, l) {
    return l.monthNames[d.month - 1];
  },
  YY(d) {
    return String(d.year).substr(2);
  },
  YYYY(d) {
    return pad(d.year, 4);
  },
  h(d) {
    return d.hours % 12 || 12;
  },
  hh(d) {
    return pad(d.hours % 12 || 12);
  },
  H(d) {
    return d.hours;
  },
  HH(d) {
    return pad(d.hours);
  },
  m(d) {
    return d.minutes;
  },
  mm(d) {
    return pad(d.minutes);
  },
  s(d) {
    return d.seconds;
  },
  ss(d) {
    return pad(d.seconds);
  },
  S(d) {
    return Math.round(d.milliseconds / 100);
  },
  SS(d) {
    return pad(Math.round(d.milliseconds / 10), 2);
  },
  SSS(d) {
    return pad(d.milliseconds, 3);
  },
  a(d, l) {
    return d.hours < 12 ? l.amPm[0] : l.amPm[1];
  },
  A(d, l) {
    return d.hours < 12 ? l.amPm[0].toUpperCase() : l.amPm[1].toUpperCase();
  },
  Z() {
    return 'Z';
  },
  ZZ(d) {
    const o = d.timezoneOffset;
    return `${o > 0 ? '-' : '+'}${pad(Math.floor(Math.abs(o) / 60), 2)}`;
  },
  ZZZ(d) {
    const o = d.timezoneOffset;
    return `${o > 0 ? '-' : '+'}${pad(
      Math.floor(Math.abs(o) / 60) * 100 + (Math.abs(o) % 60),
      4,
    )}`;
  },
  ZZZZ(d) {
    const o = d.timezoneOffset;
    return `${o > 0 ? '-' : '+'}${pad(Math.floor(Math.abs(o) / 60), 2)}:${pad(
      Math.abs(o) % 60,
      2,
    )}`;
  },
};
const parseFlags = {
  D: [
    twoDigits,
    (d, v) => {
      d.day = v;
    },
  ],
  Do: [
    new RegExp(twoDigits.source + word.source),
    (d, v) => {
      d.day = parseInt(v, 10);
    },
  ],
  d: [twoDigits, noop],
  W: [word, noop],
  M: [
    twoDigits,
    (d, v) => {
      d.month = v - 1;
    },
  ],
  MMM: [word, monthUpdate('monthNamesShort')],
  MMMM: [word, monthUpdate('monthNames')],
  YY: [
    twoDigits,
    (d, v) => {
      const da = new Date();
      const cent = +da.getFullYear().toString().substr(0, 2);
      d.year = `${v > 68 ? cent - 1 : cent}${v}`;
    },
  ],
  YYYY: [
    fourDigits,
    (d, v) => {
      d.year = v;
    },
  ],
  S: [
    /\d/,
    (d, v) => {
      d.millisecond = v * 100;
    },
  ],
  SS: [
    /\d{2}/,
    (d, v) => {
      d.millisecond = v * 10;
    },
  ],
  SSS: [
    threeDigits,
    (d, v) => {
      d.millisecond = v;
    },
  ],
  h: [
    twoDigits,
    (d, v) => {
      d.hour = v;
    },
  ],
  m: [
    twoDigits,
    (d, v) => {
      d.minute = v;
    },
  ],
  s: [
    twoDigits,
    (d, v) => {
      d.second = v;
    },
  ],
  a: [
    word,
    (d, v, l) => {
      const val = v.toLowerCase();
      if (val === l.amPm[0]) {
        d.isPm = false;
      } else if (val === l.amPm[1]) {
        d.isPm = true;
      }
    },
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (d, v) => {
      if (v === 'Z') v = '+00:00';
      const parts = `${v}`.match(/([+-]|\d\d)/gi);
      if (parts) {
        const minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
        d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
      }
    },
  ],
};
parseFlags.DD = parseFlags.D;
parseFlags.dd = parseFlags.d;
parseFlags.WWWW = parseFlags.WWW = parseFlags.WW = parseFlags.W;
parseFlags.MM = parseFlags.M;
parseFlags.mm = parseFlags.m;
parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
parseFlags.ss = parseFlags.s;
parseFlags.A = parseFlags.a;
parseFlags.ZZZZ = parseFlags.ZZZ = parseFlags.ZZ = parseFlags.Z;

function resolveConfig(config, locales) {
  // Get the detected locale string
  const detLocale = new Intl.DateTimeFormat().resolvedOptions().locale;
  // Resolve the locale id
  let id;
  if (isString_default()(config)) {
    id = config;
  } else if (_has(config, 'id')) {
    id = config.id;
  }
  id = (id || detLocale).toLowerCase();
  const localeKeys = Object.keys(locales);
  const validKey = k => localeKeys.find(lk => lk.toLowerCase() === k);
  id = validKey(id) || validKey(id.substring(0, 2)) || detLocale;
  // Add fallback and spread default locale to prevent repetitive update loops
  const defLocale = { ...locales['en-IE'], ...locales[id], id };
  // Assign or merge defaults with provided config
  config = _isObject(config) ? defaultsDeep_default()(config, defLocale) : defLocale;
  // Return resolved config
  return config;
}

class Locale {
  constructor(config, { locales = defaults_locales, timezone } = {}) {
    const { id, firstDayOfWeek, masks } = resolveConfig(config, locales);
    this.id = id;
    this.daysInWeek = daysInWeek;
    this.firstDayOfWeek = clamp_default()(firstDayOfWeek, 1, daysInWeek);
    this.masks = masks;
    this.timezone = timezone || undefined;
    this.dayNames = this.getDayNames('long');
    this.dayNamesShort = this.getDayNames('short');
    this.dayNamesShorter = this.dayNamesShort.map(s => s.substring(0, 2));
    this.dayNamesNarrow = this.getDayNames('narrow');
    this.monthNames = this.getMonthNames('long');
    this.monthNamesShort = this.getMonthNames('short');
    this.amPm = ['am', 'pm'];
    this.monthData = {};
    // Bind methods
    this.getMonthComps = this.getMonthComps.bind(this);
    this.parse = this.parse.bind(this);
    this.format = this.format.bind(this);
    this.toPage = this.toPage.bind(this);
  }

  format(date, mask) {
    date = this.normalizeDate(date);
    if (!date) return '';
    mask = this.normalizeMasks(mask)[0];
    const literals = [];
    // Make literals inactive by replacing them with ??
    mask = mask.replace(literal, ($0, $1) => {
      literals.push($1);
      return '??';
    });
    const timezone = /Z$/.test(mask) ? 'utc' : this.timezone;
    const dateParts = this.getDateParts(date, timezone);
    // Apply formatting rules
    mask = mask.replace(token, $0 =>
      $0 in formatFlags
        ? formatFlags[$0](dateParts, this)
        : $0.slice(1, $0.length - 1),
    );
    // Inline literal values back into the formatted value
    return mask.replace(/\?\?/g, () => literals.shift());
  }

  parse(dateString, mask) {
    const masks = this.normalizeMasks(mask);
    return (
      masks
        .map(m => {
          if (typeof m !== 'string') {
            throw new Error('Invalid mask in fecha.parse');
          }
          // Reset string value
          let str = dateString;
          // Avoid regular expression denial of service, fail early for really long strings
          // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
          if (str.length > 1000) {
            return false;
          }

          let isValid = true;
          const dateInfo = {};
          m.replace(token, $0 => {
            if (parseFlags[$0]) {
              const info = parseFlags[$0];
              const index = str.search(info[0]);
              if (!~index) {
                isValid = false;
              } else {
                str.replace(info[0], result => {
                  info[1](dateInfo, result, this);
                  str = str.substr(index + result.length);
                  return result;
                });
              }
            }

            return parseFlags[$0] ? '' : $0.slice(1, $0.length - 1);
          });

          if (!isValid) {
            return false;
          }

          const today = new Date();
          if (
            dateInfo.isPm === true &&
            dateInfo.hour != null &&
            +dateInfo.hour !== 12
          ) {
            dateInfo.hour = +dateInfo.hour + 12;
          } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
            dateInfo.hour = 0;
          }

          let date;
          if (dateInfo.timezoneOffset != null) {
            dateInfo.minute =
              +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
            date = new Date(
              Date.UTC(
                dateInfo.year || today.getFullYear(),
                dateInfo.month || 0,
                dateInfo.day || 1,
                dateInfo.hour || 0,
                dateInfo.minute || 0,
                dateInfo.second || 0,
                dateInfo.millisecond || 0,
              ),
            );
          } else {
            date = this.getDateFromParts({
              year: dateInfo.year || today.getFullYear(),
              month: (dateInfo.month || 0) + 1,
              day: dateInfo.day || 1,
              hours: dateInfo.hour || 0,
              minutes: dateInfo.minute || 0,
              seconds: dateInfo.second || 0,
              milliseconds: dateInfo.millisecond || 0,
            });
          }
          return date;
        })
        .find(d => d) || new Date(dateString)
    );
  }

  // Normalizes mask(s) as an array with replaced mask macros
  normalizeMasks(masks) {
    return (
      (arrayHasItems(masks) && masks) || [
        (isString_default()(masks) && masks) || 'YYYY-MM-DD',
      ]
    ).map(m =>
      maskMacros.reduce(
        (prev, curr) => prev.replace(curr, this.masks[curr] || ''),
        m,
      ),
    );
  }

  normalizeDate(d, config = {}) {
    let result = null;
    let { type, fillDate } = config;
    const { mask, patch, time } = config;
    const auto = type === 'auto' || !type;
    if (isNumber_default()(d)) {
      type = 'number';
      result = new Date(+d);
    } else if (isString_default()(d)) {
      type = 'string';
      result = d ? this.parse(d, mask || 'iso') : null;
    } else if (_isObject(d)) {
      type = 'object';
      result = this.getDateFromParts(d);
    } else {
      type = 'date';
      result = _isDate(d) ? new Date(d.getTime()) : null;
    }

    if (result && patch) {
      fillDate = fillDate == null ? new Date() : this.normalizeDate(fillDate);
      const parts = {
        ...this.getDateParts(fillDate),
        ...pick_default()(this.getDateParts(result), PATCH_KEYS[patch]),
      };
      result = this.getDateFromParts(parts);
    }
    if (auto) config.type = type;
    if (result && !isNaN(result.getTime())) {
      if (time) {
        result = this.adjustTimeForDate(result, {
          timeAdjust: time,
        });
      }
      return result;
    }
    return null;
  }

  denormalizeDate(date, { type, mask } = {}) {
    switch (type) {
      case 'number':
        return date ? date.getTime() : NaN;
      case 'string':
        return date ? this.format(date, mask || 'iso') : '';
      default:
        return date ? new Date(date) : null;
    }
  }

  hourIsValid(hour, validHours, dateParts) {
    if (!validHours) return true;
    if (isArrayLikeObject_default()(validHours)) return validHours.includes(hour);
    if (_isObject(validHours)) {
      const min = validHours.min || 0;
      const max = validHours.max || 24;
      return min <= hour && max >= hour;
    }
    return validHours(hour, dateParts);
  }

  getHourOptions(validHours, dateParts) {
    return hourOptions.filter(opt =>
      this.hourIsValid(opt.value, validHours, dateParts),
    );
  }

  getMinuteOptions(minuteIncrement) {
    const options = [];
    minuteIncrement = minuteIncrement > 0 ? minuteIncrement : 1;
    for (let i = 0; i <= 59; i += minuteIncrement) {
      options.push({
        value: i,
        label: pad(i, 2),
      });
    }
    return options;
  }

  nearestOptionValue(value, options) {
    if (value == null) return value;
    const result = options.reduce((prev, opt) => {
      if (opt.disabled) return prev;
      if (isNaN(prev)) return opt.value;
      const diffPrev = Math.abs(prev - value);
      const diffCurr = Math.abs(opt.value - value);
      return diffCurr < diffPrev ? opt.value : prev;
    }, NaN);
    return isNaN(result) ? value : result;
  }

  adjustTimeForDate(date, { timeAdjust, validHours, minuteIncrement }) {
    if (!timeAdjust && !validHours && !minuteIncrement) return date;
    const dateParts = this.getDateParts(date);
    if (timeAdjust) {
      if (timeAdjust === 'now') {
        const timeParts = this.getDateParts(new Date());
        dateParts.hours = timeParts.hours;
        dateParts.minutes = timeParts.minutes;
        dateParts.seconds = timeParts.seconds;
        dateParts.milliseconds = timeParts.milliseconds;
      } else {
        const d = new Date(`2000-01-01T${timeAdjust}Z`);
        dateParts.hours = d.getUTCHours();
        dateParts.minutes = d.getUTCMinutes();
        dateParts.seconds = d.getUTCSeconds();
        dateParts.milliseconds = d.getUTCMilliseconds();
      }
    }
    if (validHours) {
      const options = this.getHourOptions(validHours, dateParts);
      dateParts.hours = this.nearestOptionValue(dateParts.hours, options);
    }
    if (minuteIncrement) {
      const options = this.getMinuteOptions(minuteIncrement);
      dateParts.minutes = this.nearestOptionValue(dateParts.minutes, options);
    }
    date = this.getDateFromParts(dateParts);
    return date;
  }

  normalizeDates(dates, opts) {
    opts = opts || {};
    opts.locale = this;
    // Assign dates
    return (isArrayLikeObject_default()(dates) ? dates : [dates])
      .map(d => d && (d instanceof DateInfo ? d : new DateInfo(d, opts)))
      .filter(d => d);
  }

  getDateParts(date, timezone = this.timezone) {
    if (!date) return null;
    let tzDate = date;
    if (timezone) {
      const normDate = new Date(
        date.toLocaleString('en-US', { timeZone: timezone }),
      );
      normDate.setMilliseconds(date.getMilliseconds());
      const diff = normDate.getTime() - date.getTime();
      tzDate = new Date(date.getTime() + diff);
    }
    const milliseconds = tzDate.getMilliseconds();
    const seconds = tzDate.getSeconds();
    const minutes = tzDate.getMinutes();
    const hours = tzDate.getHours();
    const month = tzDate.getMonth() + 1;
    const year = tzDate.getFullYear();
    const comps = this.getMonthComps(month, year);
    const day = tzDate.getDate();
    const dayFromEnd = comps.days - day + 1;
    const weekday = tzDate.getDay() + 1;
    const weekdayOrdinal = Math.floor((day - 1) / 7 + 1);
    const weekdayOrdinalFromEnd = Math.floor((comps.days - day) / 7 + 1);
    const week = Math.ceil(
      (day + Math.abs(comps.firstWeekday - comps.firstDayOfWeek)) / 7,
    );
    const weekFromEnd = comps.weeks - week + 1;
    const parts = {
      milliseconds,
      seconds,
      minutes,
      hours,
      day,
      dayFromEnd,
      weekday,
      weekdayOrdinal,
      weekdayOrdinalFromEnd,
      week,
      weekFromEnd,
      month,
      year,
      date,
      isValid: true,
    };
    parts.timezoneOffset = this.getTimezoneOffset(parts);
    return parts;
  }

  getDateFromParts(parts) {
    if (!parts) return null;
    const d = new Date();
    const {
      year = d.getFullYear(),
      month = d.getMonth() + 1,
      day = d.getDate(),
      hours: hrs = 0,
      minutes: min = 0,
      seconds: sec = 0,
      milliseconds: ms = 0,
    } = parts;

    if (this.timezone) {
      const dateString = `${pad(year, 4)}-${pad(month, 2)}-${pad(day, 2)}T${pad(
        hrs,
        2,
      )}:${pad(min, 2)}:${pad(sec, 2)}.${pad(ms, 3)}`;
      return toDate_default()(dateString, { timeZone: this.timezone });
    }
    return new Date(year, month - 1, day, hrs, min, sec, ms);
  }

  getTimezoneOffset(parts) {
    const {
      year: y,
      month: m,
      day: d,
      hours: hrs = 0,
      minutes: min = 0,
      seconds: sec = 0,
      milliseconds: ms = 0,
    } = parts;
    let date;
    const utcDate = new Date(Date.UTC(y, m - 1, d, hrs, min, sec, ms));
    if (this.timezone) {
      const dateString = `${pad(y, 4)}-${pad(m, 2)}-${pad(d, 2)}T${pad(
        hrs,
        2,
      )}:${pad(min, 2)}:${pad(sec, 2)}.${pad(ms, 3)}`;
      date = toDate_default()(dateString, { timeZone: this.timezone });
    } else {
      date = new Date(y, m - 1, d, hrs, min, sec, ms);
    }
    return (date - utcDate) / 60000;
  }

  toPage(arg, fromPage) {
    if (isNumber_default()(arg)) {
      return addPages(fromPage, arg);
    }
    if (isString_default()(arg)) {
      return this.getDateParts(this.normalizeDate(arg));
    }
    if (_isDate(arg)) {
      return this.getDateParts(arg);
    }
    if (_isObject(arg)) {
      return arg;
    }
    return null;
  }

  getMonthDates(year = 2000) {
    const dates = [];
    for (let i = 0; i < 12; i++) {
      dates.push(new Date(year, i, 15));
    }
    return dates;
  }

  getMonthNames(length) {
    const dtf = new Intl.DateTimeFormat(this.id, {
      month: length,
      timezome: 'UTC',
    });
    return this.getMonthDates().map(d => dtf.format(d));
  }

  getWeekdayDates(firstDayOfWeek = this.firstDayOfWeek) {
    const dates = [];
    const year = 2020;
    const month = 1;
    const day = 5 + firstDayOfWeek - 1;
    for (let i = 0; i < daysInWeek; i++) {
      dates.push(
        this.getDateFromParts({
          year,
          month,
          day: day + i,
          hours: 12,
        }),
      );
    }
    return dates;
  }

  getDayNames(length) {
    const dtf = new Intl.DateTimeFormat(this.id, {
      weekday: length,
      timeZone: this.timezone,
    });
    return this.getWeekdayDates(1).map(d => dtf.format(d));
  }

  // Days/month/year components for a given month and year
  getMonthComps(month, year) {
    const key = `${month}-${year}`;
    let comps = this.monthData[key];
    if (!comps) {
      const inLeapYear =
        (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
      const firstDayOfMonth = new Date(year, month - 1, 1);
      const firstWeekday = firstDayOfMonth.getDay() + 1;
      const days = month === 2 && inLeapYear ? 29 : daysInMonths[month - 1];
      const weekStartsOn = this.firstDayOfWeek - 1;
      const weeks = getWeeksInMonth(firstDayOfMonth, {
        weekStartsOn,
      });
      const weeknumbers = [];
      const isoWeeknumbers = [];
      for (let i = 0; i < weeks; i++) {
        const date = addDays(firstDayOfMonth, i * 7);
        weeknumbers.push(getWeek(date, { weekStartsOn }));
        isoWeeknumbers.push(getISOWeek(date));
      }
      comps = {
        firstDayOfWeek: this.firstDayOfWeek,
        inLeapYear,
        firstWeekday,
        days,
        weeks,
        month,
        year,
        weeknumbers,
        isoWeeknumbers,
      };
      this.monthData[key] = comps;
    }
    return comps;
  }

  // Days/month/year components for today's month
  getThisMonthComps() {
    const { month, year } = this.getDateParts(new Date());
    return this.getMonthComps(month, year);
  }

  // Day/month/year components for previous month
  getPrevMonthComps(month, year) {
    if (month === 1) return this.getMonthComps(12, year - 1);
    return this.getMonthComps(month - 1, year);
  }

  // Day/month/year components for next month
  getNextMonthComps(month, year) {
    if (month === 12) return this.getMonthComps(1, year + 1);
    return this.getMonthComps(month + 1, year);
  }

  getDayId(date) {
    return this.format(date, 'YYYY-MM-DD');
  }

  // Builds day components for a given page
  getCalendarDays({ weeks, monthComps, prevMonthComps, nextMonthComps }) {
    const days = [];
    const { firstDayOfWeek, firstWeekday, isoWeeknumbers, weeknumbers } =
      monthComps;
    const prevMonthDaysToShow =
      firstWeekday +
      (firstWeekday < firstDayOfWeek ? daysInWeek : 0) -
      firstDayOfWeek;
    let prevMonth = true;
    let thisMonth = false;
    let nextMonth = false;
    // Formatter for aria labels
    const formatter = new Intl.DateTimeFormat(this.id, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    // Init counters with previous month's data
    let day = prevMonthComps.days - prevMonthDaysToShow + 1;
    let dayFromEnd = prevMonthComps.days - day + 1;
    let weekdayOrdinal = Math.floor((day - 1) / daysInWeek + 1);
    let weekdayOrdinalFromEnd = 1;
    let week = prevMonthComps.weeks;
    let weekFromEnd = 1;
    let month = prevMonthComps.month;
    let year = prevMonthComps.year;
    // Store todays comps
    const today = new Date();
    const todayDay = today.getDate();
    const todayMonth = today.getMonth() + 1;
    const todayYear = today.getFullYear();
    const dft = (y, m, d) => (hours, minutes, seconds, milliseconds) =>
      this.normalizeDate({
        year: y,
        month: m,
        day: d,
        hours,
        minutes,
        seconds,
        milliseconds,
      });
    // Cycle through 6 weeks (max in month)
    for (let w = 1; w <= weeks; w++) {
      // Cycle through days in week
      for (
        let i = 1, weekday = firstDayOfWeek;
        i <= daysInWeek;
        i++, weekday += weekday === daysInWeek ? 1 - daysInWeek : 1
      ) {
        // We need to know when to start counting actual month days
        if (prevMonth && weekday === firstWeekday) {
          // Reset counters for current month
          day = 1;
          dayFromEnd = monthComps.days;
          weekdayOrdinal = Math.floor((day - 1) / daysInWeek + 1);
          weekdayOrdinalFromEnd = Math.floor(
            (monthComps.days - day) / daysInWeek + 1,
          );
          week = 1;
          weekFromEnd = monthComps.weeks;
          month = monthComps.month;
          year = monthComps.year;
          // ...and flag we're tracking actual month days
          prevMonth = false;
          thisMonth = true;
        }
        // Append day info for the current week
        // Note: this might or might not be an actual month day
        //  We don't know how the UI wants to display various days,
        //  so we'll supply all the data we can
        const dateFromTime = dft(year, month, day);
        const range = {
          start: dateFromTime(0, 0, 0),
          end: dateFromTime(23, 59, 59, 999),
        };
        const date = range.start;
        const id = `${pad(year, 4)}-${pad(month, 2)}-${pad(day, 2)}`;
        const weekdayPosition = i;
        const weekdayPositionFromEnd = daysInWeek - i;
        const weeknumber = weeknumbers[w - 1];
        const isoWeeknumber = isoWeeknumbers[w - 1];
        const isToday =
          day === todayDay && month === todayMonth && year === todayYear;
        const isFirstDay = thisMonth && day === 1;
        const isLastDay = thisMonth && day === monthComps.days;
        const onTop = w === 1;
        const onBottom = w === weeks;
        const onLeft = i === 1;
        const onRight = i === daysInWeek;
        days.push({
          id,
          label: day.toString(),
          ariaLabel: formatter.format(new Date(year, month - 1, day)),
          day,
          dayFromEnd,
          weekday,
          weekdayPosition,
          weekdayPositionFromEnd,
          weekdayOrdinal,
          weekdayOrdinalFromEnd,
          week,
          weekFromEnd,
          weeknumber,
          isoWeeknumber,
          month,
          year,
          dateFromTime,
          date,
          range,
          isToday,
          isFirstDay,
          isLastDay,
          inMonth: thisMonth,
          inPrevMonth: prevMonth,
          inNextMonth: nextMonth,
          onTop,
          onBottom,
          onLeft,
          onRight,
          classes: [
            `id-${id}`,
            `day-${day}`,
            `day-from-end-${dayFromEnd}`,
            `weekday-${weekday}`,
            `weekday-position-${weekdayPosition}`,
            `weekday-ordinal-${weekdayOrdinal}`,
            `weekday-ordinal-from-end-${weekdayOrdinalFromEnd}`,
            `week-${week}`,
            `week-from-end-${weekFromEnd}`,
            {
              'is-today': isToday,
              'is-first-day': isFirstDay,
              'is-last-day': isLastDay,
              'in-month': thisMonth,
              'in-prev-month': prevMonth,
              'in-next-month': nextMonth,
              'on-top': onTop,
              'on-bottom': onBottom,
              'on-left': onLeft,
              'on-right': onRight,
            },
          ],
        });
        // See if we've hit the last day of the month
        if (thisMonth && isLastDay) {
          thisMonth = false;
          nextMonth = true;
          // Reset counters to next month's data
          day = 1;
          dayFromEnd = nextMonthComps.days;
          weekdayOrdinal = 1;
          weekdayOrdinalFromEnd = Math.floor(
            (nextMonthComps.days - day) / daysInWeek + 1,
          );
          week = 1;
          weekFromEnd = nextMonthComps.weeks;
          month = nextMonthComps.month;
          year = nextMonthComps.year;
          // Still in the middle of the month (hasn't ended yet)
        } else {
          day++;
          dayFromEnd--;
          weekdayOrdinal = Math.floor((day - 1) / daysInWeek + 1);
          weekdayOrdinalFromEnd = Math.floor(
            (monthComps.days - day) / daysInWeek + 1,
          );
        }
      }
      // Append week days
      week++;
      weekFromEnd--;
    }
    return days;
  }
}

;// ./node_modules/v-calendar/src/utils/buildMediaQuery.js


// This function gratuitously borrowed from TailwindCSS
// https://github.com/tailwindcss/tailwindcss/blob/master/src/util/buildMediaQuery.js
function buildMediaQuery(screens) {
  // Default min width
  if (isString_default()(screens)) {
    screens = { min: screens };
  }
  // Wrap in array
  if (!isArrayLikeObject_default()(screens)) {
    screens = [screens];
  }
  return screens
    .map(screen => {
      if (_has(screen, 'raw')) {
        return screen.raw;
      }
      return map_default()(screen, (value, feature) => {
        feature = get_default()(
          {
            min: 'min-width',
            max: 'max-width',
          },
          feature,
          feature,
        );
        return `(${feature}: ${value})`;
      }).join(' and ');
    })
    .join(', ');
}

;// ./node_modules/v-calendar/src/utils/screens.js
// Vue won't get included in bundle as it is externalized
// https://cli.vuejs.org/guide/build-targets.html#library





let isSettingUp = false;
let shouldRefreshQueries = false;
let screensComp = null;

function setupScreens(screens = screens_namespaceObject, forceSetup) {
  if ((screensComp && !forceSetup) || isSettingUp) {
    return;
  }
  isSettingUp = true;
  shouldRefreshQueries = true;
  // Use a private Vue component to store reactive screen matches
  screensComp = new (external_vue_default())({
    data() {
      return {
        matches: [],
        queries: [],
      };
    },
    methods: {
      refreshQueries() {
        if (!window || !window.matchMedia) return;
        this.queries = mapValues_default()(screens, v => {
          const query = window.matchMedia(buildMediaQuery(v));
          if (isFunction_default()(query.addEventListener)) {
            query.addEventListener('change', this.refreshMatches);
          } else {
            // Deprecated 'MediaQueryList' API, <Safari 14, <Edge 16
            query.addListener(this.refreshMatches);
          }
          return query;
        });
        this.refreshMatches();
      },
      refreshMatches() {
        this.matches = toPairs_default()(this.queries)
          .filter(p => p[1].matches)
          .map(p => p[0]);
      },
    },
  });
  isSettingUp = false;
}

// Global mixin that provides responsive '$screens' utility method
// that refreshes any time the screen matches update
external_vue_default().mixin({
  beforeCreate() {
    if (!isSettingUp) {
      setupScreens();
    }
  },
  mounted() {
    if (shouldRefreshQueries && screensComp) {
      screensComp.refreshQueries();
      shouldRefreshQueries = false;
    }
  },
  computed: {
    $screens() {
      return (config, def) =>
        screensComp.matches.reduce(
          (prev, curr) => (_has(config, curr) ? config[curr] : prev),
          isUndefined_default()(def) ? config.default : def,
        );
    },
  },
});

;// ./node_modules/v-calendar/src/utils/attribute.js




class Attribute {
  constructor(
    {
      key,
      hashcode,
      highlight,
      content,
      dot,
      bar,
      popover,
      dates,
      excludeDates,
      excludeMode,
      customData,
      order,
      pinPage,
    },
    theme,
    locale,
  ) {
    this.key = isUndefined_default()(key) ? createGuid() : key;
    this.hashcode = hashcode;
    this.customData = customData;
    this.order = order || 0;
    this.dateOpts = { order, locale };
    this.pinPage = pinPage;
    // Normalize attribute types
    if (highlight) {
      this.highlight = theme.normalizeHighlight(highlight);
    }
    if (content) {
      this.content = theme.normalizeContent(content);
    }
    if (dot) {
      this.dot = theme.normalizeDot(dot);
    }
    if (bar) {
      this.bar = theme.normalizeBar(bar);
    }
    if (popover) {
      this.popover = popover;
    }
    // Assign dates
    this.dates = locale.normalizeDates(dates, this.dateOpts);
    this.hasDates = !!arrayHasItems(this.dates);
    // Assign exclude dates
    this.excludeDates = locale.normalizeDates(excludeDates, this.dateOpts);
    this.hasExcludeDates = !!arrayHasItems(this.excludeDates);
    this.excludeMode = excludeMode || 'intersects';
    // Add infinite date range if excluded dates exist
    if (this.hasExcludeDates && !this.hasDates) {
      this.dates.push(new DateInfo({}, this.dateOpts));
      this.hasDates = true;
    }
    this.isComplex = _some(this.dates, d => d.isComplex);
  }

  // Accepts: Date or date range object
  // Returns: First date that partially intersects the given date
  intersectsDate(date) {
    date = date instanceof DateInfo ? date : new DateInfo(date, this.dateOpts);
    return (
      !this.excludesDate(date) &&
      (this.dates.find(d => d.intersectsDate(date)) || false)
    );
  }

  // Accepts: Date or date range object
  // Returns: First date that completely includes the given date
  includesDate(date) {
    date = date instanceof DateInfo ? date : new DateInfo(date, this.dateOpts);
    return (
      !this.excludesDate(date) &&
      (this.dates.find(d => d.includesDate(date)) || false)
    );
  }

  excludesDate(date) {
    date = date instanceof DateInfo ? date : new DateInfo(date, this.dateOpts);
    return (
      this.hasExcludeDates &&
      this.excludeDates.find(
        ed =>
          (this.excludeMode === 'intersects' && ed.intersectsDate(date)) ||
          (this.excludeMode === 'includes' && ed.includesDate(date)),
      )
    );
  }

  // Accepts: Day object
  // Returns: First attribute date info that occurs on given day.
  intersectsDay(day) {
    return (
      !this.excludesDay(day) &&
      (this.dates.find(d => d.intersectsDay(day)) || false)
    );
  }

  excludesDay(day) {
    return (
      this.hasExcludeDates &&
      this.excludeDates.find(ed => ed.intersectsDay(day))
    );
  }
}

;// ./node_modules/v-calendar/src/utils/mixins/root.js







const rootMixin = {
  mixins: [defaultsMixin],
  props: {
    color: String,
    isDark: Boolean,
    firstDayOfWeek: Number,
    masks: Object,
    locale: [String, Object],
    timezone: String,
    minDate: null,
    maxDate: null,
    minDateExact: null,
    maxDateExact: null,
    disabledDates: null,
    availableDates: null,
    theme: null,
  },
  computed: {
    $theme() {
      // Return the theme prop if it is an instance of the Theme class
      if (this.theme instanceof Theme) return this.theme;
      // Create the theme
      return new Theme({
        color: this.passedProp('color', 'blue'),
        isDark: this.passedProp('isDark', false),
      });
    },
    $locale() {
      // Return the locale prop if it is an instance of the Locale class
      if (this.locale instanceof Locale) return this.locale;
      // Build up a base config from component props
      const config = _isObject(this.locale)
        ? this.locale
        : {
            id: this.locale,
            firstDayOfWeek: this.firstDayOfWeek,
            masks: this.masks,
          };
      // Return new locale
      return new Locale(config, {
        locales: this.$locales,
        timezone: this.timezone,
      });
    },
    disabledDates_() {
      const dates = this.normalizeDates(this.disabledDates);
      const { minDate, minDateExact, maxDate, maxDateExact } = this;
      // Add disabled range for min date
      if (minDateExact || minDate) {
        const end = minDateExact
          ? this.normalizeDate(minDateExact)
          : this.normalizeDate(minDate, { time: '00:00:00' });
        dates.push({
          start: null,
          end: new Date(end.getTime() - 1000),
        });
      }
      // Add disabled range for min date
      if (maxDateExact || maxDate) {
        const start = maxDateExact
          ? this.normalizeDate(maxDateExact)
          : this.normalizeDate(maxDate, { time: '23:59:59' });
        dates.push({
          start: new Date(start.getTime() + 1000),
          end: null,
        });
      }
      return dates;
    },
    availableDates_() {
      return this.normalizeDates(this.availableDates);
    },
    disabledAttribute() {
      return new Attribute(
        {
          key: 'disabled',
          dates: this.disabledDates_,
          excludeDates: this.availableDates_,
          excludeMode: 'includes',
          order: 100,
        },
        this.$theme,
        this.$locale,
      );
    },
  },
  created() {
    setupScreens(this.$defaults.screens);
  },
  methods: {
    formatDate(date, mask) {
      return this.$locale ? this.$locale.format(date, mask) : '';
    },
    parseDate(text, mask) {
      if (!this.$locale) return null;
      const value = this.$locale.parse(text, mask);
      return _isDate(value) ? value : null;
    },
    normalizeDate(date, config) {
      return this.$locale ? this.$locale.normalizeDate(date, config) : date;
    },
    normalizeDates(dates) {
      return this.$locale.normalizeDates(dates, {
        isFullDay: true,
      });
    },
    pageForDate(date) {
      return this.$locale.getDateParts(this.normalizeDate(date));
    },
    pageForThisMonth() {
      return this.pageForDate(new Date());
    },
  },
};

;// ./node_modules/v-calendar/src/utils/mixins/safeScopedSlot.js


const safeScopedSlotMixin = {
  methods: {
    safeScopedSlot(name, args, def = null) {
      return isFunction_default()(this.$scopedSlots[name])
        ? this.$scopedSlots[name](args)
        : def;
    },
  },
};

;// ./node_modules/v-calendar/src/utils/mixins/index.js




const mixins_childMixin = childMixin;
const mixins_rootMixin = rootMixin;
const mixins_safeScopedSlotMixin = safeScopedSlotMixin;

;// ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/PopoverRow.vue?vue&type=script&lang=js



/* harmony default export */ var PopoverRowvue_type_script_lang_js = ({
  name: 'PopoverRow',
  mixins: [mixins_childMixin],
  props: {
    attribute: Object,
  },
  computed: {
    indicator() {
      const { highlight, dot, bar, popover } = this.attribute;
      if (popover && popover.hideIndicator) return null;
      if (highlight) {
        const { color, isDark } = highlight.start;
        return {
          style: {
            ...this.theme.bgAccentHigh({
              color,
              isDark: !isDark,
            }),
            width: '10px',
            height: '5px',
            borderRadius: '3px',
          },
        };
      }
      if (dot) {
        const { color, isDark } = dot.start;
        return {
          style: {
            ...this.theme.bgAccentHigh({
              color,
              isDark: !isDark,
            }),
            width: '5px',
            height: '5px',
            borderRadius: '50%',
          },
        };
      }
      if (bar) {
        const { color, isDark } = bar.start;
        return {
          style: {
            ...this.theme.bgAccentHigh({
              color,
              isDark: !isDark,
            }),
            width: '10px',
            height: '3px',
          },
        };
      }
      return null;
    },
  },
});

;// ./node_modules/v-calendar/src/components/PopoverRow.vue?vue&type=script&lang=js
 /* harmony default export */ var components_PopoverRowvue_type_script_lang_js = (PopoverRowvue_type_script_lang_js); 
;// ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-17.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-17.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-17.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/PopoverRow.vue?vue&type=style&index=0&id=0ccf1808&prod&lang=postcss&scoped=true
// extracted by mini-css-extract-plugin

;// ./node_modules/v-calendar/src/components/PopoverRow.vue?vue&type=style&index=0&id=0ccf1808&prod&lang=postcss&scoped=true

;// ./node_modules/v-calendar/src/components/PopoverRow.vue



;


/* normalize component */

var PopoverRow_component = normalizeComponent(
  components_PopoverRowvue_type_script_lang_js,
  PopoverRowvue_type_template_id_0ccf1808_scoped_true_render,
  PopoverRowvue_type_template_id_0ccf1808_scoped_true_staticRenderFns,
  false,
  null,
  "0ccf1808",
  null
  
)

/* harmony default export */ var PopoverRow = (PopoverRow_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/CalendarNav.vue?vue&type=template&id=15dac2d0
var CalendarNavvue_type_template_id_15dac2d0_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vc-nav-container"},[_c('div',{staticClass:"vc-nav-header"},[_c('span',{staticClass:"vc-nav-arrow is-left",class:{ 'is-disabled': !_vm.prevItemsEnabled },attrs:{"role":"button","tabindex":_vm.prevItemsEnabled ? 0 : undefined},on:{"click":_vm.movePrev,"keydown":e => _vm.onSpaceOrEnter(e, _vm.movePrev)}},[_vm._t("nav-left-button",function(){return [_c('svg-icon',{attrs:{"name":"left-arrow","width":"20px","height":"24px"}})]})],2),_c('span',{staticClass:"vc-nav-title vc-grid-focus",style:({ whiteSpace: 'nowrap' }),attrs:{"role":"button","tabindex":"0"},on:{"click":_vm.toggleMode,"keydown":e => _vm.onSpaceOrEnter(e, _vm.toggleMode)}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('span',{staticClass:"vc-nav-arrow is-right",class:{ 'is-disabled': !_vm.nextItemsEnabled },attrs:{"role":"button","tabindex":_vm.nextItemsEnabled ? 0 : undefined},on:{"click":_vm.moveNext,"keydown":e => _vm.onSpaceOrEnter(e, _vm.moveNext)}},[_vm._t("nav-right-button",function(){return [_c('svg-icon',{attrs:{"name":"right-arrow","width":"20px","height":"24px"}})]})],2)]),_c('div',{staticClass:"vc-nav-items"},_vm._l((_vm.activeItems),function(item){return _c('span',{key:item.label,class:_vm.getItemClasses(item),attrs:{"role":"button","data-id":item.id,"aria-label":item.ariaLabel,"tabindex":item.isDisabled ? undefined : 0},on:{"click":item.click,"keydown":e => _vm.onSpaceOrEnter(e, item.click)}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)])
}
var CalendarNavvue_type_template_id_15dac2d0_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/SvgIcon.vue?vue&type=template&id=2dc3d192&scoped=true
var SvgIconvue_type_template_id_2dc3d192_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({staticClass:"vc-svg-icon",attrs:{"width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox}},_vm.$listeners),[_c('path',{attrs:{"d":_vm.path}})])
}
var SvgIconvue_type_template_id_2dc3d192_scoped_true_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/SvgIcon.vue?vue&type=script&lang=js

const _defSize = '26px';
const _defViewBox = '0 0 32 32';

const icons = {
  'left-arrow': {
    viewBox: '0 -1 16 34',
    path:
      'M11.196 10c0 0.143-0.071 0.304-0.179 0.411l-7.018 7.018 7.018 7.018c0.107 0.107 0.179 0.268 0.179 0.411s-0.071 0.304-0.179 0.411l-0.893 0.893c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-8.321-8.321c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l8.321-8.321c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l0.893 0.893c0.107 0.107 0.179 0.25 0.179 0.411z',
  },
  'right-arrow': {
    viewBox: '-5 -1 16 34',
    path:
      'M10.625 17.429c0 0.143-0.071 0.304-0.179 0.411l-8.321 8.321c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-0.893-0.893c-0.107-0.107-0.179-0.25-0.179-0.411 0-0.143 0.071-0.304 0.179-0.411l7.018-7.018-7.018-7.018c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l0.893-0.893c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l8.321 8.321c0.107 0.107 0.179 0.268 0.179 0.411z',
  },
};

/* harmony default export */ var SvgIconvue_type_script_lang_js = ({
  props: ['name'],
  data() {
    return {
      width: _defSize,
      height: _defSize,
      viewBox: _defViewBox,
      path: '',
      isBaseline: false,
    };
  },
  mounted() {
    this.updateIcon();
  },
  watch: {
    name() {
      this.updateIcon();
    },
  },
  methods: {
    updateIcon() {
      const icon = icons[this.name];
      if (icon) {
        this.width = icon.width || _defSize;
        this.height = icon.height || _defSize;
        this.viewBox = icon.viewBox;
        this.path = icon.path;
      }
    },
  },
});

;// ./node_modules/v-calendar/src/components/SvgIcon.vue?vue&type=script&lang=js
 /* harmony default export */ var components_SvgIconvue_type_script_lang_js = (SvgIconvue_type_script_lang_js); 
;// ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-17.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-17.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-17.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/SvgIcon.vue?vue&type=style&index=0&id=2dc3d192&prod&lang=postcss&scoped=true
// extracted by mini-css-extract-plugin

;// ./node_modules/v-calendar/src/components/SvgIcon.vue?vue&type=style&index=0&id=2dc3d192&prod&lang=postcss&scoped=true

;// ./node_modules/v-calendar/src/components/SvgIcon.vue



;


/* normalize component */

var SvgIcon_component = normalizeComponent(
  components_SvgIconvue_type_script_lang_js,
  SvgIconvue_type_template_id_2dc3d192_scoped_true_render,
  SvgIconvue_type_template_id_2dc3d192_scoped_true_staticRenderFns,
  false,
  null,
  "2dc3d192",
  null
  
)

/* harmony default export */ var SvgIcon = (SvgIcon_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/CalendarNav.vue?vue&type=script&lang=js






const _yearGroupCount = 12;

/* harmony default export */ var CalendarNavvue_type_script_lang_js = ({
  name: 'CalendarNav',
  components: {
    SvgIcon: SvgIcon,
  },
  mixins: [mixins_childMixin],
  props: {
    value: { type: Object, default: () => ({ month: 0, year: 0 }) },
    validator: { type: Function, default: () => () => true },
  },
  data() {
    return {
      monthMode: true,
      yearIndex: 0,
      yearGroupIndex: 0,
      onSpaceOrEnter: onSpaceOrEnter,
    };
  },
  computed: {
    month() {
      return this.value ? this.value.month || 0 : 0;
    },
    year() {
      return this.value ? this.value.year || 0 : 0;
    },
    title() {
      return this.monthMode
        ? this.yearIndex
        : `${this.firstYear} - ${this.lastYear}`;
    },
    monthItems() {
      return this.getMonthItems(this.yearIndex);
    },
    yearItems() {
      return this.getYearItems(this.yearGroupIndex);
    },
    prevItemsEnabled() {
      return this.monthMode
        ? this.prevMonthItemsEnabled
        : this.prevYearItemsEnabled;
    },
    nextItemsEnabled() {
      return this.monthMode
        ? this.nextMonthItemsEnabled
        : this.nextYearItemsEnabled;
    },
    prevMonthItemsEnabled() {
      return this.getMonthItems(this.yearIndex - 1).some(i => !i.isDisabled);
    },
    nextMonthItemsEnabled() {
      return this.getMonthItems(this.yearIndex + 1).some(i => !i.isDisabled);
    },
    prevYearItemsEnabled() {
      return this.getYearItems(this.yearGroupIndex - 1).some(
        i => !i.isDisabled,
      );
    },
    nextYearItemsEnabled() {
      return this.getYearItems(this.yearGroupIndex + 1).some(
        i => !i.isDisabled,
      );
    },
    activeItems() {
      return this.monthMode ? this.monthItems : this.yearItems;
    },
    firstYear() {
      return head_default()(this.yearItems.map(i => i.year));
    },
    lastYear() {
      return last_default()(this.yearItems.map(i => i.year));
    },
  },
  watch: {
    year() {
      this.yearIndex = this.year;
    },
    yearIndex(val) {
      this.yearGroupIndex = this.getYearGroupIndex(val);
    },
    value() {
      this.focusFirstItem();
    },
  },
  created() {
    this.yearIndex = this.year;
  },
  mounted() {
    this.focusFirstItem();
  },
  methods: {
    focusFirstItem() {
      this.$nextTick(() => {
        // Set focus on the first enabled nav item
        const focusableEl = this.$el.querySelector(
          '.vc-nav-item:not(.is-disabled)',
        );
        if (focusableEl) {
          focusableEl.focus();
        }
      });
    },
    getItemClasses({ isActive, isCurrent, isDisabled }) {
      const classes = ['vc-nav-item'];
      if (isActive) {
        classes.push('is-active');
      } else if (isCurrent) {
        classes.push('is-current');
      }
      if (isDisabled) {
        classes.push('is-disabled');
      }
      return classes;
    },
    getYearGroupIndex(year) {
      return Math.floor(year / _yearGroupCount);
    },
    getMonthItems(year) {
      const { month: thisMonth, year: thisYear } = this.pageForDate(new Date());
      return this.locale.getMonthDates().map((d, i) => {
        const month = i + 1;
        return {
          month,
          year,
          id: `${year}.${pad(month, 2)}`,
          label: this.locale.format(d, this.masks.navMonths),
          ariaLabel: this.locale.format(d, 'MMMM YYYY'),
          isActive: month === this.month && year === this.year,
          isCurrent: month === thisMonth && year === thisYear,
          isDisabled: !this.validator({ month, year }),
          click: () => this.monthClick(month, year),
        };
      });
    },
    getYearItems(yearGroupIndex) {
      const { _, year: thisYear } = this.pageForDate(new Date());
      const startYear = yearGroupIndex * _yearGroupCount;
      const endYear = startYear + _yearGroupCount;
      const items = [];
      for (let year = startYear; year < endYear; year += 1) {
        let enabled = false;
        for (let month = 1; month < 12; month++) {
          enabled = this.validator({ month, year });
          if (enabled) break;
        }
        items.push({
          year,
          id: year,
          label: year,
          ariaLabel: year,
          isActive: year === this.year,
          isCurrent: year === thisYear,
          isDisabled: !enabled,
          click: () => this.yearClick(year),
        });
      }
      return items;
    },
    monthClick(month, year) {
      if (this.validator({ month, year })) {
        this.$emit('input', { month, year });
      }
    },
    yearClick(year) {
      this.yearIndex = year;
      this.monthMode = true;
      this.focusFirstItem();
    },
    toggleMode() {
      this.monthMode = !this.monthMode;
    },
    movePrev() {
      if (!this.prevItemsEnabled) return;
      if (this.monthMode) {
        this.movePrevYear();
      }
      this.movePrevYearGroup();
    },
    moveNext() {
      if (!this.nextItemsEnabled) return;
      if (this.monthMode) {
        this.moveNextYear();
      }
      this.moveNextYearGroup();
    },
    movePrevYear() {
      this.yearIndex--;
    },
    moveNextYear() {
      this.yearIndex++;
    },
    movePrevYearGroup() {
      this.yearGroupIndex--;
    },
    moveNextYearGroup() {
      this.yearGroupIndex++;
    },
  },
});

;// ./node_modules/v-calendar/src/components/CalendarNav.vue?vue&type=script&lang=js
 /* harmony default export */ var components_CalendarNavvue_type_script_lang_js = (CalendarNavvue_type_script_lang_js); 
;// ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-17.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-17.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-17.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/CalendarNav.vue?vue&type=style&index=0&id=15dac2d0&prod&lang=postcss
// extracted by mini-css-extract-plugin

;// ./node_modules/v-calendar/src/components/CalendarNav.vue?vue&type=style&index=0&id=15dac2d0&prod&lang=postcss

;// ./node_modules/v-calendar/src/components/CalendarNav.vue



;


/* normalize component */

var CalendarNav_component = normalizeComponent(
  components_CalendarNavvue_type_script_lang_js,
  CalendarNavvue_type_template_id_15dac2d0_render,
  CalendarNavvue_type_template_id_15dac2d0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CalendarNav = (CalendarNav_component.exports);
;// ./node_modules/v-calendar/src/utils/popovers.js


function showPopover(opts) {
  if (document) {
    document.dispatchEvent(
      new CustomEvent('show-popover', {
        detail: opts,
      }),
    );
  }
}

function hidePopover(opts) {
  if (document) {
    document.dispatchEvent(
      new CustomEvent('hide-popover', {
        detail: opts,
      }),
    );
  }
}

function togglePopover(opts) {
  if (document) {
    document.dispatchEvent(
      new CustomEvent('toggle-popover', {
        detail: opts,
      }),
    );
  }
}

function updatePopover(opts) {
  if (document) {
    document.dispatchEvent(
      new CustomEvent('update-popover', {
        detail: opts,
      }),
    );
  }
}

function getPopoverTriggerEvents(opts) {
  const { visibility } = opts;
  const click = visibility === 'click';
  const hover = visibility === 'hover';
  const hoverFocus = visibility === 'hover-focus';
  const focus = visibility === 'focus';
  opts.autoHide = !click;
  let hovered = false;
  let focused = false;
  return {
    click(e) {
      if (click) {
        opts.ref = e.target;
        togglePopover(opts);
        e.stopPropagation();
      }
    },
    mousemove(e) {
      opts.ref = e.currentTarget;
      if (!hovered) {
        hovered = true;
        if (hover || hoverFocus) {
          showPopover(opts);
        }
      }
    },
    mouseleave(e) {
      opts.ref = e.target;
      if (hovered) {
        hovered = false;
        if (hover || (hoverFocus && !focused)) {
          hidePopover(opts);
        }
      }
    },
    focusin(e) {
      opts.ref = e.currentTarget;
      if (!focused) {
        focused = true;
        if (focus || hoverFocus) {
          showPopover(opts);
        }
      }
    },
    focusout(e) {
      opts.ref = e.currentTarget;
      if (focused && !elementContains(opts.ref, e.relatedTarget)) {
        focused = false;
        if (focus || (hoverFocus && !hovered)) {
          hidePopover(opts);
        }
      }
    },
  };
}

;// ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/CalendarDay.vue?vue&type=script&lang=js






/* harmony default export */ var CalendarDayvue_type_script_lang_js = ({
  name: 'CalendarDay',
  mixins: [mixins_childMixin, mixins_safeScopedSlotMixin],
  render(h) {
    // Backgrounds layer
    const backgroundsLayer = () =>
      this.hasBackgrounds &&
      h(
        'div',
        {
          class: 'vc-highlights vc-day-layer',
        },
        this.backgrounds.map(({ key, wrapperClass, class: bgClass, style }) =>
          h(
            'div',
            {
              key,
              class: wrapperClass,
            },
            [
              h('div', {
                class: bgClass,
                style,
              }),
            ],
          ),
        ),
      );

    // Content layer
    const contentLayer = () =>
      this.safeScopedSlot('day-content', {
        day: this.day,
        attributes: this.day.attributes,
        attributesMap: this.day.attributesMap,
        dayProps: this.dayContentProps,
        dayEvents: this.dayContentEvents,
      }) ||
      h(
        'span',
        {
          class: this.dayContentClass,
          style: this.dayContentStyle,
          attrs: { ...this.dayContentProps },
          on: this.dayContentEvents,
          ref: 'content',
        },
        [this.day.label],
      );

    // Dots layer
    const dotsLayer = () =>
      this.hasDots &&
      h(
        'div',
        {
          class: 'vc-day-layer vc-day-box-center-bottom',
        },
        [
          h(
            'div',
            {
              class: 'vc-dots',
            },
            this.dots.map(({ key, class: bgClass, style }) =>
              h('span', {
                key,
                class: bgClass,
                style,
              }),
            ),
          ),
        ],
      );

    // Bars layer
    const barsLayer = () =>
      this.hasBars &&
      h(
        'div',
        {
          class: 'vc-day-layer vc-day-box-center-bottom',
        },
        [
          h(
            'div',
            {
              class: 'vc-bars',
            },
            this.bars.map(({ key, class: bgClass, style }) =>
              h('span', {
                key,
                class: bgClass,
                style,
              }),
            ),
          ),
        ],
      );

    // Root layer
    return h(
      'div',
      {
        class: [
          'vc-day',
          ...this.day.classes,
          { 'vc-day-box-center-center': !this.$scopedSlots['day-content'] },
          { 'is-not-in-month': !this.inMonth },
        ],
      },
      [backgroundsLayer(), contentLayer(), dotsLayer(), barsLayer()],
    );
  },
  inject: ['sharedState'],
  props: {
    day: { type: Object, required: true },
  },
  data() {
    return {
      glyphs: {},
      dayContentEvents: {},
    };
  },
  computed: {
    label() {
      return this.day.label;
    },
    startTime() {
      return this.day.range.start.getTime();
    },
    endTime() {
      return this.day.range.end.getTime();
    },
    inMonth() {
      return this.day.inMonth;
    },
    isDisabled() {
      return this.day.isDisabled;
    },
    backgrounds() {
      return this.glyphs.backgrounds;
    },
    hasBackgrounds() {
      return !!arrayHasItems(this.backgrounds);
    },
    content() {
      return this.glyphs.content;
    },
    dots() {
      return this.glyphs.dots;
    },
    hasDots() {
      return !!arrayHasItems(this.dots);
    },
    bars() {
      return this.glyphs.bars;
    },
    hasBars() {
      return !!arrayHasItems(this.bars);
    },
    popovers() {
      return this.glyphs.popovers;
    },
    hasPopovers() {
      return !!arrayHasItems(this.popovers);
    },
    dayContentClass() {
      return [
        'vc-day-content vc-focusable',
        { 'is-disabled': this.isDisabled },
        get_default()(last_default()(this.content), 'class') || '',
      ];
    },
    dayContentStyle() {
      return get_default()(last_default()(this.content), 'style');
    },
    dayContentProps() {
      let tabindex;
      if (this.day.isFocusable) {
        tabindex = '0';
      } else if (this.day.inMonth) {
        tabindex = '-1';
      }
      return {
        tabindex,
        'aria-label': this.day.ariaLabel,
        'aria-disabled': this.day.isDisabled ? 'true' : 'false',
        role: 'button',
      };
    },
    dayEvent() {
      return {
        ...this.day,
        el: this.$refs.content,
        popovers: this.popovers,
      };
    },
  },
  watch: {
    theme() {
      this.refresh();
    },
    popovers() {
      this.refreshPopovers();
    },
  },
  mounted() {
    this.refreshPopovers();
  },
  methods: {
    getDayEvent(origEvent) {
      return {
        ...this.dayEvent,
        event: origEvent,
      };
    },
    click(e) {
      this.$emit('dayclick', this.getDayEvent(e));
    },
    mouseenter(e) {
      this.$emit('daymouseenter', this.getDayEvent(e));
    },
    mouseleave(e) {
      this.$emit('daymouseleave', this.getDayEvent(e));
    },
    focusin(e) {
      this.$emit('dayfocusin', this.getDayEvent(e));
    },
    focusout(e) {
      this.$emit('dayfocusout', this.getDayEvent(e));
    },
    keydown(e) {
      this.$emit('daykeydown', this.getDayEvent(e));
    },
    refresh() {
      if (!this.day.refresh) return;
      this.day.refresh = false;
      const glyphs = {
        backgrounds: [],
        dots: [],
        bars: [],
        popovers: [],
        content: [],
      };
      // Use $set to trigger reactivity in popovers, if needed
      this.$set(
        this.day,
        'attributes',
        Object.values(this.day.attributesMap || {}).sort(
          (a, b) => a.order - b.order,
        ),
      );
      this.day.attributes.forEach(attr => {
        // Add glyphs for each attribute
        const { targetDate } = attr;
        const { isDate, isComplex, startTime, endTime } = targetDate;
        const onStart = this.startTime <= startTime;
        const onEnd = this.endTime >= endTime;
        const onStartAndEnd = onStart && onEnd;
        const onStartOrEnd = onStart || onEnd;
        const dateInfo = {
          isDate,
          isComplex,
          onStart,
          onEnd,
          onStartAndEnd,
          onStartOrEnd,
        };
        this.processHighlight(attr, dateInfo, glyphs);
        this.processNonHighlight(attr, 'content', dateInfo, glyphs.content);
        this.processNonHighlight(attr, 'dot', dateInfo, glyphs.dots);
        this.processNonHighlight(attr, 'bar', dateInfo, glyphs.bars);
        this.processPopover(attr, glyphs);
      });
      this.glyphs = glyphs;
    },
    processHighlight(
      { key, highlight },
      { isDate, isComplex, onStart, onEnd, onStartAndEnd },
      { backgrounds, content },
    ) {
      if (!highlight) return;
      const { base, start, end } = highlight;
      if (isDate || isComplex) {
        backgrounds.push({
          key,
          wrapperClass: 'vc-day-layer vc-day-box-center-center',
          class: ['vc-highlight', start.class],
          style: start.style,
        });
        content.push({
          key: `${key}-content`,
          class: start.contentClass,
          style: start.contentStyle,
        });
      } else if (onStartAndEnd) {
        backgrounds.push({
          key,
          wrapperClass: 'vc-day-layer vc-day-box-center-center',
          class: ['vc-highlight', start.class],
          style: start.style,
        });
        content.push({
          key: `${key}-content`,
          class: start.contentClass,
          style: start.contentStyle,
        });
      } else if (onStart) {
        backgrounds.push({
          key: `${key}-base`,
          wrapperClass: 'vc-day-layer vc-day-box-right-center',
          class: ['vc-highlight vc-highlight-base-start', base.class],
          style: base.style,
        });
        backgrounds.push({
          key,
          wrapperClass: 'vc-day-layer vc-day-box-center-center',
          class: ['vc-highlight', start.class],
          style: start.style,
        });
        content.push({
          key: `${key}-content`,
          class: start.contentClass,
          style: start.contentStyle,
        });
      } else if (onEnd) {
        backgrounds.push({
          key: `${key}-base`,
          wrapperClass: 'vc-day-layer vc-day-box-left-center',
          class: ['vc-highlight vc-highlight-base-end', base.class],
          style: base.style,
        });
        backgrounds.push({
          key,
          wrapperClass: 'vc-day-layer vc-day-box-center-center',
          class: ['vc-highlight', end.class],
          style: end.style,
        });
        content.push({
          key: `${key}-content`,
          class: end.contentClass,
          style: end.contentStyle,
        });
      } else {
        backgrounds.push({
          key: `${key}-middle`,
          wrapperClass: 'vc-day-layer vc-day-box-center-center',
          class: ['vc-highlight vc-highlight-base-middle', base.class],
          style: base.style,
        });
        content.push({
          key: `${key}-content`,
          class: base.contentClass,
          style: base.contentStyle,
        });
      }
    },
    processNonHighlight(attr, itemKey, { isDate, onStart, onEnd }, list) {
      if (!attr[itemKey]) return;
      const { key } = attr;
      const className = `vc-${itemKey}`;
      const { base, start, end } = attr[itemKey];
      if (isDate || onStart) {
        list.push({
          key,
          class: [className, start.class],
          style: start.style,
        });
      } else if (onEnd) {
        list.push({
          key,
          class: [className, end.class],
          style: end.style,
        });
      } else {
        list.push({
          key,
          class: [className, base.class],
          style: base.style,
        });
      }
    },
    processPopover(attribute, { popovers }) {
      const { key, customData, popover } = attribute;
      if (!popover) return;
      const resolvedPopover = defaults_default()(
        {
          key,
          customData,
          attribute,
        },
        { ...popover },
        {
          visibility: popover.label ? 'hover' : 'click',
          placement: 'bottom',
          isInteractive: !popover.label,
        },
      );
      popovers.splice(0, 0, resolvedPopover);
    },
    refreshPopovers() {
      let popoverEvents = {};
      if (arrayHasItems(this.popovers)) {
        popoverEvents = getPopoverTriggerEvents(
          defaults_default()({ id: this.dayPopoverId, data: this.day }, ...this.popovers),
        );
      }
      this.dayContentEvents = mergeEvents(
        {
          click: this.click,
          mouseenter: this.mouseenter,
          mouseleave: this.mouseleave,
          focusin: this.focusin,
          focusout: this.focusout,
          keydown: this.keydown,
        },
        popoverEvents,
      );
      updatePopover({
        id: this.dayPopoverId,
        data: this.day,
      });
    },
  },
});

;// ./node_modules/v-calendar/src/components/CalendarDay.vue?vue&type=script&lang=js
 /* harmony default export */ var components_CalendarDayvue_type_script_lang_js = (CalendarDayvue_type_script_lang_js); 
;// ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-17.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-17.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-17.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/CalendarDay.vue?vue&type=style&index=0&id=1623f44d&prod&lang=postcss&scoped=true
// extracted by mini-css-extract-plugin

;// ./node_modules/v-calendar/src/components/CalendarDay.vue?vue&type=style&index=0&id=1623f44d&prod&lang=postcss&scoped=true

;// ./node_modules/v-calendar/src/components/CalendarDay.vue
var CalendarDay_render, CalendarDay_staticRenderFns
;

;


/* normalize component */

var CalendarDay_component = normalizeComponent(
  components_CalendarDayvue_type_script_lang_js,
  CalendarDay_render,
  CalendarDay_staticRenderFns,
  false,
  null,
  "1623f44d",
  null
  
)

/* harmony default export */ var CalendarDay = (CalendarDay_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/CalendarPane.vue?vue&type=script&lang=js






/* harmony default export */ var CalendarPanevue_type_script_lang_js = ({
  name: 'CalendarPane',
  mixins: [mixins_childMixin, mixins_safeScopedSlotMixin],
  render(h) {
    // Header
    const header =
      this.safeScopedSlot('header', this.page) ||
      // Default header
      h(
        'div',
        {
          class: `vc-header align-${this.titlePosition}`,
        },
        [
          // Header title
          h(
            'div',
            {
              class: 'vc-title',
              on: this.navPopoverEvents,
            },
            [this.safeScopedSlot('header-title', this.page, this.page.title)],
          ),
        ],
      );

    // Weekday cells
    const weekdayCells = this.weekdayLabels.map((wl, i) =>
      h(
        'div',
        {
          key: i + 1,
          class: 'vc-weekday',
        },
        [wl],
      ),
    );

    const showWeeknumbersLeft = this.showWeeknumbers_.startsWith('left');
    const showWeeknumbersRight = this.showWeeknumbers_.startsWith('right');
    if (showWeeknumbersLeft) {
      weekdayCells.unshift(
        h('div', {
          class: 'vc-weekday',
        }),
      );
    } else if (showWeeknumbersRight) {
      weekdayCells.push(
        h('div', {
          class: 'vc-weekday',
        }),
      );
    }

    // Weeknumber cell
    const getWeeknumberCell = weeknumber =>
      h(
        'div',
        {
          class: ['vc-weeknumber'],
        },
        [
          h(
            'span',
            {
              class: ['vc-weeknumber-content', `is-${this.showWeeknumbers_}`],
              on: {
                click: event => {
                  this.$emit('weeknumberclick', {
                    weeknumber,
                    days: this.page.days.filter(
                      d => d[this.weeknumberKey] === weeknumber,
                    ),
                    event,
                  });
                },
              },
            },
            [weeknumber],
          ),
        ],
      );

    // Day cells
    const dayCells = [];
    const { daysInWeek } = this.locale;
    this.page.days.forEach((day, i) => {
      const mod = i % daysInWeek;
      // Insert weeknumber cell on left side if needed
      if (
        (showWeeknumbersLeft && mod === 0) ||
        (showWeeknumbersRight && mod === daysInWeek)
      ) {
        dayCells.push(getWeeknumberCell(day[this.weeknumberKey]));
      }
      dayCells.push(
        h(CalendarDay, {
          attrs: {
            day,
          },
          on: {
            ...this.$listeners,
          },
          scopedSlots: this.$scopedSlots,
          key: day.id,
          ref: 'days',
          refInFor: true,
        }),
      );
      // Insert weeknumber cell on right side if needed
      if (showWeeknumbersRight && mod === daysInWeek - 1) {
        dayCells.push(getWeeknumberCell(day[this.weeknumberKey]));
      }
    });

    const weeks = h(
      'div',
      {
        class: {
          'vc-weeks': true,
          'vc-show-weeknumbers': this.showWeeknumbers_,
          'is-left': showWeeknumbersLeft,
          'is-right': showWeeknumbersRight,
        },
      },
      [weekdayCells, dayCells],
    );

    return h(
      'div',
      {
        class: [
          'vc-pane',
          `row-from-end-${this.rowFromEnd}`,
          `column-from-end-${this.columnFromEnd}`,
        ],
        ref: 'pane',
      },
      [header, weeks],
    );
  },
  inheritAttrs: false,
  props: {
    page: Object,
    position: Number,
    row: Number,
    rowFromEnd: Number,
    column: Number,
    columnFromEnd: Number,
    titlePosition: String,
    navVisibility: String,
    showWeeknumbers: [Boolean, String],
    showIsoWeeknumbers: [Boolean, String],
  },
  computed: {
    weeknumberKey() {
      return this.showWeeknumbers ? 'weeknumber' : 'isoWeeknumber';
    },
    showWeeknumbers_() {
      const showWeeknumbers = this.showWeeknumbers || this.showIsoWeeknumbers;
      if (showWeeknumbers == null) return '';
      if (isBoolean_default()(showWeeknumbers)) {
        return showWeeknumbers ? 'left' : '';
      }
      if (showWeeknumbers.startsWith('right')) {
        return this.columnFromEnd > 1 ? 'right' : showWeeknumbers;
      }
      return this.column > 1 ? 'left' : showWeeknumbers;
    },
    navVisibility_() {
      return this.propOrDefault('navVisibility', 'navVisibility');
    },
    navPlacement() {
      switch (this.titlePosition) {
        case 'left':
          return 'bottom-start';
        case 'right':
          return 'bottom-end';
        default:
          return 'bottom';
      }
    },
    navPopoverEvents() {
      const {
        sharedState,
        navVisibility_,
        navPlacement,
        page,
        position,
      } = this;
      return getPopoverTriggerEvents({
        id: sharedState.navPopoverId,
        visibility: navVisibility_,
        placement: navPlacement,
        modifiers: [
          { name: 'flip', options: { fallbackPlacements: ['bottom'] } },
        ],
        data: { page, position },
        isInteractive: true,
      });
    },
    weekdayLabels() {
      return this.locale
        .getWeekdayDates()
        .map(d => this.format(d, this.masks.weekdays));
    },
  },
  methods: {
    refresh() {
      this.$refs.days.forEach(d => d.refresh());
    },
  },
});

;// ./node_modules/v-calendar/src/components/CalendarPane.vue?vue&type=script&lang=js
 /* harmony default export */ var components_CalendarPanevue_type_script_lang_js = (CalendarPanevue_type_script_lang_js); 
;// ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-17.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-17.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-17.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/CalendarPane.vue?vue&type=style&index=0&id=22657c30&prod&lang=postcss&scoped=true
// extracted by mini-css-extract-plugin

;// ./node_modules/v-calendar/src/components/CalendarPane.vue?vue&type=style&index=0&id=22657c30&prod&lang=postcss&scoped=true

;// ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/CalendarPane.vue?vue&type=style&index=1&id=22657c30&prod&lang=css
// extracted by mini-css-extract-plugin

;// ./node_modules/v-calendar/src/components/CalendarPane.vue?vue&type=style&index=1&id=22657c30&prod&lang=css

;// ./node_modules/v-calendar/src/components/CalendarPane.vue
var CalendarPane_render, CalendarPane_staticRenderFns
;

;



/* normalize component */

var CalendarPane_component = normalizeComponent(
  components_CalendarPanevue_type_script_lang_js,
  CalendarPane_render,
  CalendarPane_staticRenderFns,
  false,
  null,
  "22657c30",
  null
  
)

/* harmony default export */ var CalendarPane = (CalendarPane_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/CustomTransition.vue?vue&type=script&lang=js

/* harmony default export */ var CustomTransitionvue_type_script_lang_js = ({
  name: 'CustomTransition',
  render(h) {
    return h(
      'transition',
      {
        props: {
          name: this.name_,
          appear: this.appear,
        },
        on: {
          beforeEnter: this.beforeEnter,
          afterEnter: this.afterEnter,
        },
      },
      [this.$slots.default],
    );
  },
  props: {
    name: String,
    appear: Boolean,
  },
  computed: {
    name_() {
      return this.name || 'none';
    },
  },
  methods: {
    beforeEnter(el) {
      this.$emit('beforeEnter', el);
      this.$emit('beforeTransition', el);
    },
    afterEnter(el) {
      this.$emit('afterEnter', el);
      this.$emit('afterTransition', el);
    },
  },
});

;// ./node_modules/v-calendar/src/components/CustomTransition.vue?vue&type=script&lang=js
 /* harmony default export */ var components_CustomTransitionvue_type_script_lang_js = (CustomTransitionvue_type_script_lang_js); 
;// ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-17.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-17.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-17.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/CustomTransition.vue?vue&type=style&index=0&id=0bb24e61&prod&lang=postcss&scoped=true
// extracted by mini-css-extract-plugin

;// ./node_modules/v-calendar/src/components/CustomTransition.vue?vue&type=style&index=0&id=0bb24e61&prod&lang=postcss&scoped=true

;// ./node_modules/v-calendar/src/components/CustomTransition.vue
var CustomTransition_render, CustomTransition_staticRenderFns
;

;


/* normalize component */

var CustomTransition_component = normalizeComponent(
  components_CustomTransitionvue_type_script_lang_js,
  CustomTransition_render,
  CustomTransition_staticRenderFns,
  false,
  null,
  "0bb24e61",
  null
  
)

/* harmony default export */ var CustomTransition = (CustomTransition_component.exports);
;// ./node_modules/v-calendar/src/utils/attributeStore.js



class AttributeStore {
  constructor(theme, locale, attrs) {
    this.theme = theme;
    this.locale = locale;
    this.map = {};
    this.refresh(attrs, true);
  }

  destroy() {
    this.theme = null;
    this.locale = null;
    this.map = {};
    this.list = [];
    this.pinAttr = null;
  }

  refresh(attrs, reset) {
    const map = {};
    const list = [];
    let pinAttr = null;
    // Keep record of added and deleted attributes
    const adds = [];
    const deletes = reset ? new Set() : new Set(Object.keys(this.map));
    if (arrayHasItems(attrs)) {
      attrs.forEach((attr, i) => {
        if (!attr || !attr.dates) return;
        const key = attr.key ? attr.key.toString() : i.toString();
        const order = attr.order || 0;
        const hashcode = helpers_hash(JSON.stringify(attr));
        let exAttr = this.map[key];
        // If just tracking delta changes and attribute hash hasn't changed
        if (!reset && exAttr && exAttr.hashcode === hashcode) {
          // ...don't need to replace the attribute
          deletes.delete(key);
        } else {
          // Otherwise, create attribute and add to the list of adds
          exAttr = new Attribute(
            {
              key,
              order,
              hashcode,
              ...attr,
            },
            this.theme,
            this.locale,
          );
          adds.push(exAttr);
        }
        // Keep track of attribute to pin for initial page
        if (exAttr && exAttr.pinPage) {
          pinAttr = exAttr;
        }
        // Add attribute to map and list
        map[key] = exAttr;
        list.push(exAttr);
      });
    }
    this.map = map;
    this.list = list;
    this.pinAttr = pinAttr;
    return { adds, deletes: Array.from(deletes) };
  }
}

;// ./node_modules/v-calendar/src/utils/touch.js



const addHorizontalSwipeHandler = (
  element,
  handler,
  { maxSwipeTime, minHorizontalSwipeDistance, maxVerticalSwipeDistance },
) => {
  if (!element || !element.addEventListener || !isFunction_default()(handler)) {
    return null;
  }
  // State variables
  let startX = 0;
  let startY = 0;
  let startTime = null;
  let isSwiping = false;
  // Touch start handler
  function touchStart(e) {
    const t = e.changedTouches[0];
    startX = t.screenX;
    startY = t.screenY;
    startTime = new Date().getTime();
    isSwiping = true;
  }
  // Touch end handler
  function touchEnd(e) {
    if (!isSwiping) return;
    isSwiping = false;
    const t = e.changedTouches[0];
    const deltaX = t.screenX - startX;
    const deltaY = t.screenY - startY;
    const deltaTime = new Date().getTime() - startTime;
    if (deltaTime < maxSwipeTime) {
      if (
        Math.abs(deltaX) >= minHorizontalSwipeDistance &&
        Math.abs(deltaY) <= maxVerticalSwipeDistance
      ) {
        const arg = { toLeft: false, toRight: false };
        if (deltaX < 0) {
          // Swipe to the left
          arg.toLeft = true;
        } else {
          // Swipe to the right
          arg.toRight = true;
        }
        handler(arg);
      }
    }
  }
  // Add event handlers
  on(element, 'touchstart', touchStart, { passive: true });
  // on(element, 'touchmove', touchmove);
  on(element, 'touchend', touchEnd, { passive: true });
  // Return function that removes event handlers
  return () => {
    off(element, 'touchstart', touchStart);
    // off(element, 'touchmove', touchmove);
    off(element, 'touchend', touchEnd);
  };
};

;// ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/Calendar.vue?vue&type=script&lang=js

















/* harmony default export */ var Calendarvue_type_script_lang_js = ({
  name: 'Calendar',
  render(h) {
    // Renderer for calendar panes
    const panes = this.pages.map((page, i) => {
      const position = i + 1;
      const row = Math.ceil((i + 1) / this.columns);
      const rowFromEnd = this.rows - row + 1;
      const column = position % this.columns || this.columns;
      const columnFromEnd = this.columns - column + 1;
      return h(CalendarPane, {
        attrs: {
          ...this.$attrs,
          attributes: this.store,
        },
        props: {
          page,
          position,
          row,
          rowFromEnd,
          column,
          columnFromEnd,
          titlePosition: this.titlePosition_,
        },
        on: {
          ...this.$listeners,
          dayfocusin: e => {
            this.lastFocusedDay = e;
            this.$emit('dayfocusin', e);
          },
          dayfocusout: e => {
            this.lastFocusedDay = null;
            this.$emit('dayfocusout', e);
          },
        },
        scopedSlots: this.$scopedSlots,
        key: page.key,
        ref: 'pages',
        refInFor: true,
      });
    });
    // Renderer for calendar arrows
    const getArrowButton = isPrev => {
      const click = () => this.move(isPrev ? -this.step_ : this.step_);
      const keydown = e => onSpaceOrEnter(e, click);
      const isDisabled = isPrev ? !this.canMovePrev : !this.canMoveNext;
      return h(
        'div',
        {
          class: [
            'vc-arrow',
            `is-${isPrev ? 'left' : 'right'}`,
            { 'is-disabled': isDisabled },
          ],
          attrs: {
            role: 'button',
          },
          on: {
            click,
            keydown,
          },
        },
        [
          (isPrev
            ? this.safeScopedSlot('header-left-button', { click })
            : this.safeScopedSlot('header-right-button', { click })) ||
            h(SvgIcon, {
              props: {
                name: isPrev ? 'left-arrow' : 'right-arrow',
              },
            }),
        ],
      );
    };

    // Nav popover
    const getNavPopover = () =>
      h(Popover, {
        props: {
          id: this.sharedState.navPopoverId,
          contentClass: 'vc-nav-popover-container',
        },
        ref: 'navPopover',
        scopedSlots: {
          default: ({ data }) => {
            const { position, page } = data;
            return h(CalendarNav, {
              props: {
                value: page,
                position,
                validator: e => this.canMove(e, { position }),
              },
              on: {
                input: e => this.move(e, { position }),
              },
              scopedSlots: this.$scopedSlots,
            });
          },
        },
      });

    // Day popover
    const getDayPopover = () =>
      h(Popover, {
        props: {
          id: this.sharedState.dayPopoverId,
          contentClass: 'vc-day-popover-container',
        },
        scopedSlots: {
          default: ({ data: day, updateLayout, hide }) => {
            const attributes = Object.values(day.attributes).filter(
              a => a.popover,
            );
            const masks = this.$locale.masks;
            const format = this.formatDate;
            const dayTitle = format(day.date, masks.dayPopover);
            return (
              this.safeScopedSlot('day-popover', {
                day,
                attributes,
                masks,
                format,
                dayTitle,
                updateLayout,
                hide,
              }) ||
              h('div', [
                // Show popover header only if format is defined
                masks.dayPopover &&
                  h(
                    'div',
                    {
                      class: ['vc-day-popover-header'],
                    },
                    [dayTitle],
                  ),
                attributes.map(attribute =>
                  h(PopoverRow, {
                    key: attribute.key,
                    props: {
                      attribute,
                    },
                  }),
                ),
              ])
            );
          },
        },
      });

    // Renderer for calendar container
    return h(
      'div',
      {
        attrs: {
          'data-helptext':
            'Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year',
        },
        class: [
          'vc-container',
          `vc-${this.$theme.color}`,
          {
            'vc-is-expanded': this.isExpanded,
            'vc-is-dark': this.$theme.isDark,
          },
        ],
        on: {
          keydown: this.handleKeydown,
          mouseup: e => e.preventDefault(),
        },
        ref: 'container',
      },
      [
        getNavPopover(),
        h(
          'div',
          {
            class: [
              'vc-pane-container',
              { 'in-transition': this.inTransition },
            ],
          },
          [
            h(
              CustomTransition,
              {
                props: {
                  name: this.transitionName,
                },
                on: {
                  beforeEnter: () => {
                    this.inTransition = true;
                  },
                  afterEnter: () => {
                    this.inTransition = false;
                  },
                },
              },
              [
                h(
                  'div',
                  {
                    class: 'vc-pane-layout',
                    style: {
                      gridTemplateColumns: `repeat(${this.columns}, 1fr)`,
                    },
                    attrs: {
                      ...this.$attrs,
                    },
                    key: arrayHasItems(this.pages) ? this.pages[0].key : '',
                  },
                  panes,
                ),
              ],
            ),
            h(
              'div',
              {
                class: [`vc-arrows-container title-${this.titlePosition_}`],
              },
              [getArrowButton(true), getArrowButton(false)],
            ),
            this.$scopedSlots.footer && this.$scopedSlots.footer(),
          ],
        ),
        getDayPopover(),
      ],
    );
  },
  mixins: [mixins_rootMixin, mixins_safeScopedSlotMixin],
  provide() {
    return {
      sharedState: this.sharedState,
    };
  },
  props: {
    rows: {
      type: Number,
      default: 1,
    },
    columns: {
      type: Number,
      default: 1,
    },
    step: Number,
    titlePosition: String,
    isExpanded: Boolean,
    fromDate: Date,
    toDate: Date,
    fromPage: Object,
    toPage: Object,
    minPage: Object,
    maxPage: Object,
    transition: String,
    attributes: [Object, Array],
    trimWeeks: Boolean,
    disablePageSwipe: Boolean,
  },
  data() {
    return {
      pages: [],
      store: null,
      lastFocusedDay: null,
      focusableDay: new Date().getDate(),
      transitionName: '',
      inTransition: false,
      sharedState: {
        navPopoverId: createGuid(),
        dayPopoverId: createGuid(),
        theme: {},
        masks: {},
        locale: {},
      },
    };
  },
  computed: {
    titlePosition_() {
      return this.propOrDefault('titlePosition', 'titlePosition');
    },
    firstPage() {
      return head_default()(this.pages);
    },
    lastPage() {
      return last_default()(this.pages);
    },
    minPage_() {
      return this.minPage || this.pageForDate(this.minDate);
    },
    maxPage_() {
      return this.maxPage || this.pageForDate(this.maxDate);
    },
    count() {
      return this.rows * this.columns;
    },
    step_() {
      return this.step || this.count;
    },
    canMovePrev() {
      return this.canMove(-this.step_);
    },
    canMoveNext() {
      return this.canMove(this.step_);
    },
  },
  watch: {
    $locale() {
      this.refreshLocale();
      this.refreshPages({ page: this.firstPage, ignoreCache: true });
      this.initStore();
    },
    $theme() {
      this.refreshTheme();
      this.initStore();
    },
    fromDate() {
      this.refreshPages();
    },
    fromPage(val) {
      const firstPage = this.pages && this.pages[0];
      if (pageIsEqualToPage(val, firstPage)) return;
      this.refreshPages();
    },
    toPage(val) {
      const lastPage = this.pages && this.pages[this.pages.length - 1];
      if (pageIsEqualToPage(val, lastPage)) return;
      this.refreshPages();
    },
    count() {
      this.refreshPages();
    },
    attributes: {
      handler(val) {
        const { adds, deletes } = this.store.refresh(val);
        this.refreshAttrs(this.pages, adds, deletes);
      },
      deep: true,
    },
    pages(val) {
      this.refreshAttrs(val, this.store.list, null, true);
    },
    disabledAttribute() {
      this.refreshDisabledDays();
    },
    lastFocusedDay(val) {
      if (val) {
        this.focusableDay = val.day;
        this.refreshFocusableDays();
      }
    },
    inTransition(val) {
      if (val) {
        this.$emit('transition-start');
      } else {
        this.$emit('transition-end');
        if (this.transitionPromise) {
          this.transitionPromise.resolve(true);
          this.transitionPromise = null;
        }
      }
    },
  },
  created() {
    this.refreshLocale();
    this.refreshTheme();
    this.initStore();
    this.refreshPages();
  },
  mounted() {
    if (!this.disablePageSwipe) {
      // Add swipe handler to move to next and previous pages
      this.removeHandlers = addHorizontalSwipeHandler(
        this.$refs.container,
        ({ toLeft, toRight }) => {
          if (toLeft) {
            this.moveNext();
          } else if (toRight) {
            this.movePrev();
          }
        },
        this.$defaults.touch,
      );
    }
  },
  destroyed() {
    this.pages = [];
    this.store.destroy();
    this.store = null;
    this.sharedState = null;
    if (this.removeHandlers) this.removeHandlers();
  },
  methods: {
    refreshLocale() {
      this.sharedState.locale = this.$locale;
      this.sharedState.masks = this.$locale.masks;
    },
    refreshTheme() {
      this.sharedState.theme = this.$theme;
    },
    canMove(arg, opts = {}) {
      const page = this.$locale.toPage(arg, this.firstPage);
      let { position } = opts;
      // Pin position if arg is number
      if (isNumber_default()(arg)) position = 1;
      // Reject unresolved pages
      if (!page) {
        return Promise.reject(new Error(`Invalid argument provided: ${arg}`));
      }
      // Set position if unspecified and out of current bounds
      if (!position) {
        if (pageIsBeforePage(page, this.firstPage)) {
          position = -1;
        } else if (pageIsAfterPage(page, this.lastPage)) {
          position = 1;
        } else {
          // Page already displayed with no specified position, so we're done
          return Promise.resolve(true);
        }
      }
      // Calculate new page range without adjusting to min/max
      Object.assign(
        opts,
        this.getTargetPageRange(page, {
          position,
          force: true,
        }),
      );
      // Verify we can to move to any pages in the target range
      return pageRangeToArray(opts.fromPage, opts.toPage).some(p =>
        pageIsBetweenPages(p, this.minPage_, this.maxPage_),
      );
    },
    movePrev(opts) {
      return this.move(-this.step_, opts);
    },
    moveNext(opts) {
      return this.move(this.step_, opts);
    },
    move(arg, opts = {}) {
      // Reject if we can't move to this page
      const canMove = this.canMove(arg, opts);
      if (!opts.force && !canMove) {
        return Promise.reject(
          new Error(`Move target is disabled: ${JSON.stringify(opts)}`),
        );
      }
      // Hide nav popover for good measure
      this.$refs.navPopover.hide({ hideDelay: 0 });
      // Move to new `fromPage` if it's different from the current one
      if (opts.fromPage && !pageIsEqualToPage(opts.fromPage, this.firstPage)) {
        return this.refreshPages({
          ...opts,
          page: opts.fromPage,
          position: 1,
          force: true,
        });
      }
      return Promise.resolve(true);
    },
    focusDate(date, opts = {}) {
      // Move to the given date
      return this.move(date, opts).then(() => {
        // Set focus on the element for the date
        const focusableEl = this.$el.querySelector(
          `.id-${this.$locale.getDayId(date)}.in-month .vc-focusable`,
        );
        if (focusableEl) {
          focusableEl.focus();
          return Promise.resolve(true);
        }
        return Promise.resolve(false);
      });
    },
    showPageRange(range, opts) {
      let fromPage;
      let toPage;
      if (_isDate(range)) {
        fromPage = this.pageForDate(range);
      } else if (_isObject(range)) {
        const { month, year } = range;
        const { from, to } = range;
        if (isNumber_default()(month) && isNumber_default()(year)) {
          fromPage = range;
        } else if (from || to) {
          fromPage = _isDate(from) ? this.pageForDate(from) : from;
          toPage = _isDate(to) ? this.pageForDate(to) : to;
        }
      } else {
        return Promise.reject(new Error('Invalid page range provided.'));
      }
      const lastPage = this.lastPage;
      let page = fromPage;
      // Offset page from the desired `toPage`
      if (pageIsAfterPage(toPage, lastPage)) {
        page = addPages(toPage, -(this.pages.length - 1));
      }
      // But no earlier than the desired `fromPage`
      if (pageIsBeforePage(page, fromPage)) {
        page = fromPage;
      }
      return this.refreshPages({ ...opts, page });
    },
    getTargetPageRange(page, { position, force } = {}) {
      let fromPage = null;
      let toPage = null;
      if (pageIsValid(page)) {
        let pagesToAdd = 0;
        position = +position;
        if (!isNaN(position)) {
          pagesToAdd = position > 0 ? 1 - position : -(this.count + position);
        }
        fromPage = addPages(page, pagesToAdd);
      } else {
        fromPage = this.getDefaultInitialPage();
      }
      toPage = addPages(fromPage, this.count - 1);
      // Adjust range for min/max if not forced
      if (!force) {
        if (pageIsBeforePage(fromPage, this.minPage_)) {
          fromPage = this.minPage_;
        } else if (pageIsAfterPage(toPage, this.maxPage_)) {
          fromPage = addPages(this.maxPage_, 1 - this.count);
        }
        toPage = addPages(fromPage, this.count - 1);
      }
      return { fromPage, toPage };
    },
    getDefaultInitialPage() {
      // 1. Try the fromPage prop
      let page = this.fromPage || this.pageForDate(this.fromDate);
      if (!pageIsValid(page)) {
        // 2. Try the toPage prop
        const toPage = this.toPage || this.pageForDate(this.toPage);
        if (pageIsValid(toPage)) {
          page = addPages(toPage, 1 - this.count);
        }
      }
      // 3. Try the first attribute
      if (!pageIsValid(page)) {
        page = this.getPageForAttributes();
      }
      // 4. Use today's page
      if (!pageIsValid(page)) {
        page = this.pageForThisMonth();
      }
      return page;
    },
    refreshPages({ page, position = 1, force, transition, ignoreCache } = {}) {
      return new Promise((resolve, reject) => {
        const { fromPage, toPage } = this.getTargetPageRange(page, {
          position,
          force,
        });
        // Create the new pages
        const pages = [];
        for (let i = 0; i < this.count; i++) {
          pages.push(this.buildPage(addPages(fromPage, i), ignoreCache));
        }
        // Refresh disabled days for new pages
        this.refreshDisabledDays(pages);
        // Refresh focusable days for new pages
        this.refreshFocusableDays(pages);
        // Assign the transition
        this.transitionName = this.getPageTransition(
          this.pages[0],
          pages[0],
          transition,
        );
        // Assign the new pages
        this.pages = pages;
        // Emit page update events
        this.$emit('update:from-page', fromPage);
        this.$emit('update:to-page', toPage);
        if (this.transitionName && this.transitionName !== 'none') {
          this.transitionPromise = {
            resolve,
            reject,
          };
        } else {
          resolve(true);
        }
      });
    },
    refreshDisabledDays(pages) {
      this.getPageDays(pages).forEach(d => {
        d.isDisabled =
          !!this.disabledAttribute && this.disabledAttribute.intersectsDay(d);
      });
    },
    refreshFocusableDays(pages) {
      this.getPageDays(pages).forEach(d => {
        d.isFocusable = d.inMonth && d.day === this.focusableDay;
      });
    },
    getPageDays(pages = this.pages) {
      return pages.reduce((prev, curr) => prev.concat(curr.days), []);
    },
    getPageTransition(oldPage, newPage, transition = this.transition) {
      if (transition === 'none') return transition;
      if (
        transition === 'fade' ||
        (!transition && this.count > 1) ||
        !pageIsValid(oldPage) ||
        !pageIsValid(newPage)
      ) {
        return 'fade';
      }
      // Moving to a previous page
      const movePrev = pageIsBeforePage(newPage, oldPage);
      // Vertical slide
      if (transition === 'slide-v') {
        return movePrev ? 'slide-down' : 'slide-up';
      }
      // Horizontal slide
      return movePrev ? 'slide-right' : 'slide-left';
    },
    getPageForAttributes() {
      let page = null;
      const attr = this.store.pinAttr;
      if (attr && attr.hasDates) {
        let [date] = attr.dates;
        date = date.start || date.date;
        page = this.pageForDate(date);
      }
      return page;
    },
    buildPage({ month, year }, ignoreCache) {
      const key = `${year.toString()}-${month.toString()}`;
      let page = this.pages.find(p => p.key === key);
      if (!page || ignoreCache) {
        const date = new Date(year, month - 1, 15);
        const monthComps = this.$locale.getMonthComps(month, year);
        const prevMonthComps = this.$locale.getPrevMonthComps(month, year);
        const nextMonthComps = this.$locale.getNextMonthComps(month, year);
        page = {
          key,
          month,
          year,
          weeks: this.trimWeeks ? monthComps.weeks : 6,
          title: this.$locale.format(date, this.$locale.masks.title),
          shortMonthLabel: this.$locale.format(date, 'MMM'),
          monthLabel: this.$locale.format(date, 'MMMM'),
          shortYearLabel: year.toString().substring(2),
          yearLabel: year.toString(),
          monthComps,
          prevMonthComps,
          nextMonthComps,
          canMove: pg => this.canMove(pg),
          move: pg => this.move(pg),
          moveThisMonth: () => this.moveThisMonth(),
          movePrevMonth: () => this.move(prevMonthComps),
          moveNextMonth: () => this.move(nextMonthComps),
          refresh: true,
        };
        // Assign day info
        page.days = this.$locale.getCalendarDays(page);
      }
      return page;
    },
    initStore() {
      // Create a new attribute store
      this.store = new AttributeStore(
        this.$theme,
        this.$locale,
        this.attributes,
      );
      // Refresh attributes for existing pages
      this.refreshAttrs(this.pages, this.store.list, [], true);
    },
    refreshAttrs(pages = [], adds = [], deletes = [], reset) {
      if (!arrayHasItems(pages)) return;
      // For each page...
      pages.forEach(p => {
        // For each day...
        p.days.forEach(d => {
          let map = {};
          // If resetting...
          if (reset) {
            d.refresh = true;
          } else if (hasAny(d.attributesMap, deletes)) {
            // Delete attributes from the delete list
            map = omit_default()(d.attributesMap, deletes);
            // Flag day for refresh
            d.refresh = true;
          } else {
            // Get the existing attributes
            map = d.attributesMap || {};
          }
          // For each attribute to add...
          adds.forEach(attr => {
            // Add it if it includes the current day
            const targetDate = attr.intersectsDay(d);
            if (targetDate) {
              const newAttr = {
                ...attr,
                targetDate,
              };
              map[attr.key] = newAttr;
              // Flag day for refresh
              d.refresh = true;
            }
          });
          // Reassign day attributes
          if (d.refresh) {
            d.attributesMap = map;
          }
        });
      });
      // Refresh pages
      this.$nextTick(() => {
        this.$refs.pages.forEach(p => p.refresh());
      });
    },
    handleKeydown(e) {
      const day = this.lastFocusedDay;
      if (day != null) {
        day.event = e;
        this.handleDayKeydown(day);
      }
    },
    handleDayKeydown(day) {
      const { dateFromTime, event } = day;
      // Set to noon to offset any daylight savings time offset
      const date = dateFromTime(12);
      let newDate = null;
      switch (event.key) {
        case 'ArrowLeft': {
          // Move to previous day
          newDate = addDays(date, -1);
          break;
        }
        case 'ArrowRight': {
          // Move to next day
          newDate = addDays(date, 1);
          break;
        }
        case 'ArrowUp': {
          // Move to previous week
          newDate = addDays(date, -7);
          break;
        }
        case 'ArrowDown': {
          // Move to next week
          newDate = addDays(date, 7);
          break;
        }
        case 'Home': {
          // Move to first weekday position
          newDate = addDays(date, -day.weekdayPosition + 1);
          break;
        }
        case 'End': {
          // Move to last weekday position
          newDate = addDays(date, day.weekdayPositionFromEnd);
          break;
        }
        case 'PageUp': {
          if (event.altKey) {
            // Move to previous year w/ Alt/Option key
            newDate = addYears(date, -1);
          } else {
            // Move to previous month
            newDate = addMonths(date, -1);
          }
          break;
        }
        case 'PageDown': {
          if (event.altKey) {
            // Move to next year w/ Alt/Option key
            newDate = addYears(date, 1);
          } else {
            // Move to next month
            newDate = addMonths(date, 1);
          }
          break;
        }
      }
      if (newDate) {
        event.preventDefault();
        this.focusDate(newDate).catch(() => {});
      }
    },
  },
});

;// ./node_modules/v-calendar/src/components/Calendar.vue?vue&type=script&lang=js
 /* harmony default export */ var components_Calendarvue_type_script_lang_js = (Calendarvue_type_script_lang_js); 
;// ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-17.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-17.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-17.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/Calendar.vue?vue&type=style&index=0&id=752163b0&prod&lang=postcss
// extracted by mini-css-extract-plugin

;// ./node_modules/v-calendar/src/components/Calendar.vue?vue&type=style&index=0&id=752163b0&prod&lang=postcss

;// ./node_modules/v-calendar/src/components/Calendar.vue
var Calendar_render, Calendar_staticRenderFns
;

;


/* normalize component */

var Calendar_component = normalizeComponent(
  components_Calendarvue_type_script_lang_js,
  Calendar_render,
  Calendar_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Calendar = (Calendar_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/TimePicker.vue?vue&type=template&id=68d0690f&scoped=true
var TimePickervue_type_template_id_68d0690f_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vc-time-picker",class:[{ 'vc-disabled': _vm.isDisabled, 'vc-bordered': _vm.showBorder }]},[_c('div',[_c('svg',{staticClass:"vc-time-icon",attrs:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","viewBox":"0 0 24 24","stroke":"currentColor"}},[_c('path',{attrs:{"d":"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"}})])]),_c('div',{staticClass:"vc-date-time"},[(_vm.date)?_c('div',{staticClass:"vc-date"},[_c('span',{staticClass:"vc-weekday"},[_vm._v(" "+_vm._s(_vm.locale.format(_vm.date, 'WWW'))+" ")]),_c('span',{staticClass:"vc-month"},[_vm._v(" "+_vm._s(_vm.locale.format(_vm.date, 'MMM'))+" ")]),_c('span',{staticClass:"vc-day"},[_vm._v(" "+_vm._s(_vm.locale.format(_vm.date, 'D'))+" ")]),_c('span',{staticClass:"vc-year"},[_vm._v(" "+_vm._s(_vm.locale.format(_vm.date, 'YYYY'))+" ")])]):_vm._e(),_c('div',{staticClass:"vc-time"},[_c('time-select',{attrs:{"options":_vm.hourOptions_},model:{value:(_vm.hours),callback:function ($$v) {_vm.hours=_vm._n($$v)},expression:"hours"}}),_c('span',{staticStyle:{"margin":"0 4px"}},[_vm._v(":")]),_c('time-select',{attrs:{"options":_vm.minuteOptions},model:{value:(_vm.minutes),callback:function ($$v) {_vm.minutes=_vm._n($$v)},expression:"minutes"}}),(!_vm.is24hr)?_c('div',{staticClass:"vc-am-pm",class:{ 'vc-disabled': !(_vm.hours >= 0) }},[_c('button',{class:{ active: _vm.isAM, 'vc-disabled': _vm.amDisabled },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.isAM = true}}},[_vm._v(" AM ")]),_c('button',{class:{ active: !_vm.isAM, 'vc-disabled': _vm.pmDisabled },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.isAM = false}}},[_vm._v(" PM ")])]):_vm._e()],1)])])
}
var TimePickervue_type_template_id_68d0690f_scoped_true_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/TimeSelect.vue?vue&type=template&id=d4fbff42&scoped=true
var TimeSelectvue_type_template_id_d4fbff42_scoped_true_render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vc-select"},[_c('select',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.model=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},'select',_vm.$attrs,false),_vm._l((_vm.options),function(option){return _c('option',{key:option.value,attrs:{"disabled":option.disabled},domProps:{"value":option.value}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0),_c('div',{staticClass:"vc-select-arrow"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"}})])])])
}
var TimeSelectvue_type_template_id_d4fbff42_scoped_true_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/TimeSelect.vue?vue&type=script&lang=js

/* harmony default export */ var TimeSelectvue_type_script_lang_js = ({
  inheritAttrs: false,
  props: {
    options: Array,
    value: Number,
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
});

;// ./node_modules/v-calendar/src/components/TimeSelect.vue?vue&type=script&lang=js
 /* harmony default export */ var components_TimeSelectvue_type_script_lang_js = (TimeSelectvue_type_script_lang_js); 
;// ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-17.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-17.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-17.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/TimeSelect.vue?vue&type=style&index=0&id=d4fbff42&prod&lang=postcss&scoped=true
// extracted by mini-css-extract-plugin

;// ./node_modules/v-calendar/src/components/TimeSelect.vue?vue&type=style&index=0&id=d4fbff42&prod&lang=postcss&scoped=true

;// ./node_modules/v-calendar/src/components/TimeSelect.vue



;


/* normalize component */

var TimeSelect_component = normalizeComponent(
  components_TimeSelectvue_type_script_lang_js,
  TimeSelectvue_type_template_id_d4fbff42_scoped_true_render,
  TimeSelectvue_type_template_id_d4fbff42_scoped_true_staticRenderFns,
  false,
  null,
  "d4fbff42",
  null
  
)

/* harmony default export */ var TimeSelect = (TimeSelect_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/TimePicker.vue?vue&type=script&lang=js




const _amOptions = [
  { value: 0, label: '12' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' },
  { value: 11, label: '11' },
];
const _pmOptions = [
  { value: 12, label: '12' },
  { value: 13, label: '1' },
  { value: 14, label: '2' },
  { value: 15, label: '3' },
  { value: 16, label: '4' },
  { value: 17, label: '5' },
  { value: 18, label: '6' },
  { value: 19, label: '7' },
  { value: 20, label: '8' },
  { value: 21, label: '9' },
  { value: 22, label: '10' },
  { value: 23, label: '11' },
];

/* harmony default export */ var TimePickervue_type_script_lang_js = ({
  name: 'TimePicker',
  components: { TimeSelect: TimeSelect },
  props: {
    value: { type: Object, required: true },
    locale: { type: Object, required: true },
    theme: { type: Object, required: true },
    is24hr: { type: Boolean, default: true },
    showBorder: Boolean,
    isDisabled: Boolean,
    hourOptions: Array,
    minuteOptions: Array,
  },
  computed: {
    date() {
      let date = this.locale.normalizeDate(this.value);
      if (this.value.hours === 24) {
        date = new Date(date.getTime() - 1);
      }
      return date;
    },
    hours: {
      get() {
        return this.value.hours;
      },
      set(value) {
        this.updateValue(value, this.minutes);
      },
    },
    minutes: {
      get() {
        return this.value.minutes;
      },
      set(value) {
        this.updateValue(this.hours, value);
      },
    },
    isAM: {
      get() {
        return this.value.hours < 12;
      },
      set(value) {
        let hours = this.hours;
        if (value && hours >= 12) {
          hours -= 12;
        } else if (!value && hours < 12) {
          hours += 12;
        }
        this.updateValue(hours, this.minutes);
      },
    },
    amHourOptions() {
      return _amOptions.filter(opt =>
        this.hourOptions.some(ho => ho.value === opt.value),
      );
    },
    pmHourOptions() {
      return _pmOptions.filter(opt =>
        this.hourOptions.some(ho => ho.value === opt.value),
      );
    },
    hourOptions_() {
      if (this.is24hr) return this.hourOptions;
      if (this.isAM) return this.amHourOptions;
      return this.pmHourOptions;
    },
    amDisabled() {
      return !arrayHasItems(this.amHourOptions);
    },
    pmDisabled() {
      return !arrayHasItems(this.pmHourOptions);
    },
  },
  methods: {
    updateValue(hours, minutes) {
      if (hours !== this.hours || minutes !== this.minutes) {
        this.$emit('input', {
          ...this.value,
          hours,
          minutes,
          seconds: 0,
          milliseconds: 0,
        });
      }
    },
  },
});

;// ./node_modules/v-calendar/src/components/TimePicker.vue?vue&type=script&lang=js
 /* harmony default export */ var components_TimePickervue_type_script_lang_js = (TimePickervue_type_script_lang_js); 
;// ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-17.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-17.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-17.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/TimePicker.vue?vue&type=style&index=0&id=68d0690f&prod&lang=postcss&scoped=true
// extracted by mini-css-extract-plugin

;// ./node_modules/v-calendar/src/components/TimePicker.vue?vue&type=style&index=0&id=68d0690f&prod&lang=postcss&scoped=true

;// ./node_modules/v-calendar/src/components/TimePicker.vue



;


/* normalize component */

var TimePicker_component = normalizeComponent(
  components_TimePickervue_type_script_lang_js,
  TimePickervue_type_template_id_68d0690f_scoped_true_render,
  TimePickervue_type_template_id_68d0690f_scoped_true_staticRenderFns,
  false,
  null,
  "68d0690f",
  null
  
)

/* harmony default export */ var TimePicker = (TimePicker_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./node_modules/v-calendar/src/components/DatePicker.vue?vue&type=script&lang=js










const _baseConfig = {
  type: 'auto',
  mask: 'iso', // String mask when `type === 'string'`
  timeAdjust: '', // 'HH:MM:SS', 'now'
};

const _config = [_baseConfig, _baseConfig];

const MODE = {
  DATE: 'date',
  DATE_TIME: 'datetime',
  TIME: 'time',
};

const RANGE_PRIORITY = {
  NONE: 0,
  START: 1,
  END: 2,
  BOTH: 3,
};

/* harmony default export */ var DatePickervue_type_script_lang_js = ({
  name: 'DatePicker',
  render(h) {
    // Timepicker renderer
    const timePicker = () => {
      if (!this.dateParts) return null;
      const parts = this.isRange ? this.dateParts : [this.dateParts[0]];
      return h('div', [
        ...parts.map((dp, idx) => {
          const hourOptions = this.$locale.getHourOptions(
            this.modelConfig_[idx].validHours,
            dp,
          );
          const minuteOptions = this.$locale.getMinuteOptions(
            this.modelConfig_[idx].minuteIncrement,
            dp,
          );
          return h(TimePicker, {
            props: {
              value: dp,
              locale: this.$locale,
              theme: this.$theme,
              is24hr: this.is24hr,
              minuteIncrement: this.minuteIncrement,
              showBorder: !this.isTime,
              isDisabled: (this.isDateTime && !dp.isValid) || this.isDragging,
              hourOptions,
              minuteOptions,
            },
            on: { input: p => this.onTimeInput(p, idx === 0) },
          });
        }),
        this.$scopedSlots.footer && this.$scopedSlots.footer(),
      ]);
    };
    // Calendar renderer
    const calendar = () =>
      h(Calendar, {
        attrs: {
          ...this.$attrs,
          attributes: this.attributes_,
          theme: this.$theme,
          locale: this.$locale,
        },
        props: {
          minDate: this.minDateExact || this.minDate,
          maxDate: this.maxDateExact || this.maxDate,
          disabledDates: this.disabledDates,
          availableDates: this.availableDates,
        },
        on: {
          ...this.$listeners,
          dayclick: this.onDayClick,
          daykeydown: this.onDayKeydown,
          daymouseenter: this.onDayMouseEnter,
        },
        scopedSlots: {
          ...this.$scopedSlots,
          footer: this.isDateTime ? timePicker : this.$scopedSlots.footer,
        },
        ref: 'calendar',
      });
    // Content renderer
    const content = () => {
      if (this.isTime) {
        return h(
          'div',
          {
            class: [
              'vc-container',
              `vc-${this.$theme.color}`,
              { 'vc-is-dark': this.$theme.isDark },
            ],
          },
          [timePicker()],
        );
      }
      return calendar();
    };
    return (
      (this.$scopedSlots.default &&
        // Convert this span to a fragment when supported in Vue
        h('span', [
          // Slot content
          this.$scopedSlots.default(this.slotArgs),
          // Popover content
          h(Popover, {
            props: {
              id: this.datePickerPopoverId,
              placement: 'bottom-start',
              contentClass: `vc-container${this.isDark ? ' vc-is-dark' : ''}`,
            },
            on: {
              beforeShow: e => this.$emit('popoverWillShow', e),
              afterShow: e => this.$emit('popoverDidShow', e),
              beforeHide: e => this.$emit('popoverWillHide', e),
              afterHide: e => this.$emit('popoverDidHide', e),
            },
            scopedSlots: {
              default() {
                return content();
              },
            },
            ref: 'popover',
          }),
        ])) ||
      content()
    );
  },
  mixins: [mixins_rootMixin],
  props: {
    mode: { type: String, default: MODE.DATE },
    value: { type: null, required: true },
    modelConfig: { type: Object, default: () => ({}) },
    is24hr: Boolean,
    minuteIncrement: Number,
    isRequired: Boolean,
    isRange: Boolean,
    updateOnInput: Boolean,
    inputDebounce: Number,
    popover: { type: Object, default: () => ({}) },
    dragAttribute: Object,
    selectAttribute: Object,
    attributes: Array,
    validHours: [Object, Array, Function],
  },
  data() {
    return {
      value_: null,
      dateParts: null,
      activeDate: '',
      dragValue: null,
      inputValues: ['', ''],
      updateTimeout: null,
      watchValue: true,
      datePickerPopoverId: createGuid(),
    };
  },
  computed: {
    updateOnInput_() {
      return this.propOrDefault('updateOnInput', 'datePicker.updateOnInput');
    },
    inputDebounce_() {
      return this.propOrDefault('inputDebounce', 'datePicker.inputDebounce');
    },
    isDate() {
      return this.mode.toLowerCase() === MODE.DATE;
    },
    isDateTime() {
      return this.mode.toLowerCase() === MODE.DATE_TIME;
    },
    isTime() {
      return this.mode.toLowerCase() === MODE.TIME;
    },
    isDragging() {
      return !!this.dragValue && this.isRange;
    },
    modelConfig_() {
      return this.normalizeConfig(this.modelConfig, _config);
    },
    inputMask() {
      const masks = this.$locale.masks;
      if (this.isTime) {
        return this.is24hr ? masks.inputTime24hr : masks.inputTime;
      }
      if (this.isDateTime) {
        return this.is24hr ? masks.inputDateTime24hr : masks.inputDateTime;
      }
      return this.$locale.masks.input;
    },
    inputMaskHasTime() {
      return /[Hh]/g.test(this.inputMask);
    },
    inputMaskHasDate() {
      return /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(this.inputMask);
    },
    inputMaskPatch() {
      if (this.inputMaskHasTime && this.inputMaskHasDate) {
        return PATCH.DATE_TIME;
      }
      if (this.inputMaskHasDate) return PATCH.DATE;
      if (this.inputMaskHasTime) return PATCH.TIME;
      return undefined;
    },
    slotArgs() {
      const {
        isRange,
        isDragging,
        updateValue,
        showPopover,
        hidePopover,
        togglePopover,
      } = this;
      const inputValue = isRange
        ? {
            start: this.inputValues[0],
            end: this.inputValues[1],
          }
        : this.inputValues[0];
      const events = [true, false].map(isStart => ({
        input: this.onInputInput(isStart),
        change: this.onInputChange(isStart),
        keyup: this.onInputKeyup,
        ...getPopoverTriggerEvents({
          ...this.popover_,
          id: this.datePickerPopoverId,
          callback: e => {
            if (e.action === 'show' && e.completed) {
              this.onInputShow(isStart);
            }
          },
        }),
      }));
      const inputEvents = isRange
        ? {
            start: events[0],
            end: events[1],
          }
        : events[0];
      return {
        inputValue,
        inputEvents,
        isDragging,
        updateValue,
        showPopover,
        hidePopover,
        togglePopover,
        getPopoverTriggerEvents: getPopoverTriggerEvents,
      };
    },
    popover_() {
      return this.propOrDefault('popover', 'datePicker.popover', 'merge');
    },
    selectAttribute_() {
      if (!this.hasValue(this.value_)) return null;
      const attribute = {
        key: 'select-drag',
        ...this.selectAttribute,
        dates: this.value_,
        pinPage: true,
      };
      const { dot, bar, highlight, content } = attribute;
      if (!dot && !bar && !highlight && !content) {
        attribute.highlight = true;
      }
      return attribute;
    },
    dragAttribute_() {
      if (!this.isRange || !this.hasValue(this.dragValue)) {
        return null;
      }
      const attribute = {
        key: 'select-drag',
        ...this.dragAttribute,
        dates: this.dragValue,
      };
      const { dot, bar, highlight, content } = attribute;
      if (!dot && !bar && !highlight && !content) {
        attribute.highlight = {
          startEnd: {
            fillMode: 'outline',
          },
        };
      }
      return attribute;
    },
    attributes_() {
      const attrs = isArrayLikeObject_default()(this.attributes) ? [...this.attributes] : [];
      if (this.dragAttribute_) {
        attrs.push(this.dragAttribute_);
      } else if (this.selectAttribute_) {
        attrs.push(this.selectAttribute_);
      }
      return attrs;
    },
  },
  watch: {
    inputMask() {
      this.formatInput();
    },
    value(newValue) {
      if (!this.watchValue) return;
      this.forceUpdateValue(newValue, {
        config: this.modelConfig_,
        notify: false,
        formatInput: true,
        hidePopover: false,
      });
    },
    value_() {
      this.refreshDateParts();
    },
    dragValue() {
      this.refreshDateParts();
    },
    timezone() {
      this.refreshDateParts();
      this.forceUpdateValue(this.value_, { formatInput: true });
    },
  },
  created() {
    this.value_ = this.normalizeValue(
      this.value,
      this.modelConfig_,
      PATCH.DATE_TIME,
      RANGE_PRIORITY.BOTH,
    );
    this.forceUpdateValue(this.value, {
      config: this.modelConfig_,
      formatInput: true,
      hidePopover: false,
    });
    this.refreshDateParts();
  },
  mounted() {
    // Handle escape key presses
    on(document, 'keydown', this.onDocumentKeyDown);
    // Clear drag on background click
    on(document, 'click', this.onDocumentClick);
  },
  destroyed() {
    off(document, 'keydown', this.onDocumentKeyDown);
    off(document, 'click', this.onDocumentClick);
  },
  methods: {
    getDateParts(date) {
      return this.$locale.getDateParts(date);
    },
    getDateFromParts(parts) {
      return this.$locale.getDateFromParts(parts);
    },
    refreshDateParts() {
      const value = this.dragValue || this.value_;
      const dateParts = [];
      if (this.isRange) {
        if (value && value.start) {
          dateParts.push(this.getDateParts(value.start));
        } else {
          dateParts.push({});
        }
        if (value && value.end) {
          dateParts.push(this.getDateParts(value.end));
        } else {
          dateParts.push({});
        }
      } else if (value) {
        if (value && value.start) {
          dateParts.push(this.getDateParts(value.start));
        } else {
          dateParts.push(this.getDateParts(value));
        }
      } else {
        dateParts.push({});
      }
      this.$nextTick(() => (this.dateParts = dateParts));
    },
    onDocumentKeyDown(e) {
      // Clear drag on escape keydown
      if (this.dragValue && e.key === 'Escape') {
        this.dragValue = null;
      }
    },
    onDocumentClick(e) {
      if (
        document.body.contains(e.target) &&
        !elementContains(this.$el, e.target)
      ) {
        this.dragValue = null;
        this.formatInput();
      }
    },
    onDayClick(day) {
      this.handleDayClick(day);
      // Re-emit event
      this.$emit('dayclick', day);
    },
    onDayKeydown(day) {
      switch (day.event.key) {
        case ' ':
        case 'Enter': {
          this.handleDayClick(day);
          day.event.preventDefault();
          break;
        }
        case 'Escape': {
          this.hidePopover();
        }
      }
      // Re-emit event
      this.$emit('daykeydown', day);
    },
    handleDayClick(day) {
      const { keepVisibleOnInput, visibility } = this.popover_;
      const opts = {
        patch: PATCH.DATE,
        adjustTime: true,
        formatInput: true,
        hidePopover:
          this.isDate && !keepVisibleOnInput && visibility !== 'visible',
      };
      if (this.isRange) {
        if (!this.isDragging) {
          this.dragTrackingValue = { ...day.range };
        } else {
          this.dragTrackingValue.end = day.date;
        }
        opts.isDragging = !this.isDragging;
        opts.rangePriority = opts.isDragging
          ? RANGE_PRIORITY.NONE
          : RANGE_PRIORITY.BOTH;
        opts.hidePopover = opts.hidePopover && !opts.isDragging;
        this.updateValue(this.dragTrackingValue, opts);
      } else {
        opts.clearIfEqual = !this.isRequired;
        this.updateValue(day.date, opts);
      }
    },
    onDayMouseEnter(day) {
      if (!this.isDragging) return;
      this.dragTrackingValue.end = day.date;
      this.updateValue(this.dragTrackingValue, {
        patch: PATCH.DATE,
        adjustTime: true,
        formatInput: true,
        hidePopover: false,
        rangePriority: RANGE_PRIORITY.NONE,
      });
    },
    onTimeInput(parts, isStart) {
      let value = null;
      if (this.isRange) {
        const start = isStart ? parts : this.dateParts[0];
        const end = isStart ? this.dateParts[1] : parts;
        value = { start, end };
      } else {
        value = parts;
      }
      this.updateValue(value, {
        patch: PATCH.TIME,
        rangePriority: isStart ? RANGE_PRIORITY.START : RANGE_PRIORITY.END,
      }).then(() => this.adjustPageRange(isStart));
    },
    onInputInput(isStart) {
      return e => {
        if (!this.updateOnInput_) return;
        this.onInputUpdate(e.target.value, isStart, {
          formatInput: false,
          hidePopover: false,
          debounce: this.inputDebounce_,
        });
      };
    },
    onInputChange(isStart) {
      return e => {
        this.onInputUpdate(e.target.value, isStart, {
          formatInput: true,
          hidePopover: false,
        });
      };
    },
    onInputUpdate(inputValue, isStart, opts) {
      this.inputValues.splice(isStart ? 0 : 1, 1, inputValue);
      const value = this.isRange
        ? {
            start: this.inputValues[0],
            end: this.inputValues[1] || this.inputValues[0],
          }
        : inputValue;
      const config = {
        type: 'string',
        mask: this.inputMask,
      };
      this.updateValue(value, {
        ...opts,
        config,
        patch: this.inputMaskPatch,
        rangePriority: isStart ? RANGE_PRIORITY.START : RANGE_PRIORITY.END,
      }).then(() => this.adjustPageRange(isStart));
    },
    onInputShow(isStart) {
      this.adjustPageRange(isStart);
    },
    onInputKeyup(e) {
      // Escape key only
      if (e.key !== 'Escape') return;
      this.updateValue(this.value_, {
        formatInput: true,
        hidePopover: true,
      });
    },
    normalizeConfig(config, baseConfig = this.modelConfig_) {
      config = isArrayLikeObject_default()(config)
        ? config
        : [config.start || config, config.end || config];
      return baseConfig.map((b, i) => ({
        validHours: this.validHours,
        minuteIncrement: this.minuteIncrement,
        ...b,
        ...config[i],
      }));
    },
    updateValue(value, opts = {}) {
      clearTimeout(this.updateTimeout);
      return new Promise(resolve => {
        const { debounce, ...args } = opts;
        if (debounce > 0) {
          this.updateTimeout = setTimeout(() => {
            this.forceUpdateValue(value, args);
            resolve(this.value_);
          }, debounce);
        } else {
          this.forceUpdateValue(value, args);
          resolve(this.value_);
        }
      });
    },
    forceUpdateValue(
      value,
      {
        config = this.modelConfig_,
        patch = PATCH.DATE_TIME,
        clearIfEqual = false,
        formatInput = true,
        hidePopover = false,
        isDragging = this.isDragging,
        rangePriority = RANGE_PRIORITY.BOTH,
      } = {},
    ) {
      // 1. Normalization
      config = this.normalizeConfig(config);
      let normalizedValue = this.normalizeValue(
        value,
        config,
        patch,
        rangePriority,
      );

      // Reset to previous value if it was cleared but is required
      if (!normalizedValue && this.isRequired) {
        normalizedValue = this.value_;
      }

      // Time Adjustment
      normalizedValue = this.adjustTimeForValue(normalizedValue, config);

      // 2. Validation (date or range)
      const isDisabled = this.valueIsDisabled(normalizedValue);
      if (isDisabled) {
        if (isDragging) return;
        normalizedValue = this.value_;
        // Don't allow hiding popover
        hidePopover = false;
      }

      // 3. Assignment
      const valueKey = isDragging ? 'dragValue' : 'value_';
      let valueChanged = !this.valuesAreEqual(this[valueKey], normalizedValue);

      // Clear value if same value selected and clearIfEqual is set
      if (!isDisabled && !valueChanged && clearIfEqual) {
        normalizedValue = null;
        valueChanged = true;
      }

      // Assign value
      if (valueChanged) {
        this.$set(this, valueKey, normalizedValue);
        // Clear drag value if needed
        if (!isDragging) this.dragValue = null;
        // Denormalization
        const denormalizedValue = this.denormalizeValue(normalizedValue);
        // Notification
        const event = this.isDragging ? 'drag' : 'input';
        this.watchValue = false;
        this.$emit(event, denormalizedValue);
        this.$nextTick(() => (this.watchValue = true));
      }

      // 5. Hide popover if needed
      if (hidePopover) this.hidePopover();

      // 6. Format inputs if needed
      if (formatInput) this.formatInput();
    },
    hasValue(value) {
      if (this.isRange) {
        return _isObject(value) && !!value.start && !!value.end;
      }
      return !!value;
    },
    normalizeValue(value, config, patch, rangePriority) {
      if (!this.hasValue(value)) return null;
      if (this.isRange) {
        const result = {};
        const start = value.start > value.end ? value.end : value.start;
        result.start = this.normalizeDate(start, {
          ...config[0],
          fillDate: (this.value_ && this.value_.start) || config[0].fillDate,
          patch,
        });
        const end = value.start > value.end ? value.start : value.end;
        result.end = this.normalizeDate(end, {
          ...config[1],
          fillDate: (this.value_ && this.value_.end) || config[1].fillDate,
          patch,
        });
        return this.sortRange(result, rangePriority);
      }
      return this.normalizeDate(value, {
        ...config[0],
        fillDate: this.value_ || config[0].fillDate,
        patch,
      });
    },
    adjustTimeForValue(value, config) {
      if (!this.hasValue(value)) return null;
      if (this.isRange) {
        return {
          start: this.$locale.adjustTimeForDate(value.start, config[0]),
          end: this.$locale.adjustTimeForDate(value.end, config[1]),
        };
      }
      return this.$locale.adjustTimeForDate(value, config[0]);
    },
    sortRange(range, priority = RANGE_PRIORITY.NONE) {
      const { start, end } = range;
      if (start > end) {
        switch (priority) {
          case RANGE_PRIORITY.START:
            return { start, end: start };
          case RANGE_PRIORITY.END:
            return { start: end, end };
          case RANGE_PRIORITY.BOTH:
            return { start: end, end: start };
        }
      }
      return { start, end };
    },
    denormalizeValue(value, config = this.modelConfig_) {
      if (this.isRange) {
        if (!this.hasValue(value)) return null;
        return {
          start: this.$locale.denormalizeDate(value.start, config[0]),
          end: this.$locale.denormalizeDate(value.end, config[1]),
        };
      }
      return this.$locale.denormalizeDate(value, config[0]);
    },
    valuesAreEqual(a, b) {
      if (this.isRange) {
        const aHasValue = this.hasValue(a);
        const bHasValue = this.hasValue(b);
        if (!aHasValue && !bHasValue) return true;
        if (aHasValue !== bHasValue) return false;
        return datesAreEqual(a.start, b.start) && datesAreEqual(a.end, b.end);
      }
      return datesAreEqual(a, b);
    },
    valueIsDisabled(value) {
      return (
        this.hasValue(value) &&
        this.disabledAttribute &&
        this.disabledAttribute.intersectsDate(value)
      );
    },
    formatInput() {
      this.$nextTick(() => {
        const config = this.normalizeConfig({
          type: 'string',
          mask: this.inputMask,
        });
        const value = this.denormalizeValue(
          this.dragValue || this.value_,
          config,
        );
        if (this.isRange) {
          this.inputValues = [value && value.start, value && value.end];
        } else {
          this.inputValues = [value, ''];
        }
      });
    },
    showPopover(opts = {}) {
      showPopover({
        ref: this.$el,
        ...this.popover_,
        ...opts,
        isInteractive: true,
        id: this.datePickerPopoverId,
      });
    },
    hidePopover(opts = {}) {
      hidePopover({
        hideDelay: 10,
        ...this.popover_,
        ...opts,
        id: this.datePickerPopoverId,
      });
    },
    togglePopover(opts) {
      togglePopover({
        ref: this.$el,
        ...this.popover_,
        ...opts,
        isInteractive: true,
        id: this.datePickerPopoverId,
      });
    },
    adjustPageRange(isStart) {
      this.$nextTick(() => {
        const calendar = this.$refs.calendar;
        const page = this.getPageForValue(isStart);
        const position = isStart ? 1 : -1;
        if (
          page &&
          calendar &&
          !pageIsBetweenPages(page, calendar.firstPage, calendar.lastPage)
        ) {
          calendar.move(page, {
            position,
            transition: 'fade',
          });
        }
      });
    },
    getPageForValue(isStart) {
      if (this.hasValue(this.value_)) {
        return this.pageForDate(
          this.isRange ? this.value_[isStart ? 'start' : 'end'] : this.value_,
        );
      }
      return null;
    },
    move(args, opts) {
      if (this.$refs.calendar) {
        return this.$refs.calendar.move(args, opts);
      }
      return Promise.reject(
        new Error('Navigation disabled while calendar is not yet displayed'),
      );
    },
    focusDate(date, opts) {
      if (this.$refs.calendar) {
        return this.$refs.calendar.focusDate(date, opts);
      }
      return Promise.reject(
        new Error('Navigation disabled while calendar is not yet displayed'),
      );
    },
  },
});

;// ./node_modules/v-calendar/src/components/DatePicker.vue?vue&type=script&lang=js
 /* harmony default export */ var components_DatePickervue_type_script_lang_js = (DatePickervue_type_script_lang_js); 
;// ./node_modules/v-calendar/src/components/DatePicker.vue
var DatePicker_render, DatePicker_staticRenderFns
;



/* normalize component */
;
var DatePicker_component = normalizeComponent(
  components_DatePickervue_type_script_lang_js,
  DatePicker_render,
  DatePicker_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var components_DatePicker = (DatePicker_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/DatePicker/DatePicker.ts?vue&type=script&lang=ts&external





//import vCalendarDatePicker from 'v-calendar/lib/components/date-picker.umd'

var DatePicker = /** @class */function (_super) {
  __extends(DatePicker, _super);
  function DatePicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.inputValue = null;
    _this.initialized = false;
    return _this;
  }
  Object.defineProperty(DatePicker.prototype, "computedPopover", {
    get: function () {
      var _a;
      if (!this.popover) return;
      var popover = (_a = this.popover) !== null && _a !== void 0 ? _a : {};
      if (this.computedReadonly || this.disabled !== false) {
        popover.visibility = 'hidden';
      }
      if (this.positionFixed !== false) {
        popover.positionFixed = true;
      }
      return popover;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DatePicker.prototype, "computedReadonly", {
    get: function () {
      // noinspection PointlessBooleanExpressionJS
      return this.readonly !== false || this.plaintext !== false;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DatePicker.prototype, "computedInputProps", {
    get: function () {
      return merge_default()({
        class: this.inputClass,
        placeholder: this.placeholder,
        disabled: this.disabled,
        readonly: this.computedReadonly
      }, this.inputProps);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DatePicker.prototype, "inputClass", {
    get: function () {
      // noinspection PointlessBooleanExpressionJS
      return Object.assign({
        datepicker: true,
        'form-control': this.plaintext === false,
        'form-control-plaintext': this.plaintext !== false,
        'form-control-sm': this.size === 'sm',
        'form-control-lg': this.size === 'lg',
        'is-valid': this.state === true,
        'is-invalid': this.state === false
      });
    },
    enumerable: false,
    configurable: true
  });
  DatePicker.prototype.mounted = function () {
    var _this = this;
    this.inputElement = this.$refs.input;
    this.setDate(this.value);
    this.$nextTick(function () {
      _this.initialized = true;
    });
  };
  DatePicker.prototype.onInput = function () {
    if (!this.initialized) {
      return;
    }
    this.valid();
    this.$emit('input', this.getValue());
  };
  DatePicker.prototype.watchValue = function (val) {
    if (val !== this.inputValue) {
      this.setDate(val);
    }
  };
  DatePicker.prototype.setDate = function (date) {
    this.inputValue = typeof date === 'string' ? this.momentInstance(date).toDate() : date;
  };
  DatePicker.prototype.momentInstance = function (date) {
    if (this.useUtcToParseDate !== false) {
      return external_moment_default().utc(date);
    } else {
      return external_moment_default()(date);
    }
  };
  DatePicker.prototype.getElement = function () {
    return this.inputElement;
  };
  DatePicker.prototype.getValue = function () {
    return this.computedValue;
  };
  Object.defineProperty(DatePicker.prototype, "computedValue", {
    get: function () {
      var date = this.inputValue;
      if (!(date instanceof Date)) {
        return date;
      } else if (isNaN(date.getDate())) {
        return null;
      }
      return this.momentInstance(date).format('YYYY-MM-DD');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DatePicker.prototype, "customRules", {
    get: function () {
      return {
        date: {
          earliest: this.minDate ? this.momentInstance(this.minDate).format('YYYY-MM-DD') : this.minDate,
          latest: this.maxDate ? this.momentInstance(this.maxDate).format('YYYY-MM-DD') : this.maxDate
        }
      };
    },
    enumerable: false,
    configurable: true
  });
  DatePicker.prototype.setInvalidState = function () {
    this.inputElement.classList.add('is-invalid');
  };
  DatePicker.prototype.removeInvalidState = function () {
    this.inputElement.classList.remove('is-invalid');
  };
  __decorate([Prop({
    default: null
  })], DatePicker.prototype, "value", void 0);
  __decorate([Prop({
    default: null
  })], DatePicker.prototype, "name", void 0);
  __decorate([Prop({
    default: null
  })], DatePicker.prototype, "id", void 0);
  __decorate([Prop({
    default: 'DD/MM/YYYY'
  })], DatePicker.prototype, "placeholder", void 0);
  __decorate([Prop()], DatePicker.prototype, "size", void 0);
  __decorate([Prop({
    default: false
  })], DatePicker.prototype, "disabled", void 0);
  __decorate([Prop({
    default: false
  })], DatePicker.prototype, "readonly", void 0);
  __decorate([Prop({
    default: false
  })], DatePicker.prototype, "plaintext", void 0);
  __decorate([Prop({
    default: false
  })], DatePicker.prototype, "showWeekNumbers", void 0);
  __decorate([Prop({
    default: true
  })], DatePicker.prototype, "keepVisibleOnInput", void 0);
  __decorate([Prop({
    default: null
  })], DatePicker.prototype, "disabledDates", void 0);
  __decorate([Prop({
    default: null
  })], DatePicker.prototype, "availableDates", void 0);
  __decorate([Prop({
    default: function () {
      return {
        visibility: 'click'
      };
    }
  })], DatePicker.prototype, "popover", void 0);
  __decorate([Prop({
    default: false
  })], DatePicker.prototype, "isInline", void 0);
  __decorate([Prop()], DatePicker.prototype, "inputProps", void 0);
  __decorate([Prop()], DatePicker.prototype, "updateOnInput", void 0);
  __decorate([Prop()], DatePicker.prototype, "dragAttribute", void 0);
  __decorate([Prop()], DatePicker.prototype, "selectAttribute", void 0);
  __decorate([Prop({
    default: false
  })], DatePicker.prototype, "isRange", void 0);
  __decorate([Prop({
    default: null
  })], DatePicker.prototype, "minDate", void 0);
  __decorate([Prop({
    default: null
  })], DatePicker.prototype, "maxDate", void 0);
  __decorate([Prop({
    default: false
  })], DatePicker.prototype, "positionFixed", void 0);
  __decorate([Prop({
    default: false
  })], DatePicker.prototype, "useUtcToParseDate", void 0);
  __decorate([Watch('value')], DatePicker.prototype, "watchValue", null);
  DatePicker = __decorate([vue_class_component_esm({
    components: {
      datepicker: components_DatePicker
    }
  })], DatePicker);
  return DatePicker;
}(mixins(mixins_FormValidation));
/* harmony default export */ var DatePickervue_type_script_lang_ts_external = (DatePicker);
;// ./src/components/DatePicker/DatePicker.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DatePicker_DatePickervue_type_script_lang_ts_external = (DatePickervue_type_script_lang_ts_external); 
;// ./src/components/DatePicker/DatePicker.vue





/* normalize component */
;
var DatePicker_DatePicker_component = normalizeComponent(
  DatePicker_DatePickervue_type_script_lang_ts_external,
  DatePickervue_type_template_id_1c32d541_render,
  DatePickervue_type_template_id_1c32d541_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DatePicker_DatePicker = (DatePicker_DatePicker_component.exports);
;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DateTime/DateTime.vue?vue&type=template&id=48dd4abe
var DateTimevue_type_template_id_48dd4abe_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: {
      'kw-form-control': true,
      'datetime-group': true
    }
  }, [_vm.name ? _c('input', {
    ref: "input",
    attrs: {
      "name": _vm.name,
      "type": "hidden",
      "required": _vm.required
    },
    domProps: {
      "value": _vm.computedValue
    }
  }) : _vm._e(), _c('datepicker', {
    staticClass: "date-part",
    attrs: {
      "id": _vm.dateId,
      "name": _vm.dateName,
      "placeholder": _vm.datePlaceholder,
      "min-date": _vm.minDate,
      "max-date": _vm.maxDate,
      "readonly": _vm.readonly,
      "plaintext": _vm.plaintext,
      "size": _vm.size,
      "useUtcToParseDate": _vm.useUtcToParseDate,
      "showWeekNumbers": _vm.showWeekNumbers,
      "keepVisibleOnInput": _vm.keepVisibleOnInput
    },
    on: {
      "input": _vm.onInputDate
    },
    model: {
      value: _vm.date,
      callback: function ($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  }), _c('div', {
    class: {
      'required-indicator': _vm.required !== false,
      'time-part': true
    }
  }, [_c('timepicker', {
    attrs: {
      "id": _vm.timeId,
      "name": _vm.timeName,
      "placeholder": _vm.timePlaceholder,
      "min-time": _vm.minTime,
      "max-time": _vm.maxTime,
      "min-date": _vm.minDateTime,
      "max-date": _vm.maxDateTime,
      "readonly": _vm.readonly,
      "plaintext": _vm.plaintext,
      "size": _vm.size,
      "step": _vm.timeStep
    },
    on: {
      "input": _vm.onInputTime
    },
    model: {
      value: _vm.time,
      callback: function ($$v) {
        _vm.time = $$v;
      },
      expression: "time"
    }
  })], 1)], 1);
};
var DateTimevue_type_template_id_48dd4abe_staticRenderFns = [];

;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TimePicker/TimePicker.vue?vue&type=template&id=14ee3d7c
var TimePickervue_type_template_id_14ee3d7c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: {
      'kw-form-control': true,
      'required-indicator': _vm.required !== false,
      dropdown: true
    }
  }, [_c('div', {
    staticClass: "dropdown kw-form-control"
  }, [_c('b-form-input', {
    ref: "input",
    staticClass: "timepicker",
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "disabled": _vm.disabled,
      "required": _vm.required,
      "autofocus": _vm.autofocus,
      "size": _vm.size,
      "state": _vm.computedState,
      "readonly": _vm.readonly,
      "plaintext": _vm.plaintext,
      "placeholder": _vm.computedPlaceholder,
      "autocomplete": "off",
      "formatter": _vm.formatter
    },
    on: {
      "focus": _vm.onFocus,
      "keydown": _vm.onKeyDown,
      "keyup": _vm.onKeyUp,
      "input": _vm.onInput,
      "blur": _vm.onBlur,
      "change": _vm.onChange
    },
    model: {
      value: _vm.inputValue,
      callback: function ($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  }), _vm.computedDropdownVisibility ? _c('div', {
    staticClass: "dropdown-menu timepicker-dropdown-menu"
  }, _vm._l(_vm.datalist, function (value, key) {
    return _c('button', {
      key: key,
      ref: 'dropdown-entry-' + key,
      refInFor: true,
      class: {
        'dropdown-item': true,
        'active': value.selected,
        'btn-sm': _vm.computedDropdownSize === 'sm',
        'btn-lg': _vm.computedDropdownSize === 'lg'
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.selectValue(value);
        }
      }
    }, [_vm._v(" " + _vm._s(value.text) + " ")]);
  }), 0) : _vm._e()], 1)]);
};
var TimePickervue_type_template_id_14ee3d7c_staticRenderFns = [];

;// ./src/mixins/BootstrapInput.ts


var BootstrapInput = /** @class */function (_super) {
  __extends(BootstrapInput, _super);
  function BootstrapInput() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  __decorate([Prop()], BootstrapInput.prototype, "id", void 0);
  __decorate([Prop()], BootstrapInput.prototype, "name", void 0);
  __decorate([Prop({
    default: null
  })], BootstrapInput.prototype, "placeholder", void 0);
  __decorate([Prop()], BootstrapInput.prototype, "disabled", void 0);
  __decorate([Prop({
    default: false
  })], BootstrapInput.prototype, "required", void 0);
  __decorate([Prop({
    default: false
  })], BootstrapInput.prototype, "autofocus", void 0);
  __decorate([Prop()], BootstrapInput.prototype, "size", void 0);
  __decorate([Prop({
    default: null
  })], BootstrapInput.prototype, "state", void 0);
  __decorate([Prop({
    default: false
  })], BootstrapInput.prototype, "readonly", void 0);
  __decorate([Prop({
    default: false
  })], BootstrapInput.prototype, "plaintext", void 0);
  BootstrapInput = __decorate([vue_class_component_esm], BootstrapInput);
  return BootstrapInput;
}((external_vue_default()));
/* harmony default export */ var mixins_BootstrapInput = (BootstrapInput);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/TimePicker/TimePicker.ts?vue&type=script&lang=ts&external







var TimePickervue_type_script_lang_ts_external_TimePicker = /** @class */function (_super) {
  __extends(TimePicker, _super);
  function TimePicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.dropdownVisibility = false;
    _this.inputValue = '';
    return _this;
  }
  Object.defineProperty(TimePicker.prototype, "computedDropdownVisibility", {
    // Return dropdown visibility
    get: function () {
      return this.dropdownVisibility && this.datalist.length > 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TimePicker.prototype, "computedDropdownSize", {
    // Return size for dropdown
    get: function () {
      var _a, _b;
      return (_b = (_a = this.dropdownSize) !== null && _a !== void 0 ? _a : this.size) !== null && _b !== void 0 ? _b : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TimePicker.prototype, "datalist", {
    // Return dropdown options
    get: function () {
      var _this = this;
      var _a, _b;
      var list = [];
      // noinspection PointlessBooleanExpressionJS
      if (this.plaintext !== false || this.readonly !== false) {
        return list;
      }
      var min = (_a = this.min) !== null && _a !== void 0 ? _a : 0;
      var max = (_b = this.max) !== null && _b !== void 0 ? _b : 23;
      var selectedMarker = false;
      var isSameDay = !this.minDate && !this.maxDate || this.minDate !== null && this.maxDate !== null && this.minDate === this.maxDate;
      var minHour, minMinute;
      if (this.minTime && isSameDay) {
        var _c = this.parseTime(this.minTime),
          hour = _c.hour,
          minute = _c.minute;
        minHour = hour;
        minMinute = minute;
      }
      var maxHour, maxMinute;
      if (this.maxTime && isSameDay) {
        var _d = this.parseTime(this.maxTime),
          hour = _d.hour,
          minute = _d.minute;
        maxHour = hour;
        maxMinute = minute;
      }
      for (var i = minHour !== null && minHour !== void 0 ? minHour : min; i <= (maxHour !== null && maxHour !== void 0 ? maxHour : max); i++) {
        var hour = this.format === '12' && i > 12 ? i - 12 : i;
        var hourPart = hour < 10 ? '0' + hour : hour;
        for (var j = minHour === hour && minMinute ? minMinute : 0; j < (i === maxHour && maxMinute ? maxMinute : 60); j = j + this.step) {
          var minutePart = j < 10 ? '0' + j : j;
          var text = hourPart + ':' + minutePart;
          var value = text + ':00';
          var format = this.format === '12' ? ' ' + (i > 12 ? 'PM' : 'AM') : '';
          var selected = this.inputValue === text;
          if (selected) selectedMarker = true;
          list.push({
            text: hourPart + ':' + minutePart + format,
            value: value + format,
            selected: selected
          });
        }
      }
      if (!selectedMarker) {
        list = list.map(function (value) {
          if (selectedMarker) return value;
          var selected = _this.inputValue && value.text.startsWith(_this.inputValue);
          if (selected) {
            value.selected = selected;
            selectedMarker = true;
          }
          return value;
        });
      }
      return list;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TimePicker.prototype, "computedPlaceholder", {
    // Return placeholder
    get: function () {
      var _a;
      return (_a = this.placeholder) !== null && _a !== void 0 ? _a : '00:00' + (this.withSeconds ? ':00' : '');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TimePicker.prototype, "modelValue", {
    // Return value for v-model
    get: function () {
      var value = this.inputValue && this.inputValue.toUpperCase();
      if (!value) return null;
      var format = '';
      var modelValue;
      if (value.endsWith('AM') || value.endsWith('PM')) {
        var hasSpace = value.substr(value.length - 3, 1) === ' ';
        format = ' ' + value.substr(value.length - 2);
        modelValue = value.substr(0, value.length - (hasSpace ? 3 : 2));
      } else {
        modelValue = value;
      }
      if (!this.withSeconds && modelValue.length === 5) {
        modelValue += ':00';
      }
      return modelValue + format;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TimePicker.prototype, "customRules", {
    // Return validation rule
    get: function () {
      return {
        time: {
          mode: this.format,
          minTime: this.minTime,
          minDate: this.minDate,
          maxTime: this.maxTime,
          maxDate: this.maxDate
        }
      };
    },
    enumerable: false,
    configurable: true
  });
  TimePicker.prototype.parseTime = function (time) {
    return {
      hour: Number(time.substr(0, 2)),
      minute: Number(time.substr(3, 2))
    };
  };
  TimePicker.prototype.formatter = function (val) {
    if (!val) {
      return null;
    }
    return val.substring(0, 5);
  };
  TimePicker.prototype.watchValue = function (val) {
    if (val !== null && val.length === 8 && !this.withSeconds) {
      val = val.substr(0, 5);
    }
    if (val !== this.inputValue) {
      this.inputValue = val;
    }
  };
  TimePicker.prototype.watchInputValue = function (val) {
    this.inputValue = val && val.toUpperCase();
  };
  // Watch datalist change to scroll on selected hour
  TimePicker.prototype.watchDatalist = function () {
    var _this = this;
    if (!this.dropdownVisibility) return;
    external_vue_default().nextTick(function () {
      var dropdown = _this.$el.querySelector('.dropdown-menu');
      if (!dropdown) return;
      var active = dropdown.querySelector('.active');
      if (!active) return;
      dropdown.scrollTop = active ? active.offsetTop : 0;
    });
  };
  TimePicker.prototype.mounted = function () {
    var el = this.$el.querySelector('input');
    if (!el) {
      throw new Error('No input');
    }
    this.inputElement = el;
  };
  TimePicker.prototype.destroyed = function () {
    this.hideDataList();
  };
  // Open dropdown when focus input
  TimePicker.prototype.onFocus = function () {
    this.dropdownVisibility = true;
    window.addEventListener('click', this.onClick);
    this.watchDatalist();
  };
  TimePicker.prototype.hideDataList = function () {
    this.dropdownVisibility = false;
    window.removeEventListener('click', this.onClick);
  };
  // Keydown event tracking to block unauthorized characters
  // and add/prevent ':' character
  TimePicker.prototype.onKeyDown = function (e) {
    this.hideError();
    if (!this.inputValue) {
      return;
    }
    var key = e.key;
    var regex = this.format === '12' ? /^[b-lnoq-z@#&é"'(§è!çà)\-^$ù`,;=°_*¨£%+/.?<>]$/i : /^[a-z@#&é"'(§è!çà)\-^$ù`,;=°_*¨£%+/.?<>]$/i;
    if (!e.metaKey && regex.exec(key) !== null) {
      e.preventDefault();
      return;
    }
    var count = (this.inputValue.match(/:/g) || []).length;
    if (e.key === ':' && (!this.withSeconds && count >= 1 || this.withSeconds && count >= 2)) {
      e.preventDefault();
    }
  };
  // Track keyup event to add ';' character
  TimePicker.prototype.onKeyUp = function () {
    var value = this.inputElement.value;
    if (value.length === 2 || this.withSeconds && value.length === 5) {
      value += ':';
    }
    if (value !== this.inputValue) {
      this.inputValue = value;
    }
  };
  TimePicker.prototype.onInput = function () {
    return this.modelValue;
  };
  TimePicker.prototype.onChange = function () {
    this.valid();
    return this.modelValue;
  };
  TimePicker.prototype.onBlur = function () {
    this.valid();
    return this.modelValue;
  };
  TimePicker.prototype.onClick = function (evt) {
    var isVisible = function (elem) {
      return !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    if (!this.$el.contains(evt.target) && isVisible(this.$el)) {
      this.hideDataList();
    }
  };
  // Select a value in dropdown
  TimePicker.prototype.selectValue = function (value) {
    this.inputValue = value.text;
    this.hideDataList();
    this.onInput();
    this.onChange();
  };
  // Return value for validation
  TimePicker.prototype.getElement = function () {
    var input = this.$refs.input;
    return input.$el;
  };
  // Return value for validation
  TimePicker.prototype.getValue = function () {
    return this.modelValue;
  };
  __decorate([Prop({
    default: null
  })], TimePicker.prototype, "value", void 0);
  __decorate([Prop({
    default: '24'
  })], TimePicker.prototype, "format", void 0);
  __decorate([Prop({
    default: false
  })], TimePicker.prototype, "withSeconds", void 0);
  __decorate([Prop()], TimePicker.prototype, "min", void 0);
  __decorate([Prop()], TimePicker.prototype, "max", void 0);
  __decorate([Prop({
    default: 15
  })], TimePicker.prototype, "step", void 0);
  __decorate([Prop()], TimePicker.prototype, "dropdownSize", void 0);
  __decorate([Prop({
    default: null
  })], TimePicker.prototype, "minTime", void 0);
  __decorate([Prop({
    default: null
  })], TimePicker.prototype, "minDate", void 0);
  __decorate([Prop({
    default: null
  })], TimePicker.prototype, "maxTime", void 0);
  __decorate([Prop({
    default: null
  })], TimePicker.prototype, "maxDate", void 0);
  __decorate([Watch('value', {
    immediate: true
  })], TimePicker.prototype, "watchValue", null);
  __decorate([Watch('inputValue')], TimePicker.prototype, "watchInputValue", null);
  __decorate([Watch('datalist')], TimePicker.prototype, "watchDatalist", null);
  __decorate([Emit('input')], TimePicker.prototype, "onInput", null);
  __decorate([Emit('change')], TimePicker.prototype, "onChange", null);
  __decorate([Emit('blur')], TimePicker.prototype, "onBlur", null);
  TimePicker = __decorate([vue_class_component_esm({
    components: {
      BFormInput: external_bootstrap_vue_namespaceObject.BFormInput
    }
  })], TimePicker);
  return TimePicker;
}(mixins(mixins_FormValidation, mixins_BootstrapInput));
/* harmony default export */ var TimePickervue_type_script_lang_ts_external = (TimePickervue_type_script_lang_ts_external_TimePicker);
;// ./src/components/TimePicker/TimePicker.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TimePicker_TimePickervue_type_script_lang_ts_external = (TimePickervue_type_script_lang_ts_external); 
;// ./src/components/TimePicker/TimePicker.vue





/* normalize component */
;
var TimePicker_TimePicker_component = normalizeComponent(
  TimePicker_TimePickervue_type_script_lang_ts_external,
  TimePickervue_type_template_id_14ee3d7c_render,
  TimePickervue_type_template_id_14ee3d7c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TimePicker_TimePicker = (TimePicker_TimePicker_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/DateTime/DateTime.ts?vue&type=script&lang=ts&external






var DateTime = /** @class */function (_super) {
  __extends(DateTime, _super);
  function DateTime() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.date = null;
    _this.time = null;
    return _this;
  }
  Object.defineProperty(DateTime.prototype, "computedValue", {
    get: function () {
      return this.date && (this.time || !this.time && this.allowOnlyDate !== false) ? this.date + (this.time ? ' ' + this.time : '') : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DateTime.prototype, "minTime", {
    get: function () {
      return this.min ? this.min.substr(11) : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DateTime.prototype, "maxTime", {
    get: function () {
      return this.max ? this.max.substr(11) : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DateTime.prototype, "minDate", {
    get: function () {
      if (!this.min) {
        return null;
      }
      var min = this.min.substr(0, 10);
      return min !== '0000-00-00' ? min : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DateTime.prototype, "minDateTime", {
    get: function () {
      if (!this.min) {
        return this.max ? this.date : null;
      }
      var min = this.min.substr(0, 10);
      return min !== '0000-00-00' ? min : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DateTime.prototype, "maxDate", {
    get: function () {
      if (!this.max) {
        return null;
      }
      var max = this.max.substr(0, 10);
      return max !== '0000-00-00' ? max : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DateTime.prototype, "maxDateTime", {
    get: function () {
      if (!this.max) {
        return this.min ? this.date : null;
      }
      var max = this.max.substr(0, 10);
      return max !== '0000-00-00' ? max : null;
    },
    enumerable: false,
    configurable: true
  });
  DateTime.prototype.mounted = function () {
    if (this.value) {
      this.setLocalValue(this.value);
    }
  };
  DateTime.prototype.watchValue = function (val) {
    this.setLocalValue(val);
  };
  DateTime.prototype.setLocalValue = function (val) {
    if (val === this.date + ' ' + this.time) {
      return;
    }
    if (!val && !this.date && !this.time) {
      this.date = this.time = null;
    } else if (val) {
      this.date = external_moment_default()(val).format('YYYY-MM-DD');
      this.time = val.substr(11);
    }
  };
  DateTime.prototype.onInputDate = function () {
    this.onInput();
    return this.date;
  };
  DateTime.prototype.onInputTime = function () {
    this.onInput();
    return this.time;
  };
  DateTime.prototype.onInput = function () {
    this.valid();
    if (!this.date && !this.time) {
      return null;
    } else {
      return (this.date ? this.date : '0000-00-00') + (this.time ? ' ' + this.time : '');
    }
  };
  DateTime.prototype.getValue = function () {
    return this.computedValue;
  };
  DateTime.prototype.getElement = function () {
    return this.$el;
  };
  __decorate([Prop({
    default: null
  })], DateTime.prototype, "name", void 0);
  __decorate([Prop({
    default: null
  })], DateTime.prototype, "value", void 0);
  __decorate([Prop({
    default: null
  })], DateTime.prototype, "min", void 0);
  __decorate([Prop({
    default: null
  })], DateTime.prototype, "max", void 0);
  __decorate([Prop({
    default: 15
  })], DateTime.prototype, "timeStep", void 0);
  __decorate([Prop()], DateTime.prototype, "disabled", void 0);
  __decorate([Prop({
    default: false
  })], DateTime.prototype, "required", void 0);
  __decorate([Prop({
    default: false
  })], DateTime.prototype, "readonly", void 0);
  __decorate([Prop({
    default: false
  })], DateTime.prototype, "plaintext", void 0);
  __decorate([Prop()], DateTime.prototype, "size", void 0);
  __decorate([Prop()], DateTime.prototype, "dateName", void 0);
  __decorate([Prop()], DateTime.prototype, "dateId", void 0);
  __decorate([Prop()], DateTime.prototype, "datePlaceholder", void 0);
  __decorate([Prop()], DateTime.prototype, "timeName", void 0);
  __decorate([Prop()], DateTime.prototype, "timeId", void 0);
  __decorate([Prop()], DateTime.prototype, "timePlaceholder", void 0);
  __decorate([Prop({
    default: false
  })], DateTime.prototype, "allowOnlyDate", void 0);
  __decorate([Prop({
    default: false
  })], DateTime.prototype, "useUtcToParseDate", void 0);
  __decorate([Prop({
    default: false
  })], DateTime.prototype, "showWeekNumbers", void 0);
  __decorate([Prop({
    default: true
  })], DateTime.prototype, "keepVisibleOnInput", void 0);
  __decorate([Watch('value')], DateTime.prototype, "watchValue", null);
  __decorate([Emit('inputDate')], DateTime.prototype, "onInputDate", null);
  __decorate([Emit('inputTime')], DateTime.prototype, "onInputTime", null);
  __decorate([Emit('input')], DateTime.prototype, "onInput", null);
  DateTime = __decorate([vue_class_component_esm({
    components: {
      timepicker: TimePicker_TimePicker,
      datepicker: DatePicker_DatePicker
    }
  })], DateTime);
  return DateTime;
}(mixins(mixins_FormValidation));
/* harmony default export */ var DateTimevue_type_script_lang_ts_external = (DateTime);
;// ./src/components/DateTime/DateTime.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var DateTime_DateTimevue_type_script_lang_ts_external = (DateTimevue_type_script_lang_ts_external); 
;// ./src/components/DateTime/DateTime.vue





/* normalize component */
;
var DateTime_component = normalizeComponent(
  DateTime_DateTimevue_type_script_lang_ts_external,
  DateTimevue_type_template_id_48dd4abe_render,
  DateTimevue_type_template_id_48dd4abe_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DateTime_DateTime = (DateTime_component.exports);
;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Editor/Editor.vue?vue&type=template&id=7f7ae98e
var Editorvue_type_template_id_7f7ae98e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: {
      'kw-form-control': true,
      'required-indicator': _vm.required !== false,
      'kw-form-editor-sm': _vm.size === 'sm',
      'kw-no-bottom-toolbar': !_vm.computedConfig.charCounterCount && !_vm.computedConfig.toolbarBottom
    }
  }, [_c('froala', {
    ref: "editor",
    attrs: {
      "config": _vm.computedConfig,
      "tag": _vm.tag,
      "name": _vm.name,
      "id": _vm.id
    },
    model: {
      value: _vm.localValue,
      callback: function ($$v) {
        _vm.localValue = $$v;
      },
      expression: "localValue"
    }
  })], 1);
};
var Editorvue_type_template_id_7f7ae98e_staticRenderFns = [];

// EXTERNAL MODULE: external "froala-editor"
var external_froala_editor_ = __webpack_require__(189);
var external_froala_editor_default = /*#__PURE__*/__webpack_require__.n(external_froala_editor_);
;// ./src/components/Editor/themes/simple.ts

var config = {
  enter: (external_froala_editor_default()).ENTER_BR,
  listAdvancedTypes: false,
  quickInsertEnabled: false,
  wordCounterCount: false,
  toolbarButtons: {
    moreText: {
      buttons: ['bold', 'italic', 'underline', '|', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', '|', 'textColor', 'backgroundColor', '|', 'formatUL', 'formatOL', '|', 'strikeThrough', 'outdent', 'indent', 'quote', 'insertLink', 'insertTable', '|', 'insertHR'],
      buttonsVisible: 11
    },
    moreText2: {
      buttons: [],
      buttonsVisible: 11
    },
    moreMisc: {
      buttons: ['undo', 'redo', 'html'],
      align: 'right',
      buttonsVisible: 3
    }
  }
};
/* harmony default export */ var simple = (config);
;// ./src/components/Editor/themes/complete.ts

var complete_config = {
  wordCounterCount: false,
  enter: (external_froala_editor_default()).ENTER_BR,
  toolbarButtons: {
    moreText: {
      buttons: ['bold', 'italic', 'underline', '|', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', '|', 'textColor', 'backgroundColor', '|', 'formatUL', 'formatOL', '|', 'strikeThrough', 'fontFamily', 'fontSize', 'lineHeight', 'clearFormatting'],
      buttonsVisible: 3
    },
    moreParagraph: {
      buttons: ['paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
      buttonsVisible: 3
    },
    moreRich: {
      buttons: ['insertLink', 'insertImage', 'insertTable', 'insertHR', 'insertVideo', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly']
    },
    moreMisc: {
      buttons: ['undo', 'redo', 'html', 'fullscreen'],
      align: 'right',
      buttonsVisible: 5
    }
  }
};
/* harmony default export */ var complete = (complete_config);
;// ./src/components/Editor/themes/pdf.ts

var pdf_config = {
  wordCounterCount: false,
  enter: (external_froala_editor_default()).ENTER_BR,
  toolbarButtons: {
    moreText: {
      buttons: ['bold', 'italic', 'underline', '|', 'fontSize', '|', 'formatUL', 'formatOL', '|', 'insertImage', 'insertTable', 'insertHR', '|', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', '|', 'clearFormatting'],
      buttonsVisible: 14
    },
    moreParagraph: {
      buttons: [],
      buttonsVisible: 1
    },
    moreRich: {
      buttons: [],
      buttonsVisible: 1
    },
    moreMisc: {
      buttons: ['undo', 'redo', 'html'],
      align: 'right',
      buttonsVisible: 5
    }
  }
};
/* harmony default export */ var pdf = (pdf_config);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins.pkgd.min.js
var plugins_pkgd_min = __webpack_require__(4458);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/align.min.js
var align_min = __webpack_require__(6782);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/colors.min.js
var colors_min = __webpack_require__(9291);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/lists.min.js
var lists_min = __webpack_require__(6418);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/code_view.min.js
var code_view_min = __webpack_require__(9152);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/link.min.js
var link_min = __webpack_require__(9699);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/quote.min.js
var quote_min = __webpack_require__(4007);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/font_family.min.js
var font_family_min = __webpack_require__(1817);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/font_size.min.js
var font_size_min = __webpack_require__(4812);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/video.min.js
var video_min = __webpack_require__(264);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/table.min.js
var table_min = __webpack_require__(6975);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/emoticons.min.js
var emoticons_min = __webpack_require__(654);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/special_characters.min.js
var special_characters_min = __webpack_require__(3211);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/image.min.js
var image_min = __webpack_require__(1346);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/fullscreen.min.js
var fullscreen_min = __webpack_require__(2802);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/word_paste.min.js
var word_paste_min = __webpack_require__(5119);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/plugins/line_height.min.js
var line_height_min = __webpack_require__(8867);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array-buffer.detached.js
var es_array_buffer_detached = __webpack_require__(6573);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array-buffer.transfer.js
var es_array_buffer_transfer = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array-buffer.transfer-to-fixed-length.js
var es_array_buffer_transfer_to_fixed_length = __webpack_require__(7936);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.difference.v2.js
var es_set_difference_v2 = __webpack_require__(7642);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.intersection.v2.js
var es_set_intersection_v2 = __webpack_require__(8004);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.is-disjoint-from.v2.js
var es_set_is_disjoint_from_v2 = __webpack_require__(3853);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.is-subset-of.v2.js
var es_set_is_subset_of_v2 = __webpack_require__(5876);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.is-superset-of.v2.js
var es_set_is_superset_of_v2 = __webpack_require__(2475);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.symmetric-difference.v2.js
var es_set_symmetric_difference_v2 = __webpack_require__(5024);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.union.v2.js
var es_set_union_v2 = __webpack_require__(1698);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-reversed.js
var es_typed_array_to_reversed = __webpack_require__(7467);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-sorted.js
var es_typed_array_to_sorted = __webpack_require__(4732);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.with.js
var es_typed_array_with = __webpack_require__(9577);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.every.js
var esnext_iterator_every = __webpack_require__(3215);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(7550);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(4603);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(7566);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(8721);
;// ./local_modules/pintura/pintura.js
/*!
 * Pintura Image Editor 8.13.3
 * (c) 2018-2021 PQINA Inc. - All Rights Reserved
 * License: https://pqina.nl/pintura/license/
 *//* eslint-disable */const JFIF_MARKER=0xffe0;const EXIF_MARKER=0xffe1;const SOS_MARKER=0xffda;const Markers={[EXIF_MARKER]:'exif',[JFIF_MARKER]:'jfif',[SOS_MARKER]:'sos'};const JPEG_SOI_MARKER=0xffd8;// start of JPEG
const JPEG_MARKER_PREFIX=0xff;var dataViewGetApplicationMarkers=view=>{// If no SOI marker exit here because we're not going to find the APP1 header in a non-jpeg file
if(view.getUint16(0)!==JPEG_SOI_MARKER)return undefined;const markerTypes=Object.keys(Markers).map(v=>parseInt(v,10));const length=view.byteLength;// cache the length here
let offset=2;// start at 2 as we skip the SOI marker
let marker;// this will hold the current marker
// resulting markers
let res=undefined;while(offset<length){// test if marker is valid JPEG marker (starts with ff)
if(view.getUint8(offset)!==JPEG_MARKER_PREFIX)break;// let's read the full marker
marker=view.getUint16(offset);// read marker if included in marker types, don't
if(markerTypes.includes(marker)){const key=Markers[marker];if(!res)res={};// prevent overwriting by double markers
if(!res[key]){res[key]={offset,size:view.getUint16(offset+2)};}}// Image stream starts here, no markers found
if(marker===SOS_MARKER)break;// next offset is 2 to skip over marker type and then we add marker data size to skip to next marker
offset+=2+view.getUint16(offset+2);}// no APP markers found
return res;};const APP1_MARKER=0xffe1;const APP1_EXIF_IDENTIFIER=0x45786966;const TIFF_MARKER=0x002a;const BYTE_ALIGN_MOTOROLA=0x4d4d;const BYTE_ALIGN_INTEL=0x4949;// offset = start of APP1_MARKER
var dataViewGetExifTags=(view,offset)=>{// If no APP1 marker exit here because we're not going to find the EXIF id header outside of APP1
if(view.getUint16(offset)!==APP1_MARKER)return undefined;// get marker size
const size=view.getUint16(offset+2);// 14197
// Let's skip over app1 marker and size marker (2 + 2 bytes)
offset+=4;// We're now at the EXIF header marker (we'll only check the first 4 bytes, reads "exif"), if not there, exit
if(view.getUint32(offset)!==APP1_EXIF_IDENTIFIER)return undefined;// Let's skip over 6 byte EXIF marker
offset+=6;// Read byte alignment
let byteAlignment=view.getUint16(offset);if(byteAlignment!==BYTE_ALIGN_INTEL&&byteAlignment!==BYTE_ALIGN_MOTOROLA)return undefined;const storedAsLittleEndian=byteAlignment===BYTE_ALIGN_INTEL;// Skip over byte alignment
offset+=2;// Test if valid tiff marker data, should always be 0x002a
if(view.getUint16(offset,storedAsLittleEndian)!==TIFF_MARKER)return undefined;// Skip to first IDF, position of IDF is read after tiff marker (offset 2)
offset+=view.getUint32(offset+2,storedAsLittleEndian);// helper method to find tag offset by marker
const getTagOffsets=marker=>{let offsets=[];let i=offset;let max=offset+size-16;for(;i<max;i+=12){let tagOffset=i;// see if is match, if not, next entry
if(view.getUint16(tagOffset,storedAsLittleEndian)!==marker)continue;// add offset
offsets.push(tagOffset);}return offsets;};return{read:address=>{const tagOffsets=getTagOffsets(address);if(!tagOffsets.length)return undefined;// only return first found tag
return view.getUint16(tagOffsets[0]+8,storedAsLittleEndian);},write:(address,value)=>{const tagOffsets=getTagOffsets(address);if(!tagOffsets.length)return false;// overwrite all found tags (sometimes images can have multiple tags with the same value, let's make sure they're all set)
tagOffsets.forEach(offset=>view.setUint16(offset+8,value,storedAsLittleEndian));return true;}};};const ORIENTATION_TAG=0x0112;var arrayBufferImageExif=(data,key,value)=>{// no data, no go!
if(!data)return;const view=new DataView(data);// Get app1 header offset
const markers=dataViewGetApplicationMarkers(view);if(!markers||!markers.exif)return;// Get EXIF tags read/writer
const tags=dataViewGetExifTags(view,markers.exif.offset);if(!tags)return;// Read the exif orientation marker
return value===undefined?tags.read(key):tags.write(key,value);};const backup='__pqina_webapi__';var getNativeAPIRef=API=>window[backup]?window[backup][API]:window[API];var noop$1=(...args)=>{};const FileReaderDataFormat={ArrayBuffer:'readAsArrayBuffer'};var readFile=(file,onprogress=noop$1,options={})=>new Promise((resolve,reject)=>{const{dataFormat=FileReaderDataFormat.ArrayBuffer}=options;const reader=new(getNativeAPIRef('FileReader'))();reader.onload=()=>resolve(reader.result);reader.onerror=reject;reader.onprogress=onprogress;reader[dataFormat](file);});var blobReadSection=async(blob,slice=[0,blob.size],onprogress)=>await readFile(blob.slice(...slice),onprogress);var getImageOrientationFromFile=async(file,onprogress)=>{const head=await blobReadSection(file,[0,64*1024],onprogress);return arrayBufferImageExif(head,ORIENTATION_TAG)||1;};let result$a=null;var isBrowser=()=>{if(result$a===null)result$a=typeof window!=='undefined'&&typeof window.document!=='undefined';return result$a;};let result$9=null;var canOrientImages=()=>new Promise(resolve=>{if(result$9===null){// 2x1 pixel image 90CW rotated with orientation EXIF header
const testSrc='data:image/jpg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/4QA6RXhpZgAATU0AKgAAAAgAAwESAAMAAAABAAYAAAEoAAMAAAABAAIAAAITAAMAAAABAAEAAAAAAAD/2wBDAP//////////////////////////////////////////////////////////////////////////////////////wAALCAABAAIBASIA/8QAJgABAAAAAAAAAAAAAAAAAAAAAxABAAAAAAAAAAAAAAAAAAAAAP/aAAgBAQAAPwBH/9k=';let testImage=isBrowser()?new Image():{};testImage.onload=()=>{// should correct orientation if is presented in landscape,
// in which case the browser doesn't autocorrect
result$9=testImage.naturalWidth===1;testImage=undefined;resolve(result$9);};testImage.src=testSrc;return;}return resolve(result$9);});var canvasToImageData=canvas=>{const imageData=canvas.getContext('2d').getImageData(0,0,canvas.width,canvas.height);return imageData;};var h=(name,attributes,children=[])=>{const el=document.createElement(name);// @ts-ignore
const descriptors=Object.getOwnPropertyDescriptors(el.__proto__);for(const key in attributes){if(key==='style'){el.style.cssText=attributes[key];}else if(descriptors[key]&&descriptors[key].set||/textContent|innerHTML/.test(key)||typeof attributes[key]==='function'){el[key]=attributes[key];}else{el.setAttribute(key,attributes[key]);}}children.forEach(child=>el.appendChild(child));return el;};const MATRICES={1:()=>[1,0,0,1,0,0],2:width=>[-1,0,0,1,width,0],3:(width,height)=>[-1,0,0,-1,width,height],4:(width,height)=>[1,0,0,-1,0,height],5:()=>[0,1,1,0,0,0],6:(width,height)=>[0,1,-1,0,height,0],7:(width,height)=>[0,-1,-1,0,height,width],8:width=>[0,-1,1,0,0,width]};var getImageOrientationMatrix=(width,height,orientation=-1)=>{if(orientation===-1)orientation=1;return MATRICES[orientation](width,height);};var releaseCanvas=canvas=>{canvas.width=1;canvas.height=1;const ctx=canvas.getContext('2d');ctx&&ctx.clearRect(0,0,1,1);};var isImageData=obj=>'data'in obj;var imageDataToCanvas=async(imageData,orientation=1)=>{const[width,height]=(await canOrientImages())||orientation<5?[imageData.width,imageData.height]:[imageData.height,imageData.width];const canvas=h('canvas',{width,height});const ctx=canvas.getContext('2d');// transform image data ojects into in memory canvas elements so we can transform them (putImageData isn't affect by transforms)
if(isImageData(imageData)&&!(await canOrientImages())&&orientation>1){const inMemoryCanvas=h('canvas',{width:imageData.width,height:imageData.height});const ctx=inMemoryCanvas.getContext('2d');ctx.putImageData(imageData,0,0);imageData=inMemoryCanvas;}// get base transformation matrix
if(!(await canOrientImages())&&orientation>1){ctx.transform.apply(ctx,getImageOrientationMatrix(imageData.width,imageData.height,orientation));}// can't test for instanceof ImageBitmap as Safari doesn't support it
// if still imageData object by this point, we'll use put
if(isImageData(imageData)){ctx.putImageData(imageData,0,0);}else{ctx.drawImage(imageData,0,0);}// if image data is of type canvas, clean it up
if(imageData instanceof HTMLCanvasElement)releaseCanvas(imageData);return canvas;};var orientImageData=async(imageData,orientation=1)=>{if(orientation===1)return imageData;// correct image data for when the browser does not correctly read exif orientation headers
if(!(await canOrientImages()))return canvasToImageData(await imageDataToCanvas(imageData,orientation));return imageData;};var pintura_isObject=v=>typeof v==='object';const copy=val=>pintura_isObject(val)?deepCopy(val):val;const deepCopy=src=>{let dst;if(Array.isArray(src)){dst=[];src.forEach((val,i)=>{dst[i]=copy(val);});}else{dst={};Object.keys(src).forEach(key=>{const val=src[key];dst[key]=copy(val);});}return dst;};var pintura_isString=v=>typeof v==='string';var imageToCanvas=(image,canvasMemoryLimit)=>{// if these are 0 it's possible that we're trying to convert an SVG that doesn't have width or height attributes
// https://bugzilla.mozilla.org/show_bug.cgi?id=1328124
let canvasWidth=image.naturalWidth;let canvasHeight=image.naturalHeight;// determine if requires more memory than limit, if so limit target size
const requiredCanvasMemory=canvasWidth*canvasHeight;if(canvasMemoryLimit&&requiredCanvasMemory>canvasMemoryLimit){const canvasScalar=Math.sqrt(canvasMemoryLimit)/Math.sqrt(requiredCanvasMemory);canvasWidth=Math.floor(canvasWidth*canvasScalar);canvasHeight=Math.floor(canvasHeight*canvasScalar);}// create new canvas element
const canvas=h('canvas');canvas.width=canvasWidth;canvas.height=canvasHeight;const ctx=canvas.getContext('2d');ctx.drawImage(image,0,0,canvasWidth,canvasHeight);return canvas;};// turns image into canvas only after it's fully loaded
var imageToCanvasSafe=(image,canvasMemoryLimit)=>new Promise((resolve,reject)=>{const ready=()=>resolve(imageToCanvas(image,canvasMemoryLimit));if(image.complete&&image.width){// need to test for image.width, on ie11 it will be 0 for object urls
ready();}else{image.onload=ready;image.onerror=reject;}});var blobToCanvas=async(imageBlob,canvasMemoryLimit)=>{const imageElement=h('img',{src:URL.createObjectURL(imageBlob)});const canvas=await imageToCanvasSafe(imageElement,canvasMemoryLimit);URL.revokeObjectURL(imageElement.src);return canvas;};var canCreateImageBitmap=()=>'createImageBitmap'in window;var canCreateOffscreenCanvas=()=>'OffscreenCanvas'in window;var isSVGFile=blob=>/svg/.test(blob.type);var getUniqueId=()=>Math.random().toString(36).substr(2,9);var functionToBlob=fn=>new Blob(['(',typeof fn==='function'?fn.toString():fn,')()'],{type:'application/javascript'});const wrapFunction=fn=>`function () {self.onmessage = function (message) {(${fn.toString()}).apply(null, message.data.content.concat([function (err, response) {
    response = response || {};
    const transfer = 'data' in response ? [response.data.buffer] : 'width' in response ? [response] : [];
    return self.postMessage({ id: message.data.id, content: response, error: err }, transfer);
}]))}}`;const workerPool=new Map();var thread=(fn,args,transferList)=>new Promise((resolve,reject)=>{let workerKey=fn.toString();let pooledWorker=workerPool.get(workerKey);if(!pooledWorker){// create worker for this function
const workerFn=wrapFunction(fn);// create a new web worker
const url=URL.createObjectURL(functionToBlob(workerFn));const messages=new Map();const worker=new Worker(url);// create a pooled worker, this object will contain the worker and active messages
pooledWorker={url,worker,messages,terminate:()=>{pooledWorker.worker.terminate();URL.revokeObjectURL(url);}};// handle received messages
worker.onmessage=function(e){// should receive message id and message
const{id,content,error}=e.data;// message route no longer valid
if(!messages.has(id))return;// get related thread and resolve with returned content
const message=messages.get(id);// remove thread from threads cache
messages.delete(id);// resolve or reject message based on response from worker
error!=null?message.reject(error):message.resolve(content);};// pool this worker
workerPool.set(workerKey,pooledWorker);}// we need a way to remember this message so we generate a unique id and use that as a key for this request, that way we can link the response back to request in the pooledWorker.onmessage handler
const messageId=getUniqueId();pooledWorker.messages.set(messageId,{resolve,reject});// use pooled worker and await response
pooledWorker.worker.postMessage({id:messageId,content:args},transferList);});var blobToImageData=async(imageBlob,canvasMemoryLimit)=>{let imageData;// if can use OffscreenCanvas let's go for it as it will mean we can run this operation on a separate thread
if(canCreateImageBitmap()&&!isSVGFile(imageBlob)&&canCreateOffscreenCanvas()){try{imageData=await thread((file,canvasMemoryLimit,done)=>{createImageBitmap(file).then(bitmap=>{let canvasWidth=bitmap.width;let canvasHeight=bitmap.height;// determine if requires more memory than limit, if so limit target size
const requiredCanvasMemory=canvasWidth*canvasHeight;if(canvasMemoryLimit&&requiredCanvasMemory>canvasMemoryLimit){const canvasScalar=Math.sqrt(canvasMemoryLimit)/Math.sqrt(requiredCanvasMemory);canvasWidth=Math.floor(canvasWidth*canvasScalar);canvasHeight=Math.floor(canvasHeight*canvasScalar);}const canvas=new OffscreenCanvas(canvasWidth,canvasHeight);const ctx=canvas.getContext('2d');ctx.drawImage(bitmap,0,0,canvasWidth,canvasHeight);const imageData=ctx.getImageData(0,0,canvas.width,canvas.height);done(null,imageData);}).catch(err=>{// fail silently
done(err);});},[imageBlob,canvasMemoryLimit]);}catch(err){// fails silently on purpose, we'll try to turn the blob into image data in the main thread
// console.error(err);
}}// use main thread to generate ImageData
if(!imageData||!imageData.width){const canvas=await blobToCanvas(imageBlob,canvasMemoryLimit);imageData=canvasToImageData(canvas);releaseCanvas(canvas);}return imageData;};var canvasToBlob=(canvas,mimeType=undefined,quality=undefined)=>new Promise((resolve,reject)=>{try{canvas.toBlob(blob=>{resolve(blob);},mimeType,quality);}catch(err){reject(err);}});var imageDataToBlob=async(imageData,mimeType,quality)=>{const canvas=await imageDataToCanvas(imageData);const blob=await canvasToBlob(canvas,mimeType,quality);releaseCanvas(canvas);return blob;};var blobWriteSection=(blob,section,slice=[0,blob.size])=>{if(!section)return blob;return new Blob([section,blob.slice(...slice)],{type:blob.type});};var getExtensionFromMimeType=mimeType=>(mimeType.match(/\/([a-z]+)/)||[])[1];var getFilenameWithoutExtension=name=>name.substr(0,name.lastIndexOf('.'))||name;var getExtensionFromFilename=filename=>filename.split('.').pop();const ImageExtensionsRegex=/avif|bmp|gif|jpg|jpeg|jpe|jif|jfif|png|svg|tiff|webp/;/*
Support image mime types
- image/webp
- image/gif
- image/avif
- image/jpeg
- image/png
- image/bmp
- image/svg+xml
*/var getMimeTypeFromExtension=ext=>{// empty string returned if extension not found
if(!ImageExtensionsRegex.test(ext))return'';// return MimeType for this extension
return'image/'+(/jfif|jif|jpe|jpg/.test(ext)?'jpeg':ext==='svg'?'svg+xml':ext);};var getMimeTypeFromFilename=name=>name&&getMimeTypeFromExtension(getExtensionFromFilename(name).toLowerCase());var matchFilenameToMimeType=(filename,mimeType)=>{// get the mime type that matches this extension
const fileMimeType=getMimeTypeFromFilename(filename);// test if type already matches current mime type, no need to change name
if(fileMimeType===mimeType)return filename;// get the extension for this mimetype (gets all characters after the "image/" part)
// if mimeType doesn't yield an extension, use the fileMimeType
const targetMimeTypeExtension=getExtensionFromMimeType(mimeType)||fileMimeType;return`${getFilenameWithoutExtension(filename)}.${targetMimeTypeExtension}`;};var blobToFile=(blob,filename,mimetype)=>{const lastModified=new Date().getTime();const blobHasMimeType=blob.type.length&&!/null|text/.test(blob.type);const blobMimeType=blobHasMimeType?blob.type:mimetype;const name=matchFilenameToMimeType(filename,blobMimeType);try{return new(getNativeAPIRef('File'))([blob],name,{lastModified,type:blobHasMimeType?blob.type:blobMimeType});}catch(err){const file=blobHasMimeType?blob.slice():blob.slice(0,blob.size,blobMimeType);file.lastModified=lastModified;file.name=name;return file;}};var getAspectRatio=(w,h)=>w/h;var passthrough=v=>v;const PI=Math.PI;const HALF_PI=Math.PI/2;const QUART_PI=HALF_PI/2;var isRotatedSideways=a=>{const rotationLimited=Math.abs(a)%Math.PI;return rotationLimited>QUART_PI&&rotationLimited<Math.PI-QUART_PI;};//
// generic
//
const scale=(value,scalar,pivot)=>pivot+(value-pivot)*scalar;const ellipseCreateFromRect=rect=>({x:rect.x+rect.width*0.5,y:rect.y+rect.height*0.5,rx:rect.width*0.5,ry:rect.height*0.5});//
// vector
//
const vectorCreateEmpty=()=>vectorCreate(0,0);const vectorCreate=(x,y)=>({x,y});const vectorCreateFromSize=size=>vectorCreate(size.width,size.height);const vectorCreateFromPointerEvent=e=>vectorCreate(e.pageX,e.pageY);const vectorCreateFromPointerEventOffset=e=>vectorCreate(e.offsetX,e.offsetY);const vectorClone=v=>vectorCreate(v.x,v.y);const vectorInvert=v=>{v.x=-v.x;v.y=-v.y;return v;};const vectorPerpendicular=v=>{const x=v.x;v.x=-v.y;v.y=x;return v;};const vectorRotate=(v,radians,pivot=vectorCreateEmpty())=>{const cos=Math.cos(radians);const sin=Math.sin(radians);const tx=v.x-pivot.x;const ty=v.y-pivot.y;v.x=pivot.x+cos*tx-sin*ty;v.y=pivot.y+sin*tx+cos*ty;return v;};const vectorLength=v=>Math.sqrt(v.x*v.x+v.y*v.y);const vectorNormalize=v=>{const length=Math.sqrt(v.x*v.x+v.y*v.y);if(length===0)return vectorCreateEmpty();v.x/=length;v.y/=length;return v;};const vectorAngle=v=>Math.atan2(v.y,v.x);const vectorAngleBetween=(a,b)=>Math.atan2(b.y-a.y,b.x-a.x);const vectorEqual=(a,b)=>a.x===b.x&&a.y===b.y;const vectorApply=(v,fn)=>{v.x=fn(v.x);v.y=fn(v.y);return v;};const vectorAdd=(a,b)=>{a.x+=b.x;a.y+=b.y;return a;};const vectorSubtract=(a,b)=>{a.x-=b.x;a.y-=b.y;return a;};const vectorMultiply=(v,f)=>{v.x*=f;v.y*=f;return v;};const vectorDot=(a,b)=>a.x*b.x+a.y*b.y;const vectorDistanceSquared=(a,b=vectorCreateEmpty())=>{const x=a.x-b.x;const y=a.y-b.y;return x*x+y*y;};const vectorDistance=(a,b=vectorCreateEmpty())=>Math.sqrt(vectorDistanceSquared(a,b));const vectorCenter=v=>{let x=0;let y=0;v.forEach(v=>{x+=v.x;y+=v.y;});return vectorCreate(x/v.length,y/v.length);};const vectorsFlip=(points,flipX,flipY,cx,cy)=>{points.forEach(point=>{point.x=flipX?cx-(point.x-cx):point.x;point.y=flipY?cy-(point.y-cy):point.y;});return points;};const vectorsRotate=(points,angle,cx,cy)=>{const s=Math.sin(angle);const c=Math.cos(angle);points.forEach(p=>{p.x-=cx;p.y-=cy;const rx=p.x*c-p.y*s;const ry=p.x*s+p.y*c;p.x=cx+rx;p.y=cy+ry;});return points;};//
// size
//
const toSize=(width,height)=>({width,height});const sizeClone=size=>toSize(size.width,size.height);const sizeCreateFromAny=obj=>toSize(obj.width,obj.height);const sizeCreateFromRect=r=>toSize(r.width,r.height);const sizeCreateFromArray=a=>toSize(a[0],a[1]);const sizeCreateFromImageNaturalSize=image=>toSize(image.naturalWidth,image.naturalHeight);const sizeCreateFromElement=element=>{if(/img/i.test(element.nodeName)){return sizeCreateFromImageNaturalSize(element);}return sizeCreateFromAny(element);};const sizeCreate=(width,height)=>toSize(width,height);const sizeEqual=(a,b,format=passthrough)=>format(a.width)===format(b.width)&&format(a.height)===format(b.height);const sizeScale=(size,scalar)=>{size.width*=scalar;size.height*=scalar;return size;};const sizeCenter=size=>vectorCreate(size.width*0.5,size.height*0.5);const sizeRotate=(size,radians)=>{const r=Math.abs(radians);const cos=Math.cos(r);const sin=Math.sin(r);const w=cos*size.width+sin*size.height;const h=sin*size.width+cos*size.height;size.width=w;size.height=h;return size;};const sizeTurn=(size,radians)=>{const w=size.width;const h=size.height;if(isRotatedSideways(radians)){size.width=h;size.height=w;}return size;};const sizeContains=(a,b)=>a.width>=b.width&&a.height>=b.height;const sizeApply=(size,fn)=>{size.width=fn(size.width);size.height=fn(size.height);return size;};const sizeHypotenuse=size=>Math.sqrt(size.width*size.width+size.height*size.height);const sizeMin=(a,b)=>sizeCreate(Math.min(a.width,b.width),Math.min(a.height,b.height));//
// line
//
const lineCreate=(start,end)=>({start,end});const lineClone=line=>lineCreate(vectorClone(line.start),vectorClone(line.end));const lineExtend=(line,amount)=>{if(amount===0)return line;const v=vectorCreate(line.start.x-line.end.x,line.start.y-line.end.y);const n=vectorNormalize(v);const m=vectorMultiply(n,amount);line.start.x+=m.x;line.start.y+=m.y;line.end.x-=m.x;line.end.y-=m.y;return line;};const lineMultiply=(line,amount)=>{if(amount===0)return line;const v=vectorCreate(line.start.x-line.end.x,line.start.y-line.end.y);const n=vectorNormalize(v);const m=vectorMultiply(n,amount);line.end.x+=m.x;line.end.y+=m.y;return line;};const lineExtrude=({start,end},amount)=>{if(amount===0)return[vectorCreate(start.x,start.y),vectorCreate(start.x,start.y),vectorCreate(end.x,end.y),vectorCreate(end.x,end.y)];const a=Math.atan2(end.y-start.y,end.x-start.x);const sina=Math.sin(a)*amount;const cosa=Math.cos(a)*amount;return[vectorCreate(sina+start.x,-cosa+start.y),vectorCreate(-sina+start.x,cosa+start.y),vectorCreate(-sina+end.x,cosa+end.y),vectorCreate(sina+end.x,-cosa+end.y)];};//
// rect
//
const CornerSigns=[vectorCreate(-1,-1),vectorCreate(-1,1),vectorCreate(1,1),vectorCreate(1,-1)];const toRect=(x,y,width,height)=>({x,y,width,height});const rectClone=rect=>toRect(rect.x,rect.y,rect.width,rect.height);const rectCreateEmpty=()=>toRect(0,0,0,0);const rectCreateFromDimensions=(width,height)=>toRect(0,0,width,height);const rectCreateFromSize=size=>toRect(0,0,size.width,size.height);const rectCreateFromAny=obj=>toRect(obj.x||0,obj.y||0,obj.width||0,obj.height||0);const rectCreateFromPoints=(...args)=>{const pts=Array.isArray(args[0])?args[0]:args;let xMin=pts[0].x;let xMax=pts[0].x;let yMin=pts[0].y;let yMax=pts[0].y;pts.forEach(point=>{xMin=Math.min(xMin,point.x);xMax=Math.max(xMax,point.x);yMin=Math.min(yMin,point.y);yMax=Math.max(yMax,point.y);});return toRect(xMin,yMin,xMax-xMin,yMax-yMin);};const rectCreateFromEllipse=ellipse=>rectCreate(ellipse.x-ellipse.rx,ellipse.y-ellipse.ry,ellipse.rx*2,ellipse.ry*2);const rectCreateWithCenter=(center,size)=>toRect(center.x-size.width*0.5,center.y-size.height*0.5,size.width,size.height);const rectCreate=(x,y,width,height)=>toRect(x,y,width,height);const rectCenter=rect=>vectorCreate(rect.x+rect.width*0.5,rect.y+rect.height*0.5);const rectTranslate=(rect,t)=>{rect.x+=t.x;rect.y+=t.y;return rect;};const rectScale=(rect,scalar,pivot)=>{pivot=pivot||rectCenter(rect);rect.x=scalar*(rect.x-pivot.x)+pivot.x;rect.y=scalar*(rect.y-pivot.y)+pivot.y;rect.width=scalar*rect.width;rect.height=scalar*rect.height;return rect;};const rectMultiply=(rect,factor)=>{rect.x*=factor;rect.y*=factor;rect.width*=factor;rect.height*=factor;return rect;};const rectDivide=(rect,factor)=>{rect.x/=factor;rect.y/=factor;rect.width/=factor;rect.height/=factor;return rect;};const rectSubtract=(a,b)=>{a.x-=b.x;a.y-=b.y;a.width-=b.width;a.height-=b.height;return a;};const rectAdd=(a,b)=>{a.x+=b.x;a.y+=b.y;a.width+=b.width;a.height+=b.height;return a;};const rectEqual=(a,b,format=passthrough)=>format(a.x)===format(b.x)&&format(a.y)===format(b.y)&&format(a.width)===format(b.width)&&format(a.height)===format(b.height);const rectAspectRatio=rect=>getAspectRatio(rect.width,rect.height);const rectUpdate=(rect,x,y,width,height)=>{rect.x=x;rect.y=y;rect.width=width;rect.height=height;return rect;};const rectUpdateWithRect=(a,b)=>{a.x=b.x;a.y=b.y;a.width=b.width;a.height=b.height;return a;};const rectRotate=(rect,radians,pivot)=>{if(!pivot)pivot=rectCenter(rect);return rectGetCorners(rect).map(vertex=>vectorRotate(vertex,radians,pivot));};const rectCenterRect=(a,b)=>toRect(a.width*0.5-b.width*0.5,a.height*0.5-b.height*0.5,b.width,b.height);const rectContainsPoint=(rect,point)=>{if(point.x<rect.x)return false;if(point.y<rect.y)return false;if(point.x>rect.x+rect.width)return false;if(point.y>rect.y+rect.height)return false;return true;};const rectCoverRect=(rect,aspectRatio,offset=vectorCreateEmpty())=>{if(rect.width===0||rect.height===0)return rectCreateEmpty();const inputAspectRatio=rectAspectRatio(rect);if(!aspectRatio)aspectRatio=inputAspectRatio;let width=rect.width;let height=rect.height;if(aspectRatio>inputAspectRatio){// height remains the same, width is expanded
width=height*aspectRatio;}else{// width remains the same, height is expanded
height=width/aspectRatio;}return toRect(offset.x+(rect.width-width)*0.5,offset.y+(rect.height-height)*0.5,width,height);};const rectContainRect=(rect,aspectRatio=rectAspectRatio(rect),offset=vectorCreateEmpty())=>{if(rect.width===0||rect.height===0)return rectCreateEmpty();let width=rect.width;let height=width/aspectRatio;if(height>rect.height){height=rect.height;width=height*aspectRatio;}return toRect(offset.x+(rect.width-width)*0.5,offset.y+(rect.height-height)*0.5,width,height);};const rectToBounds=rect=>[Math.min(rect.y,rect.y+rect.height),Math.max(rect.x,rect.x+rect.width),Math.max(rect.y,rect.y+rect.height),Math.min(rect.x,rect.x+rect.width)];const rectGetCorners=rect=>[vectorCreate(rect.x,rect.y),vectorCreate(rect.x+rect.width,rect.y),vectorCreate(rect.x+rect.width,rect.y+rect.height),vectorCreate(rect.x,rect.y+rect.height)];const rectApply=(rect,fn)=>{if(!rect)return;rect.x=fn(rect.x);rect.y=fn(rect.y);rect.width=fn(rect.width);rect.height=fn(rect.height);return rect;};const rectApplyPerspective=(rect,perspective,pivot=rectCenter(rect))=>rectGetCorners(rect).map((corner,index)=>{const sign=CornerSigns[index];return vectorCreate(scale(corner.x,1.0+sign.x*perspective.x,pivot.x),scale(corner.y,1.0+sign.y*perspective.y,pivot.y));});const rectNormalizeOffset=rect=>{rect.x=0;rect.y=0;return rect;};const convexPolyCentroid=vertices=>{const first=vertices[0];const last=vertices[vertices.length-1];// make sure is closed loop
vertices=vectorEqual(first,last)?vertices:[...vertices,first];let twiceArea=0;let i=0;let x=0;let y=0;let fx=first.x;let fy=first.y;let a;let b;let f;const l=vertices.length;for(;i<l;i++){// current vertex
a=vertices[i];// next vertex
b=vertices[i+1>l-1?0:i+1];f=(a.y-fy)*(b.x-fx)-(b.y-fy)*(a.x-fx);twiceArea+=f;x+=(a.x+b.x-2*fx)*f;y+=(a.y+b.y-2*fy)*f;}f=twiceArea*3;return vectorCreate(fx+x/f,fy+y/f);};const lineLineIntersection=(a,b)=>getLineLineIntersectionPoint(a.start,a.end,b.start,b.end);const getLineLineIntersectionPoint=(a,b,c,d)=>{const denominator=(d.y-c.y)*(b.x-a.x)-(d.x-c.x)*(b.y-a.y);// lines are parallel
if(denominator===0)return undefined;const uA=((d.x-c.x)*(a.y-c.y)-(d.y-c.y)*(a.x-c.x))/denominator;const uB=((b.x-a.x)*(a.y-c.y)-(b.y-a.y)*(a.x-c.x))/denominator;// intersection is not on the line itself
if(uA<0||uA>1||uB<0||uB>1)return undefined;// return intersection point
return vectorCreate(a.x+uA*(b.x-a.x),a.y+uA*(b.y-a.y));};// checks if line intersects with one of the lines that can be drawn between the points (in sequence)
const linePointsIntersection=(line,points)=>{const l=points.length;const intersections=[];for(let i=0;i<l-1;i++){const intersection=getLineLineIntersectionPoint(line.start,line.end,points[i],points[i+1]);if(!intersection)continue;intersections.push(intersection);}return intersections.length?intersections:undefined;};// tests if a point is located in a convex polygon
const pointInPoly=(point,vertices)=>{let i;let a;let b;let aX;let aY;let bX;let bY;let edgeX;let edgeY;let d;const l=vertices.length;for(i=0;i<l;i++){// current vertex
a=vertices[i];// next vertex
b=vertices[i+1>l-1?0:i+1];// translate so that point is the origin of the calculation
aX=a.x-point.x;aY=a.y-point.y;bX=b.x-point.x;bY=b.y-point.y;edgeX=aX-bX;edgeY=aY-bY;d=edgeX*aY-edgeY*aX;// 0 is ON the edge, but we check for -0.00001 to fix floating point errors
if(d<-0.00001)return false;}return true;};// first tests if points of a are to be found in b, then does the reverse
const polyIntersectsWithPoly=(a,b)=>!!(a.find(point=>pointInPoly(point,b))||b.find(point=>pointInPoly(point,a)));const quadLines=vertices=>{const arr=[];for(let i=0;i<vertices.length;i++){let next=i+1;if(next===vertices.length)next=0;arr.push(lineCreate(vectorClone(vertices[i]),vectorClone(vertices[next])));}return arr;};const ellipseToPolygon=(center,rx,ry,rotation=0,flipX=false,flipY=false,resolution=12)=>{const points=[];for(let i=0;i<resolution;i++){points.push(vectorCreate(center.x+rx*Math.cos(i*(Math.PI*2)/resolution),center.y+ry*Math.sin(i*(Math.PI*2)/resolution)));}if(flipX||flipY)vectorsFlip(points,flipX,flipY,center.x,center.y);if(rotation)vectorsRotate(points,rotation,center.x,center.y);return points;};var getImageTransformedRect=(imageSize,imageRotation)=>{const imageRect=rectCreateFromSize(imageSize);const imageCenter=rectCenter(imageRect);const imageTransformedVertices=rectRotate(imageRect,imageRotation,imageCenter);return rectNormalizeOffset(rectCreateFromPoints(imageTransformedVertices));};var pintura_isElement=(v,name)=>v instanceof HTMLElement&&(name?new RegExp(`^${name}$`,'i').test(v.nodeName):true);var pintura_isFile=v=>v instanceof File;var canvasToFile=async(canvas,mimeType,quality)=>{const blob=await canvasToBlob(canvas,mimeType,quality);return blobToFile(blob,'canvas');};var getFilenameFromURL=url=>url.split('/').pop().split(/\?|\#/).shift();let isSafari=null;var isSafari$1=()=>{if(isSafari===null)isSafari=isSafari=/^((?!chrome|android).)*safari/i.test(navigator.userAgent);return isSafari;};var getImageElementSize=imageElement=>new Promise((resolve,reject)=>{let shouldAutoRemove=false;// test if image is attached to DOM, if not attached, attach so measurement is correct on Safari
if(!imageElement.parentNode&&isSafari$1()){shouldAutoRemove=true;// has width 0 and height 0 to prevent rendering very big SVGs (without width and height) that will for one frame overflow the window and show a scrollbar
imageElement.style.cssText=`position:absolute;visibility:hidden;pointer-events:none;left:0;top:0;width:0;height:0;`;document.body.appendChild(imageElement);}// start testing size
const measure=()=>{const width=imageElement.naturalWidth;const height=imageElement.naturalHeight;const hasSize=width&&height;if(!hasSize)return;// clean up image if was attached for measuring
if(shouldAutoRemove)imageElement.parentNode.removeChild(imageElement);clearInterval(intervalId);resolve({width,height});};imageElement.onerror=err=>{clearInterval(intervalId);reject(err);};const intervalId=setInterval(measure,1);measure();});var getImageSize=async image=>{// the image element we'll use to load the image
let imageElement=image;// if is not an image element, it must be a valid image source
if(!imageElement.src){imageElement=new Image();imageElement.src=pintura_isString(image)?image:URL.createObjectURL(image);}let size;try{size=await getImageElementSize(imageElement);}finally{pintura_isFile(image)&&URL.revokeObjectURL(imageElement.src);}return size;};const awaitComplete=image=>new Promise((resolve,reject)=>{if(image.complete)return resolve(image);image.onload=()=>resolve(image);image.onerror=reject;});var imageToFile=async imageElement=>{try{const size=await getImageSize(imageElement);const image=await awaitComplete(imageElement);const canvas=document.createElement('canvas');canvas.width=size.width;canvas.height=size.height;const ctx=canvas.getContext('2d');ctx.drawImage(image,0,0);const blob=await canvasToBlob(canvas);return blobToFile(blob,getFilenameFromURL(image.src));}catch(err){throw err;}};var isDataURI=str=>/^data:/.test(str);var createProgressEvent=(loaded=0,lengthComputable=true)=>new(getNativeAPIRef('ProgressEvent'))('progress',{loaded:loaded*100,total:100,lengthComputable});var isImage=file=>/^image/.test(file.type);var dataURIToFile=async(dataURI,filename='data-uri',onprogress=noop$1)=>{// basic loader, no size info
onprogress(createProgressEvent(0));const res=await fetch(dataURI);onprogress(createProgressEvent(0.33));const blob=await res.blob();let mimeType;if(!isImage(blob))mimeType=`image/${dataURI.includes(',/9j/')?'jpeg':'png'}`;onprogress(createProgressEvent(0.66));const file=blobToFile(blob,filename,mimeType);onprogress(createProgressEvent(1));return file;};var getResponseHeader=(xhr,header,parse=header=>header)=>xhr.getAllResponseHeaders().indexOf(header)>=0?parse(xhr.getResponseHeader(header)):undefined;var getFilenameFromContentDisposition=header=>{if(!header)return null;const matches=header.split(/filename=|filename\*=.+''/).splice(1).map(name=>name.trim().replace(/^["']|[;"']{0,2}$/g,'')).filter(name=>name.length);return matches.length?decodeURI(matches[matches.length-1]):null;};const EditorErrorCode={URL_REQUEST:'URL_REQUEST',DOCTYPE_MISSING:'DOCTYPE_MISSING'};class EditorError extends Error{constructor(message,code,metadata){super(message);this.name='EditorError';this.code=code;this.metadata=metadata;}}var fetchFile=(url,onprogress)=>new Promise((resolve,reject)=>{const handleError=()=>reject(new EditorError('Error fetching image',EditorErrorCode.URL_REQUEST,xhr));const xhr=new XMLHttpRequest();xhr.onprogress=onprogress;xhr.onerror=handleError,xhr.onload=()=>{if(!xhr.response||xhr.status>=300||xhr.status<200)return handleError();// we store the response mime type so we can add it to the blob later on, if it's missing (happens on Safari 10)
const mimetype=getResponseHeader(xhr,'Content-Type');// try to get filename and any file instructions as well
const filename=getResponseHeader(xhr,'Content-Disposition',getFilenameFromContentDisposition)||getFilenameFromURL(url);// convert to actual file if possible
resolve(blobToFile(xhr.response,filename,mimetype||getMimeTypeFromFilename(filename)));};xhr.open('GET',url);xhr.responseType='blob';xhr.send();});var urlToFile=(url,onprogress)=>{// use fetch to create blob from data uri
if(isDataURI(url))return dataURIToFile(url,undefined,onprogress);// load file from url
return fetchFile(url,onprogress);};var isBlob=v=>v instanceof Blob&&!(v instanceof File);var srcToFile=async(src,onprogress)=>{if(pintura_isFile(src)||isBlob(src))return src;else if(pintura_isString(src))return await urlToFile(src,onprogress);else if(pintura_isElement(src,'canvas'))return await canvasToFile(src);else if(pintura_isElement(src,'img'))return await imageToFile(src);else{throw new EditorError('Invalid image source','invalid-image-source');}};let result$8=null;var isMac=()=>{if(result$8===null)result$8=isBrowser()&&/^mac/i.test(navigator.platform);return result$8;};var isUserAgent=test=>isBrowser()?RegExp(test).test(window.navigator.userAgent):undefined;let result$7=null;var isIOS=()=>{if(result$7===null)// first part is for iPhones and iPads iOS 12 and below second part is for iPads with iOS 13 and up
result$7=isBrowser()&&(isUserAgent(/iPhone|iPad|iPod/)||isMac()&&navigator.maxTouchPoints>=1);return result$7;};var orientImageSize=async(size,orientation=1)=>{// browser can handle image orientation
if((await canOrientImages())||isIOS())return size;// no need to correct size
if(orientation<5)return size;// correct image size
return sizeCreate(size.height,size.width);};var isJPEG=file=>/jpeg/.test(file.type);var pintura_isPlainObject=obj=>typeof obj=='object'&&obj.constructor==Object;var stringify=value=>!pintura_isPlainObject(value)?value:JSON.stringify(value);var post=(url,dataset,options)=>new Promise((resolve,reject)=>{const{token={},beforeSend=noop$1,onprogress=noop$1}=options;token.cancel=()=>request.abort();const request=new XMLHttpRequest();request.upload.onprogress=onprogress;request.onload=()=>request.status>=200&&request.status<300?resolve(request):reject(request);request.onerror=()=>reject(request);request.ontimeout=()=>reject(request);request.open('POST',encodeURI(url));beforeSend(request);request.send(dataset.reduce((formData,args)=>{// @ts-ignore
formData.append(...args.map(stringify));return formData;},new FormData()));});var ctxRotate=(ctx,rotation=0,pivot)=>{if(rotation===0)return ctx;ctx.translate(pivot.x,pivot.y);ctx.rotate(rotation);ctx.translate(-pivot.x,-pivot.y);return ctx;};var ctxTranslate=(ctx,x,y)=>{ctx.translate(x,y);return ctx;};var ctxScale=(ctx,x,y)=>{ctx.scale(x,y);return ctx;};var cropImageData=async(imageData,options={})=>{const{flipX,flipY,rotation,crop}=options;const imageSize=sizeCreateFromAny(imageData);const shouldFlip=flipX||flipY;const shouldRotate=!!rotation;const cropDefined=crop&&(crop.x||crop.y||crop.width||crop.height);const cropCoversImage=cropDefined&&rectEqual(crop,rectCreateFromSize(imageSize));const shouldCrop=cropDefined&&!cropCoversImage;// skip!
if(!shouldFlip&&!shouldRotate&&!shouldCrop)return imageData;// create drawing context
let imageDataOut;let image=h('canvas',{width:imageData.width,height:imageData.height});image.getContext('2d').putImageData(imageData,0,0);// flip image data
if(shouldFlip){const ctx=h('canvas',{width:image.width,height:image.height}).getContext('2d');ctxScale(ctx,flipX?-1:1,flipY?-1:1);ctx.drawImage(image,flipX?-image.width:0,flipY?-image.height:0);ctx.restore();releaseCanvas(image);image=ctx.canvas;}// rotate image data
if(shouldRotate){// if shouldRotate is true we also receive a crop rect
const outputSize=sizeApply(sizeCreateFromRect(rectCreateFromPoints(rectRotate(rectCreateFromAny(image),rotation))),Math.floor);const ctx=h('canvas',{width:crop.width,height:crop.height}).getContext('2d');ctxTranslate(ctx,-crop.x,-crop.y);ctxRotate(ctx,rotation,sizeCenter(outputSize));ctx.drawImage(image,(outputSize.width-image.width)*0.5,(outputSize.height-image.height)*0.5);ctx.restore();releaseCanvas(image);image=ctx.canvas;}// crop image data
else if(shouldCrop){const ctx=image.getContext('2d');imageDataOut=ctx.getImageData(crop.x,crop.y,crop.width,crop.height);releaseCanvas(image);return imageDataOut;}// done, return resulting image data
const ctx=image.getContext('2d');imageDataOut=ctx.getImageData(0,0,image.width,image.height);releaseCanvas(image);return imageDataOut;};var resizeTransform=(options,done)=>{const{imageData,width,height}=options;const originWidth=imageData.width;const originHeight=imageData.height;const targetWidth=Math.round(width);const targetHeight=Math.round(height);const inputData=imageData.data;const outputData=new Uint8ClampedArray(targetWidth*targetHeight*4);const ratioWidth=originWidth/targetWidth;const ratioHeight=originHeight/targetHeight;const ratioWidthHalf=Math.ceil(ratioWidth*0.5);const ratioHeightHalf=Math.ceil(ratioHeight*0.5);for(let j=0;j<targetHeight;j++){for(let i=0;i<targetWidth;i++){const x2=(i+j*targetWidth)*4;let weight=0;let weights=0;let weightsAlpha=0;let r=0;let g=0;let b=0;let a=0;const centerY=(j+0.5)*ratioHeight;for(let yy=Math.floor(j*ratioHeight);yy<(j+1)*ratioHeight;yy++){const dy=Math.abs(centerY-(yy+0.5))/ratioHeightHalf;const centerX=(i+0.5)*ratioWidth;const w0=dy*dy;for(let xx=Math.floor(i*ratioWidth);xx<(i+1)*ratioWidth;xx++){let dx=Math.abs(centerX-(xx+0.5))/ratioWidthHalf;const w=Math.sqrt(w0+dx*dx);if(w>=-1&&w<=1){weight=2*w*w*w-3*w*w+1;if(weight>0){dx=4*(xx+yy*originWidth);const ref=inputData[dx+3];a+=weight*ref;weightsAlpha+=weight;if(ref<255){weight=weight*ref/250;}r+=weight*inputData[dx];g+=weight*inputData[dx+1];b+=weight*inputData[dx+2];weights+=weight;}}}}outputData[x2]=r/weights;outputData[x2+1]=g/weights;outputData[x2+2]=b/weights;outputData[x2+3]=a/weightsAlpha;}}done(null,{data:outputData,width:targetWidth,height:targetHeight});};var imageDataObjectToImageData=obj=>{if(obj instanceof ImageData){return obj;}let imageData;try{imageData=new ImageData(obj.width,obj.height);}catch(err){// IE + Old EDGE (tested on 12)
const canvas=h('canvas');imageData=canvas.getContext('2d').createImageData(obj.width,obj.height);}imageData.data.set(obj.data);return imageData;};var resizeImageData=async(imageData,options={})=>{const{width,height,fit,upscale}=options;// no need to rescale
if(!width&&!height)return imageData;let targetWidth=width;let targetHeight=height;if(!width){targetWidth=height;}else if(!height){targetHeight=width;}if(fit!=='force'){let scalarWidth=targetWidth/imageData.width;let scalarHeight=targetHeight/imageData.height;let scalar=1;if(fit==='cover'){scalar=Math.max(scalarWidth,scalarHeight);}else if(fit==='contain'){scalar=Math.min(scalarWidth,scalarHeight);}// if image is too small, exit here with original image
if(scalar>1&&upscale===false)return imageData;targetWidth=Math.round(imageData.width*scalar);targetHeight=Math.round(imageData.height*scalar);}// no need to resize?
if(imageData.width===targetWidth&&imageData.height===targetHeight)return imageData;// let's resize!
imageData=await thread(resizeTransform,[{imageData:imageData,width:targetWidth,height:targetHeight}],[imageData.data.buffer]);// the resizer returns a plain object, not an actual image data object, lets create one
return imageDataObjectToImageData(imageData);};var colorEffect=(options,done)=>{const{imageData,matrix}=options;if(!matrix)return done(null,imageData);const outputData=new Uint8ClampedArray(imageData.width*imageData.height*4);const data=imageData.data;const l=data.length;const m11=matrix[0];const m12=matrix[1];const m13=matrix[2];const m14=matrix[3];const m15=matrix[4];const m21=matrix[5];const m22=matrix[6];const m23=matrix[7];const m24=matrix[8];const m25=matrix[9];const m31=matrix[10];const m32=matrix[11];const m33=matrix[12];const m34=matrix[13];const m35=matrix[14];const m41=matrix[15];const m42=matrix[16];const m43=matrix[17];const m44=matrix[18];const m45=matrix[19];let index=0;let r=0.0;let g=0.0;let b=0.0;let a=0.0;let mr=0.0;let mg=0.0;let mb=0.0;let ma=0.0;let or=0.0;let og=0.0;let ob=0.0;for(;index<l;index+=4){r=data[index]/255;g=data[index+1]/255;b=data[index+2]/255;a=data[index+3]/255;mr=r*m11+g*m12+b*m13+a*m14+m15;mg=r*m21+g*m22+b*m23+a*m24+m25;mb=r*m31+g*m32+b*m33+a*m34+m35;ma=r*m41+g*m42+b*m43+a*m44+m45;or=Math.max(0,mr*ma)+(1.0-ma);og=Math.max(0,mg*ma)+(1.0-ma);ob=Math.max(0,mb*ma)+(1.0-ma);outputData[index]=Math.max(0.0,Math.min(1.0,or))*255;outputData[index+1]=Math.max(0.0,Math.min(1.0,og))*255;outputData[index+2]=Math.max(0.0,Math.min(1.0,ob))*255;outputData[index+3]=a*255;}done(null,{data:outputData,width:imageData.width,height:imageData.height});};var convolutionEffect=(options,done)=>{const{imageData,matrix}=options;if(!matrix)return done(null,imageData);// calculate kernel weight
let kernelWeight=matrix.reduce((prev,curr)=>prev+curr);kernelWeight=kernelWeight<=0?1:kernelWeight;// input info
const inputWidth=imageData.width;const inputHeight=imageData.height;const inputData=imageData.data;let i=0;let x=0;let y=0;const side=Math.round(Math.sqrt(matrix.length));const sideHalf=Math.floor(side/2);let r=0,g=0,b=0,a=0,cx=0,cy=0,scy=0,scx=0,srcOff=0,weight=0;const outputData=new Uint8ClampedArray(inputWidth*inputHeight*4);for(y=0;y<inputHeight;y++){for(x=0;x<inputWidth;x++){// calculate the weighed sum of the source image pixels that
// fall under the convolution matrix
r=0;g=0;b=0;a=0;for(cy=0;cy<side;cy++){for(cx=0;cx<side;cx++){scy=y+cy-sideHalf;scx=x+cx-sideHalf;if(scy<0){scy=inputHeight-1;}if(scy>=inputHeight){scy=0;}if(scx<0){scx=inputWidth-1;}if(scx>=inputWidth){scx=0;}srcOff=(scy*inputWidth+scx)*4;weight=matrix[cy*side+cx];r+=inputData[srcOff]*weight;g+=inputData[srcOff+1]*weight;b+=inputData[srcOff+2]*weight;a+=inputData[srcOff+3]*weight;}}outputData[i]=r/kernelWeight;outputData[i+1]=g/kernelWeight;outputData[i+2]=b/kernelWeight;outputData[i+3]=a/kernelWeight;i+=4;}}done(null,{data:outputData,width:inputWidth,height:inputHeight});};var vignetteEffect=(options,done)=>{let{imageData,strength}=options;if(!strength)return done(null,imageData);const outputData=new Uint8ClampedArray(imageData.width*imageData.height*4);const inputWidth=imageData.width;const inputHeight=imageData.height;const inputData=imageData.data;const dist=(x,y)=>{dx=x-cx;dy=y-cy;return Math.sqrt(dx*dx+dy*dy);};let x=0;let y=0;let cx=inputWidth*0.5;let cy=inputHeight*0.5;let dx;let dy;let dm=dist(0,0);let fr,fg,fb;let br,bg,bb,ba;let fa;let ca;const blend=(index,input,output,alpha)=>{br=input[index]/255;bg=input[index+1]/255;bb=input[index+2]/255;ba=input[index+3]/255;fa=1.0-alpha;ca=fa*ba+alpha;output[index]=(fa*ba*br+alpha*fr)/ca*255;output[index+1]=(fa*ba*bg+alpha*fg)/ca*255;output[index+2]=(fa*ba*bb+alpha*fb)/ca*255;output[index+3]=ca*255;};if(strength>0){fr=0;fg=0;fb=0;}else{strength=Math.abs(strength);fr=1;fg=1;fb=1;}for(y=0;y<inputHeight;y++){for(x=0;x<inputWidth;x++){blend(// index
(x+y*inputWidth)*4,// data in
inputData,// data out
outputData,// opacity
dist(x,y)*strength/dm);}}done(null,{data:outputData,width:imageData.width,height:imageData.height});};var noiseEffect=(options,done)=>{const{imageData,level,monochrome=false}=options;if(!level)return done(null,imageData);const outputData=new Uint8ClampedArray(imageData.width*imageData.height*4);const data=imageData.data;const l=data.length;let index=0;let r;let g;let b;const rand=()=>(-1+Math.random()*2)*255*level;const pixel=monochrome?()=>{const average=rand();return[average,average,average];}:()=>{return[rand(),rand(),rand()];};for(;index<l;index+=4){[r,g,b]=pixel();outputData[index]=data[index]+r;outputData[index+1]=data[index+1]+g;outputData[index+2]=data[index+2]+b;outputData[index+3]=data[index+3];}done(null,{data:outputData,width:imageData.width,height:imageData.height});};var gammaEffect=(options,done)=>{const{imageData,level}=options;if(!level)return done(null,imageData);const outputData=new Uint8ClampedArray(imageData.width*imageData.height*4);const data=imageData.data;const l=data.length;let index=0;let r;let g;let b;for(;index<l;index+=4){r=data[index]/255;g=data[index+1]/255;b=data[index+2]/255;outputData[index]=Math.pow(r,level)*255;outputData[index+1]=Math.pow(g,level)*255;outputData[index+2]=Math.pow(b,level)*255;outputData[index+3]=data[index+3];}done(null,{data:outputData,width:imageData.width,height:imageData.height});};var isIdentityMatrix=matrix=>{/*
    [
        1, 0, 0, 0, 0
        0, 1, 0, 0, 0
        0, 0, 1, 0, 0
        0, 0, 0, 1, 0
    ]
    */const l=matrix.length;let v;let s=l>=20?6:l>=16?5:3;for(let i=0;i<l;i++){v=matrix[i];if(v===1&&i%s!==0)return false;else if(v!==0&&v!==1)return false;}return true;};var filterImageData=async(imageData,options={})=>{const{colorMatrix,convolutionMatrix,gamma:gammaLevel,noise:noiseLevel,vignette:vignetteStrength}=options;// filters
const filters=[];// apply convolution matrix
if(convolutionMatrix){filters.push([convolutionEffect,{matrix:convolutionMatrix.clarity}]);}// apply noise
if(gammaLevel>0){filters.push([gammaEffect,{level:1.0/gammaLevel}]);}// apply color matrix
if(colorMatrix&&!isIdentityMatrix(colorMatrix)){filters.push([colorEffect,{matrix:colorMatrix}]);}// apply noise
if(noiseLevel>0||noiseLevel<0){filters.push([noiseEffect,{level:noiseLevel}]);}// apply vignette
if(vignetteStrength>0||vignetteStrength<0){filters.push([vignetteEffect,{strength:vignetteStrength}]);}// no changes
if(!filters.length)return imageData;// builds effect chain
const chain=(transforms,i)=>`(err, imageData) => {
            (${transforms[i][0].toString()})(Object.assign({ imageData: imageData }, filterInstructions[${i}]), 
                ${transforms[i+1]?chain(transforms,i+1):'done'})
        }`;const filterChain=`function (options, done) {
        const filterInstructions = options.filterInstructions;
        const imageData = options.imageData;
        (${chain(filters,0)})(null, imageData)
    }`;imageData=await thread(filterChain,[{imageData:imageData,filterInstructions:filters.map(t=>t[1])}],[imageData.data.buffer]);// the resizer returns a plain object, not an actual image data object, lets create one
return imageDataObjectToImageData(imageData);};var pintura_isNumber=v=>typeof v==='number';var isEmoji=str=>pintura_isString(str)&&str.match(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g)!==null;var hasProp=(obj,key)=>obj.hasOwnProperty(key);var pintura_isFunction=v=>typeof v==='function';var pintura_isArray=arr=>Array.isArray(arr);var isApple=()=>isIOS()||isMac();var isWindows=()=>/^win/i.test(navigator.platform);// macos:   font-size: 123, x: 63.5, y: 110
// windows: font-size: 112, x: 64, y: 103
// android: font-size: 112, x: 64, y: 102
let x=64;let y=102;let fontSize=112;let hasSetValues=false;var getEmojiSVG=(emoji,alt)=>{if(!hasSetValues&&isBrowser()){if(isWindows())y=103;if(isApple()){x=63.5;y=110;fontSize=123;}hasSetValues=true;}return`<svg${alt?` aria-label="${alt}"`:''} width="128" height="128" viewBox="0 0 128 128" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg"><text x="${x}" y="${y}" alignment-baseline="text-top" dominant-baseline="text-top" text-anchor="middle" font-size="${fontSize}px">${emoji}</text></svg>`;};var SVGToDataURL=svg=>`data:image/svg+xml,${svg.replace('<','%3C').replace('>','%3E')}`;var isBinary=v=>v instanceof Blob;var toPercentage=(value,total)=>`${value/total*100}%`;var colorArrayToRGBA=color=>`rgba(${Math.round(color[0]*255)}, ${Math.round(color[1]*255)}, ${Math.round(color[2]*255)}, ${pintura_isNumber(color[3])?color[3]:1})`;const textPadding=20;// font offset
// font size 16 -> 2, 4
// font size 32 -> 4, 6
// font size 64 -> 8, 12
// font size 128 -> 16, 24
// font size 256 -> 32, 48
let fontOffsetBrowser=undefined;const getBrowserFontOffset=fontSize=>{if(!fontOffsetBrowser){// size
const size=32;// let's calculate it
const ctx=createSimpleContext(size,size);updateTextContext(ctx,{fontSize:100,color:'#fff'});ctx.fillText('F',0,0);// get pixel data so we can find the white pixels
const data=ctx.getImageData(0,0,size,size).data;// find x offset
let p=0;let step=4;let to=data.length;let from=to-size*4;for(p=from;p<to;p+=step){if(data[p])break;}const x=(p-from)/step;// find y offset
from=(size-1)*4;step=size*4;for(p=from;p<to;p+=step){if(data[p])break;}const y=(p-from)/step;fontOffsetBrowser=vectorCreate(x,y);// done with canvas
releaseCanvas(ctx.canvas);}return vectorCreate(-fontOffsetBrowser.x*fontSize*0.01,-fontOffsetBrowser.y*fontSize*0.01);};const createSimpleContext=(width=1,height=1)=>{const canvas=h('canvas');const ctx=canvas.getContext('2d');ctx.canvas.width=width;ctx.canvas.height=height;return ctx;};const updateTextContext=(ctx,options)=>{const{fontSize=16,fontFamily='sans-serif',fontWeight='normal',fontVariant='normal',fontStyle='normal',textAlign='left',color='#000'}=options;ctx.font=`${fontStyle} ${fontVariant} ${fontWeight} ${fontSize}px ${fontFamily}`;ctx.textBaseline='top';ctx.textAlign=textAlign;ctx.fillStyle=Array.isArray(color)?colorArrayToRGBA(color):color;};const createSimpleTextContext=options=>{const ctx=createSimpleContext();updateTextContext(ctx,options);return ctx;};const computeLineHeight=(fontSize,lineHeight)=>pintura_isFunction(lineHeight)?lineHeight(fontSize):lineHeight;const getMeasureVisibleWidth=measure=>Math.abs(measure.actualBoundingBoxLeft)+Math.abs(measure.actualBoundingBoxRight);const resizeContextToFitText=(ctx,text,options)=>{const{width,height}=measureTextContext(ctx,text,computeLineHeight(options.fontSize,options.lineHeight));ctx.canvas.width=Math.ceil(width);ctx.canvas.height=Math.ceil(height);return ctx;};const measureTextContext=(ctx,text,computedLineHeight)=>{const storedTextAlign=ctx.textAlign;ctx.textAlign='left';// calculate width
const lines=text.split('\n');const width=lines.reduce((prev,curr)=>{const lineWidth=getMeasureVisibleWidth(ctx.measureText(curr));if(lineWidth>prev){prev=lineWidth;}return prev;},1);ctx.textAlign=storedTextAlign;// calculate height
const height=computedLineHeight*lines.length;return sizeCreate(Math.ceil(width),Math.ceil(height));};const TextSizeCache=new Map();const createTextSizeHash=(text,{fontSize,fontFamily,lineHeight,fontWeight,fontStyle,fontVariant})=>`${[text,fontSize,fontWeight,fontStyle,fontVariant,fontFamily].join('_')}_${pintura_isFunction(lineHeight)?lineHeight(fontSize):lineHeight}`;const textSize=(text,options)=>{const ctx=createSimpleTextContext(options);if(options.width)text=wrapText(ctx,text,options.width);const hash=createTextSizeHash(text,options);let size=TextSizeCache.get(hash);if(size)return{...size};size=measureTextContext(ctx,text,computeLineHeight(options.fontSize,options.lineHeight));TextSizeCache.set(hash,size);return{...size};};const wrapText=(ctx,text,lineWidth)=>{// exit if no text
if(text.length===0)return'';const res=[];let lineBuffer='';let lineIndex=0;let measureWidth;const paragraphs=text.split('\n\n');// draw the current line
const pushLine=()=>{if(!lineBuffer.length)return;if(!res[lineIndex]){res[lineIndex]=[];}res[lineIndex].push(lineBuffer);// clear buffer
lineBuffer='';};const fitChar=char=>{const testLine=lineBuffer+char;// measure width of entire line if adding these chars
measureWidth=ctx.measureText(testLine).width;// fits on line?
if(measureWidth<lineWidth){lineBuffer=testLine;}else{// doesn't fit but line buffer is empty, just print the character and move to next line
if(!lineBuffer.length){lineBuffer=testLine;pushLine();}// fits, lets print current line and move char to next line
else{pushLine();lineBuffer=char;}lineIndex++;}};const fitWord=word=>{const testLine=lineBuffer.length?lineBuffer+' '+word:word;// measure width of entire line if adding these chars
measureWidth=ctx.measureText(testLine).width;// fits on line?
if(measureWidth<lineWidth){lineBuffer=testLine;}// wrap to next line
else{// if line buffer is empty, whole word doesn't fit, need to cut it up
if(!lineBuffer.length){word.split('').forEach(fitChar);}// there are words in the buffer that do fit, let's draw the line and move this word to the next line
else{// draw current buffer
pushLine();lineIndex++;// retry to fit this word
fitWord(word);}}};paragraphs.forEach(p=>{const lines=p.split('\n');lines.forEach(l=>{l.split(' ').forEach(fitWord);// end of line reached, if we have words in our buffer
// at this point we need to draw them and then move to the next line
if(lineBuffer.length)pushLine();// forced new line
lineIndex++;});// forced new line
lineIndex++;});return res.map(line=>line.join(' ')).join('\n');};const drawText$1=(ctx,text='',options={})=>{// exit if no text
if(text.length===0)return ctx;const{x=0,y=0,lineWidth=0,textAlign,fontSize,lineHeight}=options;// determine where the browser will render the font and correct for browser differences
const browserFontOffset=vectorAdd(getBrowserFontOffset(fontSize),vectorCreate(fontSize/12,fontSize/3.75));const fontOffsetX=x+browserFontOffset.x;const fontOffsetY=y+browserFontOffset.y;const lineHeightComputed=pintura_isFunction(lineHeight)?lineHeight(fontSize):lineHeight;let offset=textAlign==='right'?lineWidth:textAlign==='center'?lineWidth*0.5:0;text.split('\n').forEach((line,i)=>{ctx.fillText(line,fontOffsetX+offset,fontOffsetY+i*lineHeightComputed);});return ctx;};var fixPrecision=(value,precision=12)=>parseFloat(value.toFixed(precision));const shapeEqual=(a,b)=>{return JSON.stringify(a)===JSON.stringify(b);};const shapeDeepCopy=shape=>{const shapeShallowCopy={...shape};const shapeDeepCopy=deepCopy(shapeShallowCopy);return shapeDeepCopy;};const getContextSize=(context,size={})=>{const contextAspectRatio=rectAspectRatio(context);let xOut;let yOut;const xIn=size.width||size.rx;const yIn=size.height||size.ry;if(xIn&&yIn)return sizeClone(size);if(xIn||yIn){xOut=parseFloat(xIn||Number.MAX_SAFE_INTEGER);yOut=parseFloat(yIn||Number.MAX_SAFE_INTEGER);const min=Math.min(xOut,yOut);if(pintura_isString(xIn)||pintura_isString(yIn)){xOut=`${min}%`;yOut=`${min*contextAspectRatio}%`;}else{xOut=min;yOut=min;}}else{const min=10;xOut=`${min}%`;yOut=`${min*contextAspectRatio}%`;}const xProp=size.width?'width':size.rx?'rx':undefined;const yProp=size.width?'height':size.rx?'ry':undefined;return{[xProp||'width']:xOut,[yProp||'height']:yOut};};const shapeCreateFromEmoji=(emoji,props={})=>{return{width:undefined,height:undefined,...props,aspectRatio:1,backgroundImage:SVGToDataURL(getEmojiSVG(emoji))};};const shapeCreateFromImage=(src,shapeProps={})=>{const shapeDefaultLayout=shapeIsEllipse(shapeProps)?{}:{width:undefined,height:undefined,aspectRatio:undefined};const shape={// required/default image shape props
backgroundColor:[0,0,0,0],// set default layout props
...shapeDefaultLayout,// merge with custom props
...shapeProps,// set image
backgroundImage:// is svg or URL
pintura_isString(src)?src:isBinary(src)?URL.createObjectURL(src):src};return shape;};const shapeCreateFromPreset=(preset,parentRect)=>{let shape;if(pintura_isString(preset)||isBinary(preset)){// default props for "quick" preset
const shapeOptions={...getContextSize(parentRect),backgroundSize:'contain'};// if is emoji, create default markup,
if(isEmoji(preset)){shape=shapeCreateFromEmoji(preset,shapeOptions);}// is URL, create default markup for image
else{shape=shapeCreateFromImage(preset,shapeOptions);}}else{// is using src shortcut
if(preset.src){const contextSize=getContextSize(parentRect,preset.shape||preset);// shape options
const shapeOptions={// default shape styles
...preset.shape,// precalcualte size of shape in context
...contextSize};// should auto-fix aspect ratio
if(preset.width&&preset.height&&!hasProp(shapeOptions,'aspectRatio')){const width=shapeGetPropPixelValue(contextSize,'width',parentRect);const height=shapeGetPropPixelValue(contextSize,'height',parentRect);shapeOptions.aspectRatio=getAspectRatio(width,height);}// should auto-contain sticker in container
if(!shapeOptions.backgroundSize&&!preset.shape&&(!preset.width||!preset.height))shapeOptions.backgroundSize='contain';// emoji markup
if(isEmoji(preset.src)){shape=shapeCreateFromEmoji(preset.src,shapeOptions);}// is url
else{shape=shapeCreateFromImage(preset.src,shapeOptions);}}// should have markup defined
else if(preset.shape){shape=shapeDeepCopy(preset.shape);}}if(hasProp(shape,'backgroundImage')){// set transparent background if no background color defined
if(!hasProp(shape,'backgroundColor')){shape.backgroundColor=[0,0,0,0];}// for image presets, disable styles by default
if(!hasProp(shape,'disableStyle')){shape.disableStyle=['backgroundColor','strokeColor','strokeWidth'];}// by default don't allow flipping
if(!hasProp(shape,'disableFlip')){shape.disableFlip=true;}}return parentRect?shapeComputeDisplay(shape,parentRect):shape;};const shapeLineGetStartPoint=line=>vectorCreate(line.x1,line.y1);const shapeLineGetEndPoint=line=>vectorCreate(line.x2,line.y2);const shapeTextUID=({text,textAlign,fontSize,fontFamily,lineHeight,fontWeight,fontStyle,fontVariant})=>`${[text,textAlign,fontSize,fontWeight,fontStyle,fontVariant,fontFamily].join('_')}_${pintura_isFunction(lineHeight)?lineHeight(fontSize):lineHeight}`;//#endregion
//#region shape testing
// shape types
const shapeIsText=shape=>hasProp(shape,'text');const shapeIsTextLine=shape=>shapeIsText(shape)&&!(shapeHasRelativeSize(shape)||hasProp(shape,'width'));const shapeIsTextBox=shape=>shapeIsText(shape)&&(shapeHasRelativeSize(shape)||hasProp(shape,'width'));const shapeIsRect=shape=>!shapeIsText(shape)&&shapeHasComputedSize(shape);const shapeIsEllipse=shape=>hasProp(shape,'rx');const shapeIsLine=shape=>hasProp(shape,'x1')&&!shapeIsTriangle(shape);const shapeIsTriangle=shape=>hasProp(shape,'x3');const shapeIsPath=shape=>hasProp(shape,'points');// shape state
const shapeIsTextEmpty=shape=>shapeIsText(shape)&&!shape.text.length;const shapeIsTextEditing=shape=>shapeIsText(shape)&&shape.isEditing;const shapeIsVisible=shape=>hasProp(shape,'opacity')?shape.opacity>0:true;const shapeIsSelected=shape=>shape.isSelected;const shapeIsDraft=shape=>shape._isDraft;const shapeHasSize=shape=>hasProp(shape,'width')&&hasProp(shape,'height');const shapeHasNumericStroke=shape=>pintura_isNumber(shape.strokeWidth)&&shape.strokeWidth>0;// only relevant if is bigger than 0
const shapeHasRelativePosition=shape=>{const hasRight=hasProp(shape,'right');const hasBottom=hasProp(shape,'bottom');return hasRight||hasBottom;};const shapeHasTexture=shape=>hasProp(shape,'backgroundImage')||hasProp(shape,'text');const shapeHasRelativeSize=shape=>(hasProp(shape,'x')||hasProp(shape,'left'))&&hasProp(shape,'right')||(hasProp(shape,'y')||hasProp(shape,'top'))&&hasProp(shape,'bottom');const shapeHasComputedSize=shape=>shapeHasSize(shape)||shapeHasRelativeSize(shape);// actions
const shapeSelect=shape=>{shape.isSelected=true;return shape;};const shapeMakeDraft=shape=>{shape._isDraft=true;return shape;};const shapeMakeFinal=shape=>{shape._isDraft=false;return shape;};// rights
const shapeCanStyle=(shape,style)=>{if(shape.disableStyle===true)return false;if(pintura_isArray(shape.disableStyle)&&style){return!shape.disableStyle.includes(style);}return true;};const shapeCanSelect=shape=>shape.disableSelect!==true&&!shapeIsTriangle(shape);const shapeCanRemove=shape=>shape.disableRemove!==true;const shapeCanDuplicate=shape=>shape.disableDuplicate!==true&&shapeCanMove(shape);const shapeCanReorder=shape=>shape.disableReorder!==true;const shapeCanFlip=shape=>{if(shape.disableFlip)return false;if(shapeIsDraft(shape)||shapeHasRelativePosition(shape))return false;return shapeHasTexture(shape);};const shapeCanInput=(shape,input)=>{if(!shapeIsText(shape))return false;if(shape.disableInput===true)return false;if(pintura_isFunction(shape.disableInput))return shape.disableInput(input!=null?input:shape.text);return input||true;};const shapeCanChangeTextLayout=(shape,layout)=>{if(shape.disableTextLayout===true)return false;if(pintura_isArray(shape.disableTextLayout)&&layout){return!shape.disableTextLayout.includes(layout);}return true;};const shapeCanManipulate=shape=>shape.disableManipulate!==true&&!shapeIsDraft(shape)&&!shapeHasRelativePosition(shape);const shapeCanMove=shape=>shapeCanManipulate(shape)&&shape.disableMove!==true;const shapeCanResize=shape=>shapeCanManipulate(shape)&&shapeCanMove(shape)&&shape.disableResize!==true&&(shapeHasSize(shape)||shapeIsTextBox(shape)||shapeIsEllipse(shape)||shapeIsLine(shape));const shapeCanRotate=shape=>shapeCanManipulate(shape)&&shape.disableRotate!==true&&(shapeHasSize(shape)||hasProp(shape,'text')||shapeIsEllipse(shape));//#endregion
//#region shape formatting
const shapeDeleteRelativeProps=shape=>{delete shape.left;delete shape.right;delete shape.top;delete shape.bottom;return shape;};const shapeDeleteTransformProps=shape=>{delete shape.rotation;return shape;};const shapeFormatStroke=shape=>{shape.strokeWidth=shape.strokeWidth||1;shape.strokeColor=shape.strokeColor||[0,0,0];return shape;};const shapeFormatFill=shape=>{shape.backgroundColor=shape.backgroundColor?shape.backgroundColor:shape.strokeWidth||shape.backgroundImage?undefined:[0,0,0];return shape;};const autoLineHeight=fontSize=>fontSize*1.2;const shapeFormatText=shape=>{shape.fontSize=shape.fontSize||16;shape.fontFamily=shape.fontFamily||'sans-serif';shape.fontWeight=shape.fontWeight||'normal';shape.fontStyle=shape.fontStyle||'normal';shape.fontVariant=shape.fontVariant||'normal';shape.lineHeight=pintura_isNumber(shape.lineHeight)?shape.lineHeight:autoLineHeight;shape.color=shape.color||[0,0,0];return shapeIsTextLine(shape)?shapeFormatTextLine(shape):shapeFormatTextBox(shape);};const shapeFormatTextLine=shape=>{delete shape.textAlign;return shapeDeleteRelativeProps(shape);};const shapeFormatTextBox=shape=>{shape.textAlign=shape.textAlign||'left';return shape;};const shapeFormatRect=shape=>{shape.cornerRadius=shape.cornerRadius||0;shape.strokeWidth=shape.strokeWidth||0;shape.strokeColor=shape.strokeColor||[0,0,0];return shapeFormatFill(shape);};const shapeFormatTriangle=shape=>{shape.strokeWidth=shape.strokeWidth||0;shape.strokeColor=shape.strokeColor||[0,0,0];shapeFormatFill(shape);return shapeDeleteRelativeProps(shape);};const shapeFormatEllipse=shape=>{shape.strokeWidth=shape.strokeWidth||0;shape.strokeColor=shape.strokeColor||[0,0,0];return shapeFormatFill(shape);};const shapeFormatPath=shape=>{shapeFormatStroke(shape);shapeDeleteTransformProps(shape);return shapeDeleteRelativeProps(shape);};const shapeFormatLine=shape=>{shapeFormatStroke(shape);shape.lineStart=shape.lineStart||undefined;shape.lineEnd=shape.lineEnd||undefined;shapeDeleteTransformProps(shape);return shapeDeleteRelativeProps(shape);};const shapeFormatDefaults=shape=>{if(!pintura_isString(shape.id))shape.id=getUniqueId();if(!hasProp(shape,'rotation'))shape.rotation=0;if(!hasProp(shape,'opacity'))shape.opacity=1;if(!hasProp(shape,'disableErase'))shape.disableErase=true;};const shapeFormat=shape=>{shapeFormatDefaults(shape);if(shapeIsText(shape)){shapeFormatText(shape);}else if(shapeIsRect(shape)){shapeFormatRect(shape);}else if(shapeIsPath(shape)){shapeFormatPath(shape);}else if(shapeIsLine(shape)){shapeFormatLine(shape);}else if(shapeIsEllipse(shape)){shapeFormatEllipse(shape);}else if(shapeIsTriangle(shape)){shapeFormatTriangle(shape);}return shape;};const shapeGetDescription=shape=>{if(shapeIsText(shape)){return'text';}else if(shapeIsRect(shape)){return'rectangle';}else if(shapeIsPath(shape)){return'path';}else if(shapeIsLine(shape)){return'line';}else if(shapeIsEllipse(shape)){return'ellipse';}else if(shapeIsTriangle(shape)){return'triangle';}return;};//#endregion
const toPixelValue=(percentage,total)=>parseFloat(percentage)/100*total;//#region shape transforming
const xRegExp=new RegExp(/^x|left|^width|rx|fontSize|cornerRadius|strokeWidth/,'i');const yRegExp=new RegExp(/^y|top|^height|ry/,'i');const rightRegExp=new RegExp(/right/,'i');const bottomRegExp=new RegExp(/bottom/,'i');const compute=(key,value,{width,height})=>{// handle array of percentage values
if(Array.isArray(value)){return value.map(v=>{if(pintura_isObject(v)){// update the object itself
computeProps(v,{width,height});}return v;});}// no need to compute (test with typeof instead of for perf)
if(typeof value!=='string')return value;if(!value.endsWith('%'))return value;const f=parseFloat(value)/100;if(xRegExp.test(key))return fixPrecision(width*f,6);if(yRegExp.test(key))return fixPrecision(height*f,6);if(rightRegExp.test(key))return fixPrecision(width-width*f,6);if(bottomRegExp.test(key))return fixPrecision(height-height*f,6);// dont auto-compute
return value;};const computeProps=(obj,size)=>{return Object.entries(obj).map(([key,value])=>{obj[key]=compute(key,value,size);});};const shapeComputeDisplay=(shape,parentRect)=>{computeProps(shape,parentRect);shapeComputeRect(shape,parentRect);return shape;};const shapeGetPropPixelTotal=(prop,parentRect)=>{let total;if(/^x|width|rx|fontSize|strokeWidth|cornerRadius/.test(prop)){total=parentRect.width;}else if(/^y|height|ry/.test(prop)){total=parentRect.height;}return total;};const shapeUpdateProp=(shape,prop,value,parentRect)=>{if(!pintura_isString(shape[prop])){shape[prop]=value;return shape;}const total=shapeGetPropPixelTotal(prop,parentRect);shape[prop]=total===undefined?value:toPercentage(value,total);return shape;};const shapeGetPropPixelValue=(shape,prop,parentRect)=>{if(!pintura_isString(shape[prop]))return shape[prop];return toPixelValue(shape[prop],shapeGetPropPixelTotal(prop,parentRect));};const shapeGetPropsPixelValues=(shape,props,parentRect)=>{return props.reduce((prev,prop)=>{const value=shapeGetPropPixelValue(shape,prop,parentRect);prev[prop]=value;return prev;},{});};const shapeUpdateProps=(shape,props,parentRect)=>{Object.keys(props).forEach(key=>shapeUpdateProp(shape,key,props[key],parentRect));return shape;};const shapeBounds=shape=>{const rect=rectCreateEmpty();const strokeWidth=shape.strokeWidth||0;if(shapeIsRect(shape)){rect.x=shape.x-strokeWidth*0.5;rect.y=shape.y-strokeWidth*0.5;rect.width=shape.width+strokeWidth;rect.height=shape.height+strokeWidth;}else if(shapeIsLine(shape)){const{x1,y1,x2,y2}=shape;const left=Math.abs(Math.min(x1,x2));const right=Math.abs(Math.max(x1,x2));const top=Math.abs(Math.min(y1,y2));const bottom=Math.abs(Math.min(y1,y2));rect.x=left+strokeWidth*0.5;rect.y=right+strokeWidth*0.5;rect.width=right-left+strokeWidth;rect.height=bottom-top+strokeWidth;}else if(shapeIsEllipse(shape)){rect.x=shape.x-shape.rx+strokeWidth*0.5;rect.y=shape.y-shape.ry+strokeWidth*0.5;rect.width=shape.rx*2+strokeWidth;rect.height=shape.ry*2+strokeWidth;}if(rect&&hasProp(shape,'rotation')){rectRotate(rect,shape.rotation);}return rectToBounds(rect);};const shapesBounds=(shapes,parentRect)=>{const bounds=shapes.filter(shape=>shape.x<0||shape.y<0||shape.x1<0||shape.y1<0).reduce((bounds,shape)=>{const[top,right,bottom,left]=shapeBounds(shape);bounds.top=Math.min(top,bounds.top);bounds.left=Math.min(left,bounds.left);bounds.bottom=Math.max(bottom,bounds.bottom);bounds.right=Math.max(right,bounds.right);return bounds;},{top:0,right:0,bottom:0,left:0});if(bounds.right>0)bounds.right-=parentRect.width;if(bounds.bottom>0)bounds.bottom-=parentRect.height;return bounds;};const shapesFromCompositShape=(shape,parentRect,parser)=>{const shapeCopy=shapeDeepCopy(shape);shapeComputeDisplay(shapeCopy,parentRect);return parser(shapeCopy);};const shapeComputeRect=(shape,parentRect)=>{if(hasProp(shape,'left'))shape.x=shape.left;if(hasProp(shape,'right')){const r=parentRect.width-shape.right;if(hasProp(shape,'left')){shape.x=shape.left;shape.width=Math.max(0,r-shape.left);}else if(hasProp(shape,'width')){shape.x=r-shape.width;}}if(hasProp(shape,'top'))shape.y=shape.top;if(hasProp(shape,'bottom')){const b=parentRect.height-shape.bottom;if(hasProp(shape,'top')){shape.y=shape.top;shape.height=Math.max(0,b-shape.top);}else if(hasProp(shape,'height')){shape.y=b-shape.height;}}return shape;};const shapeComputeTransform=(shape,translate,scale)=>{if(shapeIsPath(shape)){shape.points.filter(point=>pintura_isNumber(point.x)).forEach(point=>{point.x*=scale;point.y*=scale;point.x+=translate.x;point.y+=translate.y;});}if(shapeIsTriangle(shape)&&pintura_isNumber(shape.x1)){shape.x1*=scale;shape.y1*=scale;shape.x2*=scale;shape.y2*=scale;shape.x3*=scale;shape.y3*=scale;shape.x1+=translate.x;shape.y1+=translate.y;shape.x2+=translate.x;shape.y2+=translate.y;shape.x3+=translate.x;shape.y3+=translate.y;}if(shapeIsLine(shape)&&pintura_isNumber(shape.x1)){shape.x1*=scale;shape.y1*=scale;shape.x2*=scale;shape.y2*=scale;shape.x1+=translate.x;shape.y1+=translate.y;shape.x2+=translate.x;shape.y2+=translate.y;}if(pintura_isNumber(shape.x)&&pintura_isNumber(shape.y)){shape.x*=scale;shape.y*=scale;shape.x+=translate.x;shape.y+=translate.y;}if(pintura_isNumber(shape.width)&&pintura_isNumber(shape.height)){shape.width*=scale;shape.height*=scale;}if(pintura_isNumber(shape.rx)&&pintura_isNumber(shape.ry)){shape.rx*=scale;shape.ry*=scale;}if(shapeHasNumericStroke(shape)){shape.strokeWidth*=scale;}if(shapeIsText(shape)&&pintura_isNumber(shape.fontSize)){shape.fontSize*=scale;if(pintura_isNumber(shape.width)&&!pintura_isNumber(shape.width))shape.width*=scale;}if(hasProp(shape,'cornerRadius')&&pintura_isNumber(shape.cornerRadius)){shape.cornerRadius*=scale;}return shape;};const shapeGetCenter=shape=>{if(shapeIsRect(shape)){return vectorCreate(shape.x+shape.width*0.5,shape.y+shape.height*0.5);}if(shapeIsEllipse(shape)){return vectorCreate(shape.x,shape.y);}if(shapeIsTextBox(shape)){const height=shape.height||textSize(shape.text,shape).height;return vectorCreate(shape.x+shape.width*0.5,shape.y+height*0.5);}if(shapeIsTextLine(shape)){const size=textSize(shape.text,shape);return vectorCreate(shape.x+size.width*0.5,shape.y+size.height*0.5);}if(shapeIsPath(shape)){return vectorCenter(shape.points);}if(shapeIsLine(shape)){return vectorCenter([shapeLineGetStartPoint(shape),shapeLineGetEndPoint(shape)]);}return undefined;};//#endregion
var ctxRoundRect=(ctx,x,y,width,height,radius)=>{if(width<2*radius)radius=width/2;if(height<2*radius)radius=height/2;ctx.beginPath();ctx.moveTo(x+radius,y);ctx.arcTo(x+width,y,x+width,y+height,radius);ctx.arcTo(x+width,y+height,x,y+height,radius);ctx.arcTo(x,y+height,x,y,radius);ctx.arcTo(x,y,x+width,y,radius);ctx.closePath();return ctx;};var isCanvas=element=>/canvas/i.test(element.nodeName);var isRemoteURL=url=>new URL(url,location.href).origin!==location.origin;var loadImage=(image,onSize=undefined)=>new Promise((resolve,reject)=>{// the image element we'll use to load the image
let imageElement=image;let sizeCalculated=false;const reportSize=()=>{if(sizeCalculated)return;sizeCalculated=true;pintura_isFunction(onSize)&&/* Use Promise.resolve to make async but place before resolve of parent promise */Promise.resolve().then(()=>onSize(sizeCreate(imageElement.naturalWidth,imageElement.naturalHeight)));};// if is not an image element, it must be a valid image source
if(!imageElement.src){imageElement=new Image();// if is remote image, set crossOrigin
// why not always set crossOrigin? -> because when set this fires two requests,
// one for asking permission and one for downloading the image
if(pintura_isString(image)&&isRemoteURL(image))imageElement.crossOrigin='anonymous';imageElement.src=pintura_isString(image)?image:URL.createObjectURL(image);}if(imageElement.complete){reportSize();return resolve(imageElement);}// try to calculate size faster
if(pintura_isFunction(onSize))getImageElementSize(imageElement).then(reportSize).catch(reject);imageElement.onload=()=>{reportSize();resolve(imageElement);};imageElement.onerror=reject;});var pubsub=()=>{let subs=[];return{sub:(event,callback)=>{subs.push({event,callback});return()=>subs=subs.filter(subscriber=>subscriber.event!==event||subscriber.callback!==callback);},pub:(event,value)=>{subs.filter(sub=>sub.event===event).forEach(sub=>sub.callback(value));}};};const cache=new Map([]);const getImage=(src,options={})=>new Promise((resolve,reject)=>{const{onMetadata=noop$1,onLoad=resolve,onError=reject,onComplete=noop$1}=options;let imageLoadState=cache.get(src);// start loading
if(!imageLoadState){imageLoadState={loading:false,complete:false,error:false,image:undefined,size:undefined,bus:pubsub()};// store
cache.set(src,imageLoadState);}// wait for load
imageLoadState.bus.sub('meta',onMetadata);imageLoadState.bus.sub('load',onLoad);imageLoadState.bus.sub('error',onError);imageLoadState.bus.sub('complete',onComplete);// if is canvas, it's already done
if(isCanvas(src)){const canvas=src;// get image
const image=canvas.cloneNode();// update state
imageLoadState.complete=true;imageLoadState.image=image;imageLoadState.size=sizeCreateFromElement(canvas);}// already loaded
if(imageLoadState.complete){imageLoadState.bus.pub('meta',{size:imageLoadState.size});if(imageLoadState.error){imageLoadState.bus.pub('error',imageLoadState.error);}else{imageLoadState.bus.pub('load',imageLoadState.image);}imageLoadState.bus.pub('complete');// reset subscribers
imageLoadState.bus=pubsub();return;}// already loading, exit here
if(imageLoadState.loading)return;// now loading
imageLoadState.loading=true;// resource needs to be loaded
loadImage(src,size=>{imageLoadState.size=size;imageLoadState.bus.pub('meta',{size});}).then(image=>{imageLoadState.image=image;imageLoadState.bus.pub('load',image);}).catch(err=>{imageLoadState.error=err;imageLoadState.bus.pub('error',err);}).finally(()=>{imageLoadState.complete=true;imageLoadState.loading=false;imageLoadState.bus.pub('complete');// reset subscribers
imageLoadState.bus=pubsub();});});const drawCanvas=(ctx,image,srcRect,destRect)=>ctx.drawImage(image,srcRect.x,srcRect.x,srcRect.width,srcRect.height,destRect.x,destRect.y,destRect.width,destRect.height);var ctxDrawImage=async(ctx,image,srcRect,destRect,draw=drawCanvas)=>{ctx.save();ctx.clip();await draw(ctx,image,srcRect,destRect);ctx.restore();};const getDrawImageParams=(container,backgroundSize,imageSize)=>{let srcRect=rectCreate(0,0,imageSize.width,imageSize.height);const destRect=rectClone(container);if(backgroundSize==='contain'){const rect=rectContainRect(container,rectAspectRatio(srcRect));destRect.width=rect.width;destRect.height=rect.height;destRect.x+=rect.x;destRect.y+=rect.y;}else if(backgroundSize==='cover'){srcRect=rectContainRect(rectCreate(0,0,srcRect.width,srcRect.height),rectAspectRatio(destRect));}return{srcRect,destRect};};const defineRectShape=(ctx,shape)=>{shape.cornerRadius>0?ctxRoundRect(ctx,shape.x,shape.y,shape.width,shape.height,shape.cornerRadius):ctx.rect(shape.x,shape.y,shape.width,shape.height);return ctx;};const fillRectShape=(ctx,shape)=>{shape.backgroundColor&&ctx.fill();return ctx;};const strokeRectShape=(ctx,shape)=>{shape.strokeWidth&&ctx.stroke();return ctx;};var drawRect=async(ctx,shape,options={})=>new Promise(async(resolve,reject)=>{const{drawImage}=options;ctx.lineWidth=shape.strokeWidth?shape.strokeWidth:1;// 1 is default value for lineWidth prop
ctx.strokeStyle=shape.strokeColor?colorArrayToRGBA(shape.strokeColor):'none';ctx.fillStyle=shape.backgroundColor?colorArrayToRGBA(shape.backgroundColor):'none';ctx.globalAlpha=shape.opacity;if(shape.backgroundImage){let image;try{if(isCanvas(shape.backgroundImage)){image=shape.backgroundImage;}else{image=await getImage(shape.backgroundImage);}}catch(err){reject(err);}defineRectShape(ctx,shape);fillRectShape(ctx,shape);const{srcRect,destRect}=getDrawImageParams(shape,shape.backgroundSize,sizeCreateFromElement(image));await ctxDrawImage(ctx,image,srcRect,destRect,drawImage);strokeRectShape(ctx,shape);resolve([]);}else{defineRectShape(ctx,shape);fillRectShape(ctx,shape);strokeRectShape(ctx,shape);resolve([]);}});var drawEllipse=async(ctx,shape,options={})=>new Promise(async(resolve,reject)=>{const{drawImage}=options;ctx.lineWidth=shape.strokeWidth||1;// 1 is default value for lineWidth prop
ctx.strokeStyle=shape.strokeColor?colorArrayToRGBA(shape.strokeColor):'none';ctx.fillStyle=shape.backgroundColor?colorArrayToRGBA(shape.backgroundColor):'none';ctx.globalAlpha=shape.opacity;ctx.ellipse(shape.x,shape.y,shape.rx,shape.ry,0,0,Math.PI*2);shape.backgroundColor&&ctx.fill();if(shape.backgroundImage){let image;try{image=await getImage(shape.backgroundImage);}catch(err){reject(err);}const bounds=rectCreate(shape.x-shape.rx,shape.y-shape.ry,shape.rx*2,shape.ry*2);const{srcRect,destRect}=getDrawImageParams(bounds,shape.backgroundSize,sizeCreateFromElement(image));// @ts-ignore
await ctxDrawImage(ctx,image,srcRect,destRect,drawImage);shape.strokeWidth&&ctx.stroke();resolve([]);}else{shape.strokeWidth&&ctx.stroke();resolve([]);}});var drawText=async(ctx,shape,options)=>{const size=shape.width&&shape.height?sizeCreateFromAny(shape):textSize(shape.text,shape);const rect={x:shape.x,y:shape.y,width:shape.width||size.width,height:size.height};drawRect(ctx,{...shape,...rect,options});updateTextContext(ctx,shape);let tx=0;if(shape.textAlign=='center'){tx=-textPadding*0.5;}else if(shape.textAlign==='right'){tx=-textPadding;}ctx.rect(shape.x+tx,shape.y,shape.width+textPadding*2,shape.height);ctx.save();ctx.clip();drawText$1(ctx,shape.width?wrapText(ctx,shape.text,shape.width):shape.text,{x:shape.x,y:shape.y,fontSize:shape.fontSize,textAlign:shape.textAlign,lineHeight:shape.lineHeight,lineWidth:shape.width});ctx.restore();return[];};// TODO! START
// -----------
var drawLine=async(ctx,shape)=>new Promise(async resolve=>{ctx.lineWidth=shape.strokeWidth||1;// 1 is default value for lineWidth prop
ctx.strokeStyle=shape.strokeColor?colorArrayToRGBA(shape.strokeColor):'none';ctx.globalAlpha=shape.opacity;let lineStartPosition=shapeLineGetStartPoint(shape);let lineEndPosition=shapeLineGetEndPoint(shape);// draw line
ctx.moveTo(lineStartPosition.x,lineStartPosition.y);ctx.lineTo(lineEndPosition.x,lineEndPosition.y);shape.strokeWidth&&ctx.stroke();// draw other shapes
resolve([]);});// TODO! END
// -----------
var drawPath=async(ctx,shape)=>new Promise((resolve,reject)=>{ctx.lineWidth=shape.strokeWidth||1;// 1 is default value for lineWidth prop
ctx.strokeStyle=shape.strokeColor?colorArrayToRGBA(shape.strokeColor):'none';ctx.fillStyle=shape.backgroundColor?colorArrayToRGBA(shape.backgroundColor):'none';ctx.globalAlpha=shape.opacity;// draw line
const{points}=shape;if(shape.pathClose)ctx.beginPath();ctx.moveTo(points[0].x,points[0].y);const l=points.length;for(let i=1;i<l;i++){ctx.lineTo(points[i].x,points[i].y);}if(shape.pathClose)ctx.closePath();shape.strokeWidth&&ctx.stroke();shape.backgroundColor&&ctx.fill();resolve([]);});var ctxFlip=(ctx,flipX,flipY,pivot)=>{if(!flipX&&!flipY)return ctx;ctx.translate(pivot.x,pivot.y);ctx.scale(flipX?-1:1,flipY?-1:1);ctx.translate(-pivot.x,-pivot.y);return ctx;};const drawShape=async(ctx,shape,options)=>{// center, needed for transforms
const center=shapeGetCenter(shape);// rotate context
ctxRotate(ctx,shape.rotation,center);// flip context
ctxFlip(ctx,shape.flipX,shape.flipY,center);let fn;if(shapeIsRect(shape)){fn=drawRect;}else if(shapeIsEllipse(shape)){fn=drawEllipse;}else if(shapeIsLine(shape)){fn=drawLine;}else if(shapeIsPath(shape)){fn=drawPath;}else if(shapeIsText(shape)){fn=drawText;}// get shapes
return fn?[shape,...(await drawShapes(ctx,await fn(ctx,shape,options),options))]:[];};var drawShapes=async(ctx,shapes,options)=>{let drawnShapes=[];for(const shape of shapes){ctx.save();// clears previous shape's path
ctx.beginPath();// wait for shape to draw before drawing next shape
drawnShapes=[...drawnShapes,...(await drawShape(ctx,shape,options))];ctx.restore();}return drawnShapes;};var drawImageData=async(imageData,options={})=>{const{shapes=[],context=imageData,contextBounds=imageData,transform=noop$1,drawImage,preprocessShape=passthrough}=options;// no shapes to draw
if(!shapes.length)return imageData;// create drawing context
const canvas=h('canvas');canvas.width=contextBounds.width;canvas.height=contextBounds.height;const ctx=canvas.getContext('2d');ctx.putImageData(imageData,contextBounds.x||0,contextBounds.y||0);// compute the position of all shapes
const computedShapes=shapes.map(shapeDeepCopy).map(shape=>shapeComputeDisplay(shape,{x:0,y:0,width:context.width,height:context.height}))// need to take into account output size?
.map(preprocessShape).flat();// compute transforms for all shapes
transform(ctx);// draw shapes to canvas
await drawShapes(ctx,computedShapes,{drawImage});const imageDataOut=ctx.getImageData(0,0,canvas.width,canvas.height);releaseCanvas(canvas);return imageDataOut;};var fillImageData=async(imageData,options={})=>{const{backgroundColor}=options;// no background color set or is fully transparent background color
if(!backgroundColor||backgroundColor&&backgroundColor[3]===0)return imageData;// fill
let imageDataOut;let image=h('canvas');image.width=imageData.width;image.height=imageData.height;const ctx=image.getContext('2d');ctx.putImageData(imageData,0,0);// fill behind image
ctx.globalCompositeOperation='destination-over';ctx.fillStyle=colorArrayToRGBA(backgroundColor);ctx.fillRect(0,0,image.width,image.height);imageDataOut=ctx.getImageData(0,0,image.width,image.height);releaseCanvas(image);return imageDataOut;};var dotColorMatrix=(a,b)=>{const res=new Array(20);// R
res[0]=a[0]*b[0]+a[1]*b[5]+a[2]*b[10]+a[3]*b[15];res[1]=a[0]*b[1]+a[1]*b[6]+a[2]*b[11]+a[3]*b[16];res[2]=a[0]*b[2]+a[1]*b[7]+a[2]*b[12]+a[3]*b[17];res[3]=a[0]*b[3]+a[1]*b[8]+a[2]*b[13]+a[3]*b[18];res[4]=a[0]*b[4]+a[1]*b[9]+a[2]*b[14]+a[3]*b[19]+a[4];// G
res[5]=a[5]*b[0]+a[6]*b[5]+a[7]*b[10]+a[8]*b[15];res[6]=a[5]*b[1]+a[6]*b[6]+a[7]*b[11]+a[8]*b[16];res[7]=a[5]*b[2]+a[6]*b[7]+a[7]*b[12]+a[8]*b[17];res[8]=a[5]*b[3]+a[6]*b[8]+a[7]*b[13]+a[8]*b[18];res[9]=a[5]*b[4]+a[6]*b[9]+a[7]*b[14]+a[8]*b[19]+a[9];// B
res[10]=a[10]*b[0]+a[11]*b[5]+a[12]*b[10]+a[13]*b[15];res[11]=a[10]*b[1]+a[11]*b[6]+a[12]*b[11]+a[13]*b[16];res[12]=a[10]*b[2]+a[11]*b[7]+a[12]*b[12]+a[13]*b[17];res[13]=a[10]*b[3]+a[11]*b[8]+a[12]*b[13]+a[13]*b[18];res[14]=a[10]*b[4]+a[11]*b[9]+a[12]*b[14]+a[13]*b[19]+a[14];// A
res[15]=a[15]*b[0]+a[16]*b[5]+a[17]*b[10]+a[18]*b[15];res[16]=a[15]*b[1]+a[16]*b[6]+a[17]*b[11]+a[18]*b[16];res[17]=a[15]*b[2]+a[16]*b[7]+a[17]*b[12]+a[18]*b[17];res[18]=a[15]*b[3]+a[16]*b[8]+a[17]*b[13]+a[18]*b[18];res[19]=a[15]*b[4]+a[16]*b[9]+a[17]*b[14]+a[18]*b[19]+a[19];return res;};var getColorMatrixFromColorMatrices=colorMatrices=>colorMatrices.length?colorMatrices.reduce((previous,current)=>dotColorMatrix([...previous],current),colorMatrices.shift()):[];var roundFraction=(value,fr=2)=>Math.round(value*fr)/fr;var getImageRedactionScaleFactor=(imageSize,redactionShapes)=>{const imageRes=imageSize.width*imageSize.height;const maxShapeSize=redactionShapes.reduce((max,shape)=>{if(shape.width>max.width&&shape.height>max.height){max.width=shape.width;max.height=shape.height;}return max;},{width:0,height:0});const maxShapeRes=maxShapeSize.width*maxShapeSize.height;const fraction=Math.max(0.5,0.5+(1-maxShapeRes/imageRes)/2);return roundFraction(fraction,5);};function pintura_noop(){}const identity=x=>x;function pintura_assign(tar,src){// @ts-ignore
for(const k in src)tar[k]=src[k];return tar;}function run(fn){return fn();}function blank_object(){return Object.create(null);}function run_all(fns){fns.forEach(run);}function is_function(thing){return typeof thing==='function';}function safe_not_equal(a,b){return a!=a?b==b:a!==b||a&&typeof a==='object'||typeof a==='function';}function is_empty(obj){return Object.keys(obj).length===0;}function subscribe(store,...callbacks){if(store==null){return pintura_noop;}const unsub=store.subscribe(...callbacks);return unsub.unsubscribe?()=>unsub.unsubscribe():unsub;}function get_store_value(store){let value;subscribe(store,_=>value=_)();return value;}function component_subscribe(component,store,callback){component.$$.on_destroy.push(subscribe(store,callback));}function create_slot(definition,ctx,$$scope,fn){if(definition){const slot_ctx=get_slot_context(definition,ctx,$$scope,fn);return definition[0](slot_ctx);}}function get_slot_context(definition,ctx,$$scope,fn){return definition[1]&&fn?pintura_assign($$scope.ctx.slice(),definition[1](fn(ctx))):$$scope.ctx;}function get_slot_changes(definition,$$scope,dirty,fn){if(definition[2]&&fn){const lets=definition[2](fn(dirty));if($$scope.dirty===undefined){return lets;}if(typeof lets==='object'){const merged=[];const len=Math.max($$scope.dirty.length,lets.length);for(let i=0;i<len;i+=1){merged[i]=$$scope.dirty[i]|lets[i];}return merged;}return $$scope.dirty|lets;}return $$scope.dirty;}function update_slot(slot,slot_definition,ctx,$$scope,dirty,get_slot_changes_fn,get_slot_context_fn){const slot_changes=get_slot_changes(slot_definition,$$scope,dirty,get_slot_changes_fn);if(slot_changes){const slot_context=get_slot_context(slot_definition,ctx,$$scope,get_slot_context_fn);slot.p(slot_context,slot_changes);}}function exclude_internal_props(props){const result={};for(const k in props)if(k[0]!=='$')result[k]=props[k];return result;}function compute_rest_props(props,keys){const rest={};keys=new Set(keys);for(const k in props)if(!keys.has(k)&&k[0]!=='$')rest[k]=props[k];return rest;}function set_store_value(store,ret,value=ret){store.set(value);return ret;}function action_destroyer(action_result){return action_result&&is_function(action_result.destroy)?action_result.destroy:pintura_noop;}const is_client=typeof window!=='undefined';let now=is_client?()=>window.performance.now():()=>Date.now();let raf=is_client?cb=>requestAnimationFrame(cb):pintura_noop;const tasks=new Set();function run_tasks(now){tasks.forEach(task=>{if(!task.c(now)){tasks.delete(task);task.f();}});if(tasks.size!==0)raf(run_tasks);}/**
 * Creates a new task that runs on each raf frame
 * until it returns a falsy value or is aborted
 */function loop(callback){let task;if(tasks.size===0)raf(run_tasks);return{promise:new Promise(fulfill=>{tasks.add(task={c:callback,f:fulfill});}),abort(){tasks.delete(task);}};}function append(target,node){target.appendChild(node);}function insert(target,node,anchor){target.insertBefore(node,anchor||null);}function detach(node){node.parentNode.removeChild(node);}function pintura_element(name){return document.createElement(name);}function svg_element(name){return document.createElementNS('http://www.w3.org/2000/svg',name);}function pintura_text(data){return document.createTextNode(data);}function space(){return pintura_text(' ');}function empty(){return pintura_text('');}function listen(node,event,handler,options){node.addEventListener(event,handler,options);return()=>node.removeEventListener(event,handler,options);}function prevent_default(fn){return function(event){event.preventDefault();// @ts-ignore
return fn.call(this,event);};}function stop_propagation(fn){return function(event){event.stopPropagation();// @ts-ignore
return fn.call(this,event);};}function attr(node,attribute,value){if(value==null)node.removeAttribute(attribute);else if(node.getAttribute(attribute)!==value)node.setAttribute(attribute,value);}function set_attributes(node,attributes){// @ts-ignore
const descriptors=Object.getOwnPropertyDescriptors(node.__proto__);for(const key in attributes){if(attributes[key]==null){node.removeAttribute(key);}else if(key==='style'){node.style.cssText=attributes[key];}else if(key==='__value'){node.value=node[key]=attributes[key];}else if(descriptors[key]&&descriptors[key].set){node[key]=attributes[key];}else{attr(node,key,attributes[key]);}}}function children(element){return Array.from(element.childNodes);}function set_data(text,data){data=''+data;if(text.wholeText!==data)text.data=data;}function set_input_value(input,value){input.value=value==null?'':value;}function set_style(node,key,value,important){node.style.setProperty(key,value,important?'important':'');}function custom_event(type,detail){const e=document.createEvent('CustomEvent');e.initCustomEvent(type,false,false,detail);return e;}class HtmlTag{constructor(anchor=null){this.a=anchor;this.e=this.n=null;}m(html,target,anchor=null){if(!this.e){this.e=pintura_element(target.nodeName);this.t=target;this.h(html);}this.i(anchor);}h(html){this.e.innerHTML=html;this.n=Array.from(this.e.childNodes);}i(anchor){for(let i=0;i<this.n.length;i+=1){insert(this.t,this.n[i],anchor);}}p(html){this.d();this.h(html);this.i(this.a);}d(){this.n.forEach(detach);}}const active_docs=new Set();let active=0;// https://github.com/darkskyapp/string-hash/blob/master/index.js
function pintura_hash(str){let hash=5381;let i=str.length;while(i--)hash=(hash<<5)-hash^str.charCodeAt(i);return hash>>>0;}function create_rule(node,a,b,duration,delay,ease,fn,uid=0){const step=16.666/duration;let keyframes='{\n';for(let p=0;p<=1;p+=step){const t=a+(b-a)*ease(p);keyframes+=p*100+`%{${fn(t,1-t)}}\n`;}const rule=keyframes+`100% {${fn(b,1-b)}}\n}`;const name=`__svelte_${pintura_hash(rule)}_${uid}`;const doc=node.ownerDocument;active_docs.add(doc);const stylesheet=doc.__svelte_stylesheet||(doc.__svelte_stylesheet=doc.head.appendChild(pintura_element('style')).sheet);const current_rules=doc.__svelte_rules||(doc.__svelte_rules={});if(!current_rules[name]){current_rules[name]=true;stylesheet.insertRule(`@keyframes ${name} ${rule}`,stylesheet.cssRules.length);}const animation=node.style.animation||'';node.style.animation=`${animation?`${animation}, `:''}${name} ${duration}ms linear ${delay}ms 1 both`;active+=1;return name;}function delete_rule(node,name){const previous=(node.style.animation||'').split(', ');const next=previous.filter(name?anim=>anim.indexOf(name)<0// remove specific animation
:anim=>anim.indexOf('__svelte')===-1// remove all Svelte animations
);const deleted=previous.length-next.length;if(deleted){node.style.animation=next.join(', ');active-=deleted;if(!active)clear_rules();}}function clear_rules(){raf(()=>{if(active)return;active_docs.forEach(doc=>{const stylesheet=doc.__svelte_stylesheet;let i=stylesheet.cssRules.length;while(i--)stylesheet.deleteRule(i);doc.__svelte_rules={};});active_docs.clear();});}let current_component;function set_current_component(component){current_component=component;}function get_current_component(){if(!current_component)throw new Error('Function called outside component initialization');return current_component;}function onMount(fn){get_current_component().$$.on_mount.push(fn);}function afterUpdate(fn){get_current_component().$$.after_update.push(fn);}function onDestroy(fn){get_current_component().$$.on_destroy.push(fn);}function createEventDispatcher(){const component=get_current_component();return(type,detail)=>{const callbacks=component.$$.callbacks[type];if(callbacks){// TODO are there situations where events could be dispatched
// in a server (non-DOM) environment?
const event=custom_event(type,detail);callbacks.slice().forEach(fn=>{fn.call(component,event);});}};}function setContext(key,context){get_current_component().$$.context.set(key,context);}function getContext(key){return get_current_component().$$.context.get(key);}// TODO figure out if we still want to support
// shorthand events, or if we want to implement
// a real bubbling mechanism
function bubble(component,event){const callbacks=component.$$.callbacks[event.type];if(callbacks){callbacks.slice().forEach(fn=>fn(event));}}const dirty_components=[];const binding_callbacks=[];const render_callbacks=[];const flush_callbacks=[];const resolved_promise=Promise.resolve();let update_scheduled=false;function schedule_update(){if(!update_scheduled){update_scheduled=true;resolved_promise.then(flush);}}function add_render_callback(fn){render_callbacks.push(fn);}function add_flush_callback(fn){flush_callbacks.push(fn);}let flushing=false;const seen_callbacks=new Set();function flush(){if(flushing)return;flushing=true;do{// first, call beforeUpdate functions
// and update components
for(let i=0;i<dirty_components.length;i+=1){const component=dirty_components[i];set_current_component(component);update(component.$$);}set_current_component(null);dirty_components.length=0;while(binding_callbacks.length)binding_callbacks.pop()();// then, once components are updated, call
// afterUpdate functions. This may cause
// subsequent updates...
for(let i=0;i<render_callbacks.length;i+=1){const callback=render_callbacks[i];if(!seen_callbacks.has(callback)){// ...so guard against infinite loops
seen_callbacks.add(callback);callback();}}render_callbacks.length=0;}while(dirty_components.length);while(flush_callbacks.length){flush_callbacks.pop()();}update_scheduled=false;flushing=false;seen_callbacks.clear();}function update($$){if($$.fragment!==null){$$.update();run_all($$.before_update);const dirty=$$.dirty;$$.dirty=[-1];$$.fragment&&$$.fragment.p($$.ctx,dirty);$$.after_update.forEach(add_render_callback);}}let promise;function wait(){if(!promise){promise=Promise.resolve();promise.then(()=>{promise=null;});}return promise;}function dispatch(node,direction,kind){node.dispatchEvent(custom_event(`${direction?'intro':'outro'}${kind}`));}const outroing=new Set();let outros;function group_outros(){outros={r:0,c:[],p:outros// parent group
};}function check_outros(){if(!outros.r){run_all(outros.c);}outros=outros.p;}function transition_in(block,local){if(block&&block.i){outroing.delete(block);block.i(local);}}function transition_out(block,local,detach,callback){if(block&&block.o){if(outroing.has(block))return;outroing.add(block);outros.c.push(()=>{outroing.delete(block);if(callback){if(detach)block.d(1);callback();}});block.o(local);}}const null_transition={duration:0};function create_bidirectional_transition(node,fn,params,intro){let config=fn(node,params);let t=intro?0:1;let running_program=null;let pending_program=null;let animation_name=null;function clear_animation(){if(animation_name)delete_rule(node,animation_name);}function init(program,duration){const d=program.b-t;duration*=Math.abs(d);return{a:t,b:program.b,d,duration,start:program.start,end:program.start+duration,group:program.group};}function go(b){const{delay=0,duration=300,easing=identity,tick=pintura_noop,css}=config||null_transition;const program={start:now()+delay,b};if(!b){// @ts-ignore todo: improve typings
program.group=outros;outros.r+=1;}if(running_program||pending_program){pending_program=program;}else{// if this is an intro, and there's a delay, we need to do
// an initial tick and/or apply CSS animation immediately
if(css){clear_animation();animation_name=create_rule(node,t,b,duration,delay,easing,css);}if(b)tick(0,1);running_program=init(program,duration);add_render_callback(()=>dispatch(node,b,'start'));loop(now=>{if(pending_program&&now>pending_program.start){running_program=init(pending_program,duration);pending_program=null;dispatch(node,running_program.b,'start');if(css){clear_animation();animation_name=create_rule(node,t,running_program.b,running_program.duration,0,easing,config.css);}}if(running_program){if(now>=running_program.end){tick(t=running_program.b,1-t);dispatch(node,running_program.b,'end');if(!pending_program){// we're done
if(running_program.b){// intro — we can tidy up immediately
clear_animation();}else{// outro — needs to be coordinated
if(! --running_program.group.r)run_all(running_program.group.c);}}running_program=null;}else if(now>=running_program.start){const p=now-running_program.start;t=running_program.a+running_program.d*easing(p/running_program.duration);tick(t,1-t);}}return!!(running_program||pending_program);});}}return{run(b){if(is_function(config)){wait().then(()=>{// @ts-ignore
config=config();go(b);});}else{go(b);}},end(){clear_animation();running_program=pending_program=null;}};}const globals=typeof window!=='undefined'?window:typeof globalThis!=='undefined'?globalThis:__webpack_require__.g;function destroy_block(block,lookup){block.d(1);lookup.delete(block.key);}function outro_and_destroy_block(block,lookup){transition_out(block,1,1,()=>{lookup.delete(block.key);});}function update_keyed_each(old_blocks,dirty,get_key,dynamic,ctx,list,lookup,node,destroy,create_each_block,next,get_context){let o=old_blocks.length;let n=list.length;let i=o;const old_indexes={};while(i--)old_indexes[old_blocks[i].key]=i;const new_blocks=[];const new_lookup=new Map();const deltas=new Map();i=n;while(i--){const child_ctx=get_context(ctx,list,i);const key=get_key(child_ctx);let block=lookup.get(key);if(!block){block=create_each_block(key,child_ctx);block.c();}else if(dynamic){block.p(child_ctx,dirty);}new_lookup.set(key,new_blocks[i]=block);if(key in old_indexes)deltas.set(key,Math.abs(i-old_indexes[key]));}const will_move=new Set();const did_move=new Set();function insert(block){transition_in(block,1);block.m(node,next);lookup.set(block.key,block);next=block.first;n--;}while(o&&n){const new_block=new_blocks[n-1];const old_block=old_blocks[o-1];const new_key=new_block.key;const old_key=old_block.key;if(new_block===old_block){// do nothing
next=new_block.first;o--;n--;}else if(!new_lookup.has(old_key)){// remove old block
destroy(old_block,lookup);o--;}else if(!lookup.has(new_key)||will_move.has(new_key)){insert(new_block);}else if(did_move.has(old_key)){o--;}else if(deltas.get(new_key)>deltas.get(old_key)){did_move.add(new_key);insert(new_block);}else{will_move.add(old_key);o--;}}while(o--){const old_block=old_blocks[o];if(!new_lookup.has(old_block.key))destroy(old_block,lookup);}while(n)insert(new_blocks[n-1]);return new_blocks;}function get_spread_update(levels,updates){const update={};const to_null_out={};const accounted_for={$$scope:1};let i=levels.length;while(i--){const o=levels[i];const n=updates[i];if(n){for(const key in o){if(!(key in n))to_null_out[key]=1;}for(const key in n){if(!accounted_for[key]){update[key]=n[key];accounted_for[key]=1;}}levels[i]=n;}else{for(const key in o){accounted_for[key]=1;}}}for(const key in to_null_out){if(!(key in update))update[key]=undefined;}return update;}function get_spread_object(spread_props){return typeof spread_props==='object'&&spread_props!==null?spread_props:{};}function bind(component,name,callback){const index=component.$$.props[name];if(index!==undefined){component.$$.bound[index]=callback;callback(component.$$.ctx[index]);}}function create_component(block){block&&block.c();}function mount_component(component,target,anchor,customElement){const{fragment,on_mount,on_destroy,after_update}=component.$$;fragment&&fragment.m(target,anchor);if(!customElement){// onMount happens before the initial afterUpdate
add_render_callback(()=>{const new_on_destroy=on_mount.map(run).filter(is_function);if(on_destroy){on_destroy.push(...new_on_destroy);}else{// Edge case - component was destroyed immediately,
// most likely as a result of a binding initialising
run_all(new_on_destroy);}component.$$.on_mount=[];});}after_update.forEach(add_render_callback);}function destroy_component(component,detaching){const $$=component.$$;if($$.fragment!==null){run_all($$.on_destroy);$$.fragment&&$$.fragment.d(detaching);// TODO null out other refs, including component.$$ (but need to
// preserve final state?)
$$.on_destroy=$$.fragment=null;$$.ctx=[];}}function make_dirty(component,i){if(component.$$.dirty[0]===-1){dirty_components.push(component);schedule_update();component.$$.dirty.fill(0);}component.$$.dirty[i/31|0]|=1<<i%31;}function init(component,options,instance,create_fragment,not_equal,props,dirty=[-1]){const parent_component=current_component;set_current_component(component);const $$=component.$$={fragment:null,ctx:null,// state
props,update:pintura_noop,not_equal,bound:blank_object(),// lifecycle
on_mount:[],on_destroy:[],on_disconnect:[],before_update:[],after_update:[],context:new Map(parent_component?parent_component.$$.context:options.context||[]),// everything else
callbacks:blank_object(),dirty,skip_bound:false};let ready=false;$$.ctx=instance?instance(component,options.props||{},(i,ret,...rest)=>{const value=rest.length?rest[0]:ret;if($$.ctx&&not_equal($$.ctx[i],$$.ctx[i]=value)){if(!$$.skip_bound&&$$.bound[i])$$.bound[i](value);if(ready)make_dirty(component,i);}return ret;}):[];$$.update();ready=true;run_all($$.before_update);// `false` as a special case of no DOM component
$$.fragment=create_fragment?create_fragment($$.ctx):false;if(options.target){if(options.hydrate){const nodes=children(options.target);// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
$$.fragment&&$$.fragment.l(nodes);nodes.forEach(detach);}else{// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
$$.fragment&&$$.fragment.c();}if(options.intro)transition_in(component.$$.fragment);mount_component(component,options.target,options.anchor,options.customElement);flush();}set_current_component(parent_component);}/**
 * Base class for Svelte components. Used when dev=false.
 */class SvelteComponent{$destroy(){destroy_component(this,1);this.$destroy=pintura_noop;}$on(type,callback){const callbacks=this.$$.callbacks[type]||(this.$$.callbacks[type]=[]);callbacks.push(callback);return()=>{const index=callbacks.indexOf(callback);if(index!==-1)callbacks.splice(index,1);};}$set($$props){if(this.$$set&&!is_empty($$props)){this.$$.skip_bound=true;this.$$set($$props);this.$$.skip_bound=false;}}}const subscriber_queue=[];/**
 * Creates a `Readable` store that allows reading by subscription.
 * @param value initial value
 * @param {StartStopNotifier}start start and stop notifications for subscriptions
 */function readable(value,start){return{subscribe:writable(value,start).subscribe};}/**
 * Create a `Writable` store that allows both updating and reading by subscription.
 * @param {*=}value initial value
 * @param {StartStopNotifier=}start start and stop notifications for subscriptions
 */function writable(value,start=pintura_noop){let stop;const subscribers=[];function set(new_value){if(safe_not_equal(value,new_value)){value=new_value;if(stop){// store is ready
const run_queue=!subscriber_queue.length;for(let i=0;i<subscribers.length;i+=1){const s=subscribers[i];s[1]();subscriber_queue.push(s,value);}if(run_queue){for(let i=0;i<subscriber_queue.length;i+=2){subscriber_queue[i][0](subscriber_queue[i+1]);}subscriber_queue.length=0;}}}}function update(fn){set(fn(value));}function subscribe(run,invalidate=pintura_noop){const subscriber=[run,invalidate];subscribers.push(subscriber);if(subscribers.length===1){stop=start(set)||pintura_noop;}run(value);return()=>{const index=subscribers.indexOf(subscriber);if(index!==-1){subscribers.splice(index,1);}if(subscribers.length===0){stop();stop=null;}};}return{set,update,subscribe};}function derived(stores,fn,initial_value){const single=!Array.isArray(stores);const stores_array=single?[stores]:stores;const auto=fn.length<2;return readable(initial_value,set=>{let inited=false;const values=[];let pending=0;let cleanup=pintura_noop;const sync=()=>{if(pending){return;}cleanup();const result=fn(single?values[0]:values,set);if(auto){set(result);}else{cleanup=is_function(result)?result:pintura_noop;}};const unsubscribers=stores_array.map((store,i)=>subscribe(store,value=>{values[i]=value;pending&=~(1<<i);if(inited){sync();}},()=>{pending|=1<<i;}));inited=true;sync();return function stop(){run_all(unsubscribers);cleanup();};});}var mergeObjects=objects=>objects.reduce((prev,curr)=>Object.assign(prev,curr),{});// @ts-ignore
const UPDATE_VALUE=updateValue=>({updateValue});const DEFAULT_VALUE=defaultValue=>({defaultValue});const CUSTOM_STORE=fn=>({store:fn});// @ts-ignore
const DERIVED_STORE=fn=>({store:(defaultValue,stores)=>derived(...fn(stores))});const UNIQUE_DERIVED_STORE=fn=>({store:(defaultValue,stores)=>{const[selectedStores,update,isEqual=()=>false]=fn(stores);let isFirst=true;let currentValue;return derived(selectedStores,(storeValues,set)=>{update(storeValues,value=>{if(!isFirst&&isEqual(currentValue,value))return;currentValue=value;isFirst=false;set(value);});});}});const MAP_STORE=fn=>({store:(defaultValue,stores)=>{const[valueMapper,observedStores={},sorter=undefined]=fn(stores);let storedItems=[];let $observedStores={};const mapValue=item=>valueMapper(item,$observedStores);// set default properties for each item
const setValue=items=>{// was empty, still empty
if(!storedItems.length&&!items.length)return;// update value
storedItems=items;updateValue();};const updateValue=()=>{const mappedItems=storedItems.map(mapValue);if(sorter)mappedItems.sort(sorter);storedItems=[...mappedItems];set(mappedItems);};// TODO: need to at some point unsub from these stores
Object.entries(observedStores).map(([name,store])=>{return store.subscribe(value=>{$observedStores[name]=value;if(!value)return;updateValue();});});const{subscribe,set}=writable(defaultValue||[]);return{set:setValue,update:fn=>setValue(fn(storedItems)),subscribe};}});const createStore=(accessors,stores,options)=>{const{store=defaultValue=>writable(defaultValue),defaultValue=noop$1,// should be a function returning the default value
updateValue=undefined}=options;// create our private store
const storeInstance=store(defaultValue(),stores,accessors);const{subscribe,update=noop$1}=storeInstance;// update = noop because not all stores can be updated
// on update private store
let unsub;const onUpdate=cb=>{let ignoreFirstCallback=true;if(unsub)unsub();unsub=subscribe(value=>{// need to ignore first callback because that returns current value
if(ignoreFirstCallback)return ignoreFirstCallback=false;// now we have the newly assigned value
cb(value);unsub();unsub=undefined;});};// create the value updater function, needs access to stores so can read all store values
const updateStoreValue=updateValue?updateValue(accessors):passthrough;// set and validate value
storeInstance.set=nextValue=>update(previousValue=>updateStoreValue(nextValue,previousValue,onUpdate));// set default value for external reference
storeInstance.defaultValue=defaultValue;// expose store api
return storeInstance;};var createStores=props=>{const stores={};const accessors={};props.forEach(([name,...options])=>{const opts=mergeObjects(options);const store=stores[name]=createStore(accessors,stores,opts);const property={get:()=>get_store_value(store),set:store.set};Object.defineProperty(accessors,name,property);});return{stores,accessors};};var props=[// io
['src'],['imageReader'],['imageWriter'],// will process markup items before rendering, used by arrows and frames
['shapePreprocessor'],// will scramble image data for use with image redaction logic
['imageScrambler'],// current images
['images',DEFAULT_VALUE(()=>[])]];var capitalizeFirstLetter=str=>str.charAt(0).toUpperCase()+str.slice(1);var defineMethods=(object,api)=>{Object.keys(api).forEach(name=>{const descriptor=pintura_isFunction(api[name])?{value:api[name],writable:false}:api[name];Object.defineProperty(object,name,descriptor);});};const scalar=10000;var offsetRectToFitPolygon=(rect,poly)=>{const polyLines=quadLines(poly);const offset=vectorCreateEmpty();const rectVertexes=rectGetCorners(rect);// we can fit it
rectVertexes.forEach(vertex=>{// we update each corner by adding the current offset
vectorAdd(vertex,offset);// test if point lies in polygon, if so, all is fine and we can exit
if(pointInPoly(vertex,poly))return;polyLines.forEach(line=>{// get angle of edge and draw a ray from the corner perpendicular to the edge
const a=Math.atan2(line.start.y-line.end.y,line.start.x-line.end.x);const x=Math.sin(Math.PI-a)*scalar;const y=Math.cos(Math.PI-a)*scalar;const ray=vectorCreate(vertex.x+x,vertex.y+y);// extend the poly line so even if we overshoot the polygon we hit it
const lineExtended=lineExtend(lineClone(line),scalar);// get the resulting intersection (there's always an intersection)
const intersection=lineLineIntersection(lineCreate(vertex,ray),lineExtended);// no intersection, no need to do anything
if(!intersection)return;// update offset to move towards image
vectorAdd(offset,vectorSubtract(vectorClone(intersection),vertex));});});// test if any vertexes still fall outside of poly, if so, we can't fit the rect
const rectOffset=rectClone(rect);vectorAdd(rectOffset,offset);const rectOffsetVertices=rectGetCorners(rectOffset);const fits=rectOffsetVertices.every(vertex=>pointInPoly(vertex,poly));if(fits){rectUpdateWithRect(rect,rectOffset);return true;}return false;};var limitCropRectToImage=(rect,poly)=>{// get crop rect polygon vertexes
const rectVertexes=rectGetCorners(rect);// if we end up here it doesn't fit, we might need to adjust
const polyLines=quadLines(poly)// extend the poly lines a tiny bit so we
// don't shoot rays between line gaps at corners
// this caused one intersection to be missing resulting
// in error while manipulating crop edges
// (rotate image 90degrees -> drag bottom edge) (2021-04-09)
.map(line=>lineExtend(line,5));const rectCenterPosition=rectCenter(rect);const intersections=[];rectVertexes.forEach(rectVertex=>{const ray=lineMultiply(lineCreate(vectorClone(rectCenterPosition),vectorClone(rectVertex)),1000000);let intersectionFound=false;polyLines.map(lineClone).forEach(line=>{const intersection=lineLineIntersection(ray,line);if(!intersection||intersectionFound)return;intersections.push(intersection);intersectionFound=true;});});// top left -> bottom right
const tlbr=vectorDistance(intersections[0],intersections[2]);// top right -> bottom left
const trbl=vectorDistance(intersections[1],intersections[3]);// calculate smallest rectangle we can make, use that
const rectLimitedVertices=tlbr<trbl?[intersections[0],intersections[2]]:[intersections[1],intersections[3]];const rectLimitedToImage=rectCreateFromPoints(rectLimitedVertices);// only use our fitted crop rectangle if it's smaller than our current rectangle,
// this would mean that our current rectangle couldn't be moved to make it fit
if(rectLimitedToImage.width<rect.width){// need to center on previous rect
rectUpdateWithRect(rect,rectLimitedToImage);return true;}return false;};var getImagePolygon=(image,imageRotation,imagePerspective={x:0,y:0})=>{const imageRect=rectCreateFromSize(image);const imageCenter=rectCenter(imageRect);const imagePoly=rectApplyPerspective(imageRect,imagePerspective,imageCenter).map(imageVertex=>vectorRotate(imageVertex,imageRotation,imageCenter));// get image poly bounds, we need this to offset the poly vertices from 0,0
const imagePolyBounds=rectCreateFromPoints(imagePoly);// get image polygon vertexes
return imagePoly.map(imageVertex=>vectorSubtract(imageVertex,imagePolyBounds));};var getMaxSizeInRect=(size,rotation=0,aspectRatio=rectAspectRatio(size))=>{let width;let height;if(rotation!==0){const innerAngle=Math.atan2(1,aspectRatio);const rotationSigned=Math.sign(rotation)*rotation;const rotationSignedMod=rotationSigned%Math.PI;const rotationSignedModHalf=rotationSigned%HALF_PI;// determine if is turned on side
let hyp;let r;if(rotationSignedMod>QUART_PI&&rotationSignedMod<HALF_PI+QUART_PI){r=rotationSignedModHalf>QUART_PI?rotationSigned:HALF_PI-rotationSignedModHalf;}else{r=rotationSignedModHalf>QUART_PI?HALF_PI-rotationSignedModHalf:rotationSigned;}hyp=Math.min(Math.abs(size.height/Math.sin(innerAngle+r)),Math.abs(size.width/Math.cos(innerAngle-r)));width=Math.cos(innerAngle)*hyp;height=width/aspectRatio;}else{width=size.width;height=width/aspectRatio;if(height>size.height){height=size.height;width=height*aspectRatio;}}return sizeCreate(width,height);};var limitRectToImage=(rect,imageSize,imageRotation=0,imagePerspective=vectorCreateEmpty(),minSize)=>{// rotation and/or perspective, let's use the "advanced" collision detection method
if(pintura_isNumber(imageRotation)&&imageRotation!==0||imagePerspective.x||imagePerspective.y){const inputAspectRatio=rectAspectRatio(rect);// test if crop can fit image, if it can, offset the crop so it fits
const imagePolygon=getImagePolygon(imageSize,imageRotation,imagePerspective);const maxSizeInRect=getMaxSizeInRect(imageSize,imageRotation,inputAspectRatio);const canFit=rect.width<maxSizeInRect.width&&rect.height<maxSizeInRect.height;if(!canFit){const dx=rect.width*0.5-maxSizeInRect.width*0.5;const dy=rect.height*0.5-maxSizeInRect.height*0.5;// adjust crop rect to max size
if(rect.width>maxSizeInRect.width){rect.width=maxSizeInRect.width;rect.x+=dx;}if(rect.height>maxSizeInRect.height){rect.height=maxSizeInRect.height;rect.y+=dy;}// test if has exceeded min size, if so we need to limit the size and recalculate the other edge
/*
                        -\
                       /  ---\
                      h2      ---\
                     /            ---\
                    +--------w---------+\
                   /|                  | ---\
                  / |                  |     ---\
                 /  |                  |         ---\
                /   |                  |             --
               h1   |                  |             /
              /     |                  |            /
             /      |                  |           /
            -\      |                  |          /
              ---\  |                  |         /
                  --+------------------+        /
                      ---\                     /
                          --\                 /
                             ---\            /
                                 ---\       /
                                     ---\  /
                                         --
            */}offsetRectToFitPolygon(rect,imagePolygon);const wasLimited=limitCropRectToImage(rect,imagePolygon);// this makes sure that after limiting the size, the crop rect is moved to a position that is inside the image
if(wasLimited)offsetRectToFitPolygon(rect,imagePolygon);}// no rotation, no perspective, use simple bounds method
else{// remember intended aspect ratio so we can try and recreate it
let intendedAspectRatio=rectAspectRatio(rect);// limit to image size first, can never exceed that
rect.width=Math.min(rect.width,imageSize.width);rect.height=Math.min(rect.height,imageSize.height);// reposition rect so it's always inside image bounds
rect.x=Math.max(rect.x,0);if(rect.x+rect.width>imageSize.width){rect.x-=rect.x+rect.width-imageSize.width;}rect.y=Math.max(rect.y,0);if(rect.y+rect.height>imageSize.height){rect.y-=rect.y+rect.height-imageSize.height;}// we get the center of the current rect so we can center the contained rect to it
const intendedCenter=rectCenter(rect);// make sure still adheres to aspect ratio
const containedRect=rectContainRect(rect,intendedAspectRatio);containedRect.width=Math.max(minSize.width,containedRect.width);containedRect.height=Math.max(minSize.height,containedRect.height);containedRect.x=intendedCenter.x-containedRect.width*0.5;containedRect.y=intendedCenter.y-containedRect.height*0.5;rectUpdateWithRect(rect,containedRect);}};var applyCropRectAction=(cropRectPrevious,cropRectNext,imageSize,imageRotation,imagePerspective,cropLimitToImageBounds,cropMinSize,cropMaxSize)=>{// clone
const minSize=sizeClone(cropMinSize);// set upper bounds to crop max size
const maxSize=sizeClone(cropMaxSize);// limit max size (more important that min size is respected so first limit max size)
const maxScalar=fixPrecision(Math.max(cropRectNext.width/maxSize.width,cropRectNext.height/maxSize.height));const minScalar=fixPrecision(Math.min(cropRectNext.width/minSize.width,cropRectNext.height/minSize.height));// clone for resulting crop rect
const cropRectOut=rectClone(cropRectNext);//
// if exceeds min or max scale correct next crop rectangle to conform to bounds
//
if(minScalar<1||maxScalar>1){// center of both previous and next crop rects
const previousCropRectCenter=rectCenter(cropRectPrevious);const nextCropRectCenter=rectCenter(cropRectNext);// calculate scales
const scalar=minScalar<1?minScalar:maxScalar;const cx=(nextCropRectCenter.x+previousCropRectCenter.x)/2;const cy=(nextCropRectCenter.y+previousCropRectCenter.y)/2;const cw=cropRectOut.width/scalar;const ch=cropRectOut.height/scalar;rectUpdate(cropRectOut,cx-cw*0.5,cy-ch*0.5,cw,ch);}// no need to limit to bounds, let's go!
if(!cropLimitToImageBounds)return{crop:cropRectOut};//
// make sure the crop is made inside the bounds of the image
//
limitRectToImage(cropRectOut,imageSize,imageRotation,imagePerspective,minSize);return{crop:cropRectOut};};var getBaseCropRect=(imageSize,transformedCropRect,imageRotation)=>{const imageRect=rectCreateFromSize(imageSize);const imageCenter=rectCenter(imageRect);const imageTransformedVertices=rectRotate(imageRect,imageRotation,imageCenter);// get the rotated image bounds center (offset isn't relevant as crop is relative to top left image position)
const imageRotatedBoundsCenter=rectCenter(rectNormalizeOffset(rectCreateFromPoints(imageTransformedVertices)));// get the center of the crop inside the rotated image
const cropCenterInTransformedImage=rectCenter(transformedCropRect);// invert the rotation of the crop center around the rotated image center
const deRotatedCropCenter=vectorRotate(cropCenterInTransformedImage,-imageRotation,imageRotatedBoundsCenter);// calculate crop distance from rotated image center
const cropFromCenterOfTransformedImage=vectorSubtract(deRotatedCropCenter,imageRotatedBoundsCenter);// calculate original crop offset (from untransformed image)
const originalCropCenterOffset=vectorApply(vectorAdd(imageCenter,cropFromCenterOfTransformedImage),fixPrecision);return rectCreate(originalCropCenterOffset.x-transformedCropRect.width*0.5,originalCropCenterOffset.y-transformedCropRect.height*0.5,transformedCropRect.width,transformedCropRect.height);};var pintura_clamp=(value,min,max)=>Math.max(min,Math.min(value,max));var applyRotationAction=(imageRotationPrevious,imageRotation,imageRotationRange,cropRect,imageSize,imagePerspective,cropLimitToImageBounds,cropRectOrigin,cropMinSize,cropMaxSize)=>{// clone
const minSize=sizeClone(cropMinSize);// set upper bounds to crop max size if image is bigger than max size,
// else if should limit to image bounds use image size as limit
const maxSize=sizeClone(cropMaxSize);if(cropLimitToImageBounds){maxSize.width=Math.min(cropMaxSize.width,imageSize.width);maxSize.height=Math.min(cropMaxSize.height,imageSize.height);}let didAttemptDoubleTurn=false;const rotate=(rotationPrevious,rotation)=>{// get the base crop rect (position of crop rect in untransformed image)
// if we have the base crop rect we can apply the new rotation to it
const cropRectBase=getBaseCropRect(imageSize,cropRect,rotationPrevious);// calculate transforms based on new rotation and base crop rect
const imageRect=rectCreateFromSize(imageSize);const imageCenter=rectCenter(imageRect);const imageTransformedCorners=rectApplyPerspective(imageRect,imagePerspective,imageCenter);// need this to correct for perspective centroid displacement
const perspectiveOffset=vectorSubtract(vectorClone(imageCenter),convexPolyCentroid(imageTransformedCorners));// rotate around center of image
const cropCenter=vectorRotate(rectCenter(cropRectBase),rotation,imageCenter);const rotateCropOffset=vectorSubtract(vectorClone(imageCenter),cropCenter);// get center of image bounds and move to correct position
imageTransformedCorners.forEach(imageVertex=>vectorRotate(imageVertex,rotation,imageCenter));const imageBoundsRect=rectCreateFromPoints(imageTransformedCorners);const imageCentroid=convexPolyCentroid(imageTransformedCorners);const cropOffset=vectorAdd(vectorSubtract(vectorSubtract(imageCentroid,rotateCropOffset),imageBoundsRect),perspectiveOffset);// create output cropRect
const cropRectOut=rectCreate(cropOffset.x-cropRectBase.width*0.5,cropOffset.y-cropRectBase.height*0.5,cropRectBase.width,cropRectBase.height);// if has size target, scale croprect to target size
if(cropRectOrigin){rectScale(cropRectOut,cropRectOrigin.width/cropRectOut.width);}// if should limit to image bounds
if(cropLimitToImageBounds){const imagePoly=getImagePolygon(imageSize,rotation,imagePerspective);// offsetRectToFitPolygon(cropRectOut, imagePoly);
// commenting this fixes poly sliding problem when adjusting rotation
limitCropRectToImage(cropRectOut,imagePoly);}//#region if exceeds min or max adjust rotation to conform to bounds
const minScalar=fixPrecision(Math.min(cropRectOut.width/minSize.width,cropRectOut.height/minSize.height),8);const maxScalar=fixPrecision(Math.max(cropRectOut.width/maxSize.width,cropRectOut.height/maxSize.height),8);if(minScalar<1||maxScalar>1){// determine if is full image turn
const isTurn=fixPrecision(Math.abs(rotation-rotationPrevious))===fixPrecision(Math.PI/2);// try another turn if is turning image
if(isTurn&&!didAttemptDoubleTurn){didAttemptDoubleTurn=true;return rotate(imageRotationPrevious,imageRotationPrevious+Math.sign(rotation-rotationPrevious)*Math.PI);}}//#endregion
return{rotation,crop:rectApply(cropRectOut,v=>fixPrecision(v,8))};};// amount of turns applied, we need this to correctly determine the allowed rotation range
const imageTurns=Math.sign(imageRotation)*Math.round(Math.abs(imageRotation)/HALF_PI)*HALF_PI;const imageRotationClamped=pintura_clamp(imageRotation,imageTurns+imageRotationRange[0],imageTurns+imageRotationRange[1]);// set new crop position
return rotate(imageRotationPrevious,imageRotationClamped);};// @ts-ignore
const ORDERED_STATE_PROPS=[// requirements
'cropLimitToImage','cropMinSize','cropMaxSize','cropAspectRatio',// selection -> flip -> rotate -> perspective -> crop
'flipX','flipY','rotation','crop',// 'perspectiveX',
// 'perspectiveY',
// effects
'colorMatrix','convolutionMatrix','gamma','vignette',// 'noise',
// shapes
'redaction','annotation','decoration','frame',// other
'backgroundColor','targetSize','metadata'];const pintura_clone=value=>{if(pintura_isArray(value)){return value.map(pintura_clone);}else if(pintura_isObject(value)){return{...value};}return value;};const filterShapeState=shapes=>shapes.map(shape=>Object.entries(shape).reduce((copy,[key,value])=>{if(key.startsWith('_'))return copy;copy[key]=value;return copy;},{}));var stateStore=(_,stores,accessors)=>{const observedStores=ORDERED_STATE_PROPS.map(key=>stores[key]);// can only subscribe, setting is done directly through store accessors
// @ts-ignore
const{subscribe}=derived(observedStores,(values,set)=>{// create new state by looping over props in certain order
const state=ORDERED_STATE_PROPS.reduce((prev,curr,i)=>{prev[curr]=pintura_clone(values[i]);return prev;},{});// round crop if defined
state.crop&&rectApply(state.crop,Math.round);// remove internal state props from decoration and annotation
state.redaction=state.redaction&&filterShapeState(state.redaction);state.annotation=state.annotation&&filterShapeState(state.annotation);state.decoration=state.decoration&&filterShapeState(state.decoration);// set new state
set(state);});const setState=state=>{// requires at least some state to be supplied
if(!state)return;// make sure crop origin is reset
accessors.cropOrigin=undefined;// apply new values
ORDERED_STATE_PROPS// remove keys that weren't set
.filter(key=>hasProp(state,key))// apply each key in order
.forEach(key=>{accessors[key]=pintura_clone(state[key]);});};return{set:setState,update:fn=>setState(fn(null)),subscribe};};var toNumericAspectRatio=v=>{if(!v)return undefined;if(/:/.test(v)){const[w,h]=v.split(':');return w/h;}return parseFloat(v);};var arrayEqual=(a,b)=>{if(a.length!==b.length)return false;for(let i=0;i<a.length;i++){if(a[i]!==b[i])return false;}return true;};var padColorArray=(color=[0,0,0,0],opacity=1.0)=>color.length===4?color:[...color,opacity];//
// constants
//
const MIN_ROTATION=-QUART_PI;const MAX_ROTATION=QUART_PI;//
// helper methods
//
const isCropCentered=(crop,imageSize,imageRotation)=>{const cropCenter=vectorApply(rectCenter(crop),v=>fixPrecision(v,8));const imageRect=rectCreateFromSize(imageSize);const imageCenter=rectCenter(imageRect);const imageRotatedVertices=rectRotate(imageRect,imageRotation,imageCenter);const imageBoundsCenter=vectorApply(sizeCenter(rectCreateFromPoints(imageRotatedVertices)),v=>fixPrecision(v,8));const dx=Math.abs(imageBoundsCenter.x-cropCenter.x);const dy=Math.abs(imageBoundsCenter.y-cropCenter.y);return dx<1&&dy<1;};const isCropMaxSize=(cropRect,imageSize,rotation)=>{const maxSize=getMaxSizeInRect(imageSize,rotation,rectAspectRatio(cropRect));return sizeEqual(sizeApply(maxSize,Math.round),sizeApply(sizeClone(cropRect),Math.round));};//
// updater methods
//
const updateCropRect=props=>(cropNext,cropPrevious=cropNext)=>{// wait for image to load
const{loadState,size,cropMinSize,cropMaxSize,cropLimitToImage,cropAspectRatio,rotation,perspective}=props;// image hasn't loaded yet, use supplied crop rect
if(!cropNext&&!cropPrevious||!loadState||!loadState.beforeComplete)return cropNext;// crop previous set, crop next set to undefined, set crop to fit image
if(!cropNext)cropNext=rectCreateFromSize(getMaxSizeInRect(size,rotation,cropAspectRatio||rectAspectRatio(size)));// apply the action
const res=applyCropRectAction(cropPrevious,cropNext,size,rotation,perspective,cropLimitToImage,cropMinSize,cropMaxSize);const cropOut=rectApply(res.crop,v=>fixPrecision(v,8));return cropOut;};const updateCropAspectRatio=props=>(aspectRatioNext,aspectRatioPrevious)=>{const{loadState,crop,size,rotation,cropLimitToImage}=props;const aspectRatio=toNumericAspectRatio(aspectRatioNext);// no aspect ratio means custom aspect ratio so set to undefined
if(!aspectRatio)return undefined;// can't update crop if not defined yet
if(!crop||!loadState||!loadState.beforeComplete)return aspectRatio;// calculate difference between aspect ratios, if big difference, re-align in image
const aspectRatioDist=aspectRatioPrevious?Math.abs(aspectRatioNext-aspectRatioPrevious):1;// if crop centered scale up
if(isCropCentered(crop,size,rotation)&&cropLimitToImage&&aspectRatioDist>=0.1){const imageSize=sizeTurn(sizeClone(size),rotation);props.crop=rectApply(rectContainRect(rectCreateFromSize(imageSize),aspectRatioNext),fixPrecision);}else{const cropSize={width:crop.height*aspectRatio,height:crop.height};const tx=(crop.width-cropSize.width)*0.5;const ty=(crop.height-cropSize.height)*0.5;props.crop=rectApply(rectCreate(crop.x+tx,crop.y+ty,cropSize.width,cropSize.height),fixPrecision);}return aspectRatio;};const updateCropLimitToImage=props=>(limitToImageNext,limitToImagePrevious,onUpdate)=>{// skip if no crop defined
const{crop}=props;if(!crop)return limitToImageNext;// if was not limiting previously and now set limiting make sure crop fits bounds
if(!limitToImagePrevious&&limitToImageNext){onUpdate(()=>props.crop=rectClone(props.crop));}return limitToImageNext;};const updateRotation=props=>(rotationNext,rotationPrevious,onUpdate)=>{// when image rotation is updated we need to adjust the
// cropRect offset so rotation happens from cropRect center
// no change
if(rotationNext===rotationPrevious)return rotationNext;// get relevant data from store state
const{loadState,size,rotationRange,cropMinSize,cropMaxSize,crop,perspective,cropLimitToImage,cropOrigin}=props;// image not ready, exit!
if(!crop||!loadState||!loadState.beforeComplete)return rotationNext;// remember if current crop was at max size and centered, if so, resulting crop should also be at max size
const cropWasAtMaxSize=isCropMaxSize(crop,size,rotationPrevious);const cropWasCentered=isCropCentered(crop,size,rotationPrevious);// get new state
const res=applyRotationAction(rotationPrevious,rotationNext,rotationRange,crop,size,perspective,cropLimitToImage,cropOrigin,cropMinSize,cropMaxSize);// if is centered, and initial crop was at max size expand crop to max size
if(cropWasAtMaxSize&&cropWasCentered){const rect=getMaxSizeInRect(size,rotationNext,rectAspectRatio(res.crop));// move top left corner
res.crop.x+=res.crop.width*0.5;res.crop.y+=res.crop.height*0.5;res.crop.x-=rect.width*0.5;res.crop.y-=rect.height*0.5;// update size to max size
res.crop.width=rect.width;res.crop.height=rect.height;}// return validated rotation value, then, after we assign that value, we update the crop rect
// we may only call onUpdate if a change was made
onUpdate(()=>{props.crop=rectApply(res.crop,v=>fixPrecision(v,8));});// return result rotation (might have been rotated twice to fit crop rectangle)
return res.rotation;};// updates the range of valid rotation input
const updateRotationRange=(imageSize,imageIsRotatedSideways,cropMinSize,cropSize,cropLimitToImage)=>{if(!cropLimitToImage)return[MIN_ROTATION,MAX_ROTATION];/*
    - 'a' is angle between diagonal and image height
    - 'b' is angle between diagonal and crop height
    - 'c' is angle between diagonal and image width
    - resulting range is then a - b
    +----------/\------------------------+
    |         / \ \                      |
    |        /   \  \                    |
    |       /     \   \                  |
    |       \      \    \                |
    |         \     \     \              |
    |           \    \      \            |
    |             \   \       /          |
    |               \  \     /           |
    |                 \ \   /            |
    |                   \\a/b            |
    +---------------------\--------------+
    */const scalar=Math.max(cropMinSize.width/cropSize.width,cropMinSize.height/cropSize.height);const minSize=sizeCreate(cropSize.width*scalar,cropSize.height*scalar);// the hypotenus is the length of the diagonal of the min crop size
const requiredSpace=sizeHypotenuse(minSize);// minimum space available in horizontal / vertical direction
const availableSpace=Math.min(imageSize.width,imageSize.height);// if there's enough space available, we can return the max range
if(requiredSpace<availableSpace)return[MIN_ROTATION,MAX_ROTATION];// if the image is turned we need to swap the width and height
const imageWidth=imageIsRotatedSideways?imageSize.height:imageSize.width;const imageHeight=imageIsRotatedSideways?imageSize.width:imageSize.height;// subtracting the angle between the hypotenuse and the crop itself
const a=Math.acos(minSize.height/requiredSpace);const b=Math.acos(imageHeight/requiredSpace);const c=Math.asin(imageWidth/requiredSpace);const rangeHorizontal=a-b;const rangeVertical=c-a;// range is not a number, it means we can rotate as much as we want
if(Number.isNaN(rangeHorizontal)&&Number.isNaN(rangeVertical))return[MIN_ROTATION,MAX_ROTATION];// get minimum range
const range=Number.isNaN(rangeHorizontal)?rangeVertical:Number.isNaN(rangeVertical)?rangeHorizontal:Math.min(rangeHorizontal,rangeVertical);// if not, limit range to min and max rotation
const rangeMin=Math.max(-range,MIN_ROTATION);const rangeMax=Math.min(range,MAX_ROTATION);return[rangeMin,rangeMax];};// updates the range of valid crop rectangle input
const updateCropRange=(imageSize,rotation,cropAspectRatio,cropMinSize,cropMaxSize,cropLimitToImage)=>{// ! rotation doesn't affect min size, only max size
// set lower bounds to crop min size
const minSize=sizeClone(cropMinSize);// set upper bounds to crop max size
const maxSize=sizeClone(cropMaxSize);// now we got basic bounds, let's see if we should limit to the image bounds, else we done
if(!cropLimitToImage)return[minSize,maxSize];return[minSize,sizeApply(getMaxSizeInRect(imageSize,rotation,cropAspectRatio),Math.round)];};const formatShape=(shape,options)=>{const{context,props}=options;// only auto-format once
if(!shape._isFormatted){shape=shapeFormat(shape);shape._isFormatted=true;Object.assign(shape,props);}// we need to make sure shape is still correctly positioned relative to parent context
// draft cannot be relative
// if context changed
// if has left top right or bottom
if(!shape._isDraft&&shapeHasRelativeSize(shape)&&(!shape._context||!rectEqual(context,shape._context))){shape=shapeComputeRect(shape,context);shape._context={...context};}return shape;};const updateFrame=()=>frameShapeNext=>{if(!frameShapeNext)return;const shape={frameStyle:undefined,x:0,y:0,width:'100%',height:'100%',disableStyle:['backgroundColor','strokeColor','strokeWidth']};if(pintura_isString(frameShapeNext)){shape.frameStyle=frameShapeNext;}else{Object.assign(shape,frameShapeNext);}return shape;};var imageProps=[// image info received from read
['file'],['size'],// loading and processing state
['loadState'],['processState'],// derived info
['aspectRatio',DERIVED_STORE(({size})=>[size,$size=>$size?rectAspectRatio($size):undefined])],// image modifications
['perspectiveX',DEFAULT_VALUE(()=>0)],['perspectiveY',DEFAULT_VALUE(()=>0)],['perspective',DERIVED_STORE(({perspectiveX,perspectiveY})=>[[perspectiveX,perspectiveY],([x,y])=>({x,y})])],['rotation',DEFAULT_VALUE(()=>0),UPDATE_VALUE(updateRotation)],['flipX',DEFAULT_VALUE(()=>false)],['flipY',DEFAULT_VALUE(()=>false)],['flip',DERIVED_STORE(({flipX,flipY})=>[[flipX,flipY],([x,y])=>({x,y})])],['isRotatedSideways',UNIQUE_DERIVED_STORE(({rotation})=>[[rotation],([$rotation],set)=>set(isRotatedSideways($rotation)),(prevValue,nextValue)=>prevValue!==nextValue])],['crop',UPDATE_VALUE(updateCropRect)],['cropAspectRatio',UPDATE_VALUE(updateCropAspectRatio)],['cropOrigin'],['cropMinSize',DEFAULT_VALUE(()=>({width:1,height:1}))],['cropMaxSize',DEFAULT_VALUE(()=>({width:32768,height:32768}))],['cropLimitToImage',DEFAULT_VALUE(()=>true),UPDATE_VALUE(updateCropLimitToImage)],['cropSize',UNIQUE_DERIVED_STORE(({crop})=>[[crop],([$crop],set)=>{if(!$crop)return;set(sizeCreate($crop.width,$crop.height));},// if is same as previous size, don't trigger update (happens when updating only the crop offset)
(prevValue,nextValue)=>sizeEqual(prevValue,nextValue)])],['cropRectAspectRatio',DERIVED_STORE(({cropSize})=>[[cropSize],([$cropSize],set)=>{if(!$cropSize)return;set(fixPrecision(rectAspectRatio($cropSize),5));}])],['cropRange',UNIQUE_DERIVED_STORE(({size,rotation,cropRectAspectRatio,cropMinSize,cropMaxSize,cropLimitToImage})=>[[size,rotation,cropRectAspectRatio,cropMinSize,cropMaxSize,cropLimitToImage],([$size,$rotation,$cropRectAspectRatio,$cropMinSize,$cropMaxSize,$cropLimitToImage],set)=>{// wait for image size
if(!$size)return;const range=updateCropRange($size,$rotation,$cropRectAspectRatio,$cropMinSize,$cropMaxSize,$cropLimitToImage);set(range);},// if is same range as previous range, don't trigger update
(prevRange,nextRange)=>arrayEqual(prevRange,nextRange)])],['rotationRange',UNIQUE_DERIVED_STORE(({size,isRotatedSideways,cropMinSize,cropSize,cropLimitToImage})=>[[size,isRotatedSideways,cropMinSize,cropSize,cropLimitToImage],([$size,$isRotatedSideways,$cropMinSize,$cropSize,$cropLimitToImage],set)=>{// wait for image size
if(!$size||!$cropSize)return;const range=updateRotationRange($size,$isRotatedSideways,$cropMinSize,$cropSize,$cropLimitToImage);set(range);},// if is same range as previous range, don't trigger update
(prevRange,nextRange)=>arrayEqual(prevRange,nextRange)])],// canvas
['backgroundColor',UPDATE_VALUE(()=>color=>padColorArray(color))],// size
['targetSize'],// effects
['colorMatrix'],['convolutionMatrix'],['gamma'],['noise'],['vignette'],// redaction lives in image space
['redaction',MAP_STORE(({size})=>[formatShape,{context:size}])],// annotation lives in image space
['annotation',MAP_STORE(({size})=>[formatShape,{context:size}])],// decoration lives in crop space
['decoration',MAP_STORE(({crop})=>[formatShape,{context:crop}])],// frame to render on top of the image (or outside)
['frame',UPDATE_VALUE(updateFrame)],// custom metadata
['metadata'],// state of image, used to restore a previous state or request the current state
['state',CUSTOM_STORE(stateStore)]];var process=async(value,chainTasks,chainOptions={},processOptions)=>{// options relevant to the process method itself
const{ontaskstart,ontaskprogress,ontaskend,token}=processOptions;// has been cancelled
let cancelled=false;// set cancel handler method
token.cancel=()=>{// cancel called from outside of the process method
cancelled=true;};// step through chain
for(const[index,task]of chainTasks.entries()){// exit when cancelled
if(cancelled)return;// get the task function and the id so we can notify the callee of the task that is being started
const[fn,id]=task;// start task
ontaskstart(index,id);try{value=await fn(value,{...chainOptions},event=>ontaskprogress(index,id,event));}catch(err){// stop processing more items in the chain
cancelled=true;// pass error back to parent
throw err;}ontaskend(index,id);}return value;};// TODO: find better location for minSize / file load validation
var createImageCore=({minSize={width:1,height:1}}={})=>{// create default store
const{stores,accessors}=createStores(imageProps);// pub/sub
const{pub,sub}=pubsub();// processing handler
const createProcessingHandler=(stateProp,eventKey)=>{const getStore=()=>accessors[stateProp]||{};const setStore=obj=>accessors[stateProp]={...getStore(),...obj,timeStamp:Date.now()};const hasError=()=>getStore().error;const handleError=error=>{if(hasError())return;setStore({error:error});pub(`${eventKey}error`,{...getStore()});};return{start(){pub(`${eventKey}start`);},onabort(){setStore({abort:true});pub(`${eventKey}abort`,{...getStore()});},ontaskstart(index,id){if(hasError())return;setStore({index,task:id,taskProgress:undefined,taskLengthComputable:undefined});pub(`${eventKey}taskstart`,{...getStore()});},ontaskprogress(index,id,event){if(hasError())return;setStore({index,task:id,taskProgress:event.loaded/event.total,taskLengthComputable:event.lengthComputable});pub(`${eventKey}taskprogress`,{...getStore()});pub(`${eventKey}progress`,{...getStore()});},ontaskend(index,id){if(hasError())return;setStore({index,task:id});pub(`${eventKey}taskend`,{...getStore()});},ontaskerror(error){handleError(error);},error(error){handleError(error);},beforeComplete(data){if(hasError())return;setStore({beforeComplete:true});pub(`before${eventKey}`,data);},complete(data){if(hasError())return;setStore({complete:true});pub(eventKey,data);}};};//#region read image
const read=(src,{reader})=>{// exit if no reader supplied
if(!reader)return;// reset file data to undefined as we're loading a new image
Object.assign(accessors,{file:undefined,size:undefined,loadState:undefined});// our cancel token so we can abort load if needed, cancel will be set by process
let imageReadToken={cancel:noop$1};let imageReadCancelled=false;const imageReadHandler=createProcessingHandler('loadState','load');const processOptions={token:imageReadToken,...imageReadHandler};const readerState={src,size:undefined,dest:undefined};const readerOptions={};// wait a tick before starting image read so the read can be cancelled in loadstart
Promise.resolve().then(async()=>{try{imageReadHandler.start();if(imageReadCancelled)return imageReadHandler.onabort();const output=await process(readerState,reader,readerOptions,processOptions);// was cancelled
if(imageReadCancelled)return imageReadHandler.onabort();// get shortcuts for validation
const{size,dest}=output||{};// if we don't have a size
if(!size||!size.width||!size.height)throw new EditorError('Image size missing','IMAGE_SIZE_MISSING',output);// size of image is too small
if(size.width<minSize.width||size.height<minSize.height)throw new EditorError('Image too small','IMAGE_TOO_SMALL',{...output,minWidth:minSize.width,minHeight:minSize.height});// update internal data
Object.assign(accessors,{size:size,file:dest});// before load complete
imageReadHandler.beforeComplete(output);// done loading image
imageReadHandler.complete(output);}catch(err){imageReadHandler.error(err);}finally{imageReadToken=undefined;}});// call to abort load
return()=>{imageReadCancelled=true;imageReadToken&&imageReadToken.cancel();imageReadHandler.onabort();};};//#endregion
//#region write image
const write=(writer,options)=>{// not ready to start processing
if(!accessors.loadState.complete)return;// reset process state to undefined
accessors.processState=undefined;const imageWriteHandler=createProcessingHandler('processState','process');const writerState={src:accessors.file,imageState:accessors.state,dest:undefined};// willProcessImageState
if(!writer){imageWriteHandler.start();imageWriteHandler.complete(writerState);return;}// we need this token to be a blet to cancel the processing operation
let imageWriteToken={cancel:noop$1};let imageWriteCancelled=false;const writerOptions=options;const processOptions={token:imageWriteToken,...imageWriteHandler};// wait a tick before starting image write so the write can be cancelled in processtart
Promise.resolve().then(async()=>{try{imageWriteHandler.start();if(imageWriteCancelled)return imageWriteHandler.onabort();const output=await process(writerState,writer,writerOptions,processOptions);imageWriteHandler.complete(output);}catch(err){imageWriteHandler.error(err);}finally{imageWriteToken=undefined;}});// call to abort processing
return()=>{imageWriteCancelled=true;imageWriteToken&&imageWriteToken.cancel();};};//#endregion
//#region api
defineMethods(accessors,{read,write,on:sub});//#endregion
// expose store API
return{accessors,stores};};// @ts-ignore
const editorEventsToBubble=['loadstart','loadabort','loaderror','loadprogress','load','processstart','processabort','processerror','processprogress','process'];const imagePrivateProps=['flip','cropOrigin','isRotatedSideways','perspective','perspectiveX','perspectiveY','cropRange'];const editorPrivateProps=(/* unused pure expression or super */ null && (['images']));const imagePublicProps=imageProps.map(([prop])=>prop).filter(prop=>!imagePrivateProps.includes(prop));const getImagePropGroupedName=prop=>`image${capitalizeFirstLetter(prop)}`;const getEditorProps$1=()=>{const imageProperties=imagePublicProps.map(getImagePropGroupedName);const editorProperties=props.map(([prop])=>prop).filter(prop=>!editorPrivateProps.includes(prop));return imageProperties.concat(editorProperties);};const isImageSource=src=>pintura_isString(src)||isBinary(src)||pintura_isElement(src);const isImageState=obj=>hasProp(obj,'crop');var createImageEditor=()=>{// create default stores
const{stores,accessors}=createStores(props);// set up pub/sub for the app layer
const{sub,pub}=pubsub();const bubble=name=>value=>pub(name,value);// helper method
const getImageObjSafe=()=>accessors.images?accessors.images[0]:{};// initialImageProps is the list of transforms to apply when the image loads
let initialImageProps={};// create shortcuts to image props : `crop` -> `imageCrop`
imagePublicProps.forEach(prop=>{Object.defineProperty(accessors,getImagePropGroupedName(prop),{get:()=>{// no image, can't get
const image=getImageObjSafe();if(!image)return;// return from image state
return image.accessors[prop];},set:value=>{// always use as initial prop when loading a new image without reset
initialImageProps[getImagePropGroupedName(prop)]=value;// no image, we can't update
const image=getImageObjSafe();if(!image)return;// update the image immidiately
image.accessors[prop]=value;}});});// internal helper method to get active image
const getImage=()=>accessors.images&&accessors.images[0];// handling loading an image if a src is set
const unsubSrc=stores.src.subscribe(src=>{// no image set, means clear active image
if(!src)return accessors.images=[];// exit here if we don't have an imageReader we'll wait for an imageReader to be defined
if(!accessors.imageReader)return;// reset initial image props if an image is already loaded, so props applied to previous image aren't applied to the new one
if(accessors.images.length)initialImageProps={};// load image in src prop
loadSrc(src);});const unsubReader=stores.imageReader.subscribe(reader=>{// can't do anything without an image reader
if(!reader)return;// an image has already been loaded no need to load images that were set earlier
if(accessors.images.length)return;// no image to load, we'll wait for images to be set to the `src` prop
if(!accessors.src)return;// src is waiting to be loaded so let's pick it up,
loadSrc(accessors.src);});const loadSrc=src=>{// push it back a tick so we know initialImageProps are set
Promise.resolve().then(()=>{// load with initial props
return loadImage(src,initialImageProps);}).catch(()=>{// fail silently, any errors are handled with 'loaderror' event
});};//#endregion
//#region public method (note that these are also called from UI, name of method is name of dispatched event in UI)
const applyImageOptionsOrState=(image,options)=>{// test if options is image state, if so, apply and exit
if(isImageState(options)){accessors.imageState=options;return;}// create an initial crop rect if no crop supplied
if(!options.imageCrop){const imageSize=image.accessors.size;const imageRotation=options.imageRotation||0;const cropRect=rectCreateFromSize(sizeRotate(sizeClone(imageSize),imageRotation));const aspectRatio=options.imageCropAspectRatio||(options.imageCropLimitToImage?rectAspectRatio(imageSize)// use image size if should limit to image
:rectAspectRatio(cropRect));// use rotated crop rect bounds if no limit
const crop=rectContainRect(cropRect,aspectRatio);// center the image in the crop rectangle
if(!options.imageCropLimitToImage){crop.x=(imageSize.width-crop.width)/2;crop.y=(imageSize.height-crop.height)/2;}options.imageCrop=crop;}// we need to apply these props in the correct order
['imageCropLimitToImage','imageCrop','imageCropAspectRatio','imageRotation'].filter(prop=>hasProp(options,prop)).forEach(prop=>{// assign to `image`
accessors[prop]=options[prop];// remove from normalizedOptions so it's not set twice
delete options[prop];});// don't set the above options for a second time
const{imageCropLimitToImage,imageCrop,imageCropAspectRatio,imageRotation,...remainingOptions}=options;// trigger setState
Object.assign(accessors,remainingOptions);};// load image, resolve when image is loaded
let imageLoadAbort;const loadImage=(src,options={})=>new Promise((resolve,reject)=>{// get current image
let image=getImage();// determine min defined image size (is crop min size)
const cropLimitedToImage=!(options.cropLimitToImage===false||options.imageCropLimitToImage===false);const cropMinSize=options.cropMinSize||options.imageCropMinSize;const minImageSize=cropLimitedToImage?cropMinSize:image&&image.accessors.cropMinSize;// if already has image, remove existing image
if(image)removeImage();// access image props and stores
image=createImageCore({minSize:minImageSize});editorEventsToBubble.map(event=>image.accessors.on(event,bubble(event)));// done, clean up listeners
const fin=()=>{// reset initial props (as now applied)
initialImageProps={};unsubs.forEach(unsub=>unsub());};const unsubs=[];unsubs.push(image.accessors.on('loaderror',error=>{fin();reject(error);}));unsubs.push(image.accessors.on('loadabort',()=>{fin();reject({name:'AbortError'});}));unsubs.push(image.accessors.on('load',output=>{imageLoadAbort=undefined;fin();resolve(output);}));unsubs.push(image.accessors.on('beforeload',()=>applyImageOptionsOrState(image,options)));// set new image
accessors.images=[image];// assign passed options to editor accessors, we ignore 'src'
if(options.imageReader)accessors.imageReader=options.imageReader;if(options.imageWriter)accessors.imageWriter=options.imageWriter;// start reading image
imageLoadAbort=image.accessors.read(src,{reader:accessors.imageReader});});// start processing a loaded image, resolve when image is processed
let imageProcessAbort;const processImage=(src,options)=>new Promise(async(resolve,reject)=>{// if src supplied, first load src, then process
if(isImageSource(src)){await loadImage(src,options);}// if first argument is not `src` but is set it's an options object, so we'll update the options before generating the image
else if(src){if(isImageState(src)){accessors.imageState=src;}else{Object.assign(accessors,src);}}// get current active image
const image=getImage();// needs image for processing
if(!image)return reject('no image');// done, clean up listeners
const fin=()=>{imageProcessAbort=undefined;unsubs.forEach(unsub=>unsub());};const unsubs=[];unsubs.push(image.accessors.on('processerror',error=>{fin();reject(error);}));unsubs.push(image.accessors.on('processabort',()=>{fin();reject({name:'AbortError'});}));unsubs.push(image.accessors.on('process',output=>{fin();resolve(output);}));imageProcessAbort=image.accessors.write(accessors.imageWriter,{shapePreprocessor:accessors.shapePreprocessor||passthrough,imageScrambler:accessors.imageScrambler});});const abortProcessImage=()=>{const image=getImage();if(!image)return;if(imageProcessAbort)imageProcessAbort();image.accessors.processState=undefined;};// used internally (triggered by 'x' button when error loading image in UI)
const abortLoadImage=()=>{if(imageLoadAbort)imageLoadAbort();accessors.images=[];};// edit image, loads an image and resolve when image is processed
const editImage=(src,options)=>new Promise((resolve,reject)=>{loadImage(src,options).then(()=>{// access image props and stores
const{images}=accessors;const image=images[0];// done, clean up listeners
const done=()=>{unsubReject();unsubResolve();};const unsubReject=image.accessors.on('processerror',error=>{done();reject(error);});const unsubResolve=image.accessors.on('process',output=>{done();resolve(output);});}).catch(reject);});const removeImage=()=>{// no images, nothing to remove
const image=getImage();if(!image)return;// try to abort image load
if(imageLoadAbort)imageLoadAbort();image.accessors.loadState=undefined;// clear images
accessors.images=[];};//#endregion
Object.defineProperty(accessors,'stores',{get:()=>stores});//#region API
defineMethods(accessors,{on:sub,loadImage,abortLoadImage,editImage,removeImage,processImage,abortProcessImage,destroy:()=>{unsubSrc();unsubReader();}});return accessors;//#endregion
};const processImage=(src,options)=>{const{processImage}=createImageEditor();return processImage(src,options);};var getCanvasMemoryLimit=()=>{if(!isSafari$1())return Infinity;const isSafari15=/15_/.test(navigator.userAgent);if(isIOS()){// limit resolution a little bit further to prevent drawing issues
if(isSafari15)return 3840*3840;// old iOS can deal with 4096 * 4096 without issues
return 4096*4096;}return isSafari15?4096*4096:Infinity;};// custom method to draw images
const canvasDrawImage=async(ctx,image,srcRect,destRect)=>{// get resized image
const{dest}=await processImage(image,{imageReader:createDefaultImageReader$1(),imageWriter:createDefaultImageWriter$1({format:'canvas',targetSize:{...destRect,upscale:true}}),imageCrop:srcRect});// draw processed image
ctx.drawImage(dest,destRect.x,destRect.y,destRect.width,destRect.height);// release image canvas to free up memory
releaseCanvas(dest);};// connect function in process chain
const connect=(fn,getter=(...args)=>args,setter)=>async(state,options,onprogress)=>{// will hold function result
// at this point we don't know if the length of this task can be computed
onprogress(createProgressEvent(0,false));// try to run the function
let progressUpdated=false;const res=await fn(...getter(state,options,event=>{progressUpdated=true;onprogress(event);}));// a setter isn't required
setter&&setter(state,res);// if progress was updated, we expect the connected function to fire the 1/1 event, else we fire it here
if(!progressUpdated)onprogress(createProgressEvent(1,false));return state;};//
// Reader/Writer Presets
//
const AnyToFile=({srcProp='src',destProp='dest'}={})=>[connect(srcToFile,(state,options,onprogress)=>[state[srcProp],onprogress],(state,file)=>state[destProp]=file),'any-to-file'];const BlobReadImageSize=({srcProp='src',destProp='size'}={})=>[connect(getImageSize,(state,options)=>[state[srcProp]],(state,size)=>state[destProp]=size),'read-image-size'];const ImageSizeMatchOrientation=({srcSize='size',srcOrientation='orientation',destSize='size'}={})=>[connect(orientImageSize,state=>[state[srcSize],state[srcOrientation]],(state,size)=>state[destSize]=size),'image-size-match-orientation'];const BlobReadImageHead=({srcProp='src',destProp='head'}={})=>[connect((blob,slice)=>isJPEG(blob)?blobReadSection(blob,slice):undefined,// 64 * 1024 should be plenty to find extract header
// Exif metadata are restricted in size to 64 kB in JPEG images because
// according to the specification this information must be contained within a single JPEG APP1 segment.
state=>[state[srcProp],[0,64*2048],onprogress],(state,head)=>state[destProp]=head),'read-image-head'];const ImageHeadReadExifOrientationTag=({srcProp='head',destProp='orientation'}={})=>[connect(arrayBufferImageExif,state=>[state[srcProp],ORIENTATION_TAG],(state,orientation=1)=>state[destProp]=orientation),'read-exif-orientation-tag'];const ImageHeadClearExifOrientationTag=({srcProp='head'}={})=>[connect(arrayBufferImageExif,state=>[state[srcProp],ORIENTATION_TAG,1]),'clear-exif-orientation-tag'];const ApplyCanvasScalar=({srcImageSize='size',srcCanvasSize='imageData',srcImageState='imageState',destImageSize='size',destScalar='scalar'}={})=>[connect((naturalSize,canvasSize,imageState)=>{// calculate canvas scalar
const scalar=Math.min(canvasSize.width/naturalSize.width,canvasSize.height/naturalSize.height);// done because not scaling
if(scalar!==1){const{crop,annotation,decoration}=imageState;// origin to scale to
const origin=vectorCreateEmpty();// scale select.crop
if(crop)imageState.crop=rectScale(crop,scalar,origin);// scale annotation
const translate=vectorCreateEmpty();imageState.annotation=annotation.map(shape=>shapeComputeTransform(shape,translate,scalar));// scale decoration
imageState.decoration=decoration.map(shape=>shapeComputeTransform(shape,translate,scalar));}return[scalar,sizeCreateFromAny(canvasSize)];},state=>[state[srcImageSize],state[srcCanvasSize],state[srcImageState]],(state,[scalar,imageSize])=>{state[destScalar]=scalar;state[destImageSize]=imageSize;}),'calculate-canvas-scalar'];const BlobToImageData=({srcProp='src',destProp='imageData',canvasMemoryLimit=undefined})=>[connect(blobToImageData,state=>[state[srcProp],canvasMemoryLimit],(state,imageData)=>state[destProp]=imageData),'blob-to-image-data'];const ImageDataMatchOrientation=({srcImageData='imageData',srcOrientation='orientation'}={})=>[connect(orientImageData,state=>[state[srcImageData],state[srcOrientation]],(state,imageData)=>state.imageData=imageData),'image-data-match-orientation'];const ImageDataFill=({srcImageData='imageData',srcImageState='imageState'}={})=>[connect(fillImageData,state=>[state[srcImageData],{backgroundColor:state[srcImageState].backgroundColor}],(state,imageData)=>state.imageData=imageData),'image-data-fill'];const ImageDataCrop=({srcImageData='imageData',srcImageState='imageState'}={})=>[connect(cropImageData,state=>[state[srcImageData],{crop:state[srcImageState].crop,rotation:state[srcImageState].rotation,flipX:state[srcImageState].flipX,flipY:state[srcImageState].flipY}],(state,imageData)=>state.imageData=imageData),'image-data-crop'];const hasTargetSize=imageState=>!!(imageState.targetSize&&imageState.targetSize.width||imageState.targetSize&&imageState.targetSize.height);const ImageDataResize=({resize={width:undefined,height:undefined,fit:undefined,upscale:undefined},srcProp='imageData',srcImageState='imageState',destImageScaledSize='imageScaledSize'})=>[connect(resizeImageData,state=>[state[srcProp],{width:Math.min(resize.width||Number.MAX_SAFE_INTEGER,state[srcImageState].targetSize&&state[srcImageState].targetSize.width||Number.MAX_SAFE_INTEGER),height:Math.min(resize.height||Number.MAX_SAFE_INTEGER,state[srcImageState].targetSize&&state[srcImageState].targetSize.height||Number.MAX_SAFE_INTEGER),fit:resize.fit||'contain',upscale:hasTargetSize(state[srcImageState])?true:resize.upscale||false}],(state,imageData)=>{if(!sizeEqual(state.imageData,imageData))state[destImageScaledSize]=sizeCreateFromAny(imageData);state.imageData=imageData;}),'image-data-resize'];const ImageDataFilter=({srcImageData='imageData',srcImageState='imageState',destImageData='imageData'}={})=>[connect(filterImageData,state=>{const{colorMatrix}=state[srcImageState];const colorMatrices=colorMatrix&&Object.keys(colorMatrix).map(name=>colorMatrix[name]).filter(Boolean);return[state[srcImageData],{colorMatrix:colorMatrices&&getColorMatrixFromColorMatrices(colorMatrices),convolutionMatrix:state[srcImageState].convolutionMatrix,gamma:state[srcImageState].gamma,noise:state[srcImageState].noise,vignette:state[srcImageState].vignette}];},(state,imageData)=>state[destImageData]=imageData),'image-data-filter'];const createImageContextDrawingTransform=(state,{srcSize,srcImageState,destImageScaledSize})=>ctx=>{const imageSize=state[srcSize];const{crop=rectCreateFromSize(imageSize),rotation=0,flipX,flipY}=state[srcImageState];const rotatedRect=getImageTransformedRect(imageSize,rotation);const rotatedSize={width:rotatedRect.width,height:rotatedRect.height};// calculate image scalar so we can scale annotations accordingly
const scaledSize=state[destImageScaledSize];const scalar=scaledSize?Math.min(scaledSize.width/crop.width,scaledSize.height/crop.height):1;// calculate center
const dx=imageSize.width*0.5-rotatedSize.width*0.5;const dy=imageSize.height*0.5-rotatedSize.height*0.5;const center=sizeCenter(imageSize);// image scalar
ctx.scale(scalar,scalar);// offset
ctx.translate(-dx,-dy);ctx.translate(-crop.x,-crop.y);// rotation
ctx.translate(center.x,center.y);ctx.rotate(rotation);ctx.translate(-center.x,-center.y);// flipping
ctx.scale(flipX?-1:1,flipY?-1:1);ctx.translate(flipX?-imageSize.width:0,flipY?-imageSize.height:0);// annotations are clipped clip to image
ctx.rect(0,0,imageSize.width,imageSize.height);ctx.clip();};const ImageDataRedact=({srcImageData='imageData',srcImageState='imageState',destImageData='imageData',destScalar='scalar'}={})=>[connect(async(imageData,imageScrambler,imageBackgroundColor,shapes,scalar)=>{// skip!
if(!imageScrambler)return imageData;// create scrambled texture version
let scrambledCanvas;try{const options={dataSizeScalar:getImageRedactionScaleFactor(imageData,shapes)};if(imageBackgroundColor&&imageBackgroundColor[3]>0){options.backgroundColor=[...imageBackgroundColor];}scrambledCanvas=await imageScrambler(imageData,options);}catch(err){}// create drawing context
const canvas=h('canvas');canvas.width=imageData.width;canvas.height=imageData.height;const ctx=canvas.getContext('2d');ctx.putImageData(imageData,0,0);// set up a clip path so we only draw scrambled image within path
const path=new Path2D();shapes.forEach(shape=>{const rect=rectCreate(shape.x,shape.y,shape.width,shape.height);rectMultiply(rect,scalar);const corners=rectRotate(rectClone(rect),shape.rotation);const poly=new Path2D();corners.forEach((corner,i)=>{if(i===0)return poly.moveTo(corner.x,corner.y);poly.lineTo(corner.x,corner.y);});path.addPath(poly);});ctx.clip(path,'nonzero');ctx.imageSmoothingEnabled=false;ctx.drawImage(scrambledCanvas,0,0,canvas.width,canvas.height);releaseCanvas(scrambledCanvas);// done
const imageDataOut=ctx.getImageData(0,0,canvas.width,canvas.height);// clean up memory usage
releaseCanvas(canvas);return imageDataOut;},(state,{imageScrambler})=>[state[srcImageData],imageScrambler,state[srcImageState].backgroundColor,state[srcImageState].redaction,state[destScalar]],(state,imageData)=>state[destImageData]=imageData),'image-data-annotate'];const ImageDataAnnotate=({srcImageData='imageData',srcSize='size',srcImageState='imageState',destImageData='imageData',destImageScaledSize='imageScaledSize'}={})=>[connect(drawImageData,(state,{shapePreprocessor})=>[state[srcImageData],{shapes:state[srcImageState].annotation,context:state[srcSize],transform:createImageContextDrawingTransform(state,{srcSize,srcImageState,destImageScaledSize}),drawImage:canvasDrawImage,preprocessShape:shape=>shapePreprocessor(shape,{isPreview:false})}],(state,imageData)=>state[destImageData]=imageData),'image-data-annotate'];const ImageDataDecorate=({srcImageData='imageData',srcImageState='imageState',destImageData='imageData',destImageScaledSize='imageScaledSize'}={})=>[connect(drawImageData,(state,{shapePreprocessor})=>[state[srcImageData],{shapes:state[srcImageState].decoration,context:state[srcImageState].crop,transform:ctx=>{// calculate image scalar so we can scale decoration accordingly
const{crop}=state.imageState;const scaledSize=state[destImageScaledSize];const scalar=scaledSize?Math.min(scaledSize.width/crop.width,scaledSize.height/crop.height):1;ctx.scale(scalar,scalar);},drawImage:canvasDrawImage,preprocessShape:shape=>shapePreprocessor(shape,{isPreview:false})}],(state,imageData)=>state[destImageData]=imageData),'image-data-decorate'];const ImageDataFrame=({srcImageData='imageData',srcImageState='imageState',destImageData='imageData',destImageScaledSize='imageScaledSize'}={})=>[connect(drawImageData,(state,{shapePreprocessor})=>{const frame=state[srcImageState].frame;if(!frame)return[state[srcImageData]];const context={...state[srcImageState].crop};const bounds=shapesBounds(shapesFromCompositShape(frame,context,shapePreprocessor),context);context.x=Math.abs(bounds.left);context.y=Math.abs(bounds.top);context.width+=Math.abs(bounds.left)+Math.abs(bounds.right);context.height+=Math.abs(bounds.top)+Math.abs(bounds.bottom);const{crop}=state.imageState;const scaledSize=state[destImageScaledSize];const scalar=scaledSize?Math.min(scaledSize.width/crop.width,scaledSize.height/crop.height):1;rectMultiply(context,scalar);// use floor because we can't fill up half pixels
context.x=Math.floor(context.x);context.y=Math.floor(context.y);context.width=Math.floor(context.width);context.height=Math.floor(context.height);return[state[srcImageData],{shapes:[frame],contextBounds:context,transform:ctx=>{ctx.translate(context.x,context.y);},drawImage:canvasDrawImage,preprocessShape:shape=>shapePreprocessor(shape,{isPreview:false})}];},(state,imageData)=>state[destImageData]=imageData),'image-data-frame'];const ImageDataToBlob=({mimeType=undefined,quality=undefined,srcImageData='imageData',srcFile='src',destBlob='blob'}={})=>[connect(imageDataToBlob,state=>[state[srcImageData],mimeType||getMimeTypeFromFilename(state[srcFile].name)||state[srcFile].type,quality],(state,blob)=>state[destBlob]=blob),'image-data-to-blob'];const ImageDataToCanvas=({srcImageData='imageData',srcOrientation='orientation',destCanvas='dest'}={})=>[connect(imageDataToCanvas,state=>[state[srcImageData],state[srcOrientation]],(state,canvas)=>state[destCanvas]=canvas),'image-data-to-canvas'];const writeImageHead=async(blob,head)=>{if(!isJPEG(blob)||!head)return blob;// get exif section
const view=new DataView(head);const markers=dataViewGetApplicationMarkers(view);if(!markers||!markers.exif)return blob;const{exif}=markers;// from byte 0 to end of exif header
const exifBuffer=head.slice(0,exif.offset+exif.size+2);return blobWriteSection(blob,// insert head buffer into blob
exifBuffer,// current blob doesn't have exif header (as outputted by canvas), so we insert ours in
// (jpeg header 2) + (jfif size 16) + (app1 header 2)
[20]);};const BlobWriteImageHead=(srcBlob='blob',srcHead='head',destBlob='blob')=>[connect(writeImageHead,state=>[state[srcBlob],state[srcHead]],(state,blob)=>state[destBlob]=blob),'blob-write-image-head'];const BlobToFile=({renameFile=undefined,srcBlob='blob',srcFile='src',destFile='dest',defaultFilename=undefined}={})=>[connect(blobToFile,state=>[state[srcBlob],renameFile?renameFile(state[srcFile]):state[srcFile].name||`${defaultFilename}.${getExtensionFromMimeType(state[srcBlob].type)}`],(state,file)=>state[destFile]=file),'blob-to-file'];const Store=({url='./',dataset=state=>[['dest',state.dest,state.dest.name],['imageState',state.imageState]],destStore='store'})=>[connect(// upload function
async(dataset,onprogress)=>await post(url,dataset,{onprogress}),// get state values
(state,options,onprogress)=>[dataset(state),onprogress],// set state values
(state,xhr)=>state[destStore]=xhr// logs XHR request returned by `post`
),'store'];const PropFilter=allowlist=>[connect(state=>{// if no allowlist suppleid or is empty array we don't filter
if(!allowlist||!allowlist.length)return state;// else we only allow the props defined in the list and delete non matching props
Object.keys(state).forEach(key=>{if(allowlist.includes(key))return;delete state[key];});return state;}),'prop-filter'];// Generic image reader, suitable for most use cases
const createDefaultImageReader$1=(options={})=>{const{orientImage=true,outputProps=['src','dest','size'],preprocessImageFile}=options;return[// can read most source files and turn them into blobs
AnyToFile(),// TODO: test if supported mime/type
// called when file created, can be used to read unrecognized files
preprocessImageFile&&[connect(preprocessImageFile,(state,options,onprogress)=>[state.dest,options,onprogress],(state,file)=>state.dest=file),'preprocess-image-file'],// quickly read size (only reads first part of image)
BlobReadImageSize({srcProp:'dest'}),// fix image orientation
orientImage&&BlobReadImageHead({srcProp:'dest'}),orientImage&&ImageHeadReadExifOrientationTag(),orientImage&&ImageSizeMatchOrientation(),// remove unwanted props
PropFilter(outputProps)].filter(Boolean);};const createDefaultImageWriter$1=(options={})=>{const{canvasMemoryLimit=getCanvasMemoryLimit(),orientImage=true,copyImageHead=true,mimeType=undefined,quality=undefined,renameFile=undefined,targetSize=undefined,store=undefined,format='file',outputProps=['src','dest','imageState','store'],preprocessImageSource,preprocessImageState,postprocessImageData,postprocessImageBlob}=options;return[// allow preprocessing of image blob, should return a new blob, for example to automatically make image background transparent
preprocessImageSource&&[connect(preprocessImageSource,(state,options,onprogress)=>[state.src,options,onprogress],(state,src)=>state.src=src),'preprocess-image-source'],// get orientation info (if is jpeg)
(orientImage||copyImageHead)&&BlobReadImageHead(),orientImage&&ImageHeadReadExifOrientationTag(),// get image size
BlobReadImageSize(),// allow preproccesing of image state for example to replace placeholders
preprocessImageState&&[connect(preprocessImageState,(state,options,onprogress)=>[state.imageState,options,onprogress],(state,imageState)=>state.imageState=imageState),'preprocess-image-state'],// get image data
BlobToImageData({canvasMemoryLimit}),// fix image orientation
orientImage&&ImageSizeMatchOrientation(),orientImage&&ImageDataMatchOrientation(),// apply canvas scalar to data
ApplyCanvasScalar(),// apply image state
ImageDataRedact(),ImageDataCrop(),ImageDataResize({resize:targetSize}),ImageDataFilter(),ImageDataFill(),ImageDataAnnotate(),ImageDataDecorate(),ImageDataFrame(),// run post processing on image data, for example to apply circular crop
postprocessImageData&&[connect(postprocessImageData,(state,options,onprogress)=>[state.imageData,options,onprogress],(state,imageData)=>state.imageData=imageData),'postprocess-image-data'],// convert to correct output format
format==='file'?ImageDataToBlob({mimeType,quality}):format==='canvas'?ImageDataToCanvas():[state=>{state.dest=state.imageData;return state;}],// we overwite the exif orientation tag so the image is oriented correctly
format==='file'&&orientImage&&ImageHeadClearExifOrientationTag(),// we write the new image head to the target blob
format==='file'&&copyImageHead&&BlobWriteImageHead(),// allow converting the blob to a different format
postprocessImageBlob&&[connect(postprocessImageBlob,({blob,imageData,src},options,onprogress)=>[{blob,imageData,src},options,onprogress],(state,blob)=>state.blob=blob),'postprocess-image-file'],// turn the image blob into a file, will also rename the file
format==='file'&&BlobToFile({defaultFilename:'image',renameFile}),// upload or process data if is a file
format==='file'?// used for file output formats
store&&(pintura_isString(store)?// a basic store to post to
Store({url:store}):// see if is fully custom or store config
pintura_isFunction(store)?// fully custom store function
[store,'store']:// a store configuration object
Store(store)):// used for imageData and canvas output formats
pintura_isFunction(store)&&[store,'store'],// remove unwanted props
PropFilter(outputProps)].filter(Boolean);};var scrambleEffect=(options,done)=>{const{imageData,amount=1}=options;const intensity=Math.round(Math.max(1,amount)*2);const range=Math.round(intensity*0.5);const inputWidth=imageData.width;const inputHeight=imageData.height;const outputData=new Uint8ClampedArray(inputWidth*inputHeight*4);const inputData=imageData.data;let randomData;let i=0,x,y,r;let xoffset=0;let yoffset=0;let index;const l=inputWidth*inputHeight*4-4;for(y=0;y<inputHeight;y++){randomData=crypto.getRandomValues(new Uint8ClampedArray(inputHeight));for(x=0;x<inputWidth;x++){r=randomData[y]/255;xoffset=0;yoffset=0;if(r<0.5){xoffset=(-range+Math.round(Math.random()*intensity))*4;}if(r>0.5){yoffset=(-range+Math.round(Math.random()*intensity))*(inputWidth*4);}// limit to image data
index=Math.min(Math.max(0,i+xoffset+yoffset),l);outputData[i]=inputData[index];outputData[i+1]=inputData[index+1];outputData[i+2]=inputData[index+2];outputData[i+3]=inputData[index+3];i+=4;}}done(null,{data:outputData,width:imageData.width,height:imageData.height});};// basic blur covolution matrix
const BLUR_MATRIX=[0.0625,0.125,0.0625,0.125,0.25,0.125,0.0625,0.125,0.0625];var imageDataScramble=async(inputData,options={})=>{if(!inputData)return;const{width,height}=inputData;const{dataSize=96,dataSizeScalar=1,scrambleAmount=4,blurAmount=6,outputFormat='canvas',backgroundColor=[0,0,0]}=options;const size=Math.round(dataSize*dataSizeScalar);const scalar=Math.min(size/width,size/height);const outputWidth=Math.floor(width*scalar);const outputHeight=Math.floor(height*scalar);// draw low res preview, add margin so blur isn't transparent
const scaledOutputCanvas=h('canvas',{width:outputWidth,height:outputHeight});const ctx=scaledOutputCanvas.getContext('2d');// fill background on transparent images
backgroundColor.length=3;// prevent transparent colors
ctx.fillStyle=colorArrayToRGBA(backgroundColor);ctx.fillRect(0,0,outputWidth,outputHeight);if(isImageData(inputData)){// temporarily draw to canvas so we can draw image data to scaled context
const transferCanvas=h('canvas',{width,height});transferCanvas.getContext('2d').putImageData(inputData,0,0);// draw to scaled context
ctx.drawImage(transferCanvas,0,0,outputWidth,outputHeight);// release memory
releaseCanvas(transferCanvas);}else{// bitmap data
ctx.drawImage(inputData,0,0,outputWidth,outputHeight);}// get scaled image data for scrambling
const imageData=ctx.getImageData(0,0,outputWidth,outputHeight);// filters to apply
const filters=[];// add scramble filter
if(scrambleAmount>0)filters.push([scrambleEffect,{amount:scrambleAmount}]);// add blur filters
if(blurAmount>0)for(let i=0;i<blurAmount;i++){filters.push([convolutionEffect,{matrix:BLUR_MATRIX}]);}let imageDataScrambled;if(filters.length){// builds effect chain
const chain=(transforms,i)=>`(err, imageData) => {
                (${transforms[i][0].toString()})(Object.assign({ imageData: imageData }, filterInstructions[${i}]), 
                    ${transforms[i+1]?chain(transforms,i+1):'done'})
            }`;const filterChain=`function (options, done) {
            const filterInstructions = options.filterInstructions;
            const imageData = options.imageData;
            (${chain(filters,0)})(null, imageData)
        }`;// scramble image data in separate thread
const imageDataObjectScrambled=await thread(filterChain,[{imageData:imageData,filterInstructions:filters.map(t=>t[1])}],[imageData.data.buffer]);imageDataScrambled=imageDataObjectToImageData(imageDataObjectScrambled);}else{imageDataScrambled=imageData;}if(outputFormat==='canvas'){// put back scrambled data
ctx.putImageData(imageDataScrambled,0,0);// return canvas
return scaledOutputCanvas;}return imageDataScrambled;};var getComponentExportedProps=Component=>{const descriptors=Object.getOwnPropertyDescriptors(Component.prototype);return Object.keys(descriptors).filter(key=>!!descriptors[key]['get']);};function circOut(t){return Math.sqrt(1- --t*t);}function is_date(obj){return Object.prototype.toString.call(obj)==='[object Date]';}function get_interpolator(a,b){if(a===b||a!==a)return()=>a;const type=typeof a;if(type!==typeof b||Array.isArray(a)!==Array.isArray(b)){throw new Error('Cannot interpolate values of different type');}if(Array.isArray(a)){const arr=b.map((bi,i)=>{return get_interpolator(a[i],bi);});return t=>arr.map(fn=>fn(t));}if(type==='object'){if(!a||!b)throw new Error('Object cannot be null');if(is_date(a)&&is_date(b)){a=a.getTime();b=b.getTime();const delta=b-a;return t=>new Date(a+t*delta);}const keys=Object.keys(b);const interpolators={};keys.forEach(key=>{interpolators[key]=get_interpolator(a[key],b[key]);});return t=>{const result={};keys.forEach(key=>{result[key]=interpolators[key](t);});return result;};}if(type==='number'){const delta=b-a;return t=>a+t*delta;}throw new Error(`Cannot interpolate ${type} values`);}function tweened(value,defaults={}){const store=writable(value);let task;let target_value=value;function set(new_value,opts){if(value==null){store.set(value=new_value);return Promise.resolve();}target_value=new_value;let previous_task=task;let started=false;let{delay=0,duration=400,easing=identity,interpolate=get_interpolator}=pintura_assign(pintura_assign({},defaults),opts);if(duration===0){if(previous_task){previous_task.abort();previous_task=null;}store.set(value=target_value);return Promise.resolve();}const start=now()+delay;let fn;task=loop(now=>{if(now<start)return true;if(!started){fn=interpolate(value,new_value);if(typeof duration==='function')duration=duration(value,new_value);started=true;}if(previous_task){previous_task.abort();previous_task=null;}const elapsed=now-start;if(elapsed>duration){store.set(value=new_value);return false;}// @ts-ignore
store.set(value=fn(easing(elapsed/duration)));return true;});return task.promise;}return{set,update:(fn,opts)=>set(fn(target_value,value),opts),subscribe:store.subscribe};}// @ts-ignore
function tick_spring(ctx,last_value,current_value,target_value){if(typeof current_value==='number'){// @ts-ignore
const delta=target_value-current_value;// @ts-ignore
const velocity=(current_value-last_value)/(ctx.dt||1/60);// guard div by 0
const spring=ctx.opts.stiffness*delta;const damper=ctx.opts.damping*velocity;const acceleration=(spring-damper)*ctx.inv_mass;const d=(velocity+acceleration)*ctx.dt;if(Math.abs(d)<ctx.opts.precision&&Math.abs(delta)<ctx.opts.precision){return target_value;// settled
}else{ctx.settled=false;// signal loop to keep ticking
// @ts-ignore
return current_value+d;}}else if(pintura_isArray(current_value)){// @ts-ignore
return current_value.map((_,i)=>tick_spring(ctx,last_value[i],current_value[i],target_value[i]));}else if(typeof current_value==='object'){const next_value={};// @ts-ignore
for(const k in current_value){// @ts-ignore
next_value[k]=tick_spring(ctx,last_value[k],current_value[k],target_value[k]);}// @ts-ignore
return next_value;}else{throw new Error(`Cannot spring ${typeof current_value} values`);}}// export interface Spring {
//     set: (new_value: any, opts?: SpringUpdateOpts) => Promise<void>;
//     update: (fn: Function, opts?: SpringUpdateOpts) => Promise<void>;
//     subscribe: Function;
//     precision: number;
//     damping: number;
//     stiffness: number;
// }
function spring(value,opts={}){const store=writable(value);const{stiffness=0.15,damping=0.8,precision=0.01}=opts;let last_time;let task;let current_token;let last_value=value;let target_value=value;let inv_mass=1;let inv_mass_recovery_rate=0;let cancel_task=false;function set(new_value,opts={}){target_value=new_value;const token=current_token={};if(value==null||opts.hard||spring.stiffness>=1&&spring.damping>=1){cancel_task=true;// cancel any running animation
last_time=null;last_value=new_value;store.set(value=target_value);return Promise.resolve();}else if(opts.soft){const rate=opts.soft===true?0.5:+opts.soft;inv_mass_recovery_rate=1/(rate*60);inv_mass=0;// infinite mass, unaffected by spring forces
}if(!task){last_time=null;cancel_task=false;const ctx={inv_mass:undefined,opts:spring,settled:true,dt:undefined};task=loop(now=>{if(last_time===null)last_time=now;if(cancel_task){cancel_task=false;task=null;return false;}inv_mass=Math.min(inv_mass+inv_mass_recovery_rate,1);// altered so doesn't create a new object
ctx.inv_mass=inv_mass;ctx.opts=spring;ctx.settled=true;// tick_spring may signal false
ctx.dt=(now-last_time)*60/1000;const next_value=tick_spring(ctx,last_value,value,target_value);last_time=now;last_value=value;store.set(value=next_value);if(ctx.settled)task=null;return!ctx.settled;});}return new Promise(fulfil=>{task.promise.then(()=>{if(token===current_token)fulfil();});});}const spring={set,update:(fn,opts)=>set(fn(target_value,value),opts),subscribe:store.subscribe,stiffness,damping,precision};return spring;}var prefersReducedMotion=readable(false,set=>{const mql=window.matchMedia('(prefers-reduced-motion:reduce)');set(mql.matches);mql.onchange=()=>set(mql.matches);});var hasResizeObserver=()=>'ResizeObserver'in window;//
const rectNext=rectCreateEmpty();const updateNodeRect=(node,x,y,width,height)=>{if(!node.rect)node.rect=rectCreateEmpty();const rect=node.rect;rectUpdate(rectNext,x,y,width,height);if(rectEqual(rect,rectNext))return;rectUpdateWithRect(rect,rectNext);node.dispatchEvent(new CustomEvent('measure',{detail:rect}));};// measures the element
const r=Math.round;const measureViewRect=node=>{const clientRect=node.getBoundingClientRect();updateNodeRect(node,r(clientRect.x),r(clientRect.y),r(clientRect.width),r(clientRect.height));};const measureOffset=node=>updateNodeRect(node,node.offsetLeft,node.offsetTop,node.offsetWidth,node.offsetHeight);// holds all the elements to measure using requestAnimationFrame
const pintura_elements=[];// draw loop
let pintura_frame=null;function tick(){if(!pintura_elements.length){pintura_frame=null;return;}pintura_elements.forEach(node=>node.measure(node));pintura_frame=requestAnimationFrame(tick);}let observer;// ResizeObserver API not known by TypeScript
var measurable=(node,options={})=>{const{observePosition=false,observeViewRect=false,once=false,disabled=false}=options;// exit
if(disabled)return;// use resize observe if available
if(hasResizeObserver()&&!observePosition&&!observeViewRect){// we only create one observer, it will observe all registered elements
if(!observer){// @ts-ignore: [2020-02-20] ResizeObserver API not known by TypeScript
observer=new ResizeObserver(entries=>{// @ts-ignore
entries.forEach(entry=>measureOffset(entry.target));});}// start observing this node
observer.observe(node);// measure our node for the first time
measureOffset(node);// if should only measure once, remove now
if(once)observer.unobserve(node);// and we done, need to return a clean up method for when our node is destroyed
return{destroy(){// already unobserved this node
if(once)return;observer.unobserve(node);// TODO: test if all nodes have been removed, if so, remove observer
}};}// set measure function
node.measure=observeViewRect?measureViewRect:measureOffset;// add so the element is measured
pintura_elements.push(node);// start measuring on next frame, we set up a single measure loop,
// the loop will check if there's still elements that need to be measured,
// else it will stop running
if(!pintura_frame)pintura_frame=requestAnimationFrame(tick);// measure this element now
node.measure(node);// remove method
return{destroy(){const index=pintura_elements.indexOf(node);pintura_elements.splice(index,1);}};};var focusvisible=element=>{let isKeyboardInteraction=false;const handlePointerdown=()=>{isKeyboardInteraction=false;};const handleKeydown=()=>{isKeyboardInteraction=true;};const handleKeyup=()=>{isKeyboardInteraction=false;};const handleFocus=e=>{if(!isKeyboardInteraction)return;e.target.dataset.focusVisible='';};const handleBlur=e=>{delete e.target.dataset.focusVisible;};const map={pointerdown:handlePointerdown,keydown:handleKeydown,keyup:handleKeyup,focus:handleFocus,blur:handleBlur};Object.keys(map).forEach(event=>element.addEventListener(event,map[event],true));return{destroy(){Object.keys(map).forEach(event=>element.removeEventListener(event,map[event],true));}};};const getResourceFromItem=async item=>new Promise(resolve=>{if(item.kind==='file')return resolve(item.getAsFile());item.getAsString(resolve);});const getResourcesFromEvent=e=>new Promise((resolve,reject)=>{const{items}=e.dataTransfer;if(!items)return resolve([]);Promise.all(Array.from(items).map(getResourceFromItem)).then(res=>{resolve(res.filter(item=>isBinary(item)&&isImage(item)||/^http/.test(item)));}).catch(reject);});var dropable=(node,options={})=>{const handleDragOver=e=>{// need to be prevent default to allow drop
e.preventDefault();};const handleDrop=async e=>{e.preventDefault();e.stopPropagation();// prevents parents from catching this drop
try{const resources=await getResourcesFromEvent(e);node.dispatchEvent(new CustomEvent('dropfiles',{detail:{event:e,resources},...options}));}catch(err){// silent, wasn't able to catch
}};node.addEventListener('drop',handleDrop);node.addEventListener('dragover',handleDragOver);// remove method
return{destroy(){node.removeEventListener('drop',handleDrop);node.removeEventListener('dragover',handleDragOver);}};};let result$6=null;var supportsWebGL2=()=>{if(result$6===null){if('WebGL2RenderingContext'in window){let canvas;try{canvas=h('canvas');result$6=!!canvas.getContext('webgl2');}catch(err){result$6=false;}canvas&&releaseCanvas(canvas);}else{result$6=false;}}return result$6;};var getWebGLContext=(canvas,attrs)=>{if(supportsWebGL2())return canvas.getContext('webgl2',attrs);return canvas.getContext('webgl',attrs)||canvas.getContext('experimental-webgl',attrs);};let result$5=null;var isSoftwareRendering=()=>{if(result$5===null){if(isBrowser()){const canvas=h('canvas');result$5=!getWebGLContext(canvas,{failIfMajorPerformanceCaveat:true});releaseCanvas(canvas);}else{result$5=false;}}return result$5;};var isPowerOf2=value=>(value&value-1)===0;var stringReplace=(str,entries={},prefix='',postfix='')=>{return Object.keys(entries).filter(key=>!pintura_isObject(entries[key])).reduce((prev,curr)=>{return prev.replace(new RegExp(prefix+curr+postfix),entries[curr]);},str);};var SHADER_FRAG_HEAD="#version 300 es\nprecision highp float;\n\nout vec4 fragColor;";// eslint-disable-line
var SHADER_FRAG_INIT="\nfloat a=1.0;vec4 fillColor=uColor;vec4 textureColor=texture(uTexture,vTexCoord);textureColor*=(1.0-step(1.0,vTexCoord.y))*step(0.0,vTexCoord.y)*(1.0-step(1.0,vTexCoord.x))*step(0.0,vTexCoord.x);";// eslint-disable-line
var SHADER_FRAG_MASK="\nuniform float uMaskFeather[8];uniform float uMaskBounds[4];uniform float uMaskOpacity;float mask(float x,float y,float bounds[4],float opacity){return 1.0-(1.0-(smoothstep(bounds[3],bounds[3]+1.0,x)*(1.0-smoothstep(bounds[1]-1.0,bounds[1],x))*(1.0-step(bounds[0],y))*step(bounds[2],y)))*(1.0-opacity);}";// eslint-disable-line
var SHADER_FRAG_MASK_APPLY="\nfloat m=mask(gl_FragCoord.x,gl_FragCoord.y,uMaskBounds,uMaskOpacity);";// eslint-disable-line
var SHADER_FRAG_MASK_FEATHER_APPLY="\nfloat leftFeatherOpacity=step(uMaskFeather[1],gl_FragCoord.x)*uMaskFeather[0]+((1.0-uMaskFeather[0])*smoothstep(uMaskFeather[1],uMaskFeather[3],gl_FragCoord.x));float rightFeatherOpacity=(1.0-step(uMaskFeather[7],gl_FragCoord.x))*uMaskFeather[4]+((1.0-uMaskFeather[4])*smoothstep(uMaskFeather[7],uMaskFeather[5],gl_FragCoord.x));a*=leftFeatherOpacity*rightFeatherOpacity;";// eslint-disable-line
var SHADER_FRAG_RECT_AA="\nvec2 scaledPoint=vec2(vRectCoord.x*uSize.x,vRectCoord.y*uSize.y);a*=smoothstep(0.0,1.0,uSize.x-scaledPoint.x);a*=smoothstep(0.0,1.0,uSize.y-scaledPoint.y);a*=smoothstep(0.0,1.0,scaledPoint.x);a*=smoothstep(0.0,1.0,scaledPoint.y);";// eslint-disable-line
var SHADER_FRAG_CORNER_RADIUS="\nvec2 s=(uSize-2.0)*.5;vec2 r=(vRectCoord*uSize);vec2 p=r-(uSize*.5);float cornerRadius=uCornerRadius[0];bool left=r.x<s.x;bool top=r.y<s.x;if(!left&&top){cornerRadius=uCornerRadius[1];}if(!left&&!top){cornerRadius=uCornerRadius[3];}if(left&&!top){cornerRadius=uCornerRadius[2];}a*=1.0-clamp(length(max(abs(p)-(s-cornerRadius),0.0))-cornerRadius,0.0,1.0);";// eslint-disable-line
var SHADER_FRAG_SHAPE_BLEND_COLOR="\nif(m<=0.0)discard;fillColor.a*=a;fillColor.rgb*=fillColor.a;fillColor.rgb*=m;fillColor.rgb+=(1.0-m)*(uCanvasColor.rgb*fillColor.a);textureColor*=uTextureOpacity;textureColor.a*=a;textureColor.rgb*=m*a;textureColor.rgb+=(1.0-m)*(uCanvasColor.rgb*textureColor.a);fragColor=textureColor+(fillColor*(1.0-textureColor.a));";// eslint-disable-line
var SHADER_FRAG_TEXTURE_COLORIZE="\nif(uTextureColor.a!=0.0&&textureColor.a>0.0){vec3 colorFlattened=textureColor.rgb/textureColor.a;if(colorFlattened.r>.999999&&colorFlattened.g==0.0&&colorFlattened.b>.999999){textureColor.rgb=uTextureColor.rgb*textureColor.a;}textureColor*=uTextureColor.a;}";// eslint-disable-line
var SHADER_VERT_HEAD="#version 300 es\n\nin vec4 aPosition;uniform mat4 uMatrix;";// eslint-disable-line
var SHADER_VERT_MULTIPLY_MATRUX="\ngl_Position=uMatrix*vec4(aPosition.x,aPosition.y,0,1);";// eslint-disable-line
var SHADER_VERT_TEXTURE="\nin vec2 aTexCoord;out vec2 vTexCoord;";// eslint-disable-line
const SHADER_VERT_SNIPPETS={head:SHADER_VERT_HEAD,text:SHADER_VERT_TEXTURE,matrix:SHADER_VERT_MULTIPLY_MATRUX};const SHADER_FRAG_SNIPPETS={head:SHADER_FRAG_HEAD,mask:SHADER_FRAG_MASK,init:SHADER_FRAG_INIT,colorize:SHADER_FRAG_TEXTURE_COLORIZE,maskapply:SHADER_FRAG_MASK_APPLY,maskfeatherapply:SHADER_FRAG_MASK_FEATHER_APPLY,edgeaa:SHADER_FRAG_RECT_AA,cornerradius:SHADER_FRAG_CORNER_RADIUS,fragcolor:SHADER_FRAG_SHAPE_BLEND_COLOR};const transpileShader=(gl,src,type)=>{src=stringReplace(src,type===gl.VERTEX_SHADER?SHADER_VERT_SNIPPETS:SHADER_FRAG_SNIPPETS,'##').trim();// ready if supports webgl
if(supportsWebGL2())return src;src=src.replace(/#version.+/gm,'').trim();src=src.replace(/^\/\/\#/gm,'#');if(type===gl.VERTEX_SHADER){src=src.replace(/in /gm,'attribute ').replace(/out /g,'varying ');}if(type===gl.FRAGMENT_SHADER){src=src.replace(/in /gm,'varying ').replace(/out.*?;/gm,'').replace(/texture\(/g,'texture2D(').replace(/fragColor/g,'gl_FragColor');}return`${src}`;};const compileShader=(gl,src,type)=>{const shader=gl.createShader(type);const transpiledSrc=transpileShader(gl,src,type);gl.shaderSource(shader,transpiledSrc);gl.compileShader(shader);if(!gl.getShaderParameter(shader,gl.COMPILE_STATUS)){console.error(gl.getShaderInfoLog(shader));}return shader;};const createShader=(gl,vertexShader,fragmentShader,attribs,uniforms)=>{const program=gl.createProgram();gl.attachShader(program,compileShader(gl,vertexShader,gl.VERTEX_SHADER));gl.attachShader(program,compileShader(gl,fragmentShader,gl.FRAGMENT_SHADER));gl.linkProgram(program);const locations={};attribs.forEach(name=>{locations[name]=gl.getAttribLocation(program,name);});uniforms.forEach(name=>{locations[name]=gl.getUniformLocation(program,name);});return{program,locations};};const canMipMap=source=>{if(supportsWebGL2())return true;return isPowerOf2(source.width)&&isPowerOf2(source.height);};const applyTextureProperties=(gl,source,options)=>{gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,canMipMap(source)?gl.LINEAR_MIPMAP_LINEAR:gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,options.filter// === 'nearest' ? gl.NEAREST : gl.LINEAR
);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);if(canMipMap(source))gl.generateMipmap(gl.TEXTURE_2D);};const updateTexture=(gl,texture,source,options)=>{gl.bindTexture(gl.TEXTURE_2D,texture);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,source);applyTextureProperties(gl,source,options);gl.bindTexture(gl.TEXTURE_2D,null);return texture;};const applyOpacity=(color,opacity=1)=>color?[color[0],color[1],color[2],pintura_isNumber(color[3])?opacity*color[3]:opacity]:[0,0,0,0];const mat4Create=()=>{const mat=new Float32Array(16);mat[0]=1;mat[5]=1;mat[10]=1;mat[15]=1;return mat;};const mat4Perspective=(mat,fovy,aspect,near,far)=>{const f=1.0/Math.tan(fovy/2);const nf=1/(near-far);mat[0]=f/aspect;mat[1]=0;mat[2]=0;mat[3]=0;mat[4]=0;mat[5]=f;mat[6]=0;mat[7]=0;mat[8]=0;mat[9]=0;mat[10]=(far+near)*nf;mat[11]=-1;mat[12]=0;mat[13]=0;mat[14]=2*far*near*nf;mat[15]=0;};const mat4Ortho=(mat,left,right,bottom,top,near,far)=>{const lr=1/(left-right);const bt=1/(bottom-top);const nf=1/(near-far);mat[0]=-2*lr;mat[1]=0;mat[2]=0;mat[3]=0;mat[4]=0;mat[5]=-2*bt;mat[6]=0;mat[7]=0;mat[8]=0;mat[9]=0;mat[10]=2*nf;mat[11]=0;mat[12]=(left+right)*lr;mat[13]=(top+bottom)*bt;mat[14]=(far+near)*nf;mat[15]=1;};const mat4Translate=(mat,x,y,z)=>{mat[12]=mat[0]*x+mat[4]*y+mat[8]*z+mat[12];mat[13]=mat[1]*x+mat[5]*y+mat[9]*z+mat[13];mat[14]=mat[2]*x+mat[6]*y+mat[10]*z+mat[14];mat[15]=mat[3]*x+mat[7]*y+mat[11]*z+mat[15];};const mat4Scale=(mat,s)=>{mat[0]=mat[0]*s;mat[1]=mat[1]*s;mat[2]=mat[2]*s;mat[3]=mat[3]*s;mat[4]=mat[4]*s;mat[5]=mat[5]*s;mat[6]=mat[6]*s;mat[7]=mat[7]*s;mat[8]=mat[8]*s;mat[9]=mat[9]*s;mat[10]=mat[10]*s;mat[11]=mat[11]*s;};const mat4ScaleX=(mat,s)=>{mat[0]=mat[0]*s;mat[1]=mat[1]*s;mat[2]=mat[2]*s;mat[3]=mat[3]*s;};const mat4ScaleY=(mat,s)=>{mat[4]=mat[4]*s;mat[5]=mat[5]*s;mat[6]=mat[6]*s;mat[7]=mat[7]*s;};const mat4RotateX=(mat,rad)=>{const s=Math.sin(rad);const c=Math.cos(rad);const a10=mat[4];const a11=mat[5];const a12=mat[6];const a13=mat[7];const a20=mat[8];const a21=mat[9];const a22=mat[10];const a23=mat[11];mat[4]=a10*c+a20*s;mat[5]=a11*c+a21*s;mat[6]=a12*c+a22*s;mat[7]=a13*c+a23*s;mat[8]=a20*c-a10*s;mat[9]=a21*c-a11*s;mat[10]=a22*c-a12*s;mat[11]=a23*c-a13*s;};const mat4RotateY=(mat,rad)=>{const s=Math.sin(rad);const c=Math.cos(rad);const a00=mat[0];const a01=mat[1];const a02=mat[2];const a03=mat[3];const a20=mat[8];const a21=mat[9];const a22=mat[10];const a23=mat[11];mat[0]=a00*c-a20*s;mat[1]=a01*c-a21*s;mat[2]=a02*c-a22*s;mat[3]=a03*c-a23*s;mat[8]=a00*s+a20*c;mat[9]=a01*s+a21*c;mat[10]=a02*s+a22*c;mat[11]=a03*s+a23*c;};const mat4RotateZ=(mat,rad)=>{const s=Math.sin(rad);const c=Math.cos(rad);const a00=mat[0];const a01=mat[1];const a02=mat[2];const a03=mat[3];const a10=mat[4];const a11=mat[5];const a12=mat[6];const a13=mat[7];mat[0]=a00*c+a10*s;mat[1]=a01*c+a11*s;mat[2]=a02*c+a12*s;mat[3]=a03*c+a13*s;mat[4]=a10*c-a00*s;mat[5]=a11*c-a01*s;mat[6]=a12*c-a02*s;mat[7]=a13*c-a03*s;};var degToRad=degrees=>degrees*Math.PI/180;var imageFragmentShader="\n##head\nin vec2 vTexCoord;uniform sampler2D uTexture;uniform sampler2D uTextureMarkup;uniform sampler2D uTextureBlend;uniform vec2 uTextureSize;uniform float uOpacity;uniform vec4 uFillColor;uniform vec4 uOverlayColor;uniform mat4 uColorMatrix;uniform vec4 uColorOffset;uniform float uClarityKernel[9];uniform float uClarityKernelWeight;uniform float uColorGamma;uniform float uColorVignette;uniform float uMaskClip;uniform float uMaskOpacity;uniform float uMaskBounds[4];uniform float uMaskCornerRadius[4];uniform float uMaskFeather[8];vec4 applyGamma(vec4 c,float g){c.r=pow(c.r,g);c.g=pow(c.g,g);c.b=pow(c.b,g);return c;}vec4 applyColorMatrix(vec4 c,mat4 m,vec4 o){vec4 cM=(c*m)+o;cM*=cM.a;return cM;}vec4 applyConvolutionMatrix(vec4 c,float k0,float k1,float k2,float k3,float k4,float k5,float k6,float k7,float k8,float w){vec2 pixel=vec2(1)/uTextureSize;vec4 colorSum=texture(uTexture,vTexCoord-pixel)*k0+texture(uTexture,vTexCoord+pixel*vec2(0.0,-1.0))*k1+texture(uTexture,vTexCoord+pixel*vec2(1.0,-1.0))*k2+texture(uTexture,vTexCoord+pixel*vec2(-1.0,0.0))*k3+texture(uTexture,vTexCoord)*k4+texture(uTexture,vTexCoord+pixel*vec2(1.0,0.0))*k5+texture(uTexture,vTexCoord+pixel*vec2(-1.0,1.0))*k6+texture(uTexture,vTexCoord+pixel*vec2(0.0,1.0))*k7+texture(uTexture,vTexCoord+pixel)*k8;vec4 color=vec4((colorSum/w).rgb,c.a);color.rgb=clamp(color.rgb,0.0,1.0);return color;}vec4 applyVignette(vec4 c,vec2 pos,vec2 center,float v){float d=distance(pos,center)/length(center);float f=1.0-(d*abs(v));if(v>0.0){c.rgb*=f;}else if(v<0.0){c.rgb+=(1.0-f)*(1.0-c.rgb);}return c;}vec4 blendPremultipliedAlpha(vec4 back,vec4 front){return front+(back*(1.0-front.a));}void main(){float x=gl_FragCoord.x;float y=gl_FragCoord.y;float a=1.0;float maskTop=uMaskBounds[0];float maskRight=uMaskBounds[1];float maskBottom=uMaskBounds[2];float maskLeft=uMaskBounds[3];float leftFeatherOpacity=step(uMaskFeather[1],x)*uMaskFeather[0]+((1.0-uMaskFeather[0])*smoothstep(uMaskFeather[1],uMaskFeather[3],x));float rightFeatherOpacity=(1.0-step(uMaskFeather[7],x))*uMaskFeather[4]+((1.0-uMaskFeather[4])*smoothstep(uMaskFeather[7],uMaskFeather[5],x));a*=leftFeatherOpacity*rightFeatherOpacity;float overlayColorAlpha=(smoothstep(maskLeft,maskLeft+1.0,x)*(1.0-smoothstep(maskRight-1.0,maskRight,x))*(1.0-step(maskTop,y))*step(maskBottom,y));if(uOverlayColor.a==0.0){a*=overlayColorAlpha;}vec2 offset=vec2(maskLeft,maskBottom);vec2 size=vec2(maskRight-maskLeft,maskTop-maskBottom)*.5;vec2 center=offset.xy+size.xy;int pixelX=int(step(center.x,x));int pixelY=int(step(y,center.y));float cornerRadius=0.0;if(pixelX==0&&pixelY==0)cornerRadius=uMaskCornerRadius[0];if(pixelX==1&&pixelY==0)cornerRadius=uMaskCornerRadius[1];if(pixelX==0&&pixelY==1)cornerRadius=uMaskCornerRadius[2];if(pixelX==1&&pixelY==1)cornerRadius=uMaskCornerRadius[3];float cornerOffset=sign(cornerRadius)*length(max(abs(gl_FragCoord.xy-size-offset)-size+cornerRadius,0.0))-cornerRadius;float cornerOpacity=1.0-smoothstep(0.0,1.0,cornerOffset);a*=cornerOpacity;vec2 scaledPoint=vec2(vTexCoord.x*uTextureSize.x,vTexCoord.y*uTextureSize.y);a*=smoothstep(0.0,1.0,uTextureSize.x-scaledPoint.x);a*=smoothstep(0.0,1.0,uTextureSize.y-scaledPoint.y);a*=smoothstep(0.0,1.0,scaledPoint.x);a*=smoothstep(0.0,1.0,scaledPoint.y);vec4 color=texture(uTexture,vTexCoord);color=blendPremultipliedAlpha(color,texture(uTextureBlend,vTexCoord));if(uClarityKernelWeight!=-1.0){color=applyConvolutionMatrix(color,uClarityKernel[0],uClarityKernel[1],uClarityKernel[2],uClarityKernel[3],uClarityKernel[4],uClarityKernel[5],uClarityKernel[6],uClarityKernel[7],uClarityKernel[8],uClarityKernelWeight);}color=applyGamma(color,uColorGamma);color=applyColorMatrix(color,uColorMatrix,uColorOffset);color=blendPremultipliedAlpha(uFillColor,color);color*=a;if(uColorVignette!=0.0){vec2 pos=gl_FragCoord.xy-offset;color=applyVignette(color,pos,center-offset,uColorVignette);}color=blendPremultipliedAlpha(color,texture(uTextureMarkup,vTexCoord));vec4 overlayColor=uOverlayColor*(1.0-overlayColorAlpha);overlayColor.rgb*=overlayColor.a;color=blendPremultipliedAlpha(color,overlayColor);if(uOverlayColor.a>0.0&&color.a<1.0&&uFillColor.a>0.0){color=blendPremultipliedAlpha(uFillColor,overlayColor);}color*=uOpacity;fragColor=color;}";// eslint-disable-line
var imageVertexShader="\n##head\n##text\nvoid main(){vTexCoord=aTexCoord;gl_Position=uMatrix*aPosition;}";// eslint-disable-line
var pathVertexShader="#version 300 es\n\nin vec4 aPosition;in vec2 aNormal;in float aMiter;out vec2 vNormal;out float vMiter;out float vWidth;uniform float uWidth;uniform mat4 uMatrix;void main(){vMiter=aMiter;vNormal=aNormal;vWidth=(uWidth*.5)+1.0;gl_Position=uMatrix*vec4(aPosition.x+(aNormal.x*vWidth*aMiter),aPosition.y+(aNormal.y*vWidth*aMiter),0,1);}";// eslint-disable-line
var pathFragmentShader="\n##head\n##mask\nin vec2 vNormal;in float vMiter;in float vWidth;uniform float uWidth;uniform vec4 uColor;uniform vec4 uCanvasColor;void main(){vec4 fillColor=uColor;float m=mask(gl_FragCoord.x,gl_FragCoord.y,uMaskBounds,uMaskOpacity);if(m<=0.0)discard;fillColor.a*=clamp(smoothstep(vWidth-.5,vWidth-1.0,abs(vMiter)*vWidth),0.0,1.0);fillColor.rgb*=fillColor.a;fillColor.rgb*=m;fillColor.rgb+=(1.0-m)*(uCanvasColor.rgb*fillColor.a);fragColor=fillColor;}";// eslint-disable-line
var rectVertexShader="\n##head\n##text\nin vec2 aRectCoord;out vec2 vRectCoord;void main(){vTexCoord=aTexCoord;vRectCoord=aRectCoord;\n##matrix\n}";// eslint-disable-line
var rectFragmentShader="\n##head\n##mask\nin vec2 vTexCoord;in vec2 vRectCoord;uniform sampler2D uTexture;uniform vec4 uTextureColor;uniform float uTextureOpacity;uniform vec4 uColor;uniform float uCornerRadius[4];uniform vec2 uSize;uniform vec2 uPosition;uniform vec4 uCanvasColor;uniform int uInverted;void main(){\n##init\n##colorize\n##edgeaa\n##cornerradius\n##maskfeatherapply\nif(uInverted==1)a=1.0-a;\n##maskapply\n##fragcolor\n}";// eslint-disable-line
var ellipseVertexShader="\n##head\n##text\nout vec2 vTexCoordDouble;void main(){vTexCoordDouble=vec2(aTexCoord.x*2.0-1.0,aTexCoord.y*2.0-1.0);vTexCoord=aTexCoord;\n##matrix\n}";// eslint-disable-line
var ellipseFragmentShader="\n##head\n##mask\nin vec2 vTexCoord;in vec2 vTexCoordDouble;uniform sampler2D uTexture;uniform float uTextureOpacity;uniform vec2 uRadius;uniform vec4 uColor;uniform int uInverted;uniform vec4 uCanvasColor;void main(){\n##init\nfloat ar=uRadius.x/uRadius.y;vec2 rAA=vec2(uRadius.x-1.0,uRadius.y-(1.0/ar));vec2 scaledPointSq=vec2((vTexCoordDouble.x*uRadius.x)*(vTexCoordDouble.x*uRadius.x),(vTexCoordDouble.y*uRadius.y)*(vTexCoordDouble.y*uRadius.y));float p=(scaledPointSq.x/(uRadius.x*uRadius.x))+(scaledPointSq.y/(uRadius.y*uRadius.y));float pAA=(scaledPointSq.x/(rAA.x*rAA.x))+(scaledPointSq.y/(rAA.y*rAA.y));a=smoothstep(1.0,p/pAA,p);if(uInverted==1)a=1.0-a;\n##maskapply\n##fragcolor\n}";// eslint-disable-line
var triangleVertexShader="\n##head\nvoid main(){\n##matrix\n}";// eslint-disable-line
var triangleFragmentShader="\n##head\n##mask\nuniform vec4 uColor;uniform vec4 uCanvasColor;void main(){vec4 fillColor=uColor;\n##maskapply\nfillColor.rgb*=fillColor.a;fillColor.rgb*=m;fillColor.rgb+=(1.0-m)*(uCanvasColor.rgb*fillColor.a);fragColor=fillColor;}";// eslint-disable-line
const createPathSegment=(vertices,index,a,b,c)=>{const ab=vectorNormalize(vectorCreate(b.x-a.x,b.y-a.y));const bc=vectorNormalize(vectorCreate(c.x-b.x,c.y-b.y));const tangent=vectorNormalize(vectorCreate(ab.x+bc.x,ab.y+bc.y));const miter=vectorCreate(-tangent.y,tangent.x);const normal=vectorCreate(-ab.y,ab.x);// limit miter length (TEMP fix to prevent spikes, should eventually add caps)
const miterLength=Math.min(1/vectorDot(miter,normal),5);vertices[index]=b.x;vertices[index+1]=b.y;vertices[index+2]=miter.x*miterLength;vertices[index+3]=miter.y*miterLength;vertices[index+4]=-1;vertices[index+5]=b.x;vertices[index+6]=b.y;vertices[index+7]=miter.x*miterLength;vertices[index+8]=miter.y*miterLength;vertices[index+9]=1;};const createPathVertices=(points,close)=>{let a,b,c,i=0;const l=points.length;const stride=10;const vertices=new Float32Array((close?l+1:l)*stride);const first=points[0];const last=points[l-1];for(i=0;i<l;i++){a=points[i-1];b=points[i];c=points[i+1];// if previous point not available use inverse vector to next point
if(!a)a=close?last:vectorCreate(b.x+(b.x-c.x),b.y+(b.y-c.y));// if next point not available use inverse vector from previous point
if(!c)c=close?first:vectorCreate(b.x+(b.x-a.x),b.y+(b.y-a.y));createPathSegment(vertices,i*stride,a,b,c);}if(close)createPathSegment(vertices,l*stride,last,first,points[1]);return vertices;};const rectPointsToVertices=points=>{// [tl, tr, br, bl]
// B   D
// | \ |
// A  C
const vertices=new Float32Array(8);vertices[0]=points[3].x;vertices[1]=points[3].y;vertices[2]=points[0].x;vertices[3]=points[0].y;vertices[4]=points[2].x;vertices[5]=points[2].y;vertices[6]=points[1].x;vertices[7]=points[1].y;return vertices;};const trianglePointToVertices=points=>{const vertices=new Float32Array(6);vertices[0]=points[0].x;vertices[1]=points[0].y;vertices[2]=points[1].x;vertices[3]=points[1].y;vertices[4]=points[2].x;vertices[5]=points[2].y;return vertices;};const createRectPoints=(rect,rotation=0,flipX,flipY)=>{const corners=rectGetCorners(rect);const cx=rect.x+rect.width*0.5;const cy=rect.y+rect.height*0.5;if(flipX||flipY)vectorsFlip(corners,flipX,flipY,cx,cy);if(rotation!==0)vectorsRotate(corners,rotation,cx,cy);return corners;};const createEllipseOutline=(x,y,width,height,rotation,flipX,flipY)=>{const rx=Math.abs(width)*0.5;const ry=Math.abs(height)*0.5;const size=Math.abs(width)+Math.abs(height);const precision=Math.max(20,Math.round(size/6));return ellipseToPolygon(vectorCreate(x+rx,y+ry),rx,ry,rotation,flipX,flipY,precision);};const createRectOutline=(x,y,width,height,rotation,cornerRadius,flipX,flipY)=>{const points=[];if(cornerRadius.every(v=>v===0)){points.push(vectorCreate(x,y),// top left corner
vectorCreate(x+width,y),// top right corner
vectorCreate(x+width,y+height),// bottom right corner
vectorCreate(x,y+height)// bottom left corner
);}else{const[tl,tr,bl,br]=cornerRadius;const l=x;const r=x+width;const t=y;const b=y+height;// start at end of top left corner
points.push(vectorCreate(l+tl,t));pushRectCornerPoints(points,r-tr,t+tr,tr,-1);// move to bottom right corner
points.push(vectorCreate(r,t+tr));pushRectCornerPoints(points,r-br,b-br,br,0);// move to bottom left corner
points.push(vectorCreate(r-br,b));pushRectCornerPoints(points,l+bl,b-bl,bl,1);// move to top left corner
points.push(vectorCreate(l,b-bl));pushRectCornerPoints(points,l+tl,t+tl,tl,2);}if(flipX||flipY)vectorsFlip(points,flipX,flipY,x+width*0.5,y+height*0.5);if(rotation)vectorsRotate(points,rotation,x+width*0.5,y+height*0.5);return points;};const pushRectCornerPoints=(points,x,y,radius,offset)=>{const precision=Math.min(20,Math.max(4,Math.round(radius/2)));let p=0;let s=0;let rx=0;let ry=0;let i=0;for(;i<precision;i++){p=i/precision;s=offset*HALF_PI+p*HALF_PI;rx=radius*Math.cos(s);ry=radius*Math.sin(s);points.push(vectorCreate(x+rx,y+ry));}};let limit=null;var getWebGLTextureSizeLimit=()=>{if(limit!==null)return limit;const canvas=h('canvas');const gl=getWebGLContext(canvas);limit=gl?gl.getParameter(gl.MAX_TEXTURE_SIZE):undefined;releaseCanvas(canvas);return limit;};// prettier-ignore
// B   D
// | \ |
// A  C
const RECT_UV=new Float32Array([0.0,1.0,0.0,0.0,1.0,1.0,1.0,0.0]);const CLARITY_IDENTITY=[0,0,0,0,1,0,0,0,0];const COLOR_MATRIX_IDENTITY$1=[1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0];const TEXTURE_TRANSPARENT_INDEX=0;const TEXTURE_PREVIEW_BLEND_INDEX=1;const TEXTURE_PREVIEW_MARKUP_INDEX=2;const TEXTURE_PREVIEW_INDEX=3;const TEXTURE_SHAPE_INDEX=4;const COLOR_TRANSPARENT=[0,0,0,0];const NO_CORNERS=[0,0,0,0];const calculateBackgroundUVMap=(width,height,backgroundSize,backgroundPosition,viewPixelDensity)=>{if(!backgroundSize||!backgroundPosition)return RECT_UV;const x=backgroundPosition.x/backgroundSize.width;const y=backgroundPosition.y/backgroundSize.height;let w=width/backgroundSize.width/viewPixelDensity;let h=height/backgroundSize.height/viewPixelDensity;w-=x;h-=y;// prettier-ignore
// B   D
// | \ |
// A  C
// bottom left
const ax=-x;const ay=h;// top left
const bx=-x;const by=-y;// bottom right
const cx=w;const cy=h;// top right
const dx=w;const dy=-y;return new Float32Array([ax,ay,bx,by,cx,cy,dx,dy]);};const limitCornerRadius=(r,size)=>{return Math.floor(pintura_clamp(r,0,Math.min((size.width-1)*0.5,(size.height-1)*0.5)));};var createWebGLCanvas=canvas=>{const viewSize={width:0,height:0};const viewSizeVisual={width:0,height:0};const textureSizeLimit=getWebGLTextureSizeLimit()||1024;let viewAspectRatio;let viewPixelDensity;const markupMatrixCanvas=mat4Create();const markupMatrixFrameBuffer=mat4Create();let markupMatrix;let maskTop;let maskRight;let maskBottom;let maskLeft;let maskOpacity;let maskBounds;let IMAGE_MASK_FEATHER;// updated when viewport is resized
let RECT_MASK_FEATHER;let CANVAS_COLOR_R=0;let CANVAS_COLOR_G=0;let CANVAS_COLOR_B=0;const indexTextureMap=new Map([]);// resize view
const resize=(width,height,pixelDensity)=>{// density
viewPixelDensity=pixelDensity;// visual size
viewSizeVisual.width=width;viewSizeVisual.height=height;// size
viewSize.width=width*viewPixelDensity;viewSize.height=height*viewPixelDensity;// calculate the aspect ratio, we use this to determine quad size
viewAspectRatio=getAspectRatio(viewSize.width,viewSize.height);// sync dimensions with image data
canvas.width=viewSize.width;canvas.height=viewSize.height;// update canvas markup matrix
mat4Ortho(markupMatrixCanvas,0,viewSize.width,viewSize.height,0,-1,1);IMAGE_MASK_FEATHER=[1,0,1,0,1,viewSizeVisual.width,1,viewSizeVisual.width];};// fov is fixed
const FOV=degToRad(30);const FOV_TAN_HALF=Math.tan(FOV/2);// get gl drawing context
const gl=getWebGLContext(canvas,{antialias:false,alpha:false,premultipliedAlpha:true});// no drawing context received, exit
if(!gl)return;// enable derivatives
gl.getExtension('OES_standard_derivatives');// toggle gl settings
gl.disable(gl.DEPTH_TEST);// set blend mode, we need it for alpha blending
gl.enable(gl.BLEND);/*
    https://webglfundamentals.org/webgl/lessons/webgl-and-alpha.html
    most if not all Canvas 2D implementations work with pre-multiplied alpha.
    That means when you transfer them to WebGL and UNPACK_PREMULTIPLY_ALPHA_WEBGL
    is false WebGL will convert them back to un-premultipiled.
    With pre-multiplied alpha on, [1, .5, .5, 0] does not exist, it's always [0, 0, 0, 0]
    */gl.blendFunc(gl.ONE,gl.ONE_MINUS_SRC_ALPHA);gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL,true);// something to look into:
// gl.UNPACK_COLORSPACE_CONVERSION_WEBGL
const transparentTexture=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,transparentTexture);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,1,// width
1,// height
0,gl.RGBA,gl.UNSIGNED_BYTE,new Uint8Array(COLOR_TRANSPARENT)// transparent background
);indexTextureMap.set(TEXTURE_TRANSPARENT_INDEX,transparentTexture);// create image markup texture and framebuffer
const imageMarkupTexture=gl.createTexture();indexTextureMap.set(TEXTURE_PREVIEW_MARKUP_INDEX,imageMarkupTexture);const markupFramebuffer=gl.createFramebuffer();// create image blend texture and framebuffer
const imageBlendTexture=gl.createTexture();indexTextureMap.set(TEXTURE_PREVIEW_BLEND_INDEX,imageBlendTexture);const blendFramebuffer=gl.createFramebuffer();// #region image
// create default pixel drawing program, supports what we need
const imageShader=createShader(gl,imageVertexShader,imageFragmentShader,['aPosition','aTexCoord'],['uMatrix','uTexture','uTextureBlend','uTextureMarkup','uTextureSize','uColorGamma','uColorVignette','uColorOffset','uColorMatrix','uClarityKernel','uClarityKernelWeight','uOpacity','uMaskOpacity','uMaskBounds','uMaskCornerRadius','uMaskFeather','uFillColor','uOverlayColor']);// create image buffers
const imagePositionsBuffer=gl.createBuffer();const texturePositionsBuffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,texturePositionsBuffer);gl.bufferData(gl.ARRAY_BUFFER,RECT_UV,gl.STATIC_DRAW);const drawImage=(texture,textureSize,originX,originY,translateX,translateY,rotateX,rotateY,rotateZ,scale,colorMatrix=COLOR_MATRIX_IDENTITY$1,opacity=1,clarity,gamma=1,vignette=0,maskFeather=IMAGE_MASK_FEATHER,maskCornerRadius=NO_CORNERS,imageBackgroundColor=COLOR_TRANSPARENT,imageOverlayColor=COLOR_TRANSPARENT,enableMarkup=false,enableBlend=false)=>{// update image texture
const imageWidth=textureSize.width*viewPixelDensity;const imageHeight=textureSize.height*viewPixelDensity;const l=imageWidth*-0.5;const t=imageHeight*0.5;const r=imageWidth*0.5;const b=imageHeight*-0.5;// prettier-ignore
// B   D
// | \ |
// A  C
const imagePositions=new Float32Array([l,b,0,l,t,0,r,b,0,r,t,0]);gl.bindBuffer(gl.ARRAY_BUFFER,imagePositionsBuffer);gl.bufferData(gl.ARRAY_BUFFER,imagePositions,gl.STATIC_DRAW);// move image backwards so it's presented in actual pixel size
const viewZ=// 1. we calculate the z offset required to have the
//    image height match the view height
/*        /|
                 / |
                /  | height / 2
               /   |
        f / 2 /__z_|
              \    |
               \   |
                \  |
                 \ |
                  \|
        */textureSize.height/2/FOV_TAN_HALF*(// 2. we want to render the image at the actual height, viewsize / height gets us results in a 1:1 presentation
viewSize.height/textureSize.height)*// 3. z has to be negative, therefor multiply by -1
-1;// convert to pixel density
translateX*=viewPixelDensity;translateY*=viewPixelDensity;originX*=viewPixelDensity;originY*=viewPixelDensity;// get shader params
const{program,locations}=imageShader;// apply
const matrix=mat4Create();mat4Perspective(matrix,FOV,viewAspectRatio,1,-viewZ*2);// move image
mat4Translate(matrix,translateX,-translateY,viewZ);// set rotation origin in view
mat4Translate(matrix,originX,-originY,0);// rotate image
mat4RotateZ(matrix,-rotateZ);// resize
mat4Scale(matrix,scale);// reset rotation origin
mat4Translate(matrix,-originX,originY,0);// flip
mat4RotateY(matrix,rotateY);mat4RotateX(matrix,rotateX);//
// tell context to draw preview
//
gl.useProgram(program);gl.enableVertexAttribArray(locations.aPosition);gl.enableVertexAttribArray(locations.aTexCoord);// set up texture
gl.uniform1i(locations.uTexture,TEXTURE_PREVIEW_INDEX);gl.uniform2f(locations.uTextureSize,textureSize.width,textureSize.height);gl.activeTexture(gl.TEXTURE0+TEXTURE_PREVIEW_INDEX);gl.bindTexture(gl.TEXTURE_2D,texture);// set up blend texture
const blendTextureIndex=enableBlend?TEXTURE_PREVIEW_BLEND_INDEX:TEXTURE_TRANSPARENT_INDEX;const blendTexture=indexTextureMap.get(blendTextureIndex);gl.uniform1i(locations.uTextureBlend,blendTextureIndex);gl.activeTexture(gl.TEXTURE0+blendTextureIndex);gl.bindTexture(gl.TEXTURE_2D,blendTexture);// set up markup texture
const markupTextureIndex=enableMarkup?TEXTURE_PREVIEW_MARKUP_INDEX:TEXTURE_TRANSPARENT_INDEX;const markupTexture=indexTextureMap.get(markupTextureIndex);gl.uniform1i(locations.uTextureMarkup,markupTextureIndex);gl.activeTexture(gl.TEXTURE0+markupTextureIndex);gl.bindTexture(gl.TEXTURE_2D,markupTexture);// set up buffers
gl.bindBuffer(gl.ARRAY_BUFFER,imagePositionsBuffer);gl.vertexAttribPointer(locations.aPosition,3,gl.FLOAT,false,0,0);gl.bindBuffer(gl.ARRAY_BUFFER,texturePositionsBuffer);gl.vertexAttribPointer(locations.aTexCoord,2,gl.FLOAT,false,0,0);// update matrix
gl.uniformMatrix4fv(locations.uMatrix,false,matrix);// overlay color
gl.uniform4fv(locations.uOverlayColor,imageOverlayColor);gl.uniform4fv(locations.uFillColor,imageBackgroundColor);// convolution
let clarityWeight;if(!clarity||arrayEqual(clarity,CLARITY_IDENTITY)){clarity=CLARITY_IDENTITY;clarityWeight=-1;}else{clarityWeight=clarity.reduce((prev,curr)=>prev+curr,0);clarityWeight=clarityWeight<=0?1:clarityWeight;}gl.uniform1fv(locations.uClarityKernel,clarity);gl.uniform1f(locations.uClarityKernelWeight,clarityWeight);gl.uniform1f(locations.uColorGamma,1.0/gamma);gl.uniform1f(locations.uColorVignette,vignette);// set color matrix values
gl.uniform4f(locations.uColorOffset,colorMatrix[4],colorMatrix[9],colorMatrix[14],colorMatrix[19]);gl.uniformMatrix4fv(locations.uColorMatrix,false,[colorMatrix[0],colorMatrix[1],colorMatrix[2],colorMatrix[3],colorMatrix[5],colorMatrix[6],colorMatrix[7],colorMatrix[8],colorMatrix[10],colorMatrix[11],colorMatrix[12],colorMatrix[13],colorMatrix[15],colorMatrix[16],colorMatrix[17],colorMatrix[18]]);// opacity level
gl.uniform1f(locations.uOpacity,opacity);// mask
gl.uniform1f(locations.uMaskOpacity,maskOpacity);gl.uniform1fv(locations.uMaskBounds,maskBounds);gl.uniform1fv(locations.uMaskCornerRadius,maskCornerRadius.map(v=>v*viewPixelDensity));gl.uniform1fv(locations.uMaskFeather,maskFeather.map((v,i)=>i%2===0?v:v*viewPixelDensity));gl.drawArrays(gl.TRIANGLE_STRIP,0,4);gl.disableVertexAttribArray(locations.aPosition);gl.disableVertexAttribArray(locations.aTexCoord);};//#endregion
// #region path
const pathShader=createShader(gl,pathVertexShader,pathFragmentShader,['aPosition','aNormal','aMiter'],['uColor','uCanvasColor','uMatrix','uWidth','uMaskBounds','uMaskOpacity']);const pathBuffer=gl.createBuffer();const strokePath=(points,width,color,close=false)=>{const{program,locations}=pathShader;gl.useProgram(program);gl.enableVertexAttribArray(locations.aPosition);gl.enableVertexAttribArray(locations.aNormal);gl.enableVertexAttribArray(locations.aMiter);const vertices=createPathVertices(points,close);const stride=Float32Array.BYTES_PER_ELEMENT*5;const normalOffset=Float32Array.BYTES_PER_ELEMENT*2;// at position 2
const miterOffset=Float32Array.BYTES_PER_ELEMENT*4;// at position 4
gl.uniform1f(locations.uWidth,width);// add 1 so we can feather the edges
gl.uniform4fv(locations.uColor,color);gl.uniformMatrix4fv(locations.uMatrix,false,markupMatrix);gl.uniform4f(locations.uCanvasColor,CANVAS_COLOR_R,CANVAS_COLOR_G,CANVAS_COLOR_B,1);gl.uniform1fv(locations.uMaskBounds,maskBounds);gl.uniform1f(locations.uMaskOpacity,maskOpacity);gl.bindBuffer(gl.ARRAY_BUFFER,pathBuffer);gl.bufferData(gl.ARRAY_BUFFER,vertices,gl.STATIC_DRAW);gl.vertexAttribPointer(locations.aPosition,2,gl.FLOAT,false,stride,0);gl.vertexAttribPointer(locations.aNormal,2,gl.FLOAT,false,stride,normalOffset);gl.vertexAttribPointer(locations.aMiter,1,gl.FLOAT,false,stride,miterOffset);gl.drawArrays(gl.TRIANGLE_STRIP,0,vertices.length/5);gl.disableVertexAttribArray(locations.aPosition);gl.disableVertexAttribArray(locations.aNormal);gl.disableVertexAttribArray(locations.aMiter);};//#endregion
// #region triangle
const triangleShader=createShader(gl,triangleVertexShader,triangleFragmentShader,['aPosition'],['uColor','uCanvasColor','uMatrix','uMaskBounds','uMaskOpacity']);const triangleBuffer=gl.createBuffer();const fillTriangle=(vertices,backgroundColor)=>{const{program,locations}=triangleShader;gl.useProgram(program);gl.enableVertexAttribArray(locations.aPosition);gl.uniform4fv(locations.uColor,backgroundColor);gl.uniformMatrix4fv(locations.uMatrix,false,markupMatrix);gl.uniform1fv(locations.uMaskBounds,maskBounds);gl.uniform1f(locations.uMaskOpacity,maskOpacity);gl.uniform4f(locations.uCanvasColor,CANVAS_COLOR_R,CANVAS_COLOR_G,CANVAS_COLOR_B,1);gl.bindBuffer(gl.ARRAY_BUFFER,triangleBuffer);gl.bufferData(gl.ARRAY_BUFFER,vertices,gl.STATIC_DRAW);gl.vertexAttribPointer(locations.aPosition,2,gl.FLOAT,false,0,0);gl.drawArrays(gl.TRIANGLE_STRIP,0,vertices.length/2);gl.disableVertexAttribArray(locations.aPosition);return vertices;};//#endregion
// #region rect
const rectShaderAttributes=['aPosition','aTexCoord','aRectCoord'];const rectShaderUniforms=['uTexture','uColor','uMatrix','uCanvasColor','uTextureColor','uTextureOpacity','uPosition','uSize','uMaskBounds','uMaskOpacity','uMaskFeather','uCornerRadius','uInverted'];const rectShader=createShader(gl,rectVertexShader,rectFragmentShader,rectShaderAttributes,rectShaderUniforms);const rectBuffer=gl.createBuffer();const rectTextureBuffer=gl.createBuffer();const rectCornerBuffer=gl.createBuffer();const fillRect=(vertices,width,height,cornerRadius,backgroundColor,backgroundImage=transparentTexture,opacity=1.0,colorFilter=COLOR_TRANSPARENT,uv=RECT_UV,maskFeather=RECT_MASK_FEATHER,inverted)=>{const{program,locations}=rectShader;gl.useProgram(program);gl.enableVertexAttribArray(locations.aPosition);gl.enableVertexAttribArray(locations.aTexCoord);gl.enableVertexAttribArray(locations.aRectCoord);gl.uniform4fv(locations.uColor,backgroundColor);gl.uniform2fv(locations.uSize,[width,height]);gl.uniform2fv(locations.uPosition,[vertices[2],vertices[3]]);gl.uniform1i(locations.uInverted,inverted?1:0);gl.uniform1fv(locations.uCornerRadius,cornerRadius);gl.uniform4f(locations.uCanvasColor,CANVAS_COLOR_R,CANVAS_COLOR_G,CANVAS_COLOR_B,1);// mask
gl.uniform1fv(locations.uMaskFeather,maskFeather.map((v,i)=>i%2===0?v:v*viewPixelDensity));gl.uniform1fv(locations.uMaskBounds,maskBounds);gl.uniform1f(locations.uMaskOpacity,maskOpacity);gl.uniformMatrix4fv(locations.uMatrix,false,markupMatrix);gl.uniform1i(locations.uTexture,TEXTURE_SHAPE_INDEX);gl.uniform4fv(locations.uTextureColor,colorFilter);gl.uniform1f(locations.uTextureOpacity,opacity);gl.activeTexture(gl.TEXTURE0+TEXTURE_SHAPE_INDEX);gl.bindTexture(gl.TEXTURE_2D,backgroundImage);gl.bindBuffer(gl.ARRAY_BUFFER,rectTextureBuffer);gl.bufferData(gl.ARRAY_BUFFER,uv,gl.STATIC_DRAW);gl.vertexAttribPointer(locations.aTexCoord,2,gl.FLOAT,false,0,0);// we use these coordinates combined with the size of the rect to interpolate and alias edges
gl.bindBuffer(gl.ARRAY_BUFFER,rectCornerBuffer);gl.bufferData(gl.ARRAY_BUFFER,RECT_UV,gl.STATIC_DRAW);gl.vertexAttribPointer(locations.aRectCoord,2,gl.FLOAT,false,0,0);gl.bindBuffer(gl.ARRAY_BUFFER,rectBuffer);gl.bufferData(gl.ARRAY_BUFFER,vertices,gl.STATIC_DRAW);gl.vertexAttribPointer(locations.aPosition,2,gl.FLOAT,false,0,0);gl.drawArrays(gl.TRIANGLE_STRIP,0,vertices.length/2);gl.disableVertexAttribArray(locations.aPosition);gl.disableVertexAttribArray(locations.aTexCoord);gl.disableVertexAttribArray(locations.aRectCoord);return vertices;};//#endregion
// #region ellipse
const ellipseShader=createShader(gl,ellipseVertexShader,ellipseFragmentShader,['aPosition','aTexCoord'],['uTexture','uTextureOpacity','uColor','uCanvasColor','uMatrix','uRadius','uInverted','uMaskBounds','uMaskOpacity']);const ellipseBuffer=gl.createBuffer();const ellipseTextureBuffer=gl.createBuffer();const fillEllipse=(vertices,width,height,backgroundColor,backgroundImage=transparentTexture,uv=RECT_UV,opacity=1.0,inverted=false)=>{const{program,locations}=ellipseShader;gl.useProgram(program);gl.enableVertexAttribArray(locations.aPosition);gl.enableVertexAttribArray(locations.aTexCoord);gl.uniformMatrix4fv(locations.uMatrix,false,markupMatrix);gl.uniform2fv(locations.uRadius,[width*0.5,height*0.5]);gl.uniform1i(locations.uInverted,inverted?1:0);gl.uniform4fv(locations.uColor,backgroundColor);gl.uniform4f(locations.uCanvasColor,CANVAS_COLOR_R,CANVAS_COLOR_G,CANVAS_COLOR_B,1);gl.uniform1fv(locations.uMaskBounds,maskBounds);gl.uniform1f(locations.uMaskOpacity,maskOpacity);gl.uniform1i(locations.uTexture,TEXTURE_SHAPE_INDEX);gl.uniform1f(locations.uTextureOpacity,opacity);gl.activeTexture(gl.TEXTURE0+TEXTURE_SHAPE_INDEX);gl.bindTexture(gl.TEXTURE_2D,backgroundImage);gl.bindBuffer(gl.ARRAY_BUFFER,ellipseTextureBuffer);gl.bufferData(gl.ARRAY_BUFFER,uv,gl.STATIC_DRAW);gl.vertexAttribPointer(locations.aTexCoord,2,gl.FLOAT,false,0,0);gl.bindBuffer(gl.ARRAY_BUFFER,ellipseBuffer);gl.bufferData(gl.ARRAY_BUFFER,vertices,gl.STATIC_DRAW);gl.vertexAttribPointer(locations.aPosition,2,gl.FLOAT,false,0,0);gl.drawArrays(gl.TRIANGLE_STRIP,0,vertices.length/2);gl.disableVertexAttribArray(locations.aPosition);gl.disableVertexAttribArray(locations.aTexCoord);};//#endregion
//
// draw calls
//
const drawPath=(points,strokeWidth,strokeColor,strokeClose,opacity)=>{// is no line
if(points.length<2)return;strokePath(points.map(p=>({x:p.x*viewPixelDensity,y:p.y*viewPixelDensity})),strokeWidth*viewPixelDensity,applyOpacity(strokeColor,opacity),strokeClose);};const drawTriangle=(points,rotation=0,flipX=false,flipY=false,backgroundColor,opacity)=>{if(!backgroundColor)return;const clonedPoints=points.map(p=>({x:p.x*viewPixelDensity,y:p.y*viewPixelDensity}));const center=convexPolyCentroid(clonedPoints);if(flipX||flipY)vectorsFlip(clonedPoints,flipX,flipY,center.x,center.y);vectorsRotate(clonedPoints,rotation,center.x,center.y);const vertices=trianglePointToVertices(clonedPoints);fillTriangle(vertices,applyOpacity(backgroundColor,opacity));};const drawRect=(rect,rotation=0,flipX=false,flipY=false,cornerRadius,backgroundColor,backgroundImage,backgroundSize=undefined,backgroundPosition=undefined,backgroundUVMap=undefined,strokeWidth,strokeColor,opacity,maskFeather=undefined,colorize,inverted)=>{// clone first
const rectOut=rectMultiply(rectClone(rect),viewPixelDensity);// has radius, doesn't matter for coordinates
const cornerRadiusOut=cornerRadius.map(r=>limitCornerRadius(r||0,rect)).map(r=>r*viewPixelDensity);// should fill
if(backgroundColor||backgroundImage){// adjust for edge anti-aliasing, if we don't do this the
// visible rectangle will be 1 pixel smaller than the actual rectangle
const rectFill=rectClone(rectOut);rectFill.x-=0.5;rectFill.y-=0.5;rectFill.width+=1;rectFill.height+=1;const points=createRectPoints(rectFill,rotation,flipX,flipY);const vertices=rectPointsToVertices(points);let color;if(colorize){color=applyOpacity(colorize);// as 0 transparancy is used to test if the colorize filter should be applied we set it to 0.001
if(color[3]===0)color[3]=0.001;}fillRect(vertices,rectFill.width,rectFill.height,cornerRadiusOut,applyOpacity(backgroundColor,opacity),backgroundImage,opacity,color,backgroundUVMap?new Float32Array(backgroundUVMap):calculateBackgroundUVMap(rectFill.width,rectFill.height,backgroundSize,backgroundPosition,viewPixelDensity),maskFeather,inverted);}// should draw outline
if(strokeWidth){// fixes issue where stroke would render weirdly
strokeWidth=Math.min(strokeWidth,rectOut.width,rectOut.height);strokePath(// rect out is already multiplied by pixel density
createRectOutline(rectOut.x,rectOut.y,rectOut.width,rectOut.height,rotation,cornerRadiusOut,flipX,flipY),strokeWidth*viewPixelDensity,applyOpacity(strokeColor,opacity),true);}};const drawEllipse=(center,rx,ry,rotation,flipX,flipY,backgroundColor,backgroundImage,backgroundSize=undefined,backgroundPosition=undefined,backgroundUVMap=undefined,strokeWidth,strokeColor,opacity,inverted)=>{const rectOut=rectMultiply(rectCreate(center.x-rx,center.y-ry,rx*2,ry*2),viewPixelDensity);if(backgroundColor||backgroundImage){// adjust for edge anti-aliasing, if we don't do this the
// visible rectangle will be 1 pixel smaller than the actual rectangle
const rectFill=rectClone(rectOut);rectFill.x-=0.5;rectFill.y-=0.5;rectFill.width+=1.0;rectFill.height+=1.0;const points=createRectPoints(rectFill,rotation,flipX,flipY);const vertices=rectPointsToVertices(points);fillEllipse(vertices,rectFill.width,rectFill.height,applyOpacity(backgroundColor,opacity),backgroundImage,backgroundUVMap?new Float32Array(backgroundUVMap):calculateBackgroundUVMap(rectFill.width,rectFill.height,backgroundSize,backgroundPosition,viewPixelDensity),opacity,inverted);}if(strokeWidth)strokePath(// rect out is already multiplied by pixeldensity
createEllipseOutline(rectOut.x,rectOut.y,rectOut.width,rectOut.height,rotation,flipX,flipY),strokeWidth*viewPixelDensity,applyOpacity(strokeColor,opacity),true);};//#endregion
const glTextures=new Map();const imageFramebufferSize={};imageFramebufferSize[TEXTURE_PREVIEW_MARKUP_INDEX]={width:0,height:0};imageFramebufferSize[TEXTURE_PREVIEW_BLEND_INDEX]={width:0,height:0};const drawToImageFramebuffer=(index,buffer,imageSize)=>{const textureScalar=Math.min(textureSizeLimit/imageSize.width,textureSizeLimit/imageSize.height,1);const textureWidth=Math.floor(textureScalar*imageSize.width);const textureHeight=Math.floor(textureScalar*imageSize.height);if(!sizeEqual(imageSize,imageFramebufferSize[index])){// update preview markup texture
gl.bindTexture(gl.TEXTURE_2D,indexTextureMap.get(index));gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,textureWidth,textureHeight,0,gl.RGBA,gl.UNSIGNED_BYTE,null);// set the filtering, we don't need mips
gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);gl.bindFramebuffer(gl.FRAMEBUFFER,buffer);gl.framebufferTexture2D(gl.FRAMEBUFFER,gl.COLOR_ATTACHMENT0,gl.TEXTURE_2D,indexTextureMap.get(index),0);// remember so we know when to update the framebuffer
imageFramebufferSize[index]=imageSize;}else{gl.bindFramebuffer(gl.FRAMEBUFFER,buffer);}// switch transformMatrix
const w=imageSize.width*viewPixelDensity;const h=imageSize.height*viewPixelDensity;mat4Ortho(markupMatrixFrameBuffer,0,w,h,0,-1,1);mat4Translate(markupMatrixFrameBuffer,0,h,0);mat4ScaleX(markupMatrixFrameBuffer,1);mat4ScaleY(markupMatrixFrameBuffer,-1);markupMatrix=markupMatrixFrameBuffer;// framebuffer lives in image space
gl.viewport(0,0,textureWidth,textureHeight);// always transparent
gl.colorMask(true,true,true,true);gl.clearColor(0,0,0,0);gl.clear(gl.COLOR_BUFFER_BIT);// update rect mask
RECT_MASK_FEATHER=[1,0,1,0,1,Math.max(viewSize.width,imageSize.width),1,Math.max(viewSize.width,imageSize.width)];};return{// draw api
drawPath,drawTriangle,drawRect,drawEllipse,drawImage,// texture filters
textureFilterNearest:gl.NEAREST,textureFilterLinear:gl.LINEAR,//#region texture management
textureCreate:()=>{return gl.createTexture();},textureUpdate:(texture,source,options)=>{glTextures.set(texture,source);return updateTexture(gl,texture,source,options);},textureSize:texture=>{return sizeCreateFromAny(glTextures.get(texture));},textureDelete:texture=>{const source=glTextures.get(texture);if(source instanceof HTMLCanvasElement&&!source.dataset.retain)releaseCanvas(source);glTextures.delete(texture);gl.deleteTexture(texture);},//#endregion
setCanvasColor(color){CANVAS_COLOR_R=color[0];CANVAS_COLOR_G=color[1];CANVAS_COLOR_B=color[2];gl.clear(gl.COLOR_BUFFER_BIT);},drawToCanvas(){gl.bindFramebuffer(gl.FRAMEBUFFER,null);// switch transformMatrix
markupMatrix=markupMatrixCanvas;// tell webgl about the viewport
gl.viewport(0,0,gl.drawingBufferWidth,gl.drawingBufferHeight);// black (or other color depending on background)
gl.colorMask(true,true,true,false);gl.clearColor(CANVAS_COLOR_R,CANVAS_COLOR_G,CANVAS_COLOR_B,1);// gl.clearColor(0.25, 0.25, 0.25, 1); // for debugging
gl.clear(gl.COLOR_BUFFER_BIT);// update rect mask
RECT_MASK_FEATHER=[1,0,1,0,1,viewSize.width,1,viewSize.width];},drawToImageBlendBuffer(imageSize){drawToImageFramebuffer(TEXTURE_PREVIEW_BLEND_INDEX,blendFramebuffer,imageSize);},drawToImageOverlayBuffer(imageSize){drawToImageFramebuffer(TEXTURE_PREVIEW_MARKUP_INDEX,markupFramebuffer,imageSize);},// set mask
enableMask(rect,opacity){const maskX=rect.x*viewPixelDensity;const maskY=rect.y*viewPixelDensity;const maskWidth=rect.width*viewPixelDensity;const maskHeight=rect.height*viewPixelDensity;maskLeft=maskX;maskRight=maskLeft+maskWidth;maskTop=viewSize.height-maskY;maskBottom=viewSize.height-(maskY+maskHeight);maskOpacity=1.0-opacity;maskBounds=[maskTop,maskRight,maskBottom,maskLeft];},disableMask(){maskLeft=0;maskRight=viewSize.width;maskTop=viewSize.height;maskBottom=0;maskOpacity=1;maskBounds=[maskTop,maskRight,maskBottom,maskLeft];},// canvas
resize,release(){canvas.width=1;canvas.height=1;}};};var isImageBitmap=obj=>'close'in obj;/* src/core/ui/components/Canvas.svelte generated by Svelte v3.37.0 */function create_fragment$M(ctx){let div;let canvas_1;let mounted;let dispose;return{c(){div=pintura_element("div");canvas_1=pintura_element("canvas");attr(div,"class","PinturaCanvas");},m(target,anchor){insert(target,div,anchor);append(div,canvas_1);/*canvas_1_binding*/ctx[24](canvas_1);if(!mounted){dispose=[listen(canvas_1,"measure",/*measure_handler*/ctx[25]),action_destroyer(measurable.call(null,canvas_1))];mounted=true;}},p:pintura_noop,i:pintura_noop,o:pintura_noop,d(detaching){if(detaching)detach(div);/*canvas_1_binding*/ctx[24](null);mounted=false;run_all(dispose);}};}function instance$M($$self,$$props,$$invalidate){let canDraw;let drawUpdate;let $background;let $maskOpacityStore;let $mask;let $imageOverlayColor;let $maskFrameOpacityStore;const blendWithCanvasBackground=(back,front)=>{const[bR,bG,bB]=back;const[fR,fG,fB,fA]=front;return[fR*fA+bR*(1-fA),fG*fA+bG*(1-fA),fB*fA+bB*(1-fA),1];};// used to dispatch the 'measure' event
const dispatch=createEventDispatcher();let{animate}=$$props;let{maskRect}=$$props;let{maskOpacity=1}=$$props;let{maskFrameOpacity=0.95}=$$props;let{pixelRatio=1}=$$props;let{backgroundColor}=$$props;let{willRender=passthrough}=$$props;let{loadImageData=passthrough}=$$props;let{images=[]}=$$props;let{interfaceImages=[]}=$$props;// internal props
let canvas;let canvasGL=null;let width=null;let height=null;//
// springyness for main preview
//
const updateSpring=(spring,value)=>spring.set(value,{hard:!animate});const SPRING_PROPS={precision:0.0001};const SPRING_PROPS_FRACTION={precision:SPRING_PROPS.precision*0.01};// Editor UI
const background=tweened(undefined,{duration:250});component_subscribe($$self,background,value=>$$invalidate(20,$background=value));const maskOpacityStore=spring(1,SPRING_PROPS_FRACTION);component_subscribe($$self,maskOpacityStore,value=>$$invalidate(21,$maskOpacityStore=value));const maskFrameOpacityStore=spring(1,SPRING_PROPS_FRACTION);component_subscribe($$self,maskFrameOpacityStore,value=>$$invalidate(30,$maskFrameOpacityStore=value));const mask=writable();component_subscribe($$self,mask,value=>$$invalidate(28,$mask=value));const imageOverlayColor=writable();component_subscribe($$self,imageOverlayColor,value=>$$invalidate(29,$imageOverlayColor=value));//#region texture loading and binding
const TEXT_TEXTURE_MEASURE_CONTEXT=createSimpleContext();const Textures=new Map([]);const getImageTexture=(image,imageRendering)=>{// no texture yet for this source
if(!Textures.has(image)){// is in loading state when is same as source
Textures.set(image,image);// get texture filter mode
const filter=imageRendering==="pixelated"?canvasGL.textureFilterNearest:canvasGL.textureFilterLinear;// already loaded
if(!pintura_isString(image)&&(isImageBitmap(image)||isImageData(image)||isCanvas(image))){// create texture
const texture=canvasGL.textureCreate();// udpate texture in gl canvas
canvasGL.textureUpdate(texture,image,{filter});// update state we now have a texture
Textures.set(image,texture);}else// need to load the image
{loadImageData(image).then(data=>{// create texture
const texture=canvasGL.textureCreate();// udpate texture in gl canvas
canvasGL.textureUpdate(texture,data,{filter});// update state we now have a texture
Textures.set(image,texture);// need to redraw because texture is now available
requestAnimationFrame(drawUpdate);}).catch(err=>{console.error(err);});}}return Textures.get(image);};const getTextTexture=shape=>{let{text,textAlign,fontFamily,fontSize,fontWeight,fontVariant,fontStyle,lineHeight,width}=shape;// we need this context to correctly wrap text
updateTextContext(TEXT_TEXTURE_MEASURE_CONTEXT,{fontSize,fontFamily,fontWeight,fontVariant,fontStyle,textAlign});// wrap the text
const textString=width?wrapText(TEXT_TEXTURE_MEASURE_CONTEXT,text,width):text;// create UID for this texture so we can cache it and fetch it later on
const textUID=shapeTextUID({...shape,text:textString});// get texture unit assigned to this specific text shape
if(!Textures.has(textUID)){// TODO: Create power of 2 texture and update texture instead of delete -> replace
// we need to create a new texture
const ctx=createSimpleContext();updateTextContext(ctx,{fontSize,fontFamily,fontWeight,fontVariant,fontStyle,textAlign});// calculate canvas height
resizeContextToFitText(ctx,textString,{fontSize,fontFamily,fontWeight,fontVariant,fontStyle,textAlign,lineHeight});const contextMinWidth=ctx.canvas.width;// scale context to account for italic styles
ctx.canvas.width+=textPadding;// context resized, we now need to re-apply style
updateTextContext(ctx,{fontSize,fontFamily,fontWeight,fontVariant,fontStyle,textAlign,color:[1,0,1]// color we'll replace in the shader
});// if so, draw text and update texture
drawText$1(ctx,textString,{fontSize,textAlign,lineHeight,lineWidth:contextMinWidth});Textures.set(textUID,canvasGL.textureUpdate(canvasGL.textureCreate(),ctx.canvas,{filter:canvasGL.textureFilterLinear}));}return Textures.get(textUID);};const getShapeTexture=shape=>{let texture;// let's create textures for backgrounds and texts
if(shape.backgroundImage){texture=getImageTexture(shape.backgroundImage,shape.backgroundImageRendering);}else if(pintura_isString(shape.text)){if(shape.width&&shape.width<1||shape.height&&shape.height<1)return undefined;texture=getTextTexture(shape);}return texture;};const isTexture=texture=>texture instanceof WebGLTexture;const releaseUnusedTextures=usedTextures=>{Textures.forEach((registeredTexture,key)=>{const isUsed=!!usedTextures.find(usedTexture=>usedTexture===registeredTexture);// stil used, no need to release
if(isUsed)return;// remove this texture
Textures.delete(key);canvasGL.textureDelete(registeredTexture);});};//#endregion
//#region drawing
const drawImageHelper=({data,size,origin,translation,rotation,scale,colorMatrix,opacity,convolutionMatrix,gamma,vignette,maskFeather,maskCornerRadius,backgroundColor,overlayColor,enableShapes,enableBlend})=>{// calculate opaque backgroundColor if backgroundColor is transparent and visible
if(backgroundColor&&backgroundColor[3]<1&&backgroundColor[3]>0){backgroundColor=blendWithCanvasBackground($background,backgroundColor);}// gets texture to use for this image
const texture=getImageTexture(data);// draw the image
canvasGL.drawImage(texture,size,origin.x,origin.y,translation.x,translation.y,rotation.x,rotation.y,rotation.z,scale,colorMatrix,pintura_clamp(opacity,0,1),convolutionMatrix,gamma,vignette,maskFeather,maskCornerRadius,backgroundColor,overlayColor,enableShapes,enableBlend);return texture;};const backgroundCornersToUVMap=([tl,tr,br,bl])=>{// tl, tr, br, bl -> bl, tl, br, tr
// prettier-ignore
// B   D
// | \ |
// A  C
return[bl.x,bl.y,tl.x,tl.y,br.x,br.y,tr.x,tr.y];};const drawShapes=(shapes=[])=>{return shapes.map(shape=>{// only show texture if shape is finished loading
let shapeTexture=!shape._isLoading&&getShapeTexture(shape);// get the webgl texture
let texture=isTexture(shapeTexture)?shapeTexture:undefined;if(pintura_isArray(shape.points)){// is triangle
if(shape.points.length===3&&shape.backgroundColor){canvasGL.drawTriangle(shape.points,shape.rotation,shape.flipX,shape.flipY,shape.backgroundColor,shape.strokeWidth,shape.strokeColor,shape.opacity);}else// is normal path
{canvasGL.drawPath(shape.points,shape.strokeWidth,shape.strokeColor,shape.pathClose,shape.opacity);}}else// is ellipse
if(pintura_isNumber(shape.rx)&&pintura_isNumber(shape.ry)){let backgroundSize;let backgroundPosition;canvasGL.drawEllipse(shape,shape.rx,shape.ry,shape.rotation,shape.flipX,shape.flipY,shape.backgroundColor,texture,backgroundSize,backgroundPosition,shape.backgroundCorners&&backgroundCornersToUVMap(shape.backgroundCorners),shape.strokeWidth,shape.strokeColor,shape.opacity,shape.inverted);}else// is rect
if(pintura_isString(shape.text)&&texture||shape.width){const textureSize=texture&&canvasGL.textureSize(texture);let colorize=undefined;let shapeRect;let shapeCornerRadius=[shape.cornerRadius,shape.cornerRadius,shape.cornerRadius,shape.cornerRadius];if(shape.width){shapeRect=shape;}else{shapeRect={x:shape.x,y:shape.y,...textureSize};}let backgroundSize;let backgroundPosition;if(textureSize){// background should be scaled
if(shape.backgroundImage&&shape.backgroundSize){// always respect texture aspect ratio
const textureAspectRatio=getAspectRatio(textureSize.width,textureSize.height);// adjust position of background
if(shape.backgroundSize==="contain"){const rect=rectContainRect(shape,textureAspectRatio,shapeRect);backgroundSize=sizeCreateFromRect(rect);backgroundPosition=vectorCreate((shape.width-backgroundSize.width)*0.5,(shape.height-backgroundSize.height)*0.5);}else if(shape.backgroundSize==="cover"){const rect=rectCoverRect(shape,textureAspectRatio,shapeRect);backgroundSize=sizeCreateFromRect(rect);backgroundPosition=vectorCreate(rect.x,rect.y);backgroundPosition=vectorCreate((shape.width-backgroundSize.width)*0.5,(shape.height-backgroundSize.height)*0.5);}else{backgroundSize=shape.backgroundSize;backgroundPosition=shape.backgroundPosition;}}else// is text, "background" should be texture size and be positioned based on alignment
if(shape.text&&shape.width){// position texture based on text alignment
backgroundSize=textureSize;backgroundPosition=vectorCreate(0,0);// auto height
if(!shape.height)shape.height=textureSize.height;// textPadding so text doesn't clip on left and right edges
shape.x-=textPadding;shape.width+=textPadding*2;if(shape.textAlign==="left"){backgroundPosition.x=textPadding;}if(shape.textAlign==="center"){backgroundPosition.x=textPadding*0.5+(shape.width-textureSize.width)*0.5;}if(shape.textAlign==="right"){backgroundPosition.x=shape.width-textureSize.width;}}else if(shape.text){backgroundPosition=vectorCreate(0,0);backgroundSize={width:shapeRect.width,height:shapeRect.height};// texture is slightly larger because of text padding, need to compensate for this in single line mode
shapeRect.width-=textPadding;}if(shape.text)colorize=shape.color;}canvasGL.drawRect(shapeRect,shape.rotation,shape.flipX,shape.flipY,shapeCornerRadius,shape.backgroundColor,texture,backgroundSize,backgroundPosition,shape.backgroundCorners&&backgroundCornersToUVMap(shape.backgroundCorners),shape.strokeWidth,shape.strokeColor,shape.opacity,undefined,colorize,shape.inverted);}return shapeTexture;}).filter(Boolean);};// redraws state
const usedTextures=[];const redraw=()=>{// reset array of textures used in this draw call
usedTextures.length=0;// get top image shortcut
const imagesTop=images[0];// allow dev to inject more shapes
const{blendShapes,annotationShapes,interfaceShapes,decorationShapes,frameShapes}=willRender({// top image state shortcut
opacity:imagesTop.opacity,rotation:imagesTop.rotation,scale:imagesTop.scale,// active images
images,// canvas size
size:sizeCreate(width,height),// canvas background
backgroundColor:[...$background]});const canvasBackgroundColor=[...$background];const imagesMask=$mask;const imagesMaskOpacity=pintura_clamp($maskOpacityStore,0,1);const imagesOverlayColor=$imageOverlayColor;const imagesSize=imagesTop.size;const imagesBackgroundColor=imagesTop.backgroundColor;// no need to draw to blend framebuffer if no redactions
const hasBlendShapes=blendShapes.length>0;// no need to draw to markup framebuffer if no annotations
const hasAnnotations=annotationShapes.length>0;// if image has background color
const hasImageBackgroundColor=imagesBackgroundColor[3]>0;// if the overlay is transparent so we can see the canvas
const hasTransparentOverlay=imagesMaskOpacity<1;// set canvas background color to image background color if is defined
if(hasTransparentOverlay&&hasImageBackgroundColor){const backR=canvasBackgroundColor[0];const backG=canvasBackgroundColor[1];const backB=canvasBackgroundColor[2];const frontA=1-imagesMaskOpacity;const frontR=imagesBackgroundColor[0]*frontA;const frontG=imagesBackgroundColor[1]*frontA;const frontB=imagesBackgroundColor[2]*frontA;const fA=1-frontA;canvasBackgroundColor[0]=frontR+backR*fA;canvasBackgroundColor[1]=frontG+backG*fA;canvasBackgroundColor[2]=frontB+backB*fA;canvasBackgroundColor[3]=1;}canvasGL.setCanvasColor(canvasBackgroundColor);// if has blend shapes draw blend shapes to framebuffer
// TODO: only run this if blend shapes have changed
if(hasBlendShapes){canvasGL.disableMask();canvasGL.drawToImageBlendBuffer(imagesSize);usedTextures.push(...drawShapes(blendShapes));}// if has annotations draw annotation shapes to framebuffer
// TODO: only run this if annotations have changed
if(hasAnnotations){canvasGL.disableMask();canvasGL.drawToImageOverlayBuffer(imagesSize);usedTextures.push(...drawShapes(annotationShapes));}// switch to canvas drawing for other elements
canvasGL.drawToCanvas();canvasGL.enableMask(imagesMask,imagesMaskOpacity);// draw a colored rectangle behind main preview image
if(hasImageBackgroundColor){canvasGL.drawRect(imagesMask,0,false,false,[0,0,0,0],blendWithCanvasBackground($background,imagesBackgroundColor));}usedTextures.push(...[...images].reverse().map(image=>{return drawImageHelper({...image,// enable drawing markup if defined
enableShapes:hasAnnotations,// enable drawing redactions if defined
enableBlend:hasBlendShapes,// mask and overlay positions
mask:imagesMask,maskOpacity:imagesMaskOpacity,overlayColor:imagesOverlayColor});}));// TODO: move vignette here (draw with colorized circular gradient texture instead of in shader)
// draw decorations shapes relative to crop
canvasGL.enableMask(imagesMask,1);usedTextures.push(...drawShapes(decorationShapes));// draw frames
if(frameShapes.length){const shapesInside=frameShapes.filter(shape=>!shape.expandsCanvas);const shapesOutside=frameShapes.filter(shape=>shape.expandsCanvas);if(shapesInside.length){usedTextures.push(...drawShapes(shapesInside));}if(shapesOutside.length){// the half pixel helps mask the outside shapes at the correct position
canvasGL.enableMask({x:imagesMask.x+0.5,y:imagesMask.y+0.5,width:imagesMask.width-1,height:imagesMask.height-1},$maskFrameOpacityStore);usedTextures.push(...drawShapes(shapesOutside));}}// crop mask not used for interface
canvasGL.disableMask();// frames rendered on the outside
// draw custom interface shapes
usedTextures.push(...drawShapes(interfaceShapes));interfaceImages.forEach(image=>{canvasGL.enableMask(image.mask,image.maskOpacity);// draw background fill
if(image.backgroundColor){canvasGL.drawRect(image.mask,0,false,false,image.maskCornerRadius,image.backgroundColor,undefined,undefined,undefined,undefined,undefined,image.opacity,image.maskFeather);}// draw image
drawImageHelper({...image,// update translation to apply `offset` from top left
translation:{x:image.translation.x+image.offset.x-width*0.5,y:image.translation.y+image.offset.y-height*0.5}});});canvasGL.disableMask();// determine which textures can be dropped
releaseUnusedTextures(usedTextures);};//#endregion
//#region set up
// throttled redrawer
let lastDraw=Date.now();const redrawThrottled=()=>{const now=Date.now();const dist=now-lastDraw;if(dist<48)return;lastDraw=now;redraw();};// returns the render function to use for this browser context
const selectFittingRenderFunction=()=>isSoftwareRendering()?redrawThrottled:redraw;// after DOM has been altered, redraw to canvas
afterUpdate(()=>drawUpdate());// hook up canvas to WebGL drawer
onMount(()=>$$invalidate(19,canvasGL=createWebGLCanvas(canvas)));// clean up canvas
onDestroy(()=>{// if canvas wasn't created we don't need to release it
if(!canvasGL)return;// done drawing
canvasGL.release();// force release canvas for Safari
releaseCanvas(TEXT_TEXTURE_MEASURE_CONTEXT.canvas);});function canvas_1_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{canvas=$$value;$$invalidate(2,canvas);});}const measure_handler=e=>{$$invalidate(0,width=e.detail.width);$$invalidate(1,height=e.detail.height);dispatch("measure",{width,height});};$$self.$$set=$$props=>{if("animate"in $$props)$$invalidate(9,animate=$$props.animate);if("maskRect"in $$props)$$invalidate(10,maskRect=$$props.maskRect);if("maskOpacity"in $$props)$$invalidate(11,maskOpacity=$$props.maskOpacity);if("maskFrameOpacity"in $$props)$$invalidate(12,maskFrameOpacity=$$props.maskFrameOpacity);if("pixelRatio"in $$props)$$invalidate(13,pixelRatio=$$props.pixelRatio);if("backgroundColor"in $$props)$$invalidate(14,backgroundColor=$$props.backgroundColor);if("willRender"in $$props)$$invalidate(15,willRender=$$props.willRender);if("loadImageData"in $$props)$$invalidate(16,loadImageData=$$props.loadImageData);if("images"in $$props)$$invalidate(17,images=$$props.images);if("interfaceImages"in $$props)$$invalidate(18,interfaceImages=$$props.interfaceImages);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*backgroundColor*/16384){backgroundColor&&updateSpring(background,backgroundColor);}if($$self.$$.dirty[0]&/*maskOpacity*/2048){updateSpring(maskOpacityStore,pintura_isNumber(maskOpacity)?maskOpacity:1);}if($$self.$$.dirty[0]&/*maskFrameOpacity*/4096){updateSpring(maskFrameOpacityStore,pintura_isNumber(maskFrameOpacity)?maskFrameOpacity:1);}if($$self.$$.dirty[0]&/*maskRect*/1024){maskRect&&mask.set(maskRect);}if($$self.$$.dirty[0]&/*$background, $maskOpacityStore*/3145728){$background&&imageOverlayColor.set([$background[0],$background[1],$background[2],pintura_clamp($maskOpacityStore,0,1)]);}if($$self.$$.dirty[0]&/*canvasGL, width, height, images*/655363){// can draw view
$$invalidate(23,canDraw=!!(canvasGL&&width&&height&&images.length));}if($$self.$$.dirty[0]&/*width, height, canvasGL, pixelRatio*/532483){// observe width and height changes and resize the canvas proportionally
width&&height&&canvasGL&&canvasGL.resize(width,height,pixelRatio);}if($$self.$$.dirty[0]&/*canDraw*/8388608){// switch to draw method when can draw
$$invalidate(22,drawUpdate=canDraw?selectFittingRenderFunction():noop$1);}if($$self.$$.dirty[0]&/*canDraw, drawUpdate*/12582912){// if can draw state is updated and we have a draw update function, time to redraw
canDraw&&drawUpdate&&drawUpdate();}};return[width,height,canvas,dispatch,background,maskOpacityStore,maskFrameOpacityStore,mask,imageOverlayColor,animate,maskRect,maskOpacity,maskFrameOpacity,pixelRatio,backgroundColor,willRender,loadImageData,images,interfaceImages,canvasGL,$background,$maskOpacityStore,drawUpdate,canDraw,canvas_1_binding,measure_handler];}class Canvas extends SvelteComponent{constructor(options){super();init(this,options,instance$M,create_fragment$M,safe_not_equal,{animate:9,maskRect:10,maskOpacity:11,maskFrameOpacity:12,pixelRatio:13,backgroundColor:14,willRender:15,loadImageData:16,images:17,interfaceImages:18},[-1,-1]);}}var arrayJoin=(arr,filter=Boolean,str=' ')=>arr.filter(filter).join(str);/* src/core/ui/components/TabList.svelte generated by Svelte v3.37.0 */function get_each_context$9(ctx,list,i){const child_ctx=ctx.slice();child_ctx[17]=list[i];return child_ctx;}const get_default_slot_changes$1=dirty=>({tab:dirty&/*tabNodes*/4});const get_default_slot_context$1=ctx=>({tab:/*tab*/ctx[17]});// (52:0) {#if shouldRender}
function create_if_block$e(ctx){let ul;let each_blocks=[];let each_1_lookup=new Map();let ul_class_value;let current;let each_value=/*tabNodes*/ctx[2];const get_key=ctx=>/*tab*/ctx[17].id;for(let i=0;i<each_value.length;i+=1){let child_ctx=get_each_context$9(ctx,each_value,i);let key=get_key(child_ctx);each_1_lookup.set(key,each_blocks[i]=create_each_block$9(key,child_ctx));}return{c(){ul=pintura_element("ul");for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].c();}attr(ul,"class",ul_class_value=arrayJoin(["PinturaTabList",/*klass*/ctx[0]]));attr(ul,"role","tablist");attr(ul,"data-layout",/*layout*/ctx[1]);},m(target,anchor){insert(target,ul,anchor);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].m(ul,null);}/*ul_binding*/ctx[14](ul);current=true;},p(ctx,dirty){if(dirty&/*tabNodes, handleKeyTab, handleClickTab, $$scope*/1124){each_value=/*tabNodes*/ctx[2];group_outros();each_blocks=update_keyed_each(each_blocks,dirty,get_key,1,ctx,each_value,each_1_lookup,ul,outro_and_destroy_block,create_each_block$9,null,get_each_context$9);check_outros();}if(!current||dirty&/*klass*/1&&ul_class_value!==(ul_class_value=arrayJoin(["PinturaTabList",/*klass*/ctx[0]]))){attr(ul,"class",ul_class_value);}if(!current||dirty&/*layout*/2){attr(ul,"data-layout",/*layout*/ctx[1]);}},i(local){if(current)return;for(let i=0;i<each_value.length;i+=1){transition_in(each_blocks[i]);}current=true;},o(local){for(let i=0;i<each_blocks.length;i+=1){transition_out(each_blocks[i]);}current=false;},d(detaching){if(detaching)detach(ul);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].d();}/*ul_binding*/ctx[14](null);}};}// (59:8) {#each tabNodes as tab (tab.id)}
function create_each_block$9(key_1,ctx){let li;let button;let button_disabled_value;let t;let li_aria_controls_value;let li_id_value;let li_aria_selected_value;let current;let mounted;let dispose;const default_slot_template=/*#slots*/ctx[11].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[10],get_default_slot_context$1);function keydown_handler(...args){return/*keydown_handler*/ctx[12](/*tab*/ctx[17],...args);}function click_handler(...args){return/*click_handler*/ctx[13](/*tab*/ctx[17],...args);}return{key:key_1,first:null,c(){li=pintura_element("li");button=pintura_element("button");if(default_slot)default_slot.c();t=space();button.disabled=button_disabled_value=/*tab*/ctx[17].disabled;attr(li,"role","tab");attr(li,"aria-controls",li_aria_controls_value=/*tab*/ctx[17].href.substr(1));attr(li,"id",li_id_value=/*tab*/ctx[17].tabId);attr(li,"aria-selected",li_aria_selected_value=/*tab*/ctx[17].selected);this.first=li;},m(target,anchor){insert(target,li,anchor);append(li,button);if(default_slot){default_slot.m(button,null);}append(li,t);current=true;if(!mounted){dispose=[listen(button,"keydown",keydown_handler),listen(button,"click",click_handler)];mounted=true;}},p(new_ctx,dirty){ctx=new_ctx;if(default_slot){if(default_slot.p&&dirty&/*$$scope, tabNodes*/1028){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[10],dirty,get_default_slot_changes$1,get_default_slot_context$1);}}if(!current||dirty&/*tabNodes*/4&&button_disabled_value!==(button_disabled_value=/*tab*/ctx[17].disabled)){button.disabled=button_disabled_value;}if(!current||dirty&/*tabNodes*/4&&li_aria_controls_value!==(li_aria_controls_value=/*tab*/ctx[17].href.substr(1))){attr(li,"aria-controls",li_aria_controls_value);}if(!current||dirty&/*tabNodes*/4&&li_id_value!==(li_id_value=/*tab*/ctx[17].tabId)){attr(li,"id",li_id_value);}if(!current||dirty&/*tabNodes*/4&&li_aria_selected_value!==(li_aria_selected_value=/*tab*/ctx[17].selected)){attr(li,"aria-selected",li_aria_selected_value);}},i(local){if(current)return;transition_in(default_slot,local);current=true;},o(local){transition_out(default_slot,local);current=false;},d(detaching){if(detaching)detach(li);if(default_slot)default_slot.d(detaching);mounted=false;run_all(dispose);}};}function create_fragment$L(ctx){let if_block_anchor;let current;let if_block=/*shouldRender*/ctx[4]&&create_if_block$e(ctx);return{c(){if(if_block)if_block.c();if_block_anchor=empty();},m(target,anchor){if(if_block)if_block.m(target,anchor);insert(target,if_block_anchor,anchor);current=true;},p(ctx,[dirty]){if(/*shouldRender*/ctx[4]){if(if_block){if_block.p(ctx,dirty);if(dirty&/*shouldRender*/16){transition_in(if_block,1);}}else{if_block=create_if_block$e(ctx);if_block.c();transition_in(if_block,1);if_block.m(if_block_anchor.parentNode,if_block_anchor);}}else if(if_block){group_outros();transition_out(if_block,1,1,()=>{if_block=null;});check_outros();}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(if_block)if_block.d(detaching);if(detaching)detach(if_block_anchor);}};}function instance$L($$self,$$props,$$invalidate){let tabNodes;let shouldRender;let{$$slots:slots={},$$scope}=$$props;let root;let{class:klass=undefined}=$$props;let{name}=$$props;let{selected}=$$props;let{tabs=[]}=$$props;let{layout=undefined}=$$props;const dispatch=createEventDispatcher();const focusTab=index=>{const tab=root.querySelectorAll("[role=\"tab\"] button")[index];if(!tab)return;tab.focus();};const handleClickTab=(e,id)=>{e.preventDefault();e.stopPropagation();dispatch("select",id);};const handleKeyTab=({key},id)=>{if(!/arrow/i.test(key))return;const index=tabs.findIndex(tab=>tab.id===id);// next
if(/right|down/i.test(key))return focusTab(index<tabs.length-1?index+1:0);// prev
if(/left|up/i.test(key))return focusTab(index>0?index-1:tabs.length-1);};const keydown_handler=(tab,e)=>handleKeyTab(e,tab.id);const click_handler=(tab,e)=>handleClickTab(e,tab.id);function ul_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{root=$$value;$$invalidate(3,root);});}$$self.$$set=$$props=>{if("class"in $$props)$$invalidate(0,klass=$$props.class);if("name"in $$props)$$invalidate(7,name=$$props.name);if("selected"in $$props)$$invalidate(8,selected=$$props.selected);if("tabs"in $$props)$$invalidate(9,tabs=$$props.tabs);if("layout"in $$props)$$invalidate(1,layout=$$props.layout);if("$$scope"in $$props)$$invalidate(10,$$scope=$$props.$$scope);};$$self.$$.update=()=>{if($$self.$$.dirty&/*tabs, selected, name*/896){$$invalidate(2,tabNodes=tabs.map(tab=>{const isActive=tab.id===selected;return{...tab,tabId:`tab-${name}-${tab.id}`,href:`#panel-${name}-${tab.id}`,selected:isActive};}));}if($$self.$$.dirty&/*tabNodes*/4){$$invalidate(4,shouldRender=tabNodes.length>1);}};return[klass,layout,tabNodes,root,shouldRender,handleClickTab,handleKeyTab,name,selected,tabs,$$scope,slots,keydown_handler,click_handler,ul_binding];}class TabList extends SvelteComponent{constructor(options){super();init(this,options,instance$L,create_fragment$L,safe_not_equal,{class:0,name:7,selected:8,tabs:9,layout:1});}}/* src/core/ui/components/TabPanels.svelte generated by Svelte v3.37.0 */const get_default_slot_changes_1=dirty=>({panel:dirty&/*panelNodes*/16});const get_default_slot_context_1=ctx=>({panel:/*panelNodes*/ctx[4][0].id,panelIsActive:true});function get_each_context$8(ctx,list,i){const child_ctx=ctx.slice();child_ctx[14]=list[i].id;child_ctx[15]=list[i].draw;child_ctx[16]=list[i].panelId;child_ctx[17]=list[i].tabindex;child_ctx[18]=list[i].labelledBy;child_ctx[19]=list[i].hidden;child_ctx[3]=list[i].visible;return child_ctx;}const get_default_slot_changes=dirty=>({panel:dirty&/*panelNodes*/16,panelIsActive:dirty&/*panelNodes*/16});const get_default_slot_context=ctx=>({panel:/*id*/ctx[14],panelIsActive:!/*hidden*/ctx[19]});// (56:0) {:else}
function create_else_block$5(ctx){let div1;let div0;let div0_class_value;let current;let mounted;let dispose;const default_slot_template=/*#slots*/ctx[11].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[10],get_default_slot_context_1);return{c(){div1=pintura_element("div");div0=pintura_element("div");if(default_slot)default_slot.c();attr(div0,"class",div0_class_value=arrayJoin([/*panelClass*/ctx[1]]));attr(div1,"class",/*klass*/ctx[0]);attr(div1,"style",/*style*/ctx[2]);},m(target,anchor){insert(target,div1,anchor);append(div1,div0);if(default_slot){default_slot.m(div0,null);}current=true;if(!mounted){dispose=[listen(div1,"measure",/*measure_handler_1*/ctx[13]),action_destroyer(measurable.call(null,div1))];mounted=true;}},p(ctx,dirty){if(default_slot){if(default_slot.p&&dirty&/*$$scope, panelNodes*/1040){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[10],dirty,get_default_slot_changes_1,get_default_slot_context_1);}}if(!current||dirty&/*panelClass*/2&&div0_class_value!==(div0_class_value=arrayJoin([/*panelClass*/ctx[1]]))){attr(div0,"class",div0_class_value);}if(!current||dirty&/*klass*/1){attr(div1,"class",/*klass*/ctx[0]);}if(!current||dirty&/*style*/4){attr(div1,"style",/*style*/ctx[2]);}},i(local){if(current)return;transition_in(default_slot,local);current=true;},o(local){transition_out(default_slot,local);current=false;},d(detaching){if(detaching)detach(div1);if(default_slot)default_slot.d(detaching);mounted=false;run_all(dispose);}};}// (35:0) {#if shouldRender}
function create_if_block$d(ctx){let div;let each_blocks=[];let each_1_lookup=new Map();let div_class_value;let current;let mounted;let dispose;let each_value=/*panelNodes*/ctx[4];const get_key=ctx=>/*id*/ctx[14];for(let i=0;i<each_value.length;i+=1){let child_ctx=get_each_context$8(ctx,each_value,i);let key=get_key(child_ctx);each_1_lookup.set(key,each_blocks[i]=create_each_block$8(key,child_ctx));}return{c(){div=pintura_element("div");for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].c();}attr(div,"class",div_class_value=arrayJoin(["PinturaTabPanels",/*klass*/ctx[0]]));attr(div,"style",/*style*/ctx[2]);},m(target,anchor){insert(target,div,anchor);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].m(div,null);}current=true;if(!mounted){dispose=[listen(div,"measure",/*measure_handler*/ctx[12]),action_destroyer(measurable.call(null,div,{observePosition:true}))];mounted=true;}},p(ctx,dirty){if(dirty&/*arrayJoin, panelClass, panelNodes, $$scope*/1042){each_value=/*panelNodes*/ctx[4];group_outros();each_blocks=update_keyed_each(each_blocks,dirty,get_key,1,ctx,each_value,each_1_lookup,div,outro_and_destroy_block,create_each_block$8,null,get_each_context$8);check_outros();}if(!current||dirty&/*klass*/1&&div_class_value!==(div_class_value=arrayJoin(["PinturaTabPanels",/*klass*/ctx[0]]))){attr(div,"class",div_class_value);}if(!current||dirty&/*style*/4){attr(div,"style",/*style*/ctx[2]);}},i(local){if(current)return;for(let i=0;i<each_value.length;i+=1){transition_in(each_blocks[i]);}current=true;},o(local){for(let i=0;i<each_blocks.length;i+=1){transition_out(each_blocks[i]);}current=false;},d(detaching){if(detaching)detach(div);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].d();}mounted=false;run_all(dispose);}};}// (52:16) {#if draw}
function create_if_block_1$e(ctx){let current;const default_slot_template=/*#slots*/ctx[11].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[10],get_default_slot_context);return{c(){if(default_slot)default_slot.c();},m(target,anchor){if(default_slot){default_slot.m(target,anchor);}current=true;},p(ctx,dirty){if(default_slot){if(default_slot.p&&dirty&/*$$scope, panelNodes*/1040){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[10],dirty,get_default_slot_changes,get_default_slot_context);}}},i(local){if(current)return;transition_in(default_slot,local);current=true;},o(local){transition_out(default_slot,local);current=false;},d(detaching){if(default_slot)default_slot.d(detaching);}};}// (43:8) {#each panelNodes as { id, draw, panelId, tabindex, labelledBy, hidden, visible }
function create_each_block$8(key_1,ctx){let div;let t;let div_class_value;let div_hidden_value;let div_id_value;let div_tabindex_value;let div_aria_labelledby_value;let div_data_inert_value;let current;let if_block=/*draw*/ctx[15]&&create_if_block_1$e(ctx);return{key:key_1,first:null,c(){div=pintura_element("div");if(if_block)if_block.c();t=space();attr(div,"class",div_class_value=arrayJoin(["PinturaTabPanel",/*panelClass*/ctx[1]]));div.hidden=div_hidden_value=/*hidden*/ctx[19];attr(div,"id",div_id_value=/*panelId*/ctx[16]);attr(div,"tabindex",div_tabindex_value=/*tabindex*/ctx[17]);attr(div,"aria-labelledby",div_aria_labelledby_value=/*labelledBy*/ctx[18]);attr(div,"data-inert",div_data_inert_value=!/*visible*/ctx[3]);this.first=div;},m(target,anchor){insert(target,div,anchor);if(if_block)if_block.m(div,null);append(div,t);current=true;},p(new_ctx,dirty){ctx=new_ctx;if(/*draw*/ctx[15]){if(if_block){if_block.p(ctx,dirty);if(dirty&/*panelNodes*/16){transition_in(if_block,1);}}else{if_block=create_if_block_1$e(ctx);if_block.c();transition_in(if_block,1);if_block.m(div,t);}}else if(if_block){group_outros();transition_out(if_block,1,1,()=>{if_block=null;});check_outros();}if(!current||dirty&/*panelClass*/2&&div_class_value!==(div_class_value=arrayJoin(["PinturaTabPanel",/*panelClass*/ctx[1]]))){attr(div,"class",div_class_value);}if(!current||dirty&/*panelNodes*/16&&div_hidden_value!==(div_hidden_value=/*hidden*/ctx[19])){div.hidden=div_hidden_value;}if(!current||dirty&/*panelNodes*/16&&div_id_value!==(div_id_value=/*panelId*/ctx[16])){attr(div,"id",div_id_value);}if(!current||dirty&/*panelNodes*/16&&div_tabindex_value!==(div_tabindex_value=/*tabindex*/ctx[17])){attr(div,"tabindex",div_tabindex_value);}if(!current||dirty&/*panelNodes*/16&&div_aria_labelledby_value!==(div_aria_labelledby_value=/*labelledBy*/ctx[18])){attr(div,"aria-labelledby",div_aria_labelledby_value);}if(!current||dirty&/*panelNodes*/16&&div_data_inert_value!==(div_data_inert_value=!/*visible*/ctx[3])){attr(div,"data-inert",div_data_inert_value);}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(detaching)detach(div);if(if_block)if_block.d();}};}function create_fragment$K(ctx){let current_block_type_index;let if_block;let if_block_anchor;let current;const if_block_creators=[create_if_block$d,create_else_block$5];const if_blocks=[];function select_block_type(ctx,dirty){if(/*shouldRender*/ctx[5])return 0;return 1;}current_block_type_index=select_block_type(ctx);if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);return{c(){if_block.c();if_block_anchor=empty();},m(target,anchor){if_blocks[current_block_type_index].m(target,anchor);insert(target,if_block_anchor,anchor);current=true;},p(ctx,[dirty]){let previous_block_index=current_block_type_index;current_block_type_index=select_block_type(ctx);if(current_block_type_index===previous_block_index){if_blocks[current_block_type_index].p(ctx,dirty);}else{group_outros();transition_out(if_blocks[previous_block_index],1,1,()=>{if_blocks[previous_block_index]=null;});check_outros();if_block=if_blocks[current_block_type_index];if(!if_block){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);if_block.c();}else{if_block.p(ctx,dirty);}transition_in(if_block,1);if_block.m(if_block_anchor.parentNode,if_block_anchor);}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if_blocks[current_block_type_index].d(detaching);if(detaching)detach(if_block_anchor);}};}function instance$K($$self,$$props,$$invalidate){let panelNodes;let shouldRender;let{$$slots:slots={},$$scope}=$$props;let{class:klass=undefined}=$$props;let{name}=$$props;let{selected}=$$props;let{visible=undefined}=$$props;let{panelClass=undefined}=$$props;let{panels=[]}=$$props;let{style=undefined}=$$props;const drawCache={};function measure_handler(event){bubble($$self,event);}function measure_handler_1(event){bubble($$self,event);}$$self.$$set=$$props=>{if("class"in $$props)$$invalidate(0,klass=$$props.class);if("name"in $$props)$$invalidate(6,name=$$props.name);if("selected"in $$props)$$invalidate(7,selected=$$props.selected);if("visible"in $$props)$$invalidate(3,visible=$$props.visible);if("panelClass"in $$props)$$invalidate(1,panelClass=$$props.panelClass);if("panels"in $$props)$$invalidate(8,panels=$$props.panels);if("style"in $$props)$$invalidate(2,style=$$props.style);if("$$scope"in $$props)$$invalidate(10,$$scope=$$props.$$scope);};$$self.$$.update=()=>{if($$self.$$.dirty&/*panels, selected, visible, name, drawCache*/968){$$invalidate(4,panelNodes=panels.map(id=>{const isActive=id===selected;const isVisible=visible?visible.indexOf(id)!==-1:true;// remember that this tab was active so we keep drawing it even when it's inactive
if(isActive)$$invalidate(9,drawCache[id]=true,drawCache);return{id,panelId:`panel-${name}-${id}`,labelledBy:`tab-${name}-${id}`,hidden:!isActive,visible:isVisible,tabindex:isActive?0:-1,draw:isActive||drawCache[id]};}));}if($$self.$$.dirty&/*panelNodes*/16){$$invalidate(5,shouldRender=panelNodes.length>1);}};return[klass,panelClass,style,visible,panelNodes,shouldRender,name,selected,panels,drawCache,$$scope,slots,measure_handler,measure_handler_1];}class TabPanels extends SvelteComponent{constructor(options){super();init(this,options,instance$K,create_fragment$K,safe_not_equal,{class:0,name:6,selected:7,visible:3,panelClass:1,panels:8,style:2});}}/* src/core/ui/components/Panel.svelte generated by Svelte v3.37.0 */function create_fragment$J(ctx){let div;let switch_instance;let updating_name;let div_class_value;let current;const switch_instance_spread_levels=[/*componentProps*/ctx[7]];function switch_instance_name_binding(value){/*switch_instance_name_binding*/ctx[19](value);}var switch_value=/*componentView*/ctx[11];function switch_props(ctx){let switch_instance_props={};for(let i=0;i<switch_instance_spread_levels.length;i+=1){switch_instance_props=pintura_assign(switch_instance_props,switch_instance_spread_levels[i]);}if(/*panelName*/ctx[5]!==void 0){switch_instance_props.name=/*panelName*/ctx[5];}return{props:switch_instance_props};}if(switch_value){switch_instance=new switch_value(switch_props(ctx));binding_callbacks.push(()=>bind(switch_instance,"name",switch_instance_name_binding));/*switch_instance_binding*/ctx[20](switch_instance);switch_instance.$on("measure",/*measure_handler*/ctx[21]);}return{c(){div=pintura_element("div");if(switch_instance)create_component(switch_instance.$$.fragment);attr(div,"data-util",/*panelName*/ctx[5]);attr(div,"class",div_class_value=arrayJoin(["PinturaPanel",/*klass*/ctx[2]]));attr(div,"style",/*style*/ctx[6]);},m(target,anchor){insert(target,div,anchor);if(switch_instance){mount_component(switch_instance,div,null);}current=true;},p(ctx,[dirty]){const switch_instance_changes=dirty&/*componentProps*/128?get_spread_update(switch_instance_spread_levels,[get_spread_object(/*componentProps*/ctx[7])]):{};if(!updating_name&&dirty&/*panelName*/32){updating_name=true;switch_instance_changes.name=/*panelName*/ctx[5];add_flush_callback(()=>updating_name=false);}if(switch_value!==(switch_value=/*componentView*/ctx[11])){if(switch_instance){group_outros();const old_component=switch_instance;transition_out(old_component.$$.fragment,1,0,()=>{destroy_component(old_component,1);});check_outros();}if(switch_value){switch_instance=new switch_value(switch_props(ctx));binding_callbacks.push(()=>bind(switch_instance,"name",switch_instance_name_binding));/*switch_instance_binding*/ctx[20](switch_instance);switch_instance.$on("measure",/*measure_handler*/ctx[21]);create_component(switch_instance.$$.fragment);transition_in(switch_instance.$$.fragment,1);mount_component(switch_instance,div,null);}else{switch_instance=null;}}else if(switch_value){switch_instance.$set(switch_instance_changes);}if(!current||dirty&/*panelName*/32){attr(div,"data-util",/*panelName*/ctx[5]);}if(!current||dirty&/*klass*/4&&div_class_value!==(div_class_value=arrayJoin(["PinturaPanel",/*klass*/ctx[2]]))){attr(div,"class",div_class_value);}if(!current||dirty&/*style*/64){attr(div,"style",/*style*/ctx[6]);}},i(local){if(current)return;if(switch_instance)transition_in(switch_instance.$$.fragment,local);current=true;},o(local){if(switch_instance)transition_out(switch_instance.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);/*switch_instance_binding*/ctx[20](null);if(switch_instance)destroy_component(switch_instance);}};}function instance$J($$self,$$props,$$invalidate){let style;let componentProps;let $opacityClamped;let $isActivePrivateStore;const dispatch=createEventDispatcher();let{isActive=true}=$$props;let{isAnimated=true}=$$props;let{stores}=$$props;let{content}=$$props;let{component}=$$props;let{locale}=$$props;let{class:klass=undefined}=$$props;// we remember the view rect in this variable
let rect;const opacity=spring(0);const opacityClamped=derived(opacity,$opacity=>pintura_clamp($opacity,0,1));component_subscribe($$self,opacityClamped,value=>$$invalidate(18,$opacityClamped=value));// throw hide / show events
let isHidden=!isActive;// create active store so can be used in derived stores
const isActivePrivateStore=writable(isActive);component_subscribe($$self,isActivePrivateStore,value=>$$invalidate(22,$isActivePrivateStore=value));const stateProps={isActive:derived(isActivePrivateStore,$isActivePrivateStore=>$isActivePrivateStore),isActiveFraction:derived(opacityClamped,$opacityClamped=>$opacityClamped),isVisible:derived(opacityClamped,$opacityClamped=>$opacityClamped>0)};// build the component props
const componentView=content.view;const componentExportedProps=getComponentExportedProps(componentView);const componentComputedProps=Object.keys(content.props||{}).reduce((computedProps,key)=>{if(!componentExportedProps.includes(key))return computedProps;computedProps[key]=content.props[key];return computedProps;},{});const componentComputedStateProps=Object.keys(stateProps).reduce((computedStateProps,key)=>{if(!componentExportedProps.includes(key))return computedStateProps;computedStateProps[key]=stateProps[key];return computedStateProps;},{});// class used on panel element
let panelName;// we use the `hasBeenMounted` bool to block rect updates until the entire panel is ready
let hasBeenMounted=false;onMount(()=>{$$invalidate(4,hasBeenMounted=true);});function switch_instance_name_binding(value){panelName=value;$$invalidate(5,panelName);}function switch_instance_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{component=$$value;$$invalidate(0,component);});}const measure_handler=e=>{if(!hasBeenMounted||!isActive)return;$$invalidate(3,rect=e.detail);dispatch("measure",{...rect});};$$self.$$set=$$props=>{if("isActive"in $$props)$$invalidate(1,isActive=$$props.isActive);if("isAnimated"in $$props)$$invalidate(12,isAnimated=$$props.isAnimated);if("stores"in $$props)$$invalidate(13,stores=$$props.stores);if("content"in $$props)$$invalidate(14,content=$$props.content);if("component"in $$props)$$invalidate(0,component=$$props.component);if("locale"in $$props)$$invalidate(15,locale=$$props.locale);if("class"in $$props)$$invalidate(2,klass=$$props.class);};$$self.$$.update=()=>{if($$self.$$.dirty&/*rect, isActive, component*/11){// when the view rect changes and the panel is in active state or became active, dispatch measure event
if(rect&&isActive&&component)dispatch("measure",rect);}if($$self.$$.dirty&/*isActive, isAnimated*/4098){opacity.set(isActive?1:0,{hard:!isAnimated});}if($$self.$$.dirty&/*$opacityClamped, isHidden*/393216){if($opacityClamped<=0&&!isHidden){$$invalidate(17,isHidden=true);}else if($opacityClamped>0&&isHidden){$$invalidate(17,isHidden=false);}}if($$self.$$.dirty&/*hasBeenMounted, isHidden*/131088){hasBeenMounted&&dispatch(isHidden?"hide":"show");}if($$self.$$.dirty&/*$opacityClamped*/262144){dispatch("fade",$opacityClamped);}if($$self.$$.dirty&/*$opacityClamped*/262144){// only set opacity prop if is below 0
$$invalidate(6,style=$opacityClamped<1?`opacity: ${$opacityClamped}`:undefined);}if($$self.$$.dirty&/*isActive*/2){set_store_value(isActivePrivateStore,$isActivePrivateStore=isActive,$isActivePrivateStore);}if($$self.$$.dirty&/*stores, locale*/40960){$$invalidate(7,componentProps={...componentComputedProps,...componentComputedStateProps,stores,locale});}};return[component,isActive,klass,rect,hasBeenMounted,panelName,style,componentProps,dispatch,opacityClamped,isActivePrivateStore,componentView,isAnimated,stores,content,locale,opacity,isHidden,$opacityClamped,switch_instance_name_binding,switch_instance_binding,measure_handler];}class Panel extends SvelteComponent{constructor(options){super();init(this,options,instance$J,create_fragment$J,safe_not_equal,{isActive:1,isAnimated:12,stores:13,content:14,component:0,locale:15,class:2,opacity:16});}get opacity(){return this.$$.ctx[16];}}/* src/core/ui/components/Icon.svelte generated by Svelte v3.37.0 */function create_fragment$I(ctx){let svg;let svg_viewBox_value;let current;const default_slot_template=/*#slots*/ctx[5].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[4],null);return{c(){svg=svg_element("svg");if(default_slot)default_slot.c();attr(svg,"class",/*klass*/ctx[3]);attr(svg,"style",/*style*/ctx[2]);attr(svg,"width",/*width*/ctx[0]);attr(svg,"height",/*height*/ctx[1]);attr(svg,"viewBox",svg_viewBox_value="0 0 "+/*width*/ctx[0]+"\n    "+/*height*/ctx[1]);attr(svg,"xmlns","http://www.w3.org/2000/svg");attr(svg,"aria-hidden","true");attr(svg,"focusable","false");attr(svg,"stroke-linecap","round");attr(svg,"stroke-linejoin","round");},m(target,anchor){insert(target,svg,anchor);if(default_slot){default_slot.m(svg,null);}current=true;},p(ctx,[dirty]){if(default_slot){if(default_slot.p&&dirty&/*$$scope*/16){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[4],dirty,null,null);}}if(!current||dirty&/*klass*/8){attr(svg,"class",/*klass*/ctx[3]);}if(!current||dirty&/*style*/4){attr(svg,"style",/*style*/ctx[2]);}if(!current||dirty&/*width*/1){attr(svg,"width",/*width*/ctx[0]);}if(!current||dirty&/*height*/2){attr(svg,"height",/*height*/ctx[1]);}if(!current||dirty&/*width, height*/3&&svg_viewBox_value!==(svg_viewBox_value="0 0 "+/*width*/ctx[0]+"\n    "+/*height*/ctx[1])){attr(svg,"viewBox",svg_viewBox_value);}},i(local){if(current)return;transition_in(default_slot,local);current=true;},o(local){transition_out(default_slot,local);current=false;},d(detaching){if(detaching)detach(svg);if(default_slot)default_slot.d(detaching);}};}function instance$I($$self,$$props,$$invalidate){let{$$slots:slots={},$$scope}=$$props;let{width=24}=$$props;let{height=24}=$$props;let{style=undefined}=$$props;let{class:klass=undefined}=$$props;$$self.$$set=$$props=>{if("width"in $$props)$$invalidate(0,width=$$props.width);if("height"in $$props)$$invalidate(1,height=$$props.height);if("style"in $$props)$$invalidate(2,style=$$props.style);if("class"in $$props)$$invalidate(3,klass=$$props.class);if("$$scope"in $$props)$$invalidate(4,$$scope=$$props.$$scope);};return[width,height,style,klass,$$scope,slots];}class Icon extends SvelteComponent{constructor(options){super();init(this,options,instance$I,create_fragment$I,safe_not_equal,{width:0,height:1,style:2,class:3});}}var isEventTarget=(e,element)=>element===e.target||element.contains(e.target);/* src/core/ui/components/Button.svelte generated by Svelte v3.37.0 */function create_if_block_1$d(ctx){let icon_1;let current;icon_1=new Icon({props:{class:"PinturaButtonIcon",$$slots:{default:[create_default_slot$h]},$$scope:{ctx}}});return{c(){create_component(icon_1.$$.fragment);},m(target,anchor){mount_component(icon_1,target,anchor);current=true;},p(ctx,dirty){const icon_1_changes={};if(dirty&/*$$scope, icon*/1048578){icon_1_changes.$$scope={dirty,ctx};}icon_1.$set(icon_1_changes);},i(local){if(current)return;transition_in(icon_1.$$.fragment,local);current=true;},o(local){transition_out(icon_1.$$.fragment,local);current=false;},d(detaching){destroy_component(icon_1,detaching);}};}// (44:16) <Icon class="PinturaButtonIcon">
function create_default_slot$h(ctx){let g;return{c(){g=svg_element("g");},m(target,anchor){insert(target,g,anchor);g.innerHTML=/*icon*/ctx[1];},p(ctx,dirty){if(dirty&/*icon*/2)g.innerHTML=/*icon*/ctx[1];},d(detaching){if(detaching)detach(g);}};}// (50:12) {#if label}
function create_if_block$c(ctx){let span;let t;return{c(){span=pintura_element("span");t=pintura_text(/*label*/ctx[0]);attr(span,"class",/*elLabelClass*/ctx[11]);},m(target,anchor){insert(target,span,anchor);append(span,t);},p(ctx,dirty){if(dirty&/*label*/1)set_data(t,/*label*/ctx[0]);if(dirty&/*elLabelClass*/2048){attr(span,"class",/*elLabelClass*/ctx[11]);}},d(detaching){if(detaching)detach(span);}};}// (41:10)          
function fallback_block$2(ctx){let span;let t;let current;let if_block0=/*icon*/ctx[1]&&create_if_block_1$d(ctx);let if_block1=/*label*/ctx[0]&&create_if_block$c(ctx);return{c(){span=pintura_element("span");if(if_block0)if_block0.c();t=space();if(if_block1)if_block1.c();attr(span,"class",/*elButtonInnerClass*/ctx[9]);},m(target,anchor){insert(target,span,anchor);if(if_block0)if_block0.m(span,null);append(span,t);if(if_block1)if_block1.m(span,null);current=true;},p(ctx,dirty){if(/*icon*/ctx[1]){if(if_block0){if_block0.p(ctx,dirty);if(dirty&/*icon*/2){transition_in(if_block0,1);}}else{if_block0=create_if_block_1$d(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(span,t);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}if(/*label*/ctx[0]){if(if_block1){if_block1.p(ctx,dirty);}else{if_block1=create_if_block$c(ctx);if_block1.c();if_block1.m(span,null);}}else if(if_block1){if_block1.d(1);if_block1=null;}if(!current||dirty&/*elButtonInnerClass*/512){attr(span,"class",/*elButtonInnerClass*/ctx[9]);}},i(local){if(current)return;transition_in(if_block0);current=true;},o(local){transition_out(if_block0);current=false;},d(detaching){if(detaching)detach(span);if(if_block0)if_block0.d();if(if_block1)if_block1.d();}};}function create_fragment$H(ctx){let button;let current;let mounted;let dispose;const default_slot_template=/*#slots*/ctx[18].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[20],null);const default_slot_or_fallback=default_slot||fallback_block$2(ctx);return{c(){button=pintura_element("button");if(default_slot_or_fallback)default_slot_or_fallback.c();attr(button,"type",/*type*/ctx[4]);attr(button,"style",/*style*/ctx[2]);button.disabled=/*disabled*/ctx[3];attr(button,"class",/*elButtonClass*/ctx[10]);attr(button,"title",/*label*/ctx[0]);},m(target,anchor){insert(target,button,anchor);if(default_slot_or_fallback){default_slot_or_fallback.m(button,null);}/*button_binding*/ctx[19](button);current=true;if(!mounted){dispose=[listen(button,"keydown",function(){if(is_function(/*onkeydown*/ctx[6]))/*onkeydown*/ctx[6].apply(this,arguments);}),listen(button,"click",function(){if(is_function(/*onclick*/ctx[5]))/*onclick*/ctx[5].apply(this,arguments);}),action_destroyer(/*action*/ctx[7].call(null,button))];mounted=true;}},p(new_ctx,[dirty]){ctx=new_ctx;if(default_slot){if(default_slot.p&&dirty&/*$$scope*/1048576){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[20],dirty,null,null);}}else{if(default_slot_or_fallback&&default_slot_or_fallback.p&&dirty&/*elButtonInnerClass, elLabelClass, label, icon*/2563){default_slot_or_fallback.p(ctx,dirty);}}if(!current||dirty&/*type*/16){attr(button,"type",/*type*/ctx[4]);}if(!current||dirty&/*style*/4){attr(button,"style",/*style*/ctx[2]);}if(!current||dirty&/*disabled*/8){button.disabled=/*disabled*/ctx[3];}if(!current||dirty&/*elButtonClass*/1024){attr(button,"class",/*elButtonClass*/ctx[10]);}if(!current||dirty&/*label*/1){attr(button,"title",/*label*/ctx[0]);}},i(local){if(current)return;transition_in(default_slot_or_fallback,local);current=true;},o(local){transition_out(default_slot_or_fallback,local);current=false;},d(detaching){if(detaching)detach(button);if(default_slot_or_fallback)default_slot_or_fallback.d(detaching);/*button_binding*/ctx[19](null);mounted=false;run_all(dispose);}};}function instance$H($$self,$$props,$$invalidate){let elButtonInnerClass;let elButtonClass;let elLabelClass;let{$$slots:slots={},$$scope}=$$props;let{class:klass=undefined}=$$props;let{label=undefined}=$$props;let{labelClass=undefined}=$$props;let{innerClass=undefined}=$$props;let{hideLabel=false}=$$props;let{icon=undefined}=$$props;let{style=undefined}=$$props;let{disabled=undefined}=$$props;let{type="button"}=$$props;let{onclick=undefined}=$$props;let{onkeydown=undefined}=$$props;let{action=()=>{}}=$$props;let root;const isEventTarget$1=e=>isEventTarget(e,root);const getElement=()=>root;function button_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{root=$$value;$$invalidate(8,root);});}$$self.$$set=$$props=>{if("class"in $$props)$$invalidate(12,klass=$$props.class);if("label"in $$props)$$invalidate(0,label=$$props.label);if("labelClass"in $$props)$$invalidate(13,labelClass=$$props.labelClass);if("innerClass"in $$props)$$invalidate(14,innerClass=$$props.innerClass);if("hideLabel"in $$props)$$invalidate(15,hideLabel=$$props.hideLabel);if("icon"in $$props)$$invalidate(1,icon=$$props.icon);if("style"in $$props)$$invalidate(2,style=$$props.style);if("disabled"in $$props)$$invalidate(3,disabled=$$props.disabled);if("type"in $$props)$$invalidate(4,type=$$props.type);if("onclick"in $$props)$$invalidate(5,onclick=$$props.onclick);if("onkeydown"in $$props)$$invalidate(6,onkeydown=$$props.onkeydown);if("action"in $$props)$$invalidate(7,action=$$props.action);if("$$scope"in $$props)$$invalidate(20,$$scope=$$props.$$scope);};$$self.$$.update=()=>{if($$self.$$.dirty&/*innerClass*/16384){$$invalidate(9,elButtonInnerClass=arrayJoin(["PinturaButtonInner",innerClass]));}if($$self.$$.dirty&/*hideLabel, klass*/36864){$$invalidate(10,elButtonClass=arrayJoin(["PinturaButton",hideLabel&&"PinturaButtonIconOnly",klass]));}if($$self.$$.dirty&/*hideLabel, labelClass*/40960){$$invalidate(11,elLabelClass=arrayJoin([hideLabel?"implicit":"PinturaButtonLabel",labelClass]));}};return[label,icon,style,disabled,type,onclick,onkeydown,action,root,elButtonInnerClass,elButtonClass,elLabelClass,klass,labelClass,innerClass,hideLabel,isEventTarget$1,getElement,slots,button_binding,$$scope];}class Button extends SvelteComponent{constructor(options){super();init(this,options,instance$H,create_fragment$H,safe_not_equal,{class:12,label:0,labelClass:13,innerClass:14,hideLabel:15,icon:1,style:2,disabled:3,type:4,onclick:5,onkeydown:6,action:7,isEventTarget:16,getElement:17});}get isEventTarget(){return this.$$.ctx[16];}get getElement(){return this.$$.ctx[17];}}var arrayRemove=(array,predicate)=>{const index=array.findIndex(predicate);if(index>=0)return array.splice(index,1);return undefined;};// svelte
// constants
const INERTIA_THRESHOLD=0.25;// when force of velocity exceeds this value we drift
const INERTIA_DISTANCE_MULTIPLIER=50;const INERTIA_DURATION_MULTIPLIER=80;const TAP_DURATION_MAX=300;const TAP_DISTANCE_MAX=64;const DOUBLE_TAP_DURATION_MAX=700;const DOUBLE_TAP_DISTANCE_MAX=128;const isContextMenuAction=e=>pintura_isNumber(e.button)&&e.button!==0;var interactable=(node,options={})=>{// set defaults
const{inertia=false,matchTarget=false,pinch=false,getEventPosition=e=>vectorCreate(e.clientX,e.clientY)}=options;//
// helpers
//
function dispatch(type,detail){node.dispatchEvent(new CustomEvent(type,{detail}));}function resetInertia(){if(inertiaTweenUnsubscribe)inertiaTweenUnsubscribe();inertiaTweenUnsubscribe=undefined;}//#region pointer registry
const pointers=[];const addPointer=e=>{const pointer={timeStamp:e.timeStamp,timeStampInitial:e.timeStamp,position:getEventPosition(e),origin:getEventPosition(e),velocity:vectorCreateEmpty(),translation:vectorCreateEmpty(),interactionState:undefined,event:e};pointers.push(pointer);pointer.interactionState=getInteractionState(pointers);};const removePointer=e=>{const pointer=arrayRemove(pointers,pointer=>pointer.event.pointerId===e.pointerId);if(pointer)return pointer[0];};const getPointerIndex=e=>pointers.findIndex(pointer=>pointer.event.pointerId===e.pointerId);const flattenPointerOrigin=pointer=>{pointer.origin.x=pointer.position.x;pointer.origin.y=pointer.position.y;pointer.translation.x=0;pointer.translation.y=0;};const updatePointer=e=>{const pointer=getPointer(e);if(!pointer)return;const{timeStamp}=e;// position
const eventPosition=getEventPosition(e);// duration between previous interaction and new interaction, an interaction duration cannot be faster than 1 millisecond
const interactionDuration=Math.max(1,timeStamp-pointer.timeStamp);// calculate velocity
pointer.velocity.x=(eventPosition.x-pointer.position.x)/interactionDuration;pointer.velocity.y=(eventPosition.y-pointer.position.y)/interactionDuration;// update the translation
pointer.translation.x=eventPosition.x-pointer.origin.x;pointer.translation.y=eventPosition.y-pointer.origin.y;// set new state
pointer.timeStamp=timeStamp;pointer.position.x=eventPosition.x;pointer.position.y=eventPosition.y;pointer.event=e;};const getPointer=e=>{const i=getPointerIndex(e);if(i<0)return;return pointers[i];};const isSingleTouching=()=>pointers.length===1;const isMultiTouching=()=>pointers.length===2;const getDistance=(pointers,position)=>{const distanceTotal=pointers.reduce((prev,curr)=>{prev+=vectorDistance(position,curr.position);return prev;},0);return distanceTotal/pointers.length;};const getInteractionState=pointers=>{const center=vectorCenter(pointers.map(pointer=>pointer.position));const distance=getDistance(pointers,center);return{center,distance,velocity:vectorCenter(pointers.map(pointer=>pointer.velocity)),translation:vectorCenter(pointers.map(pointer=>pointer.translation))};};//#endregion
let inertiaTween;let inertiaTweenUnsubscribe;let pinchOffsetDistance;let currentTranslation;let currentScale;let isGesture;let lastTapTimeStamp=0;let lastTapPosition=undefined;// start handling interactions
node.addEventListener('pointerdown',handlePointerdown);function handlePointerdown(e){// ignore more than two pointers for now
if(isMultiTouching())return;// not interested in context menu
if(isContextMenuAction(e))return;// target should equal node, if it doesn't user might have clicked one of the nodes children
if(matchTarget&&e.target!==node)return;// stop any previous inertia tweens
resetInertia();// register this pointer
addPointer(e);// if is first pointer we need to init the drag gesture
if(isSingleTouching()){// handle pointer events
document.documentElement.addEventListener('pointermove',handlePointermove);document.documentElement.addEventListener('pointerup',handlePointerup);document.documentElement.addEventListener('pointercancel',handlePointerup);// clear vars
isGesture=false;currentScale=1;currentTranslation=vectorCreateEmpty();pinchOffsetDistance=undefined;dispatch('interactionstart',{origin:vectorClone(getPointer(e).origin)});}else if(pinch){isGesture=true;pinchOffsetDistance=vectorDistance(pointers[0].position,pointers[1].position);currentTranslation.x+=pointers[0].translation.x;currentTranslation.y+=pointers[0].translation.y;flattenPointerOrigin(pointers[0]);}}//
// pointer move can only be a primary event (other pointers are not handled)
//
let moveLast=Date.now();function handlePointermove(e){// prevent selection of text (Safari)
e.preventDefault();// update pointer state
updatePointer(e);let translation=vectorClone(pointers[0].translation);let scalar=currentScale;if(pinch&&isMultiTouching()){// current pinch distance
const pinchCurrentDistance=vectorDistance(pointers[0].position,pointers[1].position);// to find out scalar we calculate the difference between the pinch offset and the new pinch
const pinchScalar=pinchCurrentDistance/pinchOffsetDistance;// add to existing scalar
scalar*=pinchScalar;// current offset
vectorAdd(translation,pointers[1].translation);}translation.x+=currentTranslation.x;translation.y+=currentTranslation.y;// skip update event if last interaction was less than 16 ms ago
const now=Date.now();const dist=now-moveLast;if(dist<16)return;moveLast=now;dispatch('interactionupdate',{translation,scalar:pinch?scalar:undefined});}//
// pointer up can only be a primary event (other pointers are not handled)
//
function handlePointerup(e){// test if is my pointer that was released, as we're listining on document it could be other pointers
if(!getPointer(e))return;// remove pointer from active pointers array
const removedPointer=removePointer(e);// store current size
if(pinch&&isSingleTouching()){// calculate current scale
const pinchCurrentDistance=vectorDistance(pointers[0].position,removedPointer.position);currentScale*=pinchCurrentDistance/pinchOffsetDistance;currentTranslation.x+=pointers[0].translation.x+removedPointer.translation.x;currentTranslation.y+=pointers[0].translation.y+removedPointer.translation.y;flattenPointerOrigin(pointers[0]);}// check if this was a tap
let isTap=false;let isDoubleTap=false;if(!isGesture&&removedPointer){const interactionEnd=performance.now();const interactionDuration=interactionEnd-removedPointer.timeStampInitial;const interactionDistanceSquared=vectorDistanceSquared(removedPointer.translation);isTap=interactionDistanceSquared<TAP_DISTANCE_MAX&&interactionDuration<TAP_DURATION_MAX;isDoubleTap=!!(lastTapPosition&&isTap&&interactionEnd-lastTapTimeStamp<DOUBLE_TAP_DURATION_MAX&&vectorDistanceSquared(lastTapPosition,removedPointer.position)<DOUBLE_TAP_DISTANCE_MAX);if(isTap){lastTapPosition=vectorClone(removedPointer.position);lastTapTimeStamp=interactionEnd;}}// we wait till last multi-touch interaction is finished, all pointers need to be de-registered before proceeding
if(pointers.length>0)return;// stop listening
document.documentElement.removeEventListener('pointermove',handlePointermove);document.documentElement.removeEventListener('pointerup',handlePointerup);document.documentElement.removeEventListener('pointercancel',handlePointerup);const translation=vectorClone(removedPointer.translation);const velocity=vectorClone(removedPointer.velocity);// allows cancelling inertia from release handler
let inertiaPrevented=false;// user has released interaction
dispatch('interactionrelease',{isTap,isDoubleTap,translation,scalar:currentScale,preventInertia:()=>inertiaPrevented=true});// stop intantly if not a lot of force applied
const force=vectorDistance(velocity);if(inertiaPrevented||!inertia||force<INERTIA_THRESHOLD){return handleEnd(translation,{isTap,isDoubleTap});}// drift
inertiaTween=tweened(vectorClone(translation),{easing:circOut,duration:force*INERTIA_DURATION_MULTIPLIER});inertiaTween.set({x:translation.x+velocity.x*INERTIA_DISTANCE_MULTIPLIER,y:translation.y+velocity.y*INERTIA_DISTANCE_MULTIPLIER}).then(()=>{// if has unsubscribed (tween was reset)
if(!inertiaTweenUnsubscribe)return;// go!
handleEnd(get_store_value(inertiaTween),{isTap,isDoubleTap});});inertiaTweenUnsubscribe=inertiaTween.subscribe(handleInertiaUpdate);}function handleInertiaUpdate(inertiaTranslation){// if is same as previous position, ignore
if(!inertiaTranslation)return;// || vectorEqual(inertiaTranslation, translation)) return;
// this will handle drift interactions
dispatch('interactionupdate',{translation:inertiaTranslation,scalar:pinch?currentScale:undefined});}function handleEnd(translation,tapState){resetInertia();dispatch('interactionend',{...tapState,translation,scalar:pinch?currentScale:undefined});}return{destroy(){resetInertia();node.removeEventListener('pointerdown',handlePointerdown);}};};var nudgeable=(element,options={})=>{// if added as action on non focusable element you should add tabindex=0 attribute
const{direction=undefined,shiftMultiplier=10,bubbles=false,stopKeydownPropagation=true}=options;const isHorizontalDirection=direction==='horizontal';const isVerticalDirection=direction==='vertical';const handleKeydown=e=>{const{key}=e;const isShift=e.shiftKey;const isVerticalAction=/up|down/i.test(key);const isHorizontalAction=/left|right/i.test(key);// no directional key
if(!isHorizontalAction&&!isVerticalAction)return;// is horizontal but up or down pressed
if(isHorizontalDirection&&isVerticalAction)return;// is vertical but left or right pressed
if(isVerticalDirection&&isHorizontalAction)return;// if holding shift move by a factor 10
const multiplier=isShift?shiftMultiplier:1;if(stopKeydownPropagation)e.stopPropagation();element.dispatchEvent(new CustomEvent('nudge',{bubbles,detail:vectorCreate((/left/i.test(key)?-1:/right/i.test(key)?1:0)*multiplier,(/up/i.test(key)?-1:/down/i.test(key)?1:0)*multiplier)}));};element.addEventListener('keydown',handleKeydown);return{destroy(){element.removeEventListener('keydown',handleKeydown);}};};function elastify(translation,dist){return dist*Math.sign(translation)*Math.log10(1+Math.abs(translation)/dist);}const elastifyRects=(a,b,dist)=>{if(!b)return rectClone(a);const left=a.x+elastify(b.x-a.x,dist);const right=a.x+a.width+elastify(b.x+b.width-(a.x+a.width),dist);const top=a.y+elastify(b.y-a.y,dist);const bottom=a.y+a.height+elastify(b.y+b.height-(a.y+a.height),dist);return{x:left,y:top,width:right-left,height:bottom-top};};var unitToPixels=(value,element)=>{if(!value)return;if(/em/.test(value))return parseInt(value,10)*16;if(/px/.test(value))return parseInt(value,10);};var getWheelDelta=e=>{let d=e.detail||0;// @ts-ignore
const{deltaX,deltaY,wheelDelta,wheelDeltaX,wheelDeltaY}=e;// "detect" x axis interaction for MacOS trackpad
if(pintura_isNumber(wheelDeltaX)&&Math.abs(wheelDeltaX)>Math.abs(wheelDeltaY)){// blink & webkit
d=wheelDeltaX/-120;}else if(pintura_isNumber(deltaX)&&Math.abs(deltaX)>Math.abs(deltaY)){// quantum
d=deltaX/20;}// @ts-ignore
else if(wheelDelta||wheelDeltaY){// blink & webkit
d=(wheelDelta||wheelDeltaY)/-120;}if(!d){// quantum
d=deltaY/20;}return d;};/* src/core/ui/components/Scrollable.svelte generated by Svelte v3.37.0 */function create_fragment$G(ctx){let div1;let div0;let div1_class_value;let nudgeable_action;let current;let mounted;let dispose;const default_slot_template=/*#slots*/ctx[37].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[36],null);return{c(){div1=pintura_element("div");div0=pintura_element("div");if(default_slot)default_slot.c();attr(div0,"style",/*childStyle*/ctx[6]);attr(div1,"class",div1_class_value=arrayJoin(["PinturaScrollable",/*klass*/ctx[0]]));attr(div1,"style",/*overflowStyle*/ctx[4]);attr(div1,"data-direction",/*scrollDirection*/ctx[1]);attr(div1,"data-state",/*containerState*/ctx[5]);},m(target,anchor){insert(target,div1,anchor);append(div1,div0);if(default_slot){default_slot.m(div0,null);}/*div1_binding*/ctx[39](div1);current=true;if(!mounted){dispose=[listen(div0,"interactionstart",/*handleDragStart*/ctx[9]),listen(div0,"interactionupdate",/*handleDragMove*/ctx[11]),listen(div0,"interactionend",/*handleDragEnd*/ctx[12]),listen(div0,"interactionrelease",/*handleDragRelease*/ctx[10]),action_destroyer(interactable.call(null,div0,{inertia:true})),listen(div0,"measure",/*measure_handler*/ctx[38]),action_destroyer(measurable.call(null,div0)),listen(div1,"wheel",/*handleWheel*/ctx[14],{passive:false}),listen(div1,"scroll",/*handleScroll*/ctx[16]),listen(div1,"focusin",/*handleFocus*/ctx[15]),listen(div1,"nudge",/*handleNudge*/ctx[17]),listen(div1,"measure",/*handleResizeScrollContainer*/ctx[13]),action_destroyer(measurable.call(null,div1,{observePosition:true})),action_destroyer(nudgeable_action=nudgeable.call(null,div1,{direction:/*scrollDirection*/ctx[1]==="x"?"horizontal":"vertical",stopKeydownPropagation:false}))];mounted=true;}},p(ctx,dirty){if(default_slot){if(default_slot.p&&dirty[1]&/*$$scope*/32){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[36],dirty,null,null);}}if(!current||dirty[0]&/*childStyle*/64){attr(div0,"style",/*childStyle*/ctx[6]);}if(!current||dirty[0]&/*klass*/1&&div1_class_value!==(div1_class_value=arrayJoin(["PinturaScrollable",/*klass*/ctx[0]]))){attr(div1,"class",div1_class_value);}if(!current||dirty[0]&/*overflowStyle*/16){attr(div1,"style",/*overflowStyle*/ctx[4]);}if(!current||dirty[0]&/*scrollDirection*/2){attr(div1,"data-direction",/*scrollDirection*/ctx[1]);}if(!current||dirty[0]&/*containerState*/32){attr(div1,"data-state",/*containerState*/ctx[5]);}if(nudgeable_action&&is_function(nudgeable_action.update)&&dirty[0]&/*scrollDirection*/2)nudgeable_action.update.call(null,{direction:/*scrollDirection*/ctx[1]==="x"?"horizontal":"vertical",stopKeydownPropagation:false});},i(local){if(current)return;transition_in(default_slot,local);current=true;},o(local){transition_out(default_slot,local);current=false;},d(detaching){if(detaching)detach(div1);if(default_slot)default_slot.d(detaching);/*div1_binding*/ctx[39](null);mounted=false;run_all(dispose);}};}function instance$G($$self,$$props,$$invalidate){let size;let axis;let containerStyle;let containerFeatherSize;let overflows;let containerState;let childStyle;let $scrollOffset;let $keysPressedStore;let{$$slots:slots={},$$scope}=$$props;const dispatch=createEventDispatcher();const keysPressedStore=getContext("keysPressed");component_subscribe($$self,keysPressedStore,value=>$$invalidate(46,$keysPressedStore=value));let scrollState="idle";let scrollOrigin;let scrollRect;let scrollContainerRect;let scrollReleased;let scrollOffset=spring(0);component_subscribe($$self,scrollOffset,value=>$$invalidate(34,$scrollOffset=value));let{class:klass=undefined}=$$props;let{scrollBlockInteractionDist=5}=$$props;let{scrollStep=10}=$$props;// the distance multiplier for each mouse scroll interaction (delta)
let{scrollFocusMargin=64}=$$props;// the margin used around elements to decided where to move the focus so elements are positioned into view with some spacing around them, this allows peaking at next/previous elements
let{scrollDirection="x"}=$$props;let{scrollAutoCancel=false}=$$props;let{elasticity=0}=$$props;let{onscroll=noop$1}=$$props;let{maskFeatherSize=undefined}=$$props;let{maskFeatherStartOpacity=undefined}=$$props;let{maskFeatherEndOpacity=undefined}=$$props;let{scroll=undefined}=$$props;// logic
let container;let overflowStyle="";// is scroll in reset state
let scrollAtRest=true;// triggers onscroll callback
scrollOffset.subscribe(value=>{const pos=vectorCreateEmpty();pos[scrollDirection]=value;onscroll(pos);});const limitOffsetToContainer=offset=>Math.max(Math.min(0,offset),scrollContainerRect[size]-scrollRect[size]);let scrollFirstMove;let scrollCancelled;let scrollTranslationPrev;const isHorizontalTranslation=translation=>{const velocity=vectorApply(vectorCreate(translation.x-scrollTranslationPrev.x,translation.y-scrollTranslationPrev.y),Math.abs);scrollTranslationPrev=vectorClone(translation);const speed=vectorDistanceSquared(velocity);const diff=velocity.x-velocity.y;return!(speed>1&&diff<-0.5);};const handleDragStart=()=>{// not overflowing so no need to handle
if(!overflows)return;scrollCancelled=false;scrollFirstMove=true;scrollTranslationPrev=vectorCreate(0,0);scrollReleased=false;$$invalidate(28,scrollState="idle");scrollOrigin=get_store_value(scrollOffset);};const handleDragRelease=({detail})=>{if(!overflows)return;scrollReleased=true;$$invalidate(28,scrollState="idle");};const handleDragMove=({detail})=>{if(!overflows)return;if(scrollCancelled)return;// fixes problem with single move event fired when clicking
if(scrollFirstMove){scrollFirstMove=false;if(vectorDistanceSquared(detail.translation)<0.1)return;}if(scrollAutoCancel&&scrollDirection==="x"&&!isHorizontalTranslation(detail.translation)){scrollCancelled=true;return;}setScrollOffset(scrollOrigin+detail.translation[scrollDirection],{elastic:true});};const handleDragEnd=({detail})=>{if(!overflows)return;if(scrollCancelled)return;const offset=scrollOrigin+detail.translation[scrollDirection];const offsetLimited=limitOffsetToContainer(offset);scrollAtRest=false;scrollOffset.set(offsetLimited).then(res=>{if(!scrollReleased)return;scrollAtRest=true;});};const handleResizeScrollContainer=({detail})=>{$$invalidate(29,scrollContainerRect=detail);dispatch("measure",{x:detail.x,y:detail.y,width:detail.width,height:detail.height});};const setScrollOffset=(offset,options={})=>{const{elastic=false,animate=false}=options;// prevents clicks on child elements if the container is being scrolled
if(Math.abs(offset)>scrollBlockInteractionDist&&scrollState==="idle"&&!scrollReleased){$$invalidate(28,scrollState="scrolling");}const offsetLimited=limitOffsetToContainer(offset);const offsetVisual=elastic&&elasticity&&!scrollReleased?offsetLimited+elastify(offset-offsetLimited,elasticity):offsetLimited;let snapToPosition=true;if(animate){snapToPosition=false;}else if(!scrollAtRest){snapToPosition=!scrollReleased;}scrollAtRest=false;scrollOffset.set(offsetVisual,{hard:snapToPosition}).then(res=>{if(!scrollReleased)return;scrollAtRest=true;});};const handleWheel=e=>{// don't do anything if isn't overflowing
if(!overflows)return;// scroll down -> move to right/down
// scroll up -> move to left/up
// don't run default actions, prevent other actions from running
e.preventDefault();e.stopPropagation();// apply wheel delta to offset
const delta=getWheelDelta(e);const offset=get_store_value(scrollOffset);setScrollOffset(offset+delta*scrollStep,{animate:true});};const handleFocus=e=>{// don't do anything if isn't overflowing
if(!overflows)return;// ignore this handler if is dragging
if(!scrollReleased&&!$keysPressedStore.length)return;let target=e.target;// when a target is marked as implicit we use its parent elemetn
if(e.target.classList.contains("implicit"))target=target.parentNode;// get bounds
const start=target[scrollDirection==="x"?"offsetLeft":"offsetTop"];//.offsetLeft;
const space=target[scrollDirection==="x"?"offsetWidth":"offsetHeight"];//.offsetWidth;
const end=start+space;// we need to know the current offset of the scroll so we can determine if the target is in view
const currentScrollOffset=get_store_value(scrollOffset);// the margin around elements to keep in mind when focussing items
const margin=scrollFocusMargin+maskFeatherSize;if(currentScrollOffset+start<margin){setScrollOffset(-start+margin);}else if(currentScrollOffset+end>scrollContainerRect[size]-margin){setScrollOffset(scrollContainerRect[size]-end-margin,{animate:true});}};const handleScroll=()=>{// the scroll handler corrects auto browser scroll,
// is triggered when browser tries to focus an
// element outside of the scrollcontiner
$$invalidate(3,container[scrollDirection==="x"?"scrollLeft":"scrollTop"]=0,container);};const handleNudge=({detail})=>{const delta=-2*detail[scrollDirection];const offset=get_store_value(scrollOffset);setScrollOffset(offset+delta*scrollStep,{animate:true});};const measure_handler=e=>$$invalidate(2,scrollRect=e.detail);function div1_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{container=$$value;$$invalidate(3,container);});}$$self.$$set=$$props=>{if("class"in $$props)$$invalidate(0,klass=$$props.class);if("scrollBlockInteractionDist"in $$props)$$invalidate(21,scrollBlockInteractionDist=$$props.scrollBlockInteractionDist);if("scrollStep"in $$props)$$invalidate(22,scrollStep=$$props.scrollStep);if("scrollFocusMargin"in $$props)$$invalidate(23,scrollFocusMargin=$$props.scrollFocusMargin);if("scrollDirection"in $$props)$$invalidate(1,scrollDirection=$$props.scrollDirection);if("scrollAutoCancel"in $$props)$$invalidate(24,scrollAutoCancel=$$props.scrollAutoCancel);if("elasticity"in $$props)$$invalidate(25,elasticity=$$props.elasticity);if("onscroll"in $$props)$$invalidate(26,onscroll=$$props.onscroll);if("maskFeatherSize"in $$props)$$invalidate(20,maskFeatherSize=$$props.maskFeatherSize);if("maskFeatherStartOpacity"in $$props)$$invalidate(18,maskFeatherStartOpacity=$$props.maskFeatherStartOpacity);if("maskFeatherEndOpacity"in $$props)$$invalidate(19,maskFeatherEndOpacity=$$props.maskFeatherEndOpacity);if("scroll"in $$props)$$invalidate(27,scroll=$$props.scroll);if("$$scope"in $$props)$$invalidate(36,$$scope=$$props.$$scope);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*scrollDirection*/2){$$invalidate(30,size=scrollDirection==="x"?"width":"height");}if($$self.$$.dirty[0]&/*scrollDirection*/2){$$invalidate(31,axis=scrollDirection.toUpperCase());}if($$self.$$.dirty[0]&/*container*/8){$$invalidate(32,containerStyle=container&&getComputedStyle(container));}if($$self.$$.dirty[0]&/*container*/8|$$self.$$.dirty[1]&/*containerStyle*/2){$$invalidate(33,containerFeatherSize=containerStyle&&unitToPixels(containerStyle.getPropertyValue("--scrollable-feather-size")));}if($$self.$$.dirty[0]&/*scrollContainerRect, scrollRect, size, maskFeatherStartOpacity, maskFeatherEndOpacity*/1611399172|$$self.$$.dirty[1]&/*$scrollOffset, containerFeatherSize*/12){if($scrollOffset!=null&&scrollContainerRect&&containerFeatherSize!=null&&scrollRect){const startOffset=-1*$scrollOffset/containerFeatherSize;const endOffset=-(scrollContainerRect[size]-scrollRect[size]-$scrollOffset)/containerFeatherSize;$$invalidate(18,maskFeatherStartOpacity=pintura_clamp(1-startOffset,0,1));$$invalidate(19,maskFeatherEndOpacity=pintura_clamp(1-endOffset,0,1));$$invalidate(20,maskFeatherSize=containerFeatherSize);$$invalidate(4,overflowStyle=`--scrollable-feather-start-opacity: ${maskFeatherStartOpacity};--scrollable-feather-end-opacity: ${maskFeatherEndOpacity}`);}}if($$self.$$.dirty[0]&/*container, scroll*/134217736){// update scroll position
if(container&&scroll!==undefined){if(pintura_isNumber(scroll))setScrollOffset(scroll);else setScrollOffset(scroll.scrollOffset,scroll);}}if($$self.$$.dirty[0]&/*scrollContainerRect, scrollRect, size*/1610612740){$$invalidate(35,overflows=scrollContainerRect&&scrollRect?scrollRect[size]>scrollContainerRect[size]:undefined);}if($$self.$$.dirty[0]&/*scrollState*/268435456|$$self.$$.dirty[1]&/*overflows*/16){$$invalidate(5,containerState=arrayJoin([scrollState,overflows?"overflows":undefined]));}if($$self.$$.dirty[1]&/*overflows, axis, $scrollOffset*/25){$$invalidate(6,childStyle=overflows?`transform: translate${axis}(${$scrollOffset}px)`:undefined);}};return[klass,scrollDirection,scrollRect,container,overflowStyle,containerState,childStyle,keysPressedStore,scrollOffset,handleDragStart,handleDragRelease,handleDragMove,handleDragEnd,handleResizeScrollContainer,handleWheel,handleFocus,handleScroll,handleNudge,maskFeatherStartOpacity,maskFeatherEndOpacity,maskFeatherSize,scrollBlockInteractionDist,scrollStep,scrollFocusMargin,scrollAutoCancel,elasticity,onscroll,scroll,scrollState,scrollContainerRect,size,axis,containerStyle,containerFeatherSize,$scrollOffset,overflows,$$scope,slots,measure_handler,div1_binding];}class Scrollable extends SvelteComponent{constructor(options){super();init(this,options,instance$G,create_fragment$G,safe_not_equal,{class:0,scrollBlockInteractionDist:21,scrollStep:22,scrollFocusMargin:23,scrollDirection:1,scrollAutoCancel:24,elasticity:25,onscroll:26,maskFeatherSize:20,maskFeatherStartOpacity:18,maskFeatherEndOpacity:19,scroll:27},[-1,-1]);}}function fade$1(node,{delay=0,duration=400,easing=identity}={}){const o=+getComputedStyle(node).opacity;return{delay,duration,easing,css:t=>`opacity: ${t*o}`};}/* src/core/ui/components/StatusMessage.svelte generated by Svelte v3.37.0 */function create_fragment$F(ctx){let span;let t;let span_transition;let current;let mounted;let dispose;return{c(){span=pintura_element("span");t=pintura_text(/*text*/ctx[0]);attr(span,"class","PinturaStatusMessage");},m(target,anchor){insert(target,span,anchor);append(span,t);current=true;if(!mounted){dispose=[listen(span,"measure",function(){if(is_function(/*onmeasure*/ctx[1]))/*onmeasure*/ctx[1].apply(this,arguments);}),action_destroyer(measurable.call(null,span))];mounted=true;}},p(new_ctx,[dirty]){ctx=new_ctx;if(!current||dirty&/*text*/1)set_data(t,/*text*/ctx[0]);},i(local){if(current)return;add_render_callback(()=>{if(!span_transition)span_transition=create_bidirectional_transition(span,fade$1,{},true);span_transition.run(1);});current=true;},o(local){if(!span_transition)span_transition=create_bidirectional_transition(span,fade$1,{},false);span_transition.run(0);current=false;},d(detaching){if(detaching)detach(span);if(detaching&&span_transition)span_transition.end();mounted=false;run_all(dispose);}};}function instance$F($$self,$$props,$$invalidate){let{text}=$$props;let{onmeasure=noop$1}=$$props;$$self.$$set=$$props=>{if("text"in $$props)$$invalidate(0,text=$$props.text);if("onmeasure"in $$props)$$invalidate(1,onmeasure=$$props.onmeasure);};return[text,onmeasure];}class StatusMessage extends SvelteComponent{constructor(options){super();init(this,options,instance$F,create_fragment$F,safe_not_equal,{text:0,onmeasure:1});}}/* src/core/ui/components/ProgressIndicator.svelte generated by Svelte v3.37.0 */function create_fragment$E(ctx){let span1;let svg;let g;let circle0;let circle1;let t0;let span0;let t1;return{c(){span1=pintura_element("span");svg=svg_element("svg");g=svg_element("g");circle0=svg_element("circle");circle1=svg_element("circle");t0=space();span0=pintura_element("span");t1=pintura_text(/*formattedValue*/ctx[0]);attr(circle0,"class","PinturaProgressIndicatorBar");attr(circle0,"r","8.5");attr(circle0,"cx","10");attr(circle0,"cy","10");attr(circle0,"stroke-linecap","round");attr(circle0,"opacity",".25");attr(circle1,"class","PinturaProgressIndicatorFill");attr(circle1,"r","8.5");attr(circle1,"stroke-dasharray",/*circleValue*/ctx[1]);attr(circle1,"cx","10");attr(circle1,"cy","10");attr(circle1,"transform","rotate(-90) translate(-20)");attr(g,"fill","none");attr(g,"stroke","currentColor");attr(g,"stroke-width","2.5");attr(g,"stroke-linecap","round");attr(g,"opacity",/*circleOpacity*/ctx[2]);attr(svg,"width","20");attr(svg,"height","20");attr(svg,"viewBox","0 0 20 20");attr(svg,"xmlns","http://www.w3.org/2000/svg");attr(svg,"aria-hidden","true");attr(svg,"focusable","false");attr(span0,"class","implicit");attr(span1,"class","PinturaProgressIndicator");attr(span1,"data-status",/*status*/ctx[3]);},m(target,anchor){insert(target,span1,anchor);append(span1,svg);append(svg,g);append(g,circle0);append(g,circle1);append(span1,t0);append(span1,span0);append(span0,t1);},p(ctx,[dirty]){if(dirty&/*circleValue*/2){attr(circle1,"stroke-dasharray",/*circleValue*/ctx[1]);}if(dirty&/*circleOpacity*/4){attr(g,"opacity",/*circleOpacity*/ctx[2]);}if(dirty&/*formattedValue*/1)set_data(t1,/*formattedValue*/ctx[0]);if(dirty&/*status*/8){attr(span1,"data-status",/*status*/ctx[3]);}},i:pintura_noop,o:pintura_noop,d(detaching){if(detaching)detach(span1);}};}function instance$E($$self,$$props,$$invalidate){let formattedValue;let circleValue;let circleOpacity;let status;let $animatedProgressClamped;const dispatch=createEventDispatcher();let{progress}=$$props;let{min=0}=$$props;let{max=100}=$$props;let{labelBusy="Busy"}=$$props;const animatedValue=spring(0,{precision:0.01});const animatedProgressClamped=derived([animatedValue],$animatedValue=>pintura_clamp($animatedValue,min,max));component_subscribe($$self,animatedProgressClamped,value=>$$invalidate(9,$animatedProgressClamped=value));animatedProgressClamped.subscribe(value=>{if(progress===1&&Math.round(value)>=100)dispatch("complete");});$$self.$$set=$$props=>{if("progress"in $$props)$$invalidate(5,progress=$$props.progress);if("min"in $$props)$$invalidate(6,min=$$props.min);if("max"in $$props)$$invalidate(7,max=$$props.max);if("labelBusy"in $$props)$$invalidate(8,labelBusy=$$props.labelBusy);};$$self.$$.update=()=>{if($$self.$$.dirty&/*progress*/32){progress&&progress!==Infinity&&animatedValue.set(progress*100);}if($$self.$$.dirty&/*progress, labelBusy, $animatedProgressClamped*/800){$$invalidate(0,formattedValue=progress===Infinity?labelBusy:`${Math.round($animatedProgressClamped)}%`);}if($$self.$$.dirty&/*progress, $animatedProgressClamped*/544){$$invalidate(1,circleValue=progress===Infinity?"26.5 53":`${$animatedProgressClamped/100*53} 53`);}if($$self.$$.dirty&/*progress, $animatedProgressClamped*/544){$$invalidate(2,circleOpacity=Math.min(1,progress===Infinity?1:$animatedProgressClamped/10));}if($$self.$$.dirty&/*progress*/32){$$invalidate(3,status=progress===Infinity?"busy":"loading");}};return[formattedValue,circleValue,circleOpacity,status,animatedProgressClamped,progress,min,max,labelBusy,$animatedProgressClamped];}class ProgressIndicator extends SvelteComponent{constructor(options){super();init(this,options,instance$E,create_fragment$E,safe_not_equal,{progress:5,min:6,max:7,labelBusy:8});}}/* src/core/ui/components/StatusAside.svelte generated by Svelte v3.37.0 */function create_fragment$D(ctx){let span;let span_class_value;let current;const default_slot_template=/*#slots*/ctx[5].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[4],null);return{c(){span=pintura_element("span");if(default_slot)default_slot.c();attr(span,"class",span_class_value=`PinturaStatusAside ${/*klass*/ctx[0]}`);attr(span,"style",/*style*/ctx[1]);},m(target,anchor){insert(target,span,anchor);if(default_slot){default_slot.m(span,null);}current=true;},p(ctx,[dirty]){if(default_slot){if(default_slot.p&&dirty&/*$$scope*/16){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[4],dirty,null,null);}}if(!current||dirty&/*klass*/1&&span_class_value!==(span_class_value=`PinturaStatusAside ${/*klass*/ctx[0]}`)){attr(span,"class",span_class_value);}if(!current||dirty&/*style*/2){attr(span,"style",/*style*/ctx[1]);}},i(local){if(current)return;transition_in(default_slot,local);current=true;},o(local){transition_out(default_slot,local);current=false;},d(detaching){if(detaching)detach(span);if(default_slot)default_slot.d(detaching);}};}function instance$D($$self,$$props,$$invalidate){let style;let{$$slots:slots={},$$scope}=$$props;let{offset=0}=$$props;let{opacity=0}=$$props;let{class:klass=undefined}=$$props;$$self.$$set=$$props=>{if("offset"in $$props)$$invalidate(2,offset=$$props.offset);if("opacity"in $$props)$$invalidate(3,opacity=$$props.opacity);if("class"in $$props)$$invalidate(0,klass=$$props.class);if("$$scope"in $$props)$$invalidate(4,$$scope=$$props.$$scope);};$$self.$$.update=()=>{if($$self.$$.dirty&/*offset, opacity*/12){$$invalidate(1,style=`transform:translateX(${offset}px);opacity:${opacity}`);}};return[klass,style,offset,opacity,$$scope,slots];}class StatusAside extends SvelteComponent{constructor(options){super();init(this,options,instance$D,create_fragment$D,safe_not_equal,{offset:2,opacity:3,class:0});}}/* src/core/ui/components/Tag.svelte generated by Svelte v3.37.0 */function create_if_block_2$9(ctx){let label;let label_for_value;let current;const default_slot_template=/*#slots*/ctx[3].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[2],null);let label_levels=[{for:label_for_value="_"},/*attributes*/ctx[1]];let label_data={};for(let i=0;i<label_levels.length;i+=1){label_data=pintura_assign(label_data,label_levels[i]);}return{c(){label=pintura_element("label");if(default_slot)default_slot.c();set_attributes(label,label_data);},m(target,anchor){insert(target,label,anchor);if(default_slot){default_slot.m(label,null);}current=true;},p(ctx,dirty){if(default_slot){if(default_slot.p&&dirty&/*$$scope*/4){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[2],dirty,null,null);}}set_attributes(label,label_data=get_spread_update(label_levels,[{for:label_for_value},dirty&/*attributes*/2&&/*attributes*/ctx[1]]));},i(local){if(current)return;transition_in(default_slot,local);current=true;},o(local){transition_out(default_slot,local);current=false;},d(detaching){if(detaching)detach(label);if(default_slot)default_slot.d(detaching);}};}// (12:26) 
function create_if_block_1$c(ctx){let div;let current;const default_slot_template=/*#slots*/ctx[3].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[2],null);let div_levels=[/*attributes*/ctx[1]];let div_data={};for(let i=0;i<div_levels.length;i+=1){div_data=pintura_assign(div_data,div_levels[i]);}return{c(){div=pintura_element("div");if(default_slot)default_slot.c();set_attributes(div,div_data);},m(target,anchor){insert(target,div,anchor);if(default_slot){default_slot.m(div,null);}current=true;},p(ctx,dirty){if(default_slot){if(default_slot.p&&dirty&/*$$scope*/4){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[2],dirty,null,null);}}set_attributes(div,div_data=get_spread_update(div_levels,[dirty&/*attributes*/2&&/*attributes*/ctx[1]]));},i(local){if(current)return;transition_in(default_slot,local);current=true;},o(local){transition_out(default_slot,local);current=false;},d(detaching){if(detaching)detach(div);if(default_slot)default_slot.d(detaching);}};}// (8:0) {#if name === 'div'}
function create_if_block$b(ctx){let div;let current;const default_slot_template=/*#slots*/ctx[3].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[2],null);let div_levels=[/*attributes*/ctx[1]];let div_data={};for(let i=0;i<div_levels.length;i+=1){div_data=pintura_assign(div_data,div_levels[i]);}return{c(){div=pintura_element("div");if(default_slot)default_slot.c();set_attributes(div,div_data);},m(target,anchor){insert(target,div,anchor);if(default_slot){default_slot.m(div,null);}current=true;},p(ctx,dirty){if(default_slot){if(default_slot.p&&dirty&/*$$scope*/4){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[2],dirty,null,null);}}set_attributes(div,div_data=get_spread_update(div_levels,[dirty&/*attributes*/2&&/*attributes*/ctx[1]]));},i(local){if(current)return;transition_in(default_slot,local);current=true;},o(local){transition_out(default_slot,local);current=false;},d(detaching){if(detaching)detach(div);if(default_slot)default_slot.d(detaching);}};}function create_fragment$C(ctx){let current_block_type_index;let if_block;let if_block_anchor;let current;const if_block_creators=[create_if_block$b,create_if_block_1$c,create_if_block_2$9];const if_blocks=[];function select_block_type(ctx,dirty){if(/*name*/ctx[0]==="div")return 0;if(/*name*/ctx[0]==="span")return 1;if(/*name*/ctx[0]==="label")return 2;return-1;}if(~(current_block_type_index=select_block_type(ctx))){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);}return{c(){if(if_block)if_block.c();if_block_anchor=empty();},m(target,anchor){if(~current_block_type_index){if_blocks[current_block_type_index].m(target,anchor);}insert(target,if_block_anchor,anchor);current=true;},p(ctx,[dirty]){let previous_block_index=current_block_type_index;current_block_type_index=select_block_type(ctx);if(current_block_type_index===previous_block_index){if(~current_block_type_index){if_blocks[current_block_type_index].p(ctx,dirty);}}else{if(if_block){group_outros();transition_out(if_blocks[previous_block_index],1,1,()=>{if_blocks[previous_block_index]=null;});check_outros();}if(~current_block_type_index){if_block=if_blocks[current_block_type_index];if(!if_block){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);if_block.c();}else{if_block.p(ctx,dirty);}transition_in(if_block,1);if_block.m(if_block_anchor.parentNode,if_block_anchor);}else{if_block=null;}}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(~current_block_type_index){if_blocks[current_block_type_index].d(detaching);}if(detaching)detach(if_block_anchor);}};}function instance$C($$self,$$props,$$invalidate){let{$$slots:slots={},$$scope}=$$props;let{name="div"}=$$props;let{attributes={}}=$$props;$$self.$$set=$$props=>{if("name"in $$props)$$invalidate(0,name=$$props.name);if("attributes"in $$props)$$invalidate(1,attributes=$$props.attributes);if("$$scope"in $$props)$$invalidate(2,$$scope=$$props.$$scope);};return[name,attributes,$$scope,slots];}class Tag extends SvelteComponent{constructor(options){super();init(this,options,instance$C,create_fragment$C,safe_not_equal,{name:0,attributes:1});}}var getDevicePixelRatio=()=>isBrowser()&&window.devicePixelRatio||1;// if this is a non retina display snap to pixel
let fn=null;var snapToPixel=v=>{if(fn===null)fn=getDevicePixelRatio()===1?v=>Math.round(v):v=>v;return fn(v);};/* src/core/ui/components/Details.svelte generated by Svelte v3.37.0 */const get_details_slot_changes=dirty=>({});const get_details_slot_context=ctx=>({});const get_label_slot_changes=dirty=>({});const get_label_slot_context=ctx=>({});// (177:0) <Button     bind:this={buttonComponent}     class={arrayJoin(['PinturaDetailsButton', buttonClass])}     onkeydown={handleButtonKeydown}     onclick={handleClick} >
function create_default_slot$g(ctx){let current;const label_slot_template=/*#slots*/ctx[35].label;const label_slot=create_slot(label_slot_template,ctx,/*$$scope*/ctx[39],get_label_slot_context);return{c(){if(label_slot)label_slot.c();},m(target,anchor){if(label_slot){label_slot.m(target,anchor);}current=true;},p(ctx,dirty){if(label_slot){if(label_slot.p&&dirty[1]&/*$$scope*/256){update_slot(label_slot,label_slot_template,ctx,/*$$scope*/ctx[39],dirty,get_label_slot_changes,get_label_slot_context);}}},i(local){if(current)return;transition_in(label_slot,local);current=true;},o(local){transition_out(label_slot,local);current=false;},d(detaching){if(label_slot)label_slot.d(detaching);}};}// (186:0) {#if isVisible}
function create_if_block_1$b(ctx){let div;let t;let span;let div_class_value;let current;let mounted;let dispose;const details_slot_template=/*#slots*/ctx[35].details;const details_slot=create_slot(details_slot_template,ctx,/*$$scope*/ctx[39],get_details_slot_context);return{c(){div=pintura_element("div");if(details_slot)details_slot.c();t=space();span=pintura_element("span");attr(span,"class","PinturaDetailsPanelTip");attr(span,"style",/*tipStyle*/ctx[7]);attr(div,"class",div_class_value=arrayJoin(["PinturaDetailsPanel",/*panelClass*/ctx[1]]));attr(div,"tabindex","-1");attr(div,"style",/*style*/ctx[6]);},m(target,anchor){insert(target,div,anchor);if(details_slot){details_slot.m(div,null);}append(div,t);append(div,span);/*div_binding*/ctx[37](div);current=true;if(!mounted){dispose=[listen(div,"keydown",/*handlePanelKeydown*/ctx[17]),listen(div,"measure",/*measure_handler*/ctx[38]),action_destroyer(measurable.call(null,div))];mounted=true;}},p(ctx,dirty){if(details_slot){if(details_slot.p&&dirty[1]&/*$$scope*/256){update_slot(details_slot,details_slot_template,ctx,/*$$scope*/ctx[39],dirty,get_details_slot_changes,get_details_slot_context);}}if(!current||dirty[0]&/*tipStyle*/128){attr(span,"style",/*tipStyle*/ctx[7]);}if(!current||dirty[0]&/*panelClass*/2&&div_class_value!==(div_class_value=arrayJoin(["PinturaDetailsPanel",/*panelClass*/ctx[1]]))){attr(div,"class",div_class_value);}if(!current||dirty[0]&/*style*/64){attr(div,"style",/*style*/ctx[6]);}},i(local){if(current)return;transition_in(details_slot,local);current=true;},o(local){transition_out(details_slot,local);current=false;},d(detaching){if(detaching)detach(div);if(details_slot)details_slot.d(detaching);/*div_binding*/ctx[37](null);mounted=false;run_all(dispose);}};}function create_fragment$B(ctx){let t0;let button;let t1;let t2;let if_block1_anchor;let current;let mounted;let dispose;let button_props={class:arrayJoin(["PinturaDetailsButton",/*buttonClass*/ctx[0]]),onkeydown:/*handleButtonKeydown*/ctx[16],onclick:/*handleClick*/ctx[15],$$slots:{default:[create_default_slot$g]},$$scope:{ctx}};button=new Button({props:button_props});/*button_binding*/ctx[36](button);let if_block0=/*isVisible*/ctx[5]&&create_if_block_1$b(ctx);let if_block1=false;return{c(){t0=space();create_component(button.$$.fragment);t1=space();if(if_block0)if_block0.c();t2=space();if_block1_anchor=empty();},m(target,anchor){insert(target,t0,anchor);mount_component(button,target,anchor);insert(target,t1,anchor);if(if_block0)if_block0.m(target,anchor);insert(target,t2,anchor);insert(target,if_block1_anchor,anchor);current=true;if(!mounted){dispose=[listen(document.body,"pointerdown",function(){if(is_function(/*handleDown*/ctx[8]))/*handleDown*/ctx[8].apply(this,arguments);}),listen(document.body,"pointerup",function(){if(is_function(/*handleUp*/ctx[9]))/*handleUp*/ctx[9].apply(this,arguments);})];mounted=true;}},p(new_ctx,dirty){ctx=new_ctx;const button_changes={};if(dirty[0]&/*buttonClass*/1)button_changes.class=arrayJoin(["PinturaDetailsButton",/*buttonClass*/ctx[0]]);if(dirty[1]&/*$$scope*/256){button_changes.$$scope={dirty,ctx};}button.$set(button_changes);if(/*isVisible*/ctx[5]){if(if_block0){if_block0.p(ctx,dirty);if(dirty[0]&/*isVisible*/32){transition_in(if_block0,1);}}else{if_block0=create_if_block_1$b(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(t2.parentNode,t2);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}},i(local){if(current)return;transition_in(button.$$.fragment,local);transition_in(if_block0);transition_in(if_block1);current=true;},o(local){transition_out(button.$$.fragment,local);transition_out(if_block0);transition_out(if_block1);current=false;},d(detaching){if(detaching)detach(t0);/*button_binding*/ctx[36](null);destroy_component(button,detaching);if(detaching)detach(t1);if(if_block0)if_block0.d(detaching);if(detaching)detach(t2);if(detaching)detach(if_block1_anchor);mounted=false;run_all(dispose);}};}let panelMargin=12;function instance$B($$self,$$props,$$invalidate){let buttonElement;let offsetProgress;let isVisible;let isAnimating;let transform;let style;let tipScale;let tipOpacity;let tipStyle;let handleDown;let handleUp;let $offset;let $portalRootRect;let $position;let $opacity;let $portal;let{$$slots:slots={},$$scope}=$$props;let{buttonClass=undefined}=$$props;let{panelClass=undefined}=$$props;let{isActive=false}=$$props;let{onshow=({panel})=>panel.focus()}=$$props;const portal=getContext("rootPortal");component_subscribe($$self,portal,value=>$$invalidate(34,$portal=value));const portalRootRect=getContext("rootRect");component_subscribe($$self,portalRootRect,value=>$$invalidate(27,$portalRootRect=value));let panelSize;let buttonComponent;let buttonRect;let dir=vectorCreateEmpty();let opacity=spring(0);component_subscribe($$self,opacity,value=>$$invalidate(29,$opacity=value));let shift=vectorCreateEmpty();const position=writable({x:0,y:0});component_subscribe($$self,position,value=>$$invalidate(28,$position=value));const offset=spring(-5,{stiffness:0.1,damping:0.35,precision:0.001});component_subscribe($$self,offset,value=>$$invalidate(26,$offset=value));const isTargetSelf=e=>isEventTarget(e,$portal)||buttonComponent.isEventTarget(e);let downOutsidePanel=false;// move detail panel to portal
let detailPanel;let trigger;// test keydown press to open
const handleClick=e=>{if(!isActive)$$invalidate(20,buttonRect=buttonElement.getBoundingClientRect());$$invalidate(24,trigger=e);$$invalidate(18,isActive=!isActive);};const handleButtonKeydown=e=>{if(!/down/i.test(e.key))return;$$invalidate(18,isActive=true);$$invalidate(24,trigger=e);};const handlePanelKeydown=e=>{if(!/esc/i.test(e.key))return;$$invalidate(18,isActive=false);buttonElement.focus();};// clean up panel if it was appended to a portal
onDestroy(()=>{if(!$portal||!detailPanel||detailPanel.parentNode)return;$portal.removeChild(detailPanel);});function button_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{buttonComponent=$$value;$$invalidate(3,buttonComponent);});}function div_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{detailPanel=$$value;$$invalidate(4,detailPanel);});}const measure_handler=e=>$$invalidate(2,panelSize=sizeCreateFromAny(e.detail));$$self.$$set=$$props=>{if("buttonClass"in $$props)$$invalidate(0,buttonClass=$$props.buttonClass);if("panelClass"in $$props)$$invalidate(1,panelClass=$$props.panelClass);if("isActive"in $$props)$$invalidate(18,isActive=$$props.isActive);if("onshow"in $$props)$$invalidate(19,onshow=$$props.onshow);if("$$scope"in $$props)$$invalidate(39,$$scope=$$props.$$scope);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*buttonComponent*/8){buttonElement=buttonComponent&&buttonComponent.getElement();}if($$self.$$.dirty[0]&/*isActive, downOutsidePanel*/8650752){$$invalidate(9,handleUp=isActive?e=>{if(!downOutsidePanel)return;$$invalidate(23,downOutsidePanel=false);if(isTargetSelf(e))return;$$invalidate(18,isActive=false);}:undefined);}if($$self.$$.dirty[0]&/*isActive*/262144){opacity.set(isActive?1:0);}if($$self.$$.dirty[0]&/*isActive*/262144){offset.set(isActive?0:-5);}if($$self.$$.dirty[0]&/*$offset*/67108864){$$invalidate(25,offsetProgress=1-$offset/-5);}if($$self.$$.dirty[0]&/*$portalRootRect, panelSize, buttonRect*/135266308){if($portalRootRect&&panelSize&&buttonRect){// as a starting point we'll align panel to center of button and position below
let x=buttonRect.x-$portalRootRect.x+buttonRect.width*0.5-panelSize.width*0.5;let y=buttonRect.y-$portalRootRect.y+buttonRect.height;const parentLeft=panelMargin;const parentTop=panelMargin;const parentRight=$portalRootRect.width-panelMargin;const parentBottom=$portalRootRect.height-panelMargin;const panelLeft=x;const panelTop=y;const panelRight=panelLeft+panelSize.width;const panelBottom=panelTop+panelSize.height;// move to right
if(panelLeft<parentLeft){$$invalidate(22,shift.x=panelLeft-parentLeft,shift);x=parentLeft;}// move to left
if(panelRight>parentRight){$$invalidate(22,shift.x=panelRight-parentRight,shift);x=parentRight-panelSize.width;}if(panelBottom>parentBottom){// doesn't fit vertically, push up
$$invalidate(21,dir.y=-1,dir);const positionedAboveButtonY=y-panelSize.height-buttonRect.height;const panelFitsAboveButton=parentTop<positionedAboveButtonY;if(panelFitsAboveButton){$$invalidate(22,shift.y=0,shift);y-=panelSize.height+buttonRect.height;}else{// overlap with button
$$invalidate(22,shift.y=y-(panelBottom-parentBottom),shift);y-=panelBottom-parentBottom;}}else{// all is fine
$$invalidate(21,dir.y=1,dir);}set_store_value(position,$position=vectorApply(vectorCreate(x,y),snapToPixel),$position);}}if($$self.$$.dirty[0]&/*$opacity*/536870912){$$invalidate(5,isVisible=$opacity>0);}if($$self.$$.dirty[0]&/*$opacity*/536870912){$$invalidate(30,isAnimating=$opacity<1);}if($$self.$$.dirty[0]&/*$position, dir, $offset*/337641472){$$invalidate(31,transform=`translateX(${$position.x+dir.x*panelMargin}px) translateY(${$position.y+dir.y*panelMargin+dir.y*$offset}px)`);}if($$self.$$.dirty[0]&/*isAnimating, $opacity*/1610612736|$$self.$$.dirty[1]&/*transform*/1){$$invalidate(6,style=isAnimating?`opacity: ${$opacity}; pointer-events: ${$opacity<1?"none":"all"}; transform: ${transform};`:`transform: ${transform}`);}if($$self.$$.dirty[0]&/*offsetProgress*/33554432){$$invalidate(32,tipScale=0.5+offsetProgress*0.5);}if($$self.$$.dirty[0]&/*offsetProgress*/33554432){$$invalidate(33,tipOpacity=offsetProgress);}if($$self.$$.dirty[0]&/*$position, panelSize, dir, shift*/274726916|$$self.$$.dirty[1]&/*tipOpacity, tipScale*/6){$$invalidate(7,tipStyle=$position&&panelSize&&`opacity:${tipOpacity};transform:scaleX(${tipScale})rotate(45deg);top:${dir.y<0?shift.y+panelSize.height:0}px;left:${shift.x+panelSize.width*0.5}px`);}if($$self.$$.dirty[0]&/*isActive*/262144){$$invalidate(8,handleDown=isActive?e=>{if(isTargetSelf(e))return;$$invalidate(23,downOutsidePanel=true);}:undefined);}if($$self.$$.dirty[0]&/*isVisible, detailPanel*/48|$$self.$$.dirty[1]&/*$portal*/8){if(isVisible&&$portal&&detailPanel&&detailPanel.parentNode!==$portal)$portal.appendChild(detailPanel);}if($$self.$$.dirty[0]&/*isActive*/262144){if(!isActive)$$invalidate(24,trigger=undefined);}if($$self.$$.dirty[0]&/*isVisible, detailPanel, onshow, trigger*/17301552){if(isVisible&&detailPanel)onshow({e:trigger,panel:detailPanel});}};return[buttonClass,panelClass,panelSize,buttonComponent,detailPanel,isVisible,style,tipStyle,handleDown,handleUp,portal,portalRootRect,opacity,position,offset,handleClick,handleButtonKeydown,handlePanelKeydown,isActive,onshow,buttonRect,dir,shift,downOutsidePanel,trigger,offsetProgress,$offset,$portalRootRect,$position,$opacity,isAnimating,transform,tipScale,tipOpacity,$portal,slots,button_binding,div_binding,measure_handler,$$scope];}class Details extends SvelteComponent{constructor(options){super();init(this,options,instance$B,create_fragment$B,safe_not_equal,{buttonClass:0,panelClass:1,isActive:18,onshow:19},[-1,-1]);}}/* src/core/ui/components/RadioItem.svelte generated by Svelte v3.37.0 */function create_fragment$A(ctx){let li;let input;let t;let label_1;let li_class_value;let current;let mounted;let dispose;const default_slot_template=/*#slots*/ctx[14].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[13],null);return{c(){li=pintura_element("li");input=pintura_element("input");t=space();label_1=pintura_element("label");if(default_slot)default_slot.c();attr(input,"type","radio");attr(input,"class","implicit");attr(input,"id",/*inputId*/ctx[6]);attr(input,"name",/*name*/ctx[0]);input.value=/*value*/ctx[3];input.disabled=/*disabled*/ctx[5];input.checked=/*checked*/ctx[4];attr(label_1,"for",/*inputId*/ctx[6]);attr(label_1,"title",/*label*/ctx[2]);attr(li,"class",li_class_value=arrayJoin(["PinturaRadioGroupOption",/*klass*/ctx[1]]));attr(li,"data-disabled",/*disabled*/ctx[5]);attr(li,"data-selected",/*checked*/ctx[4]);},m(target,anchor){insert(target,li,anchor);append(li,input);append(li,t);append(li,label_1);if(default_slot){default_slot.m(label_1,null);}current=true;if(!mounted){dispose=[listen(input,"change",stop_propagation(/*change_handler*/ctx[15])),listen(input,"keydown",/*handleKeydown*/ctx[8]),listen(input,"click",/*handleClick*/ctx[9])];mounted=true;}},p(ctx,[dirty]){if(!current||dirty&/*inputId*/64){attr(input,"id",/*inputId*/ctx[6]);}if(!current||dirty&/*name*/1){attr(input,"name",/*name*/ctx[0]);}if(!current||dirty&/*value*/8){input.value=/*value*/ctx[3];}if(!current||dirty&/*disabled*/32){input.disabled=/*disabled*/ctx[5];}if(!current||dirty&/*checked*/16){input.checked=/*checked*/ctx[4];}if(default_slot){if(default_slot.p&&dirty&/*$$scope*/8192){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[13],dirty,null,null);}}if(!current||dirty&/*inputId*/64){attr(label_1,"for",/*inputId*/ctx[6]);}if(!current||dirty&/*label*/4){attr(label_1,"title",/*label*/ctx[2]);}if(!current||dirty&/*klass*/2&&li_class_value!==(li_class_value=arrayJoin(["PinturaRadioGroupOption",/*klass*/ctx[1]]))){attr(li,"class",li_class_value);}if(!current||dirty&/*disabled*/32){attr(li,"data-disabled",/*disabled*/ctx[5]);}if(!current||dirty&/*checked*/16){attr(li,"data-selected",/*checked*/ctx[4]);}},i(local){if(current)return;transition_in(default_slot,local);current=true;},o(local){transition_out(default_slot,local);current=false;},d(detaching){if(detaching)detach(li);if(default_slot)default_slot.d(detaching);mounted=false;run_all(dispose);}};}function instance$A($$self,$$props,$$invalidate){let inputId;let $keysPressedStored;let{$$slots:slots={},$$scope}=$$props;let{name}=$$props;let{class:klass=undefined}=$$props;let{label}=$$props;let{id}=$$props;let{value}=$$props;let{checked}=$$props;let{onkeydown}=$$props;let{onclick}=$$props;let{disabled=false}=$$props;const keysPressedStored=getContext("keysPressed");component_subscribe($$self,keysPressedStored,value=>$$invalidate(16,$keysPressedStored=value));const handleKeydown=e=>{onkeydown(e);};const handleClick=e=>{if($keysPressedStored.length)return;onclick(e);};function change_handler(event){bubble($$self,event);}$$self.$$set=$$props=>{if("name"in $$props)$$invalidate(0,name=$$props.name);if("class"in $$props)$$invalidate(1,klass=$$props.class);if("label"in $$props)$$invalidate(2,label=$$props.label);if("id"in $$props)$$invalidate(10,id=$$props.id);if("value"in $$props)$$invalidate(3,value=$$props.value);if("checked"in $$props)$$invalidate(4,checked=$$props.checked);if("onkeydown"in $$props)$$invalidate(11,onkeydown=$$props.onkeydown);if("onclick"in $$props)$$invalidate(12,onclick=$$props.onclick);if("disabled"in $$props)$$invalidate(5,disabled=$$props.disabled);if("$$scope"in $$props)$$invalidate(13,$$scope=$$props.$$scope);};$$self.$$.update=()=>{if($$self.$$.dirty&/*name, id*/1025){$$invalidate(6,inputId=`${name}-${id}`);}};return[name,klass,label,value,checked,disabled,inputId,keysPressedStored,handleKeydown,handleClick,id,onkeydown,onclick,$$scope,slots,change_handler];}class RadioItem extends SvelteComponent{constructor(options){super();init(this,options,instance$A,create_fragment$A,safe_not_equal,{name:0,class:1,label:2,id:10,value:3,checked:4,onkeydown:11,onclick:12,disabled:5});}}var flattenOptions=(options=[])=>options.reduce((prev,current)=>{const isGroup=pintura_isArray(current)?pintura_isArray(current[1]):!!current.options;if(isGroup){return prev.concat(pintura_isArray(current)?current[1]:current.options);}prev.push(current);return prev;},[]);const mapOption=(option,index,optionMapper)=>{let mappedOption;if(pintura_isArray(option)){mappedOption={id:index,value:option[0],label:option[1],...(option[2]||{})};}else{mappedOption=option;mappedOption.id=mappedOption.id!=null?mappedOption.id:index;}return optionMapper?optionMapper(mappedOption):mappedOption;};var mapOptions=(options=[],optionMapper)=>{let index=0;return options.map(option=>{index++;if(pintura_isArray(option)){// is either [label, options] or [value, label]
if(pintura_isArray(option[1])){return{id:index,label:option[0],options:option[1].map(option=>mapOption(option,++index,optionMapper))};}return mapOption(option,index,optionMapper);}else{// is either { id?, label, options } or { id?, value, label }
if(option.options){return{id:option.id||index,label:option.label,options:option.options.map(option=>mapOption(option,++index,optionMapper))};}return mapOption(option,index,optionMapper);}});};var opop=(fn,...args)=>fn&&fn(...args);var localize=(prop,locale,params)=>pintura_isFunction(prop)?prop(locale,params):prop;const localizeOptions=(options,locale)=>options.map(([value,label,props])=>{if(pintura_isArray(label)){return[localize(value,locale),localizeOptions(label,locale)];}else{const res=[value,localize(label,locale)];if(props){let obj={...props};if(props.icon)obj.icon=localize(props.icon,locale);res.push(obj);}return res;}});var localizeOptions$1=(options,locale)=>localizeOptions(options,locale);var isConfirmKey=key=>/enter| /i.test(key);/* src/core/ui/components/RadioGroup.svelte generated by Svelte v3.37.0 */function get_each_context$7(ctx,list,i){const child_ctx=ctx.slice();child_ctx[26]=list[i];return child_ctx;}const get_option_slot_changes_1=dirty=>({option:dirty&/*mappedOptions*/2048});const get_option_slot_context_1=ctx=>({option:/*option*/ctx[26]});function get_each_context_1(ctx,list,i){const child_ctx=ctx.slice();child_ctx[26]=list[i];return child_ctx;}const get_option_slot_changes=dirty=>({option:dirty&/*mappedOptions*/2048});const get_option_slot_context=ctx=>({option:/*option*/ctx[26]});const get_group_slot_changes=dirty=>({option:dirty&/*mappedOptions*/2048});const get_group_slot_context=ctx=>({option:/*option*/ctx[26]});// (71:0) {#if localizedOptions.length}
function create_if_block_1$a(ctx){let fieldset;let t;let ul;let each_blocks=[];let each_1_lookup=new Map();let fieldset_class_value;let current;let if_block=/*label*/ctx[1]&&create_if_block_7$1(ctx);let each_value=/*mappedOptions*/ctx[11];const get_key=ctx=>/*option*/ctx[26].id;for(let i=0;i<each_value.length;i+=1){let child_ctx=get_each_context$7(ctx,each_value,i);let key=get_key(child_ctx);each_1_lookup.set(key,each_blocks[i]=create_each_block$7(key,child_ctx));}return{c(){fieldset=pintura_element("fieldset");if(if_block)if_block.c();t=space();ul=pintura_element("ul");for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].c();}attr(ul,"class","PinturaRadioGroupOptions");attr(fieldset,"class",fieldset_class_value=arrayJoin(["PinturaRadioGroup",/*klass*/ctx[3]]));attr(fieldset,"data-layout",/*layout*/ctx[5]);attr(fieldset,"title",/*title*/ctx[7]);},m(target,anchor){insert(target,fieldset,anchor);if(if_block)if_block.m(fieldset,null);append(fieldset,t);append(fieldset,ul);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].m(ul,null);}current=true;},p(ctx,dirty){if(/*label*/ctx[1]){if(if_block){if_block.p(ctx,dirty);}else{if_block=create_if_block_7$1(ctx);if_block.c();if_block.m(fieldset,t);}}else if(if_block){if_block.d(1);if_block=null;}if(dirty&/*arrayJoin, optionGroupClass, mappedOptions, name, optionClass, getOptionIndex, selectedIndex, handleRadioKeydown, handleRadioClick, optionLabelClass, $$scope*/8420177){each_value=/*mappedOptions*/ctx[11];group_outros();each_blocks=update_keyed_each(each_blocks,dirty,get_key,1,ctx,each_value,each_1_lookup,ul,outro_and_destroy_block,create_each_block$7,null,get_each_context$7);check_outros();}if(!current||dirty&/*klass*/8&&fieldset_class_value!==(fieldset_class_value=arrayJoin(["PinturaRadioGroup",/*klass*/ctx[3]]))){attr(fieldset,"class",fieldset_class_value);}if(!current||dirty&/*layout*/32){attr(fieldset,"data-layout",/*layout*/ctx[5]);}if(!current||dirty&/*title*/128){attr(fieldset,"title",/*title*/ctx[7]);}},i(local){if(current)return;for(let i=0;i<each_value.length;i+=1){transition_in(each_blocks[i]);}current=true;},o(local){for(let i=0;i<each_blocks.length;i+=1){transition_out(each_blocks[i]);}current=false;},d(detaching){if(detaching)detach(fieldset);if(if_block)if_block.d();for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].d();}}};}// (73:8) {#if label}
function create_if_block_7$1(ctx){let legend;let t;let legend_class_value;return{c(){legend=pintura_element("legend");t=pintura_text(/*label*/ctx[1]);attr(legend,"class",legend_class_value=/*hideLabel*/ctx[2]&&"implicit");},m(target,anchor){insert(target,legend,anchor);append(legend,t);},p(ctx,dirty){if(dirty&/*label*/2)set_data(t,/*label*/ctx[1]);if(dirty&/*hideLabel*/4&&legend_class_value!==(legend_class_value=/*hideLabel*/ctx[2]&&"implicit")){attr(legend,"class",legend_class_value);}},d(detaching){if(detaching)detach(legend);}};}// (108:16) {:else}
function create_else_block$4(ctx){let radioitem;let current;radioitem=new RadioItem({props:{name:/*name*/ctx[4],label:/*option*/ctx[26].label,id:/*option*/ctx[26].id,value:/*option*/ctx[26].value,disabled:/*option*/ctx[26].disabled,class:/*optionClass*/ctx[8],checked:/*getOptionIndex*/ctx[12](/*option*/ctx[26])===/*selectedIndex*/ctx[0],onkeydown:/*handleRadioKeydown*/ctx[13](/*option*/ctx[26]),onclick:/*handleRadioClick*/ctx[14](/*option*/ctx[26]),$$slots:{default:[create_default_slot_2$4]},$$scope:{ctx}}});return{c(){create_component(radioitem.$$.fragment);},m(target,anchor){mount_component(radioitem,target,anchor);current=true;},p(ctx,dirty){const radioitem_changes={};if(dirty&/*name*/16)radioitem_changes.name=/*name*/ctx[4];if(dirty&/*mappedOptions*/2048)radioitem_changes.label=/*option*/ctx[26].label;if(dirty&/*mappedOptions*/2048)radioitem_changes.id=/*option*/ctx[26].id;if(dirty&/*mappedOptions*/2048)radioitem_changes.value=/*option*/ctx[26].value;if(dirty&/*mappedOptions*/2048)radioitem_changes.disabled=/*option*/ctx[26].disabled;if(dirty&/*optionClass*/256)radioitem_changes.class=/*optionClass*/ctx[8];if(dirty&/*mappedOptions, selectedIndex*/2049)radioitem_changes.checked=/*getOptionIndex*/ctx[12](/*option*/ctx[26])===/*selectedIndex*/ctx[0];if(dirty&/*mappedOptions*/2048)radioitem_changes.onkeydown=/*handleRadioKeydown*/ctx[13](/*option*/ctx[26]);if(dirty&/*mappedOptions*/2048)radioitem_changes.onclick=/*handleRadioClick*/ctx[14](/*option*/ctx[26]);if(dirty&/*$$scope, optionLabelClass, mappedOptions*/8390720){radioitem_changes.$$scope={dirty,ctx};}radioitem.$set(radioitem_changes);},i(local){if(current)return;transition_in(radioitem.$$.fragment,local);current=true;},o(local){transition_out(radioitem.$$.fragment,local);current=false;},d(detaching){destroy_component(radioitem,detaching);}};}// (78:16) {#if option.options}
function create_if_block_2$8(ctx){let li;let t0;let ul;let each_blocks=[];let each_1_lookup=new Map();let t1;let li_class_value;let current;const group_slot_template=/*#slots*/ctx[22].group;const group_slot=create_slot(group_slot_template,ctx,/*$$scope*/ctx[23],get_group_slot_context);const group_slot_or_fallback=group_slot||fallback_block_1(ctx);let each_value_1=/*option*/ctx[26].options;const get_key=ctx=>/*option*/ctx[26].id;for(let i=0;i<each_value_1.length;i+=1){let child_ctx=get_each_context_1(ctx,each_value_1,i);let key=get_key(child_ctx);each_1_lookup.set(key,each_blocks[i]=create_each_block_1(key,child_ctx));}return{c(){li=pintura_element("li");if(group_slot_or_fallback)group_slot_or_fallback.c();t0=space();ul=pintura_element("ul");for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].c();}t1=space();attr(ul,"class","PinturaRadioGroupOptions");attr(li,"class",li_class_value=arrayJoin(["PinturaRadioGroupOptionGroup",/*optionGroupClass*/ctx[9]]));},m(target,anchor){insert(target,li,anchor);if(group_slot_or_fallback){group_slot_or_fallback.m(li,null);}append(li,t0);append(li,ul);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].m(ul,null);}append(li,t1);current=true;},p(ctx,dirty){if(group_slot){if(group_slot.p&&dirty&/*$$scope, mappedOptions*/8390656){update_slot(group_slot,group_slot_template,ctx,/*$$scope*/ctx[23],dirty,get_group_slot_changes,get_group_slot_context);}}else{if(group_slot_or_fallback&&group_slot_or_fallback.p&&dirty&/*mappedOptions*/2048){group_slot_or_fallback.p(ctx,dirty);}}if(dirty&/*name, mappedOptions, optionClass, getOptionIndex, selectedIndex, handleRadioKeydown, handleRadioClick, optionLabelClass, $$scope*/8419665){each_value_1=/*option*/ctx[26].options;group_outros();each_blocks=update_keyed_each(each_blocks,dirty,get_key,1,ctx,each_value_1,each_1_lookup,ul,outro_and_destroy_block,create_each_block_1,null,get_each_context_1);check_outros();}if(!current||dirty&/*optionGroupClass*/512&&li_class_value!==(li_class_value=arrayJoin(["PinturaRadioGroupOptionGroup",/*optionGroupClass*/ctx[9]]))){attr(li,"class",li_class_value);}},i(local){if(current)return;transition_in(group_slot_or_fallback,local);for(let i=0;i<each_value_1.length;i+=1){transition_in(each_blocks[i]);}current=true;},o(local){transition_out(group_slot_or_fallback,local);for(let i=0;i<each_blocks.length;i+=1){transition_out(each_blocks[i]);}current=false;},d(detaching){if(detaching)detach(li);if(group_slot_or_fallback)group_slot_or_fallback.d(detaching);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].d();}}};}// (120:28) {#if option.icon}
function create_if_block_6$2(ctx){let icon;let current;icon=new Icon({props:{$$slots:{default:[create_default_slot_3$2]},$$scope:{ctx}}});return{c(){create_component(icon.$$.fragment);},m(target,anchor){mount_component(icon,target,anchor);current=true;},p(ctx,dirty){const icon_changes={};if(dirty&/*$$scope, mappedOptions*/8390656){icon_changes.$$scope={dirty,ctx};}icon.$set(icon_changes);},i(local){if(current)return;transition_in(icon.$$.fragment,local);current=true;},o(local){transition_out(icon.$$.fragment,local);current=false;},d(detaching){destroy_component(icon,detaching);}};}// (121:32) <Icon>
function create_default_slot_3$2(ctx){let g;let raw_value=/*option*/ctx[26].icon+"";return{c(){g=svg_element("g");},m(target,anchor){insert(target,g,anchor);g.innerHTML=raw_value;},p(ctx,dirty){if(dirty&/*mappedOptions*/2048&&raw_value!==(raw_value=/*option*/ctx[26].icon+""))g.innerHTML=raw_value;},d(detaching){if(detaching)detach(g);}};}// (123:28) {#if !option.hideLabel}
function create_if_block_5$4(ctx){let span;let t_value=/*option*/ctx[26].label+"";let t;return{c(){span=pintura_element("span");t=pintura_text(t_value);attr(span,"class",/*optionLabelClass*/ctx[6]);},m(target,anchor){insert(target,span,anchor);append(span,t);},p(ctx,dirty){if(dirty&/*mappedOptions*/2048&&t_value!==(t_value=/*option*/ctx[26].label+""))set_data(t,t_value);if(dirty&/*optionLabelClass*/64){attr(span,"class",/*optionLabelClass*/ctx[6]);}},d(detaching){if(detaching)detach(span);}};}// (119:54)                              
function fallback_block_2(ctx){let t0;let t1;let current;let if_block0=/*option*/ctx[26].icon&&create_if_block_6$2(ctx);let if_block1=!/*option*/ctx[26].hideLabel&&create_if_block_5$4(ctx);return{c(){if(if_block0)if_block0.c();t0=space();if(if_block1)if_block1.c();t1=space();},m(target,anchor){if(if_block0)if_block0.m(target,anchor);insert(target,t0,anchor);if(if_block1)if_block1.m(target,anchor);insert(target,t1,anchor);current=true;},p(ctx,dirty){if(/*option*/ctx[26].icon){if(if_block0){if_block0.p(ctx,dirty);if(dirty&/*mappedOptions*/2048){transition_in(if_block0,1);}}else{if_block0=create_if_block_6$2(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(t0.parentNode,t0);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}if(!/*option*/ctx[26].hideLabel){if(if_block1){if_block1.p(ctx,dirty);}else{if_block1=create_if_block_5$4(ctx);if_block1.c();if_block1.m(t1.parentNode,t1);}}else if(if_block1){if_block1.d(1);if_block1=null;}},i(local){if(current)return;transition_in(if_block0);current=true;},o(local){transition_out(if_block0);current=false;},d(detaching){if(if_block0)if_block0.d(detaching);if(detaching)detach(t0);if(if_block1)if_block1.d(detaching);if(detaching)detach(t1);}};}// (109:20) <RadioItem                         {name}                         label={option.label}                         id={option.id}                         value={option.value}                         disabled={option.disabled}                         class={optionClass}                         checked={getOptionIndex(option) === selectedIndex}                         onkeydown={handleRadioKeydown(option)}                         onclick={handleRadioClick(option)}                         >
function create_default_slot_2$4(ctx){let current;const option_slot_template=/*#slots*/ctx[22].option;const option_slot=create_slot(option_slot_template,ctx,/*$$scope*/ctx[23],get_option_slot_context_1);const option_slot_or_fallback=option_slot||fallback_block_2(ctx);return{c(){if(option_slot_or_fallback)option_slot_or_fallback.c();},m(target,anchor){if(option_slot_or_fallback){option_slot_or_fallback.m(target,anchor);}current=true;},p(ctx,dirty){if(option_slot){if(option_slot.p&&dirty&/*$$scope, mappedOptions*/8390656){update_slot(option_slot,option_slot_template,ctx,/*$$scope*/ctx[23],dirty,get_option_slot_changes_1,get_option_slot_context_1);}}else{if(option_slot_or_fallback&&option_slot_or_fallback.p&&dirty&/*optionLabelClass, mappedOptions*/2112){option_slot_or_fallback.p(ctx,dirty);}}},i(local){if(current)return;transition_in(option_slot_or_fallback,local);current=true;},o(local){transition_out(option_slot_or_fallback,local);current=false;},d(detaching){if(option_slot_or_fallback)option_slot_or_fallback.d(detaching);}};}// (81:29) <span class="PinturaRadioGroupOptionGroupLabel">
function fallback_block_1(ctx){let span;let t_value=/*option*/ctx[26].label+"";let t;return{c(){span=pintura_element("span");t=pintura_text(t_value);attr(span,"class","PinturaRadioGroupOptionGroupLabel");},m(target,anchor){insert(target,span,anchor);append(span,t);},p(ctx,dirty){if(dirty&/*mappedOptions*/2048&&t_value!==(t_value=/*option*/ctx[26].label+""))set_data(t,t_value);},d(detaching){if(detaching)detach(span);}};}// (97:40) {#if option.icon}
function create_if_block_4$5(ctx){let icon;let current;icon=new Icon({props:{$$slots:{default:[create_default_slot_1$7]},$$scope:{ctx}}});return{c(){create_component(icon.$$.fragment);},m(target,anchor){mount_component(icon,target,anchor);current=true;},p(ctx,dirty){const icon_changes={};if(dirty&/*$$scope, mappedOptions*/8390656){icon_changes.$$scope={dirty,ctx};}icon.$set(icon_changes);},i(local){if(current)return;transition_in(icon.$$.fragment,local);current=true;},o(local){transition_out(icon.$$.fragment,local);current=false;},d(detaching){destroy_component(icon,detaching);}};}// (98:44) <Icon>
function create_default_slot_1$7(ctx){let g;let raw_value=/*option*/ctx[26].icon+"";return{c(){g=svg_element("g");},m(target,anchor){insert(target,g,anchor);g.innerHTML=raw_value;},p(ctx,dirty){if(dirty&/*mappedOptions*/2048&&raw_value!==(raw_value=/*option*/ctx[26].icon+""))g.innerHTML=raw_value;},d(detaching){if(detaching)detach(g);}};}// (100:40) {#if !option.hideLabel}
function create_if_block_3$6(ctx){let span;let t_value=/*option*/ctx[26].label+"";let t;return{c(){span=pintura_element("span");t=pintura_text(t_value);attr(span,"class",/*optionLabelClass*/ctx[6]);},m(target,anchor){insert(target,span,anchor);append(span,t);},p(ctx,dirty){if(dirty&/*mappedOptions*/2048&&t_value!==(t_value=/*option*/ctx[26].label+""))set_data(t,t_value);if(dirty&/*optionLabelClass*/64){attr(span,"class",/*optionLabelClass*/ctx[6]);}},d(detaching){if(detaching)detach(span);}};}// (96:66)                                          
function fallback_block$1(ctx){let t0;let t1;let current;let if_block0=/*option*/ctx[26].icon&&create_if_block_4$5(ctx);let if_block1=!/*option*/ctx[26].hideLabel&&create_if_block_3$6(ctx);return{c(){if(if_block0)if_block0.c();t0=space();if(if_block1)if_block1.c();t1=space();},m(target,anchor){if(if_block0)if_block0.m(target,anchor);insert(target,t0,anchor);if(if_block1)if_block1.m(target,anchor);insert(target,t1,anchor);current=true;},p(ctx,dirty){if(/*option*/ctx[26].icon){if(if_block0){if_block0.p(ctx,dirty);if(dirty&/*mappedOptions*/2048){transition_in(if_block0,1);}}else{if_block0=create_if_block_4$5(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(t0.parentNode,t0);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}if(!/*option*/ctx[26].hideLabel){if(if_block1){if_block1.p(ctx,dirty);}else{if_block1=create_if_block_3$6(ctx);if_block1.c();if_block1.m(t1.parentNode,t1);}}else if(if_block1){if_block1.d(1);if_block1=null;}},i(local){if(current)return;transition_in(if_block0);current=true;},o(local){transition_out(if_block0);current=false;},d(detaching){if(if_block0)if_block0.d(detaching);if(detaching)detach(t0);if(if_block1)if_block1.d(detaching);if(detaching)detach(t1);}};}// (86:32) <RadioItem                                     {name}                                     label={option.label}                                     id={option.id}                                     value={option.value}                                     disabled={option.disabled}                                     class={optionClass}                                     checked={getOptionIndex(option) === selectedIndex}                                     onkeydown={handleRadioKeydown(option)}                                     onclick={handleRadioClick(option)}                                     >
function create_default_slot$f(ctx){let current;const option_slot_template=/*#slots*/ctx[22].option;const option_slot=create_slot(option_slot_template,ctx,/*$$scope*/ctx[23],get_option_slot_context);const option_slot_or_fallback=option_slot||fallback_block$1(ctx);return{c(){if(option_slot_or_fallback)option_slot_or_fallback.c();},m(target,anchor){if(option_slot_or_fallback){option_slot_or_fallback.m(target,anchor);}current=true;},p(ctx,dirty){if(option_slot){if(option_slot.p&&dirty&/*$$scope, mappedOptions*/8390656){update_slot(option_slot,option_slot_template,ctx,/*$$scope*/ctx[23],dirty,get_option_slot_changes,get_option_slot_context);}}else{if(option_slot_or_fallback&&option_slot_or_fallback.p&&dirty&/*optionLabelClass, mappedOptions*/2112){option_slot_or_fallback.p(ctx,dirty);}}},i(local){if(current)return;transition_in(option_slot_or_fallback,local);current=true;},o(local){transition_out(option_slot_or_fallback,local);current=false;},d(detaching){if(option_slot_or_fallback)option_slot_or_fallback.d(detaching);}};}// (85:28) {#each option.options as option (option.id)}
function create_each_block_1(key_1,ctx){let first;let radioitem;let current;radioitem=new RadioItem({props:{name:/*name*/ctx[4],label:/*option*/ctx[26].label,id:/*option*/ctx[26].id,value:/*option*/ctx[26].value,disabled:/*option*/ctx[26].disabled,class:/*optionClass*/ctx[8],checked:/*getOptionIndex*/ctx[12](/*option*/ctx[26])===/*selectedIndex*/ctx[0],onkeydown:/*handleRadioKeydown*/ctx[13](/*option*/ctx[26]),onclick:/*handleRadioClick*/ctx[14](/*option*/ctx[26]),$$slots:{default:[create_default_slot$f]},$$scope:{ctx}}});return{key:key_1,first:null,c(){first=empty();create_component(radioitem.$$.fragment);this.first=first;},m(target,anchor){insert(target,first,anchor);mount_component(radioitem,target,anchor);current=true;},p(new_ctx,dirty){ctx=new_ctx;const radioitem_changes={};if(dirty&/*name*/16)radioitem_changes.name=/*name*/ctx[4];if(dirty&/*mappedOptions*/2048)radioitem_changes.label=/*option*/ctx[26].label;if(dirty&/*mappedOptions*/2048)radioitem_changes.id=/*option*/ctx[26].id;if(dirty&/*mappedOptions*/2048)radioitem_changes.value=/*option*/ctx[26].value;if(dirty&/*mappedOptions*/2048)radioitem_changes.disabled=/*option*/ctx[26].disabled;if(dirty&/*optionClass*/256)radioitem_changes.class=/*optionClass*/ctx[8];if(dirty&/*mappedOptions, selectedIndex*/2049)radioitem_changes.checked=/*getOptionIndex*/ctx[12](/*option*/ctx[26])===/*selectedIndex*/ctx[0];if(dirty&/*mappedOptions*/2048)radioitem_changes.onkeydown=/*handleRadioKeydown*/ctx[13](/*option*/ctx[26]);if(dirty&/*mappedOptions*/2048)radioitem_changes.onclick=/*handleRadioClick*/ctx[14](/*option*/ctx[26]);if(dirty&/*$$scope, optionLabelClass, mappedOptions*/8390720){radioitem_changes.$$scope={dirty,ctx};}radioitem.$set(radioitem_changes);},i(local){if(current)return;transition_in(radioitem.$$.fragment,local);current=true;},o(local){transition_out(radioitem.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(first);destroy_component(radioitem,detaching);}};}// (77:12) {#each mappedOptions as option (option.id)}
function create_each_block$7(key_1,ctx){let first;let current_block_type_index;let if_block;let if_block_anchor;let current;const if_block_creators=[create_if_block_2$8,create_else_block$4];const if_blocks=[];function select_block_type(ctx,dirty){if(/*option*/ctx[26].options)return 0;return 1;}current_block_type_index=select_block_type(ctx);if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);return{key:key_1,first:null,c(){first=empty();if_block.c();if_block_anchor=empty();this.first=first;},m(target,anchor){insert(target,first,anchor);if_blocks[current_block_type_index].m(target,anchor);insert(target,if_block_anchor,anchor);current=true;},p(new_ctx,dirty){ctx=new_ctx;let previous_block_index=current_block_type_index;current_block_type_index=select_block_type(ctx);if(current_block_type_index===previous_block_index){if_blocks[current_block_type_index].p(ctx,dirty);}else{group_outros();transition_out(if_blocks[previous_block_index],1,1,()=>{if_blocks[previous_block_index]=null;});check_outros();if_block=if_blocks[current_block_type_index];if(!if_block){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);if_block.c();}else{if_block.p(ctx,dirty);}transition_in(if_block,1);if_block.m(if_block_anchor.parentNode,if_block_anchor);}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(detaching)detach(first);if_blocks[current_block_type_index].d(detaching);if(detaching)detach(if_block_anchor);}};}function create_fragment$z(ctx){let t;let if_block1_anchor;let current;let if_block0=/*localizedOptions*/ctx[10].length&&create_if_block_1$a(ctx);let if_block1=false;return{c(){if(if_block0)if_block0.c();t=space();if_block1_anchor=empty();},m(target,anchor){if(if_block0)if_block0.m(target,anchor);insert(target,t,anchor);insert(target,if_block1_anchor,anchor);current=true;},p(ctx,[dirty]){if(/*localizedOptions*/ctx[10].length){if(if_block0){if_block0.p(ctx,dirty);if(dirty&/*localizedOptions*/1024){transition_in(if_block0,1);}}else{if_block0=create_if_block_1$a(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(t.parentNode,t);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}},i(local){if(current)return;transition_in(if_block0);transition_in(if_block1);current=true;},o(local){transition_out(if_block0);transition_out(if_block1);current=false;},d(detaching){if(if_block0)if_block0.d(detaching);if(detaching)detach(t);if(detaching)detach(if_block1_anchor);}};}function instance$z($$self,$$props,$$invalidate){let localizedOptions;let mappedOptions;let flattenedOptions;let{$$slots:slots={},$$scope}=$$props;const dispatch=createEventDispatcher();let{label=undefined}=$$props;let{hideLabel=true}=$$props;let{class:klass=undefined}=$$props;let{name=`radio-group-${getUniqueId()}`}=$$props;let{selectedIndex=-1}=$$props;let{options=[]}=$$props;let{onchange=undefined}=$$props;let{layout=undefined}=$$props;let{optionMapper=undefined}=$$props;let{optionFilter=undefined}=$$props;let{value=undefined}=$$props;let{optionLabelClass=undefined}=$$props;let{title=undefined}=$$props;let{locale=undefined}=$$props;let{optionClass=undefined}=$$props;let{optionGroupClass=undefined}=$$props;const getOptionIndex=option=>flattenedOptions.findIndex(flattenedOption=>flattenedOption.id===option.id);const changeSelection=(option,e)=>{$$invalidate(0,selectedIndex=getOptionIndex(option));const payload={index:selectedIndex,...option};opop(onchange,payload,e);dispatch("change",payload);};const handleRadioKeydown=option=>e=>{// is confirm key ([enter] or [space])
if(!isConfirmKey(e.key))return;changeSelection(option,e);};const handleRadioClick=option=>e=>{changeSelection(option,e);};$$self.$$set=$$props=>{if("label"in $$props)$$invalidate(1,label=$$props.label);if("hideLabel"in $$props)$$invalidate(2,hideLabel=$$props.hideLabel);if("class"in $$props)$$invalidate(3,klass=$$props.class);if("name"in $$props)$$invalidate(4,name=$$props.name);if("selectedIndex"in $$props)$$invalidate(0,selectedIndex=$$props.selectedIndex);if("options"in $$props)$$invalidate(15,options=$$props.options);if("onchange"in $$props)$$invalidate(16,onchange=$$props.onchange);if("layout"in $$props)$$invalidate(5,layout=$$props.layout);if("optionMapper"in $$props)$$invalidate(17,optionMapper=$$props.optionMapper);if("optionFilter"in $$props)$$invalidate(18,optionFilter=$$props.optionFilter);if("value"in $$props)$$invalidate(19,value=$$props.value);if("optionLabelClass"in $$props)$$invalidate(6,optionLabelClass=$$props.optionLabelClass);if("title"in $$props)$$invalidate(7,title=$$props.title);if("locale"in $$props)$$invalidate(20,locale=$$props.locale);if("optionClass"in $$props)$$invalidate(8,optionClass=$$props.optionClass);if("optionGroupClass"in $$props)$$invalidate(9,optionGroupClass=$$props.optionGroupClass);if("$$scope"in $$props)$$invalidate(23,$$scope=$$props.$$scope);};$$self.$$.update=()=>{if($$self.$$.dirty&/*optionFilter, options, locale*/1343488){$$invalidate(10,localizedOptions=localizeOptions$1(optionFilter?options.filter(optionFilter):options,locale));}if($$self.$$.dirty&/*localizedOptions, optionMapper*/132096){$$invalidate(11,mappedOptions=mapOptions(localizedOptions,optionMapper));}if($$self.$$.dirty&/*mappedOptions*/2048){$$invalidate(21,flattenedOptions=flattenOptions(mappedOptions));}if($$self.$$.dirty&/*value, selectedIndex, flattenedOptions*/2621441){// can optionally pass value to have radio button group try to auto-select the right option
if(value&&selectedIndex<0){$$invalidate(0,selectedIndex=flattenedOptions.findIndex(option=>option.value===value));}}};return[selectedIndex,label,hideLabel,klass,name,layout,optionLabelClass,title,optionClass,optionGroupClass,localizedOptions,mappedOptions,getOptionIndex,handleRadioKeydown,handleRadioClick,options,onchange,optionMapper,optionFilter,value,locale,flattenedOptions,slots,$$scope];}class RadioGroup extends SvelteComponent{constructor(options){super();init(this,options,instance$z,create_fragment$z,safe_not_equal,{label:1,hideLabel:2,class:3,name:4,selectedIndex:0,options:15,onchange:16,layout:5,optionMapper:17,optionFilter:18,value:19,optionLabelClass:6,title:7,locale:20,optionClass:8,optionGroupClass:9});}}var isDeepEqual=(a,b)=>{if(Array.isArray(a)&&Array.isArray(b))return arrayEqual(a,b);return a===b;};/* src/core/ui/components/Dropdown.svelte generated by Svelte v3.37.0 */function create_if_block_1$9(ctx){let icon_1;let current;icon_1=new Icon({props:{class:"PinturaButtonIcon",$$slots:{default:[create_default_slot_1$6]},$$scope:{ctx}}});return{c(){create_component(icon_1.$$.fragment);},m(target,anchor){mount_component(icon_1,target,anchor);current=true;},p(ctx,dirty){const icon_1_changes={};if(dirty&/*$$scope, icon*/536870976){icon_1_changes.$$scope={dirty,ctx};}icon_1.$set(icon_1_changes);},i(local){if(current)return;transition_in(icon_1.$$.fragment,local);current=true;},o(local){transition_out(icon_1.$$.fragment,local);current=false;},d(detaching){destroy_component(icon_1,detaching);}};}// (95:12) <Icon class="PinturaButtonIcon">
function create_default_slot_1$6(ctx){let g;return{c(){g=svg_element("g");},m(target,anchor){insert(target,g,anchor);g.innerHTML=/*icon*/ctx[6];},p(ctx,dirty){if(dirty&/*icon*/64)g.innerHTML=/*icon*/ctx[6];},d(detaching){if(detaching)detach(g);}};}// (89:4) 
function create_label_slot$2(ctx){let span1;let t0;let span0;let t1_value=(/*label*/ctx[2]||/*selectedLabel*/ctx[18])+"";let t1;let span0_class_value;let span1_title_value;let span1_class_value;let current;let if_block=/*icon*/ctx[6]&&create_if_block_1$9(ctx);return{c(){span1=pintura_element("span");if(if_block)if_block.c();t0=space();span0=pintura_element("span");t1=pintura_text(t1_value);attr(span0,"class",span0_class_value=arrayJoin(["PinturaButtonLabel",/*labelClass*/ctx[3],/*hideLabel*/ctx[5]&&"implicit"]));attr(span1,"slot","label");attr(span1,"title",span1_title_value=localize(/*title*/ctx[1],/*locale*/ctx[15]));attr(span1,"class",span1_class_value=arrayJoin(["PinturaButtonInner",/*innerClass*/ctx[4]]));},m(target,anchor){insert(target,span1,anchor);if(if_block)if_block.m(span1,null);append(span1,t0);append(span1,span0);append(span0,t1);current=true;},p(ctx,dirty){if(/*icon*/ctx[6]){if(if_block){if_block.p(ctx,dirty);if(dirty&/*icon*/64){transition_in(if_block,1);}}else{if_block=create_if_block_1$9(ctx);if_block.c();transition_in(if_block,1);if_block.m(span1,t0);}}else if(if_block){group_outros();transition_out(if_block,1,1,()=>{if_block=null;});check_outros();}if((!current||dirty&/*label, selectedLabel*/262148)&&t1_value!==(t1_value=(/*label*/ctx[2]||/*selectedLabel*/ctx[18])+""))set_data(t1,t1_value);if(!current||dirty&/*labelClass, hideLabel*/40&&span0_class_value!==(span0_class_value=arrayJoin(["PinturaButtonLabel",/*labelClass*/ctx[3],/*hideLabel*/ctx[5]&&"implicit"]))){attr(span0,"class",span0_class_value);}if(!current||dirty&/*title, locale*/32770&&span1_title_value!==(span1_title_value=localize(/*title*/ctx[1],/*locale*/ctx[15]))){attr(span1,"title",span1_title_value);}if(!current||dirty&/*innerClass*/16&&span1_class_value!==(span1_class_value=arrayJoin(["PinturaButtonInner",/*innerClass*/ctx[4]]))){attr(span1,"class",span1_class_value);}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(detaching)detach(span1);if(if_block)if_block.d();}};}// (116:12) 
function create_group_slot$1(ctx){let span;let t_value=/*option*/ctx[28].label+"";let t;return{c(){span=pintura_element("span");t=pintura_text(t_value);attr(span,"slot","group");},m(target,anchor){insert(target,span,anchor);append(span,t);},p(ctx,dirty){if(dirty&/*option*/268435456&&t_value!==(t_value=/*option*/ctx[28].label+""))set_data(t,t_value);},d(detaching){if(detaching)detach(span);}};}// (118:16) {#if option.icon}
function create_if_block$a(ctx){let icon_1;let current;icon_1=new Icon({props:{style:pintura_isFunction(/*optionIconStyle*/ctx[13])?/*optionIconStyle*/ctx[13](/*option*/ctx[28].value):/*optionIconStyle*/ctx[13],$$slots:{default:[create_default_slot$e]},$$scope:{ctx}}});return{c(){create_component(icon_1.$$.fragment);},m(target,anchor){mount_component(icon_1,target,anchor);current=true;},p(ctx,dirty){const icon_1_changes={};if(dirty&/*optionIconStyle, option*/268443648)icon_1_changes.style=pintura_isFunction(/*optionIconStyle*/ctx[13])?/*optionIconStyle*/ctx[13](/*option*/ctx[28].value):/*optionIconStyle*/ctx[13];if(dirty&/*$$scope, option*/805306368){icon_1_changes.$$scope={dirty,ctx};}icon_1.$set(icon_1_changes);},i(local){if(current)return;transition_in(icon_1.$$.fragment,local);current=true;},o(local){transition_out(icon_1.$$.fragment,local);current=false;},d(detaching){destroy_component(icon_1,detaching);}};}// (119:20) <Icon                         style={isFunction(optionIconStyle)                             ? optionIconStyle(option.value)                             : optionIconStyle}>
function create_default_slot$e(ctx){let g;let raw_value=/*option*/ctx[28].icon+"";return{c(){g=svg_element("g");},m(target,anchor){insert(target,g,anchor);g.innerHTML=raw_value;},p(ctx,dirty){if(dirty&/*option*/268435456&&raw_value!==(raw_value=/*option*/ctx[28].icon+""))g.innerHTML=raw_value;},d(detaching){if(detaching)detach(g);}};}// (117:12) 
function create_option_slot$4(ctx){let span1;let t0;let span0;let t1_value=/*option*/ctx[28].label+"";let t1;let span0_style_value;let span0_class_value;let current;let if_block=/*option*/ctx[28].icon&&create_if_block$a(ctx);return{c(){span1=pintura_element("span");if(if_block)if_block.c();t0=space();span0=pintura_element("span");t1=pintura_text(t1_value);attr(span0,"style",span0_style_value=pintura_isFunction(/*optionLabelStyle*/ctx[14])?/*optionLabelStyle*/ctx[14](/*option*/ctx[28].value):/*optionLabelStyle*/ctx[14]);attr(span0,"class",span0_class_value=arrayJoin(["PinturaDropdownOptionLabel",/*optionLabelClass*/ctx[10]]));attr(span1,"slot","option");},m(target,anchor){insert(target,span1,anchor);if(if_block)if_block.m(span1,null);append(span1,t0);append(span1,span0);append(span0,t1);current=true;},p(ctx,dirty){if(/*option*/ctx[28].icon){if(if_block){if_block.p(ctx,dirty);if(dirty&/*option*/268435456){transition_in(if_block,1);}}else{if_block=create_if_block$a(ctx);if_block.c();transition_in(if_block,1);if_block.m(span1,t0);}}else if(if_block){group_outros();transition_out(if_block,1,1,()=>{if_block=null;});check_outros();}if((!current||dirty&/*option*/268435456)&&t1_value!==(t1_value=/*option*/ctx[28].label+""))set_data(t1,t1_value);if(!current||dirty&/*optionLabelStyle, option*/268451840&&span0_style_value!==(span0_style_value=pintura_isFunction(/*optionLabelStyle*/ctx[14])?/*optionLabelStyle*/ctx[14](/*option*/ctx[28].value):/*optionLabelStyle*/ctx[14])){attr(span0,"style",span0_style_value);}if(!current||dirty&/*optionLabelClass*/1024&&span0_class_value!==(span0_class_value=arrayJoin(["PinturaDropdownOptionLabel",/*optionLabelClass*/ctx[10]]))){attr(span0,"class",span0_class_value);}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(detaching)detach(span1);if(if_block)if_block.d();}};}// (102:4) 
function create_details_slot$2(ctx){let div;let radiogroup;let current;let mounted;let dispose;radiogroup=new RadioGroup({props:{name:/*name*/ctx[7],value:/*value*/ctx[9],selectedIndex:/*selectedIndex*/ctx[8],optionFilter:/*optionFilter*/ctx[11],optionMapper:/*optionMapper*/ctx[12],optionLabelClass:arrayJoin(["PinturaDropdownOptionLabel",/*optionLabelClass*/ctx[10]]),optionGroupClass:"PinturaDropdownOptionGroup",optionClass:"PinturaDropdownOption",options:/*localizedOptions*/ctx[16],onchange:/*handleSelect*/ctx[19],$$slots:{option:[create_option_slot$4,({option})=>({28:option}),({option})=>option?268435456:0],group:[create_group_slot$1,({option})=>({28:option}),({option})=>option?268435456:0]},$$scope:{ctx}}});return{c(){div=pintura_element("div");create_component(radiogroup.$$.fragment);attr(div,"class","PinturaDropdownPanel");attr(div,"slot","details");},m(target,anchor){insert(target,div,anchor);mount_component(radiogroup,div,null);current=true;if(!mounted){dispose=listen(div,"keydown",/*handleKeydown*/ctx[21]);mounted=true;}},p(ctx,dirty){const radiogroup_changes={};if(dirty&/*name*/128)radiogroup_changes.name=/*name*/ctx[7];if(dirty&/*value*/512)radiogroup_changes.value=/*value*/ctx[9];if(dirty&/*selectedIndex*/256)radiogroup_changes.selectedIndex=/*selectedIndex*/ctx[8];if(dirty&/*optionFilter*/2048)radiogroup_changes.optionFilter=/*optionFilter*/ctx[11];if(dirty&/*optionMapper*/4096)radiogroup_changes.optionMapper=/*optionMapper*/ctx[12];if(dirty&/*optionLabelClass*/1024)radiogroup_changes.optionLabelClass=arrayJoin(["PinturaDropdownOptionLabel",/*optionLabelClass*/ctx[10]]);if(dirty&/*localizedOptions*/65536)radiogroup_changes.options=/*localizedOptions*/ctx[16];if(dirty&/*$$scope, optionLabelStyle, option, optionLabelClass, optionIconStyle*/805331968){radiogroup_changes.$$scope={dirty,ctx};}radiogroup.$set(radiogroup_changes);},i(local){if(current)return;transition_in(radiogroup.$$.fragment,local);current=true;},o(local){transition_out(radiogroup.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(radiogroup);mounted=false;dispose();}};}function create_fragment$y(ctx){let details;let updating_isActive;let current;function details_isActive_binding(value){/*details_isActive_binding*/ctx[26](value);}let details_props={onshow:/*handleShowPanel*/ctx[20],buttonClass:arrayJoin(["PinturaDropdownButton",/*klass*/ctx[0],/*hideLabel*/ctx[5]&&"PinturaDropdownIconOnly"]),$$slots:{details:[create_details_slot$2],label:[create_label_slot$2]},$$scope:{ctx}};if(/*dropdownVisible*/ctx[17]!==void 0){details_props.isActive=/*dropdownVisible*/ctx[17];}details=new Details({props:details_props});binding_callbacks.push(()=>bind(details,"isActive",details_isActive_binding));return{c(){create_component(details.$$.fragment);},m(target,anchor){mount_component(details,target,anchor);current=true;},p(ctx,[dirty]){const details_changes={};if(dirty&/*klass, hideLabel*/33)details_changes.buttonClass=arrayJoin(["PinturaDropdownButton",/*klass*/ctx[0],/*hideLabel*/ctx[5]&&"PinturaDropdownIconOnly"]);if(dirty&/*$$scope, name, value, selectedIndex, optionFilter, optionMapper, optionLabelClass, localizedOptions, optionLabelStyle, optionIconStyle, title, locale, innerClass, labelClass, hideLabel, label, selectedLabel, icon*/537264126){details_changes.$$scope={dirty,ctx};}if(!updating_isActive&&dirty&/*dropdownVisible*/131072){updating_isActive=true;details_changes.isActive=/*dropdownVisible*/ctx[17];add_flush_callback(()=>updating_isActive=false);}details.$set(details_changes);},i(local){if(current)return;transition_in(details.$$.fragment,local);current=true;},o(local){transition_out(details.$$.fragment,local);current=false;},d(detaching){destroy_component(details,detaching);}};}function instance$y($$self,$$props,$$invalidate){let localizedOptions;let selectedLabel;let{class:klass=undefined}=$$props;let{title=undefined}=$$props;let{label=undefined}=$$props;let{labelClass=undefined}=$$props;let{innerClass=undefined}=$$props;let{hideLabel=false}=$$props;let{icon=undefined}=$$props;let{name=undefined}=$$props;let{options=[]}=$$props;let{selectedIndex=-1}=$$props;let{value=undefined}=$$props;let{optionLabelClass=undefined}=$$props;let{optionFilter=undefined}=$$props;let{optionMapper=undefined}=$$props;let{optionIconStyle=undefined}=$$props;let{optionLabelStyle=undefined}=$$props;let{locale=undefined}=$$props;let{onchange=noop$1}=$$props;let{onload=noop$1}=$$props;let{ondestroy=noop$1}=$$props;const getUndefinedOptionLabel=options=>{const option=options.find(option=>option[0]===undefined);if(!option)return undefined;return option[1];};let dropdownVisible;const handleSelect=detail=>{// triggers label update
$$invalidate(18,selectedLabel=detail.value);// update value
onchange(detail);// hide details
$$invalidate(17,dropdownVisible=false);};const handleShowPanel=({e,panel})=>{if(e&&e.key&&/up|down/i.test(e.key))return panel.querySelector("input:not([disabled])").focus();panel.querySelector("fieldset").focus();};const handleKeydown=e=>{// don't allow tabbing ([tab] is also blocked in normal <select>)
if(/tab/i.test(e.key))e.preventDefault();};onMount(()=>onload({options}));onDestroy(()=>ondestroy({options}));function details_isActive_binding(value){dropdownVisible=value;$$invalidate(17,dropdownVisible);}$$self.$$set=$$props=>{if("class"in $$props)$$invalidate(0,klass=$$props.class);if("title"in $$props)$$invalidate(1,title=$$props.title);if("label"in $$props)$$invalidate(2,label=$$props.label);if("labelClass"in $$props)$$invalidate(3,labelClass=$$props.labelClass);if("innerClass"in $$props)$$invalidate(4,innerClass=$$props.innerClass);if("hideLabel"in $$props)$$invalidate(5,hideLabel=$$props.hideLabel);if("icon"in $$props)$$invalidate(6,icon=$$props.icon);if("name"in $$props)$$invalidate(7,name=$$props.name);if("options"in $$props)$$invalidate(22,options=$$props.options);if("selectedIndex"in $$props)$$invalidate(8,selectedIndex=$$props.selectedIndex);if("value"in $$props)$$invalidate(9,value=$$props.value);if("optionLabelClass"in $$props)$$invalidate(10,optionLabelClass=$$props.optionLabelClass);if("optionFilter"in $$props)$$invalidate(11,optionFilter=$$props.optionFilter);if("optionMapper"in $$props)$$invalidate(12,optionMapper=$$props.optionMapper);if("optionIconStyle"in $$props)$$invalidate(13,optionIconStyle=$$props.optionIconStyle);if("optionLabelStyle"in $$props)$$invalidate(14,optionLabelStyle=$$props.optionLabelStyle);if("locale"in $$props)$$invalidate(15,locale=$$props.locale);if("onchange"in $$props)$$invalidate(23,onchange=$$props.onchange);if("onload"in $$props)$$invalidate(24,onload=$$props.onload);if("ondestroy"in $$props)$$invalidate(25,ondestroy=$$props.ondestroy);};$$self.$$.update=()=>{if($$self.$$.dirty&/*locale, options*/4227072){$$invalidate(16,localizedOptions=locale?localizeOptions$1(options,locale):options);}if($$self.$$.dirty&/*localizedOptions, value*/66048){$$invalidate(18,selectedLabel=localizedOptions.reduce((prev,curr)=>{if(prev)return prev;const item=Array.isArray(curr)?curr:[curr,curr];const[optionValue,optionLabel]=item;if(isDeepEqual(optionValue,value))return optionLabel;},undefined)||getUndefinedOptionLabel(localizedOptions));}};return[klass,title,label,labelClass,innerClass,hideLabel,icon,name,selectedIndex,value,optionLabelClass,optionFilter,optionMapper,optionIconStyle,optionLabelStyle,locale,localizedOptions,dropdownVisible,selectedLabel,handleSelect,handleShowPanel,handleKeydown,options,onchange,onload,ondestroy,details_isActive_binding];}class Dropdown extends SvelteComponent{constructor(options){super();init(this,options,instance$y,create_fragment$y,safe_not_equal,{class:0,title:1,label:2,labelClass:3,innerClass:4,hideLabel:5,icon:6,name:7,options:22,selectedIndex:8,value:9,optionLabelClass:10,optionFilter:11,optionMapper:12,optionIconStyle:13,optionLabelStyle:14,locale:15,onchange:23,onload:24,ondestroy:25});}}var numberRoundTo=(value,fraction)=>{fraction=1/fraction;return Math.round(value*fraction)/fraction;};var toFraction=(value,min,max)=>(value-min)/(max-min);/* src/core/ui/components/Slider.svelte generated by Svelte v3.37.0 */function create_default_slot_1$5(ctx){let path;return{c(){path=svg_element("path");attr(path,"d","M8 12 h8 M12 8 v8");},m(target,anchor){insert(target,path,anchor);},d(detaching){if(detaching)detach(path);}};}// (153:8) <Icon>
function create_default_slot$d(ctx){let path;return{c(){path=svg_element("path");attr(path,"d","M9 12 h6");},m(target,anchor){insert(target,path,anchor);},d(detaching){if(detaching)detach(path);}};}function create_fragment$x(ctx){let div4;let div3;let input_1;let t0;let div0;let t1;let div2;let div1;let t2;let button0;let icon0;let t3;let button1;let icon1;let div4_class_value;let current;let mounted;let dispose;icon0=new Icon({props:{$$slots:{default:[create_default_slot_1$5]},$$scope:{ctx}}});icon1=new Icon({props:{$$slots:{default:[create_default_slot$d]},$$scope:{ctx}}});return{c(){div4=pintura_element("div");div3=pintura_element("div");input_1=pintura_element("input");t0=space();div0=pintura_element("div");t1=space();div2=pintura_element("div");div1=pintura_element("div");t2=space();button0=pintura_element("button");create_component(icon0.$$.fragment);t3=space();button1=pintura_element("button");create_component(icon1.$$.fragment);attr(input_1,"type","range");attr(input_1,"id",/*id*/ctx[3]);attr(input_1,"min",/*min*/ctx[0]);attr(input_1,"max",/*max*/ctx[1]);attr(input_1,"step",/*step*/ctx[2]);input_1.value=/*numberValue*/ctx[8];attr(div0,"class","PinturaSliderTrack");attr(div0,"style",/*trackStyle*/ctx[4]);attr(div1,"class","PinturaSliderKnob");attr(div1,"style",/*knobStyle*/ctx[5]);attr(div2,"class","PinturaSliderKnobController");attr(div2,"style",/*knobControllerStyle*/ctx[10]);attr(div3,"class","PinturaSliderControl");attr(button0,"type","button");attr(button0,"aria-label","Increase");attr(button1,"type","button");attr(button1,"aria-label","Decrease");attr(div4,"class",div4_class_value=arrayJoin(["PinturaSlider",/*klass*/ctx[7]]));attr(div4,"data-direction",/*direction*/ctx[6]);},m(target,anchor){insert(target,div4,anchor);append(div4,div3);append(div3,input_1);/*input_1_binding*/ctx[22](input_1);append(div3,t0);append(div3,div0);append(div3,t1);append(div3,div2);append(div2,div1);append(div4,t2);append(div4,button0);mount_component(icon0,button0,null);append(div4,t3);append(div4,button1);mount_component(icon1,button1,null);current=true;if(!mounted){dispose=[listen(input_1,"pointerdown",/*handlePointerDown*/ctx[13]),listen(input_1,"input",/*handleInput*/ctx[11]),listen(input_1,"nudge",/*handleNudge*/ctx[12]),action_destroyer(nudgeable.call(null,input_1)),listen(button0,"pointerdown",/*handleUpdaterDown*/ctx[14](1)),listen(button1,"pointerdown",/*handleUpdaterDown*/ctx[14](-1))];mounted=true;}},p(ctx,dirty){if(!current||dirty[0]&/*id*/8){attr(input_1,"id",/*id*/ctx[3]);}if(!current||dirty[0]&/*min*/1){attr(input_1,"min",/*min*/ctx[0]);}if(!current||dirty[0]&/*max*/2){attr(input_1,"max",/*max*/ctx[1]);}if(!current||dirty[0]&/*step*/4){attr(input_1,"step",/*step*/ctx[2]);}if(!current||dirty[0]&/*numberValue*/256){input_1.value=/*numberValue*/ctx[8];}if(!current||dirty[0]&/*trackStyle*/16){attr(div0,"style",/*trackStyle*/ctx[4]);}if(!current||dirty[0]&/*knobStyle*/32){attr(div1,"style",/*knobStyle*/ctx[5]);}if(!current||dirty[0]&/*knobControllerStyle*/1024){attr(div2,"style",/*knobControllerStyle*/ctx[10]);}const icon0_changes={};if(dirty[1]&/*$$scope*/512){icon0_changes.$$scope={dirty,ctx};}icon0.$set(icon0_changes);const icon1_changes={};if(dirty[1]&/*$$scope*/512){icon1_changes.$$scope={dirty,ctx};}icon1.$set(icon1_changes);if(!current||dirty[0]&/*klass*/128&&div4_class_value!==(div4_class_value=arrayJoin(["PinturaSlider",/*klass*/ctx[7]]))){attr(div4,"class",div4_class_value);}if(!current||dirty[0]&/*direction*/64){attr(div4,"data-direction",/*direction*/ctx[6]);}},i(local){if(current)return;transition_in(icon0.$$.fragment,local);transition_in(icon1.$$.fragment,local);current=true;},o(local){transition_out(icon0.$$.fragment,local);transition_out(icon1.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div4);/*input_1_binding*/ctx[22](null);destroy_component(icon0);destroy_component(icon1);mounted=false;run_all(dispose);}};}function instance$x($$self,$$props,$$invalidate){let numberValue;let range;let position;let axis;let dimension;let offsetSizeProp;let offsetAxisProp;let pageAxisProp;let knobControllerStyle;let{min=0}=$$props;let{max=100}=$$props;let{step=1}=$$props;let{id=undefined}=$$props;let{value=0}=$$props;let{trackStyle=undefined}=$$props;let{knobStyle=undefined}=$$props;let{onchange=undefined}=$$props;let{direction="x"}=$$props;let{getValue=passthrough}=$$props;let{setValue=passthrough}=$$props;let{class:klass=undefined}=$$props;let input;let inputSize;let inputOffset;let pageOffset;let valuePrev;const formatValue=value=>setValue(numberRoundTo(pintura_clamp(value,min,max),step));const setValueByOffset=(offset,size)=>{$$invalidate(15,value=formatValue(min+offset/size*range));if(value===valuePrev)return;valuePrev=value;onchange(value);};const handleInput=e=>{// already handled by pointer events
if(inputSize)return;$$invalidate(15,value=setValue(parseFloat(e.target.value)));if(value===valuePrev)return;valuePrev=value;onchange(value);};const handleNudge=e=>{const size=input[offsetSizeProp];const offset=numberValue/range*size;setValueByOffset(offset+e.detail[direction],size);};const handlePointerDown=e=>{e.stopPropagation();inputSize=input[offsetSizeProp];inputOffset=e[offsetAxisProp];pageOffset=e[pageAxisProp];setValueByOffset(inputOffset,inputSize);document.documentElement.addEventListener("pointermove",handlePointerMove);document.documentElement.addEventListener("pointerup",handlePointerUp);};const handlePointerMove=e=>{const d=e[pageAxisProp]-pageOffset;setValueByOffset(inputOffset+d,inputSize);};const handlePointerUp=e=>{inputSize=undefined;document.documentElement.removeEventListener("pointermove",handlePointerMove);document.documentElement.removeEventListener("pointerup",handlePointerUp);onchange(value);};const update=()=>{$$invalidate(15,value=formatValue(numberValue+updateDir*step));onchange(value);};let updateTimer;let updateDir=1;let didUpdate=false;const handleUpdaterDown=dir=>e=>{updateDir=dir;didUpdate=false;updateTimer=setInterval(()=>{didUpdate=true;update();},100);document.addEventListener("pointercancel",handleUpdaterUp);document.addEventListener("pointerup",handleUpdaterUp);};const handleUpdaterUp=e=>{clearTimeout(updateTimer);if(!didUpdate)update();document.removeEventListener("pointerup",handleUpdaterUp);};function input_1_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{input=$$value;$$invalidate(9,input);});}$$self.$$set=$$props=>{if("min"in $$props)$$invalidate(0,min=$$props.min);if("max"in $$props)$$invalidate(1,max=$$props.max);if("step"in $$props)$$invalidate(2,step=$$props.step);if("id"in $$props)$$invalidate(3,id=$$props.id);if("value"in $$props)$$invalidate(15,value=$$props.value);if("trackStyle"in $$props)$$invalidate(4,trackStyle=$$props.trackStyle);if("knobStyle"in $$props)$$invalidate(5,knobStyle=$$props.knobStyle);if("onchange"in $$props)$$invalidate(16,onchange=$$props.onchange);if("direction"in $$props)$$invalidate(6,direction=$$props.direction);if("getValue"in $$props)$$invalidate(17,getValue=$$props.getValue);if("setValue"in $$props)$$invalidate(18,setValue=$$props.setValue);if("class"in $$props)$$invalidate(7,klass=$$props.class);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*value, getValue*/163840){$$invalidate(8,numberValue=value!==undefined?getValue(value):0);}if($$self.$$.dirty[0]&/*max, min*/3){range=max-min;}if($$self.$$.dirty[0]&/*numberValue, min, max*/259){$$invalidate(19,position=toFraction(numberValue,min,max)*100);}if($$self.$$.dirty[0]&/*direction*/64){$$invalidate(20,axis=direction.toUpperCase());}if($$self.$$.dirty[0]&/*direction*/64){$$invalidate(21,dimension=direction==="x"?"Width":"Height");}if($$self.$$.dirty[0]&/*dimension*/2097152){offsetSizeProp=`offset${dimension}`;}if($$self.$$.dirty[0]&/*axis*/1048576){offsetAxisProp=`offset${axis}`;}if($$self.$$.dirty[0]&/*axis*/1048576){pageAxisProp=`page${axis}`;}if($$self.$$.dirty[0]&/*axis, position*/1572864){$$invalidate(10,knobControllerStyle=`transform: translate${axis}(${position}%)`);}};return[min,max,step,id,trackStyle,knobStyle,direction,klass,numberValue,input,knobControllerStyle,handleInput,handleNudge,handlePointerDown,handleUpdaterDown,value,onchange,getValue,setValue,position,axis,dimension,input_1_binding];}class Slider extends SvelteComponent{constructor(options){super();init(this,options,instance$x,create_fragment$x,safe_not_equal,{min:0,max:1,step:2,id:3,value:15,trackStyle:4,knobStyle:5,onchange:16,direction:6,getValue:17,setValue:18,class:7},[-1,-1]);}}/* src/core/ui/components/ToggleSlider.svelte generated by Svelte v3.37.0 */function create_if_block$9(ctx){let icon_1;let current;icon_1=new Icon({props:{class:"PinturaButtonIcon",$$slots:{default:[create_default_slot$c]},$$scope:{ctx}}});return{c(){create_component(icon_1.$$.fragment);},m(target,anchor){mount_component(icon_1,target,anchor);current=true;},p(ctx,dirty){const icon_1_changes={};if(dirty&/*$$scope, icon*/262148){icon_1_changes.$$scope={dirty,ctx};}icon_1.$set(icon_1_changes);},i(local){if(current)return;transition_in(icon_1.$$.fragment,local);current=true;},o(local){transition_out(icon_1.$$.fragment,local);current=false;},d(detaching){destroy_component(icon_1,detaching);}};}// (51:12) <Icon class="PinturaButtonIcon">
function create_default_slot$c(ctx){let g;return{c(){g=svg_element("g");},m(target,anchor){insert(target,g,anchor);g.innerHTML=/*icon*/ctx[2];},p(ctx,dirty){if(dirty&/*icon*/4)g.innerHTML=/*icon*/ctx[2];},d(detaching){if(detaching)detach(g);}};}// (45:4) 
function create_label_slot$1(ctx){let span1;let t0;let span0;let t1;let span0_class_value;let span1_title_value;let span1_class_value;let current;let if_block=/*icon*/ctx[2]&&create_if_block$9(ctx);return{c(){span1=pintura_element("span");if(if_block)if_block.c();t0=space();span0=pintura_element("span");t1=pintura_text(/*currentLabel*/ctx[8]);attr(span0,"class",span0_class_value=arrayJoin(["PinturaButtonLabel",/*labelClass*/ctx[3],/*hideLabel*/ctx[5]&&"implicit"]));attr(span1,"slot","label");attr(span1,"title",span1_title_value=localize(/*title*/ctx[1],/*locale*/ctx[6]));attr(span1,"class",span1_class_value=arrayJoin(["PinturaButtonInner",/*innerClass*/ctx[4]]));},m(target,anchor){insert(target,span1,anchor);if(if_block)if_block.m(span1,null);append(span1,t0);append(span1,span0);append(span0,t1);current=true;},p(ctx,dirty){if(/*icon*/ctx[2]){if(if_block){if_block.p(ctx,dirty);if(dirty&/*icon*/4){transition_in(if_block,1);}}else{if_block=create_if_block$9(ctx);if_block.c();transition_in(if_block,1);if_block.m(span1,t0);}}else if(if_block){group_outros();transition_out(if_block,1,1,()=>{if_block=null;});check_outros();}if(!current||dirty&/*currentLabel*/256)set_data(t1,/*currentLabel*/ctx[8]);if(!current||dirty&/*labelClass, hideLabel*/40&&span0_class_value!==(span0_class_value=arrayJoin(["PinturaButtonLabel",/*labelClass*/ctx[3],/*hideLabel*/ctx[5]&&"implicit"]))){attr(span0,"class",span0_class_value);}if(!current||dirty&/*title, locale*/66&&span1_title_value!==(span1_title_value=localize(/*title*/ctx[1],/*locale*/ctx[6]))){attr(span1,"title",span1_title_value);}if(!current||dirty&/*innerClass*/16&&span1_class_value!==(span1_class_value=arrayJoin(["PinturaButtonInner",/*innerClass*/ctx[4]]))){attr(span1,"class",span1_class_value);}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(detaching)detach(span1);if(if_block)if_block.d();}};}// (58:4) 
function create_details_slot$1(ctx){let div;let slider;let current;let mounted;let dispose;const slider_spread_levels=[/*$$restProps*/ctx[11],{value:/*value*/ctx[7]},{onchange:/*handleChangeValue*/ctx[10]}];let slider_props={};for(let i=0;i<slider_spread_levels.length;i+=1){slider_props=pintura_assign(slider_props,slider_spread_levels[i]);}slider=new Slider({props:slider_props});return{c(){div=pintura_element("div");create_component(slider.$$.fragment);attr(div,"slot","details");},m(target,anchor){insert(target,div,anchor);mount_component(slider,div,null);current=true;if(!mounted){dispose=listen(div,"keydown",/*handleKeydown*/ctx[9]);mounted=true;}},p(ctx,dirty){const slider_changes=dirty&/*$$restProps, value, handleChangeValue*/3200?get_spread_update(slider_spread_levels,[dirty&/*$$restProps*/2048&&get_spread_object(/*$$restProps*/ctx[11]),dirty&/*value*/128&&{value:/*value*/ctx[7]},dirty&/*handleChangeValue*/1024&&{onchange:/*handleChangeValue*/ctx[10]}]):{};slider.$set(slider_changes);},i(local){if(current)return;transition_in(slider.$$.fragment,local);current=true;},o(local){transition_out(slider.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(slider);mounted=false;dispose();}};}function create_fragment$w(ctx){let details;let current;details=new Details({props:{panelClass:"PinturaSliderPanel",buttonClass:arrayJoin(["PinturaSliderButton",/*klass*/ctx[0],/*hideLabel*/ctx[5]&&"PinturaSliderIconOnly"]),$$slots:{details:[create_details_slot$1],label:[create_label_slot$1]},$$scope:{ctx}}});return{c(){create_component(details.$$.fragment);},m(target,anchor){mount_component(details,target,anchor);current=true;},p(ctx,[dirty]){const details_changes={};if(dirty&/*klass, hideLabel*/33)details_changes.buttonClass=arrayJoin(["PinturaSliderButton",/*klass*/ctx[0],/*hideLabel*/ctx[5]&&"PinturaSliderIconOnly"]);if(dirty&/*$$scope, $$restProps, value, title, locale, innerClass, labelClass, hideLabel, currentLabel, icon*/264702){details_changes.$$scope={dirty,ctx};}details.$set(details_changes);},i(local){if(current)return;transition_in(details.$$.fragment,local);current=true;},o(local){transition_out(details.$$.fragment,local);current=false;},d(detaching){destroy_component(details,detaching);}};}function instance$w($$self,$$props,$$invalidate){const omit_props_names=["class","title","label","icon","labelClass","innerClass","hideLabel","locale","value","onchange"];let $$restProps=compute_rest_props($$props,omit_props_names);let{class:klass=undefined}=$$props;let{title=undefined}=$$props;let{label=value=>Math.round(value)}=$$props;let{icon=undefined}=$$props;let{labelClass=undefined}=$$props;let{innerClass=undefined}=$$props;let{hideLabel=false}=$$props;let{locale=undefined}=$$props;let{value=undefined}=$$props;let{onchange=noop$1}=$$props;const{min,max,getValue=passthrough}=$$restProps;const handleKeydown=e=>{// don't allow tabbing ([tab] is also blocked in normal <select>)
if(/tab/i.test(e.key))e.preventDefault();};const getLabel=value=>pintura_isFunction(label)?label(getValue(value),min,max):label;let currentLabel=getLabel(value);const handleChangeValue=value=>{$$invalidate(8,currentLabel=getLabel(value));onchange(value);};$$self.$$set=$$new_props=>{$$props=pintura_assign(pintura_assign({},$$props),exclude_internal_props($$new_props));$$invalidate(11,$$restProps=compute_rest_props($$props,omit_props_names));if("class"in $$new_props)$$invalidate(0,klass=$$new_props.class);if("title"in $$new_props)$$invalidate(1,title=$$new_props.title);if("label"in $$new_props)$$invalidate(12,label=$$new_props.label);if("icon"in $$new_props)$$invalidate(2,icon=$$new_props.icon);if("labelClass"in $$new_props)$$invalidate(3,labelClass=$$new_props.labelClass);if("innerClass"in $$new_props)$$invalidate(4,innerClass=$$new_props.innerClass);if("hideLabel"in $$new_props)$$invalidate(5,hideLabel=$$new_props.hideLabel);if("locale"in $$new_props)$$invalidate(6,locale=$$new_props.locale);if("value"in $$new_props)$$invalidate(7,value=$$new_props.value);if("onchange"in $$new_props)$$invalidate(13,onchange=$$new_props.onchange);};return[klass,title,icon,labelClass,innerClass,hideLabel,locale,value,currentLabel,handleKeydown,handleChangeValue,$$restProps,label,onchange];}class ToggleSlider extends SvelteComponent{constructor(options){super();init(this,options,instance$w,create_fragment$w,safe_not_equal,{class:0,title:1,label:12,icon:2,labelClass:3,innerClass:4,hideLabel:5,locale:6,value:7,onchange:13});}}/* src/core/ui/components/DynamicComponentTree.svelte generated by Svelte v3.37.0 */function get_each_context$6(ctx,list,i){const child_ctx=ctx.slice();child_ctx[7]=list[i][0];child_ctx[8]=list[i][1];child_ctx[9]=list[i][2];child_ctx[0]=list[i][3];return child_ctx;}// (54:4) {:else}
function create_else_block$3(ctx){let switch_instance;let switch_instance_anchor;let current;const switch_instance_spread_levels=[/*props*/ctx[9]];var switch_value=/*ComponentMap*/ctx[1][/*node*/ctx[7]]||/*node*/ctx[7];function switch_props(ctx){let switch_instance_props={};for(let i=0;i<switch_instance_spread_levels.length;i+=1){switch_instance_props=pintura_assign(switch_instance_props,switch_instance_spread_levels[i]);}return{props:switch_instance_props};}if(switch_value){switch_instance=new switch_value(switch_props());}return{c(){if(switch_instance)create_component(switch_instance.$$.fragment);switch_instance_anchor=empty();},m(target,anchor){if(switch_instance){mount_component(switch_instance,target,anchor);}insert(target,switch_instance_anchor,anchor);current=true;},p(ctx,dirty){const switch_instance_changes=dirty&/*children*/1?get_spread_update(switch_instance_spread_levels,[get_spread_object(/*props*/ctx[9])]):{};if(switch_value!==(switch_value=/*ComponentMap*/ctx[1][/*node*/ctx[7]]||/*node*/ctx[7])){if(switch_instance){group_outros();const old_component=switch_instance;transition_out(old_component.$$.fragment,1,0,()=>{destroy_component(old_component,1);});check_outros();}if(switch_value){switch_instance=new switch_value(switch_props());create_component(switch_instance.$$.fragment);transition_in(switch_instance.$$.fragment,1);mount_component(switch_instance,switch_instance_anchor.parentNode,switch_instance_anchor);}else{switch_instance=null;}}else if(switch_value){switch_instance.$set(switch_instance_changes);}},i(local){if(current)return;if(switch_instance)transition_in(switch_instance.$$.fragment,local);current=true;},o(local){if(switch_instance)transition_out(switch_instance.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(switch_instance_anchor);if(switch_instance)destroy_component(switch_instance,detaching);}};}// (44:4) {#if !isComponent(node)}
function create_if_block$8(ctx){let tag;let current;tag=new Tag({props:{name:/*node*/ctx[7],attributes:/*getElementAttributes*/ctx[2](/*props*/ctx[9]),$$slots:{default:[create_default_slot$b]},$$scope:{ctx}}});return{c(){create_component(tag.$$.fragment);},m(target,anchor){mount_component(tag,target,anchor);current=true;},p(ctx,dirty){const tag_changes={};if(dirty&/*children*/1)tag_changes.name=/*node*/ctx[7];if(dirty&/*children*/1)tag_changes.attributes=/*getElementAttributes*/ctx[2](/*props*/ctx[9]);if(dirty&/*$$scope, children*/4097){tag_changes.$$scope={dirty,ctx};}tag.$set(tag_changes);},i(local){if(current)return;transition_in(tag.$$.fragment,local);current=true;},o(local){transition_out(tag.$$.fragment,local);current=false;},d(detaching){destroy_component(tag,detaching);}};}// (50:38) 
function create_if_block_3$5(ctx){let html_tag;let raw_value=/*props*/ctx[9].innerHTML+"";let html_anchor;return{c(){html_anchor=empty();html_tag=new HtmlTag(html_anchor);},m(target,anchor){html_tag.m(raw_value,target,anchor);insert(target,html_anchor,anchor);},p(ctx,dirty){if(dirty&/*children*/1&&raw_value!==(raw_value=/*props*/ctx[9].innerHTML+""))html_tag.p(raw_value);},i:pintura_noop,o:pintura_noop,d(detaching){if(detaching)detach(html_anchor);if(detaching)html_tag.d();}};}// (48:40) 
function create_if_block_2$7(ctx){let t_value=/*props*/ctx[9].textContent+"";let t;return{c(){t=pintura_text(t_value);},m(target,anchor){insert(target,t,anchor);},p(ctx,dirty){if(dirty&/*children*/1&&t_value!==(t_value=/*props*/ctx[9].textContent+""))set_data(t,t_value);},i:pintura_noop,o:pintura_noop,d(detaching){if(detaching)detach(t);}};}// (46:12) {#if children && children.length}
function create_if_block_1$8(ctx){let dynamiccomponenttree;let current;dynamiccomponenttree=new DynamicComponentTree_1({props:{items:/*children*/ctx[0],discardEmptyItems:true}});return{c(){create_component(dynamiccomponenttree.$$.fragment);},m(target,anchor){mount_component(dynamiccomponenttree,target,anchor);current=true;},p(ctx,dirty){const dynamiccomponenttree_changes={};if(dirty&/*children*/1)dynamiccomponenttree_changes.items=/*children*/ctx[0];dynamiccomponenttree.$set(dynamiccomponenttree_changes);},i(local){if(current)return;transition_in(dynamiccomponenttree.$$.fragment,local);current=true;},o(local){transition_out(dynamiccomponenttree.$$.fragment,local);current=false;},d(detaching){destroy_component(dynamiccomponenttree,detaching);}};}// (45:8) <Tag name={node} attributes={getElementAttributes(props)}>
function create_default_slot$b(ctx){let current_block_type_index;let if_block;let t;let current;const if_block_creators=[create_if_block_1$8,create_if_block_2$7,create_if_block_3$5];const if_blocks=[];function select_block_type_1(ctx,dirty){if(/*children*/ctx[0]&&/*children*/ctx[0].length)return 0;if(/*props*/ctx[9].textContent)return 1;if(/*props*/ctx[9].innerHTML)return 2;return-1;}if(~(current_block_type_index=select_block_type_1(ctx))){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);}return{c(){if(if_block)if_block.c();t=space();},m(target,anchor){if(~current_block_type_index){if_blocks[current_block_type_index].m(target,anchor);}insert(target,t,anchor);current=true;},p(ctx,dirty){let previous_block_index=current_block_type_index;current_block_type_index=select_block_type_1(ctx);if(current_block_type_index===previous_block_index){if(~current_block_type_index){if_blocks[current_block_type_index].p(ctx,dirty);}}else{if(if_block){group_outros();transition_out(if_blocks[previous_block_index],1,1,()=>{if_blocks[previous_block_index]=null;});check_outros();}if(~current_block_type_index){if_block=if_blocks[current_block_type_index];if(!if_block){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);if_block.c();}else{if_block.p(ctx,dirty);}transition_in(if_block,1);if_block.m(t.parentNode,t);}else{if_block=null;}}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(~current_block_type_index){if_blocks[current_block_type_index].d(detaching);}if(detaching)detach(t);}};}// (43:0) {#each children as [node, key, props, children] (key)}
function create_each_block$6(key_1,ctx){let first;let show_if;let current_block_type_index;let if_block;let if_block_anchor;let current;const if_block_creators=[create_if_block$8,create_else_block$3];const if_blocks=[];function select_block_type(ctx,dirty){if(dirty&/*children*/1)show_if=!!!/*isComponent*/ctx[3](/*node*/ctx[7]);if(show_if)return 0;return 1;}current_block_type_index=select_block_type(ctx,-1);if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);return{key:key_1,first:null,c(){first=empty();if_block.c();if_block_anchor=empty();this.first=first;},m(target,anchor){insert(target,first,anchor);if_blocks[current_block_type_index].m(target,anchor);insert(target,if_block_anchor,anchor);current=true;},p(new_ctx,dirty){ctx=new_ctx;let previous_block_index=current_block_type_index;current_block_type_index=select_block_type(ctx,dirty);if(current_block_type_index===previous_block_index){if_blocks[current_block_type_index].p(ctx,dirty);}else{group_outros();transition_out(if_blocks[previous_block_index],1,1,()=>{if_blocks[previous_block_index]=null;});check_outros();if_block=if_blocks[current_block_type_index];if(!if_block){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);if_block.c();}else{if_block.p(ctx,dirty);}transition_in(if_block,1);if_block.m(if_block_anchor.parentNode,if_block_anchor);}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(detaching)detach(first);if_blocks[current_block_type_index].d(detaching);if(detaching)detach(if_block_anchor);}};}function create_fragment$v(ctx){let each_blocks=[];let each_1_lookup=new Map();let each_1_anchor;let current;let each_value=/*children*/ctx[0];const get_key=ctx=>/*key*/ctx[8];for(let i=0;i<each_value.length;i+=1){let child_ctx=get_each_context$6(ctx,each_value,i);let key=get_key(child_ctx);each_1_lookup.set(key,each_blocks[i]=create_each_block$6(key,child_ctx));}return{c(){for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].c();}each_1_anchor=empty();},m(target,anchor){for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].m(target,anchor);}insert(target,each_1_anchor,anchor);current=true;},p(ctx,[dirty]){if(dirty&/*children, getElementAttributes, isComponent, ComponentMap*/15){each_value=/*children*/ctx[0];group_outros();each_blocks=update_keyed_each(each_blocks,dirty,get_key,1,ctx,each_value,each_1_lookup,each_1_anchor.parentNode,outro_and_destroy_block,create_each_block$6,each_1_anchor,get_each_context$6);check_outros();}},i(local){if(current)return;for(let i=0;i<each_value.length;i+=1){transition_in(each_blocks[i]);}current=true;},o(local){for(let i=0;i<each_blocks.length;i+=1){transition_out(each_blocks[i]);}current=false;},d(detaching){for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].d(detaching);}if(detaching)detach(each_1_anchor);}};}function instance$v($$self,$$props,$$invalidate){let children;let{items}=$$props;let{discardEmptyItems=true}=$$props;const ComponentMap={Button,Dropdown,Slider:ToggleSlider};const getElementAttributes=(props={})=>{const{textContent,innerHTML,...attributes}=props;return attributes;};const isComponent=node=>!pintura_isString(node)||!!ComponentMap[node];const shouldRenderItem=item=>{// don't render falsy items
if(!item)return false;// get relevant props
const[node,,props,children=[]]=item;// if item is component, we always render it
if(isComponent(node))return true;// item is tag, we have to check if it has content
return children.some(shouldRenderItem)||props.textContent||props.innerHTML;};$$self.$$set=$$props=>{if("items"in $$props)$$invalidate(4,items=$$props.items);if("discardEmptyItems"in $$props)$$invalidate(5,discardEmptyItems=$$props.discardEmptyItems);};$$self.$$.update=()=>{if($$self.$$.dirty&/*items, discardEmptyItems*/48){$$invalidate(0,children=(items&&discardEmptyItems?items.filter(shouldRenderItem):items)||[]);}};return[children,ComponentMap,getElementAttributes,isComponent,items,discardEmptyItems];}class DynamicComponentTree_1 extends SvelteComponent{constructor(options){super();init(this,options,instance$v,create_fragment$v,safe_not_equal,{items:4,discardEmptyItems:5});}}var smoothstep=(min,max,value,ease=x=>x*x*(3-2*x))=>ease(Math.max(0,Math.min(1,(value-min)/(max-min))));var canvasClone=canvas=>{const clone=h('canvas',{width:canvas.width,height:canvas.height});clone.getContext('2d').drawImage(canvas,0,0);return clone;};const ImageStoreProps=['file','size','loadState','processState','cropAspectRatio','cropLimitToImage','crop','cropMinSize','cropMaxSize','cropRange','cropOrigin','cropRectAspectRatio','rotation','rotationRange','targetSize','flipX','flipY','perspectiveX','perspectiveY','perspective','colorMatrix','convolutionMatrix','gamma','vignette','noise','redaction','decoration','annotation','frame','backgroundColor','state'];const proxy=function(get,set,update){let subscribers=[];return{set,update,publish:value=>{subscribers.forEach(cb=>cb(value));},subscribe:cb=>{subscribers.push(cb);get(cb);return()=>{subscribers=subscribers.filter(item=>item!==cb);};}};};var createImageProxy=()=>{let unsubs;let image;const proxyStores=ImageStoreProps.reduce((prev,curr)=>{prev[curr]=proxy(// getter
cb=>{// subscribe
if(!image)return cb();const unsub=image.stores[curr].subscribe(cb);unsub();},// setter
value=>{// set value on actual store if is defined
if(!image)return;image.stores[curr].set(value);},// updater
cb=>{if(!image)return;image.stores[curr].update(cb);});return prev;},{});const update=newImage=>{image=newImage;if(unsubs){// remove subscribers
unsubs.forEach(unsub=>unsub());unsubs=undefined;}if(!newImage){// need to reset load state
proxyStores['file'].publish(undefined);proxyStores['loadState'].publish(undefined);return;}unsubs=ImageStoreProps.map(prop=>newImage.stores[prop].subscribe(value=>{proxyStores[prop].publish(value);}));};return{update,stores:proxyStores};};var createPingRouter=(route,cancel=true)=>e=>{if(e.type!=='ping')return;if(cancel)e.stopPropagation();route(e.detail.type,e.detail.data);};var createPing=(type,data)=>new CustomEvent('ping',{detail:{type,data},cancelable:true,bubbles:true});var isTextarea=element=>/textarea/i.test(element.nodeName);var isTextInput=node=>/date|email|number|search|text|url/.test(node.type);var isTextField=node=>isTextarea(node)||isTextInput(node);var toKebabCase=(str,abbr)=>{return(abbr?stringReplace(str,abbr):str).replace(/([a-z])([A-Z])/g,'$1-$2').replace(/\s+/g,'-').toLowerCase();};var matchMedia$1=(query,cb)=>{const mql=matchMedia(query);mql.addListener(cb);cb(mql);return{get matches(){return mql.matches;},destroy:()=>mql.removeListener(cb)};};var mediaQueryStore=(query,formatValue=passthrough)=>{const{subscribe,set}=writable(undefined);const mm=matchMedia$1(query,({matches})=>set(formatValue(matches)));return{subscribe,unsubscribe:mm.destroy};};var canPreventNavSwipe=()=>{// if not iOS we can't prevent swipe because it probably isn't a thing
if(!isIOS())return false;// extract version number
const matches=navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/i)||[];const[,major,minor]=matches.map(v=>parseInt(v,10)||0);// is atleast version 13.4+
return major>13||major===13&&minor>=4;};var calculateImageTransforms=(stageRect,rootRect,imageSize,cropRect,imageSelectionRect,imageScale,imagePerspectiveX,imagePerspectiveY,imageRotation,imageFlipX,imageFlipY)=>{if(!stageRect||!rootRect||!imageSize||!cropRect||!imageScale)return undefined;const viewRect=rectNormalizeOffset(rectClone(rootRect));const viewCenter=rectCenter(viewRect);const stageCenter=rectCenter(stageRect);const imageRect=rectCreateFromSize(imageSize);const imageCenter=rectCenter(imageRect);const imagePerspective=vectorCreate(imagePerspectiveX,imagePerspectiveY);// get base crop rect so we can correctly apply transforms
const cropRectBase=getBaseCropRect(imageSize,cropRect,imageRotation);const cropRectBaseCenter=rectCenter(cropRectBase);const imageTranslation=vectorSubtract(vectorClone(imageCenter),cropRectBaseCenter);// calculate stage center offset from view center
const imageOffset=vectorSubtract(vectorClone(stageCenter),viewCenter);// correct for stage offset
imageTranslation.x+=imageOffset.x;imageTranslation.y+=imageOffset.y;// set origin of translation (so rotates around center of selection)
const imageOrigin=vectorInvert(vectorClone(imageTranslation));// correct for stage offset
imageOrigin.x+=imageOffset.x;imageOrigin.y+=imageOffset.y;// correct for image selection offset relative to view
const imageSelectionCenter=rectCenter(rectTranslate(rectClone(imageSelectionRect),stageRect));const imageSelectionOffset=vectorSubtract(imageSelectionCenter,stageCenter);vectorAdd(imageTranslation,imageSelectionOffset);return{// offset: imageOffset,
origin:imageOrigin,translation:imageTranslation,rotation:{x:imageFlipY?Math.PI:0,y:imageFlipX?Math.PI:0,z:imageRotation},perspective:imagePerspective,scale:imageScale};};// @ts-ignore
var historyCreate=(getState,setState)=>{// set up pub/sub for history object
const{sub,pub}=pubsub();// current history state
//let baseState;//
const entries=[];const index=writable(0);const subs=[];const updateSubs=()=>subs.forEach(cb=>cb({index:get_store_value(index),length:entries.length}));const history={get index(){return get_store_value(index);},set index(i){// validate new index
i=Number.isInteger(i)?i:0;i=pintura_clamp(i,0,entries.length-1);// remember
index.set(i);setState(entries[history.index]);// || baseState);
// update subs
updateSubs();},get state(){return entries[entries.length-1];// || baseState;
},length(){return entries.length;},undo(){const newIndex=history.index--;pub('undo',newIndex);return newIndex;},redo(){const newIndex=history.index++;pub('redo',history.index);return newIndex;},revert(){entries.length=1;// retain first state
history.index=0;pub('revert');},write(state){// write history entry
if(state){setState({...getState(),...state});}const newState=getState();const lastState=entries[entries.length-1];// don't update if new state isn't different
if(JSON.stringify(newState)===JSON.stringify(lastState))return;// reset length to current index
entries.length=history.index+1;// add new entry
entries.push(newState);// move pointer to last added index
index.set(entries.length-1);updateSubs();},set(state={}){// set clears all entries
entries.length=0;history.index=0;// set new entries
const newStateEntries=!Array.isArray(state)?[state]:state;// add new entries
entries.push(...newStateEntries);// move pointer to last added index
history.index=entries.length-1;},get(){return[...entries];},subscribe(cb){subs.push(cb);cb({index:history.index,length:entries.length});return()=>subs.splice(subs.indexOf(cb),1);},on:sub};return history;};var isChrome=()=>isBrowser()&&!!window['chrome'];var imageBitmapToImageData=async imageBitmap=>canvasToImageData(await imageDataToCanvas(imageBitmap));var blobToImageBitmap=(file,ImageOrienter,canvasMemoryLimit)=>new Promise((resolve,reject)=>{(async()=>{// get orientation of image, should return 1 for normal orientation
const orientation=await ImageOrienter.read(file);// helper method to apply orientation fix if needed
const toImageData=file=>blobToImageData(file,canvasMemoryLimit).then(imageData=>ImageOrienter.apply(imageData,orientation)).then(resolve).catch(reject);// if cannot create image bitmaps in worker
// Safari 15 cannot correctly apply orientation, also it will choke on very big images when trying to createImageBitmap in thread, so lets just do it on the main thread
// we'll ignore safari for now
if(isSVGFile(file)||!canCreateImageBitmap()||isSafari$1())return toImageData(file);// create image bitmap in thread
let imageBitmap;try{imageBitmap=await thread((file,done)=>createImageBitmap(file).then(bitmap=>done(null,bitmap)).catch(done),[file]);}catch(err){// fails silently on purpose, we'll try to turn the blob into image data in the main thread
// console.error(err);
}// no bitmap returned, something went wrong in `createImageBitmap` logic
if(!imageBitmap||!imageBitmap.width)return toImageData(file);// if the browser can't orient images, we need to correct the orientation now
if(!(await canOrientImages()))return resolve(ImageOrienter.apply(imageBitmap,orientation));// need to convert so oriented image can be used as WebGL texture
// converting ImageBitmap to <canvas> (and then optionally to image data) fixes a Chrome render bug where the
// ImageBitmap when used in WebGL doesn't render in the correct orientation
// https://bugs.chromium.org/p/chromium/issues/detail?id=1082451&q=orientation%20imagebitmap&can=2
if(isChrome()&&orientation>1)return resolve(await imageBitmapToImageData(imageBitmap));// yay we got our bitmap
resolve(imageBitmap);})();});var imageDataContain=(imageData,size)=>new Promise(async resolve=>{if(imageData.width<size.width&&imageData.height<size.height)return resolve(imageData);const scalar=Math.min(size.width/imageData.width,size.height/imageData.height);// scale
const targetWidth=scalar*imageData.width;const targetHeight=scalar*imageData.height;const canvas=h('canvas',{width:targetWidth,height:targetHeight});const ctx=canvas.getContext('2d');const data=isImageData(imageData)?await imageDataToCanvas(imageData):imageData;ctx.drawImage(data,0,0,targetWidth,targetHeight);resolve(canvasToImageData(canvas));});var hexToRGB=str=>{const[,q,w,e]=str.split('');str=str.length===4?`#${q}${q}${w}${w}${e}${e}`:str;const[,r,g,b]=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(str);return[r,g,b].map(v=>parseInt(v,16)/255);};var colorStringToColorArray=color=>{color=color.trim();// if rgba(128, 128, 128, .5)
if(/^rgba/.test(color)){return color.substr(5).split(',').map(parseFloat).map((v,i)=>v/(i===3?1:255));}// if rgb(128, 128, 128)
if(/^rgb/.test(color)){return color.substr(4).split(',').map(parseFloat).map(v=>v/255);}// if #777
if(/^#/.test(color)){return hexToRGB(color);}// is possibly 255, 0, 0
if(/[0-9]{1,3}\s?,\s?[0-9]{1,3}\s?,\s?[0-9]{1,3}/.test(color)){return color.split(',').map(v=>parseInt(v,10)).map(v=>v/255);}};let result$4=null;var supportsWebGL=()=>{if(result$4===null){const canvas=h('canvas');result$4=!!getWebGLContext(canvas);releaseCanvas(canvas);}return result$4;};var isBitmap=file=>/^image/.test(file.type)&&!/svg/.test(file.type);// @ts-ignore
const COLOR_MATRIX_IDENTITY=[1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0];const SPRING_PROPS={precision:0.0001};const SPRING_PROPS_FRACTION={precision:SPRING_PROPS.precision*0.01};var createImage=(data,size,options={})=>{const{resize:resizeInitial=1,opacity:opacityInitial=0}=options;const stores={// interface
opacity:[spring(opacityInitial,{...SPRING_PROPS,stiffness:0.1}),passthrough],resize:[spring(resizeInitial,{...SPRING_PROPS,stiffness:0.1}),passthrough],// transforms
translation:[spring(undefined,SPRING_PROPS),passthrough],rotation:[spring(undefined,SPRING_PROPS_FRACTION),passthrough],origin:[spring(undefined,SPRING_PROPS),passthrough],scale:[spring(undefined,SPRING_PROPS_FRACTION),passthrough],gamma:[spring(undefined,SPRING_PROPS_FRACTION),v=>v||1],vignette:[spring(undefined,SPRING_PROPS_FRACTION),v=>v||0],colorMatrix:[spring([...COLOR_MATRIX_IDENTITY],SPRING_PROPS),v=>v||[...COLOR_MATRIX_IDENTITY]],convolutionMatrix:[writable(undefined),v=>v&&v.clarity||undefined],backgroundColor:[spring(undefined,SPRING_PROPS),passthrough]};// shortcut to quickly get all stores from the stores object
const storeEntries=Object.entries(stores).map(([key,value])=>[key,value[0]]);const storeArray=storeEntries.map(([,store])=>store);// create quick accessors to store value setter functions, best to do ones on creation instead of on each update
const storeSetters=Object.entries(stores).reduce((prev,[key,value])=>{const[store,getValue]=value;prev[key]=(value,opts)=>store.set(getValue(value),opts);return prev;},{});// holds current derived state so can be easily read from from the outside
let stateCache;//
const state=derived(storeArray,storeValues=>{// get new state
stateCache=storeValues.reduce((calculatedState,value,index)=>{const key=storeEntries[index][0];calculatedState[key]=value;return calculatedState;},{});// set base image props
stateCache.data=data;stateCache.size=size;// apply resize modifier (is at index 1 of storeValues)
stateCache.scale*=storeValues[1];return stateCache;});state.get=()=>stateCache;state.set=(props,animate)=>{const opts={hard:!animate};Object.entries(props).forEach(([key,value])=>{if(!storeSetters[key])return;storeSetters[key](value,opts);});};return state;};var storeList=()=>{const stores=[];const subscribers=[];const state=[];const storeDidUpdate=(store,value)=>{const index=stores.indexOf(store);if(index<0)return;state[index]=value;triggerUpdate();};const triggerUpdate=()=>{subscribers.forEach(fn=>fn(state));};const addStore=store=>{store.unsub=store.subscribe(value=>storeDidUpdate(store,value));triggerUpdate();};const unshift=store=>{stores.unshift(store);addStore(store);};const push=store=>{stores.push(store);addStore(store);};const clear=()=>{stores.forEach(store=>store.unsub());stores.length=0;state.length=0;};const remove=store=>{store.unsub();const index=stores.indexOf(store);stores.splice(index,1);state.splice(index,1);};const subscribe=fn=>{subscribers.push(fn);return()=>{subscribers.splice(subscribers.indexOf(fn),1);};};const forEach=fn=>stores.forEach(fn);const filter=fn=>stores.filter(fn);const get=index=>stores[index];return{get length(){return stores.length;},clear,unshift,get,push,remove,forEach,filter,subscribe};};var isDarkColor=color=>{return color[0]<0.25&&color[1]<0.25&&color[2]<0.25;};var browse=()=>new Promise(resolve=>{// create file input box
const fileInput=h('input',{type:'file',accept:'image/*',onchange:()=>{const[file]=fileInput.files;if(!file)return resolve(undefined);resolve(file);}});// open browse window
fileInput.click();});/* src/core/ui/index.svelte generated by Svelte v3.37.0 */const{window:window_1$1}=globals;function create_if_block_1$7(ctx){let t;let if_block1_anchor;let current;let if_block0=/*isStatusVisible*/ctx[26]&&create_if_block_6$1(ctx);let if_block1=/*isReady*/ctx[27]&&create_if_block_2$6(ctx);return{c(){if(if_block0)if_block0.c();t=space();if(if_block1)if_block1.c();if_block1_anchor=empty();},m(target,anchor){if(if_block0)if_block0.m(target,anchor);insert(target,t,anchor);if(if_block1)if_block1.m(target,anchor);insert(target,if_block1_anchor,anchor);current=true;},p(ctx,dirty){if(/*isStatusVisible*/ctx[26]){if(if_block0){if_block0.p(ctx,dirty);if(dirty[0]&/*isStatusVisible*/67108864){transition_in(if_block0,1);}}else{if_block0=create_if_block_6$1(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(t.parentNode,t);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}if(/*isReady*/ctx[27]){if(if_block1){if_block1.p(ctx,dirty);if(dirty[0]&/*isReady*/134217728){transition_in(if_block1,1);}}else{if_block1=create_if_block_2$6(ctx);if_block1.c();transition_in(if_block1,1);if_block1.m(if_block1_anchor.parentNode,if_block1_anchor);}}else if(if_block1){group_outros();transition_out(if_block1,1,1,()=>{if_block1=null;});check_outros();}},i(local){if(current)return;transition_in(if_block0);transition_in(if_block1);current=true;},o(local){transition_out(if_block0);transition_out(if_block1);current=false;},d(detaching){if(if_block0)if_block0.d(detaching);if(detaching)detach(t);if(if_block1)if_block1.d(detaching);if(detaching)detach(if_block1_anchor);}};}// (2476:8) {#if isStatusVisible}
function create_if_block_6$1(ctx){let div;let p;let current_block_type_index;let if_block;let div_style_value;let current;const if_block_creators=[create_if_block_7,create_if_block_8];const if_blocks=[];function select_block_type(ctx,dirty){if(/*isSupportsError*/ctx[23])return 0;if(/*statusState*/ctx[13])return 1;return-1;}if(~(current_block_type_index=select_block_type(ctx))){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);}return{c(){div=pintura_element("div");p=pintura_element("p");if(if_block)if_block.c();attr(p,"style",/*statusTransform*/ctx[39]);attr(div,"class","PinturaStatus");attr(div,"style",div_style_value=`opacity: ${/*$statusOpacity*/ctx[25]}`);},m(target,anchor){insert(target,div,anchor);append(div,p);if(~current_block_type_index){if_blocks[current_block_type_index].m(p,null);}current=true;},p(ctx,dirty){let previous_block_index=current_block_type_index;current_block_type_index=select_block_type(ctx);if(current_block_type_index===previous_block_index){if(~current_block_type_index){if_blocks[current_block_type_index].p(ctx,dirty);}}else{if(if_block){group_outros();transition_out(if_blocks[previous_block_index],1,1,()=>{if_blocks[previous_block_index]=null;});check_outros();}if(~current_block_type_index){if_block=if_blocks[current_block_type_index];if(!if_block){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);if_block.c();}else{if_block.p(ctx,dirty);}transition_in(if_block,1);if_block.m(p,null);}else{if_block=null;}}if(!current||dirty[1]&/*statusTransform*/256){attr(p,"style",/*statusTransform*/ctx[39]);}if(!current||dirty[0]&/*$statusOpacity*/33554432&&div_style_value!==(div_style_value=`opacity: ${/*$statusOpacity*/ctx[25]}`)){attr(div,"style",div_style_value);}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(detaching)detach(div);if(~current_block_type_index){if_blocks[current_block_type_index].d();}}};}// (2489:42) 
function create_if_block_8(ctx){let statusmessage;let t;let if_block_anchor;let current;statusmessage=new StatusMessage({props:{text:/*statusState*/ctx[13].text||"",onmeasure:/*offsetAside*/ctx[127]}});let if_block=/*statusState*/ctx[13].aside&&create_if_block_9(ctx);return{c(){create_component(statusmessage.$$.fragment);t=space();if(if_block)if_block.c();if_block_anchor=empty();},m(target,anchor){mount_component(statusmessage,target,anchor);insert(target,t,anchor);if(if_block)if_block.m(target,anchor);insert(target,if_block_anchor,anchor);current=true;},p(ctx,dirty){const statusmessage_changes={};if(dirty[0]&/*statusState*/8192)statusmessage_changes.text=/*statusState*/ctx[13].text||"";statusmessage.$set(statusmessage_changes);if(/*statusState*/ctx[13].aside){if(if_block){if_block.p(ctx,dirty);if(dirty[0]&/*statusState*/8192){transition_in(if_block,1);}}else{if_block=create_if_block_9(ctx);if_block.c();transition_in(if_block,1);if_block.m(if_block_anchor.parentNode,if_block_anchor);}}else if(if_block){group_outros();transition_out(if_block,1,1,()=>{if_block=null;});check_outros();}},i(local){if(current)return;transition_in(statusmessage.$$.fragment,local);transition_in(if_block);current=true;},o(local){transition_out(statusmessage.$$.fragment,local);transition_out(if_block);current=false;},d(detaching){destroy_component(statusmessage,detaching);if(detaching)detach(t);if(if_block)if_block.d(detaching);if(detaching)detach(if_block_anchor);}};}// (2479:20) {#if isSupportsError}
function create_if_block_7(ctx){let statusmessage;let t;let statusaside;let current;statusmessage=new StatusMessage({props:{text:/*isSupportsError*/ctx[23],onmeasure:/*offsetAside*/ctx[127]}});statusaside=new StatusAside({props:{class:"PinturaStatusIcon",offset:/*$asideOffset*/ctx[43],opacity:/*$asideOpacity*/ctx[44],$$slots:{default:[create_default_slot_4$1]},$$scope:{ctx}}});return{c(){create_component(statusmessage.$$.fragment);t=space();create_component(statusaside.$$.fragment);},m(target,anchor){mount_component(statusmessage,target,anchor);insert(target,t,anchor);mount_component(statusaside,target,anchor);current=true;},p(ctx,dirty){const statusmessage_changes={};if(dirty[0]&/*isSupportsError*/8388608)statusmessage_changes.text=/*isSupportsError*/ctx[23];statusmessage.$set(statusmessage_changes);const statusaside_changes={};if(dirty[1]&/*$asideOffset*/4096)statusaside_changes.offset=/*$asideOffset*/ctx[43];if(dirty[1]&/*$asideOpacity*/8192)statusaside_changes.opacity=/*$asideOpacity*/ctx[44];if(dirty[0]&/*locale*/4|dirty[11]&/*$$scope*/1073741824){statusaside_changes.$$scope={dirty,ctx};}statusaside.$set(statusaside_changes);},i(local){if(current)return;transition_in(statusmessage.$$.fragment,local);transition_in(statusaside.$$.fragment,local);current=true;},o(local){transition_out(statusmessage.$$.fragment,local);transition_out(statusaside.$$.fragment,local);current=false;},d(detaching){destroy_component(statusmessage,detaching);if(detaching)detach(t);destroy_component(statusaside,detaching);}};}// (2492:24) {#if statusState.aside}
function create_if_block_9(ctx){let statusaside;let current;statusaside=new StatusAside({props:{class:"PinturaStatusButton",offset:/*$asideOffset*/ctx[43],opacity:/*$asideOpacity*/ctx[44],$$slots:{default:[create_default_slot_6]},$$scope:{ctx}}});return{c(){create_component(statusaside.$$.fragment);},m(target,anchor){mount_component(statusaside,target,anchor);current=true;},p(ctx,dirty){const statusaside_changes={};if(dirty[1]&/*$asideOffset*/4096)statusaside_changes.offset=/*$asideOffset*/ctx[43];if(dirty[1]&/*$asideOpacity*/8192)statusaside_changes.opacity=/*$asideOpacity*/ctx[44];if(dirty[0]&/*statusState*/8192|dirty[11]&/*$$scope*/1073741824){statusaside_changes.$$scope={dirty,ctx};}statusaside.$set(statusaside_changes);},i(local){if(current)return;transition_in(statusaside.$$.fragment,local);current=true;},o(local){transition_out(statusaside.$$.fragment,local);current=false;},d(detaching){destroy_component(statusaside,detaching);}};}// (2498:32) {#if statusState.progressIndicator.visible}
function create_if_block_11(ctx){let progressindicator;let current;progressindicator=new ProgressIndicator({props:{progress:/*statusState*/ctx[13].progressIndicator.progress}});return{c(){create_component(progressindicator.$$.fragment);},m(target,anchor){mount_component(progressindicator,target,anchor);current=true;},p(ctx,dirty){const progressindicator_changes={};if(dirty[0]&/*statusState*/8192)progressindicator_changes.progress=/*statusState*/ctx[13].progressIndicator.progress;progressindicator.$set(progressindicator_changes);},i(local){if(current)return;transition_in(progressindicator.$$.fragment,local);current=true;},o(local){transition_out(progressindicator.$$.fragment,local);current=false;},d(detaching){destroy_component(progressindicator,detaching);}};}// (2504:32) {#if statusState.closeButton && statusState.text}
function create_if_block_10(ctx){let button;let current;const button_spread_levels=[/*statusState*/ctx[13].closeButton,{hideLabel:true}];let button_props={};for(let i=0;i<button_spread_levels.length;i+=1){button_props=pintura_assign(button_props,button_spread_levels[i]);}button=new Button({props:button_props});return{c(){create_component(button.$$.fragment);},m(target,anchor){mount_component(button,target,anchor);current=true;},p(ctx,dirty){const button_changes=dirty[0]&/*statusState*/8192?get_spread_update(button_spread_levels,[get_spread_object(/*statusState*/ctx[13].closeButton),button_spread_levels[1]]):{};button.$set(button_changes);},i(local){if(current)return;transition_in(button.$$.fragment,local);current=true;},o(local){transition_out(button.$$.fragment,local);current=false;},d(detaching){destroy_component(button,detaching);}};}// (2493:28) <StatusAside                                 class="PinturaStatusButton"                                 offset={$asideOffset}                                 opacity={$asideOpacity}                             >
function create_default_slot_6(ctx){let t;let if_block1_anchor;let current;let if_block0=/*statusState*/ctx[13].progressIndicator.visible&&create_if_block_11(ctx);let if_block1=/*statusState*/ctx[13].closeButton&&/*statusState*/ctx[13].text&&create_if_block_10(ctx);return{c(){if(if_block0)if_block0.c();t=space();if(if_block1)if_block1.c();if_block1_anchor=empty();},m(target,anchor){if(if_block0)if_block0.m(target,anchor);insert(target,t,anchor);if(if_block1)if_block1.m(target,anchor);insert(target,if_block1_anchor,anchor);current=true;},p(ctx,dirty){if(/*statusState*/ctx[13].progressIndicator.visible){if(if_block0){if_block0.p(ctx,dirty);if(dirty[0]&/*statusState*/8192){transition_in(if_block0,1);}}else{if_block0=create_if_block_11(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(t.parentNode,t);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}if(/*statusState*/ctx[13].closeButton&&/*statusState*/ctx[13].text){if(if_block1){if_block1.p(ctx,dirty);if(dirty[0]&/*statusState*/8192){transition_in(if_block1,1);}}else{if_block1=create_if_block_10(ctx);if_block1.c();transition_in(if_block1,1);if_block1.m(if_block1_anchor.parentNode,if_block1_anchor);}}else if(if_block1){group_outros();transition_out(if_block1,1,1,()=>{if_block1=null;});check_outros();}},i(local){if(current)return;transition_in(if_block0);transition_in(if_block1);current=true;},o(local){transition_out(if_block0);transition_out(if_block1);current=false;},d(detaching){if(if_block0)if_block0.d(detaching);if(detaching)detach(t);if(if_block1)if_block1.d(detaching);if(detaching)detach(if_block1_anchor);}};}// (2487:28) <Icon>
function create_default_slot_5(ctx){let g;let raw_value=/*locale*/ctx[2].iconSupportError+"";return{c(){g=svg_element("g");},m(target,anchor){insert(target,g,anchor);g.innerHTML=raw_value;},p(ctx,dirty){if(dirty[0]&/*locale*/4&&raw_value!==(raw_value=/*locale*/ctx[2].iconSupportError+""))g.innerHTML=raw_value;},d(detaching){if(detaching)detach(g);}};}// (2482:24) <StatusAside                             class="PinturaStatusIcon"                             offset={$asideOffset}                             opacity={$asideOpacity}                         >
function create_default_slot_4$1(ctx){let icon;let current;icon=new Icon({props:{$$slots:{default:[create_default_slot_5]},$$scope:{ctx}}});return{c(){create_component(icon.$$.fragment);},m(target,anchor){mount_component(icon,target,anchor);current=true;},p(ctx,dirty){const icon_changes={};if(dirty[0]&/*locale*/4|dirty[11]&/*$$scope*/1073741824){icon_changes.$$scope={dirty,ctx};}icon.$set(icon_changes);},i(local){if(current)return;transition_in(icon.$$.fragment,local);current=true;},o(local){transition_out(icon.$$.fragment,local);current=false;},d(detaching){destroy_component(icon,detaching);}};}// (2514:8) {#if isReady}
function create_if_block_2$6(ctx){let t0;let t1;let current_block_type_index;let if_block2;let t2;let canvas;let t3;let div;let current;let if_block0=/*enableToolbar*/ctx[6]&&create_if_block_5$3(ctx);let if_block1=/*shouldRenderTabs*/ctx[17]&&/*showUtils*/ctx[15]&&create_if_block_4$4(ctx);const if_block_creators=[create_if_block_3$4,create_else_block$2];const if_blocks=[];function select_block_type_1(ctx,dirty){if(/*shouldRenderTabs*/ctx[17])return 0;return 1;}current_block_type_index=select_block_type_1(ctx);if_block2=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);canvas=new Canvas({props:{animate:/*$shouldAnimate*/ctx[18],pixelRatio:/*$pixelRatio*/ctx[47],backgroundColor:/*$rootBackgroundColor*/ctx[48],maskRect:/*$imageSelectionRectPresentation*/ctx[38],maskOpacity:/*imageCanvasState*/ctx[37]?/*imageCanvasState*/ctx[37].maskOpacity:1,maskFrameOpacity:/*$utilSelectedStore*/ctx[49]==="frame"&&/*$stagePadded*/ctx[50]?0:0.95,images:/*$activeImages*/ctx[22],interfaceImages:/*$interfaceImages*/ctx[51],loadImageData:/*imageSourceToImageData*/ctx[8],willRender:/*func_2*/ctx[284]}});return{c(){if(if_block0)if_block0.c();t0=space();if(if_block1)if_block1.c();t1=space();if_block2.c();t2=space();create_component(canvas.$$.fragment);t3=space();div=pintura_element("div");attr(div,"class","PinturaRootPortal");},m(target,anchor){if(if_block0)if_block0.m(target,anchor);insert(target,t0,anchor);if(if_block1)if_block1.m(target,anchor);insert(target,t1,anchor);if_blocks[current_block_type_index].m(target,anchor);insert(target,t2,anchor);mount_component(canvas,target,anchor);insert(target,t3,anchor);insert(target,div,anchor);/*div_binding*/ctx[285](div);current=true;},p(ctx,dirty){if(/*enableToolbar*/ctx[6]){if(if_block0){if_block0.p(ctx,dirty);if(dirty[0]&/*enableToolbar*/64){transition_in(if_block0,1);}}else{if_block0=create_if_block_5$3(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(t0.parentNode,t0);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}if(/*shouldRenderTabs*/ctx[17]&&/*showUtils*/ctx[15]){if(if_block1){if_block1.p(ctx,dirty);if(dirty[0]&/*shouldRenderTabs, showUtils*/163840){transition_in(if_block1,1);}}else{if_block1=create_if_block_4$4(ctx);if_block1.c();transition_in(if_block1,1);if_block1.m(t1.parentNode,t1);}}else if(if_block1){group_outros();transition_out(if_block1,1,1,()=>{if_block1=null;});check_outros();}let previous_block_index=current_block_type_index;current_block_type_index=select_block_type_1(ctx);if(current_block_type_index===previous_block_index){if_blocks[current_block_type_index].p(ctx,dirty);}else{group_outros();transition_out(if_blocks[previous_block_index],1,1,()=>{if_blocks[previous_block_index]=null;});check_outros();if_block2=if_blocks[current_block_type_index];if(!if_block2){if_block2=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);if_block2.c();}else{if_block2.p(ctx,dirty);}transition_in(if_block2,1);if_block2.m(t2.parentNode,t2);}const canvas_changes={};if(dirty[0]&/*$shouldAnimate*/262144)canvas_changes.animate=/*$shouldAnimate*/ctx[18];if(dirty[1]&/*$pixelRatio*/65536)canvas_changes.pixelRatio=/*$pixelRatio*/ctx[47];if(dirty[1]&/*$rootBackgroundColor*/131072)canvas_changes.backgroundColor=/*$rootBackgroundColor*/ctx[48];if(dirty[1]&/*$imageSelectionRectPresentation*/128)canvas_changes.maskRect=/*$imageSelectionRectPresentation*/ctx[38];if(dirty[1]&/*imageCanvasState*/64)canvas_changes.maskOpacity=/*imageCanvasState*/ctx[37]?/*imageCanvasState*/ctx[37].maskOpacity:1;if(dirty[1]&/*$utilSelectedStore, $stagePadded*/786432)canvas_changes.maskFrameOpacity=/*$utilSelectedStore*/ctx[49]==="frame"&&/*$stagePadded*/ctx[50]?0:0.95;if(dirty[0]&/*$activeImages*/4194304)canvas_changes.images=/*$activeImages*/ctx[22];if(dirty[1]&/*$interfaceImages*/1048576)canvas_changes.interfaceImages=/*$interfaceImages*/ctx[51];if(dirty[0]&/*imageSourceToImageData*/256)canvas_changes.loadImageData=/*imageSourceToImageData*/ctx[8];if(dirty[0]&/*willRenderCanvas, blendShapes*/536870944|dirty[1]&/*$imageAnnotation, $imageDecoration, $imageFrame, $imageOverlay*/31457280)canvas_changes.willRender=/*func_2*/ctx[284];canvas.$set(canvas_changes);},i(local){if(current)return;transition_in(if_block0);transition_in(if_block1);transition_in(if_block2);transition_in(canvas.$$.fragment,local);current=true;},o(local){transition_out(if_block0);transition_out(if_block1);transition_out(if_block2);transition_out(canvas.$$.fragment,local);current=false;},d(detaching){if(if_block0)if_block0.d(detaching);if(detaching)detach(t0);if(if_block1)if_block1.d(detaching);if(detaching)detach(t1);if_blocks[current_block_type_index].d(detaching);if(detaching)detach(t2);destroy_component(canvas,detaching);if(detaching)detach(t3);if(detaching)detach(div);/*div_binding*/ctx[285](null);}};}// (2515:12) {#if enableToolbar}
function create_if_block_5$3(ctx){let div;let dynamiccomponenttree;let current;let mounted;let dispose;dynamiccomponenttree=new DynamicComponentTree_1({props:{items:/*toolbarItems*/ctx[40]}});return{c(){div=pintura_element("div");create_component(dynamiccomponenttree.$$.fragment);attr(div,"class","PinturaNav PinturaNavTools");},m(target,anchor){insert(target,div,anchor);mount_component(dynamiccomponenttree,div,null);current=true;if(!mounted){dispose=[listen(div,"measure",/*measure_handler*/ctx[269]),action_destroyer(measurable.call(null,div))];mounted=true;}},p(ctx,dirty){const dynamiccomponenttree_changes={};if(dirty[1]&/*toolbarItems*/512)dynamiccomponenttree_changes.items=/*toolbarItems*/ctx[40];dynamiccomponenttree.$set(dynamiccomponenttree_changes);},i(local){if(current)return;transition_in(dynamiccomponenttree.$$.fragment,local);current=true;},o(local){transition_out(dynamiccomponenttree.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(dynamiccomponenttree);mounted=false;run_all(dispose);}};}// (2525:12) {#if shouldRenderTabs && showUtils}
function create_if_block_4$4(ctx){let div;let scrollable;let current;scrollable=new Scrollable({props:{elasticity:/*elasticityMultiplier*/ctx[4]*scrollElasticity,scrollDirection:/*isLandscape*/ctx[35]?"y":"x",$$slots:{default:[create_default_slot_1$4]},$$scope:{ctx}}});return{c(){div=pintura_element("div");create_component(scrollable.$$.fragment);attr(div,"class","PinturaNav PinturaNavMain");},m(target,anchor){insert(target,div,anchor);mount_component(scrollable,div,null);current=true;},p(ctx,dirty){const scrollable_changes={};if(dirty[0]&/*elasticityMultiplier*/16)scrollable_changes.elasticity=/*elasticityMultiplier*/ctx[4]*scrollElasticity;if(dirty[1]&/*isLandscape*/16)scrollable_changes.scrollDirection=/*isLandscape*/ctx[35]?"y":"x";if(dirty[0]&/*utilSelected*/524288|dirty[1]&/*tabsConfig, tabs*/3|dirty[11]&/*$$scope*/1073741824){scrollable_changes.$$scope={dirty,ctx};}scrollable.$set(scrollable_changes);},i(local){if(current)return;transition_in(scrollable.$$.fragment,local);current=true;},o(local){transition_out(scrollable.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(scrollable);}};}// (2537:28) <Icon>
function create_default_slot_3$1(ctx){let g;let raw_value=/*tab*/ctx[370].icon+"";return{c(){g=svg_element("g");},m(target,anchor){insert(target,g,anchor);g.innerHTML=raw_value;},p(ctx,dirty){if(dirty[11]&/*tab*/536870912&&raw_value!==(raw_value=/*tab*/ctx[370].icon+""))g.innerHTML=raw_value;},d(detaching){if(detaching)detach(g);}};}// (2531:24) <TabList                             {...tabsConfig}                             {tabs}                             on:select={({ detail }) => (utilSelected = detail)}                             let:tab                         >
function create_default_slot_2$3(ctx){let icon;let t0;let span;let t1_value=/*tab*/ctx[370].label+"";let t1;let current;icon=new Icon({props:{$$slots:{default:[create_default_slot_3$1]},$$scope:{ctx}}});return{c(){create_component(icon.$$.fragment);t0=space();span=pintura_element("span");t1=pintura_text(t1_value);},m(target,anchor){mount_component(icon,target,anchor);insert(target,t0,anchor);insert(target,span,anchor);append(span,t1);current=true;},p(ctx,dirty){const icon_changes={};if(dirty[11]&/*$$scope, tab*/1610612736){icon_changes.$$scope={dirty,ctx};}icon.$set(icon_changes);if((!current||dirty[11]&/*tab*/536870912)&&t1_value!==(t1_value=/*tab*/ctx[370].label+""))set_data(t1,t1_value);},i(local){if(current)return;transition_in(icon.$$.fragment,local);current=true;},o(local){transition_out(icon.$$.fragment,local);current=false;},d(detaching){destroy_component(icon,detaching);if(detaching)detach(t0);if(detaching)detach(span);}};}// (2527:20) <Scrollable                         elasticity={elasticityMultiplier * scrollElasticity}                         scrollDirection={isLandscape ? 'y' : 'x'}                     >
function create_default_slot_1$4(ctx){let tablist;let current;const tablist_spread_levels=[/*tabsConfig*/ctx[31],{tabs:/*tabs*/ctx[32]}];let tablist_props={$$slots:{default:[create_default_slot_2$3,({tab})=>({370:tab}),({tab})=>[0,0,0,0,0,0,0,0,0,0,0,tab?536870912:0]]},$$scope:{ctx}};for(let i=0;i<tablist_spread_levels.length;i+=1){tablist_props=pintura_assign(tablist_props,tablist_spread_levels[i]);}tablist=new TabList({props:tablist_props});tablist.$on("select",/*select_handler*/ctx[270]);return{c(){create_component(tablist.$$.fragment);},m(target,anchor){mount_component(tablist,target,anchor);current=true;},p(ctx,dirty){const tablist_changes=dirty[1]&/*tabsConfig, tabs*/3?get_spread_update(tablist_spread_levels,[dirty[1]&/*tabsConfig*/1&&get_spread_object(/*tabsConfig*/ctx[31]),dirty[1]&/*tabs*/2&&{tabs:/*tabs*/ctx[32]}]):{};if(dirty[11]&/*$$scope, tab*/1610612736){tablist_changes.$$scope={dirty,ctx};}tablist.$set(tablist_changes);},i(local){if(current)return;transition_in(tablist.$$.fragment,local);current=true;},o(local){transition_out(tablist.$$.fragment,local);current=false;},d(detaching){destroy_component(tablist,detaching);}};}// (2570:12) {:else}
function create_else_block$2(ctx){let panel;let updating_component;let current;function panel_component_binding_1(value){/*panel_component_binding_1*/ctx[279](value);}let panel_props={class:"PinturaMain",content:{.../*utilsMerged*/ctx[20].find(/*func_1*/ctx[278]),props:/*pluginOptions*/ctx[7][/*utilSelected*/ctx[19]]},locale:/*locale*/ctx[2],isAnimated:/*$shouldAnimate*/ctx[18],stores:/*utilStores*/ctx[116]};if(/*pluginInterface*/ctx[0][/*utilSelected*/ctx[19]]!==void 0){panel_props.component=/*pluginInterface*/ctx[0][/*utilSelected*/ctx[19]];}panel=new Panel({props:panel_props});binding_callbacks.push(()=>bind(panel,"component",panel_component_binding_1));panel.$on("measure",/*measure_handler_3*/ctx[280]);panel.$on("show",/*show_handler_1*/ctx[281]);panel.$on("hide",/*hide_handler_1*/ctx[282]);panel.$on("fade",/*fade_handler_1*/ctx[283]);return{c(){create_component(panel.$$.fragment);},m(target,anchor){mount_component(panel,target,anchor);current=true;},p(ctx,dirty){const panel_changes={};if(dirty[0]&/*utilsMerged, utilSelected, pluginOptions*/1572992)panel_changes.content={.../*utilsMerged*/ctx[20].find(/*func_1*/ctx[278]),props:/*pluginOptions*/ctx[7][/*utilSelected*/ctx[19]]};if(dirty[0]&/*locale*/4)panel_changes.locale=/*locale*/ctx[2];if(dirty[0]&/*$shouldAnimate*/262144)panel_changes.isAnimated=/*$shouldAnimate*/ctx[18];if(!updating_component&&dirty[0]&/*pluginInterface, utilSelected*/524289){updating_component=true;panel_changes.component=/*pluginInterface*/ctx[0][/*utilSelected*/ctx[19]];add_flush_callback(()=>updating_component=false);}panel.$set(panel_changes);},i(local){if(current)return;transition_in(panel.$$.fragment,local);current=true;},o(local){transition_out(panel.$$.fragment,local);current=false;},d(detaching){destroy_component(panel,detaching);}};}// (2544:12) {#if shouldRenderTabs}
function create_if_block_3$4(ctx){let tabpanels;let current;const tabpanels_spread_levels=[{class:"PinturaMain"},{visible:/*utilsVisible*/ctx[28]},/*tabsConfig*/ctx[31],{panels:/*panels*/ctx[33]}];let tabpanels_props={$$slots:{default:[create_default_slot$a,({panel})=>({369:panel}),({panel})=>[0,0,0,0,0,0,0,0,0,0,0,panel?268435456:0]]},$$scope:{ctx}};for(let i=0;i<tabpanels_spread_levels.length;i+=1){tabpanels_props=pintura_assign(tabpanels_props,tabpanels_spread_levels[i]);}tabpanels=new TabPanels({props:tabpanels_props});tabpanels.$on("measure",/*measure_handler_2*/ctx[277]);return{c(){create_component(tabpanels.$$.fragment);},m(target,anchor){mount_component(tabpanels,target,anchor);current=true;},p(ctx,dirty){const tabpanels_changes=dirty[0]&/*utilsVisible*/268435456|dirty[1]&/*tabsConfig, panels*/5?get_spread_update(tabpanels_spread_levels,[tabpanels_spread_levels[0],dirty[0]&/*utilsVisible*/268435456&&{visible:/*utilsVisible*/ctx[28]},dirty[1]&/*tabsConfig*/1&&get_spread_object(/*tabsConfig*/ctx[31]),dirty[1]&/*panels*/4&&{panels:/*panels*/ctx[33]}]):{};if(dirty[0]&/*utilsMerged, pluginOptions, locale, utilSelected, $shouldAnimate, pluginInterface, utilsVisible, utilsVisibleFraction*/272367749|dirty[1]&/*$utilRect*/32768|dirty[11]&/*$$scope, panel*/1342177280){tabpanels_changes.$$scope={dirty,ctx};}tabpanels.$set(tabpanels_changes);},i(local){if(current)return;transition_in(tabpanels.$$.fragment,local);current=true;},o(local){transition_out(tabpanels.$$.fragment,local);current=false;},d(detaching){destroy_component(tabpanels,detaching);}};}// (2545:16) <TabPanels                     class="PinturaMain"                     visible={utilsVisible}                     {...tabsConfig}                     {panels}                     let:panel                     on:measure={(e) => ($tabRect = e.detail)}                 >
function create_default_slot$a(ctx){let panel;let updating_component;let current;function func(...args){return/*func*/ctx[271](/*panel*/ctx[369],...args);}function panel_component_binding(value){/*panel_component_binding*/ctx[272](value,/*panel*/ctx[369]);}function show_handler(){return/*show_handler*/ctx[274](/*panel*/ctx[369]);}function hide_handler(){return/*hide_handler*/ctx[275](/*panel*/ctx[369]);}function fade_handler(...args){return/*fade_handler*/ctx[276](/*panel*/ctx[369],...args);}let panel_props={content:{.../*utilsMerged*/ctx[20].find(func),props:/*pluginOptions*/ctx[7][/*panel*/ctx[369]]},locale:/*locale*/ctx[2],isActive:/*panel*/ctx[369]===/*utilSelected*/ctx[19],isAnimated:/*$shouldAnimate*/ctx[18],stores:/*utilStores*/ctx[116]};if(/*pluginInterface*/ctx[0][/*panel*/ctx[369]]!==void 0){panel_props.component=/*pluginInterface*/ctx[0][/*panel*/ctx[369]];}panel=new Panel({props:panel_props});binding_callbacks.push(()=>bind(panel,"component",panel_component_binding));panel.$on("measure",/*measure_handler_1*/ctx[273]);panel.$on("show",show_handler);panel.$on("hide",hide_handler);panel.$on("fade",fade_handler);return{c(){create_component(panel.$$.fragment);},m(target,anchor){mount_component(panel,target,anchor);current=true;},p(new_ctx,dirty){ctx=new_ctx;const panel_changes={};if(dirty[0]&/*utilsMerged, pluginOptions*/1048704|dirty[11]&/*panel*/268435456)panel_changes.content={.../*utilsMerged*/ctx[20].find(func),props:/*pluginOptions*/ctx[7][/*panel*/ctx[369]]};if(dirty[0]&/*locale*/4)panel_changes.locale=/*locale*/ctx[2];if(dirty[0]&/*utilSelected*/524288|dirty[11]&/*panel*/268435456)panel_changes.isActive=/*panel*/ctx[369]===/*utilSelected*/ctx[19];if(dirty[0]&/*$shouldAnimate*/262144)panel_changes.isAnimated=/*$shouldAnimate*/ctx[18];if(!updating_component&&dirty[0]&/*pluginInterface*/1|dirty[11]&/*panel*/268435456){updating_component=true;panel_changes.component=/*pluginInterface*/ctx[0][/*panel*/ctx[369]];add_flush_callback(()=>updating_component=false);}panel.$set(panel_changes);},i(local){if(current)return;transition_in(panel.$$.fragment,local);current=true;},o(local){transition_out(panel.$$.fragment,local);current=false;},d(detaching){destroy_component(panel,detaching);}};}// (2632:4) {#if $disabledTransition > 0}
function create_if_block$7(ctx){let span;let span_style_value;return{c(){span=pintura_element("span");attr(span,"class","PinturaEditorOverlay");attr(span,"style",span_style_value=`opacity:${/*$disabledTransition*/ctx[56]}`);},m(target,anchor){insert(target,span,anchor);},p(ctx,dirty){if(dirty[1]&/*$disabledTransition*/33554432&&span_style_value!==(span_style_value=`opacity:${/*$disabledTransition*/ctx[56]}`)){attr(span,"style",span_style_value);}},d(detaching){if(detaching)detach(span);}};}function create_fragment$u(ctx){let div;let t;let current;let mounted;let dispose;add_render_callback(/*onwindowresize*/ctx[268]);let if_block0=/*canRender*/ctx[41]&&create_if_block_1$7(ctx);let if_block1=/*$disabledTransition*/ctx[56]>0&&create_if_block$7(ctx);return{c(){div=pintura_element("div");if(if_block0)if_block0.c();t=space();if(if_block1)if_block1.c();attr(div,"id",/*id*/ctx[3]);attr(div,"class",/*className*/ctx[34]);attr(div,"data-env",/*envStr*/ctx[36]);},m(target,anchor){insert(target,div,anchor);if(if_block0)if_block0.m(div,null);append(div,t);if(if_block1)if_block1.m(div,null);/*div_binding_1*/ctx[286](div);current=true;if(!mounted){dispose=[listen(window_1$1,"keydown",/*handleKeydown*/ctx[132]),listen(window_1$1,"keyup",/*handleKeyup*/ctx[133]),listen(window_1$1,"blur",/*handleWindowBlur*/ctx[134]),listen(window_1$1,"paste",/*handlePaste*/ctx[138]),listen(window_1$1,"resize",/*onwindowresize*/ctx[268]),listen(div,"ping",function(){if(is_function(/*routePing*/ctx[42]))/*routePing*/ctx[42].apply(this,arguments);}),listen(div,"contextmenu",/*handleContextMenu*/ctx[135]),listen(div,"touchstart",/*handleTouchStart*/ctx[128],{passive:false}),listen(div,"touchmove",/*handleTouchMove*/ctx[129]),listen(div,"pointermove",/*handlePointerMove*/ctx[130]),listen(div,"transitionend",/*handleTransitionEnd*/ctx[117]),listen(div,"dropfiles",/*handleDropFiles*/ctx[136]),listen(div,"measure",/*measure_handler_4*/ctx[287]),listen(div,"click",function(){if(is_function(/*isWaitingForImage*/ctx[24]?/*browseFileSystem*/ctx[137]:noop$1))(/*isWaitingForImage*/ctx[24]?/*browseFileSystem*/ctx[137]:noop$1).apply(this,arguments);}),action_destroyer(measurable.call(null,div,{observeViewRect:true})),action_destroyer(focusvisible.call(null,div)),action_destroyer(dropable.call(null,div))];mounted=true;}},p(new_ctx,dirty){ctx=new_ctx;if(/*canRender*/ctx[41]){if(if_block0){if_block0.p(ctx,dirty);if(dirty[1]&/*canRender*/1024){transition_in(if_block0,1);}}else{if_block0=create_if_block_1$7(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(div,t);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}if(/*$disabledTransition*/ctx[56]>0){if(if_block1){if_block1.p(ctx,dirty);}else{if_block1=create_if_block$7(ctx);if_block1.c();if_block1.m(div,null);}}else if(if_block1){if_block1.d(1);if_block1=null;}if(!current||dirty[0]&/*id*/8){attr(div,"id",/*id*/ctx[3]);}if(!current||dirty[1]&/*className*/8){attr(div,"class",/*className*/ctx[34]);}if(!current||dirty[1]&/*envStr*/32){attr(div,"data-env",/*envStr*/ctx[36]);}},i(local){if(current)return;transition_in(if_block0);current=true;},o(local){transition_out(if_block0);current=false;},d(detaching){if(detaching)detach(div);if(if_block0)if_block0.d();if(if_block1)if_block1.d();/*div_binding_1*/ctx[286](null);mounted=false;run_all(dispose);}};}const imageCropRectElasticity=5;// updating crop selection / the intended selection rect, combined with actual selection rect, used to render elasticity visualisation
const imageSelectionRectElasticity=1;const STAGE_OVERLAY_ID="stage-overlay";const maxOpacity=0.85;const scrollElasticity=10;const rangeInputElasticity=5;function instance$u($$self,$$props,$$invalidate){let isOverlayModeEnabled;let showUtils;let maxImageDataSize;let preprocessShape;let imageTargetSizeCurrent;let overlayTop;let overlayBottom;let overlayLeft;let overlayRight;let gradientOverlays;let canAnimate;let acceptsAnimations;let canUndo;let canRedo;let utilsFiltered;let utilsAvailable;let utilsDefined;let utilsMerged;let utilSelected;let utilTools;let utilsVisibleFraction;let tabsConfig;let tabs;let panels;let shouldRenderTabs;let className;let horizontalSpace;let hasLimitedSpace;let verticalSpace;let isModal;let isCenteredHorizontally;let isCenteredVertically;let isCentered;let isNarrow;let orientation;let isLandscape;let isCompact;let hasSwipeNavigation;let shouldRenderUtilTools;let navigationHorizontalPreference;let navigationVerticalPreference;let rootElementComputedStyle;let envStr;let imageCanvasState;let hasProps;let missingFeatures;let isSupportsError;let isStartLoadingImageSource;let isImageLoadError;let isWaitingForImage;let imageLoadProgress;let isLoadingImageData;let isCreatingImagePreview;let isProcessingImage;let imageLoadShowProgressIndicator;let imageLoadStatusLabel;let imageProcessStatusLabel;let imageProcessProgress;let imageProcessShowProgressIndicator;let isImageProcessingError;let isCustomStatus;let isStatusActive;let isStatusVisible;let hasAside;let statusIndent;let statusTransform;let toolbarItems;let hasClientRect;let canRender;let hasImageRedaction;let imageRedactionScalar;let routePing;let isReady;let $images;let $shapePreprocessor;let $clientRect;let $imageCropAspectRatio;let $rootRect;let $imageLoadState;let $imageCropRect;let $imageCropRectIntent;let $isInteracting;let $imageCropRectSnapshot;let $previewShouldUpscale;let $imageSelectionRect;let $shouldAnimate;let $imageSelectionRectIntent;let $stageRect;let $imageOutputSize;let $stageScalar;let $imageSize;let $presentationScalar;let $imageSelectionRectSnapshot;let $overlayInset;let $imageVisualBounds;let $overlaySize;let $overlayTopOpacity;let $overlayBottomOpacity;let $overlayLeftOpacity;let $overlayRightOpacity;let $imageOverlayMarkup;let $imageFile;let $imagePreview,$$unsubscribe_imagePreview=pintura_noop,$$subscribe_imagePreview=()=>($$unsubscribe_imagePreview(),$$unsubscribe_imagePreview=subscribe(imagePreview,$$value=>$$invalidate(205,$imagePreview=$$value)),imagePreview);let $imagePreviewSource;let $prefersReducedMotion;let $imageState;let $tabRect;let $history,$$unsubscribe_history=pintura_noop,$$subscribe_history=()=>($$unsubscribe_history(),$$unsubscribe_history=subscribe(history,$$value=>$$invalidate(211,$history=$$value)),history);let $imageProcessingPreparing;let $env;let $pointerAccuracy;let $pointerHoverable;let $imageTransforms;let $imagePreviewModifiers;let $imageProps;let $activeImages;let $imageSelectionRectPresentation;let $imageVisualLoadComplete;let $imageProcessState;let $wasProcessingImage;let $statusOpacity;let $statusWidth;let $asideWidth;let $statusOffset;let $pressedKeysStore;let $imageRedaction;let $imageScrambler;let $imageBackgroundColor;let $rootForegroundColor;let $rootLineColor;let $isInteractingFraction;let $asideOffset;let $asideOpacity;let $toolRect;let $utilRect;let $pixelRatio;let $rootBackgroundColor;let $utilSelectedStore;let $stagePadded;let $interfaceImages;let $imageAnnotation;let $imageDecoration;let $imageFrame;let $imageOverlay;let $disabledTransition;component_subscribe($$self,prefersReducedMotion,$$value=>$$invalidate(209,$prefersReducedMotion=$$value));$$self.$$.on_destroy.push(()=>$$unsubscribe_imagePreview());$$self.$$.on_destroy.push(()=>$$unsubscribe_history());const eventProxy=pubsub();const dispatch=createEventDispatcher();//
// View Props
//
let{class:klass=undefined}=$$props;let{layout:layoutMode=undefined}=$$props;let{stores}=$$props;let{locale=undefined}=$$props;let{id=undefined}=$$props;let{util=undefined}=$$props;let{utils=undefined}=$$props;// which utils are active (list of ids), or is derived from plugins automatically
let{animations="auto"}=$$props;let{disabled=false}=$$props;let{status=undefined}=$$props;let{previewUpscale=false}=$$props;let{elasticityMultiplier=10}=$$props;let{willRevert=()=>Promise.resolve(true)}=$$props;let{willProcessImage=()=>Promise.resolve(true)}=$$props;let{willRenderCanvas=passthrough}=$$props;let{willRenderToolbar=passthrough}=$$props;let{willSetHistoryInitialState=passthrough}=$$props;let{enableButtonExport=true}=$$props;let{enableButtonRevert=true}=$$props;let{enableNavigateHistory=true}=$$props;let{enableToolbar=true}=$$props;let{enableUtils=true}=$$props;let{enableButtonClose=false}=$$props;let{enableDropImage=false}=$$props;let{enablePasteImage=false}=$$props;let{enableBrowseImage=false}=$$props;let{previewImageDataMaxSize=undefined}=$$props;let{layoutDirectionPreference="auto"}=$$props;let{layoutHorizontalUtilsPreference="left"}=$$props;let{layoutVerticalUtilsPreference="bottom"}=$$props;let{imagePreviewSrc=undefined}=$$props;let{imageOrienter={read:()=>1,apply:v=>v}}=$$props;let{pluginComponents=undefined}=$$props;let{pluginOptions={}}=$$props;const sub=eventProxy.sub;const pluginInterface={};let{root}=$$props;let registeredPluginsComponents=[];// editor disabled spring for animating in and out disabled state
const disabledTransition=spring();component_subscribe($$self,disabledTransition,value=>$$invalidate(56,$disabledTransition=value));// this method is used to read image resources (preview image / shape images)
const glMaxTextureSize=getWebGLTextureSizeLimit()||1024;const maxTextureSize=sizeCreate(glMaxTextureSize,glMaxTextureSize);const canvasMemoryLimit=getCanvasMemoryLimit();let{imageSourceToImageData=src=>pintura_isString(src)?// it's a url src
fetch(src).then(res=>{if(res.status!==200)throw`${res.status} (${res.statusText})`;return res.blob();}).then(blob=>blobToImageBitmap(blob,imageOrienter,canvasMemoryLimit)).then(imageData=>imageDataContain(imageData,maxImageDataSize)):pintura_isElement(src)?// assume src is a <canvas>
new Promise(resolve=>resolve(canvasToImageData(src))):// assume src is a File or Blob
blobToImageBitmap(src,imageOrienter,canvasMemoryLimit).then(imageData=>imageDataContain(imageData,maxImageDataSize))}=$$props;const imageProxy=createImageProxy();const{file:imageFile,size:imageSize,loadState:imageLoadState,processState:imageProcessState,cropAspectRatio:imageCropAspectRatio,cropLimitToImage:imageCropLimitToImage,crop:imageCropRect,cropMinSize:imageCropMinSize,cropMaxSize:imageCropMaxSize,cropRange:imageCropRange,cropOrigin:imageCropRectOrigin,cropRectAspectRatio:imageCropRectAspectRatio,rotation:imageRotation,rotationRange:imageRotationRange,targetSize:imageOutputSize,flipX:imageFlipX,flipY:imageFlipY,backgroundColor:imageBackgroundColor,colorMatrix:imageColorMatrix,convolutionMatrix:imageConvolutionMatrix,gamma:imageGamma,vignette:imageVignette,noise:imageNoise,decoration:imageDecoration,annotation:imageAnnotation,redaction:imageRedaction,frame:imageFrame,state:imageState}=imageProxy.stores;component_subscribe($$self,imageFile,value=>$$invalidate(204,$imageFile=value));component_subscribe($$self,imageSize,value=>$$invalidate(189,$imageSize=value));component_subscribe($$self,imageLoadState,value=>$$invalidate(183,$imageLoadState=value));component_subscribe($$self,imageProcessState,value=>$$invalidate(247,$imageProcessState=value));component_subscribe($$self,imageCropAspectRatio,value=>$$invalidate(295,$imageCropAspectRatio=value));component_subscribe($$self,imageCropRect,value=>$$invalidate(184,$imageCropRect=value));component_subscribe($$self,imageOutputSize,value=>$$invalidate(188,$imageOutputSize=value));component_subscribe($$self,imageBackgroundColor,value=>$$invalidate(267,$imageBackgroundColor=value));component_subscribe($$self,imageDecoration,value=>$$invalidate(53,$imageDecoration=value));component_subscribe($$self,imageAnnotation,value=>$$invalidate(52,$imageAnnotation=value));component_subscribe($$self,imageRedaction,value=>$$invalidate(264,$imageRedaction=value));component_subscribe($$self,imageFrame,value=>$$invalidate(54,$imageFrame=value));component_subscribe($$self,imageState,value=>$$invalidate(304,$imageState=value));const{images,shapePreprocessor,imageScrambler}=stores;component_subscribe($$self,images,value=>$$invalidate(180,$images=value));component_subscribe($$self,shapePreprocessor,value=>$$invalidate(181,$shapePreprocessor=value));component_subscribe($$self,imageScrambler,value=>$$invalidate(266,$imageScrambler=value));// let the world know about state changes
imageState.subscribe(state=>eventProxy.pub("update",state));// this will hold the currently selected util
const utilSelectedStore=writable();component_subscribe($$self,utilSelectedStore,value=>$$invalidate(49,$utilSelectedStore=value));//
// handles the view rect size, makes sure it is offset from the top
//
// root element reference used to read styles
const rootBackgroundColor=writable([0,0,0]);component_subscribe($$self,rootBackgroundColor,value=>$$invalidate(48,$rootBackgroundColor=value));const rootForegroundColor=writable([1,1,1]);component_subscribe($$self,rootForegroundColor,value=>$$invalidate(306,$rootForegroundColor=value));const rootLineColor=spring();component_subscribe($$self,rootLineColor,value=>$$invalidate(307,$rootLineColor=value));// client rect is the editor rect excluding scroll offset
const clientRect=writable();component_subscribe($$self,clientRect,value=>$$invalidate(16,$clientRect=value));// root rect is the editor rect including scroll offset
const rootRect=writable();component_subscribe($$self,rootRect,value=>$$invalidate(182,$rootRect=value));// when in overlay mode force aspect ratio to aspect ratio of editor root
const syncRootAspectRatio=()=>{// get current aspect ratio and get next aspect ratio, compare, if different, reset
const currentAspectRatio=$imageCropAspectRatio;const nextAspectRatio=rectAspectRatio($rootRect);if(currentAspectRatio&&currentAspectRatio===nextAspectRatio)return;// set aspect ratio
imageCropAspectRatio.set(rectAspectRatio($rootRect));// need to set history 0 point to this state
setInitialHistoryState();};const tabRect=writable(rectCreateEmpty());component_subscribe($$self,tabRect,value=>$$invalidate(30,$tabRect=value));const toolRect=writable(rectCreateEmpty());component_subscribe($$self,toolRect,value=>$$invalidate(45,$toolRect=value));const utilRect=writable();// is undefined because we wait till util is set before defining stage rect
component_subscribe($$self,utilRect,value=>$$invalidate(46,$utilRect=value));//
// environment
//
const pointerAccuracy=mediaQueryStore("(pointer: fine)",matches=>matches?"pointer-fine":"pointer-coarse");component_subscribe($$self,pointerAccuracy,value=>$$invalidate(233,$pointerAccuracy=value));const pointerHoverable=mediaQueryStore("(hover: hover)",matches=>matches?"pointer-hover":"pointer-no-hover");component_subscribe($$self,pointerHoverable,value=>$$invalidate(234,$pointerHoverable=value));//
// app API
//
const isInteracting=writable(false);component_subscribe($$self,isInteracting,value=>$$invalidate(185,$isInteracting=value));const isInteractingFraction=readable(undefined,set=>{const animator=spring(0);const updater=value=>{animator.set(value?1:0);};const subs=[isInteracting.subscribe(updater),animator.subscribe(set)];// destroy subs
return()=>subs.forEach(unsub=>unsub());});component_subscribe($$self,isInteractingFraction,value=>$$invalidate(308,$isInteractingFraction=value));const previewShouldUpscale=writable(previewUpscale);component_subscribe($$self,previewShouldUpscale,value=>$$invalidate(298,$previewShouldUpscale=value));const imageCropRectSnapshot=writable();component_subscribe($$self,imageCropRectSnapshot,value=>$$invalidate(297,$imageCropRectSnapshot=value));const imageCropRectIntent=writable();// should always be set before setting `imageCropRect`
component_subscribe($$self,imageCropRectIntent,value=>$$invalidate(296,$imageCropRectIntent=value));const imageCropRectPresentation=readable(undefined,set=>{const animator=spring(undefined,{precision:0.0001});const update=()=>{if(!$imageCropRect)return;const instantUpdate=$imageCropRectIntent===undefined||$isInteracting;const elasticRect=elastifyRects($imageCropRect,$imageCropRectIntent,imageCropRectElasticity*elasticityMultiplier);animator.set(elasticRect,{hard:instantUpdate});};const subs=[// need to update presentation rect when crop rect is updated
imageCropRect.subscribe(update),// update parent store
animator.subscribe(set)];return()=>subs.forEach(unsub=>unsub());});const imageSelectionRect=writable();component_subscribe($$self,imageSelectionRect,value=>$$invalidate(299,$imageSelectionRect=value));const imageSelectionRectSnapshot=writable();component_subscribe($$self,imageSelectionRectSnapshot,value=>$$invalidate(303,$imageSelectionRectSnapshot=value));const imageSelectionRectIntent=writable(undefined);// should always be set before setting `imageSelectionRect`
component_subscribe($$self,imageSelectionRectIntent,value=>$$invalidate(300,$imageSelectionRectIntent=value));let prevFramePadding={left:0,right:0,top:0,bottom:0};const framePadding=derived([imageFrame,imageSelectionRect],([$imageFrame,$imageSelectionRect],set)=>{if(!$imageSelectionRect)set(prevFramePadding);// set frame padding
let newPadding=getStagePadding($imageSelectionRect,$imageFrame);// exif if no value changes
if(fixPrecision(prevFramePadding.top,4)===fixPrecision(newPadding.top,4)&&fixPrecision(prevFramePadding.bottom,4)===fixPrecision(newPadding.bottom,4)&&fixPrecision(prevFramePadding.right,4)===fixPrecision(newPadding.right,4)&&fixPrecision(prevFramePadding.left,4)===fixPrecision(newPadding.left,4))return;prevFramePadding=newPadding;set(newPadding);});const framePadded=derived([framePadding],([$framePadding],set)=>{set(Object.values($framePadding).some(value=>value>0));});let prevStagePadding={left:0,right:0,top:0,bottom:0};const stagePadding=derived([utilSelectedStore,imageFrame,imageSelectionRect],([$utilSelectedStore,$imageFrame,$imageSelectionRect],set)=>{if(!$imageSelectionRect)set(prevStagePadding);// TODO: configure in plugin
let newPadding;if($utilSelectedStore==="frame"){newPadding=getStagePadding($imageSelectionRect,$imageFrame);}else{newPadding={left:0,right:0,top:0,bottom:0};}// exif if no value changes
if(fixPrecision(prevStagePadding.top,4)===fixPrecision(newPadding.top,4)&&fixPrecision(prevStagePadding.bottom,4)===fixPrecision(newPadding.bottom,4)&&fixPrecision(prevStagePadding.right,4)===fixPrecision(newPadding.right,4)&&fixPrecision(prevStagePadding.left,4)===fixPrecision(newPadding.left,4))return;prevStagePadding=newPadding;set(newPadding);});const stagePadded=derived([stagePadding],([$stagePadding],set)=>{set(Object.values($stagePadding).some(value=>value>0));});component_subscribe($$self,stagePadded,value=>$$invalidate(50,$stagePadded=value));const stageRect=derived([utilRect,tabRect,toolRect,stagePadding],([$utilRect,$tabRect,$toolRect,$stagePadding],set)=>{if(!$utilRect)return set(undefined);let utilOffsetY=0;// if only one util active, we don't have util tabs, so add additional offset
if(utilsFiltered.length===1&&!isOverlayModeEnabled){utilOffsetY=$toolRect.y+$toolRect.height;}set(rectCreate($utilRect.x+$tabRect.x+$stagePadding.top,$utilRect.y+$tabRect.y+utilOffsetY+$stagePadding.top,$utilRect.width-($stagePadding.left+$stagePadding.right),$utilRect.height-($stagePadding.top+$stagePadding.bottom)));});component_subscribe($$self,stageRect,value=>$$invalidate(187,$stageRect=value));const stageScalar=derived([stageRect,imageCropRect],([$stageRect,$imageCropRect],set)=>{const isManipulatingImageCropRect=!!($imageCropRectSnapshot||$imageCropRectIntent);// update stage scalar, the crop output size relative to the stage, if image fits it's 1
if(!$stageRect||!$imageCropRect||isManipulatingImageCropRect)return;// calculate scale factor needed to fit crop rect to stage
const scalar=Math.min($stageRect.width/$imageCropRect.width,$stageRect.height/$imageCropRect.height);// always scaled down to fit stage, if is allowed to upscale, zoom to fit stage
const scale=$previewShouldUpscale?scalar:Math.min(1,scalar);set(scale);});component_subscribe($$self,stageScalar,value=>$$invalidate(301,$stageScalar=value));//
// Image selection
//
const getStagePadding=(presentationRect,imageFrame)=>{if(!imageFrame||!presentationRect)return{top:0,right:0,bottom:0,left:0};const shapes=shapesFromCompositShape(imageFrame,presentationRect,preprocessShape);const bounds=shapesBounds(shapes,presentationRect);return{top:Math.abs(bounds.top),right:Math.abs(bounds.right),bottom:Math.abs(bounds.bottom),left:Math.abs(bounds.left)};};const imageSelectionRectPresentation=readable(undefined,set=>{const animator=spring(undefined,{precision:0.0001});const updater=()=>{if(!$imageSelectionRect)return;const instantUpdate=$isInteracting||!$shouldAnimate;const elasticRect=elastifyRects($imageSelectionRect,$imageSelectionRectIntent,imageSelectionRectElasticity*elasticityMultiplier);// prevent negative size (can happen because of elastics)
if(elasticRect.width<0){elasticRect.width=0;elasticRect.x=$imageSelectionRect.x;}if(elasticRect.height<0){elasticRect.height=0;elasticRect.y=$imageSelectionRect.y;}// translate elastic rect x,y by stage rect x,y
rectTranslate(elasticRect,$stageRect);// adjust size if needed
// TODO: MAKE THIS CONTROLLABLE FROM PLUGIN
if($imageCropRect){if(utilSelected==="resize"){const visualSize=$imageOutputSize||$imageCropRect;rectScale(elasticRect,visualSize.width/$imageSelectionRect.width||visualSize.height/$imageSelectionRect.height);}}animator.set(elasticRect,{hard:instantUpdate});};const subs=[// need to update selection rect when stage is resized
stageRect.subscribe(updater),// listen for selection rect changes (as is assigned rect will always trigger, even if assigned same rect, this is needed to also update when intent changes)
imageSelectionRect.subscribe(updater),// if output size changes need to update presentation
imageOutputSize.subscribe(updater),// need to update if frame exceeds bounds
imageFrame.subscribe(updater),// update parent store
animator.subscribe(set)];// destroy subs
return()=>subs.forEach(unsub=>unsub());});component_subscribe($$self,imageSelectionRectPresentation,value=>$$invalidate(38,$imageSelectionRectPresentation=value));// when scaling the stage we need to recenter the image selection
let stageRectPrev;const calculateImageSelectionRect=rect=>{// don't recalculate if no change
if(isOverlayModeEnabled&&stageRectPrev&&rectEqual(stageRectPrev,rect))return;// remember so we can compare later on if has changed
stageRectPrev=rect;const imageCropRectFitsStage=$imageCropRect.width<=rect.width&&$imageCropRect.height<=rect.height;const centeredImageSelectionRect=// if we have a crop rect and it fits the stage, center it
imageCropRectFitsStage?// center the crop rectangle to the stage
rectCenterRect(rect,rectMultiply(rectClone($imageCropRect),$stageScalar||1)):// render a rectangle based on the fixed crop aspect ratio, or the aspect ratio of the current crop rectangle, or as a last resort the input image
rectContainRect(rect,rectAspectRatio($imageCropRect||$imageSize));imageSelectionRect.set(centeredImageSelectionRect);};// this runs once so we use the correct scale for the initial image selection rect
let hasSetInitialStageScalar=false;stageScalar.subscribe(scalar=>{// can't recalculate without these prosp
if(hasSetInitialStageScalar||scalar===undefined||!$imageCropRect)return;calculateImageSelectionRect($stageRect);hasSetInitialStageScalar=true;});// this recenters the crop when the window/stage is resized
stageRect.subscribe(rect=>{// can't recalculate without these prosp
if(!rect||$stageScalar===undefined||!$imageCropRect)return;calculateImageSelectionRect(rect);});// if we've taken a snapshot of the selection, also take a snapshot of the crop rect and the presentationScalar
// - cropRect so we can adjust it based on the adjustments to the imageSelectionRect
// - presentationScalar so we can use the snapshot for the calculation of the cropRect scale relative to the original imageSelectionRect (if we use the live $presentationScalar small rounding errors of the scalar result in weird glitches)
let presentationScalarSnapshot;imageSelectionRectSnapshot.subscribe(rect=>{if(!rect){presentationScalarSnapshot=undefined;set_store_value(imageCropRectSnapshot,$imageCropRectSnapshot=undefined,$imageCropRectSnapshot);return;}presentationScalarSnapshot=$presentationScalar;const cropRectClone=rectClone($imageCropRect);imageCropRectSnapshot.set(cropRectClone);});// if image selection rect is being manipulated, and imageSelectionRectSnapshot has been defined, we also need to update the crop rect
imageSelectionRect.subscribe(rect=>{// only sync crop rect with image selection rect when no longer manipulating
if(!rect||!$imageSelectionRectSnapshot)return;const offset=rectSubtract(rectClone(rect),$imageSelectionRectSnapshot);rectDivide(offset,presentationScalarSnapshot);const crop=rectAdd(rectClone($imageCropRectSnapshot),offset);imageCropRect.set(crop);});imageCropRect.subscribe(rect=>{// don't update image selection rect while we're intertacting with the view, this prevents feedback loop from cropRect model updates
if($isInteracting||$imageSelectionRectSnapshot||$imageCropRectIntent)return;// if no rect, we can't do anything
// if no selection rect yet, we wait for a selection rect to be loaded
if(!rect||!$imageSelectionRect)return;// only if crop aspect ratio differs from image selection aspect ratio we update image selection rectangle
const imageSelectionRectAspectRatio=rectAspectRatio($imageSelectionRect);const cropRectAspectRatio=rectAspectRatio(rect);if(fixPrecision(imageSelectionRectAspectRatio,6)===fixPrecision(cropRectAspectRatio,6))return;// TEMP DUPLICATE OF STAGESCALAR DERIVED STORE TO FIX ZOOM OUT AFTER WHEEL ISSUE
// reproduce -> crop view => resize selection rect vertically, tap recenter, zoom out with scroll wheel
const scalar=Math.min($stageRect.width/$imageCropRect.width,$stageRect.height/$imageCropRect.height);// const scale = $previewShouldUpscale ? scalar : Math.min(1, scalar);
const size=sizeCreate(rect.width*scalar,rect.height*scalar);const tx=($imageSelectionRect.width-size.width)*0.5;const ty=($imageSelectionRect.height-size.height)*0.5;const selectionRect=rectCreate($imageSelectionRect.x+tx,$imageSelectionRect.y+ty,size.width,size.height);imageSelectionRect.set(selectionRect);});const imageScalar=derived([stageScalar,imageCropRect,imageSelectionRect],([$stageScalar,$imageCropRect,$imageSelectionRect],set)=>{// update the image scalar, the image zoom calculated by the image selection and the actual crop coordinates
if(!$stageScalar||!$imageCropRect||!$imageSelectionRect)return;const selectionScaledWidth=$imageSelectionRect.width/$imageCropRect.width;const selectionScaledHeight=$imageSelectionRect.height/$imageCropRect.height;// need to correct for scale of stage
let scalar=Math.max(selectionScaledWidth,selectionScaledHeight)/$stageScalar;set(scalar);});const presentationScalar=derived([stageScalar,imageScalar],([$stageScalar,$imageScalar],set)=>{// can't scale presentation if no image scalar defined
if(!$imageScalar)return;const scalar=$stageScalar*$imageScalar;set(scalar);});component_subscribe($$self,presentationScalar,value=>$$invalidate(302,$presentationScalar=value));// const imagePresentationScale = writable(1);
// const imagePresentationPan = writable(vectorCreateEmpty());
//
// UI Elements
//
// image outline
const imageOutlineOpacity=spring(0.075,{stiffness:0.03,damping:0.4,precision:0.001});const imageVisualBounds=derived([imageSelectionRectPresentation,framePadding],([$rect,$padding],set)=>{if(!$rect)return;let{x,y,width,height}=$rect;let{left,right,top,bottom}=$padding;if(utilSelected==="resize"){const visualSize=$imageOutputSize||$imageCropRect;const scalar=visualSize.width/$imageSelectionRect.width||visualSize.height/$imageSelectionRect.height;left*=scalar;right*=scalar;top*=scalar;bottom*=scalar;}set({x:x-left,y:y-right,width:width+left+right,height:height+top+bottom});});component_subscribe($$self,imageVisualBounds,value=>$$invalidate(192,$imageVisualBounds=value));const imageOutline=derived([rootLineColor,imageOutlineOpacity,imageSelectionRectPresentation,imageFrame,framePadded,framePadding],([$rootLineColor,$colorOpacity,$rect,$imageFrame,$framePadded,$framePadding],set)=>{if(!$rect||isOverlayModeEnabled)return set([]);let{x,y,width,height}=$rect;x+=0.5;y+=0.5;width-=0.5;height-=0.5;const shapes=[];if($framePadded){if($colorOpacity>0.1){// image outline
shapes.push({x,y,width:width-0.5,height:height-0.5,strokeWidth:1,strokeColor:$rootLineColor,opacity:$colorOpacity});}let{left,right,top,bottom}=$framePadding;if(utilSelected==="resize"){const visualSize=$imageOutputSize||$imageCropRect;const scalar=visualSize.width/$imageSelectionRect.width||visualSize.height/$imageSelectionRect.height;left*=scalar;right*=scalar;top*=scalar;bottom*=scalar;}set([...shapes,// frame outline
{x:x-left,y:y-right,width:width+left+right,height:height+top+bottom,strokeWidth:1,strokeColor:$rootLineColor,opacity:0.05}]);return;}// draw shadow behind frame if is dark outline on dark frame or bright outline on bright frame
const isDarkLine=isDarkColor($rootLineColor);const isDarkFrame=$imageFrame&&$imageFrame.frameColor&&isDarkColor($imageFrame.frameColor);if(isDarkLine&&isDarkFrame||!isDarkLine&&!isDarkLine){const shadeColor=isDarkLine?[1,1,1,0.3]:[0,0,0,0.075];shapes.push({x,y,width,height,strokeWidth:3.5,strokeColor:shadeColor,opacity:$colorOpacity});}set([...shapes,// outline
{x,y,width,height,strokeWidth:1,strokeColor:$rootLineColor,opacity:$colorOpacity}]);});// custom markup rendered on top of image
const imageOverlayMarkup=writable([]);component_subscribe($$self,imageOverlayMarkup,value=>$$invalidate(203,$imageOverlayMarkup=value));// the resulting overlay markup
const imageOverlay=derived([imageOutline,imageOverlayMarkup],([$imageOutline,$imageOverlayMarkup],set)=>{set([...$imageOutline,...$imageOverlayMarkup]);});component_subscribe($$self,imageOverlay,value=>$$invalidate(55,$imageOverlay=value));//
// Stage overlay
//
// create canvas gradient for use as menu backdrop
const getOverlayGradient=(width,height,color)=>{const ctx=h("canvas",{width:Math.max(1,width),height:Math.max(1,height)}).getContext("2d");const gradient=ctx.createLinearGradient(0,0,width,height);[[0,0],[0.013,0.081],[0.049,0.155],[0.104,0.225],[0.175,0.29],[0.259,0.353],[0.352,0.412],[0.45,0.471],[0.55,0.529],[0.648,0.588],[0.741,0.647],[0.825,0.71],[0.896,0.775],[0.951,0.845],[0.987,0.919],[1,1]].forEach(([o,s])=>gradient.addColorStop(s,`rgba(${color[0]*255}, ${color[1]*255}, ${color[2]*255}, ${o})`));ctx.fillStyle=gradient;ctx.fillRect(0,0,ctx.canvas.width,ctx.canvas.height);return ctx.canvas;};const calculateImageTargetSize=(outputSize,cropRect)=>{let{width,height}=outputSize;const aspectRatio=rectAspectRatio(cropRect);if(width&&height)return outputSize;if(width&&!height){height=width/aspectRatio;}if(height&&!width){width=height*aspectRatio;}if(!width&&!height){width=cropRect.width;height=cropRect.height;}return sizeApply(sizeCreate(width,height),Math.round);};const overlayInset=spring(40);component_subscribe($$self,overlayInset,value=>$$invalidate(191,$overlayInset=value));const overlaySize=spring(70);component_subscribe($$self,overlaySize,value=>$$invalidate(194,$overlaySize=value));const overlayLeftOpacity=spring(0);component_subscribe($$self,overlayLeftOpacity,value=>$$invalidate(199,$overlayLeftOpacity=value));const overlayRightOpacity=spring(0);component_subscribe($$self,overlayRightOpacity,value=>$$invalidate(201,$overlayRightOpacity=value));const overlayTopOpacity=spring(0);component_subscribe($$self,overlayTopOpacity,value=>$$invalidate(195,$overlayTopOpacity=value));const overlayBottomOpacity=spring(0);component_subscribe($$self,overlayBottomOpacity,value=>$$invalidate(197,$overlayBottomOpacity=value));// make sure canvas only redraws if background color changes
let gradientOverlayHorizontal;let gradientOverlayVertical;rootBackgroundColor.subscribe(color=>{if(!color)return;$$invalidate(172,gradientOverlayHorizontal=getOverlayGradient(16,0,color));$$invalidate(172,gradientOverlayHorizontal.dataset.retain=1,gradientOverlayHorizontal);$$invalidate(173,gradientOverlayVertical=getOverlayGradient(0,16,color));$$invalidate(173,gradientOverlayVertical.dataset.retain=1,gradientOverlayVertical);});//
// Loading the preview
//
const imageVisualLoadComplete=writable(false);component_subscribe($$self,imageVisualLoadComplete,value=>$$invalidate(244,$imageVisualLoadComplete=value));const imagePreviewSource=writable();component_subscribe($$self,imagePreviewSource,value=>$$invalidate(206,$imagePreviewSource=value));const createImagePreviewLoader=(src,token)=>new Promise((resolve,reject)=>{// try not to show preview loader if updating active images array
const minPreviewLoaderDuration=activeImages.length?0:250;let cancelled=false;let timer;token.cancel=()=>cancelled=true;const now=Date.now();imageSourceToImageData(src).then(imageData=>{const dist=Date.now()-now;clearTimeout(timer);timer=setTimeout(()=>{if(cancelled)return;resolve(imageData);},Math.max(0,minPreviewLoaderDuration-dist));}).catch(reject);});let imagePreviewLoaderCancelToken;const imagePreview=derived([imageVisualLoadComplete,imagePreviewSource],([$imageVisualLoadComplete,$imagePreviewSource],set)=>{// no data, reset preview data
if(!$imageVisualLoadComplete||!$imagePreviewSource)return set(undefined);// cancel existing loader
if(imagePreviewLoaderCancelToken){imagePreviewLoaderCancelToken.cancel();$$invalidate(174,imagePreviewLoaderCancelToken=undefined);}// if image preview source is a canvas we can update immediately
if(isCanvas($imagePreviewSource)){// update image preview to canvas
return set(canvasClone($imagePreviewSource));}// load preview
$$invalidate(174,imagePreviewLoaderCancelToken={cancel:noop$1});createImagePreviewLoader($imagePreviewSource,imagePreviewLoaderCancelToken).then(set).catch(err=>{// update load state
set_store_value(imageLoadState,$imageLoadState.error=err,$imageLoadState);// log to console for debuggin purposes
}).finally(()=>{// no longer loading
$$invalidate(174,imagePreviewLoaderCancelToken=undefined);});});$$subscribe_imagePreview();let{imagePreviewCurrent=undefined}=$$props;//
// Calculates the image transforms and effects necessary for the preview
//
const imagePreviewModifiers=writable({});component_subscribe($$self,imagePreviewModifiers,value=>$$invalidate(236,$imagePreviewModifiers=value));const interfaceImages=writable([]);component_subscribe($$self,interfaceImages,value=>$$invalidate(51,$interfaceImages=value));// reset image UI previews when new file is loaded
const resetPreviews=()=>interfaceImages.set([]);const imageTransforms=derived([stageRect,rootRect,imageSize,imageCropRectPresentation,imageSelectionRect,presentationScalar,imageRotation,imageFlipX,imageFlipY,imageOutputSize],([$stageRect,$rootRect,$imageSize,$imageCropRectPresentation,$imageSelectionRect,$presentationScalar,$imageRotation,$imageFlipX,$imageFlipY,$imageOutputSize],set)=>{if(!$stageRect)return;// TODO: MAKE THIS CONTROLLABLE FROM PLUGIN
if(utilSelected==="resize"){const visualSize=$imageOutputSize||$imageCropRectPresentation;$presentationScalar=visualSize.width/$imageCropRectPresentation.width||visualSize.height/$imageCropRectPresentation.height;}set(calculateImageTransforms($stageRect,$rootRect,$imageSize,$imageCropRectPresentation,$imageSelectionRect,$presentationScalar,0,0,$imageRotation,$imageFlipX,$imageFlipY));});component_subscribe($$self,imageTransforms,value=>$$invalidate(235,$imageTransforms=value));const imageEffects=derived([imageColorMatrix,imageConvolutionMatrix,imageGamma,imageVignette,imageNoise],([$colorMatrix,$convolutionMatrix,$gamma,$vignette,$noise],set)=>{const colorMatrices=$colorMatrix&&Object.keys($colorMatrix).map(name=>$colorMatrix[name]).filter(Boolean);const effects={gamma:$gamma||undefined,vignette:$vignette||undefined,noise:$noise||undefined,convolutionMatrix:$convolutionMatrix||undefined,colorMatrix:colorMatrices&&colorMatrices.length&&getColorMatrixFromColorMatrices(colorMatrices)};set(effects);});//
// current environment variables
//
let windowWidth;let windowHeight;const shouldPreventSwipe=canPreventNavSwipe();const env=writable({});component_subscribe($$self,env,value=>$$invalidate(232,$env=value));const initialPixelRatio=getDevicePixelRatio();const pixelRatio=readable(initialPixelRatio,set=>{const handleResolutionChange=()=>set(getDevicePixelRatio());const resolutionObserver=matchMedia(`(resolution: ${initialPixelRatio}dppx)`);resolutionObserver.addListener(handleResolutionChange);return()=>resolutionObserver.removeListener(handleResolutionChange);});component_subscribe($$self,pixelRatio,value=>$$invalidate(47,$pixelRatio=value));//
// Animations based on prefers-reduced-motion, automatically checks if user prefers reduced animations
//
const shouldAnimate=writable();component_subscribe($$self,shouldAnimate,value=>$$invalidate(18,$shouldAnimate=value));const history=historyCreate(()=>{// $imageState is always a clone of the current state
return $imageState;},state=>{// set new state from history, $imageState will store a clone of the received state
set_store_value(imageState,$imageState=state,$imageState);// trigger recenter of image selection rect
tabRect.set($tabRect);});$$subscribe_history();const setInitialHistoryState=()=>{// set history state
const baseRect={x:0,y:0,...$imageSize};const baseCropRect=rectApply(rectContainRect(baseRect,$imageState.cropAspectRatio),v=>Math.round(v));const baseEditorState=willSetHistoryInitialState({// the base state is the image state but the `rotation` and `crop` are reset
...$imageState,// should be read from imageInitialProps?
rotation:0,crop:baseCropRect},$imageState);// this will be the base state
const editorInitialHistoryState=[baseEditorState];// only add additional entry if base state and current state are different
if(JSON.stringify(baseEditorState)!==JSON.stringify($imageState)){editorInitialHistoryState.push({...$imageState});}// loading done, set this as base state
history.set(editorInitialHistoryState);};imageLoadState.subscribe(state=>{// not ready yet
if(!state||!state.complete)return;// set initial state after image load has completed
setInitialHistoryState();});const revert=()=>willRevert().then(shouldReset=>shouldReset&&history.revert());//
// Visual processing of the image
//
const imageProcessingPreparing=writable(false);component_subscribe($$self,imageProcessingPreparing,value=>$$invalidate(213,$imageProcessingPreparing=value));const handleExport=()=>{// this will trigger status overlay fade in
set_store_value(imageProcessingPreparing,$imageProcessingPreparing=true,$imageProcessingPreparing);willProcessImage().then(shouldProcess=>{// nope, restore hide processing overlay and back to editing
if(!shouldProcess){set_store_value(imageProcessingPreparing,$imageProcessingPreparing=false,$imageProcessingPreparing);return;}// wait for status to be done fading in, then requests image writing
let unsub;unsub=statusOpacity.subscribe(value=>{if(value!==1)return;// stop listening for
unsub&&unsub();// request write image
dispatch("processImage");});});};imageProcessState.subscribe(state=>{if(!state)return;set_store_value(imageProcessingPreparing,$imageProcessingPreparing=true,$imageProcessingPreparing);const{complete,abort}=state;if(complete||abort)set_store_value(imageProcessingPreparing,$imageProcessingPreparing=false,$imageProcessingPreparing);});//
// Configure the available views
//
const utilStores={// model stores
...stores,// image
imageFile,imageSize,imageBackgroundColor,imageCropAspectRatio,imageCropMinSize,imageCropMaxSize,imageCropLimitToImage,imageCropRect,imageCropRectOrigin,imageCropRectSnapshot,imageCropRectAspectRatio,imageCropRange,imageRotation,imageRotationRange,imageFlipX,imageFlipY,imageOutputSize,// effects
imageColorMatrix,imageConvolutionMatrix,imageGamma,imageVignette,imageNoise,// markup
imageDecoration,imageAnnotation,imageRedaction,imageFrame,// image preview for utils that need access to pixel data
imagePreview,// image preview source so utils can update preview
imagePreviewSource,// top left position of image preview
imageTransforms,// allows utils to control how the preview is presented (for example more opacity for mask)
imagePreviewModifiers,// history state and update
history,// static env info
animation:shouldAnimate,pixelRatio,elasticityMultiplier,scrollElasticity,rangeInputElasticity,// dynamic env info
pointerAccuracy,pointerHoverable,env,rootRect,stageRect,stageScalar,framePadded,utilRect,presentationScalar,rootBackgroundColor,rootForegroundColor,rootLineColor,imageOutlineOpacity,// interaction
// imagePresentationPan,
// imagePresentationScale,
// (write) add guides to ui (for example is used by markup util to add lines for shape manipulator)
imageOverlayMarkup,// (write) interface images to render
interfaceImages,// (write) set to true to disable animations
isInteracting,// (read) goes from 0 to 1 while interacting
isInteractingFraction,// (write) the current intended crop rect
imageCropRectIntent,// (read) the current presented crop rect
imageCropRectPresentation,// (write) the current limited size of the image selection rect
imageSelectionRect,// (write) the inteded rectangle by the user
imageSelectionRectIntent,// (read) the current presentation of the image selection rect, includes elasticity etc.
imageSelectionRectPresentation,// (read) a snapshot of the image selection rectangle, use to store the rectangle before modification so alterations to the rectangle can be applied to the snapshot
imageSelectionRectSnapshot,// scalar of image in view
imageScalar};// don't expose image store
delete utilStores.image;const utilsUniqueId=`util-${getUniqueId()}`;let utilsVisible=[];// env
let iOS=isIOS();const getOrientation=(rect,layoutPreference)=>{if(!$rootRect)return"landscape";if(layoutPreference==="auto")return rect.width>rect.height?"landscape":"portrait";if(layoutPreference==="horizontal")return rect.width<500?"portrait":"landscape";if(layoutPreference==="vertical")return rect.height<400?"landscape":"portrait";};const getColorPropertyValue=name=>{const colorString=rootElementComputedStyle.getPropertyValue(name);return colorStringToColorArray(colorString);};const syncColor=(property,store)=>{const colorArray=getColorPropertyValue(property);// hide transparent color
if(!colorArray||colorArray[3]===0)return;// limit to opaque colors
colorArray.length=3;// update store
store.set(colorArray);};const syncColors=()=>{syncColor("color",rootForegroundColor);syncColor("background-color",rootBackgroundColor);syncColor("outline-color",rootLineColor);};const handleTransitionEnd=({target,propertyName})=>{if(target!==root||!/background|outline/.test(propertyName))return;syncColors();};const imageProps=derived([imageTransforms,imageEffects,imageBackgroundColor],([$imageTransforms,$imageEffects,backgroundColor])=>{return $imageTransforms&&{...$imageTransforms,...$imageEffects,backgroundColor};});component_subscribe($$self,imageProps,value=>$$invalidate(238,$imageProps=value));const activeImages=storeList();component_subscribe($$self,activeImages,value=>$$invalidate(22,$activeImages=value));const addImagePreview=()=>{// if is first image scale up slightly on entrance
const imageIntro=activeImages.length?undefined:{resize:1.05};// create the new image
const image=createImage($imagePreview,$imageSize,imageIntro);// new image on top
activeImages.unshift(image);// update images in activeImages array
updateImagePreviews($imageProps);};const updateImagePreviews=currentImageProps=>{activeImages.forEach((image,index)=>{const opacity=index===0?1:0;const resize=1;image.set({...currentImageProps,opacity,resize},$shouldAnimate);});};// if image preview changes, push it on the stack
let lastImagePreview;// test if some shapes have left/top/bottom/right offsets, if so, convert to crop space
// updates original shape (which at this point is a flattened shape (clone))
const positionDecorationShape=(shape,canvasState)=>shapeComputeDisplay(shape,{x:$imageSelectionRectPresentation.x/canvasState.scale,y:$imageSelectionRectPresentation.y/canvasState.scale,width:$imageSelectionRectPresentation.width/canvasState.scale,height:$imageSelectionRectPresentation.height/canvasState.scale});// decoration is drawn relative to view space, so we need to translate relative to crop presentation rect
const transformDecorationShape=(shape,canvasState)=>{shapeComputeTransform(shape,$imageSelectionRectPresentation,canvasState.scale,canvasState.size);return shape;};const flattenShapes=shapes=>{const flattenedShapes=[];shapes.forEach(shape=>flattenedShapes.push(flattenShape(shape)));return flattenedShapes.filter(Boolean);};const flattenShape=shape=>{// at this point shape is a copy of the original shape
if(shapeIsLine(shape)){shape.points=[vectorCreate(shape.x1,shape.y1),vectorCreate(shape.x2,shape.y2)];}else if(shapeIsTriangle(shape)){shape.points=[vectorCreate(shape.x1,shape.y1),vectorCreate(shape.x2,shape.y2),vectorCreate(shape.x3,shape.y3)];}else// is empty text
if(shapeIsTextEmpty(shape)){// make sure shape is still visible
if(shapeIsTextLine(shape)){shape.width=5;shape.height=pintura_isFunction(shape.lineHeight)?shape.lineHeight(shape.fontSize):shape.lineHeight;}// set to empty text style
shape.strokeWidth=1;shape.strokeColor=[1,1,1,0.5];shape.backgroundColor=[0,0,0,0.1];}else if(shapeIsText(shape)){shape.fontFamily=shape.fontFamily||"sans-serif";shape.fontSize=shape.fontSize||16;}return shape;};const statusOpacity=tweened(undefined,{duration:500});component_subscribe($$self,statusOpacity,value=>$$invalidate(25,$statusOpacity=value));let loadTimer;// this adds a little delay to the status fade out after an image was processed
// needed because when the modal fades out this would otherwise create a weird flash (modal fade out, but status fade out as well showing interface)
const wasProcessingImage=writable(false);component_subscribe($$self,wasProcessingImage,value=>$$invalidate(256,$wasProcessingImage=value));let statusState;const asideOffset=spring(undefined,{stiffness:0.1,damping:0.7,precision:0.25});component_subscribe($$self,asideOffset,value=>$$invalidate(43,$asideOffset=value));const asideOpacity=spring(0,{stiffness:0.1,precision:0.05});component_subscribe($$self,asideOpacity,value=>$$invalidate(44,$asideOpacity=value));const asideWidth=spring(0,{stiffness:0.02,damping:0.5,precision:0.25});component_subscribe($$self,asideWidth,value=>$$invalidate(260,$asideWidth=value));const statusWidth=spring(undefined,{stiffness:0.02,damping:0.5,precision:0.25});component_subscribe($$self,statusWidth,value=>$$invalidate(258,$statusWidth=value));const statusOffset=spring(undefined,{stiffness:0.02,damping:0.5,precision:0.25});component_subscribe($$self,statusOffset,value=>$$invalidate(261,$statusOffset=value));let asideWidthUpdateTimer;const offsetAside=e=>{// if error occured, snap in possition
const hard=!!(statusState&&statusState.closeButton);// where to render the progress indicator or close button
statusWidth.set(e.detail.width,{hard});// offsets text so it's better centered to the viewport
statusOffset.set(Math.round(-e.detail.width*0.5),{hard});};const handleCloseImageLoadError=()=>{dispatch("abortLoadImage");};const handleCloseImageProcessError=()=>{dispatch("abortProcessImage");set_store_value(imageProcessingPreparing,$imageProcessingPreparing=false,$imageProcessingPreparing);};// helper to block iOS events
const preventDefault=e=>e.preventDefault();// prevents swipe to navigate back on iOS >= 13.4+
const handleTouchStart=shouldPreventSwipe?e=>{// get touch or event itself (fixes issue with chrome dev tools)
const event=e.touches?e.touches[0]:e;// if is not an attempt to swipe back or forward
if(event.pageX>10&&event.pageX<windowWidth-10)return;// stop the navigation attempt
preventDefault(e);}:noop$1;// these are again needed since iOS 15 (was needed for 12 and lower, but  wasn't needed for 13, 14)
const handleTouchMove=isIOS()?preventDefault:noop$1;const handlePointerMove=isIOS()?preventDefault:noop$1;// context for children to know if a key is down
const pressedKeysStore=writable([]);component_subscribe($$self,pressedKeysStore,value=>$$invalidate(305,$pressedKeysStore=value));setContext("keysPressed",pressedKeysStore);const handleKeydown=e=>{const{keyCode,metaKey,ctrlKey,shiftKey}=e;// prevent tabbing through fields if editor is disabled
if(keyCode===9&&disabled){e.preventDefault();return;}// undo/redo
if(keyCode===90&&(metaKey||ctrlKey)){if(shiftKey&&metaKey){// redo on macos
history.redo();}else{// undo
history.undo();}return;}else if(keyCode===89&&ctrlKey){// redo on windows
history.redo();return;}// ignore IME popup keycode, fixes keycode 229 sticking around, as it's not triggered in keyup "If an Input Method Editor is processing key input and the event is keydown, return 229."
// https://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html
if(keyCode===229)return;// add to set
const keySet=new Set([...$pressedKeysStore,keyCode]);pressedKeysStore.set(Array.from(keySet));};const handleKeyup=({keyCode})=>{pressedKeysStore.set($pressedKeysStore.filter(pressedKey=>pressedKey!==keyCode));};// so no keys get stuck when user cmd-tabs out of the window, or when dev-tools open by key-press
const handleWindowBlur=()=>{pressedKeysStore.set([]);};// block context menu on everything but text input fields
const handleContextMenu=e=>{if(isTextField(e.target))return;e.preventDefault();};// handle files being dropped on the editor
const handleUserFile=file=>{// no file received, isn't an image file, is not a URL
if(// no file received
!file||// if it's a file object it should be a bitmap
isBinary(file)&&!isBitmap(file)||// if it's not a file object it should be a URL
!isBinary(file)&&!/^http/.test(file))return;// request load image
dispatch("loadImage",file);};const handleDropFiles=e=>{// not allowed to drop
if(!enableDropImage)return;handleUserFile(e.detail.resources[0]);};const handleSelectFile=file=>{if(!file)return;handleUserFile(file);};const browseFileSystem=()=>{if(!enableBrowseImage)return;browse().then(handleSelectFile);};const handlePaste=e=>{// not allowed to paste
if(!enablePasteImage)return;// calculate percentage of editor that is in view
const xPercentage=pintura_clamp((windowWidth-Math.abs($rootRect.x))/$rootRect.width,0,1);const yPercentage=pintura_clamp((windowHeight-Math.abs($rootRect.y))/$rootRect.height,0,1);// editor needs to be in view
if(xPercentage<0.75&&yPercentage<0.75)return;// request load image
handleUserFile((e.clipboardData||window.clipboardData).files[0]);};//
// canvas drawing
//
let scrambledPreviewImage=undefined;const updateScrambledPreview=(imagePreviewData,imageScrambler,imageRedactionScalar,imageBackgroundColor)=>{if(!imageScrambler)return;// remove transparency
const editorOptions={dataSizeScalar:imageRedactionScalar};if(imageBackgroundColor&&imageBackgroundColor[3]>0){editorOptions.backgroundColor=[...imageBackgroundColor];}imageScrambler(imagePreviewData,editorOptions).then(scrambledCanvas=>{// we've created a new scrambled preview so force release memory of old one
if(scrambledPreviewImage)releaseCanvas(scrambledPreviewImage);// update scrambled preview with new image
$$invalidate(178,scrambledPreviewImage=scrambledCanvas);});};let blendShapes=[];const getStageState=()=>({// add foreground color
foregroundColor:[...$rootForegroundColor],// add line color
lineColor:[...$rootLineColor],// add information on which util is active
utilVisibility:{...utilsVisibleFraction},// used to fade in elements when interacting
isInteracting:$isInteracting,isInteractingFraction:$isInteractingFraction,// add the root rectangle so will render can use width/height of root element
rootRect:rectClone($rootRect),// add the stage rectangle so will render knows where stage starts and ends
stageRect:rectClone($stageRect),// preview selection rect
selectionRect:rectClone($imageSelectionRectPresentation)});const createCanvasState=(canvasState,blendShapes,annotationShapes,decorationShapes,interfaceShapes,frameShapes)=>({blendShapes:blendShapes.filter(shapeIsVisible).map(shape=>shapeComputeDisplay(shape,$imageSize)),annotationShapes:flattenShapes(annotationShapes.filter(shapeIsVisible).map(shapeDeepCopy).map(shape=>shapeComputeDisplay(shape,$imageSize)).map(preprocessShape).flat()),decorationShapes:flattenShapes(decorationShapes.filter(shapeIsVisible).map(shapeDeepCopy).map(shape=>positionDecorationShape(shape,canvasState)).map(preprocessShape).flat().map(shape=>transformDecorationShape(shape,canvasState))),interfaceShapes:flattenShapes(interfaceShapes.filter(shapeIsVisible)),frameShapes:flattenShapes(frameShapes.map(shapeDeepCopy).map(shape=>positionDecorationShape(shape,canvasState)).map(preprocessShape).flat().map(shape=>transformDecorationShape(shape,canvasState)))});// setup root portal for detail panel dropdown
let rootPortal;const rootPortalStore=writable();setContext("rootPortal",rootPortalStore);// setup root rect store for global access
setContext("rootRect",rootRect);function onwindowresize(){$$invalidate(11,windowWidth=window_1$1.innerWidth);$$invalidate(12,windowHeight=window_1$1.innerHeight);}const measure_handler=e=>set_store_value(toolRect,$toolRect=e.detail,$toolRect);const select_handler=({detail})=>$$invalidate(19,utilSelected=detail);const func=(panel,util)=>util.id===panel;function panel_component_binding(value,panel){if($$self.$$.not_equal(pluginInterface[panel],value)){pluginInterface[panel]=value;$$invalidate(0,pluginInterface),$$invalidate(7,pluginOptions),$$invalidate(169,pluginComponents);}}const measure_handler_1=e=>set_store_value(utilRect,$utilRect=e.detail,$utilRect);const show_handler=panel=>$$invalidate(28,utilsVisible=utilsVisible.concat(panel));const hide_handler=panel=>$$invalidate(28,utilsVisible=utilsVisible.filter(util=>util!==panel));const fade_handler=(panel,{detail})=>$$invalidate(21,utilsVisibleFraction[panel]=detail,utilsVisibleFraction);const measure_handler_2=e=>set_store_value(tabRect,$tabRect=e.detail,$tabRect);const func_1=util=>util.id===utilSelected;function panel_component_binding_1(value){if($$self.$$.not_equal(pluginInterface[utilSelected],value)){pluginInterface[utilSelected]=value;$$invalidate(0,pluginInterface),$$invalidate(7,pluginOptions),$$invalidate(169,pluginComponents);}}const measure_handler_3=e=>set_store_value(utilRect,$utilRect=e.detail,$utilRect);const show_handler_1=()=>$$invalidate(28,utilsVisible=utilsVisible.concat(utilSelected));const hide_handler_1=()=>$$invalidate(28,utilsVisible=utilsVisible.filter(util=>util!==utilSelected));const fade_handler_1=({detail})=>$$invalidate(21,utilsVisibleFraction[utilSelected]=detail,utilsVisibleFraction);const func_2=canvasState=>{// current draw state
const drawState={...canvasState,...getStageState()};// allow devs to add custom overlay to `imageOverlay`
const{annotationShapes,decorationShapes,interfaceShapes,frameShapes}=willRenderCanvas({annotationShapes:$imageAnnotation,decorationShapes:$imageDecoration,frameShapes:[$imageFrame],interfaceShapes:$imageOverlay},drawState);// need to map shapes
return createCanvasState(drawState,blendShapes,annotationShapes,decorationShapes,interfaceShapes,frameShapes);};function div_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{rootPortal=$$value;$$invalidate(14,rootPortal);});}function div_binding_1($$value){binding_callbacks[$$value?"unshift":"push"](()=>{root=$$value;$$invalidate(1,root);});}const measure_handler_4=e=>set_store_value(clientRect,$clientRect=e.detail,$clientRect);$$self.$$set=$$props=>{if("class"in $$props)$$invalidate(143,klass=$$props.class);if("layout"in $$props)$$invalidate(144,layoutMode=$$props.layout);if("stores"in $$props)$$invalidate(145,stores=$$props.stores);if("locale"in $$props)$$invalidate(2,locale=$$props.locale);if("id"in $$props)$$invalidate(3,id=$$props.id);if("util"in $$props)$$invalidate(146,util=$$props.util);if("utils"in $$props)$$invalidate(147,utils=$$props.utils);if("animations"in $$props)$$invalidate(148,animations=$$props.animations);if("disabled"in $$props)$$invalidate(149,disabled=$$props.disabled);if("status"in $$props)$$invalidate(141,status=$$props.status);if("previewUpscale"in $$props)$$invalidate(150,previewUpscale=$$props.previewUpscale);if("elasticityMultiplier"in $$props)$$invalidate(4,elasticityMultiplier=$$props.elasticityMultiplier);if("willRevert"in $$props)$$invalidate(151,willRevert=$$props.willRevert);if("willProcessImage"in $$props)$$invalidate(152,willProcessImage=$$props.willProcessImage);if("willRenderCanvas"in $$props)$$invalidate(5,willRenderCanvas=$$props.willRenderCanvas);if("willRenderToolbar"in $$props)$$invalidate(153,willRenderToolbar=$$props.willRenderToolbar);if("willSetHistoryInitialState"in $$props)$$invalidate(154,willSetHistoryInitialState=$$props.willSetHistoryInitialState);if("enableButtonExport"in $$props)$$invalidate(155,enableButtonExport=$$props.enableButtonExport);if("enableButtonRevert"in $$props)$$invalidate(156,enableButtonRevert=$$props.enableButtonRevert);if("enableNavigateHistory"in $$props)$$invalidate(157,enableNavigateHistory=$$props.enableNavigateHistory);if("enableToolbar"in $$props)$$invalidate(6,enableToolbar=$$props.enableToolbar);if("enableUtils"in $$props)$$invalidate(158,enableUtils=$$props.enableUtils);if("enableButtonClose"in $$props)$$invalidate(159,enableButtonClose=$$props.enableButtonClose);if("enableDropImage"in $$props)$$invalidate(160,enableDropImage=$$props.enableDropImage);if("enablePasteImage"in $$props)$$invalidate(161,enablePasteImage=$$props.enablePasteImage);if("enableBrowseImage"in $$props)$$invalidate(162,enableBrowseImage=$$props.enableBrowseImage);if("previewImageDataMaxSize"in $$props)$$invalidate(163,previewImageDataMaxSize=$$props.previewImageDataMaxSize);if("layoutDirectionPreference"in $$props)$$invalidate(164,layoutDirectionPreference=$$props.layoutDirectionPreference);if("layoutHorizontalUtilsPreference"in $$props)$$invalidate(165,layoutHorizontalUtilsPreference=$$props.layoutHorizontalUtilsPreference);if("layoutVerticalUtilsPreference"in $$props)$$invalidate(166,layoutVerticalUtilsPreference=$$props.layoutVerticalUtilsPreference);if("imagePreviewSrc"in $$props)$$invalidate(167,imagePreviewSrc=$$props.imagePreviewSrc);if("imageOrienter"in $$props)$$invalidate(168,imageOrienter=$$props.imageOrienter);if("pluginComponents"in $$props)$$invalidate(169,pluginComponents=$$props.pluginComponents);if("pluginOptions"in $$props)$$invalidate(7,pluginOptions=$$props.pluginOptions);if("root"in $$props)$$invalidate(1,root=$$props.root);if("imageSourceToImageData"in $$props)$$invalidate(8,imageSourceToImageData=$$props.imageSourceToImageData);if("imagePreviewCurrent"in $$props)$$invalidate(142,imagePreviewCurrent=$$props.imagePreviewCurrent);};$$self.$$.update=()=>{if($$self.$$.dirty[4]&/*layoutMode*/1048576){// set to new object to force redraw
$$invalidate(179,isOverlayModeEnabled=layoutMode==="overlay");}if($$self.$$.dirty[5]&/*enableUtils, isOverlayModeEnabled*/16777224){$$invalidate(15,showUtils=enableUtils&&!isOverlayModeEnabled);}if($$self.$$.dirty[0]&/*pluginOptions, pluginInterface*/129){// map plugin options to plugin interface
if(pluginOptions){// for every plugin in plugin options
Object.entries(pluginOptions).forEach(([name,plugin])=>{// for every prop defined for this plugin
Object.entries(plugin).forEach(([prop,value])=>{// set value to interface
if(!pluginInterface[name])return;// set prop value
$$invalidate(0,pluginInterface[name][prop]=value,pluginInterface);});});}}if($$self.$$.dirty[0]&/*pluginInterface*/1|$$self.$$.dirty[5]&/*pluginComponents*/16384){{let changed=false;pluginComponents.forEach(([key])=>{if(pluginInterface[key])return;$$invalidate(0,pluginInterface[key]={},pluginInterface);changed=true;});if(changed){$$invalidate(171,registeredPluginsComponents=[...pluginComponents]);}}}if($$self.$$.dirty[4]&/*disabled*/33554432){disabledTransition.set(disabled?1:0);}if($$self.$$.dirty[5]&/*previewImageDataMaxSize*/256){maxImageDataSize=previewImageDataMaxSize?sizeMin(previewImageDataMaxSize,maxTextureSize):maxTextureSize;}if($$self.$$.dirty[5]&/*$images*/33554432){imageProxy.update($images[0]);}if($$self.$$.dirty[5]&/*$shapePreprocessor*/67108864){preprocessShape=$shapePreprocessor?shape=>$shapePreprocessor(shape,{isPreview:true}):passthrough;}if($$self.$$.dirty[0]&/*$clientRect*/65536){$clientRect&&rootRect.set(rectCreate($clientRect.x,$clientRect.y,$clientRect.width,$clientRect.height));}if($$self.$$.dirty[5]&/*$rootRect, isOverlayModeEnabled, $imageLoadState*/419430400){$rootRect&&isOverlayModeEnabled&&$imageLoadState&&$imageLoadState.complete&&syncRootAspectRatio();}if($$self.$$.dirty[0]&/*locale*/4|$$self.$$.dirty[4]&/*utils*/8388608|$$self.$$.dirty[5]&/*registeredPluginsComponents*/65536){$$invalidate(186,utilsFiltered=locale&&registeredPluginsComponents.length?utils||registeredPluginsComponents.map(([id])=>id):[]);}if($$self.$$.dirty[6]&/*utilsFiltered*/1){$$invalidate(17,shouldRenderTabs=utilsFiltered.length>1);}if($$self.$$.dirty[0]&/*shouldRenderTabs*/131072){if(!shouldRenderTabs)tabRect.set(rectCreateEmpty());}if($$self.$$.dirty[0]&/*enableToolbar*/64){if(!enableToolbar)toolRect.set(rectCreateEmpty());}if($$self.$$.dirty[4]&/*previewUpscale*/67108864|$$self.$$.dirty[5]&/*isOverlayModeEnabled*/16777216){previewShouldUpscale.set(previewUpscale||isOverlayModeEnabled);}if($$self.$$.dirty[5]&/*registeredPluginsComponents*/65536|$$self.$$.dirty[6]&/*utilsFiltered*/1){$$invalidate(214,utilsAvailable=registeredPluginsComponents.filter(([id])=>utilsFiltered.includes(id)));}if($$self.$$.dirty[6]&/*utilsAvailable*/268435456){$$invalidate(215,utilsDefined=utilsAvailable.length);}if($$self.$$.dirty[4]&/*util*/4194304|$$self.$$.dirty[6]&/*utilsFiltered, utilsDefined*/536870913){$$invalidate(19,utilSelected=util&&typeof util==="string"&&utilsFiltered.includes(util)?util:utilsDefined>0?utilsFiltered[0]:undefined);}if($$self.$$.dirty[0]&/*utilSelected*/524288){utilSelected&&imageOutlineOpacity.set(0.075);}if($$self.$$.dirty[0]&/*utilSelected*/524288){overlayInset.set(utilSelected==="resize"?40:30);}if($$self.$$.dirty[0]&/*utilSelected*/524288){overlaySize.set(utilSelected==="resize"?140:70);}if($$self.$$.dirty[5]&/*$imageCropRect*/536870912|$$self.$$.dirty[6]&/*$imageOutputSize*/4){$$invalidate(190,imageTargetSizeCurrent=$imageCropRect&&calculateImageTargetSize($imageOutputSize||{},$imageCropRect));}if($$self.$$.dirty[6]&/*imageTargetSizeCurrent, $stageRect, $overlayInset, $imageVisualBounds*/114){imageTargetSizeCurrent&&$stageRect&&overlayTopOpacity.set(smoothstep($stageRect.y,$stageRect.y-$overlayInset,$imageVisualBounds.y));}if($$self.$$.dirty[6]&/*imageTargetSizeCurrent, $stageRect, $overlayInset, $imageVisualBounds*/114){imageTargetSizeCurrent&&$stageRect&&overlayRightOpacity.set(smoothstep($stageRect.x+$stageRect.width,$stageRect.x+$stageRect.width+$overlayInset,$imageVisualBounds.x+$imageVisualBounds.width));}if($$self.$$.dirty[6]&/*imageTargetSizeCurrent, $stageRect, $overlayInset, $imageVisualBounds*/114){imageTargetSizeCurrent&&$stageRect&&overlayBottomOpacity.set(smoothstep($stageRect.y+$stageRect.height,$stageRect.y+$stageRect.height+$overlayInset,$imageVisualBounds.y+$imageVisualBounds.height));}if($$self.$$.dirty[6]&/*imageTargetSizeCurrent, $stageRect, $overlayInset, $imageVisualBounds*/114){imageTargetSizeCurrent&&$stageRect&&overlayLeftOpacity.set(smoothstep($stageRect.x,$stageRect.x-$overlayInset,$imageVisualBounds.x));}if($$self.$$.dirty[5]&/*$rootRect, gradientOverlayVertical*/134479872|$$self.$$.dirty[6]&/*$overlaySize, $overlayTopOpacity*/768){$$invalidate(193,overlayTop=$rootRect&&{id:STAGE_OVERLAY_ID,x:0,y:0,width:$rootRect.width,height:$overlaySize,rotation:Math.PI,opacity:maxOpacity*$overlayTopOpacity,backgroundImage:gradientOverlayVertical});}if($$self.$$.dirty[5]&/*$rootRect, gradientOverlayVertical*/134479872|$$self.$$.dirty[6]&/*$overlaySize, $overlayBottomOpacity*/2304){$$invalidate(196,overlayBottom=$rootRect&&{id:STAGE_OVERLAY_ID,x:0,y:$rootRect.height-$overlaySize,width:$rootRect.width,height:$overlaySize,opacity:maxOpacity*$overlayBottomOpacity,backgroundImage:gradientOverlayVertical});}if($$self.$$.dirty[5]&/*$rootRect, gradientOverlayHorizontal*/134348800|$$self.$$.dirty[6]&/*$overlaySize, $overlayLeftOpacity*/8448){$$invalidate(198,overlayLeft=$rootRect&&{id:STAGE_OVERLAY_ID,x:0,y:0,height:$rootRect.height,width:$overlaySize,rotation:Math.PI,opacity:maxOpacity*$overlayLeftOpacity,backgroundImage:gradientOverlayHorizontal});}if($$self.$$.dirty[5]&/*$rootRect, gradientOverlayHorizontal*/134348800|$$self.$$.dirty[6]&/*$overlaySize, $overlayRightOpacity*/33024){$$invalidate(200,overlayRight=$rootRect&&{id:STAGE_OVERLAY_ID,x:$rootRect.width-$overlaySize,y:0,height:$rootRect.height,width:$overlaySize,opacity:maxOpacity*$overlayRightOpacity,backgroundImage:gradientOverlayHorizontal});}if($$self.$$.dirty[6]&/*overlayTop, overlayRight, overlayBottom, overlayLeft*/21632){$$invalidate(202,gradientOverlays=[overlayTop,overlayRight,overlayBottom,overlayLeft].filter(Boolean));}if($$self.$$.dirty[6]&/*gradientOverlays, $imageOverlayMarkup*/196608){// if overlay top changes
if(gradientOverlays&&$imageOverlayMarkup){// remove existing resize overlays
const overlayMarkup=$imageOverlayMarkup.filter(markup=>markup.id!==STAGE_OVERLAY_ID);set_store_value(imageOverlayMarkup,$imageOverlayMarkup=[...overlayMarkup,...gradientOverlays],$imageOverlayMarkup);}}if($$self.$$.dirty[5]&/*imagePreviewSrc*/4096|$$self.$$.dirty[6]&/*$imageFile*/262144){imagePreviewSource.set(imagePreviewSrc?imagePreviewSrc:$imageFile||undefined);}if($$self.$$.dirty[0]&/*root*/2|$$self.$$.dirty[4]&/*imagePreviewCurrent*/262144|$$self.$$.dirty[6]&/*$imagePreview*/524288){{$$invalidate(142,imagePreviewCurrent=$imagePreview);if($imagePreview)root.dispatchEvent(createPing("loadpreview",imagePreviewCurrent));}}if($$self.$$.dirty[6]&/*$imagePreviewSource*/1048576){if($imagePreviewSource)resetPreviews();}if($$self.$$.dirty[5]&/*$isInteracting*/1073741824){$$invalidate(207,canAnimate=!$isInteracting&&!isSoftwareRendering());}if($$self.$$.dirty[6]&/*$prefersReducedMotion*/8388608){$$invalidate(208,acceptsAnimations=!$prefersReducedMotion);}if($$self.$$.dirty[4]&/*animations*/16777216|$$self.$$.dirty[6]&/*canAnimate, acceptsAnimations*/6291456){set_store_value(shouldAnimate,$shouldAnimate=animations==="always"?canAnimate:animations==="never"?false:canAnimate&&acceptsAnimations,$shouldAnimate);}if($$self.$$.dirty[6]&/*$history*/33554432){$$invalidate(210,canUndo=$history.index>0);}if($$self.$$.dirty[6]&/*$history*/33554432){$$invalidate(212,canRedo=$history.index<$history.length-1);}if($$self.$$.dirty[0]&/*locale*/4|$$self.$$.dirty[6]&/*utilsFiltered, utilsAvailable*/268435457){$$invalidate(20,utilsMerged=utilsFiltered.map(utilId=>{const util=utilsAvailable.find(([id])=>utilId===id);// [id, view]
if(!util)return;return{id:utilId,view:util[1],tabIcon:locale[`${utilId}Icon`],tabLabel:locale[`${utilId}Label`]};}).filter(Boolean)||[]);}if($$self.$$.dirty[0]&/*utilSelected*/524288){utilSelectedStore.set(utilSelected);}if($$self.$$.dirty[0]&/*utilSelected, pluginInterface*/524289){$$invalidate(216,utilTools=utilSelected&&pluginInterface[utilSelected].tools||[]);}if($$self.$$.dirty[0]&/*utilsMerged, utilsVisibleFraction*/3145728){$$invalidate(21,utilsVisibleFraction=utilsMerged.reduce((prev,curr)=>{prev[curr.id]=utilsVisibleFraction&&utilsVisibleFraction[curr.id]||0;return prev;},{}));}if($$self.$$.dirty[0]&/*utilSelected*/524288){$$invalidate(31,tabsConfig={name:utilsUniqueId,selected:utilSelected});}if($$self.$$.dirty[0]&/*utilsMerged*/1048576){$$invalidate(32,tabs=utilsMerged.map(util=>({id:util.id,icon:util.tabIcon,label:util.tabLabel})));}if($$self.$$.dirty[0]&/*utilsMerged*/1048576){$$invalidate(33,panels=utilsMerged.map(util=>util.id));}if($$self.$$.dirty[4]&/*klass*/524288){$$invalidate(34,className=arrayJoin(["PinturaRoot","PinturaRootComponent",klass]));}if($$self.$$.dirty[5]&/*$rootRect*/134217728){$$invalidate(217,horizontalSpace=$rootRect&&($rootRect.width>1000?"wide":$rootRect.width<600?"narrow":undefined));}if($$self.$$.dirty[5]&/*$rootRect*/134217728){$$invalidate(218,hasLimitedSpace=$rootRect&&($rootRect.width<=320||$rootRect.height<=460));}if($$self.$$.dirty[5]&/*$rootRect*/134217728){$$invalidate(219,verticalSpace=$rootRect&&($rootRect.height>1000?"tall":$rootRect.height<600?"short":undefined));}if($$self.$$.dirty[0]&/*root*/2){$$invalidate(220,isModal=root&&root.parentNode&&root.parentNode.classList.contains("PinturaModal"));}if($$self.$$.dirty[0]&/*windowWidth*/2048|$$self.$$.dirty[5]&/*$rootRect*/134217728|$$self.$$.dirty[7]&/*isModal*/8){$$invalidate(221,isCenteredHorizontally=isModal&&$rootRect&&windowWidth>$rootRect.width);}if($$self.$$.dirty[0]&/*windowHeight*/4096|$$self.$$.dirty[5]&/*$rootRect*/134217728|$$self.$$.dirty[7]&/*isModal*/8){$$invalidate(222,isCenteredVertically=isModal&&$rootRect&&windowHeight>$rootRect.height);}if($$self.$$.dirty[7]&/*isCenteredHorizontally, isCenteredVertically*/48){$$invalidate(223,isCentered=isCenteredHorizontally&&isCenteredVertically);}if($$self.$$.dirty[7]&/*horizontalSpace*/1){$$invalidate(224,isNarrow=horizontalSpace==="narrow");}if($$self.$$.dirty[5]&/*$rootRect, layoutDirectionPreference*/134218240){$$invalidate(225,orientation=getOrientation($rootRect,layoutDirectionPreference));}if($$self.$$.dirty[7]&/*orientation*/256){$$invalidate(35,isLandscape=orientation==="landscape");}if($$self.$$.dirty[7]&/*isNarrow, verticalSpace*/132){$$invalidate(226,isCompact=isNarrow||verticalSpace==="short");}if($$self.$$.dirty[0]&/*windowWidth*/2048|$$self.$$.dirty[5]&/*$rootRect*/134217728){$$invalidate(227,hasSwipeNavigation=iOS&&$rootRect&&windowWidth===$rootRect.width&&!shouldPreventSwipe);}if($$self.$$.dirty[5]&/*isOverlayModeEnabled*/16777216|$$self.$$.dirty[6]&/*utilTools*/1073741824|$$self.$$.dirty[7]&/*verticalSpace*/4){$$invalidate(228,shouldRenderUtilTools=utilTools.length&&(verticalSpace==="short"||isOverlayModeEnabled));}if($$self.$$.dirty[5]&/*layoutHorizontalUtilsPreference*/1024){$$invalidate(229,navigationHorizontalPreference=`has-navigation-preference-${layoutHorizontalUtilsPreference}`);}if($$self.$$.dirty[5]&/*layoutVerticalUtilsPreference*/2048){$$invalidate(230,navigationVerticalPreference=`has-navigation-preference-${layoutVerticalUtilsPreference}`);}if($$self.$$.dirty[0]&/*root*/2){// will update when root element is available (computed style is live, so is updated when the style is updated)
$$invalidate(231,rootElementComputedStyle=root&&getComputedStyle(root));}if($$self.$$.dirty[7]&/*rootElementComputedStyle*/16384){// sync for first time
if(rootElementComputedStyle)syncColors();}if($$self.$$.dirty[0]&/*$shouldAnimate, enableToolbar, shouldRenderTabs, showUtils*/426048|$$self.$$.dirty[4]&/*layoutMode, disabled*/34603008|$$self.$$.dirty[7]&/*$env, orientation, horizontalSpace, verticalSpace, navigationHorizontalPreference, navigationVerticalPreference, isModal, isCentered, isCenteredHorizontally, isCenteredVertically, $pointerAccuracy, $pointerHoverable, isCompact, hasSwipeNavigation, hasLimitedSpace*/243583){env.set({...$env,layoutMode,orientation,horizontalSpace,verticalSpace,navigationHorizontalPreference,navigationVerticalPreference,isModal,isDisabled:disabled,isCentered,isCenteredHorizontally,isCenteredVertically,isAnimated:$shouldAnimate,pointerAccuracy:$pointerAccuracy,pointerHoverable:$pointerHoverable,isCompact,hasSwipeNavigation,hasLimitedSpace,hasToolbar:enableToolbar,hasNavigation:shouldRenderTabs&&showUtils,isIOS:iOS});}if($$self.$$.dirty[7]&/*$env*/32768){$$invalidate(36,envStr=Object.entries($env).map(([key,value])=>{// is true boolean prop, use key
if(/^is|has/.test(key)){return value?toKebabCase(key):undefined;}// use value
return value;}).filter(Boolean).join(" "));}if($$self.$$.dirty[7]&/*$imageTransforms, $imagePreviewModifiers*/786432){$$invalidate(37,imageCanvasState=$imageTransforms&&Object.entries($imagePreviewModifiers).filter(([,value])=>value!=null).reduce((prev,[,value])=>{prev={...prev,...value};return prev;},{}));}if($$self.$$.dirty[5]&/*$imageLoadState*/268435456){//
// loading status
//
$$invalidate(237,isStartLoadingImageSource=$imageLoadState&&$imageLoadState.task==="any-to-file");}if($$self.$$.dirty[7]&/*isStartLoadingImageSource*/1048576){// reset active images when loading a new image source
if(isStartLoadingImageSource&&activeImages){activeImages.clear();}}if($$self.$$.dirty[7]&/*$imageProps*/2097152){// if image props are ready
$$invalidate(239,hasProps=!!$imageProps&&!!$imageProps.translation);}if($$self.$$.dirty[5]&/*lastImagePreview*/1048576|$$self.$$.dirty[6]&/*$imagePreview*/524288|$$self.$$.dirty[7]&/*hasProps*/4194304){if(hasProps&&$imagePreview&&$imagePreview!==lastImagePreview){$$invalidate(175,lastImagePreview=$imagePreview);addImagePreview();}}if($$self.$$.dirty[7]&/*hasProps, $imageProps*/6291456){// update images when image props change
hasProps&&updateImagePreviews($imageProps);}if($$self.$$.dirty[0]&/*$activeImages*/4194304){// clean active images array, removes 'inactive' images when their opacity is 0
if($activeImages&&$activeImages.length>1){let imagesToRemove=[];activeImages.forEach((image,index)=>{if(index===0)return;if(image.get().opacity<=0)imagesToRemove.push(image);});imagesToRemove.forEach(image=>activeImages.remove(image));}}if($$self.$$.dirty[0]&/*locale*/4|$$self.$$.dirty[7]&/*missingFeatures*/8388608){$$invalidate(23,isSupportsError=locale&&missingFeatures.length&&locale.labelSupportError(missingFeatures));}if($$self.$$.dirty[5]&/*$imageLoadState*/268435456){$$invalidate(241,isImageLoadError=$imageLoadState&&!!$imageLoadState.error);}if($$self.$$.dirty[5]&/*$imageLoadState*/268435456){$$invalidate(24,isWaitingForImage=!$imageLoadState||!$imageLoadState.complete&&$imageLoadState.task===undefined);}if($$self.$$.dirty[5]&/*$imageLoadState*/268435456){$$invalidate(242,imageLoadProgress=$imageLoadState&&($imageLoadState.taskLengthComputable?$imageLoadState.taskProgress:Infinity));}if($$self.$$.dirty[7]&/*isStartLoadingImageSource*/1048576){if(isStartLoadingImageSource)set_store_value(imageVisualLoadComplete,$imageVisualLoadComplete=false,$imageVisualLoadComplete);}if($$self.$$.dirty[5]&/*$imageLoadState, loadTimer*/270532608){if($imageLoadState&&$imageLoadState.complete){const minLoaderDuration=500;// TODO: derive visual load complete from interface rest state instead of arbitrary timer
clearTimeout(loadTimer);$$invalidate(176,loadTimer=setTimeout(()=>{set_store_value(imageVisualLoadComplete,$imageVisualLoadComplete=true,$imageVisualLoadComplete);},minLoaderDuration));}}if($$self.$$.dirty[0]&/*isWaitingForImage*/16777216|$$self.$$.dirty[5]&/*$imageLoadState*/268435456|$$self.$$.dirty[7]&/*isImageLoadError, $imageVisualLoadComplete*/150994944){$$invalidate(243,isLoadingImageData=$imageLoadState&&!isImageLoadError&&!isWaitingForImage&&!$imageVisualLoadComplete);}if($$self.$$.dirty[5]&/*imagePreviewLoaderCancelToken*/524288|$$self.$$.dirty[6]&/*$imagePreviewSource, $imagePreview*/1572864){// is creating a preview while an image source is set and the preview isn't ready or when a cancel token is found
$$invalidate(245,isCreatingImagePreview=!!$imagePreviewSource&&(!$imagePreview||!!imagePreviewLoaderCancelToken));}if($$self.$$.dirty[6]&/*$imageProcessingPreparing*/134217728|$$self.$$.dirty[7]&/*$imageProcessState*/1073741824){//
// processing status
//
$$invalidate(246,isProcessingImage=$imageProcessingPreparing||$imageProcessState&&$imageProcessState.progress!==undefined&&!$imageProcessState.complete);}if($$self.$$.dirty[0]&/*isWaitingForImage*/16777216|$$self.$$.dirty[5]&/*$imageLoadState*/268435456){$$invalidate(248,imageLoadShowProgressIndicator=$imageLoadState&&!($imageLoadState.error||isWaitingForImage));}if($$self.$$.dirty[0]&/*locale*/4|$$self.$$.dirty[5]&/*$imageLoadState*/268435456){$$invalidate(249,imageLoadStatusLabel=locale&&(!$imageLoadState?locale.statusLabelLoadImage($imageLoadState):!$imageLoadState.complete||$imageLoadState.error?stringReplace(locale.statusLabelLoadImage($imageLoadState),$imageLoadState.error&&$imageLoadState.error.metadata,"{","}"):locale.statusLabelLoadImage({progress:Infinity,task:"blob-to-bitmap"})));}if($$self.$$.dirty[0]&/*locale*/4|$$self.$$.dirty[7]&/*$imageProcessState*/1073741824){$$invalidate(250,imageProcessStatusLabel=$imageProcessState&&locale&&locale.statusLabelProcessImage($imageProcessState));}if($$self.$$.dirty[7]&/*$imageProcessState*/1073741824){$$invalidate(251,imageProcessProgress=$imageProcessState&&($imageProcessState.taskLengthComputable?$imageProcessState.taskProgress:Infinity));}if($$self.$$.dirty[7]&/*$imageProcessState*/1073741824){$$invalidate(252,imageProcessShowProgressIndicator=$imageProcessState&&!$imageProcessState.error);}if($$self.$$.dirty[7]&/*$imageProcessState*/1073741824){$$invalidate(253,isImageProcessingError=$imageProcessState&&$imageProcessState.error);}if($$self.$$.dirty[0]&/*locale, isWaitingForImage*/16777220|$$self.$$.dirty[4]&/*status*/131072|$$self.$$.dirty[7]&/*isImageLoadError, isLoadingImageData, isCreatingImagePreview, imageLoadProgress, isProcessingImage*/922746880|$$self.$$.dirty[8]&/*imageLoadStatusLabel, imageLoadShowProgressIndicator, imageProcessStatusLabel, isImageProcessingError, imageProcessShowProgressIndicator, imageProcessProgress*/63){if(status){let label;let progress;let showProgress;let isError;let errorCallback;if(pintura_isString(status))label=status;if(pintura_isNumber(status))progress=status;else if(Array.isArray(status)){[label,progress,errorCallback]=status;if(progress===false)isError=true;if(pintura_isNumber(progress))showProgress=true;}$$invalidate(13,statusState=(label||progress)&&{text:label,aside:isError||showProgress,progressIndicator:{visible:showProgress,progress},closeButton:isError&&{label:locale.statusLabelButtonClose,icon:locale.statusIconButtonClose,onclick:errorCallback||(()=>$$invalidate(141,status=undefined))}});}else if(locale&&isWaitingForImage||isImageLoadError||isLoadingImageData||isCreatingImagePreview){$$invalidate(13,statusState={text:imageLoadStatusLabel,aside:isImageLoadError||imageLoadShowProgressIndicator,progressIndicator:{visible:imageLoadShowProgressIndicator,progress:imageLoadProgress},closeButton:isImageLoadError&&{label:locale.statusLabelButtonClose,icon:locale.statusIconButtonClose,onclick:handleCloseImageLoadError}});}else if(locale&&isProcessingImage&&imageProcessStatusLabel){$$invalidate(13,statusState={text:imageProcessStatusLabel,aside:isImageProcessingError||imageProcessShowProgressIndicator,progressIndicator:{visible:imageProcessShowProgressIndicator,progress:imageProcessProgress},closeButton:isImageProcessingError&&{label:locale.statusLabelButtonClose,icon:locale.statusIconButtonClose,onclick:handleCloseImageProcessError}});}else{$$invalidate(13,statusState=undefined);}}if($$self.$$.dirty[4]&/*status*/131072){$$invalidate(254,isCustomStatus=status!==undefined);}if($$self.$$.dirty[7]&/*isModal, $imageProcessState*/1073741832){if(isModal&&$imageProcessState&&$imageProcessState.complete){wasProcessingImage.set(true);setTimeout(()=>wasProcessingImage.set(false),100);}}if($$self.$$.dirty[0]&/*isSupportsError, isWaitingForImage*/25165824|$$self.$$.dirty[7]&/*isImageLoadError, isLoadingImageData, isCreatingImagePreview, isProcessingImage*/889192448|$$self.$$.dirty[8]&/*$wasProcessingImage, isCustomStatus*/320){$$invalidate(255,isStatusActive=$wasProcessingImage||isSupportsError||isWaitingForImage||isImageLoadError||isLoadingImageData||isCreatingImagePreview||isProcessingImage||isCustomStatus);}if($$self.$$.dirty[8]&/*isStatusActive*/128){set_store_value(statusOpacity,$statusOpacity=isStatusActive?1:0,$statusOpacity);}if($$self.$$.dirty[0]&/*$statusOpacity*/33554432){$$invalidate(26,isStatusVisible=$statusOpacity>0);}if($$self.$$.dirty[0]&/*statusState*/8192){$$invalidate(257,hasAside=!!(statusState&&statusState.aside));}if($$self.$$.dirty[0]&/*isStatusVisible, statusState*/67117056|$$self.$$.dirty[5]&/*asideWidthUpdateTimer*/4194304|$$self.$$.dirty[8]&/*hasAside, $statusWidth*/1536){if(isStatusVisible&&statusState){clearTimeout(asideWidthUpdateTimer);// has aside
if(hasAside){// if error occured, snap in possition
const hard=!!statusState.error;asideOpacity.set(1);// update offset of aside
asideOffset.set($statusWidth,{hard});// update width of aside, this pushes message to left so it stays centered
$$invalidate(177,asideWidthUpdateTimer=setTimeout(()=>{asideWidth.set(16);},1));}else{asideOpacity.set(0);$$invalidate(177,asideWidthUpdateTimer=setTimeout(()=>{asideWidth.set(0);},1));}}}if($$self.$$.dirty[0]&/*isStatusVisible*/67108864){if(!isStatusVisible){statusOffset.set(undefined,{hard:true});asideOffset.set(undefined,{hard:true});asideWidth.set(0,{hard:true});}}if($$self.$$.dirty[8]&/*$asideWidth*/4096){$$invalidate(259,statusIndent=$asideWidth*0.5);}if($$self.$$.dirty[8]&/*$statusOffset, statusIndent*/10240){$$invalidate(39,statusTransform=`transform: translateX(${$statusOffset-statusIndent}px)`);}if($$self.$$.dirty[0]&/*locale*/4|$$self.$$.dirty[4]&/*willRenderToolbar*/536870912|$$self.$$.dirty[5]&/*enableButtonClose, enableButtonRevert, enableNavigateHistory, enableButtonExport*/23|$$self.$$.dirty[6]&/*canUndo, canRedo, utilTools*/1157627904|$$self.$$.dirty[7]&/*shouldRenderUtilTools, isNarrow, $env*/34944){// dynamic IO menu
$$invalidate(40,toolbarItems=locale&&willRenderToolbar([["div","alpha",{class:"PinturaNavGroup"},[["div","alpha-set",{class:"PinturaNavSet"},[// button close
enableButtonClose&&["Button","close",{label:locale.labelClose,icon:locale.iconButtonClose,onclick:()=>dispatch("close"),hideLabel:true}],// button revert
enableButtonRevert&&["Button","revert",{label:locale.labelButtonRevert,icon:locale.iconButtonRevert,disabled:!canUndo,onclick:revert,hideLabel:true}]]]]],["div","beta",{class:"PinturaNavGroup PinturaNavGroupFloat"},[enableNavigateHistory&&["div","history",{class:"PinturaNavSet"},[["Button","undo",{label:locale.labelButtonUndo,icon:locale.iconButtonUndo,disabled:!canUndo,onclick:history.undo,hideLabel:true}],["Button","redo",{label:locale.labelButtonRedo,icon:locale.iconButtonRedo,disabled:!canRedo,onclick:history.redo,hideLabel:true}]]],shouldRenderUtilTools&&["div","plugin-tools",{class:"PinturaNavSet"},utilTools.filter(Boolean).map(// in
([component,key,props])=>// out
[component,key,{...props,hideLabel:true}])]]],["div","gamma",{class:"PinturaNavGroup"},[enableButtonExport&&["Button","export",{label:locale.labelButtonExport,icon:isNarrow&&locale.iconButtonExport,class:"PinturaButtonExport",onclick:handleExport,hideLabel:isNarrow}]]]],{...$env}));}if($$self.$$.dirty[0]&/*$clientRect*/65536){$$invalidate(262,hasClientRect=$clientRect&&$clientRect.width>0&&$clientRect.height>0);}if($$self.$$.dirty[0]&/*locale*/4|$$self.$$.dirty[6]&/*utilsDefined*/536870912|$$self.$$.dirty[8]&/*hasClientRect*/16384){$$invalidate(41,canRender=hasClientRect&&locale&&utilsDefined);}if($$self.$$.dirty[8]&/*$imageRedaction*/65536){// toggles on/off depending on active redaction shapes
$$invalidate(263,hasImageRedaction=$imageRedaction&&!!$imageRedaction.length);}if($$self.$$.dirty[6]&/*$imageSize*/8|$$self.$$.dirty[8]&/*hasImageRedaction, $imageRedaction*/98304){// scales down resolution of scrambled image if redaction takes up more than half of view
$$invalidate(265,imageRedactionScalar=hasImageRedaction&&getImageRedactionScaleFactor($imageSize,$imageRedaction));}if($$self.$$.dirty[6]&/*$imagePreview*/524288|$$self.$$.dirty[8]&/*hasImageRedaction, $imageScrambler, imageRedactionScalar, $imageBackgroundColor*/950272){// only update/render preview if image redaction shapes are found
hasImageRedaction&&updateScrambledPreview($imagePreview,$imageScrambler,imageRedactionScalar,$imageBackgroundColor);}if($$self.$$.dirty[5]&/*scrambledPreviewImage*/8388608|$$self.$$.dirty[6]&/*$imageSize*/8|$$self.$$.dirty[8]&/*$imageRedaction*/65536){if($imageRedaction&&scrambledPreviewImage&&$imageSize){// used to calculate fraction x y coordinates of shape corners
const{width,height}=$imageSize;// to blended shapes
$$invalidate(29,blendShapes=$imageRedaction.map(shape=>{const rect=rectCreate(shape.x,shape.y,shape.width,shape.height);const corners=rectRotate(rectClone(rect),shape.rotation);const backgroundCorners=corners.map(corner=>vectorCreate(corner.x/width,corner.y/height));return{...shape,id:"redaction",flipX:false,flipY:false,cornerRadius:0,strokeWidth:0,strokeColor:undefined,backgroundColor:[0,0,0],backgroundImage:scrambledPreviewImage,backgroundImageRendering:"pixelated",backgroundCorners};}));}}if($$self.$$.dirty[0]&/*rootPortal*/16384){rootPortal&&rootPortalStore.set(rootPortal);}if($$self.$$.dirty[0]&/*isSupportsError*/8388608|$$self.$$.dirty[6]&/*$imagePreview*/524288){// ready bool
$$invalidate(27,isReady=$imagePreview&&!isSupportsError);}if($$self.$$.dirty[0]&/*isReady, root*/134217730){// now ready for interaction
isReady&&root.dispatchEvent(createPing("ready"));}};$$invalidate(240,missingFeatures=[!supportsWebGL()&&"WebGL"].filter(Boolean));// used to route ping events
$$invalidate(42,routePing=createPingRouter(eventProxy.pub));return[pluginInterface,root,locale,id,elasticityMultiplier,willRenderCanvas,enableToolbar,pluginOptions,imageSourceToImageData,imagePreview,history,windowWidth,windowHeight,statusState,rootPortal,showUtils,$clientRect,shouldRenderTabs,$shouldAnimate,utilSelected,utilsMerged,utilsVisibleFraction,$activeImages,isSupportsError,isWaitingForImage,$statusOpacity,isStatusVisible,isReady,utilsVisible,blendShapes,$tabRect,tabsConfig,tabs,panels,className,isLandscape,envStr,imageCanvasState,$imageSelectionRectPresentation,statusTransform,toolbarItems,canRender,routePing,$asideOffset,$asideOpacity,$toolRect,$utilRect,$pixelRatio,$rootBackgroundColor,$utilSelectedStore,$stagePadded,$interfaceImages,$imageAnnotation,$imageDecoration,$imageFrame,$imageOverlay,$disabledTransition,disabledTransition,imageFile,imageSize,imageLoadState,imageProcessState,imageCropAspectRatio,imageCropRect,imageOutputSize,imageBackgroundColor,imageDecoration,imageAnnotation,imageRedaction,imageFrame,imageState,images,shapePreprocessor,imageScrambler,utilSelectedStore,rootBackgroundColor,rootForegroundColor,rootLineColor,clientRect,rootRect,tabRect,toolRect,utilRect,pointerAccuracy,pointerHoverable,isInteracting,isInteractingFraction,previewShouldUpscale,imageCropRectSnapshot,imageCropRectIntent,imageSelectionRect,imageSelectionRectSnapshot,imageSelectionRectIntent,stagePadded,stageRect,stageScalar,imageSelectionRectPresentation,presentationScalar,imageVisualBounds,imageOverlayMarkup,imageOverlay,overlayInset,overlaySize,overlayLeftOpacity,overlayRightOpacity,overlayTopOpacity,overlayBottomOpacity,imageVisualLoadComplete,imagePreviewSource,imagePreviewModifiers,interfaceImages,imageTransforms,env,pixelRatio,shouldAnimate,imageProcessingPreparing,utilStores,handleTransitionEnd,imageProps,activeImages,statusOpacity,wasProcessingImage,asideOffset,asideOpacity,asideWidth,statusWidth,statusOffset,offsetAside,handleTouchStart,handleTouchMove,handlePointerMove,pressedKeysStore,handleKeydown,handleKeyup,handleWindowBlur,handleContextMenu,handleDropFiles,browseFileSystem,handlePaste,getStageState,createCanvasState,status,imagePreviewCurrent,klass,layoutMode,stores,util,utils,animations,disabled,previewUpscale,willRevert,willProcessImage,willRenderToolbar,willSetHistoryInitialState,enableButtonExport,enableButtonRevert,enableNavigateHistory,enableUtils,enableButtonClose,enableDropImage,enablePasteImage,enableBrowseImage,previewImageDataMaxSize,layoutDirectionPreference,layoutHorizontalUtilsPreference,layoutVerticalUtilsPreference,imagePreviewSrc,imageOrienter,pluginComponents,sub,registeredPluginsComponents,gradientOverlayHorizontal,gradientOverlayVertical,imagePreviewLoaderCancelToken,lastImagePreview,loadTimer,asideWidthUpdateTimer,scrambledPreviewImage,isOverlayModeEnabled,$images,$shapePreprocessor,$rootRect,$imageLoadState,$imageCropRect,$isInteracting,utilsFiltered,$stageRect,$imageOutputSize,$imageSize,imageTargetSizeCurrent,$overlayInset,$imageVisualBounds,overlayTop,$overlaySize,$overlayTopOpacity,overlayBottom,$overlayBottomOpacity,overlayLeft,$overlayLeftOpacity,overlayRight,$overlayRightOpacity,gradientOverlays,$imageOverlayMarkup,$imageFile,$imagePreview,$imagePreviewSource,canAnimate,acceptsAnimations,$prefersReducedMotion,canUndo,$history,canRedo,$imageProcessingPreparing,utilsAvailable,utilsDefined,utilTools,horizontalSpace,hasLimitedSpace,verticalSpace,isModal,isCenteredHorizontally,isCenteredVertically,isCentered,isNarrow,orientation,isCompact,hasSwipeNavigation,shouldRenderUtilTools,navigationHorizontalPreference,navigationVerticalPreference,rootElementComputedStyle,$env,$pointerAccuracy,$pointerHoverable,$imageTransforms,$imagePreviewModifiers,isStartLoadingImageSource,$imageProps,hasProps,missingFeatures,isImageLoadError,imageLoadProgress,isLoadingImageData,$imageVisualLoadComplete,isCreatingImagePreview,isProcessingImage,$imageProcessState,imageLoadShowProgressIndicator,imageLoadStatusLabel,imageProcessStatusLabel,imageProcessProgress,imageProcessShowProgressIndicator,isImageProcessingError,isCustomStatus,isStatusActive,$wasProcessingImage,hasAside,$statusWidth,statusIndent,$asideWidth,$statusOffset,hasClientRect,hasImageRedaction,$imageRedaction,imageRedactionScalar,$imageScrambler,$imageBackgroundColor,onwindowresize,measure_handler,select_handler,func,panel_component_binding,measure_handler_1,show_handler,hide_handler,fade_handler,measure_handler_2,func_1,panel_component_binding_1,measure_handler_3,show_handler_1,hide_handler_1,fade_handler_1,func_2,div_binding,div_binding_1,measure_handler_4];}class Ui extends SvelteComponent{constructor(options){super();init(this,options,instance$u,create_fragment$u,safe_not_equal,{class:143,layout:144,stores:145,locale:2,id:3,util:146,utils:147,animations:148,disabled:149,status:141,previewUpscale:150,elasticityMultiplier:4,willRevert:151,willProcessImage:152,willRenderCanvas:5,willRenderToolbar:153,willSetHistoryInitialState:154,enableButtonExport:155,enableButtonRevert:156,enableNavigateHistory:157,enableToolbar:6,enableUtils:158,enableButtonClose:159,enableDropImage:160,enablePasteImage:161,enableBrowseImage:162,previewImageDataMaxSize:163,layoutDirectionPreference:164,layoutHorizontalUtilsPreference:165,layoutVerticalUtilsPreference:166,imagePreviewSrc:167,imageOrienter:168,pluginComponents:169,pluginOptions:7,sub:170,pluginInterface:0,root:1,imageSourceToImageData:8,imagePreview:9,imagePreviewCurrent:142,history:10},[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1]);}get class(){return this.$$.ctx[143];}set class(klass){this.$set({class:klass});flush();}get layout(){return this.$$.ctx[144];}set layout(layoutMode){this.$set({layout:layoutMode});flush();}get stores(){return this.$$.ctx[145];}set stores(stores){this.$set({stores});flush();}get locale(){return this.$$.ctx[2];}set locale(locale){this.$set({locale});flush();}get id(){return this.$$.ctx[3];}set id(id){this.$set({id});flush();}get util(){return this.$$.ctx[146];}set util(util){this.$set({util});flush();}get utils(){return this.$$.ctx[147];}set utils(utils){this.$set({utils});flush();}get animations(){return this.$$.ctx[148];}set animations(animations){this.$set({animations});flush();}get disabled(){return this.$$.ctx[149];}set disabled(disabled){this.$set({disabled});flush();}get status(){return this.$$.ctx[141];}set status(status){this.$set({status});flush();}get previewUpscale(){return this.$$.ctx[150];}set previewUpscale(previewUpscale){this.$set({previewUpscale});flush();}get elasticityMultiplier(){return this.$$.ctx[4];}set elasticityMultiplier(elasticityMultiplier){this.$set({elasticityMultiplier});flush();}get willRevert(){return this.$$.ctx[151];}set willRevert(willRevert){this.$set({willRevert});flush();}get willProcessImage(){return this.$$.ctx[152];}set willProcessImage(willProcessImage){this.$set({willProcessImage});flush();}get willRenderCanvas(){return this.$$.ctx[5];}set willRenderCanvas(willRenderCanvas){this.$set({willRenderCanvas});flush();}get willRenderToolbar(){return this.$$.ctx[153];}set willRenderToolbar(willRenderToolbar){this.$set({willRenderToolbar});flush();}get willSetHistoryInitialState(){return this.$$.ctx[154];}set willSetHistoryInitialState(willSetHistoryInitialState){this.$set({willSetHistoryInitialState});flush();}get enableButtonExport(){return this.$$.ctx[155];}set enableButtonExport(enableButtonExport){this.$set({enableButtonExport});flush();}get enableButtonRevert(){return this.$$.ctx[156];}set enableButtonRevert(enableButtonRevert){this.$set({enableButtonRevert});flush();}get enableNavigateHistory(){return this.$$.ctx[157];}set enableNavigateHistory(enableNavigateHistory){this.$set({enableNavigateHistory});flush();}get enableToolbar(){return this.$$.ctx[6];}set enableToolbar(enableToolbar){this.$set({enableToolbar});flush();}get enableUtils(){return this.$$.ctx[158];}set enableUtils(enableUtils){this.$set({enableUtils});flush();}get enableButtonClose(){return this.$$.ctx[159];}set enableButtonClose(enableButtonClose){this.$set({enableButtonClose});flush();}get enableDropImage(){return this.$$.ctx[160];}set enableDropImage(enableDropImage){this.$set({enableDropImage});flush();}get enablePasteImage(){return this.$$.ctx[161];}set enablePasteImage(enablePasteImage){this.$set({enablePasteImage});flush();}get enableBrowseImage(){return this.$$.ctx[162];}set enableBrowseImage(enableBrowseImage){this.$set({enableBrowseImage});flush();}get previewImageDataMaxSize(){return this.$$.ctx[163];}set previewImageDataMaxSize(previewImageDataMaxSize){this.$set({previewImageDataMaxSize});flush();}get layoutDirectionPreference(){return this.$$.ctx[164];}set layoutDirectionPreference(layoutDirectionPreference){this.$set({layoutDirectionPreference});flush();}get layoutHorizontalUtilsPreference(){return this.$$.ctx[165];}set layoutHorizontalUtilsPreference(layoutHorizontalUtilsPreference){this.$set({layoutHorizontalUtilsPreference});flush();}get layoutVerticalUtilsPreference(){return this.$$.ctx[166];}set layoutVerticalUtilsPreference(layoutVerticalUtilsPreference){this.$set({layoutVerticalUtilsPreference});flush();}get imagePreviewSrc(){return this.$$.ctx[167];}set imagePreviewSrc(imagePreviewSrc){this.$set({imagePreviewSrc});flush();}get imageOrienter(){return this.$$.ctx[168];}set imageOrienter(imageOrienter){this.$set({imageOrienter});flush();}get pluginComponents(){return this.$$.ctx[169];}set pluginComponents(pluginComponents){this.$set({pluginComponents});flush();}get pluginOptions(){return this.$$.ctx[7];}set pluginOptions(pluginOptions){this.$set({pluginOptions});flush();}get sub(){return this.$$.ctx[170];}get pluginInterface(){return this.$$.ctx[0];}get root(){return this.$$.ctx[1];}set root(root){this.$set({root});flush();}get imageSourceToImageData(){return this.$$.ctx[8];}set imageSourceToImageData(imageSourceToImageData){this.$set({imageSourceToImageData});flush();}get imagePreview(){return this.$$.ctx[9];}get imagePreviewCurrent(){return this.$$.ctx[142];}set imagePreviewCurrent(imagePreviewCurrent){this.$set({imagePreviewCurrent});flush();}get history(){return this.$$.ctx[10];}}// which props to filter out of exported props
const utilPrivateProps=['klass','stores','isVisible','isActive','isActiveFraction','locale'];const viewPrivateProps=[// methods
'history',// props
'klass','stores','navButtons','pluginComponents','pluginInterface','pluginOptions','sub','imagePreviewSrc','imagePreview','imagePreviewCurrent'];// view options array
let editorProps;const pluginProps=new Set([]);const propPluginRef={};// loops over plugins and registers all available options so we can define getters/setters
const pluginComponents=new Map();const setEditorViewPlugins=(...args)=>{args.filter(plugin=>!!plugin.util).forEach(plugin=>{const[id,Component]=plugin.util;if(pluginComponents.has(id))return;pluginComponents.set(id,Component);getComponentExportedProps(Component).filter(prop=>!utilPrivateProps.includes(prop)).forEach(prop=>{pluginProps.add(prop);if(propPluginRef[prop]){propPluginRef[prop].push(id);return;}propPluginRef[prop]=[id];});});};const getEditorViewProps=()=>{editorProps=new Set(getComponentExportedProps(Ui).filter(prop=>!viewPrivateProps.includes(prop)));return[...editorProps,...pluginProps];};const attachEditorView=(target,stores)=>{const accessors={};// creates the editor component instance
const editor=new Ui({target,props:{stores,pluginComponents:Array.from(pluginComponents)}});// destroys the editor component instance
let isDestroyed=false;const destroy=()=>{if(isDestroyed)return;if(isBrowser())window.removeEventListener('pagehide',destroy);if(!editor)return;isDestroyed=true;editor.$destroy();};// set up accessors for editor props
if(!editorProps)editorProps=new Set(getComponentExportedProps(Ui).filter(prop=>!viewPrivateProps.includes(prop)));editorProps.forEach(prop=>{Object.defineProperty(accessors,prop,{get:()=>editor[prop],set:value=>editor[prop]=value});});// this reads the imagePreview store so third parties can interact with image data
Object.defineProperty(accessors,'previewImageData',{get:()=>editor.imagePreviewCurrent});// set up accessors for plugin props
pluginProps.forEach(prop=>{const plugins=propPluginRef[prop];const plugin=plugins[0];// will always get value from first plugin, when plugins share a property the value will be in sync when set
Object.defineProperty(accessors,prop,{get:()=>editor.pluginInterface[plugin][prop],set:value=>{const opts=plugins.reduce((prev,plugin)=>{prev[plugin]={...editor.pluginOptions[plugin],[prop]:value};return prev;},{});editor.pluginOptions={...editor.pluginOptions,...opts};}});});// add `element` root query
Object.defineProperty(accessors,'element',{get:()=>editor.root,set:()=>undefined});// history shortcut
const history=editor.history;defineMethods(accessors,{on:(event,cb)=>{// exit if editor was destroyed, will return stub function so unsubs can be called without issues
if(isDestroyed)return()=>{// Do nothing
};// catch history events and route to history object
if(/undo|redo|revert/.test(event))return history.on(event,cb);// gather unsub methods
const unsubs=[editor.sub(event,cb),editor.$on(event,e=>cb(e instanceof CustomEvent&&!e.detail?undefined:e))].filter(Boolean);// set up unsubscribe group
return()=>unsubs.forEach(unsub=>unsub());},updateImagePreview:src=>{editor.imagePreviewSrc=src;},close:()=>!isDestroyed&&editor.pub('close'),destroy});Object.defineProperty(accessors,'history',{get:()=>({undo:()=>history.undo(),redo:()=>history.redo(),revert:()=>history.revert(),get:()=>history.get(),set:entries=>history.set(entries),write:state=>history.write(state),get length(){return history.length();},get index(){return history.index;}})});// clean up on window unload
if(isBrowser())window.addEventListener('pagehide',destroy);return accessors;};var editorEvents=[// core editor events that should be re-dispatched
...editorEventsToBubble,// ui editor events
'undo','redo','update','revert','destroy','show','hide','close','ready','loadpreview','selectshape','updateshape','addshape','removeshape'];const dispatchElementEvent=(target,event,detail)=>target.dispatchEvent(new CustomEvent(event,{detail,bubbles:true,cancelable:true}));var dispatchEditorEvents=(editor,handler,options={})=>{const{prefix='pintura:'}=options;return editorEvents.map(event=>editor.on(event,value=>pintura_isElement(handler)?dispatchElementEvent(handler,`${prefix}${event}`,value):handler(event,value)));};var arrayInsert=(array,index,item)=>{array.splice(index,0,item);return array;};// first index is always id, so if is string, it's a node
const isNode=item=>pintura_isString(item[0]);// if it's not a node, it's a nodelist
const isNodeList=item=>!isNode(item);const getNodeId=node=>node[1];const getNodeChildren=node=>node[3]||[];function createNode(instance,id,props,children){// if three arguments received, props can be children
if(Array.isArray(props)){children=props;props={};}// node is always array of four entries
return[instance,id,props||{},children||[]];}const insertNode=(node,needle,haystack,getIndex=index=>index)=>{const nodeList=findNodeList(needle,haystack);const targetIndex=nodeList.findIndex(item=>getNodeId(item)===needle);arrayInsert(nodeList,getIndex(targetIndex),node);};const insertNodeBefore=(node,needle,haystack)=>insertNode(node,needle,haystack);const insertNodeAfter=(node,needle,haystack)=>insertNode(node,needle,haystack,index=>index+1);const appendNode=(node,haystack)=>{// if is list, add to list
if(isNodeList(haystack))return haystack.push(node);// else it's a node, add to node children
haystack[3]=[...getNodeChildren(haystack),node];};const removeNode=(needle,haystack)=>{const nodeList=findNodeList(needle,haystack);arrayRemove(nodeList,item=>getNodeId(item)===needle);return nodeList;};const findNode=(needle,haystack)=>{return isNode(haystack)?// haystack is a node, maybe node is a match or one of children is a match
getNodeId(haystack)===needle?haystack:findNode(needle,getNodeChildren(haystack)):// haystack is a list of nodes
haystack.find(item=>findNode(needle,item));};const findNodeList=(needle,haystack)=>{// haystack is node list
if(isNodeList(haystack)){// lets search nodes in this haystack
if(haystack.find(item=>getNodeId(item)===needle))return haystack;// not found, lets move the search to the childnodes
return haystack.find(item=>findNodeList(needle,getNodeChildren(item)));}// is node, lets find in children
return findNodeList(needle,getNodeChildren(haystack));};//#region markup
const propertyMap={borderColor:'strokeColor',borderWidth:'strokeWidth',lineWidth:'strokeWidth',fontColor:'color',lineColor:'strokeColor',src:'backgroundImage',fit:'backgroundSize'};const convertValue=value=>{if(value===0)return 0;if(value==='0%')return 0;if(value==='0px')return 0;if(/px$/.test(value))return parseInt(value,10);if(/\%$/.test(value))return value;if(value<=1)return`${value*100}%`;};const addValues=(a,b)=>{let _a,_b;if(/%$/.test(a)){_a=parseFloat(a);_b=parseFloat(b);return`${_a+_b}%`;}if(/px$/.test(a)){_a=parseInt(a,10);_b=parseInt(b,10);return`${_a+_b}px`;}};const shapeFromLegacyMarkup=(crop,type,style)=>{const shape=Object.keys(style).reduce((res,prop)=>{let value=style[prop];// rename prop
prop=propertyMap[prop]||prop;// if is px value
if(/px$/.test(value)){value=convertValue(value);}// if is number convert to percentage
else if(/^(?:x|y|left|right|top|bottom|width|height|fontSize|strokeWidth)$/.test(prop)&&typeof value==='number'){if(/strokeWidth/.test(prop))value*=2;value=convertValue(value);}// if is color value
if(/color/i.test(prop)){value=colorStringToColorArray(value);}if(value===null)value=undefined;res[prop]=value;return res;},{});if(type==='line'){if(shape.lineDecoration.length===1)shape.lineEnd='arrow';if(shape.lineDecoration.length===2)shape.lineStart='arrow';shape.x1=shape.x;shape.y1=shape.y;shape.x2=addValues(shape.x,shape.width);shape.y2=addValues(shape.y,shape.height);delete shape.x;delete shape.y;delete shape.width;delete shape.height;delete shape.lineDecoration;delete shape.lineStyle;}if(type==='text'){shape.y=addValues(shape.y,'-'+shape.fontSize);delete shape.width;delete shape.height;delete shape.borderStyle;}if(type==='ellipse'){let w,h;// calculate `rx` and `ry` based on `width` and `h`eight`
if(/%$/.test(shape.width)){w=parseFloat(shape.width)/100;h=parseFloat(shape.height)/100;const widthAbsolute=w*crop.width;const heightAbsolute=h*crop.height;w=widthAbsolute/crop.width*100;h=heightAbsolute/crop.height*100;}else{w=shape.width;h=shape.height;}shape.rx=w*0.5;shape.ry=h*0.5;if(/%$/.test(shape.width)){shape.rx+='%';shape.ry+='%';}shape.x=addValues(shape.x,shape.rx);shape.y=addValues(shape.y,shape.ry);delete shape.width;delete shape.height;delete shape.borderStyle;}if(type==='rect'){delete shape.borderStyle;}if(type==='path'){shape.points=shape.points.map(point=>{return{x:convertValue(point.x),y:convertValue(point.y)};});}return shape;};//#endregion
//#region crop
const getOffsetPointOnEdge=(length,rotation)=>{const a=length;const A=1.5707963267948966;const B=rotation;const C=1.5707963267948966-rotation;const sinA=Math.sin(A);const sinB=Math.sin(B);const sinC=Math.sin(C);const cosC=Math.cos(C);const ratio=a/sinA;const b=ratio*sinB;const c=ratio*sinC;return vectorCreate(cosC*b,cosC*c);};const getRotatedRectSize=(rect,rotation)=>{const w=rect.width;const h=rect.height;const hor=getOffsetPointOnEdge(w,rotation);const ver=getOffsetPointOnEdge(h,rotation);const tl=vectorCreate(rect.x+Math.abs(hor.x),rect.y-Math.abs(hor.y));const tr=vectorCreate(rect.x+rect.width+Math.abs(ver.y),rect.y+Math.abs(ver.x));const bl=vectorCreate(rect.x-Math.abs(ver.y),rect.y+rect.height-Math.abs(ver.x));return{width:vectorDistance(tl,tr),height:vectorDistance(tl,bl)};};const getBoundsAroundCenter=(imageSize,center)=>{const cx=center.x>0.5?1-center.x:center.x;const cy=center.y>0.5?1-center.y:center.y;return sizeCreate(cx*2*imageSize.width,cy*2*imageSize.height);};const getCanvasSize=(imageSize,canvasAspectRatio,zoom=1)=>{const imageAspectRatio=imageSize.height/imageSize.width;// determine actual pixels on x and y axis
let canvasWidth=1;let canvasHeight=canvasAspectRatio;let imgWidth=1;let imgHeight=imageAspectRatio;if(imgHeight>canvasHeight){imgHeight=canvasHeight;imgWidth=imgHeight/imageAspectRatio;}const scalar=Math.max(canvasWidth/imgWidth,canvasHeight/imgHeight);const width=imageSize.width/(zoom*scalar*imgWidth);const height=width*canvasAspectRatio;return{width:width,height:height};};const getCenteredCropRect=(imageSize,aspectRatio)=>{let width=imageSize.width;let height=width*aspectRatio;if(height>imageSize.height){height=imageSize.height;width=height/aspectRatio;}const x=(imageSize.width-width)*0.5;const y=(imageSize.height-height)*0.5;return rectCreate(x,y,width,height);};const getCorrectedLegacyAspectRatio=(imageSize,aspectRatio)=>aspectRatio!=null?// fox the aspect ratio
1/aspectRatio:// set image aspect ratio
imageSize.width/imageSize.height;const imagePropertiesFromLegacyCrop=(imageSize,{flip,aspectRatio,rotation,center,zoom,scaleToFit})=>{const res={};// is centered crop
const isCenteredCrop=!center||center&&center.x===0.5&&center.y===0.5;// handle basic props
if(flip&&flip.horizontal)res.flipHorizontal=flip.horizontal;if(flip&&flip.vertical)res.flipVertical=flip.vertical;// fix aspect ratio, in FilePond and editor v6 it's height/width instead of width/height
const correctedAspectRatio=getCorrectedLegacyAspectRatio(imageSize,aspectRatio);// image bounds
const cropLimit=!(scaleToFit===false);const canvasSize=getCanvasSize(imageSize,aspectRatio,zoom);const cropSize=isCenteredCrop?imageSize:getBoundsAroundCenter(imageSize,cropLimit?center:{x:0.5,y:0.5});const cropCentered=getCenteredCropRect(imageSize,aspectRatio);// has different aspect ratio than image
if(aspectRatio||!isCenteredCrop||zoom){res.crop=rectContainRect(rectCreateFromSize(cropSize),correctedAspectRatio);}if(typeof rotation==='number'&&rotation!==null){if(rotation!=null)res.rotation=rotation;const rotatedCropSize=getRotatedRectSize(cropCentered,rotation);const scalar=Math.max(rotatedCropSize.width/cropSize.width,rotatedCropSize.height/cropSize.height);// crop position in non-rotated image
const cropCenter=vectorCreate(center.x*imageSize.width,center.y*imageSize.height);// const imageCenter = sizeCenter(imageSize);
// const imageCenterToCropCenter = vectorCreate(
//     imageCenter.x - cropCenter.x,
//     imageCenter.y - cropCenter.y
// );
// get rotated image center
const rotatedImageSize=getImageTransformedRect(imageSize,rotation);const rotatedImageCenter=sizeCenter(rotatedImageSize);const rotatedImageOffset=vectorCreate((rotatedImageSize.width-imageSize.width)*0.5,(rotatedImageSize.height-imageSize.height)*0.5);// window.draw(rotatedImageCenter, 'red');
// window.draw(rotatedImageSize, 'red');
// window.draw(
//     {
//         x: rotatedImageOffset.x,
//         y: rotatedImageOffset.y,
//         width: imageSize.width,
//         height: imageSize.height,
//     },
//     'cyan'
// );
// const imagePoints = rectRotate(
//     rectCreate(
//         rotatedImageOffset.x,
//         rotatedImageOffset.y,
//         imageSize.width,
//         imageSize.height
//     ),
//     rotation
// );
// window.draw(imagePoints, 'orange');
const cropPoints=rectRotate({x:rotatedImageOffset.x+cropCenter.x-canvasSize.width/scalar*0.5,y:rotatedImageOffset.y+cropCenter.y-canvasSize.height/scalar*0.5,width:canvasSize.width/scalar,height:canvasSize.height/scalar},rotation);// window.draw(cropPoints, 'cyan');
const cropBoundsPoints=vectorsRotate(cropPoints.map(vectorClone),rotation,rotatedImageCenter.x,rotatedImageCenter.y);// window.draw(cropBoundsPoints, 'orange');
const cropBoundsPointsCenter=rectCenter(rectCreateFromPoints(cropBoundsPoints));// window.draw(cropBoundsPointsCenter, 'green');
const deRotatedCropBoundsPoints=vectorsRotate(cropBoundsPoints.map(vectorClone),-(rotation*2),cropBoundsPointsCenter.x,cropBoundsPointsCenter.y);// window.draw(deRotatedCropBoundsPoints, 'green');
res.crop=rectCreateFromPoints(deRotatedCropBoundsPoints);}else if(zoom!=null){rectScale(res.crop,1/zoom);}if(!cropLimit){res.cropLimitToImage=false;}return res;};//#endregion
const isLegacyData=(data={})=>{if('markup'in data||'color'in data||'filter'in data)return true;const{crop}=data;if(crop&&('flip'in crop||'center'in crop||'aspectRatio'in crop||'rotation'in crop))return true;return false;};var legacyDataToImageState=(editor,imageSize,data={})=>{const res={};// test if isn't legacy data
if(!isLegacyData(data))return data;if(data.crop){Object.assign(res,imagePropertiesFromLegacyCrop(imageSize,data.crop));}if(data.markup){const markup=Array.isArray(data.markup)?data.markup:Object.values(data.markup);res.decoration=markup.map(markup=>shapeFromLegacyMarkup(res.crop||imageSize,markup[0],markup[1]));}if(data.color){Object.keys(data.color).filter(key=>data.color[key]).map(key=>[key,Array.isArray(data.color[key].matrix)?data.color[key].matrix:Object.values(data.color[key].matrix)]).forEach(([key,value])=>{if(!res.colorMatrix)res.colorMatrix={};res.colorMatrix[key]=value;});}if(data.filter){if(!res.colorMatrix)res.colorMatrix={};res.colorMatrix.filter=typeof data.filter==='string'&&editor['filterFunctions'][data.filter]?editor['filterFunctions'][data.filter]():data.filter.matrix;}return res;};const isOperaMini=()=>Object.prototype.toString.call(window['operamini'])==='[object OperaMini]';const hasPromises=()=>'Promise'in window;const hasCreateObjectURL=()=>'URL'in window&&'createObjectURL'in window.URL;const hasVisibility=()=>'visibilityState'in document;const hasTiming=()=>'performance'in window;// iOS 8.x
const hasFileConstructor=()=>'File'in window;// excludes IE11
let result$3=null;var isModernBrowser=()=>{if(result$3===null)result$3=isBrowser()&&// Can't run on Opera Mini due to lack of everything
!isOperaMini()&&// Require these APIs to feature detect a modern browser
hasVisibility()&&hasPromises()&&hasFileConstructor()&&hasCreateObjectURL()&&hasTiming();return result$3;};var toPercentageNumber=v=>Math.round(v*100);const brightness={base:0,min:-0.25,max:0.25,getLabel:value=>toPercentageNumber(value/0.25),getStore:({imageColorMatrix})=>imageColorMatrix,getValue:store=>{if(!store.brightness)return;return store.brightness[4];},setValue:(store,v)=>store.update(matrices=>({// clone existing matrices
...matrices,// prettier-ignore
brightness:[1,0,0,0,v,0,1,0,0,v,0,0,1,0,v,0,0,0,1,0]}))};const contrast={base:1,min:0.5,max:1.5,getLabel:value=>toPercentageNumber(-1+(value-0.5)*2),getStore:({imageColorMatrix})=>imageColorMatrix,getValue:store=>{if(!store.contrast)return;return store.contrast[0];},setValue:(store,v)=>store.update(matrices=>({// clone existing matrices
...matrices,// prettier-ignore
contrast:[v,0,0,0,.5*(1-v),0,v,0,0,.5*(1-v),0,0,v,0,.5*(1-v),0,0,0,1,0]}))};const saturation={base:1,min:0,max:2,getLabel:value=>toPercentageNumber(value-1),getStore:({imageColorMatrix})=>imageColorMatrix,getValue:store=>{if(!store.saturation)return;return(store.saturation[0]-0.213)/0.787;},setValue:(store,v)=>store.update(matrices=>({...matrices,// prettier-ignore
saturation:[.213+.787*v,.715-.715*v,.072-.072*v,0,0,.213-.213*v,.715+.285*v,.072-.072*v,0,0,.213-.213*v,.715-.715*v,.072+.928*v,0,0,0,0,0,1,0]}))};const exposure={base:1,min:0.5,max:1.5,getLabel:value=>toPercentageNumber(-1+(value-0.5)*2),getStore:({imageColorMatrix})=>imageColorMatrix,getValue:store=>{if(!store.exposure)return;return store.exposure[0];},setValue:(store,v)=>store.update(matrices=>({...matrices,// prettier-ignore
exposure:[v,0,0,0,0,0,v,0,0,0,0,0,v,0,0,0,0,0,1,0]}))};const gamma={base:1,min:0.15,max:4,getLabel:value=>{if(value<1){return toPercentageNumber((value-0.15)/0.85-1);}return toPercentageNumber((value-1)/3);},getStore:({imageGamma})=>imageGamma};const vignette={base:0,min:-1,max:1,getStore:({imageVignette})=>imageVignette};const clarity={base:0,min:-1,max:1,getStore:({imageConvolutionMatrix})=>imageConvolutionMatrix,getValue:store=>{if(!store.clarity)return;if(store.clarity[0]===0){return store.clarity[1]/-1;}else{return store.clarity[1]/-2;}},setValue:(store,v)=>{store.update(matrices=>({...matrices,// prettier-ignore
clarity:v>=0?[0,-1*v,0,-1*v,1+4*v,-1*v,0,-1*v,0]:[-1*v,-2*v,-1*v,-2*v,1+-3*v,-2*v,-1*v,-2*v,-1*v]}));}};const temperature={base:0,min:-1,max:1,getStore:({imageColorMatrix})=>imageColorMatrix,getValue:store=>{if(!store.temperature)return;const v=store.temperature[0];if(v>=1){return(v-1)/0.1;}return(1-v)/-0.15;},setValue:(store,v)=>store.update(matrices=>({...matrices,// prettier-ignore
temperature:v>0?[1+v*.1,0,0,0,0,0,1,0,0,0,0,0,1+-v*.1,0,0,0,0,0,1,0]:[1+v*.15,0,0,0,0,0,1+v*.05,0,0,0,0,0,1+-v*.15,0,0,0,0,0,1,0]}))};const finetuneControlConfigurationDefault={gamma,brightness,contrast,saturation,exposure,temperature,clarity,vignette};const finetuneOptionsDefault=[['brightness',locale=>locale.finetuneLabelBrightness],['contrast',locale=>locale.finetuneLabelContrast],['saturation',locale=>locale.finetuneLabelSaturation],['exposure',locale=>locale.finetuneLabelExposure],['temperature',locale=>locale.finetuneLabelTemperature],['gamma',locale=>locale.finetuneLabelGamma],!isSoftwareRendering()&&['clarity',locale=>locale.finetuneLabelClarity],['vignette',locale=>locale.finetuneLabelVignette]].filter(Boolean);var _plugin_finetune_defaults={finetuneControlConfiguration:finetuneControlConfigurationDefault,finetuneOptions:finetuneOptionsDefault};/*
TODO: fix inverse fn in getValue
export const hue = {
    base: 0,
    min: 0,
    max: Math.PI,
    getStore: ({ imageColorMatrix }) => imageColorMatrix,
    getValue: (store) => {
        if (!store.hue) return;

        const v = store.hue[1];

        const o = -(Math.acos((0.715 - v) / Math.sqrt(2) / 0.715) - Math.PI / 4);

        return o;
    },
    setValue: (store, v: number) => {
        store.update((matrices) => {
            // const value = v * (Math.PI);

            const cos = Math.cos(v);
            const sin = Math.sin(v);

            const a00 = 0.213 + cos * 0.787 - sin * 0.213;
            const a01 = 0.715 - cos * 0.715 - sin * 0.715;
            const a02 = 0.072 - cos * 0.072 + sin * 0.928;
            const a10 = 0.213 - cos * 0.213 + sin * 0.143;
            const a11 = 0.715 + cos * 0.285 + sin * 0.14;
            const a12 = 0.072 - cos * 0.072 - sin * 0.283;
            const a20 = 0.213 - cos * 0.213 - sin * 0.787;
            const a21 = 0.715 - cos * 0.715 + sin * 0.715;
            const a22 = 0.072 + cos * 0.928 + sin * 0.072;

            return {
                ...matrices,

                // prettier-ignore
                hue: [
                    a00, a01, a02, 0, 0,
                    a10, a11, a12, 0, 0,
                    a20, a21, a22, 0, 0,
                      0,   0,   0, 1, 0,
                ]
            };
        });
    },
};
*/const pastel=()=>// prettier-ignore
[0.75,0.25,0.25,0,0,0.25,0.75,0.25,0,0,0.25,0.25,0.75,0,0,0,0,0,1,0];const chrome=()=>// prettier-ignore
[1.398,-0.316,0.065,-0.273,0.201,-0.051,1.278,-0.080,-0.273,0.201,-0.051,0.119,1.151,-0.290,0.215,0,0,0,1,0];const fade=()=>// prettier-ignore
[1.073,-0.015,0.092,-0.115,-0.017,0.107,0.859,0.184,-0.115,-0.017,0.015,0.077,1.104,-0.115,-0.017,0,0,0,1,0];const warm=()=>// prettier-ignore
[1.06,0,0,0,0,0,1.01,0,0,0,0,0,0.93,0,0,0,0,0,1,0];const cold=()=>// prettier-ignore
[1.1,0,0,0,-.1,0,1.1,0,0,-.1,0,0,1.2,0,-.1,0,0,0,1,0];const invert=()=>// prettier-ignore
[-1,0,0,1,0,0,-1,0,1,0,0,0,-1,1,0,0,0,0,1,0];const monoDefault=()=>// prettier-ignore
[0.212,0.715,0.114,0,0,0.212,0.715,0.114,0,0,0.212,0.715,0.114,0,0,0,0,0,1,0];const monoNoir=()=>// prettier-ignore
[0.15,1.3,-0.25,0.1,-0.2,0.15,1.3,-0.25,0.1,-0.2,0.15,1.3,-0.25,0.1,-0.2,0,0,0,1,0];const monoWash=()=>// prettier-ignore
[0.163,0.518,0.084,-0.010,0.208,0.163,0.529,0.082,-0.020,0.210,0.171,0.529,0.084,0.000,0.214,0.000,0.000,0.000,1.000,0.000];const monoStark=()=>// prettier-ignore
[0.338,0.991,0.117,0.093,-0.196,0.302,1.049,0.096,0.078,-0.196,0.286,1.016,0.146,0.101,-0.196,0.000,0.000,0.000,1.000,0.000];const sepiaDefault=()=>// prettier-ignore
[0.393,0.768,0.188,0,0,0.349,0.685,0.167,0,0,0.272,0.533,0.130,0,0,0,0,0,1,0];const sepiaBlues=()=>// prettier-ignore
[0.289,0.620,0.185,0.000,0.077,0.257,0.566,0.163,0.000,0.115,0.200,0.430,0.128,0.000,0.188,0.000,0.000,0.000,1.000,0.000];const sepiaRust=()=>// prettier-ignore
[0.269,0.764,0.172,0.050,0.100,0.239,0.527,0.152,0.000,0.176,0.186,0.400,0.119,0.000,0.159,0.000,0.000,0.000,1.000,0.000];const sepiaColor=()=>// prettier-ignore
[0.547,0.764,0.134,0.000,-0.147,0.281,0.925,0.120,0.000,-0.135,0.225,0.558,0.330,0.000,-0.113,0.000,0.000,0.000,1.000,0.000];//
// default filter set
//
const filterFunctionsDefault={chrome,fade,pastel,cold,warm,monoDefault,monoWash,monoNoir,monoStark,sepiaDefault,sepiaRust,sepiaBlues,sepiaColor};const filterOptionsDefault=[['Default',[[undefined,locale=>locale.labelDefault]]],['Classic',[['chrome',locale=>locale.filterLabelChrome],['fade',locale=>locale.filterLabelFade],['cold',locale=>locale.filterLabelCold],['warm',locale=>locale.filterLabelWarm],['pastel',locale=>locale.filterLabelPastel]]],['Monochrome',[['monoDefault',locale=>locale.filterLabelMonoDefault],['monoNoir',locale=>locale.filterLabelMonoNoir],['monoStark',locale=>locale.filterLabelMonoStark],['monoWash',locale=>locale.filterLabelMonoWash]]],['Sepia',[['sepiaDefault',locale=>locale.filterLabelSepiaDefault],['sepiaRust',locale=>locale.filterLabelSepiaRust],['sepiaBlues',locale=>locale.filterLabelSepiaBlues],['sepiaColor',locale=>locale.filterLabelSepiaColor]]]];var _plugin_filter_defaults={filterFunctions:filterFunctionsDefault,filterOptions:filterOptionsDefault};const solidSharp={shape:{frameStyle:'solid',frameSize:'2.5%'},thumb:'<rect stroke-width="5" x="0" y="0" width="100%" height="100%"/>'};const solidRound={shape:{frameStyle:'solid',frameSize:'2.5%',frameRound:true},thumb:'<rect stroke-width="5" x="0" y="0" width="100%" height="100%" rx="12%"/>'};const lineSingle={shape:{frameStyle:'line',frameInset:'2.5%',frameSize:'.3125%',frameRadius:0},thumb:'<div style="top:.5em;left:.5em;right:.5em;bottom:.5em;box-shadow:inset 0 0 0 1px currentColor"></div>'};const lineMultiple={shape:{frameStyle:'line',frameAmount:2,frameInset:'2.5%',frameSize:'.3125%',frameOffset:'1.25%',frameRadius:0},thumb:'<div style="top:.75em;left:.75em;right:.75em;bottom:.75em; outline: 3px double"></div>'};const edgeSeparate={shape:{frameStyle:'edge',frameInset:'2.5%',frameOffset:'5%',frameSize:'.3125%'},thumb:'<div style="top:.75em;left:.5em;bottom:.75em;border-left:1px solid"></div><div style="top:.75em;right:.5em;bottom:.75em;border-right:1px solid"></div><div style="top:.5em;left:.75em;right:.75em;border-top:1px solid"></div><div style="bottom:.5em;left:.75em;right:.75em;border-bottom:1px solid"></div>'};const edgeCross={shape:{frameStyle:'edge',frameInset:'2.5%',frameSize:'.3125%'},thumb:'<div style="top:-.5em;left:.5em;right:.5em;bottom:-.5em; box-shadow: inset 0 0 0 1px currentColor"></div><div style="top:.5em;left:-.5em;right:-.5em;bottom:.5em;box-shadow:inset 0 0 0 1px currentColor"></div>'};const edgeOverlap={shape:{frameStyle:'edge',frameOffset:'1.5%',frameSize:'.3125%'},thumb:'<div style="top:.3125em;left:.5em;bottom:.3125em;border-left:1px solid"></div><div style="top:.3125em;right:.5em;bottom:.3125em;border-right:1px solid"></div><div style="top:.5em;left:.3125em;right:.3125em;border-top:1px solid"></div><div style="bottom:.5em;left:.3125em;right:.3125em;border-bottom:1px solid"></div>'};const hook={shape:{frameStyle:'hook',frameInset:'2.5%',frameSize:'.3125%',frameLength:'5%'},thumb:'<div style="top:.5em;left:.5em;width:.75em;height:.75em; border-left: 1px solid;border-top: 1px solid;"></div><div style="top:.5em;right:.5em;width:.75em;height:.75em; border-right: 1px solid;border-top: 1px solid;"></div><div style="bottom:.5em;left:.5em;width:.75em;height:.75em; border-left: 1px solid;border-bottom: 1px solid;"></div><div style="bottom:.5em;right:.5em;width:.75em;height:.75em; border-right: 1px solid;border-bottom: 1px solid;"></div>'};const polaroid={shape:{frameStyle:'polaroid'},thumb:'<rect stroke-width="20%" x="-5%" y="-5%" width="110%" height="96%"/>'};const frameStylesDefault={solidSharp,solidRound,lineSingle,lineMultiple,edgeSeparate,edgeCross,edgeOverlap,hook,polaroid};const frameOptionsDefault=[[undefined,locale=>locale.labelNone],['solidSharp',locale=>locale.frameLabelMatSharp],['solidRound',locale=>locale.frameLabelMatRound],['lineSingle',locale=>locale.frameLabelLineSingle],['lineMultiple',locale=>locale.frameLabelLineMultiple],['edgeCross',locale=>locale.frameLabelEdgeCross],['edgeSeparate',locale=>locale.frameLabelEdgeSeparate],['edgeOverlap',locale=>locale.frameLabelEdgeOverlap],['hook',locale=>locale.frameLabelCornerHooks],['polaroid',locale=>locale.frameLabelPolaroid]];var _plugin_frame_defaults={frameStyles:frameStylesDefault,frameOptions:frameOptionsDefault};var RGBToHSV=(r,g,b)=>{let v=Math.max(r,g,b),n=v-Math.min(r,g,b);let h=n&&(v==r?(g-b)/n:v==g?2+(b-r)/n:4+(r-g)/n);return[60*(h<0?h+6:h)/360,v&&n/v,v];};var HSVToRGB=(h,s,v)=>{let r,g,b;const i=Math.floor(h*6);const f=h*6-i;const p=v*(1-s);const q=v*(1-f*s);const t=v*(1-(1-f)*s);switch(i%6){case 0:r=v,g=t,b=p;break;case 1:r=q,g=v,b=p;break;case 2:r=p,g=v,b=t;break;case 3:r=p,g=q,b=v;break;case 4:r=t,g=p,b=v;break;case 5:r=v,g=p,b=q;break;}return[r,g,b];};/* src/core/ui/components/ColorPreview.svelte generated by Svelte v3.37.0 */function create_fragment$t(ctx){let div;let span;let div_style_value;return{c(){div=pintura_element("div");span=pintura_element("span");attr(div,"class","PinturaColorPreview");attr(div,"title",/*title*/ctx[0]);attr(div,"style",div_style_value=`--color:${/*colorValue*/ctx[1]}`);},m(target,anchor){insert(target,div,anchor);append(div,span);},p(ctx,[dirty]){if(dirty&/*title*/1){attr(div,"title",/*title*/ctx[0]);}if(dirty&/*colorValue*/2&&div_style_value!==(div_style_value=`--color:${/*colorValue*/ctx[1]}`)){attr(div,"style",div_style_value);}},i:pintura_noop,o:pintura_noop,d(detaching){if(detaching)detach(div);}};}function instance$t($$self,$$props,$$invalidate){let colorValue;let{color=undefined}=$$props;let{title=undefined}=$$props;$$self.$$set=$$props=>{if("color"in $$props)$$invalidate(2,color=$$props.color);if("title"in $$props)$$invalidate(0,title=$$props.title);};$$self.$$.update=()=>{if($$self.$$.dirty&/*color*/4){$$invalidate(1,colorValue=color?colorArrayToRGBA(color):"transparent");}};return[title,colorValue,color];}class ColorPreview extends SvelteComponent{constructor(options){super();init(this,options,instance$t,create_fragment$t,safe_not_equal,{color:2,title:0});}}/* src/core/ui/components/ColorPicker.svelte generated by Svelte v3.37.0 */function create_if_block_4$3(ctx){let span;let t;return{c(){span=pintura_element("span");t=pintura_text(/*label*/ctx[0]);},m(target,anchor){insert(target,span,anchor);append(span,t);},p(ctx,dirty){if(dirty[0]&/*label*/1)set_data(t,/*label*/ctx[0]);},d(detaching){if(detaching)detach(span);}};}// (160:4) 
function create_label_slot(ctx){let span;let colorpreview;let t;let current;colorpreview=new ColorPreview({props:{color:/*value*/ctx[4],title:localize(/*title*/ctx[8],/*locale*/ctx[10])}});let if_block=!/*hidePresetLabel*/ctx[9]&&create_if_block_4$3(ctx);return{c(){span=pintura_element("span");create_component(colorpreview.$$.fragment);t=space();if(if_block)if_block.c();attr(span,"slot","label");attr(span,"class","PinturaButtonLabel");},m(target,anchor){insert(target,span,anchor);mount_component(colorpreview,span,null);append(span,t);if(if_block)if_block.m(span,null);current=true;},p(ctx,dirty){const colorpreview_changes={};if(dirty[0]&/*value*/16)colorpreview_changes.color=/*value*/ctx[4];if(dirty[0]&/*title, locale*/1280)colorpreview_changes.title=localize(/*title*/ctx[8],/*locale*/ctx[10]);colorpreview.$set(colorpreview_changes);if(!/*hidePresetLabel*/ctx[9]){if(if_block){if_block.p(ctx,dirty);}else{if_block=create_if_block_4$3(ctx);if_block.c();if_block.m(span,null);}}else if(if_block){if_block.d(1);if_block=null;}},i(local){if(current)return;transition_in(colorpreview.$$.fragment,local);current=true;},o(local){transition_out(colorpreview.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(span);destroy_component(colorpreview);if(if_block)if_block.d();}};}// (171:8) {#if enablePicker}
function create_if_block_2$5(ctx){let div3;let div2;let div1;let div0;let div0_style_value;let div1_style_value;let div2_style_value;let t0;let slider;let t1;let current;let mounted;let dispose;slider=new Slider({props:{class:"PinturaHuePicker",knobStyle:`background-color:${/*valueAsRGBAFullySaturated*/ctx[19]}`,onchange:/*updateHue*/ctx[24],value:/*hue*/ctx[14],min:0,max:1,step:0.01}});let if_block=/*enableOpacity*/ctx[11]&&create_if_block_3$3(ctx);return{c(){div3=pintura_element("div");div2=pintura_element("div");div1=pintura_element("div");div0=pintura_element("div");t0=space();create_component(slider.$$.fragment);t1=space();if(if_block)if_block.c();attr(div0,"role","button");attr(div0,"aria-label","Saturation slider");attr(div0,"class","PinturaPickerKnob");attr(div0,"tabindex","0");attr(div0,"style",div0_style_value=`background-color:${/*valueAsRGBAFullyOpaque*/ctx[18]};`);attr(div1,"class","PinturaPickerKnobController");attr(div1,"style",div1_style_value=`transform:translate(${/*sx*/ctx[21]}%,${/*sy*/ctx[22]}%)`);attr(div2,"class","PinturaSaturationPicker");attr(div2,"style",div2_style_value=`background-color: ${/*valueAsRGBAFullySaturated*/ctx[19]}`);attr(div3,"class","PinturaPicker");},m(target,anchor){insert(target,div3,anchor);append(div3,div2);append(div2,div1);append(div1,div0);/*div2_binding*/ctx[31](div2);append(div3,t0);mount_component(slider,div3,null);append(div3,t1);if(if_block)if_block.m(div3,null);current=true;if(!mounted){dispose=[listen(div0,"nudge",/*handleNudge*/ctx[27]),action_destroyer(nudgeable.call(null,div0)),listen(div2,"pointerdown",/*handlePointerDown*/ctx[26])];mounted=true;}},p(ctx,dirty){if(!current||dirty[0]&/*valueAsRGBAFullyOpaque*/262144&&div0_style_value!==(div0_style_value=`background-color:${/*valueAsRGBAFullyOpaque*/ctx[18]};`)){attr(div0,"style",div0_style_value);}if(!current||dirty[0]&/*sx, sy*/6291456&&div1_style_value!==(div1_style_value=`transform:translate(${/*sx*/ctx[21]}%,${/*sy*/ctx[22]}%)`)){attr(div1,"style",div1_style_value);}if(!current||dirty[0]&/*valueAsRGBAFullySaturated*/524288&&div2_style_value!==(div2_style_value=`background-color: ${/*valueAsRGBAFullySaturated*/ctx[19]}`)){attr(div2,"style",div2_style_value);}const slider_changes={};if(dirty[0]&/*valueAsRGBAFullySaturated*/524288)slider_changes.knobStyle=`background-color:${/*valueAsRGBAFullySaturated*/ctx[19]}`;if(dirty[0]&/*hue*/16384)slider_changes.value=/*hue*/ctx[14];slider.$set(slider_changes);if(/*enableOpacity*/ctx[11]){if(if_block){if_block.p(ctx,dirty);if(dirty[0]&/*enableOpacity*/2048){transition_in(if_block,1);}}else{if_block=create_if_block_3$3(ctx);if_block.c();transition_in(if_block,1);if_block.m(div3,null);}}else if(if_block){group_outros();transition_out(if_block,1,1,()=>{if_block=null;});check_outros();}},i(local){if(current)return;transition_in(slider.$$.fragment,local);transition_in(if_block);current=true;},o(local){transition_out(slider.$$.fragment,local);transition_out(if_block);current=false;},d(detaching){if(detaching)detach(div3);/*div2_binding*/ctx[31](null);destroy_component(slider);if(if_block)if_block.d();mounted=false;run_all(dispose);}};}// (205:16) {#if enableOpacity}
function create_if_block_3$3(ctx){let slider;let current;slider=new Slider({props:{class:"PinturaOpacityPicker",knobStyle:`background-color: ${/*valueAsRGBA*/ctx[16]}`,trackStyle:`background-image: linear-gradient(to right, ${/*valueAsRGBAFullyTransparent*/ctx[17]}, ${/*valueAsRGBAFullyOpaque*/ctx[18]})`,onchange:/*updateOpacity*/ctx[25],value:/*opacity*/ctx[15],min:0,max:1,step:0.01}});return{c(){create_component(slider.$$.fragment);},m(target,anchor){mount_component(slider,target,anchor);current=true;},p(ctx,dirty){const slider_changes={};if(dirty[0]&/*valueAsRGBA*/65536)slider_changes.knobStyle=`background-color: ${/*valueAsRGBA*/ctx[16]}`;if(dirty[0]&/*valueAsRGBAFullyTransparent, valueAsRGBAFullyOpaque*/393216)slider_changes.trackStyle=`background-image: linear-gradient(to right, ${/*valueAsRGBAFullyTransparent*/ctx[17]}, ${/*valueAsRGBAFullyOpaque*/ctx[18]})`;if(dirty[0]&/*opacity*/32768)slider_changes.value=/*opacity*/ctx[15];slider.$set(slider_changes);},i(local){if(current)return;transition_in(slider.$$.fragment,local);current=true;},o(local){transition_out(slider.$$.fragment,local);current=false;},d(detaching){destroy_component(slider,detaching);}};}// (221:8) {#if enablePresets}
function create_if_block$6(ctx){let radiogroup;let current;radiogroup=new RadioGroup({props:{label:"Presets",class:arrayJoin(["PinturaColorPresets",/*hidePresetLabel*/ctx[9]?"PinturaColorPresetsGrid":"PinturaColorPresetsList"]),hideLabel:false,name:/*name*/ctx[1],value:/*value*/ctx[4],optionGroupClass:"PinturaDropdownOptionGroup",optionClass:"PinturaDropdownOption",options:/*options*/ctx[2].map(/*func*/ctx[32]),selectedIndex:/*selectedIndex*/ctx[3],optionMapper:/*optionMapper*/ctx[7],optionLabelClass:/*optionLabelClass*/ctx[6],onchange:/*func_1*/ctx[33],$$slots:{option:[create_option_slot$3,({option})=>({44:option}),({option})=>[0,option?8192:0]],group:[create_group_slot,({option})=>({44:option}),({option})=>[0,option?8192:0]]},$$scope:{ctx}}});return{c(){create_component(radiogroup.$$.fragment);},m(target,anchor){mount_component(radiogroup,target,anchor);current=true;},p(ctx,dirty){const radiogroup_changes={};if(dirty[0]&/*hidePresetLabel*/512)radiogroup_changes.class=arrayJoin(["PinturaColorPresets",/*hidePresetLabel*/ctx[9]?"PinturaColorPresetsGrid":"PinturaColorPresetsList"]);if(dirty[0]&/*name*/2)radiogroup_changes.name=/*name*/ctx[1];if(dirty[0]&/*value*/16)radiogroup_changes.value=/*value*/ctx[4];if(dirty[0]&/*options, locale*/1028)radiogroup_changes.options=/*options*/ctx[2].map(/*func*/ctx[32]);if(dirty[0]&/*selectedIndex*/8)radiogroup_changes.selectedIndex=/*selectedIndex*/ctx[3];if(dirty[0]&/*optionMapper*/128)radiogroup_changes.optionMapper=/*optionMapper*/ctx[7];if(dirty[0]&/*optionLabelClass*/64)radiogroup_changes.optionLabelClass=/*optionLabelClass*/ctx[6];if(dirty[0]&/*hidePresetLabel*/512|dirty[1]&/*$$scope, option*/24576){radiogroup_changes.$$scope={dirty,ctx};}radiogroup.$set(radiogroup_changes);},i(local){if(current)return;transition_in(radiogroup.$$.fragment,local);current=true;},o(local){transition_out(radiogroup.$$.fragment,local);current=false;},d(detaching){destroy_component(radiogroup,detaching);}};}// (243:16) 
function create_group_slot(ctx){let span;let t_value=/*option*/ctx[44].label+"";let t;return{c(){span=pintura_element("span");t=pintura_text(t_value);attr(span,"slot","group");},m(target,anchor){insert(target,span,anchor);append(span,t);},p(ctx,dirty){if(dirty[1]&/*option*/8192&&t_value!==(t_value=/*option*/ctx[44].label+""))set_data(t,t_value);},d(detaching){if(detaching)detach(span);}};}// (248:20) {#if !hidePresetLabel}
function create_if_block_1$6(ctx){let span;let t_value=/*option*/ctx[44].label+"";let t;return{c(){span=pintura_element("span");t=pintura_text(t_value);attr(span,"class","PinturaButtonLabel");},m(target,anchor){insert(target,span,anchor);append(span,t);},p(ctx,dirty){if(dirty[1]&/*option*/8192&&t_value!==(t_value=/*option*/ctx[44].label+""))set_data(t,t_value);},d(detaching){if(detaching)detach(span);}};}// (246:16) 
function create_option_slot$3(ctx){let span;let colorpreview;let t;let current;colorpreview=new ColorPreview({props:{title:/*option*/ctx[44].label,color:/*option*/ctx[44].value}});let if_block=!/*hidePresetLabel*/ctx[9]&&create_if_block_1$6(ctx);return{c(){span=pintura_element("span");create_component(colorpreview.$$.fragment);t=space();if(if_block)if_block.c();attr(span,"slot","option");},m(target,anchor){insert(target,span,anchor);mount_component(colorpreview,span,null);append(span,t);if(if_block)if_block.m(span,null);current=true;},p(ctx,dirty){const colorpreview_changes={};if(dirty[1]&/*option*/8192)colorpreview_changes.title=/*option*/ctx[44].label;if(dirty[1]&/*option*/8192)colorpreview_changes.color=/*option*/ctx[44].value;colorpreview.$set(colorpreview_changes);if(!/*hidePresetLabel*/ctx[9]){if(if_block){if_block.p(ctx,dirty);}else{if_block=create_if_block_1$6(ctx);if_block.c();if_block.m(span,null);}}else if(if_block){if_block.d(1);if_block=null;}},i(local){if(current)return;transition_in(colorpreview.$$.fragment,local);current=true;},o(local){transition_out(colorpreview.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(span);destroy_component(colorpreview);if(if_block)if_block.d();}};}// (169:4) 
function create_details_slot(ctx){let div;let t;let current;let if_block0=/*enablePicker*/ctx[13]&&create_if_block_2$5(ctx);let if_block1=/*enablePresets*/ctx[12]&&create_if_block$6(ctx);return{c(){div=pintura_element("div");if(if_block0)if_block0.c();t=space();if(if_block1)if_block1.c();attr(div,"slot","details");attr(div,"class","PinturaColorPickerPanel");},m(target,anchor){insert(target,div,anchor);if(if_block0)if_block0.m(div,null);append(div,t);if(if_block1)if_block1.m(div,null);current=true;},p(ctx,dirty){if(/*enablePicker*/ctx[13]){if(if_block0){if_block0.p(ctx,dirty);if(dirty[0]&/*enablePicker*/8192){transition_in(if_block0,1);}}else{if_block0=create_if_block_2$5(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(div,t);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}if(/*enablePresets*/ctx[12]){if(if_block1){if_block1.p(ctx,dirty);if(dirty[0]&/*enablePresets*/4096){transition_in(if_block1,1);}}else{if_block1=create_if_block$6(ctx);if_block1.c();transition_in(if_block1,1);if_block1.m(div,null);}}else if(if_block1){group_outros();transition_out(if_block1,1,1,()=>{if_block1=null;});check_outros();}},i(local){if(current)return;transition_in(if_block0);transition_in(if_block1);current=true;},o(local){transition_out(if_block0);transition_out(if_block1);current=false;},d(detaching){if(detaching)detach(div);if(if_block0)if_block0.d();if(if_block1)if_block1.d();}};}function create_fragment$s(ctx){let details;let current;details=new Details({props:{buttonClass:arrayJoin(["PinturaColorPickerButton",/*buttonClass*/ctx[5]]),$$slots:{details:[create_details_slot],label:[create_label_slot]},$$scope:{ctx}}});return{c(){create_component(details.$$.fragment);},m(target,anchor){mount_component(details,target,anchor);current=true;},p(ctx,dirty){const details_changes={};if(dirty[0]&/*buttonClass*/32)details_changes.buttonClass=arrayJoin(["PinturaColorPickerButton",/*buttonClass*/ctx[5]]);if(dirty[0]&/*hidePresetLabel, name, value, options, locale, selectedIndex, optionMapper, optionLabelClass, enablePresets, valueAsRGBA, valueAsRGBAFullyTransparent, valueAsRGBAFullyOpaque, opacity, enableOpacity, valueAsRGBAFullySaturated, hue, input, sx, sy, enablePicker, label, title*/8388575|dirty[1]&/*$$scope*/16384){details_changes.$$scope={dirty,ctx};}details.$set(details_changes);},i(local){if(current)return;transition_in(details.$$.fragment,local);current=true;},o(local){transition_out(details.$$.fragment,local);current=false;},d(detaching){destroy_component(details,detaching);}};}function instance$s($$self,$$props,$$invalidate){let sx;let sy;let{label=undefined}=$$props;let{name=undefined}=$$props;let{options=[]}=$$props;let{selectedIndex=-1}=$$props;let{value=undefined}=$$props;let{buttonClass=undefined}=$$props;let{optionLabelClass=undefined}=$$props;let{optionMapper=undefined}=$$props;let{onchange=undefined}=$$props;let{title=undefined}=$$props;let{hidePresetLabel=true}=$$props;let{locale=undefined}=$$props;let{enableOpacity=true}=$$props;let{enablePresets=true}=$$props;let{enablePicker=true}=$$props;// inputs
let hue;let saturation;let brightness;let opacity;// shortcuts
let valueAsRGB;let valueAsRGBA;let valueAsRGBAFullyTransparent;let valueAsRGBAFullyOpaque;let valueAsRGBAFullySaturated;const updateProps=(color,syncControls)=>{valueAsRGB=[color[0],color[1],color[2]];if(syncControls){let valueAsHSV=RGBToHSV(...valueAsRGB);$$invalidate(14,hue=valueAsHSV[0]);$$invalidate(29,saturation=valueAsHSV[1]);$$invalidate(30,brightness=valueAsHSV[2]);$$invalidate(15,opacity=pintura_isNumber(color[3])?color[3]:1);}$$invalidate(16,valueAsRGBA=colorArrayToRGBA(color));$$invalidate(17,valueAsRGBAFullyTransparent=colorArrayToRGBA([...valueAsRGB,0]));$$invalidate(18,valueAsRGBAFullyOpaque=colorArrayToRGBA([...valueAsRGB,1]));$$invalidate(19,valueAsRGBAFullySaturated=colorArrayToRGBA(HSVToRGB(hue,1,1)));};value&&updateProps(value,true);const update=()=>{const rgb=HSVToRGB(hue,saturation,brightness);const rgba=[...rgb,opacity];updateProps(rgba);onchange(rgba);};const updateColorArray=arr=>{const rgba=arr.length===3?[...arr,1]:arr;updateProps(rgba,true);onchange(rgba);};const updateHue=h=>{$$invalidate(14,hue=h);if(opacity===0)$$invalidate(15,opacity=1);update();};const updateSaturationAndBrightness=(s,b)=>{$$invalidate(29,saturation=s);$$invalidate(30,brightness=b);if(opacity===0)$$invalidate(15,opacity=1);update();};const updateOpacity=o=>{$$invalidate(15,opacity=o);update();};const setValueByOffset=(offset,inputSize)=>{const x=pintura_clamp(offset.x/inputSize.width,0,1);const y=pintura_clamp(offset.y/inputSize.height,0,1);updateSaturationAndBrightness(x,1-y);};let input;let inputSize;let inputOffset;let inputPageOffset;const handlePointerDown=e=>{e.stopPropagation();inputSize=sizeCreate(input.offsetWidth,input.offsetHeight);inputOffset=vectorCreateFromPointerEventOffset(e);inputPageOffset=vectorCreateFromPointerEvent(e);setValueByOffset(inputOffset,inputSize);document.documentElement.addEventListener("pointermove",handlePointerMove);document.documentElement.addEventListener("pointerup",handlePointerUp);};const handlePointerMove=e=>{const d=vectorSubtract(vectorCreateFromPointerEvent(e),inputPageOffset);setValueByOffset(vectorAdd(vectorClone(inputOffset),d),inputSize);};const handlePointerUp=e=>{inputSize=undefined;document.documentElement.removeEventListener("pointermove",handlePointerMove);document.documentElement.removeEventListener("pointerup",handlePointerUp);};const handleNudge=e=>{inputSize=sizeCreate(input.offsetWidth,input.offsetHeight);const x=sx/100*inputSize.width;const y=sy/100*inputSize.height;setValueByOffset({x:x+e.detail.x,y:y+e.detail.y},inputSize);};function div2_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{input=$$value;$$invalidate(20,input);});}const func=([color,label])=>[color,pintura_isFunction(label)?label(locale):label];const func_1=detail=>updateColorArray(detail.value);$$self.$$set=$$props=>{if("label"in $$props)$$invalidate(0,label=$$props.label);if("name"in $$props)$$invalidate(1,name=$$props.name);if("options"in $$props)$$invalidate(2,options=$$props.options);if("selectedIndex"in $$props)$$invalidate(3,selectedIndex=$$props.selectedIndex);if("value"in $$props)$$invalidate(4,value=$$props.value);if("buttonClass"in $$props)$$invalidate(5,buttonClass=$$props.buttonClass);if("optionLabelClass"in $$props)$$invalidate(6,optionLabelClass=$$props.optionLabelClass);if("optionMapper"in $$props)$$invalidate(7,optionMapper=$$props.optionMapper);if("onchange"in $$props)$$invalidate(28,onchange=$$props.onchange);if("title"in $$props)$$invalidate(8,title=$$props.title);if("hidePresetLabel"in $$props)$$invalidate(9,hidePresetLabel=$$props.hidePresetLabel);if("locale"in $$props)$$invalidate(10,locale=$$props.locale);if("enableOpacity"in $$props)$$invalidate(11,enableOpacity=$$props.enableOpacity);if("enablePresets"in $$props)$$invalidate(12,enablePresets=$$props.enablePresets);if("enablePicker"in $$props)$$invalidate(13,enablePicker=$$props.enablePicker);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*saturation*/536870912){$$invalidate(21,sx=saturation*100);}if($$self.$$.dirty[0]&/*brightness*/1073741824){$$invalidate(22,sy=100-brightness*100);}};return[label,name,options,selectedIndex,value,buttonClass,optionLabelClass,optionMapper,title,hidePresetLabel,locale,enableOpacity,enablePresets,enablePicker,hue,opacity,valueAsRGBA,valueAsRGBAFullyTransparent,valueAsRGBAFullyOpaque,valueAsRGBAFullySaturated,input,sx,sy,updateColorArray,updateHue,updateOpacity,handlePointerDown,handleNudge,onchange,saturation,brightness,div2_binding,func,func_1];}class ColorPicker extends SvelteComponent{constructor(options){super();init(this,options,instance$s,create_fragment$s,safe_not_equal,{label:0,name:1,options:2,selectedIndex:3,value:4,buttonClass:5,optionLabelClass:6,optionMapper:7,onchange:28,title:8,hidePresetLabel:9,locale:10,enableOpacity:11,enablePresets:12,enablePicker:13},[-1,-1]);}}var upperCaseFirstLetter=str=>str.charAt(0).toUpperCase()+str.slice(1);let result$2=null;var canCheckFontAvailability=()=>{if(result$2===null){if(!isBrowser())result$2=false;else{try{// if browser can detect font as non existend then it supports font checking (only chrome)
// @ts-ignore
result$2=document.fonts.check('16px TestNonExistingFont')===false;}catch(err){// if throws assume can't check
result$2=false;}}}return result$2;};// @ts-ignore
const toLocaleFn=(key,localePrefix)=>locale=>locale[localePrefix?`${localePrefix}${upperCaseFirstLetter(key)}`:key];const mapToSizeOption=v=>[v,`${v}`];const createLocaleMapper=(options,localePrefix)=>key=>[options[key],toLocaleFn(key,localePrefix)];const toolColorDefault=[1,0.2549,0.2118];const toolStrokeColorDefault=[1,1,1,0];//#region tools
const toolShapeDefaults={path:()=>({points:[],disableErase:false}),eraser:()=>({eraseRadius:0}),line:()=>({x1:0,y1:0,x2:0,y2:0,disableErase:false}),rectangle:()=>({x:0,y:0,width:0,height:0}),ellipse:()=>({x:0,y:0,rx:0,ry:0}),text:()=>({x:0,y:0,text:'Text'})};const createToolStyle=(type,shape={},options={position:'relative'})=>{if(!toolShapeDefaults[type])return;const shapeDef={...toolShapeDefaults[type](),...shape};return[shapeDef,options];};const createToolStyles=tools=>({sharpie:createToolStyle('path',{strokeWidth:'0.5%',strokeColor:[...toolColorDefault],disableMove:true}),eraser:createToolStyle('eraser'),line:createToolStyle('line',{strokeColor:[...toolColorDefault],strokeWidth:'0.5%'}),arrow:createToolStyle('line',{lineStart:'none',lineEnd:'arrow-solid',strokeColor:[...toolColorDefault],strokeWidth:'0.5%'}),rectangle:createToolStyle('rectangle',{strokeColor:[...toolStrokeColorDefault],backgroundColor:[...toolColorDefault]}),ellipse:createToolStyle('ellipse',{strokeColor:[...toolStrokeColorDefault],backgroundColor:[...toolColorDefault]}),text:createToolStyle('text',{color:[...toolColorDefault],fontSize:'2%'}),...tools});//#endregion
//#region toolbar
const createToolbarItem=(tool,label,props)=>[tool,label||toLocaleFn(tool,'shapeLabelTool'),{icon:toLocaleFn(tool,'shapeIconTool'),...props}];const createToolbar=(tools=['sharpie','eraser','line','arrow','rectangle','ellipse','text','preset'])=>tools.map(tool=>{// default tool definition, assume locale in
if(pintura_isString(tool))return createToolbarItem(tool);// tool def with propery
if(Array.isArray(tool)){// state update of tool with key in locale object
if(pintura_isObject(tool[1]))return createToolbarItem(tool[0],undefined,tool[1]);// should be string, string
return createToolbarItem(tool[0],tool[1],tool[2]);}}).filter(Boolean);//#endregion
//#region style option defaults
const createDefaultColorOptions=()=>({transparent:[1,1,1,0],white:[1,1,1],silver:[0.8667,0.8667,0.8667],gray:[0.6667,0.6667,0.6667],black:[0,0,0],navy:[0,0.1216,0.2471],blue:[0,0.4549,0.851],aqua:[0.498,0.8588,1],teal:[0.2235,0.8,0.8],olive:[0.2392,0.6,0.4392],green:[0.1804,0.8,0.251],yellow:[1,0.8627,0],orange:[1,0.5216,0.1059],red:[1,0.2549,0.2118],maroon:[0.5216,0.0784,0.2941],fuchsia:[0.9412,0.0706,0.7451],purple:[0.6941,0.051,0.7882]});const createDefaultFontSizeOptions=()=>[16,18,20,24,30,36,48,64,72,96,144];const createDefaultFontScaleOptions=()=>({extraSmall:'2%',small:'4%',mediumSmall:'8%',medium:'10%',mediumLarge:'15%',large:'20%',extraLarge:'25%'});const createDefaultStrokeWidthOptions=()=>[1,2,3,4,6,8,12,16,20,24,32,48,64];const createDefaultStrokeScaleOptions=()=>({extraSmall:'0.25%',small:'0.5%',mediumSmall:'1%',medium:'1.75%',mediumLarge:'2.5%',large:'3.5%',extraLarge:'5%'});const createDefaultLineEndStyleOptions=()=>['bar','arrow','arrowSolid','circle','circleSolid','square','squareSolid'];const createDefaultFontFamilyOptions=()=>[[`Helvetica, Arial, Verdana, 'Droid Sans', sans-serif`,'Sans Serif'],[`'Arial Black', 'Avenir-Black', 'Arial Bold'`,'Black'],[`'Arial Narrow', 'Futura-CondensedMedium'`,'Narrow'],[`'Trebuchet MS'`,'Humanist'],[`Georgia, 'Avenir-Black', 'Times New Roman', 'Droid Serif', serif`,'Serif'],[`Palatino`,'Old-Style'],[`'Times New Roman', 'TimesNewRomanPSMT'`,'Transitional'],[`Menlo, Monaco, 'Lucida Console', monospace`,'Monospaced'],[`'Courier New', monospace`,'Slab Serif']];const createDefaultTextAlignOptions=()=>['left','center','right'];const createDefaultFontStyleOptions=()=>[['normal','bold'],['italic','normal'],['italic','bold']];//#endregion
//#region style options
const createColorOptions=colors=>Object.keys(colors).map(createLocaleMapper(colors,'shapeTitleColor'));const createFontSizeOptions=sizes=>sizes.map(mapToSizeOption);const createFontScaleOptions=scales=>Object.keys(scales).map(createLocaleMapper(scales,'labelSize'));const createStrokeWidthOptions=sizes=>sizes.map(mapToSizeOption);const createStrokeScaleOptions=scales=>Object.keys(scales).map(createLocaleMapper(scales,'labelSize'));const createFontFamilyOptions=fonts=>[...fonts];const createFontStyleOptions=styles=>styles.map(style=>[style,locale=>locale[`shapeLabelFontStyle${style.filter(v=>v!=='normal').map(upperCaseFirstLetter).join('')}`]]);const createLineEndStyleOptions=styles=>styles.map(style=>[toKebabCase(style),locale=>locale[`shapeTitleLineDecoration${upperCaseFirstLetter(style)}`],{icon:locale=>locale[`shapeIconLineDecoration${upperCaseFirstLetter(style)}`]}]);const createTextAlignOptions=options=>options.map(align=>[align,locale=>locale[`shapeTitleTextAlign${upperCaseFirstLetter(align)}`],{hideLabel:true,icon:locale=>locale[`shapeIconTextAlign${upperCaseFirstLetter(align)}`]}]);const createControlOptions=(items,options)=>{const{defaultKey,defaultOptions}=options||{};let arr=[];if(defaultKey)arr[0]=[undefined,locale=>locale[defaultKey],{...defaultOptions}];return[...arr,...items];};//#endregion
//#region shape style controls
const someFontsAvailableInStack=stack=>stack.split(',').map(name=>name.trim()).some(name=>{// @ts-ignore
return document.fonts.check(`16px ${name}`);});const createColorControl=items=>[ColorPicker,{title:locale=>locale.labelColor,options:createControlOptions(items)}];const createSliderControl=(options={})=>[ToggleSlider,{...options}];const createFontFamilyControl=fontFamilies=>[Dropdown,{title:locale=>locale.shapeTitleFontFamily,onload:({options=[]})=>{// can't check for font availability so don't
if(!canCheckFontAvailability())return;options// map to font stack (option value)
.map(([stack])=>stack)// filter out undefined
.filter(Boolean)// filter out fonts that are available
.filter(stack=>!someFontsAvailableInStack(stack))// remaining fonts should have dom elements for future check
.forEach(stack=>{// get as id
const testId=`PinturaFontTest-${stack.replace(/[^a-zA-Z0-9]+/g,'').toLowerCase()}`;// already added this tester
if(document.getElementById(testId))return;// add font tester
document.body.appendChild(h('span',{textContent:' ',id:testId,style:`font-family:${stack};font-size:0;color:transparent;`}));});},ondestroy:()=>{// can't check for font availability so no need to clean up
if(!canCheckFontAvailability())return;// clean up testers
const testers=document.querySelectorAll('.PinturaFontTest');testers.forEach(tester=>tester.remove());},optionLabelStyle:value=>`font-family: ${value}`,options:createControlOptions(fontFamilies,{defaultKey:'labelDefault'}),optionFilter:fontFamilyOption=>{// don't filter if not in browser context
if(!canCheckFontAvailability())return true;// get font stack
const[stack]=fontFamilyOption;// allow if undefined
if(!stack)return true;// filter out fonts that aren't available
const res=someFontsAvailableInStack(stack);return res;}}];const createBackgroundColorControl=items=>[ColorPicker,{title:locale=>locale.shapeTitleBackgroundColor,options:createControlOptions(items)}];const createStrokeColorControl=(items,options={})=>[ColorPicker,{title:locale=>locale.shapeTitleStrokeColor,options:createControlOptions(items),buttonClass:'PinturaColorPickerButtonStroke',onchange:(value,shape)=>{// get shape strokeWidth as number
const strokeWidth=shape.strokeWidth;const strokeWidthParsed=pintura_isNumber(strokeWidth)||pintura_isString(strokeWidth)?parseFloat(strokeWidth):0;// already has outline
if(strokeWidthParsed>0)return;// set outline to first stroke width
shape.strokeWidth=options&&options.defaultStrokeWidth||'0.5%';}}];const createStrokeWidthControl=items=>[Dropdown,{title:locale=>locale.shapeTitleStrokeWidth,options:shape=>{if(hasProp(shape,'backgroundColor'))return createControlOptions(items,{defaultKey:'shapeLabelStrokeNone'});return createControlOptions(items);}}];const createLineControl=(items,titleKey,optionIconStyle)=>[Dropdown,{title:locale=>locale[titleKey],options:createControlOptions(items,{defaultKey:'labelNone',defaultOptions:{icon:`<g stroke="currentColor" stroke-linecap="round" stroke-width=".125em"><path d="M5,12 H14"/></g>`}}),optionIconStyle}];const createLineStartStyleControl=items=>createLineControl(items,'shapeTitleLineStart',`transform: scaleX(-1)`);const createLineEndStyleControl=items=>createLineControl(items,'shapeTitleLineEnd');const createFontColorControl=items=>[ColorPicker,{title:locale=>locale.shapeTitleTextColor,options:createControlOptions(items)}];const createFontStyleControl=items=>[Dropdown,{title:locale=>locale.shapeTitleFontStyle,optionLabelStyle:value=>value&&`font-style:${value[0]};font-weight:${value[1]}`,options:createControlOptions(items,{defaultKey:'shapeLabelFontStyleNormal'})}];const createFontSizeControl=items=>[Dropdown,{title:locale=>locale.shapeTitleFontSize,options:createControlOptions(items,{defaultKey:'labelDefault'})}];const createTextAlignControl=items=>[RadioGroup,{title:locale=>locale.shapeTitleTextAlign,options:createControlOptions(items)}];const createLineHeightControl=items=>[Dropdown,{title:locale=>locale.shapeTitleLineHeight,options:createControlOptions(items,{defaultKey:'labelAuto'})}];const createShapeStyleControls=(options={})=>{const{colorOptions=createColorOptions(createDefaultColorOptions()),strokeWidthOptions=createStrokeScaleOptions(createDefaultStrokeScaleOptions()),lineEndStyleOptions=createLineEndStyleOptions(createDefaultLineEndStyleOptions()),fontFamilyOptions=createFontFamilyOptions(createDefaultFontFamilyOptions()),fontStyleOptions=createFontStyleOptions(createDefaultFontStyleOptions()),fontSizeOptions=createFontScaleOptions(createDefaultFontScaleOptions()),textAlignOptions=createTextAlignOptions(createDefaultTextAlignOptions())}=options;return{// generic
defaultColor:colorOptions&&createColorControl(colorOptions),defaultNumber:createSliderControl(),defaultPercentage:createSliderControl({getValue:value=>parseFloat(value),setValue:value=>`${value}%`,step:0.05,label:(value,min,max)=>`${Math.round(value/max*100)}%`,labelClass:'PinturaPercentageLabel'}),// shape background
backgroundColor:colorOptions&&createBackgroundColorControl(colorOptions),// line/outline
strokeColor:colorOptions&&createStrokeColorControl(colorOptions),strokeWidth:strokeWidthOptions&&createStrokeWidthControl(strokeWidthOptions),// line
lineStart:lineEndStyleOptions&&createLineStartStyleControl(lineEndStyleOptions),lineEnd:lineEndStyleOptions&&createLineEndStyleControl(lineEndStyleOptions),// text
color:colorOptions&&createFontColorControl(colorOptions),fontFamily:fontFamilyOptions&&createFontFamilyControl(fontFamilyOptions),fontStyle_fontWeight:fontStyleOptions&&createFontStyleControl(fontStyleOptions),fontSize:fontSizeOptions&&createFontSizeControl(fontSizeOptions),textAlign:textAlignOptions&&createTextAlignControl(textAlignOptions),// lineHeight: lineHeightOptions && createLineHeightControl(lineHeightOptions),
// generic options
frameColor:['defaultColor'],frameSize:['defaultPercentage',{min:0.2,max:10,title:locale=>locale.labelSize}],frameInset:['defaultPercentage',{min:0.5,max:10,title:locale=>locale.labelInset}],frameOffset:['defaultPercentage',{min:0.5,max:10,title:locale=>locale.labelOffset}],frameRadius:['defaultPercentage',{min:0.5,max:10,title:locale=>locale.labelRadius}],frameAmount:['defaultNumber',{min:1,max:5,step:1,title:locale=>locale.labelAmount}]};};//#endregion
/* src/core/ui/components/Measure.svelte generated by Svelte v3.37.0 */function create_fragment$r(ctx){let div;let current;let mounted;let dispose;const default_slot_template=/*#slots*/ctx[3].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[2],null);return{c(){div=pintura_element("div");if(default_slot)default_slot.c();attr(div,"class",/*klass*/ctx[0]);},m(target,anchor){insert(target,div,anchor);if(default_slot){default_slot.m(div,null);}current=true;if(!mounted){dispose=[listen(div,"measure",/*handleResize*/ctx[1]),action_destroyer(measurable.call(null,div))];mounted=true;}},p(ctx,[dirty]){if(default_slot){if(default_slot.p&&dirty&/*$$scope*/4){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[2],dirty,null,null);}}if(!current||dirty&/*klass*/1){attr(div,"class",/*klass*/ctx[0]);}},i(local){if(current)return;transition_in(default_slot,local);current=true;},o(local){transition_out(default_slot,local);current=false;},d(detaching){if(detaching)detach(div);if(default_slot)default_slot.d(detaching);mounted=false;run_all(dispose);}};}function instance$r($$self,$$props,$$invalidate){let{$$slots:slots={},$$scope}=$$props;const dispatch=createEventDispatcher();let{class:klass=null}=$$props;const handleResize=({detail})=>dispatch("measure",detail);$$self.$$set=$$props=>{if("class"in $$props)$$invalidate(0,klass=$$props.class);if("$$scope"in $$props)$$invalidate(2,$$scope=$$props.$$scope);};return[klass,handleResize,$$scope,slots];}class Measure extends SvelteComponent{constructor(options){super();init(this,options,instance$r,create_fragment$r,safe_not_equal,{class:0});}}/* src/core/ui/components/Util.svelte generated by Svelte v3.37.0 */const get_footer_slot_changes=dirty=>({});const get_footer_slot_context=ctx=>({});const get_main_slot_changes=dirty=>({});const get_main_slot_context=ctx=>({});const get_header_slot_changes=dirty=>({});const get_header_slot_context=ctx=>({});// (10:0) {#if hasHeader}
function create_if_block_2$4(ctx){let div;let current;const header_slot_template=/*#slots*/ctx[4].header;const header_slot=create_slot(header_slot_template,ctx,/*$$scope*/ctx[3],get_header_slot_context);return{c(){div=pintura_element("div");if(header_slot)header_slot.c();attr(div,"class","PinturaUtilHeader");},m(target,anchor){insert(target,div,anchor);if(header_slot){header_slot.m(div,null);}current=true;},p(ctx,dirty){if(header_slot){if(header_slot.p&&dirty&/*$$scope*/8){update_slot(header_slot,header_slot_template,ctx,/*$$scope*/ctx[3],dirty,get_header_slot_changes,get_header_slot_context);}}},i(local){if(current)return;transition_in(header_slot,local);current=true;},o(local){transition_out(header_slot,local);current=false;},d(detaching){if(detaching)detach(div);if(header_slot)header_slot.d(detaching);}};}// (17:22) <Measure class="PinturaStage" on:measure />
function fallback_block(ctx){let measure;let current;measure=new Measure({props:{class:"PinturaStage"}});measure.$on("measure",/*measure_handler*/ctx[5]);return{c(){create_component(measure.$$.fragment);},m(target,anchor){mount_component(measure,target,anchor);current=true;},p:pintura_noop,i(local){if(current)return;transition_in(measure.$$.fragment,local);current=true;},o(local){transition_out(measure.$$.fragment,local);current=false;},d(detaching){destroy_component(measure,detaching);}};}// (20:0) {#if hasFooter}
function create_if_block_1$5(ctx){let div;let current;const footer_slot_template=/*#slots*/ctx[4].footer;const footer_slot=create_slot(footer_slot_template,ctx,/*$$scope*/ctx[3],get_footer_slot_context);return{c(){div=pintura_element("div");if(footer_slot)footer_slot.c();attr(div,"class","PinturaUtilFooter");},m(target,anchor){insert(target,div,anchor);if(footer_slot){footer_slot.m(div,null);}current=true;},p(ctx,dirty){if(footer_slot){if(footer_slot.p&&dirty&/*$$scope*/8){update_slot(footer_slot,footer_slot_template,ctx,/*$$scope*/ctx[3],dirty,get_footer_slot_changes,get_footer_slot_context);}}},i(local){if(current)return;transition_in(footer_slot,local);current=true;},o(local){transition_out(footer_slot,local);current=false;},d(detaching){if(detaching)detach(div);if(footer_slot)footer_slot.d(detaching);}};}function create_fragment$q(ctx){let t0;let div;let t1;let t2;let if_block2_anchor;let current;let if_block0=/*hasHeader*/ctx[1]&&create_if_block_2$4(ctx);const main_slot_template=/*#slots*/ctx[4].main;const main_slot=create_slot(main_slot_template,ctx,/*$$scope*/ctx[3],get_main_slot_context);const main_slot_or_fallback=main_slot||fallback_block(ctx);let if_block1=/*hasFooter*/ctx[2]&&create_if_block_1$5(ctx);let if_block2=false;return{c(){if(if_block0)if_block0.c();t0=space();div=pintura_element("div");if(main_slot_or_fallback)main_slot_or_fallback.c();t1=space();if(if_block1)if_block1.c();t2=space();if_block2_anchor=empty();attr(div,"class","PinturaUtilMain");},m(target,anchor){if(if_block0)if_block0.m(target,anchor);insert(target,t0,anchor);insert(target,div,anchor);if(main_slot_or_fallback){main_slot_or_fallback.m(div,null);}/*div_binding*/ctx[6](div);insert(target,t1,anchor);if(if_block1)if_block1.m(target,anchor);insert(target,t2,anchor);insert(target,if_block2_anchor,anchor);current=true;},p(ctx,[dirty]){if(/*hasHeader*/ctx[1]){if(if_block0){if_block0.p(ctx,dirty);if(dirty&/*hasHeader*/2){transition_in(if_block0,1);}}else{if_block0=create_if_block_2$4(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(t0.parentNode,t0);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}if(main_slot){if(main_slot.p&&dirty&/*$$scope*/8){update_slot(main_slot,main_slot_template,ctx,/*$$scope*/ctx[3],dirty,get_main_slot_changes,get_main_slot_context);}}if(/*hasFooter*/ctx[2]){if(if_block1){if_block1.p(ctx,dirty);if(dirty&/*hasFooter*/4){transition_in(if_block1,1);}}else{if_block1=create_if_block_1$5(ctx);if_block1.c();transition_in(if_block1,1);if_block1.m(t2.parentNode,t2);}}else if(if_block1){group_outros();transition_out(if_block1,1,1,()=>{if_block1=null;});check_outros();}},i(local){if(current)return;transition_in(if_block0);transition_in(main_slot_or_fallback,local);transition_in(if_block1);transition_in(if_block2);current=true;},o(local){transition_out(if_block0);transition_out(main_slot_or_fallback,local);transition_out(if_block1);transition_out(if_block2);current=false;},d(detaching){if(if_block0)if_block0.d(detaching);if(detaching)detach(t0);if(detaching)detach(div);if(main_slot_or_fallback)main_slot_or_fallback.d(detaching);/*div_binding*/ctx[6](null);if(detaching)detach(t1);if(if_block1)if_block1.d(detaching);if(detaching)detach(t2);if(detaching)detach(if_block2_anchor);}};}function instance$q($$self,$$props,$$invalidate){let{$$slots:slots={},$$scope}=$$props;let{hasHeader=!!$$props.$$slots.header}=$$props;let{hasFooter=!!$$props.$$slots.footer}=$$props;let{root=undefined}=$$props;function measure_handler(event){bubble($$self,event);}function div_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{root=$$value;$$invalidate(0,root);});}$$self.$$set=$$new_props=>{$$invalidate(7,$$props=pintura_assign(pintura_assign({},$$props),exclude_internal_props($$new_props)));if("hasHeader"in $$new_props)$$invalidate(1,hasHeader=$$new_props.hasHeader);if("hasFooter"in $$new_props)$$invalidate(2,hasFooter=$$new_props.hasFooter);if("root"in $$new_props)$$invalidate(0,root=$$new_props.root);if("$$scope"in $$new_props)$$invalidate(3,$$scope=$$new_props.$$scope);};$$props=exclude_internal_props($$props);return[root,hasHeader,hasFooter,$$scope,slots,measure_handler,div_binding];}class Util extends SvelteComponent{constructor(options){super();init(this,options,instance$q,create_fragment$q,safe_not_equal,{hasHeader:1,hasFooter:2,root:0});}}/* src/core/ui/components/RangeInput.svelte generated by Svelte v3.37.0 */function create_if_block$5(ctx){let div;let div_style_value;return{c(){div=pintura_element("div");attr(div,"class","PinturaRangeInputMeter");attr(div,"style",div_style_value=`transform: translateX(${/*$position*/ctx[8].x-/*svgPadding*/ctx[9].x}px) translateY(${/*$position*/ctx[8].y-/*svgPadding*/ctx[9].y}px)`);},m(target,anchor){insert(target,div,anchor);div.innerHTML=/*svg*/ctx[6];},p(ctx,dirty){if(dirty[0]&/*svg*/64)div.innerHTML=/*svg*/ctx[6];if(dirty[0]&/*$position*/256&&div_style_value!==(div_style_value=`transform: translateX(${/*$position*/ctx[8].x-/*svgPadding*/ctx[9].x}px) translateY(${/*$position*/ctx[8].y-/*svgPadding*/ctx[9].y}px)`)){attr(div,"style",div_style_value);}},d(detaching){if(detaching)detach(div);}};}function create_fragment$p(ctx){let div1;let span;let t0;let t1;let button;let t2;let button_disabled_value;let t3;let div0;let mounted;let dispose;let if_block=/*$position*/ctx[8]&&create_if_block$5(ctx);return{c(){div1=pintura_element("div");span=pintura_element("span");t0=pintura_text(/*valueLabel*/ctx[3]);t1=space();button=pintura_element("button");t2=pintura_text(/*labelReset*/ctx[1]);t3=space();div0=pintura_element("div");if(if_block)if_block.c();attr(span,"class","PinturaRangeInputValue");attr(button,"class","PinturaRangeInputReset");attr(button,"type","button");button.disabled=button_disabled_value=/*value*/ctx[0]===/*base*/ctx[2];attr(div0,"class","PinturaRangeInputInner");attr(div0,"style",/*rangeMask*/ctx[7]);attr(div0,"data-value-limited",/*isLimited*/ctx[5]);attr(div1,"class","PinturaRangeInput");attr(div1,"tabindex","0");},m(target,anchor){insert(target,div1,anchor);append(div1,span);append(span,t0);append(div1,t1);append(div1,button);append(button,t2);append(div1,t3);append(div1,div0);if(if_block)if_block.m(div0,null);if(!mounted){dispose=[listen(button,"click",/*handleReset*/ctx[14]),listen(div0,"interactionstart",/*handleDragStart*/ctx[10]),listen(div0,"interactionupdate",/*handleDragMove*/ctx[12]),listen(div0,"interactionend",/*handleDragEnd*/ctx[13]),listen(div0,"interactionrelease",/*handleDragRelease*/ctx[11]),action_destroyer(interactable.call(null,div0,{inertia:true})),listen(div0,"measure",/*measure_handler*/ctx[32]),action_destroyer(measurable.call(null,div0)),listen(div1,"wheel",/*handleWheel*/ctx[16],{passive:false}),listen(div1,"nudge",/*handleNudge*/ctx[17]),action_destroyer(nudgeable.call(null,div1,{direction:"horizontal"}))];mounted=true;}},p(ctx,dirty){if(dirty[0]&/*valueLabel*/8)set_data(t0,/*valueLabel*/ctx[3]);if(dirty[0]&/*labelReset*/2)set_data(t2,/*labelReset*/ctx[1]);if(dirty[0]&/*value, base*/5&&button_disabled_value!==(button_disabled_value=/*value*/ctx[0]===/*base*/ctx[2])){button.disabled=button_disabled_value;}if(/*$position*/ctx[8]){if(if_block){if_block.p(ctx,dirty);}else{if_block=create_if_block$5(ctx);if_block.c();if_block.m(div0,null);}}else if(if_block){if_block.d(1);if_block=null;}if(dirty[0]&/*rangeMask*/128){attr(div0,"style",/*rangeMask*/ctx[7]);}if(dirty[0]&/*isLimited*/32){attr(div0,"data-value-limited",/*isLimited*/ctx[5]);}},i:pintura_noop,o:pintura_noop,d(detaching){if(detaching)detach(div1);if(if_block)if_block.d();mounted=false;run_all(dispose);}};}const radiusBig=2;// 2
const radiusSmall=0.75;// .75
const indicatorSpacing=10;const indicatorInterval=5;const indicatorCount=40;// must be even
function instance$p($$self,$$props,$$invalidate){let range;let valueMinLimited;let valueMaxLimited;let barSize;let baseFraction;let isLimited;let rangeMask;let $position;let{labelReset="Reset"}=$$props;let{direction="x"}=$$props;let{min=0}=$$props;let{max=1}=$$props;let{base=min}=$$props;let{value=0}=$$props;let{valueLabel=0}=$$props;let{valueMin=undefined}=$$props;let{valueMax=undefined}=$$props;let{oninputstart=noop$1}=$$props;let{oninputmove=noop$1}=$$props;let{oninputend=noop$1}=$$props;let{elasticity=0}=$$props;const round=(number,increment,offset)=>Math.ceil((number-offset)/increment)*increment+offset;let size;let svg;let svgSize;const svgPadding={x:2,y:0};const createPathCircle=(cx,cy,r)=>`M ${cx-r} ${cy} a ${r} ${r} 0 1 0 0 -1`;function getMask(limitedMin,limitedMax){const step=1/indicatorCount;const from=toFraction(limitedMin,min,max);const to=toFraction(limitedMax,min,max);const fromSnapped=fixPrecision(round(from,step,0)-step*0.5);const toSnapped=fixPrecision(round(to,step,0)-step*0.5);return`--range-mask-from:${fromSnapped*100}%;--range-mask-to:${toSnapped*100}%`;}//
// Dragging related
//
let interactionOrigin=undefined;let interactionReleased=false;let interactionRange;let interactionOptions={snap:false,elastic:false};const handleDragStart=()=>{interactionReleased=false;interactionOrigin=get_store_value(position);interactionRange=[valueToPosition(valueMin!=null?valueMin:min,direction),valueToPosition(valueMax!=null?valueMax:max,direction)];oninputstart();};const handleDragRelease=()=>{interactionReleased=true;};const handleDragMove=({detail})=>{interactionOptions.snap=!interactionReleased;interactionOptions.elastic=!interactionReleased;translatePosition(interactionOrigin,detail.translation,interactionOptions);};const handleDragEnd=({detail})=>{interactionOptions.snap=false;interactionOptions.elastic=false;const valueAtPosition=translatePosition(interactionOrigin,detail.translation,interactionOptions);interactionOrigin=undefined;interactionRange=undefined;// if is near base position, set to base
if(Math.abs(valueAtPosition-base)<0.01)return oninputend(base);oninputend(valueAtPosition);};const translatePosition=(origin,translation,options)=>{const target=origin[direction]+translation[direction];const targetLimited=pintura_clamp(target,interactionRange[1][direction],interactionRange[0][direction]);const targetElastic=elasticity?targetLimited+elastify(target-targetLimited,elasticity):targetLimited;const targetVisual=options.elastic?targetElastic:targetLimited;// set position
const targetValid=vectorCreate(0,0);targetValid[direction]=targetVisual;position.set(targetValid,{hard:options.snap});return pintura_clamp(positionToValue(targetValid,direction),min,max);};const handleReset=()=>{$$invalidate(0,value=pintura_clamp(base,valueMinLimited,valueMaxLimited));oninputstart();oninputend(value);};//
// Meter position and value updates
//
const position=spring();component_subscribe($$self,position,value=>$$invalidate(8,$position=value));const valueToPosition=(value,axis)=>{const offset=(size[axis]-barSize[axis])*0.5;const fraction=toFraction(value,min,max);const v=fraction*barSize[axis]-barSize[axis]*0.5;const pos=offset-v;return{x:axis==="x"?pos:0,y:axis==="y"?pos:0};};const positionToValue=(position,axis)=>{const dist=position[axis]-size[axis]*0.5;const fraction=-(dist/barSize[axis]);return min+fraction*range;};position.subscribe(currentPosition=>{// if not positioned yet or is not interacting we're not interested in this event
if(!currentPosition||!interactionOrigin)return;oninputmove(pintura_clamp(positionToValue(currentPosition,direction),min,max));});const updatePosition=value=>{const interactionRange=[valueToPosition(valueMin!=null?valueMin:min,direction),valueToPosition(valueMax!=null?valueMax:max,direction)];const target={x:direction==="x"?$position.x+value:0,y:direction==="y"?$position.y+value:0};const targetLimited=pintura_clamp(target[direction],interactionRange[1][direction],interactionRange[0][direction]);const positionTarget={...$position,[direction]:targetLimited};set_store_value(position,$position=positionTarget,$position);const result=pintura_clamp(positionToValue(positionTarget,direction),min,max);oninputstart();oninputmove(result);oninputend(result);};const handleWheel=e=>{// don't run default actions, prevent other actions from running
e.preventDefault();e.stopPropagation();// apply wheel delta to offset
const step=8;const delta=getWheelDelta(e)*step;updatePosition(delta);};const handleNudge=({detail})=>{updatePosition(detail[direction]*8);};const measure_handler=e=>$$invalidate(4,size=vectorCreateFromSize(e.detail));$$self.$$set=$$props=>{if("labelReset"in $$props)$$invalidate(1,labelReset=$$props.labelReset);if("direction"in $$props)$$invalidate(18,direction=$$props.direction);if("min"in $$props)$$invalidate(19,min=$$props.min);if("max"in $$props)$$invalidate(20,max=$$props.max);if("base"in $$props)$$invalidate(2,base=$$props.base);if("value"in $$props)$$invalidate(0,value=$$props.value);if("valueLabel"in $$props)$$invalidate(3,valueLabel=$$props.valueLabel);if("valueMin"in $$props)$$invalidate(21,valueMin=$$props.valueMin);if("valueMax"in $$props)$$invalidate(22,valueMax=$$props.valueMax);if("oninputstart"in $$props)$$invalidate(23,oninputstart=$$props.oninputstart);if("oninputmove"in $$props)$$invalidate(24,oninputmove=$$props.oninputmove);if("oninputend"in $$props)$$invalidate(25,oninputend=$$props.oninputend);if("elasticity"in $$props)$$invalidate(26,elasticity=$$props.elasticity);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*max, min*/1572864){//
// derived
//
$$invalidate(28,range=max-min);}if($$self.$$.dirty[0]&/*valueMin, min*/2621440){$$invalidate(29,valueMinLimited=valueMin!=null?Math.max(valueMin,min):min);}if($$self.$$.dirty[0]&/*valueMax, max*/5242880){$$invalidate(30,valueMaxLimited=valueMax!=null?Math.min(valueMax,max):max);}if($$self.$$.dirty[0]&/*base, min, max*/1572868){$$invalidate(31,baseFraction=toFraction(base,min,max));}if($$self.$$.dirty[0]&/*size*/16|$$self.$$.dirty[1]&/*baseFraction*/1){if(size){const centerY=size.y*0.5;let indicatorCenter=indicatorCount*baseFraction;let d="";let svgWidth;let svgHeight=size.y;let centerShape="";for(let i=0;i<=indicatorCount;i++){const x=svgPadding.x+i*indicatorSpacing;const y=centerY;const r=i%indicatorInterval===0?radiusBig:radiusSmall;d+=createPathCircle(x,y,r)+" ";svgWidth=x+svgPadding.x;if(i===indicatorCenter){centerShape=`<path d="M${x} ${y-4} l2 3 l-2 -1 l-2 1 z"/>`;}}$$invalidate(6,svg=`<svg width="${svgWidth}" height="${svgHeight}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${svgWidth} ${svgHeight}" aria-hidden="true" focusable="false">
        ${centerShape}
        <rect rx="4" ry="4" y="${centerY-4}"" height="8"/>
        <path fill-rule="evenodd" d="${d.trim()}"/></svg>`);$$invalidate(27,svgSize={x:svgWidth-svgPadding.x*2,y:svgHeight});}}if($$self.$$.dirty[0]&/*size, svgSize*/134217744){barSize=size&&svgSize;}if($$self.$$.dirty[0]&/*valueMinLimited, min, valueMaxLimited, max*/1612185600){$$invalidate(5,isLimited=valueMinLimited!==min||valueMaxLimited!==max);}if($$self.$$.dirty[0]&/*isLimited, valueMinLimited, valueMaxLimited*/1610612768){$$invalidate(7,rangeMask=isLimited?getMask(valueMinLimited,valueMaxLimited):"");}if($$self.$$.dirty[0]&/*range, size, value, direction*/268697617){// if has size (range is in here so the position is updated if the range is changed)
if(range&&size&&size.x&&size.y){position.set(valueToPosition(value,direction));}}};return[value,labelReset,base,valueLabel,size,isLimited,svg,rangeMask,$position,svgPadding,handleDragStart,handleDragRelease,handleDragMove,handleDragEnd,handleReset,position,handleWheel,handleNudge,direction,min,max,valueMin,valueMax,oninputstart,oninputmove,oninputend,elasticity,svgSize,range,valueMinLimited,valueMaxLimited,baseFraction,measure_handler];}class RangeInput extends SvelteComponent{constructor(options){super();init(this,options,instance$p,create_fragment$p,safe_not_equal,{labelReset:1,direction:18,min:19,max:20,base:2,value:0,valueLabel:3,valueMin:21,valueMax:22,oninputstart:23,oninputmove:24,oninputend:25,elasticity:26},[-1,-1]);}}/* src/core/ui/components/Toolbar.svelte generated by Svelte v3.37.0 */function create_fragment$o(ctx){let div1;let div0;let current;let mounted;let dispose;const default_slot_template=/*#slots*/ctx[7].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[6],null);return{c(){div1=pintura_element("div");div0=pintura_element("div");if(default_slot)default_slot.c();attr(div0,"class","PinturaToolbarInner");attr(div1,"class","PinturaToolbar");attr(div1,"data-layout",/*layout*/ctx[1]);attr(div1,"data-overflow",/*overflow*/ctx[0]);},m(target,anchor){insert(target,div1,anchor);append(div1,div0);if(default_slot){default_slot.m(div0,null);}current=true;if(!mounted){dispose=[listen(div0,"measure",/*handleChildResizeEvent*/ctx[3]),action_destroyer(measurable.call(null,div0)),listen(div1,"measure",/*handleParentResizeEvent*/ctx[2]),action_destroyer(measurable.call(null,div1))];mounted=true;}},p(ctx,[dirty]){if(default_slot){if(default_slot.p&&dirty&/*$$scope*/64){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[6],dirty,null,null);}}if(!current||dirty&/*layout*/2){attr(div1,"data-layout",/*layout*/ctx[1]);}if(!current||dirty&/*overflow*/1){attr(div1,"data-overflow",/*overflow*/ctx[0]);}},i(local){if(current)return;transition_in(default_slot,local);current=true;},o(local){transition_out(default_slot,local);current=false;},d(detaching){if(detaching)detach(div1);if(default_slot)default_slot.d(detaching);mounted=false;run_all(dispose);}};}function instance$o($$self,$$props,$$invalidate){let layout;let{$$slots:slots={},$$scope}=$$props;let childWidth=0;let childMaxWidth=0;let parentWidth=0;let overflow;const testOverflow=()=>{$$invalidate(0,overflow=layout==="compact"&&childWidth>parentWidth?"overflow":undefined);};const handleParentResizeEvent=({detail})=>{const{width}=detail;$$invalidate(5,parentWidth=width);testOverflow();};const handleChildResizeEvent=({detail})=>{const{width}=detail;if(width>childMaxWidth){$$invalidate(4,childMaxWidth=width);}childWidth=width;if(!overflow)testOverflow();};$$self.$$set=$$props=>{if("$$scope"in $$props)$$invalidate(6,$$scope=$$props.$$scope);};$$self.$$.update=()=>{if($$self.$$.dirty&/*childMaxWidth, parentWidth*/48){$$invalidate(1,layout=childMaxWidth>parentWidth?"compact":"default");}};return[overflow,layout,handleParentResizeEvent,handleChildResizeEvent,childMaxWidth,parentWidth,$$scope,slots];}class Toolbar extends SvelteComponent{constructor(options){super();init(this,options,instance$o,create_fragment$o,safe_not_equal,{});}}// enum Direction {
//     Top = 't',
//     Right = 'r',
//     Bottom = 'b',
//     Left = 'l',
//     TopLeft = 'tl',
//     TopRight = 'tr',
//     BottomRight = 'br',
//     BottomLeft = 'bl',
// }
// export const { Top, Right, Bottom, Left, TopLeft, TopRight, BottomRight, BottomLeft } = Direction;
// export default Direction;
const Direction={Top:'t',Right:'r',Bottom:'b',Left:'l',TopLeft:'tl',TopRight:'tr',BottomRight:'br',BottomLeft:'bl'};const{Top,Right,Bottom,Left,TopLeft,TopRight,BottomRight,BottomLeft}=Direction;var DirectionRectMap={[Top]:rect=>({x:rect.x,y:rect.y}),[TopRight]:rect=>({x:rect.x+rect.width,y:rect.y}),[Right]:rect=>({x:rect.x+rect.width,y:rect.y}),[BottomRight]:rect=>({x:rect.x+rect.width,y:rect.y+rect.height}),[Bottom]:rect=>({x:rect.x,y:rect.y+rect.height}),[BottomLeft]:rect=>({x:rect.x,y:rect.y+rect.height}),[Left]:rect=>({x:rect.x,y:rect.y}),[TopLeft]:rect=>({x:rect.x,y:rect.y})};/* src/core/ui/components/RectManipulator.svelte generated by Svelte v3.37.0 */function get_each_context$5(ctx,list,i){const child_ctx=ctx.slice();child_ctx[12]=list[i].key;child_ctx[13]=list[i].translate;child_ctx[14]=list[i].scale;child_ctx[15]=list[i].type;child_ctx[16]=list[i].opacity;return child_ctx;}// (107:0) {#each mappedDirections as { key, translate, scale, type, opacity }
function create_each_block$5(key_1,ctx){let div;let div_aria_label_value;let div_tabindex_value;let div_data_direction_value;let div_data_shape_value;let div_style_value;let mounted;let dispose;return{key:key_1,first:null,c(){div=pintura_element("div");attr(div,"role","button");attr(div,"aria-label",div_aria_label_value=`Drag ${/*type*/ctx[15]} ${/*key*/ctx[12]}`);attr(div,"tabindex",div_tabindex_value=/*type*/ctx[15]==="edge"?-1:0);attr(div,"class","PinturaRectManipulator");attr(div,"data-direction",div_data_direction_value=/*key*/ctx[12]);attr(div,"data-shape",div_data_shape_value=`${/*type*/ctx[15]==="edge"?"edge":`${/*style*/ctx[0]}`}`);attr(div,"style",div_style_value=`transform: translate3d(${/*translate*/ctx[13].x}px, ${/*translate*/ctx[13].y}px, 0) scale(${/*scale*/ctx[14].x}, ${/*scale*/ctx[14].y}); opacity: ${/*opacity*/ctx[16]}`);this.first=div;},m(target,anchor){insert(target,div,anchor);if(!mounted){dispose=[listen(div,"nudge",function(){if(is_function(/*nudge*/ctx[5](/*key*/ctx[12])))/*nudge*/ctx[5](/*key*/ctx[12]).apply(this,arguments);}),action_destroyer(nudgeable.call(null,div)),listen(div,"interactionstart",function(){if(is_function(/*route*/ctx[4]("resizestart",/*key*/ctx[12])))/*route*/ctx[4]("resizestart",/*key*/ctx[12]).apply(this,arguments);}),listen(div,"interactionupdate",function(){if(is_function(/*route*/ctx[4]("resizemove",/*key*/ctx[12])))/*route*/ctx[4]("resizemove",/*key*/ctx[12]).apply(this,arguments);}),listen(div,"interactionend",function(){if(is_function(/*route*/ctx[4]("resizeend",/*key*/ctx[12])))/*route*/ctx[4]("resizeend",/*key*/ctx[12]).apply(this,arguments);}),action_destroyer(interactable.call(null,div))];mounted=true;}},p(new_ctx,dirty){ctx=new_ctx;if(dirty&/*mappedDirections*/2&&div_aria_label_value!==(div_aria_label_value=`Drag ${/*type*/ctx[15]} ${/*key*/ctx[12]}`)){attr(div,"aria-label",div_aria_label_value);}if(dirty&/*mappedDirections*/2&&div_tabindex_value!==(div_tabindex_value=/*type*/ctx[15]==="edge"?-1:0)){attr(div,"tabindex",div_tabindex_value);}if(dirty&/*mappedDirections*/2&&div_data_direction_value!==(div_data_direction_value=/*key*/ctx[12])){attr(div,"data-direction",div_data_direction_value);}if(dirty&/*mappedDirections, style*/3&&div_data_shape_value!==(div_data_shape_value=`${/*type*/ctx[15]==="edge"?"edge":`${/*style*/ctx[0]}`}`)){attr(div,"data-shape",div_data_shape_value);}if(dirty&/*mappedDirections*/2&&div_style_value!==(div_style_value=`transform: translate3d(${/*translate*/ctx[13].x}px, ${/*translate*/ctx[13].y}px, 0) scale(${/*scale*/ctx[14].x}, ${/*scale*/ctx[14].y}); opacity: ${/*opacity*/ctx[16]}`)){attr(div,"style",div_style_value);}},d(detaching){if(detaching)detach(div);mounted=false;run_all(dispose);}};}function create_fragment$n(ctx){let each_blocks=[];let each_1_lookup=new Map();let each_1_anchor;let each_value=/*mappedDirections*/ctx[1];const get_key=ctx=>/*key*/ctx[12];for(let i=0;i<each_value.length;i+=1){let child_ctx=get_each_context$5(ctx,each_value,i);let key=get_key(child_ctx);each_1_lookup.set(key,each_blocks[i]=create_each_block$5(key,child_ctx));}return{c(){for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].c();}each_1_anchor=empty();},m(target,anchor){for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].m(target,anchor);}insert(target,each_1_anchor,anchor);},p(ctx,[dirty]){if(dirty&/*mappedDirections, style, nudge, route*/51){each_value=/*mappedDirections*/ctx[1];each_blocks=update_keyed_each(each_blocks,dirty,get_key,1,ctx,each_value,each_1_lookup,each_1_anchor.parentNode,destroy_block,create_each_block$5,each_1_anchor,get_each_context$5);}},i:pintura_noop,o:pintura_noop,d(detaching){for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].d(detaching);}if(detaching)detach(each_1_anchor);}};}function instance$n($$self,$$props,$$invalidate){let mappedDirections;let $selectionScale;let $selectionOpacity;let{rect=null}=$$props;let{visible=false}=$$props;let{style=undefined}=$$props;// is `undefined` to prevent bounce when first rendering view
const selectionScale=spring(undefined,{precision:0.0001,stiffness:0.2,damping:0.4});component_subscribe($$self,selectionScale,value=>$$invalidate(8,$selectionScale=value));const selectionOpacity=spring(0,{precision:0.001});component_subscribe($$self,selectionOpacity,value=>$$invalidate(9,$selectionOpacity=value));//
// dragging
//
let currentDirection;const dispatch=createEventDispatcher();const route=(type,direction)=>({detail})=>{// don't handle other interactions while manipulating on axis
if(currentDirection&&direction!==currentDirection)return;// ignore move and end events if no direction has been set
if(type!=="resizestart"&&currentDirection===undefined)return;// set new direction
if(type==="resizestart")currentDirection=direction;// release direction
if(type==="resizeend")currentDirection=undefined;dispatch(type,{direction,translation:detail&&detail.translation});};const nudge=direction=>({detail})=>{dispatch(`resizestart`,{direction,translation:{x:0,y:0}});dispatch(`resizemove`,{direction,translation:detail});dispatch(`resizeend`,{direction,translation:{x:0,y:0}});};$$self.$$set=$$props=>{if("rect"in $$props)$$invalidate(6,rect=$$props.rect);if("visible"in $$props)$$invalidate(7,visible=$$props.visible);if("style"in $$props)$$invalidate(0,style=$$props.style);};$$self.$$.update=()=>{if($$self.$$.dirty&/*visible*/128){selectionScale.set(visible?1:0.5);}if($$self.$$.dirty&/*visible*/128){selectionOpacity.set(visible?1:0);}if($$self.$$.dirty&/*rect, $selectionScale, $selectionOpacity*/832){//
// rendering
//
$$invalidate(1,mappedDirections=Object.keys(Direction).map((key,i)=>{// get direction enum
const direction=Direction[key];// get position from direction
const position=DirectionRectMap[direction](rect);// corner or edge
const type=direction.length===1?"edge":"corner";const isCorner=type==="corner";return{key:direction,type,scale:{x:/^(t|b)$/.test(direction)?rect.width:isCorner?pintura_clamp($selectionScale,0.5,1.25):1,y:/^(r|l)$/.test(direction)?rect.height:isCorner?pintura_clamp($selectionScale,0.5,1.25):1},translate:{x:position.x,y:position.y},opacity:$selectionOpacity};}));}};return[style,mappedDirections,selectionScale,selectionOpacity,route,nudge,rect,visible,$selectionScale,$selectionOpacity];}class RectManipulator extends SvelteComponent{constructor(options){super();init(this,options,instance$n,create_fragment$n,safe_not_equal,{rect:6,visible:7,style:0});}}var gesturable=element=>{function dispatch(type,detail){element.dispatchEvent(new CustomEvent(type,{detail}));}const handleGestureStart=e=>{e.preventDefault();element.addEventListener('gesturechange',handleGestureChange);element.addEventListener('gestureend',handleGestureEnd);dispatch('gesturedown');};const handleGestureChange=e=>{e.preventDefault();dispatch('gestureupdate',e.scale);};const handleGestureEnd=e=>{dispatch('gestureup',e.scale);e.preventDefault();clean();};const clean=()=>{element.removeEventListener('gesturechange',handleGestureChange);element.removeEventListener('gestureend',handleGestureEnd);};element.addEventListener('gesturestart',handleGestureStart);return{destroy:()=>{clean();element.removeEventListener('gesturestart',handleGestureStart);}};};var getEventPositionInViewport=e=>vectorCreate(e.clientX,e.clientY);var getEventPositionInStage=(e,viewOffset,stageOffset)=>{const positionInViewport=getEventPositionInViewport(e);return vectorSubtract(vectorSubtract(positionInViewport,viewOffset),stageOffset);};var DirectionInversionTable={[Top]:Bottom,[Right]:Left,[Bottom]:Top,[Left]:Right,[TopLeft]:BottomRight,[TopRight]:BottomLeft,[BottomRight]:TopLeft,[BottomLeft]:TopRight};var DirectionCoordinateTable={[Top]:[0.5,0],[Right]:[1,0.5],[Bottom]:[0.5,1],[Left]:[0,0.5],[TopLeft]:[0,0],[TopRight]:[1,0],[BottomRight]:[1,1],[BottomLeft]:[0,1]};var getTranslationInfo=target=>{const translateToRight=target===Right||target===TopRight||target===BottomRight;const translateToLeft=target===Left||target===BottomLeft||target===TopLeft;const translateToTop=target===Top||target===TopRight||target===TopLeft;const translateToBottom=target===Bottom||target===BottomRight||target===BottomLeft;const translateHorizontally=target===Left||target===Right;const translateVertically=target===Top||target===Bottom;const translateAxis=translateHorizontally||translateVertically;return[translateToRight,translateToLeft,translateToTop,translateToBottom,translateHorizontally,translateVertically,translateAxis];};var limitRectDirectionTranslation=(rect,transform,bounds,options={})=>{// the transforms to apply
const{target,translate}=transform;// the transform requirements
const{aspectRatio,minSize,maxSize}=options;// get anchor coordinates and x,y position we need this for relative scaling of the view rectangle
const anchor=DirectionInversionTable[target];const anchorDirectionCoordinates=DirectionCoordinateTable[anchor];const anchorPosition=vectorAdd(vectorCreate(rect.x,rect.y),vectorCreate(anchorDirectionCoordinates[0]*rect.width,anchorDirectionCoordinates[1]*rect.height));// get coordinate of direction
const targetDirectionCoordinates=DirectionCoordinateTable[target];const targetPosition=vectorAdd(rectClone(rect),vectorCreate(targetDirectionCoordinates[0]*rect.width,targetDirectionCoordinates[1]*rect.height));// bools to determine which direction the interaction is moving in
const[translateToRight,translateToLeft,translateToTop,translateToBottom,translateHorizontally,translateVertically,translateAxis]=getTranslationInfo(target);let tx=translate.x;let ty=translate.y;if(translateHorizontally)ty=0;else if(translateVertically)tx=0;const interactionBounds=getInteractionBounds(anchorPosition,target,bounds,{aspectRatio,minSize,maxSize});// current bounds
let[t,r,b,l]=rectToBounds(rect);// update view bounds with anchor based on translation direction (one side is always locked)
if(translateToRight)l=anchorPosition.x;else if(translateToLeft)r=anchorPosition.x;if(translateToBottom)t=anchorPosition.y;else if(translateToTop)b=anchorPosition.y;// update view bounds with interaction limits
if(translateToRight){const innerR=interactionBounds.inner.x+interactionBounds.inner.width;const outerR=interactionBounds.outer.x+interactionBounds.outer.width;r=pintura_clamp(targetPosition.x+tx,innerR,outerR);}else if(translateToLeft){const innerL=interactionBounds.outer.x;const outerL=interactionBounds.inner.x;l=pintura_clamp(targetPosition.x+tx,innerL,outerL);}if(translateToBottom){const innerB=interactionBounds.inner.y+interactionBounds.inner.height;const outerB=interactionBounds.outer.y+interactionBounds.outer.height;b=pintura_clamp(targetPosition.y+ty,innerB,outerB);}else if(translateToTop){const innerT=interactionBounds.outer.y;const outerT=interactionBounds.inner.y;t=pintura_clamp(targetPosition.y+ty,innerT,outerT);}// if aspect ratio is set we need to scale both axis
if(aspectRatio){// if translating over horizontal or vertical axis we need to update the other axis based on the aspect ratio as well
if(translateAxis){let dx=r-l;let dy=b-t;if(translateHorizontally){dy=dx/aspectRatio;t=anchorPosition.y-dy*0.5;b=anchorPosition.y+dy*0.5;}else if(translateVertically){dx=dy*aspectRatio;l=anchorPosition.x-dx*0.5;r=anchorPosition.x+dx*0.5;}}// we're translating one of the corners in both the x and y direction, need to make sure it conforms to aspect ratio
else{const pointer=vectorCreate(targetPosition.x+tx-anchorPosition.x,targetPosition.y+ty-anchorPosition.y);// translations cannot be inverted, limited by anchor position
if(target===TopRight){pointer.x=Math.max(0,pointer.x);pointer.y=Math.min(0,pointer.y);}else if(target===BottomRight){pointer.x=Math.max(0,pointer.x);pointer.y=Math.max(0,pointer.y);}else if(target===BottomLeft){pointer.x=Math.min(0,pointer.x);pointer.y=Math.max(0,pointer.y);}else if(target===TopLeft){pointer.x=Math.min(0,pointer.x);pointer.y=Math.min(0,pointer.y);}// calculate the translation pointer, then get its length, now create a new pointer based on the aspect ratio, and scale it based on the original (limited) length
const pointerLength=vectorLength(pointer);const pointerLengthMin=vectorLength(vectorCreate(interactionBounds.inner.width,interactionBounds.inner.height));const pointerLengthMax=vectorLength(vectorCreate(interactionBounds.outer.width,interactionBounds.outer.height));const pointerLengthLimited=pintura_clamp(pointerLength,pointerLengthMin,pointerLengthMax);const pointerAspectRatio=vectorCreate(aspectRatio,1);const pointerScaled=vectorMultiply(vectorNormalize(pointerAspectRatio),pointerLengthLimited);if(target===TopRight){r=anchorPosition.x+pointerScaled.x;t=anchorPosition.y-pointerScaled.y;}else if(target===BottomRight){r=anchorPosition.x+pointerScaled.x;b=anchorPosition.y+pointerScaled.y;}else if(target===BottomLeft){l=anchorPosition.x-pointerScaled.x;b=anchorPosition.y+pointerScaled.y;}else if(target===TopLeft){l=anchorPosition.x-pointerScaled.x;t=anchorPosition.y-pointerScaled.y;}}}return rectCreate(l,t,r-l,b-t);};const getInteractionBounds=(anchor,dir,bounds,options)=>{const{aspectRatio,minSize,maxSize}=options;const translateToRight=dir===Right||dir===TopRight||dir===BottomRight;const translateToLeft=dir===Left||dir===BottomLeft||dir===TopLeft;const translateToTop=dir===Top||dir===TopRight||dir===TopLeft;const translateToBottom=dir===Bottom||dir===BottomRight||dir===BottomLeft;const translateHorizontally=dir===Left||dir===Right;const translateVertically=dir===Top||dir===Bottom;// limit bounds based on anchor and direction
const limitedBounds=rectClone(bounds);if(translateToRight){limitedBounds.x=anchor.x;limitedBounds.width-=anchor.x;}else if(translateToLeft){limitedBounds.width=anchor.x;}if(translateToBottom){limitedBounds.y=anchor.y;limitedBounds.height-=anchor.y;}else if(translateToTop){limitedBounds.height=anchor.y;}// limit max size based on bounds
const maxSizeLimitedToBounds=rectCreateFromDimensions(Math.min(limitedBounds.width,maxSize.width),Math.min(limitedBounds.height,maxSize.height));if(aspectRatio){// limit height
if(translateHorizontally){const verticalSpace=Math.min(anchor.y,bounds.height-anchor.y);maxSizeLimitedToBounds.height=Math.min(verticalSpace*2,maxSizeLimitedToBounds.height);}// limit width
else if(translateVertically){const horizontalSpace=Math.min(anchor.x,bounds.width-anchor.x);maxSizeLimitedToBounds.width=Math.min(horizontalSpace*2,maxSizeLimitedToBounds.width);}}const maxSizeLimited=aspectRatio?sizeCreateFromRect(rectContainRect(maxSizeLimitedToBounds,aspectRatio)):maxSizeLimitedToBounds;// limit min size
const minSizeLimited=aspectRatio?sizeCreateFromRect(rectCoverRect(rectCreateFromSize(minSize),aspectRatio)):minSize;let l,r,t,b;// set bounds
if(translateToRight)l=anchor.x;else if(translateToLeft)r=anchor.x;if(translateToBottom)t=anchor.y;else if(translateToTop)b=anchor.y;// inner
if(translateToRight){r=l+minSizeLimited.width;}else if(translateToLeft){l=r-minSizeLimited.width;}if(translateToBottom){b=t+minSizeLimited.height;}else if(translateToTop){t=b-minSizeLimited.height;}if(translateHorizontally){t=anchor.y-minSizeLimited.height*0.5;b=anchor.y+minSizeLimited.height*0.5;}else if(translateVertically){l=anchor.x-minSizeLimited.width*0.5;r=anchor.x+minSizeLimited.width*0.5;}const inner=rectCreateFromPoints(vectorCreate(l,t),vectorCreate(r,b));// outer
if(translateToRight){r=l+maxSizeLimited.width;}else if(translateToLeft){l=r-maxSizeLimited.width;}if(translateToBottom){b=t+maxSizeLimited.height;}else if(translateToTop){t=b-maxSizeLimited.height;}if(translateHorizontally){t=anchor.y-maxSizeLimited.height*0.5;b=anchor.y+maxSizeLimited.height*0.5;}else if(translateVertically){l=anchor.x-maxSizeLimited.width*0.5;r=anchor.x+maxSizeLimited.width*0.5;}const outer=rectCreateFromPoints(vectorCreate(l,t),vectorCreate(r,b));return{inner,outer};};var applyRectDirectionTranslation=(rect,transform,options={})=>{// the transforms to apply
const{target,translate}=transform;// the transform requirements
const{aspectRatio}=options;// get anchor coordinates and x,y position we need this for relative scaling of the view rectangle
const anchor=DirectionInversionTable[target];const anchorDirectionCoordinates=DirectionCoordinateTable[anchor];const anchorPosition=vectorAdd(rectClone(rect),vectorCreate(anchorDirectionCoordinates[0]*rect.width,anchorDirectionCoordinates[1]*rect.height));// get coordinate of direction
const targetDirectionCoordinates=DirectionCoordinateTable[target];const targetPosition=vectorAdd(rectClone(rect),vectorCreate(targetDirectionCoordinates[0]*rect.width,targetDirectionCoordinates[1]*rect.height));// bools to determine which direction the interaction is moving in
const[translateToRight,translateToLeft,translateToTop,translateToBottom,translateHorizontally,translateVertically,translateAxis]=getTranslationInfo(target);let tx=translate.x;let ty=translate.y;if(translateHorizontally)ty=0;else if(translateVertically)tx=0;// current bounds
let[t,r,b,l]=rectToBounds(rect);// update view bounds with anchor based on translation direction (one side is always locked)
if(translateToRight)l=anchorPosition.x;else if(translateToLeft)r=anchorPosition.x;if(translateToBottom)t=anchorPosition.y;else if(translateToTop)b=anchorPosition.y;// update view bounds with interaction limits
if(translateToRight){r=targetPosition.x+tx;}else if(translateToLeft){l=targetPosition.x+tx;}if(translateToBottom){b=targetPosition.y+ty;}else if(translateToTop){t=targetPosition.y+ty;}// if aspect ratio is set we need to scale both axis
if(aspectRatio){// if translating over horizontal or vertical axis we need to update the other axis based on the aspect ratio as well
if(translateAxis){let dx=r-l;let dy=b-t;if(translateHorizontally){dy=dx/aspectRatio;t=anchorPosition.y-dy*0.5;b=anchorPosition.y+dy*0.5;}else if(translateVertically){dx=dy*aspectRatio;l=anchorPosition.x-dx*0.5;r=anchorPosition.x+dx*0.5;}}// we're translating one of the corners in both the x and y direction, need to make sure it conforms to aspect ratio
else{const pointer=vectorCreate(targetPosition.x+tx-anchorPosition.x,targetPosition.y+ty-anchorPosition.y);// translations cannot be inverted, limited by anchor position
if(target===TopRight){pointer.x=Math.max(0,pointer.x);pointer.y=Math.min(0,pointer.y);}else if(target===BottomRight){pointer.x=Math.max(0,pointer.x);pointer.y=Math.max(0,pointer.y);}else if(target===BottomLeft){pointer.x=Math.min(0,pointer.x);pointer.y=Math.max(0,pointer.y);}else if(target===TopLeft){pointer.x=Math.min(0,pointer.x);pointer.y=Math.min(0,pointer.y);}// calculate the translation pointer, then get its length, now create a new pointer based on the aspect ratio, and scale it based on the original (limited) length
const pointerLength=vectorLength(pointer);const pointerAspectRatio=vectorCreate(aspectRatio,1);const pointerScaled=vectorMultiply(vectorNormalize(pointerAspectRatio),pointerLength);if(target===TopRight){r=anchorPosition.x+pointerScaled.x;t=anchorPosition.y-pointerScaled.y;}else if(target===BottomRight){r=anchorPosition.x+pointerScaled.x;b=anchorPosition.y+pointerScaled.y;}else if(target===BottomLeft){l=anchorPosition.x-pointerScaled.x;b=anchorPosition.y+pointerScaled.y;}else if(target===TopLeft){l=anchorPosition.x-pointerScaled.x;t=anchorPosition.y-pointerScaled.y;}}}return rectCreate(l,t,r-l,b-t);};var radToDeg=rad=>rad*180/Math.PI;/* src/core/ui/plugins/crop/components/ImageRotator.svelte generated by Svelte v3.37.0 */function create_fragment$m(ctx){let div;let rangeinput;let current;rangeinput=new RangeInput({props:{elasticity:/*elasticity*/ctx[5],min:/*min*/ctx[7],max:/*max*/ctx[8],value:/*value*/ctx[12],valueMin:/*valueMin*/ctx[0],valueMax:/*valueMax*/ctx[1],labelReset:/*labelReset*/ctx[6],base:/*center*/ctx[11],valueLabel:`${Math.round(radToDeg(/*value*/ctx[12]))}°`,oninputstart:/*oninputstart*/ctx[2],oninputmove:/*func*/ctx[14],oninputend:/*func_1*/ctx[15]}});return{c(){div=pintura_element("div");create_component(rangeinput.$$.fragment);attr(div,"class","PinturaImageRotator");},m(target,anchor){insert(target,div,anchor);mount_component(rangeinput,div,null);current=true;},p(ctx,[dirty]){const rangeinput_changes={};if(dirty&/*elasticity*/32)rangeinput_changes.elasticity=/*elasticity*/ctx[5];if(dirty&/*min*/128)rangeinput_changes.min=/*min*/ctx[7];if(dirty&/*max*/256)rangeinput_changes.max=/*max*/ctx[8];if(dirty&/*value*/4096)rangeinput_changes.value=/*value*/ctx[12];if(dirty&/*valueMin*/1)rangeinput_changes.valueMin=/*valueMin*/ctx[0];if(dirty&/*valueMax*/2)rangeinput_changes.valueMax=/*valueMax*/ctx[1];if(dirty&/*labelReset*/64)rangeinput_changes.labelReset=/*labelReset*/ctx[6];if(dirty&/*center*/2048)rangeinput_changes.base=/*center*/ctx[11];if(dirty&/*value*/4096)rangeinput_changes.valueLabel=`${Math.round(radToDeg(/*value*/ctx[12]))}°`;if(dirty&/*oninputstart*/4)rangeinput_changes.oninputstart=/*oninputstart*/ctx[2];if(dirty&/*oninputmove, sign, turns*/1544)rangeinput_changes.oninputmove=/*func*/ctx[14];if(dirty&/*oninputend, sign, turns*/1552)rangeinput_changes.oninputend=/*func_1*/ctx[15];rangeinput.$set(rangeinput_changes);},i(local){if(current)return;transition_in(rangeinput.$$.fragment,local);current=true;},o(local){transition_out(rangeinput.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(rangeinput);}};}const MARGIN=1e-9;function instance$m($$self,$$props,$$invalidate){let min;let max;let center;let sign;let turns;let value;const HALF_PI=Math.PI/2;const QUARTER_PI=Math.PI/4;let{rotation}=$$props;let{valueMin}=$$props;let{valueMax}=$$props;let{oninputstart=noop$1}=$$props;let{oninputmove=noop$1}=$$props;let{oninputend=noop$1}=$$props;let{elasticity=0}=$$props;let{labelReset=undefined}=$$props;const func=value=>oninputmove(sign*turns+value);const func_1=value=>oninputend(sign*turns+value);$$self.$$set=$$props=>{if("rotation"in $$props)$$invalidate(13,rotation=$$props.rotation);if("valueMin"in $$props)$$invalidate(0,valueMin=$$props.valueMin);if("valueMax"in $$props)$$invalidate(1,valueMax=$$props.valueMax);if("oninputstart"in $$props)$$invalidate(2,oninputstart=$$props.oninputstart);if("oninputmove"in $$props)$$invalidate(3,oninputmove=$$props.oninputmove);if("oninputend"in $$props)$$invalidate(4,oninputend=$$props.oninputend);if("elasticity"in $$props)$$invalidate(5,elasticity=$$props.elasticity);if("labelReset"in $$props)$$invalidate(6,labelReset=$$props.labelReset);};$$self.$$.update=()=>{if($$self.$$.dirty&/*min, max*/384){$$invalidate(11,center=min+(max-min)*0.5);}if($$self.$$.dirty&/*rotation*/8192){$$invalidate(9,sign=Math.sign(rotation));}if($$self.$$.dirty&/*rotation*/8192){$$invalidate(10,turns=Math.round(Math.abs(rotation)/HALF_PI)*HALF_PI);}if($$self.$$.dirty&/*rotation, sign, turns*/9728){$$invalidate(12,value=rotation-sign*turns);}};$$invalidate(7,min=-QUARTER_PI+MARGIN);$$invalidate(8,max=QUARTER_PI-MARGIN);return[valueMin,valueMax,oninputstart,oninputmove,oninputend,elasticity,labelReset,min,max,sign,turns,center,value,rotation,func,func_1];}class ImageRotator extends SvelteComponent{constructor(options){super();init(this,options,instance$m,create_fragment$m,safe_not_equal,{rotation:13,valueMin:0,valueMax:1,oninputstart:2,oninputmove:3,oninputend:4,elasticity:5,labelReset:6});}}/* src/core/ui/plugins/crop/components/ImageInfo.svelte generated by Svelte v3.37.0 */function create_fragment$l(ctx){let div;let p;let t0;let t1;let t2;return{c(){div=pintura_element("div");p=pintura_element("p");t0=pintura_text(/*width*/ctx[0]);t1=pintura_text(" × ");t2=pintura_text(/*height*/ctx[1]);attr(div,"class","PinturaImageInfo");},m(target,anchor){insert(target,div,anchor);append(div,p);append(p,t0);append(p,t1);append(p,t2);},p(ctx,[dirty]){if(dirty&/*width*/1)set_data(t0,/*width*/ctx[0]);if(dirty&/*height*/2)set_data(t2,/*height*/ctx[1]);},i:pintura_noop,o:pintura_noop,d(detaching){if(detaching)detach(div);}};}function instance$l($$self,$$props,$$invalidate){let{width}=$$props;let{height}=$$props;$$self.$$set=$$props=>{if("width"in $$props)$$invalidate(0,width=$$props.width);if("height"in $$props)$$invalidate(1,height=$$props.height);};return[width,height];}class ImageInfo extends SvelteComponent{constructor(options){super();init(this,options,instance$l,create_fragment$l,safe_not_equal,{width:0,height:1});}}var getSelectionPresetOptionIcon=(value,options={})=>{const{width=24,height=24,bounds=16,radius=3}=options;let aspectRatio=pintura_isArray(value)?getAspectRatio(value[0],value[1]):value;let aspectRatioDefined=!!aspectRatio;aspectRatio=aspectRatioDefined?aspectRatio:1;let x;let y;let w;let h;w=aspectRatio>1?bounds:aspectRatio*bounds;h=w/aspectRatio;x=Math.round((width-w)*0.5);y=Math.round((height-h)*0.5);const fill=aspectRatioDefined?'currentColor':'none';const stroke=aspectRatioDefined?'none':'currentColor';const strokeWidth=width/16;const strokeDashArray=[width/12,width/6].join(' ');return`<rect fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" stroke-dasharray="${strokeDashArray}" x="${x}" y="${y}" width="${w}" height="${h}" rx="${radius}"/>`;};/* src/core/ui/plugins/crop/index.svelte generated by Svelte v3.37.0 */function create_default_slot_2$2(ctx){let dynamiccomponenttree;let current;dynamiccomponenttree=new DynamicComponentTree_1({props:{items:/*tools*/ctx[0]}});return{c(){create_component(dynamiccomponenttree.$$.fragment);},m(target,anchor){mount_component(dynamiccomponenttree,target,anchor);current=true;},p(ctx,dirty){const dynamiccomponenttree_changes={};if(dirty[0]&/*tools*/1)dynamiccomponenttree_changes.items=/*tools*/ctx[0];dynamiccomponenttree.$set(dynamiccomponenttree_changes);},i(local){if(current)return;transition_in(dynamiccomponenttree.$$.fragment,local);current=true;},o(local){transition_out(dynamiccomponenttree.$$.fragment,local);current=false;},d(detaching){destroy_component(dynamiccomponenttree,detaching);}};}// (1423:4) 
function create_header_slot(ctx){let div;let toolbar;let current;toolbar=new Toolbar({props:{$$slots:{default:[create_default_slot_2$2]},$$scope:{ctx}}});return{c(){div=pintura_element("div");create_component(toolbar.$$.fragment);attr(div,"slot","header");},m(target,anchor){insert(target,div,anchor);mount_component(toolbar,div,null);current=true;},p(ctx,dirty){const toolbar_changes={};if(dirty[0]&/*tools*/1|dirty[6]&/*$$scope*/64){toolbar_changes.$$scope={dirty,ctx};}toolbar.$set(toolbar_changes);},i(local){if(current)return;transition_in(toolbar.$$.fragment,local);current=true;},o(local){transition_out(toolbar.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(toolbar);}};}// (1452:12) {#if shouldRenderImageSelection && shouldRenderImageSelectionRecenterButton}
function create_if_block_5$2(ctx){let button;let current;button=new Button({props:{onclick:/*handleRecenterAction*/ctx[80],label:/*locale*/ctx[4].cropLabelButtonRecenter,icon:/*locale*/ctx[4].cropIconButtonRecenter,class:"PinturaButtonCenter",disabled:!/*canCenter*/ctx[10],hideLabel:true,style:`opacity: ${/*$recenterOpacity*/ctx[27]}; transform: translate3d(${/*$recenterOffset*/ctx[28].x}px, ${/*$recenterOffset*/ctx[28].y}px, 0)`}});return{c(){create_component(button.$$.fragment);},m(target,anchor){mount_component(button,target,anchor);current=true;},p(ctx,dirty){const button_changes={};if(dirty[0]&/*locale*/16)button_changes.label=/*locale*/ctx[4].cropLabelButtonRecenter;if(dirty[0]&/*locale*/16)button_changes.icon=/*locale*/ctx[4].cropIconButtonRecenter;if(dirty[0]&/*canCenter*/1024)button_changes.disabled=!/*canCenter*/ctx[10];if(dirty[0]&/*$recenterOpacity, $recenterOffset*/402653184)button_changes.style=`opacity: ${/*$recenterOpacity*/ctx[27]}; transform: translate3d(${/*$recenterOffset*/ctx[28].x}px, ${/*$recenterOffset*/ctx[28].y}px, 0)`;button.$set(button_changes);},i(local){if(current)return;transition_in(button.$$.fragment,local);current=true;},o(local){transition_out(button.$$.fragment,local);current=false;},d(detaching){destroy_component(button,detaching);}};}// (1464:12) {#if shouldRenderImageSelection}
function create_if_block_4$2(ctx){let rectmanipulator;let current;rectmanipulator=new RectManipulator({props:{rect:/*imageSelectionRectOffset*/ctx[11],visible:/*$isActive*/ctx[9],style:/*cropImageSelectionCornerStyle*/ctx[2]}});rectmanipulator.$on("resizestart",/*handleSelectionGrab*/ctx[60]);rectmanipulator.$on("resizemove",/*handleSelectionDrag*/ctx[61]);rectmanipulator.$on("resizeend",/*handleSelectionRelease*/ctx[62]);return{c(){create_component(rectmanipulator.$$.fragment);},m(target,anchor){mount_component(rectmanipulator,target,anchor);current=true;},p(ctx,dirty){const rectmanipulator_changes={};if(dirty[0]&/*imageSelectionRectOffset*/2048)rectmanipulator_changes.rect=/*imageSelectionRectOffset*/ctx[11];if(dirty[0]&/*$isActive*/512)rectmanipulator_changes.visible=/*$isActive*/ctx[9];if(dirty[0]&/*cropImageSelectionCornerStyle*/4)rectmanipulator_changes.style=/*cropImageSelectionCornerStyle*/ctx[2];rectmanipulator.$set(rectmanipulator_changes);},i(local){if(current)return;transition_in(rectmanipulator.$$.fragment,local);current=true;},o(local){transition_out(rectmanipulator.$$.fragment,local);current=false;},d(detaching){destroy_component(rectmanipulator,detaching);}};}// (1477:8) {#if shouldRenderInfoIndicator}
function create_if_block_3$2(ctx){let imageinfo;let current;imageinfo=new ImageInfo({props:{width:Math.round(/*$imageCropRect*/ctx[7].width),height:Math.round(/*$imageCropRect*/ctx[7].height)}});return{c(){create_component(imageinfo.$$.fragment);},m(target,anchor){mount_component(imageinfo,target,anchor);current=true;},p(ctx,dirty){const imageinfo_changes={};if(dirty[0]&/*$imageCropRect*/128)imageinfo_changes.width=Math.round(/*$imageCropRect*/ctx[7].width);if(dirty[0]&/*$imageCropRect*/128)imageinfo_changes.height=Math.round(/*$imageCropRect*/ctx[7].height);imageinfo.$set(imageinfo_changes);},i(local){if(current)return;transition_in(imageinfo.$$.fragment,local);current=true;},o(local){transition_out(imageinfo.$$.fragment,local);current=false;},d(detaching){destroy_component(imageinfo,detaching);}};}// (1429:4) 
function create_main_slot$1(ctx){let div1;let div0;let t0;let interactable_action;let t1;let current;let mounted;let dispose;let if_block0=/*shouldRenderImageSelection*/ctx[17]&&/*shouldRenderImageSelectionRecenterButton*/ctx[18]&&create_if_block_5$2(ctx);let if_block1=/*shouldRenderImageSelection*/ctx[17]&&create_if_block_4$2(ctx);let if_block2=/*shouldRenderInfoIndicator*/ctx[16]&&create_if_block_3$2(ctx);return{c(){div1=pintura_element("div");div0=pintura_element("div");if(if_block0)if_block0.c();t0=space();if(if_block1)if_block1.c();t1=space();if(if_block2)if_block2.c();attr(div0,"class","PinturaStage");attr(div1,"slot","main");},m(target,anchor){insert(target,div1,anchor);append(div1,div0);if(if_block0)if_block0.m(div0,null);append(div0,t0);if(if_block1)if_block1.m(div0,null);/*div0_binding*/ctx[145](div0);append(div1,t1);if(if_block2)if_block2.m(div1,null);current=true;if(!mounted){dispose=[listen(div0,"measure",/*measure_handler_1*/ctx[143]),action_destroyer(measurable.call(null,div0)),listen(div0,"wheel",function(){if(is_function(/*cropEnableZoom*/ctx[3]&&/*handleWheel*/ctx[79]))(/*cropEnableZoom*/ctx[3]&&/*handleWheel*/ctx[79]).apply(this,arguments);},{passive:false}),listen(div0,"interactionstart",/*handleImageDragStart*/ctx[66]),listen(div0,"interactionupdate",/*handleImageDrag*/ctx[67]),listen(div0,"interactionrelease",/*handleImageDragRelease*/ctx[69]),listen(div0,"interactionend",/*handleImageDragEnd*/ctx[68]),action_destroyer(interactable_action=interactable.call(null,div0,{drag:true,pinch:/*cropEnableZoom*/ctx[3],inertia:true,matchTarget:true,getEventPosition:/*interactable_function*/ctx[146]})),listen(div0,"gesturedown",/*handleGestureStart*/ctx[76]),listen(div0,"gestureupdate",/*handleGestureUpdate*/ctx[77]),listen(div0,"gestureup",/*handleGestureEnd*/ctx[78]),action_destroyer(gesturable.call(null,div0))];mounted=true;}},p(new_ctx,dirty){ctx=new_ctx;if(/*shouldRenderImageSelection*/ctx[17]&&/*shouldRenderImageSelectionRecenterButton*/ctx[18]){if(if_block0){if_block0.p(ctx,dirty);if(dirty[0]&/*shouldRenderImageSelection, shouldRenderImageSelectionRecenterButton*/393216){transition_in(if_block0,1);}}else{if_block0=create_if_block_5$2(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(div0,t0);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}if(/*shouldRenderImageSelection*/ctx[17]){if(if_block1){if_block1.p(ctx,dirty);if(dirty[0]&/*shouldRenderImageSelection*/131072){transition_in(if_block1,1);}}else{if_block1=create_if_block_4$2(ctx);if_block1.c();transition_in(if_block1,1);if_block1.m(div0,null);}}else if(if_block1){group_outros();transition_out(if_block1,1,1,()=>{if_block1=null;});check_outros();}if(interactable_action&&is_function(interactable_action.update)&&dirty[0]&/*cropEnableZoom, $rootRect*/32776)interactable_action.update.call(null,{drag:true,pinch:/*cropEnableZoom*/ctx[3],inertia:true,matchTarget:true,getEventPosition:/*interactable_function*/ctx[146]});if(/*shouldRenderInfoIndicator*/ctx[16]){if(if_block2){if_block2.p(ctx,dirty);if(dirty[0]&/*shouldRenderInfoIndicator*/65536){transition_in(if_block2,1);}}else{if_block2=create_if_block_3$2(ctx);if_block2.c();transition_in(if_block2,1);if_block2.m(div1,null);}}else if(if_block2){group_outros();transition_out(if_block2,1,1,()=>{if_block2=null;});check_outros();}},i(local){if(current)return;transition_in(if_block0);transition_in(if_block1);transition_in(if_block2);current=true;},o(local){transition_out(if_block0);transition_out(if_block1);transition_out(if_block2);current=false;},d(detaching){if(detaching)detach(div1);if(if_block0)if_block0.d();if(if_block1)if_block1.d();/*div0_binding*/ctx[145](null);if(if_block2)if_block2.d();mounted=false;run_all(dispose);}};}// (1485:8) {#if shouldRenderFooter}
function create_if_block$4(ctx){let tablist;let t;let tabpanels;let current;const tablist_spread_levels=[{class:"PinturaControlList"},{tabs:/*tabs*/ctx[12]},/*tabsConfig*/ctx[21]];let tablist_props={$$slots:{default:[create_default_slot_1$3,({tab})=>({191:tab}),({tab})=>[0,0,0,0,0,0,tab?32:0]]},$$scope:{ctx}};for(let i=0;i<tablist_spread_levels.length;i+=1){tablist_props=pintura_assign(tablist_props,tablist_spread_levels[i]);}tablist=new TabList({props:tablist_props});tablist.$on("select",/*select_handler*/ctx[144]);const tabpanels_spread_levels=[{class:"PinturaControlPanels"},{panelClass:"PinturaControlPanel"},{panels:/*panels*/ctx[22]},/*tabsConfig*/ctx[21]];let tabpanels_props={$$slots:{default:[create_default_slot$9,({panel})=>({190:panel}),({panel})=>[0,0,0,0,0,0,panel?16:0]]},$$scope:{ctx}};for(let i=0;i<tabpanels_spread_levels.length;i+=1){tabpanels_props=pintura_assign(tabpanels_props,tabpanels_spread_levels[i]);}tabpanels=new TabPanels({props:tabpanels_props});return{c(){create_component(tablist.$$.fragment);t=space();create_component(tabpanels.$$.fragment);},m(target,anchor){mount_component(tablist,target,anchor);insert(target,t,anchor);mount_component(tabpanels,target,anchor);current=true;},p(ctx,dirty){const tablist_changes=dirty[0]&/*tabs, tabsConfig*/2101248?get_spread_update(tablist_spread_levels,[tablist_spread_levels[0],dirty[0]&/*tabs*/4096&&{tabs:/*tabs*/ctx[12]},dirty[0]&/*tabsConfig*/2097152&&get_spread_object(/*tabsConfig*/ctx[21])]):{};if(dirty[6]&/*$$scope, tab*/96){tablist_changes.$$scope={dirty,ctx};}tablist.$set(tablist_changes);const tabpanels_changes=dirty[0]&/*panels, tabsConfig*/6291456?get_spread_update(tabpanels_spread_levels,[tabpanels_spread_levels[0],tabpanels_spread_levels[1],dirty[0]&/*panels*/4194304&&{panels:/*panels*/ctx[22]},dirty[0]&/*tabsConfig*/2097152&&get_spread_object(/*tabsConfig*/ctx[21])]):{};if(dirty[0]&/*$imageRotation, locale, $imageRotationRange, imageZoomLevelMin, $imageZoomLevelRange, $imageZoomLevel*/117457168|dirty[6]&/*$$scope, panel*/80){tabpanels_changes.$$scope={dirty,ctx};}tabpanels.$set(tabpanels_changes);},i(local){if(current)return;transition_in(tablist.$$.fragment,local);transition_in(tabpanels.$$.fragment,local);current=true;},o(local){transition_out(tablist.$$.fragment,local);transition_out(tabpanels.$$.fragment,local);current=false;},d(detaching){destroy_component(tablist,detaching);if(detaching)detach(t);destroy_component(tabpanels,detaching);}};}// (1486:12) <TabList                 class="PinturaControlList"                 {tabs}                 {...tabsConfig}                 on:select={({ detail }) => (transformSelected = detail)}                 let:tab             >
function create_default_slot_1$3(ctx){let span;let t_value=/*tab*/ctx[191].label+"";let t;return{c(){span=pintura_element("span");t=pintura_text(t_value);},m(target,anchor){insert(target,span,anchor);append(span,t);},p(ctx,dirty){if(dirty[6]&/*tab*/32&&t_value!==(t_value=/*tab*/ctx[191].label+""))set_data(t,t_value);},d(detaching){if(detaching)detach(span);}};}// (1514:59) 
function create_if_block_2$3(ctx){let rangeinput;let current;rangeinput=new RangeInput({props:{elasticity:/*elasticityMultiplier*/ctx[35]*/*rangeInputElasticity*/ctx[36],base:imageZoomLevelBase,min:/*imageZoomLevelMin*/ctx[14],max:imageZoomLevelMax,valueMin:/*$imageZoomLevelRange*/ctx[25][0],valueMax:/*$imageZoomLevelRange*/ctx[25][1],value:/*$imageZoomLevel*/ctx[26],labelReset:/*locale*/ctx[4].labelReset,valueLabel:`${Math.round(/*$imageZoomLevel*/ctx[26]*100)}%`,oninputstart:/*handleResizeStart*/ctx[73],oninputmove:/*handleResizeMove*/ctx[74],oninputend:/*handleResizeEnd*/ctx[75]}});return{c(){create_component(rangeinput.$$.fragment);},m(target,anchor){mount_component(rangeinput,target,anchor);current=true;},p(ctx,dirty){const rangeinput_changes={};if(dirty[0]&/*imageZoomLevelMin*/16384)rangeinput_changes.min=/*imageZoomLevelMin*/ctx[14];if(dirty[0]&/*$imageZoomLevelRange*/33554432)rangeinput_changes.valueMin=/*$imageZoomLevelRange*/ctx[25][0];if(dirty[0]&/*$imageZoomLevelRange*/33554432)rangeinput_changes.valueMax=/*$imageZoomLevelRange*/ctx[25][1];if(dirty[0]&/*$imageZoomLevel*/67108864)rangeinput_changes.value=/*$imageZoomLevel*/ctx[26];if(dirty[0]&/*locale*/16)rangeinput_changes.labelReset=/*locale*/ctx[4].labelReset;if(dirty[0]&/*$imageZoomLevel*/67108864)rangeinput_changes.valueLabel=`${Math.round(/*$imageZoomLevel*/ctx[26]*100)}%`;rangeinput.$set(rangeinput_changes);},i(local){if(current)return;transition_in(rangeinput.$$.fragment,local);current=true;},o(local){transition_out(rangeinput.$$.fragment,local);current=false;},d(detaching){destroy_component(rangeinput,detaching);}};}// (1503:16) {#if panel === cropUniqueId + '-rotation'}
function create_if_block_1$4(ctx){let imagerotator;let current;imagerotator=new ImageRotator({props:{elasticity:/*elasticityMultiplier*/ctx[35]*/*rangeInputElasticity*/ctx[36],rotation:/*$imageRotation*/ctx[8],labelReset:/*locale*/ctx[4].labelReset,valueMin:/*$imageRotationRange*/ctx[24][0],valueMax:/*$imageRotationRange*/ctx[24][1],oninputstart:/*handleRotateStart*/ctx[63],oninputmove:/*handleRotateMove*/ctx[64],oninputend:/*handleRotateEnd*/ctx[65]}});return{c(){create_component(imagerotator.$$.fragment);},m(target,anchor){mount_component(imagerotator,target,anchor);current=true;},p(ctx,dirty){const imagerotator_changes={};if(dirty[0]&/*$imageRotation*/256)imagerotator_changes.rotation=/*$imageRotation*/ctx[8];if(dirty[0]&/*locale*/16)imagerotator_changes.labelReset=/*locale*/ctx[4].labelReset;if(dirty[0]&/*$imageRotationRange*/16777216)imagerotator_changes.valueMin=/*$imageRotationRange*/ctx[24][0];if(dirty[0]&/*$imageRotationRange*/16777216)imagerotator_changes.valueMax=/*$imageRotationRange*/ctx[24][1];imagerotator.$set(imagerotator_changes);},i(local){if(current)return;transition_in(imagerotator.$$.fragment,local);current=true;},o(local){transition_out(imagerotator.$$.fragment,local);current=false;},d(detaching){destroy_component(imagerotator,detaching);}};}// (1496:12) <TabPanels                 class="PinturaControlPanels"                 panelClass="PinturaControlPanel"                 {panels}                 {...tabsConfig}                 let:panel             >
function create_default_slot$9(ctx){let current_block_type_index;let if_block;let if_block_anchor;let current;const if_block_creators=[create_if_block_1$4,create_if_block_2$3];const if_blocks=[];function select_block_type(ctx,dirty){if(/*panel*/ctx[190]===/*cropUniqueId*/ctx[85]+"-rotation")return 0;if(/*panel*/ctx[190]===/*cropUniqueId*/ctx[85]+"-zoom")return 1;return-1;}if(~(current_block_type_index=select_block_type(ctx))){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);}return{c(){if(if_block)if_block.c();if_block_anchor=empty();},m(target,anchor){if(~current_block_type_index){if_blocks[current_block_type_index].m(target,anchor);}insert(target,if_block_anchor,anchor);current=true;},p(ctx,dirty){let previous_block_index=current_block_type_index;current_block_type_index=select_block_type(ctx);if(current_block_type_index===previous_block_index){if(~current_block_type_index){if_blocks[current_block_type_index].p(ctx,dirty);}}else{if(if_block){group_outros();transition_out(if_blocks[previous_block_index],1,1,()=>{if_blocks[previous_block_index]=null;});check_outros();}if(~current_block_type_index){if_block=if_blocks[current_block_type_index];if(!if_block){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);if_block.c();}else{if_block.p(ctx,dirty);}transition_in(if_block,1);if_block.m(if_block_anchor.parentNode,if_block_anchor);}else{if_block=null;}}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(~current_block_type_index){if_blocks[current_block_type_index].d(detaching);}if(detaching)detach(if_block_anchor);}};}// (1484:4) 
function create_footer_slot$5(ctx){let div;let current;let if_block=/*shouldRenderFooter*/ctx[20]&&create_if_block$4(ctx);return{c(){div=pintura_element("div");if(if_block)if_block.c();attr(div,"slot","footer");attr(div,"style",/*footerStyle*/ctx[23]);},m(target,anchor){insert(target,div,anchor);if(if_block)if_block.m(div,null);current=true;},p(ctx,dirty){if(/*shouldRenderFooter*/ctx[20]){if(if_block){if_block.p(ctx,dirty);if(dirty[0]&/*shouldRenderFooter*/1048576){transition_in(if_block,1);}}else{if_block=create_if_block$4(ctx);if_block.c();transition_in(if_block,1);if_block.m(div,null);}}else if(if_block){group_outros();transition_out(if_block,1,1,()=>{if_block=null;});check_outros();}if(!current||dirty[0]&/*footerStyle*/8388608){attr(div,"style",/*footerStyle*/ctx[23]);}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(detaching)detach(div);if(if_block)if_block.d();}};}function create_fragment$k(ctx){let util;let updating_root;let current;function util_root_binding(value){/*util_root_binding*/ctx[147](value);}let util_props={hasHeader:/*shouldRenderToolbar*/ctx[19],$$slots:{footer:[create_footer_slot$5],main:[create_main_slot$1],header:[create_header_slot]},$$scope:{ctx}};if(/*root*/ctx[13]!==void 0){util_props.root=/*root*/ctx[13];}util=new Util({props:util_props});binding_callbacks.push(()=>bind(util,"root",util_root_binding));util.$on("measure",/*measure_handler*/ctx[148]);return{c(){create_component(util.$$.fragment);},m(target,anchor){mount_component(util,target,anchor);current=true;},p(ctx,dirty){const util_changes={};if(dirty[0]&/*shouldRenderToolbar*/524288)util_changes.hasHeader=/*shouldRenderToolbar*/ctx[19];if(dirty[0]&/*footerStyle, panels, tabsConfig, $imageRotation, locale, $imageRotationRange, imageZoomLevelMin, $imageZoomLevelRange, $imageZoomLevel, tabs, transformSelected, shouldRenderFooter, $imageCropRect, shouldRenderInfoIndicator, stageRef, cropEnableZoom, $rootRect, imageSelectionRectOffset, $isActive, cropImageSelectionCornerStyle, shouldRenderImageSelection, canCenter, $recenterOpacity, $recenterOffset, shouldRenderImageSelectionRecenterButton, tools*/536338429|dirty[6]&/*$$scope*/64){util_changes.$$scope={dirty,ctx};}if(!updating_root&&dirty[0]&/*root*/8192){updating_root=true;util_changes.root=/*root*/ctx[13];add_flush_callback(()=>updating_root=false);}util.$set(util_changes);},i(local){if(current)return;transition_in(util.$$.fragment,local);current=true;},o(local){transition_out(util.$$.fragment,local);current=false;},d(detaching){destroy_component(util,detaching);}};}const imageZoomLevelMax=1;const imageZoomLevelBase=0;function instance$k($$self,$$props,$$invalidate){let imageZoomLevelMin;let imageSelectionOffset;let imageSelectionCenter;let imageSelectionCenteredRect;let isImageSelectionDisplayed;let isImageSelectionCentered;let isResizingSelection;let isMaxSelectionRect;let isOverlayMode;let canZoomToCenter;let canCenter;let shouldRenderInfoIndicator;let shouldRenderImageSelection;let shouldRenderImageSelectionRecenterButton;let imageSelectionRectOffset;let hasPlentyVerticalSpace;let shouldRenderPresetSelect;let shouldRenderToolbar;let couldRenderZoomInput;let shouldRenderZoomInput;let shouldRenderFooter;let tabsConfig;let tabs;let panels;let footerStyle;let $imageCropAspectRatio;let $imageCropRect;let $imageSize;let $imageRotation;let $imageFlipY;let $imageFlipX;let $selectedPresetIndex;let $imageOutputSize;let $imageCropMinSize;let $imageCropLimitToImage;let $env;let $isActive,$$unsubscribe_isActive=pintura_noop,$$subscribe_isActive=()=>($$unsubscribe_isActive(),$$unsubscribe_isActive=subscribe(isActive,$$value=>$$invalidate(9,$isActive=$$value)),isActive);let $isInteracting;let $imageSelectionRectSnapshot;let $imageSelectionRect;let $presentationScalar;let $imageCropMaxSize;let $imageSelectionRectIntent;let $utilRect;let $imageCropRectOrigin;let $imageCropRectIntent;let $imageCropRange;let $rootRect;let $stageRect;let $imageCropRangeAspectRatio;let $imageSelectionRectPresentation;let $imageScalar;let $framePadded;let $imagePreviewModifiers;let $imageOverlayMarkup;let $imageSelectionGuides;let $animation;let $footerOffset;let $imageRotationRange;let $imageZoomLevelRange;let $imageZoomLevel;let $recenterOpacity;let $recenterOffset;$$self.$$.on_destroy.push(()=>$$unsubscribe_isActive());const name="crop";let{isActive}=$$props;$$subscribe_isActive();let{stores}=$$props;let{cropImageSelectionCornerStyle="circle"}=$$props;// 'circle', 'hook', 'invisible'
let{cropWillRenderImageSelectionGuides=(interaction,interactionFraction)=>{const isRotating=interaction=="rotate";return{rows:isRotating?5:3,cols:isRotating?5:3,opacity:interactionFraction*0.25};}}=$$props;let{cropAutoCenterImageSelectionTimeout=undefined}=$$props;let{cropEnableZoomMatchImageAspectRatio=true}=$$props;let{cropEnableRotateMatchImageAspectRatio="never"}=$$props;// 'always' | 'custom' | 'never'
let{cropEnableRotationInput=true}=$$props;let{cropEnableZoom=true}=$$props;let{cropEnableZoomInput=true}=$$props;let{cropEnableZoomAutoHide=true}=$$props;let{cropEnableImageSelection=true}=$$props;let{cropEnableInfoIndicator=false}=$$props;let{cropEnableZoomTowardsWheelPosition=true}=$$props;let{cropEnableLimitWheelInputToCropSelection=true}=$$props;let{cropEnableCenterImageSelection=true}=$$props;let{cropEnableButtonRotateLeft=true}=$$props;let{cropEnableButtonRotateRight=false}=$$props;let{cropEnableButtonFlipHorizontal=true}=$$props;let{cropEnableButtonFlipVertical=false}=$$props;let{cropSelectPresetOptions=undefined}=$$props;let{cropEnableSelectPreset=true}=$$props;let{cropEnableButtonToggleCropLimit=false}=$$props;let{cropWillRenderTools=passthrough}=$$props;let{locale={}}=$$props;let{tools=[]}=$$props;// state
let interaction="idle";// helpers
const isCustomCrop=()=>$imageCropAspectRatio===undefined;const turnAspectRatio=aspectRatio=>1/aspectRatio;const hasValidRotatedCropAspectRatio=()=>{if($imageCropAspectRatio===1)return false;const rotatedImageCropAspectRatio=turnAspectRatio($imageCropAspectRatio);// no options available, forced crop aspect ratio
if(!cropSelectPresetOptions)return false;// options available but no valid option in list
if(!flattenOptions(cropSelectPresetOptions).find(([aspectRatio])=>aspectRatio===rotatedImageCropAspectRatio))return false;return true;};const isCropMaxSize=(imageCropRect,imageSize,imageRotation)=>isRotatedSideways(imageRotation)?imageSize.width===Math.round(imageCropRect.height)||imageSize.height===Math.round(imageCropRect.width):imageSize.width===Math.round(imageCropRect.width)||imageSize.height===Math.round(imageCropRect.height);const isCropCentered=(imageCropRect,imageSize,imageRotation)=>{const imageSizeRotated=sizeApply(sizeRotate(sizeClone(imageSize),imageRotation),v=>Math.abs(Math.round(v)));const imageCenter=sizeCenter(imageSizeRotated);const cropCenter=rectCenter(imageCropRect);return vectorEqual(imageCenter,cropCenter);};const canMatchCropAspectRatioToRotation=()=>// is custom crop mode
(isCustomCrop()||// can match preset crop and preset is available
cropEnableRotateMatchImageAspectRatio==="always"&&hasValidRotatedCropAspectRatio())&&isCropCentered($imageCropRect,$imageSize,$imageRotation)&&isCropMaxSize($imageCropRect,$imageSize,$imageRotation);const applyRotation=value=>{if(cropEnableRotateMatchImageAspectRatio!=="never"&&canMatchCropAspectRatioToRotation()){set_store_value(imageRotation,$imageRotation+=value,$imageRotation);const isRotated=isRotatedSideways($imageRotation);const w=isRotated?$imageSize.height:$imageSize.width;const h=isRotated?$imageSize.width:$imageSize.height;set_store_value(imageCropRect,$imageCropRect=rectCreate(0,0,w,h),$imageCropRect);if(!isCustomCrop())set_store_value(imageCropAspectRatio,$imageCropAspectRatio=getAspectRatio(w,h),$imageCropAspectRatio);}else{set_store_value(imageRotation,$imageRotation+=value,$imageRotation);}};const{history,env,isInteracting,isInteractingFraction,rootRect,stageRect,utilRect,rootLineColor,animation,elasticityMultiplier,rangeInputElasticity,presentationScalar,// effect filtering
imagePreviewModifiers,imageOutlineOpacity,// crop selection
imageFlipX,imageFlipY,imageRotation,imageRotationRange,imageOutputSize,imageSelectionRect,imageSelectionRectSnapshot,imageSelectionRectIntent,imageSelectionRectPresentation,imageCropRectIntent,imageCropRectOrigin,imageCropRect,imageCropMinSize,imageCropMaxSize,imageCropRange,imageCropAspectRatio,imageCropRectAspectRatio,imageCropLimitToImage,imageSize,imageScalar,imageOverlayMarkup,framePadded}=stores;// the actual limited rectangle
// used to calculate rectangle while dragging
// can be used to set set intended rectangle
// readonly
component_subscribe($$self,env,value=>$$invalidate(118,$env=value));component_subscribe($$self,isInteracting,value=>$$invalidate(119,$isInteracting=value));component_subscribe($$self,rootRect,value=>$$invalidate(15,$rootRect=value));component_subscribe($$self,stageRect,value=>$$invalidate(124,$stageRect=value));component_subscribe($$self,utilRect,value=>$$invalidate(123,$utilRect=value));component_subscribe($$self,animation,value=>$$invalidate(141,$animation=value));component_subscribe($$self,presentationScalar,value=>$$invalidate(122,$presentationScalar=value));component_subscribe($$self,imagePreviewModifiers,value=>$$invalidate(136,$imagePreviewModifiers=value));component_subscribe($$self,imageFlipX,value=>$$invalidate(112,$imageFlipX=value));component_subscribe($$self,imageFlipY,value=>$$invalidate(111,$imageFlipY=value));component_subscribe($$self,imageRotation,value=>$$invalidate(8,$imageRotation=value));component_subscribe($$self,imageRotationRange,value=>$$invalidate(24,$imageRotationRange=value));component_subscribe($$self,imageOutputSize,value=>$$invalidate(159,$imageOutputSize=value));component_subscribe($$self,imageSelectionRect,value=>$$invalidate(121,$imageSelectionRect=value));component_subscribe($$self,imageSelectionRectSnapshot,value=>$$invalidate(120,$imageSelectionRectSnapshot=value));component_subscribe($$self,imageSelectionRectIntent,value=>$$invalidate(161,$imageSelectionRectIntent=value));component_subscribe($$self,imageSelectionRectPresentation,value=>$$invalidate(127,$imageSelectionRectPresentation=value));component_subscribe($$self,imageCropRectIntent,value=>$$invalidate(163,$imageCropRectIntent=value));component_subscribe($$self,imageCropRectOrigin,value=>$$invalidate(162,$imageCropRectOrigin=value));component_subscribe($$self,imageCropRect,value=>$$invalidate(7,$imageCropRect=value));component_subscribe($$self,imageCropMinSize,value=>$$invalidate(116,$imageCropMinSize=value));component_subscribe($$self,imageCropMaxSize,value=>$$invalidate(160,$imageCropMaxSize=value));component_subscribe($$self,imageCropRange,value=>$$invalidate(164,$imageCropRange=value));component_subscribe($$self,imageCropAspectRatio,value=>$$invalidate(158,$imageCropAspectRatio=value));component_subscribe($$self,imageCropLimitToImage,value=>$$invalidate(117,$imageCropLimitToImage=value));component_subscribe($$self,imageSize,value=>$$invalidate(110,$imageSize=value));component_subscribe($$self,imageScalar,value=>$$invalidate(134,$imageScalar=value));component_subscribe($$self,imageOverlayMarkup,value=>$$invalidate(166,$imageOverlayMarkup=value));component_subscribe($$self,framePadded,value=>$$invalidate(135,$framePadded=value));//
// resizing crop
//
let presentationScalarSnapshot;let imageSelectionRectMinSize;let imageSelectionRectMaxSize;const handleSelectionGrab=()=>{interaction="select";// now interacting
set_store_value(isInteracting,$isInteracting=true,$isInteracting);// we remember the current view rect and crop rect, because that is the crop rect we use as a starting point to transform while dragging
set_store_value(imageSelectionRectSnapshot,$imageSelectionRectSnapshot=rectClone($imageSelectionRect),$imageSelectionRectSnapshot);// remember current scalar so we can update min and max size correctly
presentationScalarSnapshot=$presentationScalar;imageSelectionRectMinSize=sizeScale(sizeClone($imageCropMinSize),presentationScalarSnapshot);imageSelectionRectMaxSize=sizeScale(sizeClone($imageCropMaxSize),presentationScalarSnapshot);};const handleSelectionDrag=({detail})=>{const{boundsLimited,boundsIntent}=translateSelection(detail.direction,detail.translation);// update actual image selection rectangle
set_store_value(imageSelectionRectIntent,$imageSelectionRectIntent=boundsIntent,$imageSelectionRectIntent);// intent needs to be updated first because has no listeners attached
set_store_value(imageSelectionRect,$imageSelectionRect=boundsLimited,$imageSelectionRect);};const handleSelectionRelease=({detail})=>{const{boundsLimited}=translateSelection(detail.direction,detail.translation);// we're no longer interacting with the image selection, we need to set this here so the image selection presentation is animated when applying the new bounds below
set_store_value(isInteracting,$isInteracting=false,$isInteracting);// no more intent as we're finalizing the selection, so before setting the final selection, we set this to undefined | intent needs to be updated first because has no listeners attached
set_store_value(imageSelectionRectIntent,$imageSelectionRectIntent=undefined,$imageSelectionRectIntent);// confirm the limited rect if actually made a change
if(vectorLength(detail.translation)){set_store_value(imageSelectionRect,$imageSelectionRect=boundsLimited,$imageSelectionRect);history.write();}// need to set this to undefined after setting the final rect, the snapshot is used to calculate the crop rect transform
set_store_value(imageSelectionRectSnapshot,$imageSelectionRectSnapshot=undefined,$imageSelectionRectSnapshot);// done interacting with selection
interaction=undefined;};const translateSelection=(target,translate)=>{// - selection may grow to max bounds (util bounds)
// - the image preview(!) is scaled to fit the selection, actual image size is not affected
// - we need to make sure the selection adheres to the aspect ratio of the min size
const directionTranslation={target,translate};let rectIntended=applyRectDirectionTranslation($imageSelectionRectSnapshot,directionTranslation,{aspectRatio:$imageCropAspectRatio});let cropAspectRatioLimited;// size in crop rect
const cropSize=sizeCreateFromRect(rectDivide(rectClone(rectIntended),$presentationScalar));getImagePolygon($imageSize,$imageRotation);// if one of the edges is small and not both are smaller we need to correct
if(cropSize.width<$imageCropMinSize.width||cropSize.height<$imageCropMinSize.height){// if moving towards the center of the crop, it can't exceed bounds
const translateUp=translate.y<0;const translateRight=translate.x>0;const translateLeft=translate.x<0;const translateDown=translate.y>0;const couldExceedBounds=target==="t"&&translateUp||target==="r"&&translateRight||target==="b"&&translateDown||target==="l"&&translateLeft||target==="tr"&&(translateRight||translateUp)||target==="tl"&&(translateLeft||translateUp)||target==="br"&&(translateRight||translateDown)||target==="bl"&&(translateLeft||translateDown);// need the aspect ratio of the crop to determine if it violates min size
const cropAspectRatio=rectAspectRatio(cropSize);// find the maximum size for the current aspect ratio
const cropSizeMax=getMaxSizeInRect($imageSize,$imageRotation,cropAspectRatio);if(couldExceedBounds&&(cropSizeMax.width<$imageCropMinSize.width||cropSizeMax.height<$imageCropMinSize.height)){if($imageRotation!==0){const sign=Math.sign($imageRotation);const turns=Math.round(Math.abs($imageRotation)/HALF_PI)*HALF_PI;const value=$imageRotation-sign*turns;const imageIsRotated=turns/HALF_PI%2===1;const imageWidth=imageIsRotated?$imageSize.height:$imageSize.width;const imageHeight=imageIsRotated?$imageSize.width:$imageSize.height;const r=Math.abs(value);const sin=Math.sin(r);const cos=Math.cos(r);if(cropSize.width<$imageCropMinSize.width){// width doesn't fit, let's limit the width to the min size
cropSize.width=$imageCropMinSize.width;// And now calculate the height
//  - rotation = .15
//  - image size = 384 x 288
//  - crop size width = 200
// height = 288 - (Math.sin(.15) * 200) / Math.cos(.15)
const w=cos*cropSize.width+sin*cropSize.height;const h=sin*cropSize.width+cos*cropSize.height;const dx=imageWidth-w;const dy=imageHeight-h;if(dx<dy){cropSize.height=(imageWidth-cos*cropSize.width)/sin;}else if(dy<dx){cropSize.height=(imageHeight-sin*cropSize.width)/cos;}}if(cropSize.height<$imageCropMinSize.height){// height doesn't fit, let's limit the height to the min size
cropSize.height=$imageCropMinSize.height;// And now calculate the width
//  - rotation = .15
//  - image size = 384 x 288
//  - crop size height = 200
const w=cos*cropSize.width+sin*cropSize.height;const h=sin*cropSize.width+cos*cropSize.height;const dx=imageWidth-w;const dy=imageHeight-h;if(dx<dy){// (384 - (Math.sin(.15) * 250)) / Math.cos(.15)
cropSize.width=(imageWidth-sin*cropSize.height)/cos;}else if(dy<dx){// (288 - (Math.cos(.15) * 250)) / Math.sin(.15)
cropSize.width=(imageHeight-cos*cropSize.height)/sin;}}}else{if(cropSize.width<$imageCropMinSize.width){cropSize.width=$imageCropMinSize.width;cropSize.height=$imageSize.height;}if(cropSize.height<$imageCropMinSize.height){cropSize.height=$imageCropMinSize.height;cropSize.width=$imageSize.width;}}// we now have a corrected size, let's calculate the new aspect ratio and use that to limit the translation
cropAspectRatioLimited=rectAspectRatio(cropSize);}}if(cropAspectRatioLimited){rectIntended=applyRectDirectionTranslation($imageSelectionRectSnapshot,directionTranslation,{aspectRatio:cropAspectRatioLimited||$imageCropAspectRatio});}let rectLimited=limitRectDirectionTranslation($imageSelectionRectSnapshot,directionTranslation,$utilRect,{aspectRatio:$imageCropAspectRatio||cropAspectRatioLimited,minSize:imageSelectionRectMinSize,maxSize:imageSelectionRectMaxSize});return{boundsLimited:rectLimited,boundsIntent:rectIntended};};//
// rotating
//
const handleRotateStart=()=>{interaction="rotate";// now interacting with view
set_store_value(isInteracting,$isInteracting=true,$isInteracting);// we need to know the origin of the crop so we can "shrink" the image to fit the crop rect while rotating
set_store_value(imageCropRectOrigin,$imageCropRectOrigin=rectClone($imageCropRect),$imageCropRectOrigin);};const handleRotateMove=value=>{set_store_value(imageRotation,$imageRotation=value,$imageRotation);// will auto validate
};const handleRotateEnd=value=>{// we're done interacting
set_store_value(isInteracting,$isInteracting=false,$isInteracting);// apply our final rotation value
set_store_value(imageRotation,$imageRotation=value,$imageRotation);history.write();// done, so we no longer need to "shrink" the image
set_store_value(imageCropRectOrigin,$imageCropRectOrigin=undefined,$imageCropRectOrigin);};//
// moving
//
let interactionCropRect=undefined;let interactionCropRectForce=undefined;const handleImageDragStart=()=>{interaction="pan";interactionCropRectForce=undefined;set_store_value(isInteracting,$isInteracting=true,$isInteracting);interactionCropRect=rectClone($imageCropRect);};const handleImageDrag=({detail})=>manipulateImage(detail);const handleImageDragEnd=({detail})=>{// done interacting
set_store_value(isInteracting,$isInteracting=false,$isInteracting);// apply translation to the crop rect only if did make changes
if(vectorLength(detail.translation)>0||detail.scalar!==0){manipulateImage(detail);history.write();}// no intent (needs to be set before crop rect is updated)
set_store_value(imageCropRectIntent,$imageCropRectIntent=undefined,$imageCropRectIntent);// now done
interactionCropRect=undefined;};const handleImageDragRelease=({detail})=>{interactionCropRectForce=detail.translation;set_store_value(isInteracting,$isInteracting=false,$isInteracting);};const manipulateImage=({translation,scalar})=>{const imageSelectionRectZoomFactor=Math.min($imageSelectionRect.width/$imageCropRect.width,$imageSelectionRect.height/$imageCropRect.height);const scaledTranslation=vectorMultiply(vectorClone(translation),1/imageSelectionRectZoomFactor);// while we're interacting we apply changes to the original crop rectangle, after we apply a force
let cropIntent;if(!interactionCropRectForce){cropIntent=rectTranslate(rectClone(interactionCropRect),vectorInvert(vectorClone(scaledTranslation)));if(scalar!==undefined){rectScale(cropIntent,1/scalar);}// rectScale(cropIntent, scalar);
}else{// we apply the force to the existing crop rect so animation is not borked
const forceTranslation=vectorSubtract(vectorClone(interactionCropRectForce),translation);interactionCropRectForce=translation;cropIntent=rectTranslate(rectClone($imageCropRect),forceTranslation);}// update crop rect
set_store_value(imageCropRectIntent,$imageCropRectIntent=cropIntent,$imageCropRectIntent);// auto calculates an elastic effect if bounds exceeded (needs to be set before crop rect is updated)
set_store_value(imageCropRect,$imageCropRect=cropIntent,$imageCropRect);// auto limits to bounds if needed
};//
// resizing with range input
//
const calculateZoomLevel=(imageSize,size,imageRotation)=>{if(isRotatedSideways(imageRotation)){return 1-1/Math.min(imageSize.height/size.width,imageSize.width/size.height);}return 1-1/Math.min(imageSize.width/size.width,imageSize.height/size.height);};const imageCropRangeAspectRatio=derived([imageCropRange,imageCropRect],([$imageCropRange,$imageCropRect],set)=>{if(!$imageCropRect)return;const[minSize,maxSize]=$imageCropRange;const aspectRatio=rectAspectRatio($imageCropRect);set([sizeCreateFromRect(rectApply(rectCoverRect(minSize,aspectRatio),fixPrecision)),sizeCreateFromRect(rectApply(rectContainRect(maxSize,aspectRatio),fixPrecision))]);});component_subscribe($$self,imageCropRangeAspectRatio,value=>$$invalidate(165,$imageCropRangeAspectRatio=value));// this is the max value range that can be set (triggers white range indicator bar)
const imageZoomLevelRange=derived([imageSize,imageCropLimitToImage,imageCropMinSize,imageCropMaxSize,imageCropRange,imageRotation],([$imageSize,$imageCropLimitToImage,$imageCropMinSize,$imageCropMaxSize,$imageCropRange,$imageRotation],set)=>{if(!$imageSize)return;const rangeMinSize=$imageCropRange[0];const rangeMaxSize=$imageCropRange[1];let minZoom;let maxZoom;// can't zoom out
if($imageCropLimitToImage){minZoom=calculateZoomLevel($imageSize,rangeMaxSize,$imageRotation);maxZoom=Math.min(rangeMinSize.width/$imageCropMinSize.width,rangeMinSize.height/$imageCropMinSize.height);}else{maxZoom=1;minZoom=-1;}const range=[fixPrecision(minZoom),fixPrecision(maxZoom)];set(range);});component_subscribe($$self,imageZoomLevelRange,value=>$$invalidate(25,$imageZoomLevelRange=value));const imageZoomLevel=derived([imageSize,imageCropRect,imageCropRange,imageRotation],([$imageSize,$imageCropRect,$imageCropRange,$imageRotation],set)=>{// need to check if this value is set, could be that it's empty while loading a new image
if(!$imageSize||!$imageCropRect)return set(0);let z;const rangeMinSize=$imageCropRange[0];const rangeMaxSize=$imageCropRange[1];const currentCropWidth=$imageCropRect.width;const currentCropHeight=$imageCropRect.height;const currentCropAspectRatio=rectAspectRatio($imageCropRect);const imageRect=isRotatedSideways($imageRotation)?sizeCreate($imageSize.height,$imageSize.width):$imageSize;const imageCropMaxRect=rectContainRect(imageRect,currentCropAspectRatio);if(currentCropWidth<=imageCropMaxRect.width||currentCropHeight<=imageCropMaxRect.height){// zoomed in
const w=imageCropMaxRect.width-rangeMinSize.width;const h=imageCropMaxRect.height-rangeMinSize.height;// cannot zoom in
if(w===0||h===0){z=1;}else{z=1-Math.min((currentCropWidth-rangeMinSize.width)/w,(currentCropHeight-rangeMinSize.height)/h);}}else{// zoomed out
const w=rangeMaxSize.width-imageCropMaxRect.width;const h=rangeMaxSize.height-imageCropMaxRect.height;const r=rectContainRect({width:w,height:h},currentCropAspectRatio);z=-Math.min((currentCropWidth-imageCropMaxRect.width)/r.width,(currentCropHeight-imageCropMaxRect.height)/r.height);}set(z);});component_subscribe($$self,imageZoomLevel,value=>$$invalidate(26,$imageZoomLevel=value));const snapshotCropRect=()=>{interactionCropRect=rectClone($imageCropRect);};const resizeImage=zoom=>{const aspectRatio=rectAspectRatio(interactionCropRect);let targetWidth;let targetHeight;let r;const imageRect=isRotatedSideways($imageRotation)?sizeCreate($imageSize.height,$imageSize.width):$imageSize;const imageCropMaxRect=rectContainRect(imageRect,aspectRatio);if(zoom>=0){// zoom in
const rangeWidth=imageCropMaxRect.width-$imageCropRange[0].width;const rangeHeight=imageCropMaxRect.height-$imageCropRange[0].height;targetWidth=imageCropMaxRect.width-rangeWidth*zoom;targetHeight=imageCropMaxRect.height-rangeHeight*zoom;r=rectCoverRect({width:targetWidth,height:targetHeight},aspectRatio);}else{// zoom out
const rangeWidth=$imageCropRange[1].width-imageCropMaxRect.width;const rangeHeight=$imageCropRange[1].height-imageCropMaxRect.height;targetWidth=imageCropMaxRect.width+rangeWidth*-zoom;targetHeight=imageCropMaxRect.height+rangeHeight*-zoom;r=rectContainRect({width:targetWidth,height:targetHeight},aspectRatio);}targetWidth=r.width;targetHeight=r.height;const targetX=interactionCropRect.x+interactionCropRect.width*0.5-targetWidth*0.5;const targetY=interactionCropRect.y+interactionCropRect.height*0.5-targetHeight*0.5;set_store_value(imageCropRect,$imageCropRect={x:targetX,y:targetY,width:targetWidth,height:targetHeight},$imageCropRect);};const handleResizeStart=()=>{interaction="zoom";// now interacting with view
set_store_value(isInteracting,$isInteracting=true,$isInteracting);snapshotCropRect();};const handleResizeMove=value=>{// value range from 0 (no zoom) to 1 (100% zoom, 1x1 pixel)
resizeImage(value);};const handleResizeEnd=value=>{resizeImage(value);history.write();// we're done interacting
set_store_value(isInteracting,$isInteracting=false,$isInteracting);// now done
interactionCropRect=undefined;};//
// resizing with gesture (MacBook trackpad Safari)
//
let gestureOriginCropRect;const handleGestureStart=()=>{interaction="zoom";// don't handle gesture as we're already handling input with interactable
if(interactionCropRect)return;gestureOriginCropRect=rectClone($imageCropRect);// now interacting
set_store_value(isInteracting,$isInteracting=true,$isInteracting);};const handleGestureUpdate=({detail})=>{// don't handle gesture as we're already handling input with interactable
if(!gestureOriginCropRect)return;handleScaleGesture(detail);};const handleScaleGesture=scale=>{const cropIntent=rectScale(rectClone(gestureOriginCropRect),1/scale);set_store_value(imageCropRectIntent,$imageCropRectIntent=cropIntent,$imageCropRectIntent);set_store_value(imageCropRect,$imageCropRect=cropIntent,$imageCropRect);};const handleGestureEnd=({detail})=>{// don't handle gesture as we're already handling input with interactable
if(!gestureOriginCropRect)return;// now interacting
set_store_value(isInteracting,$isInteracting=false,$isInteracting);handleScaleGesture(detail);// no intent (needs to be set before crop rect is updated)
set_store_value(imageCropRectIntent,$imageCropRectIntent=undefined,$imageCropRectIntent);gestureOriginCropRect=undefined;history.write();};//
// resizing with wheel
//
let zoomHistoryTimeoutId;const handleWheel=e=>{const stageWheelPosition=getEventPositionInStage(e,$rootRect,$stageRect);// only block input if wheel is used within image rectangle
if(cropEnableLimitWheelInputToCropSelection&&!rectContainsPoint($imageSelectionRect,stageWheelPosition))return;interaction="zoom";// now interacting
set_store_value(isInteracting,$isInteracting=true,$isInteracting);// don't run default actions, prevent other actions from running
e.preventDefault();e.stopPropagation();// convert wheel delta to scalar
const delta=getWheelDelta(e);const scalar=1+delta/100;// get current crop rect
const currentCropRect=rectClone($imageCropRect);// if already zoomed in, block further zoom in instructions
const isMinSize=Math.min($imageCropRect.width/$imageCropMinSize.width,$imageCropRect.height/$imageCropMinSize.height)===1;// if is fully zoomed out and trying to zoom out more and crop shape is free, fit image aspect ratio
if(cropEnableZoomMatchImageAspectRatio&&$imageCropLimitToImage){const isAtMaxCropSize=isCropMaxSize($imageCropRect,$imageSize,$imageRotation);if(isCustomCrop()&&isAtMaxCropSize&&delta>0&&isImageSelectionCentered){set_store_value(isInteracting,$isInteracting=false,$isInteracting);const newCropRect=isRotatedSideways($imageRotation)?rectCreateFromSize({height:$imageSize.width,width:$imageSize.height}):rectCreateFromSize($imageSize);// no change, exit
if(rectEqual(currentCropRect,newCropRect))return;// if we were previously zooming in we need to clear the timeout to prevent two history entries
clearTimeout(zoomHistoryTimeoutId);// test if crop rect in history is same as new crop rect, this is possible when zooming in and out real quick
if(rectEqual(history.state.crop,newCropRect))return;// store new crop rect
set_store_value(imageCropRect,$imageCropRect=newCropRect,$imageCropRect);history.write();return;}}// by default when zooming, zoom from center of crop rectangle
let origin=rectCenter($imageCropRect);// when zooming in, zoom in on the part of the image below the mouse cursor
if(cropEnableZoomTowardsWheelPosition&&delta<0&&!isMinSize){const selectionOffset=vectorSubtract(vectorClone(stageWheelPosition),$imageSelectionRect);const imageSelectionScale=Math.min($imageSelectionRect.width/$imageCropRect.width,$imageSelectionRect.height/$imageCropRect.height);// if wheel is inside image selection rectangle (slightly expanded version), we zoom based on position in the rectangle, if not, we use the selection center
const expandedImageSelection=rectScale(rectClone($imageSelectionRect),1.1);origin=rectContainsPoint(expandedImageSelection,stageWheelPosition)?vectorAdd(rectClone($imageCropRect),vectorMultiply(selectionOffset,1/imageSelectionScale)):origin;}let newCropRect=rectScale(rectClone($imageCropRect),scalar,origin);// determin if is new crop rect exceeds min or max size, if so, limit
if(!sizeContains($imageCropRangeAspectRatio[1],newCropRect)){// exceeds max size, limit to max size and position at new crop rect center
newCropRect=rectCreateWithCenter(rectCenter(newCropRect),$imageCropRangeAspectRatio[1]);}if(!sizeContains(newCropRect,$imageCropRangeAspectRatio[0])){// exceeds min size, limit to min size and position at new crop rect center
newCropRect=rectCreateWithCenter(rectCenter(newCropRect),$imageCropRangeAspectRatio[0]);}// no change, exit
if(rectEqual(currentCropRect,newCropRect,fixPrecision)){set_store_value(isInteracting,$isInteracting=false,$isInteracting);return;}// attempt to update the rectangle, we use fixPrecision so the width and height are nice integers when at max zoom (this makes sure the `isMinSize` variable is set to true at this point)
set_store_value(imageCropRect,$imageCropRect=rectApply(newCropRect,v=>fixPrecision(v,5)),$imageCropRect);// done!
set_store_value(isInteracting,$isInteracting=false,$isInteracting);// write history timer
clearTimeout(zoomHistoryTimeoutId);zoomHistoryTimeoutId=setTimeout(()=>{history.write();},500);};//
// recenter
//
// the 'measure' event triggers the editor to center and scale up the crop
const dispatch=createEventDispatcher();const handleRecenterAction=()=>{dispatch("measure",rectClone($utilRect));};// auto recenter after timeout
let cropAutoCenterImageSelectionTimeoutId;// animations
const recenterOpacity=spring(0,{precision:0.0001});component_subscribe($$self,recenterOpacity,value=>$$invalidate(27,$recenterOpacity=value));const recenterOffset=spring();component_subscribe($$self,recenterOffset,value=>$$invalidate(28,$recenterOffset=value));//
// crop selection presets
//
const selectedPresetIndex=derived([imageCropAspectRatio,imageOutputSize],([$cropAspectRatio,$imageOutputSize],set)=>{if(!cropSelectPresetOptions)return;const options=flattenOptions(cropSelectPresetOptions);const matchedOptionValue=[...options].// to value
map(option=>option[0]).// sort sizes first
sort((a,b)=>{if(pintura_isArray(a[0])&&!pintura_isArray(b[0]))return 1;return-1;}).// match value
find(value=>{if(pintura_isArray(value)&&$imageOutputSize){// size + aspect ratio
const[width,height]=value;const outputSizeMatches=$imageOutputSize.width===width&&$imageOutputSize.height===height;const aspectRatioMatches=$cropAspectRatio===getAspectRatio(width,height);return outputSizeMatches&&aspectRatioMatches;}// aspect ratio
return value===$cropAspectRatio;});const index=options.// to value
map(option=>option[0]).// find index of matching value
findIndex(value=>pintura_isArray(value)?arrayEqual(value,matchedOptionValue):value===matchedOptionValue);set(index);});component_subscribe($$self,selectedPresetIndex,value=>$$invalidate(114,$selectedPresetIndex=value));const getAspectRatioBySelectedIndex=selectedIndex=>{if(!cropSelectPresetOptions||selectedIndex===-1)return;const selectedValue=flattenOptions(cropSelectPresetOptions)[selectedIndex][0];return!selectedValue?undefined:pintura_isArray(selectedValue)?getAspectRatio(selectedValue[0],selectedValue[1]):selectedValue;};//
// crop guides
//
const imageSelectionGuides=derived([rootLineColor,imageSelectionRectPresentation,isInteractingFraction],([$rootLineColor,$rect,$isInteractingFraction],set)=>{const{rows,cols,opacity}=cropWillRenderImageSelectionGuides(interaction,$isInteractingFraction);if(!$rect||opacity<=0)return set([]);const{x,y,width,height}=$rect;const w=width/cols;const h=height/rows;const shapes=[];// rows
for(let r=1;r<=rows-1;r++){const yo=y+h*r;shapes.push({id:`image-selection-guide-row-${r}`,points:[vectorCreate(x,yo),vectorCreate(x+width,yo)],opacity,strokeWidth:1,strokeColor:$rootLineColor});}// cols
for(let c=1;c<=cols-1;c++){const xo=x+w*c;shapes.push({id:`image-selection-guide-col-${c}`,points:[vectorCreate(xo,y),vectorCreate(xo,y+height)],opacity,strokeWidth:1,strokeColor:$rootLineColor});}set(shapes);});component_subscribe($$self,imageSelectionGuides,value=>$$invalidate(137,$imageSelectionGuides=value));const syncGuides=()=>{// remove existing guides
const overlayMarkup=$imageOverlayMarkup.filter(markup=>!/^image\-selection\-guide/.test(markup.id));if($isActive){set_store_value(imageOverlayMarkup,$imageOverlayMarkup=[...overlayMarkup,...$imageSelectionGuides],$imageOverlayMarkup);}else{set_store_value(imageOverlayMarkup,$imageOverlayMarkup=overlayMarkup,$imageOverlayMarkup);}};const cropUniqueId=`crop-${getUniqueId()}`;let transformInitial=cropEnableRotationInput?"rotation":"zoom";let transformToolInitial=cropUniqueId+"-"+transformInitial;let transformSelected=transformToolInitial;let root=undefined;// fixes rendering issue with stage being empty in overlay mode, this basically redispatches the measure event so the stage is correctly measured
let stageRef;const footerOffset=spring($animation?20:0);component_subscribe($$self,footerOffset,value=>$$invalidate(142,$footerOffset=value));function measure_handler_1(event){bubble($$self,event);}const select_handler=({detail})=>$$invalidate(5,transformSelected=detail);function div0_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{stageRef=$$value;$$invalidate(6,stageRef);});}const interactable_function=e=>getEventPositionInViewport(e);function util_root_binding(value){root=value;$$invalidate(13,root);}function measure_handler(event){bubble($$self,event);}$$self.$$set=$$props=>{if("isActive"in $$props)$$subscribe_isActive($$invalidate(1,isActive=$$props.isActive));if("stores"in $$props)$$invalidate(88,stores=$$props.stores);if("cropImageSelectionCornerStyle"in $$props)$$invalidate(2,cropImageSelectionCornerStyle=$$props.cropImageSelectionCornerStyle);if("cropWillRenderImageSelectionGuides"in $$props)$$invalidate(89,cropWillRenderImageSelectionGuides=$$props.cropWillRenderImageSelectionGuides);if("cropAutoCenterImageSelectionTimeout"in $$props)$$invalidate(90,cropAutoCenterImageSelectionTimeout=$$props.cropAutoCenterImageSelectionTimeout);if("cropEnableZoomMatchImageAspectRatio"in $$props)$$invalidate(91,cropEnableZoomMatchImageAspectRatio=$$props.cropEnableZoomMatchImageAspectRatio);if("cropEnableRotateMatchImageAspectRatio"in $$props)$$invalidate(92,cropEnableRotateMatchImageAspectRatio=$$props.cropEnableRotateMatchImageAspectRatio);if("cropEnableRotationInput"in $$props)$$invalidate(93,cropEnableRotationInput=$$props.cropEnableRotationInput);if("cropEnableZoom"in $$props)$$invalidate(3,cropEnableZoom=$$props.cropEnableZoom);if("cropEnableZoomInput"in $$props)$$invalidate(94,cropEnableZoomInput=$$props.cropEnableZoomInput);if("cropEnableZoomAutoHide"in $$props)$$invalidate(95,cropEnableZoomAutoHide=$$props.cropEnableZoomAutoHide);if("cropEnableImageSelection"in $$props)$$invalidate(96,cropEnableImageSelection=$$props.cropEnableImageSelection);if("cropEnableInfoIndicator"in $$props)$$invalidate(97,cropEnableInfoIndicator=$$props.cropEnableInfoIndicator);if("cropEnableZoomTowardsWheelPosition"in $$props)$$invalidate(98,cropEnableZoomTowardsWheelPosition=$$props.cropEnableZoomTowardsWheelPosition);if("cropEnableLimitWheelInputToCropSelection"in $$props)$$invalidate(99,cropEnableLimitWheelInputToCropSelection=$$props.cropEnableLimitWheelInputToCropSelection);if("cropEnableCenterImageSelection"in $$props)$$invalidate(100,cropEnableCenterImageSelection=$$props.cropEnableCenterImageSelection);if("cropEnableButtonRotateLeft"in $$props)$$invalidate(101,cropEnableButtonRotateLeft=$$props.cropEnableButtonRotateLeft);if("cropEnableButtonRotateRight"in $$props)$$invalidate(102,cropEnableButtonRotateRight=$$props.cropEnableButtonRotateRight);if("cropEnableButtonFlipHorizontal"in $$props)$$invalidate(103,cropEnableButtonFlipHorizontal=$$props.cropEnableButtonFlipHorizontal);if("cropEnableButtonFlipVertical"in $$props)$$invalidate(104,cropEnableButtonFlipVertical=$$props.cropEnableButtonFlipVertical);if("cropSelectPresetOptions"in $$props)$$invalidate(105,cropSelectPresetOptions=$$props.cropSelectPresetOptions);if("cropEnableSelectPreset"in $$props)$$invalidate(106,cropEnableSelectPreset=$$props.cropEnableSelectPreset);if("cropEnableButtonToggleCropLimit"in $$props)$$invalidate(107,cropEnableButtonToggleCropLimit=$$props.cropEnableButtonToggleCropLimit);if("cropWillRenderTools"in $$props)$$invalidate(108,cropWillRenderTools=$$props.cropWillRenderTools);if("locale"in $$props)$$invalidate(4,locale=$$props.locale);if("tools"in $$props)$$invalidate(0,tools=$$props.tools);};$$self.$$.update=()=>{if($$self.$$.dirty[3]&/*$env*/33554432){$$invalidate(132,isOverlayMode=$env.layoutMode==="overlay");}if($$self.$$.dirty[3]&/*cropEnableSelectPreset*/8192|$$self.$$.dirty[4]&/*isOverlayMode*/256){$$invalidate(113,shouldRenderPresetSelect=cropEnableSelectPreset&&!isOverlayMode);}if($$self.$$.dirty[3]&/*$utilRect, $imageSelectionRect*/1342177280){// determine if we can center the crop, if we can, show the crop center button
$$invalidate(128,imageSelectionCenteredRect=$utilRect&&$imageSelectionRect&&rectCenterRect($utilRect,$imageSelectionRect));}if($$self.$$.dirty[3]&/*$imageSelectionRect*/268435456|$$self.$$.dirty[4]&/*imageSelectionCenteredRect*/16){$$invalidate(129,isImageSelectionDisplayed=!!($imageSelectionRect&&imageSelectionCenteredRect));}if($$self.$$.dirty[3]&/*$imageSelectionRect*/268435456|$$self.$$.dirty[4]&/*isImageSelectionDisplayed, imageSelectionCenteredRect*/48){$$invalidate(115,isImageSelectionCentered=isImageSelectionDisplayed&&rectEqual($imageSelectionRect,imageSelectionCenteredRect,value=>fixPrecision(value,5)));}if($$self.$$.dirty[0]&/*locale, $imageRotation*/272|$$self.$$.dirty[3]&/*cropWillRenderTools, cropEnableButtonRotateLeft, cropEnableButtonRotateRight, cropEnableButtonFlipHorizontal, $imageFlipY, $imageFlipX, cropEnableButtonFlipVertical, shouldRenderPresetSelect, cropSelectPresetOptions, $selectedPresetIndex, isImageSelectionCentered, $imageSize, $imageCropMinSize, cropEnableButtonToggleCropLimit, $imageCropLimitToImage, $env*/67034880){$$invalidate(0,tools=cropWillRenderTools([cropEnableButtonRotateLeft&&["Button","rotate-left",{label:locale.cropLabelButtonRotateLeft,labelClass:"PinturaToolbarContentWide",icon:locale.cropIconButtonRotateLeft,onclick:()=>{applyRotation(-Math.PI/2);history.write();}}],cropEnableButtonRotateRight&&["Button","rotate-right",{label:locale.cropLabelButtonRotateRight,labelClass:"PinturaToolbarContentWide",icon:locale.cropIconButtonRotateRight,onclick:()=>{applyRotation(Math.PI/2);history.write();}}],cropEnableButtonFlipHorizontal&&["Button","flip-horizontal",{label:locale.cropLabelButtonFlipHorizontal,labelClass:"PinturaToolbarContentWide",icon:locale.cropIconButtonFlipHorizontal,onclick:()=>{if(isRotatedSideways($imageRotation)){set_store_value(imageFlipY,$imageFlipY=!$imageFlipY,$imageFlipY);}else{set_store_value(imageFlipX,$imageFlipX=!$imageFlipX,$imageFlipX);}history.write();}}],cropEnableButtonFlipVertical&&["Button","flip-vertical",{label:locale.cropLabelButtonFlipVertical,labelClass:"PinturaToolbarContentWide",icon:locale.cropIconButtonFlipVertical,onclick:()=>{if(isRotatedSideways($imageRotation)){set_store_value(imageFlipX,$imageFlipX=!$imageFlipX,$imageFlipX);}else{set_store_value(imageFlipY,$imageFlipY=!$imageFlipY,$imageFlipY);}history.write();}}],shouldRenderPresetSelect&&cropSelectPresetOptions&&["Dropdown","select-preset",{icon:localize(locale.cropIconSelectPreset,locale,getAspectRatioBySelectedIndex($selectedPresetIndex)),label:locale.cropLabelSelectPreset,labelClass:"PinturaToolbarContentWide",options:cropSelectPresetOptions,selectedIndex:$selectedPresetIndex,onchange:({value})=>{if(pintura_isArray(value)){set_store_value(imageCropAspectRatio,$imageCropAspectRatio=getAspectRatio(value[0],value[1]),$imageCropAspectRatio);set_store_value(imageOutputSize,$imageOutputSize=sizeCreateFromArray(value),$imageOutputSize);}else{set_store_value(imageCropAspectRatio,$imageCropAspectRatio=value,$imageCropAspectRatio);}if(isImageSelectionCentered){handleRecenterAction();}history.write();},optionMapper:option=>{// if no aspect ratio found we enable the option by default
let disabled=false;// get aspect ratio for this option
const optionAspectRatio=pintura_isArray(option.value)?option.value[0]/option.value[1]:option.value;// can be undefined in which case we don't need to check anything
if(optionAspectRatio){const maxCropSize=getMaxSizeInRect($imageSize,$imageRotation,optionAspectRatio);disabled=maxCropSize.width<$imageCropMinSize.width||maxCropSize.height<$imageCropMinSize.height;}// add icon for this option
option.icon=getSelectionPresetOptionIcon(option.value,{bounds:14});return{...option,disabled};}}],cropEnableButtonToggleCropLimit&&["Dropdown","select-crop-limit",{icon:localize(locale.cropIconCropBoundary,locale,$imageCropLimitToImage),label:locale.cropLabelCropBoundary,labelClass:"PinturaToolbarContentWide",onchange:({value})=>{set_store_value(imageCropLimitToImage,$imageCropLimitToImage=value,$imageCropLimitToImage);history.write();},options:[[true,locale.cropLabelCropBoundaryEdge,{icon:localize(locale.cropIconCropBoundary,locale,true)}],[false,locale.cropLabelCropBoundaryNone,{icon:localize(locale.cropIconCropBoundary,locale,false)}]]}]].filter(Boolean),$env,()=>({})).filter(Boolean));}if($$self.$$.dirty[0]&/*$isActive*/512){$isActive&&imageOutlineOpacity.set(1);}if($$self.$$.dirty[3]&/*$imageCropLimitToImage*/16777216){$$invalidate(14,imageZoomLevelMin=$imageCropLimitToImage?0:-1);}if($$self.$$.dirty[3]&/*$utilRect*/1073741824|$$self.$$.dirty[4]&/*$stageRect*/1){$$invalidate(125,imageSelectionOffset=$utilRect&&vectorCreate(-($stageRect.x-$utilRect.x),-($stageRect.y-$utilRect.y)));}if($$self.$$.dirty[4]&/*$imageSelectionRectPresentation, imageSelectionOffset*/10){// normalized crop bounds, we use these to limit the crop interactions to the view
$$invalidate(126,imageSelectionCenter=$imageSelectionRectPresentation&&vectorCreate(snapToPixel($imageSelectionRectPresentation.x+$imageSelectionRectPresentation.width*0.5+imageSelectionOffset.x),snapToPixel($imageSelectionRectPresentation.y+$imageSelectionRectPresentation.height*0.5+imageSelectionOffset.y)));}if($$self.$$.dirty[3]&/*$imageSelectionRectSnapshot*/134217728){$$invalidate(130,isResizingSelection=$imageSelectionRectSnapshot!=null);}if($$self.$$.dirty[3]&/*$utilRect*/1073741824|$$self.$$.dirty[4]&/*imageSelectionCenteredRect*/16){$$invalidate(131,isMaxSelectionRect=$utilRect&&imageSelectionCenteredRect&&(imageSelectionCenteredRect.height===$utilRect.height||imageSelectionCenteredRect.width===$utilRect.width));}if($$self.$$.dirty[3]&/*$presentationScalar*/536870912|$$self.$$.dirty[4]&/*isMaxSelectionRect, $imageScalar*/1152){$$invalidate(133,canZoomToCenter=!isMaxSelectionRect&&$presentationScalar<1&&$imageScalar<1);}if($$self.$$.dirty[3]&/*isImageSelectionCentered*/4194304|$$self.$$.dirty[4]&/*isImageSelectionDisplayed, isResizingSelection, canZoomToCenter*/608){$$invalidate(10,canCenter=isImageSelectionDisplayed&&!isResizingSelection&&(!isImageSelectionCentered||canZoomToCenter));}if($$self.$$.dirty[0]&/*$imageCropRect*/128|$$self.$$.dirty[3]&/*cropEnableInfoIndicator*/16|$$self.$$.dirty[4]&/*isOverlayMode*/256){$$invalidate(16,shouldRenderInfoIndicator=cropEnableInfoIndicator&&!!$imageCropRect&&!isOverlayMode);}if($$self.$$.dirty[4]&/*$imageSelectionRectPresentation, imageSelectionOffset*/10){$$invalidate(11,imageSelectionRectOffset=$imageSelectionRectPresentation&&imageSelectionOffset&&{x:$imageSelectionRectPresentation.x+imageSelectionOffset.x,y:$imageSelectionRectPresentation.y+imageSelectionOffset.y,width:$imageSelectionRectPresentation.width,height:$imageSelectionRectPresentation.height});}if($$self.$$.dirty[0]&/*imageSelectionRectOffset*/2048|$$self.$$.dirty[3]&/*cropEnableImageSelection*/8|$$self.$$.dirty[4]&/*isOverlayMode*/256){$$invalidate(17,shouldRenderImageSelection=cropEnableImageSelection&&!!imageSelectionRectOffset&&!isOverlayMode);}if($$self.$$.dirty[2]&/*cropAutoCenterImageSelectionTimeout*/268435456|$$self.$$.dirty[3]&/*cropEnableCenterImageSelection*/128|$$self.$$.dirty[4]&/*imageSelectionCenter*/4){$$invalidate(18,shouldRenderImageSelectionRecenterButton=cropEnableCenterImageSelection&&!!imageSelectionCenter&&!cropAutoCenterImageSelectionTimeout);}if($$self.$$.dirty[0]&/*canCenter*/1024|$$self.$$.dirty[2]&/*cropAutoCenterImageSelectionTimeout*/268435456|$$self.$$.dirty[3]&/*$isInteracting, cropAutoCenterImageSelectionTimeoutId*/67174400){if(canCenter&&cropAutoCenterImageSelectionTimeout&&!$isInteracting){clearTimeout(cropAutoCenterImageSelectionTimeoutId);$$invalidate(109,cropAutoCenterImageSelectionTimeoutId=setTimeout(handleRecenterAction,cropAutoCenterImageSelectionTimeout));}}if($$self.$$.dirty[3]&/*$isInteracting, cropAutoCenterImageSelectionTimeoutId*/67174400){if($isInteracting)clearTimeout(cropAutoCenterImageSelectionTimeoutId);}if($$self.$$.dirty[0]&/*canCenter*/1024){recenterOpacity.set(canCenter?1:0);}if($$self.$$.dirty[4]&/*imageSelectionCenter*/4){recenterOffset.set(imageSelectionCenter);}if($$self.$$.dirty[0]&/*$isActive*/512|$$self.$$.dirty[4]&/*$framePadded, $imagePreviewModifiers*/6144){//
// enable seeing the image outside of the crop area, and disable the vignette effect
//
if($isActive&&!$framePadded){set_store_value(imagePreviewModifiers,$imagePreviewModifiers["crop"]={maskOpacity:0.85,maskMarkupOpacity:0.85},$imagePreviewModifiers);}else{delete $imagePreviewModifiers["crop"];}}if($$self.$$.dirty[4]&/*$imageSelectionGuides*/8192){// if overlay top changes
$imageSelectionGuides&&syncGuides();}if($$self.$$.dirty[3]&/*$env*/33554432){//
// Transform tabs
//
$$invalidate(138,hasPlentyVerticalSpace=$env.verticalSpace!=="short");}if($$self.$$.dirty[4]&/*hasPlentyVerticalSpace, isOverlayMode*/16640){$$invalidate(19,shouldRenderToolbar=hasPlentyVerticalSpace&&!isOverlayMode);}if($$self.$$.dirty[0]&/*cropEnableZoom*/8|$$self.$$.dirty[3]&/*cropEnableZoomInput*/2){$$invalidate(139,couldRenderZoomInput=cropEnableZoom&&cropEnableZoomInput);}if($$self.$$.dirty[3]&/*cropEnableZoomAutoHide*/4|$$self.$$.dirty[4]&/*hasPlentyVerticalSpace, couldRenderZoomInput*/49152){$$invalidate(140,shouldRenderZoomInput=cropEnableZoomAutoHide?hasPlentyVerticalSpace&&couldRenderZoomInput:couldRenderZoomInput);}if($$self.$$.dirty[3]&/*cropEnableRotationInput*/1|$$self.$$.dirty[4]&/*shouldRenderZoomInput*/65536){$$invalidate(20,shouldRenderFooter=cropEnableRotationInput||shouldRenderZoomInput);}if($$self.$$.dirty[4]&/*shouldRenderZoomInput*/65536){if(!shouldRenderZoomInput){$$invalidate(5,transformSelected=transformToolInitial);}}if($$self.$$.dirty[0]&/*transformSelected*/32){$$invalidate(21,tabsConfig={name:cropUniqueId,selected:transformSelected});}if($$self.$$.dirty[0]&/*locale*/16|$$self.$$.dirty[3]&/*cropEnableRotationInput*/1|$$self.$$.dirty[4]&/*shouldRenderZoomInput*/65536){$$invalidate(12,tabs=[cropEnableRotationInput&&{id:cropUniqueId+"-rotation",label:locale.cropLabelTabRotation},shouldRenderZoomInput&&{id:cropUniqueId+"-zoom",label:locale.cropLabelTabZoom}].filter(Boolean));}if($$self.$$.dirty[0]&/*tabs*/4096){$$invalidate(22,panels=tabs.map(tab=>tab.id));}if($$self.$$.dirty[0]&/*stageRef*/64|$$self.$$.dirty[4]&/*isOverlayMode*/256){if(stageRef&&!stageRef.children.length&&isOverlayMode){stageRef.dispatchEvent(new CustomEvent("measure",{detail:stageRef.rect}));}}if($$self.$$.dirty[0]&/*$isActive*/512|$$self.$$.dirty[4]&/*$animation*/131072){$animation&&footerOffset.set($isActive?0:20);}if($$self.$$.dirty[4]&/*$footerOffset*/262144){$$invalidate(23,footerStyle=$footerOffset?`transform: translateY(${$footerOffset}px)`:undefined);}};return[tools,isActive,cropImageSelectionCornerStyle,cropEnableZoom,locale,transformSelected,stageRef,$imageCropRect,$imageRotation,$isActive,canCenter,imageSelectionRectOffset,tabs,root,imageZoomLevelMin,$rootRect,shouldRenderInfoIndicator,shouldRenderImageSelection,shouldRenderImageSelectionRecenterButton,shouldRenderToolbar,shouldRenderFooter,tabsConfig,panels,footerStyle,$imageRotationRange,$imageZoomLevelRange,$imageZoomLevel,$recenterOpacity,$recenterOffset,env,isInteracting,rootRect,stageRect,utilRect,animation,elasticityMultiplier,rangeInputElasticity,presentationScalar,imagePreviewModifiers,imageFlipX,imageFlipY,imageRotation,imageRotationRange,imageOutputSize,imageSelectionRect,imageSelectionRectSnapshot,imageSelectionRectIntent,imageSelectionRectPresentation,imageCropRectIntent,imageCropRectOrigin,imageCropRect,imageCropMinSize,imageCropMaxSize,imageCropRange,imageCropAspectRatio,imageCropLimitToImage,imageSize,imageScalar,imageOverlayMarkup,framePadded,handleSelectionGrab,handleSelectionDrag,handleSelectionRelease,handleRotateStart,handleRotateMove,handleRotateEnd,handleImageDragStart,handleImageDrag,handleImageDragEnd,handleImageDragRelease,imageCropRangeAspectRatio,imageZoomLevelRange,imageZoomLevel,handleResizeStart,handleResizeMove,handleResizeEnd,handleGestureStart,handleGestureUpdate,handleGestureEnd,handleWheel,handleRecenterAction,recenterOpacity,recenterOffset,selectedPresetIndex,imageSelectionGuides,cropUniqueId,footerOffset,name,stores,cropWillRenderImageSelectionGuides,cropAutoCenterImageSelectionTimeout,cropEnableZoomMatchImageAspectRatio,cropEnableRotateMatchImageAspectRatio,cropEnableRotationInput,cropEnableZoomInput,cropEnableZoomAutoHide,cropEnableImageSelection,cropEnableInfoIndicator,cropEnableZoomTowardsWheelPosition,cropEnableLimitWheelInputToCropSelection,cropEnableCenterImageSelection,cropEnableButtonRotateLeft,cropEnableButtonRotateRight,cropEnableButtonFlipHorizontal,cropEnableButtonFlipVertical,cropSelectPresetOptions,cropEnableSelectPreset,cropEnableButtonToggleCropLimit,cropWillRenderTools,cropAutoCenterImageSelectionTimeoutId,$imageSize,$imageFlipY,$imageFlipX,shouldRenderPresetSelect,$selectedPresetIndex,isImageSelectionCentered,$imageCropMinSize,$imageCropLimitToImage,$env,$isInteracting,$imageSelectionRectSnapshot,$imageSelectionRect,$presentationScalar,$utilRect,$stageRect,imageSelectionOffset,imageSelectionCenter,$imageSelectionRectPresentation,imageSelectionCenteredRect,isImageSelectionDisplayed,isResizingSelection,isMaxSelectionRect,isOverlayMode,canZoomToCenter,$imageScalar,$framePadded,$imagePreviewModifiers,$imageSelectionGuides,hasPlentyVerticalSpace,couldRenderZoomInput,shouldRenderZoomInput,$animation,$footerOffset,measure_handler_1,select_handler,div0_binding,interactable_function,util_root_binding,measure_handler];}class Crop extends SvelteComponent{constructor(options){super();init(this,options,instance$k,create_fragment$k,safe_not_equal,{name:87,isActive:1,stores:88,cropImageSelectionCornerStyle:2,cropWillRenderImageSelectionGuides:89,cropAutoCenterImageSelectionTimeout:90,cropEnableZoomMatchImageAspectRatio:91,cropEnableRotateMatchImageAspectRatio:92,cropEnableRotationInput:93,cropEnableZoom:3,cropEnableZoomInput:94,cropEnableZoomAutoHide:95,cropEnableImageSelection:96,cropEnableInfoIndicator:97,cropEnableZoomTowardsWheelPosition:98,cropEnableLimitWheelInputToCropSelection:99,cropEnableCenterImageSelection:100,cropEnableButtonRotateLeft:101,cropEnableButtonRotateRight:102,cropEnableButtonFlipHorizontal:103,cropEnableButtonFlipVertical:104,cropSelectPresetOptions:105,cropEnableSelectPreset:106,cropEnableButtonToggleCropLimit:107,cropWillRenderTools:108,locale:4,tools:0},[-1,-1,-1,-1,-1,-1,-1]);}get name(){return this.$$.ctx[87];}get isActive(){return this.$$.ctx[1];}set isActive(isActive){this.$set({isActive});flush();}get stores(){return this.$$.ctx[88];}set stores(stores){this.$set({stores});flush();}get cropImageSelectionCornerStyle(){return this.$$.ctx[2];}set cropImageSelectionCornerStyle(cropImageSelectionCornerStyle){this.$set({cropImageSelectionCornerStyle});flush();}get cropWillRenderImageSelectionGuides(){return this.$$.ctx[89];}set cropWillRenderImageSelectionGuides(cropWillRenderImageSelectionGuides){this.$set({cropWillRenderImageSelectionGuides});flush();}get cropAutoCenterImageSelectionTimeout(){return this.$$.ctx[90];}set cropAutoCenterImageSelectionTimeout(cropAutoCenterImageSelectionTimeout){this.$set({cropAutoCenterImageSelectionTimeout});flush();}get cropEnableZoomMatchImageAspectRatio(){return this.$$.ctx[91];}set cropEnableZoomMatchImageAspectRatio(cropEnableZoomMatchImageAspectRatio){this.$set({cropEnableZoomMatchImageAspectRatio});flush();}get cropEnableRotateMatchImageAspectRatio(){return this.$$.ctx[92];}set cropEnableRotateMatchImageAspectRatio(cropEnableRotateMatchImageAspectRatio){this.$set({cropEnableRotateMatchImageAspectRatio});flush();}get cropEnableRotationInput(){return this.$$.ctx[93];}set cropEnableRotationInput(cropEnableRotationInput){this.$set({cropEnableRotationInput});flush();}get cropEnableZoom(){return this.$$.ctx[3];}set cropEnableZoom(cropEnableZoom){this.$set({cropEnableZoom});flush();}get cropEnableZoomInput(){return this.$$.ctx[94];}set cropEnableZoomInput(cropEnableZoomInput){this.$set({cropEnableZoomInput});flush();}get cropEnableZoomAutoHide(){return this.$$.ctx[95];}set cropEnableZoomAutoHide(cropEnableZoomAutoHide){this.$set({cropEnableZoomAutoHide});flush();}get cropEnableImageSelection(){return this.$$.ctx[96];}set cropEnableImageSelection(cropEnableImageSelection){this.$set({cropEnableImageSelection});flush();}get cropEnableInfoIndicator(){return this.$$.ctx[97];}set cropEnableInfoIndicator(cropEnableInfoIndicator){this.$set({cropEnableInfoIndicator});flush();}get cropEnableZoomTowardsWheelPosition(){return this.$$.ctx[98];}set cropEnableZoomTowardsWheelPosition(cropEnableZoomTowardsWheelPosition){this.$set({cropEnableZoomTowardsWheelPosition});flush();}get cropEnableLimitWheelInputToCropSelection(){return this.$$.ctx[99];}set cropEnableLimitWheelInputToCropSelection(cropEnableLimitWheelInputToCropSelection){this.$set({cropEnableLimitWheelInputToCropSelection});flush();}get cropEnableCenterImageSelection(){return this.$$.ctx[100];}set cropEnableCenterImageSelection(cropEnableCenterImageSelection){this.$set({cropEnableCenterImageSelection});flush();}get cropEnableButtonRotateLeft(){return this.$$.ctx[101];}set cropEnableButtonRotateLeft(cropEnableButtonRotateLeft){this.$set({cropEnableButtonRotateLeft});flush();}get cropEnableButtonRotateRight(){return this.$$.ctx[102];}set cropEnableButtonRotateRight(cropEnableButtonRotateRight){this.$set({cropEnableButtonRotateRight});flush();}get cropEnableButtonFlipHorizontal(){return this.$$.ctx[103];}set cropEnableButtonFlipHorizontal(cropEnableButtonFlipHorizontal){this.$set({cropEnableButtonFlipHorizontal});flush();}get cropEnableButtonFlipVertical(){return this.$$.ctx[104];}set cropEnableButtonFlipVertical(cropEnableButtonFlipVertical){this.$set({cropEnableButtonFlipVertical});flush();}get cropSelectPresetOptions(){return this.$$.ctx[105];}set cropSelectPresetOptions(cropSelectPresetOptions){this.$set({cropSelectPresetOptions});flush();}get cropEnableSelectPreset(){return this.$$.ctx[106];}set cropEnableSelectPreset(cropEnableSelectPreset){this.$set({cropEnableSelectPreset});flush();}get cropEnableButtonToggleCropLimit(){return this.$$.ctx[107];}set cropEnableButtonToggleCropLimit(cropEnableButtonToggleCropLimit){this.$set({cropEnableButtonToggleCropLimit});flush();}get cropWillRenderTools(){return this.$$.ctx[108];}set cropWillRenderTools(cropWillRenderTools){this.$set({cropWillRenderTools});flush();}get locale(){return this.$$.ctx[4];}set locale(locale){this.$set({locale});flush();}get tools(){return this.$$.ctx[0];}set tools(tools){this.$set({tools});flush();}}// @ts-ignore
var _plugin_crop={util:['crop',Crop]};/* src/core/ui/plugins/filter/index.svelte generated by Svelte v3.37.0 */function create_option_slot$2(ctx){let div1;let div0;let option=/*option*/ctx[68];let t0;let span;let t1_value=(pintura_isFunction(/*option*/ctx[68].label)?/*option*/ctx[68].label(/*locale*/ctx[2]):/*option*/ctx[68].label)+"";let t1;let mounted;let dispose;function measure_handler_1(...args){return/*measure_handler_1*/ctx[48](/*option*/ctx[68],...args);}const assign_div0=()=>/*div0_binding*/ctx[49](div0,option);const unassign_div0=()=>/*div0_binding*/ctx[49](null,option);return{c(){div1=pintura_element("div");div0=pintura_element("div");t0=space();span=pintura_element("span");t1=pintura_text(t1_value);attr(div0,"class",FILTER_PREVIEW_CLASS_NAME);attr(div1,"slot","option");attr(div1,"class","PinturaFilterOption");},m(target,anchor){insert(target,div1,anchor);append(div1,div0);assign_div0();append(div1,t0);append(div1,span);append(span,t1);if(!mounted){dispose=[listen(div0,"measure",measure_handler_1),action_destroyer(measurable.call(null,div0))];mounted=true;}},p(new_ctx,dirty){ctx=new_ctx;if(option!==/*option*/ctx[68]){unassign_div0();option=/*option*/ctx[68];assign_div0();}if(dirty[0]&/*locale*/4|dirty[2]&/*option*/64&&t1_value!==(t1_value=(pintura_isFunction(/*option*/ctx[68].label)?/*option*/ctx[68].label(/*locale*/ctx[2]):/*option*/ctx[68].label)+""))set_data(t1,t1_value);},d(detaching){if(detaching)detach(div1);unassign_div0();mounted=false;run_all(dispose);}};}// (357:8) <Scrollable             elasticity={elasticityMultiplier * scrollElasticity}             onscroll={(offset) => (tileScrollOffset = offset)}             bind:maskFeatherStartOpacity={tileLeftOpacity}             bind:maskFeatherEndOpacity={tileRightOpacity}             bind:maskFeatherSize={tileMargin}             on:measure={(e) => (tileScrollContainerRect = e.detail)}         >
function create_default_slot$8(ctx){let radiogroup;let current;radiogroup=new RadioGroup({props:{locale:/*locale*/ctx[2],layout:"row",options:/*filterOptions*/ctx[3],selectedIndex:/*selectedFilterIndex*/ctx[10],onchange:/*handleChangeFilter*/ctx[29],$$slots:{option:[create_option_slot$2,({option})=>({68:option}),({option})=>[0,0,option?64:0]]},$$scope:{ctx}}});return{c(){create_component(radiogroup.$$.fragment);},m(target,anchor){mount_component(radiogroup,target,anchor);current=true;},p(ctx,dirty){const radiogroup_changes={};if(dirty[0]&/*locale*/4)radiogroup_changes.locale=/*locale*/ctx[2];if(dirty[0]&/*filterOptions*/8)radiogroup_changes.options=/*filterOptions*/ctx[3];if(dirty[0]&/*selectedFilterIndex*/1024)radiogroup_changes.selectedIndex=/*selectedFilterIndex*/ctx[10];if(dirty[0]&/*locale, tileElements*/516|dirty[2]&/*$$scope, option*/192){radiogroup_changes.$$scope={dirty,ctx};}radiogroup.$set(radiogroup_changes);},i(local){if(current)return;transition_in(radiogroup.$$.fragment,local);current=true;},o(local){transition_out(radiogroup.$$.fragment,local);current=false;},d(detaching){destroy_component(radiogroup,detaching);}};}// (356:4) 
function create_footer_slot$4(ctx){let div;let scrollable;let updating_maskFeatherStartOpacity;let updating_maskFeatherEndOpacity;let updating_maskFeatherSize;let current;let mounted;let dispose;function scrollable_maskFeatherStartOpacity_binding(value){/*scrollable_maskFeatherStartOpacity_binding*/ctx[51](value);}function scrollable_maskFeatherEndOpacity_binding(value){/*scrollable_maskFeatherEndOpacity_binding*/ctx[52](value);}function scrollable_maskFeatherSize_binding(value){/*scrollable_maskFeatherSize_binding*/ctx[53](value);}let scrollable_props={elasticity:/*elasticityMultiplier*/ctx[15]*/*scrollElasticity*/ctx[16],onscroll:/*func*/ctx[50],$$slots:{default:[create_default_slot$8]},$$scope:{ctx}};if(/*tileLeftOpacity*/ctx[4]!==void 0){scrollable_props.maskFeatherStartOpacity=/*tileLeftOpacity*/ctx[4];}if(/*tileRightOpacity*/ctx[5]!==void 0){scrollable_props.maskFeatherEndOpacity=/*tileRightOpacity*/ctx[5];}if(/*tileMargin*/ctx[6]!==void 0){scrollable_props.maskFeatherSize=/*tileMargin*/ctx[6];}scrollable=new Scrollable({props:scrollable_props});binding_callbacks.push(()=>bind(scrollable,"maskFeatherStartOpacity",scrollable_maskFeatherStartOpacity_binding));binding_callbacks.push(()=>bind(scrollable,"maskFeatherEndOpacity",scrollable_maskFeatherEndOpacity_binding));binding_callbacks.push(()=>bind(scrollable,"maskFeatherSize",scrollable_maskFeatherSize_binding));scrollable.$on("measure",/*measure_handler_2*/ctx[54]);return{c(){div=pintura_element("div");create_component(scrollable.$$.fragment);attr(div,"slot","footer");attr(div,"style",/*footerStyle*/ctx[11]);},m(target,anchor){insert(target,div,anchor);mount_component(scrollable,div,null);current=true;if(!mounted){dispose=listen(div,"transitionend",/*handleTransitionEnd*/ctx[27]);mounted=true;}},p(ctx,dirty){const scrollable_changes={};if(dirty[0]&/*tileScrollOffset*/128)scrollable_changes.onscroll=/*func*/ctx[50];if(dirty[0]&/*locale, filterOptions, selectedFilterIndex, tileElements*/1548|dirty[2]&/*$$scope*/128){scrollable_changes.$$scope={dirty,ctx};}if(!updating_maskFeatherStartOpacity&&dirty[0]&/*tileLeftOpacity*/16){updating_maskFeatherStartOpacity=true;scrollable_changes.maskFeatherStartOpacity=/*tileLeftOpacity*/ctx[4];add_flush_callback(()=>updating_maskFeatherStartOpacity=false);}if(!updating_maskFeatherEndOpacity&&dirty[0]&/*tileRightOpacity*/32){updating_maskFeatherEndOpacity=true;scrollable_changes.maskFeatherEndOpacity=/*tileRightOpacity*/ctx[5];add_flush_callback(()=>updating_maskFeatherEndOpacity=false);}if(!updating_maskFeatherSize&&dirty[0]&/*tileMargin*/64){updating_maskFeatherSize=true;scrollable_changes.maskFeatherSize=/*tileMargin*/ctx[6];add_flush_callback(()=>updating_maskFeatherSize=false);}scrollable.$set(scrollable_changes);if(!current||dirty[0]&/*footerStyle*/2048){attr(div,"style",/*footerStyle*/ctx[11]);}},i(local){if(current)return;transition_in(scrollable.$$.fragment,local);current=true;},o(local){transition_out(scrollable.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(scrollable);mounted=false;dispose();}};}function create_fragment$j(ctx){let util;let current;util=new Util({props:{$$slots:{footer:[create_footer_slot$4]},$$scope:{ctx}}});util.$on("measure",/*measure_handler*/ctx[55]);return{c(){create_component(util.$$.fragment);},m(target,anchor){mount_component(util,target,anchor);current=true;},p(ctx,dirty){const util_changes={};if(dirty[0]&/*footerStyle, tileScrollOffset, tileLeftOpacity, tileRightOpacity, tileMargin, tileScrollContainerRect, locale, filterOptions, selectedFilterIndex, tileElements*/4092|dirty[2]&/*$$scope*/128){util_changes.$$scope={dirty,ctx};}util.$set(util_changes);},i(local){if(current)return;transition_in(util.$$.fragment,local);current=true;},o(local){transition_out(util.$$.fragment,local);current=false;},d(detaching){destroy_component(util,detaching);}};}let FILTER_PREVIEW_CLASS_NAME="PinturaFilterPreview";function instance$j($$self,$$props,$$invalidate){let filterOptionsFlattened;let selectedFilterIndex;let footerStyle;let $imageColorMatrix;let $tileRects;let $canvasSize;let $imageTransforms;let $animation;let $isActive,$$unsubscribe_isActive=pintura_noop,$$subscribe_isActive=()=>($$unsubscribe_isActive(),$$unsubscribe_isActive=subscribe(isActive,$$value=>$$invalidate(40,$isActive=$$value)),isActive);let $utilRect;let $stageRect;let $imageGamma;let $imagePreview;let $imageSize;let $imageBackgroundColor;let $isActiveFraction,$$unsubscribe_isActiveFraction=pintura_noop,$$subscribe_isActiveFraction=()=>($$unsubscribe_isActiveFraction(),$$unsubscribe_isActiveFraction=subscribe(isActiveFraction,$$value=>$$invalidate(45,$isActiveFraction=$$value)),isActiveFraction);let $footerOffset;let $imageTiles;$$self.$$.on_destroy.push(()=>$$unsubscribe_isActive());$$self.$$.on_destroy.push(()=>$$unsubscribe_isActiveFraction());const name="filter";let{isActive}=$$props;$$subscribe_isActive();let{isActiveFraction}=$$props;$$subscribe_isActiveFraction();let{stores}=$$props;let{locale}=$$props;let{filterFunctions}=$$props;let{filterOptions}=$$props;// connect filter choice to stores
const{history,interfaceImages,stageRect,utilRect,animation,elasticityMultiplier,scrollElasticity,imageSize,imagePreview,imageCropRect,imageRotation,imageFlipX,imageFlipY,imageBackgroundColor,imageGamma,imageColorMatrix}=stores;component_subscribe($$self,stageRect,value=>$$invalidate(42,$stageRect=value));component_subscribe($$self,utilRect,value=>$$invalidate(41,$utilRect=value));component_subscribe($$self,animation,value=>$$invalidate(39,$animation=value));component_subscribe($$self,imageSize,value=>$$invalidate(57,$imageSize=value));component_subscribe($$self,imagePreview,value=>$$invalidate(44,$imagePreview=value));component_subscribe($$self,imageBackgroundColor,value=>$$invalidate(58,$imageBackgroundColor=value));component_subscribe($$self,imageGamma,value=>$$invalidate(43,$imageGamma=value));component_subscribe($$self,imageColorMatrix,value=>$$invalidate(36,$imageColorMatrix=value));const getFilterIndex=(imageColorMatrix,filterOptionsFlattened)=>{if(!imageColorMatrix||!imageColorMatrix["filter"]||!filterOptionsFlattened)return 0;const filterColorMatrix=imageColorMatrix["filter"];return filterOptionsFlattened.// get id and compare matrices
findIndex(([id])=>{if(!filterFunctions[id])return false;const matrix=filterFunctions[id]();return arrayEqual(matrix,filterColorMatrix);});};const tileRects=writable({});component_subscribe($$self,tileRects,value=>$$invalidate(37,$tileRects=value));const handleTileResize=(item,rect)=>set_store_value(tileRects,$tileRects[item.value]=rect,$tileRects);const canvasSize=derived(tileRects,$tileRects=>{if(!$tileRects[undefined])return;const tileRectFirst=$tileRects[undefined];if($canvasSize&&sizeEqual($canvasSize,tileRectFirst))return $canvasSize;return sizeClone(tileRectFirst);});component_subscribe($$self,canvasSize,value=>$$invalidate(56,$canvasSize=value));const imageTransforms=derived([isActive,canvasSize,imageCropRect,imageSize,imageRotation,imageFlipX,imageFlipY],([$isActive,$canvasSize,$imageCropRect,$imageSize,$imageRotation,$imageFlipX,$imageFlipY],set)=>{if(!$isActive||!$canvasSize||!$imageSize)return $imageTransforms;const imageRect=rectCreateFromSize($imageSize);const imageCenter=rectCenter(imageRect);// get base crop rect so we can correctly apply transforms
const cropRectBase=getBaseCropRect($imageSize,$imageCropRect,$imageRotation);const cropRectBaseCenter=rectCenter(cropRectBase);const imageTranslation=vectorSubtract(vectorClone(imageCenter),cropRectBaseCenter);const imageOrigin=vectorInvert(vectorClone(imageTranslation));// scalar
const imageScalar=Math.max($canvasSize.width/$imageCropRect.width,$canvasSize.height/$imageCropRect.height);// update preview transforms
set({origin:imageOrigin,translation:imageTranslation,rotation:{x:$imageFlipY?Math.PI:0,y:$imageFlipX?Math.PI:0,z:$imageRotation},perspective:vectorCreateEmpty(),scale:imageScalar});});component_subscribe($$self,imageTransforms,value=>$$invalidate(38,$imageTransforms=value));const cloneImageTransforms=imageTransforms=>({origin:vectorClone(imageTransforms.origin),translation:vectorClone(imageTransforms.translation),rotation:{...imageTransforms.rotation},perspective:vectorClone(imageTransforms.perspective),scale:imageTransforms.scale});//
// Footer
//
const footerOffset=spring($animation?20:0);component_subscribe($$self,footerOffset,value=>$$invalidate(46,$footerOffset=value));let tileCornerRadius;const tileElements={};const handleTransitionEnd=e=>{if(e.target.className!==FILTER_PREVIEW_CLASS_NAME)return;$$invalidate(33,tileCornerRadius=Object.keys(tileElements).reduce((prev,curr)=>{const element=tileElements[curr];const style=getComputedStyle(element);const corners=["top-left","top-right","bottom-left","bottom-right"].map(corner=>style.getPropertyValue(`border-${corner}-radius`)).map(unitToPixels).// this better aligns WebGL rounded corner with css rounded corner
map(v=>v*1.25);prev[curr]=corners;return prev;},{}));};let tileLeftOpacity;// set by Scrollable
let tileRightOpacity;// set by Scrollable
let tileMargin;// set by Scrollable
let tileScrollOffset={x:0,y:0};let tileScrollContainerRect;let tileWrapperOffset;const imageTiles=writable([]);component_subscribe($$self,imageTiles,value=>$$invalidate(47,$imageTiles=value));// clones an image tile for use in canvas
const cloneImageTile=tile=>{const clone={// doesn't clone everything but should be enough
...tile,data:$imagePreview,size:$imageSize,offset:{...tile.offset},mask:{...tile.mask},backgroundColor:$imageBackgroundColor};clone.opacity=$isActiveFraction;clone.offset.y+=$footerOffset;clone.mask.y+=$footerOffset;return clone;};const handleChangeFilter=({value})=>{set_store_value(imageColorMatrix,$imageColorMatrix={...$imageColorMatrix,filter:pintura_isFunction(filterFunctions[value])?filterFunctions[value]():undefined},$imageColorMatrix);history.write();};// when destroyed we need to make sure all image previews are cleared
onDestroy(()=>{interfaceImages.set([]);});const measure_handler_1=(option,e)=>handleTileResize(option,e.detail);function div0_binding($$value,option){binding_callbacks[$$value?"unshift":"push"](()=>{tileElements[option.value]=$$value;$$invalidate(9,tileElements);});}const func=offset=>$$invalidate(7,tileScrollOffset=offset);function scrollable_maskFeatherStartOpacity_binding(value){tileLeftOpacity=value;$$invalidate(4,tileLeftOpacity);}function scrollable_maskFeatherEndOpacity_binding(value){tileRightOpacity=value;$$invalidate(5,tileRightOpacity);}function scrollable_maskFeatherSize_binding(value){tileMargin=value;$$invalidate(6,tileMargin);}const measure_handler_2=e=>$$invalidate(8,tileScrollContainerRect=e.detail);function measure_handler(event){bubble($$self,event);}$$self.$$set=$$props=>{if("isActive"in $$props)$$subscribe_isActive($$invalidate(0,isActive=$$props.isActive));if("isActiveFraction"in $$props)$$subscribe_isActiveFraction($$invalidate(1,isActiveFraction=$$props.isActiveFraction));if("stores"in $$props)$$invalidate(31,stores=$$props.stores);if("locale"in $$props)$$invalidate(2,locale=$$props.locale);if("filterFunctions"in $$props)$$invalidate(32,filterFunctions=$$props.filterFunctions);if("filterOptions"in $$props)$$invalidate(3,filterOptions=$$props.filterOptions);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*filterOptions*/8){$$invalidate(35,filterOptionsFlattened=flattenOptions(filterOptions));}if($$self.$$.dirty[1]&/*$imageColorMatrix, filterOptionsFlattened*/48){$$invalidate(10,selectedFilterIndex=getFilterIndex($imageColorMatrix,filterOptionsFlattened));}if($$self.$$.dirty[1]&/*$animation, $isActive*/768){$animation&&footerOffset.set($isActive?0:20);}if($$self.$$.dirty[1]&/*$isActive, $utilRect, $stageRect*/3584){if($isActive&&$utilRect&&$stageRect){const tileTopOffset=$stageRect.y+$stageRect.height+$utilRect.y;$$invalidate(34,tileWrapperOffset={x:$stageRect.x-$utilRect.x,y:tileTopOffset});}}if($$self.$$.dirty[0]&/*tileScrollOffset, tileScrollContainerRect, tileMargin, tileLeftOpacity, tileRightOpacity*/496|$$self.$$.dirty[1]&/*$imageTransforms, tileWrapperOffset, tileCornerRadius, filterOptionsFlattened, $tileRects, $imageColorMatrix, filterFunctions, $imageGamma*/4350){if($imageTransforms&&tileWrapperOffset&&tileScrollOffset&&tileScrollContainerRect&&tileCornerRadius){const boundsX=tileWrapperOffset.x+tileScrollContainerRect.x;const offsetX=boundsX+tileScrollOffset.x;const offsetY=tileWrapperOffset.y;const containerLeft=tileScrollContainerRect.x+tileWrapperOffset.x;const containerRight=containerLeft+tileScrollContainerRect.width;imageTiles.set(filterOptionsFlattened.map(([id],i)=>{const tileRect=$tileRects[id];// test if is outside of view
const tileLeft=tileScrollOffset.x+tileRect.x;const tileRight=tileLeft+tileRect.width;if(tileRight<0||tileLeft>tileScrollContainerRect.width)return false;const x=offsetX+tileRect.x;const y=offsetY+tileRect.y;const preview=cloneImageTransforms($imageTransforms);preview.offset=vectorCreate(tileRect.width*0.5+x,tileRect.height*0.5+y);let clipX=0;let clipWidth=0;preview.maskOpacity=1;preview.mask=rectCreate(x+clipX,y,tileRect.width+clipWidth,tileRect.height);preview.maskFeather=[1,0,1,0,1,containerRight,1,containerRight];if(tileLeft<tileMargin&&tileLeftOpacity<1){preview.maskFeather[0]=tileLeftOpacity;preview.maskFeather[1]=containerLeft;preview.maskFeather[2]=1;preview.maskFeather[3]=containerLeft+tileMargin;}if(tileRight>tileScrollContainerRect.width-tileMargin&&tileRightOpacity<1){preview.maskFeather[4]=tileRightOpacity;preview.maskFeather[5]=containerRight-tileMargin;preview.maskFeather[6]=1;preview.maskFeather[7]=containerRight;}preview.maskCornerRadius=tileCornerRadius[id];let colorMatrices=$imageColorMatrix&&Object.keys($imageColorMatrix).filter(name=>name!="filter").map(name=>$imageColorMatrix[name])||[];if(pintura_isFunction(filterFunctions[id])){colorMatrices.push(filterFunctions[id]());}preview.colorMatrix=colorMatrices.length?getColorMatrixFromColorMatrices(colorMatrices):undefined;preview.gamma=$imageGamma;return preview;}).filter(Boolean));}}if($$self.$$.dirty[1]&/*$isActiveFraction, $imageTiles, $footerOffset, $imagePreview*/122880){// Will update `interfaceImages` store when
// - $isActiveFraction is updated
// - $imageTiles is updated
// - $footerOffset is updated
if($isActiveFraction>0&&$imageTiles){// clone tiles
interfaceImages.set($imageTiles.map(cloneImageTile));}else{interfaceImages.set([]);}}if($$self.$$.dirty[1]&/*$footerOffset*/32768){$$invalidate(11,footerStyle=$footerOffset?`transform: translateY(${$footerOffset}px)`:undefined);}};return[isActive,isActiveFraction,locale,filterOptions,tileLeftOpacity,tileRightOpacity,tileMargin,tileScrollOffset,tileScrollContainerRect,tileElements,selectedFilterIndex,footerStyle,stageRect,utilRect,animation,elasticityMultiplier,scrollElasticity,imageSize,imagePreview,imageBackgroundColor,imageGamma,imageColorMatrix,tileRects,handleTileResize,canvasSize,imageTransforms,footerOffset,handleTransitionEnd,imageTiles,handleChangeFilter,name,stores,filterFunctions,tileCornerRadius,tileWrapperOffset,filterOptionsFlattened,$imageColorMatrix,$tileRects,$imageTransforms,$animation,$isActive,$utilRect,$stageRect,$imageGamma,$imagePreview,$isActiveFraction,$footerOffset,$imageTiles,measure_handler_1,div0_binding,func,scrollable_maskFeatherStartOpacity_binding,scrollable_maskFeatherEndOpacity_binding,scrollable_maskFeatherSize_binding,measure_handler_2,measure_handler];}class Filter extends SvelteComponent{constructor(options){super();init(this,options,instance$j,create_fragment$j,safe_not_equal,{name:30,isActive:0,isActiveFraction:1,stores:31,locale:2,filterFunctions:32,filterOptions:3},[-1,-1,-1]);}get name(){return this.$$.ctx[30];}get isActive(){return this.$$.ctx[0];}set isActive(isActive){this.$set({isActive});flush();}get isActiveFraction(){return this.$$.ctx[1];}set isActiveFraction(isActiveFraction){this.$set({isActiveFraction});flush();}get stores(){return this.$$.ctx[31];}set stores(stores){this.$set({stores});flush();}get locale(){return this.$$.ctx[2];}set locale(locale){this.$set({locale});flush();}get filterFunctions(){return this.$$.ctx[32];}set filterFunctions(filterFunctions){this.$set({filterFunctions});flush();}get filterOptions(){return this.$$.ctx[3];}set filterOptions(filterOptions){this.$set({filterOptions});flush();}}// @ts-ignore
var _plugin_filter={util:['filter',Filter]};/* src/core/ui/plugins/finetune/index.svelte generated by Svelte v3.37.0 */function create_default_slot_2$1(ctx){let span;let t_value=/*tab*/ctx[37].label+"";let t;return{c(){span=pintura_element("span");t=pintura_text(t_value);},m(target,anchor){insert(target,span,anchor);append(span,t);},p(ctx,dirty){if(dirty[1]&/*tab*/64&&t_value!==(t_value=/*tab*/ctx[37].label+""))set_data(t,t_value);},d(detaching){if(detaching)detach(span);}};}// (145:8) <Scrollable             elasticity={elasticityMultiplier * scrollElasticity}             class="PinturaControlListScroller"         >
function create_default_slot_1$2(ctx){let tablist;let current;const tablist_spread_levels=[{class:"PinturaControlList"},{tabs:/*tabs*/ctx[1]},/*tabsConfig*/ctx[3]];let tablist_props={$$slots:{default:[create_default_slot_2$1,({tab})=>({37:tab}),({tab})=>[0,tab?64:0]]},$$scope:{ctx}};for(let i=0;i<tablist_spread_levels.length;i+=1){tablist_props=pintura_assign(tablist_props,tablist_spread_levels[i]);}tablist=new TabList({props:tablist_props});tablist.$on("select",/*select_handler*/ctx[22]);return{c(){create_component(tablist.$$.fragment);},m(target,anchor){mount_component(tablist,target,anchor);current=true;},p(ctx,dirty){const tablist_changes=dirty[0]&/*tabs, tabsConfig*/10?get_spread_update(tablist_spread_levels,[tablist_spread_levels[0],dirty[0]&/*tabs*/2&&{tabs:/*tabs*/ctx[1]},dirty[0]&/*tabsConfig*/8&&get_spread_object(/*tabsConfig*/ctx[3])]):{};if(dirty[1]&/*$$scope, tab*/192){tablist_changes.$$scope={dirty,ctx};}tablist.$set(tablist_changes);},i(local){if(current)return;transition_in(tablist.$$.fragment,local);current=true;},o(local){transition_out(tablist.$$.fragment,local);current=false;},d(detaching){destroy_component(tablist,detaching);}};}// (160:8) <TabPanels             class="PinturaControlPanels"             panelClass="PinturaControlPanel"             {panels}             {...tabsConfig}             let:panel         >
function create_default_slot$7(ctx){let rangeinput;let current;const rangeinput_spread_levels=[/*$rangeInputConfig*/ctx[5][/*panel*/ctx[36]]];let rangeinput_props={};for(let i=0;i<rangeinput_spread_levels.length;i+=1){rangeinput_props=pintura_assign(rangeinput_props,rangeinput_spread_levels[i]);}rangeinput=new RangeInput({props:rangeinput_props});return{c(){create_component(rangeinput.$$.fragment);},m(target,anchor){mount_component(rangeinput,target,anchor);current=true;},p(ctx,dirty){const rangeinput_changes=dirty[0]&/*$rangeInputConfig*/32|dirty[1]&/*panel*/32?get_spread_update(rangeinput_spread_levels,[get_spread_object(/*$rangeInputConfig*/ctx[5][/*panel*/ctx[36]])]):{};rangeinput.$set(rangeinput_changes);},i(local){if(current)return;transition_in(rangeinput.$$.fragment,local);current=true;},o(local){transition_out(rangeinput.$$.fragment,local);current=false;},d(detaching){destroy_component(rangeinput,detaching);}};}// (144:4) 
function create_footer_slot$3(ctx){let div;let scrollable;let t;let tabpanels;let current;scrollable=new Scrollable({props:{elasticity:/*elasticityMultiplier*/ctx[9]*/*scrollElasticity*/ctx[8],class:"PinturaControlListScroller",$$slots:{default:[create_default_slot_1$2]},$$scope:{ctx}}});const tabpanels_spread_levels=[{class:"PinturaControlPanels"},{panelClass:"PinturaControlPanel"},{panels:/*panels*/ctx[4]},/*tabsConfig*/ctx[3]];let tabpanels_props={$$slots:{default:[create_default_slot$7,({panel})=>({36:panel}),({panel})=>[0,panel?32:0]]},$$scope:{ctx}};for(let i=0;i<tabpanels_spread_levels.length;i+=1){tabpanels_props=pintura_assign(tabpanels_props,tabpanels_spread_levels[i]);}tabpanels=new TabPanels({props:tabpanels_props});return{c(){div=pintura_element("div");create_component(scrollable.$$.fragment);t=space();create_component(tabpanels.$$.fragment);attr(div,"slot","footer");attr(div,"style",/*footerStyle*/ctx[6]);},m(target,anchor){insert(target,div,anchor);mount_component(scrollable,div,null);append(div,t);mount_component(tabpanels,div,null);current=true;},p(ctx,dirty){const scrollable_changes={};if(dirty[0]&/*tabs, tabsConfig, tabSelected*/14|dirty[1]&/*$$scope*/128){scrollable_changes.$$scope={dirty,ctx};}scrollable.$set(scrollable_changes);const tabpanels_changes=dirty[0]&/*panels, tabsConfig*/24?get_spread_update(tabpanels_spread_levels,[tabpanels_spread_levels[0],tabpanels_spread_levels[1],dirty[0]&/*panels*/16&&{panels:/*panels*/ctx[4]},dirty[0]&/*tabsConfig*/8&&get_spread_object(/*tabsConfig*/ctx[3])]):{};if(dirty[0]&/*$rangeInputConfig*/32|dirty[1]&/*$$scope, panel*/160){tabpanels_changes.$$scope={dirty,ctx};}tabpanels.$set(tabpanels_changes);if(!current||dirty[0]&/*footerStyle*/64){attr(div,"style",/*footerStyle*/ctx[6]);}},i(local){if(current)return;transition_in(scrollable.$$.fragment,local);transition_in(tabpanels.$$.fragment,local);current=true;},o(local){transition_out(scrollable.$$.fragment,local);transition_out(tabpanels.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(scrollable);destroy_component(tabpanels);}};}function create_fragment$i(ctx){let util;let current;util=new Util({props:{$$slots:{footer:[create_footer_slot$3]},$$scope:{ctx}}});util.$on("measure",/*measure_handler*/ctx[23]);return{c(){create_component(util.$$.fragment);},m(target,anchor){mount_component(util,target,anchor);current=true;},p(ctx,dirty){const util_changes={};if(dirty[0]&/*footerStyle, panels, tabsConfig, $rangeInputConfig, tabs, tabSelected*/126|dirty[1]&/*$$scope*/128){util_changes.$$scope={dirty,ctx};}util.$set(util_changes);},i(local){if(current)return;transition_in(util.$$.fragment,local);current=true;},o(local){transition_out(util.$$.fragment,local);current=false;},d(detaching){destroy_component(util,detaching);}};}function instance$i($$self,$$props,$$invalidate){let tabs;let tabSelected;let tabsConfig;let panels;let footerStyle;let $rangeInputConfig;let $panelValues;let $animation;let $isActive,$$unsubscribe_isActive=pintura_noop,$$subscribe_isActive=()=>($$unsubscribe_isActive(),$$unsubscribe_isActive=subscribe(isActive,$$value=>$$invalidate(20,$isActive=$$value)),isActive);let $footerOffset;$$self.$$.on_destroy.push(()=>$$unsubscribe_isActive());const name="finetune";let{stores}=$$props;let{isActive}=$$props;$$subscribe_isActive();let{locale={}}=$$props;let{finetuneControlConfiguration}=$$props;let{finetuneOptions}=$$props;const{history,animation,scrollElasticity,elasticityMultiplier,rangeInputElasticity,imageColorMatrix,imageConvolutionMatrix,imageGamma,imageVignette,imageNoise}=stores;component_subscribe($$self,animation,value=>$$invalidate(19,$animation=value));const imageEffectStores={imageColorMatrix,imageConvolutionMatrix,imageGamma,imageVignette,imageNoise};//
// Tabs
//
const uid=`finetune-${getUniqueId()}`;//
// Range inputs
//
const panelValues=writable({});component_subscribe($$self,panelValues,value=>$$invalidate(18,$panelValues=value));const rangeInputConfig=writable({});component_subscribe($$self,rangeInputConfig,value=>$$invalidate(5,$rangeInputConfig=value));const updateRangeInputState=()=>{set_store_value(rangeInputConfig,$rangeInputConfig=Object.keys($panelValues).reduce((config,id)=>{const{base,min,max,getLabel,getStore,setValue=(store,v)=>store.set(v)}=finetuneControlConfiguration[id];const store=getStore(imageEffectStores);const value=$panelValues[id]!=null?$panelValues[id]:base;config[id]={base,min,max,value,valueLabel:getLabel?getLabel(value,min,max,max-min):Math.round(100*value),oninputmove:v=>{setValue(store,v);},oninputend:v=>{setValue(store,v);history.write();},elasticity:elasticityMultiplier*rangeInputElasticity,labelReset:locale.labelReset};return config;},{}),$rangeInputConfig);};// need to unsubscribe when redrawing vie
let unsubs=[];const subscribePanelStores=config=>{if(unsubs)unsubs.forEach(unsub=>unsub());unsubs=panels.map(id=>{const{getStore,getValue=passthrough}=config[id];const store=getStore(imageEffectStores);return store.subscribe(value=>{const currentValue=value!=null?getValue(value):value;set_store_value(panelValues,$panelValues={...$panelValues,[id]:currentValue},$panelValues);});});};//
// Footer
//
const footerOffset=spring($animation?20:0);component_subscribe($$self,footerOffset,value=>$$invalidate(21,$footerOffset=value));const select_handler=({detail})=>$$invalidate(2,tabSelected=detail);function measure_handler(event){bubble($$self,event);}$$self.$$set=$$props=>{if("stores"in $$props)$$invalidate(14,stores=$$props.stores);if("isActive"in $$props)$$subscribe_isActive($$invalidate(0,isActive=$$props.isActive));if("locale"in $$props)$$invalidate(15,locale=$$props.locale);if("finetuneControlConfiguration"in $$props)$$invalidate(16,finetuneControlConfiguration=$$props.finetuneControlConfiguration);if("finetuneOptions"in $$props)$$invalidate(17,finetuneOptions=$$props.finetuneOptions);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*finetuneOptions, locale*/163840){$$invalidate(1,tabs=finetuneOptions?finetuneOptions.map(([id,label])=>({id,label:pintura_isFunction(label)?label(locale):label})):[]);}if($$self.$$.dirty[0]&/*tabs*/2){$$invalidate(2,tabSelected=tabs.length&&tabs[0].id);}if($$self.$$.dirty[0]&/*tabSelected*/4){$$invalidate(3,tabsConfig={name:uid,selected:tabSelected});}if($$self.$$.dirty[0]&/*tabs*/2){$$invalidate(4,panels=tabs.map(tab=>tab.id));}if($$self.$$.dirty[0]&/*finetuneControlConfiguration*/65536){finetuneControlConfiguration&&subscribePanelStores(finetuneControlConfiguration);}if($$self.$$.dirty[0]&/*finetuneControlConfiguration, $panelValues*/327680){finetuneControlConfiguration&&$panelValues&&updateRangeInputState();}if($$self.$$.dirty[0]&/*$animation, $isActive*/1572864){$animation&&footerOffset.set($isActive?0:20);}if($$self.$$.dirty[0]&/*$footerOffset*/2097152){$$invalidate(6,footerStyle=$footerOffset?`transform: translateY(${$footerOffset}px)`:undefined);}};return[isActive,tabs,tabSelected,tabsConfig,panels,$rangeInputConfig,footerStyle,animation,scrollElasticity,elasticityMultiplier,panelValues,rangeInputConfig,footerOffset,name,stores,locale,finetuneControlConfiguration,finetuneOptions,$panelValues,$animation,$isActive,$footerOffset,select_handler,measure_handler];}class Finetune extends SvelteComponent{constructor(options){super();init(this,options,instance$i,create_fragment$i,safe_not_equal,{name:13,stores:14,isActive:0,locale:15,finetuneControlConfiguration:16,finetuneOptions:17},[-1,-1]);}get name(){return this.$$.ctx[13];}get stores(){return this.$$.ctx[14];}set stores(stores){this.$set({stores});flush();}get isActive(){return this.$$.ctx[0];}set isActive(isActive){this.$set({isActive});flush();}get locale(){return this.$$.ctx[15];}set locale(locale){this.$set({locale});flush();}get finetuneControlConfiguration(){return this.$$.ctx[16];}set finetuneControlConfiguration(finetuneControlConfiguration){this.$set({finetuneControlConfiguration});flush();}get finetuneOptions(){return this.$$.ctx[17];}set finetuneOptions(finetuneOptions){this.$set({finetuneOptions});flush();}}// @ts-ignore
var _plugin_finetune={util:['finetune',Finetune]};/* src/core/ui/components/ShapeManipulator.svelte generated by Svelte v3.37.0 */function get_each_context$4(ctx,list,i){const child_ctx=ctx.slice();child_ctx[47]=list[i].key;child_ctx[48]=list[i].index;child_ctx[49]=list[i].translate;child_ctx[50]=list[i].scale;child_ctx[14]=list[i].rotate;child_ctx[51]=list[i].dir;child_ctx[52]=list[i].center;child_ctx[53]=list[i].type;return child_ctx;}// (247:4) {#if type === 'edge' && resizeAxis !== 'both'}
function create_if_block_1$3(ctx){let div;let div_style_value;return{c(){div=pintura_element("div");attr(div,"class","PinturaShapeManipulator");attr(div,"data-control","point");attr(div,"style",div_style_value=`pointer-events:none;transform: translate3d(${/*center*/ctx[52].x}px, ${/*center*/ctx[52].y}px, 0) scale(${/*$selectionScale*/ctx[5]}, ${/*$selectionScale*/ctx[5]}); opacity: ${/*$selectionOpacity*/ctx[6]}`);},m(target,anchor){insert(target,div,anchor);},p(ctx,dirty){if(dirty[0]&/*resizeControls, $selectionScale, $selectionOpacity*/104&&div_style_value!==(div_style_value=`pointer-events:none;transform: translate3d(${/*center*/ctx[52].x}px, ${/*center*/ctx[52].y}px, 0) scale(${/*$selectionScale*/ctx[5]}, ${/*$selectionScale*/ctx[5]}); opacity: ${/*$selectionOpacity*/ctx[6]}`)){attr(div,"style",div_style_value);}},d(detaching){if(detaching)detach(div);}};}// (226:0) {#each resizeControls as { key, index, translate, scale, rotate, dir, center, type }
function create_each_block$4(key_1,ctx){let div;let div_aria_label_value;let div_tabindex_value;let div_data_control_value;let div_style_value;let t;let if_block_anchor;let mounted;let dispose;function nudge_handler(...args){return/*nudge_handler*/ctx[18](/*index*/ctx[48],...args);}let if_block=/*type*/ctx[53]==="edge"&&/*resizeAxis*/ctx[2]!=="both"&&create_if_block_1$3(ctx);return{key:key_1,first:null,c(){div=pintura_element("div");t=space();if(if_block)if_block.c();if_block_anchor=empty();attr(div,"role","button");attr(div,"aria-label",div_aria_label_value=`Drag ${/*type*/ctx[53]} ${/*key*/ctx[47]}`);attr(div,"tabindex",div_tabindex_value=/*type*/ctx[53]==="edge"?-1:0);attr(div,"class","PinturaShapeManipulator");attr(div,"data-control",div_data_control_value=/*type*/ctx[53]);attr(div,"style",div_style_value=`cursor: ${/*dir*/ctx[51]?/*dir*/ctx[51]+"-resize":"move"}; transform: translate3d(${/*translate*/ctx[49].x}px, ${/*translate*/ctx[49].y}px, 0)${/*type*/ctx[53]==="edge"?` rotate(${/*rotate*/ctx[14]}rad)`:""} scale(${/*type*/ctx[53]==="point"?/*$selectionScale*/ctx[5]:/*scale*/ctx[50].x}, ${/*type*/ctx[53]==="point"?/*$selectionScale*/ctx[5]:/*scale*/ctx[50].y}); opacity: ${/*$selectionOpacity*/ctx[6]}`);this.first=div;},m(target,anchor){insert(target,div,anchor);insert(target,t,anchor);if(if_block)if_block.m(target,anchor);insert(target,if_block_anchor,anchor);if(!mounted){dispose=[listen(div,"keydown",/*handleKeyDown*/ctx[7]),listen(div,"keyup",/*handleKeyUp*/ctx[8]),listen(div,"nudge",nudge_handler),action_destroyer(nudgeable.call(null,div)),listen(div,"interactionstart",function(){if(is_function(/*resize*/ctx[11]("start",/*index*/ctx[48])))/*resize*/ctx[11]("start",/*index*/ctx[48]).apply(this,arguments);}),listen(div,"interactionupdate",function(){if(is_function(/*resize*/ctx[11]("move",/*index*/ctx[48])))/*resize*/ctx[11]("move",/*index*/ctx[48]).apply(this,arguments);}),listen(div,"interactionend",function(){if(is_function(/*resize*/ctx[11]("end",/*index*/ctx[48])))/*resize*/ctx[11]("end",/*index*/ctx[48]).apply(this,arguments);}),action_destroyer(interactable.call(null,div))];mounted=true;}},p(new_ctx,dirty){ctx=new_ctx;if(dirty[0]&/*resizeControls*/8&&div_aria_label_value!==(div_aria_label_value=`Drag ${/*type*/ctx[53]} ${/*key*/ctx[47]}`)){attr(div,"aria-label",div_aria_label_value);}if(dirty[0]&/*resizeControls*/8&&div_tabindex_value!==(div_tabindex_value=/*type*/ctx[53]==="edge"?-1:0)){attr(div,"tabindex",div_tabindex_value);}if(dirty[0]&/*resizeControls*/8&&div_data_control_value!==(div_data_control_value=/*type*/ctx[53])){attr(div,"data-control",div_data_control_value);}if(dirty[0]&/*resizeControls, $selectionScale, $selectionOpacity*/104&&div_style_value!==(div_style_value=`cursor: ${/*dir*/ctx[51]?/*dir*/ctx[51]+"-resize":"move"}; transform: translate3d(${/*translate*/ctx[49].x}px, ${/*translate*/ctx[49].y}px, 0)${/*type*/ctx[53]==="edge"?` rotate(${/*rotate*/ctx[14]}rad)`:""} scale(${/*type*/ctx[53]==="point"?/*$selectionScale*/ctx[5]:/*scale*/ctx[50].x}, ${/*type*/ctx[53]==="point"?/*$selectionScale*/ctx[5]:/*scale*/ctx[50].y}); opacity: ${/*$selectionOpacity*/ctx[6]}`)){attr(div,"style",div_style_value);}if(/*type*/ctx[53]==="edge"&&/*resizeAxis*/ctx[2]!=="both"){if(if_block){if_block.p(ctx,dirty);}else{if_block=create_if_block_1$3(ctx);if_block.c();if_block.m(if_block_anchor.parentNode,if_block_anchor);}}else if(if_block){if_block.d(1);if_block=null;}},d(detaching){if(detaching)detach(div);if(detaching)detach(t);if(if_block)if_block.d(detaching);if(detaching)detach(if_block_anchor);mounted=false;run_all(dispose);}};}// (255:0) {#if enableRotating && rotationControlActive}
function create_if_block$3(ctx){let div;let div_style_value;let mounted;let dispose;return{c(){div=pintura_element("div");attr(div,"role","button");attr(div,"aria-label","Drag rotator");attr(div,"tabindex","0");attr(div,"class","PinturaShapeManipulator");attr(div,"data-control","rotate");attr(div,"style",div_style_value=`transform: translate3d(${/*rotatorPoint*/ctx[0].x}px, ${/*rotatorPoint*/ctx[0].y}px, 0) scale(${/*$selectionScale*/ctx[5]}, ${/*$selectionScale*/ctx[5]}); opacity: ${/*$selectionOpacity*/ctx[6]}`);},m(target,anchor){insert(target,div,anchor);if(!mounted){dispose=[listen(div,"keydown",/*handleKeyDown*/ctx[7]),listen(div,"keyup",/*handleKeyUp*/ctx[8]),listen(div,"nudge",/*handleRotateNudge*/ctx[13]),action_destroyer(nudgeable.call(null,div)),listen(div,"interactionstart",/*rotate*/ctx[14]("start")),listen(div,"interactionupdate",/*rotate*/ctx[14]("move")),listen(div,"interactionend",/*rotate*/ctx[14]("end")),action_destroyer(interactable.call(null,div))];mounted=true;}},p(ctx,dirty){if(dirty[0]&/*rotatorPoint, $selectionScale, $selectionOpacity*/97&&div_style_value!==(div_style_value=`transform: translate3d(${/*rotatorPoint*/ctx[0].x}px, ${/*rotatorPoint*/ctx[0].y}px, 0) scale(${/*$selectionScale*/ctx[5]}, ${/*$selectionScale*/ctx[5]}); opacity: ${/*$selectionOpacity*/ctx[6]}`)){attr(div,"style",div_style_value);}},d(detaching){if(detaching)detach(div);mounted=false;run_all(dispose);}};}function create_fragment$h(ctx){let each_blocks=[];let each_1_lookup=new Map();let t;let if_block_anchor;let each_value=/*resizeControls*/ctx[3];const get_key=ctx=>/*key*/ctx[47];for(let i=0;i<each_value.length;i+=1){let child_ctx=get_each_context$4(ctx,each_value,i);let key=get_key(child_ctx);each_1_lookup.set(key,each_blocks[i]=create_each_block$4(key,child_ctx));}let if_block=/*enableRotating*/ctx[1]&&/*rotationControlActive*/ctx[4]&&create_if_block$3(ctx);return{c(){for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].c();}t=space();if(if_block)if_block.c();if_block_anchor=empty();},m(target,anchor){for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].m(target,anchor);}insert(target,t,anchor);if(if_block)if_block.m(target,anchor);insert(target,if_block_anchor,anchor);},p(ctx,dirty){if(dirty[0]&/*resizeControls, $selectionScale, $selectionOpacity, resizeAxis, handleKeyDown, handleKeyUp, handleResizeNudge, resize*/6636){each_value=/*resizeControls*/ctx[3];each_blocks=update_keyed_each(each_blocks,dirty,get_key,1,ctx,each_value,each_1_lookup,t.parentNode,destroy_block,create_each_block$4,t,get_each_context$4);}if(/*enableRotating*/ctx[1]&&/*rotationControlActive*/ctx[4]){if(if_block){if_block.p(ctx,dirty);}else{if_block=create_if_block$3(ctx);if_block.c();if_block.m(if_block_anchor.parentNode,if_block_anchor);}}else if(if_block){if_block.d(1);if_block=null;}},i:pintura_noop,o:pintura_noop,d(detaching){for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].d(detaching);}if(detaching)detach(t);if(if_block)if_block.d(detaching);if(detaching)detach(if_block_anchor);}};}function instance$h($$self,$$props,$$invalidate){let resizeAxis;let resizeControls;let rotationControlActive;let $selectionScale;let $selectionOpacity;const dispatch=createEventDispatcher();// which cursor to render
const EIGTH_PI=QUART_PI*0.5;const N=HALF_PI;const N0=N-EIGTH_PI;const N1=N+EIGTH_PI;const S=-HALF_PI;const S0=S-EIGTH_PI;const S1=S+EIGTH_PI;const E=PI;const E0=E-EIGTH_PI;const E1=-PI+EIGTH_PI;const W0=EIGTH_PI;const W1=-EIGTH_PI;const NW=N-QUART_PI;const NW0=NW-EIGTH_PI;const NW1=NW+EIGTH_PI;const NE=PI-QUART_PI;const NE0=NE-EIGTH_PI;const NE1=NE+EIGTH_PI;const SE=S-QUART_PI;const SE0=SE+EIGTH_PI;const SE1=SE-EIGTH_PI;const SW=S+QUART_PI;const SW0=SW+EIGTH_PI;const SW1=SW-EIGTH_PI;let{points=[]}=$$props;let{rotatorPoint=undefined}=$$props;let{visible=false}=$$props;let{enableResizing=true}=$$props;let{enableRotating=true}=$$props;// // internal
let shiftKey=false;const handleKeyDown=e=>shiftKey=e.shiftKey;const handleKeyUp=e=>shiftKey=false;// state
const selectionScale=spring(0.5,{precision:0.0001,stiffness:0.3,damping:0.7});component_subscribe($$self,selectionScale,value=>$$invalidate(5,$selectionScale=value));const selectionOpacity=spring(0,{precision:0.001,stiffness:0.3,damping:0.7});component_subscribe($$self,selectionOpacity,value=>$$invalidate(6,$selectionOpacity=value));const rotate=type=>({detail})=>{// always make sure we have a translation to work with
const translation=detail&&detail.translation?detail.translation:vectorCreate(0,0);dispatch(`rotate${type}`,{translation,shiftKey});};const resize=(type,indexes)=>({detail})=>{// always make sure we have a translation to work with
const translation=detail&&detail.translation?detail.translation:vectorCreate(0,0);// done transforming the points
dispatch(`resize${type}`,{indexes,translation,shiftKey});};// https://en.wikipedia.org/wiki/Radian#/media/File:Degree-Radian_Conversion.svg
const getDirectionByAngle=angle=>{let dir="";const isNorth=angle<=N1&&angle>=N0;const isSouth=angle>=S0&&angle<=S1;const isEast=angle<=E1||angle>=E0;const isWest=angle>=W1&&angle<=W0;const isNorthEast=angle>=NE0&&angle<=NE1;const isNorthWest=angle>=NW0&&angle<=NW1;const isSouthEast=angle<=SE0&&angle>=SE1;const isSouthWest=angle<=SW0&&angle>=SW1;if(isNorth||isSouth)dir="ns";if(isEast||isWest)dir="ew";if(isNorthEast||isSouthWest)dir="nesw";if(isNorthWest||isSouthEast)dir="nwse";return dir;};// 2 points -> [corner, corner]
// 3 points => [corner, edge, corner, edge, corner, edge],
// 4 points => [corner, edge, corner, edge, corner, edge, corner, edge]
const mapPointsToControls=(points,axis)=>{let i=0;const center=vectorCenter(points);const out=[];const l=points.length;const isLine=l===2;const isAxisLimited=axis!=="both";for(;i<l;i++){const p0=points[i-1]||points[points.length-1];const p1=points[i];const p2=points[i+1]||points[0];const dir=Math.atan2(p2.y-p1.y,p2.x-p1.x);// create corner, only allowed if axis equal 'both'
if(!isAxisLimited){const a=vectorNormalize(vectorCreate(p0.x-p1.x,p0.y-p1.y));const b=vectorNormalize(vectorCreate(p2.x-p1.x,p2.y-p1.y));const cornerVector=vectorCreate(a.x+b.x,a.y+b.y);out.push({index:[i],key:`point-${i}`,type:"point",scale:{x:1,y:1},translate:{x:p1.x,y:p1.y},angle:undefined,rotate:isLine?0:dir,center:p1,dir:isLine?undefined:getDirectionByAngle(Math.atan2(cornerVector.y,cornerVector.x))});}// if only two points, skip edge
if(isLine)continue;const mid=vectorCreate(p1.x+(p2.x-p1.x)*0.5,p1.y+(p2.y-p1.y)*0.5);// only allow horizontal controls
if(axis==="horizontal"&&i%2===0)continue;// only allow vertical controls
if(axis==="vertical"&&i%2!==0)continue;// create edge
out.push({index:[i,i+1===l?0:i+1],key:`edge-${i}`,type:"edge",scale:{x:vectorDistance(p1,p2),y:1},translate:{x:p1.x,y:p1.y},angle:dir,rotate:dir,center:mid,dir:getDirectionByAngle(Math.atan2(center.y-mid.y,center.x-mid.x))});}return out;};const handleResizeNudge=(indexes,translation)=>{dispatch(`resizestart`,{indexes,translation:vectorCreateEmpty()});dispatch(`resizemove`,{indexes,translation});dispatch(`resizeend`,{indexes,translation:vectorCreateEmpty()});};const handleRotateNudge=({detail})=>{dispatch(`rotatestart`,{translation:vectorCreateEmpty()});dispatch(`rotatemove`,{translation:detail});dispatch(`rotateend`,{translation:vectorCreateEmpty()});};const nudge_handler=(index,{detail})=>handleResizeNudge(index,detail);$$self.$$set=$$props=>{if("points"in $$props)$$invalidate(15,points=$$props.points);if("rotatorPoint"in $$props)$$invalidate(0,rotatorPoint=$$props.rotatorPoint);if("visible"in $$props)$$invalidate(16,visible=$$props.visible);if("enableResizing"in $$props)$$invalidate(17,enableResizing=$$props.enableResizing);if("enableRotating"in $$props)$$invalidate(1,enableRotating=$$props.enableRotating);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*visible*/65536){selectionScale.set(visible?1:0.5);}if($$self.$$.dirty[0]&/*visible*/65536){selectionOpacity.set(visible?1:0);}if($$self.$$.dirty[0]&/*enableResizing*/131072){$$invalidate(2,resizeAxis=!enableResizing?false:pintura_isString(enableResizing)?enableResizing:"both");}if($$self.$$.dirty[0]&/*resizeAxis, points*/32772){$$invalidate(3,resizeControls=resizeAxis&&mapPointsToControls(points,resizeAxis)||[]);}if($$self.$$.dirty[0]&/*points*/32768){$$invalidate(4,rotationControlActive=points.length>2);}};return[rotatorPoint,enableRotating,resizeAxis,resizeControls,rotationControlActive,$selectionScale,$selectionOpacity,handleKeyDown,handleKeyUp,selectionScale,selectionOpacity,resize,handleResizeNudge,handleRotateNudge,rotate,points,visible,enableResizing,nudge_handler];}class ShapeManipulator extends SvelteComponent{constructor(options){super();init(this,options,instance$h,create_fragment$h,safe_not_equal,{points:15,rotatorPoint:0,visible:16,enableResizing:17,enableRotating:1},[-1,-1]);}}var getEventPositionInEditor=(e,viewOffset)=>{const positionInViewport=getEventPositionInViewport(e);return vectorSubtract(positionInViewport,viewOffset);};let result$1=null;var isAndroid=()=>{if(result$1===null)result$1=isUserAgent(/Android/);return result$1;};var cursorMoveToEnd=field=>field.selectionStart=field.selectionEnd=field.value.length;let result=null;var supportsVisualViewport=()=>{if(result===null){result=isBrowser()&&'visualViewport'in window;}return result;};var createSoftKeyboardObserver=cb=>{if(!supportsVisualViewport())return false;const heightNormal=visualViewport.height;const testState=()=>{cb(visualViewport.height<heightNormal?'visible':'hidden');};visualViewport.addEventListener('resize',testState);return()=>visualViewport.removeEventListener('resize',testState);};/* src/core/ui/components/InputForm.svelte generated by Svelte v3.37.0 */function create_fragment$g(ctx){let div2;let div1;let button0;let t0;let div0;let t1;let button1;let current;let mounted;let dispose;button0=new Button({props:{onclick:/*oncancel*/ctx[1],label:/*labelCancel*/ctx[5],icon:/*iconCancel*/ctx[7],hideLabel:!/*labelCancelShow*/ctx[6]}});const default_slot_template=/*#slots*/ctx[20].default;const default_slot=create_slot(default_slot_template,ctx,/*$$scope*/ctx[19],null);button1=new Button({props:{onclick:/*onconfirm*/ctx[0],label:/*labelConfirm*/ctx[2],icon:/*iconConfirm*/ctx[4],hideLabel:!/*labelConfirmShow*/ctx[3],class:"PinturaInputFormButtonConfirm"}});return{c(){div2=pintura_element("div");div1=pintura_element("div");create_component(button0.$$.fragment);t0=space();div0=pintura_element("div");if(default_slot)default_slot.c();t1=space();create_component(button1.$$.fragment);attr(div0,"class","PinturaInputFormFields");attr(div1,"class","PinturaInputFormInner");attr(div2,"class","PinturaInputForm");attr(div2,"style",/*style*/ctx[9]);},m(target,anchor){insert(target,div2,anchor);append(div2,div1);mount_component(button0,div1,null);append(div1,t0);append(div1,div0);if(default_slot){default_slot.m(div0,null);}append(div1,t1);mount_component(button1,div1,null);/*div2_binding*/ctx[21](div2);current=true;if(!mounted){dispose=[listen(div2,"focusin",/*handleFocusIn*/ctx[10]),listen(div2,"focusout",/*handleFocusOut*/ctx[11]),listen(div2,"measure",/*handleMeasure*/ctx[12]),action_destroyer(measurable.call(null,div2))];mounted=true;}},p(ctx,dirty){const button0_changes={};if(dirty[0]&/*oncancel*/2)button0_changes.onclick=/*oncancel*/ctx[1];if(dirty[0]&/*labelCancel*/32)button0_changes.label=/*labelCancel*/ctx[5];if(dirty[0]&/*iconCancel*/128)button0_changes.icon=/*iconCancel*/ctx[7];if(dirty[0]&/*labelCancelShow*/64)button0_changes.hideLabel=!/*labelCancelShow*/ctx[6];button0.$set(button0_changes);if(default_slot){if(default_slot.p&&dirty[0]&/*$$scope*/524288){update_slot(default_slot,default_slot_template,ctx,/*$$scope*/ctx[19],dirty,null,null);}}const button1_changes={};if(dirty[0]&/*onconfirm*/1)button1_changes.onclick=/*onconfirm*/ctx[0];if(dirty[0]&/*labelConfirm*/4)button1_changes.label=/*labelConfirm*/ctx[2];if(dirty[0]&/*iconConfirm*/16)button1_changes.icon=/*iconConfirm*/ctx[4];if(dirty[0]&/*labelConfirmShow*/8)button1_changes.hideLabel=!/*labelConfirmShow*/ctx[3];button1.$set(button1_changes);if(!current||dirty[0]&/*style*/512){attr(div2,"style",/*style*/ctx[9]);}},i(local){if(current)return;transition_in(button0.$$.fragment,local);transition_in(default_slot,local);transition_in(button1.$$.fragment,local);current=true;},o(local){transition_out(button0.$$.fragment,local);transition_out(default_slot,local);transition_out(button1.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div2);destroy_component(button0);if(default_slot)default_slot.d(detaching);destroy_component(button1);/*div2_binding*/ctx[21](null);mounted=false;run_all(dispose);}};}const panelDelay=200;function instance$g($$self,$$props,$$invalidate){let computedStyle;let shouldStickToKeyboard;let style;let{$$slots:slots={},$$scope}=$$props;let{onconfirm}=$$props;let{oncancel}=$$props;let{autoFocus=true}=$$props;let{autoPositionCursor=true}=$$props;let{labelConfirm}=$$props;let{labelConfirmShow=true}=$$props;let{iconConfirm}=$$props;let{labelCancel}=$$props;let{labelCancelShow=false}=$$props;let{iconCancel}=$$props;let{panelOffset=vectorCreateEmpty()}=$$props;let panelVisible=false;let panelHeight=undefined;let panelRevealTimeout=undefined;let panelPosition="";let panelOpacity=0;let root;const isTextarea=element=>/textarea/i.test(element);const preventTextAreaScrollingOnIOS=element=>{// preventsDefault on textarea events when can no longer scroll up or down in textarea
let lastScreenY;const handleTouchStart=e=>lastScreenY=e.touches[0].screenY;const handleTouchMove=e=>{const currentScreenY=e.touches[0].screenY;const target=e.target;if(/textarea/i.test(target.nodeName)){// moving down
if(currentScreenY>lastScreenY){if(target.scrollTop==0){e.preventDefault();}}else// moving up
if(currentScreenY<lastScreenY){if(target.scrollTop+target.offsetHeight==target.scrollHeight){e.preventDefault();}}else{e.preventDefault();}lastScreenY=currentScreenY;}else{e.preventDefault();}};element.addEventListener("touchstart",handleTouchStart);element.addEventListener("touchmove",handleTouchMove);return()=>{element.removeEventListener("touchstart",handleTouchStart);element.removeEventListener("touchmove",handleTouchMove);};};const focus=()=>{const field=root.querySelector("input, textarea");field.focus();field.select();};const show=()=>{panelVisible=true;// browser does not support keyboard listener, place modal at top of view
if(!unsubSoftKeyboardListener&&(isIOS()||isAndroid())){$$invalidate(16,panelPosition="top:1em;bottom:auto;");}// prevent interacting with the root element
if(isIOS())preventTextAreaScrollingOnIOS(root);// reveal
$$invalidate(17,panelOpacity=1);};const hide=()=>{panelVisible=false;$$invalidate(17,panelOpacity=0);};const handleSoftKeyboard=keyboardState=>{// shouldn't stick, we'll stick it to the top of the viewport so the keyboard doesn't obscure the input field
if(!shouldStickToKeyboard){$$invalidate(16,panelPosition=`top: 4.5em; bottom: auto`);return;}// no need to continue, already hidden
if(keyboardState==="hidden"&&!panelVisible){focus();return;}// gonna update position here
clearTimeout(panelRevealTimeout);panelRevealTimeout=undefined;// position
$$invalidate(16,panelPosition=`top:${visualViewport.height-panelHeight-panelOffset.y}px`);// if a soft keyboard is detected, turn into modal mode
if(keyboardState==="visible"){// stick to keyboard
$$invalidate(8,root.dataset.layout="stick",root);// need to refocus
focus();// place above keyboard
show();}else// keyboard is hidden
{hide();}};let focusDateTime;const handleFocusIn=e=>{if(!isTextarea(e.target))return;// we need to remember focus time so we can detect unrealistic blur event caused by soft keyboard shenanigans
focusDateTime=Date.now();// move cursor
if(autoPositionCursor)cursorMoveToEnd(e.target);// wait a couple milliseconds
clearTimeout(panelRevealTimeout);panelRevealTimeout=setTimeout(show,panelDelay);};const handleFocusOut=e=>{const focusDuration=Date.now()-focusDateTime;if(focusDuration>50)return;// unrealistic blur, refocus
e.stopPropagation();focus();};const unsubSoftKeyboardListener=createSoftKeyboardObserver(handleSoftKeyboard);const handleMeasure=({detail})=>{panelHeight=detail.height;};onMount(()=>{if(!autoFocus)return;focus();});onDestroy(()=>{unsubSoftKeyboardListener&&unsubSoftKeyboardListener();});function div2_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{root=$$value;$$invalidate(8,root);});}$$self.$$set=$$props=>{if("onconfirm"in $$props)$$invalidate(0,onconfirm=$$props.onconfirm);if("oncancel"in $$props)$$invalidate(1,oncancel=$$props.oncancel);if("autoFocus"in $$props)$$invalidate(13,autoFocus=$$props.autoFocus);if("autoPositionCursor"in $$props)$$invalidate(14,autoPositionCursor=$$props.autoPositionCursor);if("labelConfirm"in $$props)$$invalidate(2,labelConfirm=$$props.labelConfirm);if("labelConfirmShow"in $$props)$$invalidate(3,labelConfirmShow=$$props.labelConfirmShow);if("iconConfirm"in $$props)$$invalidate(4,iconConfirm=$$props.iconConfirm);if("labelCancel"in $$props)$$invalidate(5,labelCancel=$$props.labelCancel);if("labelCancelShow"in $$props)$$invalidate(6,labelCancelShow=$$props.labelCancelShow);if("iconCancel"in $$props)$$invalidate(7,iconCancel=$$props.iconCancel);if("panelOffset"in $$props)$$invalidate(15,panelOffset=$$props.panelOffset);if("$$scope"in $$props)$$invalidate(19,$$scope=$$props.$$scope);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*root*/256){$$invalidate(18,computedStyle=root&&getComputedStyle(root));}if($$self.$$.dirty[0]&/*computedStyle*/262144){shouldStickToKeyboard=computedStyle&&computedStyle.getPropertyValue("--editor-modal")==="1";}if($$self.$$.dirty[0]&/*panelOpacity, panelPosition*/196608){$$invalidate(9,style=`opacity:${panelOpacity};${panelPosition}`);}};return[onconfirm,oncancel,labelConfirm,labelConfirmShow,iconConfirm,labelCancel,labelCancelShow,iconCancel,root,style,handleFocusIn,handleFocusOut,handleMeasure,autoFocus,autoPositionCursor,panelOffset,panelPosition,panelOpacity,computedStyle,$$scope,slots,div2_binding];}class InputForm extends SvelteComponent{constructor(options){super();init(this,options,instance$g,create_fragment$g,safe_not_equal,{onconfirm:0,oncancel:1,autoFocus:13,autoPositionCursor:14,labelConfirm:2,labelConfirmShow:3,iconConfirm:4,labelCancel:5,labelCancelShow:6,iconCancel:7,panelOffset:15},[-1,-1]);}}/* src/core/ui/components/ShapeLayoutEditor.svelte generated by Svelte v3.37.0 */function get_each_context$3(ctx,list,i){const child_ctx=ctx.slice();child_ctx[178]=list[i];child_ctx[180]=i;return child_ctx;}// (2636:12) {#each shapeNavList as item, index (item.id)}
function create_each_block$3(key_1,ctx){let li;let button;let colorpreview;let t0;let span;let t1_value=/*item*/ctx[178].name+"";let t1;let button_aria_label_value;let t2;let current;let mounted;let dispose;colorpreview=new ColorPreview({props:{color:/*item*/ctx[178].color}});function click_handler(...args){return/*click_handler*/ctx[124](/*index*/ctx[180],...args);}return{key:key_1,first:null,c(){li=pintura_element("li");button=pintura_element("button");create_component(colorpreview.$$.fragment);t0=space();span=pintura_element("span");t1=pintura_text(t1_value);t2=space();attr(button,"class","PinturaShapeListItem");attr(button,"type","button");attr(button,"aria-label",button_aria_label_value="Select shape "+/*item*/ctx[178].name);this.first=li;},m(target,anchor){insert(target,li,anchor);append(li,button);mount_component(colorpreview,button,null);append(button,t0);append(button,span);append(span,t1);append(li,t2);current=true;if(!mounted){dispose=listen(button,"click",click_handler);mounted=true;}},p(new_ctx,dirty){ctx=new_ctx;const colorpreview_changes={};if(dirty[0]&/*shapeNavList*/524288)colorpreview_changes.color=/*item*/ctx[178].color;colorpreview.$set(colorpreview_changes);if((!current||dirty[0]&/*shapeNavList*/524288)&&t1_value!==(t1_value=/*item*/ctx[178].name+""))set_data(t1,t1_value);if(!current||dirty[0]&/*shapeNavList*/524288&&button_aria_label_value!==(button_aria_label_value="Select shape "+/*item*/ctx[178].name)){attr(button,"aria-label",button_aria_label_value);}},i(local){if(current)return;transition_in(colorpreview.$$.fragment,local);current=true;},o(local){transition_out(colorpreview.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(li);destroy_component(colorpreview);mounted=false;dispose();}};}// (2652:4) {#if shouldRenderShapeManipulator}
function create_if_block_2$2(ctx){let shapemanipulator;let current;shapemanipulator=new ShapeManipulator({props:{visible:true,points:/*shapeManipulatorPoints*/ctx[8],rotatorPoint:/*shapeManipulatorRotationPointPosition*/ctx[14],enableResizing:/*allowedResizeControls*/ctx[13],enableRotating:/*allowRotateControls*/ctx[6]}});shapemanipulator.$on("resizestart",/*handleManipulatorResizeGrab*/ctx[25]);shapemanipulator.$on("resizemove",/*handleManipulatorResizeDrag*/ctx[26]);shapemanipulator.$on("resizeend",/*handleManipulatorResizeEnd*/ctx[27]);shapemanipulator.$on("rotatestart",/*handleManipulatorRotateGrab*/ctx[28]);shapemanipulator.$on("rotatemove",/*handleManipulatorRotateDrag*/ctx[29]);shapemanipulator.$on("rotateend",/*handleManipulatorRotateEnd*/ctx[30]);return{c(){create_component(shapemanipulator.$$.fragment);},m(target,anchor){mount_component(shapemanipulator,target,anchor);current=true;},p(ctx,dirty){const shapemanipulator_changes={};if(dirty[0]&/*shapeManipulatorPoints*/256)shapemanipulator_changes.points=/*shapeManipulatorPoints*/ctx[8];if(dirty[0]&/*shapeManipulatorRotationPointPosition*/16384)shapemanipulator_changes.rotatorPoint=/*shapeManipulatorRotationPointPosition*/ctx[14];if(dirty[0]&/*allowedResizeControls*/8192)shapemanipulator_changes.enableResizing=/*allowedResizeControls*/ctx[13];if(dirty[0]&/*allowRotateControls*/64)shapemanipulator_changes.enableRotating=/*allowRotateControls*/ctx[6];shapemanipulator.$set(shapemanipulator_changes);},i(local){if(current)return;transition_in(shapemanipulator.$$.fragment,local);current=true;},o(local){transition_out(shapemanipulator.$$.fragment,local);current=false;},d(detaching){destroy_component(shapemanipulator,detaching);}};}// (2668:4) {#if shouldRenderTextInput}
function create_if_block_1$2(ctx){let inputform;let current;inputform=new InputForm({props:{panelOffset:/*offset*/ctx[1],onconfirm:/*handleTextConfirm*/ctx[36],oncancel:/*handleTextCancel*/ctx[37],labelCancel:/*locale*/ctx[3].shapeLabelInputCancel,iconCancel:/*locale*/ctx[3].shapeIconInputCancel,labelConfirm:/*locale*/ctx[3].shapeLabelInputConfirm,iconConfirm:/*locale*/ctx[3].shapeIconInputConfirm,$$slots:{default:[create_default_slot$6]},$$scope:{ctx}}});return{c(){create_component(inputform.$$.fragment);},m(target,anchor){mount_component(inputform,target,anchor);current=true;},p(ctx,dirty){const inputform_changes={};if(dirty[0]&/*offset*/2)inputform_changes.panelOffset=/*offset*/ctx[1];if(dirty[0]&/*locale*/8)inputform_changes.labelCancel=/*locale*/ctx[3].shapeLabelInputCancel;if(dirty[0]&/*locale*/8)inputform_changes.iconCancel=/*locale*/ctx[3].shapeIconInputCancel;if(dirty[0]&/*locale*/8)inputform_changes.labelConfirm=/*locale*/ctx[3].shapeLabelInputConfirm;if(dirty[0]&/*locale*/8)inputform_changes.iconConfirm=/*locale*/ctx[3].shapeIconInputConfirm;if(dirty[0]&/*markupTextInputStyle, textInput, textInputText*/100352|dirty[5]&/*$$scope*/67108864){inputform_changes.$$scope={dirty,ctx};}inputform.$set(inputform_changes);},i(local){if(current)return;transition_in(inputform.$$.fragment,local);current=true;},o(local){transition_out(inputform.$$.fragment,local);current=false;},d(detaching){destroy_component(inputform,detaching);}};}// (2669:8) <InputForm             panelOffset={offset}             onconfirm={handleTextConfirm}             oncancel={handleTextCancel}             labelCancel={locale.shapeLabelInputCancel}             iconCancel={locale.shapeIconInputCancel}             labelConfirm={locale.shapeLabelInputConfirm}             iconConfirm={locale.shapeIconInputConfirm}         >
function create_default_slot$6(ctx){let textarea;let mounted;let dispose;return{c(){textarea=pintura_element("textarea");attr(textarea,"style",/*markupTextInputStyle*/ctx[16]);attr(textarea,"spellcheck","false");attr(textarea,"autocorrect","off");attr(textarea,"autocapitalize","off");},m(target,anchor){insert(target,textarea,anchor);/*textarea_binding*/ctx[125](textarea);set_input_value(textarea,/*textInputText*/ctx[15]);if(!mounted){dispose=[listen(textarea,"keydown",/*handleTextInputKeyDown*/ctx[34]),listen(textarea,"keypress",/*handleTextInputAttempt*/ctx[33]),listen(textarea,"keyup",/*handleTextInputKeyUp*/ctx[35]),listen(textarea,"input",/*handleTextInput*/ctx[32]),listen(textarea,"input",/*textarea_input_handler*/ctx[126])];mounted=true;}},p(ctx,dirty){if(dirty[0]&/*markupTextInputStyle*/65536){attr(textarea,"style",/*markupTextInputStyle*/ctx[16]);}if(dirty[0]&/*textInputText*/32768){set_input_value(textarea,/*textInputText*/ctx[15]);}},d(detaching){if(detaching)detach(textarea);/*textarea_binding*/ctx[125](null);mounted=false;run_all(dispose);}};}// (2693:4) {#if $markupControlsOpacity > 0}
function create_if_block$2(ctx){let div;let dynamiccomponenttree;let current;let mounted;let dispose;dynamiccomponenttree=new DynamicComponentTree_1({props:{items:/*shapeControls*/ctx[18]}});return{c(){div=pintura_element("div");create_component(dynamiccomponenttree.$$.fragment);attr(div,"class","PinturaShapeControls");attr(div,"style",/*markupControlsStyle*/ctx[17]);},m(target,anchor){insert(target,div,anchor);mount_component(dynamiccomponenttree,div,null);current=true;if(!mounted){dispose=[listen(div,"measure",/*measure_handler_1*/ctx[127]),action_destroyer(measurable.call(null,div))];mounted=true;}},p(ctx,dirty){const dynamiccomponenttree_changes={};if(dirty[0]&/*shapeControls*/262144)dynamiccomponenttree_changes.items=/*shapeControls*/ctx[18];dynamiccomponenttree.$set(dynamiccomponenttree_changes);if(!current||dirty[0]&/*markupControlsStyle*/131072){attr(div,"style",/*markupControlsStyle*/ctx[17]);}},i(local){if(current)return;transition_in(dynamiccomponenttree.$$.fragment,local);current=true;},o(local){transition_out(dynamiccomponenttree.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(dynamiccomponenttree);mounted=false;run_all(dispose);}};}function create_fragment$f(ctx){let div;let nav;let ul;let each_blocks=[];let each_1_lookup=new Map();let t0;let t1;let t2;let interactable_action;let current;let mounted;let dispose;let each_value=/*shapeNavList*/ctx[19];const get_key=ctx=>/*item*/ctx[178].id;for(let i=0;i<each_value.length;i+=1){let child_ctx=get_each_context$3(ctx,each_value,i);let key=get_key(child_ctx);each_1_lookup.set(key,each_blocks[i]=create_each_block$3(key,child_ctx));}let if_block0=/*shouldRenderShapeManipulator*/ctx[7]&&create_if_block_2$2(ctx);let if_block1=/*shouldRenderTextInput*/ctx[9]&&create_if_block_1$2(ctx);let if_block2=/*$markupControlsOpacity*/ctx[10]>0&&create_if_block$2(ctx);return{c(){div=pintura_element("div");nav=pintura_element("nav");ul=pintura_element("ul");for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].c();}t0=space();if(if_block0)if_block0.c();t1=space();if(if_block1)if_block1.c();t2=space();if(if_block2)if_block2.c();attr(nav,"class","PinturaShapeList");attr(nav,"data-visible",/*showShapeList*/ctx[12]);attr(div,"class","PinturaShapeEditor");attr(div,"tabindex","0");},m(target,anchor){insert(target,div,anchor);append(div,nav);append(nav,ul);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].m(ul,null);}append(div,t0);if(if_block0)if_block0.m(div,null);append(div,t1);if(if_block1)if_block1.m(div,null);append(div,t2);if(if_block2)if_block2.m(div,null);current=true;if(!mounted){dispose=[listen(nav,"focusin",/*handleFocusIn*/ctx[40]),listen(nav,"focusout",/*handleFocusOut*/ctx[41]),listen(div,"keydown",/*handleKey*/ctx[31]),listen(div,"nudge",/*handleNudge*/ctx[39]),listen(div,"measure",/*measure_handler*/ctx[123]),action_destroyer(measurable.call(null,div)),action_destroyer(nudgeable.call(null,div)),listen(div,"interactionstart",/*handleInteractionStart*/ctx[21]),listen(div,"interactionupdate",/*handleInteractionUpdate*/ctx[22]),listen(div,"interactionrelease",/*handleInteractionRelease*/ctx[23]),listen(div,"interactionend",/*handleInteractionEnd*/ctx[24]),action_destroyer(interactable_action=interactable.call(null,div,{drag:true,pinch:true,inertia:true,matchTarget:true,getEventPosition:/*interactable_function*/ctx[128]}))];mounted=true;}},p(ctx,dirty){if(dirty[0]&/*shapeNavList, selectShape, markup*/524305){each_value=/*shapeNavList*/ctx[19];group_outros();each_blocks=update_keyed_each(each_blocks,dirty,get_key,1,ctx,each_value,each_1_lookup,ul,outro_and_destroy_block,create_each_block$3,null,get_each_context$3);check_outros();}if(!current||dirty[0]&/*showShapeList*/4096){attr(nav,"data-visible",/*showShapeList*/ctx[12]);}if(/*shouldRenderShapeManipulator*/ctx[7]){if(if_block0){if_block0.p(ctx,dirty);if(dirty[0]&/*shouldRenderShapeManipulator*/128){transition_in(if_block0,1);}}else{if_block0=create_if_block_2$2(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(div,t1);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}if(/*shouldRenderTextInput*/ctx[9]){if(if_block1){if_block1.p(ctx,dirty);if(dirty[0]&/*shouldRenderTextInput*/512){transition_in(if_block1,1);}}else{if_block1=create_if_block_1$2(ctx);if_block1.c();transition_in(if_block1,1);if_block1.m(div,t2);}}else if(if_block1){group_outros();transition_out(if_block1,1,1,()=>{if_block1=null;});check_outros();}if(/*$markupControlsOpacity*/ctx[10]>0){if(if_block2){if_block2.p(ctx,dirty);if(dirty[0]&/*$markupControlsOpacity*/1024){transition_in(if_block2,1);}}else{if_block2=create_if_block$2(ctx);if_block2.c();transition_in(if_block2,1);if_block2.m(div,null);}}else if(if_block2){group_outros();transition_out(if_block2,1,1,()=>{if_block2=null;});check_outros();}if(interactable_action&&is_function(interactable_action.update)&&dirty[0]&/*rootRect*/4)interactable_action.update.call(null,{drag:true,pinch:true,inertia:true,matchTarget:true,getEventPosition:/*interactable_function*/ctx[128]});},i(local){if(current)return;for(let i=0;i<each_value.length;i+=1){transition_in(each_blocks[i]);}transition_in(if_block0);transition_in(if_block1);transition_in(if_block2);current=true;},o(local){for(let i=0;i<each_blocks.length;i+=1){transition_out(each_blocks[i]);}transition_out(if_block0);transition_out(if_block1);transition_out(if_block2);current=false;},d(detaching){if(detaching)detach(div);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].d();}if(if_block0)if_block0.d();if(if_block1)if_block1.d();if(if_block2)if_block2.d();mounted=false;run_all(dispose);}};}const ROTATION_CONTROL_OFFSET=20;const MIN_TEXT_MARKUP_WIDTH=10;const shapeControlDist=16;function instance$f($$self,$$props,$$invalidate){let activeMarkup;let activeShapeId;let activeMarkupComputed;let activeMarkupItemIsDraft;let shapeProps;let shapeActivePoints;let allowResizeControls;let allowRotateControls;let allowedResizeControls;let shouldRenderShapeManipulator;let shapeActiveScreenPoints;let shapeManipulatorPoints;let shapeManipulatorRotationPoint;let shapeManipulatorRotationPointPosition;let isTextMarkupSelected;let shouldRenderTextInput;let textShapeOrigin;let textShapeDisplayOrigin;let textSizeDisplayOrigin;let textRectDisplayOrigin;let textInputText;let markupTextInputStyle;let controlledMarkupItem;let allowShapeFlip;let allowShapeChangeTextLayout;let allowShapeDuplicate;let allowShapeRemove;let allowShapeReorder;let allowShapeInput;let allowShapeAdjustOpacity;let markupControlsAnchorPosition;let shapeControlsPosition;let markupControlsStyle;let shapeControls;let shapeNavList;let $keysPressedStored;let $markupControlsOpacity;let{uid=getUniqueId()}=$$props;// used to control manipulator lines
let{ui}=$$props;let{markup}=$$props;let{offset}=$$props;let{contextRotation=0}=$$props;let{contextFlipX=false}=$$props;let{contextFlipY=false}=$$props;let{contextScale}=$$props;let{active=false}=$$props;let{opacity=1}=$$props;let{parentRect}=$$props;let{rootRect}=$$props;let{utilRect}=$$props;let{oninteractionstart=noop$1}=$$props;let{oninteractionupdate=noop$1}=$$props;let{oninteractionrelease=noop$1}=$$props;let{oninteractionend=noop$1}=$$props;let{onaddshape=noop$1}=$$props;let{onupdateshape=noop$1}=$$props;let{onselectshape=noop$1}=$$props;let{onremoveshape=noop$1}=$$props;let{beforeSelectShape=()=>true}=$$props;let{beforeDeselectShape=()=>true}=$$props;let{beforeRemoveShape=()=>true}=$$props;let{beforeUpdateShape=(shape,props)=>props}=$$props;let{willRenderShapeControls=passthrough}=$$props;let{mapEditorPointToImagePoint}=$$props;let{mapImagePointToEditorPoint}=$$props;let{eraseRadius=undefined}=$$props;let{selectRadius=undefined}=$$props;let{enableButtonFlipVertical=false}=$$props;let{enableTapToAddText=true}=$$props;let{locale}=$$props;//
// Cache
//
const updateShape=(shape,props,parentRect)=>{let propsToUpdate=beforeUpdateShape({...shape},props,{...parentRect});shapeUpdateProps(shape,propsToUpdate,parentRect);};//
// Helpers
//
const circleOverlapsWithLine=(point,radius,from,to)=>{const ac=vectorCreate(point.x-from.x,point.y-from.y);const ab=vectorCreate(to.x-from.x,to.y-from.y);const ab2=vectorDot(ab,ab);const acab=vectorDot(ac,ab);let t=acab/ab2;t=t<0?0:t;t=t>1?1:t;const h=vectorCreate(ab.x*t+from.x-point.x,ab.y*t+from.y-point.y);const h2=vectorDot(h,h);return h2<=radius*radius;};const circleOverlapsWithPath=(position,radius,points)=>{const l=points.length;for(let i=0;i<l-1;i++){if(circleOverlapsWithLine(position,radius,points[i],points[i+1]))return true;}return false;};const circleOverlapsWithPolygon=(position,radius,points)=>{// if center is in polygon
if(pointInPoly(position,points))return true;if(circleOverlapsWithPath(position,radius,points))return true;return circleOverlapsWithLine(position,radius,points[0],points[points.length-1]);};const circleOverlapsWithEllipse=(position,radius,ellipse,rotation,flipX,flipY)=>{const points=ellipseToPolygon(vectorCreate(ellipse.x,ellipse.y),ellipse.rx,ellipse.ry,rotation,flipX,flipY,12);return circleOverlapsWithPolygon(position,radius,points);};const circleOverlapsWithRect=(position,radius,rect,rotation,pivot)=>circleOverlapsWithPolygon(position,radius,rectRotate(rect,rotation,pivot||rectCenter(rect)));const shapeToPoly=(computedShape,resolution=12)=>{if(shapeIsRect(computedShape)){return rectRotate(computedShape,computedShape.rotation,rectCenter(computedShape));}else if(shapeIsText(computedShape)){const computedRect=getMarkupShapeRect(computedShape);return rectRotate(computedRect,computedShape.rotation,rectCenter(computedRect));}else if(shapeIsEllipse(computedShape)){return ellipseToPolygon(vectorCreate(computedShape.x,computedShape.y),computedShape.rx,computedShape.ry,computedShape.rotation,computedShape.flipX,computedShape.flipY,resolution);}return[];};//
// Shape creator
//
const keysPressedStored=getContext("keysPressed");component_subscribe($$self,keysPressedStored,value=>$$invalidate(137,$keysPressedStored=value));const getShapeUpdateRotation=(rotation,flipX,flipY)=>{if(rotation===0)return rotation;if(flipX&&flipY)return rotation;if(flipX)return-rotation;if(flipY)return-rotation;return rotation;};const createShape=(shapeDefault,options={})=>{// state
let interactionOrigin;let interactionRadius;let interactionPosition;let isEllipse=shapeIsEllipse(shapeDefault);let isText=shapeIsText(shapeDefault);let isRelative=options.position==="relative";if(shapeIsPath(shapeDefault)){return{start:e=>{const{origin}=e.detail;interactionRadius=4;interactionOrigin=vectorClone(origin);interactionPosition=vectorClone(origin);const originPoint=mapEditorPointToImagePoint(origin);if(isRelative){originPoint.x=isRelative?toPercentage(originPoint.x,parentRect.width):originPoint.x;originPoint.y=isRelative?toPercentage(originPoint.y,parentRect.height):originPoint.y;}// add to markup so it's drawn
addMarkupItemDraft({...shapeDefault,points:[originPoint]});},update:e=>{const draft=getMarkupItemDraft();const{translation}=e.detail;// position
const pointerPosition=vectorCreate(interactionOrigin.x+translation.x,interactionOrigin.y+translation.y);// distance between interaction and pointer if it's too close, we don't draw this point
const dist=vectorDistance(interactionPosition,pointerPosition);if(fixPrecision(dist,5)<=interactionRadius)return;// get angle between interaction and pointer
const angle=vectorAngleBetween(pointerPosition,interactionPosition);// move brush towards pointer at angle
const moveDist=interactionRadius-dist;interactionPosition.x+=moveDist*Math.cos(angle);interactionPosition.y+=moveDist*Math.sin(angle);// create point
const point=mapEditorPointToImagePoint(interactionPosition);if(point){point.x=isRelative?toPercentage(point.x,parentRect.width):point.x;point.y=isRelative?toPercentage(point.y,parentRect.height):point.y;}draft.points=draft.points.concat(point);syncShapes();},release:e=>e.detail.preventInertia(),end:e=>{if(e.detail.isTap)return discardMarkupItemDraft();const shape=confirmMarkupItemDraft();onaddshape(shape);}};}else if(isEllipse||isText||shapeIsRect(shapeDefault)){return{start:e=>{const{origin}=e.detail;// need to remember origin so we can correctly apply interaction translation
interactionOrigin=vectorClone(origin);const mappedOriginPosition=mapEditorPointToImagePoint(interactionOrigin);// add to markup so it's drawn
const draft={...shapeDefault,rotation:-1*getShapeUpdateRotation(contextRotation,contextFlipX,contextFlipY),x:isRelative?toPercentage(mappedOriginPosition.x,parentRect.width):mappedOriginPosition.x,y:isRelative?toPercentage(mappedOriginPosition.y,parentRect.height):mappedOriginPosition.y};// de-flip shape
draft.flipX=contextFlipX;draft.flipY=contextFlipY;// remove position
delete draft.position;// hide initially
draft.opacity=0;//
if(isEllipse){draft.rx=isRelative?toPercentage(0):0;draft.ry=isRelative?toPercentage(0):0;}else{draft.width=isRelative?toPercentage(0):0;draft.height=isRelative?toPercentage(0):0;}addMarkupItemDraft(draft);},update:e=>{const draft=getMarkupItemDraft();draft.opacity=1;const{aspectRatio}=draft;let{translation}=e.detail;// limit to aspect ratio
if(aspectRatio){const t=Math.abs(translation.x)*aspectRatio;translation.x=translation.x;translation.y=t*Math.sign(translation.y);}// position
const pointerPosition=vectorCreate(interactionOrigin.x+translation.x,interactionOrigin.y+translation.y);const mappedOriginPosition=mapEditorPointToImagePoint(interactionOrigin);const mappedPointerPosition=mapEditorPointToImagePoint(pointerPosition);const pivot={x:mappedOriginPosition.x+(mappedPointerPosition.x-mappedOriginPosition.x)*0.5,y:mappedOriginPosition.y+(mappedPointerPosition.y-mappedOriginPosition.y)*0.5};const rotation=getShapeUpdateRotation(contextRotation,contextFlipX,contextFlipY);vectorRotate(mappedOriginPosition,rotation,pivot);vectorRotate(mappedPointerPosition,rotation,pivot);const l=Math.min(mappedOriginPosition.x,mappedPointerPosition.x);const t=Math.min(mappedOriginPosition.y,mappedPointerPosition.y);const r=Math.max(mappedOriginPosition.x,mappedPointerPosition.x);const b=Math.max(mappedOriginPosition.y,mappedPointerPosition.y);let width=r-l;let height=b-t;let props={};if(isEllipse){props.x=l+width*0.5;props.y=t+height*0.5;props.rx=width*0.5;props.ry=height*0.5;}else{props.x=l;props.y=t;props.width=width;props.height=height;}updateShape(draft,props,parentRect);syncShapes();},release:e=>{e.detail.preventInertia();},end:e=>{const draft=getMarkupItemDraft();if(e.detail.isTap){// will cancel if is not text shape
if(!shapeIsText(draft)||!enableTapToAddText||interactionTarget)return discardMarkupItemDraft();// will add 'auto' text shape if not targetting other shape
delete draft.width;delete draft.height;delete draft.textAlign;// position the shape correctly
const draftComputedShape=shapeComputeDisplay({...draft},parentRect);const size=textSize(draft.text,draftComputedShape);size.width*=contextScale;size.height*=contextScale;const mappedOriginPosition=mapEditorPointToImagePoint({x:interactionOrigin.x,y:interactionOrigin.y-size.height*0.5});const mappedPointerPosition=mapEditorPointToImagePoint({x:interactionOrigin.x+size.width,y:interactionOrigin.y+size.height*0.5});const pivot={x:mappedOriginPosition.x+(mappedPointerPosition.x-mappedOriginPosition.x)*0.5,y:mappedOriginPosition.y+(mappedPointerPosition.y-mappedOriginPosition.y)*0.5};const rotation=getShapeUpdateRotation(contextRotation,contextFlipX,contextFlipY);vectorRotate(mappedOriginPosition,rotation,pivot);vectorRotate(mappedPointerPosition,rotation,pivot);const l=Math.min(mappedOriginPosition.x,mappedPointerPosition.x);const t=Math.min(mappedOriginPosition.y,mappedPointerPosition.y);draft.x=pintura_isString(draft.x)?toPercentage(l,parentRect.width):l;draft.y=pintura_isString(draft.y)?toPercentage(t,parentRect.height):t;}// reveal
draft.opacity=1;// finish markup
if(!shapeIsText(draft)){const shape=confirmMarkupItemDraft();onaddshape(shape);}// select the draft
selectShape(draft);// also enable editing the text
if(shapeIsText(draft))editMarkupItem(draft);}};}else if(shapeIsLine(shapeDefault)){return{start:e=>{const{origin}=e.detail;const originMapped=mapEditorPointToImagePoint(origin);const originSnapped=vectorApply(originMapped,snapToPixel);interactionOrigin=vectorClone(origin);// add to markup so it's drawn
addMarkupItemDraft({...shapeDefault,x1:isRelative?toPercentage(originSnapped.x,parentRect.width):originSnapped.x,y1:isRelative?toPercentage(originSnapped.y,parentRect.height):originSnapped.y,x2:isRelative?toPercentage(originSnapped.x,parentRect.width):originSnapped.x,y2:isRelative?toPercentage(originSnapped.y,parentRect.height):originSnapped.y,opacity:0});},update:e=>{const draft=getMarkupItemDraft();const{translation}=e.detail;const interactionTarget=vectorAdd(vectorClone(interactionOrigin),translation);// shift pressed
if($keysPressedStored.includes(16)){const length=vectorDistance(interactionOrigin,interactionTarget);const angle=vectorAngleBetween(interactionOrigin,interactionTarget);const angleSnapInterval=Math.PI/4;const angleSnapped=angleSnapInterval*Math.round(angle/angleSnapInterval);interactionTarget.x=interactionOrigin.x+length*Math.cos(angleSnapped);interactionTarget.y=interactionOrigin.y+length*Math.sin(angleSnapped);}// update line end position
const point=mapEditorPointToImagePoint(interactionTarget);updateMarkupShape(draft,{x2:isRelative?toPercentage(point.x,parentRect.width):point.x,y2:isRelative?toPercentage(point.y,parentRect.height):point.y,opacity:1});syncShapes();},release:e=>e.detail.preventInertia(),end:e=>{const draft=getMarkupItemDraft();if(e.detail.isTap)return discardMarkupItemDraft();draft.opacity=1;// finish markup
const shape=confirmMarkupItemDraft();onaddshape(shape);// select the draft
selectShape(shape);}};}};const eraseShape=()=>{let origin;let positionPrevious;return{start:e=>{origin=e.detail.origin;positionPrevious=origin;},update:e=>{const{translation}=e.detail;const positionCurrent=vectorCreate(origin.x+translation.x,origin.y+translation.y);const shapesThatCanBeErased=markup.filter(shape=>!shape.disableErase);const shapesFound=getShapesBetweenPoints(shapesThatCanBeErased,mapEditorPointToImagePoint(positionPrevious),mapEditorPointToImagePoint(positionCurrent),eraseRadius);const shapesRemoved=removeMarkupItems(shapesFound);shapesRemoved.forEach(onremoveshape);positionPrevious=vectorClone(positionCurrent);},release:e=>e.detail.preventInertia(),end:()=>{}};};//
// Mapping coordinates
//
const getImagePointWithScreenTranslation=(point,translation)=>{const pointInScreenSpace=mapImagePointToEditorPoint(point);return mapEditorPointToImagePoint(vectorAdd(pointInScreenSpace,translation));};//
// Interaction
//
// image zoom
// const handleWheel = (e) => {
// TODO: ZOOM image
// }
// image pan
// const handleImagePan = (e) => {
// TODO: PAN image
// }
//
// markup manipulate
//
const translateShape=(shapeCurrent,shapeOriginComputed,translation)=>{if(shapeIsLine(shapeCurrent)){const beginImageOffset=getImagePointWithScreenTranslation(shapeLineGetStartPoint(shapeOriginComputed),translation);const endImageOffset=getImagePointWithScreenTranslation(shapeLineGetEndPoint(shapeOriginComputed),translation);updateShape(shapeCurrent,{x1:beginImageOffset.x,y1:beginImageOffset.y,x2:endImageOffset.x,y2:endImageOffset.y},parentRect);}else if(shapeIsRect(shapeCurrent)||shapeIsText(shapeCurrent)||shapeIsEllipse(shapeCurrent)){const imagePoint=getImagePointWithScreenTranslation(shapeOriginComputed,translation);updateShape(shapeCurrent,imagePoint,parentRect);}syncShapes();};const IndexFlipXMap={0:1,1:0,2:3,3:2};const IndexFlipYMap={0:3,1:2,2:1,3:0};const resizeMarkup=(shapeCurrent,shapeOriginComputed,indexes,translation,options)=>{if(shapeIsLine(shapeCurrent)){const[targetIndex]=indexes;const snap=$keysPressedStored.includes(16)?(origin,target)=>{const length=vectorDistance(origin,target);const angle=vectorAngleBetween(origin,target);const angleSnapInterval=Math.PI/4;const angleSnapped=angleSnapInterval*Math.round(angle/angleSnapInterval)-contextRotation%angleSnapInterval;target.x=origin.x+length*Math.cos(angleSnapped);target.y=origin.y+length*Math.sin(angleSnapped);}:(origin,target)=>target;if(targetIndex===0){const point=getImagePointWithScreenTranslation(shapeLineGetStartPoint(shapeOriginComputed),translation);snap(vectorCreate(shapeOriginComputed.x2,shapeOriginComputed.y2),point);updateShape(shapeCurrent,{x1:point.x,y1:point.y},parentRect);}else if(targetIndex===1){const point=getImagePointWithScreenTranslation(shapeLineGetEndPoint(shapeOriginComputed),translation);snap(vectorCreate(shapeOriginComputed.x1,shapeOriginComputed.y1),point);updateShape(shapeCurrent,{x2:point.x,y2:point.y},parentRect);}}else if(shapeHasSize(shapeCurrent)||shapeIsEllipse(shapeCurrent)||shapeIsTextBox(shapeCurrent)){let hasAutoHeight=false;let shapeOriginRect;if(shapeIsEllipse(shapeCurrent)){shapeOriginRect=rectCreateFromEllipse(shapeOriginComputed);}else if(shapeHasSize(shapeCurrent)){shapeOriginRect=rectCreateFromAny(shapeOriginComputed);}else{// is text with 'width' only
hasAutoHeight=true;shapeOriginRect=rectCreateFromAny(shapeOriginComputed);const size=textSize(shapeOriginComputed.text,shapeOriginComputed);shapeOriginRect.height=size.height;}let shapeAspectRatio;if(shapeCurrent.aspectRatio){shapeAspectRatio=shapeCurrent.aspectRatio;}else if(options.shiftKey&&!hasAutoHeight){shapeAspectRatio=shapeOriginRect.width/shapeOriginRect.height;}// current shape
const rectAligned=rectCreateFromAny(shapeOriginRect);const rectAlignedCenterPosition=rectCenter(rectAligned);const rectRotation=shapeCurrent.rotation;const rectAlignedCorners=rectGetCorners(rectAligned);const rectCorners=rectRotate(rectAligned,rectRotation);// is translating one corner
if(indexes.length===1){// corner
let cornerIndex=indexes[0];if(shapeCurrent.flipX)cornerIndex=IndexFlipXMap[cornerIndex];if(shapeCurrent.flipY)cornerIndex=IndexFlipYMap[cornerIndex];const[tl,tr,br,bl]=rectAlignedCorners;const screenTargetPosition=mapImagePointToEditorPoint(rectCorners[cornerIndex]);vectorAdd(screenTargetPosition,translation);const imageTargetPosition=mapEditorPointToImagePoint(screenTargetPosition);const imageTargetTranslation=vectorCreate(imageTargetPosition.x-rectCorners[cornerIndex].x,imageTargetPosition.y-rectCorners[cornerIndex].y);// if (shapeCurrent.flipX) imageTargetTranslation.x = -imageTargetTranslation.x;
// if (shapeCurrent.flipY) imageTargetTranslation.y = -imageTargetTranslation.y;
const imageTargetTranslationAligned=vectorRotate(vectorClone(imageTargetTranslation),-rectRotation);const imageTargetPositionAligned=vectorCreate(rectAlignedCorners[cornerIndex].x+imageTargetTranslationAligned.x,rectAlignedCorners[cornerIndex].y+imageTargetTranslationAligned.y);let anchor;if(cornerIndex===0)anchor=br;if(cornerIndex===1)anchor=bl;if(cornerIndex===2)anchor=tl;if(cornerIndex===3)anchor=tr;// create an aligned and updated rectangle
const rectAlignedResized=rectCreateFromPoints(anchor,imageTargetPositionAligned);// limit rect
if(shapeAspectRatio){// get size that adheres to aspect ratio but still fits current rectangle
const{width,height}=rectContainRect(rectAlignedResized,shapeAspectRatio);const[t,r,b,l]=rectToBounds(rectAlignedResized);// update size
rectAlignedResized.width=width;rectAlignedResized.height=height;// align to anchor
if(imageTargetPositionAligned.y<anchor.y){rectAlignedResized.y=b-height;}if(imageTargetPositionAligned.x<anchor.x){rectAlignedResized.x=r-width;}}// rotate the aligned rectangle around it's original pivot point
const rr=rectRotate(rectAlignedResized,rectRotation,rectAlignedCenterPosition);// now calculate the new center and then rotate the tl and br corners around that center to find their new positions
const rrc=vectorCenter(rr);const p1=vectorRotate(rr[0],-rectRotation,rrc);const p2=vectorRotate(rr[2],-rectRotation,rrc);// if (shapeCurrent.flipX || shapeCurrent.flipY) {
//     vectorsFlip([p1, p2], shapeCurrent.flipX, shapeCurrent.flipY, rectAlignedCenterPosition.x, rectAlignedCenterPosition.y)
// }
const rectUpdated=rectCreateFromPoints(p1,p2);updateShape(shapeCurrent,shapeIsEllipse(shapeCurrent)?ellipseCreateFromRect(rectUpdated):rectUpdated,parentRect);}else// is translating two corner points
{// 0-1 -> 2-3
// 1-2 -> 3-0
// 2-3 -> 0-1
// 3-0 -> 1-2
indexes=indexes.map(index=>{if(shapeCurrent.flipX)index=IndexFlipXMap[index];if(shapeCurrent.flipY)index=IndexFlipYMap[index];return index;});const[cornerA,cornerB]=indexes.map(index=>rectCorners[index]);const mid={x:cornerA.x+(cornerB.x-cornerA.x)*0.5,y:cornerA.y+(cornerB.y-cornerA.y)*0.5};const[cornerAlignedA,cornerAlignedB]=indexes.map(index=>rectAlignedCorners[index]);const[cornerAlignedC,cornerAlignedD]=indexes.map(index=>{const mappedIndex=index+2;if(mappedIndex<4)return rectAlignedCorners[mappedIndex];return rectAlignedCorners[mappedIndex-4];});// const midAligned = {
//     x: cornerAlignedA.x + (cornerAlignedB.x - cornerAlignedA.x) * .5,
//     y: cornerAlignedA.y + (cornerAlignedB.y - cornerAlignedA.y) * .5
// };
const midAnchorAligned={x:cornerAlignedC.x+(cornerAlignedD.x-cornerAlignedC.x)*0.5,y:cornerAlignedC.y+(cornerAlignedD.y-cornerAlignedC.y)*0.5};const screenTargetPosition=mapImagePointToEditorPoint(mid);vectorAdd(screenTargetPosition,translation);const imageTargetPosition=mapEditorPointToImagePoint(screenTargetPosition);const imageTargetTranslation=vectorCreate(imageTargetPosition.x-mid.x,imageTargetPosition.y-mid.y);// if (shapeCurrent.flipX) imageTargetTranslation.x = -imageTargetTranslation.x;
// if (shapeCurrent.flipY) imageTargetTranslation.y = -imageTargetTranslation.y;
const imageTargetTranslationAligned=vectorRotate(vectorClone(imageTargetTranslation),-rectRotation);// const imageTargetPositionAligned = vectorCreate(
//     midAligned.x + imageTargetTranslationAligned.x,
//     midAligned.y + imageTargetTranslationAligned.y,
// );
const d=vectorSubtract(vectorClone(cornerAlignedA),cornerAlignedB);const f=vectorApply(d,v=>1-Math.abs(Math.sign(v)));const t=vectorCreate(imageTargetTranslationAligned.x*f.x,imageTargetTranslationAligned.y*f.y);vectorAdd(cornerAlignedA,t);vectorAdd(cornerAlignedB,t);const rectAlignedResized=rectCreateFromPoints(rectAlignedCorners);// limit rect
if(shapeAspectRatio){let width=rectAlignedResized.width;let height=rectAlignedResized.height;if(f.y===0){height=width/shapeAspectRatio;}else{width=height*shapeAspectRatio;}// update size
rectAlignedResized.width=width;rectAlignedResized.height=height;// align to anchor
if(f.y===0){rectAlignedResized.y=midAnchorAligned.y-height*0.5;}else{rectAlignedResized.x=midAnchorAligned.x-width*0.5;}}// rotate the aligned rectangle around it's original pivot point
const rr=rectRotate(rectAlignedResized,rectRotation,rectAlignedCenterPosition);// now calculate the new center and then rotate the tl and br corners around that center to find their new positions
const rrc=vectorCenter(rr);const p1=vectorRotate(rr[0],-rectRotation,rrc);const p2=vectorRotate(rr[2],-rectRotation,rrc);// if (shapeCurrent.flipX || shapeCurrent.flipY) {
//     vectorsFlip([p1, p2], shapeCurrent.flipX, shapeCurrent.flipY, rectAlignedCenterPosition.x, rectAlignedCenterPosition.y)
// }
const rectUpdated=rectCreateFromPoints(p1,p2);let props;if(shapeIsEllipse(shapeCurrent)){props=ellipseCreateFromRect(rectUpdated);}else if(shapeHasSize(shapeCurrent)){props=rectUpdated;}else if(hasAutoHeight){props={x:rectUpdated.x,y:rectUpdated.y,width:rectUpdated.width};}updateShape(shapeCurrent,props,parentRect);}}syncShapes();};let rotatorInitialPosition;const rotateMarkup=(shapeCurrent,shapeOriginComputed,translation,options)=>{// calculate angle between translated rotation control and origin
const shapeRect=getMarkupShapeRect(shapeComputeDisplay(shapeDeepCopy(shapeCurrent),parentRect));const shapeCenter=rectCenter(shapeRect);const p=getImagePointWithScreenTranslation(rotatorInitialPosition,translation);let shapeRotation=vectorAngleBetween(p,shapeCenter)+Math.PI/2;if(options.shiftKey){const rotatorSnapInterval=Math.PI/16;shapeRotation=rotatorSnapInterval*Math.round(shapeRotation/rotatorSnapInterval)-contextRotation%rotatorSnapInterval;}updateShape(shapeCurrent,{rotation:shapeRotation},parentRect);syncShapes();};const getMarkupItemDraft=()=>{if(!markup.length)return;return markup.find(shapeIsDraft);};const getMarkupItemDraftIndex=()=>{if(!markup.length)return;return markup.findIndex(shapeIsDraft);};const addMarkupItemDraft=(shape,sync=true)=>{if(getMarkupItemDraft())return;shapeMakeDraft(shape);return addShape(shape,sync);};const confirmMarkupItemDraft=()=>{const markupItem=getMarkupItemDraft();if(!markupItem)return;shapeMakeFinal(markupItem);syncShapes();return markupItem;};const discardMarkupItemDraft=()=>{if(!getMarkupItemDraft())return;markup.splice(getMarkupItemDraftIndex(),1);syncShapes();};const createMarkupItem=(props={})=>({id:getUniqueId(),...props});const syncShapes=()=>$$invalidate(0,markup);const addShape=(shape,sync=true)=>{markup.push(shape);// sync markup array
if(sync)syncShapes();return shape;};const removeMarkupShapeProps=(shape,props=[],sync=true)=>{props.forEach(prop=>delete shape[prop]);// sync markup array
if(!sync)return;syncShapes();};const updateMarkupShape=(shape,props,sync=true)=>{// update markup
shape=Object.assign(shape,props);// sync markup array
if(!sync)return;syncShapes();};const updateMarkupShapeProperty=(shape,name,value,sync=true)=>{shape[name]=value;// sync markup array
if(!sync)return;syncShapes();};const updateMarkupItemsShapeProperty=(name,value,sync=true)=>{markup.forEach(shape=>updateMarkupShapeProperty(shape,name,value,false));// sync markup array
if(!sync)return;syncShapes();};const updateMarkupShapeItems=(props,sync=true)=>{markup.forEach(markupItem=>updateMarkupShape(markupItem,props,false));// sync markup array
if(!sync)return;syncShapes();};const getActiveMarkupItem=()=>[...markup].reverse().find(shapeIsSelected);const hasActiveMarkupItem=()=>!!getActiveMarkupItem();const removeShape=shapeToRemove=>{if(!beforeRemoveShape(shapeToRemove))return false;$$invalidate(0,markup=markup.filter(shape=>shape!==shapeToRemove));onremoveshape(shapeToRemove);};const removeActiveMarkupItem=()=>{const activeShape=getActiveMarkupItem();if(!activeShape)return;// get removable markup items,
const removableShapes=markup.filter(shape=>shapeCanRemove(shape)&&shapeCanSelect(shape));// find index of active shape so we can select the next active shape on removal
const index=removableShapes.findIndex(shape=>shape===activeShape);// remove the active ship from the shape array
const didRemove=removeShape(activeShape);if(didRemove===false)return;// remember selection
previousSelectedShape=activeShape;// if no more markup items, release active shape
if(removableShapes.length-1<=0)return blurShapes();// select next active markup item
const indexNext=index-1<0?removableShapes.length-1:index-1;selectShape(removableShapes[indexNext]);};let previousSelectedShape=undefined;const blurShapes=()=>{// clear text state cache, when a text shape is blurred the changes are confirmed
Object.keys(ShapeTextStateCache).forEach(key=>ShapeTextStateCache[key]={});// remember shape
previousSelectedShape=getSelectedShape();updateMarkupShapeItems({isSelected:false,isEditing:false});};const getSelectedShape=()=>markup.find(shapeIsSelected);const selectShape=(shape,sync=true)=>{// can't select draft
if(shapeIsDraft(shape))return;// get currently selected shape
const selectedShape=getSelectedShape()||previousSelectedShape;// reset previous selected shape
previousSelectedShape=undefined;// if is returned false will cancel select operation
if(!beforeSelectShape(selectedShape,shape))return;// remove selected state from other markup
blurShapes();// select
shapeSelect(shape);// selected this shape
onselectshape(shape);// sync
if(!sync)return;syncShapes();};const deselectMarkupItem=markupItem=>{updateMarkupShape(markupItem,{isSelected:false,isEditing:false});};const editMarkupItem=markupItem=>{updateMarkupShape(markupItem,{isSelected:true,isEditing:true});};const finishEditMarkupItem=markupItem=>{updateMarkupShape(markupItem,{isSelected:true,isEditing:false});};const removeMarkupItems=shapesToRemove=>{const shapesToRemoveFiltered=shapesToRemove.filter(beforeRemoveShape);$$invalidate(0,markup=markup.filter(shape=>!shapesToRemoveFiltered.includes(shape)));return shapesToRemoveFiltered;};const getTextShapeRect=shape=>{const size=textSize(shape.text,shape);return rectCreate(shape.x,shape.y,shape.width?Math.min(shape.width,size.width):size.width,shape.height?Math.min(shape.height,size.height):size.height);};const getMarkupShapeRect=shape=>{// has own rect
if(shapeHasSize(shape))return rectCreateFromAny(shape);if(shapeIsEllipse(shape))return rectCreateFromEllipse(shape);// calculate the size on canvas
const rect=getTextShapeRect(shape);rect.width=Math.max(MIN_TEXT_MARKUP_WIDTH,shape.width||rect.width);return rect;};const getShapesNearPosition=(position,range=0)=>[...markup].// reverse the array, want to select from top to bottom
reverse().map(shape=>({shape,priority:1})).// can't select paths
filter(result=>shapeCanSelect(result.shape)).// find markup near pointer
filter(result=>{// get shape
const{shape}=result;// we need to know where the shape will end up
const computedShape=shapeComputeDisplay(shapeDeepCopy(shape),parentRect);// add stroke width to range
const r=range+(computedShape.strokeWidth||0);// test if clicked in rect
if(shapeIsRect(computedShape)){return circleOverlapsWithRect(position,r,computedShape,shape.rotation);}else if(shapeIsText(computedShape)){const shapeRect=getMarkupShapeRect(computedShape);const isPositionInBounds=circleOverlapsWithRect(position,r,shapeRect,shape.rotation);let isPositionInVisual=false;if(isPositionInBounds&&!shapeIsSelected(shape)){const visualRect=getTextShapeRect(computedShape);if(shape.textAlign==="right"&&!shape.flipX){visualRect.x=shapeRect.x+shapeRect.width-visualRect.width;}if(shape.textAlign==="center"){visualRect.x=shapeRect.x+shapeRect.width*0.5-visualRect.width*0.5;}isPositionInVisual=circleOverlapsWithRect(position,r,visualRect,shape.rotation,rectCenter(shapeRect));if(!isPositionInVisual)result.priority=-1;}return isPositionInBounds;}else// test if is ellipse
if(shapeIsEllipse(computedShape)){return circleOverlapsWithEllipse(position,r,computedShape,shape.rotation,shape.flipX,shape.flipY);}else// test if clicked on line
if(shapeIsLine(computedShape)){// radius around click position, test if line intersects
return circleOverlapsWithLine(position,Math.max(16,r),shapeLineGetStartPoint(computedShape),shapeLineGetEndPoint(computedShape));// always increase range when selecting lines
}else if(shapeIsPath(computedShape)){// radius around click position, test if line intersects
return circleOverlapsWithPath(position,Math.max(16,r),computedShape.points);// always increase range when selecting lines
}return false;}).sort((a,b)=>{if(a.priority<b.priority)return 1;if(a.priority>b.priority)return-1;return 0;});const getShapesBetweenPoints=(shapes,a,b,range=0)=>{// make sure range is not negative
const r=Math.abs(range);// eraseLine should be in image space
const eraseLine=lineExtend(lineCreate(a,b),r);// create line polygon
const erasePoly=lineExtrude(eraseLine,r);// loop over shapes and find intersecting shapes
return shapes.// .filter(shapeCanErase)
filter(shape=>{const computedShape=shapeComputeDisplay(shapeDeepCopy(shape),parentRect);// if shape is line or path
if(shapeIsLine(computedShape)||shapeIsPath(computedShape)){const points=computedShape.points?[...computedShape.points]:[shapeLineGetStartPoint(computedShape),shapeLineGetEndPoint(computedShape)];return!!linePointsIntersection(eraseLine,points);}// else turn into polygon and compare polygons
return polyIntersectsWithPoly(erasePoly,shapeToPoly(computedShape));});};//
// Generic interaction
//
let interactionTimer=undefined;let interactionTarget=undefined;let interactionShape=undefined;let interactionShapeOrigin=undefined;let interactionShapeOriginComputed=undefined;let isInteracting=false;const handleInteractionStart=e=>{const{origin}=e.detail;interactionShape=undefined;interactionShapeOrigin=undefined;interactionShapeOriginComputed=undefined;interactionTarget=undefined;clearTimeout(interactionTimer);interactionTimer=setTimeout(()=>$$invalidate(99,isInteracting=true),250);// if is editing text
const draft=getMarkupItemDraft();if(draft)confirmMarkupItemDraft();// test if target is a shape, if not, run interaction handler
const point=mapEditorPointToImagePoint(vectorClone(origin));const foundShapes=getShapesNearPosition(point,selectRadius);const targettedMarkupItem=foundShapes.length&&foundShapes.shift().shape;// check if markup was targetted
if(targettedMarkupItem&&shapeIsSelected(targettedMarkupItem)){interactionShape=targettedMarkupItem;// create a deep copy so we can check on end interaction if the shape was changed
interactionShapeOrigin=shapeDeepCopy(interactionShape);// clone shape we're interacting with so we can update it properly
interactionShapeOriginComputed=shapeComputeDisplay(shapeDeepCopy(interactionShape),parentRect);return;}// set target
interactionTarget=targettedMarkupItem;// started interacting
const didStartInteraction=oninteractionstart(e);// drag current targetted it as fallback interaction, helps make sticker interaction easier
if(!didStartInteraction&&targettedMarkupItem){selectShape(targettedMarkupItem);interactionShape=targettedMarkupItem;// create a deep copy so we can check on end interaction if the shape was changed
interactionShapeOrigin=shapeDeepCopy(interactionShape);// clone shape we're interacting with so we can update it properly
interactionShapeOriginComputed=shapeComputeDisplay(shapeDeepCopy(interactionShape),parentRect);}};const handleInteractionUpdate=e=>{// is interacting with shape
if(interactionShape){// prevent moving if not allowed
if(!shapeCanMove(interactionShape))return;// prevent moving if is editing text
if(shapeIsTextEditing(interactionShape))return;return translateShape(interactionShape,interactionShapeOriginComputed,e.detail.translation);}oninteractionupdate(e);};const handleInteractionRelease=e=>{clearTimeout(interactionTimer);$$invalidate(99,isInteracting=false);// test if is text and if we double tapped, if so, switch to text edit mode
if(interactionShape){if(interactionShape.isEditing){handleTextCancel();}else if(e.detail.isDoubleTap&&shapeIsText(interactionShape)&&shapeCanInput(interactionShape)!==false){editMarkupItem(interactionShape);}return;}oninteractionrelease(e);};const handleInteractionEnd=e=>{const isSelectInteraction=interactionTarget&&e.detail.isTap;// shape remains active so user can resize, rotate
if(interactionShape){if(!shapeEqual(interactionShape,interactionShapeOrigin))onupdateshape(interactionShape);interactionShape=undefined;return;}// can we deselect the current shape?
const currentSelectedShape=getSelectedShape();const allowDeselectShape=currentSelectedShape?beforeDeselectShape(currentSelectedShape,interactionTarget):true;if(allowDeselectShape){blurShapes();}oninteractionend(e);if(allowDeselectShape&&isSelectInteraction){selectShape(interactionTarget);}};//
// Shape manipulation
//
const getMarkupShapePoints=shape=>{let points;if(shapeIsRect(shape)){const center=rectCenter(shape);points=rectGetCorners(shape);if(shape.flipX||shape.flipY)vectorsFlip(points,shape.flipX,shape.flipY,center.x,center.y);points=vectorsRotate(points,shape.rotation,center.x,center.y);}else if(shapeIsEllipse(shape)){const center=shape;points=rectGetCorners(rectCreateFromEllipse(shape));if(shape.flipX||shape.flipY)vectorsFlip(points,shape.flipX,shape.flipY,center.x,center.y);points=vectorsRotate(points,shape.rotation,center.x,center.y);}else if(shapeIsLine(shape)){points=[shapeLineGetStartPoint(shape),shapeLineGetEndPoint(shape)];}else if(shapeIsPath(shape)){points=[...shape.points];}else if(shapeIsText(shape)){const rect=getMarkupShapeRect(shape);rect.width=Math.max(MIN_TEXT_MARKUP_WIDTH,rect.width);const center=rectCenter(rect);points=rectGetCorners(rect);if(shape.flipX||shape.flipY)vectorsFlip(points,shape.flipX,shape.flipY,center.x,center.y);points=vectorsRotate(points,shape.rotation,center.x,center.y);}return points;};const getShapeRotationPoint=shape=>{const points=getMarkupShapePoints(shape);let origin;let dir;if(shape.flipY){origin=vectorCenter([points[0],points[1]]);dir=vectorNormalize(vectorCreate(points[1].x-points[2].x,points[1].y-points[2].y));}else{origin=vectorCenter([points[2],points[3]]);dir=vectorNormalize(vectorCreate(points[2].x-points[1].x,points[2].y-points[1].y));}vectorMultiply(dir,ROTATION_CONTROL_OFFSET/contextScale);return{origin,dir};};const getShapeRotationPointOnScreen=shape=>{const markupPoint=getShapeRotationPoint(shape);const screenPosition=mapImagePointToEditorPoint({x:markupPoint.origin.x+markupPoint.dir.x,y:markupPoint.origin.y+markupPoint.dir.y});const screenOrigin=mapImagePointToEditorPoint(markupPoint.origin);return{origin:screenOrigin,position:screenPosition};};// draw shape manipulator edges
let shapeManipulatorUid=`markup-manipulator-segment`;const claimManipulatorLines=()=>{$$invalidate(42,ui=ui.map(shape=>{if(shape.id!==shapeManipulatorUid)return shape;shape._group=uid;return shape;}));};const shouldManipulateLines=()=>!!ui.find(segment=>segment._group===uid);const redrawManipulatorLines=opacity=>{// get current line opacity
const current=ui.find(segment=>segment.id===shapeManipulatorUid);const manipulatorOpacity=current?Math.max(current.opacity,opacity):opacity;// create manipulator outline segments
const segments=[];const shadowOpacity=0.1*manipulatorOpacity;const lineOpacity=manipulatorOpacity;const strokeColorShadow=[0,0,0];const strokeColor=[1,1,1];const strokeWidth=1.5;const pathClose=shapeIsPath(activeMarkup)||shapeIsLine(activeMarkup)?false:true;// shadows
segments.push({id:shapeManipulatorUid,points:shapeActiveScreenPoints.map(p=>vectorCreate(p.x+1,p.y+1)),pathClose,strokeColor:strokeColorShadow,strokeWidth:2,opacity:shadowOpacity,_group:uid});if(shapeManipulatorRotationPoint){// add rotator line shadow
segments.push({id:shapeManipulatorUid,points:[vectorCreate(shapeManipulatorRotationPoint.origin.x+1,shapeManipulatorRotationPoint.origin.y+1),vectorCreate(shapeManipulatorRotationPoint.position.x+1,shapeManipulatorRotationPoint.position.y+1)],strokeColor:strokeColorShadow,strokeWidth:2,opacity:shadowOpacity,_group:uid});}// lines
segments.push({id:shapeManipulatorUid,points:shapeActiveScreenPoints,pathClose,strokeColor,strokeWidth,opacity:lineOpacity,_group:uid});if(shapeManipulatorRotationPoint){// add rotator line
segments.push({id:shapeManipulatorUid,points:[{x:shapeManipulatorRotationPoint.origin.x,y:shapeManipulatorRotationPoint.origin.y},{x:shapeManipulatorRotationPoint.position.x,y:shapeManipulatorRotationPoint.position.y}],strokeColor,strokeWidth,opacity:lineOpacity,_group:uid});}// replace existing segments
$$invalidate(42,ui=[...ui.filter(guide=>guide.id!==shapeManipulatorUid),...segments]);};const removeMarkupManipulatorLines=()=>{$$invalidate(42,ui=ui.filter(guide=>guide.opacity===0&&guide.id!==shapeManipulatorUid));};onDestroy(()=>{// clean up invisible lines
removeMarkupManipulatorLines();});const handleManipulatorResizeGrab=e=>{$$invalidate(99,isInteracting=true);interactionShape=activeMarkup;interactionShapeOriginComputed=activeMarkupComputed;};const handleManipulatorResizeDrag=e=>{const{translation,indexes,shiftKey}=e.detail;resizeMarkup(interactionShape,interactionShapeOriginComputed,indexes,translation,{shiftKey});};const handleManipulatorResizeEnd=e=>{selectShape(interactionShape);interactionShape=undefined;$$invalidate(99,isInteracting=false);onupdateshape(activeMarkup);};const handleManipulatorRotateGrab=e=>{rotatorInitialPosition=getShapeRotationPoint(activeMarkupComputed).origin;$$invalidate(99,isInteracting=true);interactionShape=activeMarkup;interactionShapeOriginComputed=activeMarkupComputed;};const handleManipulatorRotateDrag=e=>{const{translation,shiftKey}=e.detail;rotateMarkup(interactionShape,interactionShapeOriginComputed,translation,{shiftKey});};const handleManipulatorRotateEnd=()=>{selectShape(interactionShape);interactionShape=undefined;$$invalidate(99,isInteracting=false);onupdateshape(activeMarkup);};//
// Keyboard
//
const handleKey=e=>{// only handle key input if a shape has been selected
if(!hasActiveMarkupItem())return;// get key type
const{key}=e;// if is escape deselect active item
if(/escape/i.test(key)){return deselectMarkupItem(activeMarkup);}// if is tab, select next markup item
/*
    if (/arrow/i.test(key)) {
const success = e.shiftKey 
    ? selectPreviousMarkupItem(activeMarkup)
    : selectNextMarkupItem(activeMarkup);

if (success) {
    e.preventDefault();
    e.stopPropagation();
}
    }
    */// if is remove active
if(/backspace/i.test(key)&&!/input|textarea/i.test(e.target.nodeName)){// prevent back navigation on Firefox
e.preventDefault();// remove the item
removeActiveMarkupItem();}};//
// Text input
//
let textInput;const getTextShapeOriginSnapshot=()=>({...activeMarkup});const handleTextInput=()=>{const value=shapeIsTextLine(activeMarkup)?filterNewlines(textInput.value):textInput.value;const canInput=shapeCanInput(activeMarkup,value);const text=canInput===true?value:canInput;let x=textShapeDisplayOrigin.x;let y=textShapeDisplayOrigin.y;// if does not have height we need to adjust offset if is rotated
if(!activeMarkup.height){// draw origin rect
const originRotatedRect=rectRotate({...textRectDisplayOrigin},activeMarkup.rotation);// draw current rect
const size=textSize(text,activeMarkupComputed);const currentRotatedRect=rectRotate({x,y,...size},activeMarkup.rotation);const[originTopLeft,,originBottomRight]=originRotatedRect;const[currentTopLeft,,currentBottomRight]=currentRotatedRect;let a=originTopLeft;let b=currentTopLeft;// if flipped we need to 'extend' the text field in the opposite direction
if(activeMarkup.flipX){a=originBottomRight;b=currentBottomRight;}// move
const d=vectorSubtract(vectorClone(a),b);x+=d.x;y+=d.y;}updateMarkupShape(activeMarkup,{x:pintura_isString(textShapeOrigin.x)?toPercentage(x,parentRect.width):x,y:pintura_isString(textShapeOrigin.y)?toPercentage(y,parentRect.height):y,text});};const getShapeSizeTranslation=(originRect,targetRect,{flipX,flipY,rotation},anchor="top left")=>{let a,b;// draw origin rect
const[originTopLeft,originTopRight,originBottomRight,originBottomLeft]=rectRotate(originRect,rotation);// draw target rect
const[targetTopLeft,targetTopRight,targetBottomRight,targetBottomLeft]=rectRotate(targetRect,rotation);if(anchor==="top center"){// for now doesn't matter if it's flipped horizontal
const originMid=vectorCenter(flipY?[originBottomLeft,originBottomRight]:[originTopLeft,originTopRight]);const targetMid=vectorCenter(flipY?[targetBottomLeft,targetBottomRight]:[targetTopLeft,targetTopRight]);a=originMid;b=targetMid;}else if(anchor==="top right"&&!flipX||anchor==="top left"&&flipX){// tr
a=flipY?originBottomRight:originTopRight;b=flipY?targetBottomRight:targetTopRight;}else{// tl
a=flipY?originBottomLeft:originTopLeft;b=flipY?targetBottomLeft:targetTopLeft;}return vectorSubtract(vectorClone(a),b);};const translateRelative=(current,position,translation)=>vectorCreate(pintura_isString(current.x)?toPercentage(position.x+translation.x,parentRect.width):position.x+translation.x,pintura_isString(current.y)?toPercentage(position.y+translation.y,parentRect.height):position.y+translation.y);const ShapeTextStateCache={};const handleTextSwitchLayout=()=>{const shapeTextSize=textSize(activeMarkup.text,activeMarkupComputed);const isFixedBox=hasProp(activeMarkup,"height");const isAutoHeightBox=!isFixedBox&&hasProp(activeMarkup,"width");// set/get cache entries for this text shapw
const key=activeMarkup.id;let cache=ShapeTextStateCache[key];if(!cache){ShapeTextStateCache[key]={};cache=ShapeTextStateCache[key];}const toAutoWidth=sizeFrom=>{const{width,...autoSizeProps}=activeMarkupComputed;const sizeTo=textSize(activeMarkup.text,autoSizeProps);// this will change dimensions so if rotated we have to calculate new position
const translation=getShapeSizeTranslation(rectCreate(activeMarkupComputed.x,activeMarkupComputed.y,sizeFrom.width,sizeFrom.height),rectCreate(activeMarkupComputed.x,activeMarkupComputed.y,sizeTo.width,sizeTo.height),activeMarkupComputed,`top ${activeMarkup.textAlign}`);// switch to auto mode
removeMarkupShapeProps(activeMarkup,["width","height","textAlign"]);// update position based on size translation
updateMarkupShape(activeMarkup,{...translateRelative(activeMarkup,activeMarkupComputed,translation)});};const toAutoHeight=sizeFrom=>{// -> switch to auto height mode
const sizeTo=sizeCreate(cache.width||activeMarkupComputed.width||shapeTextSize.width,shapeTextSize.height);const textAlign=cache.textAlign||"left";// this will change dimensions so if rotated we have to calculate new position
const translation=getShapeSizeTranslation(rectCreate(activeMarkupComputed.x,activeMarkupComputed.y,sizeFrom.width,sizeFrom.height),rectCreate(activeMarkupComputed.x,activeMarkupComputed.y,sizeTo.width,sizeTo.height),activeMarkupComputed,`top ${textAlign}`);// switch to auto-height mode
removeMarkupShapeProps(activeMarkup,["height"]);// update position based on size translation
updateMarkupShape(activeMarkup,{...translateRelative(activeMarkup,activeMarkupComputed,translation),width:pintura_isString(activeMarkup.width)?toPercentage(sizeTo.width,parentRect.width):sizeTo.width,textAlign});};const toFixedSize=sizeFrom=>{// this can change dimensions so we need to recalculate position
const sizeTo=sizeCreate(cache.width||shapeTextSize.width,cache.height||shapeTextSize.height);const textAlign=cache.textAlign||"left";// this will change dimensions so if rotated we have to calculate new position
const translation=getShapeSizeTranslation(rectCreate(activeMarkupComputed.x,activeMarkupComputed.y,sizeFrom.width,sizeFrom.height),rectCreate(activeMarkupComputed.x,activeMarkupComputed.y,sizeTo.width,sizeTo.height),activeMarkupComputed,`top ${textAlign}`);// switch to fixed box, use stored alignment or default to left text align
updateMarkupShape(activeMarkup,{...translateRelative(activeMarkup,activeMarkupComputed,translation),width:pintura_isString(activeMarkup.width)?toPercentage(sizeTo.width,parentRect.width):sizeTo.width,height:pintura_isString(activeMarkup.width)?toPercentage(sizeTo.height,parentRect.height):sizeTo.height,textAlign});};if(isFixedBox){// store size so we can restore it later
cache.textAlign=activeMarkup.textAlign;cache.width=activeMarkupComputed.width;cache.height=activeMarkupComputed.height;const sizeFrom=sizeCreate(activeMarkupComputed.width,activeMarkupComputed.height);if(shapeCanChangeTextLayout(activeMarkup,"auto-height")){toAutoHeight(sizeFrom);}else if(shapeCanChangeTextLayout(activeMarkup,"auto-width")){toAutoWidth(sizeFrom);}}else if(isAutoHeightBox){// store alignment so we can restore it later
cache.textAlign=activeMarkup.textAlign;cache.width=activeMarkupComputed.width;// -> switch to auto width
const sizeFrom=sizeCreate(activeMarkupComputed.width,shapeTextSize.height);if(shapeCanChangeTextLayout(activeMarkup,"auto-width")){toAutoWidth(sizeFrom);}else if(shapeCanChangeTextLayout(activeMarkup,"fixed-size")){toFixedSize(sizeFrom);}}else{// -> switch to fixed size or auto height
const sizeFrom=sizeCreate(shapeTextSize.width,shapeTextSize.height);if(shapeCanChangeTextLayout(activeMarkup,"fixed-size")){toFixedSize(sizeFrom);}else if(shapeCanChangeTextLayout(activeMarkup,"auto-height")){toAutoHeight(sizeFrom);}}};const handleEditTextActiveMarkup=()=>editMarkupItem(activeMarkup);const handleTextInputAttempt=e=>{const currentValue=e.target.value;const selectionStart=e.target.selectionStart;const selectionEnd=e.target.selectionEnd;const currentValueStart=currentValue.substring(0,selectionStart);const currentValueEnd=currentValue.substring(selectionEnd);const intendedValue=currentValueStart+e.key+currentValueEnd;const filteredValue=shapeCanInput(activeMarkup,intendedValue);if(filteredValue!==intendedValue)return e.preventDefault();};const filterNewlines=value=>{const lines=value.// split on lines so we can create compressed normal line of text
split(/[\n\r]/g);if(lines.length>1){return lines.// remove spaces around lines
map(str=>str.trim()).// remove empty strings
filter(str=>str.length).// create new line
join(" ");}// just return line
return lines[0];};// prevent moving shape when focusing text field, and close field if escape pressed
const handleTextInputKeyDown=e=>{if(shapeIsTextLine(activeMarkup)&&/enter/i.test(e.code))return e.preventDefault();if(/arrow/i.test(e.code))return e.stopPropagation();if(/escape/i.test(e.key))return handleTextCancel();};// handle alt/ctrl/cmd + return
const handleTextInputKeyUp=e=>{// get key type
const{key,ctrlKey,altKey}=e;// confirm multi line text elements
if(/enter/i.test(key)&&ctrlKey|altKey)return handleTextConfirm();};const handleTextConfirm=()=>{// if was draft, now need to confirm
let wasDraft=shapeIsDraft(activeMarkup);if(shapeIsDraft(activeMarkup))confirmMarkupItemDraft();// final text input check
handleTextInput();// done
finishEditMarkupItem(activeMarkup);if(wasDraft)onaddshape(activeMarkup);else onupdateshape(activeMarkup);};const handleTextCancel=()=>{if(shapeIsDraft(activeMarkup)){discardMarkupItemDraft();}else{updateMarkupShape(activeMarkup,{text:textShapeOrigin.text,x:textShapeOrigin.x,y:textShapeOrigin.y});finishEditMarkupItem(activeMarkup);}};//
// Controls
//
const handleFlipX=e=>{e.stopPropagation();const flipX=activeMarkup.flipX||false;updateMarkupShapeProperty(activeMarkup,"flipX",!flipX);onupdateshape(activeMarkup);};const handleFlipY=e=>{e.stopPropagation();const flipY=activeMarkup.flipY||false;updateMarkupShapeProperty(activeMarkup,"flipY",!flipY);onupdateshape(activeMarkup);};const handleAdjustOpacity=value=>{updateMarkupShapeProperty(activeMarkup,"opacity",value);onupdateshape(activeMarkup);};const handleRemoveActiveMarkup=e=>{e.stopPropagation();e.target.blur();// cancels focus of remove button
removeActiveMarkupItem();};const handleMoveToFrontActiveMarkup=e=>{e.stopPropagation();// test if is not already at top of stack, if so, exit
const index=markup.findIndex(shape=>shape===activeMarkup);if(index===markup.length-1)return;// add to last index
$$invalidate(0,markup=markup.filter(markupItem=>markupItem!==activeMarkup).concat([activeMarkup]));onupdateshape(activeMarkup);};const handleDuplicateActiveMarkup=e=>{e.stopPropagation();// create clone
const clone=shapeDeepCopy(activeMarkup);clone.id=getUniqueId();const duplicationOffset=vectorCreate(50,-50);// offset
if(shapeIsLine(clone)){const linePosition=shapeGetPropsPixelValues(clone,["x1","y1","x2","y2"],parentRect);linePosition.x1+=duplicationOffset.x;linePosition.y1+=duplicationOffset.y;linePosition.x2+=duplicationOffset.x;linePosition.y2+=duplicationOffset.y;shapeUpdateProps(clone,linePosition,parentRect);}else{const currentPosition=shapeGetPropsPixelValues(clone,["x","y"],parentRect);currentPosition.x+=50;currentPosition.y-=50;shapeUpdateProps(clone,currentPosition,parentRect);}// add clone
markup.push(clone);// added
onaddshape(clone);// select clone
selectShape(clone);};const getMarkupControlsAnchorPosition=rect=>vectorApply(vectorCreate(rect.x+rect.width*0.5,rect.y),snapToPixel);//
// show & position markup controls panel
//
const markupControlsOpacity=spring(0,{stiffness:0.2,damping:0.7});component_subscribe($$self,markupControlsOpacity,value=>$$invalidate(10,$markupControlsOpacity=value));let shapeControlsSize;const getShapeControlPositionOnCanvas=position=>{const left=utilRect.x;const top=utilRect.y;const right=left+utilRect.width;let x=Math.max(position.x-shapeControlsSize.width*0.5,left);let y=Math.max(position.y-shapeControlsSize.height-shapeControlDist,top);if(x+shapeControlsSize.width>right)x=right-shapeControlsSize.width;return vectorCreate(x,y);};const TextLayoutChangeIcon=(locale,shape)=>{const{disableTextLayout=[]}=shape;// is fixed size
if("height"in shape){if(disableTextLayout.includes("auto-height")){// next is auto-width, no need to set as is empty
return locale.shapeIconButtonTextLayoutAutoWidth;}else{// next is auto-height
return locale.shapeIconButtonTextLayoutAutoHeight;}}else// is auto-height
if("width"in shape){if(disableTextLayout.includes("auto-width")){// next is fixed-size
return locale.shapeIconButtonTextLayoutFixedSize;}else{// next is auto-width, no need to set as is empty
return locale.shapeIconButtonTextLayoutAutoWidth;}}else// is auto-width
{// next is fixed-size
if(disableTextLayout.includes("fixed-size")){// next is fixed-size
return locale.shapeIconButtonTextLayoutAutoHeight;}else{// next is auto-width, no need to set as is empty
return locale.shapeIconButtonTextLayoutFixedSize;}}};const TextLayoutChangeLabel=(locale,shape)=>{const{disableTextLayout=[]}=shape;// is fixed size
if("height"in shape){if(disableTextLayout.includes("auto-height")){// next is auto-width, no need to set as is empty
return locale.shapeTitleButtonTextLayoutAutoWidth;}else{// next is auto-height
return locale.shapeTitleButtonTextLayoutAutoHeight;}}else// is auto-height
if("width"in shape){if(disableTextLayout.includes("auto-width")){// next is fixed-size
return locale.shapeTitleButtonTextLayoutFixedSize;}else{// next is auto-width, no need to set as is empty
return locale.shapeTitleButtonTextLayoutAutoWidth;}}else// is auto-width
{// next is fixed-size
if(disableTextLayout.includes("fixed-size")){// next is fixed-size
return locale.shapeTitleButtonTextLayoutAutoHeight;}else{// next is auto-width, no need to set as is empty
return locale.shapeTitleButtonTextLayoutFixedSize;}}};const handleNudge=e=>{const shape=getActiveMarkupItem();if(!shape)return;if(!shapeCanMove(shape))return;interactionShape=shape;interactionShapeOriginComputed=shapeComputeDisplay(shapeDeepCopy(interactionShape),parentRect);translateShape(interactionShape,interactionShapeOriginComputed,e.detail);};// shape navigator
let showShapeList=false;const handleFocusIn=e=>{$$invalidate(12,showShapeList=true);};const handleFocusOut=({relatedTarget})=>{// still in list
if(relatedTarget&&relatedTarget.classList.contains("shape-selector__button"))return;$$invalidate(12,showShapeList=false);};function measure_handler(event){bubble($$self,event);}const click_handler=(index,e)=>selectShape(markup[index]);function textarea_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{textInput=$$value;$$invalidate(11,textInput);});}function textarea_input_handler(){textInputText=this.value;$$invalidate(15,textInputText),$$invalidate(9,shouldRenderTextInput),$$invalidate(100,activeMarkup),$$invalidate(109,isTextMarkupSelected),$$invalidate(0,markup);}const measure_handler_1=e=>$$invalidate(5,shapeControlsSize=e.detail);const interactable_function=e=>getEventPositionInEditor(e,rootRect);$$self.$$set=$$props=>{if("uid"in $$props)$$invalidate(43,uid=$$props.uid);if("ui"in $$props)$$invalidate(42,ui=$$props.ui);if("markup"in $$props)$$invalidate(0,markup=$$props.markup);if("offset"in $$props)$$invalidate(1,offset=$$props.offset);if("contextRotation"in $$props)$$invalidate(44,contextRotation=$$props.contextRotation);if("contextFlipX"in $$props)$$invalidate(45,contextFlipX=$$props.contextFlipX);if("contextFlipY"in $$props)$$invalidate(46,contextFlipY=$$props.contextFlipY);if("contextScale"in $$props)$$invalidate(47,contextScale=$$props.contextScale);if("active"in $$props)$$invalidate(48,active=$$props.active);if("opacity"in $$props)$$invalidate(49,opacity=$$props.opacity);if("parentRect"in $$props)$$invalidate(50,parentRect=$$props.parentRect);if("rootRect"in $$props)$$invalidate(2,rootRect=$$props.rootRect);if("utilRect"in $$props)$$invalidate(51,utilRect=$$props.utilRect);if("oninteractionstart"in $$props)$$invalidate(52,oninteractionstart=$$props.oninteractionstart);if("oninteractionupdate"in $$props)$$invalidate(53,oninteractionupdate=$$props.oninteractionupdate);if("oninteractionrelease"in $$props)$$invalidate(54,oninteractionrelease=$$props.oninteractionrelease);if("oninteractionend"in $$props)$$invalidate(55,oninteractionend=$$props.oninteractionend);if("onaddshape"in $$props)$$invalidate(56,onaddshape=$$props.onaddshape);if("onupdateshape"in $$props)$$invalidate(57,onupdateshape=$$props.onupdateshape);if("onselectshape"in $$props)$$invalidate(58,onselectshape=$$props.onselectshape);if("onremoveshape"in $$props)$$invalidate(59,onremoveshape=$$props.onremoveshape);if("beforeSelectShape"in $$props)$$invalidate(60,beforeSelectShape=$$props.beforeSelectShape);if("beforeDeselectShape"in $$props)$$invalidate(61,beforeDeselectShape=$$props.beforeDeselectShape);if("beforeRemoveShape"in $$props)$$invalidate(62,beforeRemoveShape=$$props.beforeRemoveShape);if("beforeUpdateShape"in $$props)$$invalidate(63,beforeUpdateShape=$$props.beforeUpdateShape);if("willRenderShapeControls"in $$props)$$invalidate(64,willRenderShapeControls=$$props.willRenderShapeControls);if("mapEditorPointToImagePoint"in $$props)$$invalidate(65,mapEditorPointToImagePoint=$$props.mapEditorPointToImagePoint);if("mapImagePointToEditorPoint"in $$props)$$invalidate(66,mapImagePointToEditorPoint=$$props.mapImagePointToEditorPoint);if("eraseRadius"in $$props)$$invalidate(67,eraseRadius=$$props.eraseRadius);if("selectRadius"in $$props)$$invalidate(68,selectRadius=$$props.selectRadius);if("enableButtonFlipVertical"in $$props)$$invalidate(69,enableButtonFlipVertical=$$props.enableButtonFlipVertical);if("enableTapToAddText"in $$props)$$invalidate(70,enableTapToAddText=$$props.enableTapToAddText);if("locale"in $$props)$$invalidate(3,locale=$$props.locale);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*markup*/1){$$invalidate(100,activeMarkup=markup&&(getMarkupItemDraft()||getActiveMarkupItem()));}if($$self.$$.dirty[3]&/*activeMarkup*/128){$$invalidate(101,activeShapeId=activeMarkup&&!shapeIsDraft(activeMarkup)?activeMarkup.id:undefined);}if($$self.$$.dirty[0]&/*rootRect*/4|$$self.$$.dirty[1]&/*parentRect*/524288|$$self.$$.dirty[3]&/*activeMarkup*/128){// rootRect is in there so it recomputes the shape when the editor is resized
$$invalidate(102,activeMarkupComputed=rootRect&&activeMarkup&&shapeComputeDisplay(shapeDeepCopy(activeMarkup),parentRect));}if($$self.$$.dirty[3]&/*activeMarkup*/128){$$invalidate(103,activeMarkupItemIsDraft=!!(activeMarkup&&shapeIsDraft(activeMarkup)));}if($$self.$$.dirty[3]&/*activeMarkup*/128){$$invalidate(104,shapeProps=activeMarkup||undefined);}if($$self.$$.dirty[1]&/*opacity*/262144|$$self.$$.dirty[3]&/*activeMarkup, activeMarkupComputed*/640){// TODO: we use opacity to trigger a redraw of the active points, this should be changed to the image zoom factor in a future release
//  && !shapeIsPath(activeMarkupComputed)
$$invalidate(105,shapeActivePoints=activeMarkup&&opacity&&getMarkupShapePoints(activeMarkupComputed)||[]);}if($$self.$$.dirty[3]&/*activeMarkup*/128){$$invalidate(106,allowResizeControls=activeMarkup&&shapeCanResize(activeMarkup)&&!shapeIsTextEditing(activeMarkup));}if($$self.$$.dirty[3]&/*activeMarkup*/128){$$invalidate(6,allowRotateControls=activeMarkup&&shapeCanRotate(activeMarkup)&&!shapeIsTextEditing(activeMarkup));}if($$self.$$.dirty[3]&/*allowResizeControls, activeMarkup*/8320){$$invalidate(13,allowedResizeControls=allowResizeControls&&hasProp(activeMarkup,"text")&&!activeMarkup.height?"horizontal":allowResizeControls);}if($$self.$$.dirty[3]&/*activeMarkup, shapeActivePoints*/4224){$$invalidate(7,shouldRenderShapeManipulator=activeMarkup&&shapeActivePoints.length>1);}if($$self.$$.dirty[2]&/*mapImagePointToEditorPoint*/16|$$self.$$.dirty[3]&/*shapeActivePoints*/4096){$$invalidate(107,shapeActiveScreenPoints=shapeActivePoints.map(mapImagePointToEditorPoint));}if($$self.$$.dirty[0]&/*offset*/2|$$self.$$.dirty[3]&/*shapeActiveScreenPoints*/16384){$$invalidate(8,shapeManipulatorPoints=shapeActiveScreenPoints.map(point=>vectorCreate(point.x-offset.x,point.y-offset.y)));}if($$self.$$.dirty[0]&/*shouldRenderShapeManipulator, allowRotateControls*/192|$$self.$$.dirty[1]&/*opacity*/262144|$$self.$$.dirty[3]&/*activeMarkupComputed*/512){// TODO: we use opacity to trigger a redraw of the active points, this should be changed to the image zoom factor in a future release
$$invalidate(108,shapeManipulatorRotationPoint=shouldRenderShapeManipulator&&allowRotateControls&&opacity&&getShapeRotationPointOnScreen(activeMarkupComputed));}if($$self.$$.dirty[0]&/*offset*/2|$$self.$$.dirty[3]&/*shapeManipulatorRotationPoint*/32768){$$invalidate(14,shapeManipulatorRotationPointPosition=shapeManipulatorRotationPoint&&vectorCreate(shapeManipulatorRotationPoint.position.x-offset.x,shapeManipulatorRotationPoint.position.y-offset.y));}if($$self.$$.dirty[0]&/*shapeManipulatorPoints*/256|$$self.$$.dirty[1]&/*active, opacity*/393216|$$self.$$.dirty[3]&/*activeMarkup*/128){if(active){// show when something selected
if(opacity>0){claimManipulatorLines();// don't draw for line
const isPathDraft=activeMarkup&&shapeIsDraft(activeMarkup)&&shapeIsPath(activeMarkup);if(shapeManipulatorPoints.length>2&&!isPathDraft){redrawManipulatorLines(opacity);}else{removeMarkupManipulatorLines();}}else// hide when nothing selected
if(!activeMarkup){redrawManipulatorLines(opacity);}}else if(shouldManipulateLines()){redrawManipulatorLines(opacity);}}if($$self.$$.dirty[3]&/*activeMarkup*/128){$$invalidate(109,isTextMarkupSelected=activeMarkup&&shapeIsText(activeMarkup));}if($$self.$$.dirty[3]&/*isTextMarkupSelected, activeMarkup*/65664){$$invalidate(9,shouldRenderTextInput=isTextMarkupSelected&&shapeCanInput(activeMarkup)!==false&&activeMarkup.isEditing);}if($$self.$$.dirty[0]&/*shouldRenderTextInput*/512){$$invalidate(110,textShapeOrigin=shouldRenderTextInput?getTextShapeOriginSnapshot():undefined);}if($$self.$$.dirty[1]&/*parentRect*/524288|$$self.$$.dirty[3]&/*textShapeOrigin*/131072){$$invalidate(111,textShapeDisplayOrigin=textShapeOrigin&&shapeComputeDisplay({...textShapeOrigin},parentRect));}if($$self.$$.dirty[3]&/*textShapeDisplayOrigin*/262144){$$invalidate(112,textSizeDisplayOrigin=textShapeDisplayOrigin&&textSize(textShapeDisplayOrigin.text,textShapeDisplayOrigin));}if($$self.$$.dirty[3]&/*textShapeDisplayOrigin, textSizeDisplayOrigin*/786432){textRectDisplayOrigin=textShapeDisplayOrigin&&rectCreate(textShapeDisplayOrigin.x,textShapeDisplayOrigin.y,textSizeDisplayOrigin.width,textSizeDisplayOrigin.height);}if($$self.$$.dirty[0]&/*shouldRenderTextInput*/512|$$self.$$.dirty[3]&/*activeMarkup*/128){$$invalidate(15,textInputText=shouldRenderTextInput?activeMarkup.text:"");}if($$self.$$.dirty[0]&/*shouldRenderTextInput*/512|$$self.$$.dirty[3]&/*shapeProps*/2048){$$invalidate(16,markupTextInputStyle=shouldRenderTextInput&&`
    text-align: ${shapeProps.textAlign||"left"};
    font-family: ${shapeProps.fontFamily||"sans-serif"};
`);}if($$self.$$.dirty[3]&/*activeMarkup, activeMarkupItemIsDraft, controlledMarkupItem*/1049728){$$invalidate(113,controlledMarkupItem=activeMarkup&&!activeMarkupItemIsDraft?activeMarkup:controlledMarkupItem);}if($$self.$$.dirty[3]&/*controlledMarkupItem*/1048576){$$invalidate(114,allowShapeFlip=controlledMarkupItem&&shapeCanFlip(controlledMarkupItem));}if($$self.$$.dirty[3]&/*controlledMarkupItem*/1048576){$$invalidate(115,allowShapeChangeTextLayout=controlledMarkupItem&&shapeCanChangeTextLayout(controlledMarkupItem));}if($$self.$$.dirty[3]&/*controlledMarkupItem*/1048576){$$invalidate(116,allowShapeDuplicate=controlledMarkupItem&&shapeCanDuplicate(controlledMarkupItem));}if($$self.$$.dirty[3]&/*controlledMarkupItem*/1048576){$$invalidate(117,allowShapeRemove=controlledMarkupItem&&shapeCanRemove(controlledMarkupItem));}if($$self.$$.dirty[3]&/*controlledMarkupItem*/1048576){$$invalidate(118,allowShapeReorder=controlledMarkupItem&&shapeCanReorder(controlledMarkupItem));}if($$self.$$.dirty[3]&/*controlledMarkupItem*/1048576){$$invalidate(119,allowShapeInput=controlledMarkupItem&&shapeCanInput(controlledMarkupItem)!==false);}if($$self.$$.dirty[3]&/*controlledMarkupItem*/1048576){$$invalidate(120,allowShapeAdjustOpacity=controlledMarkupItem&&hasProp(controlledMarkupItem,"backgroundImage")&&shapeCanStyle(controlledMarkupItem,"opacity"));}if($$self.$$.dirty[0]&/*shouldRenderTextInput*/512|$$self.$$.dirty[3]&/*activeMarkup, activeMarkupItemIsDraft, isInteracting*/1216){markupControlsOpacity.set(activeMarkup&&!activeMarkupItemIsDraft&&!isInteracting&&!shouldRenderTextInput?1:0);}if($$self.$$.dirty[0]&/*shapeManipulatorPoints*/256|$$self.$$.dirty[3]&/*activeMarkup, activeMarkupItemIsDraft, markupControlsAnchorPosition*/268436608){$$invalidate(121,markupControlsAnchorPosition=activeMarkup&&!activeMarkupItemIsDraft?getMarkupControlsAnchorPosition(rectCreateFromPoints(shapeManipulatorPoints)):markupControlsAnchorPosition);}if($$self.$$.dirty[0]&/*shapeControlsSize*/32|$$self.$$.dirty[1]&/*utilRect*/1048576|$$self.$$.dirty[3]&/*markupControlsAnchorPosition*/268435456){$$invalidate(122,shapeControlsPosition=markupControlsAnchorPosition&&shapeControlsSize&&utilRect&&getShapeControlPositionOnCanvas(markupControlsAnchorPosition));}if($$self.$$.dirty[0]&/*$markupControlsOpacity*/1024|$$self.$$.dirty[3]&/*shapeControlsPosition*/536870912){$$invalidate(17,markupControlsStyle=shapeControlsPosition&&`transform: translate(${shapeControlsPosition.x}px, ${shapeControlsPosition.y}px);opacity:${$markupControlsOpacity}`);}if($$self.$$.dirty[0]&/*locale*/8|$$self.$$.dirty[2]&/*willRenderShapeControls, enableButtonFlipVertical*/132|$$self.$$.dirty[3]&/*activeShapeId, allowShapeAdjustOpacity, activeMarkup, allowShapeFlip, allowShapeReorder, allowShapeDuplicate, allowShapeRemove, allowShapeInput, allowShapeChangeTextLayout*/266338688){$$invalidate(18,shapeControls=activeShapeId&&willRenderShapeControls([allowShapeAdjustOpacity&&["div","alpha",{class:"PinturaShapeControlsGroup"},[["Slider","adjust-opacity",{onchange:handleAdjustOpacity,step:0.01,value:hasProp(activeMarkup,"opacity")?activeMarkup.opacity:1,label:(value,min,max)=>`${Math.round(value/max*100)}%`,min:0,max:1,direction:"x"}]]],["div","beta",{class:"PinturaShapeControlsGroup"},[allowShapeFlip&&["Button","flip-horizontal",{onclick:handleFlipX,label:locale.shapeTitleButtonFlipHorizontal,icon:locale.shapeIconButtonFlipHorizontal,hideLabel:true}],allowShapeFlip&&enableButtonFlipVertical&&["Button","flip-vertical",{onclick:handleFlipY,label:locale.shapeTitleButtonFlipVertical,icon:locale.shapeIconButtonFlipVertical,hideLabel:true}],allowShapeReorder&&["Button","to-front",{onclick:handleMoveToFrontActiveMarkup,label:locale.shapeTitleButtonMoveToFront,icon:locale.shapeIconButtonMoveToFront,hideLabel:true}],allowShapeDuplicate&&["Button","duplicate",{onclick:handleDuplicateActiveMarkup,label:locale.shapeTitleButtonDuplicate,icon:locale.shapeIconButtonDuplicate,hideLabel:true}],allowShapeRemove&&["Button","remove",{onclick:handleRemoveActiveMarkup,label:locale.shapeTitleButtonRemove,icon:locale.shapeIconButtonRemove,hideLabel:true}]].filter(Boolean)],allowShapeInput&&allowShapeChangeTextLayout&&["div","gamma",{class:"PinturaShapeControlsGroup"},[["Button","text-layout",{onclick:handleTextSwitchLayout,label:localize(TextLayoutChangeLabel,locale,activeMarkup),icon:localize(TextLayoutChangeIcon,locale,activeMarkup),hideLabel:true}]]],allowShapeInput&&["div","delta",{class:"PinturaShapeControlsGroup"},[["Button","edit-text",{label:locale.shapeLabelInputText,onclick:handleEditTextActiveMarkup}]]]].filter(Boolean),activeShapeId));}if($$self.$$.dirty[0]&/*markup, locale*/9){$$invalidate(19,shapeNavList=markup.filter(shapeCanSelect).filter(shape=>!shapeIsDraft(shape)).map(shape=>({id:shape.id,color:shapeIsText(shape)?shape.color:shapeIsLine(shape)?shape.strokeColor:shape.backgroundColor,name:shape.name||locale[`shapeLabelTool${capitalizeFirstLetter(shapeGetDescription(shape))}`]})));}};return[markup,offset,rootRect,locale,selectShape,shapeControlsSize,allowRotateControls,shouldRenderShapeManipulator,shapeManipulatorPoints,shouldRenderTextInput,$markupControlsOpacity,textInput,showShapeList,allowedResizeControls,shapeManipulatorRotationPointPosition,textInputText,markupTextInputStyle,markupControlsStyle,shapeControls,shapeNavList,keysPressedStored,handleInteractionStart,handleInteractionUpdate,handleInteractionRelease,handleInteractionEnd,handleManipulatorResizeGrab,handleManipulatorResizeDrag,handleManipulatorResizeEnd,handleManipulatorRotateGrab,handleManipulatorRotateDrag,handleManipulatorRotateEnd,handleKey,handleTextInput,handleTextInputAttempt,handleTextInputKeyDown,handleTextInputKeyUp,handleTextConfirm,handleTextCancel,markupControlsOpacity,handleNudge,handleFocusIn,handleFocusOut,ui,uid,contextRotation,contextFlipX,contextFlipY,contextScale,active,opacity,parentRect,utilRect,oninteractionstart,oninteractionupdate,oninteractionrelease,oninteractionend,onaddshape,onupdateshape,onselectshape,onremoveshape,beforeSelectShape,beforeDeselectShape,beforeRemoveShape,beforeUpdateShape,willRenderShapeControls,mapEditorPointToImagePoint,mapImagePointToEditorPoint,eraseRadius,selectRadius,enableButtonFlipVertical,enableTapToAddText,createShape,eraseShape,getMarkupItemDraft,getMarkupItemDraftIndex,addMarkupItemDraft,confirmMarkupItemDraft,discardMarkupItemDraft,createMarkupItem,syncShapes,addShape,removeMarkupShapeProps,updateMarkupShape,updateMarkupShapeProperty,updateMarkupItemsShapeProperty,updateMarkupShapeItems,getActiveMarkupItem,hasActiveMarkupItem,removeShape,removeActiveMarkupItem,blurShapes,deselectMarkupItem,editMarkupItem,finishEditMarkupItem,removeMarkupItems,getTextShapeRect,getMarkupShapeRect,getShapesNearPosition,getShapesBetweenPoints,isInteracting,activeMarkup,activeShapeId,activeMarkupComputed,activeMarkupItemIsDraft,shapeProps,shapeActivePoints,allowResizeControls,shapeActiveScreenPoints,shapeManipulatorRotationPoint,isTextMarkupSelected,textShapeOrigin,textShapeDisplayOrigin,textSizeDisplayOrigin,controlledMarkupItem,allowShapeFlip,allowShapeChangeTextLayout,allowShapeDuplicate,allowShapeRemove,allowShapeReorder,allowShapeInput,allowShapeAdjustOpacity,markupControlsAnchorPosition,shapeControlsPosition,measure_handler,click_handler,textarea_binding,textarea_input_handler,measure_handler_1,interactable_function];}class ShapeLayoutEditor extends SvelteComponent{constructor(options){super();init(this,options,instance$f,create_fragment$f,safe_not_equal,{uid:43,ui:42,markup:0,offset:1,contextRotation:44,contextFlipX:45,contextFlipY:46,contextScale:47,active:48,opacity:49,parentRect:50,rootRect:2,utilRect:51,oninteractionstart:52,oninteractionupdate:53,oninteractionrelease:54,oninteractionend:55,onaddshape:56,onupdateshape:57,onselectshape:58,onremoveshape:59,beforeSelectShape:60,beforeDeselectShape:61,beforeRemoveShape:62,beforeUpdateShape:63,willRenderShapeControls:64,mapEditorPointToImagePoint:65,mapImagePointToEditorPoint:66,eraseRadius:67,selectRadius:68,enableButtonFlipVertical:69,enableTapToAddText:70,locale:3,createShape:71,eraseShape:72,getMarkupItemDraft:73,getMarkupItemDraftIndex:74,addMarkupItemDraft:75,confirmMarkupItemDraft:76,discardMarkupItemDraft:77,createMarkupItem:78,syncShapes:79,addShape:80,removeMarkupShapeProps:81,updateMarkupShape:82,updateMarkupShapeProperty:83,updateMarkupItemsShapeProperty:84,updateMarkupShapeItems:85,getActiveMarkupItem:86,hasActiveMarkupItem:87,removeShape:88,removeActiveMarkupItem:89,blurShapes:90,selectShape:4,deselectMarkupItem:91,editMarkupItem:92,finishEditMarkupItem:93,removeMarkupItems:94,getTextShapeRect:95,getMarkupShapeRect:96,getShapesNearPosition:97,getShapesBetweenPoints:98},[-1,-1,-1,-1,-1,-1]);}get createShape(){return this.$$.ctx[71];}get eraseShape(){return this.$$.ctx[72];}get getMarkupItemDraft(){return this.$$.ctx[73];}get getMarkupItemDraftIndex(){return this.$$.ctx[74];}get addMarkupItemDraft(){return this.$$.ctx[75];}get confirmMarkupItemDraft(){return this.$$.ctx[76];}get discardMarkupItemDraft(){return this.$$.ctx[77];}get createMarkupItem(){return this.$$.ctx[78];}get syncShapes(){return this.$$.ctx[79];}get addShape(){return this.$$.ctx[80];}get removeMarkupShapeProps(){return this.$$.ctx[81];}get updateMarkupShape(){return this.$$.ctx[82];}get updateMarkupShapeProperty(){return this.$$.ctx[83];}get updateMarkupItemsShapeProperty(){return this.$$.ctx[84];}get updateMarkupShapeItems(){return this.$$.ctx[85];}get getActiveMarkupItem(){return this.$$.ctx[86];}get hasActiveMarkupItem(){return this.$$.ctx[87];}get removeShape(){return this.$$.ctx[88];}get removeActiveMarkupItem(){return this.$$.ctx[89];}get blurShapes(){return this.$$.ctx[90];}get selectShape(){return this.$$.ctx[4];}get deselectMarkupItem(){return this.$$.ctx[91];}get editMarkupItem(){return this.$$.ctx[92];}get finishEditMarkupItem(){return this.$$.ctx[93];}get removeMarkupItems(){return this.$$.ctx[94];}get getTextShapeRect(){return this.$$.ctx[95];}get getMarkupShapeRect(){return this.$$.ctx[96];}get getShapesNearPosition(){return this.$$.ctx[97];}get getShapesBetweenPoints(){return this.$$.ctx[98];}}/* src/core/ui/components/ShapeStyleControls.svelte generated by Svelte v3.37.0 */function get_each_context$2(ctx,list,i){const child_ctx=ctx.slice();child_ctx[7]=list[i];return child_ctx;}// (21:12) {#each controls as control (control.id)}
function create_each_block$2(key_1,ctx){let li;let span;let t0_value=localize(/*control*/ctx[7].componentProps.title,/*locale*/ctx[1])+"";let t0;let t1;let switch_instance;let t2;let current;const switch_instance_spread_levels=[/*control*/ctx[7].componentProps];var switch_value=/*control*/ctx[7].component;function switch_props(ctx){let switch_instance_props={};for(let i=0;i<switch_instance_spread_levels.length;i+=1){switch_instance_props=pintura_assign(switch_instance_props,switch_instance_spread_levels[i]);}return{props:switch_instance_props};}if(switch_value){switch_instance=new switch_value(switch_props());}return{key:key_1,first:null,c(){li=pintura_element("li");span=pintura_element("span");t0=pintura_text(t0_value);t1=space();if(switch_instance)create_component(switch_instance.$$.fragment);t2=space();attr(span,"class","PinturaShapeStyleLabel");attr(li,"class","PinturaShapeStyle");this.first=li;},m(target,anchor){insert(target,li,anchor);append(li,span);append(span,t0);append(li,t1);if(switch_instance){mount_component(switch_instance,li,null);}append(li,t2);current=true;},p(new_ctx,dirty){ctx=new_ctx;if((!current||dirty&/*controls, locale*/3)&&t0_value!==(t0_value=localize(/*control*/ctx[7].componentProps.title,/*locale*/ctx[1])+""))set_data(t0,t0_value);const switch_instance_changes=dirty&/*controls*/1?get_spread_update(switch_instance_spread_levels,[get_spread_object(/*control*/ctx[7].componentProps)]):{};if(switch_value!==(switch_value=/*control*/ctx[7].component)){if(switch_instance){group_outros();const old_component=switch_instance;transition_out(old_component.$$.fragment,1,0,()=>{destroy_component(old_component,1);});check_outros();}if(switch_value){switch_instance=new switch_value(switch_props());create_component(switch_instance.$$.fragment);transition_in(switch_instance.$$.fragment,1);mount_component(switch_instance,li,t2);}else{switch_instance=null;}}else if(switch_value){switch_instance.$set(switch_instance_changes);}},i(local){if(current)return;if(switch_instance)transition_in(switch_instance.$$.fragment,local);current=true;},o(local){if(switch_instance)transition_out(switch_instance.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(li);if(switch_instance)destroy_component(switch_instance);}};}// (19:4) <Scrollable class="PinturaShapeStyles" elasticity={scrollElasticity}>
function create_default_slot$5(ctx){let ul;let each_blocks=[];let each_1_lookup=new Map();let current;let each_value=/*controls*/ctx[0];const get_key=ctx=>/*control*/ctx[7].id;for(let i=0;i<each_value.length;i+=1){let child_ctx=get_each_context$2(ctx,each_value,i);let key=get_key(child_ctx);each_1_lookup.set(key,each_blocks[i]=create_each_block$2(key,child_ctx));}return{c(){ul=pintura_element("ul");for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].c();}attr(ul,"class","PinturaShapeStyleList");},m(target,anchor){insert(target,ul,anchor);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].m(ul,null);}current=true;},p(ctx,dirty){if(dirty&/*controls, localize, locale*/3){each_value=/*controls*/ctx[0];group_outros();each_blocks=update_keyed_each(each_blocks,dirty,get_key,1,ctx,each_value,each_1_lookup,ul,outro_and_destroy_block,create_each_block$2,null,get_each_context$2);check_outros();}},i(local){if(current)return;for(let i=0;i<each_value.length;i+=1){transition_in(each_blocks[i]);}current=true;},o(local){for(let i=0;i<each_blocks.length;i+=1){transition_out(each_blocks[i]);}current=false;},d(detaching){if(detaching)detach(ul);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].d();}}};}function create_fragment$e(ctx){let div;let scrollable;let current;scrollable=new Scrollable({props:{class:"PinturaShapeStyles",elasticity:/*scrollElasticity*/ctx[2],$$slots:{default:[create_default_slot$5]},$$scope:{ctx}}});return{c(){div=pintura_element("div");create_component(scrollable.$$.fragment);attr(div,"style",/*style*/ctx[3]);},m(target,anchor){insert(target,div,anchor);mount_component(scrollable,div,null);current=true;},p(ctx,[dirty]){const scrollable_changes={};if(dirty&/*scrollElasticity*/4)scrollable_changes.elasticity=/*scrollElasticity*/ctx[2];if(dirty&/*$$scope, controls, locale*/1027){scrollable_changes.$$scope={dirty,ctx};}scrollable.$set(scrollable_changes);if(!current||dirty&/*style*/8){attr(div,"style",/*style*/ctx[3]);}},i(local){if(current)return;transition_in(scrollable.$$.fragment,local);current=true;},o(local){transition_out(scrollable.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(scrollable);}};}function instance$e($$self,$$props,$$invalidate){let style;let $opacity;let{isActive=false}=$$props;let{controls=[]}=$$props;let{locale}=$$props;let{scrollElasticity}=$$props;const opacity=spring(0);component_subscribe($$self,opacity,value=>$$invalidate(6,$opacity=value));$$self.$$set=$$props=>{if("isActive"in $$props)$$invalidate(5,isActive=$$props.isActive);if("controls"in $$props)$$invalidate(0,controls=$$props.controls);if("locale"in $$props)$$invalidate(1,locale=$$props.locale);if("scrollElasticity"in $$props)$$invalidate(2,scrollElasticity=$$props.scrollElasticity);};$$self.$$.update=()=>{if($$self.$$.dirty&/*isActive*/32){opacity.set(isActive?1:0);}if($$self.$$.dirty&/*$opacity, isActive*/96){$$invalidate(3,style=`opacity:${$opacity};${!isActive?"pointer-events:none;":""}${$opacity<=0?"visibility:hidden":""}`);}};return[controls,locale,scrollElasticity,style,opacity,isActive,$opacity];}class ShapeStyleControls extends SvelteComponent{constructor(options){super();init(this,options,instance$e,create_fragment$e,safe_not_equal,{isActive:5,controls:0,locale:1,scrollElasticity:2});}}/* src/core/ui/components/ShapeStyleEditor.svelte generated by Svelte v3.37.0 */function get_each_context$1(ctx,list,i){const child_ctx=ctx.slice();child_ctx[11]=list[i].key;child_ctx[2]=list[i].controls;child_ctx[12]=list[i].isActive;return child_ctx;}// (132:4) {#each currentStyleControlSets as { key, controls, isActive }
function create_each_block$1(key_1,ctx){let first;let shapestylecontrols;let current;shapestylecontrols=new ShapeStyleControls({props:{isActive:/*isActive*/ctx[12],controls:/*controls*/ctx[2],locale:/*locale*/ctx[0],scrollElasticity:/*scrollElasticity*/ctx[1]}});return{key:key_1,first:null,c(){first=empty();create_component(shapestylecontrols.$$.fragment);this.first=first;},m(target,anchor){insert(target,first,anchor);mount_component(shapestylecontrols,target,anchor);current=true;},p(new_ctx,dirty){ctx=new_ctx;const shapestylecontrols_changes={};if(dirty&/*currentStyleControlSets*/8)shapestylecontrols_changes.isActive=/*isActive*/ctx[12];if(dirty&/*currentStyleControlSets*/8)shapestylecontrols_changes.controls=/*controls*/ctx[2];if(dirty&/*locale*/1)shapestylecontrols_changes.locale=/*locale*/ctx[0];if(dirty&/*scrollElasticity*/2)shapestylecontrols_changes.scrollElasticity=/*scrollElasticity*/ctx[1];shapestylecontrols.$set(shapestylecontrols_changes);},i(local){if(current)return;transition_in(shapestylecontrols.$$.fragment,local);current=true;},o(local){transition_out(shapestylecontrols.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(first);destroy_component(shapestylecontrols,detaching);}};}function create_fragment$d(ctx){let div;let each_blocks=[];let each_1_lookup=new Map();let current;let each_value=/*currentStyleControlSets*/ctx[3];const get_key=ctx=>/*key*/ctx[11];for(let i=0;i<each_value.length;i+=1){let child_ctx=get_each_context$1(ctx,each_value,i);let key=get_key(child_ctx);each_1_lookup.set(key,each_blocks[i]=create_each_block$1(key,child_ctx));}return{c(){div=pintura_element("div");for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].c();}attr(div,"class","PinturaShapeStyleEditor");},m(target,anchor){insert(target,div,anchor);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].m(div,null);}current=true;},p(ctx,[dirty]){if(dirty&/*currentStyleControlSets, locale, scrollElasticity*/11){each_value=/*currentStyleControlSets*/ctx[3];group_outros();each_blocks=update_keyed_each(each_blocks,dirty,get_key,1,ctx,each_value,each_1_lookup,div,outro_and_destroy_block,create_each_block$1,null,get_each_context$1);check_outros();}},i(local){if(current)return;for(let i=0;i<each_value.length;i+=1){transition_in(each_blocks[i]);}current=true;},o(local){for(let i=0;i<each_blocks.length;i+=1){transition_out(each_blocks[i]);}current=false;},d(detaching){if(detaching)detach(div);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].d();}}};}function instance$d($$self,$$props,$$invalidate){let controlKeys;let activeControls;let currentStyleControlSets;let{controls={}}=$$props;let{shape=undefined}=$$props;let{onchange}=$$props;let{locale}=$$props;let{scrollElasticity}=$$props;const getShapeControls=shape=>{const shapeId=shape.id||"tool";const activeControls=controlKeys.filter(styleKey=>styleKey.split("_").every(styleKey=>// shape needs to have the property
hasProp(shape,styleKey)&&// shape needs to be able to style the property
shapeCanStyle(shape,styleKey))).map(styleKey=>{const styleKeys=styleKey.split("_");const currentValue=styleKeys.length>1?styleKeys.map(key=>shape[key]):shape[styleKey];let[component,componentProps]=controls[styleKey];// is reference to other control
if(pintura_isString(component)){// exif if not a valid default control
if(!controls[component])return;// create component based on reference
const componentCustomProps={...componentProps};[component,componentProps]=controls[component];componentProps={...componentProps,...componentCustomProps};}const options=pintura_isFunction(componentProps.options)?componentProps.options(shape):componentProps.options;return{id:`${shapeId}_${styleKey}`,component,componentProps:{...componentProps,// set the options prop
options,// defaults
locale,value:currentValue,optionLabelClass:"PinturaButtonLabel",onchange:detail=>{const value=pintura_isObject(detail)&&!pintura_isArray(detail)?detail.value:detail;// allow custom changes
if(componentProps.onchange)componentProps.onchange(value,shape);// internal change
const props=styleKeys.length>1?styleKeys.reduce((prev,key,index)=>{return{...prev,[key]:Array.isArray(value)?value[index]:value};},{}):{[styleKey]:value};onchange(props);}}};}).filter(Boolean);return activeControls;};const styleControlSets=[];const getStyleControlSets=(key,controls)=>{let controlSet=styleControlSets.find(controlSet=>controlSet.key===key);if(!controlSet){// create
controlSet={key,controls};// add
styleControlSets.push(controlSet);}// hide all
styleControlSets.forEach(controlSet=>controlSet.isActive=false);// update active controls
controlSet.controls=controls;// show active
controlSet.isActive=true;return styleControlSets;};$$self.$$set=$$props=>{if("controls"in $$props)$$invalidate(2,controls=$$props.controls);if("shape"in $$props)$$invalidate(4,shape=$$props.shape);if("onchange"in $$props)$$invalidate(5,onchange=$$props.onchange);if("locale"in $$props)$$invalidate(0,locale=$$props.locale);if("scrollElasticity"in $$props)$$invalidate(1,scrollElasticity=$$props.scrollElasticity);};$$self.$$.update=()=>{if($$self.$$.dirty&/*controls*/4){// finds the controls needed to style the selected shape
$$invalidate(6,controlKeys=Object.keys(controls).filter(key=>controls[key]));}if($$self.$$.dirty&/*shape, controlKeys*/80){$$invalidate(7,activeControls=shape&&controlKeys&&shapeCanStyle(shape)?getShapeControls(shape):[]);}if($$self.$$.dirty&/*shape, activeControls*/144){$$invalidate(3,currentStyleControlSets=shape?getStyleControlSets(Object.keys(shape).join("_"),activeControls):[]);}};return[locale,scrollElasticity,controls,currentStyleControlSets,shape,onchange,controlKeys,activeControls];}class ShapeStyleEditor extends SvelteComponent{constructor(options){super();init(this,options,instance$d,create_fragment$d,safe_not_equal,{controls:2,shape:4,onchange:5,locale:0,scrollElasticity:1});}}/* src/core/ui/components/DragButton.svelte generated by Svelte v3.37.0 */function create_fragment$c(ctx){let button;let mounted;let dispose;return{c(){button=pintura_element("button");attr(button,"class","PinturaDragButton");attr(button,"title",/*title*/ctx[1]);button.disabled=/*disabled*/ctx[2];},m(target,anchor){insert(target,button,anchor);button.innerHTML=/*html*/ctx[0];/*button_binding*/ctx[9](button);if(!mounted){dispose=listen(button,"pointerdown",/*handleDown*/ctx[4]);mounted=true;}},p(ctx,[dirty]){if(dirty&/*html*/1)button.innerHTML=/*html*/ctx[0];if(dirty&/*title*/2){attr(button,"title",/*title*/ctx[1]);}if(dirty&/*disabled*/4){button.disabled=/*disabled*/ctx[2];}},i:pintura_noop,o:pintura_noop,d(detaching){if(detaching)detach(button);/*button_binding*/ctx[9](null);mounted=false;dispose();}};}function instance$c($$self,$$props,$$invalidate){let{html}=$$props;let{title}=$$props;let{onclick}=$$props;let{disabled=false}=$$props;let{ongrab=noop$1}=$$props;let{ondrag=noop$1}=$$props;let{ondrop=noop$1}=$$props;let element;const isOverButton=e=>vectorDistanceSquared(downPosition,vectorCreate(e.pageX,e.pageY))<256;let downPosition;const handleDown=e=>{downPosition=vectorCreate(e.pageX,e.pageY);ongrab(e);document.documentElement.addEventListener("pointermove",handleMove);document.documentElement.addEventListener("pointerup",handleUp);};const handleUp=e=>{document.documentElement.removeEventListener("pointermove",handleMove);document.documentElement.removeEventListener("pointerup",handleUp);const upPosition=vectorCreate(e.pageX,e.pageY);// must have moved enough distance to drop
if(vectorDistanceSquared(downPosition,upPosition)<32)return onclick(e);// cant drop in button /
if(isOverButton(e))return;// was dragging
ondrop(e);};const handleMove=e=>{// must have moved enough distance from button
if(isOverButton(e))return;// dragging out of button
ondrag(e);};function button_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{element=$$value;$$invalidate(3,element);});}$$self.$$set=$$props=>{if("html"in $$props)$$invalidate(0,html=$$props.html);if("title"in $$props)$$invalidate(1,title=$$props.title);if("onclick"in $$props)$$invalidate(5,onclick=$$props.onclick);if("disabled"in $$props)$$invalidate(2,disabled=$$props.disabled);if("ongrab"in $$props)$$invalidate(6,ongrab=$$props.ongrab);if("ondrag"in $$props)$$invalidate(7,ondrag=$$props.ondrag);if("ondrop"in $$props)$$invalidate(8,ondrop=$$props.ondrop);};return[html,title,disabled,element,handleDown,onclick,ongrab,ondrag,ondrop,button_binding];}class DragButton extends SvelteComponent{constructor(options){super();init(this,options,instance$c,create_fragment$c,safe_not_equal,{html:0,title:1,onclick:5,disabled:2,ongrab:6,ondrag:7,ondrop:8});}}/* src/core/ui/components/ShapePresetsList.svelte generated by Svelte v3.37.0 */function get_each_context(ctx,list,i){const child_ctx=ctx.slice();child_ctx[14]=list[i];return child_ctx;}// (25:4) {#each presets as preset (preset.id)}
function create_each_block(key_1,ctx){let li;let dragbutton;let t;let didMountPresetThumb_action;let current;let mounted;let dispose;function func(){return/*func*/ctx[10](/*preset*/ctx[14]);}function func_1(...args){return/*func_1*/ctx[11](/*preset*/ctx[14],...args);}function func_2(...args){return/*func_2*/ctx[12](/*preset*/ctx[14],...args);}function func_3(...args){return/*func_3*/ctx[13](/*preset*/ctx[14],...args);}dragbutton=new DragButton({props:{onclick:func,ongrab:func_1,ondrag:func_2,ondrop:func_3,disabled:/*disabled*/ctx[1]||/*preset*/ctx[14].disabled,title:/*preset*/ctx[14].title,html:/*preset*/ctx[14].thumb}});return{key:key_1,first:null,c(){li=pintura_element("li");create_component(dragbutton.$$.fragment);t=space();attr(li,"class","PinturaShapePreset");attr(li,"style",/*style*/ctx[6]);this.first=li;},m(target,anchor){insert(target,li,anchor);mount_component(dragbutton,li,null);append(li,t);current=true;if(!mounted){dispose=action_destroyer(didMountPresetThumb_action=/*didMountPresetThumb*/ctx[8].call(null,li,/*preset*/ctx[14]));mounted=true;}},p(new_ctx,dirty){ctx=new_ctx;const dragbutton_changes={};if(dirty&/*onclickpreset, presets*/5)dragbutton_changes.onclick=func;if(dirty&/*ongrabpreset, presets*/9)dragbutton_changes.ongrab=func_1;if(dirty&/*ondragpreset, presets*/17)dragbutton_changes.ondrag=func_2;if(dirty&/*ondroppreset, presets*/33)dragbutton_changes.ondrop=func_3;if(dirty&/*disabled, presets*/3)dragbutton_changes.disabled=/*disabled*/ctx[1]||/*preset*/ctx[14].disabled;if(dirty&/*presets*/1)dragbutton_changes.title=/*preset*/ctx[14].title;if(dirty&/*presets*/1)dragbutton_changes.html=/*preset*/ctx[14].thumb;dragbutton.$set(dragbutton_changes);if(!current||dirty&/*style*/64){attr(li,"style",/*style*/ctx[6]);}if(didMountPresetThumb_action&&is_function(didMountPresetThumb_action.update)&&dirty&/*presets*/1)didMountPresetThumb_action.update.call(null,/*preset*/ctx[14]);},i(local){if(current)return;transition_in(dragbutton.$$.fragment,local);current=true;},o(local){transition_out(dragbutton.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(li);destroy_component(dragbutton);mounted=false;dispose();}};}function create_fragment$b(ctx){let ul;let each_blocks=[];let each_1_lookup=new Map();let current;let each_value=/*presets*/ctx[0];const get_key=ctx=>/*preset*/ctx[14].id;for(let i=0;i<each_value.length;i+=1){let child_ctx=get_each_context(ctx,each_value,i);let key=get_key(child_ctx);each_1_lookup.set(key,each_blocks[i]=create_each_block(key,child_ctx));}return{c(){ul=pintura_element("ul");for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].c();}attr(ul,"class","PinturaShapePresetsList");},m(target,anchor){insert(target,ul,anchor);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].m(ul,null);}current=true;},p(ctx,[dirty]){if(dirty&/*style, presets, onclickpreset, ongrabpreset, ondragpreset, ondroppreset, disabled*/127){each_value=/*presets*/ctx[0];group_outros();each_blocks=update_keyed_each(each_blocks,dirty,get_key,1,ctx,each_value,each_1_lookup,ul,outro_and_destroy_block,create_each_block,null,get_each_context);check_outros();}},i(local){if(current)return;for(let i=0;i<each_value.length;i+=1){transition_in(each_blocks[i]);}current=true;},o(local){for(let i=0;i<each_blocks.length;i+=1){transition_out(each_blocks[i]);}current=false;},d(detaching){if(detaching)detach(ul);for(let i=0;i<each_blocks.length;i+=1){each_blocks[i].d();}}};}function instance$b($$self,$$props,$$invalidate){let style;let $anim;let{presets}=$$props;let{disabled=undefined}=$$props;let{onclickpreset}=$$props;let{ongrabpreset=undefined}=$$props;let{ondragpreset=undefined}=$$props;let{ondroppreset=undefined}=$$props;const anim=tweened(0,{duration:300});component_subscribe($$self,anim,value=>$$invalidate(9,$anim=value));const didMountPresetThumb=(element,item)=>item.mount&&item.mount(element.firstChild,item);onMount(()=>anim.set(1));const func=preset=>onclickpreset(preset.id);const func_1=(preset,e)=>ongrabpreset&&ongrabpreset(preset.id,e);const func_2=(preset,e)=>ondragpreset&&ondragpreset(preset.id,e);const func_3=(preset,e)=>ondroppreset&&ondroppreset(preset.id,e);$$self.$$set=$$props=>{if("presets"in $$props)$$invalidate(0,presets=$$props.presets);if("disabled"in $$props)$$invalidate(1,disabled=$$props.disabled);if("onclickpreset"in $$props)$$invalidate(2,onclickpreset=$$props.onclickpreset);if("ongrabpreset"in $$props)$$invalidate(3,ongrabpreset=$$props.ongrabpreset);if("ondragpreset"in $$props)$$invalidate(4,ondragpreset=$$props.ondragpreset);if("ondroppreset"in $$props)$$invalidate(5,ondroppreset=$$props.ondroppreset);};$$self.$$.update=()=>{if($$self.$$.dirty&/*$anim*/512){$$invalidate(6,style=`opacity:${$anim}`);}};return[presets,disabled,onclickpreset,ongrabpreset,ondragpreset,ondroppreset,style,anim,didMountPresetThumb,$anim,func,func_1,func_2,func_3];}class ShapePresetsList extends SvelteComponent{constructor(options){super();init(this,options,instance$b,create_fragment$b,safe_not_equal,{presets:0,disabled:1,onclickpreset:2,ongrabpreset:3,ondragpreset:4,ondroppreset:5});}}var isSVGMarkup=str=>/<svg /.test(str);/* src/core/ui/components/ShapePresetsPalette.svelte generated by Svelte v3.37.0 */function create_if_block_6(ctx){let dynamiccomponenttree;let current;dynamiccomponenttree=new DynamicComponentTree_1({props:{items:/*presetToolbar*/ctx[13]}});return{c(){create_component(dynamiccomponenttree.$$.fragment);},m(target,anchor){mount_component(dynamiccomponenttree,target,anchor);current=true;},p(ctx,dirty){const dynamiccomponenttree_changes={};if(dirty&/*presetToolbar*/8192)dynamiccomponenttree_changes.items=/*presetToolbar*/ctx[13];dynamiccomponenttree.$set(dynamiccomponenttree_changes);},i(local){if(current)return;transition_in(dynamiccomponenttree.$$.fragment,local);current=true;},o(local){transition_out(dynamiccomponenttree.$$.fragment,local);current=false;},d(detaching){destroy_component(dynamiccomponenttree,detaching);}};}// (177:4) {#if shouldRenderPresets}
function create_if_block$1(ctx){let current_block_type_index;let if_block;let if_block_anchor;let current;const if_block_creators=[create_if_block_1$1,create_else_block$1];const if_blocks=[];function select_block_type_1(ctx,dirty){if(/*shouldGroupPresets*/ctx[7])return 0;return 1;}current_block_type_index=select_block_type_1(ctx);if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);return{c(){if_block.c();if_block_anchor=empty();},m(target,anchor){if_blocks[current_block_type_index].m(target,anchor);insert(target,if_block_anchor,anchor);current=true;},p(ctx,dirty){let previous_block_index=current_block_type_index;current_block_type_index=select_block_type_1(ctx);if(current_block_type_index===previous_block_index){if_blocks[current_block_type_index].p(ctx,dirty);}else{group_outros();transition_out(if_blocks[previous_block_index],1,1,()=>{if_blocks[previous_block_index]=null;});check_outros();if_block=if_blocks[current_block_type_index];if(!if_block){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);if_block.c();}else{if_block.p(ctx,dirty);}transition_in(if_block,1);if_block.m(if_block_anchor.parentNode,if_block_anchor);}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if_blocks[current_block_type_index].d(detaching);if(detaching)detach(if_block_anchor);}};}// (227:8) {:else}
function create_else_block$1(ctx){let div;let t;let scrollable;let current;let if_block=/*presetToolbar*/ctx[13]&&create_if_block_5$1(ctx);scrollable=new Scrollable({props:{scrollAutoCancel:/*shouldRenderPresets*/ctx[6],elasticity:/*scrollElasticity*/ctx[0],$$slots:{default:[create_default_slot_4]},$$scope:{ctx}}});return{c(){div=pintura_element("div");if(if_block)if_block.c();t=space();create_component(scrollable.$$.fragment);attr(div,"class","PinturaShapePresetsFlat");},m(target,anchor){insert(target,div,anchor);if(if_block)if_block.m(div,null);append(div,t);mount_component(scrollable,div,null);current=true;},p(ctx,dirty){if(/*presetToolbar*/ctx[13]){if(if_block){if_block.p(ctx,dirty);if(dirty&/*presetToolbar*/8192){transition_in(if_block,1);}}else{if_block=create_if_block_5$1(ctx);if_block.c();transition_in(if_block,1);if_block.m(div,t);}}else if(if_block){group_outros();transition_out(if_block,1,1,()=>{if_block=null;});check_outros();}const scrollable_changes={};if(dirty&/*shouldRenderPresets*/64)scrollable_changes.scrollAutoCancel=/*shouldRenderPresets*/ctx[6];if(dirty&/*scrollElasticity*/1)scrollable_changes.elasticity=/*scrollElasticity*/ctx[0];if(dirty&/*$$scope, presetsMapped, onaddpreset, ongrabpreset, ondragpreset, ondroppreset*/536870974){scrollable_changes.$$scope={dirty,ctx};}scrollable.$set(scrollable_changes);},i(local){if(current)return;transition_in(if_block);transition_in(scrollable.$$.fragment,local);current=true;},o(local){transition_out(if_block);transition_out(scrollable.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);if(if_block)if_block.d();destroy_component(scrollable);}};}// (179:8) {#if shouldGroupPresets}
function create_if_block_1$1(ctx){let div1;let div0;let t0;let tablist;let t1;let tabpanels;let current;let if_block=/*presetToolbar*/ctx[13]&&create_if_block_4$1(ctx);const tablist_spread_levels=[{class:"PinturaControlList"},{tabs:/*tabs*/ctx[8]},/*tabsConfig*/ctx[11],{layout:"compact"}];let tablist_props={$$slots:{default:[create_default_slot_2,({tab})=>({28:tab}),({tab})=>tab?268435456:0]},$$scope:{ctx}};for(let i=0;i<tablist_spread_levels.length;i+=1){tablist_props=pintura_assign(tablist_props,tablist_spread_levels[i]);}tablist=new TabList({props:tablist_props});tablist.$on("select",/*select_handler*/ctx[18]);const tabpanels_spread_levels=[{class:"PinturaControlPanels"},{panelClass:"PinturaControlPanel"},{panels:/*panels*/ctx[12]},/*tabsConfig*/ctx[11]];let tabpanels_props={$$slots:{default:[create_default_slot$4,({panel,panelIsActive})=>({26:panel,27:panelIsActive}),({panel,panelIsActive})=>(panel?67108864:0)|(panelIsActive?134217728:0)]},$$scope:{ctx}};for(let i=0;i<tabpanels_spread_levels.length;i+=1){tabpanels_props=pintura_assign(tabpanels_props,tabpanels_spread_levels[i]);}tabpanels=new TabPanels({props:tabpanels_props});return{c(){div1=pintura_element("div");div0=pintura_element("div");if(if_block)if_block.c();t0=space();create_component(tablist.$$.fragment);t1=space();create_component(tabpanels.$$.fragment);attr(div0,"class","PinturaShapePresetsGroups");attr(div1,"class","PinturaShapePresetsGrouped");},m(target,anchor){insert(target,div1,anchor);append(div1,div0);if(if_block)if_block.m(div0,null);append(div0,t0);mount_component(tablist,div0,null);append(div1,t1);mount_component(tabpanels,div1,null);current=true;},p(ctx,dirty){if(/*presetToolbar*/ctx[13]){if(if_block){if_block.p(ctx,dirty);if(dirty&/*presetToolbar*/8192){transition_in(if_block,1);}}else{if_block=create_if_block_4$1(ctx);if_block.c();transition_in(if_block,1);if_block.m(div0,t0);}}else if(if_block){group_outros();transition_out(if_block,1,1,()=>{if_block=null;});check_outros();}const tablist_changes=dirty&/*tabs, tabsConfig*/2304?get_spread_update(tablist_spread_levels,[tablist_spread_levels[0],dirty&/*tabs*/256&&{tabs:/*tabs*/ctx[8]},dirty&/*tabsConfig*/2048&&get_spread_object(/*tabsConfig*/ctx[11]),tablist_spread_levels[3]]):{};if(dirty&/*$$scope, tab*/805306368){tablist_changes.$$scope={dirty,ctx};}tablist.$set(tablist_changes);const tabpanels_changes=dirty&/*panels, tabsConfig*/6144?get_spread_update(tabpanels_spread_levels,[tabpanels_spread_levels[0],tabpanels_spread_levels[1],dirty&/*panels*/4096&&{panels:/*panels*/ctx[12]},dirty&/*tabsConfig*/2048&&get_spread_object(/*tabsConfig*/ctx[11])]):{};if(dirty&/*$$scope, panelIsActive, shouldRenderPresets, scrollElasticity, presetTabs, panel, onaddpreset, ongrabpreset, ondragpreset, ondroppreset*/738198623){tabpanels_changes.$$scope={dirty,ctx};}tabpanels.$set(tabpanels_changes);},i(local){if(current)return;transition_in(if_block);transition_in(tablist.$$.fragment,local);transition_in(tabpanels.$$.fragment,local);current=true;},o(local){transition_out(if_block);transition_out(tablist.$$.fragment,local);transition_out(tabpanels.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div1);if(if_block)if_block.d();destroy_component(tablist);destroy_component(tabpanels);}};}// (230:16) {#if presetToolbar}
function create_if_block_5$1(ctx){let dynamiccomponenttree;let current;dynamiccomponenttree=new DynamicComponentTree_1({props:{items:/*presetToolbar*/ctx[13]}});return{c(){create_component(dynamiccomponenttree.$$.fragment);},m(target,anchor){mount_component(dynamiccomponenttree,target,anchor);current=true;},p(ctx,dirty){const dynamiccomponenttree_changes={};if(dirty&/*presetToolbar*/8192)dynamiccomponenttree_changes.items=/*presetToolbar*/ctx[13];dynamiccomponenttree.$set(dynamiccomponenttree_changes);},i(local){if(current)return;transition_in(dynamiccomponenttree.$$.fragment,local);current=true;},o(local){transition_out(dynamiccomponenttree.$$.fragment,local);current=false;},d(detaching){destroy_component(dynamiccomponenttree,detaching);}};}// (234:16) <Scrollable scrollAutoCancel={shouldRenderPresets} elasticity={scrollElasticity}>
function create_default_slot_4(ctx){let shapepresetslist;let current;shapepresetslist=new ShapePresetsList({props:{presets:/*presetsMapped*/ctx[5],onclickpreset:/*onaddpreset*/ctx[1],ongrabpreset:/*ongrabpreset*/ctx[2],ondragpreset:/*ondragpreset*/ctx[3],ondroppreset:/*ondroppreset*/ctx[4]}});return{c(){create_component(shapepresetslist.$$.fragment);},m(target,anchor){mount_component(shapepresetslist,target,anchor);current=true;},p(ctx,dirty){const shapepresetslist_changes={};if(dirty&/*presetsMapped*/32)shapepresetslist_changes.presets=/*presetsMapped*/ctx[5];if(dirty&/*onaddpreset*/2)shapepresetslist_changes.onclickpreset=/*onaddpreset*/ctx[1];if(dirty&/*ongrabpreset*/4)shapepresetslist_changes.ongrabpreset=/*ongrabpreset*/ctx[2];if(dirty&/*ondragpreset*/8)shapepresetslist_changes.ondragpreset=/*ondragpreset*/ctx[3];if(dirty&/*ondroppreset*/16)shapepresetslist_changes.ondroppreset=/*ondroppreset*/ctx[4];shapepresetslist.$set(shapepresetslist_changes);},i(local){if(current)return;transition_in(shapepresetslist.$$.fragment,local);current=true;},o(local){transition_out(shapepresetslist.$$.fragment,local);current=false;},d(detaching){destroy_component(shapepresetslist,detaching);}};}// (182:20) {#if presetToolbar}
function create_if_block_4$1(ctx){let dynamiccomponenttree;let current;dynamiccomponenttree=new DynamicComponentTree_1({props:{items:/*presetToolbar*/ctx[13]}});return{c(){create_component(dynamiccomponenttree.$$.fragment);},m(target,anchor){mount_component(dynamiccomponenttree,target,anchor);current=true;},p(ctx,dirty){const dynamiccomponenttree_changes={};if(dirty&/*presetToolbar*/8192)dynamiccomponenttree_changes.items=/*presetToolbar*/ctx[13];dynamiccomponenttree.$set(dynamiccomponenttree_changes);},i(local){if(current)return;transition_in(dynamiccomponenttree.$$.fragment,local);current=true;},o(local){transition_out(dynamiccomponenttree.$$.fragment,local);current=false;},d(detaching){destroy_component(dynamiccomponenttree,detaching);}};}// (194:24) {#if tab.icon}
function create_if_block_3$1(ctx){let icon;let current;icon=new Icon({props:{$$slots:{default:[create_default_slot_3]},$$scope:{ctx}}});return{c(){create_component(icon.$$.fragment);},m(target,anchor){mount_component(icon,target,anchor);current=true;},p(ctx,dirty){const icon_changes={};if(dirty&/*$$scope, tab*/805306368){icon_changes.$$scope={dirty,ctx};}icon.$set(icon_changes);},i(local){if(current)return;transition_in(icon.$$.fragment,local);current=true;},o(local){transition_out(icon.$$.fragment,local);current=false;},d(detaching){destroy_component(icon,detaching);}};}// (195:28) <Icon>
function create_default_slot_3(ctx){let g;let raw_value=/*tab*/ctx[28].icon+"";return{c(){g=svg_element("g");},m(target,anchor){insert(target,g,anchor);g.innerHTML=raw_value;},p(ctx,dirty){if(dirty&/*tab*/268435456&&raw_value!==(raw_value=/*tab*/ctx[28].icon+""))g.innerHTML=raw_value;},d(detaching){if(detaching)detach(g);}};}// (197:24) {#if !tab.hideLabel}
function create_if_block_2$1(ctx){let span;let t_value=/*tab*/ctx[28].label+"";let t;return{c(){span=pintura_element("span");t=pintura_text(t_value);},m(target,anchor){insert(target,span,anchor);append(span,t);},p(ctx,dirty){if(dirty&/*tab*/268435456&&t_value!==(t_value=/*tab*/ctx[28].label+""))set_data(t,t_value);},d(detaching){if(detaching)detach(span);}};}// (186:20) <TabList                         class="PinturaControlList"                         {tabs}                         {...tabsConfig}                         layout="compact"                         on:select={({ detail }) => (tabSelected = detail)}                         let:tab                     >
function create_default_slot_2(ctx){let t;let if_block1_anchor;let current;let if_block0=/*tab*/ctx[28].icon&&create_if_block_3$1(ctx);let if_block1=!/*tab*/ctx[28].hideLabel&&create_if_block_2$1(ctx);return{c(){if(if_block0)if_block0.c();t=space();if(if_block1)if_block1.c();if_block1_anchor=empty();},m(target,anchor){if(if_block0)if_block0.m(target,anchor);insert(target,t,anchor);if(if_block1)if_block1.m(target,anchor);insert(target,if_block1_anchor,anchor);current=true;},p(ctx,dirty){if(/*tab*/ctx[28].icon){if(if_block0){if_block0.p(ctx,dirty);if(dirty&/*tab*/268435456){transition_in(if_block0,1);}}else{if_block0=create_if_block_3$1(ctx);if_block0.c();transition_in(if_block0,1);if_block0.m(t.parentNode,t);}}else if(if_block0){group_outros();transition_out(if_block0,1,1,()=>{if_block0=null;});check_outros();}if(!/*tab*/ctx[28].hideLabel){if(if_block1){if_block1.p(ctx,dirty);}else{if_block1=create_if_block_2$1(ctx);if_block1.c();if_block1.m(if_block1_anchor.parentNode,if_block1_anchor);}}else if(if_block1){if_block1.d(1);if_block1=null;}},i(local){if(current)return;transition_in(if_block0);current=true;},o(local){transition_out(if_block0);current=false;},d(detaching){if(if_block0)if_block0.d(detaching);if(detaching)detach(t);if(if_block1)if_block1.d(detaching);if(detaching)detach(if_block1_anchor);}};}// (211:20) <Scrollable                         scroll={panelIsActive ? { scrollOffset: 0, animate: false } : undefined}                         scrollAutoCancel={shouldRenderPresets}                         elasticity={scrollElasticity}                     >
function create_default_slot_1$1(ctx){let shapepresetslist;let current;shapepresetslist=new ShapePresetsList({props:{presets:/*presetTabs*/ctx[10][/*panel*/ctx[26]].items,disabled:/*presetTabs*/ctx[10][/*panel*/ctx[26]].disabled,onclickpreset:/*onaddpreset*/ctx[1],ongrabpreset:/*ongrabpreset*/ctx[2],ondragpreset:/*ondragpreset*/ctx[3],ondroppreset:/*ondroppreset*/ctx[4]}});return{c(){create_component(shapepresetslist.$$.fragment);},m(target,anchor){mount_component(shapepresetslist,target,anchor);current=true;},p(ctx,dirty){const shapepresetslist_changes={};if(dirty&/*presetTabs, panel*/67109888)shapepresetslist_changes.presets=/*presetTabs*/ctx[10][/*panel*/ctx[26]].items;if(dirty&/*presetTabs, panel*/67109888)shapepresetslist_changes.disabled=/*presetTabs*/ctx[10][/*panel*/ctx[26]].disabled;if(dirty&/*onaddpreset*/2)shapepresetslist_changes.onclickpreset=/*onaddpreset*/ctx[1];if(dirty&/*ongrabpreset*/4)shapepresetslist_changes.ongrabpreset=/*ongrabpreset*/ctx[2];if(dirty&/*ondragpreset*/8)shapepresetslist_changes.ondragpreset=/*ondragpreset*/ctx[3];if(dirty&/*ondroppreset*/16)shapepresetslist_changes.ondroppreset=/*ondroppreset*/ctx[4];shapepresetslist.$set(shapepresetslist_changes);},i(local){if(current)return;transition_in(shapepresetslist.$$.fragment,local);current=true;},o(local){transition_out(shapepresetslist.$$.fragment,local);current=false;},d(detaching){destroy_component(shapepresetslist,detaching);}};}// (203:16) <TabPanels                     class="PinturaControlPanels"                     panelClass="PinturaControlPanel"                     {panels}                     {...tabsConfig}                     let:panel                     let:panelIsActive                 >
function create_default_slot$4(ctx){let scrollable;let current;scrollable=new Scrollable({props:{scroll:/*panelIsActive*/ctx[27]?{scrollOffset:0,animate:false}:undefined,scrollAutoCancel:/*shouldRenderPresets*/ctx[6],elasticity:/*scrollElasticity*/ctx[0],$$slots:{default:[create_default_slot_1$1]},$$scope:{ctx}}});return{c(){create_component(scrollable.$$.fragment);},m(target,anchor){mount_component(scrollable,target,anchor);current=true;},p(ctx,dirty){const scrollable_changes={};if(dirty&/*panelIsActive*/134217728)scrollable_changes.scroll=/*panelIsActive*/ctx[27]?{scrollOffset:0,animate:false}:undefined;if(dirty&/*shouldRenderPresets*/64)scrollable_changes.scrollAutoCancel=/*shouldRenderPresets*/ctx[6];if(dirty&/*scrollElasticity*/1)scrollable_changes.elasticity=/*scrollElasticity*/ctx[0];if(dirty&/*$$scope, presetTabs, panel, onaddpreset, ongrabpreset, ondragpreset, ondroppreset*/603980830){scrollable_changes.$$scope={dirty,ctx};}scrollable.$set(scrollable_changes);},i(local){if(current)return;transition_in(scrollable.$$.fragment,local);current=true;},o(local){transition_out(scrollable.$$.fragment,local);current=false;},d(detaching){destroy_component(scrollable,detaching);}};}function create_fragment$a(ctx){let div;let current_block_type_index;let if_block;let current;const if_block_creators=[create_if_block$1,create_if_block_6];const if_blocks=[];function select_block_type(ctx,dirty){if(/*shouldRenderPresets*/ctx[6])return 0;if(/*presetToolbar*/ctx[13])return 1;return-1;}if(~(current_block_type_index=select_block_type(ctx))){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);}return{c(){div=pintura_element("div");if(if_block)if_block.c();attr(div,"class","PinturaShapePresetsPalette");},m(target,anchor){insert(target,div,anchor);if(~current_block_type_index){if_blocks[current_block_type_index].m(div,null);}current=true;},p(ctx,[dirty]){let previous_block_index=current_block_type_index;current_block_type_index=select_block_type(ctx);if(current_block_type_index===previous_block_index){if(~current_block_type_index){if_blocks[current_block_type_index].p(ctx,dirty);}}else{if(if_block){group_outros();transition_out(if_blocks[previous_block_index],1,1,()=>{if_blocks[previous_block_index]=null;});check_outros();}if(~current_block_type_index){if_block=if_blocks[current_block_type_index];if(!if_block){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);if_block.c();}else{if_block.p(ctx,dirty);}transition_in(if_block,1);if_block.m(div,null);}else{if_block=null;}}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(detaching)detach(div);if(~current_block_type_index){if_blocks[current_block_type_index].d();}}};}function instance$a($$self,$$props,$$invalidate){let presetsMapped;let shouldRenderPresets;let shouldGroupPresets;let tabs;let presetTabs;let tabSelected;let tabsConfig;let panels;let presetToolbar;let{locale}=$$props;let{presets}=$$props;let{scrollElasticity}=$$props;let{enableSelectImage=true}=$$props;let{willRenderPresetToolbar=passthrough}=$$props;let{onaddpreset=noop$1}=$$props;let{ongrabpreset=undefined}=$$props;let{ondragpreset=undefined}=$$props;let{ondroppreset=undefined}=$$props;const uid=`presets-${getUniqueId()}`;const isPresetGroup=item=>pintura_isArray(item)&&pintura_isString(item[0])&&pintura_isArray(item[1]);const getPresetThumb=(value,alt="")=>{// could be svg
if(isSVGMarkup(value))return value;// test if is emoji
if(isEmoji(value))return getEmojiSVG(value,alt);// must be URL
return`<img src="${value}" alt="${alt}"/>`;};const getAltFromSrc=src=>getFilenameWithoutExtension(getFilenameFromURL(src));const excludedStickerItemProps=["src","alt","thumb","shape","id","mount","disabled"];const mapPreset=item=>{let id=item;let src;let shape;let shapeProps;let thumb;let alt;let mount;let disabled;// if item is a string, it's either an emoji or a URL
if(pintura_isString(item)){// is emoji
if(isEmoji(item)){src=item;alt=item;thumb=getPresetThumb(src,alt);}else// must be URL
{src=item;alt=getAltFromSrc(src);thumb=getPresetThumb(src,alt);}}else{// set custom thumbnail if defined
src=item.src;alt=item.alt||(pintura_isString(src)?getAltFromSrc(src):pintura_isString(item.thumb)?getAltFromSrc(item.thumb):undefined);thumb=getPresetThumb(item.thumb||src,alt);shape=item.shape;mount=item.mount;disabled=item.disabled;shapeProps=Object.keys(item).reduce((prev,curr)=>{if(excludedStickerItemProps.includes(curr))return prev;prev[curr]=item[curr];return prev;},{});}return{id,src,thumb,shape,shapeProps,alt,title:alt,mount,disabled};};const mapPresets=items=>items.map(item=>{if(isPresetGroup(item)){return{...item[2],id:`${uid}-${item[0].toLowerCase()}`,label:item[0],items:mapPresets(item[1])};}return mapPreset(item);});const select_handler=({detail})=>$$invalidate(9,tabSelected=detail);$$self.$$set=$$props=>{if("locale"in $$props)$$invalidate(14,locale=$$props.locale);if("presets"in $$props)$$invalidate(15,presets=$$props.presets);if("scrollElasticity"in $$props)$$invalidate(0,scrollElasticity=$$props.scrollElasticity);if("enableSelectImage"in $$props)$$invalidate(16,enableSelectImage=$$props.enableSelectImage);if("willRenderPresetToolbar"in $$props)$$invalidate(17,willRenderPresetToolbar=$$props.willRenderPresetToolbar);if("onaddpreset"in $$props)$$invalidate(1,onaddpreset=$$props.onaddpreset);if("ongrabpreset"in $$props)$$invalidate(2,ongrabpreset=$$props.ongrabpreset);if("ondragpreset"in $$props)$$invalidate(3,ondragpreset=$$props.ondragpreset);if("ondroppreset"in $$props)$$invalidate(4,ondroppreset=$$props.ondroppreset);};$$self.$$.update=()=>{if($$self.$$.dirty&/*presets*/32768){$$invalidate(5,presetsMapped=mapPresets(presets));}if($$self.$$.dirty&/*presetsMapped*/32){//
// handle file input
//
$$invalidate(6,shouldRenderPresets=presetsMapped.length);}if($$self.$$.dirty&/*shouldRenderPresets, presetsMapped*/96){$$invalidate(7,shouldGroupPresets=shouldRenderPresets&&presetsMapped.some(preset=>!!preset.items));}if($$self.$$.dirty&/*shouldGroupPresets, presetsMapped*/160){$$invalidate(8,tabs=shouldGroupPresets&&presetsMapped);}if($$self.$$.dirty&/*shouldGroupPresets, presetsMapped*/160){$$invalidate(10,presetTabs=shouldGroupPresets&&presetsMapped.reduce((prev,curr)=>{prev[curr.id]=curr;return prev;},{}));}if($$self.$$.dirty&/*tabSelected, tabs*/768){$$invalidate(9,tabSelected=tabSelected||tabs&&(tabs.find(tab=>!tab.disabled)||{}).id);}if($$self.$$.dirty&/*tabSelected*/512){$$invalidate(11,tabsConfig={name:uid,selected:tabSelected});}if($$self.$$.dirty&/*tabs*/256){$$invalidate(12,panels=tabs&&tabs.map(tab=>tab.id));}if($$self.$$.dirty&/*locale, willRenderPresetToolbar, enableSelectImage, onaddpreset*/212994){$$invalidate(13,presetToolbar=locale&&willRenderPresetToolbar([enableSelectImage&&["Button","browse",{label:locale.shapeLabelButtonSelectSticker,icon:locale.shapeIconButtonSelectSticker,onclick:()=>{browse().then(file=>{if(!file)return;onaddpreset(file);});}// // create file input box
// const fileInput = h('input', {
//     type: 'file',
}]]));//     accept: 'image/*',
//     onchange: () => {
//         const [file] = fileInput.files;
//         if (!file) return;
//         onaddpreset(file);
//     },
// });
// // open browse window
// fileInput.click();
}};return[scrollElasticity,onaddpreset,ongrabpreset,ondragpreset,ondroppreset,presetsMapped,shouldRenderPresets,shouldGroupPresets,tabs,tabSelected,presetTabs,tabsConfig,panels,presetToolbar,locale,presets,enableSelectImage,willRenderPresetToolbar,select_handler];}class ShapePresetsPalette extends SvelteComponent{constructor(options){super();init(this,options,instance$a,create_fragment$a,safe_not_equal,{locale:14,presets:15,scrollElasticity:0,enableSelectImage:16,willRenderPresetToolbar:17,onaddpreset:1,ongrabpreset:2,ondragpreset:3,ondroppreset:4});}}var createPingDispatcher=node=>(type,data)=>{node.dispatchEvent(createPing(type,data));};/* src/core/ui/components/ShapeUtil.svelte generated by Svelte v3.37.0 */function create_if_block_5(ctx){let shapelayouteditor;let updating_markup;let updating_ui;let current;const shapelayouteditor_spread_levels=[{locale:/*locale*/ctx[4]},{uid:/*utilKey*/ctx[13]},{parentRect:/*$parentRect*/ctx[23]},{rootRect:/*$rootRect*/ctx[31]},{utilRect:/*$utilRect*/ctx[25]},{offset:/*markupOffset*/ctx[33]},{contextScale:/*$presentationScalar*/ctx[42]},{contextRotation:/*imageRotation*/ctx[16]},{contextFlipX:/*imageFlipX*/ctx[17]},{contextFlipY:/*imageFlipY*/ctx[18]},{active:/*$isActive*/ctx[24]},{opacity:/*$isActiveFraction*/ctx[28]},{eraseRadius:/*toolEraseRadius*/ctx[34]},{selectRadius:/*toolSelectRadius*/ctx[6]},{enableButtonFlipVertical:/*enableButtonFlipVertical*/ctx[8]},{mapEditorPointToImagePoint:/*mapScreenPointToImagePoint*/ctx[14]},{mapImagePointToEditorPoint:/*mapImagePointToScreenPoint*/ctx[15]},{enableTapToAddText:/*enableTapToAddText*/ctx[11]},{oninteractionstart:/*handleInteractionStart*/ctx[54]},{oninteractionupdate:/*handleInteractionUpdate*/ctx[55]},{oninteractionrelease:/*handleInteractionRelease*/ctx[56]},{oninteractionend:/*handleInteractionEnd*/ctx[57]},{onaddshape:/*func_1*/ctx[89]},{onselectshape:/*func_2*/ctx[90]},{onupdateshape:/*func_3*/ctx[91]},{onremoveshape:/*func_4*/ctx[92]},/*layoutEditorHooks*/ctx[39]];function shapelayouteditor_markup_binding(value){/*shapelayouteditor_markup_binding*/ctx[94](value);}function shapelayouteditor_ui_binding(value){/*shapelayouteditor_ui_binding*/ctx[95](value);}let shapelayouteditor_props={};for(let i=0;i<shapelayouteditor_spread_levels.length;i+=1){shapelayouteditor_props=pintura_assign(shapelayouteditor_props,shapelayouteditor_spread_levels[i]);}if(/*$shapes*/ctx[26]!==void 0){shapelayouteditor_props.markup=/*$shapes*/ctx[26];}if(/*$imageOverlayMarkup*/ctx[41]!==void 0){shapelayouteditor_props.ui=/*$imageOverlayMarkup*/ctx[41];}shapelayouteditor=new ShapeLayoutEditor({props:shapelayouteditor_props});/*shapelayouteditor_binding*/ctx[93](shapelayouteditor);binding_callbacks.push(()=>bind(shapelayouteditor,"markup",shapelayouteditor_markup_binding));binding_callbacks.push(()=>bind(shapelayouteditor,"ui",shapelayouteditor_ui_binding));return{c(){create_component(shapelayouteditor.$$.fragment);},m(target,anchor){mount_component(shapelayouteditor,target,anchor);current=true;},p(ctx,dirty){const shapelayouteditor_changes=dirty[0]&/*locale, utilKey, $parentRect, $utilRect, imageRotation, imageFlipX, imageFlipY, $isActive, $isActiveFraction, toolSelectRadius, enableButtonFlipVertical, mapScreenPointToImagePoint, mapImagePointToScreenPoint, enableTapToAddText*/327674192|dirty[1]&/*$rootRect, markupOffset, $presentationScalar, toolEraseRadius, handleInteractionStart, handleInteractionUpdate, handleInteractionRelease, handleInteractionEnd, ping, layoutEditorHooks*/125831469|dirty[2]&/*handleMarkupUpdate*/4?get_spread_update(shapelayouteditor_spread_levels,[dirty[0]&/*locale*/16&&{locale:/*locale*/ctx[4]},dirty[0]&/*utilKey*/8192&&{uid:/*utilKey*/ctx[13]},dirty[0]&/*$parentRect*/8388608&&{parentRect:/*$parentRect*/ctx[23]},dirty[1]&/*$rootRect*/1&&{rootRect:/*$rootRect*/ctx[31]},dirty[0]&/*$utilRect*/33554432&&{utilRect:/*$utilRect*/ctx[25]},dirty[1]&/*markupOffset*/4&&{offset:/*markupOffset*/ctx[33]},dirty[1]&/*$presentationScalar*/2048&&{contextScale:/*$presentationScalar*/ctx[42]},dirty[0]&/*imageRotation*/65536&&{contextRotation:/*imageRotation*/ctx[16]},dirty[0]&/*imageFlipX*/131072&&{contextFlipX:/*imageFlipX*/ctx[17]},dirty[0]&/*imageFlipY*/262144&&{contextFlipY:/*imageFlipY*/ctx[18]},dirty[0]&/*$isActive*/16777216&&{active:/*$isActive*/ctx[24]},dirty[0]&/*$isActiveFraction*/268435456&&{opacity:/*$isActiveFraction*/ctx[28]},dirty[1]&/*toolEraseRadius*/8&&{eraseRadius:/*toolEraseRadius*/ctx[34]},dirty[0]&/*toolSelectRadius*/64&&{selectRadius:/*toolSelectRadius*/ctx[6]},dirty[0]&/*enableButtonFlipVertical*/256&&{enableButtonFlipVertical:/*enableButtonFlipVertical*/ctx[8]},dirty[0]&/*mapScreenPointToImagePoint*/16384&&{mapEditorPointToImagePoint:/*mapScreenPointToImagePoint*/ctx[14]},dirty[0]&/*mapImagePointToScreenPoint*/32768&&{mapImagePointToEditorPoint:/*mapImagePointToScreenPoint*/ctx[15]},dirty[0]&/*enableTapToAddText*/2048&&{enableTapToAddText:/*enableTapToAddText*/ctx[11]},dirty[1]&/*handleInteractionStart*/8388608&&{oninteractionstart:/*handleInteractionStart*/ctx[54]},dirty[1]&/*handleInteractionUpdate*/16777216&&{oninteractionupdate:/*handleInteractionUpdate*/ctx[55]},dirty[1]&/*handleInteractionRelease*/33554432&&{oninteractionrelease:/*handleInteractionRelease*/ctx[56]},dirty[1]&/*handleInteractionEnd*/67108864&&{oninteractionend:/*handleInteractionEnd*/ctx[57]},dirty[1]&/*ping*/32|dirty[2]&/*handleMarkupUpdate*/4&&{onaddshape:/*func_1*/ctx[89]},dirty[1]&/*ping*/32&&{onselectshape:/*func_2*/ctx[90]},dirty[1]&/*ping*/32|dirty[2]&/*handleMarkupUpdate*/4&&{onupdateshape:/*func_3*/ctx[91]},dirty[1]&/*ping*/32|dirty[2]&/*handleMarkupUpdate*/4&&{onremoveshape:/*func_4*/ctx[92]},dirty[1]&/*layoutEditorHooks*/256&&get_spread_object(/*layoutEditorHooks*/ctx[39])]):{};if(!updating_markup&&dirty[0]&/*$shapes*/67108864){updating_markup=true;shapelayouteditor_changes.markup=/*$shapes*/ctx[26];add_flush_callback(()=>updating_markup=false);}if(!updating_ui&&dirty[1]&/*$imageOverlayMarkup*/1024){updating_ui=true;shapelayouteditor_changes.ui=/*$imageOverlayMarkup*/ctx[41];add_flush_callback(()=>updating_ui=false);}shapelayouteditor.$set(shapelayouteditor_changes);},i(local){if(current)return;transition_in(shapelayouteditor.$$.fragment,local);current=true;},o(local){transition_out(shapelayouteditor.$$.fragment,local);current=false;},d(detaching){/*shapelayouteditor_binding*/ctx[93](null);destroy_component(shapelayouteditor,detaching);}};}// (559:4) 
function create_main_slot(ctx){let div;let current;let mounted;let dispose;let if_block=/*shouldRenderShapeEditor*/ctx[32]&&create_if_block_5(ctx);return{c(){div=pintura_element("div");if(if_block)if_block.c();attr(div,"slot","main");set_style(div,"cursor","crosshair");},m(target,anchor){insert(target,div,anchor);if(if_block)if_block.m(div,null);/*div_binding*/ctx[96](div);current=true;if(!mounted){dispose=[action_destroyer(dropable.call(null,div)),listen(div,"dropfiles",function(){if(is_function(/*enablePresetDropImage*/ctx[10]?/*handleDropFiles*/ctx[63]:noop$1))(/*enablePresetDropImage*/ctx[10]?/*handleDropFiles*/ctx[63]:noop$1).apply(this,arguments);}),action_destroyer(measurable.call(null,div)),listen(div,"measure",/*measure_handler_1*/ctx[87])];mounted=true;}},p(new_ctx,dirty){ctx=new_ctx;if(/*shouldRenderShapeEditor*/ctx[32]){if(if_block){if_block.p(ctx,dirty);if(dirty[1]&/*shouldRenderShapeEditor*/2){transition_in(if_block,1);}}else{if_block=create_if_block_5(ctx);if_block.c();transition_in(if_block,1);if_block.m(div,null);}}else if(if_block){group_outros();transition_out(if_block,1,1,()=>{if_block=null;});check_outros();}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(detaching)detach(div);if(if_block)if_block.d();/*div_binding*/ctx[96](null);mounted=false;run_all(dispose);}};}// (681:38) 
function create_if_block_4(ctx){let shapepresetspalette;let current;shapepresetspalette=new ShapePresetsPalette({props:{locale:/*locale*/ctx[4],presets:/*shapePresets*/ctx[12],enableSelectImage:/*enablePresetSelectImage*/ctx[9],willRenderPresetToolbar:/*runWillRenderPresetToolbarHook*/ctx[38],onaddpreset:/*handleAddPreset*/ctx[62],ongrabpreset:/*handleGrabPreset*/ctx[59],ondragpreset:/*handleDragPreset*/ctx[60],ondroppreset:/*handleDropPreset*/ctx[61],scrollElasticity:/*computedScrollElasticity*/ctx[37]}});return{c(){create_component(shapepresetspalette.$$.fragment);},m(target,anchor){mount_component(shapepresetspalette,target,anchor);current=true;},p(ctx,dirty){const shapepresetspalette_changes={};if(dirty[0]&/*locale*/16)shapepresetspalette_changes.locale=/*locale*/ctx[4];if(dirty[0]&/*shapePresets*/4096)shapepresetspalette_changes.presets=/*shapePresets*/ctx[12];if(dirty[0]&/*enablePresetSelectImage*/512)shapepresetspalette_changes.enableSelectImage=/*enablePresetSelectImage*/ctx[9];if(dirty[1]&/*runWillRenderPresetToolbarHook*/128)shapepresetspalette_changes.willRenderPresetToolbar=/*runWillRenderPresetToolbarHook*/ctx[38];if(dirty[1]&/*computedScrollElasticity*/64)shapepresetspalette_changes.scrollElasticity=/*computedScrollElasticity*/ctx[37];shapepresetspalette.$set(shapepresetspalette_changes);},i(local){if(current)return;transition_in(shapepresetspalette.$$.fragment,local);current=true;},o(local){transition_out(shapepresetspalette.$$.fragment,local);current=false;},d(detaching){destroy_component(shapepresetspalette,detaching);}};}// (616:8) {#if shouldRenderControls}
function create_if_block(ctx){let div;let current_block_type_index;let if_block0;let t;let if_block1_anchor;let current;const if_block_creators=[create_if_block_3,create_else_block];const if_blocks=[];function select_block_type_1(ctx,dirty){if(/*shouldRenderPresets*/ctx[35])return 0;return 1;}current_block_type_index=select_block_type_1(ctx);if_block0=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);let if_block1=/*showToolbar*/ctx[22]&&create_if_block_1(ctx);return{c(){div=pintura_element("div");if_block0.c();t=space();if(if_block1)if_block1.c();if_block1_anchor=empty();attr(div,"class","PinturaControlPanels");},m(target,anchor){insert(target,div,anchor);if_blocks[current_block_type_index].m(div,null);insert(target,t,anchor);if(if_block1)if_block1.m(target,anchor);insert(target,if_block1_anchor,anchor);current=true;},p(ctx,dirty){let previous_block_index=current_block_type_index;current_block_type_index=select_block_type_1(ctx);if(current_block_type_index===previous_block_index){if_blocks[current_block_type_index].p(ctx,dirty);}else{group_outros();transition_out(if_blocks[previous_block_index],1,1,()=>{if_blocks[previous_block_index]=null;});check_outros();if_block0=if_blocks[current_block_type_index];if(!if_block0){if_block0=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);if_block0.c();}else{if_block0.p(ctx,dirty);}transition_in(if_block0,1);if_block0.m(div,null);}if(/*showToolbar*/ctx[22]){if(if_block1){if_block1.p(ctx,dirty);if(dirty[0]&/*showToolbar*/4194304){transition_in(if_block1,1);}}else{if_block1=create_if_block_1(ctx);if_block1.c();transition_in(if_block1,1);if_block1.m(if_block1_anchor.parentNode,if_block1_anchor);}}else if(if_block1){group_outros();transition_out(if_block1,1,1,()=>{if_block1=null;});check_outros();}},i(local){if(current)return;transition_in(if_block0);transition_in(if_block1);current=true;},o(local){transition_out(if_block0);transition_out(if_block1);current=false;},d(detaching){if(detaching)detach(div);if_blocks[current_block_type_index].d();if(detaching)detach(t);if(if_block1)if_block1.d(detaching);if(detaching)detach(if_block1_anchor);}};}// (632:16) {:else}
function create_else_block(ctx){let div;let shapestyleeditor;let current;shapestyleeditor=new ShapeStyleEditor({props:{locale:/*locale*/ctx[4],shape:/*markupShapeSelected*/ctx[27],onchange:/*handleUpdateSelectedMarkupShape*/ctx[58],controls:/*shapeControls*/ctx[7],scrollElasticity:/*computedScrollElasticity*/ctx[37]}});return{c(){div=pintura_element("div");create_component(shapestyleeditor.$$.fragment);attr(div,"class","PinturaControlPanel");},m(target,anchor){insert(target,div,anchor);mount_component(shapestyleeditor,div,null);current=true;},p(ctx,dirty){const shapestyleeditor_changes={};if(dirty[0]&/*locale*/16)shapestyleeditor_changes.locale=/*locale*/ctx[4];if(dirty[0]&/*markupShapeSelected*/134217728)shapestyleeditor_changes.shape=/*markupShapeSelected*/ctx[27];if(dirty[0]&/*shapeControls*/128)shapestyleeditor_changes.controls=/*shapeControls*/ctx[7];if(dirty[1]&/*computedScrollElasticity*/64)shapestyleeditor_changes.scrollElasticity=/*computedScrollElasticity*/ctx[37];shapestyleeditor.$set(shapestyleeditor_changes);},i(local){if(current)return;transition_in(shapestyleeditor.$$.fragment,local);current=true;},o(local){transition_out(shapestyleeditor.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(shapestyleeditor);}};}// (618:16) {#if shouldRenderPresets}
function create_if_block_3(ctx){let div;let shapepresetspalette;let current;shapepresetspalette=new ShapePresetsPalette({props:{locale:/*locale*/ctx[4],presets:/*shapePresets*/ctx[12],enableSelectImage:/*enablePresetSelectImage*/ctx[9],willRenderPresetToolbar:/*runWillRenderPresetToolbarHook*/ctx[38],onaddpreset:/*handleAddPreset*/ctx[62],ongrabpreset:/*handleGrabPreset*/ctx[59],ondragpreset:/*handleDragPreset*/ctx[60],ondroppreset:/*handleDropPreset*/ctx[61],scrollElasticity:/*computedScrollElasticity*/ctx[37]}});return{c(){div=pintura_element("div");create_component(shapepresetspalette.$$.fragment);attr(div,"class","PinturaControlPanel");},m(target,anchor){insert(target,div,anchor);mount_component(shapepresetspalette,div,null);current=true;},p(ctx,dirty){const shapepresetspalette_changes={};if(dirty[0]&/*locale*/16)shapepresetspalette_changes.locale=/*locale*/ctx[4];if(dirty[0]&/*shapePresets*/4096)shapepresetspalette_changes.presets=/*shapePresets*/ctx[12];if(dirty[0]&/*enablePresetSelectImage*/512)shapepresetspalette_changes.enableSelectImage=/*enablePresetSelectImage*/ctx[9];if(dirty[1]&/*runWillRenderPresetToolbarHook*/128)shapepresetspalette_changes.willRenderPresetToolbar=/*runWillRenderPresetToolbarHook*/ctx[38];if(dirty[1]&/*computedScrollElasticity*/64)shapepresetspalette_changes.scrollElasticity=/*computedScrollElasticity*/ctx[37];shapepresetspalette.$set(shapepresetspalette_changes);},i(local){if(current)return;transition_in(shapepresetspalette.$$.fragment,local);current=true;},o(local){transition_out(shapepresetspalette.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(shapepresetspalette);}};}// (645:12) {#if showToolbar}
function create_if_block_1(ctx){let scrollable;let current;scrollable=new Scrollable({props:{class:"PinturaControlListScroller",elasticity:/*computedScrollElasticity*/ctx[37],$$slots:{default:[create_default_slot$3]},$$scope:{ctx}}});return{c(){create_component(scrollable.$$.fragment);},m(target,anchor){mount_component(scrollable,target,anchor);current=true;},p(ctx,dirty){const scrollable_changes={};if(dirty[1]&/*computedScrollElasticity*/64)scrollable_changes.elasticity=/*computedScrollElasticity*/ctx[37];if(dirty[0]&/*locale, toolsFiltered, toolActive*/2097169|dirty[3]&/*$$scope*/4194304){scrollable_changes.$$scope={dirty,ctx};}scrollable.$set(scrollable_changes);},i(local){if(current)return;transition_in(scrollable.$$.fragment,local);current=true;},o(local){transition_out(scrollable.$$.fragment,local);current=false;},d(detaching){destroy_component(scrollable,detaching);}};}// (663:28) {#if option.icon}
function create_if_block_2(ctx){let icon;let current;icon=new Icon({props:{$$slots:{default:[create_default_slot_1]},$$scope:{ctx}}});return{c(){create_component(icon.$$.fragment);},m(target,anchor){mount_component(icon,target,anchor);current=true;},p(ctx,dirty){const icon_changes={};if(dirty[0]&/*locale*/16|dirty[3]&/*$$scope, option*/6291456){icon_changes.$$scope={dirty,ctx};}icon.$set(icon_changes);},i(local){if(current)return;transition_in(icon.$$.fragment,local);current=true;},o(local){transition_out(icon.$$.fragment,local);current=false;},d(detaching){destroy_component(icon,detaching);}};}// (664:32) <Icon                                     >
function create_default_slot_1(ctx){let g;let raw_value=(pintura_isFunction(/*option*/ctx[114].icon)?/*option*/ctx[114].icon(/*locale*/ctx[4]):/*option*/ctx[114].icon)+"";return{c(){g=svg_element("g");},m(target,anchor){insert(target,g,anchor);g.innerHTML=raw_value;},p(ctx,dirty){if(dirty[0]&/*locale*/16|dirty[3]&/*option*/2097152&&raw_value!==(raw_value=(pintura_isFunction(/*option*/ctx[114].icon)?/*option*/ctx[114].icon(/*locale*/ctx[4]):/*option*/ctx[114].icon)+""))g.innerHTML=raw_value;},d(detaching){if(detaching)detach(g);}};}// (662:24) 
function create_option_slot$1(ctx){let div;let t0;let span;let t1_value=(pintura_isFunction(/*option*/ctx[114].label)?/*option*/ctx[114].label(/*locale*/ctx[4]):/*option*/ctx[114].label)+"";let t1;let current;let if_block=/*option*/ctx[114].icon&&create_if_block_2(ctx);return{c(){div=pintura_element("div");if(if_block)if_block.c();t0=space();span=pintura_element("span");t1=pintura_text(t1_value);attr(div,"slot","option");},m(target,anchor){insert(target,div,anchor);if(if_block)if_block.m(div,null);append(div,t0);append(div,span);append(span,t1);current=true;},p(ctx,dirty){if(/*option*/ctx[114].icon){if(if_block){if_block.p(ctx,dirty);if(dirty[3]&/*option*/2097152){transition_in(if_block,1);}}else{if_block=create_if_block_2(ctx);if_block.c();transition_in(if_block,1);if_block.m(div,t0);}}else if(if_block){group_outros();transition_out(if_block,1,1,()=>{if_block=null;});check_outros();}if((!current||dirty[0]&/*locale*/16|dirty[3]&/*option*/2097152)&&t1_value!==(t1_value=(pintura_isFunction(/*option*/ctx[114].label)?/*option*/ctx[114].label(/*locale*/ctx[4]):/*option*/ctx[114].label)+""))set_data(t1,t1_value);},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(detaching)detach(div);if(if_block)if_block.d();}};}// (646:16) <Scrollable                     class="PinturaControlListScroller"                     elasticity={computedScrollElasticity}                 >
function create_default_slot$3(ctx){let radiogroup;let current;radiogroup=new RadioGroup({props:{locale:/*locale*/ctx[4],class:"PinturaControlList",optionClass:"PinturaControlListOption",layout:"row",options:/*toolsFiltered*/ctx[21],selectedIndex:/*toolsFiltered*/ctx[21].findIndex(/*func*/ctx[88]),onchange:/*updateActiveTool*/ctx[53],$$slots:{option:[create_option_slot$1,({option})=>({114:option}),({option})=>[0,0,0,option?2097152:0]]},$$scope:{ctx}}});return{c(){create_component(radiogroup.$$.fragment);},m(target,anchor){mount_component(radiogroup,target,anchor);current=true;},p(ctx,dirty){const radiogroup_changes={};if(dirty[0]&/*locale*/16)radiogroup_changes.locale=/*locale*/ctx[4];if(dirty[0]&/*toolsFiltered*/2097152)radiogroup_changes.options=/*toolsFiltered*/ctx[21];if(dirty[0]&/*toolsFiltered, toolActive*/2097153)radiogroup_changes.selectedIndex=/*toolsFiltered*/ctx[21].findIndex(/*func*/ctx[88]);if(dirty[0]&/*locale*/16|dirty[3]&/*$$scope, option*/6291456){radiogroup_changes.$$scope={dirty,ctx};}radiogroup.$set(radiogroup_changes);},i(local){if(current)return;transition_in(radiogroup.$$.fragment,local);current=true;},o(local){transition_out(radiogroup.$$.fragment,local);current=false;},d(detaching){destroy_component(radiogroup,detaching);}};}// (615:4) 
function create_footer_slot$2(ctx){let div;let current_block_type_index;let if_block;let current;const if_block_creators=[create_if_block,create_if_block_4];const if_blocks=[];function select_block_type(ctx,dirty){if(/*shouldRenderControls*/ctx[30])return 0;if(/*shouldRenderPresets*/ctx[35])return 1;return-1;}if(~(current_block_type_index=select_block_type(ctx))){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);}return{c(){div=pintura_element("div");if(if_block)if_block.c();attr(div,"slot","footer");attr(div,"style",/*footerStyle*/ctx[40]);},m(target,anchor){insert(target,div,anchor);if(~current_block_type_index){if_blocks[current_block_type_index].m(div,null);}current=true;},p(ctx,dirty){let previous_block_index=current_block_type_index;current_block_type_index=select_block_type(ctx);if(current_block_type_index===previous_block_index){if(~current_block_type_index){if_blocks[current_block_type_index].p(ctx,dirty);}}else{if(if_block){group_outros();transition_out(if_blocks[previous_block_index],1,1,()=>{if_blocks[previous_block_index]=null;});check_outros();}if(~current_block_type_index){if_block=if_blocks[current_block_type_index];if(!if_block){if_block=if_blocks[current_block_type_index]=if_block_creators[current_block_type_index](ctx);if_block.c();}else{if_block.p(ctx,dirty);}transition_in(if_block,1);if_block.m(div,null);}else{if_block=null;}}if(!current||dirty[1]&/*footerStyle*/512){attr(div,"style",/*footerStyle*/ctx[40]);}},i(local){if(current)return;transition_in(if_block);current=true;},o(local){transition_out(if_block);current=false;},d(detaching){if(detaching)detach(div);if(~current_block_type_index){if_blocks[current_block_type_index].d();}}};}function create_fragment$9(ctx){let util;let current;util=new Util({props:{$$slots:{footer:[create_footer_slot$2],main:[create_main_slot]},$$scope:{ctx}}});util.$on("measure",/*measure_handler*/ctx[97]);return{c(){create_component(util.$$.fragment);},m(target,anchor){mount_component(util,target,anchor);current=true;},p(ctx,dirty){const util_changes={};if(dirty[0]&/*locale, toolsFiltered, toolActive, showToolbar, shapePresets, enablePresetSelectImage, markupShapeSelected, shapeControls, shouldRenderControls, pingHub, enablePresetDropImage, utilKey, $parentRect, $utilRect, imageRotation, imageFlipX, imageFlipY, $isActive, $isActiveFraction, toolSelectRadius, enableButtonFlipVertical, mapScreenPointToImagePoint, mapImagePointToScreenPoint, enableTapToAddText, markupEditor, $shapes*/2146959313|dirty[1]&/*footerStyle, computedScrollElasticity, runWillRenderPresetToolbarHook, shouldRenderPresets, $rootRect, markupOffset, $presentationScalar, toolEraseRadius, ping, layoutEditorHooks, $imageOverlayMarkup, shouldRenderShapeEditor*/4095|dirty[3]&/*$$scope*/4194304){util_changes.$$scope={dirty,ctx};}util.$set(util_changes);},i(local){if(current)return;transition_in(util.$$.fragment,local);current=true;},o(local){transition_out(util.$$.fragment,local);current=false;},d(detaching){destroy_component(util,detaching);}};}function instance$9($$self,$$props,$$invalidate){let toolsFiltered;let hasShapeControls;let showToolbar;let hasTools;let hasActiveTool;let shouldRenderControls;let shouldRenderShapeEditor;let markupOffset;let markupShapeKeys;let markupSelected;let markupToolShape;let markupToolStylesComputed;let markupShapeSelected;let toolEraseRadius;let shouldRenderPresets;let shouldStickToImage;let ping;let computedScrollElasticity;let runWillRenderPresetToolbarHook;let layoutEditorHooks;let footerStyle;let $parentRect,$$unsubscribe_parentRect=pintura_noop,$$subscribe_parentRect=()=>($$unsubscribe_parentRect(),$$unsubscribe_parentRect=subscribe(parentRect,$$value=>$$invalidate(23,$parentRect=$$value)),parentRect);let $rootRect;let $isActive,$$unsubscribe_isActive=pintura_noop,$$subscribe_isActive=()=>($$unsubscribe_isActive(),$$unsubscribe_isActive=subscribe(isActive,$$value=>$$invalidate(24,$isActive=$$value)),isActive);let $imagePreviewModifiers;let $isVisible,$$unsubscribe_isVisible=pintura_noop,$$subscribe_isVisible=()=>($$unsubscribe_isVisible(),$$unsubscribe_isVisible=subscribe(isVisible,$$value=>$$invalidate(78,$isVisible=$$value)),isVisible);let $utilRect;let $stageRect;let $shapes,$$unsubscribe_shapes=pintura_noop,$$subscribe_shapes=()=>($$unsubscribe_shapes(),$$unsubscribe_shapes=subscribe(shapes,$$value=>$$invalidate(26,$shapes=$$value)),shapes);let $shapePreprocessor;let $isActiveFraction,$$unsubscribe_isActiveFraction=pintura_noop,$$subscribe_isActiveFraction=()=>($$unsubscribe_isActiveFraction(),$$unsubscribe_isActiveFraction=subscribe(isActiveFraction,$$value=>$$invalidate(28,$isActiveFraction=$$value)),isActiveFraction);let $imageCropRect;let $env;let $animation;let $footerOffset;let $imageOverlayMarkup;let $presentationScalar;$$self.$$.on_destroy.push(()=>$$unsubscribe_parentRect());$$self.$$.on_destroy.push(()=>$$unsubscribe_isActive());$$self.$$.on_destroy.push(()=>$$unsubscribe_isVisible());$$self.$$.on_destroy.push(()=>$$unsubscribe_shapes());$$self.$$.on_destroy.push(()=>$$unsubscribe_isActiveFraction());let{isActive}=$$props;$$subscribe_isActive();let{isActiveFraction}=$$props;$$subscribe_isActiveFraction();let{isVisible}=$$props;$$subscribe_isVisible();let{stores}=$$props;let{locale={}}=$$props;let{shapes}=$$props;$$subscribe_shapes();let{tools=[]}=$$props;let{toolShapes=[]}=$$props;let{toolActive=undefined}=$$props;let{toolSelectRadius=undefined}=$$props;let{shapeControls={}}=$$props;let{enableButtonFlipVertical=false}=$$props;let{enablePresetSelectImage=true}=$$props;let{enablePresetDropImage=true}=$$props;let{enableSelectToolToAddShape=false}=$$props;let{enableTapToAddText=false}=$$props;let{willRenderPresetToolbar=undefined}=$$props;let{shapePresets=[]}=$$props;let{utilKey}=$$props;let{mapScreenPointToImagePoint}=$$props;let{mapImagePointToScreenPoint}=$$props;let{imageRotation=0}=$$props;let{imageFlipX=false}=$$props;let{imageFlipY=false}=$$props;let{parentRect}=$$props;$$subscribe_parentRect();let{hooks={}}=$$props;const{env,animation,history,rootRect,stageRect,utilRect,elasticityMultiplier,scrollElasticity,imageOverlayMarkup,imagePreviewModifiers,imageCropRect,presentationScalar,shapePreprocessor,// for panning / scaling the image
imagePresentationScale,imagePresentationPan}=stores;component_subscribe($$self,env,value=>$$invalidate(84,$env=value));component_subscribe($$self,animation,value=>$$invalidate(85,$animation=value));component_subscribe($$self,rootRect,value=>$$invalidate(31,$rootRect=value));component_subscribe($$self,stageRect,value=>$$invalidate(79,$stageRect=value));component_subscribe($$self,utilRect,value=>$$invalidate(25,$utilRect=value));component_subscribe($$self,imageOverlayMarkup,value=>$$invalidate(41,$imageOverlayMarkup=value));component_subscribe($$self,imagePreviewModifiers,value=>$$invalidate(76,$imagePreviewModifiers=value));component_subscribe($$self,imageCropRect,value=>$$invalidate(101,$imageCropRect=value));component_subscribe($$self,presentationScalar,value=>$$invalidate(42,$presentationScalar=value));component_subscribe($$self,shapePreprocessor,value=>$$invalidate(83,$shapePreprocessor=value));const updateActiveTool=({value},event)=>{$$invalidate(0,toolActive=value);// if is keyboard navigating or should add shape
if(enableSelectToolToAddShape||isConfirmKey(event.key)){AddToolDefaultShape(value);}};const AddToolDefaultShape=tool=>{const[shape,options]=toolShapes[tool];let isRelative=options.position==="relative";let shapeToAdd;const size=isRelative?"20%":$parentRect.width*0.2;const x=isRelative?"0%":0;const y=isRelative?"0%":0;if(shapeIsRect(shape)||shapeIsText(shape)){shapeToAdd=shapeDeepCopy(shape);shapeToAdd.x=x;shapeToAdd.y=y;shapeUpdateProps(shapeToAdd,{width:size,height:size},$parentRect);}else if(shapeIsEllipse(shape)){shapeToAdd=shapeDeepCopy(shape);shapeToAdd.x=x;shapeToAdd.y=y;shapeUpdateProps(shapeToAdd,{rx:size,ry:size},$parentRect);}else if(shapeIsLine(shape)){shapeToAdd=shapeDeepCopy(shape);shapeToAdd.x1=x;shapeToAdd.y1=y;shapeToAdd.x2=x;shapeToAdd.y2=y;}if(!shapeToAdd)return;Promise.resolve().then(()=>{addShape(createShapeAtPosition(shapeToAdd,undefined,size));});};const mapScreenEventToImagePoint=e=>mapScreenPointToImagePoint(getEventPositionInEditor(e,$rootRect));// A reference to the markup editor, we need this so we can call exported functions
let markupEditor;// the current tool styles
let markupToolStyles={};//
// Create new shape
//
let interactionHandler;const handleInteractionStart=e=>{if(toolActive==="eraser"){interactionHandler=markupEditor.eraseShape();}else if(toolActive&&toolShapes[toolActive]){const[shape,options]=toolShapes[toolActive];interactionHandler=markupEditor.createShape({...shape,...markupToolStylesComputed},options);}else{interactionHandler=undefined;}if(!interactionHandler)return false;interactionHandler.start(e);return true;};const handleInteractionUpdate=e=>{if(!interactionHandler)return false;interactionHandler.update(e);return true;};const handleInteractionRelease=e=>{if(!interactionHandler)return false;interactionHandler.release(e);return true;};const handleInteractionEnd=e=>{if(!interactionHandler)return false;interactionHandler.end(e);interactionHandler=undefined;return true;};const blurOnToolSwitch=()=>{if(!markupEditor)return;markupEditor.blurShapes();};function handleUpdateSelectedMarkupShape(props){// remember style for when creating or styling other element
Object.keys(props).forEach(key=>$$invalidate(72,markupToolStyles[key]=props[key],markupToolStyles));// it's possible we're only updating default styles
if(!markupSelected)return;// update element
markupEditor.updateMarkupShape(markupSelected,props);// update markup style
handleMarkupUpdate();}const createShapeAtPosition=(shape,position,size)=>{// position defaults to crop center
let positionIsCenter=false;if(!position){// is centering to stage
positionIsCenter=true;// calculate image or rect position
position=shouldStickToImage?mapScreenPointToImagePoint(rectCenter($stageRect)):rectCenter($imageCropRect);}// adjust offset if parent rect is image crop rect
position.x-=$parentRect.x||0;position.y-=$parentRect.y||0;// de-flip shape
if(imageFlipX||imageFlipY){shape.flipX=imageFlipX;shape.flipY=imageFlipY;}// reposition if there's already shapes at position and shape isn't full screen
const shapesAlreadyAtPosition=markupEditor.getShapesNearPosition(position);if(positionIsCenter&&shapesAlreadyAtPosition.length){const dist=Math.min($imageCropRect.width,$imageCropRect.height)*0.1;position.x+=Math.round(-dist+Math.random()*dist*2);position.y+=Math.round(-dist+Math.random()*dist*2);}// de-rotate shape
if(imageRotation!==0){if(imageFlipX&&imageFlipY)shape.rotation=-imageRotation;else if(imageFlipX)shape.rotation=imageRotation;else if(imageFlipY)shape.rotation=imageRotation;else shape.rotation=-imageRotation;}if(hasProp(shape,"width")&&hasProp(shape,"height")){const{width,height}=shapeGetPropsPixelValues(shape,["width","height"],$parentRect);shapeUpdateProps(shape,{x:position.x-width*0.5,y:position.y-height*0.5},$parentRect);}else if(shapeIsEllipse(shape)){shapeUpdateProps(shape,{x:position.x,y:position.y},$parentRect);}else if(shapeIsLine(shape)){const{x1,y1,x2,y2}=shapeGetPropsPixelValues(shape,["x1","y1","x2","y2"],$parentRect);const dist=vectorDistance(vectorCreate(x1,y1),vectorCreate(x2,y2));const l=dist||pintura_isString(size)?toPixelValue(size,$parentRect.width):size;shapeUpdateProps(shape,{x1:position.x-l,y1:position.y+l,x2:position.x+l,y2:position.y-l},$parentRect);}return shape;};const addPreset=(preset,position)=>{const shape=createShapeAtPosition(shapeCreateFromPreset(preset,$imageCropRect),position);return addShape(shape);};const addShape=shape=>{const{beforeAddShape=()=>true}=hooks;if(!beforeAddShape(shape))return;markupEditor.addShape(shape);markupEditor.selectShape(shape);history.write();return shape;};let dragCancelled=false;const handleGrabPreset=()=>{dragCancelled=false;};const handleDragPreset=(preset,e)=>{if(dragCancelled)return;const{beforeAddShape=()=>true}=hooks;const position=mapScreenEventToImagePoint(e);// create or update if is inside image
const draft=markupEditor.getMarkupItemDraft();const inCropRect=rectContainsPoint($imageCropRect,{// adjust offset if parent rect is image crop rect
x:position.x+($parentRect.x||0),y:position.y+($parentRect.y||0)});// remove draft if not dragging inside image
if(draft&&!inCropRect)markupEditor.discardMarkupItemDraft();// stop here if we're not in the crop rect
if(!inCropRect)return;// create draft shape
if(!draft){const shape=createShapeAtPosition(shapeCreateFromPreset(preset,$imageCropRect),position);if(!beforeAddShape(shape)){dragCancelled=true;e.preventDefault();return;}shapeMakeDraft(shape);markupEditor.addShape(shape);return;}// center shape on pointer if it has dimensions
if(shapeIsRect(draft)){position.x-=draft.width*0.5;position.y-=draft.height*0.5;}// update the draft shape
markupEditor.updateMarkupShape(draft,position);};const handleDropPreset=(_,e)=>{if(dragCancelled)return;const position=mapScreenEventToImagePoint(e);if(!rectContainsPoint($imageCropRect,{x:position.x+($parentRect.x||0),y:position.y+($parentRect.y||0)})){markupEditor.discardMarkupItemDraft();return;}// confirm shape
const shape=markupEditor.confirmMarkupItemDraft();markupEditor.selectShape(shape);// update history
history.write();};const handleAddPreset=preset=>addPreset(preset);const handleAddFiles=(files,position)=>files.forEach(file=>addPreset(file,position));const handleDropFiles=e=>handleAddFiles(e.detail.resources,mapScreenEventToImagePoint(e.detail.event));//
// Zoom
//
// const handleWheel = (e) => {
//     // don't run default actions, prevent other actions from running
//     e.preventDefault();
//     e.stopPropagation();
//     // convert wheel delta to scalar
//     const delta = getWheelDelta(e);
//     const scalar = 1 + (delta / 100);
//     // update image zoom
//     imagePresentationScale.update(v => v * scalar)
// }
// on:wheel|nonpassive={handleWheel}
//
// History
//
const handleMarkupUpdate=()=>history.write();// used to fire ping events from
let pingHub;//
// Footer style
//
const footerOffset=spring($animation?20:0);component_subscribe($$self,footerOffset,value=>$$invalidate(86,$footerOffset=value));function measure_handler_1(event){bubble($$self,event);}const func=option=>option[0]===toolActive;const func_1=shape=>{ping("addshape",shape);handleMarkupUpdate();};const func_2=shape=>{ping("selectshape",shape);};const func_3=shape=>{ping("updateshape",shape);handleMarkupUpdate();};const func_4=shape=>{ping("removeshape",shape);handleMarkupUpdate();};function shapelayouteditor_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{markupEditor=$$value;$$invalidate(29,markupEditor);});}function shapelayouteditor_markup_binding(value){$shapes=value;shapes.set($shapes);}function shapelayouteditor_ui_binding(value){$imageOverlayMarkup=value;imageOverlayMarkup.set($imageOverlayMarkup);}function div_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{pingHub=$$value;$$invalidate(20,pingHub);});}function measure_handler(event){bubble($$self,event);}$$self.$$set=$$props=>{if("isActive"in $$props)$$subscribe_isActive($$invalidate(1,isActive=$$props.isActive));if("isActiveFraction"in $$props)$$subscribe_isActiveFraction($$invalidate(2,isActiveFraction=$$props.isActiveFraction));if("isVisible"in $$props)$$subscribe_isVisible($$invalidate(3,isVisible=$$props.isVisible));if("stores"in $$props)$$invalidate(66,stores=$$props.stores);if("locale"in $$props)$$invalidate(4,locale=$$props.locale);if("shapes"in $$props)$$subscribe_shapes($$invalidate(5,shapes=$$props.shapes));if("tools"in $$props)$$invalidate(67,tools=$$props.tools);if("toolShapes"in $$props)$$invalidate(68,toolShapes=$$props.toolShapes);if("toolActive"in $$props)$$invalidate(0,toolActive=$$props.toolActive);if("toolSelectRadius"in $$props)$$invalidate(6,toolSelectRadius=$$props.toolSelectRadius);if("shapeControls"in $$props)$$invalidate(7,shapeControls=$$props.shapeControls);if("enableButtonFlipVertical"in $$props)$$invalidate(8,enableButtonFlipVertical=$$props.enableButtonFlipVertical);if("enablePresetSelectImage"in $$props)$$invalidate(9,enablePresetSelectImage=$$props.enablePresetSelectImage);if("enablePresetDropImage"in $$props)$$invalidate(10,enablePresetDropImage=$$props.enablePresetDropImage);if("enableSelectToolToAddShape"in $$props)$$invalidate(69,enableSelectToolToAddShape=$$props.enableSelectToolToAddShape);if("enableTapToAddText"in $$props)$$invalidate(11,enableTapToAddText=$$props.enableTapToAddText);if("willRenderPresetToolbar"in $$props)$$invalidate(70,willRenderPresetToolbar=$$props.willRenderPresetToolbar);if("shapePresets"in $$props)$$invalidate(12,shapePresets=$$props.shapePresets);if("utilKey"in $$props)$$invalidate(13,utilKey=$$props.utilKey);if("mapScreenPointToImagePoint"in $$props)$$invalidate(14,mapScreenPointToImagePoint=$$props.mapScreenPointToImagePoint);if("mapImagePointToScreenPoint"in $$props)$$invalidate(15,mapImagePointToScreenPoint=$$props.mapImagePointToScreenPoint);if("imageRotation"in $$props)$$invalidate(16,imageRotation=$$props.imageRotation);if("imageFlipX"in $$props)$$invalidate(17,imageFlipX=$$props.imageFlipX);if("imageFlipY"in $$props)$$invalidate(18,imageFlipY=$$props.imageFlipY);if("parentRect"in $$props)$$subscribe_parentRect($$invalidate(19,parentRect=$$props.parentRect));if("hooks"in $$props)$$invalidate(71,hooks=$$props.hooks);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*shapePresets*/4096|$$self.$$.dirty[2]&/*tools*/32){// remove presets tool if no shape presets defined
$$invalidate(21,toolsFiltered=shapePresets.length===0?tools.filter(tool=>tool[0]!=="preset"):tools);}if($$self.$$.dirty[0]&/*shapeControls*/128){$$invalidate(73,hasShapeControls=Object.keys(shapeControls).length);}if($$self.$$.dirty[0]&/*toolsFiltered*/2097152){$$invalidate(22,showToolbar=toolsFiltered.length>1);}if($$self.$$.dirty[0]&/*toolsFiltered*/2097152){$$invalidate(74,hasTools=!!toolsFiltered.length);}if($$self.$$.dirty[0]&/*showToolbar, toolActive, toolsFiltered*/6291457){// set to first tool in tools list if not defined
if(showToolbar&&toolActive===undefined)$$invalidate(0,toolActive=toolsFiltered[0][0]);}if($$self.$$.dirty[0]&/*toolActive*/1){$$invalidate(75,hasActiveTool=toolActive!==undefined);}if($$self.$$.dirty[2]&/*hasActiveTool, hasTools, hasShapeControls*/14336){$$invalidate(30,shouldRenderControls=(!hasActiveTool||hasTools)&&hasShapeControls);}if($$self.$$.dirty[0]&/*$isActive, utilKey*/16785408|$$self.$$.dirty[2]&/*$imagePreviewModifiers*/16384){//
// enable seeing the markup outlines outside of the crop area
//
if($isActive){set_store_value(imagePreviewModifiers,$imagePreviewModifiers[utilKey]={maskMarkupOpacity:0.85},$imagePreviewModifiers);}else{delete $imagePreviewModifiers[utilKey];}}if($$self.$$.dirty[0]&/*toolActive*/1){if(toolActive)blurOnToolSwitch();}if($$self.$$.dirty[2]&/*$isVisible*/65536){$$invalidate(32,shouldRenderShapeEditor=$isVisible);}if($$self.$$.dirty[0]&/*$utilRect*/33554432|$$self.$$.dirty[2]&/*$stageRect*/131072){$$invalidate(33,markupOffset=$utilRect&&vectorCreate($stageRect.x-$utilRect.x,$stageRect.y-$utilRect.y));}if($$self.$$.dirty[0]&/*shapeControls*/128){$$invalidate(80,markupShapeKeys=Object.keys(shapeControls));}if($$self.$$.dirty[0]&/*$shapes*/67108864){$$invalidate(81,markupSelected=$shapes.filter(shapeIsSelected)[0]);}if($$self.$$.dirty[0]&/*$isActive, toolActive*/16777217|$$self.$$.dirty[2]&/*toolShapes*/64){$$invalidate(82,markupToolShape=$isActive&&(toolShapes[toolActive]?shapeFormat(shapeDeepCopy(toolShapes[toolActive][0])):{}));}if($$self.$$.dirty[2]&/*markupToolShape, markupShapeKeys, markupToolStyles*/1311744){$$invalidate(77,markupToolStylesComputed=markupToolShape&&Object.keys(markupToolShape).reduce((prev,key)=>{const isDisableStyleProp=key==="disableStyle";const isStylableProp=markupShapeKeys.find(shapeKey=>shapeKey.split("_").includes(key));// skip props that can't be styled, but keep all `disable` props
if(!isDisableStyleProp&&!isStylableProp)return prev;// skip props that are set to undefined, this means they won't auto-inherit current styles (line won't inherit line ends)
if(markupToolShape[key]===undefined)return prev;// apply this style
prev[key]=markupToolStyles[key]||markupToolShape[key];return prev;},{}));}if($$self.$$.dirty[2]&/*markupSelected, markupToolStylesComputed*/557056){$$invalidate(27,markupShapeSelected=markupSelected||markupToolStylesComputed);}if($$self.$$.dirty[0]&/*markupShapeSelected*/134217728|$$self.$$.dirty[2]&/*$shapePreprocessor*/2097152){// TODO: remove temporary warning while everyone switches to 8.7.0+
if(markupShapeSelected&&markupShapeSelected.lineEnd&&!$shapePreprocessor){console.warn(`Set shapePreprocessor property to draw lineStart and lineEnd styles.\nhttps://pqina.nl/pintura/docs/v8/api/exports/#createshapepreprocessor`);}}if($$self.$$.dirty[2]&/*markupToolShape*/1048576){$$invalidate(34,toolEraseRadius=markupToolShape&&pintura_isNumber(markupToolShape.eraseRadius)?markupToolShape.eraseRadius:undefined);}if($$self.$$.dirty[0]&/*$isActiveFraction, toolActive, shapePresets, enablePresetSelectImage*/268440065){//
// presets
//
$$invalidate(35,shouldRenderPresets=$isActiveFraction>0&&toolActive==="preset"&&(shapePresets.length>0||enablePresetSelectImage));}if($$self.$$.dirty[0]&/*$parentRect*/8388608){// if parent rect is a `Size` we're sticking presets to the image context
shouldStickToImage=!hasProp($parentRect,"x")&&!hasProp($parentRect,"y");}if($$self.$$.dirty[0]&/*pingHub*/1048576){$$invalidate(36,ping=pingHub&&createPingDispatcher(pingHub));}if($$self.$$.dirty[2]&/*willRenderPresetToolbar, $env*/4194560){//
//
//
$$invalidate(38,runWillRenderPresetToolbarHook=willRenderPresetToolbar?toolbar=>willRenderPresetToolbar(toolbar,addPreset,{...$env}):passthrough);}if($$self.$$.dirty[2]&/*hooks*/512){//
// filter out beforeAdd hook
//
$$invalidate(39,layoutEditorHooks=Object.keys(hooks).reduce((prev,curr)=>{if(curr==="beforeAddShape")return prev;prev[curr]=hooks[curr];return prev;},{}));}if($$self.$$.dirty[0]&/*$isActive*/16777216|$$self.$$.dirty[2]&/*$animation*/8388608){$animation&&footerOffset.set($isActive?0:20);}if($$self.$$.dirty[2]&/*$footerOffset*/16777216){$$invalidate(40,footerStyle=$footerOffset?`transform: translateY(${$footerOffset}px)`:undefined);}};$$invalidate(37,computedScrollElasticity=elasticityMultiplier*scrollElasticity);return[toolActive,isActive,isActiveFraction,isVisible,locale,shapes,toolSelectRadius,shapeControls,enableButtonFlipVertical,enablePresetSelectImage,enablePresetDropImage,enableTapToAddText,shapePresets,utilKey,mapScreenPointToImagePoint,mapImagePointToScreenPoint,imageRotation,imageFlipX,imageFlipY,parentRect,pingHub,toolsFiltered,showToolbar,$parentRect,$isActive,$utilRect,$shapes,markupShapeSelected,$isActiveFraction,markupEditor,shouldRenderControls,$rootRect,shouldRenderShapeEditor,markupOffset,toolEraseRadius,shouldRenderPresets,ping,computedScrollElasticity,runWillRenderPresetToolbarHook,layoutEditorHooks,footerStyle,$imageOverlayMarkup,$presentationScalar,env,animation,rootRect,stageRect,utilRect,imageOverlayMarkup,imagePreviewModifiers,imageCropRect,presentationScalar,shapePreprocessor,updateActiveTool,handleInteractionStart,handleInteractionUpdate,handleInteractionRelease,handleInteractionEnd,handleUpdateSelectedMarkupShape,handleGrabPreset,handleDragPreset,handleDropPreset,handleAddPreset,handleDropFiles,handleMarkupUpdate,footerOffset,stores,tools,toolShapes,enableSelectToolToAddShape,willRenderPresetToolbar,hooks,markupToolStyles,hasShapeControls,hasTools,hasActiveTool,$imagePreviewModifiers,markupToolStylesComputed,$isVisible,$stageRect,markupShapeKeys,markupSelected,markupToolShape,$shapePreprocessor,$env,$animation,$footerOffset,measure_handler_1,func,func_1,func_2,func_3,func_4,shapelayouteditor_binding,shapelayouteditor_markup_binding,shapelayouteditor_ui_binding,div_binding,measure_handler];}class ShapeUtil extends SvelteComponent{constructor(options){super();init(this,options,instance$9,create_fragment$9,safe_not_equal,{isActive:1,isActiveFraction:2,isVisible:3,stores:66,locale:4,shapes:5,tools:67,toolShapes:68,toolActive:0,toolSelectRadius:6,shapeControls:7,enableButtonFlipVertical:8,enablePresetSelectImage:9,enablePresetDropImage:10,enableSelectToolToAddShape:69,enableTapToAddText:11,willRenderPresetToolbar:70,shapePresets:12,utilKey:13,mapScreenPointToImagePoint:14,mapImagePointToScreenPoint:15,imageRotation:16,imageFlipX:17,imageFlipY:18,parentRect:19,hooks:71},[-1,-1,-1,-1]);}get isActive(){return this.$$.ctx[1];}set isActive(isActive){this.$set({isActive});flush();}get isActiveFraction(){return this.$$.ctx[2];}set isActiveFraction(isActiveFraction){this.$set({isActiveFraction});flush();}get isVisible(){return this.$$.ctx[3];}set isVisible(isVisible){this.$set({isVisible});flush();}get stores(){return this.$$.ctx[66];}set stores(stores){this.$set({stores});flush();}get locale(){return this.$$.ctx[4];}set locale(locale){this.$set({locale});flush();}get shapes(){return this.$$.ctx[5];}set shapes(shapes){this.$set({shapes});flush();}get tools(){return this.$$.ctx[67];}set tools(tools){this.$set({tools});flush();}get toolShapes(){return this.$$.ctx[68];}set toolShapes(toolShapes){this.$set({toolShapes});flush();}get toolActive(){return this.$$.ctx[0];}set toolActive(toolActive){this.$set({toolActive});flush();}get toolSelectRadius(){return this.$$.ctx[6];}set toolSelectRadius(toolSelectRadius){this.$set({toolSelectRadius});flush();}get shapeControls(){return this.$$.ctx[7];}set shapeControls(shapeControls){this.$set({shapeControls});flush();}get enableButtonFlipVertical(){return this.$$.ctx[8];}set enableButtonFlipVertical(enableButtonFlipVertical){this.$set({enableButtonFlipVertical});flush();}get enablePresetSelectImage(){return this.$$.ctx[9];}set enablePresetSelectImage(enablePresetSelectImage){this.$set({enablePresetSelectImage});flush();}get enablePresetDropImage(){return this.$$.ctx[10];}set enablePresetDropImage(enablePresetDropImage){this.$set({enablePresetDropImage});flush();}get enableSelectToolToAddShape(){return this.$$.ctx[69];}set enableSelectToolToAddShape(enableSelectToolToAddShape){this.$set({enableSelectToolToAddShape});flush();}get enableTapToAddText(){return this.$$.ctx[11];}set enableTapToAddText(enableTapToAddText){this.$set({enableTapToAddText});flush();}get willRenderPresetToolbar(){return this.$$.ctx[70];}set willRenderPresetToolbar(willRenderPresetToolbar){this.$set({willRenderPresetToolbar});flush();}get shapePresets(){return this.$$.ctx[12];}set shapePresets(shapePresets){this.$set({shapePresets});flush();}get utilKey(){return this.$$.ctx[13];}set utilKey(utilKey){this.$set({utilKey});flush();}get mapScreenPointToImagePoint(){return this.$$.ctx[14];}set mapScreenPointToImagePoint(mapScreenPointToImagePoint){this.$set({mapScreenPointToImagePoint});flush();}get mapImagePointToScreenPoint(){return this.$$.ctx[15];}set mapImagePointToScreenPoint(mapImagePointToScreenPoint){this.$set({mapImagePointToScreenPoint});flush();}get imageRotation(){return this.$$.ctx[16];}set imageRotation(imageRotation){this.$set({imageRotation});flush();}get imageFlipX(){return this.$$.ctx[17];}set imageFlipX(imageFlipX){this.$set({imageFlipX});flush();}get imageFlipY(){return this.$$.ctx[18];}set imageFlipY(imageFlipY){this.$set({imageFlipY});flush();}get parentRect(){return this.$$.ctx[19];}set parentRect(parentRect){this.$set({parentRect});flush();}get hooks(){return this.$$.ctx[71];}set hooks(hooks){this.$set({hooks});flush();}}var _mapImagePointToScreenPoint=(imagePoint,canvasSize,imageSize,imageOrigin,imageTranslation,imageRotation,imageScalar,imageFlipX,imageFlipY)=>{const mappedPoint=vectorClone(imagePoint);const imageCenterX=imageSize.width*0.5;const imageCenterY=imageSize.height*0.5;const canvasCenterX=canvasSize.width*0.5;const canvasCenterY=canvasSize.height*0.5;const imageOffsetX=imageTranslation.x+imageOrigin.x;const imageOffsetY=imageTranslation.y+imageOrigin.y;if(imageFlipX)mappedPoint.x=imageSize.width-mappedPoint.x;if(imageFlipY)mappedPoint.y=imageSize.height-mappedPoint.y;// rotate around image center based on if image is rotated
const c=Math.cos(imageRotation);const s=Math.sin(imageRotation);mappedPoint.x-=imageCenterX;mappedPoint.y-=imageCenterY;const rx=mappedPoint.x*c-mappedPoint.y*s;const ry=mappedPoint.x*s+mappedPoint.y*c;mappedPoint.x=imageCenterX+rx;mappedPoint.y=imageCenterY+ry;// position based on screen transforms
mappedPoint.x*=imageScalar;mappedPoint.y*=imageScalar;mappedPoint.x+=canvasCenterX;mappedPoint.y+=canvasCenterY;mappedPoint.x+=imageOffsetX;mappedPoint.y+=imageOffsetY;mappedPoint.x-=imageCenterX*imageScalar;mappedPoint.y-=imageCenterY*imageScalar;const tx=(imageTranslation.x-imageOffsetX)*imageScalar;const ty=(imageTranslation.y-imageOffsetY)*imageScalar;const rtx=tx*c-ty*s;const rty=tx*s+ty*c;mappedPoint.x+=rtx;mappedPoint.y+=rty;return mappedPoint;};var _mapScreenPointToImagePoint=(screenPoint,canvasSize,imageSize,imageOrigin,imageTranslation,imageRotation,imageScalar,imageFlipX,imageFlipY)=>{const mappedPoint=vectorClone(screenPoint);const imageCenter=sizeCenter(imageSize);const canvasCenter=sizeCenter(canvasSize);const imageOffset=vectorCreate(imageTranslation.x+imageOrigin.x,imageTranslation.y+imageOrigin.y);const c=Math.cos(imageRotation);const s=Math.sin(imageRotation);mappedPoint.x-=canvasCenter.x;mappedPoint.y-=canvasCenter.y;const tx=(imageTranslation.x-imageOffset.x)*imageScalar;const ty=(imageTranslation.y-imageOffset.y)*imageScalar;const rtx=tx*c-ty*s;const rty=tx*s+ty*c;mappedPoint.x-=rtx;mappedPoint.y-=rty;mappedPoint.x-=imageOffset.x;mappedPoint.y-=imageOffset.y;mappedPoint.x/=imageScalar;mappedPoint.y/=imageScalar;const rx=mappedPoint.x*c+mappedPoint.y*s;const ry=mappedPoint.x*s-mappedPoint.y*c;mappedPoint.x=rx;mappedPoint.y=-ry;mappedPoint.x+=imageCenter.x;mappedPoint.y+=imageCenter.y;if(imageFlipX)mappedPoint.x=imageSize.width-mappedPoint.x;if(imageFlipY)mappedPoint.y=imageSize.height-mappedPoint.y;return mappedPoint;};/* src/core/ui/plugins/annotate/index.svelte generated by Svelte v3.37.0 */function create_fragment$8(ctx){let shapeutil;let updating_toolActive;let current;function shapeutil_toolActive_binding(value){/*shapeutil_toolActive_binding*/ctx[39](value);}let shapeutil_props={stores:/*stores*/ctx[4],locale:/*locale*/ctx[5],isActive:/*isActive*/ctx[1],isActiveFraction:/*isActiveFraction*/ctx[2],isVisible:/*isVisible*/ctx[3],mapScreenPointToImagePoint:/*mapScreenPointToImagePoint*/ctx[36],mapImagePointToScreenPoint:/*mapImagePointToScreenPoint*/ctx[37],utilKey:"annotate",imageRotation:/*$imageRotation*/ctx[28],imageFlipX:/*$imageFlipX*/ctx[26],imageFlipY:/*$imageFlipY*/ctx[27],shapes:/*imageAnnotation*/ctx[30],tools:/*annotateTools*/ctx[11]||/*markupEditorToolbar*/ctx[6],toolShapes:/*annotateToolShapes*/ctx[12]||/*markupEditorToolStyles*/ctx[7],enableSelectToolToAddShape:/*enableSelectToolToAddShape*/ctx[18],enableTapToAddText:/*enableTapToAddText*/ctx[19],shapeControls:/*annotateShapeControls*/ctx[13]||/*markupEditorShapeStyleControls*/ctx[8],shapePresets:/*annotatePresets*/ctx[16],enableButtonFlipVertical:/*annotateEnableButtonFlipVertical*/ctx[14],parentRect:/*imageSize*/ctx[31],enablePresetSelectImage:/*annotateEnableSelectImagePreset*/ctx[15],toolSelectRadius:/*markupEditorToolSelectRadius*/ctx[9],willRenderPresetToolbar:/*annotateWillRenderShapePresetToolbar*/ctx[17]||/*willRenderShapePresetToolbar*/ctx[10],hooks:{willRenderShapeControls:/*willRenderShapeControls*/ctx[20],beforeAddShape:/*beforeAddShape*/ctx[21],beforeRemoveShape:/*beforeRemoveShape*/ctx[22],beforeDeselectShape:/*beforeDeselectShape*/ctx[23],beforeSelectShape:/*beforeSelectShape*/ctx[24],beforeUpdateShape:/*beforeUpdateShape*/ctx[25]}};if(/*annotateActiveTool*/ctx[0]!==void 0){shapeutil_props.toolActive=/*annotateActiveTool*/ctx[0];}shapeutil=new ShapeUtil({props:shapeutil_props});binding_callbacks.push(()=>bind(shapeutil,"toolActive",shapeutil_toolActive_binding));shapeutil.$on("measure",/*measure_handler*/ctx[40]);return{c(){create_component(shapeutil.$$.fragment);},m(target,anchor){mount_component(shapeutil,target,anchor);current=true;},p(ctx,dirty){const shapeutil_changes={};if(dirty[0]&/*stores*/16)shapeutil_changes.stores=/*stores*/ctx[4];if(dirty[0]&/*locale*/32)shapeutil_changes.locale=/*locale*/ctx[5];if(dirty[0]&/*isActive*/2)shapeutil_changes.isActive=/*isActive*/ctx[1];if(dirty[0]&/*isActiveFraction*/4)shapeutil_changes.isActiveFraction=/*isActiveFraction*/ctx[2];if(dirty[0]&/*isVisible*/8)shapeutil_changes.isVisible=/*isVisible*/ctx[3];if(dirty[0]&/*$imageRotation*/268435456)shapeutil_changes.imageRotation=/*$imageRotation*/ctx[28];if(dirty[0]&/*$imageFlipX*/67108864)shapeutil_changes.imageFlipX=/*$imageFlipX*/ctx[26];if(dirty[0]&/*$imageFlipY*/134217728)shapeutil_changes.imageFlipY=/*$imageFlipY*/ctx[27];if(dirty[0]&/*annotateTools, markupEditorToolbar*/2112)shapeutil_changes.tools=/*annotateTools*/ctx[11]||/*markupEditorToolbar*/ctx[6];if(dirty[0]&/*annotateToolShapes, markupEditorToolStyles*/4224)shapeutil_changes.toolShapes=/*annotateToolShapes*/ctx[12]||/*markupEditorToolStyles*/ctx[7];if(dirty[0]&/*enableSelectToolToAddShape*/262144)shapeutil_changes.enableSelectToolToAddShape=/*enableSelectToolToAddShape*/ctx[18];if(dirty[0]&/*enableTapToAddText*/524288)shapeutil_changes.enableTapToAddText=/*enableTapToAddText*/ctx[19];if(dirty[0]&/*annotateShapeControls, markupEditorShapeStyleControls*/8448)shapeutil_changes.shapeControls=/*annotateShapeControls*/ctx[13]||/*markupEditorShapeStyleControls*/ctx[8];if(dirty[0]&/*annotatePresets*/65536)shapeutil_changes.shapePresets=/*annotatePresets*/ctx[16];if(dirty[0]&/*annotateEnableButtonFlipVertical*/16384)shapeutil_changes.enableButtonFlipVertical=/*annotateEnableButtonFlipVertical*/ctx[14];if(dirty[0]&/*annotateEnableSelectImagePreset*/32768)shapeutil_changes.enablePresetSelectImage=/*annotateEnableSelectImagePreset*/ctx[15];if(dirty[0]&/*markupEditorToolSelectRadius*/512)shapeutil_changes.toolSelectRadius=/*markupEditorToolSelectRadius*/ctx[9];if(dirty[0]&/*annotateWillRenderShapePresetToolbar, willRenderShapePresetToolbar*/132096)shapeutil_changes.willRenderPresetToolbar=/*annotateWillRenderShapePresetToolbar*/ctx[17]||/*willRenderShapePresetToolbar*/ctx[10];if(dirty[0]&/*willRenderShapeControls, beforeAddShape, beforeRemoveShape, beforeDeselectShape, beforeSelectShape, beforeUpdateShape*/66060288)shapeutil_changes.hooks={willRenderShapeControls:/*willRenderShapeControls*/ctx[20],beforeAddShape:/*beforeAddShape*/ctx[21],beforeRemoveShape:/*beforeRemoveShape*/ctx[22],beforeDeselectShape:/*beforeDeselectShape*/ctx[23],beforeSelectShape:/*beforeSelectShape*/ctx[24],beforeUpdateShape:/*beforeUpdateShape*/ctx[25]};if(!updating_toolActive&&dirty[0]&/*annotateActiveTool*/1){updating_toolActive=true;shapeutil_changes.toolActive=/*annotateActiveTool*/ctx[0];add_flush_callback(()=>updating_toolActive=false);}shapeutil.$set(shapeutil_changes);},i(local){if(current)return;transition_in(shapeutil.$$.fragment,local);current=true;},o(local){transition_out(shapeutil.$$.fragment,local);current=false;},d(detaching){destroy_component(shapeutil,detaching);}};}function instance$8($$self,$$props,$$invalidate){let $rootRect;let $imageSize;let $imageTransforms;let $imageFlipX;let $imageFlipY;let $imageRotation;const name="annotate";let{isActive}=$$props;let{isActiveFraction}=$$props;let{isVisible}=$$props;let{stores}=$$props;let{locale={}}=$$props;let{markupEditorToolbar=undefined}=$$props;let{markupEditorToolStyles=undefined}=$$props;let{markupEditorShapeStyleControls=undefined}=$$props;let{markupEditorToolSelectRadius=undefined}=$$props;let{willRenderShapePresetToolbar=undefined}=$$props;let{annotateTools=undefined}=$$props;let{annotateToolShapes=undefined}=$$props;let{annotateShapeControls=undefined}=$$props;let{annotateActiveTool=undefined}=$$props;let{annotateEnableButtonFlipVertical=false}=$$props;let{annotateEnableSelectImagePreset=false}=$$props;let{annotatePresets=[]}=$$props;let{annotateWillRenderShapePresetToolbar=undefined}=$$props;let{enableSelectToolToAddShape=undefined}=$$props;let{enableTapToAddText=undefined}=$$props;let{willRenderShapeControls=undefined}=$$props;let{beforeAddShape=undefined}=$$props;let{beforeRemoveShape=undefined}=$$props;let{beforeDeselectShape=undefined}=$$props;let{beforeSelectShape=undefined}=$$props;let{beforeUpdateShape=undefined}=$$props;// connect filter choice to stores
const{rootRect,imageAnnotation,imageSize,imageTransforms,imageRotation,imageFlipX,imageFlipY}=stores;component_subscribe($$self,rootRect,value=>$$invalidate(41,$rootRect=value));component_subscribe($$self,imageSize,value=>$$invalidate(42,$imageSize=value));component_subscribe($$self,imageTransforms,value=>$$invalidate(43,$imageTransforms=value));component_subscribe($$self,imageRotation,value=>$$invalidate(28,$imageRotation=value));component_subscribe($$self,imageFlipX,value=>$$invalidate(26,$imageFlipX=value));component_subscribe($$self,imageFlipY,value=>$$invalidate(27,$imageFlipY=value));//
// Mapping coordinates
//
const mapScreenPointToImagePoint=point=>_mapScreenPointToImagePoint(point,$rootRect,$imageSize,$imageTransforms.origin,$imageTransforms.translation,$imageTransforms.rotation.z,$imageTransforms.scale,$imageFlipX,$imageFlipY);const mapImagePointToScreenPoint=point=>_mapImagePointToScreenPoint(point,$rootRect,$imageSize,$imageTransforms.origin,$imageTransforms.translation,$imageTransforms.rotation.z,$imageTransforms.scale,$imageFlipX,$imageFlipY);function shapeutil_toolActive_binding(value){annotateActiveTool=value;$$invalidate(0,annotateActiveTool);}function measure_handler(event){bubble($$self,event);}$$self.$$set=$$props=>{if("isActive"in $$props)$$invalidate(1,isActive=$$props.isActive);if("isActiveFraction"in $$props)$$invalidate(2,isActiveFraction=$$props.isActiveFraction);if("isVisible"in $$props)$$invalidate(3,isVisible=$$props.isVisible);if("stores"in $$props)$$invalidate(4,stores=$$props.stores);if("locale"in $$props)$$invalidate(5,locale=$$props.locale);if("markupEditorToolbar"in $$props)$$invalidate(6,markupEditorToolbar=$$props.markupEditorToolbar);if("markupEditorToolStyles"in $$props)$$invalidate(7,markupEditorToolStyles=$$props.markupEditorToolStyles);if("markupEditorShapeStyleControls"in $$props)$$invalidate(8,markupEditorShapeStyleControls=$$props.markupEditorShapeStyleControls);if("markupEditorToolSelectRadius"in $$props)$$invalidate(9,markupEditorToolSelectRadius=$$props.markupEditorToolSelectRadius);if("willRenderShapePresetToolbar"in $$props)$$invalidate(10,willRenderShapePresetToolbar=$$props.willRenderShapePresetToolbar);if("annotateTools"in $$props)$$invalidate(11,annotateTools=$$props.annotateTools);if("annotateToolShapes"in $$props)$$invalidate(12,annotateToolShapes=$$props.annotateToolShapes);if("annotateShapeControls"in $$props)$$invalidate(13,annotateShapeControls=$$props.annotateShapeControls);if("annotateActiveTool"in $$props)$$invalidate(0,annotateActiveTool=$$props.annotateActiveTool);if("annotateEnableButtonFlipVertical"in $$props)$$invalidate(14,annotateEnableButtonFlipVertical=$$props.annotateEnableButtonFlipVertical);if("annotateEnableSelectImagePreset"in $$props)$$invalidate(15,annotateEnableSelectImagePreset=$$props.annotateEnableSelectImagePreset);if("annotatePresets"in $$props)$$invalidate(16,annotatePresets=$$props.annotatePresets);if("annotateWillRenderShapePresetToolbar"in $$props)$$invalidate(17,annotateWillRenderShapePresetToolbar=$$props.annotateWillRenderShapePresetToolbar);if("enableSelectToolToAddShape"in $$props)$$invalidate(18,enableSelectToolToAddShape=$$props.enableSelectToolToAddShape);if("enableTapToAddText"in $$props)$$invalidate(19,enableTapToAddText=$$props.enableTapToAddText);if("willRenderShapeControls"in $$props)$$invalidate(20,willRenderShapeControls=$$props.willRenderShapeControls);if("beforeAddShape"in $$props)$$invalidate(21,beforeAddShape=$$props.beforeAddShape);if("beforeRemoveShape"in $$props)$$invalidate(22,beforeRemoveShape=$$props.beforeRemoveShape);if("beforeDeselectShape"in $$props)$$invalidate(23,beforeDeselectShape=$$props.beforeDeselectShape);if("beforeSelectShape"in $$props)$$invalidate(24,beforeSelectShape=$$props.beforeSelectShape);if("beforeUpdateShape"in $$props)$$invalidate(25,beforeUpdateShape=$$props.beforeUpdateShape);};return[annotateActiveTool,isActive,isActiveFraction,isVisible,stores,locale,markupEditorToolbar,markupEditorToolStyles,markupEditorShapeStyleControls,markupEditorToolSelectRadius,willRenderShapePresetToolbar,annotateTools,annotateToolShapes,annotateShapeControls,annotateEnableButtonFlipVertical,annotateEnableSelectImagePreset,annotatePresets,annotateWillRenderShapePresetToolbar,enableSelectToolToAddShape,enableTapToAddText,willRenderShapeControls,beforeAddShape,beforeRemoveShape,beforeDeselectShape,beforeSelectShape,beforeUpdateShape,$imageFlipX,$imageFlipY,$imageRotation,rootRect,imageAnnotation,imageSize,imageTransforms,imageRotation,imageFlipX,imageFlipY,mapScreenPointToImagePoint,mapImagePointToScreenPoint,name,shapeutil_toolActive_binding,measure_handler];}class Annotate extends SvelteComponent{constructor(options){super();init(this,options,instance$8,create_fragment$8,safe_not_equal,{name:38,isActive:1,isActiveFraction:2,isVisible:3,stores:4,locale:5,markupEditorToolbar:6,markupEditorToolStyles:7,markupEditorShapeStyleControls:8,markupEditorToolSelectRadius:9,willRenderShapePresetToolbar:10,annotateTools:11,annotateToolShapes:12,annotateShapeControls:13,annotateActiveTool:0,annotateEnableButtonFlipVertical:14,annotateEnableSelectImagePreset:15,annotatePresets:16,annotateWillRenderShapePresetToolbar:17,enableSelectToolToAddShape:18,enableTapToAddText:19,willRenderShapeControls:20,beforeAddShape:21,beforeRemoveShape:22,beforeDeselectShape:23,beforeSelectShape:24,beforeUpdateShape:25},[-1,-1]);}get name(){return this.$$.ctx[38];}get isActive(){return this.$$.ctx[1];}set isActive(isActive){this.$set({isActive});flush();}get isActiveFraction(){return this.$$.ctx[2];}set isActiveFraction(isActiveFraction){this.$set({isActiveFraction});flush();}get isVisible(){return this.$$.ctx[3];}set isVisible(isVisible){this.$set({isVisible});flush();}get stores(){return this.$$.ctx[4];}set stores(stores){this.$set({stores});flush();}get locale(){return this.$$.ctx[5];}set locale(locale){this.$set({locale});flush();}get markupEditorToolbar(){return this.$$.ctx[6];}set markupEditorToolbar(markupEditorToolbar){this.$set({markupEditorToolbar});flush();}get markupEditorToolStyles(){return this.$$.ctx[7];}set markupEditorToolStyles(markupEditorToolStyles){this.$set({markupEditorToolStyles});flush();}get markupEditorShapeStyleControls(){return this.$$.ctx[8];}set markupEditorShapeStyleControls(markupEditorShapeStyleControls){this.$set({markupEditorShapeStyleControls});flush();}get markupEditorToolSelectRadius(){return this.$$.ctx[9];}set markupEditorToolSelectRadius(markupEditorToolSelectRadius){this.$set({markupEditorToolSelectRadius});flush();}get willRenderShapePresetToolbar(){return this.$$.ctx[10];}set willRenderShapePresetToolbar(willRenderShapePresetToolbar){this.$set({willRenderShapePresetToolbar});flush();}get annotateTools(){return this.$$.ctx[11];}set annotateTools(annotateTools){this.$set({annotateTools});flush();}get annotateToolShapes(){return this.$$.ctx[12];}set annotateToolShapes(annotateToolShapes){this.$set({annotateToolShapes});flush();}get annotateShapeControls(){return this.$$.ctx[13];}set annotateShapeControls(annotateShapeControls){this.$set({annotateShapeControls});flush();}get annotateActiveTool(){return this.$$.ctx[0];}set annotateActiveTool(annotateActiveTool){this.$set({annotateActiveTool});flush();}get annotateEnableButtonFlipVertical(){return this.$$.ctx[14];}set annotateEnableButtonFlipVertical(annotateEnableButtonFlipVertical){this.$set({annotateEnableButtonFlipVertical});flush();}get annotateEnableSelectImagePreset(){return this.$$.ctx[15];}set annotateEnableSelectImagePreset(annotateEnableSelectImagePreset){this.$set({annotateEnableSelectImagePreset});flush();}get annotatePresets(){return this.$$.ctx[16];}set annotatePresets(annotatePresets){this.$set({annotatePresets});flush();}get annotateWillRenderShapePresetToolbar(){return this.$$.ctx[17];}set annotateWillRenderShapePresetToolbar(annotateWillRenderShapePresetToolbar){this.$set({annotateWillRenderShapePresetToolbar});flush();}get enableSelectToolToAddShape(){return this.$$.ctx[18];}set enableSelectToolToAddShape(enableSelectToolToAddShape){this.$set({enableSelectToolToAddShape});flush();}get enableTapToAddText(){return this.$$.ctx[19];}set enableTapToAddText(enableTapToAddText){this.$set({enableTapToAddText});flush();}get willRenderShapeControls(){return this.$$.ctx[20];}set willRenderShapeControls(willRenderShapeControls){this.$set({willRenderShapeControls});flush();}get beforeAddShape(){return this.$$.ctx[21];}set beforeAddShape(beforeAddShape){this.$set({beforeAddShape});flush();}get beforeRemoveShape(){return this.$$.ctx[22];}set beforeRemoveShape(beforeRemoveShape){this.$set({beforeRemoveShape});flush();}get beforeDeselectShape(){return this.$$.ctx[23];}set beforeDeselectShape(beforeDeselectShape){this.$set({beforeDeselectShape});flush();}get beforeSelectShape(){return this.$$.ctx[24];}set beforeSelectShape(beforeSelectShape){this.$set({beforeSelectShape});flush();}get beforeUpdateShape(){return this.$$.ctx[25];}set beforeUpdateShape(beforeUpdateShape){this.$set({beforeUpdateShape});flush();}}// @ts-ignore
var _plugin_annotate={util:['annotate',Annotate]};/* src/core/ui/plugins/decorate/index.svelte generated by Svelte v3.37.0 */function create_fragment$7(ctx){let shapeutil;let updating_toolActive;let current;function shapeutil_toolActive_binding(value){/*shapeutil_toolActive_binding*/ctx[33](value);}let shapeutil_props={stores:/*stores*/ctx[4],locale:/*locale*/ctx[5],isActive:/*isActive*/ctx[1],isActiveFraction:/*isActiveFraction*/ctx[2],isVisible:/*isVisible*/ctx[3],mapScreenPointToImagePoint:/*mapScreenPointToImagePoint*/ctx[30],mapImagePointToScreenPoint:/*mapImagePointToScreenPoint*/ctx[31],utilKey:"decorate",shapes:/*imageDecoration*/ctx[27],tools:/*decorateTools*/ctx[11]||/*markupEditorToolbar*/ctx[6],toolShapes:/*decorateToolShapes*/ctx[12]||/*markupEditorToolStyles*/ctx[7],shapeControls:/*decorateShapeControls*/ctx[13]||/*markupEditorShapeStyleControls*/ctx[8],shapePresets:/*decoratePresets*/ctx[16],enableSelectToolToAddShape:/*enableSelectToolToAddShape*/ctx[18],enableTapToAddText:/*enableTapToAddText*/ctx[19],enablePresetSelectImage:/*decorateEnableSelectImagePreset*/ctx[15],enableButtonFlipVertical:/*decorateEnableButtonFlipVertical*/ctx[14],parentRect:/*imageCropRect*/ctx[26],toolSelectRadius:/*markupEditorToolSelectRadius*/ctx[9],willRenderPresetToolbar:/*decorateWillRenderShapePresetToolbar*/ctx[17]||/*willRenderShapePresetToolbar*/ctx[10],hooks:{willRenderShapeControls:/*willRenderShapeControls*/ctx[20],beforeAddShape:/*beforeAddShape*/ctx[21],beforeRemoveShape:/*beforeRemoveShape*/ctx[22],beforeDeselectShape:/*beforeDeselectShape*/ctx[23],beforeSelectShape:/*beforeSelectShape*/ctx[24],beforeUpdateShape:/*beforeUpdateShape*/ctx[25]}};if(/*decorateActiveTool*/ctx[0]!==void 0){shapeutil_props.toolActive=/*decorateActiveTool*/ctx[0];}shapeutil=new ShapeUtil({props:shapeutil_props});binding_callbacks.push(()=>bind(shapeutil,"toolActive",shapeutil_toolActive_binding));shapeutil.$on("measure",/*measure_handler*/ctx[34]);return{c(){create_component(shapeutil.$$.fragment);},m(target,anchor){mount_component(shapeutil,target,anchor);current=true;},p(ctx,dirty){const shapeutil_changes={};if(dirty[0]&/*stores*/16)shapeutil_changes.stores=/*stores*/ctx[4];if(dirty[0]&/*locale*/32)shapeutil_changes.locale=/*locale*/ctx[5];if(dirty[0]&/*isActive*/2)shapeutil_changes.isActive=/*isActive*/ctx[1];if(dirty[0]&/*isActiveFraction*/4)shapeutil_changes.isActiveFraction=/*isActiveFraction*/ctx[2];if(dirty[0]&/*isVisible*/8)shapeutil_changes.isVisible=/*isVisible*/ctx[3];if(dirty[0]&/*decorateTools, markupEditorToolbar*/2112)shapeutil_changes.tools=/*decorateTools*/ctx[11]||/*markupEditorToolbar*/ctx[6];if(dirty[0]&/*decorateToolShapes, markupEditorToolStyles*/4224)shapeutil_changes.toolShapes=/*decorateToolShapes*/ctx[12]||/*markupEditorToolStyles*/ctx[7];if(dirty[0]&/*decorateShapeControls, markupEditorShapeStyleControls*/8448)shapeutil_changes.shapeControls=/*decorateShapeControls*/ctx[13]||/*markupEditorShapeStyleControls*/ctx[8];if(dirty[0]&/*decoratePresets*/65536)shapeutil_changes.shapePresets=/*decoratePresets*/ctx[16];if(dirty[0]&/*enableSelectToolToAddShape*/262144)shapeutil_changes.enableSelectToolToAddShape=/*enableSelectToolToAddShape*/ctx[18];if(dirty[0]&/*enableTapToAddText*/524288)shapeutil_changes.enableTapToAddText=/*enableTapToAddText*/ctx[19];if(dirty[0]&/*decorateEnableSelectImagePreset*/32768)shapeutil_changes.enablePresetSelectImage=/*decorateEnableSelectImagePreset*/ctx[15];if(dirty[0]&/*decorateEnableButtonFlipVertical*/16384)shapeutil_changes.enableButtonFlipVertical=/*decorateEnableButtonFlipVertical*/ctx[14];if(dirty[0]&/*markupEditorToolSelectRadius*/512)shapeutil_changes.toolSelectRadius=/*markupEditorToolSelectRadius*/ctx[9];if(dirty[0]&/*decorateWillRenderShapePresetToolbar, willRenderShapePresetToolbar*/132096)shapeutil_changes.willRenderPresetToolbar=/*decorateWillRenderShapePresetToolbar*/ctx[17]||/*willRenderShapePresetToolbar*/ctx[10];if(dirty[0]&/*willRenderShapeControls, beforeAddShape, beforeRemoveShape, beforeDeselectShape, beforeSelectShape, beforeUpdateShape*/66060288)shapeutil_changes.hooks={willRenderShapeControls:/*willRenderShapeControls*/ctx[20],beforeAddShape:/*beforeAddShape*/ctx[21],beforeRemoveShape:/*beforeRemoveShape*/ctx[22],beforeDeselectShape:/*beforeDeselectShape*/ctx[23],beforeSelectShape:/*beforeSelectShape*/ctx[24],beforeUpdateShape:/*beforeUpdateShape*/ctx[25]};if(!updating_toolActive&&dirty[0]&/*decorateActiveTool*/1){updating_toolActive=true;shapeutil_changes.toolActive=/*decorateActiveTool*/ctx[0];add_flush_callback(()=>updating_toolActive=false);}shapeutil.$set(shapeutil_changes);},i(local){if(current)return;transition_in(shapeutil.$$.fragment,local);current=true;},o(local){transition_out(shapeutil.$$.fragment,local);current=false;},d(detaching){destroy_component(shapeutil,detaching);}};}function instance$7($$self,$$props,$$invalidate){let $imageSelectionRectPresentation;let $presentationScalar;const name="decorate";let{isActive}=$$props;let{isActiveFraction}=$$props;let{isVisible}=$$props;let{stores}=$$props;let{locale={}}=$$props;let{markupEditorToolbar=undefined}=$$props;let{markupEditorToolStyles=undefined}=$$props;let{markupEditorShapeStyleControls=undefined}=$$props;let{markupEditorToolSelectRadius=undefined}=$$props;let{willRenderShapePresetToolbar=undefined}=$$props;let{decorateTools=undefined}=$$props;let{decorateToolShapes=undefined}=$$props;let{decorateShapeControls=undefined}=$$props;let{decorateActiveTool=undefined}=$$props;let{decorateEnableButtonFlipVertical=false}=$$props;let{decorateEnableSelectImagePreset=false}=$$props;let{decoratePresets=[]}=$$props;let{decorateWillRenderShapePresetToolbar=undefined}=$$props;let{enableSelectToolToAddShape=undefined}=$$props;let{enableTapToAddText=undefined}=$$props;let{willRenderShapeControls=undefined}=$$props;let{beforeAddShape=undefined}=$$props;let{beforeRemoveShape=undefined}=$$props;let{beforeDeselectShape=undefined}=$$props;let{beforeSelectShape=undefined}=$$props;let{beforeUpdateShape=undefined}=$$props;const{imageCropRect,imageDecoration,imageSelectionRectPresentation,presentationScalar}=stores;component_subscribe($$self,imageSelectionRectPresentation,value=>$$invalidate(35,$imageSelectionRectPresentation=value));component_subscribe($$self,presentationScalar,value=>$$invalidate(36,$presentationScalar=value));const mapScreenPointToImagePoint=screenPoint=>{const mappedPoint=vectorClone(screenPoint);mappedPoint.x-=$imageSelectionRectPresentation.x;mappedPoint.y-=$imageSelectionRectPresentation.y;mappedPoint.x/=$presentationScalar;mappedPoint.y/=$presentationScalar;return mappedPoint;};const mapImagePointToScreenPoint=imagePoint=>{const mappedPoint=vectorClone(imagePoint);mappedPoint.x*=$presentationScalar;mappedPoint.y*=$presentationScalar;mappedPoint.x+=$imageSelectionRectPresentation.x;mappedPoint.y+=$imageSelectionRectPresentation.y;return mappedPoint;};function shapeutil_toolActive_binding(value){decorateActiveTool=value;$$invalidate(0,decorateActiveTool);}function measure_handler(event){bubble($$self,event);}$$self.$$set=$$props=>{if("isActive"in $$props)$$invalidate(1,isActive=$$props.isActive);if("isActiveFraction"in $$props)$$invalidate(2,isActiveFraction=$$props.isActiveFraction);if("isVisible"in $$props)$$invalidate(3,isVisible=$$props.isVisible);if("stores"in $$props)$$invalidate(4,stores=$$props.stores);if("locale"in $$props)$$invalidate(5,locale=$$props.locale);if("markupEditorToolbar"in $$props)$$invalidate(6,markupEditorToolbar=$$props.markupEditorToolbar);if("markupEditorToolStyles"in $$props)$$invalidate(7,markupEditorToolStyles=$$props.markupEditorToolStyles);if("markupEditorShapeStyleControls"in $$props)$$invalidate(8,markupEditorShapeStyleControls=$$props.markupEditorShapeStyleControls);if("markupEditorToolSelectRadius"in $$props)$$invalidate(9,markupEditorToolSelectRadius=$$props.markupEditorToolSelectRadius);if("willRenderShapePresetToolbar"in $$props)$$invalidate(10,willRenderShapePresetToolbar=$$props.willRenderShapePresetToolbar);if("decorateTools"in $$props)$$invalidate(11,decorateTools=$$props.decorateTools);if("decorateToolShapes"in $$props)$$invalidate(12,decorateToolShapes=$$props.decorateToolShapes);if("decorateShapeControls"in $$props)$$invalidate(13,decorateShapeControls=$$props.decorateShapeControls);if("decorateActiveTool"in $$props)$$invalidate(0,decorateActiveTool=$$props.decorateActiveTool);if("decorateEnableButtonFlipVertical"in $$props)$$invalidate(14,decorateEnableButtonFlipVertical=$$props.decorateEnableButtonFlipVertical);if("decorateEnableSelectImagePreset"in $$props)$$invalidate(15,decorateEnableSelectImagePreset=$$props.decorateEnableSelectImagePreset);if("decoratePresets"in $$props)$$invalidate(16,decoratePresets=$$props.decoratePresets);if("decorateWillRenderShapePresetToolbar"in $$props)$$invalidate(17,decorateWillRenderShapePresetToolbar=$$props.decorateWillRenderShapePresetToolbar);if("enableSelectToolToAddShape"in $$props)$$invalidate(18,enableSelectToolToAddShape=$$props.enableSelectToolToAddShape);if("enableTapToAddText"in $$props)$$invalidate(19,enableTapToAddText=$$props.enableTapToAddText);if("willRenderShapeControls"in $$props)$$invalidate(20,willRenderShapeControls=$$props.willRenderShapeControls);if("beforeAddShape"in $$props)$$invalidate(21,beforeAddShape=$$props.beforeAddShape);if("beforeRemoveShape"in $$props)$$invalidate(22,beforeRemoveShape=$$props.beforeRemoveShape);if("beforeDeselectShape"in $$props)$$invalidate(23,beforeDeselectShape=$$props.beforeDeselectShape);if("beforeSelectShape"in $$props)$$invalidate(24,beforeSelectShape=$$props.beforeSelectShape);if("beforeUpdateShape"in $$props)$$invalidate(25,beforeUpdateShape=$$props.beforeUpdateShape);};return[decorateActiveTool,isActive,isActiveFraction,isVisible,stores,locale,markupEditorToolbar,markupEditorToolStyles,markupEditorShapeStyleControls,markupEditorToolSelectRadius,willRenderShapePresetToolbar,decorateTools,decorateToolShapes,decorateShapeControls,decorateEnableButtonFlipVertical,decorateEnableSelectImagePreset,decoratePresets,decorateWillRenderShapePresetToolbar,enableSelectToolToAddShape,enableTapToAddText,willRenderShapeControls,beforeAddShape,beforeRemoveShape,beforeDeselectShape,beforeSelectShape,beforeUpdateShape,imageCropRect,imageDecoration,imageSelectionRectPresentation,presentationScalar,mapScreenPointToImagePoint,mapImagePointToScreenPoint,name,shapeutil_toolActive_binding,measure_handler];}class Decorate extends SvelteComponent{constructor(options){super();init(this,options,instance$7,create_fragment$7,safe_not_equal,{name:32,isActive:1,isActiveFraction:2,isVisible:3,stores:4,locale:5,markupEditorToolbar:6,markupEditorToolStyles:7,markupEditorShapeStyleControls:8,markupEditorToolSelectRadius:9,willRenderShapePresetToolbar:10,decorateTools:11,decorateToolShapes:12,decorateShapeControls:13,decorateActiveTool:0,decorateEnableButtonFlipVertical:14,decorateEnableSelectImagePreset:15,decoratePresets:16,decorateWillRenderShapePresetToolbar:17,enableSelectToolToAddShape:18,enableTapToAddText:19,willRenderShapeControls:20,beforeAddShape:21,beforeRemoveShape:22,beforeDeselectShape:23,beforeSelectShape:24,beforeUpdateShape:25},[-1,-1]);}get name(){return this.$$.ctx[32];}get isActive(){return this.$$.ctx[1];}set isActive(isActive){this.$set({isActive});flush();}get isActiveFraction(){return this.$$.ctx[2];}set isActiveFraction(isActiveFraction){this.$set({isActiveFraction});flush();}get isVisible(){return this.$$.ctx[3];}set isVisible(isVisible){this.$set({isVisible});flush();}get stores(){return this.$$.ctx[4];}set stores(stores){this.$set({stores});flush();}get locale(){return this.$$.ctx[5];}set locale(locale){this.$set({locale});flush();}get markupEditorToolbar(){return this.$$.ctx[6];}set markupEditorToolbar(markupEditorToolbar){this.$set({markupEditorToolbar});flush();}get markupEditorToolStyles(){return this.$$.ctx[7];}set markupEditorToolStyles(markupEditorToolStyles){this.$set({markupEditorToolStyles});flush();}get markupEditorShapeStyleControls(){return this.$$.ctx[8];}set markupEditorShapeStyleControls(markupEditorShapeStyleControls){this.$set({markupEditorShapeStyleControls});flush();}get markupEditorToolSelectRadius(){return this.$$.ctx[9];}set markupEditorToolSelectRadius(markupEditorToolSelectRadius){this.$set({markupEditorToolSelectRadius});flush();}get willRenderShapePresetToolbar(){return this.$$.ctx[10];}set willRenderShapePresetToolbar(willRenderShapePresetToolbar){this.$set({willRenderShapePresetToolbar});flush();}get decorateTools(){return this.$$.ctx[11];}set decorateTools(decorateTools){this.$set({decorateTools});flush();}get decorateToolShapes(){return this.$$.ctx[12];}set decorateToolShapes(decorateToolShapes){this.$set({decorateToolShapes});flush();}get decorateShapeControls(){return this.$$.ctx[13];}set decorateShapeControls(decorateShapeControls){this.$set({decorateShapeControls});flush();}get decorateActiveTool(){return this.$$.ctx[0];}set decorateActiveTool(decorateActiveTool){this.$set({decorateActiveTool});flush();}get decorateEnableButtonFlipVertical(){return this.$$.ctx[14];}set decorateEnableButtonFlipVertical(decorateEnableButtonFlipVertical){this.$set({decorateEnableButtonFlipVertical});flush();}get decorateEnableSelectImagePreset(){return this.$$.ctx[15];}set decorateEnableSelectImagePreset(decorateEnableSelectImagePreset){this.$set({decorateEnableSelectImagePreset});flush();}get decoratePresets(){return this.$$.ctx[16];}set decoratePresets(decoratePresets){this.$set({decoratePresets});flush();}get decorateWillRenderShapePresetToolbar(){return this.$$.ctx[17];}set decorateWillRenderShapePresetToolbar(decorateWillRenderShapePresetToolbar){this.$set({decorateWillRenderShapePresetToolbar});flush();}get enableSelectToolToAddShape(){return this.$$.ctx[18];}set enableSelectToolToAddShape(enableSelectToolToAddShape){this.$set({enableSelectToolToAddShape});flush();}get enableTapToAddText(){return this.$$.ctx[19];}set enableTapToAddText(enableTapToAddText){this.$set({enableTapToAddText});flush();}get willRenderShapeControls(){return this.$$.ctx[20];}set willRenderShapeControls(willRenderShapeControls){this.$set({willRenderShapeControls});flush();}get beforeAddShape(){return this.$$.ctx[21];}set beforeAddShape(beforeAddShape){this.$set({beforeAddShape});flush();}get beforeRemoveShape(){return this.$$.ctx[22];}set beforeRemoveShape(beforeRemoveShape){this.$set({beforeRemoveShape});flush();}get beforeDeselectShape(){return this.$$.ctx[23];}set beforeDeselectShape(beforeDeselectShape){this.$set({beforeDeselectShape});flush();}get beforeSelectShape(){return this.$$.ctx[24];}set beforeSelectShape(beforeSelectShape){this.$set({beforeSelectShape});flush();}get beforeUpdateShape(){return this.$$.ctx[25];}set beforeUpdateShape(beforeUpdateShape){this.$set({beforeUpdateShape});flush();}}// @ts-ignore
var _plugin_decorate={util:['decorate',Decorate]};/* src/core/ui/plugins/sticker/index.svelte generated by Svelte v3.37.0 */function create_fragment$6(ctx){let shapeutil;let current;shapeutil=new ShapeUtil({props:{stores:/*stores*/ctx[3],locale:/*locale*/ctx[4],isActive:/*isActive*/ctx[0],isActiveFraction:/*isActiveFraction*/ctx[1],isVisible:/*isVisible*/ctx[2],mapScreenPointToImagePoint:/*mapScreenPointToImagePoint*/ctx[32],mapImagePointToScreenPoint:/*mapImagePointToScreenPoint*/ctx[33],utilKey:"sticker",shapePresets:/*stickers*/ctx[5],shapes:/*stickerStickToImage*/ctx[6]?/*imageAnnotation*/ctx[25]:/*imageDecoration*/ctx[26],toolActive:"preset",imageFlipX:/*stickerStickToImage*/ctx[6]?/*$imageFlipX*/ctx[18]:false,imageFlipY:/*stickerStickToImage*/ctx[6]?/*$imageFlipY*/ctx[19]:false,imageRotation:/*stickerStickToImage*/ctx[6]?/*$imageRotation*/ctx[20]:0,parentRect:/*stickerStickToImage*/ctx[6]?/*imageSize*/ctx[27]:/*imageCropRect*/ctx[23],enablePresetSelectImage:/*stickerEnableSelectImage*/ctx[7],enableButtonFlipVertical:/*stickersEnableButtonFlipVertical*/ctx[8],toolSelectRadius:/*markupEditorToolSelectRadius*/ctx[11],willRenderPresetToolbar:/*stickersWillRenderShapePresetToolbar*/ctx[9]||/*willRenderShapePresetToolbar*/ctx[12],hooks:{willRenderShapeControls:/*willRenderShapeControls*/ctx[10],beforeAddShape:/*beforeAddShape*/ctx[13],beforeRemoveShape:/*beforeRemoveShape*/ctx[14],beforeDeselectShape:/*beforeDeselectShape*/ctx[15],beforeSelectShape:/*beforeSelectShape*/ctx[16],beforeUpdateShape:/*beforeUpdateShape*/ctx[17]}}});shapeutil.$on("measure",/*measure_handler*/ctx[35]);return{c(){create_component(shapeutil.$$.fragment);},m(target,anchor){mount_component(shapeutil,target,anchor);current=true;},p(ctx,dirty){const shapeutil_changes={};if(dirty[0]&/*stores*/8)shapeutil_changes.stores=/*stores*/ctx[3];if(dirty[0]&/*locale*/16)shapeutil_changes.locale=/*locale*/ctx[4];if(dirty[0]&/*isActive*/1)shapeutil_changes.isActive=/*isActive*/ctx[0];if(dirty[0]&/*isActiveFraction*/2)shapeutil_changes.isActiveFraction=/*isActiveFraction*/ctx[1];if(dirty[0]&/*isVisible*/4)shapeutil_changes.isVisible=/*isVisible*/ctx[2];if(dirty[0]&/*stickers*/32)shapeutil_changes.shapePresets=/*stickers*/ctx[5];if(dirty[0]&/*stickerStickToImage*/64)shapeutil_changes.shapes=/*stickerStickToImage*/ctx[6]?/*imageAnnotation*/ctx[25]:/*imageDecoration*/ctx[26];if(dirty[0]&/*stickerStickToImage, $imageFlipX*/262208)shapeutil_changes.imageFlipX=/*stickerStickToImage*/ctx[6]?/*$imageFlipX*/ctx[18]:false;if(dirty[0]&/*stickerStickToImage, $imageFlipY*/524352)shapeutil_changes.imageFlipY=/*stickerStickToImage*/ctx[6]?/*$imageFlipY*/ctx[19]:false;if(dirty[0]&/*stickerStickToImage, $imageRotation*/1048640)shapeutil_changes.imageRotation=/*stickerStickToImage*/ctx[6]?/*$imageRotation*/ctx[20]:0;if(dirty[0]&/*stickerStickToImage*/64)shapeutil_changes.parentRect=/*stickerStickToImage*/ctx[6]?/*imageSize*/ctx[27]:/*imageCropRect*/ctx[23];if(dirty[0]&/*stickerEnableSelectImage*/128)shapeutil_changes.enablePresetSelectImage=/*stickerEnableSelectImage*/ctx[7];if(dirty[0]&/*stickersEnableButtonFlipVertical*/256)shapeutil_changes.enableButtonFlipVertical=/*stickersEnableButtonFlipVertical*/ctx[8];if(dirty[0]&/*markupEditorToolSelectRadius*/2048)shapeutil_changes.toolSelectRadius=/*markupEditorToolSelectRadius*/ctx[11];if(dirty[0]&/*stickersWillRenderShapePresetToolbar, willRenderShapePresetToolbar*/4608)shapeutil_changes.willRenderPresetToolbar=/*stickersWillRenderShapePresetToolbar*/ctx[9]||/*willRenderShapePresetToolbar*/ctx[12];if(dirty[0]&/*willRenderShapeControls, beforeAddShape, beforeRemoveShape, beforeDeselectShape, beforeSelectShape, beforeUpdateShape*/254976)shapeutil_changes.hooks={willRenderShapeControls:/*willRenderShapeControls*/ctx[10],beforeAddShape:/*beforeAddShape*/ctx[13],beforeRemoveShape:/*beforeRemoveShape*/ctx[14],beforeDeselectShape:/*beforeDeselectShape*/ctx[15],beforeSelectShape:/*beforeSelectShape*/ctx[16],beforeUpdateShape:/*beforeUpdateShape*/ctx[17]};shapeutil.$set(shapeutil_changes);},i(local){if(current)return;transition_in(shapeutil.$$.fragment,local);current=true;},o(local){transition_out(shapeutil.$$.fragment,local);current=false;},d(detaching){destroy_component(shapeutil,detaching);}};}function instance$6($$self,$$props,$$invalidate){let $rootRect;let $imageSize;let $imageTransforms;let $imageFlipX;let $imageFlipY;let $imageSelectionRectPresentation;let $presentationScalar;let $imageRotation;const name="sticker";let{isActive}=$$props;let{isActiveFraction}=$$props;let{isVisible}=$$props;let{stores}=$$props;let{locale={}}=$$props;let{stickers=[]}=$$props;let{stickerStickToImage=false}=$$props;let{stickerEnableSelectImage=true}=$$props;let{stickersEnableButtonFlipVertical=false}=$$props;let{stickersWillRenderShapePresetToolbar=undefined}=$$props;let{willRenderShapeControls=undefined}=$$props;let{markupEditorToolSelectRadius=undefined}=$$props;let{willRenderShapePresetToolbar=undefined}=$$props;let{beforeAddShape=undefined}=$$props;let{beforeRemoveShape=undefined}=$$props;let{beforeDeselectShape=undefined}=$$props;let{beforeSelectShape=undefined}=$$props;let{beforeUpdateShape=undefined}=$$props;// connect filter choice to stores
const{presentationScalar,rootRect,imageCropRect,imageSelectionRectPresentation,imageAnnotation,imageDecoration,imageSize,imageTransforms,imageRotation,imageFlipX,imageFlipY}=stores;component_subscribe($$self,presentationScalar,value=>$$invalidate(40,$presentationScalar=value));component_subscribe($$self,rootRect,value=>$$invalidate(36,$rootRect=value));component_subscribe($$self,imageSelectionRectPresentation,value=>$$invalidate(39,$imageSelectionRectPresentation=value));component_subscribe($$self,imageSize,value=>$$invalidate(37,$imageSize=value));component_subscribe($$self,imageTransforms,value=>$$invalidate(38,$imageTransforms=value));component_subscribe($$self,imageRotation,value=>$$invalidate(20,$imageRotation=value));component_subscribe($$self,imageFlipX,value=>$$invalidate(18,$imageFlipX=value));component_subscribe($$self,imageFlipY,value=>$$invalidate(19,$imageFlipY=value));//
// Mapping coordinates
//
const mapScreenPointToImagePoint=stickerStickToImage?point=>_mapScreenPointToImagePoint(point,$rootRect,$imageSize,$imageTransforms.origin,$imageTransforms.translation,$imageTransforms.rotation.z,$imageTransforms.scale,$imageFlipX,$imageFlipY):point=>{const mappedPoint=vectorClone(point);mappedPoint.x-=$imageSelectionRectPresentation.x;mappedPoint.y-=$imageSelectionRectPresentation.y;mappedPoint.x/=$presentationScalar;mappedPoint.y/=$presentationScalar;return mappedPoint;};const mapImagePointToScreenPoint=stickerStickToImage?point=>_mapImagePointToScreenPoint(point,$rootRect,$imageSize,$imageTransforms.origin,$imageTransforms.translation,$imageTransforms.rotation.z,$imageTransforms.scale,$imageFlipX,$imageFlipY):point=>{const mappedPoint=vectorClone(point);mappedPoint.x*=$presentationScalar;mappedPoint.y*=$presentationScalar;mappedPoint.x+=$imageSelectionRectPresentation.x;mappedPoint.y+=$imageSelectionRectPresentation.y;return mappedPoint;};function measure_handler(event){bubble($$self,event);}$$self.$$set=$$props=>{if("isActive"in $$props)$$invalidate(0,isActive=$$props.isActive);if("isActiveFraction"in $$props)$$invalidate(1,isActiveFraction=$$props.isActiveFraction);if("isVisible"in $$props)$$invalidate(2,isVisible=$$props.isVisible);if("stores"in $$props)$$invalidate(3,stores=$$props.stores);if("locale"in $$props)$$invalidate(4,locale=$$props.locale);if("stickers"in $$props)$$invalidate(5,stickers=$$props.stickers);if("stickerStickToImage"in $$props)$$invalidate(6,stickerStickToImage=$$props.stickerStickToImage);if("stickerEnableSelectImage"in $$props)$$invalidate(7,stickerEnableSelectImage=$$props.stickerEnableSelectImage);if("stickersEnableButtonFlipVertical"in $$props)$$invalidate(8,stickersEnableButtonFlipVertical=$$props.stickersEnableButtonFlipVertical);if("stickersWillRenderShapePresetToolbar"in $$props)$$invalidate(9,stickersWillRenderShapePresetToolbar=$$props.stickersWillRenderShapePresetToolbar);if("willRenderShapeControls"in $$props)$$invalidate(10,willRenderShapeControls=$$props.willRenderShapeControls);if("markupEditorToolSelectRadius"in $$props)$$invalidate(11,markupEditorToolSelectRadius=$$props.markupEditorToolSelectRadius);if("willRenderShapePresetToolbar"in $$props)$$invalidate(12,willRenderShapePresetToolbar=$$props.willRenderShapePresetToolbar);if("beforeAddShape"in $$props)$$invalidate(13,beforeAddShape=$$props.beforeAddShape);if("beforeRemoveShape"in $$props)$$invalidate(14,beforeRemoveShape=$$props.beforeRemoveShape);if("beforeDeselectShape"in $$props)$$invalidate(15,beforeDeselectShape=$$props.beforeDeselectShape);if("beforeSelectShape"in $$props)$$invalidate(16,beforeSelectShape=$$props.beforeSelectShape);if("beforeUpdateShape"in $$props)$$invalidate(17,beforeUpdateShape=$$props.beforeUpdateShape);};return[isActive,isActiveFraction,isVisible,stores,locale,stickers,stickerStickToImage,stickerEnableSelectImage,stickersEnableButtonFlipVertical,stickersWillRenderShapePresetToolbar,willRenderShapeControls,markupEditorToolSelectRadius,willRenderShapePresetToolbar,beforeAddShape,beforeRemoveShape,beforeDeselectShape,beforeSelectShape,beforeUpdateShape,$imageFlipX,$imageFlipY,$imageRotation,presentationScalar,rootRect,imageCropRect,imageSelectionRectPresentation,imageAnnotation,imageDecoration,imageSize,imageTransforms,imageRotation,imageFlipX,imageFlipY,mapScreenPointToImagePoint,mapImagePointToScreenPoint,name,measure_handler];}class Sticker extends SvelteComponent{constructor(options){super();init(this,options,instance$6,create_fragment$6,safe_not_equal,{name:34,isActive:0,isActiveFraction:1,isVisible:2,stores:3,locale:4,stickers:5,stickerStickToImage:6,stickerEnableSelectImage:7,stickersEnableButtonFlipVertical:8,stickersWillRenderShapePresetToolbar:9,willRenderShapeControls:10,markupEditorToolSelectRadius:11,willRenderShapePresetToolbar:12,beforeAddShape:13,beforeRemoveShape:14,beforeDeselectShape:15,beforeSelectShape:16,beforeUpdateShape:17},[-1,-1]);}get name(){return this.$$.ctx[34];}get isActive(){return this.$$.ctx[0];}set isActive(isActive){this.$set({isActive});flush();}get isActiveFraction(){return this.$$.ctx[1];}set isActiveFraction(isActiveFraction){this.$set({isActiveFraction});flush();}get isVisible(){return this.$$.ctx[2];}set isVisible(isVisible){this.$set({isVisible});flush();}get stores(){return this.$$.ctx[3];}set stores(stores){this.$set({stores});flush();}get locale(){return this.$$.ctx[4];}set locale(locale){this.$set({locale});flush();}get stickers(){return this.$$.ctx[5];}set stickers(stickers){this.$set({stickers});flush();}get stickerStickToImage(){return this.$$.ctx[6];}set stickerStickToImage(stickerStickToImage){this.$set({stickerStickToImage});flush();}get stickerEnableSelectImage(){return this.$$.ctx[7];}set stickerEnableSelectImage(stickerEnableSelectImage){this.$set({stickerEnableSelectImage});flush();}get stickersEnableButtonFlipVertical(){return this.$$.ctx[8];}set stickersEnableButtonFlipVertical(stickersEnableButtonFlipVertical){this.$set({stickersEnableButtonFlipVertical});flush();}get stickersWillRenderShapePresetToolbar(){return this.$$.ctx[9];}set stickersWillRenderShapePresetToolbar(stickersWillRenderShapePresetToolbar){this.$set({stickersWillRenderShapePresetToolbar});flush();}get willRenderShapeControls(){return this.$$.ctx[10];}set willRenderShapeControls(willRenderShapeControls){this.$set({willRenderShapeControls});flush();}get markupEditorToolSelectRadius(){return this.$$.ctx[11];}set markupEditorToolSelectRadius(markupEditorToolSelectRadius){this.$set({markupEditorToolSelectRadius});flush();}get willRenderShapePresetToolbar(){return this.$$.ctx[12];}set willRenderShapePresetToolbar(willRenderShapePresetToolbar){this.$set({willRenderShapePresetToolbar});flush();}get beforeAddShape(){return this.$$.ctx[13];}set beforeAddShape(beforeAddShape){this.$set({beforeAddShape});flush();}get beforeRemoveShape(){return this.$$.ctx[14];}set beforeRemoveShape(beforeRemoveShape){this.$set({beforeRemoveShape});flush();}get beforeDeselectShape(){return this.$$.ctx[15];}set beforeDeselectShape(beforeDeselectShape){this.$set({beforeDeselectShape});flush();}get beforeSelectShape(){return this.$$.ctx[16];}set beforeSelectShape(beforeSelectShape){this.$set({beforeSelectShape});flush();}get beforeUpdateShape(){return this.$$.ctx[17];}set beforeUpdateShape(beforeUpdateShape){this.$set({beforeUpdateShape});flush();}}// @ts-ignore
var _plugin_sticker={util:['sticker',Sticker]};/* src/core/ui/plugins/frame/index.svelte generated by Svelte v3.37.0 */function create_option_slot(ctx){let div;let html_tag;let raw_value=(/*getOptionThumb*/ctx[13](/*option*/ctx[27].value)||"")+"";let t0;let span;let t1_value=(pintura_isFunction(/*option*/ctx[27].label)?/*option*/ctx[27].label(/*locale*/ctx[1]):/*option*/ctx[27].label)+"";let t1;return{c(){div=pintura_element("div");t0=space();span=pintura_element("span");t1=pintura_text(t1_value);html_tag=new HtmlTag(t0);attr(div,"slot","option");},m(target,anchor){insert(target,div,anchor);html_tag.m(raw_value,div);append(div,t0);append(div,span);append(span,t1);},p(ctx,dirty){if(dirty&/*option*/134217728&&raw_value!==(raw_value=(/*getOptionThumb*/ctx[13](/*option*/ctx[27].value)||"")+""))html_tag.p(raw_value);if(dirty&/*option, locale*/134217730&&t1_value!==(t1_value=(pintura_isFunction(/*option*/ctx[27].label)?/*option*/ctx[27].label(/*locale*/ctx[1]):/*option*/ctx[27].label)+""))set_data(t1,t1_value);},d(detaching){if(detaching)detach(div);}};}// (125:8) <Scrollable elasticity={scrollElasticity}>
function create_default_slot$2(ctx){let radiogroup;let current;radiogroup=new RadioGroup({props:{locale:/*locale*/ctx[1],layout:"row",options:/*frameOptions*/ctx[2],selectedIndex:/*selectedFrameIndex*/ctx[10],onchange:/*handleChangeFrame*/ctx[11],$$slots:{option:[create_option_slot,({option})=>({27:option}),({option})=>option?134217728:0]},$$scope:{ctx}}});return{c(){create_component(radiogroup.$$.fragment);},m(target,anchor){mount_component(radiogroup,target,anchor);current=true;},p(ctx,dirty){const radiogroup_changes={};if(dirty&/*locale*/2)radiogroup_changes.locale=/*locale*/ctx[1];if(dirty&/*frameOptions*/4)radiogroup_changes.options=/*frameOptions*/ctx[2];if(dirty&/*$$scope, option, locale*/402653186){radiogroup_changes.$$scope={dirty,ctx};}radiogroup.$set(radiogroup_changes);},i(local){if(current)return;transition_in(radiogroup.$$.fragment,local);current=true;},o(local){transition_out(radiogroup.$$.fragment,local);current=false;},d(detaching){destroy_component(radiogroup,detaching);}};}// (116:4) 
function create_footer_slot$1(ctx){let div;let shapestyleeditor;let t;let scrollable;let current;shapestyleeditor=new ShapeStyleEditor({props:{locale:/*locale*/ctx[1],shape:/*$imageFrame*/ctx[5],onchange:/*handleUpdateSelectedFrameShape*/ctx[12],controls:/*markupEditorShapeStyleControls*/ctx[3],scrollElasticity:/*computedScrollElasticity*/ctx[4]}});scrollable=new Scrollable({props:{elasticity:/*scrollElasticity*/ctx[8],$$slots:{default:[create_default_slot$2]},$$scope:{ctx}}});return{c(){div=pintura_element("div");create_component(shapestyleeditor.$$.fragment);t=space();create_component(scrollable.$$.fragment);attr(div,"slot","footer");attr(div,"style",/*footerStyle*/ctx[6]);},m(target,anchor){insert(target,div,anchor);mount_component(shapestyleeditor,div,null);append(div,t);mount_component(scrollable,div,null);current=true;},p(ctx,dirty){const shapestyleeditor_changes={};if(dirty&/*locale*/2)shapestyleeditor_changes.locale=/*locale*/ctx[1];if(dirty&/*$imageFrame*/32)shapestyleeditor_changes.shape=/*$imageFrame*/ctx[5];if(dirty&/*markupEditorShapeStyleControls*/8)shapestyleeditor_changes.controls=/*markupEditorShapeStyleControls*/ctx[3];if(dirty&/*computedScrollElasticity*/16)shapestyleeditor_changes.scrollElasticity=/*computedScrollElasticity*/ctx[4];shapestyleeditor.$set(shapestyleeditor_changes);const scrollable_changes={};if(dirty&/*$$scope, locale, frameOptions*/268435462){scrollable_changes.$$scope={dirty,ctx};}scrollable.$set(scrollable_changes);if(!current||dirty&/*footerStyle*/64){attr(div,"style",/*footerStyle*/ctx[6]);}},i(local){if(current)return;transition_in(shapestyleeditor.$$.fragment,local);transition_in(scrollable.$$.fragment,local);current=true;},o(local){transition_out(shapestyleeditor.$$.fragment,local);transition_out(scrollable.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(shapestyleeditor);destroy_component(scrollable);}};}function create_fragment$5(ctx){let util;let current;util=new Util({props:{$$slots:{footer:[create_footer_slot$1]},$$scope:{ctx}}});util.$on("measure",/*measure_handler*/ctx[21]);return{c(){create_component(util.$$.fragment);},m(target,anchor){mount_component(util,target,anchor);current=true;},p(ctx,[dirty]){const util_changes={};if(dirty&/*$$scope, footerStyle, locale, frameOptions, $imageFrame, markupEditorShapeStyleControls, computedScrollElasticity*/268435582){util_changes.$$scope={dirty,ctx};}util.$set(util_changes);},i(local){if(current)return;transition_in(util.$$.fragment,local);current=true;},o(local){transition_out(util.$$.fragment,local);current=false;},d(detaching){destroy_component(util,detaching);}};}function instance$5($$self,$$props,$$invalidate){let computedScrollElasticity;let footerStyle;let $imageFrame;let $animation;let $isActive,$$unsubscribe_isActive=pintura_noop,$$subscribe_isActive=()=>($$unsubscribe_isActive(),$$unsubscribe_isActive=subscribe(isActive,$$value=>$$invalidate(19,$isActive=$$value)),isActive);let $footerOffset;$$self.$$.on_destroy.push(()=>$$unsubscribe_isActive());const name="frame";let{isActive}=$$props;$$subscribe_isActive();let{stores}=$$props;let{locale={}}=$$props;let{frameStyles={}}=$$props;let{frameOptions=[]}=$$props;let{markupEditorShapeStyleControls=undefined}=$$props;// connect filter choice to stores
const{animation,elasticityMultiplier,scrollElasticity,imageFrame}=stores;component_subscribe($$self,animation,value=>$$invalidate(18,$animation=value));component_subscribe($$self,imageFrame,value=>$$invalidate(5,$imageFrame=value));// current index in frame list
let selectedFrameIndex=$imageFrame?frameOptions.findIndex(([id])=>id===$imageFrame.id):0;// default frame styles
let frameActiveStyles={frameColor:[1,1,1]};const handleChangeFrame=({value})=>{// get new frame
const frameBase=frameStyles[value];// no new frame selected
if(!frameBase||!frameBase.shape){imageFrame.set(undefined);return;}// create new base frame
const frame={id:value,// set base styles
...frameActiveStyles,// copy the frame base, it's possible that this frame has a different layout
...shapeDeepCopy(frameBase.shape)};imageFrame.set(frame);};function handleUpdateSelectedFrameShape(props){// remember color style for when creating or styling other element
if(hasProp(props,"frameColor"))frameActiveStyles.frameColor=props.frameColor;// it's possible we're only updating default styles
if(!$imageFrame)return;// frameSelected
shapeUpdateProps($imageFrame,props);// update shape so ui shape controls are updated
imageFrame.set($imageFrame);}const isIncompleteSVGMarkup=str=>/rect|path|circle|line|<g>/i.test(str);const isHTML=str=>/div/i.test(str);const getThumb=value=>{if(isHTML(value))return value;// could be full svg
if(isSVGMarkup(value))return value;// could be a partial svg in which case we turn it into a full svg
if(isIncompleteSVGMarkup(value))return`<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" stroke-width="1" stroke="currentColor" fill="none" aria-hidden="true" focusable="false" stroke-linecap="round" stroke-linejoin="round">${value}</svg>`;// if not, must be URL
return`<img src="${value}" alt=""/>`;};const getOptionThumb=key=>{const frameStyle=frameStyles[key];if(!frameStyle||!frameStyle.thumb)return;return getThumb(frameStyle.thumb);};//
// Footer style
//
const footerOffset=spring($animation?20:0);component_subscribe($$self,footerOffset,value=>$$invalidate(20,$footerOffset=value));function measure_handler(event){bubble($$self,event);}$$self.$$set=$$props=>{if("isActive"in $$props)$$subscribe_isActive($$invalidate(0,isActive=$$props.isActive));if("stores"in $$props)$$invalidate(16,stores=$$props.stores);if("locale"in $$props)$$invalidate(1,locale=$$props.locale);if("frameStyles"in $$props)$$invalidate(17,frameStyles=$$props.frameStyles);if("frameOptions"in $$props)$$invalidate(2,frameOptions=$$props.frameOptions);if("markupEditorShapeStyleControls"in $$props)$$invalidate(3,markupEditorShapeStyleControls=$$props.markupEditorShapeStyleControls);};$$self.$$.update=()=>{if($$self.$$.dirty&/*$animation, $isActive*/786432){$animation&&footerOffset.set($isActive?0:20);}if($$self.$$.dirty&/*$footerOffset*/1048576){$$invalidate(6,footerStyle=$footerOffset?`transform: translateY(${$footerOffset}px)`:undefined);}};$$invalidate(4,computedScrollElasticity=elasticityMultiplier*scrollElasticity);return[isActive,locale,frameOptions,markupEditorShapeStyleControls,computedScrollElasticity,$imageFrame,footerStyle,animation,scrollElasticity,imageFrame,selectedFrameIndex,handleChangeFrame,handleUpdateSelectedFrameShape,getOptionThumb,footerOffset,name,stores,frameStyles,$animation,$isActive,$footerOffset,measure_handler];}class Frame extends SvelteComponent{constructor(options){super();init(this,options,instance$5,create_fragment$5,safe_not_equal,{name:15,isActive:0,stores:16,locale:1,frameStyles:17,frameOptions:2,markupEditorShapeStyleControls:3});}get name(){return this.$$.ctx[15];}get isActive(){return this.$$.ctx[0];}set isActive(isActive){this.$set({isActive});flush();}get stores(){return this.$$.ctx[16];}set stores(stores){this.$set({stores});flush();}get locale(){return this.$$.ctx[1];}set locale(locale){this.$set({locale});flush();}get frameStyles(){return this.$$.ctx[17];}set frameStyles(frameStyles){this.$set({frameStyles});flush();}get frameOptions(){return this.$$.ctx[2];}set frameOptions(frameOptions){this.$set({frameOptions});flush();}get markupEditorShapeStyleControls(){return this.$$.ctx[3];}set markupEditorShapeStyleControls(markupEditorShapeStyleControls){this.$set({markupEditorShapeStyleControls});flush();}}// @ts-ignore
var _plugin_frame={util:['frame',Frame]};/* src/core/ui/plugins/resize/DimensionInput.svelte generated by Svelte v3.37.0 */function create_fragment$4(ctx){let div;let label_1;let t0;let t1;let input;let input_value_value;let mounted;let dispose;return{c(){div=pintura_element("div");label_1=pintura_element("label");t0=pintura_text(/*label*/ctx[1]);t1=space();input=pintura_element("input");attr(label_1,"for",/*id*/ctx[0]);attr(label_1,"title",/*title*/ctx[2]);attr(label_1,"aria-label",/*title*/ctx[2]);attr(input,"id",/*id*/ctx[0]);attr(input,"type","text");attr(input,"inputmode","numeric");attr(input,"pattern","[0-9]*");attr(input,"data-state",/*state*/ctx[3]);attr(input,"autocomplete","off");attr(input,"placeholder",/*placeholder*/ctx[4]);input.value=input_value_value=/*value*/ctx[5]===undefined?"":/*format*/ctx[7](/*value*/ctx[5]+"");attr(div,"class","PinturaInputDimension");},m(target,anchor){insert(target,div,anchor);append(div,label_1);append(label_1,t0);append(div,t1);append(div,input);if(!mounted){dispose=listen(input,"input",/*input_handler*/ctx[8]);mounted=true;}},p(ctx,[dirty]){if(dirty&/*label*/2)set_data(t0,/*label*/ctx[1]);if(dirty&/*id*/1){attr(label_1,"for",/*id*/ctx[0]);}if(dirty&/*title*/4){attr(label_1,"title",/*title*/ctx[2]);}if(dirty&/*title*/4){attr(label_1,"aria-label",/*title*/ctx[2]);}if(dirty&/*id*/1){attr(input,"id",/*id*/ctx[0]);}if(dirty&/*state*/8){attr(input,"data-state",/*state*/ctx[3]);}if(dirty&/*placeholder*/16){attr(input,"placeholder",/*placeholder*/ctx[4]);}if(dirty&/*value, format*/160&&input_value_value!==(input_value_value=/*value*/ctx[5]===undefined?"":/*format*/ctx[7](/*value*/ctx[5]+""))&&input.value!==input_value_value){input.value=input_value_value;}},i:pintura_noop,o:pintura_noop,d(detaching){if(detaching)detach(div);mounted=false;dispose();}};}function instance$4($$self,$$props,$$invalidate){let{id}=$$props;let{label}=$$props;let{title}=$$props;let{state}=$$props;let{placeholder}=$$props;let{value}=$$props;let{onchange}=$$props;let{format=str=>str.replace(/\D/g,"")}=$$props;const input_handler=e=>onchange(format(e.currentTarget.value));$$self.$$set=$$props=>{if("id"in $$props)$$invalidate(0,id=$$props.id);if("label"in $$props)$$invalidate(1,label=$$props.label);if("title"in $$props)$$invalidate(2,title=$$props.title);if("state"in $$props)$$invalidate(3,state=$$props.state);if("placeholder"in $$props)$$invalidate(4,placeholder=$$props.placeholder);if("value"in $$props)$$invalidate(5,value=$$props.value);if("onchange"in $$props)$$invalidate(6,onchange=$$props.onchange);if("format"in $$props)$$invalidate(7,format=$$props.format);};return[id,label,title,state,placeholder,value,onchange,format,input_handler];}class DimensionInput extends SvelteComponent{constructor(options){super();init(this,options,instance$4,create_fragment$4,safe_not_equal,{id:0,label:1,title:2,state:3,placeholder:4,value:5,onchange:6,format:7});}}/* src/core/ui/plugins/resize/DimensionLock.svelte generated by Svelte v3.37.0 */function create_default_slot$1(ctx){let g;return{c(){g=svg_element("g");},m(target,anchor){insert(target,g,anchor);g.innerHTML=/*icon*/ctx[2];},p(ctx,dirty){if(dirty&/*icon*/4)g.innerHTML=/*icon*/ctx[2];},d(detaching){if(detaching)detach(g);}};}function create_fragment$3(ctx){let div;let input;let t;let label;let icon_1;let current;let mounted;let dispose;icon_1=new Icon({props:{$$slots:{default:[create_default_slot$1]},$$scope:{ctx}}});return{c(){div=pintura_element("div");input=pintura_element("input");t=space();label=pintura_element("label");create_component(icon_1.$$.fragment);attr(input,"id",/*id*/ctx[0]);attr(input,"class","implicit");attr(input,"type","checkbox");input.checked=/*locked*/ctx[1];attr(label,"for",/*id*/ctx[0]);attr(label,"title",/*title*/ctx[3]);},m(target,anchor){insert(target,div,anchor);append(div,input);append(div,t);append(div,label);mount_component(icon_1,label,null);current=true;if(!mounted){dispose=listen(input,"change",/*change_handler*/ctx[5]);mounted=true;}},p(ctx,[dirty]){if(!current||dirty&/*id*/1){attr(input,"id",/*id*/ctx[0]);}if(!current||dirty&/*locked*/2){input.checked=/*locked*/ctx[1];}const icon_1_changes={};if(dirty&/*$$scope, icon*/68){icon_1_changes.$$scope={dirty,ctx};}icon_1.$set(icon_1_changes);if(!current||dirty&/*id*/1){attr(label,"for",/*id*/ctx[0]);}if(!current||dirty&/*title*/8){attr(label,"title",/*title*/ctx[3]);}},i(local){if(current)return;transition_in(icon_1.$$.fragment,local);current=true;},o(local){transition_out(icon_1.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(div);destroy_component(icon_1);mounted=false;dispose();}};}function instance$3($$self,$$props,$$invalidate){let{id}=$$props;let{locked}=$$props;let{icon}=$$props;let{title}=$$props;let{onchange}=$$props;const change_handler=e=>onchange(e.currentTarget.checked);$$self.$$set=$$props=>{if("id"in $$props)$$invalidate(0,id=$$props.id);if("locked"in $$props)$$invalidate(1,locked=$$props.locked);if("icon"in $$props)$$invalidate(2,icon=$$props.icon);if("title"in $$props)$$invalidate(3,title=$$props.title);if("onchange"in $$props)$$invalidate(4,onchange=$$props.onchange);};return[id,locked,icon,title,onchange,change_handler];}class DimensionLock extends SvelteComponent{constructor(options){super();init(this,options,instance$3,create_fragment$3,safe_not_equal,{id:0,locked:1,icon:2,title:3,onchange:4});}}/* src/core/ui/plugins/resize/index.svelte generated by Svelte v3.37.0 */function create_default_slot(ctx){let t;return{c(){t=pintura_text("Save");},m(target,anchor){insert(target,t,anchor);},d(detaching){if(detaching)detach(t);}};}// (542:4) 
function create_footer_slot(ctx){let form;let div1;let fieldset;let legend;let t0_value=/*locale*/ctx[1].resizeLabelFormCaption+"";let t0;let t1;let div0;let dynamiccomponenttree;let t2;let button;let current;let mounted;let dispose;dynamiccomponenttree=new DynamicComponentTree_1({props:{items:/*tools*/ctx[3]}});button=new Button({props:{type:"submit",class:"implicit",$$slots:{default:[create_default_slot]},$$scope:{ctx}}});return{c(){form=pintura_element("form");div1=pintura_element("div");fieldset=pintura_element("fieldset");legend=pintura_element("legend");t0=pintura_text(t0_value);t1=space();div0=pintura_element("div");create_component(dynamiccomponenttree.$$.fragment);t2=space();create_component(button.$$.fragment);attr(legend,"class","implicit");attr(div0,"class","PinturaFieldsetInner");attr(div1,"class","PinturaFormInner");attr(form,"slot","footer");attr(form,"style",/*footerStyle*/ctx[4]);},m(target,anchor){insert(target,form,anchor);append(form,div1);append(div1,fieldset);append(fieldset,legend);append(legend,t0);append(fieldset,t1);append(fieldset,div0);mount_component(dynamiccomponenttree,div0,null);/*div0_binding*/ctx[62](div0);append(div1,t2);mount_component(button,div1,null);current=true;if(!mounted){dispose=[listen(div0,"focusin",/*handleFocusIn*/ctx[13]),listen(div0,"focusout",/*handleFocusOut*/ctx[14]),listen(form,"submit",prevent_default(/*handleSubmit*/ctx[15]))];mounted=true;}},p(ctx,dirty){if((!current||dirty[0]&/*locale*/2)&&t0_value!==(t0_value=/*locale*/ctx[1].resizeLabelFormCaption+""))set_data(t0,t0_value);const dynamiccomponenttree_changes={};if(dirty[0]&/*tools*/8)dynamiccomponenttree_changes.items=/*tools*/ctx[3];dynamiccomponenttree.$set(dynamiccomponenttree_changes);const button_changes={};if(dirty[2]&/*$$scope*/524288){button_changes.$$scope={dirty,ctx};}button.$set(button_changes);if(!current||dirty[0]&/*footerStyle*/16){attr(form,"style",/*footerStyle*/ctx[4]);}},i(local){if(current)return;transition_in(dynamiccomponenttree.$$.fragment,local);transition_in(button.$$.fragment,local);current=true;},o(local){transition_out(dynamiccomponenttree.$$.fragment,local);transition_out(button.$$.fragment,local);current=false;},d(detaching){if(detaching)detach(form);destroy_component(dynamiccomponenttree);/*div0_binding*/ctx[62](null);destroy_component(button);mounted=false;run_all(dispose);}};}function create_fragment$2(ctx){let util;let current;util=new Util({props:{$$slots:{footer:[create_footer_slot]},$$scope:{ctx}}});util.$on("measure",/*measure_handler*/ctx[63]);return{c(){create_component(util.$$.fragment);},m(target,anchor){mount_component(util,target,anchor);current=true;},p(ctx,dirty){const util_changes={};if(dirty[0]&/*footerStyle, fieldsGroup, tools, locale*/30|dirty[2]&/*$$scope*/524288){util_changes.$$scope={dirty,ctx};}util.$set(util_changes);},i(local){if(current)return;transition_in(util.$$.fragment,local);current=true;},o(local){transition_out(util.$$.fragment,local);current=false;},d(detaching){destroy_component(util,detaching);}};}function instance$2($$self,$$props,$$invalidate){let sizePresetLabel;let widthPresetLabel;let heightPresetLabel;let canRenderSizePresets;let canRenderWidthPresets;let canRenderHeightPresets;let canRenderSizeInputs;let tools;let footerStyle;let $imageCropRectAspectRatio;let $imageOutputSize;let $imageCropAspectRatio;let $imageSize;let $formattedResizeSizePresetOptions;let $formattedResizeSizePresetOptionsFlattened;let $formattedResizeWidthPresetOptions;let $formattedResizeWidthPresetOptionsFlattened;let $formattedResizeHeightPresetOptions;let $formattedResizeHeightPresetOptionsFlattened;let $sizePresetSelectedIndex;let $widthPresetSelectedIndex;let $heightPresetSelectedIndex;let $imageCropRect;let $iconActiveFraction;let $env;let $animation;let $isActive,$$unsubscribe_isActive=pintura_noop,$$subscribe_isActive=()=>($$unsubscribe_isActive(),$$unsubscribe_isActive=subscribe(isActive,$$value=>$$invalidate(60,$isActive=$$value)),isActive);let $footerOffset;$$self.$$.on_destroy.push(()=>$$unsubscribe_isActive());const formatValue=(value,min=0,max=9999)=>{if(pintura_isString(value)){value=value.replace(/\D/g,"");if(!value.length)return;}const v=Math.round(value);if(Number.isNaN(v))return;return pintura_clamp(v,min,max);};const name="resize";let{isActive}=$$props;$$subscribe_isActive();let{stores}=$$props;let{locale={}}=$$props;let{resizeMinSize=sizeCreate(1,1)}=$$props;let{resizeMaxSize=sizeCreate(9999,9999)}=$$props;let{resizeSizePresetOptions=undefined}=$$props;let{resizeWidthPresetOptions=undefined}=$$props;let{resizeHeightPresetOptions=undefined}=$$props;let{resizeWillRenderFooter=passthrough}=$$props;// offset
const iconActiveFraction=spring(0,{stiffness:0.15,damping:0.3});component_subscribe($$self,iconActiveFraction,value=>$$invalidate(57,$iconActiveFraction=value));const{animation,imageSize,imageCropRect,imageCropRectAspectRatio,imageCropAspectRatio,imageOutputSize,history,env}=stores;component_subscribe($$self,animation,value=>$$invalidate(59,$animation=value));component_subscribe($$self,imageSize,value=>$$invalidate(69,$imageSize=value));component_subscribe($$self,imageCropRect,value=>$$invalidate(52,$imageCropRect=value));component_subscribe($$self,imageCropRectAspectRatio,value=>$$invalidate(39,$imageCropRectAspectRatio=value));component_subscribe($$self,imageCropAspectRatio,value=>$$invalidate(68,$imageCropAspectRatio=value));component_subscribe($$self,imageOutputSize,value=>$$invalidate(67,$imageOutputSize=value));component_subscribe($$self,env,value=>$$invalidate(58,$env=value));const formId=getUniqueId();let fieldsGroup;let maintainAspectRatio=false;let width;let height;let activeField;let lastActiveField;const getState=(value,field,activeField,resizeMinSize,resizeMaxSize)=>value!=null&&activeField!==field?value>=resizeMinSize[field]&&value<=resizeMaxSize[field]?"valid":"invalid":"undetermined";const getWidthPlaceholder=(value,cropAspectRatio,cropRect)=>Math.round(value!=null?value*cropAspectRatio:cropRect.width);const getHeightPlaceholder=(value,cropAspectRatio,cropRect)=>Math.round(value!=null?value/cropAspectRatio:cropRect.height);// populate active field
const handleFocusIn=e=>{const id=e.target.id;if(/width/.test(id)){$$invalidate(37,activeField="width");}else if(/height/.test(id)){$$invalidate(37,activeField="height");}else if(/aspectRatio/i.test(id)){$$invalidate(37,activeField="lock");}else{$$invalidate(37,activeField=undefined);}};const handleFocusOut=e=>{if(!fieldsGroup.contains(e.relatedTarget))handleSubmit();$$invalidate(37,activeField=undefined);};// sync fields if one has a value and aspect ratio should be maintained
const syncFields=()=>{if(!maintainAspectRatio||!width||!height)return;if(activeField==="width"){// sync height field
$$invalidate(36,height=Math.round(width/$imageCropRectAspectRatio));}else if(activeField==="height"){// sync width field
$$invalidate(35,width=Math.round(height*$imageCropRectAspectRatio));}else{if(lastActiveField==="width"){$$invalidate(36,height=Math.round(width/$imageCropRectAspectRatio));}else if(lastActiveField==="height"){$$invalidate(35,width=Math.round(height*$imageCropRectAspectRatio));}consolidateSize();}};// $: if (maintainAspectRatio && width && height) syncFields()
const consolidateSize=forcedAspectRatio=>{// first need to limit values
let inputWidth=formatValue(width);let inputHeight=formatValue(height);let currentWidth=inputWidth;let currentHeight=inputHeight;let bothAxisDefined=currentWidth&&currentHeight;let aspectRatio=forcedAspectRatio||$imageCropRectAspectRatio;// done, no consolidation needed
if(!currentWidth&&!currentHeight)return;// need to fill in missing values
if(currentWidth&&!currentHeight){currentHeight=Math.round(currentWidth/aspectRatio);}else if(currentHeight&&!currentWidth){currentWidth=Math.round(currentHeight*aspectRatio);}aspectRatio=forcedAspectRatio||bothAxisDefined?getAspectRatio(currentWidth,currentHeight):$imageCropRectAspectRatio;// now we have both width and height let's re-fit the min max size
let currentSize=sizeCreate(currentWidth,currentHeight);if(!sizeContains(resizeMaxSize,currentSize)){// too big
currentSize=rectContainRect(resizeMaxSize,aspectRatio);}if(!sizeContains(currentSize,resizeMinSize)){// too small
currentSize=rectCoverRect(resizeMinSize,aspectRatio);}$$invalidate(35,width=inputWidth!=null?Math.round(currentSize.width):undefined);$$invalidate(36,height=inputHeight!=null?Math.round(currentSize.height):undefined);};const handleSubmit=()=>{// calculate correct values
consolidateSize();// get curent values so we can check if they were changed (if not, no need to write history or update)
const{width:currentWidth,height:currentHeight}=$imageOutputSize||{};// no need to update
if(currentWidth===width&&currentHeight===height)return;// update state
if(!width&&!height){// reset image crop
set_store_value(imageCropAspectRatio,$imageCropAspectRatio=$imageSize.width/$imageSize.height,$imageCropAspectRatio);set_store_value(imageCropAspectRatio,$imageCropAspectRatio=undefined,$imageCropAspectRatio);// reset output size
set_store_value(imageOutputSize,$imageOutputSize=undefined,$imageOutputSize);}else{if(width&&height)set_store_value(imageCropAspectRatio,$imageCropAspectRatio=width/height,$imageCropAspectRatio);set_store_value(imageOutputSize,$imageOutputSize=sizeCreate(width,height),$imageOutputSize);}history.write();};// handle external updates to outputSize
imageOutputSize.subscribe(size=>{if(!size){$$invalidate(35,width=undefined);$$invalidate(36,height=undefined);return;}$$invalidate(35,width=size.width);$$invalidate(36,height=size.height);// make sure the size conforms to min max
consolidateSize();});// if the crop aspect ratio is changed we need to align width/height
imageCropAspectRatio.subscribe(cropAspectRatio=>{// exit if no dimensions supplied
if(!width&&!height)return;// no crop aspect ratio has been selected, so all is fine
if(!cropAspectRatio)return;// fix size to match new aspect ratio of the crop
if(width&&height&&getAspectRatio(width,height)!==cropAspectRatio){$$invalidate(36,height=width/cropAspectRatio);consolidateSize(cropAspectRatio);}else{consolidateSize();}});//
// size presets
//
const formatPresetDimensionOption=option=>{if(pintura_isString(option[0])){option[1]=option[1].map(formatPresetDimensionOption);return option;}return pintura_isNumber(option)?[option,""+option]:option;};const formatPresetSizeOption=option=>{if(pintura_isString(option[0])){option[1]=option[1].map(formatPresetSizeOption);return option;}let[value,label]=option;// Size only
if(pintura_isNumber(value)&&pintura_isNumber(label)){const[w,h]=[value,label];label=`${w} × ${h}`;value=[w,h];}return[value,label];};const formattedResizeSizePresetOptions=writable();component_subscribe($$self,formattedResizeSizePresetOptions,value=>$$invalidate(40,$formattedResizeSizePresetOptions=value));const formattedResizeSizePresetOptionsFlattened=writable();component_subscribe($$self,formattedResizeSizePresetOptionsFlattened,value=>$$invalidate(41,$formattedResizeSizePresetOptionsFlattened=value));const formattedResizeWidthPresetOptions=writable();component_subscribe($$self,formattedResizeWidthPresetOptions,value=>$$invalidate(42,$formattedResizeWidthPresetOptions=value));const formattedResizeWidthPresetOptionsFlattened=writable();component_subscribe($$self,formattedResizeWidthPresetOptionsFlattened,value=>$$invalidate(43,$formattedResizeWidthPresetOptionsFlattened=value));const formattedResizeHeightPresetOptions=writable();component_subscribe($$self,formattedResizeHeightPresetOptions,value=>$$invalidate(44,$formattedResizeHeightPresetOptions=value));const formattedResizeHeightPresetOptionsFlattened=writable();component_subscribe($$self,formattedResizeHeightPresetOptionsFlattened,value=>$$invalidate(45,$formattedResizeHeightPresetOptionsFlattened=value));const sizePresetSelectedIndex=derived([imageOutputSize,formattedResizeSizePresetOptionsFlattened],([$imageOutputSize,$formattedResizeSizePresetOptionsFlattened],set)=>{if(!$formattedResizeSizePresetOptionsFlattened)return set(-1);const index=$formattedResizeSizePresetOptionsFlattened.findIndex(([value])=>{if(!value&&!$imageOutputSize)return true;if(!value)return false;const[width,height]=value;return $imageOutputSize.width===width&&$imageOutputSize.height===height;});set(index<0?0:index);});component_subscribe($$self,sizePresetSelectedIndex,value=>$$invalidate(47,$sizePresetSelectedIndex=value));const widthPresetSelectedIndex=derived([imageOutputSize,formattedResizeWidthPresetOptionsFlattened],([$imageOutputSize,$formattedResizeWidthPresetOptionsFlattened],set)=>{if(!$formattedResizeWidthPresetOptionsFlattened)return set(-1);const index=$formattedResizeWidthPresetOptionsFlattened.findIndex(([value])=>{if(!value&&!$imageOutputSize)return true;if(!value)return false;return $imageOutputSize.width===value;});set(index<0?0:index);});component_subscribe($$self,widthPresetSelectedIndex,value=>$$invalidate(49,$widthPresetSelectedIndex=value));const heightPresetSelectedIndex=derived([imageOutputSize,formattedResizeHeightPresetOptionsFlattened],([$imageOutputSize,$formattedResizeHeightPresetOptionsFlattened],set)=>{if(!$formattedResizeHeightPresetOptionsFlattened)return set(-1);const index=$formattedResizeHeightPresetOptionsFlattened.findIndex(([value])=>{if(!value&&!$imageOutputSize)return true;if(!value)return false;return $imageOutputSize.height===value;});set(index<0?0:index);});component_subscribe($$self,heightPresetSelectedIndex,value=>$$invalidate(51,$heightPresetSelectedIndex=value));let storedCropRect=undefined;let storedCropAspectRatio=undefined;const setImageOutputSizeWithArray=size=>{if(size&&!storedCropRect){storedCropRect={...$imageCropRect};storedCropAspectRatio=$imageCropAspectRatio;}if(!size){set_store_value(imageCropRect,$imageCropRect=storedCropRect,$imageCropRect);set_store_value(imageCropAspectRatio,$imageCropAspectRatio=storedCropAspectRatio,$imageCropAspectRatio);set_store_value(imageOutputSize,$imageOutputSize=undefined,$imageOutputSize);storedCropRect=undefined;storedCropAspectRatio=undefined;}else{set_store_value(imageCropAspectRatio,$imageCropAspectRatio=getAspectRatio(size[0],size[1]),$imageCropAspectRatio);set_store_value(imageOutputSize,$imageOutputSize=sizeCreateFromArray(size),$imageOutputSize);}history.write();};//
// toolbar
//
let redrawTrigger={};//
// Footer
//
const footerOffset=spring($animation?20:0);component_subscribe($$self,footerOffset,value=>$$invalidate(61,$footerOffset=value));function div0_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{fieldsGroup=$$value;$$invalidate(2,fieldsGroup);});}function measure_handler(event){bubble($$self,event);}$$self.$$set=$$props=>{if("isActive"in $$props)$$subscribe_isActive($$invalidate(0,isActive=$$props.isActive));if("stores"in $$props)$$invalidate(27,stores=$$props.stores);if("locale"in $$props)$$invalidate(1,locale=$$props.locale);if("resizeMinSize"in $$props)$$invalidate(28,resizeMinSize=$$props.resizeMinSize);if("resizeMaxSize"in $$props)$$invalidate(29,resizeMaxSize=$$props.resizeMaxSize);if("resizeSizePresetOptions"in $$props)$$invalidate(30,resizeSizePresetOptions=$$props.resizeSizePresetOptions);if("resizeWidthPresetOptions"in $$props)$$invalidate(31,resizeWidthPresetOptions=$$props.resizeWidthPresetOptions);if("resizeHeightPresetOptions"in $$props)$$invalidate(32,resizeHeightPresetOptions=$$props.resizeHeightPresetOptions);if("resizeWillRenderFooter"in $$props)$$invalidate(33,resizeWillRenderFooter=$$props.resizeWillRenderFooter);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*resizeSizePresetOptions*/1073741824|$$self.$$.dirty[1]&/*$formattedResizeSizePresetOptions*/512){if(resizeSizePresetOptions){set_store_value(formattedResizeSizePresetOptions,$formattedResizeSizePresetOptions=resizeSizePresetOptions.map(formatPresetSizeOption),$formattedResizeSizePresetOptions);set_store_value(formattedResizeSizePresetOptionsFlattened,$formattedResizeSizePresetOptionsFlattened=flattenOptions($formattedResizeSizePresetOptions),$formattedResizeSizePresetOptionsFlattened);}}if($$self.$$.dirty[1]&/*$formattedResizeSizePresetOptions*/512){//
// helper bools
//
$$invalidate(53,canRenderSizePresets=!!$formattedResizeSizePresetOptions);}if($$self.$$.dirty[1]&/*$sizePresetSelectedIndex, $formattedResizeSizePresetOptionsFlattened*/66560){$$invalidate(46,sizePresetLabel=$sizePresetSelectedIndex>-1&&$formattedResizeSizePresetOptionsFlattened[$sizePresetSelectedIndex][1]);}if($$self.$$.dirty[1]&/*resizeWidthPresetOptions, $formattedResizeWidthPresetOptions*/2049){if(resizeWidthPresetOptions){set_store_value(formattedResizeWidthPresetOptions,$formattedResizeWidthPresetOptions=resizeWidthPresetOptions.map(formatPresetDimensionOption),$formattedResizeWidthPresetOptions);set_store_value(formattedResizeWidthPresetOptionsFlattened,$formattedResizeWidthPresetOptionsFlattened=flattenOptions($formattedResizeWidthPresetOptions),$formattedResizeWidthPresetOptionsFlattened);}}if($$self.$$.dirty[1]&/*canRenderSizePresets, $formattedResizeWidthPresetOptions*/4196352){$$invalidate(54,canRenderWidthPresets=!canRenderSizePresets&&$formattedResizeWidthPresetOptions);}if($$self.$$.dirty[1]&/*$widthPresetSelectedIndex, $formattedResizeWidthPresetOptionsFlattened*/266240){$$invalidate(48,widthPresetLabel=$widthPresetSelectedIndex>-1&&$formattedResizeWidthPresetOptionsFlattened[$widthPresetSelectedIndex][1]);}if($$self.$$.dirty[1]&/*resizeHeightPresetOptions, $formattedResizeHeightPresetOptions*/8194){if(resizeHeightPresetOptions){set_store_value(formattedResizeHeightPresetOptions,$formattedResizeHeightPresetOptions=resizeHeightPresetOptions.map(formatPresetDimensionOption),$formattedResizeHeightPresetOptions);set_store_value(formattedResizeHeightPresetOptionsFlattened,$formattedResizeHeightPresetOptionsFlattened=flattenOptions($formattedResizeHeightPresetOptions),$formattedResizeHeightPresetOptionsFlattened);}}if($$self.$$.dirty[1]&/*canRenderSizePresets, $formattedResizeHeightPresetOptions*/4202496){$$invalidate(55,canRenderHeightPresets=!canRenderSizePresets&&$formattedResizeHeightPresetOptions);}if($$self.$$.dirty[1]&/*$heightPresetSelectedIndex, $formattedResizeHeightPresetOptionsFlattened*/1064960){$$invalidate(50,heightPresetLabel=$heightPresetSelectedIndex>-1&&$formattedResizeHeightPresetOptionsFlattened[$heightPresetSelectedIndex][1]);}if($$self.$$.dirty[1]&/*canRenderSizePresets, canRenderWidthPresets, canRenderHeightPresets*/29360128){$$invalidate(56,canRenderSizeInputs=!canRenderSizePresets&&!canRenderWidthPresets&&!canRenderHeightPresets);}if($$self.$$.dirty[0]&/*locale, resizeMinSize, resizeMaxSize*/805306370|$$self.$$.dirty[1]&/*redrawTrigger, resizeWillRenderFooter, canRenderSizePresets, sizePresetLabel, $formattedResizeSizePresetOptions, $sizePresetSelectedIndex, canRenderWidthPresets, widthPresetLabel, $formattedResizeWidthPresetOptions, $widthPresetSelectedIndex, canRenderHeightPresets, heightPresetLabel, $formattedResizeHeightPresetOptions, $heightPresetSelectedIndex, canRenderSizeInputs, height, $imageCropRectAspectRatio, $imageCropRect, width, activeField, maintainAspectRatio, $iconActiveFraction, $env*/268413948){$$invalidate(3,tools=redrawTrigger&&resizeWillRenderFooter([canRenderSizePresets&&["Dropdown","size-presets",{label:sizePresetLabel,options:$formattedResizeSizePresetOptions,onchange:item=>setImageOutputSizeWithArray(item.value),selectedIndex:$sizePresetSelectedIndex}],canRenderWidthPresets&&["Dropdown","width-presets",{label:widthPresetLabel,options:$formattedResizeWidthPresetOptions,onchange:item=>{$$invalidate(35,width=item.value);handleSubmit();},selectedIndex:$widthPresetSelectedIndex}],canRenderWidthPresets&&canRenderHeightPresets&&["span","times",{class:"PinturaResizeLabel",innerHTML:"&times;"}],canRenderHeightPresets&&["Dropdown","height-presets",{label:heightPresetLabel,options:$formattedResizeHeightPresetOptions,onchange:item=>{$$invalidate(36,height=item.value);handleSubmit();},selectedIndex:$heightPresetSelectedIndex}],canRenderSizeInputs&&[DimensionInput,"width-input",{id:`width-${formId}`,title:locale.resizeTitleInputWidth,label:locale.resizeLabelInputWidth,placeholder:getWidthPlaceholder(formatValue(height),$imageCropRectAspectRatio,$imageCropRect),value:width,state:getState(formatValue(width),"width",activeField,resizeMinSize,resizeMaxSize),onchange:value=>{$$invalidate(35,width=value);syncFields();}}],canRenderSizeInputs&&[DimensionLock,"aspect-ratio-lock",{id:`aspect-ratio-lock-${formId}`,title:locale.resizeTitleButtonMaintainAspectRatio,icon:pintura_isString(locale.resizeIconButtonMaintainAspectRatio)?locale.resizeIconButtonMaintainAspectRatio:locale.resizeIconButtonMaintainAspectRatio(maintainAspectRatio,$iconActiveFraction),locked:maintainAspectRatio,onchange:locked=>{$$invalidate(34,maintainAspectRatio=locked);syncFields();}}],canRenderSizeInputs&&[DimensionInput,"height-input",{id:`height-${formId}`,title:locale.resizeTitleInputHeight,label:locale.resizeLabelInputHeight,placeholder:getHeightPlaceholder(formatValue(width),$imageCropRectAspectRatio,$imageCropRect),value:height,state:getState(formatValue(height),"height",activeField,resizeMinSize,resizeMaxSize),onchange:value=>{$$invalidate(36,height=value);syncFields();}}]].filter(Boolean),{...$env},()=>$$invalidate(38,redrawTrigger={})).filter(Boolean));}if($$self.$$.dirty[1]&/*maintainAspectRatio*/8){iconActiveFraction.set(maintainAspectRatio?1:0);}if($$self.$$.dirty[1]&/*activeField*/64){if(activeField)lastActiveField=activeField;}if($$self.$$.dirty[1]&/*$animation, $isActive*/805306368){$animation&&footerOffset.set($isActive?0:20);}if($$self.$$.dirty[1]&/*$footerOffset*/1073741824){$$invalidate(4,footerStyle=$footerOffset?`transform: translateY(${$footerOffset}px)`:undefined);}};return[isActive,locale,fieldsGroup,tools,footerStyle,iconActiveFraction,animation,imageSize,imageCropRect,imageCropRectAspectRatio,imageCropAspectRatio,imageOutputSize,env,handleFocusIn,handleFocusOut,handleSubmit,formattedResizeSizePresetOptions,formattedResizeSizePresetOptionsFlattened,formattedResizeWidthPresetOptions,formattedResizeWidthPresetOptionsFlattened,formattedResizeHeightPresetOptions,formattedResizeHeightPresetOptionsFlattened,sizePresetSelectedIndex,widthPresetSelectedIndex,heightPresetSelectedIndex,footerOffset,name,stores,resizeMinSize,resizeMaxSize,resizeSizePresetOptions,resizeWidthPresetOptions,resizeHeightPresetOptions,resizeWillRenderFooter,maintainAspectRatio,width,height,activeField,redrawTrigger,$imageCropRectAspectRatio,$formattedResizeSizePresetOptions,$formattedResizeSizePresetOptionsFlattened,$formattedResizeWidthPresetOptions,$formattedResizeWidthPresetOptionsFlattened,$formattedResizeHeightPresetOptions,$formattedResizeHeightPresetOptionsFlattened,sizePresetLabel,$sizePresetSelectedIndex,widthPresetLabel,$widthPresetSelectedIndex,heightPresetLabel,$heightPresetSelectedIndex,$imageCropRect,canRenderSizePresets,canRenderWidthPresets,canRenderHeightPresets,canRenderSizeInputs,$iconActiveFraction,$env,$animation,$isActive,$footerOffset,div0_binding,measure_handler];}class Resize extends SvelteComponent{constructor(options){super();init(this,options,instance$2,create_fragment$2,safe_not_equal,{name:26,isActive:0,stores:27,locale:1,resizeMinSize:28,resizeMaxSize:29,resizeSizePresetOptions:30,resizeWidthPresetOptions:31,resizeHeightPresetOptions:32,resizeWillRenderFooter:33},[-1,-1,-1]);}get name(){return this.$$.ctx[26];}get isActive(){return this.$$.ctx[0];}set isActive(isActive){this.$set({isActive});flush();}get stores(){return this.$$.ctx[27];}set stores(stores){this.$set({stores});flush();}get locale(){return this.$$.ctx[1];}set locale(locale){this.$set({locale});flush();}get resizeMinSize(){return this.$$.ctx[28];}set resizeMinSize(resizeMinSize){this.$set({resizeMinSize});flush();}get resizeMaxSize(){return this.$$.ctx[29];}set resizeMaxSize(resizeMaxSize){this.$set({resizeMaxSize});flush();}get resizeSizePresetOptions(){return this.$$.ctx[30];}set resizeSizePresetOptions(resizeSizePresetOptions){this.$set({resizeSizePresetOptions});flush();}get resizeWidthPresetOptions(){return this.$$.ctx[31];}set resizeWidthPresetOptions(resizeWidthPresetOptions){this.$set({resizeWidthPresetOptions});flush();}get resizeHeightPresetOptions(){return this.$$.ctx[32];}set resizeHeightPresetOptions(resizeHeightPresetOptions){this.$set({resizeHeightPresetOptions});flush();}get resizeWillRenderFooter(){return this.$$.ctx[33];}set resizeWillRenderFooter(resizeWillRenderFooter){this.$set({resizeWillRenderFooter});flush();}}// @ts-ignore
var _plugin_resize={util:['resize',Resize]};/* src/core/ui/plugins/redact/index.svelte generated by Svelte v3.37.0 */function create_fragment$1(ctx){let shapeutil;let current;shapeutil=new ShapeUtil({props:{stores:/*stores*/ctx[3],locale:/*locale*/ctx[4],isActive:/*isActive*/ctx[0],isActiveFraction:/*isActiveFraction*/ctx[1],isVisible:/*isVisible*/ctx[2],mapScreenPointToImagePoint:/*mapScreenPointToImagePoint*/ctx[15],mapImagePointToScreenPoint:/*mapImagePointToScreenPoint*/ctx[16],utilKey:"redact",imageRotation:/*$imageRotation*/ctx[7],imageFlipX:/*$imageFlipX*/ctx[5],imageFlipY:/*$imageFlipY*/ctx[6],shapes:/*imageRedaction*/ctx[8],tools:["rect"],toolShapes:{rectangle:[{x:0,y:0,width:0,height:0}]},toolActive:"rectangle",parentRect:/*imageSize*/ctx[10],enablePresetDropImage:false,enablePresetSelectImage:false,hooks:{willRenderShapeControls:/*func*/ctx[18]}}});shapeutil.$on("measure",/*measure_handler*/ctx[19]);return{c(){create_component(shapeutil.$$.fragment);},m(target,anchor){mount_component(shapeutil,target,anchor);current=true;},p(ctx,[dirty]){const shapeutil_changes={};if(dirty&/*stores*/8)shapeutil_changes.stores=/*stores*/ctx[3];if(dirty&/*locale*/16)shapeutil_changes.locale=/*locale*/ctx[4];if(dirty&/*isActive*/1)shapeutil_changes.isActive=/*isActive*/ctx[0];if(dirty&/*isActiveFraction*/2)shapeutil_changes.isActiveFraction=/*isActiveFraction*/ctx[1];if(dirty&/*isVisible*/4)shapeutil_changes.isVisible=/*isVisible*/ctx[2];if(dirty&/*$imageRotation*/128)shapeutil_changes.imageRotation=/*$imageRotation*/ctx[7];if(dirty&/*$imageFlipX*/32)shapeutil_changes.imageFlipX=/*$imageFlipX*/ctx[5];if(dirty&/*$imageFlipY*/64)shapeutil_changes.imageFlipY=/*$imageFlipY*/ctx[6];shapeutil.$set(shapeutil_changes);},i(local){if(current)return;transition_in(shapeutil.$$.fragment,local);current=true;},o(local){transition_out(shapeutil.$$.fragment,local);current=false;},d(detaching){destroy_component(shapeutil,detaching);}};}function instance$1($$self,$$props,$$invalidate){let $rootRect;let $imageSize;let $imageTransforms;let $imageFlipX;let $imageFlipY;let $imageRotation;const name="redact";let{isActive}=$$props;let{isActiveFraction}=$$props;let{isVisible}=$$props;let{stores}=$$props;let{locale={}}=$$props;// connect filter choice to stores
const{imageRedaction,rootRect,imageSize,imageTransforms,imageRotation,imageFlipX,imageFlipY}=stores;component_subscribe($$self,rootRect,value=>$$invalidate(20,$rootRect=value));component_subscribe($$self,imageSize,value=>$$invalidate(21,$imageSize=value));component_subscribe($$self,imageTransforms,value=>$$invalidate(22,$imageTransforms=value));component_subscribe($$self,imageRotation,value=>$$invalidate(7,$imageRotation=value));component_subscribe($$self,imageFlipX,value=>$$invalidate(5,$imageFlipX=value));component_subscribe($$self,imageFlipY,value=>$$invalidate(6,$imageFlipY=value));//
// Mapping coordinates
//
const mapScreenPointToImagePoint=point=>_mapScreenPointToImagePoint(point,$rootRect,$imageSize,$imageTransforms.origin,$imageTransforms.translation,$imageTransforms.rotation.z,$imageTransforms.scale,$imageFlipX,$imageFlipY);const mapImagePointToScreenPoint=point=>_mapImagePointToScreenPoint(point,$rootRect,$imageSize,$imageTransforms.origin,$imageTransforms.translation,$imageTransforms.rotation.z,$imageTransforms.scale,$imageFlipX,$imageFlipY);const func=controls=>{const children=getNodeChildren(controls[0]);removeNode("to-front",children);return controls;};function measure_handler(event){bubble($$self,event);}$$self.$$set=$$props=>{if("isActive"in $$props)$$invalidate(0,isActive=$$props.isActive);if("isActiveFraction"in $$props)$$invalidate(1,isActiveFraction=$$props.isActiveFraction);if("isVisible"in $$props)$$invalidate(2,isVisible=$$props.isVisible);if("stores"in $$props)$$invalidate(3,stores=$$props.stores);if("locale"in $$props)$$invalidate(4,locale=$$props.locale);};return[isActive,isActiveFraction,isVisible,stores,locale,$imageFlipX,$imageFlipY,$imageRotation,imageRedaction,rootRect,imageSize,imageTransforms,imageRotation,imageFlipX,imageFlipY,mapScreenPointToImagePoint,mapImagePointToScreenPoint,name,func,measure_handler];}class Redact extends SvelteComponent{constructor(options){super();init(this,options,instance$1,create_fragment$1,safe_not_equal,{name:17,isActive:0,isActiveFraction:1,isVisible:2,stores:3,locale:4});}get name(){return this.$$.ctx[17];}get isActive(){return this.$$.ctx[0];}set isActive(isActive){this.$set({isActive});flush();}get isActiveFraction(){return this.$$.ctx[1];}set isActiveFraction(isActiveFraction){this.$set({isActiveFraction});flush();}get isVisible(){return this.$$.ctx[2];}set isVisible(isVisible){this.$set({isVisible});flush();}get stores(){return this.$$.ctx[3];}set stores(stores){this.$set({stores});flush();}get locale(){return this.$$.ctx[4];}set locale(locale){this.$set({locale});flush();}}// @ts-ignore
var _plugin_redact={util:['redact',Redact]};const IconCross='<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M18 6L6 18M6 6l12 12"></path></path></g>';const CharacterA='<path fill="none" d="M9 15 L12 9 L15 15 M10 13.5 h3" stroke="currentColor" stroke-width=".125em"/>';var _locale_en_gb={// generic
labelReset:'Reset',labelDefault:'Default',labelAuto:'Auto',labelNone:'None',labelEdit:'Edit',labelClose:'Close',labelSupportError:features=>`${features.join(', ')} not supported on this browser`,// defaults
labelColor:'Color',labelWidth:'Width',labelSize:'Size',labelOffset:'Offset',labelAmount:'Amount',labelInset:'Inset',labelRadius:'Radius',// sizes
labelSizeExtraSmall:'Extra small',labelSizeSmall:'Small',labelSizeMediumSmall:'Medium small',labelSizeMedium:'Medium',labelSizeMediumLarge:'Medium large',labelSizeLarge:'Large',labelSizeExtraLarge:'Extra large',// unused?
labelButtonRevert:'Revert',labelButtonCancel:'Cancel',labelButtonUndo:'Undo',labelButtonRedo:'Redo',labelButtonExport:'Done',iconSupportError:`<g fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><g><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></g>`,iconButtonClose:IconCross,iconButtonRevert:`<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M7.388 18.538a8 8 0 10-2.992-9.03"/><path fill="currentColor" d="M2.794 11.696L2.37 6.714l5.088 3.18z"/><path d="M12 8v4M12 12l4 2"/></g>`,iconButtonUndo:`<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M10 8h4c2.485 0 5 2 5 5s-2.515 5-5 5h-4"/><path fill="currentColor" d="M5 8l4-3v6z"/></g>`,iconButtonRedo:`<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M14 8h-4c-2.485 0-5 2-5 5s2.515 5 5 5h4"/><path fill="currentColor" d="M19 8l-4-3v6z"/></g>`,iconButtonExport:`<polyline points="20 6 9 17 4 12" fill="none" stroke="currentColor" stroke-width=".125em"></polyline>`,// status
statusLabelButtonClose:'Close',statusIconButtonClose:IconCross,statusLabelLoadImage:state=>{if(!state||!state.task)return'Waiting for image';if(state.error)return state.error.code==='IMAGE_TOO_SMALL'?'Minimum image size is {minWidth} × {minHeight}':'Error loading image';if(state.task==='blob-to-bitmap')return'Creating preview…';return'Loading image…';},// processing status message
statusLabelProcessImage:state=>{if(!state||!state.task)return undefined;if(state.task==='store'){if(state.error)return'Error uploading image';return'Uploading image…';}if(state.error)return'Error processing image';return'Processing image…';}};const MarkupEditor={shapeLabelButtonSelectSticker:'Select image',shapeIconButtonSelectSticker:`<g fill="none" stroke="currentColor" stroke-width="0.0625em"><path d="M8 21 L15 11 L19 15"/><path d="M15 2 v5 h5"/><path d="M8 2 h8 l4 4 v12 q0 4 -4 4 h-8 q-4 0 -4 -4 v-12 q0 -4 4 -4z"/></g><circle fill="currentColor" cx="10" cy="8" r="1.5"/>`,shapeIconButtonFlipHorizontal:`<g stroke="currentColor" stroke-width=".125em"><path fill="none" d="M6 6.5h5v11H6z"/><path fill="currentColor" d="M15 6.5h3v11h-3z"/><path d="M11 4v16" fill="currentColor"/></g>`,shapeIconButtonFlipVertical:`<g stroke="currentColor" stroke-width=".125em"><rect x="7" y="8" width="11" height="5" fill="none"/><rect x="7" y="17" width="11" height="2" fill="currentColor"/><line x1="5" y1="13" x2="20" y2="13"/></g>`,shapeIconButtonRemove:`<g fill="none" fill-rule="evenodd"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M7.5 7h9z"/><path d="M7.916 9h8.168a1 1 0 01.99 1.14l-.972 6.862a2 2 0 01-1.473 1.653c-.877.23-1.753.345-2.629.345-.876 0-1.752-.115-2.628-.345a2 2 0 01-1.473-1.653l-.973-6.862A1 1 0 017.916 9z" fill="currentColor"/><rect fill="currentColor" x="10" y="5" width="4" height="3" rx="1"/></g>`,shapeIconButtonDuplicate:`<g fill="none" fill-rule="evenodd"><path d="M15 13.994V16a2 2 0 01-2 2H8a2 2 0 01-2-2v-5a2 2 0 012-2h2.142" stroke="currentColor" stroke-width=".125em"/><path d="M15 9V8a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2h-1zm-4-4h6a2 2 0 012 2v6a2 2 0 01-2 2h-6a2 2 0 01-2-2V7a2 2 0 012-2z" fill="currentColor"/></g>`,shapeIconButtonMoveToFront:`<g fill="none" fill-rule="evenodd"><rect fill="currentColor" x="11" y="13" width="8" height="2" rx="1"/><rect fill="currentColor" x="9" y="17" width="10" height="2" rx="1"/><path d="M11.364 8H10a5 5 0 000 10M12 6.5L14.5 8 12 9.5z" stroke="currentColor" stroke-width=".125em" stroke-linecap="round"/></g>`,shapeIconButtonTextLayoutAutoWidth:`${CharacterA}`,shapeIconButtonTextLayoutAutoHeight:`<g fill="currentColor"><circle cx="4" cy="12" r="1.5"/><circle cx="20" cy="12" r="1.5"/></g>${CharacterA}`,shapeIconButtonTextLayoutFixedSize:`<g fill="currentColor"><circle cx="5" cy="6" r="1.5"/><circle cx="19" cy="6" r="1.5"/><circle cx="19" cy="19" r="1.5"/><circle cx="5" cy="19" r="1.5"/></g>${CharacterA}`,shapeTitleButtonTextLayoutAutoWidth:'Auto width',shapeTitleButtonTextLayoutAutoHeight:'Auto height',shapeTitleButtonTextLayoutFixedSize:'Fixed size',shapeTitleButtonFlipHorizontal:'Flip Horizontal',shapeTitleButtonFlipVertical:'Flip Vertical',shapeTitleButtonRemove:'Remove',shapeTitleButtonDuplicate:'Duplicate',shapeTitleButtonMoveToFront:'Move to front',shapeLabelInputText:'Edit text',shapeIconInputCancel:`<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M18 6L6 18M6 6l12 12"/></g>`,shapeIconInputConfirm:`<g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><polyline points="20 6 9 17 4 12"/></g>`,shapeLabelInputCancel:'Cancel',shapeLabelInputConfirm:'Confirm',shapeLabelStrokeNone:'No outline',shapeLabelFontStyleNormal:'Normal',shapeLabelFontStyleBold:'Bold',shapeLabelFontStyleItalic:'Italic',shapeLabelFontStyleItalicBold:'Bold Italic',shapeTitleBackgroundColor:'Fill color',shapeTitleFontFamily:'Font',shapeTitleFontSize:'Font size',shapeTitleFontStyle:'Font style',shapeTitleLineHeight:'Leading',shapeTitleLineStart:'Start',shapeTitleLineEnd:'End',shapeTitleStrokeWidth:'Line width',shapeTitleStrokeColor:'Line color',shapeTitleLineDecorationBar:'Bar',shapeTitleLineDecorationCircle:'Circle',shapeTitleLineDecorationSquare:'Square',shapeTitleLineDecorationArrow:'Arrow',shapeTitleLineDecorationCircleSolid:'Circle solid',shapeTitleLineDecorationSquareSolid:'Square solid',shapeTitleLineDecorationArrowSolid:'Arrow solid',shapeIconLineDecorationBar:`<g stroke="currentColor" stroke-linecap="round" stroke-width=".125em"><path d="M5,12 H16"/><path d="M16,8 V16"/></g>`,shapeIconLineDecorationCircle:`<g stroke="currentColor" stroke-linecap="round"><path stroke-width=".125em" d="M5,12 H12"/><circle fill="none" stroke-width=".125em" cx="16" cy="12" r="4"/></g>`,shapeIconLineDecorationSquare:`<g stroke="currentColor" stroke-linecap="round"><path stroke-width=".125em" d="M5,12 H12"/><rect fill="none" stroke-width=".125em" x="12" y="8" width="8" height="8"/></g>`,shapeIconLineDecorationArrow:`<g stroke="currentColor" stroke-linecap="round" stroke-width=".125em"><path d="M5,12 H16 M13,7 l6,5 l-6,5" fill="none"/></g>`,shapeIconLineDecorationCircleSolid:`<g stroke="currentColor" stroke-linecap="round"><path stroke-width=".125em" d="M5,12 H12"/><circle fill="currentColor" cx="16" cy="12" r="4"/></g>`,shapeIconLineDecorationSquareSolid:`<g stroke="currentColor" stroke-linecap="round"><path stroke-width=".125em" d="M5,12 H12"/><rect fill="currentColor" x="12" y="8" width="8" height="8"/></g>`,shapeIconLineDecorationArrowSolid:`<g stroke="currentColor" stroke-linecap="round" stroke-width=".125em"><path d="M5,12 H16"/><path d="M13,7 l6,5 l-6,5z" fill="currentColor"/></g>`,shapeTitleColorTransparent:'Transparent',shapeTitleColorWhite:'White',shapeTitleColorSilver:'Silver',shapeTitleColorGray:'Gray',shapeTitleColorBlack:'Black',shapeTitleColorNavy:'Navy',shapeTitleColorBlue:'Blue',shapeTitleColorAqua:'Aqua',shapeTitleColorTeal:'Teal',shapeTitleColorOlive:'Olive',shapeTitleColorGreen:'Green',shapeTitleColorYellow:'Yellow',shapeTitleColorOrange:'Orange',shapeTitleColorRed:'Red',shapeTitleColorMaroon:'Maroon',shapeTitleColorFuchsia:'Fuchsia',shapeTitleColorPurple:'Purple',shapeTitleTextColor:'Font color',shapeTitleTextAlign:'Text align',shapeTitleTextAlignLeft:'Left align text',shapeTitleTextAlignCenter:'Center align text',shapeTitleTextAlignRight:'Right align text',shapeIconTextAlignLeft:`<g stroke-width=".125em" stroke="currentColor"><line x1="5" y1="8" x2="15" y2="8"/><line x1="5" y1="12" x2="19" y2="12"/><line x1="5" y1="16" x2="14" y2="16"/></g>`,shapeIconTextAlignCenter:`<g stroke-width=".125em" stroke="currentColor"><line x1="7" y1="8" x2="17" y2="8"/><line x1="5" y1="12" x2="19" y2="12"/><line x1="8" y1="16" x2="16" y2="16"/></g>`,shapeIconTextAlignRight:`<g stroke-width=".125em" stroke="currentColor"><line x1="9" y1="8" x2="19" y2="8"/><line x1="5" y1="12" x2="19" y2="12"/><line x1="11" y1="16" x2="19" y2="16"/></g>`,shapeLabelToolSharpie:'Sharpie',shapeLabelToolEraser:'Eraser',shapeLabelToolRectangle:'Rectangle',shapeLabelToolEllipse:'Ellipse',shapeLabelToolArrow:'Arrow',shapeLabelToolLine:'Line',shapeLabelToolText:'Text',shapeLabelToolPreset:'Stickers',shapeIconToolSharpie:`<g stroke-width=".125em" stroke="currentColor" fill="none"><path d="M2.025 5c5.616-2.732 8.833-3.857 9.65-3.374C12.903 2.351.518 12.666 2.026 14 3.534 15.334 16.536.566 17.73 2.566 18.924 4.566 3.98 17.187 4.831 18c.851.813 9.848-6 11.643-6 1.087 0-2.53 5.11-2.92 7-.086.41 3.323-1.498 4.773-1 .494.17.64 2.317 1.319 3 .439.443 1.332.776 2.679 1" stroke="currentColor" stroke-width=".125em" fill="none" fill-rule="evenodd" stroke-linejoin="round"/></g>`,shapeIconToolEraser:`<g stroke-width=".125em" stroke="currentColor" stroke-linecap="round" fill="none"><g transform="translate(3, 15) rotate(-45)"><rect x="0" y="0" width="18" height="10" rx="3"/></g><line x1="11" y1="21" x2="18" y2="21"/><line x1="20" y1="21" x2="22" y2="21"/></g>`,shapeIconToolRectangle:`<g stroke-width=".125em" stroke="currentColor" fill="none"><rect x="2" y="2" width="20" height="20" rx="3"/></g>`,shapeIconToolEllipse:`<g stroke-width=".125em" stroke="currentColor" fill="none"><circle cx="12" cy="12" r="11"/></g>`,shapeIconToolArrow:`<g stroke-width=".125em" stroke="currentColor" fill="none"><line x1="20" y1="3" x2="6" y2="21"/><path d="m10 5 L22 1 L21 13" fill="currentColor" stroke="none"/></g>`,shapeIconToolLine:`<g stroke-width=".125em" stroke="currentColor" fill="none"><line x1="20" y1="3" x2="6" y2="21"/></g>`,shapeIconToolText:`<g stroke="none" fill="currentColor" transform="translate(6,0)"><path d="M8.14 20.085c.459 0 .901-.034 1.329-.102a8.597 8.597 0 001.015-.21v1.984c-.281.135-.695.247-1.242.336a9.328 9.328 0 01-1.477.133c-3.312 0-4.968-1.745-4.968-5.235V6.804H.344v-1.25l2.453-1.078L3.89.819h1.5v3.97h4.97v2.015H5.39v10.078c0 1.031.245 1.823.735 2.375s1.161.828 2.015.828z"/>`,shapeIconToolPreset:`<g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M12 22c2.773 0 1.189-5.177 3-7 1.796-1.808 7-.25 7-3 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10z"></path><path d="M20 17c-3 3-5 5-8 5"></path></g>`};var _plugin_crop_locale_en_gb={cropLabel:'Crop',cropIcon:'<g stroke-width=".125em" stroke="currentColor" fill="none"><path d="M23 17H9a2 2 0 0 1-2-2v-5m0-3V1 M1 7h14a2 2 0 0 1 2 2v7m0 4v3"/></g>',cropIconButtonRecenter:`<path stroke="currentColor" fill="none" stroke-width="2" stroke-linejoin="bevel" d="M1.5 7.5v-6h6M1.5 16.5v6h6M22.5 16.5v6h-6M22.5 7.5v-6h-6"/><circle cx="12" cy="12" r="3.5" fill="currentColor" stroke="none"/>`,cropIconButtonRotateLeft:'<g stroke="none" fill="currentColor"><path fill="none" d="M-1-1h582v402H-1z"/><rect x="3" rx="1" height="12" width="12" y="9"/><path d="M15 5h-1a5 5 0 015 5 1 1 0 002 0 7 7 0 00-7-7h-1.374l.747-.747A1 1 0 0011.958.84L9.603 3.194a1 1 0 000 1.415l2.355 2.355a1 1 0 001.415-1.414l-.55-.55H15z"/></g>',cropIconButtonRotateRight:'<g stroke="none" fill="currentColor"><path fill="none" d="M-1-1h582v402H-1z"/><path d="M11.177 5H10a5 5 0 00-5 5 1 1 0 01-2 0 7 7 0 017-7h1.374l-.747-.747A1 1 0 0112.042.84l2.355 2.355a1 1 0 010 1.415l-2.355 2.354a1 1 0 01-1.415-1.414l.55-.55z"/><rect rx="1" height="12" width="12" y="9" x="9"/></g>',cropIconButtonFlipVertical:'<g stroke="none" fill="currentColor"><path d="M19.993 12.143H7a1 1 0 0 1-1-1V5.994a1 1 0 0 1 1.368-.93l12.993 5.15a1 1 0 0 1-.368 1.93z"/><path d="M19.993 14a1 1 0 0 1 .368 1.93L7.368 21.078A1 1 0 0 1 6 20.148V15a1 1 0 0 1 1-1h12.993z" opacity=".6"/></g>',cropIconButtonFlipHorizontal:'<g stroke="none" fill="currentColor"><path d="M11.93 7.007V20a1 1 0 0 1-1 1H5.78a1 1 0 0 1-.93-1.368l5.15-12.993a1 1 0 0 1 1.929.368z"/><path d="M14 7.007V20a1 1 0 0 0 1 1h5.149a1 1 0 0 0 .93-1.368l-5.15-12.993A1 1 0 0 0 14 7.007z" opacity=".6"/></g>',cropIconSelectPreset:(locale,aspectRatio)=>{const[a,b,c]=!aspectRatio?[0.2,0.3,0.4]:[aspectRatio<1?1:0.3,aspectRatio===1?0.85:0.5,aspectRatio>1?1:0.3];return`<g fill="currentColor">
            <rect opacity="${a}" x="2" y="4" width="10" height="18" rx="1"/>
            <rect opacity="${b}" x="4" y="8" width="14" height="14" rx="1"/>
            <rect opacity="${c}" x="6" y="12" width="17" height="10" rx="1"/>
        </g>`;},cropIconCropBoundary:(locale,isBoundToImage)=>{const[a,b,c,d]=isBoundToImage?[0.3,1,0,0]:[0,0,0.3,1];return`<g fill="currentColor">
            <rect opacity="${a}" x="2" y="3" width="20" height="20" rx="1"/>
            <rect opacity="${b}" x="7" y="8" width="10" height="10" rx="1"/>
            <rect opacity="${c}" x="4" y="8" width="14" height="14" rx="1"/>
            <rect opacity="${d}" x="12" y="4" width="10" height="10" rx="1"/>
        </g>`;},cropLabelButtonRecenter:'Recenter',cropLabelButtonRotateLeft:'Rotate left',cropLabelButtonRotateRight:'Rotate right',cropLabelButtonFlipHorizontal:'Flip horizontal',cropLabelButtonFlipVertical:'Flip vertical',cropLabelSelectPreset:'Crop shape',cropLabelCropBoundary:'Crop boundary',cropLabelCropBoundaryEdge:'Edge of image',cropLabelCropBoundaryNone:'None',cropLabelTabRotation:'Rotation',cropLabelTabZoom:'Zoom'};var _plugin_filter_locale_en_gb={filterLabel:'Filter',filterIcon:'<g stroke-width=".125em" stroke="currentColor" fill="none"><path d="M18.347 9.907a6.5 6.5 0 1 0-1.872 3.306M3.26 11.574a6.5 6.5 0 1 0 2.815-1.417 M10.15 17.897A6.503 6.503 0 0 0 16.5 23a6.5 6.5 0 1 0-6.183-8.51"/></g>',filterLabelChrome:'Chrome',filterLabelFade:'Fade',filterLabelCold:'Cold',filterLabelWarm:'Warm',filterLabelPastel:'Pastel',filterLabelMonoDefault:'Mono',filterLabelMonoNoir:'Noir',filterLabelMonoWash:'Wash',filterLabelMonoStark:'Stark',filterLabelSepiaDefault:'Sepia',filterLabelSepiaBlues:'Blues',filterLabelSepiaRust:'Rust',filterLabelSepiaColor:'Color'};var _plugin_finetune_locale_en_gb={finetuneLabel:'Finetune',finetuneIcon:'<g stroke-width=".125em" stroke="currentColor" fill="none"><path d="M4 1v5.5m0 3.503V23M12 1v10.5m0 3.5v8M20 1v15.5m0 3.5v3M2 7h4M10 12h4M18 17h4"/></g>',finetuneLabelBrightness:'Brightness',finetuneLabelContrast:'Contrast',finetuneLabelSaturation:'Saturation',finetuneLabelExposure:'Exposure',finetuneLabelTemperature:'Temperature',finetuneLabelGamma:'Gamma',finetuneLabelClarity:'Clarity',finetuneLabelVignette:'Vignette'};var _plugin_resize_locale_en_gb={resizeLabel:'Resize',resizeIcon:'<g stroke-width=".125em" stroke="currentColor" fill="none"><rect x="2" y="12" width="10" height="10" rx="2"/><path d="M4 11.5V4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5"/><path d="M14 10l3.365-3.365M14 6h4v4"/></g>',resizeLabelFormCaption:'Image output size',resizeLabelInputWidth:'w',resizeTitleInputWidth:'Width',resizeLabelInputHeight:'h',resizeTitleInputHeight:'Height',resizeTitleButtonMaintainAspectRatio:'Maintain aspectratio',resizeIconButtonMaintainAspectRatio:(active,activeFraction)=>`
        <defs>
            <mask id="mask1" x="0" y="0" width="24" height="24" >
                <rect x="0" y="0" width="24" height="10" fill="#fff" stroke="none"/>
            </mask>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <g  mask="url(#mask1)">
                <path transform="translate(0 ${(activeFraction-1)*3})" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" d="M9.401 10.205v-.804a2.599 2.599 0 0 1 5.198 0V17"/>
            </g>
            <rect fill="currentColor" x="7" y="10" width="10" height="7" rx="1.5"/>
        </g>
    `};var _plugin_decorate_locale_en_gb={decorateLabel:'Decorate',decorateIcon:'<g fill="none" fill-rule="evenodd"><path stroke="currentColor" stroke-width=".125em" stroke-linecap="round" stroke-linejoin="round" d="M12 18.5l-6.466 3.4 1.235-7.2-5.23-5.1 7.228-1.05L12 2l3.233 6.55 7.229 1.05-5.231 5.1 1.235 7.2z"/></g>'};var _plugin_annotate_locale_en_gb={annotateLabel:'Annotate',annotateIcon:'<g stroke-width=".125em" stroke="currentColor" fill="none"><path d="M17.086 2.914a2.828 2.828 0 1 1 4 4l-14.5 14.5-5.5 1.5 1.5-5.5 14.5-14.5z"/></g>'};var _plugin_sticker_locale_en_gb={stickerLabel:'Sticker',stickerIcon:'<g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M12 22c2.773 0 1.189-5.177 3-7 1.796-1.808 7-.25 7-3 0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10z"/><path d="M20 17c-3 3-5 5-8 5"/></g>'};var _plugin_frame_locale_en_gb={frameLabel:'Frame',frameIcon:`<g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em">
            <rect x="2" y="2" width="20" height="20" rx="4"/>
            <rect x="6" y="6" width="12" height="12" rx="1"/>
        </g>`,frameLabelMatSharp:'Mat',frameLabelMatRound:'Bevel',frameLabelLineSingle:'Line',frameLabelLineMultiple:'Zebra',frameLabelEdgeSeparate:'Inset',frameLabelEdgeOverlap:'Plus',frameLabelEdgeCross:'Lumber',frameLabelCornerHooks:'Hook',frameLabelPolaroid:'Polaroid'};var _plugin_redact_locale_en_gb={redactLabel:'Redact',redactIcon:`<g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em">

        <path d="M 2 7 l 0.1 -.1"/>
        <path d="M 2 12 l 5 -5"/>
        <path d="M 2 17 l 10 -10"/>
        <path d="M 7 17 l 10 -10"/>
        <path d="M 12 17 l 10 -10"/>
        <path d="M 17 17 l 5 -5"/>
        <path d="M 22 17 l .1 -.1"/>

    </g>`};var hasDefinedCustomElement=name=>document.createElement(name).constructor!==HTMLElement;var linkAccessors=(destination,origin)=>{const descriptors=Object.getOwnPropertyDescriptors(destination);Object.keys(descriptors).forEach(key=>{// props, set new setter and getter
if(!!descriptors[key]['get']){Object.defineProperty(origin,key,{get:()=>destination[key],set:value=>destination[key]=value});}// method, copy reference
else{origin[key]=destination[key];}});};var hasDoctype=()=>isBrowser()&&document.doctype!==null;var initEditorView=target=>{const accessors={};const{sub,pub}=pubsub();// catch missing doctype
if(!hasDoctype())console.warn('Browser is in quirks mode, add <!DOCTYPE html> to page to fix render issues');// create editor core
const core=createImageEditor();linkAccessors(core,accessors);// create editor view
const view=attachEditorView(target,core.stores);linkAccessors(view,accessors);// listen for UI interaction and link to editor API (internals)
const unsubs=['loadImage','processImage','abortProcessImage','abortLoadImage'].map(event=>view.on(event,e=>{// run core method, if returns a promise, we silence errors as those are passed to the UI via stores
const returned=core[event](e&&e.detail);if(returned instanceof Promise)returned.catch(()=>{});}));// auto subscribes on each possible publisher
const subscribe=(event,cb)=>{const unsubInit=sub(event,cb);const unsubCore=core.on(event,cb);const unsubView=view.on(event,cb);return()=>{unsubInit();unsubCore();unsubView();};};// handles every event, useful for routing events from the options object
accessors.handleEvent=noop$1;const handleEventUnsubs=editorEvents.map(type=>subscribe(type,res=>accessors.handleEvent(type,res)));// set up new api
defineMethods(accessors,{on:subscribe,updateImage:src=>new Promise((resolve,reject)=>{// save history
const storedHistory=accessors.history.get();// save state
const storedState=accessors.imageState;// update image
core.loadImage(src).then(res=>{// restore history
accessors.history.set(storedHistory);// restore state
accessors.imageState=storedState;// done!
resolve(res);}).catch(reject);}),close:()=>{pub('close');},destroy:()=>{// unsub
[...unsubs,...handleEventUnsubs].forEach(unsub=>unsub());// destroy
view.destroy();core.destroy();// destroyed
pub('destroy');}});return accessors;};const TAG='pintura-editor';var _defineCustomElements=()=>new Promise(resolve=>{if(!PinturaImageEditorElement)return resolve([]);!hasDefinedCustomElement(TAG)&&customElements.define(TAG,PinturaImageEditorElement);customElements.whenDefined(TAG).then(()=>resolve(document.querySelectorAll(TAG)));});const PinturaImageEditorElement=isBrowser()&&class extends HTMLElement{constructor(){super();this._editor=undefined;this._unsubs=undefined;}static get observedAttributes(){return['src'];}attributeChangedCallback(attrName,oldValue,newValue){this[attrName]=newValue;}connectedCallback(){this._editor=initEditorView(this);linkAccessors(this._editor,this);this._editor.src=this.getAttribute('src');this._unsubs=dispatchEditorEvents(this._editor,this);}disconnectedCallback(){this._editor.destroy();this._unsubs.forEach(unsub=>unsub());}};const CSS_CLASS_NAME='pintura-editor';var _appendEditor=(target,options={})=>{const element=pintura_isString(target)?document.querySelector(target):target;if(!pintura_isElement(element))return undefined;options.class=options.class?`${CSS_CLASS_NAME} ${options.class}`:CSS_CLASS_NAME;const accessors=initEditorView(element);return Object.assign(accessors,options);};/* src/core/ui/modal/index.svelte generated by Svelte v3.37.0 */const{document:document_1,window:window_1}=globals;function create_fragment(ctx){let t;let div;let mounted;let dispose;add_render_callback(/*onwindowresize*/ctx[27]);return{c(){t=space();div=pintura_element("div");attr(div,"class",/*className*/ctx[5]);attr(div,"style",/*style*/ctx[4]);},m(target,anchor){insert(target,t,anchor);insert(target,div,anchor);/*div_binding*/ctx[28](div);if(!mounted){dispose=[listen(window_1,"keydown",/*handleKey*/ctx[10]),listen(window_1,"orientationchange",/*spawnMeasureElement*/ctx[11]),listen(window_1,"resize",/*onwindowresize*/ctx[27]),listen(document_1.body,"focusin",function(){if(is_function(!/*hidden*/ctx[1]&&/*handleFocusIn*/ctx[7]))(!/*hidden*/ctx[1]&&/*handleFocusIn*/ctx[7]).apply(this,arguments);}),listen(document_1.body,"focusout",function(){if(is_function(/*hasFocussedTextField*/ctx[2]&&/*handleFocusOut*/ctx[8]))(/*hasFocussedTextField*/ctx[2]&&/*handleFocusOut*/ctx[8]).apply(this,arguments);}),listen(div,"wheel",/*handleWheel*/ctx[9],{passive:false})];mounted=true;}},p(new_ctx,dirty){ctx=new_ctx;if(dirty[0]&/*className*/32){attr(div,"class",/*className*/ctx[5]);}if(dirty[0]&/*style*/16){attr(div,"style",/*style*/ctx[4]);}},i:pintura_noop,o:pintura_noop,d(detaching){if(detaching)detach(t);if(detaching)detach(div);/*div_binding*/ctx[28](null);mounted=false;run_all(dispose);}};}function instance($$self,$$props,$$invalidate){let o;let viewportRules;let isOpaque;let isIOSFooterVisible;let style;let className;let scrollsBodyOnInteraction;let $opacity;const dispatch=createEventDispatcher();let{root}=$$props;let{preventZoomViewport=true}=$$props;let{preventScrollBodyIfNeeded=true}=$$props;let{preventFooterOverlapIfNeeded=true}=$$props;let{class:klass=undefined}=$$props;let hidden=true;let hiding=false;let showing=false;let doc=isBrowser()&&document.documentElement;let body=isBrowser()&&document.body;let head=isBrowser()&&document.head;const opacity=spring(0,{precision:0.001,damping:0.5});component_subscribe($$self,opacity,value=>$$invalidate(23,$opacity=value));// animate hide and show
const unsub=opacity.subscribe(o=>{if(showing&&o>=1){$$invalidate(19,showing=false);// now shown
$$invalidate(1,hidden=false);dispatch("show");}else if(hiding&&o<=0){$$invalidate(18,hiding=false);// now hidden
$$invalidate(1,hidden=true);dispatch("hide");}});// clean up when removed
onDestroy(()=>{// make sure no longer locking body element
doc.classList.remove("PinturaModalBodyLock");// clean up subs
unsub();});let hasFocussedTextField=false;let viewportDefaults=undefined;let themeDefaults=undefined;let showTimeoutId=undefined;const getViewPortElement=()=>document.querySelector("meta[name=viewport]");const getThemeElements=()=>Array.from(document.querySelectorAll("meta[name=theme-color]"));const show=()=>{// is visible, or busy becoming visible
if(showing||!hidden)return;// now in 'showing' transition
$$invalidate(19,showing=true);// store default viewport element values
const viewportElement=getViewPortElement()||h("meta",{name:"viewport"});viewportDefaults=!viewportDefaults&&viewportElement.getAttribute("content");viewportElement.setAttribute("content",viewportRules+(/cover/.test(viewportDefaults)?",viewport-fit=cover":""));if(!viewportElement.parentNode)head.append(viewportElement);// store default theme element values
const backgroundColor=getComputedStyle(root).getPropertyValue("--color-background");const themeElements=getThemeElements();if(themeElements.length){// store defaults
themeDefaults=themeElements.map(element=>element.getAttribute("content"));}else{// create element
const themeElement=h("meta",{name:"theme-color"});head.append(themeElement);themeElements.push(themeElement);}// update colors
themeElements.forEach(element=>element.setAttribute("content",`rgb(${backgroundColor})`));clearTimeout(showTimeoutId);showTimeoutId=setTimeout(()=>opacity.set(1),250);};const hide=()=>{// is hiding or already hidden
if(hiding||hidden)return;// if previous command was show, we need to prevent the timeout from kicking off
clearTimeout(showTimeoutId);// now in 'hiding' transition
$$invalidate(18,hiding=true);// get a reference to the viewport element, it should be there as we created it earlier,
// we restore defaults if the viewport metatag was defined, if not, we destroy it
const viewportElement=getViewPortElement();if(viewportDefaults)viewportElement.setAttribute("content",viewportDefaults);else viewportElement.remove();// restore colors
const themeElements=getThemeElements();if(themeDefaults){themeElements.forEach((element,index)=>{element.setAttribute("content",themeDefaults[index]);});}else themeElements.forEach(element=>element.remove());// let's hide!
opacity.set(0);};//
// handle soft keyboard impact on window height
//
let focusOutTimer;let focusInWindowHeight;const handleFocusIn=e=>{// test if is text input element
if(!/textarea/i.test(e.target))return;// now focussing a field
$$invalidate(2,hasFocussedTextField=true);focusInWindowHeight=windowHeight;};const handleFocusOut=e=>{// test if is text input element
if(!/textarea/i.test(e.target))return;// prevent accidentally setting two timers
clearTimeout(focusOutTimer);// test if window height changed, if not, no soft keyboard appeared and we can set false to focus state immidiately
if(focusInWindowHeight===windowHeight){$$invalidate(2,hasFocussedTextField=false);}else// soft keyboard might have appeared, test for window height change before setting unfocus state
{const windowCurrentHeight=windowHeight;runWhen(()=>windowHeight!==windowCurrentHeight,()=>$$invalidate(2,hasFocussedTextField=false));}};const runWhen=(test,cb)=>{const frame=()=>{if(test()){cb();return;}requestAnimationFrame(frame);};requestAnimationFrame(frame);};//
// end soft keyboard logic
//
// prevent mousewheel from scrolling content behind modal
const handleWheel=e=>e.preventDefault();// handle escape to close modal
const handleKey=e=>{// get key type
const{key}=e;// only deal with escape key
if(!/escape/i.test(key))return;// don't close when in an input or textuarea
const targetElement=e.target;if(targetElement&&/input|textarea/i.test(targetElement.nodeName))return;// only close if I'm the top modal
const modals=document.querySelectorAll(".PinturaModal");if(modals[modals.length-1]!==root)return;// request close
dispatch("close");};// this logic scales modal to fit viewport height
let windowHeight=0;let windowHeightComputed;// iOS measure actual page height so we can make optional use of available space
let measureElement;let measureElementHeight=undefined;const spawnMeasureElement=()=>{// can't spawn more than one
if(measureElement)return;// create measure element and append to body
measureElement=h("div",{style:"position:fixed;height:100vh;top:0"});body.append(measureElement);};onMount(()=>{// no need to run this logic if is not on iOS
if(!preventFooterOverlapIfNeeded||!isIOS())return;// will be used in first read to determine page height and bottom padding
spawnMeasureElement();});afterUpdate(()=>{// will only run on iOS
if(!measureElement)return;// get height and store
$$invalidate(21,measureElementHeight=measureElement.offsetHeight);// remove measure element
measureElement.remove();measureElement=undefined;});//
// document lock style for iOS 15.0
//
let scrollOffsetY=undefined;// syncs height of doc lock with window
const syncHeight=()=>doc.style.setProperty("--pintura-document-height",`${window.innerHeight}px`);const toggleDocumentLock=isOpaque=>{if(isOpaque){scrollOffsetY=window.scrollY;// prevents safari on iOS 15.0 from scrolling body and showing footer on drag interaction
doc.classList.add("PinturaDocumentLock");// need to do this to sync height of initial window
syncHeight();// also sync on resize
window.addEventListener("resize",syncHeight);}else{// stop syncing height
window.removeEventListener("resize",syncHeight);// clean up
doc.classList.remove("PinturaDocumentLock");pintura_isNumber(scrollOffsetY)&&window.scrollTo(0,scrollOffsetY);scrollOffsetY=undefined;}};function onwindowresize(){$$invalidate(3,windowHeight=window_1.innerHeight);}function div_binding($$value){binding_callbacks[$$value?"unshift":"push"](()=>{root=$$value;$$invalidate(0,root);});}$$self.$$set=$$props=>{if("root"in $$props)$$invalidate(0,root=$$props.root);if("preventZoomViewport"in $$props)$$invalidate(12,preventZoomViewport=$$props.preventZoomViewport);if("preventScrollBodyIfNeeded"in $$props)$$invalidate(13,preventScrollBodyIfNeeded=$$props.preventScrollBodyIfNeeded);if("preventFooterOverlapIfNeeded"in $$props)$$invalidate(14,preventFooterOverlapIfNeeded=$$props.preventFooterOverlapIfNeeded);if("class"in $$props)$$invalidate(15,klass=$$props.class);};$$self.$$.update=()=>{if($$self.$$.dirty[0]&/*showing, hiding, $opacity, hidden*/9175042){$$invalidate(22,o=showing||hiding?$opacity:hidden?0:1);}if($$self.$$.dirty[0]&/*preventZoomViewport*/4096){viewportRules="width=device-width,height=device-height,initial-scale=1"+(preventZoomViewport?",maximum-scale=1,user-scalable=0":"");}if($$self.$$.dirty[0]&/*showing, hidden, hiding*/786434){$$invalidate(24,isOpaque=!showing&&!hidden&&!hiding);}if($$self.$$.dirty[0]&/*hasFocussedTextField, windowHeight*/12){if(!hasFocussedTextField)$$invalidate(20,windowHeightComputed=windowHeight);}if($$self.$$.dirty[0]&/*measureElementHeight, windowHeight*/2097160){$$invalidate(25,isIOSFooterVisible=pintura_isNumber(measureElementHeight)?`--viewport-pad-footer:${measureElementHeight>windowHeight?0:1}`:"");}if($$self.$$.dirty[0]&/*o, windowHeightComputed, isIOSFooterVisible*/38797312){$$invalidate(4,style=`opacity:${o};height:${windowHeightComputed}px;--editor-modal:1;${isIOSFooterVisible}`);}if($$self.$$.dirty[0]&/*klass*/32768){$$invalidate(5,className=arrayJoin(["pintura-editor","PinturaModal",klass]));}if($$self.$$.dirty[0]&/*preventScrollBodyIfNeeded*/8192){$$invalidate(26,scrollsBodyOnInteraction=preventScrollBodyIfNeeded&&isIOS()&&/15_/.test(navigator.userAgent));}if($$self.$$.dirty[0]&/*scrollsBodyOnInteraction, isOpaque*/83886080){scrollsBodyOnInteraction&&toggleDocumentLock(isOpaque);}};return[root,hidden,hasFocussedTextField,windowHeight,style,className,opacity,handleFocusIn,handleFocusOut,handleWheel,handleKey,spawnMeasureElement,preventZoomViewport,preventScrollBodyIfNeeded,preventFooterOverlapIfNeeded,klass,show,hide,hiding,showing,windowHeightComputed,measureElementHeight,o,$opacity,isOpaque,isIOSFooterVisible,scrollsBodyOnInteraction,onwindowresize,div_binding];}class Modal extends SvelteComponent{constructor(options){super();init(this,options,instance,create_fragment,safe_not_equal,{root:0,preventZoomViewport:12,preventScrollBodyIfNeeded:13,preventFooterOverlapIfNeeded:14,class:15,show:16,hide:17},[-1,-1]);}get root(){return this.$$.ctx[0];}set root(root){this.$set({root});flush();}get preventZoomViewport(){return this.$$.ctx[12];}set preventZoomViewport(preventZoomViewport){this.$set({preventZoomViewport});flush();}get preventScrollBodyIfNeeded(){return this.$$.ctx[13];}set preventScrollBodyIfNeeded(preventScrollBodyIfNeeded){this.$set({preventScrollBodyIfNeeded});flush();}get preventFooterOverlapIfNeeded(){return this.$$.ctx[14];}set preventFooterOverlapIfNeeded(preventFooterOverlapIfNeeded){this.$set({preventFooterOverlapIfNeeded});flush();}get class(){return this.$$.ctx[15];}set class(klass){this.$set({class:klass});flush();}get show(){return this.$$.ctx[16];}get hide(){return this.$$.ctx[17];}}// @ts-ignore
// we export a function that renders the view as to not export svelte component related code to outside the ui dir
var createModal=(options={},parent)=>new Modal({target:parent||document.body,props:{class:options.class,preventZoomViewport:options.preventZoomViewport,preventScrollBodyIfNeeded:options.preventScrollBodyIfNeeded,preventFooterOverlapIfNeeded:options.preventFooterOverlapIfNeeded}});var _openEditor=(options={},parent)=>{// set up pub/sub for the app layer
const{sub,pub}=pubsub();const accessors={};const modal=createModal(options,parent);const hide=()=>{if(!modal.hide)return;// was destroyed
modal.hide();};const show=()=>{if(!modal.show)return;// was destroyed
modal.show();};const view=initEditorView(modal.root);linkAccessors(view,accessors);// link up handle event
accessors.handleEvent=noop$1;view.handleEvent=(type,detail)=>accessors.handleEvent(type,detail);// route close request from view to modal
view.on('close',async()=>{const{willClose}=options;if(!willClose)return hide();const shouldClose=await willClose();if(shouldClose)hide();});const subscribe=(event,cb)=>{// capture modal related events
if(/show|hide/.test(event))return sub(event,cb);// route rest of events to view
return view.on(event,cb);};const modalHandleEventUnsubs=['show','hide'].map(type=>subscribe(type,detail=>accessors.handleEvent(type,detail)));// cleans up view
const destroy=()=>{// unsub
modalHandleEventUnsubs.forEach(unsub=>unsub());// remove
hide();modal.$destroy();view.destroy();};defineMethods(accessors,{on:subscribe,destroy,hide,show});// add element root query
Object.defineProperty(accessors,'modal',{get:()=>modal.root,set:()=>undefined});// route modal events
modal.$on('close',view.close);modal.$on('show',()=>pub('show'));modal.$on('hide',()=>{pub('hide');if(options.enableAutoDestroy!==false)destroy();});// modal behavior
if(options.enableAutoHide!==false)view.on('process',hide);view.on('loadstart',show);// test if should
if(options.enableButtonClose!==false)options.enableButtonClose=true;// delete class
delete options.class;// update props
Object.assign(accessors,options);return accessors;};var _overlayEditor=(target,options)=>{const editor=_appendEditor(target,{...options,layout:'overlay'});return editor;};// helper method to calculate end style params that are passed to lineEnd style functions
const getLineEndParams=(start,end,strokeWidth,isSolid)=>{const direction=vectorCreate(end.x-start.x,end.y-start.y);const normal=vectorNormalize(direction);const scaledSize=5*strokeWidth;let scaledSizeHalf;// solid
if(isSolid){scaledSizeHalf=scaledSize*0.5;}// stroke
else{scaledSizeHalf=Math.ceil((scaledSize-1)*0.5);}const offset=vectorMultiply(vectorClone(normal),scaledSizeHalf);return{anchor:vectorClone(start),offset,normal,solid:isSolid,size:scaledSize,sizeHalf:scaledSizeHalf};};// various available styles
const lineEndStyleArrow=({anchor,solid,normal,offset,size,sizeHalf,strokeWidth,strokeColor},anchorRef)=>{const x=anchor.x;const y=anchor.y;const tipOffset=vectorMultiply(vectorClone(normal),size);const inset=vectorCreate(x+tipOffset.x,y+tipOffset.y);vectorMultiply(tipOffset,0.55);if(solid){// move back so arrow triangle overlaps with end of line (otherwise line sticks out of triangle tip)
vectorAdd(anchorRef,offset);const arrowOffset=vectorMultiply(vectorClone(normal),sizeHalf*0.5);return[{points:[vectorCreate(x-arrowOffset.x,y-arrowOffset.y),vectorCreate(inset.x-tipOffset.y,inset.y+tipOffset.x),vectorCreate(inset.x+tipOffset.y,inset.y-tipOffset.x)],backgroundColor:strokeColor}];}else{// this prevents trouble with sharp line rendering in webgl
const p=vectorMultiply(vectorPerpendicular(vectorClone(normal)),0.5);const tipLeft=vectorCreate(x-p.x,y-p.y);const tipRight=vectorCreate(x+p.x,y+p.y);return[{points:[vectorCreate(inset.x+tipOffset.y,inset.y-tipOffset.x),tipLeft,vectorCreate(x,y),tipRight,vectorCreate(inset.x-tipOffset.y,inset.y+tipOffset.x)],strokeWidth:strokeWidth,strokeColor:strokeColor}];}};const lineEndStyleCircle=({anchor,solid,offset,normal,sizeHalf,strokeWidth,strokeColor},anchorRef)=>{// update anchor point position
vectorAdd(anchorRef,offset);// if solid, move line slightly towards circle as to make them overlap
if(solid)vectorAdd(anchorRef,vectorInvert(vectorClone(normal)));return[{x:anchor.x,y:anchor.y,rx:sizeHalf,ry:sizeHalf,backgroundColor:solid?strokeColor:undefined,strokeWidth:solid?undefined:strokeWidth,strokeColor:solid?undefined:strokeColor}];};const lineEndStyleBar=({anchor,offset,strokeWidth,strokeColor})=>{return[{points:[vectorCreate(anchor.x-offset.y,anchor.y+offset.x),vectorCreate(anchor.x+offset.y,anchor.y-offset.x)],strokeWidth,strokeColor}];};const lineEndStyleSquare=({anchor,solid,offset,normal,sizeHalf,strokeWidth,strokeColor},anchorRef)=>{// update anchor point position
vectorAdd(anchorRef,offset);return[{x:anchor.x-sizeHalf,y:anchor.y-sizeHalf,width:sizeHalf*2,height:sizeHalf*2,rotation:vectorAngle(normal),backgroundColor:solid?strokeColor:undefined,strokeWidth:solid?undefined:strokeWidth,strokeColor:solid?undefined:strokeColor}];};// this method parses the shape and checks if lineStart or lineEnd is being used
const createLineEndProcessor=(styles={})=>shape=>{if(!hasProp(shape,'lineStart')&&!hasProp(shape,'lineEnd'))return;// resulting shapes
const res=[];const{lineStart,lineEnd,strokeWidth,strokeColor}=shape;const start=vectorCreate(shape.x1,shape.y1);const end=vectorCreate(shape.x2,shape.y2);const points=[start,end];// handle lineStart
if(lineStart){const[style,solid]=lineStart.split('-');const process=styles[style];if(process){const params=getLineEndParams(start,end,strokeWidth,!!solid);res.push(...process({...params,strokeColor,strokeWidth},start));}}// handle lineEnd
if(lineEnd){const[style,solid]=lineEnd.split('-');const process=styles[style];if(process){const params=getLineEndParams(end,start,strokeWidth,!!solid);res.push(...process({...params,strokeColor,strokeWidth},end));}}return[// return inner path
{points,strokeWidth,strokeColor},// add line end styles
...res];};// the default line end styles available, can import and extend
const createDefaultLineEndStyles=()=>({arrow:lineEndStyleArrow,circle:lineEndStyleCircle,square:lineEndStyleSquare,bar:lineEndStyleBar});const safeFactor=(value,factor)=>{const v=parseFloat(value)*factor;return pintura_isString(value)?`${v}%`:v;};const toValue=(value,total)=>pintura_isString(value)?toPixelValue(value,total):value;// const toFraction = (value, total) => toValue(value, total) / total;
const frameStyleSolid=shape=>[{...shape,frameStyle:'line',frameInset:0,frameOffset:0,frameSize:shape.frameSize?safeFactor(shape.frameSize,2):'2.5%',frameRadius:shape.frameRound?safeFactor(shape.frameSize,2):0}];const frameStyleLine=({x,y,width,height,frameInset='3.5%',frameSize='.25%',frameColor=[1,1,1],frameOffset='5%',frameAmount=1,frameRadius=0,expandsCanvas=false},{isPreview})=>{const size=Math.sqrt(width*height);let frameSizeValue=toValue(frameSize,size);const frameInsetValue=toValue(frameInset,size);const frameOffsetValue=toValue(frameOffset,size);let center=0;if(!isPreview){frameSizeValue=Math.max(1,Math.round(frameSizeValue));center=frameSizeValue%2==0?0:0.5;}const r=toValue(safeFactor(frameRadius,frameAmount),size);return new Array(frameAmount).fill(undefined).map((_,index)=>{const offset=frameOffsetValue*index;let left=x+frameInsetValue+offset;let top=y+frameInsetValue+offset;let right=x+width-frameInsetValue-offset;let bottom=y+height-frameInsetValue-offset;if(!isPreview){left=Math.round(left);top=Math.round(top);right=Math.round(right);bottom=Math.round(bottom);}const radius=r>0?r-offset:0;return{x:left+center,y:top+center,width:right-left,height:bottom-top,cornerRadius:radius,strokeWidth:frameSizeValue,strokeColor:frameColor,expandsCanvas};});};const frameStyleEdge=({x,y,width,height,frameSize='.25%',frameOffset=0,frameInset='2.5%',frameColor=[1,1,1]},{isPreview})=>{const size=Math.sqrt(width*height);let frameSizeValue=toValue(frameSize,size);let frameInsetValue=toValue(frameInset,size);let frameOffsetValue=toValue(frameOffset,size);let center=0;if(!isPreview){frameSizeValue=Math.max(1,Math.round(frameSizeValue));frameInsetValue=Math.round(frameInsetValue);frameOffsetValue=Math.round(frameOffsetValue);center=frameSizeValue%2==0?0:0.5;}const offset=frameOffsetValue-frameInsetValue;const left=x+frameInsetValue+center;const top=y+frameInsetValue+center;const right=x+width-frameInsetValue-center;const bottom=y+height-frameInsetValue-center;return[// top
{points:[vectorCreate(left+offset,top),vectorCreate(right-offset,top)]},{points:[vectorCreate(right,top+offset),vectorCreate(right,bottom-offset)]},{points:[vectorCreate(right-offset,bottom),vectorCreate(left+offset,bottom)]},{points:[vectorCreate(left,bottom-offset),vectorCreate(left,top+offset)]}].map(shape=>{shape.strokeWidth=frameSizeValue;shape.strokeColor=frameColor;return shape;});};const frameStyleHook=({x,y,width,height,frameSize='.25%',frameInset='2.5%',frameLength='2.5%',frameColor=[1,1,1]},{isPreview})=>{const size=Math.sqrt(width*height);let frameSizeValue=toValue(frameSize,size);let frameInsetValue=toValue(frameInset,size);let frameLengthValue=toValue(frameLength,size);let center=0;if(!isPreview){frameSizeValue=Math.max(1,Math.round(frameSizeValue));frameInsetValue=Math.round(frameInsetValue);frameLengthValue=Math.round(frameLengthValue);center=frameSizeValue%2==0?0:0.5;}const left=x+frameInsetValue+center;const top=y+frameInsetValue+center;const right=x+width-frameInsetValue-center;const bottom=y+height-frameInsetValue-center;return[// top
{points:[vectorCreate(left,top+frameLengthValue),vectorCreate(left,top),vectorCreate(left+frameLengthValue,top)]},{points:[vectorCreate(right-frameLengthValue,top),vectorCreate(right,top),vectorCreate(right,top+frameLengthValue)]},{points:[vectorCreate(right,bottom-frameLengthValue),vectorCreate(right,bottom),vectorCreate(right-frameLengthValue,bottom)]},{points:[vectorCreate(left+frameLengthValue,bottom),vectorCreate(left,bottom),vectorCreate(left,bottom-frameLengthValue)]}].map(shape=>{shape.strokeWidth=frameSizeValue;shape.strokeColor=frameColor;return shape;});};const frameStylePolaroid=({x,y,width,height,frameColor=[1,1,1]},{isPreview})=>{const size=Math.sqrt(width*height);const borderWidth=0.1*size;let chinHeight=0.2*size;const borderWidthHalf=0.5*borderWidth;let strokeWidth=0.0025*size;if(!isPreview){// borderWidthHalf = Math.round(borderWidthHalf);
// borderWidth = Math.round(borderWidth);
chinHeight=Math.ceil(chinHeight);strokeWidth=Math.max(2,strokeWidth);}// always remove opacity
frameColor.length=3;return[// border
{id:'border',x:x-borderWidthHalf,y:y-borderWidthHalf,width:width+borderWidth,height:height+chinHeight,frameStyle:'line',frameInset:0,frameOffset:0,frameSize:borderWidth,frameColor,expandsCanvas:true},// chin
{id:'chin',x:x-borderWidthHalf,y:height,width:width+borderWidth,height:chinHeight,backgroundColor:frameColor,expandsCanvas:true},// for preview only
isPreview&&{x,y,width,height,strokeWidth,strokeColor:frameColor}].filter(Boolean);};const createFrameStyleProcessor=(styles={})=>(shape,options)=>{// handle solid frameStyle
if(!hasProp(shape,'frameStyle'))return;const style=shape.frameStyle;// get parser for style
const process=styles[style];if(!process)return;// remove frameStyle property so we don't get endless looops
const{frameStyle,...shapeReadyToParse}=shape;return process(shapeReadyToParse,options);};// the default frame styles available, can import and extend
const createDefaultFrameStyles=()=>({solid:frameStyleSolid,hook:frameStyleHook,line:frameStyleLine,edge:frameStyleEdge,polaroid:frameStylePolaroid});// the default lineEnd parser to use
const createDefaultLineEndProcessors=()=>createLineEndProcessor(createDefaultLineEndStyles());const createDefaultFrameStyleProcessor=()=>createFrameStyleProcessor(createDefaultFrameStyles());const createDefaultShapeProcessors=()=>[createDefaultFrameStyleProcessor(),createDefaultLineEndProcessors()];const createShapePreprocessor$1=processors=>{const processShape=(shape,options={isPreview:true})=>{const res=processors.map(process=>{const res=process(shape,options);// processor wasn't a match?
if(!res)return;return res.map(shape=>processShape(shape,options));}).filter(Boolean).flat();return!res.length?shape:res.flat();};return processShape;};const createDefaultImageReader=createDefaultImageReader$1;const createDefaultImageWriter=createDefaultImageWriter$1;const createDefaultImageOrienter=()=>({read:getImageOrientationFromFile,apply:orientImageData});const createDefaultImageScrambler=(configurationOptions={})=>{// default configuration
const{blurAmount,scrambleAmount,enableSmoothing,backgroundColor}=configurationOptions;// as called from editor ui
return(imageData,uiOptions)=>imageDataScramble(imageData,{blurAmount,scrambleAmount,enableSmoothing,backgroundColor,...uiOptions});};const createEditor=(/* unused pure expression or super */ null && (createImageEditor));const getEditorProps=()=>getEditorProps$1().concat(getEditorViewProps());// private api for framework components
const createMarkupEditorToolbar=(/* unused pure expression or super */ null && (createToolbar));const createMarkupEditorToolStyles=(/* unused pure expression or super */ null && (createToolStyles));// markup editor style controls
const createMarkupEditorShapeStyleControls=(/* unused pure expression or super */ null && (createShapeStyleControls));const markup_editor_defaults={markupEditorToolbar:createToolbar(),markupEditorToolStyles:createToolStyles(),markupEditorShapeStyleControls:createShapeStyleControls()};const setPlugins=(/* unused pure expression or super */ null && (setEditorViewPlugins));const plugin_crop=_plugin_crop;const plugin_filter=_plugin_filter;const plugin_finetune=_plugin_finetune;const plugin_annotate=_plugin_annotate;const plugin_decorate=_plugin_decorate;const plugin_sticker=_plugin_sticker;const plugin_frame=_plugin_frame;const plugin_redact=_plugin_redact;const plugin_resize=_plugin_resize;const plugin_finetune_defaults=_plugin_finetune_defaults;const plugin_filter_defaults=_plugin_filter_defaults;const plugin_frame_defaults=_plugin_frame_defaults;const locale_en_gb=_locale_en_gb;const markup_editor_locale_en_gb=MarkupEditor;const plugin_crop_locale_en_gb=_plugin_crop_locale_en_gb;const plugin_filter_locale_en_gb=_plugin_filter_locale_en_gb;const plugin_finetune_locale_en_gb=_plugin_finetune_locale_en_gb;const plugin_resize_locale_en_gb=_plugin_resize_locale_en_gb;const plugin_decorate_locale_en_gb=_plugin_decorate_locale_en_gb;const plugin_annotate_locale_en_gb=_plugin_annotate_locale_en_gb;const plugin_sticker_locale_en_gb=_plugin_sticker_locale_en_gb;const plugin_frame_locale_en_gb=_plugin_frame_locale_en_gb;const plugin_redact_locale_en_gb=_plugin_redact_locale_en_gb;const elementsToEditor=(factory,targets,options={})=>{const elements=pintura_isString(targets)?Array.from(document.querySelectorAll(targets)):targets;return elements.filter(Boolean).map(element=>factory(element,deepCopy(options)));};const appendEditor=(/* unused pure expression or super */ null && (_appendEditor));const openEditor=_openEditor;const overlayEditor=(/* unused pure expression or super */ null && (_overlayEditor));const appendEditors=(targets,options)=>elementsToEditor(appendEditor,targets,options);const getEditorDefaultReadWriteOptions=(options={})=>{// allow passing reader / writer / scrambler options as object
let readerProps=undefined;if(!Array.isArray(options.imageWriter)){readerProps=options.imageWriter;delete options.imageReader;}let writerProps=undefined;if(!Array.isArray(options.imageWriter)){writerProps=options.imageWriter;delete options.imageWriter;}let scramblerProps=undefined;if(!pintura_isFunction(options.imageScrambler)){scramblerProps=options.imageScrambler;delete options.imageScrambler;}return{// default handling of images
imageReader:createDefaultImageReader(readerProps),imageWriter:createDefaultImageWriter(writerProps),imageOrienter:createDefaultImageOrienter(),imageScrambler:createDefaultImageScrambler(scramblerProps)};};const createShapePreprocessor=(/* unused pure expression or super */ null && (createShapePreprocessor$1));const createDefaultShapePreprocessor=()=>createShapePreprocessor$1(createDefaultShapeProcessors());const processDefaultImage=(src,options={})=>processImage(src,{...getEditorDefaultReadWriteOptions(options),...options});const getEditorDefaults=(options={})=>{// load all plugins
setEditorViewPlugins(...[plugin_crop,plugin_filter,plugin_finetune,plugin_annotate,plugin_decorate,plugin_sticker,plugin_frame,plugin_redact,plugin_resize].filter(Boolean));// auto hide stickers util if no stickers defined
const utils=['crop','filter','finetune','annotate','decorate',options.stickers&&'sticker','frame','redact','resize'].filter(Boolean);// get default read/write options object
const defaultReadWriteOptions=getEditorDefaultReadWriteOptions(options);// locale
const locale={...locale_en_gb,...markup_editor_locale_en_gb,...plugin_crop_locale_en_gb,...plugin_filter_locale_en_gb,...plugin_finetune_locale_en_gb,...plugin_frame_locale_en_gb,...plugin_redact_locale_en_gb,...plugin_resize_locale_en_gb,...plugin_decorate_locale_en_gb,...plugin_annotate_locale_en_gb,...plugin_sticker_locale_en_gb,...options.locale};delete options.locale;// create huge config object
return mergeObjects([{// set reader / writer / orienter
...defaultReadWriteOptions,// shape preprocessor
shapePreprocessor:createDefaultShapePreprocessor(),// default utils
utils,// default plugin options
...plugin_finetune_defaults,...plugin_filter_defaults,...plugin_frame_defaults,...markup_editor_defaults,// stickers stick to image by default
stickerStickToImage:true,// locale
locale},options]);};const defineCustomElements=async(options={})=>{const elements=await _defineCustomElements();elements.forEach(editor=>Object.assign(editor,deepCopy(options)));return elements;};const defineDefaultCustomElements=options=>defineCustomElements(getEditorDefaults(options));const openDefaultEditor=options=>openEditor(getEditorDefaults(options));const appendDefaultEditor=(element,options)=>appendEditor(element,getEditorDefaults(options));const overlayDefaultEditor=(element,options)=>overlayEditor(element,getEditorDefaults(options));const appendDefaultEditors=(targets,options)=>elementsToEditor(appendDefaultEditor,targets,options);
;// ./src/lang/en.ts

/* eslint-disable camelcase */

var validationLang = {
  required: 'This field is required',
  requiredCheckbox: 'You must check this box',
  minChecked: 'You must tick at least {n} cases | You must tick at least {n} boxes',
  maxChecked: 'You must tick at most {n} box | You must tick a maximum of {n} boxes',
  time: 'Must be a valid time',
  minTime: 'Must be greater than the start time',
  maxTime: 'Must be less than start time',
  password: 'The password must contain at least 8 characters, a number, a lowercase, an uppercase and a special character (,;:=+_()#?!@$%^&*-)',
  confirmPassword: 'The two passwords are different',
  phone: 'Must be a valid phone number',
  phoneMobile: 'Must be a valid mobile phone number',
  domain: 'Must be a valid domain',
  url: 'Must be a valid url',
  hexColor: 'Must be a valid color code',
  array: 'Must be an array',
  tagsExplain: 'Select an existing entry or create a new one by validating with the Enter key',
  noOption: 'No option',
  loading: 'Loading...',
  sameValue: 'The value must be the same',
  minNumber: 'The number must be greater than {n}',
  maxNumber: 'The number must be less than {n}',
  email: '{value} is not a valid email'
};
var FilepondLang = {
  labelDecimalSeparator: 'auto',
  labelThousandsSeparator: 'auto',
  labelIdle: 'Drag & Drop your files or <span class="filepond--label-action"> Browse </span>',
  labelInvalidField: 'Field contains invalid files',
  labelFileWaitingForSize: 'Waiting for size',
  labelFileSizeNotAvailable: 'Size not available',
  labelFileLoading: 'Loading',
  labelFileLoadError: 'Error during upload',
  labelFileProcessing: 'Uploading',
  labelFileProcessingComplete: 'Upload complete',
  labelFileProcessingAborted: 'Upload cancelled',
  labelFileProcessingError: 'Error during upload',
  labelFileProcessingRevertError: 'Error during revert',
  labelFileRemoveError: 'Error during remove',
  labelTapToCancel: 'tap to cancel',
  labelTapToRetry: 'tap to retry',
  labelTapToUndo: 'tap to undo',
  labelButtonRemoveItem: 'Remove',
  labelButtonAbortItemLoad: 'Abort',
  labelButtonRetryItemLoad: 'Retry',
  labelButtonAbortItemProcessing: 'Cancel',
  labelButtonUndoItemProcessing: 'Undo',
  labelButtonRetryItemProcessing: 'Retry',
  labelButtonProcessItem: 'Upload',
  imageValidateSizeLabelFormatError: 'Image type not supported',
  imageValidateSizeLabelImageSizeTooSmall: 'Image is too small',
  imageValidateSizeLabelImageSizeTooBig: 'Image is too big',
  imageValidateSizeLabelExpectedMinSize: 'Minimum size is {minWidth} × {minHeight}',
  imageValidateSizeLabelExpectedMaxSize: 'Maximum size is {maxWidth} × {maxHeight}',
  imageValidateSizeLabelImageResolutionTooLow: 'Resolution is too low',
  imageValidateSizeLabelImageResolutionTooHigh: 'Resolution is too high',
  imageValidateSizeLabelExpectedMinResolution: 'Minimum resolution is {minResolution}',
  imageValidateSizeLabelExpectedMaxResolution: 'Maximum resolution is {maxResolution}',
  labelFileTypeNotAllowed: 'File of invalid type',
  fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
  labelMaxFileSizeExceeded: 'File is too large',
  labelMaxFileSize: 'Maximum file size is {filesize}',
  labelMaxTotalFileSizeExceeded: 'Maximum total size exceeded',
  labelMaxTotalFileSize: 'Maximum total file size is {filesize}'
};
var editor = {
  Valid: 'Valid',
  'Border size': 'Border size',
  'Border style': 'Border style',
  Normal: 'Normal',
  Dashed: 'Dashed',
  'Cell Border Color': 'Cell Border Color',
  'Table Border Color': 'Table Border Color',
  'Table Background Color': 'Table Background Color',
  'Variable type': 'Variable type',
  'Variable to insert': 'Variable to insert',
  'Show prefix and suffix only if the variable contains a value': 'Show prefix and suffix only if the variable contains a value',
  Prefix: 'Prefix',
  'Add a newline before the prefix': 'Add a newline before the prefix',
  'Add a newline after the prefix': 'Add a newline after the prefix',
  Suffix: 'Suffix',
  'Add a newline before the suffix': 'Add a newline before the suffix',
  'Add a newline after the suffix': 'Add a newline after the suffix',
  'Insert variable': 'Insert variable',
  'Edit variable': 'Edit variable',
  'Delete variable': 'Delete variable',
  'Insert dynamic variable': 'Insert dynamic variable'
};
var PinturaLang = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, locale_en_gb), plugin_crop_locale_en_gb), plugin_finetune_locale_en_gb), plugin_filter_locale_en_gb), plugin_annotate_locale_en_gb), plugin_decorate_locale_en_gb), plugin_resize_locale_en_gb), plugin_sticker_locale_en_gb), markup_editor_locale_en_gb);
var lang = {
  validation: validationLang,
  filepond: FilepondLang,
  pintura: PinturaLang,
  editor: editor
};
/* harmony default export */ var en = (lang);
;// ./src/lang/fr.ts
var fr_validationLang = {
  required: 'Ce champ est obligatoire',
  requiredCheckbox: 'Vous devez cocher cette case',
  minChecked: 'Vous devez cocher au minimum {n} case | Vous devez cocher au minimum {n} cases',
  maxChecked: 'Vous devez cocher au maximum {n} case | Vous devez cocher au maximum {n} cases',
  time: 'Doit être une heure valide',
  minTime: 'Doit être supérieure à l\'heure de début',
  maxTime: 'Doit être inférieure à l\'heure de début',
  password: 'Le mot de passe doit comporter au moins 8 caractères, un chiffre, une minuscule, une majuscule et un caractère spécial (,;:=+_()#?!@$%^&*-)',
  confirmPassword: 'Les mots de passe sont différents',
  phone: 'Doit être un numéro de téléphone valide',
  phoneMobile: 'Doit être un numéro de téléphone portable valide',
  domain: 'Doit être un domaine valide',
  url: 'Doit être une URL valide',
  hexColor: 'Doit être un code couleur valide',
  array: 'Doit être un tableau',
  tagsExplain: 'Sélectionnez une entrée existante ou créez en une nouvelle en validant avec la touche Entrée',
  noOption: 'Aucun résultat',
  loading: 'Chargement en cours...',
  sameValue: 'La valeur doit être identique',
  minNumber: 'Le nombre doit être supérieur ou égal à {n}',
  maxNumber: 'Le nombre doit être inférieur ou égal à {n}',
  email: '{value} n\'est pas un email valide'
};
var fr_FilepondLang = {
  labelDecimalSeparator: 'auto',
  labelThousandsSeparator: 'auto',
  labelIdle: 'Glissez vos fichiers ici ou <span class="filepond--label-action"> Sélectionnez un fichier </span>',
  labelInvalidField: 'Le champ contient des fichiers invalides',
  labelFileWaitingForSize: 'En attente de la taille du fichier',
  labelFileSizeNotAvailable: 'Taille du fichier indisponible',
  labelFileLoading: 'Chargement',
  labelFileLoadError: 'Une erreur est survenue pendant l\'envoi du fichier',
  labelFileProcessing: 'Envoi du fichier',
  labelFileProcessingComplete: 'Envoi terminé',
  labelFileProcessingAborted: 'Envoi annulé',
  labelFileProcessingError: 'Une erreur est survenue pendant l\'envoi du fichier',
  labelFileProcessingRevertError: 'Erreur lors de l\'annulation',
  labelFileRemoveError: 'Erreur lors de la suppression',
  labelTapToCancel: 'Cliquez pour annuler',
  labelTapToRetry: 'Cliquez pour recommencer',
  labelTapToUndo: 'Cliquez pour annuler',
  labelButtonRemoveItem: 'Supprimer',
  labelButtonAbortItemLoad: 'Annuler',
  labelButtonRetryItemLoad: 'Recommencer',
  labelButtonAbortItemProcessing: 'Annuler',
  labelButtonUndoItemProcessing: 'Annuler',
  labelButtonRetryItemProcessing: 'Recomencer',
  labelButtonProcessItem: 'Envoyer',
  imageValidateSizeLabelFormatError: 'Type d\'image non supporté',
  imageValidateSizeLabelImageSizeTooSmall: 'Image trop petite',
  imageValidateSizeLabelImageSizeTooBig: 'Image trop grande',
  imageValidateSizeLabelExpectedMinSize: 'Taille minimum : {minWidth} × {minHeight}',
  imageValidateSizeLabelExpectedMaxSize: 'Taille maximum : {maxWidth} × {maxHeight}',
  imageValidateSizeLabelImageResolutionTooLow: 'Résolution trop petite',
  imageValidateSizeLabelImageResolutionTooHigh: 'Résolution trop grande',
  imageValidateSizeLabelExpectedMinResolution: 'Résolution minimum : {minResolution}',
  imageValidateSizeLabelExpectedMaxResolution: 'Résolution maximum : {maxResolution}',
  labelFileTypeNotAllowed: 'Type de fichier invalide',
  fileValidateTypeLabelExpectedTypes: 'Extension acceptée : {allButLastType} or {lastType}',
  labelMaxFileSizeExceeded: 'Fichier trop lourd',
  labelMaxFileSize: 'Poids maximum autorisé : {filesize}',
  labelMaxTotalFileSizeExceeded: 'Le poids des fichiers dépasse la limite autorisée',
  labelMaxTotalFileSize: 'Le poids de tous les fichiers ne doit pas dépasser : {filesize}'
};
var fr_editor = {
  Valid: 'Valider',
  'Border size': 'Taille de la bordure',
  'Border style': 'Style de bordure',
  Normal: 'Normale',
  Dashed: 'Pointillé',
  'Cell Border Color': 'Bordure de la cellule',
  'Table Border Color': 'Bordures du tableau',
  'Table Background Color': 'Couleur de fond du tableau',
  'Variable type': 'Type de variable',
  'Variable to insert': 'Variable à insérer',
  'Show prefix and suffix only if the variable contains a value': 'Afficher le prefixe et le suffixe uniquement si la variable contient une valeur',
  'Show prefix in bold': 'Afficher le préfixe en gras',
  Prefix: 'Préfixe',
  'Add a newline before the prefix': 'Ajouter un retour à la ligne avant le préfixe',
  'Add a newline after the prefix': 'Ajouter un retour à la ligne après le préfixe',
  Suffix: 'Suffixe',
  'Add a newline before the suffix': 'Ajouter un retour à la ligne avant le suffixe',
  'Add a newline after the suffix': 'Ajouter un retour à la ligne après le suffixe',
  'Insert variable': 'Insérer la variable',
  'Edit variable': 'Modifier la variable',
  'Delete variable': 'Supprimer la variable',
  'Insert dynamic variable': 'Insérer une variable dynamique',
  'Cell Padding': 'Espacement du contenu de la cellule',
  'Padding top': 'Haut',
  'Padding left': 'Droite',
  'Padding bottom': 'Bas',
  'Padding right': 'Gauche',
  'Table cells spacing': 'Espace des cellules',
  'Space between cells': 'Espace entre les cellules',
  'Space in cells': 'Espace à l\'intérieur des cellules',
  'Cell size': 'Dimensions de la cellule',
  'Download image': 'Télécharger une image'
};
var fr_PinturaLang = {
  labelReset: 'Réinitialiser',
  labelDefault: 'Par défaut',
  labelAuto: 'Auto',
  labelNone: 'Non',
  labelEdit: 'Modifier',
  labelClose: 'Fermer',
  labelSupportError: function (features) {
    return features.join(', ') + " non pris en charge sur ce navigateur";
  },
  labelSizeExtraSmall: 'Très petit',
  labelSizeSmall: 'petit',
  labelSizeMediumSmall: 'Moyen petit',
  labelSizeMedium: 'Moyen',
  labelSizeMediumLarge: 'Moyen large',
  labelSizeLarge: 'Large',
  labelSizeExtraLarge: 'Très large',
  labelButtonRevert: 'Rétablir',
  labelButtonCancel: 'Annuler',
  labelButtonUndo: 'Annuler',
  labelButtonRedo: 'Rétablir',
  labelButtonExport: 'Terminé',
  statusLabelButtonClose: 'Fermer',
  statusLabelLoadImage: function (state) {
    if (!state || !state.task) return 'En attente d\'image';
    if (state.error) {
      return state.error.code === 'IMAGE_TOO_SMALL' ? 'La taille minimale de l\'image est {minWidth} × {minHeight}' : 'Erreur de chargement de l\'image';
    }
    if (state.task === 'blob-to-bitmap') return 'Création d\'un aperçu…';
    return 'Chargement de l\'image…';
  },
  statusLabelProcessImage: function (state) {
    if (!state || !state.task) return undefined;
    if (state.task === 'store') {
      if (state.error) return 'Erreur lors de l\'envoi de l\'image';
      return 'Chargement de l\'image…';
    }
    if (state.error) return 'Erreur de traitement de l\'image';
    return 'Traitement de l\'image…';
  },
  shapeLabelButtonSelectSticker: 'Sélectionner une image',
  shapeTitleButtonTextLayoutAutoWidth: 'Largeur automatique',
  shapeTitleButtonTextLayoutAutoHeight: 'Hauteur automatique',
  shapeTitleButtonTextLayoutFixedSize: 'Taille fixe',
  shapeTitleButtonFlipHorizontal: 'Retourner horizontalement',
  shapeTitleButtonFlipVertical: 'Retourner verticalement',
  shapeTitleButtonRemove: 'Supprimer',
  shapeTitleButtonDuplicate: 'Dupliquer',
  shapeTitleButtonMoveToFront: 'Déplacer vers l\'avant',
  shapeLabelInputText: 'Éditer le texte',
  shapeLabelInputCancel: 'Annuler',
  shapeLabelInputConfirm: 'Confirmer',
  shapeLabelStrokeNone: 'Pas de contour',
  shapeLabelFontStyleNormal: 'Normal',
  shapeLabelFontStyleBold: 'Gras',
  shapeLabelFontStyleItalic: 'Italique',
  shapeLabelFontStyleItalicBold: 'Italique Gras',
  shapeTitleBackgroundColor: 'Couleur de fond',
  shapeTitleFontFamily: 'Police',
  shapeTitleFontSize: 'Taille de police',
  shapeTitleFontStyle: 'Style de police',
  shapeTitleLineHeight: 'Premier',
  shapeTitleLineStart: 'Début',
  shapeTitleLineEnd: 'Fin',
  shapeTitleStrokeWidth: 'Largeur de ligne',
  shapeTitleStrokeColor: 'Couleur de la ligne',
  shapeTitleLineDecorationBar: 'Barre',
  shapeTitleLineDecorationCircle: 'Cercle',
  shapeTitleLineDecorationSquare: 'Carré',
  shapeTitleLineDecorationArrow: 'Flèche',
  shapeTitleLineDecorationCircleSolid: 'Cercle solid',
  shapeTitleLineDecorationSquareSolid: 'Carré solid',
  shapeTitleLineDecorationArrowSolid: 'Flèche solide',
  shapeTitleColorTransparent: 'Transparent',
  shapeTitleColorWhite: 'Blanc',
  shapeTitleColorSilver: 'Argent',
  shapeTitleColorGray: 'Gris',
  shapeTitleColorBlack: 'Noir',
  shapeTitleColorNavy: 'Bleu marine',
  shapeTitleColorBlue: 'Bleu',
  shapeTitleColorAqua: 'Aqua',
  shapeTitleColorTeal: 'Teal',
  shapeTitleColorOlive: 'Olive',
  shapeTitleColorGreen: 'Vert',
  shapeTitleColorYellow: 'Jaune',
  shapeTitleColorOrange: 'Orange',
  shapeTitleColorRed: 'Grouge',
  shapeTitleColorMaroon: 'Bordeaux',
  shapeTitleColorFuchsia: 'Fuchsia',
  shapeTitleColorPurple: 'Violet',
  shapeTitleTextColor: 'Couleur de la police',
  shapeTitleTextAlign: 'Alignement du texte',
  shapeTitleTextAlignLeft: 'Aligner le texte à gauche',
  shapeTitleTextAlignCenter: 'Centrer le texte',
  shapeTitleTextAlignRight: 'Aligner le texte à droite',
  shapeLabelToolSharpie: 'Sharpie',
  shapeLabelToolEraser: 'Gomme',
  shapeLabelToolRectangle: 'Rectangle',
  shapeLabelToolEllipse: 'Ellipse',
  shapeLabelToolArrow: 'Flèche',
  shapeLabelToolLine: 'Ligne',
  shapeLabelToolText: 'Texte',
  shapeLabelToolPreset: 'Stickers',
  cropLabel: 'Recadrer',
  cropLabelButtonRecenter: 'Recenter',
  cropLabelButtonRotateLeft: 'Rotation à gauche',
  cropLabelButtonRotateRight: 'Rotation à droite',
  cropLabelButtonFlipHorizontal: 'Retourner horizontalement',
  cropLabelButtonFlipVertical: 'Retourner verticalement',
  cropLabelSelectPreset: 'Forme de recadrage',
  cropLabelCropBoundary: 'Limite de recadrage',
  cropLabelCropBoundaryEdge: 'Bord de l\'image',
  cropLabelCropBoundaryNone: 'Non',
  cropLabelTabRotation: 'Rotation',
  cropLabelTabZoom: 'Zoom',
  filterLabel: 'Filtres',
  filterLabelChrome: 'Chrome',
  filterLabelFade: 'Fade',
  filterLabelCold: 'Cold',
  filterLabelWarm: 'Warm',
  filterLabelPastel: 'Pastel',
  filterLabelMonoDefault: 'Mono',
  filterLabelMonoNoir: 'Noir',
  filterLabelMonoWash: 'Wash',
  filterLabelMonoStark: 'Stark',
  filterLabelSepiaDefault: 'Sepia',
  filterLabelSepiaBlues: 'Blues',
  filterLabelSepiaRust: 'Rust',
  filterLabelSepiaColor: 'Color',
  finetuneLabel: 'Réglages',
  finetuneLabelBrightness: 'Luminosité',
  finetuneLabelContrast: 'Contraste',
  finetuneLabelSaturation: 'Saturation',
  finetuneLabelExposure: 'Exposition',
  finetuneLabelTemperature: 'Température',
  finetuneLabelGamma: 'Gamma',
  finetuneLabelClarity: 'Clarté',
  finetuneLabelVignette: 'Vignette',
  resizeLabel: 'Taille',
  resizeLabelFormCaption: 'Taille de sortie d\'image',
  resizeLabelInputWidth: 'l',
  resizeTitleInputWidth: 'Largeur',
  resizeLabelInputHeight: 'h',
  resizeTitleInputHeight: 'Hauteur',
  resizeTitleButtonMaintainAspectRatio: 'Maintenir le ratio',
  decorateLabel: 'Décorer',
  annotateLabel: 'Annoter',
  stickerLabel: 'Sticker'
};
var fr_lang = {
  validation: fr_validationLang,
  filepond: fr_FilepondLang,
  pintura: fr_PinturaLang,
  editor: fr_editor
};
/* harmony default export */ var fr = (fr_lang);
;// ./src/lang/index.ts


var Lang = {
  en: en,
  fr: fr
};
/* harmony default export */ var src_lang = (Lang);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/languages/fr.js
var languages_fr = __webpack_require__(212);
;// ./src/components/Editor/lang.js




(external_froala_editor_default()).LANGUAGE.fr.translation = merge_default()((external_froala_editor_default()).LANGUAGE.fr.translation, src_lang.fr.editor);
;// ./src/components/Editor/plugins/tableBackground.js




Object.assign((external_froala_editor_default()).POPUP_TEMPLATES, {
  'tableBackground.popup': '[_BUTTONS_][_COLOR_SELECTOR_][_CUSTOM_COLOR_]'
});
(external_froala_editor_default()).PLUGINS.tableBackground = function (editor) {
  const __ = editor.language.translate;
  let selectedTable = null;
  const initPopup = () => {
    const buttons = `<div class="fr-buttons fr-tabs fr-buttons-selectTableBackgroundColor">
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command fr-btn fr-back" data-cmd="tableBackgroundBack">
          <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 11L7.83 11 11.425 7.405 10.01 5.991 5.416 10.586 5.414 10.584 4 11.998 4.002 12 4 12.002 5.414 13.416 5.416 13.414 10.01 18.009 11.425 16.595 7.83 13 20 13 20 13 20 11 20 11Z"></path>
          </svg>
          <span class="fr-sr-only">${__('Back')}</span>
        </button>
        <div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>
      </div>`;
    let colorSelector = '<div class="fr-color-set fr-table-colors fr-table-border-colors">';
    editor.opts.tableColors.forEach((color, i) => {
      if (color !== 'REMOVE') {
        colorSelector += `
          <span class="fr-command"
                style="background: ${color}"
                tabIndex="-1"
                role="button"
                data-cmd="selectTableBackgroundColor"
                data-param1="${color}"
          >
            <span class="fr-sr-only">
            ${__('Color')} ${color}&nbsp;&nbsp;&nbsp;
            </span>
          </span>`;
        if ((i + 1) % 8 === 0) {
          colorSelector += '<br>';
        }
      } else {
        colorSelector += `
          <span class="fr-command fr-table-background-remove-color" data-cmd="selectTableBackgroundColor" tabIndex="-1" role="button" data-param1="REMOVE" title="${__('Clear Formatting')}">
            ${editor.icon.create('tableColorRemove')}
            <span class="fr-sr-only">${__('Clear Formatting')}</span>
          </span>`;
      }
    });
    colorSelector += '</div>';
    const customColor = `
        <div class="fr-table-cell fr-layer form-group mb-2 mt-2 d-block">
            <div class="fr-table-cell-label">${__('HEX Color')}</div>
            <input type="text" value="" maxlength="7" class="form-control form-control-sm fr-table-cell-border-custom-color" />
        </div>`;
    return editor.popups.create('tableBackground.popup', {
      buttons,
      color_selector: colorSelector,
      custom_color: customColor
    });
  };
  const showPopup = () => {
    let $popup = editor.popups.get('tableBackground.popup');
    if (!$popup) $popup = initPopup();
    editor.popups.setContainer('tableBackground.popup', editor.$tb);
    const tablePopup = editor.popups.get('table.edit');
    const $btn = tablePopup.find('.fr-command[data-cmd="tableBorder"]');
    const left = $btn.offset().left - $btn.outerWidth();
    const top = tablePopup.offset().top;
    editor.popups.show('tableBackground.popup', left, top);
    setInitialValues();
  };
  const hidePopup = () => {
    editor.popups.hide('tableBackground.popup');
    selectedTable = null;
  };
  const setInitialValues = () => {
    selectedTable = editor.$el.find('.fr-selected-cell').closest('table').first();
    selectColor(selectedTable[0].style.backgroundColor);
  };
  const selectColor = color => {
    if (color === 'REMOVE') {
      resetStyles();
      return;
    }
    color = editor.helpers.RGBToHex(color);
    const popup = editor.popups.get('tableBackground.popup');
    popup.find('.fr-table-border-colors > span').removeClass('selected');
    if (popup) {
      popup.find('.fr-table-cell-border-custom-color').val(color);
      const colorSelector = popup.find('.fr-table-border-colors > span[data-param1="' + color + '"]');
      if (colorSelector.length > 0) {
        colorSelector.addClass('selected');
      }
    }
  };
  const resetStyles = () => {
    selectedTable.css('background-color', '');
    hidePopup();
  };
  const applyStyles = () => {
    const popup = editor.popups.get('tableBackground.popup');
    const color = popup.find('.fr-table-cell-border-custom-color').val();
    selectedTable.css('background-color', color);
    hidePopup();
  };
  const selectAndApplyColor = color => {
    selectColor(color);
    if (color !== 'REMOVE') {
      applyStyles();
    }
  };

  // Methods visible outside the plugin.
  return {
    showPopup,
    hidePopup,
    selectAndApplyColor
  };
};
external_froala_editor_default().DefineIcon('tableBackground', {
  SVG_KEY: 'cellBackground'
});
external_froala_editor_default().RegisterCommand('tableBackground', {
  title: 'Table Background Color',
  focus: false,
  popup: true,
  callback: function () {
    this.tableBackground.showPopup();
  }
});
external_froala_editor_default().RegisterCommand('tableBackgroundBack', {
  callback: function () {
    this.tableBackground.hidePopup();
  }
});
external_froala_editor_default().RegisterCommand('selectTableBackgroundColor', {
  callback: function (e, t) {
    this.tableBackground.selectAndApplyColor(t);
  }
});
;// ./src/components/Editor/plugins/tableBorderStyles.js




Object.assign((external_froala_editor_default()).POPUP_TEMPLATES, {
  'tableBorderStyles.popup': '[_BUTTONS_][_WIDTH_][_STYLE_][_COLOR_SELECTOR_][_CUSTOM_COLOR_]'
});
Object.assign((external_froala_editor_default()).DEFAULTS, {
  tableBorderUnit: 'px'
});
(external_froala_editor_default()).PLUGINS.tableBorderStyles = function (editor) {
  const __ = editor.language.translate;
  let selectedTable = null;
  const initPopup = () => {
    const buttons = `<div class="fr-buttons fr-tabs fr-buttons-selectTableBorderColor">
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command fr-btn fr-back" data-cmd="tableBorderBack">
          <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 11L7.83 11 11.425 7.405 10.01 5.991 5.416 10.586 5.414 10.584 4 11.998 4.002 12 4 12.002 5.414 13.416 5.416 13.414 10.01 18.009 11.425 16.595 7.83 13 20 13 20 13 20 11 20 11Z"></path>
          </svg>
          <span class="fr-sr-only">${__('Back')}</span>
        </button>
        <div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command btn btn-sm btn-primary" data-cmd="applyTableBorderStyles">
          ${__('Valid')}
        </button>
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command btn btn-sm btn-secondary" data-cmd="resetTableBorderStyles">
          ${__('Clean')}
        </button>
      </div>`;
    const borderWidth = `
        <div class="fr-table-cell fr-layer form-group" style="display: block">
            <div class="fr-table-cell-label">${__('Border size')}</div>
            <input type="number" value="1" min="0" class="form-control form-control-sm fr-table-cell-border-width" />
        </div>`;
    const styleSelector = `
        <div class="fr-table-cell fr-layer form-group" style="display: block">
            <div class="fr-table-cell-label">${__('Border style')}</div>
            <select class="form-control form-control-sm fr-table-cell-border-style">
                <option value="solid">${__('Normal')}</option>
                <option value="dashed">${__('Dashed')}</option>
            </select>
        </div>`;
    let colorSelector = '<div class="fr-color-set fr-table-colors fr-table-border-colors">';
    editor.opts.tableColors.forEach((color, i) => {
      if (color !== 'REMOVE') {
        colorSelector += `
          <span class="fr-command"
                style="background: ${color}"
                tabIndex="-1"
                role="button"
                data-cmd="selectTableBorderColor"
                data-param1="${color}"
          >
            <span class="fr-sr-only">
            ${__('Color')} ${color}&nbsp;&nbsp;&nbsp;
            </span>
          </span>`;
        if ((i + 1) % 8 === 0) {
          colorSelector += '<br>';
        }
      }
    });
    colorSelector += '</div>';
    const customColor = `
        <div class="fr-table-cell fr-layer form-group mb-2 mt-2 d-block">
            <div class="fr-table-cell-label">${__('HEX Color')}</div>
            <input type="text" value="" maxlength="7" class="form-control form-control-sm fr-table-cell-border-custom-color" />
        </div>`;
    return editor.popups.create('tableBorderStyles.popup', {
      buttons,
      width: borderWidth,
      style: styleSelector,
      color_selector: colorSelector,
      custom_color: customColor
    });
  };
  const showPopup = () => {
    let $popup = editor.popups.get('tableBorderStyles.popup');
    if (!$popup) $popup = initPopup();
    editor.popups.setContainer('tableBorderStyles.popup', editor.$tb);
    const tablePopup = editor.popups.get('table.edit');
    const $btn = tablePopup.find('.fr-command[data-cmd="tableBorder"]');
    const left = $btn.offset().left - $btn.outerWidth();
    const top = tablePopup.offset().top;
    editor.popups.show('tableBorderStyles.popup', left, top);
    setInitialValues();
  };
  const hidePopup = () => {
    editor.popups.hide('tableBorderStyles.popup');
    selectedTable = null;
  };
  const setInitialValues = () => {
    selectedTable = editor.$el.find('.fr-selected-cell').closest('table').first();
    const cell = selectedTable[0];
    const popup = editor.popups.get('tableBorderStyles.popup');
    let borderWidth = cell.style.borderBottomWidth;
    if (borderWidth === '') {
      borderWidth = 1;
    } else {
      borderWidth = borderWidth.replace('px', '').replace('pt', '');
    }
    popup.find('.fr-table-cell-border-width').val(borderWidth);
    let borderStyle = cell.style.borderBottomStyle;
    if (borderStyle === '') {
      borderStyle = 'solid';
    }
    popup.find('.fr-table-cell-border-style').val(borderStyle);
    selectColor(cell.style.borderBottomColor);
  };
  const selectColor = color => {
    color = editor.helpers.RGBToHex(color);
    const popup = editor.popups.get('tableBorderStyles.popup');
    popup.find('.fr-table-border-colors > span').removeClass('selected');
    if (popup) {
      popup.find('.fr-table-cell-border-custom-color').val(color);
      const colorSelector = popup.find('.fr-table-border-colors > span[data-param1="' + color + '"]');
      if (colorSelector.length > 0) {
        colorSelector.addClass('selected');
      }
    }
  };
  const resetStyles = () => {
    selectedTable.css('border-style', '');
    selectedTable.css('border-width', '');
    selectedTable.css('border-color', '');
    selectedTable.removeClass('withCustomBorders');
    hidePopup();
  };
  const applyStyles = () => {
    const popup = editor.popups.get('tableBorderStyles.popup');
    const borderWidth = parseInt(popup.find('.fr-table-cell-border-width').val());
    if (borderWidth === 0) {
      resetStyles();
      return;
    }
    selectedTable.addClass('withCustomBorders');
    const style = popup.find('.fr-table-cell-border-style').val();
    const color = popup.find('.fr-table-cell-border-custom-color').val();
    selectedTable.css('border', borderWidth + editor.opts.tableBorderUnit + ' ' + style + ' ' + color);
    hidePopup();
  };

  // Methods visible outside the plugin.
  return {
    showPopup,
    hidePopup,
    selectColor,
    resetStyles,
    applyStyles
  };
};
external_froala_editor_default().DefineIcon('tableBorder', {
  SVG_KEY: 'cellBorderColor'
});
external_froala_editor_default().RegisterCommand('tableBorder', {
  title: 'Table Border Color',
  focus: false,
  popup: true,
  callback: function () {
    this.tableBorderStyles.showPopup();
  }
});
external_froala_editor_default().RegisterCommand('tableBorderBack', {
  callback: function () {
    this.tableBorderStyles.hidePopup();
  }
});
external_froala_editor_default().RegisterCommand('selectTableBorderColor', {
  callback: function (e, t) {
    this.tableBorderStyles.selectColor(t);
  }
});
external_froala_editor_default().RegisterCommand('resetTableBorderStyles', {
  callback: function () {
    this.tableBorderStyles.resetStyles();
  }
});
external_froala_editor_default().RegisterCommand('applyTableBorderStyles', {
  callback: function () {
    this.tableBorderStyles.applyStyles();
  }
});
;// ./src/components/Editor/plugins/tableCellBorderStyles.js




Object.assign((external_froala_editor_default()).POPUP_TEMPLATES, {
  'tableCellBorderStyles.popup': '[_BUTTONS_][_WIDTH_][_STYLE_][_COLOR_SELECTOR_][_CUSTOM_COLOR_]'
});
Object.assign((external_froala_editor_default()).DEFAULTS, {
  tableBorderUnit: 'px'
});
(external_froala_editor_default()).PLUGINS.tableCellBorderStyles = function (editor) {
  const __ = editor.language.translate;
  let selectedCell = null;
  const initPopup = () => {
    const buttons = `<div class="fr-buttons fr-tabs fr-buttons-selectTableBorderColor">
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command fr-btn fr-back" data-cmd="tableCellBorderBack">
          <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 11L7.83 11 11.425 7.405 10.01 5.991 5.416 10.586 5.414 10.584 4 11.998 4.002 12 4 12.002 5.414 13.416 5.416 13.414 10.01 18.009 11.425 16.595 7.83 13 20 13 20 13 20 11 20 11Z"></path>
          </svg>
          <span class="fr-sr-only">${__('Back')}</span>
        </button>
        <div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command btn btn-sm btn-primary" data-cmd="applyTableCellBorderStyles">
          ${__('Valid')}
        </button>
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command btn btn-sm btn-secondary" data-cmd="resetTableCellBorderStyles">
          ${__('Clean')}
        </button>
      </div>`;
    const borderWidth = `
        <div class="fr-table-cell fr-layer form-group" style="display: block">
            <div class="fr-table-cell-label">${__('Border size')}</div>
            <input type="number" value="1" min="0" class="form-control form-control-sm fr-table-cell-border-width" />
        </div>`;
    const styleSelector = `
        <div class="fr-table-cell fr-layer form-group" style="display: block">
            <div class="fr-table-cell-label">${__('Border style')}</div>
            <select class="form-control form-control-sm fr-table-cell-border-style">
                <option value="solid">${__('Normal')}</option>
                <option value="dashed">${__('Dashed')}</option>
            </select>
        </div>`;
    let colorSelector = '<div class="fr-color-set fr-table-colors fr-table-border-colors">';
    editor.opts.tableColors.forEach((color, i) => {
      if (color !== 'REMOVE') {
        colorSelector += `
          <span class="fr-command"
                style="background: ${color}"
                tabIndex="-1"
                role="button"
                data-cmd="selectTableCellBorderColor"
                data-param1="${color}"
          >
            <span class="fr-sr-only">
            ${__('Color')} ${color}&nbsp;&nbsp;&nbsp;
            </span>
          </span>`;
        if ((i + 1) % 8 === 0) {
          colorSelector += '<br>';
        }
      }
    });
    colorSelector += '</div>';
    const customColor = `
        <div class="fr-table-cell fr-layer form-group mb-2 mt-2 d-block">
            <div class="fr-table-cell-label">${__('HEX Color')}</div>
            <input type="text" value="" maxlength="7" class="form-control form-control-sm fr-table-cell-border-custom-color" />
        </div>`;
    return editor.popups.create('tableCellBorderStyles.popup', {
      buttons,
      width: borderWidth,
      style: styleSelector,
      color_selector: colorSelector,
      custom_color: customColor
    });
  };
  const showPopup = () => {
    let $popup = editor.popups.get('tableCellBorderStyles.popup');
    if (!$popup) $popup = initPopup();
    editor.popups.setContainer('tableCellBorderStyles.popup', editor.$tb);
    const tablePopup = editor.popups.get('table.edit');
    const $btn = tablePopup.find('.fr-command[data-cmd="tableCellBorder"]');
    const left = $btn.offset().left - $btn.outerWidth();
    const top = tablePopup.offset().top;
    editor.popups.show('tableCellBorderStyles.popup', left, top);
    setInitialValues();
  };
  const hidePopup = () => {
    editor.popups.hide('tableCellBorderStyles.popup');
    selectedCell = null;
  };
  const setInitialValues = () => {
    selectedCell = editor.$el.find('.fr-selected-cell').first();
    const cell = selectedCell[0];
    const popup = editor.popups.get('tableCellBorderStyles.popup');
    let borderWidth = cell.style.borderBottomWidth;
    if (borderWidth === '') {
      borderWidth = 1;
    } else {
      borderWidth = borderWidth.replace('px', '').replace('pt', '');
    }
    popup.find('.fr-table-cell-border-width').val(borderWidth);
    let borderStyle = cell.style.borderBottomStyle;
    if (borderStyle === '') {
      borderStyle = 'solid';
    }
    popup.find('.fr-table-cell-border-style').val(borderStyle);
    selectColor(cell.style.borderBottomColor);
  };
  const selectColor = color => {
    color = editor.helpers.RGBToHex(color);
    const popup = editor.popups.get('tableCellBorderStyles.popup');
    popup.find('.fr-table-border-colors > span').removeClass('selected');
    if (popup) {
      popup.find('.fr-table-cell-border-custom-color').val(color);
      const colorSelector = popup.find('.fr-table-border-colors > span[data-param1="' + color + '"]');
      if (colorSelector.length > 0) {
        colorSelector.addClass('selected');
      }
    }
  };
  const resetStyles = () => {
    selectedCell.css('border-style', '');
    selectedCell.css('border-width', '');
    selectedCell.css('border-color', '');
    hidePopup();
  };
  const applyStyles = () => {
    const popup = editor.popups.get('tableCellBorderStyles.popup');
    const borderWidth = parseInt(popup.find('.fr-table-cell-border-width').val());
    if (borderWidth === 0) {
      resetStyles();
      return;
    }
    const style = popup.find('.fr-table-cell-border-style').val();
    const color = popup.find('.fr-table-cell-border-custom-color').val();
    selectedCell.css('border', borderWidth + editor.opts.tableBorderUnit + ' ' + style + ' ' + color);
    hidePopup();
  };

  // Methods visible outside the plugin.
  return {
    showPopup,
    hidePopup,
    selectColor,
    resetStyles,
    applyStyles
  };
};
external_froala_editor_default().DefineIcon('tableCellBorder', {
  SVG_KEY: 'cellBorderColor'
});
external_froala_editor_default().RegisterCommand('tableCellBorder', {
  title: 'Cell Border Color',
  focus: false,
  popup: true,
  callback: function () {
    this.tableCellBorderStyles.showPopup();
  }
});
external_froala_editor_default().RegisterCommand('tableCellBorderBack', {
  callback: function () {
    this.tableCellBorderStyles.hidePopup();
  }
});
external_froala_editor_default().RegisterCommand('selectTableCellBorderColor', {
  callback: function (e, t) {
    this.tableCellBorderStyles.selectColor(t);
  }
});
external_froala_editor_default().RegisterCommand('resetTableCellBorderStyles', {
  callback: function () {
    this.tableCellBorderStyles.resetStyles();
  }
});
external_froala_editor_default().RegisterCommand('applyTableCellBorderStyles', {
  callback: function () {
    this.tableCellBorderStyles.applyStyles();
  }
});
;// ./src/components/Editor/plugins/tableCellHeight.js



Object.assign((external_froala_editor_default()).POPUP_TEMPLATES, {
  'tableCellHeight.popup': '[_BUTTONS_][_SIZE_]'
});
Object.assign((external_froala_editor_default()).DEFAULTS, {
  tableHeightUnit: 'px'
});
(external_froala_editor_default()).PLUGINS.tableCellHeight = function (editor) {
  const __ = editor.language.translate;
  let selectedCell = null;
  const initPopup = () => {
    const buttons = `<div class="fr-buttons fr-tabs fr-buttons-selectTableBorderColor">
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command fr-btn fr-back" data-cmd="tableCellHeightBack">
          <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 11L7.83 11 11.425 7.405 10.01 5.991 5.416 10.586 5.414 10.584 4 11.998 4.002 12 4 12.002 5.414 13.416 5.416 13.414 10.01 18.009 11.425 16.595 7.83 13 20 13 20 13 20 11 20 11Z"></path>
          </svg>
          <span class="fr-sr-only">${__('Back')}</span>
        </button>
        <div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command btn btn-sm btn-primary" data-cmd="applyTableCellHeight">
          ${__('Valid')}
        </button>
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command btn btn-sm btn-secondary" data-cmd="resetTableCellHeight">
          ${__('Clean')}
        </button>
      </div>`;
    const size = `
        <div class="fr-table-cell fr-layer form-group" style="display: block">
            <div class="fr-table-cell-label">${__('Height')}</div>
            <div class="input-group">
              <input type="number" value="1" min="0" class="form-control form-control-sm fr-table-cell-height" />
              <div class="input-group-append pl-2 pt-1">
                ${editor.opts.tableHeightUnit}
              </div>
            </div>
        </div>
        <div class="fr-table-cell fr-layer form-group" style="display: block">
            <div class="fr-table-cell-label">${__('Width')}</div>
            <div class="input-group">
              <input type="number" value="1" min="0" class="form-control form-control-sm fr-table-cell-width" />
                <div class="input-group-append pl-2 pt-1">
                  ${editor.opts.tableHeightUnit}
                </div>
              </div>
        </div>`;
    return editor.popups.create('tableCellHeight.popup', {
      buttons,
      size: size
    });
  };
  const showPopup = () => {
    let $popup = editor.popups.get('tableCellHeight.popup');
    if (!$popup) $popup = initPopup();
    editor.popups.setContainer('tableCellHeight.popup', editor.$tb);
    const tablePopup = editor.popups.get('table.edit');
    const $btn = tablePopup.find('.fr-command[data-cmd="tableCellHeight"]');
    const left = $btn.offset().left - $btn.outerWidth();
    const top = tablePopup.offset().top;
    editor.popups.show('tableCellHeight.popup', left, top);
    setInitialValues();
  };
  const hidePopup = () => {
    editor.popups.hide('tableCellHeight.popup');
    selectedCell = null;
  };
  const setInitialValues = () => {
    selectedCell = editor.$el.find('.fr-selected-cell').first();
    const cell = selectedCell[0];
    const popup = editor.popups.get('tableCellHeight.popup');
    let width = cell.style.width;
    width = width.replace(editor.opts.tableHeightUnit, '');
    popup.find('.fr-table-cell-width').val(width);
    let height = cell.style.height;
    height = height.replace(editor.opts.tableHeightUnit, '');
    popup.find('.fr-table-cell-height').val(height);
  };
  const resetStyles = () => {
    selectedCell.css('height', '');
    selectedCell.css('width', '');
    hidePopup();
  };
  const applyStyles = () => {
    const popup = editor.popups.get('tableCellHeight.popup');
    const height = popup.find('.fr-table-cell-height').val();
    selectedCell.css('height', height + editor.opts.tableHeightUnit);
    const width = popup.find('.fr-table-cell-width').val();
    selectedCell.css('width', width + editor.opts.tableHeightUnit);
    hidePopup();
  };

  // Methods visible outside the plugin.
  return {
    showPopup,
    hidePopup,
    resetStyles,
    applyStyles
  };
};
external_froala_editor_default().DefineIcon('tableCellHeight', {
  SVG_KEY: 'imageSize'
});
external_froala_editor_default().RegisterCommand('tableCellHeight', {
  title: 'Cell size',
  focus: false,
  popup: true,
  callback: function () {
    this.tableCellHeight.showPopup();
  }
});
external_froala_editor_default().RegisterCommand('tableCellHeightBack', {
  callback: function () {
    this.tableCellHeight.hidePopup();
  }
});
external_froala_editor_default().RegisterCommand('resetTableCellHeight', {
  callback: function () {
    this.tableCellHeight.resetStyles();
  }
});
external_froala_editor_default().RegisterCommand('applyTableCellHeight', {
  callback: function () {
    this.tableCellHeight.applyStyles();
  }
});
;// ./src/components/Editor/plugins/tableCellPadding.js



Object.assign((external_froala_editor_default()).POPUP_TEMPLATES, {
  'tableCellPadding.popup': '[_BUTTONS_][_PADDING_]'
});
Object.assign((external_froala_editor_default()).DEFAULTS, {
  tablePaddingUnit: 'px'
});
(external_froala_editor_default()).PLUGINS.tableCellPadding = function (editor) {
  const __ = editor.language.translate;
  let selectedCell = null;
  const initPopup = () => {
    const buttons = `<div class="fr-buttons fr-tabs fr-buttons-selectTableBorderColor">
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command fr-btn fr-back" data-cmd="tableCellPaddingBack">
          <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 11L7.83 11 11.425 7.405 10.01 5.991 5.416 10.586 5.414 10.584 4 11.998 4.002 12 4 12.002 5.414 13.416 5.416 13.414 10.01 18.009 11.425 16.595 7.83 13 20 13 20 13 20 11 20 11Z"></path>
          </svg>
          <span class="fr-sr-only">${__('Back')}</span>
        </button>
        <div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command btn btn-sm btn-primary" data-cmd="applyTableCellPadding">
          ${__('Valid')}
        </button>
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command btn btn-sm btn-secondary" data-cmd="resetTableCellPadding">
          ${__('Clean')}
        </button>
      </div>`;
    const padding = `
        <div class="fr-table-cell fr-layer form-group" style="display: block">
            <div class="fr-table-cell-label">${__('Padding top')}</div>
            <div class="input-group">
              <input type="number" value="1" min="0" class="form-control form-control-sm fr-table-cell-padding-top" />
              <div class="input-group-append pl-2 pt-1">
                ${editor.opts.tablePaddingUnit}
              </div>
            </div>
        </div>
        <div class="fr-table-cell fr-layer form-group" style="display: block">
            <div class="fr-table-cell-label">${__('Padding left')}</div>
            <div class="input-group">
              <input type="number" value="1" min="0" class="form-control form-control-sm fr-table-cell-padding-left" />
                <div class="input-group-append pl-2 pt-1">
                  ${editor.opts.tablePaddingUnit}
                </div>
              </div>
        </div>
        <div class="fr-table-cell fr-layer form-group" style="display: block">
            <div class="fr-table-cell-label">${__('Padding bottom')}</div>
            <div class="input-group">
              <input type="number" value="1" min="0" class="form-control form-control-sm fr-table-cell-padding-bottom" />
              <div class="input-group-append pl-2 pt-1">
                ${editor.opts.tablePaddingUnit}
              </div>
            </div>
        </div>
        <div class="fr-table-cell fr-layer form-group" style="display: block">
            <div class="fr-table-cell-label">${__('Padding right')}</div>
            <div class="input-group">
              <input type="number" value="1" min="0" class="form-control form-control-sm fr-table-cell-padding-right" />
              <div class="input-group-append pl-2 pt-1">
                ${editor.opts.tablePaddingUnit}
              </div>
            </div>
        </div>`;
    return editor.popups.create('tableCellPadding.popup', {
      buttons,
      padding: padding
    });
  };
  const showPopup = () => {
    let $popup = editor.popups.get('tableCellPadding.popup');
    if (!$popup) $popup = initPopup();
    editor.popups.setContainer('tableCellPadding.popup', editor.$tb);
    const tablePopup = editor.popups.get('table.edit');
    const $btn = tablePopup.find('.fr-command[data-cmd="tableCellPadding"]');
    const left = $btn.offset().left - $btn.outerWidth();
    const top = tablePopup.offset().top;
    editor.popups.show('tableCellPadding.popup', left, top);
    setInitialValues();
  };
  const hidePopup = () => {
    editor.popups.hide('tableCellPadding.popup');
    selectedCell = null;
  };
  const setInitialValues = () => {
    selectedCell = editor.$el.find('.fr-selected-cell').first();
    const cell = selectedCell[0];
    const popup = editor.popups.get('tableCellPadding.popup');
    let paddingTop = cell.style.paddingTop;
    paddingTop = paddingTop.replace('px', '').replace('pt', '');
    popup.find('.fr-table-cell-padding-top').val(paddingTop);
    let paddingLeft = cell.style.paddingLeft;
    paddingLeft = paddingLeft.replace('px', '').replace('pt', '');
    popup.find('.fr-table-cell-padding-left').val(paddingLeft);
    let paddingBottom = cell.style.paddingBottom;
    paddingBottom = paddingBottom.replace('px', '').replace('pt', '');
    popup.find('.fr-table-cell-padding-bottom').val(paddingBottom);
    let paddingRight = cell.style.paddingRight;
    paddingRight = paddingRight.replace('px', '').replace('pt', '');
    popup.find('.fr-table-cell-padding-right').val(paddingRight);
  };
  const resetStyles = () => {
    selectedCell.css('padding-top', '');
    selectedCell.css('padding-left', '');
    selectedCell.css('padding-bottom', '');
    selectedCell.css('padding-right', '');
    hidePopup();
  };
  const applyStyles = () => {
    const popup = editor.popups.get('tableCellPadding.popup');
    const paddingTop = popup.find('.fr-table-cell-padding-top').val();
    selectedCell.css('padding-top', paddingTop + editor.opts.tablePaddingUnit);
    const paddingLeft = popup.find('.fr-table-cell-padding-left').val();
    selectedCell.css('padding-left', paddingLeft + editor.opts.tablePaddingUnit);
    const paddingBottom = popup.find('.fr-table-cell-padding-bottom').val();
    selectedCell.css('padding-bottom', paddingBottom + editor.opts.tablePaddingUnit);
    const paddingRight = popup.find('.fr-table-cell-padding-right').val();
    selectedCell.css('padding-right', paddingRight + editor.opts.tablePaddingUnit);
    hidePopup();
  };

  // Methods visible outside the plugin.
  return {
    showPopup,
    hidePopup,
    resetStyles,
    applyStyles
  };
};
external_froala_editor_default().DefineIcon('tableCellPadding', {
  SVG_KEY: 'fullscreen'
});
external_froala_editor_default().RegisterCommand('tableCellPadding', {
  title: 'Cell Padding',
  focus: false,
  popup: true,
  callback: function () {
    this.tableCellPadding.showPopup();
  }
});
external_froala_editor_default().RegisterCommand('tableCellPaddingBack', {
  callback: function () {
    this.tableCellPadding.hidePopup();
  }
});
external_froala_editor_default().RegisterCommand('resetTableCellPadding', {
  callback: function () {
    this.tableCellPadding.resetStyles();
  }
});
external_froala_editor_default().RegisterCommand('applyTableCellPadding', {
  callback: function () {
    this.tableCellPadding.applyStyles();
  }
});
;// ./src/components/Editor/plugins/tableSpaces.js



Object.assign((external_froala_editor_default()).POPUP_TEMPLATES, {
  'tableSpaces.popup': '[_BUTTONS_][_SPACE_]'
});
(external_froala_editor_default()).PLUGINS.tableSpaces = function (editor) {
  const __ = editor.language.translate;
  let selectedTable = null;
  const initPopup = () => {
    const buttons = `<div class="fr-buttons fr-tabs fr-buttons-selectTableBorderColor">
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command fr-btn fr-back" data-cmd="tableSpacesBack">
          <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 11L7.83 11 11.425 7.405 10.01 5.991 5.416 10.586 5.414 10.584 4 11.998 4.002 12 4 12.002 5.414 13.416 5.416 13.414 10.01 18.009 11.425 16.595 7.83 13 20 13 20 13 20 11 20 11Z"></path>
          </svg>
          <span class="fr-sr-only">${__('Back')}</span>
        </button>
        <div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command btn btn-sm btn-primary" data-cmd="applyTableSpacing">
          ${__('Valid')}
        </button>
        <button type="button" tabindex="-1" role="button" title="${__('Back')}" class="fr-command btn btn-sm btn-secondary" data-cmd="resetTableSpacing">
          ${__('Clean')}
        </button>
      </div>`;
    const space = `
        <div class="fr-table-cell fr-layer form-group" style="display: block">
            <div class="fr-table-cell-label">${__('Space between cells')}</div>
            <input type="number" value="1" min="0" class="form-control form-control-sm fr-table-cellspacing" />
        </div>
        <div class="fr-table-cell fr-layer form-group" style="display: block">
            <div class="fr-table-cell-label">${__('Space in cells')}</div>
            <input type="number" value="1" min="0" class="form-control form-control-sm fr-table-cellpadding" />
        </div>`;
    return editor.popups.create('tableSpaces.popup', {
      buttons,
      space
    });
  };
  const showPopup = () => {
    let $popup = editor.popups.get('tableSpaces.popup');
    if (!$popup) $popup = initPopup();
    editor.popups.setContainer('tableSpaces.popup', editor.$tb);
    const tablePopup = editor.popups.get('table.edit');
    const $btn = tablePopup.find('.fr-command[data-cmd="tableSpaces"]');
    const left = $btn.offset().left - $btn.outerWidth();
    const top = tablePopup.offset().top;
    editor.popups.show('tableSpaces.popup', left, top);
    setInitialValues();
  };
  const hidePopup = () => {
    editor.popups.hide('tableSpaces.popup');
    selectedTable = null;
  };
  const setInitialValues = () => {
    selectedTable = editor.$el.find('.fr-selected-cell').closest('table').first();
    const popup = editor.popups.get('tableSpaces.popup');
    let cellspacing = selectedTable.attr('cellspacing');
    if (cellspacing === '') {
      cellspacing = 0;
    }
    popup.find('.fr-table-cellspacing').val(cellspacing);
    let cellpadding = selectedTable.attr('cellpadding');
    if (cellpadding === '') {
      cellspacing = 0;
    }
    popup.find('.fr-table-cellpadding').val(cellpadding);
  };
  const resetStyles = () => {
    selectedTable.attr('cellpadding', 0);
    selectedTable.attr('cellspacing', 0);
    selectedTable.css('border-collapse', 'collapse');
    hidePopup();
  };
  const applyStyles = () => {
    const popup = editor.popups.get('tableSpaces.popup');
    const cellpadding = popup.find('.fr-table-cellpadding').val();
    selectedTable.attr('cellpadding', cellpadding);
    const cellspacing = popup.find('.fr-table-cellspacing').val();
    selectedTable.attr('cellspacing', cellspacing);
    if (cellspacing > 0) {
      selectedTable.css('border-collapse', 'unset');
    }
    hidePopup();
  };

  // Methods visible outside the plugin.
  return {
    showPopup,
    hidePopup,
    resetStyles,
    applyStyles
  };
};
external_froala_editor_default().DefineIcon('tableSpaces', {
  SVG_KEY: 'fullscreen'
});
external_froala_editor_default().RegisterCommand('tableSpaces', {
  title: 'Table cells spacing',
  focus: false,
  popup: true,
  callback: function () {
    this.tableSpaces.showPopup();
  }
});
external_froala_editor_default().RegisterCommand('tableSpacesBack', {
  callback: function () {
    this.tableSpaces.hidePopup();
  }
});
external_froala_editor_default().RegisterCommand('resetTableSpacing', {
  callback: function () {
    this.tableSpaces.resetStyles();
  }
});
external_froala_editor_default().RegisterCommand('applyTableSpacing', {
  callback: function () {
    this.tableSpaces.applyStyles();
  }
});
// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(9754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: ./node_modules/lodash/findKey.js
var findKey = __webpack_require__(826);
var findKey_default = /*#__PURE__*/__webpack_require__.n(findKey);
;// ./src/components/Editor/plugins/dynamicVariables.js







Object.assign((external_froala_editor_default()).POPUP_TEMPLATES, {
  'dynamicVariables.popup': '[_TYPES_][_VARIABLES_][_EXTRA_][_INSERT_]',
  'dynamicVariables.edit': '[_BUTTONS_]'
});
Object.assign((external_froala_editor_default()).DEFAULTS, {
  dynamicVariables: {},
  dynamicVariablesEdition: true,
  dynamicVariablesDelete: true
});
(external_froala_editor_default()).PLUGINS.dynamicVariables = function (editor) {
  const __ = editor.language.translate;
  let selectVariableType = null;
  let selectedDynamicVariable = null;
  const initPopup = () => {
    let firstVariables = null;
    let types = `
      <div class="fr-table-cell form-group mt-2 fr-dynamic-variables-row">
        <div class="fr-table-cell-label">${__('Variable type')}</div>
        <select class="form-control form-control-sm fr-dynamic-variables-types">`;
    forEach_default()(editor.opts.dynamicVariables, (variable, key) => {
      if (!firstVariables) {
        firstVariables = variable.variables;
      }
      types += `<option value="${key}">${variable.label}</option>`;
    });
    types += '</select></div>';
    let variables = `
      <div class="fr-table-cell form-group fr-dynamic-variables-row">
        <div class="fr-table-cell-label">${__('Variable to insert')}</div>
        <select class="form-control form-control-sm fr-dynamic-variables-variables">`;
    firstVariables.sort((a, b) => a.label.localeCompare(b.label)).forEach(variable => {
      variables += `<option value="${variable.value}">${variable.label}</option>`;
    });
    variables += `</select>
      </div>`;
    const extra = `
      <div class="fr-table-cell fr-dynamic-variables-row">
        <div class="form-control-sm">
          <input type="checkbox" class="mr-2" value="true" id="fr-dynamic-variables-conditional-show">
          <label for="fr-dynamic-variables-conditional-show">
            ${__('Show prefix and suffix only if the variable contains a value')}
          </label>
        </div>
      </div>
      <fieldset class="fr-table-cell form-group fr-dynamic-variables-row">
        <div class="fr-table-cell-label">${__('Prefix')}</div>
        <input type="text" class="form-control form-control-sm fr-dynamic-variables-prefix">
        <div class="form-control-sm mt-1">
          <input type="checkbox" class="mr-2" value="true" id="fr-dynamic-variables-bold-prefix">
          <label for="fr-dynamic-variables-bold-prefix">
            ${__('Show prefix in bold')}
          </label>
        </div>
        <div class="form-control-sm mt-1">
          <input type="checkbox" class="mr-2" value="true" id="fr-dynamic-variables-before-prefix">
          <label for="fr-dynamic-variables-before-prefix">
            ${__('Add a newline before the prefix')}
          </label>
        </div>
        <div class="form-control-sm">
          <input type="checkbox" class="mr-2" value="true" id="fr-dynamic-variables-after-prefix">
          <label for="fr-dynamic-variables-after-prefix">
            ${__('Add a newline after the prefix')}
          </label>
        </div>
      </fieldset>
      <fieldset class="fr-table-cell form-group fr-dynamic-variables-row">
        <div class="fr-table-cell-label">${__('Suffix')}</div>
        <input type="text" class="form-control form-control-sm fr-dynamic-variables-suffix">
        <div class="form-control-sm mt-1">
          <input type="checkbox" class="mr-2" value="true" id="fr-dynamic-variables-before-suffix">
          <label for="fr-dynamic-variables-before-suffix">
            ${__('Add a newline before the suffix')}
          </label>
        </div>
        <div class="form-control-sm">
          <input type="checkbox" class="mr-2" value="true" id="fr-dynamic-variables-after-suffix">
          <label for="fr-dynamic-variables-after-suffix">
            ${__('Add a newline after the suffix')}
          </label>
        </div>
      </fieldset>`;
    const insert = `
      <div class="fr-table-cell text-center fr-dynamic-variables-row mb-1">
        <button type="button" class="fr-command btn btn-primary btn-sm" role="button" data-cmd="insertSelectedDynamicVariables">
          ${__('Insert variable')}
        </button>
      </div>`;
    return editor.popups.create('dynamicVariables.popup', {
      types,
      variables,
      extra,
      insert
    });
  };
  const clearPopupForm = () => {
    const popup = editor.popups.get('dynamicVariables.popup');
    popup.find('.fr-dynamic-variables-prefix').val('');
    popup.find('.fr-dynamic-variables-suffix').val('');
    popup.find('#fr-dynamic-variables-before-prefix').attr('checked', '');
    popup.find('#fr-dynamic-variables-after-prefix').attr('checked', '');
    popup.find('#fr-dynamic-variables-bold-prefix').attr('checked', '');
    popup.find('#fr-dynamic-variables-before-suffix').attr('checked', '');
    popup.find('#fr-dynamic-variables-after-suffix').attr('checked', '');
    popup.find('#fr-dynamic-variables-conditional-show').attr('checked', '');
  };
  const showPopup = () => {
    let $popup = editor.popups.get('dynamicVariables.popup');
    if (!$popup) $popup = initPopup();
    clearPopupForm();
    const $tb = editor.$tb;
    editor.popups.setContainer('dynamicVariables.popup', $tb);
    const left = (editor.$tb.outerWidth() - $popup.outerWidth()) / 2;
    const top = $tb.offset().top;
    editor.popups.show('dynamicVariables.popup', left, top);
    initializePopup();
  };
  const hidePopup = () => {
    destroyPopup();
    editor.popups.hide('dynamicVariables.popup');
  };
  const initializePopup = () => {
    selectVariableType = editor.popups.get('dynamicVariables.popup').find('select.fr-dynamic-variables-types');
    selectVariableType.on('input', onVariableTypeSelect);
  };
  const destroyPopup = () => {
    if (selectVariableType) {
      selectVariableType.off('input', onVariableTypeSelect);
    }
  };
  const onVariableTypeSelect = () => {
    setVariableTypes(selectVariableType.val());
  };
  const setVariableTypes = type => {
    const variables = editor.opts.dynamicVariables[type].variables;
    let options = '';
    variables.sort((a, b) => a.label.localeCompare(b.label)).forEach(variable => {
      options += `<option value="${variable.value}">${variable.label}</option>`;
    });
    const select = editor.popups.get('dynamicVariables.popup').find('select.fr-dynamic-variables-variables');
    if (select) {
      select.html(options);
    }
  };
  const insertVariable = () => {
    const popup = editor.popups.get('dynamicVariables.popup');
    const variable = popup.find('.fr-dynamic-variables-variables').val();
    const conditional = popup.find('#fr-dynamic-variables-conditional-show').attr('checked');
    const prefix = popup.find('.fr-dynamic-variables-prefix').val();
    const prefixBefore = popup.find('#fr-dynamic-variables-before-prefix').attr('checked');
    const prefixAfter = popup.find('#fr-dynamic-variables-after-prefix').attr('checked');
    const prefixBold = popup.find('#fr-dynamic-variables-bold-prefix').attr('checked');
    const suffix = popup.find('.fr-dynamic-variables-suffix').val();
    const suffixBefore = popup.find('#fr-dynamic-variables-before-suffix').attr('checked');
    const suffixAfter = popup.find('#fr-dynamic-variables-after-suffix').attr('checked');
    let output = '';
    let label = '';
    if (prefixBefore) {
      label += '<br>';
      output += ' data-prefix-space-before="true"';
    }
    if (prefix !== '') {
      let prefixLabel = prefix;
      if (prefixBold) {
        output += ' data-prefix-bold="true"';
        prefixLabel = '<strong>' + prefixLabel + '</strong>';
      }
      label += prefixLabel;
      output += ' data-prefix="' + prefix + '"';
      if (!prefixAfter) {
        label += ' ';
      }
    }
    if (prefixAfter) {
      label += '<br>';
      output += ' data-prefix-space-after="true"';
    }
    output += ' data-variable="' + variable + '"';
    label += variable;
    if (suffixBefore) {
      label += '<br>';
      output += ' data-suffix-space-before="true"';
    }
    if (suffix !== '') {
      if (!suffixBefore) {
        label += ' ';
      }
      label += suffix;
      output += ' data-suffix="' + suffix + '"';
    }
    if (suffixAfter) {
      label += '<br>&nbsp;';
      output += ' data-suffix-space-after="true"';
    }
    if (conditional) {
      output += 'data-conditional-show="true"';
    }
    const content = '<variable ' + output + ' contenteditable="false" class="fr-dynamic-variable">' + label + '</variable>';
    if (selectedDynamicVariable && document.body.contains(selectedDynamicVariable)) {
      const temp = document.createElement('div');
      temp.innerHTML = content;
      selectedDynamicVariable.parentNode.replaceChild(temp.childNodes[0], selectedDynamicVariable);
    } else {
      editor.html.insert(content);
    }
    hidePopup();
  };
  const listenClick = e => {
    const $el = e.currentTarget;
    if ($el && $el.classList.contains('fr-dynamic-variable')) {
      selectedDynamicVariable = $el;
      $el.classList.add('selected-dynamic-variable');
      showVariableEdit();
    } else {
      unselectVariable();
    }
  };
  const setContentEditable = state => {
    editor.$el.find('.fr-dynamic-variable').attr('contenteditable', state);
  };
  function _init() {
    editor.opts.htmlAllowedTags.push('variable');
    editor.events.on('click', listenClick);
    editor.events.on('commands.before', () => setContentEditable(true));
    editor.events.on('commands.after', () => setContentEditable(false));
  }
  const unselectVariable = () => {
    if (selectedDynamicVariable) {
      selectedDynamicVariable.classList.remove('selected-dynamic-variable');
    }
  };
  const initVariableEdit = () => {
    let buttons = '';
    if (editor.opts.dynamicVariablesEdition) {
      buttons += `
          <button type="button" tabindex="-1" role="button" class="fr-command fr-btn" data-cmd="editDynamicVariable" data-title="${__('Edit variable')}">
            <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M17,11.2L12.8,7L5,14.8V19h4.2L17,11.2z M7,16.8v-1.5l5.6-5.6l1.4,1.5l-5.6,5.6H7z M13.5,6.3l0.7-0.7c0.8-0.8,2.1-0.8,2.8,0  c0,0,0,0,0,0L18.4,7c0.8,0.8,0.8,2,0,2.8l-0.7,0.7L13.5,6.3z"></path>
            </svg>
            <span class="fr-sr-only">${__('Edit variable')}</span>
          </button>`;
    }
    if (editor.opts.dynamicVariablesDelete) {
      buttons += `
          <button type="button" tabindex="-1" role="button" class="fr-command fr-btn" data-cmd="deleteDynamicVariable" data-title="${__('Delete variable')}">
            <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z"></path>
            </svg>
            <span class="fr-sr-only">${__('Delete variable')}</span>
          </button>`;
    }
    const $popup = editor.popups.create('dynamicVariables.edit', {
      buttons: '<div class="fr-buttons">' + buttons + '</div>'
    });
    editor.popups.onHide('dynamicVariables.edit', hideVariableEdit);
    return $popup;
  };
  const showVariableEdit = () => {
    if (!selectedDynamicVariable) {
      return;
    }
    let $popup = editor.popups.get('dynamicVariables.edit');
    if (!$popup) $popup = initVariableEdit();
    const $tb = editor.$tb;
    editor.popups.setContainer('dynamicVariables.edit', $tb);
    const offset = selectedDynamicVariable.getBoundingClientRect();
    const left = offset.left;
    const top = offset.top + 10;
    editor.popups.show('dynamicVariables.edit', left, top);
  };
  const hideVariableEdit = () => {
    editor.popups.hide('dynamicVariables.edit');
    unselectVariable();
    editor.toolbar.enable();
  };
  const editVariable = () => {
    if (!selectedDynamicVariable) {
      return;
    }
    const $el = selectedDynamicVariable;
    const variable = $el.getAttribute('data-variable');
    const conditional = $el.getAttribute('data-conditional-show');
    const prefix = $el.getAttribute('data-prefix');
    const prefixBefore = $el.getAttribute('data-prefix-space-before');
    const prefixAfter = $el.getAttribute('data-prefix-space-after');
    const prefixBold = $el.getAttribute('data-prefix-bold');
    const suffix = $el.getAttribute('data-suffix');
    const suffixBefore = $el.getAttribute('data-suffix-space-before');
    const suffixAfter = $el.getAttribute('data-suffix-space-after');
    const variableType = findKey_default()(editor.opts.dynamicVariables, content => {
      return content.variables.find(v => v.value === variable);
    });
    showPopup();
    const popup = editor.popups.get('dynamicVariables.popup');
    popup.find('.fr-dynamic-variables-types').val(variableType);
    setVariableTypes(variableType);
    popup.find('.fr-dynamic-variables-variables').val(variable);
    popup.find('.fr-dynamic-variables-prefix').val(prefix);
    if (prefixBefore === 'true') {
      popup.find('#fr-dynamic-variables-before-prefix').attr('checked', 'checked');
    }
    if (prefixAfter === 'true') {
      popup.find('#fr-dynamic-variables-after-prefix').attr('checked', 'checked');
    }
    if (prefixBold === 'true') {
      popup.find('#fr-dynamic-variables-bold-prefix').attr('checked', 'checked');
    }
    popup.find('.fr-dynamic-variables-suffix').val(suffix);
    if (suffixBefore === 'true') {
      popup.find('#fr-dynamic-variables-before-suffix').attr('checked', 'checked');
    }
    if (suffixAfter === 'true') {
      popup.find('#fr-dynamic-variables-after-suffix').attr('checked', 'checked');
    }
    if (conditional === 'true') {
      popup.find('#fr-dynamic-variables-conditional-show').attr('checked', 'checked');
    }
  };
  const deleteVariable = () => {
    if (selectedDynamicVariable) {
      selectedDynamicVariable.remove();
      selectedDynamicVariable = null;
      hideVariableEdit();
    }
  };
  return {
    _init,
    showPopup,
    hidePopup,
    insertVariable,
    editVariable,
    deleteVariable
  };
};
external_froala_editor_default().DefineIcon('insertDynamicVariables', {
  SVG_KEY: 'inlineClass'
});
external_froala_editor_default().RegisterCommand('insertDynamicVariables', {
  title: 'Insert dynamic variable',
  focus: false,
  popup: true,
  callback: function () {
    this.dynamicVariables.showPopup();
  }
});
external_froala_editor_default().RegisterCommand('closeDynamicVariablesPopup', {
  callback: function () {
    this.dynamicVariables.hidePopup();
  }
});
external_froala_editor_default().RegisterCommand('insertSelectedDynamicVariables', {
  callback: function () {
    this.dynamicVariables.insertVariable();
  }
});
external_froala_editor_default().RegisterCommand('editDynamicVariable', {
  callback: function () {
    this.dynamicVariables.editVariable();
  }
});
external_froala_editor_default().RegisterCommand('deleteDynamicVariable', {
  callback: function () {
    this.dynamicVariables.deleteVariable();
  }
});
;// ./src/components/Editor/plugins/uploadInlineImage.js

(external_froala_editor_default()).PLUGINS.uploadInlineImage = function (editor) {
  const upload = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.onchange = e => {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        editor.html.insert('<img src="' + reader.result + '" alt="" />');
      };
    };
    input.click();
  };
  return {
    upload
  };
};
external_froala_editor_default().DefineIcon('uploadInlineImage', {
  SVG_KEY: 'upload'
});
external_froala_editor_default().RegisterCommand('uploadInlineImage', {
  title: 'Download image',
  focus: true,
  callback: function () {
    this.uploadInlineImage.upload();
  }
});
;// ./src/components/Editor/froala-editor.ts

















// import 'froala-editor/js/plugins/line_breaker.min.js'









;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Editor/FroalaEditor.vue?vue&type=script&lang=js



/* eslint-disable */



/* harmony default export */ var FroalaEditorvue_type_script_lang_js = ({
  props: ['tag', 'value', 'config', 'onManualControllerReady'],
  watch: {
    value: function () {
      this.model = this.value ?? '';
      this.updateValue();
    }
  },
  render: function (createElement) {
    return createElement(this.currentTag, {
      ref: 'textarea'
    }, [this.$slots.default]);
  },
  created: function () {
    this.currentTag = this.tag || this.currentTag;
    this.model = this.value;
  },
  // After first time render.
  mounted: function () {
    if (this.SPECIAL_TAGS.indexOf(this.currentTag) != -1) {
      this.hasSpecialTag = true;
    }
    if (this.onManualControllerReady) {
      this.generateManualController();
    } else {
      this.createEditor();
    }
  },
  beforeDestroy: function () {
    this.destroyEditor();
    this.$refs.textarea.remove();
  },
  data: function () {
    return {
      initEvents: [],
      // Tag on which the editor is initialized.
      currentTag: 'div',
      // Editor element.
      _editor: null,
      // Current config.
      currentConfig: null,
      // Editor options config
      defaultConfig: {
        immediateVueModelUpdate: false,
        vueIgnoreAttrs: null
      },
      editorInitialized: false,
      SPECIAL_TAGS: ['img', 'button', 'input', 'a'],
      INNER_HTML_ATTR: 'innerHTML',
      hasSpecialTag: false,
      model: null,
      oldModel: null
    };
  },
  methods: {
    updateValue: function () {
      if (JSON.stringify(this.oldModel) === JSON.stringify(this.model)) {
        return;
      }
      this.setContent(!this.editorInitialized);
    },
    createEditor: function () {
      if (this.editorInitialized) {
        return;
      }
      this.currentConfig = this.clone(this.config || this.defaultConfig);
      this.currentConfig = {
        ...this.currentConfig,
        key: "BWC6D-16B1A2F3F1H1A3vb2EAJLQCVLUVBd1NXNRSSATEXC-8C2H2C4D4B6C2A1C4A1G2=="
      };
      this.setContent(true);

      // Bind editor events.
      this.registerEvents();
      this.initListeners();
      this._editor = new (external_froala_editor_default())(this.$el, this.currentConfig);
    },
    // Return clone object
    clone(item) {
      const me = this;
      if (!item) {
        return item;
      } // null, undefined values check

      let types = [Number, String, Boolean],
        result;

      // normalizing primitives if someone did new String('aaa'), or new Number('444');
      types.forEach(function (type) {
        if (item instanceof type) {
          result = type(item);
        }
      });
      if (typeof result == "undefined") {
        if (Object.prototype.toString.call(item) === "[object Array]") {
          result = [];
          item.forEach(function (child, index, array) {
            result[index] = me.clone(child);
          });
        } else if (typeof item == "object") {
          // testing that this is DOM
          if (item.nodeType && typeof item.cloneNode == "function") {
            result = item.cloneNode(true);
          } else if (!item.prototype) {
            // check that this is a literal
            if (item instanceof Date) {
              result = new Date(item);
            } else {
              // it is an object literal
              result = {};
              for (var i in item) {
                result[i] = me.clone(item[i]);
              }
            }
          } else {
            if (false) {} else {
              result = item;
            }
          }
        } else {
          result = item;
        }
      }
      return result;
    },
    setContent: function (firstTime) {
      if (!this.editorInitialized && !firstTime) {
        return;
      }
      if (this.model || this.model == '') {
        this.oldModel = this.model;
        if (this.hasSpecialTag) {
          this.setSpecialTagContent();
        } else {
          this.setNormalTagContent(firstTime);
        }
      }
    },
    setNormalTagContent: function (firstTime) {
      var self = this;
      function htmlSet() {
        if (!self._editor) {
          return;
        }
        self._editor.html.set(self.model || '');

        //This will reset the undo stack everytime the model changes externally. Can we fix this?

        self._editor.undo.saveStep();
        self._editor.undo.reset();
      }
      if (!this.editorInitialized || firstTime) {
        this.registerEvent('initialized', function () {
          htmlSet();
        });
      } else {
        htmlSet();
      }
    },
    setSpecialTagContent: function () {
      var tags = this.model;

      // add tags on element
      if (tags) {
        for (var attr in tags) {
          if (tags.hasOwnProperty(attr) && attr != this.INNER_HTML_ATTR) {
            this.$el.setAttribute(attr, tags[attr]);
          }
        }
        if (tags.hasOwnProperty(this.INNER_HTML_ATTR)) {
          this.$el.innerHTML = tags[this.INNER_HTML_ATTR];
        }
      }
    },
    destroyEditor: function () {
      if (this._editor) {
        this._editor.destroy();
        this.editorInitialized = false;
        this._editor = null;
      }
    },
    getEditor: function () {
      return this._editor;
    },
    generateManualController: function () {
      var controls = {
        initialize: this.createEditor,
        destroy: this.destroyEditor,
        getEditor: this.getEditor
      };
      this.onManualControllerReady(controls);
    },
    updateModel: function () {
      var modelContent = '';
      if (this.hasSpecialTag) {
        var attributeNodes = this.$el[0].attributes;
        var attrs = {};
        for (var i = 0; i < attributeNodes.length; i++) {
          var attrName = attributeNodes[i].name;
          if (this.currentConfig.vueIgnoreAttrs && this.currentConfig.vueIgnoreAttrs.indexOf(attrName) != -1) {
            continue;
          }
          attrs[attrName] = attributeNodes[i].value;
        }
        if (this.$el[0].innerHTML) {
          attrs[this.INNER_HTML_ATTR] = this.$el[0].innerHTML;
        }
        modelContent = attrs;
      } else {
        var returnedHtml = this._editor.html.get();
        if (typeof returnedHtml === 'string') {
          modelContent = returnedHtml;
        }
      }
      this.oldModel = modelContent;
      this.$emit('input', modelContent);
    },
    initListeners: function () {
      var self = this;
      this.registerEvent('initialized', function () {
        if (self._editor && self._editor.events) {
          // bind contentChange and keyup event to froalaModel
          self._editor.events.on('contentChanged', function () {
            self.updateModel();
          });
          if (self.currentConfig.immediateVueModelUpdate) {
            self._editor.events.on('keyup', function () {
              self.updateModel();
            });
          }
        }
      });
    },
    // register event on editor element
    registerEvent: function (eventName, callback) {
      if (!eventName || !callback) {
        return;
      }

      // Initialized event.
      if (eventName == 'initialized') {
        this.initEvents.push(callback);
      } else {
        if (!this.currentConfig.events) {
          this.currentConfig.events = {};
        }
        this.currentConfig.events[eventName] = callback;
      }
    },
    registerEvents: function () {
      // Handle initialized on its own.
      this.registerInitialized();

      // Get current events.
      var events = this.currentConfig.events;
      if (!events) {
        return;
      }
      for (var event in events) {
        if (events.hasOwnProperty(event) && event != 'initialized') {
          this.registerEvent(event, events[event]);
        }
      }
    },
    registerInitialized: function () {
      // Bind initialized.
      if (!this.currentConfig.events) {
        this.currentConfig.events = {};
      }

      // Set original initialized event.
      if (this.currentConfig.events.initialized) {
        this.registerEvent('initialized', this.currentConfig.events.initialized);
      }

      // Bind initialized event.
      this.currentConfig.events.initialized = () => {
        this.editorInitialized = true;
        for (var i = 0; i < this.initEvents.length; i++) {
          this.initEvents[i].call(this._editor);
        }
      };
    }
  }
});
;// ./src/components/Editor/FroalaEditor.vue?vue&type=script&lang=js
 /* harmony default export */ var Editor_FroalaEditorvue_type_script_lang_js = (FroalaEditorvue_type_script_lang_js); 
;// ./src/components/Editor/FroalaEditor.vue
var FroalaEditor_render, FroalaEditor_staticRenderFns
;



/* normalize component */
;
var FroalaEditor_component = normalizeComponent(
  Editor_FroalaEditorvue_type_script_lang_js,
  FroalaEditor_render,
  FroalaEditor_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FroalaEditor = (FroalaEditor_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/Editor/Editor.ts?vue&type=script&lang=ts&external








var Editor = /** @class */function (_super) {
  __extends(Editor, _super);
  function Editor() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    // Store value localy
    _this.localValue = null;
    return _this;
  }
  Object.defineProperty(Editor.prototype, "computedConfig", {
    // Return editor configuration
    get: function () {
      var _a, _b;
      return Object.assign({
        language: 'fr',
        attribution: false,
        toolbarBottom: false,
        pastePlain: true,
        imageUpload: false,
        videoUpload: false,
        placeholderText: this.placeholder,
        charCounterCount: false
      }, this.modeConfig, this.config, {
        events: merge_default()(this.computedEvents, (_a = this.modeConfig.events) !== null && _a !== void 0 ? _a : {}, (_b = this.config.events) !== null && _b !== void 0 ? _b : {})
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Editor.prototype, "modeConfig", {
    // Return configuration for selected mode
    get: function () {
      switch (this.mode) {
        case 'simple':
          return simple;
        case 'complete':
          return complete;
        case 'pdf':
          return pdf;
        default:
          return {};
      }
    },
    enumerable: false,
    configurable: true
  });
  // Watch for v-model value change
  Editor.prototype.watchValue = function (val) {
    this.localValue = val;
  };
  Object.defineProperty(Editor.prototype, "computedEvents", {
    // Return editor events
    get: function () {
      return Object.assign({
        contentChanged: this.onChange,
        keydown: this.onKeydown
      }, this.events);
    },
    enumerable: false,
    configurable: true
  });
  // Push change and valid data on input event
  Editor.prototype.onChange = function () {
    this.valid();
    return this.getValue();
  };
  // Hide error on keydown event
  Editor.prototype.onKeydown = function () {
    this.hideError();
  };
  // Return value for validation
  Editor.prototype.getValue = function () {
    return this.localValue;
  };
  Editor.prototype.destroyed = function () {
    if (this.$el instanceof HTMLTextAreaElement) {
      this.$el.remove();
    }
  };
  __decorate([Prop({
    default: null
  })], Editor.prototype, "value", void 0);
  __decorate([Prop()], Editor.prototype, "name", void 0);
  __decorate([Prop()], Editor.prototype, "id", void 0);
  __decorate([Prop({
    default: 'textarea'
  })], Editor.prototype, "tag", void 0);
  __decorate([Prop({
    default: ''
  })], Editor.prototype, "placeholder", void 0);
  __decorate([Prop({
    default: function () {
      return {};
    }
  })], Editor.prototype, "config", void 0);
  __decorate([Prop({
    default: function () {
      return {};
    }
  })], Editor.prototype, "events", void 0);
  __decorate([Prop()], Editor.prototype, "size", void 0);
  __decorate([Prop({
    default: 'simple'
  })], Editor.prototype, "mode", void 0);
  __decorate([Watch('value', {
    immediate: true
  })], Editor.prototype, "watchValue", null);
  __decorate([Emit('input')], Editor.prototype, "onChange", null);
  Editor = __decorate([vue_class_component_esm({
    components: {
      Froala: FroalaEditor
    }
  })], Editor);
  return Editor;
}(mixins(mixins_FormValidation));
/* harmony default export */ var Editorvue_type_script_lang_ts_external = (Editor);
;// ./src/components/Editor/Editor.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Editor_Editorvue_type_script_lang_ts_external = (Editorvue_type_script_lang_ts_external); 
;// ./src/components/Editor/Editor.vue





/* normalize component */
;
var Editor_component = normalizeComponent(
  Editor_Editorvue_type_script_lang_ts_external,
  Editorvue_type_template_id_7f7ae98e_render,
  Editorvue_type_template_id_7f7ae98e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Editor_Editor = (Editor_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Editor/FroalaView.vue?vue&type=script&lang=js
/* eslint-disable */

/* harmony default export */ var FroalaViewvue_type_script_lang_js = ({
  props: ['tag', 'value'],
  watch: {
    value: function (newValue) {
      this._element.innerHTML = newValue;
    }
  },
  created: function () {
    this.currentTag = this.tag || this.currentTag;
  },
  render: function (createElement) {
    return createElement(this.currentTag, {
      class: 'fr-view'
    });
  },
  // After first time render.
  mounted: function () {
    this._element = this.$el;
    if (this.value) {
      this._element.innerHTML = this.value;
    }
  },
  data: function () {
    return {
      currentTag: 'div',
      _element: null
    };
  }
});
;// ./src/components/Editor/FroalaView.vue?vue&type=script&lang=js
 /* harmony default export */ var Editor_FroalaViewvue_type_script_lang_js = (FroalaViewvue_type_script_lang_js); 
;// ./src/components/Editor/FroalaView.vue
var FroalaView_render, FroalaView_staticRenderFns
;



/* normalize component */
;
var FroalaView_component = normalizeComponent(
  Editor_FroalaViewvue_type_script_lang_js,
  FroalaView_render,
  FroalaView_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FroalaView = (FroalaView_component.exports);
;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FileUpload/FileUpload.vue?vue&type=template&id=06cae276
var FileUploadvue_type_template_id_06cae276_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: {
      'btn-mode': this.btnMode !== false || _vm.hasButtonSlot,
      'kw-form-control': true
    }
  }, [_vm.hasButtonSlot ? _vm._t("button", null, {
    "selectFile": _vm.selectFile
  }) : _vm.btnMode !== false ? _c('button', {
    class: _vm.computedBtnClass,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.selectFile.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.btnLabel) + " ")]) : _vm._e(), _c('file-pond', _vm._g(_vm._b({
    ref: "filepond"
  }, 'file-pond', _vm.filepondAttributes, false), _vm.filepondEvents))], 2);
};
var FileUploadvue_type_template_id_06cae276_staticRenderFns = [];

;// external "vue-filepond"
var external_vue_filepond_namespaceObject = require("vue-filepond");
var external_vue_filepond_default = /*#__PURE__*/__webpack_require__.n(external_vue_filepond_namespaceObject);
;// external "filepond-plugin-file-validate-size"
var external_filepond_plugin_file_validate_size_namespaceObject = require("filepond-plugin-file-validate-size");
var external_filepond_plugin_file_validate_size_default = /*#__PURE__*/__webpack_require__.n(external_filepond_plugin_file_validate_size_namespaceObject);
;// external "filepond-plugin-file-validate-type"
var external_filepond_plugin_file_validate_type_namespaceObject = require("filepond-plugin-file-validate-type");
var external_filepond_plugin_file_validate_type_default = /*#__PURE__*/__webpack_require__.n(external_filepond_plugin_file_validate_type_namespaceObject);
;// external "filepond-plugin-file-metadata"
var external_filepond_plugin_file_metadata_namespaceObject = require("filepond-plugin-file-metadata");
var external_filepond_plugin_file_metadata_default = /*#__PURE__*/__webpack_require__.n(external_filepond_plugin_file_metadata_namespaceObject);
;// external "filepond-plugin-image-validate-size"
var external_filepond_plugin_image_validate_size_namespaceObject = require("filepond-plugin-image-validate-size");
var external_filepond_plugin_image_validate_size_default = /*#__PURE__*/__webpack_require__.n(external_filepond_plugin_image_validate_size_namespaceObject);
;// external "filepond-plugin-file-poster"
var external_filepond_plugin_file_poster_namespaceObject = require("filepond-plugin-file-poster");
var external_filepond_plugin_file_poster_default = /*#__PURE__*/__webpack_require__.n(external_filepond_plugin_file_poster_namespaceObject);
;// ./local_modules/filepond-plugin-image-editor/FilePondPluginImageEditor.esm.js






/*!
 * Pintura Image Editor 8.13.3
 * (c) 2018-2021 PQINA Inc. - All Rights Reserved
 * License: https://pqina.nl/pintura/license/
 */
/* eslint-disable */

var FilePondPluginImageEditor_esm_isFile = v => v instanceof File;
var FilePondPluginImageEditor_esm_isImage = file => /^image/.test(file.type);
var FilePondPluginImageEditor_esm_isString = v => typeof v === 'string';
let FilePondPluginImageEditor_esm_isSafari = null;
var FilePondPluginImageEditor_esm_isSafari$1 = () => {
  if (FilePondPluginImageEditor_esm_isSafari === null) FilePondPluginImageEditor_esm_isSafari = FilePondPluginImageEditor_esm_isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  return FilePondPluginImageEditor_esm_isSafari;
};
var FilePondPluginImageEditor_esm_getImageElementSize = imageElement => new Promise((resolve, reject) => {
  let shouldAutoRemove = false;
  // test if image is attached to DOM, if not attached, attach so measurement is correct on Safari
  if (!imageElement.parentNode && FilePondPluginImageEditor_esm_isSafari$1()) {
    shouldAutoRemove = true;
    // has width 0 and height 0 to prevent rendering very big SVGs (without width and height) that will for one frame overflow the window and show a scrollbar
    imageElement.style.cssText = `position:absolute;visibility:hidden;pointer-events:none;left:0;top:0;width:0;height:0;`;
    document.body.appendChild(imageElement);
  }
  // start testing size
  const measure = () => {
    const width = imageElement.naturalWidth;
    const height = imageElement.naturalHeight;
    const hasSize = width && height;
    if (!hasSize) return;
    // clean up image if was attached for measuring
    if (shouldAutoRemove) imageElement.parentNode.removeChild(imageElement);
    clearInterval(intervalId);
    resolve({
      width,
      height
    });
  };
  imageElement.onerror = err => {
    clearInterval(intervalId);
    reject(err);
  };
  const intervalId = setInterval(measure, 1);
  measure();
});
var FilePondPluginImageEditor_esm_getImageSize = async image => {
  // the image element we'll use to load the image
  let imageElement = image;
  // if is not an image element, it must be a valid image source
  if (!imageElement.src) {
    imageElement = new Image();
    imageElement.src = FilePondPluginImageEditor_esm_isString(image) ? image : URL.createObjectURL(image);
  }
  let size;
  try {
    size = await FilePondPluginImageEditor_esm_getImageElementSize(imageElement);
  } finally {
    FilePondPluginImageEditor_esm_isFile(image) && URL.revokeObjectURL(imageElement.src);
  }
  return size;
};
var FilePondPluginImageEditor_esm_isBlob = v => v instanceof Blob && !(v instanceof File);
var FilePondPluginImageEditor_esm_noop = (...args) => {};
let FilePondPluginImageEditor_esm_result$3 = null;
var FilePondPluginImageEditor_esm_isBrowser = () => {
  if (FilePondPluginImageEditor_esm_result$3 === null) FilePondPluginImageEditor_esm_result$3 = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  return FilePondPluginImageEditor_esm_result$3;
};
var FilePondPluginImageEditor_esm_h = (name, attributes, children = []) => {
  const el = document.createElement(name);
  // @ts-ignore
  const descriptors = Object.getOwnPropertyDescriptors(el.__proto__);
  for (const key in attributes) {
    if (key === 'style') {
      el.style.cssText = attributes[key];
    } else if (descriptors[key] && descriptors[key].set || /textContent|innerHTML/.test(key) || typeof attributes[key] === 'function') {
      el[key] = attributes[key];
    } else {
      el.setAttribute(key, attributes[key]);
    }
  }
  children.forEach(child => el.appendChild(child));
  return el;
};
var FilePondPluginImageEditor_esm_releaseCanvas = canvas => {
  canvas.width = 1;
  canvas.height = 1;
  const ctx = canvas.getContext('2d');
  ctx && ctx.clearRect(0, 0, 1, 1);
};
let FilePondPluginImageEditor_esm_result$2 = null;
var FilePondPluginImageEditor_esm_supportsWebGL2 = () => {
  if (FilePondPluginImageEditor_esm_result$2 === null) {
    if ('WebGL2RenderingContext' in window) {
      let canvas;
      try {
        canvas = FilePondPluginImageEditor_esm_h('canvas');
        FilePondPluginImageEditor_esm_result$2 = !!canvas.getContext('webgl2');
      } catch (err) {
        FilePondPluginImageEditor_esm_result$2 = false;
      }
      canvas && FilePondPluginImageEditor_esm_releaseCanvas(canvas);
    } else {
      FilePondPluginImageEditor_esm_result$2 = false;
    }
  }
  return FilePondPluginImageEditor_esm_result$2;
};
var FilePondPluginImageEditor_esm_getWebGLContext = (canvas, attrs) => {
  if (FilePondPluginImageEditor_esm_supportsWebGL2()) return canvas.getContext('webgl2', attrs);
  return canvas.getContext('webgl', attrs) || canvas.getContext('experimental-webgl', attrs);
};
let FilePondPluginImageEditor_esm_result$1 = null;
var FilePondPluginImageEditor_esm_supportsWebGL = () => {
  if (FilePondPluginImageEditor_esm_result$1 === null) {
    const canvas = FilePondPluginImageEditor_esm_h('canvas');
    FilePondPluginImageEditor_esm_result$1 = !!FilePondPluginImageEditor_esm_getWebGLContext(canvas);
    FilePondPluginImageEditor_esm_releaseCanvas(canvas);
  }
  return FilePondPluginImageEditor_esm_result$1;
};
const FilePondPluginImageEditor_esm_isOperaMini = () => Object.prototype.toString.call(window['operamini']) === '[object OperaMini]';
const FilePondPluginImageEditor_esm_hasPromises = () => 'Promise' in window;
const FilePondPluginImageEditor_esm_hasCreateObjectURL = () => 'URL' in window && 'createObjectURL' in window.URL;
const FilePondPluginImageEditor_esm_hasVisibility = () => 'visibilityState' in document;
const FilePondPluginImageEditor_esm_hasTiming = () => 'performance' in window; // iOS 8.x
const FilePondPluginImageEditor_esm_hasFileConstructor = () => 'File' in window; // excludes IE11
let FilePondPluginImageEditor_esm_result = null;
var FilePondPluginImageEditor_esm_isModernBrowser = () => {
  if (FilePondPluginImageEditor_esm_result === null) FilePondPluginImageEditor_esm_result = FilePondPluginImageEditor_esm_isBrowser() &&
  // Can't run on Opera Mini due to lack of everything
  !FilePondPluginImageEditor_esm_isOperaMini() &&
  // Require these APIs to feature detect a modern browser
  FilePondPluginImageEditor_esm_hasVisibility() && FilePondPluginImageEditor_esm_hasPromises() && FilePondPluginImageEditor_esm_hasFileConstructor() && FilePondPluginImageEditor_esm_hasCreateObjectURL() && FilePondPluginImageEditor_esm_hasTiming();
  return FilePondPluginImageEditor_esm_result;
};

/**
 * Image Edit Proxy Plugin
 */
const FilePondPluginImageEditor_esm_plugin = _ => {
  const {
    addFilter,
    utils,
    views
  } = _;
  const {
    Type,
    createRoute
  } = utils;
  const {
    fileActionButton
  } = views;
  const getEditorSafe = editor => editor === null ? {} : editor;
  addFilter('SHOULD_REMOVE_ON_REVERT', (shouldRemove, {
    item,
    query
  }) => new Promise(resolve => {
    const {
      file
    } = item;
    // if this file is editable it shouldn't be removed immidiately even when instant uploading
    const canEdit = query('GET_ALLOW_IMAGE_EDITOR') && query('GET_IMAGE_EDITOR_ALLOW_EDIT') && query('GET_IMAGE_EDITOR_SUPPORT_EDIT') && query('GET_IMAGE_EDITOR_SUPPORT_IMAGE')(file);
    // if the file cannot be edited it should be removed on revert
    resolve(!canEdit);
  }));
  // open editor when loading a new item
  addFilter('DID_LOAD_ITEM', (item, {
    query,
    dispatch
  }) => new Promise((resolve, reject) => {
    // if is temp or local file
    if (item.origin > 1) {
      resolve(item);
      return;
    }
    // get file reference
    const {
      file
    } = item;
    if (!query('GET_ALLOW_IMAGE_EDITOR') || !query('GET_IMAGE_EDITOR_INSTANT_EDIT')) return resolve(item);
    // exit if this is not an image
    if (!query('GET_IMAGE_EDITOR_SUPPORT_IMAGE')(file)) return resolve(item);
    // request editing of a file
    const requestEdit = () => {
      if (!editRequestQueue.length) return;
      const {
        item,
        resolve,
        reject
      } = editRequestQueue[0];
      dispatch('EDIT_ITEM', {
        id: item.id,
        handleEditorResponse: createEditorResponseHandler(item, resolve, reject)
      });
    };
    // is called when the user confirms editing the file
    const createEditorResponseHandler = (item, resolve, reject) => userDidConfirm => {
      // remove item
      editRequestQueue.shift();
      // handle item
      if (userDidConfirm) {
        resolve(item);
      } else {
        reject(item);
      }
      // TODO: Fix, should not be needed to kick the internal loop in case no processes are running
      dispatch('KICK');
      // handle next item!
      requestEdit();
    };
    queueEditRequest({
      item,
      resolve,
      reject
    });
    if (editRequestQueue.length === 1) {
      requestEdit();
    }
  }));
  // extend item methods
  addFilter('DID_CREATE_ITEM', (item, {
    query,
    dispatch
  }) => {
    item.extend('edit', () => {
      dispatch('EDIT_ITEM', {
        id: item.id
      });
    });
  });
  const editRequestQueue = [];
  const queueEditRequest = editRequest => {
    editRequestQueue.push(editRequest);
    return editRequest;
  };
  const couldTransformFile = query => {
    // no editor defined, then exit
    const {
      imageProcessor,
      imageReader,
      imageWriter
    } = getEditorSafe(query('GET_IMAGE_EDITOR'));
    return query('GET_IMAGE_EDITOR_WRITE_IMAGE') && query('GET_IMAGE_EDITOR_SUPPORT_WRITE_IMAGE') && imageProcessor && imageReader && imageWriter;
  };
  // called for each view that is created right after the 'create' method
  addFilter('CREATE_VIEW', viewAPI => {
    // get reference to created view
    const {
      is,
      view,
      query
    } = viewAPI;
    if (!query('GET_ALLOW_IMAGE_EDITOR')) return;
    if (!query('GET_IMAGE_EDITOR_SUPPORT_WRITE_IMAGE')) return;
    const supportsFilePoster = query('GET_ALLOW_FILE_POSTER');
    // only run for either the file or the file info panel
    const shouldExtendView = is('file-info') && !supportsFilePoster || is('file') && supportsFilePoster;
    if (!shouldExtendView) return;
    // no editor defined, then exit
    const {
      createEditor,
      imageProcessor,
      imageReader,
      imageWriter,
      editorOptions,
      legacyDataToImageState,
      imageState: imageBaseState
    } = getEditorSafe(query('GET_IMAGE_EDITOR'));
    if (!imageReader || !imageWriter || !editorOptions || !editorOptions.locale) return;
    // remove default image reader and writer if set
    delete editorOptions.imageReader;
    delete editorOptions.imageWriter;
    const [createImageReader, imageReaderOptions] = imageReader;
    const [createImageWriter = FilePondPluginImageEditor_esm_noop, imageWriterOptions] = imageWriter;
    // tests if file item has poster
    const getItemByProps = props => {
      const {
        id
      } = props;
      const item = query('GET_ITEM', id);
      return item;
    };
    const hasPoster = (root, props) => {
      if (!query('GET_ALLOW_FILE_POSTER')) return false;
      const item = getItemByProps(props);
      if (!item) return;
      // test if is filtered
      if (!query('GET_FILE_POSTER_FILTER_ITEM')(item)) return false;
      const poster = item.getMetadata('poster');
      return !!poster;
    };
    // generate preview
    const getPosterTargetSize = (root, targetSize) => {
      const posterHeight = root.query('GET_FILE_POSTER_HEIGHT');
      const maxPosterHeight = root.query('GET_FILE_POSTER_MAX_HEIGHT');
      if (posterHeight) {
        targetSize.width = posterHeight * 2;
        targetSize.height = posterHeight * 2;
      } else if (maxPosterHeight) {
        targetSize.width = maxPosterHeight * 2;
        targetSize.height = maxPosterHeight * 2;
      }
      return targetSize;
    };
    const createEditorOptions = root => {
      const targetSize = getPosterTargetSize(root, {
        width: 512,
        height: 512
      });
      return {
        ...editorOptions,
        imageReader: createImageReader(imageReaderOptions),
        imageWriter: createImageWriter({
          // poster size
          targetSize,
          // can optionally overwrite poster size
          ...(imageWriterOptions || {})
        })
      };
    };
    const createImagePoster = ({
      root,
      props
    }) => {
      // need image processor to create image poster
      if (!imageProcessor) return;
      const item = getItemByProps(props);
      if (!item) return;
      const file = item.file;
      const imageState = item.getMetadata('imageState');
      const options = {
        ...createEditorOptions(root),
        imageState: {
          ...imageBaseState,
          ...imageState
        }
      };
      imageProcessor(file, options).then(({
        dest
      }) => {
        item.setMetadata('poster', URL.createObjectURL(dest), true);
      });
    };
    // opens the editor, if it does not already exist, it creates the editor
    const openImageEditor = ({
      root,
      props,
      action
    }) => {
      const {
        handleEditorResponse
      } = action;
      // get item
      const item = getItemByProps(props);
      // file to open
      const file = item.file;
      // open the editor (sets editor properties and imageState property)
      const editor = createEditor({
        ...createEditorOptions(root),
        src: file
      });
      // when the image has loaded, update the editor
      editor.on('load', ({
        size
      }) => {
        // get current image edit state
        let imageState = item.getMetadata('imageState');
        imageState = legacyDataToImageState ? legacyDataToImageState(editor, size, imageState) : imageState;
        // update editor view based on image edit state
        editor.imageState = {
          ...imageBaseState,
          ...imageState
        };
      });
      editor.on('process', ({
        imageState,
        dest
      }) => {
        // if already has post URL, try to revoke
        const poster = item.getMetadata('poster');
        poster && URL.revokeObjectURL(item.getMetadata('poster'));
        // store state, two seperate actions because we want to trigger preparefile when setting `imageState`
        item.setMetadata('poster', URL.createObjectURL(dest));
        item.setMetadata('imageState', imageState);
        // used in instant edit mode
        if (!handleEditorResponse) return;
        handleEditorResponse(true);
      });
      editor.on('close', () => {
        // used in instant edit mode
        if (!handleEditorResponse) return;
        handleEditorResponse(false);
      });
    };
    //#region view
    const didLoadItem = ({
      root,
      props
    }) => {
      const {
        id
      } = props;
      // try to access item
      const item = query('GET_ITEM', id);
      if (!item) return;
      // get the file object
      const file = item.file;
      // exit if this is not an image
      if (!query('GET_IMAGE_EDITOR_SUPPORT_IMAGE')(file)) return;
      if (query('GET_ALLOW_FILE_POSTER') && !item.getMetadata('poster')) {
        root.dispatch('REQUEST_CREATE_IMAGE_POSTER', {
          id
        });
      }
      if (!query('GET_IMAGE_EDITOR_ALLOW_EDIT') || !query('GET_IMAGE_EDITOR_SUPPORT_EDIT')) return;
      // handle interactions
      root.ref.handleEdit = e => {
        e.stopPropagation();
        root.dispatch('EDIT_ITEM', {
          id
        });
      };
      updateEditButton(root, props);
    };
    const updateEditButton = (root, props) => {
      root.ref.buttonEditItem && root.removeChildView(root.ref.buttonEditItem);
      if (root.ref.editButton && root.ref.editButton.parentNode) {
        root.ref.editButton.parentNode.removeChild(root.ref.editButton);
      }
      if (hasPoster(root, props)) {
        // add edit button to preview
        const buttonView = view.createChildView(fileActionButton, {
          label: 'edit',
          icon: query('GET_IMAGE_EDITOR_ICON_EDIT'),
          opacity: 0
        });
        // edit item classname
        buttonView.element.classList.add('filepond--action-edit-item');
        buttonView.element.dataset.align = query('GET_STYLE_IMAGE_EDITOR_BUTTON_EDIT_ITEM_POSITION');
        buttonView.on('click', root.ref.handleEdit);
        root.ref.buttonEditItem = view.appendChildView(buttonView);
      } else {
        // view is file info
        const filenameElement = view.element.querySelector('.filepond--file-info-main');
        const editButton = document.createElement('button');
        editButton.className = 'filepond--action-edit-item-alt';
        editButton.innerHTML = query('GET_IMAGE_EDITOR_ICON_EDIT') + '<span>edit</span>';
        editButton.addEventListener('click', root.ref.handleEdit);
        filenameElement.appendChild(editButton);
        root.ref.editButton = editButton;
      }
    };
    const didUpdateItemMetadata = ({
      root,
      props,
      action
    }) => {
      if (!/poster/.test(action.change.key)) return;
      if (!query('GET_IMAGE_EDITOR_ALLOW_EDIT') || !query('GET_IMAGE_EDITOR_SUPPORT_EDIT')) return;
      updateEditButton(root, props);
    };
    view.registerDestroyer(({
      root
    }) => {
      if (root.ref.buttonEditItem) {
        root.ref.buttonEditItem.off('click', root.ref.handleEdit);
      }
      if (root.ref.editButton) {
        root.ref.editButton.removeEventListener('click', root.ref.handleEdit);
      }
    });
    const routes = {
      EDIT_ITEM: openImageEditor,
      DID_LOAD_ITEM: didLoadItem,
      DID_UPDATE_ITEM_METADATA: didUpdateItemMetadata,
      DID_REMOVE_ITEM: ({
        props
      }) => {
        const {
          id
        } = props;
        const item = query('GET_ITEM', id);
        if (!item) return;
        const poster = item.getMetadata('poster');
        poster && URL.revokeObjectURL(poster);
      },
      REQUEST_CREATE_IMAGE_POSTER: createImagePoster,
      DID_FILE_POSTER_LOAD: undefined
    };
    if (supportsFilePoster) {
      // view is file
      const didPosterUpdate = ({
        root
      }) => {
        if (!root.ref.buttonEditItem) return;
        root.ref.buttonEditItem.opacity = 1;
      };
      routes.DID_FILE_POSTER_LOAD = didPosterUpdate;
    }
    //#endregion
    // start writing
    view.registerWriter(createRoute(routes));
  });
  //#region write image
  addFilter('SHOULD_PREPARE_OUTPUT', (shouldPrepareOutput, {
    query,
    change,
    item
  }) => new Promise(resolve => {
    if (!query('GET_IMAGE_EDITOR_SUPPORT_IMAGE')(item.file)) return resolve(false);
    if (change && !/imageState/.test(change.key)) return resolve(false);
    resolve(!query('IS_ASYNC'));
  }));
  const shouldTransformFile = (query, file, item) => new Promise(resolve => {
    // invalid item
    if (!couldTransformFile(query) || item.archived || !FilePondPluginImageEditor_esm_isFile(file) && !FilePondPluginImageEditor_esm_isBlob(file) || !query('GET_IMAGE_EDITOR_SUPPORT_IMAGE')(file)) {
      return resolve(false);
    }
    // if size can't be read this browser doesn't support image
    FilePondPluginImageEditor_esm_getImageSize(file).then(() => {
      const fn = query('GET_IMAGE_TRANSFORM_IMAGE_FILTER');
      if (fn) {
        const filterResult = fn(file);
        if (typeof filterResult === 'boolean') {
          return resolve(filterResult);
        }
        if (typeof filterResult.then === 'function') {
          return filterResult.then(resolve);
        }
      }
      resolve(true);
    }).catch(() => {
      resolve(false);
    });
  });
  // subscribe to file transformations
  addFilter('PREPARE_OUTPUT', (file, {
    query,
    item
  }) => {
    const writeOutputImage = file => new Promise((resolve, reject) => {
      const imageState = item.getMetadata('imageState');
      // no editor defined, then exit
      const {
        imageProcessor,
        imageReader,
        imageWriter,
        editorOptions,
        imageState: imageBaseState
      } = getEditorSafe(query('GET_IMAGE_EDITOR'));
      if (!imageProcessor || !imageReader || !imageWriter || !editorOptions) return;
      const [createImageReader, imageReaderOptions] = imageReader;
      const [createImageWriter = FilePondPluginImageEditor_esm_noop, imageWriterOptions] = imageWriter;
      imageProcessor(file, {
        ...editorOptions,
        imageReader: createImageReader(imageReaderOptions),
        imageWriter: createImageWriter(imageWriterOptions),
        imageState: {
          ...imageBaseState,
          ...imageState
        }
      }).then(resolve).catch(reject);
    });
    return new Promise(resolve => {
      shouldTransformFile(query, file, item).then(shouldWrite => {
        if (!shouldWrite) return resolve(file);
        writeOutputImage(file).then(res => {
          const afterFn = query('GET_IMAGE_EDITOR_AFTER_WRITE_IMAGE');
          if (afterFn) return afterFn(res).then(resolve);
          // @ts-ignore
          resolve(res.dest);
        });
      });
    });
  });
  //#endregion
  // Expose plugin options
  return {
    options: {
      // enable or disable image editing
      allowImageEditor: [true, Type.BOOLEAN],
      // open editor when image is dropped
      imageEditorInstantEdit: [false, Type.BOOLEAN],
      // allow editing
      imageEditorAllowEdit: [true, Type.BOOLEAN],
      // cannot edit if no WebGL or is <=IE11
      imageEditorSupportEdit: [FilePondPluginImageEditor_esm_isBrowser() && FilePondPluginImageEditor_esm_isModernBrowser() && FilePondPluginImageEditor_esm_supportsWebGL(), Type.BOOLEAN],
      // receives file and should return true if can edit
      imageEditorSupportImage: [FilePondPluginImageEditor_esm_isImage, Type.FUNCTION],
      // cannot write if is <= IE11
      imageEditorSupportWriteImage: [FilePondPluginImageEditor_esm_isModernBrowser(), Type.BOOLEAN],
      // should output image
      imageEditorWriteImage: [true, Type.BOOLEAN],
      // receives written image and can return single or more images
      imageEditorAfterWriteImage: [undefined, Type.FUNCTION],
      // editor object
      imageEditor: [null, Type.OBJECT],
      // the icon to use for the edit button
      imageEditorIconEdit: ['<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M8.5 17h1.586l7-7L15.5 8.414l-7 7V17zm-1.707-2.707l8-8a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-8 8A1 1 0 0 1 10.5 19h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 .293-.707z" fill="currentColor" fill-rule="nonzero"/></svg>', Type.STRING],
      // location of processing button
      styleImageEditorButtonEditItemPosition: ['bottom center', Type.STRING]
    }
  };
};
// fire pluginloaded event if running in browser, this allows registering the plugin when using async script tags
if (FilePondPluginImageEditor_esm_isBrowser()) document.dispatchEvent(new CustomEvent('FilePond:pluginloaded', {
  detail: FilePondPluginImageEditor_esm_plugin
}));
/* harmony default export */ var FilePondPluginImageEditor_esm = (FilePondPluginImageEditor_esm_plugin);
;// ./src/components/FileUpload/FilePond.ts







var FilePond = external_vue_filepond_default()((external_filepond_plugin_file_validate_size_default()), (external_filepond_plugin_file_validate_type_default()), (external_filepond_plugin_file_metadata_default()), (external_filepond_plugin_image_validate_size_default()), (external_filepond_plugin_file_poster_default()), FilePondPluginImageEditor_esm);
/* harmony default export */ var FileUpload_FilePond = (FilePond);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/FileUpload/FileUpload.ts?vue&type=script&lang=ts&external








var FileUpload = /** @class */function (_super) {
  __extends(FileUpload, _super);
  function FileUpload() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.files = [];
    _this.componentName = 'FileUpload';
    _this.formComponent = null;
    return _this;
  }
  FileUpload.prototype.watchValue = function (val) {
    this.files = val;
  };
  FileUpload.prototype.mounted = function () {
    this.files = this.value;
    // If registerElement method if defined by a parent form component
    // Register the component for data valisation
    if (this.registerElement) {
      this.formComponent = this.registerElement(this);
    }
  };
  FileUpload.prototype.destroyed = function () {
    // If registerElement method if defined by a parent form component
    // Unregister the component from data valisation
    if (this.unRegisterElement) {
      this.unRegisterElement(this);
      this.formComponent = null;
    }
  };
  Object.defineProperty(FileUpload.prototype, "filepondAttributes", {
    get: function () {
      var _this = this;
      // noinspection PointlessBooleanExpressionJS
      return Object.assign({}, this.$t('kwForm.filepond'), {
        credits: '',
        ref: 'filepond',
        name: this.name,
        disabled: this.disabled !== false,
        allowDrop: this.allowDrop !== false,
        allowMultiple: this.multiple !== false,
        maxFiles: this.maxFiles,
        itemInsertLocation: 'after',
        dropOnPage: this.dropOnPage !== false,
        files: this.files,
        instantUpload: this.instantUpload !== false,
        maxParallelUploads: this.maxParallelUploads,
        server: {
          process: function (fieldName, file, metadata, load, error, progress, abort) {
            var _a;
            var formData = _this.uploadFormDatas(new FormData());
            formData.append(_this.name, file, file.name);
            var axiosInstance = (_a = _this.$KwFormConfig.axios) !== null && _a !== void 0 ? _a : (external_axios_default());
            var controller = new AbortController();
            // const CancelToken = axios.CancelToken
            // const source = CancelToken.source()
            axiosInstance({
              method: 'POST',
              url: _this.url,
              data: formData,
              isKForm: true,
              signal: controller.signal,
              // cancelToken: source.token,
              onUploadProgress: function (e) {
                progress(e.lengthComputable, e.loaded, e.total);
              }
            }).then(function (response) {
              _this.returnUploadResponse(response);
              load(response.data);
            }).catch(function (error) {
              if (!external_axios_default().isCancel(error)) {
                _this.returnUploadErrorResponse(error);
                error('Error during upload');
              }
            });
            return {
              abort: function () {
                controller.abort();
                // source.cancel('Operation canceled by the user.')
                abort();
              }
            };
          }
        },
        imageValidateSizeMinWidth: this.validateMinWidth,
        imageValidateSizeMaxWidth: this.validateMaxWidth,
        imageValidateSizeMinHeight: this.validateMinHeight,
        imageValidateSizeMaxHeight: this.validateMaxHeight,
        allowFileTypeValidation: this.accept.length > 0,
        acceptedFileTypes: this.accept,
        minFileSize: this.minSize,
        maxFileSize: this.maxSize,
        onprocessfilestart: this.onUploadStart,
        filePosterMinHeight: this.previewMinHeight,
        filePosterMaxHeight: this.previewMaxHeight,
        allowFilePoster: this.imagePreview !== false,
        imageEditor: this.imageEdit === false ? null : this.imageEditorOptions,
        imageEditorInstantEdit: this.instantImageEdit !== false
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FileUpload.prototype, "imageEditorOptions", {
    get: function () {
      return {
        // Maps legacy data objects to new imageState objects (optional)
        legacyDataToImageState: legacyDataToImageState,
        // Used to create the editor (required)
        createEditor: openEditor,
        // Used for reading the image data. See JavaScript installation for details on the `imageReader` property (required)
        imageReader: [createDefaultImageReader, {
          // createDefaultImageReader options here
        }],
        // Can leave out when not generating a preview thumbnail and/or output image (required)
        imageWriter: [createDefaultImageWriter, {
          targetSize: {
            width: this.resizeWidth,
            height: this.resizeHeight,
            fit: this.resizeMode
          }
        }],
        imageProcessor: processImage,
        editorOptions: this.editorOptions
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FileUpload.prototype, "hasButtonSlot", {
    get: function () {
      return !!this.$slots.button || !!this.$scopedSlots.button;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FileUpload.prototype, "editorOptions", {
    get: function () {
      var options = merge_default()(getEditorDefaults(), {
        locale: this.$t('kwForm.pintura')
      });
      // cropResize
      if (this.cropCircle !== false) {
        options.imageCropAspectRatio = 1;
        options.willRenderCanvas = function (shapes, state) {
          var utilVisibility = state.utilVisibility,
            selectionRect = state.selectionRect,
            lineColor = state.lineColor,
            backgroundColor = state.backgroundColor;
          if (utilVisibility.crop <= 0) return shapes;
          var x = selectionRect.x,
            y = selectionRect.y,
            width = selectionRect.width,
            height = selectionRect.height;
          return __assign(__assign({}, shapes), {
            interfaceShapes: __spreadArray([{
              x: x + width * 0.5,
              y: y + height * 0.5,
              rx: width * 0.5,
              ry: height * 0.5,
              opacity: utilVisibility.crop,
              inverted: true,
              backgroundColor: __spreadArray(__spreadArray([], backgroundColor, true), [0.5], false),
              strokeWidth: 1,
              strokeColor: __spreadArray([], lineColor, true)
            }], shapes.interfaceShapes, true)
          });
        };
      }
      return options;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FileUpload.prototype, "filepondEvents", {
    get: function () {
      var events = {};
      // noinspection PointlessBooleanExpressionJS
      if (this.removeUploadedFile !== false) {
        events.processfile = this.handleFileUpload;
      }
      return events;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FileUpload.prototype, "computedBtnClass", {
    get: function () {
      var css = {
        btn: true
      };
      if (this.btnSize !== null) {
        css['btn-' + this.btnSize] = true;
      }
      if (this.btnTheme !== null) {
        css['btn-' + this.btnTheme] = true;
      }
      return css;
    },
    enumerable: false,
    configurable: true
  });
  FileUpload.prototype.handleFileUpload = function (error, file) {
    if (error === null) {
      var filepond = this.$refs.filepond;
      filepond.removeFile(file.id);
    }
  };
  FileUpload.prototype.uploadFormDatas = function (formData) {
    if (this.method.toLowerCase() === 'put') {
      formData.append('_method', 'PUT');
    }
    if (this.datas) {
      this.parseDatas(formData, this.datas);
    }
    return formData;
  };
  FileUpload.prototype.parseDatas = function (formData, datas, prefix) {
    var _this = this;
    if (prefix === void 0) {
      prefix = null;
    }
    if (datas !== null && typeof datas === 'object') {
      for (var _i = 0, _a = Object.entries(datas); _i < _a.length; _i++) {
        var _b = _a[_i],
          key = _b[0],
          value = _b[1];
        this.parseDatas(formData, value, prefix ? prefix + '[' + key + ']' : key);
      }
    } else if (Array.isArray(datas)) {
      datas.forEach(function (value, index) {
        _this.parseDatas(formData, value, prefix + '[' + index + ']');
      });
    } else if (prefix !== null) {
      if (datas === 'true') datas = String(1);else if (datas === 'false') datas = String(0);else if (typeof datas === 'boolean') datas = Number(datas);else if (datas === null || datas === undefined) datas = '';
      formData.append(prefix, datas);
    }
    return formData;
  };
  FileUpload.prototype.onUploadStart = function (file) {
    return file;
  };
  FileUpload.prototype.returnUploadResponse = function (response) {
    return response.data;
  };
  FileUpload.prototype.returnUploadErrorResponse = function (error) {
    return error.response;
  };
  FileUpload.prototype.selectFile = function () {
    var filepond = this.$refs.filepond;
    filepond.browse();
  };
  FileUpload.prototype.getFiles = function () {
    var filepond = this.$refs.filepond;
    return filepond.getFiles();
  };
  FileUpload.prototype.hasFile = function () {
    return this.getFiles().length > 0;
  };
  FileUpload.prototype.upload = function () {
    var filepond = this.$refs.filepond;
    filepond.processFiles();
  };
  __decorate([Prop({
    default: function () {
      return [];
    }
  })], FileUpload.prototype, "value", void 0);
  __decorate([Prop({
    default: 'file'
  })], FileUpload.prototype, "name", void 0);
  __decorate([Prop({
    default: false
  })], FileUpload.prototype, "disabled", void 0);
  __decorate([Prop({
    default: true
  })], FileUpload.prototype, "allowDrop", void 0);
  __decorate([Prop({
    default: false
  })], FileUpload.prototype, "multiple", void 0);
  __decorate([Prop({
    default: null
  })], FileUpload.prototype, "maxFiles", void 0);
  __decorate([Prop({
    default: false
  })], FileUpload.prototype, "dropOnPage", void 0);
  __decorate([Prop({
    required: true
  })], FileUpload.prototype, "url", void 0);
  __decorate([Prop({
    default: 'POST'
  })], FileUpload.prototype, "method", void 0);
  __decorate([Prop({
    default: null
  })], FileUpload.prototype, "datas", void 0);
  __decorate([Prop({
    default: true
  })], FileUpload.prototype, "instantUpload", void 0);
  __decorate([Prop({
    default: false
  })], FileUpload.prototype, "imageEdit", void 0);
  __decorate([Prop({
    default: false
  })], FileUpload.prototype, "instantImageEdit", void 0);
  __decorate([Prop({
    default: true
  })], FileUpload.prototype, "imagePreview", void 0);
  __decorate([Prop({
    default: 44
  })], FileUpload.prototype, "previewMinHeight", void 0);
  __decorate([Prop({
    default: 256
  })], FileUpload.prototype, "previewMaxHeight", void 0);
  __decorate([Prop({
    default: 1
  })], FileUpload.prototype, "validateMinWidth", void 0);
  __decorate([Prop({
    default: 65535
  })], FileUpload.prototype, "validateMaxWidth", void 0);
  __decorate([Prop({
    default: 1
  })], FileUpload.prototype, "validateMinHeight", void 0);
  __decorate([Prop({
    default: 65535
  })], FileUpload.prototype, "validateMaxHeight", void 0);
  __decorate([Prop({
    default: function () {
      return [];
    }
  })], FileUpload.prototype, "accept", void 0);
  __decorate([Prop({
    default: null
  })], FileUpload.prototype, "minSize", void 0);
  __decorate([Prop({
    default: null
  })], FileUpload.prototype, "maxSize", void 0);
  __decorate([Prop({
    default: null
  })], FileUpload.prototype, "resizeWidth", void 0);
  __decorate([Prop({
    default: null
  })], FileUpload.prototype, "resizeHeight", void 0);
  __decorate([Prop({
    default: 'cover'
  })], FileUpload.prototype, "resizeMode", void 0);
  __decorate([Prop({
    default: false
  })], FileUpload.prototype, "cropCircle", void 0);
  __decorate([Prop({
    default: false
  })], FileUpload.prototype, "btnMode", void 0);
  __decorate([Prop({
    default: 'Sélectionner un fichier'
  })], FileUpload.prototype, "btnLabel", void 0);
  __decorate([Prop({
    default: null
  })], FileUpload.prototype, "btnSize", void 0);
  __decorate([Prop({
    default: 'primary'
  })], FileUpload.prototype, "btnTheme", void 0);
  __decorate([Prop({
    default: function () {
      return ['crop', 'resize', 'filter', 'color'];
    }
  })], FileUpload.prototype, "utils", void 0);
  __decorate([Prop({
    default: false
  })], FileUpload.prototype, "removeUploadedFile", void 0);
  __decorate([Prop({
    default: 1
  })], FileUpload.prototype, "maxParallelUploads", void 0);
  __decorate([Inject({
    from: 'registerElement',
    default: null
  })], FileUpload.prototype, "registerElement", void 0);
  __decorate([Inject({
    from: 'unRegisterElement',
    default: null
  })], FileUpload.prototype, "unRegisterElement", void 0);
  __decorate([Watch('value')], FileUpload.prototype, "watchValue", null);
  __decorate([Emit('onUploadStart')], FileUpload.prototype, "onUploadStart", null);
  __decorate([Emit('onUpload')], FileUpload.prototype, "returnUploadResponse", null);
  __decorate([Emit('onError')], FileUpload.prototype, "returnUploadErrorResponse", null);
  FileUpload = __decorate([vue_class_component_esm({
    components: {
      FilePond: FileUpload_FilePond
    }
  })], FileUpload);
  return FileUpload;
}((external_vue_default()));
/* harmony default export */ var FileUploadvue_type_script_lang_ts_external = (FileUpload);
;// ./src/components/FileUpload/FileUpload.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FileUpload_FileUploadvue_type_script_lang_ts_external = (FileUploadvue_type_script_lang_ts_external); 
;// ./src/components/FileUpload/FileUpload.vue





/* normalize component */
;
var FileUpload_component = normalizeComponent(
  FileUpload_FileUploadvue_type_script_lang_ts_external,
  FileUploadvue_type_template_id_06cae276_render,
  FileUploadvue_type_template_id_06cae276_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FileUpload_FileUpload = (FileUpload_component.exports);
;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Form/Form.vue?vue&type=template&id=6d25d968
var Formvue_type_template_id_6d25d968_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('form', {
    attrs: {
      "action": _vm.action,
      "id": _vm.id,
      "method": _vm.method
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_vm.computedLoading ? _c('div', {
    staticClass: "ajax-form-loading"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.spinnerIcon,
      "spin": ""
    }
  })], 1) : _vm._e(), _vm._t("default"), _c('b-modal', {
    attrs: {
      "ok-only": true,
      "content-class": "form-global-errors"
    },
    model: {
      value: _vm.globalErrorsState,
      callback: function ($$v) {
        _vm.globalErrorsState = $$v;
      },
      expression: "globalErrorsState"
    }
  }, [_vm._v(" " + _vm._s(_vm.computedAjaxGlobalErrors) + " ")]), _vm.login && _vm.$KwFormConfig.loginComponent ? _c('div', {
    staticClass: "kform-login"
  }, [_c(_vm.$KwFormConfig.loginComponent, _vm._b({
    tag: "component",
    on: {
      "logged": function ($event) {
        _vm.login = false;
      }
    }
  }, 'component', _vm.loginAttributes, false))], 1) : _vm._e()], 2);
};
var Formvue_type_template_id_6d25d968_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/lodash/forOwn.js
var forOwn = __webpack_require__(5596);
var forOwn_default = /*#__PURE__*/__webpack_require__.n(forOwn);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faSpinnerThird.js
var faSpinnerThird = __webpack_require__(5149);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/Form/Form.ts?vue&type=script&lang=ts&external












var Form = /** @class */function (_super) {
  __extends(Form, _super);
  function Form() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.loading = false; // Loader state
    _this.elements = []; // Component who need validation
    _this.ajaxGlobalErrors = null; // Store errors who are not directly linked to a form element
    _this.globalErrorsState = false;
    _this.spinnerIcon = faSpinnerThird/* faSpinnerThird */.sq;
    _this.login = false;
    return _this;
  }
  Form.prototype.mounted = function () {
    this.form = this.$el;
    this.form.$formComponent = this;
  };
  Object.defineProperty(Form.prototype, "computedLoading", {
    get: function () {
      return this.noFormLoader === false && this.loading === true;
    },
    enumerable: false,
    configurable: true
  });
  // Add component for validation
  Form.prototype.registerElement = function (component) {
    var _a, _b, _c;
    this.elements.push({
      name: (_b = (_a = component.name) !== null && _a !== void 0 ? _a : component.validationName) !== null && _b !== void 0 ? _b : null,
      component: component,
      componentName: (_c = component.componentName) !== null && _c !== void 0 ? _c : null
    });
    return this;
  };
  // Remove a component for validation
  Form.prototype.unRegisterElement = function (component) {
    this.elements = this.elements.filter(function (el) {
      return el.component !== component;
    });
  };
  // Return all elements who need validation
  Form.prototype.getElements = function () {
    return this.elements;
  };
  Object.defineProperty(Form.prototype, "computedParent", {
    // Return parent paremeter to use
    get: function () {
      var _a, _b;
      var parent = this.parent;
      if (parent) {
        return parent;
      }
      if ((_b = (_a = this.$KwFormConfig) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.parent) {
        return this.$KwFormConfig.form.parent;
      }
      return this.$root.$el;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Form.prototype, "computedAjaxGlobalErrors", {
    // Return global errors for display
    get: function () {
      return this.ajaxGlobalErrors && this.ajaxGlobalErrors.join('\n');
    },
    enumerable: false,
    configurable: true
  });
  // Valid all elements
  Form.prototype.validElements = function () {
    var _this = this;
    var errors = [];
    var nbErrors = 0;
    this.elements.forEach(function (element) {
      if (typeof element.component.valid !== 'function' || element.component.disabled === true) {
        return;
      }
      var error = element.component.valid(!_this.showOnlyFirstError || _this.showOnlyFirstError && nbErrors === 0);
      if (error) {
        nbErrors++;
        errors.push({
          component: element.component,
          name: element.name,
          errors: error
        });
      }
    });
    return errors.length === 0 ? null : errors;
  };
  // When form is submitted
  Form.prototype.onSubmit = function () {
    var errors = this.validElements();
    if (errors) {
      // If errors
      this.goToError(errors);
      this.$emit('validationErrors', errors);
      return;
    }
    if (this.validateDatas) {
      var customValidation = this.validateDatas(this.getFormDatas());
      if (customValidation === false) {
        this.$emit('validateDatasErrors');
        // Stop form submission
        return;
      } else if (typeof customValidation === 'object') {
        // If object, show error and stop form submission
        this.showAjaxValidationErrors(customValidation);
        this.$emit('validateDatasErrors');
        return;
      }
    }
    if (this.ajax === false) {
      // Normal form submission
      this.form.submit();
    } else {
      // If valid and ajax submission
      this.ajaxSubmit();
    }
  };
  // Scroll or show the element with errors if needed
  Form.prototype.goToError = function (errors) {
    if (errors.length === 0) {
      return;
    }
    var error = errors[0];
    var component = error.component.$el;
    if (component.offsetParent === null) {
      // Check if child of tabs component
      var parentTab = component.closest('[role="tabpanel"]');
      if (parentTab && parentTab.__vue__) {
        var parent = parentTab.__vue__.$parent;
        if (parent instanceof (external_vue_default()) && parent.activate) {
          parent.activate();
          return;
        }
      }
      // Check if child of collapse component
      var parentAccordion = component.closest('.collapse');
      if (parentAccordion) {
        this.$root.$emit('bv::toggle::collapse', parentAccordion.id);
      }
    } else if (!this.isInViewport(component)) {
      var el = void 0;
      var parentModal = component.closest('.modal-body');
      if (parentModal) {
        el = parentModal;
      } else {
        el = typeof this.computedParent === 'string' ? document.querySelector(this.computedParent) : this.computedParent;
      }
      if (el) {
        var offset = component.offsetTop - 10;
        if (offset < 0) offset = 0;
        el.scrollTop = offset;
      }
    }
  };
  // Prepare datas from form v-model for ajax send
  Form.prototype.injectObject = function (object, formData, prefix) {
    var _this = this;
    forOwn_default()(object, function (value, key) {
      var newPrefix = prefix ? prefix + '[' + key + ']' : key;
      if (Array.isArray(value) && value.length === 0) {
        formData.set(newPrefix, '');
      } else if (typeof value === 'object' && value !== null) {
        _this.injectObject(value, formData, newPrefix);
      } else {
        formData.set(newPrefix, value);
      }
    });
  };
  // Return the form datas
  Form.prototype.getFormDatas = function () {
    // Prepare form datas
    // Use v-model instead of form datas if exist
    var formData = new FormData(!this.value ? this.form : undefined);
    if (this.value) {
      this.injectObject(this.value, formData);
    } else {
      // Remove Fileupload component element
      this.elements.forEach(function (element) {
        switch (element.componentName) {
          case 'FileUpload':
            formData.delete(element.name);
            break;
          case 'Select':
            // eslint-disable-next-line no-case-declarations
            var name = element.name;
            if (!name) {
              break;
            }
            // eslint-disable-next-line no-case-declarations
            var hasArrayName = name.substr(-2) === '[]';
            if (element.component.multiple === false || !hasArrayName) {
              // If no multiple selection
              break;
            }
            if (formData.has(name)) {
              // If present in FormData and not empty
              if (formData.get(name) !== '') {
                break;
              }
              // Delete if empty
              formData.delete(name);
            }
            formData.append(name.substr(0, name.length - 2), '');
            break;
        }
      });
    }
    // Transform boolean to text for Laravel validation
    // And set false null values to empty
    formData.forEach(function (e, i) {
      if (e === 'true') formData.set(i, String(1));else if (e === 'false') formData.set(i, String(0));else if (e === 'null') formData.set(i, '');
    });
    return formData;
  };
  // Submit form with Ajax
  Form.prototype.ajaxSubmit = function () {
    var _a;
    return __awaiter(this, void 0, Promise, function () {
      var formData, method, axiosInstance;
      var _this = this;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            formData = this.getFormDatas();
            if (!this.beforeSubmit) return [3 /*break*/, 2];
            return [4 /*yield*/, this.beforeSubmit(formData)];
          case 1:
            _b.sent();
            _b.label = 2;
          case 2:
            // Send event
            this.$emit('beforeSubmit', formData);
            // If datas must be append to the request
            if (this.ajaxDatas) {
              this.ajaxDatas.forEach(function (v, i) {
                formData.append(i, v);
              });
            }
            method = this.method.toLowerCase();
            if (method !== 'get' && method !== 'post') {
              formData.append('_method', method);
              method = 'post';
            }
            this.loading = true;
            this.ajaxGlobalErrors = null;
            axiosInstance = (_a = this.$KwFormConfig.axios) !== null && _a !== void 0 ? _a : (external_axios_default());
            return [4 /*yield*/, axiosInstance({
              method: method,
              url: this.action,
              data: formData,
              headers: this.ajaxHeaders,
              isKForm: true
            }).then(function (response) {
              _this.$emit('submitComplete', response);
            }).catch(function (error) {
              return __awaiter(_this, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                  response = error.response;
                  if (response.status === 401) {
                    if (this.$KwFormConfig.loginComponent && this.dontAskLogin === false) {
                      this.login = true;
                    }
                  } else if (response.status === 422 && response.data.errors !== undefined) {
                    // If form validation error
                    this.showAjaxValidationErrors(response.data.errors);
                  }
                  this.$emit('submitError', error);
                  if (this.keepLoaderAfterSubmit !== false) {
                    this.loading = false;
                  }
                  return [2 /*return*/];
                });
              });
            }).finally(function () {
              if (_this.keepLoaderAfterSubmit === false) {
                _this.loading = false;
              }
            })];
          case 3:
            _b.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  Object.defineProperty(Form.prototype, "loginAttributes", {
    get: function () {
      var options = this.$KwFormConfig.loginAttributes;
      if (!options) {
        return {};
      } else if (typeof options === 'function') {
        return options(this);
      } else {
        return options;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Form.prototype, "ajaxHeaders", {
    // Return headers to use for ajax form submission
    get: function () {
      return Object.assign({}, this.$KwFormConfig.headers, {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json'
      });
    },
    enumerable: false,
    configurable: true
  });
  // Laravel return xx.yy instead of xx[yy]
  // transformation of the key to find the input name
  Form.prototype.parseAttributeName = function (key) {
    var finalKey = key;
    if (finalKey.indexOf('.') !== -1) {
      finalKey.split('.').forEach(function (k, i) {
        if (i === 0) finalKey = k;else {
          finalKey += '[' + k + ']';
        }
      });
    }
    return finalKey;
  };
  Form.prototype.showAjaxValidationErrors = function (errors) {
    // If the error not correspond to an input, store it for global display
    var unattributes = [];
    var _loop_1 = function (key) {
      var finalKey = this_1.parseAttributeName(key);
      // Find the component
      var element = this_1.elements.find(function (e) {
        return e.name === finalKey || e.name === finalKey + '[]';
      });
      if (element) {
        // Show the error
        element.component.showError(errors[key]);
      } else {
        unattributes.push.apply(unattributes, errors[key]);
      }
    };
    var this_1 = this;
    // List all errors
    for (var key in errors) {
      _loop_1(key);
    }
    if (unattributes.length > 0) {
      this.ajaxGlobalErrors = unattributes;
      this.globalErrorsState = true;
    }
  };
  // Check if an element is present in viewport
  Form.prototype.isInViewport = function (element) {
    var rect = element.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  };
  /**
   * Method for submitting the form
   */
  Form.prototype.submit = function () {
    var _this = this;
    this.$nextTick(function () {
      _this.onSubmit();
    });
  };
  __decorate([Prop({
    default: null
  })], Form.prototype, "value", void 0);
  __decorate([Prop({
    required: true
  })], Form.prototype, "action", void 0);
  __decorate([Prop({
    default: 'post'
  })], Form.prototype, "method", void 0);
  __decorate([Prop({
    default: null
  })], Form.prototype, "id", void 0);
  __decorate([Prop({
    default: true
  })], Form.prototype, "ajax", void 0);
  __decorate([Prop({
    default: null
  })], Form.prototype, "ajaxDatas", void 0);
  __decorate([Prop({
    default: true
  })], Form.prototype, "showOnlyFirstError", void 0);
  __decorate([Prop({
    default: false
  })], Form.prototype, "noFormLoader", void 0);
  __decorate([Prop({
    default: false
  })], Form.prototype, "keepLoaderAfterSubmit", void 0);
  __decorate([Prop()], Form.prototype, "parent", void 0);
  __decorate([Prop({
    default: null
  })], Form.prototype, "validateDatas", void 0);
  __decorate([Prop({
    default: false
  })], Form.prototype, "dontAskLogin", void 0);
  __decorate([Prop({
    default: null
  })], Form.prototype, "beforeSubmit", void 0);
  __decorate([Provide('registerElement')], Form.prototype, "registerElement", null);
  __decorate([Provide('unRegisterElement')], Form.prototype, "unRegisterElement", null);
  Form = __decorate([vue_class_component_esm({
    components: {
      BModal: external_bootstrap_vue_namespaceObject.BModal,
      BSpinner: external_bootstrap_vue_namespaceObject.BSpinner,
      FontAwesomeIcon: vue_fontawesome_namespaceObject.FontAwesomeIcon
    }
  })], Form);
  return Form;
}((external_vue_default()));
/* harmony default export */ var Formvue_type_script_lang_ts_external = (Form);
;// ./src/components/Form/Form.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Form_Formvue_type_script_lang_ts_external = (Formvue_type_script_lang_ts_external); 
;// ./src/components/Form/Form.vue





/* normalize component */
;
var Form_component = normalizeComponent(
  Form_Formvue_type_script_lang_ts_external,
  Formvue_type_template_id_6d25d968_render,
  Formvue_type_template_id_6d25d968_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Form_Form = (Form_component.exports);
;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InputNumber/InputNumber.vue?vue&type=template&id=87efa90a
var InputNumbervue_type_template_id_87efa90a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: {
      'kw-form-control': true,
      'datetime-group': true,
      'required-indicator': this.required !== false
    }
  }, [_vm.prepend || _vm.append ? _c('b-input-group', {
    attrs: {
      "append": _vm.append,
      "append-html": _vm.appendHtml,
      "prepend": _vm.prepend,
      "prepend-html": _vm.prependHtml,
      "tag": _vm.tag,
      "size": _vm.size
    }
  }, [_c('b-form-input', {
    staticClass: "form-number",
    attrs: {
      "type": "number",
      "name": _vm.name,
      "id": _vm.id,
      "disabled": _vm.disabled,
      "required": _vm.required,
      "autofocus": _vm.autofocus,
      "size": _vm.size,
      "state": _vm.computedState,
      "readonly": _vm.readonly,
      "plaintext": _vm.plaintext,
      "placeholder": _vm.placeholder,
      "step": "any"
    },
    on: {
      "change": _vm.onChange,
      "input": _vm.onInput,
      "blur": _vm.onBlur,
      "focus": _vm.onFocus,
      "keydown": _vm.onKeyDown
    },
    model: {
      value: _vm.inputValue,
      callback: function ($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1) : _c('b-form-input', {
    staticClass: "form-number",
    attrs: {
      "type": "number",
      "name": _vm.name,
      "id": _vm.id,
      "disabled": _vm.disabled,
      "required": _vm.required,
      "autofocus": _vm.autofocus,
      "size": _vm.size,
      "state": _vm.computedState,
      "readonly": _vm.readonly,
      "plaintext": _vm.plaintext,
      "placeholder": _vm.placeholder,
      "step": "any"
    },
    on: {
      "change": _vm.onChange,
      "input": _vm.onInput,
      "blur": _vm.onBlur,
      "focus": _vm.onFocus,
      "keydown": _vm.onKeyDown
    },
    model: {
      value: _vm.inputValue,
      callback: function ($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1);
};
var InputNumbervue_type_template_id_87efa90a_staticRenderFns = [];

;// ./src/mixins/FormNumber.ts




var FormNumber = /** @class */function (_super) {
  __extends(FormNumber, _super);
  function FormNumber() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.inputElement = null;
    _this.inputValue = null;
    _this.oldValue = null;
    return _this;
  }
  Object.defineProperty(FormNumber.prototype, "computedMin", {
    get: function () {
      return this.min !== null ? Number(this.min.toString()) : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FormNumber.prototype, "computedMax", {
    get: function () {
      return this.max !== null ? Number(this.max.toString()) : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FormNumber.prototype, "customRules", {
    get: function () {
      var rules = {};
      if (this.maxDecimal === 0) rules.integer = true;else rules.decimal = true;
      if (this.computedMin !== null) {
        rules.min = String(this.computedMin);
      }
      if (this.computedMax !== null) {
        rules.max = String(this.computedMax);
      }
      return rules;
    },
    enumerable: false,
    configurable: true
  });
  FormNumber.prototype.watchValue = function (val) {
    // noinspection PointlessBooleanExpressionJS
    var local = typeof this.inputValue === 'number' ? this.inputValue : this.inputValue ? parseFloat(this.inputValue) : this.noDefaultValue === false ? 0 : null;
    if (parseFloat(val) !== local) {
      this.updateValue(val);
    }
  };
  // On change event
  FormNumber.prototype.onChange = function (val) {
    this.updateValue(val);
    this.valid();
    this.$emit('change', this.getValue(), this.oldValue);
  };
  // On input event
  FormNumber.prototype.onInput = function () {
    this.$emit('input', this.getValue(), this.oldValue);
  };
  // On blur event
  FormNumber.prototype.onBlur = function () {
    this.valid();
    this.updateValue(this.inputValue);
    this.oldValue = this.inputValue;
    return this.inputValue;
  };
  // On key down event
  FormNumber.prototype.onKeyDown = function (evt) {
    this.hideError();
    return evt;
  };
  // noinspection JSUnusedGlobalSymbols
  FormNumber.prototype.onFocus = function () {
    if (this.readonly !== false) {
      return;
    }
    this.oldValue = this.inputValue;
    // noinspection PointlessBooleanExpressionJS
    if (this.inputValue === 0 && this.noDefaultValue === false) {
      this.inputValue = null;
    }
  };
  FormNumber.prototype.mounted = function () {
    // noinspection PointlessBooleanExpressionJS
    if (this.noDefaultValue === false) {
      this.inputValue = 0;
    }
    this.inputElement = this.$el.querySelector('input');
    this.updateValue(this.value);
  };
  FormNumber.prototype.getElement = function () {
    if (this.inputElement === null) {
      throw new Error('Input element can\'t be null');
    }
    return this.inputElement;
  };
  FormNumber.prototype.getValue = function () {
    if (this.inputValue === null || this.inputValue === '') {
      // noinspection PointlessBooleanExpressionJS
      return this.noDefaultValue === false ? 0 : null;
    }
    return typeof this.inputValue === 'string' ? parseFloat(this.inputValue) : this.inputValue;
  };
  // Update input value
  FormNumber.prototype.updateValue = function (val) {
    if (val === '' || val === undefined || val === null) {
      // noinspection PointlessBooleanExpressionJS
      val = this.noDefaultValue === false ? 0 : null;
    }
    if (typeof val === 'string') {
      if (val.substr(val.length - 1) === '.') {
        this.inputValue = val;
        return;
      }
      val = parseFloat(val);
    }
    if (val !== null && this.maxDecimal !== null) {
      var pourcent = 1;
      for (var i = 0; i < this.maxDecimal; i++) {
        pourcent = pourcent * 10;
      }
      val = (Math.round(val * pourcent) / pourcent).toFixed(this.maxDecimal);
    }
    this.inputValue = val === null ? null : parseFloat(String(val));
    if (this.inputValue !== this.value) {
      this.onInput();
    }
  };
  __decorate([Prop({
    default: null
  })], FormNumber.prototype, "value", void 0);
  __decorate([Prop({
    default: 2
  })], FormNumber.prototype, "maxDecimal", void 0);
  __decorate([Prop({
    default: null
  })], FormNumber.prototype, "min", void 0);
  __decorate([Prop({
    default: null
  })], FormNumber.prototype, "max", void 0);
  __decorate([Prop({
    default: false
  })], FormNumber.prototype, "noDefaultValue", void 0);
  __decorate([Watch('value')], FormNumber.prototype, "watchValue", null);
  __decorate([Emit('blur')], FormNumber.prototype, "onBlur", null);
  __decorate([Emit('keydown')], FormNumber.prototype, "onKeyDown", null);
  FormNumber = __decorate([vue_class_component_esm], FormNumber);
  return FormNumber;
}(mixins(mixins_BootstrapInput, mixins_FormValidation));
/* harmony default export */ var mixins_FormNumber = (FormNumber);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/InputNumber/InputNumber.ts?vue&type=script&lang=ts&external




var InputNumber = /** @class */function (_super) {
  __extends(InputNumber, _super);
  function InputNumber() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  __decorate([Prop()], InputNumber.prototype, "prepend", void 0);
  __decorate([Prop()], InputNumber.prototype, "prependHtml", void 0);
  __decorate([Prop()], InputNumber.prototype, "append", void 0);
  __decorate([Prop()], InputNumber.prototype, "appendHtml", void 0);
  __decorate([Prop()], InputNumber.prototype, "tag", void 0);
  InputNumber = __decorate([vue_class_component_esm({
    components: {
      BFormInput: external_bootstrap_vue_namespaceObject.BFormInput,
      BInputGroup: external_bootstrap_vue_namespaceObject.BInputGroup
    }
  })], InputNumber);
  return InputNumber;
}(mixins(mixins_FormNumber));
/* harmony default export */ var InputNumbervue_type_script_lang_ts_external = (InputNumber);
;// ./src/components/InputNumber/InputNumber.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var InputNumber_InputNumbervue_type_script_lang_ts_external = (InputNumbervue_type_script_lang_ts_external); 
;// ./src/components/InputNumber/InputNumber.vue





/* normalize component */
;
var InputNumber_component = normalizeComponent(
  InputNumber_InputNumbervue_type_script_lang_ts_external,
  InputNumbervue_type_template_id_87efa90a_render,
  InputNumbervue_type_template_id_87efa90a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InputNumber_InputNumber = (InputNumber_component.exports);
;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PeriodSelect/PeriodSelect.vue?vue&type=template&id=785aeac7
var PeriodSelectvue_type_template_id_785aeac7_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('b-dropdown', {
    ref: "dropdown",
    class: {
      'kw-form-period': true,
      'with-compare': _vm.canCompare !== false && _vm.compare
    },
    attrs: {
      "no-caret": "",
      "right": _vm.dropdownRight
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('div', {
          staticClass: "kw-form-period-indicator"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v(" " + _vm._s(_vm.selectedPreset.label) + " ")]), _vm._v(" " + _vm._s(_vm.date(_vm.begin)) + " "), _c('font-awesome-icon', {
          staticClass: "mx-2",
          attrs: {
            "icon": _vm.icon
          }
        }), _vm._v(" " + _vm._s(_vm.date(_vm.end)) + " "), _vm.canCompare !== false && _vm.compare ? _c('p', {
          staticClass: "mb-0 small text-right"
        }, [_vm._v(" Comparer : " + _vm._s(_vm.date(_vm.compareBegin)) + " "), _c('font-awesome-icon', {
          staticClass: "mx-2",
          attrs: {
            "icon": _vm.icon
          }
        }), _vm._v(" " + _vm._s(_vm.date(_vm.compareEnd)) + " ")], 1) : _vm._e()], 1)];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-text', {
    attrs: {
      "tag": "div"
    }
  }, [_c('div', {
    class: {
      'kw-form-period-select': true
    }
  }, [_c('b-list-group', {
    staticClass: "small"
  }, _vm._l(_vm.periods, function (period, i) {
    return _c('b-list-group-item', {
      key: i,
      attrs: {
        "button": "",
        "active": period.key === _vm.preset,
        "disabled": period.key === 'custom'
      },
      on: {
        "click": function ($event) {
          return _vm.selectPeriod(period.key);
        }
      }
    }, [_vm._v(" " + _vm._s(period.label) + " ")]);
  }), 1), _c('div', {
    staticClass: "pt-1"
  }, [_c('b-row', {
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    staticClass: "pr-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-form-group', {
    staticClass: "mr-2 mb-0",
    attrs: {
      "label": "Début",
      "label-class": "small"
    }
  }, [_c('k-form-datepicker', {
    attrs: {
      "max-date": _vm.end,
      "size": "sm"
    },
    on: {
      "input": _vm.selectDates
    },
    model: {
      value: _vm.begin,
      callback: function ($$v) {
        _vm.begin = $$v;
      },
      expression: "begin"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "pl-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Fin",
      "label-class": "small"
    }
  }, [_c('k-form-datepicker', {
    attrs: {
      "min-date": _vm.begin,
      "size": "sm"
    },
    on: {
      "input": _vm.selectDates
    },
    model: {
      value: _vm.end,
      callback: function ($$v) {
        _vm.end = $$v;
      },
      expression: "end"
    }
  })], 1)], 1), _vm.canCompare !== false ? _c('b-col', {
    staticClass: "mb-1 pr-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('k-form-checkbox', {
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.compare,
      callback: function ($$v) {
        _vm.compare = $$v;
      },
      expression: "compare"
    }
  }, [_vm._v(" Comparer ")])], 1) : _vm._e(), _vm.canCompare !== false && _vm.compare ? [_c('b-col', {
    staticClass: "pr-0 pl-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-form-group', {
    staticClass: "mr-2 mb-0",
    attrs: {
      "label": "Début",
      "label-class": "small"
    }
  }, [_c('k-form-datepicker', {
    attrs: {
      "max-date": _vm.compareEnd,
      "size": "sm"
    },
    on: {
      "input": _vm.selectCompareDates
    },
    model: {
      value: _vm.compareBegin,
      callback: function ($$v) {
        _vm.compareBegin = $$v;
      },
      expression: "compareBegin"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "pl-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Fin",
      "label-class": "small"
    }
  }, [_c('k-form-datepicker', {
    attrs: {
      "min-date": _vm.compareBegin,
      "size": "sm"
    },
    on: {
      "input": _vm.selectCompareDates
    },
    model: {
      value: _vm.compareEnd,
      callback: function ($$v) {
        _vm.compareEnd = $$v;
      },
      expression: "compareEnd"
    }
  })], 1)], 1)] : _vm._e()], 2), _c('datepicker', {
    ref: "calendar",
    attrs: {
      "attributes": _vm.compareDates,
      "is-range": "",
      "columns": 2
    },
    on: {
      "input": _vm.applyRange
    },
    model: {
      value: _vm.range,
      callback: function ($$v) {
        _vm.range = $$v;
      },
      expression: "range"
    }
  })], 1), _vm.compare ? _c('b-list-group', {
    staticClass: "small"
  }, _vm._l(_vm.comparePeriods, function (period, i) {
    return _c('b-list-group-item', {
      key: i,
      attrs: {
        "button": "",
        "active": period.key === _vm.comparePreset,
        "disabled": period.key === 'custom'
      },
      on: {
        "click": function ($event) {
          return _vm.selectComparePeriod(period.key);
        }
      }
    }, [_vm._v(" " + _vm._s(period.label) + " ")]);
  }), 1) : _vm._e()], 1)])], 1);
};
var PeriodSelectvue_type_template_id_785aeac7_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/faArrowRight.js
var faArrowRight = __webpack_require__(6150);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/PeriodSelect/PeriodSelect.ts?vue&type=script&lang=ts&external











var PeriodSelect = /** @class */function (_super) {
  __extends(PeriodSelect, _super);
  function PeriodSelect() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.icon = faArrowRight/* faArrowRight */.dm;
    _this.preset = 'current_year';
    _this.applyingPreset = false;
    _this.begin = null;
    _this.end = null;
    _this.range = null;
    _this.compare = false;
    _this.comparePreset = 'previous';
    _this.compareBegin = null;
    _this.compareEnd = null;
    _this.compareRange = null;
    _this.initialized = false;
    _this.date = function (date) {
      var _a;
      if (date === undefined || date === null || date === '') {
        return '';
      }
      var format = (_a = _this.$KwFormConfig.dateFormat) !== null && _a !== void 0 ? _a : 'DD-MM-YYYY';
      if (typeof format === 'string') {
        return external_moment_default()(date).format(format);
      }
      return format(date);
    };
    return _this;
  }
  PeriodSelect.prototype.mounted = function () {
    var _this = this;
    this.initialized = false;
    this.initializeDatas();
    this.selectPeriod(this.preset);
    this.$nextTick(function () {
      _this.initialized = true;
    });
  };
  PeriodSelect.prototype.initializeDatas = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var datas = this.datas;
    if (!datas) {
      return;
    }
    this.preset = (_a = datas.preset) !== null && _a !== void 0 ? _a : 'current_year';
    this.begin = (_b = datas.begin) !== null && _b !== void 0 ? _b : null;
    this.end = (_c = datas.end) !== null && _c !== void 0 ? _c : null;
    if (this.canCompare !== false) {
      this.compare = (_d = datas.compare) !== null && _d !== void 0 ? _d : false;
      this.comparePreset = (_e = datas.presetCompare) !== null && _e !== void 0 ? _e : 'previous';
      this.compareBegin = (_f = datas.beginCompare) !== null && _f !== void 0 ? _f : null;
      this.compareEnd = (_g = datas.endCompare) !== null && _g !== void 0 ? _g : null;
    }
  };
  Object.defineProperty(PeriodSelect.prototype, "periods", {
    get: function () {
      return [{
        key: 'custom',
        label: 'Personnalisé'
      }, {
        key: 'current_year',
        label: 'Cette année'
      }, {
        key: 'previous_year',
        label: 'Année dernière'
      }, {
        key: 'current_month',
        label: 'Ce mois'
      }, {
        key: 'previous_month',
        label: 'Mois dernier'
      }, {
        key: 'current_week',
        label: 'Cette semaine'
      }, {
        key: 'previous_week',
        label: 'Semaine dernière'
      }, {
        key: 'last_30_days',
        label: 'Les 30 derniers jours'
      }, {
        key: 'last_60_days',
        label: 'Les 60 derniers jours'
      }, {
        key: 'last_90_days',
        label: 'Les 90 derniers jours'
      }, {
        key: 'last_12_months',
        label: 'Les 12 derniers mois'
      }];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PeriodSelect.prototype, "comparePeriods", {
    get: function () {
      return [{
        key: 'custom',
        label: 'Personnalisé'
      }, {
        key: 'previous',
        label: 'Période précédente'
      }, {
        key: 'previous_year',
        label: 'Même période l\'année dernière'
      }];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PeriodSelect.prototype, "selectedPreset", {
    get: function () {
      var _this = this;
      return this.periods.find(function (period) {
        return period.key === _this.preset;
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PeriodSelect.prototype, "compareDates", {
    get: function () {
      if (!this.compare || !this.compareRange) {
        return [];
      }
      return [{
        highlight: {
          style: {
            background: '#f9cc7d'
          }
        },
        dates: this.compareRange
      }];
    },
    enumerable: false,
    configurable: true
  });
  PeriodSelect.prototype.selectPeriod = function (key) {
    var _this = this;
    this.preset = key;
    switch (key) {
      case 'current_year':
        this.begin = external_moment_default()().startOf('year').format('YYYY-MM-DD');
        this.end = external_moment_default()().endOf('year').format('YYYY-MM-DD');
        break;
      case 'previous_year':
        this.begin = external_moment_default()().subtract(1, 'year').startOf('year').format('YYYY-MM-DD');
        this.end = external_moment_default()().subtract(1, 'year').endOf('year').format('YYYY-MM-DD');
        break;
      case 'current_month':
        this.begin = external_moment_default()().startOf('month').format('YYYY-MM-DD');
        this.end = external_moment_default()().endOf('month').format('YYYY-MM-DD');
        break;
      case 'previous_month':
        this.begin = external_moment_default()().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
        this.end = external_moment_default()().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
        break;
      case 'current_week':
        this.begin = external_moment_default()().startOf('week').add('1', 'day').format('YYYY-MM-DD');
        this.end = external_moment_default()().endOf('week').add('1', 'day').format('YYYY-MM-DD');
        break;
      case 'previous_week':
        this.begin = external_moment_default()().subtract(1, 'week').startOf('week').add('1', 'day').format('YYYY-MM-DD');
        this.end = external_moment_default()().subtract(1, 'week').endOf('week').add('1', 'day').format('YYYY-MM-DD');
        break;
      case 'last_30_days':
        this.begin = external_moment_default()().subtract(30, 'day').format('YYYY-MM-DD');
        this.end = external_moment_default()().subtract(1, 'day').format('YYYY-MM-DD');
        break;
      case 'last_60_days':
        this.begin = external_moment_default()().subtract(60, 'day').format('YYYY-MM-DD');
        this.end = external_moment_default()().subtract(1, 'day').format('YYYY-MM-DD');
        break;
      case 'last_90_days':
        this.begin = external_moment_default()().subtract(90, 'day').format('YYYY-MM-DD');
        this.end = external_moment_default()().subtract(1, 'day').format('YYYY-MM-DD');
        break;
      case 'last_12_months':
        this.begin = external_moment_default()().subtract(1, 'day').subtract(12, 'months').format('YYYY-MM-DD');
        this.end = external_moment_default()().subtract(1, 'day').format('YYYY-MM-DD');
        break;
    }
    this.applyingPreset = true;
    this.applyDates();
    this.$nextTick(function () {
      _this.applyingPreset = false;
    });
  };
  PeriodSelect.prototype.selectDates = function () {
    if (this.applyingPreset) {
      return;
    }
    this.preset = 'custom';
    this.applyDates();
  };
  PeriodSelect.prototype.applyDates = function () {
    if (this.begin && this.end) {
      this.range = {
        start: this.begin,
        end: this.end
      };
      if (this.canCompare !== false && this.compare) {
        this.selectComparePeriod(this.comparePreset);
      } else {
        this.datasUpdated();
      }
    }
  };
  PeriodSelect.prototype.applyRange = function () {
    if (this.applyingPreset) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.$refs.calendar.move(this.end);
    } else if (this.range) {
      this.begin = external_moment_default()(this.range.start).format('YYYY-MM-DD');
      this.end = external_moment_default()(this.range.end).format('YYYY-MM-DD');
      this.preset = 'custom';
    }
  };
  PeriodSelect.prototype.selectCompareDates = function () {
    if (this.applyingPreset) {
      return;
    }
    this.comparePreset = 'custom';
    this.applyCompareDates();
  };
  PeriodSelect.prototype.applyCompareDates = function () {
    if (this.compareBegin && this.compareEnd) {
      this.compareRange = {
        start: this.compareBegin + 'T00:00:00.000Z',
        end: this.compareEnd + 'T00:00:00.000Z'
      };
      this.datasUpdated();
    }
  };
  PeriodSelect.prototype.watchCompare = function () {
    if (this.canCompare !== false && this.compare) {
      this.selectComparePeriod(this.comparePreset);
    }
  };
  PeriodSelect.prototype.watchCompareDisabled = function () {
    if (!this.initialized) {
      return;
    }
    if (this.canCompare !== false && !this.compare) {
      this.datasUpdated();
    }
    var dropdown = this.$refs.dropdown;
    dropdown.hide();
    this.$nextTick(function () {
      dropdown.show();
    });
  };
  PeriodSelect.prototype.selectComparePeriod = function (key) {
    var _this = this;
    this.comparePreset = key;
    var nbDays = external_moment_default()(this.end).diff(external_moment_default()(this.begin), 'days');
    var base;
    switch (key) {
      case 'previous':
        base = external_moment_default()(this.begin).subtract(1, 'day');
        switch (this.preset) {
          case 'current_year':
          case 'previous_year':
            this.compareBegin = base.clone().startOf('year').format('YYYY-MM-DD');
            this.compareEnd = base.clone().endOf('year').format('YYYY-MM-DD');
            break;
          case 'current_month':
          case 'previous_month':
            this.compareBegin = base.clone().startOf('month').format('YYYY-MM-DD');
            this.compareEnd = base.clone().endOf('month').format('YYYY-MM-DD');
            break;
          case 'current_week':
          case 'previous_week':
            this.compareBegin = base.clone().startOf('week').format('YYYY-MM-DD');
            this.compareEnd = base.clone().endOf('week').format('YYYY-MM-DD');
            break;
          default:
            this.compareBegin = external_moment_default()(this.begin).subtract(nbDays, 'days').format('YYYY-MM-DD');
            this.compareEnd = external_moment_default()(this.end).subtract(nbDays + 1, 'days').format('YYYY-MM-DD');
        }
        break;
      case 'previous_year':
        this.compareBegin = external_moment_default()(this.begin).subtract(1, 'year').format('YYYY-MM-DD');
        this.compareEnd = external_moment_default()(this.end).subtract(1, 'year').format('YYYY-MM-DD');
        break;
    }
    this.applyingPreset = true;
    this.applyCompareDates();
    this.$nextTick(function () {
      _this.applyingPreset = false;
    });
  };
  PeriodSelect.prototype.datasUpdated = function () {
    var datas = {
      preset: this.preset,
      begin: this.begin,
      end: this.end
    };
    if (this.canCompare !== false) {
      datas.compare = this.compare;
      datas.presetCompare = this.comparePreset;
      datas.beginCompare = this.compareBegin;
      datas.endCompare = this.compareEnd;
    }
    this.$emit('updated', datas);
  };
  __decorate([Prop({
    default: null
  })], PeriodSelect.prototype, "datas", void 0);
  __decorate([Prop({
    default: false
  })], PeriodSelect.prototype, "canCompare", void 0);
  __decorate([Prop({
    default: false
  })], PeriodSelect.prototype, "dropdownRight", void 0);
  __decorate([Watch('compare'), Watch('begin'), Watch('end')], PeriodSelect.prototype, "watchCompare", null);
  __decorate([Watch('compare')], PeriodSelect.prototype, "watchCompareDisabled", null);
  PeriodSelect = __decorate([vue_class_component_esm({
    components: {
      datepicker: components_DatePicker,
      BListGroup: external_bootstrap_vue_namespaceObject.BListGroup,
      BListGroupItem: external_bootstrap_vue_namespaceObject.BListGroupItem,
      BFormGroup: external_bootstrap_vue_namespaceObject.BFormGroup,
      BBadge: external_bootstrap_vue_namespaceObject.BBadge,
      BRow: external_bootstrap_vue_namespaceObject.BRow,
      BCol: external_bootstrap_vue_namespaceObject.BCol,
      BDropdown: external_bootstrap_vue_namespaceObject.BDropdown,
      BDropdownText: external_bootstrap_vue_namespaceObject.BDropdownText,
      KFormDatepicker: DatePicker_DatePicker,
      KFormCheckbox: Checkbox_Checkbox,
      FontAwesomeIcon: vue_fontawesome_namespaceObject.FontAwesomeIcon
    }
  })], PeriodSelect);
  return PeriodSelect;
}((external_vue_default()));
/* harmony default export */ var PeriodSelectvue_type_script_lang_ts_external = (PeriodSelect);
;// ./src/components/PeriodSelect/PeriodSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PeriodSelect_PeriodSelectvue_type_script_lang_ts_external = (PeriodSelectvue_type_script_lang_ts_external); 
;// ./src/components/PeriodSelect/PeriodSelect.vue





/* normalize component */
;
var PeriodSelect_component = normalizeComponent(
  PeriodSelect_PeriodSelectvue_type_script_lang_ts_external,
  PeriodSelectvue_type_template_id_785aeac7_render,
  PeriodSelectvue_type_template_id_785aeac7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PeriodSelect_PeriodSelect = (PeriodSelect_component.exports);
;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Phone/Phone.vue?vue&type=template&id=c8c010c2
var Phonevue_type_template_id_c8c010c2_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: {
      'kw-form-control': true,
      'required-indicator': _vm.required !== false
    }
  }, [_vm.name ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.vModelValue,
      expression: "vModelValue"
    }],
    attrs: {
      "type": "hidden",
      "name": _vm.name
    },
    domProps: {
      "value": _vm.vModelValue
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.vModelValue = $event.target.value;
      }
    }
  }) : _vm._e(), _c('b-form-input', {
    ref: "input",
    staticClass: "iti__tel-input",
    attrs: {
      "type": "tel",
      "id": _vm.id,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus,
      "size": _vm.size,
      "state": _vm.computedState,
      "readonly": _vm.readonly,
      "plaintext": _vm.plaintext,
      "placeholder": _vm.phonePlaceholder,
      "autocomplete": "off"
    },
    on: {
      "change": _vm.onChange,
      "input": _vm.onInput,
      "blur": _vm.onBlur,
      "keydown": _vm.onKeyDown
    },
    model: {
      value: _vm.localValue,
      callback: function ($$v) {
        _vm.localValue = $$v;
      },
      expression: "localValue"
    }
  })], 1);
};
var Phonevue_type_template_id_c8c010c2_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/intl-tel-input/build/js/intlTelInputWithUtils.js
var intlTelInputWithUtils = __webpack_require__(5623);
var intlTelInputWithUtils_default = /*#__PURE__*/__webpack_require__.n(intlTelInputWithUtils);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/Phone/Phone.ts?vue&type=script&lang=ts&external






var Phone = /** @class */function (_super) {
  __extends(Phone, _super);
  function Phone() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.intlInstance = null;
    _this.inputElement = null;
    _this.phonePlaceholder = '';
    _this.localValue = null;
    _this.vModelValue = null;
    return _this;
  }
  Phone.prototype.watchValue = function (val) {
    if (!this.intlInstance || !this.inputElement) return;
    if (val === null) {
      this.localValue = null;
      this.vModelValue = null;
    } else {
      // Set number with intl and get formated value
      this.intlInstance.setNumber(val);
      this.localValue = this.inputElement.value;
      // Get internationnal number
      this.vModelValue = this.intlInstance.getNumber();
    }
  };
  Phone.prototype.mounted = function () {
    var _this = this;
    var bInput = this.$refs.input;
    this.inputElement = bInput.$el;
    external_vue_default().nextTick(function () {
      _this.initIntl();
      _this.watchValue(_this.value);
    });
  };
  Phone.prototype.destroyed = function () {
    this.destroyIntl();
  };
  Object.defineProperty(Phone.prototype, "customRules", {
    get: function () {
      // Add phone validation rules
      return {
        phone: true
      };
    },
    enumerable: false,
    configurable: true
  });
  Phone.prototype.countryChange = function () {
    this.onInput();
    return this.intlInstance && JSON.parse(JSON.stringify(this.intlInstance.getSelectedCountryData()));
  };
  // On change event
  Phone.prototype.onChange = function () {
    this.updateValues();
    this.valid();
    return this.vModelValue;
  };
  // On input event
  Phone.prototype.onInput = function () {
    this.updateValues();
    return this.vModelValue;
  };
  // On blur event
  Phone.prototype.onBlur = function () {
    if (!this.inputElement) {
      return null;
    }
    this.valid();
    return this.vModelValue;
  };
  // On key down event
  Phone.prototype.onKeyDown = function () {
    this.hideError();
  };
  // Update values
  Phone.prototype.updateValues = function () {
    if (!this.inputElement || !this.intlInstance) {
      return;
    }
    this.vModelValue = this.intlInstance.getNumber();
    this.localValue = this.inputElement.value;
  };
  // Return the input element
  Phone.prototype.getElement = function () {
    if (this.inputElement === null) {
      throw new Error('Phone element can\'t be null');
    }
    return this.inputElement;
  };
  // Return phone value
  Phone.prototype.getValue = function () {
    return this.intlInstance && this.intlInstance.getNumber();
  };
  // Initialize intl instance
  Phone.prototype.initIntl = function () {
    if (this.intlInstance) {
      this.destroyIntl();
    }
    var element = this.getElement();
    this.intlInstance = intlTelInputWithUtils_default()(element, this.getOptions());
    // Store instance on element
    element.intlInstance = this.intlInstance;
    element.addEventListener('countrychange', this.countryChange);
  };
  // Destroy intl instance
  Phone.prototype.destroyIntl = function () {
    if (this.intlInstance) {
      this.intlInstance.destroy();
      this.getElement().removeEventListener('countrychange', this.countryChange);
    }
    this.intlInstance = null;
  };
  // Return the placeholder to show
  Phone.prototype.placeholderOption = function (defaultValue) {
    var _a, _b;
    var placeholder = (_b = (_a = this.customPlaceholder) !== null && _a !== void 0 ? _a : this.placeholder) !== null && _b !== void 0 ? _b : defaultValue;
    placeholder = String(placeholder);
    this.phonePlaceholder = placeholder;
    return placeholder;
  };
  Phone.prototype.getAllowDropdown = function () {
    return this.readonly ? false : this.allowDropdown;
  };
  // Return intl option
  Phone.prototype.getOptions = function () {
    var _this = this;
    var opts = {
      customPlaceholder: this.placeholderOption,
      allowDropdown: this.getAllowDropdown()
    };
    if (this.allowDropdown) opts.allowDropdown = this.allowDropdown;
    // if (this.autoHideDialCode) opts.autoHideDialCode = this.autoHideDialCode
    if (this.autoPlaceholder) opts.autoPlaceholder = this.autoPlaceholder;
    if (this.customPlaceholder) opts.customPlaceholder = this.customPlaceholder;
    if (this.dropdownContainer) opts.dropdownContainer = this.dropdownContainer;
    if (this.excludeCountries) opts.excludeCountries = this.excludeCountries;
    if (this.formatOnDisplay) opts.formatOnDisplay = this.formatOnDisplay;
    if (this.geoIpLookup) opts.geoIpLookup = this.geoIpLookup;
    if (this.hiddenInput) opts.hiddenInput = function () {
      return {
        phone: _this.hiddenInput
      };
    };
    if (this.initialCountry) opts.initialCountry = this.initialCountry;
    //if (this.localizedCountries) opts.localizedCountries = this.localizedCountries
    if (this.nationalMode) opts.nationalMode = this.nationalMode;
    if (this.onlyCountries) opts.onlyCountries = this.onlyCountries;
    if (this.placeholderNumberType) opts.placeholderNumberType = this.placeholderNumberType;
    //if (this.preferredCountries) opts.preferredCountries = this.preferredCountries
    if (this.separateDialCode) opts.separateDialCode = this.separateDialCode;
    return opts;
  };
  Phone.prototype.watchOptions = function () {
    this.initIntl();
  };
  __decorate([Prop({
    default: null
  })], Phone.prototype, "value", void 0);
  __decorate([Prop({
    default: true
  })], Phone.prototype, "allowDropdown", void 0);
  __decorate([Prop()], Phone.prototype, "autoHideDialCode", void 0);
  __decorate([Prop()], Phone.prototype, "autoPlaceholder", void 0);
  __decorate([Prop()], Phone.prototype, "customPlaceholder", void 0);
  __decorate([Prop()], Phone.prototype, "dropdownContainer", void 0);
  __decorate([Prop()], Phone.prototype, "excludeCountries", void 0);
  __decorate([Prop({
    default: true
  })], Phone.prototype, "formatOnDisplay", void 0);
  __decorate([Prop()], Phone.prototype, "geoIpLookup", void 0);
  __decorate([Prop()], Phone.prototype, "hiddenInput", void 0);
  __decorate([Prop({
    default: 'fr'
  })], Phone.prototype, "initialCountry", void 0);
  __decorate([Prop()], Phone.prototype, "localizedCountries", void 0);
  __decorate([Prop({
    default: true
  })], Phone.prototype, "nationalMode", void 0);
  __decorate([Prop()], Phone.prototype, "onlyCountries", void 0);
  __decorate([Prop({
    default: 'FIXED_LINE'
  })], Phone.prototype, "placeholderNumberType", void 0);
  __decorate([Prop({
    default: function () {
      return ['fr', 'de', 'be', 'it', 'ch', 'gb'];
    }
  })], Phone.prototype, "preferredCountries", void 0);
  __decorate([Prop({
    default: false
  })], Phone.prototype, "separateDialCode", void 0);
  __decorate([Watch('value')], Phone.prototype, "watchValue", null);
  __decorate([Emit()], Phone.prototype, "countryChange", null);
  __decorate([Emit('change')], Phone.prototype, "onChange", null);
  __decorate([Emit('input')], Phone.prototype, "onInput", null);
  __decorate([Emit('blur')], Phone.prototype, "onBlur", null);
  __decorate([Watch('readonly'), Watch('placeholderOption'), Watch('allowDropdown'), Watch('autoHideDialCode'), Watch('autoPlaceholder'), Watch('customPlaceholder'), Watch('dropdownContainer'), Watch('excludeCountries'), Watch('formatOnDisplay'), Watch('geoIpLookup'), Watch('hiddenInput'), Watch('initialCountry'), Watch('localizedCountries'), Watch('nationalMode'), Watch('onlyCountries'), Watch('placeholderNumberType'), Watch('preferredCountries'), Watch('separateDialCode')], Phone.prototype, "watchOptions", null);
  Phone = __decorate([vue_class_component_esm({
    components: {
      BFormInput: external_bootstrap_vue_namespaceObject.BFormInput
    }
  })], Phone);
  return Phone;
}(mixins(mixins_FormValidation, mixins_BootstrapInput));
/* harmony default export */ var Phonevue_type_script_lang_ts_external = (Phone);
;// ./src/components/Phone/Phone.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Phone_Phonevue_type_script_lang_ts_external = (Phonevue_type_script_lang_ts_external); 
;// ./src/components/Phone/Phone.vue





/* normalize component */
;
var Phone_component = normalizeComponent(
  Phone_Phonevue_type_script_lang_ts_external,
  Phonevue_type_template_id_c8c010c2_render,
  Phonevue_type_template_id_c8c010c2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Phone_Phone = (Phone_component.exports);
;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Spinner/Spinner.vue?vue&type=template&id=7b672e7c
var Spinnervue_type_template_id_7b672e7c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: {
      'spinner-wrapper': true,
      'horizontal-alignment': !_vm.vertical,
      'vertical-alignment': _vm.vertical,
      'left-placement': _vm.vertical && _vm.left !== false,
      'kw-form-control': true
    }
  }, [_vm.vertical === false ? _c('b-button', {
    attrs: {
      "variant": _vm.theme,
      "disabled": _vm.decrementState
    },
    on: {
      "click": _vm.decrement
    }
  }, [_vm._v(" - ")]) : _vm._e(), _c('div', {
    class: {
      'required-indicator': this.required !== false
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "name": _vm.name,
      "id": _vm.id,
      "disabled": _vm.disabled,
      "required": _vm.required,
      "autofocus": _vm.autofocus,
      "size": _vm.size,
      "state": _vm.computedState,
      "readonly": _vm.readonly,
      "plaintext": _vm.plaintext,
      "placeholder": _vm.placeholder,
      "step": "any"
    },
    on: {
      "change": _vm.onChange,
      "input": _vm.onInput,
      "blur": _vm.onBlur,
      "focus": _vm.onFocus,
      "keydown": _vm.onKeyDown
    },
    model: {
      value: _vm.inputValue,
      callback: function ($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1), _vm.vertical === false ? _c('b-button', {
    attrs: {
      "variant": _vm.theme,
      "disabled": _vm.incrementState
    },
    on: {
      "click": _vm.increment
    }
  }, [_vm._v(" + ")]) : _vm._e(), _vm.vertical !== false ? _c('div', {
    staticClass: "spinner-controls"
  }, [_c('b-button', {
    attrs: {
      "variant": _vm.theme,
      "disabled": _vm.incrementState
    },
    on: {
      "click": _vm.increment
    }
  }, [_vm._v("+")]), _c('b-button', {
    attrs: {
      "variant": _vm.theme,
      "disabled": _vm.decrementState
    },
    on: {
      "click": _vm.decrement
    }
  }, [_vm._v("-")])], 1) : _vm._e()], 1);
};
var Spinnervue_type_template_id_7b672e7c_staticRenderFns = [];

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/Spinner/Spinner.ts?vue&type=script&lang=ts&external




var NumberComponent = /** @class */function (_super) {
  __extends(NumberComponent, _super);
  function NumberComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(NumberComponent.prototype, "incrementState", {
    get: function () {
      return this.disabled || this.readonly || this.max !== null && this.inputValue !== null && this.inputValue >= this.max;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NumberComponent.prototype, "decrementState", {
    get: function () {
      return this.disabled || this.readonly || this.min !== null && this.inputValue !== null && this.inputValue <= this.min;
    },
    enumerable: false,
    configurable: true
  });
  NumberComponent.prototype.increment = function () {
    this.applyValue(this.step);
  };
  NumberComponent.prototype.decrement = function () {
    this.applyValue(-this.step);
  };
  NumberComponent.prototype.applyValue = function (step) {
    var _a;
    var value = (_a = this.inputValue) !== null && _a !== void 0 ? _a : 0;
    if (typeof value === 'string') value = parseFloat(value);
    value = value + step;
    this.inputValue = value;
    this.valid();
    var min = this.computedMin;
    if (min !== null && min > value) {
      this.inputValue = min;
    }
    var max = this.computedMax;
    if (max !== null && max < value) {
      this.inputValue = max;
    }
    this.onInput();
    this.$emit('change', this.getValue(), this.oldValue);
  };
  __decorate([Prop({
    default: 0
  })], NumberComponent.prototype, "maxDecimal", void 0);
  __decorate([Prop({
    default: 1
  })], NumberComponent.prototype, "step", void 0);
  __decorate([Prop({
    default: true
  })], NumberComponent.prototype, "vertical", void 0);
  __decorate([Prop({
    default: false
  })], NumberComponent.prototype, "left", void 0);
  __decorate([Prop({
    default: null
  })], NumberComponent.prototype, "theme", void 0);
  NumberComponent = __decorate([vue_class_component_esm({
    components: {
      BFormInput: external_bootstrap_vue_namespaceObject.BFormInput,
      BButton: external_bootstrap_vue_namespaceObject.BButton
    }
  })], NumberComponent);
  return NumberComponent;
}(mixins(mixins_FormNumber));
/* harmony default export */ var Spinnervue_type_script_lang_ts_external = (NumberComponent);
;// ./src/components/Spinner/Spinner.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Spinner_Spinnervue_type_script_lang_ts_external = (Spinnervue_type_script_lang_ts_external); 
;// ./src/components/Spinner/Spinner.vue





/* normalize component */
;
var Spinner_component = normalizeComponent(
  Spinner_Spinnervue_type_script_lang_ts_external,
  Spinnervue_type_template_id_7b672e7c_render,
  Spinnervue_type_template_id_7b672e7c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Spinner = (Spinner_component.exports);
;// ./node_modules/bootstrap-vue/src/constants/env.js
const HAS_WINDOW_SUPPORT = typeof window !== 'undefined'
const HAS_DOCUMENT_SUPPORT = typeof document !== 'undefined'
const HAS_NAVIGATOR_SUPPORT = typeof navigator !== 'undefined'
const HAS_PROMISE_SUPPORT = typeof Promise !== 'undefined'
/* istanbul ignore next: JSDOM always returns false */
const HAS_MUTATION_OBSERVER_SUPPORT =
  typeof MutationObserver !== 'undefined' ||
  typeof WebKitMutationObserver !== 'undefined' ||
  typeof MozMutationObserver !== 'undefined'

const IS_BROWSER = HAS_WINDOW_SUPPORT && HAS_DOCUMENT_SUPPORT && HAS_NAVIGATOR_SUPPORT

const env_WINDOW = HAS_WINDOW_SUPPORT ? window : {}
const env_DOCUMENT = HAS_DOCUMENT_SUPPORT ? document : {}
const NAVIGATOR = HAS_NAVIGATOR_SUPPORT ? navigator : {}
const USER_AGENT = (NAVIGATOR.userAgent || '').toLowerCase()

const IS_JSDOM = USER_AGENT.indexOf('jsdom') > 0
const IS_IE = /msie|trident/.test(USER_AGENT)

// Determine if the browser supports the option passive for events
const HAS_PASSIVE_EVENT_SUPPORT = (() => {
  let passiveEventSupported = false
  if (IS_BROWSER) {
    try {
      const options = {
        // This function will be called when the browser
        // attempts to access the passive property
        get passive() {
          /* istanbul ignore next: will never be called in JSDOM */
          passiveEventSupported = true
        }
      }
      env_WINDOW.addEventListener('test', options, options)
      env_WINDOW.removeEventListener('test', options, options)
    } catch {
      /* istanbul ignore next: will never be called in JSDOM */
      passiveEventSupported = false
    }
  }
  return passiveEventSupported
})()

const HAS_TOUCH_SUPPORT =
  IS_BROWSER && ('ontouchstart' in env_DOCUMENT.documentElement || NAVIGATOR.maxTouchPoints > 0)

const HAS_POINTER_EVENT_SUPPORT =
  IS_BROWSER && Boolean(env_WINDOW.PointerEvent || env_WINDOW.MSPointerEvent)

/* istanbul ignore next: JSDOM only checks for 'IntersectionObserver' */
const HAS_INTERACTION_OBSERVER_SUPPORT =
  IS_BROWSER &&
  'IntersectionObserver' in env_WINDOW &&
  'IntersectionObserverEntry' in env_WINDOW &&
  // Edge 15 and UC Browser lack support for `isIntersecting`
  // but we an use `intersectionRatio > 0` instead
  // 'isIntersecting' in window.IntersectionObserverEntry.prototype &&
  'intersectionRatio' in env_WINDOW.IntersectionObserverEntry.prototype

;// ./node_modules/bootstrap-vue/src/constants/safe-types.js


/* istanbul ignore next */
const safe_types_Element = HAS_WINDOW_SUPPORT ? env_WINDOW.Element : class Element extends Object {}

/* istanbul ignore next */
const safe_types_HTMLElement = HAS_WINDOW_SUPPORT
  ? env_WINDOW.HTMLElement
  : class HTMLElement extends safe_types_Element {}

/* istanbul ignore next */
const SVGElement = HAS_WINDOW_SUPPORT
  ? env_WINDOW.SVGElement
  : class SVGElement extends safe_types_Element {}

/* istanbul ignore next */
const safe_types_File = HAS_WINDOW_SUPPORT ? env_WINDOW.File : class File extends Object {}

;// ./node_modules/bootstrap-vue/src/utils/dom.js







// --- Constants ---

const ELEMENT_PROTO = safe_types_Element.prototype

const TABABLE_SELECTOR = [
  'button',
  '[href]:not(.disabled)',
  'input',
  'select',
  'textarea',
  '[tabindex]',
  '[contenteditable]'
]
  .map(s => `${s}:not(:disabled):not([disabled])`)
  .join(', ')

// --- Normalization utils ---

// See: https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
/* istanbul ignore next */
const matchesEl =
  ELEMENT_PROTO.matches || ELEMENT_PROTO.msMatchesSelector || ELEMENT_PROTO.webkitMatchesSelector

// See: https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
/* istanbul ignore next */
const closestEl =
  ELEMENT_PROTO.closest ||
  function(sel) {
    let el = this
    do {
      // Use our "patched" matches function
      if (matches(el, sel)) {
        return el
      }
      el = el.parentElement || el.parentNode
    } while (!isNull(el) && el.nodeType === Node.ELEMENT_NODE)
    return null
  }

// `requestAnimationFrame()` convenience method
/* istanbul ignore next: JSDOM always returns the first option */
const requestAF = (
  env_WINDOW.requestAnimationFrame ||
  env_WINDOW.webkitRequestAnimationFrame ||
  env_WINDOW.mozRequestAnimationFrame ||
  env_WINDOW.msRequestAnimationFrame ||
  env_WINDOW.oRequestAnimationFrame ||
  // Fallback, but not a true polyfill
  // Only needed for Opera Mini
  /* istanbul ignore next */
  (cb => setTimeout(cb, 16))
).bind(env_WINDOW)

const MutationObs =
  env_WINDOW.MutationObserver || env_WINDOW.WebKitMutationObserver || env_WINDOW.MozMutationObserver || null

// --- Utils ---

// Remove a node from DOM
const dom_removeNode = el => el && el.parentNode && el.parentNode.removeChild(el)

// Determine if an element is an HTML element
const dom_isElement = el => !!(el && el.nodeType === Node.ELEMENT_NODE)

// Get the currently active HTML element
const getActiveElement = (excludes = []) => {
  const { activeElement } = DOCUMENT
  return activeElement && !excludes.some(el => el === activeElement) ? activeElement : null
}

// Returns `true` if a tag's name equals `name`
const isTag = (tag, name) => toString(tag).toLowerCase() === toString(name).toLowerCase()

// Determine if an HTML element is the currently active element
const isActiveElement = el => dom_isElement(el) && el === getActiveElement()

// Determine if an HTML element is visible - Faster than CSS check
const isVisible = el => {
  if (!dom_isElement(el) || !el.parentNode || !dom_contains(env_DOCUMENT.body, el)) {
    // Note this can fail for shadow dom elements since they
    // are not a direct descendant of document.body
    return false
  }
  if (getStyle(el, 'display') === 'none') {
    // We do this check to help with vue-test-utils when using v-show
    /* istanbul ignore next */
    return false
  }
  // All browsers support getBoundingClientRect(), except JSDOM as it returns all 0's for values :(
  // So any tests that need isVisible will fail in JSDOM
  // Except when we override the getBCR prototype in some tests
  const bcr = getBCR(el)
  return !!(bcr && bcr.height > 0 && bcr.width > 0)
}

// Determine if an element is disabled
const isDisabled = el =>
  !dom_isElement(el) || el.disabled || hasAttr(el, 'disabled') || hasClass(el, 'disabled')

// Cause/wait-for an element to reflow its content (adjusting its height/width)
const reflow = el => {
  // Requesting an elements offsetHight will trigger a reflow of the element content
  /* istanbul ignore next: reflow doesn't happen in JSDOM */
  return dom_isElement(el) && el.offsetHeight
}

// Select all elements matching selector. Returns `[]` if none found
const selectAll = (selector, root) =>
  arrayFrom((dom_isElement(root) ? root : DOCUMENT).querySelectorAll(selector))

// Select a single element, returns `null` if not found
const dom_select = (selector, root) =>
  (dom_isElement(root) ? root : DOCUMENT).querySelector(selector) || null

// Determine if an element matches a selector
const matches = (el, selector) => (dom_isElement(el) ? matchesEl.call(el, selector) : false)

// Finds closest element matching selector. Returns `null` if not found
const closest = (selector, root, includeRoot = false) => {
  if (!dom_isElement(root)) {
    return null
  }
  const el = closestEl.call(root, selector)

  // Native closest behaviour when `includeRoot` is truthy,
  // else emulate jQuery closest and return `null` if match is
  // the passed in root element when `includeRoot` is falsey
  return includeRoot ? el : el === root ? null : el
}

// Returns true if the parent element contains the child element
const dom_contains = (parent, child) =>
  parent && inspect_isFunction(parent.contains) ? parent.contains(child) : false

// Get an element given an ID
const getById = id => DOCUMENT.getElementById(/^#/.test(id) ? id.slice(1) : id) || null

// Add a class to an element
const addClass = (el, className) => {
  // We are checking for `el.classList` existence here since IE 11
  // returns `undefined` for some elements (e.g. SVG elements)
  // See https://github.com/bootstrap-vue/bootstrap-vue/issues/2713
  if (className && dom_isElement(el) && el.classList) {
    el.classList.add(className)
  }
}

// Remove a class from an element
const removeClass = (el, className) => {
  // We are checking for `el.classList` existence here since IE 11
  // returns `undefined` for some elements (e.g. SVG elements)
  // See https://github.com/bootstrap-vue/bootstrap-vue/issues/2713
  if (className && dom_isElement(el) && el.classList) {
    el.classList.remove(className)
  }
}

// Test if an element has a class
const hasClass = (el, className) => {
  // We are checking for `el.classList` existence here since IE 11
  // returns `undefined` for some elements (e.g. SVG elements)
  // See https://github.com/bootstrap-vue/bootstrap-vue/issues/2713
  if (className && dom_isElement(el) && el.classList) {
    return el.classList.contains(className)
  }
  return false
}

// Set an attribute on an element
const setAttr = (el, attr, value) => {
  if (attr && dom_isElement(el)) {
    el.setAttribute(attr, value)
  }
}

// Remove an attribute from an element
const removeAttr = (el, attr) => {
  if (attr && dom_isElement(el)) {
    el.removeAttribute(attr)
  }
}

// Get an attribute value from an element
// Returns `null` if not found
const getAttr = (el, attr) => (attr && dom_isElement(el) ? el.getAttribute(attr) : null)

// Determine if an attribute exists on an element
// Returns `true` or `false`, or `null` if element not found
const hasAttr = (el, attr) => (attr && dom_isElement(el) ? el.hasAttribute(attr) : null)

// Set an style property on an element
const setStyle = (el, prop, value) => {
  if (prop && dom_isElement(el)) {
    el.style[prop] = value
  }
}

// Remove an style property from an element
const removeStyle = (el, prop) => {
  if (prop && dom_isElement(el)) {
    el.style[prop] = ''
  }
}

// Get an style property value from an element
// Returns `null` if not found
const getStyle = (el, prop) => (prop && dom_isElement(el) ? el.style[prop] || null : null)

// Return the Bounding Client Rect of an element
// Returns `null` if not an element
/* istanbul ignore next: getBoundingClientRect() doesn't work in JSDOM */
const getBCR = el => (dom_isElement(el) ? el.getBoundingClientRect() : null)

// Get computed style object for an element
/* istanbul ignore next: getComputedStyle() doesn't work in JSDOM */
const getCS = el => {
  const { getComputedStyle } = env_WINDOW
  return getComputedStyle && dom_isElement(el) ? getComputedStyle(el) : {}
}

// Returns a `Selection` object representing the range of text selected
// Returns `null` if no window support is given
/* istanbul ignore next: getSelection() doesn't work in JSDOM */
const getSel = () => {
  const { getSelection } = WINDOW
  return getSelection ? WINDOW.getSelection() : null
}

// Return an element's offset with respect to document element
// https://j11y.io/jquery/#v=git&fn=jQuery.fn.offset
const dom_offset = el => /* istanbul ignore next: getBoundingClientRect(), getClientRects() doesn't work in JSDOM */ {
  const _offset = { top: 0, left: 0 }
  if (!dom_isElement(el) || el.getClientRects().length === 0) {
    return _offset
  }
  const bcr = getBCR(el)
  if (bcr) {
    const win = el.ownerDocument.defaultView
    _offset.top = bcr.top + win.pageYOffset
    _offset.left = bcr.left + win.pageXOffset
  }
  return _offset
}

// Return an element's offset with respect to to its offsetParent
// https://j11y.io/jquery/#v=git&fn=jQuery.fn.position
const position = el => /* istanbul ignore next: getBoundingClientRect() doesn't work in JSDOM */ {
  let _offset = { top: 0, left: 0 }
  if (!dom_isElement(el)) {
    return _offset
  }
  let parentOffset = { top: 0, left: 0 }
  const elStyles = getCS(el)
  if (elStyles.position === 'fixed') {
    _offset = getBCR(el) || _offset
  } else {
    _offset = dom_offset(el)
    const doc = el.ownerDocument
    let offsetParent = el.offsetParent || doc.documentElement
    while (
      offsetParent &&
      (offsetParent === doc.body || offsetParent === doc.documentElement) &&
      getCS(offsetParent).position === 'static'
    ) {
      offsetParent = offsetParent.parentNode
    }
    if (offsetParent && offsetParent !== el && offsetParent.nodeType === Node.ELEMENT_NODE) {
      parentOffset = dom_offset(offsetParent)
      const offsetParentStyles = getCS(offsetParent)
      parentOffset.top += toFloat(offsetParentStyles.borderTopWidth, 0)
      parentOffset.left += toFloat(offsetParentStyles.borderLeftWidth, 0)
    }
  }
  return {
    top: _offset.top - parentOffset.top - toFloat(elStyles.marginTop, 0),
    left: _offset.left - parentOffset.left - toFloat(elStyles.marginLeft, 0)
  }
}

// Find all tabable elements in the given element
// Assumes users have not used `tabindex` > `0` on elements
const getTabables = (rootEl = document) =>
  selectAll(TABABLE_SELECTOR, rootEl)
    .filter(isVisible)
    .filter(el => el.tabIndex > -1 && !el.disabled)

// Attempt to focus an element, and return `true` if successful
const attemptFocus = (el, options = {}) => {
  try {
    el.focus(options)
  } catch {}
  return isActiveElement(el)
}

// Attempt to blur an element, and return `true` if successful
const attemptBlur = el => {
  try {
    el.blur()
  } catch {}
  return !isActiveElement(el)
}

;// ./node_modules/bootstrap-vue/src/utils/math.js
// Math utilty functions

const mathMin = Math.min

const mathMax = Math.max

const mathAbs = Math.abs

const mathCeil = Math.ceil

const mathFloor = Math.floor

const mathPow = Math.pow

const mathRound = Math.round

;// ./node_modules/bootstrap-vue/src/utils/number.js
// Number utilities

// Converts a value (string, number, etc.) to an integer number
// Assumes radix base 10
const number_toInteger = (value, defaultValue = NaN) => {
  const integer = parseInt(value, 10)
  return isNaN(integer) ? defaultValue : integer
}

// Converts a value (string, number, etc.) to a number
const number_toFloat = (value, defaultValue = NaN) => {
  const float = parseFloat(value)
  return isNaN(float) ? defaultValue : float
}

// Converts a value (string, number, etc.) to a string
// representation with `precision` digits after the decimal
// Returns the string 'NaN' if the value cannot be converted
const toFixed = (val, precision) => number_toFloat(val).toFixed(number_toInteger(precision, 0))

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/Textarea/Textarea.ts?vue&type=script&lang=ts&external









var Textarea = /** @class */function (_super) {
  __extends(Textarea, _super);
  function Textarea() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(Textarea.prototype, "computedListeners", {
    // Override to apply custom listeners
    get: function () {
      return __assign(__assign({}, this.bvListeners), {
        input: this.onInput,
        change: this.onChangeWithValidation,
        blur: this.onBlurWithValidation,
        keydown: this.onKeyDown
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Textarea.prototype, "customComputedAttrs", {
    // Override to remove required attribute
    get: function () {
      return merge_default()({}, this.computedAttrs, {
        required: false,
        minlength: this.minlength,
        maxlength: this.maxlength
      });
    },
    enumerable: false,
    configurable: true
  });
  // Override render function
  Textarea.prototype.render = function (h) {
    return h('div', {
      class: {
        'required-indicator': this.required !== false && this.requiredIndicator !== false
      }
    }, [this.renderTextarea(h)]);
  };
  // Original render function with change computedAttrs to customComputedAttrs
  Textarea.prototype.renderTextarea = function (h) {
    return h('textarea', {
      ref: 'input',
      class: this.computedClass,
      style: this.computedStyle,
      directives: [{
        name: 'b-visible',
        value: this.visibleCallback,
        // If textarea is within 640px of viewport, consider it visible
        modifiers: {
          640: true
        }
      }],
      attrs: this.customComputedAttrs,
      domProps: {
        value: this.localValue
      },
      on: this.computedListeners
    });
  };
  Textarea.prototype.computeHeight = function () {
    if (this.$isServer || !isNull(this.computedRows)) {
      return null;
    }
    var el = this.$refs.input;
    // Element must be visible (not hidden) and in document
    // Must be checked after above checks
    if (!isVisible(el)) {
      return null;
    }
    // Get current computed styles
    var computedStyle = getCS(el);
    // Height of one line of text in px
    var lineHeight = number_toFloat(computedStyle.lineHeight, 1);
    // Calculate height of border and padding
    var border = number_toFloat(computedStyle.borderTopWidth, 0) + number_toFloat(computedStyle.borderBottomWidth, 0);
    var padding = number_toFloat(computedStyle.paddingTop, 0) + number_toFloat(computedStyle.paddingBottom, 0);
    // Calculate offset
    var offset = border + padding;
    // Minimum height for min rows (which must be 2 rows or greater for cross-browser support)
    var minHeight = lineHeight * this.computedMinRows + offset;
    // Get the current style height (with `px` units)
    var oldHeight = getStyle(el, 'height') || computedStyle.height;
    // Probe scrollHeight by temporarily changing the height to `auto`
    setStyle(el, 'height', 'auto');
    var scrollHeight = el.scrollHeight;
    // Place the original old height back on the element, just in case `computedProp`
    // returns the same value as before
    setStyle(el, 'height', oldHeight);
    // Calculate content height in 'rows' (scrollHeight includes padding but not border)
    var contentRows = mathMax((scrollHeight - padding) / lineHeight, 2);
    // Calculate number of rows to display (limited within min/max rows)
    var rows = mathMin(mathMax(contentRows, this.computedMinRows), this.computedMaxRows);
    // Calculate the required height of the textarea including border and padding (in pixels)
    var height = mathMax(mathCeil(rows * lineHeight + offset), minHeight);
    // Computed height remains the larger of `oldHeight` and new `height`,
    // when height is in `sticky` mode (prop `no-auto-shrink` is true)
    if (this.noAutoShrink && number_toFloat(oldHeight, 0) > height) {
      return oldHeight;
    }
    // Return the new computed CSS height in px units
    return height + "px";
  };
  // Override change event to add validation
  Textarea.prototype.onChangeWithValidation = function (e) {
    this.onChange(e);
    this.valid();
  };
  // Override blur event to add validation
  Textarea.prototype.onBlurWithValidation = function (e) {
    this.onBlur(e);
    this.valid();
  };
  // Keydown event for hide er  rors
  Textarea.prototype.onKeyDown = function () {
    this.hideError();
  };
  Textarea.prototype.getElement = function () {
    return this.$refs.input;
  };
  __decorate([Prop({
    default: 10
  })], Textarea.prototype, "maxRows", void 0);
  __decorate([Prop({
    default: null
  })], Textarea.prototype, "minlength", void 0);
  __decorate([Prop({
    default: null
  })], Textarea.prototype, "maxlength", void 0);
  Textarea = __decorate([vue_class_component_esm], Textarea);
  return Textarea;
}(mixins(external_bootstrap_vue_namespaceObject.BFormTextarea, mixins_FormValidation));
/* harmony default export */ var Textareavue_type_script_lang_ts_external = (Textarea);
;// ./src/components/Textarea/Textarea.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Textarea_Textareavue_type_script_lang_ts_external = (Textareavue_type_script_lang_ts_external); 
;// ./src/components/Textarea/Textarea.vue
var Textarea_render, Textarea_staticRenderFns
;



/* normalize component */
;
var Textarea_component = normalizeComponent(
  Textarea_Textareavue_type_script_lang_ts_external,
  Textarea_render,
  Textarea_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Textarea_Textarea = (Textarea_component.exports);
;// ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/StickyBar/StickyBar.vue?vue&type=template&id=b48873de
var StickyBarvue_type_template_id_b48873de_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.computedClass,
    style: _vm.style
  }, [_vm._t("default")], 2);
};
var StickyBarvue_type_template_id_b48873de_staticRenderFns = [];

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./src/components/StickyBar/StickyBar.ts?vue&type=script&lang=ts&external


var StickyBar = /** @class */function (_super) {
  __extends(StickyBar, _super);
  function StickyBar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.originalPosition = 0;
    _this.parentScrollTop = 0;
    _this.bottomPosition = 0;
    _this.observer = null;
    return _this;
  }
  StickyBar.prototype.mounted = function () {
    this.setParent();
    this.setInitialPosition();
    this.initializeObserver();
    this.saveScrollTop();
    this.parentElement.addEventListener('scroll', this.saveScrollTop);
    this.setRelativeParent();
    if (this.relativeParentElement) {
      this.relativeParentElement.addEventListener('scroll', this.saveScrollTop);
    }
  };
  StickyBar.prototype.beforeDestroy = function () {
    if (this.observer) {
      this.observer.disconnect();
    }
  };
  // Remove event listener
  StickyBar.prototype.destroyed = function () {
    this.parentElement.removeEventListener('scroll', this.saveScrollTop);
    if (this.relativeParentElement) {
      this.relativeParentElement.removeEventListener('scroll', this.saveScrollTop);
    }
  };
  Object.defineProperty(StickyBar.prototype, "isFixed", {
    // Check if bar must be fixed
    get: function () {
      return this.originalPosition > this.parentScrollTop;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StickyBar.prototype, "computedClass", {
    // Return css class for bar
    get: function () {
      return {
        'sticky-bar-form': true,
        fixed: this.isFixed
      };
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StickyBar.prototype, "style", {
    // Return css styles for bar
    get: function () {
      if (!this.isFixed) {
        return {};
      }
      var offset = this.parentElement.getBoundingClientRect();
      return {
        width: offset.width + 'px',
        left: offset.left + 'px',
        bottom: this.bottomPosition + 'px'
      };
    },
    enumerable: false,
    configurable: true
  });
  StickyBar.prototype.setInitialPosition = function () {
    var offset = this.$el.getBoundingClientRect();
    this.originalPosition = offset.top - this.parentElement.offsetTop;
  };
  StickyBar.prototype.initializeObserver = function () {
    var _this = this;
    var observer = new MutationObserver(function () {
      if (!_this.isFixed) {
        _this.setInitialPosition();
      }
    });
    observer.observe(this.parentElement, {
      childList: true,
      subtree: true
    });
    this.observer = observer;
  };
  // Save scroll top position
  StickyBar.prototype.saveScrollTop = function () {
    if (typeof window === undefined) {
      return;
    }
    var elementHeight = this.$el.getBoundingClientRect().height;
    var parentHeight = window.innerHeight + elementHeight;
    if (this.parentElement && this.parentElement.style.height !== '') {
      // If parent element have style height parameter
      parentHeight = Number(this.parentElement.style.height.replace('px', '')) + elementHeight;
    }
    this.parentScrollTop = this.parentElement.scrollTop + parentHeight;
    var offset = this.parentElement.getBoundingClientRect();
    var bottom = window.innerHeight - offset.top - offset.height;
    if (bottom < 0) bottom = 0;
    this.bottomPosition = bottom;
  };
  // Set the parent Element
  StickyBar.prototype.setParent = function () {
    var _a, _b;
    if (typeof window === undefined) {
      return;
    }
    var parent = this.parent === undefined ? (_b = (_a = this.$KwFormConfig) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.parent : this.parent;
    if (parent === undefined || parent === null || parent === '') {
      parent = window.document.body;
    }
    if (typeof parent === 'string') {
      parent = document.querySelector(parent);
    }
    if (parent) {
      this.parentElement = parent;
    }
  };
  StickyBar.prototype.setRelativeParent = function () {
    var parent = this.relativeParent;
    if (typeof parent === 'string') {
      parent = document.querySelector(parent);
    }
    if (parent) {
      this.relativeParentElement = parent;
    }
  };
  __decorate([Prop()], StickyBar.prototype, "parent", void 0);
  __decorate([Prop()], StickyBar.prototype, "relativeParent", void 0);
  StickyBar = __decorate([vue_class_component_esm], StickyBar);
  return StickyBar;
}((external_vue_default()));
/* harmony default export */ var StickyBarvue_type_script_lang_ts_external = (StickyBar);
;// ./src/components/StickyBar/StickyBar.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var StickyBar_StickyBarvue_type_script_lang_ts_external = (StickyBarvue_type_script_lang_ts_external); 
;// ./src/components/StickyBar/StickyBar.vue





/* normalize component */
;
var StickyBar_component = normalizeComponent(
  StickyBar_StickyBarvue_type_script_lang_ts_external,
  StickyBarvue_type_template_id_b48873de_render,
  StickyBarvue_type_template_id_b48873de_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StickyBar_StickyBar = (StickyBar_component.exports);
;// ./src/install.ts

























var KwixeoForm = {
  prefix: 'k-',
  prefix2: 'form-',
  formComponents: {
    address: Address_Address,
    'address-search': AddressSearch,
    checkbox: Checkbox_Checkbox,
    'checkbox-group': CheckboxGroup,
    datepicker: DatePicker_DatePicker,
    datetime: DateTime_DateTime,
    editor: Editor_Editor,
    file: FileUpload_FileUpload,
    input: Input_Input,
    number: InputNumber_InputNumber,
    'period-select': PeriodSelect_PeriodSelect,
    phone: Phone_Phone,
    select: Select_Select,
    spinner: Spinner,
    timepicker: TimePicker_TimePicker,
    textarea: Textarea_Textarea,
    'sticky-bar': StickyBar_StickyBar
  },
  languages: src_lang,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  install: function (Vue, options) {
    var _a;
    var opts = options !== null && options !== void 0 ? options : {};
    if (opts.prefix) {
      this.prefix = opts.prefix;
    }
    // Set default form option
    var form = (_a = opts.form) !== null && _a !== void 0 ? _a : {};
    if (!form.parent) form.parent = window.document.body;
    opts.form = form;
    // Store configuration as global
    Vue.prototype.$KwFormConfig = opts;
    // Register language files
    if (opts.i18n) {
      this.registerLanguages(opts.i18n);
    }
    // Register form compopnent
    Vue.component(this.prefix + 'form', Form_Form);
    // Register other components
    for (var name in this.formComponents) {
      var componentName = this.prefix + this.prefix2 + name;
      Vue.component(componentName, this.formComponents[name]);
    }
    // Register custom Froala components
    Vue.component('Froala', FroalaEditor);
    Vue.component('FroalaView', FroalaView);
    // Add custom validation rules
    if (opts && opts.validationRules) {
      forEach_default()(opts.validationRules, function (rule, key) {
        validate.validators[key] = rule;
      });
    }
  },
  registerLanguages: function (i18n) {
    if (!i18n) {
      return;
    }
    var languages = this.languages;
    Object.keys(languages).forEach(function (locale) {
      i18n.mergeLocaleMessage(locale, {
        kwForm: languages[locale]
      });
    });
  }
};
/* harmony default export */ var install = (KwixeoForm);
;// ./src/index.ts














































;// ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=form.common.js.map